// @ts-nocheck
import { offlineExchange } from '@urql/exchange-graphcache';
import { Resolver as GraphCacheResolver, UpdateResolver as GraphCacheUpdateResolver, OptimisticMutationResolver as GraphCacheOptimisticMutationResolver } from '@urql/exchange-graphcache';

import { gql } from '@urql/vue';
import * as Urql from '@urql/vue';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  date: { input: any; output: any; }
  float8: { input: any; output: any; }
  jsonb: { input: any; output: any; }
  numeric: { input: any; output: any; }
  timestamp: { input: any; output: any; }
  timestamptz: { input: any; output: any; }
  uuid: { input: any; output: any; }
};

export type AccountManager = {
  __typename: 'AccountManager';
  email?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  full_name?: Maybe<Scalars['String']['output']>;
  h_number?: Maybe<Scalars['String']['output']>;
  identifier?: Maybe<Scalars['String']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
};

/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export type Boolean_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Boolean']['input']>;
  _gt?: InputMaybe<Scalars['Boolean']['input']>;
  _gte?: InputMaybe<Scalars['Boolean']['input']>;
  _in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Boolean']['input']>;
  _lte?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Scalars['Boolean']['input']>;
  _nin?: InputMaybe<Array<Scalars['Boolean']['input']>>;
};

export type CanBeMerged = {
  __typename: 'CanBeMerged';
  can_be_merged?: Maybe<Scalars['Boolean']['output']>;
  reasons?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type CreditCheckOverrideUser = {
  __typename: 'CreditCheckOverrideUser';
  email?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  full_name?: Maybe<Scalars['String']['output']>;
  h_number?: Maybe<Scalars['String']['output']>;
  identifier?: Maybe<Scalars['String']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
};

export type ErpCustomer = {
  __typename: 'ERPCustomer';
  customer_erp_id?: Maybe<Scalars['String']['output']>;
  customer_name?: Maybe<Scalars['String']['output']>;
};

export type ErpWellAddress = {
  __typename: 'ERPWellAddress';
  address_erp_id?: Maybe<Scalars['String']['output']>;
  customer_erp_id?: Maybe<Scalars['String']['output']>;
  customer_name?: Maybe<Scalars['String']['output']>;
  well_erp_id?: Maybe<Scalars['String']['output']>;
  well_name?: Maybe<Scalars['String']['output']>;
  well_uwi?: Maybe<Scalars['String']['output']>;
};

export type ErpWell = {
  __typename: 'ErpWell';
  country_code?: Maybe<Scalars['String']['output']>;
  country_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  latitude?: Maybe<Scalars['String']['output']>;
  longitude?: Maybe<Scalars['String']['output']>;
  payer_id?: Maybe<Scalars['String']['output']>;
  payer_name?: Maybe<Scalars['String']['output']>;
  region_code?: Maybe<Scalars['String']['output']>;
  region_name?: Maybe<Scalars['String']['output']>;
  sap_id?: Maybe<Scalars['String']['output']>;
  ship_to_address_id?: Maybe<Scalars['String']['output']>;
  ship_to_address_name?: Maybe<Scalars['String']['output']>;
  ship_to_full_address?: Maybe<Scalars['String']['output']>;
  sold_to_customer_id?: Maybe<Scalars['String']['output']>;
  sold_to_customer_msa_signed?: Maybe<Scalars['Boolean']['output']>;
  sold_to_customer_name?: Maybe<Scalars['String']['output']>;
  uwi?: Maybe<Scalars['String']['output']>;
  well_name?: Maybe<Scalars['String']['output']>;
  welladdress_id?: Maybe<Scalars['String']['output']>;
};

export type ErpWellReadings = {
  __typename: 'ErpWellReadings';
  casing_pressure?: Maybe<Scalars['Float']['output']>;
  fluid_temperature?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  motor_current?: Maybe<Scalars['Float']['output']>;
  motor_frequency?: Maybe<Scalars['Float']['output']>;
  produced_gas_rate?: Maybe<Scalars['Float']['output']>;
  produced_oil_rate?: Maybe<Scalars['Float']['output']>;
  produced_rate?: Maybe<Scalars['Float']['output']>;
  produced_water_rate?: Maybe<Scalars['Float']['output']>;
  pump_intake_pressure?: Maybe<Scalars['Float']['output']>;
  reading_date?: Maybe<Scalars['date']['output']>;
  tubing_pressure?: Maybe<Scalars['Float']['output']>;
};

export enum ErpWellReadingsIdType {
  ErpShipToId = 'erp_ship_to_id',
  ErpWellId = 'erp_well_id',
  ErpWelladdressId = 'erp_welladdress_id'
}

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type Int_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Int']['input']>;
  _gt?: InputMaybe<Scalars['Int']['input']>;
  _gte?: InputMaybe<Scalars['Int']['input']>;
  _in?: InputMaybe<Array<Scalars['Int']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Int']['input']>;
  _lte?: InputMaybe<Scalars['Int']['input']>;
  _neq?: InputMaybe<Scalars['Int']['input']>;
  _nin?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type JobType = {
  __typename: 'JobType';
  category?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  material_number?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  plant?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type Ocms = {
  __typename: 'Ocms';
  date?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  plant_erp_id?: Maybe<Scalars['String']['output']>;
  plant_name?: Maybe<Scalars['String']['output']>;
  shipping_status?: Maybe<Scalars['String']['output']>;
};

export type PreparedBy = {
  __typename: 'PreparedBy';
  email?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  full_name?: Maybe<Scalars['String']['output']>;
  h_number?: Maybe<Scalars['String']['output']>;
  identifier?: Maybe<Scalars['String']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
};

export type SkAddress = {
  __typename: 'SKAddress';
  city?: Maybe<Scalars['String']['output']>;
  district?: Maybe<Scalars['String']['output']>;
  full_address?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  name1?: Maybe<Scalars['String']['output']>;
  name2?: Maybe<Scalars['String']['output']>;
  name3?: Maybe<Scalars['String']['output']>;
  name4?: Maybe<Scalars['String']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
  postal_code?: Maybe<Scalars['String']['output']>;
  region?: Maybe<SkRegion>;
  street?: Maybe<Scalars['String']['output']>;
};

export type SkBillable = {
  __typename: 'SKBillable';
  id?: Maybe<Scalars['Int']['output']>;
  margin?: Maybe<Scalars['Float']['output']>;
  material_description?: Maybe<Scalars['String']['output']>;
  material_long_description?: Maybe<Scalars['String']['output']>;
  material_number?: Maybe<Scalars['String']['output']>;
  material_type?: Maybe<Scalars['String']['output']>;
  notes_description?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['String']['output']>;
  pricing_date?: Maybe<Scalars['String']['output']>;
  prod_hierarchy?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['String']['output']>;
  quote_price?: Maybe<Scalars['Float']['output']>;
  serialized?: Maybe<Scalars['Boolean']['output']>;
  total?: Maybe<Scalars['String']['output']>;
  uom?: Maybe<Scalars['String']['output']>;
};

export type SkCableInventory = {
  __typename: 'SKCableInventory';
  available?: Maybe<Scalars['String']['output']>;
  available_count?: Maybe<Scalars['Float']['output']>;
  inventory_count?: Maybe<Scalars['Float']['output']>;
  reserved?: Maybe<Scalars['String']['output']>;
};

export type SkContract = {
  __typename: 'SKContract';
  active?: Maybe<Scalars['Boolean']['output']>;
  customer?: Maybe<Scalars['String']['output']>;
  date_range?: Maybe<SkMaterialDateRange>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  price_list?: Maybe<SkPriceList>;
  pricing_date?: Maybe<Scalars['String']['output']>;
};

export type SkCoordinates = {
  __typename: 'SKCoordinates';
  coordinates?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  type?: Maybe<Scalars['String']['output']>;
};

export type SkCountry = {
  __typename: 'SKCountry';
  active?: Maybe<Scalars['Boolean']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type SkCurrency = {
  __typename: 'SKCurrency';
  active?: Maybe<Scalars['Boolean']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
};

export type SkCustomer = {
  __typename: 'SKCustomer';
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type SkDeleteQuote = {
  __typename: 'SKDeleteQuote';
  id?: Maybe<Scalars['Int']['output']>;
};

export type SkDeleteQuoteInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type SkEquipmentTypeConversion = {
  __typename: 'SKEquipmentTypeConversion';
  cable_type?: Maybe<Scalars['String']['output']>;
  equipment_type?: Maybe<Scalars['String']['output']>;
  hierarchy_numbers?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  id?: Maybe<Scalars['Int']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  sap_server?: Maybe<Scalars['String']['output']>;
};

export type SkInventory = {
  __typename: 'SKInventory';
  available?: Maybe<Scalars['String']['output']>;
  reserved?: Maybe<Scalars['String']['output']>;
};

export type SkJob = {
  __typename: 'SKJob';
  account_manager?: Maybe<AccountManager>;
  attachment_count?: Maybe<Scalars['Int']['output']>;
  cable_ocms?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  can_be_combined?: Maybe<Scalars['Boolean']['output']>;
  can_be_deleted?: Maybe<Scalars['Boolean']['output']>;
  can_be_merged?: Maybe<CanBeMerged>;
  contract?: Maybe<Scalars['String']['output']>;
  contract_lower_date?: Maybe<Scalars['String']['output']>;
  contract_name?: Maybe<Scalars['String']['output']>;
  contract_original?: Maybe<Scalars['String']['output']>;
  contract_upper_date?: Maybe<Scalars['String']['output']>;
  credit_check_fail?: Maybe<Scalars['Boolean']['output']>;
  credit_check_override?: Maybe<Scalars['Boolean']['output']>;
  credit_check_override_user?: Maybe<CreditCheckOverrideUser>;
  credit_payer_status?: Maybe<Scalars['String']['output']>;
  credit_rep_cell?: Maybe<Scalars['String']['output']>;
  credit_rep_name?: Maybe<Scalars['String']['output']>;
  credit_rep_number?: Maybe<Scalars['String']['output']>;
  credit_rep_office?: Maybe<Scalars['String']['output']>;
  credit_transaction_id?: Maybe<Scalars['Int']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['String']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  discrepancies?: Maybe<Scalars['String']['output']>;
  dispatches?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  end_date?: Maybe<Scalars['String']['output']>;
  erp_data_source?: Maybe<Scalars['String']['output']>;
  erp_transaction_active?: Maybe<Scalars['Boolean']['output']>;
  erp_well?: Maybe<ErpWell>;
  has_been_submitted?: Maybe<Scalars['Boolean']['output']>;
  has_duplicate_job_number?: Maybe<Scalars['Boolean']['output']>;
  has_erp_transactions_with_errors_or_pending?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  inbound_job?: Maybe<Scalars['String']['output']>;
  install_override_message?: Maybe<Scalars['String']['output']>;
  install_override_user?: Maybe<Scalars['String']['output']>;
  iocms?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  job_type?: Maybe<JobType>;
  natural_work_area?: Maybe<Scalars['String']['output']>;
  non_well_job?: Maybe<Scalars['Boolean']['output']>;
  note_count?: Maybe<Scalars['Int']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  nwa_id?: Maybe<Scalars['String']['output']>;
  ocms?: Maybe<Array<Maybe<Ocms>>>;
  planning_order?: Maybe<Scalars['String']['output']>;
  planning_order_error?: Maybe<Scalars['String']['output']>;
  plant_erp_id?: Maybe<Scalars['String']['output']>;
  plant_name?: Maybe<Scalars['String']['output']>;
  plant_profit_center?: Maybe<Scalars['String']['output']>;
  plo_transaction_id?: Maybe<Scalars['Int']['output']>;
  prepared_by?: Maybe<PreparedBy>;
  price_list_name?: Maybe<Scalars['String']['output']>;
  price_list_number?: Maybe<Scalars['String']['output']>;
  price_list_original?: Maybe<Scalars['String']['output']>;
  pricing_date?: Maybe<Scalars['String']['output']>;
  proposal_number?: Maybe<Scalars['String']['output']>;
  proposal_version?: Maybe<Scalars['String']['output']>;
  proposed_job_start_date?: Maybe<Scalars['String']['output']>;
  quote_number?: Maybe<Scalars['String']['output']>;
  quote_total?: Maybe<Scalars['String']['output']>;
  sales_district?: Maybe<Scalars['String']['output']>;
  sales_office?: Maybe<Scalars['String']['output']>;
  sales_organization_id?: Maybe<Scalars['String']['output']>;
  ship_to?: Maybe<Scalars['String']['output']>;
  similar_jobs?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  sold_to?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  ticket_manager_error_message?: Maybe<Scalars['String']['output']>;
  ticket_manager_transaction_id?: Maybe<Scalars['Int']['output']>;
  well?: Maybe<Scalars['String']['output']>;
};

export type SkJobInput = {
  account_manager?: InputMaybe<Scalars['String']['input']>;
  author?: InputMaybe<Scalars['String']['input']>;
  contract?: InputMaybe<Scalars['String']['input']>;
  credit_check_sent?: InputMaybe<Scalars['Boolean']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['String']['input']>;
  erp_well?: InputMaybe<Scalars['String']['input']>;
  erp_well_address_id?: InputMaybe<Scalars['String']['input']>;
  job_type?: InputMaybe<Scalars['String']['input']>;
  natural_work_area?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  nwa_id?: InputMaybe<Scalars['String']['input']>;
  planning_order?: InputMaybe<Scalars['String']['input']>;
  plant_erp_id?: InputMaybe<Scalars['String']['input']>;
  plant_name?: InputMaybe<Scalars['String']['input']>;
  prepared_by?: InputMaybe<Scalars['String']['input']>;
  price_list_number?: InputMaybe<Scalars['String']['input']>;
  pricing_date?: InputMaybe<Scalars['String']['input']>;
  proposal_number?: InputMaybe<Scalars['String']['input']>;
  proposal_version?: InputMaybe<Scalars['String']['input']>;
  proposed_job_start_date?: InputMaybe<Scalars['String']['input']>;
  quote_number?: InputMaybe<Scalars['String']['input']>;
  quote_total?: InputMaybe<Scalars['Float']['input']>;
  sales_office?: InputMaybe<Scalars['String']['input']>;
  salesman?: InputMaybe<Scalars['String']['input']>;
  ship_to?: InputMaybe<Scalars['String']['input']>;
  sold_to?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  spyglass_quote_id?: InputMaybe<Scalars['String']['input']>;
};

export type SkMaterial = {
  __typename: 'SKMaterial';
  active?: Maybe<Scalars['Boolean']['output']>;
  api_response_count?: Maybe<Scalars['Int']['output']>;
  base_uom?: Maybe<Scalars['String']['output']>;
  cable_inventory?: Maybe<SkCableInventory>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  extended_to_plants?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  inventory?: Maybe<SkInventory>;
  long_description?: Maybe<Scalars['String']['output']>;
  material_type?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  pricing?: Maybe<SkMaterialPricing>;
  prod_hierarchy?: Maybe<Scalars['String']['output']>;
  refurb_of?: Maybe<Scalars['String']['output']>;
  serialized?: Maybe<Scalars['Boolean']['output']>;
  so_uom?: Maybe<Scalars['String']['output']>;
  spooled_type?: Maybe<Scalars['String']['output']>;
  standard_offering?: Maybe<Scalars['Boolean']['output']>;
};

export type SkMaterialDateRange = {
  __typename: 'SKMaterialDateRange';
  bounds?: Maybe<Scalars['String']['output']>;
  lower?: Maybe<Scalars['String']['output']>;
  upper?: Maybe<Scalars['String']['output']>;
};

export type SkMaterialPricing = {
  __typename: 'SKMaterialPricing';
  currency?: Maybe<Scalars['String']['output']>;
  date_range?: Maybe<SkMaterialDateRange>;
  floor?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['String']['output']>;
  pricing_date?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['Int']['output']>;
  uom?: Maybe<Scalars['String']['output']>;
};

export type SkMaterialsPaginated = {
  __typename: 'SKMaterialsPaginated';
  count?: Maybe<Scalars['Int']['output']>;
  erp_data_source?: Maybe<Scalars['String']['output']>;
  next?: Maybe<Scalars['String']['output']>;
  previous?: Maybe<Scalars['String']['output']>;
  results?: Maybe<Array<Maybe<SkMaterial>>>;
  route_as_of?: Maybe<Scalars['String']['output']>;
  route_plant?: Maybe<Scalars['String']['output']>;
  route_source?: Maybe<Scalars['String']['output']>;
};

export type SkNwa = {
  __typename: 'SKNwa';
  active?: Maybe<Scalars['Boolean']['output']>;
  al_name?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deprecated?: Maybe<Scalars['Boolean']['output']>;
  display_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type SkPlanningOrder = {
  __typename: 'SKPlanningOrder';
  contract?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  natural_work_area?: Maybe<Scalars['String']['output']>;
  nwa_id?: Maybe<Scalars['String']['output']>;
  planning_order?: Maybe<Scalars['String']['output']>;
  plant_erp_id?: Maybe<Scalars['String']['output']>;
  plant_name?: Maybe<Scalars['String']['output']>;
  price_list_name?: Maybe<Scalars['String']['output']>;
  price_list_number?: Maybe<Scalars['String']['output']>;
};

export type SkPlant = {
  __typename: 'SKPlant';
  active?: Maybe<Scalars['Boolean']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  s4_cutover_date?: Maybe<Scalars['String']['output']>;
};

export type SkPriceList = {
  __typename: 'SKPriceList';
  active?: Maybe<Scalars['Boolean']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['String']['output']>;
};

export type SkQuote = {
  __typename: 'SKQuote';
  created_at?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  deleted_at?: Maybe<Scalars['String']['output']>;
  erp_address_id?: Maybe<Scalars['String']['output']>;
  erp_address_name?: Maybe<Scalars['String']['output']>;
  erp_contract_number?: Maybe<Scalars['String']['output']>;
  erp_customer_name?: Maybe<Scalars['String']['output']>;
  erp_customer_number?: Maybe<Scalars['String']['output']>;
  erp_full_address?: Maybe<Scalars['String']['output']>;
  erp_nwa_id?: Maybe<Scalars['String']['output']>;
  erp_nwa_name?: Maybe<Scalars['String']['output']>;
  erp_plant_id?: Maybe<Scalars['String']['output']>;
  erp_plant_name?: Maybe<Scalars['String']['output']>;
  erp_price_list_name?: Maybe<Scalars['String']['output']>;
  erp_price_list_number?: Maybe<Scalars['String']['output']>;
  erp_well_country?: Maybe<Scalars['String']['output']>;
  erp_well_id?: Maybe<Scalars['String']['output']>;
  erp_well_name?: Maybe<Scalars['String']['output']>;
  erp_well_region?: Maybe<Scalars['String']['output']>;
  erp_well_uwi?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  job?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  pricing_date?: Maybe<Scalars['String']['output']>;
  proposed_start_date?: Maybe<Scalars['String']['output']>;
  sk_planning_order?: Maybe<Scalars['String']['output']>;
  sk_proposal_number?: Maybe<Scalars['String']['output']>;
  spyglass_id?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['String']['output']>;
  version_number?: Maybe<Scalars['Int']['output']>;
};

export type SkQuoteInput = {
  created_at?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  deleted_at?: InputMaybe<Scalars['String']['input']>;
  erp_address_id?: InputMaybe<Scalars['String']['input']>;
  erp_address_name?: InputMaybe<Scalars['String']['input']>;
  erp_contract_number?: InputMaybe<Scalars['String']['input']>;
  erp_customer_name?: InputMaybe<Scalars['String']['input']>;
  erp_customer_number?: InputMaybe<Scalars['String']['input']>;
  erp_full_address?: InputMaybe<Scalars['String']['input']>;
  erp_nwa_id?: InputMaybe<Scalars['String']['input']>;
  erp_nwa_name?: InputMaybe<Scalars['String']['input']>;
  erp_plant_id?: InputMaybe<Scalars['String']['input']>;
  erp_plant_name?: InputMaybe<Scalars['String']['input']>;
  erp_price_list_name?: InputMaybe<Scalars['String']['input']>;
  erp_price_list_number?: InputMaybe<Scalars['String']['input']>;
  erp_well_country?: InputMaybe<Scalars['String']['input']>;
  erp_well_id?: InputMaybe<Scalars['String']['input']>;
  erp_well_name?: InputMaybe<Scalars['String']['input']>;
  erp_well_region?: InputMaybe<Scalars['String']['input']>;
  erp_well_uwi?: InputMaybe<Scalars['String']['input']>;
  job?: InputMaybe<Scalars['Int']['input']>;
  job_type?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pricing_date?: InputMaybe<Scalars['String']['input']>;
  proposed_start_date?: InputMaybe<Scalars['String']['input']>;
  rules?: InputMaybe<Array<InputMaybe<SkRuleInput>>>;
  sk_job_id?: InputMaybe<Scalars['Int']['input']>;
  sk_job_number?: InputMaybe<Scalars['String']['input']>;
  sk_planning_order?: InputMaybe<Scalars['String']['input']>;
  sk_proposal_number?: InputMaybe<Scalars['String']['input']>;
  spyglass_id?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['String']['input']>;
  version_number?: InputMaybe<Scalars['Int']['input']>;
};

export type SkRegion = {
  __typename: 'SKRegion';
  active?: Maybe<Scalars['Boolean']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  country?: Maybe<SkCountry>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type SkRuleInput = {
  created_at?: InputMaybe<Scalars['String']['input']>;
  credit?: InputMaybe<Scalars['Float']['input']>;
  erp_material_long_description?: InputMaybe<Scalars['String']['input']>;
  erp_material_number?: InputMaybe<Scalars['String']['input']>;
  erp_material_short_description?: InputMaybe<Scalars['String']['input']>;
  erp_price?: InputMaybe<Scalars['Float']['input']>;
  erp_product_hierarchy?: InputMaybe<Scalars['String']['input']>;
  erp_uom?: InputMaybe<Scalars['String']['input']>;
  margin?: InputMaybe<Scalars['Float']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  parent_order?: InputMaybe<Scalars['Int']['input']>;
  price_override?: InputMaybe<Scalars['Float']['input']>;
  pricing_date?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  sub_order?: InputMaybe<Scalars['Int']['input']>;
  subcategory?: InputMaybe<Scalars['String']['input']>;
  tax_type?: InputMaybe<Scalars['String']['input']>;
};

export type SkWell = {
  __typename: 'SKWell';
  active?: Maybe<Scalars['Boolean']['output']>;
  coordinates?: Maybe<SkCoordinates>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  name1?: Maybe<Scalars['String']['output']>;
  name2?: Maybe<Scalars['String']['output']>;
  name3?: Maybe<Scalars['String']['output']>;
  name4?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['Int']['output']>;
  uwi?: Maybe<Scalars['String']['output']>;
  uwi_computed?: Maybe<Scalars['String']['output']>;
  well_type?: Maybe<Scalars['String']['output']>;
};

export type SkWellAddress = {
  __typename: 'SKWellAddress';
  address?: Maybe<SkAddress>;
  customer?: Maybe<SkWellAddressCustomer>;
  well?: Maybe<SkWell>;
  well_address_id?: Maybe<Scalars['Int']['output']>;
};

export type SkWellAddressCustomer = {
  __typename: 'SKWellAddressCustomer';
  active?: Maybe<Scalars['Boolean']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  msa_signed?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  name1?: Maybe<Scalars['String']['output']>;
  name2?: Maybe<Scalars['String']['output']>;
  name3?: Maybe<Scalars['String']['output']>;
  name4?: Maybe<Scalars['String']['output']>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['String']['input']>;
  _gt?: InputMaybe<Scalars['String']['input']>;
  _gte?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']['input']>;
  _in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']['input']>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']['input']>;
  _lt?: InputMaybe<Scalars['String']['input']>;
  _lte?: InputMaybe<Scalars['String']['input']>;
  _neq?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']['input']>;
  _nin?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "bolt_on_discharges" */
export type Bolt_On_Discharges = {
  __typename: 'bolt_on_discharges';
  author_id: Scalars['String']['output'];
  created_at: Scalars['timestamptz']['output'];
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  flange_outer_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  id: Scalars['uuid']['output'];
  include_ecopetrol_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  include_koc_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  inner_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  is_hps: Scalars['Boolean']['output'];
  length_inches?: Maybe<Scalars['numeric']['output']>;
  manufacturer?: Maybe<Scalars['String']['output']>;
  neck_inner_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  neck_outer_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  only_ecopetrol_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  only_koc_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  outer_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  series_model?: Maybe<Scalars['String']['output']>;
  tubing_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  updated_at: Scalars['timestamptz']['output'];
  weight_pounds?: Maybe<Scalars['numeric']['output']>;
};

/** aggregated selection of "bolt_on_discharges" */
export type Bolt_On_Discharges_Aggregate = {
  __typename: 'bolt_on_discharges_aggregate';
  aggregate?: Maybe<Bolt_On_Discharges_Aggregate_Fields>;
  nodes: Array<Bolt_On_Discharges>;
};

/** aggregate fields of "bolt_on_discharges" */
export type Bolt_On_Discharges_Aggregate_Fields = {
  __typename: 'bolt_on_discharges_aggregate_fields';
  avg?: Maybe<Bolt_On_Discharges_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Bolt_On_Discharges_Max_Fields>;
  min?: Maybe<Bolt_On_Discharges_Min_Fields>;
  stddev?: Maybe<Bolt_On_Discharges_Stddev_Fields>;
  stddev_pop?: Maybe<Bolt_On_Discharges_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Bolt_On_Discharges_Stddev_Samp_Fields>;
  sum?: Maybe<Bolt_On_Discharges_Sum_Fields>;
  var_pop?: Maybe<Bolt_On_Discharges_Var_Pop_Fields>;
  var_samp?: Maybe<Bolt_On_Discharges_Var_Samp_Fields>;
  variance?: Maybe<Bolt_On_Discharges_Variance_Fields>;
};


/** aggregate fields of "bolt_on_discharges" */
export type Bolt_On_Discharges_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Bolt_On_Discharges_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Bolt_On_Discharges_Avg_Fields = {
  __typename: 'bolt_on_discharges_avg_fields';
  flange_outer_diameter_inches?: Maybe<Scalars['Float']['output']>;
  inner_diameter_inches?: Maybe<Scalars['Float']['output']>;
  length_inches?: Maybe<Scalars['Float']['output']>;
  neck_inner_diameter_inches?: Maybe<Scalars['Float']['output']>;
  neck_outer_diameter_inches?: Maybe<Scalars['Float']['output']>;
  outer_diameter_inches?: Maybe<Scalars['Float']['output']>;
  tubing_diameter_inches?: Maybe<Scalars['Float']['output']>;
  weight_pounds?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "bolt_on_discharges". All fields are combined with a logical 'AND'. */
export type Bolt_On_Discharges_Bool_Exp = {
  _and?: InputMaybe<Array<Bolt_On_Discharges_Bool_Exp>>;
  _not?: InputMaybe<Bolt_On_Discharges_Bool_Exp>;
  _or?: InputMaybe<Array<Bolt_On_Discharges_Bool_Exp>>;
  author_id?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  flange_outer_diameter_inches?: InputMaybe<Numeric_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  include_ecopetrol_timestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  include_koc_timestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  inner_diameter_inches?: InputMaybe<Numeric_Comparison_Exp>;
  is_hps?: InputMaybe<Boolean_Comparison_Exp>;
  length_inches?: InputMaybe<Numeric_Comparison_Exp>;
  manufacturer?: InputMaybe<String_Comparison_Exp>;
  neck_inner_diameter_inches?: InputMaybe<Numeric_Comparison_Exp>;
  neck_outer_diameter_inches?: InputMaybe<Numeric_Comparison_Exp>;
  only_ecopetrol_timestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  only_koc_timestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  outer_diameter_inches?: InputMaybe<Numeric_Comparison_Exp>;
  series_model?: InputMaybe<String_Comparison_Exp>;
  tubing_diameter_inches?: InputMaybe<Numeric_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  weight_pounds?: InputMaybe<Numeric_Comparison_Exp>;
};

/** unique or primary key constraints on table "bolt_on_discharges" */
export enum Bolt_On_Discharges_Constraint {
  /** unique or primary key constraint on columns "id" */
  BoltOnDischargesPkey = 'bolt_on_discharges_pkey'
}

/** input type for incrementing numeric columns in table "bolt_on_discharges" */
export type Bolt_On_Discharges_Inc_Input = {
  flange_outer_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  inner_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  length_inches?: InputMaybe<Scalars['numeric']['input']>;
  neck_inner_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  neck_outer_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  outer_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  tubing_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  weight_pounds?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "bolt_on_discharges" */
export type Bolt_On_Discharges_Insert_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  flange_outer_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  include_ecopetrol_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  include_koc_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  inner_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  is_hps?: InputMaybe<Scalars['Boolean']['input']>;
  length_inches?: InputMaybe<Scalars['numeric']['input']>;
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  neck_inner_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  neck_outer_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  only_ecopetrol_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  only_koc_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  outer_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  series_model?: InputMaybe<Scalars['String']['input']>;
  tubing_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  weight_pounds?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate max on columns */
export type Bolt_On_Discharges_Max_Fields = {
  __typename: 'bolt_on_discharges_max_fields';
  author_id?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  flange_outer_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  include_ecopetrol_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  include_koc_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  inner_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  length_inches?: Maybe<Scalars['numeric']['output']>;
  manufacturer?: Maybe<Scalars['String']['output']>;
  neck_inner_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  neck_outer_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  only_ecopetrol_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  only_koc_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  outer_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  series_model?: Maybe<Scalars['String']['output']>;
  tubing_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  weight_pounds?: Maybe<Scalars['numeric']['output']>;
};

/** aggregate min on columns */
export type Bolt_On_Discharges_Min_Fields = {
  __typename: 'bolt_on_discharges_min_fields';
  author_id?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  flange_outer_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  include_ecopetrol_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  include_koc_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  inner_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  length_inches?: Maybe<Scalars['numeric']['output']>;
  manufacturer?: Maybe<Scalars['String']['output']>;
  neck_inner_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  neck_outer_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  only_ecopetrol_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  only_koc_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  outer_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  series_model?: Maybe<Scalars['String']['output']>;
  tubing_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  weight_pounds?: Maybe<Scalars['numeric']['output']>;
};

/** response of any mutation on the table "bolt_on_discharges" */
export type Bolt_On_Discharges_Mutation_Response = {
  __typename: 'bolt_on_discharges_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Bolt_On_Discharges>;
};

/** input type for inserting object relation for remote table "bolt_on_discharges" */
export type Bolt_On_Discharges_Obj_Rel_Insert_Input = {
  data: Bolt_On_Discharges_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Bolt_On_Discharges_On_Conflict>;
};

/** on_conflict condition type for table "bolt_on_discharges" */
export type Bolt_On_Discharges_On_Conflict = {
  constraint: Bolt_On_Discharges_Constraint;
  update_columns?: Array<Bolt_On_Discharges_Update_Column>;
  where?: InputMaybe<Bolt_On_Discharges_Bool_Exp>;
};

/** Ordering options when selecting data from "bolt_on_discharges". */
export type Bolt_On_Discharges_Order_By = {
  author_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  flange_outer_diameter_inches?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  include_ecopetrol_timestamp?: InputMaybe<Order_By>;
  include_koc_timestamp?: InputMaybe<Order_By>;
  inner_diameter_inches?: InputMaybe<Order_By>;
  is_hps?: InputMaybe<Order_By>;
  length_inches?: InputMaybe<Order_By>;
  manufacturer?: InputMaybe<Order_By>;
  neck_inner_diameter_inches?: InputMaybe<Order_By>;
  neck_outer_diameter_inches?: InputMaybe<Order_By>;
  only_ecopetrol_timestamp?: InputMaybe<Order_By>;
  only_koc_timestamp?: InputMaybe<Order_By>;
  outer_diameter_inches?: InputMaybe<Order_By>;
  series_model?: InputMaybe<Order_By>;
  tubing_diameter_inches?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  weight_pounds?: InputMaybe<Order_By>;
};

/** primary key columns input for table: bolt_on_discharges */
export type Bolt_On_Discharges_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "bolt_on_discharges" */
export enum Bolt_On_Discharges_Select_Column {
  /** column name */
  AuthorId = 'author_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  FlangeOuterDiameterInches = 'flange_outer_diameter_inches',
  /** column name */
  Id = 'id',
  /** column name */
  IncludeEcopetrolTimestamp = 'include_ecopetrol_timestamp',
  /** column name */
  IncludeKocTimestamp = 'include_koc_timestamp',
  /** column name */
  InnerDiameterInches = 'inner_diameter_inches',
  /** column name */
  IsHps = 'is_hps',
  /** column name */
  LengthInches = 'length_inches',
  /** column name */
  Manufacturer = 'manufacturer',
  /** column name */
  NeckInnerDiameterInches = 'neck_inner_diameter_inches',
  /** column name */
  NeckOuterDiameterInches = 'neck_outer_diameter_inches',
  /** column name */
  OnlyEcopetrolTimestamp = 'only_ecopetrol_timestamp',
  /** column name */
  OnlyKocTimestamp = 'only_koc_timestamp',
  /** column name */
  OuterDiameterInches = 'outer_diameter_inches',
  /** column name */
  SeriesModel = 'series_model',
  /** column name */
  TubingDiameterInches = 'tubing_diameter_inches',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WeightPounds = 'weight_pounds'
}

/** input type for updating data in table "bolt_on_discharges" */
export type Bolt_On_Discharges_Set_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  flange_outer_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  include_ecopetrol_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  include_koc_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  inner_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  is_hps?: InputMaybe<Scalars['Boolean']['input']>;
  length_inches?: InputMaybe<Scalars['numeric']['input']>;
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  neck_inner_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  neck_outer_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  only_ecopetrol_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  only_koc_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  outer_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  series_model?: InputMaybe<Scalars['String']['input']>;
  tubing_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  weight_pounds?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate stddev on columns */
export type Bolt_On_Discharges_Stddev_Fields = {
  __typename: 'bolt_on_discharges_stddev_fields';
  flange_outer_diameter_inches?: Maybe<Scalars['Float']['output']>;
  inner_diameter_inches?: Maybe<Scalars['Float']['output']>;
  length_inches?: Maybe<Scalars['Float']['output']>;
  neck_inner_diameter_inches?: Maybe<Scalars['Float']['output']>;
  neck_outer_diameter_inches?: Maybe<Scalars['Float']['output']>;
  outer_diameter_inches?: Maybe<Scalars['Float']['output']>;
  tubing_diameter_inches?: Maybe<Scalars['Float']['output']>;
  weight_pounds?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Bolt_On_Discharges_Stddev_Pop_Fields = {
  __typename: 'bolt_on_discharges_stddev_pop_fields';
  flange_outer_diameter_inches?: Maybe<Scalars['Float']['output']>;
  inner_diameter_inches?: Maybe<Scalars['Float']['output']>;
  length_inches?: Maybe<Scalars['Float']['output']>;
  neck_inner_diameter_inches?: Maybe<Scalars['Float']['output']>;
  neck_outer_diameter_inches?: Maybe<Scalars['Float']['output']>;
  outer_diameter_inches?: Maybe<Scalars['Float']['output']>;
  tubing_diameter_inches?: Maybe<Scalars['Float']['output']>;
  weight_pounds?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Bolt_On_Discharges_Stddev_Samp_Fields = {
  __typename: 'bolt_on_discharges_stddev_samp_fields';
  flange_outer_diameter_inches?: Maybe<Scalars['Float']['output']>;
  inner_diameter_inches?: Maybe<Scalars['Float']['output']>;
  length_inches?: Maybe<Scalars['Float']['output']>;
  neck_inner_diameter_inches?: Maybe<Scalars['Float']['output']>;
  neck_outer_diameter_inches?: Maybe<Scalars['Float']['output']>;
  outer_diameter_inches?: Maybe<Scalars['Float']['output']>;
  tubing_diameter_inches?: Maybe<Scalars['Float']['output']>;
  weight_pounds?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "bolt_on_discharges" */
export type Bolt_On_Discharges_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Bolt_On_Discharges_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Bolt_On_Discharges_Stream_Cursor_Value_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  flange_outer_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  include_ecopetrol_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  include_koc_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  inner_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  is_hps?: InputMaybe<Scalars['Boolean']['input']>;
  length_inches?: InputMaybe<Scalars['numeric']['input']>;
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  neck_inner_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  neck_outer_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  only_ecopetrol_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  only_koc_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  outer_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  series_model?: InputMaybe<Scalars['String']['input']>;
  tubing_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  weight_pounds?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate sum on columns */
export type Bolt_On_Discharges_Sum_Fields = {
  __typename: 'bolt_on_discharges_sum_fields';
  flange_outer_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  inner_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  length_inches?: Maybe<Scalars['numeric']['output']>;
  neck_inner_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  neck_outer_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  outer_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  tubing_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  weight_pounds?: Maybe<Scalars['numeric']['output']>;
};

/** update columns of table "bolt_on_discharges" */
export enum Bolt_On_Discharges_Update_Column {
  /** column name */
  AuthorId = 'author_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  FlangeOuterDiameterInches = 'flange_outer_diameter_inches',
  /** column name */
  Id = 'id',
  /** column name */
  IncludeEcopetrolTimestamp = 'include_ecopetrol_timestamp',
  /** column name */
  IncludeKocTimestamp = 'include_koc_timestamp',
  /** column name */
  InnerDiameterInches = 'inner_diameter_inches',
  /** column name */
  IsHps = 'is_hps',
  /** column name */
  LengthInches = 'length_inches',
  /** column name */
  Manufacturer = 'manufacturer',
  /** column name */
  NeckInnerDiameterInches = 'neck_inner_diameter_inches',
  /** column name */
  NeckOuterDiameterInches = 'neck_outer_diameter_inches',
  /** column name */
  OnlyEcopetrolTimestamp = 'only_ecopetrol_timestamp',
  /** column name */
  OnlyKocTimestamp = 'only_koc_timestamp',
  /** column name */
  OuterDiameterInches = 'outer_diameter_inches',
  /** column name */
  SeriesModel = 'series_model',
  /** column name */
  TubingDiameterInches = 'tubing_diameter_inches',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WeightPounds = 'weight_pounds'
}

export type Bolt_On_Discharges_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Bolt_On_Discharges_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Bolt_On_Discharges_Set_Input>;
  /** filter the rows which have to be updated */
  where: Bolt_On_Discharges_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Bolt_On_Discharges_Var_Pop_Fields = {
  __typename: 'bolt_on_discharges_var_pop_fields';
  flange_outer_diameter_inches?: Maybe<Scalars['Float']['output']>;
  inner_diameter_inches?: Maybe<Scalars['Float']['output']>;
  length_inches?: Maybe<Scalars['Float']['output']>;
  neck_inner_diameter_inches?: Maybe<Scalars['Float']['output']>;
  neck_outer_diameter_inches?: Maybe<Scalars['Float']['output']>;
  outer_diameter_inches?: Maybe<Scalars['Float']['output']>;
  tubing_diameter_inches?: Maybe<Scalars['Float']['output']>;
  weight_pounds?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Bolt_On_Discharges_Var_Samp_Fields = {
  __typename: 'bolt_on_discharges_var_samp_fields';
  flange_outer_diameter_inches?: Maybe<Scalars['Float']['output']>;
  inner_diameter_inches?: Maybe<Scalars['Float']['output']>;
  length_inches?: Maybe<Scalars['Float']['output']>;
  neck_inner_diameter_inches?: Maybe<Scalars['Float']['output']>;
  neck_outer_diameter_inches?: Maybe<Scalars['Float']['output']>;
  outer_diameter_inches?: Maybe<Scalars['Float']['output']>;
  tubing_diameter_inches?: Maybe<Scalars['Float']['output']>;
  weight_pounds?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Bolt_On_Discharges_Variance_Fields = {
  __typename: 'bolt_on_discharges_variance_fields';
  flange_outer_diameter_inches?: Maybe<Scalars['Float']['output']>;
  inner_diameter_inches?: Maybe<Scalars['Float']['output']>;
  length_inches?: Maybe<Scalars['Float']['output']>;
  neck_inner_diameter_inches?: Maybe<Scalars['Float']['output']>;
  neck_outer_diameter_inches?: Maybe<Scalars['Float']['output']>;
  outer_diameter_inches?: Maybe<Scalars['Float']['output']>;
  tubing_diameter_inches?: Maybe<Scalars['Float']['output']>;
  weight_pounds?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "bubble_point_options" */
export type Bubble_Point_Options = {
  __typename: 'bubble_point_options';
  comment?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

/** aggregated selection of "bubble_point_options" */
export type Bubble_Point_Options_Aggregate = {
  __typename: 'bubble_point_options_aggregate';
  aggregate?: Maybe<Bubble_Point_Options_Aggregate_Fields>;
  nodes: Array<Bubble_Point_Options>;
};

/** aggregate fields of "bubble_point_options" */
export type Bubble_Point_Options_Aggregate_Fields = {
  __typename: 'bubble_point_options_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Bubble_Point_Options_Max_Fields>;
  min?: Maybe<Bubble_Point_Options_Min_Fields>;
};


/** aggregate fields of "bubble_point_options" */
export type Bubble_Point_Options_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Bubble_Point_Options_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "bubble_point_options". All fields are combined with a logical 'AND'. */
export type Bubble_Point_Options_Bool_Exp = {
  _and?: InputMaybe<Array<Bubble_Point_Options_Bool_Exp>>;
  _not?: InputMaybe<Bubble_Point_Options_Bool_Exp>;
  _or?: InputMaybe<Array<Bubble_Point_Options_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "bubble_point_options" */
export enum Bubble_Point_Options_Constraint {
  /** unique or primary key constraint on columns "value" */
  BubblePointOptionsPkey = 'bubble_point_options_pkey'
}

export enum Bubble_Point_Options_Enum {
  /** De Ghetto Heavy Oil */
  DeGhettoHeavyOil = 'de_ghetto_heavy_oil',
  /** Glaso (North Sea) */
  GlasoNorthSea = 'glaso_north_sea',
  /** Kartoatmodjo & Schmidt */
  KartoatmodjoSchmidt = 'kartoatmodjo_schmidt',
  /** Lasater */
  Lasater = 'lasater',
  /** Petrosky & Farshad (GOM) */
  PetroskyFarshadGom = 'petrosky_farshad_gom',
  /** Standing */
  Standing = 'standing',
  /** Vasquez Beggs */
  VasquezBeggs = 'vasquez_beggs'
}

/** Boolean expression to compare columns of type "bubble_point_options_enum". All fields are combined with logical 'AND'. */
export type Bubble_Point_Options_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Bubble_Point_Options_Enum>;
  _in?: InputMaybe<Array<Bubble_Point_Options_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Bubble_Point_Options_Enum>;
  _nin?: InputMaybe<Array<Bubble_Point_Options_Enum>>;
};

/** input type for inserting data into table "bubble_point_options" */
export type Bubble_Point_Options_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Bubble_Point_Options_Max_Fields = {
  __typename: 'bubble_point_options_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Bubble_Point_Options_Min_Fields = {
  __typename: 'bubble_point_options_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "bubble_point_options" */
export type Bubble_Point_Options_Mutation_Response = {
  __typename: 'bubble_point_options_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Bubble_Point_Options>;
};

/** input type for inserting object relation for remote table "bubble_point_options" */
export type Bubble_Point_Options_Obj_Rel_Insert_Input = {
  data: Bubble_Point_Options_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Bubble_Point_Options_On_Conflict>;
};

/** on_conflict condition type for table "bubble_point_options" */
export type Bubble_Point_Options_On_Conflict = {
  constraint: Bubble_Point_Options_Constraint;
  update_columns?: Array<Bubble_Point_Options_Update_Column>;
  where?: InputMaybe<Bubble_Point_Options_Bool_Exp>;
};

/** Ordering options when selecting data from "bubble_point_options". */
export type Bubble_Point_Options_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: bubble_point_options */
export type Bubble_Point_Options_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "bubble_point_options" */
export enum Bubble_Point_Options_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "bubble_point_options" */
export type Bubble_Point_Options_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "bubble_point_options" */
export type Bubble_Point_Options_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Bubble_Point_Options_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Bubble_Point_Options_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "bubble_point_options" */
export enum Bubble_Point_Options_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Bubble_Point_Options_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Bubble_Point_Options_Set_Input>;
  /** filter the rows which have to be updated */
  where: Bubble_Point_Options_Bool_Exp;
};

/** columns and relationships of "cables" */
export type Cables = {
  __typename: 'cables';
  amp_factor?: Maybe<Scalars['numeric']['output']>;
  armor?: Maybe<Scalars['String']['output']>;
  author_id: Scalars['String']['output'];
  construction?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  depth_inches?: Maybe<Scalars['numeric']['output']>;
  family?: Maybe<Scalars['String']['output']>;
  gauge?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  impedance_60_hz_per_1000_ft?: Maybe<Scalars['numeric']['output']>;
  imported_sizing_id?: Maybe<Scalars['Int']['output']>;
  include_ecopetrol_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  include_koc_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  kv?: Maybe<Scalars['Int']['output']>;
  manufacturer?: Maybe<Scalars['String']['output']>;
  max_temperature_fahrenheit?: Maybe<Scalars['Int']['output']>;
  only_ecopetrol_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  only_koc_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  part_number?: Maybe<Scalars['String']['output']>;
  pound_per_foot?: Maybe<Scalars['numeric']['output']>;
  /** A computed field, executes function "prioritizecablemanufacturer" */
  prioritized_manufacturer?: Maybe<Scalars['String']['output']>;
  resistance_per_1000_ft?: Maybe<Scalars['numeric']['output']>;
  /** An object relationship */
  sizing_import?: Maybe<Sizing_Imports>;
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Users;
  width_inches?: Maybe<Scalars['numeric']['output']>;
};

/** aggregated selection of "cables" */
export type Cables_Aggregate = {
  __typename: 'cables_aggregate';
  aggregate?: Maybe<Cables_Aggregate_Fields>;
  nodes: Array<Cables>;
};

export type Cables_Aggregate_Bool_Exp = {
  count?: InputMaybe<Cables_Aggregate_Bool_Exp_Count>;
};

export type Cables_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Cables_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Cables_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "cables" */
export type Cables_Aggregate_Fields = {
  __typename: 'cables_aggregate_fields';
  avg?: Maybe<Cables_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Cables_Max_Fields>;
  min?: Maybe<Cables_Min_Fields>;
  stddev?: Maybe<Cables_Stddev_Fields>;
  stddev_pop?: Maybe<Cables_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Cables_Stddev_Samp_Fields>;
  sum?: Maybe<Cables_Sum_Fields>;
  var_pop?: Maybe<Cables_Var_Pop_Fields>;
  var_samp?: Maybe<Cables_Var_Samp_Fields>;
  variance?: Maybe<Cables_Variance_Fields>;
};


/** aggregate fields of "cables" */
export type Cables_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Cables_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "cables" */
export type Cables_Aggregate_Order_By = {
  avg?: InputMaybe<Cables_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Cables_Max_Order_By>;
  min?: InputMaybe<Cables_Min_Order_By>;
  stddev?: InputMaybe<Cables_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Cables_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Cables_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Cables_Sum_Order_By>;
  var_pop?: InputMaybe<Cables_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Cables_Var_Samp_Order_By>;
  variance?: InputMaybe<Cables_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "cables" */
export type Cables_Arr_Rel_Insert_Input = {
  data: Array<Cables_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Cables_On_Conflict>;
};

/** aggregate avg on columns */
export type Cables_Avg_Fields = {
  __typename: 'cables_avg_fields';
  amp_factor?: Maybe<Scalars['Float']['output']>;
  depth_inches?: Maybe<Scalars['Float']['output']>;
  impedance_60_hz_per_1000_ft?: Maybe<Scalars['Float']['output']>;
  imported_sizing_id?: Maybe<Scalars['Float']['output']>;
  kv?: Maybe<Scalars['Float']['output']>;
  max_temperature_fahrenheit?: Maybe<Scalars['Float']['output']>;
  pound_per_foot?: Maybe<Scalars['Float']['output']>;
  resistance_per_1000_ft?: Maybe<Scalars['Float']['output']>;
  width_inches?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "cables" */
export type Cables_Avg_Order_By = {
  amp_factor?: InputMaybe<Order_By>;
  depth_inches?: InputMaybe<Order_By>;
  impedance_60_hz_per_1000_ft?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  kv?: InputMaybe<Order_By>;
  max_temperature_fahrenheit?: InputMaybe<Order_By>;
  pound_per_foot?: InputMaybe<Order_By>;
  resistance_per_1000_ft?: InputMaybe<Order_By>;
  width_inches?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "cables". All fields are combined with a logical 'AND'. */
export type Cables_Bool_Exp = {
  _and?: InputMaybe<Array<Cables_Bool_Exp>>;
  _not?: InputMaybe<Cables_Bool_Exp>;
  _or?: InputMaybe<Array<Cables_Bool_Exp>>;
  amp_factor?: InputMaybe<Numeric_Comparison_Exp>;
  armor?: InputMaybe<String_Comparison_Exp>;
  author_id?: InputMaybe<String_Comparison_Exp>;
  construction?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  depth_inches?: InputMaybe<Numeric_Comparison_Exp>;
  family?: InputMaybe<String_Comparison_Exp>;
  gauge?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  impedance_60_hz_per_1000_ft?: InputMaybe<Numeric_Comparison_Exp>;
  imported_sizing_id?: InputMaybe<Int_Comparison_Exp>;
  include_ecopetrol_timestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  include_koc_timestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  kv?: InputMaybe<Int_Comparison_Exp>;
  manufacturer?: InputMaybe<String_Comparison_Exp>;
  max_temperature_fahrenheit?: InputMaybe<Int_Comparison_Exp>;
  only_ecopetrol_timestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  only_koc_timestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  part_number?: InputMaybe<String_Comparison_Exp>;
  pound_per_foot?: InputMaybe<Numeric_Comparison_Exp>;
  prioritized_manufacturer?: InputMaybe<String_Comparison_Exp>;
  resistance_per_1000_ft?: InputMaybe<Numeric_Comparison_Exp>;
  sizing_import?: InputMaybe<Sizing_Imports_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  width_inches?: InputMaybe<Numeric_Comparison_Exp>;
};

/** unique or primary key constraints on table "cables" */
export enum Cables_Constraint {
  /** unique or primary key constraint on columns "id" */
  CablesPkey = 'cables_pkey'
}

/** input type for incrementing numeric columns in table "cables" */
export type Cables_Inc_Input = {
  amp_factor?: InputMaybe<Scalars['numeric']['input']>;
  depth_inches?: InputMaybe<Scalars['numeric']['input']>;
  impedance_60_hz_per_1000_ft?: InputMaybe<Scalars['numeric']['input']>;
  imported_sizing_id?: InputMaybe<Scalars['Int']['input']>;
  kv?: InputMaybe<Scalars['Int']['input']>;
  max_temperature_fahrenheit?: InputMaybe<Scalars['Int']['input']>;
  pound_per_foot?: InputMaybe<Scalars['numeric']['input']>;
  resistance_per_1000_ft?: InputMaybe<Scalars['numeric']['input']>;
  width_inches?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "cables" */
export type Cables_Insert_Input = {
  amp_factor?: InputMaybe<Scalars['numeric']['input']>;
  armor?: InputMaybe<Scalars['String']['input']>;
  author_id?: InputMaybe<Scalars['String']['input']>;
  construction?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  depth_inches?: InputMaybe<Scalars['numeric']['input']>;
  family?: InputMaybe<Scalars['String']['input']>;
  gauge?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  impedance_60_hz_per_1000_ft?: InputMaybe<Scalars['numeric']['input']>;
  imported_sizing_id?: InputMaybe<Scalars['Int']['input']>;
  include_ecopetrol_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  include_koc_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  kv?: InputMaybe<Scalars['Int']['input']>;
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  max_temperature_fahrenheit?: InputMaybe<Scalars['Int']['input']>;
  only_ecopetrol_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  only_koc_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  part_number?: InputMaybe<Scalars['String']['input']>;
  pound_per_foot?: InputMaybe<Scalars['numeric']['input']>;
  resistance_per_1000_ft?: InputMaybe<Scalars['numeric']['input']>;
  sizing_import?: InputMaybe<Sizing_Imports_Obj_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  width_inches?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate max on columns */
export type Cables_Max_Fields = {
  __typename: 'cables_max_fields';
  amp_factor?: Maybe<Scalars['numeric']['output']>;
  armor?: Maybe<Scalars['String']['output']>;
  author_id?: Maybe<Scalars['String']['output']>;
  construction?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  depth_inches?: Maybe<Scalars['numeric']['output']>;
  family?: Maybe<Scalars['String']['output']>;
  gauge?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  impedance_60_hz_per_1000_ft?: Maybe<Scalars['numeric']['output']>;
  imported_sizing_id?: Maybe<Scalars['Int']['output']>;
  include_ecopetrol_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  include_koc_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  kv?: Maybe<Scalars['Int']['output']>;
  manufacturer?: Maybe<Scalars['String']['output']>;
  max_temperature_fahrenheit?: Maybe<Scalars['Int']['output']>;
  only_ecopetrol_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  only_koc_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  part_number?: Maybe<Scalars['String']['output']>;
  pound_per_foot?: Maybe<Scalars['numeric']['output']>;
  /** A computed field, executes function "prioritizecablemanufacturer" */
  prioritized_manufacturer?: Maybe<Scalars['String']['output']>;
  resistance_per_1000_ft?: Maybe<Scalars['numeric']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  width_inches?: Maybe<Scalars['numeric']['output']>;
};

/** order by max() on columns of table "cables" */
export type Cables_Max_Order_By = {
  amp_factor?: InputMaybe<Order_By>;
  armor?: InputMaybe<Order_By>;
  author_id?: InputMaybe<Order_By>;
  construction?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  depth_inches?: InputMaybe<Order_By>;
  family?: InputMaybe<Order_By>;
  gauge?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  impedance_60_hz_per_1000_ft?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  include_ecopetrol_timestamp?: InputMaybe<Order_By>;
  include_koc_timestamp?: InputMaybe<Order_By>;
  kv?: InputMaybe<Order_By>;
  manufacturer?: InputMaybe<Order_By>;
  max_temperature_fahrenheit?: InputMaybe<Order_By>;
  only_ecopetrol_timestamp?: InputMaybe<Order_By>;
  only_koc_timestamp?: InputMaybe<Order_By>;
  part_number?: InputMaybe<Order_By>;
  pound_per_foot?: InputMaybe<Order_By>;
  resistance_per_1000_ft?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  width_inches?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Cables_Min_Fields = {
  __typename: 'cables_min_fields';
  amp_factor?: Maybe<Scalars['numeric']['output']>;
  armor?: Maybe<Scalars['String']['output']>;
  author_id?: Maybe<Scalars['String']['output']>;
  construction?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  depth_inches?: Maybe<Scalars['numeric']['output']>;
  family?: Maybe<Scalars['String']['output']>;
  gauge?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  impedance_60_hz_per_1000_ft?: Maybe<Scalars['numeric']['output']>;
  imported_sizing_id?: Maybe<Scalars['Int']['output']>;
  include_ecopetrol_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  include_koc_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  kv?: Maybe<Scalars['Int']['output']>;
  manufacturer?: Maybe<Scalars['String']['output']>;
  max_temperature_fahrenheit?: Maybe<Scalars['Int']['output']>;
  only_ecopetrol_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  only_koc_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  part_number?: Maybe<Scalars['String']['output']>;
  pound_per_foot?: Maybe<Scalars['numeric']['output']>;
  /** A computed field, executes function "prioritizecablemanufacturer" */
  prioritized_manufacturer?: Maybe<Scalars['String']['output']>;
  resistance_per_1000_ft?: Maybe<Scalars['numeric']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  width_inches?: Maybe<Scalars['numeric']['output']>;
};

/** order by min() on columns of table "cables" */
export type Cables_Min_Order_By = {
  amp_factor?: InputMaybe<Order_By>;
  armor?: InputMaybe<Order_By>;
  author_id?: InputMaybe<Order_By>;
  construction?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  depth_inches?: InputMaybe<Order_By>;
  family?: InputMaybe<Order_By>;
  gauge?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  impedance_60_hz_per_1000_ft?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  include_ecopetrol_timestamp?: InputMaybe<Order_By>;
  include_koc_timestamp?: InputMaybe<Order_By>;
  kv?: InputMaybe<Order_By>;
  manufacturer?: InputMaybe<Order_By>;
  max_temperature_fahrenheit?: InputMaybe<Order_By>;
  only_ecopetrol_timestamp?: InputMaybe<Order_By>;
  only_koc_timestamp?: InputMaybe<Order_By>;
  part_number?: InputMaybe<Order_By>;
  pound_per_foot?: InputMaybe<Order_By>;
  resistance_per_1000_ft?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  width_inches?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "cables" */
export type Cables_Mutation_Response = {
  __typename: 'cables_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Cables>;
};

/** input type for inserting object relation for remote table "cables" */
export type Cables_Obj_Rel_Insert_Input = {
  data: Cables_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Cables_On_Conflict>;
};

/** on_conflict condition type for table "cables" */
export type Cables_On_Conflict = {
  constraint: Cables_Constraint;
  update_columns?: Array<Cables_Update_Column>;
  where?: InputMaybe<Cables_Bool_Exp>;
};

/** Ordering options when selecting data from "cables". */
export type Cables_Order_By = {
  amp_factor?: InputMaybe<Order_By>;
  armor?: InputMaybe<Order_By>;
  author_id?: InputMaybe<Order_By>;
  construction?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  depth_inches?: InputMaybe<Order_By>;
  family?: InputMaybe<Order_By>;
  gauge?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  impedance_60_hz_per_1000_ft?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  include_ecopetrol_timestamp?: InputMaybe<Order_By>;
  include_koc_timestamp?: InputMaybe<Order_By>;
  kv?: InputMaybe<Order_By>;
  manufacturer?: InputMaybe<Order_By>;
  max_temperature_fahrenheit?: InputMaybe<Order_By>;
  only_ecopetrol_timestamp?: InputMaybe<Order_By>;
  only_koc_timestamp?: InputMaybe<Order_By>;
  part_number?: InputMaybe<Order_By>;
  pound_per_foot?: InputMaybe<Order_By>;
  prioritized_manufacturer?: InputMaybe<Order_By>;
  resistance_per_1000_ft?: InputMaybe<Order_By>;
  sizing_import?: InputMaybe<Sizing_Imports_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  width_inches?: InputMaybe<Order_By>;
};

/** primary key columns input for table: cables */
export type Cables_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "cables" */
export enum Cables_Select_Column {
  /** column name */
  AmpFactor = 'amp_factor',
  /** column name */
  Armor = 'armor',
  /** column name */
  AuthorId = 'author_id',
  /** column name */
  Construction = 'construction',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  DepthInches = 'depth_inches',
  /** column name */
  Family = 'family',
  /** column name */
  Gauge = 'gauge',
  /** column name */
  Id = 'id',
  /** column name */
  Impedance_60HzPer_1000Ft = 'impedance_60_hz_per_1000_ft',
  /** column name */
  ImportedSizingId = 'imported_sizing_id',
  /** column name */
  IncludeEcopetrolTimestamp = 'include_ecopetrol_timestamp',
  /** column name */
  IncludeKocTimestamp = 'include_koc_timestamp',
  /** column name */
  Kv = 'kv',
  /** column name */
  Manufacturer = 'manufacturer',
  /** column name */
  MaxTemperatureFahrenheit = 'max_temperature_fahrenheit',
  /** column name */
  OnlyEcopetrolTimestamp = 'only_ecopetrol_timestamp',
  /** column name */
  OnlyKocTimestamp = 'only_koc_timestamp',
  /** column name */
  PartNumber = 'part_number',
  /** column name */
  PoundPerFoot = 'pound_per_foot',
  /** column name */
  ResistancePer_1000Ft = 'resistance_per_1000_ft',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WidthInches = 'width_inches'
}

/** input type for updating data in table "cables" */
export type Cables_Set_Input = {
  amp_factor?: InputMaybe<Scalars['numeric']['input']>;
  armor?: InputMaybe<Scalars['String']['input']>;
  author_id?: InputMaybe<Scalars['String']['input']>;
  construction?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  depth_inches?: InputMaybe<Scalars['numeric']['input']>;
  family?: InputMaybe<Scalars['String']['input']>;
  gauge?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  impedance_60_hz_per_1000_ft?: InputMaybe<Scalars['numeric']['input']>;
  imported_sizing_id?: InputMaybe<Scalars['Int']['input']>;
  include_ecopetrol_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  include_koc_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  kv?: InputMaybe<Scalars['Int']['input']>;
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  max_temperature_fahrenheit?: InputMaybe<Scalars['Int']['input']>;
  only_ecopetrol_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  only_koc_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  part_number?: InputMaybe<Scalars['String']['input']>;
  pound_per_foot?: InputMaybe<Scalars['numeric']['input']>;
  resistance_per_1000_ft?: InputMaybe<Scalars['numeric']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  width_inches?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate stddev on columns */
export type Cables_Stddev_Fields = {
  __typename: 'cables_stddev_fields';
  amp_factor?: Maybe<Scalars['Float']['output']>;
  depth_inches?: Maybe<Scalars['Float']['output']>;
  impedance_60_hz_per_1000_ft?: Maybe<Scalars['Float']['output']>;
  imported_sizing_id?: Maybe<Scalars['Float']['output']>;
  kv?: Maybe<Scalars['Float']['output']>;
  max_temperature_fahrenheit?: Maybe<Scalars['Float']['output']>;
  pound_per_foot?: Maybe<Scalars['Float']['output']>;
  resistance_per_1000_ft?: Maybe<Scalars['Float']['output']>;
  width_inches?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "cables" */
export type Cables_Stddev_Order_By = {
  amp_factor?: InputMaybe<Order_By>;
  depth_inches?: InputMaybe<Order_By>;
  impedance_60_hz_per_1000_ft?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  kv?: InputMaybe<Order_By>;
  max_temperature_fahrenheit?: InputMaybe<Order_By>;
  pound_per_foot?: InputMaybe<Order_By>;
  resistance_per_1000_ft?: InputMaybe<Order_By>;
  width_inches?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Cables_Stddev_Pop_Fields = {
  __typename: 'cables_stddev_pop_fields';
  amp_factor?: Maybe<Scalars['Float']['output']>;
  depth_inches?: Maybe<Scalars['Float']['output']>;
  impedance_60_hz_per_1000_ft?: Maybe<Scalars['Float']['output']>;
  imported_sizing_id?: Maybe<Scalars['Float']['output']>;
  kv?: Maybe<Scalars['Float']['output']>;
  max_temperature_fahrenheit?: Maybe<Scalars['Float']['output']>;
  pound_per_foot?: Maybe<Scalars['Float']['output']>;
  resistance_per_1000_ft?: Maybe<Scalars['Float']['output']>;
  width_inches?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "cables" */
export type Cables_Stddev_Pop_Order_By = {
  amp_factor?: InputMaybe<Order_By>;
  depth_inches?: InputMaybe<Order_By>;
  impedance_60_hz_per_1000_ft?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  kv?: InputMaybe<Order_By>;
  max_temperature_fahrenheit?: InputMaybe<Order_By>;
  pound_per_foot?: InputMaybe<Order_By>;
  resistance_per_1000_ft?: InputMaybe<Order_By>;
  width_inches?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Cables_Stddev_Samp_Fields = {
  __typename: 'cables_stddev_samp_fields';
  amp_factor?: Maybe<Scalars['Float']['output']>;
  depth_inches?: Maybe<Scalars['Float']['output']>;
  impedance_60_hz_per_1000_ft?: Maybe<Scalars['Float']['output']>;
  imported_sizing_id?: Maybe<Scalars['Float']['output']>;
  kv?: Maybe<Scalars['Float']['output']>;
  max_temperature_fahrenheit?: Maybe<Scalars['Float']['output']>;
  pound_per_foot?: Maybe<Scalars['Float']['output']>;
  resistance_per_1000_ft?: Maybe<Scalars['Float']['output']>;
  width_inches?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "cables" */
export type Cables_Stddev_Samp_Order_By = {
  amp_factor?: InputMaybe<Order_By>;
  depth_inches?: InputMaybe<Order_By>;
  impedance_60_hz_per_1000_ft?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  kv?: InputMaybe<Order_By>;
  max_temperature_fahrenheit?: InputMaybe<Order_By>;
  pound_per_foot?: InputMaybe<Order_By>;
  resistance_per_1000_ft?: InputMaybe<Order_By>;
  width_inches?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "cables" */
export type Cables_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Cables_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Cables_Stream_Cursor_Value_Input = {
  amp_factor?: InputMaybe<Scalars['numeric']['input']>;
  armor?: InputMaybe<Scalars['String']['input']>;
  author_id?: InputMaybe<Scalars['String']['input']>;
  construction?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  depth_inches?: InputMaybe<Scalars['numeric']['input']>;
  family?: InputMaybe<Scalars['String']['input']>;
  gauge?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  impedance_60_hz_per_1000_ft?: InputMaybe<Scalars['numeric']['input']>;
  imported_sizing_id?: InputMaybe<Scalars['Int']['input']>;
  include_ecopetrol_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  include_koc_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  kv?: InputMaybe<Scalars['Int']['input']>;
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  max_temperature_fahrenheit?: InputMaybe<Scalars['Int']['input']>;
  only_ecopetrol_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  only_koc_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  part_number?: InputMaybe<Scalars['String']['input']>;
  pound_per_foot?: InputMaybe<Scalars['numeric']['input']>;
  resistance_per_1000_ft?: InputMaybe<Scalars['numeric']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  width_inches?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate sum on columns */
export type Cables_Sum_Fields = {
  __typename: 'cables_sum_fields';
  amp_factor?: Maybe<Scalars['numeric']['output']>;
  depth_inches?: Maybe<Scalars['numeric']['output']>;
  impedance_60_hz_per_1000_ft?: Maybe<Scalars['numeric']['output']>;
  imported_sizing_id?: Maybe<Scalars['Int']['output']>;
  kv?: Maybe<Scalars['Int']['output']>;
  max_temperature_fahrenheit?: Maybe<Scalars['Int']['output']>;
  pound_per_foot?: Maybe<Scalars['numeric']['output']>;
  resistance_per_1000_ft?: Maybe<Scalars['numeric']['output']>;
  width_inches?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "cables" */
export type Cables_Sum_Order_By = {
  amp_factor?: InputMaybe<Order_By>;
  depth_inches?: InputMaybe<Order_By>;
  impedance_60_hz_per_1000_ft?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  kv?: InputMaybe<Order_By>;
  max_temperature_fahrenheit?: InputMaybe<Order_By>;
  pound_per_foot?: InputMaybe<Order_By>;
  resistance_per_1000_ft?: InputMaybe<Order_By>;
  width_inches?: InputMaybe<Order_By>;
};

/** update columns of table "cables" */
export enum Cables_Update_Column {
  /** column name */
  AmpFactor = 'amp_factor',
  /** column name */
  Armor = 'armor',
  /** column name */
  AuthorId = 'author_id',
  /** column name */
  Construction = 'construction',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  DepthInches = 'depth_inches',
  /** column name */
  Family = 'family',
  /** column name */
  Gauge = 'gauge',
  /** column name */
  Id = 'id',
  /** column name */
  Impedance_60HzPer_1000Ft = 'impedance_60_hz_per_1000_ft',
  /** column name */
  ImportedSizingId = 'imported_sizing_id',
  /** column name */
  IncludeEcopetrolTimestamp = 'include_ecopetrol_timestamp',
  /** column name */
  IncludeKocTimestamp = 'include_koc_timestamp',
  /** column name */
  Kv = 'kv',
  /** column name */
  Manufacturer = 'manufacturer',
  /** column name */
  MaxTemperatureFahrenheit = 'max_temperature_fahrenheit',
  /** column name */
  OnlyEcopetrolTimestamp = 'only_ecopetrol_timestamp',
  /** column name */
  OnlyKocTimestamp = 'only_koc_timestamp',
  /** column name */
  PartNumber = 'part_number',
  /** column name */
  PoundPerFoot = 'pound_per_foot',
  /** column name */
  ResistancePer_1000Ft = 'resistance_per_1000_ft',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WidthInches = 'width_inches'
}

export type Cables_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Cables_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Cables_Set_Input>;
  /** filter the rows which have to be updated */
  where: Cables_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Cables_Var_Pop_Fields = {
  __typename: 'cables_var_pop_fields';
  amp_factor?: Maybe<Scalars['Float']['output']>;
  depth_inches?: Maybe<Scalars['Float']['output']>;
  impedance_60_hz_per_1000_ft?: Maybe<Scalars['Float']['output']>;
  imported_sizing_id?: Maybe<Scalars['Float']['output']>;
  kv?: Maybe<Scalars['Float']['output']>;
  max_temperature_fahrenheit?: Maybe<Scalars['Float']['output']>;
  pound_per_foot?: Maybe<Scalars['Float']['output']>;
  resistance_per_1000_ft?: Maybe<Scalars['Float']['output']>;
  width_inches?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "cables" */
export type Cables_Var_Pop_Order_By = {
  amp_factor?: InputMaybe<Order_By>;
  depth_inches?: InputMaybe<Order_By>;
  impedance_60_hz_per_1000_ft?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  kv?: InputMaybe<Order_By>;
  max_temperature_fahrenheit?: InputMaybe<Order_By>;
  pound_per_foot?: InputMaybe<Order_By>;
  resistance_per_1000_ft?: InputMaybe<Order_By>;
  width_inches?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Cables_Var_Samp_Fields = {
  __typename: 'cables_var_samp_fields';
  amp_factor?: Maybe<Scalars['Float']['output']>;
  depth_inches?: Maybe<Scalars['Float']['output']>;
  impedance_60_hz_per_1000_ft?: Maybe<Scalars['Float']['output']>;
  imported_sizing_id?: Maybe<Scalars['Float']['output']>;
  kv?: Maybe<Scalars['Float']['output']>;
  max_temperature_fahrenheit?: Maybe<Scalars['Float']['output']>;
  pound_per_foot?: Maybe<Scalars['Float']['output']>;
  resistance_per_1000_ft?: Maybe<Scalars['Float']['output']>;
  width_inches?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "cables" */
export type Cables_Var_Samp_Order_By = {
  amp_factor?: InputMaybe<Order_By>;
  depth_inches?: InputMaybe<Order_By>;
  impedance_60_hz_per_1000_ft?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  kv?: InputMaybe<Order_By>;
  max_temperature_fahrenheit?: InputMaybe<Order_By>;
  pound_per_foot?: InputMaybe<Order_By>;
  resistance_per_1000_ft?: InputMaybe<Order_By>;
  width_inches?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Cables_Variance_Fields = {
  __typename: 'cables_variance_fields';
  amp_factor?: Maybe<Scalars['Float']['output']>;
  depth_inches?: Maybe<Scalars['Float']['output']>;
  impedance_60_hz_per_1000_ft?: Maybe<Scalars['Float']['output']>;
  imported_sizing_id?: Maybe<Scalars['Float']['output']>;
  kv?: Maybe<Scalars['Float']['output']>;
  max_temperature_fahrenheit?: Maybe<Scalars['Float']['output']>;
  pound_per_foot?: Maybe<Scalars['Float']['output']>;
  resistance_per_1000_ft?: Maybe<Scalars['Float']['output']>;
  width_inches?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "cables" */
export type Cables_Variance_Order_By = {
  amp_factor?: InputMaybe<Order_By>;
  depth_inches?: InputMaybe<Order_By>;
  impedance_60_hz_per_1000_ft?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  kv?: InputMaybe<Order_By>;
  max_temperature_fahrenheit?: InputMaybe<Order_By>;
  pound_per_foot?: InputMaybe<Order_By>;
  resistance_per_1000_ft?: InputMaybe<Order_By>;
  width_inches?: InputMaybe<Order_By>;
};

/** columns and relationships of "casing_flow_options" */
export type Casing_Flow_Options = {
  __typename: 'casing_flow_options';
  comment?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

/** aggregated selection of "casing_flow_options" */
export type Casing_Flow_Options_Aggregate = {
  __typename: 'casing_flow_options_aggregate';
  aggregate?: Maybe<Casing_Flow_Options_Aggregate_Fields>;
  nodes: Array<Casing_Flow_Options>;
};

/** aggregate fields of "casing_flow_options" */
export type Casing_Flow_Options_Aggregate_Fields = {
  __typename: 'casing_flow_options_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Casing_Flow_Options_Max_Fields>;
  min?: Maybe<Casing_Flow_Options_Min_Fields>;
};


/** aggregate fields of "casing_flow_options" */
export type Casing_Flow_Options_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Casing_Flow_Options_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "casing_flow_options". All fields are combined with a logical 'AND'. */
export type Casing_Flow_Options_Bool_Exp = {
  _and?: InputMaybe<Array<Casing_Flow_Options_Bool_Exp>>;
  _not?: InputMaybe<Casing_Flow_Options_Bool_Exp>;
  _or?: InputMaybe<Array<Casing_Flow_Options_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "casing_flow_options" */
export enum Casing_Flow_Options_Constraint {
  /** unique or primary key constraint on columns "value" */
  CasingFlowOptionsPkey = 'casing_flow_options_pkey'
}

export enum Casing_Flow_Options_Enum {
  /** Beggs & Brill */
  BeggsBrill = 'beggs_brill',
  /** Duns & Ros */
  DunsRos = 'duns_ros',
  /** Hagedorn & Brown */
  HagedornBrown = 'hagedorn_brown',
  /** Orkiszewski */
  Orkiszewski = 'orkiszewski'
}

/** Boolean expression to compare columns of type "casing_flow_options_enum". All fields are combined with logical 'AND'. */
export type Casing_Flow_Options_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Casing_Flow_Options_Enum>;
  _in?: InputMaybe<Array<Casing_Flow_Options_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Casing_Flow_Options_Enum>;
  _nin?: InputMaybe<Array<Casing_Flow_Options_Enum>>;
};

/** input type for inserting data into table "casing_flow_options" */
export type Casing_Flow_Options_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Casing_Flow_Options_Max_Fields = {
  __typename: 'casing_flow_options_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Casing_Flow_Options_Min_Fields = {
  __typename: 'casing_flow_options_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "casing_flow_options" */
export type Casing_Flow_Options_Mutation_Response = {
  __typename: 'casing_flow_options_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Casing_Flow_Options>;
};

/** on_conflict condition type for table "casing_flow_options" */
export type Casing_Flow_Options_On_Conflict = {
  constraint: Casing_Flow_Options_Constraint;
  update_columns?: Array<Casing_Flow_Options_Update_Column>;
  where?: InputMaybe<Casing_Flow_Options_Bool_Exp>;
};

/** Ordering options when selecting data from "casing_flow_options". */
export type Casing_Flow_Options_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: casing_flow_options */
export type Casing_Flow_Options_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "casing_flow_options" */
export enum Casing_Flow_Options_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "casing_flow_options" */
export type Casing_Flow_Options_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "casing_flow_options" */
export type Casing_Flow_Options_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Casing_Flow_Options_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Casing_Flow_Options_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "casing_flow_options" */
export enum Casing_Flow_Options_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Casing_Flow_Options_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Casing_Flow_Options_Set_Input>;
  /** filter the rows which have to be updated */
  where: Casing_Flow_Options_Bool_Exp;
};

/** columns and relationships of "casings" */
export type Casings = {
  __typename: 'casings';
  author_id: Scalars['String']['output'];
  casing_type: Casings_Type_Enum;
  coupling_outer_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  created_at: Scalars['timestamptz']['output'];
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  drift_inches?: Maybe<Scalars['numeric']['output']>;
  id: Scalars['uuid']['output'];
  imperial_name?: Maybe<Scalars['String']['output']>;
  imported_sizing_id?: Maybe<Scalars['Int']['output']>;
  include_ecopetrol_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  include_koc_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  interior_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  metric_name?: Maybe<Scalars['String']['output']>;
  only_ecopetrol_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  only_koc_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  outer_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  pound_per_foot?: Maybe<Scalars['numeric']['output']>;
  /** An object relationship */
  sizing_import?: Maybe<Sizing_Imports>;
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Users;
};

/** aggregated selection of "casings" */
export type Casings_Aggregate = {
  __typename: 'casings_aggregate';
  aggregate?: Maybe<Casings_Aggregate_Fields>;
  nodes: Array<Casings>;
};

export type Casings_Aggregate_Bool_Exp = {
  count?: InputMaybe<Casings_Aggregate_Bool_Exp_Count>;
};

export type Casings_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Casings_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Casings_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "casings" */
export type Casings_Aggregate_Fields = {
  __typename: 'casings_aggregate_fields';
  avg?: Maybe<Casings_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Casings_Max_Fields>;
  min?: Maybe<Casings_Min_Fields>;
  stddev?: Maybe<Casings_Stddev_Fields>;
  stddev_pop?: Maybe<Casings_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Casings_Stddev_Samp_Fields>;
  sum?: Maybe<Casings_Sum_Fields>;
  var_pop?: Maybe<Casings_Var_Pop_Fields>;
  var_samp?: Maybe<Casings_Var_Samp_Fields>;
  variance?: Maybe<Casings_Variance_Fields>;
};


/** aggregate fields of "casings" */
export type Casings_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Casings_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "casings" */
export type Casings_Aggregate_Order_By = {
  avg?: InputMaybe<Casings_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Casings_Max_Order_By>;
  min?: InputMaybe<Casings_Min_Order_By>;
  stddev?: InputMaybe<Casings_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Casings_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Casings_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Casings_Sum_Order_By>;
  var_pop?: InputMaybe<Casings_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Casings_Var_Samp_Order_By>;
  variance?: InputMaybe<Casings_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "casings" */
export type Casings_Arr_Rel_Insert_Input = {
  data: Array<Casings_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Casings_On_Conflict>;
};

/** aggregate avg on columns */
export type Casings_Avg_Fields = {
  __typename: 'casings_avg_fields';
  coupling_outer_diameter_inches?: Maybe<Scalars['Float']['output']>;
  drift_inches?: Maybe<Scalars['Float']['output']>;
  imported_sizing_id?: Maybe<Scalars['Float']['output']>;
  interior_diameter_inches?: Maybe<Scalars['Float']['output']>;
  outer_diameter_inches?: Maybe<Scalars['Float']['output']>;
  pound_per_foot?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "casings" */
export type Casings_Avg_Order_By = {
  coupling_outer_diameter_inches?: InputMaybe<Order_By>;
  drift_inches?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  interior_diameter_inches?: InputMaybe<Order_By>;
  outer_diameter_inches?: InputMaybe<Order_By>;
  pound_per_foot?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "casings". All fields are combined with a logical 'AND'. */
export type Casings_Bool_Exp = {
  _and?: InputMaybe<Array<Casings_Bool_Exp>>;
  _not?: InputMaybe<Casings_Bool_Exp>;
  _or?: InputMaybe<Array<Casings_Bool_Exp>>;
  author_id?: InputMaybe<String_Comparison_Exp>;
  casing_type?: InputMaybe<Casings_Type_Enum_Comparison_Exp>;
  coupling_outer_diameter_inches?: InputMaybe<Numeric_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  drift_inches?: InputMaybe<Numeric_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  imperial_name?: InputMaybe<String_Comparison_Exp>;
  imported_sizing_id?: InputMaybe<Int_Comparison_Exp>;
  include_ecopetrol_timestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  include_koc_timestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  interior_diameter_inches?: InputMaybe<Numeric_Comparison_Exp>;
  metric_name?: InputMaybe<String_Comparison_Exp>;
  only_ecopetrol_timestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  only_koc_timestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  outer_diameter_inches?: InputMaybe<Numeric_Comparison_Exp>;
  pound_per_foot?: InputMaybe<Numeric_Comparison_Exp>;
  sizing_import?: InputMaybe<Sizing_Imports_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
};

/** unique or primary key constraints on table "casings" */
export enum Casings_Constraint {
  /** unique or primary key constraint on columns "id" */
  CasingsPkey = 'casings_pkey'
}

/** input type for incrementing numeric columns in table "casings" */
export type Casings_Inc_Input = {
  coupling_outer_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  drift_inches?: InputMaybe<Scalars['numeric']['input']>;
  imported_sizing_id?: InputMaybe<Scalars['Int']['input']>;
  interior_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  outer_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  pound_per_foot?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "casings" */
export type Casings_Insert_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  casing_type?: InputMaybe<Casings_Type_Enum>;
  coupling_outer_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  drift_inches?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  imperial_name?: InputMaybe<Scalars['String']['input']>;
  imported_sizing_id?: InputMaybe<Scalars['Int']['input']>;
  include_ecopetrol_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  include_koc_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  interior_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  metric_name?: InputMaybe<Scalars['String']['input']>;
  only_ecopetrol_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  only_koc_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  outer_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  pound_per_foot?: InputMaybe<Scalars['numeric']['input']>;
  sizing_import?: InputMaybe<Sizing_Imports_Obj_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Casings_Max_Fields = {
  __typename: 'casings_max_fields';
  author_id?: Maybe<Scalars['String']['output']>;
  coupling_outer_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  drift_inches?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  imperial_name?: Maybe<Scalars['String']['output']>;
  imported_sizing_id?: Maybe<Scalars['Int']['output']>;
  include_ecopetrol_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  include_koc_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  interior_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  metric_name?: Maybe<Scalars['String']['output']>;
  only_ecopetrol_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  only_koc_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  outer_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  pound_per_foot?: Maybe<Scalars['numeric']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "casings" */
export type Casings_Max_Order_By = {
  author_id?: InputMaybe<Order_By>;
  coupling_outer_diameter_inches?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  drift_inches?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  imperial_name?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  include_ecopetrol_timestamp?: InputMaybe<Order_By>;
  include_koc_timestamp?: InputMaybe<Order_By>;
  interior_diameter_inches?: InputMaybe<Order_By>;
  metric_name?: InputMaybe<Order_By>;
  only_ecopetrol_timestamp?: InputMaybe<Order_By>;
  only_koc_timestamp?: InputMaybe<Order_By>;
  outer_diameter_inches?: InputMaybe<Order_By>;
  pound_per_foot?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Casings_Min_Fields = {
  __typename: 'casings_min_fields';
  author_id?: Maybe<Scalars['String']['output']>;
  coupling_outer_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  drift_inches?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  imperial_name?: Maybe<Scalars['String']['output']>;
  imported_sizing_id?: Maybe<Scalars['Int']['output']>;
  include_ecopetrol_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  include_koc_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  interior_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  metric_name?: Maybe<Scalars['String']['output']>;
  only_ecopetrol_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  only_koc_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  outer_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  pound_per_foot?: Maybe<Scalars['numeric']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "casings" */
export type Casings_Min_Order_By = {
  author_id?: InputMaybe<Order_By>;
  coupling_outer_diameter_inches?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  drift_inches?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  imperial_name?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  include_ecopetrol_timestamp?: InputMaybe<Order_By>;
  include_koc_timestamp?: InputMaybe<Order_By>;
  interior_diameter_inches?: InputMaybe<Order_By>;
  metric_name?: InputMaybe<Order_By>;
  only_ecopetrol_timestamp?: InputMaybe<Order_By>;
  only_koc_timestamp?: InputMaybe<Order_By>;
  outer_diameter_inches?: InputMaybe<Order_By>;
  pound_per_foot?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "casings" */
export type Casings_Mutation_Response = {
  __typename: 'casings_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Casings>;
};

/** input type for inserting object relation for remote table "casings" */
export type Casings_Obj_Rel_Insert_Input = {
  data: Casings_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Casings_On_Conflict>;
};

/** on_conflict condition type for table "casings" */
export type Casings_On_Conflict = {
  constraint: Casings_Constraint;
  update_columns?: Array<Casings_Update_Column>;
  where?: InputMaybe<Casings_Bool_Exp>;
};

/** Ordering options when selecting data from "casings". */
export type Casings_Order_By = {
  author_id?: InputMaybe<Order_By>;
  casing_type?: InputMaybe<Order_By>;
  coupling_outer_diameter_inches?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  drift_inches?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  imperial_name?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  include_ecopetrol_timestamp?: InputMaybe<Order_By>;
  include_koc_timestamp?: InputMaybe<Order_By>;
  interior_diameter_inches?: InputMaybe<Order_By>;
  metric_name?: InputMaybe<Order_By>;
  only_ecopetrol_timestamp?: InputMaybe<Order_By>;
  only_koc_timestamp?: InputMaybe<Order_By>;
  outer_diameter_inches?: InputMaybe<Order_By>;
  pound_per_foot?: InputMaybe<Order_By>;
  sizing_import?: InputMaybe<Sizing_Imports_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
};

/** primary key columns input for table: casings */
export type Casings_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "casings" */
export enum Casings_Select_Column {
  /** column name */
  AuthorId = 'author_id',
  /** column name */
  CasingType = 'casing_type',
  /** column name */
  CouplingOuterDiameterInches = 'coupling_outer_diameter_inches',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  DriftInches = 'drift_inches',
  /** column name */
  Id = 'id',
  /** column name */
  ImperialName = 'imperial_name',
  /** column name */
  ImportedSizingId = 'imported_sizing_id',
  /** column name */
  IncludeEcopetrolTimestamp = 'include_ecopetrol_timestamp',
  /** column name */
  IncludeKocTimestamp = 'include_koc_timestamp',
  /** column name */
  InteriorDiameterInches = 'interior_diameter_inches',
  /** column name */
  MetricName = 'metric_name',
  /** column name */
  OnlyEcopetrolTimestamp = 'only_ecopetrol_timestamp',
  /** column name */
  OnlyKocTimestamp = 'only_koc_timestamp',
  /** column name */
  OuterDiameterInches = 'outer_diameter_inches',
  /** column name */
  PoundPerFoot = 'pound_per_foot',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "casings" */
export type Casings_Set_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  casing_type?: InputMaybe<Casings_Type_Enum>;
  coupling_outer_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  drift_inches?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  imperial_name?: InputMaybe<Scalars['String']['input']>;
  imported_sizing_id?: InputMaybe<Scalars['Int']['input']>;
  include_ecopetrol_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  include_koc_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  interior_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  metric_name?: InputMaybe<Scalars['String']['input']>;
  only_ecopetrol_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  only_koc_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  outer_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  pound_per_foot?: InputMaybe<Scalars['numeric']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Casings_Stddev_Fields = {
  __typename: 'casings_stddev_fields';
  coupling_outer_diameter_inches?: Maybe<Scalars['Float']['output']>;
  drift_inches?: Maybe<Scalars['Float']['output']>;
  imported_sizing_id?: Maybe<Scalars['Float']['output']>;
  interior_diameter_inches?: Maybe<Scalars['Float']['output']>;
  outer_diameter_inches?: Maybe<Scalars['Float']['output']>;
  pound_per_foot?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "casings" */
export type Casings_Stddev_Order_By = {
  coupling_outer_diameter_inches?: InputMaybe<Order_By>;
  drift_inches?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  interior_diameter_inches?: InputMaybe<Order_By>;
  outer_diameter_inches?: InputMaybe<Order_By>;
  pound_per_foot?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Casings_Stddev_Pop_Fields = {
  __typename: 'casings_stddev_pop_fields';
  coupling_outer_diameter_inches?: Maybe<Scalars['Float']['output']>;
  drift_inches?: Maybe<Scalars['Float']['output']>;
  imported_sizing_id?: Maybe<Scalars['Float']['output']>;
  interior_diameter_inches?: Maybe<Scalars['Float']['output']>;
  outer_diameter_inches?: Maybe<Scalars['Float']['output']>;
  pound_per_foot?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "casings" */
export type Casings_Stddev_Pop_Order_By = {
  coupling_outer_diameter_inches?: InputMaybe<Order_By>;
  drift_inches?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  interior_diameter_inches?: InputMaybe<Order_By>;
  outer_diameter_inches?: InputMaybe<Order_By>;
  pound_per_foot?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Casings_Stddev_Samp_Fields = {
  __typename: 'casings_stddev_samp_fields';
  coupling_outer_diameter_inches?: Maybe<Scalars['Float']['output']>;
  drift_inches?: Maybe<Scalars['Float']['output']>;
  imported_sizing_id?: Maybe<Scalars['Float']['output']>;
  interior_diameter_inches?: Maybe<Scalars['Float']['output']>;
  outer_diameter_inches?: Maybe<Scalars['Float']['output']>;
  pound_per_foot?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "casings" */
export type Casings_Stddev_Samp_Order_By = {
  coupling_outer_diameter_inches?: InputMaybe<Order_By>;
  drift_inches?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  interior_diameter_inches?: InputMaybe<Order_By>;
  outer_diameter_inches?: InputMaybe<Order_By>;
  pound_per_foot?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "casings" */
export type Casings_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Casings_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Casings_Stream_Cursor_Value_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  casing_type?: InputMaybe<Casings_Type_Enum>;
  coupling_outer_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  drift_inches?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  imperial_name?: InputMaybe<Scalars['String']['input']>;
  imported_sizing_id?: InputMaybe<Scalars['Int']['input']>;
  include_ecopetrol_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  include_koc_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  interior_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  metric_name?: InputMaybe<Scalars['String']['input']>;
  only_ecopetrol_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  only_koc_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  outer_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  pound_per_foot?: InputMaybe<Scalars['numeric']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Casings_Sum_Fields = {
  __typename: 'casings_sum_fields';
  coupling_outer_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  drift_inches?: Maybe<Scalars['numeric']['output']>;
  imported_sizing_id?: Maybe<Scalars['Int']['output']>;
  interior_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  outer_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  pound_per_foot?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "casings" */
export type Casings_Sum_Order_By = {
  coupling_outer_diameter_inches?: InputMaybe<Order_By>;
  drift_inches?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  interior_diameter_inches?: InputMaybe<Order_By>;
  outer_diameter_inches?: InputMaybe<Order_By>;
  pound_per_foot?: InputMaybe<Order_By>;
};

/** columns and relationships of "casings_type" */
export type Casings_Type = {
  __typename: 'casings_type';
  comment?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

/** aggregated selection of "casings_type" */
export type Casings_Type_Aggregate = {
  __typename: 'casings_type_aggregate';
  aggregate?: Maybe<Casings_Type_Aggregate_Fields>;
  nodes: Array<Casings_Type>;
};

/** aggregate fields of "casings_type" */
export type Casings_Type_Aggregate_Fields = {
  __typename: 'casings_type_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Casings_Type_Max_Fields>;
  min?: Maybe<Casings_Type_Min_Fields>;
};


/** aggregate fields of "casings_type" */
export type Casings_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Casings_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "casings_type". All fields are combined with a logical 'AND'. */
export type Casings_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Casings_Type_Bool_Exp>>;
  _not?: InputMaybe<Casings_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Casings_Type_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "casings_type" */
export enum Casings_Type_Constraint {
  /** unique or primary key constraint on columns "value" */
  CasingsTypePkey = 'casings_type_pkey'
}

export enum Casings_Type_Enum {
  /** Both */
  Both = 'both',
  /** Casing */
  Casing = 'casing',
  /** Shroud */
  Shroud = 'shroud'
}

/** Boolean expression to compare columns of type "casings_type_enum". All fields are combined with logical 'AND'. */
export type Casings_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Casings_Type_Enum>;
  _in?: InputMaybe<Array<Casings_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Casings_Type_Enum>;
  _nin?: InputMaybe<Array<Casings_Type_Enum>>;
};

/** input type for inserting data into table "casings_type" */
export type Casings_Type_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Casings_Type_Max_Fields = {
  __typename: 'casings_type_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Casings_Type_Min_Fields = {
  __typename: 'casings_type_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "casings_type" */
export type Casings_Type_Mutation_Response = {
  __typename: 'casings_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Casings_Type>;
};

/** on_conflict condition type for table "casings_type" */
export type Casings_Type_On_Conflict = {
  constraint: Casings_Type_Constraint;
  update_columns?: Array<Casings_Type_Update_Column>;
  where?: InputMaybe<Casings_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "casings_type". */
export type Casings_Type_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: casings_type */
export type Casings_Type_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "casings_type" */
export enum Casings_Type_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "casings_type" */
export type Casings_Type_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "casings_type" */
export type Casings_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Casings_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Casings_Type_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "casings_type" */
export enum Casings_Type_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Casings_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Casings_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Casings_Type_Bool_Exp;
};

/** update columns of table "casings" */
export enum Casings_Update_Column {
  /** column name */
  AuthorId = 'author_id',
  /** column name */
  CasingType = 'casing_type',
  /** column name */
  CouplingOuterDiameterInches = 'coupling_outer_diameter_inches',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  DriftInches = 'drift_inches',
  /** column name */
  Id = 'id',
  /** column name */
  ImperialName = 'imperial_name',
  /** column name */
  ImportedSizingId = 'imported_sizing_id',
  /** column name */
  IncludeEcopetrolTimestamp = 'include_ecopetrol_timestamp',
  /** column name */
  IncludeKocTimestamp = 'include_koc_timestamp',
  /** column name */
  InteriorDiameterInches = 'interior_diameter_inches',
  /** column name */
  MetricName = 'metric_name',
  /** column name */
  OnlyEcopetrolTimestamp = 'only_ecopetrol_timestamp',
  /** column name */
  OnlyKocTimestamp = 'only_koc_timestamp',
  /** column name */
  OuterDiameterInches = 'outer_diameter_inches',
  /** column name */
  PoundPerFoot = 'pound_per_foot',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Casings_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Casings_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Casings_Set_Input>;
  /** filter the rows which have to be updated */
  where: Casings_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Casings_Var_Pop_Fields = {
  __typename: 'casings_var_pop_fields';
  coupling_outer_diameter_inches?: Maybe<Scalars['Float']['output']>;
  drift_inches?: Maybe<Scalars['Float']['output']>;
  imported_sizing_id?: Maybe<Scalars['Float']['output']>;
  interior_diameter_inches?: Maybe<Scalars['Float']['output']>;
  outer_diameter_inches?: Maybe<Scalars['Float']['output']>;
  pound_per_foot?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "casings" */
export type Casings_Var_Pop_Order_By = {
  coupling_outer_diameter_inches?: InputMaybe<Order_By>;
  drift_inches?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  interior_diameter_inches?: InputMaybe<Order_By>;
  outer_diameter_inches?: InputMaybe<Order_By>;
  pound_per_foot?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Casings_Var_Samp_Fields = {
  __typename: 'casings_var_samp_fields';
  coupling_outer_diameter_inches?: Maybe<Scalars['Float']['output']>;
  drift_inches?: Maybe<Scalars['Float']['output']>;
  imported_sizing_id?: Maybe<Scalars['Float']['output']>;
  interior_diameter_inches?: Maybe<Scalars['Float']['output']>;
  outer_diameter_inches?: Maybe<Scalars['Float']['output']>;
  pound_per_foot?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "casings" */
export type Casings_Var_Samp_Order_By = {
  coupling_outer_diameter_inches?: InputMaybe<Order_By>;
  drift_inches?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  interior_diameter_inches?: InputMaybe<Order_By>;
  outer_diameter_inches?: InputMaybe<Order_By>;
  pound_per_foot?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Casings_Variance_Fields = {
  __typename: 'casings_variance_fields';
  coupling_outer_diameter_inches?: Maybe<Scalars['Float']['output']>;
  drift_inches?: Maybe<Scalars['Float']['output']>;
  imported_sizing_id?: Maybe<Scalars['Float']['output']>;
  interior_diameter_inches?: Maybe<Scalars['Float']['output']>;
  outer_diameter_inches?: Maybe<Scalars['Float']['output']>;
  pound_per_foot?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "casings" */
export type Casings_Variance_Order_By = {
  coupling_outer_diameter_inches?: InputMaybe<Order_By>;
  drift_inches?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  interior_diameter_inches?: InputMaybe<Order_By>;
  outer_diameter_inches?: InputMaybe<Order_By>;
  pound_per_foot?: InputMaybe<Order_By>;
};

/** ordering argument of a cursor */
export enum Cursor_Ordering {
  /** ascending ordering of the cursor */
  Asc = 'ASC',
  /** descending ordering of the cursor */
  Desc = 'DESC'
}

/** columns and relationships of "customers" */
export type Customers = {
  __typename: 'customers';
  customer_erp_id: Scalars['String']['output'];
  customer_name?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  imported_sizing_id?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  sizing_import?: Maybe<Sizing_Imports>;
};

/** aggregated selection of "customers" */
export type Customers_Aggregate = {
  __typename: 'customers_aggregate';
  aggregate?: Maybe<Customers_Aggregate_Fields>;
  nodes: Array<Customers>;
};

export type Customers_Aggregate_Bool_Exp = {
  count?: InputMaybe<Customers_Aggregate_Bool_Exp_Count>;
};

export type Customers_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Customers_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Customers_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "customers" */
export type Customers_Aggregate_Fields = {
  __typename: 'customers_aggregate_fields';
  avg?: Maybe<Customers_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Customers_Max_Fields>;
  min?: Maybe<Customers_Min_Fields>;
  stddev?: Maybe<Customers_Stddev_Fields>;
  stddev_pop?: Maybe<Customers_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Customers_Stddev_Samp_Fields>;
  sum?: Maybe<Customers_Sum_Fields>;
  var_pop?: Maybe<Customers_Var_Pop_Fields>;
  var_samp?: Maybe<Customers_Var_Samp_Fields>;
  variance?: Maybe<Customers_Variance_Fields>;
};


/** aggregate fields of "customers" */
export type Customers_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Customers_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "customers" */
export type Customers_Aggregate_Order_By = {
  avg?: InputMaybe<Customers_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Customers_Max_Order_By>;
  min?: InputMaybe<Customers_Min_Order_By>;
  stddev?: InputMaybe<Customers_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Customers_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Customers_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Customers_Sum_Order_By>;
  var_pop?: InputMaybe<Customers_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Customers_Var_Samp_Order_By>;
  variance?: InputMaybe<Customers_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "customers" */
export type Customers_Arr_Rel_Insert_Input = {
  data: Array<Customers_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Customers_On_Conflict>;
};

/** aggregate avg on columns */
export type Customers_Avg_Fields = {
  __typename: 'customers_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  imported_sizing_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "customers" */
export type Customers_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "customers". All fields are combined with a logical 'AND'. */
export type Customers_Bool_Exp = {
  _and?: InputMaybe<Array<Customers_Bool_Exp>>;
  _not?: InputMaybe<Customers_Bool_Exp>;
  _or?: InputMaybe<Array<Customers_Bool_Exp>>;
  customer_erp_id?: InputMaybe<String_Comparison_Exp>;
  customer_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  imported_sizing_id?: InputMaybe<Int_Comparison_Exp>;
  sizing_import?: InputMaybe<Sizing_Imports_Bool_Exp>;
};

/** unique or primary key constraints on table "customers" */
export enum Customers_Constraint {
  /** unique or primary key constraint on columns "customer_erp_id" */
  CustomersCustomerErpIdKey = 'customers_customer_erp_id_key',
  /** unique or primary key constraint on columns "id" */
  CustomersPkey = 'customers_pkey'
}

/** input type for incrementing numeric columns in table "customers" */
export type Customers_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  imported_sizing_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "customers" */
export type Customers_Insert_Input = {
  customer_erp_id?: InputMaybe<Scalars['String']['input']>;
  customer_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  imported_sizing_id?: InputMaybe<Scalars['Int']['input']>;
  sizing_import?: InputMaybe<Sizing_Imports_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Customers_Max_Fields = {
  __typename: 'customers_max_fields';
  customer_erp_id?: Maybe<Scalars['String']['output']>;
  customer_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  imported_sizing_id?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "customers" */
export type Customers_Max_Order_By = {
  customer_erp_id?: InputMaybe<Order_By>;
  customer_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Customers_Min_Fields = {
  __typename: 'customers_min_fields';
  customer_erp_id?: Maybe<Scalars['String']['output']>;
  customer_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  imported_sizing_id?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "customers" */
export type Customers_Min_Order_By = {
  customer_erp_id?: InputMaybe<Order_By>;
  customer_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "customers" */
export type Customers_Mutation_Response = {
  __typename: 'customers_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Customers>;
};

/** input type for inserting object relation for remote table "customers" */
export type Customers_Obj_Rel_Insert_Input = {
  data: Customers_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Customers_On_Conflict>;
};

/** on_conflict condition type for table "customers" */
export type Customers_On_Conflict = {
  constraint: Customers_Constraint;
  update_columns?: Array<Customers_Update_Column>;
  where?: InputMaybe<Customers_Bool_Exp>;
};

/** Ordering options when selecting data from "customers". */
export type Customers_Order_By = {
  customer_erp_id?: InputMaybe<Order_By>;
  customer_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  sizing_import?: InputMaybe<Sizing_Imports_Order_By>;
};

/** primary key columns input for table: customers */
export type Customers_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "customers" */
export enum Customers_Select_Column {
  /** column name */
  CustomerErpId = 'customer_erp_id',
  /** column name */
  CustomerName = 'customer_name',
  /** column name */
  Id = 'id',
  /** column name */
  ImportedSizingId = 'imported_sizing_id'
}

/** input type for updating data in table "customers" */
export type Customers_Set_Input = {
  customer_erp_id?: InputMaybe<Scalars['String']['input']>;
  customer_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  imported_sizing_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Customers_Stddev_Fields = {
  __typename: 'customers_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  imported_sizing_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "customers" */
export type Customers_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Customers_Stddev_Pop_Fields = {
  __typename: 'customers_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  imported_sizing_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "customers" */
export type Customers_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Customers_Stddev_Samp_Fields = {
  __typename: 'customers_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  imported_sizing_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "customers" */
export type Customers_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "customers" */
export type Customers_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Customers_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Customers_Stream_Cursor_Value_Input = {
  customer_erp_id?: InputMaybe<Scalars['String']['input']>;
  customer_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  imported_sizing_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Customers_Sum_Fields = {
  __typename: 'customers_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
  imported_sizing_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "customers" */
export type Customers_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
};

/** update columns of table "customers" */
export enum Customers_Update_Column {
  /** column name */
  CustomerErpId = 'customer_erp_id',
  /** column name */
  CustomerName = 'customer_name',
  /** column name */
  Id = 'id',
  /** column name */
  ImportedSizingId = 'imported_sizing_id'
}

export type Customers_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Customers_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Customers_Set_Input>;
  /** filter the rows which have to be updated */
  where: Customers_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Customers_Var_Pop_Fields = {
  __typename: 'customers_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  imported_sizing_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "customers" */
export type Customers_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Customers_Var_Samp_Fields = {
  __typename: 'customers_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  imported_sizing_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "customers" */
export type Customers_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Customers_Variance_Fields = {
  __typename: 'customers_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  imported_sizing_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "customers" */
export type Customers_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
};

/** Boolean expression to compare columns of type "date". All fields are combined with logical 'AND'. */
export type Date_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['date']['input']>;
  _gt?: InputMaybe<Scalars['date']['input']>;
  _gte?: InputMaybe<Scalars['date']['input']>;
  _in?: InputMaybe<Array<Scalars['date']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['date']['input']>;
  _lte?: InputMaybe<Scalars['date']['input']>;
  _neq?: InputMaybe<Scalars['date']['input']>;
  _nin?: InputMaybe<Array<Scalars['date']['input']>>;
};

/** columns and relationships of "dead_oil_options" */
export type Dead_Oil_Options = {
  __typename: 'dead_oil_options';
  comment?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

/** aggregated selection of "dead_oil_options" */
export type Dead_Oil_Options_Aggregate = {
  __typename: 'dead_oil_options_aggregate';
  aggregate?: Maybe<Dead_Oil_Options_Aggregate_Fields>;
  nodes: Array<Dead_Oil_Options>;
};

/** aggregate fields of "dead_oil_options" */
export type Dead_Oil_Options_Aggregate_Fields = {
  __typename: 'dead_oil_options_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Dead_Oil_Options_Max_Fields>;
  min?: Maybe<Dead_Oil_Options_Min_Fields>;
};


/** aggregate fields of "dead_oil_options" */
export type Dead_Oil_Options_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Dead_Oil_Options_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "dead_oil_options". All fields are combined with a logical 'AND'. */
export type Dead_Oil_Options_Bool_Exp = {
  _and?: InputMaybe<Array<Dead_Oil_Options_Bool_Exp>>;
  _not?: InputMaybe<Dead_Oil_Options_Bool_Exp>;
  _or?: InputMaybe<Array<Dead_Oil_Options_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "dead_oil_options" */
export enum Dead_Oil_Options_Constraint {
  /** unique or primary key constraint on columns "value" */
  DeadOilOptionsPkey = 'dead_oil_options_pkey'
}

export enum Dead_Oil_Options_Enum {
  /** Beggs & Robinson */
  BeggsRobinson = 'beggs_robinson',
  /** Custom */
  Custom = 'custom',
  /** De Ghetto Heavy Oil */
  DeGhettoHeavyOil = 'de_ghetto_heavy_oil',
  /** Glaso (North Sea) */
  GlasoNorthSea = 'glaso_north_sea',
  /** Kartoatmodjo & Schmidt */
  KartoatmodjoSchmidt = 'kartoatmodjo_schmidt'
}

/** Boolean expression to compare columns of type "dead_oil_options_enum". All fields are combined with logical 'AND'. */
export type Dead_Oil_Options_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Dead_Oil_Options_Enum>;
  _in?: InputMaybe<Array<Dead_Oil_Options_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Dead_Oil_Options_Enum>;
  _nin?: InputMaybe<Array<Dead_Oil_Options_Enum>>;
};

/** input type for inserting data into table "dead_oil_options" */
export type Dead_Oil_Options_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Dead_Oil_Options_Max_Fields = {
  __typename: 'dead_oil_options_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Dead_Oil_Options_Min_Fields = {
  __typename: 'dead_oil_options_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "dead_oil_options" */
export type Dead_Oil_Options_Mutation_Response = {
  __typename: 'dead_oil_options_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Dead_Oil_Options>;
};

/** input type for inserting object relation for remote table "dead_oil_options" */
export type Dead_Oil_Options_Obj_Rel_Insert_Input = {
  data: Dead_Oil_Options_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Dead_Oil_Options_On_Conflict>;
};

/** on_conflict condition type for table "dead_oil_options" */
export type Dead_Oil_Options_On_Conflict = {
  constraint: Dead_Oil_Options_Constraint;
  update_columns?: Array<Dead_Oil_Options_Update_Column>;
  where?: InputMaybe<Dead_Oil_Options_Bool_Exp>;
};

/** Ordering options when selecting data from "dead_oil_options". */
export type Dead_Oil_Options_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: dead_oil_options */
export type Dead_Oil_Options_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "dead_oil_options" */
export enum Dead_Oil_Options_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "dead_oil_options" */
export type Dead_Oil_Options_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "dead_oil_options" */
export type Dead_Oil_Options_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Dead_Oil_Options_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Dead_Oil_Options_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "dead_oil_options" */
export enum Dead_Oil_Options_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Dead_Oil_Options_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Dead_Oil_Options_Set_Input>;
  /** filter the rows which have to be updated */
  where: Dead_Oil_Options_Bool_Exp;
};

/** columns and relationships of "deviation_survey" */
export type Deviation_Survey = {
  __typename: 'deviation_survey';
  author_id: Scalars['String']['output'];
  created_at: Scalars['timestamptz']['output'];
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  directional_data_set: Deviation_Survey_Directional_Dataset_Enum;
  /** [measured_depth, inclination, azimuth, true_vertical_depth, dog_leg_severity] */
  entry_rows?: Maybe<Array<Scalars['float8']['output']>>;
  id: Scalars['uuid']['output'];
  imported_sizing_id?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  sizing_import?: Maybe<Sizing_Imports>;
  title?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Users;
};

/** aggregated selection of "deviation_survey" */
export type Deviation_Survey_Aggregate = {
  __typename: 'deviation_survey_aggregate';
  aggregate?: Maybe<Deviation_Survey_Aggregate_Fields>;
  nodes: Array<Deviation_Survey>;
};

export type Deviation_Survey_Aggregate_Bool_Exp = {
  count?: InputMaybe<Deviation_Survey_Aggregate_Bool_Exp_Count>;
};

export type Deviation_Survey_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Deviation_Survey_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Deviation_Survey_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "deviation_survey" */
export type Deviation_Survey_Aggregate_Fields = {
  __typename: 'deviation_survey_aggregate_fields';
  avg?: Maybe<Deviation_Survey_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Deviation_Survey_Max_Fields>;
  min?: Maybe<Deviation_Survey_Min_Fields>;
  stddev?: Maybe<Deviation_Survey_Stddev_Fields>;
  stddev_pop?: Maybe<Deviation_Survey_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Deviation_Survey_Stddev_Samp_Fields>;
  sum?: Maybe<Deviation_Survey_Sum_Fields>;
  var_pop?: Maybe<Deviation_Survey_Var_Pop_Fields>;
  var_samp?: Maybe<Deviation_Survey_Var_Samp_Fields>;
  variance?: Maybe<Deviation_Survey_Variance_Fields>;
};


/** aggregate fields of "deviation_survey" */
export type Deviation_Survey_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Deviation_Survey_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "deviation_survey" */
export type Deviation_Survey_Aggregate_Order_By = {
  avg?: InputMaybe<Deviation_Survey_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Deviation_Survey_Max_Order_By>;
  min?: InputMaybe<Deviation_Survey_Min_Order_By>;
  stddev?: InputMaybe<Deviation_Survey_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Deviation_Survey_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Deviation_Survey_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Deviation_Survey_Sum_Order_By>;
  var_pop?: InputMaybe<Deviation_Survey_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Deviation_Survey_Var_Samp_Order_By>;
  variance?: InputMaybe<Deviation_Survey_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "deviation_survey" */
export type Deviation_Survey_Arr_Rel_Insert_Input = {
  data: Array<Deviation_Survey_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Deviation_Survey_On_Conflict>;
};

/** aggregate avg on columns */
export type Deviation_Survey_Avg_Fields = {
  __typename: 'deviation_survey_avg_fields';
  imported_sizing_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "deviation_survey" */
export type Deviation_Survey_Avg_Order_By = {
  imported_sizing_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "deviation_survey". All fields are combined with a logical 'AND'. */
export type Deviation_Survey_Bool_Exp = {
  _and?: InputMaybe<Array<Deviation_Survey_Bool_Exp>>;
  _not?: InputMaybe<Deviation_Survey_Bool_Exp>;
  _or?: InputMaybe<Array<Deviation_Survey_Bool_Exp>>;
  author_id?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  directional_data_set?: InputMaybe<Deviation_Survey_Directional_Dataset_Enum_Comparison_Exp>;
  entry_rows?: InputMaybe<Float8_Array_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  imported_sizing_id?: InputMaybe<Int_Comparison_Exp>;
  sizing_import?: InputMaybe<Sizing_Imports_Bool_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
};

/** unique or primary key constraints on table "deviation_survey" */
export enum Deviation_Survey_Constraint {
  /** unique or primary key constraint on columns "id" */
  DeviationSurveyPkey = 'deviation_survey_pkey'
}

/** columns and relationships of "deviation_survey_directional_dataset" */
export type Deviation_Survey_Directional_Dataset = {
  __typename: 'deviation_survey_directional_dataset';
  comment?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  deviation_surveys: Array<Deviation_Survey>;
  /** An aggregate relationship */
  deviation_surveys_aggregate: Deviation_Survey_Aggregate;
  value: Scalars['String']['output'];
};


/** columns and relationships of "deviation_survey_directional_dataset" */
export type Deviation_Survey_Directional_DatasetDeviation_SurveysArgs = {
  distinct_on?: InputMaybe<Array<Deviation_Survey_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Deviation_Survey_Order_By>>;
  where?: InputMaybe<Deviation_Survey_Bool_Exp>;
};


/** columns and relationships of "deviation_survey_directional_dataset" */
export type Deviation_Survey_Directional_DatasetDeviation_Surveys_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Deviation_Survey_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Deviation_Survey_Order_By>>;
  where?: InputMaybe<Deviation_Survey_Bool_Exp>;
};

/** aggregated selection of "deviation_survey_directional_dataset" */
export type Deviation_Survey_Directional_Dataset_Aggregate = {
  __typename: 'deviation_survey_directional_dataset_aggregate';
  aggregate?: Maybe<Deviation_Survey_Directional_Dataset_Aggregate_Fields>;
  nodes: Array<Deviation_Survey_Directional_Dataset>;
};

/** aggregate fields of "deviation_survey_directional_dataset" */
export type Deviation_Survey_Directional_Dataset_Aggregate_Fields = {
  __typename: 'deviation_survey_directional_dataset_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Deviation_Survey_Directional_Dataset_Max_Fields>;
  min?: Maybe<Deviation_Survey_Directional_Dataset_Min_Fields>;
};


/** aggregate fields of "deviation_survey_directional_dataset" */
export type Deviation_Survey_Directional_Dataset_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Deviation_Survey_Directional_Dataset_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "deviation_survey_directional_dataset". All fields are combined with a logical 'AND'. */
export type Deviation_Survey_Directional_Dataset_Bool_Exp = {
  _and?: InputMaybe<Array<Deviation_Survey_Directional_Dataset_Bool_Exp>>;
  _not?: InputMaybe<Deviation_Survey_Directional_Dataset_Bool_Exp>;
  _or?: InputMaybe<Array<Deviation_Survey_Directional_Dataset_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  deviation_surveys?: InputMaybe<Deviation_Survey_Bool_Exp>;
  deviation_surveys_aggregate?: InputMaybe<Deviation_Survey_Aggregate_Bool_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "deviation_survey_directional_dataset" */
export enum Deviation_Survey_Directional_Dataset_Constraint {
  /** unique or primary key constraint on columns "value" */
  DeviationSurveyDirectionalDatasetPkey = 'deviation_survey_directional_dataset_pkey'
}

export enum Deviation_Survey_Directional_Dataset_Enum {
  /** 3D MD Inclination Azimuth */
  ThreeDMdInclinationAzimuth = 'three_d_md_inclination_azimuth',
  /** 2D MD Inclination */
  TwoDMdInclination = 'two_d_md_inclination',
  /** 2D MD TVD */
  TwoDMdTvd = 'two_d_md_tvd'
}

/** Boolean expression to compare columns of type "deviation_survey_directional_dataset_enum". All fields are combined with logical 'AND'. */
export type Deviation_Survey_Directional_Dataset_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Deviation_Survey_Directional_Dataset_Enum>;
  _in?: InputMaybe<Array<Deviation_Survey_Directional_Dataset_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Deviation_Survey_Directional_Dataset_Enum>;
  _nin?: InputMaybe<Array<Deviation_Survey_Directional_Dataset_Enum>>;
};

/** input type for inserting data into table "deviation_survey_directional_dataset" */
export type Deviation_Survey_Directional_Dataset_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  deviation_surveys?: InputMaybe<Deviation_Survey_Arr_Rel_Insert_Input>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Deviation_Survey_Directional_Dataset_Max_Fields = {
  __typename: 'deviation_survey_directional_dataset_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Deviation_Survey_Directional_Dataset_Min_Fields = {
  __typename: 'deviation_survey_directional_dataset_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "deviation_survey_directional_dataset" */
export type Deviation_Survey_Directional_Dataset_Mutation_Response = {
  __typename: 'deviation_survey_directional_dataset_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Deviation_Survey_Directional_Dataset>;
};

/** on_conflict condition type for table "deviation_survey_directional_dataset" */
export type Deviation_Survey_Directional_Dataset_On_Conflict = {
  constraint: Deviation_Survey_Directional_Dataset_Constraint;
  update_columns?: Array<Deviation_Survey_Directional_Dataset_Update_Column>;
  where?: InputMaybe<Deviation_Survey_Directional_Dataset_Bool_Exp>;
};

/** Ordering options when selecting data from "deviation_survey_directional_dataset". */
export type Deviation_Survey_Directional_Dataset_Order_By = {
  comment?: InputMaybe<Order_By>;
  deviation_surveys_aggregate?: InputMaybe<Deviation_Survey_Aggregate_Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: deviation_survey_directional_dataset */
export type Deviation_Survey_Directional_Dataset_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "deviation_survey_directional_dataset" */
export enum Deviation_Survey_Directional_Dataset_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "deviation_survey_directional_dataset" */
export type Deviation_Survey_Directional_Dataset_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "deviation_survey_directional_dataset" */
export type Deviation_Survey_Directional_Dataset_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Deviation_Survey_Directional_Dataset_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Deviation_Survey_Directional_Dataset_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "deviation_survey_directional_dataset" */
export enum Deviation_Survey_Directional_Dataset_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Deviation_Survey_Directional_Dataset_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Deviation_Survey_Directional_Dataset_Set_Input>;
  /** filter the rows which have to be updated */
  where: Deviation_Survey_Directional_Dataset_Bool_Exp;
};

/** input type for incrementing numeric columns in table "deviation_survey" */
export type Deviation_Survey_Inc_Input = {
  imported_sizing_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "deviation_survey" */
export type Deviation_Survey_Insert_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  directional_data_set?: InputMaybe<Deviation_Survey_Directional_Dataset_Enum>;
  /** [measured_depth, inclination, azimuth, true_vertical_depth, dog_leg_severity] */
  entry_rows?: InputMaybe<Array<Scalars['float8']['input']>>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  imported_sizing_id?: InputMaybe<Scalars['Int']['input']>;
  sizing_import?: InputMaybe<Sizing_Imports_Obj_Rel_Insert_Input>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Deviation_Survey_Max_Fields = {
  __typename: 'deviation_survey_max_fields';
  author_id?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  /** [measured_depth, inclination, azimuth, true_vertical_depth, dog_leg_severity] */
  entry_rows?: Maybe<Array<Scalars['float8']['output']>>;
  id?: Maybe<Scalars['uuid']['output']>;
  imported_sizing_id?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "deviation_survey" */
export type Deviation_Survey_Max_Order_By = {
  author_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  /** [measured_depth, inclination, azimuth, true_vertical_depth, dog_leg_severity] */
  entry_rows?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Deviation_Survey_Min_Fields = {
  __typename: 'deviation_survey_min_fields';
  author_id?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  /** [measured_depth, inclination, azimuth, true_vertical_depth, dog_leg_severity] */
  entry_rows?: Maybe<Array<Scalars['float8']['output']>>;
  id?: Maybe<Scalars['uuid']['output']>;
  imported_sizing_id?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "deviation_survey" */
export type Deviation_Survey_Min_Order_By = {
  author_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  /** [measured_depth, inclination, azimuth, true_vertical_depth, dog_leg_severity] */
  entry_rows?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "deviation_survey" */
export type Deviation_Survey_Mutation_Response = {
  __typename: 'deviation_survey_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Deviation_Survey>;
};

/** input type for inserting object relation for remote table "deviation_survey" */
export type Deviation_Survey_Obj_Rel_Insert_Input = {
  data: Deviation_Survey_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Deviation_Survey_On_Conflict>;
};

/** on_conflict condition type for table "deviation_survey" */
export type Deviation_Survey_On_Conflict = {
  constraint: Deviation_Survey_Constraint;
  update_columns?: Array<Deviation_Survey_Update_Column>;
  where?: InputMaybe<Deviation_Survey_Bool_Exp>;
};

/** Ordering options when selecting data from "deviation_survey". */
export type Deviation_Survey_Order_By = {
  author_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  directional_data_set?: InputMaybe<Order_By>;
  entry_rows?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  sizing_import?: InputMaybe<Sizing_Imports_Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
};

/** primary key columns input for table: deviation_survey */
export type Deviation_Survey_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "deviation_survey" */
export enum Deviation_Survey_Select_Column {
  /** column name */
  AuthorId = 'author_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  DirectionalDataSet = 'directional_data_set',
  /** column name */
  EntryRows = 'entry_rows',
  /** column name */
  Id = 'id',
  /** column name */
  ImportedSizingId = 'imported_sizing_id',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "deviation_survey" */
export type Deviation_Survey_Set_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  directional_data_set?: InputMaybe<Deviation_Survey_Directional_Dataset_Enum>;
  /** [measured_depth, inclination, azimuth, true_vertical_depth, dog_leg_severity] */
  entry_rows?: InputMaybe<Array<Scalars['float8']['input']>>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  imported_sizing_id?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Deviation_Survey_Stddev_Fields = {
  __typename: 'deviation_survey_stddev_fields';
  imported_sizing_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "deviation_survey" */
export type Deviation_Survey_Stddev_Order_By = {
  imported_sizing_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Deviation_Survey_Stddev_Pop_Fields = {
  __typename: 'deviation_survey_stddev_pop_fields';
  imported_sizing_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "deviation_survey" */
export type Deviation_Survey_Stddev_Pop_Order_By = {
  imported_sizing_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Deviation_Survey_Stddev_Samp_Fields = {
  __typename: 'deviation_survey_stddev_samp_fields';
  imported_sizing_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "deviation_survey" */
export type Deviation_Survey_Stddev_Samp_Order_By = {
  imported_sizing_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "deviation_survey" */
export type Deviation_Survey_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Deviation_Survey_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Deviation_Survey_Stream_Cursor_Value_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  directional_data_set?: InputMaybe<Deviation_Survey_Directional_Dataset_Enum>;
  /** [measured_depth, inclination, azimuth, true_vertical_depth, dog_leg_severity] */
  entry_rows?: InputMaybe<Array<Scalars['float8']['input']>>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  imported_sizing_id?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Deviation_Survey_Sum_Fields = {
  __typename: 'deviation_survey_sum_fields';
  imported_sizing_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "deviation_survey" */
export type Deviation_Survey_Sum_Order_By = {
  imported_sizing_id?: InputMaybe<Order_By>;
};

/** update columns of table "deviation_survey" */
export enum Deviation_Survey_Update_Column {
  /** column name */
  AuthorId = 'author_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  DirectionalDataSet = 'directional_data_set',
  /** column name */
  EntryRows = 'entry_rows',
  /** column name */
  Id = 'id',
  /** column name */
  ImportedSizingId = 'imported_sizing_id',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Deviation_Survey_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Deviation_Survey_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Deviation_Survey_Set_Input>;
  /** filter the rows which have to be updated */
  where: Deviation_Survey_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Deviation_Survey_Var_Pop_Fields = {
  __typename: 'deviation_survey_var_pop_fields';
  imported_sizing_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "deviation_survey" */
export type Deviation_Survey_Var_Pop_Order_By = {
  imported_sizing_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Deviation_Survey_Var_Samp_Fields = {
  __typename: 'deviation_survey_var_samp_fields';
  imported_sizing_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "deviation_survey" */
export type Deviation_Survey_Var_Samp_Order_By = {
  imported_sizing_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Deviation_Survey_Variance_Fields = {
  __typename: 'deviation_survey_variance_fields';
  imported_sizing_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "deviation_survey" */
export type Deviation_Survey_Variance_Order_By = {
  imported_sizing_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "display_units" */
export type Display_Units = {
  __typename: 'display_units';
  comment?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

/** aggregated selection of "display_units" */
export type Display_Units_Aggregate = {
  __typename: 'display_units_aggregate';
  aggregate?: Maybe<Display_Units_Aggregate_Fields>;
  nodes: Array<Display_Units>;
};

/** aggregate fields of "display_units" */
export type Display_Units_Aggregate_Fields = {
  __typename: 'display_units_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Display_Units_Max_Fields>;
  min?: Maybe<Display_Units_Min_Fields>;
};


/** aggregate fields of "display_units" */
export type Display_Units_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Display_Units_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "display_units". All fields are combined with a logical 'AND'. */
export type Display_Units_Bool_Exp = {
  _and?: InputMaybe<Array<Display_Units_Bool_Exp>>;
  _not?: InputMaybe<Display_Units_Bool_Exp>;
  _or?: InputMaybe<Array<Display_Units_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "display_units" */
export enum Display_Units_Constraint {
  /** unique or primary key constraint on columns "value" */
  DisplayUnitsPkey = 'display_units_pkey'
}

export enum Display_Units_Enum {
  /** Canadian Oil Field */
  CanadianOilField = 'canadian_oil_field',
  /** Europe Geothermal */
  EuropeGeothermal = 'europe_geothermal',
  /** European Oil */
  EuropeOilField = 'europe_oil_field',
  /** International HPS (m³/h) */
  InternationalHps = 'international_hps',
  /** International HPS (m³/d) */
  InternationalHpsM3d = 'international_hps_m3d',
  /** Turkey Geothermal */
  TurkeyGeothermal = 'turkey_geothermal',
  /** US HPS (STB/D) */
  UsHps = 'us_hps',
  /** US HPS (G/m) */
  UsHpsGm = 'us_hps_gm',
  /** US Oil Field */
  UsOilField = 'us_oil_field',
  /** US Water Well */
  UsWaterWell = 'us_water_well'
}

/** Boolean expression to compare columns of type "display_units_enum". All fields are combined with logical 'AND'. */
export type Display_Units_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Display_Units_Enum>;
  _in?: InputMaybe<Array<Display_Units_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Display_Units_Enum>;
  _nin?: InputMaybe<Array<Display_Units_Enum>>;
};

/** input type for inserting data into table "display_units" */
export type Display_Units_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Display_Units_Max_Fields = {
  __typename: 'display_units_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Display_Units_Min_Fields = {
  __typename: 'display_units_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "display_units" */
export type Display_Units_Mutation_Response = {
  __typename: 'display_units_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Display_Units>;
};

/** input type for inserting object relation for remote table "display_units" */
export type Display_Units_Obj_Rel_Insert_Input = {
  data: Display_Units_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Display_Units_On_Conflict>;
};

/** on_conflict condition type for table "display_units" */
export type Display_Units_On_Conflict = {
  constraint: Display_Units_Constraint;
  update_columns?: Array<Display_Units_Update_Column>;
  where?: InputMaybe<Display_Units_Bool_Exp>;
};

/** Ordering options when selecting data from "display_units". */
export type Display_Units_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: display_units */
export type Display_Units_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "display_units" */
export enum Display_Units_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "display_units" */
export type Display_Units_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "display_units" */
export type Display_Units_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Display_Units_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Display_Units_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "display_units" */
export enum Display_Units_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Display_Units_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Display_Units_Set_Input>;
  /** filter the rows which have to be updated */
  where: Display_Units_Bool_Exp;
};

/** columns and relationships of "eula" */
export type Eula = {
  __typename: 'eula';
  activated: Scalars['Boolean']['output'];
  activated_on?: Maybe<Scalars['timestamptz']['output']>;
  created_at: Scalars['timestamptz']['output'];
  deactivated_at?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  license: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
  version?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "eula" */
export type Eula_Aggregate = {
  __typename: 'eula_aggregate';
  aggregate?: Maybe<Eula_Aggregate_Fields>;
  nodes: Array<Eula>;
};

/** aggregate fields of "eula" */
export type Eula_Aggregate_Fields = {
  __typename: 'eula_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Eula_Max_Fields>;
  min?: Maybe<Eula_Min_Fields>;
};


/** aggregate fields of "eula" */
export type Eula_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Eula_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "eula". All fields are combined with a logical 'AND'. */
export type Eula_Bool_Exp = {
  _and?: InputMaybe<Array<Eula_Bool_Exp>>;
  _not?: InputMaybe<Eula_Bool_Exp>;
  _or?: InputMaybe<Array<Eula_Bool_Exp>>;
  activated?: InputMaybe<Boolean_Comparison_Exp>;
  activated_on?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deactivated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  license?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  version?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "eula" */
export enum Eula_Constraint {
  /** unique or primary key constraint on columns "id" */
  EulaPkey = 'eula_pkey'
}

/** input type for inserting data into table "eula" */
export type Eula_Insert_Input = {
  activated?: InputMaybe<Scalars['Boolean']['input']>;
  activated_on?: InputMaybe<Scalars['timestamptz']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deactivated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  license?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Eula_Max_Fields = {
  __typename: 'eula_max_fields';
  activated_on?: Maybe<Scalars['timestamptz']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deactivated_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  license?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Eula_Min_Fields = {
  __typename: 'eula_min_fields';
  activated_on?: Maybe<Scalars['timestamptz']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deactivated_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  license?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "eula" */
export type Eula_Mutation_Response = {
  __typename: 'eula_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Eula>;
};

/** input type for inserting object relation for remote table "eula" */
export type Eula_Obj_Rel_Insert_Input = {
  data: Eula_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Eula_On_Conflict>;
};

/** on_conflict condition type for table "eula" */
export type Eula_On_Conflict = {
  constraint: Eula_Constraint;
  update_columns?: Array<Eula_Update_Column>;
  where?: InputMaybe<Eula_Bool_Exp>;
};

/** Ordering options when selecting data from "eula". */
export type Eula_Order_By = {
  activated?: InputMaybe<Order_By>;
  activated_on?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deactivated_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  license?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  version?: InputMaybe<Order_By>;
};

/** primary key columns input for table: eula */
export type Eula_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "eula" */
export enum Eula_Select_Column {
  /** column name */
  Activated = 'activated',
  /** column name */
  ActivatedOn = 'activated_on',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeactivatedAt = 'deactivated_at',
  /** column name */
  Id = 'id',
  /** column name */
  License = 'license',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Version = 'version'
}

/** input type for updating data in table "eula" */
export type Eula_Set_Input = {
  activated?: InputMaybe<Scalars['Boolean']['input']>;
  activated_on?: InputMaybe<Scalars['timestamptz']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deactivated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  license?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "eula" */
export type Eula_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Eula_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Eula_Stream_Cursor_Value_Input = {
  activated?: InputMaybe<Scalars['Boolean']['input']>;
  activated_on?: InputMaybe<Scalars['timestamptz']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deactivated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  license?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "eula" */
export enum Eula_Update_Column {
  /** column name */
  Activated = 'activated',
  /** column name */
  ActivatedOn = 'activated_on',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeactivatedAt = 'deactivated_at',
  /** column name */
  Id = 'id',
  /** column name */
  License = 'license',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Version = 'version'
}

export type Eula_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Eula_Set_Input>;
  /** filter the rows which have to be updated */
  where: Eula_Bool_Exp;
};

/** Boolean expression to compare columns of type "float8". All fields are combined with logical 'AND'. */
export type Float8_Array_Comparison_Exp = {
  /** is the array contained in the given array value */
  _contained_in?: InputMaybe<Array<Scalars['float8']['input']>>;
  /** does the array contain the given value */
  _contains?: InputMaybe<Array<Scalars['float8']['input']>>;
  _eq?: InputMaybe<Array<Scalars['float8']['input']>>;
  _gt?: InputMaybe<Array<Scalars['float8']['input']>>;
  _gte?: InputMaybe<Array<Scalars['float8']['input']>>;
  _in?: InputMaybe<Array<Array<Scalars['float8']['input']>>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Array<Scalars['float8']['input']>>;
  _lte?: InputMaybe<Array<Scalars['float8']['input']>>;
  _neq?: InputMaybe<Array<Scalars['float8']['input']>>;
  _nin?: InputMaybe<Array<Array<Scalars['float8']['input']>>>;
};

/** columns and relationships of "flow_model" */
export type Flow_Model = {
  __typename: 'flow_model';
  comment?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

/** columns and relationships of "flow_model_active" */
export type Flow_Model_Active = {
  __typename: 'flow_model_active';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "flow_model_active" */
export type Flow_Model_Active_Aggregate = {
  __typename: 'flow_model_active_aggregate';
  aggregate?: Maybe<Flow_Model_Active_Aggregate_Fields>;
  nodes: Array<Flow_Model_Active>;
};

/** aggregate fields of "flow_model_active" */
export type Flow_Model_Active_Aggregate_Fields = {
  __typename: 'flow_model_active_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Flow_Model_Active_Max_Fields>;
  min?: Maybe<Flow_Model_Active_Min_Fields>;
};


/** aggregate fields of "flow_model_active" */
export type Flow_Model_Active_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Flow_Model_Active_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "flow_model_active". All fields are combined with a logical 'AND'. */
export type Flow_Model_Active_Bool_Exp = {
  _and?: InputMaybe<Array<Flow_Model_Active_Bool_Exp>>;
  _not?: InputMaybe<Flow_Model_Active_Bool_Exp>;
  _or?: InputMaybe<Array<Flow_Model_Active_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** input type for inserting data into table "flow_model_active" */
export type Flow_Model_Active_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Flow_Model_Active_Max_Fields = {
  __typename: 'flow_model_active_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Flow_Model_Active_Min_Fields = {
  __typename: 'flow_model_active_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "flow_model_active" */
export type Flow_Model_Active_Mutation_Response = {
  __typename: 'flow_model_active_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Flow_Model_Active>;
};

/** Ordering options when selecting data from "flow_model_active". */
export type Flow_Model_Active_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** select columns of table "flow_model_active" */
export enum Flow_Model_Active_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "flow_model_active" */
export type Flow_Model_Active_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "flow_model_active" */
export type Flow_Model_Active_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Flow_Model_Active_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Flow_Model_Active_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type Flow_Model_Active_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Flow_Model_Active_Set_Input>;
  /** filter the rows which have to be updated */
  where: Flow_Model_Active_Bool_Exp;
};

/** aggregated selection of "flow_model" */
export type Flow_Model_Aggregate = {
  __typename: 'flow_model_aggregate';
  aggregate?: Maybe<Flow_Model_Aggregate_Fields>;
  nodes: Array<Flow_Model>;
};

/** aggregate fields of "flow_model" */
export type Flow_Model_Aggregate_Fields = {
  __typename: 'flow_model_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Flow_Model_Max_Fields>;
  min?: Maybe<Flow_Model_Min_Fields>;
};


/** aggregate fields of "flow_model" */
export type Flow_Model_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Flow_Model_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "flow_model". All fields are combined with a logical 'AND'. */
export type Flow_Model_Bool_Exp = {
  _and?: InputMaybe<Array<Flow_Model_Bool_Exp>>;
  _not?: InputMaybe<Flow_Model_Bool_Exp>;
  _or?: InputMaybe<Array<Flow_Model_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "flow_model" */
export enum Flow_Model_Constraint {
  /** unique or primary key constraint on columns "value" */
  FlowModelPkey = 'flow_model_pkey'
}

/** columns and relationships of "flow_model_deprecated" */
export type Flow_Model_Deprecated = {
  __typename: 'flow_model_deprecated';
  value: Flow_Model_Enum;
};

/** aggregated selection of "flow_model_deprecated" */
export type Flow_Model_Deprecated_Aggregate = {
  __typename: 'flow_model_deprecated_aggregate';
  aggregate?: Maybe<Flow_Model_Deprecated_Aggregate_Fields>;
  nodes: Array<Flow_Model_Deprecated>;
};

/** aggregate fields of "flow_model_deprecated" */
export type Flow_Model_Deprecated_Aggregate_Fields = {
  __typename: 'flow_model_deprecated_aggregate_fields';
  count: Scalars['Int']['output'];
};


/** aggregate fields of "flow_model_deprecated" */
export type Flow_Model_Deprecated_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Flow_Model_Deprecated_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "flow_model_deprecated". All fields are combined with a logical 'AND'. */
export type Flow_Model_Deprecated_Bool_Exp = {
  _and?: InputMaybe<Array<Flow_Model_Deprecated_Bool_Exp>>;
  _not?: InputMaybe<Flow_Model_Deprecated_Bool_Exp>;
  _or?: InputMaybe<Array<Flow_Model_Deprecated_Bool_Exp>>;
  value?: InputMaybe<Flow_Model_Enum_Comparison_Exp>;
};

/** unique or primary key constraints on table "flow_model_deprecated" */
export enum Flow_Model_Deprecated_Constraint {
  /** unique or primary key constraint on columns "value" */
  FlowModelDeprecatedPkey = 'flow_model_deprecated_pkey'
}

/** input type for inserting data into table "flow_model_deprecated" */
export type Flow_Model_Deprecated_Insert_Input = {
  value?: InputMaybe<Flow_Model_Enum>;
};

/** response of any mutation on the table "flow_model_deprecated" */
export type Flow_Model_Deprecated_Mutation_Response = {
  __typename: 'flow_model_deprecated_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Flow_Model_Deprecated>;
};

/** on_conflict condition type for table "flow_model_deprecated" */
export type Flow_Model_Deprecated_On_Conflict = {
  constraint: Flow_Model_Deprecated_Constraint;
  update_columns?: Array<Flow_Model_Deprecated_Update_Column>;
  where?: InputMaybe<Flow_Model_Deprecated_Bool_Exp>;
};

/** Ordering options when selecting data from "flow_model_deprecated". */
export type Flow_Model_Deprecated_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: flow_model_deprecated */
export type Flow_Model_Deprecated_Pk_Columns_Input = {
  value: Flow_Model_Enum;
};

/** select columns of table "flow_model_deprecated" */
export enum Flow_Model_Deprecated_Select_Column {
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "flow_model_deprecated" */
export type Flow_Model_Deprecated_Set_Input = {
  value?: InputMaybe<Flow_Model_Enum>;
};

/** Streaming cursor of the table "flow_model_deprecated" */
export type Flow_Model_Deprecated_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Flow_Model_Deprecated_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Flow_Model_Deprecated_Stream_Cursor_Value_Input = {
  value?: InputMaybe<Flow_Model_Enum>;
};

/** update columns of table "flow_model_deprecated" */
export enum Flow_Model_Deprecated_Update_Column {
  /** column name */
  Value = 'value'
}

export type Flow_Model_Deprecated_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Flow_Model_Deprecated_Set_Input>;
  /** filter the rows which have to be updated */
  where: Flow_Model_Deprecated_Bool_Exp;
};

export enum Flow_Model_Enum {
  /** Calc PI */
  CalculateProductivityIndex = 'calculate_productivity_index',
  /** Composite */
  Composite = 'composite',
  /** Enter PI */
  EnterProductivityIndex = 'enter_productivity_index',
  /** Straight Line */
  StraightLine = 'straight_line',
  /** Vogel */
  Vogel = 'vogel',
  /** Vogel (Modified) */
  VogelModified = 'vogel_modified',
  /** Wiggins */
  Wiggins = 'wiggins'
}

/** Boolean expression to compare columns of type "flow_model_enum". All fields are combined with logical 'AND'. */
export type Flow_Model_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Flow_Model_Enum>;
  _in?: InputMaybe<Array<Flow_Model_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Flow_Model_Enum>;
  _nin?: InputMaybe<Array<Flow_Model_Enum>>;
};

/** input type for inserting data into table "flow_model" */
export type Flow_Model_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Flow_Model_Max_Fields = {
  __typename: 'flow_model_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Flow_Model_Min_Fields = {
  __typename: 'flow_model_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "flow_model" */
export type Flow_Model_Mutation_Response = {
  __typename: 'flow_model_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Flow_Model>;
};

/** input type for inserting object relation for remote table "flow_model" */
export type Flow_Model_Obj_Rel_Insert_Input = {
  data: Flow_Model_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Flow_Model_On_Conflict>;
};

/** on_conflict condition type for table "flow_model" */
export type Flow_Model_On_Conflict = {
  constraint: Flow_Model_Constraint;
  update_columns?: Array<Flow_Model_Update_Column>;
  where?: InputMaybe<Flow_Model_Bool_Exp>;
};

/** Ordering options when selecting data from "flow_model". */
export type Flow_Model_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: flow_model */
export type Flow_Model_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "flow_model" */
export enum Flow_Model_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "flow_model" */
export type Flow_Model_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "flow_model" */
export type Flow_Model_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Flow_Model_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Flow_Model_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "flow_model" */
export enum Flow_Model_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Flow_Model_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Flow_Model_Set_Input>;
  /** filter the rows which have to be updated */
  where: Flow_Model_Bool_Exp;
};

/** columns and relationships of "friction_loss_options" */
export type Friction_Loss_Options = {
  __typename: 'friction_loss_options';
  comment?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

/** aggregated selection of "friction_loss_options" */
export type Friction_Loss_Options_Aggregate = {
  __typename: 'friction_loss_options_aggregate';
  aggregate?: Maybe<Friction_Loss_Options_Aggregate_Fields>;
  nodes: Array<Friction_Loss_Options>;
};

/** aggregate fields of "friction_loss_options" */
export type Friction_Loss_Options_Aggregate_Fields = {
  __typename: 'friction_loss_options_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Friction_Loss_Options_Max_Fields>;
  min?: Maybe<Friction_Loss_Options_Min_Fields>;
};


/** aggregate fields of "friction_loss_options" */
export type Friction_Loss_Options_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Friction_Loss_Options_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "friction_loss_options". All fields are combined with a logical 'AND'. */
export type Friction_Loss_Options_Bool_Exp = {
  _and?: InputMaybe<Array<Friction_Loss_Options_Bool_Exp>>;
  _not?: InputMaybe<Friction_Loss_Options_Bool_Exp>;
  _or?: InputMaybe<Array<Friction_Loss_Options_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "friction_loss_options" */
export enum Friction_Loss_Options_Constraint {
  /** unique or primary key constraint on columns "value" */
  FrictionLossOptionsPkey = 'friction_loss_options_pkey'
}

export enum Friction_Loss_Options_Enum {
  /** Beggs & Brill */
  BeggsBrill = 'beggs_brill',
  /** Hazen-Williams */
  HazenWilliams = 'hazen_williams'
}

/** Boolean expression to compare columns of type "friction_loss_options_enum". All fields are combined with logical 'AND'. */
export type Friction_Loss_Options_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Friction_Loss_Options_Enum>;
  _in?: InputMaybe<Array<Friction_Loss_Options_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Friction_Loss_Options_Enum>;
  _nin?: InputMaybe<Array<Friction_Loss_Options_Enum>>;
};

/** input type for inserting data into table "friction_loss_options" */
export type Friction_Loss_Options_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Friction_Loss_Options_Max_Fields = {
  __typename: 'friction_loss_options_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Friction_Loss_Options_Min_Fields = {
  __typename: 'friction_loss_options_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "friction_loss_options" */
export type Friction_Loss_Options_Mutation_Response = {
  __typename: 'friction_loss_options_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Friction_Loss_Options>;
};

/** on_conflict condition type for table "friction_loss_options" */
export type Friction_Loss_Options_On_Conflict = {
  constraint: Friction_Loss_Options_Constraint;
  update_columns?: Array<Friction_Loss_Options_Update_Column>;
  where?: InputMaybe<Friction_Loss_Options_Bool_Exp>;
};

/** Ordering options when selecting data from "friction_loss_options". */
export type Friction_Loss_Options_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: friction_loss_options */
export type Friction_Loss_Options_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "friction_loss_options" */
export enum Friction_Loss_Options_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "friction_loss_options" */
export type Friction_Loss_Options_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "friction_loss_options" */
export type Friction_Loss_Options_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Friction_Loss_Options_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Friction_Loss_Options_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "friction_loss_options" */
export enum Friction_Loss_Options_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Friction_Loss_Options_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Friction_Loss_Options_Set_Input>;
  /** filter the rows which have to be updated */
  where: Friction_Loss_Options_Bool_Exp;
};

/** columns and relationships of "gas_compressibility_options" */
export type Gas_Compressibility_Options = {
  __typename: 'gas_compressibility_options';
  comment?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

/** aggregated selection of "gas_compressibility_options" */
export type Gas_Compressibility_Options_Aggregate = {
  __typename: 'gas_compressibility_options_aggregate';
  aggregate?: Maybe<Gas_Compressibility_Options_Aggregate_Fields>;
  nodes: Array<Gas_Compressibility_Options>;
};

/** aggregate fields of "gas_compressibility_options" */
export type Gas_Compressibility_Options_Aggregate_Fields = {
  __typename: 'gas_compressibility_options_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Gas_Compressibility_Options_Max_Fields>;
  min?: Maybe<Gas_Compressibility_Options_Min_Fields>;
};


/** aggregate fields of "gas_compressibility_options" */
export type Gas_Compressibility_Options_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Gas_Compressibility_Options_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "gas_compressibility_options". All fields are combined with a logical 'AND'. */
export type Gas_Compressibility_Options_Bool_Exp = {
  _and?: InputMaybe<Array<Gas_Compressibility_Options_Bool_Exp>>;
  _not?: InputMaybe<Gas_Compressibility_Options_Bool_Exp>;
  _or?: InputMaybe<Array<Gas_Compressibility_Options_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "gas_compressibility_options" */
export enum Gas_Compressibility_Options_Constraint {
  /** unique or primary key constraint on columns "value" */
  GasCompressibilityOptionsPkey = 'gas_compressibility_options_pkey'
}

export enum Gas_Compressibility_Options_Enum {
  /** Beggs & Brill */
  BeggsBrill = 'beggs_brill',
  /** CNGA */
  Cnga = 'cnga',
  /** Dranchuk Purvis */
  DranchukPurvis = 'dranchuk_purvis',
  /** Peng Robinson */
  PengRobinson = 'peng_robinson',
  /** Poettman Carpenter (Standings Katz) */
  StandingKatz = 'standing_katz'
}

/** Boolean expression to compare columns of type "gas_compressibility_options_enum". All fields are combined with logical 'AND'. */
export type Gas_Compressibility_Options_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Gas_Compressibility_Options_Enum>;
  _in?: InputMaybe<Array<Gas_Compressibility_Options_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Gas_Compressibility_Options_Enum>;
  _nin?: InputMaybe<Array<Gas_Compressibility_Options_Enum>>;
};

/** input type for inserting data into table "gas_compressibility_options" */
export type Gas_Compressibility_Options_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Gas_Compressibility_Options_Max_Fields = {
  __typename: 'gas_compressibility_options_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Gas_Compressibility_Options_Min_Fields = {
  __typename: 'gas_compressibility_options_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "gas_compressibility_options" */
export type Gas_Compressibility_Options_Mutation_Response = {
  __typename: 'gas_compressibility_options_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Gas_Compressibility_Options>;
};

/** input type for inserting object relation for remote table "gas_compressibility_options" */
export type Gas_Compressibility_Options_Obj_Rel_Insert_Input = {
  data: Gas_Compressibility_Options_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Gas_Compressibility_Options_On_Conflict>;
};

/** on_conflict condition type for table "gas_compressibility_options" */
export type Gas_Compressibility_Options_On_Conflict = {
  constraint: Gas_Compressibility_Options_Constraint;
  update_columns?: Array<Gas_Compressibility_Options_Update_Column>;
  where?: InputMaybe<Gas_Compressibility_Options_Bool_Exp>;
};

/** Ordering options when selecting data from "gas_compressibility_options". */
export type Gas_Compressibility_Options_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: gas_compressibility_options */
export type Gas_Compressibility_Options_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "gas_compressibility_options" */
export enum Gas_Compressibility_Options_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "gas_compressibility_options" */
export type Gas_Compressibility_Options_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "gas_compressibility_options" */
export type Gas_Compressibility_Options_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Gas_Compressibility_Options_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Gas_Compressibility_Options_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "gas_compressibility_options" */
export enum Gas_Compressibility_Options_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Gas_Compressibility_Options_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Gas_Compressibility_Options_Set_Input>;
  /** filter the rows which have to be updated */
  where: Gas_Compressibility_Options_Bool_Exp;
};

/** columns and relationships of "gas_viscosity_options" */
export type Gas_Viscosity_Options = {
  __typename: 'gas_viscosity_options';
  comment?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

/** aggregated selection of "gas_viscosity_options" */
export type Gas_Viscosity_Options_Aggregate = {
  __typename: 'gas_viscosity_options_aggregate';
  aggregate?: Maybe<Gas_Viscosity_Options_Aggregate_Fields>;
  nodes: Array<Gas_Viscosity_Options>;
};

/** aggregate fields of "gas_viscosity_options" */
export type Gas_Viscosity_Options_Aggregate_Fields = {
  __typename: 'gas_viscosity_options_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Gas_Viscosity_Options_Max_Fields>;
  min?: Maybe<Gas_Viscosity_Options_Min_Fields>;
};


/** aggregate fields of "gas_viscosity_options" */
export type Gas_Viscosity_Options_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Gas_Viscosity_Options_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "gas_viscosity_options". All fields are combined with a logical 'AND'. */
export type Gas_Viscosity_Options_Bool_Exp = {
  _and?: InputMaybe<Array<Gas_Viscosity_Options_Bool_Exp>>;
  _not?: InputMaybe<Gas_Viscosity_Options_Bool_Exp>;
  _or?: InputMaybe<Array<Gas_Viscosity_Options_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "gas_viscosity_options" */
export enum Gas_Viscosity_Options_Constraint {
  /** unique or primary key constraint on columns "value" */
  GasViscosityOptionsPkey = 'gas_viscosity_options_pkey'
}

export enum Gas_Viscosity_Options_Enum {
  /** Standings Dempsey (Carr Kobayashi Burrows) */
  CarrKobayashiBurrows = 'carr_kobayashi_burrows',
  /** Drankchuk Islam Bentsen (Carr Kobayashi Burrows) */
  CarrKobayashiBurrowsDib = 'carr_kobayashi_burrows_dib',
  /** Chen Ruth */
  ChenRuth = 'chen_ruth',
  /** Lee */
  Lee = 'lee'
}

/** Boolean expression to compare columns of type "gas_viscosity_options_enum". All fields are combined with logical 'AND'. */
export type Gas_Viscosity_Options_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Gas_Viscosity_Options_Enum>;
  _in?: InputMaybe<Array<Gas_Viscosity_Options_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Gas_Viscosity_Options_Enum>;
  _nin?: InputMaybe<Array<Gas_Viscosity_Options_Enum>>;
};

/** input type for inserting data into table "gas_viscosity_options" */
export type Gas_Viscosity_Options_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Gas_Viscosity_Options_Max_Fields = {
  __typename: 'gas_viscosity_options_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Gas_Viscosity_Options_Min_Fields = {
  __typename: 'gas_viscosity_options_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "gas_viscosity_options" */
export type Gas_Viscosity_Options_Mutation_Response = {
  __typename: 'gas_viscosity_options_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Gas_Viscosity_Options>;
};

/** input type for inserting object relation for remote table "gas_viscosity_options" */
export type Gas_Viscosity_Options_Obj_Rel_Insert_Input = {
  data: Gas_Viscosity_Options_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Gas_Viscosity_Options_On_Conflict>;
};

/** on_conflict condition type for table "gas_viscosity_options" */
export type Gas_Viscosity_Options_On_Conflict = {
  constraint: Gas_Viscosity_Options_Constraint;
  update_columns?: Array<Gas_Viscosity_Options_Update_Column>;
  where?: InputMaybe<Gas_Viscosity_Options_Bool_Exp>;
};

/** Ordering options when selecting data from "gas_viscosity_options". */
export type Gas_Viscosity_Options_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: gas_viscosity_options */
export type Gas_Viscosity_Options_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "gas_viscosity_options" */
export enum Gas_Viscosity_Options_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "gas_viscosity_options" */
export type Gas_Viscosity_Options_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "gas_viscosity_options" */
export type Gas_Viscosity_Options_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Gas_Viscosity_Options_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Gas_Viscosity_Options_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "gas_viscosity_options" */
export enum Gas_Viscosity_Options_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Gas_Viscosity_Options_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Gas_Viscosity_Options_Set_Input>;
  /** filter the rows which have to be updated */
  where: Gas_Viscosity_Options_Bool_Exp;
};

/** columns and relationships of "housings" */
export type Housings = {
  __typename: 'housings';
  author_id: Scalars['String']['output'];
  created_at: Scalars['timestamptz']['output'];
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  housing_number?: Maybe<Scalars['Int']['output']>;
  id: Scalars['uuid']['output'];
  imported_sizing_id?: Maybe<Scalars['Int']['output']>;
  include_ecopetrol_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  include_koc_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  length_inches?: Maybe<Scalars['numeric']['output']>;
  only_ecopetrol_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  only_koc_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  pump?: Maybe<Pumps>;
  pump_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  sizing_import?: Maybe<Sizing_Imports>;
  stage_count?: Maybe<Scalars['Int']['output']>;
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Users;
  weight_pounds?: Maybe<Scalars['numeric']['output']>;
};

/** aggregated selection of "housings" */
export type Housings_Aggregate = {
  __typename: 'housings_aggregate';
  aggregate?: Maybe<Housings_Aggregate_Fields>;
  nodes: Array<Housings>;
};

export type Housings_Aggregate_Bool_Exp = {
  count?: InputMaybe<Housings_Aggregate_Bool_Exp_Count>;
};

export type Housings_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Housings_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Housings_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "housings" */
export type Housings_Aggregate_Fields = {
  __typename: 'housings_aggregate_fields';
  avg?: Maybe<Housings_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Housings_Max_Fields>;
  min?: Maybe<Housings_Min_Fields>;
  stddev?: Maybe<Housings_Stddev_Fields>;
  stddev_pop?: Maybe<Housings_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Housings_Stddev_Samp_Fields>;
  sum?: Maybe<Housings_Sum_Fields>;
  var_pop?: Maybe<Housings_Var_Pop_Fields>;
  var_samp?: Maybe<Housings_Var_Samp_Fields>;
  variance?: Maybe<Housings_Variance_Fields>;
};


/** aggregate fields of "housings" */
export type Housings_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Housings_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "housings" */
export type Housings_Aggregate_Order_By = {
  avg?: InputMaybe<Housings_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Housings_Max_Order_By>;
  min?: InputMaybe<Housings_Min_Order_By>;
  stddev?: InputMaybe<Housings_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Housings_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Housings_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Housings_Sum_Order_By>;
  var_pop?: InputMaybe<Housings_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Housings_Var_Samp_Order_By>;
  variance?: InputMaybe<Housings_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "housings" */
export type Housings_Arr_Rel_Insert_Input = {
  data: Array<Housings_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Housings_On_Conflict>;
};

/** aggregate avg on columns */
export type Housings_Avg_Fields = {
  __typename: 'housings_avg_fields';
  housing_number?: Maybe<Scalars['Float']['output']>;
  imported_sizing_id?: Maybe<Scalars['Float']['output']>;
  length_inches?: Maybe<Scalars['Float']['output']>;
  stage_count?: Maybe<Scalars['Float']['output']>;
  weight_pounds?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "housings" */
export type Housings_Avg_Order_By = {
  housing_number?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  length_inches?: InputMaybe<Order_By>;
  stage_count?: InputMaybe<Order_By>;
  weight_pounds?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "housings". All fields are combined with a logical 'AND'. */
export type Housings_Bool_Exp = {
  _and?: InputMaybe<Array<Housings_Bool_Exp>>;
  _not?: InputMaybe<Housings_Bool_Exp>;
  _or?: InputMaybe<Array<Housings_Bool_Exp>>;
  author_id?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  housing_number?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  imported_sizing_id?: InputMaybe<Int_Comparison_Exp>;
  include_ecopetrol_timestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  include_koc_timestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  length_inches?: InputMaybe<Numeric_Comparison_Exp>;
  only_ecopetrol_timestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  only_koc_timestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  pump?: InputMaybe<Pumps_Bool_Exp>;
  pump_id?: InputMaybe<Uuid_Comparison_Exp>;
  sizing_import?: InputMaybe<Sizing_Imports_Bool_Exp>;
  stage_count?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  weight_pounds?: InputMaybe<Numeric_Comparison_Exp>;
};

/** unique or primary key constraints on table "housings" */
export enum Housings_Constraint {
  /** unique or primary key constraint on columns "id" */
  HousingsPkey = 'housings_pkey'
}

/** input type for incrementing numeric columns in table "housings" */
export type Housings_Inc_Input = {
  housing_number?: InputMaybe<Scalars['Int']['input']>;
  imported_sizing_id?: InputMaybe<Scalars['Int']['input']>;
  length_inches?: InputMaybe<Scalars['numeric']['input']>;
  stage_count?: InputMaybe<Scalars['Int']['input']>;
  weight_pounds?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "housings" */
export type Housings_Insert_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  housing_number?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  imported_sizing_id?: InputMaybe<Scalars['Int']['input']>;
  include_ecopetrol_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  include_koc_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  length_inches?: InputMaybe<Scalars['numeric']['input']>;
  only_ecopetrol_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  only_koc_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  pump?: InputMaybe<Pumps_Obj_Rel_Insert_Input>;
  pump_id?: InputMaybe<Scalars['uuid']['input']>;
  sizing_import?: InputMaybe<Sizing_Imports_Obj_Rel_Insert_Input>;
  stage_count?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  weight_pounds?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate max on columns */
export type Housings_Max_Fields = {
  __typename: 'housings_max_fields';
  author_id?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  housing_number?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  imported_sizing_id?: Maybe<Scalars['Int']['output']>;
  include_ecopetrol_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  include_koc_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  length_inches?: Maybe<Scalars['numeric']['output']>;
  only_ecopetrol_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  only_koc_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  pump_id?: Maybe<Scalars['uuid']['output']>;
  stage_count?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  weight_pounds?: Maybe<Scalars['numeric']['output']>;
};

/** order by max() on columns of table "housings" */
export type Housings_Max_Order_By = {
  author_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  housing_number?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  include_ecopetrol_timestamp?: InputMaybe<Order_By>;
  include_koc_timestamp?: InputMaybe<Order_By>;
  length_inches?: InputMaybe<Order_By>;
  only_ecopetrol_timestamp?: InputMaybe<Order_By>;
  only_koc_timestamp?: InputMaybe<Order_By>;
  pump_id?: InputMaybe<Order_By>;
  stage_count?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  weight_pounds?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Housings_Min_Fields = {
  __typename: 'housings_min_fields';
  author_id?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  housing_number?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  imported_sizing_id?: Maybe<Scalars['Int']['output']>;
  include_ecopetrol_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  include_koc_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  length_inches?: Maybe<Scalars['numeric']['output']>;
  only_ecopetrol_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  only_koc_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  pump_id?: Maybe<Scalars['uuid']['output']>;
  stage_count?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  weight_pounds?: Maybe<Scalars['numeric']['output']>;
};

/** order by min() on columns of table "housings" */
export type Housings_Min_Order_By = {
  author_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  housing_number?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  include_ecopetrol_timestamp?: InputMaybe<Order_By>;
  include_koc_timestamp?: InputMaybe<Order_By>;
  length_inches?: InputMaybe<Order_By>;
  only_ecopetrol_timestamp?: InputMaybe<Order_By>;
  only_koc_timestamp?: InputMaybe<Order_By>;
  pump_id?: InputMaybe<Order_By>;
  stage_count?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  weight_pounds?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "housings" */
export type Housings_Mutation_Response = {
  __typename: 'housings_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Housings>;
};

/** input type for inserting object relation for remote table "housings" */
export type Housings_Obj_Rel_Insert_Input = {
  data: Housings_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Housings_On_Conflict>;
};

/** on_conflict condition type for table "housings" */
export type Housings_On_Conflict = {
  constraint: Housings_Constraint;
  update_columns?: Array<Housings_Update_Column>;
  where?: InputMaybe<Housings_Bool_Exp>;
};

/** Ordering options when selecting data from "housings". */
export type Housings_Order_By = {
  author_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  housing_number?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  include_ecopetrol_timestamp?: InputMaybe<Order_By>;
  include_koc_timestamp?: InputMaybe<Order_By>;
  length_inches?: InputMaybe<Order_By>;
  only_ecopetrol_timestamp?: InputMaybe<Order_By>;
  only_koc_timestamp?: InputMaybe<Order_By>;
  pump?: InputMaybe<Pumps_Order_By>;
  pump_id?: InputMaybe<Order_By>;
  sizing_import?: InputMaybe<Sizing_Imports_Order_By>;
  stage_count?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  weight_pounds?: InputMaybe<Order_By>;
};

/** primary key columns input for table: housings */
export type Housings_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "housings" */
export enum Housings_Select_Column {
  /** column name */
  AuthorId = 'author_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  HousingNumber = 'housing_number',
  /** column name */
  Id = 'id',
  /** column name */
  ImportedSizingId = 'imported_sizing_id',
  /** column name */
  IncludeEcopetrolTimestamp = 'include_ecopetrol_timestamp',
  /** column name */
  IncludeKocTimestamp = 'include_koc_timestamp',
  /** column name */
  LengthInches = 'length_inches',
  /** column name */
  OnlyEcopetrolTimestamp = 'only_ecopetrol_timestamp',
  /** column name */
  OnlyKocTimestamp = 'only_koc_timestamp',
  /** column name */
  PumpId = 'pump_id',
  /** column name */
  StageCount = 'stage_count',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WeightPounds = 'weight_pounds'
}

/** input type for updating data in table "housings" */
export type Housings_Set_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  housing_number?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  imported_sizing_id?: InputMaybe<Scalars['Int']['input']>;
  include_ecopetrol_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  include_koc_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  length_inches?: InputMaybe<Scalars['numeric']['input']>;
  only_ecopetrol_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  only_koc_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  pump_id?: InputMaybe<Scalars['uuid']['input']>;
  stage_count?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  weight_pounds?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate stddev on columns */
export type Housings_Stddev_Fields = {
  __typename: 'housings_stddev_fields';
  housing_number?: Maybe<Scalars['Float']['output']>;
  imported_sizing_id?: Maybe<Scalars['Float']['output']>;
  length_inches?: Maybe<Scalars['Float']['output']>;
  stage_count?: Maybe<Scalars['Float']['output']>;
  weight_pounds?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "housings" */
export type Housings_Stddev_Order_By = {
  housing_number?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  length_inches?: InputMaybe<Order_By>;
  stage_count?: InputMaybe<Order_By>;
  weight_pounds?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Housings_Stddev_Pop_Fields = {
  __typename: 'housings_stddev_pop_fields';
  housing_number?: Maybe<Scalars['Float']['output']>;
  imported_sizing_id?: Maybe<Scalars['Float']['output']>;
  length_inches?: Maybe<Scalars['Float']['output']>;
  stage_count?: Maybe<Scalars['Float']['output']>;
  weight_pounds?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "housings" */
export type Housings_Stddev_Pop_Order_By = {
  housing_number?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  length_inches?: InputMaybe<Order_By>;
  stage_count?: InputMaybe<Order_By>;
  weight_pounds?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Housings_Stddev_Samp_Fields = {
  __typename: 'housings_stddev_samp_fields';
  housing_number?: Maybe<Scalars['Float']['output']>;
  imported_sizing_id?: Maybe<Scalars['Float']['output']>;
  length_inches?: Maybe<Scalars['Float']['output']>;
  stage_count?: Maybe<Scalars['Float']['output']>;
  weight_pounds?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "housings" */
export type Housings_Stddev_Samp_Order_By = {
  housing_number?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  length_inches?: InputMaybe<Order_By>;
  stage_count?: InputMaybe<Order_By>;
  weight_pounds?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "housings" */
export type Housings_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Housings_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Housings_Stream_Cursor_Value_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  housing_number?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  imported_sizing_id?: InputMaybe<Scalars['Int']['input']>;
  include_ecopetrol_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  include_koc_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  length_inches?: InputMaybe<Scalars['numeric']['input']>;
  only_ecopetrol_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  only_koc_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  pump_id?: InputMaybe<Scalars['uuid']['input']>;
  stage_count?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  weight_pounds?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate sum on columns */
export type Housings_Sum_Fields = {
  __typename: 'housings_sum_fields';
  housing_number?: Maybe<Scalars['Int']['output']>;
  imported_sizing_id?: Maybe<Scalars['Int']['output']>;
  length_inches?: Maybe<Scalars['numeric']['output']>;
  stage_count?: Maybe<Scalars['Int']['output']>;
  weight_pounds?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "housings" */
export type Housings_Sum_Order_By = {
  housing_number?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  length_inches?: InputMaybe<Order_By>;
  stage_count?: InputMaybe<Order_By>;
  weight_pounds?: InputMaybe<Order_By>;
};

/** update columns of table "housings" */
export enum Housings_Update_Column {
  /** column name */
  AuthorId = 'author_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  HousingNumber = 'housing_number',
  /** column name */
  Id = 'id',
  /** column name */
  ImportedSizingId = 'imported_sizing_id',
  /** column name */
  IncludeEcopetrolTimestamp = 'include_ecopetrol_timestamp',
  /** column name */
  IncludeKocTimestamp = 'include_koc_timestamp',
  /** column name */
  LengthInches = 'length_inches',
  /** column name */
  OnlyEcopetrolTimestamp = 'only_ecopetrol_timestamp',
  /** column name */
  OnlyKocTimestamp = 'only_koc_timestamp',
  /** column name */
  PumpId = 'pump_id',
  /** column name */
  StageCount = 'stage_count',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WeightPounds = 'weight_pounds'
}

export type Housings_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Housings_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Housings_Set_Input>;
  /** filter the rows which have to be updated */
  where: Housings_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Housings_Var_Pop_Fields = {
  __typename: 'housings_var_pop_fields';
  housing_number?: Maybe<Scalars['Float']['output']>;
  imported_sizing_id?: Maybe<Scalars['Float']['output']>;
  length_inches?: Maybe<Scalars['Float']['output']>;
  stage_count?: Maybe<Scalars['Float']['output']>;
  weight_pounds?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "housings" */
export type Housings_Var_Pop_Order_By = {
  housing_number?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  length_inches?: InputMaybe<Order_By>;
  stage_count?: InputMaybe<Order_By>;
  weight_pounds?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Housings_Var_Samp_Fields = {
  __typename: 'housings_var_samp_fields';
  housing_number?: Maybe<Scalars['Float']['output']>;
  imported_sizing_id?: Maybe<Scalars['Float']['output']>;
  length_inches?: Maybe<Scalars['Float']['output']>;
  stage_count?: Maybe<Scalars['Float']['output']>;
  weight_pounds?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "housings" */
export type Housings_Var_Samp_Order_By = {
  housing_number?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  length_inches?: InputMaybe<Order_By>;
  stage_count?: InputMaybe<Order_By>;
  weight_pounds?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Housings_Variance_Fields = {
  __typename: 'housings_variance_fields';
  housing_number?: Maybe<Scalars['Float']['output']>;
  imported_sizing_id?: Maybe<Scalars['Float']['output']>;
  length_inches?: Maybe<Scalars['Float']['output']>;
  stage_count?: Maybe<Scalars['Float']['output']>;
  weight_pounds?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "housings" */
export type Housings_Variance_Order_By = {
  housing_number?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  length_inches?: InputMaybe<Order_By>;
  stage_count?: InputMaybe<Order_By>;
  weight_pounds?: InputMaybe<Order_By>;
};

/** columns and relationships of "hps_liquid_type" */
export type Hps_Liquid_Type = {
  __typename: 'hps_liquid_type';
  comment?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

/** aggregated selection of "hps_liquid_type" */
export type Hps_Liquid_Type_Aggregate = {
  __typename: 'hps_liquid_type_aggregate';
  aggregate?: Maybe<Hps_Liquid_Type_Aggregate_Fields>;
  nodes: Array<Hps_Liquid_Type>;
};

/** aggregate fields of "hps_liquid_type" */
export type Hps_Liquid_Type_Aggregate_Fields = {
  __typename: 'hps_liquid_type_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Hps_Liquid_Type_Max_Fields>;
  min?: Maybe<Hps_Liquid_Type_Min_Fields>;
};


/** aggregate fields of "hps_liquid_type" */
export type Hps_Liquid_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Hps_Liquid_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "hps_liquid_type". All fields are combined with a logical 'AND'. */
export type Hps_Liquid_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Hps_Liquid_Type_Bool_Exp>>;
  _not?: InputMaybe<Hps_Liquid_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Hps_Liquid_Type_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "hps_liquid_type" */
export enum Hps_Liquid_Type_Constraint {
  /** unique or primary key constraint on columns "value" */
  HpsLiquidTypePkey = 'hps_liquid_type_pkey'
}

export enum Hps_Liquid_Type_Enum {
  /** Amine */
  Amine = 'amine',
  /** Condensate */
  Condensate = 'condensate',
  /** Multiphase */
  Multiphase = 'multiphase',
  /** Oil */
  Oil = 'oil',
  /** Water */
  Water = 'water'
}

/** Boolean expression to compare columns of type "hps_liquid_type_enum". All fields are combined with logical 'AND'. */
export type Hps_Liquid_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Hps_Liquid_Type_Enum>;
  _in?: InputMaybe<Array<Hps_Liquid_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Hps_Liquid_Type_Enum>;
  _nin?: InputMaybe<Array<Hps_Liquid_Type_Enum>>;
};

/** input type for inserting data into table "hps_liquid_type" */
export type Hps_Liquid_Type_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Hps_Liquid_Type_Max_Fields = {
  __typename: 'hps_liquid_type_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Hps_Liquid_Type_Min_Fields = {
  __typename: 'hps_liquid_type_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "hps_liquid_type" */
export type Hps_Liquid_Type_Mutation_Response = {
  __typename: 'hps_liquid_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Hps_Liquid_Type>;
};

/** on_conflict condition type for table "hps_liquid_type" */
export type Hps_Liquid_Type_On_Conflict = {
  constraint: Hps_Liquid_Type_Constraint;
  update_columns?: Array<Hps_Liquid_Type_Update_Column>;
  where?: InputMaybe<Hps_Liquid_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "hps_liquid_type". */
export type Hps_Liquid_Type_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: hps_liquid_type */
export type Hps_Liquid_Type_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "hps_liquid_type" */
export enum Hps_Liquid_Type_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "hps_liquid_type" */
export type Hps_Liquid_Type_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "hps_liquid_type" */
export type Hps_Liquid_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Hps_Liquid_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Hps_Liquid_Type_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "hps_liquid_type" */
export enum Hps_Liquid_Type_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Hps_Liquid_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Hps_Liquid_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Hps_Liquid_Type_Bool_Exp;
};

/** columns and relationships of "intakes" */
export type Intakes = {
  __typename: 'intakes';
  author_id: Scalars['String']['output'];
  bhp0?: Maybe<Scalars['numeric']['output']>;
  bhp1?: Maybe<Scalars['numeric']['output']>;
  bhp2?: Maybe<Scalars['numeric']['output']>;
  bhp3?: Maybe<Scalars['numeric']['output']>;
  bhp4?: Maybe<Scalars['numeric']['output']>;
  bhp5?: Maybe<Scalars['numeric']['output']>;
  bolt_on?: Maybe<Scalars['Boolean']['output']>;
  configuration?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  eff1?: Maybe<Scalars['numeric']['output']>;
  eff2?: Maybe<Scalars['numeric']['output']>;
  high_strength_shaft_limit_hp?: Maybe<Scalars['Int']['output']>;
  housing_material?: Maybe<Scalars['String']['output']>;
  hp?: Maybe<Scalars['numeric']['output']>;
  id: Scalars['uuid']['output'];
  imported_sizing_id?: Maybe<Scalars['Int']['output']>;
  include_ecopetrol_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  include_koc_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  inner_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  intake_type?: Maybe<Scalars['String']['output']>;
  is_hps: Scalars['Boolean']['output'];
  length_inches?: Maybe<Scalars['numeric']['output']>;
  manufacturer?: Maybe<Scalars['String']['output']>;
  max_rate_bpd?: Maybe<Scalars['Int']['output']>;
  neck_inner_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  neck_outer_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  only_ecopetrol_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  only_koc_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  outer_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  part_number?: Maybe<Scalars['String']['output']>;
  port_area_square_inches: Scalars['numeric']['output'];
  /** A computed field, executes function "prioritizeintakemanufacturer" */
  prioritized_manufacturer?: Maybe<Scalars['String']['output']>;
  shaft_limit_hp?: Maybe<Scalars['Int']['output']>;
  shaft_material?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  sizing_import?: Maybe<Sizing_Imports>;
  stage_count?: Maybe<Scalars['Int']['output']>;
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Users;
  weight_pounds?: Maybe<Scalars['numeric']['output']>;
};

/** aggregated selection of "intakes" */
export type Intakes_Aggregate = {
  __typename: 'intakes_aggregate';
  aggregate?: Maybe<Intakes_Aggregate_Fields>;
  nodes: Array<Intakes>;
};

export type Intakes_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Intakes_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Intakes_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Intakes_Aggregate_Bool_Exp_Count>;
};

export type Intakes_Aggregate_Bool_Exp_Bool_And = {
  arguments: Intakes_Select_Column_Intakes_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Intakes_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Intakes_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Intakes_Select_Column_Intakes_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Intakes_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Intakes_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Intakes_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Intakes_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "intakes" */
export type Intakes_Aggregate_Fields = {
  __typename: 'intakes_aggregate_fields';
  avg?: Maybe<Intakes_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Intakes_Max_Fields>;
  min?: Maybe<Intakes_Min_Fields>;
  stddev?: Maybe<Intakes_Stddev_Fields>;
  stddev_pop?: Maybe<Intakes_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Intakes_Stddev_Samp_Fields>;
  sum?: Maybe<Intakes_Sum_Fields>;
  var_pop?: Maybe<Intakes_Var_Pop_Fields>;
  var_samp?: Maybe<Intakes_Var_Samp_Fields>;
  variance?: Maybe<Intakes_Variance_Fields>;
};


/** aggregate fields of "intakes" */
export type Intakes_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Intakes_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "intakes" */
export type Intakes_Aggregate_Order_By = {
  avg?: InputMaybe<Intakes_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Intakes_Max_Order_By>;
  min?: InputMaybe<Intakes_Min_Order_By>;
  stddev?: InputMaybe<Intakes_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Intakes_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Intakes_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Intakes_Sum_Order_By>;
  var_pop?: InputMaybe<Intakes_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Intakes_Var_Samp_Order_By>;
  variance?: InputMaybe<Intakes_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "intakes" */
export type Intakes_Arr_Rel_Insert_Input = {
  data: Array<Intakes_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Intakes_On_Conflict>;
};

/** aggregate avg on columns */
export type Intakes_Avg_Fields = {
  __typename: 'intakes_avg_fields';
  bhp0?: Maybe<Scalars['Float']['output']>;
  bhp1?: Maybe<Scalars['Float']['output']>;
  bhp2?: Maybe<Scalars['Float']['output']>;
  bhp3?: Maybe<Scalars['Float']['output']>;
  bhp4?: Maybe<Scalars['Float']['output']>;
  bhp5?: Maybe<Scalars['Float']['output']>;
  eff1?: Maybe<Scalars['Float']['output']>;
  eff2?: Maybe<Scalars['Float']['output']>;
  high_strength_shaft_limit_hp?: Maybe<Scalars['Float']['output']>;
  hp?: Maybe<Scalars['Float']['output']>;
  imported_sizing_id?: Maybe<Scalars['Float']['output']>;
  inner_diameter_inches?: Maybe<Scalars['Float']['output']>;
  length_inches?: Maybe<Scalars['Float']['output']>;
  max_rate_bpd?: Maybe<Scalars['Float']['output']>;
  neck_inner_diameter_inches?: Maybe<Scalars['Float']['output']>;
  neck_outer_diameter_inches?: Maybe<Scalars['Float']['output']>;
  outer_diameter_inches?: Maybe<Scalars['Float']['output']>;
  port_area_square_inches?: Maybe<Scalars['Float']['output']>;
  shaft_limit_hp?: Maybe<Scalars['Float']['output']>;
  stage_count?: Maybe<Scalars['Float']['output']>;
  weight_pounds?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "intakes" */
export type Intakes_Avg_Order_By = {
  bhp0?: InputMaybe<Order_By>;
  bhp1?: InputMaybe<Order_By>;
  bhp2?: InputMaybe<Order_By>;
  bhp3?: InputMaybe<Order_By>;
  bhp4?: InputMaybe<Order_By>;
  bhp5?: InputMaybe<Order_By>;
  eff1?: InputMaybe<Order_By>;
  eff2?: InputMaybe<Order_By>;
  high_strength_shaft_limit_hp?: InputMaybe<Order_By>;
  hp?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  inner_diameter_inches?: InputMaybe<Order_By>;
  length_inches?: InputMaybe<Order_By>;
  max_rate_bpd?: InputMaybe<Order_By>;
  neck_inner_diameter_inches?: InputMaybe<Order_By>;
  neck_outer_diameter_inches?: InputMaybe<Order_By>;
  outer_diameter_inches?: InputMaybe<Order_By>;
  port_area_square_inches?: InputMaybe<Order_By>;
  shaft_limit_hp?: InputMaybe<Order_By>;
  stage_count?: InputMaybe<Order_By>;
  weight_pounds?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "intakes". All fields are combined with a logical 'AND'. */
export type Intakes_Bool_Exp = {
  _and?: InputMaybe<Array<Intakes_Bool_Exp>>;
  _not?: InputMaybe<Intakes_Bool_Exp>;
  _or?: InputMaybe<Array<Intakes_Bool_Exp>>;
  author_id?: InputMaybe<String_Comparison_Exp>;
  bhp0?: InputMaybe<Numeric_Comparison_Exp>;
  bhp1?: InputMaybe<Numeric_Comparison_Exp>;
  bhp2?: InputMaybe<Numeric_Comparison_Exp>;
  bhp3?: InputMaybe<Numeric_Comparison_Exp>;
  bhp4?: InputMaybe<Numeric_Comparison_Exp>;
  bhp5?: InputMaybe<Numeric_Comparison_Exp>;
  bolt_on?: InputMaybe<Boolean_Comparison_Exp>;
  configuration?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  eff1?: InputMaybe<Numeric_Comparison_Exp>;
  eff2?: InputMaybe<Numeric_Comparison_Exp>;
  high_strength_shaft_limit_hp?: InputMaybe<Int_Comparison_Exp>;
  housing_material?: InputMaybe<String_Comparison_Exp>;
  hp?: InputMaybe<Numeric_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  imported_sizing_id?: InputMaybe<Int_Comparison_Exp>;
  include_ecopetrol_timestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  include_koc_timestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  inner_diameter_inches?: InputMaybe<Numeric_Comparison_Exp>;
  intake_type?: InputMaybe<String_Comparison_Exp>;
  is_hps?: InputMaybe<Boolean_Comparison_Exp>;
  length_inches?: InputMaybe<Numeric_Comparison_Exp>;
  manufacturer?: InputMaybe<String_Comparison_Exp>;
  max_rate_bpd?: InputMaybe<Int_Comparison_Exp>;
  neck_inner_diameter_inches?: InputMaybe<Numeric_Comparison_Exp>;
  neck_outer_diameter_inches?: InputMaybe<Numeric_Comparison_Exp>;
  only_ecopetrol_timestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  only_koc_timestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  outer_diameter_inches?: InputMaybe<Numeric_Comparison_Exp>;
  part_number?: InputMaybe<String_Comparison_Exp>;
  port_area_square_inches?: InputMaybe<Numeric_Comparison_Exp>;
  prioritized_manufacturer?: InputMaybe<String_Comparison_Exp>;
  shaft_limit_hp?: InputMaybe<Int_Comparison_Exp>;
  shaft_material?: InputMaybe<String_Comparison_Exp>;
  sizing_import?: InputMaybe<Sizing_Imports_Bool_Exp>;
  stage_count?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  weight_pounds?: InputMaybe<Numeric_Comparison_Exp>;
};

/** unique or primary key constraints on table "intakes" */
export enum Intakes_Constraint {
  /** unique or primary key constraint on columns "id" */
  IntakesPkey = 'intakes_pkey'
}

/** input type for incrementing numeric columns in table "intakes" */
export type Intakes_Inc_Input = {
  bhp0?: InputMaybe<Scalars['numeric']['input']>;
  bhp1?: InputMaybe<Scalars['numeric']['input']>;
  bhp2?: InputMaybe<Scalars['numeric']['input']>;
  bhp3?: InputMaybe<Scalars['numeric']['input']>;
  bhp4?: InputMaybe<Scalars['numeric']['input']>;
  bhp5?: InputMaybe<Scalars['numeric']['input']>;
  eff1?: InputMaybe<Scalars['numeric']['input']>;
  eff2?: InputMaybe<Scalars['numeric']['input']>;
  high_strength_shaft_limit_hp?: InputMaybe<Scalars['Int']['input']>;
  hp?: InputMaybe<Scalars['numeric']['input']>;
  imported_sizing_id?: InputMaybe<Scalars['Int']['input']>;
  inner_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  length_inches?: InputMaybe<Scalars['numeric']['input']>;
  max_rate_bpd?: InputMaybe<Scalars['Int']['input']>;
  neck_inner_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  neck_outer_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  outer_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  port_area_square_inches?: InputMaybe<Scalars['numeric']['input']>;
  shaft_limit_hp?: InputMaybe<Scalars['Int']['input']>;
  stage_count?: InputMaybe<Scalars['Int']['input']>;
  weight_pounds?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "intakes" */
export type Intakes_Insert_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  bhp0?: InputMaybe<Scalars['numeric']['input']>;
  bhp1?: InputMaybe<Scalars['numeric']['input']>;
  bhp2?: InputMaybe<Scalars['numeric']['input']>;
  bhp3?: InputMaybe<Scalars['numeric']['input']>;
  bhp4?: InputMaybe<Scalars['numeric']['input']>;
  bhp5?: InputMaybe<Scalars['numeric']['input']>;
  bolt_on?: InputMaybe<Scalars['Boolean']['input']>;
  configuration?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  eff1?: InputMaybe<Scalars['numeric']['input']>;
  eff2?: InputMaybe<Scalars['numeric']['input']>;
  high_strength_shaft_limit_hp?: InputMaybe<Scalars['Int']['input']>;
  housing_material?: InputMaybe<Scalars['String']['input']>;
  hp?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  imported_sizing_id?: InputMaybe<Scalars['Int']['input']>;
  include_ecopetrol_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  include_koc_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  inner_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  intake_type?: InputMaybe<Scalars['String']['input']>;
  is_hps?: InputMaybe<Scalars['Boolean']['input']>;
  length_inches?: InputMaybe<Scalars['numeric']['input']>;
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  max_rate_bpd?: InputMaybe<Scalars['Int']['input']>;
  neck_inner_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  neck_outer_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  only_ecopetrol_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  only_koc_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  outer_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  part_number?: InputMaybe<Scalars['String']['input']>;
  port_area_square_inches?: InputMaybe<Scalars['numeric']['input']>;
  shaft_limit_hp?: InputMaybe<Scalars['Int']['input']>;
  shaft_material?: InputMaybe<Scalars['String']['input']>;
  sizing_import?: InputMaybe<Sizing_Imports_Obj_Rel_Insert_Input>;
  stage_count?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  weight_pounds?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate max on columns */
export type Intakes_Max_Fields = {
  __typename: 'intakes_max_fields';
  author_id?: Maybe<Scalars['String']['output']>;
  bhp0?: Maybe<Scalars['numeric']['output']>;
  bhp1?: Maybe<Scalars['numeric']['output']>;
  bhp2?: Maybe<Scalars['numeric']['output']>;
  bhp3?: Maybe<Scalars['numeric']['output']>;
  bhp4?: Maybe<Scalars['numeric']['output']>;
  bhp5?: Maybe<Scalars['numeric']['output']>;
  configuration?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  eff1?: Maybe<Scalars['numeric']['output']>;
  eff2?: Maybe<Scalars['numeric']['output']>;
  high_strength_shaft_limit_hp?: Maybe<Scalars['Int']['output']>;
  housing_material?: Maybe<Scalars['String']['output']>;
  hp?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  imported_sizing_id?: Maybe<Scalars['Int']['output']>;
  include_ecopetrol_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  include_koc_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  inner_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  intake_type?: Maybe<Scalars['String']['output']>;
  length_inches?: Maybe<Scalars['numeric']['output']>;
  manufacturer?: Maybe<Scalars['String']['output']>;
  max_rate_bpd?: Maybe<Scalars['Int']['output']>;
  neck_inner_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  neck_outer_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  only_ecopetrol_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  only_koc_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  outer_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  part_number?: Maybe<Scalars['String']['output']>;
  port_area_square_inches?: Maybe<Scalars['numeric']['output']>;
  /** A computed field, executes function "prioritizeintakemanufacturer" */
  prioritized_manufacturer?: Maybe<Scalars['String']['output']>;
  shaft_limit_hp?: Maybe<Scalars['Int']['output']>;
  shaft_material?: Maybe<Scalars['String']['output']>;
  stage_count?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  weight_pounds?: Maybe<Scalars['numeric']['output']>;
};

/** order by max() on columns of table "intakes" */
export type Intakes_Max_Order_By = {
  author_id?: InputMaybe<Order_By>;
  bhp0?: InputMaybe<Order_By>;
  bhp1?: InputMaybe<Order_By>;
  bhp2?: InputMaybe<Order_By>;
  bhp3?: InputMaybe<Order_By>;
  bhp4?: InputMaybe<Order_By>;
  bhp5?: InputMaybe<Order_By>;
  configuration?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  eff1?: InputMaybe<Order_By>;
  eff2?: InputMaybe<Order_By>;
  high_strength_shaft_limit_hp?: InputMaybe<Order_By>;
  housing_material?: InputMaybe<Order_By>;
  hp?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  include_ecopetrol_timestamp?: InputMaybe<Order_By>;
  include_koc_timestamp?: InputMaybe<Order_By>;
  inner_diameter_inches?: InputMaybe<Order_By>;
  intake_type?: InputMaybe<Order_By>;
  length_inches?: InputMaybe<Order_By>;
  manufacturer?: InputMaybe<Order_By>;
  max_rate_bpd?: InputMaybe<Order_By>;
  neck_inner_diameter_inches?: InputMaybe<Order_By>;
  neck_outer_diameter_inches?: InputMaybe<Order_By>;
  only_ecopetrol_timestamp?: InputMaybe<Order_By>;
  only_koc_timestamp?: InputMaybe<Order_By>;
  outer_diameter_inches?: InputMaybe<Order_By>;
  part_number?: InputMaybe<Order_By>;
  port_area_square_inches?: InputMaybe<Order_By>;
  shaft_limit_hp?: InputMaybe<Order_By>;
  shaft_material?: InputMaybe<Order_By>;
  stage_count?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  weight_pounds?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Intakes_Min_Fields = {
  __typename: 'intakes_min_fields';
  author_id?: Maybe<Scalars['String']['output']>;
  bhp0?: Maybe<Scalars['numeric']['output']>;
  bhp1?: Maybe<Scalars['numeric']['output']>;
  bhp2?: Maybe<Scalars['numeric']['output']>;
  bhp3?: Maybe<Scalars['numeric']['output']>;
  bhp4?: Maybe<Scalars['numeric']['output']>;
  bhp5?: Maybe<Scalars['numeric']['output']>;
  configuration?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  eff1?: Maybe<Scalars['numeric']['output']>;
  eff2?: Maybe<Scalars['numeric']['output']>;
  high_strength_shaft_limit_hp?: Maybe<Scalars['Int']['output']>;
  housing_material?: Maybe<Scalars['String']['output']>;
  hp?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  imported_sizing_id?: Maybe<Scalars['Int']['output']>;
  include_ecopetrol_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  include_koc_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  inner_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  intake_type?: Maybe<Scalars['String']['output']>;
  length_inches?: Maybe<Scalars['numeric']['output']>;
  manufacturer?: Maybe<Scalars['String']['output']>;
  max_rate_bpd?: Maybe<Scalars['Int']['output']>;
  neck_inner_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  neck_outer_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  only_ecopetrol_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  only_koc_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  outer_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  part_number?: Maybe<Scalars['String']['output']>;
  port_area_square_inches?: Maybe<Scalars['numeric']['output']>;
  /** A computed field, executes function "prioritizeintakemanufacturer" */
  prioritized_manufacturer?: Maybe<Scalars['String']['output']>;
  shaft_limit_hp?: Maybe<Scalars['Int']['output']>;
  shaft_material?: Maybe<Scalars['String']['output']>;
  stage_count?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  weight_pounds?: Maybe<Scalars['numeric']['output']>;
};

/** order by min() on columns of table "intakes" */
export type Intakes_Min_Order_By = {
  author_id?: InputMaybe<Order_By>;
  bhp0?: InputMaybe<Order_By>;
  bhp1?: InputMaybe<Order_By>;
  bhp2?: InputMaybe<Order_By>;
  bhp3?: InputMaybe<Order_By>;
  bhp4?: InputMaybe<Order_By>;
  bhp5?: InputMaybe<Order_By>;
  configuration?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  eff1?: InputMaybe<Order_By>;
  eff2?: InputMaybe<Order_By>;
  high_strength_shaft_limit_hp?: InputMaybe<Order_By>;
  housing_material?: InputMaybe<Order_By>;
  hp?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  include_ecopetrol_timestamp?: InputMaybe<Order_By>;
  include_koc_timestamp?: InputMaybe<Order_By>;
  inner_diameter_inches?: InputMaybe<Order_By>;
  intake_type?: InputMaybe<Order_By>;
  length_inches?: InputMaybe<Order_By>;
  manufacturer?: InputMaybe<Order_By>;
  max_rate_bpd?: InputMaybe<Order_By>;
  neck_inner_diameter_inches?: InputMaybe<Order_By>;
  neck_outer_diameter_inches?: InputMaybe<Order_By>;
  only_ecopetrol_timestamp?: InputMaybe<Order_By>;
  only_koc_timestamp?: InputMaybe<Order_By>;
  outer_diameter_inches?: InputMaybe<Order_By>;
  part_number?: InputMaybe<Order_By>;
  port_area_square_inches?: InputMaybe<Order_By>;
  shaft_limit_hp?: InputMaybe<Order_By>;
  shaft_material?: InputMaybe<Order_By>;
  stage_count?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  weight_pounds?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "intakes" */
export type Intakes_Mutation_Response = {
  __typename: 'intakes_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Intakes>;
};

/** input type for inserting object relation for remote table "intakes" */
export type Intakes_Obj_Rel_Insert_Input = {
  data: Intakes_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Intakes_On_Conflict>;
};

/** on_conflict condition type for table "intakes" */
export type Intakes_On_Conflict = {
  constraint: Intakes_Constraint;
  update_columns?: Array<Intakes_Update_Column>;
  where?: InputMaybe<Intakes_Bool_Exp>;
};

/** Ordering options when selecting data from "intakes". */
export type Intakes_Order_By = {
  author_id?: InputMaybe<Order_By>;
  bhp0?: InputMaybe<Order_By>;
  bhp1?: InputMaybe<Order_By>;
  bhp2?: InputMaybe<Order_By>;
  bhp3?: InputMaybe<Order_By>;
  bhp4?: InputMaybe<Order_By>;
  bhp5?: InputMaybe<Order_By>;
  bolt_on?: InputMaybe<Order_By>;
  configuration?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  eff1?: InputMaybe<Order_By>;
  eff2?: InputMaybe<Order_By>;
  high_strength_shaft_limit_hp?: InputMaybe<Order_By>;
  housing_material?: InputMaybe<Order_By>;
  hp?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  include_ecopetrol_timestamp?: InputMaybe<Order_By>;
  include_koc_timestamp?: InputMaybe<Order_By>;
  inner_diameter_inches?: InputMaybe<Order_By>;
  intake_type?: InputMaybe<Order_By>;
  is_hps?: InputMaybe<Order_By>;
  length_inches?: InputMaybe<Order_By>;
  manufacturer?: InputMaybe<Order_By>;
  max_rate_bpd?: InputMaybe<Order_By>;
  neck_inner_diameter_inches?: InputMaybe<Order_By>;
  neck_outer_diameter_inches?: InputMaybe<Order_By>;
  only_ecopetrol_timestamp?: InputMaybe<Order_By>;
  only_koc_timestamp?: InputMaybe<Order_By>;
  outer_diameter_inches?: InputMaybe<Order_By>;
  part_number?: InputMaybe<Order_By>;
  port_area_square_inches?: InputMaybe<Order_By>;
  prioritized_manufacturer?: InputMaybe<Order_By>;
  shaft_limit_hp?: InputMaybe<Order_By>;
  shaft_material?: InputMaybe<Order_By>;
  sizing_import?: InputMaybe<Sizing_Imports_Order_By>;
  stage_count?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  weight_pounds?: InputMaybe<Order_By>;
};

/** primary key columns input for table: intakes */
export type Intakes_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "intakes" */
export enum Intakes_Select_Column {
  /** column name */
  AuthorId = 'author_id',
  /** column name */
  Bhp0 = 'bhp0',
  /** column name */
  Bhp1 = 'bhp1',
  /** column name */
  Bhp2 = 'bhp2',
  /** column name */
  Bhp3 = 'bhp3',
  /** column name */
  Bhp4 = 'bhp4',
  /** column name */
  Bhp5 = 'bhp5',
  /** column name */
  BoltOn = 'bolt_on',
  /** column name */
  Configuration = 'configuration',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Eff1 = 'eff1',
  /** column name */
  Eff2 = 'eff2',
  /** column name */
  HighStrengthShaftLimitHp = 'high_strength_shaft_limit_hp',
  /** column name */
  HousingMaterial = 'housing_material',
  /** column name */
  Hp = 'hp',
  /** column name */
  Id = 'id',
  /** column name */
  ImportedSizingId = 'imported_sizing_id',
  /** column name */
  IncludeEcopetrolTimestamp = 'include_ecopetrol_timestamp',
  /** column name */
  IncludeKocTimestamp = 'include_koc_timestamp',
  /** column name */
  InnerDiameterInches = 'inner_diameter_inches',
  /** column name */
  IntakeType = 'intake_type',
  /** column name */
  IsHps = 'is_hps',
  /** column name */
  LengthInches = 'length_inches',
  /** column name */
  Manufacturer = 'manufacturer',
  /** column name */
  MaxRateBpd = 'max_rate_bpd',
  /** column name */
  NeckInnerDiameterInches = 'neck_inner_diameter_inches',
  /** column name */
  NeckOuterDiameterInches = 'neck_outer_diameter_inches',
  /** column name */
  OnlyEcopetrolTimestamp = 'only_ecopetrol_timestamp',
  /** column name */
  OnlyKocTimestamp = 'only_koc_timestamp',
  /** column name */
  OuterDiameterInches = 'outer_diameter_inches',
  /** column name */
  PartNumber = 'part_number',
  /** column name */
  PortAreaSquareInches = 'port_area_square_inches',
  /** column name */
  ShaftLimitHp = 'shaft_limit_hp',
  /** column name */
  ShaftMaterial = 'shaft_material',
  /** column name */
  StageCount = 'stage_count',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WeightPounds = 'weight_pounds'
}

/** select "intakes_aggregate_bool_exp_bool_and_arguments_columns" columns of table "intakes" */
export enum Intakes_Select_Column_Intakes_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  BoltOn = 'bolt_on',
  /** column name */
  IsHps = 'is_hps'
}

/** select "intakes_aggregate_bool_exp_bool_or_arguments_columns" columns of table "intakes" */
export enum Intakes_Select_Column_Intakes_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  BoltOn = 'bolt_on',
  /** column name */
  IsHps = 'is_hps'
}

/** input type for updating data in table "intakes" */
export type Intakes_Set_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  bhp0?: InputMaybe<Scalars['numeric']['input']>;
  bhp1?: InputMaybe<Scalars['numeric']['input']>;
  bhp2?: InputMaybe<Scalars['numeric']['input']>;
  bhp3?: InputMaybe<Scalars['numeric']['input']>;
  bhp4?: InputMaybe<Scalars['numeric']['input']>;
  bhp5?: InputMaybe<Scalars['numeric']['input']>;
  bolt_on?: InputMaybe<Scalars['Boolean']['input']>;
  configuration?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  eff1?: InputMaybe<Scalars['numeric']['input']>;
  eff2?: InputMaybe<Scalars['numeric']['input']>;
  high_strength_shaft_limit_hp?: InputMaybe<Scalars['Int']['input']>;
  housing_material?: InputMaybe<Scalars['String']['input']>;
  hp?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  imported_sizing_id?: InputMaybe<Scalars['Int']['input']>;
  include_ecopetrol_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  include_koc_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  inner_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  intake_type?: InputMaybe<Scalars['String']['input']>;
  is_hps?: InputMaybe<Scalars['Boolean']['input']>;
  length_inches?: InputMaybe<Scalars['numeric']['input']>;
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  max_rate_bpd?: InputMaybe<Scalars['Int']['input']>;
  neck_inner_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  neck_outer_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  only_ecopetrol_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  only_koc_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  outer_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  part_number?: InputMaybe<Scalars['String']['input']>;
  port_area_square_inches?: InputMaybe<Scalars['numeric']['input']>;
  shaft_limit_hp?: InputMaybe<Scalars['Int']['input']>;
  shaft_material?: InputMaybe<Scalars['String']['input']>;
  stage_count?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  weight_pounds?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate stddev on columns */
export type Intakes_Stddev_Fields = {
  __typename: 'intakes_stddev_fields';
  bhp0?: Maybe<Scalars['Float']['output']>;
  bhp1?: Maybe<Scalars['Float']['output']>;
  bhp2?: Maybe<Scalars['Float']['output']>;
  bhp3?: Maybe<Scalars['Float']['output']>;
  bhp4?: Maybe<Scalars['Float']['output']>;
  bhp5?: Maybe<Scalars['Float']['output']>;
  eff1?: Maybe<Scalars['Float']['output']>;
  eff2?: Maybe<Scalars['Float']['output']>;
  high_strength_shaft_limit_hp?: Maybe<Scalars['Float']['output']>;
  hp?: Maybe<Scalars['Float']['output']>;
  imported_sizing_id?: Maybe<Scalars['Float']['output']>;
  inner_diameter_inches?: Maybe<Scalars['Float']['output']>;
  length_inches?: Maybe<Scalars['Float']['output']>;
  max_rate_bpd?: Maybe<Scalars['Float']['output']>;
  neck_inner_diameter_inches?: Maybe<Scalars['Float']['output']>;
  neck_outer_diameter_inches?: Maybe<Scalars['Float']['output']>;
  outer_diameter_inches?: Maybe<Scalars['Float']['output']>;
  port_area_square_inches?: Maybe<Scalars['Float']['output']>;
  shaft_limit_hp?: Maybe<Scalars['Float']['output']>;
  stage_count?: Maybe<Scalars['Float']['output']>;
  weight_pounds?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "intakes" */
export type Intakes_Stddev_Order_By = {
  bhp0?: InputMaybe<Order_By>;
  bhp1?: InputMaybe<Order_By>;
  bhp2?: InputMaybe<Order_By>;
  bhp3?: InputMaybe<Order_By>;
  bhp4?: InputMaybe<Order_By>;
  bhp5?: InputMaybe<Order_By>;
  eff1?: InputMaybe<Order_By>;
  eff2?: InputMaybe<Order_By>;
  high_strength_shaft_limit_hp?: InputMaybe<Order_By>;
  hp?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  inner_diameter_inches?: InputMaybe<Order_By>;
  length_inches?: InputMaybe<Order_By>;
  max_rate_bpd?: InputMaybe<Order_By>;
  neck_inner_diameter_inches?: InputMaybe<Order_By>;
  neck_outer_diameter_inches?: InputMaybe<Order_By>;
  outer_diameter_inches?: InputMaybe<Order_By>;
  port_area_square_inches?: InputMaybe<Order_By>;
  shaft_limit_hp?: InputMaybe<Order_By>;
  stage_count?: InputMaybe<Order_By>;
  weight_pounds?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Intakes_Stddev_Pop_Fields = {
  __typename: 'intakes_stddev_pop_fields';
  bhp0?: Maybe<Scalars['Float']['output']>;
  bhp1?: Maybe<Scalars['Float']['output']>;
  bhp2?: Maybe<Scalars['Float']['output']>;
  bhp3?: Maybe<Scalars['Float']['output']>;
  bhp4?: Maybe<Scalars['Float']['output']>;
  bhp5?: Maybe<Scalars['Float']['output']>;
  eff1?: Maybe<Scalars['Float']['output']>;
  eff2?: Maybe<Scalars['Float']['output']>;
  high_strength_shaft_limit_hp?: Maybe<Scalars['Float']['output']>;
  hp?: Maybe<Scalars['Float']['output']>;
  imported_sizing_id?: Maybe<Scalars['Float']['output']>;
  inner_diameter_inches?: Maybe<Scalars['Float']['output']>;
  length_inches?: Maybe<Scalars['Float']['output']>;
  max_rate_bpd?: Maybe<Scalars['Float']['output']>;
  neck_inner_diameter_inches?: Maybe<Scalars['Float']['output']>;
  neck_outer_diameter_inches?: Maybe<Scalars['Float']['output']>;
  outer_diameter_inches?: Maybe<Scalars['Float']['output']>;
  port_area_square_inches?: Maybe<Scalars['Float']['output']>;
  shaft_limit_hp?: Maybe<Scalars['Float']['output']>;
  stage_count?: Maybe<Scalars['Float']['output']>;
  weight_pounds?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "intakes" */
export type Intakes_Stddev_Pop_Order_By = {
  bhp0?: InputMaybe<Order_By>;
  bhp1?: InputMaybe<Order_By>;
  bhp2?: InputMaybe<Order_By>;
  bhp3?: InputMaybe<Order_By>;
  bhp4?: InputMaybe<Order_By>;
  bhp5?: InputMaybe<Order_By>;
  eff1?: InputMaybe<Order_By>;
  eff2?: InputMaybe<Order_By>;
  high_strength_shaft_limit_hp?: InputMaybe<Order_By>;
  hp?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  inner_diameter_inches?: InputMaybe<Order_By>;
  length_inches?: InputMaybe<Order_By>;
  max_rate_bpd?: InputMaybe<Order_By>;
  neck_inner_diameter_inches?: InputMaybe<Order_By>;
  neck_outer_diameter_inches?: InputMaybe<Order_By>;
  outer_diameter_inches?: InputMaybe<Order_By>;
  port_area_square_inches?: InputMaybe<Order_By>;
  shaft_limit_hp?: InputMaybe<Order_By>;
  stage_count?: InputMaybe<Order_By>;
  weight_pounds?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Intakes_Stddev_Samp_Fields = {
  __typename: 'intakes_stddev_samp_fields';
  bhp0?: Maybe<Scalars['Float']['output']>;
  bhp1?: Maybe<Scalars['Float']['output']>;
  bhp2?: Maybe<Scalars['Float']['output']>;
  bhp3?: Maybe<Scalars['Float']['output']>;
  bhp4?: Maybe<Scalars['Float']['output']>;
  bhp5?: Maybe<Scalars['Float']['output']>;
  eff1?: Maybe<Scalars['Float']['output']>;
  eff2?: Maybe<Scalars['Float']['output']>;
  high_strength_shaft_limit_hp?: Maybe<Scalars['Float']['output']>;
  hp?: Maybe<Scalars['Float']['output']>;
  imported_sizing_id?: Maybe<Scalars['Float']['output']>;
  inner_diameter_inches?: Maybe<Scalars['Float']['output']>;
  length_inches?: Maybe<Scalars['Float']['output']>;
  max_rate_bpd?: Maybe<Scalars['Float']['output']>;
  neck_inner_diameter_inches?: Maybe<Scalars['Float']['output']>;
  neck_outer_diameter_inches?: Maybe<Scalars['Float']['output']>;
  outer_diameter_inches?: Maybe<Scalars['Float']['output']>;
  port_area_square_inches?: Maybe<Scalars['Float']['output']>;
  shaft_limit_hp?: Maybe<Scalars['Float']['output']>;
  stage_count?: Maybe<Scalars['Float']['output']>;
  weight_pounds?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "intakes" */
export type Intakes_Stddev_Samp_Order_By = {
  bhp0?: InputMaybe<Order_By>;
  bhp1?: InputMaybe<Order_By>;
  bhp2?: InputMaybe<Order_By>;
  bhp3?: InputMaybe<Order_By>;
  bhp4?: InputMaybe<Order_By>;
  bhp5?: InputMaybe<Order_By>;
  eff1?: InputMaybe<Order_By>;
  eff2?: InputMaybe<Order_By>;
  high_strength_shaft_limit_hp?: InputMaybe<Order_By>;
  hp?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  inner_diameter_inches?: InputMaybe<Order_By>;
  length_inches?: InputMaybe<Order_By>;
  max_rate_bpd?: InputMaybe<Order_By>;
  neck_inner_diameter_inches?: InputMaybe<Order_By>;
  neck_outer_diameter_inches?: InputMaybe<Order_By>;
  outer_diameter_inches?: InputMaybe<Order_By>;
  port_area_square_inches?: InputMaybe<Order_By>;
  shaft_limit_hp?: InputMaybe<Order_By>;
  stage_count?: InputMaybe<Order_By>;
  weight_pounds?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "intakes" */
export type Intakes_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Intakes_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Intakes_Stream_Cursor_Value_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  bhp0?: InputMaybe<Scalars['numeric']['input']>;
  bhp1?: InputMaybe<Scalars['numeric']['input']>;
  bhp2?: InputMaybe<Scalars['numeric']['input']>;
  bhp3?: InputMaybe<Scalars['numeric']['input']>;
  bhp4?: InputMaybe<Scalars['numeric']['input']>;
  bhp5?: InputMaybe<Scalars['numeric']['input']>;
  bolt_on?: InputMaybe<Scalars['Boolean']['input']>;
  configuration?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  eff1?: InputMaybe<Scalars['numeric']['input']>;
  eff2?: InputMaybe<Scalars['numeric']['input']>;
  high_strength_shaft_limit_hp?: InputMaybe<Scalars['Int']['input']>;
  housing_material?: InputMaybe<Scalars['String']['input']>;
  hp?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  imported_sizing_id?: InputMaybe<Scalars['Int']['input']>;
  include_ecopetrol_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  include_koc_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  inner_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  intake_type?: InputMaybe<Scalars['String']['input']>;
  is_hps?: InputMaybe<Scalars['Boolean']['input']>;
  length_inches?: InputMaybe<Scalars['numeric']['input']>;
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  max_rate_bpd?: InputMaybe<Scalars['Int']['input']>;
  neck_inner_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  neck_outer_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  only_ecopetrol_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  only_koc_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  outer_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  part_number?: InputMaybe<Scalars['String']['input']>;
  port_area_square_inches?: InputMaybe<Scalars['numeric']['input']>;
  shaft_limit_hp?: InputMaybe<Scalars['Int']['input']>;
  shaft_material?: InputMaybe<Scalars['String']['input']>;
  stage_count?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  weight_pounds?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate sum on columns */
export type Intakes_Sum_Fields = {
  __typename: 'intakes_sum_fields';
  bhp0?: Maybe<Scalars['numeric']['output']>;
  bhp1?: Maybe<Scalars['numeric']['output']>;
  bhp2?: Maybe<Scalars['numeric']['output']>;
  bhp3?: Maybe<Scalars['numeric']['output']>;
  bhp4?: Maybe<Scalars['numeric']['output']>;
  bhp5?: Maybe<Scalars['numeric']['output']>;
  eff1?: Maybe<Scalars['numeric']['output']>;
  eff2?: Maybe<Scalars['numeric']['output']>;
  high_strength_shaft_limit_hp?: Maybe<Scalars['Int']['output']>;
  hp?: Maybe<Scalars['numeric']['output']>;
  imported_sizing_id?: Maybe<Scalars['Int']['output']>;
  inner_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  length_inches?: Maybe<Scalars['numeric']['output']>;
  max_rate_bpd?: Maybe<Scalars['Int']['output']>;
  neck_inner_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  neck_outer_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  outer_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  port_area_square_inches?: Maybe<Scalars['numeric']['output']>;
  shaft_limit_hp?: Maybe<Scalars['Int']['output']>;
  stage_count?: Maybe<Scalars['Int']['output']>;
  weight_pounds?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "intakes" */
export type Intakes_Sum_Order_By = {
  bhp0?: InputMaybe<Order_By>;
  bhp1?: InputMaybe<Order_By>;
  bhp2?: InputMaybe<Order_By>;
  bhp3?: InputMaybe<Order_By>;
  bhp4?: InputMaybe<Order_By>;
  bhp5?: InputMaybe<Order_By>;
  eff1?: InputMaybe<Order_By>;
  eff2?: InputMaybe<Order_By>;
  high_strength_shaft_limit_hp?: InputMaybe<Order_By>;
  hp?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  inner_diameter_inches?: InputMaybe<Order_By>;
  length_inches?: InputMaybe<Order_By>;
  max_rate_bpd?: InputMaybe<Order_By>;
  neck_inner_diameter_inches?: InputMaybe<Order_By>;
  neck_outer_diameter_inches?: InputMaybe<Order_By>;
  outer_diameter_inches?: InputMaybe<Order_By>;
  port_area_square_inches?: InputMaybe<Order_By>;
  shaft_limit_hp?: InputMaybe<Order_By>;
  stage_count?: InputMaybe<Order_By>;
  weight_pounds?: InputMaybe<Order_By>;
};

/** update columns of table "intakes" */
export enum Intakes_Update_Column {
  /** column name */
  AuthorId = 'author_id',
  /** column name */
  Bhp0 = 'bhp0',
  /** column name */
  Bhp1 = 'bhp1',
  /** column name */
  Bhp2 = 'bhp2',
  /** column name */
  Bhp3 = 'bhp3',
  /** column name */
  Bhp4 = 'bhp4',
  /** column name */
  Bhp5 = 'bhp5',
  /** column name */
  BoltOn = 'bolt_on',
  /** column name */
  Configuration = 'configuration',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Eff1 = 'eff1',
  /** column name */
  Eff2 = 'eff2',
  /** column name */
  HighStrengthShaftLimitHp = 'high_strength_shaft_limit_hp',
  /** column name */
  HousingMaterial = 'housing_material',
  /** column name */
  Hp = 'hp',
  /** column name */
  Id = 'id',
  /** column name */
  ImportedSizingId = 'imported_sizing_id',
  /** column name */
  IncludeEcopetrolTimestamp = 'include_ecopetrol_timestamp',
  /** column name */
  IncludeKocTimestamp = 'include_koc_timestamp',
  /** column name */
  InnerDiameterInches = 'inner_diameter_inches',
  /** column name */
  IntakeType = 'intake_type',
  /** column name */
  IsHps = 'is_hps',
  /** column name */
  LengthInches = 'length_inches',
  /** column name */
  Manufacturer = 'manufacturer',
  /** column name */
  MaxRateBpd = 'max_rate_bpd',
  /** column name */
  NeckInnerDiameterInches = 'neck_inner_diameter_inches',
  /** column name */
  NeckOuterDiameterInches = 'neck_outer_diameter_inches',
  /** column name */
  OnlyEcopetrolTimestamp = 'only_ecopetrol_timestamp',
  /** column name */
  OnlyKocTimestamp = 'only_koc_timestamp',
  /** column name */
  OuterDiameterInches = 'outer_diameter_inches',
  /** column name */
  PartNumber = 'part_number',
  /** column name */
  PortAreaSquareInches = 'port_area_square_inches',
  /** column name */
  ShaftLimitHp = 'shaft_limit_hp',
  /** column name */
  ShaftMaterial = 'shaft_material',
  /** column name */
  StageCount = 'stage_count',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WeightPounds = 'weight_pounds'
}

export type Intakes_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Intakes_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Intakes_Set_Input>;
  /** filter the rows which have to be updated */
  where: Intakes_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Intakes_Var_Pop_Fields = {
  __typename: 'intakes_var_pop_fields';
  bhp0?: Maybe<Scalars['Float']['output']>;
  bhp1?: Maybe<Scalars['Float']['output']>;
  bhp2?: Maybe<Scalars['Float']['output']>;
  bhp3?: Maybe<Scalars['Float']['output']>;
  bhp4?: Maybe<Scalars['Float']['output']>;
  bhp5?: Maybe<Scalars['Float']['output']>;
  eff1?: Maybe<Scalars['Float']['output']>;
  eff2?: Maybe<Scalars['Float']['output']>;
  high_strength_shaft_limit_hp?: Maybe<Scalars['Float']['output']>;
  hp?: Maybe<Scalars['Float']['output']>;
  imported_sizing_id?: Maybe<Scalars['Float']['output']>;
  inner_diameter_inches?: Maybe<Scalars['Float']['output']>;
  length_inches?: Maybe<Scalars['Float']['output']>;
  max_rate_bpd?: Maybe<Scalars['Float']['output']>;
  neck_inner_diameter_inches?: Maybe<Scalars['Float']['output']>;
  neck_outer_diameter_inches?: Maybe<Scalars['Float']['output']>;
  outer_diameter_inches?: Maybe<Scalars['Float']['output']>;
  port_area_square_inches?: Maybe<Scalars['Float']['output']>;
  shaft_limit_hp?: Maybe<Scalars['Float']['output']>;
  stage_count?: Maybe<Scalars['Float']['output']>;
  weight_pounds?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "intakes" */
export type Intakes_Var_Pop_Order_By = {
  bhp0?: InputMaybe<Order_By>;
  bhp1?: InputMaybe<Order_By>;
  bhp2?: InputMaybe<Order_By>;
  bhp3?: InputMaybe<Order_By>;
  bhp4?: InputMaybe<Order_By>;
  bhp5?: InputMaybe<Order_By>;
  eff1?: InputMaybe<Order_By>;
  eff2?: InputMaybe<Order_By>;
  high_strength_shaft_limit_hp?: InputMaybe<Order_By>;
  hp?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  inner_diameter_inches?: InputMaybe<Order_By>;
  length_inches?: InputMaybe<Order_By>;
  max_rate_bpd?: InputMaybe<Order_By>;
  neck_inner_diameter_inches?: InputMaybe<Order_By>;
  neck_outer_diameter_inches?: InputMaybe<Order_By>;
  outer_diameter_inches?: InputMaybe<Order_By>;
  port_area_square_inches?: InputMaybe<Order_By>;
  shaft_limit_hp?: InputMaybe<Order_By>;
  stage_count?: InputMaybe<Order_By>;
  weight_pounds?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Intakes_Var_Samp_Fields = {
  __typename: 'intakes_var_samp_fields';
  bhp0?: Maybe<Scalars['Float']['output']>;
  bhp1?: Maybe<Scalars['Float']['output']>;
  bhp2?: Maybe<Scalars['Float']['output']>;
  bhp3?: Maybe<Scalars['Float']['output']>;
  bhp4?: Maybe<Scalars['Float']['output']>;
  bhp5?: Maybe<Scalars['Float']['output']>;
  eff1?: Maybe<Scalars['Float']['output']>;
  eff2?: Maybe<Scalars['Float']['output']>;
  high_strength_shaft_limit_hp?: Maybe<Scalars['Float']['output']>;
  hp?: Maybe<Scalars['Float']['output']>;
  imported_sizing_id?: Maybe<Scalars['Float']['output']>;
  inner_diameter_inches?: Maybe<Scalars['Float']['output']>;
  length_inches?: Maybe<Scalars['Float']['output']>;
  max_rate_bpd?: Maybe<Scalars['Float']['output']>;
  neck_inner_diameter_inches?: Maybe<Scalars['Float']['output']>;
  neck_outer_diameter_inches?: Maybe<Scalars['Float']['output']>;
  outer_diameter_inches?: Maybe<Scalars['Float']['output']>;
  port_area_square_inches?: Maybe<Scalars['Float']['output']>;
  shaft_limit_hp?: Maybe<Scalars['Float']['output']>;
  stage_count?: Maybe<Scalars['Float']['output']>;
  weight_pounds?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "intakes" */
export type Intakes_Var_Samp_Order_By = {
  bhp0?: InputMaybe<Order_By>;
  bhp1?: InputMaybe<Order_By>;
  bhp2?: InputMaybe<Order_By>;
  bhp3?: InputMaybe<Order_By>;
  bhp4?: InputMaybe<Order_By>;
  bhp5?: InputMaybe<Order_By>;
  eff1?: InputMaybe<Order_By>;
  eff2?: InputMaybe<Order_By>;
  high_strength_shaft_limit_hp?: InputMaybe<Order_By>;
  hp?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  inner_diameter_inches?: InputMaybe<Order_By>;
  length_inches?: InputMaybe<Order_By>;
  max_rate_bpd?: InputMaybe<Order_By>;
  neck_inner_diameter_inches?: InputMaybe<Order_By>;
  neck_outer_diameter_inches?: InputMaybe<Order_By>;
  outer_diameter_inches?: InputMaybe<Order_By>;
  port_area_square_inches?: InputMaybe<Order_By>;
  shaft_limit_hp?: InputMaybe<Order_By>;
  stage_count?: InputMaybe<Order_By>;
  weight_pounds?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Intakes_Variance_Fields = {
  __typename: 'intakes_variance_fields';
  bhp0?: Maybe<Scalars['Float']['output']>;
  bhp1?: Maybe<Scalars['Float']['output']>;
  bhp2?: Maybe<Scalars['Float']['output']>;
  bhp3?: Maybe<Scalars['Float']['output']>;
  bhp4?: Maybe<Scalars['Float']['output']>;
  bhp5?: Maybe<Scalars['Float']['output']>;
  eff1?: Maybe<Scalars['Float']['output']>;
  eff2?: Maybe<Scalars['Float']['output']>;
  high_strength_shaft_limit_hp?: Maybe<Scalars['Float']['output']>;
  hp?: Maybe<Scalars['Float']['output']>;
  imported_sizing_id?: Maybe<Scalars['Float']['output']>;
  inner_diameter_inches?: Maybe<Scalars['Float']['output']>;
  length_inches?: Maybe<Scalars['Float']['output']>;
  max_rate_bpd?: Maybe<Scalars['Float']['output']>;
  neck_inner_diameter_inches?: Maybe<Scalars['Float']['output']>;
  neck_outer_diameter_inches?: Maybe<Scalars['Float']['output']>;
  outer_diameter_inches?: Maybe<Scalars['Float']['output']>;
  port_area_square_inches?: Maybe<Scalars['Float']['output']>;
  shaft_limit_hp?: Maybe<Scalars['Float']['output']>;
  stage_count?: Maybe<Scalars['Float']['output']>;
  weight_pounds?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "intakes" */
export type Intakes_Variance_Order_By = {
  bhp0?: InputMaybe<Order_By>;
  bhp1?: InputMaybe<Order_By>;
  bhp2?: InputMaybe<Order_By>;
  bhp3?: InputMaybe<Order_By>;
  bhp4?: InputMaybe<Order_By>;
  bhp5?: InputMaybe<Order_By>;
  eff1?: InputMaybe<Order_By>;
  eff2?: InputMaybe<Order_By>;
  high_strength_shaft_limit_hp?: InputMaybe<Order_By>;
  hp?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  inner_diameter_inches?: InputMaybe<Order_By>;
  length_inches?: InputMaybe<Order_By>;
  max_rate_bpd?: InputMaybe<Order_By>;
  neck_inner_diameter_inches?: InputMaybe<Order_By>;
  neck_outer_diameter_inches?: InputMaybe<Order_By>;
  outer_diameter_inches?: InputMaybe<Order_By>;
  port_area_square_inches?: InputMaybe<Order_By>;
  shaft_limit_hp?: InputMaybe<Order_By>;
  stage_count?: InputMaybe<Order_By>;
  weight_pounds?: InputMaybe<Order_By>;
};

export type Jsonb_Cast_Exp = {
  String?: InputMaybe<String_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "jsonb". All fields are combined with logical 'AND'. */
export type Jsonb_Comparison_Exp = {
  _cast?: InputMaybe<Jsonb_Cast_Exp>;
  /** is the column contained in the given json value */
  _contained_in?: InputMaybe<Scalars['jsonb']['input']>;
  /** does the column contain the given json value at the top level */
  _contains?: InputMaybe<Scalars['jsonb']['input']>;
  _eq?: InputMaybe<Scalars['jsonb']['input']>;
  _gt?: InputMaybe<Scalars['jsonb']['input']>;
  _gte?: InputMaybe<Scalars['jsonb']['input']>;
  /** does the string exist as a top-level key in the column */
  _has_key?: InputMaybe<Scalars['String']['input']>;
  /** do all of these strings exist as top-level keys in the column */
  _has_keys_all?: InputMaybe<Array<Scalars['String']['input']>>;
  /** do any of these strings exist as top-level keys in the column */
  _has_keys_any?: InputMaybe<Array<Scalars['String']['input']>>;
  _in?: InputMaybe<Array<Scalars['jsonb']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['jsonb']['input']>;
  _lte?: InputMaybe<Scalars['jsonb']['input']>;
  _neq?: InputMaybe<Scalars['jsonb']['input']>;
  _nin?: InputMaybe<Array<Scalars['jsonb']['input']>>;
};

/** columns and relationships of "legacy_users" */
export type Legacy_Users = {
  __typename: 'legacy_users';
  display_name?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  hal_identifier: Scalars['String']['output'];
  /** An array relationship */
  sizing_imports: Array<Sizing_Imports>;
  /** An aggregate relationship */
  sizing_imports_aggregate: Sizing_Imports_Aggregate;
};


/** columns and relationships of "legacy_users" */
export type Legacy_UsersSizing_ImportsArgs = {
  distinct_on?: InputMaybe<Array<Sizing_Imports_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sizing_Imports_Order_By>>;
  where?: InputMaybe<Sizing_Imports_Bool_Exp>;
};


/** columns and relationships of "legacy_users" */
export type Legacy_UsersSizing_Imports_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sizing_Imports_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sizing_Imports_Order_By>>;
  where?: InputMaybe<Sizing_Imports_Bool_Exp>;
};

/** aggregated selection of "legacy_users" */
export type Legacy_Users_Aggregate = {
  __typename: 'legacy_users_aggregate';
  aggregate?: Maybe<Legacy_Users_Aggregate_Fields>;
  nodes: Array<Legacy_Users>;
};

/** aggregate fields of "legacy_users" */
export type Legacy_Users_Aggregate_Fields = {
  __typename: 'legacy_users_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Legacy_Users_Max_Fields>;
  min?: Maybe<Legacy_Users_Min_Fields>;
};


/** aggregate fields of "legacy_users" */
export type Legacy_Users_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Legacy_Users_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "legacy_users". All fields are combined with a logical 'AND'. */
export type Legacy_Users_Bool_Exp = {
  _and?: InputMaybe<Array<Legacy_Users_Bool_Exp>>;
  _not?: InputMaybe<Legacy_Users_Bool_Exp>;
  _or?: InputMaybe<Array<Legacy_Users_Bool_Exp>>;
  display_name?: InputMaybe<String_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  hal_identifier?: InputMaybe<String_Comparison_Exp>;
  sizing_imports?: InputMaybe<Sizing_Imports_Bool_Exp>;
  sizing_imports_aggregate?: InputMaybe<Sizing_Imports_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "legacy_users" */
export enum Legacy_Users_Constraint {
  /** unique or primary key constraint on columns "hal_identifier" */
  LegacyUsersPkey = 'legacy_users_pkey'
}

/** input type for inserting data into table "legacy_users" */
export type Legacy_Users_Insert_Input = {
  display_name?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  hal_identifier?: InputMaybe<Scalars['String']['input']>;
  sizing_imports?: InputMaybe<Sizing_Imports_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Legacy_Users_Max_Fields = {
  __typename: 'legacy_users_max_fields';
  display_name?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  hal_identifier?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Legacy_Users_Min_Fields = {
  __typename: 'legacy_users_min_fields';
  display_name?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  hal_identifier?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "legacy_users" */
export type Legacy_Users_Mutation_Response = {
  __typename: 'legacy_users_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Legacy_Users>;
};

/** input type for inserting object relation for remote table "legacy_users" */
export type Legacy_Users_Obj_Rel_Insert_Input = {
  data: Legacy_Users_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Legacy_Users_On_Conflict>;
};

/** on_conflict condition type for table "legacy_users" */
export type Legacy_Users_On_Conflict = {
  constraint: Legacy_Users_Constraint;
  update_columns?: Array<Legacy_Users_Update_Column>;
  where?: InputMaybe<Legacy_Users_Bool_Exp>;
};

/** Ordering options when selecting data from "legacy_users". */
export type Legacy_Users_Order_By = {
  display_name?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  hal_identifier?: InputMaybe<Order_By>;
  sizing_imports_aggregate?: InputMaybe<Sizing_Imports_Aggregate_Order_By>;
};

/** primary key columns input for table: legacy_users */
export type Legacy_Users_Pk_Columns_Input = {
  hal_identifier: Scalars['String']['input'];
};

/** select columns of table "legacy_users" */
export enum Legacy_Users_Select_Column {
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  Email = 'email',
  /** column name */
  HalIdentifier = 'hal_identifier'
}

/** input type for updating data in table "legacy_users" */
export type Legacy_Users_Set_Input = {
  display_name?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  hal_identifier?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "legacy_users" */
export type Legacy_Users_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Legacy_Users_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Legacy_Users_Stream_Cursor_Value_Input = {
  display_name?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  hal_identifier?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "legacy_users" */
export enum Legacy_Users_Update_Column {
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  Email = 'email',
  /** column name */
  HalIdentifier = 'hal_identifier'
}

export type Legacy_Users_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Legacy_Users_Set_Input>;
  /** filter the rows which have to be updated */
  where: Legacy_Users_Bool_Exp;
};

/** columns and relationships of "motor_lead_extensions" */
export type Motor_Lead_Extensions = {
  __typename: 'motor_lead_extensions';
  amp_factor?: Maybe<Scalars['numeric']['output']>;
  author_id: Scalars['String']['output'];
  created_at: Scalars['timestamptz']['output'];
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  depth_inches?: Maybe<Scalars['numeric']['output']>;
  family?: Maybe<Scalars['String']['output']>;
  gauge?: Maybe<Scalars['Int']['output']>;
  id: Scalars['uuid']['output'];
  impedance_60_hz_per_1000_ft?: Maybe<Scalars['numeric']['output']>;
  imported_sizing_id?: Maybe<Scalars['Int']['output']>;
  include_ecopetrol_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  include_koc_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  kv?: Maybe<Scalars['Int']['output']>;
  length_feet?: Maybe<Scalars['numeric']['output']>;
  manufacturer?: Maybe<Scalars['String']['output']>;
  max_pothead_temperature_fahrenheit?: Maybe<Scalars['Int']['output']>;
  max_temperature_fahrenheit?: Maybe<Scalars['Int']['output']>;
  only_ecopetrol_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  only_koc_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  part_number?: Maybe<Scalars['String']['output']>;
  pound_per_foot?: Maybe<Scalars['numeric']['output']>;
  /** A computed field, executes function "prioritizemlemanufacturer" */
  prioritized_manufacturer?: Maybe<Scalars['String']['output']>;
  resistance_per_1000_ft?: Maybe<Scalars['numeric']['output']>;
  series?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  sizing_import?: Maybe<Sizing_Imports>;
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Users;
  width_inches?: Maybe<Scalars['numeric']['output']>;
};

/** aggregated selection of "motor_lead_extensions" */
export type Motor_Lead_Extensions_Aggregate = {
  __typename: 'motor_lead_extensions_aggregate';
  aggregate?: Maybe<Motor_Lead_Extensions_Aggregate_Fields>;
  nodes: Array<Motor_Lead_Extensions>;
};

export type Motor_Lead_Extensions_Aggregate_Bool_Exp = {
  count?: InputMaybe<Motor_Lead_Extensions_Aggregate_Bool_Exp_Count>;
};

export type Motor_Lead_Extensions_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Motor_Lead_Extensions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Motor_Lead_Extensions_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "motor_lead_extensions" */
export type Motor_Lead_Extensions_Aggregate_Fields = {
  __typename: 'motor_lead_extensions_aggregate_fields';
  avg?: Maybe<Motor_Lead_Extensions_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Motor_Lead_Extensions_Max_Fields>;
  min?: Maybe<Motor_Lead_Extensions_Min_Fields>;
  stddev?: Maybe<Motor_Lead_Extensions_Stddev_Fields>;
  stddev_pop?: Maybe<Motor_Lead_Extensions_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Motor_Lead_Extensions_Stddev_Samp_Fields>;
  sum?: Maybe<Motor_Lead_Extensions_Sum_Fields>;
  var_pop?: Maybe<Motor_Lead_Extensions_Var_Pop_Fields>;
  var_samp?: Maybe<Motor_Lead_Extensions_Var_Samp_Fields>;
  variance?: Maybe<Motor_Lead_Extensions_Variance_Fields>;
};


/** aggregate fields of "motor_lead_extensions" */
export type Motor_Lead_Extensions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Motor_Lead_Extensions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "motor_lead_extensions" */
export type Motor_Lead_Extensions_Aggregate_Order_By = {
  avg?: InputMaybe<Motor_Lead_Extensions_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Motor_Lead_Extensions_Max_Order_By>;
  min?: InputMaybe<Motor_Lead_Extensions_Min_Order_By>;
  stddev?: InputMaybe<Motor_Lead_Extensions_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Motor_Lead_Extensions_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Motor_Lead_Extensions_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Motor_Lead_Extensions_Sum_Order_By>;
  var_pop?: InputMaybe<Motor_Lead_Extensions_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Motor_Lead_Extensions_Var_Samp_Order_By>;
  variance?: InputMaybe<Motor_Lead_Extensions_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "motor_lead_extensions" */
export type Motor_Lead_Extensions_Arr_Rel_Insert_Input = {
  data: Array<Motor_Lead_Extensions_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Motor_Lead_Extensions_On_Conflict>;
};

/** aggregate avg on columns */
export type Motor_Lead_Extensions_Avg_Fields = {
  __typename: 'motor_lead_extensions_avg_fields';
  amp_factor?: Maybe<Scalars['Float']['output']>;
  depth_inches?: Maybe<Scalars['Float']['output']>;
  gauge?: Maybe<Scalars['Float']['output']>;
  impedance_60_hz_per_1000_ft?: Maybe<Scalars['Float']['output']>;
  imported_sizing_id?: Maybe<Scalars['Float']['output']>;
  kv?: Maybe<Scalars['Float']['output']>;
  length_feet?: Maybe<Scalars['Float']['output']>;
  max_pothead_temperature_fahrenheit?: Maybe<Scalars['Float']['output']>;
  max_temperature_fahrenheit?: Maybe<Scalars['Float']['output']>;
  pound_per_foot?: Maybe<Scalars['Float']['output']>;
  resistance_per_1000_ft?: Maybe<Scalars['Float']['output']>;
  series?: Maybe<Scalars['Float']['output']>;
  width_inches?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "motor_lead_extensions" */
export type Motor_Lead_Extensions_Avg_Order_By = {
  amp_factor?: InputMaybe<Order_By>;
  depth_inches?: InputMaybe<Order_By>;
  gauge?: InputMaybe<Order_By>;
  impedance_60_hz_per_1000_ft?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  kv?: InputMaybe<Order_By>;
  length_feet?: InputMaybe<Order_By>;
  max_pothead_temperature_fahrenheit?: InputMaybe<Order_By>;
  max_temperature_fahrenheit?: InputMaybe<Order_By>;
  pound_per_foot?: InputMaybe<Order_By>;
  resistance_per_1000_ft?: InputMaybe<Order_By>;
  series?: InputMaybe<Order_By>;
  width_inches?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "motor_lead_extensions". All fields are combined with a logical 'AND'. */
export type Motor_Lead_Extensions_Bool_Exp = {
  _and?: InputMaybe<Array<Motor_Lead_Extensions_Bool_Exp>>;
  _not?: InputMaybe<Motor_Lead_Extensions_Bool_Exp>;
  _or?: InputMaybe<Array<Motor_Lead_Extensions_Bool_Exp>>;
  amp_factor?: InputMaybe<Numeric_Comparison_Exp>;
  author_id?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  depth_inches?: InputMaybe<Numeric_Comparison_Exp>;
  family?: InputMaybe<String_Comparison_Exp>;
  gauge?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  impedance_60_hz_per_1000_ft?: InputMaybe<Numeric_Comparison_Exp>;
  imported_sizing_id?: InputMaybe<Int_Comparison_Exp>;
  include_ecopetrol_timestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  include_koc_timestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  kv?: InputMaybe<Int_Comparison_Exp>;
  length_feet?: InputMaybe<Numeric_Comparison_Exp>;
  manufacturer?: InputMaybe<String_Comparison_Exp>;
  max_pothead_temperature_fahrenheit?: InputMaybe<Int_Comparison_Exp>;
  max_temperature_fahrenheit?: InputMaybe<Int_Comparison_Exp>;
  only_ecopetrol_timestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  only_koc_timestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  part_number?: InputMaybe<String_Comparison_Exp>;
  pound_per_foot?: InputMaybe<Numeric_Comparison_Exp>;
  prioritized_manufacturer?: InputMaybe<String_Comparison_Exp>;
  resistance_per_1000_ft?: InputMaybe<Numeric_Comparison_Exp>;
  series?: InputMaybe<Int_Comparison_Exp>;
  sizing_import?: InputMaybe<Sizing_Imports_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  width_inches?: InputMaybe<Numeric_Comparison_Exp>;
};

/** unique or primary key constraints on table "motor_lead_extensions" */
export enum Motor_Lead_Extensions_Constraint {
  /** unique or primary key constraint on columns "id" */
  MotorLeadExtensionsPkey = 'motor_lead_extensions_pkey'
}

/** input type for incrementing numeric columns in table "motor_lead_extensions" */
export type Motor_Lead_Extensions_Inc_Input = {
  amp_factor?: InputMaybe<Scalars['numeric']['input']>;
  depth_inches?: InputMaybe<Scalars['numeric']['input']>;
  gauge?: InputMaybe<Scalars['Int']['input']>;
  impedance_60_hz_per_1000_ft?: InputMaybe<Scalars['numeric']['input']>;
  imported_sizing_id?: InputMaybe<Scalars['Int']['input']>;
  kv?: InputMaybe<Scalars['Int']['input']>;
  length_feet?: InputMaybe<Scalars['numeric']['input']>;
  max_pothead_temperature_fahrenheit?: InputMaybe<Scalars['Int']['input']>;
  max_temperature_fahrenheit?: InputMaybe<Scalars['Int']['input']>;
  pound_per_foot?: InputMaybe<Scalars['numeric']['input']>;
  resistance_per_1000_ft?: InputMaybe<Scalars['numeric']['input']>;
  series?: InputMaybe<Scalars['Int']['input']>;
  width_inches?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "motor_lead_extensions" */
export type Motor_Lead_Extensions_Insert_Input = {
  amp_factor?: InputMaybe<Scalars['numeric']['input']>;
  author_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  depth_inches?: InputMaybe<Scalars['numeric']['input']>;
  family?: InputMaybe<Scalars['String']['input']>;
  gauge?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  impedance_60_hz_per_1000_ft?: InputMaybe<Scalars['numeric']['input']>;
  imported_sizing_id?: InputMaybe<Scalars['Int']['input']>;
  include_ecopetrol_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  include_koc_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  kv?: InputMaybe<Scalars['Int']['input']>;
  length_feet?: InputMaybe<Scalars['numeric']['input']>;
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  max_pothead_temperature_fahrenheit?: InputMaybe<Scalars['Int']['input']>;
  max_temperature_fahrenheit?: InputMaybe<Scalars['Int']['input']>;
  only_ecopetrol_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  only_koc_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  part_number?: InputMaybe<Scalars['String']['input']>;
  pound_per_foot?: InputMaybe<Scalars['numeric']['input']>;
  resistance_per_1000_ft?: InputMaybe<Scalars['numeric']['input']>;
  series?: InputMaybe<Scalars['Int']['input']>;
  sizing_import?: InputMaybe<Sizing_Imports_Obj_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  width_inches?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate max on columns */
export type Motor_Lead_Extensions_Max_Fields = {
  __typename: 'motor_lead_extensions_max_fields';
  amp_factor?: Maybe<Scalars['numeric']['output']>;
  author_id?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  depth_inches?: Maybe<Scalars['numeric']['output']>;
  family?: Maybe<Scalars['String']['output']>;
  gauge?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  impedance_60_hz_per_1000_ft?: Maybe<Scalars['numeric']['output']>;
  imported_sizing_id?: Maybe<Scalars['Int']['output']>;
  include_ecopetrol_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  include_koc_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  kv?: Maybe<Scalars['Int']['output']>;
  length_feet?: Maybe<Scalars['numeric']['output']>;
  manufacturer?: Maybe<Scalars['String']['output']>;
  max_pothead_temperature_fahrenheit?: Maybe<Scalars['Int']['output']>;
  max_temperature_fahrenheit?: Maybe<Scalars['Int']['output']>;
  only_ecopetrol_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  only_koc_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  part_number?: Maybe<Scalars['String']['output']>;
  pound_per_foot?: Maybe<Scalars['numeric']['output']>;
  /** A computed field, executes function "prioritizemlemanufacturer" */
  prioritized_manufacturer?: Maybe<Scalars['String']['output']>;
  resistance_per_1000_ft?: Maybe<Scalars['numeric']['output']>;
  series?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  width_inches?: Maybe<Scalars['numeric']['output']>;
};

/** order by max() on columns of table "motor_lead_extensions" */
export type Motor_Lead_Extensions_Max_Order_By = {
  amp_factor?: InputMaybe<Order_By>;
  author_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  depth_inches?: InputMaybe<Order_By>;
  family?: InputMaybe<Order_By>;
  gauge?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  impedance_60_hz_per_1000_ft?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  include_ecopetrol_timestamp?: InputMaybe<Order_By>;
  include_koc_timestamp?: InputMaybe<Order_By>;
  kv?: InputMaybe<Order_By>;
  length_feet?: InputMaybe<Order_By>;
  manufacturer?: InputMaybe<Order_By>;
  max_pothead_temperature_fahrenheit?: InputMaybe<Order_By>;
  max_temperature_fahrenheit?: InputMaybe<Order_By>;
  only_ecopetrol_timestamp?: InputMaybe<Order_By>;
  only_koc_timestamp?: InputMaybe<Order_By>;
  part_number?: InputMaybe<Order_By>;
  pound_per_foot?: InputMaybe<Order_By>;
  resistance_per_1000_ft?: InputMaybe<Order_By>;
  series?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  width_inches?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Motor_Lead_Extensions_Min_Fields = {
  __typename: 'motor_lead_extensions_min_fields';
  amp_factor?: Maybe<Scalars['numeric']['output']>;
  author_id?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  depth_inches?: Maybe<Scalars['numeric']['output']>;
  family?: Maybe<Scalars['String']['output']>;
  gauge?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  impedance_60_hz_per_1000_ft?: Maybe<Scalars['numeric']['output']>;
  imported_sizing_id?: Maybe<Scalars['Int']['output']>;
  include_ecopetrol_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  include_koc_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  kv?: Maybe<Scalars['Int']['output']>;
  length_feet?: Maybe<Scalars['numeric']['output']>;
  manufacturer?: Maybe<Scalars['String']['output']>;
  max_pothead_temperature_fahrenheit?: Maybe<Scalars['Int']['output']>;
  max_temperature_fahrenheit?: Maybe<Scalars['Int']['output']>;
  only_ecopetrol_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  only_koc_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  part_number?: Maybe<Scalars['String']['output']>;
  pound_per_foot?: Maybe<Scalars['numeric']['output']>;
  /** A computed field, executes function "prioritizemlemanufacturer" */
  prioritized_manufacturer?: Maybe<Scalars['String']['output']>;
  resistance_per_1000_ft?: Maybe<Scalars['numeric']['output']>;
  series?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  width_inches?: Maybe<Scalars['numeric']['output']>;
};

/** order by min() on columns of table "motor_lead_extensions" */
export type Motor_Lead_Extensions_Min_Order_By = {
  amp_factor?: InputMaybe<Order_By>;
  author_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  depth_inches?: InputMaybe<Order_By>;
  family?: InputMaybe<Order_By>;
  gauge?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  impedance_60_hz_per_1000_ft?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  include_ecopetrol_timestamp?: InputMaybe<Order_By>;
  include_koc_timestamp?: InputMaybe<Order_By>;
  kv?: InputMaybe<Order_By>;
  length_feet?: InputMaybe<Order_By>;
  manufacturer?: InputMaybe<Order_By>;
  max_pothead_temperature_fahrenheit?: InputMaybe<Order_By>;
  max_temperature_fahrenheit?: InputMaybe<Order_By>;
  only_ecopetrol_timestamp?: InputMaybe<Order_By>;
  only_koc_timestamp?: InputMaybe<Order_By>;
  part_number?: InputMaybe<Order_By>;
  pound_per_foot?: InputMaybe<Order_By>;
  resistance_per_1000_ft?: InputMaybe<Order_By>;
  series?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  width_inches?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "motor_lead_extensions" */
export type Motor_Lead_Extensions_Mutation_Response = {
  __typename: 'motor_lead_extensions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Motor_Lead_Extensions>;
};

/** input type for inserting object relation for remote table "motor_lead_extensions" */
export type Motor_Lead_Extensions_Obj_Rel_Insert_Input = {
  data: Motor_Lead_Extensions_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Motor_Lead_Extensions_On_Conflict>;
};

/** on_conflict condition type for table "motor_lead_extensions" */
export type Motor_Lead_Extensions_On_Conflict = {
  constraint: Motor_Lead_Extensions_Constraint;
  update_columns?: Array<Motor_Lead_Extensions_Update_Column>;
  where?: InputMaybe<Motor_Lead_Extensions_Bool_Exp>;
};

/** Ordering options when selecting data from "motor_lead_extensions". */
export type Motor_Lead_Extensions_Order_By = {
  amp_factor?: InputMaybe<Order_By>;
  author_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  depth_inches?: InputMaybe<Order_By>;
  family?: InputMaybe<Order_By>;
  gauge?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  impedance_60_hz_per_1000_ft?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  include_ecopetrol_timestamp?: InputMaybe<Order_By>;
  include_koc_timestamp?: InputMaybe<Order_By>;
  kv?: InputMaybe<Order_By>;
  length_feet?: InputMaybe<Order_By>;
  manufacturer?: InputMaybe<Order_By>;
  max_pothead_temperature_fahrenheit?: InputMaybe<Order_By>;
  max_temperature_fahrenheit?: InputMaybe<Order_By>;
  only_ecopetrol_timestamp?: InputMaybe<Order_By>;
  only_koc_timestamp?: InputMaybe<Order_By>;
  part_number?: InputMaybe<Order_By>;
  pound_per_foot?: InputMaybe<Order_By>;
  prioritized_manufacturer?: InputMaybe<Order_By>;
  resistance_per_1000_ft?: InputMaybe<Order_By>;
  series?: InputMaybe<Order_By>;
  sizing_import?: InputMaybe<Sizing_Imports_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  width_inches?: InputMaybe<Order_By>;
};

/** primary key columns input for table: motor_lead_extensions */
export type Motor_Lead_Extensions_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "motor_lead_extensions" */
export enum Motor_Lead_Extensions_Select_Column {
  /** column name */
  AmpFactor = 'amp_factor',
  /** column name */
  AuthorId = 'author_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  DepthInches = 'depth_inches',
  /** column name */
  Family = 'family',
  /** column name */
  Gauge = 'gauge',
  /** column name */
  Id = 'id',
  /** column name */
  Impedance_60HzPer_1000Ft = 'impedance_60_hz_per_1000_ft',
  /** column name */
  ImportedSizingId = 'imported_sizing_id',
  /** column name */
  IncludeEcopetrolTimestamp = 'include_ecopetrol_timestamp',
  /** column name */
  IncludeKocTimestamp = 'include_koc_timestamp',
  /** column name */
  Kv = 'kv',
  /** column name */
  LengthFeet = 'length_feet',
  /** column name */
  Manufacturer = 'manufacturer',
  /** column name */
  MaxPotheadTemperatureFahrenheit = 'max_pothead_temperature_fahrenheit',
  /** column name */
  MaxTemperatureFahrenheit = 'max_temperature_fahrenheit',
  /** column name */
  OnlyEcopetrolTimestamp = 'only_ecopetrol_timestamp',
  /** column name */
  OnlyKocTimestamp = 'only_koc_timestamp',
  /** column name */
  PartNumber = 'part_number',
  /** column name */
  PoundPerFoot = 'pound_per_foot',
  /** column name */
  ResistancePer_1000Ft = 'resistance_per_1000_ft',
  /** column name */
  Series = 'series',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WidthInches = 'width_inches'
}

/** input type for updating data in table "motor_lead_extensions" */
export type Motor_Lead_Extensions_Set_Input = {
  amp_factor?: InputMaybe<Scalars['numeric']['input']>;
  author_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  depth_inches?: InputMaybe<Scalars['numeric']['input']>;
  family?: InputMaybe<Scalars['String']['input']>;
  gauge?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  impedance_60_hz_per_1000_ft?: InputMaybe<Scalars['numeric']['input']>;
  imported_sizing_id?: InputMaybe<Scalars['Int']['input']>;
  include_ecopetrol_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  include_koc_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  kv?: InputMaybe<Scalars['Int']['input']>;
  length_feet?: InputMaybe<Scalars['numeric']['input']>;
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  max_pothead_temperature_fahrenheit?: InputMaybe<Scalars['Int']['input']>;
  max_temperature_fahrenheit?: InputMaybe<Scalars['Int']['input']>;
  only_ecopetrol_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  only_koc_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  part_number?: InputMaybe<Scalars['String']['input']>;
  pound_per_foot?: InputMaybe<Scalars['numeric']['input']>;
  resistance_per_1000_ft?: InputMaybe<Scalars['numeric']['input']>;
  series?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  width_inches?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate stddev on columns */
export type Motor_Lead_Extensions_Stddev_Fields = {
  __typename: 'motor_lead_extensions_stddev_fields';
  amp_factor?: Maybe<Scalars['Float']['output']>;
  depth_inches?: Maybe<Scalars['Float']['output']>;
  gauge?: Maybe<Scalars['Float']['output']>;
  impedance_60_hz_per_1000_ft?: Maybe<Scalars['Float']['output']>;
  imported_sizing_id?: Maybe<Scalars['Float']['output']>;
  kv?: Maybe<Scalars['Float']['output']>;
  length_feet?: Maybe<Scalars['Float']['output']>;
  max_pothead_temperature_fahrenheit?: Maybe<Scalars['Float']['output']>;
  max_temperature_fahrenheit?: Maybe<Scalars['Float']['output']>;
  pound_per_foot?: Maybe<Scalars['Float']['output']>;
  resistance_per_1000_ft?: Maybe<Scalars['Float']['output']>;
  series?: Maybe<Scalars['Float']['output']>;
  width_inches?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "motor_lead_extensions" */
export type Motor_Lead_Extensions_Stddev_Order_By = {
  amp_factor?: InputMaybe<Order_By>;
  depth_inches?: InputMaybe<Order_By>;
  gauge?: InputMaybe<Order_By>;
  impedance_60_hz_per_1000_ft?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  kv?: InputMaybe<Order_By>;
  length_feet?: InputMaybe<Order_By>;
  max_pothead_temperature_fahrenheit?: InputMaybe<Order_By>;
  max_temperature_fahrenheit?: InputMaybe<Order_By>;
  pound_per_foot?: InputMaybe<Order_By>;
  resistance_per_1000_ft?: InputMaybe<Order_By>;
  series?: InputMaybe<Order_By>;
  width_inches?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Motor_Lead_Extensions_Stddev_Pop_Fields = {
  __typename: 'motor_lead_extensions_stddev_pop_fields';
  amp_factor?: Maybe<Scalars['Float']['output']>;
  depth_inches?: Maybe<Scalars['Float']['output']>;
  gauge?: Maybe<Scalars['Float']['output']>;
  impedance_60_hz_per_1000_ft?: Maybe<Scalars['Float']['output']>;
  imported_sizing_id?: Maybe<Scalars['Float']['output']>;
  kv?: Maybe<Scalars['Float']['output']>;
  length_feet?: Maybe<Scalars['Float']['output']>;
  max_pothead_temperature_fahrenheit?: Maybe<Scalars['Float']['output']>;
  max_temperature_fahrenheit?: Maybe<Scalars['Float']['output']>;
  pound_per_foot?: Maybe<Scalars['Float']['output']>;
  resistance_per_1000_ft?: Maybe<Scalars['Float']['output']>;
  series?: Maybe<Scalars['Float']['output']>;
  width_inches?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "motor_lead_extensions" */
export type Motor_Lead_Extensions_Stddev_Pop_Order_By = {
  amp_factor?: InputMaybe<Order_By>;
  depth_inches?: InputMaybe<Order_By>;
  gauge?: InputMaybe<Order_By>;
  impedance_60_hz_per_1000_ft?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  kv?: InputMaybe<Order_By>;
  length_feet?: InputMaybe<Order_By>;
  max_pothead_temperature_fahrenheit?: InputMaybe<Order_By>;
  max_temperature_fahrenheit?: InputMaybe<Order_By>;
  pound_per_foot?: InputMaybe<Order_By>;
  resistance_per_1000_ft?: InputMaybe<Order_By>;
  series?: InputMaybe<Order_By>;
  width_inches?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Motor_Lead_Extensions_Stddev_Samp_Fields = {
  __typename: 'motor_lead_extensions_stddev_samp_fields';
  amp_factor?: Maybe<Scalars['Float']['output']>;
  depth_inches?: Maybe<Scalars['Float']['output']>;
  gauge?: Maybe<Scalars['Float']['output']>;
  impedance_60_hz_per_1000_ft?: Maybe<Scalars['Float']['output']>;
  imported_sizing_id?: Maybe<Scalars['Float']['output']>;
  kv?: Maybe<Scalars['Float']['output']>;
  length_feet?: Maybe<Scalars['Float']['output']>;
  max_pothead_temperature_fahrenheit?: Maybe<Scalars['Float']['output']>;
  max_temperature_fahrenheit?: Maybe<Scalars['Float']['output']>;
  pound_per_foot?: Maybe<Scalars['Float']['output']>;
  resistance_per_1000_ft?: Maybe<Scalars['Float']['output']>;
  series?: Maybe<Scalars['Float']['output']>;
  width_inches?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "motor_lead_extensions" */
export type Motor_Lead_Extensions_Stddev_Samp_Order_By = {
  amp_factor?: InputMaybe<Order_By>;
  depth_inches?: InputMaybe<Order_By>;
  gauge?: InputMaybe<Order_By>;
  impedance_60_hz_per_1000_ft?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  kv?: InputMaybe<Order_By>;
  length_feet?: InputMaybe<Order_By>;
  max_pothead_temperature_fahrenheit?: InputMaybe<Order_By>;
  max_temperature_fahrenheit?: InputMaybe<Order_By>;
  pound_per_foot?: InputMaybe<Order_By>;
  resistance_per_1000_ft?: InputMaybe<Order_By>;
  series?: InputMaybe<Order_By>;
  width_inches?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "motor_lead_extensions" */
export type Motor_Lead_Extensions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Motor_Lead_Extensions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Motor_Lead_Extensions_Stream_Cursor_Value_Input = {
  amp_factor?: InputMaybe<Scalars['numeric']['input']>;
  author_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  depth_inches?: InputMaybe<Scalars['numeric']['input']>;
  family?: InputMaybe<Scalars['String']['input']>;
  gauge?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  impedance_60_hz_per_1000_ft?: InputMaybe<Scalars['numeric']['input']>;
  imported_sizing_id?: InputMaybe<Scalars['Int']['input']>;
  include_ecopetrol_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  include_koc_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  kv?: InputMaybe<Scalars['Int']['input']>;
  length_feet?: InputMaybe<Scalars['numeric']['input']>;
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  max_pothead_temperature_fahrenheit?: InputMaybe<Scalars['Int']['input']>;
  max_temperature_fahrenheit?: InputMaybe<Scalars['Int']['input']>;
  only_ecopetrol_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  only_koc_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  part_number?: InputMaybe<Scalars['String']['input']>;
  pound_per_foot?: InputMaybe<Scalars['numeric']['input']>;
  resistance_per_1000_ft?: InputMaybe<Scalars['numeric']['input']>;
  series?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  width_inches?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate sum on columns */
export type Motor_Lead_Extensions_Sum_Fields = {
  __typename: 'motor_lead_extensions_sum_fields';
  amp_factor?: Maybe<Scalars['numeric']['output']>;
  depth_inches?: Maybe<Scalars['numeric']['output']>;
  gauge?: Maybe<Scalars['Int']['output']>;
  impedance_60_hz_per_1000_ft?: Maybe<Scalars['numeric']['output']>;
  imported_sizing_id?: Maybe<Scalars['Int']['output']>;
  kv?: Maybe<Scalars['Int']['output']>;
  length_feet?: Maybe<Scalars['numeric']['output']>;
  max_pothead_temperature_fahrenheit?: Maybe<Scalars['Int']['output']>;
  max_temperature_fahrenheit?: Maybe<Scalars['Int']['output']>;
  pound_per_foot?: Maybe<Scalars['numeric']['output']>;
  resistance_per_1000_ft?: Maybe<Scalars['numeric']['output']>;
  series?: Maybe<Scalars['Int']['output']>;
  width_inches?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "motor_lead_extensions" */
export type Motor_Lead_Extensions_Sum_Order_By = {
  amp_factor?: InputMaybe<Order_By>;
  depth_inches?: InputMaybe<Order_By>;
  gauge?: InputMaybe<Order_By>;
  impedance_60_hz_per_1000_ft?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  kv?: InputMaybe<Order_By>;
  length_feet?: InputMaybe<Order_By>;
  max_pothead_temperature_fahrenheit?: InputMaybe<Order_By>;
  max_temperature_fahrenheit?: InputMaybe<Order_By>;
  pound_per_foot?: InputMaybe<Order_By>;
  resistance_per_1000_ft?: InputMaybe<Order_By>;
  series?: InputMaybe<Order_By>;
  width_inches?: InputMaybe<Order_By>;
};

/** update columns of table "motor_lead_extensions" */
export enum Motor_Lead_Extensions_Update_Column {
  /** column name */
  AmpFactor = 'amp_factor',
  /** column name */
  AuthorId = 'author_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  DepthInches = 'depth_inches',
  /** column name */
  Family = 'family',
  /** column name */
  Gauge = 'gauge',
  /** column name */
  Id = 'id',
  /** column name */
  Impedance_60HzPer_1000Ft = 'impedance_60_hz_per_1000_ft',
  /** column name */
  ImportedSizingId = 'imported_sizing_id',
  /** column name */
  IncludeEcopetrolTimestamp = 'include_ecopetrol_timestamp',
  /** column name */
  IncludeKocTimestamp = 'include_koc_timestamp',
  /** column name */
  Kv = 'kv',
  /** column name */
  LengthFeet = 'length_feet',
  /** column name */
  Manufacturer = 'manufacturer',
  /** column name */
  MaxPotheadTemperatureFahrenheit = 'max_pothead_temperature_fahrenheit',
  /** column name */
  MaxTemperatureFahrenheit = 'max_temperature_fahrenheit',
  /** column name */
  OnlyEcopetrolTimestamp = 'only_ecopetrol_timestamp',
  /** column name */
  OnlyKocTimestamp = 'only_koc_timestamp',
  /** column name */
  PartNumber = 'part_number',
  /** column name */
  PoundPerFoot = 'pound_per_foot',
  /** column name */
  ResistancePer_1000Ft = 'resistance_per_1000_ft',
  /** column name */
  Series = 'series',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WidthInches = 'width_inches'
}

export type Motor_Lead_Extensions_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Motor_Lead_Extensions_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Motor_Lead_Extensions_Set_Input>;
  /** filter the rows which have to be updated */
  where: Motor_Lead_Extensions_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Motor_Lead_Extensions_Var_Pop_Fields = {
  __typename: 'motor_lead_extensions_var_pop_fields';
  amp_factor?: Maybe<Scalars['Float']['output']>;
  depth_inches?: Maybe<Scalars['Float']['output']>;
  gauge?: Maybe<Scalars['Float']['output']>;
  impedance_60_hz_per_1000_ft?: Maybe<Scalars['Float']['output']>;
  imported_sizing_id?: Maybe<Scalars['Float']['output']>;
  kv?: Maybe<Scalars['Float']['output']>;
  length_feet?: Maybe<Scalars['Float']['output']>;
  max_pothead_temperature_fahrenheit?: Maybe<Scalars['Float']['output']>;
  max_temperature_fahrenheit?: Maybe<Scalars['Float']['output']>;
  pound_per_foot?: Maybe<Scalars['Float']['output']>;
  resistance_per_1000_ft?: Maybe<Scalars['Float']['output']>;
  series?: Maybe<Scalars['Float']['output']>;
  width_inches?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "motor_lead_extensions" */
export type Motor_Lead_Extensions_Var_Pop_Order_By = {
  amp_factor?: InputMaybe<Order_By>;
  depth_inches?: InputMaybe<Order_By>;
  gauge?: InputMaybe<Order_By>;
  impedance_60_hz_per_1000_ft?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  kv?: InputMaybe<Order_By>;
  length_feet?: InputMaybe<Order_By>;
  max_pothead_temperature_fahrenheit?: InputMaybe<Order_By>;
  max_temperature_fahrenheit?: InputMaybe<Order_By>;
  pound_per_foot?: InputMaybe<Order_By>;
  resistance_per_1000_ft?: InputMaybe<Order_By>;
  series?: InputMaybe<Order_By>;
  width_inches?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Motor_Lead_Extensions_Var_Samp_Fields = {
  __typename: 'motor_lead_extensions_var_samp_fields';
  amp_factor?: Maybe<Scalars['Float']['output']>;
  depth_inches?: Maybe<Scalars['Float']['output']>;
  gauge?: Maybe<Scalars['Float']['output']>;
  impedance_60_hz_per_1000_ft?: Maybe<Scalars['Float']['output']>;
  imported_sizing_id?: Maybe<Scalars['Float']['output']>;
  kv?: Maybe<Scalars['Float']['output']>;
  length_feet?: Maybe<Scalars['Float']['output']>;
  max_pothead_temperature_fahrenheit?: Maybe<Scalars['Float']['output']>;
  max_temperature_fahrenheit?: Maybe<Scalars['Float']['output']>;
  pound_per_foot?: Maybe<Scalars['Float']['output']>;
  resistance_per_1000_ft?: Maybe<Scalars['Float']['output']>;
  series?: Maybe<Scalars['Float']['output']>;
  width_inches?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "motor_lead_extensions" */
export type Motor_Lead_Extensions_Var_Samp_Order_By = {
  amp_factor?: InputMaybe<Order_By>;
  depth_inches?: InputMaybe<Order_By>;
  gauge?: InputMaybe<Order_By>;
  impedance_60_hz_per_1000_ft?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  kv?: InputMaybe<Order_By>;
  length_feet?: InputMaybe<Order_By>;
  max_pothead_temperature_fahrenheit?: InputMaybe<Order_By>;
  max_temperature_fahrenheit?: InputMaybe<Order_By>;
  pound_per_foot?: InputMaybe<Order_By>;
  resistance_per_1000_ft?: InputMaybe<Order_By>;
  series?: InputMaybe<Order_By>;
  width_inches?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Motor_Lead_Extensions_Variance_Fields = {
  __typename: 'motor_lead_extensions_variance_fields';
  amp_factor?: Maybe<Scalars['Float']['output']>;
  depth_inches?: Maybe<Scalars['Float']['output']>;
  gauge?: Maybe<Scalars['Float']['output']>;
  impedance_60_hz_per_1000_ft?: Maybe<Scalars['Float']['output']>;
  imported_sizing_id?: Maybe<Scalars['Float']['output']>;
  kv?: Maybe<Scalars['Float']['output']>;
  length_feet?: Maybe<Scalars['Float']['output']>;
  max_pothead_temperature_fahrenheit?: Maybe<Scalars['Float']['output']>;
  max_temperature_fahrenheit?: Maybe<Scalars['Float']['output']>;
  pound_per_foot?: Maybe<Scalars['Float']['output']>;
  resistance_per_1000_ft?: Maybe<Scalars['Float']['output']>;
  series?: Maybe<Scalars['Float']['output']>;
  width_inches?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "motor_lead_extensions" */
export type Motor_Lead_Extensions_Variance_Order_By = {
  amp_factor?: InputMaybe<Order_By>;
  depth_inches?: InputMaybe<Order_By>;
  gauge?: InputMaybe<Order_By>;
  impedance_60_hz_per_1000_ft?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  kv?: InputMaybe<Order_By>;
  length_feet?: InputMaybe<Order_By>;
  max_pothead_temperature_fahrenheit?: InputMaybe<Order_By>;
  max_temperature_fahrenheit?: InputMaybe<Order_By>;
  pound_per_foot?: InputMaybe<Order_By>;
  resistance_per_1000_ft?: InputMaybe<Order_By>;
  series?: InputMaybe<Order_By>;
  width_inches?: InputMaybe<Order_By>;
};

/** columns and relationships of "motors" */
export type Motors = {
  __typename: 'motors';
  allow_rerate: Scalars['Boolean']['output'];
  author_id: Scalars['String']['output'];
  configuration?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  eff1?: Maybe<Scalars['numeric']['output']>;
  eff2?: Maybe<Scalars['numeric']['output']>;
  eff3?: Maybe<Scalars['numeric']['output']>;
  eff4?: Maybe<Scalars['numeric']['output']>;
  eff5?: Maybe<Scalars['numeric']['output']>;
  effb?: Maybe<Scalars['numeric']['output']>;
  effv0: Scalars['numeric']['output'];
  effv1: Scalars['numeric']['output'];
  effv2: Scalars['numeric']['output'];
  i1?: Maybe<Scalars['numeric']['output']>;
  i2?: Maybe<Scalars['numeric']['output']>;
  i3?: Maybe<Scalars['numeric']['output']>;
  i4?: Maybe<Scalars['numeric']['output']>;
  i5?: Maybe<Scalars['numeric']['output']>;
  ib?: Maybe<Scalars['numeric']['output']>;
  id: Scalars['uuid']['output'];
  imported_sizing_id?: Maybe<Scalars['Int']['output']>;
  include_ecopetrol_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  include_koc_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  inner_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  is_hps: Scalars['Boolean']['output'];
  iv0: Scalars['numeric']['output'];
  iv1: Scalars['numeric']['output'];
  iv2: Scalars['numeric']['output'];
  k3?: Maybe<Scalars['numeric']['output']>;
  length_inches?: Maybe<Scalars['numeric']['output']>;
  manufacturer?: Maybe<Scalars['String']['output']>;
  mle_offset_depth_inches: Scalars['numeric']['output'];
  n1?: Maybe<Scalars['numeric']['output']>;
  n2?: Maybe<Scalars['numeric']['output']>;
  n3?: Maybe<Scalars['numeric']['output']>;
  n4?: Maybe<Scalars['numeric']['output']>;
  n5?: Maybe<Scalars['numeric']['output']>;
  nameplate_current?: Maybe<Scalars['Int']['output']>;
  nameplate_horsepower?: Maybe<Scalars['Int']['output']>;
  nameplate_rerate_ratio?: Maybe<Scalars['numeric']['output']>;
  nameplate_voltage?: Maybe<Scalars['Int']['output']>;
  nb?: Maybe<Scalars['numeric']['output']>;
  neck_inner_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  neck_outer_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  nv0: Scalars['numeric']['output'];
  nv1: Scalars['numeric']['output'];
  nv2: Scalars['numeric']['output'];
  oil_volume_gallons?: Maybe<Scalars['numeric']['output']>;
  only_ecopetrol_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  only_koc_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  outer_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  outer_diameter_rub_inches: Scalars['numeric']['output'];
  part_number?: Maybe<Scalars['String']['output']>;
  pf1?: Maybe<Scalars['numeric']['output']>;
  pf2?: Maybe<Scalars['numeric']['output']>;
  pf3?: Maybe<Scalars['numeric']['output']>;
  pf4?: Maybe<Scalars['numeric']['output']>;
  pf5?: Maybe<Scalars['numeric']['output']>;
  pfb?: Maybe<Scalars['numeric']['output']>;
  pfv0: Scalars['numeric']['output'];
  pfv1: Scalars['numeric']['output'];
  pfv2: Scalars['numeric']['output'];
  poles?: Maybe<Scalars['Int']['output']>;
  /** A computed field, executes function "prioritizemotormanufacturer" */
  prioritized_manufacturer?: Maybe<Scalars['String']['output']>;
  rr_l1?: Maybe<Scalars['numeric']['output']>;
  rr_l2?: Maybe<Scalars['numeric']['output']>;
  rr_lb?: Maybe<Scalars['numeric']['output']>;
  rr_v1?: Maybe<Scalars['numeric']['output']>;
  rr_v2: Scalars['numeric']['output'];
  rr_v3: Scalars['numeric']['output'];
  rr_vb?: Maybe<Scalars['numeric']['output']>;
  shaft_height_inches?: Maybe<Scalars['numeric']['output']>;
  shaft_horsepower?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  sizing_import?: Maybe<Sizing_Imports>;
  stator_inner_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  stator_outer_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  temperature_rating_fahrenheit?: Maybe<Scalars['Int']['output']>;
  tv0: Scalars['numeric']['output'];
  tv1: Scalars['numeric']['output'];
  tv2: Scalars['numeric']['output'];
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Users;
  weight_pounds?: Maybe<Scalars['numeric']['output']>;
};

/** aggregated selection of "motors" */
export type Motors_Aggregate = {
  __typename: 'motors_aggregate';
  aggregate?: Maybe<Motors_Aggregate_Fields>;
  nodes: Array<Motors>;
};

export type Motors_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Motors_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Motors_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Motors_Aggregate_Bool_Exp_Count>;
};

export type Motors_Aggregate_Bool_Exp_Bool_And = {
  arguments: Motors_Select_Column_Motors_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Motors_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Motors_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Motors_Select_Column_Motors_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Motors_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Motors_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Motors_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Motors_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "motors" */
export type Motors_Aggregate_Fields = {
  __typename: 'motors_aggregate_fields';
  avg?: Maybe<Motors_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Motors_Max_Fields>;
  min?: Maybe<Motors_Min_Fields>;
  stddev?: Maybe<Motors_Stddev_Fields>;
  stddev_pop?: Maybe<Motors_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Motors_Stddev_Samp_Fields>;
  sum?: Maybe<Motors_Sum_Fields>;
  var_pop?: Maybe<Motors_Var_Pop_Fields>;
  var_samp?: Maybe<Motors_Var_Samp_Fields>;
  variance?: Maybe<Motors_Variance_Fields>;
};


/** aggregate fields of "motors" */
export type Motors_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Motors_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "motors" */
export type Motors_Aggregate_Order_By = {
  avg?: InputMaybe<Motors_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Motors_Max_Order_By>;
  min?: InputMaybe<Motors_Min_Order_By>;
  stddev?: InputMaybe<Motors_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Motors_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Motors_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Motors_Sum_Order_By>;
  var_pop?: InputMaybe<Motors_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Motors_Var_Samp_Order_By>;
  variance?: InputMaybe<Motors_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "motors" */
export type Motors_Arr_Rel_Insert_Input = {
  data: Array<Motors_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Motors_On_Conflict>;
};

/** aggregate avg on columns */
export type Motors_Avg_Fields = {
  __typename: 'motors_avg_fields';
  eff1?: Maybe<Scalars['Float']['output']>;
  eff2?: Maybe<Scalars['Float']['output']>;
  eff3?: Maybe<Scalars['Float']['output']>;
  eff4?: Maybe<Scalars['Float']['output']>;
  eff5?: Maybe<Scalars['Float']['output']>;
  effb?: Maybe<Scalars['Float']['output']>;
  effv0?: Maybe<Scalars['Float']['output']>;
  effv1?: Maybe<Scalars['Float']['output']>;
  effv2?: Maybe<Scalars['Float']['output']>;
  i1?: Maybe<Scalars['Float']['output']>;
  i2?: Maybe<Scalars['Float']['output']>;
  i3?: Maybe<Scalars['Float']['output']>;
  i4?: Maybe<Scalars['Float']['output']>;
  i5?: Maybe<Scalars['Float']['output']>;
  ib?: Maybe<Scalars['Float']['output']>;
  imported_sizing_id?: Maybe<Scalars['Float']['output']>;
  inner_diameter_inches?: Maybe<Scalars['Float']['output']>;
  iv0?: Maybe<Scalars['Float']['output']>;
  iv1?: Maybe<Scalars['Float']['output']>;
  iv2?: Maybe<Scalars['Float']['output']>;
  k3?: Maybe<Scalars['Float']['output']>;
  length_inches?: Maybe<Scalars['Float']['output']>;
  mle_offset_depth_inches?: Maybe<Scalars['Float']['output']>;
  n1?: Maybe<Scalars['Float']['output']>;
  n2?: Maybe<Scalars['Float']['output']>;
  n3?: Maybe<Scalars['Float']['output']>;
  n4?: Maybe<Scalars['Float']['output']>;
  n5?: Maybe<Scalars['Float']['output']>;
  nameplate_current?: Maybe<Scalars['Float']['output']>;
  nameplate_horsepower?: Maybe<Scalars['Float']['output']>;
  nameplate_rerate_ratio?: Maybe<Scalars['Float']['output']>;
  nameplate_voltage?: Maybe<Scalars['Float']['output']>;
  nb?: Maybe<Scalars['Float']['output']>;
  neck_inner_diameter_inches?: Maybe<Scalars['Float']['output']>;
  neck_outer_diameter_inches?: Maybe<Scalars['Float']['output']>;
  nv0?: Maybe<Scalars['Float']['output']>;
  nv1?: Maybe<Scalars['Float']['output']>;
  nv2?: Maybe<Scalars['Float']['output']>;
  oil_volume_gallons?: Maybe<Scalars['Float']['output']>;
  outer_diameter_inches?: Maybe<Scalars['Float']['output']>;
  outer_diameter_rub_inches?: Maybe<Scalars['Float']['output']>;
  pf1?: Maybe<Scalars['Float']['output']>;
  pf2?: Maybe<Scalars['Float']['output']>;
  pf3?: Maybe<Scalars['Float']['output']>;
  pf4?: Maybe<Scalars['Float']['output']>;
  pf5?: Maybe<Scalars['Float']['output']>;
  pfb?: Maybe<Scalars['Float']['output']>;
  pfv0?: Maybe<Scalars['Float']['output']>;
  pfv1?: Maybe<Scalars['Float']['output']>;
  pfv2?: Maybe<Scalars['Float']['output']>;
  poles?: Maybe<Scalars['Float']['output']>;
  rr_l1?: Maybe<Scalars['Float']['output']>;
  rr_l2?: Maybe<Scalars['Float']['output']>;
  rr_lb?: Maybe<Scalars['Float']['output']>;
  rr_v1?: Maybe<Scalars['Float']['output']>;
  rr_v2?: Maybe<Scalars['Float']['output']>;
  rr_v3?: Maybe<Scalars['Float']['output']>;
  rr_vb?: Maybe<Scalars['Float']['output']>;
  shaft_height_inches?: Maybe<Scalars['Float']['output']>;
  shaft_horsepower?: Maybe<Scalars['Float']['output']>;
  stator_inner_diameter_inches?: Maybe<Scalars['Float']['output']>;
  stator_outer_diameter_inches?: Maybe<Scalars['Float']['output']>;
  temperature_rating_fahrenheit?: Maybe<Scalars['Float']['output']>;
  tv0?: Maybe<Scalars['Float']['output']>;
  tv1?: Maybe<Scalars['Float']['output']>;
  tv2?: Maybe<Scalars['Float']['output']>;
  weight_pounds?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "motors" */
export type Motors_Avg_Order_By = {
  eff1?: InputMaybe<Order_By>;
  eff2?: InputMaybe<Order_By>;
  eff3?: InputMaybe<Order_By>;
  eff4?: InputMaybe<Order_By>;
  eff5?: InputMaybe<Order_By>;
  effb?: InputMaybe<Order_By>;
  effv0?: InputMaybe<Order_By>;
  effv1?: InputMaybe<Order_By>;
  effv2?: InputMaybe<Order_By>;
  i1?: InputMaybe<Order_By>;
  i2?: InputMaybe<Order_By>;
  i3?: InputMaybe<Order_By>;
  i4?: InputMaybe<Order_By>;
  i5?: InputMaybe<Order_By>;
  ib?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  inner_diameter_inches?: InputMaybe<Order_By>;
  iv0?: InputMaybe<Order_By>;
  iv1?: InputMaybe<Order_By>;
  iv2?: InputMaybe<Order_By>;
  k3?: InputMaybe<Order_By>;
  length_inches?: InputMaybe<Order_By>;
  mle_offset_depth_inches?: InputMaybe<Order_By>;
  n1?: InputMaybe<Order_By>;
  n2?: InputMaybe<Order_By>;
  n3?: InputMaybe<Order_By>;
  n4?: InputMaybe<Order_By>;
  n5?: InputMaybe<Order_By>;
  nameplate_current?: InputMaybe<Order_By>;
  nameplate_horsepower?: InputMaybe<Order_By>;
  nameplate_rerate_ratio?: InputMaybe<Order_By>;
  nameplate_voltage?: InputMaybe<Order_By>;
  nb?: InputMaybe<Order_By>;
  neck_inner_diameter_inches?: InputMaybe<Order_By>;
  neck_outer_diameter_inches?: InputMaybe<Order_By>;
  nv0?: InputMaybe<Order_By>;
  nv1?: InputMaybe<Order_By>;
  nv2?: InputMaybe<Order_By>;
  oil_volume_gallons?: InputMaybe<Order_By>;
  outer_diameter_inches?: InputMaybe<Order_By>;
  outer_diameter_rub_inches?: InputMaybe<Order_By>;
  pf1?: InputMaybe<Order_By>;
  pf2?: InputMaybe<Order_By>;
  pf3?: InputMaybe<Order_By>;
  pf4?: InputMaybe<Order_By>;
  pf5?: InputMaybe<Order_By>;
  pfb?: InputMaybe<Order_By>;
  pfv0?: InputMaybe<Order_By>;
  pfv1?: InputMaybe<Order_By>;
  pfv2?: InputMaybe<Order_By>;
  poles?: InputMaybe<Order_By>;
  rr_l1?: InputMaybe<Order_By>;
  rr_l2?: InputMaybe<Order_By>;
  rr_lb?: InputMaybe<Order_By>;
  rr_v1?: InputMaybe<Order_By>;
  rr_v2?: InputMaybe<Order_By>;
  rr_v3?: InputMaybe<Order_By>;
  rr_vb?: InputMaybe<Order_By>;
  shaft_height_inches?: InputMaybe<Order_By>;
  shaft_horsepower?: InputMaybe<Order_By>;
  stator_inner_diameter_inches?: InputMaybe<Order_By>;
  stator_outer_diameter_inches?: InputMaybe<Order_By>;
  temperature_rating_fahrenheit?: InputMaybe<Order_By>;
  tv0?: InputMaybe<Order_By>;
  tv1?: InputMaybe<Order_By>;
  tv2?: InputMaybe<Order_By>;
  weight_pounds?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "motors". All fields are combined with a logical 'AND'. */
export type Motors_Bool_Exp = {
  _and?: InputMaybe<Array<Motors_Bool_Exp>>;
  _not?: InputMaybe<Motors_Bool_Exp>;
  _or?: InputMaybe<Array<Motors_Bool_Exp>>;
  allow_rerate?: InputMaybe<Boolean_Comparison_Exp>;
  author_id?: InputMaybe<String_Comparison_Exp>;
  configuration?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  eff1?: InputMaybe<Numeric_Comparison_Exp>;
  eff2?: InputMaybe<Numeric_Comparison_Exp>;
  eff3?: InputMaybe<Numeric_Comparison_Exp>;
  eff4?: InputMaybe<Numeric_Comparison_Exp>;
  eff5?: InputMaybe<Numeric_Comparison_Exp>;
  effb?: InputMaybe<Numeric_Comparison_Exp>;
  effv0?: InputMaybe<Numeric_Comparison_Exp>;
  effv1?: InputMaybe<Numeric_Comparison_Exp>;
  effv2?: InputMaybe<Numeric_Comparison_Exp>;
  i1?: InputMaybe<Numeric_Comparison_Exp>;
  i2?: InputMaybe<Numeric_Comparison_Exp>;
  i3?: InputMaybe<Numeric_Comparison_Exp>;
  i4?: InputMaybe<Numeric_Comparison_Exp>;
  i5?: InputMaybe<Numeric_Comparison_Exp>;
  ib?: InputMaybe<Numeric_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  imported_sizing_id?: InputMaybe<Int_Comparison_Exp>;
  include_ecopetrol_timestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  include_koc_timestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  inner_diameter_inches?: InputMaybe<Numeric_Comparison_Exp>;
  is_hps?: InputMaybe<Boolean_Comparison_Exp>;
  iv0?: InputMaybe<Numeric_Comparison_Exp>;
  iv1?: InputMaybe<Numeric_Comparison_Exp>;
  iv2?: InputMaybe<Numeric_Comparison_Exp>;
  k3?: InputMaybe<Numeric_Comparison_Exp>;
  length_inches?: InputMaybe<Numeric_Comparison_Exp>;
  manufacturer?: InputMaybe<String_Comparison_Exp>;
  mle_offset_depth_inches?: InputMaybe<Numeric_Comparison_Exp>;
  n1?: InputMaybe<Numeric_Comparison_Exp>;
  n2?: InputMaybe<Numeric_Comparison_Exp>;
  n3?: InputMaybe<Numeric_Comparison_Exp>;
  n4?: InputMaybe<Numeric_Comparison_Exp>;
  n5?: InputMaybe<Numeric_Comparison_Exp>;
  nameplate_current?: InputMaybe<Int_Comparison_Exp>;
  nameplate_horsepower?: InputMaybe<Int_Comparison_Exp>;
  nameplate_rerate_ratio?: InputMaybe<Numeric_Comparison_Exp>;
  nameplate_voltage?: InputMaybe<Int_Comparison_Exp>;
  nb?: InputMaybe<Numeric_Comparison_Exp>;
  neck_inner_diameter_inches?: InputMaybe<Numeric_Comparison_Exp>;
  neck_outer_diameter_inches?: InputMaybe<Numeric_Comparison_Exp>;
  nv0?: InputMaybe<Numeric_Comparison_Exp>;
  nv1?: InputMaybe<Numeric_Comparison_Exp>;
  nv2?: InputMaybe<Numeric_Comparison_Exp>;
  oil_volume_gallons?: InputMaybe<Numeric_Comparison_Exp>;
  only_ecopetrol_timestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  only_koc_timestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  outer_diameter_inches?: InputMaybe<Numeric_Comparison_Exp>;
  outer_diameter_rub_inches?: InputMaybe<Numeric_Comparison_Exp>;
  part_number?: InputMaybe<String_Comparison_Exp>;
  pf1?: InputMaybe<Numeric_Comparison_Exp>;
  pf2?: InputMaybe<Numeric_Comparison_Exp>;
  pf3?: InputMaybe<Numeric_Comparison_Exp>;
  pf4?: InputMaybe<Numeric_Comparison_Exp>;
  pf5?: InputMaybe<Numeric_Comparison_Exp>;
  pfb?: InputMaybe<Numeric_Comparison_Exp>;
  pfv0?: InputMaybe<Numeric_Comparison_Exp>;
  pfv1?: InputMaybe<Numeric_Comparison_Exp>;
  pfv2?: InputMaybe<Numeric_Comparison_Exp>;
  poles?: InputMaybe<Int_Comparison_Exp>;
  prioritized_manufacturer?: InputMaybe<String_Comparison_Exp>;
  rr_l1?: InputMaybe<Numeric_Comparison_Exp>;
  rr_l2?: InputMaybe<Numeric_Comparison_Exp>;
  rr_lb?: InputMaybe<Numeric_Comparison_Exp>;
  rr_v1?: InputMaybe<Numeric_Comparison_Exp>;
  rr_v2?: InputMaybe<Numeric_Comparison_Exp>;
  rr_v3?: InputMaybe<Numeric_Comparison_Exp>;
  rr_vb?: InputMaybe<Numeric_Comparison_Exp>;
  shaft_height_inches?: InputMaybe<Numeric_Comparison_Exp>;
  shaft_horsepower?: InputMaybe<Int_Comparison_Exp>;
  sizing_import?: InputMaybe<Sizing_Imports_Bool_Exp>;
  stator_inner_diameter_inches?: InputMaybe<Numeric_Comparison_Exp>;
  stator_outer_diameter_inches?: InputMaybe<Numeric_Comparison_Exp>;
  temperature_rating_fahrenheit?: InputMaybe<Int_Comparison_Exp>;
  tv0?: InputMaybe<Numeric_Comparison_Exp>;
  tv1?: InputMaybe<Numeric_Comparison_Exp>;
  tv2?: InputMaybe<Numeric_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  weight_pounds?: InputMaybe<Numeric_Comparison_Exp>;
};

/** unique or primary key constraints on table "motors" */
export enum Motors_Constraint {
  /** unique or primary key constraint on columns "id" */
  MotorsPkey = 'motors_pkey'
}

/** input type for incrementing numeric columns in table "motors" */
export type Motors_Inc_Input = {
  eff1?: InputMaybe<Scalars['numeric']['input']>;
  eff2?: InputMaybe<Scalars['numeric']['input']>;
  eff3?: InputMaybe<Scalars['numeric']['input']>;
  eff4?: InputMaybe<Scalars['numeric']['input']>;
  eff5?: InputMaybe<Scalars['numeric']['input']>;
  effb?: InputMaybe<Scalars['numeric']['input']>;
  effv0?: InputMaybe<Scalars['numeric']['input']>;
  effv1?: InputMaybe<Scalars['numeric']['input']>;
  effv2?: InputMaybe<Scalars['numeric']['input']>;
  i1?: InputMaybe<Scalars['numeric']['input']>;
  i2?: InputMaybe<Scalars['numeric']['input']>;
  i3?: InputMaybe<Scalars['numeric']['input']>;
  i4?: InputMaybe<Scalars['numeric']['input']>;
  i5?: InputMaybe<Scalars['numeric']['input']>;
  ib?: InputMaybe<Scalars['numeric']['input']>;
  imported_sizing_id?: InputMaybe<Scalars['Int']['input']>;
  inner_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  iv0?: InputMaybe<Scalars['numeric']['input']>;
  iv1?: InputMaybe<Scalars['numeric']['input']>;
  iv2?: InputMaybe<Scalars['numeric']['input']>;
  k3?: InputMaybe<Scalars['numeric']['input']>;
  length_inches?: InputMaybe<Scalars['numeric']['input']>;
  mle_offset_depth_inches?: InputMaybe<Scalars['numeric']['input']>;
  n1?: InputMaybe<Scalars['numeric']['input']>;
  n2?: InputMaybe<Scalars['numeric']['input']>;
  n3?: InputMaybe<Scalars['numeric']['input']>;
  n4?: InputMaybe<Scalars['numeric']['input']>;
  n5?: InputMaybe<Scalars['numeric']['input']>;
  nameplate_current?: InputMaybe<Scalars['Int']['input']>;
  nameplate_horsepower?: InputMaybe<Scalars['Int']['input']>;
  nameplate_rerate_ratio?: InputMaybe<Scalars['numeric']['input']>;
  nameplate_voltage?: InputMaybe<Scalars['Int']['input']>;
  nb?: InputMaybe<Scalars['numeric']['input']>;
  neck_inner_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  neck_outer_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  nv0?: InputMaybe<Scalars['numeric']['input']>;
  nv1?: InputMaybe<Scalars['numeric']['input']>;
  nv2?: InputMaybe<Scalars['numeric']['input']>;
  oil_volume_gallons?: InputMaybe<Scalars['numeric']['input']>;
  outer_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  outer_diameter_rub_inches?: InputMaybe<Scalars['numeric']['input']>;
  pf1?: InputMaybe<Scalars['numeric']['input']>;
  pf2?: InputMaybe<Scalars['numeric']['input']>;
  pf3?: InputMaybe<Scalars['numeric']['input']>;
  pf4?: InputMaybe<Scalars['numeric']['input']>;
  pf5?: InputMaybe<Scalars['numeric']['input']>;
  pfb?: InputMaybe<Scalars['numeric']['input']>;
  pfv0?: InputMaybe<Scalars['numeric']['input']>;
  pfv1?: InputMaybe<Scalars['numeric']['input']>;
  pfv2?: InputMaybe<Scalars['numeric']['input']>;
  poles?: InputMaybe<Scalars['Int']['input']>;
  rr_l1?: InputMaybe<Scalars['numeric']['input']>;
  rr_l2?: InputMaybe<Scalars['numeric']['input']>;
  rr_lb?: InputMaybe<Scalars['numeric']['input']>;
  rr_v1?: InputMaybe<Scalars['numeric']['input']>;
  rr_v2?: InputMaybe<Scalars['numeric']['input']>;
  rr_v3?: InputMaybe<Scalars['numeric']['input']>;
  rr_vb?: InputMaybe<Scalars['numeric']['input']>;
  shaft_height_inches?: InputMaybe<Scalars['numeric']['input']>;
  shaft_horsepower?: InputMaybe<Scalars['Int']['input']>;
  stator_inner_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  stator_outer_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  temperature_rating_fahrenheit?: InputMaybe<Scalars['Int']['input']>;
  tv0?: InputMaybe<Scalars['numeric']['input']>;
  tv1?: InputMaybe<Scalars['numeric']['input']>;
  tv2?: InputMaybe<Scalars['numeric']['input']>;
  weight_pounds?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "motors" */
export type Motors_Insert_Input = {
  allow_rerate?: InputMaybe<Scalars['Boolean']['input']>;
  author_id?: InputMaybe<Scalars['String']['input']>;
  configuration?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  eff1?: InputMaybe<Scalars['numeric']['input']>;
  eff2?: InputMaybe<Scalars['numeric']['input']>;
  eff3?: InputMaybe<Scalars['numeric']['input']>;
  eff4?: InputMaybe<Scalars['numeric']['input']>;
  eff5?: InputMaybe<Scalars['numeric']['input']>;
  effb?: InputMaybe<Scalars['numeric']['input']>;
  effv0?: InputMaybe<Scalars['numeric']['input']>;
  effv1?: InputMaybe<Scalars['numeric']['input']>;
  effv2?: InputMaybe<Scalars['numeric']['input']>;
  i1?: InputMaybe<Scalars['numeric']['input']>;
  i2?: InputMaybe<Scalars['numeric']['input']>;
  i3?: InputMaybe<Scalars['numeric']['input']>;
  i4?: InputMaybe<Scalars['numeric']['input']>;
  i5?: InputMaybe<Scalars['numeric']['input']>;
  ib?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  imported_sizing_id?: InputMaybe<Scalars['Int']['input']>;
  include_ecopetrol_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  include_koc_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  inner_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  is_hps?: InputMaybe<Scalars['Boolean']['input']>;
  iv0?: InputMaybe<Scalars['numeric']['input']>;
  iv1?: InputMaybe<Scalars['numeric']['input']>;
  iv2?: InputMaybe<Scalars['numeric']['input']>;
  k3?: InputMaybe<Scalars['numeric']['input']>;
  length_inches?: InputMaybe<Scalars['numeric']['input']>;
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  mle_offset_depth_inches?: InputMaybe<Scalars['numeric']['input']>;
  n1?: InputMaybe<Scalars['numeric']['input']>;
  n2?: InputMaybe<Scalars['numeric']['input']>;
  n3?: InputMaybe<Scalars['numeric']['input']>;
  n4?: InputMaybe<Scalars['numeric']['input']>;
  n5?: InputMaybe<Scalars['numeric']['input']>;
  nameplate_current?: InputMaybe<Scalars['Int']['input']>;
  nameplate_horsepower?: InputMaybe<Scalars['Int']['input']>;
  nameplate_rerate_ratio?: InputMaybe<Scalars['numeric']['input']>;
  nameplate_voltage?: InputMaybe<Scalars['Int']['input']>;
  nb?: InputMaybe<Scalars['numeric']['input']>;
  neck_inner_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  neck_outer_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  nv0?: InputMaybe<Scalars['numeric']['input']>;
  nv1?: InputMaybe<Scalars['numeric']['input']>;
  nv2?: InputMaybe<Scalars['numeric']['input']>;
  oil_volume_gallons?: InputMaybe<Scalars['numeric']['input']>;
  only_ecopetrol_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  only_koc_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  outer_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  outer_diameter_rub_inches?: InputMaybe<Scalars['numeric']['input']>;
  part_number?: InputMaybe<Scalars['String']['input']>;
  pf1?: InputMaybe<Scalars['numeric']['input']>;
  pf2?: InputMaybe<Scalars['numeric']['input']>;
  pf3?: InputMaybe<Scalars['numeric']['input']>;
  pf4?: InputMaybe<Scalars['numeric']['input']>;
  pf5?: InputMaybe<Scalars['numeric']['input']>;
  pfb?: InputMaybe<Scalars['numeric']['input']>;
  pfv0?: InputMaybe<Scalars['numeric']['input']>;
  pfv1?: InputMaybe<Scalars['numeric']['input']>;
  pfv2?: InputMaybe<Scalars['numeric']['input']>;
  poles?: InputMaybe<Scalars['Int']['input']>;
  rr_l1?: InputMaybe<Scalars['numeric']['input']>;
  rr_l2?: InputMaybe<Scalars['numeric']['input']>;
  rr_lb?: InputMaybe<Scalars['numeric']['input']>;
  rr_v1?: InputMaybe<Scalars['numeric']['input']>;
  rr_v2?: InputMaybe<Scalars['numeric']['input']>;
  rr_v3?: InputMaybe<Scalars['numeric']['input']>;
  rr_vb?: InputMaybe<Scalars['numeric']['input']>;
  shaft_height_inches?: InputMaybe<Scalars['numeric']['input']>;
  shaft_horsepower?: InputMaybe<Scalars['Int']['input']>;
  sizing_import?: InputMaybe<Sizing_Imports_Obj_Rel_Insert_Input>;
  stator_inner_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  stator_outer_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  temperature_rating_fahrenheit?: InputMaybe<Scalars['Int']['input']>;
  tv0?: InputMaybe<Scalars['numeric']['input']>;
  tv1?: InputMaybe<Scalars['numeric']['input']>;
  tv2?: InputMaybe<Scalars['numeric']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  weight_pounds?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate max on columns */
export type Motors_Max_Fields = {
  __typename: 'motors_max_fields';
  author_id?: Maybe<Scalars['String']['output']>;
  configuration?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  eff1?: Maybe<Scalars['numeric']['output']>;
  eff2?: Maybe<Scalars['numeric']['output']>;
  eff3?: Maybe<Scalars['numeric']['output']>;
  eff4?: Maybe<Scalars['numeric']['output']>;
  eff5?: Maybe<Scalars['numeric']['output']>;
  effb?: Maybe<Scalars['numeric']['output']>;
  effv0?: Maybe<Scalars['numeric']['output']>;
  effv1?: Maybe<Scalars['numeric']['output']>;
  effv2?: Maybe<Scalars['numeric']['output']>;
  i1?: Maybe<Scalars['numeric']['output']>;
  i2?: Maybe<Scalars['numeric']['output']>;
  i3?: Maybe<Scalars['numeric']['output']>;
  i4?: Maybe<Scalars['numeric']['output']>;
  i5?: Maybe<Scalars['numeric']['output']>;
  ib?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  imported_sizing_id?: Maybe<Scalars['Int']['output']>;
  include_ecopetrol_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  include_koc_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  inner_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  iv0?: Maybe<Scalars['numeric']['output']>;
  iv1?: Maybe<Scalars['numeric']['output']>;
  iv2?: Maybe<Scalars['numeric']['output']>;
  k3?: Maybe<Scalars['numeric']['output']>;
  length_inches?: Maybe<Scalars['numeric']['output']>;
  manufacturer?: Maybe<Scalars['String']['output']>;
  mle_offset_depth_inches?: Maybe<Scalars['numeric']['output']>;
  n1?: Maybe<Scalars['numeric']['output']>;
  n2?: Maybe<Scalars['numeric']['output']>;
  n3?: Maybe<Scalars['numeric']['output']>;
  n4?: Maybe<Scalars['numeric']['output']>;
  n5?: Maybe<Scalars['numeric']['output']>;
  nameplate_current?: Maybe<Scalars['Int']['output']>;
  nameplate_horsepower?: Maybe<Scalars['Int']['output']>;
  nameplate_rerate_ratio?: Maybe<Scalars['numeric']['output']>;
  nameplate_voltage?: Maybe<Scalars['Int']['output']>;
  nb?: Maybe<Scalars['numeric']['output']>;
  neck_inner_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  neck_outer_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  nv0?: Maybe<Scalars['numeric']['output']>;
  nv1?: Maybe<Scalars['numeric']['output']>;
  nv2?: Maybe<Scalars['numeric']['output']>;
  oil_volume_gallons?: Maybe<Scalars['numeric']['output']>;
  only_ecopetrol_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  only_koc_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  outer_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  outer_diameter_rub_inches?: Maybe<Scalars['numeric']['output']>;
  part_number?: Maybe<Scalars['String']['output']>;
  pf1?: Maybe<Scalars['numeric']['output']>;
  pf2?: Maybe<Scalars['numeric']['output']>;
  pf3?: Maybe<Scalars['numeric']['output']>;
  pf4?: Maybe<Scalars['numeric']['output']>;
  pf5?: Maybe<Scalars['numeric']['output']>;
  pfb?: Maybe<Scalars['numeric']['output']>;
  pfv0?: Maybe<Scalars['numeric']['output']>;
  pfv1?: Maybe<Scalars['numeric']['output']>;
  pfv2?: Maybe<Scalars['numeric']['output']>;
  poles?: Maybe<Scalars['Int']['output']>;
  /** A computed field, executes function "prioritizemotormanufacturer" */
  prioritized_manufacturer?: Maybe<Scalars['String']['output']>;
  rr_l1?: Maybe<Scalars['numeric']['output']>;
  rr_l2?: Maybe<Scalars['numeric']['output']>;
  rr_lb?: Maybe<Scalars['numeric']['output']>;
  rr_v1?: Maybe<Scalars['numeric']['output']>;
  rr_v2?: Maybe<Scalars['numeric']['output']>;
  rr_v3?: Maybe<Scalars['numeric']['output']>;
  rr_vb?: Maybe<Scalars['numeric']['output']>;
  shaft_height_inches?: Maybe<Scalars['numeric']['output']>;
  shaft_horsepower?: Maybe<Scalars['Int']['output']>;
  stator_inner_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  stator_outer_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  temperature_rating_fahrenheit?: Maybe<Scalars['Int']['output']>;
  tv0?: Maybe<Scalars['numeric']['output']>;
  tv1?: Maybe<Scalars['numeric']['output']>;
  tv2?: Maybe<Scalars['numeric']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  weight_pounds?: Maybe<Scalars['numeric']['output']>;
};

/** order by max() on columns of table "motors" */
export type Motors_Max_Order_By = {
  author_id?: InputMaybe<Order_By>;
  configuration?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  eff1?: InputMaybe<Order_By>;
  eff2?: InputMaybe<Order_By>;
  eff3?: InputMaybe<Order_By>;
  eff4?: InputMaybe<Order_By>;
  eff5?: InputMaybe<Order_By>;
  effb?: InputMaybe<Order_By>;
  effv0?: InputMaybe<Order_By>;
  effv1?: InputMaybe<Order_By>;
  effv2?: InputMaybe<Order_By>;
  i1?: InputMaybe<Order_By>;
  i2?: InputMaybe<Order_By>;
  i3?: InputMaybe<Order_By>;
  i4?: InputMaybe<Order_By>;
  i5?: InputMaybe<Order_By>;
  ib?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  include_ecopetrol_timestamp?: InputMaybe<Order_By>;
  include_koc_timestamp?: InputMaybe<Order_By>;
  inner_diameter_inches?: InputMaybe<Order_By>;
  iv0?: InputMaybe<Order_By>;
  iv1?: InputMaybe<Order_By>;
  iv2?: InputMaybe<Order_By>;
  k3?: InputMaybe<Order_By>;
  length_inches?: InputMaybe<Order_By>;
  manufacturer?: InputMaybe<Order_By>;
  mle_offset_depth_inches?: InputMaybe<Order_By>;
  n1?: InputMaybe<Order_By>;
  n2?: InputMaybe<Order_By>;
  n3?: InputMaybe<Order_By>;
  n4?: InputMaybe<Order_By>;
  n5?: InputMaybe<Order_By>;
  nameplate_current?: InputMaybe<Order_By>;
  nameplate_horsepower?: InputMaybe<Order_By>;
  nameplate_rerate_ratio?: InputMaybe<Order_By>;
  nameplate_voltage?: InputMaybe<Order_By>;
  nb?: InputMaybe<Order_By>;
  neck_inner_diameter_inches?: InputMaybe<Order_By>;
  neck_outer_diameter_inches?: InputMaybe<Order_By>;
  nv0?: InputMaybe<Order_By>;
  nv1?: InputMaybe<Order_By>;
  nv2?: InputMaybe<Order_By>;
  oil_volume_gallons?: InputMaybe<Order_By>;
  only_ecopetrol_timestamp?: InputMaybe<Order_By>;
  only_koc_timestamp?: InputMaybe<Order_By>;
  outer_diameter_inches?: InputMaybe<Order_By>;
  outer_diameter_rub_inches?: InputMaybe<Order_By>;
  part_number?: InputMaybe<Order_By>;
  pf1?: InputMaybe<Order_By>;
  pf2?: InputMaybe<Order_By>;
  pf3?: InputMaybe<Order_By>;
  pf4?: InputMaybe<Order_By>;
  pf5?: InputMaybe<Order_By>;
  pfb?: InputMaybe<Order_By>;
  pfv0?: InputMaybe<Order_By>;
  pfv1?: InputMaybe<Order_By>;
  pfv2?: InputMaybe<Order_By>;
  poles?: InputMaybe<Order_By>;
  rr_l1?: InputMaybe<Order_By>;
  rr_l2?: InputMaybe<Order_By>;
  rr_lb?: InputMaybe<Order_By>;
  rr_v1?: InputMaybe<Order_By>;
  rr_v2?: InputMaybe<Order_By>;
  rr_v3?: InputMaybe<Order_By>;
  rr_vb?: InputMaybe<Order_By>;
  shaft_height_inches?: InputMaybe<Order_By>;
  shaft_horsepower?: InputMaybe<Order_By>;
  stator_inner_diameter_inches?: InputMaybe<Order_By>;
  stator_outer_diameter_inches?: InputMaybe<Order_By>;
  temperature_rating_fahrenheit?: InputMaybe<Order_By>;
  tv0?: InputMaybe<Order_By>;
  tv1?: InputMaybe<Order_By>;
  tv2?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  weight_pounds?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Motors_Min_Fields = {
  __typename: 'motors_min_fields';
  author_id?: Maybe<Scalars['String']['output']>;
  configuration?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  eff1?: Maybe<Scalars['numeric']['output']>;
  eff2?: Maybe<Scalars['numeric']['output']>;
  eff3?: Maybe<Scalars['numeric']['output']>;
  eff4?: Maybe<Scalars['numeric']['output']>;
  eff5?: Maybe<Scalars['numeric']['output']>;
  effb?: Maybe<Scalars['numeric']['output']>;
  effv0?: Maybe<Scalars['numeric']['output']>;
  effv1?: Maybe<Scalars['numeric']['output']>;
  effv2?: Maybe<Scalars['numeric']['output']>;
  i1?: Maybe<Scalars['numeric']['output']>;
  i2?: Maybe<Scalars['numeric']['output']>;
  i3?: Maybe<Scalars['numeric']['output']>;
  i4?: Maybe<Scalars['numeric']['output']>;
  i5?: Maybe<Scalars['numeric']['output']>;
  ib?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  imported_sizing_id?: Maybe<Scalars['Int']['output']>;
  include_ecopetrol_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  include_koc_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  inner_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  iv0?: Maybe<Scalars['numeric']['output']>;
  iv1?: Maybe<Scalars['numeric']['output']>;
  iv2?: Maybe<Scalars['numeric']['output']>;
  k3?: Maybe<Scalars['numeric']['output']>;
  length_inches?: Maybe<Scalars['numeric']['output']>;
  manufacturer?: Maybe<Scalars['String']['output']>;
  mle_offset_depth_inches?: Maybe<Scalars['numeric']['output']>;
  n1?: Maybe<Scalars['numeric']['output']>;
  n2?: Maybe<Scalars['numeric']['output']>;
  n3?: Maybe<Scalars['numeric']['output']>;
  n4?: Maybe<Scalars['numeric']['output']>;
  n5?: Maybe<Scalars['numeric']['output']>;
  nameplate_current?: Maybe<Scalars['Int']['output']>;
  nameplate_horsepower?: Maybe<Scalars['Int']['output']>;
  nameplate_rerate_ratio?: Maybe<Scalars['numeric']['output']>;
  nameplate_voltage?: Maybe<Scalars['Int']['output']>;
  nb?: Maybe<Scalars['numeric']['output']>;
  neck_inner_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  neck_outer_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  nv0?: Maybe<Scalars['numeric']['output']>;
  nv1?: Maybe<Scalars['numeric']['output']>;
  nv2?: Maybe<Scalars['numeric']['output']>;
  oil_volume_gallons?: Maybe<Scalars['numeric']['output']>;
  only_ecopetrol_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  only_koc_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  outer_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  outer_diameter_rub_inches?: Maybe<Scalars['numeric']['output']>;
  part_number?: Maybe<Scalars['String']['output']>;
  pf1?: Maybe<Scalars['numeric']['output']>;
  pf2?: Maybe<Scalars['numeric']['output']>;
  pf3?: Maybe<Scalars['numeric']['output']>;
  pf4?: Maybe<Scalars['numeric']['output']>;
  pf5?: Maybe<Scalars['numeric']['output']>;
  pfb?: Maybe<Scalars['numeric']['output']>;
  pfv0?: Maybe<Scalars['numeric']['output']>;
  pfv1?: Maybe<Scalars['numeric']['output']>;
  pfv2?: Maybe<Scalars['numeric']['output']>;
  poles?: Maybe<Scalars['Int']['output']>;
  /** A computed field, executes function "prioritizemotormanufacturer" */
  prioritized_manufacturer?: Maybe<Scalars['String']['output']>;
  rr_l1?: Maybe<Scalars['numeric']['output']>;
  rr_l2?: Maybe<Scalars['numeric']['output']>;
  rr_lb?: Maybe<Scalars['numeric']['output']>;
  rr_v1?: Maybe<Scalars['numeric']['output']>;
  rr_v2?: Maybe<Scalars['numeric']['output']>;
  rr_v3?: Maybe<Scalars['numeric']['output']>;
  rr_vb?: Maybe<Scalars['numeric']['output']>;
  shaft_height_inches?: Maybe<Scalars['numeric']['output']>;
  shaft_horsepower?: Maybe<Scalars['Int']['output']>;
  stator_inner_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  stator_outer_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  temperature_rating_fahrenheit?: Maybe<Scalars['Int']['output']>;
  tv0?: Maybe<Scalars['numeric']['output']>;
  tv1?: Maybe<Scalars['numeric']['output']>;
  tv2?: Maybe<Scalars['numeric']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  weight_pounds?: Maybe<Scalars['numeric']['output']>;
};

/** order by min() on columns of table "motors" */
export type Motors_Min_Order_By = {
  author_id?: InputMaybe<Order_By>;
  configuration?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  eff1?: InputMaybe<Order_By>;
  eff2?: InputMaybe<Order_By>;
  eff3?: InputMaybe<Order_By>;
  eff4?: InputMaybe<Order_By>;
  eff5?: InputMaybe<Order_By>;
  effb?: InputMaybe<Order_By>;
  effv0?: InputMaybe<Order_By>;
  effv1?: InputMaybe<Order_By>;
  effv2?: InputMaybe<Order_By>;
  i1?: InputMaybe<Order_By>;
  i2?: InputMaybe<Order_By>;
  i3?: InputMaybe<Order_By>;
  i4?: InputMaybe<Order_By>;
  i5?: InputMaybe<Order_By>;
  ib?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  include_ecopetrol_timestamp?: InputMaybe<Order_By>;
  include_koc_timestamp?: InputMaybe<Order_By>;
  inner_diameter_inches?: InputMaybe<Order_By>;
  iv0?: InputMaybe<Order_By>;
  iv1?: InputMaybe<Order_By>;
  iv2?: InputMaybe<Order_By>;
  k3?: InputMaybe<Order_By>;
  length_inches?: InputMaybe<Order_By>;
  manufacturer?: InputMaybe<Order_By>;
  mle_offset_depth_inches?: InputMaybe<Order_By>;
  n1?: InputMaybe<Order_By>;
  n2?: InputMaybe<Order_By>;
  n3?: InputMaybe<Order_By>;
  n4?: InputMaybe<Order_By>;
  n5?: InputMaybe<Order_By>;
  nameplate_current?: InputMaybe<Order_By>;
  nameplate_horsepower?: InputMaybe<Order_By>;
  nameplate_rerate_ratio?: InputMaybe<Order_By>;
  nameplate_voltage?: InputMaybe<Order_By>;
  nb?: InputMaybe<Order_By>;
  neck_inner_diameter_inches?: InputMaybe<Order_By>;
  neck_outer_diameter_inches?: InputMaybe<Order_By>;
  nv0?: InputMaybe<Order_By>;
  nv1?: InputMaybe<Order_By>;
  nv2?: InputMaybe<Order_By>;
  oil_volume_gallons?: InputMaybe<Order_By>;
  only_ecopetrol_timestamp?: InputMaybe<Order_By>;
  only_koc_timestamp?: InputMaybe<Order_By>;
  outer_diameter_inches?: InputMaybe<Order_By>;
  outer_diameter_rub_inches?: InputMaybe<Order_By>;
  part_number?: InputMaybe<Order_By>;
  pf1?: InputMaybe<Order_By>;
  pf2?: InputMaybe<Order_By>;
  pf3?: InputMaybe<Order_By>;
  pf4?: InputMaybe<Order_By>;
  pf5?: InputMaybe<Order_By>;
  pfb?: InputMaybe<Order_By>;
  pfv0?: InputMaybe<Order_By>;
  pfv1?: InputMaybe<Order_By>;
  pfv2?: InputMaybe<Order_By>;
  poles?: InputMaybe<Order_By>;
  rr_l1?: InputMaybe<Order_By>;
  rr_l2?: InputMaybe<Order_By>;
  rr_lb?: InputMaybe<Order_By>;
  rr_v1?: InputMaybe<Order_By>;
  rr_v2?: InputMaybe<Order_By>;
  rr_v3?: InputMaybe<Order_By>;
  rr_vb?: InputMaybe<Order_By>;
  shaft_height_inches?: InputMaybe<Order_By>;
  shaft_horsepower?: InputMaybe<Order_By>;
  stator_inner_diameter_inches?: InputMaybe<Order_By>;
  stator_outer_diameter_inches?: InputMaybe<Order_By>;
  temperature_rating_fahrenheit?: InputMaybe<Order_By>;
  tv0?: InputMaybe<Order_By>;
  tv1?: InputMaybe<Order_By>;
  tv2?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  weight_pounds?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "motors" */
export type Motors_Mutation_Response = {
  __typename: 'motors_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Motors>;
};

/** input type for inserting object relation for remote table "motors" */
export type Motors_Obj_Rel_Insert_Input = {
  data: Motors_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Motors_On_Conflict>;
};

/** on_conflict condition type for table "motors" */
export type Motors_On_Conflict = {
  constraint: Motors_Constraint;
  update_columns?: Array<Motors_Update_Column>;
  where?: InputMaybe<Motors_Bool_Exp>;
};

/** Ordering options when selecting data from "motors". */
export type Motors_Order_By = {
  allow_rerate?: InputMaybe<Order_By>;
  author_id?: InputMaybe<Order_By>;
  configuration?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  eff1?: InputMaybe<Order_By>;
  eff2?: InputMaybe<Order_By>;
  eff3?: InputMaybe<Order_By>;
  eff4?: InputMaybe<Order_By>;
  eff5?: InputMaybe<Order_By>;
  effb?: InputMaybe<Order_By>;
  effv0?: InputMaybe<Order_By>;
  effv1?: InputMaybe<Order_By>;
  effv2?: InputMaybe<Order_By>;
  i1?: InputMaybe<Order_By>;
  i2?: InputMaybe<Order_By>;
  i3?: InputMaybe<Order_By>;
  i4?: InputMaybe<Order_By>;
  i5?: InputMaybe<Order_By>;
  ib?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  include_ecopetrol_timestamp?: InputMaybe<Order_By>;
  include_koc_timestamp?: InputMaybe<Order_By>;
  inner_diameter_inches?: InputMaybe<Order_By>;
  is_hps?: InputMaybe<Order_By>;
  iv0?: InputMaybe<Order_By>;
  iv1?: InputMaybe<Order_By>;
  iv2?: InputMaybe<Order_By>;
  k3?: InputMaybe<Order_By>;
  length_inches?: InputMaybe<Order_By>;
  manufacturer?: InputMaybe<Order_By>;
  mle_offset_depth_inches?: InputMaybe<Order_By>;
  n1?: InputMaybe<Order_By>;
  n2?: InputMaybe<Order_By>;
  n3?: InputMaybe<Order_By>;
  n4?: InputMaybe<Order_By>;
  n5?: InputMaybe<Order_By>;
  nameplate_current?: InputMaybe<Order_By>;
  nameplate_horsepower?: InputMaybe<Order_By>;
  nameplate_rerate_ratio?: InputMaybe<Order_By>;
  nameplate_voltage?: InputMaybe<Order_By>;
  nb?: InputMaybe<Order_By>;
  neck_inner_diameter_inches?: InputMaybe<Order_By>;
  neck_outer_diameter_inches?: InputMaybe<Order_By>;
  nv0?: InputMaybe<Order_By>;
  nv1?: InputMaybe<Order_By>;
  nv2?: InputMaybe<Order_By>;
  oil_volume_gallons?: InputMaybe<Order_By>;
  only_ecopetrol_timestamp?: InputMaybe<Order_By>;
  only_koc_timestamp?: InputMaybe<Order_By>;
  outer_diameter_inches?: InputMaybe<Order_By>;
  outer_diameter_rub_inches?: InputMaybe<Order_By>;
  part_number?: InputMaybe<Order_By>;
  pf1?: InputMaybe<Order_By>;
  pf2?: InputMaybe<Order_By>;
  pf3?: InputMaybe<Order_By>;
  pf4?: InputMaybe<Order_By>;
  pf5?: InputMaybe<Order_By>;
  pfb?: InputMaybe<Order_By>;
  pfv0?: InputMaybe<Order_By>;
  pfv1?: InputMaybe<Order_By>;
  pfv2?: InputMaybe<Order_By>;
  poles?: InputMaybe<Order_By>;
  prioritized_manufacturer?: InputMaybe<Order_By>;
  rr_l1?: InputMaybe<Order_By>;
  rr_l2?: InputMaybe<Order_By>;
  rr_lb?: InputMaybe<Order_By>;
  rr_v1?: InputMaybe<Order_By>;
  rr_v2?: InputMaybe<Order_By>;
  rr_v3?: InputMaybe<Order_By>;
  rr_vb?: InputMaybe<Order_By>;
  shaft_height_inches?: InputMaybe<Order_By>;
  shaft_horsepower?: InputMaybe<Order_By>;
  sizing_import?: InputMaybe<Sizing_Imports_Order_By>;
  stator_inner_diameter_inches?: InputMaybe<Order_By>;
  stator_outer_diameter_inches?: InputMaybe<Order_By>;
  temperature_rating_fahrenheit?: InputMaybe<Order_By>;
  tv0?: InputMaybe<Order_By>;
  tv1?: InputMaybe<Order_By>;
  tv2?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  weight_pounds?: InputMaybe<Order_By>;
};

/** primary key columns input for table: motors */
export type Motors_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "motors" */
export enum Motors_Select_Column {
  /** column name */
  AllowRerate = 'allow_rerate',
  /** column name */
  AuthorId = 'author_id',
  /** column name */
  Configuration = 'configuration',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Eff1 = 'eff1',
  /** column name */
  Eff2 = 'eff2',
  /** column name */
  Eff3 = 'eff3',
  /** column name */
  Eff4 = 'eff4',
  /** column name */
  Eff5 = 'eff5',
  /** column name */
  Effb = 'effb',
  /** column name */
  Effv0 = 'effv0',
  /** column name */
  Effv1 = 'effv1',
  /** column name */
  Effv2 = 'effv2',
  /** column name */
  I1 = 'i1',
  /** column name */
  I2 = 'i2',
  /** column name */
  I3 = 'i3',
  /** column name */
  I4 = 'i4',
  /** column name */
  I5 = 'i5',
  /** column name */
  Ib = 'ib',
  /** column name */
  Id = 'id',
  /** column name */
  ImportedSizingId = 'imported_sizing_id',
  /** column name */
  IncludeEcopetrolTimestamp = 'include_ecopetrol_timestamp',
  /** column name */
  IncludeKocTimestamp = 'include_koc_timestamp',
  /** column name */
  InnerDiameterInches = 'inner_diameter_inches',
  /** column name */
  IsHps = 'is_hps',
  /** column name */
  Iv0 = 'iv0',
  /** column name */
  Iv1 = 'iv1',
  /** column name */
  Iv2 = 'iv2',
  /** column name */
  K3 = 'k3',
  /** column name */
  LengthInches = 'length_inches',
  /** column name */
  Manufacturer = 'manufacturer',
  /** column name */
  MleOffsetDepthInches = 'mle_offset_depth_inches',
  /** column name */
  N1 = 'n1',
  /** column name */
  N2 = 'n2',
  /** column name */
  N3 = 'n3',
  /** column name */
  N4 = 'n4',
  /** column name */
  N5 = 'n5',
  /** column name */
  NameplateCurrent = 'nameplate_current',
  /** column name */
  NameplateHorsepower = 'nameplate_horsepower',
  /** column name */
  NameplateRerateRatio = 'nameplate_rerate_ratio',
  /** column name */
  NameplateVoltage = 'nameplate_voltage',
  /** column name */
  Nb = 'nb',
  /** column name */
  NeckInnerDiameterInches = 'neck_inner_diameter_inches',
  /** column name */
  NeckOuterDiameterInches = 'neck_outer_diameter_inches',
  /** column name */
  Nv0 = 'nv0',
  /** column name */
  Nv1 = 'nv1',
  /** column name */
  Nv2 = 'nv2',
  /** column name */
  OilVolumeGallons = 'oil_volume_gallons',
  /** column name */
  OnlyEcopetrolTimestamp = 'only_ecopetrol_timestamp',
  /** column name */
  OnlyKocTimestamp = 'only_koc_timestamp',
  /** column name */
  OuterDiameterInches = 'outer_diameter_inches',
  /** column name */
  OuterDiameterRubInches = 'outer_diameter_rub_inches',
  /** column name */
  PartNumber = 'part_number',
  /** column name */
  Pf1 = 'pf1',
  /** column name */
  Pf2 = 'pf2',
  /** column name */
  Pf3 = 'pf3',
  /** column name */
  Pf4 = 'pf4',
  /** column name */
  Pf5 = 'pf5',
  /** column name */
  Pfb = 'pfb',
  /** column name */
  Pfv0 = 'pfv0',
  /** column name */
  Pfv1 = 'pfv1',
  /** column name */
  Pfv2 = 'pfv2',
  /** column name */
  Poles = 'poles',
  /** column name */
  RrL1 = 'rr_l1',
  /** column name */
  RrL2 = 'rr_l2',
  /** column name */
  RrLb = 'rr_lb',
  /** column name */
  RrV1 = 'rr_v1',
  /** column name */
  RrV2 = 'rr_v2',
  /** column name */
  RrV3 = 'rr_v3',
  /** column name */
  RrVb = 'rr_vb',
  /** column name */
  ShaftHeightInches = 'shaft_height_inches',
  /** column name */
  ShaftHorsepower = 'shaft_horsepower',
  /** column name */
  StatorInnerDiameterInches = 'stator_inner_diameter_inches',
  /** column name */
  StatorOuterDiameterInches = 'stator_outer_diameter_inches',
  /** column name */
  TemperatureRatingFahrenheit = 'temperature_rating_fahrenheit',
  /** column name */
  Tv0 = 'tv0',
  /** column name */
  Tv1 = 'tv1',
  /** column name */
  Tv2 = 'tv2',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WeightPounds = 'weight_pounds'
}

/** select "motors_aggregate_bool_exp_bool_and_arguments_columns" columns of table "motors" */
export enum Motors_Select_Column_Motors_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  AllowRerate = 'allow_rerate',
  /** column name */
  IsHps = 'is_hps'
}

/** select "motors_aggregate_bool_exp_bool_or_arguments_columns" columns of table "motors" */
export enum Motors_Select_Column_Motors_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  AllowRerate = 'allow_rerate',
  /** column name */
  IsHps = 'is_hps'
}

/** input type for updating data in table "motors" */
export type Motors_Set_Input = {
  allow_rerate?: InputMaybe<Scalars['Boolean']['input']>;
  author_id?: InputMaybe<Scalars['String']['input']>;
  configuration?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  eff1?: InputMaybe<Scalars['numeric']['input']>;
  eff2?: InputMaybe<Scalars['numeric']['input']>;
  eff3?: InputMaybe<Scalars['numeric']['input']>;
  eff4?: InputMaybe<Scalars['numeric']['input']>;
  eff5?: InputMaybe<Scalars['numeric']['input']>;
  effb?: InputMaybe<Scalars['numeric']['input']>;
  effv0?: InputMaybe<Scalars['numeric']['input']>;
  effv1?: InputMaybe<Scalars['numeric']['input']>;
  effv2?: InputMaybe<Scalars['numeric']['input']>;
  i1?: InputMaybe<Scalars['numeric']['input']>;
  i2?: InputMaybe<Scalars['numeric']['input']>;
  i3?: InputMaybe<Scalars['numeric']['input']>;
  i4?: InputMaybe<Scalars['numeric']['input']>;
  i5?: InputMaybe<Scalars['numeric']['input']>;
  ib?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  imported_sizing_id?: InputMaybe<Scalars['Int']['input']>;
  include_ecopetrol_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  include_koc_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  inner_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  is_hps?: InputMaybe<Scalars['Boolean']['input']>;
  iv0?: InputMaybe<Scalars['numeric']['input']>;
  iv1?: InputMaybe<Scalars['numeric']['input']>;
  iv2?: InputMaybe<Scalars['numeric']['input']>;
  k3?: InputMaybe<Scalars['numeric']['input']>;
  length_inches?: InputMaybe<Scalars['numeric']['input']>;
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  mle_offset_depth_inches?: InputMaybe<Scalars['numeric']['input']>;
  n1?: InputMaybe<Scalars['numeric']['input']>;
  n2?: InputMaybe<Scalars['numeric']['input']>;
  n3?: InputMaybe<Scalars['numeric']['input']>;
  n4?: InputMaybe<Scalars['numeric']['input']>;
  n5?: InputMaybe<Scalars['numeric']['input']>;
  nameplate_current?: InputMaybe<Scalars['Int']['input']>;
  nameplate_horsepower?: InputMaybe<Scalars['Int']['input']>;
  nameplate_rerate_ratio?: InputMaybe<Scalars['numeric']['input']>;
  nameplate_voltage?: InputMaybe<Scalars['Int']['input']>;
  nb?: InputMaybe<Scalars['numeric']['input']>;
  neck_inner_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  neck_outer_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  nv0?: InputMaybe<Scalars['numeric']['input']>;
  nv1?: InputMaybe<Scalars['numeric']['input']>;
  nv2?: InputMaybe<Scalars['numeric']['input']>;
  oil_volume_gallons?: InputMaybe<Scalars['numeric']['input']>;
  only_ecopetrol_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  only_koc_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  outer_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  outer_diameter_rub_inches?: InputMaybe<Scalars['numeric']['input']>;
  part_number?: InputMaybe<Scalars['String']['input']>;
  pf1?: InputMaybe<Scalars['numeric']['input']>;
  pf2?: InputMaybe<Scalars['numeric']['input']>;
  pf3?: InputMaybe<Scalars['numeric']['input']>;
  pf4?: InputMaybe<Scalars['numeric']['input']>;
  pf5?: InputMaybe<Scalars['numeric']['input']>;
  pfb?: InputMaybe<Scalars['numeric']['input']>;
  pfv0?: InputMaybe<Scalars['numeric']['input']>;
  pfv1?: InputMaybe<Scalars['numeric']['input']>;
  pfv2?: InputMaybe<Scalars['numeric']['input']>;
  poles?: InputMaybe<Scalars['Int']['input']>;
  rr_l1?: InputMaybe<Scalars['numeric']['input']>;
  rr_l2?: InputMaybe<Scalars['numeric']['input']>;
  rr_lb?: InputMaybe<Scalars['numeric']['input']>;
  rr_v1?: InputMaybe<Scalars['numeric']['input']>;
  rr_v2?: InputMaybe<Scalars['numeric']['input']>;
  rr_v3?: InputMaybe<Scalars['numeric']['input']>;
  rr_vb?: InputMaybe<Scalars['numeric']['input']>;
  shaft_height_inches?: InputMaybe<Scalars['numeric']['input']>;
  shaft_horsepower?: InputMaybe<Scalars['Int']['input']>;
  stator_inner_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  stator_outer_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  temperature_rating_fahrenheit?: InputMaybe<Scalars['Int']['input']>;
  tv0?: InputMaybe<Scalars['numeric']['input']>;
  tv1?: InputMaybe<Scalars['numeric']['input']>;
  tv2?: InputMaybe<Scalars['numeric']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  weight_pounds?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate stddev on columns */
export type Motors_Stddev_Fields = {
  __typename: 'motors_stddev_fields';
  eff1?: Maybe<Scalars['Float']['output']>;
  eff2?: Maybe<Scalars['Float']['output']>;
  eff3?: Maybe<Scalars['Float']['output']>;
  eff4?: Maybe<Scalars['Float']['output']>;
  eff5?: Maybe<Scalars['Float']['output']>;
  effb?: Maybe<Scalars['Float']['output']>;
  effv0?: Maybe<Scalars['Float']['output']>;
  effv1?: Maybe<Scalars['Float']['output']>;
  effv2?: Maybe<Scalars['Float']['output']>;
  i1?: Maybe<Scalars['Float']['output']>;
  i2?: Maybe<Scalars['Float']['output']>;
  i3?: Maybe<Scalars['Float']['output']>;
  i4?: Maybe<Scalars['Float']['output']>;
  i5?: Maybe<Scalars['Float']['output']>;
  ib?: Maybe<Scalars['Float']['output']>;
  imported_sizing_id?: Maybe<Scalars['Float']['output']>;
  inner_diameter_inches?: Maybe<Scalars['Float']['output']>;
  iv0?: Maybe<Scalars['Float']['output']>;
  iv1?: Maybe<Scalars['Float']['output']>;
  iv2?: Maybe<Scalars['Float']['output']>;
  k3?: Maybe<Scalars['Float']['output']>;
  length_inches?: Maybe<Scalars['Float']['output']>;
  mle_offset_depth_inches?: Maybe<Scalars['Float']['output']>;
  n1?: Maybe<Scalars['Float']['output']>;
  n2?: Maybe<Scalars['Float']['output']>;
  n3?: Maybe<Scalars['Float']['output']>;
  n4?: Maybe<Scalars['Float']['output']>;
  n5?: Maybe<Scalars['Float']['output']>;
  nameplate_current?: Maybe<Scalars['Float']['output']>;
  nameplate_horsepower?: Maybe<Scalars['Float']['output']>;
  nameplate_rerate_ratio?: Maybe<Scalars['Float']['output']>;
  nameplate_voltage?: Maybe<Scalars['Float']['output']>;
  nb?: Maybe<Scalars['Float']['output']>;
  neck_inner_diameter_inches?: Maybe<Scalars['Float']['output']>;
  neck_outer_diameter_inches?: Maybe<Scalars['Float']['output']>;
  nv0?: Maybe<Scalars['Float']['output']>;
  nv1?: Maybe<Scalars['Float']['output']>;
  nv2?: Maybe<Scalars['Float']['output']>;
  oil_volume_gallons?: Maybe<Scalars['Float']['output']>;
  outer_diameter_inches?: Maybe<Scalars['Float']['output']>;
  outer_diameter_rub_inches?: Maybe<Scalars['Float']['output']>;
  pf1?: Maybe<Scalars['Float']['output']>;
  pf2?: Maybe<Scalars['Float']['output']>;
  pf3?: Maybe<Scalars['Float']['output']>;
  pf4?: Maybe<Scalars['Float']['output']>;
  pf5?: Maybe<Scalars['Float']['output']>;
  pfb?: Maybe<Scalars['Float']['output']>;
  pfv0?: Maybe<Scalars['Float']['output']>;
  pfv1?: Maybe<Scalars['Float']['output']>;
  pfv2?: Maybe<Scalars['Float']['output']>;
  poles?: Maybe<Scalars['Float']['output']>;
  rr_l1?: Maybe<Scalars['Float']['output']>;
  rr_l2?: Maybe<Scalars['Float']['output']>;
  rr_lb?: Maybe<Scalars['Float']['output']>;
  rr_v1?: Maybe<Scalars['Float']['output']>;
  rr_v2?: Maybe<Scalars['Float']['output']>;
  rr_v3?: Maybe<Scalars['Float']['output']>;
  rr_vb?: Maybe<Scalars['Float']['output']>;
  shaft_height_inches?: Maybe<Scalars['Float']['output']>;
  shaft_horsepower?: Maybe<Scalars['Float']['output']>;
  stator_inner_diameter_inches?: Maybe<Scalars['Float']['output']>;
  stator_outer_diameter_inches?: Maybe<Scalars['Float']['output']>;
  temperature_rating_fahrenheit?: Maybe<Scalars['Float']['output']>;
  tv0?: Maybe<Scalars['Float']['output']>;
  tv1?: Maybe<Scalars['Float']['output']>;
  tv2?: Maybe<Scalars['Float']['output']>;
  weight_pounds?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "motors" */
export type Motors_Stddev_Order_By = {
  eff1?: InputMaybe<Order_By>;
  eff2?: InputMaybe<Order_By>;
  eff3?: InputMaybe<Order_By>;
  eff4?: InputMaybe<Order_By>;
  eff5?: InputMaybe<Order_By>;
  effb?: InputMaybe<Order_By>;
  effv0?: InputMaybe<Order_By>;
  effv1?: InputMaybe<Order_By>;
  effv2?: InputMaybe<Order_By>;
  i1?: InputMaybe<Order_By>;
  i2?: InputMaybe<Order_By>;
  i3?: InputMaybe<Order_By>;
  i4?: InputMaybe<Order_By>;
  i5?: InputMaybe<Order_By>;
  ib?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  inner_diameter_inches?: InputMaybe<Order_By>;
  iv0?: InputMaybe<Order_By>;
  iv1?: InputMaybe<Order_By>;
  iv2?: InputMaybe<Order_By>;
  k3?: InputMaybe<Order_By>;
  length_inches?: InputMaybe<Order_By>;
  mle_offset_depth_inches?: InputMaybe<Order_By>;
  n1?: InputMaybe<Order_By>;
  n2?: InputMaybe<Order_By>;
  n3?: InputMaybe<Order_By>;
  n4?: InputMaybe<Order_By>;
  n5?: InputMaybe<Order_By>;
  nameplate_current?: InputMaybe<Order_By>;
  nameplate_horsepower?: InputMaybe<Order_By>;
  nameplate_rerate_ratio?: InputMaybe<Order_By>;
  nameplate_voltage?: InputMaybe<Order_By>;
  nb?: InputMaybe<Order_By>;
  neck_inner_diameter_inches?: InputMaybe<Order_By>;
  neck_outer_diameter_inches?: InputMaybe<Order_By>;
  nv0?: InputMaybe<Order_By>;
  nv1?: InputMaybe<Order_By>;
  nv2?: InputMaybe<Order_By>;
  oil_volume_gallons?: InputMaybe<Order_By>;
  outer_diameter_inches?: InputMaybe<Order_By>;
  outer_diameter_rub_inches?: InputMaybe<Order_By>;
  pf1?: InputMaybe<Order_By>;
  pf2?: InputMaybe<Order_By>;
  pf3?: InputMaybe<Order_By>;
  pf4?: InputMaybe<Order_By>;
  pf5?: InputMaybe<Order_By>;
  pfb?: InputMaybe<Order_By>;
  pfv0?: InputMaybe<Order_By>;
  pfv1?: InputMaybe<Order_By>;
  pfv2?: InputMaybe<Order_By>;
  poles?: InputMaybe<Order_By>;
  rr_l1?: InputMaybe<Order_By>;
  rr_l2?: InputMaybe<Order_By>;
  rr_lb?: InputMaybe<Order_By>;
  rr_v1?: InputMaybe<Order_By>;
  rr_v2?: InputMaybe<Order_By>;
  rr_v3?: InputMaybe<Order_By>;
  rr_vb?: InputMaybe<Order_By>;
  shaft_height_inches?: InputMaybe<Order_By>;
  shaft_horsepower?: InputMaybe<Order_By>;
  stator_inner_diameter_inches?: InputMaybe<Order_By>;
  stator_outer_diameter_inches?: InputMaybe<Order_By>;
  temperature_rating_fahrenheit?: InputMaybe<Order_By>;
  tv0?: InputMaybe<Order_By>;
  tv1?: InputMaybe<Order_By>;
  tv2?: InputMaybe<Order_By>;
  weight_pounds?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Motors_Stddev_Pop_Fields = {
  __typename: 'motors_stddev_pop_fields';
  eff1?: Maybe<Scalars['Float']['output']>;
  eff2?: Maybe<Scalars['Float']['output']>;
  eff3?: Maybe<Scalars['Float']['output']>;
  eff4?: Maybe<Scalars['Float']['output']>;
  eff5?: Maybe<Scalars['Float']['output']>;
  effb?: Maybe<Scalars['Float']['output']>;
  effv0?: Maybe<Scalars['Float']['output']>;
  effv1?: Maybe<Scalars['Float']['output']>;
  effv2?: Maybe<Scalars['Float']['output']>;
  i1?: Maybe<Scalars['Float']['output']>;
  i2?: Maybe<Scalars['Float']['output']>;
  i3?: Maybe<Scalars['Float']['output']>;
  i4?: Maybe<Scalars['Float']['output']>;
  i5?: Maybe<Scalars['Float']['output']>;
  ib?: Maybe<Scalars['Float']['output']>;
  imported_sizing_id?: Maybe<Scalars['Float']['output']>;
  inner_diameter_inches?: Maybe<Scalars['Float']['output']>;
  iv0?: Maybe<Scalars['Float']['output']>;
  iv1?: Maybe<Scalars['Float']['output']>;
  iv2?: Maybe<Scalars['Float']['output']>;
  k3?: Maybe<Scalars['Float']['output']>;
  length_inches?: Maybe<Scalars['Float']['output']>;
  mle_offset_depth_inches?: Maybe<Scalars['Float']['output']>;
  n1?: Maybe<Scalars['Float']['output']>;
  n2?: Maybe<Scalars['Float']['output']>;
  n3?: Maybe<Scalars['Float']['output']>;
  n4?: Maybe<Scalars['Float']['output']>;
  n5?: Maybe<Scalars['Float']['output']>;
  nameplate_current?: Maybe<Scalars['Float']['output']>;
  nameplate_horsepower?: Maybe<Scalars['Float']['output']>;
  nameplate_rerate_ratio?: Maybe<Scalars['Float']['output']>;
  nameplate_voltage?: Maybe<Scalars['Float']['output']>;
  nb?: Maybe<Scalars['Float']['output']>;
  neck_inner_diameter_inches?: Maybe<Scalars['Float']['output']>;
  neck_outer_diameter_inches?: Maybe<Scalars['Float']['output']>;
  nv0?: Maybe<Scalars['Float']['output']>;
  nv1?: Maybe<Scalars['Float']['output']>;
  nv2?: Maybe<Scalars['Float']['output']>;
  oil_volume_gallons?: Maybe<Scalars['Float']['output']>;
  outer_diameter_inches?: Maybe<Scalars['Float']['output']>;
  outer_diameter_rub_inches?: Maybe<Scalars['Float']['output']>;
  pf1?: Maybe<Scalars['Float']['output']>;
  pf2?: Maybe<Scalars['Float']['output']>;
  pf3?: Maybe<Scalars['Float']['output']>;
  pf4?: Maybe<Scalars['Float']['output']>;
  pf5?: Maybe<Scalars['Float']['output']>;
  pfb?: Maybe<Scalars['Float']['output']>;
  pfv0?: Maybe<Scalars['Float']['output']>;
  pfv1?: Maybe<Scalars['Float']['output']>;
  pfv2?: Maybe<Scalars['Float']['output']>;
  poles?: Maybe<Scalars['Float']['output']>;
  rr_l1?: Maybe<Scalars['Float']['output']>;
  rr_l2?: Maybe<Scalars['Float']['output']>;
  rr_lb?: Maybe<Scalars['Float']['output']>;
  rr_v1?: Maybe<Scalars['Float']['output']>;
  rr_v2?: Maybe<Scalars['Float']['output']>;
  rr_v3?: Maybe<Scalars['Float']['output']>;
  rr_vb?: Maybe<Scalars['Float']['output']>;
  shaft_height_inches?: Maybe<Scalars['Float']['output']>;
  shaft_horsepower?: Maybe<Scalars['Float']['output']>;
  stator_inner_diameter_inches?: Maybe<Scalars['Float']['output']>;
  stator_outer_diameter_inches?: Maybe<Scalars['Float']['output']>;
  temperature_rating_fahrenheit?: Maybe<Scalars['Float']['output']>;
  tv0?: Maybe<Scalars['Float']['output']>;
  tv1?: Maybe<Scalars['Float']['output']>;
  tv2?: Maybe<Scalars['Float']['output']>;
  weight_pounds?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "motors" */
export type Motors_Stddev_Pop_Order_By = {
  eff1?: InputMaybe<Order_By>;
  eff2?: InputMaybe<Order_By>;
  eff3?: InputMaybe<Order_By>;
  eff4?: InputMaybe<Order_By>;
  eff5?: InputMaybe<Order_By>;
  effb?: InputMaybe<Order_By>;
  effv0?: InputMaybe<Order_By>;
  effv1?: InputMaybe<Order_By>;
  effv2?: InputMaybe<Order_By>;
  i1?: InputMaybe<Order_By>;
  i2?: InputMaybe<Order_By>;
  i3?: InputMaybe<Order_By>;
  i4?: InputMaybe<Order_By>;
  i5?: InputMaybe<Order_By>;
  ib?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  inner_diameter_inches?: InputMaybe<Order_By>;
  iv0?: InputMaybe<Order_By>;
  iv1?: InputMaybe<Order_By>;
  iv2?: InputMaybe<Order_By>;
  k3?: InputMaybe<Order_By>;
  length_inches?: InputMaybe<Order_By>;
  mle_offset_depth_inches?: InputMaybe<Order_By>;
  n1?: InputMaybe<Order_By>;
  n2?: InputMaybe<Order_By>;
  n3?: InputMaybe<Order_By>;
  n4?: InputMaybe<Order_By>;
  n5?: InputMaybe<Order_By>;
  nameplate_current?: InputMaybe<Order_By>;
  nameplate_horsepower?: InputMaybe<Order_By>;
  nameplate_rerate_ratio?: InputMaybe<Order_By>;
  nameplate_voltage?: InputMaybe<Order_By>;
  nb?: InputMaybe<Order_By>;
  neck_inner_diameter_inches?: InputMaybe<Order_By>;
  neck_outer_diameter_inches?: InputMaybe<Order_By>;
  nv0?: InputMaybe<Order_By>;
  nv1?: InputMaybe<Order_By>;
  nv2?: InputMaybe<Order_By>;
  oil_volume_gallons?: InputMaybe<Order_By>;
  outer_diameter_inches?: InputMaybe<Order_By>;
  outer_diameter_rub_inches?: InputMaybe<Order_By>;
  pf1?: InputMaybe<Order_By>;
  pf2?: InputMaybe<Order_By>;
  pf3?: InputMaybe<Order_By>;
  pf4?: InputMaybe<Order_By>;
  pf5?: InputMaybe<Order_By>;
  pfb?: InputMaybe<Order_By>;
  pfv0?: InputMaybe<Order_By>;
  pfv1?: InputMaybe<Order_By>;
  pfv2?: InputMaybe<Order_By>;
  poles?: InputMaybe<Order_By>;
  rr_l1?: InputMaybe<Order_By>;
  rr_l2?: InputMaybe<Order_By>;
  rr_lb?: InputMaybe<Order_By>;
  rr_v1?: InputMaybe<Order_By>;
  rr_v2?: InputMaybe<Order_By>;
  rr_v3?: InputMaybe<Order_By>;
  rr_vb?: InputMaybe<Order_By>;
  shaft_height_inches?: InputMaybe<Order_By>;
  shaft_horsepower?: InputMaybe<Order_By>;
  stator_inner_diameter_inches?: InputMaybe<Order_By>;
  stator_outer_diameter_inches?: InputMaybe<Order_By>;
  temperature_rating_fahrenheit?: InputMaybe<Order_By>;
  tv0?: InputMaybe<Order_By>;
  tv1?: InputMaybe<Order_By>;
  tv2?: InputMaybe<Order_By>;
  weight_pounds?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Motors_Stddev_Samp_Fields = {
  __typename: 'motors_stddev_samp_fields';
  eff1?: Maybe<Scalars['Float']['output']>;
  eff2?: Maybe<Scalars['Float']['output']>;
  eff3?: Maybe<Scalars['Float']['output']>;
  eff4?: Maybe<Scalars['Float']['output']>;
  eff5?: Maybe<Scalars['Float']['output']>;
  effb?: Maybe<Scalars['Float']['output']>;
  effv0?: Maybe<Scalars['Float']['output']>;
  effv1?: Maybe<Scalars['Float']['output']>;
  effv2?: Maybe<Scalars['Float']['output']>;
  i1?: Maybe<Scalars['Float']['output']>;
  i2?: Maybe<Scalars['Float']['output']>;
  i3?: Maybe<Scalars['Float']['output']>;
  i4?: Maybe<Scalars['Float']['output']>;
  i5?: Maybe<Scalars['Float']['output']>;
  ib?: Maybe<Scalars['Float']['output']>;
  imported_sizing_id?: Maybe<Scalars['Float']['output']>;
  inner_diameter_inches?: Maybe<Scalars['Float']['output']>;
  iv0?: Maybe<Scalars['Float']['output']>;
  iv1?: Maybe<Scalars['Float']['output']>;
  iv2?: Maybe<Scalars['Float']['output']>;
  k3?: Maybe<Scalars['Float']['output']>;
  length_inches?: Maybe<Scalars['Float']['output']>;
  mle_offset_depth_inches?: Maybe<Scalars['Float']['output']>;
  n1?: Maybe<Scalars['Float']['output']>;
  n2?: Maybe<Scalars['Float']['output']>;
  n3?: Maybe<Scalars['Float']['output']>;
  n4?: Maybe<Scalars['Float']['output']>;
  n5?: Maybe<Scalars['Float']['output']>;
  nameplate_current?: Maybe<Scalars['Float']['output']>;
  nameplate_horsepower?: Maybe<Scalars['Float']['output']>;
  nameplate_rerate_ratio?: Maybe<Scalars['Float']['output']>;
  nameplate_voltage?: Maybe<Scalars['Float']['output']>;
  nb?: Maybe<Scalars['Float']['output']>;
  neck_inner_diameter_inches?: Maybe<Scalars['Float']['output']>;
  neck_outer_diameter_inches?: Maybe<Scalars['Float']['output']>;
  nv0?: Maybe<Scalars['Float']['output']>;
  nv1?: Maybe<Scalars['Float']['output']>;
  nv2?: Maybe<Scalars['Float']['output']>;
  oil_volume_gallons?: Maybe<Scalars['Float']['output']>;
  outer_diameter_inches?: Maybe<Scalars['Float']['output']>;
  outer_diameter_rub_inches?: Maybe<Scalars['Float']['output']>;
  pf1?: Maybe<Scalars['Float']['output']>;
  pf2?: Maybe<Scalars['Float']['output']>;
  pf3?: Maybe<Scalars['Float']['output']>;
  pf4?: Maybe<Scalars['Float']['output']>;
  pf5?: Maybe<Scalars['Float']['output']>;
  pfb?: Maybe<Scalars['Float']['output']>;
  pfv0?: Maybe<Scalars['Float']['output']>;
  pfv1?: Maybe<Scalars['Float']['output']>;
  pfv2?: Maybe<Scalars['Float']['output']>;
  poles?: Maybe<Scalars['Float']['output']>;
  rr_l1?: Maybe<Scalars['Float']['output']>;
  rr_l2?: Maybe<Scalars['Float']['output']>;
  rr_lb?: Maybe<Scalars['Float']['output']>;
  rr_v1?: Maybe<Scalars['Float']['output']>;
  rr_v2?: Maybe<Scalars['Float']['output']>;
  rr_v3?: Maybe<Scalars['Float']['output']>;
  rr_vb?: Maybe<Scalars['Float']['output']>;
  shaft_height_inches?: Maybe<Scalars['Float']['output']>;
  shaft_horsepower?: Maybe<Scalars['Float']['output']>;
  stator_inner_diameter_inches?: Maybe<Scalars['Float']['output']>;
  stator_outer_diameter_inches?: Maybe<Scalars['Float']['output']>;
  temperature_rating_fahrenheit?: Maybe<Scalars['Float']['output']>;
  tv0?: Maybe<Scalars['Float']['output']>;
  tv1?: Maybe<Scalars['Float']['output']>;
  tv2?: Maybe<Scalars['Float']['output']>;
  weight_pounds?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "motors" */
export type Motors_Stddev_Samp_Order_By = {
  eff1?: InputMaybe<Order_By>;
  eff2?: InputMaybe<Order_By>;
  eff3?: InputMaybe<Order_By>;
  eff4?: InputMaybe<Order_By>;
  eff5?: InputMaybe<Order_By>;
  effb?: InputMaybe<Order_By>;
  effv0?: InputMaybe<Order_By>;
  effv1?: InputMaybe<Order_By>;
  effv2?: InputMaybe<Order_By>;
  i1?: InputMaybe<Order_By>;
  i2?: InputMaybe<Order_By>;
  i3?: InputMaybe<Order_By>;
  i4?: InputMaybe<Order_By>;
  i5?: InputMaybe<Order_By>;
  ib?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  inner_diameter_inches?: InputMaybe<Order_By>;
  iv0?: InputMaybe<Order_By>;
  iv1?: InputMaybe<Order_By>;
  iv2?: InputMaybe<Order_By>;
  k3?: InputMaybe<Order_By>;
  length_inches?: InputMaybe<Order_By>;
  mle_offset_depth_inches?: InputMaybe<Order_By>;
  n1?: InputMaybe<Order_By>;
  n2?: InputMaybe<Order_By>;
  n3?: InputMaybe<Order_By>;
  n4?: InputMaybe<Order_By>;
  n5?: InputMaybe<Order_By>;
  nameplate_current?: InputMaybe<Order_By>;
  nameplate_horsepower?: InputMaybe<Order_By>;
  nameplate_rerate_ratio?: InputMaybe<Order_By>;
  nameplate_voltage?: InputMaybe<Order_By>;
  nb?: InputMaybe<Order_By>;
  neck_inner_diameter_inches?: InputMaybe<Order_By>;
  neck_outer_diameter_inches?: InputMaybe<Order_By>;
  nv0?: InputMaybe<Order_By>;
  nv1?: InputMaybe<Order_By>;
  nv2?: InputMaybe<Order_By>;
  oil_volume_gallons?: InputMaybe<Order_By>;
  outer_diameter_inches?: InputMaybe<Order_By>;
  outer_diameter_rub_inches?: InputMaybe<Order_By>;
  pf1?: InputMaybe<Order_By>;
  pf2?: InputMaybe<Order_By>;
  pf3?: InputMaybe<Order_By>;
  pf4?: InputMaybe<Order_By>;
  pf5?: InputMaybe<Order_By>;
  pfb?: InputMaybe<Order_By>;
  pfv0?: InputMaybe<Order_By>;
  pfv1?: InputMaybe<Order_By>;
  pfv2?: InputMaybe<Order_By>;
  poles?: InputMaybe<Order_By>;
  rr_l1?: InputMaybe<Order_By>;
  rr_l2?: InputMaybe<Order_By>;
  rr_lb?: InputMaybe<Order_By>;
  rr_v1?: InputMaybe<Order_By>;
  rr_v2?: InputMaybe<Order_By>;
  rr_v3?: InputMaybe<Order_By>;
  rr_vb?: InputMaybe<Order_By>;
  shaft_height_inches?: InputMaybe<Order_By>;
  shaft_horsepower?: InputMaybe<Order_By>;
  stator_inner_diameter_inches?: InputMaybe<Order_By>;
  stator_outer_diameter_inches?: InputMaybe<Order_By>;
  temperature_rating_fahrenheit?: InputMaybe<Order_By>;
  tv0?: InputMaybe<Order_By>;
  tv1?: InputMaybe<Order_By>;
  tv2?: InputMaybe<Order_By>;
  weight_pounds?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "motors" */
export type Motors_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Motors_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Motors_Stream_Cursor_Value_Input = {
  allow_rerate?: InputMaybe<Scalars['Boolean']['input']>;
  author_id?: InputMaybe<Scalars['String']['input']>;
  configuration?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  eff1?: InputMaybe<Scalars['numeric']['input']>;
  eff2?: InputMaybe<Scalars['numeric']['input']>;
  eff3?: InputMaybe<Scalars['numeric']['input']>;
  eff4?: InputMaybe<Scalars['numeric']['input']>;
  eff5?: InputMaybe<Scalars['numeric']['input']>;
  effb?: InputMaybe<Scalars['numeric']['input']>;
  effv0?: InputMaybe<Scalars['numeric']['input']>;
  effv1?: InputMaybe<Scalars['numeric']['input']>;
  effv2?: InputMaybe<Scalars['numeric']['input']>;
  i1?: InputMaybe<Scalars['numeric']['input']>;
  i2?: InputMaybe<Scalars['numeric']['input']>;
  i3?: InputMaybe<Scalars['numeric']['input']>;
  i4?: InputMaybe<Scalars['numeric']['input']>;
  i5?: InputMaybe<Scalars['numeric']['input']>;
  ib?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  imported_sizing_id?: InputMaybe<Scalars['Int']['input']>;
  include_ecopetrol_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  include_koc_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  inner_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  is_hps?: InputMaybe<Scalars['Boolean']['input']>;
  iv0?: InputMaybe<Scalars['numeric']['input']>;
  iv1?: InputMaybe<Scalars['numeric']['input']>;
  iv2?: InputMaybe<Scalars['numeric']['input']>;
  k3?: InputMaybe<Scalars['numeric']['input']>;
  length_inches?: InputMaybe<Scalars['numeric']['input']>;
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  mle_offset_depth_inches?: InputMaybe<Scalars['numeric']['input']>;
  n1?: InputMaybe<Scalars['numeric']['input']>;
  n2?: InputMaybe<Scalars['numeric']['input']>;
  n3?: InputMaybe<Scalars['numeric']['input']>;
  n4?: InputMaybe<Scalars['numeric']['input']>;
  n5?: InputMaybe<Scalars['numeric']['input']>;
  nameplate_current?: InputMaybe<Scalars['Int']['input']>;
  nameplate_horsepower?: InputMaybe<Scalars['Int']['input']>;
  nameplate_rerate_ratio?: InputMaybe<Scalars['numeric']['input']>;
  nameplate_voltage?: InputMaybe<Scalars['Int']['input']>;
  nb?: InputMaybe<Scalars['numeric']['input']>;
  neck_inner_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  neck_outer_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  nv0?: InputMaybe<Scalars['numeric']['input']>;
  nv1?: InputMaybe<Scalars['numeric']['input']>;
  nv2?: InputMaybe<Scalars['numeric']['input']>;
  oil_volume_gallons?: InputMaybe<Scalars['numeric']['input']>;
  only_ecopetrol_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  only_koc_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  outer_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  outer_diameter_rub_inches?: InputMaybe<Scalars['numeric']['input']>;
  part_number?: InputMaybe<Scalars['String']['input']>;
  pf1?: InputMaybe<Scalars['numeric']['input']>;
  pf2?: InputMaybe<Scalars['numeric']['input']>;
  pf3?: InputMaybe<Scalars['numeric']['input']>;
  pf4?: InputMaybe<Scalars['numeric']['input']>;
  pf5?: InputMaybe<Scalars['numeric']['input']>;
  pfb?: InputMaybe<Scalars['numeric']['input']>;
  pfv0?: InputMaybe<Scalars['numeric']['input']>;
  pfv1?: InputMaybe<Scalars['numeric']['input']>;
  pfv2?: InputMaybe<Scalars['numeric']['input']>;
  poles?: InputMaybe<Scalars['Int']['input']>;
  rr_l1?: InputMaybe<Scalars['numeric']['input']>;
  rr_l2?: InputMaybe<Scalars['numeric']['input']>;
  rr_lb?: InputMaybe<Scalars['numeric']['input']>;
  rr_v1?: InputMaybe<Scalars['numeric']['input']>;
  rr_v2?: InputMaybe<Scalars['numeric']['input']>;
  rr_v3?: InputMaybe<Scalars['numeric']['input']>;
  rr_vb?: InputMaybe<Scalars['numeric']['input']>;
  shaft_height_inches?: InputMaybe<Scalars['numeric']['input']>;
  shaft_horsepower?: InputMaybe<Scalars['Int']['input']>;
  stator_inner_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  stator_outer_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  temperature_rating_fahrenheit?: InputMaybe<Scalars['Int']['input']>;
  tv0?: InputMaybe<Scalars['numeric']['input']>;
  tv1?: InputMaybe<Scalars['numeric']['input']>;
  tv2?: InputMaybe<Scalars['numeric']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  weight_pounds?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate sum on columns */
export type Motors_Sum_Fields = {
  __typename: 'motors_sum_fields';
  eff1?: Maybe<Scalars['numeric']['output']>;
  eff2?: Maybe<Scalars['numeric']['output']>;
  eff3?: Maybe<Scalars['numeric']['output']>;
  eff4?: Maybe<Scalars['numeric']['output']>;
  eff5?: Maybe<Scalars['numeric']['output']>;
  effb?: Maybe<Scalars['numeric']['output']>;
  effv0?: Maybe<Scalars['numeric']['output']>;
  effv1?: Maybe<Scalars['numeric']['output']>;
  effv2?: Maybe<Scalars['numeric']['output']>;
  i1?: Maybe<Scalars['numeric']['output']>;
  i2?: Maybe<Scalars['numeric']['output']>;
  i3?: Maybe<Scalars['numeric']['output']>;
  i4?: Maybe<Scalars['numeric']['output']>;
  i5?: Maybe<Scalars['numeric']['output']>;
  ib?: Maybe<Scalars['numeric']['output']>;
  imported_sizing_id?: Maybe<Scalars['Int']['output']>;
  inner_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  iv0?: Maybe<Scalars['numeric']['output']>;
  iv1?: Maybe<Scalars['numeric']['output']>;
  iv2?: Maybe<Scalars['numeric']['output']>;
  k3?: Maybe<Scalars['numeric']['output']>;
  length_inches?: Maybe<Scalars['numeric']['output']>;
  mle_offset_depth_inches?: Maybe<Scalars['numeric']['output']>;
  n1?: Maybe<Scalars['numeric']['output']>;
  n2?: Maybe<Scalars['numeric']['output']>;
  n3?: Maybe<Scalars['numeric']['output']>;
  n4?: Maybe<Scalars['numeric']['output']>;
  n5?: Maybe<Scalars['numeric']['output']>;
  nameplate_current?: Maybe<Scalars['Int']['output']>;
  nameplate_horsepower?: Maybe<Scalars['Int']['output']>;
  nameplate_rerate_ratio?: Maybe<Scalars['numeric']['output']>;
  nameplate_voltage?: Maybe<Scalars['Int']['output']>;
  nb?: Maybe<Scalars['numeric']['output']>;
  neck_inner_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  neck_outer_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  nv0?: Maybe<Scalars['numeric']['output']>;
  nv1?: Maybe<Scalars['numeric']['output']>;
  nv2?: Maybe<Scalars['numeric']['output']>;
  oil_volume_gallons?: Maybe<Scalars['numeric']['output']>;
  outer_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  outer_diameter_rub_inches?: Maybe<Scalars['numeric']['output']>;
  pf1?: Maybe<Scalars['numeric']['output']>;
  pf2?: Maybe<Scalars['numeric']['output']>;
  pf3?: Maybe<Scalars['numeric']['output']>;
  pf4?: Maybe<Scalars['numeric']['output']>;
  pf5?: Maybe<Scalars['numeric']['output']>;
  pfb?: Maybe<Scalars['numeric']['output']>;
  pfv0?: Maybe<Scalars['numeric']['output']>;
  pfv1?: Maybe<Scalars['numeric']['output']>;
  pfv2?: Maybe<Scalars['numeric']['output']>;
  poles?: Maybe<Scalars['Int']['output']>;
  rr_l1?: Maybe<Scalars['numeric']['output']>;
  rr_l2?: Maybe<Scalars['numeric']['output']>;
  rr_lb?: Maybe<Scalars['numeric']['output']>;
  rr_v1?: Maybe<Scalars['numeric']['output']>;
  rr_v2?: Maybe<Scalars['numeric']['output']>;
  rr_v3?: Maybe<Scalars['numeric']['output']>;
  rr_vb?: Maybe<Scalars['numeric']['output']>;
  shaft_height_inches?: Maybe<Scalars['numeric']['output']>;
  shaft_horsepower?: Maybe<Scalars['Int']['output']>;
  stator_inner_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  stator_outer_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  temperature_rating_fahrenheit?: Maybe<Scalars['Int']['output']>;
  tv0?: Maybe<Scalars['numeric']['output']>;
  tv1?: Maybe<Scalars['numeric']['output']>;
  tv2?: Maybe<Scalars['numeric']['output']>;
  weight_pounds?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "motors" */
export type Motors_Sum_Order_By = {
  eff1?: InputMaybe<Order_By>;
  eff2?: InputMaybe<Order_By>;
  eff3?: InputMaybe<Order_By>;
  eff4?: InputMaybe<Order_By>;
  eff5?: InputMaybe<Order_By>;
  effb?: InputMaybe<Order_By>;
  effv0?: InputMaybe<Order_By>;
  effv1?: InputMaybe<Order_By>;
  effv2?: InputMaybe<Order_By>;
  i1?: InputMaybe<Order_By>;
  i2?: InputMaybe<Order_By>;
  i3?: InputMaybe<Order_By>;
  i4?: InputMaybe<Order_By>;
  i5?: InputMaybe<Order_By>;
  ib?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  inner_diameter_inches?: InputMaybe<Order_By>;
  iv0?: InputMaybe<Order_By>;
  iv1?: InputMaybe<Order_By>;
  iv2?: InputMaybe<Order_By>;
  k3?: InputMaybe<Order_By>;
  length_inches?: InputMaybe<Order_By>;
  mle_offset_depth_inches?: InputMaybe<Order_By>;
  n1?: InputMaybe<Order_By>;
  n2?: InputMaybe<Order_By>;
  n3?: InputMaybe<Order_By>;
  n4?: InputMaybe<Order_By>;
  n5?: InputMaybe<Order_By>;
  nameplate_current?: InputMaybe<Order_By>;
  nameplate_horsepower?: InputMaybe<Order_By>;
  nameplate_rerate_ratio?: InputMaybe<Order_By>;
  nameplate_voltage?: InputMaybe<Order_By>;
  nb?: InputMaybe<Order_By>;
  neck_inner_diameter_inches?: InputMaybe<Order_By>;
  neck_outer_diameter_inches?: InputMaybe<Order_By>;
  nv0?: InputMaybe<Order_By>;
  nv1?: InputMaybe<Order_By>;
  nv2?: InputMaybe<Order_By>;
  oil_volume_gallons?: InputMaybe<Order_By>;
  outer_diameter_inches?: InputMaybe<Order_By>;
  outer_diameter_rub_inches?: InputMaybe<Order_By>;
  pf1?: InputMaybe<Order_By>;
  pf2?: InputMaybe<Order_By>;
  pf3?: InputMaybe<Order_By>;
  pf4?: InputMaybe<Order_By>;
  pf5?: InputMaybe<Order_By>;
  pfb?: InputMaybe<Order_By>;
  pfv0?: InputMaybe<Order_By>;
  pfv1?: InputMaybe<Order_By>;
  pfv2?: InputMaybe<Order_By>;
  poles?: InputMaybe<Order_By>;
  rr_l1?: InputMaybe<Order_By>;
  rr_l2?: InputMaybe<Order_By>;
  rr_lb?: InputMaybe<Order_By>;
  rr_v1?: InputMaybe<Order_By>;
  rr_v2?: InputMaybe<Order_By>;
  rr_v3?: InputMaybe<Order_By>;
  rr_vb?: InputMaybe<Order_By>;
  shaft_height_inches?: InputMaybe<Order_By>;
  shaft_horsepower?: InputMaybe<Order_By>;
  stator_inner_diameter_inches?: InputMaybe<Order_By>;
  stator_outer_diameter_inches?: InputMaybe<Order_By>;
  temperature_rating_fahrenheit?: InputMaybe<Order_By>;
  tv0?: InputMaybe<Order_By>;
  tv1?: InputMaybe<Order_By>;
  tv2?: InputMaybe<Order_By>;
  weight_pounds?: InputMaybe<Order_By>;
};

/** update columns of table "motors" */
export enum Motors_Update_Column {
  /** column name */
  AllowRerate = 'allow_rerate',
  /** column name */
  AuthorId = 'author_id',
  /** column name */
  Configuration = 'configuration',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Eff1 = 'eff1',
  /** column name */
  Eff2 = 'eff2',
  /** column name */
  Eff3 = 'eff3',
  /** column name */
  Eff4 = 'eff4',
  /** column name */
  Eff5 = 'eff5',
  /** column name */
  Effb = 'effb',
  /** column name */
  Effv0 = 'effv0',
  /** column name */
  Effv1 = 'effv1',
  /** column name */
  Effv2 = 'effv2',
  /** column name */
  I1 = 'i1',
  /** column name */
  I2 = 'i2',
  /** column name */
  I3 = 'i3',
  /** column name */
  I4 = 'i4',
  /** column name */
  I5 = 'i5',
  /** column name */
  Ib = 'ib',
  /** column name */
  Id = 'id',
  /** column name */
  ImportedSizingId = 'imported_sizing_id',
  /** column name */
  IncludeEcopetrolTimestamp = 'include_ecopetrol_timestamp',
  /** column name */
  IncludeKocTimestamp = 'include_koc_timestamp',
  /** column name */
  InnerDiameterInches = 'inner_diameter_inches',
  /** column name */
  IsHps = 'is_hps',
  /** column name */
  Iv0 = 'iv0',
  /** column name */
  Iv1 = 'iv1',
  /** column name */
  Iv2 = 'iv2',
  /** column name */
  K3 = 'k3',
  /** column name */
  LengthInches = 'length_inches',
  /** column name */
  Manufacturer = 'manufacturer',
  /** column name */
  MleOffsetDepthInches = 'mle_offset_depth_inches',
  /** column name */
  N1 = 'n1',
  /** column name */
  N2 = 'n2',
  /** column name */
  N3 = 'n3',
  /** column name */
  N4 = 'n4',
  /** column name */
  N5 = 'n5',
  /** column name */
  NameplateCurrent = 'nameplate_current',
  /** column name */
  NameplateHorsepower = 'nameplate_horsepower',
  /** column name */
  NameplateRerateRatio = 'nameplate_rerate_ratio',
  /** column name */
  NameplateVoltage = 'nameplate_voltage',
  /** column name */
  Nb = 'nb',
  /** column name */
  NeckInnerDiameterInches = 'neck_inner_diameter_inches',
  /** column name */
  NeckOuterDiameterInches = 'neck_outer_diameter_inches',
  /** column name */
  Nv0 = 'nv0',
  /** column name */
  Nv1 = 'nv1',
  /** column name */
  Nv2 = 'nv2',
  /** column name */
  OilVolumeGallons = 'oil_volume_gallons',
  /** column name */
  OnlyEcopetrolTimestamp = 'only_ecopetrol_timestamp',
  /** column name */
  OnlyKocTimestamp = 'only_koc_timestamp',
  /** column name */
  OuterDiameterInches = 'outer_diameter_inches',
  /** column name */
  OuterDiameterRubInches = 'outer_diameter_rub_inches',
  /** column name */
  PartNumber = 'part_number',
  /** column name */
  Pf1 = 'pf1',
  /** column name */
  Pf2 = 'pf2',
  /** column name */
  Pf3 = 'pf3',
  /** column name */
  Pf4 = 'pf4',
  /** column name */
  Pf5 = 'pf5',
  /** column name */
  Pfb = 'pfb',
  /** column name */
  Pfv0 = 'pfv0',
  /** column name */
  Pfv1 = 'pfv1',
  /** column name */
  Pfv2 = 'pfv2',
  /** column name */
  Poles = 'poles',
  /** column name */
  RrL1 = 'rr_l1',
  /** column name */
  RrL2 = 'rr_l2',
  /** column name */
  RrLb = 'rr_lb',
  /** column name */
  RrV1 = 'rr_v1',
  /** column name */
  RrV2 = 'rr_v2',
  /** column name */
  RrV3 = 'rr_v3',
  /** column name */
  RrVb = 'rr_vb',
  /** column name */
  ShaftHeightInches = 'shaft_height_inches',
  /** column name */
  ShaftHorsepower = 'shaft_horsepower',
  /** column name */
  StatorInnerDiameterInches = 'stator_inner_diameter_inches',
  /** column name */
  StatorOuterDiameterInches = 'stator_outer_diameter_inches',
  /** column name */
  TemperatureRatingFahrenheit = 'temperature_rating_fahrenheit',
  /** column name */
  Tv0 = 'tv0',
  /** column name */
  Tv1 = 'tv1',
  /** column name */
  Tv2 = 'tv2',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WeightPounds = 'weight_pounds'
}

export type Motors_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Motors_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Motors_Set_Input>;
  /** filter the rows which have to be updated */
  where: Motors_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Motors_Var_Pop_Fields = {
  __typename: 'motors_var_pop_fields';
  eff1?: Maybe<Scalars['Float']['output']>;
  eff2?: Maybe<Scalars['Float']['output']>;
  eff3?: Maybe<Scalars['Float']['output']>;
  eff4?: Maybe<Scalars['Float']['output']>;
  eff5?: Maybe<Scalars['Float']['output']>;
  effb?: Maybe<Scalars['Float']['output']>;
  effv0?: Maybe<Scalars['Float']['output']>;
  effv1?: Maybe<Scalars['Float']['output']>;
  effv2?: Maybe<Scalars['Float']['output']>;
  i1?: Maybe<Scalars['Float']['output']>;
  i2?: Maybe<Scalars['Float']['output']>;
  i3?: Maybe<Scalars['Float']['output']>;
  i4?: Maybe<Scalars['Float']['output']>;
  i5?: Maybe<Scalars['Float']['output']>;
  ib?: Maybe<Scalars['Float']['output']>;
  imported_sizing_id?: Maybe<Scalars['Float']['output']>;
  inner_diameter_inches?: Maybe<Scalars['Float']['output']>;
  iv0?: Maybe<Scalars['Float']['output']>;
  iv1?: Maybe<Scalars['Float']['output']>;
  iv2?: Maybe<Scalars['Float']['output']>;
  k3?: Maybe<Scalars['Float']['output']>;
  length_inches?: Maybe<Scalars['Float']['output']>;
  mle_offset_depth_inches?: Maybe<Scalars['Float']['output']>;
  n1?: Maybe<Scalars['Float']['output']>;
  n2?: Maybe<Scalars['Float']['output']>;
  n3?: Maybe<Scalars['Float']['output']>;
  n4?: Maybe<Scalars['Float']['output']>;
  n5?: Maybe<Scalars['Float']['output']>;
  nameplate_current?: Maybe<Scalars['Float']['output']>;
  nameplate_horsepower?: Maybe<Scalars['Float']['output']>;
  nameplate_rerate_ratio?: Maybe<Scalars['Float']['output']>;
  nameplate_voltage?: Maybe<Scalars['Float']['output']>;
  nb?: Maybe<Scalars['Float']['output']>;
  neck_inner_diameter_inches?: Maybe<Scalars['Float']['output']>;
  neck_outer_diameter_inches?: Maybe<Scalars['Float']['output']>;
  nv0?: Maybe<Scalars['Float']['output']>;
  nv1?: Maybe<Scalars['Float']['output']>;
  nv2?: Maybe<Scalars['Float']['output']>;
  oil_volume_gallons?: Maybe<Scalars['Float']['output']>;
  outer_diameter_inches?: Maybe<Scalars['Float']['output']>;
  outer_diameter_rub_inches?: Maybe<Scalars['Float']['output']>;
  pf1?: Maybe<Scalars['Float']['output']>;
  pf2?: Maybe<Scalars['Float']['output']>;
  pf3?: Maybe<Scalars['Float']['output']>;
  pf4?: Maybe<Scalars['Float']['output']>;
  pf5?: Maybe<Scalars['Float']['output']>;
  pfb?: Maybe<Scalars['Float']['output']>;
  pfv0?: Maybe<Scalars['Float']['output']>;
  pfv1?: Maybe<Scalars['Float']['output']>;
  pfv2?: Maybe<Scalars['Float']['output']>;
  poles?: Maybe<Scalars['Float']['output']>;
  rr_l1?: Maybe<Scalars['Float']['output']>;
  rr_l2?: Maybe<Scalars['Float']['output']>;
  rr_lb?: Maybe<Scalars['Float']['output']>;
  rr_v1?: Maybe<Scalars['Float']['output']>;
  rr_v2?: Maybe<Scalars['Float']['output']>;
  rr_v3?: Maybe<Scalars['Float']['output']>;
  rr_vb?: Maybe<Scalars['Float']['output']>;
  shaft_height_inches?: Maybe<Scalars['Float']['output']>;
  shaft_horsepower?: Maybe<Scalars['Float']['output']>;
  stator_inner_diameter_inches?: Maybe<Scalars['Float']['output']>;
  stator_outer_diameter_inches?: Maybe<Scalars['Float']['output']>;
  temperature_rating_fahrenheit?: Maybe<Scalars['Float']['output']>;
  tv0?: Maybe<Scalars['Float']['output']>;
  tv1?: Maybe<Scalars['Float']['output']>;
  tv2?: Maybe<Scalars['Float']['output']>;
  weight_pounds?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "motors" */
export type Motors_Var_Pop_Order_By = {
  eff1?: InputMaybe<Order_By>;
  eff2?: InputMaybe<Order_By>;
  eff3?: InputMaybe<Order_By>;
  eff4?: InputMaybe<Order_By>;
  eff5?: InputMaybe<Order_By>;
  effb?: InputMaybe<Order_By>;
  effv0?: InputMaybe<Order_By>;
  effv1?: InputMaybe<Order_By>;
  effv2?: InputMaybe<Order_By>;
  i1?: InputMaybe<Order_By>;
  i2?: InputMaybe<Order_By>;
  i3?: InputMaybe<Order_By>;
  i4?: InputMaybe<Order_By>;
  i5?: InputMaybe<Order_By>;
  ib?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  inner_diameter_inches?: InputMaybe<Order_By>;
  iv0?: InputMaybe<Order_By>;
  iv1?: InputMaybe<Order_By>;
  iv2?: InputMaybe<Order_By>;
  k3?: InputMaybe<Order_By>;
  length_inches?: InputMaybe<Order_By>;
  mle_offset_depth_inches?: InputMaybe<Order_By>;
  n1?: InputMaybe<Order_By>;
  n2?: InputMaybe<Order_By>;
  n3?: InputMaybe<Order_By>;
  n4?: InputMaybe<Order_By>;
  n5?: InputMaybe<Order_By>;
  nameplate_current?: InputMaybe<Order_By>;
  nameplate_horsepower?: InputMaybe<Order_By>;
  nameplate_rerate_ratio?: InputMaybe<Order_By>;
  nameplate_voltage?: InputMaybe<Order_By>;
  nb?: InputMaybe<Order_By>;
  neck_inner_diameter_inches?: InputMaybe<Order_By>;
  neck_outer_diameter_inches?: InputMaybe<Order_By>;
  nv0?: InputMaybe<Order_By>;
  nv1?: InputMaybe<Order_By>;
  nv2?: InputMaybe<Order_By>;
  oil_volume_gallons?: InputMaybe<Order_By>;
  outer_diameter_inches?: InputMaybe<Order_By>;
  outer_diameter_rub_inches?: InputMaybe<Order_By>;
  pf1?: InputMaybe<Order_By>;
  pf2?: InputMaybe<Order_By>;
  pf3?: InputMaybe<Order_By>;
  pf4?: InputMaybe<Order_By>;
  pf5?: InputMaybe<Order_By>;
  pfb?: InputMaybe<Order_By>;
  pfv0?: InputMaybe<Order_By>;
  pfv1?: InputMaybe<Order_By>;
  pfv2?: InputMaybe<Order_By>;
  poles?: InputMaybe<Order_By>;
  rr_l1?: InputMaybe<Order_By>;
  rr_l2?: InputMaybe<Order_By>;
  rr_lb?: InputMaybe<Order_By>;
  rr_v1?: InputMaybe<Order_By>;
  rr_v2?: InputMaybe<Order_By>;
  rr_v3?: InputMaybe<Order_By>;
  rr_vb?: InputMaybe<Order_By>;
  shaft_height_inches?: InputMaybe<Order_By>;
  shaft_horsepower?: InputMaybe<Order_By>;
  stator_inner_diameter_inches?: InputMaybe<Order_By>;
  stator_outer_diameter_inches?: InputMaybe<Order_By>;
  temperature_rating_fahrenheit?: InputMaybe<Order_By>;
  tv0?: InputMaybe<Order_By>;
  tv1?: InputMaybe<Order_By>;
  tv2?: InputMaybe<Order_By>;
  weight_pounds?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Motors_Var_Samp_Fields = {
  __typename: 'motors_var_samp_fields';
  eff1?: Maybe<Scalars['Float']['output']>;
  eff2?: Maybe<Scalars['Float']['output']>;
  eff3?: Maybe<Scalars['Float']['output']>;
  eff4?: Maybe<Scalars['Float']['output']>;
  eff5?: Maybe<Scalars['Float']['output']>;
  effb?: Maybe<Scalars['Float']['output']>;
  effv0?: Maybe<Scalars['Float']['output']>;
  effv1?: Maybe<Scalars['Float']['output']>;
  effv2?: Maybe<Scalars['Float']['output']>;
  i1?: Maybe<Scalars['Float']['output']>;
  i2?: Maybe<Scalars['Float']['output']>;
  i3?: Maybe<Scalars['Float']['output']>;
  i4?: Maybe<Scalars['Float']['output']>;
  i5?: Maybe<Scalars['Float']['output']>;
  ib?: Maybe<Scalars['Float']['output']>;
  imported_sizing_id?: Maybe<Scalars['Float']['output']>;
  inner_diameter_inches?: Maybe<Scalars['Float']['output']>;
  iv0?: Maybe<Scalars['Float']['output']>;
  iv1?: Maybe<Scalars['Float']['output']>;
  iv2?: Maybe<Scalars['Float']['output']>;
  k3?: Maybe<Scalars['Float']['output']>;
  length_inches?: Maybe<Scalars['Float']['output']>;
  mle_offset_depth_inches?: Maybe<Scalars['Float']['output']>;
  n1?: Maybe<Scalars['Float']['output']>;
  n2?: Maybe<Scalars['Float']['output']>;
  n3?: Maybe<Scalars['Float']['output']>;
  n4?: Maybe<Scalars['Float']['output']>;
  n5?: Maybe<Scalars['Float']['output']>;
  nameplate_current?: Maybe<Scalars['Float']['output']>;
  nameplate_horsepower?: Maybe<Scalars['Float']['output']>;
  nameplate_rerate_ratio?: Maybe<Scalars['Float']['output']>;
  nameplate_voltage?: Maybe<Scalars['Float']['output']>;
  nb?: Maybe<Scalars['Float']['output']>;
  neck_inner_diameter_inches?: Maybe<Scalars['Float']['output']>;
  neck_outer_diameter_inches?: Maybe<Scalars['Float']['output']>;
  nv0?: Maybe<Scalars['Float']['output']>;
  nv1?: Maybe<Scalars['Float']['output']>;
  nv2?: Maybe<Scalars['Float']['output']>;
  oil_volume_gallons?: Maybe<Scalars['Float']['output']>;
  outer_diameter_inches?: Maybe<Scalars['Float']['output']>;
  outer_diameter_rub_inches?: Maybe<Scalars['Float']['output']>;
  pf1?: Maybe<Scalars['Float']['output']>;
  pf2?: Maybe<Scalars['Float']['output']>;
  pf3?: Maybe<Scalars['Float']['output']>;
  pf4?: Maybe<Scalars['Float']['output']>;
  pf5?: Maybe<Scalars['Float']['output']>;
  pfb?: Maybe<Scalars['Float']['output']>;
  pfv0?: Maybe<Scalars['Float']['output']>;
  pfv1?: Maybe<Scalars['Float']['output']>;
  pfv2?: Maybe<Scalars['Float']['output']>;
  poles?: Maybe<Scalars['Float']['output']>;
  rr_l1?: Maybe<Scalars['Float']['output']>;
  rr_l2?: Maybe<Scalars['Float']['output']>;
  rr_lb?: Maybe<Scalars['Float']['output']>;
  rr_v1?: Maybe<Scalars['Float']['output']>;
  rr_v2?: Maybe<Scalars['Float']['output']>;
  rr_v3?: Maybe<Scalars['Float']['output']>;
  rr_vb?: Maybe<Scalars['Float']['output']>;
  shaft_height_inches?: Maybe<Scalars['Float']['output']>;
  shaft_horsepower?: Maybe<Scalars['Float']['output']>;
  stator_inner_diameter_inches?: Maybe<Scalars['Float']['output']>;
  stator_outer_diameter_inches?: Maybe<Scalars['Float']['output']>;
  temperature_rating_fahrenheit?: Maybe<Scalars['Float']['output']>;
  tv0?: Maybe<Scalars['Float']['output']>;
  tv1?: Maybe<Scalars['Float']['output']>;
  tv2?: Maybe<Scalars['Float']['output']>;
  weight_pounds?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "motors" */
export type Motors_Var_Samp_Order_By = {
  eff1?: InputMaybe<Order_By>;
  eff2?: InputMaybe<Order_By>;
  eff3?: InputMaybe<Order_By>;
  eff4?: InputMaybe<Order_By>;
  eff5?: InputMaybe<Order_By>;
  effb?: InputMaybe<Order_By>;
  effv0?: InputMaybe<Order_By>;
  effv1?: InputMaybe<Order_By>;
  effv2?: InputMaybe<Order_By>;
  i1?: InputMaybe<Order_By>;
  i2?: InputMaybe<Order_By>;
  i3?: InputMaybe<Order_By>;
  i4?: InputMaybe<Order_By>;
  i5?: InputMaybe<Order_By>;
  ib?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  inner_diameter_inches?: InputMaybe<Order_By>;
  iv0?: InputMaybe<Order_By>;
  iv1?: InputMaybe<Order_By>;
  iv2?: InputMaybe<Order_By>;
  k3?: InputMaybe<Order_By>;
  length_inches?: InputMaybe<Order_By>;
  mle_offset_depth_inches?: InputMaybe<Order_By>;
  n1?: InputMaybe<Order_By>;
  n2?: InputMaybe<Order_By>;
  n3?: InputMaybe<Order_By>;
  n4?: InputMaybe<Order_By>;
  n5?: InputMaybe<Order_By>;
  nameplate_current?: InputMaybe<Order_By>;
  nameplate_horsepower?: InputMaybe<Order_By>;
  nameplate_rerate_ratio?: InputMaybe<Order_By>;
  nameplate_voltage?: InputMaybe<Order_By>;
  nb?: InputMaybe<Order_By>;
  neck_inner_diameter_inches?: InputMaybe<Order_By>;
  neck_outer_diameter_inches?: InputMaybe<Order_By>;
  nv0?: InputMaybe<Order_By>;
  nv1?: InputMaybe<Order_By>;
  nv2?: InputMaybe<Order_By>;
  oil_volume_gallons?: InputMaybe<Order_By>;
  outer_diameter_inches?: InputMaybe<Order_By>;
  outer_diameter_rub_inches?: InputMaybe<Order_By>;
  pf1?: InputMaybe<Order_By>;
  pf2?: InputMaybe<Order_By>;
  pf3?: InputMaybe<Order_By>;
  pf4?: InputMaybe<Order_By>;
  pf5?: InputMaybe<Order_By>;
  pfb?: InputMaybe<Order_By>;
  pfv0?: InputMaybe<Order_By>;
  pfv1?: InputMaybe<Order_By>;
  pfv2?: InputMaybe<Order_By>;
  poles?: InputMaybe<Order_By>;
  rr_l1?: InputMaybe<Order_By>;
  rr_l2?: InputMaybe<Order_By>;
  rr_lb?: InputMaybe<Order_By>;
  rr_v1?: InputMaybe<Order_By>;
  rr_v2?: InputMaybe<Order_By>;
  rr_v3?: InputMaybe<Order_By>;
  rr_vb?: InputMaybe<Order_By>;
  shaft_height_inches?: InputMaybe<Order_By>;
  shaft_horsepower?: InputMaybe<Order_By>;
  stator_inner_diameter_inches?: InputMaybe<Order_By>;
  stator_outer_diameter_inches?: InputMaybe<Order_By>;
  temperature_rating_fahrenheit?: InputMaybe<Order_By>;
  tv0?: InputMaybe<Order_By>;
  tv1?: InputMaybe<Order_By>;
  tv2?: InputMaybe<Order_By>;
  weight_pounds?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Motors_Variance_Fields = {
  __typename: 'motors_variance_fields';
  eff1?: Maybe<Scalars['Float']['output']>;
  eff2?: Maybe<Scalars['Float']['output']>;
  eff3?: Maybe<Scalars['Float']['output']>;
  eff4?: Maybe<Scalars['Float']['output']>;
  eff5?: Maybe<Scalars['Float']['output']>;
  effb?: Maybe<Scalars['Float']['output']>;
  effv0?: Maybe<Scalars['Float']['output']>;
  effv1?: Maybe<Scalars['Float']['output']>;
  effv2?: Maybe<Scalars['Float']['output']>;
  i1?: Maybe<Scalars['Float']['output']>;
  i2?: Maybe<Scalars['Float']['output']>;
  i3?: Maybe<Scalars['Float']['output']>;
  i4?: Maybe<Scalars['Float']['output']>;
  i5?: Maybe<Scalars['Float']['output']>;
  ib?: Maybe<Scalars['Float']['output']>;
  imported_sizing_id?: Maybe<Scalars['Float']['output']>;
  inner_diameter_inches?: Maybe<Scalars['Float']['output']>;
  iv0?: Maybe<Scalars['Float']['output']>;
  iv1?: Maybe<Scalars['Float']['output']>;
  iv2?: Maybe<Scalars['Float']['output']>;
  k3?: Maybe<Scalars['Float']['output']>;
  length_inches?: Maybe<Scalars['Float']['output']>;
  mle_offset_depth_inches?: Maybe<Scalars['Float']['output']>;
  n1?: Maybe<Scalars['Float']['output']>;
  n2?: Maybe<Scalars['Float']['output']>;
  n3?: Maybe<Scalars['Float']['output']>;
  n4?: Maybe<Scalars['Float']['output']>;
  n5?: Maybe<Scalars['Float']['output']>;
  nameplate_current?: Maybe<Scalars['Float']['output']>;
  nameplate_horsepower?: Maybe<Scalars['Float']['output']>;
  nameplate_rerate_ratio?: Maybe<Scalars['Float']['output']>;
  nameplate_voltage?: Maybe<Scalars['Float']['output']>;
  nb?: Maybe<Scalars['Float']['output']>;
  neck_inner_diameter_inches?: Maybe<Scalars['Float']['output']>;
  neck_outer_diameter_inches?: Maybe<Scalars['Float']['output']>;
  nv0?: Maybe<Scalars['Float']['output']>;
  nv1?: Maybe<Scalars['Float']['output']>;
  nv2?: Maybe<Scalars['Float']['output']>;
  oil_volume_gallons?: Maybe<Scalars['Float']['output']>;
  outer_diameter_inches?: Maybe<Scalars['Float']['output']>;
  outer_diameter_rub_inches?: Maybe<Scalars['Float']['output']>;
  pf1?: Maybe<Scalars['Float']['output']>;
  pf2?: Maybe<Scalars['Float']['output']>;
  pf3?: Maybe<Scalars['Float']['output']>;
  pf4?: Maybe<Scalars['Float']['output']>;
  pf5?: Maybe<Scalars['Float']['output']>;
  pfb?: Maybe<Scalars['Float']['output']>;
  pfv0?: Maybe<Scalars['Float']['output']>;
  pfv1?: Maybe<Scalars['Float']['output']>;
  pfv2?: Maybe<Scalars['Float']['output']>;
  poles?: Maybe<Scalars['Float']['output']>;
  rr_l1?: Maybe<Scalars['Float']['output']>;
  rr_l2?: Maybe<Scalars['Float']['output']>;
  rr_lb?: Maybe<Scalars['Float']['output']>;
  rr_v1?: Maybe<Scalars['Float']['output']>;
  rr_v2?: Maybe<Scalars['Float']['output']>;
  rr_v3?: Maybe<Scalars['Float']['output']>;
  rr_vb?: Maybe<Scalars['Float']['output']>;
  shaft_height_inches?: Maybe<Scalars['Float']['output']>;
  shaft_horsepower?: Maybe<Scalars['Float']['output']>;
  stator_inner_diameter_inches?: Maybe<Scalars['Float']['output']>;
  stator_outer_diameter_inches?: Maybe<Scalars['Float']['output']>;
  temperature_rating_fahrenheit?: Maybe<Scalars['Float']['output']>;
  tv0?: Maybe<Scalars['Float']['output']>;
  tv1?: Maybe<Scalars['Float']['output']>;
  tv2?: Maybe<Scalars['Float']['output']>;
  weight_pounds?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "motors" */
export type Motors_Variance_Order_By = {
  eff1?: InputMaybe<Order_By>;
  eff2?: InputMaybe<Order_By>;
  eff3?: InputMaybe<Order_By>;
  eff4?: InputMaybe<Order_By>;
  eff5?: InputMaybe<Order_By>;
  effb?: InputMaybe<Order_By>;
  effv0?: InputMaybe<Order_By>;
  effv1?: InputMaybe<Order_By>;
  effv2?: InputMaybe<Order_By>;
  i1?: InputMaybe<Order_By>;
  i2?: InputMaybe<Order_By>;
  i3?: InputMaybe<Order_By>;
  i4?: InputMaybe<Order_By>;
  i5?: InputMaybe<Order_By>;
  ib?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  inner_diameter_inches?: InputMaybe<Order_By>;
  iv0?: InputMaybe<Order_By>;
  iv1?: InputMaybe<Order_By>;
  iv2?: InputMaybe<Order_By>;
  k3?: InputMaybe<Order_By>;
  length_inches?: InputMaybe<Order_By>;
  mle_offset_depth_inches?: InputMaybe<Order_By>;
  n1?: InputMaybe<Order_By>;
  n2?: InputMaybe<Order_By>;
  n3?: InputMaybe<Order_By>;
  n4?: InputMaybe<Order_By>;
  n5?: InputMaybe<Order_By>;
  nameplate_current?: InputMaybe<Order_By>;
  nameplate_horsepower?: InputMaybe<Order_By>;
  nameplate_rerate_ratio?: InputMaybe<Order_By>;
  nameplate_voltage?: InputMaybe<Order_By>;
  nb?: InputMaybe<Order_By>;
  neck_inner_diameter_inches?: InputMaybe<Order_By>;
  neck_outer_diameter_inches?: InputMaybe<Order_By>;
  nv0?: InputMaybe<Order_By>;
  nv1?: InputMaybe<Order_By>;
  nv2?: InputMaybe<Order_By>;
  oil_volume_gallons?: InputMaybe<Order_By>;
  outer_diameter_inches?: InputMaybe<Order_By>;
  outer_diameter_rub_inches?: InputMaybe<Order_By>;
  pf1?: InputMaybe<Order_By>;
  pf2?: InputMaybe<Order_By>;
  pf3?: InputMaybe<Order_By>;
  pf4?: InputMaybe<Order_By>;
  pf5?: InputMaybe<Order_By>;
  pfb?: InputMaybe<Order_By>;
  pfv0?: InputMaybe<Order_By>;
  pfv1?: InputMaybe<Order_By>;
  pfv2?: InputMaybe<Order_By>;
  poles?: InputMaybe<Order_By>;
  rr_l1?: InputMaybe<Order_By>;
  rr_l2?: InputMaybe<Order_By>;
  rr_lb?: InputMaybe<Order_By>;
  rr_v1?: InputMaybe<Order_By>;
  rr_v2?: InputMaybe<Order_By>;
  rr_v3?: InputMaybe<Order_By>;
  rr_vb?: InputMaybe<Order_By>;
  shaft_height_inches?: InputMaybe<Order_By>;
  shaft_horsepower?: InputMaybe<Order_By>;
  stator_inner_diameter_inches?: InputMaybe<Order_By>;
  stator_outer_diameter_inches?: InputMaybe<Order_By>;
  temperature_rating_fahrenheit?: InputMaybe<Order_By>;
  tv0?: InputMaybe<Order_By>;
  tv1?: InputMaybe<Order_By>;
  tv2?: InputMaybe<Order_By>;
  weight_pounds?: InputMaybe<Order_By>;
};

/** mutation root */
export type Mutation_Root = {
  __typename: 'mutation_root';
  createSKJob?: Maybe<SkJob>;
  createSKQuote?: Maybe<SkQuote>;
  deleteSKQuote?: Maybe<SkDeleteQuote>;
  /** delete data from the table: "bolt_on_discharges" */
  delete_bolt_on_discharges?: Maybe<Bolt_On_Discharges_Mutation_Response>;
  /** delete single row from the table: "bolt_on_discharges" */
  delete_bolt_on_discharges_by_pk?: Maybe<Bolt_On_Discharges>;
  /** delete data from the table: "bubble_point_options" */
  delete_bubble_point_options?: Maybe<Bubble_Point_Options_Mutation_Response>;
  /** delete single row from the table: "bubble_point_options" */
  delete_bubble_point_options_by_pk?: Maybe<Bubble_Point_Options>;
  /** delete data from the table: "cables" */
  delete_cables?: Maybe<Cables_Mutation_Response>;
  /** delete single row from the table: "cables" */
  delete_cables_by_pk?: Maybe<Cables>;
  /** delete data from the table: "casing_flow_options" */
  delete_casing_flow_options?: Maybe<Casing_Flow_Options_Mutation_Response>;
  /** delete single row from the table: "casing_flow_options" */
  delete_casing_flow_options_by_pk?: Maybe<Casing_Flow_Options>;
  /** delete data from the table: "casings" */
  delete_casings?: Maybe<Casings_Mutation_Response>;
  /** delete single row from the table: "casings" */
  delete_casings_by_pk?: Maybe<Casings>;
  /** delete data from the table: "casings_type" */
  delete_casings_type?: Maybe<Casings_Type_Mutation_Response>;
  /** delete single row from the table: "casings_type" */
  delete_casings_type_by_pk?: Maybe<Casings_Type>;
  /** delete data from the table: "customers" */
  delete_customers?: Maybe<Customers_Mutation_Response>;
  /** delete single row from the table: "customers" */
  delete_customers_by_pk?: Maybe<Customers>;
  /** delete data from the table: "dead_oil_options" */
  delete_dead_oil_options?: Maybe<Dead_Oil_Options_Mutation_Response>;
  /** delete single row from the table: "dead_oil_options" */
  delete_dead_oil_options_by_pk?: Maybe<Dead_Oil_Options>;
  /** delete data from the table: "deviation_survey" */
  delete_deviation_survey?: Maybe<Deviation_Survey_Mutation_Response>;
  /** delete single row from the table: "deviation_survey" */
  delete_deviation_survey_by_pk?: Maybe<Deviation_Survey>;
  /** delete data from the table: "deviation_survey_directional_dataset" */
  delete_deviation_survey_directional_dataset?: Maybe<Deviation_Survey_Directional_Dataset_Mutation_Response>;
  /** delete single row from the table: "deviation_survey_directional_dataset" */
  delete_deviation_survey_directional_dataset_by_pk?: Maybe<Deviation_Survey_Directional_Dataset>;
  /** delete data from the table: "display_units" */
  delete_display_units?: Maybe<Display_Units_Mutation_Response>;
  /** delete single row from the table: "display_units" */
  delete_display_units_by_pk?: Maybe<Display_Units>;
  /** delete data from the table: "eula" */
  delete_eula?: Maybe<Eula_Mutation_Response>;
  /** delete single row from the table: "eula" */
  delete_eula_by_pk?: Maybe<Eula>;
  /** delete data from the table: "flow_model" */
  delete_flow_model?: Maybe<Flow_Model_Mutation_Response>;
  /** delete data from the table: "flow_model_active" */
  delete_flow_model_active?: Maybe<Flow_Model_Active_Mutation_Response>;
  /** delete single row from the table: "flow_model" */
  delete_flow_model_by_pk?: Maybe<Flow_Model>;
  /** delete data from the table: "flow_model_deprecated" */
  delete_flow_model_deprecated?: Maybe<Flow_Model_Deprecated_Mutation_Response>;
  /** delete single row from the table: "flow_model_deprecated" */
  delete_flow_model_deprecated_by_pk?: Maybe<Flow_Model_Deprecated>;
  /** delete data from the table: "friction_loss_options" */
  delete_friction_loss_options?: Maybe<Friction_Loss_Options_Mutation_Response>;
  /** delete single row from the table: "friction_loss_options" */
  delete_friction_loss_options_by_pk?: Maybe<Friction_Loss_Options>;
  /** delete data from the table: "gas_compressibility_options" */
  delete_gas_compressibility_options?: Maybe<Gas_Compressibility_Options_Mutation_Response>;
  /** delete single row from the table: "gas_compressibility_options" */
  delete_gas_compressibility_options_by_pk?: Maybe<Gas_Compressibility_Options>;
  /** delete data from the table: "gas_viscosity_options" */
  delete_gas_viscosity_options?: Maybe<Gas_Viscosity_Options_Mutation_Response>;
  /** delete single row from the table: "gas_viscosity_options" */
  delete_gas_viscosity_options_by_pk?: Maybe<Gas_Viscosity_Options>;
  /** delete data from the table: "housings" */
  delete_housings?: Maybe<Housings_Mutation_Response>;
  /** delete single row from the table: "housings" */
  delete_housings_by_pk?: Maybe<Housings>;
  /** delete data from the table: "hps_liquid_type" */
  delete_hps_liquid_type?: Maybe<Hps_Liquid_Type_Mutation_Response>;
  /** delete single row from the table: "hps_liquid_type" */
  delete_hps_liquid_type_by_pk?: Maybe<Hps_Liquid_Type>;
  /** delete data from the table: "intakes" */
  delete_intakes?: Maybe<Intakes_Mutation_Response>;
  /** delete single row from the table: "intakes" */
  delete_intakes_by_pk?: Maybe<Intakes>;
  /** delete data from the table: "legacy_users" */
  delete_legacy_users?: Maybe<Legacy_Users_Mutation_Response>;
  /** delete single row from the table: "legacy_users" */
  delete_legacy_users_by_pk?: Maybe<Legacy_Users>;
  /** delete data from the table: "motor_lead_extensions" */
  delete_motor_lead_extensions?: Maybe<Motor_Lead_Extensions_Mutation_Response>;
  /** delete single row from the table: "motor_lead_extensions" */
  delete_motor_lead_extensions_by_pk?: Maybe<Motor_Lead_Extensions>;
  /** delete data from the table: "motors" */
  delete_motors?: Maybe<Motors_Mutation_Response>;
  /** delete single row from the table: "motors" */
  delete_motors_by_pk?: Maybe<Motors>;
  /** delete data from the table: "natural_gas_separation_options" */
  delete_natural_gas_separation_options?: Maybe<Natural_Gas_Separation_Options_Mutation_Response>;
  /** delete single row from the table: "natural_gas_separation_options" */
  delete_natural_gas_separation_options_by_pk?: Maybe<Natural_Gas_Separation_Options>;
  /** delete data from the table: "oil_density_options" */
  delete_oil_density_options?: Maybe<Oil_Density_Options_Mutation_Response>;
  /** delete single row from the table: "oil_density_options" */
  delete_oil_density_options_by_pk?: Maybe<Oil_Density_Options>;
  /** delete data from the table: "oil_volume_factor_options" */
  delete_oil_volume_factor_options?: Maybe<Oil_Volume_Factor_Options_Mutation_Response>;
  /** delete single row from the table: "oil_volume_factor_options" */
  delete_oil_volume_factor_options_by_pk?: Maybe<Oil_Volume_Factor_Options>;
  /** delete data from the table: "override_options" */
  delete_override_options?: Maybe<Override_Options_Mutation_Response>;
  /** delete single row from the table: "override_options" */
  delete_override_options_by_pk?: Maybe<Override_Options>;
  /** delete data from the table: "pumps" */
  delete_pumps?: Maybe<Pumps_Mutation_Response>;
  /** delete single row from the table: "pumps" */
  delete_pumps_by_pk?: Maybe<Pumps>;
  /** delete data from the table: "quote_line_item_category_dataset" */
  delete_quote_line_item_category_dataset?: Maybe<Quote_Line_Item_Category_Dataset_Mutation_Response>;
  /** delete single row from the table: "quote_line_item_category_dataset" */
  delete_quote_line_item_category_dataset_by_pk?: Maybe<Quote_Line_Item_Category_Dataset>;
  /** delete data from the table: "quote_line_item_serialized_dataset" */
  delete_quote_line_item_serialized_dataset?: Maybe<Quote_Line_Item_Serialized_Dataset_Mutation_Response>;
  /** delete single row from the table: "quote_line_item_serialized_dataset" */
  delete_quote_line_item_serialized_dataset_by_pk?: Maybe<Quote_Line_Item_Serialized_Dataset>;
  /** delete data from the table: "quote_line_item_source_dataset" */
  delete_quote_line_item_source_dataset?: Maybe<Quote_Line_Item_Source_Dataset_Mutation_Response>;
  /** delete single row from the table: "quote_line_item_source_dataset" */
  delete_quote_line_item_source_dataset_by_pk?: Maybe<Quote_Line_Item_Source_Dataset>;
  /** delete data from the table: "quote_line_item_subcategory_dataset" */
  delete_quote_line_item_subcategory_dataset?: Maybe<Quote_Line_Item_Subcategory_Dataset_Mutation_Response>;
  /** delete single row from the table: "quote_line_item_subcategory_dataset" */
  delete_quote_line_item_subcategory_dataset_by_pk?: Maybe<Quote_Line_Item_Subcategory_Dataset>;
  /** delete data from the table: "quote_line_item_tax_type_dataset" */
  delete_quote_line_item_tax_type_dataset?: Maybe<Quote_Line_Item_Tax_Type_Dataset_Mutation_Response>;
  /** delete single row from the table: "quote_line_item_tax_type_dataset" */
  delete_quote_line_item_tax_type_dataset_by_pk?: Maybe<Quote_Line_Item_Tax_Type_Dataset>;
  /** delete data from the table: "quote_line_item_type_dataset" */
  delete_quote_line_item_type_dataset?: Maybe<Quote_Line_Item_Type_Dataset_Mutation_Response>;
  /** delete single row from the table: "quote_line_item_type_dataset" */
  delete_quote_line_item_type_dataset_by_pk?: Maybe<Quote_Line_Item_Type_Dataset>;
  /** delete data from the table: "quote_line_items" */
  delete_quote_line_items?: Maybe<Quote_Line_Items_Mutation_Response>;
  /** delete single row from the table: "quote_line_items" */
  delete_quote_line_items_by_pk?: Maybe<Quote_Line_Items>;
  /** delete data from the table: "quote_sk_job_type_dataset" */
  delete_quote_sk_job_type_dataset?: Maybe<Quote_Sk_Job_Type_Dataset_Mutation_Response>;
  /** delete single row from the table: "quote_sk_job_type_dataset" */
  delete_quote_sk_job_type_dataset_by_pk?: Maybe<Quote_Sk_Job_Type_Dataset>;
  /** delete data from the table: "quote_source_dataset" */
  delete_quote_source_dataset?: Maybe<Quote_Source_Dataset_Mutation_Response>;
  /** delete single row from the table: "quote_source_dataset" */
  delete_quote_source_dataset_by_pk?: Maybe<Quote_Source_Dataset>;
  /** delete data from the table: "quote_status_dataset" */
  delete_quote_status_dataset?: Maybe<Quote_Status_Dataset_Mutation_Response>;
  /** delete single row from the table: "quote_status_dataset" */
  delete_quote_status_dataset_by_pk?: Maybe<Quote_Status_Dataset>;
  /** delete data from the table: "quote_user_messages" */
  delete_quote_user_messages?: Maybe<Quote_User_Messages_Mutation_Response>;
  /** delete single row from the table: "quote_user_messages" */
  delete_quote_user_messages_by_pk?: Maybe<Quote_User_Messages>;
  /** delete data from the table: "quotes" */
  delete_quotes?: Maybe<Quotes_Mutation_Response>;
  /** delete single row from the table: "quotes" */
  delete_quotes_by_pk?: Maybe<Quotes>;
  /** delete data from the table: "revisions.performance_evaluations_journal" */
  delete_revisions_performance_evaluations_journal?: Maybe<Revisions_Performance_Evaluations_Journal_Mutation_Response>;
  /** delete single row from the table: "revisions.performance_evaluations_journal" */
  delete_revisions_performance_evaluations_journal_by_pk?: Maybe<Revisions_Performance_Evaluations_Journal>;
  /** delete data from the table: "revisions.performance_evaluations_revisions" */
  delete_revisions_performance_evaluations_revisions?: Maybe<Revisions_Performance_Evaluations_Revisions_Mutation_Response>;
  /** delete single row from the table: "revisions.performance_evaluations_revisions" */
  delete_revisions_performance_evaluations_revisions_by_pk?: Maybe<Revisions_Performance_Evaluations_Revisions>;
  /** delete data from the table: "revisions.performance_evaluations_xref_pumps_journal" */
  delete_revisions_performance_evaluations_xref_pumps_journal?: Maybe<Revisions_Performance_Evaluations_Xref_Pumps_Journal_Mutation_Response>;
  /** delete single row from the table: "revisions.performance_evaluations_xref_pumps_journal" */
  delete_revisions_performance_evaluations_xref_pumps_journal_by_pk?: Maybe<Revisions_Performance_Evaluations_Xref_Pumps_Journal>;
  /** delete data from the table: "revisions.performance_evaluations_xref_pumps_revisions" */
  delete_revisions_performance_evaluations_xref_pumps_revisions?: Maybe<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Mutation_Response>;
  /** delete single row from the table: "revisions.performance_evaluations_xref_pumps_revisions" */
  delete_revisions_performance_evaluations_xref_pumps_revisions_by_pk?: Maybe<Revisions_Performance_Evaluations_Xref_Pumps_Revisions>;
  /** delete data from the table: "revisions.sc_equip_xref_downhole_ytool_bypass_tubings_journal" */
  delete_revisions_sc_equip_xref_downhole_ytool_bypass_tubings_journal?: Maybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_Mutation_Response>;
  /** delete single row from the table: "revisions.sc_equip_xref_downhole_ytool_bypass_tubings_journal" */
  delete_revisions_sc_equip_xref_downhole_ytool_bypass_tubings_journal_by_pk?: Maybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal>;
  /** delete data from the table: "revisions.sc_equip_xref_downhole_ytool_bypass_tubings_revisions" */
  delete_revisions_sc_equip_xref_downhole_ytool_bypass_tubings_revisions?: Maybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Mutation_Response>;
  /** delete single row from the table: "revisions.sc_equip_xref_downhole_ytool_bypass_tubings_revisions" */
  delete_revisions_sc_equip_xref_downhole_ytool_bypass_tubings_revisions_by_pk?: Maybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions>;
  /** delete data from the table: "revisions.sc_equip_xref_downhole_ytool_equip_tubings_journal" */
  delete_revisions_sc_equip_xref_downhole_ytool_equip_tubings_journal?: Maybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_Mutation_Response>;
  /** delete single row from the table: "revisions.sc_equip_xref_downhole_ytool_equip_tubings_journal" */
  delete_revisions_sc_equip_xref_downhole_ytool_equip_tubings_journal_by_pk?: Maybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal>;
  /** delete data from the table: "revisions.sc_equip_xref_downhole_ytool_equip_tubings_revisions" */
  delete_revisions_sc_equip_xref_downhole_ytool_equip_tubings_revisions?: Maybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Mutation_Response>;
  /** delete single row from the table: "revisions.sc_equip_xref_downhole_ytool_equip_tubings_revisions" */
  delete_revisions_sc_equip_xref_downhole_ytool_equip_tubings_revisions_by_pk?: Maybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions>;
  /** delete data from the table: "revisions.sc_equip_xref_uphole_ytool_bypass_tubings_journal" */
  delete_revisions_sc_equip_xref_uphole_ytool_bypass_tubings_journal?: Maybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_Mutation_Response>;
  /** delete single row from the table: "revisions.sc_equip_xref_uphole_ytool_bypass_tubings_journal" */
  delete_revisions_sc_equip_xref_uphole_ytool_bypass_tubings_journal_by_pk?: Maybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal>;
  /** delete data from the table: "revisions.sc_equip_xref_uphole_ytool_bypass_tubings_revisions" */
  delete_revisions_sc_equip_xref_uphole_ytool_bypass_tubings_revisions?: Maybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Mutation_Response>;
  /** delete single row from the table: "revisions.sc_equip_xref_uphole_ytool_bypass_tubings_revisions" */
  delete_revisions_sc_equip_xref_uphole_ytool_bypass_tubings_revisions_by_pk?: Maybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions>;
  /** delete data from the table: "revisions.sc_equip_xref_uphole_ytool_equip_tubings_journal" */
  delete_revisions_sc_equip_xref_uphole_ytool_equip_tubings_journal?: Maybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_Mutation_Response>;
  /** delete single row from the table: "revisions.sc_equip_xref_uphole_ytool_equip_tubings_journal" */
  delete_revisions_sc_equip_xref_uphole_ytool_equip_tubings_journal_by_pk?: Maybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal>;
  /** delete data from the table: "revisions.sc_equip_xref_uphole_ytool_equip_tubings_revisions" */
  delete_revisions_sc_equip_xref_uphole_ytool_equip_tubings_revisions?: Maybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Mutation_Response>;
  /** delete single row from the table: "revisions.sc_equip_xref_uphole_ytool_equip_tubings_revisions" */
  delete_revisions_sc_equip_xref_uphole_ytool_equip_tubings_revisions_by_pk?: Maybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions>;
  /** delete data from the table: "revisions.scenario_correlations_journal" */
  delete_revisions_scenario_correlations_journal?: Maybe<Revisions_Scenario_Correlations_Journal_Mutation_Response>;
  /** delete single row from the table: "revisions.scenario_correlations_journal" */
  delete_revisions_scenario_correlations_journal_by_pk?: Maybe<Revisions_Scenario_Correlations_Journal>;
  /** delete data from the table: "revisions.scenario_correlations_revisions" */
  delete_revisions_scenario_correlations_revisions?: Maybe<Revisions_Scenario_Correlations_Revisions_Mutation_Response>;
  /** delete single row from the table: "revisions.scenario_correlations_revisions" */
  delete_revisions_scenario_correlations_revisions_by_pk?: Maybe<Revisions_Scenario_Correlations_Revisions>;
  /** delete data from the table: "revisions.scenario_equipment_journal" */
  delete_revisions_scenario_equipment_journal?: Maybe<Revisions_Scenario_Equipment_Journal_Mutation_Response>;
  /** delete single row from the table: "revisions.scenario_equipment_journal" */
  delete_revisions_scenario_equipment_journal_by_pk?: Maybe<Revisions_Scenario_Equipment_Journal>;
  /** delete data from the table: "revisions.scenario_equipment_revisions" */
  delete_revisions_scenario_equipment_revisions?: Maybe<Revisions_Scenario_Equipment_Revisions_Mutation_Response>;
  /** delete single row from the table: "revisions.scenario_equipment_revisions" */
  delete_revisions_scenario_equipment_revisions_by_pk?: Maybe<Revisions_Scenario_Equipment_Revisions>;
  /** delete data from the table: "revisions.scenario_equipment_xref_cables_journal" */
  delete_revisions_scenario_equipment_xref_cables_journal?: Maybe<Revisions_Scenario_Equipment_Xref_Cables_Journal_Mutation_Response>;
  /** delete single row from the table: "revisions.scenario_equipment_xref_cables_journal" */
  delete_revisions_scenario_equipment_xref_cables_journal_by_pk?: Maybe<Revisions_Scenario_Equipment_Xref_Cables_Journal>;
  /** delete data from the table: "revisions.scenario_equipment_xref_cables_revisions" */
  delete_revisions_scenario_equipment_xref_cables_revisions?: Maybe<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Mutation_Response>;
  /** delete single row from the table: "revisions.scenario_equipment_xref_cables_revisions" */
  delete_revisions_scenario_equipment_xref_cables_revisions_by_pk?: Maybe<Revisions_Scenario_Equipment_Xref_Cables_Revisions>;
  /** delete data from the table: "revisions.scenario_equipment_xref_housings_journal" */
  delete_revisions_scenario_equipment_xref_housings_journal?: Maybe<Revisions_Scenario_Equipment_Xref_Housings_Journal_Mutation_Response>;
  /** delete single row from the table: "revisions.scenario_equipment_xref_housings_journal" */
  delete_revisions_scenario_equipment_xref_housings_journal_by_pk?: Maybe<Revisions_Scenario_Equipment_Xref_Housings_Journal>;
  /** delete data from the table: "revisions.scenario_equipment_xref_housings_revisions" */
  delete_revisions_scenario_equipment_xref_housings_revisions?: Maybe<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Mutation_Response>;
  /** delete single row from the table: "revisions.scenario_equipment_xref_housings_revisions" */
  delete_revisions_scenario_equipment_xref_housings_revisions_by_pk?: Maybe<Revisions_Scenario_Equipment_Xref_Housings_Revisions>;
  /** delete data from the table: "revisions.scenario_equipment_xref_intakes_journal" */
  delete_revisions_scenario_equipment_xref_intakes_journal?: Maybe<Revisions_Scenario_Equipment_Xref_Intakes_Journal_Mutation_Response>;
  /** delete single row from the table: "revisions.scenario_equipment_xref_intakes_journal" */
  delete_revisions_scenario_equipment_xref_intakes_journal_by_pk?: Maybe<Revisions_Scenario_Equipment_Xref_Intakes_Journal>;
  /** delete data from the table: "revisions.scenario_equipment_xref_intakes_revisions" */
  delete_revisions_scenario_equipment_xref_intakes_revisions?: Maybe<Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Mutation_Response>;
  /** delete single row from the table: "revisions.scenario_equipment_xref_intakes_revisions" */
  delete_revisions_scenario_equipment_xref_intakes_revisions_by_pk?: Maybe<Revisions_Scenario_Equipment_Xref_Intakes_Revisions>;
  /** delete data from the table: "revisions.scenario_equipment_xref_pumps_journal" */
  delete_revisions_scenario_equipment_xref_pumps_journal?: Maybe<Revisions_Scenario_Equipment_Xref_Pumps_Journal_Mutation_Response>;
  /** delete single row from the table: "revisions.scenario_equipment_xref_pumps_journal" */
  delete_revisions_scenario_equipment_xref_pumps_journal_by_pk?: Maybe<Revisions_Scenario_Equipment_Xref_Pumps_Journal>;
  /** delete data from the table: "revisions.scenario_equipment_xref_pumps_revisions" */
  delete_revisions_scenario_equipment_xref_pumps_revisions?: Maybe<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Mutation_Response>;
  /** delete single row from the table: "revisions.scenario_equipment_xref_pumps_revisions" */
  delete_revisions_scenario_equipment_xref_pumps_revisions_by_pk?: Maybe<Revisions_Scenario_Equipment_Xref_Pumps_Revisions>;
  /** delete data from the table: "revisions.scenario_equipment_xref_seals_journal" */
  delete_revisions_scenario_equipment_xref_seals_journal?: Maybe<Revisions_Scenario_Equipment_Xref_Seals_Journal_Mutation_Response>;
  /** delete single row from the table: "revisions.scenario_equipment_xref_seals_journal" */
  delete_revisions_scenario_equipment_xref_seals_journal_by_pk?: Maybe<Revisions_Scenario_Equipment_Xref_Seals_Journal>;
  /** delete data from the table: "revisions.scenario_equipment_xref_seals_revisions" */
  delete_revisions_scenario_equipment_xref_seals_revisions?: Maybe<Revisions_Scenario_Equipment_Xref_Seals_Revisions_Mutation_Response>;
  /** delete single row from the table: "revisions.scenario_equipment_xref_seals_revisions" */
  delete_revisions_scenario_equipment_xref_seals_revisions_by_pk?: Maybe<Revisions_Scenario_Equipment_Xref_Seals_Revisions>;
  /** delete data from the table: "revisions.scenario_parameters_journal" */
  delete_revisions_scenario_parameters_journal?: Maybe<Revisions_Scenario_Parameters_Journal_Mutation_Response>;
  /** delete single row from the table: "revisions.scenario_parameters_journal" */
  delete_revisions_scenario_parameters_journal_by_pk?: Maybe<Revisions_Scenario_Parameters_Journal>;
  /** delete data from the table: "revisions.scenario_parameters_revisions" */
  delete_revisions_scenario_parameters_revisions?: Maybe<Revisions_Scenario_Parameters_Revisions_Mutation_Response>;
  /** delete single row from the table: "revisions.scenario_parameters_revisions" */
  delete_revisions_scenario_parameters_revisions_by_pk?: Maybe<Revisions_Scenario_Parameters_Revisions>;
  /** delete data from the table: "revisions.scenario_well_properties_journal" */
  delete_revisions_scenario_well_properties_journal?: Maybe<Revisions_Scenario_Well_Properties_Journal_Mutation_Response>;
  /** delete single row from the table: "revisions.scenario_well_properties_journal" */
  delete_revisions_scenario_well_properties_journal_by_pk?: Maybe<Revisions_Scenario_Well_Properties_Journal>;
  /** delete data from the table: "revisions.scenario_well_properties_revisions" */
  delete_revisions_scenario_well_properties_revisions?: Maybe<Revisions_Scenario_Well_Properties_Revisions_Mutation_Response>;
  /** delete single row from the table: "revisions.scenario_well_properties_revisions" */
  delete_revisions_scenario_well_properties_revisions_by_pk?: Maybe<Revisions_Scenario_Well_Properties_Revisions>;
  /** delete data from the table: "revisions.scenarios_journal" */
  delete_revisions_scenarios_journal?: Maybe<Revisions_Scenarios_Journal_Mutation_Response>;
  /** delete single row from the table: "revisions.scenarios_journal" */
  delete_revisions_scenarios_journal_by_pk?: Maybe<Revisions_Scenarios_Journal>;
  /** delete data from the table: "revisions.scenarios_revisions" */
  delete_revisions_scenarios_revisions?: Maybe<Revisions_Scenarios_Revisions_Mutation_Response>;
  /** delete single row from the table: "revisions.scenarios_revisions" */
  delete_revisions_scenarios_revisions_by_pk?: Maybe<Revisions_Scenarios_Revisions>;
  /** delete data from the table: "revisions.sizings_journal" */
  delete_revisions_sizings_journal?: Maybe<Revisions_Sizings_Journal_Mutation_Response>;
  /** delete single row from the table: "revisions.sizings_journal" */
  delete_revisions_sizings_journal_by_pk?: Maybe<Revisions_Sizings_Journal>;
  /** delete data from the table: "revisions.sizings_revisions" */
  delete_revisions_sizings_revisions?: Maybe<Revisions_Sizings_Revisions_Mutation_Response>;
  /** delete single row from the table: "revisions.sizings_revisions" */
  delete_revisions_sizings_revisions_by_pk?: Maybe<Revisions_Sizings_Revisions>;
  /** delete data from the table: "saturated_oil_options" */
  delete_saturated_oil_options?: Maybe<Saturated_Oil_Options_Mutation_Response>;
  /** delete single row from the table: "saturated_oil_options" */
  delete_saturated_oil_options_by_pk?: Maybe<Saturated_Oil_Options>;
  /** delete data from the table: "scenario_reasons" */
  delete_scenario_reasons?: Maybe<Scenario_Reasons_Mutation_Response>;
  /** delete single row from the table: "scenario_reasons" */
  delete_scenario_reasons_by_pk?: Maybe<Scenario_Reasons>;
  /** delete data from the table: "seal_motor_oil" */
  delete_seal_motor_oil?: Maybe<Seal_Motor_Oil_Mutation_Response>;
  /** delete single row from the table: "seal_motor_oil" */
  delete_seal_motor_oil_by_pk?: Maybe<Seal_Motor_Oil>;
  /** delete data from the table: "seals" */
  delete_seals?: Maybe<Seals_Mutation_Response>;
  /** delete single row from the table: "seals" */
  delete_seals_by_pk?: Maybe<Seals>;
  /** delete data from the table: "sensors" */
  delete_sensors?: Maybe<Sensors_Mutation_Response>;
  /** delete single row from the table: "sensors" */
  delete_sensors_by_pk?: Maybe<Sensors>;
  /** delete data from the table: "sizing_dispositions" */
  delete_sizing_dispositions?: Maybe<Sizing_Dispositions_Mutation_Response>;
  /** delete single row from the table: "sizing_dispositions" */
  delete_sizing_dispositions_by_pk?: Maybe<Sizing_Dispositions>;
  /** delete data from the table: "sizing_imports" */
  delete_sizing_imports?: Maybe<Sizing_Imports_Mutation_Response>;
  /** delete single row from the table: "sizing_imports" */
  delete_sizing_imports_by_pk?: Maybe<Sizing_Imports>;
  /** delete data from the table: "sizing_pumping_type" */
  delete_sizing_pumping_type?: Maybe<Sizing_Pumping_Type_Mutation_Response>;
  /** delete single row from the table: "sizing_pumping_type" */
  delete_sizing_pumping_type_by_pk?: Maybe<Sizing_Pumping_Type>;
  /** delete data from the table: "solution_gas_oil_ratio_options" */
  delete_solution_gas_oil_ratio_options?: Maybe<Solution_Gas_Oil_Ratio_Options_Mutation_Response>;
  /** delete single row from the table: "solution_gas_oil_ratio_options" */
  delete_solution_gas_oil_ratio_options_by_pk?: Maybe<Solution_Gas_Oil_Ratio_Options>;
  /** delete data from the table: "step_down_transformers" */
  delete_step_down_transformers?: Maybe<Step_Down_Transformers_Mutation_Response>;
  /** delete single row from the table: "step_down_transformers" */
  delete_step_down_transformers_by_pk?: Maybe<Step_Down_Transformers>;
  /** delete data from the table: "step_up_transformers" */
  delete_step_up_transformers?: Maybe<Step_Up_Transformers_Mutation_Response>;
  /** delete single row from the table: "step_up_transformers" */
  delete_step_up_transformers_by_pk?: Maybe<Step_Up_Transformers>;
  /** delete data from the table: "switchboards" */
  delete_switchboards?: Maybe<Switchboards_Mutation_Response>;
  /** delete single row from the table: "switchboards" */
  delete_switchboards_by_pk?: Maybe<Switchboards>;
  /** delete data from the table: "tubing_flow_options" */
  delete_tubing_flow_options?: Maybe<Tubing_Flow_Options_Mutation_Response>;
  /** delete single row from the table: "tubing_flow_options" */
  delete_tubing_flow_options_by_pk?: Maybe<Tubing_Flow_Options>;
  /** delete data from the table: "tubings" */
  delete_tubings?: Maybe<Tubings_Mutation_Response>;
  /** delete single row from the table: "tubings" */
  delete_tubings_by_pk?: Maybe<Tubings>;
  /** delete data from the table: "tubings_type" */
  delete_tubings_type?: Maybe<Tubings_Type_Mutation_Response>;
  /** delete single row from the table: "tubings_type" */
  delete_tubings_type_by_pk?: Maybe<Tubings_Type>;
  /** delete data from the table: "under_saturated_oil_options" */
  delete_under_saturated_oil_options?: Maybe<Under_Saturated_Oil_Options_Mutation_Response>;
  /** delete single row from the table: "under_saturated_oil_options" */
  delete_under_saturated_oil_options_by_pk?: Maybe<Under_Saturated_Oil_Options>;
  /** delete data from the table: "user_eula_acceptance" */
  delete_user_eula_acceptance?: Maybe<User_Eula_Acceptance_Mutation_Response>;
  /** delete single row from the table: "user_eula_acceptance" */
  delete_user_eula_acceptance_by_pk?: Maybe<User_Eula_Acceptance>;
  /** delete data from the table: "users" */
  delete_users?: Maybe<Users_Mutation_Response>;
  /** delete single row from the table: "users" */
  delete_users_by_pk?: Maybe<Users>;
  /** delete data from the table: "variable_speed_drives" */
  delete_variable_speed_drives?: Maybe<Variable_Speed_Drives_Mutation_Response>;
  /** delete single row from the table: "variable_speed_drives" */
  delete_variable_speed_drives_by_pk?: Maybe<Variable_Speed_Drives>;
  /** delete data from the table: "water_density_options" */
  delete_water_density_options?: Maybe<Water_Density_Options_Mutation_Response>;
  /** delete single row from the table: "water_density_options" */
  delete_water_density_options_by_pk?: Maybe<Water_Density_Options>;
  /** delete data from the table: "water_solution_gas_options" */
  delete_water_solution_gas_options?: Maybe<Water_Solution_Gas_Options_Mutation_Response>;
  /** delete single row from the table: "water_solution_gas_options" */
  delete_water_solution_gas_options_by_pk?: Maybe<Water_Solution_Gas_Options>;
  /** delete data from the table: "water_viscosity_options" */
  delete_water_viscosity_options?: Maybe<Water_Viscosity_Options_Mutation_Response>;
  /** delete single row from the table: "water_viscosity_options" */
  delete_water_viscosity_options_by_pk?: Maybe<Water_Viscosity_Options>;
  /** delete data from the table: "water_volume_factor_options" */
  delete_water_volume_factor_options?: Maybe<Water_Volume_Factor_Options_Mutation_Response>;
  /** delete single row from the table: "water_volume_factor_options" */
  delete_water_volume_factor_options_by_pk?: Maybe<Water_Volume_Factor_Options>;
  /** delete data from the table: "well_gas_type_options" */
  delete_well_gas_type_options?: Maybe<Well_Gas_Type_Options_Mutation_Response>;
  /** delete single row from the table: "well_gas_type_options" */
  delete_well_gas_type_options_by_pk?: Maybe<Well_Gas_Type_Options>;
  /** delete data from the table: "well_test_gas_input_options" */
  delete_well_test_gas_input_options?: Maybe<Well_Test_Gas_Input_Options_Mutation_Response>;
  /** delete single row from the table: "well_test_gas_input_options" */
  delete_well_test_gas_input_options_by_pk?: Maybe<Well_Test_Gas_Input_Options>;
  /** delete data from the table: "well_test_liquid_input_options" */
  delete_well_test_liquid_input_options?: Maybe<Well_Test_Liquid_Input_Options_Mutation_Response>;
  /** delete single row from the table: "well_test_liquid_input_options" */
  delete_well_test_liquid_input_options_by_pk?: Maybe<Well_Test_Liquid_Input_Options>;
  /** delete data from the table: "well_test_pressure_input_options" */
  delete_well_test_pressure_input_options?: Maybe<Well_Test_Pressure_Input_Options_Mutation_Response>;
  /** delete single row from the table: "well_test_pressure_input_options" */
  delete_well_test_pressure_input_options_by_pk?: Maybe<Well_Test_Pressure_Input_Options>;
  /** delete data from the table: "wells" */
  delete_wells?: Maybe<Wells_Mutation_Response>;
  /** delete single row from the table: "wells" */
  delete_wells_by_pk?: Maybe<Wells>;
  /** delete data from the table: "y_tools" */
  delete_y_tools?: Maybe<Y_Tools_Mutation_Response>;
  /** delete single row from the table: "y_tools" */
  delete_y_tools_by_pk?: Maybe<Y_Tools>;
  /** insert data into the table: "bolt_on_discharges" */
  insert_bolt_on_discharges?: Maybe<Bolt_On_Discharges_Mutation_Response>;
  /** insert a single row into the table: "bolt_on_discharges" */
  insert_bolt_on_discharges_one?: Maybe<Bolt_On_Discharges>;
  /** insert data into the table: "bubble_point_options" */
  insert_bubble_point_options?: Maybe<Bubble_Point_Options_Mutation_Response>;
  /** insert a single row into the table: "bubble_point_options" */
  insert_bubble_point_options_one?: Maybe<Bubble_Point_Options>;
  /** insert data into the table: "cables" */
  insert_cables?: Maybe<Cables_Mutation_Response>;
  /** insert a single row into the table: "cables" */
  insert_cables_one?: Maybe<Cables>;
  /** insert data into the table: "casing_flow_options" */
  insert_casing_flow_options?: Maybe<Casing_Flow_Options_Mutation_Response>;
  /** insert a single row into the table: "casing_flow_options" */
  insert_casing_flow_options_one?: Maybe<Casing_Flow_Options>;
  /** insert data into the table: "casings" */
  insert_casings?: Maybe<Casings_Mutation_Response>;
  /** insert a single row into the table: "casings" */
  insert_casings_one?: Maybe<Casings>;
  /** insert data into the table: "casings_type" */
  insert_casings_type?: Maybe<Casings_Type_Mutation_Response>;
  /** insert a single row into the table: "casings_type" */
  insert_casings_type_one?: Maybe<Casings_Type>;
  /** insert data into the table: "customers" */
  insert_customers?: Maybe<Customers_Mutation_Response>;
  /** insert a single row into the table: "customers" */
  insert_customers_one?: Maybe<Customers>;
  /** insert data into the table: "dead_oil_options" */
  insert_dead_oil_options?: Maybe<Dead_Oil_Options_Mutation_Response>;
  /** insert a single row into the table: "dead_oil_options" */
  insert_dead_oil_options_one?: Maybe<Dead_Oil_Options>;
  /** insert data into the table: "deviation_survey" */
  insert_deviation_survey?: Maybe<Deviation_Survey_Mutation_Response>;
  /** insert data into the table: "deviation_survey_directional_dataset" */
  insert_deviation_survey_directional_dataset?: Maybe<Deviation_Survey_Directional_Dataset_Mutation_Response>;
  /** insert a single row into the table: "deviation_survey_directional_dataset" */
  insert_deviation_survey_directional_dataset_one?: Maybe<Deviation_Survey_Directional_Dataset>;
  /** insert a single row into the table: "deviation_survey" */
  insert_deviation_survey_one?: Maybe<Deviation_Survey>;
  /** insert data into the table: "display_units" */
  insert_display_units?: Maybe<Display_Units_Mutation_Response>;
  /** insert a single row into the table: "display_units" */
  insert_display_units_one?: Maybe<Display_Units>;
  /** insert data into the table: "eula" */
  insert_eula?: Maybe<Eula_Mutation_Response>;
  /** insert a single row into the table: "eula" */
  insert_eula_one?: Maybe<Eula>;
  /** insert data into the table: "flow_model" */
  insert_flow_model?: Maybe<Flow_Model_Mutation_Response>;
  /** insert data into the table: "flow_model_active" */
  insert_flow_model_active?: Maybe<Flow_Model_Active_Mutation_Response>;
  /** insert a single row into the table: "flow_model_active" */
  insert_flow_model_active_one?: Maybe<Flow_Model_Active>;
  /** insert data into the table: "flow_model_deprecated" */
  insert_flow_model_deprecated?: Maybe<Flow_Model_Deprecated_Mutation_Response>;
  /** insert a single row into the table: "flow_model_deprecated" */
  insert_flow_model_deprecated_one?: Maybe<Flow_Model_Deprecated>;
  /** insert a single row into the table: "flow_model" */
  insert_flow_model_one?: Maybe<Flow_Model>;
  /** insert data into the table: "friction_loss_options" */
  insert_friction_loss_options?: Maybe<Friction_Loss_Options_Mutation_Response>;
  /** insert a single row into the table: "friction_loss_options" */
  insert_friction_loss_options_one?: Maybe<Friction_Loss_Options>;
  /** insert data into the table: "gas_compressibility_options" */
  insert_gas_compressibility_options?: Maybe<Gas_Compressibility_Options_Mutation_Response>;
  /** insert a single row into the table: "gas_compressibility_options" */
  insert_gas_compressibility_options_one?: Maybe<Gas_Compressibility_Options>;
  /** insert data into the table: "gas_viscosity_options" */
  insert_gas_viscosity_options?: Maybe<Gas_Viscosity_Options_Mutation_Response>;
  /** insert a single row into the table: "gas_viscosity_options" */
  insert_gas_viscosity_options_one?: Maybe<Gas_Viscosity_Options>;
  /** insert data into the table: "housings" */
  insert_housings?: Maybe<Housings_Mutation_Response>;
  /** insert a single row into the table: "housings" */
  insert_housings_one?: Maybe<Housings>;
  /** insert data into the table: "hps_liquid_type" */
  insert_hps_liquid_type?: Maybe<Hps_Liquid_Type_Mutation_Response>;
  /** insert a single row into the table: "hps_liquid_type" */
  insert_hps_liquid_type_one?: Maybe<Hps_Liquid_Type>;
  /** insert data into the table: "intakes" */
  insert_intakes?: Maybe<Intakes_Mutation_Response>;
  /** insert a single row into the table: "intakes" */
  insert_intakes_one?: Maybe<Intakes>;
  /** insert data into the table: "legacy_users" */
  insert_legacy_users?: Maybe<Legacy_Users_Mutation_Response>;
  /** insert a single row into the table: "legacy_users" */
  insert_legacy_users_one?: Maybe<Legacy_Users>;
  /** insert data into the table: "motor_lead_extensions" */
  insert_motor_lead_extensions?: Maybe<Motor_Lead_Extensions_Mutation_Response>;
  /** insert a single row into the table: "motor_lead_extensions" */
  insert_motor_lead_extensions_one?: Maybe<Motor_Lead_Extensions>;
  /** insert data into the table: "motors" */
  insert_motors?: Maybe<Motors_Mutation_Response>;
  /** insert a single row into the table: "motors" */
  insert_motors_one?: Maybe<Motors>;
  /** insert data into the table: "natural_gas_separation_options" */
  insert_natural_gas_separation_options?: Maybe<Natural_Gas_Separation_Options_Mutation_Response>;
  /** insert a single row into the table: "natural_gas_separation_options" */
  insert_natural_gas_separation_options_one?: Maybe<Natural_Gas_Separation_Options>;
  /** insert data into the table: "oil_density_options" */
  insert_oil_density_options?: Maybe<Oil_Density_Options_Mutation_Response>;
  /** insert a single row into the table: "oil_density_options" */
  insert_oil_density_options_one?: Maybe<Oil_Density_Options>;
  /** insert data into the table: "oil_volume_factor_options" */
  insert_oil_volume_factor_options?: Maybe<Oil_Volume_Factor_Options_Mutation_Response>;
  /** insert a single row into the table: "oil_volume_factor_options" */
  insert_oil_volume_factor_options_one?: Maybe<Oil_Volume_Factor_Options>;
  /** insert data into the table: "override_options" */
  insert_override_options?: Maybe<Override_Options_Mutation_Response>;
  /** insert a single row into the table: "override_options" */
  insert_override_options_one?: Maybe<Override_Options>;
  /** insert data into the table: "pumps" */
  insert_pumps?: Maybe<Pumps_Mutation_Response>;
  /** insert a single row into the table: "pumps" */
  insert_pumps_one?: Maybe<Pumps>;
  /** insert data into the table: "quote_line_item_category_dataset" */
  insert_quote_line_item_category_dataset?: Maybe<Quote_Line_Item_Category_Dataset_Mutation_Response>;
  /** insert a single row into the table: "quote_line_item_category_dataset" */
  insert_quote_line_item_category_dataset_one?: Maybe<Quote_Line_Item_Category_Dataset>;
  /** insert data into the table: "quote_line_item_serialized_dataset" */
  insert_quote_line_item_serialized_dataset?: Maybe<Quote_Line_Item_Serialized_Dataset_Mutation_Response>;
  /** insert a single row into the table: "quote_line_item_serialized_dataset" */
  insert_quote_line_item_serialized_dataset_one?: Maybe<Quote_Line_Item_Serialized_Dataset>;
  /** insert data into the table: "quote_line_item_source_dataset" */
  insert_quote_line_item_source_dataset?: Maybe<Quote_Line_Item_Source_Dataset_Mutation_Response>;
  /** insert a single row into the table: "quote_line_item_source_dataset" */
  insert_quote_line_item_source_dataset_one?: Maybe<Quote_Line_Item_Source_Dataset>;
  /** insert data into the table: "quote_line_item_subcategory_dataset" */
  insert_quote_line_item_subcategory_dataset?: Maybe<Quote_Line_Item_Subcategory_Dataset_Mutation_Response>;
  /** insert a single row into the table: "quote_line_item_subcategory_dataset" */
  insert_quote_line_item_subcategory_dataset_one?: Maybe<Quote_Line_Item_Subcategory_Dataset>;
  /** insert data into the table: "quote_line_item_tax_type_dataset" */
  insert_quote_line_item_tax_type_dataset?: Maybe<Quote_Line_Item_Tax_Type_Dataset_Mutation_Response>;
  /** insert a single row into the table: "quote_line_item_tax_type_dataset" */
  insert_quote_line_item_tax_type_dataset_one?: Maybe<Quote_Line_Item_Tax_Type_Dataset>;
  /** insert data into the table: "quote_line_item_type_dataset" */
  insert_quote_line_item_type_dataset?: Maybe<Quote_Line_Item_Type_Dataset_Mutation_Response>;
  /** insert a single row into the table: "quote_line_item_type_dataset" */
  insert_quote_line_item_type_dataset_one?: Maybe<Quote_Line_Item_Type_Dataset>;
  /** insert data into the table: "quote_line_items" */
  insert_quote_line_items?: Maybe<Quote_Line_Items_Mutation_Response>;
  /** insert a single row into the table: "quote_line_items" */
  insert_quote_line_items_one?: Maybe<Quote_Line_Items>;
  /** insert data into the table: "quote_sk_job_type_dataset" */
  insert_quote_sk_job_type_dataset?: Maybe<Quote_Sk_Job_Type_Dataset_Mutation_Response>;
  /** insert a single row into the table: "quote_sk_job_type_dataset" */
  insert_quote_sk_job_type_dataset_one?: Maybe<Quote_Sk_Job_Type_Dataset>;
  /** insert data into the table: "quote_source_dataset" */
  insert_quote_source_dataset?: Maybe<Quote_Source_Dataset_Mutation_Response>;
  /** insert a single row into the table: "quote_source_dataset" */
  insert_quote_source_dataset_one?: Maybe<Quote_Source_Dataset>;
  /** insert data into the table: "quote_status_dataset" */
  insert_quote_status_dataset?: Maybe<Quote_Status_Dataset_Mutation_Response>;
  /** insert a single row into the table: "quote_status_dataset" */
  insert_quote_status_dataset_one?: Maybe<Quote_Status_Dataset>;
  /** insert data into the table: "quote_user_messages" */
  insert_quote_user_messages?: Maybe<Quote_User_Messages_Mutation_Response>;
  /** insert a single row into the table: "quote_user_messages" */
  insert_quote_user_messages_one?: Maybe<Quote_User_Messages>;
  /** insert data into the table: "quotes" */
  insert_quotes?: Maybe<Quotes_Mutation_Response>;
  /** insert a single row into the table: "quotes" */
  insert_quotes_one?: Maybe<Quotes>;
  /** insert data into the table: "revisions.performance_evaluations_journal" */
  insert_revisions_performance_evaluations_journal?: Maybe<Revisions_Performance_Evaluations_Journal_Mutation_Response>;
  /** insert a single row into the table: "revisions.performance_evaluations_journal" */
  insert_revisions_performance_evaluations_journal_one?: Maybe<Revisions_Performance_Evaluations_Journal>;
  /** insert data into the table: "revisions.performance_evaluations_revisions" */
  insert_revisions_performance_evaluations_revisions?: Maybe<Revisions_Performance_Evaluations_Revisions_Mutation_Response>;
  /** insert a single row into the table: "revisions.performance_evaluations_revisions" */
  insert_revisions_performance_evaluations_revisions_one?: Maybe<Revisions_Performance_Evaluations_Revisions>;
  /** insert data into the table: "revisions.performance_evaluations_xref_pumps_journal" */
  insert_revisions_performance_evaluations_xref_pumps_journal?: Maybe<Revisions_Performance_Evaluations_Xref_Pumps_Journal_Mutation_Response>;
  /** insert a single row into the table: "revisions.performance_evaluations_xref_pumps_journal" */
  insert_revisions_performance_evaluations_xref_pumps_journal_one?: Maybe<Revisions_Performance_Evaluations_Xref_Pumps_Journal>;
  /** insert data into the table: "revisions.performance_evaluations_xref_pumps_revisions" */
  insert_revisions_performance_evaluations_xref_pumps_revisions?: Maybe<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Mutation_Response>;
  /** insert a single row into the table: "revisions.performance_evaluations_xref_pumps_revisions" */
  insert_revisions_performance_evaluations_xref_pumps_revisions_one?: Maybe<Revisions_Performance_Evaluations_Xref_Pumps_Revisions>;
  /** insert data into the table: "revisions.sc_equip_xref_downhole_ytool_bypass_tubings_journal" */
  insert_revisions_sc_equip_xref_downhole_ytool_bypass_tubings_journal?: Maybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_Mutation_Response>;
  /** insert a single row into the table: "revisions.sc_equip_xref_downhole_ytool_bypass_tubings_journal" */
  insert_revisions_sc_equip_xref_downhole_ytool_bypass_tubings_journal_one?: Maybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal>;
  /** insert data into the table: "revisions.sc_equip_xref_downhole_ytool_bypass_tubings_revisions" */
  insert_revisions_sc_equip_xref_downhole_ytool_bypass_tubings_revisions?: Maybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Mutation_Response>;
  /** insert a single row into the table: "revisions.sc_equip_xref_downhole_ytool_bypass_tubings_revisions" */
  insert_revisions_sc_equip_xref_downhole_ytool_bypass_tubings_revisions_one?: Maybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions>;
  /** insert data into the table: "revisions.sc_equip_xref_downhole_ytool_equip_tubings_journal" */
  insert_revisions_sc_equip_xref_downhole_ytool_equip_tubings_journal?: Maybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_Mutation_Response>;
  /** insert a single row into the table: "revisions.sc_equip_xref_downhole_ytool_equip_tubings_journal" */
  insert_revisions_sc_equip_xref_downhole_ytool_equip_tubings_journal_one?: Maybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal>;
  /** insert data into the table: "revisions.sc_equip_xref_downhole_ytool_equip_tubings_revisions" */
  insert_revisions_sc_equip_xref_downhole_ytool_equip_tubings_revisions?: Maybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Mutation_Response>;
  /** insert a single row into the table: "revisions.sc_equip_xref_downhole_ytool_equip_tubings_revisions" */
  insert_revisions_sc_equip_xref_downhole_ytool_equip_tubings_revisions_one?: Maybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions>;
  /** insert data into the table: "revisions.sc_equip_xref_uphole_ytool_bypass_tubings_journal" */
  insert_revisions_sc_equip_xref_uphole_ytool_bypass_tubings_journal?: Maybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_Mutation_Response>;
  /** insert a single row into the table: "revisions.sc_equip_xref_uphole_ytool_bypass_tubings_journal" */
  insert_revisions_sc_equip_xref_uphole_ytool_bypass_tubings_journal_one?: Maybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal>;
  /** insert data into the table: "revisions.sc_equip_xref_uphole_ytool_bypass_tubings_revisions" */
  insert_revisions_sc_equip_xref_uphole_ytool_bypass_tubings_revisions?: Maybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Mutation_Response>;
  /** insert a single row into the table: "revisions.sc_equip_xref_uphole_ytool_bypass_tubings_revisions" */
  insert_revisions_sc_equip_xref_uphole_ytool_bypass_tubings_revisions_one?: Maybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions>;
  /** insert data into the table: "revisions.sc_equip_xref_uphole_ytool_equip_tubings_journal" */
  insert_revisions_sc_equip_xref_uphole_ytool_equip_tubings_journal?: Maybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_Mutation_Response>;
  /** insert a single row into the table: "revisions.sc_equip_xref_uphole_ytool_equip_tubings_journal" */
  insert_revisions_sc_equip_xref_uphole_ytool_equip_tubings_journal_one?: Maybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal>;
  /** insert data into the table: "revisions.sc_equip_xref_uphole_ytool_equip_tubings_revisions" */
  insert_revisions_sc_equip_xref_uphole_ytool_equip_tubings_revisions?: Maybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Mutation_Response>;
  /** insert a single row into the table: "revisions.sc_equip_xref_uphole_ytool_equip_tubings_revisions" */
  insert_revisions_sc_equip_xref_uphole_ytool_equip_tubings_revisions_one?: Maybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions>;
  /** insert data into the table: "revisions.scenario_correlations_journal" */
  insert_revisions_scenario_correlations_journal?: Maybe<Revisions_Scenario_Correlations_Journal_Mutation_Response>;
  /** insert a single row into the table: "revisions.scenario_correlations_journal" */
  insert_revisions_scenario_correlations_journal_one?: Maybe<Revisions_Scenario_Correlations_Journal>;
  /** insert data into the table: "revisions.scenario_correlations_revisions" */
  insert_revisions_scenario_correlations_revisions?: Maybe<Revisions_Scenario_Correlations_Revisions_Mutation_Response>;
  /** insert a single row into the table: "revisions.scenario_correlations_revisions" */
  insert_revisions_scenario_correlations_revisions_one?: Maybe<Revisions_Scenario_Correlations_Revisions>;
  /** insert data into the table: "revisions.scenario_equipment_journal" */
  insert_revisions_scenario_equipment_journal?: Maybe<Revisions_Scenario_Equipment_Journal_Mutation_Response>;
  /** insert a single row into the table: "revisions.scenario_equipment_journal" */
  insert_revisions_scenario_equipment_journal_one?: Maybe<Revisions_Scenario_Equipment_Journal>;
  /** insert data into the table: "revisions.scenario_equipment_revisions" */
  insert_revisions_scenario_equipment_revisions?: Maybe<Revisions_Scenario_Equipment_Revisions_Mutation_Response>;
  /** insert a single row into the table: "revisions.scenario_equipment_revisions" */
  insert_revisions_scenario_equipment_revisions_one?: Maybe<Revisions_Scenario_Equipment_Revisions>;
  /** insert data into the table: "revisions.scenario_equipment_xref_cables_journal" */
  insert_revisions_scenario_equipment_xref_cables_journal?: Maybe<Revisions_Scenario_Equipment_Xref_Cables_Journal_Mutation_Response>;
  /** insert a single row into the table: "revisions.scenario_equipment_xref_cables_journal" */
  insert_revisions_scenario_equipment_xref_cables_journal_one?: Maybe<Revisions_Scenario_Equipment_Xref_Cables_Journal>;
  /** insert data into the table: "revisions.scenario_equipment_xref_cables_revisions" */
  insert_revisions_scenario_equipment_xref_cables_revisions?: Maybe<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Mutation_Response>;
  /** insert a single row into the table: "revisions.scenario_equipment_xref_cables_revisions" */
  insert_revisions_scenario_equipment_xref_cables_revisions_one?: Maybe<Revisions_Scenario_Equipment_Xref_Cables_Revisions>;
  /** insert data into the table: "revisions.scenario_equipment_xref_housings_journal" */
  insert_revisions_scenario_equipment_xref_housings_journal?: Maybe<Revisions_Scenario_Equipment_Xref_Housings_Journal_Mutation_Response>;
  /** insert a single row into the table: "revisions.scenario_equipment_xref_housings_journal" */
  insert_revisions_scenario_equipment_xref_housings_journal_one?: Maybe<Revisions_Scenario_Equipment_Xref_Housings_Journal>;
  /** insert data into the table: "revisions.scenario_equipment_xref_housings_revisions" */
  insert_revisions_scenario_equipment_xref_housings_revisions?: Maybe<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Mutation_Response>;
  /** insert a single row into the table: "revisions.scenario_equipment_xref_housings_revisions" */
  insert_revisions_scenario_equipment_xref_housings_revisions_one?: Maybe<Revisions_Scenario_Equipment_Xref_Housings_Revisions>;
  /** insert data into the table: "revisions.scenario_equipment_xref_intakes_journal" */
  insert_revisions_scenario_equipment_xref_intakes_journal?: Maybe<Revisions_Scenario_Equipment_Xref_Intakes_Journal_Mutation_Response>;
  /** insert a single row into the table: "revisions.scenario_equipment_xref_intakes_journal" */
  insert_revisions_scenario_equipment_xref_intakes_journal_one?: Maybe<Revisions_Scenario_Equipment_Xref_Intakes_Journal>;
  /** insert data into the table: "revisions.scenario_equipment_xref_intakes_revisions" */
  insert_revisions_scenario_equipment_xref_intakes_revisions?: Maybe<Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Mutation_Response>;
  /** insert a single row into the table: "revisions.scenario_equipment_xref_intakes_revisions" */
  insert_revisions_scenario_equipment_xref_intakes_revisions_one?: Maybe<Revisions_Scenario_Equipment_Xref_Intakes_Revisions>;
  /** insert data into the table: "revisions.scenario_equipment_xref_pumps_journal" */
  insert_revisions_scenario_equipment_xref_pumps_journal?: Maybe<Revisions_Scenario_Equipment_Xref_Pumps_Journal_Mutation_Response>;
  /** insert a single row into the table: "revisions.scenario_equipment_xref_pumps_journal" */
  insert_revisions_scenario_equipment_xref_pumps_journal_one?: Maybe<Revisions_Scenario_Equipment_Xref_Pumps_Journal>;
  /** insert data into the table: "revisions.scenario_equipment_xref_pumps_revisions" */
  insert_revisions_scenario_equipment_xref_pumps_revisions?: Maybe<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Mutation_Response>;
  /** insert a single row into the table: "revisions.scenario_equipment_xref_pumps_revisions" */
  insert_revisions_scenario_equipment_xref_pumps_revisions_one?: Maybe<Revisions_Scenario_Equipment_Xref_Pumps_Revisions>;
  /** insert data into the table: "revisions.scenario_equipment_xref_seals_journal" */
  insert_revisions_scenario_equipment_xref_seals_journal?: Maybe<Revisions_Scenario_Equipment_Xref_Seals_Journal_Mutation_Response>;
  /** insert a single row into the table: "revisions.scenario_equipment_xref_seals_journal" */
  insert_revisions_scenario_equipment_xref_seals_journal_one?: Maybe<Revisions_Scenario_Equipment_Xref_Seals_Journal>;
  /** insert data into the table: "revisions.scenario_equipment_xref_seals_revisions" */
  insert_revisions_scenario_equipment_xref_seals_revisions?: Maybe<Revisions_Scenario_Equipment_Xref_Seals_Revisions_Mutation_Response>;
  /** insert a single row into the table: "revisions.scenario_equipment_xref_seals_revisions" */
  insert_revisions_scenario_equipment_xref_seals_revisions_one?: Maybe<Revisions_Scenario_Equipment_Xref_Seals_Revisions>;
  /** insert data into the table: "revisions.scenario_parameters_journal" */
  insert_revisions_scenario_parameters_journal?: Maybe<Revisions_Scenario_Parameters_Journal_Mutation_Response>;
  /** insert a single row into the table: "revisions.scenario_parameters_journal" */
  insert_revisions_scenario_parameters_journal_one?: Maybe<Revisions_Scenario_Parameters_Journal>;
  /** insert data into the table: "revisions.scenario_parameters_revisions" */
  insert_revisions_scenario_parameters_revisions?: Maybe<Revisions_Scenario_Parameters_Revisions_Mutation_Response>;
  /** insert a single row into the table: "revisions.scenario_parameters_revisions" */
  insert_revisions_scenario_parameters_revisions_one?: Maybe<Revisions_Scenario_Parameters_Revisions>;
  /** insert data into the table: "revisions.scenario_well_properties_journal" */
  insert_revisions_scenario_well_properties_journal?: Maybe<Revisions_Scenario_Well_Properties_Journal_Mutation_Response>;
  /** insert a single row into the table: "revisions.scenario_well_properties_journal" */
  insert_revisions_scenario_well_properties_journal_one?: Maybe<Revisions_Scenario_Well_Properties_Journal>;
  /** insert data into the table: "revisions.scenario_well_properties_revisions" */
  insert_revisions_scenario_well_properties_revisions?: Maybe<Revisions_Scenario_Well_Properties_Revisions_Mutation_Response>;
  /** insert a single row into the table: "revisions.scenario_well_properties_revisions" */
  insert_revisions_scenario_well_properties_revisions_one?: Maybe<Revisions_Scenario_Well_Properties_Revisions>;
  /** insert data into the table: "revisions.scenarios_journal" */
  insert_revisions_scenarios_journal?: Maybe<Revisions_Scenarios_Journal_Mutation_Response>;
  /** insert a single row into the table: "revisions.scenarios_journal" */
  insert_revisions_scenarios_journal_one?: Maybe<Revisions_Scenarios_Journal>;
  /** insert data into the table: "revisions.scenarios_revisions" */
  insert_revisions_scenarios_revisions?: Maybe<Revisions_Scenarios_Revisions_Mutation_Response>;
  /** insert a single row into the table: "revisions.scenarios_revisions" */
  insert_revisions_scenarios_revisions_one?: Maybe<Revisions_Scenarios_Revisions>;
  /** insert data into the table: "revisions.sizings_journal" */
  insert_revisions_sizings_journal?: Maybe<Revisions_Sizings_Journal_Mutation_Response>;
  /** insert a single row into the table: "revisions.sizings_journal" */
  insert_revisions_sizings_journal_one?: Maybe<Revisions_Sizings_Journal>;
  /** insert data into the table: "revisions.sizings_revisions" */
  insert_revisions_sizings_revisions?: Maybe<Revisions_Sizings_Revisions_Mutation_Response>;
  /** insert a single row into the table: "revisions.sizings_revisions" */
  insert_revisions_sizings_revisions_one?: Maybe<Revisions_Sizings_Revisions>;
  /** insert data into the table: "saturated_oil_options" */
  insert_saturated_oil_options?: Maybe<Saturated_Oil_Options_Mutation_Response>;
  /** insert a single row into the table: "saturated_oil_options" */
  insert_saturated_oil_options_one?: Maybe<Saturated_Oil_Options>;
  /** insert data into the table: "scenario_reasons" */
  insert_scenario_reasons?: Maybe<Scenario_Reasons_Mutation_Response>;
  /** insert a single row into the table: "scenario_reasons" */
  insert_scenario_reasons_one?: Maybe<Scenario_Reasons>;
  /** insert data into the table: "seal_motor_oil" */
  insert_seal_motor_oil?: Maybe<Seal_Motor_Oil_Mutation_Response>;
  /** insert a single row into the table: "seal_motor_oil" */
  insert_seal_motor_oil_one?: Maybe<Seal_Motor_Oil>;
  /** insert data into the table: "seals" */
  insert_seals?: Maybe<Seals_Mutation_Response>;
  /** insert a single row into the table: "seals" */
  insert_seals_one?: Maybe<Seals>;
  /** insert data into the table: "sensors" */
  insert_sensors?: Maybe<Sensors_Mutation_Response>;
  /** insert a single row into the table: "sensors" */
  insert_sensors_one?: Maybe<Sensors>;
  /** insert data into the table: "sizing_dispositions" */
  insert_sizing_dispositions?: Maybe<Sizing_Dispositions_Mutation_Response>;
  /** insert a single row into the table: "sizing_dispositions" */
  insert_sizing_dispositions_one?: Maybe<Sizing_Dispositions>;
  /** insert data into the table: "sizing_imports" */
  insert_sizing_imports?: Maybe<Sizing_Imports_Mutation_Response>;
  /** insert a single row into the table: "sizing_imports" */
  insert_sizing_imports_one?: Maybe<Sizing_Imports>;
  /** insert data into the table: "sizing_pumping_type" */
  insert_sizing_pumping_type?: Maybe<Sizing_Pumping_Type_Mutation_Response>;
  /** insert a single row into the table: "sizing_pumping_type" */
  insert_sizing_pumping_type_one?: Maybe<Sizing_Pumping_Type>;
  /** insert data into the table: "solution_gas_oil_ratio_options" */
  insert_solution_gas_oil_ratio_options?: Maybe<Solution_Gas_Oil_Ratio_Options_Mutation_Response>;
  /** insert a single row into the table: "solution_gas_oil_ratio_options" */
  insert_solution_gas_oil_ratio_options_one?: Maybe<Solution_Gas_Oil_Ratio_Options>;
  /** insert data into the table: "step_down_transformers" */
  insert_step_down_transformers?: Maybe<Step_Down_Transformers_Mutation_Response>;
  /** insert a single row into the table: "step_down_transformers" */
  insert_step_down_transformers_one?: Maybe<Step_Down_Transformers>;
  /** insert data into the table: "step_up_transformers" */
  insert_step_up_transformers?: Maybe<Step_Up_Transformers_Mutation_Response>;
  /** insert a single row into the table: "step_up_transformers" */
  insert_step_up_transformers_one?: Maybe<Step_Up_Transformers>;
  /** insert data into the table: "switchboards" */
  insert_switchboards?: Maybe<Switchboards_Mutation_Response>;
  /** insert a single row into the table: "switchboards" */
  insert_switchboards_one?: Maybe<Switchboards>;
  /** insert data into the table: "tubing_flow_options" */
  insert_tubing_flow_options?: Maybe<Tubing_Flow_Options_Mutation_Response>;
  /** insert a single row into the table: "tubing_flow_options" */
  insert_tubing_flow_options_one?: Maybe<Tubing_Flow_Options>;
  /** insert data into the table: "tubings" */
  insert_tubings?: Maybe<Tubings_Mutation_Response>;
  /** insert a single row into the table: "tubings" */
  insert_tubings_one?: Maybe<Tubings>;
  /** insert data into the table: "tubings_type" */
  insert_tubings_type?: Maybe<Tubings_Type_Mutation_Response>;
  /** insert a single row into the table: "tubings_type" */
  insert_tubings_type_one?: Maybe<Tubings_Type>;
  /** insert data into the table: "under_saturated_oil_options" */
  insert_under_saturated_oil_options?: Maybe<Under_Saturated_Oil_Options_Mutation_Response>;
  /** insert a single row into the table: "under_saturated_oil_options" */
  insert_under_saturated_oil_options_one?: Maybe<Under_Saturated_Oil_Options>;
  /** insert data into the table: "user_eula_acceptance" */
  insert_user_eula_acceptance?: Maybe<User_Eula_Acceptance_Mutation_Response>;
  /** insert a single row into the table: "user_eula_acceptance" */
  insert_user_eula_acceptance_one?: Maybe<User_Eula_Acceptance>;
  /** insert data into the table: "users" */
  insert_users?: Maybe<Users_Mutation_Response>;
  /** insert a single row into the table: "users" */
  insert_users_one?: Maybe<Users>;
  /** insert data into the table: "variable_speed_drives" */
  insert_variable_speed_drives?: Maybe<Variable_Speed_Drives_Mutation_Response>;
  /** insert a single row into the table: "variable_speed_drives" */
  insert_variable_speed_drives_one?: Maybe<Variable_Speed_Drives>;
  /** insert data into the table: "water_density_options" */
  insert_water_density_options?: Maybe<Water_Density_Options_Mutation_Response>;
  /** insert a single row into the table: "water_density_options" */
  insert_water_density_options_one?: Maybe<Water_Density_Options>;
  /** insert data into the table: "water_solution_gas_options" */
  insert_water_solution_gas_options?: Maybe<Water_Solution_Gas_Options_Mutation_Response>;
  /** insert a single row into the table: "water_solution_gas_options" */
  insert_water_solution_gas_options_one?: Maybe<Water_Solution_Gas_Options>;
  /** insert data into the table: "water_viscosity_options" */
  insert_water_viscosity_options?: Maybe<Water_Viscosity_Options_Mutation_Response>;
  /** insert a single row into the table: "water_viscosity_options" */
  insert_water_viscosity_options_one?: Maybe<Water_Viscosity_Options>;
  /** insert data into the table: "water_volume_factor_options" */
  insert_water_volume_factor_options?: Maybe<Water_Volume_Factor_Options_Mutation_Response>;
  /** insert a single row into the table: "water_volume_factor_options" */
  insert_water_volume_factor_options_one?: Maybe<Water_Volume_Factor_Options>;
  /** insert data into the table: "well_gas_type_options" */
  insert_well_gas_type_options?: Maybe<Well_Gas_Type_Options_Mutation_Response>;
  /** insert a single row into the table: "well_gas_type_options" */
  insert_well_gas_type_options_one?: Maybe<Well_Gas_Type_Options>;
  /** insert data into the table: "well_test_gas_input_options" */
  insert_well_test_gas_input_options?: Maybe<Well_Test_Gas_Input_Options_Mutation_Response>;
  /** insert a single row into the table: "well_test_gas_input_options" */
  insert_well_test_gas_input_options_one?: Maybe<Well_Test_Gas_Input_Options>;
  /** insert data into the table: "well_test_liquid_input_options" */
  insert_well_test_liquid_input_options?: Maybe<Well_Test_Liquid_Input_Options_Mutation_Response>;
  /** insert a single row into the table: "well_test_liquid_input_options" */
  insert_well_test_liquid_input_options_one?: Maybe<Well_Test_Liquid_Input_Options>;
  /** insert data into the table: "well_test_pressure_input_options" */
  insert_well_test_pressure_input_options?: Maybe<Well_Test_Pressure_Input_Options_Mutation_Response>;
  /** insert a single row into the table: "well_test_pressure_input_options" */
  insert_well_test_pressure_input_options_one?: Maybe<Well_Test_Pressure_Input_Options>;
  /** insert data into the table: "wells" */
  insert_wells?: Maybe<Wells_Mutation_Response>;
  /** insert a single row into the table: "wells" */
  insert_wells_one?: Maybe<Wells>;
  /** insert data into the table: "y_tools" */
  insert_y_tools?: Maybe<Y_Tools_Mutation_Response>;
  /** insert a single row into the table: "y_tools" */
  insert_y_tools_one?: Maybe<Y_Tools>;
  updateSKQuoteJob?: Maybe<SkQuote>;
  /** update data of the table: "bolt_on_discharges" */
  update_bolt_on_discharges?: Maybe<Bolt_On_Discharges_Mutation_Response>;
  /** update single row of the table: "bolt_on_discharges" */
  update_bolt_on_discharges_by_pk?: Maybe<Bolt_On_Discharges>;
  /** update multiples rows of table: "bolt_on_discharges" */
  update_bolt_on_discharges_many?: Maybe<Array<Maybe<Bolt_On_Discharges_Mutation_Response>>>;
  /** update data of the table: "bubble_point_options" */
  update_bubble_point_options?: Maybe<Bubble_Point_Options_Mutation_Response>;
  /** update single row of the table: "bubble_point_options" */
  update_bubble_point_options_by_pk?: Maybe<Bubble_Point_Options>;
  /** update multiples rows of table: "bubble_point_options" */
  update_bubble_point_options_many?: Maybe<Array<Maybe<Bubble_Point_Options_Mutation_Response>>>;
  /** update data of the table: "cables" */
  update_cables?: Maybe<Cables_Mutation_Response>;
  /** update single row of the table: "cables" */
  update_cables_by_pk?: Maybe<Cables>;
  /** update multiples rows of table: "cables" */
  update_cables_many?: Maybe<Array<Maybe<Cables_Mutation_Response>>>;
  /** update data of the table: "casing_flow_options" */
  update_casing_flow_options?: Maybe<Casing_Flow_Options_Mutation_Response>;
  /** update single row of the table: "casing_flow_options" */
  update_casing_flow_options_by_pk?: Maybe<Casing_Flow_Options>;
  /** update multiples rows of table: "casing_flow_options" */
  update_casing_flow_options_many?: Maybe<Array<Maybe<Casing_Flow_Options_Mutation_Response>>>;
  /** update data of the table: "casings" */
  update_casings?: Maybe<Casings_Mutation_Response>;
  /** update single row of the table: "casings" */
  update_casings_by_pk?: Maybe<Casings>;
  /** update multiples rows of table: "casings" */
  update_casings_many?: Maybe<Array<Maybe<Casings_Mutation_Response>>>;
  /** update data of the table: "casings_type" */
  update_casings_type?: Maybe<Casings_Type_Mutation_Response>;
  /** update single row of the table: "casings_type" */
  update_casings_type_by_pk?: Maybe<Casings_Type>;
  /** update multiples rows of table: "casings_type" */
  update_casings_type_many?: Maybe<Array<Maybe<Casings_Type_Mutation_Response>>>;
  /** update data of the table: "customers" */
  update_customers?: Maybe<Customers_Mutation_Response>;
  /** update single row of the table: "customers" */
  update_customers_by_pk?: Maybe<Customers>;
  /** update multiples rows of table: "customers" */
  update_customers_many?: Maybe<Array<Maybe<Customers_Mutation_Response>>>;
  /** update data of the table: "dead_oil_options" */
  update_dead_oil_options?: Maybe<Dead_Oil_Options_Mutation_Response>;
  /** update single row of the table: "dead_oil_options" */
  update_dead_oil_options_by_pk?: Maybe<Dead_Oil_Options>;
  /** update multiples rows of table: "dead_oil_options" */
  update_dead_oil_options_many?: Maybe<Array<Maybe<Dead_Oil_Options_Mutation_Response>>>;
  /** update data of the table: "deviation_survey" */
  update_deviation_survey?: Maybe<Deviation_Survey_Mutation_Response>;
  /** update single row of the table: "deviation_survey" */
  update_deviation_survey_by_pk?: Maybe<Deviation_Survey>;
  /** update data of the table: "deviation_survey_directional_dataset" */
  update_deviation_survey_directional_dataset?: Maybe<Deviation_Survey_Directional_Dataset_Mutation_Response>;
  /** update single row of the table: "deviation_survey_directional_dataset" */
  update_deviation_survey_directional_dataset_by_pk?: Maybe<Deviation_Survey_Directional_Dataset>;
  /** update multiples rows of table: "deviation_survey_directional_dataset" */
  update_deviation_survey_directional_dataset_many?: Maybe<Array<Maybe<Deviation_Survey_Directional_Dataset_Mutation_Response>>>;
  /** update multiples rows of table: "deviation_survey" */
  update_deviation_survey_many?: Maybe<Array<Maybe<Deviation_Survey_Mutation_Response>>>;
  /** update data of the table: "display_units" */
  update_display_units?: Maybe<Display_Units_Mutation_Response>;
  /** update single row of the table: "display_units" */
  update_display_units_by_pk?: Maybe<Display_Units>;
  /** update multiples rows of table: "display_units" */
  update_display_units_many?: Maybe<Array<Maybe<Display_Units_Mutation_Response>>>;
  /** update data of the table: "eula" */
  update_eula?: Maybe<Eula_Mutation_Response>;
  /** update single row of the table: "eula" */
  update_eula_by_pk?: Maybe<Eula>;
  /** update multiples rows of table: "eula" */
  update_eula_many?: Maybe<Array<Maybe<Eula_Mutation_Response>>>;
  /** update data of the table: "flow_model" */
  update_flow_model?: Maybe<Flow_Model_Mutation_Response>;
  /** update data of the table: "flow_model_active" */
  update_flow_model_active?: Maybe<Flow_Model_Active_Mutation_Response>;
  /** update multiples rows of table: "flow_model_active" */
  update_flow_model_active_many?: Maybe<Array<Maybe<Flow_Model_Active_Mutation_Response>>>;
  /** update single row of the table: "flow_model" */
  update_flow_model_by_pk?: Maybe<Flow_Model>;
  /** update data of the table: "flow_model_deprecated" */
  update_flow_model_deprecated?: Maybe<Flow_Model_Deprecated_Mutation_Response>;
  /** update single row of the table: "flow_model_deprecated" */
  update_flow_model_deprecated_by_pk?: Maybe<Flow_Model_Deprecated>;
  /** update multiples rows of table: "flow_model_deprecated" */
  update_flow_model_deprecated_many?: Maybe<Array<Maybe<Flow_Model_Deprecated_Mutation_Response>>>;
  /** update multiples rows of table: "flow_model" */
  update_flow_model_many?: Maybe<Array<Maybe<Flow_Model_Mutation_Response>>>;
  /** update data of the table: "friction_loss_options" */
  update_friction_loss_options?: Maybe<Friction_Loss_Options_Mutation_Response>;
  /** update single row of the table: "friction_loss_options" */
  update_friction_loss_options_by_pk?: Maybe<Friction_Loss_Options>;
  /** update multiples rows of table: "friction_loss_options" */
  update_friction_loss_options_many?: Maybe<Array<Maybe<Friction_Loss_Options_Mutation_Response>>>;
  /** update data of the table: "gas_compressibility_options" */
  update_gas_compressibility_options?: Maybe<Gas_Compressibility_Options_Mutation_Response>;
  /** update single row of the table: "gas_compressibility_options" */
  update_gas_compressibility_options_by_pk?: Maybe<Gas_Compressibility_Options>;
  /** update multiples rows of table: "gas_compressibility_options" */
  update_gas_compressibility_options_many?: Maybe<Array<Maybe<Gas_Compressibility_Options_Mutation_Response>>>;
  /** update data of the table: "gas_viscosity_options" */
  update_gas_viscosity_options?: Maybe<Gas_Viscosity_Options_Mutation_Response>;
  /** update single row of the table: "gas_viscosity_options" */
  update_gas_viscosity_options_by_pk?: Maybe<Gas_Viscosity_Options>;
  /** update multiples rows of table: "gas_viscosity_options" */
  update_gas_viscosity_options_many?: Maybe<Array<Maybe<Gas_Viscosity_Options_Mutation_Response>>>;
  /** update data of the table: "housings" */
  update_housings?: Maybe<Housings_Mutation_Response>;
  /** update single row of the table: "housings" */
  update_housings_by_pk?: Maybe<Housings>;
  /** update multiples rows of table: "housings" */
  update_housings_many?: Maybe<Array<Maybe<Housings_Mutation_Response>>>;
  /** update data of the table: "hps_liquid_type" */
  update_hps_liquid_type?: Maybe<Hps_Liquid_Type_Mutation_Response>;
  /** update single row of the table: "hps_liquid_type" */
  update_hps_liquid_type_by_pk?: Maybe<Hps_Liquid_Type>;
  /** update multiples rows of table: "hps_liquid_type" */
  update_hps_liquid_type_many?: Maybe<Array<Maybe<Hps_Liquid_Type_Mutation_Response>>>;
  /** update data of the table: "intakes" */
  update_intakes?: Maybe<Intakes_Mutation_Response>;
  /** update single row of the table: "intakes" */
  update_intakes_by_pk?: Maybe<Intakes>;
  /** update multiples rows of table: "intakes" */
  update_intakes_many?: Maybe<Array<Maybe<Intakes_Mutation_Response>>>;
  /** update data of the table: "legacy_users" */
  update_legacy_users?: Maybe<Legacy_Users_Mutation_Response>;
  /** update single row of the table: "legacy_users" */
  update_legacy_users_by_pk?: Maybe<Legacy_Users>;
  /** update multiples rows of table: "legacy_users" */
  update_legacy_users_many?: Maybe<Array<Maybe<Legacy_Users_Mutation_Response>>>;
  /** update data of the table: "motor_lead_extensions" */
  update_motor_lead_extensions?: Maybe<Motor_Lead_Extensions_Mutation_Response>;
  /** update single row of the table: "motor_lead_extensions" */
  update_motor_lead_extensions_by_pk?: Maybe<Motor_Lead_Extensions>;
  /** update multiples rows of table: "motor_lead_extensions" */
  update_motor_lead_extensions_many?: Maybe<Array<Maybe<Motor_Lead_Extensions_Mutation_Response>>>;
  /** update data of the table: "motors" */
  update_motors?: Maybe<Motors_Mutation_Response>;
  /** update single row of the table: "motors" */
  update_motors_by_pk?: Maybe<Motors>;
  /** update multiples rows of table: "motors" */
  update_motors_many?: Maybe<Array<Maybe<Motors_Mutation_Response>>>;
  /** update data of the table: "natural_gas_separation_options" */
  update_natural_gas_separation_options?: Maybe<Natural_Gas_Separation_Options_Mutation_Response>;
  /** update single row of the table: "natural_gas_separation_options" */
  update_natural_gas_separation_options_by_pk?: Maybe<Natural_Gas_Separation_Options>;
  /** update multiples rows of table: "natural_gas_separation_options" */
  update_natural_gas_separation_options_many?: Maybe<Array<Maybe<Natural_Gas_Separation_Options_Mutation_Response>>>;
  /** update data of the table: "oil_density_options" */
  update_oil_density_options?: Maybe<Oil_Density_Options_Mutation_Response>;
  /** update single row of the table: "oil_density_options" */
  update_oil_density_options_by_pk?: Maybe<Oil_Density_Options>;
  /** update multiples rows of table: "oil_density_options" */
  update_oil_density_options_many?: Maybe<Array<Maybe<Oil_Density_Options_Mutation_Response>>>;
  /** update data of the table: "oil_volume_factor_options" */
  update_oil_volume_factor_options?: Maybe<Oil_Volume_Factor_Options_Mutation_Response>;
  /** update single row of the table: "oil_volume_factor_options" */
  update_oil_volume_factor_options_by_pk?: Maybe<Oil_Volume_Factor_Options>;
  /** update multiples rows of table: "oil_volume_factor_options" */
  update_oil_volume_factor_options_many?: Maybe<Array<Maybe<Oil_Volume_Factor_Options_Mutation_Response>>>;
  /** update data of the table: "override_options" */
  update_override_options?: Maybe<Override_Options_Mutation_Response>;
  /** update single row of the table: "override_options" */
  update_override_options_by_pk?: Maybe<Override_Options>;
  /** update multiples rows of table: "override_options" */
  update_override_options_many?: Maybe<Array<Maybe<Override_Options_Mutation_Response>>>;
  /** update data of the table: "pumps" */
  update_pumps?: Maybe<Pumps_Mutation_Response>;
  /** update single row of the table: "pumps" */
  update_pumps_by_pk?: Maybe<Pumps>;
  /** update multiples rows of table: "pumps" */
  update_pumps_many?: Maybe<Array<Maybe<Pumps_Mutation_Response>>>;
  /** update data of the table: "quote_line_item_category_dataset" */
  update_quote_line_item_category_dataset?: Maybe<Quote_Line_Item_Category_Dataset_Mutation_Response>;
  /** update single row of the table: "quote_line_item_category_dataset" */
  update_quote_line_item_category_dataset_by_pk?: Maybe<Quote_Line_Item_Category_Dataset>;
  /** update multiples rows of table: "quote_line_item_category_dataset" */
  update_quote_line_item_category_dataset_many?: Maybe<Array<Maybe<Quote_Line_Item_Category_Dataset_Mutation_Response>>>;
  /** update data of the table: "quote_line_item_serialized_dataset" */
  update_quote_line_item_serialized_dataset?: Maybe<Quote_Line_Item_Serialized_Dataset_Mutation_Response>;
  /** update single row of the table: "quote_line_item_serialized_dataset" */
  update_quote_line_item_serialized_dataset_by_pk?: Maybe<Quote_Line_Item_Serialized_Dataset>;
  /** update multiples rows of table: "quote_line_item_serialized_dataset" */
  update_quote_line_item_serialized_dataset_many?: Maybe<Array<Maybe<Quote_Line_Item_Serialized_Dataset_Mutation_Response>>>;
  /** update data of the table: "quote_line_item_source_dataset" */
  update_quote_line_item_source_dataset?: Maybe<Quote_Line_Item_Source_Dataset_Mutation_Response>;
  /** update single row of the table: "quote_line_item_source_dataset" */
  update_quote_line_item_source_dataset_by_pk?: Maybe<Quote_Line_Item_Source_Dataset>;
  /** update multiples rows of table: "quote_line_item_source_dataset" */
  update_quote_line_item_source_dataset_many?: Maybe<Array<Maybe<Quote_Line_Item_Source_Dataset_Mutation_Response>>>;
  /** update data of the table: "quote_line_item_subcategory_dataset" */
  update_quote_line_item_subcategory_dataset?: Maybe<Quote_Line_Item_Subcategory_Dataset_Mutation_Response>;
  /** update single row of the table: "quote_line_item_subcategory_dataset" */
  update_quote_line_item_subcategory_dataset_by_pk?: Maybe<Quote_Line_Item_Subcategory_Dataset>;
  /** update multiples rows of table: "quote_line_item_subcategory_dataset" */
  update_quote_line_item_subcategory_dataset_many?: Maybe<Array<Maybe<Quote_Line_Item_Subcategory_Dataset_Mutation_Response>>>;
  /** update data of the table: "quote_line_item_tax_type_dataset" */
  update_quote_line_item_tax_type_dataset?: Maybe<Quote_Line_Item_Tax_Type_Dataset_Mutation_Response>;
  /** update single row of the table: "quote_line_item_tax_type_dataset" */
  update_quote_line_item_tax_type_dataset_by_pk?: Maybe<Quote_Line_Item_Tax_Type_Dataset>;
  /** update multiples rows of table: "quote_line_item_tax_type_dataset" */
  update_quote_line_item_tax_type_dataset_many?: Maybe<Array<Maybe<Quote_Line_Item_Tax_Type_Dataset_Mutation_Response>>>;
  /** update data of the table: "quote_line_item_type_dataset" */
  update_quote_line_item_type_dataset?: Maybe<Quote_Line_Item_Type_Dataset_Mutation_Response>;
  /** update single row of the table: "quote_line_item_type_dataset" */
  update_quote_line_item_type_dataset_by_pk?: Maybe<Quote_Line_Item_Type_Dataset>;
  /** update multiples rows of table: "quote_line_item_type_dataset" */
  update_quote_line_item_type_dataset_many?: Maybe<Array<Maybe<Quote_Line_Item_Type_Dataset_Mutation_Response>>>;
  /** update data of the table: "quote_line_items" */
  update_quote_line_items?: Maybe<Quote_Line_Items_Mutation_Response>;
  /** update single row of the table: "quote_line_items" */
  update_quote_line_items_by_pk?: Maybe<Quote_Line_Items>;
  /** update multiples rows of table: "quote_line_items" */
  update_quote_line_items_many?: Maybe<Array<Maybe<Quote_Line_Items_Mutation_Response>>>;
  /** update data of the table: "quote_sk_job_type_dataset" */
  update_quote_sk_job_type_dataset?: Maybe<Quote_Sk_Job_Type_Dataset_Mutation_Response>;
  /** update single row of the table: "quote_sk_job_type_dataset" */
  update_quote_sk_job_type_dataset_by_pk?: Maybe<Quote_Sk_Job_Type_Dataset>;
  /** update multiples rows of table: "quote_sk_job_type_dataset" */
  update_quote_sk_job_type_dataset_many?: Maybe<Array<Maybe<Quote_Sk_Job_Type_Dataset_Mutation_Response>>>;
  /** update data of the table: "quote_source_dataset" */
  update_quote_source_dataset?: Maybe<Quote_Source_Dataset_Mutation_Response>;
  /** update single row of the table: "quote_source_dataset" */
  update_quote_source_dataset_by_pk?: Maybe<Quote_Source_Dataset>;
  /** update multiples rows of table: "quote_source_dataset" */
  update_quote_source_dataset_many?: Maybe<Array<Maybe<Quote_Source_Dataset_Mutation_Response>>>;
  /** update data of the table: "quote_status_dataset" */
  update_quote_status_dataset?: Maybe<Quote_Status_Dataset_Mutation_Response>;
  /** update single row of the table: "quote_status_dataset" */
  update_quote_status_dataset_by_pk?: Maybe<Quote_Status_Dataset>;
  /** update multiples rows of table: "quote_status_dataset" */
  update_quote_status_dataset_many?: Maybe<Array<Maybe<Quote_Status_Dataset_Mutation_Response>>>;
  /** update data of the table: "quote_user_messages" */
  update_quote_user_messages?: Maybe<Quote_User_Messages_Mutation_Response>;
  /** update single row of the table: "quote_user_messages" */
  update_quote_user_messages_by_pk?: Maybe<Quote_User_Messages>;
  /** update multiples rows of table: "quote_user_messages" */
  update_quote_user_messages_many?: Maybe<Array<Maybe<Quote_User_Messages_Mutation_Response>>>;
  /** update data of the table: "quotes" */
  update_quotes?: Maybe<Quotes_Mutation_Response>;
  /** update single row of the table: "quotes" */
  update_quotes_by_pk?: Maybe<Quotes>;
  /** update multiples rows of table: "quotes" */
  update_quotes_many?: Maybe<Array<Maybe<Quotes_Mutation_Response>>>;
  /** update data of the table: "revisions.performance_evaluations_journal" */
  update_revisions_performance_evaluations_journal?: Maybe<Revisions_Performance_Evaluations_Journal_Mutation_Response>;
  /** update single row of the table: "revisions.performance_evaluations_journal" */
  update_revisions_performance_evaluations_journal_by_pk?: Maybe<Revisions_Performance_Evaluations_Journal>;
  /** update multiples rows of table: "revisions.performance_evaluations_journal" */
  update_revisions_performance_evaluations_journal_many?: Maybe<Array<Maybe<Revisions_Performance_Evaluations_Journal_Mutation_Response>>>;
  /** update data of the table: "revisions.performance_evaluations_revisions" */
  update_revisions_performance_evaluations_revisions?: Maybe<Revisions_Performance_Evaluations_Revisions_Mutation_Response>;
  /** update single row of the table: "revisions.performance_evaluations_revisions" */
  update_revisions_performance_evaluations_revisions_by_pk?: Maybe<Revisions_Performance_Evaluations_Revisions>;
  /** update multiples rows of table: "revisions.performance_evaluations_revisions" */
  update_revisions_performance_evaluations_revisions_many?: Maybe<Array<Maybe<Revisions_Performance_Evaluations_Revisions_Mutation_Response>>>;
  /** update data of the table: "revisions.performance_evaluations_xref_pumps_journal" */
  update_revisions_performance_evaluations_xref_pumps_journal?: Maybe<Revisions_Performance_Evaluations_Xref_Pumps_Journal_Mutation_Response>;
  /** update single row of the table: "revisions.performance_evaluations_xref_pumps_journal" */
  update_revisions_performance_evaluations_xref_pumps_journal_by_pk?: Maybe<Revisions_Performance_Evaluations_Xref_Pumps_Journal>;
  /** update multiples rows of table: "revisions.performance_evaluations_xref_pumps_journal" */
  update_revisions_performance_evaluations_xref_pumps_journal_many?: Maybe<Array<Maybe<Revisions_Performance_Evaluations_Xref_Pumps_Journal_Mutation_Response>>>;
  /** update data of the table: "revisions.performance_evaluations_xref_pumps_revisions" */
  update_revisions_performance_evaluations_xref_pumps_revisions?: Maybe<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Mutation_Response>;
  /** update single row of the table: "revisions.performance_evaluations_xref_pumps_revisions" */
  update_revisions_performance_evaluations_xref_pumps_revisions_by_pk?: Maybe<Revisions_Performance_Evaluations_Xref_Pumps_Revisions>;
  /** update multiples rows of table: "revisions.performance_evaluations_xref_pumps_revisions" */
  update_revisions_performance_evaluations_xref_pumps_revisions_many?: Maybe<Array<Maybe<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Mutation_Response>>>;
  /** update data of the table: "revisions.sc_equip_xref_downhole_ytool_bypass_tubings_journal" */
  update_revisions_sc_equip_xref_downhole_ytool_bypass_tubings_journal?: Maybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_Mutation_Response>;
  /** update single row of the table: "revisions.sc_equip_xref_downhole_ytool_bypass_tubings_journal" */
  update_revisions_sc_equip_xref_downhole_ytool_bypass_tubings_journal_by_pk?: Maybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal>;
  /** update multiples rows of table: "revisions.sc_equip_xref_downhole_ytool_bypass_tubings_journal" */
  update_revisions_sc_equip_xref_downhole_ytool_bypass_tubings_journal_many?: Maybe<Array<Maybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_Mutation_Response>>>;
  /** update data of the table: "revisions.sc_equip_xref_downhole_ytool_bypass_tubings_revisions" */
  update_revisions_sc_equip_xref_downhole_ytool_bypass_tubings_revisions?: Maybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Mutation_Response>;
  /** update single row of the table: "revisions.sc_equip_xref_downhole_ytool_bypass_tubings_revisions" */
  update_revisions_sc_equip_xref_downhole_ytool_bypass_tubings_revisions_by_pk?: Maybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions>;
  /** update multiples rows of table: "revisions.sc_equip_xref_downhole_ytool_bypass_tubings_revisions" */
  update_revisions_sc_equip_xref_downhole_ytool_bypass_tubings_revisions_many?: Maybe<Array<Maybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Mutation_Response>>>;
  /** update data of the table: "revisions.sc_equip_xref_downhole_ytool_equip_tubings_journal" */
  update_revisions_sc_equip_xref_downhole_ytool_equip_tubings_journal?: Maybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_Mutation_Response>;
  /** update single row of the table: "revisions.sc_equip_xref_downhole_ytool_equip_tubings_journal" */
  update_revisions_sc_equip_xref_downhole_ytool_equip_tubings_journal_by_pk?: Maybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal>;
  /** update multiples rows of table: "revisions.sc_equip_xref_downhole_ytool_equip_tubings_journal" */
  update_revisions_sc_equip_xref_downhole_ytool_equip_tubings_journal_many?: Maybe<Array<Maybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_Mutation_Response>>>;
  /** update data of the table: "revisions.sc_equip_xref_downhole_ytool_equip_tubings_revisions" */
  update_revisions_sc_equip_xref_downhole_ytool_equip_tubings_revisions?: Maybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Mutation_Response>;
  /** update single row of the table: "revisions.sc_equip_xref_downhole_ytool_equip_tubings_revisions" */
  update_revisions_sc_equip_xref_downhole_ytool_equip_tubings_revisions_by_pk?: Maybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions>;
  /** update multiples rows of table: "revisions.sc_equip_xref_downhole_ytool_equip_tubings_revisions" */
  update_revisions_sc_equip_xref_downhole_ytool_equip_tubings_revisions_many?: Maybe<Array<Maybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Mutation_Response>>>;
  /** update data of the table: "revisions.sc_equip_xref_uphole_ytool_bypass_tubings_journal" */
  update_revisions_sc_equip_xref_uphole_ytool_bypass_tubings_journal?: Maybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_Mutation_Response>;
  /** update single row of the table: "revisions.sc_equip_xref_uphole_ytool_bypass_tubings_journal" */
  update_revisions_sc_equip_xref_uphole_ytool_bypass_tubings_journal_by_pk?: Maybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal>;
  /** update multiples rows of table: "revisions.sc_equip_xref_uphole_ytool_bypass_tubings_journal" */
  update_revisions_sc_equip_xref_uphole_ytool_bypass_tubings_journal_many?: Maybe<Array<Maybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_Mutation_Response>>>;
  /** update data of the table: "revisions.sc_equip_xref_uphole_ytool_bypass_tubings_revisions" */
  update_revisions_sc_equip_xref_uphole_ytool_bypass_tubings_revisions?: Maybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Mutation_Response>;
  /** update single row of the table: "revisions.sc_equip_xref_uphole_ytool_bypass_tubings_revisions" */
  update_revisions_sc_equip_xref_uphole_ytool_bypass_tubings_revisions_by_pk?: Maybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions>;
  /** update multiples rows of table: "revisions.sc_equip_xref_uphole_ytool_bypass_tubings_revisions" */
  update_revisions_sc_equip_xref_uphole_ytool_bypass_tubings_revisions_many?: Maybe<Array<Maybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Mutation_Response>>>;
  /** update data of the table: "revisions.sc_equip_xref_uphole_ytool_equip_tubings_journal" */
  update_revisions_sc_equip_xref_uphole_ytool_equip_tubings_journal?: Maybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_Mutation_Response>;
  /** update single row of the table: "revisions.sc_equip_xref_uphole_ytool_equip_tubings_journal" */
  update_revisions_sc_equip_xref_uphole_ytool_equip_tubings_journal_by_pk?: Maybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal>;
  /** update multiples rows of table: "revisions.sc_equip_xref_uphole_ytool_equip_tubings_journal" */
  update_revisions_sc_equip_xref_uphole_ytool_equip_tubings_journal_many?: Maybe<Array<Maybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_Mutation_Response>>>;
  /** update data of the table: "revisions.sc_equip_xref_uphole_ytool_equip_tubings_revisions" */
  update_revisions_sc_equip_xref_uphole_ytool_equip_tubings_revisions?: Maybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Mutation_Response>;
  /** update single row of the table: "revisions.sc_equip_xref_uphole_ytool_equip_tubings_revisions" */
  update_revisions_sc_equip_xref_uphole_ytool_equip_tubings_revisions_by_pk?: Maybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions>;
  /** update multiples rows of table: "revisions.sc_equip_xref_uphole_ytool_equip_tubings_revisions" */
  update_revisions_sc_equip_xref_uphole_ytool_equip_tubings_revisions_many?: Maybe<Array<Maybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Mutation_Response>>>;
  /** update data of the table: "revisions.scenario_correlations_journal" */
  update_revisions_scenario_correlations_journal?: Maybe<Revisions_Scenario_Correlations_Journal_Mutation_Response>;
  /** update single row of the table: "revisions.scenario_correlations_journal" */
  update_revisions_scenario_correlations_journal_by_pk?: Maybe<Revisions_Scenario_Correlations_Journal>;
  /** update multiples rows of table: "revisions.scenario_correlations_journal" */
  update_revisions_scenario_correlations_journal_many?: Maybe<Array<Maybe<Revisions_Scenario_Correlations_Journal_Mutation_Response>>>;
  /** update data of the table: "revisions.scenario_correlations_revisions" */
  update_revisions_scenario_correlations_revisions?: Maybe<Revisions_Scenario_Correlations_Revisions_Mutation_Response>;
  /** update single row of the table: "revisions.scenario_correlations_revisions" */
  update_revisions_scenario_correlations_revisions_by_pk?: Maybe<Revisions_Scenario_Correlations_Revisions>;
  /** update multiples rows of table: "revisions.scenario_correlations_revisions" */
  update_revisions_scenario_correlations_revisions_many?: Maybe<Array<Maybe<Revisions_Scenario_Correlations_Revisions_Mutation_Response>>>;
  /** update data of the table: "revisions.scenario_equipment_journal" */
  update_revisions_scenario_equipment_journal?: Maybe<Revisions_Scenario_Equipment_Journal_Mutation_Response>;
  /** update single row of the table: "revisions.scenario_equipment_journal" */
  update_revisions_scenario_equipment_journal_by_pk?: Maybe<Revisions_Scenario_Equipment_Journal>;
  /** update multiples rows of table: "revisions.scenario_equipment_journal" */
  update_revisions_scenario_equipment_journal_many?: Maybe<Array<Maybe<Revisions_Scenario_Equipment_Journal_Mutation_Response>>>;
  /** update data of the table: "revisions.scenario_equipment_revisions" */
  update_revisions_scenario_equipment_revisions?: Maybe<Revisions_Scenario_Equipment_Revisions_Mutation_Response>;
  /** update single row of the table: "revisions.scenario_equipment_revisions" */
  update_revisions_scenario_equipment_revisions_by_pk?: Maybe<Revisions_Scenario_Equipment_Revisions>;
  /** update multiples rows of table: "revisions.scenario_equipment_revisions" */
  update_revisions_scenario_equipment_revisions_many?: Maybe<Array<Maybe<Revisions_Scenario_Equipment_Revisions_Mutation_Response>>>;
  /** update data of the table: "revisions.scenario_equipment_xref_cables_journal" */
  update_revisions_scenario_equipment_xref_cables_journal?: Maybe<Revisions_Scenario_Equipment_Xref_Cables_Journal_Mutation_Response>;
  /** update single row of the table: "revisions.scenario_equipment_xref_cables_journal" */
  update_revisions_scenario_equipment_xref_cables_journal_by_pk?: Maybe<Revisions_Scenario_Equipment_Xref_Cables_Journal>;
  /** update multiples rows of table: "revisions.scenario_equipment_xref_cables_journal" */
  update_revisions_scenario_equipment_xref_cables_journal_many?: Maybe<Array<Maybe<Revisions_Scenario_Equipment_Xref_Cables_Journal_Mutation_Response>>>;
  /** update data of the table: "revisions.scenario_equipment_xref_cables_revisions" */
  update_revisions_scenario_equipment_xref_cables_revisions?: Maybe<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Mutation_Response>;
  /** update single row of the table: "revisions.scenario_equipment_xref_cables_revisions" */
  update_revisions_scenario_equipment_xref_cables_revisions_by_pk?: Maybe<Revisions_Scenario_Equipment_Xref_Cables_Revisions>;
  /** update multiples rows of table: "revisions.scenario_equipment_xref_cables_revisions" */
  update_revisions_scenario_equipment_xref_cables_revisions_many?: Maybe<Array<Maybe<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Mutation_Response>>>;
  /** update data of the table: "revisions.scenario_equipment_xref_housings_journal" */
  update_revisions_scenario_equipment_xref_housings_journal?: Maybe<Revisions_Scenario_Equipment_Xref_Housings_Journal_Mutation_Response>;
  /** update single row of the table: "revisions.scenario_equipment_xref_housings_journal" */
  update_revisions_scenario_equipment_xref_housings_journal_by_pk?: Maybe<Revisions_Scenario_Equipment_Xref_Housings_Journal>;
  /** update multiples rows of table: "revisions.scenario_equipment_xref_housings_journal" */
  update_revisions_scenario_equipment_xref_housings_journal_many?: Maybe<Array<Maybe<Revisions_Scenario_Equipment_Xref_Housings_Journal_Mutation_Response>>>;
  /** update data of the table: "revisions.scenario_equipment_xref_housings_revisions" */
  update_revisions_scenario_equipment_xref_housings_revisions?: Maybe<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Mutation_Response>;
  /** update single row of the table: "revisions.scenario_equipment_xref_housings_revisions" */
  update_revisions_scenario_equipment_xref_housings_revisions_by_pk?: Maybe<Revisions_Scenario_Equipment_Xref_Housings_Revisions>;
  /** update multiples rows of table: "revisions.scenario_equipment_xref_housings_revisions" */
  update_revisions_scenario_equipment_xref_housings_revisions_many?: Maybe<Array<Maybe<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Mutation_Response>>>;
  /** update data of the table: "revisions.scenario_equipment_xref_intakes_journal" */
  update_revisions_scenario_equipment_xref_intakes_journal?: Maybe<Revisions_Scenario_Equipment_Xref_Intakes_Journal_Mutation_Response>;
  /** update single row of the table: "revisions.scenario_equipment_xref_intakes_journal" */
  update_revisions_scenario_equipment_xref_intakes_journal_by_pk?: Maybe<Revisions_Scenario_Equipment_Xref_Intakes_Journal>;
  /** update multiples rows of table: "revisions.scenario_equipment_xref_intakes_journal" */
  update_revisions_scenario_equipment_xref_intakes_journal_many?: Maybe<Array<Maybe<Revisions_Scenario_Equipment_Xref_Intakes_Journal_Mutation_Response>>>;
  /** update data of the table: "revisions.scenario_equipment_xref_intakes_revisions" */
  update_revisions_scenario_equipment_xref_intakes_revisions?: Maybe<Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Mutation_Response>;
  /** update single row of the table: "revisions.scenario_equipment_xref_intakes_revisions" */
  update_revisions_scenario_equipment_xref_intakes_revisions_by_pk?: Maybe<Revisions_Scenario_Equipment_Xref_Intakes_Revisions>;
  /** update multiples rows of table: "revisions.scenario_equipment_xref_intakes_revisions" */
  update_revisions_scenario_equipment_xref_intakes_revisions_many?: Maybe<Array<Maybe<Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Mutation_Response>>>;
  /** update data of the table: "revisions.scenario_equipment_xref_pumps_journal" */
  update_revisions_scenario_equipment_xref_pumps_journal?: Maybe<Revisions_Scenario_Equipment_Xref_Pumps_Journal_Mutation_Response>;
  /** update single row of the table: "revisions.scenario_equipment_xref_pumps_journal" */
  update_revisions_scenario_equipment_xref_pumps_journal_by_pk?: Maybe<Revisions_Scenario_Equipment_Xref_Pumps_Journal>;
  /** update multiples rows of table: "revisions.scenario_equipment_xref_pumps_journal" */
  update_revisions_scenario_equipment_xref_pumps_journal_many?: Maybe<Array<Maybe<Revisions_Scenario_Equipment_Xref_Pumps_Journal_Mutation_Response>>>;
  /** update data of the table: "revisions.scenario_equipment_xref_pumps_revisions" */
  update_revisions_scenario_equipment_xref_pumps_revisions?: Maybe<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Mutation_Response>;
  /** update single row of the table: "revisions.scenario_equipment_xref_pumps_revisions" */
  update_revisions_scenario_equipment_xref_pumps_revisions_by_pk?: Maybe<Revisions_Scenario_Equipment_Xref_Pumps_Revisions>;
  /** update multiples rows of table: "revisions.scenario_equipment_xref_pumps_revisions" */
  update_revisions_scenario_equipment_xref_pumps_revisions_many?: Maybe<Array<Maybe<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Mutation_Response>>>;
  /** update data of the table: "revisions.scenario_equipment_xref_seals_journal" */
  update_revisions_scenario_equipment_xref_seals_journal?: Maybe<Revisions_Scenario_Equipment_Xref_Seals_Journal_Mutation_Response>;
  /** update single row of the table: "revisions.scenario_equipment_xref_seals_journal" */
  update_revisions_scenario_equipment_xref_seals_journal_by_pk?: Maybe<Revisions_Scenario_Equipment_Xref_Seals_Journal>;
  /** update multiples rows of table: "revisions.scenario_equipment_xref_seals_journal" */
  update_revisions_scenario_equipment_xref_seals_journal_many?: Maybe<Array<Maybe<Revisions_Scenario_Equipment_Xref_Seals_Journal_Mutation_Response>>>;
  /** update data of the table: "revisions.scenario_equipment_xref_seals_revisions" */
  update_revisions_scenario_equipment_xref_seals_revisions?: Maybe<Revisions_Scenario_Equipment_Xref_Seals_Revisions_Mutation_Response>;
  /** update single row of the table: "revisions.scenario_equipment_xref_seals_revisions" */
  update_revisions_scenario_equipment_xref_seals_revisions_by_pk?: Maybe<Revisions_Scenario_Equipment_Xref_Seals_Revisions>;
  /** update multiples rows of table: "revisions.scenario_equipment_xref_seals_revisions" */
  update_revisions_scenario_equipment_xref_seals_revisions_many?: Maybe<Array<Maybe<Revisions_Scenario_Equipment_Xref_Seals_Revisions_Mutation_Response>>>;
  /** update data of the table: "revisions.scenario_parameters_journal" */
  update_revisions_scenario_parameters_journal?: Maybe<Revisions_Scenario_Parameters_Journal_Mutation_Response>;
  /** update single row of the table: "revisions.scenario_parameters_journal" */
  update_revisions_scenario_parameters_journal_by_pk?: Maybe<Revisions_Scenario_Parameters_Journal>;
  /** update multiples rows of table: "revisions.scenario_parameters_journal" */
  update_revisions_scenario_parameters_journal_many?: Maybe<Array<Maybe<Revisions_Scenario_Parameters_Journal_Mutation_Response>>>;
  /** update data of the table: "revisions.scenario_parameters_revisions" */
  update_revisions_scenario_parameters_revisions?: Maybe<Revisions_Scenario_Parameters_Revisions_Mutation_Response>;
  /** update single row of the table: "revisions.scenario_parameters_revisions" */
  update_revisions_scenario_parameters_revisions_by_pk?: Maybe<Revisions_Scenario_Parameters_Revisions>;
  /** update multiples rows of table: "revisions.scenario_parameters_revisions" */
  update_revisions_scenario_parameters_revisions_many?: Maybe<Array<Maybe<Revisions_Scenario_Parameters_Revisions_Mutation_Response>>>;
  /** update data of the table: "revisions.scenario_well_properties_journal" */
  update_revisions_scenario_well_properties_journal?: Maybe<Revisions_Scenario_Well_Properties_Journal_Mutation_Response>;
  /** update single row of the table: "revisions.scenario_well_properties_journal" */
  update_revisions_scenario_well_properties_journal_by_pk?: Maybe<Revisions_Scenario_Well_Properties_Journal>;
  /** update multiples rows of table: "revisions.scenario_well_properties_journal" */
  update_revisions_scenario_well_properties_journal_many?: Maybe<Array<Maybe<Revisions_Scenario_Well_Properties_Journal_Mutation_Response>>>;
  /** update data of the table: "revisions.scenario_well_properties_revisions" */
  update_revisions_scenario_well_properties_revisions?: Maybe<Revisions_Scenario_Well_Properties_Revisions_Mutation_Response>;
  /** update single row of the table: "revisions.scenario_well_properties_revisions" */
  update_revisions_scenario_well_properties_revisions_by_pk?: Maybe<Revisions_Scenario_Well_Properties_Revisions>;
  /** update multiples rows of table: "revisions.scenario_well_properties_revisions" */
  update_revisions_scenario_well_properties_revisions_many?: Maybe<Array<Maybe<Revisions_Scenario_Well_Properties_Revisions_Mutation_Response>>>;
  /** update data of the table: "revisions.scenarios_journal" */
  update_revisions_scenarios_journal?: Maybe<Revisions_Scenarios_Journal_Mutation_Response>;
  /** update single row of the table: "revisions.scenarios_journal" */
  update_revisions_scenarios_journal_by_pk?: Maybe<Revisions_Scenarios_Journal>;
  /** update multiples rows of table: "revisions.scenarios_journal" */
  update_revisions_scenarios_journal_many?: Maybe<Array<Maybe<Revisions_Scenarios_Journal_Mutation_Response>>>;
  /** update data of the table: "revisions.scenarios_revisions" */
  update_revisions_scenarios_revisions?: Maybe<Revisions_Scenarios_Revisions_Mutation_Response>;
  /** update single row of the table: "revisions.scenarios_revisions" */
  update_revisions_scenarios_revisions_by_pk?: Maybe<Revisions_Scenarios_Revisions>;
  /** update multiples rows of table: "revisions.scenarios_revisions" */
  update_revisions_scenarios_revisions_many?: Maybe<Array<Maybe<Revisions_Scenarios_Revisions_Mutation_Response>>>;
  /** update data of the table: "revisions.sizings_journal" */
  update_revisions_sizings_journal?: Maybe<Revisions_Sizings_Journal_Mutation_Response>;
  /** update single row of the table: "revisions.sizings_journal" */
  update_revisions_sizings_journal_by_pk?: Maybe<Revisions_Sizings_Journal>;
  /** update multiples rows of table: "revisions.sizings_journal" */
  update_revisions_sizings_journal_many?: Maybe<Array<Maybe<Revisions_Sizings_Journal_Mutation_Response>>>;
  /** update data of the table: "revisions.sizings_revisions" */
  update_revisions_sizings_revisions?: Maybe<Revisions_Sizings_Revisions_Mutation_Response>;
  /** update single row of the table: "revisions.sizings_revisions" */
  update_revisions_sizings_revisions_by_pk?: Maybe<Revisions_Sizings_Revisions>;
  /** update multiples rows of table: "revisions.sizings_revisions" */
  update_revisions_sizings_revisions_many?: Maybe<Array<Maybe<Revisions_Sizings_Revisions_Mutation_Response>>>;
  /** update data of the table: "saturated_oil_options" */
  update_saturated_oil_options?: Maybe<Saturated_Oil_Options_Mutation_Response>;
  /** update single row of the table: "saturated_oil_options" */
  update_saturated_oil_options_by_pk?: Maybe<Saturated_Oil_Options>;
  /** update multiples rows of table: "saturated_oil_options" */
  update_saturated_oil_options_many?: Maybe<Array<Maybe<Saturated_Oil_Options_Mutation_Response>>>;
  /** update data of the table: "scenario_reasons" */
  update_scenario_reasons?: Maybe<Scenario_Reasons_Mutation_Response>;
  /** update single row of the table: "scenario_reasons" */
  update_scenario_reasons_by_pk?: Maybe<Scenario_Reasons>;
  /** update multiples rows of table: "scenario_reasons" */
  update_scenario_reasons_many?: Maybe<Array<Maybe<Scenario_Reasons_Mutation_Response>>>;
  /** update data of the table: "seal_motor_oil" */
  update_seal_motor_oil?: Maybe<Seal_Motor_Oil_Mutation_Response>;
  /** update single row of the table: "seal_motor_oil" */
  update_seal_motor_oil_by_pk?: Maybe<Seal_Motor_Oil>;
  /** update multiples rows of table: "seal_motor_oil" */
  update_seal_motor_oil_many?: Maybe<Array<Maybe<Seal_Motor_Oil_Mutation_Response>>>;
  /** update data of the table: "seals" */
  update_seals?: Maybe<Seals_Mutation_Response>;
  /** update single row of the table: "seals" */
  update_seals_by_pk?: Maybe<Seals>;
  /** update multiples rows of table: "seals" */
  update_seals_many?: Maybe<Array<Maybe<Seals_Mutation_Response>>>;
  /** update data of the table: "sensors" */
  update_sensors?: Maybe<Sensors_Mutation_Response>;
  /** update single row of the table: "sensors" */
  update_sensors_by_pk?: Maybe<Sensors>;
  /** update multiples rows of table: "sensors" */
  update_sensors_many?: Maybe<Array<Maybe<Sensors_Mutation_Response>>>;
  /** update data of the table: "sizing_dispositions" */
  update_sizing_dispositions?: Maybe<Sizing_Dispositions_Mutation_Response>;
  /** update single row of the table: "sizing_dispositions" */
  update_sizing_dispositions_by_pk?: Maybe<Sizing_Dispositions>;
  /** update multiples rows of table: "sizing_dispositions" */
  update_sizing_dispositions_many?: Maybe<Array<Maybe<Sizing_Dispositions_Mutation_Response>>>;
  /** update data of the table: "sizing_imports" */
  update_sizing_imports?: Maybe<Sizing_Imports_Mutation_Response>;
  /** update single row of the table: "sizing_imports" */
  update_sizing_imports_by_pk?: Maybe<Sizing_Imports>;
  /** update multiples rows of table: "sizing_imports" */
  update_sizing_imports_many?: Maybe<Array<Maybe<Sizing_Imports_Mutation_Response>>>;
  /** update data of the table: "sizing_pumping_type" */
  update_sizing_pumping_type?: Maybe<Sizing_Pumping_Type_Mutation_Response>;
  /** update single row of the table: "sizing_pumping_type" */
  update_sizing_pumping_type_by_pk?: Maybe<Sizing_Pumping_Type>;
  /** update multiples rows of table: "sizing_pumping_type" */
  update_sizing_pumping_type_many?: Maybe<Array<Maybe<Sizing_Pumping_Type_Mutation_Response>>>;
  /** update data of the table: "solution_gas_oil_ratio_options" */
  update_solution_gas_oil_ratio_options?: Maybe<Solution_Gas_Oil_Ratio_Options_Mutation_Response>;
  /** update single row of the table: "solution_gas_oil_ratio_options" */
  update_solution_gas_oil_ratio_options_by_pk?: Maybe<Solution_Gas_Oil_Ratio_Options>;
  /** update multiples rows of table: "solution_gas_oil_ratio_options" */
  update_solution_gas_oil_ratio_options_many?: Maybe<Array<Maybe<Solution_Gas_Oil_Ratio_Options_Mutation_Response>>>;
  /** update data of the table: "step_down_transformers" */
  update_step_down_transformers?: Maybe<Step_Down_Transformers_Mutation_Response>;
  /** update single row of the table: "step_down_transformers" */
  update_step_down_transformers_by_pk?: Maybe<Step_Down_Transformers>;
  /** update multiples rows of table: "step_down_transformers" */
  update_step_down_transformers_many?: Maybe<Array<Maybe<Step_Down_Transformers_Mutation_Response>>>;
  /** update data of the table: "step_up_transformers" */
  update_step_up_transformers?: Maybe<Step_Up_Transformers_Mutation_Response>;
  /** update single row of the table: "step_up_transformers" */
  update_step_up_transformers_by_pk?: Maybe<Step_Up_Transformers>;
  /** update multiples rows of table: "step_up_transformers" */
  update_step_up_transformers_many?: Maybe<Array<Maybe<Step_Up_Transformers_Mutation_Response>>>;
  /** update data of the table: "switchboards" */
  update_switchboards?: Maybe<Switchboards_Mutation_Response>;
  /** update single row of the table: "switchboards" */
  update_switchboards_by_pk?: Maybe<Switchboards>;
  /** update multiples rows of table: "switchboards" */
  update_switchboards_many?: Maybe<Array<Maybe<Switchboards_Mutation_Response>>>;
  /** update data of the table: "tubing_flow_options" */
  update_tubing_flow_options?: Maybe<Tubing_Flow_Options_Mutation_Response>;
  /** update single row of the table: "tubing_flow_options" */
  update_tubing_flow_options_by_pk?: Maybe<Tubing_Flow_Options>;
  /** update multiples rows of table: "tubing_flow_options" */
  update_tubing_flow_options_many?: Maybe<Array<Maybe<Tubing_Flow_Options_Mutation_Response>>>;
  /** update data of the table: "tubings" */
  update_tubings?: Maybe<Tubings_Mutation_Response>;
  /** update single row of the table: "tubings" */
  update_tubings_by_pk?: Maybe<Tubings>;
  /** update multiples rows of table: "tubings" */
  update_tubings_many?: Maybe<Array<Maybe<Tubings_Mutation_Response>>>;
  /** update data of the table: "tubings_type" */
  update_tubings_type?: Maybe<Tubings_Type_Mutation_Response>;
  /** update single row of the table: "tubings_type" */
  update_tubings_type_by_pk?: Maybe<Tubings_Type>;
  /** update multiples rows of table: "tubings_type" */
  update_tubings_type_many?: Maybe<Array<Maybe<Tubings_Type_Mutation_Response>>>;
  /** update data of the table: "under_saturated_oil_options" */
  update_under_saturated_oil_options?: Maybe<Under_Saturated_Oil_Options_Mutation_Response>;
  /** update single row of the table: "under_saturated_oil_options" */
  update_under_saturated_oil_options_by_pk?: Maybe<Under_Saturated_Oil_Options>;
  /** update multiples rows of table: "under_saturated_oil_options" */
  update_under_saturated_oil_options_many?: Maybe<Array<Maybe<Under_Saturated_Oil_Options_Mutation_Response>>>;
  /** update data of the table: "user_eula_acceptance" */
  update_user_eula_acceptance?: Maybe<User_Eula_Acceptance_Mutation_Response>;
  /** update single row of the table: "user_eula_acceptance" */
  update_user_eula_acceptance_by_pk?: Maybe<User_Eula_Acceptance>;
  /** update multiples rows of table: "user_eula_acceptance" */
  update_user_eula_acceptance_many?: Maybe<Array<Maybe<User_Eula_Acceptance_Mutation_Response>>>;
  /** update data of the table: "users" */
  update_users?: Maybe<Users_Mutation_Response>;
  /** update single row of the table: "users" */
  update_users_by_pk?: Maybe<Users>;
  /** update multiples rows of table: "users" */
  update_users_many?: Maybe<Array<Maybe<Users_Mutation_Response>>>;
  /** update data of the table: "variable_speed_drives" */
  update_variable_speed_drives?: Maybe<Variable_Speed_Drives_Mutation_Response>;
  /** update single row of the table: "variable_speed_drives" */
  update_variable_speed_drives_by_pk?: Maybe<Variable_Speed_Drives>;
  /** update multiples rows of table: "variable_speed_drives" */
  update_variable_speed_drives_many?: Maybe<Array<Maybe<Variable_Speed_Drives_Mutation_Response>>>;
  /** update data of the table: "water_density_options" */
  update_water_density_options?: Maybe<Water_Density_Options_Mutation_Response>;
  /** update single row of the table: "water_density_options" */
  update_water_density_options_by_pk?: Maybe<Water_Density_Options>;
  /** update multiples rows of table: "water_density_options" */
  update_water_density_options_many?: Maybe<Array<Maybe<Water_Density_Options_Mutation_Response>>>;
  /** update data of the table: "water_solution_gas_options" */
  update_water_solution_gas_options?: Maybe<Water_Solution_Gas_Options_Mutation_Response>;
  /** update single row of the table: "water_solution_gas_options" */
  update_water_solution_gas_options_by_pk?: Maybe<Water_Solution_Gas_Options>;
  /** update multiples rows of table: "water_solution_gas_options" */
  update_water_solution_gas_options_many?: Maybe<Array<Maybe<Water_Solution_Gas_Options_Mutation_Response>>>;
  /** update data of the table: "water_viscosity_options" */
  update_water_viscosity_options?: Maybe<Water_Viscosity_Options_Mutation_Response>;
  /** update single row of the table: "water_viscosity_options" */
  update_water_viscosity_options_by_pk?: Maybe<Water_Viscosity_Options>;
  /** update multiples rows of table: "water_viscosity_options" */
  update_water_viscosity_options_many?: Maybe<Array<Maybe<Water_Viscosity_Options_Mutation_Response>>>;
  /** update data of the table: "water_volume_factor_options" */
  update_water_volume_factor_options?: Maybe<Water_Volume_Factor_Options_Mutation_Response>;
  /** update single row of the table: "water_volume_factor_options" */
  update_water_volume_factor_options_by_pk?: Maybe<Water_Volume_Factor_Options>;
  /** update multiples rows of table: "water_volume_factor_options" */
  update_water_volume_factor_options_many?: Maybe<Array<Maybe<Water_Volume_Factor_Options_Mutation_Response>>>;
  /** update data of the table: "well_gas_type_options" */
  update_well_gas_type_options?: Maybe<Well_Gas_Type_Options_Mutation_Response>;
  /** update single row of the table: "well_gas_type_options" */
  update_well_gas_type_options_by_pk?: Maybe<Well_Gas_Type_Options>;
  /** update multiples rows of table: "well_gas_type_options" */
  update_well_gas_type_options_many?: Maybe<Array<Maybe<Well_Gas_Type_Options_Mutation_Response>>>;
  /** update data of the table: "well_test_gas_input_options" */
  update_well_test_gas_input_options?: Maybe<Well_Test_Gas_Input_Options_Mutation_Response>;
  /** update single row of the table: "well_test_gas_input_options" */
  update_well_test_gas_input_options_by_pk?: Maybe<Well_Test_Gas_Input_Options>;
  /** update multiples rows of table: "well_test_gas_input_options" */
  update_well_test_gas_input_options_many?: Maybe<Array<Maybe<Well_Test_Gas_Input_Options_Mutation_Response>>>;
  /** update data of the table: "well_test_liquid_input_options" */
  update_well_test_liquid_input_options?: Maybe<Well_Test_Liquid_Input_Options_Mutation_Response>;
  /** update single row of the table: "well_test_liquid_input_options" */
  update_well_test_liquid_input_options_by_pk?: Maybe<Well_Test_Liquid_Input_Options>;
  /** update multiples rows of table: "well_test_liquid_input_options" */
  update_well_test_liquid_input_options_many?: Maybe<Array<Maybe<Well_Test_Liquid_Input_Options_Mutation_Response>>>;
  /** update data of the table: "well_test_pressure_input_options" */
  update_well_test_pressure_input_options?: Maybe<Well_Test_Pressure_Input_Options_Mutation_Response>;
  /** update single row of the table: "well_test_pressure_input_options" */
  update_well_test_pressure_input_options_by_pk?: Maybe<Well_Test_Pressure_Input_Options>;
  /** update multiples rows of table: "well_test_pressure_input_options" */
  update_well_test_pressure_input_options_many?: Maybe<Array<Maybe<Well_Test_Pressure_Input_Options_Mutation_Response>>>;
  /** update data of the table: "wells" */
  update_wells?: Maybe<Wells_Mutation_Response>;
  /** update single row of the table: "wells" */
  update_wells_by_pk?: Maybe<Wells>;
  /** update multiples rows of table: "wells" */
  update_wells_many?: Maybe<Array<Maybe<Wells_Mutation_Response>>>;
  /** update data of the table: "y_tools" */
  update_y_tools?: Maybe<Y_Tools_Mutation_Response>;
  /** update single row of the table: "y_tools" */
  update_y_tools_by_pk?: Maybe<Y_Tools>;
  /** update multiples rows of table: "y_tools" */
  update_y_tools_many?: Maybe<Array<Maybe<Y_Tools_Mutation_Response>>>;
};


/** mutation root */
export type Mutation_RootCreateSkJobArgs = {
  input?: InputMaybe<SkJobInput>;
  is_s4_user?: InputMaybe<Scalars['Boolean']['input']>;
};


/** mutation root */
export type Mutation_RootCreateSkQuoteArgs = {
  input?: InputMaybe<SkQuoteInput>;
  is_s4_user?: InputMaybe<Scalars['Boolean']['input']>;
};


/** mutation root */
export type Mutation_RootDeleteSkQuoteArgs = {
  input?: InputMaybe<SkDeleteQuoteInput>;
  is_s4_user?: InputMaybe<Scalars['Boolean']['input']>;
};


/** mutation root */
export type Mutation_RootDelete_Bolt_On_DischargesArgs = {
  where: Bolt_On_Discharges_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Bolt_On_Discharges_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Bubble_Point_OptionsArgs = {
  where: Bubble_Point_Options_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Bubble_Point_Options_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_CablesArgs = {
  where: Cables_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Cables_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Casing_Flow_OptionsArgs = {
  where: Casing_Flow_Options_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Casing_Flow_Options_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_CasingsArgs = {
  where: Casings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Casings_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Casings_TypeArgs = {
  where: Casings_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Casings_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_CustomersArgs = {
  where: Customers_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Customers_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Dead_Oil_OptionsArgs = {
  where: Dead_Oil_Options_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Dead_Oil_Options_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Deviation_SurveyArgs = {
  where: Deviation_Survey_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Deviation_Survey_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Deviation_Survey_Directional_DatasetArgs = {
  where: Deviation_Survey_Directional_Dataset_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Deviation_Survey_Directional_Dataset_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Display_UnitsArgs = {
  where: Display_Units_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Display_Units_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_EulaArgs = {
  where: Eula_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Eula_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Flow_ModelArgs = {
  where: Flow_Model_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Flow_Model_ActiveArgs = {
  where: Flow_Model_Active_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Flow_Model_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Flow_Model_DeprecatedArgs = {
  where: Flow_Model_Deprecated_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Flow_Model_Deprecated_By_PkArgs = {
  value: Flow_Model_Enum;
};


/** mutation root */
export type Mutation_RootDelete_Friction_Loss_OptionsArgs = {
  where: Friction_Loss_Options_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Friction_Loss_Options_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Gas_Compressibility_OptionsArgs = {
  where: Gas_Compressibility_Options_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Gas_Compressibility_Options_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Gas_Viscosity_OptionsArgs = {
  where: Gas_Viscosity_Options_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Gas_Viscosity_Options_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_HousingsArgs = {
  where: Housings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Housings_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Hps_Liquid_TypeArgs = {
  where: Hps_Liquid_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Hps_Liquid_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_IntakesArgs = {
  where: Intakes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Intakes_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Legacy_UsersArgs = {
  where: Legacy_Users_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Legacy_Users_By_PkArgs = {
  hal_identifier: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Motor_Lead_ExtensionsArgs = {
  where: Motor_Lead_Extensions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Motor_Lead_Extensions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_MotorsArgs = {
  where: Motors_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Motors_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Natural_Gas_Separation_OptionsArgs = {
  where: Natural_Gas_Separation_Options_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Natural_Gas_Separation_Options_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Oil_Density_OptionsArgs = {
  where: Oil_Density_Options_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Oil_Density_Options_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Oil_Volume_Factor_OptionsArgs = {
  where: Oil_Volume_Factor_Options_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Oil_Volume_Factor_Options_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Override_OptionsArgs = {
  where: Override_Options_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Override_Options_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_PumpsArgs = {
  where: Pumps_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Pumps_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Quote_Line_Item_Category_DatasetArgs = {
  where: Quote_Line_Item_Category_Dataset_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Quote_Line_Item_Category_Dataset_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Quote_Line_Item_Serialized_DatasetArgs = {
  where: Quote_Line_Item_Serialized_Dataset_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Quote_Line_Item_Serialized_Dataset_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Quote_Line_Item_Source_DatasetArgs = {
  where: Quote_Line_Item_Source_Dataset_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Quote_Line_Item_Source_Dataset_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Quote_Line_Item_Subcategory_DatasetArgs = {
  where: Quote_Line_Item_Subcategory_Dataset_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Quote_Line_Item_Subcategory_Dataset_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Quote_Line_Item_Tax_Type_DatasetArgs = {
  where: Quote_Line_Item_Tax_Type_Dataset_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Quote_Line_Item_Tax_Type_Dataset_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Quote_Line_Item_Type_DatasetArgs = {
  where: Quote_Line_Item_Type_Dataset_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Quote_Line_Item_Type_Dataset_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Quote_Line_ItemsArgs = {
  where: Quote_Line_Items_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Quote_Line_Items_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Quote_Sk_Job_Type_DatasetArgs = {
  where: Quote_Sk_Job_Type_Dataset_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Quote_Sk_Job_Type_Dataset_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Quote_Source_DatasetArgs = {
  where: Quote_Source_Dataset_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Quote_Source_Dataset_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Quote_Status_DatasetArgs = {
  where: Quote_Status_Dataset_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Quote_Status_Dataset_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Quote_User_MessagesArgs = {
  where: Quote_User_Messages_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Quote_User_Messages_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_QuotesArgs = {
  where: Quotes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Quotes_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Revisions_Performance_Evaluations_JournalArgs = {
  where: Revisions_Performance_Evaluations_Journal_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Revisions_Performance_Evaluations_Journal_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Revisions_Performance_Evaluations_RevisionsArgs = {
  where: Revisions_Performance_Evaluations_Revisions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Revisions_Performance_Evaluations_Revisions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Revisions_Performance_Evaluations_Xref_Pumps_JournalArgs = {
  where: Revisions_Performance_Evaluations_Xref_Pumps_Journal_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Revisions_Performance_Evaluations_Xref_Pumps_Journal_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Revisions_Performance_Evaluations_Xref_Pumps_RevisionsArgs = {
  where: Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Revisions_Performance_Evaluations_Xref_Pumps_Revisions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_JournalArgs = {
  where: Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_RevisionsArgs = {
  where: Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_JournalArgs = {
  where: Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_RevisionsArgs = {
  where: Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_JournalArgs = {
  where: Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_RevisionsArgs = {
  where: Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_JournalArgs = {
  where: Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_RevisionsArgs = {
  where: Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Revisions_Scenario_Correlations_JournalArgs = {
  where: Revisions_Scenario_Correlations_Journal_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Revisions_Scenario_Correlations_Journal_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Revisions_Scenario_Correlations_RevisionsArgs = {
  where: Revisions_Scenario_Correlations_Revisions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Revisions_Scenario_Correlations_Revisions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Revisions_Scenario_Equipment_JournalArgs = {
  where: Revisions_Scenario_Equipment_Journal_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Revisions_Scenario_Equipment_Journal_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Revisions_Scenario_Equipment_RevisionsArgs = {
  where: Revisions_Scenario_Equipment_Revisions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Revisions_Scenario_Equipment_Revisions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Revisions_Scenario_Equipment_Xref_Cables_JournalArgs = {
  where: Revisions_Scenario_Equipment_Xref_Cables_Journal_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Revisions_Scenario_Equipment_Xref_Cables_Journal_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Revisions_Scenario_Equipment_Xref_Cables_RevisionsArgs = {
  where: Revisions_Scenario_Equipment_Xref_Cables_Revisions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Revisions_Scenario_Equipment_Xref_Cables_Revisions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Revisions_Scenario_Equipment_Xref_Housings_JournalArgs = {
  where: Revisions_Scenario_Equipment_Xref_Housings_Journal_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Revisions_Scenario_Equipment_Xref_Housings_Journal_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Revisions_Scenario_Equipment_Xref_Housings_RevisionsArgs = {
  where: Revisions_Scenario_Equipment_Xref_Housings_Revisions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Revisions_Scenario_Equipment_Xref_Housings_Revisions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Revisions_Scenario_Equipment_Xref_Intakes_JournalArgs = {
  where: Revisions_Scenario_Equipment_Xref_Intakes_Journal_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Revisions_Scenario_Equipment_Xref_Intakes_Journal_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Revisions_Scenario_Equipment_Xref_Intakes_RevisionsArgs = {
  where: Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Revisions_Scenario_Equipment_Xref_Intakes_Revisions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Revisions_Scenario_Equipment_Xref_Pumps_JournalArgs = {
  where: Revisions_Scenario_Equipment_Xref_Pumps_Journal_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Revisions_Scenario_Equipment_Xref_Pumps_Journal_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Revisions_Scenario_Equipment_Xref_Pumps_RevisionsArgs = {
  where: Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Revisions_Scenario_Equipment_Xref_Pumps_Revisions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Revisions_Scenario_Equipment_Xref_Seals_JournalArgs = {
  where: Revisions_Scenario_Equipment_Xref_Seals_Journal_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Revisions_Scenario_Equipment_Xref_Seals_Journal_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Revisions_Scenario_Equipment_Xref_Seals_RevisionsArgs = {
  where: Revisions_Scenario_Equipment_Xref_Seals_Revisions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Revisions_Scenario_Equipment_Xref_Seals_Revisions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Revisions_Scenario_Parameters_JournalArgs = {
  where: Revisions_Scenario_Parameters_Journal_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Revisions_Scenario_Parameters_Journal_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Revisions_Scenario_Parameters_RevisionsArgs = {
  where: Revisions_Scenario_Parameters_Revisions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Revisions_Scenario_Parameters_Revisions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Revisions_Scenario_Well_Properties_JournalArgs = {
  where: Revisions_Scenario_Well_Properties_Journal_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Revisions_Scenario_Well_Properties_Journal_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Revisions_Scenario_Well_Properties_RevisionsArgs = {
  where: Revisions_Scenario_Well_Properties_Revisions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Revisions_Scenario_Well_Properties_Revisions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Revisions_Scenarios_JournalArgs = {
  where: Revisions_Scenarios_Journal_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Revisions_Scenarios_Journal_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Revisions_Scenarios_RevisionsArgs = {
  where: Revisions_Scenarios_Revisions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Revisions_Scenarios_Revisions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Revisions_Sizings_JournalArgs = {
  where: Revisions_Sizings_Journal_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Revisions_Sizings_Journal_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Revisions_Sizings_RevisionsArgs = {
  where: Revisions_Sizings_Revisions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Revisions_Sizings_Revisions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Saturated_Oil_OptionsArgs = {
  where: Saturated_Oil_Options_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Saturated_Oil_Options_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Scenario_ReasonsArgs = {
  where: Scenario_Reasons_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Scenario_Reasons_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Seal_Motor_OilArgs = {
  where: Seal_Motor_Oil_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Seal_Motor_Oil_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_SealsArgs = {
  where: Seals_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Seals_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_SensorsArgs = {
  where: Sensors_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Sensors_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Sizing_DispositionsArgs = {
  where: Sizing_Dispositions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Sizing_Dispositions_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Sizing_ImportsArgs = {
  where: Sizing_Imports_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Sizing_Imports_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Sizing_Pumping_TypeArgs = {
  where: Sizing_Pumping_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Sizing_Pumping_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Solution_Gas_Oil_Ratio_OptionsArgs = {
  where: Solution_Gas_Oil_Ratio_Options_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Solution_Gas_Oil_Ratio_Options_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Step_Down_TransformersArgs = {
  where: Step_Down_Transformers_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Step_Down_Transformers_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Step_Up_TransformersArgs = {
  where: Step_Up_Transformers_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Step_Up_Transformers_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_SwitchboardsArgs = {
  where: Switchboards_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Switchboards_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Tubing_Flow_OptionsArgs = {
  where: Tubing_Flow_Options_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Tubing_Flow_Options_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_TubingsArgs = {
  where: Tubings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Tubings_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Tubings_TypeArgs = {
  where: Tubings_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Tubings_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Under_Saturated_Oil_OptionsArgs = {
  where: Under_Saturated_Oil_Options_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Under_Saturated_Oil_Options_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_User_Eula_AcceptanceArgs = {
  where: User_Eula_Acceptance_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Eula_Acceptance_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_UsersArgs = {
  where: Users_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Users_By_PkArgs = {
  id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Variable_Speed_DrivesArgs = {
  where: Variable_Speed_Drives_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Variable_Speed_Drives_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Water_Density_OptionsArgs = {
  where: Water_Density_Options_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Water_Density_Options_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Water_Solution_Gas_OptionsArgs = {
  where: Water_Solution_Gas_Options_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Water_Solution_Gas_Options_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Water_Viscosity_OptionsArgs = {
  where: Water_Viscosity_Options_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Water_Viscosity_Options_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Water_Volume_Factor_OptionsArgs = {
  where: Water_Volume_Factor_Options_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Water_Volume_Factor_Options_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Well_Gas_Type_OptionsArgs = {
  where: Well_Gas_Type_Options_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Well_Gas_Type_Options_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Well_Test_Gas_Input_OptionsArgs = {
  where: Well_Test_Gas_Input_Options_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Well_Test_Gas_Input_Options_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Well_Test_Liquid_Input_OptionsArgs = {
  where: Well_Test_Liquid_Input_Options_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Well_Test_Liquid_Input_Options_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Well_Test_Pressure_Input_OptionsArgs = {
  where: Well_Test_Pressure_Input_Options_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Well_Test_Pressure_Input_Options_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_WellsArgs = {
  where: Wells_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Wells_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Y_ToolsArgs = {
  where: Y_Tools_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Y_Tools_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootInsert_Bolt_On_DischargesArgs = {
  objects: Array<Bolt_On_Discharges_Insert_Input>;
  on_conflict?: InputMaybe<Bolt_On_Discharges_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Bolt_On_Discharges_OneArgs = {
  object: Bolt_On_Discharges_Insert_Input;
  on_conflict?: InputMaybe<Bolt_On_Discharges_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Bubble_Point_OptionsArgs = {
  objects: Array<Bubble_Point_Options_Insert_Input>;
  on_conflict?: InputMaybe<Bubble_Point_Options_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Bubble_Point_Options_OneArgs = {
  object: Bubble_Point_Options_Insert_Input;
  on_conflict?: InputMaybe<Bubble_Point_Options_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_CablesArgs = {
  objects: Array<Cables_Insert_Input>;
  on_conflict?: InputMaybe<Cables_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Cables_OneArgs = {
  object: Cables_Insert_Input;
  on_conflict?: InputMaybe<Cables_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Casing_Flow_OptionsArgs = {
  objects: Array<Casing_Flow_Options_Insert_Input>;
  on_conflict?: InputMaybe<Casing_Flow_Options_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Casing_Flow_Options_OneArgs = {
  object: Casing_Flow_Options_Insert_Input;
  on_conflict?: InputMaybe<Casing_Flow_Options_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_CasingsArgs = {
  objects: Array<Casings_Insert_Input>;
  on_conflict?: InputMaybe<Casings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Casings_OneArgs = {
  object: Casings_Insert_Input;
  on_conflict?: InputMaybe<Casings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Casings_TypeArgs = {
  objects: Array<Casings_Type_Insert_Input>;
  on_conflict?: InputMaybe<Casings_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Casings_Type_OneArgs = {
  object: Casings_Type_Insert_Input;
  on_conflict?: InputMaybe<Casings_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_CustomersArgs = {
  objects: Array<Customers_Insert_Input>;
  on_conflict?: InputMaybe<Customers_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Customers_OneArgs = {
  object: Customers_Insert_Input;
  on_conflict?: InputMaybe<Customers_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Dead_Oil_OptionsArgs = {
  objects: Array<Dead_Oil_Options_Insert_Input>;
  on_conflict?: InputMaybe<Dead_Oil_Options_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Dead_Oil_Options_OneArgs = {
  object: Dead_Oil_Options_Insert_Input;
  on_conflict?: InputMaybe<Dead_Oil_Options_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Deviation_SurveyArgs = {
  objects: Array<Deviation_Survey_Insert_Input>;
  on_conflict?: InputMaybe<Deviation_Survey_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Deviation_Survey_Directional_DatasetArgs = {
  objects: Array<Deviation_Survey_Directional_Dataset_Insert_Input>;
  on_conflict?: InputMaybe<Deviation_Survey_Directional_Dataset_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Deviation_Survey_Directional_Dataset_OneArgs = {
  object: Deviation_Survey_Directional_Dataset_Insert_Input;
  on_conflict?: InputMaybe<Deviation_Survey_Directional_Dataset_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Deviation_Survey_OneArgs = {
  object: Deviation_Survey_Insert_Input;
  on_conflict?: InputMaybe<Deviation_Survey_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Display_UnitsArgs = {
  objects: Array<Display_Units_Insert_Input>;
  on_conflict?: InputMaybe<Display_Units_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Display_Units_OneArgs = {
  object: Display_Units_Insert_Input;
  on_conflict?: InputMaybe<Display_Units_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_EulaArgs = {
  objects: Array<Eula_Insert_Input>;
  on_conflict?: InputMaybe<Eula_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eula_OneArgs = {
  object: Eula_Insert_Input;
  on_conflict?: InputMaybe<Eula_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Flow_ModelArgs = {
  objects: Array<Flow_Model_Insert_Input>;
  on_conflict?: InputMaybe<Flow_Model_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Flow_Model_ActiveArgs = {
  objects: Array<Flow_Model_Active_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Flow_Model_Active_OneArgs = {
  object: Flow_Model_Active_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_Flow_Model_DeprecatedArgs = {
  objects: Array<Flow_Model_Deprecated_Insert_Input>;
  on_conflict?: InputMaybe<Flow_Model_Deprecated_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Flow_Model_Deprecated_OneArgs = {
  object: Flow_Model_Deprecated_Insert_Input;
  on_conflict?: InputMaybe<Flow_Model_Deprecated_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Flow_Model_OneArgs = {
  object: Flow_Model_Insert_Input;
  on_conflict?: InputMaybe<Flow_Model_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Friction_Loss_OptionsArgs = {
  objects: Array<Friction_Loss_Options_Insert_Input>;
  on_conflict?: InputMaybe<Friction_Loss_Options_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Friction_Loss_Options_OneArgs = {
  object: Friction_Loss_Options_Insert_Input;
  on_conflict?: InputMaybe<Friction_Loss_Options_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Gas_Compressibility_OptionsArgs = {
  objects: Array<Gas_Compressibility_Options_Insert_Input>;
  on_conflict?: InputMaybe<Gas_Compressibility_Options_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Gas_Compressibility_Options_OneArgs = {
  object: Gas_Compressibility_Options_Insert_Input;
  on_conflict?: InputMaybe<Gas_Compressibility_Options_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Gas_Viscosity_OptionsArgs = {
  objects: Array<Gas_Viscosity_Options_Insert_Input>;
  on_conflict?: InputMaybe<Gas_Viscosity_Options_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Gas_Viscosity_Options_OneArgs = {
  object: Gas_Viscosity_Options_Insert_Input;
  on_conflict?: InputMaybe<Gas_Viscosity_Options_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_HousingsArgs = {
  objects: Array<Housings_Insert_Input>;
  on_conflict?: InputMaybe<Housings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Housings_OneArgs = {
  object: Housings_Insert_Input;
  on_conflict?: InputMaybe<Housings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Hps_Liquid_TypeArgs = {
  objects: Array<Hps_Liquid_Type_Insert_Input>;
  on_conflict?: InputMaybe<Hps_Liquid_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Hps_Liquid_Type_OneArgs = {
  object: Hps_Liquid_Type_Insert_Input;
  on_conflict?: InputMaybe<Hps_Liquid_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_IntakesArgs = {
  objects: Array<Intakes_Insert_Input>;
  on_conflict?: InputMaybe<Intakes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Intakes_OneArgs = {
  object: Intakes_Insert_Input;
  on_conflict?: InputMaybe<Intakes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Legacy_UsersArgs = {
  objects: Array<Legacy_Users_Insert_Input>;
  on_conflict?: InputMaybe<Legacy_Users_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Legacy_Users_OneArgs = {
  object: Legacy_Users_Insert_Input;
  on_conflict?: InputMaybe<Legacy_Users_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Motor_Lead_ExtensionsArgs = {
  objects: Array<Motor_Lead_Extensions_Insert_Input>;
  on_conflict?: InputMaybe<Motor_Lead_Extensions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Motor_Lead_Extensions_OneArgs = {
  object: Motor_Lead_Extensions_Insert_Input;
  on_conflict?: InputMaybe<Motor_Lead_Extensions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_MotorsArgs = {
  objects: Array<Motors_Insert_Input>;
  on_conflict?: InputMaybe<Motors_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Motors_OneArgs = {
  object: Motors_Insert_Input;
  on_conflict?: InputMaybe<Motors_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Natural_Gas_Separation_OptionsArgs = {
  objects: Array<Natural_Gas_Separation_Options_Insert_Input>;
  on_conflict?: InputMaybe<Natural_Gas_Separation_Options_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Natural_Gas_Separation_Options_OneArgs = {
  object: Natural_Gas_Separation_Options_Insert_Input;
  on_conflict?: InputMaybe<Natural_Gas_Separation_Options_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Oil_Density_OptionsArgs = {
  objects: Array<Oil_Density_Options_Insert_Input>;
  on_conflict?: InputMaybe<Oil_Density_Options_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Oil_Density_Options_OneArgs = {
  object: Oil_Density_Options_Insert_Input;
  on_conflict?: InputMaybe<Oil_Density_Options_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Oil_Volume_Factor_OptionsArgs = {
  objects: Array<Oil_Volume_Factor_Options_Insert_Input>;
  on_conflict?: InputMaybe<Oil_Volume_Factor_Options_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Oil_Volume_Factor_Options_OneArgs = {
  object: Oil_Volume_Factor_Options_Insert_Input;
  on_conflict?: InputMaybe<Oil_Volume_Factor_Options_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Override_OptionsArgs = {
  objects: Array<Override_Options_Insert_Input>;
  on_conflict?: InputMaybe<Override_Options_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Override_Options_OneArgs = {
  object: Override_Options_Insert_Input;
  on_conflict?: InputMaybe<Override_Options_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_PumpsArgs = {
  objects: Array<Pumps_Insert_Input>;
  on_conflict?: InputMaybe<Pumps_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Pumps_OneArgs = {
  object: Pumps_Insert_Input;
  on_conflict?: InputMaybe<Pumps_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Quote_Line_Item_Category_DatasetArgs = {
  objects: Array<Quote_Line_Item_Category_Dataset_Insert_Input>;
  on_conflict?: InputMaybe<Quote_Line_Item_Category_Dataset_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Quote_Line_Item_Category_Dataset_OneArgs = {
  object: Quote_Line_Item_Category_Dataset_Insert_Input;
  on_conflict?: InputMaybe<Quote_Line_Item_Category_Dataset_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Quote_Line_Item_Serialized_DatasetArgs = {
  objects: Array<Quote_Line_Item_Serialized_Dataset_Insert_Input>;
  on_conflict?: InputMaybe<Quote_Line_Item_Serialized_Dataset_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Quote_Line_Item_Serialized_Dataset_OneArgs = {
  object: Quote_Line_Item_Serialized_Dataset_Insert_Input;
  on_conflict?: InputMaybe<Quote_Line_Item_Serialized_Dataset_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Quote_Line_Item_Source_DatasetArgs = {
  objects: Array<Quote_Line_Item_Source_Dataset_Insert_Input>;
  on_conflict?: InputMaybe<Quote_Line_Item_Source_Dataset_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Quote_Line_Item_Source_Dataset_OneArgs = {
  object: Quote_Line_Item_Source_Dataset_Insert_Input;
  on_conflict?: InputMaybe<Quote_Line_Item_Source_Dataset_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Quote_Line_Item_Subcategory_DatasetArgs = {
  objects: Array<Quote_Line_Item_Subcategory_Dataset_Insert_Input>;
  on_conflict?: InputMaybe<Quote_Line_Item_Subcategory_Dataset_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Quote_Line_Item_Subcategory_Dataset_OneArgs = {
  object: Quote_Line_Item_Subcategory_Dataset_Insert_Input;
  on_conflict?: InputMaybe<Quote_Line_Item_Subcategory_Dataset_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Quote_Line_Item_Tax_Type_DatasetArgs = {
  objects: Array<Quote_Line_Item_Tax_Type_Dataset_Insert_Input>;
  on_conflict?: InputMaybe<Quote_Line_Item_Tax_Type_Dataset_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Quote_Line_Item_Tax_Type_Dataset_OneArgs = {
  object: Quote_Line_Item_Tax_Type_Dataset_Insert_Input;
  on_conflict?: InputMaybe<Quote_Line_Item_Tax_Type_Dataset_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Quote_Line_Item_Type_DatasetArgs = {
  objects: Array<Quote_Line_Item_Type_Dataset_Insert_Input>;
  on_conflict?: InputMaybe<Quote_Line_Item_Type_Dataset_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Quote_Line_Item_Type_Dataset_OneArgs = {
  object: Quote_Line_Item_Type_Dataset_Insert_Input;
  on_conflict?: InputMaybe<Quote_Line_Item_Type_Dataset_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Quote_Line_ItemsArgs = {
  objects: Array<Quote_Line_Items_Insert_Input>;
  on_conflict?: InputMaybe<Quote_Line_Items_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Quote_Line_Items_OneArgs = {
  object: Quote_Line_Items_Insert_Input;
  on_conflict?: InputMaybe<Quote_Line_Items_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Quote_Sk_Job_Type_DatasetArgs = {
  objects: Array<Quote_Sk_Job_Type_Dataset_Insert_Input>;
  on_conflict?: InputMaybe<Quote_Sk_Job_Type_Dataset_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Quote_Sk_Job_Type_Dataset_OneArgs = {
  object: Quote_Sk_Job_Type_Dataset_Insert_Input;
  on_conflict?: InputMaybe<Quote_Sk_Job_Type_Dataset_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Quote_Source_DatasetArgs = {
  objects: Array<Quote_Source_Dataset_Insert_Input>;
  on_conflict?: InputMaybe<Quote_Source_Dataset_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Quote_Source_Dataset_OneArgs = {
  object: Quote_Source_Dataset_Insert_Input;
  on_conflict?: InputMaybe<Quote_Source_Dataset_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Quote_Status_DatasetArgs = {
  objects: Array<Quote_Status_Dataset_Insert_Input>;
  on_conflict?: InputMaybe<Quote_Status_Dataset_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Quote_Status_Dataset_OneArgs = {
  object: Quote_Status_Dataset_Insert_Input;
  on_conflict?: InputMaybe<Quote_Status_Dataset_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Quote_User_MessagesArgs = {
  objects: Array<Quote_User_Messages_Insert_Input>;
  on_conflict?: InputMaybe<Quote_User_Messages_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Quote_User_Messages_OneArgs = {
  object: Quote_User_Messages_Insert_Input;
  on_conflict?: InputMaybe<Quote_User_Messages_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_QuotesArgs = {
  objects: Array<Quotes_Insert_Input>;
  on_conflict?: InputMaybe<Quotes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Quotes_OneArgs = {
  object: Quotes_Insert_Input;
  on_conflict?: InputMaybe<Quotes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Revisions_Performance_Evaluations_JournalArgs = {
  objects: Array<Revisions_Performance_Evaluations_Journal_Insert_Input>;
  on_conflict?: InputMaybe<Revisions_Performance_Evaluations_Journal_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Revisions_Performance_Evaluations_Journal_OneArgs = {
  object: Revisions_Performance_Evaluations_Journal_Insert_Input;
  on_conflict?: InputMaybe<Revisions_Performance_Evaluations_Journal_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Revisions_Performance_Evaluations_RevisionsArgs = {
  objects: Array<Revisions_Performance_Evaluations_Revisions_Insert_Input>;
  on_conflict?: InputMaybe<Revisions_Performance_Evaluations_Revisions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Revisions_Performance_Evaluations_Revisions_OneArgs = {
  object: Revisions_Performance_Evaluations_Revisions_Insert_Input;
  on_conflict?: InputMaybe<Revisions_Performance_Evaluations_Revisions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Revisions_Performance_Evaluations_Xref_Pumps_JournalArgs = {
  objects: Array<Revisions_Performance_Evaluations_Xref_Pumps_Journal_Insert_Input>;
  on_conflict?: InputMaybe<Revisions_Performance_Evaluations_Xref_Pumps_Journal_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Revisions_Performance_Evaluations_Xref_Pumps_Journal_OneArgs = {
  object: Revisions_Performance_Evaluations_Xref_Pumps_Journal_Insert_Input;
  on_conflict?: InputMaybe<Revisions_Performance_Evaluations_Xref_Pumps_Journal_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Revisions_Performance_Evaluations_Xref_Pumps_RevisionsArgs = {
  objects: Array<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Insert_Input>;
  on_conflict?: InputMaybe<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Revisions_Performance_Evaluations_Xref_Pumps_Revisions_OneArgs = {
  object: Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Insert_Input;
  on_conflict?: InputMaybe<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_JournalArgs = {
  objects: Array<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_Insert_Input>;
  on_conflict?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_OneArgs = {
  object: Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_Insert_Input;
  on_conflict?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_RevisionsArgs = {
  objects: Array<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Insert_Input>;
  on_conflict?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_OneArgs = {
  object: Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Insert_Input;
  on_conflict?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_JournalArgs = {
  objects: Array<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_Insert_Input>;
  on_conflict?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_OneArgs = {
  object: Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_Insert_Input;
  on_conflict?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_RevisionsArgs = {
  objects: Array<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Insert_Input>;
  on_conflict?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_OneArgs = {
  object: Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Insert_Input;
  on_conflict?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_JournalArgs = {
  objects: Array<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_Insert_Input>;
  on_conflict?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_OneArgs = {
  object: Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_Insert_Input;
  on_conflict?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_RevisionsArgs = {
  objects: Array<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Insert_Input>;
  on_conflict?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_OneArgs = {
  object: Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Insert_Input;
  on_conflict?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_JournalArgs = {
  objects: Array<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_Insert_Input>;
  on_conflict?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_OneArgs = {
  object: Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_Insert_Input;
  on_conflict?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_RevisionsArgs = {
  objects: Array<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Insert_Input>;
  on_conflict?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_OneArgs = {
  object: Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Insert_Input;
  on_conflict?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Revisions_Scenario_Correlations_JournalArgs = {
  objects: Array<Revisions_Scenario_Correlations_Journal_Insert_Input>;
  on_conflict?: InputMaybe<Revisions_Scenario_Correlations_Journal_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Revisions_Scenario_Correlations_Journal_OneArgs = {
  object: Revisions_Scenario_Correlations_Journal_Insert_Input;
  on_conflict?: InputMaybe<Revisions_Scenario_Correlations_Journal_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Revisions_Scenario_Correlations_RevisionsArgs = {
  objects: Array<Revisions_Scenario_Correlations_Revisions_Insert_Input>;
  on_conflict?: InputMaybe<Revisions_Scenario_Correlations_Revisions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Revisions_Scenario_Correlations_Revisions_OneArgs = {
  object: Revisions_Scenario_Correlations_Revisions_Insert_Input;
  on_conflict?: InputMaybe<Revisions_Scenario_Correlations_Revisions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Revisions_Scenario_Equipment_JournalArgs = {
  objects: Array<Revisions_Scenario_Equipment_Journal_Insert_Input>;
  on_conflict?: InputMaybe<Revisions_Scenario_Equipment_Journal_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Revisions_Scenario_Equipment_Journal_OneArgs = {
  object: Revisions_Scenario_Equipment_Journal_Insert_Input;
  on_conflict?: InputMaybe<Revisions_Scenario_Equipment_Journal_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Revisions_Scenario_Equipment_RevisionsArgs = {
  objects: Array<Revisions_Scenario_Equipment_Revisions_Insert_Input>;
  on_conflict?: InputMaybe<Revisions_Scenario_Equipment_Revisions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Revisions_Scenario_Equipment_Revisions_OneArgs = {
  object: Revisions_Scenario_Equipment_Revisions_Insert_Input;
  on_conflict?: InputMaybe<Revisions_Scenario_Equipment_Revisions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Revisions_Scenario_Equipment_Xref_Cables_JournalArgs = {
  objects: Array<Revisions_Scenario_Equipment_Xref_Cables_Journal_Insert_Input>;
  on_conflict?: InputMaybe<Revisions_Scenario_Equipment_Xref_Cables_Journal_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Revisions_Scenario_Equipment_Xref_Cables_Journal_OneArgs = {
  object: Revisions_Scenario_Equipment_Xref_Cables_Journal_Insert_Input;
  on_conflict?: InputMaybe<Revisions_Scenario_Equipment_Xref_Cables_Journal_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Revisions_Scenario_Equipment_Xref_Cables_RevisionsArgs = {
  objects: Array<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Insert_Input>;
  on_conflict?: InputMaybe<Revisions_Scenario_Equipment_Xref_Cables_Revisions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Revisions_Scenario_Equipment_Xref_Cables_Revisions_OneArgs = {
  object: Revisions_Scenario_Equipment_Xref_Cables_Revisions_Insert_Input;
  on_conflict?: InputMaybe<Revisions_Scenario_Equipment_Xref_Cables_Revisions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Revisions_Scenario_Equipment_Xref_Housings_JournalArgs = {
  objects: Array<Revisions_Scenario_Equipment_Xref_Housings_Journal_Insert_Input>;
  on_conflict?: InputMaybe<Revisions_Scenario_Equipment_Xref_Housings_Journal_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Revisions_Scenario_Equipment_Xref_Housings_Journal_OneArgs = {
  object: Revisions_Scenario_Equipment_Xref_Housings_Journal_Insert_Input;
  on_conflict?: InputMaybe<Revisions_Scenario_Equipment_Xref_Housings_Journal_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Revisions_Scenario_Equipment_Xref_Housings_RevisionsArgs = {
  objects: Array<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Insert_Input>;
  on_conflict?: InputMaybe<Revisions_Scenario_Equipment_Xref_Housings_Revisions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Revisions_Scenario_Equipment_Xref_Housings_Revisions_OneArgs = {
  object: Revisions_Scenario_Equipment_Xref_Housings_Revisions_Insert_Input;
  on_conflict?: InputMaybe<Revisions_Scenario_Equipment_Xref_Housings_Revisions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Revisions_Scenario_Equipment_Xref_Intakes_JournalArgs = {
  objects: Array<Revisions_Scenario_Equipment_Xref_Intakes_Journal_Insert_Input>;
  on_conflict?: InputMaybe<Revisions_Scenario_Equipment_Xref_Intakes_Journal_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Revisions_Scenario_Equipment_Xref_Intakes_Journal_OneArgs = {
  object: Revisions_Scenario_Equipment_Xref_Intakes_Journal_Insert_Input;
  on_conflict?: InputMaybe<Revisions_Scenario_Equipment_Xref_Intakes_Journal_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Revisions_Scenario_Equipment_Xref_Intakes_RevisionsArgs = {
  objects: Array<Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Insert_Input>;
  on_conflict?: InputMaybe<Revisions_Scenario_Equipment_Xref_Intakes_Revisions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Revisions_Scenario_Equipment_Xref_Intakes_Revisions_OneArgs = {
  object: Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Insert_Input;
  on_conflict?: InputMaybe<Revisions_Scenario_Equipment_Xref_Intakes_Revisions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Revisions_Scenario_Equipment_Xref_Pumps_JournalArgs = {
  objects: Array<Revisions_Scenario_Equipment_Xref_Pumps_Journal_Insert_Input>;
  on_conflict?: InputMaybe<Revisions_Scenario_Equipment_Xref_Pumps_Journal_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Revisions_Scenario_Equipment_Xref_Pumps_Journal_OneArgs = {
  object: Revisions_Scenario_Equipment_Xref_Pumps_Journal_Insert_Input;
  on_conflict?: InputMaybe<Revisions_Scenario_Equipment_Xref_Pumps_Journal_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Revisions_Scenario_Equipment_Xref_Pumps_RevisionsArgs = {
  objects: Array<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Insert_Input>;
  on_conflict?: InputMaybe<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Revisions_Scenario_Equipment_Xref_Pumps_Revisions_OneArgs = {
  object: Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Insert_Input;
  on_conflict?: InputMaybe<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Revisions_Scenario_Equipment_Xref_Seals_JournalArgs = {
  objects: Array<Revisions_Scenario_Equipment_Xref_Seals_Journal_Insert_Input>;
  on_conflict?: InputMaybe<Revisions_Scenario_Equipment_Xref_Seals_Journal_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Revisions_Scenario_Equipment_Xref_Seals_Journal_OneArgs = {
  object: Revisions_Scenario_Equipment_Xref_Seals_Journal_Insert_Input;
  on_conflict?: InputMaybe<Revisions_Scenario_Equipment_Xref_Seals_Journal_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Revisions_Scenario_Equipment_Xref_Seals_RevisionsArgs = {
  objects: Array<Revisions_Scenario_Equipment_Xref_Seals_Revisions_Insert_Input>;
  on_conflict?: InputMaybe<Revisions_Scenario_Equipment_Xref_Seals_Revisions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Revisions_Scenario_Equipment_Xref_Seals_Revisions_OneArgs = {
  object: Revisions_Scenario_Equipment_Xref_Seals_Revisions_Insert_Input;
  on_conflict?: InputMaybe<Revisions_Scenario_Equipment_Xref_Seals_Revisions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Revisions_Scenario_Parameters_JournalArgs = {
  objects: Array<Revisions_Scenario_Parameters_Journal_Insert_Input>;
  on_conflict?: InputMaybe<Revisions_Scenario_Parameters_Journal_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Revisions_Scenario_Parameters_Journal_OneArgs = {
  object: Revisions_Scenario_Parameters_Journal_Insert_Input;
  on_conflict?: InputMaybe<Revisions_Scenario_Parameters_Journal_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Revisions_Scenario_Parameters_RevisionsArgs = {
  objects: Array<Revisions_Scenario_Parameters_Revisions_Insert_Input>;
  on_conflict?: InputMaybe<Revisions_Scenario_Parameters_Revisions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Revisions_Scenario_Parameters_Revisions_OneArgs = {
  object: Revisions_Scenario_Parameters_Revisions_Insert_Input;
  on_conflict?: InputMaybe<Revisions_Scenario_Parameters_Revisions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Revisions_Scenario_Well_Properties_JournalArgs = {
  objects: Array<Revisions_Scenario_Well_Properties_Journal_Insert_Input>;
  on_conflict?: InputMaybe<Revisions_Scenario_Well_Properties_Journal_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Revisions_Scenario_Well_Properties_Journal_OneArgs = {
  object: Revisions_Scenario_Well_Properties_Journal_Insert_Input;
  on_conflict?: InputMaybe<Revisions_Scenario_Well_Properties_Journal_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Revisions_Scenario_Well_Properties_RevisionsArgs = {
  objects: Array<Revisions_Scenario_Well_Properties_Revisions_Insert_Input>;
  on_conflict?: InputMaybe<Revisions_Scenario_Well_Properties_Revisions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Revisions_Scenario_Well_Properties_Revisions_OneArgs = {
  object: Revisions_Scenario_Well_Properties_Revisions_Insert_Input;
  on_conflict?: InputMaybe<Revisions_Scenario_Well_Properties_Revisions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Revisions_Scenarios_JournalArgs = {
  objects: Array<Revisions_Scenarios_Journal_Insert_Input>;
  on_conflict?: InputMaybe<Revisions_Scenarios_Journal_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Revisions_Scenarios_Journal_OneArgs = {
  object: Revisions_Scenarios_Journal_Insert_Input;
  on_conflict?: InputMaybe<Revisions_Scenarios_Journal_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Revisions_Scenarios_RevisionsArgs = {
  objects: Array<Revisions_Scenarios_Revisions_Insert_Input>;
  on_conflict?: InputMaybe<Revisions_Scenarios_Revisions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Revisions_Scenarios_Revisions_OneArgs = {
  object: Revisions_Scenarios_Revisions_Insert_Input;
  on_conflict?: InputMaybe<Revisions_Scenarios_Revisions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Revisions_Sizings_JournalArgs = {
  objects: Array<Revisions_Sizings_Journal_Insert_Input>;
  on_conflict?: InputMaybe<Revisions_Sizings_Journal_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Revisions_Sizings_Journal_OneArgs = {
  object: Revisions_Sizings_Journal_Insert_Input;
  on_conflict?: InputMaybe<Revisions_Sizings_Journal_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Revisions_Sizings_RevisionsArgs = {
  objects: Array<Revisions_Sizings_Revisions_Insert_Input>;
  on_conflict?: InputMaybe<Revisions_Sizings_Revisions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Revisions_Sizings_Revisions_OneArgs = {
  object: Revisions_Sizings_Revisions_Insert_Input;
  on_conflict?: InputMaybe<Revisions_Sizings_Revisions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Saturated_Oil_OptionsArgs = {
  objects: Array<Saturated_Oil_Options_Insert_Input>;
  on_conflict?: InputMaybe<Saturated_Oil_Options_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Saturated_Oil_Options_OneArgs = {
  object: Saturated_Oil_Options_Insert_Input;
  on_conflict?: InputMaybe<Saturated_Oil_Options_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Scenario_ReasonsArgs = {
  objects: Array<Scenario_Reasons_Insert_Input>;
  on_conflict?: InputMaybe<Scenario_Reasons_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Scenario_Reasons_OneArgs = {
  object: Scenario_Reasons_Insert_Input;
  on_conflict?: InputMaybe<Scenario_Reasons_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Seal_Motor_OilArgs = {
  objects: Array<Seal_Motor_Oil_Insert_Input>;
  on_conflict?: InputMaybe<Seal_Motor_Oil_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Seal_Motor_Oil_OneArgs = {
  object: Seal_Motor_Oil_Insert_Input;
  on_conflict?: InputMaybe<Seal_Motor_Oil_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_SealsArgs = {
  objects: Array<Seals_Insert_Input>;
  on_conflict?: InputMaybe<Seals_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Seals_OneArgs = {
  object: Seals_Insert_Input;
  on_conflict?: InputMaybe<Seals_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_SensorsArgs = {
  objects: Array<Sensors_Insert_Input>;
  on_conflict?: InputMaybe<Sensors_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Sensors_OneArgs = {
  object: Sensors_Insert_Input;
  on_conflict?: InputMaybe<Sensors_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Sizing_DispositionsArgs = {
  objects: Array<Sizing_Dispositions_Insert_Input>;
  on_conflict?: InputMaybe<Sizing_Dispositions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Sizing_Dispositions_OneArgs = {
  object: Sizing_Dispositions_Insert_Input;
  on_conflict?: InputMaybe<Sizing_Dispositions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Sizing_ImportsArgs = {
  objects: Array<Sizing_Imports_Insert_Input>;
  on_conflict?: InputMaybe<Sizing_Imports_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Sizing_Imports_OneArgs = {
  object: Sizing_Imports_Insert_Input;
  on_conflict?: InputMaybe<Sizing_Imports_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Sizing_Pumping_TypeArgs = {
  objects: Array<Sizing_Pumping_Type_Insert_Input>;
  on_conflict?: InputMaybe<Sizing_Pumping_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Sizing_Pumping_Type_OneArgs = {
  object: Sizing_Pumping_Type_Insert_Input;
  on_conflict?: InputMaybe<Sizing_Pumping_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Solution_Gas_Oil_Ratio_OptionsArgs = {
  objects: Array<Solution_Gas_Oil_Ratio_Options_Insert_Input>;
  on_conflict?: InputMaybe<Solution_Gas_Oil_Ratio_Options_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Solution_Gas_Oil_Ratio_Options_OneArgs = {
  object: Solution_Gas_Oil_Ratio_Options_Insert_Input;
  on_conflict?: InputMaybe<Solution_Gas_Oil_Ratio_Options_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Step_Down_TransformersArgs = {
  objects: Array<Step_Down_Transformers_Insert_Input>;
  on_conflict?: InputMaybe<Step_Down_Transformers_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Step_Down_Transformers_OneArgs = {
  object: Step_Down_Transformers_Insert_Input;
  on_conflict?: InputMaybe<Step_Down_Transformers_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Step_Up_TransformersArgs = {
  objects: Array<Step_Up_Transformers_Insert_Input>;
  on_conflict?: InputMaybe<Step_Up_Transformers_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Step_Up_Transformers_OneArgs = {
  object: Step_Up_Transformers_Insert_Input;
  on_conflict?: InputMaybe<Step_Up_Transformers_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_SwitchboardsArgs = {
  objects: Array<Switchboards_Insert_Input>;
  on_conflict?: InputMaybe<Switchboards_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Switchboards_OneArgs = {
  object: Switchboards_Insert_Input;
  on_conflict?: InputMaybe<Switchboards_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tubing_Flow_OptionsArgs = {
  objects: Array<Tubing_Flow_Options_Insert_Input>;
  on_conflict?: InputMaybe<Tubing_Flow_Options_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tubing_Flow_Options_OneArgs = {
  object: Tubing_Flow_Options_Insert_Input;
  on_conflict?: InputMaybe<Tubing_Flow_Options_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_TubingsArgs = {
  objects: Array<Tubings_Insert_Input>;
  on_conflict?: InputMaybe<Tubings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tubings_OneArgs = {
  object: Tubings_Insert_Input;
  on_conflict?: InputMaybe<Tubings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tubings_TypeArgs = {
  objects: Array<Tubings_Type_Insert_Input>;
  on_conflict?: InputMaybe<Tubings_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tubings_Type_OneArgs = {
  object: Tubings_Type_Insert_Input;
  on_conflict?: InputMaybe<Tubings_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Under_Saturated_Oil_OptionsArgs = {
  objects: Array<Under_Saturated_Oil_Options_Insert_Input>;
  on_conflict?: InputMaybe<Under_Saturated_Oil_Options_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Under_Saturated_Oil_Options_OneArgs = {
  object: Under_Saturated_Oil_Options_Insert_Input;
  on_conflict?: InputMaybe<Under_Saturated_Oil_Options_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Eula_AcceptanceArgs = {
  objects: Array<User_Eula_Acceptance_Insert_Input>;
  on_conflict?: InputMaybe<User_Eula_Acceptance_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Eula_Acceptance_OneArgs = {
  object: User_Eula_Acceptance_Insert_Input;
  on_conflict?: InputMaybe<User_Eula_Acceptance_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_UsersArgs = {
  objects: Array<Users_Insert_Input>;
  on_conflict?: InputMaybe<Users_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Users_OneArgs = {
  object: Users_Insert_Input;
  on_conflict?: InputMaybe<Users_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Variable_Speed_DrivesArgs = {
  objects: Array<Variable_Speed_Drives_Insert_Input>;
  on_conflict?: InputMaybe<Variable_Speed_Drives_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Variable_Speed_Drives_OneArgs = {
  object: Variable_Speed_Drives_Insert_Input;
  on_conflict?: InputMaybe<Variable_Speed_Drives_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Water_Density_OptionsArgs = {
  objects: Array<Water_Density_Options_Insert_Input>;
  on_conflict?: InputMaybe<Water_Density_Options_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Water_Density_Options_OneArgs = {
  object: Water_Density_Options_Insert_Input;
  on_conflict?: InputMaybe<Water_Density_Options_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Water_Solution_Gas_OptionsArgs = {
  objects: Array<Water_Solution_Gas_Options_Insert_Input>;
  on_conflict?: InputMaybe<Water_Solution_Gas_Options_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Water_Solution_Gas_Options_OneArgs = {
  object: Water_Solution_Gas_Options_Insert_Input;
  on_conflict?: InputMaybe<Water_Solution_Gas_Options_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Water_Viscosity_OptionsArgs = {
  objects: Array<Water_Viscosity_Options_Insert_Input>;
  on_conflict?: InputMaybe<Water_Viscosity_Options_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Water_Viscosity_Options_OneArgs = {
  object: Water_Viscosity_Options_Insert_Input;
  on_conflict?: InputMaybe<Water_Viscosity_Options_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Water_Volume_Factor_OptionsArgs = {
  objects: Array<Water_Volume_Factor_Options_Insert_Input>;
  on_conflict?: InputMaybe<Water_Volume_Factor_Options_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Water_Volume_Factor_Options_OneArgs = {
  object: Water_Volume_Factor_Options_Insert_Input;
  on_conflict?: InputMaybe<Water_Volume_Factor_Options_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Well_Gas_Type_OptionsArgs = {
  objects: Array<Well_Gas_Type_Options_Insert_Input>;
  on_conflict?: InputMaybe<Well_Gas_Type_Options_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Well_Gas_Type_Options_OneArgs = {
  object: Well_Gas_Type_Options_Insert_Input;
  on_conflict?: InputMaybe<Well_Gas_Type_Options_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Well_Test_Gas_Input_OptionsArgs = {
  objects: Array<Well_Test_Gas_Input_Options_Insert_Input>;
  on_conflict?: InputMaybe<Well_Test_Gas_Input_Options_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Well_Test_Gas_Input_Options_OneArgs = {
  object: Well_Test_Gas_Input_Options_Insert_Input;
  on_conflict?: InputMaybe<Well_Test_Gas_Input_Options_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Well_Test_Liquid_Input_OptionsArgs = {
  objects: Array<Well_Test_Liquid_Input_Options_Insert_Input>;
  on_conflict?: InputMaybe<Well_Test_Liquid_Input_Options_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Well_Test_Liquid_Input_Options_OneArgs = {
  object: Well_Test_Liquid_Input_Options_Insert_Input;
  on_conflict?: InputMaybe<Well_Test_Liquid_Input_Options_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Well_Test_Pressure_Input_OptionsArgs = {
  objects: Array<Well_Test_Pressure_Input_Options_Insert_Input>;
  on_conflict?: InputMaybe<Well_Test_Pressure_Input_Options_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Well_Test_Pressure_Input_Options_OneArgs = {
  object: Well_Test_Pressure_Input_Options_Insert_Input;
  on_conflict?: InputMaybe<Well_Test_Pressure_Input_Options_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_WellsArgs = {
  objects: Array<Wells_Insert_Input>;
  on_conflict?: InputMaybe<Wells_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Wells_OneArgs = {
  object: Wells_Insert_Input;
  on_conflict?: InputMaybe<Wells_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Y_ToolsArgs = {
  objects: Array<Y_Tools_Insert_Input>;
  on_conflict?: InputMaybe<Y_Tools_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Y_Tools_OneArgs = {
  object: Y_Tools_Insert_Input;
  on_conflict?: InputMaybe<Y_Tools_On_Conflict>;
};


/** mutation root */
export type Mutation_RootUpdateSkQuoteJobArgs = {
  input: SkQuoteInput;
  is_s4_user?: InputMaybe<Scalars['Boolean']['input']>;
};


/** mutation root */
export type Mutation_RootUpdate_Bolt_On_DischargesArgs = {
  _inc?: InputMaybe<Bolt_On_Discharges_Inc_Input>;
  _set?: InputMaybe<Bolt_On_Discharges_Set_Input>;
  where: Bolt_On_Discharges_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Bolt_On_Discharges_By_PkArgs = {
  _inc?: InputMaybe<Bolt_On_Discharges_Inc_Input>;
  _set?: InputMaybe<Bolt_On_Discharges_Set_Input>;
  pk_columns: Bolt_On_Discharges_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Bolt_On_Discharges_ManyArgs = {
  updates: Array<Bolt_On_Discharges_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Bubble_Point_OptionsArgs = {
  _set?: InputMaybe<Bubble_Point_Options_Set_Input>;
  where: Bubble_Point_Options_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Bubble_Point_Options_By_PkArgs = {
  _set?: InputMaybe<Bubble_Point_Options_Set_Input>;
  pk_columns: Bubble_Point_Options_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Bubble_Point_Options_ManyArgs = {
  updates: Array<Bubble_Point_Options_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_CablesArgs = {
  _inc?: InputMaybe<Cables_Inc_Input>;
  _set?: InputMaybe<Cables_Set_Input>;
  where: Cables_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Cables_By_PkArgs = {
  _inc?: InputMaybe<Cables_Inc_Input>;
  _set?: InputMaybe<Cables_Set_Input>;
  pk_columns: Cables_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Cables_ManyArgs = {
  updates: Array<Cables_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Casing_Flow_OptionsArgs = {
  _set?: InputMaybe<Casing_Flow_Options_Set_Input>;
  where: Casing_Flow_Options_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Casing_Flow_Options_By_PkArgs = {
  _set?: InputMaybe<Casing_Flow_Options_Set_Input>;
  pk_columns: Casing_Flow_Options_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Casing_Flow_Options_ManyArgs = {
  updates: Array<Casing_Flow_Options_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_CasingsArgs = {
  _inc?: InputMaybe<Casings_Inc_Input>;
  _set?: InputMaybe<Casings_Set_Input>;
  where: Casings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Casings_By_PkArgs = {
  _inc?: InputMaybe<Casings_Inc_Input>;
  _set?: InputMaybe<Casings_Set_Input>;
  pk_columns: Casings_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Casings_ManyArgs = {
  updates: Array<Casings_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Casings_TypeArgs = {
  _set?: InputMaybe<Casings_Type_Set_Input>;
  where: Casings_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Casings_Type_By_PkArgs = {
  _set?: InputMaybe<Casings_Type_Set_Input>;
  pk_columns: Casings_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Casings_Type_ManyArgs = {
  updates: Array<Casings_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_CustomersArgs = {
  _inc?: InputMaybe<Customers_Inc_Input>;
  _set?: InputMaybe<Customers_Set_Input>;
  where: Customers_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Customers_By_PkArgs = {
  _inc?: InputMaybe<Customers_Inc_Input>;
  _set?: InputMaybe<Customers_Set_Input>;
  pk_columns: Customers_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Customers_ManyArgs = {
  updates: Array<Customers_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Dead_Oil_OptionsArgs = {
  _set?: InputMaybe<Dead_Oil_Options_Set_Input>;
  where: Dead_Oil_Options_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Dead_Oil_Options_By_PkArgs = {
  _set?: InputMaybe<Dead_Oil_Options_Set_Input>;
  pk_columns: Dead_Oil_Options_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Dead_Oil_Options_ManyArgs = {
  updates: Array<Dead_Oil_Options_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Deviation_SurveyArgs = {
  _inc?: InputMaybe<Deviation_Survey_Inc_Input>;
  _set?: InputMaybe<Deviation_Survey_Set_Input>;
  where: Deviation_Survey_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Deviation_Survey_By_PkArgs = {
  _inc?: InputMaybe<Deviation_Survey_Inc_Input>;
  _set?: InputMaybe<Deviation_Survey_Set_Input>;
  pk_columns: Deviation_Survey_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Deviation_Survey_Directional_DatasetArgs = {
  _set?: InputMaybe<Deviation_Survey_Directional_Dataset_Set_Input>;
  where: Deviation_Survey_Directional_Dataset_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Deviation_Survey_Directional_Dataset_By_PkArgs = {
  _set?: InputMaybe<Deviation_Survey_Directional_Dataset_Set_Input>;
  pk_columns: Deviation_Survey_Directional_Dataset_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Deviation_Survey_Directional_Dataset_ManyArgs = {
  updates: Array<Deviation_Survey_Directional_Dataset_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Deviation_Survey_ManyArgs = {
  updates: Array<Deviation_Survey_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Display_UnitsArgs = {
  _set?: InputMaybe<Display_Units_Set_Input>;
  where: Display_Units_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Display_Units_By_PkArgs = {
  _set?: InputMaybe<Display_Units_Set_Input>;
  pk_columns: Display_Units_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Display_Units_ManyArgs = {
  updates: Array<Display_Units_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_EulaArgs = {
  _set?: InputMaybe<Eula_Set_Input>;
  where: Eula_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Eula_By_PkArgs = {
  _set?: InputMaybe<Eula_Set_Input>;
  pk_columns: Eula_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Eula_ManyArgs = {
  updates: Array<Eula_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Flow_ModelArgs = {
  _set?: InputMaybe<Flow_Model_Set_Input>;
  where: Flow_Model_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Flow_Model_ActiveArgs = {
  _set?: InputMaybe<Flow_Model_Active_Set_Input>;
  where: Flow_Model_Active_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Flow_Model_Active_ManyArgs = {
  updates: Array<Flow_Model_Active_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Flow_Model_By_PkArgs = {
  _set?: InputMaybe<Flow_Model_Set_Input>;
  pk_columns: Flow_Model_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Flow_Model_DeprecatedArgs = {
  _set?: InputMaybe<Flow_Model_Deprecated_Set_Input>;
  where: Flow_Model_Deprecated_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Flow_Model_Deprecated_By_PkArgs = {
  _set?: InputMaybe<Flow_Model_Deprecated_Set_Input>;
  pk_columns: Flow_Model_Deprecated_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Flow_Model_Deprecated_ManyArgs = {
  updates: Array<Flow_Model_Deprecated_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Flow_Model_ManyArgs = {
  updates: Array<Flow_Model_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Friction_Loss_OptionsArgs = {
  _set?: InputMaybe<Friction_Loss_Options_Set_Input>;
  where: Friction_Loss_Options_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Friction_Loss_Options_By_PkArgs = {
  _set?: InputMaybe<Friction_Loss_Options_Set_Input>;
  pk_columns: Friction_Loss_Options_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Friction_Loss_Options_ManyArgs = {
  updates: Array<Friction_Loss_Options_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Gas_Compressibility_OptionsArgs = {
  _set?: InputMaybe<Gas_Compressibility_Options_Set_Input>;
  where: Gas_Compressibility_Options_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Gas_Compressibility_Options_By_PkArgs = {
  _set?: InputMaybe<Gas_Compressibility_Options_Set_Input>;
  pk_columns: Gas_Compressibility_Options_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Gas_Compressibility_Options_ManyArgs = {
  updates: Array<Gas_Compressibility_Options_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Gas_Viscosity_OptionsArgs = {
  _set?: InputMaybe<Gas_Viscosity_Options_Set_Input>;
  where: Gas_Viscosity_Options_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Gas_Viscosity_Options_By_PkArgs = {
  _set?: InputMaybe<Gas_Viscosity_Options_Set_Input>;
  pk_columns: Gas_Viscosity_Options_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Gas_Viscosity_Options_ManyArgs = {
  updates: Array<Gas_Viscosity_Options_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_HousingsArgs = {
  _inc?: InputMaybe<Housings_Inc_Input>;
  _set?: InputMaybe<Housings_Set_Input>;
  where: Housings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Housings_By_PkArgs = {
  _inc?: InputMaybe<Housings_Inc_Input>;
  _set?: InputMaybe<Housings_Set_Input>;
  pk_columns: Housings_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Housings_ManyArgs = {
  updates: Array<Housings_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Hps_Liquid_TypeArgs = {
  _set?: InputMaybe<Hps_Liquid_Type_Set_Input>;
  where: Hps_Liquid_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Hps_Liquid_Type_By_PkArgs = {
  _set?: InputMaybe<Hps_Liquid_Type_Set_Input>;
  pk_columns: Hps_Liquid_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Hps_Liquid_Type_ManyArgs = {
  updates: Array<Hps_Liquid_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_IntakesArgs = {
  _inc?: InputMaybe<Intakes_Inc_Input>;
  _set?: InputMaybe<Intakes_Set_Input>;
  where: Intakes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Intakes_By_PkArgs = {
  _inc?: InputMaybe<Intakes_Inc_Input>;
  _set?: InputMaybe<Intakes_Set_Input>;
  pk_columns: Intakes_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Intakes_ManyArgs = {
  updates: Array<Intakes_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Legacy_UsersArgs = {
  _set?: InputMaybe<Legacy_Users_Set_Input>;
  where: Legacy_Users_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Legacy_Users_By_PkArgs = {
  _set?: InputMaybe<Legacy_Users_Set_Input>;
  pk_columns: Legacy_Users_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Legacy_Users_ManyArgs = {
  updates: Array<Legacy_Users_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Motor_Lead_ExtensionsArgs = {
  _inc?: InputMaybe<Motor_Lead_Extensions_Inc_Input>;
  _set?: InputMaybe<Motor_Lead_Extensions_Set_Input>;
  where: Motor_Lead_Extensions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Motor_Lead_Extensions_By_PkArgs = {
  _inc?: InputMaybe<Motor_Lead_Extensions_Inc_Input>;
  _set?: InputMaybe<Motor_Lead_Extensions_Set_Input>;
  pk_columns: Motor_Lead_Extensions_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Motor_Lead_Extensions_ManyArgs = {
  updates: Array<Motor_Lead_Extensions_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_MotorsArgs = {
  _inc?: InputMaybe<Motors_Inc_Input>;
  _set?: InputMaybe<Motors_Set_Input>;
  where: Motors_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Motors_By_PkArgs = {
  _inc?: InputMaybe<Motors_Inc_Input>;
  _set?: InputMaybe<Motors_Set_Input>;
  pk_columns: Motors_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Motors_ManyArgs = {
  updates: Array<Motors_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Natural_Gas_Separation_OptionsArgs = {
  _set?: InputMaybe<Natural_Gas_Separation_Options_Set_Input>;
  where: Natural_Gas_Separation_Options_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Natural_Gas_Separation_Options_By_PkArgs = {
  _set?: InputMaybe<Natural_Gas_Separation_Options_Set_Input>;
  pk_columns: Natural_Gas_Separation_Options_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Natural_Gas_Separation_Options_ManyArgs = {
  updates: Array<Natural_Gas_Separation_Options_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Oil_Density_OptionsArgs = {
  _set?: InputMaybe<Oil_Density_Options_Set_Input>;
  where: Oil_Density_Options_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Oil_Density_Options_By_PkArgs = {
  _set?: InputMaybe<Oil_Density_Options_Set_Input>;
  pk_columns: Oil_Density_Options_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Oil_Density_Options_ManyArgs = {
  updates: Array<Oil_Density_Options_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Oil_Volume_Factor_OptionsArgs = {
  _set?: InputMaybe<Oil_Volume_Factor_Options_Set_Input>;
  where: Oil_Volume_Factor_Options_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Oil_Volume_Factor_Options_By_PkArgs = {
  _set?: InputMaybe<Oil_Volume_Factor_Options_Set_Input>;
  pk_columns: Oil_Volume_Factor_Options_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Oil_Volume_Factor_Options_ManyArgs = {
  updates: Array<Oil_Volume_Factor_Options_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Override_OptionsArgs = {
  _set?: InputMaybe<Override_Options_Set_Input>;
  where: Override_Options_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Override_Options_By_PkArgs = {
  _set?: InputMaybe<Override_Options_Set_Input>;
  pk_columns: Override_Options_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Override_Options_ManyArgs = {
  updates: Array<Override_Options_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_PumpsArgs = {
  _inc?: InputMaybe<Pumps_Inc_Input>;
  _set?: InputMaybe<Pumps_Set_Input>;
  where: Pumps_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Pumps_By_PkArgs = {
  _inc?: InputMaybe<Pumps_Inc_Input>;
  _set?: InputMaybe<Pumps_Set_Input>;
  pk_columns: Pumps_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Pumps_ManyArgs = {
  updates: Array<Pumps_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Quote_Line_Item_Category_DatasetArgs = {
  _set?: InputMaybe<Quote_Line_Item_Category_Dataset_Set_Input>;
  where: Quote_Line_Item_Category_Dataset_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Quote_Line_Item_Category_Dataset_By_PkArgs = {
  _set?: InputMaybe<Quote_Line_Item_Category_Dataset_Set_Input>;
  pk_columns: Quote_Line_Item_Category_Dataset_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Quote_Line_Item_Category_Dataset_ManyArgs = {
  updates: Array<Quote_Line_Item_Category_Dataset_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Quote_Line_Item_Serialized_DatasetArgs = {
  _set?: InputMaybe<Quote_Line_Item_Serialized_Dataset_Set_Input>;
  where: Quote_Line_Item_Serialized_Dataset_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Quote_Line_Item_Serialized_Dataset_By_PkArgs = {
  _set?: InputMaybe<Quote_Line_Item_Serialized_Dataset_Set_Input>;
  pk_columns: Quote_Line_Item_Serialized_Dataset_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Quote_Line_Item_Serialized_Dataset_ManyArgs = {
  updates: Array<Quote_Line_Item_Serialized_Dataset_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Quote_Line_Item_Source_DatasetArgs = {
  _set?: InputMaybe<Quote_Line_Item_Source_Dataset_Set_Input>;
  where: Quote_Line_Item_Source_Dataset_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Quote_Line_Item_Source_Dataset_By_PkArgs = {
  _set?: InputMaybe<Quote_Line_Item_Source_Dataset_Set_Input>;
  pk_columns: Quote_Line_Item_Source_Dataset_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Quote_Line_Item_Source_Dataset_ManyArgs = {
  updates: Array<Quote_Line_Item_Source_Dataset_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Quote_Line_Item_Subcategory_DatasetArgs = {
  _set?: InputMaybe<Quote_Line_Item_Subcategory_Dataset_Set_Input>;
  where: Quote_Line_Item_Subcategory_Dataset_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Quote_Line_Item_Subcategory_Dataset_By_PkArgs = {
  _set?: InputMaybe<Quote_Line_Item_Subcategory_Dataset_Set_Input>;
  pk_columns: Quote_Line_Item_Subcategory_Dataset_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Quote_Line_Item_Subcategory_Dataset_ManyArgs = {
  updates: Array<Quote_Line_Item_Subcategory_Dataset_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Quote_Line_Item_Tax_Type_DatasetArgs = {
  _set?: InputMaybe<Quote_Line_Item_Tax_Type_Dataset_Set_Input>;
  where: Quote_Line_Item_Tax_Type_Dataset_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Quote_Line_Item_Tax_Type_Dataset_By_PkArgs = {
  _set?: InputMaybe<Quote_Line_Item_Tax_Type_Dataset_Set_Input>;
  pk_columns: Quote_Line_Item_Tax_Type_Dataset_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Quote_Line_Item_Tax_Type_Dataset_ManyArgs = {
  updates: Array<Quote_Line_Item_Tax_Type_Dataset_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Quote_Line_Item_Type_DatasetArgs = {
  _set?: InputMaybe<Quote_Line_Item_Type_Dataset_Set_Input>;
  where: Quote_Line_Item_Type_Dataset_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Quote_Line_Item_Type_Dataset_By_PkArgs = {
  _set?: InputMaybe<Quote_Line_Item_Type_Dataset_Set_Input>;
  pk_columns: Quote_Line_Item_Type_Dataset_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Quote_Line_Item_Type_Dataset_ManyArgs = {
  updates: Array<Quote_Line_Item_Type_Dataset_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Quote_Line_ItemsArgs = {
  _append?: InputMaybe<Quote_Line_Items_Append_Input>;
  _delete_at_path?: InputMaybe<Quote_Line_Items_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Quote_Line_Items_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Quote_Line_Items_Delete_Key_Input>;
  _inc?: InputMaybe<Quote_Line_Items_Inc_Input>;
  _prepend?: InputMaybe<Quote_Line_Items_Prepend_Input>;
  _set?: InputMaybe<Quote_Line_Items_Set_Input>;
  where: Quote_Line_Items_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Quote_Line_Items_By_PkArgs = {
  _append?: InputMaybe<Quote_Line_Items_Append_Input>;
  _delete_at_path?: InputMaybe<Quote_Line_Items_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Quote_Line_Items_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Quote_Line_Items_Delete_Key_Input>;
  _inc?: InputMaybe<Quote_Line_Items_Inc_Input>;
  _prepend?: InputMaybe<Quote_Line_Items_Prepend_Input>;
  _set?: InputMaybe<Quote_Line_Items_Set_Input>;
  pk_columns: Quote_Line_Items_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Quote_Line_Items_ManyArgs = {
  updates: Array<Quote_Line_Items_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Quote_Sk_Job_Type_DatasetArgs = {
  _set?: InputMaybe<Quote_Sk_Job_Type_Dataset_Set_Input>;
  where: Quote_Sk_Job_Type_Dataset_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Quote_Sk_Job_Type_Dataset_By_PkArgs = {
  _set?: InputMaybe<Quote_Sk_Job_Type_Dataset_Set_Input>;
  pk_columns: Quote_Sk_Job_Type_Dataset_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Quote_Sk_Job_Type_Dataset_ManyArgs = {
  updates: Array<Quote_Sk_Job_Type_Dataset_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Quote_Source_DatasetArgs = {
  _set?: InputMaybe<Quote_Source_Dataset_Set_Input>;
  where: Quote_Source_Dataset_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Quote_Source_Dataset_By_PkArgs = {
  _set?: InputMaybe<Quote_Source_Dataset_Set_Input>;
  pk_columns: Quote_Source_Dataset_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Quote_Source_Dataset_ManyArgs = {
  updates: Array<Quote_Source_Dataset_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Quote_Status_DatasetArgs = {
  _set?: InputMaybe<Quote_Status_Dataset_Set_Input>;
  where: Quote_Status_Dataset_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Quote_Status_Dataset_By_PkArgs = {
  _set?: InputMaybe<Quote_Status_Dataset_Set_Input>;
  pk_columns: Quote_Status_Dataset_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Quote_Status_Dataset_ManyArgs = {
  updates: Array<Quote_Status_Dataset_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Quote_User_MessagesArgs = {
  _set?: InputMaybe<Quote_User_Messages_Set_Input>;
  where: Quote_User_Messages_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Quote_User_Messages_By_PkArgs = {
  _set?: InputMaybe<Quote_User_Messages_Set_Input>;
  pk_columns: Quote_User_Messages_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Quote_User_Messages_ManyArgs = {
  updates: Array<Quote_User_Messages_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_QuotesArgs = {
  _append?: InputMaybe<Quotes_Append_Input>;
  _delete_at_path?: InputMaybe<Quotes_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Quotes_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Quotes_Delete_Key_Input>;
  _inc?: InputMaybe<Quotes_Inc_Input>;
  _prepend?: InputMaybe<Quotes_Prepend_Input>;
  _set?: InputMaybe<Quotes_Set_Input>;
  where: Quotes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Quotes_By_PkArgs = {
  _append?: InputMaybe<Quotes_Append_Input>;
  _delete_at_path?: InputMaybe<Quotes_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Quotes_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Quotes_Delete_Key_Input>;
  _inc?: InputMaybe<Quotes_Inc_Input>;
  _prepend?: InputMaybe<Quotes_Prepend_Input>;
  _set?: InputMaybe<Quotes_Set_Input>;
  pk_columns: Quotes_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Quotes_ManyArgs = {
  updates: Array<Quotes_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Revisions_Performance_Evaluations_JournalArgs = {
  _set?: InputMaybe<Revisions_Performance_Evaluations_Journal_Set_Input>;
  where: Revisions_Performance_Evaluations_Journal_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Revisions_Performance_Evaluations_Journal_By_PkArgs = {
  _set?: InputMaybe<Revisions_Performance_Evaluations_Journal_Set_Input>;
  pk_columns: Revisions_Performance_Evaluations_Journal_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Revisions_Performance_Evaluations_Journal_ManyArgs = {
  updates: Array<Revisions_Performance_Evaluations_Journal_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Revisions_Performance_Evaluations_RevisionsArgs = {
  _inc?: InputMaybe<Revisions_Performance_Evaluations_Revisions_Inc_Input>;
  _set?: InputMaybe<Revisions_Performance_Evaluations_Revisions_Set_Input>;
  where: Revisions_Performance_Evaluations_Revisions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Revisions_Performance_Evaluations_Revisions_By_PkArgs = {
  _inc?: InputMaybe<Revisions_Performance_Evaluations_Revisions_Inc_Input>;
  _set?: InputMaybe<Revisions_Performance_Evaluations_Revisions_Set_Input>;
  pk_columns: Revisions_Performance_Evaluations_Revisions_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Revisions_Performance_Evaluations_Revisions_ManyArgs = {
  updates: Array<Revisions_Performance_Evaluations_Revisions_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Revisions_Performance_Evaluations_Xref_Pumps_JournalArgs = {
  _set?: InputMaybe<Revisions_Performance_Evaluations_Xref_Pumps_Journal_Set_Input>;
  where: Revisions_Performance_Evaluations_Xref_Pumps_Journal_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Revisions_Performance_Evaluations_Xref_Pumps_Journal_By_PkArgs = {
  _set?: InputMaybe<Revisions_Performance_Evaluations_Xref_Pumps_Journal_Set_Input>;
  pk_columns: Revisions_Performance_Evaluations_Xref_Pumps_Journal_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Revisions_Performance_Evaluations_Xref_Pumps_Journal_ManyArgs = {
  updates: Array<Revisions_Performance_Evaluations_Xref_Pumps_Journal_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Revisions_Performance_Evaluations_Xref_Pumps_RevisionsArgs = {
  _inc?: InputMaybe<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Inc_Input>;
  _set?: InputMaybe<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Set_Input>;
  where: Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Revisions_Performance_Evaluations_Xref_Pumps_Revisions_By_PkArgs = {
  _inc?: InputMaybe<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Inc_Input>;
  _set?: InputMaybe<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Set_Input>;
  pk_columns: Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Revisions_Performance_Evaluations_Xref_Pumps_Revisions_ManyArgs = {
  updates: Array<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_JournalArgs = {
  _set?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_Set_Input>;
  where: Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_By_PkArgs = {
  _set?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_Set_Input>;
  pk_columns: Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_ManyArgs = {
  updates: Array<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_RevisionsArgs = {
  _inc?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Inc_Input>;
  _set?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Set_Input>;
  where: Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_By_PkArgs = {
  _inc?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Inc_Input>;
  _set?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Set_Input>;
  pk_columns: Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_ManyArgs = {
  updates: Array<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_JournalArgs = {
  _set?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_Set_Input>;
  where: Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_By_PkArgs = {
  _set?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_Set_Input>;
  pk_columns: Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_ManyArgs = {
  updates: Array<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_RevisionsArgs = {
  _inc?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Inc_Input>;
  _set?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Set_Input>;
  where: Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_By_PkArgs = {
  _inc?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Inc_Input>;
  _set?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Set_Input>;
  pk_columns: Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_ManyArgs = {
  updates: Array<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_JournalArgs = {
  _set?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_Set_Input>;
  where: Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_By_PkArgs = {
  _set?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_Set_Input>;
  pk_columns: Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_ManyArgs = {
  updates: Array<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_RevisionsArgs = {
  _inc?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Inc_Input>;
  _set?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Set_Input>;
  where: Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_By_PkArgs = {
  _inc?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Inc_Input>;
  _set?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Set_Input>;
  pk_columns: Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_ManyArgs = {
  updates: Array<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_JournalArgs = {
  _set?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_Set_Input>;
  where: Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_By_PkArgs = {
  _set?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_Set_Input>;
  pk_columns: Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_ManyArgs = {
  updates: Array<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_RevisionsArgs = {
  _inc?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Inc_Input>;
  _set?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Set_Input>;
  where: Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_By_PkArgs = {
  _inc?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Inc_Input>;
  _set?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Set_Input>;
  pk_columns: Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_ManyArgs = {
  updates: Array<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Revisions_Scenario_Correlations_JournalArgs = {
  _set?: InputMaybe<Revisions_Scenario_Correlations_Journal_Set_Input>;
  where: Revisions_Scenario_Correlations_Journal_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Revisions_Scenario_Correlations_Journal_By_PkArgs = {
  _set?: InputMaybe<Revisions_Scenario_Correlations_Journal_Set_Input>;
  pk_columns: Revisions_Scenario_Correlations_Journal_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Revisions_Scenario_Correlations_Journal_ManyArgs = {
  updates: Array<Revisions_Scenario_Correlations_Journal_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Revisions_Scenario_Correlations_RevisionsArgs = {
  _inc?: InputMaybe<Revisions_Scenario_Correlations_Revisions_Inc_Input>;
  _set?: InputMaybe<Revisions_Scenario_Correlations_Revisions_Set_Input>;
  where: Revisions_Scenario_Correlations_Revisions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Revisions_Scenario_Correlations_Revisions_By_PkArgs = {
  _inc?: InputMaybe<Revisions_Scenario_Correlations_Revisions_Inc_Input>;
  _set?: InputMaybe<Revisions_Scenario_Correlations_Revisions_Set_Input>;
  pk_columns: Revisions_Scenario_Correlations_Revisions_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Revisions_Scenario_Correlations_Revisions_ManyArgs = {
  updates: Array<Revisions_Scenario_Correlations_Revisions_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Revisions_Scenario_Equipment_JournalArgs = {
  _set?: InputMaybe<Revisions_Scenario_Equipment_Journal_Set_Input>;
  where: Revisions_Scenario_Equipment_Journal_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Revisions_Scenario_Equipment_Journal_By_PkArgs = {
  _set?: InputMaybe<Revisions_Scenario_Equipment_Journal_Set_Input>;
  pk_columns: Revisions_Scenario_Equipment_Journal_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Revisions_Scenario_Equipment_Journal_ManyArgs = {
  updates: Array<Revisions_Scenario_Equipment_Journal_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Revisions_Scenario_Equipment_RevisionsArgs = {
  _set?: InputMaybe<Revisions_Scenario_Equipment_Revisions_Set_Input>;
  where: Revisions_Scenario_Equipment_Revisions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Revisions_Scenario_Equipment_Revisions_By_PkArgs = {
  _set?: InputMaybe<Revisions_Scenario_Equipment_Revisions_Set_Input>;
  pk_columns: Revisions_Scenario_Equipment_Revisions_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Revisions_Scenario_Equipment_Revisions_ManyArgs = {
  updates: Array<Revisions_Scenario_Equipment_Revisions_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Revisions_Scenario_Equipment_Xref_Cables_JournalArgs = {
  _set?: InputMaybe<Revisions_Scenario_Equipment_Xref_Cables_Journal_Set_Input>;
  where: Revisions_Scenario_Equipment_Xref_Cables_Journal_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Revisions_Scenario_Equipment_Xref_Cables_Journal_By_PkArgs = {
  _set?: InputMaybe<Revisions_Scenario_Equipment_Xref_Cables_Journal_Set_Input>;
  pk_columns: Revisions_Scenario_Equipment_Xref_Cables_Journal_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Revisions_Scenario_Equipment_Xref_Cables_Journal_ManyArgs = {
  updates: Array<Revisions_Scenario_Equipment_Xref_Cables_Journal_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Revisions_Scenario_Equipment_Xref_Cables_RevisionsArgs = {
  _inc?: InputMaybe<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Inc_Input>;
  _set?: InputMaybe<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Set_Input>;
  where: Revisions_Scenario_Equipment_Xref_Cables_Revisions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Revisions_Scenario_Equipment_Xref_Cables_Revisions_By_PkArgs = {
  _inc?: InputMaybe<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Inc_Input>;
  _set?: InputMaybe<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Set_Input>;
  pk_columns: Revisions_Scenario_Equipment_Xref_Cables_Revisions_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Revisions_Scenario_Equipment_Xref_Cables_Revisions_ManyArgs = {
  updates: Array<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Revisions_Scenario_Equipment_Xref_Housings_JournalArgs = {
  _set?: InputMaybe<Revisions_Scenario_Equipment_Xref_Housings_Journal_Set_Input>;
  where: Revisions_Scenario_Equipment_Xref_Housings_Journal_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Revisions_Scenario_Equipment_Xref_Housings_Journal_By_PkArgs = {
  _set?: InputMaybe<Revisions_Scenario_Equipment_Xref_Housings_Journal_Set_Input>;
  pk_columns: Revisions_Scenario_Equipment_Xref_Housings_Journal_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Revisions_Scenario_Equipment_Xref_Housings_Journal_ManyArgs = {
  updates: Array<Revisions_Scenario_Equipment_Xref_Housings_Journal_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Revisions_Scenario_Equipment_Xref_Housings_RevisionsArgs = {
  _inc?: InputMaybe<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Inc_Input>;
  _set?: InputMaybe<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Set_Input>;
  where: Revisions_Scenario_Equipment_Xref_Housings_Revisions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Revisions_Scenario_Equipment_Xref_Housings_Revisions_By_PkArgs = {
  _inc?: InputMaybe<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Inc_Input>;
  _set?: InputMaybe<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Set_Input>;
  pk_columns: Revisions_Scenario_Equipment_Xref_Housings_Revisions_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Revisions_Scenario_Equipment_Xref_Housings_Revisions_ManyArgs = {
  updates: Array<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Revisions_Scenario_Equipment_Xref_Intakes_JournalArgs = {
  _set?: InputMaybe<Revisions_Scenario_Equipment_Xref_Intakes_Journal_Set_Input>;
  where: Revisions_Scenario_Equipment_Xref_Intakes_Journal_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Revisions_Scenario_Equipment_Xref_Intakes_Journal_By_PkArgs = {
  _set?: InputMaybe<Revisions_Scenario_Equipment_Xref_Intakes_Journal_Set_Input>;
  pk_columns: Revisions_Scenario_Equipment_Xref_Intakes_Journal_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Revisions_Scenario_Equipment_Xref_Intakes_Journal_ManyArgs = {
  updates: Array<Revisions_Scenario_Equipment_Xref_Intakes_Journal_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Revisions_Scenario_Equipment_Xref_Intakes_RevisionsArgs = {
  _set?: InputMaybe<Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Set_Input>;
  where: Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Revisions_Scenario_Equipment_Xref_Intakes_Revisions_By_PkArgs = {
  _set?: InputMaybe<Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Set_Input>;
  pk_columns: Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Revisions_Scenario_Equipment_Xref_Intakes_Revisions_ManyArgs = {
  updates: Array<Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Revisions_Scenario_Equipment_Xref_Pumps_JournalArgs = {
  _set?: InputMaybe<Revisions_Scenario_Equipment_Xref_Pumps_Journal_Set_Input>;
  where: Revisions_Scenario_Equipment_Xref_Pumps_Journal_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Revisions_Scenario_Equipment_Xref_Pumps_Journal_By_PkArgs = {
  _set?: InputMaybe<Revisions_Scenario_Equipment_Xref_Pumps_Journal_Set_Input>;
  pk_columns: Revisions_Scenario_Equipment_Xref_Pumps_Journal_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Revisions_Scenario_Equipment_Xref_Pumps_Journal_ManyArgs = {
  updates: Array<Revisions_Scenario_Equipment_Xref_Pumps_Journal_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Revisions_Scenario_Equipment_Xref_Pumps_RevisionsArgs = {
  _inc?: InputMaybe<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Inc_Input>;
  _set?: InputMaybe<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Set_Input>;
  where: Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Revisions_Scenario_Equipment_Xref_Pumps_Revisions_By_PkArgs = {
  _inc?: InputMaybe<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Inc_Input>;
  _set?: InputMaybe<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Set_Input>;
  pk_columns: Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Revisions_Scenario_Equipment_Xref_Pumps_Revisions_ManyArgs = {
  updates: Array<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Revisions_Scenario_Equipment_Xref_Seals_JournalArgs = {
  _set?: InputMaybe<Revisions_Scenario_Equipment_Xref_Seals_Journal_Set_Input>;
  where: Revisions_Scenario_Equipment_Xref_Seals_Journal_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Revisions_Scenario_Equipment_Xref_Seals_Journal_By_PkArgs = {
  _set?: InputMaybe<Revisions_Scenario_Equipment_Xref_Seals_Journal_Set_Input>;
  pk_columns: Revisions_Scenario_Equipment_Xref_Seals_Journal_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Revisions_Scenario_Equipment_Xref_Seals_Journal_ManyArgs = {
  updates: Array<Revisions_Scenario_Equipment_Xref_Seals_Journal_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Revisions_Scenario_Equipment_Xref_Seals_RevisionsArgs = {
  _set?: InputMaybe<Revisions_Scenario_Equipment_Xref_Seals_Revisions_Set_Input>;
  where: Revisions_Scenario_Equipment_Xref_Seals_Revisions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Revisions_Scenario_Equipment_Xref_Seals_Revisions_By_PkArgs = {
  _set?: InputMaybe<Revisions_Scenario_Equipment_Xref_Seals_Revisions_Set_Input>;
  pk_columns: Revisions_Scenario_Equipment_Xref_Seals_Revisions_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Revisions_Scenario_Equipment_Xref_Seals_Revisions_ManyArgs = {
  updates: Array<Revisions_Scenario_Equipment_Xref_Seals_Revisions_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Revisions_Scenario_Parameters_JournalArgs = {
  _set?: InputMaybe<Revisions_Scenario_Parameters_Journal_Set_Input>;
  where: Revisions_Scenario_Parameters_Journal_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Revisions_Scenario_Parameters_Journal_By_PkArgs = {
  _set?: InputMaybe<Revisions_Scenario_Parameters_Journal_Set_Input>;
  pk_columns: Revisions_Scenario_Parameters_Journal_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Revisions_Scenario_Parameters_Journal_ManyArgs = {
  updates: Array<Revisions_Scenario_Parameters_Journal_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Revisions_Scenario_Parameters_RevisionsArgs = {
  _inc?: InputMaybe<Revisions_Scenario_Parameters_Revisions_Inc_Input>;
  _set?: InputMaybe<Revisions_Scenario_Parameters_Revisions_Set_Input>;
  where: Revisions_Scenario_Parameters_Revisions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Revisions_Scenario_Parameters_Revisions_By_PkArgs = {
  _inc?: InputMaybe<Revisions_Scenario_Parameters_Revisions_Inc_Input>;
  _set?: InputMaybe<Revisions_Scenario_Parameters_Revisions_Set_Input>;
  pk_columns: Revisions_Scenario_Parameters_Revisions_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Revisions_Scenario_Parameters_Revisions_ManyArgs = {
  updates: Array<Revisions_Scenario_Parameters_Revisions_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Revisions_Scenario_Well_Properties_JournalArgs = {
  _set?: InputMaybe<Revisions_Scenario_Well_Properties_Journal_Set_Input>;
  where: Revisions_Scenario_Well_Properties_Journal_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Revisions_Scenario_Well_Properties_Journal_By_PkArgs = {
  _set?: InputMaybe<Revisions_Scenario_Well_Properties_Journal_Set_Input>;
  pk_columns: Revisions_Scenario_Well_Properties_Journal_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Revisions_Scenario_Well_Properties_Journal_ManyArgs = {
  updates: Array<Revisions_Scenario_Well_Properties_Journal_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Revisions_Scenario_Well_Properties_RevisionsArgs = {
  _append?: InputMaybe<Revisions_Scenario_Well_Properties_Revisions_Append_Input>;
  _delete_at_path?: InputMaybe<Revisions_Scenario_Well_Properties_Revisions_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Revisions_Scenario_Well_Properties_Revisions_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Revisions_Scenario_Well_Properties_Revisions_Delete_Key_Input>;
  _inc?: InputMaybe<Revisions_Scenario_Well_Properties_Revisions_Inc_Input>;
  _prepend?: InputMaybe<Revisions_Scenario_Well_Properties_Revisions_Prepend_Input>;
  _set?: InputMaybe<Revisions_Scenario_Well_Properties_Revisions_Set_Input>;
  where: Revisions_Scenario_Well_Properties_Revisions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Revisions_Scenario_Well_Properties_Revisions_By_PkArgs = {
  _append?: InputMaybe<Revisions_Scenario_Well_Properties_Revisions_Append_Input>;
  _delete_at_path?: InputMaybe<Revisions_Scenario_Well_Properties_Revisions_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Revisions_Scenario_Well_Properties_Revisions_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Revisions_Scenario_Well_Properties_Revisions_Delete_Key_Input>;
  _inc?: InputMaybe<Revisions_Scenario_Well_Properties_Revisions_Inc_Input>;
  _prepend?: InputMaybe<Revisions_Scenario_Well_Properties_Revisions_Prepend_Input>;
  _set?: InputMaybe<Revisions_Scenario_Well_Properties_Revisions_Set_Input>;
  pk_columns: Revisions_Scenario_Well_Properties_Revisions_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Revisions_Scenario_Well_Properties_Revisions_ManyArgs = {
  updates: Array<Revisions_Scenario_Well_Properties_Revisions_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Revisions_Scenarios_JournalArgs = {
  _set?: InputMaybe<Revisions_Scenarios_Journal_Set_Input>;
  where: Revisions_Scenarios_Journal_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Revisions_Scenarios_Journal_By_PkArgs = {
  _set?: InputMaybe<Revisions_Scenarios_Journal_Set_Input>;
  pk_columns: Revisions_Scenarios_Journal_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Revisions_Scenarios_Journal_ManyArgs = {
  updates: Array<Revisions_Scenarios_Journal_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Revisions_Scenarios_RevisionsArgs = {
  _append?: InputMaybe<Revisions_Scenarios_Revisions_Append_Input>;
  _delete_at_path?: InputMaybe<Revisions_Scenarios_Revisions_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Revisions_Scenarios_Revisions_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Revisions_Scenarios_Revisions_Delete_Key_Input>;
  _prepend?: InputMaybe<Revisions_Scenarios_Revisions_Prepend_Input>;
  _set?: InputMaybe<Revisions_Scenarios_Revisions_Set_Input>;
  where: Revisions_Scenarios_Revisions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Revisions_Scenarios_Revisions_By_PkArgs = {
  _append?: InputMaybe<Revisions_Scenarios_Revisions_Append_Input>;
  _delete_at_path?: InputMaybe<Revisions_Scenarios_Revisions_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Revisions_Scenarios_Revisions_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Revisions_Scenarios_Revisions_Delete_Key_Input>;
  _prepend?: InputMaybe<Revisions_Scenarios_Revisions_Prepend_Input>;
  _set?: InputMaybe<Revisions_Scenarios_Revisions_Set_Input>;
  pk_columns: Revisions_Scenarios_Revisions_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Revisions_Scenarios_Revisions_ManyArgs = {
  updates: Array<Revisions_Scenarios_Revisions_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Revisions_Sizings_JournalArgs = {
  _set?: InputMaybe<Revisions_Sizings_Journal_Set_Input>;
  where: Revisions_Sizings_Journal_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Revisions_Sizings_Journal_By_PkArgs = {
  _set?: InputMaybe<Revisions_Sizings_Journal_Set_Input>;
  pk_columns: Revisions_Sizings_Journal_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Revisions_Sizings_Journal_ManyArgs = {
  updates: Array<Revisions_Sizings_Journal_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Revisions_Sizings_RevisionsArgs = {
  _inc?: InputMaybe<Revisions_Sizings_Revisions_Inc_Input>;
  _set?: InputMaybe<Revisions_Sizings_Revisions_Set_Input>;
  where: Revisions_Sizings_Revisions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Revisions_Sizings_Revisions_By_PkArgs = {
  _inc?: InputMaybe<Revisions_Sizings_Revisions_Inc_Input>;
  _set?: InputMaybe<Revisions_Sizings_Revisions_Set_Input>;
  pk_columns: Revisions_Sizings_Revisions_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Revisions_Sizings_Revisions_ManyArgs = {
  updates: Array<Revisions_Sizings_Revisions_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Saturated_Oil_OptionsArgs = {
  _set?: InputMaybe<Saturated_Oil_Options_Set_Input>;
  where: Saturated_Oil_Options_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Saturated_Oil_Options_By_PkArgs = {
  _set?: InputMaybe<Saturated_Oil_Options_Set_Input>;
  pk_columns: Saturated_Oil_Options_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Saturated_Oil_Options_ManyArgs = {
  updates: Array<Saturated_Oil_Options_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Scenario_ReasonsArgs = {
  _set?: InputMaybe<Scenario_Reasons_Set_Input>;
  where: Scenario_Reasons_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Scenario_Reasons_By_PkArgs = {
  _set?: InputMaybe<Scenario_Reasons_Set_Input>;
  pk_columns: Scenario_Reasons_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Scenario_Reasons_ManyArgs = {
  updates: Array<Scenario_Reasons_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Seal_Motor_OilArgs = {
  _inc?: InputMaybe<Seal_Motor_Oil_Inc_Input>;
  _set?: InputMaybe<Seal_Motor_Oil_Set_Input>;
  where: Seal_Motor_Oil_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Seal_Motor_Oil_By_PkArgs = {
  _inc?: InputMaybe<Seal_Motor_Oil_Inc_Input>;
  _set?: InputMaybe<Seal_Motor_Oil_Set_Input>;
  pk_columns: Seal_Motor_Oil_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Seal_Motor_Oil_ManyArgs = {
  updates: Array<Seal_Motor_Oil_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_SealsArgs = {
  _inc?: InputMaybe<Seals_Inc_Input>;
  _set?: InputMaybe<Seals_Set_Input>;
  where: Seals_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Seals_By_PkArgs = {
  _inc?: InputMaybe<Seals_Inc_Input>;
  _set?: InputMaybe<Seals_Set_Input>;
  pk_columns: Seals_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Seals_ManyArgs = {
  updates: Array<Seals_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_SensorsArgs = {
  _inc?: InputMaybe<Sensors_Inc_Input>;
  _set?: InputMaybe<Sensors_Set_Input>;
  where: Sensors_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Sensors_By_PkArgs = {
  _inc?: InputMaybe<Sensors_Inc_Input>;
  _set?: InputMaybe<Sensors_Set_Input>;
  pk_columns: Sensors_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Sensors_ManyArgs = {
  updates: Array<Sensors_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Sizing_DispositionsArgs = {
  _set?: InputMaybe<Sizing_Dispositions_Set_Input>;
  where: Sizing_Dispositions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Sizing_Dispositions_By_PkArgs = {
  _set?: InputMaybe<Sizing_Dispositions_Set_Input>;
  pk_columns: Sizing_Dispositions_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Sizing_Dispositions_ManyArgs = {
  updates: Array<Sizing_Dispositions_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Sizing_ImportsArgs = {
  _append?: InputMaybe<Sizing_Imports_Append_Input>;
  _delete_at_path?: InputMaybe<Sizing_Imports_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Sizing_Imports_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Sizing_Imports_Delete_Key_Input>;
  _inc?: InputMaybe<Sizing_Imports_Inc_Input>;
  _prepend?: InputMaybe<Sizing_Imports_Prepend_Input>;
  _set?: InputMaybe<Sizing_Imports_Set_Input>;
  where: Sizing_Imports_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Sizing_Imports_By_PkArgs = {
  _append?: InputMaybe<Sizing_Imports_Append_Input>;
  _delete_at_path?: InputMaybe<Sizing_Imports_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Sizing_Imports_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Sizing_Imports_Delete_Key_Input>;
  _inc?: InputMaybe<Sizing_Imports_Inc_Input>;
  _prepend?: InputMaybe<Sizing_Imports_Prepend_Input>;
  _set?: InputMaybe<Sizing_Imports_Set_Input>;
  pk_columns: Sizing_Imports_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Sizing_Imports_ManyArgs = {
  updates: Array<Sizing_Imports_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Sizing_Pumping_TypeArgs = {
  _set?: InputMaybe<Sizing_Pumping_Type_Set_Input>;
  where: Sizing_Pumping_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Sizing_Pumping_Type_By_PkArgs = {
  _set?: InputMaybe<Sizing_Pumping_Type_Set_Input>;
  pk_columns: Sizing_Pumping_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Sizing_Pumping_Type_ManyArgs = {
  updates: Array<Sizing_Pumping_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Solution_Gas_Oil_Ratio_OptionsArgs = {
  _set?: InputMaybe<Solution_Gas_Oil_Ratio_Options_Set_Input>;
  where: Solution_Gas_Oil_Ratio_Options_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Solution_Gas_Oil_Ratio_Options_By_PkArgs = {
  _set?: InputMaybe<Solution_Gas_Oil_Ratio_Options_Set_Input>;
  pk_columns: Solution_Gas_Oil_Ratio_Options_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Solution_Gas_Oil_Ratio_Options_ManyArgs = {
  updates: Array<Solution_Gas_Oil_Ratio_Options_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Step_Down_TransformersArgs = {
  _inc?: InputMaybe<Step_Down_Transformers_Inc_Input>;
  _set?: InputMaybe<Step_Down_Transformers_Set_Input>;
  where: Step_Down_Transformers_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Step_Down_Transformers_By_PkArgs = {
  _inc?: InputMaybe<Step_Down_Transformers_Inc_Input>;
  _set?: InputMaybe<Step_Down_Transformers_Set_Input>;
  pk_columns: Step_Down_Transformers_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Step_Down_Transformers_ManyArgs = {
  updates: Array<Step_Down_Transformers_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Step_Up_TransformersArgs = {
  _inc?: InputMaybe<Step_Up_Transformers_Inc_Input>;
  _set?: InputMaybe<Step_Up_Transformers_Set_Input>;
  where: Step_Up_Transformers_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Step_Up_Transformers_By_PkArgs = {
  _inc?: InputMaybe<Step_Up_Transformers_Inc_Input>;
  _set?: InputMaybe<Step_Up_Transformers_Set_Input>;
  pk_columns: Step_Up_Transformers_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Step_Up_Transformers_ManyArgs = {
  updates: Array<Step_Up_Transformers_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_SwitchboardsArgs = {
  _inc?: InputMaybe<Switchboards_Inc_Input>;
  _set?: InputMaybe<Switchboards_Set_Input>;
  where: Switchboards_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Switchboards_By_PkArgs = {
  _inc?: InputMaybe<Switchboards_Inc_Input>;
  _set?: InputMaybe<Switchboards_Set_Input>;
  pk_columns: Switchboards_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Switchboards_ManyArgs = {
  updates: Array<Switchboards_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Tubing_Flow_OptionsArgs = {
  _set?: InputMaybe<Tubing_Flow_Options_Set_Input>;
  where: Tubing_Flow_Options_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Tubing_Flow_Options_By_PkArgs = {
  _set?: InputMaybe<Tubing_Flow_Options_Set_Input>;
  pk_columns: Tubing_Flow_Options_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Tubing_Flow_Options_ManyArgs = {
  updates: Array<Tubing_Flow_Options_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_TubingsArgs = {
  _inc?: InputMaybe<Tubings_Inc_Input>;
  _set?: InputMaybe<Tubings_Set_Input>;
  where: Tubings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Tubings_By_PkArgs = {
  _inc?: InputMaybe<Tubings_Inc_Input>;
  _set?: InputMaybe<Tubings_Set_Input>;
  pk_columns: Tubings_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Tubings_ManyArgs = {
  updates: Array<Tubings_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Tubings_TypeArgs = {
  _set?: InputMaybe<Tubings_Type_Set_Input>;
  where: Tubings_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Tubings_Type_By_PkArgs = {
  _set?: InputMaybe<Tubings_Type_Set_Input>;
  pk_columns: Tubings_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Tubings_Type_ManyArgs = {
  updates: Array<Tubings_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Under_Saturated_Oil_OptionsArgs = {
  _set?: InputMaybe<Under_Saturated_Oil_Options_Set_Input>;
  where: Under_Saturated_Oil_Options_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Under_Saturated_Oil_Options_By_PkArgs = {
  _set?: InputMaybe<Under_Saturated_Oil_Options_Set_Input>;
  pk_columns: Under_Saturated_Oil_Options_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Under_Saturated_Oil_Options_ManyArgs = {
  updates: Array<Under_Saturated_Oil_Options_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_Eula_AcceptanceArgs = {
  _set?: InputMaybe<User_Eula_Acceptance_Set_Input>;
  where: User_Eula_Acceptance_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Eula_Acceptance_By_PkArgs = {
  _set?: InputMaybe<User_Eula_Acceptance_Set_Input>;
  pk_columns: User_Eula_Acceptance_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Eula_Acceptance_ManyArgs = {
  updates: Array<User_Eula_Acceptance_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_UsersArgs = {
  _set?: InputMaybe<Users_Set_Input>;
  where: Users_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Users_By_PkArgs = {
  _set?: InputMaybe<Users_Set_Input>;
  pk_columns: Users_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Users_ManyArgs = {
  updates: Array<Users_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Variable_Speed_DrivesArgs = {
  _inc?: InputMaybe<Variable_Speed_Drives_Inc_Input>;
  _set?: InputMaybe<Variable_Speed_Drives_Set_Input>;
  where: Variable_Speed_Drives_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Variable_Speed_Drives_By_PkArgs = {
  _inc?: InputMaybe<Variable_Speed_Drives_Inc_Input>;
  _set?: InputMaybe<Variable_Speed_Drives_Set_Input>;
  pk_columns: Variable_Speed_Drives_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Variable_Speed_Drives_ManyArgs = {
  updates: Array<Variable_Speed_Drives_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Water_Density_OptionsArgs = {
  _set?: InputMaybe<Water_Density_Options_Set_Input>;
  where: Water_Density_Options_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Water_Density_Options_By_PkArgs = {
  _set?: InputMaybe<Water_Density_Options_Set_Input>;
  pk_columns: Water_Density_Options_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Water_Density_Options_ManyArgs = {
  updates: Array<Water_Density_Options_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Water_Solution_Gas_OptionsArgs = {
  _set?: InputMaybe<Water_Solution_Gas_Options_Set_Input>;
  where: Water_Solution_Gas_Options_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Water_Solution_Gas_Options_By_PkArgs = {
  _set?: InputMaybe<Water_Solution_Gas_Options_Set_Input>;
  pk_columns: Water_Solution_Gas_Options_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Water_Solution_Gas_Options_ManyArgs = {
  updates: Array<Water_Solution_Gas_Options_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Water_Viscosity_OptionsArgs = {
  _set?: InputMaybe<Water_Viscosity_Options_Set_Input>;
  where: Water_Viscosity_Options_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Water_Viscosity_Options_By_PkArgs = {
  _set?: InputMaybe<Water_Viscosity_Options_Set_Input>;
  pk_columns: Water_Viscosity_Options_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Water_Viscosity_Options_ManyArgs = {
  updates: Array<Water_Viscosity_Options_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Water_Volume_Factor_OptionsArgs = {
  _set?: InputMaybe<Water_Volume_Factor_Options_Set_Input>;
  where: Water_Volume_Factor_Options_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Water_Volume_Factor_Options_By_PkArgs = {
  _set?: InputMaybe<Water_Volume_Factor_Options_Set_Input>;
  pk_columns: Water_Volume_Factor_Options_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Water_Volume_Factor_Options_ManyArgs = {
  updates: Array<Water_Volume_Factor_Options_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Well_Gas_Type_OptionsArgs = {
  _set?: InputMaybe<Well_Gas_Type_Options_Set_Input>;
  where: Well_Gas_Type_Options_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Well_Gas_Type_Options_By_PkArgs = {
  _set?: InputMaybe<Well_Gas_Type_Options_Set_Input>;
  pk_columns: Well_Gas_Type_Options_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Well_Gas_Type_Options_ManyArgs = {
  updates: Array<Well_Gas_Type_Options_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Well_Test_Gas_Input_OptionsArgs = {
  _set?: InputMaybe<Well_Test_Gas_Input_Options_Set_Input>;
  where: Well_Test_Gas_Input_Options_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Well_Test_Gas_Input_Options_By_PkArgs = {
  _set?: InputMaybe<Well_Test_Gas_Input_Options_Set_Input>;
  pk_columns: Well_Test_Gas_Input_Options_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Well_Test_Gas_Input_Options_ManyArgs = {
  updates: Array<Well_Test_Gas_Input_Options_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Well_Test_Liquid_Input_OptionsArgs = {
  _set?: InputMaybe<Well_Test_Liquid_Input_Options_Set_Input>;
  where: Well_Test_Liquid_Input_Options_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Well_Test_Liquid_Input_Options_By_PkArgs = {
  _set?: InputMaybe<Well_Test_Liquid_Input_Options_Set_Input>;
  pk_columns: Well_Test_Liquid_Input_Options_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Well_Test_Liquid_Input_Options_ManyArgs = {
  updates: Array<Well_Test_Liquid_Input_Options_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Well_Test_Pressure_Input_OptionsArgs = {
  _set?: InputMaybe<Well_Test_Pressure_Input_Options_Set_Input>;
  where: Well_Test_Pressure_Input_Options_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Well_Test_Pressure_Input_Options_By_PkArgs = {
  _set?: InputMaybe<Well_Test_Pressure_Input_Options_Set_Input>;
  pk_columns: Well_Test_Pressure_Input_Options_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Well_Test_Pressure_Input_Options_ManyArgs = {
  updates: Array<Well_Test_Pressure_Input_Options_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_WellsArgs = {
  _inc?: InputMaybe<Wells_Inc_Input>;
  _set?: InputMaybe<Wells_Set_Input>;
  where: Wells_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Wells_By_PkArgs = {
  _inc?: InputMaybe<Wells_Inc_Input>;
  _set?: InputMaybe<Wells_Set_Input>;
  pk_columns: Wells_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Wells_ManyArgs = {
  updates: Array<Wells_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Y_ToolsArgs = {
  _inc?: InputMaybe<Y_Tools_Inc_Input>;
  _set?: InputMaybe<Y_Tools_Set_Input>;
  where: Y_Tools_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Y_Tools_By_PkArgs = {
  _inc?: InputMaybe<Y_Tools_Inc_Input>;
  _set?: InputMaybe<Y_Tools_Set_Input>;
  pk_columns: Y_Tools_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Y_Tools_ManyArgs = {
  updates: Array<Y_Tools_Updates>;
};

/** columns and relationships of "natural_gas_separation_options" */
export type Natural_Gas_Separation_Options = {
  __typename: 'natural_gas_separation_options';
  comment?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

/** aggregated selection of "natural_gas_separation_options" */
export type Natural_Gas_Separation_Options_Aggregate = {
  __typename: 'natural_gas_separation_options_aggregate';
  aggregate?: Maybe<Natural_Gas_Separation_Options_Aggregate_Fields>;
  nodes: Array<Natural_Gas_Separation_Options>;
};

/** aggregate fields of "natural_gas_separation_options" */
export type Natural_Gas_Separation_Options_Aggregate_Fields = {
  __typename: 'natural_gas_separation_options_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Natural_Gas_Separation_Options_Max_Fields>;
  min?: Maybe<Natural_Gas_Separation_Options_Min_Fields>;
};


/** aggregate fields of "natural_gas_separation_options" */
export type Natural_Gas_Separation_Options_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Natural_Gas_Separation_Options_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "natural_gas_separation_options". All fields are combined with a logical 'AND'. */
export type Natural_Gas_Separation_Options_Bool_Exp = {
  _and?: InputMaybe<Array<Natural_Gas_Separation_Options_Bool_Exp>>;
  _not?: InputMaybe<Natural_Gas_Separation_Options_Bool_Exp>;
  _or?: InputMaybe<Array<Natural_Gas_Separation_Options_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "natural_gas_separation_options" */
export enum Natural_Gas_Separation_Options_Constraint {
  /** unique or primary key constraint on columns "value" */
  NaturalGasSeparationOptionsPkey = 'natural_gas_separation_options_pkey'
}

export enum Natural_Gas_Separation_Options_Enum {
  /** Alhanati */
  Alhanati = 'alhanati',
  /** Al-Hassan */
  Alhassan = 'alhassan'
}

/** Boolean expression to compare columns of type "natural_gas_separation_options_enum". All fields are combined with logical 'AND'. */
export type Natural_Gas_Separation_Options_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Natural_Gas_Separation_Options_Enum>;
  _in?: InputMaybe<Array<Natural_Gas_Separation_Options_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Natural_Gas_Separation_Options_Enum>;
  _nin?: InputMaybe<Array<Natural_Gas_Separation_Options_Enum>>;
};

/** input type for inserting data into table "natural_gas_separation_options" */
export type Natural_Gas_Separation_Options_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Natural_Gas_Separation_Options_Max_Fields = {
  __typename: 'natural_gas_separation_options_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Natural_Gas_Separation_Options_Min_Fields = {
  __typename: 'natural_gas_separation_options_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "natural_gas_separation_options" */
export type Natural_Gas_Separation_Options_Mutation_Response = {
  __typename: 'natural_gas_separation_options_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Natural_Gas_Separation_Options>;
};

/** on_conflict condition type for table "natural_gas_separation_options" */
export type Natural_Gas_Separation_Options_On_Conflict = {
  constraint: Natural_Gas_Separation_Options_Constraint;
  update_columns?: Array<Natural_Gas_Separation_Options_Update_Column>;
  where?: InputMaybe<Natural_Gas_Separation_Options_Bool_Exp>;
};

/** Ordering options when selecting data from "natural_gas_separation_options". */
export type Natural_Gas_Separation_Options_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: natural_gas_separation_options */
export type Natural_Gas_Separation_Options_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "natural_gas_separation_options" */
export enum Natural_Gas_Separation_Options_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "natural_gas_separation_options" */
export type Natural_Gas_Separation_Options_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "natural_gas_separation_options" */
export type Natural_Gas_Separation_Options_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Natural_Gas_Separation_Options_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Natural_Gas_Separation_Options_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "natural_gas_separation_options" */
export enum Natural_Gas_Separation_Options_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Natural_Gas_Separation_Options_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Natural_Gas_Separation_Options_Set_Input>;
  /** filter the rows which have to be updated */
  where: Natural_Gas_Separation_Options_Bool_Exp;
};

/** Boolean expression to compare columns of type "numeric". All fields are combined with logical 'AND'. */
export type Numeric_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['numeric']['input']>;
  _gt?: InputMaybe<Scalars['numeric']['input']>;
  _gte?: InputMaybe<Scalars['numeric']['input']>;
  _in?: InputMaybe<Array<Scalars['numeric']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['numeric']['input']>;
  _lte?: InputMaybe<Scalars['numeric']['input']>;
  _neq?: InputMaybe<Scalars['numeric']['input']>;
  _nin?: InputMaybe<Array<Scalars['numeric']['input']>>;
};

/** columns and relationships of "oil_density_options" */
export type Oil_Density_Options = {
  __typename: 'oil_density_options';
  comment?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

/** aggregated selection of "oil_density_options" */
export type Oil_Density_Options_Aggregate = {
  __typename: 'oil_density_options_aggregate';
  aggregate?: Maybe<Oil_Density_Options_Aggregate_Fields>;
  nodes: Array<Oil_Density_Options>;
};

/** aggregate fields of "oil_density_options" */
export type Oil_Density_Options_Aggregate_Fields = {
  __typename: 'oil_density_options_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Oil_Density_Options_Max_Fields>;
  min?: Maybe<Oil_Density_Options_Min_Fields>;
};


/** aggregate fields of "oil_density_options" */
export type Oil_Density_Options_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Oil_Density_Options_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "oil_density_options". All fields are combined with a logical 'AND'. */
export type Oil_Density_Options_Bool_Exp = {
  _and?: InputMaybe<Array<Oil_Density_Options_Bool_Exp>>;
  _not?: InputMaybe<Oil_Density_Options_Bool_Exp>;
  _or?: InputMaybe<Array<Oil_Density_Options_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "oil_density_options" */
export enum Oil_Density_Options_Constraint {
  /** unique or primary key constraint on columns "value" */
  OilDensityOptionsPkey = 'oil_density_options_pkey'
}

export enum Oil_Density_Options_Enum {
  /** Ahmed */
  Ahmed = 'ahmed',
  /** Standing */
  Standing = 'standing'
}

/** Boolean expression to compare columns of type "oil_density_options_enum". All fields are combined with logical 'AND'. */
export type Oil_Density_Options_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Oil_Density_Options_Enum>;
  _in?: InputMaybe<Array<Oil_Density_Options_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Oil_Density_Options_Enum>;
  _nin?: InputMaybe<Array<Oil_Density_Options_Enum>>;
};

/** input type for inserting data into table "oil_density_options" */
export type Oil_Density_Options_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Oil_Density_Options_Max_Fields = {
  __typename: 'oil_density_options_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Oil_Density_Options_Min_Fields = {
  __typename: 'oil_density_options_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "oil_density_options" */
export type Oil_Density_Options_Mutation_Response = {
  __typename: 'oil_density_options_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Oil_Density_Options>;
};

/** input type for inserting object relation for remote table "oil_density_options" */
export type Oil_Density_Options_Obj_Rel_Insert_Input = {
  data: Oil_Density_Options_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Oil_Density_Options_On_Conflict>;
};

/** on_conflict condition type for table "oil_density_options" */
export type Oil_Density_Options_On_Conflict = {
  constraint: Oil_Density_Options_Constraint;
  update_columns?: Array<Oil_Density_Options_Update_Column>;
  where?: InputMaybe<Oil_Density_Options_Bool_Exp>;
};

/** Ordering options when selecting data from "oil_density_options". */
export type Oil_Density_Options_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: oil_density_options */
export type Oil_Density_Options_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "oil_density_options" */
export enum Oil_Density_Options_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "oil_density_options" */
export type Oil_Density_Options_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "oil_density_options" */
export type Oil_Density_Options_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Oil_Density_Options_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Oil_Density_Options_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "oil_density_options" */
export enum Oil_Density_Options_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Oil_Density_Options_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Oil_Density_Options_Set_Input>;
  /** filter the rows which have to be updated */
  where: Oil_Density_Options_Bool_Exp;
};

/** columns and relationships of "oil_volume_factor_options" */
export type Oil_Volume_Factor_Options = {
  __typename: 'oil_volume_factor_options';
  comment?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

/** aggregated selection of "oil_volume_factor_options" */
export type Oil_Volume_Factor_Options_Aggregate = {
  __typename: 'oil_volume_factor_options_aggregate';
  aggregate?: Maybe<Oil_Volume_Factor_Options_Aggregate_Fields>;
  nodes: Array<Oil_Volume_Factor_Options>;
};

/** aggregate fields of "oil_volume_factor_options" */
export type Oil_Volume_Factor_Options_Aggregate_Fields = {
  __typename: 'oil_volume_factor_options_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Oil_Volume_Factor_Options_Max_Fields>;
  min?: Maybe<Oil_Volume_Factor_Options_Min_Fields>;
};


/** aggregate fields of "oil_volume_factor_options" */
export type Oil_Volume_Factor_Options_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Oil_Volume_Factor_Options_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "oil_volume_factor_options". All fields are combined with a logical 'AND'. */
export type Oil_Volume_Factor_Options_Bool_Exp = {
  _and?: InputMaybe<Array<Oil_Volume_Factor_Options_Bool_Exp>>;
  _not?: InputMaybe<Oil_Volume_Factor_Options_Bool_Exp>;
  _or?: InputMaybe<Array<Oil_Volume_Factor_Options_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "oil_volume_factor_options" */
export enum Oil_Volume_Factor_Options_Constraint {
  /** unique or primary key constraint on columns "value" */
  OilVolumeFactorOptionsPkey = 'oil_volume_factor_options_pkey'
}

export enum Oil_Volume_Factor_Options_Enum {
  /** De Ghetto Heavy Oil */
  DeGhettoHeavyOil = 'de_ghetto_heavy_oil',
  /** Glaso (North Sea) */
  GlasoNorthSea = 'glaso_north_sea',
  /** Kartoatmodjo & Schmidt */
  KartoatmodjoSchmidt = 'kartoatmodjo_schmidt',
  /** Petrosky & Farshad (GOM) */
  PetroskyFarshadGom = 'petrosky_farshad_gom',
  /** Standing */
  Standing = 'standing',
  /** Vasquez Beggs */
  VasquezBeggs = 'vasquez_beggs'
}

/** Boolean expression to compare columns of type "oil_volume_factor_options_enum". All fields are combined with logical 'AND'. */
export type Oil_Volume_Factor_Options_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Oil_Volume_Factor_Options_Enum>;
  _in?: InputMaybe<Array<Oil_Volume_Factor_Options_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Oil_Volume_Factor_Options_Enum>;
  _nin?: InputMaybe<Array<Oil_Volume_Factor_Options_Enum>>;
};

/** input type for inserting data into table "oil_volume_factor_options" */
export type Oil_Volume_Factor_Options_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Oil_Volume_Factor_Options_Max_Fields = {
  __typename: 'oil_volume_factor_options_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Oil_Volume_Factor_Options_Min_Fields = {
  __typename: 'oil_volume_factor_options_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "oil_volume_factor_options" */
export type Oil_Volume_Factor_Options_Mutation_Response = {
  __typename: 'oil_volume_factor_options_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Oil_Volume_Factor_Options>;
};

/** input type for inserting object relation for remote table "oil_volume_factor_options" */
export type Oil_Volume_Factor_Options_Obj_Rel_Insert_Input = {
  data: Oil_Volume_Factor_Options_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Oil_Volume_Factor_Options_On_Conflict>;
};

/** on_conflict condition type for table "oil_volume_factor_options" */
export type Oil_Volume_Factor_Options_On_Conflict = {
  constraint: Oil_Volume_Factor_Options_Constraint;
  update_columns?: Array<Oil_Volume_Factor_Options_Update_Column>;
  where?: InputMaybe<Oil_Volume_Factor_Options_Bool_Exp>;
};

/** Ordering options when selecting data from "oil_volume_factor_options". */
export type Oil_Volume_Factor_Options_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: oil_volume_factor_options */
export type Oil_Volume_Factor_Options_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "oil_volume_factor_options" */
export enum Oil_Volume_Factor_Options_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "oil_volume_factor_options" */
export type Oil_Volume_Factor_Options_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "oil_volume_factor_options" */
export type Oil_Volume_Factor_Options_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Oil_Volume_Factor_Options_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Oil_Volume_Factor_Options_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "oil_volume_factor_options" */
export enum Oil_Volume_Factor_Options_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Oil_Volume_Factor_Options_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Oil_Volume_Factor_Options_Set_Input>;
  /** filter the rows which have to be updated */
  where: Oil_Volume_Factor_Options_Bool_Exp;
};

/** column ordering options */
export enum Order_By {
  /** in ascending order, nulls last */
  Asc = 'asc',
  /** in ascending order, nulls first */
  AscNullsFirst = 'asc_nulls_first',
  /** in ascending order, nulls last */
  AscNullsLast = 'asc_nulls_last',
  /** in descending order, nulls first */
  Desc = 'desc',
  /** in descending order, nulls first */
  DescNullsFirst = 'desc_nulls_first',
  /** in descending order, nulls last */
  DescNullsLast = 'desc_nulls_last'
}

/** columns and relationships of "override_options" */
export type Override_Options = {
  __typename: 'override_options';
  comment?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

/** aggregated selection of "override_options" */
export type Override_Options_Aggregate = {
  __typename: 'override_options_aggregate';
  aggregate?: Maybe<Override_Options_Aggregate_Fields>;
  nodes: Array<Override_Options>;
};

/** aggregate fields of "override_options" */
export type Override_Options_Aggregate_Fields = {
  __typename: 'override_options_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Override_Options_Max_Fields>;
  min?: Maybe<Override_Options_Min_Fields>;
};


/** aggregate fields of "override_options" */
export type Override_Options_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Override_Options_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "override_options". All fields are combined with a logical 'AND'. */
export type Override_Options_Bool_Exp = {
  _and?: InputMaybe<Array<Override_Options_Bool_Exp>>;
  _not?: InputMaybe<Override_Options_Bool_Exp>;
  _or?: InputMaybe<Array<Override_Options_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "override_options" */
export enum Override_Options_Constraint {
  /** unique or primary key constraint on columns "value" */
  OverrideOptionsPkey = 'override_options_pkey'
}

export enum Override_Options_Enum {
  /** Calculate */
  Calculate = 'calculate',
  /** Disable */
  Disable = 'disable',
  /** Override */
  Override = 'override'
}

/** Boolean expression to compare columns of type "override_options_enum". All fields are combined with logical 'AND'. */
export type Override_Options_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Override_Options_Enum>;
  _in?: InputMaybe<Array<Override_Options_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Override_Options_Enum>;
  _nin?: InputMaybe<Array<Override_Options_Enum>>;
};

/** input type for inserting data into table "override_options" */
export type Override_Options_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Override_Options_Max_Fields = {
  __typename: 'override_options_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Override_Options_Min_Fields = {
  __typename: 'override_options_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "override_options" */
export type Override_Options_Mutation_Response = {
  __typename: 'override_options_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Override_Options>;
};

/** on_conflict condition type for table "override_options" */
export type Override_Options_On_Conflict = {
  constraint: Override_Options_Constraint;
  update_columns?: Array<Override_Options_Update_Column>;
  where?: InputMaybe<Override_Options_Bool_Exp>;
};

/** Ordering options when selecting data from "override_options". */
export type Override_Options_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: override_options */
export type Override_Options_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "override_options" */
export enum Override_Options_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "override_options" */
export type Override_Options_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "override_options" */
export type Override_Options_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Override_Options_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Override_Options_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "override_options" */
export enum Override_Options_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Override_Options_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Override_Options_Set_Input>;
  /** filter the rows which have to be updated */
  where: Override_Options_Bool_Exp;
};

/** columns and relationships of "performance_evaluations" */
export type Performance_Evaluations = {
  __typename: 'performance_evaluations';
  /** An object relationship */
  author?: Maybe<Users>;
  casing_pressure_psia?: Maybe<Scalars['numeric']['output']>;
  gas_rate_mscf_day?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  intake_gas_separation_override_type?: Maybe<Scalars['String']['output']>;
  intake_override_gas_separation_percent?: Maybe<Scalars['numeric']['output']>;
  journal_author_id?: Maybe<Scalars['String']['output']>;
  journal_created_at?: Maybe<Scalars['timestamptz']['output']>;
  journal_deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  journal_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  natural_gas_separation_override_type?: Maybe<Scalars['String']['output']>;
  natural_override_gas_separation_percent?: Maybe<Scalars['numeric']['output']>;
  oil_rate_std_barrel_day?: Maybe<Scalars['numeric']['output']>;
  parent_id?: Maybe<Scalars['uuid']['output']>;
  pump_hz?: Maybe<Scalars['numeric']['output']>;
  pump_intake_pressure_psia?: Maybe<Scalars['numeric']['output']>;
  pump_wear_brake_horsepower_correction_ratio?: Maybe<Scalars['numeric']['output']>;
  pump_wear_head_correction_ratio?: Maybe<Scalars['numeric']['output']>;
  /** An object relationship */
  scenario?: Maybe<Scenarios>;
  scenario_id?: Maybe<Scalars['uuid']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  tubing_pressure_psia?: Maybe<Scalars['numeric']['output']>;
  water_rate_std_barrel_day?: Maybe<Scalars['numeric']['output']>;
  winning_revision_author_id?: Maybe<Scalars['String']['output']>;
  winning_revision_created_at?: Maybe<Scalars['timestamptz']['output']>;
  winning_revision_deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  winning_revision_id?: Maybe<Scalars['uuid']['output']>;
  winning_revision_parent_id?: Maybe<Scalars['uuid']['output']>;
  winning_revision_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An array relationship */
  xref_pumps: Array<Performance_Evaluations_Xref_Pumps>;
  /** An aggregate relationship */
  xref_pumps_aggregate: Performance_Evaluations_Xref_Pumps_Aggregate;
};


/** columns and relationships of "performance_evaluations" */
export type Performance_EvaluationsXref_PumpsArgs = {
  distinct_on?: InputMaybe<Array<Performance_Evaluations_Xref_Pumps_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Performance_Evaluations_Xref_Pumps_Order_By>>;
  where?: InputMaybe<Performance_Evaluations_Xref_Pumps_Bool_Exp>;
};


/** columns and relationships of "performance_evaluations" */
export type Performance_EvaluationsXref_Pumps_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Performance_Evaluations_Xref_Pumps_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Performance_Evaluations_Xref_Pumps_Order_By>>;
  where?: InputMaybe<Performance_Evaluations_Xref_Pumps_Bool_Exp>;
};

/** aggregated selection of "performance_evaluations" */
export type Performance_Evaluations_Aggregate = {
  __typename: 'performance_evaluations_aggregate';
  aggregate?: Maybe<Performance_Evaluations_Aggregate_Fields>;
  nodes: Array<Performance_Evaluations>;
};

export type Performance_Evaluations_Aggregate_Bool_Exp = {
  count?: InputMaybe<Performance_Evaluations_Aggregate_Bool_Exp_Count>;
};

export type Performance_Evaluations_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Performance_Evaluations_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Performance_Evaluations_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "performance_evaluations" */
export type Performance_Evaluations_Aggregate_Fields = {
  __typename: 'performance_evaluations_aggregate_fields';
  avg?: Maybe<Performance_Evaluations_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Performance_Evaluations_Max_Fields>;
  min?: Maybe<Performance_Evaluations_Min_Fields>;
  stddev?: Maybe<Performance_Evaluations_Stddev_Fields>;
  stddev_pop?: Maybe<Performance_Evaluations_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Performance_Evaluations_Stddev_Samp_Fields>;
  sum?: Maybe<Performance_Evaluations_Sum_Fields>;
  var_pop?: Maybe<Performance_Evaluations_Var_Pop_Fields>;
  var_samp?: Maybe<Performance_Evaluations_Var_Samp_Fields>;
  variance?: Maybe<Performance_Evaluations_Variance_Fields>;
};


/** aggregate fields of "performance_evaluations" */
export type Performance_Evaluations_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Performance_Evaluations_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "performance_evaluations" */
export type Performance_Evaluations_Aggregate_Order_By = {
  avg?: InputMaybe<Performance_Evaluations_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Performance_Evaluations_Max_Order_By>;
  min?: InputMaybe<Performance_Evaluations_Min_Order_By>;
  stddev?: InputMaybe<Performance_Evaluations_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Performance_Evaluations_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Performance_Evaluations_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Performance_Evaluations_Sum_Order_By>;
  var_pop?: InputMaybe<Performance_Evaluations_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Performance_Evaluations_Var_Samp_Order_By>;
  variance?: InputMaybe<Performance_Evaluations_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "performance_evaluations" */
export type Performance_Evaluations_Arr_Rel_Insert_Input = {
  data: Array<Performance_Evaluations_Insert_Input>;
};

/** aggregate avg on columns */
export type Performance_Evaluations_Avg_Fields = {
  __typename: 'performance_evaluations_avg_fields';
  casing_pressure_psia?: Maybe<Scalars['Float']['output']>;
  gas_rate_mscf_day?: Maybe<Scalars['Float']['output']>;
  intake_override_gas_separation_percent?: Maybe<Scalars['Float']['output']>;
  natural_override_gas_separation_percent?: Maybe<Scalars['Float']['output']>;
  oil_rate_std_barrel_day?: Maybe<Scalars['Float']['output']>;
  pump_hz?: Maybe<Scalars['Float']['output']>;
  pump_intake_pressure_psia?: Maybe<Scalars['Float']['output']>;
  pump_wear_brake_horsepower_correction_ratio?: Maybe<Scalars['Float']['output']>;
  pump_wear_head_correction_ratio?: Maybe<Scalars['Float']['output']>;
  tubing_pressure_psia?: Maybe<Scalars['Float']['output']>;
  water_rate_std_barrel_day?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "performance_evaluations" */
export type Performance_Evaluations_Avg_Order_By = {
  casing_pressure_psia?: InputMaybe<Order_By>;
  gas_rate_mscf_day?: InputMaybe<Order_By>;
  intake_override_gas_separation_percent?: InputMaybe<Order_By>;
  natural_override_gas_separation_percent?: InputMaybe<Order_By>;
  oil_rate_std_barrel_day?: InputMaybe<Order_By>;
  pump_hz?: InputMaybe<Order_By>;
  pump_intake_pressure_psia?: InputMaybe<Order_By>;
  pump_wear_brake_horsepower_correction_ratio?: InputMaybe<Order_By>;
  pump_wear_head_correction_ratio?: InputMaybe<Order_By>;
  tubing_pressure_psia?: InputMaybe<Order_By>;
  water_rate_std_barrel_day?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "performance_evaluations". All fields are combined with a logical 'AND'. */
export type Performance_Evaluations_Bool_Exp = {
  _and?: InputMaybe<Array<Performance_Evaluations_Bool_Exp>>;
  _not?: InputMaybe<Performance_Evaluations_Bool_Exp>;
  _or?: InputMaybe<Array<Performance_Evaluations_Bool_Exp>>;
  author?: InputMaybe<Users_Bool_Exp>;
  casing_pressure_psia?: InputMaybe<Numeric_Comparison_Exp>;
  gas_rate_mscf_day?: InputMaybe<Numeric_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  intake_gas_separation_override_type?: InputMaybe<String_Comparison_Exp>;
  intake_override_gas_separation_percent?: InputMaybe<Numeric_Comparison_Exp>;
  journal_author_id?: InputMaybe<String_Comparison_Exp>;
  journal_created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  journal_deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  journal_updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  natural_gas_separation_override_type?: InputMaybe<String_Comparison_Exp>;
  natural_override_gas_separation_percent?: InputMaybe<Numeric_Comparison_Exp>;
  oil_rate_std_barrel_day?: InputMaybe<Numeric_Comparison_Exp>;
  parent_id?: InputMaybe<Uuid_Comparison_Exp>;
  pump_hz?: InputMaybe<Numeric_Comparison_Exp>;
  pump_intake_pressure_psia?: InputMaybe<Numeric_Comparison_Exp>;
  pump_wear_brake_horsepower_correction_ratio?: InputMaybe<Numeric_Comparison_Exp>;
  pump_wear_head_correction_ratio?: InputMaybe<Numeric_Comparison_Exp>;
  scenario?: InputMaybe<Scenarios_Bool_Exp>;
  scenario_id?: InputMaybe<Uuid_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  tubing_pressure_psia?: InputMaybe<Numeric_Comparison_Exp>;
  water_rate_std_barrel_day?: InputMaybe<Numeric_Comparison_Exp>;
  winning_revision_author_id?: InputMaybe<String_Comparison_Exp>;
  winning_revision_created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  winning_revision_deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  winning_revision_id?: InputMaybe<Uuid_Comparison_Exp>;
  winning_revision_parent_id?: InputMaybe<Uuid_Comparison_Exp>;
  winning_revision_updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  xref_pumps?: InputMaybe<Performance_Evaluations_Xref_Pumps_Bool_Exp>;
  xref_pumps_aggregate?: InputMaybe<Performance_Evaluations_Xref_Pumps_Aggregate_Bool_Exp>;
};

/** input type for inserting data into table "performance_evaluations" */
export type Performance_Evaluations_Insert_Input = {
  author?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  casing_pressure_psia?: InputMaybe<Scalars['numeric']['input']>;
  gas_rate_mscf_day?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  intake_gas_separation_override_type?: InputMaybe<Scalars['String']['input']>;
  intake_override_gas_separation_percent?: InputMaybe<Scalars['numeric']['input']>;
  journal_author_id?: InputMaybe<Scalars['String']['input']>;
  journal_created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  journal_deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  journal_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  natural_gas_separation_override_type?: InputMaybe<Scalars['String']['input']>;
  natural_override_gas_separation_percent?: InputMaybe<Scalars['numeric']['input']>;
  oil_rate_std_barrel_day?: InputMaybe<Scalars['numeric']['input']>;
  parent_id?: InputMaybe<Scalars['uuid']['input']>;
  pump_hz?: InputMaybe<Scalars['numeric']['input']>;
  pump_intake_pressure_psia?: InputMaybe<Scalars['numeric']['input']>;
  pump_wear_brake_horsepower_correction_ratio?: InputMaybe<Scalars['numeric']['input']>;
  pump_wear_head_correction_ratio?: InputMaybe<Scalars['numeric']['input']>;
  scenario?: InputMaybe<Scenarios_Obj_Rel_Insert_Input>;
  scenario_id?: InputMaybe<Scalars['uuid']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  tubing_pressure_psia?: InputMaybe<Scalars['numeric']['input']>;
  water_rate_std_barrel_day?: InputMaybe<Scalars['numeric']['input']>;
  winning_revision_author_id?: InputMaybe<Scalars['String']['input']>;
  winning_revision_created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  winning_revision_deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  winning_revision_id?: InputMaybe<Scalars['uuid']['input']>;
  winning_revision_parent_id?: InputMaybe<Scalars['uuid']['input']>;
  winning_revision_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  xref_pumps?: InputMaybe<Performance_Evaluations_Xref_Pumps_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Performance_Evaluations_Max_Fields = {
  __typename: 'performance_evaluations_max_fields';
  casing_pressure_psia?: Maybe<Scalars['numeric']['output']>;
  gas_rate_mscf_day?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  intake_gas_separation_override_type?: Maybe<Scalars['String']['output']>;
  intake_override_gas_separation_percent?: Maybe<Scalars['numeric']['output']>;
  journal_author_id?: Maybe<Scalars['String']['output']>;
  journal_created_at?: Maybe<Scalars['timestamptz']['output']>;
  journal_deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  journal_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  natural_gas_separation_override_type?: Maybe<Scalars['String']['output']>;
  natural_override_gas_separation_percent?: Maybe<Scalars['numeric']['output']>;
  oil_rate_std_barrel_day?: Maybe<Scalars['numeric']['output']>;
  parent_id?: Maybe<Scalars['uuid']['output']>;
  pump_hz?: Maybe<Scalars['numeric']['output']>;
  pump_intake_pressure_psia?: Maybe<Scalars['numeric']['output']>;
  pump_wear_brake_horsepower_correction_ratio?: Maybe<Scalars['numeric']['output']>;
  pump_wear_head_correction_ratio?: Maybe<Scalars['numeric']['output']>;
  scenario_id?: Maybe<Scalars['uuid']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  tubing_pressure_psia?: Maybe<Scalars['numeric']['output']>;
  water_rate_std_barrel_day?: Maybe<Scalars['numeric']['output']>;
  winning_revision_author_id?: Maybe<Scalars['String']['output']>;
  winning_revision_created_at?: Maybe<Scalars['timestamptz']['output']>;
  winning_revision_deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  winning_revision_id?: Maybe<Scalars['uuid']['output']>;
  winning_revision_parent_id?: Maybe<Scalars['uuid']['output']>;
  winning_revision_updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "performance_evaluations" */
export type Performance_Evaluations_Max_Order_By = {
  casing_pressure_psia?: InputMaybe<Order_By>;
  gas_rate_mscf_day?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  intake_gas_separation_override_type?: InputMaybe<Order_By>;
  intake_override_gas_separation_percent?: InputMaybe<Order_By>;
  journal_author_id?: InputMaybe<Order_By>;
  journal_created_at?: InputMaybe<Order_By>;
  journal_deleted_at?: InputMaybe<Order_By>;
  journal_updated_at?: InputMaybe<Order_By>;
  natural_gas_separation_override_type?: InputMaybe<Order_By>;
  natural_override_gas_separation_percent?: InputMaybe<Order_By>;
  oil_rate_std_barrel_day?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  pump_hz?: InputMaybe<Order_By>;
  pump_intake_pressure_psia?: InputMaybe<Order_By>;
  pump_wear_brake_horsepower_correction_ratio?: InputMaybe<Order_By>;
  pump_wear_head_correction_ratio?: InputMaybe<Order_By>;
  scenario_id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  tubing_pressure_psia?: InputMaybe<Order_By>;
  water_rate_std_barrel_day?: InputMaybe<Order_By>;
  winning_revision_author_id?: InputMaybe<Order_By>;
  winning_revision_created_at?: InputMaybe<Order_By>;
  winning_revision_deleted_at?: InputMaybe<Order_By>;
  winning_revision_id?: InputMaybe<Order_By>;
  winning_revision_parent_id?: InputMaybe<Order_By>;
  winning_revision_updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Performance_Evaluations_Min_Fields = {
  __typename: 'performance_evaluations_min_fields';
  casing_pressure_psia?: Maybe<Scalars['numeric']['output']>;
  gas_rate_mscf_day?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  intake_gas_separation_override_type?: Maybe<Scalars['String']['output']>;
  intake_override_gas_separation_percent?: Maybe<Scalars['numeric']['output']>;
  journal_author_id?: Maybe<Scalars['String']['output']>;
  journal_created_at?: Maybe<Scalars['timestamptz']['output']>;
  journal_deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  journal_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  natural_gas_separation_override_type?: Maybe<Scalars['String']['output']>;
  natural_override_gas_separation_percent?: Maybe<Scalars['numeric']['output']>;
  oil_rate_std_barrel_day?: Maybe<Scalars['numeric']['output']>;
  parent_id?: Maybe<Scalars['uuid']['output']>;
  pump_hz?: Maybe<Scalars['numeric']['output']>;
  pump_intake_pressure_psia?: Maybe<Scalars['numeric']['output']>;
  pump_wear_brake_horsepower_correction_ratio?: Maybe<Scalars['numeric']['output']>;
  pump_wear_head_correction_ratio?: Maybe<Scalars['numeric']['output']>;
  scenario_id?: Maybe<Scalars['uuid']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  tubing_pressure_psia?: Maybe<Scalars['numeric']['output']>;
  water_rate_std_barrel_day?: Maybe<Scalars['numeric']['output']>;
  winning_revision_author_id?: Maybe<Scalars['String']['output']>;
  winning_revision_created_at?: Maybe<Scalars['timestamptz']['output']>;
  winning_revision_deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  winning_revision_id?: Maybe<Scalars['uuid']['output']>;
  winning_revision_parent_id?: Maybe<Scalars['uuid']['output']>;
  winning_revision_updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "performance_evaluations" */
export type Performance_Evaluations_Min_Order_By = {
  casing_pressure_psia?: InputMaybe<Order_By>;
  gas_rate_mscf_day?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  intake_gas_separation_override_type?: InputMaybe<Order_By>;
  intake_override_gas_separation_percent?: InputMaybe<Order_By>;
  journal_author_id?: InputMaybe<Order_By>;
  journal_created_at?: InputMaybe<Order_By>;
  journal_deleted_at?: InputMaybe<Order_By>;
  journal_updated_at?: InputMaybe<Order_By>;
  natural_gas_separation_override_type?: InputMaybe<Order_By>;
  natural_override_gas_separation_percent?: InputMaybe<Order_By>;
  oil_rate_std_barrel_day?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  pump_hz?: InputMaybe<Order_By>;
  pump_intake_pressure_psia?: InputMaybe<Order_By>;
  pump_wear_brake_horsepower_correction_ratio?: InputMaybe<Order_By>;
  pump_wear_head_correction_ratio?: InputMaybe<Order_By>;
  scenario_id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  tubing_pressure_psia?: InputMaybe<Order_By>;
  water_rate_std_barrel_day?: InputMaybe<Order_By>;
  winning_revision_author_id?: InputMaybe<Order_By>;
  winning_revision_created_at?: InputMaybe<Order_By>;
  winning_revision_deleted_at?: InputMaybe<Order_By>;
  winning_revision_id?: InputMaybe<Order_By>;
  winning_revision_parent_id?: InputMaybe<Order_By>;
  winning_revision_updated_at?: InputMaybe<Order_By>;
};

/** input type for inserting object relation for remote table "performance_evaluations" */
export type Performance_Evaluations_Obj_Rel_Insert_Input = {
  data: Performance_Evaluations_Insert_Input;
};

/** Ordering options when selecting data from "performance_evaluations". */
export type Performance_Evaluations_Order_By = {
  author?: InputMaybe<Users_Order_By>;
  casing_pressure_psia?: InputMaybe<Order_By>;
  gas_rate_mscf_day?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  intake_gas_separation_override_type?: InputMaybe<Order_By>;
  intake_override_gas_separation_percent?: InputMaybe<Order_By>;
  journal_author_id?: InputMaybe<Order_By>;
  journal_created_at?: InputMaybe<Order_By>;
  journal_deleted_at?: InputMaybe<Order_By>;
  journal_updated_at?: InputMaybe<Order_By>;
  natural_gas_separation_override_type?: InputMaybe<Order_By>;
  natural_override_gas_separation_percent?: InputMaybe<Order_By>;
  oil_rate_std_barrel_day?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  pump_hz?: InputMaybe<Order_By>;
  pump_intake_pressure_psia?: InputMaybe<Order_By>;
  pump_wear_brake_horsepower_correction_ratio?: InputMaybe<Order_By>;
  pump_wear_head_correction_ratio?: InputMaybe<Order_By>;
  scenario?: InputMaybe<Scenarios_Order_By>;
  scenario_id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  tubing_pressure_psia?: InputMaybe<Order_By>;
  water_rate_std_barrel_day?: InputMaybe<Order_By>;
  winning_revision_author_id?: InputMaybe<Order_By>;
  winning_revision_created_at?: InputMaybe<Order_By>;
  winning_revision_deleted_at?: InputMaybe<Order_By>;
  winning_revision_id?: InputMaybe<Order_By>;
  winning_revision_parent_id?: InputMaybe<Order_By>;
  winning_revision_updated_at?: InputMaybe<Order_By>;
  xref_pumps_aggregate?: InputMaybe<Performance_Evaluations_Xref_Pumps_Aggregate_Order_By>;
};

/** select columns of table "performance_evaluations" */
export enum Performance_Evaluations_Select_Column {
  /** column name */
  CasingPressurePsia = 'casing_pressure_psia',
  /** column name */
  GasRateMscfDay = 'gas_rate_mscf_day',
  /** column name */
  Id = 'id',
  /** column name */
  IntakeGasSeparationOverrideType = 'intake_gas_separation_override_type',
  /** column name */
  IntakeOverrideGasSeparationPercent = 'intake_override_gas_separation_percent',
  /** column name */
  JournalAuthorId = 'journal_author_id',
  /** column name */
  JournalCreatedAt = 'journal_created_at',
  /** column name */
  JournalDeletedAt = 'journal_deleted_at',
  /** column name */
  JournalUpdatedAt = 'journal_updated_at',
  /** column name */
  NaturalGasSeparationOverrideType = 'natural_gas_separation_override_type',
  /** column name */
  NaturalOverrideGasSeparationPercent = 'natural_override_gas_separation_percent',
  /** column name */
  OilRateStdBarrelDay = 'oil_rate_std_barrel_day',
  /** column name */
  ParentId = 'parent_id',
  /** column name */
  PumpHz = 'pump_hz',
  /** column name */
  PumpIntakePressurePsia = 'pump_intake_pressure_psia',
  /** column name */
  PumpWearBrakeHorsepowerCorrectionRatio = 'pump_wear_brake_horsepower_correction_ratio',
  /** column name */
  PumpWearHeadCorrectionRatio = 'pump_wear_head_correction_ratio',
  /** column name */
  ScenarioId = 'scenario_id',
  /** column name */
  Title = 'title',
  /** column name */
  TubingPressurePsia = 'tubing_pressure_psia',
  /** column name */
  WaterRateStdBarrelDay = 'water_rate_std_barrel_day',
  /** column name */
  WinningRevisionAuthorId = 'winning_revision_author_id',
  /** column name */
  WinningRevisionCreatedAt = 'winning_revision_created_at',
  /** column name */
  WinningRevisionDeletedAt = 'winning_revision_deleted_at',
  /** column name */
  WinningRevisionId = 'winning_revision_id',
  /** column name */
  WinningRevisionParentId = 'winning_revision_parent_id',
  /** column name */
  WinningRevisionUpdatedAt = 'winning_revision_updated_at'
}

/** aggregate stddev on columns */
export type Performance_Evaluations_Stddev_Fields = {
  __typename: 'performance_evaluations_stddev_fields';
  casing_pressure_psia?: Maybe<Scalars['Float']['output']>;
  gas_rate_mscf_day?: Maybe<Scalars['Float']['output']>;
  intake_override_gas_separation_percent?: Maybe<Scalars['Float']['output']>;
  natural_override_gas_separation_percent?: Maybe<Scalars['Float']['output']>;
  oil_rate_std_barrel_day?: Maybe<Scalars['Float']['output']>;
  pump_hz?: Maybe<Scalars['Float']['output']>;
  pump_intake_pressure_psia?: Maybe<Scalars['Float']['output']>;
  pump_wear_brake_horsepower_correction_ratio?: Maybe<Scalars['Float']['output']>;
  pump_wear_head_correction_ratio?: Maybe<Scalars['Float']['output']>;
  tubing_pressure_psia?: Maybe<Scalars['Float']['output']>;
  water_rate_std_barrel_day?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "performance_evaluations" */
export type Performance_Evaluations_Stddev_Order_By = {
  casing_pressure_psia?: InputMaybe<Order_By>;
  gas_rate_mscf_day?: InputMaybe<Order_By>;
  intake_override_gas_separation_percent?: InputMaybe<Order_By>;
  natural_override_gas_separation_percent?: InputMaybe<Order_By>;
  oil_rate_std_barrel_day?: InputMaybe<Order_By>;
  pump_hz?: InputMaybe<Order_By>;
  pump_intake_pressure_psia?: InputMaybe<Order_By>;
  pump_wear_brake_horsepower_correction_ratio?: InputMaybe<Order_By>;
  pump_wear_head_correction_ratio?: InputMaybe<Order_By>;
  tubing_pressure_psia?: InputMaybe<Order_By>;
  water_rate_std_barrel_day?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Performance_Evaluations_Stddev_Pop_Fields = {
  __typename: 'performance_evaluations_stddev_pop_fields';
  casing_pressure_psia?: Maybe<Scalars['Float']['output']>;
  gas_rate_mscf_day?: Maybe<Scalars['Float']['output']>;
  intake_override_gas_separation_percent?: Maybe<Scalars['Float']['output']>;
  natural_override_gas_separation_percent?: Maybe<Scalars['Float']['output']>;
  oil_rate_std_barrel_day?: Maybe<Scalars['Float']['output']>;
  pump_hz?: Maybe<Scalars['Float']['output']>;
  pump_intake_pressure_psia?: Maybe<Scalars['Float']['output']>;
  pump_wear_brake_horsepower_correction_ratio?: Maybe<Scalars['Float']['output']>;
  pump_wear_head_correction_ratio?: Maybe<Scalars['Float']['output']>;
  tubing_pressure_psia?: Maybe<Scalars['Float']['output']>;
  water_rate_std_barrel_day?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "performance_evaluations" */
export type Performance_Evaluations_Stddev_Pop_Order_By = {
  casing_pressure_psia?: InputMaybe<Order_By>;
  gas_rate_mscf_day?: InputMaybe<Order_By>;
  intake_override_gas_separation_percent?: InputMaybe<Order_By>;
  natural_override_gas_separation_percent?: InputMaybe<Order_By>;
  oil_rate_std_barrel_day?: InputMaybe<Order_By>;
  pump_hz?: InputMaybe<Order_By>;
  pump_intake_pressure_psia?: InputMaybe<Order_By>;
  pump_wear_brake_horsepower_correction_ratio?: InputMaybe<Order_By>;
  pump_wear_head_correction_ratio?: InputMaybe<Order_By>;
  tubing_pressure_psia?: InputMaybe<Order_By>;
  water_rate_std_barrel_day?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Performance_Evaluations_Stddev_Samp_Fields = {
  __typename: 'performance_evaluations_stddev_samp_fields';
  casing_pressure_psia?: Maybe<Scalars['Float']['output']>;
  gas_rate_mscf_day?: Maybe<Scalars['Float']['output']>;
  intake_override_gas_separation_percent?: Maybe<Scalars['Float']['output']>;
  natural_override_gas_separation_percent?: Maybe<Scalars['Float']['output']>;
  oil_rate_std_barrel_day?: Maybe<Scalars['Float']['output']>;
  pump_hz?: Maybe<Scalars['Float']['output']>;
  pump_intake_pressure_psia?: Maybe<Scalars['Float']['output']>;
  pump_wear_brake_horsepower_correction_ratio?: Maybe<Scalars['Float']['output']>;
  pump_wear_head_correction_ratio?: Maybe<Scalars['Float']['output']>;
  tubing_pressure_psia?: Maybe<Scalars['Float']['output']>;
  water_rate_std_barrel_day?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "performance_evaluations" */
export type Performance_Evaluations_Stddev_Samp_Order_By = {
  casing_pressure_psia?: InputMaybe<Order_By>;
  gas_rate_mscf_day?: InputMaybe<Order_By>;
  intake_override_gas_separation_percent?: InputMaybe<Order_By>;
  natural_override_gas_separation_percent?: InputMaybe<Order_By>;
  oil_rate_std_barrel_day?: InputMaybe<Order_By>;
  pump_hz?: InputMaybe<Order_By>;
  pump_intake_pressure_psia?: InputMaybe<Order_By>;
  pump_wear_brake_horsepower_correction_ratio?: InputMaybe<Order_By>;
  pump_wear_head_correction_ratio?: InputMaybe<Order_By>;
  tubing_pressure_psia?: InputMaybe<Order_By>;
  water_rate_std_barrel_day?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "performance_evaluations" */
export type Performance_Evaluations_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Performance_Evaluations_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Performance_Evaluations_Stream_Cursor_Value_Input = {
  casing_pressure_psia?: InputMaybe<Scalars['numeric']['input']>;
  gas_rate_mscf_day?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  intake_gas_separation_override_type?: InputMaybe<Scalars['String']['input']>;
  intake_override_gas_separation_percent?: InputMaybe<Scalars['numeric']['input']>;
  journal_author_id?: InputMaybe<Scalars['String']['input']>;
  journal_created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  journal_deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  journal_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  natural_gas_separation_override_type?: InputMaybe<Scalars['String']['input']>;
  natural_override_gas_separation_percent?: InputMaybe<Scalars['numeric']['input']>;
  oil_rate_std_barrel_day?: InputMaybe<Scalars['numeric']['input']>;
  parent_id?: InputMaybe<Scalars['uuid']['input']>;
  pump_hz?: InputMaybe<Scalars['numeric']['input']>;
  pump_intake_pressure_psia?: InputMaybe<Scalars['numeric']['input']>;
  pump_wear_brake_horsepower_correction_ratio?: InputMaybe<Scalars['numeric']['input']>;
  pump_wear_head_correction_ratio?: InputMaybe<Scalars['numeric']['input']>;
  scenario_id?: InputMaybe<Scalars['uuid']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  tubing_pressure_psia?: InputMaybe<Scalars['numeric']['input']>;
  water_rate_std_barrel_day?: InputMaybe<Scalars['numeric']['input']>;
  winning_revision_author_id?: InputMaybe<Scalars['String']['input']>;
  winning_revision_created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  winning_revision_deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  winning_revision_id?: InputMaybe<Scalars['uuid']['input']>;
  winning_revision_parent_id?: InputMaybe<Scalars['uuid']['input']>;
  winning_revision_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Performance_Evaluations_Sum_Fields = {
  __typename: 'performance_evaluations_sum_fields';
  casing_pressure_psia?: Maybe<Scalars['numeric']['output']>;
  gas_rate_mscf_day?: Maybe<Scalars['numeric']['output']>;
  intake_override_gas_separation_percent?: Maybe<Scalars['numeric']['output']>;
  natural_override_gas_separation_percent?: Maybe<Scalars['numeric']['output']>;
  oil_rate_std_barrel_day?: Maybe<Scalars['numeric']['output']>;
  pump_hz?: Maybe<Scalars['numeric']['output']>;
  pump_intake_pressure_psia?: Maybe<Scalars['numeric']['output']>;
  pump_wear_brake_horsepower_correction_ratio?: Maybe<Scalars['numeric']['output']>;
  pump_wear_head_correction_ratio?: Maybe<Scalars['numeric']['output']>;
  tubing_pressure_psia?: Maybe<Scalars['numeric']['output']>;
  water_rate_std_barrel_day?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "performance_evaluations" */
export type Performance_Evaluations_Sum_Order_By = {
  casing_pressure_psia?: InputMaybe<Order_By>;
  gas_rate_mscf_day?: InputMaybe<Order_By>;
  intake_override_gas_separation_percent?: InputMaybe<Order_By>;
  natural_override_gas_separation_percent?: InputMaybe<Order_By>;
  oil_rate_std_barrel_day?: InputMaybe<Order_By>;
  pump_hz?: InputMaybe<Order_By>;
  pump_intake_pressure_psia?: InputMaybe<Order_By>;
  pump_wear_brake_horsepower_correction_ratio?: InputMaybe<Order_By>;
  pump_wear_head_correction_ratio?: InputMaybe<Order_By>;
  tubing_pressure_psia?: InputMaybe<Order_By>;
  water_rate_std_barrel_day?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Performance_Evaluations_Var_Pop_Fields = {
  __typename: 'performance_evaluations_var_pop_fields';
  casing_pressure_psia?: Maybe<Scalars['Float']['output']>;
  gas_rate_mscf_day?: Maybe<Scalars['Float']['output']>;
  intake_override_gas_separation_percent?: Maybe<Scalars['Float']['output']>;
  natural_override_gas_separation_percent?: Maybe<Scalars['Float']['output']>;
  oil_rate_std_barrel_day?: Maybe<Scalars['Float']['output']>;
  pump_hz?: Maybe<Scalars['Float']['output']>;
  pump_intake_pressure_psia?: Maybe<Scalars['Float']['output']>;
  pump_wear_brake_horsepower_correction_ratio?: Maybe<Scalars['Float']['output']>;
  pump_wear_head_correction_ratio?: Maybe<Scalars['Float']['output']>;
  tubing_pressure_psia?: Maybe<Scalars['Float']['output']>;
  water_rate_std_barrel_day?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "performance_evaluations" */
export type Performance_Evaluations_Var_Pop_Order_By = {
  casing_pressure_psia?: InputMaybe<Order_By>;
  gas_rate_mscf_day?: InputMaybe<Order_By>;
  intake_override_gas_separation_percent?: InputMaybe<Order_By>;
  natural_override_gas_separation_percent?: InputMaybe<Order_By>;
  oil_rate_std_barrel_day?: InputMaybe<Order_By>;
  pump_hz?: InputMaybe<Order_By>;
  pump_intake_pressure_psia?: InputMaybe<Order_By>;
  pump_wear_brake_horsepower_correction_ratio?: InputMaybe<Order_By>;
  pump_wear_head_correction_ratio?: InputMaybe<Order_By>;
  tubing_pressure_psia?: InputMaybe<Order_By>;
  water_rate_std_barrel_day?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Performance_Evaluations_Var_Samp_Fields = {
  __typename: 'performance_evaluations_var_samp_fields';
  casing_pressure_psia?: Maybe<Scalars['Float']['output']>;
  gas_rate_mscf_day?: Maybe<Scalars['Float']['output']>;
  intake_override_gas_separation_percent?: Maybe<Scalars['Float']['output']>;
  natural_override_gas_separation_percent?: Maybe<Scalars['Float']['output']>;
  oil_rate_std_barrel_day?: Maybe<Scalars['Float']['output']>;
  pump_hz?: Maybe<Scalars['Float']['output']>;
  pump_intake_pressure_psia?: Maybe<Scalars['Float']['output']>;
  pump_wear_brake_horsepower_correction_ratio?: Maybe<Scalars['Float']['output']>;
  pump_wear_head_correction_ratio?: Maybe<Scalars['Float']['output']>;
  tubing_pressure_psia?: Maybe<Scalars['Float']['output']>;
  water_rate_std_barrel_day?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "performance_evaluations" */
export type Performance_Evaluations_Var_Samp_Order_By = {
  casing_pressure_psia?: InputMaybe<Order_By>;
  gas_rate_mscf_day?: InputMaybe<Order_By>;
  intake_override_gas_separation_percent?: InputMaybe<Order_By>;
  natural_override_gas_separation_percent?: InputMaybe<Order_By>;
  oil_rate_std_barrel_day?: InputMaybe<Order_By>;
  pump_hz?: InputMaybe<Order_By>;
  pump_intake_pressure_psia?: InputMaybe<Order_By>;
  pump_wear_brake_horsepower_correction_ratio?: InputMaybe<Order_By>;
  pump_wear_head_correction_ratio?: InputMaybe<Order_By>;
  tubing_pressure_psia?: InputMaybe<Order_By>;
  water_rate_std_barrel_day?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Performance_Evaluations_Variance_Fields = {
  __typename: 'performance_evaluations_variance_fields';
  casing_pressure_psia?: Maybe<Scalars['Float']['output']>;
  gas_rate_mscf_day?: Maybe<Scalars['Float']['output']>;
  intake_override_gas_separation_percent?: Maybe<Scalars['Float']['output']>;
  natural_override_gas_separation_percent?: Maybe<Scalars['Float']['output']>;
  oil_rate_std_barrel_day?: Maybe<Scalars['Float']['output']>;
  pump_hz?: Maybe<Scalars['Float']['output']>;
  pump_intake_pressure_psia?: Maybe<Scalars['Float']['output']>;
  pump_wear_brake_horsepower_correction_ratio?: Maybe<Scalars['Float']['output']>;
  pump_wear_head_correction_ratio?: Maybe<Scalars['Float']['output']>;
  tubing_pressure_psia?: Maybe<Scalars['Float']['output']>;
  water_rate_std_barrel_day?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "performance_evaluations" */
export type Performance_Evaluations_Variance_Order_By = {
  casing_pressure_psia?: InputMaybe<Order_By>;
  gas_rate_mscf_day?: InputMaybe<Order_By>;
  intake_override_gas_separation_percent?: InputMaybe<Order_By>;
  natural_override_gas_separation_percent?: InputMaybe<Order_By>;
  oil_rate_std_barrel_day?: InputMaybe<Order_By>;
  pump_hz?: InputMaybe<Order_By>;
  pump_intake_pressure_psia?: InputMaybe<Order_By>;
  pump_wear_brake_horsepower_correction_ratio?: InputMaybe<Order_By>;
  pump_wear_head_correction_ratio?: InputMaybe<Order_By>;
  tubing_pressure_psia?: InputMaybe<Order_By>;
  water_rate_std_barrel_day?: InputMaybe<Order_By>;
};

/** columns and relationships of "performance_evaluations_xref_pumps" */
export type Performance_Evaluations_Xref_Pumps = {
  __typename: 'performance_evaluations_xref_pumps';
  brake_horsepower_correction_ratio?: Maybe<Scalars['numeric']['output']>;
  head_correction_ratio?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  journal_author_id?: Maybe<Scalars['String']['output']>;
  journal_created_at?: Maybe<Scalars['timestamptz']['output']>;
  journal_deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  journal_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  parent_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  performance_evaluation?: Maybe<Performance_Evaluations>;
  performance_evaluation_id?: Maybe<Scalars['uuid']['output']>;
  rate_correction_ratio?: Maybe<Scalars['numeric']['output']>;
  winning_revision_author_id?: Maybe<Scalars['String']['output']>;
  winning_revision_created_at?: Maybe<Scalars['timestamptz']['output']>;
  winning_revision_deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  winning_revision_id?: Maybe<Scalars['uuid']['output']>;
  winning_revision_parent_id?: Maybe<Scalars['uuid']['output']>;
  winning_revision_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  xref_pump_id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregated selection of "performance_evaluations_xref_pumps" */
export type Performance_Evaluations_Xref_Pumps_Aggregate = {
  __typename: 'performance_evaluations_xref_pumps_aggregate';
  aggregate?: Maybe<Performance_Evaluations_Xref_Pumps_Aggregate_Fields>;
  nodes: Array<Performance_Evaluations_Xref_Pumps>;
};

export type Performance_Evaluations_Xref_Pumps_Aggregate_Bool_Exp = {
  count?: InputMaybe<Performance_Evaluations_Xref_Pumps_Aggregate_Bool_Exp_Count>;
};

export type Performance_Evaluations_Xref_Pumps_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Performance_Evaluations_Xref_Pumps_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Performance_Evaluations_Xref_Pumps_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "performance_evaluations_xref_pumps" */
export type Performance_Evaluations_Xref_Pumps_Aggregate_Fields = {
  __typename: 'performance_evaluations_xref_pumps_aggregate_fields';
  avg?: Maybe<Performance_Evaluations_Xref_Pumps_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Performance_Evaluations_Xref_Pumps_Max_Fields>;
  min?: Maybe<Performance_Evaluations_Xref_Pumps_Min_Fields>;
  stddev?: Maybe<Performance_Evaluations_Xref_Pumps_Stddev_Fields>;
  stddev_pop?: Maybe<Performance_Evaluations_Xref_Pumps_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Performance_Evaluations_Xref_Pumps_Stddev_Samp_Fields>;
  sum?: Maybe<Performance_Evaluations_Xref_Pumps_Sum_Fields>;
  var_pop?: Maybe<Performance_Evaluations_Xref_Pumps_Var_Pop_Fields>;
  var_samp?: Maybe<Performance_Evaluations_Xref_Pumps_Var_Samp_Fields>;
  variance?: Maybe<Performance_Evaluations_Xref_Pumps_Variance_Fields>;
};


/** aggregate fields of "performance_evaluations_xref_pumps" */
export type Performance_Evaluations_Xref_Pumps_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Performance_Evaluations_Xref_Pumps_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "performance_evaluations_xref_pumps" */
export type Performance_Evaluations_Xref_Pumps_Aggregate_Order_By = {
  avg?: InputMaybe<Performance_Evaluations_Xref_Pumps_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Performance_Evaluations_Xref_Pumps_Max_Order_By>;
  min?: InputMaybe<Performance_Evaluations_Xref_Pumps_Min_Order_By>;
  stddev?: InputMaybe<Performance_Evaluations_Xref_Pumps_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Performance_Evaluations_Xref_Pumps_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Performance_Evaluations_Xref_Pumps_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Performance_Evaluations_Xref_Pumps_Sum_Order_By>;
  var_pop?: InputMaybe<Performance_Evaluations_Xref_Pumps_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Performance_Evaluations_Xref_Pumps_Var_Samp_Order_By>;
  variance?: InputMaybe<Performance_Evaluations_Xref_Pumps_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "performance_evaluations_xref_pumps" */
export type Performance_Evaluations_Xref_Pumps_Arr_Rel_Insert_Input = {
  data: Array<Performance_Evaluations_Xref_Pumps_Insert_Input>;
};

/** aggregate avg on columns */
export type Performance_Evaluations_Xref_Pumps_Avg_Fields = {
  __typename: 'performance_evaluations_xref_pumps_avg_fields';
  brake_horsepower_correction_ratio?: Maybe<Scalars['Float']['output']>;
  head_correction_ratio?: Maybe<Scalars['Float']['output']>;
  rate_correction_ratio?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "performance_evaluations_xref_pumps" */
export type Performance_Evaluations_Xref_Pumps_Avg_Order_By = {
  brake_horsepower_correction_ratio?: InputMaybe<Order_By>;
  head_correction_ratio?: InputMaybe<Order_By>;
  rate_correction_ratio?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "performance_evaluations_xref_pumps". All fields are combined with a logical 'AND'. */
export type Performance_Evaluations_Xref_Pumps_Bool_Exp = {
  _and?: InputMaybe<Array<Performance_Evaluations_Xref_Pumps_Bool_Exp>>;
  _not?: InputMaybe<Performance_Evaluations_Xref_Pumps_Bool_Exp>;
  _or?: InputMaybe<Array<Performance_Evaluations_Xref_Pumps_Bool_Exp>>;
  brake_horsepower_correction_ratio?: InputMaybe<Numeric_Comparison_Exp>;
  head_correction_ratio?: InputMaybe<Numeric_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  journal_author_id?: InputMaybe<String_Comparison_Exp>;
  journal_created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  journal_deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  journal_updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  parent_id?: InputMaybe<Uuid_Comparison_Exp>;
  performance_evaluation?: InputMaybe<Performance_Evaluations_Bool_Exp>;
  performance_evaluation_id?: InputMaybe<Uuid_Comparison_Exp>;
  rate_correction_ratio?: InputMaybe<Numeric_Comparison_Exp>;
  winning_revision_author_id?: InputMaybe<String_Comparison_Exp>;
  winning_revision_created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  winning_revision_deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  winning_revision_id?: InputMaybe<Uuid_Comparison_Exp>;
  winning_revision_parent_id?: InputMaybe<Uuid_Comparison_Exp>;
  winning_revision_updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  xref_pump_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** input type for inserting data into table "performance_evaluations_xref_pumps" */
export type Performance_Evaluations_Xref_Pumps_Insert_Input = {
  brake_horsepower_correction_ratio?: InputMaybe<Scalars['numeric']['input']>;
  head_correction_ratio?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  journal_author_id?: InputMaybe<Scalars['String']['input']>;
  journal_created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  journal_deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  journal_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  parent_id?: InputMaybe<Scalars['uuid']['input']>;
  performance_evaluation?: InputMaybe<Performance_Evaluations_Obj_Rel_Insert_Input>;
  performance_evaluation_id?: InputMaybe<Scalars['uuid']['input']>;
  rate_correction_ratio?: InputMaybe<Scalars['numeric']['input']>;
  winning_revision_author_id?: InputMaybe<Scalars['String']['input']>;
  winning_revision_created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  winning_revision_deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  winning_revision_id?: InputMaybe<Scalars['uuid']['input']>;
  winning_revision_parent_id?: InputMaybe<Scalars['uuid']['input']>;
  winning_revision_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  xref_pump_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Performance_Evaluations_Xref_Pumps_Max_Fields = {
  __typename: 'performance_evaluations_xref_pumps_max_fields';
  brake_horsepower_correction_ratio?: Maybe<Scalars['numeric']['output']>;
  head_correction_ratio?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  journal_author_id?: Maybe<Scalars['String']['output']>;
  journal_created_at?: Maybe<Scalars['timestamptz']['output']>;
  journal_deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  journal_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  parent_id?: Maybe<Scalars['uuid']['output']>;
  performance_evaluation_id?: Maybe<Scalars['uuid']['output']>;
  rate_correction_ratio?: Maybe<Scalars['numeric']['output']>;
  winning_revision_author_id?: Maybe<Scalars['String']['output']>;
  winning_revision_created_at?: Maybe<Scalars['timestamptz']['output']>;
  winning_revision_deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  winning_revision_id?: Maybe<Scalars['uuid']['output']>;
  winning_revision_parent_id?: Maybe<Scalars['uuid']['output']>;
  winning_revision_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  xref_pump_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "performance_evaluations_xref_pumps" */
export type Performance_Evaluations_Xref_Pumps_Max_Order_By = {
  brake_horsepower_correction_ratio?: InputMaybe<Order_By>;
  head_correction_ratio?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  journal_author_id?: InputMaybe<Order_By>;
  journal_created_at?: InputMaybe<Order_By>;
  journal_deleted_at?: InputMaybe<Order_By>;
  journal_updated_at?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  performance_evaluation_id?: InputMaybe<Order_By>;
  rate_correction_ratio?: InputMaybe<Order_By>;
  winning_revision_author_id?: InputMaybe<Order_By>;
  winning_revision_created_at?: InputMaybe<Order_By>;
  winning_revision_deleted_at?: InputMaybe<Order_By>;
  winning_revision_id?: InputMaybe<Order_By>;
  winning_revision_parent_id?: InputMaybe<Order_By>;
  winning_revision_updated_at?: InputMaybe<Order_By>;
  xref_pump_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Performance_Evaluations_Xref_Pumps_Min_Fields = {
  __typename: 'performance_evaluations_xref_pumps_min_fields';
  brake_horsepower_correction_ratio?: Maybe<Scalars['numeric']['output']>;
  head_correction_ratio?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  journal_author_id?: Maybe<Scalars['String']['output']>;
  journal_created_at?: Maybe<Scalars['timestamptz']['output']>;
  journal_deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  journal_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  parent_id?: Maybe<Scalars['uuid']['output']>;
  performance_evaluation_id?: Maybe<Scalars['uuid']['output']>;
  rate_correction_ratio?: Maybe<Scalars['numeric']['output']>;
  winning_revision_author_id?: Maybe<Scalars['String']['output']>;
  winning_revision_created_at?: Maybe<Scalars['timestamptz']['output']>;
  winning_revision_deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  winning_revision_id?: Maybe<Scalars['uuid']['output']>;
  winning_revision_parent_id?: Maybe<Scalars['uuid']['output']>;
  winning_revision_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  xref_pump_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "performance_evaluations_xref_pumps" */
export type Performance_Evaluations_Xref_Pumps_Min_Order_By = {
  brake_horsepower_correction_ratio?: InputMaybe<Order_By>;
  head_correction_ratio?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  journal_author_id?: InputMaybe<Order_By>;
  journal_created_at?: InputMaybe<Order_By>;
  journal_deleted_at?: InputMaybe<Order_By>;
  journal_updated_at?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  performance_evaluation_id?: InputMaybe<Order_By>;
  rate_correction_ratio?: InputMaybe<Order_By>;
  winning_revision_author_id?: InputMaybe<Order_By>;
  winning_revision_created_at?: InputMaybe<Order_By>;
  winning_revision_deleted_at?: InputMaybe<Order_By>;
  winning_revision_id?: InputMaybe<Order_By>;
  winning_revision_parent_id?: InputMaybe<Order_By>;
  winning_revision_updated_at?: InputMaybe<Order_By>;
  xref_pump_id?: InputMaybe<Order_By>;
};

/** input type for inserting object relation for remote table "performance_evaluations_xref_pumps" */
export type Performance_Evaluations_Xref_Pumps_Obj_Rel_Insert_Input = {
  data: Performance_Evaluations_Xref_Pumps_Insert_Input;
};

/** Ordering options when selecting data from "performance_evaluations_xref_pumps". */
export type Performance_Evaluations_Xref_Pumps_Order_By = {
  brake_horsepower_correction_ratio?: InputMaybe<Order_By>;
  head_correction_ratio?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  journal_author_id?: InputMaybe<Order_By>;
  journal_created_at?: InputMaybe<Order_By>;
  journal_deleted_at?: InputMaybe<Order_By>;
  journal_updated_at?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  performance_evaluation?: InputMaybe<Performance_Evaluations_Order_By>;
  performance_evaluation_id?: InputMaybe<Order_By>;
  rate_correction_ratio?: InputMaybe<Order_By>;
  winning_revision_author_id?: InputMaybe<Order_By>;
  winning_revision_created_at?: InputMaybe<Order_By>;
  winning_revision_deleted_at?: InputMaybe<Order_By>;
  winning_revision_id?: InputMaybe<Order_By>;
  winning_revision_parent_id?: InputMaybe<Order_By>;
  winning_revision_updated_at?: InputMaybe<Order_By>;
  xref_pump_id?: InputMaybe<Order_By>;
};

/** select columns of table "performance_evaluations_xref_pumps" */
export enum Performance_Evaluations_Xref_Pumps_Select_Column {
  /** column name */
  BrakeHorsepowerCorrectionRatio = 'brake_horsepower_correction_ratio',
  /** column name */
  HeadCorrectionRatio = 'head_correction_ratio',
  /** column name */
  Id = 'id',
  /** column name */
  JournalAuthorId = 'journal_author_id',
  /** column name */
  JournalCreatedAt = 'journal_created_at',
  /** column name */
  JournalDeletedAt = 'journal_deleted_at',
  /** column name */
  JournalUpdatedAt = 'journal_updated_at',
  /** column name */
  ParentId = 'parent_id',
  /** column name */
  PerformanceEvaluationId = 'performance_evaluation_id',
  /** column name */
  RateCorrectionRatio = 'rate_correction_ratio',
  /** column name */
  WinningRevisionAuthorId = 'winning_revision_author_id',
  /** column name */
  WinningRevisionCreatedAt = 'winning_revision_created_at',
  /** column name */
  WinningRevisionDeletedAt = 'winning_revision_deleted_at',
  /** column name */
  WinningRevisionId = 'winning_revision_id',
  /** column name */
  WinningRevisionParentId = 'winning_revision_parent_id',
  /** column name */
  WinningRevisionUpdatedAt = 'winning_revision_updated_at',
  /** column name */
  XrefPumpId = 'xref_pump_id'
}

/** aggregate stddev on columns */
export type Performance_Evaluations_Xref_Pumps_Stddev_Fields = {
  __typename: 'performance_evaluations_xref_pumps_stddev_fields';
  brake_horsepower_correction_ratio?: Maybe<Scalars['Float']['output']>;
  head_correction_ratio?: Maybe<Scalars['Float']['output']>;
  rate_correction_ratio?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "performance_evaluations_xref_pumps" */
export type Performance_Evaluations_Xref_Pumps_Stddev_Order_By = {
  brake_horsepower_correction_ratio?: InputMaybe<Order_By>;
  head_correction_ratio?: InputMaybe<Order_By>;
  rate_correction_ratio?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Performance_Evaluations_Xref_Pumps_Stddev_Pop_Fields = {
  __typename: 'performance_evaluations_xref_pumps_stddev_pop_fields';
  brake_horsepower_correction_ratio?: Maybe<Scalars['Float']['output']>;
  head_correction_ratio?: Maybe<Scalars['Float']['output']>;
  rate_correction_ratio?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "performance_evaluations_xref_pumps" */
export type Performance_Evaluations_Xref_Pumps_Stddev_Pop_Order_By = {
  brake_horsepower_correction_ratio?: InputMaybe<Order_By>;
  head_correction_ratio?: InputMaybe<Order_By>;
  rate_correction_ratio?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Performance_Evaluations_Xref_Pumps_Stddev_Samp_Fields = {
  __typename: 'performance_evaluations_xref_pumps_stddev_samp_fields';
  brake_horsepower_correction_ratio?: Maybe<Scalars['Float']['output']>;
  head_correction_ratio?: Maybe<Scalars['Float']['output']>;
  rate_correction_ratio?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "performance_evaluations_xref_pumps" */
export type Performance_Evaluations_Xref_Pumps_Stddev_Samp_Order_By = {
  brake_horsepower_correction_ratio?: InputMaybe<Order_By>;
  head_correction_ratio?: InputMaybe<Order_By>;
  rate_correction_ratio?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "performance_evaluations_xref_pumps" */
export type Performance_Evaluations_Xref_Pumps_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Performance_Evaluations_Xref_Pumps_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Performance_Evaluations_Xref_Pumps_Stream_Cursor_Value_Input = {
  brake_horsepower_correction_ratio?: InputMaybe<Scalars['numeric']['input']>;
  head_correction_ratio?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  journal_author_id?: InputMaybe<Scalars['String']['input']>;
  journal_created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  journal_deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  journal_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  parent_id?: InputMaybe<Scalars['uuid']['input']>;
  performance_evaluation_id?: InputMaybe<Scalars['uuid']['input']>;
  rate_correction_ratio?: InputMaybe<Scalars['numeric']['input']>;
  winning_revision_author_id?: InputMaybe<Scalars['String']['input']>;
  winning_revision_created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  winning_revision_deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  winning_revision_id?: InputMaybe<Scalars['uuid']['input']>;
  winning_revision_parent_id?: InputMaybe<Scalars['uuid']['input']>;
  winning_revision_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  xref_pump_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Performance_Evaluations_Xref_Pumps_Sum_Fields = {
  __typename: 'performance_evaluations_xref_pumps_sum_fields';
  brake_horsepower_correction_ratio?: Maybe<Scalars['numeric']['output']>;
  head_correction_ratio?: Maybe<Scalars['numeric']['output']>;
  rate_correction_ratio?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "performance_evaluations_xref_pumps" */
export type Performance_Evaluations_Xref_Pumps_Sum_Order_By = {
  brake_horsepower_correction_ratio?: InputMaybe<Order_By>;
  head_correction_ratio?: InputMaybe<Order_By>;
  rate_correction_ratio?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Performance_Evaluations_Xref_Pumps_Var_Pop_Fields = {
  __typename: 'performance_evaluations_xref_pumps_var_pop_fields';
  brake_horsepower_correction_ratio?: Maybe<Scalars['Float']['output']>;
  head_correction_ratio?: Maybe<Scalars['Float']['output']>;
  rate_correction_ratio?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "performance_evaluations_xref_pumps" */
export type Performance_Evaluations_Xref_Pumps_Var_Pop_Order_By = {
  brake_horsepower_correction_ratio?: InputMaybe<Order_By>;
  head_correction_ratio?: InputMaybe<Order_By>;
  rate_correction_ratio?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Performance_Evaluations_Xref_Pumps_Var_Samp_Fields = {
  __typename: 'performance_evaluations_xref_pumps_var_samp_fields';
  brake_horsepower_correction_ratio?: Maybe<Scalars['Float']['output']>;
  head_correction_ratio?: Maybe<Scalars['Float']['output']>;
  rate_correction_ratio?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "performance_evaluations_xref_pumps" */
export type Performance_Evaluations_Xref_Pumps_Var_Samp_Order_By = {
  brake_horsepower_correction_ratio?: InputMaybe<Order_By>;
  head_correction_ratio?: InputMaybe<Order_By>;
  rate_correction_ratio?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Performance_Evaluations_Xref_Pumps_Variance_Fields = {
  __typename: 'performance_evaluations_xref_pumps_variance_fields';
  brake_horsepower_correction_ratio?: Maybe<Scalars['Float']['output']>;
  head_correction_ratio?: Maybe<Scalars['Float']['output']>;
  rate_correction_ratio?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "performance_evaluations_xref_pumps" */
export type Performance_Evaluations_Xref_Pumps_Variance_Order_By = {
  brake_horsepower_correction_ratio?: InputMaybe<Order_By>;
  head_correction_ratio?: InputMaybe<Order_By>;
  rate_correction_ratio?: InputMaybe<Order_By>;
};

/** columns and relationships of "pumps" */
export type Pumps = {
  __typename: 'pumps';
  author_id: Scalars['String']['output'];
  bep_rate_standard_pump_bpd?: Maybe<Scalars['Int']['output']>;
  bhp1?: Maybe<Scalars['numeric']['output']>;
  bhp2?: Maybe<Scalars['numeric']['output']>;
  bhp3?: Maybe<Scalars['numeric']['output']>;
  bhp4?: Maybe<Scalars['numeric']['output']>;
  bhp5?: Maybe<Scalars['numeric']['output']>;
  bhpb?: Maybe<Scalars['numeric']['output']>;
  compression_thrust_per_stage?: Maybe<Scalars['numeric']['output']>;
  construction?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  h1?: Maybe<Scalars['numeric']['output']>;
  h2?: Maybe<Scalars['numeric']['output']>;
  h3?: Maybe<Scalars['numeric']['output']>;
  h4?: Maybe<Scalars['numeric']['output']>;
  h5?: Maybe<Scalars['numeric']['output']>;
  hb?: Maybe<Scalars['numeric']['output']>;
  high_strength_housing_pressure_rating_psi?: Maybe<Scalars['Int']['output']>;
  high_strength_shaft_rating_hp?: Maybe<Scalars['Int']['output']>;
  housing_inner_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  housing_outer_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  /** An array relationship */
  housings: Array<Housings>;
  /** An aggregate relationship */
  housings_aggregate: Housings_Aggregate;
  id: Scalars['uuid']['output'];
  imported_sizing_id?: Maybe<Scalars['Int']['output']>;
  include_ecopetrol_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  include_koc_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  is_compression_pump: Scalars['Boolean']['output'];
  manufacturer?: Maybe<Scalars['String']['output']>;
  max_bolt_load_pounds?: Maybe<Scalars['numeric']['output']>;
  max_graph_rate_standard_pump_bpd?: Maybe<Scalars['Int']['output']>;
  max_rate_standard_pump_bpd?: Maybe<Scalars['Int']['output']>;
  min_rate_standard_pump_bpd?: Maybe<Scalars['Int']['output']>;
  neck_inner_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  neck_outer_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  npsh1?: Maybe<Scalars['numeric']['output']>;
  npsh2?: Maybe<Scalars['numeric']['output']>;
  npsh3?: Maybe<Scalars['numeric']['output']>;
  npsh4?: Maybe<Scalars['numeric']['output']>;
  only_ecopetrol_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  only_koc_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  part_number?: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "prioritizepumpmanufacturer" */
  prioritized_manufacturer?: Maybe<Scalars['String']['output']>;
  rotation?: Maybe<Scalars['String']['output']>;
  series_model?: Maybe<Scalars['String']['output']>;
  shaft_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  /** An object relationship */
  sizing_import?: Maybe<Sizing_Imports>;
  stage_type?: Maybe<Scalars['Int']['output']>;
  standard_housing_pressure_rating_psi?: Maybe<Scalars['Int']['output']>;
  standard_shaft_rating_hp?: Maybe<Scalars['Int']['output']>;
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Users;
};


/** columns and relationships of "pumps" */
export type PumpsHousingsArgs = {
  distinct_on?: InputMaybe<Array<Housings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Housings_Order_By>>;
  where?: InputMaybe<Housings_Bool_Exp>;
};


/** columns and relationships of "pumps" */
export type PumpsHousings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Housings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Housings_Order_By>>;
  where?: InputMaybe<Housings_Bool_Exp>;
};

/** aggregated selection of "pumps" */
export type Pumps_Aggregate = {
  __typename: 'pumps_aggregate';
  aggregate?: Maybe<Pumps_Aggregate_Fields>;
  nodes: Array<Pumps>;
};

export type Pumps_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Pumps_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Pumps_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Pumps_Aggregate_Bool_Exp_Count>;
};

export type Pumps_Aggregate_Bool_Exp_Bool_And = {
  arguments: Pumps_Select_Column_Pumps_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Pumps_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Pumps_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Pumps_Select_Column_Pumps_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Pumps_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Pumps_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Pumps_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Pumps_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "pumps" */
export type Pumps_Aggregate_Fields = {
  __typename: 'pumps_aggregate_fields';
  avg?: Maybe<Pumps_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Pumps_Max_Fields>;
  min?: Maybe<Pumps_Min_Fields>;
  stddev?: Maybe<Pumps_Stddev_Fields>;
  stddev_pop?: Maybe<Pumps_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Pumps_Stddev_Samp_Fields>;
  sum?: Maybe<Pumps_Sum_Fields>;
  var_pop?: Maybe<Pumps_Var_Pop_Fields>;
  var_samp?: Maybe<Pumps_Var_Samp_Fields>;
  variance?: Maybe<Pumps_Variance_Fields>;
};


/** aggregate fields of "pumps" */
export type Pumps_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Pumps_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "pumps" */
export type Pumps_Aggregate_Order_By = {
  avg?: InputMaybe<Pumps_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Pumps_Max_Order_By>;
  min?: InputMaybe<Pumps_Min_Order_By>;
  stddev?: InputMaybe<Pumps_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Pumps_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Pumps_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Pumps_Sum_Order_By>;
  var_pop?: InputMaybe<Pumps_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Pumps_Var_Samp_Order_By>;
  variance?: InputMaybe<Pumps_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "pumps" */
export type Pumps_Arr_Rel_Insert_Input = {
  data: Array<Pumps_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Pumps_On_Conflict>;
};

/** aggregate avg on columns */
export type Pumps_Avg_Fields = {
  __typename: 'pumps_avg_fields';
  bep_rate_standard_pump_bpd?: Maybe<Scalars['Float']['output']>;
  bhp1?: Maybe<Scalars['Float']['output']>;
  bhp2?: Maybe<Scalars['Float']['output']>;
  bhp3?: Maybe<Scalars['Float']['output']>;
  bhp4?: Maybe<Scalars['Float']['output']>;
  bhp5?: Maybe<Scalars['Float']['output']>;
  bhpb?: Maybe<Scalars['Float']['output']>;
  compression_thrust_per_stage?: Maybe<Scalars['Float']['output']>;
  h1?: Maybe<Scalars['Float']['output']>;
  h2?: Maybe<Scalars['Float']['output']>;
  h3?: Maybe<Scalars['Float']['output']>;
  h4?: Maybe<Scalars['Float']['output']>;
  h5?: Maybe<Scalars['Float']['output']>;
  hb?: Maybe<Scalars['Float']['output']>;
  high_strength_housing_pressure_rating_psi?: Maybe<Scalars['Float']['output']>;
  high_strength_shaft_rating_hp?: Maybe<Scalars['Float']['output']>;
  housing_inner_diameter_inches?: Maybe<Scalars['Float']['output']>;
  housing_outer_diameter_inches?: Maybe<Scalars['Float']['output']>;
  imported_sizing_id?: Maybe<Scalars['Float']['output']>;
  max_bolt_load_pounds?: Maybe<Scalars['Float']['output']>;
  max_graph_rate_standard_pump_bpd?: Maybe<Scalars['Float']['output']>;
  max_rate_standard_pump_bpd?: Maybe<Scalars['Float']['output']>;
  min_rate_standard_pump_bpd?: Maybe<Scalars['Float']['output']>;
  neck_inner_diameter_inches?: Maybe<Scalars['Float']['output']>;
  neck_outer_diameter_inches?: Maybe<Scalars['Float']['output']>;
  npsh1?: Maybe<Scalars['Float']['output']>;
  npsh2?: Maybe<Scalars['Float']['output']>;
  npsh3?: Maybe<Scalars['Float']['output']>;
  npsh4?: Maybe<Scalars['Float']['output']>;
  shaft_diameter_inches?: Maybe<Scalars['Float']['output']>;
  stage_type?: Maybe<Scalars['Float']['output']>;
  standard_housing_pressure_rating_psi?: Maybe<Scalars['Float']['output']>;
  standard_shaft_rating_hp?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "pumps" */
export type Pumps_Avg_Order_By = {
  bep_rate_standard_pump_bpd?: InputMaybe<Order_By>;
  bhp1?: InputMaybe<Order_By>;
  bhp2?: InputMaybe<Order_By>;
  bhp3?: InputMaybe<Order_By>;
  bhp4?: InputMaybe<Order_By>;
  bhp5?: InputMaybe<Order_By>;
  bhpb?: InputMaybe<Order_By>;
  compression_thrust_per_stage?: InputMaybe<Order_By>;
  h1?: InputMaybe<Order_By>;
  h2?: InputMaybe<Order_By>;
  h3?: InputMaybe<Order_By>;
  h4?: InputMaybe<Order_By>;
  h5?: InputMaybe<Order_By>;
  hb?: InputMaybe<Order_By>;
  high_strength_housing_pressure_rating_psi?: InputMaybe<Order_By>;
  high_strength_shaft_rating_hp?: InputMaybe<Order_By>;
  housing_inner_diameter_inches?: InputMaybe<Order_By>;
  housing_outer_diameter_inches?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  max_bolt_load_pounds?: InputMaybe<Order_By>;
  max_graph_rate_standard_pump_bpd?: InputMaybe<Order_By>;
  max_rate_standard_pump_bpd?: InputMaybe<Order_By>;
  min_rate_standard_pump_bpd?: InputMaybe<Order_By>;
  neck_inner_diameter_inches?: InputMaybe<Order_By>;
  neck_outer_diameter_inches?: InputMaybe<Order_By>;
  npsh1?: InputMaybe<Order_By>;
  npsh2?: InputMaybe<Order_By>;
  npsh3?: InputMaybe<Order_By>;
  npsh4?: InputMaybe<Order_By>;
  shaft_diameter_inches?: InputMaybe<Order_By>;
  stage_type?: InputMaybe<Order_By>;
  standard_housing_pressure_rating_psi?: InputMaybe<Order_By>;
  standard_shaft_rating_hp?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "pumps". All fields are combined with a logical 'AND'. */
export type Pumps_Bool_Exp = {
  _and?: InputMaybe<Array<Pumps_Bool_Exp>>;
  _not?: InputMaybe<Pumps_Bool_Exp>;
  _or?: InputMaybe<Array<Pumps_Bool_Exp>>;
  author_id?: InputMaybe<String_Comparison_Exp>;
  bep_rate_standard_pump_bpd?: InputMaybe<Int_Comparison_Exp>;
  bhp1?: InputMaybe<Numeric_Comparison_Exp>;
  bhp2?: InputMaybe<Numeric_Comparison_Exp>;
  bhp3?: InputMaybe<Numeric_Comparison_Exp>;
  bhp4?: InputMaybe<Numeric_Comparison_Exp>;
  bhp5?: InputMaybe<Numeric_Comparison_Exp>;
  bhpb?: InputMaybe<Numeric_Comparison_Exp>;
  compression_thrust_per_stage?: InputMaybe<Numeric_Comparison_Exp>;
  construction?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  h1?: InputMaybe<Numeric_Comparison_Exp>;
  h2?: InputMaybe<Numeric_Comparison_Exp>;
  h3?: InputMaybe<Numeric_Comparison_Exp>;
  h4?: InputMaybe<Numeric_Comparison_Exp>;
  h5?: InputMaybe<Numeric_Comparison_Exp>;
  hb?: InputMaybe<Numeric_Comparison_Exp>;
  high_strength_housing_pressure_rating_psi?: InputMaybe<Int_Comparison_Exp>;
  high_strength_shaft_rating_hp?: InputMaybe<Int_Comparison_Exp>;
  housing_inner_diameter_inches?: InputMaybe<Numeric_Comparison_Exp>;
  housing_outer_diameter_inches?: InputMaybe<Numeric_Comparison_Exp>;
  housings?: InputMaybe<Housings_Bool_Exp>;
  housings_aggregate?: InputMaybe<Housings_Aggregate_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  imported_sizing_id?: InputMaybe<Int_Comparison_Exp>;
  include_ecopetrol_timestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  include_koc_timestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  is_compression_pump?: InputMaybe<Boolean_Comparison_Exp>;
  manufacturer?: InputMaybe<String_Comparison_Exp>;
  max_bolt_load_pounds?: InputMaybe<Numeric_Comparison_Exp>;
  max_graph_rate_standard_pump_bpd?: InputMaybe<Int_Comparison_Exp>;
  max_rate_standard_pump_bpd?: InputMaybe<Int_Comparison_Exp>;
  min_rate_standard_pump_bpd?: InputMaybe<Int_Comparison_Exp>;
  neck_inner_diameter_inches?: InputMaybe<Numeric_Comparison_Exp>;
  neck_outer_diameter_inches?: InputMaybe<Numeric_Comparison_Exp>;
  npsh1?: InputMaybe<Numeric_Comparison_Exp>;
  npsh2?: InputMaybe<Numeric_Comparison_Exp>;
  npsh3?: InputMaybe<Numeric_Comparison_Exp>;
  npsh4?: InputMaybe<Numeric_Comparison_Exp>;
  only_ecopetrol_timestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  only_koc_timestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  part_number?: InputMaybe<String_Comparison_Exp>;
  prioritized_manufacturer?: InputMaybe<String_Comparison_Exp>;
  rotation?: InputMaybe<String_Comparison_Exp>;
  series_model?: InputMaybe<String_Comparison_Exp>;
  shaft_diameter_inches?: InputMaybe<Numeric_Comparison_Exp>;
  sizing_import?: InputMaybe<Sizing_Imports_Bool_Exp>;
  stage_type?: InputMaybe<Int_Comparison_Exp>;
  standard_housing_pressure_rating_psi?: InputMaybe<Int_Comparison_Exp>;
  standard_shaft_rating_hp?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
};

/** unique or primary key constraints on table "pumps" */
export enum Pumps_Constraint {
  /** unique or primary key constraint on columns "id" */
  PumpsPkey = 'pumps_pkey'
}

/** input type for incrementing numeric columns in table "pumps" */
export type Pumps_Inc_Input = {
  bep_rate_standard_pump_bpd?: InputMaybe<Scalars['Int']['input']>;
  bhp1?: InputMaybe<Scalars['numeric']['input']>;
  bhp2?: InputMaybe<Scalars['numeric']['input']>;
  bhp3?: InputMaybe<Scalars['numeric']['input']>;
  bhp4?: InputMaybe<Scalars['numeric']['input']>;
  bhp5?: InputMaybe<Scalars['numeric']['input']>;
  bhpb?: InputMaybe<Scalars['numeric']['input']>;
  compression_thrust_per_stage?: InputMaybe<Scalars['numeric']['input']>;
  h1?: InputMaybe<Scalars['numeric']['input']>;
  h2?: InputMaybe<Scalars['numeric']['input']>;
  h3?: InputMaybe<Scalars['numeric']['input']>;
  h4?: InputMaybe<Scalars['numeric']['input']>;
  h5?: InputMaybe<Scalars['numeric']['input']>;
  hb?: InputMaybe<Scalars['numeric']['input']>;
  high_strength_housing_pressure_rating_psi?: InputMaybe<Scalars['Int']['input']>;
  high_strength_shaft_rating_hp?: InputMaybe<Scalars['Int']['input']>;
  housing_inner_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  housing_outer_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  imported_sizing_id?: InputMaybe<Scalars['Int']['input']>;
  max_bolt_load_pounds?: InputMaybe<Scalars['numeric']['input']>;
  max_graph_rate_standard_pump_bpd?: InputMaybe<Scalars['Int']['input']>;
  max_rate_standard_pump_bpd?: InputMaybe<Scalars['Int']['input']>;
  min_rate_standard_pump_bpd?: InputMaybe<Scalars['Int']['input']>;
  neck_inner_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  neck_outer_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  npsh1?: InputMaybe<Scalars['numeric']['input']>;
  npsh2?: InputMaybe<Scalars['numeric']['input']>;
  npsh3?: InputMaybe<Scalars['numeric']['input']>;
  npsh4?: InputMaybe<Scalars['numeric']['input']>;
  shaft_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  stage_type?: InputMaybe<Scalars['Int']['input']>;
  standard_housing_pressure_rating_psi?: InputMaybe<Scalars['Int']['input']>;
  standard_shaft_rating_hp?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "pumps" */
export type Pumps_Insert_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  bep_rate_standard_pump_bpd?: InputMaybe<Scalars['Int']['input']>;
  bhp1?: InputMaybe<Scalars['numeric']['input']>;
  bhp2?: InputMaybe<Scalars['numeric']['input']>;
  bhp3?: InputMaybe<Scalars['numeric']['input']>;
  bhp4?: InputMaybe<Scalars['numeric']['input']>;
  bhp5?: InputMaybe<Scalars['numeric']['input']>;
  bhpb?: InputMaybe<Scalars['numeric']['input']>;
  compression_thrust_per_stage?: InputMaybe<Scalars['numeric']['input']>;
  construction?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  h1?: InputMaybe<Scalars['numeric']['input']>;
  h2?: InputMaybe<Scalars['numeric']['input']>;
  h3?: InputMaybe<Scalars['numeric']['input']>;
  h4?: InputMaybe<Scalars['numeric']['input']>;
  h5?: InputMaybe<Scalars['numeric']['input']>;
  hb?: InputMaybe<Scalars['numeric']['input']>;
  high_strength_housing_pressure_rating_psi?: InputMaybe<Scalars['Int']['input']>;
  high_strength_shaft_rating_hp?: InputMaybe<Scalars['Int']['input']>;
  housing_inner_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  housing_outer_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  housings?: InputMaybe<Housings_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  imported_sizing_id?: InputMaybe<Scalars['Int']['input']>;
  include_ecopetrol_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  include_koc_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  is_compression_pump?: InputMaybe<Scalars['Boolean']['input']>;
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  max_bolt_load_pounds?: InputMaybe<Scalars['numeric']['input']>;
  max_graph_rate_standard_pump_bpd?: InputMaybe<Scalars['Int']['input']>;
  max_rate_standard_pump_bpd?: InputMaybe<Scalars['Int']['input']>;
  min_rate_standard_pump_bpd?: InputMaybe<Scalars['Int']['input']>;
  neck_inner_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  neck_outer_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  npsh1?: InputMaybe<Scalars['numeric']['input']>;
  npsh2?: InputMaybe<Scalars['numeric']['input']>;
  npsh3?: InputMaybe<Scalars['numeric']['input']>;
  npsh4?: InputMaybe<Scalars['numeric']['input']>;
  only_ecopetrol_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  only_koc_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  part_number?: InputMaybe<Scalars['String']['input']>;
  rotation?: InputMaybe<Scalars['String']['input']>;
  series_model?: InputMaybe<Scalars['String']['input']>;
  shaft_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  sizing_import?: InputMaybe<Sizing_Imports_Obj_Rel_Insert_Input>;
  stage_type?: InputMaybe<Scalars['Int']['input']>;
  standard_housing_pressure_rating_psi?: InputMaybe<Scalars['Int']['input']>;
  standard_shaft_rating_hp?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Pumps_Max_Fields = {
  __typename: 'pumps_max_fields';
  author_id?: Maybe<Scalars['String']['output']>;
  bep_rate_standard_pump_bpd?: Maybe<Scalars['Int']['output']>;
  bhp1?: Maybe<Scalars['numeric']['output']>;
  bhp2?: Maybe<Scalars['numeric']['output']>;
  bhp3?: Maybe<Scalars['numeric']['output']>;
  bhp4?: Maybe<Scalars['numeric']['output']>;
  bhp5?: Maybe<Scalars['numeric']['output']>;
  bhpb?: Maybe<Scalars['numeric']['output']>;
  compression_thrust_per_stage?: Maybe<Scalars['numeric']['output']>;
  construction?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  h1?: Maybe<Scalars['numeric']['output']>;
  h2?: Maybe<Scalars['numeric']['output']>;
  h3?: Maybe<Scalars['numeric']['output']>;
  h4?: Maybe<Scalars['numeric']['output']>;
  h5?: Maybe<Scalars['numeric']['output']>;
  hb?: Maybe<Scalars['numeric']['output']>;
  high_strength_housing_pressure_rating_psi?: Maybe<Scalars['Int']['output']>;
  high_strength_shaft_rating_hp?: Maybe<Scalars['Int']['output']>;
  housing_inner_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  housing_outer_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  imported_sizing_id?: Maybe<Scalars['Int']['output']>;
  include_ecopetrol_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  include_koc_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  manufacturer?: Maybe<Scalars['String']['output']>;
  max_bolt_load_pounds?: Maybe<Scalars['numeric']['output']>;
  max_graph_rate_standard_pump_bpd?: Maybe<Scalars['Int']['output']>;
  max_rate_standard_pump_bpd?: Maybe<Scalars['Int']['output']>;
  min_rate_standard_pump_bpd?: Maybe<Scalars['Int']['output']>;
  neck_inner_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  neck_outer_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  npsh1?: Maybe<Scalars['numeric']['output']>;
  npsh2?: Maybe<Scalars['numeric']['output']>;
  npsh3?: Maybe<Scalars['numeric']['output']>;
  npsh4?: Maybe<Scalars['numeric']['output']>;
  only_ecopetrol_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  only_koc_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  part_number?: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "prioritizepumpmanufacturer" */
  prioritized_manufacturer?: Maybe<Scalars['String']['output']>;
  rotation?: Maybe<Scalars['String']['output']>;
  series_model?: Maybe<Scalars['String']['output']>;
  shaft_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  stage_type?: Maybe<Scalars['Int']['output']>;
  standard_housing_pressure_rating_psi?: Maybe<Scalars['Int']['output']>;
  standard_shaft_rating_hp?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "pumps" */
export type Pumps_Max_Order_By = {
  author_id?: InputMaybe<Order_By>;
  bep_rate_standard_pump_bpd?: InputMaybe<Order_By>;
  bhp1?: InputMaybe<Order_By>;
  bhp2?: InputMaybe<Order_By>;
  bhp3?: InputMaybe<Order_By>;
  bhp4?: InputMaybe<Order_By>;
  bhp5?: InputMaybe<Order_By>;
  bhpb?: InputMaybe<Order_By>;
  compression_thrust_per_stage?: InputMaybe<Order_By>;
  construction?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  h1?: InputMaybe<Order_By>;
  h2?: InputMaybe<Order_By>;
  h3?: InputMaybe<Order_By>;
  h4?: InputMaybe<Order_By>;
  h5?: InputMaybe<Order_By>;
  hb?: InputMaybe<Order_By>;
  high_strength_housing_pressure_rating_psi?: InputMaybe<Order_By>;
  high_strength_shaft_rating_hp?: InputMaybe<Order_By>;
  housing_inner_diameter_inches?: InputMaybe<Order_By>;
  housing_outer_diameter_inches?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  include_ecopetrol_timestamp?: InputMaybe<Order_By>;
  include_koc_timestamp?: InputMaybe<Order_By>;
  manufacturer?: InputMaybe<Order_By>;
  max_bolt_load_pounds?: InputMaybe<Order_By>;
  max_graph_rate_standard_pump_bpd?: InputMaybe<Order_By>;
  max_rate_standard_pump_bpd?: InputMaybe<Order_By>;
  min_rate_standard_pump_bpd?: InputMaybe<Order_By>;
  neck_inner_diameter_inches?: InputMaybe<Order_By>;
  neck_outer_diameter_inches?: InputMaybe<Order_By>;
  npsh1?: InputMaybe<Order_By>;
  npsh2?: InputMaybe<Order_By>;
  npsh3?: InputMaybe<Order_By>;
  npsh4?: InputMaybe<Order_By>;
  only_ecopetrol_timestamp?: InputMaybe<Order_By>;
  only_koc_timestamp?: InputMaybe<Order_By>;
  part_number?: InputMaybe<Order_By>;
  rotation?: InputMaybe<Order_By>;
  series_model?: InputMaybe<Order_By>;
  shaft_diameter_inches?: InputMaybe<Order_By>;
  stage_type?: InputMaybe<Order_By>;
  standard_housing_pressure_rating_psi?: InputMaybe<Order_By>;
  standard_shaft_rating_hp?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Pumps_Min_Fields = {
  __typename: 'pumps_min_fields';
  author_id?: Maybe<Scalars['String']['output']>;
  bep_rate_standard_pump_bpd?: Maybe<Scalars['Int']['output']>;
  bhp1?: Maybe<Scalars['numeric']['output']>;
  bhp2?: Maybe<Scalars['numeric']['output']>;
  bhp3?: Maybe<Scalars['numeric']['output']>;
  bhp4?: Maybe<Scalars['numeric']['output']>;
  bhp5?: Maybe<Scalars['numeric']['output']>;
  bhpb?: Maybe<Scalars['numeric']['output']>;
  compression_thrust_per_stage?: Maybe<Scalars['numeric']['output']>;
  construction?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  h1?: Maybe<Scalars['numeric']['output']>;
  h2?: Maybe<Scalars['numeric']['output']>;
  h3?: Maybe<Scalars['numeric']['output']>;
  h4?: Maybe<Scalars['numeric']['output']>;
  h5?: Maybe<Scalars['numeric']['output']>;
  hb?: Maybe<Scalars['numeric']['output']>;
  high_strength_housing_pressure_rating_psi?: Maybe<Scalars['Int']['output']>;
  high_strength_shaft_rating_hp?: Maybe<Scalars['Int']['output']>;
  housing_inner_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  housing_outer_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  imported_sizing_id?: Maybe<Scalars['Int']['output']>;
  include_ecopetrol_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  include_koc_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  manufacturer?: Maybe<Scalars['String']['output']>;
  max_bolt_load_pounds?: Maybe<Scalars['numeric']['output']>;
  max_graph_rate_standard_pump_bpd?: Maybe<Scalars['Int']['output']>;
  max_rate_standard_pump_bpd?: Maybe<Scalars['Int']['output']>;
  min_rate_standard_pump_bpd?: Maybe<Scalars['Int']['output']>;
  neck_inner_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  neck_outer_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  npsh1?: Maybe<Scalars['numeric']['output']>;
  npsh2?: Maybe<Scalars['numeric']['output']>;
  npsh3?: Maybe<Scalars['numeric']['output']>;
  npsh4?: Maybe<Scalars['numeric']['output']>;
  only_ecopetrol_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  only_koc_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  part_number?: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "prioritizepumpmanufacturer" */
  prioritized_manufacturer?: Maybe<Scalars['String']['output']>;
  rotation?: Maybe<Scalars['String']['output']>;
  series_model?: Maybe<Scalars['String']['output']>;
  shaft_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  stage_type?: Maybe<Scalars['Int']['output']>;
  standard_housing_pressure_rating_psi?: Maybe<Scalars['Int']['output']>;
  standard_shaft_rating_hp?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "pumps" */
export type Pumps_Min_Order_By = {
  author_id?: InputMaybe<Order_By>;
  bep_rate_standard_pump_bpd?: InputMaybe<Order_By>;
  bhp1?: InputMaybe<Order_By>;
  bhp2?: InputMaybe<Order_By>;
  bhp3?: InputMaybe<Order_By>;
  bhp4?: InputMaybe<Order_By>;
  bhp5?: InputMaybe<Order_By>;
  bhpb?: InputMaybe<Order_By>;
  compression_thrust_per_stage?: InputMaybe<Order_By>;
  construction?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  h1?: InputMaybe<Order_By>;
  h2?: InputMaybe<Order_By>;
  h3?: InputMaybe<Order_By>;
  h4?: InputMaybe<Order_By>;
  h5?: InputMaybe<Order_By>;
  hb?: InputMaybe<Order_By>;
  high_strength_housing_pressure_rating_psi?: InputMaybe<Order_By>;
  high_strength_shaft_rating_hp?: InputMaybe<Order_By>;
  housing_inner_diameter_inches?: InputMaybe<Order_By>;
  housing_outer_diameter_inches?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  include_ecopetrol_timestamp?: InputMaybe<Order_By>;
  include_koc_timestamp?: InputMaybe<Order_By>;
  manufacturer?: InputMaybe<Order_By>;
  max_bolt_load_pounds?: InputMaybe<Order_By>;
  max_graph_rate_standard_pump_bpd?: InputMaybe<Order_By>;
  max_rate_standard_pump_bpd?: InputMaybe<Order_By>;
  min_rate_standard_pump_bpd?: InputMaybe<Order_By>;
  neck_inner_diameter_inches?: InputMaybe<Order_By>;
  neck_outer_diameter_inches?: InputMaybe<Order_By>;
  npsh1?: InputMaybe<Order_By>;
  npsh2?: InputMaybe<Order_By>;
  npsh3?: InputMaybe<Order_By>;
  npsh4?: InputMaybe<Order_By>;
  only_ecopetrol_timestamp?: InputMaybe<Order_By>;
  only_koc_timestamp?: InputMaybe<Order_By>;
  part_number?: InputMaybe<Order_By>;
  rotation?: InputMaybe<Order_By>;
  series_model?: InputMaybe<Order_By>;
  shaft_diameter_inches?: InputMaybe<Order_By>;
  stage_type?: InputMaybe<Order_By>;
  standard_housing_pressure_rating_psi?: InputMaybe<Order_By>;
  standard_shaft_rating_hp?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "pumps" */
export type Pumps_Mutation_Response = {
  __typename: 'pumps_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Pumps>;
};

/** input type for inserting object relation for remote table "pumps" */
export type Pumps_Obj_Rel_Insert_Input = {
  data: Pumps_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Pumps_On_Conflict>;
};

/** on_conflict condition type for table "pumps" */
export type Pumps_On_Conflict = {
  constraint: Pumps_Constraint;
  update_columns?: Array<Pumps_Update_Column>;
  where?: InputMaybe<Pumps_Bool_Exp>;
};

/** Ordering options when selecting data from "pumps". */
export type Pumps_Order_By = {
  author_id?: InputMaybe<Order_By>;
  bep_rate_standard_pump_bpd?: InputMaybe<Order_By>;
  bhp1?: InputMaybe<Order_By>;
  bhp2?: InputMaybe<Order_By>;
  bhp3?: InputMaybe<Order_By>;
  bhp4?: InputMaybe<Order_By>;
  bhp5?: InputMaybe<Order_By>;
  bhpb?: InputMaybe<Order_By>;
  compression_thrust_per_stage?: InputMaybe<Order_By>;
  construction?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  h1?: InputMaybe<Order_By>;
  h2?: InputMaybe<Order_By>;
  h3?: InputMaybe<Order_By>;
  h4?: InputMaybe<Order_By>;
  h5?: InputMaybe<Order_By>;
  hb?: InputMaybe<Order_By>;
  high_strength_housing_pressure_rating_psi?: InputMaybe<Order_By>;
  high_strength_shaft_rating_hp?: InputMaybe<Order_By>;
  housing_inner_diameter_inches?: InputMaybe<Order_By>;
  housing_outer_diameter_inches?: InputMaybe<Order_By>;
  housings_aggregate?: InputMaybe<Housings_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  include_ecopetrol_timestamp?: InputMaybe<Order_By>;
  include_koc_timestamp?: InputMaybe<Order_By>;
  is_compression_pump?: InputMaybe<Order_By>;
  manufacturer?: InputMaybe<Order_By>;
  max_bolt_load_pounds?: InputMaybe<Order_By>;
  max_graph_rate_standard_pump_bpd?: InputMaybe<Order_By>;
  max_rate_standard_pump_bpd?: InputMaybe<Order_By>;
  min_rate_standard_pump_bpd?: InputMaybe<Order_By>;
  neck_inner_diameter_inches?: InputMaybe<Order_By>;
  neck_outer_diameter_inches?: InputMaybe<Order_By>;
  npsh1?: InputMaybe<Order_By>;
  npsh2?: InputMaybe<Order_By>;
  npsh3?: InputMaybe<Order_By>;
  npsh4?: InputMaybe<Order_By>;
  only_ecopetrol_timestamp?: InputMaybe<Order_By>;
  only_koc_timestamp?: InputMaybe<Order_By>;
  part_number?: InputMaybe<Order_By>;
  prioritized_manufacturer?: InputMaybe<Order_By>;
  rotation?: InputMaybe<Order_By>;
  series_model?: InputMaybe<Order_By>;
  shaft_diameter_inches?: InputMaybe<Order_By>;
  sizing_import?: InputMaybe<Sizing_Imports_Order_By>;
  stage_type?: InputMaybe<Order_By>;
  standard_housing_pressure_rating_psi?: InputMaybe<Order_By>;
  standard_shaft_rating_hp?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
};

/** primary key columns input for table: pumps */
export type Pumps_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "pumps" */
export enum Pumps_Select_Column {
  /** column name */
  AuthorId = 'author_id',
  /** column name */
  BepRateStandardPumpBpd = 'bep_rate_standard_pump_bpd',
  /** column name */
  Bhp1 = 'bhp1',
  /** column name */
  Bhp2 = 'bhp2',
  /** column name */
  Bhp3 = 'bhp3',
  /** column name */
  Bhp4 = 'bhp4',
  /** column name */
  Bhp5 = 'bhp5',
  /** column name */
  Bhpb = 'bhpb',
  /** column name */
  CompressionThrustPerStage = 'compression_thrust_per_stage',
  /** column name */
  Construction = 'construction',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  H1 = 'h1',
  /** column name */
  H2 = 'h2',
  /** column name */
  H3 = 'h3',
  /** column name */
  H4 = 'h4',
  /** column name */
  H5 = 'h5',
  /** column name */
  Hb = 'hb',
  /** column name */
  HighStrengthHousingPressureRatingPsi = 'high_strength_housing_pressure_rating_psi',
  /** column name */
  HighStrengthShaftRatingHp = 'high_strength_shaft_rating_hp',
  /** column name */
  HousingInnerDiameterInches = 'housing_inner_diameter_inches',
  /** column name */
  HousingOuterDiameterInches = 'housing_outer_diameter_inches',
  /** column name */
  Id = 'id',
  /** column name */
  ImportedSizingId = 'imported_sizing_id',
  /** column name */
  IncludeEcopetrolTimestamp = 'include_ecopetrol_timestamp',
  /** column name */
  IncludeKocTimestamp = 'include_koc_timestamp',
  /** column name */
  IsCompressionPump = 'is_compression_pump',
  /** column name */
  Manufacturer = 'manufacturer',
  /** column name */
  MaxBoltLoadPounds = 'max_bolt_load_pounds',
  /** column name */
  MaxGraphRateStandardPumpBpd = 'max_graph_rate_standard_pump_bpd',
  /** column name */
  MaxRateStandardPumpBpd = 'max_rate_standard_pump_bpd',
  /** column name */
  MinRateStandardPumpBpd = 'min_rate_standard_pump_bpd',
  /** column name */
  NeckInnerDiameterInches = 'neck_inner_diameter_inches',
  /** column name */
  NeckOuterDiameterInches = 'neck_outer_diameter_inches',
  /** column name */
  Npsh1 = 'npsh1',
  /** column name */
  Npsh2 = 'npsh2',
  /** column name */
  Npsh3 = 'npsh3',
  /** column name */
  Npsh4 = 'npsh4',
  /** column name */
  OnlyEcopetrolTimestamp = 'only_ecopetrol_timestamp',
  /** column name */
  OnlyKocTimestamp = 'only_koc_timestamp',
  /** column name */
  PartNumber = 'part_number',
  /** column name */
  Rotation = 'rotation',
  /** column name */
  SeriesModel = 'series_model',
  /** column name */
  ShaftDiameterInches = 'shaft_diameter_inches',
  /** column name */
  StageType = 'stage_type',
  /** column name */
  StandardHousingPressureRatingPsi = 'standard_housing_pressure_rating_psi',
  /** column name */
  StandardShaftRatingHp = 'standard_shaft_rating_hp',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** select "pumps_aggregate_bool_exp_bool_and_arguments_columns" columns of table "pumps" */
export enum Pumps_Select_Column_Pumps_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsCompressionPump = 'is_compression_pump'
}

/** select "pumps_aggregate_bool_exp_bool_or_arguments_columns" columns of table "pumps" */
export enum Pumps_Select_Column_Pumps_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsCompressionPump = 'is_compression_pump'
}

/** input type for updating data in table "pumps" */
export type Pumps_Set_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  bep_rate_standard_pump_bpd?: InputMaybe<Scalars['Int']['input']>;
  bhp1?: InputMaybe<Scalars['numeric']['input']>;
  bhp2?: InputMaybe<Scalars['numeric']['input']>;
  bhp3?: InputMaybe<Scalars['numeric']['input']>;
  bhp4?: InputMaybe<Scalars['numeric']['input']>;
  bhp5?: InputMaybe<Scalars['numeric']['input']>;
  bhpb?: InputMaybe<Scalars['numeric']['input']>;
  compression_thrust_per_stage?: InputMaybe<Scalars['numeric']['input']>;
  construction?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  h1?: InputMaybe<Scalars['numeric']['input']>;
  h2?: InputMaybe<Scalars['numeric']['input']>;
  h3?: InputMaybe<Scalars['numeric']['input']>;
  h4?: InputMaybe<Scalars['numeric']['input']>;
  h5?: InputMaybe<Scalars['numeric']['input']>;
  hb?: InputMaybe<Scalars['numeric']['input']>;
  high_strength_housing_pressure_rating_psi?: InputMaybe<Scalars['Int']['input']>;
  high_strength_shaft_rating_hp?: InputMaybe<Scalars['Int']['input']>;
  housing_inner_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  housing_outer_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  imported_sizing_id?: InputMaybe<Scalars['Int']['input']>;
  include_ecopetrol_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  include_koc_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  is_compression_pump?: InputMaybe<Scalars['Boolean']['input']>;
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  max_bolt_load_pounds?: InputMaybe<Scalars['numeric']['input']>;
  max_graph_rate_standard_pump_bpd?: InputMaybe<Scalars['Int']['input']>;
  max_rate_standard_pump_bpd?: InputMaybe<Scalars['Int']['input']>;
  min_rate_standard_pump_bpd?: InputMaybe<Scalars['Int']['input']>;
  neck_inner_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  neck_outer_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  npsh1?: InputMaybe<Scalars['numeric']['input']>;
  npsh2?: InputMaybe<Scalars['numeric']['input']>;
  npsh3?: InputMaybe<Scalars['numeric']['input']>;
  npsh4?: InputMaybe<Scalars['numeric']['input']>;
  only_ecopetrol_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  only_koc_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  part_number?: InputMaybe<Scalars['String']['input']>;
  rotation?: InputMaybe<Scalars['String']['input']>;
  series_model?: InputMaybe<Scalars['String']['input']>;
  shaft_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  stage_type?: InputMaybe<Scalars['Int']['input']>;
  standard_housing_pressure_rating_psi?: InputMaybe<Scalars['Int']['input']>;
  standard_shaft_rating_hp?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Pumps_Stddev_Fields = {
  __typename: 'pumps_stddev_fields';
  bep_rate_standard_pump_bpd?: Maybe<Scalars['Float']['output']>;
  bhp1?: Maybe<Scalars['Float']['output']>;
  bhp2?: Maybe<Scalars['Float']['output']>;
  bhp3?: Maybe<Scalars['Float']['output']>;
  bhp4?: Maybe<Scalars['Float']['output']>;
  bhp5?: Maybe<Scalars['Float']['output']>;
  bhpb?: Maybe<Scalars['Float']['output']>;
  compression_thrust_per_stage?: Maybe<Scalars['Float']['output']>;
  h1?: Maybe<Scalars['Float']['output']>;
  h2?: Maybe<Scalars['Float']['output']>;
  h3?: Maybe<Scalars['Float']['output']>;
  h4?: Maybe<Scalars['Float']['output']>;
  h5?: Maybe<Scalars['Float']['output']>;
  hb?: Maybe<Scalars['Float']['output']>;
  high_strength_housing_pressure_rating_psi?: Maybe<Scalars['Float']['output']>;
  high_strength_shaft_rating_hp?: Maybe<Scalars['Float']['output']>;
  housing_inner_diameter_inches?: Maybe<Scalars['Float']['output']>;
  housing_outer_diameter_inches?: Maybe<Scalars['Float']['output']>;
  imported_sizing_id?: Maybe<Scalars['Float']['output']>;
  max_bolt_load_pounds?: Maybe<Scalars['Float']['output']>;
  max_graph_rate_standard_pump_bpd?: Maybe<Scalars['Float']['output']>;
  max_rate_standard_pump_bpd?: Maybe<Scalars['Float']['output']>;
  min_rate_standard_pump_bpd?: Maybe<Scalars['Float']['output']>;
  neck_inner_diameter_inches?: Maybe<Scalars['Float']['output']>;
  neck_outer_diameter_inches?: Maybe<Scalars['Float']['output']>;
  npsh1?: Maybe<Scalars['Float']['output']>;
  npsh2?: Maybe<Scalars['Float']['output']>;
  npsh3?: Maybe<Scalars['Float']['output']>;
  npsh4?: Maybe<Scalars['Float']['output']>;
  shaft_diameter_inches?: Maybe<Scalars['Float']['output']>;
  stage_type?: Maybe<Scalars['Float']['output']>;
  standard_housing_pressure_rating_psi?: Maybe<Scalars['Float']['output']>;
  standard_shaft_rating_hp?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "pumps" */
export type Pumps_Stddev_Order_By = {
  bep_rate_standard_pump_bpd?: InputMaybe<Order_By>;
  bhp1?: InputMaybe<Order_By>;
  bhp2?: InputMaybe<Order_By>;
  bhp3?: InputMaybe<Order_By>;
  bhp4?: InputMaybe<Order_By>;
  bhp5?: InputMaybe<Order_By>;
  bhpb?: InputMaybe<Order_By>;
  compression_thrust_per_stage?: InputMaybe<Order_By>;
  h1?: InputMaybe<Order_By>;
  h2?: InputMaybe<Order_By>;
  h3?: InputMaybe<Order_By>;
  h4?: InputMaybe<Order_By>;
  h5?: InputMaybe<Order_By>;
  hb?: InputMaybe<Order_By>;
  high_strength_housing_pressure_rating_psi?: InputMaybe<Order_By>;
  high_strength_shaft_rating_hp?: InputMaybe<Order_By>;
  housing_inner_diameter_inches?: InputMaybe<Order_By>;
  housing_outer_diameter_inches?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  max_bolt_load_pounds?: InputMaybe<Order_By>;
  max_graph_rate_standard_pump_bpd?: InputMaybe<Order_By>;
  max_rate_standard_pump_bpd?: InputMaybe<Order_By>;
  min_rate_standard_pump_bpd?: InputMaybe<Order_By>;
  neck_inner_diameter_inches?: InputMaybe<Order_By>;
  neck_outer_diameter_inches?: InputMaybe<Order_By>;
  npsh1?: InputMaybe<Order_By>;
  npsh2?: InputMaybe<Order_By>;
  npsh3?: InputMaybe<Order_By>;
  npsh4?: InputMaybe<Order_By>;
  shaft_diameter_inches?: InputMaybe<Order_By>;
  stage_type?: InputMaybe<Order_By>;
  standard_housing_pressure_rating_psi?: InputMaybe<Order_By>;
  standard_shaft_rating_hp?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Pumps_Stddev_Pop_Fields = {
  __typename: 'pumps_stddev_pop_fields';
  bep_rate_standard_pump_bpd?: Maybe<Scalars['Float']['output']>;
  bhp1?: Maybe<Scalars['Float']['output']>;
  bhp2?: Maybe<Scalars['Float']['output']>;
  bhp3?: Maybe<Scalars['Float']['output']>;
  bhp4?: Maybe<Scalars['Float']['output']>;
  bhp5?: Maybe<Scalars['Float']['output']>;
  bhpb?: Maybe<Scalars['Float']['output']>;
  compression_thrust_per_stage?: Maybe<Scalars['Float']['output']>;
  h1?: Maybe<Scalars['Float']['output']>;
  h2?: Maybe<Scalars['Float']['output']>;
  h3?: Maybe<Scalars['Float']['output']>;
  h4?: Maybe<Scalars['Float']['output']>;
  h5?: Maybe<Scalars['Float']['output']>;
  hb?: Maybe<Scalars['Float']['output']>;
  high_strength_housing_pressure_rating_psi?: Maybe<Scalars['Float']['output']>;
  high_strength_shaft_rating_hp?: Maybe<Scalars['Float']['output']>;
  housing_inner_diameter_inches?: Maybe<Scalars['Float']['output']>;
  housing_outer_diameter_inches?: Maybe<Scalars['Float']['output']>;
  imported_sizing_id?: Maybe<Scalars['Float']['output']>;
  max_bolt_load_pounds?: Maybe<Scalars['Float']['output']>;
  max_graph_rate_standard_pump_bpd?: Maybe<Scalars['Float']['output']>;
  max_rate_standard_pump_bpd?: Maybe<Scalars['Float']['output']>;
  min_rate_standard_pump_bpd?: Maybe<Scalars['Float']['output']>;
  neck_inner_diameter_inches?: Maybe<Scalars['Float']['output']>;
  neck_outer_diameter_inches?: Maybe<Scalars['Float']['output']>;
  npsh1?: Maybe<Scalars['Float']['output']>;
  npsh2?: Maybe<Scalars['Float']['output']>;
  npsh3?: Maybe<Scalars['Float']['output']>;
  npsh4?: Maybe<Scalars['Float']['output']>;
  shaft_diameter_inches?: Maybe<Scalars['Float']['output']>;
  stage_type?: Maybe<Scalars['Float']['output']>;
  standard_housing_pressure_rating_psi?: Maybe<Scalars['Float']['output']>;
  standard_shaft_rating_hp?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "pumps" */
export type Pumps_Stddev_Pop_Order_By = {
  bep_rate_standard_pump_bpd?: InputMaybe<Order_By>;
  bhp1?: InputMaybe<Order_By>;
  bhp2?: InputMaybe<Order_By>;
  bhp3?: InputMaybe<Order_By>;
  bhp4?: InputMaybe<Order_By>;
  bhp5?: InputMaybe<Order_By>;
  bhpb?: InputMaybe<Order_By>;
  compression_thrust_per_stage?: InputMaybe<Order_By>;
  h1?: InputMaybe<Order_By>;
  h2?: InputMaybe<Order_By>;
  h3?: InputMaybe<Order_By>;
  h4?: InputMaybe<Order_By>;
  h5?: InputMaybe<Order_By>;
  hb?: InputMaybe<Order_By>;
  high_strength_housing_pressure_rating_psi?: InputMaybe<Order_By>;
  high_strength_shaft_rating_hp?: InputMaybe<Order_By>;
  housing_inner_diameter_inches?: InputMaybe<Order_By>;
  housing_outer_diameter_inches?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  max_bolt_load_pounds?: InputMaybe<Order_By>;
  max_graph_rate_standard_pump_bpd?: InputMaybe<Order_By>;
  max_rate_standard_pump_bpd?: InputMaybe<Order_By>;
  min_rate_standard_pump_bpd?: InputMaybe<Order_By>;
  neck_inner_diameter_inches?: InputMaybe<Order_By>;
  neck_outer_diameter_inches?: InputMaybe<Order_By>;
  npsh1?: InputMaybe<Order_By>;
  npsh2?: InputMaybe<Order_By>;
  npsh3?: InputMaybe<Order_By>;
  npsh4?: InputMaybe<Order_By>;
  shaft_diameter_inches?: InputMaybe<Order_By>;
  stage_type?: InputMaybe<Order_By>;
  standard_housing_pressure_rating_psi?: InputMaybe<Order_By>;
  standard_shaft_rating_hp?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Pumps_Stddev_Samp_Fields = {
  __typename: 'pumps_stddev_samp_fields';
  bep_rate_standard_pump_bpd?: Maybe<Scalars['Float']['output']>;
  bhp1?: Maybe<Scalars['Float']['output']>;
  bhp2?: Maybe<Scalars['Float']['output']>;
  bhp3?: Maybe<Scalars['Float']['output']>;
  bhp4?: Maybe<Scalars['Float']['output']>;
  bhp5?: Maybe<Scalars['Float']['output']>;
  bhpb?: Maybe<Scalars['Float']['output']>;
  compression_thrust_per_stage?: Maybe<Scalars['Float']['output']>;
  h1?: Maybe<Scalars['Float']['output']>;
  h2?: Maybe<Scalars['Float']['output']>;
  h3?: Maybe<Scalars['Float']['output']>;
  h4?: Maybe<Scalars['Float']['output']>;
  h5?: Maybe<Scalars['Float']['output']>;
  hb?: Maybe<Scalars['Float']['output']>;
  high_strength_housing_pressure_rating_psi?: Maybe<Scalars['Float']['output']>;
  high_strength_shaft_rating_hp?: Maybe<Scalars['Float']['output']>;
  housing_inner_diameter_inches?: Maybe<Scalars['Float']['output']>;
  housing_outer_diameter_inches?: Maybe<Scalars['Float']['output']>;
  imported_sizing_id?: Maybe<Scalars['Float']['output']>;
  max_bolt_load_pounds?: Maybe<Scalars['Float']['output']>;
  max_graph_rate_standard_pump_bpd?: Maybe<Scalars['Float']['output']>;
  max_rate_standard_pump_bpd?: Maybe<Scalars['Float']['output']>;
  min_rate_standard_pump_bpd?: Maybe<Scalars['Float']['output']>;
  neck_inner_diameter_inches?: Maybe<Scalars['Float']['output']>;
  neck_outer_diameter_inches?: Maybe<Scalars['Float']['output']>;
  npsh1?: Maybe<Scalars['Float']['output']>;
  npsh2?: Maybe<Scalars['Float']['output']>;
  npsh3?: Maybe<Scalars['Float']['output']>;
  npsh4?: Maybe<Scalars['Float']['output']>;
  shaft_diameter_inches?: Maybe<Scalars['Float']['output']>;
  stage_type?: Maybe<Scalars['Float']['output']>;
  standard_housing_pressure_rating_psi?: Maybe<Scalars['Float']['output']>;
  standard_shaft_rating_hp?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "pumps" */
export type Pumps_Stddev_Samp_Order_By = {
  bep_rate_standard_pump_bpd?: InputMaybe<Order_By>;
  bhp1?: InputMaybe<Order_By>;
  bhp2?: InputMaybe<Order_By>;
  bhp3?: InputMaybe<Order_By>;
  bhp4?: InputMaybe<Order_By>;
  bhp5?: InputMaybe<Order_By>;
  bhpb?: InputMaybe<Order_By>;
  compression_thrust_per_stage?: InputMaybe<Order_By>;
  h1?: InputMaybe<Order_By>;
  h2?: InputMaybe<Order_By>;
  h3?: InputMaybe<Order_By>;
  h4?: InputMaybe<Order_By>;
  h5?: InputMaybe<Order_By>;
  hb?: InputMaybe<Order_By>;
  high_strength_housing_pressure_rating_psi?: InputMaybe<Order_By>;
  high_strength_shaft_rating_hp?: InputMaybe<Order_By>;
  housing_inner_diameter_inches?: InputMaybe<Order_By>;
  housing_outer_diameter_inches?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  max_bolt_load_pounds?: InputMaybe<Order_By>;
  max_graph_rate_standard_pump_bpd?: InputMaybe<Order_By>;
  max_rate_standard_pump_bpd?: InputMaybe<Order_By>;
  min_rate_standard_pump_bpd?: InputMaybe<Order_By>;
  neck_inner_diameter_inches?: InputMaybe<Order_By>;
  neck_outer_diameter_inches?: InputMaybe<Order_By>;
  npsh1?: InputMaybe<Order_By>;
  npsh2?: InputMaybe<Order_By>;
  npsh3?: InputMaybe<Order_By>;
  npsh4?: InputMaybe<Order_By>;
  shaft_diameter_inches?: InputMaybe<Order_By>;
  stage_type?: InputMaybe<Order_By>;
  standard_housing_pressure_rating_psi?: InputMaybe<Order_By>;
  standard_shaft_rating_hp?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "pumps" */
export type Pumps_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Pumps_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Pumps_Stream_Cursor_Value_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  bep_rate_standard_pump_bpd?: InputMaybe<Scalars['Int']['input']>;
  bhp1?: InputMaybe<Scalars['numeric']['input']>;
  bhp2?: InputMaybe<Scalars['numeric']['input']>;
  bhp3?: InputMaybe<Scalars['numeric']['input']>;
  bhp4?: InputMaybe<Scalars['numeric']['input']>;
  bhp5?: InputMaybe<Scalars['numeric']['input']>;
  bhpb?: InputMaybe<Scalars['numeric']['input']>;
  compression_thrust_per_stage?: InputMaybe<Scalars['numeric']['input']>;
  construction?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  h1?: InputMaybe<Scalars['numeric']['input']>;
  h2?: InputMaybe<Scalars['numeric']['input']>;
  h3?: InputMaybe<Scalars['numeric']['input']>;
  h4?: InputMaybe<Scalars['numeric']['input']>;
  h5?: InputMaybe<Scalars['numeric']['input']>;
  hb?: InputMaybe<Scalars['numeric']['input']>;
  high_strength_housing_pressure_rating_psi?: InputMaybe<Scalars['Int']['input']>;
  high_strength_shaft_rating_hp?: InputMaybe<Scalars['Int']['input']>;
  housing_inner_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  housing_outer_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  imported_sizing_id?: InputMaybe<Scalars['Int']['input']>;
  include_ecopetrol_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  include_koc_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  is_compression_pump?: InputMaybe<Scalars['Boolean']['input']>;
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  max_bolt_load_pounds?: InputMaybe<Scalars['numeric']['input']>;
  max_graph_rate_standard_pump_bpd?: InputMaybe<Scalars['Int']['input']>;
  max_rate_standard_pump_bpd?: InputMaybe<Scalars['Int']['input']>;
  min_rate_standard_pump_bpd?: InputMaybe<Scalars['Int']['input']>;
  neck_inner_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  neck_outer_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  npsh1?: InputMaybe<Scalars['numeric']['input']>;
  npsh2?: InputMaybe<Scalars['numeric']['input']>;
  npsh3?: InputMaybe<Scalars['numeric']['input']>;
  npsh4?: InputMaybe<Scalars['numeric']['input']>;
  only_ecopetrol_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  only_koc_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  part_number?: InputMaybe<Scalars['String']['input']>;
  rotation?: InputMaybe<Scalars['String']['input']>;
  series_model?: InputMaybe<Scalars['String']['input']>;
  shaft_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  stage_type?: InputMaybe<Scalars['Int']['input']>;
  standard_housing_pressure_rating_psi?: InputMaybe<Scalars['Int']['input']>;
  standard_shaft_rating_hp?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Pumps_Sum_Fields = {
  __typename: 'pumps_sum_fields';
  bep_rate_standard_pump_bpd?: Maybe<Scalars['Int']['output']>;
  bhp1?: Maybe<Scalars['numeric']['output']>;
  bhp2?: Maybe<Scalars['numeric']['output']>;
  bhp3?: Maybe<Scalars['numeric']['output']>;
  bhp4?: Maybe<Scalars['numeric']['output']>;
  bhp5?: Maybe<Scalars['numeric']['output']>;
  bhpb?: Maybe<Scalars['numeric']['output']>;
  compression_thrust_per_stage?: Maybe<Scalars['numeric']['output']>;
  h1?: Maybe<Scalars['numeric']['output']>;
  h2?: Maybe<Scalars['numeric']['output']>;
  h3?: Maybe<Scalars['numeric']['output']>;
  h4?: Maybe<Scalars['numeric']['output']>;
  h5?: Maybe<Scalars['numeric']['output']>;
  hb?: Maybe<Scalars['numeric']['output']>;
  high_strength_housing_pressure_rating_psi?: Maybe<Scalars['Int']['output']>;
  high_strength_shaft_rating_hp?: Maybe<Scalars['Int']['output']>;
  housing_inner_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  housing_outer_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  imported_sizing_id?: Maybe<Scalars['Int']['output']>;
  max_bolt_load_pounds?: Maybe<Scalars['numeric']['output']>;
  max_graph_rate_standard_pump_bpd?: Maybe<Scalars['Int']['output']>;
  max_rate_standard_pump_bpd?: Maybe<Scalars['Int']['output']>;
  min_rate_standard_pump_bpd?: Maybe<Scalars['Int']['output']>;
  neck_inner_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  neck_outer_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  npsh1?: Maybe<Scalars['numeric']['output']>;
  npsh2?: Maybe<Scalars['numeric']['output']>;
  npsh3?: Maybe<Scalars['numeric']['output']>;
  npsh4?: Maybe<Scalars['numeric']['output']>;
  shaft_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  stage_type?: Maybe<Scalars['Int']['output']>;
  standard_housing_pressure_rating_psi?: Maybe<Scalars['Int']['output']>;
  standard_shaft_rating_hp?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "pumps" */
export type Pumps_Sum_Order_By = {
  bep_rate_standard_pump_bpd?: InputMaybe<Order_By>;
  bhp1?: InputMaybe<Order_By>;
  bhp2?: InputMaybe<Order_By>;
  bhp3?: InputMaybe<Order_By>;
  bhp4?: InputMaybe<Order_By>;
  bhp5?: InputMaybe<Order_By>;
  bhpb?: InputMaybe<Order_By>;
  compression_thrust_per_stage?: InputMaybe<Order_By>;
  h1?: InputMaybe<Order_By>;
  h2?: InputMaybe<Order_By>;
  h3?: InputMaybe<Order_By>;
  h4?: InputMaybe<Order_By>;
  h5?: InputMaybe<Order_By>;
  hb?: InputMaybe<Order_By>;
  high_strength_housing_pressure_rating_psi?: InputMaybe<Order_By>;
  high_strength_shaft_rating_hp?: InputMaybe<Order_By>;
  housing_inner_diameter_inches?: InputMaybe<Order_By>;
  housing_outer_diameter_inches?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  max_bolt_load_pounds?: InputMaybe<Order_By>;
  max_graph_rate_standard_pump_bpd?: InputMaybe<Order_By>;
  max_rate_standard_pump_bpd?: InputMaybe<Order_By>;
  min_rate_standard_pump_bpd?: InputMaybe<Order_By>;
  neck_inner_diameter_inches?: InputMaybe<Order_By>;
  neck_outer_diameter_inches?: InputMaybe<Order_By>;
  npsh1?: InputMaybe<Order_By>;
  npsh2?: InputMaybe<Order_By>;
  npsh3?: InputMaybe<Order_By>;
  npsh4?: InputMaybe<Order_By>;
  shaft_diameter_inches?: InputMaybe<Order_By>;
  stage_type?: InputMaybe<Order_By>;
  standard_housing_pressure_rating_psi?: InputMaybe<Order_By>;
  standard_shaft_rating_hp?: InputMaybe<Order_By>;
};

/** update columns of table "pumps" */
export enum Pumps_Update_Column {
  /** column name */
  AuthorId = 'author_id',
  /** column name */
  BepRateStandardPumpBpd = 'bep_rate_standard_pump_bpd',
  /** column name */
  Bhp1 = 'bhp1',
  /** column name */
  Bhp2 = 'bhp2',
  /** column name */
  Bhp3 = 'bhp3',
  /** column name */
  Bhp4 = 'bhp4',
  /** column name */
  Bhp5 = 'bhp5',
  /** column name */
  Bhpb = 'bhpb',
  /** column name */
  CompressionThrustPerStage = 'compression_thrust_per_stage',
  /** column name */
  Construction = 'construction',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  H1 = 'h1',
  /** column name */
  H2 = 'h2',
  /** column name */
  H3 = 'h3',
  /** column name */
  H4 = 'h4',
  /** column name */
  H5 = 'h5',
  /** column name */
  Hb = 'hb',
  /** column name */
  HighStrengthHousingPressureRatingPsi = 'high_strength_housing_pressure_rating_psi',
  /** column name */
  HighStrengthShaftRatingHp = 'high_strength_shaft_rating_hp',
  /** column name */
  HousingInnerDiameterInches = 'housing_inner_diameter_inches',
  /** column name */
  HousingOuterDiameterInches = 'housing_outer_diameter_inches',
  /** column name */
  Id = 'id',
  /** column name */
  ImportedSizingId = 'imported_sizing_id',
  /** column name */
  IncludeEcopetrolTimestamp = 'include_ecopetrol_timestamp',
  /** column name */
  IncludeKocTimestamp = 'include_koc_timestamp',
  /** column name */
  IsCompressionPump = 'is_compression_pump',
  /** column name */
  Manufacturer = 'manufacturer',
  /** column name */
  MaxBoltLoadPounds = 'max_bolt_load_pounds',
  /** column name */
  MaxGraphRateStandardPumpBpd = 'max_graph_rate_standard_pump_bpd',
  /** column name */
  MaxRateStandardPumpBpd = 'max_rate_standard_pump_bpd',
  /** column name */
  MinRateStandardPumpBpd = 'min_rate_standard_pump_bpd',
  /** column name */
  NeckInnerDiameterInches = 'neck_inner_diameter_inches',
  /** column name */
  NeckOuterDiameterInches = 'neck_outer_diameter_inches',
  /** column name */
  Npsh1 = 'npsh1',
  /** column name */
  Npsh2 = 'npsh2',
  /** column name */
  Npsh3 = 'npsh3',
  /** column name */
  Npsh4 = 'npsh4',
  /** column name */
  OnlyEcopetrolTimestamp = 'only_ecopetrol_timestamp',
  /** column name */
  OnlyKocTimestamp = 'only_koc_timestamp',
  /** column name */
  PartNumber = 'part_number',
  /** column name */
  Rotation = 'rotation',
  /** column name */
  SeriesModel = 'series_model',
  /** column name */
  ShaftDiameterInches = 'shaft_diameter_inches',
  /** column name */
  StageType = 'stage_type',
  /** column name */
  StandardHousingPressureRatingPsi = 'standard_housing_pressure_rating_psi',
  /** column name */
  StandardShaftRatingHp = 'standard_shaft_rating_hp',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Pumps_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Pumps_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Pumps_Set_Input>;
  /** filter the rows which have to be updated */
  where: Pumps_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Pumps_Var_Pop_Fields = {
  __typename: 'pumps_var_pop_fields';
  bep_rate_standard_pump_bpd?: Maybe<Scalars['Float']['output']>;
  bhp1?: Maybe<Scalars['Float']['output']>;
  bhp2?: Maybe<Scalars['Float']['output']>;
  bhp3?: Maybe<Scalars['Float']['output']>;
  bhp4?: Maybe<Scalars['Float']['output']>;
  bhp5?: Maybe<Scalars['Float']['output']>;
  bhpb?: Maybe<Scalars['Float']['output']>;
  compression_thrust_per_stage?: Maybe<Scalars['Float']['output']>;
  h1?: Maybe<Scalars['Float']['output']>;
  h2?: Maybe<Scalars['Float']['output']>;
  h3?: Maybe<Scalars['Float']['output']>;
  h4?: Maybe<Scalars['Float']['output']>;
  h5?: Maybe<Scalars['Float']['output']>;
  hb?: Maybe<Scalars['Float']['output']>;
  high_strength_housing_pressure_rating_psi?: Maybe<Scalars['Float']['output']>;
  high_strength_shaft_rating_hp?: Maybe<Scalars['Float']['output']>;
  housing_inner_diameter_inches?: Maybe<Scalars['Float']['output']>;
  housing_outer_diameter_inches?: Maybe<Scalars['Float']['output']>;
  imported_sizing_id?: Maybe<Scalars['Float']['output']>;
  max_bolt_load_pounds?: Maybe<Scalars['Float']['output']>;
  max_graph_rate_standard_pump_bpd?: Maybe<Scalars['Float']['output']>;
  max_rate_standard_pump_bpd?: Maybe<Scalars['Float']['output']>;
  min_rate_standard_pump_bpd?: Maybe<Scalars['Float']['output']>;
  neck_inner_diameter_inches?: Maybe<Scalars['Float']['output']>;
  neck_outer_diameter_inches?: Maybe<Scalars['Float']['output']>;
  npsh1?: Maybe<Scalars['Float']['output']>;
  npsh2?: Maybe<Scalars['Float']['output']>;
  npsh3?: Maybe<Scalars['Float']['output']>;
  npsh4?: Maybe<Scalars['Float']['output']>;
  shaft_diameter_inches?: Maybe<Scalars['Float']['output']>;
  stage_type?: Maybe<Scalars['Float']['output']>;
  standard_housing_pressure_rating_psi?: Maybe<Scalars['Float']['output']>;
  standard_shaft_rating_hp?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "pumps" */
export type Pumps_Var_Pop_Order_By = {
  bep_rate_standard_pump_bpd?: InputMaybe<Order_By>;
  bhp1?: InputMaybe<Order_By>;
  bhp2?: InputMaybe<Order_By>;
  bhp3?: InputMaybe<Order_By>;
  bhp4?: InputMaybe<Order_By>;
  bhp5?: InputMaybe<Order_By>;
  bhpb?: InputMaybe<Order_By>;
  compression_thrust_per_stage?: InputMaybe<Order_By>;
  h1?: InputMaybe<Order_By>;
  h2?: InputMaybe<Order_By>;
  h3?: InputMaybe<Order_By>;
  h4?: InputMaybe<Order_By>;
  h5?: InputMaybe<Order_By>;
  hb?: InputMaybe<Order_By>;
  high_strength_housing_pressure_rating_psi?: InputMaybe<Order_By>;
  high_strength_shaft_rating_hp?: InputMaybe<Order_By>;
  housing_inner_diameter_inches?: InputMaybe<Order_By>;
  housing_outer_diameter_inches?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  max_bolt_load_pounds?: InputMaybe<Order_By>;
  max_graph_rate_standard_pump_bpd?: InputMaybe<Order_By>;
  max_rate_standard_pump_bpd?: InputMaybe<Order_By>;
  min_rate_standard_pump_bpd?: InputMaybe<Order_By>;
  neck_inner_diameter_inches?: InputMaybe<Order_By>;
  neck_outer_diameter_inches?: InputMaybe<Order_By>;
  npsh1?: InputMaybe<Order_By>;
  npsh2?: InputMaybe<Order_By>;
  npsh3?: InputMaybe<Order_By>;
  npsh4?: InputMaybe<Order_By>;
  shaft_diameter_inches?: InputMaybe<Order_By>;
  stage_type?: InputMaybe<Order_By>;
  standard_housing_pressure_rating_psi?: InputMaybe<Order_By>;
  standard_shaft_rating_hp?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Pumps_Var_Samp_Fields = {
  __typename: 'pumps_var_samp_fields';
  bep_rate_standard_pump_bpd?: Maybe<Scalars['Float']['output']>;
  bhp1?: Maybe<Scalars['Float']['output']>;
  bhp2?: Maybe<Scalars['Float']['output']>;
  bhp3?: Maybe<Scalars['Float']['output']>;
  bhp4?: Maybe<Scalars['Float']['output']>;
  bhp5?: Maybe<Scalars['Float']['output']>;
  bhpb?: Maybe<Scalars['Float']['output']>;
  compression_thrust_per_stage?: Maybe<Scalars['Float']['output']>;
  h1?: Maybe<Scalars['Float']['output']>;
  h2?: Maybe<Scalars['Float']['output']>;
  h3?: Maybe<Scalars['Float']['output']>;
  h4?: Maybe<Scalars['Float']['output']>;
  h5?: Maybe<Scalars['Float']['output']>;
  hb?: Maybe<Scalars['Float']['output']>;
  high_strength_housing_pressure_rating_psi?: Maybe<Scalars['Float']['output']>;
  high_strength_shaft_rating_hp?: Maybe<Scalars['Float']['output']>;
  housing_inner_diameter_inches?: Maybe<Scalars['Float']['output']>;
  housing_outer_diameter_inches?: Maybe<Scalars['Float']['output']>;
  imported_sizing_id?: Maybe<Scalars['Float']['output']>;
  max_bolt_load_pounds?: Maybe<Scalars['Float']['output']>;
  max_graph_rate_standard_pump_bpd?: Maybe<Scalars['Float']['output']>;
  max_rate_standard_pump_bpd?: Maybe<Scalars['Float']['output']>;
  min_rate_standard_pump_bpd?: Maybe<Scalars['Float']['output']>;
  neck_inner_diameter_inches?: Maybe<Scalars['Float']['output']>;
  neck_outer_diameter_inches?: Maybe<Scalars['Float']['output']>;
  npsh1?: Maybe<Scalars['Float']['output']>;
  npsh2?: Maybe<Scalars['Float']['output']>;
  npsh3?: Maybe<Scalars['Float']['output']>;
  npsh4?: Maybe<Scalars['Float']['output']>;
  shaft_diameter_inches?: Maybe<Scalars['Float']['output']>;
  stage_type?: Maybe<Scalars['Float']['output']>;
  standard_housing_pressure_rating_psi?: Maybe<Scalars['Float']['output']>;
  standard_shaft_rating_hp?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "pumps" */
export type Pumps_Var_Samp_Order_By = {
  bep_rate_standard_pump_bpd?: InputMaybe<Order_By>;
  bhp1?: InputMaybe<Order_By>;
  bhp2?: InputMaybe<Order_By>;
  bhp3?: InputMaybe<Order_By>;
  bhp4?: InputMaybe<Order_By>;
  bhp5?: InputMaybe<Order_By>;
  bhpb?: InputMaybe<Order_By>;
  compression_thrust_per_stage?: InputMaybe<Order_By>;
  h1?: InputMaybe<Order_By>;
  h2?: InputMaybe<Order_By>;
  h3?: InputMaybe<Order_By>;
  h4?: InputMaybe<Order_By>;
  h5?: InputMaybe<Order_By>;
  hb?: InputMaybe<Order_By>;
  high_strength_housing_pressure_rating_psi?: InputMaybe<Order_By>;
  high_strength_shaft_rating_hp?: InputMaybe<Order_By>;
  housing_inner_diameter_inches?: InputMaybe<Order_By>;
  housing_outer_diameter_inches?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  max_bolt_load_pounds?: InputMaybe<Order_By>;
  max_graph_rate_standard_pump_bpd?: InputMaybe<Order_By>;
  max_rate_standard_pump_bpd?: InputMaybe<Order_By>;
  min_rate_standard_pump_bpd?: InputMaybe<Order_By>;
  neck_inner_diameter_inches?: InputMaybe<Order_By>;
  neck_outer_diameter_inches?: InputMaybe<Order_By>;
  npsh1?: InputMaybe<Order_By>;
  npsh2?: InputMaybe<Order_By>;
  npsh3?: InputMaybe<Order_By>;
  npsh4?: InputMaybe<Order_By>;
  shaft_diameter_inches?: InputMaybe<Order_By>;
  stage_type?: InputMaybe<Order_By>;
  standard_housing_pressure_rating_psi?: InputMaybe<Order_By>;
  standard_shaft_rating_hp?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Pumps_Variance_Fields = {
  __typename: 'pumps_variance_fields';
  bep_rate_standard_pump_bpd?: Maybe<Scalars['Float']['output']>;
  bhp1?: Maybe<Scalars['Float']['output']>;
  bhp2?: Maybe<Scalars['Float']['output']>;
  bhp3?: Maybe<Scalars['Float']['output']>;
  bhp4?: Maybe<Scalars['Float']['output']>;
  bhp5?: Maybe<Scalars['Float']['output']>;
  bhpb?: Maybe<Scalars['Float']['output']>;
  compression_thrust_per_stage?: Maybe<Scalars['Float']['output']>;
  h1?: Maybe<Scalars['Float']['output']>;
  h2?: Maybe<Scalars['Float']['output']>;
  h3?: Maybe<Scalars['Float']['output']>;
  h4?: Maybe<Scalars['Float']['output']>;
  h5?: Maybe<Scalars['Float']['output']>;
  hb?: Maybe<Scalars['Float']['output']>;
  high_strength_housing_pressure_rating_psi?: Maybe<Scalars['Float']['output']>;
  high_strength_shaft_rating_hp?: Maybe<Scalars['Float']['output']>;
  housing_inner_diameter_inches?: Maybe<Scalars['Float']['output']>;
  housing_outer_diameter_inches?: Maybe<Scalars['Float']['output']>;
  imported_sizing_id?: Maybe<Scalars['Float']['output']>;
  max_bolt_load_pounds?: Maybe<Scalars['Float']['output']>;
  max_graph_rate_standard_pump_bpd?: Maybe<Scalars['Float']['output']>;
  max_rate_standard_pump_bpd?: Maybe<Scalars['Float']['output']>;
  min_rate_standard_pump_bpd?: Maybe<Scalars['Float']['output']>;
  neck_inner_diameter_inches?: Maybe<Scalars['Float']['output']>;
  neck_outer_diameter_inches?: Maybe<Scalars['Float']['output']>;
  npsh1?: Maybe<Scalars['Float']['output']>;
  npsh2?: Maybe<Scalars['Float']['output']>;
  npsh3?: Maybe<Scalars['Float']['output']>;
  npsh4?: Maybe<Scalars['Float']['output']>;
  shaft_diameter_inches?: Maybe<Scalars['Float']['output']>;
  stage_type?: Maybe<Scalars['Float']['output']>;
  standard_housing_pressure_rating_psi?: Maybe<Scalars['Float']['output']>;
  standard_shaft_rating_hp?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "pumps" */
export type Pumps_Variance_Order_By = {
  bep_rate_standard_pump_bpd?: InputMaybe<Order_By>;
  bhp1?: InputMaybe<Order_By>;
  bhp2?: InputMaybe<Order_By>;
  bhp3?: InputMaybe<Order_By>;
  bhp4?: InputMaybe<Order_By>;
  bhp5?: InputMaybe<Order_By>;
  bhpb?: InputMaybe<Order_By>;
  compression_thrust_per_stage?: InputMaybe<Order_By>;
  h1?: InputMaybe<Order_By>;
  h2?: InputMaybe<Order_By>;
  h3?: InputMaybe<Order_By>;
  h4?: InputMaybe<Order_By>;
  h5?: InputMaybe<Order_By>;
  hb?: InputMaybe<Order_By>;
  high_strength_housing_pressure_rating_psi?: InputMaybe<Order_By>;
  high_strength_shaft_rating_hp?: InputMaybe<Order_By>;
  housing_inner_diameter_inches?: InputMaybe<Order_By>;
  housing_outer_diameter_inches?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  max_bolt_load_pounds?: InputMaybe<Order_By>;
  max_graph_rate_standard_pump_bpd?: InputMaybe<Order_By>;
  max_rate_standard_pump_bpd?: InputMaybe<Order_By>;
  min_rate_standard_pump_bpd?: InputMaybe<Order_By>;
  neck_inner_diameter_inches?: InputMaybe<Order_By>;
  neck_outer_diameter_inches?: InputMaybe<Order_By>;
  npsh1?: InputMaybe<Order_By>;
  npsh2?: InputMaybe<Order_By>;
  npsh3?: InputMaybe<Order_By>;
  npsh4?: InputMaybe<Order_By>;
  shaft_diameter_inches?: InputMaybe<Order_By>;
  stage_type?: InputMaybe<Order_By>;
  standard_housing_pressure_rating_psi?: InputMaybe<Order_By>;
  standard_shaft_rating_hp?: InputMaybe<Order_By>;
};

export type Query_Root = {
  __typename: 'query_root';
  /** fetch data from the table: "bolt_on_discharges" */
  bolt_on_discharges: Array<Bolt_On_Discharges>;
  /** fetch aggregated fields from the table: "bolt_on_discharges" */
  bolt_on_discharges_aggregate: Bolt_On_Discharges_Aggregate;
  /** fetch data from the table: "bolt_on_discharges" using primary key columns */
  bolt_on_discharges_by_pk?: Maybe<Bolt_On_Discharges>;
  /** fetch data from the table: "bubble_point_options" */
  bubble_point_options: Array<Bubble_Point_Options>;
  /** fetch aggregated fields from the table: "bubble_point_options" */
  bubble_point_options_aggregate: Bubble_Point_Options_Aggregate;
  /** fetch data from the table: "bubble_point_options" using primary key columns */
  bubble_point_options_by_pk?: Maybe<Bubble_Point_Options>;
  /** An array relationship */
  cables: Array<Cables>;
  /** An aggregate relationship */
  cables_aggregate: Cables_Aggregate;
  /** fetch data from the table: "cables" using primary key columns */
  cables_by_pk?: Maybe<Cables>;
  /** fetch data from the table: "casing_flow_options" */
  casing_flow_options: Array<Casing_Flow_Options>;
  /** fetch aggregated fields from the table: "casing_flow_options" */
  casing_flow_options_aggregate: Casing_Flow_Options_Aggregate;
  /** fetch data from the table: "casing_flow_options" using primary key columns */
  casing_flow_options_by_pk?: Maybe<Casing_Flow_Options>;
  /** An array relationship */
  casings: Array<Casings>;
  /** An aggregate relationship */
  casings_aggregate: Casings_Aggregate;
  /** fetch data from the table: "casings" using primary key columns */
  casings_by_pk?: Maybe<Casings>;
  /** fetch data from the table: "casings_type" */
  casings_type: Array<Casings_Type>;
  /** fetch aggregated fields from the table: "casings_type" */
  casings_type_aggregate: Casings_Type_Aggregate;
  /** fetch data from the table: "casings_type" using primary key columns */
  casings_type_by_pk?: Maybe<Casings_Type>;
  /** An array relationship */
  customers: Array<Customers>;
  /** An aggregate relationship */
  customers_aggregate: Customers_Aggregate;
  /** fetch data from the table: "customers" using primary key columns */
  customers_by_pk?: Maybe<Customers>;
  /** fetch data from the table: "dead_oil_options" */
  dead_oil_options: Array<Dead_Oil_Options>;
  /** fetch aggregated fields from the table: "dead_oil_options" */
  dead_oil_options_aggregate: Dead_Oil_Options_Aggregate;
  /** fetch data from the table: "dead_oil_options" using primary key columns */
  dead_oil_options_by_pk?: Maybe<Dead_Oil_Options>;
  /** fetch data from the table: "deviation_survey" */
  deviation_survey: Array<Deviation_Survey>;
  /** fetch aggregated fields from the table: "deviation_survey" */
  deviation_survey_aggregate: Deviation_Survey_Aggregate;
  /** fetch data from the table: "deviation_survey" using primary key columns */
  deviation_survey_by_pk?: Maybe<Deviation_Survey>;
  /** fetch data from the table: "deviation_survey_directional_dataset" */
  deviation_survey_directional_dataset: Array<Deviation_Survey_Directional_Dataset>;
  /** fetch aggregated fields from the table: "deviation_survey_directional_dataset" */
  deviation_survey_directional_dataset_aggregate: Deviation_Survey_Directional_Dataset_Aggregate;
  /** fetch data from the table: "deviation_survey_directional_dataset" using primary key columns */
  deviation_survey_directional_dataset_by_pk?: Maybe<Deviation_Survey_Directional_Dataset>;
  /** fetch data from the table: "display_units" */
  display_units: Array<Display_Units>;
  /** fetch aggregated fields from the table: "display_units" */
  display_units_aggregate: Display_Units_Aggregate;
  /** fetch data from the table: "display_units" using primary key columns */
  display_units_by_pk?: Maybe<Display_Units>;
  /** fetch data from the table: "eula" */
  eula: Array<Eula>;
  /** fetch aggregated fields from the table: "eula" */
  eula_aggregate: Eula_Aggregate;
  /** fetch data from the table: "eula" using primary key columns */
  eula_by_pk?: Maybe<Eula>;
  /** fetch data from the table: "flow_model" */
  flow_model: Array<Flow_Model>;
  /** fetch data from the table: "flow_model_active" */
  flow_model_active: Array<Flow_Model_Active>;
  /** fetch aggregated fields from the table: "flow_model_active" */
  flow_model_active_aggregate: Flow_Model_Active_Aggregate;
  /** fetch aggregated fields from the table: "flow_model" */
  flow_model_aggregate: Flow_Model_Aggregate;
  /** fetch data from the table: "flow_model" using primary key columns */
  flow_model_by_pk?: Maybe<Flow_Model>;
  /** fetch data from the table: "flow_model_deprecated" */
  flow_model_deprecated: Array<Flow_Model_Deprecated>;
  /** fetch aggregated fields from the table: "flow_model_deprecated" */
  flow_model_deprecated_aggregate: Flow_Model_Deprecated_Aggregate;
  /** fetch data from the table: "flow_model_deprecated" using primary key columns */
  flow_model_deprecated_by_pk?: Maybe<Flow_Model_Deprecated>;
  /** fetch data from the table: "friction_loss_options" */
  friction_loss_options: Array<Friction_Loss_Options>;
  /** fetch aggregated fields from the table: "friction_loss_options" */
  friction_loss_options_aggregate: Friction_Loss_Options_Aggregate;
  /** fetch data from the table: "friction_loss_options" using primary key columns */
  friction_loss_options_by_pk?: Maybe<Friction_Loss_Options>;
  /** fetch data from the table: "gas_compressibility_options" */
  gas_compressibility_options: Array<Gas_Compressibility_Options>;
  /** fetch aggregated fields from the table: "gas_compressibility_options" */
  gas_compressibility_options_aggregate: Gas_Compressibility_Options_Aggregate;
  /** fetch data from the table: "gas_compressibility_options" using primary key columns */
  gas_compressibility_options_by_pk?: Maybe<Gas_Compressibility_Options>;
  /** fetch data from the table: "gas_viscosity_options" */
  gas_viscosity_options: Array<Gas_Viscosity_Options>;
  /** fetch aggregated fields from the table: "gas_viscosity_options" */
  gas_viscosity_options_aggregate: Gas_Viscosity_Options_Aggregate;
  /** fetch data from the table: "gas_viscosity_options" using primary key columns */
  gas_viscosity_options_by_pk?: Maybe<Gas_Viscosity_Options>;
  getERPCustomers?: Maybe<Array<Maybe<ErpCustomer>>>;
  getERPWellAddresses?: Maybe<Array<Maybe<ErpWellAddress>>>;
  getErpWellReadings?: Maybe<Array<Maybe<ErpWellReadings>>>;
  getSKBillables?: Maybe<Array<Maybe<SkBillable>>>;
  getSKContracts?: Maybe<Array<Maybe<SkContract>>>;
  getSKCurrencies?: Maybe<Array<Maybe<SkCurrency>>>;
  getSKCustomers?: Maybe<Array<Maybe<SkCustomer>>>;
  getSKEquipmentTypeConversions?: Maybe<Array<Maybe<SkEquipmentTypeConversion>>>;
  getSKJobs?: Maybe<Array<Maybe<SkJob>>>;
  getSKMaterials?: Maybe<Array<Maybe<SkMaterial>>>;
  getSKMaterialsPaginated?: Maybe<SkMaterialsPaginated>;
  /** getSKNwas */
  getSKNwas?: Maybe<Array<Maybe<SkNwa>>>;
  getSKPlanningOrder?: Maybe<Array<Maybe<SkPlanningOrder>>>;
  getSKPlants?: Maybe<Array<Maybe<SkPlant>>>;
  getSKPriceLists?: Maybe<Array<Maybe<SkPriceList>>>;
  getSKWellAddresses?: Maybe<Array<Maybe<SkWellAddress>>>;
  /** An array relationship */
  housings: Array<Housings>;
  /** An aggregate relationship */
  housings_aggregate: Housings_Aggregate;
  /** fetch data from the table: "housings" using primary key columns */
  housings_by_pk?: Maybe<Housings>;
  /** fetch data from the table: "hps_liquid_type" */
  hps_liquid_type: Array<Hps_Liquid_Type>;
  /** fetch aggregated fields from the table: "hps_liquid_type" */
  hps_liquid_type_aggregate: Hps_Liquid_Type_Aggregate;
  /** fetch data from the table: "hps_liquid_type" using primary key columns */
  hps_liquid_type_by_pk?: Maybe<Hps_Liquid_Type>;
  /** An array relationship */
  intakes: Array<Intakes>;
  /** An aggregate relationship */
  intakes_aggregate: Intakes_Aggregate;
  /** fetch data from the table: "intakes" using primary key columns */
  intakes_by_pk?: Maybe<Intakes>;
  /** fetch data from the table: "legacy_users" */
  legacy_users: Array<Legacy_Users>;
  /** fetch aggregated fields from the table: "legacy_users" */
  legacy_users_aggregate: Legacy_Users_Aggregate;
  /** fetch data from the table: "legacy_users" using primary key columns */
  legacy_users_by_pk?: Maybe<Legacy_Users>;
  /** An array relationship */
  motor_lead_extensions: Array<Motor_Lead_Extensions>;
  /** An aggregate relationship */
  motor_lead_extensions_aggregate: Motor_Lead_Extensions_Aggregate;
  /** fetch data from the table: "motor_lead_extensions" using primary key columns */
  motor_lead_extensions_by_pk?: Maybe<Motor_Lead_Extensions>;
  /** An array relationship */
  motors: Array<Motors>;
  /** An aggregate relationship */
  motors_aggregate: Motors_Aggregate;
  /** fetch data from the table: "motors" using primary key columns */
  motors_by_pk?: Maybe<Motors>;
  /** fetch data from the table: "natural_gas_separation_options" */
  natural_gas_separation_options: Array<Natural_Gas_Separation_Options>;
  /** fetch aggregated fields from the table: "natural_gas_separation_options" */
  natural_gas_separation_options_aggregate: Natural_Gas_Separation_Options_Aggregate;
  /** fetch data from the table: "natural_gas_separation_options" using primary key columns */
  natural_gas_separation_options_by_pk?: Maybe<Natural_Gas_Separation_Options>;
  /** fetch data from the table: "oil_density_options" */
  oil_density_options: Array<Oil_Density_Options>;
  /** fetch aggregated fields from the table: "oil_density_options" */
  oil_density_options_aggregate: Oil_Density_Options_Aggregate;
  /** fetch data from the table: "oil_density_options" using primary key columns */
  oil_density_options_by_pk?: Maybe<Oil_Density_Options>;
  /** fetch data from the table: "oil_volume_factor_options" */
  oil_volume_factor_options: Array<Oil_Volume_Factor_Options>;
  /** fetch aggregated fields from the table: "oil_volume_factor_options" */
  oil_volume_factor_options_aggregate: Oil_Volume_Factor_Options_Aggregate;
  /** fetch data from the table: "oil_volume_factor_options" using primary key columns */
  oil_volume_factor_options_by_pk?: Maybe<Oil_Volume_Factor_Options>;
  /** fetch data from the table: "override_options" */
  override_options: Array<Override_Options>;
  /** fetch aggregated fields from the table: "override_options" */
  override_options_aggregate: Override_Options_Aggregate;
  /** fetch data from the table: "override_options" using primary key columns */
  override_options_by_pk?: Maybe<Override_Options>;
  /** An array relationship */
  performance_evaluations: Array<Performance_Evaluations>;
  /** An aggregate relationship */
  performance_evaluations_aggregate: Performance_Evaluations_Aggregate;
  /** fetch data from the table: "performance_evaluations_xref_pumps" */
  performance_evaluations_xref_pumps: Array<Performance_Evaluations_Xref_Pumps>;
  /** fetch aggregated fields from the table: "performance_evaluations_xref_pumps" */
  performance_evaluations_xref_pumps_aggregate: Performance_Evaluations_Xref_Pumps_Aggregate;
  /** An array relationship */
  pumps: Array<Pumps>;
  /** An aggregate relationship */
  pumps_aggregate: Pumps_Aggregate;
  /** fetch data from the table: "pumps" using primary key columns */
  pumps_by_pk?: Maybe<Pumps>;
  /** fetch data from the table: "quote_line_item_category_dataset" */
  quote_line_item_category_dataset: Array<Quote_Line_Item_Category_Dataset>;
  /** fetch aggregated fields from the table: "quote_line_item_category_dataset" */
  quote_line_item_category_dataset_aggregate: Quote_Line_Item_Category_Dataset_Aggregate;
  /** fetch data from the table: "quote_line_item_category_dataset" using primary key columns */
  quote_line_item_category_dataset_by_pk?: Maybe<Quote_Line_Item_Category_Dataset>;
  /** fetch data from the table: "quote_line_item_serialized_dataset" */
  quote_line_item_serialized_dataset: Array<Quote_Line_Item_Serialized_Dataset>;
  /** fetch aggregated fields from the table: "quote_line_item_serialized_dataset" */
  quote_line_item_serialized_dataset_aggregate: Quote_Line_Item_Serialized_Dataset_Aggregate;
  /** fetch data from the table: "quote_line_item_serialized_dataset" using primary key columns */
  quote_line_item_serialized_dataset_by_pk?: Maybe<Quote_Line_Item_Serialized_Dataset>;
  /** fetch data from the table: "quote_line_item_source_dataset" */
  quote_line_item_source_dataset: Array<Quote_Line_Item_Source_Dataset>;
  /** fetch aggregated fields from the table: "quote_line_item_source_dataset" */
  quote_line_item_source_dataset_aggregate: Quote_Line_Item_Source_Dataset_Aggregate;
  /** fetch data from the table: "quote_line_item_source_dataset" using primary key columns */
  quote_line_item_source_dataset_by_pk?: Maybe<Quote_Line_Item_Source_Dataset>;
  /** fetch data from the table: "quote_line_item_subcategory_dataset" */
  quote_line_item_subcategory_dataset: Array<Quote_Line_Item_Subcategory_Dataset>;
  /** fetch aggregated fields from the table: "quote_line_item_subcategory_dataset" */
  quote_line_item_subcategory_dataset_aggregate: Quote_Line_Item_Subcategory_Dataset_Aggregate;
  /** fetch data from the table: "quote_line_item_subcategory_dataset" using primary key columns */
  quote_line_item_subcategory_dataset_by_pk?: Maybe<Quote_Line_Item_Subcategory_Dataset>;
  /** fetch data from the table: "quote_line_item_tax_type_dataset" */
  quote_line_item_tax_type_dataset: Array<Quote_Line_Item_Tax_Type_Dataset>;
  /** fetch aggregated fields from the table: "quote_line_item_tax_type_dataset" */
  quote_line_item_tax_type_dataset_aggregate: Quote_Line_Item_Tax_Type_Dataset_Aggregate;
  /** fetch data from the table: "quote_line_item_tax_type_dataset" using primary key columns */
  quote_line_item_tax_type_dataset_by_pk?: Maybe<Quote_Line_Item_Tax_Type_Dataset>;
  /** fetch data from the table: "quote_line_item_type_dataset" */
  quote_line_item_type_dataset: Array<Quote_Line_Item_Type_Dataset>;
  /** fetch aggregated fields from the table: "quote_line_item_type_dataset" */
  quote_line_item_type_dataset_aggregate: Quote_Line_Item_Type_Dataset_Aggregate;
  /** fetch data from the table: "quote_line_item_type_dataset" using primary key columns */
  quote_line_item_type_dataset_by_pk?: Maybe<Quote_Line_Item_Type_Dataset>;
  /** An array relationship */
  quote_line_items: Array<Quote_Line_Items>;
  /** An aggregate relationship */
  quote_line_items_aggregate: Quote_Line_Items_Aggregate;
  /** fetch data from the table: "quote_line_items" using primary key columns */
  quote_line_items_by_pk?: Maybe<Quote_Line_Items>;
  /** fetch data from the table: "quote_sk_job_type_dataset" */
  quote_sk_job_type_dataset: Array<Quote_Sk_Job_Type_Dataset>;
  /** fetch aggregated fields from the table: "quote_sk_job_type_dataset" */
  quote_sk_job_type_dataset_aggregate: Quote_Sk_Job_Type_Dataset_Aggregate;
  /** fetch data from the table: "quote_sk_job_type_dataset" using primary key columns */
  quote_sk_job_type_dataset_by_pk?: Maybe<Quote_Sk_Job_Type_Dataset>;
  /** fetch data from the table: "quote_source_dataset" */
  quote_source_dataset: Array<Quote_Source_Dataset>;
  /** fetch aggregated fields from the table: "quote_source_dataset" */
  quote_source_dataset_aggregate: Quote_Source_Dataset_Aggregate;
  /** fetch data from the table: "quote_source_dataset" using primary key columns */
  quote_source_dataset_by_pk?: Maybe<Quote_Source_Dataset>;
  /** fetch data from the table: "quote_status_dataset" */
  quote_status_dataset: Array<Quote_Status_Dataset>;
  /** fetch aggregated fields from the table: "quote_status_dataset" */
  quote_status_dataset_aggregate: Quote_Status_Dataset_Aggregate;
  /** fetch data from the table: "quote_status_dataset" using primary key columns */
  quote_status_dataset_by_pk?: Maybe<Quote_Status_Dataset>;
  /** fetch data from the table: "quote_user_messages" */
  quote_user_messages: Array<Quote_User_Messages>;
  /** fetch aggregated fields from the table: "quote_user_messages" */
  quote_user_messages_aggregate: Quote_User_Messages_Aggregate;
  /** fetch data from the table: "quote_user_messages" using primary key columns */
  quote_user_messages_by_pk?: Maybe<Quote_User_Messages>;
  /** An array relationship */
  quotes: Array<Quotes>;
  /** An aggregate relationship */
  quotes_aggregate: Quotes_Aggregate;
  /** fetch data from the table: "quotes" using primary key columns */
  quotes_by_pk?: Maybe<Quotes>;
  /** fetch data from the table: "revisions.performance_evaluations_journal" */
  revisions_performance_evaluations_journal: Array<Revisions_Performance_Evaluations_Journal>;
  /** fetch aggregated fields from the table: "revisions.performance_evaluations_journal" */
  revisions_performance_evaluations_journal_aggregate: Revisions_Performance_Evaluations_Journal_Aggregate;
  /** fetch data from the table: "revisions.performance_evaluations_journal" using primary key columns */
  revisions_performance_evaluations_journal_by_pk?: Maybe<Revisions_Performance_Evaluations_Journal>;
  /** fetch data from the table: "revisions.performance_evaluations_revisions" */
  revisions_performance_evaluations_revisions: Array<Revisions_Performance_Evaluations_Revisions>;
  /** fetch aggregated fields from the table: "revisions.performance_evaluations_revisions" */
  revisions_performance_evaluations_revisions_aggregate: Revisions_Performance_Evaluations_Revisions_Aggregate;
  /** fetch data from the table: "revisions.performance_evaluations_revisions" using primary key columns */
  revisions_performance_evaluations_revisions_by_pk?: Maybe<Revisions_Performance_Evaluations_Revisions>;
  /** fetch data from the table: "revisions.performance_evaluations_xref_pumps_journal" */
  revisions_performance_evaluations_xref_pumps_journal: Array<Revisions_Performance_Evaluations_Xref_Pumps_Journal>;
  /** fetch aggregated fields from the table: "revisions.performance_evaluations_xref_pumps_journal" */
  revisions_performance_evaluations_xref_pumps_journal_aggregate: Revisions_Performance_Evaluations_Xref_Pumps_Journal_Aggregate;
  /** fetch data from the table: "revisions.performance_evaluations_xref_pumps_journal" using primary key columns */
  revisions_performance_evaluations_xref_pumps_journal_by_pk?: Maybe<Revisions_Performance_Evaluations_Xref_Pumps_Journal>;
  /** fetch data from the table: "revisions.performance_evaluations_xref_pumps_revisions" */
  revisions_performance_evaluations_xref_pumps_revisions: Array<Revisions_Performance_Evaluations_Xref_Pumps_Revisions>;
  /** fetch aggregated fields from the table: "revisions.performance_evaluations_xref_pumps_revisions" */
  revisions_performance_evaluations_xref_pumps_revisions_aggregate: Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Aggregate;
  /** fetch data from the table: "revisions.performance_evaluations_xref_pumps_revisions" using primary key columns */
  revisions_performance_evaluations_xref_pumps_revisions_by_pk?: Maybe<Revisions_Performance_Evaluations_Xref_Pumps_Revisions>;
  /** fetch data from the table: "revisions.sc_equip_xref_downhole_ytool_bypass_tubings_journal" */
  revisions_sc_equip_xref_downhole_ytool_bypass_tubings_journal: Array<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal>;
  /** fetch aggregated fields from the table: "revisions.sc_equip_xref_downhole_ytool_bypass_tubings_journal" */
  revisions_sc_equip_xref_downhole_ytool_bypass_tubings_journal_aggregate: Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_Aggregate;
  /** fetch data from the table: "revisions.sc_equip_xref_downhole_ytool_bypass_tubings_journal" using primary key columns */
  revisions_sc_equip_xref_downhole_ytool_bypass_tubings_journal_by_pk?: Maybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal>;
  /** fetch data from the table: "revisions.sc_equip_xref_downhole_ytool_bypass_tubings_revisions" */
  revisions_sc_equip_xref_downhole_ytool_bypass_tubings_revisions: Array<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions>;
  /** fetch aggregated fields from the table: "revisions.sc_equip_xref_downhole_ytool_bypass_tubings_revisions" */
  revisions_sc_equip_xref_downhole_ytool_bypass_tubings_revisions_aggregate: Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Aggregate;
  /** fetch data from the table: "revisions.sc_equip_xref_downhole_ytool_bypass_tubings_revisions" using primary key columns */
  revisions_sc_equip_xref_downhole_ytool_bypass_tubings_revisions_by_pk?: Maybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions>;
  /** fetch data from the table: "revisions.sc_equip_xref_downhole_ytool_equip_tubings_journal" */
  revisions_sc_equip_xref_downhole_ytool_equip_tubings_journal: Array<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal>;
  /** fetch aggregated fields from the table: "revisions.sc_equip_xref_downhole_ytool_equip_tubings_journal" */
  revisions_sc_equip_xref_downhole_ytool_equip_tubings_journal_aggregate: Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_Aggregate;
  /** fetch data from the table: "revisions.sc_equip_xref_downhole_ytool_equip_tubings_journal" using primary key columns */
  revisions_sc_equip_xref_downhole_ytool_equip_tubings_journal_by_pk?: Maybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal>;
  /** fetch data from the table: "revisions.sc_equip_xref_downhole_ytool_equip_tubings_revisions" */
  revisions_sc_equip_xref_downhole_ytool_equip_tubings_revisions: Array<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions>;
  /** fetch aggregated fields from the table: "revisions.sc_equip_xref_downhole_ytool_equip_tubings_revisions" */
  revisions_sc_equip_xref_downhole_ytool_equip_tubings_revisions_aggregate: Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Aggregate;
  /** fetch data from the table: "revisions.sc_equip_xref_downhole_ytool_equip_tubings_revisions" using primary key columns */
  revisions_sc_equip_xref_downhole_ytool_equip_tubings_revisions_by_pk?: Maybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions>;
  /** fetch data from the table: "revisions.sc_equip_xref_uphole_ytool_bypass_tubings_journal" */
  revisions_sc_equip_xref_uphole_ytool_bypass_tubings_journal: Array<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal>;
  /** fetch aggregated fields from the table: "revisions.sc_equip_xref_uphole_ytool_bypass_tubings_journal" */
  revisions_sc_equip_xref_uphole_ytool_bypass_tubings_journal_aggregate: Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_Aggregate;
  /** fetch data from the table: "revisions.sc_equip_xref_uphole_ytool_bypass_tubings_journal" using primary key columns */
  revisions_sc_equip_xref_uphole_ytool_bypass_tubings_journal_by_pk?: Maybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal>;
  /** fetch data from the table: "revisions.sc_equip_xref_uphole_ytool_bypass_tubings_revisions" */
  revisions_sc_equip_xref_uphole_ytool_bypass_tubings_revisions: Array<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions>;
  /** fetch aggregated fields from the table: "revisions.sc_equip_xref_uphole_ytool_bypass_tubings_revisions" */
  revisions_sc_equip_xref_uphole_ytool_bypass_tubings_revisions_aggregate: Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Aggregate;
  /** fetch data from the table: "revisions.sc_equip_xref_uphole_ytool_bypass_tubings_revisions" using primary key columns */
  revisions_sc_equip_xref_uphole_ytool_bypass_tubings_revisions_by_pk?: Maybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions>;
  /** fetch data from the table: "revisions.sc_equip_xref_uphole_ytool_equip_tubings_journal" */
  revisions_sc_equip_xref_uphole_ytool_equip_tubings_journal: Array<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal>;
  /** fetch aggregated fields from the table: "revisions.sc_equip_xref_uphole_ytool_equip_tubings_journal" */
  revisions_sc_equip_xref_uphole_ytool_equip_tubings_journal_aggregate: Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_Aggregate;
  /** fetch data from the table: "revisions.sc_equip_xref_uphole_ytool_equip_tubings_journal" using primary key columns */
  revisions_sc_equip_xref_uphole_ytool_equip_tubings_journal_by_pk?: Maybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal>;
  /** fetch data from the table: "revisions.sc_equip_xref_uphole_ytool_equip_tubings_revisions" */
  revisions_sc_equip_xref_uphole_ytool_equip_tubings_revisions: Array<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions>;
  /** fetch aggregated fields from the table: "revisions.sc_equip_xref_uphole_ytool_equip_tubings_revisions" */
  revisions_sc_equip_xref_uphole_ytool_equip_tubings_revisions_aggregate: Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Aggregate;
  /** fetch data from the table: "revisions.sc_equip_xref_uphole_ytool_equip_tubings_revisions" using primary key columns */
  revisions_sc_equip_xref_uphole_ytool_equip_tubings_revisions_by_pk?: Maybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions>;
  /** fetch data from the table: "revisions.scenario_correlations_journal" */
  revisions_scenario_correlations_journal: Array<Revisions_Scenario_Correlations_Journal>;
  /** fetch aggregated fields from the table: "revisions.scenario_correlations_journal" */
  revisions_scenario_correlations_journal_aggregate: Revisions_Scenario_Correlations_Journal_Aggregate;
  /** fetch data from the table: "revisions.scenario_correlations_journal" using primary key columns */
  revisions_scenario_correlations_journal_by_pk?: Maybe<Revisions_Scenario_Correlations_Journal>;
  /** fetch data from the table: "revisions.scenario_correlations_revisions" */
  revisions_scenario_correlations_revisions: Array<Revisions_Scenario_Correlations_Revisions>;
  /** fetch aggregated fields from the table: "revisions.scenario_correlations_revisions" */
  revisions_scenario_correlations_revisions_aggregate: Revisions_Scenario_Correlations_Revisions_Aggregate;
  /** fetch data from the table: "revisions.scenario_correlations_revisions" using primary key columns */
  revisions_scenario_correlations_revisions_by_pk?: Maybe<Revisions_Scenario_Correlations_Revisions>;
  /** fetch data from the table: "revisions.scenario_equipment_journal" */
  revisions_scenario_equipment_journal: Array<Revisions_Scenario_Equipment_Journal>;
  /** fetch aggregated fields from the table: "revisions.scenario_equipment_journal" */
  revisions_scenario_equipment_journal_aggregate: Revisions_Scenario_Equipment_Journal_Aggregate;
  /** fetch data from the table: "revisions.scenario_equipment_journal" using primary key columns */
  revisions_scenario_equipment_journal_by_pk?: Maybe<Revisions_Scenario_Equipment_Journal>;
  /** fetch data from the table: "revisions.scenario_equipment_revisions" */
  revisions_scenario_equipment_revisions: Array<Revisions_Scenario_Equipment_Revisions>;
  /** fetch aggregated fields from the table: "revisions.scenario_equipment_revisions" */
  revisions_scenario_equipment_revisions_aggregate: Revisions_Scenario_Equipment_Revisions_Aggregate;
  /** fetch data from the table: "revisions.scenario_equipment_revisions" using primary key columns */
  revisions_scenario_equipment_revisions_by_pk?: Maybe<Revisions_Scenario_Equipment_Revisions>;
  /** fetch data from the table: "revisions.scenario_equipment_xref_cables_journal" */
  revisions_scenario_equipment_xref_cables_journal: Array<Revisions_Scenario_Equipment_Xref_Cables_Journal>;
  /** fetch aggregated fields from the table: "revisions.scenario_equipment_xref_cables_journal" */
  revisions_scenario_equipment_xref_cables_journal_aggregate: Revisions_Scenario_Equipment_Xref_Cables_Journal_Aggregate;
  /** fetch data from the table: "revisions.scenario_equipment_xref_cables_journal" using primary key columns */
  revisions_scenario_equipment_xref_cables_journal_by_pk?: Maybe<Revisions_Scenario_Equipment_Xref_Cables_Journal>;
  /** fetch data from the table: "revisions.scenario_equipment_xref_cables_revisions" */
  revisions_scenario_equipment_xref_cables_revisions: Array<Revisions_Scenario_Equipment_Xref_Cables_Revisions>;
  /** fetch aggregated fields from the table: "revisions.scenario_equipment_xref_cables_revisions" */
  revisions_scenario_equipment_xref_cables_revisions_aggregate: Revisions_Scenario_Equipment_Xref_Cables_Revisions_Aggregate;
  /** fetch data from the table: "revisions.scenario_equipment_xref_cables_revisions" using primary key columns */
  revisions_scenario_equipment_xref_cables_revisions_by_pk?: Maybe<Revisions_Scenario_Equipment_Xref_Cables_Revisions>;
  /** fetch data from the table: "revisions.scenario_equipment_xref_housings_journal" */
  revisions_scenario_equipment_xref_housings_journal: Array<Revisions_Scenario_Equipment_Xref_Housings_Journal>;
  /** fetch aggregated fields from the table: "revisions.scenario_equipment_xref_housings_journal" */
  revisions_scenario_equipment_xref_housings_journal_aggregate: Revisions_Scenario_Equipment_Xref_Housings_Journal_Aggregate;
  /** fetch data from the table: "revisions.scenario_equipment_xref_housings_journal" using primary key columns */
  revisions_scenario_equipment_xref_housings_journal_by_pk?: Maybe<Revisions_Scenario_Equipment_Xref_Housings_Journal>;
  /** fetch data from the table: "revisions.scenario_equipment_xref_housings_revisions" */
  revisions_scenario_equipment_xref_housings_revisions: Array<Revisions_Scenario_Equipment_Xref_Housings_Revisions>;
  /** fetch aggregated fields from the table: "revisions.scenario_equipment_xref_housings_revisions" */
  revisions_scenario_equipment_xref_housings_revisions_aggregate: Revisions_Scenario_Equipment_Xref_Housings_Revisions_Aggregate;
  /** fetch data from the table: "revisions.scenario_equipment_xref_housings_revisions" using primary key columns */
  revisions_scenario_equipment_xref_housings_revisions_by_pk?: Maybe<Revisions_Scenario_Equipment_Xref_Housings_Revisions>;
  /** fetch data from the table: "revisions.scenario_equipment_xref_intakes_journal" */
  revisions_scenario_equipment_xref_intakes_journal: Array<Revisions_Scenario_Equipment_Xref_Intakes_Journal>;
  /** fetch aggregated fields from the table: "revisions.scenario_equipment_xref_intakes_journal" */
  revisions_scenario_equipment_xref_intakes_journal_aggregate: Revisions_Scenario_Equipment_Xref_Intakes_Journal_Aggregate;
  /** fetch data from the table: "revisions.scenario_equipment_xref_intakes_journal" using primary key columns */
  revisions_scenario_equipment_xref_intakes_journal_by_pk?: Maybe<Revisions_Scenario_Equipment_Xref_Intakes_Journal>;
  /** fetch data from the table: "revisions.scenario_equipment_xref_intakes_revisions" */
  revisions_scenario_equipment_xref_intakes_revisions: Array<Revisions_Scenario_Equipment_Xref_Intakes_Revisions>;
  /** fetch aggregated fields from the table: "revisions.scenario_equipment_xref_intakes_revisions" */
  revisions_scenario_equipment_xref_intakes_revisions_aggregate: Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Aggregate;
  /** fetch data from the table: "revisions.scenario_equipment_xref_intakes_revisions" using primary key columns */
  revisions_scenario_equipment_xref_intakes_revisions_by_pk?: Maybe<Revisions_Scenario_Equipment_Xref_Intakes_Revisions>;
  /** fetch data from the table: "revisions.scenario_equipment_xref_pumps_journal" */
  revisions_scenario_equipment_xref_pumps_journal: Array<Revisions_Scenario_Equipment_Xref_Pumps_Journal>;
  /** fetch aggregated fields from the table: "revisions.scenario_equipment_xref_pumps_journal" */
  revisions_scenario_equipment_xref_pumps_journal_aggregate: Revisions_Scenario_Equipment_Xref_Pumps_Journal_Aggregate;
  /** fetch data from the table: "revisions.scenario_equipment_xref_pumps_journal" using primary key columns */
  revisions_scenario_equipment_xref_pumps_journal_by_pk?: Maybe<Revisions_Scenario_Equipment_Xref_Pumps_Journal>;
  /** fetch data from the table: "revisions.scenario_equipment_xref_pumps_revisions" */
  revisions_scenario_equipment_xref_pumps_revisions: Array<Revisions_Scenario_Equipment_Xref_Pumps_Revisions>;
  /** fetch aggregated fields from the table: "revisions.scenario_equipment_xref_pumps_revisions" */
  revisions_scenario_equipment_xref_pumps_revisions_aggregate: Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Aggregate;
  /** fetch data from the table: "revisions.scenario_equipment_xref_pumps_revisions" using primary key columns */
  revisions_scenario_equipment_xref_pumps_revisions_by_pk?: Maybe<Revisions_Scenario_Equipment_Xref_Pumps_Revisions>;
  /** fetch data from the table: "revisions.scenario_equipment_xref_seals_journal" */
  revisions_scenario_equipment_xref_seals_journal: Array<Revisions_Scenario_Equipment_Xref_Seals_Journal>;
  /** fetch aggregated fields from the table: "revisions.scenario_equipment_xref_seals_journal" */
  revisions_scenario_equipment_xref_seals_journal_aggregate: Revisions_Scenario_Equipment_Xref_Seals_Journal_Aggregate;
  /** fetch data from the table: "revisions.scenario_equipment_xref_seals_journal" using primary key columns */
  revisions_scenario_equipment_xref_seals_journal_by_pk?: Maybe<Revisions_Scenario_Equipment_Xref_Seals_Journal>;
  /** fetch data from the table: "revisions.scenario_equipment_xref_seals_revisions" */
  revisions_scenario_equipment_xref_seals_revisions: Array<Revisions_Scenario_Equipment_Xref_Seals_Revisions>;
  /** fetch aggregated fields from the table: "revisions.scenario_equipment_xref_seals_revisions" */
  revisions_scenario_equipment_xref_seals_revisions_aggregate: Revisions_Scenario_Equipment_Xref_Seals_Revisions_Aggregate;
  /** fetch data from the table: "revisions.scenario_equipment_xref_seals_revisions" using primary key columns */
  revisions_scenario_equipment_xref_seals_revisions_by_pk?: Maybe<Revisions_Scenario_Equipment_Xref_Seals_Revisions>;
  /** fetch data from the table: "revisions.scenario_parameters_journal" */
  revisions_scenario_parameters_journal: Array<Revisions_Scenario_Parameters_Journal>;
  /** fetch aggregated fields from the table: "revisions.scenario_parameters_journal" */
  revisions_scenario_parameters_journal_aggregate: Revisions_Scenario_Parameters_Journal_Aggregate;
  /** fetch data from the table: "revisions.scenario_parameters_journal" using primary key columns */
  revisions_scenario_parameters_journal_by_pk?: Maybe<Revisions_Scenario_Parameters_Journal>;
  /** fetch data from the table: "revisions.scenario_parameters_revisions" */
  revisions_scenario_parameters_revisions: Array<Revisions_Scenario_Parameters_Revisions>;
  /** fetch aggregated fields from the table: "revisions.scenario_parameters_revisions" */
  revisions_scenario_parameters_revisions_aggregate: Revisions_Scenario_Parameters_Revisions_Aggregate;
  /** fetch data from the table: "revisions.scenario_parameters_revisions" using primary key columns */
  revisions_scenario_parameters_revisions_by_pk?: Maybe<Revisions_Scenario_Parameters_Revisions>;
  /** fetch data from the table: "revisions.scenario_well_properties_journal" */
  revisions_scenario_well_properties_journal: Array<Revisions_Scenario_Well_Properties_Journal>;
  /** fetch aggregated fields from the table: "revisions.scenario_well_properties_journal" */
  revisions_scenario_well_properties_journal_aggregate: Revisions_Scenario_Well_Properties_Journal_Aggregate;
  /** fetch data from the table: "revisions.scenario_well_properties_journal" using primary key columns */
  revisions_scenario_well_properties_journal_by_pk?: Maybe<Revisions_Scenario_Well_Properties_Journal>;
  /** fetch data from the table: "revisions.scenario_well_properties_revisions" */
  revisions_scenario_well_properties_revisions: Array<Revisions_Scenario_Well_Properties_Revisions>;
  /** fetch aggregated fields from the table: "revisions.scenario_well_properties_revisions" */
  revisions_scenario_well_properties_revisions_aggregate: Revisions_Scenario_Well_Properties_Revisions_Aggregate;
  /** fetch data from the table: "revisions.scenario_well_properties_revisions" using primary key columns */
  revisions_scenario_well_properties_revisions_by_pk?: Maybe<Revisions_Scenario_Well_Properties_Revisions>;
  /** fetch data from the table: "revisions.scenarios_journal" */
  revisions_scenarios_journal: Array<Revisions_Scenarios_Journal>;
  /** fetch aggregated fields from the table: "revisions.scenarios_journal" */
  revisions_scenarios_journal_aggregate: Revisions_Scenarios_Journal_Aggregate;
  /** fetch data from the table: "revisions.scenarios_journal" using primary key columns */
  revisions_scenarios_journal_by_pk?: Maybe<Revisions_Scenarios_Journal>;
  /** fetch data from the table: "revisions.scenarios_revisions" */
  revisions_scenarios_revisions: Array<Revisions_Scenarios_Revisions>;
  /** fetch aggregated fields from the table: "revisions.scenarios_revisions" */
  revisions_scenarios_revisions_aggregate: Revisions_Scenarios_Revisions_Aggregate;
  /** fetch data from the table: "revisions.scenarios_revisions" using primary key columns */
  revisions_scenarios_revisions_by_pk?: Maybe<Revisions_Scenarios_Revisions>;
  /** fetch data from the table: "revisions.sizings_journal" */
  revisions_sizings_journal: Array<Revisions_Sizings_Journal>;
  /** fetch aggregated fields from the table: "revisions.sizings_journal" */
  revisions_sizings_journal_aggregate: Revisions_Sizings_Journal_Aggregate;
  /** fetch data from the table: "revisions.sizings_journal" using primary key columns */
  revisions_sizings_journal_by_pk?: Maybe<Revisions_Sizings_Journal>;
  /** fetch data from the table: "revisions.sizings_revisions" */
  revisions_sizings_revisions: Array<Revisions_Sizings_Revisions>;
  /** fetch aggregated fields from the table: "revisions.sizings_revisions" */
  revisions_sizings_revisions_aggregate: Revisions_Sizings_Revisions_Aggregate;
  /** fetch data from the table: "revisions.sizings_revisions" using primary key columns */
  revisions_sizings_revisions_by_pk?: Maybe<Revisions_Sizings_Revisions>;
  /** fetch data from the table: "saturated_oil_options" */
  saturated_oil_options: Array<Saturated_Oil_Options>;
  /** fetch aggregated fields from the table: "saturated_oil_options" */
  saturated_oil_options_aggregate: Saturated_Oil_Options_Aggregate;
  /** fetch data from the table: "saturated_oil_options" using primary key columns */
  saturated_oil_options_by_pk?: Maybe<Saturated_Oil_Options>;
  /** fetch data from the table: "sc_equip_xref_downhole_ytool_bypass_tubings" */
  sc_equip_xref_downhole_ytool_bypass_tubings: Array<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings>;
  /** fetch aggregated fields from the table: "sc_equip_xref_downhole_ytool_bypass_tubings" */
  sc_equip_xref_downhole_ytool_bypass_tubings_aggregate: Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Aggregate;
  /** fetch data from the table: "sc_equip_xref_downhole_ytool_equip_tubings" */
  sc_equip_xref_downhole_ytool_equip_tubings: Array<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings>;
  /** fetch aggregated fields from the table: "sc_equip_xref_downhole_ytool_equip_tubings" */
  sc_equip_xref_downhole_ytool_equip_tubings_aggregate: Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Aggregate;
  /** fetch data from the table: "sc_equip_xref_uphole_ytool_bypass_tubings" */
  sc_equip_xref_uphole_ytool_bypass_tubings: Array<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings>;
  /** fetch aggregated fields from the table: "sc_equip_xref_uphole_ytool_bypass_tubings" */
  sc_equip_xref_uphole_ytool_bypass_tubings_aggregate: Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Aggregate;
  /** fetch data from the table: "sc_equip_xref_uphole_ytool_equip_tubings" */
  sc_equip_xref_uphole_ytool_equip_tubings: Array<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings>;
  /** fetch aggregated fields from the table: "sc_equip_xref_uphole_ytool_equip_tubings" */
  sc_equip_xref_uphole_ytool_equip_tubings_aggregate: Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Aggregate;
  /** fetch data from the table: "scenario_correlations" */
  scenario_correlations: Array<Scenario_Correlations>;
  /** fetch aggregated fields from the table: "scenario_correlations" */
  scenario_correlations_aggregate: Scenario_Correlations_Aggregate;
  /** fetch data from the table: "scenario_equipment" */
  scenario_equipment: Array<Scenario_Equipment>;
  /** fetch aggregated fields from the table: "scenario_equipment" */
  scenario_equipment_aggregate: Scenario_Equipment_Aggregate;
  /** fetch data from the table: "scenario_equipment_xref_cables" */
  scenario_equipment_xref_cables: Array<Scenario_Equipment_Xref_Cables>;
  /** fetch aggregated fields from the table: "scenario_equipment_xref_cables" */
  scenario_equipment_xref_cables_aggregate: Scenario_Equipment_Xref_Cables_Aggregate;
  /** fetch data from the table: "scenario_equipment_xref_housings" */
  scenario_equipment_xref_housings: Array<Scenario_Equipment_Xref_Housings>;
  /** fetch aggregated fields from the table: "scenario_equipment_xref_housings" */
  scenario_equipment_xref_housings_aggregate: Scenario_Equipment_Xref_Housings_Aggregate;
  /** fetch data from the table: "scenario_equipment_xref_intakes" */
  scenario_equipment_xref_intakes: Array<Scenario_Equipment_Xref_Intakes>;
  /** fetch aggregated fields from the table: "scenario_equipment_xref_intakes" */
  scenario_equipment_xref_intakes_aggregate: Scenario_Equipment_Xref_Intakes_Aggregate;
  /** fetch data from the table: "scenario_equipment_xref_pumps" */
  scenario_equipment_xref_pumps: Array<Scenario_Equipment_Xref_Pumps>;
  /** fetch aggregated fields from the table: "scenario_equipment_xref_pumps" */
  scenario_equipment_xref_pumps_aggregate: Scenario_Equipment_Xref_Pumps_Aggregate;
  /** fetch data from the table: "scenario_equipment_xref_seals" */
  scenario_equipment_xref_seals: Array<Scenario_Equipment_Xref_Seals>;
  /** fetch aggregated fields from the table: "scenario_equipment_xref_seals" */
  scenario_equipment_xref_seals_aggregate: Scenario_Equipment_Xref_Seals_Aggregate;
  /** fetch data from the table: "scenario_parameters" */
  scenario_parameters: Array<Scenario_Parameters>;
  /** fetch aggregated fields from the table: "scenario_parameters" */
  scenario_parameters_aggregate: Scenario_Parameters_Aggregate;
  /** fetch data from the table: "scenario_reasons" */
  scenario_reasons: Array<Scenario_Reasons>;
  /** fetch aggregated fields from the table: "scenario_reasons" */
  scenario_reasons_aggregate: Scenario_Reasons_Aggregate;
  /** fetch data from the table: "scenario_reasons" using primary key columns */
  scenario_reasons_by_pk?: Maybe<Scenario_Reasons>;
  /** fetch data from the table: "scenario_well_properties" */
  scenario_well_properties: Array<Scenario_Well_Properties>;
  /** fetch aggregated fields from the table: "scenario_well_properties" */
  scenario_well_properties_aggregate: Scenario_Well_Properties_Aggregate;
  /** An array relationship */
  scenarios: Array<Scenarios>;
  /** An aggregate relationship */
  scenarios_aggregate: Scenarios_Aggregate;
  /** fetch data from the table: "seal_motor_oil" */
  seal_motor_oil: Array<Seal_Motor_Oil>;
  /** fetch aggregated fields from the table: "seal_motor_oil" */
  seal_motor_oil_aggregate: Seal_Motor_Oil_Aggregate;
  /** fetch data from the table: "seal_motor_oil" using primary key columns */
  seal_motor_oil_by_pk?: Maybe<Seal_Motor_Oil>;
  /** An array relationship */
  seals: Array<Seals>;
  /** An aggregate relationship */
  seals_aggregate: Seals_Aggregate;
  /** fetch data from the table: "seals" using primary key columns */
  seals_by_pk?: Maybe<Seals>;
  /** An array relationship */
  sensors: Array<Sensors>;
  /** An aggregate relationship */
  sensors_aggregate: Sensors_Aggregate;
  /** fetch data from the table: "sensors" using primary key columns */
  sensors_by_pk?: Maybe<Sensors>;
  /** fetch data from the table: "sizing_dispositions" */
  sizing_dispositions: Array<Sizing_Dispositions>;
  /** fetch aggregated fields from the table: "sizing_dispositions" */
  sizing_dispositions_aggregate: Sizing_Dispositions_Aggregate;
  /** fetch data from the table: "sizing_dispositions" using primary key columns */
  sizing_dispositions_by_pk?: Maybe<Sizing_Dispositions>;
  /** An array relationship */
  sizing_imports: Array<Sizing_Imports>;
  /** An aggregate relationship */
  sizing_imports_aggregate: Sizing_Imports_Aggregate;
  /** fetch data from the table: "sizing_imports" using primary key columns */
  sizing_imports_by_pk?: Maybe<Sizing_Imports>;
  /** fetch data from the table: "sizing_pumping_type" */
  sizing_pumping_type: Array<Sizing_Pumping_Type>;
  /** fetch aggregated fields from the table: "sizing_pumping_type" */
  sizing_pumping_type_aggregate: Sizing_Pumping_Type_Aggregate;
  /** fetch data from the table: "sizing_pumping_type" using primary key columns */
  sizing_pumping_type_by_pk?: Maybe<Sizing_Pumping_Type>;
  /** An array relationship */
  sizings: Array<Sizings>;
  /** An aggregate relationship */
  sizings_aggregate: Sizings_Aggregate;
  /** fetch data from the table: "solution_gas_oil_ratio_options" */
  solution_gas_oil_ratio_options: Array<Solution_Gas_Oil_Ratio_Options>;
  /** fetch aggregated fields from the table: "solution_gas_oil_ratio_options" */
  solution_gas_oil_ratio_options_aggregate: Solution_Gas_Oil_Ratio_Options_Aggregate;
  /** fetch data from the table: "solution_gas_oil_ratio_options" using primary key columns */
  solution_gas_oil_ratio_options_by_pk?: Maybe<Solution_Gas_Oil_Ratio_Options>;
  /** fetch data from the table: "status" */
  status: Array<Status>;
  /** fetch aggregated fields from the table: "status" */
  status_aggregate: Status_Aggregate;
  /** An array relationship */
  step_down_transformers: Array<Step_Down_Transformers>;
  /** An aggregate relationship */
  step_down_transformers_aggregate: Step_Down_Transformers_Aggregate;
  /** fetch data from the table: "step_down_transformers" using primary key columns */
  step_down_transformers_by_pk?: Maybe<Step_Down_Transformers>;
  /** An array relationship */
  step_up_transformers: Array<Step_Up_Transformers>;
  /** An aggregate relationship */
  step_up_transformers_aggregate: Step_Up_Transformers_Aggregate;
  /** fetch data from the table: "step_up_transformers" using primary key columns */
  step_up_transformers_by_pk?: Maybe<Step_Up_Transformers>;
  /** An array relationship */
  switchboards: Array<Switchboards>;
  /** An aggregate relationship */
  switchboards_aggregate: Switchboards_Aggregate;
  /** fetch data from the table: "switchboards" using primary key columns */
  switchboards_by_pk?: Maybe<Switchboards>;
  /** fetch data from the table: "tubing_flow_options" */
  tubing_flow_options: Array<Tubing_Flow_Options>;
  /** fetch aggregated fields from the table: "tubing_flow_options" */
  tubing_flow_options_aggregate: Tubing_Flow_Options_Aggregate;
  /** fetch data from the table: "tubing_flow_options" using primary key columns */
  tubing_flow_options_by_pk?: Maybe<Tubing_Flow_Options>;
  /** An array relationship */
  tubings: Array<Tubings>;
  /** An aggregate relationship */
  tubings_aggregate: Tubings_Aggregate;
  /** fetch data from the table: "tubings" using primary key columns */
  tubings_by_pk?: Maybe<Tubings>;
  /** fetch data from the table: "tubings_type" */
  tubings_type: Array<Tubings_Type>;
  /** fetch aggregated fields from the table: "tubings_type" */
  tubings_type_aggregate: Tubings_Type_Aggregate;
  /** fetch data from the table: "tubings_type" using primary key columns */
  tubings_type_by_pk?: Maybe<Tubings_Type>;
  /** fetch data from the table: "under_saturated_oil_options" */
  under_saturated_oil_options: Array<Under_Saturated_Oil_Options>;
  /** fetch aggregated fields from the table: "under_saturated_oil_options" */
  under_saturated_oil_options_aggregate: Under_Saturated_Oil_Options_Aggregate;
  /** fetch data from the table: "under_saturated_oil_options" using primary key columns */
  under_saturated_oil_options_by_pk?: Maybe<Under_Saturated_Oil_Options>;
  /** fetch data from the table: "user_eula_acceptance" */
  user_eula_acceptance: Array<User_Eula_Acceptance>;
  /** fetch aggregated fields from the table: "user_eula_acceptance" */
  user_eula_acceptance_aggregate: User_Eula_Acceptance_Aggregate;
  /** fetch data from the table: "user_eula_acceptance" using primary key columns */
  user_eula_acceptance_by_pk?: Maybe<User_Eula_Acceptance>;
  /** fetch data from the table: "users" */
  users: Array<Users>;
  /** fetch aggregated fields from the table: "users" */
  users_aggregate: Users_Aggregate;
  /** fetch data from the table: "users" using primary key columns */
  users_by_pk?: Maybe<Users>;
  /** An array relationship */
  variable_speed_drives: Array<Variable_Speed_Drives>;
  /** An aggregate relationship */
  variable_speed_drives_aggregate: Variable_Speed_Drives_Aggregate;
  /** fetch data from the table: "variable_speed_drives" using primary key columns */
  variable_speed_drives_by_pk?: Maybe<Variable_Speed_Drives>;
  /** fetch data from the table: "water_density_options" */
  water_density_options: Array<Water_Density_Options>;
  /** fetch aggregated fields from the table: "water_density_options" */
  water_density_options_aggregate: Water_Density_Options_Aggregate;
  /** fetch data from the table: "water_density_options" using primary key columns */
  water_density_options_by_pk?: Maybe<Water_Density_Options>;
  /** fetch data from the table: "water_solution_gas_options" */
  water_solution_gas_options: Array<Water_Solution_Gas_Options>;
  /** fetch aggregated fields from the table: "water_solution_gas_options" */
  water_solution_gas_options_aggregate: Water_Solution_Gas_Options_Aggregate;
  /** fetch data from the table: "water_solution_gas_options" using primary key columns */
  water_solution_gas_options_by_pk?: Maybe<Water_Solution_Gas_Options>;
  /** fetch data from the table: "water_viscosity_options" */
  water_viscosity_options: Array<Water_Viscosity_Options>;
  /** fetch aggregated fields from the table: "water_viscosity_options" */
  water_viscosity_options_aggregate: Water_Viscosity_Options_Aggregate;
  /** fetch data from the table: "water_viscosity_options" using primary key columns */
  water_viscosity_options_by_pk?: Maybe<Water_Viscosity_Options>;
  /** fetch data from the table: "water_volume_factor_options" */
  water_volume_factor_options: Array<Water_Volume_Factor_Options>;
  /** fetch aggregated fields from the table: "water_volume_factor_options" */
  water_volume_factor_options_aggregate: Water_Volume_Factor_Options_Aggregate;
  /** fetch data from the table: "water_volume_factor_options" using primary key columns */
  water_volume_factor_options_by_pk?: Maybe<Water_Volume_Factor_Options>;
  /** fetch data from the table: "well_gas_type_options" */
  well_gas_type_options: Array<Well_Gas_Type_Options>;
  /** fetch aggregated fields from the table: "well_gas_type_options" */
  well_gas_type_options_aggregate: Well_Gas_Type_Options_Aggregate;
  /** fetch data from the table: "well_gas_type_options" using primary key columns */
  well_gas_type_options_by_pk?: Maybe<Well_Gas_Type_Options>;
  /** fetch data from the table: "well_test_gas_input_options" */
  well_test_gas_input_options: Array<Well_Test_Gas_Input_Options>;
  /** fetch aggregated fields from the table: "well_test_gas_input_options" */
  well_test_gas_input_options_aggregate: Well_Test_Gas_Input_Options_Aggregate;
  /** fetch data from the table: "well_test_gas_input_options" using primary key columns */
  well_test_gas_input_options_by_pk?: Maybe<Well_Test_Gas_Input_Options>;
  /** fetch data from the table: "well_test_liquid_input_options" */
  well_test_liquid_input_options: Array<Well_Test_Liquid_Input_Options>;
  /** fetch aggregated fields from the table: "well_test_liquid_input_options" */
  well_test_liquid_input_options_aggregate: Well_Test_Liquid_Input_Options_Aggregate;
  /** fetch data from the table: "well_test_liquid_input_options" using primary key columns */
  well_test_liquid_input_options_by_pk?: Maybe<Well_Test_Liquid_Input_Options>;
  /** fetch data from the table: "well_test_pressure_input_options" */
  well_test_pressure_input_options: Array<Well_Test_Pressure_Input_Options>;
  /** fetch aggregated fields from the table: "well_test_pressure_input_options" */
  well_test_pressure_input_options_aggregate: Well_Test_Pressure_Input_Options_Aggregate;
  /** fetch data from the table: "well_test_pressure_input_options" using primary key columns */
  well_test_pressure_input_options_by_pk?: Maybe<Well_Test_Pressure_Input_Options>;
  /** An array relationship */
  wells: Array<Wells>;
  /** An aggregate relationship */
  wells_aggregate: Wells_Aggregate;
  /** fetch data from the table: "wells" using primary key columns */
  wells_by_pk?: Maybe<Wells>;
  /** fetch data from the table: "y_tools" */
  y_tools: Array<Y_Tools>;
  /** fetch aggregated fields from the table: "y_tools" */
  y_tools_aggregate: Y_Tools_Aggregate;
  /** fetch data from the table: "y_tools" using primary key columns */
  y_tools_by_pk?: Maybe<Y_Tools>;
};


export type Query_RootBolt_On_DischargesArgs = {
  distinct_on?: InputMaybe<Array<Bolt_On_Discharges_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Bolt_On_Discharges_Order_By>>;
  where?: InputMaybe<Bolt_On_Discharges_Bool_Exp>;
};


export type Query_RootBolt_On_Discharges_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Bolt_On_Discharges_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Bolt_On_Discharges_Order_By>>;
  where?: InputMaybe<Bolt_On_Discharges_Bool_Exp>;
};


export type Query_RootBolt_On_Discharges_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootBubble_Point_OptionsArgs = {
  distinct_on?: InputMaybe<Array<Bubble_Point_Options_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Bubble_Point_Options_Order_By>>;
  where?: InputMaybe<Bubble_Point_Options_Bool_Exp>;
};


export type Query_RootBubble_Point_Options_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Bubble_Point_Options_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Bubble_Point_Options_Order_By>>;
  where?: InputMaybe<Bubble_Point_Options_Bool_Exp>;
};


export type Query_RootBubble_Point_Options_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootCablesArgs = {
  distinct_on?: InputMaybe<Array<Cables_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cables_Order_By>>;
  where?: InputMaybe<Cables_Bool_Exp>;
};


export type Query_RootCables_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Cables_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cables_Order_By>>;
  where?: InputMaybe<Cables_Bool_Exp>;
};


export type Query_RootCables_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootCasing_Flow_OptionsArgs = {
  distinct_on?: InputMaybe<Array<Casing_Flow_Options_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Casing_Flow_Options_Order_By>>;
  where?: InputMaybe<Casing_Flow_Options_Bool_Exp>;
};


export type Query_RootCasing_Flow_Options_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Casing_Flow_Options_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Casing_Flow_Options_Order_By>>;
  where?: InputMaybe<Casing_Flow_Options_Bool_Exp>;
};


export type Query_RootCasing_Flow_Options_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootCasingsArgs = {
  distinct_on?: InputMaybe<Array<Casings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Casings_Order_By>>;
  where?: InputMaybe<Casings_Bool_Exp>;
};


export type Query_RootCasings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Casings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Casings_Order_By>>;
  where?: InputMaybe<Casings_Bool_Exp>;
};


export type Query_RootCasings_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootCasings_TypeArgs = {
  distinct_on?: InputMaybe<Array<Casings_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Casings_Type_Order_By>>;
  where?: InputMaybe<Casings_Type_Bool_Exp>;
};


export type Query_RootCasings_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Casings_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Casings_Type_Order_By>>;
  where?: InputMaybe<Casings_Type_Bool_Exp>;
};


export type Query_RootCasings_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootCustomersArgs = {
  distinct_on?: InputMaybe<Array<Customers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customers_Order_By>>;
  where?: InputMaybe<Customers_Bool_Exp>;
};


export type Query_RootCustomers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customers_Order_By>>;
  where?: InputMaybe<Customers_Bool_Exp>;
};


export type Query_RootCustomers_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootDead_Oil_OptionsArgs = {
  distinct_on?: InputMaybe<Array<Dead_Oil_Options_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Dead_Oil_Options_Order_By>>;
  where?: InputMaybe<Dead_Oil_Options_Bool_Exp>;
};


export type Query_RootDead_Oil_Options_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Dead_Oil_Options_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Dead_Oil_Options_Order_By>>;
  where?: InputMaybe<Dead_Oil_Options_Bool_Exp>;
};


export type Query_RootDead_Oil_Options_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootDeviation_SurveyArgs = {
  distinct_on?: InputMaybe<Array<Deviation_Survey_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Deviation_Survey_Order_By>>;
  where?: InputMaybe<Deviation_Survey_Bool_Exp>;
};


export type Query_RootDeviation_Survey_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Deviation_Survey_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Deviation_Survey_Order_By>>;
  where?: InputMaybe<Deviation_Survey_Bool_Exp>;
};


export type Query_RootDeviation_Survey_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootDeviation_Survey_Directional_DatasetArgs = {
  distinct_on?: InputMaybe<Array<Deviation_Survey_Directional_Dataset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Deviation_Survey_Directional_Dataset_Order_By>>;
  where?: InputMaybe<Deviation_Survey_Directional_Dataset_Bool_Exp>;
};


export type Query_RootDeviation_Survey_Directional_Dataset_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Deviation_Survey_Directional_Dataset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Deviation_Survey_Directional_Dataset_Order_By>>;
  where?: InputMaybe<Deviation_Survey_Directional_Dataset_Bool_Exp>;
};


export type Query_RootDeviation_Survey_Directional_Dataset_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootDisplay_UnitsArgs = {
  distinct_on?: InputMaybe<Array<Display_Units_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Display_Units_Order_By>>;
  where?: InputMaybe<Display_Units_Bool_Exp>;
};


export type Query_RootDisplay_Units_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Display_Units_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Display_Units_Order_By>>;
  where?: InputMaybe<Display_Units_Bool_Exp>;
};


export type Query_RootDisplay_Units_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootEulaArgs = {
  distinct_on?: InputMaybe<Array<Eula_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eula_Order_By>>;
  where?: InputMaybe<Eula_Bool_Exp>;
};


export type Query_RootEula_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eula_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eula_Order_By>>;
  where?: InputMaybe<Eula_Bool_Exp>;
};


export type Query_RootEula_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootFlow_ModelArgs = {
  distinct_on?: InputMaybe<Array<Flow_Model_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Flow_Model_Order_By>>;
  where?: InputMaybe<Flow_Model_Bool_Exp>;
};


export type Query_RootFlow_Model_ActiveArgs = {
  distinct_on?: InputMaybe<Array<Flow_Model_Active_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Flow_Model_Active_Order_By>>;
  where?: InputMaybe<Flow_Model_Active_Bool_Exp>;
};


export type Query_RootFlow_Model_Active_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Flow_Model_Active_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Flow_Model_Active_Order_By>>;
  where?: InputMaybe<Flow_Model_Active_Bool_Exp>;
};


export type Query_RootFlow_Model_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Flow_Model_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Flow_Model_Order_By>>;
  where?: InputMaybe<Flow_Model_Bool_Exp>;
};


export type Query_RootFlow_Model_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootFlow_Model_DeprecatedArgs = {
  distinct_on?: InputMaybe<Array<Flow_Model_Deprecated_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Flow_Model_Deprecated_Order_By>>;
  where?: InputMaybe<Flow_Model_Deprecated_Bool_Exp>;
};


export type Query_RootFlow_Model_Deprecated_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Flow_Model_Deprecated_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Flow_Model_Deprecated_Order_By>>;
  where?: InputMaybe<Flow_Model_Deprecated_Bool_Exp>;
};


export type Query_RootFlow_Model_Deprecated_By_PkArgs = {
  value: Flow_Model_Enum;
};


export type Query_RootFriction_Loss_OptionsArgs = {
  distinct_on?: InputMaybe<Array<Friction_Loss_Options_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Friction_Loss_Options_Order_By>>;
  where?: InputMaybe<Friction_Loss_Options_Bool_Exp>;
};


export type Query_RootFriction_Loss_Options_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Friction_Loss_Options_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Friction_Loss_Options_Order_By>>;
  where?: InputMaybe<Friction_Loss_Options_Bool_Exp>;
};


export type Query_RootFriction_Loss_Options_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootGas_Compressibility_OptionsArgs = {
  distinct_on?: InputMaybe<Array<Gas_Compressibility_Options_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Gas_Compressibility_Options_Order_By>>;
  where?: InputMaybe<Gas_Compressibility_Options_Bool_Exp>;
};


export type Query_RootGas_Compressibility_Options_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Gas_Compressibility_Options_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Gas_Compressibility_Options_Order_By>>;
  where?: InputMaybe<Gas_Compressibility_Options_Bool_Exp>;
};


export type Query_RootGas_Compressibility_Options_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootGas_Viscosity_OptionsArgs = {
  distinct_on?: InputMaybe<Array<Gas_Viscosity_Options_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Gas_Viscosity_Options_Order_By>>;
  where?: InputMaybe<Gas_Viscosity_Options_Bool_Exp>;
};


export type Query_RootGas_Viscosity_Options_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Gas_Viscosity_Options_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Gas_Viscosity_Options_Order_By>>;
  where?: InputMaybe<Gas_Viscosity_Options_Bool_Exp>;
};


export type Query_RootGas_Viscosity_Options_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootGetErpCustomersArgs = {
  customer_erp_id?: InputMaybe<Scalars['String']['input']>;
  is_customer?: InputMaybe<Scalars['Boolean']['input']>;
  is_s4_user?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};


export type Query_RootGetErpWellAddressesArgs = {
  customer_erp_id?: InputMaybe<Scalars['String']['input']>;
  is_customer?: InputMaybe<Scalars['Boolean']['input']>;
  is_s4_user?: InputMaybe<Scalars['Boolean']['input']>;
  well_name?: InputMaybe<Scalars['String']['input']>;
};


export type Query_RootGetErpWellReadingsArgs = {
  id: Scalars['String']['input'];
  id_type: ErpWellReadingsIdType;
  is_s4_user?: InputMaybe<Scalars['Boolean']['input']>;
};


export type Query_RootGetSkBillablesArgs = {
  is_s4_user?: InputMaybe<Scalars['Boolean']['input']>;
  summitQueryString?: InputMaybe<Scalars['String']['input']>;
};


export type Query_RootGetSkContractsArgs = {
  is_s4_user?: InputMaybe<Scalars['Boolean']['input']>;
  summitQueryString?: InputMaybe<Scalars['String']['input']>;
};


export type Query_RootGetSkCurrenciesArgs = {
  is_s4_user?: InputMaybe<Scalars['Boolean']['input']>;
  summitQueryString?: InputMaybe<Scalars['String']['input']>;
};


export type Query_RootGetSkCustomersArgs = {
  is_s4_user?: InputMaybe<Scalars['Boolean']['input']>;
  summitQueryString?: InputMaybe<Scalars['String']['input']>;
};


export type Query_RootGetSkEquipmentTypeConversionsArgs = {
  is_s4_user?: InputMaybe<Scalars['Boolean']['input']>;
  summitQueryString?: InputMaybe<Scalars['String']['input']>;
};


export type Query_RootGetSkJobsArgs = {
  is_s4_user?: InputMaybe<Scalars['Boolean']['input']>;
  summitQueryString?: InputMaybe<Scalars['String']['input']>;
};


export type Query_RootGetSkMaterialsArgs = {
  is_s4_user?: InputMaybe<Scalars['Boolean']['input']>;
  summitQueryString?: InputMaybe<Scalars['String']['input']>;
};


export type Query_RootGetSkMaterialsPaginatedArgs = {
  is_s4_user?: InputMaybe<Scalars['Boolean']['input']>;
  summitQueryString?: InputMaybe<Scalars['String']['input']>;
};


export type Query_RootGetSkNwasArgs = {
  is_s4_user?: InputMaybe<Scalars['Boolean']['input']>;
  summitQueryString?: InputMaybe<Scalars['String']['input']>;
};


export type Query_RootGetSkPlanningOrderArgs = {
  is_s4_user?: InputMaybe<Scalars['Boolean']['input']>;
  summitQueryString?: InputMaybe<Scalars['String']['input']>;
};


export type Query_RootGetSkPlantsArgs = {
  is_s4_user?: InputMaybe<Scalars['Boolean']['input']>;
  summitQueryString?: InputMaybe<Scalars['String']['input']>;
};


export type Query_RootGetSkPriceListsArgs = {
  is_s4_user?: InputMaybe<Scalars['Boolean']['input']>;
  summitQueryString?: InputMaybe<Scalars['String']['input']>;
};


export type Query_RootGetSkWellAddressesArgs = {
  is_s4_user?: InputMaybe<Scalars['Boolean']['input']>;
  summitQueryString?: InputMaybe<Scalars['String']['input']>;
};


export type Query_RootHousingsArgs = {
  distinct_on?: InputMaybe<Array<Housings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Housings_Order_By>>;
  where?: InputMaybe<Housings_Bool_Exp>;
};


export type Query_RootHousings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Housings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Housings_Order_By>>;
  where?: InputMaybe<Housings_Bool_Exp>;
};


export type Query_RootHousings_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootHps_Liquid_TypeArgs = {
  distinct_on?: InputMaybe<Array<Hps_Liquid_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Hps_Liquid_Type_Order_By>>;
  where?: InputMaybe<Hps_Liquid_Type_Bool_Exp>;
};


export type Query_RootHps_Liquid_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Hps_Liquid_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Hps_Liquid_Type_Order_By>>;
  where?: InputMaybe<Hps_Liquid_Type_Bool_Exp>;
};


export type Query_RootHps_Liquid_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootIntakesArgs = {
  distinct_on?: InputMaybe<Array<Intakes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Intakes_Order_By>>;
  where?: InputMaybe<Intakes_Bool_Exp>;
};


export type Query_RootIntakes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Intakes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Intakes_Order_By>>;
  where?: InputMaybe<Intakes_Bool_Exp>;
};


export type Query_RootIntakes_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootLegacy_UsersArgs = {
  distinct_on?: InputMaybe<Array<Legacy_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Legacy_Users_Order_By>>;
  where?: InputMaybe<Legacy_Users_Bool_Exp>;
};


export type Query_RootLegacy_Users_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Legacy_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Legacy_Users_Order_By>>;
  where?: InputMaybe<Legacy_Users_Bool_Exp>;
};


export type Query_RootLegacy_Users_By_PkArgs = {
  hal_identifier: Scalars['String']['input'];
};


export type Query_RootMotor_Lead_ExtensionsArgs = {
  distinct_on?: InputMaybe<Array<Motor_Lead_Extensions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Motor_Lead_Extensions_Order_By>>;
  where?: InputMaybe<Motor_Lead_Extensions_Bool_Exp>;
};


export type Query_RootMotor_Lead_Extensions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Motor_Lead_Extensions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Motor_Lead_Extensions_Order_By>>;
  where?: InputMaybe<Motor_Lead_Extensions_Bool_Exp>;
};


export type Query_RootMotor_Lead_Extensions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootMotorsArgs = {
  distinct_on?: InputMaybe<Array<Motors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Motors_Order_By>>;
  where?: InputMaybe<Motors_Bool_Exp>;
};


export type Query_RootMotors_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Motors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Motors_Order_By>>;
  where?: InputMaybe<Motors_Bool_Exp>;
};


export type Query_RootMotors_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootNatural_Gas_Separation_OptionsArgs = {
  distinct_on?: InputMaybe<Array<Natural_Gas_Separation_Options_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Natural_Gas_Separation_Options_Order_By>>;
  where?: InputMaybe<Natural_Gas_Separation_Options_Bool_Exp>;
};


export type Query_RootNatural_Gas_Separation_Options_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Natural_Gas_Separation_Options_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Natural_Gas_Separation_Options_Order_By>>;
  where?: InputMaybe<Natural_Gas_Separation_Options_Bool_Exp>;
};


export type Query_RootNatural_Gas_Separation_Options_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootOil_Density_OptionsArgs = {
  distinct_on?: InputMaybe<Array<Oil_Density_Options_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Oil_Density_Options_Order_By>>;
  where?: InputMaybe<Oil_Density_Options_Bool_Exp>;
};


export type Query_RootOil_Density_Options_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Oil_Density_Options_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Oil_Density_Options_Order_By>>;
  where?: InputMaybe<Oil_Density_Options_Bool_Exp>;
};


export type Query_RootOil_Density_Options_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootOil_Volume_Factor_OptionsArgs = {
  distinct_on?: InputMaybe<Array<Oil_Volume_Factor_Options_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Oil_Volume_Factor_Options_Order_By>>;
  where?: InputMaybe<Oil_Volume_Factor_Options_Bool_Exp>;
};


export type Query_RootOil_Volume_Factor_Options_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Oil_Volume_Factor_Options_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Oil_Volume_Factor_Options_Order_By>>;
  where?: InputMaybe<Oil_Volume_Factor_Options_Bool_Exp>;
};


export type Query_RootOil_Volume_Factor_Options_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootOverride_OptionsArgs = {
  distinct_on?: InputMaybe<Array<Override_Options_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Override_Options_Order_By>>;
  where?: InputMaybe<Override_Options_Bool_Exp>;
};


export type Query_RootOverride_Options_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Override_Options_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Override_Options_Order_By>>;
  where?: InputMaybe<Override_Options_Bool_Exp>;
};


export type Query_RootOverride_Options_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootPerformance_EvaluationsArgs = {
  distinct_on?: InputMaybe<Array<Performance_Evaluations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Performance_Evaluations_Order_By>>;
  where?: InputMaybe<Performance_Evaluations_Bool_Exp>;
};


export type Query_RootPerformance_Evaluations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Performance_Evaluations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Performance_Evaluations_Order_By>>;
  where?: InputMaybe<Performance_Evaluations_Bool_Exp>;
};


export type Query_RootPerformance_Evaluations_Xref_PumpsArgs = {
  distinct_on?: InputMaybe<Array<Performance_Evaluations_Xref_Pumps_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Performance_Evaluations_Xref_Pumps_Order_By>>;
  where?: InputMaybe<Performance_Evaluations_Xref_Pumps_Bool_Exp>;
};


export type Query_RootPerformance_Evaluations_Xref_Pumps_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Performance_Evaluations_Xref_Pumps_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Performance_Evaluations_Xref_Pumps_Order_By>>;
  where?: InputMaybe<Performance_Evaluations_Xref_Pumps_Bool_Exp>;
};


export type Query_RootPumpsArgs = {
  distinct_on?: InputMaybe<Array<Pumps_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pumps_Order_By>>;
  where?: InputMaybe<Pumps_Bool_Exp>;
};


export type Query_RootPumps_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pumps_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pumps_Order_By>>;
  where?: InputMaybe<Pumps_Bool_Exp>;
};


export type Query_RootPumps_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootQuote_Line_Item_Category_DatasetArgs = {
  distinct_on?: InputMaybe<Array<Quote_Line_Item_Category_Dataset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quote_Line_Item_Category_Dataset_Order_By>>;
  where?: InputMaybe<Quote_Line_Item_Category_Dataset_Bool_Exp>;
};


export type Query_RootQuote_Line_Item_Category_Dataset_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quote_Line_Item_Category_Dataset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quote_Line_Item_Category_Dataset_Order_By>>;
  where?: InputMaybe<Quote_Line_Item_Category_Dataset_Bool_Exp>;
};


export type Query_RootQuote_Line_Item_Category_Dataset_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootQuote_Line_Item_Serialized_DatasetArgs = {
  distinct_on?: InputMaybe<Array<Quote_Line_Item_Serialized_Dataset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quote_Line_Item_Serialized_Dataset_Order_By>>;
  where?: InputMaybe<Quote_Line_Item_Serialized_Dataset_Bool_Exp>;
};


export type Query_RootQuote_Line_Item_Serialized_Dataset_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quote_Line_Item_Serialized_Dataset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quote_Line_Item_Serialized_Dataset_Order_By>>;
  where?: InputMaybe<Quote_Line_Item_Serialized_Dataset_Bool_Exp>;
};


export type Query_RootQuote_Line_Item_Serialized_Dataset_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootQuote_Line_Item_Source_DatasetArgs = {
  distinct_on?: InputMaybe<Array<Quote_Line_Item_Source_Dataset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quote_Line_Item_Source_Dataset_Order_By>>;
  where?: InputMaybe<Quote_Line_Item_Source_Dataset_Bool_Exp>;
};


export type Query_RootQuote_Line_Item_Source_Dataset_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quote_Line_Item_Source_Dataset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quote_Line_Item_Source_Dataset_Order_By>>;
  where?: InputMaybe<Quote_Line_Item_Source_Dataset_Bool_Exp>;
};


export type Query_RootQuote_Line_Item_Source_Dataset_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootQuote_Line_Item_Subcategory_DatasetArgs = {
  distinct_on?: InputMaybe<Array<Quote_Line_Item_Subcategory_Dataset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quote_Line_Item_Subcategory_Dataset_Order_By>>;
  where?: InputMaybe<Quote_Line_Item_Subcategory_Dataset_Bool_Exp>;
};


export type Query_RootQuote_Line_Item_Subcategory_Dataset_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quote_Line_Item_Subcategory_Dataset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quote_Line_Item_Subcategory_Dataset_Order_By>>;
  where?: InputMaybe<Quote_Line_Item_Subcategory_Dataset_Bool_Exp>;
};


export type Query_RootQuote_Line_Item_Subcategory_Dataset_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootQuote_Line_Item_Tax_Type_DatasetArgs = {
  distinct_on?: InputMaybe<Array<Quote_Line_Item_Tax_Type_Dataset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quote_Line_Item_Tax_Type_Dataset_Order_By>>;
  where?: InputMaybe<Quote_Line_Item_Tax_Type_Dataset_Bool_Exp>;
};


export type Query_RootQuote_Line_Item_Tax_Type_Dataset_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quote_Line_Item_Tax_Type_Dataset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quote_Line_Item_Tax_Type_Dataset_Order_By>>;
  where?: InputMaybe<Quote_Line_Item_Tax_Type_Dataset_Bool_Exp>;
};


export type Query_RootQuote_Line_Item_Tax_Type_Dataset_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootQuote_Line_Item_Type_DatasetArgs = {
  distinct_on?: InputMaybe<Array<Quote_Line_Item_Type_Dataset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quote_Line_Item_Type_Dataset_Order_By>>;
  where?: InputMaybe<Quote_Line_Item_Type_Dataset_Bool_Exp>;
};


export type Query_RootQuote_Line_Item_Type_Dataset_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quote_Line_Item_Type_Dataset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quote_Line_Item_Type_Dataset_Order_By>>;
  where?: InputMaybe<Quote_Line_Item_Type_Dataset_Bool_Exp>;
};


export type Query_RootQuote_Line_Item_Type_Dataset_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootQuote_Line_ItemsArgs = {
  distinct_on?: InputMaybe<Array<Quote_Line_Items_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quote_Line_Items_Order_By>>;
  where?: InputMaybe<Quote_Line_Items_Bool_Exp>;
};


export type Query_RootQuote_Line_Items_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quote_Line_Items_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quote_Line_Items_Order_By>>;
  where?: InputMaybe<Quote_Line_Items_Bool_Exp>;
};


export type Query_RootQuote_Line_Items_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootQuote_Sk_Job_Type_DatasetArgs = {
  distinct_on?: InputMaybe<Array<Quote_Sk_Job_Type_Dataset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quote_Sk_Job_Type_Dataset_Order_By>>;
  where?: InputMaybe<Quote_Sk_Job_Type_Dataset_Bool_Exp>;
};


export type Query_RootQuote_Sk_Job_Type_Dataset_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quote_Sk_Job_Type_Dataset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quote_Sk_Job_Type_Dataset_Order_By>>;
  where?: InputMaybe<Quote_Sk_Job_Type_Dataset_Bool_Exp>;
};


export type Query_RootQuote_Sk_Job_Type_Dataset_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootQuote_Source_DatasetArgs = {
  distinct_on?: InputMaybe<Array<Quote_Source_Dataset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quote_Source_Dataset_Order_By>>;
  where?: InputMaybe<Quote_Source_Dataset_Bool_Exp>;
};


export type Query_RootQuote_Source_Dataset_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quote_Source_Dataset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quote_Source_Dataset_Order_By>>;
  where?: InputMaybe<Quote_Source_Dataset_Bool_Exp>;
};


export type Query_RootQuote_Source_Dataset_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootQuote_Status_DatasetArgs = {
  distinct_on?: InputMaybe<Array<Quote_Status_Dataset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quote_Status_Dataset_Order_By>>;
  where?: InputMaybe<Quote_Status_Dataset_Bool_Exp>;
};


export type Query_RootQuote_Status_Dataset_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quote_Status_Dataset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quote_Status_Dataset_Order_By>>;
  where?: InputMaybe<Quote_Status_Dataset_Bool_Exp>;
};


export type Query_RootQuote_Status_Dataset_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootQuote_User_MessagesArgs = {
  distinct_on?: InputMaybe<Array<Quote_User_Messages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quote_User_Messages_Order_By>>;
  where?: InputMaybe<Quote_User_Messages_Bool_Exp>;
};


export type Query_RootQuote_User_Messages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quote_User_Messages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quote_User_Messages_Order_By>>;
  where?: InputMaybe<Quote_User_Messages_Bool_Exp>;
};


export type Query_RootQuote_User_Messages_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootQuotesArgs = {
  distinct_on?: InputMaybe<Array<Quotes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quotes_Order_By>>;
  where?: InputMaybe<Quotes_Bool_Exp>;
};


export type Query_RootQuotes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quotes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quotes_Order_By>>;
  where?: InputMaybe<Quotes_Bool_Exp>;
};


export type Query_RootQuotes_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootRevisions_Performance_Evaluations_JournalArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Performance_Evaluations_Journal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Performance_Evaluations_Journal_Order_By>>;
  where?: InputMaybe<Revisions_Performance_Evaluations_Journal_Bool_Exp>;
};


export type Query_RootRevisions_Performance_Evaluations_Journal_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Performance_Evaluations_Journal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Performance_Evaluations_Journal_Order_By>>;
  where?: InputMaybe<Revisions_Performance_Evaluations_Journal_Bool_Exp>;
};


export type Query_RootRevisions_Performance_Evaluations_Journal_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootRevisions_Performance_Evaluations_RevisionsArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Performance_Evaluations_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Performance_Evaluations_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Performance_Evaluations_Revisions_Bool_Exp>;
};


export type Query_RootRevisions_Performance_Evaluations_Revisions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Performance_Evaluations_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Performance_Evaluations_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Performance_Evaluations_Revisions_Bool_Exp>;
};


export type Query_RootRevisions_Performance_Evaluations_Revisions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootRevisions_Performance_Evaluations_Xref_Pumps_JournalArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Performance_Evaluations_Xref_Pumps_Journal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Performance_Evaluations_Xref_Pumps_Journal_Order_By>>;
  where?: InputMaybe<Revisions_Performance_Evaluations_Xref_Pumps_Journal_Bool_Exp>;
};


export type Query_RootRevisions_Performance_Evaluations_Xref_Pumps_Journal_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Performance_Evaluations_Xref_Pumps_Journal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Performance_Evaluations_Xref_Pumps_Journal_Order_By>>;
  where?: InputMaybe<Revisions_Performance_Evaluations_Xref_Pumps_Journal_Bool_Exp>;
};


export type Query_RootRevisions_Performance_Evaluations_Xref_Pumps_Journal_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootRevisions_Performance_Evaluations_Xref_Pumps_RevisionsArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Bool_Exp>;
};


export type Query_RootRevisions_Performance_Evaluations_Xref_Pumps_Revisions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Bool_Exp>;
};


export type Query_RootRevisions_Performance_Evaluations_Xref_Pumps_Revisions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootRevisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_JournalArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_Order_By>>;
  where?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_Bool_Exp>;
};


export type Query_RootRevisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_Order_By>>;
  where?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_Bool_Exp>;
};


export type Query_RootRevisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootRevisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_RevisionsArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Bool_Exp>;
};


export type Query_RootRevisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Bool_Exp>;
};


export type Query_RootRevisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootRevisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_JournalArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_Order_By>>;
  where?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_Bool_Exp>;
};


export type Query_RootRevisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_Order_By>>;
  where?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_Bool_Exp>;
};


export type Query_RootRevisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootRevisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_RevisionsArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Bool_Exp>;
};


export type Query_RootRevisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Bool_Exp>;
};


export type Query_RootRevisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootRevisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_JournalArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_Order_By>>;
  where?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_Bool_Exp>;
};


export type Query_RootRevisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_Order_By>>;
  where?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_Bool_Exp>;
};


export type Query_RootRevisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootRevisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_RevisionsArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Bool_Exp>;
};


export type Query_RootRevisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Bool_Exp>;
};


export type Query_RootRevisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootRevisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_JournalArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_Order_By>>;
  where?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_Bool_Exp>;
};


export type Query_RootRevisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_Order_By>>;
  where?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_Bool_Exp>;
};


export type Query_RootRevisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootRevisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_RevisionsArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Bool_Exp>;
};


export type Query_RootRevisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Bool_Exp>;
};


export type Query_RootRevisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootRevisions_Scenario_Correlations_JournalArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Correlations_Journal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Correlations_Journal_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Correlations_Journal_Bool_Exp>;
};


export type Query_RootRevisions_Scenario_Correlations_Journal_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Correlations_Journal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Correlations_Journal_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Correlations_Journal_Bool_Exp>;
};


export type Query_RootRevisions_Scenario_Correlations_Journal_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootRevisions_Scenario_Correlations_RevisionsArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Correlations_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Correlations_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Correlations_Revisions_Bool_Exp>;
};


export type Query_RootRevisions_Scenario_Correlations_Revisions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Correlations_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Correlations_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Correlations_Revisions_Bool_Exp>;
};


export type Query_RootRevisions_Scenario_Correlations_Revisions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootRevisions_Scenario_Equipment_JournalArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Equipment_Journal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Equipment_Journal_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Equipment_Journal_Bool_Exp>;
};


export type Query_RootRevisions_Scenario_Equipment_Journal_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Equipment_Journal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Equipment_Journal_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Equipment_Journal_Bool_Exp>;
};


export type Query_RootRevisions_Scenario_Equipment_Journal_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootRevisions_Scenario_Equipment_RevisionsArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Equipment_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Equipment_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Equipment_Revisions_Bool_Exp>;
};


export type Query_RootRevisions_Scenario_Equipment_Revisions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Equipment_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Equipment_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Equipment_Revisions_Bool_Exp>;
};


export type Query_RootRevisions_Scenario_Equipment_Revisions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootRevisions_Scenario_Equipment_Xref_Cables_JournalArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Cables_Journal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Cables_Journal_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Equipment_Xref_Cables_Journal_Bool_Exp>;
};


export type Query_RootRevisions_Scenario_Equipment_Xref_Cables_Journal_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Cables_Journal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Cables_Journal_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Equipment_Xref_Cables_Journal_Bool_Exp>;
};


export type Query_RootRevisions_Scenario_Equipment_Xref_Cables_Journal_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootRevisions_Scenario_Equipment_Xref_Cables_RevisionsArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Bool_Exp>;
};


export type Query_RootRevisions_Scenario_Equipment_Xref_Cables_Revisions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Bool_Exp>;
};


export type Query_RootRevisions_Scenario_Equipment_Xref_Cables_Revisions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootRevisions_Scenario_Equipment_Xref_Housings_JournalArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Housings_Journal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Housings_Journal_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Equipment_Xref_Housings_Journal_Bool_Exp>;
};


export type Query_RootRevisions_Scenario_Equipment_Xref_Housings_Journal_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Housings_Journal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Housings_Journal_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Equipment_Xref_Housings_Journal_Bool_Exp>;
};


export type Query_RootRevisions_Scenario_Equipment_Xref_Housings_Journal_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootRevisions_Scenario_Equipment_Xref_Housings_RevisionsArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Bool_Exp>;
};


export type Query_RootRevisions_Scenario_Equipment_Xref_Housings_Revisions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Bool_Exp>;
};


export type Query_RootRevisions_Scenario_Equipment_Xref_Housings_Revisions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootRevisions_Scenario_Equipment_Xref_Intakes_JournalArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Intakes_Journal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Intakes_Journal_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Equipment_Xref_Intakes_Journal_Bool_Exp>;
};


export type Query_RootRevisions_Scenario_Equipment_Xref_Intakes_Journal_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Intakes_Journal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Intakes_Journal_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Equipment_Xref_Intakes_Journal_Bool_Exp>;
};


export type Query_RootRevisions_Scenario_Equipment_Xref_Intakes_Journal_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootRevisions_Scenario_Equipment_Xref_Intakes_RevisionsArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Bool_Exp>;
};


export type Query_RootRevisions_Scenario_Equipment_Xref_Intakes_Revisions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Bool_Exp>;
};


export type Query_RootRevisions_Scenario_Equipment_Xref_Intakes_Revisions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootRevisions_Scenario_Equipment_Xref_Pumps_JournalArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Pumps_Journal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Pumps_Journal_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Equipment_Xref_Pumps_Journal_Bool_Exp>;
};


export type Query_RootRevisions_Scenario_Equipment_Xref_Pumps_Journal_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Pumps_Journal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Pumps_Journal_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Equipment_Xref_Pumps_Journal_Bool_Exp>;
};


export type Query_RootRevisions_Scenario_Equipment_Xref_Pumps_Journal_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootRevisions_Scenario_Equipment_Xref_Pumps_RevisionsArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Bool_Exp>;
};


export type Query_RootRevisions_Scenario_Equipment_Xref_Pumps_Revisions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Bool_Exp>;
};


export type Query_RootRevisions_Scenario_Equipment_Xref_Pumps_Revisions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootRevisions_Scenario_Equipment_Xref_Seals_JournalArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Seals_Journal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Seals_Journal_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Equipment_Xref_Seals_Journal_Bool_Exp>;
};


export type Query_RootRevisions_Scenario_Equipment_Xref_Seals_Journal_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Seals_Journal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Seals_Journal_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Equipment_Xref_Seals_Journal_Bool_Exp>;
};


export type Query_RootRevisions_Scenario_Equipment_Xref_Seals_Journal_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootRevisions_Scenario_Equipment_Xref_Seals_RevisionsArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Seals_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Seals_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Equipment_Xref_Seals_Revisions_Bool_Exp>;
};


export type Query_RootRevisions_Scenario_Equipment_Xref_Seals_Revisions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Seals_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Seals_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Equipment_Xref_Seals_Revisions_Bool_Exp>;
};


export type Query_RootRevisions_Scenario_Equipment_Xref_Seals_Revisions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootRevisions_Scenario_Parameters_JournalArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Parameters_Journal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Parameters_Journal_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Parameters_Journal_Bool_Exp>;
};


export type Query_RootRevisions_Scenario_Parameters_Journal_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Parameters_Journal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Parameters_Journal_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Parameters_Journal_Bool_Exp>;
};


export type Query_RootRevisions_Scenario_Parameters_Journal_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootRevisions_Scenario_Parameters_RevisionsArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Parameters_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Parameters_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Parameters_Revisions_Bool_Exp>;
};


export type Query_RootRevisions_Scenario_Parameters_Revisions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Parameters_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Parameters_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Parameters_Revisions_Bool_Exp>;
};


export type Query_RootRevisions_Scenario_Parameters_Revisions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootRevisions_Scenario_Well_Properties_JournalArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Well_Properties_Journal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Well_Properties_Journal_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Well_Properties_Journal_Bool_Exp>;
};


export type Query_RootRevisions_Scenario_Well_Properties_Journal_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Well_Properties_Journal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Well_Properties_Journal_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Well_Properties_Journal_Bool_Exp>;
};


export type Query_RootRevisions_Scenario_Well_Properties_Journal_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootRevisions_Scenario_Well_Properties_RevisionsArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Well_Properties_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Well_Properties_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Well_Properties_Revisions_Bool_Exp>;
};


export type Query_RootRevisions_Scenario_Well_Properties_Revisions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Well_Properties_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Well_Properties_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Well_Properties_Revisions_Bool_Exp>;
};


export type Query_RootRevisions_Scenario_Well_Properties_Revisions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootRevisions_Scenarios_JournalArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenarios_Journal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenarios_Journal_Order_By>>;
  where?: InputMaybe<Revisions_Scenarios_Journal_Bool_Exp>;
};


export type Query_RootRevisions_Scenarios_Journal_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenarios_Journal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenarios_Journal_Order_By>>;
  where?: InputMaybe<Revisions_Scenarios_Journal_Bool_Exp>;
};


export type Query_RootRevisions_Scenarios_Journal_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootRevisions_Scenarios_RevisionsArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenarios_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenarios_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Scenarios_Revisions_Bool_Exp>;
};


export type Query_RootRevisions_Scenarios_Revisions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenarios_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenarios_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Scenarios_Revisions_Bool_Exp>;
};


export type Query_RootRevisions_Scenarios_Revisions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootRevisions_Sizings_JournalArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Sizings_Journal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Sizings_Journal_Order_By>>;
  where?: InputMaybe<Revisions_Sizings_Journal_Bool_Exp>;
};


export type Query_RootRevisions_Sizings_Journal_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Sizings_Journal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Sizings_Journal_Order_By>>;
  where?: InputMaybe<Revisions_Sizings_Journal_Bool_Exp>;
};


export type Query_RootRevisions_Sizings_Journal_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootRevisions_Sizings_RevisionsArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Sizings_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Sizings_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Sizings_Revisions_Bool_Exp>;
};


export type Query_RootRevisions_Sizings_Revisions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Sizings_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Sizings_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Sizings_Revisions_Bool_Exp>;
};


export type Query_RootRevisions_Sizings_Revisions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootSaturated_Oil_OptionsArgs = {
  distinct_on?: InputMaybe<Array<Saturated_Oil_Options_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Saturated_Oil_Options_Order_By>>;
  where?: InputMaybe<Saturated_Oil_Options_Bool_Exp>;
};


export type Query_RootSaturated_Oil_Options_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Saturated_Oil_Options_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Saturated_Oil_Options_Order_By>>;
  where?: InputMaybe<Saturated_Oil_Options_Bool_Exp>;
};


export type Query_RootSaturated_Oil_Options_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootSc_Equip_Xref_Downhole_Ytool_Bypass_TubingsArgs = {
  distinct_on?: InputMaybe<Array<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Order_By>>;
  where?: InputMaybe<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Bool_Exp>;
};


export type Query_RootSc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Order_By>>;
  where?: InputMaybe<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Bool_Exp>;
};


export type Query_RootSc_Equip_Xref_Downhole_Ytool_Equip_TubingsArgs = {
  distinct_on?: InputMaybe<Array<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Order_By>>;
  where?: InputMaybe<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Bool_Exp>;
};


export type Query_RootSc_Equip_Xref_Downhole_Ytool_Equip_Tubings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Order_By>>;
  where?: InputMaybe<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Bool_Exp>;
};


export type Query_RootSc_Equip_Xref_Uphole_Ytool_Bypass_TubingsArgs = {
  distinct_on?: InputMaybe<Array<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Order_By>>;
  where?: InputMaybe<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Bool_Exp>;
};


export type Query_RootSc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Order_By>>;
  where?: InputMaybe<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Bool_Exp>;
};


export type Query_RootSc_Equip_Xref_Uphole_Ytool_Equip_TubingsArgs = {
  distinct_on?: InputMaybe<Array<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Order_By>>;
  where?: InputMaybe<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Bool_Exp>;
};


export type Query_RootSc_Equip_Xref_Uphole_Ytool_Equip_Tubings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Order_By>>;
  where?: InputMaybe<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Bool_Exp>;
};


export type Query_RootScenario_CorrelationsArgs = {
  distinct_on?: InputMaybe<Array<Scenario_Correlations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Scenario_Correlations_Order_By>>;
  where?: InputMaybe<Scenario_Correlations_Bool_Exp>;
};


export type Query_RootScenario_Correlations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Scenario_Correlations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Scenario_Correlations_Order_By>>;
  where?: InputMaybe<Scenario_Correlations_Bool_Exp>;
};


export type Query_RootScenario_EquipmentArgs = {
  distinct_on?: InputMaybe<Array<Scenario_Equipment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Scenario_Equipment_Order_By>>;
  where?: InputMaybe<Scenario_Equipment_Bool_Exp>;
};


export type Query_RootScenario_Equipment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Scenario_Equipment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Scenario_Equipment_Order_By>>;
  where?: InputMaybe<Scenario_Equipment_Bool_Exp>;
};


export type Query_RootScenario_Equipment_Xref_CablesArgs = {
  distinct_on?: InputMaybe<Array<Scenario_Equipment_Xref_Cables_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Scenario_Equipment_Xref_Cables_Order_By>>;
  where?: InputMaybe<Scenario_Equipment_Xref_Cables_Bool_Exp>;
};


export type Query_RootScenario_Equipment_Xref_Cables_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Scenario_Equipment_Xref_Cables_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Scenario_Equipment_Xref_Cables_Order_By>>;
  where?: InputMaybe<Scenario_Equipment_Xref_Cables_Bool_Exp>;
};


export type Query_RootScenario_Equipment_Xref_HousingsArgs = {
  distinct_on?: InputMaybe<Array<Scenario_Equipment_Xref_Housings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Scenario_Equipment_Xref_Housings_Order_By>>;
  where?: InputMaybe<Scenario_Equipment_Xref_Housings_Bool_Exp>;
};


export type Query_RootScenario_Equipment_Xref_Housings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Scenario_Equipment_Xref_Housings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Scenario_Equipment_Xref_Housings_Order_By>>;
  where?: InputMaybe<Scenario_Equipment_Xref_Housings_Bool_Exp>;
};


export type Query_RootScenario_Equipment_Xref_IntakesArgs = {
  distinct_on?: InputMaybe<Array<Scenario_Equipment_Xref_Intakes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Scenario_Equipment_Xref_Intakes_Order_By>>;
  where?: InputMaybe<Scenario_Equipment_Xref_Intakes_Bool_Exp>;
};


export type Query_RootScenario_Equipment_Xref_Intakes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Scenario_Equipment_Xref_Intakes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Scenario_Equipment_Xref_Intakes_Order_By>>;
  where?: InputMaybe<Scenario_Equipment_Xref_Intakes_Bool_Exp>;
};


export type Query_RootScenario_Equipment_Xref_PumpsArgs = {
  distinct_on?: InputMaybe<Array<Scenario_Equipment_Xref_Pumps_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Scenario_Equipment_Xref_Pumps_Order_By>>;
  where?: InputMaybe<Scenario_Equipment_Xref_Pumps_Bool_Exp>;
};


export type Query_RootScenario_Equipment_Xref_Pumps_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Scenario_Equipment_Xref_Pumps_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Scenario_Equipment_Xref_Pumps_Order_By>>;
  where?: InputMaybe<Scenario_Equipment_Xref_Pumps_Bool_Exp>;
};


export type Query_RootScenario_Equipment_Xref_SealsArgs = {
  distinct_on?: InputMaybe<Array<Scenario_Equipment_Xref_Seals_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Scenario_Equipment_Xref_Seals_Order_By>>;
  where?: InputMaybe<Scenario_Equipment_Xref_Seals_Bool_Exp>;
};


export type Query_RootScenario_Equipment_Xref_Seals_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Scenario_Equipment_Xref_Seals_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Scenario_Equipment_Xref_Seals_Order_By>>;
  where?: InputMaybe<Scenario_Equipment_Xref_Seals_Bool_Exp>;
};


export type Query_RootScenario_ParametersArgs = {
  distinct_on?: InputMaybe<Array<Scenario_Parameters_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Scenario_Parameters_Order_By>>;
  where?: InputMaybe<Scenario_Parameters_Bool_Exp>;
};


export type Query_RootScenario_Parameters_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Scenario_Parameters_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Scenario_Parameters_Order_By>>;
  where?: InputMaybe<Scenario_Parameters_Bool_Exp>;
};


export type Query_RootScenario_ReasonsArgs = {
  distinct_on?: InputMaybe<Array<Scenario_Reasons_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Scenario_Reasons_Order_By>>;
  where?: InputMaybe<Scenario_Reasons_Bool_Exp>;
};


export type Query_RootScenario_Reasons_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Scenario_Reasons_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Scenario_Reasons_Order_By>>;
  where?: InputMaybe<Scenario_Reasons_Bool_Exp>;
};


export type Query_RootScenario_Reasons_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootScenario_Well_PropertiesArgs = {
  distinct_on?: InputMaybe<Array<Scenario_Well_Properties_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Scenario_Well_Properties_Order_By>>;
  where?: InputMaybe<Scenario_Well_Properties_Bool_Exp>;
};


export type Query_RootScenario_Well_Properties_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Scenario_Well_Properties_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Scenario_Well_Properties_Order_By>>;
  where?: InputMaybe<Scenario_Well_Properties_Bool_Exp>;
};


export type Query_RootScenariosArgs = {
  distinct_on?: InputMaybe<Array<Scenarios_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Scenarios_Order_By>>;
  where?: InputMaybe<Scenarios_Bool_Exp>;
};


export type Query_RootScenarios_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Scenarios_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Scenarios_Order_By>>;
  where?: InputMaybe<Scenarios_Bool_Exp>;
};


export type Query_RootSeal_Motor_OilArgs = {
  distinct_on?: InputMaybe<Array<Seal_Motor_Oil_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Seal_Motor_Oil_Order_By>>;
  where?: InputMaybe<Seal_Motor_Oil_Bool_Exp>;
};


export type Query_RootSeal_Motor_Oil_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Seal_Motor_Oil_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Seal_Motor_Oil_Order_By>>;
  where?: InputMaybe<Seal_Motor_Oil_Bool_Exp>;
};


export type Query_RootSeal_Motor_Oil_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootSealsArgs = {
  distinct_on?: InputMaybe<Array<Seals_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Seals_Order_By>>;
  where?: InputMaybe<Seals_Bool_Exp>;
};


export type Query_RootSeals_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Seals_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Seals_Order_By>>;
  where?: InputMaybe<Seals_Bool_Exp>;
};


export type Query_RootSeals_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootSensorsArgs = {
  distinct_on?: InputMaybe<Array<Sensors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sensors_Order_By>>;
  where?: InputMaybe<Sensors_Bool_Exp>;
};


export type Query_RootSensors_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sensors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sensors_Order_By>>;
  where?: InputMaybe<Sensors_Bool_Exp>;
};


export type Query_RootSensors_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootSizing_DispositionsArgs = {
  distinct_on?: InputMaybe<Array<Sizing_Dispositions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sizing_Dispositions_Order_By>>;
  where?: InputMaybe<Sizing_Dispositions_Bool_Exp>;
};


export type Query_RootSizing_Dispositions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sizing_Dispositions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sizing_Dispositions_Order_By>>;
  where?: InputMaybe<Sizing_Dispositions_Bool_Exp>;
};


export type Query_RootSizing_Dispositions_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootSizing_ImportsArgs = {
  distinct_on?: InputMaybe<Array<Sizing_Imports_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sizing_Imports_Order_By>>;
  where?: InputMaybe<Sizing_Imports_Bool_Exp>;
};


export type Query_RootSizing_Imports_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sizing_Imports_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sizing_Imports_Order_By>>;
  where?: InputMaybe<Sizing_Imports_Bool_Exp>;
};


export type Query_RootSizing_Imports_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootSizing_Pumping_TypeArgs = {
  distinct_on?: InputMaybe<Array<Sizing_Pumping_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sizing_Pumping_Type_Order_By>>;
  where?: InputMaybe<Sizing_Pumping_Type_Bool_Exp>;
};


export type Query_RootSizing_Pumping_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sizing_Pumping_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sizing_Pumping_Type_Order_By>>;
  where?: InputMaybe<Sizing_Pumping_Type_Bool_Exp>;
};


export type Query_RootSizing_Pumping_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootSizingsArgs = {
  distinct_on?: InputMaybe<Array<Sizings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sizings_Order_By>>;
  where?: InputMaybe<Sizings_Bool_Exp>;
};


export type Query_RootSizings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sizings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sizings_Order_By>>;
  where?: InputMaybe<Sizings_Bool_Exp>;
};


export type Query_RootSolution_Gas_Oil_Ratio_OptionsArgs = {
  distinct_on?: InputMaybe<Array<Solution_Gas_Oil_Ratio_Options_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Solution_Gas_Oil_Ratio_Options_Order_By>>;
  where?: InputMaybe<Solution_Gas_Oil_Ratio_Options_Bool_Exp>;
};


export type Query_RootSolution_Gas_Oil_Ratio_Options_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Solution_Gas_Oil_Ratio_Options_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Solution_Gas_Oil_Ratio_Options_Order_By>>;
  where?: InputMaybe<Solution_Gas_Oil_Ratio_Options_Bool_Exp>;
};


export type Query_RootSolution_Gas_Oil_Ratio_Options_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootStatusArgs = {
  distinct_on?: InputMaybe<Array<Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Status_Order_By>>;
  where?: InputMaybe<Status_Bool_Exp>;
};


export type Query_RootStatus_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Status_Order_By>>;
  where?: InputMaybe<Status_Bool_Exp>;
};


export type Query_RootStep_Down_TransformersArgs = {
  distinct_on?: InputMaybe<Array<Step_Down_Transformers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Step_Down_Transformers_Order_By>>;
  where?: InputMaybe<Step_Down_Transformers_Bool_Exp>;
};


export type Query_RootStep_Down_Transformers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Step_Down_Transformers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Step_Down_Transformers_Order_By>>;
  where?: InputMaybe<Step_Down_Transformers_Bool_Exp>;
};


export type Query_RootStep_Down_Transformers_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootStep_Up_TransformersArgs = {
  distinct_on?: InputMaybe<Array<Step_Up_Transformers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Step_Up_Transformers_Order_By>>;
  where?: InputMaybe<Step_Up_Transformers_Bool_Exp>;
};


export type Query_RootStep_Up_Transformers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Step_Up_Transformers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Step_Up_Transformers_Order_By>>;
  where?: InputMaybe<Step_Up_Transformers_Bool_Exp>;
};


export type Query_RootStep_Up_Transformers_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootSwitchboardsArgs = {
  distinct_on?: InputMaybe<Array<Switchboards_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Switchboards_Order_By>>;
  where?: InputMaybe<Switchboards_Bool_Exp>;
};


export type Query_RootSwitchboards_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Switchboards_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Switchboards_Order_By>>;
  where?: InputMaybe<Switchboards_Bool_Exp>;
};


export type Query_RootSwitchboards_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootTubing_Flow_OptionsArgs = {
  distinct_on?: InputMaybe<Array<Tubing_Flow_Options_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tubing_Flow_Options_Order_By>>;
  where?: InputMaybe<Tubing_Flow_Options_Bool_Exp>;
};


export type Query_RootTubing_Flow_Options_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tubing_Flow_Options_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tubing_Flow_Options_Order_By>>;
  where?: InputMaybe<Tubing_Flow_Options_Bool_Exp>;
};


export type Query_RootTubing_Flow_Options_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootTubingsArgs = {
  distinct_on?: InputMaybe<Array<Tubings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tubings_Order_By>>;
  where?: InputMaybe<Tubings_Bool_Exp>;
};


export type Query_RootTubings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tubings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tubings_Order_By>>;
  where?: InputMaybe<Tubings_Bool_Exp>;
};


export type Query_RootTubings_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootTubings_TypeArgs = {
  distinct_on?: InputMaybe<Array<Tubings_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tubings_Type_Order_By>>;
  where?: InputMaybe<Tubings_Type_Bool_Exp>;
};


export type Query_RootTubings_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tubings_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tubings_Type_Order_By>>;
  where?: InputMaybe<Tubings_Type_Bool_Exp>;
};


export type Query_RootTubings_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootUnder_Saturated_Oil_OptionsArgs = {
  distinct_on?: InputMaybe<Array<Under_Saturated_Oil_Options_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Under_Saturated_Oil_Options_Order_By>>;
  where?: InputMaybe<Under_Saturated_Oil_Options_Bool_Exp>;
};


export type Query_RootUnder_Saturated_Oil_Options_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Under_Saturated_Oil_Options_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Under_Saturated_Oil_Options_Order_By>>;
  where?: InputMaybe<Under_Saturated_Oil_Options_Bool_Exp>;
};


export type Query_RootUnder_Saturated_Oil_Options_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootUser_Eula_AcceptanceArgs = {
  distinct_on?: InputMaybe<Array<User_Eula_Acceptance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Eula_Acceptance_Order_By>>;
  where?: InputMaybe<User_Eula_Acceptance_Bool_Exp>;
};


export type Query_RootUser_Eula_Acceptance_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Eula_Acceptance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Eula_Acceptance_Order_By>>;
  where?: InputMaybe<User_Eula_Acceptance_Bool_Exp>;
};


export type Query_RootUser_Eula_Acceptance_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootUsersArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Query_RootUsers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Query_RootUsers_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Query_RootVariable_Speed_DrivesArgs = {
  distinct_on?: InputMaybe<Array<Variable_Speed_Drives_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variable_Speed_Drives_Order_By>>;
  where?: InputMaybe<Variable_Speed_Drives_Bool_Exp>;
};


export type Query_RootVariable_Speed_Drives_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Variable_Speed_Drives_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variable_Speed_Drives_Order_By>>;
  where?: InputMaybe<Variable_Speed_Drives_Bool_Exp>;
};


export type Query_RootVariable_Speed_Drives_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootWater_Density_OptionsArgs = {
  distinct_on?: InputMaybe<Array<Water_Density_Options_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Water_Density_Options_Order_By>>;
  where?: InputMaybe<Water_Density_Options_Bool_Exp>;
};


export type Query_RootWater_Density_Options_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Water_Density_Options_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Water_Density_Options_Order_By>>;
  where?: InputMaybe<Water_Density_Options_Bool_Exp>;
};


export type Query_RootWater_Density_Options_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootWater_Solution_Gas_OptionsArgs = {
  distinct_on?: InputMaybe<Array<Water_Solution_Gas_Options_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Water_Solution_Gas_Options_Order_By>>;
  where?: InputMaybe<Water_Solution_Gas_Options_Bool_Exp>;
};


export type Query_RootWater_Solution_Gas_Options_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Water_Solution_Gas_Options_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Water_Solution_Gas_Options_Order_By>>;
  where?: InputMaybe<Water_Solution_Gas_Options_Bool_Exp>;
};


export type Query_RootWater_Solution_Gas_Options_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootWater_Viscosity_OptionsArgs = {
  distinct_on?: InputMaybe<Array<Water_Viscosity_Options_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Water_Viscosity_Options_Order_By>>;
  where?: InputMaybe<Water_Viscosity_Options_Bool_Exp>;
};


export type Query_RootWater_Viscosity_Options_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Water_Viscosity_Options_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Water_Viscosity_Options_Order_By>>;
  where?: InputMaybe<Water_Viscosity_Options_Bool_Exp>;
};


export type Query_RootWater_Viscosity_Options_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootWater_Volume_Factor_OptionsArgs = {
  distinct_on?: InputMaybe<Array<Water_Volume_Factor_Options_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Water_Volume_Factor_Options_Order_By>>;
  where?: InputMaybe<Water_Volume_Factor_Options_Bool_Exp>;
};


export type Query_RootWater_Volume_Factor_Options_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Water_Volume_Factor_Options_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Water_Volume_Factor_Options_Order_By>>;
  where?: InputMaybe<Water_Volume_Factor_Options_Bool_Exp>;
};


export type Query_RootWater_Volume_Factor_Options_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootWell_Gas_Type_OptionsArgs = {
  distinct_on?: InputMaybe<Array<Well_Gas_Type_Options_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Well_Gas_Type_Options_Order_By>>;
  where?: InputMaybe<Well_Gas_Type_Options_Bool_Exp>;
};


export type Query_RootWell_Gas_Type_Options_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Well_Gas_Type_Options_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Well_Gas_Type_Options_Order_By>>;
  where?: InputMaybe<Well_Gas_Type_Options_Bool_Exp>;
};


export type Query_RootWell_Gas_Type_Options_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootWell_Test_Gas_Input_OptionsArgs = {
  distinct_on?: InputMaybe<Array<Well_Test_Gas_Input_Options_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Well_Test_Gas_Input_Options_Order_By>>;
  where?: InputMaybe<Well_Test_Gas_Input_Options_Bool_Exp>;
};


export type Query_RootWell_Test_Gas_Input_Options_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Well_Test_Gas_Input_Options_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Well_Test_Gas_Input_Options_Order_By>>;
  where?: InputMaybe<Well_Test_Gas_Input_Options_Bool_Exp>;
};


export type Query_RootWell_Test_Gas_Input_Options_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootWell_Test_Liquid_Input_OptionsArgs = {
  distinct_on?: InputMaybe<Array<Well_Test_Liquid_Input_Options_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Well_Test_Liquid_Input_Options_Order_By>>;
  where?: InputMaybe<Well_Test_Liquid_Input_Options_Bool_Exp>;
};


export type Query_RootWell_Test_Liquid_Input_Options_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Well_Test_Liquid_Input_Options_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Well_Test_Liquid_Input_Options_Order_By>>;
  where?: InputMaybe<Well_Test_Liquid_Input_Options_Bool_Exp>;
};


export type Query_RootWell_Test_Liquid_Input_Options_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootWell_Test_Pressure_Input_OptionsArgs = {
  distinct_on?: InputMaybe<Array<Well_Test_Pressure_Input_Options_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Well_Test_Pressure_Input_Options_Order_By>>;
  where?: InputMaybe<Well_Test_Pressure_Input_Options_Bool_Exp>;
};


export type Query_RootWell_Test_Pressure_Input_Options_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Well_Test_Pressure_Input_Options_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Well_Test_Pressure_Input_Options_Order_By>>;
  where?: InputMaybe<Well_Test_Pressure_Input_Options_Bool_Exp>;
};


export type Query_RootWell_Test_Pressure_Input_Options_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootWellsArgs = {
  distinct_on?: InputMaybe<Array<Wells_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Wells_Order_By>>;
  where?: InputMaybe<Wells_Bool_Exp>;
};


export type Query_RootWells_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Wells_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Wells_Order_By>>;
  where?: InputMaybe<Wells_Bool_Exp>;
};


export type Query_RootWells_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootY_ToolsArgs = {
  distinct_on?: InputMaybe<Array<Y_Tools_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Y_Tools_Order_By>>;
  where?: InputMaybe<Y_Tools_Bool_Exp>;
};


export type Query_RootY_Tools_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Y_Tools_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Y_Tools_Order_By>>;
  where?: InputMaybe<Y_Tools_Bool_Exp>;
};


export type Query_RootY_Tools_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** columns and relationships of "quote_line_item_category_dataset" */
export type Quote_Line_Item_Category_Dataset = {
  __typename: 'quote_line_item_category_dataset';
  comment?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

/** aggregated selection of "quote_line_item_category_dataset" */
export type Quote_Line_Item_Category_Dataset_Aggregate = {
  __typename: 'quote_line_item_category_dataset_aggregate';
  aggregate?: Maybe<Quote_Line_Item_Category_Dataset_Aggregate_Fields>;
  nodes: Array<Quote_Line_Item_Category_Dataset>;
};

/** aggregate fields of "quote_line_item_category_dataset" */
export type Quote_Line_Item_Category_Dataset_Aggregate_Fields = {
  __typename: 'quote_line_item_category_dataset_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Quote_Line_Item_Category_Dataset_Max_Fields>;
  min?: Maybe<Quote_Line_Item_Category_Dataset_Min_Fields>;
};


/** aggregate fields of "quote_line_item_category_dataset" */
export type Quote_Line_Item_Category_Dataset_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Quote_Line_Item_Category_Dataset_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "quote_line_item_category_dataset". All fields are combined with a logical 'AND'. */
export type Quote_Line_Item_Category_Dataset_Bool_Exp = {
  _and?: InputMaybe<Array<Quote_Line_Item_Category_Dataset_Bool_Exp>>;
  _not?: InputMaybe<Quote_Line_Item_Category_Dataset_Bool_Exp>;
  _or?: InputMaybe<Array<Quote_Line_Item_Category_Dataset_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "quote_line_item_category_dataset" */
export enum Quote_Line_Item_Category_Dataset_Constraint {
  /** unique or primary key constraint on columns "value" */
  QuoteLineItemCategoryDatasetPkey = 'quote_line_item_category_dataset_pkey'
}

export enum Quote_Line_Item_Category_Dataset_Enum {
  /** Credit */
  Credit = 'credit',
  /** Discount */
  Discount = 'discount',
  /** Equipment */
  Equipment = 'equipment',
  /** Product */
  Product = 'product',
  /** Service */
  Service = 'service'
}

/** Boolean expression to compare columns of type "quote_line_item_category_dataset_enum". All fields are combined with logical 'AND'. */
export type Quote_Line_Item_Category_Dataset_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Quote_Line_Item_Category_Dataset_Enum>;
  _in?: InputMaybe<Array<Quote_Line_Item_Category_Dataset_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Quote_Line_Item_Category_Dataset_Enum>;
  _nin?: InputMaybe<Array<Quote_Line_Item_Category_Dataset_Enum>>;
};

/** input type for inserting data into table "quote_line_item_category_dataset" */
export type Quote_Line_Item_Category_Dataset_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Quote_Line_Item_Category_Dataset_Max_Fields = {
  __typename: 'quote_line_item_category_dataset_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Quote_Line_Item_Category_Dataset_Min_Fields = {
  __typename: 'quote_line_item_category_dataset_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "quote_line_item_category_dataset" */
export type Quote_Line_Item_Category_Dataset_Mutation_Response = {
  __typename: 'quote_line_item_category_dataset_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Quote_Line_Item_Category_Dataset>;
};

/** on_conflict condition type for table "quote_line_item_category_dataset" */
export type Quote_Line_Item_Category_Dataset_On_Conflict = {
  constraint: Quote_Line_Item_Category_Dataset_Constraint;
  update_columns?: Array<Quote_Line_Item_Category_Dataset_Update_Column>;
  where?: InputMaybe<Quote_Line_Item_Category_Dataset_Bool_Exp>;
};

/** Ordering options when selecting data from "quote_line_item_category_dataset". */
export type Quote_Line_Item_Category_Dataset_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: quote_line_item_category_dataset */
export type Quote_Line_Item_Category_Dataset_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "quote_line_item_category_dataset" */
export enum Quote_Line_Item_Category_Dataset_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "quote_line_item_category_dataset" */
export type Quote_Line_Item_Category_Dataset_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "quote_line_item_category_dataset" */
export type Quote_Line_Item_Category_Dataset_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Quote_Line_Item_Category_Dataset_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Quote_Line_Item_Category_Dataset_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "quote_line_item_category_dataset" */
export enum Quote_Line_Item_Category_Dataset_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Quote_Line_Item_Category_Dataset_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Quote_Line_Item_Category_Dataset_Set_Input>;
  /** filter the rows which have to be updated */
  where: Quote_Line_Item_Category_Dataset_Bool_Exp;
};

/** columns and relationships of "quote_line_item_serialized_dataset" */
export type Quote_Line_Item_Serialized_Dataset = {
  __typename: 'quote_line_item_serialized_dataset';
  comment?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

/** aggregated selection of "quote_line_item_serialized_dataset" */
export type Quote_Line_Item_Serialized_Dataset_Aggregate = {
  __typename: 'quote_line_item_serialized_dataset_aggregate';
  aggregate?: Maybe<Quote_Line_Item_Serialized_Dataset_Aggregate_Fields>;
  nodes: Array<Quote_Line_Item_Serialized_Dataset>;
};

/** aggregate fields of "quote_line_item_serialized_dataset" */
export type Quote_Line_Item_Serialized_Dataset_Aggregate_Fields = {
  __typename: 'quote_line_item_serialized_dataset_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Quote_Line_Item_Serialized_Dataset_Max_Fields>;
  min?: Maybe<Quote_Line_Item_Serialized_Dataset_Min_Fields>;
};


/** aggregate fields of "quote_line_item_serialized_dataset" */
export type Quote_Line_Item_Serialized_Dataset_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Quote_Line_Item_Serialized_Dataset_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "quote_line_item_serialized_dataset". All fields are combined with a logical 'AND'. */
export type Quote_Line_Item_Serialized_Dataset_Bool_Exp = {
  _and?: InputMaybe<Array<Quote_Line_Item_Serialized_Dataset_Bool_Exp>>;
  _not?: InputMaybe<Quote_Line_Item_Serialized_Dataset_Bool_Exp>;
  _or?: InputMaybe<Array<Quote_Line_Item_Serialized_Dataset_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "quote_line_item_serialized_dataset" */
export enum Quote_Line_Item_Serialized_Dataset_Constraint {
  /** unique or primary key constraint on columns "value" */
  QuoteLineItemSerializedDatasetPkey = 'quote_line_item_serialized_dataset_pkey'
}

export enum Quote_Line_Item_Serialized_Dataset_Enum {
  /** Serialized */
  Serialized = 'serialized',
  /** Unserialized */
  Unserialized = 'unserialized'
}

/** Boolean expression to compare columns of type "quote_line_item_serialized_dataset_enum". All fields are combined with logical 'AND'. */
export type Quote_Line_Item_Serialized_Dataset_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Quote_Line_Item_Serialized_Dataset_Enum>;
  _in?: InputMaybe<Array<Quote_Line_Item_Serialized_Dataset_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Quote_Line_Item_Serialized_Dataset_Enum>;
  _nin?: InputMaybe<Array<Quote_Line_Item_Serialized_Dataset_Enum>>;
};

/** input type for inserting data into table "quote_line_item_serialized_dataset" */
export type Quote_Line_Item_Serialized_Dataset_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Quote_Line_Item_Serialized_Dataset_Max_Fields = {
  __typename: 'quote_line_item_serialized_dataset_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Quote_Line_Item_Serialized_Dataset_Min_Fields = {
  __typename: 'quote_line_item_serialized_dataset_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "quote_line_item_serialized_dataset" */
export type Quote_Line_Item_Serialized_Dataset_Mutation_Response = {
  __typename: 'quote_line_item_serialized_dataset_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Quote_Line_Item_Serialized_Dataset>;
};

/** on_conflict condition type for table "quote_line_item_serialized_dataset" */
export type Quote_Line_Item_Serialized_Dataset_On_Conflict = {
  constraint: Quote_Line_Item_Serialized_Dataset_Constraint;
  update_columns?: Array<Quote_Line_Item_Serialized_Dataset_Update_Column>;
  where?: InputMaybe<Quote_Line_Item_Serialized_Dataset_Bool_Exp>;
};

/** Ordering options when selecting data from "quote_line_item_serialized_dataset". */
export type Quote_Line_Item_Serialized_Dataset_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: quote_line_item_serialized_dataset */
export type Quote_Line_Item_Serialized_Dataset_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "quote_line_item_serialized_dataset" */
export enum Quote_Line_Item_Serialized_Dataset_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "quote_line_item_serialized_dataset" */
export type Quote_Line_Item_Serialized_Dataset_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "quote_line_item_serialized_dataset" */
export type Quote_Line_Item_Serialized_Dataset_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Quote_Line_Item_Serialized_Dataset_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Quote_Line_Item_Serialized_Dataset_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "quote_line_item_serialized_dataset" */
export enum Quote_Line_Item_Serialized_Dataset_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Quote_Line_Item_Serialized_Dataset_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Quote_Line_Item_Serialized_Dataset_Set_Input>;
  /** filter the rows which have to be updated */
  where: Quote_Line_Item_Serialized_Dataset_Bool_Exp;
};

/** columns and relationships of "quote_line_item_source_dataset" */
export type Quote_Line_Item_Source_Dataset = {
  __typename: 'quote_line_item_source_dataset';
  comment?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

/** aggregated selection of "quote_line_item_source_dataset" */
export type Quote_Line_Item_Source_Dataset_Aggregate = {
  __typename: 'quote_line_item_source_dataset_aggregate';
  aggregate?: Maybe<Quote_Line_Item_Source_Dataset_Aggregate_Fields>;
  nodes: Array<Quote_Line_Item_Source_Dataset>;
};

/** aggregate fields of "quote_line_item_source_dataset" */
export type Quote_Line_Item_Source_Dataset_Aggregate_Fields = {
  __typename: 'quote_line_item_source_dataset_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Quote_Line_Item_Source_Dataset_Max_Fields>;
  min?: Maybe<Quote_Line_Item_Source_Dataset_Min_Fields>;
};


/** aggregate fields of "quote_line_item_source_dataset" */
export type Quote_Line_Item_Source_Dataset_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Quote_Line_Item_Source_Dataset_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "quote_line_item_source_dataset". All fields are combined with a logical 'AND'. */
export type Quote_Line_Item_Source_Dataset_Bool_Exp = {
  _and?: InputMaybe<Array<Quote_Line_Item_Source_Dataset_Bool_Exp>>;
  _not?: InputMaybe<Quote_Line_Item_Source_Dataset_Bool_Exp>;
  _or?: InputMaybe<Array<Quote_Line_Item_Source_Dataset_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "quote_line_item_source_dataset" */
export enum Quote_Line_Item_Source_Dataset_Constraint {
  /** unique or primary key constraint on columns "value" */
  QuoteLineItemSourceDatasetPkey = 'quote_line_item_source_dataset_pkey'
}

export enum Quote_Line_Item_Source_Dataset_Enum {
  /** Change Order */
  ChangeOrder = 'change_order',
  /** Copy Quote */
  CopyQuote = 'copy_quote',
  /** New Version */
  NewVersion = 'new_version',
  /** Scenario Autocomplete */
  ScenarioAutocomplete = 'scenario_autocomplete',
  /** Sizing Bulk Select */
  SizingBulkSelect = 'sizing_bulk_select',
  /** Sizing Multi Select */
  SizingMultiSelect = 'sizing_multi_select',
  /** Sizing Single Select */
  SizingSingleSelect = 'sizing_single_select',
  /** User */
  User = 'user'
}

/** Boolean expression to compare columns of type "quote_line_item_source_dataset_enum". All fields are combined with logical 'AND'. */
export type Quote_Line_Item_Source_Dataset_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Quote_Line_Item_Source_Dataset_Enum>;
  _in?: InputMaybe<Array<Quote_Line_Item_Source_Dataset_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Quote_Line_Item_Source_Dataset_Enum>;
  _nin?: InputMaybe<Array<Quote_Line_Item_Source_Dataset_Enum>>;
};

/** input type for inserting data into table "quote_line_item_source_dataset" */
export type Quote_Line_Item_Source_Dataset_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Quote_Line_Item_Source_Dataset_Max_Fields = {
  __typename: 'quote_line_item_source_dataset_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Quote_Line_Item_Source_Dataset_Min_Fields = {
  __typename: 'quote_line_item_source_dataset_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "quote_line_item_source_dataset" */
export type Quote_Line_Item_Source_Dataset_Mutation_Response = {
  __typename: 'quote_line_item_source_dataset_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Quote_Line_Item_Source_Dataset>;
};

/** on_conflict condition type for table "quote_line_item_source_dataset" */
export type Quote_Line_Item_Source_Dataset_On_Conflict = {
  constraint: Quote_Line_Item_Source_Dataset_Constraint;
  update_columns?: Array<Quote_Line_Item_Source_Dataset_Update_Column>;
  where?: InputMaybe<Quote_Line_Item_Source_Dataset_Bool_Exp>;
};

/** Ordering options when selecting data from "quote_line_item_source_dataset". */
export type Quote_Line_Item_Source_Dataset_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: quote_line_item_source_dataset */
export type Quote_Line_Item_Source_Dataset_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "quote_line_item_source_dataset" */
export enum Quote_Line_Item_Source_Dataset_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "quote_line_item_source_dataset" */
export type Quote_Line_Item_Source_Dataset_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "quote_line_item_source_dataset" */
export type Quote_Line_Item_Source_Dataset_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Quote_Line_Item_Source_Dataset_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Quote_Line_Item_Source_Dataset_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "quote_line_item_source_dataset" */
export enum Quote_Line_Item_Source_Dataset_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Quote_Line_Item_Source_Dataset_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Quote_Line_Item_Source_Dataset_Set_Input>;
  /** filter the rows which have to be updated */
  where: Quote_Line_Item_Source_Dataset_Bool_Exp;
};

/** columns and relationships of "quote_line_item_subcategory_dataset" */
export type Quote_Line_Item_Subcategory_Dataset = {
  __typename: 'quote_line_item_subcategory_dataset';
  comment?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

/** aggregated selection of "quote_line_item_subcategory_dataset" */
export type Quote_Line_Item_Subcategory_Dataset_Aggregate = {
  __typename: 'quote_line_item_subcategory_dataset_aggregate';
  aggregate?: Maybe<Quote_Line_Item_Subcategory_Dataset_Aggregate_Fields>;
  nodes: Array<Quote_Line_Item_Subcategory_Dataset>;
};

/** aggregate fields of "quote_line_item_subcategory_dataset" */
export type Quote_Line_Item_Subcategory_Dataset_Aggregate_Fields = {
  __typename: 'quote_line_item_subcategory_dataset_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Quote_Line_Item_Subcategory_Dataset_Max_Fields>;
  min?: Maybe<Quote_Line_Item_Subcategory_Dataset_Min_Fields>;
};


/** aggregate fields of "quote_line_item_subcategory_dataset" */
export type Quote_Line_Item_Subcategory_Dataset_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Quote_Line_Item_Subcategory_Dataset_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "quote_line_item_subcategory_dataset". All fields are combined with a logical 'AND'. */
export type Quote_Line_Item_Subcategory_Dataset_Bool_Exp = {
  _and?: InputMaybe<Array<Quote_Line_Item_Subcategory_Dataset_Bool_Exp>>;
  _not?: InputMaybe<Quote_Line_Item_Subcategory_Dataset_Bool_Exp>;
  _or?: InputMaybe<Array<Quote_Line_Item_Subcategory_Dataset_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "quote_line_item_subcategory_dataset" */
export enum Quote_Line_Item_Subcategory_Dataset_Constraint {
  /** unique or primary key constraint on columns "value" */
  QuoteLineItemSubcategoryDatasetPkey = 'quote_line_item_subcategory_dataset_pkey'
}

export enum Quote_Line_Item_Subcategory_Dataset_Enum {
  /** Consumable */
  Consumable = 'consumable',
  /** Reusable */
  Reusable = 'reusable'
}

/** Boolean expression to compare columns of type "quote_line_item_subcategory_dataset_enum". All fields are combined with logical 'AND'. */
export type Quote_Line_Item_Subcategory_Dataset_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Quote_Line_Item_Subcategory_Dataset_Enum>;
  _in?: InputMaybe<Array<Quote_Line_Item_Subcategory_Dataset_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Quote_Line_Item_Subcategory_Dataset_Enum>;
  _nin?: InputMaybe<Array<Quote_Line_Item_Subcategory_Dataset_Enum>>;
};

/** input type for inserting data into table "quote_line_item_subcategory_dataset" */
export type Quote_Line_Item_Subcategory_Dataset_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Quote_Line_Item_Subcategory_Dataset_Max_Fields = {
  __typename: 'quote_line_item_subcategory_dataset_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Quote_Line_Item_Subcategory_Dataset_Min_Fields = {
  __typename: 'quote_line_item_subcategory_dataset_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "quote_line_item_subcategory_dataset" */
export type Quote_Line_Item_Subcategory_Dataset_Mutation_Response = {
  __typename: 'quote_line_item_subcategory_dataset_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Quote_Line_Item_Subcategory_Dataset>;
};

/** on_conflict condition type for table "quote_line_item_subcategory_dataset" */
export type Quote_Line_Item_Subcategory_Dataset_On_Conflict = {
  constraint: Quote_Line_Item_Subcategory_Dataset_Constraint;
  update_columns?: Array<Quote_Line_Item_Subcategory_Dataset_Update_Column>;
  where?: InputMaybe<Quote_Line_Item_Subcategory_Dataset_Bool_Exp>;
};

/** Ordering options when selecting data from "quote_line_item_subcategory_dataset". */
export type Quote_Line_Item_Subcategory_Dataset_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: quote_line_item_subcategory_dataset */
export type Quote_Line_Item_Subcategory_Dataset_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "quote_line_item_subcategory_dataset" */
export enum Quote_Line_Item_Subcategory_Dataset_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "quote_line_item_subcategory_dataset" */
export type Quote_Line_Item_Subcategory_Dataset_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "quote_line_item_subcategory_dataset" */
export type Quote_Line_Item_Subcategory_Dataset_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Quote_Line_Item_Subcategory_Dataset_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Quote_Line_Item_Subcategory_Dataset_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "quote_line_item_subcategory_dataset" */
export enum Quote_Line_Item_Subcategory_Dataset_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Quote_Line_Item_Subcategory_Dataset_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Quote_Line_Item_Subcategory_Dataset_Set_Input>;
  /** filter the rows which have to be updated */
  where: Quote_Line_Item_Subcategory_Dataset_Bool_Exp;
};

/** columns and relationships of "quote_line_item_tax_type_dataset" */
export type Quote_Line_Item_Tax_Type_Dataset = {
  __typename: 'quote_line_item_tax_type_dataset';
  comment?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

/** aggregated selection of "quote_line_item_tax_type_dataset" */
export type Quote_Line_Item_Tax_Type_Dataset_Aggregate = {
  __typename: 'quote_line_item_tax_type_dataset_aggregate';
  aggregate?: Maybe<Quote_Line_Item_Tax_Type_Dataset_Aggregate_Fields>;
  nodes: Array<Quote_Line_Item_Tax_Type_Dataset>;
};

/** aggregate fields of "quote_line_item_tax_type_dataset" */
export type Quote_Line_Item_Tax_Type_Dataset_Aggregate_Fields = {
  __typename: 'quote_line_item_tax_type_dataset_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Quote_Line_Item_Tax_Type_Dataset_Max_Fields>;
  min?: Maybe<Quote_Line_Item_Tax_Type_Dataset_Min_Fields>;
};


/** aggregate fields of "quote_line_item_tax_type_dataset" */
export type Quote_Line_Item_Tax_Type_Dataset_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Quote_Line_Item_Tax_Type_Dataset_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "quote_line_item_tax_type_dataset". All fields are combined with a logical 'AND'. */
export type Quote_Line_Item_Tax_Type_Dataset_Bool_Exp = {
  _and?: InputMaybe<Array<Quote_Line_Item_Tax_Type_Dataset_Bool_Exp>>;
  _not?: InputMaybe<Quote_Line_Item_Tax_Type_Dataset_Bool_Exp>;
  _or?: InputMaybe<Array<Quote_Line_Item_Tax_Type_Dataset_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "quote_line_item_tax_type_dataset" */
export enum Quote_Line_Item_Tax_Type_Dataset_Constraint {
  /** unique or primary key constraint on columns "value" */
  QuoteLineItemTaxTypeDatasetPkey = 'quote_line_item_tax_type_dataset_pkey'
}

export enum Quote_Line_Item_Tax_Type_Dataset_Enum {
  /** Exempt */
  Exempt = 'exempt',
  /** Free */
  Free = 'free',
  /** Taxed */
  Taxed = 'taxed'
}

/** Boolean expression to compare columns of type "quote_line_item_tax_type_dataset_enum". All fields are combined with logical 'AND'. */
export type Quote_Line_Item_Tax_Type_Dataset_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Quote_Line_Item_Tax_Type_Dataset_Enum>;
  _in?: InputMaybe<Array<Quote_Line_Item_Tax_Type_Dataset_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Quote_Line_Item_Tax_Type_Dataset_Enum>;
  _nin?: InputMaybe<Array<Quote_Line_Item_Tax_Type_Dataset_Enum>>;
};

/** input type for inserting data into table "quote_line_item_tax_type_dataset" */
export type Quote_Line_Item_Tax_Type_Dataset_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Quote_Line_Item_Tax_Type_Dataset_Max_Fields = {
  __typename: 'quote_line_item_tax_type_dataset_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Quote_Line_Item_Tax_Type_Dataset_Min_Fields = {
  __typename: 'quote_line_item_tax_type_dataset_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "quote_line_item_tax_type_dataset" */
export type Quote_Line_Item_Tax_Type_Dataset_Mutation_Response = {
  __typename: 'quote_line_item_tax_type_dataset_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Quote_Line_Item_Tax_Type_Dataset>;
};

/** on_conflict condition type for table "quote_line_item_tax_type_dataset" */
export type Quote_Line_Item_Tax_Type_Dataset_On_Conflict = {
  constraint: Quote_Line_Item_Tax_Type_Dataset_Constraint;
  update_columns?: Array<Quote_Line_Item_Tax_Type_Dataset_Update_Column>;
  where?: InputMaybe<Quote_Line_Item_Tax_Type_Dataset_Bool_Exp>;
};

/** Ordering options when selecting data from "quote_line_item_tax_type_dataset". */
export type Quote_Line_Item_Tax_Type_Dataset_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: quote_line_item_tax_type_dataset */
export type Quote_Line_Item_Tax_Type_Dataset_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "quote_line_item_tax_type_dataset" */
export enum Quote_Line_Item_Tax_Type_Dataset_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "quote_line_item_tax_type_dataset" */
export type Quote_Line_Item_Tax_Type_Dataset_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "quote_line_item_tax_type_dataset" */
export type Quote_Line_Item_Tax_Type_Dataset_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Quote_Line_Item_Tax_Type_Dataset_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Quote_Line_Item_Tax_Type_Dataset_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "quote_line_item_tax_type_dataset" */
export enum Quote_Line_Item_Tax_Type_Dataset_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Quote_Line_Item_Tax_Type_Dataset_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Quote_Line_Item_Tax_Type_Dataset_Set_Input>;
  /** filter the rows which have to be updated */
  where: Quote_Line_Item_Tax_Type_Dataset_Bool_Exp;
};

/** columns and relationships of "quote_line_item_type_dataset" */
export type Quote_Line_Item_Type_Dataset = {
  __typename: 'quote_line_item_type_dataset';
  comment?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

/** aggregated selection of "quote_line_item_type_dataset" */
export type Quote_Line_Item_Type_Dataset_Aggregate = {
  __typename: 'quote_line_item_type_dataset_aggregate';
  aggregate?: Maybe<Quote_Line_Item_Type_Dataset_Aggregate_Fields>;
  nodes: Array<Quote_Line_Item_Type_Dataset>;
};

/** aggregate fields of "quote_line_item_type_dataset" */
export type Quote_Line_Item_Type_Dataset_Aggregate_Fields = {
  __typename: 'quote_line_item_type_dataset_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Quote_Line_Item_Type_Dataset_Max_Fields>;
  min?: Maybe<Quote_Line_Item_Type_Dataset_Min_Fields>;
};


/** aggregate fields of "quote_line_item_type_dataset" */
export type Quote_Line_Item_Type_Dataset_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Quote_Line_Item_Type_Dataset_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "quote_line_item_type_dataset". All fields are combined with a logical 'AND'. */
export type Quote_Line_Item_Type_Dataset_Bool_Exp = {
  _and?: InputMaybe<Array<Quote_Line_Item_Type_Dataset_Bool_Exp>>;
  _not?: InputMaybe<Quote_Line_Item_Type_Dataset_Bool_Exp>;
  _or?: InputMaybe<Array<Quote_Line_Item_Type_Dataset_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "quote_line_item_type_dataset" */
export enum Quote_Line_Item_Type_Dataset_Constraint {
  /** unique or primary key constraint on columns "value" */
  QuoteLineItemTypeDatasetPkey = 'quote_line_item_type_dataset_pkey'
}

export enum Quote_Line_Item_Type_Dataset_Enum {
  /** Cable */
  Cable = 'cable',
  /** Capillary Tube */
  CapillaryTube = 'capillary_tube',
  /** Filters */
  Filters = 'filters',
  /** Gas Separator */
  GasSeparator = 'gas_separator',
  /** Intake */
  Intake = 'intake',
  /** Miscellaneous */
  Miscellaneous = 'miscellaneous',
  /** mle */
  Mle = 'mle',
  /** Motor */
  Motor = 'motor',
  /** Pump */
  Pump = 'pump',
  /** Seal */
  Seal = 'seal',
  /** Sensor */
  Sensor = 'sensor',
  /** Sine Wave */
  SineWave = 'sine_wave',
  /** Sine Wave Filter */
  SineWaveFilter = 'sine_wave_filter',
  /** Step Down Transformer */
  StepDownTransformer = 'step_down_transformer',
  /** Step Up Transformer */
  StepUpTransformer = 'step_up_transformer',
  /** Surface Drive */
  SurfaceDrive = 'surface_drive',
  /** Uncategorized */
  Uncategorized = 'uncategorized'
}

/** Boolean expression to compare columns of type "quote_line_item_type_dataset_enum". All fields are combined with logical 'AND'. */
export type Quote_Line_Item_Type_Dataset_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Quote_Line_Item_Type_Dataset_Enum>;
  _in?: InputMaybe<Array<Quote_Line_Item_Type_Dataset_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Quote_Line_Item_Type_Dataset_Enum>;
  _nin?: InputMaybe<Array<Quote_Line_Item_Type_Dataset_Enum>>;
};

/** input type for inserting data into table "quote_line_item_type_dataset" */
export type Quote_Line_Item_Type_Dataset_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Quote_Line_Item_Type_Dataset_Max_Fields = {
  __typename: 'quote_line_item_type_dataset_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Quote_Line_Item_Type_Dataset_Min_Fields = {
  __typename: 'quote_line_item_type_dataset_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "quote_line_item_type_dataset" */
export type Quote_Line_Item_Type_Dataset_Mutation_Response = {
  __typename: 'quote_line_item_type_dataset_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Quote_Line_Item_Type_Dataset>;
};

/** on_conflict condition type for table "quote_line_item_type_dataset" */
export type Quote_Line_Item_Type_Dataset_On_Conflict = {
  constraint: Quote_Line_Item_Type_Dataset_Constraint;
  update_columns?: Array<Quote_Line_Item_Type_Dataset_Update_Column>;
  where?: InputMaybe<Quote_Line_Item_Type_Dataset_Bool_Exp>;
};

/** Ordering options when selecting data from "quote_line_item_type_dataset". */
export type Quote_Line_Item_Type_Dataset_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: quote_line_item_type_dataset */
export type Quote_Line_Item_Type_Dataset_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "quote_line_item_type_dataset" */
export enum Quote_Line_Item_Type_Dataset_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "quote_line_item_type_dataset" */
export type Quote_Line_Item_Type_Dataset_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "quote_line_item_type_dataset" */
export type Quote_Line_Item_Type_Dataset_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Quote_Line_Item_Type_Dataset_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Quote_Line_Item_Type_Dataset_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "quote_line_item_type_dataset" */
export enum Quote_Line_Item_Type_Dataset_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Quote_Line_Item_Type_Dataset_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Quote_Line_Item_Type_Dataset_Set_Input>;
  /** filter the rows which have to be updated */
  where: Quote_Line_Item_Type_Dataset_Bool_Exp;
};

/** columns and relationships of "quote_line_items" */
export type Quote_Line_Items = {
  __typename: 'quote_line_items';
  /** An object relationship */
  cable?: Maybe<Cables>;
  category?: Maybe<Quote_Line_Item_Category_Dataset_Enum>;
  created_at: Scalars['timestamptz']['output'];
  credit?: Maybe<Scalars['numeric']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  erp_material_long_description?: Maybe<Scalars['String']['output']>;
  erp_material_number?: Maybe<Scalars['String']['output']>;
  erp_material_short_description?: Maybe<Scalars['String']['output']>;
  erp_price?: Maybe<Scalars['numeric']['output']>;
  erp_product_hierarchy?: Maybe<Scalars['String']['output']>;
  erp_serialized?: Maybe<Quote_Line_Item_Serialized_Dataset_Enum>;
  erp_uom?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  intake?: Maybe<Intakes>;
  line_item_type?: Maybe<Quote_Line_Item_Type_Dataset_Enum>;
  margin?: Maybe<Scalars['numeric']['output']>;
  /** An object relationship */
  motor?: Maybe<Motors>;
  /** An object relationship */
  motor_lead_extension?: Maybe<Motor_Lead_Extensions>;
  note?: Maybe<Scalars['String']['output']>;
  parent_order?: Maybe<Scalars['Int']['output']>;
  price_override?: Maybe<Scalars['numeric']['output']>;
  pricing_date?: Maybe<Scalars['date']['output']>;
  /** An object relationship */
  pump?: Maybe<Pumps>;
  quantity?: Maybe<Scalars['Int']['output']>;
  quote_id: Scalars['uuid']['output'];
  /** An object relationship */
  seal?: Maybe<Seals>;
  /** An object relationship */
  sensor?: Maybe<Sensors>;
  source?: Maybe<Quote_Line_Item_Source_Dataset_Enum>;
  spyglass_cable?: Maybe<Scalars['uuid']['output']>;
  spyglass_equipment_import_json?: Maybe<Scalars['jsonb']['output']>;
  spyglass_intake?: Maybe<Scalars['uuid']['output']>;
  spyglass_motor?: Maybe<Scalars['uuid']['output']>;
  spyglass_motor_lead_extension?: Maybe<Scalars['uuid']['output']>;
  spyglass_pump?: Maybe<Scalars['uuid']['output']>;
  spyglass_seal?: Maybe<Scalars['uuid']['output']>;
  spyglass_sensor?: Maybe<Scalars['uuid']['output']>;
  spyglass_step_down_transformer?: Maybe<Scalars['uuid']['output']>;
  spyglass_step_up_transformer?: Maybe<Scalars['uuid']['output']>;
  spyglass_switchboard?: Maybe<Scalars['uuid']['output']>;
  spyglass_variable_speed_drive?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  step_down_transformer?: Maybe<Step_Down_Transformers>;
  /** An object relationship */
  step_up_transformer?: Maybe<Step_Up_Transformers>;
  sub_order?: Maybe<Scalars['Int']['output']>;
  subcategory?: Maybe<Quote_Line_Item_Subcategory_Dataset_Enum>;
  /** An object relationship */
  switchboard?: Maybe<Switchboards>;
  tax_type?: Maybe<Quote_Line_Item_Tax_Type_Dataset_Enum>;
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  variable_speed_drive?: Maybe<Variable_Speed_Drives>;
};


/** columns and relationships of "quote_line_items" */
export type Quote_Line_ItemsSpyglass_Equipment_Import_JsonArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "quote_line_items" */
export type Quote_Line_Items_Aggregate = {
  __typename: 'quote_line_items_aggregate';
  aggregate?: Maybe<Quote_Line_Items_Aggregate_Fields>;
  nodes: Array<Quote_Line_Items>;
};

export type Quote_Line_Items_Aggregate_Bool_Exp = {
  count?: InputMaybe<Quote_Line_Items_Aggregate_Bool_Exp_Count>;
};

export type Quote_Line_Items_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Quote_Line_Items_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Quote_Line_Items_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "quote_line_items" */
export type Quote_Line_Items_Aggregate_Fields = {
  __typename: 'quote_line_items_aggregate_fields';
  avg?: Maybe<Quote_Line_Items_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Quote_Line_Items_Max_Fields>;
  min?: Maybe<Quote_Line_Items_Min_Fields>;
  stddev?: Maybe<Quote_Line_Items_Stddev_Fields>;
  stddev_pop?: Maybe<Quote_Line_Items_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Quote_Line_Items_Stddev_Samp_Fields>;
  sum?: Maybe<Quote_Line_Items_Sum_Fields>;
  var_pop?: Maybe<Quote_Line_Items_Var_Pop_Fields>;
  var_samp?: Maybe<Quote_Line_Items_Var_Samp_Fields>;
  variance?: Maybe<Quote_Line_Items_Variance_Fields>;
};


/** aggregate fields of "quote_line_items" */
export type Quote_Line_Items_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Quote_Line_Items_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "quote_line_items" */
export type Quote_Line_Items_Aggregate_Order_By = {
  avg?: InputMaybe<Quote_Line_Items_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Quote_Line_Items_Max_Order_By>;
  min?: InputMaybe<Quote_Line_Items_Min_Order_By>;
  stddev?: InputMaybe<Quote_Line_Items_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Quote_Line_Items_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Quote_Line_Items_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Quote_Line_Items_Sum_Order_By>;
  var_pop?: InputMaybe<Quote_Line_Items_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Quote_Line_Items_Var_Samp_Order_By>;
  variance?: InputMaybe<Quote_Line_Items_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Quote_Line_Items_Append_Input = {
  spyglass_equipment_import_json?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "quote_line_items" */
export type Quote_Line_Items_Arr_Rel_Insert_Input = {
  data: Array<Quote_Line_Items_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Quote_Line_Items_On_Conflict>;
};

/** aggregate avg on columns */
export type Quote_Line_Items_Avg_Fields = {
  __typename: 'quote_line_items_avg_fields';
  credit?: Maybe<Scalars['Float']['output']>;
  erp_price?: Maybe<Scalars['Float']['output']>;
  margin?: Maybe<Scalars['Float']['output']>;
  parent_order?: Maybe<Scalars['Float']['output']>;
  price_override?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  sub_order?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "quote_line_items" */
export type Quote_Line_Items_Avg_Order_By = {
  credit?: InputMaybe<Order_By>;
  erp_price?: InputMaybe<Order_By>;
  margin?: InputMaybe<Order_By>;
  parent_order?: InputMaybe<Order_By>;
  price_override?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  sub_order?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "quote_line_items". All fields are combined with a logical 'AND'. */
export type Quote_Line_Items_Bool_Exp = {
  _and?: InputMaybe<Array<Quote_Line_Items_Bool_Exp>>;
  _not?: InputMaybe<Quote_Line_Items_Bool_Exp>;
  _or?: InputMaybe<Array<Quote_Line_Items_Bool_Exp>>;
  cable?: InputMaybe<Cables_Bool_Exp>;
  category?: InputMaybe<Quote_Line_Item_Category_Dataset_Enum_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  credit?: InputMaybe<Numeric_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  erp_material_long_description?: InputMaybe<String_Comparison_Exp>;
  erp_material_number?: InputMaybe<String_Comparison_Exp>;
  erp_material_short_description?: InputMaybe<String_Comparison_Exp>;
  erp_price?: InputMaybe<Numeric_Comparison_Exp>;
  erp_product_hierarchy?: InputMaybe<String_Comparison_Exp>;
  erp_serialized?: InputMaybe<Quote_Line_Item_Serialized_Dataset_Enum_Comparison_Exp>;
  erp_uom?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  intake?: InputMaybe<Intakes_Bool_Exp>;
  line_item_type?: InputMaybe<Quote_Line_Item_Type_Dataset_Enum_Comparison_Exp>;
  margin?: InputMaybe<Numeric_Comparison_Exp>;
  motor?: InputMaybe<Motors_Bool_Exp>;
  motor_lead_extension?: InputMaybe<Motor_Lead_Extensions_Bool_Exp>;
  note?: InputMaybe<String_Comparison_Exp>;
  parent_order?: InputMaybe<Int_Comparison_Exp>;
  price_override?: InputMaybe<Numeric_Comparison_Exp>;
  pricing_date?: InputMaybe<Date_Comparison_Exp>;
  pump?: InputMaybe<Pumps_Bool_Exp>;
  quantity?: InputMaybe<Int_Comparison_Exp>;
  quote_id?: InputMaybe<Uuid_Comparison_Exp>;
  seal?: InputMaybe<Seals_Bool_Exp>;
  sensor?: InputMaybe<Sensors_Bool_Exp>;
  source?: InputMaybe<Quote_Line_Item_Source_Dataset_Enum_Comparison_Exp>;
  spyglass_cable?: InputMaybe<Uuid_Comparison_Exp>;
  spyglass_equipment_import_json?: InputMaybe<Jsonb_Comparison_Exp>;
  spyglass_intake?: InputMaybe<Uuid_Comparison_Exp>;
  spyglass_motor?: InputMaybe<Uuid_Comparison_Exp>;
  spyglass_motor_lead_extension?: InputMaybe<Uuid_Comparison_Exp>;
  spyglass_pump?: InputMaybe<Uuid_Comparison_Exp>;
  spyglass_seal?: InputMaybe<Uuid_Comparison_Exp>;
  spyglass_sensor?: InputMaybe<Uuid_Comparison_Exp>;
  spyglass_step_down_transformer?: InputMaybe<Uuid_Comparison_Exp>;
  spyglass_step_up_transformer?: InputMaybe<Uuid_Comparison_Exp>;
  spyglass_switchboard?: InputMaybe<Uuid_Comparison_Exp>;
  spyglass_variable_speed_drive?: InputMaybe<Uuid_Comparison_Exp>;
  step_down_transformer?: InputMaybe<Step_Down_Transformers_Bool_Exp>;
  step_up_transformer?: InputMaybe<Step_Up_Transformers_Bool_Exp>;
  sub_order?: InputMaybe<Int_Comparison_Exp>;
  subcategory?: InputMaybe<Quote_Line_Item_Subcategory_Dataset_Enum_Comparison_Exp>;
  switchboard?: InputMaybe<Switchboards_Bool_Exp>;
  tax_type?: InputMaybe<Quote_Line_Item_Tax_Type_Dataset_Enum_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  variable_speed_drive?: InputMaybe<Variable_Speed_Drives_Bool_Exp>;
};

/** unique or primary key constraints on table "quote_line_items" */
export enum Quote_Line_Items_Constraint {
  /** unique or primary key constraint on columns "id" */
  QuoteLineItemsPkey = 'quote_line_items_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Quote_Line_Items_Delete_At_Path_Input = {
  spyglass_equipment_import_json?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Quote_Line_Items_Delete_Elem_Input = {
  spyglass_equipment_import_json?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Quote_Line_Items_Delete_Key_Input = {
  spyglass_equipment_import_json?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "quote_line_items" */
export type Quote_Line_Items_Inc_Input = {
  credit?: InputMaybe<Scalars['numeric']['input']>;
  erp_price?: InputMaybe<Scalars['numeric']['input']>;
  margin?: InputMaybe<Scalars['numeric']['input']>;
  parent_order?: InputMaybe<Scalars['Int']['input']>;
  price_override?: InputMaybe<Scalars['numeric']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  sub_order?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "quote_line_items" */
export type Quote_Line_Items_Insert_Input = {
  cable?: InputMaybe<Cables_Obj_Rel_Insert_Input>;
  category?: InputMaybe<Quote_Line_Item_Category_Dataset_Enum>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  credit?: InputMaybe<Scalars['numeric']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  erp_material_long_description?: InputMaybe<Scalars['String']['input']>;
  erp_material_number?: InputMaybe<Scalars['String']['input']>;
  erp_material_short_description?: InputMaybe<Scalars['String']['input']>;
  erp_price?: InputMaybe<Scalars['numeric']['input']>;
  erp_product_hierarchy?: InputMaybe<Scalars['String']['input']>;
  erp_serialized?: InputMaybe<Quote_Line_Item_Serialized_Dataset_Enum>;
  erp_uom?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  intake?: InputMaybe<Intakes_Obj_Rel_Insert_Input>;
  line_item_type?: InputMaybe<Quote_Line_Item_Type_Dataset_Enum>;
  margin?: InputMaybe<Scalars['numeric']['input']>;
  motor?: InputMaybe<Motors_Obj_Rel_Insert_Input>;
  motor_lead_extension?: InputMaybe<Motor_Lead_Extensions_Obj_Rel_Insert_Input>;
  note?: InputMaybe<Scalars['String']['input']>;
  parent_order?: InputMaybe<Scalars['Int']['input']>;
  price_override?: InputMaybe<Scalars['numeric']['input']>;
  pricing_date?: InputMaybe<Scalars['date']['input']>;
  pump?: InputMaybe<Pumps_Obj_Rel_Insert_Input>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  quote_id?: InputMaybe<Scalars['uuid']['input']>;
  seal?: InputMaybe<Seals_Obj_Rel_Insert_Input>;
  sensor?: InputMaybe<Sensors_Obj_Rel_Insert_Input>;
  source?: InputMaybe<Quote_Line_Item_Source_Dataset_Enum>;
  spyglass_cable?: InputMaybe<Scalars['uuid']['input']>;
  spyglass_equipment_import_json?: InputMaybe<Scalars['jsonb']['input']>;
  spyglass_intake?: InputMaybe<Scalars['uuid']['input']>;
  spyglass_motor?: InputMaybe<Scalars['uuid']['input']>;
  spyglass_motor_lead_extension?: InputMaybe<Scalars['uuid']['input']>;
  spyglass_pump?: InputMaybe<Scalars['uuid']['input']>;
  spyglass_seal?: InputMaybe<Scalars['uuid']['input']>;
  spyglass_sensor?: InputMaybe<Scalars['uuid']['input']>;
  spyglass_step_down_transformer?: InputMaybe<Scalars['uuid']['input']>;
  spyglass_step_up_transformer?: InputMaybe<Scalars['uuid']['input']>;
  spyglass_switchboard?: InputMaybe<Scalars['uuid']['input']>;
  spyglass_variable_speed_drive?: InputMaybe<Scalars['uuid']['input']>;
  step_down_transformer?: InputMaybe<Step_Down_Transformers_Obj_Rel_Insert_Input>;
  step_up_transformer?: InputMaybe<Step_Up_Transformers_Obj_Rel_Insert_Input>;
  sub_order?: InputMaybe<Scalars['Int']['input']>;
  subcategory?: InputMaybe<Quote_Line_Item_Subcategory_Dataset_Enum>;
  switchboard?: InputMaybe<Switchboards_Obj_Rel_Insert_Input>;
  tax_type?: InputMaybe<Quote_Line_Item_Tax_Type_Dataset_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  variable_speed_drive?: InputMaybe<Variable_Speed_Drives_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Quote_Line_Items_Max_Fields = {
  __typename: 'quote_line_items_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  credit?: Maybe<Scalars['numeric']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  erp_material_long_description?: Maybe<Scalars['String']['output']>;
  erp_material_number?: Maybe<Scalars['String']['output']>;
  erp_material_short_description?: Maybe<Scalars['String']['output']>;
  erp_price?: Maybe<Scalars['numeric']['output']>;
  erp_product_hierarchy?: Maybe<Scalars['String']['output']>;
  erp_uom?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  margin?: Maybe<Scalars['numeric']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  parent_order?: Maybe<Scalars['Int']['output']>;
  price_override?: Maybe<Scalars['numeric']['output']>;
  pricing_date?: Maybe<Scalars['date']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  quote_id?: Maybe<Scalars['uuid']['output']>;
  spyglass_cable?: Maybe<Scalars['uuid']['output']>;
  spyglass_intake?: Maybe<Scalars['uuid']['output']>;
  spyglass_motor?: Maybe<Scalars['uuid']['output']>;
  spyglass_motor_lead_extension?: Maybe<Scalars['uuid']['output']>;
  spyglass_pump?: Maybe<Scalars['uuid']['output']>;
  spyglass_seal?: Maybe<Scalars['uuid']['output']>;
  spyglass_sensor?: Maybe<Scalars['uuid']['output']>;
  spyglass_step_down_transformer?: Maybe<Scalars['uuid']['output']>;
  spyglass_step_up_transformer?: Maybe<Scalars['uuid']['output']>;
  spyglass_switchboard?: Maybe<Scalars['uuid']['output']>;
  spyglass_variable_speed_drive?: Maybe<Scalars['uuid']['output']>;
  sub_order?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "quote_line_items" */
export type Quote_Line_Items_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  credit?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  erp_material_long_description?: InputMaybe<Order_By>;
  erp_material_number?: InputMaybe<Order_By>;
  erp_material_short_description?: InputMaybe<Order_By>;
  erp_price?: InputMaybe<Order_By>;
  erp_product_hierarchy?: InputMaybe<Order_By>;
  erp_uom?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  margin?: InputMaybe<Order_By>;
  note?: InputMaybe<Order_By>;
  parent_order?: InputMaybe<Order_By>;
  price_override?: InputMaybe<Order_By>;
  pricing_date?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  quote_id?: InputMaybe<Order_By>;
  spyglass_cable?: InputMaybe<Order_By>;
  spyglass_intake?: InputMaybe<Order_By>;
  spyglass_motor?: InputMaybe<Order_By>;
  spyglass_motor_lead_extension?: InputMaybe<Order_By>;
  spyglass_pump?: InputMaybe<Order_By>;
  spyglass_seal?: InputMaybe<Order_By>;
  spyglass_sensor?: InputMaybe<Order_By>;
  spyglass_step_down_transformer?: InputMaybe<Order_By>;
  spyglass_step_up_transformer?: InputMaybe<Order_By>;
  spyglass_switchboard?: InputMaybe<Order_By>;
  spyglass_variable_speed_drive?: InputMaybe<Order_By>;
  sub_order?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Quote_Line_Items_Min_Fields = {
  __typename: 'quote_line_items_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  credit?: Maybe<Scalars['numeric']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  erp_material_long_description?: Maybe<Scalars['String']['output']>;
  erp_material_number?: Maybe<Scalars['String']['output']>;
  erp_material_short_description?: Maybe<Scalars['String']['output']>;
  erp_price?: Maybe<Scalars['numeric']['output']>;
  erp_product_hierarchy?: Maybe<Scalars['String']['output']>;
  erp_uom?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  margin?: Maybe<Scalars['numeric']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  parent_order?: Maybe<Scalars['Int']['output']>;
  price_override?: Maybe<Scalars['numeric']['output']>;
  pricing_date?: Maybe<Scalars['date']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  quote_id?: Maybe<Scalars['uuid']['output']>;
  spyglass_cable?: Maybe<Scalars['uuid']['output']>;
  spyglass_intake?: Maybe<Scalars['uuid']['output']>;
  spyglass_motor?: Maybe<Scalars['uuid']['output']>;
  spyglass_motor_lead_extension?: Maybe<Scalars['uuid']['output']>;
  spyglass_pump?: Maybe<Scalars['uuid']['output']>;
  spyglass_seal?: Maybe<Scalars['uuid']['output']>;
  spyglass_sensor?: Maybe<Scalars['uuid']['output']>;
  spyglass_step_down_transformer?: Maybe<Scalars['uuid']['output']>;
  spyglass_step_up_transformer?: Maybe<Scalars['uuid']['output']>;
  spyglass_switchboard?: Maybe<Scalars['uuid']['output']>;
  spyglass_variable_speed_drive?: Maybe<Scalars['uuid']['output']>;
  sub_order?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "quote_line_items" */
export type Quote_Line_Items_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  credit?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  erp_material_long_description?: InputMaybe<Order_By>;
  erp_material_number?: InputMaybe<Order_By>;
  erp_material_short_description?: InputMaybe<Order_By>;
  erp_price?: InputMaybe<Order_By>;
  erp_product_hierarchy?: InputMaybe<Order_By>;
  erp_uom?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  margin?: InputMaybe<Order_By>;
  note?: InputMaybe<Order_By>;
  parent_order?: InputMaybe<Order_By>;
  price_override?: InputMaybe<Order_By>;
  pricing_date?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  quote_id?: InputMaybe<Order_By>;
  spyglass_cable?: InputMaybe<Order_By>;
  spyglass_intake?: InputMaybe<Order_By>;
  spyglass_motor?: InputMaybe<Order_By>;
  spyglass_motor_lead_extension?: InputMaybe<Order_By>;
  spyglass_pump?: InputMaybe<Order_By>;
  spyglass_seal?: InputMaybe<Order_By>;
  spyglass_sensor?: InputMaybe<Order_By>;
  spyglass_step_down_transformer?: InputMaybe<Order_By>;
  spyglass_step_up_transformer?: InputMaybe<Order_By>;
  spyglass_switchboard?: InputMaybe<Order_By>;
  spyglass_variable_speed_drive?: InputMaybe<Order_By>;
  sub_order?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "quote_line_items" */
export type Quote_Line_Items_Mutation_Response = {
  __typename: 'quote_line_items_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Quote_Line_Items>;
};

/** on_conflict condition type for table "quote_line_items" */
export type Quote_Line_Items_On_Conflict = {
  constraint: Quote_Line_Items_Constraint;
  update_columns?: Array<Quote_Line_Items_Update_Column>;
  where?: InputMaybe<Quote_Line_Items_Bool_Exp>;
};

/** Ordering options when selecting data from "quote_line_items". */
export type Quote_Line_Items_Order_By = {
  cable?: InputMaybe<Cables_Order_By>;
  category?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  credit?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  erp_material_long_description?: InputMaybe<Order_By>;
  erp_material_number?: InputMaybe<Order_By>;
  erp_material_short_description?: InputMaybe<Order_By>;
  erp_price?: InputMaybe<Order_By>;
  erp_product_hierarchy?: InputMaybe<Order_By>;
  erp_serialized?: InputMaybe<Order_By>;
  erp_uom?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  intake?: InputMaybe<Intakes_Order_By>;
  line_item_type?: InputMaybe<Order_By>;
  margin?: InputMaybe<Order_By>;
  motor?: InputMaybe<Motors_Order_By>;
  motor_lead_extension?: InputMaybe<Motor_Lead_Extensions_Order_By>;
  note?: InputMaybe<Order_By>;
  parent_order?: InputMaybe<Order_By>;
  price_override?: InputMaybe<Order_By>;
  pricing_date?: InputMaybe<Order_By>;
  pump?: InputMaybe<Pumps_Order_By>;
  quantity?: InputMaybe<Order_By>;
  quote_id?: InputMaybe<Order_By>;
  seal?: InputMaybe<Seals_Order_By>;
  sensor?: InputMaybe<Sensors_Order_By>;
  source?: InputMaybe<Order_By>;
  spyglass_cable?: InputMaybe<Order_By>;
  spyglass_equipment_import_json?: InputMaybe<Order_By>;
  spyglass_intake?: InputMaybe<Order_By>;
  spyglass_motor?: InputMaybe<Order_By>;
  spyglass_motor_lead_extension?: InputMaybe<Order_By>;
  spyglass_pump?: InputMaybe<Order_By>;
  spyglass_seal?: InputMaybe<Order_By>;
  spyglass_sensor?: InputMaybe<Order_By>;
  spyglass_step_down_transformer?: InputMaybe<Order_By>;
  spyglass_step_up_transformer?: InputMaybe<Order_By>;
  spyglass_switchboard?: InputMaybe<Order_By>;
  spyglass_variable_speed_drive?: InputMaybe<Order_By>;
  step_down_transformer?: InputMaybe<Step_Down_Transformers_Order_By>;
  step_up_transformer?: InputMaybe<Step_Up_Transformers_Order_By>;
  sub_order?: InputMaybe<Order_By>;
  subcategory?: InputMaybe<Order_By>;
  switchboard?: InputMaybe<Switchboards_Order_By>;
  tax_type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  variable_speed_drive?: InputMaybe<Variable_Speed_Drives_Order_By>;
};

/** primary key columns input for table: quote_line_items */
export type Quote_Line_Items_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Quote_Line_Items_Prepend_Input = {
  spyglass_equipment_import_json?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "quote_line_items" */
export enum Quote_Line_Items_Select_Column {
  /** column name */
  Category = 'category',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Credit = 'credit',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  ErpMaterialLongDescription = 'erp_material_long_description',
  /** column name */
  ErpMaterialNumber = 'erp_material_number',
  /** column name */
  ErpMaterialShortDescription = 'erp_material_short_description',
  /** column name */
  ErpPrice = 'erp_price',
  /** column name */
  ErpProductHierarchy = 'erp_product_hierarchy',
  /** column name */
  ErpSerialized = 'erp_serialized',
  /** column name */
  ErpUom = 'erp_uom',
  /** column name */
  Id = 'id',
  /** column name */
  LineItemType = 'line_item_type',
  /** column name */
  Margin = 'margin',
  /** column name */
  Note = 'note',
  /** column name */
  ParentOrder = 'parent_order',
  /** column name */
  PriceOverride = 'price_override',
  /** column name */
  PricingDate = 'pricing_date',
  /** column name */
  Quantity = 'quantity',
  /** column name */
  QuoteId = 'quote_id',
  /** column name */
  Source = 'source',
  /** column name */
  SpyglassCable = 'spyglass_cable',
  /** column name */
  SpyglassEquipmentImportJson = 'spyglass_equipment_import_json',
  /** column name */
  SpyglassIntake = 'spyglass_intake',
  /** column name */
  SpyglassMotor = 'spyglass_motor',
  /** column name */
  SpyglassMotorLeadExtension = 'spyglass_motor_lead_extension',
  /** column name */
  SpyglassPump = 'spyglass_pump',
  /** column name */
  SpyglassSeal = 'spyglass_seal',
  /** column name */
  SpyglassSensor = 'spyglass_sensor',
  /** column name */
  SpyglassStepDownTransformer = 'spyglass_step_down_transformer',
  /** column name */
  SpyglassStepUpTransformer = 'spyglass_step_up_transformer',
  /** column name */
  SpyglassSwitchboard = 'spyglass_switchboard',
  /** column name */
  SpyglassVariableSpeedDrive = 'spyglass_variable_speed_drive',
  /** column name */
  SubOrder = 'sub_order',
  /** column name */
  Subcategory = 'subcategory',
  /** column name */
  TaxType = 'tax_type',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "quote_line_items" */
export type Quote_Line_Items_Set_Input = {
  category?: InputMaybe<Quote_Line_Item_Category_Dataset_Enum>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  credit?: InputMaybe<Scalars['numeric']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  erp_material_long_description?: InputMaybe<Scalars['String']['input']>;
  erp_material_number?: InputMaybe<Scalars['String']['input']>;
  erp_material_short_description?: InputMaybe<Scalars['String']['input']>;
  erp_price?: InputMaybe<Scalars['numeric']['input']>;
  erp_product_hierarchy?: InputMaybe<Scalars['String']['input']>;
  erp_serialized?: InputMaybe<Quote_Line_Item_Serialized_Dataset_Enum>;
  erp_uom?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  line_item_type?: InputMaybe<Quote_Line_Item_Type_Dataset_Enum>;
  margin?: InputMaybe<Scalars['numeric']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  parent_order?: InputMaybe<Scalars['Int']['input']>;
  price_override?: InputMaybe<Scalars['numeric']['input']>;
  pricing_date?: InputMaybe<Scalars['date']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  quote_id?: InputMaybe<Scalars['uuid']['input']>;
  source?: InputMaybe<Quote_Line_Item_Source_Dataset_Enum>;
  spyglass_cable?: InputMaybe<Scalars['uuid']['input']>;
  spyglass_equipment_import_json?: InputMaybe<Scalars['jsonb']['input']>;
  spyglass_intake?: InputMaybe<Scalars['uuid']['input']>;
  spyglass_motor?: InputMaybe<Scalars['uuid']['input']>;
  spyglass_motor_lead_extension?: InputMaybe<Scalars['uuid']['input']>;
  spyglass_pump?: InputMaybe<Scalars['uuid']['input']>;
  spyglass_seal?: InputMaybe<Scalars['uuid']['input']>;
  spyglass_sensor?: InputMaybe<Scalars['uuid']['input']>;
  spyglass_step_down_transformer?: InputMaybe<Scalars['uuid']['input']>;
  spyglass_step_up_transformer?: InputMaybe<Scalars['uuid']['input']>;
  spyglass_switchboard?: InputMaybe<Scalars['uuid']['input']>;
  spyglass_variable_speed_drive?: InputMaybe<Scalars['uuid']['input']>;
  sub_order?: InputMaybe<Scalars['Int']['input']>;
  subcategory?: InputMaybe<Quote_Line_Item_Subcategory_Dataset_Enum>;
  tax_type?: InputMaybe<Quote_Line_Item_Tax_Type_Dataset_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Quote_Line_Items_Stddev_Fields = {
  __typename: 'quote_line_items_stddev_fields';
  credit?: Maybe<Scalars['Float']['output']>;
  erp_price?: Maybe<Scalars['Float']['output']>;
  margin?: Maybe<Scalars['Float']['output']>;
  parent_order?: Maybe<Scalars['Float']['output']>;
  price_override?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  sub_order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "quote_line_items" */
export type Quote_Line_Items_Stddev_Order_By = {
  credit?: InputMaybe<Order_By>;
  erp_price?: InputMaybe<Order_By>;
  margin?: InputMaybe<Order_By>;
  parent_order?: InputMaybe<Order_By>;
  price_override?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  sub_order?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Quote_Line_Items_Stddev_Pop_Fields = {
  __typename: 'quote_line_items_stddev_pop_fields';
  credit?: Maybe<Scalars['Float']['output']>;
  erp_price?: Maybe<Scalars['Float']['output']>;
  margin?: Maybe<Scalars['Float']['output']>;
  parent_order?: Maybe<Scalars['Float']['output']>;
  price_override?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  sub_order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "quote_line_items" */
export type Quote_Line_Items_Stddev_Pop_Order_By = {
  credit?: InputMaybe<Order_By>;
  erp_price?: InputMaybe<Order_By>;
  margin?: InputMaybe<Order_By>;
  parent_order?: InputMaybe<Order_By>;
  price_override?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  sub_order?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Quote_Line_Items_Stddev_Samp_Fields = {
  __typename: 'quote_line_items_stddev_samp_fields';
  credit?: Maybe<Scalars['Float']['output']>;
  erp_price?: Maybe<Scalars['Float']['output']>;
  margin?: Maybe<Scalars['Float']['output']>;
  parent_order?: Maybe<Scalars['Float']['output']>;
  price_override?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  sub_order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "quote_line_items" */
export type Quote_Line_Items_Stddev_Samp_Order_By = {
  credit?: InputMaybe<Order_By>;
  erp_price?: InputMaybe<Order_By>;
  margin?: InputMaybe<Order_By>;
  parent_order?: InputMaybe<Order_By>;
  price_override?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  sub_order?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "quote_line_items" */
export type Quote_Line_Items_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Quote_Line_Items_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Quote_Line_Items_Stream_Cursor_Value_Input = {
  category?: InputMaybe<Quote_Line_Item_Category_Dataset_Enum>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  credit?: InputMaybe<Scalars['numeric']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  erp_material_long_description?: InputMaybe<Scalars['String']['input']>;
  erp_material_number?: InputMaybe<Scalars['String']['input']>;
  erp_material_short_description?: InputMaybe<Scalars['String']['input']>;
  erp_price?: InputMaybe<Scalars['numeric']['input']>;
  erp_product_hierarchy?: InputMaybe<Scalars['String']['input']>;
  erp_serialized?: InputMaybe<Quote_Line_Item_Serialized_Dataset_Enum>;
  erp_uom?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  line_item_type?: InputMaybe<Quote_Line_Item_Type_Dataset_Enum>;
  margin?: InputMaybe<Scalars['numeric']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  parent_order?: InputMaybe<Scalars['Int']['input']>;
  price_override?: InputMaybe<Scalars['numeric']['input']>;
  pricing_date?: InputMaybe<Scalars['date']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  quote_id?: InputMaybe<Scalars['uuid']['input']>;
  source?: InputMaybe<Quote_Line_Item_Source_Dataset_Enum>;
  spyglass_cable?: InputMaybe<Scalars['uuid']['input']>;
  spyglass_equipment_import_json?: InputMaybe<Scalars['jsonb']['input']>;
  spyglass_intake?: InputMaybe<Scalars['uuid']['input']>;
  spyglass_motor?: InputMaybe<Scalars['uuid']['input']>;
  spyglass_motor_lead_extension?: InputMaybe<Scalars['uuid']['input']>;
  spyglass_pump?: InputMaybe<Scalars['uuid']['input']>;
  spyglass_seal?: InputMaybe<Scalars['uuid']['input']>;
  spyglass_sensor?: InputMaybe<Scalars['uuid']['input']>;
  spyglass_step_down_transformer?: InputMaybe<Scalars['uuid']['input']>;
  spyglass_step_up_transformer?: InputMaybe<Scalars['uuid']['input']>;
  spyglass_switchboard?: InputMaybe<Scalars['uuid']['input']>;
  spyglass_variable_speed_drive?: InputMaybe<Scalars['uuid']['input']>;
  sub_order?: InputMaybe<Scalars['Int']['input']>;
  subcategory?: InputMaybe<Quote_Line_Item_Subcategory_Dataset_Enum>;
  tax_type?: InputMaybe<Quote_Line_Item_Tax_Type_Dataset_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Quote_Line_Items_Sum_Fields = {
  __typename: 'quote_line_items_sum_fields';
  credit?: Maybe<Scalars['numeric']['output']>;
  erp_price?: Maybe<Scalars['numeric']['output']>;
  margin?: Maybe<Scalars['numeric']['output']>;
  parent_order?: Maybe<Scalars['Int']['output']>;
  price_override?: Maybe<Scalars['numeric']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  sub_order?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "quote_line_items" */
export type Quote_Line_Items_Sum_Order_By = {
  credit?: InputMaybe<Order_By>;
  erp_price?: InputMaybe<Order_By>;
  margin?: InputMaybe<Order_By>;
  parent_order?: InputMaybe<Order_By>;
  price_override?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  sub_order?: InputMaybe<Order_By>;
};

/** update columns of table "quote_line_items" */
export enum Quote_Line_Items_Update_Column {
  /** column name */
  Category = 'category',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Credit = 'credit',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  ErpMaterialLongDescription = 'erp_material_long_description',
  /** column name */
  ErpMaterialNumber = 'erp_material_number',
  /** column name */
  ErpMaterialShortDescription = 'erp_material_short_description',
  /** column name */
  ErpPrice = 'erp_price',
  /** column name */
  ErpProductHierarchy = 'erp_product_hierarchy',
  /** column name */
  ErpSerialized = 'erp_serialized',
  /** column name */
  ErpUom = 'erp_uom',
  /** column name */
  Id = 'id',
  /** column name */
  LineItemType = 'line_item_type',
  /** column name */
  Margin = 'margin',
  /** column name */
  Note = 'note',
  /** column name */
  ParentOrder = 'parent_order',
  /** column name */
  PriceOverride = 'price_override',
  /** column name */
  PricingDate = 'pricing_date',
  /** column name */
  Quantity = 'quantity',
  /** column name */
  QuoteId = 'quote_id',
  /** column name */
  Source = 'source',
  /** column name */
  SpyglassCable = 'spyglass_cable',
  /** column name */
  SpyglassEquipmentImportJson = 'spyglass_equipment_import_json',
  /** column name */
  SpyglassIntake = 'spyglass_intake',
  /** column name */
  SpyglassMotor = 'spyglass_motor',
  /** column name */
  SpyglassMotorLeadExtension = 'spyglass_motor_lead_extension',
  /** column name */
  SpyglassPump = 'spyglass_pump',
  /** column name */
  SpyglassSeal = 'spyglass_seal',
  /** column name */
  SpyglassSensor = 'spyglass_sensor',
  /** column name */
  SpyglassStepDownTransformer = 'spyglass_step_down_transformer',
  /** column name */
  SpyglassStepUpTransformer = 'spyglass_step_up_transformer',
  /** column name */
  SpyglassSwitchboard = 'spyglass_switchboard',
  /** column name */
  SpyglassVariableSpeedDrive = 'spyglass_variable_speed_drive',
  /** column name */
  SubOrder = 'sub_order',
  /** column name */
  Subcategory = 'subcategory',
  /** column name */
  TaxType = 'tax_type',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Quote_Line_Items_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Quote_Line_Items_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Quote_Line_Items_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Quote_Line_Items_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Quote_Line_Items_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Quote_Line_Items_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Quote_Line_Items_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Quote_Line_Items_Set_Input>;
  /** filter the rows which have to be updated */
  where: Quote_Line_Items_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Quote_Line_Items_Var_Pop_Fields = {
  __typename: 'quote_line_items_var_pop_fields';
  credit?: Maybe<Scalars['Float']['output']>;
  erp_price?: Maybe<Scalars['Float']['output']>;
  margin?: Maybe<Scalars['Float']['output']>;
  parent_order?: Maybe<Scalars['Float']['output']>;
  price_override?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  sub_order?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "quote_line_items" */
export type Quote_Line_Items_Var_Pop_Order_By = {
  credit?: InputMaybe<Order_By>;
  erp_price?: InputMaybe<Order_By>;
  margin?: InputMaybe<Order_By>;
  parent_order?: InputMaybe<Order_By>;
  price_override?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  sub_order?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Quote_Line_Items_Var_Samp_Fields = {
  __typename: 'quote_line_items_var_samp_fields';
  credit?: Maybe<Scalars['Float']['output']>;
  erp_price?: Maybe<Scalars['Float']['output']>;
  margin?: Maybe<Scalars['Float']['output']>;
  parent_order?: Maybe<Scalars['Float']['output']>;
  price_override?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  sub_order?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "quote_line_items" */
export type Quote_Line_Items_Var_Samp_Order_By = {
  credit?: InputMaybe<Order_By>;
  erp_price?: InputMaybe<Order_By>;
  margin?: InputMaybe<Order_By>;
  parent_order?: InputMaybe<Order_By>;
  price_override?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  sub_order?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Quote_Line_Items_Variance_Fields = {
  __typename: 'quote_line_items_variance_fields';
  credit?: Maybe<Scalars['Float']['output']>;
  erp_price?: Maybe<Scalars['Float']['output']>;
  margin?: Maybe<Scalars['Float']['output']>;
  parent_order?: Maybe<Scalars['Float']['output']>;
  price_override?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  sub_order?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "quote_line_items" */
export type Quote_Line_Items_Variance_Order_By = {
  credit?: InputMaybe<Order_By>;
  erp_price?: InputMaybe<Order_By>;
  margin?: InputMaybe<Order_By>;
  parent_order?: InputMaybe<Order_By>;
  price_override?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  sub_order?: InputMaybe<Order_By>;
};

/** columns and relationships of "quote_sk_job_type_dataset" */
export type Quote_Sk_Job_Type_Dataset = {
  __typename: 'quote_sk_job_type_dataset';
  comment?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

/** aggregated selection of "quote_sk_job_type_dataset" */
export type Quote_Sk_Job_Type_Dataset_Aggregate = {
  __typename: 'quote_sk_job_type_dataset_aggregate';
  aggregate?: Maybe<Quote_Sk_Job_Type_Dataset_Aggregate_Fields>;
  nodes: Array<Quote_Sk_Job_Type_Dataset>;
};

/** aggregate fields of "quote_sk_job_type_dataset" */
export type Quote_Sk_Job_Type_Dataset_Aggregate_Fields = {
  __typename: 'quote_sk_job_type_dataset_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Quote_Sk_Job_Type_Dataset_Max_Fields>;
  min?: Maybe<Quote_Sk_Job_Type_Dataset_Min_Fields>;
};


/** aggregate fields of "quote_sk_job_type_dataset" */
export type Quote_Sk_Job_Type_Dataset_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Quote_Sk_Job_Type_Dataset_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "quote_sk_job_type_dataset". All fields are combined with a logical 'AND'. */
export type Quote_Sk_Job_Type_Dataset_Bool_Exp = {
  _and?: InputMaybe<Array<Quote_Sk_Job_Type_Dataset_Bool_Exp>>;
  _not?: InputMaybe<Quote_Sk_Job_Type_Dataset_Bool_Exp>;
  _or?: InputMaybe<Array<Quote_Sk_Job_Type_Dataset_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "quote_sk_job_type_dataset" */
export enum Quote_Sk_Job_Type_Dataset_Constraint {
  /** unique or primary key constraint on columns "value" */
  QuoteSkJobTypeDatasetPkey = 'quote_sk_job_type_dataset_pkey'
}

export enum Quote_Sk_Job_Type_Dataset_Enum {
  /** Well Test - SESP RENTAL BOM - INSTALLATION */
  Spyglass_1092000 = 'spyglass_1092000',
  /** Well Test - SESP RENTAL BOM - MONITORING FEE */
  Spyglass_1092002 = 'spyglass_1092002',
  /** Sale/trade - SESP DIRECT SALE BOM - MONITORING FEE */
  Spyglass_1092014 = 'spyglass_1092014',
  /** Sale/trade - SESP DIRECT SALE BOM - INSTALLATION */
  Spyglass_1126619 = 'spyglass_1126619'
}

/** Boolean expression to compare columns of type "quote_sk_job_type_dataset_enum". All fields are combined with logical 'AND'. */
export type Quote_Sk_Job_Type_Dataset_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Quote_Sk_Job_Type_Dataset_Enum>;
  _in?: InputMaybe<Array<Quote_Sk_Job_Type_Dataset_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Quote_Sk_Job_Type_Dataset_Enum>;
  _nin?: InputMaybe<Array<Quote_Sk_Job_Type_Dataset_Enum>>;
};

/** input type for inserting data into table "quote_sk_job_type_dataset" */
export type Quote_Sk_Job_Type_Dataset_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Quote_Sk_Job_Type_Dataset_Max_Fields = {
  __typename: 'quote_sk_job_type_dataset_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Quote_Sk_Job_Type_Dataset_Min_Fields = {
  __typename: 'quote_sk_job_type_dataset_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "quote_sk_job_type_dataset" */
export type Quote_Sk_Job_Type_Dataset_Mutation_Response = {
  __typename: 'quote_sk_job_type_dataset_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Quote_Sk_Job_Type_Dataset>;
};

/** on_conflict condition type for table "quote_sk_job_type_dataset" */
export type Quote_Sk_Job_Type_Dataset_On_Conflict = {
  constraint: Quote_Sk_Job_Type_Dataset_Constraint;
  update_columns?: Array<Quote_Sk_Job_Type_Dataset_Update_Column>;
  where?: InputMaybe<Quote_Sk_Job_Type_Dataset_Bool_Exp>;
};

/** Ordering options when selecting data from "quote_sk_job_type_dataset". */
export type Quote_Sk_Job_Type_Dataset_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: quote_sk_job_type_dataset */
export type Quote_Sk_Job_Type_Dataset_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "quote_sk_job_type_dataset" */
export enum Quote_Sk_Job_Type_Dataset_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "quote_sk_job_type_dataset" */
export type Quote_Sk_Job_Type_Dataset_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "quote_sk_job_type_dataset" */
export type Quote_Sk_Job_Type_Dataset_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Quote_Sk_Job_Type_Dataset_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Quote_Sk_Job_Type_Dataset_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "quote_sk_job_type_dataset" */
export enum Quote_Sk_Job_Type_Dataset_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Quote_Sk_Job_Type_Dataset_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Quote_Sk_Job_Type_Dataset_Set_Input>;
  /** filter the rows which have to be updated */
  where: Quote_Sk_Job_Type_Dataset_Bool_Exp;
};

/** columns and relationships of "quote_source_dataset" */
export type Quote_Source_Dataset = {
  __typename: 'quote_source_dataset';
  comment?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

/** aggregated selection of "quote_source_dataset" */
export type Quote_Source_Dataset_Aggregate = {
  __typename: 'quote_source_dataset_aggregate';
  aggregate?: Maybe<Quote_Source_Dataset_Aggregate_Fields>;
  nodes: Array<Quote_Source_Dataset>;
};

/** aggregate fields of "quote_source_dataset" */
export type Quote_Source_Dataset_Aggregate_Fields = {
  __typename: 'quote_source_dataset_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Quote_Source_Dataset_Max_Fields>;
  min?: Maybe<Quote_Source_Dataset_Min_Fields>;
};


/** aggregate fields of "quote_source_dataset" */
export type Quote_Source_Dataset_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Quote_Source_Dataset_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "quote_source_dataset". All fields are combined with a logical 'AND'. */
export type Quote_Source_Dataset_Bool_Exp = {
  _and?: InputMaybe<Array<Quote_Source_Dataset_Bool_Exp>>;
  _not?: InputMaybe<Quote_Source_Dataset_Bool_Exp>;
  _or?: InputMaybe<Array<Quote_Source_Dataset_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "quote_source_dataset" */
export enum Quote_Source_Dataset_Constraint {
  /** unique or primary key constraint on columns "value" */
  QuoteSourceDatasetPkey = 'quote_source_dataset_pkey'
}

export enum Quote_Source_Dataset_Enum {
  /** Copy Quote */
  CopyQuote = 'copy_quote',
  /** New Version */
  NewVersion = 'new_version',
  /** Scenario Autocomplete */
  ScenarioAutocomplete = 'scenario_autocomplete',
  /** Sizing Bulk Select */
  SizingBulkSelect = 'sizing_bulk_select',
  /** Sizing Multi Select */
  SizingMultiSelect = 'sizing_multi_select',
  /** Sizing Single Select */
  SizingSingleSelect = 'sizing_single_select',
  /** User */
  User = 'user'
}

/** Boolean expression to compare columns of type "quote_source_dataset_enum". All fields are combined with logical 'AND'. */
export type Quote_Source_Dataset_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Quote_Source_Dataset_Enum>;
  _in?: InputMaybe<Array<Quote_Source_Dataset_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Quote_Source_Dataset_Enum>;
  _nin?: InputMaybe<Array<Quote_Source_Dataset_Enum>>;
};

/** input type for inserting data into table "quote_source_dataset" */
export type Quote_Source_Dataset_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Quote_Source_Dataset_Max_Fields = {
  __typename: 'quote_source_dataset_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Quote_Source_Dataset_Min_Fields = {
  __typename: 'quote_source_dataset_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "quote_source_dataset" */
export type Quote_Source_Dataset_Mutation_Response = {
  __typename: 'quote_source_dataset_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Quote_Source_Dataset>;
};

/** input type for inserting object relation for remote table "quote_source_dataset" */
export type Quote_Source_Dataset_Obj_Rel_Insert_Input = {
  data: Quote_Source_Dataset_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Quote_Source_Dataset_On_Conflict>;
};

/** on_conflict condition type for table "quote_source_dataset" */
export type Quote_Source_Dataset_On_Conflict = {
  constraint: Quote_Source_Dataset_Constraint;
  update_columns?: Array<Quote_Source_Dataset_Update_Column>;
  where?: InputMaybe<Quote_Source_Dataset_Bool_Exp>;
};

/** Ordering options when selecting data from "quote_source_dataset". */
export type Quote_Source_Dataset_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: quote_source_dataset */
export type Quote_Source_Dataset_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "quote_source_dataset" */
export enum Quote_Source_Dataset_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "quote_source_dataset" */
export type Quote_Source_Dataset_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "quote_source_dataset" */
export type Quote_Source_Dataset_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Quote_Source_Dataset_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Quote_Source_Dataset_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "quote_source_dataset" */
export enum Quote_Source_Dataset_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Quote_Source_Dataset_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Quote_Source_Dataset_Set_Input>;
  /** filter the rows which have to be updated */
  where: Quote_Source_Dataset_Bool_Exp;
};

/** columns and relationships of "quote_status_dataset" */
export type Quote_Status_Dataset = {
  __typename: 'quote_status_dataset';
  comment?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

/** aggregated selection of "quote_status_dataset" */
export type Quote_Status_Dataset_Aggregate = {
  __typename: 'quote_status_dataset_aggregate';
  aggregate?: Maybe<Quote_Status_Dataset_Aggregate_Fields>;
  nodes: Array<Quote_Status_Dataset>;
};

/** aggregate fields of "quote_status_dataset" */
export type Quote_Status_Dataset_Aggregate_Fields = {
  __typename: 'quote_status_dataset_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Quote_Status_Dataset_Max_Fields>;
  min?: Maybe<Quote_Status_Dataset_Min_Fields>;
};


/** aggregate fields of "quote_status_dataset" */
export type Quote_Status_Dataset_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Quote_Status_Dataset_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "quote_status_dataset". All fields are combined with a logical 'AND'. */
export type Quote_Status_Dataset_Bool_Exp = {
  _and?: InputMaybe<Array<Quote_Status_Dataset_Bool_Exp>>;
  _not?: InputMaybe<Quote_Status_Dataset_Bool_Exp>;
  _or?: InputMaybe<Array<Quote_Status_Dataset_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "quote_status_dataset" */
export enum Quote_Status_Dataset_Constraint {
  /** unique or primary key constraint on columns "value" */
  QuoteStatusDatasetPkey = 'quote_status_dataset_pkey'
}

export enum Quote_Status_Dataset_Enum {
  /** Draft */
  Draft = 'draft',
  /** Published */
  Published = 'published',
  /** Rejected */
  Rejected = 'rejected',
  /** Won */
  Won = 'won'
}

/** Boolean expression to compare columns of type "quote_status_dataset_enum". All fields are combined with logical 'AND'. */
export type Quote_Status_Dataset_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Quote_Status_Dataset_Enum>;
  _in?: InputMaybe<Array<Quote_Status_Dataset_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Quote_Status_Dataset_Enum>;
  _nin?: InputMaybe<Array<Quote_Status_Dataset_Enum>>;
};

/** input type for inserting data into table "quote_status_dataset" */
export type Quote_Status_Dataset_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Quote_Status_Dataset_Max_Fields = {
  __typename: 'quote_status_dataset_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Quote_Status_Dataset_Min_Fields = {
  __typename: 'quote_status_dataset_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "quote_status_dataset" */
export type Quote_Status_Dataset_Mutation_Response = {
  __typename: 'quote_status_dataset_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Quote_Status_Dataset>;
};

/** input type for inserting object relation for remote table "quote_status_dataset" */
export type Quote_Status_Dataset_Obj_Rel_Insert_Input = {
  data: Quote_Status_Dataset_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Quote_Status_Dataset_On_Conflict>;
};

/** on_conflict condition type for table "quote_status_dataset" */
export type Quote_Status_Dataset_On_Conflict = {
  constraint: Quote_Status_Dataset_Constraint;
  update_columns?: Array<Quote_Status_Dataset_Update_Column>;
  where?: InputMaybe<Quote_Status_Dataset_Bool_Exp>;
};

/** Ordering options when selecting data from "quote_status_dataset". */
export type Quote_Status_Dataset_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: quote_status_dataset */
export type Quote_Status_Dataset_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "quote_status_dataset" */
export enum Quote_Status_Dataset_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "quote_status_dataset" */
export type Quote_Status_Dataset_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "quote_status_dataset" */
export type Quote_Status_Dataset_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Quote_Status_Dataset_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Quote_Status_Dataset_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "quote_status_dataset" */
export enum Quote_Status_Dataset_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Quote_Status_Dataset_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Quote_Status_Dataset_Set_Input>;
  /** filter the rows which have to be updated */
  where: Quote_Status_Dataset_Bool_Exp;
};

/** columns and relationships of "quote_user_messages" */
export type Quote_User_Messages = {
  __typename: 'quote_user_messages';
  author_id?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  created_by?: Maybe<Users>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  message?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['timestamptz']['output'];
};

/** aggregated selection of "quote_user_messages" */
export type Quote_User_Messages_Aggregate = {
  __typename: 'quote_user_messages_aggregate';
  aggregate?: Maybe<Quote_User_Messages_Aggregate_Fields>;
  nodes: Array<Quote_User_Messages>;
};

/** aggregate fields of "quote_user_messages" */
export type Quote_User_Messages_Aggregate_Fields = {
  __typename: 'quote_user_messages_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Quote_User_Messages_Max_Fields>;
  min?: Maybe<Quote_User_Messages_Min_Fields>;
};


/** aggregate fields of "quote_user_messages" */
export type Quote_User_Messages_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Quote_User_Messages_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "quote_user_messages". All fields are combined with a logical 'AND'. */
export type Quote_User_Messages_Bool_Exp = {
  _and?: InputMaybe<Array<Quote_User_Messages_Bool_Exp>>;
  _not?: InputMaybe<Quote_User_Messages_Bool_Exp>;
  _or?: InputMaybe<Array<Quote_User_Messages_Bool_Exp>>;
  author_id?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Users_Bool_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  message?: InputMaybe<String_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "quote_user_messages" */
export enum Quote_User_Messages_Constraint {
  /** unique or primary key constraint on columns "id" */
  QuoteUserMessagesPkey = 'quote_user_messages_pkey'
}

/** input type for inserting data into table "quote_user_messages" */
export type Quote_User_Messages_Insert_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Quote_User_Messages_Max_Fields = {
  __typename: 'quote_user_messages_max_fields';
  author_id?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Quote_User_Messages_Min_Fields = {
  __typename: 'quote_user_messages_min_fields';
  author_id?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "quote_user_messages" */
export type Quote_User_Messages_Mutation_Response = {
  __typename: 'quote_user_messages_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Quote_User_Messages>;
};

/** on_conflict condition type for table "quote_user_messages" */
export type Quote_User_Messages_On_Conflict = {
  constraint: Quote_User_Messages_Constraint;
  update_columns?: Array<Quote_User_Messages_Update_Column>;
  where?: InputMaybe<Quote_User_Messages_Bool_Exp>;
};

/** Ordering options when selecting data from "quote_user_messages". */
export type Quote_User_Messages_Order_By = {
  author_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Users_Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  message?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: quote_user_messages */
export type Quote_User_Messages_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "quote_user_messages" */
export enum Quote_User_Messages_Select_Column {
  /** column name */
  AuthorId = 'author_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  Message = 'message',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "quote_user_messages" */
export type Quote_User_Messages_Set_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "quote_user_messages" */
export type Quote_User_Messages_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Quote_User_Messages_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Quote_User_Messages_Stream_Cursor_Value_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "quote_user_messages" */
export enum Quote_User_Messages_Update_Column {
  /** column name */
  AuthorId = 'author_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  Message = 'message',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Quote_User_Messages_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Quote_User_Messages_Set_Input>;
  /** filter the rows which have to be updated */
  where: Quote_User_Messages_Bool_Exp;
};

/** columns and relationships of "quotes" */
export type Quotes = {
  __typename: 'quotes';
  comments?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  customer_rep_email?: Maybe<Scalars['String']['output']>;
  customer_rep_name?: Maybe<Scalars['String']['output']>;
  customer_rep_phone_number?: Maybe<Scalars['String']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  directions?: Maybe<Scalars['String']['output']>;
  erp_address_id?: Maybe<Scalars['String']['output']>;
  erp_address_name?: Maybe<Scalars['String']['output']>;
  erp_contract_number?: Maybe<Scalars['String']['output']>;
  erp_customer_name?: Maybe<Scalars['String']['output']>;
  erp_customer_number?: Maybe<Scalars['String']['output']>;
  erp_full_address?: Maybe<Scalars['String']['output']>;
  erp_nwa_id?: Maybe<Scalars['String']['output']>;
  erp_nwa_name?: Maybe<Scalars['String']['output']>;
  erp_plant_id?: Maybe<Scalars['String']['output']>;
  erp_plant_name?: Maybe<Scalars['String']['output']>;
  erp_price_list_name?: Maybe<Scalars['String']['output']>;
  erp_price_list_number?: Maybe<Scalars['String']['output']>;
  erp_well_country?: Maybe<Scalars['String']['output']>;
  erp_well_id?: Maybe<Scalars['String']['output']>;
  erp_well_name?: Maybe<Scalars['String']['output']>;
  erp_well_region?: Maybe<Scalars['String']['output']>;
  erp_well_uwi?: Maybe<Scalars['String']['output']>;
  error_log_json?: Maybe<Scalars['jsonb']['output']>;
  id: Scalars['uuid']['output'];
  name?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  parent?: Maybe<Quotes>;
  parent_id?: Maybe<Scalars['uuid']['output']>;
  prepared_by_id?: Maybe<Scalars['String']['output']>;
  pricing_date?: Maybe<Scalars['date']['output']>;
  proposed_start_date?: Maybe<Scalars['date']['output']>;
  /** An array relationship */
  quote_line_items: Array<Quote_Line_Items>;
  /** An aggregate relationship */
  quote_line_items_aggregate: Quote_Line_Items_Aggregate;
  /** An object relationship */
  quote_scenario?: Maybe<Scenarios>;
  /** An object relationship */
  quote_source?: Maybe<Quote_Source_Dataset>;
  /** An object relationship */
  quote_status: Quote_Status_Dataset;
  sk_job_id?: Maybe<Scalars['Int']['output']>;
  sk_job_number?: Maybe<Scalars['String']['output']>;
  sk_job_type?: Maybe<Quote_Sk_Job_Type_Dataset_Enum>;
  sk_planning_order?: Maybe<Scalars['String']['output']>;
  sk_proposal_number?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Quote_Source_Dataset_Enum>;
  spyglass_scenario_id?: Maybe<Scalars['uuid']['output']>;
  spyglass_scenario_import_json?: Maybe<Scalars['jsonb']['output']>;
  status: Quote_Status_Dataset_Enum;
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user?: Maybe<Users>;
  version_number?: Maybe<Scalars['Int']['output']>;
};


/** columns and relationships of "quotes" */
export type QuotesError_Log_JsonArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "quotes" */
export type QuotesQuote_Line_ItemsArgs = {
  distinct_on?: InputMaybe<Array<Quote_Line_Items_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quote_Line_Items_Order_By>>;
  where?: InputMaybe<Quote_Line_Items_Bool_Exp>;
};


/** columns and relationships of "quotes" */
export type QuotesQuote_Line_Items_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quote_Line_Items_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quote_Line_Items_Order_By>>;
  where?: InputMaybe<Quote_Line_Items_Bool_Exp>;
};


/** columns and relationships of "quotes" */
export type QuotesSpyglass_Scenario_Import_JsonArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "quotes" */
export type Quotes_Aggregate = {
  __typename: 'quotes_aggregate';
  aggregate?: Maybe<Quotes_Aggregate_Fields>;
  nodes: Array<Quotes>;
};

export type Quotes_Aggregate_Bool_Exp = {
  count?: InputMaybe<Quotes_Aggregate_Bool_Exp_Count>;
};

export type Quotes_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Quotes_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Quotes_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "quotes" */
export type Quotes_Aggregate_Fields = {
  __typename: 'quotes_aggregate_fields';
  avg?: Maybe<Quotes_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Quotes_Max_Fields>;
  min?: Maybe<Quotes_Min_Fields>;
  stddev?: Maybe<Quotes_Stddev_Fields>;
  stddev_pop?: Maybe<Quotes_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Quotes_Stddev_Samp_Fields>;
  sum?: Maybe<Quotes_Sum_Fields>;
  var_pop?: Maybe<Quotes_Var_Pop_Fields>;
  var_samp?: Maybe<Quotes_Var_Samp_Fields>;
  variance?: Maybe<Quotes_Variance_Fields>;
};


/** aggregate fields of "quotes" */
export type Quotes_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Quotes_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "quotes" */
export type Quotes_Aggregate_Order_By = {
  avg?: InputMaybe<Quotes_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Quotes_Max_Order_By>;
  min?: InputMaybe<Quotes_Min_Order_By>;
  stddev?: InputMaybe<Quotes_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Quotes_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Quotes_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Quotes_Sum_Order_By>;
  var_pop?: InputMaybe<Quotes_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Quotes_Var_Samp_Order_By>;
  variance?: InputMaybe<Quotes_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Quotes_Append_Input = {
  error_log_json?: InputMaybe<Scalars['jsonb']['input']>;
  spyglass_scenario_import_json?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "quotes" */
export type Quotes_Arr_Rel_Insert_Input = {
  data: Array<Quotes_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Quotes_On_Conflict>;
};

/** aggregate avg on columns */
export type Quotes_Avg_Fields = {
  __typename: 'quotes_avg_fields';
  sk_job_id?: Maybe<Scalars['Float']['output']>;
  version_number?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "quotes" */
export type Quotes_Avg_Order_By = {
  sk_job_id?: InputMaybe<Order_By>;
  version_number?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "quotes". All fields are combined with a logical 'AND'. */
export type Quotes_Bool_Exp = {
  _and?: InputMaybe<Array<Quotes_Bool_Exp>>;
  _not?: InputMaybe<Quotes_Bool_Exp>;
  _or?: InputMaybe<Array<Quotes_Bool_Exp>>;
  comments?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  currency?: InputMaybe<String_Comparison_Exp>;
  customer_rep_email?: InputMaybe<String_Comparison_Exp>;
  customer_rep_name?: InputMaybe<String_Comparison_Exp>;
  customer_rep_phone_number?: InputMaybe<String_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  directions?: InputMaybe<String_Comparison_Exp>;
  erp_address_id?: InputMaybe<String_Comparison_Exp>;
  erp_address_name?: InputMaybe<String_Comparison_Exp>;
  erp_contract_number?: InputMaybe<String_Comparison_Exp>;
  erp_customer_name?: InputMaybe<String_Comparison_Exp>;
  erp_customer_number?: InputMaybe<String_Comparison_Exp>;
  erp_full_address?: InputMaybe<String_Comparison_Exp>;
  erp_nwa_id?: InputMaybe<String_Comparison_Exp>;
  erp_nwa_name?: InputMaybe<String_Comparison_Exp>;
  erp_plant_id?: InputMaybe<String_Comparison_Exp>;
  erp_plant_name?: InputMaybe<String_Comparison_Exp>;
  erp_price_list_name?: InputMaybe<String_Comparison_Exp>;
  erp_price_list_number?: InputMaybe<String_Comparison_Exp>;
  erp_well_country?: InputMaybe<String_Comparison_Exp>;
  erp_well_id?: InputMaybe<String_Comparison_Exp>;
  erp_well_name?: InputMaybe<String_Comparison_Exp>;
  erp_well_region?: InputMaybe<String_Comparison_Exp>;
  erp_well_uwi?: InputMaybe<String_Comparison_Exp>;
  error_log_json?: InputMaybe<Jsonb_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  note?: InputMaybe<String_Comparison_Exp>;
  parent?: InputMaybe<Quotes_Bool_Exp>;
  parent_id?: InputMaybe<Uuid_Comparison_Exp>;
  prepared_by_id?: InputMaybe<String_Comparison_Exp>;
  pricing_date?: InputMaybe<Date_Comparison_Exp>;
  proposed_start_date?: InputMaybe<Date_Comparison_Exp>;
  quote_line_items?: InputMaybe<Quote_Line_Items_Bool_Exp>;
  quote_line_items_aggregate?: InputMaybe<Quote_Line_Items_Aggregate_Bool_Exp>;
  quote_scenario?: InputMaybe<Scenarios_Bool_Exp>;
  quote_source?: InputMaybe<Quote_Source_Dataset_Bool_Exp>;
  quote_status?: InputMaybe<Quote_Status_Dataset_Bool_Exp>;
  sk_job_id?: InputMaybe<Int_Comparison_Exp>;
  sk_job_number?: InputMaybe<String_Comparison_Exp>;
  sk_job_type?: InputMaybe<Quote_Sk_Job_Type_Dataset_Enum_Comparison_Exp>;
  sk_planning_order?: InputMaybe<String_Comparison_Exp>;
  sk_proposal_number?: InputMaybe<String_Comparison_Exp>;
  source?: InputMaybe<Quote_Source_Dataset_Enum_Comparison_Exp>;
  spyglass_scenario_id?: InputMaybe<Uuid_Comparison_Exp>;
  spyglass_scenario_import_json?: InputMaybe<Jsonb_Comparison_Exp>;
  status?: InputMaybe<Quote_Status_Dataset_Enum_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  version_number?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "quotes" */
export enum Quotes_Constraint {
  /** unique or primary key constraint on columns "id" */
  QuotesPkey = 'quotes_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Quotes_Delete_At_Path_Input = {
  error_log_json?: InputMaybe<Array<Scalars['String']['input']>>;
  spyglass_scenario_import_json?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Quotes_Delete_Elem_Input = {
  error_log_json?: InputMaybe<Scalars['Int']['input']>;
  spyglass_scenario_import_json?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Quotes_Delete_Key_Input = {
  error_log_json?: InputMaybe<Scalars['String']['input']>;
  spyglass_scenario_import_json?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "quotes" */
export type Quotes_Inc_Input = {
  sk_job_id?: InputMaybe<Scalars['Int']['input']>;
  version_number?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "quotes" */
export type Quotes_Insert_Input = {
  comments?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  customer_rep_email?: InputMaybe<Scalars['String']['input']>;
  customer_rep_name?: InputMaybe<Scalars['String']['input']>;
  customer_rep_phone_number?: InputMaybe<Scalars['String']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  directions?: InputMaybe<Scalars['String']['input']>;
  erp_address_id?: InputMaybe<Scalars['String']['input']>;
  erp_address_name?: InputMaybe<Scalars['String']['input']>;
  erp_contract_number?: InputMaybe<Scalars['String']['input']>;
  erp_customer_name?: InputMaybe<Scalars['String']['input']>;
  erp_customer_number?: InputMaybe<Scalars['String']['input']>;
  erp_full_address?: InputMaybe<Scalars['String']['input']>;
  erp_nwa_id?: InputMaybe<Scalars['String']['input']>;
  erp_nwa_name?: InputMaybe<Scalars['String']['input']>;
  erp_plant_id?: InputMaybe<Scalars['String']['input']>;
  erp_plant_name?: InputMaybe<Scalars['String']['input']>;
  erp_price_list_name?: InputMaybe<Scalars['String']['input']>;
  erp_price_list_number?: InputMaybe<Scalars['String']['input']>;
  erp_well_country?: InputMaybe<Scalars['String']['input']>;
  erp_well_id?: InputMaybe<Scalars['String']['input']>;
  erp_well_name?: InputMaybe<Scalars['String']['input']>;
  erp_well_region?: InputMaybe<Scalars['String']['input']>;
  erp_well_uwi?: InputMaybe<Scalars['String']['input']>;
  error_log_json?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  parent?: InputMaybe<Quotes_Obj_Rel_Insert_Input>;
  parent_id?: InputMaybe<Scalars['uuid']['input']>;
  prepared_by_id?: InputMaybe<Scalars['String']['input']>;
  pricing_date?: InputMaybe<Scalars['date']['input']>;
  proposed_start_date?: InputMaybe<Scalars['date']['input']>;
  quote_line_items?: InputMaybe<Quote_Line_Items_Arr_Rel_Insert_Input>;
  quote_scenario?: InputMaybe<Scenarios_Obj_Rel_Insert_Input>;
  quote_source?: InputMaybe<Quote_Source_Dataset_Obj_Rel_Insert_Input>;
  quote_status?: InputMaybe<Quote_Status_Dataset_Obj_Rel_Insert_Input>;
  sk_job_id?: InputMaybe<Scalars['Int']['input']>;
  sk_job_number?: InputMaybe<Scalars['String']['input']>;
  sk_job_type?: InputMaybe<Quote_Sk_Job_Type_Dataset_Enum>;
  sk_planning_order?: InputMaybe<Scalars['String']['input']>;
  sk_proposal_number?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Quote_Source_Dataset_Enum>;
  spyglass_scenario_id?: InputMaybe<Scalars['uuid']['input']>;
  spyglass_scenario_import_json?: InputMaybe<Scalars['jsonb']['input']>;
  status?: InputMaybe<Quote_Status_Dataset_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  version_number?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type Quotes_Max_Fields = {
  __typename: 'quotes_max_fields';
  comments?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  customer_rep_email?: Maybe<Scalars['String']['output']>;
  customer_rep_name?: Maybe<Scalars['String']['output']>;
  customer_rep_phone_number?: Maybe<Scalars['String']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  directions?: Maybe<Scalars['String']['output']>;
  erp_address_id?: Maybe<Scalars['String']['output']>;
  erp_address_name?: Maybe<Scalars['String']['output']>;
  erp_contract_number?: Maybe<Scalars['String']['output']>;
  erp_customer_name?: Maybe<Scalars['String']['output']>;
  erp_customer_number?: Maybe<Scalars['String']['output']>;
  erp_full_address?: Maybe<Scalars['String']['output']>;
  erp_nwa_id?: Maybe<Scalars['String']['output']>;
  erp_nwa_name?: Maybe<Scalars['String']['output']>;
  erp_plant_id?: Maybe<Scalars['String']['output']>;
  erp_plant_name?: Maybe<Scalars['String']['output']>;
  erp_price_list_name?: Maybe<Scalars['String']['output']>;
  erp_price_list_number?: Maybe<Scalars['String']['output']>;
  erp_well_country?: Maybe<Scalars['String']['output']>;
  erp_well_id?: Maybe<Scalars['String']['output']>;
  erp_well_name?: Maybe<Scalars['String']['output']>;
  erp_well_region?: Maybe<Scalars['String']['output']>;
  erp_well_uwi?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  parent_id?: Maybe<Scalars['uuid']['output']>;
  prepared_by_id?: Maybe<Scalars['String']['output']>;
  pricing_date?: Maybe<Scalars['date']['output']>;
  proposed_start_date?: Maybe<Scalars['date']['output']>;
  sk_job_id?: Maybe<Scalars['Int']['output']>;
  sk_job_number?: Maybe<Scalars['String']['output']>;
  sk_planning_order?: Maybe<Scalars['String']['output']>;
  sk_proposal_number?: Maybe<Scalars['String']['output']>;
  spyglass_scenario_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  version_number?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "quotes" */
export type Quotes_Max_Order_By = {
  comments?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  customer_rep_email?: InputMaybe<Order_By>;
  customer_rep_name?: InputMaybe<Order_By>;
  customer_rep_phone_number?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  directions?: InputMaybe<Order_By>;
  erp_address_id?: InputMaybe<Order_By>;
  erp_address_name?: InputMaybe<Order_By>;
  erp_contract_number?: InputMaybe<Order_By>;
  erp_customer_name?: InputMaybe<Order_By>;
  erp_customer_number?: InputMaybe<Order_By>;
  erp_full_address?: InputMaybe<Order_By>;
  erp_nwa_id?: InputMaybe<Order_By>;
  erp_nwa_name?: InputMaybe<Order_By>;
  erp_plant_id?: InputMaybe<Order_By>;
  erp_plant_name?: InputMaybe<Order_By>;
  erp_price_list_name?: InputMaybe<Order_By>;
  erp_price_list_number?: InputMaybe<Order_By>;
  erp_well_country?: InputMaybe<Order_By>;
  erp_well_id?: InputMaybe<Order_By>;
  erp_well_name?: InputMaybe<Order_By>;
  erp_well_region?: InputMaybe<Order_By>;
  erp_well_uwi?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  note?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  prepared_by_id?: InputMaybe<Order_By>;
  pricing_date?: InputMaybe<Order_By>;
  proposed_start_date?: InputMaybe<Order_By>;
  sk_job_id?: InputMaybe<Order_By>;
  sk_job_number?: InputMaybe<Order_By>;
  sk_planning_order?: InputMaybe<Order_By>;
  sk_proposal_number?: InputMaybe<Order_By>;
  spyglass_scenario_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  version_number?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Quotes_Min_Fields = {
  __typename: 'quotes_min_fields';
  comments?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  customer_rep_email?: Maybe<Scalars['String']['output']>;
  customer_rep_name?: Maybe<Scalars['String']['output']>;
  customer_rep_phone_number?: Maybe<Scalars['String']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  directions?: Maybe<Scalars['String']['output']>;
  erp_address_id?: Maybe<Scalars['String']['output']>;
  erp_address_name?: Maybe<Scalars['String']['output']>;
  erp_contract_number?: Maybe<Scalars['String']['output']>;
  erp_customer_name?: Maybe<Scalars['String']['output']>;
  erp_customer_number?: Maybe<Scalars['String']['output']>;
  erp_full_address?: Maybe<Scalars['String']['output']>;
  erp_nwa_id?: Maybe<Scalars['String']['output']>;
  erp_nwa_name?: Maybe<Scalars['String']['output']>;
  erp_plant_id?: Maybe<Scalars['String']['output']>;
  erp_plant_name?: Maybe<Scalars['String']['output']>;
  erp_price_list_name?: Maybe<Scalars['String']['output']>;
  erp_price_list_number?: Maybe<Scalars['String']['output']>;
  erp_well_country?: Maybe<Scalars['String']['output']>;
  erp_well_id?: Maybe<Scalars['String']['output']>;
  erp_well_name?: Maybe<Scalars['String']['output']>;
  erp_well_region?: Maybe<Scalars['String']['output']>;
  erp_well_uwi?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  parent_id?: Maybe<Scalars['uuid']['output']>;
  prepared_by_id?: Maybe<Scalars['String']['output']>;
  pricing_date?: Maybe<Scalars['date']['output']>;
  proposed_start_date?: Maybe<Scalars['date']['output']>;
  sk_job_id?: Maybe<Scalars['Int']['output']>;
  sk_job_number?: Maybe<Scalars['String']['output']>;
  sk_planning_order?: Maybe<Scalars['String']['output']>;
  sk_proposal_number?: Maybe<Scalars['String']['output']>;
  spyglass_scenario_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  version_number?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "quotes" */
export type Quotes_Min_Order_By = {
  comments?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  customer_rep_email?: InputMaybe<Order_By>;
  customer_rep_name?: InputMaybe<Order_By>;
  customer_rep_phone_number?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  directions?: InputMaybe<Order_By>;
  erp_address_id?: InputMaybe<Order_By>;
  erp_address_name?: InputMaybe<Order_By>;
  erp_contract_number?: InputMaybe<Order_By>;
  erp_customer_name?: InputMaybe<Order_By>;
  erp_customer_number?: InputMaybe<Order_By>;
  erp_full_address?: InputMaybe<Order_By>;
  erp_nwa_id?: InputMaybe<Order_By>;
  erp_nwa_name?: InputMaybe<Order_By>;
  erp_plant_id?: InputMaybe<Order_By>;
  erp_plant_name?: InputMaybe<Order_By>;
  erp_price_list_name?: InputMaybe<Order_By>;
  erp_price_list_number?: InputMaybe<Order_By>;
  erp_well_country?: InputMaybe<Order_By>;
  erp_well_id?: InputMaybe<Order_By>;
  erp_well_name?: InputMaybe<Order_By>;
  erp_well_region?: InputMaybe<Order_By>;
  erp_well_uwi?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  note?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  prepared_by_id?: InputMaybe<Order_By>;
  pricing_date?: InputMaybe<Order_By>;
  proposed_start_date?: InputMaybe<Order_By>;
  sk_job_id?: InputMaybe<Order_By>;
  sk_job_number?: InputMaybe<Order_By>;
  sk_planning_order?: InputMaybe<Order_By>;
  sk_proposal_number?: InputMaybe<Order_By>;
  spyglass_scenario_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  version_number?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "quotes" */
export type Quotes_Mutation_Response = {
  __typename: 'quotes_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Quotes>;
};

/** input type for inserting object relation for remote table "quotes" */
export type Quotes_Obj_Rel_Insert_Input = {
  data: Quotes_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Quotes_On_Conflict>;
};

/** on_conflict condition type for table "quotes" */
export type Quotes_On_Conflict = {
  constraint: Quotes_Constraint;
  update_columns?: Array<Quotes_Update_Column>;
  where?: InputMaybe<Quotes_Bool_Exp>;
};

/** Ordering options when selecting data from "quotes". */
export type Quotes_Order_By = {
  comments?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  customer_rep_email?: InputMaybe<Order_By>;
  customer_rep_name?: InputMaybe<Order_By>;
  customer_rep_phone_number?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  directions?: InputMaybe<Order_By>;
  erp_address_id?: InputMaybe<Order_By>;
  erp_address_name?: InputMaybe<Order_By>;
  erp_contract_number?: InputMaybe<Order_By>;
  erp_customer_name?: InputMaybe<Order_By>;
  erp_customer_number?: InputMaybe<Order_By>;
  erp_full_address?: InputMaybe<Order_By>;
  erp_nwa_id?: InputMaybe<Order_By>;
  erp_nwa_name?: InputMaybe<Order_By>;
  erp_plant_id?: InputMaybe<Order_By>;
  erp_plant_name?: InputMaybe<Order_By>;
  erp_price_list_name?: InputMaybe<Order_By>;
  erp_price_list_number?: InputMaybe<Order_By>;
  erp_well_country?: InputMaybe<Order_By>;
  erp_well_id?: InputMaybe<Order_By>;
  erp_well_name?: InputMaybe<Order_By>;
  erp_well_region?: InputMaybe<Order_By>;
  erp_well_uwi?: InputMaybe<Order_By>;
  error_log_json?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  note?: InputMaybe<Order_By>;
  parent?: InputMaybe<Quotes_Order_By>;
  parent_id?: InputMaybe<Order_By>;
  prepared_by_id?: InputMaybe<Order_By>;
  pricing_date?: InputMaybe<Order_By>;
  proposed_start_date?: InputMaybe<Order_By>;
  quote_line_items_aggregate?: InputMaybe<Quote_Line_Items_Aggregate_Order_By>;
  quote_scenario?: InputMaybe<Scenarios_Order_By>;
  quote_source?: InputMaybe<Quote_Source_Dataset_Order_By>;
  quote_status?: InputMaybe<Quote_Status_Dataset_Order_By>;
  sk_job_id?: InputMaybe<Order_By>;
  sk_job_number?: InputMaybe<Order_By>;
  sk_job_type?: InputMaybe<Order_By>;
  sk_planning_order?: InputMaybe<Order_By>;
  sk_proposal_number?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
  spyglass_scenario_id?: InputMaybe<Order_By>;
  spyglass_scenario_import_json?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  version_number?: InputMaybe<Order_By>;
};

/** primary key columns input for table: quotes */
export type Quotes_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Quotes_Prepend_Input = {
  error_log_json?: InputMaybe<Scalars['jsonb']['input']>;
  spyglass_scenario_import_json?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "quotes" */
export enum Quotes_Select_Column {
  /** column name */
  Comments = 'comments',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Currency = 'currency',
  /** column name */
  CustomerRepEmail = 'customer_rep_email',
  /** column name */
  CustomerRepName = 'customer_rep_name',
  /** column name */
  CustomerRepPhoneNumber = 'customer_rep_phone_number',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Directions = 'directions',
  /** column name */
  ErpAddressId = 'erp_address_id',
  /** column name */
  ErpAddressName = 'erp_address_name',
  /** column name */
  ErpContractNumber = 'erp_contract_number',
  /** column name */
  ErpCustomerName = 'erp_customer_name',
  /** column name */
  ErpCustomerNumber = 'erp_customer_number',
  /** column name */
  ErpFullAddress = 'erp_full_address',
  /** column name */
  ErpNwaId = 'erp_nwa_id',
  /** column name */
  ErpNwaName = 'erp_nwa_name',
  /** column name */
  ErpPlantId = 'erp_plant_id',
  /** column name */
  ErpPlantName = 'erp_plant_name',
  /** column name */
  ErpPriceListName = 'erp_price_list_name',
  /** column name */
  ErpPriceListNumber = 'erp_price_list_number',
  /** column name */
  ErpWellCountry = 'erp_well_country',
  /** column name */
  ErpWellId = 'erp_well_id',
  /** column name */
  ErpWellName = 'erp_well_name',
  /** column name */
  ErpWellRegion = 'erp_well_region',
  /** column name */
  ErpWellUwi = 'erp_well_uwi',
  /** column name */
  ErrorLogJson = 'error_log_json',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Note = 'note',
  /** column name */
  ParentId = 'parent_id',
  /** column name */
  PreparedById = 'prepared_by_id',
  /** column name */
  PricingDate = 'pricing_date',
  /** column name */
  ProposedStartDate = 'proposed_start_date',
  /** column name */
  SkJobId = 'sk_job_id',
  /** column name */
  SkJobNumber = 'sk_job_number',
  /** column name */
  SkJobType = 'sk_job_type',
  /** column name */
  SkPlanningOrder = 'sk_planning_order',
  /** column name */
  SkProposalNumber = 'sk_proposal_number',
  /** column name */
  Source = 'source',
  /** column name */
  SpyglassScenarioId = 'spyglass_scenario_id',
  /** column name */
  SpyglassScenarioImportJson = 'spyglass_scenario_import_json',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  VersionNumber = 'version_number'
}

/** input type for updating data in table "quotes" */
export type Quotes_Set_Input = {
  comments?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  customer_rep_email?: InputMaybe<Scalars['String']['input']>;
  customer_rep_name?: InputMaybe<Scalars['String']['input']>;
  customer_rep_phone_number?: InputMaybe<Scalars['String']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  directions?: InputMaybe<Scalars['String']['input']>;
  erp_address_id?: InputMaybe<Scalars['String']['input']>;
  erp_address_name?: InputMaybe<Scalars['String']['input']>;
  erp_contract_number?: InputMaybe<Scalars['String']['input']>;
  erp_customer_name?: InputMaybe<Scalars['String']['input']>;
  erp_customer_number?: InputMaybe<Scalars['String']['input']>;
  erp_full_address?: InputMaybe<Scalars['String']['input']>;
  erp_nwa_id?: InputMaybe<Scalars['String']['input']>;
  erp_nwa_name?: InputMaybe<Scalars['String']['input']>;
  erp_plant_id?: InputMaybe<Scalars['String']['input']>;
  erp_plant_name?: InputMaybe<Scalars['String']['input']>;
  erp_price_list_name?: InputMaybe<Scalars['String']['input']>;
  erp_price_list_number?: InputMaybe<Scalars['String']['input']>;
  erp_well_country?: InputMaybe<Scalars['String']['input']>;
  erp_well_id?: InputMaybe<Scalars['String']['input']>;
  erp_well_name?: InputMaybe<Scalars['String']['input']>;
  erp_well_region?: InputMaybe<Scalars['String']['input']>;
  erp_well_uwi?: InputMaybe<Scalars['String']['input']>;
  error_log_json?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  parent_id?: InputMaybe<Scalars['uuid']['input']>;
  prepared_by_id?: InputMaybe<Scalars['String']['input']>;
  pricing_date?: InputMaybe<Scalars['date']['input']>;
  proposed_start_date?: InputMaybe<Scalars['date']['input']>;
  sk_job_id?: InputMaybe<Scalars['Int']['input']>;
  sk_job_number?: InputMaybe<Scalars['String']['input']>;
  sk_job_type?: InputMaybe<Quote_Sk_Job_Type_Dataset_Enum>;
  sk_planning_order?: InputMaybe<Scalars['String']['input']>;
  sk_proposal_number?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Quote_Source_Dataset_Enum>;
  spyglass_scenario_id?: InputMaybe<Scalars['uuid']['input']>;
  spyglass_scenario_import_json?: InputMaybe<Scalars['jsonb']['input']>;
  status?: InputMaybe<Quote_Status_Dataset_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  version_number?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Quotes_Stddev_Fields = {
  __typename: 'quotes_stddev_fields';
  sk_job_id?: Maybe<Scalars['Float']['output']>;
  version_number?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "quotes" */
export type Quotes_Stddev_Order_By = {
  sk_job_id?: InputMaybe<Order_By>;
  version_number?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Quotes_Stddev_Pop_Fields = {
  __typename: 'quotes_stddev_pop_fields';
  sk_job_id?: Maybe<Scalars['Float']['output']>;
  version_number?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "quotes" */
export type Quotes_Stddev_Pop_Order_By = {
  sk_job_id?: InputMaybe<Order_By>;
  version_number?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Quotes_Stddev_Samp_Fields = {
  __typename: 'quotes_stddev_samp_fields';
  sk_job_id?: Maybe<Scalars['Float']['output']>;
  version_number?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "quotes" */
export type Quotes_Stddev_Samp_Order_By = {
  sk_job_id?: InputMaybe<Order_By>;
  version_number?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "quotes" */
export type Quotes_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Quotes_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Quotes_Stream_Cursor_Value_Input = {
  comments?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  customer_rep_email?: InputMaybe<Scalars['String']['input']>;
  customer_rep_name?: InputMaybe<Scalars['String']['input']>;
  customer_rep_phone_number?: InputMaybe<Scalars['String']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  directions?: InputMaybe<Scalars['String']['input']>;
  erp_address_id?: InputMaybe<Scalars['String']['input']>;
  erp_address_name?: InputMaybe<Scalars['String']['input']>;
  erp_contract_number?: InputMaybe<Scalars['String']['input']>;
  erp_customer_name?: InputMaybe<Scalars['String']['input']>;
  erp_customer_number?: InputMaybe<Scalars['String']['input']>;
  erp_full_address?: InputMaybe<Scalars['String']['input']>;
  erp_nwa_id?: InputMaybe<Scalars['String']['input']>;
  erp_nwa_name?: InputMaybe<Scalars['String']['input']>;
  erp_plant_id?: InputMaybe<Scalars['String']['input']>;
  erp_plant_name?: InputMaybe<Scalars['String']['input']>;
  erp_price_list_name?: InputMaybe<Scalars['String']['input']>;
  erp_price_list_number?: InputMaybe<Scalars['String']['input']>;
  erp_well_country?: InputMaybe<Scalars['String']['input']>;
  erp_well_id?: InputMaybe<Scalars['String']['input']>;
  erp_well_name?: InputMaybe<Scalars['String']['input']>;
  erp_well_region?: InputMaybe<Scalars['String']['input']>;
  erp_well_uwi?: InputMaybe<Scalars['String']['input']>;
  error_log_json?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  parent_id?: InputMaybe<Scalars['uuid']['input']>;
  prepared_by_id?: InputMaybe<Scalars['String']['input']>;
  pricing_date?: InputMaybe<Scalars['date']['input']>;
  proposed_start_date?: InputMaybe<Scalars['date']['input']>;
  sk_job_id?: InputMaybe<Scalars['Int']['input']>;
  sk_job_number?: InputMaybe<Scalars['String']['input']>;
  sk_job_type?: InputMaybe<Quote_Sk_Job_Type_Dataset_Enum>;
  sk_planning_order?: InputMaybe<Scalars['String']['input']>;
  sk_proposal_number?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Quote_Source_Dataset_Enum>;
  spyglass_scenario_id?: InputMaybe<Scalars['uuid']['input']>;
  spyglass_scenario_import_json?: InputMaybe<Scalars['jsonb']['input']>;
  status?: InputMaybe<Quote_Status_Dataset_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  version_number?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Quotes_Sum_Fields = {
  __typename: 'quotes_sum_fields';
  sk_job_id?: Maybe<Scalars['Int']['output']>;
  version_number?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "quotes" */
export type Quotes_Sum_Order_By = {
  sk_job_id?: InputMaybe<Order_By>;
  version_number?: InputMaybe<Order_By>;
};

/** update columns of table "quotes" */
export enum Quotes_Update_Column {
  /** column name */
  Comments = 'comments',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Currency = 'currency',
  /** column name */
  CustomerRepEmail = 'customer_rep_email',
  /** column name */
  CustomerRepName = 'customer_rep_name',
  /** column name */
  CustomerRepPhoneNumber = 'customer_rep_phone_number',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Directions = 'directions',
  /** column name */
  ErpAddressId = 'erp_address_id',
  /** column name */
  ErpAddressName = 'erp_address_name',
  /** column name */
  ErpContractNumber = 'erp_contract_number',
  /** column name */
  ErpCustomerName = 'erp_customer_name',
  /** column name */
  ErpCustomerNumber = 'erp_customer_number',
  /** column name */
  ErpFullAddress = 'erp_full_address',
  /** column name */
  ErpNwaId = 'erp_nwa_id',
  /** column name */
  ErpNwaName = 'erp_nwa_name',
  /** column name */
  ErpPlantId = 'erp_plant_id',
  /** column name */
  ErpPlantName = 'erp_plant_name',
  /** column name */
  ErpPriceListName = 'erp_price_list_name',
  /** column name */
  ErpPriceListNumber = 'erp_price_list_number',
  /** column name */
  ErpWellCountry = 'erp_well_country',
  /** column name */
  ErpWellId = 'erp_well_id',
  /** column name */
  ErpWellName = 'erp_well_name',
  /** column name */
  ErpWellRegion = 'erp_well_region',
  /** column name */
  ErpWellUwi = 'erp_well_uwi',
  /** column name */
  ErrorLogJson = 'error_log_json',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Note = 'note',
  /** column name */
  ParentId = 'parent_id',
  /** column name */
  PreparedById = 'prepared_by_id',
  /** column name */
  PricingDate = 'pricing_date',
  /** column name */
  ProposedStartDate = 'proposed_start_date',
  /** column name */
  SkJobId = 'sk_job_id',
  /** column name */
  SkJobNumber = 'sk_job_number',
  /** column name */
  SkJobType = 'sk_job_type',
  /** column name */
  SkPlanningOrder = 'sk_planning_order',
  /** column name */
  SkProposalNumber = 'sk_proposal_number',
  /** column name */
  Source = 'source',
  /** column name */
  SpyglassScenarioId = 'spyglass_scenario_id',
  /** column name */
  SpyglassScenarioImportJson = 'spyglass_scenario_import_json',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  VersionNumber = 'version_number'
}

export type Quotes_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Quotes_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Quotes_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Quotes_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Quotes_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Quotes_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Quotes_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Quotes_Set_Input>;
  /** filter the rows which have to be updated */
  where: Quotes_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Quotes_Var_Pop_Fields = {
  __typename: 'quotes_var_pop_fields';
  sk_job_id?: Maybe<Scalars['Float']['output']>;
  version_number?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "quotes" */
export type Quotes_Var_Pop_Order_By = {
  sk_job_id?: InputMaybe<Order_By>;
  version_number?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Quotes_Var_Samp_Fields = {
  __typename: 'quotes_var_samp_fields';
  sk_job_id?: Maybe<Scalars['Float']['output']>;
  version_number?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "quotes" */
export type Quotes_Var_Samp_Order_By = {
  sk_job_id?: InputMaybe<Order_By>;
  version_number?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Quotes_Variance_Fields = {
  __typename: 'quotes_variance_fields';
  sk_job_id?: Maybe<Scalars['Float']['output']>;
  version_number?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "quotes" */
export type Quotes_Variance_Order_By = {
  sk_job_id?: InputMaybe<Order_By>;
  version_number?: InputMaybe<Order_By>;
};

/** columns and relationships of "revisions.performance_evaluations_journal" */
export type Revisions_Performance_Evaluations_Journal = {
  __typename: 'revisions_performance_evaluations_journal';
  author_id: Scalars['String']['output'];
  created_at: Scalars['timestamptz']['output'];
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  parent_journal_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  performance_evaluations_journal?: Maybe<Revisions_Performance_Evaluations_Journal>;
  /** An array relationship */
  performance_evaluations_journals: Array<Revisions_Performance_Evaluations_Journal>;
  /** An aggregate relationship */
  performance_evaluations_journals_aggregate: Revisions_Performance_Evaluations_Journal_Aggregate;
  /** An object relationship */
  performance_evaluations_revision?: Maybe<Revisions_Performance_Evaluations_Revisions>;
  /** An array relationship */
  performance_evaluations_revisions: Array<Revisions_Performance_Evaluations_Revisions>;
  /** An aggregate relationship */
  performance_evaluations_revisions_aggregate: Revisions_Performance_Evaluations_Revisions_Aggregate;
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Users;
  winning_revision_id?: Maybe<Scalars['uuid']['output']>;
};


/** columns and relationships of "revisions.performance_evaluations_journal" */
export type Revisions_Performance_Evaluations_JournalPerformance_Evaluations_JournalsArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Performance_Evaluations_Journal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Performance_Evaluations_Journal_Order_By>>;
  where?: InputMaybe<Revisions_Performance_Evaluations_Journal_Bool_Exp>;
};


/** columns and relationships of "revisions.performance_evaluations_journal" */
export type Revisions_Performance_Evaluations_JournalPerformance_Evaluations_Journals_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Performance_Evaluations_Journal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Performance_Evaluations_Journal_Order_By>>;
  where?: InputMaybe<Revisions_Performance_Evaluations_Journal_Bool_Exp>;
};


/** columns and relationships of "revisions.performance_evaluations_journal" */
export type Revisions_Performance_Evaluations_JournalPerformance_Evaluations_RevisionsArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Performance_Evaluations_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Performance_Evaluations_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Performance_Evaluations_Revisions_Bool_Exp>;
};


/** columns and relationships of "revisions.performance_evaluations_journal" */
export type Revisions_Performance_Evaluations_JournalPerformance_Evaluations_Revisions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Performance_Evaluations_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Performance_Evaluations_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Performance_Evaluations_Revisions_Bool_Exp>;
};

/** aggregated selection of "revisions.performance_evaluations_journal" */
export type Revisions_Performance_Evaluations_Journal_Aggregate = {
  __typename: 'revisions_performance_evaluations_journal_aggregate';
  aggregate?: Maybe<Revisions_Performance_Evaluations_Journal_Aggregate_Fields>;
  nodes: Array<Revisions_Performance_Evaluations_Journal>;
};

export type Revisions_Performance_Evaluations_Journal_Aggregate_Bool_Exp = {
  count?: InputMaybe<Revisions_Performance_Evaluations_Journal_Aggregate_Bool_Exp_Count>;
};

export type Revisions_Performance_Evaluations_Journal_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Revisions_Performance_Evaluations_Journal_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Revisions_Performance_Evaluations_Journal_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "revisions.performance_evaluations_journal" */
export type Revisions_Performance_Evaluations_Journal_Aggregate_Fields = {
  __typename: 'revisions_performance_evaluations_journal_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Revisions_Performance_Evaluations_Journal_Max_Fields>;
  min?: Maybe<Revisions_Performance_Evaluations_Journal_Min_Fields>;
};


/** aggregate fields of "revisions.performance_evaluations_journal" */
export type Revisions_Performance_Evaluations_Journal_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Revisions_Performance_Evaluations_Journal_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "revisions.performance_evaluations_journal" */
export type Revisions_Performance_Evaluations_Journal_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Revisions_Performance_Evaluations_Journal_Max_Order_By>;
  min?: InputMaybe<Revisions_Performance_Evaluations_Journal_Min_Order_By>;
};

/** input type for inserting array relation for remote table "revisions.performance_evaluations_journal" */
export type Revisions_Performance_Evaluations_Journal_Arr_Rel_Insert_Input = {
  data: Array<Revisions_Performance_Evaluations_Journal_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Revisions_Performance_Evaluations_Journal_On_Conflict>;
};

/** Boolean expression to filter rows from the table "revisions.performance_evaluations_journal". All fields are combined with a logical 'AND'. */
export type Revisions_Performance_Evaluations_Journal_Bool_Exp = {
  _and?: InputMaybe<Array<Revisions_Performance_Evaluations_Journal_Bool_Exp>>;
  _not?: InputMaybe<Revisions_Performance_Evaluations_Journal_Bool_Exp>;
  _or?: InputMaybe<Array<Revisions_Performance_Evaluations_Journal_Bool_Exp>>;
  author_id?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  parent_journal_id?: InputMaybe<Uuid_Comparison_Exp>;
  performance_evaluations_journal?: InputMaybe<Revisions_Performance_Evaluations_Journal_Bool_Exp>;
  performance_evaluations_journals?: InputMaybe<Revisions_Performance_Evaluations_Journal_Bool_Exp>;
  performance_evaluations_journals_aggregate?: InputMaybe<Revisions_Performance_Evaluations_Journal_Aggregate_Bool_Exp>;
  performance_evaluations_revision?: InputMaybe<Revisions_Performance_Evaluations_Revisions_Bool_Exp>;
  performance_evaluations_revisions?: InputMaybe<Revisions_Performance_Evaluations_Revisions_Bool_Exp>;
  performance_evaluations_revisions_aggregate?: InputMaybe<Revisions_Performance_Evaluations_Revisions_Aggregate_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  winning_revision_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "revisions.performance_evaluations_journal" */
export enum Revisions_Performance_Evaluations_Journal_Constraint {
  /** unique or primary key constraint on columns "id" */
  PerformanceEvaluationsJournalPkey = 'performance_evaluations_journal_pkey'
}

/** input type for inserting data into table "revisions.performance_evaluations_journal" */
export type Revisions_Performance_Evaluations_Journal_Insert_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  parent_journal_id?: InputMaybe<Scalars['uuid']['input']>;
  performance_evaluations_journal?: InputMaybe<Revisions_Performance_Evaluations_Journal_Obj_Rel_Insert_Input>;
  performance_evaluations_journals?: InputMaybe<Revisions_Performance_Evaluations_Journal_Arr_Rel_Insert_Input>;
  performance_evaluations_revision?: InputMaybe<Revisions_Performance_Evaluations_Revisions_Obj_Rel_Insert_Input>;
  performance_evaluations_revisions?: InputMaybe<Revisions_Performance_Evaluations_Revisions_Arr_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  winning_revision_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Revisions_Performance_Evaluations_Journal_Max_Fields = {
  __typename: 'revisions_performance_evaluations_journal_max_fields';
  author_id?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  parent_journal_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  winning_revision_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "revisions.performance_evaluations_journal" */
export type Revisions_Performance_Evaluations_Journal_Max_Order_By = {
  author_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parent_journal_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  winning_revision_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Revisions_Performance_Evaluations_Journal_Min_Fields = {
  __typename: 'revisions_performance_evaluations_journal_min_fields';
  author_id?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  parent_journal_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  winning_revision_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "revisions.performance_evaluations_journal" */
export type Revisions_Performance_Evaluations_Journal_Min_Order_By = {
  author_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parent_journal_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  winning_revision_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "revisions.performance_evaluations_journal" */
export type Revisions_Performance_Evaluations_Journal_Mutation_Response = {
  __typename: 'revisions_performance_evaluations_journal_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Revisions_Performance_Evaluations_Journal>;
};

/** input type for inserting object relation for remote table "revisions.performance_evaluations_journal" */
export type Revisions_Performance_Evaluations_Journal_Obj_Rel_Insert_Input = {
  data: Revisions_Performance_Evaluations_Journal_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Revisions_Performance_Evaluations_Journal_On_Conflict>;
};

/** on_conflict condition type for table "revisions.performance_evaluations_journal" */
export type Revisions_Performance_Evaluations_Journal_On_Conflict = {
  constraint: Revisions_Performance_Evaluations_Journal_Constraint;
  update_columns?: Array<Revisions_Performance_Evaluations_Journal_Update_Column>;
  where?: InputMaybe<Revisions_Performance_Evaluations_Journal_Bool_Exp>;
};

/** Ordering options when selecting data from "revisions.performance_evaluations_journal". */
export type Revisions_Performance_Evaluations_Journal_Order_By = {
  author_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parent_journal_id?: InputMaybe<Order_By>;
  performance_evaluations_journal?: InputMaybe<Revisions_Performance_Evaluations_Journal_Order_By>;
  performance_evaluations_journals_aggregate?: InputMaybe<Revisions_Performance_Evaluations_Journal_Aggregate_Order_By>;
  performance_evaluations_revision?: InputMaybe<Revisions_Performance_Evaluations_Revisions_Order_By>;
  performance_evaluations_revisions_aggregate?: InputMaybe<Revisions_Performance_Evaluations_Revisions_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  winning_revision_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: revisions.performance_evaluations_journal */
export type Revisions_Performance_Evaluations_Journal_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "revisions.performance_evaluations_journal" */
export enum Revisions_Performance_Evaluations_Journal_Select_Column {
  /** column name */
  AuthorId = 'author_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  ParentJournalId = 'parent_journal_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WinningRevisionId = 'winning_revision_id'
}

/** input type for updating data in table "revisions.performance_evaluations_journal" */
export type Revisions_Performance_Evaluations_Journal_Set_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  parent_journal_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  winning_revision_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "revisions_performance_evaluations_journal" */
export type Revisions_Performance_Evaluations_Journal_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Revisions_Performance_Evaluations_Journal_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Revisions_Performance_Evaluations_Journal_Stream_Cursor_Value_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  parent_journal_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  winning_revision_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "revisions.performance_evaluations_journal" */
export enum Revisions_Performance_Evaluations_Journal_Update_Column {
  /** column name */
  AuthorId = 'author_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  ParentJournalId = 'parent_journal_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WinningRevisionId = 'winning_revision_id'
}

export type Revisions_Performance_Evaluations_Journal_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Revisions_Performance_Evaluations_Journal_Set_Input>;
  /** filter the rows which have to be updated */
  where: Revisions_Performance_Evaluations_Journal_Bool_Exp;
};

/** columns and relationships of "revisions.performance_evaluations_revisions" */
export type Revisions_Performance_Evaluations_Revisions = {
  __typename: 'revisions_performance_evaluations_revisions';
  author_id: Scalars['String']['output'];
  casing_pressure_psia?: Maybe<Scalars['numeric']['output']>;
  cloned_from_journal_id?: Maybe<Scalars['uuid']['output']>;
  created_at: Scalars['timestamptz']['output'];
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  gas_rate_mscf_day?: Maybe<Scalars['numeric']['output']>;
  id: Scalars['uuid']['output'];
  intake_gas_separation_override_type?: Maybe<Override_Options_Enum>;
  intake_override_gas_separation_percent?: Maybe<Scalars['numeric']['output']>;
  journal_id: Scalars['uuid']['output'];
  natural_gas_separation_override_type?: Maybe<Override_Options_Enum>;
  natural_override_gas_separation_percent?: Maybe<Scalars['numeric']['output']>;
  oil_rate_std_barrel_day?: Maybe<Scalars['numeric']['output']>;
  parent_revision_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  performance_evaluations_journal: Revisions_Performance_Evaluations_Journal;
  /** An array relationship */
  performance_evaluations_journals: Array<Revisions_Performance_Evaluations_Journal>;
  /** An aggregate relationship */
  performance_evaluations_journals_aggregate: Revisions_Performance_Evaluations_Journal_Aggregate;
  /** An object relationship */
  performance_evaluations_revision?: Maybe<Revisions_Performance_Evaluations_Revisions>;
  /** An array relationship */
  performance_evaluations_revisions: Array<Revisions_Performance_Evaluations_Revisions>;
  /** An aggregate relationship */
  performance_evaluations_revisions_aggregate: Revisions_Performance_Evaluations_Revisions_Aggregate;
  /** An object relationship */
  performance_evaluations_view?: Maybe<Performance_Evaluations>;
  pump_hz?: Maybe<Scalars['numeric']['output']>;
  pump_intake_pressure_psia?: Maybe<Scalars['numeric']['output']>;
  pump_wear_brake_horsepower_correction_ratio: Scalars['numeric']['output'];
  pump_wear_head_correction_ratio: Scalars['numeric']['output'];
  scenario_id: Scalars['uuid']['output'];
  /** An object relationship */
  scenarios_journal: Revisions_Scenarios_Journal;
  title: Scalars['String']['output'];
  tubing_pressure_psia?: Maybe<Scalars['numeric']['output']>;
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Users;
  water_rate_std_barrel_day?: Maybe<Scalars['numeric']['output']>;
};


/** columns and relationships of "revisions.performance_evaluations_revisions" */
export type Revisions_Performance_Evaluations_RevisionsPerformance_Evaluations_JournalsArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Performance_Evaluations_Journal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Performance_Evaluations_Journal_Order_By>>;
  where?: InputMaybe<Revisions_Performance_Evaluations_Journal_Bool_Exp>;
};


/** columns and relationships of "revisions.performance_evaluations_revisions" */
export type Revisions_Performance_Evaluations_RevisionsPerformance_Evaluations_Journals_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Performance_Evaluations_Journal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Performance_Evaluations_Journal_Order_By>>;
  where?: InputMaybe<Revisions_Performance_Evaluations_Journal_Bool_Exp>;
};


/** columns and relationships of "revisions.performance_evaluations_revisions" */
export type Revisions_Performance_Evaluations_RevisionsPerformance_Evaluations_RevisionsArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Performance_Evaluations_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Performance_Evaluations_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Performance_Evaluations_Revisions_Bool_Exp>;
};


/** columns and relationships of "revisions.performance_evaluations_revisions" */
export type Revisions_Performance_Evaluations_RevisionsPerformance_Evaluations_Revisions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Performance_Evaluations_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Performance_Evaluations_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Performance_Evaluations_Revisions_Bool_Exp>;
};

/** aggregated selection of "revisions.performance_evaluations_revisions" */
export type Revisions_Performance_Evaluations_Revisions_Aggregate = {
  __typename: 'revisions_performance_evaluations_revisions_aggregate';
  aggregate?: Maybe<Revisions_Performance_Evaluations_Revisions_Aggregate_Fields>;
  nodes: Array<Revisions_Performance_Evaluations_Revisions>;
};

export type Revisions_Performance_Evaluations_Revisions_Aggregate_Bool_Exp = {
  count?: InputMaybe<Revisions_Performance_Evaluations_Revisions_Aggregate_Bool_Exp_Count>;
};

export type Revisions_Performance_Evaluations_Revisions_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Revisions_Performance_Evaluations_Revisions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Revisions_Performance_Evaluations_Revisions_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "revisions.performance_evaluations_revisions" */
export type Revisions_Performance_Evaluations_Revisions_Aggregate_Fields = {
  __typename: 'revisions_performance_evaluations_revisions_aggregate_fields';
  avg?: Maybe<Revisions_Performance_Evaluations_Revisions_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Revisions_Performance_Evaluations_Revisions_Max_Fields>;
  min?: Maybe<Revisions_Performance_Evaluations_Revisions_Min_Fields>;
  stddev?: Maybe<Revisions_Performance_Evaluations_Revisions_Stddev_Fields>;
  stddev_pop?: Maybe<Revisions_Performance_Evaluations_Revisions_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Revisions_Performance_Evaluations_Revisions_Stddev_Samp_Fields>;
  sum?: Maybe<Revisions_Performance_Evaluations_Revisions_Sum_Fields>;
  var_pop?: Maybe<Revisions_Performance_Evaluations_Revisions_Var_Pop_Fields>;
  var_samp?: Maybe<Revisions_Performance_Evaluations_Revisions_Var_Samp_Fields>;
  variance?: Maybe<Revisions_Performance_Evaluations_Revisions_Variance_Fields>;
};


/** aggregate fields of "revisions.performance_evaluations_revisions" */
export type Revisions_Performance_Evaluations_Revisions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Revisions_Performance_Evaluations_Revisions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "revisions.performance_evaluations_revisions" */
export type Revisions_Performance_Evaluations_Revisions_Aggregate_Order_By = {
  avg?: InputMaybe<Revisions_Performance_Evaluations_Revisions_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Revisions_Performance_Evaluations_Revisions_Max_Order_By>;
  min?: InputMaybe<Revisions_Performance_Evaluations_Revisions_Min_Order_By>;
  stddev?: InputMaybe<Revisions_Performance_Evaluations_Revisions_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Revisions_Performance_Evaluations_Revisions_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Revisions_Performance_Evaluations_Revisions_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Revisions_Performance_Evaluations_Revisions_Sum_Order_By>;
  var_pop?: InputMaybe<Revisions_Performance_Evaluations_Revisions_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Revisions_Performance_Evaluations_Revisions_Var_Samp_Order_By>;
  variance?: InputMaybe<Revisions_Performance_Evaluations_Revisions_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "revisions.performance_evaluations_revisions" */
export type Revisions_Performance_Evaluations_Revisions_Arr_Rel_Insert_Input = {
  data: Array<Revisions_Performance_Evaluations_Revisions_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Revisions_Performance_Evaluations_Revisions_On_Conflict>;
};

/** aggregate avg on columns */
export type Revisions_Performance_Evaluations_Revisions_Avg_Fields = {
  __typename: 'revisions_performance_evaluations_revisions_avg_fields';
  casing_pressure_psia?: Maybe<Scalars['Float']['output']>;
  gas_rate_mscf_day?: Maybe<Scalars['Float']['output']>;
  intake_override_gas_separation_percent?: Maybe<Scalars['Float']['output']>;
  natural_override_gas_separation_percent?: Maybe<Scalars['Float']['output']>;
  oil_rate_std_barrel_day?: Maybe<Scalars['Float']['output']>;
  pump_hz?: Maybe<Scalars['Float']['output']>;
  pump_intake_pressure_psia?: Maybe<Scalars['Float']['output']>;
  pump_wear_brake_horsepower_correction_ratio?: Maybe<Scalars['Float']['output']>;
  pump_wear_head_correction_ratio?: Maybe<Scalars['Float']['output']>;
  tubing_pressure_psia?: Maybe<Scalars['Float']['output']>;
  water_rate_std_barrel_day?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "revisions.performance_evaluations_revisions" */
export type Revisions_Performance_Evaluations_Revisions_Avg_Order_By = {
  casing_pressure_psia?: InputMaybe<Order_By>;
  gas_rate_mscf_day?: InputMaybe<Order_By>;
  intake_override_gas_separation_percent?: InputMaybe<Order_By>;
  natural_override_gas_separation_percent?: InputMaybe<Order_By>;
  oil_rate_std_barrel_day?: InputMaybe<Order_By>;
  pump_hz?: InputMaybe<Order_By>;
  pump_intake_pressure_psia?: InputMaybe<Order_By>;
  pump_wear_brake_horsepower_correction_ratio?: InputMaybe<Order_By>;
  pump_wear_head_correction_ratio?: InputMaybe<Order_By>;
  tubing_pressure_psia?: InputMaybe<Order_By>;
  water_rate_std_barrel_day?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "revisions.performance_evaluations_revisions". All fields are combined with a logical 'AND'. */
export type Revisions_Performance_Evaluations_Revisions_Bool_Exp = {
  _and?: InputMaybe<Array<Revisions_Performance_Evaluations_Revisions_Bool_Exp>>;
  _not?: InputMaybe<Revisions_Performance_Evaluations_Revisions_Bool_Exp>;
  _or?: InputMaybe<Array<Revisions_Performance_Evaluations_Revisions_Bool_Exp>>;
  author_id?: InputMaybe<String_Comparison_Exp>;
  casing_pressure_psia?: InputMaybe<Numeric_Comparison_Exp>;
  cloned_from_journal_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  gas_rate_mscf_day?: InputMaybe<Numeric_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  intake_gas_separation_override_type?: InputMaybe<Override_Options_Enum_Comparison_Exp>;
  intake_override_gas_separation_percent?: InputMaybe<Numeric_Comparison_Exp>;
  journal_id?: InputMaybe<Uuid_Comparison_Exp>;
  natural_gas_separation_override_type?: InputMaybe<Override_Options_Enum_Comparison_Exp>;
  natural_override_gas_separation_percent?: InputMaybe<Numeric_Comparison_Exp>;
  oil_rate_std_barrel_day?: InputMaybe<Numeric_Comparison_Exp>;
  parent_revision_id?: InputMaybe<Uuid_Comparison_Exp>;
  performance_evaluations_journal?: InputMaybe<Revisions_Performance_Evaluations_Journal_Bool_Exp>;
  performance_evaluations_journals?: InputMaybe<Revisions_Performance_Evaluations_Journal_Bool_Exp>;
  performance_evaluations_journals_aggregate?: InputMaybe<Revisions_Performance_Evaluations_Journal_Aggregate_Bool_Exp>;
  performance_evaluations_revision?: InputMaybe<Revisions_Performance_Evaluations_Revisions_Bool_Exp>;
  performance_evaluations_revisions?: InputMaybe<Revisions_Performance_Evaluations_Revisions_Bool_Exp>;
  performance_evaluations_revisions_aggregate?: InputMaybe<Revisions_Performance_Evaluations_Revisions_Aggregate_Bool_Exp>;
  performance_evaluations_view?: InputMaybe<Performance_Evaluations_Bool_Exp>;
  pump_hz?: InputMaybe<Numeric_Comparison_Exp>;
  pump_intake_pressure_psia?: InputMaybe<Numeric_Comparison_Exp>;
  pump_wear_brake_horsepower_correction_ratio?: InputMaybe<Numeric_Comparison_Exp>;
  pump_wear_head_correction_ratio?: InputMaybe<Numeric_Comparison_Exp>;
  scenario_id?: InputMaybe<Uuid_Comparison_Exp>;
  scenarios_journal?: InputMaybe<Revisions_Scenarios_Journal_Bool_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  tubing_pressure_psia?: InputMaybe<Numeric_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  water_rate_std_barrel_day?: InputMaybe<Numeric_Comparison_Exp>;
};

/** unique or primary key constraints on table "revisions.performance_evaluations_revisions" */
export enum Revisions_Performance_Evaluations_Revisions_Constraint {
  /** unique or primary key constraint on columns "id" */
  PerformanceEvaluationsRevisionsPkey = 'performance_evaluations_revisions_pkey'
}

/** input type for incrementing numeric columns in table "revisions.performance_evaluations_revisions" */
export type Revisions_Performance_Evaluations_Revisions_Inc_Input = {
  casing_pressure_psia?: InputMaybe<Scalars['numeric']['input']>;
  gas_rate_mscf_day?: InputMaybe<Scalars['numeric']['input']>;
  intake_override_gas_separation_percent?: InputMaybe<Scalars['numeric']['input']>;
  natural_override_gas_separation_percent?: InputMaybe<Scalars['numeric']['input']>;
  oil_rate_std_barrel_day?: InputMaybe<Scalars['numeric']['input']>;
  pump_hz?: InputMaybe<Scalars['numeric']['input']>;
  pump_intake_pressure_psia?: InputMaybe<Scalars['numeric']['input']>;
  pump_wear_brake_horsepower_correction_ratio?: InputMaybe<Scalars['numeric']['input']>;
  pump_wear_head_correction_ratio?: InputMaybe<Scalars['numeric']['input']>;
  tubing_pressure_psia?: InputMaybe<Scalars['numeric']['input']>;
  water_rate_std_barrel_day?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "revisions.performance_evaluations_revisions" */
export type Revisions_Performance_Evaluations_Revisions_Insert_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  casing_pressure_psia?: InputMaybe<Scalars['numeric']['input']>;
  cloned_from_journal_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  gas_rate_mscf_day?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  intake_gas_separation_override_type?: InputMaybe<Override_Options_Enum>;
  intake_override_gas_separation_percent?: InputMaybe<Scalars['numeric']['input']>;
  journal_id?: InputMaybe<Scalars['uuid']['input']>;
  natural_gas_separation_override_type?: InputMaybe<Override_Options_Enum>;
  natural_override_gas_separation_percent?: InputMaybe<Scalars['numeric']['input']>;
  oil_rate_std_barrel_day?: InputMaybe<Scalars['numeric']['input']>;
  parent_revision_id?: InputMaybe<Scalars['uuid']['input']>;
  performance_evaluations_journal?: InputMaybe<Revisions_Performance_Evaluations_Journal_Obj_Rel_Insert_Input>;
  performance_evaluations_journals?: InputMaybe<Revisions_Performance_Evaluations_Journal_Arr_Rel_Insert_Input>;
  performance_evaluations_revision?: InputMaybe<Revisions_Performance_Evaluations_Revisions_Obj_Rel_Insert_Input>;
  performance_evaluations_revisions?: InputMaybe<Revisions_Performance_Evaluations_Revisions_Arr_Rel_Insert_Input>;
  performance_evaluations_view?: InputMaybe<Performance_Evaluations_Obj_Rel_Insert_Input>;
  pump_hz?: InputMaybe<Scalars['numeric']['input']>;
  pump_intake_pressure_psia?: InputMaybe<Scalars['numeric']['input']>;
  pump_wear_brake_horsepower_correction_ratio?: InputMaybe<Scalars['numeric']['input']>;
  pump_wear_head_correction_ratio?: InputMaybe<Scalars['numeric']['input']>;
  scenario_id?: InputMaybe<Scalars['uuid']['input']>;
  scenarios_journal?: InputMaybe<Revisions_Scenarios_Journal_Obj_Rel_Insert_Input>;
  title?: InputMaybe<Scalars['String']['input']>;
  tubing_pressure_psia?: InputMaybe<Scalars['numeric']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  water_rate_std_barrel_day?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate max on columns */
export type Revisions_Performance_Evaluations_Revisions_Max_Fields = {
  __typename: 'revisions_performance_evaluations_revisions_max_fields';
  author_id?: Maybe<Scalars['String']['output']>;
  casing_pressure_psia?: Maybe<Scalars['numeric']['output']>;
  cloned_from_journal_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  gas_rate_mscf_day?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  intake_override_gas_separation_percent?: Maybe<Scalars['numeric']['output']>;
  journal_id?: Maybe<Scalars['uuid']['output']>;
  natural_override_gas_separation_percent?: Maybe<Scalars['numeric']['output']>;
  oil_rate_std_barrel_day?: Maybe<Scalars['numeric']['output']>;
  parent_revision_id?: Maybe<Scalars['uuid']['output']>;
  pump_hz?: Maybe<Scalars['numeric']['output']>;
  pump_intake_pressure_psia?: Maybe<Scalars['numeric']['output']>;
  pump_wear_brake_horsepower_correction_ratio?: Maybe<Scalars['numeric']['output']>;
  pump_wear_head_correction_ratio?: Maybe<Scalars['numeric']['output']>;
  scenario_id?: Maybe<Scalars['uuid']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  tubing_pressure_psia?: Maybe<Scalars['numeric']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  water_rate_std_barrel_day?: Maybe<Scalars['numeric']['output']>;
};

/** order by max() on columns of table "revisions.performance_evaluations_revisions" */
export type Revisions_Performance_Evaluations_Revisions_Max_Order_By = {
  author_id?: InputMaybe<Order_By>;
  casing_pressure_psia?: InputMaybe<Order_By>;
  cloned_from_journal_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  gas_rate_mscf_day?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  intake_override_gas_separation_percent?: InputMaybe<Order_By>;
  journal_id?: InputMaybe<Order_By>;
  natural_override_gas_separation_percent?: InputMaybe<Order_By>;
  oil_rate_std_barrel_day?: InputMaybe<Order_By>;
  parent_revision_id?: InputMaybe<Order_By>;
  pump_hz?: InputMaybe<Order_By>;
  pump_intake_pressure_psia?: InputMaybe<Order_By>;
  pump_wear_brake_horsepower_correction_ratio?: InputMaybe<Order_By>;
  pump_wear_head_correction_ratio?: InputMaybe<Order_By>;
  scenario_id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  tubing_pressure_psia?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  water_rate_std_barrel_day?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Revisions_Performance_Evaluations_Revisions_Min_Fields = {
  __typename: 'revisions_performance_evaluations_revisions_min_fields';
  author_id?: Maybe<Scalars['String']['output']>;
  casing_pressure_psia?: Maybe<Scalars['numeric']['output']>;
  cloned_from_journal_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  gas_rate_mscf_day?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  intake_override_gas_separation_percent?: Maybe<Scalars['numeric']['output']>;
  journal_id?: Maybe<Scalars['uuid']['output']>;
  natural_override_gas_separation_percent?: Maybe<Scalars['numeric']['output']>;
  oil_rate_std_barrel_day?: Maybe<Scalars['numeric']['output']>;
  parent_revision_id?: Maybe<Scalars['uuid']['output']>;
  pump_hz?: Maybe<Scalars['numeric']['output']>;
  pump_intake_pressure_psia?: Maybe<Scalars['numeric']['output']>;
  pump_wear_brake_horsepower_correction_ratio?: Maybe<Scalars['numeric']['output']>;
  pump_wear_head_correction_ratio?: Maybe<Scalars['numeric']['output']>;
  scenario_id?: Maybe<Scalars['uuid']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  tubing_pressure_psia?: Maybe<Scalars['numeric']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  water_rate_std_barrel_day?: Maybe<Scalars['numeric']['output']>;
};

/** order by min() on columns of table "revisions.performance_evaluations_revisions" */
export type Revisions_Performance_Evaluations_Revisions_Min_Order_By = {
  author_id?: InputMaybe<Order_By>;
  casing_pressure_psia?: InputMaybe<Order_By>;
  cloned_from_journal_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  gas_rate_mscf_day?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  intake_override_gas_separation_percent?: InputMaybe<Order_By>;
  journal_id?: InputMaybe<Order_By>;
  natural_override_gas_separation_percent?: InputMaybe<Order_By>;
  oil_rate_std_barrel_day?: InputMaybe<Order_By>;
  parent_revision_id?: InputMaybe<Order_By>;
  pump_hz?: InputMaybe<Order_By>;
  pump_intake_pressure_psia?: InputMaybe<Order_By>;
  pump_wear_brake_horsepower_correction_ratio?: InputMaybe<Order_By>;
  pump_wear_head_correction_ratio?: InputMaybe<Order_By>;
  scenario_id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  tubing_pressure_psia?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  water_rate_std_barrel_day?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "revisions.performance_evaluations_revisions" */
export type Revisions_Performance_Evaluations_Revisions_Mutation_Response = {
  __typename: 'revisions_performance_evaluations_revisions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Revisions_Performance_Evaluations_Revisions>;
};

/** input type for inserting object relation for remote table "revisions.performance_evaluations_revisions" */
export type Revisions_Performance_Evaluations_Revisions_Obj_Rel_Insert_Input = {
  data: Revisions_Performance_Evaluations_Revisions_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Revisions_Performance_Evaluations_Revisions_On_Conflict>;
};

/** on_conflict condition type for table "revisions.performance_evaluations_revisions" */
export type Revisions_Performance_Evaluations_Revisions_On_Conflict = {
  constraint: Revisions_Performance_Evaluations_Revisions_Constraint;
  update_columns?: Array<Revisions_Performance_Evaluations_Revisions_Update_Column>;
  where?: InputMaybe<Revisions_Performance_Evaluations_Revisions_Bool_Exp>;
};

/** Ordering options when selecting data from "revisions.performance_evaluations_revisions". */
export type Revisions_Performance_Evaluations_Revisions_Order_By = {
  author_id?: InputMaybe<Order_By>;
  casing_pressure_psia?: InputMaybe<Order_By>;
  cloned_from_journal_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  gas_rate_mscf_day?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  intake_gas_separation_override_type?: InputMaybe<Order_By>;
  intake_override_gas_separation_percent?: InputMaybe<Order_By>;
  journal_id?: InputMaybe<Order_By>;
  natural_gas_separation_override_type?: InputMaybe<Order_By>;
  natural_override_gas_separation_percent?: InputMaybe<Order_By>;
  oil_rate_std_barrel_day?: InputMaybe<Order_By>;
  parent_revision_id?: InputMaybe<Order_By>;
  performance_evaluations_journal?: InputMaybe<Revisions_Performance_Evaluations_Journal_Order_By>;
  performance_evaluations_journals_aggregate?: InputMaybe<Revisions_Performance_Evaluations_Journal_Aggregate_Order_By>;
  performance_evaluations_revision?: InputMaybe<Revisions_Performance_Evaluations_Revisions_Order_By>;
  performance_evaluations_revisions_aggregate?: InputMaybe<Revisions_Performance_Evaluations_Revisions_Aggregate_Order_By>;
  performance_evaluations_view?: InputMaybe<Performance_Evaluations_Order_By>;
  pump_hz?: InputMaybe<Order_By>;
  pump_intake_pressure_psia?: InputMaybe<Order_By>;
  pump_wear_brake_horsepower_correction_ratio?: InputMaybe<Order_By>;
  pump_wear_head_correction_ratio?: InputMaybe<Order_By>;
  scenario_id?: InputMaybe<Order_By>;
  scenarios_journal?: InputMaybe<Revisions_Scenarios_Journal_Order_By>;
  title?: InputMaybe<Order_By>;
  tubing_pressure_psia?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  water_rate_std_barrel_day?: InputMaybe<Order_By>;
};

/** primary key columns input for table: revisions.performance_evaluations_revisions */
export type Revisions_Performance_Evaluations_Revisions_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "revisions.performance_evaluations_revisions" */
export enum Revisions_Performance_Evaluations_Revisions_Select_Column {
  /** column name */
  AuthorId = 'author_id',
  /** column name */
  CasingPressurePsia = 'casing_pressure_psia',
  /** column name */
  ClonedFromJournalId = 'cloned_from_journal_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  GasRateMscfDay = 'gas_rate_mscf_day',
  /** column name */
  Id = 'id',
  /** column name */
  IntakeGasSeparationOverrideType = 'intake_gas_separation_override_type',
  /** column name */
  IntakeOverrideGasSeparationPercent = 'intake_override_gas_separation_percent',
  /** column name */
  JournalId = 'journal_id',
  /** column name */
  NaturalGasSeparationOverrideType = 'natural_gas_separation_override_type',
  /** column name */
  NaturalOverrideGasSeparationPercent = 'natural_override_gas_separation_percent',
  /** column name */
  OilRateStdBarrelDay = 'oil_rate_std_barrel_day',
  /** column name */
  ParentRevisionId = 'parent_revision_id',
  /** column name */
  PumpHz = 'pump_hz',
  /** column name */
  PumpIntakePressurePsia = 'pump_intake_pressure_psia',
  /** column name */
  PumpWearBrakeHorsepowerCorrectionRatio = 'pump_wear_brake_horsepower_correction_ratio',
  /** column name */
  PumpWearHeadCorrectionRatio = 'pump_wear_head_correction_ratio',
  /** column name */
  ScenarioId = 'scenario_id',
  /** column name */
  Title = 'title',
  /** column name */
  TubingPressurePsia = 'tubing_pressure_psia',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WaterRateStdBarrelDay = 'water_rate_std_barrel_day'
}

/** input type for updating data in table "revisions.performance_evaluations_revisions" */
export type Revisions_Performance_Evaluations_Revisions_Set_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  casing_pressure_psia?: InputMaybe<Scalars['numeric']['input']>;
  cloned_from_journal_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  gas_rate_mscf_day?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  intake_gas_separation_override_type?: InputMaybe<Override_Options_Enum>;
  intake_override_gas_separation_percent?: InputMaybe<Scalars['numeric']['input']>;
  journal_id?: InputMaybe<Scalars['uuid']['input']>;
  natural_gas_separation_override_type?: InputMaybe<Override_Options_Enum>;
  natural_override_gas_separation_percent?: InputMaybe<Scalars['numeric']['input']>;
  oil_rate_std_barrel_day?: InputMaybe<Scalars['numeric']['input']>;
  parent_revision_id?: InputMaybe<Scalars['uuid']['input']>;
  pump_hz?: InputMaybe<Scalars['numeric']['input']>;
  pump_intake_pressure_psia?: InputMaybe<Scalars['numeric']['input']>;
  pump_wear_brake_horsepower_correction_ratio?: InputMaybe<Scalars['numeric']['input']>;
  pump_wear_head_correction_ratio?: InputMaybe<Scalars['numeric']['input']>;
  scenario_id?: InputMaybe<Scalars['uuid']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  tubing_pressure_psia?: InputMaybe<Scalars['numeric']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  water_rate_std_barrel_day?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate stddev on columns */
export type Revisions_Performance_Evaluations_Revisions_Stddev_Fields = {
  __typename: 'revisions_performance_evaluations_revisions_stddev_fields';
  casing_pressure_psia?: Maybe<Scalars['Float']['output']>;
  gas_rate_mscf_day?: Maybe<Scalars['Float']['output']>;
  intake_override_gas_separation_percent?: Maybe<Scalars['Float']['output']>;
  natural_override_gas_separation_percent?: Maybe<Scalars['Float']['output']>;
  oil_rate_std_barrel_day?: Maybe<Scalars['Float']['output']>;
  pump_hz?: Maybe<Scalars['Float']['output']>;
  pump_intake_pressure_psia?: Maybe<Scalars['Float']['output']>;
  pump_wear_brake_horsepower_correction_ratio?: Maybe<Scalars['Float']['output']>;
  pump_wear_head_correction_ratio?: Maybe<Scalars['Float']['output']>;
  tubing_pressure_psia?: Maybe<Scalars['Float']['output']>;
  water_rate_std_barrel_day?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "revisions.performance_evaluations_revisions" */
export type Revisions_Performance_Evaluations_Revisions_Stddev_Order_By = {
  casing_pressure_psia?: InputMaybe<Order_By>;
  gas_rate_mscf_day?: InputMaybe<Order_By>;
  intake_override_gas_separation_percent?: InputMaybe<Order_By>;
  natural_override_gas_separation_percent?: InputMaybe<Order_By>;
  oil_rate_std_barrel_day?: InputMaybe<Order_By>;
  pump_hz?: InputMaybe<Order_By>;
  pump_intake_pressure_psia?: InputMaybe<Order_By>;
  pump_wear_brake_horsepower_correction_ratio?: InputMaybe<Order_By>;
  pump_wear_head_correction_ratio?: InputMaybe<Order_By>;
  tubing_pressure_psia?: InputMaybe<Order_By>;
  water_rate_std_barrel_day?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Revisions_Performance_Evaluations_Revisions_Stddev_Pop_Fields = {
  __typename: 'revisions_performance_evaluations_revisions_stddev_pop_fields';
  casing_pressure_psia?: Maybe<Scalars['Float']['output']>;
  gas_rate_mscf_day?: Maybe<Scalars['Float']['output']>;
  intake_override_gas_separation_percent?: Maybe<Scalars['Float']['output']>;
  natural_override_gas_separation_percent?: Maybe<Scalars['Float']['output']>;
  oil_rate_std_barrel_day?: Maybe<Scalars['Float']['output']>;
  pump_hz?: Maybe<Scalars['Float']['output']>;
  pump_intake_pressure_psia?: Maybe<Scalars['Float']['output']>;
  pump_wear_brake_horsepower_correction_ratio?: Maybe<Scalars['Float']['output']>;
  pump_wear_head_correction_ratio?: Maybe<Scalars['Float']['output']>;
  tubing_pressure_psia?: Maybe<Scalars['Float']['output']>;
  water_rate_std_barrel_day?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "revisions.performance_evaluations_revisions" */
export type Revisions_Performance_Evaluations_Revisions_Stddev_Pop_Order_By = {
  casing_pressure_psia?: InputMaybe<Order_By>;
  gas_rate_mscf_day?: InputMaybe<Order_By>;
  intake_override_gas_separation_percent?: InputMaybe<Order_By>;
  natural_override_gas_separation_percent?: InputMaybe<Order_By>;
  oil_rate_std_barrel_day?: InputMaybe<Order_By>;
  pump_hz?: InputMaybe<Order_By>;
  pump_intake_pressure_psia?: InputMaybe<Order_By>;
  pump_wear_brake_horsepower_correction_ratio?: InputMaybe<Order_By>;
  pump_wear_head_correction_ratio?: InputMaybe<Order_By>;
  tubing_pressure_psia?: InputMaybe<Order_By>;
  water_rate_std_barrel_day?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Revisions_Performance_Evaluations_Revisions_Stddev_Samp_Fields = {
  __typename: 'revisions_performance_evaluations_revisions_stddev_samp_fields';
  casing_pressure_psia?: Maybe<Scalars['Float']['output']>;
  gas_rate_mscf_day?: Maybe<Scalars['Float']['output']>;
  intake_override_gas_separation_percent?: Maybe<Scalars['Float']['output']>;
  natural_override_gas_separation_percent?: Maybe<Scalars['Float']['output']>;
  oil_rate_std_barrel_day?: Maybe<Scalars['Float']['output']>;
  pump_hz?: Maybe<Scalars['Float']['output']>;
  pump_intake_pressure_psia?: Maybe<Scalars['Float']['output']>;
  pump_wear_brake_horsepower_correction_ratio?: Maybe<Scalars['Float']['output']>;
  pump_wear_head_correction_ratio?: Maybe<Scalars['Float']['output']>;
  tubing_pressure_psia?: Maybe<Scalars['Float']['output']>;
  water_rate_std_barrel_day?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "revisions.performance_evaluations_revisions" */
export type Revisions_Performance_Evaluations_Revisions_Stddev_Samp_Order_By = {
  casing_pressure_psia?: InputMaybe<Order_By>;
  gas_rate_mscf_day?: InputMaybe<Order_By>;
  intake_override_gas_separation_percent?: InputMaybe<Order_By>;
  natural_override_gas_separation_percent?: InputMaybe<Order_By>;
  oil_rate_std_barrel_day?: InputMaybe<Order_By>;
  pump_hz?: InputMaybe<Order_By>;
  pump_intake_pressure_psia?: InputMaybe<Order_By>;
  pump_wear_brake_horsepower_correction_ratio?: InputMaybe<Order_By>;
  pump_wear_head_correction_ratio?: InputMaybe<Order_By>;
  tubing_pressure_psia?: InputMaybe<Order_By>;
  water_rate_std_barrel_day?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "revisions_performance_evaluations_revisions" */
export type Revisions_Performance_Evaluations_Revisions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Revisions_Performance_Evaluations_Revisions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Revisions_Performance_Evaluations_Revisions_Stream_Cursor_Value_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  casing_pressure_psia?: InputMaybe<Scalars['numeric']['input']>;
  cloned_from_journal_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  gas_rate_mscf_day?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  intake_gas_separation_override_type?: InputMaybe<Override_Options_Enum>;
  intake_override_gas_separation_percent?: InputMaybe<Scalars['numeric']['input']>;
  journal_id?: InputMaybe<Scalars['uuid']['input']>;
  natural_gas_separation_override_type?: InputMaybe<Override_Options_Enum>;
  natural_override_gas_separation_percent?: InputMaybe<Scalars['numeric']['input']>;
  oil_rate_std_barrel_day?: InputMaybe<Scalars['numeric']['input']>;
  parent_revision_id?: InputMaybe<Scalars['uuid']['input']>;
  pump_hz?: InputMaybe<Scalars['numeric']['input']>;
  pump_intake_pressure_psia?: InputMaybe<Scalars['numeric']['input']>;
  pump_wear_brake_horsepower_correction_ratio?: InputMaybe<Scalars['numeric']['input']>;
  pump_wear_head_correction_ratio?: InputMaybe<Scalars['numeric']['input']>;
  scenario_id?: InputMaybe<Scalars['uuid']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  tubing_pressure_psia?: InputMaybe<Scalars['numeric']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  water_rate_std_barrel_day?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate sum on columns */
export type Revisions_Performance_Evaluations_Revisions_Sum_Fields = {
  __typename: 'revisions_performance_evaluations_revisions_sum_fields';
  casing_pressure_psia?: Maybe<Scalars['numeric']['output']>;
  gas_rate_mscf_day?: Maybe<Scalars['numeric']['output']>;
  intake_override_gas_separation_percent?: Maybe<Scalars['numeric']['output']>;
  natural_override_gas_separation_percent?: Maybe<Scalars['numeric']['output']>;
  oil_rate_std_barrel_day?: Maybe<Scalars['numeric']['output']>;
  pump_hz?: Maybe<Scalars['numeric']['output']>;
  pump_intake_pressure_psia?: Maybe<Scalars['numeric']['output']>;
  pump_wear_brake_horsepower_correction_ratio?: Maybe<Scalars['numeric']['output']>;
  pump_wear_head_correction_ratio?: Maybe<Scalars['numeric']['output']>;
  tubing_pressure_psia?: Maybe<Scalars['numeric']['output']>;
  water_rate_std_barrel_day?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "revisions.performance_evaluations_revisions" */
export type Revisions_Performance_Evaluations_Revisions_Sum_Order_By = {
  casing_pressure_psia?: InputMaybe<Order_By>;
  gas_rate_mscf_day?: InputMaybe<Order_By>;
  intake_override_gas_separation_percent?: InputMaybe<Order_By>;
  natural_override_gas_separation_percent?: InputMaybe<Order_By>;
  oil_rate_std_barrel_day?: InputMaybe<Order_By>;
  pump_hz?: InputMaybe<Order_By>;
  pump_intake_pressure_psia?: InputMaybe<Order_By>;
  pump_wear_brake_horsepower_correction_ratio?: InputMaybe<Order_By>;
  pump_wear_head_correction_ratio?: InputMaybe<Order_By>;
  tubing_pressure_psia?: InputMaybe<Order_By>;
  water_rate_std_barrel_day?: InputMaybe<Order_By>;
};

/** update columns of table "revisions.performance_evaluations_revisions" */
export enum Revisions_Performance_Evaluations_Revisions_Update_Column {
  /** column name */
  AuthorId = 'author_id',
  /** column name */
  CasingPressurePsia = 'casing_pressure_psia',
  /** column name */
  ClonedFromJournalId = 'cloned_from_journal_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  GasRateMscfDay = 'gas_rate_mscf_day',
  /** column name */
  Id = 'id',
  /** column name */
  IntakeGasSeparationOverrideType = 'intake_gas_separation_override_type',
  /** column name */
  IntakeOverrideGasSeparationPercent = 'intake_override_gas_separation_percent',
  /** column name */
  JournalId = 'journal_id',
  /** column name */
  NaturalGasSeparationOverrideType = 'natural_gas_separation_override_type',
  /** column name */
  NaturalOverrideGasSeparationPercent = 'natural_override_gas_separation_percent',
  /** column name */
  OilRateStdBarrelDay = 'oil_rate_std_barrel_day',
  /** column name */
  ParentRevisionId = 'parent_revision_id',
  /** column name */
  PumpHz = 'pump_hz',
  /** column name */
  PumpIntakePressurePsia = 'pump_intake_pressure_psia',
  /** column name */
  PumpWearBrakeHorsepowerCorrectionRatio = 'pump_wear_brake_horsepower_correction_ratio',
  /** column name */
  PumpWearHeadCorrectionRatio = 'pump_wear_head_correction_ratio',
  /** column name */
  ScenarioId = 'scenario_id',
  /** column name */
  Title = 'title',
  /** column name */
  TubingPressurePsia = 'tubing_pressure_psia',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WaterRateStdBarrelDay = 'water_rate_std_barrel_day'
}

export type Revisions_Performance_Evaluations_Revisions_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Revisions_Performance_Evaluations_Revisions_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Revisions_Performance_Evaluations_Revisions_Set_Input>;
  /** filter the rows which have to be updated */
  where: Revisions_Performance_Evaluations_Revisions_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Revisions_Performance_Evaluations_Revisions_Var_Pop_Fields = {
  __typename: 'revisions_performance_evaluations_revisions_var_pop_fields';
  casing_pressure_psia?: Maybe<Scalars['Float']['output']>;
  gas_rate_mscf_day?: Maybe<Scalars['Float']['output']>;
  intake_override_gas_separation_percent?: Maybe<Scalars['Float']['output']>;
  natural_override_gas_separation_percent?: Maybe<Scalars['Float']['output']>;
  oil_rate_std_barrel_day?: Maybe<Scalars['Float']['output']>;
  pump_hz?: Maybe<Scalars['Float']['output']>;
  pump_intake_pressure_psia?: Maybe<Scalars['Float']['output']>;
  pump_wear_brake_horsepower_correction_ratio?: Maybe<Scalars['Float']['output']>;
  pump_wear_head_correction_ratio?: Maybe<Scalars['Float']['output']>;
  tubing_pressure_psia?: Maybe<Scalars['Float']['output']>;
  water_rate_std_barrel_day?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "revisions.performance_evaluations_revisions" */
export type Revisions_Performance_Evaluations_Revisions_Var_Pop_Order_By = {
  casing_pressure_psia?: InputMaybe<Order_By>;
  gas_rate_mscf_day?: InputMaybe<Order_By>;
  intake_override_gas_separation_percent?: InputMaybe<Order_By>;
  natural_override_gas_separation_percent?: InputMaybe<Order_By>;
  oil_rate_std_barrel_day?: InputMaybe<Order_By>;
  pump_hz?: InputMaybe<Order_By>;
  pump_intake_pressure_psia?: InputMaybe<Order_By>;
  pump_wear_brake_horsepower_correction_ratio?: InputMaybe<Order_By>;
  pump_wear_head_correction_ratio?: InputMaybe<Order_By>;
  tubing_pressure_psia?: InputMaybe<Order_By>;
  water_rate_std_barrel_day?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Revisions_Performance_Evaluations_Revisions_Var_Samp_Fields = {
  __typename: 'revisions_performance_evaluations_revisions_var_samp_fields';
  casing_pressure_psia?: Maybe<Scalars['Float']['output']>;
  gas_rate_mscf_day?: Maybe<Scalars['Float']['output']>;
  intake_override_gas_separation_percent?: Maybe<Scalars['Float']['output']>;
  natural_override_gas_separation_percent?: Maybe<Scalars['Float']['output']>;
  oil_rate_std_barrel_day?: Maybe<Scalars['Float']['output']>;
  pump_hz?: Maybe<Scalars['Float']['output']>;
  pump_intake_pressure_psia?: Maybe<Scalars['Float']['output']>;
  pump_wear_brake_horsepower_correction_ratio?: Maybe<Scalars['Float']['output']>;
  pump_wear_head_correction_ratio?: Maybe<Scalars['Float']['output']>;
  tubing_pressure_psia?: Maybe<Scalars['Float']['output']>;
  water_rate_std_barrel_day?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "revisions.performance_evaluations_revisions" */
export type Revisions_Performance_Evaluations_Revisions_Var_Samp_Order_By = {
  casing_pressure_psia?: InputMaybe<Order_By>;
  gas_rate_mscf_day?: InputMaybe<Order_By>;
  intake_override_gas_separation_percent?: InputMaybe<Order_By>;
  natural_override_gas_separation_percent?: InputMaybe<Order_By>;
  oil_rate_std_barrel_day?: InputMaybe<Order_By>;
  pump_hz?: InputMaybe<Order_By>;
  pump_intake_pressure_psia?: InputMaybe<Order_By>;
  pump_wear_brake_horsepower_correction_ratio?: InputMaybe<Order_By>;
  pump_wear_head_correction_ratio?: InputMaybe<Order_By>;
  tubing_pressure_psia?: InputMaybe<Order_By>;
  water_rate_std_barrel_day?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Revisions_Performance_Evaluations_Revisions_Variance_Fields = {
  __typename: 'revisions_performance_evaluations_revisions_variance_fields';
  casing_pressure_psia?: Maybe<Scalars['Float']['output']>;
  gas_rate_mscf_day?: Maybe<Scalars['Float']['output']>;
  intake_override_gas_separation_percent?: Maybe<Scalars['Float']['output']>;
  natural_override_gas_separation_percent?: Maybe<Scalars['Float']['output']>;
  oil_rate_std_barrel_day?: Maybe<Scalars['Float']['output']>;
  pump_hz?: Maybe<Scalars['Float']['output']>;
  pump_intake_pressure_psia?: Maybe<Scalars['Float']['output']>;
  pump_wear_brake_horsepower_correction_ratio?: Maybe<Scalars['Float']['output']>;
  pump_wear_head_correction_ratio?: Maybe<Scalars['Float']['output']>;
  tubing_pressure_psia?: Maybe<Scalars['Float']['output']>;
  water_rate_std_barrel_day?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "revisions.performance_evaluations_revisions" */
export type Revisions_Performance_Evaluations_Revisions_Variance_Order_By = {
  casing_pressure_psia?: InputMaybe<Order_By>;
  gas_rate_mscf_day?: InputMaybe<Order_By>;
  intake_override_gas_separation_percent?: InputMaybe<Order_By>;
  natural_override_gas_separation_percent?: InputMaybe<Order_By>;
  oil_rate_std_barrel_day?: InputMaybe<Order_By>;
  pump_hz?: InputMaybe<Order_By>;
  pump_intake_pressure_psia?: InputMaybe<Order_By>;
  pump_wear_brake_horsepower_correction_ratio?: InputMaybe<Order_By>;
  pump_wear_head_correction_ratio?: InputMaybe<Order_By>;
  tubing_pressure_psia?: InputMaybe<Order_By>;
  water_rate_std_barrel_day?: InputMaybe<Order_By>;
};

/** columns and relationships of "revisions.performance_evaluations_xref_pumps_journal" */
export type Revisions_Performance_Evaluations_Xref_Pumps_Journal = {
  __typename: 'revisions_performance_evaluations_xref_pumps_journal';
  author_id: Scalars['String']['output'];
  created_at: Scalars['timestamptz']['output'];
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  parent_journal_id?: Maybe<Scalars['uuid']['output']>;
  updated_at: Scalars['timestamptz']['output'];
  winning_revision_id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregated selection of "revisions.performance_evaluations_xref_pumps_journal" */
export type Revisions_Performance_Evaluations_Xref_Pumps_Journal_Aggregate = {
  __typename: 'revisions_performance_evaluations_xref_pumps_journal_aggregate';
  aggregate?: Maybe<Revisions_Performance_Evaluations_Xref_Pumps_Journal_Aggregate_Fields>;
  nodes: Array<Revisions_Performance_Evaluations_Xref_Pumps_Journal>;
};

export type Revisions_Performance_Evaluations_Xref_Pumps_Journal_Aggregate_Bool_Exp = {
  count?: InputMaybe<Revisions_Performance_Evaluations_Xref_Pumps_Journal_Aggregate_Bool_Exp_Count>;
};

export type Revisions_Performance_Evaluations_Xref_Pumps_Journal_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Revisions_Performance_Evaluations_Xref_Pumps_Journal_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Revisions_Performance_Evaluations_Xref_Pumps_Journal_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "revisions.performance_evaluations_xref_pumps_journal" */
export type Revisions_Performance_Evaluations_Xref_Pumps_Journal_Aggregate_Fields = {
  __typename: 'revisions_performance_evaluations_xref_pumps_journal_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Revisions_Performance_Evaluations_Xref_Pumps_Journal_Max_Fields>;
  min?: Maybe<Revisions_Performance_Evaluations_Xref_Pumps_Journal_Min_Fields>;
};


/** aggregate fields of "revisions.performance_evaluations_xref_pumps_journal" */
export type Revisions_Performance_Evaluations_Xref_Pumps_Journal_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Revisions_Performance_Evaluations_Xref_Pumps_Journal_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "revisions.performance_evaluations_xref_pumps_journal" */
export type Revisions_Performance_Evaluations_Xref_Pumps_Journal_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Revisions_Performance_Evaluations_Xref_Pumps_Journal_Max_Order_By>;
  min?: InputMaybe<Revisions_Performance_Evaluations_Xref_Pumps_Journal_Min_Order_By>;
};

/** input type for inserting array relation for remote table "revisions.performance_evaluations_xref_pumps_journal" */
export type Revisions_Performance_Evaluations_Xref_Pumps_Journal_Arr_Rel_Insert_Input = {
  data: Array<Revisions_Performance_Evaluations_Xref_Pumps_Journal_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Revisions_Performance_Evaluations_Xref_Pumps_Journal_On_Conflict>;
};

/** Boolean expression to filter rows from the table "revisions.performance_evaluations_xref_pumps_journal". All fields are combined with a logical 'AND'. */
export type Revisions_Performance_Evaluations_Xref_Pumps_Journal_Bool_Exp = {
  _and?: InputMaybe<Array<Revisions_Performance_Evaluations_Xref_Pumps_Journal_Bool_Exp>>;
  _not?: InputMaybe<Revisions_Performance_Evaluations_Xref_Pumps_Journal_Bool_Exp>;
  _or?: InputMaybe<Array<Revisions_Performance_Evaluations_Xref_Pumps_Journal_Bool_Exp>>;
  author_id?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  parent_journal_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  winning_revision_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "revisions.performance_evaluations_xref_pumps_journal" */
export enum Revisions_Performance_Evaluations_Xref_Pumps_Journal_Constraint {
  /** unique or primary key constraint on columns "id" */
  PerformanceEvaluationsXrefPumpsJournalPkey = 'performance_evaluations_xref_pumps_journal_pkey'
}

/** input type for inserting data into table "revisions.performance_evaluations_xref_pumps_journal" */
export type Revisions_Performance_Evaluations_Xref_Pumps_Journal_Insert_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  parent_journal_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  winning_revision_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Revisions_Performance_Evaluations_Xref_Pumps_Journal_Max_Fields = {
  __typename: 'revisions_performance_evaluations_xref_pumps_journal_max_fields';
  author_id?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  parent_journal_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  winning_revision_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "revisions.performance_evaluations_xref_pumps_journal" */
export type Revisions_Performance_Evaluations_Xref_Pumps_Journal_Max_Order_By = {
  author_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parent_journal_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  winning_revision_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Revisions_Performance_Evaluations_Xref_Pumps_Journal_Min_Fields = {
  __typename: 'revisions_performance_evaluations_xref_pumps_journal_min_fields';
  author_id?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  parent_journal_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  winning_revision_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "revisions.performance_evaluations_xref_pumps_journal" */
export type Revisions_Performance_Evaluations_Xref_Pumps_Journal_Min_Order_By = {
  author_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parent_journal_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  winning_revision_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "revisions.performance_evaluations_xref_pumps_journal" */
export type Revisions_Performance_Evaluations_Xref_Pumps_Journal_Mutation_Response = {
  __typename: 'revisions_performance_evaluations_xref_pumps_journal_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Revisions_Performance_Evaluations_Xref_Pumps_Journal>;
};

/** on_conflict condition type for table "revisions.performance_evaluations_xref_pumps_journal" */
export type Revisions_Performance_Evaluations_Xref_Pumps_Journal_On_Conflict = {
  constraint: Revisions_Performance_Evaluations_Xref_Pumps_Journal_Constraint;
  update_columns?: Array<Revisions_Performance_Evaluations_Xref_Pumps_Journal_Update_Column>;
  where?: InputMaybe<Revisions_Performance_Evaluations_Xref_Pumps_Journal_Bool_Exp>;
};

/** Ordering options when selecting data from "revisions.performance_evaluations_xref_pumps_journal". */
export type Revisions_Performance_Evaluations_Xref_Pumps_Journal_Order_By = {
  author_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parent_journal_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  winning_revision_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: revisions.performance_evaluations_xref_pumps_journal */
export type Revisions_Performance_Evaluations_Xref_Pumps_Journal_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "revisions.performance_evaluations_xref_pumps_journal" */
export enum Revisions_Performance_Evaluations_Xref_Pumps_Journal_Select_Column {
  /** column name */
  AuthorId = 'author_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  ParentJournalId = 'parent_journal_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WinningRevisionId = 'winning_revision_id'
}

/** input type for updating data in table "revisions.performance_evaluations_xref_pumps_journal" */
export type Revisions_Performance_Evaluations_Xref_Pumps_Journal_Set_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  parent_journal_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  winning_revision_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "revisions_performance_evaluations_xref_pumps_journal" */
export type Revisions_Performance_Evaluations_Xref_Pumps_Journal_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Revisions_Performance_Evaluations_Xref_Pumps_Journal_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Revisions_Performance_Evaluations_Xref_Pumps_Journal_Stream_Cursor_Value_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  parent_journal_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  winning_revision_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "revisions.performance_evaluations_xref_pumps_journal" */
export enum Revisions_Performance_Evaluations_Xref_Pumps_Journal_Update_Column {
  /** column name */
  AuthorId = 'author_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  ParentJournalId = 'parent_journal_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WinningRevisionId = 'winning_revision_id'
}

export type Revisions_Performance_Evaluations_Xref_Pumps_Journal_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Revisions_Performance_Evaluations_Xref_Pumps_Journal_Set_Input>;
  /** filter the rows which have to be updated */
  where: Revisions_Performance_Evaluations_Xref_Pumps_Journal_Bool_Exp;
};

/** columns and relationships of "revisions.performance_evaluations_xref_pumps_revisions" */
export type Revisions_Performance_Evaluations_Xref_Pumps_Revisions = {
  __typename: 'revisions_performance_evaluations_xref_pumps_revisions';
  author_id: Scalars['String']['output'];
  brake_horsepower_correction_ratio?: Maybe<Scalars['numeric']['output']>;
  cloned_from_journal_id?: Maybe<Scalars['uuid']['output']>;
  created_at: Scalars['timestamptz']['output'];
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  head_correction_ratio?: Maybe<Scalars['numeric']['output']>;
  id: Scalars['uuid']['output'];
  journal_id: Scalars['uuid']['output'];
  parent_revision_id?: Maybe<Scalars['uuid']['output']>;
  performance_evaluation_id: Scalars['uuid']['output'];
  /** An object relationship */
  performance_evaluations_journal: Revisions_Performance_Evaluations_Journal;
  /** An array relationship */
  performance_evaluations_xref_pumps_journals: Array<Revisions_Performance_Evaluations_Xref_Pumps_Journal>;
  /** An aggregate relationship */
  performance_evaluations_xref_pumps_journals_aggregate: Revisions_Performance_Evaluations_Xref_Pumps_Journal_Aggregate;
  /** An array relationship */
  performance_evaluations_xref_pumps_revisions: Array<Revisions_Performance_Evaluations_Xref_Pumps_Revisions>;
  /** An aggregate relationship */
  performance_evaluations_xref_pumps_revisions_aggregate: Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Aggregate;
  /** An object relationship */
  performance_evaluations_xref_pumps_view?: Maybe<Performance_Evaluations_Xref_Pumps>;
  rate_correction_ratio?: Maybe<Scalars['numeric']['output']>;
  /** An object relationship */
  scenario_equipment_xref_pumps_journal: Revisions_Scenario_Equipment_Xref_Pumps_Journal;
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Users;
  xref_pump_id: Scalars['uuid']['output'];
};


/** columns and relationships of "revisions.performance_evaluations_xref_pumps_revisions" */
export type Revisions_Performance_Evaluations_Xref_Pumps_RevisionsPerformance_Evaluations_Xref_Pumps_JournalsArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Performance_Evaluations_Xref_Pumps_Journal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Performance_Evaluations_Xref_Pumps_Journal_Order_By>>;
  where?: InputMaybe<Revisions_Performance_Evaluations_Xref_Pumps_Journal_Bool_Exp>;
};


/** columns and relationships of "revisions.performance_evaluations_xref_pumps_revisions" */
export type Revisions_Performance_Evaluations_Xref_Pumps_RevisionsPerformance_Evaluations_Xref_Pumps_Journals_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Performance_Evaluations_Xref_Pumps_Journal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Performance_Evaluations_Xref_Pumps_Journal_Order_By>>;
  where?: InputMaybe<Revisions_Performance_Evaluations_Xref_Pumps_Journal_Bool_Exp>;
};


/** columns and relationships of "revisions.performance_evaluations_xref_pumps_revisions" */
export type Revisions_Performance_Evaluations_Xref_Pumps_RevisionsPerformance_Evaluations_Xref_Pumps_RevisionsArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Bool_Exp>;
};


/** columns and relationships of "revisions.performance_evaluations_xref_pumps_revisions" */
export type Revisions_Performance_Evaluations_Xref_Pumps_RevisionsPerformance_Evaluations_Xref_Pumps_Revisions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Bool_Exp>;
};

/** aggregated selection of "revisions.performance_evaluations_xref_pumps_revisions" */
export type Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Aggregate = {
  __typename: 'revisions_performance_evaluations_xref_pumps_revisions_aggregate';
  aggregate?: Maybe<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Aggregate_Fields>;
  nodes: Array<Revisions_Performance_Evaluations_Xref_Pumps_Revisions>;
};

export type Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Aggregate_Bool_Exp = {
  count?: InputMaybe<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Aggregate_Bool_Exp_Count>;
};

export type Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "revisions.performance_evaluations_xref_pumps_revisions" */
export type Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Aggregate_Fields = {
  __typename: 'revisions_performance_evaluations_xref_pumps_revisions_aggregate_fields';
  avg?: Maybe<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Max_Fields>;
  min?: Maybe<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Min_Fields>;
  stddev?: Maybe<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Stddev_Fields>;
  stddev_pop?: Maybe<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Stddev_Samp_Fields>;
  sum?: Maybe<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Sum_Fields>;
  var_pop?: Maybe<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Var_Pop_Fields>;
  var_samp?: Maybe<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Var_Samp_Fields>;
  variance?: Maybe<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Variance_Fields>;
};


/** aggregate fields of "revisions.performance_evaluations_xref_pumps_revisions" */
export type Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "revisions.performance_evaluations_xref_pumps_revisions" */
export type Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Aggregate_Order_By = {
  avg?: InputMaybe<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Max_Order_By>;
  min?: InputMaybe<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Min_Order_By>;
  stddev?: InputMaybe<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Sum_Order_By>;
  var_pop?: InputMaybe<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Var_Samp_Order_By>;
  variance?: InputMaybe<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "revisions.performance_evaluations_xref_pumps_revisions" */
export type Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Arr_Rel_Insert_Input = {
  data: Array<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_On_Conflict>;
};

/** aggregate avg on columns */
export type Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Avg_Fields = {
  __typename: 'revisions_performance_evaluations_xref_pumps_revisions_avg_fields';
  brake_horsepower_correction_ratio?: Maybe<Scalars['Float']['output']>;
  head_correction_ratio?: Maybe<Scalars['Float']['output']>;
  rate_correction_ratio?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "revisions.performance_evaluations_xref_pumps_revisions" */
export type Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Avg_Order_By = {
  brake_horsepower_correction_ratio?: InputMaybe<Order_By>;
  head_correction_ratio?: InputMaybe<Order_By>;
  rate_correction_ratio?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "revisions.performance_evaluations_xref_pumps_revisions". All fields are combined with a logical 'AND'. */
export type Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Bool_Exp = {
  _and?: InputMaybe<Array<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Bool_Exp>>;
  _not?: InputMaybe<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Bool_Exp>;
  _or?: InputMaybe<Array<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Bool_Exp>>;
  author_id?: InputMaybe<String_Comparison_Exp>;
  brake_horsepower_correction_ratio?: InputMaybe<Numeric_Comparison_Exp>;
  cloned_from_journal_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  head_correction_ratio?: InputMaybe<Numeric_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  journal_id?: InputMaybe<Uuid_Comparison_Exp>;
  parent_revision_id?: InputMaybe<Uuid_Comparison_Exp>;
  performance_evaluation_id?: InputMaybe<Uuid_Comparison_Exp>;
  performance_evaluations_journal?: InputMaybe<Revisions_Performance_Evaluations_Journal_Bool_Exp>;
  performance_evaluations_xref_pumps_journals?: InputMaybe<Revisions_Performance_Evaluations_Xref_Pumps_Journal_Bool_Exp>;
  performance_evaluations_xref_pumps_journals_aggregate?: InputMaybe<Revisions_Performance_Evaluations_Xref_Pumps_Journal_Aggregate_Bool_Exp>;
  performance_evaluations_xref_pumps_revisions?: InputMaybe<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Bool_Exp>;
  performance_evaluations_xref_pumps_revisions_aggregate?: InputMaybe<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Aggregate_Bool_Exp>;
  performance_evaluations_xref_pumps_view?: InputMaybe<Performance_Evaluations_Xref_Pumps_Bool_Exp>;
  rate_correction_ratio?: InputMaybe<Numeric_Comparison_Exp>;
  scenario_equipment_xref_pumps_journal?: InputMaybe<Revisions_Scenario_Equipment_Xref_Pumps_Journal_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  xref_pump_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "revisions.performance_evaluations_xref_pumps_revisions" */
export enum Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Constraint {
  /** unique or primary key constraint on columns "id" */
  PerformanceEvaluationsXrefPumpsRevisionsPkey = 'performance_evaluations_xref_pumps_revisions_pkey'
}

/** input type for incrementing numeric columns in table "revisions.performance_evaluations_xref_pumps_revisions" */
export type Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Inc_Input = {
  brake_horsepower_correction_ratio?: InputMaybe<Scalars['numeric']['input']>;
  head_correction_ratio?: InputMaybe<Scalars['numeric']['input']>;
  rate_correction_ratio?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "revisions.performance_evaluations_xref_pumps_revisions" */
export type Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Insert_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  brake_horsepower_correction_ratio?: InputMaybe<Scalars['numeric']['input']>;
  cloned_from_journal_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  head_correction_ratio?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  journal_id?: InputMaybe<Scalars['uuid']['input']>;
  parent_revision_id?: InputMaybe<Scalars['uuid']['input']>;
  performance_evaluation_id?: InputMaybe<Scalars['uuid']['input']>;
  performance_evaluations_journal?: InputMaybe<Revisions_Performance_Evaluations_Journal_Obj_Rel_Insert_Input>;
  performance_evaluations_xref_pumps_journals?: InputMaybe<Revisions_Performance_Evaluations_Xref_Pumps_Journal_Arr_Rel_Insert_Input>;
  performance_evaluations_xref_pumps_revisions?: InputMaybe<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Arr_Rel_Insert_Input>;
  performance_evaluations_xref_pumps_view?: InputMaybe<Performance_Evaluations_Xref_Pumps_Obj_Rel_Insert_Input>;
  rate_correction_ratio?: InputMaybe<Scalars['numeric']['input']>;
  scenario_equipment_xref_pumps_journal?: InputMaybe<Revisions_Scenario_Equipment_Xref_Pumps_Journal_Obj_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  xref_pump_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Max_Fields = {
  __typename: 'revisions_performance_evaluations_xref_pumps_revisions_max_fields';
  author_id?: Maybe<Scalars['String']['output']>;
  brake_horsepower_correction_ratio?: Maybe<Scalars['numeric']['output']>;
  cloned_from_journal_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  head_correction_ratio?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  journal_id?: Maybe<Scalars['uuid']['output']>;
  parent_revision_id?: Maybe<Scalars['uuid']['output']>;
  performance_evaluation_id?: Maybe<Scalars['uuid']['output']>;
  rate_correction_ratio?: Maybe<Scalars['numeric']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  xref_pump_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "revisions.performance_evaluations_xref_pumps_revisions" */
export type Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Max_Order_By = {
  author_id?: InputMaybe<Order_By>;
  brake_horsepower_correction_ratio?: InputMaybe<Order_By>;
  cloned_from_journal_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  head_correction_ratio?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  journal_id?: InputMaybe<Order_By>;
  parent_revision_id?: InputMaybe<Order_By>;
  performance_evaluation_id?: InputMaybe<Order_By>;
  rate_correction_ratio?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  xref_pump_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Min_Fields = {
  __typename: 'revisions_performance_evaluations_xref_pumps_revisions_min_fields';
  author_id?: Maybe<Scalars['String']['output']>;
  brake_horsepower_correction_ratio?: Maybe<Scalars['numeric']['output']>;
  cloned_from_journal_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  head_correction_ratio?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  journal_id?: Maybe<Scalars['uuid']['output']>;
  parent_revision_id?: Maybe<Scalars['uuid']['output']>;
  performance_evaluation_id?: Maybe<Scalars['uuid']['output']>;
  rate_correction_ratio?: Maybe<Scalars['numeric']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  xref_pump_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "revisions.performance_evaluations_xref_pumps_revisions" */
export type Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Min_Order_By = {
  author_id?: InputMaybe<Order_By>;
  brake_horsepower_correction_ratio?: InputMaybe<Order_By>;
  cloned_from_journal_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  head_correction_ratio?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  journal_id?: InputMaybe<Order_By>;
  parent_revision_id?: InputMaybe<Order_By>;
  performance_evaluation_id?: InputMaybe<Order_By>;
  rate_correction_ratio?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  xref_pump_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "revisions.performance_evaluations_xref_pumps_revisions" */
export type Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Mutation_Response = {
  __typename: 'revisions_performance_evaluations_xref_pumps_revisions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Revisions_Performance_Evaluations_Xref_Pumps_Revisions>;
};

/** on_conflict condition type for table "revisions.performance_evaluations_xref_pumps_revisions" */
export type Revisions_Performance_Evaluations_Xref_Pumps_Revisions_On_Conflict = {
  constraint: Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Constraint;
  update_columns?: Array<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Update_Column>;
  where?: InputMaybe<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Bool_Exp>;
};

/** Ordering options when selecting data from "revisions.performance_evaluations_xref_pumps_revisions". */
export type Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Order_By = {
  author_id?: InputMaybe<Order_By>;
  brake_horsepower_correction_ratio?: InputMaybe<Order_By>;
  cloned_from_journal_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  head_correction_ratio?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  journal_id?: InputMaybe<Order_By>;
  parent_revision_id?: InputMaybe<Order_By>;
  performance_evaluation_id?: InputMaybe<Order_By>;
  performance_evaluations_journal?: InputMaybe<Revisions_Performance_Evaluations_Journal_Order_By>;
  performance_evaluations_xref_pumps_journals_aggregate?: InputMaybe<Revisions_Performance_Evaluations_Xref_Pumps_Journal_Aggregate_Order_By>;
  performance_evaluations_xref_pumps_revisions_aggregate?: InputMaybe<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Aggregate_Order_By>;
  performance_evaluations_xref_pumps_view?: InputMaybe<Performance_Evaluations_Xref_Pumps_Order_By>;
  rate_correction_ratio?: InputMaybe<Order_By>;
  scenario_equipment_xref_pumps_journal?: InputMaybe<Revisions_Scenario_Equipment_Xref_Pumps_Journal_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  xref_pump_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: revisions.performance_evaluations_xref_pumps_revisions */
export type Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "revisions.performance_evaluations_xref_pumps_revisions" */
export enum Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Select_Column {
  /** column name */
  AuthorId = 'author_id',
  /** column name */
  BrakeHorsepowerCorrectionRatio = 'brake_horsepower_correction_ratio',
  /** column name */
  ClonedFromJournalId = 'cloned_from_journal_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  HeadCorrectionRatio = 'head_correction_ratio',
  /** column name */
  Id = 'id',
  /** column name */
  JournalId = 'journal_id',
  /** column name */
  ParentRevisionId = 'parent_revision_id',
  /** column name */
  PerformanceEvaluationId = 'performance_evaluation_id',
  /** column name */
  RateCorrectionRatio = 'rate_correction_ratio',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  XrefPumpId = 'xref_pump_id'
}

/** input type for updating data in table "revisions.performance_evaluations_xref_pumps_revisions" */
export type Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Set_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  brake_horsepower_correction_ratio?: InputMaybe<Scalars['numeric']['input']>;
  cloned_from_journal_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  head_correction_ratio?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  journal_id?: InputMaybe<Scalars['uuid']['input']>;
  parent_revision_id?: InputMaybe<Scalars['uuid']['input']>;
  performance_evaluation_id?: InputMaybe<Scalars['uuid']['input']>;
  rate_correction_ratio?: InputMaybe<Scalars['numeric']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  xref_pump_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Stddev_Fields = {
  __typename: 'revisions_performance_evaluations_xref_pumps_revisions_stddev_fields';
  brake_horsepower_correction_ratio?: Maybe<Scalars['Float']['output']>;
  head_correction_ratio?: Maybe<Scalars['Float']['output']>;
  rate_correction_ratio?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "revisions.performance_evaluations_xref_pumps_revisions" */
export type Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Stddev_Order_By = {
  brake_horsepower_correction_ratio?: InputMaybe<Order_By>;
  head_correction_ratio?: InputMaybe<Order_By>;
  rate_correction_ratio?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Stddev_Pop_Fields = {
  __typename: 'revisions_performance_evaluations_xref_pumps_revisions_stddev_pop_fields';
  brake_horsepower_correction_ratio?: Maybe<Scalars['Float']['output']>;
  head_correction_ratio?: Maybe<Scalars['Float']['output']>;
  rate_correction_ratio?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "revisions.performance_evaluations_xref_pumps_revisions" */
export type Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Stddev_Pop_Order_By = {
  brake_horsepower_correction_ratio?: InputMaybe<Order_By>;
  head_correction_ratio?: InputMaybe<Order_By>;
  rate_correction_ratio?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Stddev_Samp_Fields = {
  __typename: 'revisions_performance_evaluations_xref_pumps_revisions_stddev_samp_fields';
  brake_horsepower_correction_ratio?: Maybe<Scalars['Float']['output']>;
  head_correction_ratio?: Maybe<Scalars['Float']['output']>;
  rate_correction_ratio?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "revisions.performance_evaluations_xref_pumps_revisions" */
export type Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Stddev_Samp_Order_By = {
  brake_horsepower_correction_ratio?: InputMaybe<Order_By>;
  head_correction_ratio?: InputMaybe<Order_By>;
  rate_correction_ratio?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "revisions_performance_evaluations_xref_pumps_revisions" */
export type Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Stream_Cursor_Value_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  brake_horsepower_correction_ratio?: InputMaybe<Scalars['numeric']['input']>;
  cloned_from_journal_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  head_correction_ratio?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  journal_id?: InputMaybe<Scalars['uuid']['input']>;
  parent_revision_id?: InputMaybe<Scalars['uuid']['input']>;
  performance_evaluation_id?: InputMaybe<Scalars['uuid']['input']>;
  rate_correction_ratio?: InputMaybe<Scalars['numeric']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  xref_pump_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Sum_Fields = {
  __typename: 'revisions_performance_evaluations_xref_pumps_revisions_sum_fields';
  brake_horsepower_correction_ratio?: Maybe<Scalars['numeric']['output']>;
  head_correction_ratio?: Maybe<Scalars['numeric']['output']>;
  rate_correction_ratio?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "revisions.performance_evaluations_xref_pumps_revisions" */
export type Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Sum_Order_By = {
  brake_horsepower_correction_ratio?: InputMaybe<Order_By>;
  head_correction_ratio?: InputMaybe<Order_By>;
  rate_correction_ratio?: InputMaybe<Order_By>;
};

/** update columns of table "revisions.performance_evaluations_xref_pumps_revisions" */
export enum Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Update_Column {
  /** column name */
  AuthorId = 'author_id',
  /** column name */
  BrakeHorsepowerCorrectionRatio = 'brake_horsepower_correction_ratio',
  /** column name */
  ClonedFromJournalId = 'cloned_from_journal_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  HeadCorrectionRatio = 'head_correction_ratio',
  /** column name */
  Id = 'id',
  /** column name */
  JournalId = 'journal_id',
  /** column name */
  ParentRevisionId = 'parent_revision_id',
  /** column name */
  PerformanceEvaluationId = 'performance_evaluation_id',
  /** column name */
  RateCorrectionRatio = 'rate_correction_ratio',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  XrefPumpId = 'xref_pump_id'
}

export type Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Set_Input>;
  /** filter the rows which have to be updated */
  where: Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Var_Pop_Fields = {
  __typename: 'revisions_performance_evaluations_xref_pumps_revisions_var_pop_fields';
  brake_horsepower_correction_ratio?: Maybe<Scalars['Float']['output']>;
  head_correction_ratio?: Maybe<Scalars['Float']['output']>;
  rate_correction_ratio?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "revisions.performance_evaluations_xref_pumps_revisions" */
export type Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Var_Pop_Order_By = {
  brake_horsepower_correction_ratio?: InputMaybe<Order_By>;
  head_correction_ratio?: InputMaybe<Order_By>;
  rate_correction_ratio?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Var_Samp_Fields = {
  __typename: 'revisions_performance_evaluations_xref_pumps_revisions_var_samp_fields';
  brake_horsepower_correction_ratio?: Maybe<Scalars['Float']['output']>;
  head_correction_ratio?: Maybe<Scalars['Float']['output']>;
  rate_correction_ratio?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "revisions.performance_evaluations_xref_pumps_revisions" */
export type Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Var_Samp_Order_By = {
  brake_horsepower_correction_ratio?: InputMaybe<Order_By>;
  head_correction_ratio?: InputMaybe<Order_By>;
  rate_correction_ratio?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Variance_Fields = {
  __typename: 'revisions_performance_evaluations_xref_pumps_revisions_variance_fields';
  brake_horsepower_correction_ratio?: Maybe<Scalars['Float']['output']>;
  head_correction_ratio?: Maybe<Scalars['Float']['output']>;
  rate_correction_ratio?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "revisions.performance_evaluations_xref_pumps_revisions" */
export type Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Variance_Order_By = {
  brake_horsepower_correction_ratio?: InputMaybe<Order_By>;
  head_correction_ratio?: InputMaybe<Order_By>;
  rate_correction_ratio?: InputMaybe<Order_By>;
};

/** columns and relationships of "revisions.sc_equip_xref_downhole_ytool_bypass_tubings_journal" */
export type Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal = {
  __typename: 'revisions_sc_equip_xref_downhole_ytool_bypass_tubings_journal';
  author_id: Scalars['String']['output'];
  created_at: Scalars['timestamptz']['output'];
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  parent_journal_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  sc_equip_xref_downhole_ytool_bypass_tubings_journal?: Maybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal>;
  /** An array relationship */
  sc_equip_xref_downhole_ytool_bypass_tubings_journals: Array<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal>;
  /** An aggregate relationship */
  sc_equip_xref_downhole_ytool_bypass_tubings_journals_aggregate: Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_Aggregate;
  /** An object relationship */
  sc_equip_xref_downhole_ytool_bypass_tubings_revision?: Maybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions>;
  /** An array relationship */
  sc_equip_xref_downhole_ytool_bypass_tubings_revisions: Array<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions>;
  /** An aggregate relationship */
  sc_equip_xref_downhole_ytool_bypass_tubings_revisions_aggregate: Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Aggregate;
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Users;
  winning_revision_id?: Maybe<Scalars['uuid']['output']>;
};


/** columns and relationships of "revisions.sc_equip_xref_downhole_ytool_bypass_tubings_journal" */
export type Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_JournalSc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_JournalsArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_Order_By>>;
  where?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_Bool_Exp>;
};


/** columns and relationships of "revisions.sc_equip_xref_downhole_ytool_bypass_tubings_journal" */
export type Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_JournalSc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journals_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_Order_By>>;
  where?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_Bool_Exp>;
};


/** columns and relationships of "revisions.sc_equip_xref_downhole_ytool_bypass_tubings_journal" */
export type Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_JournalSc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_RevisionsArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Bool_Exp>;
};


/** columns and relationships of "revisions.sc_equip_xref_downhole_ytool_bypass_tubings_journal" */
export type Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_JournalSc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Bool_Exp>;
};

/** aggregated selection of "revisions.sc_equip_xref_downhole_ytool_bypass_tubings_journal" */
export type Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_Aggregate = {
  __typename: 'revisions_sc_equip_xref_downhole_ytool_bypass_tubings_journal_aggregate';
  aggregate?: Maybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_Aggregate_Fields>;
  nodes: Array<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal>;
};

export type Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_Aggregate_Bool_Exp = {
  count?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_Aggregate_Bool_Exp_Count>;
};

export type Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "revisions.sc_equip_xref_downhole_ytool_bypass_tubings_journal" */
export type Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_Aggregate_Fields = {
  __typename: 'revisions_sc_equip_xref_downhole_ytool_bypass_tubings_journal_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_Max_Fields>;
  min?: Maybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_Min_Fields>;
};


/** aggregate fields of "revisions.sc_equip_xref_downhole_ytool_bypass_tubings_journal" */
export type Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "revisions.sc_equip_xref_downhole_ytool_bypass_tubings_journal" */
export type Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_Max_Order_By>;
  min?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_Min_Order_By>;
};

/** input type for inserting array relation for remote table "revisions.sc_equip_xref_downhole_ytool_bypass_tubings_journal" */
export type Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_Arr_Rel_Insert_Input = {
  data: Array<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_On_Conflict>;
};

/** Boolean expression to filter rows from the table "revisions.sc_equip_xref_downhole_ytool_bypass_tubings_journal". All fields are combined with a logical 'AND'. */
export type Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_Bool_Exp = {
  _and?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_Bool_Exp>>;
  _not?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_Bool_Exp>;
  _or?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_Bool_Exp>>;
  author_id?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  parent_journal_id?: InputMaybe<Uuid_Comparison_Exp>;
  sc_equip_xref_downhole_ytool_bypass_tubings_journal?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_Bool_Exp>;
  sc_equip_xref_downhole_ytool_bypass_tubings_journals?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_Bool_Exp>;
  sc_equip_xref_downhole_ytool_bypass_tubings_journals_aggregate?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_Aggregate_Bool_Exp>;
  sc_equip_xref_downhole_ytool_bypass_tubings_revision?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Bool_Exp>;
  sc_equip_xref_downhole_ytool_bypass_tubings_revisions?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Bool_Exp>;
  sc_equip_xref_downhole_ytool_bypass_tubings_revisions_aggregate?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Aggregate_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  winning_revision_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "revisions.sc_equip_xref_downhole_ytool_bypass_tubings_journal" */
export enum Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_Constraint {
  /** unique or primary key constraint on columns "id" */
  ScEquipXrefDownholeYtoolBypassTubingsJournalPkey = 'sc_equip_xref_downhole_ytool_bypass_tubings_journal_pkey'
}

/** input type for inserting data into table "revisions.sc_equip_xref_downhole_ytool_bypass_tubings_journal" */
export type Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_Insert_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  parent_journal_id?: InputMaybe<Scalars['uuid']['input']>;
  sc_equip_xref_downhole_ytool_bypass_tubings_journal?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_Obj_Rel_Insert_Input>;
  sc_equip_xref_downhole_ytool_bypass_tubings_journals?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_Arr_Rel_Insert_Input>;
  sc_equip_xref_downhole_ytool_bypass_tubings_revision?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Obj_Rel_Insert_Input>;
  sc_equip_xref_downhole_ytool_bypass_tubings_revisions?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Arr_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  winning_revision_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_Max_Fields = {
  __typename: 'revisions_sc_equip_xref_downhole_ytool_bypass_tubings_journal_max_fields';
  author_id?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  parent_journal_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  winning_revision_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "revisions.sc_equip_xref_downhole_ytool_bypass_tubings_journal" */
export type Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_Max_Order_By = {
  author_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parent_journal_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  winning_revision_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_Min_Fields = {
  __typename: 'revisions_sc_equip_xref_downhole_ytool_bypass_tubings_journal_min_fields';
  author_id?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  parent_journal_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  winning_revision_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "revisions.sc_equip_xref_downhole_ytool_bypass_tubings_journal" */
export type Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_Min_Order_By = {
  author_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parent_journal_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  winning_revision_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "revisions.sc_equip_xref_downhole_ytool_bypass_tubings_journal" */
export type Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_Mutation_Response = {
  __typename: 'revisions_sc_equip_xref_downhole_ytool_bypass_tubings_journal_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal>;
};

/** input type for inserting object relation for remote table "revisions.sc_equip_xref_downhole_ytool_bypass_tubings_journal" */
export type Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_Obj_Rel_Insert_Input = {
  data: Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_On_Conflict>;
};

/** on_conflict condition type for table "revisions.sc_equip_xref_downhole_ytool_bypass_tubings_journal" */
export type Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_On_Conflict = {
  constraint: Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_Constraint;
  update_columns?: Array<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_Update_Column>;
  where?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_Bool_Exp>;
};

/** Ordering options when selecting data from "revisions.sc_equip_xref_downhole_ytool_bypass_tubings_journal". */
export type Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_Order_By = {
  author_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parent_journal_id?: InputMaybe<Order_By>;
  sc_equip_xref_downhole_ytool_bypass_tubings_journal?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_Order_By>;
  sc_equip_xref_downhole_ytool_bypass_tubings_journals_aggregate?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_Aggregate_Order_By>;
  sc_equip_xref_downhole_ytool_bypass_tubings_revision?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Order_By>;
  sc_equip_xref_downhole_ytool_bypass_tubings_revisions_aggregate?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  winning_revision_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: revisions.sc_equip_xref_downhole_ytool_bypass_tubings_journal */
export type Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "revisions.sc_equip_xref_downhole_ytool_bypass_tubings_journal" */
export enum Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_Select_Column {
  /** column name */
  AuthorId = 'author_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  ParentJournalId = 'parent_journal_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WinningRevisionId = 'winning_revision_id'
}

/** input type for updating data in table "revisions.sc_equip_xref_downhole_ytool_bypass_tubings_journal" */
export type Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_Set_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  parent_journal_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  winning_revision_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "revisions_sc_equip_xref_downhole_ytool_bypass_tubings_journal" */
export type Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_Stream_Cursor_Value_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  parent_journal_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  winning_revision_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "revisions.sc_equip_xref_downhole_ytool_bypass_tubings_journal" */
export enum Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_Update_Column {
  /** column name */
  AuthorId = 'author_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  ParentJournalId = 'parent_journal_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WinningRevisionId = 'winning_revision_id'
}

export type Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_Set_Input>;
  /** filter the rows which have to be updated */
  where: Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_Bool_Exp;
};

/** columns and relationships of "revisions.sc_equip_xref_downhole_ytool_bypass_tubings_revisions" */
export type Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions = {
  __typename: 'revisions_sc_equip_xref_downhole_ytool_bypass_tubings_revisions';
  author_id: Scalars['String']['output'];
  cloned_from_journal_id?: Maybe<Scalars['uuid']['output']>;
  created_at: Scalars['timestamptz']['output'];
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  journal_id: Scalars['uuid']['output'];
  length_feet?: Maybe<Scalars['numeric']['output']>;
  parent_revision_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  sc_equip_xref_downhole_ytool_bypass_tubings_journal: Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal;
  /** An array relationship */
  sc_equip_xref_downhole_ytool_bypass_tubings_journals: Array<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal>;
  /** An aggregate relationship */
  sc_equip_xref_downhole_ytool_bypass_tubings_journals_aggregate: Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_Aggregate;
  /** An object relationship */
  sc_equip_xref_downhole_ytool_bypass_tubings_revision?: Maybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions>;
  /** An array relationship */
  sc_equip_xref_downhole_ytool_bypass_tubings_revisions: Array<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions>;
  /** An aggregate relationship */
  sc_equip_xref_downhole_ytool_bypass_tubings_revisions_aggregate: Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Aggregate;
  /** An object relationship */
  sc_equip_xref_downhole_ytool_bypass_tubings_view?: Maybe<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings>;
  scenario_equipment_id: Scalars['uuid']['output'];
  /** An object relationship */
  scenario_equipment_journal: Revisions_Scenario_Equipment_Journal;
  /** An object relationship */
  tubing: Tubings;
  tubing_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Users;
};


/** columns and relationships of "revisions.sc_equip_xref_downhole_ytool_bypass_tubings_revisions" */
export type Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_RevisionsSc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_JournalsArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_Order_By>>;
  where?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_Bool_Exp>;
};


/** columns and relationships of "revisions.sc_equip_xref_downhole_ytool_bypass_tubings_revisions" */
export type Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_RevisionsSc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journals_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_Order_By>>;
  where?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_Bool_Exp>;
};


/** columns and relationships of "revisions.sc_equip_xref_downhole_ytool_bypass_tubings_revisions" */
export type Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_RevisionsSc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_RevisionsArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Bool_Exp>;
};


/** columns and relationships of "revisions.sc_equip_xref_downhole_ytool_bypass_tubings_revisions" */
export type Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_RevisionsSc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Bool_Exp>;
};

/** aggregated selection of "revisions.sc_equip_xref_downhole_ytool_bypass_tubings_revisions" */
export type Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Aggregate = {
  __typename: 'revisions_sc_equip_xref_downhole_ytool_bypass_tubings_revisions_aggregate';
  aggregate?: Maybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Aggregate_Fields>;
  nodes: Array<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions>;
};

export type Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Aggregate_Bool_Exp = {
  count?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Aggregate_Bool_Exp_Count>;
};

export type Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "revisions.sc_equip_xref_downhole_ytool_bypass_tubings_revisions" */
export type Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Aggregate_Fields = {
  __typename: 'revisions_sc_equip_xref_downhole_ytool_bypass_tubings_revisions_aggregate_fields';
  avg?: Maybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Max_Fields>;
  min?: Maybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Min_Fields>;
  stddev?: Maybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Stddev_Fields>;
  stddev_pop?: Maybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Stddev_Samp_Fields>;
  sum?: Maybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Sum_Fields>;
  var_pop?: Maybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Var_Pop_Fields>;
  var_samp?: Maybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Var_Samp_Fields>;
  variance?: Maybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Variance_Fields>;
};


/** aggregate fields of "revisions.sc_equip_xref_downhole_ytool_bypass_tubings_revisions" */
export type Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "revisions.sc_equip_xref_downhole_ytool_bypass_tubings_revisions" */
export type Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Aggregate_Order_By = {
  avg?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Max_Order_By>;
  min?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Min_Order_By>;
  stddev?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Sum_Order_By>;
  var_pop?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Var_Samp_Order_By>;
  variance?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "revisions.sc_equip_xref_downhole_ytool_bypass_tubings_revisions" */
export type Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Arr_Rel_Insert_Input = {
  data: Array<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_On_Conflict>;
};

/** aggregate avg on columns */
export type Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Avg_Fields = {
  __typename: 'revisions_sc_equip_xref_downhole_ytool_bypass_tubings_revisions_avg_fields';
  length_feet?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "revisions.sc_equip_xref_downhole_ytool_bypass_tubings_revisions" */
export type Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Avg_Order_By = {
  length_feet?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "revisions.sc_equip_xref_downhole_ytool_bypass_tubings_revisions". All fields are combined with a logical 'AND'. */
export type Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Bool_Exp = {
  _and?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Bool_Exp>>;
  _not?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Bool_Exp>;
  _or?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Bool_Exp>>;
  author_id?: InputMaybe<String_Comparison_Exp>;
  cloned_from_journal_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  journal_id?: InputMaybe<Uuid_Comparison_Exp>;
  length_feet?: InputMaybe<Numeric_Comparison_Exp>;
  parent_revision_id?: InputMaybe<Uuid_Comparison_Exp>;
  sc_equip_xref_downhole_ytool_bypass_tubings_journal?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_Bool_Exp>;
  sc_equip_xref_downhole_ytool_bypass_tubings_journals?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_Bool_Exp>;
  sc_equip_xref_downhole_ytool_bypass_tubings_journals_aggregate?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_Aggregate_Bool_Exp>;
  sc_equip_xref_downhole_ytool_bypass_tubings_revision?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Bool_Exp>;
  sc_equip_xref_downhole_ytool_bypass_tubings_revisions?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Bool_Exp>;
  sc_equip_xref_downhole_ytool_bypass_tubings_revisions_aggregate?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Aggregate_Bool_Exp>;
  sc_equip_xref_downhole_ytool_bypass_tubings_view?: InputMaybe<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Bool_Exp>;
  scenario_equipment_id?: InputMaybe<Uuid_Comparison_Exp>;
  scenario_equipment_journal?: InputMaybe<Revisions_Scenario_Equipment_Journal_Bool_Exp>;
  tubing?: InputMaybe<Tubings_Bool_Exp>;
  tubing_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
};

/** unique or primary key constraints on table "revisions.sc_equip_xref_downhole_ytool_bypass_tubings_revisions" */
export enum Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Constraint {
  /** unique or primary key constraint on columns "id" */
  ScEquipXrefDownholeYtoolBypassTubingsRevisionsPkey = 'sc_equip_xref_downhole_ytool_bypass_tubings_revisions_pkey'
}

/** input type for incrementing numeric columns in table "revisions.sc_equip_xref_downhole_ytool_bypass_tubings_revisions" */
export type Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Inc_Input = {
  length_feet?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "revisions.sc_equip_xref_downhole_ytool_bypass_tubings_revisions" */
export type Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Insert_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  cloned_from_journal_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  journal_id?: InputMaybe<Scalars['uuid']['input']>;
  length_feet?: InputMaybe<Scalars['numeric']['input']>;
  parent_revision_id?: InputMaybe<Scalars['uuid']['input']>;
  sc_equip_xref_downhole_ytool_bypass_tubings_journal?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_Obj_Rel_Insert_Input>;
  sc_equip_xref_downhole_ytool_bypass_tubings_journals?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_Arr_Rel_Insert_Input>;
  sc_equip_xref_downhole_ytool_bypass_tubings_revision?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Obj_Rel_Insert_Input>;
  sc_equip_xref_downhole_ytool_bypass_tubings_revisions?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Arr_Rel_Insert_Input>;
  sc_equip_xref_downhole_ytool_bypass_tubings_view?: InputMaybe<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Obj_Rel_Insert_Input>;
  scenario_equipment_id?: InputMaybe<Scalars['uuid']['input']>;
  scenario_equipment_journal?: InputMaybe<Revisions_Scenario_Equipment_Journal_Obj_Rel_Insert_Input>;
  tubing?: InputMaybe<Tubings_Obj_Rel_Insert_Input>;
  tubing_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Max_Fields = {
  __typename: 'revisions_sc_equip_xref_downhole_ytool_bypass_tubings_revisions_max_fields';
  author_id?: Maybe<Scalars['String']['output']>;
  cloned_from_journal_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  journal_id?: Maybe<Scalars['uuid']['output']>;
  length_feet?: Maybe<Scalars['numeric']['output']>;
  parent_revision_id?: Maybe<Scalars['uuid']['output']>;
  scenario_equipment_id?: Maybe<Scalars['uuid']['output']>;
  tubing_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "revisions.sc_equip_xref_downhole_ytool_bypass_tubings_revisions" */
export type Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Max_Order_By = {
  author_id?: InputMaybe<Order_By>;
  cloned_from_journal_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  journal_id?: InputMaybe<Order_By>;
  length_feet?: InputMaybe<Order_By>;
  parent_revision_id?: InputMaybe<Order_By>;
  scenario_equipment_id?: InputMaybe<Order_By>;
  tubing_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Min_Fields = {
  __typename: 'revisions_sc_equip_xref_downhole_ytool_bypass_tubings_revisions_min_fields';
  author_id?: Maybe<Scalars['String']['output']>;
  cloned_from_journal_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  journal_id?: Maybe<Scalars['uuid']['output']>;
  length_feet?: Maybe<Scalars['numeric']['output']>;
  parent_revision_id?: Maybe<Scalars['uuid']['output']>;
  scenario_equipment_id?: Maybe<Scalars['uuid']['output']>;
  tubing_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "revisions.sc_equip_xref_downhole_ytool_bypass_tubings_revisions" */
export type Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Min_Order_By = {
  author_id?: InputMaybe<Order_By>;
  cloned_from_journal_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  journal_id?: InputMaybe<Order_By>;
  length_feet?: InputMaybe<Order_By>;
  parent_revision_id?: InputMaybe<Order_By>;
  scenario_equipment_id?: InputMaybe<Order_By>;
  tubing_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "revisions.sc_equip_xref_downhole_ytool_bypass_tubings_revisions" */
export type Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Mutation_Response = {
  __typename: 'revisions_sc_equip_xref_downhole_ytool_bypass_tubings_revisions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions>;
};

/** input type for inserting object relation for remote table "revisions.sc_equip_xref_downhole_ytool_bypass_tubings_revisions" */
export type Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Obj_Rel_Insert_Input = {
  data: Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_On_Conflict>;
};

/** on_conflict condition type for table "revisions.sc_equip_xref_downhole_ytool_bypass_tubings_revisions" */
export type Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_On_Conflict = {
  constraint: Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Constraint;
  update_columns?: Array<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Update_Column>;
  where?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Bool_Exp>;
};

/** Ordering options when selecting data from "revisions.sc_equip_xref_downhole_ytool_bypass_tubings_revisions". */
export type Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Order_By = {
  author_id?: InputMaybe<Order_By>;
  cloned_from_journal_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  journal_id?: InputMaybe<Order_By>;
  length_feet?: InputMaybe<Order_By>;
  parent_revision_id?: InputMaybe<Order_By>;
  sc_equip_xref_downhole_ytool_bypass_tubings_journal?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_Order_By>;
  sc_equip_xref_downhole_ytool_bypass_tubings_journals_aggregate?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_Aggregate_Order_By>;
  sc_equip_xref_downhole_ytool_bypass_tubings_revision?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Order_By>;
  sc_equip_xref_downhole_ytool_bypass_tubings_revisions_aggregate?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Aggregate_Order_By>;
  sc_equip_xref_downhole_ytool_bypass_tubings_view?: InputMaybe<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Order_By>;
  scenario_equipment_id?: InputMaybe<Order_By>;
  scenario_equipment_journal?: InputMaybe<Revisions_Scenario_Equipment_Journal_Order_By>;
  tubing?: InputMaybe<Tubings_Order_By>;
  tubing_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
};

/** primary key columns input for table: revisions.sc_equip_xref_downhole_ytool_bypass_tubings_revisions */
export type Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "revisions.sc_equip_xref_downhole_ytool_bypass_tubings_revisions" */
export enum Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Select_Column {
  /** column name */
  AuthorId = 'author_id',
  /** column name */
  ClonedFromJournalId = 'cloned_from_journal_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  JournalId = 'journal_id',
  /** column name */
  LengthFeet = 'length_feet',
  /** column name */
  ParentRevisionId = 'parent_revision_id',
  /** column name */
  ScenarioEquipmentId = 'scenario_equipment_id',
  /** column name */
  TubingId = 'tubing_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "revisions.sc_equip_xref_downhole_ytool_bypass_tubings_revisions" */
export type Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Set_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  cloned_from_journal_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  journal_id?: InputMaybe<Scalars['uuid']['input']>;
  length_feet?: InputMaybe<Scalars['numeric']['input']>;
  parent_revision_id?: InputMaybe<Scalars['uuid']['input']>;
  scenario_equipment_id?: InputMaybe<Scalars['uuid']['input']>;
  tubing_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Stddev_Fields = {
  __typename: 'revisions_sc_equip_xref_downhole_ytool_bypass_tubings_revisions_stddev_fields';
  length_feet?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "revisions.sc_equip_xref_downhole_ytool_bypass_tubings_revisions" */
export type Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Stddev_Order_By = {
  length_feet?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Stddev_Pop_Fields = {
  __typename: 'revisions_sc_equip_xref_downhole_ytool_bypass_tubings_revisions_stddev_pop_fields';
  length_feet?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "revisions.sc_equip_xref_downhole_ytool_bypass_tubings_revisions" */
export type Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Stddev_Pop_Order_By = {
  length_feet?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Stddev_Samp_Fields = {
  __typename: 'revisions_sc_equip_xref_downhole_ytool_bypass_tubings_revisions_stddev_samp_fields';
  length_feet?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "revisions.sc_equip_xref_downhole_ytool_bypass_tubings_revisions" */
export type Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Stddev_Samp_Order_By = {
  length_feet?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "revisions_sc_equip_xref_downhole_ytool_bypass_tubings_revisions" */
export type Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Stream_Cursor_Value_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  cloned_from_journal_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  journal_id?: InputMaybe<Scalars['uuid']['input']>;
  length_feet?: InputMaybe<Scalars['numeric']['input']>;
  parent_revision_id?: InputMaybe<Scalars['uuid']['input']>;
  scenario_equipment_id?: InputMaybe<Scalars['uuid']['input']>;
  tubing_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Sum_Fields = {
  __typename: 'revisions_sc_equip_xref_downhole_ytool_bypass_tubings_revisions_sum_fields';
  length_feet?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "revisions.sc_equip_xref_downhole_ytool_bypass_tubings_revisions" */
export type Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Sum_Order_By = {
  length_feet?: InputMaybe<Order_By>;
};

/** update columns of table "revisions.sc_equip_xref_downhole_ytool_bypass_tubings_revisions" */
export enum Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Update_Column {
  /** column name */
  AuthorId = 'author_id',
  /** column name */
  ClonedFromJournalId = 'cloned_from_journal_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  JournalId = 'journal_id',
  /** column name */
  LengthFeet = 'length_feet',
  /** column name */
  ParentRevisionId = 'parent_revision_id',
  /** column name */
  ScenarioEquipmentId = 'scenario_equipment_id',
  /** column name */
  TubingId = 'tubing_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Set_Input>;
  /** filter the rows which have to be updated */
  where: Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Var_Pop_Fields = {
  __typename: 'revisions_sc_equip_xref_downhole_ytool_bypass_tubings_revisions_var_pop_fields';
  length_feet?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "revisions.sc_equip_xref_downhole_ytool_bypass_tubings_revisions" */
export type Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Var_Pop_Order_By = {
  length_feet?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Var_Samp_Fields = {
  __typename: 'revisions_sc_equip_xref_downhole_ytool_bypass_tubings_revisions_var_samp_fields';
  length_feet?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "revisions.sc_equip_xref_downhole_ytool_bypass_tubings_revisions" */
export type Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Var_Samp_Order_By = {
  length_feet?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Variance_Fields = {
  __typename: 'revisions_sc_equip_xref_downhole_ytool_bypass_tubings_revisions_variance_fields';
  length_feet?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "revisions.sc_equip_xref_downhole_ytool_bypass_tubings_revisions" */
export type Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Variance_Order_By = {
  length_feet?: InputMaybe<Order_By>;
};

/** columns and relationships of "revisions.sc_equip_xref_downhole_ytool_equip_tubings_journal" */
export type Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal = {
  __typename: 'revisions_sc_equip_xref_downhole_ytool_equip_tubings_journal';
  author_id: Scalars['String']['output'];
  created_at: Scalars['timestamptz']['output'];
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  parent_journal_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  sc_equip_xref_downhole_ytool_equip_tubings_journal?: Maybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal>;
  /** An array relationship */
  sc_equip_xref_downhole_ytool_equip_tubings_journals: Array<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal>;
  /** An aggregate relationship */
  sc_equip_xref_downhole_ytool_equip_tubings_journals_aggregate: Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_Aggregate;
  /** An object relationship */
  sc_equip_xref_downhole_ytool_equip_tubings_revisions?: Maybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions>;
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Users;
  winning_revision_id?: Maybe<Scalars['uuid']['output']>;
};


/** columns and relationships of "revisions.sc_equip_xref_downhole_ytool_equip_tubings_journal" */
export type Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_JournalSc_Equip_Xref_Downhole_Ytool_Equip_Tubings_JournalsArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_Order_By>>;
  where?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_Bool_Exp>;
};


/** columns and relationships of "revisions.sc_equip_xref_downhole_ytool_equip_tubings_journal" */
export type Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_JournalSc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journals_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_Order_By>>;
  where?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_Bool_Exp>;
};

/** aggregated selection of "revisions.sc_equip_xref_downhole_ytool_equip_tubings_journal" */
export type Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_Aggregate = {
  __typename: 'revisions_sc_equip_xref_downhole_ytool_equip_tubings_journal_aggregate';
  aggregate?: Maybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_Aggregate_Fields>;
  nodes: Array<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal>;
};

export type Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_Aggregate_Bool_Exp = {
  count?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_Aggregate_Bool_Exp_Count>;
};

export type Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "revisions.sc_equip_xref_downhole_ytool_equip_tubings_journal" */
export type Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_Aggregate_Fields = {
  __typename: 'revisions_sc_equip_xref_downhole_ytool_equip_tubings_journal_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_Max_Fields>;
  min?: Maybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_Min_Fields>;
};


/** aggregate fields of "revisions.sc_equip_xref_downhole_ytool_equip_tubings_journal" */
export type Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "revisions.sc_equip_xref_downhole_ytool_equip_tubings_journal" */
export type Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_Max_Order_By>;
  min?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_Min_Order_By>;
};

/** input type for inserting array relation for remote table "revisions.sc_equip_xref_downhole_ytool_equip_tubings_journal" */
export type Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_Arr_Rel_Insert_Input = {
  data: Array<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_On_Conflict>;
};

/** Boolean expression to filter rows from the table "revisions.sc_equip_xref_downhole_ytool_equip_tubings_journal". All fields are combined with a logical 'AND'. */
export type Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_Bool_Exp = {
  _and?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_Bool_Exp>>;
  _not?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_Bool_Exp>;
  _or?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_Bool_Exp>>;
  author_id?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  parent_journal_id?: InputMaybe<Uuid_Comparison_Exp>;
  sc_equip_xref_downhole_ytool_equip_tubings_journal?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_Bool_Exp>;
  sc_equip_xref_downhole_ytool_equip_tubings_journals?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_Bool_Exp>;
  sc_equip_xref_downhole_ytool_equip_tubings_journals_aggregate?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_Aggregate_Bool_Exp>;
  sc_equip_xref_downhole_ytool_equip_tubings_revisions?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  winning_revision_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "revisions.sc_equip_xref_downhole_ytool_equip_tubings_journal" */
export enum Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_Constraint {
  /** unique or primary key constraint on columns "id" */
  ScEquipXrefDownholeYtoolEquipTubingsJournalPkey = 'sc_equip_xref_downhole_ytool_equip_tubings_journal_pkey'
}

/** input type for inserting data into table "revisions.sc_equip_xref_downhole_ytool_equip_tubings_journal" */
export type Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_Insert_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  parent_journal_id?: InputMaybe<Scalars['uuid']['input']>;
  sc_equip_xref_downhole_ytool_equip_tubings_journal?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_Obj_Rel_Insert_Input>;
  sc_equip_xref_downhole_ytool_equip_tubings_journals?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_Arr_Rel_Insert_Input>;
  sc_equip_xref_downhole_ytool_equip_tubings_revisions?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Obj_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  winning_revision_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_Max_Fields = {
  __typename: 'revisions_sc_equip_xref_downhole_ytool_equip_tubings_journal_max_fields';
  author_id?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  parent_journal_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  winning_revision_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "revisions.sc_equip_xref_downhole_ytool_equip_tubings_journal" */
export type Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_Max_Order_By = {
  author_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parent_journal_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  winning_revision_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_Min_Fields = {
  __typename: 'revisions_sc_equip_xref_downhole_ytool_equip_tubings_journal_min_fields';
  author_id?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  parent_journal_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  winning_revision_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "revisions.sc_equip_xref_downhole_ytool_equip_tubings_journal" */
export type Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_Min_Order_By = {
  author_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parent_journal_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  winning_revision_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "revisions.sc_equip_xref_downhole_ytool_equip_tubings_journal" */
export type Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_Mutation_Response = {
  __typename: 'revisions_sc_equip_xref_downhole_ytool_equip_tubings_journal_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal>;
};

/** input type for inserting object relation for remote table "revisions.sc_equip_xref_downhole_ytool_equip_tubings_journal" */
export type Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_Obj_Rel_Insert_Input = {
  data: Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_On_Conflict>;
};

/** on_conflict condition type for table "revisions.sc_equip_xref_downhole_ytool_equip_tubings_journal" */
export type Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_On_Conflict = {
  constraint: Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_Constraint;
  update_columns?: Array<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_Update_Column>;
  where?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_Bool_Exp>;
};

/** Ordering options when selecting data from "revisions.sc_equip_xref_downhole_ytool_equip_tubings_journal". */
export type Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_Order_By = {
  author_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parent_journal_id?: InputMaybe<Order_By>;
  sc_equip_xref_downhole_ytool_equip_tubings_journal?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_Order_By>;
  sc_equip_xref_downhole_ytool_equip_tubings_journals_aggregate?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_Aggregate_Order_By>;
  sc_equip_xref_downhole_ytool_equip_tubings_revisions?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  winning_revision_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: revisions.sc_equip_xref_downhole_ytool_equip_tubings_journal */
export type Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "revisions.sc_equip_xref_downhole_ytool_equip_tubings_journal" */
export enum Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_Select_Column {
  /** column name */
  AuthorId = 'author_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  ParentJournalId = 'parent_journal_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WinningRevisionId = 'winning_revision_id'
}

/** input type for updating data in table "revisions.sc_equip_xref_downhole_ytool_equip_tubings_journal" */
export type Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_Set_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  parent_journal_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  winning_revision_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "revisions_sc_equip_xref_downhole_ytool_equip_tubings_journal" */
export type Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_Stream_Cursor_Value_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  parent_journal_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  winning_revision_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "revisions.sc_equip_xref_downhole_ytool_equip_tubings_journal" */
export enum Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_Update_Column {
  /** column name */
  AuthorId = 'author_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  ParentJournalId = 'parent_journal_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WinningRevisionId = 'winning_revision_id'
}

export type Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_Set_Input>;
  /** filter the rows which have to be updated */
  where: Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_Bool_Exp;
};

/** columns and relationships of "revisions.sc_equip_xref_downhole_ytool_equip_tubings_revisions" */
export type Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions = {
  __typename: 'revisions_sc_equip_xref_downhole_ytool_equip_tubings_revisions';
  author_id: Scalars['String']['output'];
  cloned_from_journal_id?: Maybe<Scalars['uuid']['output']>;
  created_at: Scalars['timestamptz']['output'];
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  journal_id: Scalars['uuid']['output'];
  length_feet?: Maybe<Scalars['numeric']['output']>;
  parent_revision_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  sc_equip_xref_downhole_ytool_equip_tubings_journal: Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal;
  /** An array relationship */
  sc_equip_xref_downhole_ytool_equip_tubings_journals: Array<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal>;
  /** An aggregate relationship */
  sc_equip_xref_downhole_ytool_equip_tubings_journals_aggregate: Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_Aggregate;
  /** An object relationship */
  sc_equip_xref_downhole_ytool_equip_tubings_revisions?: Maybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions>;
  /** An object relationship */
  sc_equip_xref_downhole_ytool_equip_tubings_view?: Maybe<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings>;
  scenario_equipment_id: Scalars['uuid']['output'];
  /** An object relationship */
  scenario_equipment_journal: Revisions_Scenario_Equipment_Journal;
  /** An object relationship */
  tubing: Tubings;
  tubing_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Users;
};


/** columns and relationships of "revisions.sc_equip_xref_downhole_ytool_equip_tubings_revisions" */
export type Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_RevisionsSc_Equip_Xref_Downhole_Ytool_Equip_Tubings_JournalsArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_Order_By>>;
  where?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_Bool_Exp>;
};


/** columns and relationships of "revisions.sc_equip_xref_downhole_ytool_equip_tubings_revisions" */
export type Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_RevisionsSc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journals_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_Order_By>>;
  where?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_Bool_Exp>;
};

/** aggregated selection of "revisions.sc_equip_xref_downhole_ytool_equip_tubings_revisions" */
export type Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Aggregate = {
  __typename: 'revisions_sc_equip_xref_downhole_ytool_equip_tubings_revisions_aggregate';
  aggregate?: Maybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Aggregate_Fields>;
  nodes: Array<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions>;
};

export type Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Aggregate_Bool_Exp = {
  count?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Aggregate_Bool_Exp_Count>;
};

export type Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "revisions.sc_equip_xref_downhole_ytool_equip_tubings_revisions" */
export type Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Aggregate_Fields = {
  __typename: 'revisions_sc_equip_xref_downhole_ytool_equip_tubings_revisions_aggregate_fields';
  avg?: Maybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Max_Fields>;
  min?: Maybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Min_Fields>;
  stddev?: Maybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Stddev_Fields>;
  stddev_pop?: Maybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Stddev_Samp_Fields>;
  sum?: Maybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Sum_Fields>;
  var_pop?: Maybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Var_Pop_Fields>;
  var_samp?: Maybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Var_Samp_Fields>;
  variance?: Maybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Variance_Fields>;
};


/** aggregate fields of "revisions.sc_equip_xref_downhole_ytool_equip_tubings_revisions" */
export type Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "revisions.sc_equip_xref_downhole_ytool_equip_tubings_revisions" */
export type Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Aggregate_Order_By = {
  avg?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Max_Order_By>;
  min?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Min_Order_By>;
  stddev?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Sum_Order_By>;
  var_pop?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Var_Samp_Order_By>;
  variance?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "revisions.sc_equip_xref_downhole_ytool_equip_tubings_revisions" */
export type Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Arr_Rel_Insert_Input = {
  data: Array<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_On_Conflict>;
};

/** aggregate avg on columns */
export type Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Avg_Fields = {
  __typename: 'revisions_sc_equip_xref_downhole_ytool_equip_tubings_revisions_avg_fields';
  length_feet?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "revisions.sc_equip_xref_downhole_ytool_equip_tubings_revisions" */
export type Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Avg_Order_By = {
  length_feet?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "revisions.sc_equip_xref_downhole_ytool_equip_tubings_revisions". All fields are combined with a logical 'AND'. */
export type Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Bool_Exp = {
  _and?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Bool_Exp>>;
  _not?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Bool_Exp>;
  _or?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Bool_Exp>>;
  author_id?: InputMaybe<String_Comparison_Exp>;
  cloned_from_journal_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  journal_id?: InputMaybe<Uuid_Comparison_Exp>;
  length_feet?: InputMaybe<Numeric_Comparison_Exp>;
  parent_revision_id?: InputMaybe<Uuid_Comparison_Exp>;
  sc_equip_xref_downhole_ytool_equip_tubings_journal?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_Bool_Exp>;
  sc_equip_xref_downhole_ytool_equip_tubings_journals?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_Bool_Exp>;
  sc_equip_xref_downhole_ytool_equip_tubings_journals_aggregate?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_Aggregate_Bool_Exp>;
  sc_equip_xref_downhole_ytool_equip_tubings_revisions?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Bool_Exp>;
  sc_equip_xref_downhole_ytool_equip_tubings_view?: InputMaybe<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Bool_Exp>;
  scenario_equipment_id?: InputMaybe<Uuid_Comparison_Exp>;
  scenario_equipment_journal?: InputMaybe<Revisions_Scenario_Equipment_Journal_Bool_Exp>;
  tubing?: InputMaybe<Tubings_Bool_Exp>;
  tubing_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
};

/** unique or primary key constraints on table "revisions.sc_equip_xref_downhole_ytool_equip_tubings_revisions" */
export enum Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Constraint {
  /** unique or primary key constraint on columns "id" */
  ScEquipXrefDownholeYtoolEquipTubingsRevisionsPkey = 'sc_equip_xref_downhole_ytool_equip_tubings_revisions_pkey'
}

/** input type for incrementing numeric columns in table "revisions.sc_equip_xref_downhole_ytool_equip_tubings_revisions" */
export type Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Inc_Input = {
  length_feet?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "revisions.sc_equip_xref_downhole_ytool_equip_tubings_revisions" */
export type Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Insert_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  cloned_from_journal_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  journal_id?: InputMaybe<Scalars['uuid']['input']>;
  length_feet?: InputMaybe<Scalars['numeric']['input']>;
  parent_revision_id?: InputMaybe<Scalars['uuid']['input']>;
  sc_equip_xref_downhole_ytool_equip_tubings_journal?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_Obj_Rel_Insert_Input>;
  sc_equip_xref_downhole_ytool_equip_tubings_journals?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_Arr_Rel_Insert_Input>;
  sc_equip_xref_downhole_ytool_equip_tubings_revisions?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Obj_Rel_Insert_Input>;
  sc_equip_xref_downhole_ytool_equip_tubings_view?: InputMaybe<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Obj_Rel_Insert_Input>;
  scenario_equipment_id?: InputMaybe<Scalars['uuid']['input']>;
  scenario_equipment_journal?: InputMaybe<Revisions_Scenario_Equipment_Journal_Obj_Rel_Insert_Input>;
  tubing?: InputMaybe<Tubings_Obj_Rel_Insert_Input>;
  tubing_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Max_Fields = {
  __typename: 'revisions_sc_equip_xref_downhole_ytool_equip_tubings_revisions_max_fields';
  author_id?: Maybe<Scalars['String']['output']>;
  cloned_from_journal_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  journal_id?: Maybe<Scalars['uuid']['output']>;
  length_feet?: Maybe<Scalars['numeric']['output']>;
  parent_revision_id?: Maybe<Scalars['uuid']['output']>;
  scenario_equipment_id?: Maybe<Scalars['uuid']['output']>;
  tubing_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "revisions.sc_equip_xref_downhole_ytool_equip_tubings_revisions" */
export type Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Max_Order_By = {
  author_id?: InputMaybe<Order_By>;
  cloned_from_journal_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  journal_id?: InputMaybe<Order_By>;
  length_feet?: InputMaybe<Order_By>;
  parent_revision_id?: InputMaybe<Order_By>;
  scenario_equipment_id?: InputMaybe<Order_By>;
  tubing_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Min_Fields = {
  __typename: 'revisions_sc_equip_xref_downhole_ytool_equip_tubings_revisions_min_fields';
  author_id?: Maybe<Scalars['String']['output']>;
  cloned_from_journal_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  journal_id?: Maybe<Scalars['uuid']['output']>;
  length_feet?: Maybe<Scalars['numeric']['output']>;
  parent_revision_id?: Maybe<Scalars['uuid']['output']>;
  scenario_equipment_id?: Maybe<Scalars['uuid']['output']>;
  tubing_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "revisions.sc_equip_xref_downhole_ytool_equip_tubings_revisions" */
export type Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Min_Order_By = {
  author_id?: InputMaybe<Order_By>;
  cloned_from_journal_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  journal_id?: InputMaybe<Order_By>;
  length_feet?: InputMaybe<Order_By>;
  parent_revision_id?: InputMaybe<Order_By>;
  scenario_equipment_id?: InputMaybe<Order_By>;
  tubing_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "revisions.sc_equip_xref_downhole_ytool_equip_tubings_revisions" */
export type Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Mutation_Response = {
  __typename: 'revisions_sc_equip_xref_downhole_ytool_equip_tubings_revisions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions>;
};

/** input type for inserting object relation for remote table "revisions.sc_equip_xref_downhole_ytool_equip_tubings_revisions" */
export type Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Obj_Rel_Insert_Input = {
  data: Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_On_Conflict>;
};

/** on_conflict condition type for table "revisions.sc_equip_xref_downhole_ytool_equip_tubings_revisions" */
export type Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_On_Conflict = {
  constraint: Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Constraint;
  update_columns?: Array<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Update_Column>;
  where?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Bool_Exp>;
};

/** Ordering options when selecting data from "revisions.sc_equip_xref_downhole_ytool_equip_tubings_revisions". */
export type Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Order_By = {
  author_id?: InputMaybe<Order_By>;
  cloned_from_journal_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  journal_id?: InputMaybe<Order_By>;
  length_feet?: InputMaybe<Order_By>;
  parent_revision_id?: InputMaybe<Order_By>;
  sc_equip_xref_downhole_ytool_equip_tubings_journal?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_Order_By>;
  sc_equip_xref_downhole_ytool_equip_tubings_journals_aggregate?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_Aggregate_Order_By>;
  sc_equip_xref_downhole_ytool_equip_tubings_revisions?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Order_By>;
  sc_equip_xref_downhole_ytool_equip_tubings_view?: InputMaybe<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Order_By>;
  scenario_equipment_id?: InputMaybe<Order_By>;
  scenario_equipment_journal?: InputMaybe<Revisions_Scenario_Equipment_Journal_Order_By>;
  tubing?: InputMaybe<Tubings_Order_By>;
  tubing_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
};

/** primary key columns input for table: revisions.sc_equip_xref_downhole_ytool_equip_tubings_revisions */
export type Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "revisions.sc_equip_xref_downhole_ytool_equip_tubings_revisions" */
export enum Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Select_Column {
  /** column name */
  AuthorId = 'author_id',
  /** column name */
  ClonedFromJournalId = 'cloned_from_journal_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  JournalId = 'journal_id',
  /** column name */
  LengthFeet = 'length_feet',
  /** column name */
  ParentRevisionId = 'parent_revision_id',
  /** column name */
  ScenarioEquipmentId = 'scenario_equipment_id',
  /** column name */
  TubingId = 'tubing_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "revisions.sc_equip_xref_downhole_ytool_equip_tubings_revisions" */
export type Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Set_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  cloned_from_journal_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  journal_id?: InputMaybe<Scalars['uuid']['input']>;
  length_feet?: InputMaybe<Scalars['numeric']['input']>;
  parent_revision_id?: InputMaybe<Scalars['uuid']['input']>;
  scenario_equipment_id?: InputMaybe<Scalars['uuid']['input']>;
  tubing_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Stddev_Fields = {
  __typename: 'revisions_sc_equip_xref_downhole_ytool_equip_tubings_revisions_stddev_fields';
  length_feet?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "revisions.sc_equip_xref_downhole_ytool_equip_tubings_revisions" */
export type Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Stddev_Order_By = {
  length_feet?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Stddev_Pop_Fields = {
  __typename: 'revisions_sc_equip_xref_downhole_ytool_equip_tubings_revisions_stddev_pop_fields';
  length_feet?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "revisions.sc_equip_xref_downhole_ytool_equip_tubings_revisions" */
export type Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Stddev_Pop_Order_By = {
  length_feet?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Stddev_Samp_Fields = {
  __typename: 'revisions_sc_equip_xref_downhole_ytool_equip_tubings_revisions_stddev_samp_fields';
  length_feet?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "revisions.sc_equip_xref_downhole_ytool_equip_tubings_revisions" */
export type Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Stddev_Samp_Order_By = {
  length_feet?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "revisions_sc_equip_xref_downhole_ytool_equip_tubings_revisions" */
export type Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Stream_Cursor_Value_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  cloned_from_journal_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  journal_id?: InputMaybe<Scalars['uuid']['input']>;
  length_feet?: InputMaybe<Scalars['numeric']['input']>;
  parent_revision_id?: InputMaybe<Scalars['uuid']['input']>;
  scenario_equipment_id?: InputMaybe<Scalars['uuid']['input']>;
  tubing_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Sum_Fields = {
  __typename: 'revisions_sc_equip_xref_downhole_ytool_equip_tubings_revisions_sum_fields';
  length_feet?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "revisions.sc_equip_xref_downhole_ytool_equip_tubings_revisions" */
export type Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Sum_Order_By = {
  length_feet?: InputMaybe<Order_By>;
};

/** update columns of table "revisions.sc_equip_xref_downhole_ytool_equip_tubings_revisions" */
export enum Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Update_Column {
  /** column name */
  AuthorId = 'author_id',
  /** column name */
  ClonedFromJournalId = 'cloned_from_journal_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  JournalId = 'journal_id',
  /** column name */
  LengthFeet = 'length_feet',
  /** column name */
  ParentRevisionId = 'parent_revision_id',
  /** column name */
  ScenarioEquipmentId = 'scenario_equipment_id',
  /** column name */
  TubingId = 'tubing_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Set_Input>;
  /** filter the rows which have to be updated */
  where: Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Var_Pop_Fields = {
  __typename: 'revisions_sc_equip_xref_downhole_ytool_equip_tubings_revisions_var_pop_fields';
  length_feet?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "revisions.sc_equip_xref_downhole_ytool_equip_tubings_revisions" */
export type Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Var_Pop_Order_By = {
  length_feet?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Var_Samp_Fields = {
  __typename: 'revisions_sc_equip_xref_downhole_ytool_equip_tubings_revisions_var_samp_fields';
  length_feet?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "revisions.sc_equip_xref_downhole_ytool_equip_tubings_revisions" */
export type Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Var_Samp_Order_By = {
  length_feet?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Variance_Fields = {
  __typename: 'revisions_sc_equip_xref_downhole_ytool_equip_tubings_revisions_variance_fields';
  length_feet?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "revisions.sc_equip_xref_downhole_ytool_equip_tubings_revisions" */
export type Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Variance_Order_By = {
  length_feet?: InputMaybe<Order_By>;
};

/** columns and relationships of "revisions.sc_equip_xref_uphole_ytool_bypass_tubings_journal" */
export type Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal = {
  __typename: 'revisions_sc_equip_xref_uphole_ytool_bypass_tubings_journal';
  author_id: Scalars['String']['output'];
  created_at: Scalars['timestamptz']['output'];
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  parent_journal_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  sc_equip_xref_uphole_ytool_bypass_tubings_journal?: Maybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal>;
  /** An array relationship */
  sc_equip_xref_uphole_ytool_bypass_tubings_journals: Array<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal>;
  /** An aggregate relationship */
  sc_equip_xref_uphole_ytool_bypass_tubings_journals_aggregate: Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_Aggregate;
  /** An object relationship */
  sc_equip_xref_uphole_ytool_bypass_tubings_revision?: Maybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions>;
  /** An array relationship */
  sc_equip_xref_uphole_ytool_bypass_tubings_revisions: Array<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions>;
  /** An aggregate relationship */
  sc_equip_xref_uphole_ytool_bypass_tubings_revisions_aggregate: Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Aggregate;
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Users;
  winning_revision_id?: Maybe<Scalars['uuid']['output']>;
};


/** columns and relationships of "revisions.sc_equip_xref_uphole_ytool_bypass_tubings_journal" */
export type Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_JournalSc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_JournalsArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_Order_By>>;
  where?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_Bool_Exp>;
};


/** columns and relationships of "revisions.sc_equip_xref_uphole_ytool_bypass_tubings_journal" */
export type Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_JournalSc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journals_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_Order_By>>;
  where?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_Bool_Exp>;
};


/** columns and relationships of "revisions.sc_equip_xref_uphole_ytool_bypass_tubings_journal" */
export type Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_JournalSc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_RevisionsArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Bool_Exp>;
};


/** columns and relationships of "revisions.sc_equip_xref_uphole_ytool_bypass_tubings_journal" */
export type Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_JournalSc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Bool_Exp>;
};

/** aggregated selection of "revisions.sc_equip_xref_uphole_ytool_bypass_tubings_journal" */
export type Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_Aggregate = {
  __typename: 'revisions_sc_equip_xref_uphole_ytool_bypass_tubings_journal_aggregate';
  aggregate?: Maybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_Aggregate_Fields>;
  nodes: Array<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal>;
};

export type Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_Aggregate_Bool_Exp = {
  count?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_Aggregate_Bool_Exp_Count>;
};

export type Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "revisions.sc_equip_xref_uphole_ytool_bypass_tubings_journal" */
export type Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_Aggregate_Fields = {
  __typename: 'revisions_sc_equip_xref_uphole_ytool_bypass_tubings_journal_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_Max_Fields>;
  min?: Maybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_Min_Fields>;
};


/** aggregate fields of "revisions.sc_equip_xref_uphole_ytool_bypass_tubings_journal" */
export type Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "revisions.sc_equip_xref_uphole_ytool_bypass_tubings_journal" */
export type Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_Max_Order_By>;
  min?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_Min_Order_By>;
};

/** input type for inserting array relation for remote table "revisions.sc_equip_xref_uphole_ytool_bypass_tubings_journal" */
export type Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_Arr_Rel_Insert_Input = {
  data: Array<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_On_Conflict>;
};

/** Boolean expression to filter rows from the table "revisions.sc_equip_xref_uphole_ytool_bypass_tubings_journal". All fields are combined with a logical 'AND'. */
export type Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_Bool_Exp = {
  _and?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_Bool_Exp>>;
  _not?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_Bool_Exp>;
  _or?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_Bool_Exp>>;
  author_id?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  parent_journal_id?: InputMaybe<Uuid_Comparison_Exp>;
  sc_equip_xref_uphole_ytool_bypass_tubings_journal?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_Bool_Exp>;
  sc_equip_xref_uphole_ytool_bypass_tubings_journals?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_Bool_Exp>;
  sc_equip_xref_uphole_ytool_bypass_tubings_journals_aggregate?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_Aggregate_Bool_Exp>;
  sc_equip_xref_uphole_ytool_bypass_tubings_revision?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Bool_Exp>;
  sc_equip_xref_uphole_ytool_bypass_tubings_revisions?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Bool_Exp>;
  sc_equip_xref_uphole_ytool_bypass_tubings_revisions_aggregate?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Aggregate_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  winning_revision_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "revisions.sc_equip_xref_uphole_ytool_bypass_tubings_journal" */
export enum Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_Constraint {
  /** unique or primary key constraint on columns "id" */
  ScEquipXrefUpholeYtoolBypassTubingsJournalPkey = 'sc_equip_xref_uphole_ytool_bypass_tubings_journal_pkey'
}

/** input type for inserting data into table "revisions.sc_equip_xref_uphole_ytool_bypass_tubings_journal" */
export type Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_Insert_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  parent_journal_id?: InputMaybe<Scalars['uuid']['input']>;
  sc_equip_xref_uphole_ytool_bypass_tubings_journal?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_Obj_Rel_Insert_Input>;
  sc_equip_xref_uphole_ytool_bypass_tubings_journals?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_Arr_Rel_Insert_Input>;
  sc_equip_xref_uphole_ytool_bypass_tubings_revision?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Obj_Rel_Insert_Input>;
  sc_equip_xref_uphole_ytool_bypass_tubings_revisions?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Arr_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  winning_revision_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_Max_Fields = {
  __typename: 'revisions_sc_equip_xref_uphole_ytool_bypass_tubings_journal_max_fields';
  author_id?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  parent_journal_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  winning_revision_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "revisions.sc_equip_xref_uphole_ytool_bypass_tubings_journal" */
export type Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_Max_Order_By = {
  author_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parent_journal_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  winning_revision_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_Min_Fields = {
  __typename: 'revisions_sc_equip_xref_uphole_ytool_bypass_tubings_journal_min_fields';
  author_id?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  parent_journal_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  winning_revision_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "revisions.sc_equip_xref_uphole_ytool_bypass_tubings_journal" */
export type Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_Min_Order_By = {
  author_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parent_journal_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  winning_revision_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "revisions.sc_equip_xref_uphole_ytool_bypass_tubings_journal" */
export type Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_Mutation_Response = {
  __typename: 'revisions_sc_equip_xref_uphole_ytool_bypass_tubings_journal_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal>;
};

/** input type for inserting object relation for remote table "revisions.sc_equip_xref_uphole_ytool_bypass_tubings_journal" */
export type Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_Obj_Rel_Insert_Input = {
  data: Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_On_Conflict>;
};

/** on_conflict condition type for table "revisions.sc_equip_xref_uphole_ytool_bypass_tubings_journal" */
export type Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_On_Conflict = {
  constraint: Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_Constraint;
  update_columns?: Array<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_Update_Column>;
  where?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_Bool_Exp>;
};

/** Ordering options when selecting data from "revisions.sc_equip_xref_uphole_ytool_bypass_tubings_journal". */
export type Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_Order_By = {
  author_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parent_journal_id?: InputMaybe<Order_By>;
  sc_equip_xref_uphole_ytool_bypass_tubings_journal?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_Order_By>;
  sc_equip_xref_uphole_ytool_bypass_tubings_journals_aggregate?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_Aggregate_Order_By>;
  sc_equip_xref_uphole_ytool_bypass_tubings_revision?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Order_By>;
  sc_equip_xref_uphole_ytool_bypass_tubings_revisions_aggregate?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  winning_revision_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: revisions.sc_equip_xref_uphole_ytool_bypass_tubings_journal */
export type Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "revisions.sc_equip_xref_uphole_ytool_bypass_tubings_journal" */
export enum Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_Select_Column {
  /** column name */
  AuthorId = 'author_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  ParentJournalId = 'parent_journal_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WinningRevisionId = 'winning_revision_id'
}

/** input type for updating data in table "revisions.sc_equip_xref_uphole_ytool_bypass_tubings_journal" */
export type Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_Set_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  parent_journal_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  winning_revision_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "revisions_sc_equip_xref_uphole_ytool_bypass_tubings_journal" */
export type Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_Stream_Cursor_Value_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  parent_journal_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  winning_revision_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "revisions.sc_equip_xref_uphole_ytool_bypass_tubings_journal" */
export enum Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_Update_Column {
  /** column name */
  AuthorId = 'author_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  ParentJournalId = 'parent_journal_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WinningRevisionId = 'winning_revision_id'
}

export type Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_Set_Input>;
  /** filter the rows which have to be updated */
  where: Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_Bool_Exp;
};

/** columns and relationships of "revisions.sc_equip_xref_uphole_ytool_bypass_tubings_revisions" */
export type Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions = {
  __typename: 'revisions_sc_equip_xref_uphole_ytool_bypass_tubings_revisions';
  author_id: Scalars['String']['output'];
  cloned_from_journal_id?: Maybe<Scalars['uuid']['output']>;
  created_at: Scalars['timestamptz']['output'];
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  journal_id: Scalars['uuid']['output'];
  length_feet?: Maybe<Scalars['numeric']['output']>;
  parent_revision_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  sc_equip_xref_uphole_ytool_bypass_tubings_journal: Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal;
  /** An array relationship */
  sc_equip_xref_uphole_ytool_bypass_tubings_journals: Array<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal>;
  /** An aggregate relationship */
  sc_equip_xref_uphole_ytool_bypass_tubings_journals_aggregate: Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_Aggregate;
  /** An object relationship */
  sc_equip_xref_uphole_ytool_bypass_tubings_revision?: Maybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions>;
  /** An array relationship */
  sc_equip_xref_uphole_ytool_bypass_tubings_revisions: Array<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions>;
  /** An aggregate relationship */
  sc_equip_xref_uphole_ytool_bypass_tubings_revisions_aggregate: Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Aggregate;
  /** An object relationship */
  sc_equip_xref_uphole_ytool_bypass_tubings_view?: Maybe<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings>;
  scenario_equipment_id: Scalars['uuid']['output'];
  /** An object relationship */
  scenario_equipment_journal: Revisions_Scenario_Equipment_Journal;
  /** An object relationship */
  tubing: Tubings;
  tubing_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Users;
};


/** columns and relationships of "revisions.sc_equip_xref_uphole_ytool_bypass_tubings_revisions" */
export type Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_RevisionsSc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_JournalsArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_Order_By>>;
  where?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_Bool_Exp>;
};


/** columns and relationships of "revisions.sc_equip_xref_uphole_ytool_bypass_tubings_revisions" */
export type Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_RevisionsSc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journals_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_Order_By>>;
  where?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_Bool_Exp>;
};


/** columns and relationships of "revisions.sc_equip_xref_uphole_ytool_bypass_tubings_revisions" */
export type Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_RevisionsSc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_RevisionsArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Bool_Exp>;
};


/** columns and relationships of "revisions.sc_equip_xref_uphole_ytool_bypass_tubings_revisions" */
export type Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_RevisionsSc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Bool_Exp>;
};

/** aggregated selection of "revisions.sc_equip_xref_uphole_ytool_bypass_tubings_revisions" */
export type Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Aggregate = {
  __typename: 'revisions_sc_equip_xref_uphole_ytool_bypass_tubings_revisions_aggregate';
  aggregate?: Maybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Aggregate_Fields>;
  nodes: Array<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions>;
};

export type Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Aggregate_Bool_Exp = {
  count?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Aggregate_Bool_Exp_Count>;
};

export type Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "revisions.sc_equip_xref_uphole_ytool_bypass_tubings_revisions" */
export type Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Aggregate_Fields = {
  __typename: 'revisions_sc_equip_xref_uphole_ytool_bypass_tubings_revisions_aggregate_fields';
  avg?: Maybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Max_Fields>;
  min?: Maybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Min_Fields>;
  stddev?: Maybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Stddev_Fields>;
  stddev_pop?: Maybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Stddev_Samp_Fields>;
  sum?: Maybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Sum_Fields>;
  var_pop?: Maybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Var_Pop_Fields>;
  var_samp?: Maybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Var_Samp_Fields>;
  variance?: Maybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Variance_Fields>;
};


/** aggregate fields of "revisions.sc_equip_xref_uphole_ytool_bypass_tubings_revisions" */
export type Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "revisions.sc_equip_xref_uphole_ytool_bypass_tubings_revisions" */
export type Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Aggregate_Order_By = {
  avg?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Max_Order_By>;
  min?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Min_Order_By>;
  stddev?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Sum_Order_By>;
  var_pop?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Var_Samp_Order_By>;
  variance?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "revisions.sc_equip_xref_uphole_ytool_bypass_tubings_revisions" */
export type Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Arr_Rel_Insert_Input = {
  data: Array<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_On_Conflict>;
};

/** aggregate avg on columns */
export type Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Avg_Fields = {
  __typename: 'revisions_sc_equip_xref_uphole_ytool_bypass_tubings_revisions_avg_fields';
  length_feet?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "revisions.sc_equip_xref_uphole_ytool_bypass_tubings_revisions" */
export type Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Avg_Order_By = {
  length_feet?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "revisions.sc_equip_xref_uphole_ytool_bypass_tubings_revisions". All fields are combined with a logical 'AND'. */
export type Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Bool_Exp = {
  _and?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Bool_Exp>>;
  _not?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Bool_Exp>;
  _or?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Bool_Exp>>;
  author_id?: InputMaybe<String_Comparison_Exp>;
  cloned_from_journal_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  journal_id?: InputMaybe<Uuid_Comparison_Exp>;
  length_feet?: InputMaybe<Numeric_Comparison_Exp>;
  parent_revision_id?: InputMaybe<Uuid_Comparison_Exp>;
  sc_equip_xref_uphole_ytool_bypass_tubings_journal?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_Bool_Exp>;
  sc_equip_xref_uphole_ytool_bypass_tubings_journals?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_Bool_Exp>;
  sc_equip_xref_uphole_ytool_bypass_tubings_journals_aggregate?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_Aggregate_Bool_Exp>;
  sc_equip_xref_uphole_ytool_bypass_tubings_revision?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Bool_Exp>;
  sc_equip_xref_uphole_ytool_bypass_tubings_revisions?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Bool_Exp>;
  sc_equip_xref_uphole_ytool_bypass_tubings_revisions_aggregate?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Aggregate_Bool_Exp>;
  sc_equip_xref_uphole_ytool_bypass_tubings_view?: InputMaybe<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Bool_Exp>;
  scenario_equipment_id?: InputMaybe<Uuid_Comparison_Exp>;
  scenario_equipment_journal?: InputMaybe<Revisions_Scenario_Equipment_Journal_Bool_Exp>;
  tubing?: InputMaybe<Tubings_Bool_Exp>;
  tubing_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
};

/** unique or primary key constraints on table "revisions.sc_equip_xref_uphole_ytool_bypass_tubings_revisions" */
export enum Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Constraint {
  /** unique or primary key constraint on columns "id" */
  ScEquipXrefUpholeYtoolBypassTubingsRevisionsPkey = 'sc_equip_xref_uphole_ytool_bypass_tubings_revisions_pkey'
}

/** input type for incrementing numeric columns in table "revisions.sc_equip_xref_uphole_ytool_bypass_tubings_revisions" */
export type Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Inc_Input = {
  length_feet?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "revisions.sc_equip_xref_uphole_ytool_bypass_tubings_revisions" */
export type Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Insert_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  cloned_from_journal_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  journal_id?: InputMaybe<Scalars['uuid']['input']>;
  length_feet?: InputMaybe<Scalars['numeric']['input']>;
  parent_revision_id?: InputMaybe<Scalars['uuid']['input']>;
  sc_equip_xref_uphole_ytool_bypass_tubings_journal?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_Obj_Rel_Insert_Input>;
  sc_equip_xref_uphole_ytool_bypass_tubings_journals?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_Arr_Rel_Insert_Input>;
  sc_equip_xref_uphole_ytool_bypass_tubings_revision?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Obj_Rel_Insert_Input>;
  sc_equip_xref_uphole_ytool_bypass_tubings_revisions?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Arr_Rel_Insert_Input>;
  sc_equip_xref_uphole_ytool_bypass_tubings_view?: InputMaybe<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Obj_Rel_Insert_Input>;
  scenario_equipment_id?: InputMaybe<Scalars['uuid']['input']>;
  scenario_equipment_journal?: InputMaybe<Revisions_Scenario_Equipment_Journal_Obj_Rel_Insert_Input>;
  tubing?: InputMaybe<Tubings_Obj_Rel_Insert_Input>;
  tubing_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Max_Fields = {
  __typename: 'revisions_sc_equip_xref_uphole_ytool_bypass_tubings_revisions_max_fields';
  author_id?: Maybe<Scalars['String']['output']>;
  cloned_from_journal_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  journal_id?: Maybe<Scalars['uuid']['output']>;
  length_feet?: Maybe<Scalars['numeric']['output']>;
  parent_revision_id?: Maybe<Scalars['uuid']['output']>;
  scenario_equipment_id?: Maybe<Scalars['uuid']['output']>;
  tubing_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "revisions.sc_equip_xref_uphole_ytool_bypass_tubings_revisions" */
export type Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Max_Order_By = {
  author_id?: InputMaybe<Order_By>;
  cloned_from_journal_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  journal_id?: InputMaybe<Order_By>;
  length_feet?: InputMaybe<Order_By>;
  parent_revision_id?: InputMaybe<Order_By>;
  scenario_equipment_id?: InputMaybe<Order_By>;
  tubing_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Min_Fields = {
  __typename: 'revisions_sc_equip_xref_uphole_ytool_bypass_tubings_revisions_min_fields';
  author_id?: Maybe<Scalars['String']['output']>;
  cloned_from_journal_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  journal_id?: Maybe<Scalars['uuid']['output']>;
  length_feet?: Maybe<Scalars['numeric']['output']>;
  parent_revision_id?: Maybe<Scalars['uuid']['output']>;
  scenario_equipment_id?: Maybe<Scalars['uuid']['output']>;
  tubing_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "revisions.sc_equip_xref_uphole_ytool_bypass_tubings_revisions" */
export type Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Min_Order_By = {
  author_id?: InputMaybe<Order_By>;
  cloned_from_journal_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  journal_id?: InputMaybe<Order_By>;
  length_feet?: InputMaybe<Order_By>;
  parent_revision_id?: InputMaybe<Order_By>;
  scenario_equipment_id?: InputMaybe<Order_By>;
  tubing_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "revisions.sc_equip_xref_uphole_ytool_bypass_tubings_revisions" */
export type Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Mutation_Response = {
  __typename: 'revisions_sc_equip_xref_uphole_ytool_bypass_tubings_revisions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions>;
};

/** input type for inserting object relation for remote table "revisions.sc_equip_xref_uphole_ytool_bypass_tubings_revisions" */
export type Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Obj_Rel_Insert_Input = {
  data: Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_On_Conflict>;
};

/** on_conflict condition type for table "revisions.sc_equip_xref_uphole_ytool_bypass_tubings_revisions" */
export type Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_On_Conflict = {
  constraint: Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Constraint;
  update_columns?: Array<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Update_Column>;
  where?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Bool_Exp>;
};

/** Ordering options when selecting data from "revisions.sc_equip_xref_uphole_ytool_bypass_tubings_revisions". */
export type Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Order_By = {
  author_id?: InputMaybe<Order_By>;
  cloned_from_journal_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  journal_id?: InputMaybe<Order_By>;
  length_feet?: InputMaybe<Order_By>;
  parent_revision_id?: InputMaybe<Order_By>;
  sc_equip_xref_uphole_ytool_bypass_tubings_journal?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_Order_By>;
  sc_equip_xref_uphole_ytool_bypass_tubings_journals_aggregate?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_Aggregate_Order_By>;
  sc_equip_xref_uphole_ytool_bypass_tubings_revision?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Order_By>;
  sc_equip_xref_uphole_ytool_bypass_tubings_revisions_aggregate?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Aggregate_Order_By>;
  sc_equip_xref_uphole_ytool_bypass_tubings_view?: InputMaybe<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Order_By>;
  scenario_equipment_id?: InputMaybe<Order_By>;
  scenario_equipment_journal?: InputMaybe<Revisions_Scenario_Equipment_Journal_Order_By>;
  tubing?: InputMaybe<Tubings_Order_By>;
  tubing_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
};

/** primary key columns input for table: revisions.sc_equip_xref_uphole_ytool_bypass_tubings_revisions */
export type Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "revisions.sc_equip_xref_uphole_ytool_bypass_tubings_revisions" */
export enum Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Select_Column {
  /** column name */
  AuthorId = 'author_id',
  /** column name */
  ClonedFromJournalId = 'cloned_from_journal_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  JournalId = 'journal_id',
  /** column name */
  LengthFeet = 'length_feet',
  /** column name */
  ParentRevisionId = 'parent_revision_id',
  /** column name */
  ScenarioEquipmentId = 'scenario_equipment_id',
  /** column name */
  TubingId = 'tubing_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "revisions.sc_equip_xref_uphole_ytool_bypass_tubings_revisions" */
export type Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Set_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  cloned_from_journal_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  journal_id?: InputMaybe<Scalars['uuid']['input']>;
  length_feet?: InputMaybe<Scalars['numeric']['input']>;
  parent_revision_id?: InputMaybe<Scalars['uuid']['input']>;
  scenario_equipment_id?: InputMaybe<Scalars['uuid']['input']>;
  tubing_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Stddev_Fields = {
  __typename: 'revisions_sc_equip_xref_uphole_ytool_bypass_tubings_revisions_stddev_fields';
  length_feet?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "revisions.sc_equip_xref_uphole_ytool_bypass_tubings_revisions" */
export type Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Stddev_Order_By = {
  length_feet?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Stddev_Pop_Fields = {
  __typename: 'revisions_sc_equip_xref_uphole_ytool_bypass_tubings_revisions_stddev_pop_fields';
  length_feet?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "revisions.sc_equip_xref_uphole_ytool_bypass_tubings_revisions" */
export type Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Stddev_Pop_Order_By = {
  length_feet?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Stddev_Samp_Fields = {
  __typename: 'revisions_sc_equip_xref_uphole_ytool_bypass_tubings_revisions_stddev_samp_fields';
  length_feet?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "revisions.sc_equip_xref_uphole_ytool_bypass_tubings_revisions" */
export type Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Stddev_Samp_Order_By = {
  length_feet?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "revisions_sc_equip_xref_uphole_ytool_bypass_tubings_revisions" */
export type Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Stream_Cursor_Value_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  cloned_from_journal_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  journal_id?: InputMaybe<Scalars['uuid']['input']>;
  length_feet?: InputMaybe<Scalars['numeric']['input']>;
  parent_revision_id?: InputMaybe<Scalars['uuid']['input']>;
  scenario_equipment_id?: InputMaybe<Scalars['uuid']['input']>;
  tubing_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Sum_Fields = {
  __typename: 'revisions_sc_equip_xref_uphole_ytool_bypass_tubings_revisions_sum_fields';
  length_feet?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "revisions.sc_equip_xref_uphole_ytool_bypass_tubings_revisions" */
export type Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Sum_Order_By = {
  length_feet?: InputMaybe<Order_By>;
};

/** update columns of table "revisions.sc_equip_xref_uphole_ytool_bypass_tubings_revisions" */
export enum Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Update_Column {
  /** column name */
  AuthorId = 'author_id',
  /** column name */
  ClonedFromJournalId = 'cloned_from_journal_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  JournalId = 'journal_id',
  /** column name */
  LengthFeet = 'length_feet',
  /** column name */
  ParentRevisionId = 'parent_revision_id',
  /** column name */
  ScenarioEquipmentId = 'scenario_equipment_id',
  /** column name */
  TubingId = 'tubing_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Set_Input>;
  /** filter the rows which have to be updated */
  where: Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Var_Pop_Fields = {
  __typename: 'revisions_sc_equip_xref_uphole_ytool_bypass_tubings_revisions_var_pop_fields';
  length_feet?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "revisions.sc_equip_xref_uphole_ytool_bypass_tubings_revisions" */
export type Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Var_Pop_Order_By = {
  length_feet?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Var_Samp_Fields = {
  __typename: 'revisions_sc_equip_xref_uphole_ytool_bypass_tubings_revisions_var_samp_fields';
  length_feet?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "revisions.sc_equip_xref_uphole_ytool_bypass_tubings_revisions" */
export type Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Var_Samp_Order_By = {
  length_feet?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Variance_Fields = {
  __typename: 'revisions_sc_equip_xref_uphole_ytool_bypass_tubings_revisions_variance_fields';
  length_feet?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "revisions.sc_equip_xref_uphole_ytool_bypass_tubings_revisions" */
export type Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Variance_Order_By = {
  length_feet?: InputMaybe<Order_By>;
};

/** columns and relationships of "revisions.sc_equip_xref_uphole_ytool_equip_tubings_journal" */
export type Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal = {
  __typename: 'revisions_sc_equip_xref_uphole_ytool_equip_tubings_journal';
  author_id: Scalars['String']['output'];
  created_at: Scalars['timestamptz']['output'];
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  parent_journal_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  sc_equip_xref_uphole_ytool_equip_tubings_journal?: Maybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal>;
  /** An array relationship */
  sc_equip_xref_uphole_ytool_equip_tubings_journals: Array<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal>;
  /** An aggregate relationship */
  sc_equip_xref_uphole_ytool_equip_tubings_journals_aggregate: Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_Aggregate;
  /** An object relationship */
  sc_equip_xref_uphole_ytool_equip_tubings_revisions?: Maybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions>;
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Users;
  winning_revision_id?: Maybe<Scalars['uuid']['output']>;
};


/** columns and relationships of "revisions.sc_equip_xref_uphole_ytool_equip_tubings_journal" */
export type Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_JournalSc_Equip_Xref_Uphole_Ytool_Equip_Tubings_JournalsArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_Order_By>>;
  where?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_Bool_Exp>;
};


/** columns and relationships of "revisions.sc_equip_xref_uphole_ytool_equip_tubings_journal" */
export type Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_JournalSc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journals_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_Order_By>>;
  where?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_Bool_Exp>;
};

/** aggregated selection of "revisions.sc_equip_xref_uphole_ytool_equip_tubings_journal" */
export type Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_Aggregate = {
  __typename: 'revisions_sc_equip_xref_uphole_ytool_equip_tubings_journal_aggregate';
  aggregate?: Maybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_Aggregate_Fields>;
  nodes: Array<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal>;
};

export type Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_Aggregate_Bool_Exp = {
  count?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_Aggregate_Bool_Exp_Count>;
};

export type Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "revisions.sc_equip_xref_uphole_ytool_equip_tubings_journal" */
export type Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_Aggregate_Fields = {
  __typename: 'revisions_sc_equip_xref_uphole_ytool_equip_tubings_journal_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_Max_Fields>;
  min?: Maybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_Min_Fields>;
};


/** aggregate fields of "revisions.sc_equip_xref_uphole_ytool_equip_tubings_journal" */
export type Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "revisions.sc_equip_xref_uphole_ytool_equip_tubings_journal" */
export type Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_Max_Order_By>;
  min?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_Min_Order_By>;
};

/** input type for inserting array relation for remote table "revisions.sc_equip_xref_uphole_ytool_equip_tubings_journal" */
export type Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_Arr_Rel_Insert_Input = {
  data: Array<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_On_Conflict>;
};

/** Boolean expression to filter rows from the table "revisions.sc_equip_xref_uphole_ytool_equip_tubings_journal". All fields are combined with a logical 'AND'. */
export type Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_Bool_Exp = {
  _and?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_Bool_Exp>>;
  _not?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_Bool_Exp>;
  _or?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_Bool_Exp>>;
  author_id?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  parent_journal_id?: InputMaybe<Uuid_Comparison_Exp>;
  sc_equip_xref_uphole_ytool_equip_tubings_journal?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_Bool_Exp>;
  sc_equip_xref_uphole_ytool_equip_tubings_journals?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_Bool_Exp>;
  sc_equip_xref_uphole_ytool_equip_tubings_journals_aggregate?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_Aggregate_Bool_Exp>;
  sc_equip_xref_uphole_ytool_equip_tubings_revisions?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  winning_revision_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "revisions.sc_equip_xref_uphole_ytool_equip_tubings_journal" */
export enum Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_Constraint {
  /** unique or primary key constraint on columns "id" */
  ScEquipXrefUpholeYtoolEquipTubingsJournalPkey = 'sc_equip_xref_uphole_ytool_equip_tubings_journal_pkey'
}

/** input type for inserting data into table "revisions.sc_equip_xref_uphole_ytool_equip_tubings_journal" */
export type Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_Insert_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  parent_journal_id?: InputMaybe<Scalars['uuid']['input']>;
  sc_equip_xref_uphole_ytool_equip_tubings_journal?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_Obj_Rel_Insert_Input>;
  sc_equip_xref_uphole_ytool_equip_tubings_journals?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_Arr_Rel_Insert_Input>;
  sc_equip_xref_uphole_ytool_equip_tubings_revisions?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Obj_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  winning_revision_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_Max_Fields = {
  __typename: 'revisions_sc_equip_xref_uphole_ytool_equip_tubings_journal_max_fields';
  author_id?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  parent_journal_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  winning_revision_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "revisions.sc_equip_xref_uphole_ytool_equip_tubings_journal" */
export type Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_Max_Order_By = {
  author_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parent_journal_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  winning_revision_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_Min_Fields = {
  __typename: 'revisions_sc_equip_xref_uphole_ytool_equip_tubings_journal_min_fields';
  author_id?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  parent_journal_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  winning_revision_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "revisions.sc_equip_xref_uphole_ytool_equip_tubings_journal" */
export type Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_Min_Order_By = {
  author_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parent_journal_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  winning_revision_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "revisions.sc_equip_xref_uphole_ytool_equip_tubings_journal" */
export type Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_Mutation_Response = {
  __typename: 'revisions_sc_equip_xref_uphole_ytool_equip_tubings_journal_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal>;
};

/** input type for inserting object relation for remote table "revisions.sc_equip_xref_uphole_ytool_equip_tubings_journal" */
export type Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_Obj_Rel_Insert_Input = {
  data: Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_On_Conflict>;
};

/** on_conflict condition type for table "revisions.sc_equip_xref_uphole_ytool_equip_tubings_journal" */
export type Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_On_Conflict = {
  constraint: Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_Constraint;
  update_columns?: Array<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_Update_Column>;
  where?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_Bool_Exp>;
};

/** Ordering options when selecting data from "revisions.sc_equip_xref_uphole_ytool_equip_tubings_journal". */
export type Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_Order_By = {
  author_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parent_journal_id?: InputMaybe<Order_By>;
  sc_equip_xref_uphole_ytool_equip_tubings_journal?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_Order_By>;
  sc_equip_xref_uphole_ytool_equip_tubings_journals_aggregate?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_Aggregate_Order_By>;
  sc_equip_xref_uphole_ytool_equip_tubings_revisions?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  winning_revision_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: revisions.sc_equip_xref_uphole_ytool_equip_tubings_journal */
export type Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "revisions.sc_equip_xref_uphole_ytool_equip_tubings_journal" */
export enum Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_Select_Column {
  /** column name */
  AuthorId = 'author_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  ParentJournalId = 'parent_journal_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WinningRevisionId = 'winning_revision_id'
}

/** input type for updating data in table "revisions.sc_equip_xref_uphole_ytool_equip_tubings_journal" */
export type Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_Set_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  parent_journal_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  winning_revision_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "revisions_sc_equip_xref_uphole_ytool_equip_tubings_journal" */
export type Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_Stream_Cursor_Value_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  parent_journal_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  winning_revision_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "revisions.sc_equip_xref_uphole_ytool_equip_tubings_journal" */
export enum Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_Update_Column {
  /** column name */
  AuthorId = 'author_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  ParentJournalId = 'parent_journal_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WinningRevisionId = 'winning_revision_id'
}

export type Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_Set_Input>;
  /** filter the rows which have to be updated */
  where: Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_Bool_Exp;
};

/** columns and relationships of "revisions.sc_equip_xref_uphole_ytool_equip_tubings_revisions" */
export type Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions = {
  __typename: 'revisions_sc_equip_xref_uphole_ytool_equip_tubings_revisions';
  author_id: Scalars['String']['output'];
  cloned_from_journal_id?: Maybe<Scalars['uuid']['output']>;
  created_at: Scalars['timestamptz']['output'];
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  journal_id: Scalars['uuid']['output'];
  length_feet?: Maybe<Scalars['numeric']['output']>;
  parent_revision_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  sc_equip_xref_uphole_ytool_equip_tubings_journal: Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal;
  /** An array relationship */
  sc_equip_xref_uphole_ytool_equip_tubings_journals: Array<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal>;
  /** An aggregate relationship */
  sc_equip_xref_uphole_ytool_equip_tubings_journals_aggregate: Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_Aggregate;
  /** An object relationship */
  sc_equip_xref_uphole_ytool_equip_tubings_revisions?: Maybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions>;
  /** An object relationship */
  sc_equip_xref_uphole_ytool_equip_tubings_view?: Maybe<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings>;
  scenario_equipment_id: Scalars['uuid']['output'];
  /** An object relationship */
  scenario_equipment_journal: Revisions_Scenario_Equipment_Journal;
  /** An object relationship */
  tubing: Tubings;
  tubing_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Users;
};


/** columns and relationships of "revisions.sc_equip_xref_uphole_ytool_equip_tubings_revisions" */
export type Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_RevisionsSc_Equip_Xref_Uphole_Ytool_Equip_Tubings_JournalsArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_Order_By>>;
  where?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_Bool_Exp>;
};


/** columns and relationships of "revisions.sc_equip_xref_uphole_ytool_equip_tubings_revisions" */
export type Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_RevisionsSc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journals_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_Order_By>>;
  where?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_Bool_Exp>;
};

/** aggregated selection of "revisions.sc_equip_xref_uphole_ytool_equip_tubings_revisions" */
export type Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Aggregate = {
  __typename: 'revisions_sc_equip_xref_uphole_ytool_equip_tubings_revisions_aggregate';
  aggregate?: Maybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Aggregate_Fields>;
  nodes: Array<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions>;
};

export type Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Aggregate_Bool_Exp = {
  count?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Aggregate_Bool_Exp_Count>;
};

export type Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "revisions.sc_equip_xref_uphole_ytool_equip_tubings_revisions" */
export type Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Aggregate_Fields = {
  __typename: 'revisions_sc_equip_xref_uphole_ytool_equip_tubings_revisions_aggregate_fields';
  avg?: Maybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Max_Fields>;
  min?: Maybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Min_Fields>;
  stddev?: Maybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Stddev_Fields>;
  stddev_pop?: Maybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Stddev_Samp_Fields>;
  sum?: Maybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Sum_Fields>;
  var_pop?: Maybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Var_Pop_Fields>;
  var_samp?: Maybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Var_Samp_Fields>;
  variance?: Maybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Variance_Fields>;
};


/** aggregate fields of "revisions.sc_equip_xref_uphole_ytool_equip_tubings_revisions" */
export type Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "revisions.sc_equip_xref_uphole_ytool_equip_tubings_revisions" */
export type Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Aggregate_Order_By = {
  avg?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Max_Order_By>;
  min?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Min_Order_By>;
  stddev?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Sum_Order_By>;
  var_pop?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Var_Samp_Order_By>;
  variance?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "revisions.sc_equip_xref_uphole_ytool_equip_tubings_revisions" */
export type Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Arr_Rel_Insert_Input = {
  data: Array<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_On_Conflict>;
};

/** aggregate avg on columns */
export type Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Avg_Fields = {
  __typename: 'revisions_sc_equip_xref_uphole_ytool_equip_tubings_revisions_avg_fields';
  length_feet?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "revisions.sc_equip_xref_uphole_ytool_equip_tubings_revisions" */
export type Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Avg_Order_By = {
  length_feet?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "revisions.sc_equip_xref_uphole_ytool_equip_tubings_revisions". All fields are combined with a logical 'AND'. */
export type Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Bool_Exp = {
  _and?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Bool_Exp>>;
  _not?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Bool_Exp>;
  _or?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Bool_Exp>>;
  author_id?: InputMaybe<String_Comparison_Exp>;
  cloned_from_journal_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  journal_id?: InputMaybe<Uuid_Comparison_Exp>;
  length_feet?: InputMaybe<Numeric_Comparison_Exp>;
  parent_revision_id?: InputMaybe<Uuid_Comparison_Exp>;
  sc_equip_xref_uphole_ytool_equip_tubings_journal?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_Bool_Exp>;
  sc_equip_xref_uphole_ytool_equip_tubings_journals?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_Bool_Exp>;
  sc_equip_xref_uphole_ytool_equip_tubings_journals_aggregate?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_Aggregate_Bool_Exp>;
  sc_equip_xref_uphole_ytool_equip_tubings_revisions?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Bool_Exp>;
  sc_equip_xref_uphole_ytool_equip_tubings_view?: InputMaybe<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Bool_Exp>;
  scenario_equipment_id?: InputMaybe<Uuid_Comparison_Exp>;
  scenario_equipment_journal?: InputMaybe<Revisions_Scenario_Equipment_Journal_Bool_Exp>;
  tubing?: InputMaybe<Tubings_Bool_Exp>;
  tubing_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
};

/** unique or primary key constraints on table "revisions.sc_equip_xref_uphole_ytool_equip_tubings_revisions" */
export enum Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Constraint {
  /** unique or primary key constraint on columns "id" */
  ScEquipXrefUpholeYtoolEquipTubingsRevisionsPkey = 'sc_equip_xref_uphole_ytool_equip_tubings_revisions_pkey'
}

/** input type for incrementing numeric columns in table "revisions.sc_equip_xref_uphole_ytool_equip_tubings_revisions" */
export type Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Inc_Input = {
  length_feet?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "revisions.sc_equip_xref_uphole_ytool_equip_tubings_revisions" */
export type Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Insert_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  cloned_from_journal_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  journal_id?: InputMaybe<Scalars['uuid']['input']>;
  length_feet?: InputMaybe<Scalars['numeric']['input']>;
  parent_revision_id?: InputMaybe<Scalars['uuid']['input']>;
  sc_equip_xref_uphole_ytool_equip_tubings_journal?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_Obj_Rel_Insert_Input>;
  sc_equip_xref_uphole_ytool_equip_tubings_journals?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_Arr_Rel_Insert_Input>;
  sc_equip_xref_uphole_ytool_equip_tubings_revisions?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Obj_Rel_Insert_Input>;
  sc_equip_xref_uphole_ytool_equip_tubings_view?: InputMaybe<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Obj_Rel_Insert_Input>;
  scenario_equipment_id?: InputMaybe<Scalars['uuid']['input']>;
  scenario_equipment_journal?: InputMaybe<Revisions_Scenario_Equipment_Journal_Obj_Rel_Insert_Input>;
  tubing?: InputMaybe<Tubings_Obj_Rel_Insert_Input>;
  tubing_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Max_Fields = {
  __typename: 'revisions_sc_equip_xref_uphole_ytool_equip_tubings_revisions_max_fields';
  author_id?: Maybe<Scalars['String']['output']>;
  cloned_from_journal_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  journal_id?: Maybe<Scalars['uuid']['output']>;
  length_feet?: Maybe<Scalars['numeric']['output']>;
  parent_revision_id?: Maybe<Scalars['uuid']['output']>;
  scenario_equipment_id?: Maybe<Scalars['uuid']['output']>;
  tubing_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "revisions.sc_equip_xref_uphole_ytool_equip_tubings_revisions" */
export type Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Max_Order_By = {
  author_id?: InputMaybe<Order_By>;
  cloned_from_journal_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  journal_id?: InputMaybe<Order_By>;
  length_feet?: InputMaybe<Order_By>;
  parent_revision_id?: InputMaybe<Order_By>;
  scenario_equipment_id?: InputMaybe<Order_By>;
  tubing_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Min_Fields = {
  __typename: 'revisions_sc_equip_xref_uphole_ytool_equip_tubings_revisions_min_fields';
  author_id?: Maybe<Scalars['String']['output']>;
  cloned_from_journal_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  journal_id?: Maybe<Scalars['uuid']['output']>;
  length_feet?: Maybe<Scalars['numeric']['output']>;
  parent_revision_id?: Maybe<Scalars['uuid']['output']>;
  scenario_equipment_id?: Maybe<Scalars['uuid']['output']>;
  tubing_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "revisions.sc_equip_xref_uphole_ytool_equip_tubings_revisions" */
export type Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Min_Order_By = {
  author_id?: InputMaybe<Order_By>;
  cloned_from_journal_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  journal_id?: InputMaybe<Order_By>;
  length_feet?: InputMaybe<Order_By>;
  parent_revision_id?: InputMaybe<Order_By>;
  scenario_equipment_id?: InputMaybe<Order_By>;
  tubing_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "revisions.sc_equip_xref_uphole_ytool_equip_tubings_revisions" */
export type Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Mutation_Response = {
  __typename: 'revisions_sc_equip_xref_uphole_ytool_equip_tubings_revisions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions>;
};

/** input type for inserting object relation for remote table "revisions.sc_equip_xref_uphole_ytool_equip_tubings_revisions" */
export type Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Obj_Rel_Insert_Input = {
  data: Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_On_Conflict>;
};

/** on_conflict condition type for table "revisions.sc_equip_xref_uphole_ytool_equip_tubings_revisions" */
export type Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_On_Conflict = {
  constraint: Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Constraint;
  update_columns?: Array<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Update_Column>;
  where?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Bool_Exp>;
};

/** Ordering options when selecting data from "revisions.sc_equip_xref_uphole_ytool_equip_tubings_revisions". */
export type Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Order_By = {
  author_id?: InputMaybe<Order_By>;
  cloned_from_journal_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  journal_id?: InputMaybe<Order_By>;
  length_feet?: InputMaybe<Order_By>;
  parent_revision_id?: InputMaybe<Order_By>;
  sc_equip_xref_uphole_ytool_equip_tubings_journal?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_Order_By>;
  sc_equip_xref_uphole_ytool_equip_tubings_journals_aggregate?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_Aggregate_Order_By>;
  sc_equip_xref_uphole_ytool_equip_tubings_revisions?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Order_By>;
  sc_equip_xref_uphole_ytool_equip_tubings_view?: InputMaybe<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Order_By>;
  scenario_equipment_id?: InputMaybe<Order_By>;
  scenario_equipment_journal?: InputMaybe<Revisions_Scenario_Equipment_Journal_Order_By>;
  tubing?: InputMaybe<Tubings_Order_By>;
  tubing_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
};

/** primary key columns input for table: revisions.sc_equip_xref_uphole_ytool_equip_tubings_revisions */
export type Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "revisions.sc_equip_xref_uphole_ytool_equip_tubings_revisions" */
export enum Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Select_Column {
  /** column name */
  AuthorId = 'author_id',
  /** column name */
  ClonedFromJournalId = 'cloned_from_journal_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  JournalId = 'journal_id',
  /** column name */
  LengthFeet = 'length_feet',
  /** column name */
  ParentRevisionId = 'parent_revision_id',
  /** column name */
  ScenarioEquipmentId = 'scenario_equipment_id',
  /** column name */
  TubingId = 'tubing_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "revisions.sc_equip_xref_uphole_ytool_equip_tubings_revisions" */
export type Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Set_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  cloned_from_journal_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  journal_id?: InputMaybe<Scalars['uuid']['input']>;
  length_feet?: InputMaybe<Scalars['numeric']['input']>;
  parent_revision_id?: InputMaybe<Scalars['uuid']['input']>;
  scenario_equipment_id?: InputMaybe<Scalars['uuid']['input']>;
  tubing_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Stddev_Fields = {
  __typename: 'revisions_sc_equip_xref_uphole_ytool_equip_tubings_revisions_stddev_fields';
  length_feet?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "revisions.sc_equip_xref_uphole_ytool_equip_tubings_revisions" */
export type Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Stddev_Order_By = {
  length_feet?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Stddev_Pop_Fields = {
  __typename: 'revisions_sc_equip_xref_uphole_ytool_equip_tubings_revisions_stddev_pop_fields';
  length_feet?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "revisions.sc_equip_xref_uphole_ytool_equip_tubings_revisions" */
export type Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Stddev_Pop_Order_By = {
  length_feet?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Stddev_Samp_Fields = {
  __typename: 'revisions_sc_equip_xref_uphole_ytool_equip_tubings_revisions_stddev_samp_fields';
  length_feet?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "revisions.sc_equip_xref_uphole_ytool_equip_tubings_revisions" */
export type Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Stddev_Samp_Order_By = {
  length_feet?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "revisions_sc_equip_xref_uphole_ytool_equip_tubings_revisions" */
export type Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Stream_Cursor_Value_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  cloned_from_journal_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  journal_id?: InputMaybe<Scalars['uuid']['input']>;
  length_feet?: InputMaybe<Scalars['numeric']['input']>;
  parent_revision_id?: InputMaybe<Scalars['uuid']['input']>;
  scenario_equipment_id?: InputMaybe<Scalars['uuid']['input']>;
  tubing_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Sum_Fields = {
  __typename: 'revisions_sc_equip_xref_uphole_ytool_equip_tubings_revisions_sum_fields';
  length_feet?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "revisions.sc_equip_xref_uphole_ytool_equip_tubings_revisions" */
export type Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Sum_Order_By = {
  length_feet?: InputMaybe<Order_By>;
};

/** update columns of table "revisions.sc_equip_xref_uphole_ytool_equip_tubings_revisions" */
export enum Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Update_Column {
  /** column name */
  AuthorId = 'author_id',
  /** column name */
  ClonedFromJournalId = 'cloned_from_journal_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  JournalId = 'journal_id',
  /** column name */
  LengthFeet = 'length_feet',
  /** column name */
  ParentRevisionId = 'parent_revision_id',
  /** column name */
  ScenarioEquipmentId = 'scenario_equipment_id',
  /** column name */
  TubingId = 'tubing_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Set_Input>;
  /** filter the rows which have to be updated */
  where: Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Var_Pop_Fields = {
  __typename: 'revisions_sc_equip_xref_uphole_ytool_equip_tubings_revisions_var_pop_fields';
  length_feet?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "revisions.sc_equip_xref_uphole_ytool_equip_tubings_revisions" */
export type Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Var_Pop_Order_By = {
  length_feet?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Var_Samp_Fields = {
  __typename: 'revisions_sc_equip_xref_uphole_ytool_equip_tubings_revisions_var_samp_fields';
  length_feet?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "revisions.sc_equip_xref_uphole_ytool_equip_tubings_revisions" */
export type Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Var_Samp_Order_By = {
  length_feet?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Variance_Fields = {
  __typename: 'revisions_sc_equip_xref_uphole_ytool_equip_tubings_revisions_variance_fields';
  length_feet?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "revisions.sc_equip_xref_uphole_ytool_equip_tubings_revisions" */
export type Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Variance_Order_By = {
  length_feet?: InputMaybe<Order_By>;
};

/** columns and relationships of "revisions.scenario_correlations_journal" */
export type Revisions_Scenario_Correlations_Journal = {
  __typename: 'revisions_scenario_correlations_journal';
  author_id: Scalars['String']['output'];
  created_at: Scalars['timestamptz']['output'];
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  parent_journal_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  scenario_correlations_journal?: Maybe<Revisions_Scenario_Correlations_Journal>;
  /** An array relationship */
  scenario_correlations_journals: Array<Revisions_Scenario_Correlations_Journal>;
  /** An aggregate relationship */
  scenario_correlations_journals_aggregate: Revisions_Scenario_Correlations_Journal_Aggregate;
  /** An object relationship */
  scenario_correlations_revision?: Maybe<Revisions_Scenario_Correlations_Revisions>;
  /** An array relationship */
  scenario_correlations_revisions: Array<Revisions_Scenario_Correlations_Revisions>;
  /** An aggregate relationship */
  scenario_correlations_revisions_aggregate: Revisions_Scenario_Correlations_Revisions_Aggregate;
  /** An array relationship */
  scenarios_revisions: Array<Revisions_Scenarios_Revisions>;
  /** An aggregate relationship */
  scenarios_revisions_aggregate: Revisions_Scenarios_Revisions_Aggregate;
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Users;
  winning_revision_id?: Maybe<Scalars['uuid']['output']>;
};


/** columns and relationships of "revisions.scenario_correlations_journal" */
export type Revisions_Scenario_Correlations_JournalScenario_Correlations_JournalsArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Correlations_Journal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Correlations_Journal_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Correlations_Journal_Bool_Exp>;
};


/** columns and relationships of "revisions.scenario_correlations_journal" */
export type Revisions_Scenario_Correlations_JournalScenario_Correlations_Journals_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Correlations_Journal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Correlations_Journal_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Correlations_Journal_Bool_Exp>;
};


/** columns and relationships of "revisions.scenario_correlations_journal" */
export type Revisions_Scenario_Correlations_JournalScenario_Correlations_RevisionsArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Correlations_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Correlations_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Correlations_Revisions_Bool_Exp>;
};


/** columns and relationships of "revisions.scenario_correlations_journal" */
export type Revisions_Scenario_Correlations_JournalScenario_Correlations_Revisions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Correlations_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Correlations_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Correlations_Revisions_Bool_Exp>;
};


/** columns and relationships of "revisions.scenario_correlations_journal" */
export type Revisions_Scenario_Correlations_JournalScenarios_RevisionsArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenarios_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenarios_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Scenarios_Revisions_Bool_Exp>;
};


/** columns and relationships of "revisions.scenario_correlations_journal" */
export type Revisions_Scenario_Correlations_JournalScenarios_Revisions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenarios_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenarios_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Scenarios_Revisions_Bool_Exp>;
};

/** aggregated selection of "revisions.scenario_correlations_journal" */
export type Revisions_Scenario_Correlations_Journal_Aggregate = {
  __typename: 'revisions_scenario_correlations_journal_aggregate';
  aggregate?: Maybe<Revisions_Scenario_Correlations_Journal_Aggregate_Fields>;
  nodes: Array<Revisions_Scenario_Correlations_Journal>;
};

export type Revisions_Scenario_Correlations_Journal_Aggregate_Bool_Exp = {
  count?: InputMaybe<Revisions_Scenario_Correlations_Journal_Aggregate_Bool_Exp_Count>;
};

export type Revisions_Scenario_Correlations_Journal_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Revisions_Scenario_Correlations_Journal_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Revisions_Scenario_Correlations_Journal_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "revisions.scenario_correlations_journal" */
export type Revisions_Scenario_Correlations_Journal_Aggregate_Fields = {
  __typename: 'revisions_scenario_correlations_journal_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Revisions_Scenario_Correlations_Journal_Max_Fields>;
  min?: Maybe<Revisions_Scenario_Correlations_Journal_Min_Fields>;
};


/** aggregate fields of "revisions.scenario_correlations_journal" */
export type Revisions_Scenario_Correlations_Journal_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Revisions_Scenario_Correlations_Journal_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "revisions.scenario_correlations_journal" */
export type Revisions_Scenario_Correlations_Journal_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Revisions_Scenario_Correlations_Journal_Max_Order_By>;
  min?: InputMaybe<Revisions_Scenario_Correlations_Journal_Min_Order_By>;
};

/** input type for inserting array relation for remote table "revisions.scenario_correlations_journal" */
export type Revisions_Scenario_Correlations_Journal_Arr_Rel_Insert_Input = {
  data: Array<Revisions_Scenario_Correlations_Journal_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Revisions_Scenario_Correlations_Journal_On_Conflict>;
};

/** Boolean expression to filter rows from the table "revisions.scenario_correlations_journal". All fields are combined with a logical 'AND'. */
export type Revisions_Scenario_Correlations_Journal_Bool_Exp = {
  _and?: InputMaybe<Array<Revisions_Scenario_Correlations_Journal_Bool_Exp>>;
  _not?: InputMaybe<Revisions_Scenario_Correlations_Journal_Bool_Exp>;
  _or?: InputMaybe<Array<Revisions_Scenario_Correlations_Journal_Bool_Exp>>;
  author_id?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  parent_journal_id?: InputMaybe<Uuid_Comparison_Exp>;
  scenario_correlations_journal?: InputMaybe<Revisions_Scenario_Correlations_Journal_Bool_Exp>;
  scenario_correlations_journals?: InputMaybe<Revisions_Scenario_Correlations_Journal_Bool_Exp>;
  scenario_correlations_journals_aggregate?: InputMaybe<Revisions_Scenario_Correlations_Journal_Aggregate_Bool_Exp>;
  scenario_correlations_revision?: InputMaybe<Revisions_Scenario_Correlations_Revisions_Bool_Exp>;
  scenario_correlations_revisions?: InputMaybe<Revisions_Scenario_Correlations_Revisions_Bool_Exp>;
  scenario_correlations_revisions_aggregate?: InputMaybe<Revisions_Scenario_Correlations_Revisions_Aggregate_Bool_Exp>;
  scenarios_revisions?: InputMaybe<Revisions_Scenarios_Revisions_Bool_Exp>;
  scenarios_revisions_aggregate?: InputMaybe<Revisions_Scenarios_Revisions_Aggregate_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  winning_revision_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "revisions.scenario_correlations_journal" */
export enum Revisions_Scenario_Correlations_Journal_Constraint {
  /** unique or primary key constraint on columns "id" */
  ScenarioCorrelationsJournalPkey = 'scenario_correlations_journal_pkey'
}

/** input type for inserting data into table "revisions.scenario_correlations_journal" */
export type Revisions_Scenario_Correlations_Journal_Insert_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  parent_journal_id?: InputMaybe<Scalars['uuid']['input']>;
  scenario_correlations_journal?: InputMaybe<Revisions_Scenario_Correlations_Journal_Obj_Rel_Insert_Input>;
  scenario_correlations_journals?: InputMaybe<Revisions_Scenario_Correlations_Journal_Arr_Rel_Insert_Input>;
  scenario_correlations_revision?: InputMaybe<Revisions_Scenario_Correlations_Revisions_Obj_Rel_Insert_Input>;
  scenario_correlations_revisions?: InputMaybe<Revisions_Scenario_Correlations_Revisions_Arr_Rel_Insert_Input>;
  scenarios_revisions?: InputMaybe<Revisions_Scenarios_Revisions_Arr_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  winning_revision_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Revisions_Scenario_Correlations_Journal_Max_Fields = {
  __typename: 'revisions_scenario_correlations_journal_max_fields';
  author_id?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  parent_journal_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  winning_revision_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "revisions.scenario_correlations_journal" */
export type Revisions_Scenario_Correlations_Journal_Max_Order_By = {
  author_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parent_journal_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  winning_revision_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Revisions_Scenario_Correlations_Journal_Min_Fields = {
  __typename: 'revisions_scenario_correlations_journal_min_fields';
  author_id?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  parent_journal_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  winning_revision_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "revisions.scenario_correlations_journal" */
export type Revisions_Scenario_Correlations_Journal_Min_Order_By = {
  author_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parent_journal_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  winning_revision_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "revisions.scenario_correlations_journal" */
export type Revisions_Scenario_Correlations_Journal_Mutation_Response = {
  __typename: 'revisions_scenario_correlations_journal_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Revisions_Scenario_Correlations_Journal>;
};

/** input type for inserting object relation for remote table "revisions.scenario_correlations_journal" */
export type Revisions_Scenario_Correlations_Journal_Obj_Rel_Insert_Input = {
  data: Revisions_Scenario_Correlations_Journal_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Revisions_Scenario_Correlations_Journal_On_Conflict>;
};

/** on_conflict condition type for table "revisions.scenario_correlations_journal" */
export type Revisions_Scenario_Correlations_Journal_On_Conflict = {
  constraint: Revisions_Scenario_Correlations_Journal_Constraint;
  update_columns?: Array<Revisions_Scenario_Correlations_Journal_Update_Column>;
  where?: InputMaybe<Revisions_Scenario_Correlations_Journal_Bool_Exp>;
};

/** Ordering options when selecting data from "revisions.scenario_correlations_journal". */
export type Revisions_Scenario_Correlations_Journal_Order_By = {
  author_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parent_journal_id?: InputMaybe<Order_By>;
  scenario_correlations_journal?: InputMaybe<Revisions_Scenario_Correlations_Journal_Order_By>;
  scenario_correlations_journals_aggregate?: InputMaybe<Revisions_Scenario_Correlations_Journal_Aggregate_Order_By>;
  scenario_correlations_revision?: InputMaybe<Revisions_Scenario_Correlations_Revisions_Order_By>;
  scenario_correlations_revisions_aggregate?: InputMaybe<Revisions_Scenario_Correlations_Revisions_Aggregate_Order_By>;
  scenarios_revisions_aggregate?: InputMaybe<Revisions_Scenarios_Revisions_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  winning_revision_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: revisions.scenario_correlations_journal */
export type Revisions_Scenario_Correlations_Journal_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "revisions.scenario_correlations_journal" */
export enum Revisions_Scenario_Correlations_Journal_Select_Column {
  /** column name */
  AuthorId = 'author_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  ParentJournalId = 'parent_journal_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WinningRevisionId = 'winning_revision_id'
}

/** input type for updating data in table "revisions.scenario_correlations_journal" */
export type Revisions_Scenario_Correlations_Journal_Set_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  parent_journal_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  winning_revision_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "revisions_scenario_correlations_journal" */
export type Revisions_Scenario_Correlations_Journal_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Revisions_Scenario_Correlations_Journal_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Revisions_Scenario_Correlations_Journal_Stream_Cursor_Value_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  parent_journal_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  winning_revision_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "revisions.scenario_correlations_journal" */
export enum Revisions_Scenario_Correlations_Journal_Update_Column {
  /** column name */
  AuthorId = 'author_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  ParentJournalId = 'parent_journal_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WinningRevisionId = 'winning_revision_id'
}

export type Revisions_Scenario_Correlations_Journal_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Revisions_Scenario_Correlations_Journal_Set_Input>;
  /** filter the rows which have to be updated */
  where: Revisions_Scenario_Correlations_Journal_Bool_Exp;
};

/** columns and relationships of "revisions.scenario_correlations_revisions" */
export type Revisions_Scenario_Correlations_Revisions = {
  __typename: 'revisions_scenario_correlations_revisions';
  author_id: Scalars['String']['output'];
  bubble_point: Bubble_Point_Options_Enum;
  /** An object relationship */
  bubble_point_option: Bubble_Point_Options;
  casing_apply_hazen_williams_correction: Scalars['Boolean']['output'];
  casing_flow: Casing_Flow_Options_Enum;
  casing_griffith_wallis: Scalars['Boolean']['output'];
  casing_hazen_williams_coefficient: Scalars['numeric']['output'];
  casing_palmer_correction: Scalars['Boolean']['output'];
  casing_roughness_inches: Scalars['numeric']['output'];
  cloned_from_journal_id?: Maybe<Scalars['uuid']['output']>;
  created_at: Scalars['timestamptz']['output'];
  dead_oil: Dead_Oil_Options_Enum;
  /** An object relationship */
  dead_oil_option: Dead_Oil_Options;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  friction_loss: Friction_Loss_Options_Enum;
  gas_compressibility: Gas_Compressibility_Options_Enum;
  /** An object relationship */
  gas_compressibility_option: Gas_Compressibility_Options;
  gas_viscosity: Gas_Viscosity_Options_Enum;
  /** An object relationship */
  gas_viscosity_option: Gas_Viscosity_Options;
  id: Scalars['uuid']['output'];
  journal_id: Scalars['uuid']['output'];
  natural_gas_separation: Natural_Gas_Separation_Options_Enum;
  oil_density: Oil_Density_Options_Enum;
  /** An object relationship */
  oil_density_option: Oil_Density_Options;
  oil_volume_factor_saturated: Scalars['String']['output'];
  /** An object relationship */
  oil_volume_factor_saturated_option?: Maybe<Oil_Volume_Factor_Options>;
  oil_volume_factor_undersaturated: Oil_Volume_Factor_Options_Enum;
  /** An object relationship */
  oil_volume_factor_undersaturated_option?: Maybe<Oil_Volume_Factor_Options>;
  parent_revision_id?: Maybe<Scalars['uuid']['output']>;
  salinity_ppm: Scalars['numeric']['output'];
  saturated_oil: Saturated_Oil_Options_Enum;
  /** An object relationship */
  saturated_oil_option: Saturated_Oil_Options;
  /** An object relationship */
  scenario_correlations_journal: Revisions_Scenario_Correlations_Journal;
  /** An array relationship */
  scenario_correlations_journals: Array<Revisions_Scenario_Correlations_Journal>;
  /** An aggregate relationship */
  scenario_correlations_journals_aggregate: Revisions_Scenario_Correlations_Journal_Aggregate;
  /** An object relationship */
  scenario_correlations_revision?: Maybe<Revisions_Scenario_Correlations_Revisions>;
  /** An array relationship */
  scenario_correlations_revisions: Array<Revisions_Scenario_Correlations_Revisions>;
  /** An aggregate relationship */
  scenario_correlations_revisions_aggregate: Revisions_Scenario_Correlations_Revisions_Aggregate;
  /** An object relationship */
  scenario_correlations_view?: Maybe<Scenario_Correlations>;
  /** An object relationship */
  solution_gas_oil_ratio_option: Solution_Gas_Oil_Ratio_Options;
  solution_gor: Solution_Gas_Oil_Ratio_Options_Enum;
  tdh_tuning_factor_ratio: Scalars['numeric']['output'];
  tubing_apply_hazen_williams_correction: Scalars['Boolean']['output'];
  tubing_flow: Tubing_Flow_Options_Enum;
  /** An object relationship */
  tubing_flow_option: Tubing_Flow_Options;
  tubing_griffith_wallis: Scalars['Boolean']['output'];
  tubing_hazen_williams_coefficient: Scalars['numeric']['output'];
  tubing_palmer_correction: Scalars['Boolean']['output'];
  tubing_roughness_inches: Scalars['numeric']['output'];
  under_saturated_oil: Under_Saturated_Oil_Options_Enum;
  /** An object relationship */
  under_saturated_oil_option: Under_Saturated_Oil_Options;
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Users;
  water_density: Water_Density_Options_Enum;
  water_solution_gas: Water_Solution_Gas_Options_Enum;
  water_viscosity: Water_Viscosity_Options_Enum;
  /** An object relationship */
  water_viscosity_option: Water_Viscosity_Options;
  water_volume_factor: Water_Volume_Factor_Options_Enum;
  /** An object relationship */
  water_volume_factor_option: Water_Volume_Factor_Options;
};


/** columns and relationships of "revisions.scenario_correlations_revisions" */
export type Revisions_Scenario_Correlations_RevisionsScenario_Correlations_JournalsArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Correlations_Journal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Correlations_Journal_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Correlations_Journal_Bool_Exp>;
};


/** columns and relationships of "revisions.scenario_correlations_revisions" */
export type Revisions_Scenario_Correlations_RevisionsScenario_Correlations_Journals_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Correlations_Journal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Correlations_Journal_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Correlations_Journal_Bool_Exp>;
};


/** columns and relationships of "revisions.scenario_correlations_revisions" */
export type Revisions_Scenario_Correlations_RevisionsScenario_Correlations_RevisionsArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Correlations_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Correlations_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Correlations_Revisions_Bool_Exp>;
};


/** columns and relationships of "revisions.scenario_correlations_revisions" */
export type Revisions_Scenario_Correlations_RevisionsScenario_Correlations_Revisions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Correlations_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Correlations_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Correlations_Revisions_Bool_Exp>;
};

/** aggregated selection of "revisions.scenario_correlations_revisions" */
export type Revisions_Scenario_Correlations_Revisions_Aggregate = {
  __typename: 'revisions_scenario_correlations_revisions_aggregate';
  aggregate?: Maybe<Revisions_Scenario_Correlations_Revisions_Aggregate_Fields>;
  nodes: Array<Revisions_Scenario_Correlations_Revisions>;
};

export type Revisions_Scenario_Correlations_Revisions_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Revisions_Scenario_Correlations_Revisions_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Revisions_Scenario_Correlations_Revisions_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Revisions_Scenario_Correlations_Revisions_Aggregate_Bool_Exp_Count>;
};

export type Revisions_Scenario_Correlations_Revisions_Aggregate_Bool_Exp_Bool_And = {
  arguments: Revisions_Scenario_Correlations_Revisions_Select_Column_Revisions_Scenario_Correlations_Revisions_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Revisions_Scenario_Correlations_Revisions_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Revisions_Scenario_Correlations_Revisions_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Revisions_Scenario_Correlations_Revisions_Select_Column_Revisions_Scenario_Correlations_Revisions_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Revisions_Scenario_Correlations_Revisions_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Revisions_Scenario_Correlations_Revisions_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Revisions_Scenario_Correlations_Revisions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Revisions_Scenario_Correlations_Revisions_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "revisions.scenario_correlations_revisions" */
export type Revisions_Scenario_Correlations_Revisions_Aggregate_Fields = {
  __typename: 'revisions_scenario_correlations_revisions_aggregate_fields';
  avg?: Maybe<Revisions_Scenario_Correlations_Revisions_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Revisions_Scenario_Correlations_Revisions_Max_Fields>;
  min?: Maybe<Revisions_Scenario_Correlations_Revisions_Min_Fields>;
  stddev?: Maybe<Revisions_Scenario_Correlations_Revisions_Stddev_Fields>;
  stddev_pop?: Maybe<Revisions_Scenario_Correlations_Revisions_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Revisions_Scenario_Correlations_Revisions_Stddev_Samp_Fields>;
  sum?: Maybe<Revisions_Scenario_Correlations_Revisions_Sum_Fields>;
  var_pop?: Maybe<Revisions_Scenario_Correlations_Revisions_Var_Pop_Fields>;
  var_samp?: Maybe<Revisions_Scenario_Correlations_Revisions_Var_Samp_Fields>;
  variance?: Maybe<Revisions_Scenario_Correlations_Revisions_Variance_Fields>;
};


/** aggregate fields of "revisions.scenario_correlations_revisions" */
export type Revisions_Scenario_Correlations_Revisions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Revisions_Scenario_Correlations_Revisions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "revisions.scenario_correlations_revisions" */
export type Revisions_Scenario_Correlations_Revisions_Aggregate_Order_By = {
  avg?: InputMaybe<Revisions_Scenario_Correlations_Revisions_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Revisions_Scenario_Correlations_Revisions_Max_Order_By>;
  min?: InputMaybe<Revisions_Scenario_Correlations_Revisions_Min_Order_By>;
  stddev?: InputMaybe<Revisions_Scenario_Correlations_Revisions_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Revisions_Scenario_Correlations_Revisions_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Revisions_Scenario_Correlations_Revisions_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Revisions_Scenario_Correlations_Revisions_Sum_Order_By>;
  var_pop?: InputMaybe<Revisions_Scenario_Correlations_Revisions_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Revisions_Scenario_Correlations_Revisions_Var_Samp_Order_By>;
  variance?: InputMaybe<Revisions_Scenario_Correlations_Revisions_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "revisions.scenario_correlations_revisions" */
export type Revisions_Scenario_Correlations_Revisions_Arr_Rel_Insert_Input = {
  data: Array<Revisions_Scenario_Correlations_Revisions_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Revisions_Scenario_Correlations_Revisions_On_Conflict>;
};

/** aggregate avg on columns */
export type Revisions_Scenario_Correlations_Revisions_Avg_Fields = {
  __typename: 'revisions_scenario_correlations_revisions_avg_fields';
  casing_hazen_williams_coefficient?: Maybe<Scalars['Float']['output']>;
  casing_roughness_inches?: Maybe<Scalars['Float']['output']>;
  salinity_ppm?: Maybe<Scalars['Float']['output']>;
  tdh_tuning_factor_ratio?: Maybe<Scalars['Float']['output']>;
  tubing_hazen_williams_coefficient?: Maybe<Scalars['Float']['output']>;
  tubing_roughness_inches?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "revisions.scenario_correlations_revisions" */
export type Revisions_Scenario_Correlations_Revisions_Avg_Order_By = {
  casing_hazen_williams_coefficient?: InputMaybe<Order_By>;
  casing_roughness_inches?: InputMaybe<Order_By>;
  salinity_ppm?: InputMaybe<Order_By>;
  tdh_tuning_factor_ratio?: InputMaybe<Order_By>;
  tubing_hazen_williams_coefficient?: InputMaybe<Order_By>;
  tubing_roughness_inches?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "revisions.scenario_correlations_revisions". All fields are combined with a logical 'AND'. */
export type Revisions_Scenario_Correlations_Revisions_Bool_Exp = {
  _and?: InputMaybe<Array<Revisions_Scenario_Correlations_Revisions_Bool_Exp>>;
  _not?: InputMaybe<Revisions_Scenario_Correlations_Revisions_Bool_Exp>;
  _or?: InputMaybe<Array<Revisions_Scenario_Correlations_Revisions_Bool_Exp>>;
  author_id?: InputMaybe<String_Comparison_Exp>;
  bubble_point?: InputMaybe<Bubble_Point_Options_Enum_Comparison_Exp>;
  bubble_point_option?: InputMaybe<Bubble_Point_Options_Bool_Exp>;
  casing_apply_hazen_williams_correction?: InputMaybe<Boolean_Comparison_Exp>;
  casing_flow?: InputMaybe<Casing_Flow_Options_Enum_Comparison_Exp>;
  casing_griffith_wallis?: InputMaybe<Boolean_Comparison_Exp>;
  casing_hazen_williams_coefficient?: InputMaybe<Numeric_Comparison_Exp>;
  casing_palmer_correction?: InputMaybe<Boolean_Comparison_Exp>;
  casing_roughness_inches?: InputMaybe<Numeric_Comparison_Exp>;
  cloned_from_journal_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  dead_oil?: InputMaybe<Dead_Oil_Options_Enum_Comparison_Exp>;
  dead_oil_option?: InputMaybe<Dead_Oil_Options_Bool_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  friction_loss?: InputMaybe<Friction_Loss_Options_Enum_Comparison_Exp>;
  gas_compressibility?: InputMaybe<Gas_Compressibility_Options_Enum_Comparison_Exp>;
  gas_compressibility_option?: InputMaybe<Gas_Compressibility_Options_Bool_Exp>;
  gas_viscosity?: InputMaybe<Gas_Viscosity_Options_Enum_Comparison_Exp>;
  gas_viscosity_option?: InputMaybe<Gas_Viscosity_Options_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  journal_id?: InputMaybe<Uuid_Comparison_Exp>;
  natural_gas_separation?: InputMaybe<Natural_Gas_Separation_Options_Enum_Comparison_Exp>;
  oil_density?: InputMaybe<Oil_Density_Options_Enum_Comparison_Exp>;
  oil_density_option?: InputMaybe<Oil_Density_Options_Bool_Exp>;
  oil_volume_factor_saturated?: InputMaybe<String_Comparison_Exp>;
  oil_volume_factor_saturated_option?: InputMaybe<Oil_Volume_Factor_Options_Bool_Exp>;
  oil_volume_factor_undersaturated?: InputMaybe<Oil_Volume_Factor_Options_Enum_Comparison_Exp>;
  oil_volume_factor_undersaturated_option?: InputMaybe<Oil_Volume_Factor_Options_Bool_Exp>;
  parent_revision_id?: InputMaybe<Uuid_Comparison_Exp>;
  salinity_ppm?: InputMaybe<Numeric_Comparison_Exp>;
  saturated_oil?: InputMaybe<Saturated_Oil_Options_Enum_Comparison_Exp>;
  saturated_oil_option?: InputMaybe<Saturated_Oil_Options_Bool_Exp>;
  scenario_correlations_journal?: InputMaybe<Revisions_Scenario_Correlations_Journal_Bool_Exp>;
  scenario_correlations_journals?: InputMaybe<Revisions_Scenario_Correlations_Journal_Bool_Exp>;
  scenario_correlations_journals_aggregate?: InputMaybe<Revisions_Scenario_Correlations_Journal_Aggregate_Bool_Exp>;
  scenario_correlations_revision?: InputMaybe<Revisions_Scenario_Correlations_Revisions_Bool_Exp>;
  scenario_correlations_revisions?: InputMaybe<Revisions_Scenario_Correlations_Revisions_Bool_Exp>;
  scenario_correlations_revisions_aggregate?: InputMaybe<Revisions_Scenario_Correlations_Revisions_Aggregate_Bool_Exp>;
  scenario_correlations_view?: InputMaybe<Scenario_Correlations_Bool_Exp>;
  solution_gas_oil_ratio_option?: InputMaybe<Solution_Gas_Oil_Ratio_Options_Bool_Exp>;
  solution_gor?: InputMaybe<Solution_Gas_Oil_Ratio_Options_Enum_Comparison_Exp>;
  tdh_tuning_factor_ratio?: InputMaybe<Numeric_Comparison_Exp>;
  tubing_apply_hazen_williams_correction?: InputMaybe<Boolean_Comparison_Exp>;
  tubing_flow?: InputMaybe<Tubing_Flow_Options_Enum_Comparison_Exp>;
  tubing_flow_option?: InputMaybe<Tubing_Flow_Options_Bool_Exp>;
  tubing_griffith_wallis?: InputMaybe<Boolean_Comparison_Exp>;
  tubing_hazen_williams_coefficient?: InputMaybe<Numeric_Comparison_Exp>;
  tubing_palmer_correction?: InputMaybe<Boolean_Comparison_Exp>;
  tubing_roughness_inches?: InputMaybe<Numeric_Comparison_Exp>;
  under_saturated_oil?: InputMaybe<Under_Saturated_Oil_Options_Enum_Comparison_Exp>;
  under_saturated_oil_option?: InputMaybe<Under_Saturated_Oil_Options_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  water_density?: InputMaybe<Water_Density_Options_Enum_Comparison_Exp>;
  water_solution_gas?: InputMaybe<Water_Solution_Gas_Options_Enum_Comparison_Exp>;
  water_viscosity?: InputMaybe<Water_Viscosity_Options_Enum_Comparison_Exp>;
  water_viscosity_option?: InputMaybe<Water_Viscosity_Options_Bool_Exp>;
  water_volume_factor?: InputMaybe<Water_Volume_Factor_Options_Enum_Comparison_Exp>;
  water_volume_factor_option?: InputMaybe<Water_Volume_Factor_Options_Bool_Exp>;
};

/** unique or primary key constraints on table "revisions.scenario_correlations_revisions" */
export enum Revisions_Scenario_Correlations_Revisions_Constraint {
  /** unique or primary key constraint on columns "id" */
  ScenarioCorrelationsRevisionsPkey = 'scenario_correlations_revisions_pkey'
}

/** input type for incrementing numeric columns in table "revisions.scenario_correlations_revisions" */
export type Revisions_Scenario_Correlations_Revisions_Inc_Input = {
  casing_hazen_williams_coefficient?: InputMaybe<Scalars['numeric']['input']>;
  casing_roughness_inches?: InputMaybe<Scalars['numeric']['input']>;
  salinity_ppm?: InputMaybe<Scalars['numeric']['input']>;
  tdh_tuning_factor_ratio?: InputMaybe<Scalars['numeric']['input']>;
  tubing_hazen_williams_coefficient?: InputMaybe<Scalars['numeric']['input']>;
  tubing_roughness_inches?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "revisions.scenario_correlations_revisions" */
export type Revisions_Scenario_Correlations_Revisions_Insert_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  bubble_point?: InputMaybe<Bubble_Point_Options_Enum>;
  bubble_point_option?: InputMaybe<Bubble_Point_Options_Obj_Rel_Insert_Input>;
  casing_apply_hazen_williams_correction?: InputMaybe<Scalars['Boolean']['input']>;
  casing_flow?: InputMaybe<Casing_Flow_Options_Enum>;
  casing_griffith_wallis?: InputMaybe<Scalars['Boolean']['input']>;
  casing_hazen_williams_coefficient?: InputMaybe<Scalars['numeric']['input']>;
  casing_palmer_correction?: InputMaybe<Scalars['Boolean']['input']>;
  casing_roughness_inches?: InputMaybe<Scalars['numeric']['input']>;
  cloned_from_journal_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  dead_oil?: InputMaybe<Dead_Oil_Options_Enum>;
  dead_oil_option?: InputMaybe<Dead_Oil_Options_Obj_Rel_Insert_Input>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  friction_loss?: InputMaybe<Friction_Loss_Options_Enum>;
  gas_compressibility?: InputMaybe<Gas_Compressibility_Options_Enum>;
  gas_compressibility_option?: InputMaybe<Gas_Compressibility_Options_Obj_Rel_Insert_Input>;
  gas_viscosity?: InputMaybe<Gas_Viscosity_Options_Enum>;
  gas_viscosity_option?: InputMaybe<Gas_Viscosity_Options_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  journal_id?: InputMaybe<Scalars['uuid']['input']>;
  natural_gas_separation?: InputMaybe<Natural_Gas_Separation_Options_Enum>;
  oil_density?: InputMaybe<Oil_Density_Options_Enum>;
  oil_density_option?: InputMaybe<Oil_Density_Options_Obj_Rel_Insert_Input>;
  oil_volume_factor_saturated?: InputMaybe<Scalars['String']['input']>;
  oil_volume_factor_saturated_option?: InputMaybe<Oil_Volume_Factor_Options_Obj_Rel_Insert_Input>;
  oil_volume_factor_undersaturated?: InputMaybe<Oil_Volume_Factor_Options_Enum>;
  oil_volume_factor_undersaturated_option?: InputMaybe<Oil_Volume_Factor_Options_Obj_Rel_Insert_Input>;
  parent_revision_id?: InputMaybe<Scalars['uuid']['input']>;
  salinity_ppm?: InputMaybe<Scalars['numeric']['input']>;
  saturated_oil?: InputMaybe<Saturated_Oil_Options_Enum>;
  saturated_oil_option?: InputMaybe<Saturated_Oil_Options_Obj_Rel_Insert_Input>;
  scenario_correlations_journal?: InputMaybe<Revisions_Scenario_Correlations_Journal_Obj_Rel_Insert_Input>;
  scenario_correlations_journals?: InputMaybe<Revisions_Scenario_Correlations_Journal_Arr_Rel_Insert_Input>;
  scenario_correlations_revision?: InputMaybe<Revisions_Scenario_Correlations_Revisions_Obj_Rel_Insert_Input>;
  scenario_correlations_revisions?: InputMaybe<Revisions_Scenario_Correlations_Revisions_Arr_Rel_Insert_Input>;
  scenario_correlations_view?: InputMaybe<Scenario_Correlations_Obj_Rel_Insert_Input>;
  solution_gas_oil_ratio_option?: InputMaybe<Solution_Gas_Oil_Ratio_Options_Obj_Rel_Insert_Input>;
  solution_gor?: InputMaybe<Solution_Gas_Oil_Ratio_Options_Enum>;
  tdh_tuning_factor_ratio?: InputMaybe<Scalars['numeric']['input']>;
  tubing_apply_hazen_williams_correction?: InputMaybe<Scalars['Boolean']['input']>;
  tubing_flow?: InputMaybe<Tubing_Flow_Options_Enum>;
  tubing_flow_option?: InputMaybe<Tubing_Flow_Options_Obj_Rel_Insert_Input>;
  tubing_griffith_wallis?: InputMaybe<Scalars['Boolean']['input']>;
  tubing_hazen_williams_coefficient?: InputMaybe<Scalars['numeric']['input']>;
  tubing_palmer_correction?: InputMaybe<Scalars['Boolean']['input']>;
  tubing_roughness_inches?: InputMaybe<Scalars['numeric']['input']>;
  under_saturated_oil?: InputMaybe<Under_Saturated_Oil_Options_Enum>;
  under_saturated_oil_option?: InputMaybe<Under_Saturated_Oil_Options_Obj_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  water_density?: InputMaybe<Water_Density_Options_Enum>;
  water_solution_gas?: InputMaybe<Water_Solution_Gas_Options_Enum>;
  water_viscosity?: InputMaybe<Water_Viscosity_Options_Enum>;
  water_viscosity_option?: InputMaybe<Water_Viscosity_Options_Obj_Rel_Insert_Input>;
  water_volume_factor?: InputMaybe<Water_Volume_Factor_Options_Enum>;
  water_volume_factor_option?: InputMaybe<Water_Volume_Factor_Options_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Revisions_Scenario_Correlations_Revisions_Max_Fields = {
  __typename: 'revisions_scenario_correlations_revisions_max_fields';
  author_id?: Maybe<Scalars['String']['output']>;
  casing_hazen_williams_coefficient?: Maybe<Scalars['numeric']['output']>;
  casing_roughness_inches?: Maybe<Scalars['numeric']['output']>;
  cloned_from_journal_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  journal_id?: Maybe<Scalars['uuid']['output']>;
  oil_volume_factor_saturated?: Maybe<Scalars['String']['output']>;
  parent_revision_id?: Maybe<Scalars['uuid']['output']>;
  salinity_ppm?: Maybe<Scalars['numeric']['output']>;
  tdh_tuning_factor_ratio?: Maybe<Scalars['numeric']['output']>;
  tubing_hazen_williams_coefficient?: Maybe<Scalars['numeric']['output']>;
  tubing_roughness_inches?: Maybe<Scalars['numeric']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "revisions.scenario_correlations_revisions" */
export type Revisions_Scenario_Correlations_Revisions_Max_Order_By = {
  author_id?: InputMaybe<Order_By>;
  casing_hazen_williams_coefficient?: InputMaybe<Order_By>;
  casing_roughness_inches?: InputMaybe<Order_By>;
  cloned_from_journal_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  journal_id?: InputMaybe<Order_By>;
  oil_volume_factor_saturated?: InputMaybe<Order_By>;
  parent_revision_id?: InputMaybe<Order_By>;
  salinity_ppm?: InputMaybe<Order_By>;
  tdh_tuning_factor_ratio?: InputMaybe<Order_By>;
  tubing_hazen_williams_coefficient?: InputMaybe<Order_By>;
  tubing_roughness_inches?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Revisions_Scenario_Correlations_Revisions_Min_Fields = {
  __typename: 'revisions_scenario_correlations_revisions_min_fields';
  author_id?: Maybe<Scalars['String']['output']>;
  casing_hazen_williams_coefficient?: Maybe<Scalars['numeric']['output']>;
  casing_roughness_inches?: Maybe<Scalars['numeric']['output']>;
  cloned_from_journal_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  journal_id?: Maybe<Scalars['uuid']['output']>;
  oil_volume_factor_saturated?: Maybe<Scalars['String']['output']>;
  parent_revision_id?: Maybe<Scalars['uuid']['output']>;
  salinity_ppm?: Maybe<Scalars['numeric']['output']>;
  tdh_tuning_factor_ratio?: Maybe<Scalars['numeric']['output']>;
  tubing_hazen_williams_coefficient?: Maybe<Scalars['numeric']['output']>;
  tubing_roughness_inches?: Maybe<Scalars['numeric']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "revisions.scenario_correlations_revisions" */
export type Revisions_Scenario_Correlations_Revisions_Min_Order_By = {
  author_id?: InputMaybe<Order_By>;
  casing_hazen_williams_coefficient?: InputMaybe<Order_By>;
  casing_roughness_inches?: InputMaybe<Order_By>;
  cloned_from_journal_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  journal_id?: InputMaybe<Order_By>;
  oil_volume_factor_saturated?: InputMaybe<Order_By>;
  parent_revision_id?: InputMaybe<Order_By>;
  salinity_ppm?: InputMaybe<Order_By>;
  tdh_tuning_factor_ratio?: InputMaybe<Order_By>;
  tubing_hazen_williams_coefficient?: InputMaybe<Order_By>;
  tubing_roughness_inches?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "revisions.scenario_correlations_revisions" */
export type Revisions_Scenario_Correlations_Revisions_Mutation_Response = {
  __typename: 'revisions_scenario_correlations_revisions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Revisions_Scenario_Correlations_Revisions>;
};

/** input type for inserting object relation for remote table "revisions.scenario_correlations_revisions" */
export type Revisions_Scenario_Correlations_Revisions_Obj_Rel_Insert_Input = {
  data: Revisions_Scenario_Correlations_Revisions_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Revisions_Scenario_Correlations_Revisions_On_Conflict>;
};

/** on_conflict condition type for table "revisions.scenario_correlations_revisions" */
export type Revisions_Scenario_Correlations_Revisions_On_Conflict = {
  constraint: Revisions_Scenario_Correlations_Revisions_Constraint;
  update_columns?: Array<Revisions_Scenario_Correlations_Revisions_Update_Column>;
  where?: InputMaybe<Revisions_Scenario_Correlations_Revisions_Bool_Exp>;
};

/** Ordering options when selecting data from "revisions.scenario_correlations_revisions". */
export type Revisions_Scenario_Correlations_Revisions_Order_By = {
  author_id?: InputMaybe<Order_By>;
  bubble_point?: InputMaybe<Order_By>;
  bubble_point_option?: InputMaybe<Bubble_Point_Options_Order_By>;
  casing_apply_hazen_williams_correction?: InputMaybe<Order_By>;
  casing_flow?: InputMaybe<Order_By>;
  casing_griffith_wallis?: InputMaybe<Order_By>;
  casing_hazen_williams_coefficient?: InputMaybe<Order_By>;
  casing_palmer_correction?: InputMaybe<Order_By>;
  casing_roughness_inches?: InputMaybe<Order_By>;
  cloned_from_journal_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  dead_oil?: InputMaybe<Order_By>;
  dead_oil_option?: InputMaybe<Dead_Oil_Options_Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  friction_loss?: InputMaybe<Order_By>;
  gas_compressibility?: InputMaybe<Order_By>;
  gas_compressibility_option?: InputMaybe<Gas_Compressibility_Options_Order_By>;
  gas_viscosity?: InputMaybe<Order_By>;
  gas_viscosity_option?: InputMaybe<Gas_Viscosity_Options_Order_By>;
  id?: InputMaybe<Order_By>;
  journal_id?: InputMaybe<Order_By>;
  natural_gas_separation?: InputMaybe<Order_By>;
  oil_density?: InputMaybe<Order_By>;
  oil_density_option?: InputMaybe<Oil_Density_Options_Order_By>;
  oil_volume_factor_saturated?: InputMaybe<Order_By>;
  oil_volume_factor_saturated_option?: InputMaybe<Oil_Volume_Factor_Options_Order_By>;
  oil_volume_factor_undersaturated?: InputMaybe<Order_By>;
  oil_volume_factor_undersaturated_option?: InputMaybe<Oil_Volume_Factor_Options_Order_By>;
  parent_revision_id?: InputMaybe<Order_By>;
  salinity_ppm?: InputMaybe<Order_By>;
  saturated_oil?: InputMaybe<Order_By>;
  saturated_oil_option?: InputMaybe<Saturated_Oil_Options_Order_By>;
  scenario_correlations_journal?: InputMaybe<Revisions_Scenario_Correlations_Journal_Order_By>;
  scenario_correlations_journals_aggregate?: InputMaybe<Revisions_Scenario_Correlations_Journal_Aggregate_Order_By>;
  scenario_correlations_revision?: InputMaybe<Revisions_Scenario_Correlations_Revisions_Order_By>;
  scenario_correlations_revisions_aggregate?: InputMaybe<Revisions_Scenario_Correlations_Revisions_Aggregate_Order_By>;
  scenario_correlations_view?: InputMaybe<Scenario_Correlations_Order_By>;
  solution_gas_oil_ratio_option?: InputMaybe<Solution_Gas_Oil_Ratio_Options_Order_By>;
  solution_gor?: InputMaybe<Order_By>;
  tdh_tuning_factor_ratio?: InputMaybe<Order_By>;
  tubing_apply_hazen_williams_correction?: InputMaybe<Order_By>;
  tubing_flow?: InputMaybe<Order_By>;
  tubing_flow_option?: InputMaybe<Tubing_Flow_Options_Order_By>;
  tubing_griffith_wallis?: InputMaybe<Order_By>;
  tubing_hazen_williams_coefficient?: InputMaybe<Order_By>;
  tubing_palmer_correction?: InputMaybe<Order_By>;
  tubing_roughness_inches?: InputMaybe<Order_By>;
  under_saturated_oil?: InputMaybe<Order_By>;
  under_saturated_oil_option?: InputMaybe<Under_Saturated_Oil_Options_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  water_density?: InputMaybe<Order_By>;
  water_solution_gas?: InputMaybe<Order_By>;
  water_viscosity?: InputMaybe<Order_By>;
  water_viscosity_option?: InputMaybe<Water_Viscosity_Options_Order_By>;
  water_volume_factor?: InputMaybe<Order_By>;
  water_volume_factor_option?: InputMaybe<Water_Volume_Factor_Options_Order_By>;
};

/** primary key columns input for table: revisions.scenario_correlations_revisions */
export type Revisions_Scenario_Correlations_Revisions_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "revisions.scenario_correlations_revisions" */
export enum Revisions_Scenario_Correlations_Revisions_Select_Column {
  /** column name */
  AuthorId = 'author_id',
  /** column name */
  BubblePoint = 'bubble_point',
  /** column name */
  CasingApplyHazenWilliamsCorrection = 'casing_apply_hazen_williams_correction',
  /** column name */
  CasingFlow = 'casing_flow',
  /** column name */
  CasingGriffithWallis = 'casing_griffith_wallis',
  /** column name */
  CasingHazenWilliamsCoefficient = 'casing_hazen_williams_coefficient',
  /** column name */
  CasingPalmerCorrection = 'casing_palmer_correction',
  /** column name */
  CasingRoughnessInches = 'casing_roughness_inches',
  /** column name */
  ClonedFromJournalId = 'cloned_from_journal_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeadOil = 'dead_oil',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  FrictionLoss = 'friction_loss',
  /** column name */
  GasCompressibility = 'gas_compressibility',
  /** column name */
  GasViscosity = 'gas_viscosity',
  /** column name */
  Id = 'id',
  /** column name */
  JournalId = 'journal_id',
  /** column name */
  NaturalGasSeparation = 'natural_gas_separation',
  /** column name */
  OilDensity = 'oil_density',
  /** column name */
  OilVolumeFactorSaturated = 'oil_volume_factor_saturated',
  /** column name */
  OilVolumeFactorUndersaturated = 'oil_volume_factor_undersaturated',
  /** column name */
  ParentRevisionId = 'parent_revision_id',
  /** column name */
  SalinityPpm = 'salinity_ppm',
  /** column name */
  SaturatedOil = 'saturated_oil',
  /** column name */
  SolutionGor = 'solution_gor',
  /** column name */
  TdhTuningFactorRatio = 'tdh_tuning_factor_ratio',
  /** column name */
  TubingApplyHazenWilliamsCorrection = 'tubing_apply_hazen_williams_correction',
  /** column name */
  TubingFlow = 'tubing_flow',
  /** column name */
  TubingGriffithWallis = 'tubing_griffith_wallis',
  /** column name */
  TubingHazenWilliamsCoefficient = 'tubing_hazen_williams_coefficient',
  /** column name */
  TubingPalmerCorrection = 'tubing_palmer_correction',
  /** column name */
  TubingRoughnessInches = 'tubing_roughness_inches',
  /** column name */
  UnderSaturatedOil = 'under_saturated_oil',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WaterDensity = 'water_density',
  /** column name */
  WaterSolutionGas = 'water_solution_gas',
  /** column name */
  WaterViscosity = 'water_viscosity',
  /** column name */
  WaterVolumeFactor = 'water_volume_factor'
}

/** select "revisions_scenario_correlations_revisions_aggregate_bool_exp_bool_and_arguments_columns" columns of table "revisions.scenario_correlations_revisions" */
export enum Revisions_Scenario_Correlations_Revisions_Select_Column_Revisions_Scenario_Correlations_Revisions_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  CasingApplyHazenWilliamsCorrection = 'casing_apply_hazen_williams_correction',
  /** column name */
  CasingGriffithWallis = 'casing_griffith_wallis',
  /** column name */
  CasingPalmerCorrection = 'casing_palmer_correction',
  /** column name */
  TubingApplyHazenWilliamsCorrection = 'tubing_apply_hazen_williams_correction',
  /** column name */
  TubingGriffithWallis = 'tubing_griffith_wallis',
  /** column name */
  TubingPalmerCorrection = 'tubing_palmer_correction'
}

/** select "revisions_scenario_correlations_revisions_aggregate_bool_exp_bool_or_arguments_columns" columns of table "revisions.scenario_correlations_revisions" */
export enum Revisions_Scenario_Correlations_Revisions_Select_Column_Revisions_Scenario_Correlations_Revisions_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  CasingApplyHazenWilliamsCorrection = 'casing_apply_hazen_williams_correction',
  /** column name */
  CasingGriffithWallis = 'casing_griffith_wallis',
  /** column name */
  CasingPalmerCorrection = 'casing_palmer_correction',
  /** column name */
  TubingApplyHazenWilliamsCorrection = 'tubing_apply_hazen_williams_correction',
  /** column name */
  TubingGriffithWallis = 'tubing_griffith_wallis',
  /** column name */
  TubingPalmerCorrection = 'tubing_palmer_correction'
}

/** input type for updating data in table "revisions.scenario_correlations_revisions" */
export type Revisions_Scenario_Correlations_Revisions_Set_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  bubble_point?: InputMaybe<Bubble_Point_Options_Enum>;
  casing_apply_hazen_williams_correction?: InputMaybe<Scalars['Boolean']['input']>;
  casing_flow?: InputMaybe<Casing_Flow_Options_Enum>;
  casing_griffith_wallis?: InputMaybe<Scalars['Boolean']['input']>;
  casing_hazen_williams_coefficient?: InputMaybe<Scalars['numeric']['input']>;
  casing_palmer_correction?: InputMaybe<Scalars['Boolean']['input']>;
  casing_roughness_inches?: InputMaybe<Scalars['numeric']['input']>;
  cloned_from_journal_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  dead_oil?: InputMaybe<Dead_Oil_Options_Enum>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  friction_loss?: InputMaybe<Friction_Loss_Options_Enum>;
  gas_compressibility?: InputMaybe<Gas_Compressibility_Options_Enum>;
  gas_viscosity?: InputMaybe<Gas_Viscosity_Options_Enum>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  journal_id?: InputMaybe<Scalars['uuid']['input']>;
  natural_gas_separation?: InputMaybe<Natural_Gas_Separation_Options_Enum>;
  oil_density?: InputMaybe<Oil_Density_Options_Enum>;
  oil_volume_factor_saturated?: InputMaybe<Scalars['String']['input']>;
  oil_volume_factor_undersaturated?: InputMaybe<Oil_Volume_Factor_Options_Enum>;
  parent_revision_id?: InputMaybe<Scalars['uuid']['input']>;
  salinity_ppm?: InputMaybe<Scalars['numeric']['input']>;
  saturated_oil?: InputMaybe<Saturated_Oil_Options_Enum>;
  solution_gor?: InputMaybe<Solution_Gas_Oil_Ratio_Options_Enum>;
  tdh_tuning_factor_ratio?: InputMaybe<Scalars['numeric']['input']>;
  tubing_apply_hazen_williams_correction?: InputMaybe<Scalars['Boolean']['input']>;
  tubing_flow?: InputMaybe<Tubing_Flow_Options_Enum>;
  tubing_griffith_wallis?: InputMaybe<Scalars['Boolean']['input']>;
  tubing_hazen_williams_coefficient?: InputMaybe<Scalars['numeric']['input']>;
  tubing_palmer_correction?: InputMaybe<Scalars['Boolean']['input']>;
  tubing_roughness_inches?: InputMaybe<Scalars['numeric']['input']>;
  under_saturated_oil?: InputMaybe<Under_Saturated_Oil_Options_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  water_density?: InputMaybe<Water_Density_Options_Enum>;
  water_solution_gas?: InputMaybe<Water_Solution_Gas_Options_Enum>;
  water_viscosity?: InputMaybe<Water_Viscosity_Options_Enum>;
  water_volume_factor?: InputMaybe<Water_Volume_Factor_Options_Enum>;
};

/** aggregate stddev on columns */
export type Revisions_Scenario_Correlations_Revisions_Stddev_Fields = {
  __typename: 'revisions_scenario_correlations_revisions_stddev_fields';
  casing_hazen_williams_coefficient?: Maybe<Scalars['Float']['output']>;
  casing_roughness_inches?: Maybe<Scalars['Float']['output']>;
  salinity_ppm?: Maybe<Scalars['Float']['output']>;
  tdh_tuning_factor_ratio?: Maybe<Scalars['Float']['output']>;
  tubing_hazen_williams_coefficient?: Maybe<Scalars['Float']['output']>;
  tubing_roughness_inches?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "revisions.scenario_correlations_revisions" */
export type Revisions_Scenario_Correlations_Revisions_Stddev_Order_By = {
  casing_hazen_williams_coefficient?: InputMaybe<Order_By>;
  casing_roughness_inches?: InputMaybe<Order_By>;
  salinity_ppm?: InputMaybe<Order_By>;
  tdh_tuning_factor_ratio?: InputMaybe<Order_By>;
  tubing_hazen_williams_coefficient?: InputMaybe<Order_By>;
  tubing_roughness_inches?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Revisions_Scenario_Correlations_Revisions_Stddev_Pop_Fields = {
  __typename: 'revisions_scenario_correlations_revisions_stddev_pop_fields';
  casing_hazen_williams_coefficient?: Maybe<Scalars['Float']['output']>;
  casing_roughness_inches?: Maybe<Scalars['Float']['output']>;
  salinity_ppm?: Maybe<Scalars['Float']['output']>;
  tdh_tuning_factor_ratio?: Maybe<Scalars['Float']['output']>;
  tubing_hazen_williams_coefficient?: Maybe<Scalars['Float']['output']>;
  tubing_roughness_inches?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "revisions.scenario_correlations_revisions" */
export type Revisions_Scenario_Correlations_Revisions_Stddev_Pop_Order_By = {
  casing_hazen_williams_coefficient?: InputMaybe<Order_By>;
  casing_roughness_inches?: InputMaybe<Order_By>;
  salinity_ppm?: InputMaybe<Order_By>;
  tdh_tuning_factor_ratio?: InputMaybe<Order_By>;
  tubing_hazen_williams_coefficient?: InputMaybe<Order_By>;
  tubing_roughness_inches?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Revisions_Scenario_Correlations_Revisions_Stddev_Samp_Fields = {
  __typename: 'revisions_scenario_correlations_revisions_stddev_samp_fields';
  casing_hazen_williams_coefficient?: Maybe<Scalars['Float']['output']>;
  casing_roughness_inches?: Maybe<Scalars['Float']['output']>;
  salinity_ppm?: Maybe<Scalars['Float']['output']>;
  tdh_tuning_factor_ratio?: Maybe<Scalars['Float']['output']>;
  tubing_hazen_williams_coefficient?: Maybe<Scalars['Float']['output']>;
  tubing_roughness_inches?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "revisions.scenario_correlations_revisions" */
export type Revisions_Scenario_Correlations_Revisions_Stddev_Samp_Order_By = {
  casing_hazen_williams_coefficient?: InputMaybe<Order_By>;
  casing_roughness_inches?: InputMaybe<Order_By>;
  salinity_ppm?: InputMaybe<Order_By>;
  tdh_tuning_factor_ratio?: InputMaybe<Order_By>;
  tubing_hazen_williams_coefficient?: InputMaybe<Order_By>;
  tubing_roughness_inches?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "revisions_scenario_correlations_revisions" */
export type Revisions_Scenario_Correlations_Revisions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Revisions_Scenario_Correlations_Revisions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Revisions_Scenario_Correlations_Revisions_Stream_Cursor_Value_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  bubble_point?: InputMaybe<Bubble_Point_Options_Enum>;
  casing_apply_hazen_williams_correction?: InputMaybe<Scalars['Boolean']['input']>;
  casing_flow?: InputMaybe<Casing_Flow_Options_Enum>;
  casing_griffith_wallis?: InputMaybe<Scalars['Boolean']['input']>;
  casing_hazen_williams_coefficient?: InputMaybe<Scalars['numeric']['input']>;
  casing_palmer_correction?: InputMaybe<Scalars['Boolean']['input']>;
  casing_roughness_inches?: InputMaybe<Scalars['numeric']['input']>;
  cloned_from_journal_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  dead_oil?: InputMaybe<Dead_Oil_Options_Enum>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  friction_loss?: InputMaybe<Friction_Loss_Options_Enum>;
  gas_compressibility?: InputMaybe<Gas_Compressibility_Options_Enum>;
  gas_viscosity?: InputMaybe<Gas_Viscosity_Options_Enum>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  journal_id?: InputMaybe<Scalars['uuid']['input']>;
  natural_gas_separation?: InputMaybe<Natural_Gas_Separation_Options_Enum>;
  oil_density?: InputMaybe<Oil_Density_Options_Enum>;
  oil_volume_factor_saturated?: InputMaybe<Scalars['String']['input']>;
  oil_volume_factor_undersaturated?: InputMaybe<Oil_Volume_Factor_Options_Enum>;
  parent_revision_id?: InputMaybe<Scalars['uuid']['input']>;
  salinity_ppm?: InputMaybe<Scalars['numeric']['input']>;
  saturated_oil?: InputMaybe<Saturated_Oil_Options_Enum>;
  solution_gor?: InputMaybe<Solution_Gas_Oil_Ratio_Options_Enum>;
  tdh_tuning_factor_ratio?: InputMaybe<Scalars['numeric']['input']>;
  tubing_apply_hazen_williams_correction?: InputMaybe<Scalars['Boolean']['input']>;
  tubing_flow?: InputMaybe<Tubing_Flow_Options_Enum>;
  tubing_griffith_wallis?: InputMaybe<Scalars['Boolean']['input']>;
  tubing_hazen_williams_coefficient?: InputMaybe<Scalars['numeric']['input']>;
  tubing_palmer_correction?: InputMaybe<Scalars['Boolean']['input']>;
  tubing_roughness_inches?: InputMaybe<Scalars['numeric']['input']>;
  under_saturated_oil?: InputMaybe<Under_Saturated_Oil_Options_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  water_density?: InputMaybe<Water_Density_Options_Enum>;
  water_solution_gas?: InputMaybe<Water_Solution_Gas_Options_Enum>;
  water_viscosity?: InputMaybe<Water_Viscosity_Options_Enum>;
  water_volume_factor?: InputMaybe<Water_Volume_Factor_Options_Enum>;
};

/** aggregate sum on columns */
export type Revisions_Scenario_Correlations_Revisions_Sum_Fields = {
  __typename: 'revisions_scenario_correlations_revisions_sum_fields';
  casing_hazen_williams_coefficient?: Maybe<Scalars['numeric']['output']>;
  casing_roughness_inches?: Maybe<Scalars['numeric']['output']>;
  salinity_ppm?: Maybe<Scalars['numeric']['output']>;
  tdh_tuning_factor_ratio?: Maybe<Scalars['numeric']['output']>;
  tubing_hazen_williams_coefficient?: Maybe<Scalars['numeric']['output']>;
  tubing_roughness_inches?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "revisions.scenario_correlations_revisions" */
export type Revisions_Scenario_Correlations_Revisions_Sum_Order_By = {
  casing_hazen_williams_coefficient?: InputMaybe<Order_By>;
  casing_roughness_inches?: InputMaybe<Order_By>;
  salinity_ppm?: InputMaybe<Order_By>;
  tdh_tuning_factor_ratio?: InputMaybe<Order_By>;
  tubing_hazen_williams_coefficient?: InputMaybe<Order_By>;
  tubing_roughness_inches?: InputMaybe<Order_By>;
};

/** update columns of table "revisions.scenario_correlations_revisions" */
export enum Revisions_Scenario_Correlations_Revisions_Update_Column {
  /** column name */
  AuthorId = 'author_id',
  /** column name */
  BubblePoint = 'bubble_point',
  /** column name */
  CasingApplyHazenWilliamsCorrection = 'casing_apply_hazen_williams_correction',
  /** column name */
  CasingFlow = 'casing_flow',
  /** column name */
  CasingGriffithWallis = 'casing_griffith_wallis',
  /** column name */
  CasingHazenWilliamsCoefficient = 'casing_hazen_williams_coefficient',
  /** column name */
  CasingPalmerCorrection = 'casing_palmer_correction',
  /** column name */
  CasingRoughnessInches = 'casing_roughness_inches',
  /** column name */
  ClonedFromJournalId = 'cloned_from_journal_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeadOil = 'dead_oil',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  FrictionLoss = 'friction_loss',
  /** column name */
  GasCompressibility = 'gas_compressibility',
  /** column name */
  GasViscosity = 'gas_viscosity',
  /** column name */
  Id = 'id',
  /** column name */
  JournalId = 'journal_id',
  /** column name */
  NaturalGasSeparation = 'natural_gas_separation',
  /** column name */
  OilDensity = 'oil_density',
  /** column name */
  OilVolumeFactorSaturated = 'oil_volume_factor_saturated',
  /** column name */
  OilVolumeFactorUndersaturated = 'oil_volume_factor_undersaturated',
  /** column name */
  ParentRevisionId = 'parent_revision_id',
  /** column name */
  SalinityPpm = 'salinity_ppm',
  /** column name */
  SaturatedOil = 'saturated_oil',
  /** column name */
  SolutionGor = 'solution_gor',
  /** column name */
  TdhTuningFactorRatio = 'tdh_tuning_factor_ratio',
  /** column name */
  TubingApplyHazenWilliamsCorrection = 'tubing_apply_hazen_williams_correction',
  /** column name */
  TubingFlow = 'tubing_flow',
  /** column name */
  TubingGriffithWallis = 'tubing_griffith_wallis',
  /** column name */
  TubingHazenWilliamsCoefficient = 'tubing_hazen_williams_coefficient',
  /** column name */
  TubingPalmerCorrection = 'tubing_palmer_correction',
  /** column name */
  TubingRoughnessInches = 'tubing_roughness_inches',
  /** column name */
  UnderSaturatedOil = 'under_saturated_oil',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WaterDensity = 'water_density',
  /** column name */
  WaterSolutionGas = 'water_solution_gas',
  /** column name */
  WaterViscosity = 'water_viscosity',
  /** column name */
  WaterVolumeFactor = 'water_volume_factor'
}

export type Revisions_Scenario_Correlations_Revisions_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Revisions_Scenario_Correlations_Revisions_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Revisions_Scenario_Correlations_Revisions_Set_Input>;
  /** filter the rows which have to be updated */
  where: Revisions_Scenario_Correlations_Revisions_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Revisions_Scenario_Correlations_Revisions_Var_Pop_Fields = {
  __typename: 'revisions_scenario_correlations_revisions_var_pop_fields';
  casing_hazen_williams_coefficient?: Maybe<Scalars['Float']['output']>;
  casing_roughness_inches?: Maybe<Scalars['Float']['output']>;
  salinity_ppm?: Maybe<Scalars['Float']['output']>;
  tdh_tuning_factor_ratio?: Maybe<Scalars['Float']['output']>;
  tubing_hazen_williams_coefficient?: Maybe<Scalars['Float']['output']>;
  tubing_roughness_inches?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "revisions.scenario_correlations_revisions" */
export type Revisions_Scenario_Correlations_Revisions_Var_Pop_Order_By = {
  casing_hazen_williams_coefficient?: InputMaybe<Order_By>;
  casing_roughness_inches?: InputMaybe<Order_By>;
  salinity_ppm?: InputMaybe<Order_By>;
  tdh_tuning_factor_ratio?: InputMaybe<Order_By>;
  tubing_hazen_williams_coefficient?: InputMaybe<Order_By>;
  tubing_roughness_inches?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Revisions_Scenario_Correlations_Revisions_Var_Samp_Fields = {
  __typename: 'revisions_scenario_correlations_revisions_var_samp_fields';
  casing_hazen_williams_coefficient?: Maybe<Scalars['Float']['output']>;
  casing_roughness_inches?: Maybe<Scalars['Float']['output']>;
  salinity_ppm?: Maybe<Scalars['Float']['output']>;
  tdh_tuning_factor_ratio?: Maybe<Scalars['Float']['output']>;
  tubing_hazen_williams_coefficient?: Maybe<Scalars['Float']['output']>;
  tubing_roughness_inches?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "revisions.scenario_correlations_revisions" */
export type Revisions_Scenario_Correlations_Revisions_Var_Samp_Order_By = {
  casing_hazen_williams_coefficient?: InputMaybe<Order_By>;
  casing_roughness_inches?: InputMaybe<Order_By>;
  salinity_ppm?: InputMaybe<Order_By>;
  tdh_tuning_factor_ratio?: InputMaybe<Order_By>;
  tubing_hazen_williams_coefficient?: InputMaybe<Order_By>;
  tubing_roughness_inches?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Revisions_Scenario_Correlations_Revisions_Variance_Fields = {
  __typename: 'revisions_scenario_correlations_revisions_variance_fields';
  casing_hazen_williams_coefficient?: Maybe<Scalars['Float']['output']>;
  casing_roughness_inches?: Maybe<Scalars['Float']['output']>;
  salinity_ppm?: Maybe<Scalars['Float']['output']>;
  tdh_tuning_factor_ratio?: Maybe<Scalars['Float']['output']>;
  tubing_hazen_williams_coefficient?: Maybe<Scalars['Float']['output']>;
  tubing_roughness_inches?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "revisions.scenario_correlations_revisions" */
export type Revisions_Scenario_Correlations_Revisions_Variance_Order_By = {
  casing_hazen_williams_coefficient?: InputMaybe<Order_By>;
  casing_roughness_inches?: InputMaybe<Order_By>;
  salinity_ppm?: InputMaybe<Order_By>;
  tdh_tuning_factor_ratio?: InputMaybe<Order_By>;
  tubing_hazen_williams_coefficient?: InputMaybe<Order_By>;
  tubing_roughness_inches?: InputMaybe<Order_By>;
};

/** columns and relationships of "revisions.scenario_equipment_journal" */
export type Revisions_Scenario_Equipment_Journal = {
  __typename: 'revisions_scenario_equipment_journal';
  author_id: Scalars['String']['output'];
  created_at: Scalars['timestamptz']['output'];
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  parent_journal_id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  sc_equip_xref_downhole_ytool_bypass_tubings_revisions: Array<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions>;
  /** An aggregate relationship */
  sc_equip_xref_downhole_ytool_bypass_tubings_revisions_aggregate: Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Aggregate;
  /** An array relationship */
  sc_equip_xref_downhole_ytool_equip_tubings_revisions: Array<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions>;
  /** An aggregate relationship */
  sc_equip_xref_downhole_ytool_equip_tubings_revisions_aggregate: Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Aggregate;
  /** An array relationship */
  sc_equip_xref_uphole_ytool_bypass_tubings_revisions: Array<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions>;
  /** An aggregate relationship */
  sc_equip_xref_uphole_ytool_bypass_tubings_revisions_aggregate: Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Aggregate;
  /** An array relationship */
  sc_equip_xref_uphole_ytool_equip_tubings_revisions: Array<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions>;
  /** An aggregate relationship */
  sc_equip_xref_uphole_ytool_equip_tubings_revisions_aggregate: Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Aggregate;
  /** An object relationship */
  scenario_equipment_journal?: Maybe<Revisions_Scenario_Equipment_Journal>;
  /** An array relationship */
  scenario_equipment_journals: Array<Revisions_Scenario_Equipment_Journal>;
  /** An aggregate relationship */
  scenario_equipment_journals_aggregate: Revisions_Scenario_Equipment_Journal_Aggregate;
  /** An object relationship */
  scenario_equipment_revision?: Maybe<Revisions_Scenario_Equipment_Revisions>;
  /** An array relationship */
  scenario_equipment_revisions: Array<Revisions_Scenario_Equipment_Revisions>;
  /** An aggregate relationship */
  scenario_equipment_revisions_aggregate: Revisions_Scenario_Equipment_Revisions_Aggregate;
  /** An array relationship */
  scenario_equipment_xref_cables_revisions: Array<Revisions_Scenario_Equipment_Xref_Cables_Revisions>;
  /** An aggregate relationship */
  scenario_equipment_xref_cables_revisions_aggregate: Revisions_Scenario_Equipment_Xref_Cables_Revisions_Aggregate;
  /** An array relationship */
  scenario_equipment_xref_intakes_revisions: Array<Revisions_Scenario_Equipment_Xref_Intakes_Revisions>;
  /** An aggregate relationship */
  scenario_equipment_xref_intakes_revisions_aggregate: Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Aggregate;
  /** An array relationship */
  scenario_equipment_xref_pumps_revisions: Array<Revisions_Scenario_Equipment_Xref_Pumps_Revisions>;
  /** An aggregate relationship */
  scenario_equipment_xref_pumps_revisions_aggregate: Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Aggregate;
  /** An array relationship */
  scenario_equipment_xref_seals_revisions: Array<Revisions_Scenario_Equipment_Xref_Seals_Revisions>;
  /** An aggregate relationship */
  scenario_equipment_xref_seals_revisions_aggregate: Revisions_Scenario_Equipment_Xref_Seals_Revisions_Aggregate;
  /** An array relationship */
  scenarios_revisions: Array<Revisions_Scenarios_Revisions>;
  /** An aggregate relationship */
  scenarios_revisions_aggregate: Revisions_Scenarios_Revisions_Aggregate;
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Users;
  winning_revision_id?: Maybe<Scalars['uuid']['output']>;
};


/** columns and relationships of "revisions.scenario_equipment_journal" */
export type Revisions_Scenario_Equipment_JournalSc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_RevisionsArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Bool_Exp>;
};


/** columns and relationships of "revisions.scenario_equipment_journal" */
export type Revisions_Scenario_Equipment_JournalSc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Bool_Exp>;
};


/** columns and relationships of "revisions.scenario_equipment_journal" */
export type Revisions_Scenario_Equipment_JournalSc_Equip_Xref_Downhole_Ytool_Equip_Tubings_RevisionsArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Bool_Exp>;
};


/** columns and relationships of "revisions.scenario_equipment_journal" */
export type Revisions_Scenario_Equipment_JournalSc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Bool_Exp>;
};


/** columns and relationships of "revisions.scenario_equipment_journal" */
export type Revisions_Scenario_Equipment_JournalSc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_RevisionsArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Bool_Exp>;
};


/** columns and relationships of "revisions.scenario_equipment_journal" */
export type Revisions_Scenario_Equipment_JournalSc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Bool_Exp>;
};


/** columns and relationships of "revisions.scenario_equipment_journal" */
export type Revisions_Scenario_Equipment_JournalSc_Equip_Xref_Uphole_Ytool_Equip_Tubings_RevisionsArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Bool_Exp>;
};


/** columns and relationships of "revisions.scenario_equipment_journal" */
export type Revisions_Scenario_Equipment_JournalSc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Bool_Exp>;
};


/** columns and relationships of "revisions.scenario_equipment_journal" */
export type Revisions_Scenario_Equipment_JournalScenario_Equipment_JournalsArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Equipment_Journal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Equipment_Journal_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Equipment_Journal_Bool_Exp>;
};


/** columns and relationships of "revisions.scenario_equipment_journal" */
export type Revisions_Scenario_Equipment_JournalScenario_Equipment_Journals_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Equipment_Journal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Equipment_Journal_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Equipment_Journal_Bool_Exp>;
};


/** columns and relationships of "revisions.scenario_equipment_journal" */
export type Revisions_Scenario_Equipment_JournalScenario_Equipment_RevisionsArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Equipment_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Equipment_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Equipment_Revisions_Bool_Exp>;
};


/** columns and relationships of "revisions.scenario_equipment_journal" */
export type Revisions_Scenario_Equipment_JournalScenario_Equipment_Revisions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Equipment_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Equipment_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Equipment_Revisions_Bool_Exp>;
};


/** columns and relationships of "revisions.scenario_equipment_journal" */
export type Revisions_Scenario_Equipment_JournalScenario_Equipment_Xref_Cables_RevisionsArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Bool_Exp>;
};


/** columns and relationships of "revisions.scenario_equipment_journal" */
export type Revisions_Scenario_Equipment_JournalScenario_Equipment_Xref_Cables_Revisions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Bool_Exp>;
};


/** columns and relationships of "revisions.scenario_equipment_journal" */
export type Revisions_Scenario_Equipment_JournalScenario_Equipment_Xref_Intakes_RevisionsArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Bool_Exp>;
};


/** columns and relationships of "revisions.scenario_equipment_journal" */
export type Revisions_Scenario_Equipment_JournalScenario_Equipment_Xref_Intakes_Revisions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Bool_Exp>;
};


/** columns and relationships of "revisions.scenario_equipment_journal" */
export type Revisions_Scenario_Equipment_JournalScenario_Equipment_Xref_Pumps_RevisionsArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Bool_Exp>;
};


/** columns and relationships of "revisions.scenario_equipment_journal" */
export type Revisions_Scenario_Equipment_JournalScenario_Equipment_Xref_Pumps_Revisions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Bool_Exp>;
};


/** columns and relationships of "revisions.scenario_equipment_journal" */
export type Revisions_Scenario_Equipment_JournalScenario_Equipment_Xref_Seals_RevisionsArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Seals_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Seals_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Equipment_Xref_Seals_Revisions_Bool_Exp>;
};


/** columns and relationships of "revisions.scenario_equipment_journal" */
export type Revisions_Scenario_Equipment_JournalScenario_Equipment_Xref_Seals_Revisions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Seals_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Seals_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Equipment_Xref_Seals_Revisions_Bool_Exp>;
};


/** columns and relationships of "revisions.scenario_equipment_journal" */
export type Revisions_Scenario_Equipment_JournalScenarios_RevisionsArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenarios_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenarios_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Scenarios_Revisions_Bool_Exp>;
};


/** columns and relationships of "revisions.scenario_equipment_journal" */
export type Revisions_Scenario_Equipment_JournalScenarios_Revisions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenarios_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenarios_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Scenarios_Revisions_Bool_Exp>;
};

/** aggregated selection of "revisions.scenario_equipment_journal" */
export type Revisions_Scenario_Equipment_Journal_Aggregate = {
  __typename: 'revisions_scenario_equipment_journal_aggregate';
  aggregate?: Maybe<Revisions_Scenario_Equipment_Journal_Aggregate_Fields>;
  nodes: Array<Revisions_Scenario_Equipment_Journal>;
};

export type Revisions_Scenario_Equipment_Journal_Aggregate_Bool_Exp = {
  count?: InputMaybe<Revisions_Scenario_Equipment_Journal_Aggregate_Bool_Exp_Count>;
};

export type Revisions_Scenario_Equipment_Journal_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Revisions_Scenario_Equipment_Journal_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Revisions_Scenario_Equipment_Journal_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "revisions.scenario_equipment_journal" */
export type Revisions_Scenario_Equipment_Journal_Aggregate_Fields = {
  __typename: 'revisions_scenario_equipment_journal_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Revisions_Scenario_Equipment_Journal_Max_Fields>;
  min?: Maybe<Revisions_Scenario_Equipment_Journal_Min_Fields>;
};


/** aggregate fields of "revisions.scenario_equipment_journal" */
export type Revisions_Scenario_Equipment_Journal_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Revisions_Scenario_Equipment_Journal_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "revisions.scenario_equipment_journal" */
export type Revisions_Scenario_Equipment_Journal_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Revisions_Scenario_Equipment_Journal_Max_Order_By>;
  min?: InputMaybe<Revisions_Scenario_Equipment_Journal_Min_Order_By>;
};

/** input type for inserting array relation for remote table "revisions.scenario_equipment_journal" */
export type Revisions_Scenario_Equipment_Journal_Arr_Rel_Insert_Input = {
  data: Array<Revisions_Scenario_Equipment_Journal_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Revisions_Scenario_Equipment_Journal_On_Conflict>;
};

/** Boolean expression to filter rows from the table "revisions.scenario_equipment_journal". All fields are combined with a logical 'AND'. */
export type Revisions_Scenario_Equipment_Journal_Bool_Exp = {
  _and?: InputMaybe<Array<Revisions_Scenario_Equipment_Journal_Bool_Exp>>;
  _not?: InputMaybe<Revisions_Scenario_Equipment_Journal_Bool_Exp>;
  _or?: InputMaybe<Array<Revisions_Scenario_Equipment_Journal_Bool_Exp>>;
  author_id?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  parent_journal_id?: InputMaybe<Uuid_Comparison_Exp>;
  sc_equip_xref_downhole_ytool_bypass_tubings_revisions?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Bool_Exp>;
  sc_equip_xref_downhole_ytool_bypass_tubings_revisions_aggregate?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Aggregate_Bool_Exp>;
  sc_equip_xref_downhole_ytool_equip_tubings_revisions?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Bool_Exp>;
  sc_equip_xref_downhole_ytool_equip_tubings_revisions_aggregate?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Aggregate_Bool_Exp>;
  sc_equip_xref_uphole_ytool_bypass_tubings_revisions?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Bool_Exp>;
  sc_equip_xref_uphole_ytool_bypass_tubings_revisions_aggregate?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Aggregate_Bool_Exp>;
  sc_equip_xref_uphole_ytool_equip_tubings_revisions?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Bool_Exp>;
  sc_equip_xref_uphole_ytool_equip_tubings_revisions_aggregate?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Aggregate_Bool_Exp>;
  scenario_equipment_journal?: InputMaybe<Revisions_Scenario_Equipment_Journal_Bool_Exp>;
  scenario_equipment_journals?: InputMaybe<Revisions_Scenario_Equipment_Journal_Bool_Exp>;
  scenario_equipment_journals_aggregate?: InputMaybe<Revisions_Scenario_Equipment_Journal_Aggregate_Bool_Exp>;
  scenario_equipment_revision?: InputMaybe<Revisions_Scenario_Equipment_Revisions_Bool_Exp>;
  scenario_equipment_revisions?: InputMaybe<Revisions_Scenario_Equipment_Revisions_Bool_Exp>;
  scenario_equipment_revisions_aggregate?: InputMaybe<Revisions_Scenario_Equipment_Revisions_Aggregate_Bool_Exp>;
  scenario_equipment_xref_cables_revisions?: InputMaybe<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Bool_Exp>;
  scenario_equipment_xref_cables_revisions_aggregate?: InputMaybe<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Aggregate_Bool_Exp>;
  scenario_equipment_xref_intakes_revisions?: InputMaybe<Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Bool_Exp>;
  scenario_equipment_xref_intakes_revisions_aggregate?: InputMaybe<Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Aggregate_Bool_Exp>;
  scenario_equipment_xref_pumps_revisions?: InputMaybe<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Bool_Exp>;
  scenario_equipment_xref_pumps_revisions_aggregate?: InputMaybe<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Aggregate_Bool_Exp>;
  scenario_equipment_xref_seals_revisions?: InputMaybe<Revisions_Scenario_Equipment_Xref_Seals_Revisions_Bool_Exp>;
  scenario_equipment_xref_seals_revisions_aggregate?: InputMaybe<Revisions_Scenario_Equipment_Xref_Seals_Revisions_Aggregate_Bool_Exp>;
  scenarios_revisions?: InputMaybe<Revisions_Scenarios_Revisions_Bool_Exp>;
  scenarios_revisions_aggregate?: InputMaybe<Revisions_Scenarios_Revisions_Aggregate_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  winning_revision_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "revisions.scenario_equipment_journal" */
export enum Revisions_Scenario_Equipment_Journal_Constraint {
  /** unique or primary key constraint on columns "id" */
  ScenarioEquipmentJournalPkey = 'scenario_equipment_journal_pkey'
}

/** input type for inserting data into table "revisions.scenario_equipment_journal" */
export type Revisions_Scenario_Equipment_Journal_Insert_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  parent_journal_id?: InputMaybe<Scalars['uuid']['input']>;
  sc_equip_xref_downhole_ytool_bypass_tubings_revisions?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Arr_Rel_Insert_Input>;
  sc_equip_xref_downhole_ytool_equip_tubings_revisions?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Arr_Rel_Insert_Input>;
  sc_equip_xref_uphole_ytool_bypass_tubings_revisions?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Arr_Rel_Insert_Input>;
  sc_equip_xref_uphole_ytool_equip_tubings_revisions?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Arr_Rel_Insert_Input>;
  scenario_equipment_journal?: InputMaybe<Revisions_Scenario_Equipment_Journal_Obj_Rel_Insert_Input>;
  scenario_equipment_journals?: InputMaybe<Revisions_Scenario_Equipment_Journal_Arr_Rel_Insert_Input>;
  scenario_equipment_revision?: InputMaybe<Revisions_Scenario_Equipment_Revisions_Obj_Rel_Insert_Input>;
  scenario_equipment_revisions?: InputMaybe<Revisions_Scenario_Equipment_Revisions_Arr_Rel_Insert_Input>;
  scenario_equipment_xref_cables_revisions?: InputMaybe<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Arr_Rel_Insert_Input>;
  scenario_equipment_xref_intakes_revisions?: InputMaybe<Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Arr_Rel_Insert_Input>;
  scenario_equipment_xref_pumps_revisions?: InputMaybe<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Arr_Rel_Insert_Input>;
  scenario_equipment_xref_seals_revisions?: InputMaybe<Revisions_Scenario_Equipment_Xref_Seals_Revisions_Arr_Rel_Insert_Input>;
  scenarios_revisions?: InputMaybe<Revisions_Scenarios_Revisions_Arr_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  winning_revision_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Revisions_Scenario_Equipment_Journal_Max_Fields = {
  __typename: 'revisions_scenario_equipment_journal_max_fields';
  author_id?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  parent_journal_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  winning_revision_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "revisions.scenario_equipment_journal" */
export type Revisions_Scenario_Equipment_Journal_Max_Order_By = {
  author_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parent_journal_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  winning_revision_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Revisions_Scenario_Equipment_Journal_Min_Fields = {
  __typename: 'revisions_scenario_equipment_journal_min_fields';
  author_id?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  parent_journal_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  winning_revision_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "revisions.scenario_equipment_journal" */
export type Revisions_Scenario_Equipment_Journal_Min_Order_By = {
  author_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parent_journal_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  winning_revision_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "revisions.scenario_equipment_journal" */
export type Revisions_Scenario_Equipment_Journal_Mutation_Response = {
  __typename: 'revisions_scenario_equipment_journal_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Revisions_Scenario_Equipment_Journal>;
};

/** input type for inserting object relation for remote table "revisions.scenario_equipment_journal" */
export type Revisions_Scenario_Equipment_Journal_Obj_Rel_Insert_Input = {
  data: Revisions_Scenario_Equipment_Journal_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Revisions_Scenario_Equipment_Journal_On_Conflict>;
};

/** on_conflict condition type for table "revisions.scenario_equipment_journal" */
export type Revisions_Scenario_Equipment_Journal_On_Conflict = {
  constraint: Revisions_Scenario_Equipment_Journal_Constraint;
  update_columns?: Array<Revisions_Scenario_Equipment_Journal_Update_Column>;
  where?: InputMaybe<Revisions_Scenario_Equipment_Journal_Bool_Exp>;
};

/** Ordering options when selecting data from "revisions.scenario_equipment_journal". */
export type Revisions_Scenario_Equipment_Journal_Order_By = {
  author_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parent_journal_id?: InputMaybe<Order_By>;
  sc_equip_xref_downhole_ytool_bypass_tubings_revisions_aggregate?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Aggregate_Order_By>;
  sc_equip_xref_downhole_ytool_equip_tubings_revisions_aggregate?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Aggregate_Order_By>;
  sc_equip_xref_uphole_ytool_bypass_tubings_revisions_aggregate?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Aggregate_Order_By>;
  sc_equip_xref_uphole_ytool_equip_tubings_revisions_aggregate?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Aggregate_Order_By>;
  scenario_equipment_journal?: InputMaybe<Revisions_Scenario_Equipment_Journal_Order_By>;
  scenario_equipment_journals_aggregate?: InputMaybe<Revisions_Scenario_Equipment_Journal_Aggregate_Order_By>;
  scenario_equipment_revision?: InputMaybe<Revisions_Scenario_Equipment_Revisions_Order_By>;
  scenario_equipment_revisions_aggregate?: InputMaybe<Revisions_Scenario_Equipment_Revisions_Aggregate_Order_By>;
  scenario_equipment_xref_cables_revisions_aggregate?: InputMaybe<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Aggregate_Order_By>;
  scenario_equipment_xref_intakes_revisions_aggregate?: InputMaybe<Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Aggregate_Order_By>;
  scenario_equipment_xref_pumps_revisions_aggregate?: InputMaybe<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Aggregate_Order_By>;
  scenario_equipment_xref_seals_revisions_aggregate?: InputMaybe<Revisions_Scenario_Equipment_Xref_Seals_Revisions_Aggregate_Order_By>;
  scenarios_revisions_aggregate?: InputMaybe<Revisions_Scenarios_Revisions_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  winning_revision_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: revisions.scenario_equipment_journal */
export type Revisions_Scenario_Equipment_Journal_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "revisions.scenario_equipment_journal" */
export enum Revisions_Scenario_Equipment_Journal_Select_Column {
  /** column name */
  AuthorId = 'author_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  ParentJournalId = 'parent_journal_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WinningRevisionId = 'winning_revision_id'
}

/** input type for updating data in table "revisions.scenario_equipment_journal" */
export type Revisions_Scenario_Equipment_Journal_Set_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  parent_journal_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  winning_revision_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "revisions_scenario_equipment_journal" */
export type Revisions_Scenario_Equipment_Journal_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Revisions_Scenario_Equipment_Journal_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Revisions_Scenario_Equipment_Journal_Stream_Cursor_Value_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  parent_journal_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  winning_revision_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "revisions.scenario_equipment_journal" */
export enum Revisions_Scenario_Equipment_Journal_Update_Column {
  /** column name */
  AuthorId = 'author_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  ParentJournalId = 'parent_journal_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WinningRevisionId = 'winning_revision_id'
}

export type Revisions_Scenario_Equipment_Journal_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Revisions_Scenario_Equipment_Journal_Set_Input>;
  /** filter the rows which have to be updated */
  where: Revisions_Scenario_Equipment_Journal_Bool_Exp;
};

/** columns and relationships of "revisions.scenario_equipment_revisions" */
export type Revisions_Scenario_Equipment_Revisions = {
  __typename: 'revisions_scenario_equipment_revisions';
  author_id: Scalars['String']['output'];
  bolt_on_discharge_id?: Maybe<Scalars['uuid']['output']>;
  cables_order: Array<Scalars['uuid']['output']>;
  cloned_from_journal_id?: Maybe<Scalars['uuid']['output']>;
  created_at: Scalars['timestamptz']['output'];
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  down_trans_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  downhole_y_tool?: Maybe<Y_Tools>;
  downhole_y_tool_bypass_tubing_order?: Maybe<Array<Scalars['uuid']['output']>>;
  downhole_y_tool_equipment_tubing_order?: Maybe<Array<Scalars['uuid']['output']>>;
  downhole_y_tool_id?: Maybe<Scalars['uuid']['output']>;
  has_lower_equip_stack?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['uuid']['output'];
  include_y_tool?: Maybe<Scalars['Boolean']['output']>;
  intakes_order: Array<Scalars['uuid']['output']>;
  journal_id: Scalars['uuid']['output'];
  lower_bolt_on_discharge_id?: Maybe<Scalars['uuid']['output']>;
  lower_cables_order?: Maybe<Array<Scalars['uuid']['output']>>;
  lower_intakes_order?: Maybe<Array<Scalars['uuid']['output']>>;
  lower_mle_id?: Maybe<Scalars['uuid']['output']>;
  lower_motor_id?: Maybe<Scalars['uuid']['output']>;
  lower_pumps_order?: Maybe<Array<Scalars['uuid']['output']>>;
  lower_seal_motor_oil_id?: Maybe<Scalars['uuid']['output']>;
  lower_seals_order?: Maybe<Array<Scalars['uuid']['output']>>;
  lower_sensor_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  lower_shroud?: Maybe<Casings>;
  lower_shroud_id?: Maybe<Scalars['uuid']['output']>;
  mle_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  motor?: Maybe<Motors>;
  motor_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  motor_lead_extension?: Maybe<Motor_Lead_Extensions>;
  parent_revision_id?: Maybe<Scalars['uuid']['output']>;
  pumps_order: Array<Scalars['uuid']['output']>;
  /** An object relationship */
  scenario_equipment_journal: Revisions_Scenario_Equipment_Journal;
  /** An array relationship */
  scenario_equipment_journals: Array<Revisions_Scenario_Equipment_Journal>;
  /** An aggregate relationship */
  scenario_equipment_journals_aggregate: Revisions_Scenario_Equipment_Journal_Aggregate;
  /** An object relationship */
  scenario_equipment_revision?: Maybe<Revisions_Scenario_Equipment_Revisions>;
  /** An array relationship */
  scenario_equipment_revisions: Array<Revisions_Scenario_Equipment_Revisions>;
  /** An aggregate relationship */
  scenario_equipment_revisions_aggregate: Revisions_Scenario_Equipment_Revisions_Aggregate;
  /** An object relationship */
  scenario_equipment_view?: Maybe<Scenario_Equipment>;
  /** An object relationship */
  seal_motor_oil?: Maybe<Seal_Motor_Oil>;
  seal_motor_oil_id?: Maybe<Scalars['uuid']['output']>;
  seals_order: Array<Scalars['uuid']['output']>;
  /** An object relationship */
  sensor?: Maybe<Sensors>;
  sensor_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  shroud?: Maybe<Casings>;
  shroud_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  step_down_transformer?: Maybe<Step_Down_Transformers>;
  /** An object relationship */
  step_up_transformer?: Maybe<Step_Up_Transformers>;
  /** An object relationship */
  switchboard?: Maybe<Switchboards>;
  switchboard_id?: Maybe<Scalars['uuid']['output']>;
  up_trans_id?: Maybe<Scalars['uuid']['output']>;
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  uphole_y_tool?: Maybe<Y_Tools>;
  uphole_y_tool_bypass_tubing_order?: Maybe<Array<Scalars['uuid']['output']>>;
  uphole_y_tool_equipment_tubing_order?: Maybe<Array<Scalars['uuid']['output']>>;
  uphole_y_tool_id?: Maybe<Scalars['uuid']['output']>;
  use_downhole_y_tool?: Maybe<Scalars['Boolean']['output']>;
  use_uphole_y_tool?: Maybe<Scalars['Boolean']['output']>;
  use_vsd?: Maybe<Scalars['Boolean']['output']>;
  /** An object relationship */
  user: Users;
  /** An object relationship */
  variable_speed_drive?: Maybe<Variable_Speed_Drives>;
  vsd_id?: Maybe<Scalars['uuid']['output']>;
};


/** columns and relationships of "revisions.scenario_equipment_revisions" */
export type Revisions_Scenario_Equipment_RevisionsScenario_Equipment_JournalsArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Equipment_Journal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Equipment_Journal_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Equipment_Journal_Bool_Exp>;
};


/** columns and relationships of "revisions.scenario_equipment_revisions" */
export type Revisions_Scenario_Equipment_RevisionsScenario_Equipment_Journals_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Equipment_Journal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Equipment_Journal_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Equipment_Journal_Bool_Exp>;
};


/** columns and relationships of "revisions.scenario_equipment_revisions" */
export type Revisions_Scenario_Equipment_RevisionsScenario_Equipment_RevisionsArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Equipment_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Equipment_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Equipment_Revisions_Bool_Exp>;
};


/** columns and relationships of "revisions.scenario_equipment_revisions" */
export type Revisions_Scenario_Equipment_RevisionsScenario_Equipment_Revisions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Equipment_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Equipment_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Equipment_Revisions_Bool_Exp>;
};

/** aggregated selection of "revisions.scenario_equipment_revisions" */
export type Revisions_Scenario_Equipment_Revisions_Aggregate = {
  __typename: 'revisions_scenario_equipment_revisions_aggregate';
  aggregate?: Maybe<Revisions_Scenario_Equipment_Revisions_Aggregate_Fields>;
  nodes: Array<Revisions_Scenario_Equipment_Revisions>;
};

export type Revisions_Scenario_Equipment_Revisions_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Revisions_Scenario_Equipment_Revisions_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Revisions_Scenario_Equipment_Revisions_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Revisions_Scenario_Equipment_Revisions_Aggregate_Bool_Exp_Count>;
};

export type Revisions_Scenario_Equipment_Revisions_Aggregate_Bool_Exp_Bool_And = {
  arguments: Revisions_Scenario_Equipment_Revisions_Select_Column_Revisions_Scenario_Equipment_Revisions_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Revisions_Scenario_Equipment_Revisions_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Revisions_Scenario_Equipment_Revisions_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Revisions_Scenario_Equipment_Revisions_Select_Column_Revisions_Scenario_Equipment_Revisions_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Revisions_Scenario_Equipment_Revisions_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Revisions_Scenario_Equipment_Revisions_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Revisions_Scenario_Equipment_Revisions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Revisions_Scenario_Equipment_Revisions_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "revisions.scenario_equipment_revisions" */
export type Revisions_Scenario_Equipment_Revisions_Aggregate_Fields = {
  __typename: 'revisions_scenario_equipment_revisions_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Revisions_Scenario_Equipment_Revisions_Max_Fields>;
  min?: Maybe<Revisions_Scenario_Equipment_Revisions_Min_Fields>;
};


/** aggregate fields of "revisions.scenario_equipment_revisions" */
export type Revisions_Scenario_Equipment_Revisions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Revisions_Scenario_Equipment_Revisions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "revisions.scenario_equipment_revisions" */
export type Revisions_Scenario_Equipment_Revisions_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Revisions_Scenario_Equipment_Revisions_Max_Order_By>;
  min?: InputMaybe<Revisions_Scenario_Equipment_Revisions_Min_Order_By>;
};

/** input type for inserting array relation for remote table "revisions.scenario_equipment_revisions" */
export type Revisions_Scenario_Equipment_Revisions_Arr_Rel_Insert_Input = {
  data: Array<Revisions_Scenario_Equipment_Revisions_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Revisions_Scenario_Equipment_Revisions_On_Conflict>;
};

/** Boolean expression to filter rows from the table "revisions.scenario_equipment_revisions". All fields are combined with a logical 'AND'. */
export type Revisions_Scenario_Equipment_Revisions_Bool_Exp = {
  _and?: InputMaybe<Array<Revisions_Scenario_Equipment_Revisions_Bool_Exp>>;
  _not?: InputMaybe<Revisions_Scenario_Equipment_Revisions_Bool_Exp>;
  _or?: InputMaybe<Array<Revisions_Scenario_Equipment_Revisions_Bool_Exp>>;
  author_id?: InputMaybe<String_Comparison_Exp>;
  bolt_on_discharge_id?: InputMaybe<Uuid_Comparison_Exp>;
  cables_order?: InputMaybe<Uuid_Array_Comparison_Exp>;
  cloned_from_journal_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  down_trans_id?: InputMaybe<Uuid_Comparison_Exp>;
  downhole_y_tool?: InputMaybe<Y_Tools_Bool_Exp>;
  downhole_y_tool_bypass_tubing_order?: InputMaybe<Uuid_Array_Comparison_Exp>;
  downhole_y_tool_equipment_tubing_order?: InputMaybe<Uuid_Array_Comparison_Exp>;
  downhole_y_tool_id?: InputMaybe<Uuid_Comparison_Exp>;
  has_lower_equip_stack?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  include_y_tool?: InputMaybe<Boolean_Comparison_Exp>;
  intakes_order?: InputMaybe<Uuid_Array_Comparison_Exp>;
  journal_id?: InputMaybe<Uuid_Comparison_Exp>;
  lower_bolt_on_discharge_id?: InputMaybe<Uuid_Comparison_Exp>;
  lower_cables_order?: InputMaybe<Uuid_Array_Comparison_Exp>;
  lower_intakes_order?: InputMaybe<Uuid_Array_Comparison_Exp>;
  lower_mle_id?: InputMaybe<Uuid_Comparison_Exp>;
  lower_motor_id?: InputMaybe<Uuid_Comparison_Exp>;
  lower_pumps_order?: InputMaybe<Uuid_Array_Comparison_Exp>;
  lower_seal_motor_oil_id?: InputMaybe<Uuid_Comparison_Exp>;
  lower_seals_order?: InputMaybe<Uuid_Array_Comparison_Exp>;
  lower_sensor_id?: InputMaybe<Uuid_Comparison_Exp>;
  lower_shroud?: InputMaybe<Casings_Bool_Exp>;
  lower_shroud_id?: InputMaybe<Uuid_Comparison_Exp>;
  mle_id?: InputMaybe<Uuid_Comparison_Exp>;
  motor?: InputMaybe<Motors_Bool_Exp>;
  motor_id?: InputMaybe<Uuid_Comparison_Exp>;
  motor_lead_extension?: InputMaybe<Motor_Lead_Extensions_Bool_Exp>;
  parent_revision_id?: InputMaybe<Uuid_Comparison_Exp>;
  pumps_order?: InputMaybe<Uuid_Array_Comparison_Exp>;
  scenario_equipment_journal?: InputMaybe<Revisions_Scenario_Equipment_Journal_Bool_Exp>;
  scenario_equipment_journals?: InputMaybe<Revisions_Scenario_Equipment_Journal_Bool_Exp>;
  scenario_equipment_journals_aggregate?: InputMaybe<Revisions_Scenario_Equipment_Journal_Aggregate_Bool_Exp>;
  scenario_equipment_revision?: InputMaybe<Revisions_Scenario_Equipment_Revisions_Bool_Exp>;
  scenario_equipment_revisions?: InputMaybe<Revisions_Scenario_Equipment_Revisions_Bool_Exp>;
  scenario_equipment_revisions_aggregate?: InputMaybe<Revisions_Scenario_Equipment_Revisions_Aggregate_Bool_Exp>;
  scenario_equipment_view?: InputMaybe<Scenario_Equipment_Bool_Exp>;
  seal_motor_oil?: InputMaybe<Seal_Motor_Oil_Bool_Exp>;
  seal_motor_oil_id?: InputMaybe<Uuid_Comparison_Exp>;
  seals_order?: InputMaybe<Uuid_Array_Comparison_Exp>;
  sensor?: InputMaybe<Sensors_Bool_Exp>;
  sensor_id?: InputMaybe<Uuid_Comparison_Exp>;
  shroud?: InputMaybe<Casings_Bool_Exp>;
  shroud_id?: InputMaybe<Uuid_Comparison_Exp>;
  step_down_transformer?: InputMaybe<Step_Down_Transformers_Bool_Exp>;
  step_up_transformer?: InputMaybe<Step_Up_Transformers_Bool_Exp>;
  switchboard?: InputMaybe<Switchboards_Bool_Exp>;
  switchboard_id?: InputMaybe<Uuid_Comparison_Exp>;
  up_trans_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  uphole_y_tool?: InputMaybe<Y_Tools_Bool_Exp>;
  uphole_y_tool_bypass_tubing_order?: InputMaybe<Uuid_Array_Comparison_Exp>;
  uphole_y_tool_equipment_tubing_order?: InputMaybe<Uuid_Array_Comparison_Exp>;
  uphole_y_tool_id?: InputMaybe<Uuid_Comparison_Exp>;
  use_downhole_y_tool?: InputMaybe<Boolean_Comparison_Exp>;
  use_uphole_y_tool?: InputMaybe<Boolean_Comparison_Exp>;
  use_vsd?: InputMaybe<Boolean_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  variable_speed_drive?: InputMaybe<Variable_Speed_Drives_Bool_Exp>;
  vsd_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "revisions.scenario_equipment_revisions" */
export enum Revisions_Scenario_Equipment_Revisions_Constraint {
  /** unique or primary key constraint on columns "id" */
  ScenarioEquipmentRevisionsPkey = 'scenario_equipment_revisions_pkey'
}

/** input type for inserting data into table "revisions.scenario_equipment_revisions" */
export type Revisions_Scenario_Equipment_Revisions_Insert_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  bolt_on_discharge_id?: InputMaybe<Scalars['uuid']['input']>;
  cables_order?: InputMaybe<Array<Scalars['uuid']['input']>>;
  cloned_from_journal_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  down_trans_id?: InputMaybe<Scalars['uuid']['input']>;
  downhole_y_tool?: InputMaybe<Y_Tools_Obj_Rel_Insert_Input>;
  downhole_y_tool_bypass_tubing_order?: InputMaybe<Array<Scalars['uuid']['input']>>;
  downhole_y_tool_equipment_tubing_order?: InputMaybe<Array<Scalars['uuid']['input']>>;
  downhole_y_tool_id?: InputMaybe<Scalars['uuid']['input']>;
  has_lower_equip_stack?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  include_y_tool?: InputMaybe<Scalars['Boolean']['input']>;
  intakes_order?: InputMaybe<Array<Scalars['uuid']['input']>>;
  journal_id?: InputMaybe<Scalars['uuid']['input']>;
  lower_bolt_on_discharge_id?: InputMaybe<Scalars['uuid']['input']>;
  lower_cables_order?: InputMaybe<Array<Scalars['uuid']['input']>>;
  lower_intakes_order?: InputMaybe<Array<Scalars['uuid']['input']>>;
  lower_mle_id?: InputMaybe<Scalars['uuid']['input']>;
  lower_motor_id?: InputMaybe<Scalars['uuid']['input']>;
  lower_pumps_order?: InputMaybe<Array<Scalars['uuid']['input']>>;
  lower_seal_motor_oil_id?: InputMaybe<Scalars['uuid']['input']>;
  lower_seals_order?: InputMaybe<Array<Scalars['uuid']['input']>>;
  lower_sensor_id?: InputMaybe<Scalars['uuid']['input']>;
  lower_shroud?: InputMaybe<Casings_Obj_Rel_Insert_Input>;
  lower_shroud_id?: InputMaybe<Scalars['uuid']['input']>;
  mle_id?: InputMaybe<Scalars['uuid']['input']>;
  motor?: InputMaybe<Motors_Obj_Rel_Insert_Input>;
  motor_id?: InputMaybe<Scalars['uuid']['input']>;
  motor_lead_extension?: InputMaybe<Motor_Lead_Extensions_Obj_Rel_Insert_Input>;
  parent_revision_id?: InputMaybe<Scalars['uuid']['input']>;
  pumps_order?: InputMaybe<Array<Scalars['uuid']['input']>>;
  scenario_equipment_journal?: InputMaybe<Revisions_Scenario_Equipment_Journal_Obj_Rel_Insert_Input>;
  scenario_equipment_journals?: InputMaybe<Revisions_Scenario_Equipment_Journal_Arr_Rel_Insert_Input>;
  scenario_equipment_revision?: InputMaybe<Revisions_Scenario_Equipment_Revisions_Obj_Rel_Insert_Input>;
  scenario_equipment_revisions?: InputMaybe<Revisions_Scenario_Equipment_Revisions_Arr_Rel_Insert_Input>;
  scenario_equipment_view?: InputMaybe<Scenario_Equipment_Obj_Rel_Insert_Input>;
  seal_motor_oil?: InputMaybe<Seal_Motor_Oil_Obj_Rel_Insert_Input>;
  seal_motor_oil_id?: InputMaybe<Scalars['uuid']['input']>;
  seals_order?: InputMaybe<Array<Scalars['uuid']['input']>>;
  sensor?: InputMaybe<Sensors_Obj_Rel_Insert_Input>;
  sensor_id?: InputMaybe<Scalars['uuid']['input']>;
  shroud?: InputMaybe<Casings_Obj_Rel_Insert_Input>;
  shroud_id?: InputMaybe<Scalars['uuid']['input']>;
  step_down_transformer?: InputMaybe<Step_Down_Transformers_Obj_Rel_Insert_Input>;
  step_up_transformer?: InputMaybe<Step_Up_Transformers_Obj_Rel_Insert_Input>;
  switchboard?: InputMaybe<Switchboards_Obj_Rel_Insert_Input>;
  switchboard_id?: InputMaybe<Scalars['uuid']['input']>;
  up_trans_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  uphole_y_tool?: InputMaybe<Y_Tools_Obj_Rel_Insert_Input>;
  uphole_y_tool_bypass_tubing_order?: InputMaybe<Array<Scalars['uuid']['input']>>;
  uphole_y_tool_equipment_tubing_order?: InputMaybe<Array<Scalars['uuid']['input']>>;
  uphole_y_tool_id?: InputMaybe<Scalars['uuid']['input']>;
  use_downhole_y_tool?: InputMaybe<Scalars['Boolean']['input']>;
  use_uphole_y_tool?: InputMaybe<Scalars['Boolean']['input']>;
  use_vsd?: InputMaybe<Scalars['Boolean']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  variable_speed_drive?: InputMaybe<Variable_Speed_Drives_Obj_Rel_Insert_Input>;
  vsd_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Revisions_Scenario_Equipment_Revisions_Max_Fields = {
  __typename: 'revisions_scenario_equipment_revisions_max_fields';
  author_id?: Maybe<Scalars['String']['output']>;
  bolt_on_discharge_id?: Maybe<Scalars['uuid']['output']>;
  cables_order?: Maybe<Array<Scalars['uuid']['output']>>;
  cloned_from_journal_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  down_trans_id?: Maybe<Scalars['uuid']['output']>;
  downhole_y_tool_bypass_tubing_order?: Maybe<Array<Scalars['uuid']['output']>>;
  downhole_y_tool_equipment_tubing_order?: Maybe<Array<Scalars['uuid']['output']>>;
  downhole_y_tool_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  intakes_order?: Maybe<Array<Scalars['uuid']['output']>>;
  journal_id?: Maybe<Scalars['uuid']['output']>;
  lower_bolt_on_discharge_id?: Maybe<Scalars['uuid']['output']>;
  lower_cables_order?: Maybe<Array<Scalars['uuid']['output']>>;
  lower_intakes_order?: Maybe<Array<Scalars['uuid']['output']>>;
  lower_mle_id?: Maybe<Scalars['uuid']['output']>;
  lower_motor_id?: Maybe<Scalars['uuid']['output']>;
  lower_pumps_order?: Maybe<Array<Scalars['uuid']['output']>>;
  lower_seal_motor_oil_id?: Maybe<Scalars['uuid']['output']>;
  lower_seals_order?: Maybe<Array<Scalars['uuid']['output']>>;
  lower_sensor_id?: Maybe<Scalars['uuid']['output']>;
  lower_shroud_id?: Maybe<Scalars['uuid']['output']>;
  mle_id?: Maybe<Scalars['uuid']['output']>;
  motor_id?: Maybe<Scalars['uuid']['output']>;
  parent_revision_id?: Maybe<Scalars['uuid']['output']>;
  pumps_order?: Maybe<Array<Scalars['uuid']['output']>>;
  seal_motor_oil_id?: Maybe<Scalars['uuid']['output']>;
  seals_order?: Maybe<Array<Scalars['uuid']['output']>>;
  sensor_id?: Maybe<Scalars['uuid']['output']>;
  shroud_id?: Maybe<Scalars['uuid']['output']>;
  switchboard_id?: Maybe<Scalars['uuid']['output']>;
  up_trans_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  uphole_y_tool_bypass_tubing_order?: Maybe<Array<Scalars['uuid']['output']>>;
  uphole_y_tool_equipment_tubing_order?: Maybe<Array<Scalars['uuid']['output']>>;
  uphole_y_tool_id?: Maybe<Scalars['uuid']['output']>;
  vsd_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "revisions.scenario_equipment_revisions" */
export type Revisions_Scenario_Equipment_Revisions_Max_Order_By = {
  author_id?: InputMaybe<Order_By>;
  bolt_on_discharge_id?: InputMaybe<Order_By>;
  cables_order?: InputMaybe<Order_By>;
  cloned_from_journal_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  down_trans_id?: InputMaybe<Order_By>;
  downhole_y_tool_bypass_tubing_order?: InputMaybe<Order_By>;
  downhole_y_tool_equipment_tubing_order?: InputMaybe<Order_By>;
  downhole_y_tool_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  intakes_order?: InputMaybe<Order_By>;
  journal_id?: InputMaybe<Order_By>;
  lower_bolt_on_discharge_id?: InputMaybe<Order_By>;
  lower_cables_order?: InputMaybe<Order_By>;
  lower_intakes_order?: InputMaybe<Order_By>;
  lower_mle_id?: InputMaybe<Order_By>;
  lower_motor_id?: InputMaybe<Order_By>;
  lower_pumps_order?: InputMaybe<Order_By>;
  lower_seal_motor_oil_id?: InputMaybe<Order_By>;
  lower_seals_order?: InputMaybe<Order_By>;
  lower_sensor_id?: InputMaybe<Order_By>;
  lower_shroud_id?: InputMaybe<Order_By>;
  mle_id?: InputMaybe<Order_By>;
  motor_id?: InputMaybe<Order_By>;
  parent_revision_id?: InputMaybe<Order_By>;
  pumps_order?: InputMaybe<Order_By>;
  seal_motor_oil_id?: InputMaybe<Order_By>;
  seals_order?: InputMaybe<Order_By>;
  sensor_id?: InputMaybe<Order_By>;
  shroud_id?: InputMaybe<Order_By>;
  switchboard_id?: InputMaybe<Order_By>;
  up_trans_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  uphole_y_tool_bypass_tubing_order?: InputMaybe<Order_By>;
  uphole_y_tool_equipment_tubing_order?: InputMaybe<Order_By>;
  uphole_y_tool_id?: InputMaybe<Order_By>;
  vsd_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Revisions_Scenario_Equipment_Revisions_Min_Fields = {
  __typename: 'revisions_scenario_equipment_revisions_min_fields';
  author_id?: Maybe<Scalars['String']['output']>;
  bolt_on_discharge_id?: Maybe<Scalars['uuid']['output']>;
  cables_order?: Maybe<Array<Scalars['uuid']['output']>>;
  cloned_from_journal_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  down_trans_id?: Maybe<Scalars['uuid']['output']>;
  downhole_y_tool_bypass_tubing_order?: Maybe<Array<Scalars['uuid']['output']>>;
  downhole_y_tool_equipment_tubing_order?: Maybe<Array<Scalars['uuid']['output']>>;
  downhole_y_tool_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  intakes_order?: Maybe<Array<Scalars['uuid']['output']>>;
  journal_id?: Maybe<Scalars['uuid']['output']>;
  lower_bolt_on_discharge_id?: Maybe<Scalars['uuid']['output']>;
  lower_cables_order?: Maybe<Array<Scalars['uuid']['output']>>;
  lower_intakes_order?: Maybe<Array<Scalars['uuid']['output']>>;
  lower_mle_id?: Maybe<Scalars['uuid']['output']>;
  lower_motor_id?: Maybe<Scalars['uuid']['output']>;
  lower_pumps_order?: Maybe<Array<Scalars['uuid']['output']>>;
  lower_seal_motor_oil_id?: Maybe<Scalars['uuid']['output']>;
  lower_seals_order?: Maybe<Array<Scalars['uuid']['output']>>;
  lower_sensor_id?: Maybe<Scalars['uuid']['output']>;
  lower_shroud_id?: Maybe<Scalars['uuid']['output']>;
  mle_id?: Maybe<Scalars['uuid']['output']>;
  motor_id?: Maybe<Scalars['uuid']['output']>;
  parent_revision_id?: Maybe<Scalars['uuid']['output']>;
  pumps_order?: Maybe<Array<Scalars['uuid']['output']>>;
  seal_motor_oil_id?: Maybe<Scalars['uuid']['output']>;
  seals_order?: Maybe<Array<Scalars['uuid']['output']>>;
  sensor_id?: Maybe<Scalars['uuid']['output']>;
  shroud_id?: Maybe<Scalars['uuid']['output']>;
  switchboard_id?: Maybe<Scalars['uuid']['output']>;
  up_trans_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  uphole_y_tool_bypass_tubing_order?: Maybe<Array<Scalars['uuid']['output']>>;
  uphole_y_tool_equipment_tubing_order?: Maybe<Array<Scalars['uuid']['output']>>;
  uphole_y_tool_id?: Maybe<Scalars['uuid']['output']>;
  vsd_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "revisions.scenario_equipment_revisions" */
export type Revisions_Scenario_Equipment_Revisions_Min_Order_By = {
  author_id?: InputMaybe<Order_By>;
  bolt_on_discharge_id?: InputMaybe<Order_By>;
  cables_order?: InputMaybe<Order_By>;
  cloned_from_journal_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  down_trans_id?: InputMaybe<Order_By>;
  downhole_y_tool_bypass_tubing_order?: InputMaybe<Order_By>;
  downhole_y_tool_equipment_tubing_order?: InputMaybe<Order_By>;
  downhole_y_tool_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  intakes_order?: InputMaybe<Order_By>;
  journal_id?: InputMaybe<Order_By>;
  lower_bolt_on_discharge_id?: InputMaybe<Order_By>;
  lower_cables_order?: InputMaybe<Order_By>;
  lower_intakes_order?: InputMaybe<Order_By>;
  lower_mle_id?: InputMaybe<Order_By>;
  lower_motor_id?: InputMaybe<Order_By>;
  lower_pumps_order?: InputMaybe<Order_By>;
  lower_seal_motor_oil_id?: InputMaybe<Order_By>;
  lower_seals_order?: InputMaybe<Order_By>;
  lower_sensor_id?: InputMaybe<Order_By>;
  lower_shroud_id?: InputMaybe<Order_By>;
  mle_id?: InputMaybe<Order_By>;
  motor_id?: InputMaybe<Order_By>;
  parent_revision_id?: InputMaybe<Order_By>;
  pumps_order?: InputMaybe<Order_By>;
  seal_motor_oil_id?: InputMaybe<Order_By>;
  seals_order?: InputMaybe<Order_By>;
  sensor_id?: InputMaybe<Order_By>;
  shroud_id?: InputMaybe<Order_By>;
  switchboard_id?: InputMaybe<Order_By>;
  up_trans_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  uphole_y_tool_bypass_tubing_order?: InputMaybe<Order_By>;
  uphole_y_tool_equipment_tubing_order?: InputMaybe<Order_By>;
  uphole_y_tool_id?: InputMaybe<Order_By>;
  vsd_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "revisions.scenario_equipment_revisions" */
export type Revisions_Scenario_Equipment_Revisions_Mutation_Response = {
  __typename: 'revisions_scenario_equipment_revisions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Revisions_Scenario_Equipment_Revisions>;
};

/** input type for inserting object relation for remote table "revisions.scenario_equipment_revisions" */
export type Revisions_Scenario_Equipment_Revisions_Obj_Rel_Insert_Input = {
  data: Revisions_Scenario_Equipment_Revisions_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Revisions_Scenario_Equipment_Revisions_On_Conflict>;
};

/** on_conflict condition type for table "revisions.scenario_equipment_revisions" */
export type Revisions_Scenario_Equipment_Revisions_On_Conflict = {
  constraint: Revisions_Scenario_Equipment_Revisions_Constraint;
  update_columns?: Array<Revisions_Scenario_Equipment_Revisions_Update_Column>;
  where?: InputMaybe<Revisions_Scenario_Equipment_Revisions_Bool_Exp>;
};

/** Ordering options when selecting data from "revisions.scenario_equipment_revisions". */
export type Revisions_Scenario_Equipment_Revisions_Order_By = {
  author_id?: InputMaybe<Order_By>;
  bolt_on_discharge_id?: InputMaybe<Order_By>;
  cables_order?: InputMaybe<Order_By>;
  cloned_from_journal_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  down_trans_id?: InputMaybe<Order_By>;
  downhole_y_tool?: InputMaybe<Y_Tools_Order_By>;
  downhole_y_tool_bypass_tubing_order?: InputMaybe<Order_By>;
  downhole_y_tool_equipment_tubing_order?: InputMaybe<Order_By>;
  downhole_y_tool_id?: InputMaybe<Order_By>;
  has_lower_equip_stack?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  include_y_tool?: InputMaybe<Order_By>;
  intakes_order?: InputMaybe<Order_By>;
  journal_id?: InputMaybe<Order_By>;
  lower_bolt_on_discharge_id?: InputMaybe<Order_By>;
  lower_cables_order?: InputMaybe<Order_By>;
  lower_intakes_order?: InputMaybe<Order_By>;
  lower_mle_id?: InputMaybe<Order_By>;
  lower_motor_id?: InputMaybe<Order_By>;
  lower_pumps_order?: InputMaybe<Order_By>;
  lower_seal_motor_oil_id?: InputMaybe<Order_By>;
  lower_seals_order?: InputMaybe<Order_By>;
  lower_sensor_id?: InputMaybe<Order_By>;
  lower_shroud?: InputMaybe<Casings_Order_By>;
  lower_shroud_id?: InputMaybe<Order_By>;
  mle_id?: InputMaybe<Order_By>;
  motor?: InputMaybe<Motors_Order_By>;
  motor_id?: InputMaybe<Order_By>;
  motor_lead_extension?: InputMaybe<Motor_Lead_Extensions_Order_By>;
  parent_revision_id?: InputMaybe<Order_By>;
  pumps_order?: InputMaybe<Order_By>;
  scenario_equipment_journal?: InputMaybe<Revisions_Scenario_Equipment_Journal_Order_By>;
  scenario_equipment_journals_aggregate?: InputMaybe<Revisions_Scenario_Equipment_Journal_Aggregate_Order_By>;
  scenario_equipment_revision?: InputMaybe<Revisions_Scenario_Equipment_Revisions_Order_By>;
  scenario_equipment_revisions_aggregate?: InputMaybe<Revisions_Scenario_Equipment_Revisions_Aggregate_Order_By>;
  scenario_equipment_view?: InputMaybe<Scenario_Equipment_Order_By>;
  seal_motor_oil?: InputMaybe<Seal_Motor_Oil_Order_By>;
  seal_motor_oil_id?: InputMaybe<Order_By>;
  seals_order?: InputMaybe<Order_By>;
  sensor?: InputMaybe<Sensors_Order_By>;
  sensor_id?: InputMaybe<Order_By>;
  shroud?: InputMaybe<Casings_Order_By>;
  shroud_id?: InputMaybe<Order_By>;
  step_down_transformer?: InputMaybe<Step_Down_Transformers_Order_By>;
  step_up_transformer?: InputMaybe<Step_Up_Transformers_Order_By>;
  switchboard?: InputMaybe<Switchboards_Order_By>;
  switchboard_id?: InputMaybe<Order_By>;
  up_trans_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  uphole_y_tool?: InputMaybe<Y_Tools_Order_By>;
  uphole_y_tool_bypass_tubing_order?: InputMaybe<Order_By>;
  uphole_y_tool_equipment_tubing_order?: InputMaybe<Order_By>;
  uphole_y_tool_id?: InputMaybe<Order_By>;
  use_downhole_y_tool?: InputMaybe<Order_By>;
  use_uphole_y_tool?: InputMaybe<Order_By>;
  use_vsd?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  variable_speed_drive?: InputMaybe<Variable_Speed_Drives_Order_By>;
  vsd_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: revisions.scenario_equipment_revisions */
export type Revisions_Scenario_Equipment_Revisions_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "revisions.scenario_equipment_revisions" */
export enum Revisions_Scenario_Equipment_Revisions_Select_Column {
  /** column name */
  AuthorId = 'author_id',
  /** column name */
  BoltOnDischargeId = 'bolt_on_discharge_id',
  /** column name */
  CablesOrder = 'cables_order',
  /** column name */
  ClonedFromJournalId = 'cloned_from_journal_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  DownTransId = 'down_trans_id',
  /** column name */
  DownholeYToolBypassTubingOrder = 'downhole_y_tool_bypass_tubing_order',
  /** column name */
  DownholeYToolEquipmentTubingOrder = 'downhole_y_tool_equipment_tubing_order',
  /** column name */
  DownholeYToolId = 'downhole_y_tool_id',
  /** column name */
  HasLowerEquipStack = 'has_lower_equip_stack',
  /** column name */
  Id = 'id',
  /** column name */
  IncludeYTool = 'include_y_tool',
  /** column name */
  IntakesOrder = 'intakes_order',
  /** column name */
  JournalId = 'journal_id',
  /** column name */
  LowerBoltOnDischargeId = 'lower_bolt_on_discharge_id',
  /** column name */
  LowerCablesOrder = 'lower_cables_order',
  /** column name */
  LowerIntakesOrder = 'lower_intakes_order',
  /** column name */
  LowerMleId = 'lower_mle_id',
  /** column name */
  LowerMotorId = 'lower_motor_id',
  /** column name */
  LowerPumpsOrder = 'lower_pumps_order',
  /** column name */
  LowerSealMotorOilId = 'lower_seal_motor_oil_id',
  /** column name */
  LowerSealsOrder = 'lower_seals_order',
  /** column name */
  LowerSensorId = 'lower_sensor_id',
  /** column name */
  LowerShroudId = 'lower_shroud_id',
  /** column name */
  MleId = 'mle_id',
  /** column name */
  MotorId = 'motor_id',
  /** column name */
  ParentRevisionId = 'parent_revision_id',
  /** column name */
  PumpsOrder = 'pumps_order',
  /** column name */
  SealMotorOilId = 'seal_motor_oil_id',
  /** column name */
  SealsOrder = 'seals_order',
  /** column name */
  SensorId = 'sensor_id',
  /** column name */
  ShroudId = 'shroud_id',
  /** column name */
  SwitchboardId = 'switchboard_id',
  /** column name */
  UpTransId = 'up_trans_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpholeYToolBypassTubingOrder = 'uphole_y_tool_bypass_tubing_order',
  /** column name */
  UpholeYToolEquipmentTubingOrder = 'uphole_y_tool_equipment_tubing_order',
  /** column name */
  UpholeYToolId = 'uphole_y_tool_id',
  /** column name */
  UseDownholeYTool = 'use_downhole_y_tool',
  /** column name */
  UseUpholeYTool = 'use_uphole_y_tool',
  /** column name */
  UseVsd = 'use_vsd',
  /** column name */
  VsdId = 'vsd_id'
}

/** select "revisions_scenario_equipment_revisions_aggregate_bool_exp_bool_and_arguments_columns" columns of table "revisions.scenario_equipment_revisions" */
export enum Revisions_Scenario_Equipment_Revisions_Select_Column_Revisions_Scenario_Equipment_Revisions_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  HasLowerEquipStack = 'has_lower_equip_stack',
  /** column name */
  IncludeYTool = 'include_y_tool',
  /** column name */
  UseDownholeYTool = 'use_downhole_y_tool',
  /** column name */
  UseUpholeYTool = 'use_uphole_y_tool',
  /** column name */
  UseVsd = 'use_vsd'
}

/** select "revisions_scenario_equipment_revisions_aggregate_bool_exp_bool_or_arguments_columns" columns of table "revisions.scenario_equipment_revisions" */
export enum Revisions_Scenario_Equipment_Revisions_Select_Column_Revisions_Scenario_Equipment_Revisions_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  HasLowerEquipStack = 'has_lower_equip_stack',
  /** column name */
  IncludeYTool = 'include_y_tool',
  /** column name */
  UseDownholeYTool = 'use_downhole_y_tool',
  /** column name */
  UseUpholeYTool = 'use_uphole_y_tool',
  /** column name */
  UseVsd = 'use_vsd'
}

/** input type for updating data in table "revisions.scenario_equipment_revisions" */
export type Revisions_Scenario_Equipment_Revisions_Set_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  bolt_on_discharge_id?: InputMaybe<Scalars['uuid']['input']>;
  cables_order?: InputMaybe<Array<Scalars['uuid']['input']>>;
  cloned_from_journal_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  down_trans_id?: InputMaybe<Scalars['uuid']['input']>;
  downhole_y_tool_bypass_tubing_order?: InputMaybe<Array<Scalars['uuid']['input']>>;
  downhole_y_tool_equipment_tubing_order?: InputMaybe<Array<Scalars['uuid']['input']>>;
  downhole_y_tool_id?: InputMaybe<Scalars['uuid']['input']>;
  has_lower_equip_stack?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  include_y_tool?: InputMaybe<Scalars['Boolean']['input']>;
  intakes_order?: InputMaybe<Array<Scalars['uuid']['input']>>;
  journal_id?: InputMaybe<Scalars['uuid']['input']>;
  lower_bolt_on_discharge_id?: InputMaybe<Scalars['uuid']['input']>;
  lower_cables_order?: InputMaybe<Array<Scalars['uuid']['input']>>;
  lower_intakes_order?: InputMaybe<Array<Scalars['uuid']['input']>>;
  lower_mle_id?: InputMaybe<Scalars['uuid']['input']>;
  lower_motor_id?: InputMaybe<Scalars['uuid']['input']>;
  lower_pumps_order?: InputMaybe<Array<Scalars['uuid']['input']>>;
  lower_seal_motor_oil_id?: InputMaybe<Scalars['uuid']['input']>;
  lower_seals_order?: InputMaybe<Array<Scalars['uuid']['input']>>;
  lower_sensor_id?: InputMaybe<Scalars['uuid']['input']>;
  lower_shroud_id?: InputMaybe<Scalars['uuid']['input']>;
  mle_id?: InputMaybe<Scalars['uuid']['input']>;
  motor_id?: InputMaybe<Scalars['uuid']['input']>;
  parent_revision_id?: InputMaybe<Scalars['uuid']['input']>;
  pumps_order?: InputMaybe<Array<Scalars['uuid']['input']>>;
  seal_motor_oil_id?: InputMaybe<Scalars['uuid']['input']>;
  seals_order?: InputMaybe<Array<Scalars['uuid']['input']>>;
  sensor_id?: InputMaybe<Scalars['uuid']['input']>;
  shroud_id?: InputMaybe<Scalars['uuid']['input']>;
  switchboard_id?: InputMaybe<Scalars['uuid']['input']>;
  up_trans_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  uphole_y_tool_bypass_tubing_order?: InputMaybe<Array<Scalars['uuid']['input']>>;
  uphole_y_tool_equipment_tubing_order?: InputMaybe<Array<Scalars['uuid']['input']>>;
  uphole_y_tool_id?: InputMaybe<Scalars['uuid']['input']>;
  use_downhole_y_tool?: InputMaybe<Scalars['Boolean']['input']>;
  use_uphole_y_tool?: InputMaybe<Scalars['Boolean']['input']>;
  use_vsd?: InputMaybe<Scalars['Boolean']['input']>;
  vsd_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "revisions_scenario_equipment_revisions" */
export type Revisions_Scenario_Equipment_Revisions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Revisions_Scenario_Equipment_Revisions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Revisions_Scenario_Equipment_Revisions_Stream_Cursor_Value_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  bolt_on_discharge_id?: InputMaybe<Scalars['uuid']['input']>;
  cables_order?: InputMaybe<Array<Scalars['uuid']['input']>>;
  cloned_from_journal_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  down_trans_id?: InputMaybe<Scalars['uuid']['input']>;
  downhole_y_tool_bypass_tubing_order?: InputMaybe<Array<Scalars['uuid']['input']>>;
  downhole_y_tool_equipment_tubing_order?: InputMaybe<Array<Scalars['uuid']['input']>>;
  downhole_y_tool_id?: InputMaybe<Scalars['uuid']['input']>;
  has_lower_equip_stack?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  include_y_tool?: InputMaybe<Scalars['Boolean']['input']>;
  intakes_order?: InputMaybe<Array<Scalars['uuid']['input']>>;
  journal_id?: InputMaybe<Scalars['uuid']['input']>;
  lower_bolt_on_discharge_id?: InputMaybe<Scalars['uuid']['input']>;
  lower_cables_order?: InputMaybe<Array<Scalars['uuid']['input']>>;
  lower_intakes_order?: InputMaybe<Array<Scalars['uuid']['input']>>;
  lower_mle_id?: InputMaybe<Scalars['uuid']['input']>;
  lower_motor_id?: InputMaybe<Scalars['uuid']['input']>;
  lower_pumps_order?: InputMaybe<Array<Scalars['uuid']['input']>>;
  lower_seal_motor_oil_id?: InputMaybe<Scalars['uuid']['input']>;
  lower_seals_order?: InputMaybe<Array<Scalars['uuid']['input']>>;
  lower_sensor_id?: InputMaybe<Scalars['uuid']['input']>;
  lower_shroud_id?: InputMaybe<Scalars['uuid']['input']>;
  mle_id?: InputMaybe<Scalars['uuid']['input']>;
  motor_id?: InputMaybe<Scalars['uuid']['input']>;
  parent_revision_id?: InputMaybe<Scalars['uuid']['input']>;
  pumps_order?: InputMaybe<Array<Scalars['uuid']['input']>>;
  seal_motor_oil_id?: InputMaybe<Scalars['uuid']['input']>;
  seals_order?: InputMaybe<Array<Scalars['uuid']['input']>>;
  sensor_id?: InputMaybe<Scalars['uuid']['input']>;
  shroud_id?: InputMaybe<Scalars['uuid']['input']>;
  switchboard_id?: InputMaybe<Scalars['uuid']['input']>;
  up_trans_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  uphole_y_tool_bypass_tubing_order?: InputMaybe<Array<Scalars['uuid']['input']>>;
  uphole_y_tool_equipment_tubing_order?: InputMaybe<Array<Scalars['uuid']['input']>>;
  uphole_y_tool_id?: InputMaybe<Scalars['uuid']['input']>;
  use_downhole_y_tool?: InputMaybe<Scalars['Boolean']['input']>;
  use_uphole_y_tool?: InputMaybe<Scalars['Boolean']['input']>;
  use_vsd?: InputMaybe<Scalars['Boolean']['input']>;
  vsd_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "revisions.scenario_equipment_revisions" */
export enum Revisions_Scenario_Equipment_Revisions_Update_Column {
  /** column name */
  AuthorId = 'author_id',
  /** column name */
  BoltOnDischargeId = 'bolt_on_discharge_id',
  /** column name */
  CablesOrder = 'cables_order',
  /** column name */
  ClonedFromJournalId = 'cloned_from_journal_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  DownTransId = 'down_trans_id',
  /** column name */
  DownholeYToolBypassTubingOrder = 'downhole_y_tool_bypass_tubing_order',
  /** column name */
  DownholeYToolEquipmentTubingOrder = 'downhole_y_tool_equipment_tubing_order',
  /** column name */
  DownholeYToolId = 'downhole_y_tool_id',
  /** column name */
  HasLowerEquipStack = 'has_lower_equip_stack',
  /** column name */
  Id = 'id',
  /** column name */
  IncludeYTool = 'include_y_tool',
  /** column name */
  IntakesOrder = 'intakes_order',
  /** column name */
  JournalId = 'journal_id',
  /** column name */
  LowerBoltOnDischargeId = 'lower_bolt_on_discharge_id',
  /** column name */
  LowerCablesOrder = 'lower_cables_order',
  /** column name */
  LowerIntakesOrder = 'lower_intakes_order',
  /** column name */
  LowerMleId = 'lower_mle_id',
  /** column name */
  LowerMotorId = 'lower_motor_id',
  /** column name */
  LowerPumpsOrder = 'lower_pumps_order',
  /** column name */
  LowerSealMotorOilId = 'lower_seal_motor_oil_id',
  /** column name */
  LowerSealsOrder = 'lower_seals_order',
  /** column name */
  LowerSensorId = 'lower_sensor_id',
  /** column name */
  LowerShroudId = 'lower_shroud_id',
  /** column name */
  MleId = 'mle_id',
  /** column name */
  MotorId = 'motor_id',
  /** column name */
  ParentRevisionId = 'parent_revision_id',
  /** column name */
  PumpsOrder = 'pumps_order',
  /** column name */
  SealMotorOilId = 'seal_motor_oil_id',
  /** column name */
  SealsOrder = 'seals_order',
  /** column name */
  SensorId = 'sensor_id',
  /** column name */
  ShroudId = 'shroud_id',
  /** column name */
  SwitchboardId = 'switchboard_id',
  /** column name */
  UpTransId = 'up_trans_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpholeYToolBypassTubingOrder = 'uphole_y_tool_bypass_tubing_order',
  /** column name */
  UpholeYToolEquipmentTubingOrder = 'uphole_y_tool_equipment_tubing_order',
  /** column name */
  UpholeYToolId = 'uphole_y_tool_id',
  /** column name */
  UseDownholeYTool = 'use_downhole_y_tool',
  /** column name */
  UseUpholeYTool = 'use_uphole_y_tool',
  /** column name */
  UseVsd = 'use_vsd',
  /** column name */
  VsdId = 'vsd_id'
}

export type Revisions_Scenario_Equipment_Revisions_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Revisions_Scenario_Equipment_Revisions_Set_Input>;
  /** filter the rows which have to be updated */
  where: Revisions_Scenario_Equipment_Revisions_Bool_Exp;
};

/** columns and relationships of "revisions.scenario_equipment_xref_cables_journal" */
export type Revisions_Scenario_Equipment_Xref_Cables_Journal = {
  __typename: 'revisions_scenario_equipment_xref_cables_journal';
  author_id: Scalars['String']['output'];
  created_at: Scalars['timestamptz']['output'];
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  parent_journal_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  scenario_equipment_xref_cables_journal?: Maybe<Revisions_Scenario_Equipment_Xref_Cables_Journal>;
  /** An array relationship */
  scenario_equipment_xref_cables_journals: Array<Revisions_Scenario_Equipment_Xref_Cables_Journal>;
  /** An aggregate relationship */
  scenario_equipment_xref_cables_journals_aggregate: Revisions_Scenario_Equipment_Xref_Cables_Journal_Aggregate;
  /** An object relationship */
  scenario_equipment_xref_cables_revision?: Maybe<Revisions_Scenario_Equipment_Xref_Cables_Revisions>;
  /** An array relationship */
  scenario_equipment_xref_cables_revisions: Array<Revisions_Scenario_Equipment_Xref_Cables_Revisions>;
  /** An aggregate relationship */
  scenario_equipment_xref_cables_revisions_aggregate: Revisions_Scenario_Equipment_Xref_Cables_Revisions_Aggregate;
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Users;
  winning_revision_id?: Maybe<Scalars['uuid']['output']>;
};


/** columns and relationships of "revisions.scenario_equipment_xref_cables_journal" */
export type Revisions_Scenario_Equipment_Xref_Cables_JournalScenario_Equipment_Xref_Cables_JournalsArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Cables_Journal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Cables_Journal_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Equipment_Xref_Cables_Journal_Bool_Exp>;
};


/** columns and relationships of "revisions.scenario_equipment_xref_cables_journal" */
export type Revisions_Scenario_Equipment_Xref_Cables_JournalScenario_Equipment_Xref_Cables_Journals_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Cables_Journal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Cables_Journal_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Equipment_Xref_Cables_Journal_Bool_Exp>;
};


/** columns and relationships of "revisions.scenario_equipment_xref_cables_journal" */
export type Revisions_Scenario_Equipment_Xref_Cables_JournalScenario_Equipment_Xref_Cables_RevisionsArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Bool_Exp>;
};


/** columns and relationships of "revisions.scenario_equipment_xref_cables_journal" */
export type Revisions_Scenario_Equipment_Xref_Cables_JournalScenario_Equipment_Xref_Cables_Revisions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Bool_Exp>;
};

/** aggregated selection of "revisions.scenario_equipment_xref_cables_journal" */
export type Revisions_Scenario_Equipment_Xref_Cables_Journal_Aggregate = {
  __typename: 'revisions_scenario_equipment_xref_cables_journal_aggregate';
  aggregate?: Maybe<Revisions_Scenario_Equipment_Xref_Cables_Journal_Aggregate_Fields>;
  nodes: Array<Revisions_Scenario_Equipment_Xref_Cables_Journal>;
};

export type Revisions_Scenario_Equipment_Xref_Cables_Journal_Aggregate_Bool_Exp = {
  count?: InputMaybe<Revisions_Scenario_Equipment_Xref_Cables_Journal_Aggregate_Bool_Exp_Count>;
};

export type Revisions_Scenario_Equipment_Xref_Cables_Journal_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Cables_Journal_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Revisions_Scenario_Equipment_Xref_Cables_Journal_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "revisions.scenario_equipment_xref_cables_journal" */
export type Revisions_Scenario_Equipment_Xref_Cables_Journal_Aggregate_Fields = {
  __typename: 'revisions_scenario_equipment_xref_cables_journal_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Revisions_Scenario_Equipment_Xref_Cables_Journal_Max_Fields>;
  min?: Maybe<Revisions_Scenario_Equipment_Xref_Cables_Journal_Min_Fields>;
};


/** aggregate fields of "revisions.scenario_equipment_xref_cables_journal" */
export type Revisions_Scenario_Equipment_Xref_Cables_Journal_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Cables_Journal_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "revisions.scenario_equipment_xref_cables_journal" */
export type Revisions_Scenario_Equipment_Xref_Cables_Journal_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Revisions_Scenario_Equipment_Xref_Cables_Journal_Max_Order_By>;
  min?: InputMaybe<Revisions_Scenario_Equipment_Xref_Cables_Journal_Min_Order_By>;
};

/** input type for inserting array relation for remote table "revisions.scenario_equipment_xref_cables_journal" */
export type Revisions_Scenario_Equipment_Xref_Cables_Journal_Arr_Rel_Insert_Input = {
  data: Array<Revisions_Scenario_Equipment_Xref_Cables_Journal_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Revisions_Scenario_Equipment_Xref_Cables_Journal_On_Conflict>;
};

/** Boolean expression to filter rows from the table "revisions.scenario_equipment_xref_cables_journal". All fields are combined with a logical 'AND'. */
export type Revisions_Scenario_Equipment_Xref_Cables_Journal_Bool_Exp = {
  _and?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Cables_Journal_Bool_Exp>>;
  _not?: InputMaybe<Revisions_Scenario_Equipment_Xref_Cables_Journal_Bool_Exp>;
  _or?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Cables_Journal_Bool_Exp>>;
  author_id?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  parent_journal_id?: InputMaybe<Uuid_Comparison_Exp>;
  scenario_equipment_xref_cables_journal?: InputMaybe<Revisions_Scenario_Equipment_Xref_Cables_Journal_Bool_Exp>;
  scenario_equipment_xref_cables_journals?: InputMaybe<Revisions_Scenario_Equipment_Xref_Cables_Journal_Bool_Exp>;
  scenario_equipment_xref_cables_journals_aggregate?: InputMaybe<Revisions_Scenario_Equipment_Xref_Cables_Journal_Aggregate_Bool_Exp>;
  scenario_equipment_xref_cables_revision?: InputMaybe<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Bool_Exp>;
  scenario_equipment_xref_cables_revisions?: InputMaybe<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Bool_Exp>;
  scenario_equipment_xref_cables_revisions_aggregate?: InputMaybe<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Aggregate_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  winning_revision_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "revisions.scenario_equipment_xref_cables_journal" */
export enum Revisions_Scenario_Equipment_Xref_Cables_Journal_Constraint {
  /** unique or primary key constraint on columns "id" */
  ScenarioEquipmentXrefCablesJournalPkey = 'scenario_equipment_xref_cables_journal_pkey'
}

/** input type for inserting data into table "revisions.scenario_equipment_xref_cables_journal" */
export type Revisions_Scenario_Equipment_Xref_Cables_Journal_Insert_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  parent_journal_id?: InputMaybe<Scalars['uuid']['input']>;
  scenario_equipment_xref_cables_journal?: InputMaybe<Revisions_Scenario_Equipment_Xref_Cables_Journal_Obj_Rel_Insert_Input>;
  scenario_equipment_xref_cables_journals?: InputMaybe<Revisions_Scenario_Equipment_Xref_Cables_Journal_Arr_Rel_Insert_Input>;
  scenario_equipment_xref_cables_revision?: InputMaybe<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Obj_Rel_Insert_Input>;
  scenario_equipment_xref_cables_revisions?: InputMaybe<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Arr_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  winning_revision_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Revisions_Scenario_Equipment_Xref_Cables_Journal_Max_Fields = {
  __typename: 'revisions_scenario_equipment_xref_cables_journal_max_fields';
  author_id?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  parent_journal_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  winning_revision_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "revisions.scenario_equipment_xref_cables_journal" */
export type Revisions_Scenario_Equipment_Xref_Cables_Journal_Max_Order_By = {
  author_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parent_journal_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  winning_revision_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Revisions_Scenario_Equipment_Xref_Cables_Journal_Min_Fields = {
  __typename: 'revisions_scenario_equipment_xref_cables_journal_min_fields';
  author_id?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  parent_journal_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  winning_revision_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "revisions.scenario_equipment_xref_cables_journal" */
export type Revisions_Scenario_Equipment_Xref_Cables_Journal_Min_Order_By = {
  author_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parent_journal_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  winning_revision_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "revisions.scenario_equipment_xref_cables_journal" */
export type Revisions_Scenario_Equipment_Xref_Cables_Journal_Mutation_Response = {
  __typename: 'revisions_scenario_equipment_xref_cables_journal_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Revisions_Scenario_Equipment_Xref_Cables_Journal>;
};

/** input type for inserting object relation for remote table "revisions.scenario_equipment_xref_cables_journal" */
export type Revisions_Scenario_Equipment_Xref_Cables_Journal_Obj_Rel_Insert_Input = {
  data: Revisions_Scenario_Equipment_Xref_Cables_Journal_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Revisions_Scenario_Equipment_Xref_Cables_Journal_On_Conflict>;
};

/** on_conflict condition type for table "revisions.scenario_equipment_xref_cables_journal" */
export type Revisions_Scenario_Equipment_Xref_Cables_Journal_On_Conflict = {
  constraint: Revisions_Scenario_Equipment_Xref_Cables_Journal_Constraint;
  update_columns?: Array<Revisions_Scenario_Equipment_Xref_Cables_Journal_Update_Column>;
  where?: InputMaybe<Revisions_Scenario_Equipment_Xref_Cables_Journal_Bool_Exp>;
};

/** Ordering options when selecting data from "revisions.scenario_equipment_xref_cables_journal". */
export type Revisions_Scenario_Equipment_Xref_Cables_Journal_Order_By = {
  author_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parent_journal_id?: InputMaybe<Order_By>;
  scenario_equipment_xref_cables_journal?: InputMaybe<Revisions_Scenario_Equipment_Xref_Cables_Journal_Order_By>;
  scenario_equipment_xref_cables_journals_aggregate?: InputMaybe<Revisions_Scenario_Equipment_Xref_Cables_Journal_Aggregate_Order_By>;
  scenario_equipment_xref_cables_revision?: InputMaybe<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Order_By>;
  scenario_equipment_xref_cables_revisions_aggregate?: InputMaybe<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  winning_revision_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: revisions.scenario_equipment_xref_cables_journal */
export type Revisions_Scenario_Equipment_Xref_Cables_Journal_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "revisions.scenario_equipment_xref_cables_journal" */
export enum Revisions_Scenario_Equipment_Xref_Cables_Journal_Select_Column {
  /** column name */
  AuthorId = 'author_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  ParentJournalId = 'parent_journal_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WinningRevisionId = 'winning_revision_id'
}

/** input type for updating data in table "revisions.scenario_equipment_xref_cables_journal" */
export type Revisions_Scenario_Equipment_Xref_Cables_Journal_Set_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  parent_journal_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  winning_revision_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "revisions_scenario_equipment_xref_cables_journal" */
export type Revisions_Scenario_Equipment_Xref_Cables_Journal_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Revisions_Scenario_Equipment_Xref_Cables_Journal_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Revisions_Scenario_Equipment_Xref_Cables_Journal_Stream_Cursor_Value_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  parent_journal_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  winning_revision_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "revisions.scenario_equipment_xref_cables_journal" */
export enum Revisions_Scenario_Equipment_Xref_Cables_Journal_Update_Column {
  /** column name */
  AuthorId = 'author_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  ParentJournalId = 'parent_journal_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WinningRevisionId = 'winning_revision_id'
}

export type Revisions_Scenario_Equipment_Xref_Cables_Journal_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Revisions_Scenario_Equipment_Xref_Cables_Journal_Set_Input>;
  /** filter the rows which have to be updated */
  where: Revisions_Scenario_Equipment_Xref_Cables_Journal_Bool_Exp;
};

/** columns and relationships of "revisions.scenario_equipment_xref_cables_revisions" */
export type Revisions_Scenario_Equipment_Xref_Cables_Revisions = {
  __typename: 'revisions_scenario_equipment_xref_cables_revisions';
  author_id: Scalars['String']['output'];
  /** An object relationship */
  cable: Cables;
  cable_id: Scalars['uuid']['output'];
  cloned_from_journal_id?: Maybe<Scalars['uuid']['output']>;
  created_at: Scalars['timestamptz']['output'];
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  journal_id: Scalars['uuid']['output'];
  length_feet?: Maybe<Scalars['numeric']['output']>;
  parent_revision_id?: Maybe<Scalars['uuid']['output']>;
  scenario_equipment_id: Scalars['uuid']['output'];
  /** An object relationship */
  scenario_equipment_journal: Revisions_Scenario_Equipment_Journal;
  /** An object relationship */
  scenario_equipment_xref_cables_journal: Revisions_Scenario_Equipment_Xref_Cables_Journal;
  /** An array relationship */
  scenario_equipment_xref_cables_journals: Array<Revisions_Scenario_Equipment_Xref_Cables_Journal>;
  /** An aggregate relationship */
  scenario_equipment_xref_cables_journals_aggregate: Revisions_Scenario_Equipment_Xref_Cables_Journal_Aggregate;
  /** An object relationship */
  scenario_equipment_xref_cables_revision?: Maybe<Revisions_Scenario_Equipment_Xref_Cables_Revisions>;
  /** An array relationship */
  scenario_equipment_xref_cables_revisions: Array<Revisions_Scenario_Equipment_Xref_Cables_Revisions>;
  /** An aggregate relationship */
  scenario_equipment_xref_cables_revisions_aggregate: Revisions_Scenario_Equipment_Xref_Cables_Revisions_Aggregate;
  /** An object relationship */
  scenario_equipment_xref_cables_view?: Maybe<Scenario_Equipment_Xref_Cables>;
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Users;
};


/** columns and relationships of "revisions.scenario_equipment_xref_cables_revisions" */
export type Revisions_Scenario_Equipment_Xref_Cables_RevisionsScenario_Equipment_Xref_Cables_JournalsArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Cables_Journal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Cables_Journal_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Equipment_Xref_Cables_Journal_Bool_Exp>;
};


/** columns and relationships of "revisions.scenario_equipment_xref_cables_revisions" */
export type Revisions_Scenario_Equipment_Xref_Cables_RevisionsScenario_Equipment_Xref_Cables_Journals_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Cables_Journal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Cables_Journal_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Equipment_Xref_Cables_Journal_Bool_Exp>;
};


/** columns and relationships of "revisions.scenario_equipment_xref_cables_revisions" */
export type Revisions_Scenario_Equipment_Xref_Cables_RevisionsScenario_Equipment_Xref_Cables_RevisionsArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Bool_Exp>;
};


/** columns and relationships of "revisions.scenario_equipment_xref_cables_revisions" */
export type Revisions_Scenario_Equipment_Xref_Cables_RevisionsScenario_Equipment_Xref_Cables_Revisions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Bool_Exp>;
};

/** aggregated selection of "revisions.scenario_equipment_xref_cables_revisions" */
export type Revisions_Scenario_Equipment_Xref_Cables_Revisions_Aggregate = {
  __typename: 'revisions_scenario_equipment_xref_cables_revisions_aggregate';
  aggregate?: Maybe<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Aggregate_Fields>;
  nodes: Array<Revisions_Scenario_Equipment_Xref_Cables_Revisions>;
};

export type Revisions_Scenario_Equipment_Xref_Cables_Revisions_Aggregate_Bool_Exp = {
  count?: InputMaybe<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Aggregate_Bool_Exp_Count>;
};

export type Revisions_Scenario_Equipment_Xref_Cables_Revisions_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "revisions.scenario_equipment_xref_cables_revisions" */
export type Revisions_Scenario_Equipment_Xref_Cables_Revisions_Aggregate_Fields = {
  __typename: 'revisions_scenario_equipment_xref_cables_revisions_aggregate_fields';
  avg?: Maybe<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Max_Fields>;
  min?: Maybe<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Min_Fields>;
  stddev?: Maybe<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Stddev_Fields>;
  stddev_pop?: Maybe<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Stddev_Samp_Fields>;
  sum?: Maybe<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Sum_Fields>;
  var_pop?: Maybe<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Var_Pop_Fields>;
  var_samp?: Maybe<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Var_Samp_Fields>;
  variance?: Maybe<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Variance_Fields>;
};


/** aggregate fields of "revisions.scenario_equipment_xref_cables_revisions" */
export type Revisions_Scenario_Equipment_Xref_Cables_Revisions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "revisions.scenario_equipment_xref_cables_revisions" */
export type Revisions_Scenario_Equipment_Xref_Cables_Revisions_Aggregate_Order_By = {
  avg?: InputMaybe<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Max_Order_By>;
  min?: InputMaybe<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Min_Order_By>;
  stddev?: InputMaybe<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Sum_Order_By>;
  var_pop?: InputMaybe<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Var_Samp_Order_By>;
  variance?: InputMaybe<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "revisions.scenario_equipment_xref_cables_revisions" */
export type Revisions_Scenario_Equipment_Xref_Cables_Revisions_Arr_Rel_Insert_Input = {
  data: Array<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Revisions_Scenario_Equipment_Xref_Cables_Revisions_On_Conflict>;
};

/** aggregate avg on columns */
export type Revisions_Scenario_Equipment_Xref_Cables_Revisions_Avg_Fields = {
  __typename: 'revisions_scenario_equipment_xref_cables_revisions_avg_fields';
  length_feet?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "revisions.scenario_equipment_xref_cables_revisions" */
export type Revisions_Scenario_Equipment_Xref_Cables_Revisions_Avg_Order_By = {
  length_feet?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "revisions.scenario_equipment_xref_cables_revisions". All fields are combined with a logical 'AND'. */
export type Revisions_Scenario_Equipment_Xref_Cables_Revisions_Bool_Exp = {
  _and?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Bool_Exp>>;
  _not?: InputMaybe<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Bool_Exp>;
  _or?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Bool_Exp>>;
  author_id?: InputMaybe<String_Comparison_Exp>;
  cable?: InputMaybe<Cables_Bool_Exp>;
  cable_id?: InputMaybe<Uuid_Comparison_Exp>;
  cloned_from_journal_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  journal_id?: InputMaybe<Uuid_Comparison_Exp>;
  length_feet?: InputMaybe<Numeric_Comparison_Exp>;
  parent_revision_id?: InputMaybe<Uuid_Comparison_Exp>;
  scenario_equipment_id?: InputMaybe<Uuid_Comparison_Exp>;
  scenario_equipment_journal?: InputMaybe<Revisions_Scenario_Equipment_Journal_Bool_Exp>;
  scenario_equipment_xref_cables_journal?: InputMaybe<Revisions_Scenario_Equipment_Xref_Cables_Journal_Bool_Exp>;
  scenario_equipment_xref_cables_journals?: InputMaybe<Revisions_Scenario_Equipment_Xref_Cables_Journal_Bool_Exp>;
  scenario_equipment_xref_cables_journals_aggregate?: InputMaybe<Revisions_Scenario_Equipment_Xref_Cables_Journal_Aggregate_Bool_Exp>;
  scenario_equipment_xref_cables_revision?: InputMaybe<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Bool_Exp>;
  scenario_equipment_xref_cables_revisions?: InputMaybe<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Bool_Exp>;
  scenario_equipment_xref_cables_revisions_aggregate?: InputMaybe<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Aggregate_Bool_Exp>;
  scenario_equipment_xref_cables_view?: InputMaybe<Scenario_Equipment_Xref_Cables_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
};

/** unique or primary key constraints on table "revisions.scenario_equipment_xref_cables_revisions" */
export enum Revisions_Scenario_Equipment_Xref_Cables_Revisions_Constraint {
  /** unique or primary key constraint on columns "id" */
  ScenarioEquipmentXrefCablesRevisionsPkey = 'scenario_equipment_xref_cables_revisions_pkey'
}

/** input type for incrementing numeric columns in table "revisions.scenario_equipment_xref_cables_revisions" */
export type Revisions_Scenario_Equipment_Xref_Cables_Revisions_Inc_Input = {
  length_feet?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "revisions.scenario_equipment_xref_cables_revisions" */
export type Revisions_Scenario_Equipment_Xref_Cables_Revisions_Insert_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  cable?: InputMaybe<Cables_Obj_Rel_Insert_Input>;
  cable_id?: InputMaybe<Scalars['uuid']['input']>;
  cloned_from_journal_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  journal_id?: InputMaybe<Scalars['uuid']['input']>;
  length_feet?: InputMaybe<Scalars['numeric']['input']>;
  parent_revision_id?: InputMaybe<Scalars['uuid']['input']>;
  scenario_equipment_id?: InputMaybe<Scalars['uuid']['input']>;
  scenario_equipment_journal?: InputMaybe<Revisions_Scenario_Equipment_Journal_Obj_Rel_Insert_Input>;
  scenario_equipment_xref_cables_journal?: InputMaybe<Revisions_Scenario_Equipment_Xref_Cables_Journal_Obj_Rel_Insert_Input>;
  scenario_equipment_xref_cables_journals?: InputMaybe<Revisions_Scenario_Equipment_Xref_Cables_Journal_Arr_Rel_Insert_Input>;
  scenario_equipment_xref_cables_revision?: InputMaybe<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Obj_Rel_Insert_Input>;
  scenario_equipment_xref_cables_revisions?: InputMaybe<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Arr_Rel_Insert_Input>;
  scenario_equipment_xref_cables_view?: InputMaybe<Scenario_Equipment_Xref_Cables_Obj_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Revisions_Scenario_Equipment_Xref_Cables_Revisions_Max_Fields = {
  __typename: 'revisions_scenario_equipment_xref_cables_revisions_max_fields';
  author_id?: Maybe<Scalars['String']['output']>;
  cable_id?: Maybe<Scalars['uuid']['output']>;
  cloned_from_journal_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  journal_id?: Maybe<Scalars['uuid']['output']>;
  length_feet?: Maybe<Scalars['numeric']['output']>;
  parent_revision_id?: Maybe<Scalars['uuid']['output']>;
  scenario_equipment_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "revisions.scenario_equipment_xref_cables_revisions" */
export type Revisions_Scenario_Equipment_Xref_Cables_Revisions_Max_Order_By = {
  author_id?: InputMaybe<Order_By>;
  cable_id?: InputMaybe<Order_By>;
  cloned_from_journal_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  journal_id?: InputMaybe<Order_By>;
  length_feet?: InputMaybe<Order_By>;
  parent_revision_id?: InputMaybe<Order_By>;
  scenario_equipment_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Revisions_Scenario_Equipment_Xref_Cables_Revisions_Min_Fields = {
  __typename: 'revisions_scenario_equipment_xref_cables_revisions_min_fields';
  author_id?: Maybe<Scalars['String']['output']>;
  cable_id?: Maybe<Scalars['uuid']['output']>;
  cloned_from_journal_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  journal_id?: Maybe<Scalars['uuid']['output']>;
  length_feet?: Maybe<Scalars['numeric']['output']>;
  parent_revision_id?: Maybe<Scalars['uuid']['output']>;
  scenario_equipment_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "revisions.scenario_equipment_xref_cables_revisions" */
export type Revisions_Scenario_Equipment_Xref_Cables_Revisions_Min_Order_By = {
  author_id?: InputMaybe<Order_By>;
  cable_id?: InputMaybe<Order_By>;
  cloned_from_journal_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  journal_id?: InputMaybe<Order_By>;
  length_feet?: InputMaybe<Order_By>;
  parent_revision_id?: InputMaybe<Order_By>;
  scenario_equipment_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "revisions.scenario_equipment_xref_cables_revisions" */
export type Revisions_Scenario_Equipment_Xref_Cables_Revisions_Mutation_Response = {
  __typename: 'revisions_scenario_equipment_xref_cables_revisions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Revisions_Scenario_Equipment_Xref_Cables_Revisions>;
};

/** input type for inserting object relation for remote table "revisions.scenario_equipment_xref_cables_revisions" */
export type Revisions_Scenario_Equipment_Xref_Cables_Revisions_Obj_Rel_Insert_Input = {
  data: Revisions_Scenario_Equipment_Xref_Cables_Revisions_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Revisions_Scenario_Equipment_Xref_Cables_Revisions_On_Conflict>;
};

/** on_conflict condition type for table "revisions.scenario_equipment_xref_cables_revisions" */
export type Revisions_Scenario_Equipment_Xref_Cables_Revisions_On_Conflict = {
  constraint: Revisions_Scenario_Equipment_Xref_Cables_Revisions_Constraint;
  update_columns?: Array<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Update_Column>;
  where?: InputMaybe<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Bool_Exp>;
};

/** Ordering options when selecting data from "revisions.scenario_equipment_xref_cables_revisions". */
export type Revisions_Scenario_Equipment_Xref_Cables_Revisions_Order_By = {
  author_id?: InputMaybe<Order_By>;
  cable?: InputMaybe<Cables_Order_By>;
  cable_id?: InputMaybe<Order_By>;
  cloned_from_journal_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  journal_id?: InputMaybe<Order_By>;
  length_feet?: InputMaybe<Order_By>;
  parent_revision_id?: InputMaybe<Order_By>;
  scenario_equipment_id?: InputMaybe<Order_By>;
  scenario_equipment_journal?: InputMaybe<Revisions_Scenario_Equipment_Journal_Order_By>;
  scenario_equipment_xref_cables_journal?: InputMaybe<Revisions_Scenario_Equipment_Xref_Cables_Journal_Order_By>;
  scenario_equipment_xref_cables_journals_aggregate?: InputMaybe<Revisions_Scenario_Equipment_Xref_Cables_Journal_Aggregate_Order_By>;
  scenario_equipment_xref_cables_revision?: InputMaybe<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Order_By>;
  scenario_equipment_xref_cables_revisions_aggregate?: InputMaybe<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Aggregate_Order_By>;
  scenario_equipment_xref_cables_view?: InputMaybe<Scenario_Equipment_Xref_Cables_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
};

/** primary key columns input for table: revisions.scenario_equipment_xref_cables_revisions */
export type Revisions_Scenario_Equipment_Xref_Cables_Revisions_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "revisions.scenario_equipment_xref_cables_revisions" */
export enum Revisions_Scenario_Equipment_Xref_Cables_Revisions_Select_Column {
  /** column name */
  AuthorId = 'author_id',
  /** column name */
  CableId = 'cable_id',
  /** column name */
  ClonedFromJournalId = 'cloned_from_journal_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  JournalId = 'journal_id',
  /** column name */
  LengthFeet = 'length_feet',
  /** column name */
  ParentRevisionId = 'parent_revision_id',
  /** column name */
  ScenarioEquipmentId = 'scenario_equipment_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "revisions.scenario_equipment_xref_cables_revisions" */
export type Revisions_Scenario_Equipment_Xref_Cables_Revisions_Set_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  cable_id?: InputMaybe<Scalars['uuid']['input']>;
  cloned_from_journal_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  journal_id?: InputMaybe<Scalars['uuid']['input']>;
  length_feet?: InputMaybe<Scalars['numeric']['input']>;
  parent_revision_id?: InputMaybe<Scalars['uuid']['input']>;
  scenario_equipment_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Revisions_Scenario_Equipment_Xref_Cables_Revisions_Stddev_Fields = {
  __typename: 'revisions_scenario_equipment_xref_cables_revisions_stddev_fields';
  length_feet?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "revisions.scenario_equipment_xref_cables_revisions" */
export type Revisions_Scenario_Equipment_Xref_Cables_Revisions_Stddev_Order_By = {
  length_feet?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Revisions_Scenario_Equipment_Xref_Cables_Revisions_Stddev_Pop_Fields = {
  __typename: 'revisions_scenario_equipment_xref_cables_revisions_stddev_pop_fields';
  length_feet?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "revisions.scenario_equipment_xref_cables_revisions" */
export type Revisions_Scenario_Equipment_Xref_Cables_Revisions_Stddev_Pop_Order_By = {
  length_feet?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Revisions_Scenario_Equipment_Xref_Cables_Revisions_Stddev_Samp_Fields = {
  __typename: 'revisions_scenario_equipment_xref_cables_revisions_stddev_samp_fields';
  length_feet?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "revisions.scenario_equipment_xref_cables_revisions" */
export type Revisions_Scenario_Equipment_Xref_Cables_Revisions_Stddev_Samp_Order_By = {
  length_feet?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "revisions_scenario_equipment_xref_cables_revisions" */
export type Revisions_Scenario_Equipment_Xref_Cables_Revisions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Revisions_Scenario_Equipment_Xref_Cables_Revisions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Revisions_Scenario_Equipment_Xref_Cables_Revisions_Stream_Cursor_Value_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  cable_id?: InputMaybe<Scalars['uuid']['input']>;
  cloned_from_journal_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  journal_id?: InputMaybe<Scalars['uuid']['input']>;
  length_feet?: InputMaybe<Scalars['numeric']['input']>;
  parent_revision_id?: InputMaybe<Scalars['uuid']['input']>;
  scenario_equipment_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Revisions_Scenario_Equipment_Xref_Cables_Revisions_Sum_Fields = {
  __typename: 'revisions_scenario_equipment_xref_cables_revisions_sum_fields';
  length_feet?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "revisions.scenario_equipment_xref_cables_revisions" */
export type Revisions_Scenario_Equipment_Xref_Cables_Revisions_Sum_Order_By = {
  length_feet?: InputMaybe<Order_By>;
};

/** update columns of table "revisions.scenario_equipment_xref_cables_revisions" */
export enum Revisions_Scenario_Equipment_Xref_Cables_Revisions_Update_Column {
  /** column name */
  AuthorId = 'author_id',
  /** column name */
  CableId = 'cable_id',
  /** column name */
  ClonedFromJournalId = 'cloned_from_journal_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  JournalId = 'journal_id',
  /** column name */
  LengthFeet = 'length_feet',
  /** column name */
  ParentRevisionId = 'parent_revision_id',
  /** column name */
  ScenarioEquipmentId = 'scenario_equipment_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Revisions_Scenario_Equipment_Xref_Cables_Revisions_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Set_Input>;
  /** filter the rows which have to be updated */
  where: Revisions_Scenario_Equipment_Xref_Cables_Revisions_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Revisions_Scenario_Equipment_Xref_Cables_Revisions_Var_Pop_Fields = {
  __typename: 'revisions_scenario_equipment_xref_cables_revisions_var_pop_fields';
  length_feet?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "revisions.scenario_equipment_xref_cables_revisions" */
export type Revisions_Scenario_Equipment_Xref_Cables_Revisions_Var_Pop_Order_By = {
  length_feet?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Revisions_Scenario_Equipment_Xref_Cables_Revisions_Var_Samp_Fields = {
  __typename: 'revisions_scenario_equipment_xref_cables_revisions_var_samp_fields';
  length_feet?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "revisions.scenario_equipment_xref_cables_revisions" */
export type Revisions_Scenario_Equipment_Xref_Cables_Revisions_Var_Samp_Order_By = {
  length_feet?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Revisions_Scenario_Equipment_Xref_Cables_Revisions_Variance_Fields = {
  __typename: 'revisions_scenario_equipment_xref_cables_revisions_variance_fields';
  length_feet?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "revisions.scenario_equipment_xref_cables_revisions" */
export type Revisions_Scenario_Equipment_Xref_Cables_Revisions_Variance_Order_By = {
  length_feet?: InputMaybe<Order_By>;
};

/** columns and relationships of "revisions.scenario_equipment_xref_housings_journal" */
export type Revisions_Scenario_Equipment_Xref_Housings_Journal = {
  __typename: 'revisions_scenario_equipment_xref_housings_journal';
  author_id: Scalars['String']['output'];
  created_at: Scalars['timestamptz']['output'];
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  parent_journal_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  scenario_equipment_xref_housings_journal?: Maybe<Revisions_Scenario_Equipment_Xref_Housings_Journal>;
  /** An array relationship */
  scenario_equipment_xref_housings_journals: Array<Revisions_Scenario_Equipment_Xref_Housings_Journal>;
  /** An aggregate relationship */
  scenario_equipment_xref_housings_journals_aggregate: Revisions_Scenario_Equipment_Xref_Housings_Journal_Aggregate;
  /** An object relationship */
  scenario_equipment_xref_housings_revision?: Maybe<Revisions_Scenario_Equipment_Xref_Housings_Revisions>;
  /** An array relationship */
  scenario_equipment_xref_housings_revisions: Array<Revisions_Scenario_Equipment_Xref_Housings_Revisions>;
  /** An aggregate relationship */
  scenario_equipment_xref_housings_revisions_aggregate: Revisions_Scenario_Equipment_Xref_Housings_Revisions_Aggregate;
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Users;
  winning_revision_id?: Maybe<Scalars['uuid']['output']>;
};


/** columns and relationships of "revisions.scenario_equipment_xref_housings_journal" */
export type Revisions_Scenario_Equipment_Xref_Housings_JournalScenario_Equipment_Xref_Housings_JournalsArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Housings_Journal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Housings_Journal_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Equipment_Xref_Housings_Journal_Bool_Exp>;
};


/** columns and relationships of "revisions.scenario_equipment_xref_housings_journal" */
export type Revisions_Scenario_Equipment_Xref_Housings_JournalScenario_Equipment_Xref_Housings_Journals_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Housings_Journal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Housings_Journal_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Equipment_Xref_Housings_Journal_Bool_Exp>;
};


/** columns and relationships of "revisions.scenario_equipment_xref_housings_journal" */
export type Revisions_Scenario_Equipment_Xref_Housings_JournalScenario_Equipment_Xref_Housings_RevisionsArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Bool_Exp>;
};


/** columns and relationships of "revisions.scenario_equipment_xref_housings_journal" */
export type Revisions_Scenario_Equipment_Xref_Housings_JournalScenario_Equipment_Xref_Housings_Revisions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Bool_Exp>;
};

/** aggregated selection of "revisions.scenario_equipment_xref_housings_journal" */
export type Revisions_Scenario_Equipment_Xref_Housings_Journal_Aggregate = {
  __typename: 'revisions_scenario_equipment_xref_housings_journal_aggregate';
  aggregate?: Maybe<Revisions_Scenario_Equipment_Xref_Housings_Journal_Aggregate_Fields>;
  nodes: Array<Revisions_Scenario_Equipment_Xref_Housings_Journal>;
};

export type Revisions_Scenario_Equipment_Xref_Housings_Journal_Aggregate_Bool_Exp = {
  count?: InputMaybe<Revisions_Scenario_Equipment_Xref_Housings_Journal_Aggregate_Bool_Exp_Count>;
};

export type Revisions_Scenario_Equipment_Xref_Housings_Journal_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Housings_Journal_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Revisions_Scenario_Equipment_Xref_Housings_Journal_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "revisions.scenario_equipment_xref_housings_journal" */
export type Revisions_Scenario_Equipment_Xref_Housings_Journal_Aggregate_Fields = {
  __typename: 'revisions_scenario_equipment_xref_housings_journal_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Revisions_Scenario_Equipment_Xref_Housings_Journal_Max_Fields>;
  min?: Maybe<Revisions_Scenario_Equipment_Xref_Housings_Journal_Min_Fields>;
};


/** aggregate fields of "revisions.scenario_equipment_xref_housings_journal" */
export type Revisions_Scenario_Equipment_Xref_Housings_Journal_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Housings_Journal_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "revisions.scenario_equipment_xref_housings_journal" */
export type Revisions_Scenario_Equipment_Xref_Housings_Journal_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Revisions_Scenario_Equipment_Xref_Housings_Journal_Max_Order_By>;
  min?: InputMaybe<Revisions_Scenario_Equipment_Xref_Housings_Journal_Min_Order_By>;
};

/** input type for inserting array relation for remote table "revisions.scenario_equipment_xref_housings_journal" */
export type Revisions_Scenario_Equipment_Xref_Housings_Journal_Arr_Rel_Insert_Input = {
  data: Array<Revisions_Scenario_Equipment_Xref_Housings_Journal_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Revisions_Scenario_Equipment_Xref_Housings_Journal_On_Conflict>;
};

/** Boolean expression to filter rows from the table "revisions.scenario_equipment_xref_housings_journal". All fields are combined with a logical 'AND'. */
export type Revisions_Scenario_Equipment_Xref_Housings_Journal_Bool_Exp = {
  _and?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Housings_Journal_Bool_Exp>>;
  _not?: InputMaybe<Revisions_Scenario_Equipment_Xref_Housings_Journal_Bool_Exp>;
  _or?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Housings_Journal_Bool_Exp>>;
  author_id?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  parent_journal_id?: InputMaybe<Uuid_Comparison_Exp>;
  scenario_equipment_xref_housings_journal?: InputMaybe<Revisions_Scenario_Equipment_Xref_Housings_Journal_Bool_Exp>;
  scenario_equipment_xref_housings_journals?: InputMaybe<Revisions_Scenario_Equipment_Xref_Housings_Journal_Bool_Exp>;
  scenario_equipment_xref_housings_journals_aggregate?: InputMaybe<Revisions_Scenario_Equipment_Xref_Housings_Journal_Aggregate_Bool_Exp>;
  scenario_equipment_xref_housings_revision?: InputMaybe<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Bool_Exp>;
  scenario_equipment_xref_housings_revisions?: InputMaybe<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Bool_Exp>;
  scenario_equipment_xref_housings_revisions_aggregate?: InputMaybe<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Aggregate_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  winning_revision_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "revisions.scenario_equipment_xref_housings_journal" */
export enum Revisions_Scenario_Equipment_Xref_Housings_Journal_Constraint {
  /** unique or primary key constraint on columns "id" */
  ScenarioEquipmentXrefHousingsJournalPkey = 'scenario_equipment_xref_housings_journal_pkey'
}

/** input type for inserting data into table "revisions.scenario_equipment_xref_housings_journal" */
export type Revisions_Scenario_Equipment_Xref_Housings_Journal_Insert_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  parent_journal_id?: InputMaybe<Scalars['uuid']['input']>;
  scenario_equipment_xref_housings_journal?: InputMaybe<Revisions_Scenario_Equipment_Xref_Housings_Journal_Obj_Rel_Insert_Input>;
  scenario_equipment_xref_housings_journals?: InputMaybe<Revisions_Scenario_Equipment_Xref_Housings_Journal_Arr_Rel_Insert_Input>;
  scenario_equipment_xref_housings_revision?: InputMaybe<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Obj_Rel_Insert_Input>;
  scenario_equipment_xref_housings_revisions?: InputMaybe<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Arr_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  winning_revision_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Revisions_Scenario_Equipment_Xref_Housings_Journal_Max_Fields = {
  __typename: 'revisions_scenario_equipment_xref_housings_journal_max_fields';
  author_id?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  parent_journal_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  winning_revision_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "revisions.scenario_equipment_xref_housings_journal" */
export type Revisions_Scenario_Equipment_Xref_Housings_Journal_Max_Order_By = {
  author_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parent_journal_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  winning_revision_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Revisions_Scenario_Equipment_Xref_Housings_Journal_Min_Fields = {
  __typename: 'revisions_scenario_equipment_xref_housings_journal_min_fields';
  author_id?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  parent_journal_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  winning_revision_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "revisions.scenario_equipment_xref_housings_journal" */
export type Revisions_Scenario_Equipment_Xref_Housings_Journal_Min_Order_By = {
  author_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parent_journal_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  winning_revision_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "revisions.scenario_equipment_xref_housings_journal" */
export type Revisions_Scenario_Equipment_Xref_Housings_Journal_Mutation_Response = {
  __typename: 'revisions_scenario_equipment_xref_housings_journal_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Revisions_Scenario_Equipment_Xref_Housings_Journal>;
};

/** input type for inserting object relation for remote table "revisions.scenario_equipment_xref_housings_journal" */
export type Revisions_Scenario_Equipment_Xref_Housings_Journal_Obj_Rel_Insert_Input = {
  data: Revisions_Scenario_Equipment_Xref_Housings_Journal_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Revisions_Scenario_Equipment_Xref_Housings_Journal_On_Conflict>;
};

/** on_conflict condition type for table "revisions.scenario_equipment_xref_housings_journal" */
export type Revisions_Scenario_Equipment_Xref_Housings_Journal_On_Conflict = {
  constraint: Revisions_Scenario_Equipment_Xref_Housings_Journal_Constraint;
  update_columns?: Array<Revisions_Scenario_Equipment_Xref_Housings_Journal_Update_Column>;
  where?: InputMaybe<Revisions_Scenario_Equipment_Xref_Housings_Journal_Bool_Exp>;
};

/** Ordering options when selecting data from "revisions.scenario_equipment_xref_housings_journal". */
export type Revisions_Scenario_Equipment_Xref_Housings_Journal_Order_By = {
  author_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parent_journal_id?: InputMaybe<Order_By>;
  scenario_equipment_xref_housings_journal?: InputMaybe<Revisions_Scenario_Equipment_Xref_Housings_Journal_Order_By>;
  scenario_equipment_xref_housings_journals_aggregate?: InputMaybe<Revisions_Scenario_Equipment_Xref_Housings_Journal_Aggregate_Order_By>;
  scenario_equipment_xref_housings_revision?: InputMaybe<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Order_By>;
  scenario_equipment_xref_housings_revisions_aggregate?: InputMaybe<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  winning_revision_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: revisions.scenario_equipment_xref_housings_journal */
export type Revisions_Scenario_Equipment_Xref_Housings_Journal_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "revisions.scenario_equipment_xref_housings_journal" */
export enum Revisions_Scenario_Equipment_Xref_Housings_Journal_Select_Column {
  /** column name */
  AuthorId = 'author_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  ParentJournalId = 'parent_journal_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WinningRevisionId = 'winning_revision_id'
}

/** input type for updating data in table "revisions.scenario_equipment_xref_housings_journal" */
export type Revisions_Scenario_Equipment_Xref_Housings_Journal_Set_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  parent_journal_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  winning_revision_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "revisions_scenario_equipment_xref_housings_journal" */
export type Revisions_Scenario_Equipment_Xref_Housings_Journal_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Revisions_Scenario_Equipment_Xref_Housings_Journal_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Revisions_Scenario_Equipment_Xref_Housings_Journal_Stream_Cursor_Value_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  parent_journal_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  winning_revision_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "revisions.scenario_equipment_xref_housings_journal" */
export enum Revisions_Scenario_Equipment_Xref_Housings_Journal_Update_Column {
  /** column name */
  AuthorId = 'author_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  ParentJournalId = 'parent_journal_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WinningRevisionId = 'winning_revision_id'
}

export type Revisions_Scenario_Equipment_Xref_Housings_Journal_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Revisions_Scenario_Equipment_Xref_Housings_Journal_Set_Input>;
  /** filter the rows which have to be updated */
  where: Revisions_Scenario_Equipment_Xref_Housings_Journal_Bool_Exp;
};

/** columns and relationships of "revisions.scenario_equipment_xref_housings_revisions" */
export type Revisions_Scenario_Equipment_Xref_Housings_Revisions = {
  __typename: 'revisions_scenario_equipment_xref_housings_revisions';
  author_id: Scalars['String']['output'];
  cloned_from_journal_id?: Maybe<Scalars['uuid']['output']>;
  created_at: Scalars['timestamptz']['output'];
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  housing: Housings;
  housing_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  journal_id: Scalars['uuid']['output'];
  length_inches?: Maybe<Scalars['numeric']['output']>;
  parent_revision_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  scenario_equipment_xref_housings_journal: Revisions_Scenario_Equipment_Xref_Housings_Journal;
  /** An array relationship */
  scenario_equipment_xref_housings_journals: Array<Revisions_Scenario_Equipment_Xref_Housings_Journal>;
  /** An aggregate relationship */
  scenario_equipment_xref_housings_journals_aggregate: Revisions_Scenario_Equipment_Xref_Housings_Journal_Aggregate;
  /** An object relationship */
  scenario_equipment_xref_housings_revision?: Maybe<Revisions_Scenario_Equipment_Xref_Housings_Revisions>;
  /** An array relationship */
  scenario_equipment_xref_housings_revisions: Array<Revisions_Scenario_Equipment_Xref_Housings_Revisions>;
  /** An aggregate relationship */
  scenario_equipment_xref_housings_revisions_aggregate: Revisions_Scenario_Equipment_Xref_Housings_Revisions_Aggregate;
  /** An object relationship */
  scenario_equipment_xref_housings_view?: Maybe<Scenario_Equipment_Xref_Housings>;
  scenario_equipment_xref_pump_id: Scalars['uuid']['output'];
  /** An object relationship */
  scenario_equipment_xref_pumps_journal: Revisions_Scenario_Equipment_Xref_Pumps_Journal;
  stage_count?: Maybe<Scalars['Int']['output']>;
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Users;
};


/** columns and relationships of "revisions.scenario_equipment_xref_housings_revisions" */
export type Revisions_Scenario_Equipment_Xref_Housings_RevisionsScenario_Equipment_Xref_Housings_JournalsArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Housings_Journal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Housings_Journal_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Equipment_Xref_Housings_Journal_Bool_Exp>;
};


/** columns and relationships of "revisions.scenario_equipment_xref_housings_revisions" */
export type Revisions_Scenario_Equipment_Xref_Housings_RevisionsScenario_Equipment_Xref_Housings_Journals_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Housings_Journal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Housings_Journal_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Equipment_Xref_Housings_Journal_Bool_Exp>;
};


/** columns and relationships of "revisions.scenario_equipment_xref_housings_revisions" */
export type Revisions_Scenario_Equipment_Xref_Housings_RevisionsScenario_Equipment_Xref_Housings_RevisionsArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Bool_Exp>;
};


/** columns and relationships of "revisions.scenario_equipment_xref_housings_revisions" */
export type Revisions_Scenario_Equipment_Xref_Housings_RevisionsScenario_Equipment_Xref_Housings_Revisions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Bool_Exp>;
};

/** aggregated selection of "revisions.scenario_equipment_xref_housings_revisions" */
export type Revisions_Scenario_Equipment_Xref_Housings_Revisions_Aggregate = {
  __typename: 'revisions_scenario_equipment_xref_housings_revisions_aggregate';
  aggregate?: Maybe<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Aggregate_Fields>;
  nodes: Array<Revisions_Scenario_Equipment_Xref_Housings_Revisions>;
};

export type Revisions_Scenario_Equipment_Xref_Housings_Revisions_Aggregate_Bool_Exp = {
  count?: InputMaybe<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Aggregate_Bool_Exp_Count>;
};

export type Revisions_Scenario_Equipment_Xref_Housings_Revisions_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "revisions.scenario_equipment_xref_housings_revisions" */
export type Revisions_Scenario_Equipment_Xref_Housings_Revisions_Aggregate_Fields = {
  __typename: 'revisions_scenario_equipment_xref_housings_revisions_aggregate_fields';
  avg?: Maybe<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Max_Fields>;
  min?: Maybe<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Min_Fields>;
  stddev?: Maybe<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Stddev_Fields>;
  stddev_pop?: Maybe<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Stddev_Samp_Fields>;
  sum?: Maybe<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Sum_Fields>;
  var_pop?: Maybe<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Var_Pop_Fields>;
  var_samp?: Maybe<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Var_Samp_Fields>;
  variance?: Maybe<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Variance_Fields>;
};


/** aggregate fields of "revisions.scenario_equipment_xref_housings_revisions" */
export type Revisions_Scenario_Equipment_Xref_Housings_Revisions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "revisions.scenario_equipment_xref_housings_revisions" */
export type Revisions_Scenario_Equipment_Xref_Housings_Revisions_Aggregate_Order_By = {
  avg?: InputMaybe<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Max_Order_By>;
  min?: InputMaybe<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Min_Order_By>;
  stddev?: InputMaybe<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Sum_Order_By>;
  var_pop?: InputMaybe<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Var_Samp_Order_By>;
  variance?: InputMaybe<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "revisions.scenario_equipment_xref_housings_revisions" */
export type Revisions_Scenario_Equipment_Xref_Housings_Revisions_Arr_Rel_Insert_Input = {
  data: Array<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Revisions_Scenario_Equipment_Xref_Housings_Revisions_On_Conflict>;
};

/** aggregate avg on columns */
export type Revisions_Scenario_Equipment_Xref_Housings_Revisions_Avg_Fields = {
  __typename: 'revisions_scenario_equipment_xref_housings_revisions_avg_fields';
  length_inches?: Maybe<Scalars['Float']['output']>;
  stage_count?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "revisions.scenario_equipment_xref_housings_revisions" */
export type Revisions_Scenario_Equipment_Xref_Housings_Revisions_Avg_Order_By = {
  length_inches?: InputMaybe<Order_By>;
  stage_count?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "revisions.scenario_equipment_xref_housings_revisions". All fields are combined with a logical 'AND'. */
export type Revisions_Scenario_Equipment_Xref_Housings_Revisions_Bool_Exp = {
  _and?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Bool_Exp>>;
  _not?: InputMaybe<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Bool_Exp>;
  _or?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Bool_Exp>>;
  author_id?: InputMaybe<String_Comparison_Exp>;
  cloned_from_journal_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  housing?: InputMaybe<Housings_Bool_Exp>;
  housing_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  journal_id?: InputMaybe<Uuid_Comparison_Exp>;
  length_inches?: InputMaybe<Numeric_Comparison_Exp>;
  parent_revision_id?: InputMaybe<Uuid_Comparison_Exp>;
  scenario_equipment_xref_housings_journal?: InputMaybe<Revisions_Scenario_Equipment_Xref_Housings_Journal_Bool_Exp>;
  scenario_equipment_xref_housings_journals?: InputMaybe<Revisions_Scenario_Equipment_Xref_Housings_Journal_Bool_Exp>;
  scenario_equipment_xref_housings_journals_aggregate?: InputMaybe<Revisions_Scenario_Equipment_Xref_Housings_Journal_Aggregate_Bool_Exp>;
  scenario_equipment_xref_housings_revision?: InputMaybe<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Bool_Exp>;
  scenario_equipment_xref_housings_revisions?: InputMaybe<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Bool_Exp>;
  scenario_equipment_xref_housings_revisions_aggregate?: InputMaybe<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Aggregate_Bool_Exp>;
  scenario_equipment_xref_housings_view?: InputMaybe<Scenario_Equipment_Xref_Housings_Bool_Exp>;
  scenario_equipment_xref_pump_id?: InputMaybe<Uuid_Comparison_Exp>;
  scenario_equipment_xref_pumps_journal?: InputMaybe<Revisions_Scenario_Equipment_Xref_Pumps_Journal_Bool_Exp>;
  stage_count?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
};

/** unique or primary key constraints on table "revisions.scenario_equipment_xref_housings_revisions" */
export enum Revisions_Scenario_Equipment_Xref_Housings_Revisions_Constraint {
  /** unique or primary key constraint on columns "id" */
  ScenarioEquipmentXrefHousingsRevisionsPkey = 'scenario_equipment_xref_housings_revisions_pkey'
}

/** input type for incrementing numeric columns in table "revisions.scenario_equipment_xref_housings_revisions" */
export type Revisions_Scenario_Equipment_Xref_Housings_Revisions_Inc_Input = {
  length_inches?: InputMaybe<Scalars['numeric']['input']>;
  stage_count?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "revisions.scenario_equipment_xref_housings_revisions" */
export type Revisions_Scenario_Equipment_Xref_Housings_Revisions_Insert_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  cloned_from_journal_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  housing?: InputMaybe<Housings_Obj_Rel_Insert_Input>;
  housing_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  journal_id?: InputMaybe<Scalars['uuid']['input']>;
  length_inches?: InputMaybe<Scalars['numeric']['input']>;
  parent_revision_id?: InputMaybe<Scalars['uuid']['input']>;
  scenario_equipment_xref_housings_journal?: InputMaybe<Revisions_Scenario_Equipment_Xref_Housings_Journal_Obj_Rel_Insert_Input>;
  scenario_equipment_xref_housings_journals?: InputMaybe<Revisions_Scenario_Equipment_Xref_Housings_Journal_Arr_Rel_Insert_Input>;
  scenario_equipment_xref_housings_revision?: InputMaybe<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Obj_Rel_Insert_Input>;
  scenario_equipment_xref_housings_revisions?: InputMaybe<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Arr_Rel_Insert_Input>;
  scenario_equipment_xref_housings_view?: InputMaybe<Scenario_Equipment_Xref_Housings_Obj_Rel_Insert_Input>;
  scenario_equipment_xref_pump_id?: InputMaybe<Scalars['uuid']['input']>;
  scenario_equipment_xref_pumps_journal?: InputMaybe<Revisions_Scenario_Equipment_Xref_Pumps_Journal_Obj_Rel_Insert_Input>;
  stage_count?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Revisions_Scenario_Equipment_Xref_Housings_Revisions_Max_Fields = {
  __typename: 'revisions_scenario_equipment_xref_housings_revisions_max_fields';
  author_id?: Maybe<Scalars['String']['output']>;
  cloned_from_journal_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  housing_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  journal_id?: Maybe<Scalars['uuid']['output']>;
  length_inches?: Maybe<Scalars['numeric']['output']>;
  parent_revision_id?: Maybe<Scalars['uuid']['output']>;
  scenario_equipment_xref_pump_id?: Maybe<Scalars['uuid']['output']>;
  stage_count?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "revisions.scenario_equipment_xref_housings_revisions" */
export type Revisions_Scenario_Equipment_Xref_Housings_Revisions_Max_Order_By = {
  author_id?: InputMaybe<Order_By>;
  cloned_from_journal_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  housing_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  journal_id?: InputMaybe<Order_By>;
  length_inches?: InputMaybe<Order_By>;
  parent_revision_id?: InputMaybe<Order_By>;
  scenario_equipment_xref_pump_id?: InputMaybe<Order_By>;
  stage_count?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Revisions_Scenario_Equipment_Xref_Housings_Revisions_Min_Fields = {
  __typename: 'revisions_scenario_equipment_xref_housings_revisions_min_fields';
  author_id?: Maybe<Scalars['String']['output']>;
  cloned_from_journal_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  housing_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  journal_id?: Maybe<Scalars['uuid']['output']>;
  length_inches?: Maybe<Scalars['numeric']['output']>;
  parent_revision_id?: Maybe<Scalars['uuid']['output']>;
  scenario_equipment_xref_pump_id?: Maybe<Scalars['uuid']['output']>;
  stage_count?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "revisions.scenario_equipment_xref_housings_revisions" */
export type Revisions_Scenario_Equipment_Xref_Housings_Revisions_Min_Order_By = {
  author_id?: InputMaybe<Order_By>;
  cloned_from_journal_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  housing_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  journal_id?: InputMaybe<Order_By>;
  length_inches?: InputMaybe<Order_By>;
  parent_revision_id?: InputMaybe<Order_By>;
  scenario_equipment_xref_pump_id?: InputMaybe<Order_By>;
  stage_count?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "revisions.scenario_equipment_xref_housings_revisions" */
export type Revisions_Scenario_Equipment_Xref_Housings_Revisions_Mutation_Response = {
  __typename: 'revisions_scenario_equipment_xref_housings_revisions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Revisions_Scenario_Equipment_Xref_Housings_Revisions>;
};

/** input type for inserting object relation for remote table "revisions.scenario_equipment_xref_housings_revisions" */
export type Revisions_Scenario_Equipment_Xref_Housings_Revisions_Obj_Rel_Insert_Input = {
  data: Revisions_Scenario_Equipment_Xref_Housings_Revisions_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Revisions_Scenario_Equipment_Xref_Housings_Revisions_On_Conflict>;
};

/** on_conflict condition type for table "revisions.scenario_equipment_xref_housings_revisions" */
export type Revisions_Scenario_Equipment_Xref_Housings_Revisions_On_Conflict = {
  constraint: Revisions_Scenario_Equipment_Xref_Housings_Revisions_Constraint;
  update_columns?: Array<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Update_Column>;
  where?: InputMaybe<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Bool_Exp>;
};

/** Ordering options when selecting data from "revisions.scenario_equipment_xref_housings_revisions". */
export type Revisions_Scenario_Equipment_Xref_Housings_Revisions_Order_By = {
  author_id?: InputMaybe<Order_By>;
  cloned_from_journal_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  housing?: InputMaybe<Housings_Order_By>;
  housing_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  journal_id?: InputMaybe<Order_By>;
  length_inches?: InputMaybe<Order_By>;
  parent_revision_id?: InputMaybe<Order_By>;
  scenario_equipment_xref_housings_journal?: InputMaybe<Revisions_Scenario_Equipment_Xref_Housings_Journal_Order_By>;
  scenario_equipment_xref_housings_journals_aggregate?: InputMaybe<Revisions_Scenario_Equipment_Xref_Housings_Journal_Aggregate_Order_By>;
  scenario_equipment_xref_housings_revision?: InputMaybe<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Order_By>;
  scenario_equipment_xref_housings_revisions_aggregate?: InputMaybe<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Aggregate_Order_By>;
  scenario_equipment_xref_housings_view?: InputMaybe<Scenario_Equipment_Xref_Housings_Order_By>;
  scenario_equipment_xref_pump_id?: InputMaybe<Order_By>;
  scenario_equipment_xref_pumps_journal?: InputMaybe<Revisions_Scenario_Equipment_Xref_Pumps_Journal_Order_By>;
  stage_count?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
};

/** primary key columns input for table: revisions.scenario_equipment_xref_housings_revisions */
export type Revisions_Scenario_Equipment_Xref_Housings_Revisions_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "revisions.scenario_equipment_xref_housings_revisions" */
export enum Revisions_Scenario_Equipment_Xref_Housings_Revisions_Select_Column {
  /** column name */
  AuthorId = 'author_id',
  /** column name */
  ClonedFromJournalId = 'cloned_from_journal_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  HousingId = 'housing_id',
  /** column name */
  Id = 'id',
  /** column name */
  JournalId = 'journal_id',
  /** column name */
  LengthInches = 'length_inches',
  /** column name */
  ParentRevisionId = 'parent_revision_id',
  /** column name */
  ScenarioEquipmentXrefPumpId = 'scenario_equipment_xref_pump_id',
  /** column name */
  StageCount = 'stage_count',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "revisions.scenario_equipment_xref_housings_revisions" */
export type Revisions_Scenario_Equipment_Xref_Housings_Revisions_Set_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  cloned_from_journal_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  housing_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  journal_id?: InputMaybe<Scalars['uuid']['input']>;
  length_inches?: InputMaybe<Scalars['numeric']['input']>;
  parent_revision_id?: InputMaybe<Scalars['uuid']['input']>;
  scenario_equipment_xref_pump_id?: InputMaybe<Scalars['uuid']['input']>;
  stage_count?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Revisions_Scenario_Equipment_Xref_Housings_Revisions_Stddev_Fields = {
  __typename: 'revisions_scenario_equipment_xref_housings_revisions_stddev_fields';
  length_inches?: Maybe<Scalars['Float']['output']>;
  stage_count?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "revisions.scenario_equipment_xref_housings_revisions" */
export type Revisions_Scenario_Equipment_Xref_Housings_Revisions_Stddev_Order_By = {
  length_inches?: InputMaybe<Order_By>;
  stage_count?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Revisions_Scenario_Equipment_Xref_Housings_Revisions_Stddev_Pop_Fields = {
  __typename: 'revisions_scenario_equipment_xref_housings_revisions_stddev_pop_fields';
  length_inches?: Maybe<Scalars['Float']['output']>;
  stage_count?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "revisions.scenario_equipment_xref_housings_revisions" */
export type Revisions_Scenario_Equipment_Xref_Housings_Revisions_Stddev_Pop_Order_By = {
  length_inches?: InputMaybe<Order_By>;
  stage_count?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Revisions_Scenario_Equipment_Xref_Housings_Revisions_Stddev_Samp_Fields = {
  __typename: 'revisions_scenario_equipment_xref_housings_revisions_stddev_samp_fields';
  length_inches?: Maybe<Scalars['Float']['output']>;
  stage_count?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "revisions.scenario_equipment_xref_housings_revisions" */
export type Revisions_Scenario_Equipment_Xref_Housings_Revisions_Stddev_Samp_Order_By = {
  length_inches?: InputMaybe<Order_By>;
  stage_count?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "revisions_scenario_equipment_xref_housings_revisions" */
export type Revisions_Scenario_Equipment_Xref_Housings_Revisions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Revisions_Scenario_Equipment_Xref_Housings_Revisions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Revisions_Scenario_Equipment_Xref_Housings_Revisions_Stream_Cursor_Value_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  cloned_from_journal_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  housing_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  journal_id?: InputMaybe<Scalars['uuid']['input']>;
  length_inches?: InputMaybe<Scalars['numeric']['input']>;
  parent_revision_id?: InputMaybe<Scalars['uuid']['input']>;
  scenario_equipment_xref_pump_id?: InputMaybe<Scalars['uuid']['input']>;
  stage_count?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Revisions_Scenario_Equipment_Xref_Housings_Revisions_Sum_Fields = {
  __typename: 'revisions_scenario_equipment_xref_housings_revisions_sum_fields';
  length_inches?: Maybe<Scalars['numeric']['output']>;
  stage_count?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "revisions.scenario_equipment_xref_housings_revisions" */
export type Revisions_Scenario_Equipment_Xref_Housings_Revisions_Sum_Order_By = {
  length_inches?: InputMaybe<Order_By>;
  stage_count?: InputMaybe<Order_By>;
};

/** update columns of table "revisions.scenario_equipment_xref_housings_revisions" */
export enum Revisions_Scenario_Equipment_Xref_Housings_Revisions_Update_Column {
  /** column name */
  AuthorId = 'author_id',
  /** column name */
  ClonedFromJournalId = 'cloned_from_journal_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  HousingId = 'housing_id',
  /** column name */
  Id = 'id',
  /** column name */
  JournalId = 'journal_id',
  /** column name */
  LengthInches = 'length_inches',
  /** column name */
  ParentRevisionId = 'parent_revision_id',
  /** column name */
  ScenarioEquipmentXrefPumpId = 'scenario_equipment_xref_pump_id',
  /** column name */
  StageCount = 'stage_count',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Revisions_Scenario_Equipment_Xref_Housings_Revisions_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Set_Input>;
  /** filter the rows which have to be updated */
  where: Revisions_Scenario_Equipment_Xref_Housings_Revisions_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Revisions_Scenario_Equipment_Xref_Housings_Revisions_Var_Pop_Fields = {
  __typename: 'revisions_scenario_equipment_xref_housings_revisions_var_pop_fields';
  length_inches?: Maybe<Scalars['Float']['output']>;
  stage_count?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "revisions.scenario_equipment_xref_housings_revisions" */
export type Revisions_Scenario_Equipment_Xref_Housings_Revisions_Var_Pop_Order_By = {
  length_inches?: InputMaybe<Order_By>;
  stage_count?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Revisions_Scenario_Equipment_Xref_Housings_Revisions_Var_Samp_Fields = {
  __typename: 'revisions_scenario_equipment_xref_housings_revisions_var_samp_fields';
  length_inches?: Maybe<Scalars['Float']['output']>;
  stage_count?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "revisions.scenario_equipment_xref_housings_revisions" */
export type Revisions_Scenario_Equipment_Xref_Housings_Revisions_Var_Samp_Order_By = {
  length_inches?: InputMaybe<Order_By>;
  stage_count?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Revisions_Scenario_Equipment_Xref_Housings_Revisions_Variance_Fields = {
  __typename: 'revisions_scenario_equipment_xref_housings_revisions_variance_fields';
  length_inches?: Maybe<Scalars['Float']['output']>;
  stage_count?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "revisions.scenario_equipment_xref_housings_revisions" */
export type Revisions_Scenario_Equipment_Xref_Housings_Revisions_Variance_Order_By = {
  length_inches?: InputMaybe<Order_By>;
  stage_count?: InputMaybe<Order_By>;
};

/** columns and relationships of "revisions.scenario_equipment_xref_intakes_journal" */
export type Revisions_Scenario_Equipment_Xref_Intakes_Journal = {
  __typename: 'revisions_scenario_equipment_xref_intakes_journal';
  author_id: Scalars['String']['output'];
  created_at: Scalars['timestamptz']['output'];
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  parent_journal_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  scenario_equipment_xref_intakes_journal?: Maybe<Revisions_Scenario_Equipment_Xref_Intakes_Journal>;
  /** An array relationship */
  scenario_equipment_xref_intakes_journals: Array<Revisions_Scenario_Equipment_Xref_Intakes_Journal>;
  /** An aggregate relationship */
  scenario_equipment_xref_intakes_journals_aggregate: Revisions_Scenario_Equipment_Xref_Intakes_Journal_Aggregate;
  /** An object relationship */
  scenario_equipment_xref_intakes_revision?: Maybe<Revisions_Scenario_Equipment_Xref_Intakes_Revisions>;
  /** An array relationship */
  scenario_equipment_xref_intakes_revisions: Array<Revisions_Scenario_Equipment_Xref_Intakes_Revisions>;
  /** An aggregate relationship */
  scenario_equipment_xref_intakes_revisions_aggregate: Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Aggregate;
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Users;
  winning_revision_id?: Maybe<Scalars['uuid']['output']>;
};


/** columns and relationships of "revisions.scenario_equipment_xref_intakes_journal" */
export type Revisions_Scenario_Equipment_Xref_Intakes_JournalScenario_Equipment_Xref_Intakes_JournalsArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Intakes_Journal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Intakes_Journal_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Equipment_Xref_Intakes_Journal_Bool_Exp>;
};


/** columns and relationships of "revisions.scenario_equipment_xref_intakes_journal" */
export type Revisions_Scenario_Equipment_Xref_Intakes_JournalScenario_Equipment_Xref_Intakes_Journals_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Intakes_Journal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Intakes_Journal_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Equipment_Xref_Intakes_Journal_Bool_Exp>;
};


/** columns and relationships of "revisions.scenario_equipment_xref_intakes_journal" */
export type Revisions_Scenario_Equipment_Xref_Intakes_JournalScenario_Equipment_Xref_Intakes_RevisionsArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Bool_Exp>;
};


/** columns and relationships of "revisions.scenario_equipment_xref_intakes_journal" */
export type Revisions_Scenario_Equipment_Xref_Intakes_JournalScenario_Equipment_Xref_Intakes_Revisions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Bool_Exp>;
};

/** aggregated selection of "revisions.scenario_equipment_xref_intakes_journal" */
export type Revisions_Scenario_Equipment_Xref_Intakes_Journal_Aggregate = {
  __typename: 'revisions_scenario_equipment_xref_intakes_journal_aggregate';
  aggregate?: Maybe<Revisions_Scenario_Equipment_Xref_Intakes_Journal_Aggregate_Fields>;
  nodes: Array<Revisions_Scenario_Equipment_Xref_Intakes_Journal>;
};

export type Revisions_Scenario_Equipment_Xref_Intakes_Journal_Aggregate_Bool_Exp = {
  count?: InputMaybe<Revisions_Scenario_Equipment_Xref_Intakes_Journal_Aggregate_Bool_Exp_Count>;
};

export type Revisions_Scenario_Equipment_Xref_Intakes_Journal_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Intakes_Journal_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Revisions_Scenario_Equipment_Xref_Intakes_Journal_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "revisions.scenario_equipment_xref_intakes_journal" */
export type Revisions_Scenario_Equipment_Xref_Intakes_Journal_Aggregate_Fields = {
  __typename: 'revisions_scenario_equipment_xref_intakes_journal_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Revisions_Scenario_Equipment_Xref_Intakes_Journal_Max_Fields>;
  min?: Maybe<Revisions_Scenario_Equipment_Xref_Intakes_Journal_Min_Fields>;
};


/** aggregate fields of "revisions.scenario_equipment_xref_intakes_journal" */
export type Revisions_Scenario_Equipment_Xref_Intakes_Journal_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Intakes_Journal_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "revisions.scenario_equipment_xref_intakes_journal" */
export type Revisions_Scenario_Equipment_Xref_Intakes_Journal_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Revisions_Scenario_Equipment_Xref_Intakes_Journal_Max_Order_By>;
  min?: InputMaybe<Revisions_Scenario_Equipment_Xref_Intakes_Journal_Min_Order_By>;
};

/** input type for inserting array relation for remote table "revisions.scenario_equipment_xref_intakes_journal" */
export type Revisions_Scenario_Equipment_Xref_Intakes_Journal_Arr_Rel_Insert_Input = {
  data: Array<Revisions_Scenario_Equipment_Xref_Intakes_Journal_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Revisions_Scenario_Equipment_Xref_Intakes_Journal_On_Conflict>;
};

/** Boolean expression to filter rows from the table "revisions.scenario_equipment_xref_intakes_journal". All fields are combined with a logical 'AND'. */
export type Revisions_Scenario_Equipment_Xref_Intakes_Journal_Bool_Exp = {
  _and?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Intakes_Journal_Bool_Exp>>;
  _not?: InputMaybe<Revisions_Scenario_Equipment_Xref_Intakes_Journal_Bool_Exp>;
  _or?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Intakes_Journal_Bool_Exp>>;
  author_id?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  parent_journal_id?: InputMaybe<Uuid_Comparison_Exp>;
  scenario_equipment_xref_intakes_journal?: InputMaybe<Revisions_Scenario_Equipment_Xref_Intakes_Journal_Bool_Exp>;
  scenario_equipment_xref_intakes_journals?: InputMaybe<Revisions_Scenario_Equipment_Xref_Intakes_Journal_Bool_Exp>;
  scenario_equipment_xref_intakes_journals_aggregate?: InputMaybe<Revisions_Scenario_Equipment_Xref_Intakes_Journal_Aggregate_Bool_Exp>;
  scenario_equipment_xref_intakes_revision?: InputMaybe<Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Bool_Exp>;
  scenario_equipment_xref_intakes_revisions?: InputMaybe<Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Bool_Exp>;
  scenario_equipment_xref_intakes_revisions_aggregate?: InputMaybe<Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Aggregate_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  winning_revision_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "revisions.scenario_equipment_xref_intakes_journal" */
export enum Revisions_Scenario_Equipment_Xref_Intakes_Journal_Constraint {
  /** unique or primary key constraint on columns "id" */
  ScenarioEquipmentXrefIntakesJournalPkey = 'scenario_equipment_xref_intakes_journal_pkey'
}

/** input type for inserting data into table "revisions.scenario_equipment_xref_intakes_journal" */
export type Revisions_Scenario_Equipment_Xref_Intakes_Journal_Insert_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  parent_journal_id?: InputMaybe<Scalars['uuid']['input']>;
  scenario_equipment_xref_intakes_journal?: InputMaybe<Revisions_Scenario_Equipment_Xref_Intakes_Journal_Obj_Rel_Insert_Input>;
  scenario_equipment_xref_intakes_journals?: InputMaybe<Revisions_Scenario_Equipment_Xref_Intakes_Journal_Arr_Rel_Insert_Input>;
  scenario_equipment_xref_intakes_revision?: InputMaybe<Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Obj_Rel_Insert_Input>;
  scenario_equipment_xref_intakes_revisions?: InputMaybe<Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Arr_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  winning_revision_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Revisions_Scenario_Equipment_Xref_Intakes_Journal_Max_Fields = {
  __typename: 'revisions_scenario_equipment_xref_intakes_journal_max_fields';
  author_id?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  parent_journal_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  winning_revision_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "revisions.scenario_equipment_xref_intakes_journal" */
export type Revisions_Scenario_Equipment_Xref_Intakes_Journal_Max_Order_By = {
  author_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parent_journal_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  winning_revision_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Revisions_Scenario_Equipment_Xref_Intakes_Journal_Min_Fields = {
  __typename: 'revisions_scenario_equipment_xref_intakes_journal_min_fields';
  author_id?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  parent_journal_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  winning_revision_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "revisions.scenario_equipment_xref_intakes_journal" */
export type Revisions_Scenario_Equipment_Xref_Intakes_Journal_Min_Order_By = {
  author_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parent_journal_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  winning_revision_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "revisions.scenario_equipment_xref_intakes_journal" */
export type Revisions_Scenario_Equipment_Xref_Intakes_Journal_Mutation_Response = {
  __typename: 'revisions_scenario_equipment_xref_intakes_journal_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Revisions_Scenario_Equipment_Xref_Intakes_Journal>;
};

/** input type for inserting object relation for remote table "revisions.scenario_equipment_xref_intakes_journal" */
export type Revisions_Scenario_Equipment_Xref_Intakes_Journal_Obj_Rel_Insert_Input = {
  data: Revisions_Scenario_Equipment_Xref_Intakes_Journal_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Revisions_Scenario_Equipment_Xref_Intakes_Journal_On_Conflict>;
};

/** on_conflict condition type for table "revisions.scenario_equipment_xref_intakes_journal" */
export type Revisions_Scenario_Equipment_Xref_Intakes_Journal_On_Conflict = {
  constraint: Revisions_Scenario_Equipment_Xref_Intakes_Journal_Constraint;
  update_columns?: Array<Revisions_Scenario_Equipment_Xref_Intakes_Journal_Update_Column>;
  where?: InputMaybe<Revisions_Scenario_Equipment_Xref_Intakes_Journal_Bool_Exp>;
};

/** Ordering options when selecting data from "revisions.scenario_equipment_xref_intakes_journal". */
export type Revisions_Scenario_Equipment_Xref_Intakes_Journal_Order_By = {
  author_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parent_journal_id?: InputMaybe<Order_By>;
  scenario_equipment_xref_intakes_journal?: InputMaybe<Revisions_Scenario_Equipment_Xref_Intakes_Journal_Order_By>;
  scenario_equipment_xref_intakes_journals_aggregate?: InputMaybe<Revisions_Scenario_Equipment_Xref_Intakes_Journal_Aggregate_Order_By>;
  scenario_equipment_xref_intakes_revision?: InputMaybe<Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Order_By>;
  scenario_equipment_xref_intakes_revisions_aggregate?: InputMaybe<Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  winning_revision_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: revisions.scenario_equipment_xref_intakes_journal */
export type Revisions_Scenario_Equipment_Xref_Intakes_Journal_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "revisions.scenario_equipment_xref_intakes_journal" */
export enum Revisions_Scenario_Equipment_Xref_Intakes_Journal_Select_Column {
  /** column name */
  AuthorId = 'author_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  ParentJournalId = 'parent_journal_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WinningRevisionId = 'winning_revision_id'
}

/** input type for updating data in table "revisions.scenario_equipment_xref_intakes_journal" */
export type Revisions_Scenario_Equipment_Xref_Intakes_Journal_Set_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  parent_journal_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  winning_revision_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "revisions_scenario_equipment_xref_intakes_journal" */
export type Revisions_Scenario_Equipment_Xref_Intakes_Journal_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Revisions_Scenario_Equipment_Xref_Intakes_Journal_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Revisions_Scenario_Equipment_Xref_Intakes_Journal_Stream_Cursor_Value_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  parent_journal_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  winning_revision_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "revisions.scenario_equipment_xref_intakes_journal" */
export enum Revisions_Scenario_Equipment_Xref_Intakes_Journal_Update_Column {
  /** column name */
  AuthorId = 'author_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  ParentJournalId = 'parent_journal_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WinningRevisionId = 'winning_revision_id'
}

export type Revisions_Scenario_Equipment_Xref_Intakes_Journal_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Revisions_Scenario_Equipment_Xref_Intakes_Journal_Set_Input>;
  /** filter the rows which have to be updated */
  where: Revisions_Scenario_Equipment_Xref_Intakes_Journal_Bool_Exp;
};

/** columns and relationships of "revisions.scenario_equipment_xref_intakes_revisions" */
export type Revisions_Scenario_Equipment_Xref_Intakes_Revisions = {
  __typename: 'revisions_scenario_equipment_xref_intakes_revisions';
  author_id: Scalars['String']['output'];
  cloned_from_journal_id?: Maybe<Scalars['uuid']['output']>;
  created_at: Scalars['timestamptz']['output'];
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  intake: Intakes;
  intake_id: Scalars['uuid']['output'];
  journal_id: Scalars['uuid']['output'];
  parent_revision_id?: Maybe<Scalars['uuid']['output']>;
  scenario_equipment_id: Scalars['uuid']['output'];
  /** An object relationship */
  scenario_equipment_journal: Revisions_Scenario_Equipment_Journal;
  /** An object relationship */
  scenario_equipment_xref_intakes_journal: Revisions_Scenario_Equipment_Xref_Intakes_Journal;
  /** An array relationship */
  scenario_equipment_xref_intakes_journals: Array<Revisions_Scenario_Equipment_Xref_Intakes_Journal>;
  /** An aggregate relationship */
  scenario_equipment_xref_intakes_journals_aggregate: Revisions_Scenario_Equipment_Xref_Intakes_Journal_Aggregate;
  /** An object relationship */
  scenario_equipment_xref_intakes_revision?: Maybe<Revisions_Scenario_Equipment_Xref_Intakes_Revisions>;
  /** An array relationship */
  scenario_equipment_xref_intakes_revisions: Array<Revisions_Scenario_Equipment_Xref_Intakes_Revisions>;
  /** An aggregate relationship */
  scenario_equipment_xref_intakes_revisions_aggregate: Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Aggregate;
  /** An object relationship */
  scenario_equipment_xref_intakes_view?: Maybe<Scenario_Equipment_Xref_Intakes>;
  updated_at: Scalars['timestamptz']['output'];
  use_high_strength_shaft: Scalars['Boolean']['output'];
  /** An object relationship */
  user: Users;
};


/** columns and relationships of "revisions.scenario_equipment_xref_intakes_revisions" */
export type Revisions_Scenario_Equipment_Xref_Intakes_RevisionsScenario_Equipment_Xref_Intakes_JournalsArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Intakes_Journal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Intakes_Journal_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Equipment_Xref_Intakes_Journal_Bool_Exp>;
};


/** columns and relationships of "revisions.scenario_equipment_xref_intakes_revisions" */
export type Revisions_Scenario_Equipment_Xref_Intakes_RevisionsScenario_Equipment_Xref_Intakes_Journals_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Intakes_Journal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Intakes_Journal_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Equipment_Xref_Intakes_Journal_Bool_Exp>;
};


/** columns and relationships of "revisions.scenario_equipment_xref_intakes_revisions" */
export type Revisions_Scenario_Equipment_Xref_Intakes_RevisionsScenario_Equipment_Xref_Intakes_RevisionsArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Bool_Exp>;
};


/** columns and relationships of "revisions.scenario_equipment_xref_intakes_revisions" */
export type Revisions_Scenario_Equipment_Xref_Intakes_RevisionsScenario_Equipment_Xref_Intakes_Revisions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Bool_Exp>;
};

/** aggregated selection of "revisions.scenario_equipment_xref_intakes_revisions" */
export type Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Aggregate = {
  __typename: 'revisions_scenario_equipment_xref_intakes_revisions_aggregate';
  aggregate?: Maybe<Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Aggregate_Fields>;
  nodes: Array<Revisions_Scenario_Equipment_Xref_Intakes_Revisions>;
};

export type Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Aggregate_Bool_Exp_Count>;
};

export type Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Aggregate_Bool_Exp_Bool_And = {
  arguments: Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Select_Column_Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Select_Column_Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "revisions.scenario_equipment_xref_intakes_revisions" */
export type Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Aggregate_Fields = {
  __typename: 'revisions_scenario_equipment_xref_intakes_revisions_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Max_Fields>;
  min?: Maybe<Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Min_Fields>;
};


/** aggregate fields of "revisions.scenario_equipment_xref_intakes_revisions" */
export type Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "revisions.scenario_equipment_xref_intakes_revisions" */
export type Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Max_Order_By>;
  min?: InputMaybe<Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Min_Order_By>;
};

/** input type for inserting array relation for remote table "revisions.scenario_equipment_xref_intakes_revisions" */
export type Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Arr_Rel_Insert_Input = {
  data: Array<Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Revisions_Scenario_Equipment_Xref_Intakes_Revisions_On_Conflict>;
};

/** Boolean expression to filter rows from the table "revisions.scenario_equipment_xref_intakes_revisions". All fields are combined with a logical 'AND'. */
export type Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Bool_Exp = {
  _and?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Bool_Exp>>;
  _not?: InputMaybe<Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Bool_Exp>;
  _or?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Bool_Exp>>;
  author_id?: InputMaybe<String_Comparison_Exp>;
  cloned_from_journal_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  intake?: InputMaybe<Intakes_Bool_Exp>;
  intake_id?: InputMaybe<Uuid_Comparison_Exp>;
  journal_id?: InputMaybe<Uuid_Comparison_Exp>;
  parent_revision_id?: InputMaybe<Uuid_Comparison_Exp>;
  scenario_equipment_id?: InputMaybe<Uuid_Comparison_Exp>;
  scenario_equipment_journal?: InputMaybe<Revisions_Scenario_Equipment_Journal_Bool_Exp>;
  scenario_equipment_xref_intakes_journal?: InputMaybe<Revisions_Scenario_Equipment_Xref_Intakes_Journal_Bool_Exp>;
  scenario_equipment_xref_intakes_journals?: InputMaybe<Revisions_Scenario_Equipment_Xref_Intakes_Journal_Bool_Exp>;
  scenario_equipment_xref_intakes_journals_aggregate?: InputMaybe<Revisions_Scenario_Equipment_Xref_Intakes_Journal_Aggregate_Bool_Exp>;
  scenario_equipment_xref_intakes_revision?: InputMaybe<Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Bool_Exp>;
  scenario_equipment_xref_intakes_revisions?: InputMaybe<Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Bool_Exp>;
  scenario_equipment_xref_intakes_revisions_aggregate?: InputMaybe<Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Aggregate_Bool_Exp>;
  scenario_equipment_xref_intakes_view?: InputMaybe<Scenario_Equipment_Xref_Intakes_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  use_high_strength_shaft?: InputMaybe<Boolean_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
};

/** unique or primary key constraints on table "revisions.scenario_equipment_xref_intakes_revisions" */
export enum Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Constraint {
  /** unique or primary key constraint on columns "id" */
  ScenarioEquipmentXrefIntakesRevisionsPkey = 'scenario_equipment_xref_intakes_revisions_pkey'
}

/** input type for inserting data into table "revisions.scenario_equipment_xref_intakes_revisions" */
export type Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Insert_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  cloned_from_journal_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  intake?: InputMaybe<Intakes_Obj_Rel_Insert_Input>;
  intake_id?: InputMaybe<Scalars['uuid']['input']>;
  journal_id?: InputMaybe<Scalars['uuid']['input']>;
  parent_revision_id?: InputMaybe<Scalars['uuid']['input']>;
  scenario_equipment_id?: InputMaybe<Scalars['uuid']['input']>;
  scenario_equipment_journal?: InputMaybe<Revisions_Scenario_Equipment_Journal_Obj_Rel_Insert_Input>;
  scenario_equipment_xref_intakes_journal?: InputMaybe<Revisions_Scenario_Equipment_Xref_Intakes_Journal_Obj_Rel_Insert_Input>;
  scenario_equipment_xref_intakes_journals?: InputMaybe<Revisions_Scenario_Equipment_Xref_Intakes_Journal_Arr_Rel_Insert_Input>;
  scenario_equipment_xref_intakes_revision?: InputMaybe<Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Obj_Rel_Insert_Input>;
  scenario_equipment_xref_intakes_revisions?: InputMaybe<Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Arr_Rel_Insert_Input>;
  scenario_equipment_xref_intakes_view?: InputMaybe<Scenario_Equipment_Xref_Intakes_Obj_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  use_high_strength_shaft?: InputMaybe<Scalars['Boolean']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Max_Fields = {
  __typename: 'revisions_scenario_equipment_xref_intakes_revisions_max_fields';
  author_id?: Maybe<Scalars['String']['output']>;
  cloned_from_journal_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  intake_id?: Maybe<Scalars['uuid']['output']>;
  journal_id?: Maybe<Scalars['uuid']['output']>;
  parent_revision_id?: Maybe<Scalars['uuid']['output']>;
  scenario_equipment_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "revisions.scenario_equipment_xref_intakes_revisions" */
export type Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Max_Order_By = {
  author_id?: InputMaybe<Order_By>;
  cloned_from_journal_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  intake_id?: InputMaybe<Order_By>;
  journal_id?: InputMaybe<Order_By>;
  parent_revision_id?: InputMaybe<Order_By>;
  scenario_equipment_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Min_Fields = {
  __typename: 'revisions_scenario_equipment_xref_intakes_revisions_min_fields';
  author_id?: Maybe<Scalars['String']['output']>;
  cloned_from_journal_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  intake_id?: Maybe<Scalars['uuid']['output']>;
  journal_id?: Maybe<Scalars['uuid']['output']>;
  parent_revision_id?: Maybe<Scalars['uuid']['output']>;
  scenario_equipment_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "revisions.scenario_equipment_xref_intakes_revisions" */
export type Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Min_Order_By = {
  author_id?: InputMaybe<Order_By>;
  cloned_from_journal_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  intake_id?: InputMaybe<Order_By>;
  journal_id?: InputMaybe<Order_By>;
  parent_revision_id?: InputMaybe<Order_By>;
  scenario_equipment_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "revisions.scenario_equipment_xref_intakes_revisions" */
export type Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Mutation_Response = {
  __typename: 'revisions_scenario_equipment_xref_intakes_revisions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Revisions_Scenario_Equipment_Xref_Intakes_Revisions>;
};

/** input type for inserting object relation for remote table "revisions.scenario_equipment_xref_intakes_revisions" */
export type Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Obj_Rel_Insert_Input = {
  data: Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Revisions_Scenario_Equipment_Xref_Intakes_Revisions_On_Conflict>;
};

/** on_conflict condition type for table "revisions.scenario_equipment_xref_intakes_revisions" */
export type Revisions_Scenario_Equipment_Xref_Intakes_Revisions_On_Conflict = {
  constraint: Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Constraint;
  update_columns?: Array<Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Update_Column>;
  where?: InputMaybe<Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Bool_Exp>;
};

/** Ordering options when selecting data from "revisions.scenario_equipment_xref_intakes_revisions". */
export type Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Order_By = {
  author_id?: InputMaybe<Order_By>;
  cloned_from_journal_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  intake?: InputMaybe<Intakes_Order_By>;
  intake_id?: InputMaybe<Order_By>;
  journal_id?: InputMaybe<Order_By>;
  parent_revision_id?: InputMaybe<Order_By>;
  scenario_equipment_id?: InputMaybe<Order_By>;
  scenario_equipment_journal?: InputMaybe<Revisions_Scenario_Equipment_Journal_Order_By>;
  scenario_equipment_xref_intakes_journal?: InputMaybe<Revisions_Scenario_Equipment_Xref_Intakes_Journal_Order_By>;
  scenario_equipment_xref_intakes_journals_aggregate?: InputMaybe<Revisions_Scenario_Equipment_Xref_Intakes_Journal_Aggregate_Order_By>;
  scenario_equipment_xref_intakes_revision?: InputMaybe<Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Order_By>;
  scenario_equipment_xref_intakes_revisions_aggregate?: InputMaybe<Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Aggregate_Order_By>;
  scenario_equipment_xref_intakes_view?: InputMaybe<Scenario_Equipment_Xref_Intakes_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  use_high_strength_shaft?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
};

/** primary key columns input for table: revisions.scenario_equipment_xref_intakes_revisions */
export type Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "revisions.scenario_equipment_xref_intakes_revisions" */
export enum Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Select_Column {
  /** column name */
  AuthorId = 'author_id',
  /** column name */
  ClonedFromJournalId = 'cloned_from_journal_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  IntakeId = 'intake_id',
  /** column name */
  JournalId = 'journal_id',
  /** column name */
  ParentRevisionId = 'parent_revision_id',
  /** column name */
  ScenarioEquipmentId = 'scenario_equipment_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UseHighStrengthShaft = 'use_high_strength_shaft'
}

/** select "revisions_scenario_equipment_xref_intakes_revisions_aggregate_bool_exp_bool_and_arguments_columns" columns of table "revisions.scenario_equipment_xref_intakes_revisions" */
export enum Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Select_Column_Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  UseHighStrengthShaft = 'use_high_strength_shaft'
}

/** select "revisions_scenario_equipment_xref_intakes_revisions_aggregate_bool_exp_bool_or_arguments_columns" columns of table "revisions.scenario_equipment_xref_intakes_revisions" */
export enum Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Select_Column_Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  UseHighStrengthShaft = 'use_high_strength_shaft'
}

/** input type for updating data in table "revisions.scenario_equipment_xref_intakes_revisions" */
export type Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Set_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  cloned_from_journal_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  intake_id?: InputMaybe<Scalars['uuid']['input']>;
  journal_id?: InputMaybe<Scalars['uuid']['input']>;
  parent_revision_id?: InputMaybe<Scalars['uuid']['input']>;
  scenario_equipment_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  use_high_strength_shaft?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Streaming cursor of the table "revisions_scenario_equipment_xref_intakes_revisions" */
export type Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Stream_Cursor_Value_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  cloned_from_journal_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  intake_id?: InputMaybe<Scalars['uuid']['input']>;
  journal_id?: InputMaybe<Scalars['uuid']['input']>;
  parent_revision_id?: InputMaybe<Scalars['uuid']['input']>;
  scenario_equipment_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  use_high_strength_shaft?: InputMaybe<Scalars['Boolean']['input']>;
};

/** update columns of table "revisions.scenario_equipment_xref_intakes_revisions" */
export enum Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Update_Column {
  /** column name */
  AuthorId = 'author_id',
  /** column name */
  ClonedFromJournalId = 'cloned_from_journal_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  IntakeId = 'intake_id',
  /** column name */
  JournalId = 'journal_id',
  /** column name */
  ParentRevisionId = 'parent_revision_id',
  /** column name */
  ScenarioEquipmentId = 'scenario_equipment_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UseHighStrengthShaft = 'use_high_strength_shaft'
}

export type Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Set_Input>;
  /** filter the rows which have to be updated */
  where: Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Bool_Exp;
};

/** columns and relationships of "revisions.scenario_equipment_xref_pumps_journal" */
export type Revisions_Scenario_Equipment_Xref_Pumps_Journal = {
  __typename: 'revisions_scenario_equipment_xref_pumps_journal';
  author_id: Scalars['String']['output'];
  created_at: Scalars['timestamptz']['output'];
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  parent_journal_id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  scenario_equipment_xref_housings_revisions: Array<Revisions_Scenario_Equipment_Xref_Housings_Revisions>;
  /** An aggregate relationship */
  scenario_equipment_xref_housings_revisions_aggregate: Revisions_Scenario_Equipment_Xref_Housings_Revisions_Aggregate;
  /** An object relationship */
  scenario_equipment_xref_pumps_journal?: Maybe<Revisions_Scenario_Equipment_Xref_Pumps_Journal>;
  /** An array relationship */
  scenario_equipment_xref_pumps_journals: Array<Revisions_Scenario_Equipment_Xref_Pumps_Journal>;
  /** An aggregate relationship */
  scenario_equipment_xref_pumps_journals_aggregate: Revisions_Scenario_Equipment_Xref_Pumps_Journal_Aggregate;
  /** An object relationship */
  scenario_equipment_xref_pumps_revision?: Maybe<Revisions_Scenario_Equipment_Xref_Pumps_Revisions>;
  /** An array relationship */
  scenario_equipment_xref_pumps_revisions: Array<Revisions_Scenario_Equipment_Xref_Pumps_Revisions>;
  /** An aggregate relationship */
  scenario_equipment_xref_pumps_revisions_aggregate: Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Aggregate;
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Users;
  winning_revision_id?: Maybe<Scalars['uuid']['output']>;
};


/** columns and relationships of "revisions.scenario_equipment_xref_pumps_journal" */
export type Revisions_Scenario_Equipment_Xref_Pumps_JournalScenario_Equipment_Xref_Housings_RevisionsArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Bool_Exp>;
};


/** columns and relationships of "revisions.scenario_equipment_xref_pumps_journal" */
export type Revisions_Scenario_Equipment_Xref_Pumps_JournalScenario_Equipment_Xref_Housings_Revisions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Bool_Exp>;
};


/** columns and relationships of "revisions.scenario_equipment_xref_pumps_journal" */
export type Revisions_Scenario_Equipment_Xref_Pumps_JournalScenario_Equipment_Xref_Pumps_JournalsArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Pumps_Journal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Pumps_Journal_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Equipment_Xref_Pumps_Journal_Bool_Exp>;
};


/** columns and relationships of "revisions.scenario_equipment_xref_pumps_journal" */
export type Revisions_Scenario_Equipment_Xref_Pumps_JournalScenario_Equipment_Xref_Pumps_Journals_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Pumps_Journal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Pumps_Journal_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Equipment_Xref_Pumps_Journal_Bool_Exp>;
};


/** columns and relationships of "revisions.scenario_equipment_xref_pumps_journal" */
export type Revisions_Scenario_Equipment_Xref_Pumps_JournalScenario_Equipment_Xref_Pumps_RevisionsArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Bool_Exp>;
};


/** columns and relationships of "revisions.scenario_equipment_xref_pumps_journal" */
export type Revisions_Scenario_Equipment_Xref_Pumps_JournalScenario_Equipment_Xref_Pumps_Revisions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Bool_Exp>;
};

/** aggregated selection of "revisions.scenario_equipment_xref_pumps_journal" */
export type Revisions_Scenario_Equipment_Xref_Pumps_Journal_Aggregate = {
  __typename: 'revisions_scenario_equipment_xref_pumps_journal_aggregate';
  aggregate?: Maybe<Revisions_Scenario_Equipment_Xref_Pumps_Journal_Aggregate_Fields>;
  nodes: Array<Revisions_Scenario_Equipment_Xref_Pumps_Journal>;
};

export type Revisions_Scenario_Equipment_Xref_Pumps_Journal_Aggregate_Bool_Exp = {
  count?: InputMaybe<Revisions_Scenario_Equipment_Xref_Pumps_Journal_Aggregate_Bool_Exp_Count>;
};

export type Revisions_Scenario_Equipment_Xref_Pumps_Journal_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Pumps_Journal_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Revisions_Scenario_Equipment_Xref_Pumps_Journal_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "revisions.scenario_equipment_xref_pumps_journal" */
export type Revisions_Scenario_Equipment_Xref_Pumps_Journal_Aggregate_Fields = {
  __typename: 'revisions_scenario_equipment_xref_pumps_journal_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Revisions_Scenario_Equipment_Xref_Pumps_Journal_Max_Fields>;
  min?: Maybe<Revisions_Scenario_Equipment_Xref_Pumps_Journal_Min_Fields>;
};


/** aggregate fields of "revisions.scenario_equipment_xref_pumps_journal" */
export type Revisions_Scenario_Equipment_Xref_Pumps_Journal_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Pumps_Journal_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "revisions.scenario_equipment_xref_pumps_journal" */
export type Revisions_Scenario_Equipment_Xref_Pumps_Journal_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Revisions_Scenario_Equipment_Xref_Pumps_Journal_Max_Order_By>;
  min?: InputMaybe<Revisions_Scenario_Equipment_Xref_Pumps_Journal_Min_Order_By>;
};

/** input type for inserting array relation for remote table "revisions.scenario_equipment_xref_pumps_journal" */
export type Revisions_Scenario_Equipment_Xref_Pumps_Journal_Arr_Rel_Insert_Input = {
  data: Array<Revisions_Scenario_Equipment_Xref_Pumps_Journal_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Revisions_Scenario_Equipment_Xref_Pumps_Journal_On_Conflict>;
};

/** Boolean expression to filter rows from the table "revisions.scenario_equipment_xref_pumps_journal". All fields are combined with a logical 'AND'. */
export type Revisions_Scenario_Equipment_Xref_Pumps_Journal_Bool_Exp = {
  _and?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Pumps_Journal_Bool_Exp>>;
  _not?: InputMaybe<Revisions_Scenario_Equipment_Xref_Pumps_Journal_Bool_Exp>;
  _or?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Pumps_Journal_Bool_Exp>>;
  author_id?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  parent_journal_id?: InputMaybe<Uuid_Comparison_Exp>;
  scenario_equipment_xref_housings_revisions?: InputMaybe<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Bool_Exp>;
  scenario_equipment_xref_housings_revisions_aggregate?: InputMaybe<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Aggregate_Bool_Exp>;
  scenario_equipment_xref_pumps_journal?: InputMaybe<Revisions_Scenario_Equipment_Xref_Pumps_Journal_Bool_Exp>;
  scenario_equipment_xref_pumps_journals?: InputMaybe<Revisions_Scenario_Equipment_Xref_Pumps_Journal_Bool_Exp>;
  scenario_equipment_xref_pumps_journals_aggregate?: InputMaybe<Revisions_Scenario_Equipment_Xref_Pumps_Journal_Aggregate_Bool_Exp>;
  scenario_equipment_xref_pumps_revision?: InputMaybe<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Bool_Exp>;
  scenario_equipment_xref_pumps_revisions?: InputMaybe<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Bool_Exp>;
  scenario_equipment_xref_pumps_revisions_aggregate?: InputMaybe<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Aggregate_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  winning_revision_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "revisions.scenario_equipment_xref_pumps_journal" */
export enum Revisions_Scenario_Equipment_Xref_Pumps_Journal_Constraint {
  /** unique or primary key constraint on columns "id" */
  ScenarioEquipmentXrefPumpsJournalPkey = 'scenario_equipment_xref_pumps_journal_pkey'
}

/** input type for inserting data into table "revisions.scenario_equipment_xref_pumps_journal" */
export type Revisions_Scenario_Equipment_Xref_Pumps_Journal_Insert_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  parent_journal_id?: InputMaybe<Scalars['uuid']['input']>;
  scenario_equipment_xref_housings_revisions?: InputMaybe<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Arr_Rel_Insert_Input>;
  scenario_equipment_xref_pumps_journal?: InputMaybe<Revisions_Scenario_Equipment_Xref_Pumps_Journal_Obj_Rel_Insert_Input>;
  scenario_equipment_xref_pumps_journals?: InputMaybe<Revisions_Scenario_Equipment_Xref_Pumps_Journal_Arr_Rel_Insert_Input>;
  scenario_equipment_xref_pumps_revision?: InputMaybe<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Obj_Rel_Insert_Input>;
  scenario_equipment_xref_pumps_revisions?: InputMaybe<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Arr_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  winning_revision_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Revisions_Scenario_Equipment_Xref_Pumps_Journal_Max_Fields = {
  __typename: 'revisions_scenario_equipment_xref_pumps_journal_max_fields';
  author_id?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  parent_journal_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  winning_revision_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "revisions.scenario_equipment_xref_pumps_journal" */
export type Revisions_Scenario_Equipment_Xref_Pumps_Journal_Max_Order_By = {
  author_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parent_journal_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  winning_revision_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Revisions_Scenario_Equipment_Xref_Pumps_Journal_Min_Fields = {
  __typename: 'revisions_scenario_equipment_xref_pumps_journal_min_fields';
  author_id?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  parent_journal_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  winning_revision_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "revisions.scenario_equipment_xref_pumps_journal" */
export type Revisions_Scenario_Equipment_Xref_Pumps_Journal_Min_Order_By = {
  author_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parent_journal_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  winning_revision_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "revisions.scenario_equipment_xref_pumps_journal" */
export type Revisions_Scenario_Equipment_Xref_Pumps_Journal_Mutation_Response = {
  __typename: 'revisions_scenario_equipment_xref_pumps_journal_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Revisions_Scenario_Equipment_Xref_Pumps_Journal>;
};

/** input type for inserting object relation for remote table "revisions.scenario_equipment_xref_pumps_journal" */
export type Revisions_Scenario_Equipment_Xref_Pumps_Journal_Obj_Rel_Insert_Input = {
  data: Revisions_Scenario_Equipment_Xref_Pumps_Journal_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Revisions_Scenario_Equipment_Xref_Pumps_Journal_On_Conflict>;
};

/** on_conflict condition type for table "revisions.scenario_equipment_xref_pumps_journal" */
export type Revisions_Scenario_Equipment_Xref_Pumps_Journal_On_Conflict = {
  constraint: Revisions_Scenario_Equipment_Xref_Pumps_Journal_Constraint;
  update_columns?: Array<Revisions_Scenario_Equipment_Xref_Pumps_Journal_Update_Column>;
  where?: InputMaybe<Revisions_Scenario_Equipment_Xref_Pumps_Journal_Bool_Exp>;
};

/** Ordering options when selecting data from "revisions.scenario_equipment_xref_pumps_journal". */
export type Revisions_Scenario_Equipment_Xref_Pumps_Journal_Order_By = {
  author_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parent_journal_id?: InputMaybe<Order_By>;
  scenario_equipment_xref_housings_revisions_aggregate?: InputMaybe<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Aggregate_Order_By>;
  scenario_equipment_xref_pumps_journal?: InputMaybe<Revisions_Scenario_Equipment_Xref_Pumps_Journal_Order_By>;
  scenario_equipment_xref_pumps_journals_aggregate?: InputMaybe<Revisions_Scenario_Equipment_Xref_Pumps_Journal_Aggregate_Order_By>;
  scenario_equipment_xref_pumps_revision?: InputMaybe<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Order_By>;
  scenario_equipment_xref_pumps_revisions_aggregate?: InputMaybe<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  winning_revision_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: revisions.scenario_equipment_xref_pumps_journal */
export type Revisions_Scenario_Equipment_Xref_Pumps_Journal_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "revisions.scenario_equipment_xref_pumps_journal" */
export enum Revisions_Scenario_Equipment_Xref_Pumps_Journal_Select_Column {
  /** column name */
  AuthorId = 'author_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  ParentJournalId = 'parent_journal_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WinningRevisionId = 'winning_revision_id'
}

/** input type for updating data in table "revisions.scenario_equipment_xref_pumps_journal" */
export type Revisions_Scenario_Equipment_Xref_Pumps_Journal_Set_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  parent_journal_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  winning_revision_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "revisions_scenario_equipment_xref_pumps_journal" */
export type Revisions_Scenario_Equipment_Xref_Pumps_Journal_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Revisions_Scenario_Equipment_Xref_Pumps_Journal_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Revisions_Scenario_Equipment_Xref_Pumps_Journal_Stream_Cursor_Value_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  parent_journal_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  winning_revision_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "revisions.scenario_equipment_xref_pumps_journal" */
export enum Revisions_Scenario_Equipment_Xref_Pumps_Journal_Update_Column {
  /** column name */
  AuthorId = 'author_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  ParentJournalId = 'parent_journal_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WinningRevisionId = 'winning_revision_id'
}

export type Revisions_Scenario_Equipment_Xref_Pumps_Journal_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Revisions_Scenario_Equipment_Xref_Pumps_Journal_Set_Input>;
  /** filter the rows which have to be updated */
  where: Revisions_Scenario_Equipment_Xref_Pumps_Journal_Bool_Exp;
};

/** columns and relationships of "revisions.scenario_equipment_xref_pumps_revisions" */
export type Revisions_Scenario_Equipment_Xref_Pumps_Revisions = {
  __typename: 'revisions_scenario_equipment_xref_pumps_revisions';
  author_id: Scalars['String']['output'];
  brake_horsepower_correction_ratio?: Maybe<Scalars['numeric']['output']>;
  cloned_from_journal_id?: Maybe<Scalars['uuid']['output']>;
  created_at: Scalars['timestamptz']['output'];
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  head_correction_ratio?: Maybe<Scalars['numeric']['output']>;
  housings_order: Array<Scalars['uuid']['output']>;
  id: Scalars['uuid']['output'];
  journal_id: Scalars['uuid']['output'];
  length_feet?: Maybe<Scalars['numeric']['output']>;
  parent_revision_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  pump: Pumps;
  pump_id: Scalars['uuid']['output'];
  rate_correction_ratio?: Maybe<Scalars['numeric']['output']>;
  scenario_equipment_id: Scalars['uuid']['output'];
  /** An object relationship */
  scenario_equipment_journal: Revisions_Scenario_Equipment_Journal;
  /** An object relationship */
  scenario_equipment_xref_pumps_journal: Revisions_Scenario_Equipment_Xref_Pumps_Journal;
  /** An array relationship */
  scenario_equipment_xref_pumps_journals: Array<Revisions_Scenario_Equipment_Xref_Pumps_Journal>;
  /** An aggregate relationship */
  scenario_equipment_xref_pumps_journals_aggregate: Revisions_Scenario_Equipment_Xref_Pumps_Journal_Aggregate;
  /** An object relationship */
  scenario_equipment_xref_pumps_revision?: Maybe<Revisions_Scenario_Equipment_Xref_Pumps_Revisions>;
  /** An array relationship */
  scenario_equipment_xref_pumps_revisions: Array<Revisions_Scenario_Equipment_Xref_Pumps_Revisions>;
  /** An aggregate relationship */
  scenario_equipment_xref_pumps_revisions_aggregate: Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Aggregate;
  /** An object relationship */
  scenario_equipment_xref_pumps_view?: Maybe<Scenario_Equipment_Xref_Pumps>;
  total_stages?: Maybe<Scalars['Int']['output']>;
  updated_at: Scalars['timestamptz']['output'];
  use_high_strength_shaft: Scalars['Boolean']['output'];
  /** An object relationship */
  user: Users;
  weight_pounds: Scalars['numeric']['output'];
};


/** columns and relationships of "revisions.scenario_equipment_xref_pumps_revisions" */
export type Revisions_Scenario_Equipment_Xref_Pumps_RevisionsScenario_Equipment_Xref_Pumps_JournalsArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Pumps_Journal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Pumps_Journal_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Equipment_Xref_Pumps_Journal_Bool_Exp>;
};


/** columns and relationships of "revisions.scenario_equipment_xref_pumps_revisions" */
export type Revisions_Scenario_Equipment_Xref_Pumps_RevisionsScenario_Equipment_Xref_Pumps_Journals_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Pumps_Journal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Pumps_Journal_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Equipment_Xref_Pumps_Journal_Bool_Exp>;
};


/** columns and relationships of "revisions.scenario_equipment_xref_pumps_revisions" */
export type Revisions_Scenario_Equipment_Xref_Pumps_RevisionsScenario_Equipment_Xref_Pumps_RevisionsArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Bool_Exp>;
};


/** columns and relationships of "revisions.scenario_equipment_xref_pumps_revisions" */
export type Revisions_Scenario_Equipment_Xref_Pumps_RevisionsScenario_Equipment_Xref_Pumps_Revisions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Bool_Exp>;
};

/** aggregated selection of "revisions.scenario_equipment_xref_pumps_revisions" */
export type Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Aggregate = {
  __typename: 'revisions_scenario_equipment_xref_pumps_revisions_aggregate';
  aggregate?: Maybe<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Aggregate_Fields>;
  nodes: Array<Revisions_Scenario_Equipment_Xref_Pumps_Revisions>;
};

export type Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Aggregate_Bool_Exp_Count>;
};

export type Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Aggregate_Bool_Exp_Bool_And = {
  arguments: Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Select_Column_Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Select_Column_Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "revisions.scenario_equipment_xref_pumps_revisions" */
export type Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Aggregate_Fields = {
  __typename: 'revisions_scenario_equipment_xref_pumps_revisions_aggregate_fields';
  avg?: Maybe<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Max_Fields>;
  min?: Maybe<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Min_Fields>;
  stddev?: Maybe<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Stddev_Fields>;
  stddev_pop?: Maybe<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Stddev_Samp_Fields>;
  sum?: Maybe<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Sum_Fields>;
  var_pop?: Maybe<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Var_Pop_Fields>;
  var_samp?: Maybe<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Var_Samp_Fields>;
  variance?: Maybe<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Variance_Fields>;
};


/** aggregate fields of "revisions.scenario_equipment_xref_pumps_revisions" */
export type Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "revisions.scenario_equipment_xref_pumps_revisions" */
export type Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Aggregate_Order_By = {
  avg?: InputMaybe<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Max_Order_By>;
  min?: InputMaybe<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Min_Order_By>;
  stddev?: InputMaybe<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Sum_Order_By>;
  var_pop?: InputMaybe<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Var_Samp_Order_By>;
  variance?: InputMaybe<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "revisions.scenario_equipment_xref_pumps_revisions" */
export type Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Arr_Rel_Insert_Input = {
  data: Array<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_On_Conflict>;
};

/** aggregate avg on columns */
export type Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Avg_Fields = {
  __typename: 'revisions_scenario_equipment_xref_pumps_revisions_avg_fields';
  brake_horsepower_correction_ratio?: Maybe<Scalars['Float']['output']>;
  head_correction_ratio?: Maybe<Scalars['Float']['output']>;
  length_feet?: Maybe<Scalars['Float']['output']>;
  rate_correction_ratio?: Maybe<Scalars['Float']['output']>;
  total_stages?: Maybe<Scalars['Float']['output']>;
  weight_pounds?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "revisions.scenario_equipment_xref_pumps_revisions" */
export type Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Avg_Order_By = {
  brake_horsepower_correction_ratio?: InputMaybe<Order_By>;
  head_correction_ratio?: InputMaybe<Order_By>;
  length_feet?: InputMaybe<Order_By>;
  rate_correction_ratio?: InputMaybe<Order_By>;
  total_stages?: InputMaybe<Order_By>;
  weight_pounds?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "revisions.scenario_equipment_xref_pumps_revisions". All fields are combined with a logical 'AND'. */
export type Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Bool_Exp = {
  _and?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Bool_Exp>>;
  _not?: InputMaybe<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Bool_Exp>;
  _or?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Bool_Exp>>;
  author_id?: InputMaybe<String_Comparison_Exp>;
  brake_horsepower_correction_ratio?: InputMaybe<Numeric_Comparison_Exp>;
  cloned_from_journal_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  head_correction_ratio?: InputMaybe<Numeric_Comparison_Exp>;
  housings_order?: InputMaybe<Uuid_Array_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  journal_id?: InputMaybe<Uuid_Comparison_Exp>;
  length_feet?: InputMaybe<Numeric_Comparison_Exp>;
  parent_revision_id?: InputMaybe<Uuid_Comparison_Exp>;
  pump?: InputMaybe<Pumps_Bool_Exp>;
  pump_id?: InputMaybe<Uuid_Comparison_Exp>;
  rate_correction_ratio?: InputMaybe<Numeric_Comparison_Exp>;
  scenario_equipment_id?: InputMaybe<Uuid_Comparison_Exp>;
  scenario_equipment_journal?: InputMaybe<Revisions_Scenario_Equipment_Journal_Bool_Exp>;
  scenario_equipment_xref_pumps_journal?: InputMaybe<Revisions_Scenario_Equipment_Xref_Pumps_Journal_Bool_Exp>;
  scenario_equipment_xref_pumps_journals?: InputMaybe<Revisions_Scenario_Equipment_Xref_Pumps_Journal_Bool_Exp>;
  scenario_equipment_xref_pumps_journals_aggregate?: InputMaybe<Revisions_Scenario_Equipment_Xref_Pumps_Journal_Aggregate_Bool_Exp>;
  scenario_equipment_xref_pumps_revision?: InputMaybe<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Bool_Exp>;
  scenario_equipment_xref_pumps_revisions?: InputMaybe<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Bool_Exp>;
  scenario_equipment_xref_pumps_revisions_aggregate?: InputMaybe<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Aggregate_Bool_Exp>;
  scenario_equipment_xref_pumps_view?: InputMaybe<Scenario_Equipment_Xref_Pumps_Bool_Exp>;
  total_stages?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  use_high_strength_shaft?: InputMaybe<Boolean_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  weight_pounds?: InputMaybe<Numeric_Comparison_Exp>;
};

/** unique or primary key constraints on table "revisions.scenario_equipment_xref_pumps_revisions" */
export enum Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Constraint {
  /** unique or primary key constraint on columns "id" */
  ScenarioEquipmentXrefPumpsRevisionsPkey = 'scenario_equipment_xref_pumps_revisions_pkey'
}

/** input type for incrementing numeric columns in table "revisions.scenario_equipment_xref_pumps_revisions" */
export type Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Inc_Input = {
  brake_horsepower_correction_ratio?: InputMaybe<Scalars['numeric']['input']>;
  head_correction_ratio?: InputMaybe<Scalars['numeric']['input']>;
  length_feet?: InputMaybe<Scalars['numeric']['input']>;
  rate_correction_ratio?: InputMaybe<Scalars['numeric']['input']>;
  total_stages?: InputMaybe<Scalars['Int']['input']>;
  weight_pounds?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "revisions.scenario_equipment_xref_pumps_revisions" */
export type Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Insert_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  brake_horsepower_correction_ratio?: InputMaybe<Scalars['numeric']['input']>;
  cloned_from_journal_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  head_correction_ratio?: InputMaybe<Scalars['numeric']['input']>;
  housings_order?: InputMaybe<Array<Scalars['uuid']['input']>>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  journal_id?: InputMaybe<Scalars['uuid']['input']>;
  length_feet?: InputMaybe<Scalars['numeric']['input']>;
  parent_revision_id?: InputMaybe<Scalars['uuid']['input']>;
  pump?: InputMaybe<Pumps_Obj_Rel_Insert_Input>;
  pump_id?: InputMaybe<Scalars['uuid']['input']>;
  rate_correction_ratio?: InputMaybe<Scalars['numeric']['input']>;
  scenario_equipment_id?: InputMaybe<Scalars['uuid']['input']>;
  scenario_equipment_journal?: InputMaybe<Revisions_Scenario_Equipment_Journal_Obj_Rel_Insert_Input>;
  scenario_equipment_xref_pumps_journal?: InputMaybe<Revisions_Scenario_Equipment_Xref_Pumps_Journal_Obj_Rel_Insert_Input>;
  scenario_equipment_xref_pumps_journals?: InputMaybe<Revisions_Scenario_Equipment_Xref_Pumps_Journal_Arr_Rel_Insert_Input>;
  scenario_equipment_xref_pumps_revision?: InputMaybe<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Obj_Rel_Insert_Input>;
  scenario_equipment_xref_pumps_revisions?: InputMaybe<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Arr_Rel_Insert_Input>;
  scenario_equipment_xref_pumps_view?: InputMaybe<Scenario_Equipment_Xref_Pumps_Obj_Rel_Insert_Input>;
  total_stages?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  use_high_strength_shaft?: InputMaybe<Scalars['Boolean']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  weight_pounds?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate max on columns */
export type Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Max_Fields = {
  __typename: 'revisions_scenario_equipment_xref_pumps_revisions_max_fields';
  author_id?: Maybe<Scalars['String']['output']>;
  brake_horsepower_correction_ratio?: Maybe<Scalars['numeric']['output']>;
  cloned_from_journal_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  head_correction_ratio?: Maybe<Scalars['numeric']['output']>;
  housings_order?: Maybe<Array<Scalars['uuid']['output']>>;
  id?: Maybe<Scalars['uuid']['output']>;
  journal_id?: Maybe<Scalars['uuid']['output']>;
  length_feet?: Maybe<Scalars['numeric']['output']>;
  parent_revision_id?: Maybe<Scalars['uuid']['output']>;
  pump_id?: Maybe<Scalars['uuid']['output']>;
  rate_correction_ratio?: Maybe<Scalars['numeric']['output']>;
  scenario_equipment_id?: Maybe<Scalars['uuid']['output']>;
  total_stages?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  weight_pounds?: Maybe<Scalars['numeric']['output']>;
};

/** order by max() on columns of table "revisions.scenario_equipment_xref_pumps_revisions" */
export type Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Max_Order_By = {
  author_id?: InputMaybe<Order_By>;
  brake_horsepower_correction_ratio?: InputMaybe<Order_By>;
  cloned_from_journal_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  head_correction_ratio?: InputMaybe<Order_By>;
  housings_order?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  journal_id?: InputMaybe<Order_By>;
  length_feet?: InputMaybe<Order_By>;
  parent_revision_id?: InputMaybe<Order_By>;
  pump_id?: InputMaybe<Order_By>;
  rate_correction_ratio?: InputMaybe<Order_By>;
  scenario_equipment_id?: InputMaybe<Order_By>;
  total_stages?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  weight_pounds?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Min_Fields = {
  __typename: 'revisions_scenario_equipment_xref_pumps_revisions_min_fields';
  author_id?: Maybe<Scalars['String']['output']>;
  brake_horsepower_correction_ratio?: Maybe<Scalars['numeric']['output']>;
  cloned_from_journal_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  head_correction_ratio?: Maybe<Scalars['numeric']['output']>;
  housings_order?: Maybe<Array<Scalars['uuid']['output']>>;
  id?: Maybe<Scalars['uuid']['output']>;
  journal_id?: Maybe<Scalars['uuid']['output']>;
  length_feet?: Maybe<Scalars['numeric']['output']>;
  parent_revision_id?: Maybe<Scalars['uuid']['output']>;
  pump_id?: Maybe<Scalars['uuid']['output']>;
  rate_correction_ratio?: Maybe<Scalars['numeric']['output']>;
  scenario_equipment_id?: Maybe<Scalars['uuid']['output']>;
  total_stages?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  weight_pounds?: Maybe<Scalars['numeric']['output']>;
};

/** order by min() on columns of table "revisions.scenario_equipment_xref_pumps_revisions" */
export type Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Min_Order_By = {
  author_id?: InputMaybe<Order_By>;
  brake_horsepower_correction_ratio?: InputMaybe<Order_By>;
  cloned_from_journal_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  head_correction_ratio?: InputMaybe<Order_By>;
  housings_order?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  journal_id?: InputMaybe<Order_By>;
  length_feet?: InputMaybe<Order_By>;
  parent_revision_id?: InputMaybe<Order_By>;
  pump_id?: InputMaybe<Order_By>;
  rate_correction_ratio?: InputMaybe<Order_By>;
  scenario_equipment_id?: InputMaybe<Order_By>;
  total_stages?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  weight_pounds?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "revisions.scenario_equipment_xref_pumps_revisions" */
export type Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Mutation_Response = {
  __typename: 'revisions_scenario_equipment_xref_pumps_revisions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Revisions_Scenario_Equipment_Xref_Pumps_Revisions>;
};

/** input type for inserting object relation for remote table "revisions.scenario_equipment_xref_pumps_revisions" */
export type Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Obj_Rel_Insert_Input = {
  data: Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_On_Conflict>;
};

/** on_conflict condition type for table "revisions.scenario_equipment_xref_pumps_revisions" */
export type Revisions_Scenario_Equipment_Xref_Pumps_Revisions_On_Conflict = {
  constraint: Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Constraint;
  update_columns?: Array<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Update_Column>;
  where?: InputMaybe<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Bool_Exp>;
};

/** Ordering options when selecting data from "revisions.scenario_equipment_xref_pumps_revisions". */
export type Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Order_By = {
  author_id?: InputMaybe<Order_By>;
  brake_horsepower_correction_ratio?: InputMaybe<Order_By>;
  cloned_from_journal_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  head_correction_ratio?: InputMaybe<Order_By>;
  housings_order?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  journal_id?: InputMaybe<Order_By>;
  length_feet?: InputMaybe<Order_By>;
  parent_revision_id?: InputMaybe<Order_By>;
  pump?: InputMaybe<Pumps_Order_By>;
  pump_id?: InputMaybe<Order_By>;
  rate_correction_ratio?: InputMaybe<Order_By>;
  scenario_equipment_id?: InputMaybe<Order_By>;
  scenario_equipment_journal?: InputMaybe<Revisions_Scenario_Equipment_Journal_Order_By>;
  scenario_equipment_xref_pumps_journal?: InputMaybe<Revisions_Scenario_Equipment_Xref_Pumps_Journal_Order_By>;
  scenario_equipment_xref_pumps_journals_aggregate?: InputMaybe<Revisions_Scenario_Equipment_Xref_Pumps_Journal_Aggregate_Order_By>;
  scenario_equipment_xref_pumps_revision?: InputMaybe<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Order_By>;
  scenario_equipment_xref_pumps_revisions_aggregate?: InputMaybe<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Aggregate_Order_By>;
  scenario_equipment_xref_pumps_view?: InputMaybe<Scenario_Equipment_Xref_Pumps_Order_By>;
  total_stages?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  use_high_strength_shaft?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  weight_pounds?: InputMaybe<Order_By>;
};

/** primary key columns input for table: revisions.scenario_equipment_xref_pumps_revisions */
export type Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "revisions.scenario_equipment_xref_pumps_revisions" */
export enum Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Select_Column {
  /** column name */
  AuthorId = 'author_id',
  /** column name */
  BrakeHorsepowerCorrectionRatio = 'brake_horsepower_correction_ratio',
  /** column name */
  ClonedFromJournalId = 'cloned_from_journal_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  HeadCorrectionRatio = 'head_correction_ratio',
  /** column name */
  HousingsOrder = 'housings_order',
  /** column name */
  Id = 'id',
  /** column name */
  JournalId = 'journal_id',
  /** column name */
  LengthFeet = 'length_feet',
  /** column name */
  ParentRevisionId = 'parent_revision_id',
  /** column name */
  PumpId = 'pump_id',
  /** column name */
  RateCorrectionRatio = 'rate_correction_ratio',
  /** column name */
  ScenarioEquipmentId = 'scenario_equipment_id',
  /** column name */
  TotalStages = 'total_stages',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UseHighStrengthShaft = 'use_high_strength_shaft',
  /** column name */
  WeightPounds = 'weight_pounds'
}

/** select "revisions_scenario_equipment_xref_pumps_revisions_aggregate_bool_exp_bool_and_arguments_columns" columns of table "revisions.scenario_equipment_xref_pumps_revisions" */
export enum Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Select_Column_Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  UseHighStrengthShaft = 'use_high_strength_shaft'
}

/** select "revisions_scenario_equipment_xref_pumps_revisions_aggregate_bool_exp_bool_or_arguments_columns" columns of table "revisions.scenario_equipment_xref_pumps_revisions" */
export enum Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Select_Column_Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  UseHighStrengthShaft = 'use_high_strength_shaft'
}

/** input type for updating data in table "revisions.scenario_equipment_xref_pumps_revisions" */
export type Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Set_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  brake_horsepower_correction_ratio?: InputMaybe<Scalars['numeric']['input']>;
  cloned_from_journal_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  head_correction_ratio?: InputMaybe<Scalars['numeric']['input']>;
  housings_order?: InputMaybe<Array<Scalars['uuid']['input']>>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  journal_id?: InputMaybe<Scalars['uuid']['input']>;
  length_feet?: InputMaybe<Scalars['numeric']['input']>;
  parent_revision_id?: InputMaybe<Scalars['uuid']['input']>;
  pump_id?: InputMaybe<Scalars['uuid']['input']>;
  rate_correction_ratio?: InputMaybe<Scalars['numeric']['input']>;
  scenario_equipment_id?: InputMaybe<Scalars['uuid']['input']>;
  total_stages?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  use_high_strength_shaft?: InputMaybe<Scalars['Boolean']['input']>;
  weight_pounds?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate stddev on columns */
export type Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Stddev_Fields = {
  __typename: 'revisions_scenario_equipment_xref_pumps_revisions_stddev_fields';
  brake_horsepower_correction_ratio?: Maybe<Scalars['Float']['output']>;
  head_correction_ratio?: Maybe<Scalars['Float']['output']>;
  length_feet?: Maybe<Scalars['Float']['output']>;
  rate_correction_ratio?: Maybe<Scalars['Float']['output']>;
  total_stages?: Maybe<Scalars['Float']['output']>;
  weight_pounds?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "revisions.scenario_equipment_xref_pumps_revisions" */
export type Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Stddev_Order_By = {
  brake_horsepower_correction_ratio?: InputMaybe<Order_By>;
  head_correction_ratio?: InputMaybe<Order_By>;
  length_feet?: InputMaybe<Order_By>;
  rate_correction_ratio?: InputMaybe<Order_By>;
  total_stages?: InputMaybe<Order_By>;
  weight_pounds?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Stddev_Pop_Fields = {
  __typename: 'revisions_scenario_equipment_xref_pumps_revisions_stddev_pop_fields';
  brake_horsepower_correction_ratio?: Maybe<Scalars['Float']['output']>;
  head_correction_ratio?: Maybe<Scalars['Float']['output']>;
  length_feet?: Maybe<Scalars['Float']['output']>;
  rate_correction_ratio?: Maybe<Scalars['Float']['output']>;
  total_stages?: Maybe<Scalars['Float']['output']>;
  weight_pounds?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "revisions.scenario_equipment_xref_pumps_revisions" */
export type Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Stddev_Pop_Order_By = {
  brake_horsepower_correction_ratio?: InputMaybe<Order_By>;
  head_correction_ratio?: InputMaybe<Order_By>;
  length_feet?: InputMaybe<Order_By>;
  rate_correction_ratio?: InputMaybe<Order_By>;
  total_stages?: InputMaybe<Order_By>;
  weight_pounds?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Stddev_Samp_Fields = {
  __typename: 'revisions_scenario_equipment_xref_pumps_revisions_stddev_samp_fields';
  brake_horsepower_correction_ratio?: Maybe<Scalars['Float']['output']>;
  head_correction_ratio?: Maybe<Scalars['Float']['output']>;
  length_feet?: Maybe<Scalars['Float']['output']>;
  rate_correction_ratio?: Maybe<Scalars['Float']['output']>;
  total_stages?: Maybe<Scalars['Float']['output']>;
  weight_pounds?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "revisions.scenario_equipment_xref_pumps_revisions" */
export type Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Stddev_Samp_Order_By = {
  brake_horsepower_correction_ratio?: InputMaybe<Order_By>;
  head_correction_ratio?: InputMaybe<Order_By>;
  length_feet?: InputMaybe<Order_By>;
  rate_correction_ratio?: InputMaybe<Order_By>;
  total_stages?: InputMaybe<Order_By>;
  weight_pounds?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "revisions_scenario_equipment_xref_pumps_revisions" */
export type Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Stream_Cursor_Value_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  brake_horsepower_correction_ratio?: InputMaybe<Scalars['numeric']['input']>;
  cloned_from_journal_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  head_correction_ratio?: InputMaybe<Scalars['numeric']['input']>;
  housings_order?: InputMaybe<Array<Scalars['uuid']['input']>>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  journal_id?: InputMaybe<Scalars['uuid']['input']>;
  length_feet?: InputMaybe<Scalars['numeric']['input']>;
  parent_revision_id?: InputMaybe<Scalars['uuid']['input']>;
  pump_id?: InputMaybe<Scalars['uuid']['input']>;
  rate_correction_ratio?: InputMaybe<Scalars['numeric']['input']>;
  scenario_equipment_id?: InputMaybe<Scalars['uuid']['input']>;
  total_stages?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  use_high_strength_shaft?: InputMaybe<Scalars['Boolean']['input']>;
  weight_pounds?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate sum on columns */
export type Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Sum_Fields = {
  __typename: 'revisions_scenario_equipment_xref_pumps_revisions_sum_fields';
  brake_horsepower_correction_ratio?: Maybe<Scalars['numeric']['output']>;
  head_correction_ratio?: Maybe<Scalars['numeric']['output']>;
  length_feet?: Maybe<Scalars['numeric']['output']>;
  rate_correction_ratio?: Maybe<Scalars['numeric']['output']>;
  total_stages?: Maybe<Scalars['Int']['output']>;
  weight_pounds?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "revisions.scenario_equipment_xref_pumps_revisions" */
export type Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Sum_Order_By = {
  brake_horsepower_correction_ratio?: InputMaybe<Order_By>;
  head_correction_ratio?: InputMaybe<Order_By>;
  length_feet?: InputMaybe<Order_By>;
  rate_correction_ratio?: InputMaybe<Order_By>;
  total_stages?: InputMaybe<Order_By>;
  weight_pounds?: InputMaybe<Order_By>;
};

/** update columns of table "revisions.scenario_equipment_xref_pumps_revisions" */
export enum Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Update_Column {
  /** column name */
  AuthorId = 'author_id',
  /** column name */
  BrakeHorsepowerCorrectionRatio = 'brake_horsepower_correction_ratio',
  /** column name */
  ClonedFromJournalId = 'cloned_from_journal_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  HeadCorrectionRatio = 'head_correction_ratio',
  /** column name */
  HousingsOrder = 'housings_order',
  /** column name */
  Id = 'id',
  /** column name */
  JournalId = 'journal_id',
  /** column name */
  LengthFeet = 'length_feet',
  /** column name */
  ParentRevisionId = 'parent_revision_id',
  /** column name */
  PumpId = 'pump_id',
  /** column name */
  RateCorrectionRatio = 'rate_correction_ratio',
  /** column name */
  ScenarioEquipmentId = 'scenario_equipment_id',
  /** column name */
  TotalStages = 'total_stages',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UseHighStrengthShaft = 'use_high_strength_shaft',
  /** column name */
  WeightPounds = 'weight_pounds'
}

export type Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Set_Input>;
  /** filter the rows which have to be updated */
  where: Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Var_Pop_Fields = {
  __typename: 'revisions_scenario_equipment_xref_pumps_revisions_var_pop_fields';
  brake_horsepower_correction_ratio?: Maybe<Scalars['Float']['output']>;
  head_correction_ratio?: Maybe<Scalars['Float']['output']>;
  length_feet?: Maybe<Scalars['Float']['output']>;
  rate_correction_ratio?: Maybe<Scalars['Float']['output']>;
  total_stages?: Maybe<Scalars['Float']['output']>;
  weight_pounds?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "revisions.scenario_equipment_xref_pumps_revisions" */
export type Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Var_Pop_Order_By = {
  brake_horsepower_correction_ratio?: InputMaybe<Order_By>;
  head_correction_ratio?: InputMaybe<Order_By>;
  length_feet?: InputMaybe<Order_By>;
  rate_correction_ratio?: InputMaybe<Order_By>;
  total_stages?: InputMaybe<Order_By>;
  weight_pounds?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Var_Samp_Fields = {
  __typename: 'revisions_scenario_equipment_xref_pumps_revisions_var_samp_fields';
  brake_horsepower_correction_ratio?: Maybe<Scalars['Float']['output']>;
  head_correction_ratio?: Maybe<Scalars['Float']['output']>;
  length_feet?: Maybe<Scalars['Float']['output']>;
  rate_correction_ratio?: Maybe<Scalars['Float']['output']>;
  total_stages?: Maybe<Scalars['Float']['output']>;
  weight_pounds?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "revisions.scenario_equipment_xref_pumps_revisions" */
export type Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Var_Samp_Order_By = {
  brake_horsepower_correction_ratio?: InputMaybe<Order_By>;
  head_correction_ratio?: InputMaybe<Order_By>;
  length_feet?: InputMaybe<Order_By>;
  rate_correction_ratio?: InputMaybe<Order_By>;
  total_stages?: InputMaybe<Order_By>;
  weight_pounds?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Variance_Fields = {
  __typename: 'revisions_scenario_equipment_xref_pumps_revisions_variance_fields';
  brake_horsepower_correction_ratio?: Maybe<Scalars['Float']['output']>;
  head_correction_ratio?: Maybe<Scalars['Float']['output']>;
  length_feet?: Maybe<Scalars['Float']['output']>;
  rate_correction_ratio?: Maybe<Scalars['Float']['output']>;
  total_stages?: Maybe<Scalars['Float']['output']>;
  weight_pounds?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "revisions.scenario_equipment_xref_pumps_revisions" */
export type Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Variance_Order_By = {
  brake_horsepower_correction_ratio?: InputMaybe<Order_By>;
  head_correction_ratio?: InputMaybe<Order_By>;
  length_feet?: InputMaybe<Order_By>;
  rate_correction_ratio?: InputMaybe<Order_By>;
  total_stages?: InputMaybe<Order_By>;
  weight_pounds?: InputMaybe<Order_By>;
};

/** columns and relationships of "revisions.scenario_equipment_xref_seals_journal" */
export type Revisions_Scenario_Equipment_Xref_Seals_Journal = {
  __typename: 'revisions_scenario_equipment_xref_seals_journal';
  author_id: Scalars['String']['output'];
  created_at: Scalars['timestamptz']['output'];
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  parent_journal_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  scenario_equipment_xref_seals_journal?: Maybe<Revisions_Scenario_Equipment_Xref_Seals_Journal>;
  /** An array relationship */
  scenario_equipment_xref_seals_journals: Array<Revisions_Scenario_Equipment_Xref_Seals_Journal>;
  /** An aggregate relationship */
  scenario_equipment_xref_seals_journals_aggregate: Revisions_Scenario_Equipment_Xref_Seals_Journal_Aggregate;
  /** An object relationship */
  scenario_equipment_xref_seals_revision?: Maybe<Revisions_Scenario_Equipment_Xref_Seals_Revisions>;
  /** An array relationship */
  scenario_equipment_xref_seals_revisions: Array<Revisions_Scenario_Equipment_Xref_Seals_Revisions>;
  /** An aggregate relationship */
  scenario_equipment_xref_seals_revisions_aggregate: Revisions_Scenario_Equipment_Xref_Seals_Revisions_Aggregate;
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Users;
  winning_revision_id?: Maybe<Scalars['uuid']['output']>;
};


/** columns and relationships of "revisions.scenario_equipment_xref_seals_journal" */
export type Revisions_Scenario_Equipment_Xref_Seals_JournalScenario_Equipment_Xref_Seals_JournalsArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Seals_Journal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Seals_Journal_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Equipment_Xref_Seals_Journal_Bool_Exp>;
};


/** columns and relationships of "revisions.scenario_equipment_xref_seals_journal" */
export type Revisions_Scenario_Equipment_Xref_Seals_JournalScenario_Equipment_Xref_Seals_Journals_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Seals_Journal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Seals_Journal_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Equipment_Xref_Seals_Journal_Bool_Exp>;
};


/** columns and relationships of "revisions.scenario_equipment_xref_seals_journal" */
export type Revisions_Scenario_Equipment_Xref_Seals_JournalScenario_Equipment_Xref_Seals_RevisionsArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Seals_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Seals_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Equipment_Xref_Seals_Revisions_Bool_Exp>;
};


/** columns and relationships of "revisions.scenario_equipment_xref_seals_journal" */
export type Revisions_Scenario_Equipment_Xref_Seals_JournalScenario_Equipment_Xref_Seals_Revisions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Seals_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Seals_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Equipment_Xref_Seals_Revisions_Bool_Exp>;
};

/** aggregated selection of "revisions.scenario_equipment_xref_seals_journal" */
export type Revisions_Scenario_Equipment_Xref_Seals_Journal_Aggregate = {
  __typename: 'revisions_scenario_equipment_xref_seals_journal_aggregate';
  aggregate?: Maybe<Revisions_Scenario_Equipment_Xref_Seals_Journal_Aggregate_Fields>;
  nodes: Array<Revisions_Scenario_Equipment_Xref_Seals_Journal>;
};

export type Revisions_Scenario_Equipment_Xref_Seals_Journal_Aggregate_Bool_Exp = {
  count?: InputMaybe<Revisions_Scenario_Equipment_Xref_Seals_Journal_Aggregate_Bool_Exp_Count>;
};

export type Revisions_Scenario_Equipment_Xref_Seals_Journal_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Seals_Journal_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Revisions_Scenario_Equipment_Xref_Seals_Journal_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "revisions.scenario_equipment_xref_seals_journal" */
export type Revisions_Scenario_Equipment_Xref_Seals_Journal_Aggregate_Fields = {
  __typename: 'revisions_scenario_equipment_xref_seals_journal_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Revisions_Scenario_Equipment_Xref_Seals_Journal_Max_Fields>;
  min?: Maybe<Revisions_Scenario_Equipment_Xref_Seals_Journal_Min_Fields>;
};


/** aggregate fields of "revisions.scenario_equipment_xref_seals_journal" */
export type Revisions_Scenario_Equipment_Xref_Seals_Journal_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Seals_Journal_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "revisions.scenario_equipment_xref_seals_journal" */
export type Revisions_Scenario_Equipment_Xref_Seals_Journal_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Revisions_Scenario_Equipment_Xref_Seals_Journal_Max_Order_By>;
  min?: InputMaybe<Revisions_Scenario_Equipment_Xref_Seals_Journal_Min_Order_By>;
};

/** input type for inserting array relation for remote table "revisions.scenario_equipment_xref_seals_journal" */
export type Revisions_Scenario_Equipment_Xref_Seals_Journal_Arr_Rel_Insert_Input = {
  data: Array<Revisions_Scenario_Equipment_Xref_Seals_Journal_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Revisions_Scenario_Equipment_Xref_Seals_Journal_On_Conflict>;
};

/** Boolean expression to filter rows from the table "revisions.scenario_equipment_xref_seals_journal". All fields are combined with a logical 'AND'. */
export type Revisions_Scenario_Equipment_Xref_Seals_Journal_Bool_Exp = {
  _and?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Seals_Journal_Bool_Exp>>;
  _not?: InputMaybe<Revisions_Scenario_Equipment_Xref_Seals_Journal_Bool_Exp>;
  _or?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Seals_Journal_Bool_Exp>>;
  author_id?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  parent_journal_id?: InputMaybe<Uuid_Comparison_Exp>;
  scenario_equipment_xref_seals_journal?: InputMaybe<Revisions_Scenario_Equipment_Xref_Seals_Journal_Bool_Exp>;
  scenario_equipment_xref_seals_journals?: InputMaybe<Revisions_Scenario_Equipment_Xref_Seals_Journal_Bool_Exp>;
  scenario_equipment_xref_seals_journals_aggregate?: InputMaybe<Revisions_Scenario_Equipment_Xref_Seals_Journal_Aggregate_Bool_Exp>;
  scenario_equipment_xref_seals_revision?: InputMaybe<Revisions_Scenario_Equipment_Xref_Seals_Revisions_Bool_Exp>;
  scenario_equipment_xref_seals_revisions?: InputMaybe<Revisions_Scenario_Equipment_Xref_Seals_Revisions_Bool_Exp>;
  scenario_equipment_xref_seals_revisions_aggregate?: InputMaybe<Revisions_Scenario_Equipment_Xref_Seals_Revisions_Aggregate_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  winning_revision_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "revisions.scenario_equipment_xref_seals_journal" */
export enum Revisions_Scenario_Equipment_Xref_Seals_Journal_Constraint {
  /** unique or primary key constraint on columns "id" */
  ScenarioEquipmentXrefSealsJournalPkey = 'scenario_equipment_xref_seals_journal_pkey'
}

/** input type for inserting data into table "revisions.scenario_equipment_xref_seals_journal" */
export type Revisions_Scenario_Equipment_Xref_Seals_Journal_Insert_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  parent_journal_id?: InputMaybe<Scalars['uuid']['input']>;
  scenario_equipment_xref_seals_journal?: InputMaybe<Revisions_Scenario_Equipment_Xref_Seals_Journal_Obj_Rel_Insert_Input>;
  scenario_equipment_xref_seals_journals?: InputMaybe<Revisions_Scenario_Equipment_Xref_Seals_Journal_Arr_Rel_Insert_Input>;
  scenario_equipment_xref_seals_revision?: InputMaybe<Revisions_Scenario_Equipment_Xref_Seals_Revisions_Obj_Rel_Insert_Input>;
  scenario_equipment_xref_seals_revisions?: InputMaybe<Revisions_Scenario_Equipment_Xref_Seals_Revisions_Arr_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  winning_revision_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Revisions_Scenario_Equipment_Xref_Seals_Journal_Max_Fields = {
  __typename: 'revisions_scenario_equipment_xref_seals_journal_max_fields';
  author_id?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  parent_journal_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  winning_revision_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "revisions.scenario_equipment_xref_seals_journal" */
export type Revisions_Scenario_Equipment_Xref_Seals_Journal_Max_Order_By = {
  author_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parent_journal_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  winning_revision_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Revisions_Scenario_Equipment_Xref_Seals_Journal_Min_Fields = {
  __typename: 'revisions_scenario_equipment_xref_seals_journal_min_fields';
  author_id?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  parent_journal_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  winning_revision_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "revisions.scenario_equipment_xref_seals_journal" */
export type Revisions_Scenario_Equipment_Xref_Seals_Journal_Min_Order_By = {
  author_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parent_journal_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  winning_revision_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "revisions.scenario_equipment_xref_seals_journal" */
export type Revisions_Scenario_Equipment_Xref_Seals_Journal_Mutation_Response = {
  __typename: 'revisions_scenario_equipment_xref_seals_journal_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Revisions_Scenario_Equipment_Xref_Seals_Journal>;
};

/** input type for inserting object relation for remote table "revisions.scenario_equipment_xref_seals_journal" */
export type Revisions_Scenario_Equipment_Xref_Seals_Journal_Obj_Rel_Insert_Input = {
  data: Revisions_Scenario_Equipment_Xref_Seals_Journal_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Revisions_Scenario_Equipment_Xref_Seals_Journal_On_Conflict>;
};

/** on_conflict condition type for table "revisions.scenario_equipment_xref_seals_journal" */
export type Revisions_Scenario_Equipment_Xref_Seals_Journal_On_Conflict = {
  constraint: Revisions_Scenario_Equipment_Xref_Seals_Journal_Constraint;
  update_columns?: Array<Revisions_Scenario_Equipment_Xref_Seals_Journal_Update_Column>;
  where?: InputMaybe<Revisions_Scenario_Equipment_Xref_Seals_Journal_Bool_Exp>;
};

/** Ordering options when selecting data from "revisions.scenario_equipment_xref_seals_journal". */
export type Revisions_Scenario_Equipment_Xref_Seals_Journal_Order_By = {
  author_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parent_journal_id?: InputMaybe<Order_By>;
  scenario_equipment_xref_seals_journal?: InputMaybe<Revisions_Scenario_Equipment_Xref_Seals_Journal_Order_By>;
  scenario_equipment_xref_seals_journals_aggregate?: InputMaybe<Revisions_Scenario_Equipment_Xref_Seals_Journal_Aggregate_Order_By>;
  scenario_equipment_xref_seals_revision?: InputMaybe<Revisions_Scenario_Equipment_Xref_Seals_Revisions_Order_By>;
  scenario_equipment_xref_seals_revisions_aggregate?: InputMaybe<Revisions_Scenario_Equipment_Xref_Seals_Revisions_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  winning_revision_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: revisions.scenario_equipment_xref_seals_journal */
export type Revisions_Scenario_Equipment_Xref_Seals_Journal_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "revisions.scenario_equipment_xref_seals_journal" */
export enum Revisions_Scenario_Equipment_Xref_Seals_Journal_Select_Column {
  /** column name */
  AuthorId = 'author_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  ParentJournalId = 'parent_journal_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WinningRevisionId = 'winning_revision_id'
}

/** input type for updating data in table "revisions.scenario_equipment_xref_seals_journal" */
export type Revisions_Scenario_Equipment_Xref_Seals_Journal_Set_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  parent_journal_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  winning_revision_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "revisions_scenario_equipment_xref_seals_journal" */
export type Revisions_Scenario_Equipment_Xref_Seals_Journal_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Revisions_Scenario_Equipment_Xref_Seals_Journal_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Revisions_Scenario_Equipment_Xref_Seals_Journal_Stream_Cursor_Value_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  parent_journal_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  winning_revision_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "revisions.scenario_equipment_xref_seals_journal" */
export enum Revisions_Scenario_Equipment_Xref_Seals_Journal_Update_Column {
  /** column name */
  AuthorId = 'author_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  ParentJournalId = 'parent_journal_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WinningRevisionId = 'winning_revision_id'
}

export type Revisions_Scenario_Equipment_Xref_Seals_Journal_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Revisions_Scenario_Equipment_Xref_Seals_Journal_Set_Input>;
  /** filter the rows which have to be updated */
  where: Revisions_Scenario_Equipment_Xref_Seals_Journal_Bool_Exp;
};

/** columns and relationships of "revisions.scenario_equipment_xref_seals_revisions" */
export type Revisions_Scenario_Equipment_Xref_Seals_Revisions = {
  __typename: 'revisions_scenario_equipment_xref_seals_revisions';
  author_id: Scalars['String']['output'];
  cloned_from_journal_id?: Maybe<Scalars['uuid']['output']>;
  created_at: Scalars['timestamptz']['output'];
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  journal_id: Scalars['uuid']['output'];
  parent_revision_id?: Maybe<Scalars['uuid']['output']>;
  scenario_equipment_id: Scalars['uuid']['output'];
  /** An object relationship */
  scenario_equipment_journal: Revisions_Scenario_Equipment_Journal;
  /** An object relationship */
  scenario_equipment_xref_seals_journal: Revisions_Scenario_Equipment_Xref_Seals_Journal;
  /** An array relationship */
  scenario_equipment_xref_seals_journals: Array<Revisions_Scenario_Equipment_Xref_Seals_Journal>;
  /** An aggregate relationship */
  scenario_equipment_xref_seals_journals_aggregate: Revisions_Scenario_Equipment_Xref_Seals_Journal_Aggregate;
  /** An object relationship */
  scenario_equipment_xref_seals_revision?: Maybe<Revisions_Scenario_Equipment_Xref_Seals_Revisions>;
  /** An array relationship */
  scenario_equipment_xref_seals_revisions: Array<Revisions_Scenario_Equipment_Xref_Seals_Revisions>;
  /** An aggregate relationship */
  scenario_equipment_xref_seals_revisions_aggregate: Revisions_Scenario_Equipment_Xref_Seals_Revisions_Aggregate;
  /** An object relationship */
  scenario_equipment_xref_seals_view?: Maybe<Scenario_Equipment_Xref_Seals>;
  /** An object relationship */
  seal: Seals;
  seal_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
  use_high_strength_shaft: Scalars['Boolean']['output'];
  /** An object relationship */
  user: Users;
};


/** columns and relationships of "revisions.scenario_equipment_xref_seals_revisions" */
export type Revisions_Scenario_Equipment_Xref_Seals_RevisionsScenario_Equipment_Xref_Seals_JournalsArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Seals_Journal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Seals_Journal_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Equipment_Xref_Seals_Journal_Bool_Exp>;
};


/** columns and relationships of "revisions.scenario_equipment_xref_seals_revisions" */
export type Revisions_Scenario_Equipment_Xref_Seals_RevisionsScenario_Equipment_Xref_Seals_Journals_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Seals_Journal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Seals_Journal_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Equipment_Xref_Seals_Journal_Bool_Exp>;
};


/** columns and relationships of "revisions.scenario_equipment_xref_seals_revisions" */
export type Revisions_Scenario_Equipment_Xref_Seals_RevisionsScenario_Equipment_Xref_Seals_RevisionsArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Seals_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Seals_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Equipment_Xref_Seals_Revisions_Bool_Exp>;
};


/** columns and relationships of "revisions.scenario_equipment_xref_seals_revisions" */
export type Revisions_Scenario_Equipment_Xref_Seals_RevisionsScenario_Equipment_Xref_Seals_Revisions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Seals_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Seals_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Equipment_Xref_Seals_Revisions_Bool_Exp>;
};

/** aggregated selection of "revisions.scenario_equipment_xref_seals_revisions" */
export type Revisions_Scenario_Equipment_Xref_Seals_Revisions_Aggregate = {
  __typename: 'revisions_scenario_equipment_xref_seals_revisions_aggregate';
  aggregate?: Maybe<Revisions_Scenario_Equipment_Xref_Seals_Revisions_Aggregate_Fields>;
  nodes: Array<Revisions_Scenario_Equipment_Xref_Seals_Revisions>;
};

export type Revisions_Scenario_Equipment_Xref_Seals_Revisions_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Revisions_Scenario_Equipment_Xref_Seals_Revisions_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Revisions_Scenario_Equipment_Xref_Seals_Revisions_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Revisions_Scenario_Equipment_Xref_Seals_Revisions_Aggregate_Bool_Exp_Count>;
};

export type Revisions_Scenario_Equipment_Xref_Seals_Revisions_Aggregate_Bool_Exp_Bool_And = {
  arguments: Revisions_Scenario_Equipment_Xref_Seals_Revisions_Select_Column_Revisions_Scenario_Equipment_Xref_Seals_Revisions_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Revisions_Scenario_Equipment_Xref_Seals_Revisions_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Revisions_Scenario_Equipment_Xref_Seals_Revisions_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Revisions_Scenario_Equipment_Xref_Seals_Revisions_Select_Column_Revisions_Scenario_Equipment_Xref_Seals_Revisions_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Revisions_Scenario_Equipment_Xref_Seals_Revisions_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Revisions_Scenario_Equipment_Xref_Seals_Revisions_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Seals_Revisions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Revisions_Scenario_Equipment_Xref_Seals_Revisions_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "revisions.scenario_equipment_xref_seals_revisions" */
export type Revisions_Scenario_Equipment_Xref_Seals_Revisions_Aggregate_Fields = {
  __typename: 'revisions_scenario_equipment_xref_seals_revisions_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Revisions_Scenario_Equipment_Xref_Seals_Revisions_Max_Fields>;
  min?: Maybe<Revisions_Scenario_Equipment_Xref_Seals_Revisions_Min_Fields>;
};


/** aggregate fields of "revisions.scenario_equipment_xref_seals_revisions" */
export type Revisions_Scenario_Equipment_Xref_Seals_Revisions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Seals_Revisions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "revisions.scenario_equipment_xref_seals_revisions" */
export type Revisions_Scenario_Equipment_Xref_Seals_Revisions_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Revisions_Scenario_Equipment_Xref_Seals_Revisions_Max_Order_By>;
  min?: InputMaybe<Revisions_Scenario_Equipment_Xref_Seals_Revisions_Min_Order_By>;
};

/** input type for inserting array relation for remote table "revisions.scenario_equipment_xref_seals_revisions" */
export type Revisions_Scenario_Equipment_Xref_Seals_Revisions_Arr_Rel_Insert_Input = {
  data: Array<Revisions_Scenario_Equipment_Xref_Seals_Revisions_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Revisions_Scenario_Equipment_Xref_Seals_Revisions_On_Conflict>;
};

/** Boolean expression to filter rows from the table "revisions.scenario_equipment_xref_seals_revisions". All fields are combined with a logical 'AND'. */
export type Revisions_Scenario_Equipment_Xref_Seals_Revisions_Bool_Exp = {
  _and?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Seals_Revisions_Bool_Exp>>;
  _not?: InputMaybe<Revisions_Scenario_Equipment_Xref_Seals_Revisions_Bool_Exp>;
  _or?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Seals_Revisions_Bool_Exp>>;
  author_id?: InputMaybe<String_Comparison_Exp>;
  cloned_from_journal_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  journal_id?: InputMaybe<Uuid_Comparison_Exp>;
  parent_revision_id?: InputMaybe<Uuid_Comparison_Exp>;
  scenario_equipment_id?: InputMaybe<Uuid_Comparison_Exp>;
  scenario_equipment_journal?: InputMaybe<Revisions_Scenario_Equipment_Journal_Bool_Exp>;
  scenario_equipment_xref_seals_journal?: InputMaybe<Revisions_Scenario_Equipment_Xref_Seals_Journal_Bool_Exp>;
  scenario_equipment_xref_seals_journals?: InputMaybe<Revisions_Scenario_Equipment_Xref_Seals_Journal_Bool_Exp>;
  scenario_equipment_xref_seals_journals_aggregate?: InputMaybe<Revisions_Scenario_Equipment_Xref_Seals_Journal_Aggregate_Bool_Exp>;
  scenario_equipment_xref_seals_revision?: InputMaybe<Revisions_Scenario_Equipment_Xref_Seals_Revisions_Bool_Exp>;
  scenario_equipment_xref_seals_revisions?: InputMaybe<Revisions_Scenario_Equipment_Xref_Seals_Revisions_Bool_Exp>;
  scenario_equipment_xref_seals_revisions_aggregate?: InputMaybe<Revisions_Scenario_Equipment_Xref_Seals_Revisions_Aggregate_Bool_Exp>;
  scenario_equipment_xref_seals_view?: InputMaybe<Scenario_Equipment_Xref_Seals_Bool_Exp>;
  seal?: InputMaybe<Seals_Bool_Exp>;
  seal_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  use_high_strength_shaft?: InputMaybe<Boolean_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
};

/** unique or primary key constraints on table "revisions.scenario_equipment_xref_seals_revisions" */
export enum Revisions_Scenario_Equipment_Xref_Seals_Revisions_Constraint {
  /** unique or primary key constraint on columns "id" */
  ScenarioEquipmentXrefSealsRevisionsPkey = 'scenario_equipment_xref_seals_revisions_pkey'
}

/** input type for inserting data into table "revisions.scenario_equipment_xref_seals_revisions" */
export type Revisions_Scenario_Equipment_Xref_Seals_Revisions_Insert_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  cloned_from_journal_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  journal_id?: InputMaybe<Scalars['uuid']['input']>;
  parent_revision_id?: InputMaybe<Scalars['uuid']['input']>;
  scenario_equipment_id?: InputMaybe<Scalars['uuid']['input']>;
  scenario_equipment_journal?: InputMaybe<Revisions_Scenario_Equipment_Journal_Obj_Rel_Insert_Input>;
  scenario_equipment_xref_seals_journal?: InputMaybe<Revisions_Scenario_Equipment_Xref_Seals_Journal_Obj_Rel_Insert_Input>;
  scenario_equipment_xref_seals_journals?: InputMaybe<Revisions_Scenario_Equipment_Xref_Seals_Journal_Arr_Rel_Insert_Input>;
  scenario_equipment_xref_seals_revision?: InputMaybe<Revisions_Scenario_Equipment_Xref_Seals_Revisions_Obj_Rel_Insert_Input>;
  scenario_equipment_xref_seals_revisions?: InputMaybe<Revisions_Scenario_Equipment_Xref_Seals_Revisions_Arr_Rel_Insert_Input>;
  scenario_equipment_xref_seals_view?: InputMaybe<Scenario_Equipment_Xref_Seals_Obj_Rel_Insert_Input>;
  seal?: InputMaybe<Seals_Obj_Rel_Insert_Input>;
  seal_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  use_high_strength_shaft?: InputMaybe<Scalars['Boolean']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Revisions_Scenario_Equipment_Xref_Seals_Revisions_Max_Fields = {
  __typename: 'revisions_scenario_equipment_xref_seals_revisions_max_fields';
  author_id?: Maybe<Scalars['String']['output']>;
  cloned_from_journal_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  journal_id?: Maybe<Scalars['uuid']['output']>;
  parent_revision_id?: Maybe<Scalars['uuid']['output']>;
  scenario_equipment_id?: Maybe<Scalars['uuid']['output']>;
  seal_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "revisions.scenario_equipment_xref_seals_revisions" */
export type Revisions_Scenario_Equipment_Xref_Seals_Revisions_Max_Order_By = {
  author_id?: InputMaybe<Order_By>;
  cloned_from_journal_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  journal_id?: InputMaybe<Order_By>;
  parent_revision_id?: InputMaybe<Order_By>;
  scenario_equipment_id?: InputMaybe<Order_By>;
  seal_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Revisions_Scenario_Equipment_Xref_Seals_Revisions_Min_Fields = {
  __typename: 'revisions_scenario_equipment_xref_seals_revisions_min_fields';
  author_id?: Maybe<Scalars['String']['output']>;
  cloned_from_journal_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  journal_id?: Maybe<Scalars['uuid']['output']>;
  parent_revision_id?: Maybe<Scalars['uuid']['output']>;
  scenario_equipment_id?: Maybe<Scalars['uuid']['output']>;
  seal_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "revisions.scenario_equipment_xref_seals_revisions" */
export type Revisions_Scenario_Equipment_Xref_Seals_Revisions_Min_Order_By = {
  author_id?: InputMaybe<Order_By>;
  cloned_from_journal_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  journal_id?: InputMaybe<Order_By>;
  parent_revision_id?: InputMaybe<Order_By>;
  scenario_equipment_id?: InputMaybe<Order_By>;
  seal_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "revisions.scenario_equipment_xref_seals_revisions" */
export type Revisions_Scenario_Equipment_Xref_Seals_Revisions_Mutation_Response = {
  __typename: 'revisions_scenario_equipment_xref_seals_revisions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Revisions_Scenario_Equipment_Xref_Seals_Revisions>;
};

/** input type for inserting object relation for remote table "revisions.scenario_equipment_xref_seals_revisions" */
export type Revisions_Scenario_Equipment_Xref_Seals_Revisions_Obj_Rel_Insert_Input = {
  data: Revisions_Scenario_Equipment_Xref_Seals_Revisions_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Revisions_Scenario_Equipment_Xref_Seals_Revisions_On_Conflict>;
};

/** on_conflict condition type for table "revisions.scenario_equipment_xref_seals_revisions" */
export type Revisions_Scenario_Equipment_Xref_Seals_Revisions_On_Conflict = {
  constraint: Revisions_Scenario_Equipment_Xref_Seals_Revisions_Constraint;
  update_columns?: Array<Revisions_Scenario_Equipment_Xref_Seals_Revisions_Update_Column>;
  where?: InputMaybe<Revisions_Scenario_Equipment_Xref_Seals_Revisions_Bool_Exp>;
};

/** Ordering options when selecting data from "revisions.scenario_equipment_xref_seals_revisions". */
export type Revisions_Scenario_Equipment_Xref_Seals_Revisions_Order_By = {
  author_id?: InputMaybe<Order_By>;
  cloned_from_journal_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  journal_id?: InputMaybe<Order_By>;
  parent_revision_id?: InputMaybe<Order_By>;
  scenario_equipment_id?: InputMaybe<Order_By>;
  scenario_equipment_journal?: InputMaybe<Revisions_Scenario_Equipment_Journal_Order_By>;
  scenario_equipment_xref_seals_journal?: InputMaybe<Revisions_Scenario_Equipment_Xref_Seals_Journal_Order_By>;
  scenario_equipment_xref_seals_journals_aggregate?: InputMaybe<Revisions_Scenario_Equipment_Xref_Seals_Journal_Aggregate_Order_By>;
  scenario_equipment_xref_seals_revision?: InputMaybe<Revisions_Scenario_Equipment_Xref_Seals_Revisions_Order_By>;
  scenario_equipment_xref_seals_revisions_aggregate?: InputMaybe<Revisions_Scenario_Equipment_Xref_Seals_Revisions_Aggregate_Order_By>;
  scenario_equipment_xref_seals_view?: InputMaybe<Scenario_Equipment_Xref_Seals_Order_By>;
  seal?: InputMaybe<Seals_Order_By>;
  seal_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  use_high_strength_shaft?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
};

/** primary key columns input for table: revisions.scenario_equipment_xref_seals_revisions */
export type Revisions_Scenario_Equipment_Xref_Seals_Revisions_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "revisions.scenario_equipment_xref_seals_revisions" */
export enum Revisions_Scenario_Equipment_Xref_Seals_Revisions_Select_Column {
  /** column name */
  AuthorId = 'author_id',
  /** column name */
  ClonedFromJournalId = 'cloned_from_journal_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  JournalId = 'journal_id',
  /** column name */
  ParentRevisionId = 'parent_revision_id',
  /** column name */
  ScenarioEquipmentId = 'scenario_equipment_id',
  /** column name */
  SealId = 'seal_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UseHighStrengthShaft = 'use_high_strength_shaft'
}

/** select "revisions_scenario_equipment_xref_seals_revisions_aggregate_bool_exp_bool_and_arguments_columns" columns of table "revisions.scenario_equipment_xref_seals_revisions" */
export enum Revisions_Scenario_Equipment_Xref_Seals_Revisions_Select_Column_Revisions_Scenario_Equipment_Xref_Seals_Revisions_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  UseHighStrengthShaft = 'use_high_strength_shaft'
}

/** select "revisions_scenario_equipment_xref_seals_revisions_aggregate_bool_exp_bool_or_arguments_columns" columns of table "revisions.scenario_equipment_xref_seals_revisions" */
export enum Revisions_Scenario_Equipment_Xref_Seals_Revisions_Select_Column_Revisions_Scenario_Equipment_Xref_Seals_Revisions_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  UseHighStrengthShaft = 'use_high_strength_shaft'
}

/** input type for updating data in table "revisions.scenario_equipment_xref_seals_revisions" */
export type Revisions_Scenario_Equipment_Xref_Seals_Revisions_Set_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  cloned_from_journal_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  journal_id?: InputMaybe<Scalars['uuid']['input']>;
  parent_revision_id?: InputMaybe<Scalars['uuid']['input']>;
  scenario_equipment_id?: InputMaybe<Scalars['uuid']['input']>;
  seal_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  use_high_strength_shaft?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Streaming cursor of the table "revisions_scenario_equipment_xref_seals_revisions" */
export type Revisions_Scenario_Equipment_Xref_Seals_Revisions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Revisions_Scenario_Equipment_Xref_Seals_Revisions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Revisions_Scenario_Equipment_Xref_Seals_Revisions_Stream_Cursor_Value_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  cloned_from_journal_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  journal_id?: InputMaybe<Scalars['uuid']['input']>;
  parent_revision_id?: InputMaybe<Scalars['uuid']['input']>;
  scenario_equipment_id?: InputMaybe<Scalars['uuid']['input']>;
  seal_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  use_high_strength_shaft?: InputMaybe<Scalars['Boolean']['input']>;
};

/** update columns of table "revisions.scenario_equipment_xref_seals_revisions" */
export enum Revisions_Scenario_Equipment_Xref_Seals_Revisions_Update_Column {
  /** column name */
  AuthorId = 'author_id',
  /** column name */
  ClonedFromJournalId = 'cloned_from_journal_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  JournalId = 'journal_id',
  /** column name */
  ParentRevisionId = 'parent_revision_id',
  /** column name */
  ScenarioEquipmentId = 'scenario_equipment_id',
  /** column name */
  SealId = 'seal_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UseHighStrengthShaft = 'use_high_strength_shaft'
}

export type Revisions_Scenario_Equipment_Xref_Seals_Revisions_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Revisions_Scenario_Equipment_Xref_Seals_Revisions_Set_Input>;
  /** filter the rows which have to be updated */
  where: Revisions_Scenario_Equipment_Xref_Seals_Revisions_Bool_Exp;
};

/** columns and relationships of "revisions.scenario_parameters_journal" */
export type Revisions_Scenario_Parameters_Journal = {
  __typename: 'revisions_scenario_parameters_journal';
  author_id: Scalars['String']['output'];
  created_at: Scalars['timestamptz']['output'];
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  parent_journal_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  scenario_parameters_journal?: Maybe<Revisions_Scenario_Parameters_Journal>;
  /** An array relationship */
  scenario_parameters_journals: Array<Revisions_Scenario_Parameters_Journal>;
  /** An aggregate relationship */
  scenario_parameters_journals_aggregate: Revisions_Scenario_Parameters_Journal_Aggregate;
  /** An object relationship */
  scenario_parameters_revision?: Maybe<Revisions_Scenario_Parameters_Revisions>;
  /** An array relationship */
  scenario_parameters_revisions: Array<Revisions_Scenario_Parameters_Revisions>;
  /** An aggregate relationship */
  scenario_parameters_revisions_aggregate: Revisions_Scenario_Parameters_Revisions_Aggregate;
  /** An array relationship */
  scenarios_revisions: Array<Revisions_Scenarios_Revisions>;
  /** An aggregate relationship */
  scenarios_revisions_aggregate: Revisions_Scenarios_Revisions_Aggregate;
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Users;
  winning_revision_id?: Maybe<Scalars['uuid']['output']>;
};


/** columns and relationships of "revisions.scenario_parameters_journal" */
export type Revisions_Scenario_Parameters_JournalScenario_Parameters_JournalsArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Parameters_Journal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Parameters_Journal_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Parameters_Journal_Bool_Exp>;
};


/** columns and relationships of "revisions.scenario_parameters_journal" */
export type Revisions_Scenario_Parameters_JournalScenario_Parameters_Journals_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Parameters_Journal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Parameters_Journal_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Parameters_Journal_Bool_Exp>;
};


/** columns and relationships of "revisions.scenario_parameters_journal" */
export type Revisions_Scenario_Parameters_JournalScenario_Parameters_RevisionsArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Parameters_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Parameters_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Parameters_Revisions_Bool_Exp>;
};


/** columns and relationships of "revisions.scenario_parameters_journal" */
export type Revisions_Scenario_Parameters_JournalScenario_Parameters_Revisions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Parameters_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Parameters_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Parameters_Revisions_Bool_Exp>;
};


/** columns and relationships of "revisions.scenario_parameters_journal" */
export type Revisions_Scenario_Parameters_JournalScenarios_RevisionsArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenarios_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenarios_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Scenarios_Revisions_Bool_Exp>;
};


/** columns and relationships of "revisions.scenario_parameters_journal" */
export type Revisions_Scenario_Parameters_JournalScenarios_Revisions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenarios_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenarios_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Scenarios_Revisions_Bool_Exp>;
};

/** aggregated selection of "revisions.scenario_parameters_journal" */
export type Revisions_Scenario_Parameters_Journal_Aggregate = {
  __typename: 'revisions_scenario_parameters_journal_aggregate';
  aggregate?: Maybe<Revisions_Scenario_Parameters_Journal_Aggregate_Fields>;
  nodes: Array<Revisions_Scenario_Parameters_Journal>;
};

export type Revisions_Scenario_Parameters_Journal_Aggregate_Bool_Exp = {
  count?: InputMaybe<Revisions_Scenario_Parameters_Journal_Aggregate_Bool_Exp_Count>;
};

export type Revisions_Scenario_Parameters_Journal_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Revisions_Scenario_Parameters_Journal_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Revisions_Scenario_Parameters_Journal_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "revisions.scenario_parameters_journal" */
export type Revisions_Scenario_Parameters_Journal_Aggregate_Fields = {
  __typename: 'revisions_scenario_parameters_journal_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Revisions_Scenario_Parameters_Journal_Max_Fields>;
  min?: Maybe<Revisions_Scenario_Parameters_Journal_Min_Fields>;
};


/** aggregate fields of "revisions.scenario_parameters_journal" */
export type Revisions_Scenario_Parameters_Journal_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Revisions_Scenario_Parameters_Journal_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "revisions.scenario_parameters_journal" */
export type Revisions_Scenario_Parameters_Journal_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Revisions_Scenario_Parameters_Journal_Max_Order_By>;
  min?: InputMaybe<Revisions_Scenario_Parameters_Journal_Min_Order_By>;
};

/** input type for inserting array relation for remote table "revisions.scenario_parameters_journal" */
export type Revisions_Scenario_Parameters_Journal_Arr_Rel_Insert_Input = {
  data: Array<Revisions_Scenario_Parameters_Journal_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Revisions_Scenario_Parameters_Journal_On_Conflict>;
};

/** Boolean expression to filter rows from the table "revisions.scenario_parameters_journal". All fields are combined with a logical 'AND'. */
export type Revisions_Scenario_Parameters_Journal_Bool_Exp = {
  _and?: InputMaybe<Array<Revisions_Scenario_Parameters_Journal_Bool_Exp>>;
  _not?: InputMaybe<Revisions_Scenario_Parameters_Journal_Bool_Exp>;
  _or?: InputMaybe<Array<Revisions_Scenario_Parameters_Journal_Bool_Exp>>;
  author_id?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  parent_journal_id?: InputMaybe<Uuid_Comparison_Exp>;
  scenario_parameters_journal?: InputMaybe<Revisions_Scenario_Parameters_Journal_Bool_Exp>;
  scenario_parameters_journals?: InputMaybe<Revisions_Scenario_Parameters_Journal_Bool_Exp>;
  scenario_parameters_journals_aggregate?: InputMaybe<Revisions_Scenario_Parameters_Journal_Aggregate_Bool_Exp>;
  scenario_parameters_revision?: InputMaybe<Revisions_Scenario_Parameters_Revisions_Bool_Exp>;
  scenario_parameters_revisions?: InputMaybe<Revisions_Scenario_Parameters_Revisions_Bool_Exp>;
  scenario_parameters_revisions_aggregate?: InputMaybe<Revisions_Scenario_Parameters_Revisions_Aggregate_Bool_Exp>;
  scenarios_revisions?: InputMaybe<Revisions_Scenarios_Revisions_Bool_Exp>;
  scenarios_revisions_aggregate?: InputMaybe<Revisions_Scenarios_Revisions_Aggregate_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  winning_revision_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "revisions.scenario_parameters_journal" */
export enum Revisions_Scenario_Parameters_Journal_Constraint {
  /** unique or primary key constraint on columns "id" */
  ScenarioParametersJournalPkey = 'scenario_parameters_journal_pkey'
}

/** input type for inserting data into table "revisions.scenario_parameters_journal" */
export type Revisions_Scenario_Parameters_Journal_Insert_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  parent_journal_id?: InputMaybe<Scalars['uuid']['input']>;
  scenario_parameters_journal?: InputMaybe<Revisions_Scenario_Parameters_Journal_Obj_Rel_Insert_Input>;
  scenario_parameters_journals?: InputMaybe<Revisions_Scenario_Parameters_Journal_Arr_Rel_Insert_Input>;
  scenario_parameters_revision?: InputMaybe<Revisions_Scenario_Parameters_Revisions_Obj_Rel_Insert_Input>;
  scenario_parameters_revisions?: InputMaybe<Revisions_Scenario_Parameters_Revisions_Arr_Rel_Insert_Input>;
  scenarios_revisions?: InputMaybe<Revisions_Scenarios_Revisions_Arr_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  winning_revision_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Revisions_Scenario_Parameters_Journal_Max_Fields = {
  __typename: 'revisions_scenario_parameters_journal_max_fields';
  author_id?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  parent_journal_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  winning_revision_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "revisions.scenario_parameters_journal" */
export type Revisions_Scenario_Parameters_Journal_Max_Order_By = {
  author_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parent_journal_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  winning_revision_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Revisions_Scenario_Parameters_Journal_Min_Fields = {
  __typename: 'revisions_scenario_parameters_journal_min_fields';
  author_id?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  parent_journal_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  winning_revision_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "revisions.scenario_parameters_journal" */
export type Revisions_Scenario_Parameters_Journal_Min_Order_By = {
  author_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parent_journal_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  winning_revision_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "revisions.scenario_parameters_journal" */
export type Revisions_Scenario_Parameters_Journal_Mutation_Response = {
  __typename: 'revisions_scenario_parameters_journal_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Revisions_Scenario_Parameters_Journal>;
};

/** input type for inserting object relation for remote table "revisions.scenario_parameters_journal" */
export type Revisions_Scenario_Parameters_Journal_Obj_Rel_Insert_Input = {
  data: Revisions_Scenario_Parameters_Journal_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Revisions_Scenario_Parameters_Journal_On_Conflict>;
};

/** on_conflict condition type for table "revisions.scenario_parameters_journal" */
export type Revisions_Scenario_Parameters_Journal_On_Conflict = {
  constraint: Revisions_Scenario_Parameters_Journal_Constraint;
  update_columns?: Array<Revisions_Scenario_Parameters_Journal_Update_Column>;
  where?: InputMaybe<Revisions_Scenario_Parameters_Journal_Bool_Exp>;
};

/** Ordering options when selecting data from "revisions.scenario_parameters_journal". */
export type Revisions_Scenario_Parameters_Journal_Order_By = {
  author_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parent_journal_id?: InputMaybe<Order_By>;
  scenario_parameters_journal?: InputMaybe<Revisions_Scenario_Parameters_Journal_Order_By>;
  scenario_parameters_journals_aggregate?: InputMaybe<Revisions_Scenario_Parameters_Journal_Aggregate_Order_By>;
  scenario_parameters_revision?: InputMaybe<Revisions_Scenario_Parameters_Revisions_Order_By>;
  scenario_parameters_revisions_aggregate?: InputMaybe<Revisions_Scenario_Parameters_Revisions_Aggregate_Order_By>;
  scenarios_revisions_aggregate?: InputMaybe<Revisions_Scenarios_Revisions_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  winning_revision_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: revisions.scenario_parameters_journal */
export type Revisions_Scenario_Parameters_Journal_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "revisions.scenario_parameters_journal" */
export enum Revisions_Scenario_Parameters_Journal_Select_Column {
  /** column name */
  AuthorId = 'author_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  ParentJournalId = 'parent_journal_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WinningRevisionId = 'winning_revision_id'
}

/** input type for updating data in table "revisions.scenario_parameters_journal" */
export type Revisions_Scenario_Parameters_Journal_Set_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  parent_journal_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  winning_revision_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "revisions_scenario_parameters_journal" */
export type Revisions_Scenario_Parameters_Journal_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Revisions_Scenario_Parameters_Journal_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Revisions_Scenario_Parameters_Journal_Stream_Cursor_Value_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  parent_journal_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  winning_revision_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "revisions.scenario_parameters_journal" */
export enum Revisions_Scenario_Parameters_Journal_Update_Column {
  /** column name */
  AuthorId = 'author_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  ParentJournalId = 'parent_journal_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WinningRevisionId = 'winning_revision_id'
}

export type Revisions_Scenario_Parameters_Journal_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Revisions_Scenario_Parameters_Journal_Set_Input>;
  /** filter the rows which have to be updated */
  where: Revisions_Scenario_Parameters_Journal_Bool_Exp;
};

/** columns and relationships of "revisions.scenario_parameters_revisions" */
export type Revisions_Scenario_Parameters_Revisions = {
  __typename: 'revisions_scenario_parameters_revisions';
  author_id: Scalars['String']['output'];
  bottom_casing_pressure_psia?: Maybe<Scalars['numeric']['output']>;
  bottom_tubing_pressure_psia?: Maybe<Scalars['numeric']['output']>;
  cable_cost_kw_hr_usd?: Maybe<Scalars['numeric']['output']>;
  cloned_from_journal_id?: Maybe<Scalars['uuid']['output']>;
  created_at: Scalars['timestamptz']['output'];
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  elevation_feet_asl?: Maybe<Scalars['numeric']['output']>;
  /** An object relationship */
  flowModelByFlowModel: Flow_Model;
  flow_model: Flow_Model_Enum;
  has_compression_pump?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['uuid']['output'];
  /** As fluid flows around the motor of the pump the friction of the fluid causes the pressure to drop. This drop in pressure may already be included in the well test inputs so this calculation must be optionally included. */
  include_casing_friction_loss?: Maybe<Scalars['Boolean']['output']>;
  intake_gas_separation_override_type?: Maybe<Override_Options_Enum>;
  intake_override_gas_separation_percent?: Maybe<Scalars['numeric']['output']>;
  intake_packer_installed?: Maybe<Scalars['Boolean']['output']>;
  journal_id: Scalars['uuid']['output'];
  lower_has_compression_pump?: Maybe<Scalars['Boolean']['output']>;
  lower_include_casing_friction_loss?: Maybe<Scalars['Boolean']['output']>;
  lower_intake_gas_separation_override_type?: Maybe<Override_Options_Enum>;
  lower_intake_override_gas_separation_percent?: Maybe<Scalars['numeric']['output']>;
  lower_intake_packer_installed?: Maybe<Scalars['Boolean']['output']>;
  lower_motor_rerate_ratio?: Maybe<Scalars['numeric']['output']>;
  lower_motor_shroud_interior_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  lower_natural_gas_separation_override_type?: Maybe<Override_Options_Enum>;
  lower_natural_override_gas_separation_percent?: Maybe<Scalars['numeric']['output']>;
  lower_pump_hz?: Maybe<Scalars['numeric']['output']>;
  lower_pump_override_gas_correction_percent?: Maybe<Scalars['numeric']['output']>;
  lower_pump_wear_brake_horsepower_correction_ratio: Scalars['numeric']['output'];
  lower_pump_wear_head_correction_ratio: Scalars['numeric']['output'];
  lower_use_legacy_gas_head_rerate?: Maybe<Scalars['Boolean']['output']>;
  maximum_frequency: Scalars['numeric']['output'];
  minimum_frequency: Scalars['numeric']['output'];
  motor_rerate_ratio?: Maybe<Scalars['numeric']['output']>;
  motor_shroud_interior_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  natural_gas_separation_override_type?: Maybe<Override_Options_Enum>;
  natural_override_gas_separation_percent?: Maybe<Scalars['numeric']['output']>;
  parent_revision_id?: Maybe<Scalars['uuid']['output']>;
  /** pump_hz is the only known column with exponential notation in legacy sizings AND by truncating pump_hz doesnt effect calculations. */
  pump_hz?: Maybe<Scalars['numeric']['output']>;
  pump_override_gas_correction_percent?: Maybe<Scalars['numeric']['output']>;
  pump_wear_brake_horsepower_correction_ratio: Scalars['numeric']['output'];
  pump_wear_head_correction_ratio: Scalars['numeric']['output'];
  /** An object relationship */
  scenario_parameters_journal: Revisions_Scenario_Parameters_Journal;
  /** An array relationship */
  scenario_parameters_journals: Array<Revisions_Scenario_Parameters_Journal>;
  /** An aggregate relationship */
  scenario_parameters_journals_aggregate: Revisions_Scenario_Parameters_Journal_Aggregate;
  /** An object relationship */
  scenario_parameters_revision?: Maybe<Revisions_Scenario_Parameters_Revisions>;
  /** An array relationship */
  scenario_parameters_revisions: Array<Revisions_Scenario_Parameters_Revisions>;
  /** An aggregate relationship */
  scenario_parameters_revisions_aggregate: Revisions_Scenario_Parameters_Revisions_Aggregate;
  /** An object relationship */
  scenario_parameters_view?: Maybe<Scenario_Parameters>;
  surface_drive_incoming_power_volts?: Maybe<Scalars['numeric']['output']>;
  target_liquid_rate_std_barrel_day?: Maybe<Scalars['numeric']['output']>;
  updated_at: Scalars['timestamptz']['output'];
  /** Due to updates to the calculations, some users want to use the formula from Reaver 2.0. This boolean field will persist the user selection to use legacy calcs */
  use_legacy_gas_head_rerate?: Maybe<Scalars['Boolean']['output']>;
  /** An object relationship */
  user: Users;
  vsd_input_voltage?: Maybe<Scalars['numeric']['output']>;
};


/** columns and relationships of "revisions.scenario_parameters_revisions" */
export type Revisions_Scenario_Parameters_RevisionsScenario_Parameters_JournalsArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Parameters_Journal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Parameters_Journal_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Parameters_Journal_Bool_Exp>;
};


/** columns and relationships of "revisions.scenario_parameters_revisions" */
export type Revisions_Scenario_Parameters_RevisionsScenario_Parameters_Journals_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Parameters_Journal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Parameters_Journal_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Parameters_Journal_Bool_Exp>;
};


/** columns and relationships of "revisions.scenario_parameters_revisions" */
export type Revisions_Scenario_Parameters_RevisionsScenario_Parameters_RevisionsArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Parameters_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Parameters_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Parameters_Revisions_Bool_Exp>;
};


/** columns and relationships of "revisions.scenario_parameters_revisions" */
export type Revisions_Scenario_Parameters_RevisionsScenario_Parameters_Revisions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Parameters_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Parameters_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Parameters_Revisions_Bool_Exp>;
};

/** aggregated selection of "revisions.scenario_parameters_revisions" */
export type Revisions_Scenario_Parameters_Revisions_Aggregate = {
  __typename: 'revisions_scenario_parameters_revisions_aggregate';
  aggregate?: Maybe<Revisions_Scenario_Parameters_Revisions_Aggregate_Fields>;
  nodes: Array<Revisions_Scenario_Parameters_Revisions>;
};

export type Revisions_Scenario_Parameters_Revisions_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Revisions_Scenario_Parameters_Revisions_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Revisions_Scenario_Parameters_Revisions_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Revisions_Scenario_Parameters_Revisions_Aggregate_Bool_Exp_Count>;
};

export type Revisions_Scenario_Parameters_Revisions_Aggregate_Bool_Exp_Bool_And = {
  arguments: Revisions_Scenario_Parameters_Revisions_Select_Column_Revisions_Scenario_Parameters_Revisions_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Revisions_Scenario_Parameters_Revisions_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Revisions_Scenario_Parameters_Revisions_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Revisions_Scenario_Parameters_Revisions_Select_Column_Revisions_Scenario_Parameters_Revisions_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Revisions_Scenario_Parameters_Revisions_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Revisions_Scenario_Parameters_Revisions_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Revisions_Scenario_Parameters_Revisions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Revisions_Scenario_Parameters_Revisions_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "revisions.scenario_parameters_revisions" */
export type Revisions_Scenario_Parameters_Revisions_Aggregate_Fields = {
  __typename: 'revisions_scenario_parameters_revisions_aggregate_fields';
  avg?: Maybe<Revisions_Scenario_Parameters_Revisions_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Revisions_Scenario_Parameters_Revisions_Max_Fields>;
  min?: Maybe<Revisions_Scenario_Parameters_Revisions_Min_Fields>;
  stddev?: Maybe<Revisions_Scenario_Parameters_Revisions_Stddev_Fields>;
  stddev_pop?: Maybe<Revisions_Scenario_Parameters_Revisions_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Revisions_Scenario_Parameters_Revisions_Stddev_Samp_Fields>;
  sum?: Maybe<Revisions_Scenario_Parameters_Revisions_Sum_Fields>;
  var_pop?: Maybe<Revisions_Scenario_Parameters_Revisions_Var_Pop_Fields>;
  var_samp?: Maybe<Revisions_Scenario_Parameters_Revisions_Var_Samp_Fields>;
  variance?: Maybe<Revisions_Scenario_Parameters_Revisions_Variance_Fields>;
};


/** aggregate fields of "revisions.scenario_parameters_revisions" */
export type Revisions_Scenario_Parameters_Revisions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Revisions_Scenario_Parameters_Revisions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "revisions.scenario_parameters_revisions" */
export type Revisions_Scenario_Parameters_Revisions_Aggregate_Order_By = {
  avg?: InputMaybe<Revisions_Scenario_Parameters_Revisions_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Revisions_Scenario_Parameters_Revisions_Max_Order_By>;
  min?: InputMaybe<Revisions_Scenario_Parameters_Revisions_Min_Order_By>;
  stddev?: InputMaybe<Revisions_Scenario_Parameters_Revisions_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Revisions_Scenario_Parameters_Revisions_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Revisions_Scenario_Parameters_Revisions_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Revisions_Scenario_Parameters_Revisions_Sum_Order_By>;
  var_pop?: InputMaybe<Revisions_Scenario_Parameters_Revisions_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Revisions_Scenario_Parameters_Revisions_Var_Samp_Order_By>;
  variance?: InputMaybe<Revisions_Scenario_Parameters_Revisions_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "revisions.scenario_parameters_revisions" */
export type Revisions_Scenario_Parameters_Revisions_Arr_Rel_Insert_Input = {
  data: Array<Revisions_Scenario_Parameters_Revisions_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Revisions_Scenario_Parameters_Revisions_On_Conflict>;
};

/** aggregate avg on columns */
export type Revisions_Scenario_Parameters_Revisions_Avg_Fields = {
  __typename: 'revisions_scenario_parameters_revisions_avg_fields';
  bottom_casing_pressure_psia?: Maybe<Scalars['Float']['output']>;
  bottom_tubing_pressure_psia?: Maybe<Scalars['Float']['output']>;
  cable_cost_kw_hr_usd?: Maybe<Scalars['Float']['output']>;
  elevation_feet_asl?: Maybe<Scalars['Float']['output']>;
  intake_override_gas_separation_percent?: Maybe<Scalars['Float']['output']>;
  lower_intake_override_gas_separation_percent?: Maybe<Scalars['Float']['output']>;
  lower_motor_rerate_ratio?: Maybe<Scalars['Float']['output']>;
  lower_motor_shroud_interior_diameter_inches?: Maybe<Scalars['Float']['output']>;
  lower_natural_override_gas_separation_percent?: Maybe<Scalars['Float']['output']>;
  lower_pump_hz?: Maybe<Scalars['Float']['output']>;
  lower_pump_override_gas_correction_percent?: Maybe<Scalars['Float']['output']>;
  lower_pump_wear_brake_horsepower_correction_ratio?: Maybe<Scalars['Float']['output']>;
  lower_pump_wear_head_correction_ratio?: Maybe<Scalars['Float']['output']>;
  maximum_frequency?: Maybe<Scalars['Float']['output']>;
  minimum_frequency?: Maybe<Scalars['Float']['output']>;
  motor_rerate_ratio?: Maybe<Scalars['Float']['output']>;
  motor_shroud_interior_diameter_inches?: Maybe<Scalars['Float']['output']>;
  natural_override_gas_separation_percent?: Maybe<Scalars['Float']['output']>;
  /** pump_hz is the only known column with exponential notation in legacy sizings AND by truncating pump_hz doesnt effect calculations. */
  pump_hz?: Maybe<Scalars['Float']['output']>;
  pump_override_gas_correction_percent?: Maybe<Scalars['Float']['output']>;
  pump_wear_brake_horsepower_correction_ratio?: Maybe<Scalars['Float']['output']>;
  pump_wear_head_correction_ratio?: Maybe<Scalars['Float']['output']>;
  surface_drive_incoming_power_volts?: Maybe<Scalars['Float']['output']>;
  target_liquid_rate_std_barrel_day?: Maybe<Scalars['Float']['output']>;
  vsd_input_voltage?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "revisions.scenario_parameters_revisions" */
export type Revisions_Scenario_Parameters_Revisions_Avg_Order_By = {
  bottom_casing_pressure_psia?: InputMaybe<Order_By>;
  bottom_tubing_pressure_psia?: InputMaybe<Order_By>;
  cable_cost_kw_hr_usd?: InputMaybe<Order_By>;
  elevation_feet_asl?: InputMaybe<Order_By>;
  intake_override_gas_separation_percent?: InputMaybe<Order_By>;
  lower_intake_override_gas_separation_percent?: InputMaybe<Order_By>;
  lower_motor_rerate_ratio?: InputMaybe<Order_By>;
  lower_motor_shroud_interior_diameter_inches?: InputMaybe<Order_By>;
  lower_natural_override_gas_separation_percent?: InputMaybe<Order_By>;
  lower_pump_hz?: InputMaybe<Order_By>;
  lower_pump_override_gas_correction_percent?: InputMaybe<Order_By>;
  lower_pump_wear_brake_horsepower_correction_ratio?: InputMaybe<Order_By>;
  lower_pump_wear_head_correction_ratio?: InputMaybe<Order_By>;
  maximum_frequency?: InputMaybe<Order_By>;
  minimum_frequency?: InputMaybe<Order_By>;
  motor_rerate_ratio?: InputMaybe<Order_By>;
  motor_shroud_interior_diameter_inches?: InputMaybe<Order_By>;
  natural_override_gas_separation_percent?: InputMaybe<Order_By>;
  /** pump_hz is the only known column with exponential notation in legacy sizings AND by truncating pump_hz doesnt effect calculations. */
  pump_hz?: InputMaybe<Order_By>;
  pump_override_gas_correction_percent?: InputMaybe<Order_By>;
  pump_wear_brake_horsepower_correction_ratio?: InputMaybe<Order_By>;
  pump_wear_head_correction_ratio?: InputMaybe<Order_By>;
  surface_drive_incoming_power_volts?: InputMaybe<Order_By>;
  target_liquid_rate_std_barrel_day?: InputMaybe<Order_By>;
  vsd_input_voltage?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "revisions.scenario_parameters_revisions". All fields are combined with a logical 'AND'. */
export type Revisions_Scenario_Parameters_Revisions_Bool_Exp = {
  _and?: InputMaybe<Array<Revisions_Scenario_Parameters_Revisions_Bool_Exp>>;
  _not?: InputMaybe<Revisions_Scenario_Parameters_Revisions_Bool_Exp>;
  _or?: InputMaybe<Array<Revisions_Scenario_Parameters_Revisions_Bool_Exp>>;
  author_id?: InputMaybe<String_Comparison_Exp>;
  bottom_casing_pressure_psia?: InputMaybe<Numeric_Comparison_Exp>;
  bottom_tubing_pressure_psia?: InputMaybe<Numeric_Comparison_Exp>;
  cable_cost_kw_hr_usd?: InputMaybe<Numeric_Comparison_Exp>;
  cloned_from_journal_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  elevation_feet_asl?: InputMaybe<Numeric_Comparison_Exp>;
  flowModelByFlowModel?: InputMaybe<Flow_Model_Bool_Exp>;
  flow_model?: InputMaybe<Flow_Model_Enum_Comparison_Exp>;
  has_compression_pump?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  include_casing_friction_loss?: InputMaybe<Boolean_Comparison_Exp>;
  intake_gas_separation_override_type?: InputMaybe<Override_Options_Enum_Comparison_Exp>;
  intake_override_gas_separation_percent?: InputMaybe<Numeric_Comparison_Exp>;
  intake_packer_installed?: InputMaybe<Boolean_Comparison_Exp>;
  journal_id?: InputMaybe<Uuid_Comparison_Exp>;
  lower_has_compression_pump?: InputMaybe<Boolean_Comparison_Exp>;
  lower_include_casing_friction_loss?: InputMaybe<Boolean_Comparison_Exp>;
  lower_intake_gas_separation_override_type?: InputMaybe<Override_Options_Enum_Comparison_Exp>;
  lower_intake_override_gas_separation_percent?: InputMaybe<Numeric_Comparison_Exp>;
  lower_intake_packer_installed?: InputMaybe<Boolean_Comparison_Exp>;
  lower_motor_rerate_ratio?: InputMaybe<Numeric_Comparison_Exp>;
  lower_motor_shroud_interior_diameter_inches?: InputMaybe<Numeric_Comparison_Exp>;
  lower_natural_gas_separation_override_type?: InputMaybe<Override_Options_Enum_Comparison_Exp>;
  lower_natural_override_gas_separation_percent?: InputMaybe<Numeric_Comparison_Exp>;
  lower_pump_hz?: InputMaybe<Numeric_Comparison_Exp>;
  lower_pump_override_gas_correction_percent?: InputMaybe<Numeric_Comparison_Exp>;
  lower_pump_wear_brake_horsepower_correction_ratio?: InputMaybe<Numeric_Comparison_Exp>;
  lower_pump_wear_head_correction_ratio?: InputMaybe<Numeric_Comparison_Exp>;
  lower_use_legacy_gas_head_rerate?: InputMaybe<Boolean_Comparison_Exp>;
  maximum_frequency?: InputMaybe<Numeric_Comparison_Exp>;
  minimum_frequency?: InputMaybe<Numeric_Comparison_Exp>;
  motor_rerate_ratio?: InputMaybe<Numeric_Comparison_Exp>;
  motor_shroud_interior_diameter_inches?: InputMaybe<Numeric_Comparison_Exp>;
  natural_gas_separation_override_type?: InputMaybe<Override_Options_Enum_Comparison_Exp>;
  natural_override_gas_separation_percent?: InputMaybe<Numeric_Comparison_Exp>;
  parent_revision_id?: InputMaybe<Uuid_Comparison_Exp>;
  pump_hz?: InputMaybe<Numeric_Comparison_Exp>;
  pump_override_gas_correction_percent?: InputMaybe<Numeric_Comparison_Exp>;
  pump_wear_brake_horsepower_correction_ratio?: InputMaybe<Numeric_Comparison_Exp>;
  pump_wear_head_correction_ratio?: InputMaybe<Numeric_Comparison_Exp>;
  scenario_parameters_journal?: InputMaybe<Revisions_Scenario_Parameters_Journal_Bool_Exp>;
  scenario_parameters_journals?: InputMaybe<Revisions_Scenario_Parameters_Journal_Bool_Exp>;
  scenario_parameters_journals_aggregate?: InputMaybe<Revisions_Scenario_Parameters_Journal_Aggregate_Bool_Exp>;
  scenario_parameters_revision?: InputMaybe<Revisions_Scenario_Parameters_Revisions_Bool_Exp>;
  scenario_parameters_revisions?: InputMaybe<Revisions_Scenario_Parameters_Revisions_Bool_Exp>;
  scenario_parameters_revisions_aggregate?: InputMaybe<Revisions_Scenario_Parameters_Revisions_Aggregate_Bool_Exp>;
  scenario_parameters_view?: InputMaybe<Scenario_Parameters_Bool_Exp>;
  surface_drive_incoming_power_volts?: InputMaybe<Numeric_Comparison_Exp>;
  target_liquid_rate_std_barrel_day?: InputMaybe<Numeric_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  use_legacy_gas_head_rerate?: InputMaybe<Boolean_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  vsd_input_voltage?: InputMaybe<Numeric_Comparison_Exp>;
};

/** unique or primary key constraints on table "revisions.scenario_parameters_revisions" */
export enum Revisions_Scenario_Parameters_Revisions_Constraint {
  /** unique or primary key constraint on columns "id" */
  ScenarioParametersRevisionsPkey = 'scenario_parameters_revisions_pkey'
}

/** input type for incrementing numeric columns in table "revisions.scenario_parameters_revisions" */
export type Revisions_Scenario_Parameters_Revisions_Inc_Input = {
  bottom_casing_pressure_psia?: InputMaybe<Scalars['numeric']['input']>;
  bottom_tubing_pressure_psia?: InputMaybe<Scalars['numeric']['input']>;
  cable_cost_kw_hr_usd?: InputMaybe<Scalars['numeric']['input']>;
  elevation_feet_asl?: InputMaybe<Scalars['numeric']['input']>;
  intake_override_gas_separation_percent?: InputMaybe<Scalars['numeric']['input']>;
  lower_intake_override_gas_separation_percent?: InputMaybe<Scalars['numeric']['input']>;
  lower_motor_rerate_ratio?: InputMaybe<Scalars['numeric']['input']>;
  lower_motor_shroud_interior_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  lower_natural_override_gas_separation_percent?: InputMaybe<Scalars['numeric']['input']>;
  lower_pump_hz?: InputMaybe<Scalars['numeric']['input']>;
  lower_pump_override_gas_correction_percent?: InputMaybe<Scalars['numeric']['input']>;
  lower_pump_wear_brake_horsepower_correction_ratio?: InputMaybe<Scalars['numeric']['input']>;
  lower_pump_wear_head_correction_ratio?: InputMaybe<Scalars['numeric']['input']>;
  maximum_frequency?: InputMaybe<Scalars['numeric']['input']>;
  minimum_frequency?: InputMaybe<Scalars['numeric']['input']>;
  motor_rerate_ratio?: InputMaybe<Scalars['numeric']['input']>;
  motor_shroud_interior_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  natural_override_gas_separation_percent?: InputMaybe<Scalars['numeric']['input']>;
  /** pump_hz is the only known column with exponential notation in legacy sizings AND by truncating pump_hz doesnt effect calculations. */
  pump_hz?: InputMaybe<Scalars['numeric']['input']>;
  pump_override_gas_correction_percent?: InputMaybe<Scalars['numeric']['input']>;
  pump_wear_brake_horsepower_correction_ratio?: InputMaybe<Scalars['numeric']['input']>;
  pump_wear_head_correction_ratio?: InputMaybe<Scalars['numeric']['input']>;
  surface_drive_incoming_power_volts?: InputMaybe<Scalars['numeric']['input']>;
  target_liquid_rate_std_barrel_day?: InputMaybe<Scalars['numeric']['input']>;
  vsd_input_voltage?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "revisions.scenario_parameters_revisions" */
export type Revisions_Scenario_Parameters_Revisions_Insert_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  bottom_casing_pressure_psia?: InputMaybe<Scalars['numeric']['input']>;
  bottom_tubing_pressure_psia?: InputMaybe<Scalars['numeric']['input']>;
  cable_cost_kw_hr_usd?: InputMaybe<Scalars['numeric']['input']>;
  cloned_from_journal_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  elevation_feet_asl?: InputMaybe<Scalars['numeric']['input']>;
  flowModelByFlowModel?: InputMaybe<Flow_Model_Obj_Rel_Insert_Input>;
  flow_model?: InputMaybe<Flow_Model_Enum>;
  has_compression_pump?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  /** As fluid flows around the motor of the pump the friction of the fluid causes the pressure to drop. This drop in pressure may already be included in the well test inputs so this calculation must be optionally included. */
  include_casing_friction_loss?: InputMaybe<Scalars['Boolean']['input']>;
  intake_gas_separation_override_type?: InputMaybe<Override_Options_Enum>;
  intake_override_gas_separation_percent?: InputMaybe<Scalars['numeric']['input']>;
  intake_packer_installed?: InputMaybe<Scalars['Boolean']['input']>;
  journal_id?: InputMaybe<Scalars['uuid']['input']>;
  lower_has_compression_pump?: InputMaybe<Scalars['Boolean']['input']>;
  lower_include_casing_friction_loss?: InputMaybe<Scalars['Boolean']['input']>;
  lower_intake_gas_separation_override_type?: InputMaybe<Override_Options_Enum>;
  lower_intake_override_gas_separation_percent?: InputMaybe<Scalars['numeric']['input']>;
  lower_intake_packer_installed?: InputMaybe<Scalars['Boolean']['input']>;
  lower_motor_rerate_ratio?: InputMaybe<Scalars['numeric']['input']>;
  lower_motor_shroud_interior_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  lower_natural_gas_separation_override_type?: InputMaybe<Override_Options_Enum>;
  lower_natural_override_gas_separation_percent?: InputMaybe<Scalars['numeric']['input']>;
  lower_pump_hz?: InputMaybe<Scalars['numeric']['input']>;
  lower_pump_override_gas_correction_percent?: InputMaybe<Scalars['numeric']['input']>;
  lower_pump_wear_brake_horsepower_correction_ratio?: InputMaybe<Scalars['numeric']['input']>;
  lower_pump_wear_head_correction_ratio?: InputMaybe<Scalars['numeric']['input']>;
  lower_use_legacy_gas_head_rerate?: InputMaybe<Scalars['Boolean']['input']>;
  maximum_frequency?: InputMaybe<Scalars['numeric']['input']>;
  minimum_frequency?: InputMaybe<Scalars['numeric']['input']>;
  motor_rerate_ratio?: InputMaybe<Scalars['numeric']['input']>;
  motor_shroud_interior_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  natural_gas_separation_override_type?: InputMaybe<Override_Options_Enum>;
  natural_override_gas_separation_percent?: InputMaybe<Scalars['numeric']['input']>;
  parent_revision_id?: InputMaybe<Scalars['uuid']['input']>;
  /** pump_hz is the only known column with exponential notation in legacy sizings AND by truncating pump_hz doesnt effect calculations. */
  pump_hz?: InputMaybe<Scalars['numeric']['input']>;
  pump_override_gas_correction_percent?: InputMaybe<Scalars['numeric']['input']>;
  pump_wear_brake_horsepower_correction_ratio?: InputMaybe<Scalars['numeric']['input']>;
  pump_wear_head_correction_ratio?: InputMaybe<Scalars['numeric']['input']>;
  scenario_parameters_journal?: InputMaybe<Revisions_Scenario_Parameters_Journal_Obj_Rel_Insert_Input>;
  scenario_parameters_journals?: InputMaybe<Revisions_Scenario_Parameters_Journal_Arr_Rel_Insert_Input>;
  scenario_parameters_revision?: InputMaybe<Revisions_Scenario_Parameters_Revisions_Obj_Rel_Insert_Input>;
  scenario_parameters_revisions?: InputMaybe<Revisions_Scenario_Parameters_Revisions_Arr_Rel_Insert_Input>;
  scenario_parameters_view?: InputMaybe<Scenario_Parameters_Obj_Rel_Insert_Input>;
  surface_drive_incoming_power_volts?: InputMaybe<Scalars['numeric']['input']>;
  target_liquid_rate_std_barrel_day?: InputMaybe<Scalars['numeric']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  /** Due to updates to the calculations, some users want to use the formula from Reaver 2.0. This boolean field will persist the user selection to use legacy calcs */
  use_legacy_gas_head_rerate?: InputMaybe<Scalars['Boolean']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  vsd_input_voltage?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate max on columns */
export type Revisions_Scenario_Parameters_Revisions_Max_Fields = {
  __typename: 'revisions_scenario_parameters_revisions_max_fields';
  author_id?: Maybe<Scalars['String']['output']>;
  bottom_casing_pressure_psia?: Maybe<Scalars['numeric']['output']>;
  bottom_tubing_pressure_psia?: Maybe<Scalars['numeric']['output']>;
  cable_cost_kw_hr_usd?: Maybe<Scalars['numeric']['output']>;
  cloned_from_journal_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  elevation_feet_asl?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  intake_override_gas_separation_percent?: Maybe<Scalars['numeric']['output']>;
  journal_id?: Maybe<Scalars['uuid']['output']>;
  lower_intake_override_gas_separation_percent?: Maybe<Scalars['numeric']['output']>;
  lower_motor_rerate_ratio?: Maybe<Scalars['numeric']['output']>;
  lower_motor_shroud_interior_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  lower_natural_override_gas_separation_percent?: Maybe<Scalars['numeric']['output']>;
  lower_pump_hz?: Maybe<Scalars['numeric']['output']>;
  lower_pump_override_gas_correction_percent?: Maybe<Scalars['numeric']['output']>;
  lower_pump_wear_brake_horsepower_correction_ratio?: Maybe<Scalars['numeric']['output']>;
  lower_pump_wear_head_correction_ratio?: Maybe<Scalars['numeric']['output']>;
  maximum_frequency?: Maybe<Scalars['numeric']['output']>;
  minimum_frequency?: Maybe<Scalars['numeric']['output']>;
  motor_rerate_ratio?: Maybe<Scalars['numeric']['output']>;
  motor_shroud_interior_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  natural_override_gas_separation_percent?: Maybe<Scalars['numeric']['output']>;
  parent_revision_id?: Maybe<Scalars['uuid']['output']>;
  /** pump_hz is the only known column with exponential notation in legacy sizings AND by truncating pump_hz doesnt effect calculations. */
  pump_hz?: Maybe<Scalars['numeric']['output']>;
  pump_override_gas_correction_percent?: Maybe<Scalars['numeric']['output']>;
  pump_wear_brake_horsepower_correction_ratio?: Maybe<Scalars['numeric']['output']>;
  pump_wear_head_correction_ratio?: Maybe<Scalars['numeric']['output']>;
  surface_drive_incoming_power_volts?: Maybe<Scalars['numeric']['output']>;
  target_liquid_rate_std_barrel_day?: Maybe<Scalars['numeric']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  vsd_input_voltage?: Maybe<Scalars['numeric']['output']>;
};

/** order by max() on columns of table "revisions.scenario_parameters_revisions" */
export type Revisions_Scenario_Parameters_Revisions_Max_Order_By = {
  author_id?: InputMaybe<Order_By>;
  bottom_casing_pressure_psia?: InputMaybe<Order_By>;
  bottom_tubing_pressure_psia?: InputMaybe<Order_By>;
  cable_cost_kw_hr_usd?: InputMaybe<Order_By>;
  cloned_from_journal_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  elevation_feet_asl?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  intake_override_gas_separation_percent?: InputMaybe<Order_By>;
  journal_id?: InputMaybe<Order_By>;
  lower_intake_override_gas_separation_percent?: InputMaybe<Order_By>;
  lower_motor_rerate_ratio?: InputMaybe<Order_By>;
  lower_motor_shroud_interior_diameter_inches?: InputMaybe<Order_By>;
  lower_natural_override_gas_separation_percent?: InputMaybe<Order_By>;
  lower_pump_hz?: InputMaybe<Order_By>;
  lower_pump_override_gas_correction_percent?: InputMaybe<Order_By>;
  lower_pump_wear_brake_horsepower_correction_ratio?: InputMaybe<Order_By>;
  lower_pump_wear_head_correction_ratio?: InputMaybe<Order_By>;
  maximum_frequency?: InputMaybe<Order_By>;
  minimum_frequency?: InputMaybe<Order_By>;
  motor_rerate_ratio?: InputMaybe<Order_By>;
  motor_shroud_interior_diameter_inches?: InputMaybe<Order_By>;
  natural_override_gas_separation_percent?: InputMaybe<Order_By>;
  parent_revision_id?: InputMaybe<Order_By>;
  /** pump_hz is the only known column with exponential notation in legacy sizings AND by truncating pump_hz doesnt effect calculations. */
  pump_hz?: InputMaybe<Order_By>;
  pump_override_gas_correction_percent?: InputMaybe<Order_By>;
  pump_wear_brake_horsepower_correction_ratio?: InputMaybe<Order_By>;
  pump_wear_head_correction_ratio?: InputMaybe<Order_By>;
  surface_drive_incoming_power_volts?: InputMaybe<Order_By>;
  target_liquid_rate_std_barrel_day?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  vsd_input_voltage?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Revisions_Scenario_Parameters_Revisions_Min_Fields = {
  __typename: 'revisions_scenario_parameters_revisions_min_fields';
  author_id?: Maybe<Scalars['String']['output']>;
  bottom_casing_pressure_psia?: Maybe<Scalars['numeric']['output']>;
  bottom_tubing_pressure_psia?: Maybe<Scalars['numeric']['output']>;
  cable_cost_kw_hr_usd?: Maybe<Scalars['numeric']['output']>;
  cloned_from_journal_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  elevation_feet_asl?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  intake_override_gas_separation_percent?: Maybe<Scalars['numeric']['output']>;
  journal_id?: Maybe<Scalars['uuid']['output']>;
  lower_intake_override_gas_separation_percent?: Maybe<Scalars['numeric']['output']>;
  lower_motor_rerate_ratio?: Maybe<Scalars['numeric']['output']>;
  lower_motor_shroud_interior_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  lower_natural_override_gas_separation_percent?: Maybe<Scalars['numeric']['output']>;
  lower_pump_hz?: Maybe<Scalars['numeric']['output']>;
  lower_pump_override_gas_correction_percent?: Maybe<Scalars['numeric']['output']>;
  lower_pump_wear_brake_horsepower_correction_ratio?: Maybe<Scalars['numeric']['output']>;
  lower_pump_wear_head_correction_ratio?: Maybe<Scalars['numeric']['output']>;
  maximum_frequency?: Maybe<Scalars['numeric']['output']>;
  minimum_frequency?: Maybe<Scalars['numeric']['output']>;
  motor_rerate_ratio?: Maybe<Scalars['numeric']['output']>;
  motor_shroud_interior_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  natural_override_gas_separation_percent?: Maybe<Scalars['numeric']['output']>;
  parent_revision_id?: Maybe<Scalars['uuid']['output']>;
  /** pump_hz is the only known column with exponential notation in legacy sizings AND by truncating pump_hz doesnt effect calculations. */
  pump_hz?: Maybe<Scalars['numeric']['output']>;
  pump_override_gas_correction_percent?: Maybe<Scalars['numeric']['output']>;
  pump_wear_brake_horsepower_correction_ratio?: Maybe<Scalars['numeric']['output']>;
  pump_wear_head_correction_ratio?: Maybe<Scalars['numeric']['output']>;
  surface_drive_incoming_power_volts?: Maybe<Scalars['numeric']['output']>;
  target_liquid_rate_std_barrel_day?: Maybe<Scalars['numeric']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  vsd_input_voltage?: Maybe<Scalars['numeric']['output']>;
};

/** order by min() on columns of table "revisions.scenario_parameters_revisions" */
export type Revisions_Scenario_Parameters_Revisions_Min_Order_By = {
  author_id?: InputMaybe<Order_By>;
  bottom_casing_pressure_psia?: InputMaybe<Order_By>;
  bottom_tubing_pressure_psia?: InputMaybe<Order_By>;
  cable_cost_kw_hr_usd?: InputMaybe<Order_By>;
  cloned_from_journal_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  elevation_feet_asl?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  intake_override_gas_separation_percent?: InputMaybe<Order_By>;
  journal_id?: InputMaybe<Order_By>;
  lower_intake_override_gas_separation_percent?: InputMaybe<Order_By>;
  lower_motor_rerate_ratio?: InputMaybe<Order_By>;
  lower_motor_shroud_interior_diameter_inches?: InputMaybe<Order_By>;
  lower_natural_override_gas_separation_percent?: InputMaybe<Order_By>;
  lower_pump_hz?: InputMaybe<Order_By>;
  lower_pump_override_gas_correction_percent?: InputMaybe<Order_By>;
  lower_pump_wear_brake_horsepower_correction_ratio?: InputMaybe<Order_By>;
  lower_pump_wear_head_correction_ratio?: InputMaybe<Order_By>;
  maximum_frequency?: InputMaybe<Order_By>;
  minimum_frequency?: InputMaybe<Order_By>;
  motor_rerate_ratio?: InputMaybe<Order_By>;
  motor_shroud_interior_diameter_inches?: InputMaybe<Order_By>;
  natural_override_gas_separation_percent?: InputMaybe<Order_By>;
  parent_revision_id?: InputMaybe<Order_By>;
  /** pump_hz is the only known column with exponential notation in legacy sizings AND by truncating pump_hz doesnt effect calculations. */
  pump_hz?: InputMaybe<Order_By>;
  pump_override_gas_correction_percent?: InputMaybe<Order_By>;
  pump_wear_brake_horsepower_correction_ratio?: InputMaybe<Order_By>;
  pump_wear_head_correction_ratio?: InputMaybe<Order_By>;
  surface_drive_incoming_power_volts?: InputMaybe<Order_By>;
  target_liquid_rate_std_barrel_day?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  vsd_input_voltage?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "revisions.scenario_parameters_revisions" */
export type Revisions_Scenario_Parameters_Revisions_Mutation_Response = {
  __typename: 'revisions_scenario_parameters_revisions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Revisions_Scenario_Parameters_Revisions>;
};

/** input type for inserting object relation for remote table "revisions.scenario_parameters_revisions" */
export type Revisions_Scenario_Parameters_Revisions_Obj_Rel_Insert_Input = {
  data: Revisions_Scenario_Parameters_Revisions_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Revisions_Scenario_Parameters_Revisions_On_Conflict>;
};

/** on_conflict condition type for table "revisions.scenario_parameters_revisions" */
export type Revisions_Scenario_Parameters_Revisions_On_Conflict = {
  constraint: Revisions_Scenario_Parameters_Revisions_Constraint;
  update_columns?: Array<Revisions_Scenario_Parameters_Revisions_Update_Column>;
  where?: InputMaybe<Revisions_Scenario_Parameters_Revisions_Bool_Exp>;
};

/** Ordering options when selecting data from "revisions.scenario_parameters_revisions". */
export type Revisions_Scenario_Parameters_Revisions_Order_By = {
  author_id?: InputMaybe<Order_By>;
  bottom_casing_pressure_psia?: InputMaybe<Order_By>;
  bottom_tubing_pressure_psia?: InputMaybe<Order_By>;
  cable_cost_kw_hr_usd?: InputMaybe<Order_By>;
  cloned_from_journal_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  elevation_feet_asl?: InputMaybe<Order_By>;
  flowModelByFlowModel?: InputMaybe<Flow_Model_Order_By>;
  flow_model?: InputMaybe<Order_By>;
  has_compression_pump?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  include_casing_friction_loss?: InputMaybe<Order_By>;
  intake_gas_separation_override_type?: InputMaybe<Order_By>;
  intake_override_gas_separation_percent?: InputMaybe<Order_By>;
  intake_packer_installed?: InputMaybe<Order_By>;
  journal_id?: InputMaybe<Order_By>;
  lower_has_compression_pump?: InputMaybe<Order_By>;
  lower_include_casing_friction_loss?: InputMaybe<Order_By>;
  lower_intake_gas_separation_override_type?: InputMaybe<Order_By>;
  lower_intake_override_gas_separation_percent?: InputMaybe<Order_By>;
  lower_intake_packer_installed?: InputMaybe<Order_By>;
  lower_motor_rerate_ratio?: InputMaybe<Order_By>;
  lower_motor_shroud_interior_diameter_inches?: InputMaybe<Order_By>;
  lower_natural_gas_separation_override_type?: InputMaybe<Order_By>;
  lower_natural_override_gas_separation_percent?: InputMaybe<Order_By>;
  lower_pump_hz?: InputMaybe<Order_By>;
  lower_pump_override_gas_correction_percent?: InputMaybe<Order_By>;
  lower_pump_wear_brake_horsepower_correction_ratio?: InputMaybe<Order_By>;
  lower_pump_wear_head_correction_ratio?: InputMaybe<Order_By>;
  lower_use_legacy_gas_head_rerate?: InputMaybe<Order_By>;
  maximum_frequency?: InputMaybe<Order_By>;
  minimum_frequency?: InputMaybe<Order_By>;
  motor_rerate_ratio?: InputMaybe<Order_By>;
  motor_shroud_interior_diameter_inches?: InputMaybe<Order_By>;
  natural_gas_separation_override_type?: InputMaybe<Order_By>;
  natural_override_gas_separation_percent?: InputMaybe<Order_By>;
  parent_revision_id?: InputMaybe<Order_By>;
  pump_hz?: InputMaybe<Order_By>;
  pump_override_gas_correction_percent?: InputMaybe<Order_By>;
  pump_wear_brake_horsepower_correction_ratio?: InputMaybe<Order_By>;
  pump_wear_head_correction_ratio?: InputMaybe<Order_By>;
  scenario_parameters_journal?: InputMaybe<Revisions_Scenario_Parameters_Journal_Order_By>;
  scenario_parameters_journals_aggregate?: InputMaybe<Revisions_Scenario_Parameters_Journal_Aggregate_Order_By>;
  scenario_parameters_revision?: InputMaybe<Revisions_Scenario_Parameters_Revisions_Order_By>;
  scenario_parameters_revisions_aggregate?: InputMaybe<Revisions_Scenario_Parameters_Revisions_Aggregate_Order_By>;
  scenario_parameters_view?: InputMaybe<Scenario_Parameters_Order_By>;
  surface_drive_incoming_power_volts?: InputMaybe<Order_By>;
  target_liquid_rate_std_barrel_day?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  use_legacy_gas_head_rerate?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  vsd_input_voltage?: InputMaybe<Order_By>;
};

/** primary key columns input for table: revisions.scenario_parameters_revisions */
export type Revisions_Scenario_Parameters_Revisions_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "revisions.scenario_parameters_revisions" */
export enum Revisions_Scenario_Parameters_Revisions_Select_Column {
  /** column name */
  AuthorId = 'author_id',
  /** column name */
  BottomCasingPressurePsia = 'bottom_casing_pressure_psia',
  /** column name */
  BottomTubingPressurePsia = 'bottom_tubing_pressure_psia',
  /** column name */
  CableCostKwHrUsd = 'cable_cost_kw_hr_usd',
  /** column name */
  ClonedFromJournalId = 'cloned_from_journal_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  ElevationFeetAsl = 'elevation_feet_asl',
  /** column name */
  FlowModel = 'flow_model',
  /** column name */
  HasCompressionPump = 'has_compression_pump',
  /** column name */
  Id = 'id',
  /** column name */
  IncludeCasingFrictionLoss = 'include_casing_friction_loss',
  /** column name */
  IntakeGasSeparationOverrideType = 'intake_gas_separation_override_type',
  /** column name */
  IntakeOverrideGasSeparationPercent = 'intake_override_gas_separation_percent',
  /** column name */
  IntakePackerInstalled = 'intake_packer_installed',
  /** column name */
  JournalId = 'journal_id',
  /** column name */
  LowerHasCompressionPump = 'lower_has_compression_pump',
  /** column name */
  LowerIncludeCasingFrictionLoss = 'lower_include_casing_friction_loss',
  /** column name */
  LowerIntakeGasSeparationOverrideType = 'lower_intake_gas_separation_override_type',
  /** column name */
  LowerIntakeOverrideGasSeparationPercent = 'lower_intake_override_gas_separation_percent',
  /** column name */
  LowerIntakePackerInstalled = 'lower_intake_packer_installed',
  /** column name */
  LowerMotorRerateRatio = 'lower_motor_rerate_ratio',
  /** column name */
  LowerMotorShroudInteriorDiameterInches = 'lower_motor_shroud_interior_diameter_inches',
  /** column name */
  LowerNaturalGasSeparationOverrideType = 'lower_natural_gas_separation_override_type',
  /** column name */
  LowerNaturalOverrideGasSeparationPercent = 'lower_natural_override_gas_separation_percent',
  /** column name */
  LowerPumpHz = 'lower_pump_hz',
  /** column name */
  LowerPumpOverrideGasCorrectionPercent = 'lower_pump_override_gas_correction_percent',
  /** column name */
  LowerPumpWearBrakeHorsepowerCorrectionRatio = 'lower_pump_wear_brake_horsepower_correction_ratio',
  /** column name */
  LowerPumpWearHeadCorrectionRatio = 'lower_pump_wear_head_correction_ratio',
  /** column name */
  LowerUseLegacyGasHeadRerate = 'lower_use_legacy_gas_head_rerate',
  /** column name */
  MaximumFrequency = 'maximum_frequency',
  /** column name */
  MinimumFrequency = 'minimum_frequency',
  /** column name */
  MotorRerateRatio = 'motor_rerate_ratio',
  /** column name */
  MotorShroudInteriorDiameterInches = 'motor_shroud_interior_diameter_inches',
  /** column name */
  NaturalGasSeparationOverrideType = 'natural_gas_separation_override_type',
  /** column name */
  NaturalOverrideGasSeparationPercent = 'natural_override_gas_separation_percent',
  /** column name */
  ParentRevisionId = 'parent_revision_id',
  /** column name */
  PumpHz = 'pump_hz',
  /** column name */
  PumpOverrideGasCorrectionPercent = 'pump_override_gas_correction_percent',
  /** column name */
  PumpWearBrakeHorsepowerCorrectionRatio = 'pump_wear_brake_horsepower_correction_ratio',
  /** column name */
  PumpWearHeadCorrectionRatio = 'pump_wear_head_correction_ratio',
  /** column name */
  SurfaceDriveIncomingPowerVolts = 'surface_drive_incoming_power_volts',
  /** column name */
  TargetLiquidRateStdBarrelDay = 'target_liquid_rate_std_barrel_day',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UseLegacyGasHeadRerate = 'use_legacy_gas_head_rerate',
  /** column name */
  VsdInputVoltage = 'vsd_input_voltage'
}

/** select "revisions_scenario_parameters_revisions_aggregate_bool_exp_bool_and_arguments_columns" columns of table "revisions.scenario_parameters_revisions" */
export enum Revisions_Scenario_Parameters_Revisions_Select_Column_Revisions_Scenario_Parameters_Revisions_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  HasCompressionPump = 'has_compression_pump',
  /** column name */
  IncludeCasingFrictionLoss = 'include_casing_friction_loss',
  /** column name */
  IntakePackerInstalled = 'intake_packer_installed',
  /** column name */
  LowerHasCompressionPump = 'lower_has_compression_pump',
  /** column name */
  LowerIncludeCasingFrictionLoss = 'lower_include_casing_friction_loss',
  /** column name */
  LowerIntakePackerInstalled = 'lower_intake_packer_installed',
  /** column name */
  LowerUseLegacyGasHeadRerate = 'lower_use_legacy_gas_head_rerate',
  /** column name */
  UseLegacyGasHeadRerate = 'use_legacy_gas_head_rerate'
}

/** select "revisions_scenario_parameters_revisions_aggregate_bool_exp_bool_or_arguments_columns" columns of table "revisions.scenario_parameters_revisions" */
export enum Revisions_Scenario_Parameters_Revisions_Select_Column_Revisions_Scenario_Parameters_Revisions_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  HasCompressionPump = 'has_compression_pump',
  /** column name */
  IncludeCasingFrictionLoss = 'include_casing_friction_loss',
  /** column name */
  IntakePackerInstalled = 'intake_packer_installed',
  /** column name */
  LowerHasCompressionPump = 'lower_has_compression_pump',
  /** column name */
  LowerIncludeCasingFrictionLoss = 'lower_include_casing_friction_loss',
  /** column name */
  LowerIntakePackerInstalled = 'lower_intake_packer_installed',
  /** column name */
  LowerUseLegacyGasHeadRerate = 'lower_use_legacy_gas_head_rerate',
  /** column name */
  UseLegacyGasHeadRerate = 'use_legacy_gas_head_rerate'
}

/** input type for updating data in table "revisions.scenario_parameters_revisions" */
export type Revisions_Scenario_Parameters_Revisions_Set_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  bottom_casing_pressure_psia?: InputMaybe<Scalars['numeric']['input']>;
  bottom_tubing_pressure_psia?: InputMaybe<Scalars['numeric']['input']>;
  cable_cost_kw_hr_usd?: InputMaybe<Scalars['numeric']['input']>;
  cloned_from_journal_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  elevation_feet_asl?: InputMaybe<Scalars['numeric']['input']>;
  flow_model?: InputMaybe<Flow_Model_Enum>;
  has_compression_pump?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  /** As fluid flows around the motor of the pump the friction of the fluid causes the pressure to drop. This drop in pressure may already be included in the well test inputs so this calculation must be optionally included. */
  include_casing_friction_loss?: InputMaybe<Scalars['Boolean']['input']>;
  intake_gas_separation_override_type?: InputMaybe<Override_Options_Enum>;
  intake_override_gas_separation_percent?: InputMaybe<Scalars['numeric']['input']>;
  intake_packer_installed?: InputMaybe<Scalars['Boolean']['input']>;
  journal_id?: InputMaybe<Scalars['uuid']['input']>;
  lower_has_compression_pump?: InputMaybe<Scalars['Boolean']['input']>;
  lower_include_casing_friction_loss?: InputMaybe<Scalars['Boolean']['input']>;
  lower_intake_gas_separation_override_type?: InputMaybe<Override_Options_Enum>;
  lower_intake_override_gas_separation_percent?: InputMaybe<Scalars['numeric']['input']>;
  lower_intake_packer_installed?: InputMaybe<Scalars['Boolean']['input']>;
  lower_motor_rerate_ratio?: InputMaybe<Scalars['numeric']['input']>;
  lower_motor_shroud_interior_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  lower_natural_gas_separation_override_type?: InputMaybe<Override_Options_Enum>;
  lower_natural_override_gas_separation_percent?: InputMaybe<Scalars['numeric']['input']>;
  lower_pump_hz?: InputMaybe<Scalars['numeric']['input']>;
  lower_pump_override_gas_correction_percent?: InputMaybe<Scalars['numeric']['input']>;
  lower_pump_wear_brake_horsepower_correction_ratio?: InputMaybe<Scalars['numeric']['input']>;
  lower_pump_wear_head_correction_ratio?: InputMaybe<Scalars['numeric']['input']>;
  lower_use_legacy_gas_head_rerate?: InputMaybe<Scalars['Boolean']['input']>;
  maximum_frequency?: InputMaybe<Scalars['numeric']['input']>;
  minimum_frequency?: InputMaybe<Scalars['numeric']['input']>;
  motor_rerate_ratio?: InputMaybe<Scalars['numeric']['input']>;
  motor_shroud_interior_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  natural_gas_separation_override_type?: InputMaybe<Override_Options_Enum>;
  natural_override_gas_separation_percent?: InputMaybe<Scalars['numeric']['input']>;
  parent_revision_id?: InputMaybe<Scalars['uuid']['input']>;
  /** pump_hz is the only known column with exponential notation in legacy sizings AND by truncating pump_hz doesnt effect calculations. */
  pump_hz?: InputMaybe<Scalars['numeric']['input']>;
  pump_override_gas_correction_percent?: InputMaybe<Scalars['numeric']['input']>;
  pump_wear_brake_horsepower_correction_ratio?: InputMaybe<Scalars['numeric']['input']>;
  pump_wear_head_correction_ratio?: InputMaybe<Scalars['numeric']['input']>;
  surface_drive_incoming_power_volts?: InputMaybe<Scalars['numeric']['input']>;
  target_liquid_rate_std_barrel_day?: InputMaybe<Scalars['numeric']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  /** Due to updates to the calculations, some users want to use the formula from Reaver 2.0. This boolean field will persist the user selection to use legacy calcs */
  use_legacy_gas_head_rerate?: InputMaybe<Scalars['Boolean']['input']>;
  vsd_input_voltage?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate stddev on columns */
export type Revisions_Scenario_Parameters_Revisions_Stddev_Fields = {
  __typename: 'revisions_scenario_parameters_revisions_stddev_fields';
  bottom_casing_pressure_psia?: Maybe<Scalars['Float']['output']>;
  bottom_tubing_pressure_psia?: Maybe<Scalars['Float']['output']>;
  cable_cost_kw_hr_usd?: Maybe<Scalars['Float']['output']>;
  elevation_feet_asl?: Maybe<Scalars['Float']['output']>;
  intake_override_gas_separation_percent?: Maybe<Scalars['Float']['output']>;
  lower_intake_override_gas_separation_percent?: Maybe<Scalars['Float']['output']>;
  lower_motor_rerate_ratio?: Maybe<Scalars['Float']['output']>;
  lower_motor_shroud_interior_diameter_inches?: Maybe<Scalars['Float']['output']>;
  lower_natural_override_gas_separation_percent?: Maybe<Scalars['Float']['output']>;
  lower_pump_hz?: Maybe<Scalars['Float']['output']>;
  lower_pump_override_gas_correction_percent?: Maybe<Scalars['Float']['output']>;
  lower_pump_wear_brake_horsepower_correction_ratio?: Maybe<Scalars['Float']['output']>;
  lower_pump_wear_head_correction_ratio?: Maybe<Scalars['Float']['output']>;
  maximum_frequency?: Maybe<Scalars['Float']['output']>;
  minimum_frequency?: Maybe<Scalars['Float']['output']>;
  motor_rerate_ratio?: Maybe<Scalars['Float']['output']>;
  motor_shroud_interior_diameter_inches?: Maybe<Scalars['Float']['output']>;
  natural_override_gas_separation_percent?: Maybe<Scalars['Float']['output']>;
  /** pump_hz is the only known column with exponential notation in legacy sizings AND by truncating pump_hz doesnt effect calculations. */
  pump_hz?: Maybe<Scalars['Float']['output']>;
  pump_override_gas_correction_percent?: Maybe<Scalars['Float']['output']>;
  pump_wear_brake_horsepower_correction_ratio?: Maybe<Scalars['Float']['output']>;
  pump_wear_head_correction_ratio?: Maybe<Scalars['Float']['output']>;
  surface_drive_incoming_power_volts?: Maybe<Scalars['Float']['output']>;
  target_liquid_rate_std_barrel_day?: Maybe<Scalars['Float']['output']>;
  vsd_input_voltage?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "revisions.scenario_parameters_revisions" */
export type Revisions_Scenario_Parameters_Revisions_Stddev_Order_By = {
  bottom_casing_pressure_psia?: InputMaybe<Order_By>;
  bottom_tubing_pressure_psia?: InputMaybe<Order_By>;
  cable_cost_kw_hr_usd?: InputMaybe<Order_By>;
  elevation_feet_asl?: InputMaybe<Order_By>;
  intake_override_gas_separation_percent?: InputMaybe<Order_By>;
  lower_intake_override_gas_separation_percent?: InputMaybe<Order_By>;
  lower_motor_rerate_ratio?: InputMaybe<Order_By>;
  lower_motor_shroud_interior_diameter_inches?: InputMaybe<Order_By>;
  lower_natural_override_gas_separation_percent?: InputMaybe<Order_By>;
  lower_pump_hz?: InputMaybe<Order_By>;
  lower_pump_override_gas_correction_percent?: InputMaybe<Order_By>;
  lower_pump_wear_brake_horsepower_correction_ratio?: InputMaybe<Order_By>;
  lower_pump_wear_head_correction_ratio?: InputMaybe<Order_By>;
  maximum_frequency?: InputMaybe<Order_By>;
  minimum_frequency?: InputMaybe<Order_By>;
  motor_rerate_ratio?: InputMaybe<Order_By>;
  motor_shroud_interior_diameter_inches?: InputMaybe<Order_By>;
  natural_override_gas_separation_percent?: InputMaybe<Order_By>;
  /** pump_hz is the only known column with exponential notation in legacy sizings AND by truncating pump_hz doesnt effect calculations. */
  pump_hz?: InputMaybe<Order_By>;
  pump_override_gas_correction_percent?: InputMaybe<Order_By>;
  pump_wear_brake_horsepower_correction_ratio?: InputMaybe<Order_By>;
  pump_wear_head_correction_ratio?: InputMaybe<Order_By>;
  surface_drive_incoming_power_volts?: InputMaybe<Order_By>;
  target_liquid_rate_std_barrel_day?: InputMaybe<Order_By>;
  vsd_input_voltage?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Revisions_Scenario_Parameters_Revisions_Stddev_Pop_Fields = {
  __typename: 'revisions_scenario_parameters_revisions_stddev_pop_fields';
  bottom_casing_pressure_psia?: Maybe<Scalars['Float']['output']>;
  bottom_tubing_pressure_psia?: Maybe<Scalars['Float']['output']>;
  cable_cost_kw_hr_usd?: Maybe<Scalars['Float']['output']>;
  elevation_feet_asl?: Maybe<Scalars['Float']['output']>;
  intake_override_gas_separation_percent?: Maybe<Scalars['Float']['output']>;
  lower_intake_override_gas_separation_percent?: Maybe<Scalars['Float']['output']>;
  lower_motor_rerate_ratio?: Maybe<Scalars['Float']['output']>;
  lower_motor_shroud_interior_diameter_inches?: Maybe<Scalars['Float']['output']>;
  lower_natural_override_gas_separation_percent?: Maybe<Scalars['Float']['output']>;
  lower_pump_hz?: Maybe<Scalars['Float']['output']>;
  lower_pump_override_gas_correction_percent?: Maybe<Scalars['Float']['output']>;
  lower_pump_wear_brake_horsepower_correction_ratio?: Maybe<Scalars['Float']['output']>;
  lower_pump_wear_head_correction_ratio?: Maybe<Scalars['Float']['output']>;
  maximum_frequency?: Maybe<Scalars['Float']['output']>;
  minimum_frequency?: Maybe<Scalars['Float']['output']>;
  motor_rerate_ratio?: Maybe<Scalars['Float']['output']>;
  motor_shroud_interior_diameter_inches?: Maybe<Scalars['Float']['output']>;
  natural_override_gas_separation_percent?: Maybe<Scalars['Float']['output']>;
  /** pump_hz is the only known column with exponential notation in legacy sizings AND by truncating pump_hz doesnt effect calculations. */
  pump_hz?: Maybe<Scalars['Float']['output']>;
  pump_override_gas_correction_percent?: Maybe<Scalars['Float']['output']>;
  pump_wear_brake_horsepower_correction_ratio?: Maybe<Scalars['Float']['output']>;
  pump_wear_head_correction_ratio?: Maybe<Scalars['Float']['output']>;
  surface_drive_incoming_power_volts?: Maybe<Scalars['Float']['output']>;
  target_liquid_rate_std_barrel_day?: Maybe<Scalars['Float']['output']>;
  vsd_input_voltage?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "revisions.scenario_parameters_revisions" */
export type Revisions_Scenario_Parameters_Revisions_Stddev_Pop_Order_By = {
  bottom_casing_pressure_psia?: InputMaybe<Order_By>;
  bottom_tubing_pressure_psia?: InputMaybe<Order_By>;
  cable_cost_kw_hr_usd?: InputMaybe<Order_By>;
  elevation_feet_asl?: InputMaybe<Order_By>;
  intake_override_gas_separation_percent?: InputMaybe<Order_By>;
  lower_intake_override_gas_separation_percent?: InputMaybe<Order_By>;
  lower_motor_rerate_ratio?: InputMaybe<Order_By>;
  lower_motor_shroud_interior_diameter_inches?: InputMaybe<Order_By>;
  lower_natural_override_gas_separation_percent?: InputMaybe<Order_By>;
  lower_pump_hz?: InputMaybe<Order_By>;
  lower_pump_override_gas_correction_percent?: InputMaybe<Order_By>;
  lower_pump_wear_brake_horsepower_correction_ratio?: InputMaybe<Order_By>;
  lower_pump_wear_head_correction_ratio?: InputMaybe<Order_By>;
  maximum_frequency?: InputMaybe<Order_By>;
  minimum_frequency?: InputMaybe<Order_By>;
  motor_rerate_ratio?: InputMaybe<Order_By>;
  motor_shroud_interior_diameter_inches?: InputMaybe<Order_By>;
  natural_override_gas_separation_percent?: InputMaybe<Order_By>;
  /** pump_hz is the only known column with exponential notation in legacy sizings AND by truncating pump_hz doesnt effect calculations. */
  pump_hz?: InputMaybe<Order_By>;
  pump_override_gas_correction_percent?: InputMaybe<Order_By>;
  pump_wear_brake_horsepower_correction_ratio?: InputMaybe<Order_By>;
  pump_wear_head_correction_ratio?: InputMaybe<Order_By>;
  surface_drive_incoming_power_volts?: InputMaybe<Order_By>;
  target_liquid_rate_std_barrel_day?: InputMaybe<Order_By>;
  vsd_input_voltage?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Revisions_Scenario_Parameters_Revisions_Stddev_Samp_Fields = {
  __typename: 'revisions_scenario_parameters_revisions_stddev_samp_fields';
  bottom_casing_pressure_psia?: Maybe<Scalars['Float']['output']>;
  bottom_tubing_pressure_psia?: Maybe<Scalars['Float']['output']>;
  cable_cost_kw_hr_usd?: Maybe<Scalars['Float']['output']>;
  elevation_feet_asl?: Maybe<Scalars['Float']['output']>;
  intake_override_gas_separation_percent?: Maybe<Scalars['Float']['output']>;
  lower_intake_override_gas_separation_percent?: Maybe<Scalars['Float']['output']>;
  lower_motor_rerate_ratio?: Maybe<Scalars['Float']['output']>;
  lower_motor_shroud_interior_diameter_inches?: Maybe<Scalars['Float']['output']>;
  lower_natural_override_gas_separation_percent?: Maybe<Scalars['Float']['output']>;
  lower_pump_hz?: Maybe<Scalars['Float']['output']>;
  lower_pump_override_gas_correction_percent?: Maybe<Scalars['Float']['output']>;
  lower_pump_wear_brake_horsepower_correction_ratio?: Maybe<Scalars['Float']['output']>;
  lower_pump_wear_head_correction_ratio?: Maybe<Scalars['Float']['output']>;
  maximum_frequency?: Maybe<Scalars['Float']['output']>;
  minimum_frequency?: Maybe<Scalars['Float']['output']>;
  motor_rerate_ratio?: Maybe<Scalars['Float']['output']>;
  motor_shroud_interior_diameter_inches?: Maybe<Scalars['Float']['output']>;
  natural_override_gas_separation_percent?: Maybe<Scalars['Float']['output']>;
  /** pump_hz is the only known column with exponential notation in legacy sizings AND by truncating pump_hz doesnt effect calculations. */
  pump_hz?: Maybe<Scalars['Float']['output']>;
  pump_override_gas_correction_percent?: Maybe<Scalars['Float']['output']>;
  pump_wear_brake_horsepower_correction_ratio?: Maybe<Scalars['Float']['output']>;
  pump_wear_head_correction_ratio?: Maybe<Scalars['Float']['output']>;
  surface_drive_incoming_power_volts?: Maybe<Scalars['Float']['output']>;
  target_liquid_rate_std_barrel_day?: Maybe<Scalars['Float']['output']>;
  vsd_input_voltage?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "revisions.scenario_parameters_revisions" */
export type Revisions_Scenario_Parameters_Revisions_Stddev_Samp_Order_By = {
  bottom_casing_pressure_psia?: InputMaybe<Order_By>;
  bottom_tubing_pressure_psia?: InputMaybe<Order_By>;
  cable_cost_kw_hr_usd?: InputMaybe<Order_By>;
  elevation_feet_asl?: InputMaybe<Order_By>;
  intake_override_gas_separation_percent?: InputMaybe<Order_By>;
  lower_intake_override_gas_separation_percent?: InputMaybe<Order_By>;
  lower_motor_rerate_ratio?: InputMaybe<Order_By>;
  lower_motor_shroud_interior_diameter_inches?: InputMaybe<Order_By>;
  lower_natural_override_gas_separation_percent?: InputMaybe<Order_By>;
  lower_pump_hz?: InputMaybe<Order_By>;
  lower_pump_override_gas_correction_percent?: InputMaybe<Order_By>;
  lower_pump_wear_brake_horsepower_correction_ratio?: InputMaybe<Order_By>;
  lower_pump_wear_head_correction_ratio?: InputMaybe<Order_By>;
  maximum_frequency?: InputMaybe<Order_By>;
  minimum_frequency?: InputMaybe<Order_By>;
  motor_rerate_ratio?: InputMaybe<Order_By>;
  motor_shroud_interior_diameter_inches?: InputMaybe<Order_By>;
  natural_override_gas_separation_percent?: InputMaybe<Order_By>;
  /** pump_hz is the only known column with exponential notation in legacy sizings AND by truncating pump_hz doesnt effect calculations. */
  pump_hz?: InputMaybe<Order_By>;
  pump_override_gas_correction_percent?: InputMaybe<Order_By>;
  pump_wear_brake_horsepower_correction_ratio?: InputMaybe<Order_By>;
  pump_wear_head_correction_ratio?: InputMaybe<Order_By>;
  surface_drive_incoming_power_volts?: InputMaybe<Order_By>;
  target_liquid_rate_std_barrel_day?: InputMaybe<Order_By>;
  vsd_input_voltage?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "revisions_scenario_parameters_revisions" */
export type Revisions_Scenario_Parameters_Revisions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Revisions_Scenario_Parameters_Revisions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Revisions_Scenario_Parameters_Revisions_Stream_Cursor_Value_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  bottom_casing_pressure_psia?: InputMaybe<Scalars['numeric']['input']>;
  bottom_tubing_pressure_psia?: InputMaybe<Scalars['numeric']['input']>;
  cable_cost_kw_hr_usd?: InputMaybe<Scalars['numeric']['input']>;
  cloned_from_journal_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  elevation_feet_asl?: InputMaybe<Scalars['numeric']['input']>;
  flow_model?: InputMaybe<Flow_Model_Enum>;
  has_compression_pump?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  /** As fluid flows around the motor of the pump the friction of the fluid causes the pressure to drop. This drop in pressure may already be included in the well test inputs so this calculation must be optionally included. */
  include_casing_friction_loss?: InputMaybe<Scalars['Boolean']['input']>;
  intake_gas_separation_override_type?: InputMaybe<Override_Options_Enum>;
  intake_override_gas_separation_percent?: InputMaybe<Scalars['numeric']['input']>;
  intake_packer_installed?: InputMaybe<Scalars['Boolean']['input']>;
  journal_id?: InputMaybe<Scalars['uuid']['input']>;
  lower_has_compression_pump?: InputMaybe<Scalars['Boolean']['input']>;
  lower_include_casing_friction_loss?: InputMaybe<Scalars['Boolean']['input']>;
  lower_intake_gas_separation_override_type?: InputMaybe<Override_Options_Enum>;
  lower_intake_override_gas_separation_percent?: InputMaybe<Scalars['numeric']['input']>;
  lower_intake_packer_installed?: InputMaybe<Scalars['Boolean']['input']>;
  lower_motor_rerate_ratio?: InputMaybe<Scalars['numeric']['input']>;
  lower_motor_shroud_interior_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  lower_natural_gas_separation_override_type?: InputMaybe<Override_Options_Enum>;
  lower_natural_override_gas_separation_percent?: InputMaybe<Scalars['numeric']['input']>;
  lower_pump_hz?: InputMaybe<Scalars['numeric']['input']>;
  lower_pump_override_gas_correction_percent?: InputMaybe<Scalars['numeric']['input']>;
  lower_pump_wear_brake_horsepower_correction_ratio?: InputMaybe<Scalars['numeric']['input']>;
  lower_pump_wear_head_correction_ratio?: InputMaybe<Scalars['numeric']['input']>;
  lower_use_legacy_gas_head_rerate?: InputMaybe<Scalars['Boolean']['input']>;
  maximum_frequency?: InputMaybe<Scalars['numeric']['input']>;
  minimum_frequency?: InputMaybe<Scalars['numeric']['input']>;
  motor_rerate_ratio?: InputMaybe<Scalars['numeric']['input']>;
  motor_shroud_interior_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  natural_gas_separation_override_type?: InputMaybe<Override_Options_Enum>;
  natural_override_gas_separation_percent?: InputMaybe<Scalars['numeric']['input']>;
  parent_revision_id?: InputMaybe<Scalars['uuid']['input']>;
  /** pump_hz is the only known column with exponential notation in legacy sizings AND by truncating pump_hz doesnt effect calculations. */
  pump_hz?: InputMaybe<Scalars['numeric']['input']>;
  pump_override_gas_correction_percent?: InputMaybe<Scalars['numeric']['input']>;
  pump_wear_brake_horsepower_correction_ratio?: InputMaybe<Scalars['numeric']['input']>;
  pump_wear_head_correction_ratio?: InputMaybe<Scalars['numeric']['input']>;
  surface_drive_incoming_power_volts?: InputMaybe<Scalars['numeric']['input']>;
  target_liquid_rate_std_barrel_day?: InputMaybe<Scalars['numeric']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  /** Due to updates to the calculations, some users want to use the formula from Reaver 2.0. This boolean field will persist the user selection to use legacy calcs */
  use_legacy_gas_head_rerate?: InputMaybe<Scalars['Boolean']['input']>;
  vsd_input_voltage?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate sum on columns */
export type Revisions_Scenario_Parameters_Revisions_Sum_Fields = {
  __typename: 'revisions_scenario_parameters_revisions_sum_fields';
  bottom_casing_pressure_psia?: Maybe<Scalars['numeric']['output']>;
  bottom_tubing_pressure_psia?: Maybe<Scalars['numeric']['output']>;
  cable_cost_kw_hr_usd?: Maybe<Scalars['numeric']['output']>;
  elevation_feet_asl?: Maybe<Scalars['numeric']['output']>;
  intake_override_gas_separation_percent?: Maybe<Scalars['numeric']['output']>;
  lower_intake_override_gas_separation_percent?: Maybe<Scalars['numeric']['output']>;
  lower_motor_rerate_ratio?: Maybe<Scalars['numeric']['output']>;
  lower_motor_shroud_interior_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  lower_natural_override_gas_separation_percent?: Maybe<Scalars['numeric']['output']>;
  lower_pump_hz?: Maybe<Scalars['numeric']['output']>;
  lower_pump_override_gas_correction_percent?: Maybe<Scalars['numeric']['output']>;
  lower_pump_wear_brake_horsepower_correction_ratio?: Maybe<Scalars['numeric']['output']>;
  lower_pump_wear_head_correction_ratio?: Maybe<Scalars['numeric']['output']>;
  maximum_frequency?: Maybe<Scalars['numeric']['output']>;
  minimum_frequency?: Maybe<Scalars['numeric']['output']>;
  motor_rerate_ratio?: Maybe<Scalars['numeric']['output']>;
  motor_shroud_interior_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  natural_override_gas_separation_percent?: Maybe<Scalars['numeric']['output']>;
  /** pump_hz is the only known column with exponential notation in legacy sizings AND by truncating pump_hz doesnt effect calculations. */
  pump_hz?: Maybe<Scalars['numeric']['output']>;
  pump_override_gas_correction_percent?: Maybe<Scalars['numeric']['output']>;
  pump_wear_brake_horsepower_correction_ratio?: Maybe<Scalars['numeric']['output']>;
  pump_wear_head_correction_ratio?: Maybe<Scalars['numeric']['output']>;
  surface_drive_incoming_power_volts?: Maybe<Scalars['numeric']['output']>;
  target_liquid_rate_std_barrel_day?: Maybe<Scalars['numeric']['output']>;
  vsd_input_voltage?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "revisions.scenario_parameters_revisions" */
export type Revisions_Scenario_Parameters_Revisions_Sum_Order_By = {
  bottom_casing_pressure_psia?: InputMaybe<Order_By>;
  bottom_tubing_pressure_psia?: InputMaybe<Order_By>;
  cable_cost_kw_hr_usd?: InputMaybe<Order_By>;
  elevation_feet_asl?: InputMaybe<Order_By>;
  intake_override_gas_separation_percent?: InputMaybe<Order_By>;
  lower_intake_override_gas_separation_percent?: InputMaybe<Order_By>;
  lower_motor_rerate_ratio?: InputMaybe<Order_By>;
  lower_motor_shroud_interior_diameter_inches?: InputMaybe<Order_By>;
  lower_natural_override_gas_separation_percent?: InputMaybe<Order_By>;
  lower_pump_hz?: InputMaybe<Order_By>;
  lower_pump_override_gas_correction_percent?: InputMaybe<Order_By>;
  lower_pump_wear_brake_horsepower_correction_ratio?: InputMaybe<Order_By>;
  lower_pump_wear_head_correction_ratio?: InputMaybe<Order_By>;
  maximum_frequency?: InputMaybe<Order_By>;
  minimum_frequency?: InputMaybe<Order_By>;
  motor_rerate_ratio?: InputMaybe<Order_By>;
  motor_shroud_interior_diameter_inches?: InputMaybe<Order_By>;
  natural_override_gas_separation_percent?: InputMaybe<Order_By>;
  /** pump_hz is the only known column with exponential notation in legacy sizings AND by truncating pump_hz doesnt effect calculations. */
  pump_hz?: InputMaybe<Order_By>;
  pump_override_gas_correction_percent?: InputMaybe<Order_By>;
  pump_wear_brake_horsepower_correction_ratio?: InputMaybe<Order_By>;
  pump_wear_head_correction_ratio?: InputMaybe<Order_By>;
  surface_drive_incoming_power_volts?: InputMaybe<Order_By>;
  target_liquid_rate_std_barrel_day?: InputMaybe<Order_By>;
  vsd_input_voltage?: InputMaybe<Order_By>;
};

/** update columns of table "revisions.scenario_parameters_revisions" */
export enum Revisions_Scenario_Parameters_Revisions_Update_Column {
  /** column name */
  AuthorId = 'author_id',
  /** column name */
  BottomCasingPressurePsia = 'bottom_casing_pressure_psia',
  /** column name */
  BottomTubingPressurePsia = 'bottom_tubing_pressure_psia',
  /** column name */
  CableCostKwHrUsd = 'cable_cost_kw_hr_usd',
  /** column name */
  ClonedFromJournalId = 'cloned_from_journal_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  ElevationFeetAsl = 'elevation_feet_asl',
  /** column name */
  FlowModel = 'flow_model',
  /** column name */
  HasCompressionPump = 'has_compression_pump',
  /** column name */
  Id = 'id',
  /** column name */
  IncludeCasingFrictionLoss = 'include_casing_friction_loss',
  /** column name */
  IntakeGasSeparationOverrideType = 'intake_gas_separation_override_type',
  /** column name */
  IntakeOverrideGasSeparationPercent = 'intake_override_gas_separation_percent',
  /** column name */
  IntakePackerInstalled = 'intake_packer_installed',
  /** column name */
  JournalId = 'journal_id',
  /** column name */
  LowerHasCompressionPump = 'lower_has_compression_pump',
  /** column name */
  LowerIncludeCasingFrictionLoss = 'lower_include_casing_friction_loss',
  /** column name */
  LowerIntakeGasSeparationOverrideType = 'lower_intake_gas_separation_override_type',
  /** column name */
  LowerIntakeOverrideGasSeparationPercent = 'lower_intake_override_gas_separation_percent',
  /** column name */
  LowerIntakePackerInstalled = 'lower_intake_packer_installed',
  /** column name */
  LowerMotorRerateRatio = 'lower_motor_rerate_ratio',
  /** column name */
  LowerMotorShroudInteriorDiameterInches = 'lower_motor_shroud_interior_diameter_inches',
  /** column name */
  LowerNaturalGasSeparationOverrideType = 'lower_natural_gas_separation_override_type',
  /** column name */
  LowerNaturalOverrideGasSeparationPercent = 'lower_natural_override_gas_separation_percent',
  /** column name */
  LowerPumpHz = 'lower_pump_hz',
  /** column name */
  LowerPumpOverrideGasCorrectionPercent = 'lower_pump_override_gas_correction_percent',
  /** column name */
  LowerPumpWearBrakeHorsepowerCorrectionRatio = 'lower_pump_wear_brake_horsepower_correction_ratio',
  /** column name */
  LowerPumpWearHeadCorrectionRatio = 'lower_pump_wear_head_correction_ratio',
  /** column name */
  LowerUseLegacyGasHeadRerate = 'lower_use_legacy_gas_head_rerate',
  /** column name */
  MaximumFrequency = 'maximum_frequency',
  /** column name */
  MinimumFrequency = 'minimum_frequency',
  /** column name */
  MotorRerateRatio = 'motor_rerate_ratio',
  /** column name */
  MotorShroudInteriorDiameterInches = 'motor_shroud_interior_diameter_inches',
  /** column name */
  NaturalGasSeparationOverrideType = 'natural_gas_separation_override_type',
  /** column name */
  NaturalOverrideGasSeparationPercent = 'natural_override_gas_separation_percent',
  /** column name */
  ParentRevisionId = 'parent_revision_id',
  /** column name */
  PumpHz = 'pump_hz',
  /** column name */
  PumpOverrideGasCorrectionPercent = 'pump_override_gas_correction_percent',
  /** column name */
  PumpWearBrakeHorsepowerCorrectionRatio = 'pump_wear_brake_horsepower_correction_ratio',
  /** column name */
  PumpWearHeadCorrectionRatio = 'pump_wear_head_correction_ratio',
  /** column name */
  SurfaceDriveIncomingPowerVolts = 'surface_drive_incoming_power_volts',
  /** column name */
  TargetLiquidRateStdBarrelDay = 'target_liquid_rate_std_barrel_day',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UseLegacyGasHeadRerate = 'use_legacy_gas_head_rerate',
  /** column name */
  VsdInputVoltage = 'vsd_input_voltage'
}

export type Revisions_Scenario_Parameters_Revisions_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Revisions_Scenario_Parameters_Revisions_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Revisions_Scenario_Parameters_Revisions_Set_Input>;
  /** filter the rows which have to be updated */
  where: Revisions_Scenario_Parameters_Revisions_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Revisions_Scenario_Parameters_Revisions_Var_Pop_Fields = {
  __typename: 'revisions_scenario_parameters_revisions_var_pop_fields';
  bottom_casing_pressure_psia?: Maybe<Scalars['Float']['output']>;
  bottom_tubing_pressure_psia?: Maybe<Scalars['Float']['output']>;
  cable_cost_kw_hr_usd?: Maybe<Scalars['Float']['output']>;
  elevation_feet_asl?: Maybe<Scalars['Float']['output']>;
  intake_override_gas_separation_percent?: Maybe<Scalars['Float']['output']>;
  lower_intake_override_gas_separation_percent?: Maybe<Scalars['Float']['output']>;
  lower_motor_rerate_ratio?: Maybe<Scalars['Float']['output']>;
  lower_motor_shroud_interior_diameter_inches?: Maybe<Scalars['Float']['output']>;
  lower_natural_override_gas_separation_percent?: Maybe<Scalars['Float']['output']>;
  lower_pump_hz?: Maybe<Scalars['Float']['output']>;
  lower_pump_override_gas_correction_percent?: Maybe<Scalars['Float']['output']>;
  lower_pump_wear_brake_horsepower_correction_ratio?: Maybe<Scalars['Float']['output']>;
  lower_pump_wear_head_correction_ratio?: Maybe<Scalars['Float']['output']>;
  maximum_frequency?: Maybe<Scalars['Float']['output']>;
  minimum_frequency?: Maybe<Scalars['Float']['output']>;
  motor_rerate_ratio?: Maybe<Scalars['Float']['output']>;
  motor_shroud_interior_diameter_inches?: Maybe<Scalars['Float']['output']>;
  natural_override_gas_separation_percent?: Maybe<Scalars['Float']['output']>;
  /** pump_hz is the only known column with exponential notation in legacy sizings AND by truncating pump_hz doesnt effect calculations. */
  pump_hz?: Maybe<Scalars['Float']['output']>;
  pump_override_gas_correction_percent?: Maybe<Scalars['Float']['output']>;
  pump_wear_brake_horsepower_correction_ratio?: Maybe<Scalars['Float']['output']>;
  pump_wear_head_correction_ratio?: Maybe<Scalars['Float']['output']>;
  surface_drive_incoming_power_volts?: Maybe<Scalars['Float']['output']>;
  target_liquid_rate_std_barrel_day?: Maybe<Scalars['Float']['output']>;
  vsd_input_voltage?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "revisions.scenario_parameters_revisions" */
export type Revisions_Scenario_Parameters_Revisions_Var_Pop_Order_By = {
  bottom_casing_pressure_psia?: InputMaybe<Order_By>;
  bottom_tubing_pressure_psia?: InputMaybe<Order_By>;
  cable_cost_kw_hr_usd?: InputMaybe<Order_By>;
  elevation_feet_asl?: InputMaybe<Order_By>;
  intake_override_gas_separation_percent?: InputMaybe<Order_By>;
  lower_intake_override_gas_separation_percent?: InputMaybe<Order_By>;
  lower_motor_rerate_ratio?: InputMaybe<Order_By>;
  lower_motor_shroud_interior_diameter_inches?: InputMaybe<Order_By>;
  lower_natural_override_gas_separation_percent?: InputMaybe<Order_By>;
  lower_pump_hz?: InputMaybe<Order_By>;
  lower_pump_override_gas_correction_percent?: InputMaybe<Order_By>;
  lower_pump_wear_brake_horsepower_correction_ratio?: InputMaybe<Order_By>;
  lower_pump_wear_head_correction_ratio?: InputMaybe<Order_By>;
  maximum_frequency?: InputMaybe<Order_By>;
  minimum_frequency?: InputMaybe<Order_By>;
  motor_rerate_ratio?: InputMaybe<Order_By>;
  motor_shroud_interior_diameter_inches?: InputMaybe<Order_By>;
  natural_override_gas_separation_percent?: InputMaybe<Order_By>;
  /** pump_hz is the only known column with exponential notation in legacy sizings AND by truncating pump_hz doesnt effect calculations. */
  pump_hz?: InputMaybe<Order_By>;
  pump_override_gas_correction_percent?: InputMaybe<Order_By>;
  pump_wear_brake_horsepower_correction_ratio?: InputMaybe<Order_By>;
  pump_wear_head_correction_ratio?: InputMaybe<Order_By>;
  surface_drive_incoming_power_volts?: InputMaybe<Order_By>;
  target_liquid_rate_std_barrel_day?: InputMaybe<Order_By>;
  vsd_input_voltage?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Revisions_Scenario_Parameters_Revisions_Var_Samp_Fields = {
  __typename: 'revisions_scenario_parameters_revisions_var_samp_fields';
  bottom_casing_pressure_psia?: Maybe<Scalars['Float']['output']>;
  bottom_tubing_pressure_psia?: Maybe<Scalars['Float']['output']>;
  cable_cost_kw_hr_usd?: Maybe<Scalars['Float']['output']>;
  elevation_feet_asl?: Maybe<Scalars['Float']['output']>;
  intake_override_gas_separation_percent?: Maybe<Scalars['Float']['output']>;
  lower_intake_override_gas_separation_percent?: Maybe<Scalars['Float']['output']>;
  lower_motor_rerate_ratio?: Maybe<Scalars['Float']['output']>;
  lower_motor_shroud_interior_diameter_inches?: Maybe<Scalars['Float']['output']>;
  lower_natural_override_gas_separation_percent?: Maybe<Scalars['Float']['output']>;
  lower_pump_hz?: Maybe<Scalars['Float']['output']>;
  lower_pump_override_gas_correction_percent?: Maybe<Scalars['Float']['output']>;
  lower_pump_wear_brake_horsepower_correction_ratio?: Maybe<Scalars['Float']['output']>;
  lower_pump_wear_head_correction_ratio?: Maybe<Scalars['Float']['output']>;
  maximum_frequency?: Maybe<Scalars['Float']['output']>;
  minimum_frequency?: Maybe<Scalars['Float']['output']>;
  motor_rerate_ratio?: Maybe<Scalars['Float']['output']>;
  motor_shroud_interior_diameter_inches?: Maybe<Scalars['Float']['output']>;
  natural_override_gas_separation_percent?: Maybe<Scalars['Float']['output']>;
  /** pump_hz is the only known column with exponential notation in legacy sizings AND by truncating pump_hz doesnt effect calculations. */
  pump_hz?: Maybe<Scalars['Float']['output']>;
  pump_override_gas_correction_percent?: Maybe<Scalars['Float']['output']>;
  pump_wear_brake_horsepower_correction_ratio?: Maybe<Scalars['Float']['output']>;
  pump_wear_head_correction_ratio?: Maybe<Scalars['Float']['output']>;
  surface_drive_incoming_power_volts?: Maybe<Scalars['Float']['output']>;
  target_liquid_rate_std_barrel_day?: Maybe<Scalars['Float']['output']>;
  vsd_input_voltage?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "revisions.scenario_parameters_revisions" */
export type Revisions_Scenario_Parameters_Revisions_Var_Samp_Order_By = {
  bottom_casing_pressure_psia?: InputMaybe<Order_By>;
  bottom_tubing_pressure_psia?: InputMaybe<Order_By>;
  cable_cost_kw_hr_usd?: InputMaybe<Order_By>;
  elevation_feet_asl?: InputMaybe<Order_By>;
  intake_override_gas_separation_percent?: InputMaybe<Order_By>;
  lower_intake_override_gas_separation_percent?: InputMaybe<Order_By>;
  lower_motor_rerate_ratio?: InputMaybe<Order_By>;
  lower_motor_shroud_interior_diameter_inches?: InputMaybe<Order_By>;
  lower_natural_override_gas_separation_percent?: InputMaybe<Order_By>;
  lower_pump_hz?: InputMaybe<Order_By>;
  lower_pump_override_gas_correction_percent?: InputMaybe<Order_By>;
  lower_pump_wear_brake_horsepower_correction_ratio?: InputMaybe<Order_By>;
  lower_pump_wear_head_correction_ratio?: InputMaybe<Order_By>;
  maximum_frequency?: InputMaybe<Order_By>;
  minimum_frequency?: InputMaybe<Order_By>;
  motor_rerate_ratio?: InputMaybe<Order_By>;
  motor_shroud_interior_diameter_inches?: InputMaybe<Order_By>;
  natural_override_gas_separation_percent?: InputMaybe<Order_By>;
  /** pump_hz is the only known column with exponential notation in legacy sizings AND by truncating pump_hz doesnt effect calculations. */
  pump_hz?: InputMaybe<Order_By>;
  pump_override_gas_correction_percent?: InputMaybe<Order_By>;
  pump_wear_brake_horsepower_correction_ratio?: InputMaybe<Order_By>;
  pump_wear_head_correction_ratio?: InputMaybe<Order_By>;
  surface_drive_incoming_power_volts?: InputMaybe<Order_By>;
  target_liquid_rate_std_barrel_day?: InputMaybe<Order_By>;
  vsd_input_voltage?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Revisions_Scenario_Parameters_Revisions_Variance_Fields = {
  __typename: 'revisions_scenario_parameters_revisions_variance_fields';
  bottom_casing_pressure_psia?: Maybe<Scalars['Float']['output']>;
  bottom_tubing_pressure_psia?: Maybe<Scalars['Float']['output']>;
  cable_cost_kw_hr_usd?: Maybe<Scalars['Float']['output']>;
  elevation_feet_asl?: Maybe<Scalars['Float']['output']>;
  intake_override_gas_separation_percent?: Maybe<Scalars['Float']['output']>;
  lower_intake_override_gas_separation_percent?: Maybe<Scalars['Float']['output']>;
  lower_motor_rerate_ratio?: Maybe<Scalars['Float']['output']>;
  lower_motor_shroud_interior_diameter_inches?: Maybe<Scalars['Float']['output']>;
  lower_natural_override_gas_separation_percent?: Maybe<Scalars['Float']['output']>;
  lower_pump_hz?: Maybe<Scalars['Float']['output']>;
  lower_pump_override_gas_correction_percent?: Maybe<Scalars['Float']['output']>;
  lower_pump_wear_brake_horsepower_correction_ratio?: Maybe<Scalars['Float']['output']>;
  lower_pump_wear_head_correction_ratio?: Maybe<Scalars['Float']['output']>;
  maximum_frequency?: Maybe<Scalars['Float']['output']>;
  minimum_frequency?: Maybe<Scalars['Float']['output']>;
  motor_rerate_ratio?: Maybe<Scalars['Float']['output']>;
  motor_shroud_interior_diameter_inches?: Maybe<Scalars['Float']['output']>;
  natural_override_gas_separation_percent?: Maybe<Scalars['Float']['output']>;
  /** pump_hz is the only known column with exponential notation in legacy sizings AND by truncating pump_hz doesnt effect calculations. */
  pump_hz?: Maybe<Scalars['Float']['output']>;
  pump_override_gas_correction_percent?: Maybe<Scalars['Float']['output']>;
  pump_wear_brake_horsepower_correction_ratio?: Maybe<Scalars['Float']['output']>;
  pump_wear_head_correction_ratio?: Maybe<Scalars['Float']['output']>;
  surface_drive_incoming_power_volts?: Maybe<Scalars['Float']['output']>;
  target_liquid_rate_std_barrel_day?: Maybe<Scalars['Float']['output']>;
  vsd_input_voltage?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "revisions.scenario_parameters_revisions" */
export type Revisions_Scenario_Parameters_Revisions_Variance_Order_By = {
  bottom_casing_pressure_psia?: InputMaybe<Order_By>;
  bottom_tubing_pressure_psia?: InputMaybe<Order_By>;
  cable_cost_kw_hr_usd?: InputMaybe<Order_By>;
  elevation_feet_asl?: InputMaybe<Order_By>;
  intake_override_gas_separation_percent?: InputMaybe<Order_By>;
  lower_intake_override_gas_separation_percent?: InputMaybe<Order_By>;
  lower_motor_rerate_ratio?: InputMaybe<Order_By>;
  lower_motor_shroud_interior_diameter_inches?: InputMaybe<Order_By>;
  lower_natural_override_gas_separation_percent?: InputMaybe<Order_By>;
  lower_pump_hz?: InputMaybe<Order_By>;
  lower_pump_override_gas_correction_percent?: InputMaybe<Order_By>;
  lower_pump_wear_brake_horsepower_correction_ratio?: InputMaybe<Order_By>;
  lower_pump_wear_head_correction_ratio?: InputMaybe<Order_By>;
  maximum_frequency?: InputMaybe<Order_By>;
  minimum_frequency?: InputMaybe<Order_By>;
  motor_rerate_ratio?: InputMaybe<Order_By>;
  motor_shroud_interior_diameter_inches?: InputMaybe<Order_By>;
  natural_override_gas_separation_percent?: InputMaybe<Order_By>;
  /** pump_hz is the only known column with exponential notation in legacy sizings AND by truncating pump_hz doesnt effect calculations. */
  pump_hz?: InputMaybe<Order_By>;
  pump_override_gas_correction_percent?: InputMaybe<Order_By>;
  pump_wear_brake_horsepower_correction_ratio?: InputMaybe<Order_By>;
  pump_wear_head_correction_ratio?: InputMaybe<Order_By>;
  surface_drive_incoming_power_volts?: InputMaybe<Order_By>;
  target_liquid_rate_std_barrel_day?: InputMaybe<Order_By>;
  vsd_input_voltage?: InputMaybe<Order_By>;
};

/** columns and relationships of "revisions.scenario_well_properties_journal" */
export type Revisions_Scenario_Well_Properties_Journal = {
  __typename: 'revisions_scenario_well_properties_journal';
  author_id: Scalars['String']['output'];
  created_at: Scalars['timestamptz']['output'];
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  parent_journal_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  scenario_well_properties_journal?: Maybe<Revisions_Scenario_Well_Properties_Journal>;
  /** An array relationship */
  scenario_well_properties_journals: Array<Revisions_Scenario_Well_Properties_Journal>;
  /** An aggregate relationship */
  scenario_well_properties_journals_aggregate: Revisions_Scenario_Well_Properties_Journal_Aggregate;
  /** An object relationship */
  scenario_well_properties_revision?: Maybe<Revisions_Scenario_Well_Properties_Revisions>;
  /** An array relationship */
  scenario_well_properties_revisions: Array<Revisions_Scenario_Well_Properties_Revisions>;
  /** An aggregate relationship */
  scenario_well_properties_revisions_aggregate: Revisions_Scenario_Well_Properties_Revisions_Aggregate;
  /** An array relationship */
  scenarios_revisions: Array<Revisions_Scenarios_Revisions>;
  /** An aggregate relationship */
  scenarios_revisions_aggregate: Revisions_Scenarios_Revisions_Aggregate;
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Users;
  winning_revision_id?: Maybe<Scalars['uuid']['output']>;
};


/** columns and relationships of "revisions.scenario_well_properties_journal" */
export type Revisions_Scenario_Well_Properties_JournalScenario_Well_Properties_JournalsArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Well_Properties_Journal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Well_Properties_Journal_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Well_Properties_Journal_Bool_Exp>;
};


/** columns and relationships of "revisions.scenario_well_properties_journal" */
export type Revisions_Scenario_Well_Properties_JournalScenario_Well_Properties_Journals_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Well_Properties_Journal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Well_Properties_Journal_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Well_Properties_Journal_Bool_Exp>;
};


/** columns and relationships of "revisions.scenario_well_properties_journal" */
export type Revisions_Scenario_Well_Properties_JournalScenario_Well_Properties_RevisionsArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Well_Properties_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Well_Properties_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Well_Properties_Revisions_Bool_Exp>;
};


/** columns and relationships of "revisions.scenario_well_properties_journal" */
export type Revisions_Scenario_Well_Properties_JournalScenario_Well_Properties_Revisions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Well_Properties_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Well_Properties_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Well_Properties_Revisions_Bool_Exp>;
};


/** columns and relationships of "revisions.scenario_well_properties_journal" */
export type Revisions_Scenario_Well_Properties_JournalScenarios_RevisionsArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenarios_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenarios_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Scenarios_Revisions_Bool_Exp>;
};


/** columns and relationships of "revisions.scenario_well_properties_journal" */
export type Revisions_Scenario_Well_Properties_JournalScenarios_Revisions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenarios_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenarios_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Scenarios_Revisions_Bool_Exp>;
};

/** aggregated selection of "revisions.scenario_well_properties_journal" */
export type Revisions_Scenario_Well_Properties_Journal_Aggregate = {
  __typename: 'revisions_scenario_well_properties_journal_aggregate';
  aggregate?: Maybe<Revisions_Scenario_Well_Properties_Journal_Aggregate_Fields>;
  nodes: Array<Revisions_Scenario_Well_Properties_Journal>;
};

export type Revisions_Scenario_Well_Properties_Journal_Aggregate_Bool_Exp = {
  count?: InputMaybe<Revisions_Scenario_Well_Properties_Journal_Aggregate_Bool_Exp_Count>;
};

export type Revisions_Scenario_Well_Properties_Journal_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Revisions_Scenario_Well_Properties_Journal_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Revisions_Scenario_Well_Properties_Journal_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "revisions.scenario_well_properties_journal" */
export type Revisions_Scenario_Well_Properties_Journal_Aggregate_Fields = {
  __typename: 'revisions_scenario_well_properties_journal_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Revisions_Scenario_Well_Properties_Journal_Max_Fields>;
  min?: Maybe<Revisions_Scenario_Well_Properties_Journal_Min_Fields>;
};


/** aggregate fields of "revisions.scenario_well_properties_journal" */
export type Revisions_Scenario_Well_Properties_Journal_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Revisions_Scenario_Well_Properties_Journal_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "revisions.scenario_well_properties_journal" */
export type Revisions_Scenario_Well_Properties_Journal_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Revisions_Scenario_Well_Properties_Journal_Max_Order_By>;
  min?: InputMaybe<Revisions_Scenario_Well_Properties_Journal_Min_Order_By>;
};

/** input type for inserting array relation for remote table "revisions.scenario_well_properties_journal" */
export type Revisions_Scenario_Well_Properties_Journal_Arr_Rel_Insert_Input = {
  data: Array<Revisions_Scenario_Well_Properties_Journal_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Revisions_Scenario_Well_Properties_Journal_On_Conflict>;
};

/** Boolean expression to filter rows from the table "revisions.scenario_well_properties_journal". All fields are combined with a logical 'AND'. */
export type Revisions_Scenario_Well_Properties_Journal_Bool_Exp = {
  _and?: InputMaybe<Array<Revisions_Scenario_Well_Properties_Journal_Bool_Exp>>;
  _not?: InputMaybe<Revisions_Scenario_Well_Properties_Journal_Bool_Exp>;
  _or?: InputMaybe<Array<Revisions_Scenario_Well_Properties_Journal_Bool_Exp>>;
  author_id?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  parent_journal_id?: InputMaybe<Uuid_Comparison_Exp>;
  scenario_well_properties_journal?: InputMaybe<Revisions_Scenario_Well_Properties_Journal_Bool_Exp>;
  scenario_well_properties_journals?: InputMaybe<Revisions_Scenario_Well_Properties_Journal_Bool_Exp>;
  scenario_well_properties_journals_aggregate?: InputMaybe<Revisions_Scenario_Well_Properties_Journal_Aggregate_Bool_Exp>;
  scenario_well_properties_revision?: InputMaybe<Revisions_Scenario_Well_Properties_Revisions_Bool_Exp>;
  scenario_well_properties_revisions?: InputMaybe<Revisions_Scenario_Well_Properties_Revisions_Bool_Exp>;
  scenario_well_properties_revisions_aggregate?: InputMaybe<Revisions_Scenario_Well_Properties_Revisions_Aggregate_Bool_Exp>;
  scenarios_revisions?: InputMaybe<Revisions_Scenarios_Revisions_Bool_Exp>;
  scenarios_revisions_aggregate?: InputMaybe<Revisions_Scenarios_Revisions_Aggregate_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  winning_revision_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "revisions.scenario_well_properties_journal" */
export enum Revisions_Scenario_Well_Properties_Journal_Constraint {
  /** unique or primary key constraint on columns "id" */
  ScenarioWellPropertiesJournalPkey = 'scenario_well_properties_journal_pkey'
}

/** input type for inserting data into table "revisions.scenario_well_properties_journal" */
export type Revisions_Scenario_Well_Properties_Journal_Insert_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  parent_journal_id?: InputMaybe<Scalars['uuid']['input']>;
  scenario_well_properties_journal?: InputMaybe<Revisions_Scenario_Well_Properties_Journal_Obj_Rel_Insert_Input>;
  scenario_well_properties_journals?: InputMaybe<Revisions_Scenario_Well_Properties_Journal_Arr_Rel_Insert_Input>;
  scenario_well_properties_revision?: InputMaybe<Revisions_Scenario_Well_Properties_Revisions_Obj_Rel_Insert_Input>;
  scenario_well_properties_revisions?: InputMaybe<Revisions_Scenario_Well_Properties_Revisions_Arr_Rel_Insert_Input>;
  scenarios_revisions?: InputMaybe<Revisions_Scenarios_Revisions_Arr_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  winning_revision_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Revisions_Scenario_Well_Properties_Journal_Max_Fields = {
  __typename: 'revisions_scenario_well_properties_journal_max_fields';
  author_id?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  parent_journal_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  winning_revision_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "revisions.scenario_well_properties_journal" */
export type Revisions_Scenario_Well_Properties_Journal_Max_Order_By = {
  author_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parent_journal_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  winning_revision_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Revisions_Scenario_Well_Properties_Journal_Min_Fields = {
  __typename: 'revisions_scenario_well_properties_journal_min_fields';
  author_id?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  parent_journal_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  winning_revision_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "revisions.scenario_well_properties_journal" */
export type Revisions_Scenario_Well_Properties_Journal_Min_Order_By = {
  author_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parent_journal_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  winning_revision_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "revisions.scenario_well_properties_journal" */
export type Revisions_Scenario_Well_Properties_Journal_Mutation_Response = {
  __typename: 'revisions_scenario_well_properties_journal_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Revisions_Scenario_Well_Properties_Journal>;
};

/** input type for inserting object relation for remote table "revisions.scenario_well_properties_journal" */
export type Revisions_Scenario_Well_Properties_Journal_Obj_Rel_Insert_Input = {
  data: Revisions_Scenario_Well_Properties_Journal_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Revisions_Scenario_Well_Properties_Journal_On_Conflict>;
};

/** on_conflict condition type for table "revisions.scenario_well_properties_journal" */
export type Revisions_Scenario_Well_Properties_Journal_On_Conflict = {
  constraint: Revisions_Scenario_Well_Properties_Journal_Constraint;
  update_columns?: Array<Revisions_Scenario_Well_Properties_Journal_Update_Column>;
  where?: InputMaybe<Revisions_Scenario_Well_Properties_Journal_Bool_Exp>;
};

/** Ordering options when selecting data from "revisions.scenario_well_properties_journal". */
export type Revisions_Scenario_Well_Properties_Journal_Order_By = {
  author_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parent_journal_id?: InputMaybe<Order_By>;
  scenario_well_properties_journal?: InputMaybe<Revisions_Scenario_Well_Properties_Journal_Order_By>;
  scenario_well_properties_journals_aggregate?: InputMaybe<Revisions_Scenario_Well_Properties_Journal_Aggregate_Order_By>;
  scenario_well_properties_revision?: InputMaybe<Revisions_Scenario_Well_Properties_Revisions_Order_By>;
  scenario_well_properties_revisions_aggregate?: InputMaybe<Revisions_Scenario_Well_Properties_Revisions_Aggregate_Order_By>;
  scenarios_revisions_aggregate?: InputMaybe<Revisions_Scenarios_Revisions_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  winning_revision_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: revisions.scenario_well_properties_journal */
export type Revisions_Scenario_Well_Properties_Journal_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "revisions.scenario_well_properties_journal" */
export enum Revisions_Scenario_Well_Properties_Journal_Select_Column {
  /** column name */
  AuthorId = 'author_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  ParentJournalId = 'parent_journal_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WinningRevisionId = 'winning_revision_id'
}

/** input type for updating data in table "revisions.scenario_well_properties_journal" */
export type Revisions_Scenario_Well_Properties_Journal_Set_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  parent_journal_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  winning_revision_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "revisions_scenario_well_properties_journal" */
export type Revisions_Scenario_Well_Properties_Journal_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Revisions_Scenario_Well_Properties_Journal_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Revisions_Scenario_Well_Properties_Journal_Stream_Cursor_Value_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  parent_journal_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  winning_revision_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "revisions.scenario_well_properties_journal" */
export enum Revisions_Scenario_Well_Properties_Journal_Update_Column {
  /** column name */
  AuthorId = 'author_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  ParentJournalId = 'parent_journal_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WinningRevisionId = 'winning_revision_id'
}

export type Revisions_Scenario_Well_Properties_Journal_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Revisions_Scenario_Well_Properties_Journal_Set_Input>;
  /** filter the rows which have to be updated */
  where: Revisions_Scenario_Well_Properties_Journal_Bool_Exp;
};

/** columns and relationships of "revisions.scenario_well_properties_revisions" */
export type Revisions_Scenario_Well_Properties_Revisions = {
  __typename: 'revisions_scenario_well_properties_revisions';
  ar_percent: Scalars['numeric']['output'];
  author_id: Scalars['String']['output'];
  average_dls?: Maybe<Scalars['numeric']['output']>;
  /** An object relationship */
  bottom_casing?: Maybe<Casings>;
  bottom_casing_id?: Maybe<Scalars['uuid']['output']>;
  bottom_casing_length_feet?: Maybe<Scalars['numeric']['output']>;
  /** An object relationship */
  bottom_tubing?: Maybe<Tubings>;
  bottom_tubing_id?: Maybe<Scalars['uuid']['output']>;
  bottom_tubing_length_feet?: Maybe<Scalars['numeric']['output']>;
  bottomhole_temperature_fahrenheit?: Maybe<Scalars['numeric']['output']>;
  bubble_point_pressure_psia?: Maybe<Scalars['numeric']['output']>;
  c1_methane_percent: Scalars['numeric']['output'];
  c2_ethane_percent: Scalars['numeric']['output'];
  c3_propane_percent: Scalars['numeric']['output'];
  c6_hexane_percent: Scalars['numeric']['output'];
  c7_heptane_percent: Scalars['numeric']['output'];
  cloned_from_journal_id?: Maybe<Scalars['uuid']['output']>;
  co2_percent?: Maybe<Scalars['numeric']['output']>;
  condensate_api_override?: Maybe<Scalars['numeric']['output']>;
  created_at: Scalars['timestamptz']['output'];
  custom_fluid_properties?: Maybe<Scalars['jsonb']['output']>;
  custom_viscosities_properties?: Maybe<Scalars['jsonb']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  deviation_survey?: Maybe<Deviation_Survey>;
  deviation_survey_id?: Maybe<Scalars['uuid']['output']>;
  dew_point_pressure_psia_override?: Maybe<Scalars['numeric']['output']>;
  fluid_viscosity_override_cp?: Maybe<Scalars['numeric']['output']>;
  gas_specific_gravity?: Maybe<Scalars['numeric']['output']>;
  gas_type?: Maybe<Well_Gas_Type_Options_Enum>;
  h2s_percent?: Maybe<Scalars['numeric']['output']>;
  hps_liquid_type?: Maybe<Hps_Liquid_Type_Enum>;
  hps_pump_inlet_pressure_psia?: Maybe<Scalars['numeric']['output']>;
  hps_pump_inlet_temperature_fahrenheit?: Maybe<Scalars['numeric']['output']>;
  hps_required_discharge_pressure_psia?: Maybe<Scalars['numeric']['output']>;
  ic4_isobutene_percent: Scalars['numeric']['output'];
  ic5_isopentane_percent: Scalars['numeric']['output'];
  id: Scalars['uuid']['output'];
  journal_id: Scalars['uuid']['output'];
  n2_percent?: Maybe<Scalars['numeric']['output']>;
  nc4_butane_percent: Scalars['numeric']['output'];
  nc5_bentane_percent: Scalars['numeric']['output'];
  npsha_ft?: Maybe<Scalars['numeric']['output']>;
  o2_percent: Scalars['numeric']['output'];
  oil_gravity_api?: Maybe<Scalars['numeric']['output']>;
  parent_revision_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  scenario_well_properties_journal: Revisions_Scenario_Well_Properties_Journal;
  /** An array relationship */
  scenario_well_properties_journals: Array<Revisions_Scenario_Well_Properties_Journal>;
  /** An aggregate relationship */
  scenario_well_properties_journals_aggregate: Revisions_Scenario_Well_Properties_Journal_Aggregate;
  /** An object relationship */
  scenario_well_properties_revision?: Maybe<Revisions_Scenario_Well_Properties_Revisions>;
  /** An array relationship */
  scenario_well_properties_revisions: Array<Revisions_Scenario_Well_Properties_Revisions>;
  /** An aggregate relationship */
  scenario_well_properties_revisions_aggregate: Revisions_Scenario_Well_Properties_Revisions_Aggregate;
  /** An object relationship */
  scenario_well_properties_view?: Maybe<Scenario_Well_Properties>;
  surface_temperature_fahrenheit?: Maybe<Scalars['numeric']['output']>;
  /** An object relationship */
  top_casing?: Maybe<Casings>;
  top_casing_id?: Maybe<Scalars['uuid']['output']>;
  top_casing_length_feet?: Maybe<Scalars['numeric']['output']>;
  top_of_perforations_measured_depth_feet?: Maybe<Scalars['numeric']['output']>;
  top_of_perforations_true_vertical_depth_feet?: Maybe<Scalars['numeric']['output']>;
  /** An object relationship */
  top_tubing?: Maybe<Tubings>;
  top_tubing_id?: Maybe<Scalars['uuid']['output']>;
  top_tubing_length_feet?: Maybe<Scalars['numeric']['output']>;
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Users;
  water_specific_gravity?: Maybe<Scalars['numeric']['output']>;
  well_test_datum_point_measured_depth_feet?: Maybe<Scalars['numeric']['output']>;
  /** An object relationship */
  well_test_gas_input_option?: Maybe<Well_Test_Gas_Input_Options>;
  well_test_gas_input_type?: Maybe<Well_Test_Gas_Input_Options_Enum>;
  well_test_gas_rate_mscf_day?: Maybe<Scalars['numeric']['output']>;
  /** An object relationship */
  well_test_liquid_input_option?: Maybe<Well_Test_Liquid_Input_Options>;
  well_test_liquid_input_type?: Maybe<Well_Test_Liquid_Input_Options_Enum>;
  well_test_oil_rate_stb_day?: Maybe<Scalars['numeric']['output']>;
  well_test_pressure_input_type?: Maybe<Well_Test_Pressure_Input_Options_Enum>;
  well_test_producing_bottom_hole_pressure_psia?: Maybe<Scalars['numeric']['output']>;
  well_test_productivity_index?: Maybe<Scalars['numeric']['output']>;
  well_test_static_bottom_hole_pressure_psia?: Maybe<Scalars['numeric']['output']>;
  well_test_test_date?: Maybe<Scalars['timestamptz']['output']>;
  well_test_water_rate_stb_day?: Maybe<Scalars['numeric']['output']>;
};


/** columns and relationships of "revisions.scenario_well_properties_revisions" */
export type Revisions_Scenario_Well_Properties_RevisionsCustom_Fluid_PropertiesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "revisions.scenario_well_properties_revisions" */
export type Revisions_Scenario_Well_Properties_RevisionsCustom_Viscosities_PropertiesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "revisions.scenario_well_properties_revisions" */
export type Revisions_Scenario_Well_Properties_RevisionsScenario_Well_Properties_JournalsArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Well_Properties_Journal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Well_Properties_Journal_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Well_Properties_Journal_Bool_Exp>;
};


/** columns and relationships of "revisions.scenario_well_properties_revisions" */
export type Revisions_Scenario_Well_Properties_RevisionsScenario_Well_Properties_Journals_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Well_Properties_Journal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Well_Properties_Journal_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Well_Properties_Journal_Bool_Exp>;
};


/** columns and relationships of "revisions.scenario_well_properties_revisions" */
export type Revisions_Scenario_Well_Properties_RevisionsScenario_Well_Properties_RevisionsArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Well_Properties_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Well_Properties_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Well_Properties_Revisions_Bool_Exp>;
};


/** columns and relationships of "revisions.scenario_well_properties_revisions" */
export type Revisions_Scenario_Well_Properties_RevisionsScenario_Well_Properties_Revisions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Well_Properties_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Well_Properties_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Well_Properties_Revisions_Bool_Exp>;
};

/** aggregated selection of "revisions.scenario_well_properties_revisions" */
export type Revisions_Scenario_Well_Properties_Revisions_Aggregate = {
  __typename: 'revisions_scenario_well_properties_revisions_aggregate';
  aggregate?: Maybe<Revisions_Scenario_Well_Properties_Revisions_Aggregate_Fields>;
  nodes: Array<Revisions_Scenario_Well_Properties_Revisions>;
};

export type Revisions_Scenario_Well_Properties_Revisions_Aggregate_Bool_Exp = {
  count?: InputMaybe<Revisions_Scenario_Well_Properties_Revisions_Aggregate_Bool_Exp_Count>;
};

export type Revisions_Scenario_Well_Properties_Revisions_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Revisions_Scenario_Well_Properties_Revisions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Revisions_Scenario_Well_Properties_Revisions_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "revisions.scenario_well_properties_revisions" */
export type Revisions_Scenario_Well_Properties_Revisions_Aggregate_Fields = {
  __typename: 'revisions_scenario_well_properties_revisions_aggregate_fields';
  avg?: Maybe<Revisions_Scenario_Well_Properties_Revisions_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Revisions_Scenario_Well_Properties_Revisions_Max_Fields>;
  min?: Maybe<Revisions_Scenario_Well_Properties_Revisions_Min_Fields>;
  stddev?: Maybe<Revisions_Scenario_Well_Properties_Revisions_Stddev_Fields>;
  stddev_pop?: Maybe<Revisions_Scenario_Well_Properties_Revisions_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Revisions_Scenario_Well_Properties_Revisions_Stddev_Samp_Fields>;
  sum?: Maybe<Revisions_Scenario_Well_Properties_Revisions_Sum_Fields>;
  var_pop?: Maybe<Revisions_Scenario_Well_Properties_Revisions_Var_Pop_Fields>;
  var_samp?: Maybe<Revisions_Scenario_Well_Properties_Revisions_Var_Samp_Fields>;
  variance?: Maybe<Revisions_Scenario_Well_Properties_Revisions_Variance_Fields>;
};


/** aggregate fields of "revisions.scenario_well_properties_revisions" */
export type Revisions_Scenario_Well_Properties_Revisions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Revisions_Scenario_Well_Properties_Revisions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "revisions.scenario_well_properties_revisions" */
export type Revisions_Scenario_Well_Properties_Revisions_Aggregate_Order_By = {
  avg?: InputMaybe<Revisions_Scenario_Well_Properties_Revisions_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Revisions_Scenario_Well_Properties_Revisions_Max_Order_By>;
  min?: InputMaybe<Revisions_Scenario_Well_Properties_Revisions_Min_Order_By>;
  stddev?: InputMaybe<Revisions_Scenario_Well_Properties_Revisions_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Revisions_Scenario_Well_Properties_Revisions_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Revisions_Scenario_Well_Properties_Revisions_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Revisions_Scenario_Well_Properties_Revisions_Sum_Order_By>;
  var_pop?: InputMaybe<Revisions_Scenario_Well_Properties_Revisions_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Revisions_Scenario_Well_Properties_Revisions_Var_Samp_Order_By>;
  variance?: InputMaybe<Revisions_Scenario_Well_Properties_Revisions_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Revisions_Scenario_Well_Properties_Revisions_Append_Input = {
  custom_fluid_properties?: InputMaybe<Scalars['jsonb']['input']>;
  custom_viscosities_properties?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "revisions.scenario_well_properties_revisions" */
export type Revisions_Scenario_Well_Properties_Revisions_Arr_Rel_Insert_Input = {
  data: Array<Revisions_Scenario_Well_Properties_Revisions_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Revisions_Scenario_Well_Properties_Revisions_On_Conflict>;
};

/** aggregate avg on columns */
export type Revisions_Scenario_Well_Properties_Revisions_Avg_Fields = {
  __typename: 'revisions_scenario_well_properties_revisions_avg_fields';
  ar_percent?: Maybe<Scalars['Float']['output']>;
  average_dls?: Maybe<Scalars['Float']['output']>;
  bottom_casing_length_feet?: Maybe<Scalars['Float']['output']>;
  bottom_tubing_length_feet?: Maybe<Scalars['Float']['output']>;
  bottomhole_temperature_fahrenheit?: Maybe<Scalars['Float']['output']>;
  bubble_point_pressure_psia?: Maybe<Scalars['Float']['output']>;
  c1_methane_percent?: Maybe<Scalars['Float']['output']>;
  c2_ethane_percent?: Maybe<Scalars['Float']['output']>;
  c3_propane_percent?: Maybe<Scalars['Float']['output']>;
  c6_hexane_percent?: Maybe<Scalars['Float']['output']>;
  c7_heptane_percent?: Maybe<Scalars['Float']['output']>;
  co2_percent?: Maybe<Scalars['Float']['output']>;
  condensate_api_override?: Maybe<Scalars['Float']['output']>;
  dew_point_pressure_psia_override?: Maybe<Scalars['Float']['output']>;
  fluid_viscosity_override_cp?: Maybe<Scalars['Float']['output']>;
  gas_specific_gravity?: Maybe<Scalars['Float']['output']>;
  h2s_percent?: Maybe<Scalars['Float']['output']>;
  hps_pump_inlet_pressure_psia?: Maybe<Scalars['Float']['output']>;
  hps_pump_inlet_temperature_fahrenheit?: Maybe<Scalars['Float']['output']>;
  hps_required_discharge_pressure_psia?: Maybe<Scalars['Float']['output']>;
  ic4_isobutene_percent?: Maybe<Scalars['Float']['output']>;
  ic5_isopentane_percent?: Maybe<Scalars['Float']['output']>;
  n2_percent?: Maybe<Scalars['Float']['output']>;
  nc4_butane_percent?: Maybe<Scalars['Float']['output']>;
  nc5_bentane_percent?: Maybe<Scalars['Float']['output']>;
  npsha_ft?: Maybe<Scalars['Float']['output']>;
  o2_percent?: Maybe<Scalars['Float']['output']>;
  oil_gravity_api?: Maybe<Scalars['Float']['output']>;
  surface_temperature_fahrenheit?: Maybe<Scalars['Float']['output']>;
  top_casing_length_feet?: Maybe<Scalars['Float']['output']>;
  top_of_perforations_measured_depth_feet?: Maybe<Scalars['Float']['output']>;
  top_of_perforations_true_vertical_depth_feet?: Maybe<Scalars['Float']['output']>;
  top_tubing_length_feet?: Maybe<Scalars['Float']['output']>;
  water_specific_gravity?: Maybe<Scalars['Float']['output']>;
  well_test_datum_point_measured_depth_feet?: Maybe<Scalars['Float']['output']>;
  well_test_gas_rate_mscf_day?: Maybe<Scalars['Float']['output']>;
  well_test_oil_rate_stb_day?: Maybe<Scalars['Float']['output']>;
  well_test_producing_bottom_hole_pressure_psia?: Maybe<Scalars['Float']['output']>;
  well_test_productivity_index?: Maybe<Scalars['Float']['output']>;
  well_test_static_bottom_hole_pressure_psia?: Maybe<Scalars['Float']['output']>;
  well_test_water_rate_stb_day?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "revisions.scenario_well_properties_revisions" */
export type Revisions_Scenario_Well_Properties_Revisions_Avg_Order_By = {
  ar_percent?: InputMaybe<Order_By>;
  average_dls?: InputMaybe<Order_By>;
  bottom_casing_length_feet?: InputMaybe<Order_By>;
  bottom_tubing_length_feet?: InputMaybe<Order_By>;
  bottomhole_temperature_fahrenheit?: InputMaybe<Order_By>;
  bubble_point_pressure_psia?: InputMaybe<Order_By>;
  c1_methane_percent?: InputMaybe<Order_By>;
  c2_ethane_percent?: InputMaybe<Order_By>;
  c3_propane_percent?: InputMaybe<Order_By>;
  c6_hexane_percent?: InputMaybe<Order_By>;
  c7_heptane_percent?: InputMaybe<Order_By>;
  co2_percent?: InputMaybe<Order_By>;
  condensate_api_override?: InputMaybe<Order_By>;
  dew_point_pressure_psia_override?: InputMaybe<Order_By>;
  fluid_viscosity_override_cp?: InputMaybe<Order_By>;
  gas_specific_gravity?: InputMaybe<Order_By>;
  h2s_percent?: InputMaybe<Order_By>;
  hps_pump_inlet_pressure_psia?: InputMaybe<Order_By>;
  hps_pump_inlet_temperature_fahrenheit?: InputMaybe<Order_By>;
  hps_required_discharge_pressure_psia?: InputMaybe<Order_By>;
  ic4_isobutene_percent?: InputMaybe<Order_By>;
  ic5_isopentane_percent?: InputMaybe<Order_By>;
  n2_percent?: InputMaybe<Order_By>;
  nc4_butane_percent?: InputMaybe<Order_By>;
  nc5_bentane_percent?: InputMaybe<Order_By>;
  npsha_ft?: InputMaybe<Order_By>;
  o2_percent?: InputMaybe<Order_By>;
  oil_gravity_api?: InputMaybe<Order_By>;
  surface_temperature_fahrenheit?: InputMaybe<Order_By>;
  top_casing_length_feet?: InputMaybe<Order_By>;
  top_of_perforations_measured_depth_feet?: InputMaybe<Order_By>;
  top_of_perforations_true_vertical_depth_feet?: InputMaybe<Order_By>;
  top_tubing_length_feet?: InputMaybe<Order_By>;
  water_specific_gravity?: InputMaybe<Order_By>;
  well_test_datum_point_measured_depth_feet?: InputMaybe<Order_By>;
  well_test_gas_rate_mscf_day?: InputMaybe<Order_By>;
  well_test_oil_rate_stb_day?: InputMaybe<Order_By>;
  well_test_producing_bottom_hole_pressure_psia?: InputMaybe<Order_By>;
  well_test_productivity_index?: InputMaybe<Order_By>;
  well_test_static_bottom_hole_pressure_psia?: InputMaybe<Order_By>;
  well_test_water_rate_stb_day?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "revisions.scenario_well_properties_revisions". All fields are combined with a logical 'AND'. */
export type Revisions_Scenario_Well_Properties_Revisions_Bool_Exp = {
  _and?: InputMaybe<Array<Revisions_Scenario_Well_Properties_Revisions_Bool_Exp>>;
  _not?: InputMaybe<Revisions_Scenario_Well_Properties_Revisions_Bool_Exp>;
  _or?: InputMaybe<Array<Revisions_Scenario_Well_Properties_Revisions_Bool_Exp>>;
  ar_percent?: InputMaybe<Numeric_Comparison_Exp>;
  author_id?: InputMaybe<String_Comparison_Exp>;
  average_dls?: InputMaybe<Numeric_Comparison_Exp>;
  bottom_casing?: InputMaybe<Casings_Bool_Exp>;
  bottom_casing_id?: InputMaybe<Uuid_Comparison_Exp>;
  bottom_casing_length_feet?: InputMaybe<Numeric_Comparison_Exp>;
  bottom_tubing?: InputMaybe<Tubings_Bool_Exp>;
  bottom_tubing_id?: InputMaybe<Uuid_Comparison_Exp>;
  bottom_tubing_length_feet?: InputMaybe<Numeric_Comparison_Exp>;
  bottomhole_temperature_fahrenheit?: InputMaybe<Numeric_Comparison_Exp>;
  bubble_point_pressure_psia?: InputMaybe<Numeric_Comparison_Exp>;
  c1_methane_percent?: InputMaybe<Numeric_Comparison_Exp>;
  c2_ethane_percent?: InputMaybe<Numeric_Comparison_Exp>;
  c3_propane_percent?: InputMaybe<Numeric_Comparison_Exp>;
  c6_hexane_percent?: InputMaybe<Numeric_Comparison_Exp>;
  c7_heptane_percent?: InputMaybe<Numeric_Comparison_Exp>;
  cloned_from_journal_id?: InputMaybe<Uuid_Comparison_Exp>;
  co2_percent?: InputMaybe<Numeric_Comparison_Exp>;
  condensate_api_override?: InputMaybe<Numeric_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  custom_fluid_properties?: InputMaybe<Jsonb_Comparison_Exp>;
  custom_viscosities_properties?: InputMaybe<Jsonb_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deviation_survey?: InputMaybe<Deviation_Survey_Bool_Exp>;
  deviation_survey_id?: InputMaybe<Uuid_Comparison_Exp>;
  dew_point_pressure_psia_override?: InputMaybe<Numeric_Comparison_Exp>;
  fluid_viscosity_override_cp?: InputMaybe<Numeric_Comparison_Exp>;
  gas_specific_gravity?: InputMaybe<Numeric_Comparison_Exp>;
  gas_type?: InputMaybe<Well_Gas_Type_Options_Enum_Comparison_Exp>;
  h2s_percent?: InputMaybe<Numeric_Comparison_Exp>;
  hps_liquid_type?: InputMaybe<Hps_Liquid_Type_Enum_Comparison_Exp>;
  hps_pump_inlet_pressure_psia?: InputMaybe<Numeric_Comparison_Exp>;
  hps_pump_inlet_temperature_fahrenheit?: InputMaybe<Numeric_Comparison_Exp>;
  hps_required_discharge_pressure_psia?: InputMaybe<Numeric_Comparison_Exp>;
  ic4_isobutene_percent?: InputMaybe<Numeric_Comparison_Exp>;
  ic5_isopentane_percent?: InputMaybe<Numeric_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  journal_id?: InputMaybe<Uuid_Comparison_Exp>;
  n2_percent?: InputMaybe<Numeric_Comparison_Exp>;
  nc4_butane_percent?: InputMaybe<Numeric_Comparison_Exp>;
  nc5_bentane_percent?: InputMaybe<Numeric_Comparison_Exp>;
  npsha_ft?: InputMaybe<Numeric_Comparison_Exp>;
  o2_percent?: InputMaybe<Numeric_Comparison_Exp>;
  oil_gravity_api?: InputMaybe<Numeric_Comparison_Exp>;
  parent_revision_id?: InputMaybe<Uuid_Comparison_Exp>;
  scenario_well_properties_journal?: InputMaybe<Revisions_Scenario_Well_Properties_Journal_Bool_Exp>;
  scenario_well_properties_journals?: InputMaybe<Revisions_Scenario_Well_Properties_Journal_Bool_Exp>;
  scenario_well_properties_journals_aggregate?: InputMaybe<Revisions_Scenario_Well_Properties_Journal_Aggregate_Bool_Exp>;
  scenario_well_properties_revision?: InputMaybe<Revisions_Scenario_Well_Properties_Revisions_Bool_Exp>;
  scenario_well_properties_revisions?: InputMaybe<Revisions_Scenario_Well_Properties_Revisions_Bool_Exp>;
  scenario_well_properties_revisions_aggregate?: InputMaybe<Revisions_Scenario_Well_Properties_Revisions_Aggregate_Bool_Exp>;
  scenario_well_properties_view?: InputMaybe<Scenario_Well_Properties_Bool_Exp>;
  surface_temperature_fahrenheit?: InputMaybe<Numeric_Comparison_Exp>;
  top_casing?: InputMaybe<Casings_Bool_Exp>;
  top_casing_id?: InputMaybe<Uuid_Comparison_Exp>;
  top_casing_length_feet?: InputMaybe<Numeric_Comparison_Exp>;
  top_of_perforations_measured_depth_feet?: InputMaybe<Numeric_Comparison_Exp>;
  top_of_perforations_true_vertical_depth_feet?: InputMaybe<Numeric_Comparison_Exp>;
  top_tubing?: InputMaybe<Tubings_Bool_Exp>;
  top_tubing_id?: InputMaybe<Uuid_Comparison_Exp>;
  top_tubing_length_feet?: InputMaybe<Numeric_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  water_specific_gravity?: InputMaybe<Numeric_Comparison_Exp>;
  well_test_datum_point_measured_depth_feet?: InputMaybe<Numeric_Comparison_Exp>;
  well_test_gas_input_option?: InputMaybe<Well_Test_Gas_Input_Options_Bool_Exp>;
  well_test_gas_input_type?: InputMaybe<Well_Test_Gas_Input_Options_Enum_Comparison_Exp>;
  well_test_gas_rate_mscf_day?: InputMaybe<Numeric_Comparison_Exp>;
  well_test_liquid_input_option?: InputMaybe<Well_Test_Liquid_Input_Options_Bool_Exp>;
  well_test_liquid_input_type?: InputMaybe<Well_Test_Liquid_Input_Options_Enum_Comparison_Exp>;
  well_test_oil_rate_stb_day?: InputMaybe<Numeric_Comparison_Exp>;
  well_test_pressure_input_type?: InputMaybe<Well_Test_Pressure_Input_Options_Enum_Comparison_Exp>;
  well_test_producing_bottom_hole_pressure_psia?: InputMaybe<Numeric_Comparison_Exp>;
  well_test_productivity_index?: InputMaybe<Numeric_Comparison_Exp>;
  well_test_static_bottom_hole_pressure_psia?: InputMaybe<Numeric_Comparison_Exp>;
  well_test_test_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  well_test_water_rate_stb_day?: InputMaybe<Numeric_Comparison_Exp>;
};

/** unique or primary key constraints on table "revisions.scenario_well_properties_revisions" */
export enum Revisions_Scenario_Well_Properties_Revisions_Constraint {
  /** unique or primary key constraint on columns "id" */
  ScenarioWellPropertiesRevisionsPkey = 'scenario_well_properties_revisions_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Revisions_Scenario_Well_Properties_Revisions_Delete_At_Path_Input = {
  custom_fluid_properties?: InputMaybe<Array<Scalars['String']['input']>>;
  custom_viscosities_properties?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Revisions_Scenario_Well_Properties_Revisions_Delete_Elem_Input = {
  custom_fluid_properties?: InputMaybe<Scalars['Int']['input']>;
  custom_viscosities_properties?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Revisions_Scenario_Well_Properties_Revisions_Delete_Key_Input = {
  custom_fluid_properties?: InputMaybe<Scalars['String']['input']>;
  custom_viscosities_properties?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "revisions.scenario_well_properties_revisions" */
export type Revisions_Scenario_Well_Properties_Revisions_Inc_Input = {
  ar_percent?: InputMaybe<Scalars['numeric']['input']>;
  average_dls?: InputMaybe<Scalars['numeric']['input']>;
  bottom_casing_length_feet?: InputMaybe<Scalars['numeric']['input']>;
  bottom_tubing_length_feet?: InputMaybe<Scalars['numeric']['input']>;
  bottomhole_temperature_fahrenheit?: InputMaybe<Scalars['numeric']['input']>;
  bubble_point_pressure_psia?: InputMaybe<Scalars['numeric']['input']>;
  c1_methane_percent?: InputMaybe<Scalars['numeric']['input']>;
  c2_ethane_percent?: InputMaybe<Scalars['numeric']['input']>;
  c3_propane_percent?: InputMaybe<Scalars['numeric']['input']>;
  c6_hexane_percent?: InputMaybe<Scalars['numeric']['input']>;
  c7_heptane_percent?: InputMaybe<Scalars['numeric']['input']>;
  co2_percent?: InputMaybe<Scalars['numeric']['input']>;
  condensate_api_override?: InputMaybe<Scalars['numeric']['input']>;
  dew_point_pressure_psia_override?: InputMaybe<Scalars['numeric']['input']>;
  fluid_viscosity_override_cp?: InputMaybe<Scalars['numeric']['input']>;
  gas_specific_gravity?: InputMaybe<Scalars['numeric']['input']>;
  h2s_percent?: InputMaybe<Scalars['numeric']['input']>;
  hps_pump_inlet_pressure_psia?: InputMaybe<Scalars['numeric']['input']>;
  hps_pump_inlet_temperature_fahrenheit?: InputMaybe<Scalars['numeric']['input']>;
  hps_required_discharge_pressure_psia?: InputMaybe<Scalars['numeric']['input']>;
  ic4_isobutene_percent?: InputMaybe<Scalars['numeric']['input']>;
  ic5_isopentane_percent?: InputMaybe<Scalars['numeric']['input']>;
  n2_percent?: InputMaybe<Scalars['numeric']['input']>;
  nc4_butane_percent?: InputMaybe<Scalars['numeric']['input']>;
  nc5_bentane_percent?: InputMaybe<Scalars['numeric']['input']>;
  npsha_ft?: InputMaybe<Scalars['numeric']['input']>;
  o2_percent?: InputMaybe<Scalars['numeric']['input']>;
  oil_gravity_api?: InputMaybe<Scalars['numeric']['input']>;
  surface_temperature_fahrenheit?: InputMaybe<Scalars['numeric']['input']>;
  top_casing_length_feet?: InputMaybe<Scalars['numeric']['input']>;
  top_of_perforations_measured_depth_feet?: InputMaybe<Scalars['numeric']['input']>;
  top_of_perforations_true_vertical_depth_feet?: InputMaybe<Scalars['numeric']['input']>;
  top_tubing_length_feet?: InputMaybe<Scalars['numeric']['input']>;
  water_specific_gravity?: InputMaybe<Scalars['numeric']['input']>;
  well_test_datum_point_measured_depth_feet?: InputMaybe<Scalars['numeric']['input']>;
  well_test_gas_rate_mscf_day?: InputMaybe<Scalars['numeric']['input']>;
  well_test_oil_rate_stb_day?: InputMaybe<Scalars['numeric']['input']>;
  well_test_producing_bottom_hole_pressure_psia?: InputMaybe<Scalars['numeric']['input']>;
  well_test_productivity_index?: InputMaybe<Scalars['numeric']['input']>;
  well_test_static_bottom_hole_pressure_psia?: InputMaybe<Scalars['numeric']['input']>;
  well_test_water_rate_stb_day?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "revisions.scenario_well_properties_revisions" */
export type Revisions_Scenario_Well_Properties_Revisions_Insert_Input = {
  ar_percent?: InputMaybe<Scalars['numeric']['input']>;
  author_id?: InputMaybe<Scalars['String']['input']>;
  average_dls?: InputMaybe<Scalars['numeric']['input']>;
  bottom_casing?: InputMaybe<Casings_Obj_Rel_Insert_Input>;
  bottom_casing_id?: InputMaybe<Scalars['uuid']['input']>;
  bottom_casing_length_feet?: InputMaybe<Scalars['numeric']['input']>;
  bottom_tubing?: InputMaybe<Tubings_Obj_Rel_Insert_Input>;
  bottom_tubing_id?: InputMaybe<Scalars['uuid']['input']>;
  bottom_tubing_length_feet?: InputMaybe<Scalars['numeric']['input']>;
  bottomhole_temperature_fahrenheit?: InputMaybe<Scalars['numeric']['input']>;
  bubble_point_pressure_psia?: InputMaybe<Scalars['numeric']['input']>;
  c1_methane_percent?: InputMaybe<Scalars['numeric']['input']>;
  c2_ethane_percent?: InputMaybe<Scalars['numeric']['input']>;
  c3_propane_percent?: InputMaybe<Scalars['numeric']['input']>;
  c6_hexane_percent?: InputMaybe<Scalars['numeric']['input']>;
  c7_heptane_percent?: InputMaybe<Scalars['numeric']['input']>;
  cloned_from_journal_id?: InputMaybe<Scalars['uuid']['input']>;
  co2_percent?: InputMaybe<Scalars['numeric']['input']>;
  condensate_api_override?: InputMaybe<Scalars['numeric']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  custom_fluid_properties?: InputMaybe<Scalars['jsonb']['input']>;
  custom_viscosities_properties?: InputMaybe<Scalars['jsonb']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deviation_survey?: InputMaybe<Deviation_Survey_Obj_Rel_Insert_Input>;
  deviation_survey_id?: InputMaybe<Scalars['uuid']['input']>;
  dew_point_pressure_psia_override?: InputMaybe<Scalars['numeric']['input']>;
  fluid_viscosity_override_cp?: InputMaybe<Scalars['numeric']['input']>;
  gas_specific_gravity?: InputMaybe<Scalars['numeric']['input']>;
  gas_type?: InputMaybe<Well_Gas_Type_Options_Enum>;
  h2s_percent?: InputMaybe<Scalars['numeric']['input']>;
  hps_liquid_type?: InputMaybe<Hps_Liquid_Type_Enum>;
  hps_pump_inlet_pressure_psia?: InputMaybe<Scalars['numeric']['input']>;
  hps_pump_inlet_temperature_fahrenheit?: InputMaybe<Scalars['numeric']['input']>;
  hps_required_discharge_pressure_psia?: InputMaybe<Scalars['numeric']['input']>;
  ic4_isobutene_percent?: InputMaybe<Scalars['numeric']['input']>;
  ic5_isopentane_percent?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  journal_id?: InputMaybe<Scalars['uuid']['input']>;
  n2_percent?: InputMaybe<Scalars['numeric']['input']>;
  nc4_butane_percent?: InputMaybe<Scalars['numeric']['input']>;
  nc5_bentane_percent?: InputMaybe<Scalars['numeric']['input']>;
  npsha_ft?: InputMaybe<Scalars['numeric']['input']>;
  o2_percent?: InputMaybe<Scalars['numeric']['input']>;
  oil_gravity_api?: InputMaybe<Scalars['numeric']['input']>;
  parent_revision_id?: InputMaybe<Scalars['uuid']['input']>;
  scenario_well_properties_journal?: InputMaybe<Revisions_Scenario_Well_Properties_Journal_Obj_Rel_Insert_Input>;
  scenario_well_properties_journals?: InputMaybe<Revisions_Scenario_Well_Properties_Journal_Arr_Rel_Insert_Input>;
  scenario_well_properties_revision?: InputMaybe<Revisions_Scenario_Well_Properties_Revisions_Obj_Rel_Insert_Input>;
  scenario_well_properties_revisions?: InputMaybe<Revisions_Scenario_Well_Properties_Revisions_Arr_Rel_Insert_Input>;
  scenario_well_properties_view?: InputMaybe<Scenario_Well_Properties_Obj_Rel_Insert_Input>;
  surface_temperature_fahrenheit?: InputMaybe<Scalars['numeric']['input']>;
  top_casing?: InputMaybe<Casings_Obj_Rel_Insert_Input>;
  top_casing_id?: InputMaybe<Scalars['uuid']['input']>;
  top_casing_length_feet?: InputMaybe<Scalars['numeric']['input']>;
  top_of_perforations_measured_depth_feet?: InputMaybe<Scalars['numeric']['input']>;
  top_of_perforations_true_vertical_depth_feet?: InputMaybe<Scalars['numeric']['input']>;
  top_tubing?: InputMaybe<Tubings_Obj_Rel_Insert_Input>;
  top_tubing_id?: InputMaybe<Scalars['uuid']['input']>;
  top_tubing_length_feet?: InputMaybe<Scalars['numeric']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  water_specific_gravity?: InputMaybe<Scalars['numeric']['input']>;
  well_test_datum_point_measured_depth_feet?: InputMaybe<Scalars['numeric']['input']>;
  well_test_gas_input_option?: InputMaybe<Well_Test_Gas_Input_Options_Obj_Rel_Insert_Input>;
  well_test_gas_input_type?: InputMaybe<Well_Test_Gas_Input_Options_Enum>;
  well_test_gas_rate_mscf_day?: InputMaybe<Scalars['numeric']['input']>;
  well_test_liquid_input_option?: InputMaybe<Well_Test_Liquid_Input_Options_Obj_Rel_Insert_Input>;
  well_test_liquid_input_type?: InputMaybe<Well_Test_Liquid_Input_Options_Enum>;
  well_test_oil_rate_stb_day?: InputMaybe<Scalars['numeric']['input']>;
  well_test_pressure_input_type?: InputMaybe<Well_Test_Pressure_Input_Options_Enum>;
  well_test_producing_bottom_hole_pressure_psia?: InputMaybe<Scalars['numeric']['input']>;
  well_test_productivity_index?: InputMaybe<Scalars['numeric']['input']>;
  well_test_static_bottom_hole_pressure_psia?: InputMaybe<Scalars['numeric']['input']>;
  well_test_test_date?: InputMaybe<Scalars['timestamptz']['input']>;
  well_test_water_rate_stb_day?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate max on columns */
export type Revisions_Scenario_Well_Properties_Revisions_Max_Fields = {
  __typename: 'revisions_scenario_well_properties_revisions_max_fields';
  ar_percent?: Maybe<Scalars['numeric']['output']>;
  author_id?: Maybe<Scalars['String']['output']>;
  average_dls?: Maybe<Scalars['numeric']['output']>;
  bottom_casing_id?: Maybe<Scalars['uuid']['output']>;
  bottom_casing_length_feet?: Maybe<Scalars['numeric']['output']>;
  bottom_tubing_id?: Maybe<Scalars['uuid']['output']>;
  bottom_tubing_length_feet?: Maybe<Scalars['numeric']['output']>;
  bottomhole_temperature_fahrenheit?: Maybe<Scalars['numeric']['output']>;
  bubble_point_pressure_psia?: Maybe<Scalars['numeric']['output']>;
  c1_methane_percent?: Maybe<Scalars['numeric']['output']>;
  c2_ethane_percent?: Maybe<Scalars['numeric']['output']>;
  c3_propane_percent?: Maybe<Scalars['numeric']['output']>;
  c6_hexane_percent?: Maybe<Scalars['numeric']['output']>;
  c7_heptane_percent?: Maybe<Scalars['numeric']['output']>;
  cloned_from_journal_id?: Maybe<Scalars['uuid']['output']>;
  co2_percent?: Maybe<Scalars['numeric']['output']>;
  condensate_api_override?: Maybe<Scalars['numeric']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  deviation_survey_id?: Maybe<Scalars['uuid']['output']>;
  dew_point_pressure_psia_override?: Maybe<Scalars['numeric']['output']>;
  fluid_viscosity_override_cp?: Maybe<Scalars['numeric']['output']>;
  gas_specific_gravity?: Maybe<Scalars['numeric']['output']>;
  h2s_percent?: Maybe<Scalars['numeric']['output']>;
  hps_pump_inlet_pressure_psia?: Maybe<Scalars['numeric']['output']>;
  hps_pump_inlet_temperature_fahrenheit?: Maybe<Scalars['numeric']['output']>;
  hps_required_discharge_pressure_psia?: Maybe<Scalars['numeric']['output']>;
  ic4_isobutene_percent?: Maybe<Scalars['numeric']['output']>;
  ic5_isopentane_percent?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  journal_id?: Maybe<Scalars['uuid']['output']>;
  n2_percent?: Maybe<Scalars['numeric']['output']>;
  nc4_butane_percent?: Maybe<Scalars['numeric']['output']>;
  nc5_bentane_percent?: Maybe<Scalars['numeric']['output']>;
  npsha_ft?: Maybe<Scalars['numeric']['output']>;
  o2_percent?: Maybe<Scalars['numeric']['output']>;
  oil_gravity_api?: Maybe<Scalars['numeric']['output']>;
  parent_revision_id?: Maybe<Scalars['uuid']['output']>;
  surface_temperature_fahrenheit?: Maybe<Scalars['numeric']['output']>;
  top_casing_id?: Maybe<Scalars['uuid']['output']>;
  top_casing_length_feet?: Maybe<Scalars['numeric']['output']>;
  top_of_perforations_measured_depth_feet?: Maybe<Scalars['numeric']['output']>;
  top_of_perforations_true_vertical_depth_feet?: Maybe<Scalars['numeric']['output']>;
  top_tubing_id?: Maybe<Scalars['uuid']['output']>;
  top_tubing_length_feet?: Maybe<Scalars['numeric']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  water_specific_gravity?: Maybe<Scalars['numeric']['output']>;
  well_test_datum_point_measured_depth_feet?: Maybe<Scalars['numeric']['output']>;
  well_test_gas_rate_mscf_day?: Maybe<Scalars['numeric']['output']>;
  well_test_oil_rate_stb_day?: Maybe<Scalars['numeric']['output']>;
  well_test_producing_bottom_hole_pressure_psia?: Maybe<Scalars['numeric']['output']>;
  well_test_productivity_index?: Maybe<Scalars['numeric']['output']>;
  well_test_static_bottom_hole_pressure_psia?: Maybe<Scalars['numeric']['output']>;
  well_test_test_date?: Maybe<Scalars['timestamptz']['output']>;
  well_test_water_rate_stb_day?: Maybe<Scalars['numeric']['output']>;
};

/** order by max() on columns of table "revisions.scenario_well_properties_revisions" */
export type Revisions_Scenario_Well_Properties_Revisions_Max_Order_By = {
  ar_percent?: InputMaybe<Order_By>;
  author_id?: InputMaybe<Order_By>;
  average_dls?: InputMaybe<Order_By>;
  bottom_casing_id?: InputMaybe<Order_By>;
  bottom_casing_length_feet?: InputMaybe<Order_By>;
  bottom_tubing_id?: InputMaybe<Order_By>;
  bottom_tubing_length_feet?: InputMaybe<Order_By>;
  bottomhole_temperature_fahrenheit?: InputMaybe<Order_By>;
  bubble_point_pressure_psia?: InputMaybe<Order_By>;
  c1_methane_percent?: InputMaybe<Order_By>;
  c2_ethane_percent?: InputMaybe<Order_By>;
  c3_propane_percent?: InputMaybe<Order_By>;
  c6_hexane_percent?: InputMaybe<Order_By>;
  c7_heptane_percent?: InputMaybe<Order_By>;
  cloned_from_journal_id?: InputMaybe<Order_By>;
  co2_percent?: InputMaybe<Order_By>;
  condensate_api_override?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  deviation_survey_id?: InputMaybe<Order_By>;
  dew_point_pressure_psia_override?: InputMaybe<Order_By>;
  fluid_viscosity_override_cp?: InputMaybe<Order_By>;
  gas_specific_gravity?: InputMaybe<Order_By>;
  h2s_percent?: InputMaybe<Order_By>;
  hps_pump_inlet_pressure_psia?: InputMaybe<Order_By>;
  hps_pump_inlet_temperature_fahrenheit?: InputMaybe<Order_By>;
  hps_required_discharge_pressure_psia?: InputMaybe<Order_By>;
  ic4_isobutene_percent?: InputMaybe<Order_By>;
  ic5_isopentane_percent?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  journal_id?: InputMaybe<Order_By>;
  n2_percent?: InputMaybe<Order_By>;
  nc4_butane_percent?: InputMaybe<Order_By>;
  nc5_bentane_percent?: InputMaybe<Order_By>;
  npsha_ft?: InputMaybe<Order_By>;
  o2_percent?: InputMaybe<Order_By>;
  oil_gravity_api?: InputMaybe<Order_By>;
  parent_revision_id?: InputMaybe<Order_By>;
  surface_temperature_fahrenheit?: InputMaybe<Order_By>;
  top_casing_id?: InputMaybe<Order_By>;
  top_casing_length_feet?: InputMaybe<Order_By>;
  top_of_perforations_measured_depth_feet?: InputMaybe<Order_By>;
  top_of_perforations_true_vertical_depth_feet?: InputMaybe<Order_By>;
  top_tubing_id?: InputMaybe<Order_By>;
  top_tubing_length_feet?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  water_specific_gravity?: InputMaybe<Order_By>;
  well_test_datum_point_measured_depth_feet?: InputMaybe<Order_By>;
  well_test_gas_rate_mscf_day?: InputMaybe<Order_By>;
  well_test_oil_rate_stb_day?: InputMaybe<Order_By>;
  well_test_producing_bottom_hole_pressure_psia?: InputMaybe<Order_By>;
  well_test_productivity_index?: InputMaybe<Order_By>;
  well_test_static_bottom_hole_pressure_psia?: InputMaybe<Order_By>;
  well_test_test_date?: InputMaybe<Order_By>;
  well_test_water_rate_stb_day?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Revisions_Scenario_Well_Properties_Revisions_Min_Fields = {
  __typename: 'revisions_scenario_well_properties_revisions_min_fields';
  ar_percent?: Maybe<Scalars['numeric']['output']>;
  author_id?: Maybe<Scalars['String']['output']>;
  average_dls?: Maybe<Scalars['numeric']['output']>;
  bottom_casing_id?: Maybe<Scalars['uuid']['output']>;
  bottom_casing_length_feet?: Maybe<Scalars['numeric']['output']>;
  bottom_tubing_id?: Maybe<Scalars['uuid']['output']>;
  bottom_tubing_length_feet?: Maybe<Scalars['numeric']['output']>;
  bottomhole_temperature_fahrenheit?: Maybe<Scalars['numeric']['output']>;
  bubble_point_pressure_psia?: Maybe<Scalars['numeric']['output']>;
  c1_methane_percent?: Maybe<Scalars['numeric']['output']>;
  c2_ethane_percent?: Maybe<Scalars['numeric']['output']>;
  c3_propane_percent?: Maybe<Scalars['numeric']['output']>;
  c6_hexane_percent?: Maybe<Scalars['numeric']['output']>;
  c7_heptane_percent?: Maybe<Scalars['numeric']['output']>;
  cloned_from_journal_id?: Maybe<Scalars['uuid']['output']>;
  co2_percent?: Maybe<Scalars['numeric']['output']>;
  condensate_api_override?: Maybe<Scalars['numeric']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  deviation_survey_id?: Maybe<Scalars['uuid']['output']>;
  dew_point_pressure_psia_override?: Maybe<Scalars['numeric']['output']>;
  fluid_viscosity_override_cp?: Maybe<Scalars['numeric']['output']>;
  gas_specific_gravity?: Maybe<Scalars['numeric']['output']>;
  h2s_percent?: Maybe<Scalars['numeric']['output']>;
  hps_pump_inlet_pressure_psia?: Maybe<Scalars['numeric']['output']>;
  hps_pump_inlet_temperature_fahrenheit?: Maybe<Scalars['numeric']['output']>;
  hps_required_discharge_pressure_psia?: Maybe<Scalars['numeric']['output']>;
  ic4_isobutene_percent?: Maybe<Scalars['numeric']['output']>;
  ic5_isopentane_percent?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  journal_id?: Maybe<Scalars['uuid']['output']>;
  n2_percent?: Maybe<Scalars['numeric']['output']>;
  nc4_butane_percent?: Maybe<Scalars['numeric']['output']>;
  nc5_bentane_percent?: Maybe<Scalars['numeric']['output']>;
  npsha_ft?: Maybe<Scalars['numeric']['output']>;
  o2_percent?: Maybe<Scalars['numeric']['output']>;
  oil_gravity_api?: Maybe<Scalars['numeric']['output']>;
  parent_revision_id?: Maybe<Scalars['uuid']['output']>;
  surface_temperature_fahrenheit?: Maybe<Scalars['numeric']['output']>;
  top_casing_id?: Maybe<Scalars['uuid']['output']>;
  top_casing_length_feet?: Maybe<Scalars['numeric']['output']>;
  top_of_perforations_measured_depth_feet?: Maybe<Scalars['numeric']['output']>;
  top_of_perforations_true_vertical_depth_feet?: Maybe<Scalars['numeric']['output']>;
  top_tubing_id?: Maybe<Scalars['uuid']['output']>;
  top_tubing_length_feet?: Maybe<Scalars['numeric']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  water_specific_gravity?: Maybe<Scalars['numeric']['output']>;
  well_test_datum_point_measured_depth_feet?: Maybe<Scalars['numeric']['output']>;
  well_test_gas_rate_mscf_day?: Maybe<Scalars['numeric']['output']>;
  well_test_oil_rate_stb_day?: Maybe<Scalars['numeric']['output']>;
  well_test_producing_bottom_hole_pressure_psia?: Maybe<Scalars['numeric']['output']>;
  well_test_productivity_index?: Maybe<Scalars['numeric']['output']>;
  well_test_static_bottom_hole_pressure_psia?: Maybe<Scalars['numeric']['output']>;
  well_test_test_date?: Maybe<Scalars['timestamptz']['output']>;
  well_test_water_rate_stb_day?: Maybe<Scalars['numeric']['output']>;
};

/** order by min() on columns of table "revisions.scenario_well_properties_revisions" */
export type Revisions_Scenario_Well_Properties_Revisions_Min_Order_By = {
  ar_percent?: InputMaybe<Order_By>;
  author_id?: InputMaybe<Order_By>;
  average_dls?: InputMaybe<Order_By>;
  bottom_casing_id?: InputMaybe<Order_By>;
  bottom_casing_length_feet?: InputMaybe<Order_By>;
  bottom_tubing_id?: InputMaybe<Order_By>;
  bottom_tubing_length_feet?: InputMaybe<Order_By>;
  bottomhole_temperature_fahrenheit?: InputMaybe<Order_By>;
  bubble_point_pressure_psia?: InputMaybe<Order_By>;
  c1_methane_percent?: InputMaybe<Order_By>;
  c2_ethane_percent?: InputMaybe<Order_By>;
  c3_propane_percent?: InputMaybe<Order_By>;
  c6_hexane_percent?: InputMaybe<Order_By>;
  c7_heptane_percent?: InputMaybe<Order_By>;
  cloned_from_journal_id?: InputMaybe<Order_By>;
  co2_percent?: InputMaybe<Order_By>;
  condensate_api_override?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  deviation_survey_id?: InputMaybe<Order_By>;
  dew_point_pressure_psia_override?: InputMaybe<Order_By>;
  fluid_viscosity_override_cp?: InputMaybe<Order_By>;
  gas_specific_gravity?: InputMaybe<Order_By>;
  h2s_percent?: InputMaybe<Order_By>;
  hps_pump_inlet_pressure_psia?: InputMaybe<Order_By>;
  hps_pump_inlet_temperature_fahrenheit?: InputMaybe<Order_By>;
  hps_required_discharge_pressure_psia?: InputMaybe<Order_By>;
  ic4_isobutene_percent?: InputMaybe<Order_By>;
  ic5_isopentane_percent?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  journal_id?: InputMaybe<Order_By>;
  n2_percent?: InputMaybe<Order_By>;
  nc4_butane_percent?: InputMaybe<Order_By>;
  nc5_bentane_percent?: InputMaybe<Order_By>;
  npsha_ft?: InputMaybe<Order_By>;
  o2_percent?: InputMaybe<Order_By>;
  oil_gravity_api?: InputMaybe<Order_By>;
  parent_revision_id?: InputMaybe<Order_By>;
  surface_temperature_fahrenheit?: InputMaybe<Order_By>;
  top_casing_id?: InputMaybe<Order_By>;
  top_casing_length_feet?: InputMaybe<Order_By>;
  top_of_perforations_measured_depth_feet?: InputMaybe<Order_By>;
  top_of_perforations_true_vertical_depth_feet?: InputMaybe<Order_By>;
  top_tubing_id?: InputMaybe<Order_By>;
  top_tubing_length_feet?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  water_specific_gravity?: InputMaybe<Order_By>;
  well_test_datum_point_measured_depth_feet?: InputMaybe<Order_By>;
  well_test_gas_rate_mscf_day?: InputMaybe<Order_By>;
  well_test_oil_rate_stb_day?: InputMaybe<Order_By>;
  well_test_producing_bottom_hole_pressure_psia?: InputMaybe<Order_By>;
  well_test_productivity_index?: InputMaybe<Order_By>;
  well_test_static_bottom_hole_pressure_psia?: InputMaybe<Order_By>;
  well_test_test_date?: InputMaybe<Order_By>;
  well_test_water_rate_stb_day?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "revisions.scenario_well_properties_revisions" */
export type Revisions_Scenario_Well_Properties_Revisions_Mutation_Response = {
  __typename: 'revisions_scenario_well_properties_revisions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Revisions_Scenario_Well_Properties_Revisions>;
};

/** input type for inserting object relation for remote table "revisions.scenario_well_properties_revisions" */
export type Revisions_Scenario_Well_Properties_Revisions_Obj_Rel_Insert_Input = {
  data: Revisions_Scenario_Well_Properties_Revisions_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Revisions_Scenario_Well_Properties_Revisions_On_Conflict>;
};

/** on_conflict condition type for table "revisions.scenario_well_properties_revisions" */
export type Revisions_Scenario_Well_Properties_Revisions_On_Conflict = {
  constraint: Revisions_Scenario_Well_Properties_Revisions_Constraint;
  update_columns?: Array<Revisions_Scenario_Well_Properties_Revisions_Update_Column>;
  where?: InputMaybe<Revisions_Scenario_Well_Properties_Revisions_Bool_Exp>;
};

/** Ordering options when selecting data from "revisions.scenario_well_properties_revisions". */
export type Revisions_Scenario_Well_Properties_Revisions_Order_By = {
  ar_percent?: InputMaybe<Order_By>;
  author_id?: InputMaybe<Order_By>;
  average_dls?: InputMaybe<Order_By>;
  bottom_casing?: InputMaybe<Casings_Order_By>;
  bottom_casing_id?: InputMaybe<Order_By>;
  bottom_casing_length_feet?: InputMaybe<Order_By>;
  bottom_tubing?: InputMaybe<Tubings_Order_By>;
  bottom_tubing_id?: InputMaybe<Order_By>;
  bottom_tubing_length_feet?: InputMaybe<Order_By>;
  bottomhole_temperature_fahrenheit?: InputMaybe<Order_By>;
  bubble_point_pressure_psia?: InputMaybe<Order_By>;
  c1_methane_percent?: InputMaybe<Order_By>;
  c2_ethane_percent?: InputMaybe<Order_By>;
  c3_propane_percent?: InputMaybe<Order_By>;
  c6_hexane_percent?: InputMaybe<Order_By>;
  c7_heptane_percent?: InputMaybe<Order_By>;
  cloned_from_journal_id?: InputMaybe<Order_By>;
  co2_percent?: InputMaybe<Order_By>;
  condensate_api_override?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  custom_fluid_properties?: InputMaybe<Order_By>;
  custom_viscosities_properties?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  deviation_survey?: InputMaybe<Deviation_Survey_Order_By>;
  deviation_survey_id?: InputMaybe<Order_By>;
  dew_point_pressure_psia_override?: InputMaybe<Order_By>;
  fluid_viscosity_override_cp?: InputMaybe<Order_By>;
  gas_specific_gravity?: InputMaybe<Order_By>;
  gas_type?: InputMaybe<Order_By>;
  h2s_percent?: InputMaybe<Order_By>;
  hps_liquid_type?: InputMaybe<Order_By>;
  hps_pump_inlet_pressure_psia?: InputMaybe<Order_By>;
  hps_pump_inlet_temperature_fahrenheit?: InputMaybe<Order_By>;
  hps_required_discharge_pressure_psia?: InputMaybe<Order_By>;
  ic4_isobutene_percent?: InputMaybe<Order_By>;
  ic5_isopentane_percent?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  journal_id?: InputMaybe<Order_By>;
  n2_percent?: InputMaybe<Order_By>;
  nc4_butane_percent?: InputMaybe<Order_By>;
  nc5_bentane_percent?: InputMaybe<Order_By>;
  npsha_ft?: InputMaybe<Order_By>;
  o2_percent?: InputMaybe<Order_By>;
  oil_gravity_api?: InputMaybe<Order_By>;
  parent_revision_id?: InputMaybe<Order_By>;
  scenario_well_properties_journal?: InputMaybe<Revisions_Scenario_Well_Properties_Journal_Order_By>;
  scenario_well_properties_journals_aggregate?: InputMaybe<Revisions_Scenario_Well_Properties_Journal_Aggregate_Order_By>;
  scenario_well_properties_revision?: InputMaybe<Revisions_Scenario_Well_Properties_Revisions_Order_By>;
  scenario_well_properties_revisions_aggregate?: InputMaybe<Revisions_Scenario_Well_Properties_Revisions_Aggregate_Order_By>;
  scenario_well_properties_view?: InputMaybe<Scenario_Well_Properties_Order_By>;
  surface_temperature_fahrenheit?: InputMaybe<Order_By>;
  top_casing?: InputMaybe<Casings_Order_By>;
  top_casing_id?: InputMaybe<Order_By>;
  top_casing_length_feet?: InputMaybe<Order_By>;
  top_of_perforations_measured_depth_feet?: InputMaybe<Order_By>;
  top_of_perforations_true_vertical_depth_feet?: InputMaybe<Order_By>;
  top_tubing?: InputMaybe<Tubings_Order_By>;
  top_tubing_id?: InputMaybe<Order_By>;
  top_tubing_length_feet?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  water_specific_gravity?: InputMaybe<Order_By>;
  well_test_datum_point_measured_depth_feet?: InputMaybe<Order_By>;
  well_test_gas_input_option?: InputMaybe<Well_Test_Gas_Input_Options_Order_By>;
  well_test_gas_input_type?: InputMaybe<Order_By>;
  well_test_gas_rate_mscf_day?: InputMaybe<Order_By>;
  well_test_liquid_input_option?: InputMaybe<Well_Test_Liquid_Input_Options_Order_By>;
  well_test_liquid_input_type?: InputMaybe<Order_By>;
  well_test_oil_rate_stb_day?: InputMaybe<Order_By>;
  well_test_pressure_input_type?: InputMaybe<Order_By>;
  well_test_producing_bottom_hole_pressure_psia?: InputMaybe<Order_By>;
  well_test_productivity_index?: InputMaybe<Order_By>;
  well_test_static_bottom_hole_pressure_psia?: InputMaybe<Order_By>;
  well_test_test_date?: InputMaybe<Order_By>;
  well_test_water_rate_stb_day?: InputMaybe<Order_By>;
};

/** primary key columns input for table: revisions.scenario_well_properties_revisions */
export type Revisions_Scenario_Well_Properties_Revisions_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Revisions_Scenario_Well_Properties_Revisions_Prepend_Input = {
  custom_fluid_properties?: InputMaybe<Scalars['jsonb']['input']>;
  custom_viscosities_properties?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "revisions.scenario_well_properties_revisions" */
export enum Revisions_Scenario_Well_Properties_Revisions_Select_Column {
  /** column name */
  ArPercent = 'ar_percent',
  /** column name */
  AuthorId = 'author_id',
  /** column name */
  AverageDls = 'average_dls',
  /** column name */
  BottomCasingId = 'bottom_casing_id',
  /** column name */
  BottomCasingLengthFeet = 'bottom_casing_length_feet',
  /** column name */
  BottomTubingId = 'bottom_tubing_id',
  /** column name */
  BottomTubingLengthFeet = 'bottom_tubing_length_feet',
  /** column name */
  BottomholeTemperatureFahrenheit = 'bottomhole_temperature_fahrenheit',
  /** column name */
  BubblePointPressurePsia = 'bubble_point_pressure_psia',
  /** column name */
  C1MethanePercent = 'c1_methane_percent',
  /** column name */
  C2EthanePercent = 'c2_ethane_percent',
  /** column name */
  C3PropanePercent = 'c3_propane_percent',
  /** column name */
  C6HexanePercent = 'c6_hexane_percent',
  /** column name */
  C7HeptanePercent = 'c7_heptane_percent',
  /** column name */
  ClonedFromJournalId = 'cloned_from_journal_id',
  /** column name */
  Co2Percent = 'co2_percent',
  /** column name */
  CondensateApiOverride = 'condensate_api_override',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CustomFluidProperties = 'custom_fluid_properties',
  /** column name */
  CustomViscositiesProperties = 'custom_viscosities_properties',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  DeviationSurveyId = 'deviation_survey_id',
  /** column name */
  DewPointPressurePsiaOverride = 'dew_point_pressure_psia_override',
  /** column name */
  FluidViscosityOverrideCp = 'fluid_viscosity_override_cp',
  /** column name */
  GasSpecificGravity = 'gas_specific_gravity',
  /** column name */
  GasType = 'gas_type',
  /** column name */
  H2sPercent = 'h2s_percent',
  /** column name */
  HpsLiquidType = 'hps_liquid_type',
  /** column name */
  HpsPumpInletPressurePsia = 'hps_pump_inlet_pressure_psia',
  /** column name */
  HpsPumpInletTemperatureFahrenheit = 'hps_pump_inlet_temperature_fahrenheit',
  /** column name */
  HpsRequiredDischargePressurePsia = 'hps_required_discharge_pressure_psia',
  /** column name */
  Ic4IsobutenePercent = 'ic4_isobutene_percent',
  /** column name */
  Ic5IsopentanePercent = 'ic5_isopentane_percent',
  /** column name */
  Id = 'id',
  /** column name */
  JournalId = 'journal_id',
  /** column name */
  N2Percent = 'n2_percent',
  /** column name */
  Nc4ButanePercent = 'nc4_butane_percent',
  /** column name */
  Nc5BentanePercent = 'nc5_bentane_percent',
  /** column name */
  NpshaFt = 'npsha_ft',
  /** column name */
  O2Percent = 'o2_percent',
  /** column name */
  OilGravityApi = 'oil_gravity_api',
  /** column name */
  ParentRevisionId = 'parent_revision_id',
  /** column name */
  SurfaceTemperatureFahrenheit = 'surface_temperature_fahrenheit',
  /** column name */
  TopCasingId = 'top_casing_id',
  /** column name */
  TopCasingLengthFeet = 'top_casing_length_feet',
  /** column name */
  TopOfPerforationsMeasuredDepthFeet = 'top_of_perforations_measured_depth_feet',
  /** column name */
  TopOfPerforationsTrueVerticalDepthFeet = 'top_of_perforations_true_vertical_depth_feet',
  /** column name */
  TopTubingId = 'top_tubing_id',
  /** column name */
  TopTubingLengthFeet = 'top_tubing_length_feet',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WaterSpecificGravity = 'water_specific_gravity',
  /** column name */
  WellTestDatumPointMeasuredDepthFeet = 'well_test_datum_point_measured_depth_feet',
  /** column name */
  WellTestGasInputType = 'well_test_gas_input_type',
  /** column name */
  WellTestGasRateMscfDay = 'well_test_gas_rate_mscf_day',
  /** column name */
  WellTestLiquidInputType = 'well_test_liquid_input_type',
  /** column name */
  WellTestOilRateStbDay = 'well_test_oil_rate_stb_day',
  /** column name */
  WellTestPressureInputType = 'well_test_pressure_input_type',
  /** column name */
  WellTestProducingBottomHolePressurePsia = 'well_test_producing_bottom_hole_pressure_psia',
  /** column name */
  WellTestProductivityIndex = 'well_test_productivity_index',
  /** column name */
  WellTestStaticBottomHolePressurePsia = 'well_test_static_bottom_hole_pressure_psia',
  /** column name */
  WellTestTestDate = 'well_test_test_date',
  /** column name */
  WellTestWaterRateStbDay = 'well_test_water_rate_stb_day'
}

/** input type for updating data in table "revisions.scenario_well_properties_revisions" */
export type Revisions_Scenario_Well_Properties_Revisions_Set_Input = {
  ar_percent?: InputMaybe<Scalars['numeric']['input']>;
  author_id?: InputMaybe<Scalars['String']['input']>;
  average_dls?: InputMaybe<Scalars['numeric']['input']>;
  bottom_casing_id?: InputMaybe<Scalars['uuid']['input']>;
  bottom_casing_length_feet?: InputMaybe<Scalars['numeric']['input']>;
  bottom_tubing_id?: InputMaybe<Scalars['uuid']['input']>;
  bottom_tubing_length_feet?: InputMaybe<Scalars['numeric']['input']>;
  bottomhole_temperature_fahrenheit?: InputMaybe<Scalars['numeric']['input']>;
  bubble_point_pressure_psia?: InputMaybe<Scalars['numeric']['input']>;
  c1_methane_percent?: InputMaybe<Scalars['numeric']['input']>;
  c2_ethane_percent?: InputMaybe<Scalars['numeric']['input']>;
  c3_propane_percent?: InputMaybe<Scalars['numeric']['input']>;
  c6_hexane_percent?: InputMaybe<Scalars['numeric']['input']>;
  c7_heptane_percent?: InputMaybe<Scalars['numeric']['input']>;
  cloned_from_journal_id?: InputMaybe<Scalars['uuid']['input']>;
  co2_percent?: InputMaybe<Scalars['numeric']['input']>;
  condensate_api_override?: InputMaybe<Scalars['numeric']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  custom_fluid_properties?: InputMaybe<Scalars['jsonb']['input']>;
  custom_viscosities_properties?: InputMaybe<Scalars['jsonb']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deviation_survey_id?: InputMaybe<Scalars['uuid']['input']>;
  dew_point_pressure_psia_override?: InputMaybe<Scalars['numeric']['input']>;
  fluid_viscosity_override_cp?: InputMaybe<Scalars['numeric']['input']>;
  gas_specific_gravity?: InputMaybe<Scalars['numeric']['input']>;
  gas_type?: InputMaybe<Well_Gas_Type_Options_Enum>;
  h2s_percent?: InputMaybe<Scalars['numeric']['input']>;
  hps_liquid_type?: InputMaybe<Hps_Liquid_Type_Enum>;
  hps_pump_inlet_pressure_psia?: InputMaybe<Scalars['numeric']['input']>;
  hps_pump_inlet_temperature_fahrenheit?: InputMaybe<Scalars['numeric']['input']>;
  hps_required_discharge_pressure_psia?: InputMaybe<Scalars['numeric']['input']>;
  ic4_isobutene_percent?: InputMaybe<Scalars['numeric']['input']>;
  ic5_isopentane_percent?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  journal_id?: InputMaybe<Scalars['uuid']['input']>;
  n2_percent?: InputMaybe<Scalars['numeric']['input']>;
  nc4_butane_percent?: InputMaybe<Scalars['numeric']['input']>;
  nc5_bentane_percent?: InputMaybe<Scalars['numeric']['input']>;
  npsha_ft?: InputMaybe<Scalars['numeric']['input']>;
  o2_percent?: InputMaybe<Scalars['numeric']['input']>;
  oil_gravity_api?: InputMaybe<Scalars['numeric']['input']>;
  parent_revision_id?: InputMaybe<Scalars['uuid']['input']>;
  surface_temperature_fahrenheit?: InputMaybe<Scalars['numeric']['input']>;
  top_casing_id?: InputMaybe<Scalars['uuid']['input']>;
  top_casing_length_feet?: InputMaybe<Scalars['numeric']['input']>;
  top_of_perforations_measured_depth_feet?: InputMaybe<Scalars['numeric']['input']>;
  top_of_perforations_true_vertical_depth_feet?: InputMaybe<Scalars['numeric']['input']>;
  top_tubing_id?: InputMaybe<Scalars['uuid']['input']>;
  top_tubing_length_feet?: InputMaybe<Scalars['numeric']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  water_specific_gravity?: InputMaybe<Scalars['numeric']['input']>;
  well_test_datum_point_measured_depth_feet?: InputMaybe<Scalars['numeric']['input']>;
  well_test_gas_input_type?: InputMaybe<Well_Test_Gas_Input_Options_Enum>;
  well_test_gas_rate_mscf_day?: InputMaybe<Scalars['numeric']['input']>;
  well_test_liquid_input_type?: InputMaybe<Well_Test_Liquid_Input_Options_Enum>;
  well_test_oil_rate_stb_day?: InputMaybe<Scalars['numeric']['input']>;
  well_test_pressure_input_type?: InputMaybe<Well_Test_Pressure_Input_Options_Enum>;
  well_test_producing_bottom_hole_pressure_psia?: InputMaybe<Scalars['numeric']['input']>;
  well_test_productivity_index?: InputMaybe<Scalars['numeric']['input']>;
  well_test_static_bottom_hole_pressure_psia?: InputMaybe<Scalars['numeric']['input']>;
  well_test_test_date?: InputMaybe<Scalars['timestamptz']['input']>;
  well_test_water_rate_stb_day?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate stddev on columns */
export type Revisions_Scenario_Well_Properties_Revisions_Stddev_Fields = {
  __typename: 'revisions_scenario_well_properties_revisions_stddev_fields';
  ar_percent?: Maybe<Scalars['Float']['output']>;
  average_dls?: Maybe<Scalars['Float']['output']>;
  bottom_casing_length_feet?: Maybe<Scalars['Float']['output']>;
  bottom_tubing_length_feet?: Maybe<Scalars['Float']['output']>;
  bottomhole_temperature_fahrenheit?: Maybe<Scalars['Float']['output']>;
  bubble_point_pressure_psia?: Maybe<Scalars['Float']['output']>;
  c1_methane_percent?: Maybe<Scalars['Float']['output']>;
  c2_ethane_percent?: Maybe<Scalars['Float']['output']>;
  c3_propane_percent?: Maybe<Scalars['Float']['output']>;
  c6_hexane_percent?: Maybe<Scalars['Float']['output']>;
  c7_heptane_percent?: Maybe<Scalars['Float']['output']>;
  co2_percent?: Maybe<Scalars['Float']['output']>;
  condensate_api_override?: Maybe<Scalars['Float']['output']>;
  dew_point_pressure_psia_override?: Maybe<Scalars['Float']['output']>;
  fluid_viscosity_override_cp?: Maybe<Scalars['Float']['output']>;
  gas_specific_gravity?: Maybe<Scalars['Float']['output']>;
  h2s_percent?: Maybe<Scalars['Float']['output']>;
  hps_pump_inlet_pressure_psia?: Maybe<Scalars['Float']['output']>;
  hps_pump_inlet_temperature_fahrenheit?: Maybe<Scalars['Float']['output']>;
  hps_required_discharge_pressure_psia?: Maybe<Scalars['Float']['output']>;
  ic4_isobutene_percent?: Maybe<Scalars['Float']['output']>;
  ic5_isopentane_percent?: Maybe<Scalars['Float']['output']>;
  n2_percent?: Maybe<Scalars['Float']['output']>;
  nc4_butane_percent?: Maybe<Scalars['Float']['output']>;
  nc5_bentane_percent?: Maybe<Scalars['Float']['output']>;
  npsha_ft?: Maybe<Scalars['Float']['output']>;
  o2_percent?: Maybe<Scalars['Float']['output']>;
  oil_gravity_api?: Maybe<Scalars['Float']['output']>;
  surface_temperature_fahrenheit?: Maybe<Scalars['Float']['output']>;
  top_casing_length_feet?: Maybe<Scalars['Float']['output']>;
  top_of_perforations_measured_depth_feet?: Maybe<Scalars['Float']['output']>;
  top_of_perforations_true_vertical_depth_feet?: Maybe<Scalars['Float']['output']>;
  top_tubing_length_feet?: Maybe<Scalars['Float']['output']>;
  water_specific_gravity?: Maybe<Scalars['Float']['output']>;
  well_test_datum_point_measured_depth_feet?: Maybe<Scalars['Float']['output']>;
  well_test_gas_rate_mscf_day?: Maybe<Scalars['Float']['output']>;
  well_test_oil_rate_stb_day?: Maybe<Scalars['Float']['output']>;
  well_test_producing_bottom_hole_pressure_psia?: Maybe<Scalars['Float']['output']>;
  well_test_productivity_index?: Maybe<Scalars['Float']['output']>;
  well_test_static_bottom_hole_pressure_psia?: Maybe<Scalars['Float']['output']>;
  well_test_water_rate_stb_day?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "revisions.scenario_well_properties_revisions" */
export type Revisions_Scenario_Well_Properties_Revisions_Stddev_Order_By = {
  ar_percent?: InputMaybe<Order_By>;
  average_dls?: InputMaybe<Order_By>;
  bottom_casing_length_feet?: InputMaybe<Order_By>;
  bottom_tubing_length_feet?: InputMaybe<Order_By>;
  bottomhole_temperature_fahrenheit?: InputMaybe<Order_By>;
  bubble_point_pressure_psia?: InputMaybe<Order_By>;
  c1_methane_percent?: InputMaybe<Order_By>;
  c2_ethane_percent?: InputMaybe<Order_By>;
  c3_propane_percent?: InputMaybe<Order_By>;
  c6_hexane_percent?: InputMaybe<Order_By>;
  c7_heptane_percent?: InputMaybe<Order_By>;
  co2_percent?: InputMaybe<Order_By>;
  condensate_api_override?: InputMaybe<Order_By>;
  dew_point_pressure_psia_override?: InputMaybe<Order_By>;
  fluid_viscosity_override_cp?: InputMaybe<Order_By>;
  gas_specific_gravity?: InputMaybe<Order_By>;
  h2s_percent?: InputMaybe<Order_By>;
  hps_pump_inlet_pressure_psia?: InputMaybe<Order_By>;
  hps_pump_inlet_temperature_fahrenheit?: InputMaybe<Order_By>;
  hps_required_discharge_pressure_psia?: InputMaybe<Order_By>;
  ic4_isobutene_percent?: InputMaybe<Order_By>;
  ic5_isopentane_percent?: InputMaybe<Order_By>;
  n2_percent?: InputMaybe<Order_By>;
  nc4_butane_percent?: InputMaybe<Order_By>;
  nc5_bentane_percent?: InputMaybe<Order_By>;
  npsha_ft?: InputMaybe<Order_By>;
  o2_percent?: InputMaybe<Order_By>;
  oil_gravity_api?: InputMaybe<Order_By>;
  surface_temperature_fahrenheit?: InputMaybe<Order_By>;
  top_casing_length_feet?: InputMaybe<Order_By>;
  top_of_perforations_measured_depth_feet?: InputMaybe<Order_By>;
  top_of_perforations_true_vertical_depth_feet?: InputMaybe<Order_By>;
  top_tubing_length_feet?: InputMaybe<Order_By>;
  water_specific_gravity?: InputMaybe<Order_By>;
  well_test_datum_point_measured_depth_feet?: InputMaybe<Order_By>;
  well_test_gas_rate_mscf_day?: InputMaybe<Order_By>;
  well_test_oil_rate_stb_day?: InputMaybe<Order_By>;
  well_test_producing_bottom_hole_pressure_psia?: InputMaybe<Order_By>;
  well_test_productivity_index?: InputMaybe<Order_By>;
  well_test_static_bottom_hole_pressure_psia?: InputMaybe<Order_By>;
  well_test_water_rate_stb_day?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Revisions_Scenario_Well_Properties_Revisions_Stddev_Pop_Fields = {
  __typename: 'revisions_scenario_well_properties_revisions_stddev_pop_fields';
  ar_percent?: Maybe<Scalars['Float']['output']>;
  average_dls?: Maybe<Scalars['Float']['output']>;
  bottom_casing_length_feet?: Maybe<Scalars['Float']['output']>;
  bottom_tubing_length_feet?: Maybe<Scalars['Float']['output']>;
  bottomhole_temperature_fahrenheit?: Maybe<Scalars['Float']['output']>;
  bubble_point_pressure_psia?: Maybe<Scalars['Float']['output']>;
  c1_methane_percent?: Maybe<Scalars['Float']['output']>;
  c2_ethane_percent?: Maybe<Scalars['Float']['output']>;
  c3_propane_percent?: Maybe<Scalars['Float']['output']>;
  c6_hexane_percent?: Maybe<Scalars['Float']['output']>;
  c7_heptane_percent?: Maybe<Scalars['Float']['output']>;
  co2_percent?: Maybe<Scalars['Float']['output']>;
  condensate_api_override?: Maybe<Scalars['Float']['output']>;
  dew_point_pressure_psia_override?: Maybe<Scalars['Float']['output']>;
  fluid_viscosity_override_cp?: Maybe<Scalars['Float']['output']>;
  gas_specific_gravity?: Maybe<Scalars['Float']['output']>;
  h2s_percent?: Maybe<Scalars['Float']['output']>;
  hps_pump_inlet_pressure_psia?: Maybe<Scalars['Float']['output']>;
  hps_pump_inlet_temperature_fahrenheit?: Maybe<Scalars['Float']['output']>;
  hps_required_discharge_pressure_psia?: Maybe<Scalars['Float']['output']>;
  ic4_isobutene_percent?: Maybe<Scalars['Float']['output']>;
  ic5_isopentane_percent?: Maybe<Scalars['Float']['output']>;
  n2_percent?: Maybe<Scalars['Float']['output']>;
  nc4_butane_percent?: Maybe<Scalars['Float']['output']>;
  nc5_bentane_percent?: Maybe<Scalars['Float']['output']>;
  npsha_ft?: Maybe<Scalars['Float']['output']>;
  o2_percent?: Maybe<Scalars['Float']['output']>;
  oil_gravity_api?: Maybe<Scalars['Float']['output']>;
  surface_temperature_fahrenheit?: Maybe<Scalars['Float']['output']>;
  top_casing_length_feet?: Maybe<Scalars['Float']['output']>;
  top_of_perforations_measured_depth_feet?: Maybe<Scalars['Float']['output']>;
  top_of_perforations_true_vertical_depth_feet?: Maybe<Scalars['Float']['output']>;
  top_tubing_length_feet?: Maybe<Scalars['Float']['output']>;
  water_specific_gravity?: Maybe<Scalars['Float']['output']>;
  well_test_datum_point_measured_depth_feet?: Maybe<Scalars['Float']['output']>;
  well_test_gas_rate_mscf_day?: Maybe<Scalars['Float']['output']>;
  well_test_oil_rate_stb_day?: Maybe<Scalars['Float']['output']>;
  well_test_producing_bottom_hole_pressure_psia?: Maybe<Scalars['Float']['output']>;
  well_test_productivity_index?: Maybe<Scalars['Float']['output']>;
  well_test_static_bottom_hole_pressure_psia?: Maybe<Scalars['Float']['output']>;
  well_test_water_rate_stb_day?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "revisions.scenario_well_properties_revisions" */
export type Revisions_Scenario_Well_Properties_Revisions_Stddev_Pop_Order_By = {
  ar_percent?: InputMaybe<Order_By>;
  average_dls?: InputMaybe<Order_By>;
  bottom_casing_length_feet?: InputMaybe<Order_By>;
  bottom_tubing_length_feet?: InputMaybe<Order_By>;
  bottomhole_temperature_fahrenheit?: InputMaybe<Order_By>;
  bubble_point_pressure_psia?: InputMaybe<Order_By>;
  c1_methane_percent?: InputMaybe<Order_By>;
  c2_ethane_percent?: InputMaybe<Order_By>;
  c3_propane_percent?: InputMaybe<Order_By>;
  c6_hexane_percent?: InputMaybe<Order_By>;
  c7_heptane_percent?: InputMaybe<Order_By>;
  co2_percent?: InputMaybe<Order_By>;
  condensate_api_override?: InputMaybe<Order_By>;
  dew_point_pressure_psia_override?: InputMaybe<Order_By>;
  fluid_viscosity_override_cp?: InputMaybe<Order_By>;
  gas_specific_gravity?: InputMaybe<Order_By>;
  h2s_percent?: InputMaybe<Order_By>;
  hps_pump_inlet_pressure_psia?: InputMaybe<Order_By>;
  hps_pump_inlet_temperature_fahrenheit?: InputMaybe<Order_By>;
  hps_required_discharge_pressure_psia?: InputMaybe<Order_By>;
  ic4_isobutene_percent?: InputMaybe<Order_By>;
  ic5_isopentane_percent?: InputMaybe<Order_By>;
  n2_percent?: InputMaybe<Order_By>;
  nc4_butane_percent?: InputMaybe<Order_By>;
  nc5_bentane_percent?: InputMaybe<Order_By>;
  npsha_ft?: InputMaybe<Order_By>;
  o2_percent?: InputMaybe<Order_By>;
  oil_gravity_api?: InputMaybe<Order_By>;
  surface_temperature_fahrenheit?: InputMaybe<Order_By>;
  top_casing_length_feet?: InputMaybe<Order_By>;
  top_of_perforations_measured_depth_feet?: InputMaybe<Order_By>;
  top_of_perforations_true_vertical_depth_feet?: InputMaybe<Order_By>;
  top_tubing_length_feet?: InputMaybe<Order_By>;
  water_specific_gravity?: InputMaybe<Order_By>;
  well_test_datum_point_measured_depth_feet?: InputMaybe<Order_By>;
  well_test_gas_rate_mscf_day?: InputMaybe<Order_By>;
  well_test_oil_rate_stb_day?: InputMaybe<Order_By>;
  well_test_producing_bottom_hole_pressure_psia?: InputMaybe<Order_By>;
  well_test_productivity_index?: InputMaybe<Order_By>;
  well_test_static_bottom_hole_pressure_psia?: InputMaybe<Order_By>;
  well_test_water_rate_stb_day?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Revisions_Scenario_Well_Properties_Revisions_Stddev_Samp_Fields = {
  __typename: 'revisions_scenario_well_properties_revisions_stddev_samp_fields';
  ar_percent?: Maybe<Scalars['Float']['output']>;
  average_dls?: Maybe<Scalars['Float']['output']>;
  bottom_casing_length_feet?: Maybe<Scalars['Float']['output']>;
  bottom_tubing_length_feet?: Maybe<Scalars['Float']['output']>;
  bottomhole_temperature_fahrenheit?: Maybe<Scalars['Float']['output']>;
  bubble_point_pressure_psia?: Maybe<Scalars['Float']['output']>;
  c1_methane_percent?: Maybe<Scalars['Float']['output']>;
  c2_ethane_percent?: Maybe<Scalars['Float']['output']>;
  c3_propane_percent?: Maybe<Scalars['Float']['output']>;
  c6_hexane_percent?: Maybe<Scalars['Float']['output']>;
  c7_heptane_percent?: Maybe<Scalars['Float']['output']>;
  co2_percent?: Maybe<Scalars['Float']['output']>;
  condensate_api_override?: Maybe<Scalars['Float']['output']>;
  dew_point_pressure_psia_override?: Maybe<Scalars['Float']['output']>;
  fluid_viscosity_override_cp?: Maybe<Scalars['Float']['output']>;
  gas_specific_gravity?: Maybe<Scalars['Float']['output']>;
  h2s_percent?: Maybe<Scalars['Float']['output']>;
  hps_pump_inlet_pressure_psia?: Maybe<Scalars['Float']['output']>;
  hps_pump_inlet_temperature_fahrenheit?: Maybe<Scalars['Float']['output']>;
  hps_required_discharge_pressure_psia?: Maybe<Scalars['Float']['output']>;
  ic4_isobutene_percent?: Maybe<Scalars['Float']['output']>;
  ic5_isopentane_percent?: Maybe<Scalars['Float']['output']>;
  n2_percent?: Maybe<Scalars['Float']['output']>;
  nc4_butane_percent?: Maybe<Scalars['Float']['output']>;
  nc5_bentane_percent?: Maybe<Scalars['Float']['output']>;
  npsha_ft?: Maybe<Scalars['Float']['output']>;
  o2_percent?: Maybe<Scalars['Float']['output']>;
  oil_gravity_api?: Maybe<Scalars['Float']['output']>;
  surface_temperature_fahrenheit?: Maybe<Scalars['Float']['output']>;
  top_casing_length_feet?: Maybe<Scalars['Float']['output']>;
  top_of_perforations_measured_depth_feet?: Maybe<Scalars['Float']['output']>;
  top_of_perforations_true_vertical_depth_feet?: Maybe<Scalars['Float']['output']>;
  top_tubing_length_feet?: Maybe<Scalars['Float']['output']>;
  water_specific_gravity?: Maybe<Scalars['Float']['output']>;
  well_test_datum_point_measured_depth_feet?: Maybe<Scalars['Float']['output']>;
  well_test_gas_rate_mscf_day?: Maybe<Scalars['Float']['output']>;
  well_test_oil_rate_stb_day?: Maybe<Scalars['Float']['output']>;
  well_test_producing_bottom_hole_pressure_psia?: Maybe<Scalars['Float']['output']>;
  well_test_productivity_index?: Maybe<Scalars['Float']['output']>;
  well_test_static_bottom_hole_pressure_psia?: Maybe<Scalars['Float']['output']>;
  well_test_water_rate_stb_day?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "revisions.scenario_well_properties_revisions" */
export type Revisions_Scenario_Well_Properties_Revisions_Stddev_Samp_Order_By = {
  ar_percent?: InputMaybe<Order_By>;
  average_dls?: InputMaybe<Order_By>;
  bottom_casing_length_feet?: InputMaybe<Order_By>;
  bottom_tubing_length_feet?: InputMaybe<Order_By>;
  bottomhole_temperature_fahrenheit?: InputMaybe<Order_By>;
  bubble_point_pressure_psia?: InputMaybe<Order_By>;
  c1_methane_percent?: InputMaybe<Order_By>;
  c2_ethane_percent?: InputMaybe<Order_By>;
  c3_propane_percent?: InputMaybe<Order_By>;
  c6_hexane_percent?: InputMaybe<Order_By>;
  c7_heptane_percent?: InputMaybe<Order_By>;
  co2_percent?: InputMaybe<Order_By>;
  condensate_api_override?: InputMaybe<Order_By>;
  dew_point_pressure_psia_override?: InputMaybe<Order_By>;
  fluid_viscosity_override_cp?: InputMaybe<Order_By>;
  gas_specific_gravity?: InputMaybe<Order_By>;
  h2s_percent?: InputMaybe<Order_By>;
  hps_pump_inlet_pressure_psia?: InputMaybe<Order_By>;
  hps_pump_inlet_temperature_fahrenheit?: InputMaybe<Order_By>;
  hps_required_discharge_pressure_psia?: InputMaybe<Order_By>;
  ic4_isobutene_percent?: InputMaybe<Order_By>;
  ic5_isopentane_percent?: InputMaybe<Order_By>;
  n2_percent?: InputMaybe<Order_By>;
  nc4_butane_percent?: InputMaybe<Order_By>;
  nc5_bentane_percent?: InputMaybe<Order_By>;
  npsha_ft?: InputMaybe<Order_By>;
  o2_percent?: InputMaybe<Order_By>;
  oil_gravity_api?: InputMaybe<Order_By>;
  surface_temperature_fahrenheit?: InputMaybe<Order_By>;
  top_casing_length_feet?: InputMaybe<Order_By>;
  top_of_perforations_measured_depth_feet?: InputMaybe<Order_By>;
  top_of_perforations_true_vertical_depth_feet?: InputMaybe<Order_By>;
  top_tubing_length_feet?: InputMaybe<Order_By>;
  water_specific_gravity?: InputMaybe<Order_By>;
  well_test_datum_point_measured_depth_feet?: InputMaybe<Order_By>;
  well_test_gas_rate_mscf_day?: InputMaybe<Order_By>;
  well_test_oil_rate_stb_day?: InputMaybe<Order_By>;
  well_test_producing_bottom_hole_pressure_psia?: InputMaybe<Order_By>;
  well_test_productivity_index?: InputMaybe<Order_By>;
  well_test_static_bottom_hole_pressure_psia?: InputMaybe<Order_By>;
  well_test_water_rate_stb_day?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "revisions_scenario_well_properties_revisions" */
export type Revisions_Scenario_Well_Properties_Revisions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Revisions_Scenario_Well_Properties_Revisions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Revisions_Scenario_Well_Properties_Revisions_Stream_Cursor_Value_Input = {
  ar_percent?: InputMaybe<Scalars['numeric']['input']>;
  author_id?: InputMaybe<Scalars['String']['input']>;
  average_dls?: InputMaybe<Scalars['numeric']['input']>;
  bottom_casing_id?: InputMaybe<Scalars['uuid']['input']>;
  bottom_casing_length_feet?: InputMaybe<Scalars['numeric']['input']>;
  bottom_tubing_id?: InputMaybe<Scalars['uuid']['input']>;
  bottom_tubing_length_feet?: InputMaybe<Scalars['numeric']['input']>;
  bottomhole_temperature_fahrenheit?: InputMaybe<Scalars['numeric']['input']>;
  bubble_point_pressure_psia?: InputMaybe<Scalars['numeric']['input']>;
  c1_methane_percent?: InputMaybe<Scalars['numeric']['input']>;
  c2_ethane_percent?: InputMaybe<Scalars['numeric']['input']>;
  c3_propane_percent?: InputMaybe<Scalars['numeric']['input']>;
  c6_hexane_percent?: InputMaybe<Scalars['numeric']['input']>;
  c7_heptane_percent?: InputMaybe<Scalars['numeric']['input']>;
  cloned_from_journal_id?: InputMaybe<Scalars['uuid']['input']>;
  co2_percent?: InputMaybe<Scalars['numeric']['input']>;
  condensate_api_override?: InputMaybe<Scalars['numeric']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  custom_fluid_properties?: InputMaybe<Scalars['jsonb']['input']>;
  custom_viscosities_properties?: InputMaybe<Scalars['jsonb']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deviation_survey_id?: InputMaybe<Scalars['uuid']['input']>;
  dew_point_pressure_psia_override?: InputMaybe<Scalars['numeric']['input']>;
  fluid_viscosity_override_cp?: InputMaybe<Scalars['numeric']['input']>;
  gas_specific_gravity?: InputMaybe<Scalars['numeric']['input']>;
  gas_type?: InputMaybe<Well_Gas_Type_Options_Enum>;
  h2s_percent?: InputMaybe<Scalars['numeric']['input']>;
  hps_liquid_type?: InputMaybe<Hps_Liquid_Type_Enum>;
  hps_pump_inlet_pressure_psia?: InputMaybe<Scalars['numeric']['input']>;
  hps_pump_inlet_temperature_fahrenheit?: InputMaybe<Scalars['numeric']['input']>;
  hps_required_discharge_pressure_psia?: InputMaybe<Scalars['numeric']['input']>;
  ic4_isobutene_percent?: InputMaybe<Scalars['numeric']['input']>;
  ic5_isopentane_percent?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  journal_id?: InputMaybe<Scalars['uuid']['input']>;
  n2_percent?: InputMaybe<Scalars['numeric']['input']>;
  nc4_butane_percent?: InputMaybe<Scalars['numeric']['input']>;
  nc5_bentane_percent?: InputMaybe<Scalars['numeric']['input']>;
  npsha_ft?: InputMaybe<Scalars['numeric']['input']>;
  o2_percent?: InputMaybe<Scalars['numeric']['input']>;
  oil_gravity_api?: InputMaybe<Scalars['numeric']['input']>;
  parent_revision_id?: InputMaybe<Scalars['uuid']['input']>;
  surface_temperature_fahrenheit?: InputMaybe<Scalars['numeric']['input']>;
  top_casing_id?: InputMaybe<Scalars['uuid']['input']>;
  top_casing_length_feet?: InputMaybe<Scalars['numeric']['input']>;
  top_of_perforations_measured_depth_feet?: InputMaybe<Scalars['numeric']['input']>;
  top_of_perforations_true_vertical_depth_feet?: InputMaybe<Scalars['numeric']['input']>;
  top_tubing_id?: InputMaybe<Scalars['uuid']['input']>;
  top_tubing_length_feet?: InputMaybe<Scalars['numeric']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  water_specific_gravity?: InputMaybe<Scalars['numeric']['input']>;
  well_test_datum_point_measured_depth_feet?: InputMaybe<Scalars['numeric']['input']>;
  well_test_gas_input_type?: InputMaybe<Well_Test_Gas_Input_Options_Enum>;
  well_test_gas_rate_mscf_day?: InputMaybe<Scalars['numeric']['input']>;
  well_test_liquid_input_type?: InputMaybe<Well_Test_Liquid_Input_Options_Enum>;
  well_test_oil_rate_stb_day?: InputMaybe<Scalars['numeric']['input']>;
  well_test_pressure_input_type?: InputMaybe<Well_Test_Pressure_Input_Options_Enum>;
  well_test_producing_bottom_hole_pressure_psia?: InputMaybe<Scalars['numeric']['input']>;
  well_test_productivity_index?: InputMaybe<Scalars['numeric']['input']>;
  well_test_static_bottom_hole_pressure_psia?: InputMaybe<Scalars['numeric']['input']>;
  well_test_test_date?: InputMaybe<Scalars['timestamptz']['input']>;
  well_test_water_rate_stb_day?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate sum on columns */
export type Revisions_Scenario_Well_Properties_Revisions_Sum_Fields = {
  __typename: 'revisions_scenario_well_properties_revisions_sum_fields';
  ar_percent?: Maybe<Scalars['numeric']['output']>;
  average_dls?: Maybe<Scalars['numeric']['output']>;
  bottom_casing_length_feet?: Maybe<Scalars['numeric']['output']>;
  bottom_tubing_length_feet?: Maybe<Scalars['numeric']['output']>;
  bottomhole_temperature_fahrenheit?: Maybe<Scalars['numeric']['output']>;
  bubble_point_pressure_psia?: Maybe<Scalars['numeric']['output']>;
  c1_methane_percent?: Maybe<Scalars['numeric']['output']>;
  c2_ethane_percent?: Maybe<Scalars['numeric']['output']>;
  c3_propane_percent?: Maybe<Scalars['numeric']['output']>;
  c6_hexane_percent?: Maybe<Scalars['numeric']['output']>;
  c7_heptane_percent?: Maybe<Scalars['numeric']['output']>;
  co2_percent?: Maybe<Scalars['numeric']['output']>;
  condensate_api_override?: Maybe<Scalars['numeric']['output']>;
  dew_point_pressure_psia_override?: Maybe<Scalars['numeric']['output']>;
  fluid_viscosity_override_cp?: Maybe<Scalars['numeric']['output']>;
  gas_specific_gravity?: Maybe<Scalars['numeric']['output']>;
  h2s_percent?: Maybe<Scalars['numeric']['output']>;
  hps_pump_inlet_pressure_psia?: Maybe<Scalars['numeric']['output']>;
  hps_pump_inlet_temperature_fahrenheit?: Maybe<Scalars['numeric']['output']>;
  hps_required_discharge_pressure_psia?: Maybe<Scalars['numeric']['output']>;
  ic4_isobutene_percent?: Maybe<Scalars['numeric']['output']>;
  ic5_isopentane_percent?: Maybe<Scalars['numeric']['output']>;
  n2_percent?: Maybe<Scalars['numeric']['output']>;
  nc4_butane_percent?: Maybe<Scalars['numeric']['output']>;
  nc5_bentane_percent?: Maybe<Scalars['numeric']['output']>;
  npsha_ft?: Maybe<Scalars['numeric']['output']>;
  o2_percent?: Maybe<Scalars['numeric']['output']>;
  oil_gravity_api?: Maybe<Scalars['numeric']['output']>;
  surface_temperature_fahrenheit?: Maybe<Scalars['numeric']['output']>;
  top_casing_length_feet?: Maybe<Scalars['numeric']['output']>;
  top_of_perforations_measured_depth_feet?: Maybe<Scalars['numeric']['output']>;
  top_of_perforations_true_vertical_depth_feet?: Maybe<Scalars['numeric']['output']>;
  top_tubing_length_feet?: Maybe<Scalars['numeric']['output']>;
  water_specific_gravity?: Maybe<Scalars['numeric']['output']>;
  well_test_datum_point_measured_depth_feet?: Maybe<Scalars['numeric']['output']>;
  well_test_gas_rate_mscf_day?: Maybe<Scalars['numeric']['output']>;
  well_test_oil_rate_stb_day?: Maybe<Scalars['numeric']['output']>;
  well_test_producing_bottom_hole_pressure_psia?: Maybe<Scalars['numeric']['output']>;
  well_test_productivity_index?: Maybe<Scalars['numeric']['output']>;
  well_test_static_bottom_hole_pressure_psia?: Maybe<Scalars['numeric']['output']>;
  well_test_water_rate_stb_day?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "revisions.scenario_well_properties_revisions" */
export type Revisions_Scenario_Well_Properties_Revisions_Sum_Order_By = {
  ar_percent?: InputMaybe<Order_By>;
  average_dls?: InputMaybe<Order_By>;
  bottom_casing_length_feet?: InputMaybe<Order_By>;
  bottom_tubing_length_feet?: InputMaybe<Order_By>;
  bottomhole_temperature_fahrenheit?: InputMaybe<Order_By>;
  bubble_point_pressure_psia?: InputMaybe<Order_By>;
  c1_methane_percent?: InputMaybe<Order_By>;
  c2_ethane_percent?: InputMaybe<Order_By>;
  c3_propane_percent?: InputMaybe<Order_By>;
  c6_hexane_percent?: InputMaybe<Order_By>;
  c7_heptane_percent?: InputMaybe<Order_By>;
  co2_percent?: InputMaybe<Order_By>;
  condensate_api_override?: InputMaybe<Order_By>;
  dew_point_pressure_psia_override?: InputMaybe<Order_By>;
  fluid_viscosity_override_cp?: InputMaybe<Order_By>;
  gas_specific_gravity?: InputMaybe<Order_By>;
  h2s_percent?: InputMaybe<Order_By>;
  hps_pump_inlet_pressure_psia?: InputMaybe<Order_By>;
  hps_pump_inlet_temperature_fahrenheit?: InputMaybe<Order_By>;
  hps_required_discharge_pressure_psia?: InputMaybe<Order_By>;
  ic4_isobutene_percent?: InputMaybe<Order_By>;
  ic5_isopentane_percent?: InputMaybe<Order_By>;
  n2_percent?: InputMaybe<Order_By>;
  nc4_butane_percent?: InputMaybe<Order_By>;
  nc5_bentane_percent?: InputMaybe<Order_By>;
  npsha_ft?: InputMaybe<Order_By>;
  o2_percent?: InputMaybe<Order_By>;
  oil_gravity_api?: InputMaybe<Order_By>;
  surface_temperature_fahrenheit?: InputMaybe<Order_By>;
  top_casing_length_feet?: InputMaybe<Order_By>;
  top_of_perforations_measured_depth_feet?: InputMaybe<Order_By>;
  top_of_perforations_true_vertical_depth_feet?: InputMaybe<Order_By>;
  top_tubing_length_feet?: InputMaybe<Order_By>;
  water_specific_gravity?: InputMaybe<Order_By>;
  well_test_datum_point_measured_depth_feet?: InputMaybe<Order_By>;
  well_test_gas_rate_mscf_day?: InputMaybe<Order_By>;
  well_test_oil_rate_stb_day?: InputMaybe<Order_By>;
  well_test_producing_bottom_hole_pressure_psia?: InputMaybe<Order_By>;
  well_test_productivity_index?: InputMaybe<Order_By>;
  well_test_static_bottom_hole_pressure_psia?: InputMaybe<Order_By>;
  well_test_water_rate_stb_day?: InputMaybe<Order_By>;
};

/** update columns of table "revisions.scenario_well_properties_revisions" */
export enum Revisions_Scenario_Well_Properties_Revisions_Update_Column {
  /** column name */
  ArPercent = 'ar_percent',
  /** column name */
  AuthorId = 'author_id',
  /** column name */
  AverageDls = 'average_dls',
  /** column name */
  BottomCasingId = 'bottom_casing_id',
  /** column name */
  BottomCasingLengthFeet = 'bottom_casing_length_feet',
  /** column name */
  BottomTubingId = 'bottom_tubing_id',
  /** column name */
  BottomTubingLengthFeet = 'bottom_tubing_length_feet',
  /** column name */
  BottomholeTemperatureFahrenheit = 'bottomhole_temperature_fahrenheit',
  /** column name */
  BubblePointPressurePsia = 'bubble_point_pressure_psia',
  /** column name */
  C1MethanePercent = 'c1_methane_percent',
  /** column name */
  C2EthanePercent = 'c2_ethane_percent',
  /** column name */
  C3PropanePercent = 'c3_propane_percent',
  /** column name */
  C6HexanePercent = 'c6_hexane_percent',
  /** column name */
  C7HeptanePercent = 'c7_heptane_percent',
  /** column name */
  ClonedFromJournalId = 'cloned_from_journal_id',
  /** column name */
  Co2Percent = 'co2_percent',
  /** column name */
  CondensateApiOverride = 'condensate_api_override',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CustomFluidProperties = 'custom_fluid_properties',
  /** column name */
  CustomViscositiesProperties = 'custom_viscosities_properties',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  DeviationSurveyId = 'deviation_survey_id',
  /** column name */
  DewPointPressurePsiaOverride = 'dew_point_pressure_psia_override',
  /** column name */
  FluidViscosityOverrideCp = 'fluid_viscosity_override_cp',
  /** column name */
  GasSpecificGravity = 'gas_specific_gravity',
  /** column name */
  GasType = 'gas_type',
  /** column name */
  H2sPercent = 'h2s_percent',
  /** column name */
  HpsLiquidType = 'hps_liquid_type',
  /** column name */
  HpsPumpInletPressurePsia = 'hps_pump_inlet_pressure_psia',
  /** column name */
  HpsPumpInletTemperatureFahrenheit = 'hps_pump_inlet_temperature_fahrenheit',
  /** column name */
  HpsRequiredDischargePressurePsia = 'hps_required_discharge_pressure_psia',
  /** column name */
  Ic4IsobutenePercent = 'ic4_isobutene_percent',
  /** column name */
  Ic5IsopentanePercent = 'ic5_isopentane_percent',
  /** column name */
  Id = 'id',
  /** column name */
  JournalId = 'journal_id',
  /** column name */
  N2Percent = 'n2_percent',
  /** column name */
  Nc4ButanePercent = 'nc4_butane_percent',
  /** column name */
  Nc5BentanePercent = 'nc5_bentane_percent',
  /** column name */
  NpshaFt = 'npsha_ft',
  /** column name */
  O2Percent = 'o2_percent',
  /** column name */
  OilGravityApi = 'oil_gravity_api',
  /** column name */
  ParentRevisionId = 'parent_revision_id',
  /** column name */
  SurfaceTemperatureFahrenheit = 'surface_temperature_fahrenheit',
  /** column name */
  TopCasingId = 'top_casing_id',
  /** column name */
  TopCasingLengthFeet = 'top_casing_length_feet',
  /** column name */
  TopOfPerforationsMeasuredDepthFeet = 'top_of_perforations_measured_depth_feet',
  /** column name */
  TopOfPerforationsTrueVerticalDepthFeet = 'top_of_perforations_true_vertical_depth_feet',
  /** column name */
  TopTubingId = 'top_tubing_id',
  /** column name */
  TopTubingLengthFeet = 'top_tubing_length_feet',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WaterSpecificGravity = 'water_specific_gravity',
  /** column name */
  WellTestDatumPointMeasuredDepthFeet = 'well_test_datum_point_measured_depth_feet',
  /** column name */
  WellTestGasInputType = 'well_test_gas_input_type',
  /** column name */
  WellTestGasRateMscfDay = 'well_test_gas_rate_mscf_day',
  /** column name */
  WellTestLiquidInputType = 'well_test_liquid_input_type',
  /** column name */
  WellTestOilRateStbDay = 'well_test_oil_rate_stb_day',
  /** column name */
  WellTestPressureInputType = 'well_test_pressure_input_type',
  /** column name */
  WellTestProducingBottomHolePressurePsia = 'well_test_producing_bottom_hole_pressure_psia',
  /** column name */
  WellTestProductivityIndex = 'well_test_productivity_index',
  /** column name */
  WellTestStaticBottomHolePressurePsia = 'well_test_static_bottom_hole_pressure_psia',
  /** column name */
  WellTestTestDate = 'well_test_test_date',
  /** column name */
  WellTestWaterRateStbDay = 'well_test_water_rate_stb_day'
}

export type Revisions_Scenario_Well_Properties_Revisions_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Revisions_Scenario_Well_Properties_Revisions_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Revisions_Scenario_Well_Properties_Revisions_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Revisions_Scenario_Well_Properties_Revisions_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Revisions_Scenario_Well_Properties_Revisions_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Revisions_Scenario_Well_Properties_Revisions_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Revisions_Scenario_Well_Properties_Revisions_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Revisions_Scenario_Well_Properties_Revisions_Set_Input>;
  /** filter the rows which have to be updated */
  where: Revisions_Scenario_Well_Properties_Revisions_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Revisions_Scenario_Well_Properties_Revisions_Var_Pop_Fields = {
  __typename: 'revisions_scenario_well_properties_revisions_var_pop_fields';
  ar_percent?: Maybe<Scalars['Float']['output']>;
  average_dls?: Maybe<Scalars['Float']['output']>;
  bottom_casing_length_feet?: Maybe<Scalars['Float']['output']>;
  bottom_tubing_length_feet?: Maybe<Scalars['Float']['output']>;
  bottomhole_temperature_fahrenheit?: Maybe<Scalars['Float']['output']>;
  bubble_point_pressure_psia?: Maybe<Scalars['Float']['output']>;
  c1_methane_percent?: Maybe<Scalars['Float']['output']>;
  c2_ethane_percent?: Maybe<Scalars['Float']['output']>;
  c3_propane_percent?: Maybe<Scalars['Float']['output']>;
  c6_hexane_percent?: Maybe<Scalars['Float']['output']>;
  c7_heptane_percent?: Maybe<Scalars['Float']['output']>;
  co2_percent?: Maybe<Scalars['Float']['output']>;
  condensate_api_override?: Maybe<Scalars['Float']['output']>;
  dew_point_pressure_psia_override?: Maybe<Scalars['Float']['output']>;
  fluid_viscosity_override_cp?: Maybe<Scalars['Float']['output']>;
  gas_specific_gravity?: Maybe<Scalars['Float']['output']>;
  h2s_percent?: Maybe<Scalars['Float']['output']>;
  hps_pump_inlet_pressure_psia?: Maybe<Scalars['Float']['output']>;
  hps_pump_inlet_temperature_fahrenheit?: Maybe<Scalars['Float']['output']>;
  hps_required_discharge_pressure_psia?: Maybe<Scalars['Float']['output']>;
  ic4_isobutene_percent?: Maybe<Scalars['Float']['output']>;
  ic5_isopentane_percent?: Maybe<Scalars['Float']['output']>;
  n2_percent?: Maybe<Scalars['Float']['output']>;
  nc4_butane_percent?: Maybe<Scalars['Float']['output']>;
  nc5_bentane_percent?: Maybe<Scalars['Float']['output']>;
  npsha_ft?: Maybe<Scalars['Float']['output']>;
  o2_percent?: Maybe<Scalars['Float']['output']>;
  oil_gravity_api?: Maybe<Scalars['Float']['output']>;
  surface_temperature_fahrenheit?: Maybe<Scalars['Float']['output']>;
  top_casing_length_feet?: Maybe<Scalars['Float']['output']>;
  top_of_perforations_measured_depth_feet?: Maybe<Scalars['Float']['output']>;
  top_of_perforations_true_vertical_depth_feet?: Maybe<Scalars['Float']['output']>;
  top_tubing_length_feet?: Maybe<Scalars['Float']['output']>;
  water_specific_gravity?: Maybe<Scalars['Float']['output']>;
  well_test_datum_point_measured_depth_feet?: Maybe<Scalars['Float']['output']>;
  well_test_gas_rate_mscf_day?: Maybe<Scalars['Float']['output']>;
  well_test_oil_rate_stb_day?: Maybe<Scalars['Float']['output']>;
  well_test_producing_bottom_hole_pressure_psia?: Maybe<Scalars['Float']['output']>;
  well_test_productivity_index?: Maybe<Scalars['Float']['output']>;
  well_test_static_bottom_hole_pressure_psia?: Maybe<Scalars['Float']['output']>;
  well_test_water_rate_stb_day?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "revisions.scenario_well_properties_revisions" */
export type Revisions_Scenario_Well_Properties_Revisions_Var_Pop_Order_By = {
  ar_percent?: InputMaybe<Order_By>;
  average_dls?: InputMaybe<Order_By>;
  bottom_casing_length_feet?: InputMaybe<Order_By>;
  bottom_tubing_length_feet?: InputMaybe<Order_By>;
  bottomhole_temperature_fahrenheit?: InputMaybe<Order_By>;
  bubble_point_pressure_psia?: InputMaybe<Order_By>;
  c1_methane_percent?: InputMaybe<Order_By>;
  c2_ethane_percent?: InputMaybe<Order_By>;
  c3_propane_percent?: InputMaybe<Order_By>;
  c6_hexane_percent?: InputMaybe<Order_By>;
  c7_heptane_percent?: InputMaybe<Order_By>;
  co2_percent?: InputMaybe<Order_By>;
  condensate_api_override?: InputMaybe<Order_By>;
  dew_point_pressure_psia_override?: InputMaybe<Order_By>;
  fluid_viscosity_override_cp?: InputMaybe<Order_By>;
  gas_specific_gravity?: InputMaybe<Order_By>;
  h2s_percent?: InputMaybe<Order_By>;
  hps_pump_inlet_pressure_psia?: InputMaybe<Order_By>;
  hps_pump_inlet_temperature_fahrenheit?: InputMaybe<Order_By>;
  hps_required_discharge_pressure_psia?: InputMaybe<Order_By>;
  ic4_isobutene_percent?: InputMaybe<Order_By>;
  ic5_isopentane_percent?: InputMaybe<Order_By>;
  n2_percent?: InputMaybe<Order_By>;
  nc4_butane_percent?: InputMaybe<Order_By>;
  nc5_bentane_percent?: InputMaybe<Order_By>;
  npsha_ft?: InputMaybe<Order_By>;
  o2_percent?: InputMaybe<Order_By>;
  oil_gravity_api?: InputMaybe<Order_By>;
  surface_temperature_fahrenheit?: InputMaybe<Order_By>;
  top_casing_length_feet?: InputMaybe<Order_By>;
  top_of_perforations_measured_depth_feet?: InputMaybe<Order_By>;
  top_of_perforations_true_vertical_depth_feet?: InputMaybe<Order_By>;
  top_tubing_length_feet?: InputMaybe<Order_By>;
  water_specific_gravity?: InputMaybe<Order_By>;
  well_test_datum_point_measured_depth_feet?: InputMaybe<Order_By>;
  well_test_gas_rate_mscf_day?: InputMaybe<Order_By>;
  well_test_oil_rate_stb_day?: InputMaybe<Order_By>;
  well_test_producing_bottom_hole_pressure_psia?: InputMaybe<Order_By>;
  well_test_productivity_index?: InputMaybe<Order_By>;
  well_test_static_bottom_hole_pressure_psia?: InputMaybe<Order_By>;
  well_test_water_rate_stb_day?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Revisions_Scenario_Well_Properties_Revisions_Var_Samp_Fields = {
  __typename: 'revisions_scenario_well_properties_revisions_var_samp_fields';
  ar_percent?: Maybe<Scalars['Float']['output']>;
  average_dls?: Maybe<Scalars['Float']['output']>;
  bottom_casing_length_feet?: Maybe<Scalars['Float']['output']>;
  bottom_tubing_length_feet?: Maybe<Scalars['Float']['output']>;
  bottomhole_temperature_fahrenheit?: Maybe<Scalars['Float']['output']>;
  bubble_point_pressure_psia?: Maybe<Scalars['Float']['output']>;
  c1_methane_percent?: Maybe<Scalars['Float']['output']>;
  c2_ethane_percent?: Maybe<Scalars['Float']['output']>;
  c3_propane_percent?: Maybe<Scalars['Float']['output']>;
  c6_hexane_percent?: Maybe<Scalars['Float']['output']>;
  c7_heptane_percent?: Maybe<Scalars['Float']['output']>;
  co2_percent?: Maybe<Scalars['Float']['output']>;
  condensate_api_override?: Maybe<Scalars['Float']['output']>;
  dew_point_pressure_psia_override?: Maybe<Scalars['Float']['output']>;
  fluid_viscosity_override_cp?: Maybe<Scalars['Float']['output']>;
  gas_specific_gravity?: Maybe<Scalars['Float']['output']>;
  h2s_percent?: Maybe<Scalars['Float']['output']>;
  hps_pump_inlet_pressure_psia?: Maybe<Scalars['Float']['output']>;
  hps_pump_inlet_temperature_fahrenheit?: Maybe<Scalars['Float']['output']>;
  hps_required_discharge_pressure_psia?: Maybe<Scalars['Float']['output']>;
  ic4_isobutene_percent?: Maybe<Scalars['Float']['output']>;
  ic5_isopentane_percent?: Maybe<Scalars['Float']['output']>;
  n2_percent?: Maybe<Scalars['Float']['output']>;
  nc4_butane_percent?: Maybe<Scalars['Float']['output']>;
  nc5_bentane_percent?: Maybe<Scalars['Float']['output']>;
  npsha_ft?: Maybe<Scalars['Float']['output']>;
  o2_percent?: Maybe<Scalars['Float']['output']>;
  oil_gravity_api?: Maybe<Scalars['Float']['output']>;
  surface_temperature_fahrenheit?: Maybe<Scalars['Float']['output']>;
  top_casing_length_feet?: Maybe<Scalars['Float']['output']>;
  top_of_perforations_measured_depth_feet?: Maybe<Scalars['Float']['output']>;
  top_of_perforations_true_vertical_depth_feet?: Maybe<Scalars['Float']['output']>;
  top_tubing_length_feet?: Maybe<Scalars['Float']['output']>;
  water_specific_gravity?: Maybe<Scalars['Float']['output']>;
  well_test_datum_point_measured_depth_feet?: Maybe<Scalars['Float']['output']>;
  well_test_gas_rate_mscf_day?: Maybe<Scalars['Float']['output']>;
  well_test_oil_rate_stb_day?: Maybe<Scalars['Float']['output']>;
  well_test_producing_bottom_hole_pressure_psia?: Maybe<Scalars['Float']['output']>;
  well_test_productivity_index?: Maybe<Scalars['Float']['output']>;
  well_test_static_bottom_hole_pressure_psia?: Maybe<Scalars['Float']['output']>;
  well_test_water_rate_stb_day?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "revisions.scenario_well_properties_revisions" */
export type Revisions_Scenario_Well_Properties_Revisions_Var_Samp_Order_By = {
  ar_percent?: InputMaybe<Order_By>;
  average_dls?: InputMaybe<Order_By>;
  bottom_casing_length_feet?: InputMaybe<Order_By>;
  bottom_tubing_length_feet?: InputMaybe<Order_By>;
  bottomhole_temperature_fahrenheit?: InputMaybe<Order_By>;
  bubble_point_pressure_psia?: InputMaybe<Order_By>;
  c1_methane_percent?: InputMaybe<Order_By>;
  c2_ethane_percent?: InputMaybe<Order_By>;
  c3_propane_percent?: InputMaybe<Order_By>;
  c6_hexane_percent?: InputMaybe<Order_By>;
  c7_heptane_percent?: InputMaybe<Order_By>;
  co2_percent?: InputMaybe<Order_By>;
  condensate_api_override?: InputMaybe<Order_By>;
  dew_point_pressure_psia_override?: InputMaybe<Order_By>;
  fluid_viscosity_override_cp?: InputMaybe<Order_By>;
  gas_specific_gravity?: InputMaybe<Order_By>;
  h2s_percent?: InputMaybe<Order_By>;
  hps_pump_inlet_pressure_psia?: InputMaybe<Order_By>;
  hps_pump_inlet_temperature_fahrenheit?: InputMaybe<Order_By>;
  hps_required_discharge_pressure_psia?: InputMaybe<Order_By>;
  ic4_isobutene_percent?: InputMaybe<Order_By>;
  ic5_isopentane_percent?: InputMaybe<Order_By>;
  n2_percent?: InputMaybe<Order_By>;
  nc4_butane_percent?: InputMaybe<Order_By>;
  nc5_bentane_percent?: InputMaybe<Order_By>;
  npsha_ft?: InputMaybe<Order_By>;
  o2_percent?: InputMaybe<Order_By>;
  oil_gravity_api?: InputMaybe<Order_By>;
  surface_temperature_fahrenheit?: InputMaybe<Order_By>;
  top_casing_length_feet?: InputMaybe<Order_By>;
  top_of_perforations_measured_depth_feet?: InputMaybe<Order_By>;
  top_of_perforations_true_vertical_depth_feet?: InputMaybe<Order_By>;
  top_tubing_length_feet?: InputMaybe<Order_By>;
  water_specific_gravity?: InputMaybe<Order_By>;
  well_test_datum_point_measured_depth_feet?: InputMaybe<Order_By>;
  well_test_gas_rate_mscf_day?: InputMaybe<Order_By>;
  well_test_oil_rate_stb_day?: InputMaybe<Order_By>;
  well_test_producing_bottom_hole_pressure_psia?: InputMaybe<Order_By>;
  well_test_productivity_index?: InputMaybe<Order_By>;
  well_test_static_bottom_hole_pressure_psia?: InputMaybe<Order_By>;
  well_test_water_rate_stb_day?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Revisions_Scenario_Well_Properties_Revisions_Variance_Fields = {
  __typename: 'revisions_scenario_well_properties_revisions_variance_fields';
  ar_percent?: Maybe<Scalars['Float']['output']>;
  average_dls?: Maybe<Scalars['Float']['output']>;
  bottom_casing_length_feet?: Maybe<Scalars['Float']['output']>;
  bottom_tubing_length_feet?: Maybe<Scalars['Float']['output']>;
  bottomhole_temperature_fahrenheit?: Maybe<Scalars['Float']['output']>;
  bubble_point_pressure_psia?: Maybe<Scalars['Float']['output']>;
  c1_methane_percent?: Maybe<Scalars['Float']['output']>;
  c2_ethane_percent?: Maybe<Scalars['Float']['output']>;
  c3_propane_percent?: Maybe<Scalars['Float']['output']>;
  c6_hexane_percent?: Maybe<Scalars['Float']['output']>;
  c7_heptane_percent?: Maybe<Scalars['Float']['output']>;
  co2_percent?: Maybe<Scalars['Float']['output']>;
  condensate_api_override?: Maybe<Scalars['Float']['output']>;
  dew_point_pressure_psia_override?: Maybe<Scalars['Float']['output']>;
  fluid_viscosity_override_cp?: Maybe<Scalars['Float']['output']>;
  gas_specific_gravity?: Maybe<Scalars['Float']['output']>;
  h2s_percent?: Maybe<Scalars['Float']['output']>;
  hps_pump_inlet_pressure_psia?: Maybe<Scalars['Float']['output']>;
  hps_pump_inlet_temperature_fahrenheit?: Maybe<Scalars['Float']['output']>;
  hps_required_discharge_pressure_psia?: Maybe<Scalars['Float']['output']>;
  ic4_isobutene_percent?: Maybe<Scalars['Float']['output']>;
  ic5_isopentane_percent?: Maybe<Scalars['Float']['output']>;
  n2_percent?: Maybe<Scalars['Float']['output']>;
  nc4_butane_percent?: Maybe<Scalars['Float']['output']>;
  nc5_bentane_percent?: Maybe<Scalars['Float']['output']>;
  npsha_ft?: Maybe<Scalars['Float']['output']>;
  o2_percent?: Maybe<Scalars['Float']['output']>;
  oil_gravity_api?: Maybe<Scalars['Float']['output']>;
  surface_temperature_fahrenheit?: Maybe<Scalars['Float']['output']>;
  top_casing_length_feet?: Maybe<Scalars['Float']['output']>;
  top_of_perforations_measured_depth_feet?: Maybe<Scalars['Float']['output']>;
  top_of_perforations_true_vertical_depth_feet?: Maybe<Scalars['Float']['output']>;
  top_tubing_length_feet?: Maybe<Scalars['Float']['output']>;
  water_specific_gravity?: Maybe<Scalars['Float']['output']>;
  well_test_datum_point_measured_depth_feet?: Maybe<Scalars['Float']['output']>;
  well_test_gas_rate_mscf_day?: Maybe<Scalars['Float']['output']>;
  well_test_oil_rate_stb_day?: Maybe<Scalars['Float']['output']>;
  well_test_producing_bottom_hole_pressure_psia?: Maybe<Scalars['Float']['output']>;
  well_test_productivity_index?: Maybe<Scalars['Float']['output']>;
  well_test_static_bottom_hole_pressure_psia?: Maybe<Scalars['Float']['output']>;
  well_test_water_rate_stb_day?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "revisions.scenario_well_properties_revisions" */
export type Revisions_Scenario_Well_Properties_Revisions_Variance_Order_By = {
  ar_percent?: InputMaybe<Order_By>;
  average_dls?: InputMaybe<Order_By>;
  bottom_casing_length_feet?: InputMaybe<Order_By>;
  bottom_tubing_length_feet?: InputMaybe<Order_By>;
  bottomhole_temperature_fahrenheit?: InputMaybe<Order_By>;
  bubble_point_pressure_psia?: InputMaybe<Order_By>;
  c1_methane_percent?: InputMaybe<Order_By>;
  c2_ethane_percent?: InputMaybe<Order_By>;
  c3_propane_percent?: InputMaybe<Order_By>;
  c6_hexane_percent?: InputMaybe<Order_By>;
  c7_heptane_percent?: InputMaybe<Order_By>;
  co2_percent?: InputMaybe<Order_By>;
  condensate_api_override?: InputMaybe<Order_By>;
  dew_point_pressure_psia_override?: InputMaybe<Order_By>;
  fluid_viscosity_override_cp?: InputMaybe<Order_By>;
  gas_specific_gravity?: InputMaybe<Order_By>;
  h2s_percent?: InputMaybe<Order_By>;
  hps_pump_inlet_pressure_psia?: InputMaybe<Order_By>;
  hps_pump_inlet_temperature_fahrenheit?: InputMaybe<Order_By>;
  hps_required_discharge_pressure_psia?: InputMaybe<Order_By>;
  ic4_isobutene_percent?: InputMaybe<Order_By>;
  ic5_isopentane_percent?: InputMaybe<Order_By>;
  n2_percent?: InputMaybe<Order_By>;
  nc4_butane_percent?: InputMaybe<Order_By>;
  nc5_bentane_percent?: InputMaybe<Order_By>;
  npsha_ft?: InputMaybe<Order_By>;
  o2_percent?: InputMaybe<Order_By>;
  oil_gravity_api?: InputMaybe<Order_By>;
  surface_temperature_fahrenheit?: InputMaybe<Order_By>;
  top_casing_length_feet?: InputMaybe<Order_By>;
  top_of_perforations_measured_depth_feet?: InputMaybe<Order_By>;
  top_of_perforations_true_vertical_depth_feet?: InputMaybe<Order_By>;
  top_tubing_length_feet?: InputMaybe<Order_By>;
  water_specific_gravity?: InputMaybe<Order_By>;
  well_test_datum_point_measured_depth_feet?: InputMaybe<Order_By>;
  well_test_gas_rate_mscf_day?: InputMaybe<Order_By>;
  well_test_oil_rate_stb_day?: InputMaybe<Order_By>;
  well_test_producing_bottom_hole_pressure_psia?: InputMaybe<Order_By>;
  well_test_productivity_index?: InputMaybe<Order_By>;
  well_test_static_bottom_hole_pressure_psia?: InputMaybe<Order_By>;
  well_test_water_rate_stb_day?: InputMaybe<Order_By>;
};

/** columns and relationships of "revisions.scenarios_journal" */
export type Revisions_Scenarios_Journal = {
  __typename: 'revisions_scenarios_journal';
  /** An object relationship */
  author: Users;
  author_id: Scalars['String']['output'];
  created_at: Scalars['timestamptz']['output'];
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  parent_journal_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  parent_scenarios_journal?: Maybe<Revisions_Scenarios_Journal>;
  /** An array relationship */
  performance_evaluations_revisions: Array<Revisions_Performance_Evaluations_Revisions>;
  /** An aggregate relationship */
  performance_evaluations_revisions_aggregate: Revisions_Performance_Evaluations_Revisions_Aggregate;
  /** An array relationship */
  scenarios_journals_children: Array<Revisions_Scenarios_Journal>;
  /** An aggregate relationship */
  scenarios_journals_children_aggregate: Revisions_Scenarios_Journal_Aggregate;
  /** An array relationship */
  scenarios_revisions: Array<Revisions_Scenarios_Revisions>;
  /** An aggregate relationship */
  scenarios_revisions_aggregate: Revisions_Scenarios_Revisions_Aggregate;
  /** An array relationship */
  sizings_revisions_installed_on: Array<Revisions_Sizings_Revisions>;
  /** An aggregate relationship */
  sizings_revisions_installed_on_aggregate: Revisions_Sizings_Revisions_Aggregate;
  updated_at: Scalars['timestamptz']['output'];
  winning_revision_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  winning_scenarios_revision?: Maybe<Revisions_Scenarios_Revisions>;
};


/** columns and relationships of "revisions.scenarios_journal" */
export type Revisions_Scenarios_JournalPerformance_Evaluations_RevisionsArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Performance_Evaluations_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Performance_Evaluations_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Performance_Evaluations_Revisions_Bool_Exp>;
};


/** columns and relationships of "revisions.scenarios_journal" */
export type Revisions_Scenarios_JournalPerformance_Evaluations_Revisions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Performance_Evaluations_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Performance_Evaluations_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Performance_Evaluations_Revisions_Bool_Exp>;
};


/** columns and relationships of "revisions.scenarios_journal" */
export type Revisions_Scenarios_JournalScenarios_Journals_ChildrenArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenarios_Journal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenarios_Journal_Order_By>>;
  where?: InputMaybe<Revisions_Scenarios_Journal_Bool_Exp>;
};


/** columns and relationships of "revisions.scenarios_journal" */
export type Revisions_Scenarios_JournalScenarios_Journals_Children_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenarios_Journal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenarios_Journal_Order_By>>;
  where?: InputMaybe<Revisions_Scenarios_Journal_Bool_Exp>;
};


/** columns and relationships of "revisions.scenarios_journal" */
export type Revisions_Scenarios_JournalScenarios_RevisionsArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenarios_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenarios_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Scenarios_Revisions_Bool_Exp>;
};


/** columns and relationships of "revisions.scenarios_journal" */
export type Revisions_Scenarios_JournalScenarios_Revisions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenarios_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenarios_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Scenarios_Revisions_Bool_Exp>;
};


/** columns and relationships of "revisions.scenarios_journal" */
export type Revisions_Scenarios_JournalSizings_Revisions_Installed_OnArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Sizings_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Sizings_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Sizings_Revisions_Bool_Exp>;
};


/** columns and relationships of "revisions.scenarios_journal" */
export type Revisions_Scenarios_JournalSizings_Revisions_Installed_On_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Sizings_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Sizings_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Sizings_Revisions_Bool_Exp>;
};

/** aggregated selection of "revisions.scenarios_journal" */
export type Revisions_Scenarios_Journal_Aggregate = {
  __typename: 'revisions_scenarios_journal_aggregate';
  aggregate?: Maybe<Revisions_Scenarios_Journal_Aggregate_Fields>;
  nodes: Array<Revisions_Scenarios_Journal>;
};

export type Revisions_Scenarios_Journal_Aggregate_Bool_Exp = {
  count?: InputMaybe<Revisions_Scenarios_Journal_Aggregate_Bool_Exp_Count>;
};

export type Revisions_Scenarios_Journal_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Revisions_Scenarios_Journal_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Revisions_Scenarios_Journal_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "revisions.scenarios_journal" */
export type Revisions_Scenarios_Journal_Aggregate_Fields = {
  __typename: 'revisions_scenarios_journal_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Revisions_Scenarios_Journal_Max_Fields>;
  min?: Maybe<Revisions_Scenarios_Journal_Min_Fields>;
};


/** aggregate fields of "revisions.scenarios_journal" */
export type Revisions_Scenarios_Journal_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Revisions_Scenarios_Journal_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "revisions.scenarios_journal" */
export type Revisions_Scenarios_Journal_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Revisions_Scenarios_Journal_Max_Order_By>;
  min?: InputMaybe<Revisions_Scenarios_Journal_Min_Order_By>;
};

/** input type for inserting array relation for remote table "revisions.scenarios_journal" */
export type Revisions_Scenarios_Journal_Arr_Rel_Insert_Input = {
  data: Array<Revisions_Scenarios_Journal_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Revisions_Scenarios_Journal_On_Conflict>;
};

/** Boolean expression to filter rows from the table "revisions.scenarios_journal". All fields are combined with a logical 'AND'. */
export type Revisions_Scenarios_Journal_Bool_Exp = {
  _and?: InputMaybe<Array<Revisions_Scenarios_Journal_Bool_Exp>>;
  _not?: InputMaybe<Revisions_Scenarios_Journal_Bool_Exp>;
  _or?: InputMaybe<Array<Revisions_Scenarios_Journal_Bool_Exp>>;
  author?: InputMaybe<Users_Bool_Exp>;
  author_id?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  parent_journal_id?: InputMaybe<Uuid_Comparison_Exp>;
  parent_scenarios_journal?: InputMaybe<Revisions_Scenarios_Journal_Bool_Exp>;
  performance_evaluations_revisions?: InputMaybe<Revisions_Performance_Evaluations_Revisions_Bool_Exp>;
  performance_evaluations_revisions_aggregate?: InputMaybe<Revisions_Performance_Evaluations_Revisions_Aggregate_Bool_Exp>;
  scenarios_journals_children?: InputMaybe<Revisions_Scenarios_Journal_Bool_Exp>;
  scenarios_journals_children_aggregate?: InputMaybe<Revisions_Scenarios_Journal_Aggregate_Bool_Exp>;
  scenarios_revisions?: InputMaybe<Revisions_Scenarios_Revisions_Bool_Exp>;
  scenarios_revisions_aggregate?: InputMaybe<Revisions_Scenarios_Revisions_Aggregate_Bool_Exp>;
  sizings_revisions_installed_on?: InputMaybe<Revisions_Sizings_Revisions_Bool_Exp>;
  sizings_revisions_installed_on_aggregate?: InputMaybe<Revisions_Sizings_Revisions_Aggregate_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  winning_revision_id?: InputMaybe<Uuid_Comparison_Exp>;
  winning_scenarios_revision?: InputMaybe<Revisions_Scenarios_Revisions_Bool_Exp>;
};

/** unique or primary key constraints on table "revisions.scenarios_journal" */
export enum Revisions_Scenarios_Journal_Constraint {
  /** unique or primary key constraint on columns "id" */
  ScenariosJournalPkey = 'scenarios_journal_pkey'
}

/** input type for inserting data into table "revisions.scenarios_journal" */
export type Revisions_Scenarios_Journal_Insert_Input = {
  author?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  author_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  parent_journal_id?: InputMaybe<Scalars['uuid']['input']>;
  parent_scenarios_journal?: InputMaybe<Revisions_Scenarios_Journal_Obj_Rel_Insert_Input>;
  performance_evaluations_revisions?: InputMaybe<Revisions_Performance_Evaluations_Revisions_Arr_Rel_Insert_Input>;
  scenarios_journals_children?: InputMaybe<Revisions_Scenarios_Journal_Arr_Rel_Insert_Input>;
  scenarios_revisions?: InputMaybe<Revisions_Scenarios_Revisions_Arr_Rel_Insert_Input>;
  sizings_revisions_installed_on?: InputMaybe<Revisions_Sizings_Revisions_Arr_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  winning_revision_id?: InputMaybe<Scalars['uuid']['input']>;
  winning_scenarios_revision?: InputMaybe<Revisions_Scenarios_Revisions_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Revisions_Scenarios_Journal_Max_Fields = {
  __typename: 'revisions_scenarios_journal_max_fields';
  author_id?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  parent_journal_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  winning_revision_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "revisions.scenarios_journal" */
export type Revisions_Scenarios_Journal_Max_Order_By = {
  author_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parent_journal_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  winning_revision_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Revisions_Scenarios_Journal_Min_Fields = {
  __typename: 'revisions_scenarios_journal_min_fields';
  author_id?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  parent_journal_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  winning_revision_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "revisions.scenarios_journal" */
export type Revisions_Scenarios_Journal_Min_Order_By = {
  author_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parent_journal_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  winning_revision_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "revisions.scenarios_journal" */
export type Revisions_Scenarios_Journal_Mutation_Response = {
  __typename: 'revisions_scenarios_journal_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Revisions_Scenarios_Journal>;
};

/** input type for inserting object relation for remote table "revisions.scenarios_journal" */
export type Revisions_Scenarios_Journal_Obj_Rel_Insert_Input = {
  data: Revisions_Scenarios_Journal_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Revisions_Scenarios_Journal_On_Conflict>;
};

/** on_conflict condition type for table "revisions.scenarios_journal" */
export type Revisions_Scenarios_Journal_On_Conflict = {
  constraint: Revisions_Scenarios_Journal_Constraint;
  update_columns?: Array<Revisions_Scenarios_Journal_Update_Column>;
  where?: InputMaybe<Revisions_Scenarios_Journal_Bool_Exp>;
};

/** Ordering options when selecting data from "revisions.scenarios_journal". */
export type Revisions_Scenarios_Journal_Order_By = {
  author?: InputMaybe<Users_Order_By>;
  author_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parent_journal_id?: InputMaybe<Order_By>;
  parent_scenarios_journal?: InputMaybe<Revisions_Scenarios_Journal_Order_By>;
  performance_evaluations_revisions_aggregate?: InputMaybe<Revisions_Performance_Evaluations_Revisions_Aggregate_Order_By>;
  scenarios_journals_children_aggregate?: InputMaybe<Revisions_Scenarios_Journal_Aggregate_Order_By>;
  scenarios_revisions_aggregate?: InputMaybe<Revisions_Scenarios_Revisions_Aggregate_Order_By>;
  sizings_revisions_installed_on_aggregate?: InputMaybe<Revisions_Sizings_Revisions_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  winning_revision_id?: InputMaybe<Order_By>;
  winning_scenarios_revision?: InputMaybe<Revisions_Scenarios_Revisions_Order_By>;
};

/** primary key columns input for table: revisions.scenarios_journal */
export type Revisions_Scenarios_Journal_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "revisions.scenarios_journal" */
export enum Revisions_Scenarios_Journal_Select_Column {
  /** column name */
  AuthorId = 'author_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  ParentJournalId = 'parent_journal_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WinningRevisionId = 'winning_revision_id'
}

/** input type for updating data in table "revisions.scenarios_journal" */
export type Revisions_Scenarios_Journal_Set_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  parent_journal_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  winning_revision_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "revisions_scenarios_journal" */
export type Revisions_Scenarios_Journal_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Revisions_Scenarios_Journal_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Revisions_Scenarios_Journal_Stream_Cursor_Value_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  parent_journal_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  winning_revision_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "revisions.scenarios_journal" */
export enum Revisions_Scenarios_Journal_Update_Column {
  /** column name */
  AuthorId = 'author_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  ParentJournalId = 'parent_journal_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WinningRevisionId = 'winning_revision_id'
}

export type Revisions_Scenarios_Journal_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Revisions_Scenarios_Journal_Set_Input>;
  /** filter the rows which have to be updated */
  where: Revisions_Scenarios_Journal_Bool_Exp;
};

/** columns and relationships of "revisions.scenarios_revisions" */
export type Revisions_Scenarios_Revisions = {
  __typename: 'revisions_scenarios_revisions';
  /** An object relationship */
  author: Users;
  author_id: Scalars['String']['output'];
  cloned_from_journal_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  cloned_from_scenario?: Maybe<Revisions_Scenarios_Journal>;
  correlations_id?: Maybe<Scalars['uuid']['output']>;
  created_at: Scalars['timestamptz']['output'];
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  display_unit_overrides: Scalars['jsonb']['output'];
  id: Scalars['uuid']['output'];
  internal_notes?: Maybe<Scalars['String']['output']>;
  journal_id: Scalars['uuid']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  parameters_id?: Maybe<Scalars['uuid']['output']>;
  parent_revision_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  parent_scenarios_revision?: Maybe<Revisions_Scenarios_Revisions>;
  pumping_type: Sizing_Pumping_Type_Enum;
  reason?: Maybe<Scenario_Reasons_Enum>;
  /** An object relationship */
  scenario_correlations_journal?: Maybe<Revisions_Scenario_Correlations_Journal>;
  scenario_equipment_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  scenario_equipment_journal?: Maybe<Revisions_Scenario_Equipment_Journal>;
  /** An object relationship */
  scenario_parameters_journal?: Maybe<Revisions_Scenario_Parameters_Journal>;
  /** An object relationship */
  scenario_reason?: Maybe<Scenario_Reasons>;
  /** An object relationship */
  scenario_well_properties_journal?: Maybe<Revisions_Scenario_Well_Properties_Journal>;
  /** An object relationship */
  scenarios_journal: Revisions_Scenarios_Journal;
  /** An array relationship */
  scenarios_journals: Array<Revisions_Scenarios_Journal>;
  /** An aggregate relationship */
  scenarios_journals_aggregate: Revisions_Scenarios_Journal_Aggregate;
  /** An array relationship */
  scenarios_revisions_parents: Array<Revisions_Scenarios_Revisions>;
  /** An aggregate relationship */
  scenarios_revisions_parents_aggregate: Revisions_Scenarios_Revisions_Aggregate;
  /** An object relationship */
  scenarios_view?: Maybe<Scenarios>;
  sizing_id: Scalars['uuid']['output'];
  /** An object relationship */
  sizings_journal: Revisions_Sizings_Journal;
  title?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['timestamptz']['output'];
  well_properties_id?: Maybe<Scalars['uuid']['output']>;
};


/** columns and relationships of "revisions.scenarios_revisions" */
export type Revisions_Scenarios_RevisionsDisplay_Unit_OverridesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "revisions.scenarios_revisions" */
export type Revisions_Scenarios_RevisionsScenarios_JournalsArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenarios_Journal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenarios_Journal_Order_By>>;
  where?: InputMaybe<Revisions_Scenarios_Journal_Bool_Exp>;
};


/** columns and relationships of "revisions.scenarios_revisions" */
export type Revisions_Scenarios_RevisionsScenarios_Journals_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenarios_Journal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenarios_Journal_Order_By>>;
  where?: InputMaybe<Revisions_Scenarios_Journal_Bool_Exp>;
};


/** columns and relationships of "revisions.scenarios_revisions" */
export type Revisions_Scenarios_RevisionsScenarios_Revisions_ParentsArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenarios_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenarios_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Scenarios_Revisions_Bool_Exp>;
};


/** columns and relationships of "revisions.scenarios_revisions" */
export type Revisions_Scenarios_RevisionsScenarios_Revisions_Parents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenarios_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenarios_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Scenarios_Revisions_Bool_Exp>;
};

/** aggregated selection of "revisions.scenarios_revisions" */
export type Revisions_Scenarios_Revisions_Aggregate = {
  __typename: 'revisions_scenarios_revisions_aggregate';
  aggregate?: Maybe<Revisions_Scenarios_Revisions_Aggregate_Fields>;
  nodes: Array<Revisions_Scenarios_Revisions>;
};

export type Revisions_Scenarios_Revisions_Aggregate_Bool_Exp = {
  count?: InputMaybe<Revisions_Scenarios_Revisions_Aggregate_Bool_Exp_Count>;
};

export type Revisions_Scenarios_Revisions_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Revisions_Scenarios_Revisions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Revisions_Scenarios_Revisions_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "revisions.scenarios_revisions" */
export type Revisions_Scenarios_Revisions_Aggregate_Fields = {
  __typename: 'revisions_scenarios_revisions_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Revisions_Scenarios_Revisions_Max_Fields>;
  min?: Maybe<Revisions_Scenarios_Revisions_Min_Fields>;
};


/** aggregate fields of "revisions.scenarios_revisions" */
export type Revisions_Scenarios_Revisions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Revisions_Scenarios_Revisions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "revisions.scenarios_revisions" */
export type Revisions_Scenarios_Revisions_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Revisions_Scenarios_Revisions_Max_Order_By>;
  min?: InputMaybe<Revisions_Scenarios_Revisions_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Revisions_Scenarios_Revisions_Append_Input = {
  display_unit_overrides?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "revisions.scenarios_revisions" */
export type Revisions_Scenarios_Revisions_Arr_Rel_Insert_Input = {
  data: Array<Revisions_Scenarios_Revisions_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Revisions_Scenarios_Revisions_On_Conflict>;
};

/** Boolean expression to filter rows from the table "revisions.scenarios_revisions". All fields are combined with a logical 'AND'. */
export type Revisions_Scenarios_Revisions_Bool_Exp = {
  _and?: InputMaybe<Array<Revisions_Scenarios_Revisions_Bool_Exp>>;
  _not?: InputMaybe<Revisions_Scenarios_Revisions_Bool_Exp>;
  _or?: InputMaybe<Array<Revisions_Scenarios_Revisions_Bool_Exp>>;
  author?: InputMaybe<Users_Bool_Exp>;
  author_id?: InputMaybe<String_Comparison_Exp>;
  cloned_from_journal_id?: InputMaybe<Uuid_Comparison_Exp>;
  cloned_from_scenario?: InputMaybe<Revisions_Scenarios_Journal_Bool_Exp>;
  correlations_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  display_unit_overrides?: InputMaybe<Jsonb_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  internal_notes?: InputMaybe<String_Comparison_Exp>;
  journal_id?: InputMaybe<Uuid_Comparison_Exp>;
  notes?: InputMaybe<String_Comparison_Exp>;
  parameters_id?: InputMaybe<Uuid_Comparison_Exp>;
  parent_revision_id?: InputMaybe<Uuid_Comparison_Exp>;
  parent_scenarios_revision?: InputMaybe<Revisions_Scenarios_Revisions_Bool_Exp>;
  pumping_type?: InputMaybe<Sizing_Pumping_Type_Enum_Comparison_Exp>;
  reason?: InputMaybe<Scenario_Reasons_Enum_Comparison_Exp>;
  scenario_correlations_journal?: InputMaybe<Revisions_Scenario_Correlations_Journal_Bool_Exp>;
  scenario_equipment_id?: InputMaybe<Uuid_Comparison_Exp>;
  scenario_equipment_journal?: InputMaybe<Revisions_Scenario_Equipment_Journal_Bool_Exp>;
  scenario_parameters_journal?: InputMaybe<Revisions_Scenario_Parameters_Journal_Bool_Exp>;
  scenario_reason?: InputMaybe<Scenario_Reasons_Bool_Exp>;
  scenario_well_properties_journal?: InputMaybe<Revisions_Scenario_Well_Properties_Journal_Bool_Exp>;
  scenarios_journal?: InputMaybe<Revisions_Scenarios_Journal_Bool_Exp>;
  scenarios_journals?: InputMaybe<Revisions_Scenarios_Journal_Bool_Exp>;
  scenarios_journals_aggregate?: InputMaybe<Revisions_Scenarios_Journal_Aggregate_Bool_Exp>;
  scenarios_revisions_parents?: InputMaybe<Revisions_Scenarios_Revisions_Bool_Exp>;
  scenarios_revisions_parents_aggregate?: InputMaybe<Revisions_Scenarios_Revisions_Aggregate_Bool_Exp>;
  scenarios_view?: InputMaybe<Scenarios_Bool_Exp>;
  sizing_id?: InputMaybe<Uuid_Comparison_Exp>;
  sizings_journal?: InputMaybe<Revisions_Sizings_Journal_Bool_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  well_properties_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "revisions.scenarios_revisions" */
export enum Revisions_Scenarios_Revisions_Constraint {
  /** unique or primary key constraint on columns "id" */
  ScenariosRevisionsPkey = 'scenarios_revisions_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Revisions_Scenarios_Revisions_Delete_At_Path_Input = {
  display_unit_overrides?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Revisions_Scenarios_Revisions_Delete_Elem_Input = {
  display_unit_overrides?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Revisions_Scenarios_Revisions_Delete_Key_Input = {
  display_unit_overrides?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "revisions.scenarios_revisions" */
export type Revisions_Scenarios_Revisions_Insert_Input = {
  author?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  author_id?: InputMaybe<Scalars['String']['input']>;
  cloned_from_journal_id?: InputMaybe<Scalars['uuid']['input']>;
  cloned_from_scenario?: InputMaybe<Revisions_Scenarios_Journal_Obj_Rel_Insert_Input>;
  correlations_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  display_unit_overrides?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  internal_notes?: InputMaybe<Scalars['String']['input']>;
  journal_id?: InputMaybe<Scalars['uuid']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  parameters_id?: InputMaybe<Scalars['uuid']['input']>;
  parent_revision_id?: InputMaybe<Scalars['uuid']['input']>;
  parent_scenarios_revision?: InputMaybe<Revisions_Scenarios_Revisions_Obj_Rel_Insert_Input>;
  pumping_type?: InputMaybe<Sizing_Pumping_Type_Enum>;
  reason?: InputMaybe<Scenario_Reasons_Enum>;
  scenario_correlations_journal?: InputMaybe<Revisions_Scenario_Correlations_Journal_Obj_Rel_Insert_Input>;
  scenario_equipment_id?: InputMaybe<Scalars['uuid']['input']>;
  scenario_equipment_journal?: InputMaybe<Revisions_Scenario_Equipment_Journal_Obj_Rel_Insert_Input>;
  scenario_parameters_journal?: InputMaybe<Revisions_Scenario_Parameters_Journal_Obj_Rel_Insert_Input>;
  scenario_reason?: InputMaybe<Scenario_Reasons_Obj_Rel_Insert_Input>;
  scenario_well_properties_journal?: InputMaybe<Revisions_Scenario_Well_Properties_Journal_Obj_Rel_Insert_Input>;
  scenarios_journal?: InputMaybe<Revisions_Scenarios_Journal_Obj_Rel_Insert_Input>;
  scenarios_journals?: InputMaybe<Revisions_Scenarios_Journal_Arr_Rel_Insert_Input>;
  scenarios_revisions_parents?: InputMaybe<Revisions_Scenarios_Revisions_Arr_Rel_Insert_Input>;
  scenarios_view?: InputMaybe<Scenarios_Obj_Rel_Insert_Input>;
  sizing_id?: InputMaybe<Scalars['uuid']['input']>;
  sizings_journal?: InputMaybe<Revisions_Sizings_Journal_Obj_Rel_Insert_Input>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  well_properties_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Revisions_Scenarios_Revisions_Max_Fields = {
  __typename: 'revisions_scenarios_revisions_max_fields';
  author_id?: Maybe<Scalars['String']['output']>;
  cloned_from_journal_id?: Maybe<Scalars['uuid']['output']>;
  correlations_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  internal_notes?: Maybe<Scalars['String']['output']>;
  journal_id?: Maybe<Scalars['uuid']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  parameters_id?: Maybe<Scalars['uuid']['output']>;
  parent_revision_id?: Maybe<Scalars['uuid']['output']>;
  scenario_equipment_id?: Maybe<Scalars['uuid']['output']>;
  sizing_id?: Maybe<Scalars['uuid']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  well_properties_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "revisions.scenarios_revisions" */
export type Revisions_Scenarios_Revisions_Max_Order_By = {
  author_id?: InputMaybe<Order_By>;
  cloned_from_journal_id?: InputMaybe<Order_By>;
  correlations_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  internal_notes?: InputMaybe<Order_By>;
  journal_id?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  parameters_id?: InputMaybe<Order_By>;
  parent_revision_id?: InputMaybe<Order_By>;
  scenario_equipment_id?: InputMaybe<Order_By>;
  sizing_id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  well_properties_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Revisions_Scenarios_Revisions_Min_Fields = {
  __typename: 'revisions_scenarios_revisions_min_fields';
  author_id?: Maybe<Scalars['String']['output']>;
  cloned_from_journal_id?: Maybe<Scalars['uuid']['output']>;
  correlations_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  internal_notes?: Maybe<Scalars['String']['output']>;
  journal_id?: Maybe<Scalars['uuid']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  parameters_id?: Maybe<Scalars['uuid']['output']>;
  parent_revision_id?: Maybe<Scalars['uuid']['output']>;
  scenario_equipment_id?: Maybe<Scalars['uuid']['output']>;
  sizing_id?: Maybe<Scalars['uuid']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  well_properties_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "revisions.scenarios_revisions" */
export type Revisions_Scenarios_Revisions_Min_Order_By = {
  author_id?: InputMaybe<Order_By>;
  cloned_from_journal_id?: InputMaybe<Order_By>;
  correlations_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  internal_notes?: InputMaybe<Order_By>;
  journal_id?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  parameters_id?: InputMaybe<Order_By>;
  parent_revision_id?: InputMaybe<Order_By>;
  scenario_equipment_id?: InputMaybe<Order_By>;
  sizing_id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  well_properties_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "revisions.scenarios_revisions" */
export type Revisions_Scenarios_Revisions_Mutation_Response = {
  __typename: 'revisions_scenarios_revisions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Revisions_Scenarios_Revisions>;
};

/** input type for inserting object relation for remote table "revisions.scenarios_revisions" */
export type Revisions_Scenarios_Revisions_Obj_Rel_Insert_Input = {
  data: Revisions_Scenarios_Revisions_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Revisions_Scenarios_Revisions_On_Conflict>;
};

/** on_conflict condition type for table "revisions.scenarios_revisions" */
export type Revisions_Scenarios_Revisions_On_Conflict = {
  constraint: Revisions_Scenarios_Revisions_Constraint;
  update_columns?: Array<Revisions_Scenarios_Revisions_Update_Column>;
  where?: InputMaybe<Revisions_Scenarios_Revisions_Bool_Exp>;
};

/** Ordering options when selecting data from "revisions.scenarios_revisions". */
export type Revisions_Scenarios_Revisions_Order_By = {
  author?: InputMaybe<Users_Order_By>;
  author_id?: InputMaybe<Order_By>;
  cloned_from_journal_id?: InputMaybe<Order_By>;
  cloned_from_scenario?: InputMaybe<Revisions_Scenarios_Journal_Order_By>;
  correlations_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  display_unit_overrides?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  internal_notes?: InputMaybe<Order_By>;
  journal_id?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  parameters_id?: InputMaybe<Order_By>;
  parent_revision_id?: InputMaybe<Order_By>;
  parent_scenarios_revision?: InputMaybe<Revisions_Scenarios_Revisions_Order_By>;
  pumping_type?: InputMaybe<Order_By>;
  reason?: InputMaybe<Order_By>;
  scenario_correlations_journal?: InputMaybe<Revisions_Scenario_Correlations_Journal_Order_By>;
  scenario_equipment_id?: InputMaybe<Order_By>;
  scenario_equipment_journal?: InputMaybe<Revisions_Scenario_Equipment_Journal_Order_By>;
  scenario_parameters_journal?: InputMaybe<Revisions_Scenario_Parameters_Journal_Order_By>;
  scenario_reason?: InputMaybe<Scenario_Reasons_Order_By>;
  scenario_well_properties_journal?: InputMaybe<Revisions_Scenario_Well_Properties_Journal_Order_By>;
  scenarios_journal?: InputMaybe<Revisions_Scenarios_Journal_Order_By>;
  scenarios_journals_aggregate?: InputMaybe<Revisions_Scenarios_Journal_Aggregate_Order_By>;
  scenarios_revisions_parents_aggregate?: InputMaybe<Revisions_Scenarios_Revisions_Aggregate_Order_By>;
  scenarios_view?: InputMaybe<Scenarios_Order_By>;
  sizing_id?: InputMaybe<Order_By>;
  sizings_journal?: InputMaybe<Revisions_Sizings_Journal_Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  well_properties_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: revisions.scenarios_revisions */
export type Revisions_Scenarios_Revisions_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Revisions_Scenarios_Revisions_Prepend_Input = {
  display_unit_overrides?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "revisions.scenarios_revisions" */
export enum Revisions_Scenarios_Revisions_Select_Column {
  /** column name */
  AuthorId = 'author_id',
  /** column name */
  ClonedFromJournalId = 'cloned_from_journal_id',
  /** column name */
  CorrelationsId = 'correlations_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  DisplayUnitOverrides = 'display_unit_overrides',
  /** column name */
  Id = 'id',
  /** column name */
  InternalNotes = 'internal_notes',
  /** column name */
  JournalId = 'journal_id',
  /** column name */
  Notes = 'notes',
  /** column name */
  ParametersId = 'parameters_id',
  /** column name */
  ParentRevisionId = 'parent_revision_id',
  /** column name */
  PumpingType = 'pumping_type',
  /** column name */
  Reason = 'reason',
  /** column name */
  ScenarioEquipmentId = 'scenario_equipment_id',
  /** column name */
  SizingId = 'sizing_id',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WellPropertiesId = 'well_properties_id'
}

/** input type for updating data in table "revisions.scenarios_revisions" */
export type Revisions_Scenarios_Revisions_Set_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  cloned_from_journal_id?: InputMaybe<Scalars['uuid']['input']>;
  correlations_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  display_unit_overrides?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  internal_notes?: InputMaybe<Scalars['String']['input']>;
  journal_id?: InputMaybe<Scalars['uuid']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  parameters_id?: InputMaybe<Scalars['uuid']['input']>;
  parent_revision_id?: InputMaybe<Scalars['uuid']['input']>;
  pumping_type?: InputMaybe<Sizing_Pumping_Type_Enum>;
  reason?: InputMaybe<Scenario_Reasons_Enum>;
  scenario_equipment_id?: InputMaybe<Scalars['uuid']['input']>;
  sizing_id?: InputMaybe<Scalars['uuid']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  well_properties_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "revisions_scenarios_revisions" */
export type Revisions_Scenarios_Revisions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Revisions_Scenarios_Revisions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Revisions_Scenarios_Revisions_Stream_Cursor_Value_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  cloned_from_journal_id?: InputMaybe<Scalars['uuid']['input']>;
  correlations_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  display_unit_overrides?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  internal_notes?: InputMaybe<Scalars['String']['input']>;
  journal_id?: InputMaybe<Scalars['uuid']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  parameters_id?: InputMaybe<Scalars['uuid']['input']>;
  parent_revision_id?: InputMaybe<Scalars['uuid']['input']>;
  pumping_type?: InputMaybe<Sizing_Pumping_Type_Enum>;
  reason?: InputMaybe<Scenario_Reasons_Enum>;
  scenario_equipment_id?: InputMaybe<Scalars['uuid']['input']>;
  sizing_id?: InputMaybe<Scalars['uuid']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  well_properties_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "revisions.scenarios_revisions" */
export enum Revisions_Scenarios_Revisions_Update_Column {
  /** column name */
  AuthorId = 'author_id',
  /** column name */
  ClonedFromJournalId = 'cloned_from_journal_id',
  /** column name */
  CorrelationsId = 'correlations_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  DisplayUnitOverrides = 'display_unit_overrides',
  /** column name */
  Id = 'id',
  /** column name */
  InternalNotes = 'internal_notes',
  /** column name */
  JournalId = 'journal_id',
  /** column name */
  Notes = 'notes',
  /** column name */
  ParametersId = 'parameters_id',
  /** column name */
  ParentRevisionId = 'parent_revision_id',
  /** column name */
  PumpingType = 'pumping_type',
  /** column name */
  Reason = 'reason',
  /** column name */
  ScenarioEquipmentId = 'scenario_equipment_id',
  /** column name */
  SizingId = 'sizing_id',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WellPropertiesId = 'well_properties_id'
}

export type Revisions_Scenarios_Revisions_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Revisions_Scenarios_Revisions_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Revisions_Scenarios_Revisions_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Revisions_Scenarios_Revisions_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Revisions_Scenarios_Revisions_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Revisions_Scenarios_Revisions_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Revisions_Scenarios_Revisions_Set_Input>;
  /** filter the rows which have to be updated */
  where: Revisions_Scenarios_Revisions_Bool_Exp;
};

/** columns and relationships of "revisions.sizings_journal" */
export type Revisions_Sizings_Journal = {
  __typename: 'revisions_sizings_journal';
  /** An object relationship */
  author: Users;
  author_id: Scalars['String']['output'];
  created_at: Scalars['timestamptz']['output'];
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  parent_journal_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  parent_sizings_journal?: Maybe<Revisions_Sizings_Journal>;
  /** An array relationship */
  scenarios_revisions: Array<Revisions_Scenarios_Revisions>;
  /** An aggregate relationship */
  scenarios_revisions_aggregate: Revisions_Scenarios_Revisions_Aggregate;
  /** An array relationship */
  sizings_journals_children: Array<Revisions_Sizings_Journal>;
  /** An aggregate relationship */
  sizings_journals_children_aggregate: Revisions_Sizings_Journal_Aggregate;
  /** An array relationship */
  sizings_revisions: Array<Revisions_Sizings_Revisions>;
  /** An aggregate relationship */
  sizings_revisions_aggregate: Revisions_Sizings_Revisions_Aggregate;
  updated_at: Scalars['timestamptz']['output'];
  winning_revision_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  winning_sizings_revision?: Maybe<Revisions_Sizings_Revisions>;
};


/** columns and relationships of "revisions.sizings_journal" */
export type Revisions_Sizings_JournalScenarios_RevisionsArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenarios_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenarios_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Scenarios_Revisions_Bool_Exp>;
};


/** columns and relationships of "revisions.sizings_journal" */
export type Revisions_Sizings_JournalScenarios_Revisions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenarios_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenarios_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Scenarios_Revisions_Bool_Exp>;
};


/** columns and relationships of "revisions.sizings_journal" */
export type Revisions_Sizings_JournalSizings_Journals_ChildrenArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Sizings_Journal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Sizings_Journal_Order_By>>;
  where?: InputMaybe<Revisions_Sizings_Journal_Bool_Exp>;
};


/** columns and relationships of "revisions.sizings_journal" */
export type Revisions_Sizings_JournalSizings_Journals_Children_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Sizings_Journal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Sizings_Journal_Order_By>>;
  where?: InputMaybe<Revisions_Sizings_Journal_Bool_Exp>;
};


/** columns and relationships of "revisions.sizings_journal" */
export type Revisions_Sizings_JournalSizings_RevisionsArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Sizings_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Sizings_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Sizings_Revisions_Bool_Exp>;
};


/** columns and relationships of "revisions.sizings_journal" */
export type Revisions_Sizings_JournalSizings_Revisions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Sizings_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Sizings_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Sizings_Revisions_Bool_Exp>;
};

/** aggregated selection of "revisions.sizings_journal" */
export type Revisions_Sizings_Journal_Aggregate = {
  __typename: 'revisions_sizings_journal_aggregate';
  aggregate?: Maybe<Revisions_Sizings_Journal_Aggregate_Fields>;
  nodes: Array<Revisions_Sizings_Journal>;
};

export type Revisions_Sizings_Journal_Aggregate_Bool_Exp = {
  count?: InputMaybe<Revisions_Sizings_Journal_Aggregate_Bool_Exp_Count>;
};

export type Revisions_Sizings_Journal_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Revisions_Sizings_Journal_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Revisions_Sizings_Journal_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "revisions.sizings_journal" */
export type Revisions_Sizings_Journal_Aggregate_Fields = {
  __typename: 'revisions_sizings_journal_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Revisions_Sizings_Journal_Max_Fields>;
  min?: Maybe<Revisions_Sizings_Journal_Min_Fields>;
};


/** aggregate fields of "revisions.sizings_journal" */
export type Revisions_Sizings_Journal_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Revisions_Sizings_Journal_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "revisions.sizings_journal" */
export type Revisions_Sizings_Journal_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Revisions_Sizings_Journal_Max_Order_By>;
  min?: InputMaybe<Revisions_Sizings_Journal_Min_Order_By>;
};

/** input type for inserting array relation for remote table "revisions.sizings_journal" */
export type Revisions_Sizings_Journal_Arr_Rel_Insert_Input = {
  data: Array<Revisions_Sizings_Journal_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Revisions_Sizings_Journal_On_Conflict>;
};

/** Boolean expression to filter rows from the table "revisions.sizings_journal". All fields are combined with a logical 'AND'. */
export type Revisions_Sizings_Journal_Bool_Exp = {
  _and?: InputMaybe<Array<Revisions_Sizings_Journal_Bool_Exp>>;
  _not?: InputMaybe<Revisions_Sizings_Journal_Bool_Exp>;
  _or?: InputMaybe<Array<Revisions_Sizings_Journal_Bool_Exp>>;
  author?: InputMaybe<Users_Bool_Exp>;
  author_id?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  parent_journal_id?: InputMaybe<Uuid_Comparison_Exp>;
  parent_sizings_journal?: InputMaybe<Revisions_Sizings_Journal_Bool_Exp>;
  scenarios_revisions?: InputMaybe<Revisions_Scenarios_Revisions_Bool_Exp>;
  scenarios_revisions_aggregate?: InputMaybe<Revisions_Scenarios_Revisions_Aggregate_Bool_Exp>;
  sizings_journals_children?: InputMaybe<Revisions_Sizings_Journal_Bool_Exp>;
  sizings_journals_children_aggregate?: InputMaybe<Revisions_Sizings_Journal_Aggregate_Bool_Exp>;
  sizings_revisions?: InputMaybe<Revisions_Sizings_Revisions_Bool_Exp>;
  sizings_revisions_aggregate?: InputMaybe<Revisions_Sizings_Revisions_Aggregate_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  winning_revision_id?: InputMaybe<Uuid_Comparison_Exp>;
  winning_sizings_revision?: InputMaybe<Revisions_Sizings_Revisions_Bool_Exp>;
};

/** unique or primary key constraints on table "revisions.sizings_journal" */
export enum Revisions_Sizings_Journal_Constraint {
  /** unique or primary key constraint on columns "id" */
  SizingsJournalPkey = 'sizings_journal_pkey'
}

/** input type for inserting data into table "revisions.sizings_journal" */
export type Revisions_Sizings_Journal_Insert_Input = {
  author?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  author_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  parent_journal_id?: InputMaybe<Scalars['uuid']['input']>;
  parent_sizings_journal?: InputMaybe<Revisions_Sizings_Journal_Obj_Rel_Insert_Input>;
  scenarios_revisions?: InputMaybe<Revisions_Scenarios_Revisions_Arr_Rel_Insert_Input>;
  sizings_journals_children?: InputMaybe<Revisions_Sizings_Journal_Arr_Rel_Insert_Input>;
  sizings_revisions?: InputMaybe<Revisions_Sizings_Revisions_Arr_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  winning_revision_id?: InputMaybe<Scalars['uuid']['input']>;
  winning_sizings_revision?: InputMaybe<Revisions_Sizings_Revisions_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Revisions_Sizings_Journal_Max_Fields = {
  __typename: 'revisions_sizings_journal_max_fields';
  author_id?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  parent_journal_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  winning_revision_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "revisions.sizings_journal" */
export type Revisions_Sizings_Journal_Max_Order_By = {
  author_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parent_journal_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  winning_revision_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Revisions_Sizings_Journal_Min_Fields = {
  __typename: 'revisions_sizings_journal_min_fields';
  author_id?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  parent_journal_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  winning_revision_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "revisions.sizings_journal" */
export type Revisions_Sizings_Journal_Min_Order_By = {
  author_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parent_journal_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  winning_revision_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "revisions.sizings_journal" */
export type Revisions_Sizings_Journal_Mutation_Response = {
  __typename: 'revisions_sizings_journal_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Revisions_Sizings_Journal>;
};

/** input type for inserting object relation for remote table "revisions.sizings_journal" */
export type Revisions_Sizings_Journal_Obj_Rel_Insert_Input = {
  data: Revisions_Sizings_Journal_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Revisions_Sizings_Journal_On_Conflict>;
};

/** on_conflict condition type for table "revisions.sizings_journal" */
export type Revisions_Sizings_Journal_On_Conflict = {
  constraint: Revisions_Sizings_Journal_Constraint;
  update_columns?: Array<Revisions_Sizings_Journal_Update_Column>;
  where?: InputMaybe<Revisions_Sizings_Journal_Bool_Exp>;
};

/** Ordering options when selecting data from "revisions.sizings_journal". */
export type Revisions_Sizings_Journal_Order_By = {
  author?: InputMaybe<Users_Order_By>;
  author_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parent_journal_id?: InputMaybe<Order_By>;
  parent_sizings_journal?: InputMaybe<Revisions_Sizings_Journal_Order_By>;
  scenarios_revisions_aggregate?: InputMaybe<Revisions_Scenarios_Revisions_Aggregate_Order_By>;
  sizings_journals_children_aggregate?: InputMaybe<Revisions_Sizings_Journal_Aggregate_Order_By>;
  sizings_revisions_aggregate?: InputMaybe<Revisions_Sizings_Revisions_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  winning_revision_id?: InputMaybe<Order_By>;
  winning_sizings_revision?: InputMaybe<Revisions_Sizings_Revisions_Order_By>;
};

/** primary key columns input for table: revisions.sizings_journal */
export type Revisions_Sizings_Journal_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "revisions.sizings_journal" */
export enum Revisions_Sizings_Journal_Select_Column {
  /** column name */
  AuthorId = 'author_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  ParentJournalId = 'parent_journal_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WinningRevisionId = 'winning_revision_id'
}

/** input type for updating data in table "revisions.sizings_journal" */
export type Revisions_Sizings_Journal_Set_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  parent_journal_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  winning_revision_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "revisions_sizings_journal" */
export type Revisions_Sizings_Journal_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Revisions_Sizings_Journal_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Revisions_Sizings_Journal_Stream_Cursor_Value_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  parent_journal_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  winning_revision_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "revisions.sizings_journal" */
export enum Revisions_Sizings_Journal_Update_Column {
  /** column name */
  AuthorId = 'author_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  ParentJournalId = 'parent_journal_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WinningRevisionId = 'winning_revision_id'
}

export type Revisions_Sizings_Journal_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Revisions_Sizings_Journal_Set_Input>;
  /** filter the rows which have to be updated */
  where: Revisions_Sizings_Journal_Bool_Exp;
};

/** columns and relationships of "revisions.sizings_revisions" */
export type Revisions_Sizings_Revisions = {
  __typename: 'revisions_sizings_revisions';
  /** An object relationship */
  author: Users;
  author_id: Scalars['String']['output'];
  cloned_from_journal_id?: Maybe<Scalars['uuid']['output']>;
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  customer?: Maybe<Customers>;
  customer_id?: Maybe<Scalars['Int']['output']>;
  default_display_units: Display_Units_Enum;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  display_unit: Display_Units;
  disposition: Sizing_Dispositions_Enum;
  hps_location?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  imported_sizing_id?: Maybe<Scalars['Int']['output']>;
  installed_scenario_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  installed_scenarios_journal?: Maybe<Revisions_Scenarios_Journal>;
  is_shared?: Maybe<Scalars['Boolean']['output']>;
  journal_id: Scalars['uuid']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  parent_revision_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  parent_sizings_revision?: Maybe<Revisions_Sizings_Revisions>;
  pumping_type: Sizing_Pumping_Type_Enum;
  scenario_order: Array<Scalars['uuid']['output']>;
  share_with_customer: Scalars['Boolean']['output'];
  /** An object relationship */
  sizing_disposition: Sizing_Dispositions;
  /** An object relationship */
  sizing_import?: Maybe<Sizing_Imports>;
  /** An object relationship */
  sizings_journal: Revisions_Sizings_Journal;
  /** An array relationship */
  sizings_journals: Array<Revisions_Sizings_Journal>;
  /** An aggregate relationship */
  sizings_journals_aggregate: Revisions_Sizings_Journal_Aggregate;
  /** An array relationship */
  sizings_revisions_parents: Array<Revisions_Sizings_Revisions>;
  /** An aggregate relationship */
  sizings_revisions_parents_aggregate: Revisions_Sizings_Revisions_Aggregate;
  /** An object relationship */
  sizings_view?: Maybe<Sizings>;
  title?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  well?: Maybe<Wells>;
  well_id?: Maybe<Scalars['Int']['output']>;
};


/** columns and relationships of "revisions.sizings_revisions" */
export type Revisions_Sizings_RevisionsSizings_JournalsArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Sizings_Journal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Sizings_Journal_Order_By>>;
  where?: InputMaybe<Revisions_Sizings_Journal_Bool_Exp>;
};


/** columns and relationships of "revisions.sizings_revisions" */
export type Revisions_Sizings_RevisionsSizings_Journals_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Sizings_Journal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Sizings_Journal_Order_By>>;
  where?: InputMaybe<Revisions_Sizings_Journal_Bool_Exp>;
};


/** columns and relationships of "revisions.sizings_revisions" */
export type Revisions_Sizings_RevisionsSizings_Revisions_ParentsArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Sizings_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Sizings_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Sizings_Revisions_Bool_Exp>;
};


/** columns and relationships of "revisions.sizings_revisions" */
export type Revisions_Sizings_RevisionsSizings_Revisions_Parents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Sizings_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Sizings_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Sizings_Revisions_Bool_Exp>;
};

/** aggregated selection of "revisions.sizings_revisions" */
export type Revisions_Sizings_Revisions_Aggregate = {
  __typename: 'revisions_sizings_revisions_aggregate';
  aggregate?: Maybe<Revisions_Sizings_Revisions_Aggregate_Fields>;
  nodes: Array<Revisions_Sizings_Revisions>;
};

export type Revisions_Sizings_Revisions_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Revisions_Sizings_Revisions_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Revisions_Sizings_Revisions_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Revisions_Sizings_Revisions_Aggregate_Bool_Exp_Count>;
};

export type Revisions_Sizings_Revisions_Aggregate_Bool_Exp_Bool_And = {
  arguments: Revisions_Sizings_Revisions_Select_Column_Revisions_Sizings_Revisions_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Revisions_Sizings_Revisions_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Revisions_Sizings_Revisions_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Revisions_Sizings_Revisions_Select_Column_Revisions_Sizings_Revisions_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Revisions_Sizings_Revisions_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Revisions_Sizings_Revisions_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Revisions_Sizings_Revisions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Revisions_Sizings_Revisions_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "revisions.sizings_revisions" */
export type Revisions_Sizings_Revisions_Aggregate_Fields = {
  __typename: 'revisions_sizings_revisions_aggregate_fields';
  avg?: Maybe<Revisions_Sizings_Revisions_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Revisions_Sizings_Revisions_Max_Fields>;
  min?: Maybe<Revisions_Sizings_Revisions_Min_Fields>;
  stddev?: Maybe<Revisions_Sizings_Revisions_Stddev_Fields>;
  stddev_pop?: Maybe<Revisions_Sizings_Revisions_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Revisions_Sizings_Revisions_Stddev_Samp_Fields>;
  sum?: Maybe<Revisions_Sizings_Revisions_Sum_Fields>;
  var_pop?: Maybe<Revisions_Sizings_Revisions_Var_Pop_Fields>;
  var_samp?: Maybe<Revisions_Sizings_Revisions_Var_Samp_Fields>;
  variance?: Maybe<Revisions_Sizings_Revisions_Variance_Fields>;
};


/** aggregate fields of "revisions.sizings_revisions" */
export type Revisions_Sizings_Revisions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Revisions_Sizings_Revisions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "revisions.sizings_revisions" */
export type Revisions_Sizings_Revisions_Aggregate_Order_By = {
  avg?: InputMaybe<Revisions_Sizings_Revisions_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Revisions_Sizings_Revisions_Max_Order_By>;
  min?: InputMaybe<Revisions_Sizings_Revisions_Min_Order_By>;
  stddev?: InputMaybe<Revisions_Sizings_Revisions_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Revisions_Sizings_Revisions_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Revisions_Sizings_Revisions_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Revisions_Sizings_Revisions_Sum_Order_By>;
  var_pop?: InputMaybe<Revisions_Sizings_Revisions_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Revisions_Sizings_Revisions_Var_Samp_Order_By>;
  variance?: InputMaybe<Revisions_Sizings_Revisions_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "revisions.sizings_revisions" */
export type Revisions_Sizings_Revisions_Arr_Rel_Insert_Input = {
  data: Array<Revisions_Sizings_Revisions_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Revisions_Sizings_Revisions_On_Conflict>;
};

/** aggregate avg on columns */
export type Revisions_Sizings_Revisions_Avg_Fields = {
  __typename: 'revisions_sizings_revisions_avg_fields';
  customer_id?: Maybe<Scalars['Float']['output']>;
  imported_sizing_id?: Maybe<Scalars['Float']['output']>;
  well_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "revisions.sizings_revisions" */
export type Revisions_Sizings_Revisions_Avg_Order_By = {
  customer_id?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  well_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "revisions.sizings_revisions". All fields are combined with a logical 'AND'. */
export type Revisions_Sizings_Revisions_Bool_Exp = {
  _and?: InputMaybe<Array<Revisions_Sizings_Revisions_Bool_Exp>>;
  _not?: InputMaybe<Revisions_Sizings_Revisions_Bool_Exp>;
  _or?: InputMaybe<Array<Revisions_Sizings_Revisions_Bool_Exp>>;
  author?: InputMaybe<Users_Bool_Exp>;
  author_id?: InputMaybe<String_Comparison_Exp>;
  cloned_from_journal_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  customer?: InputMaybe<Customers_Bool_Exp>;
  customer_id?: InputMaybe<Int_Comparison_Exp>;
  default_display_units?: InputMaybe<Display_Units_Enum_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  display_unit?: InputMaybe<Display_Units_Bool_Exp>;
  disposition?: InputMaybe<Sizing_Dispositions_Enum_Comparison_Exp>;
  hps_location?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  imported_sizing_id?: InputMaybe<Int_Comparison_Exp>;
  installed_scenario_id?: InputMaybe<Uuid_Comparison_Exp>;
  installed_scenarios_journal?: InputMaybe<Revisions_Scenarios_Journal_Bool_Exp>;
  is_shared?: InputMaybe<Boolean_Comparison_Exp>;
  journal_id?: InputMaybe<Uuid_Comparison_Exp>;
  notes?: InputMaybe<String_Comparison_Exp>;
  parent_revision_id?: InputMaybe<Uuid_Comparison_Exp>;
  parent_sizings_revision?: InputMaybe<Revisions_Sizings_Revisions_Bool_Exp>;
  pumping_type?: InputMaybe<Sizing_Pumping_Type_Enum_Comparison_Exp>;
  scenario_order?: InputMaybe<Uuid_Array_Comparison_Exp>;
  share_with_customer?: InputMaybe<Boolean_Comparison_Exp>;
  sizing_disposition?: InputMaybe<Sizing_Dispositions_Bool_Exp>;
  sizing_import?: InputMaybe<Sizing_Imports_Bool_Exp>;
  sizings_journal?: InputMaybe<Revisions_Sizings_Journal_Bool_Exp>;
  sizings_journals?: InputMaybe<Revisions_Sizings_Journal_Bool_Exp>;
  sizings_journals_aggregate?: InputMaybe<Revisions_Sizings_Journal_Aggregate_Bool_Exp>;
  sizings_revisions_parents?: InputMaybe<Revisions_Sizings_Revisions_Bool_Exp>;
  sizings_revisions_parents_aggregate?: InputMaybe<Revisions_Sizings_Revisions_Aggregate_Bool_Exp>;
  sizings_view?: InputMaybe<Sizings_Bool_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  well?: InputMaybe<Wells_Bool_Exp>;
  well_id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "revisions.sizings_revisions" */
export enum Revisions_Sizings_Revisions_Constraint {
  /** unique or primary key constraint on columns "id" */
  SizingsRevisionsPkey = 'sizings_revisions_pkey'
}

/** input type for incrementing numeric columns in table "revisions.sizings_revisions" */
export type Revisions_Sizings_Revisions_Inc_Input = {
  customer_id?: InputMaybe<Scalars['Int']['input']>;
  imported_sizing_id?: InputMaybe<Scalars['Int']['input']>;
  well_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "revisions.sizings_revisions" */
export type Revisions_Sizings_Revisions_Insert_Input = {
  author?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  author_id?: InputMaybe<Scalars['String']['input']>;
  cloned_from_journal_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  customer?: InputMaybe<Customers_Obj_Rel_Insert_Input>;
  customer_id?: InputMaybe<Scalars['Int']['input']>;
  default_display_units?: InputMaybe<Display_Units_Enum>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  display_unit?: InputMaybe<Display_Units_Obj_Rel_Insert_Input>;
  disposition?: InputMaybe<Sizing_Dispositions_Enum>;
  hps_location?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  imported_sizing_id?: InputMaybe<Scalars['Int']['input']>;
  installed_scenario_id?: InputMaybe<Scalars['uuid']['input']>;
  installed_scenarios_journal?: InputMaybe<Revisions_Scenarios_Journal_Obj_Rel_Insert_Input>;
  is_shared?: InputMaybe<Scalars['Boolean']['input']>;
  journal_id?: InputMaybe<Scalars['uuid']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  parent_revision_id?: InputMaybe<Scalars['uuid']['input']>;
  parent_sizings_revision?: InputMaybe<Revisions_Sizings_Revisions_Obj_Rel_Insert_Input>;
  pumping_type?: InputMaybe<Sizing_Pumping_Type_Enum>;
  scenario_order?: InputMaybe<Array<Scalars['uuid']['input']>>;
  share_with_customer?: InputMaybe<Scalars['Boolean']['input']>;
  sizing_disposition?: InputMaybe<Sizing_Dispositions_Obj_Rel_Insert_Input>;
  sizing_import?: InputMaybe<Sizing_Imports_Obj_Rel_Insert_Input>;
  sizings_journal?: InputMaybe<Revisions_Sizings_Journal_Obj_Rel_Insert_Input>;
  sizings_journals?: InputMaybe<Revisions_Sizings_Journal_Arr_Rel_Insert_Input>;
  sizings_revisions_parents?: InputMaybe<Revisions_Sizings_Revisions_Arr_Rel_Insert_Input>;
  sizings_view?: InputMaybe<Sizings_Obj_Rel_Insert_Input>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  well?: InputMaybe<Wells_Obj_Rel_Insert_Input>;
  well_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type Revisions_Sizings_Revisions_Max_Fields = {
  __typename: 'revisions_sizings_revisions_max_fields';
  author_id?: Maybe<Scalars['String']['output']>;
  cloned_from_journal_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  customer_id?: Maybe<Scalars['Int']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  hps_location?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  imported_sizing_id?: Maybe<Scalars['Int']['output']>;
  installed_scenario_id?: Maybe<Scalars['uuid']['output']>;
  journal_id?: Maybe<Scalars['uuid']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  parent_revision_id?: Maybe<Scalars['uuid']['output']>;
  scenario_order?: Maybe<Array<Scalars['uuid']['output']>>;
  title?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  well_id?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "revisions.sizings_revisions" */
export type Revisions_Sizings_Revisions_Max_Order_By = {
  author_id?: InputMaybe<Order_By>;
  cloned_from_journal_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  customer_id?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  hps_location?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  installed_scenario_id?: InputMaybe<Order_By>;
  journal_id?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  parent_revision_id?: InputMaybe<Order_By>;
  scenario_order?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  well_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Revisions_Sizings_Revisions_Min_Fields = {
  __typename: 'revisions_sizings_revisions_min_fields';
  author_id?: Maybe<Scalars['String']['output']>;
  cloned_from_journal_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  customer_id?: Maybe<Scalars['Int']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  hps_location?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  imported_sizing_id?: Maybe<Scalars['Int']['output']>;
  installed_scenario_id?: Maybe<Scalars['uuid']['output']>;
  journal_id?: Maybe<Scalars['uuid']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  parent_revision_id?: Maybe<Scalars['uuid']['output']>;
  scenario_order?: Maybe<Array<Scalars['uuid']['output']>>;
  title?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  well_id?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "revisions.sizings_revisions" */
export type Revisions_Sizings_Revisions_Min_Order_By = {
  author_id?: InputMaybe<Order_By>;
  cloned_from_journal_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  customer_id?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  hps_location?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  installed_scenario_id?: InputMaybe<Order_By>;
  journal_id?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  parent_revision_id?: InputMaybe<Order_By>;
  scenario_order?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  well_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "revisions.sizings_revisions" */
export type Revisions_Sizings_Revisions_Mutation_Response = {
  __typename: 'revisions_sizings_revisions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Revisions_Sizings_Revisions>;
};

/** input type for inserting object relation for remote table "revisions.sizings_revisions" */
export type Revisions_Sizings_Revisions_Obj_Rel_Insert_Input = {
  data: Revisions_Sizings_Revisions_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Revisions_Sizings_Revisions_On_Conflict>;
};

/** on_conflict condition type for table "revisions.sizings_revisions" */
export type Revisions_Sizings_Revisions_On_Conflict = {
  constraint: Revisions_Sizings_Revisions_Constraint;
  update_columns?: Array<Revisions_Sizings_Revisions_Update_Column>;
  where?: InputMaybe<Revisions_Sizings_Revisions_Bool_Exp>;
};

/** Ordering options when selecting data from "revisions.sizings_revisions". */
export type Revisions_Sizings_Revisions_Order_By = {
  author?: InputMaybe<Users_Order_By>;
  author_id?: InputMaybe<Order_By>;
  cloned_from_journal_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  customer?: InputMaybe<Customers_Order_By>;
  customer_id?: InputMaybe<Order_By>;
  default_display_units?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  display_unit?: InputMaybe<Display_Units_Order_By>;
  disposition?: InputMaybe<Order_By>;
  hps_location?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  installed_scenario_id?: InputMaybe<Order_By>;
  installed_scenarios_journal?: InputMaybe<Revisions_Scenarios_Journal_Order_By>;
  is_shared?: InputMaybe<Order_By>;
  journal_id?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  parent_revision_id?: InputMaybe<Order_By>;
  parent_sizings_revision?: InputMaybe<Revisions_Sizings_Revisions_Order_By>;
  pumping_type?: InputMaybe<Order_By>;
  scenario_order?: InputMaybe<Order_By>;
  share_with_customer?: InputMaybe<Order_By>;
  sizing_disposition?: InputMaybe<Sizing_Dispositions_Order_By>;
  sizing_import?: InputMaybe<Sizing_Imports_Order_By>;
  sizings_journal?: InputMaybe<Revisions_Sizings_Journal_Order_By>;
  sizings_journals_aggregate?: InputMaybe<Revisions_Sizings_Journal_Aggregate_Order_By>;
  sizings_revisions_parents_aggregate?: InputMaybe<Revisions_Sizings_Revisions_Aggregate_Order_By>;
  sizings_view?: InputMaybe<Sizings_Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  well?: InputMaybe<Wells_Order_By>;
  well_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: revisions.sizings_revisions */
export type Revisions_Sizings_Revisions_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "revisions.sizings_revisions" */
export enum Revisions_Sizings_Revisions_Select_Column {
  /** column name */
  AuthorId = 'author_id',
  /** column name */
  ClonedFromJournalId = 'cloned_from_journal_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CustomerId = 'customer_id',
  /** column name */
  DefaultDisplayUnits = 'default_display_units',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Disposition = 'disposition',
  /** column name */
  HpsLocation = 'hps_location',
  /** column name */
  Id = 'id',
  /** column name */
  ImportedSizingId = 'imported_sizing_id',
  /** column name */
  InstalledScenarioId = 'installed_scenario_id',
  /** column name */
  IsShared = 'is_shared',
  /** column name */
  JournalId = 'journal_id',
  /** column name */
  Notes = 'notes',
  /** column name */
  ParentRevisionId = 'parent_revision_id',
  /** column name */
  PumpingType = 'pumping_type',
  /** column name */
  ScenarioOrder = 'scenario_order',
  /** column name */
  ShareWithCustomer = 'share_with_customer',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WellId = 'well_id'
}

/** select "revisions_sizings_revisions_aggregate_bool_exp_bool_and_arguments_columns" columns of table "revisions.sizings_revisions" */
export enum Revisions_Sizings_Revisions_Select_Column_Revisions_Sizings_Revisions_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsShared = 'is_shared',
  /** column name */
  ShareWithCustomer = 'share_with_customer'
}

/** select "revisions_sizings_revisions_aggregate_bool_exp_bool_or_arguments_columns" columns of table "revisions.sizings_revisions" */
export enum Revisions_Sizings_Revisions_Select_Column_Revisions_Sizings_Revisions_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsShared = 'is_shared',
  /** column name */
  ShareWithCustomer = 'share_with_customer'
}

/** input type for updating data in table "revisions.sizings_revisions" */
export type Revisions_Sizings_Revisions_Set_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  cloned_from_journal_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  customer_id?: InputMaybe<Scalars['Int']['input']>;
  default_display_units?: InputMaybe<Display_Units_Enum>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  disposition?: InputMaybe<Sizing_Dispositions_Enum>;
  hps_location?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  imported_sizing_id?: InputMaybe<Scalars['Int']['input']>;
  installed_scenario_id?: InputMaybe<Scalars['uuid']['input']>;
  is_shared?: InputMaybe<Scalars['Boolean']['input']>;
  journal_id?: InputMaybe<Scalars['uuid']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  parent_revision_id?: InputMaybe<Scalars['uuid']['input']>;
  pumping_type?: InputMaybe<Sizing_Pumping_Type_Enum>;
  scenario_order?: InputMaybe<Array<Scalars['uuid']['input']>>;
  share_with_customer?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  well_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Revisions_Sizings_Revisions_Stddev_Fields = {
  __typename: 'revisions_sizings_revisions_stddev_fields';
  customer_id?: Maybe<Scalars['Float']['output']>;
  imported_sizing_id?: Maybe<Scalars['Float']['output']>;
  well_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "revisions.sizings_revisions" */
export type Revisions_Sizings_Revisions_Stddev_Order_By = {
  customer_id?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  well_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Revisions_Sizings_Revisions_Stddev_Pop_Fields = {
  __typename: 'revisions_sizings_revisions_stddev_pop_fields';
  customer_id?: Maybe<Scalars['Float']['output']>;
  imported_sizing_id?: Maybe<Scalars['Float']['output']>;
  well_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "revisions.sizings_revisions" */
export type Revisions_Sizings_Revisions_Stddev_Pop_Order_By = {
  customer_id?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  well_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Revisions_Sizings_Revisions_Stddev_Samp_Fields = {
  __typename: 'revisions_sizings_revisions_stddev_samp_fields';
  customer_id?: Maybe<Scalars['Float']['output']>;
  imported_sizing_id?: Maybe<Scalars['Float']['output']>;
  well_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "revisions.sizings_revisions" */
export type Revisions_Sizings_Revisions_Stddev_Samp_Order_By = {
  customer_id?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  well_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "revisions_sizings_revisions" */
export type Revisions_Sizings_Revisions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Revisions_Sizings_Revisions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Revisions_Sizings_Revisions_Stream_Cursor_Value_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  cloned_from_journal_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  customer_id?: InputMaybe<Scalars['Int']['input']>;
  default_display_units?: InputMaybe<Display_Units_Enum>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  disposition?: InputMaybe<Sizing_Dispositions_Enum>;
  hps_location?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  imported_sizing_id?: InputMaybe<Scalars['Int']['input']>;
  installed_scenario_id?: InputMaybe<Scalars['uuid']['input']>;
  is_shared?: InputMaybe<Scalars['Boolean']['input']>;
  journal_id?: InputMaybe<Scalars['uuid']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  parent_revision_id?: InputMaybe<Scalars['uuid']['input']>;
  pumping_type?: InputMaybe<Sizing_Pumping_Type_Enum>;
  scenario_order?: InputMaybe<Array<Scalars['uuid']['input']>>;
  share_with_customer?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  well_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Revisions_Sizings_Revisions_Sum_Fields = {
  __typename: 'revisions_sizings_revisions_sum_fields';
  customer_id?: Maybe<Scalars['Int']['output']>;
  imported_sizing_id?: Maybe<Scalars['Int']['output']>;
  well_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "revisions.sizings_revisions" */
export type Revisions_Sizings_Revisions_Sum_Order_By = {
  customer_id?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  well_id?: InputMaybe<Order_By>;
};

/** update columns of table "revisions.sizings_revisions" */
export enum Revisions_Sizings_Revisions_Update_Column {
  /** column name */
  AuthorId = 'author_id',
  /** column name */
  ClonedFromJournalId = 'cloned_from_journal_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CustomerId = 'customer_id',
  /** column name */
  DefaultDisplayUnits = 'default_display_units',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Disposition = 'disposition',
  /** column name */
  HpsLocation = 'hps_location',
  /** column name */
  Id = 'id',
  /** column name */
  ImportedSizingId = 'imported_sizing_id',
  /** column name */
  InstalledScenarioId = 'installed_scenario_id',
  /** column name */
  IsShared = 'is_shared',
  /** column name */
  JournalId = 'journal_id',
  /** column name */
  Notes = 'notes',
  /** column name */
  ParentRevisionId = 'parent_revision_id',
  /** column name */
  PumpingType = 'pumping_type',
  /** column name */
  ScenarioOrder = 'scenario_order',
  /** column name */
  ShareWithCustomer = 'share_with_customer',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WellId = 'well_id'
}

export type Revisions_Sizings_Revisions_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Revisions_Sizings_Revisions_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Revisions_Sizings_Revisions_Set_Input>;
  /** filter the rows which have to be updated */
  where: Revisions_Sizings_Revisions_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Revisions_Sizings_Revisions_Var_Pop_Fields = {
  __typename: 'revisions_sizings_revisions_var_pop_fields';
  customer_id?: Maybe<Scalars['Float']['output']>;
  imported_sizing_id?: Maybe<Scalars['Float']['output']>;
  well_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "revisions.sizings_revisions" */
export type Revisions_Sizings_Revisions_Var_Pop_Order_By = {
  customer_id?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  well_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Revisions_Sizings_Revisions_Var_Samp_Fields = {
  __typename: 'revisions_sizings_revisions_var_samp_fields';
  customer_id?: Maybe<Scalars['Float']['output']>;
  imported_sizing_id?: Maybe<Scalars['Float']['output']>;
  well_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "revisions.sizings_revisions" */
export type Revisions_Sizings_Revisions_Var_Samp_Order_By = {
  customer_id?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  well_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Revisions_Sizings_Revisions_Variance_Fields = {
  __typename: 'revisions_sizings_revisions_variance_fields';
  customer_id?: Maybe<Scalars['Float']['output']>;
  imported_sizing_id?: Maybe<Scalars['Float']['output']>;
  well_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "revisions.sizings_revisions" */
export type Revisions_Sizings_Revisions_Variance_Order_By = {
  customer_id?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  well_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "saturated_oil_options" */
export type Saturated_Oil_Options = {
  __typename: 'saturated_oil_options';
  comment?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

/** aggregated selection of "saturated_oil_options" */
export type Saturated_Oil_Options_Aggregate = {
  __typename: 'saturated_oil_options_aggregate';
  aggregate?: Maybe<Saturated_Oil_Options_Aggregate_Fields>;
  nodes: Array<Saturated_Oil_Options>;
};

/** aggregate fields of "saturated_oil_options" */
export type Saturated_Oil_Options_Aggregate_Fields = {
  __typename: 'saturated_oil_options_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Saturated_Oil_Options_Max_Fields>;
  min?: Maybe<Saturated_Oil_Options_Min_Fields>;
};


/** aggregate fields of "saturated_oil_options" */
export type Saturated_Oil_Options_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Saturated_Oil_Options_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "saturated_oil_options". All fields are combined with a logical 'AND'. */
export type Saturated_Oil_Options_Bool_Exp = {
  _and?: InputMaybe<Array<Saturated_Oil_Options_Bool_Exp>>;
  _not?: InputMaybe<Saturated_Oil_Options_Bool_Exp>;
  _or?: InputMaybe<Array<Saturated_Oil_Options_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "saturated_oil_options" */
export enum Saturated_Oil_Options_Constraint {
  /** unique or primary key constraint on columns "value" */
  SaturatedOilOptionsPkey = 'saturated_oil_options_pkey'
}

export enum Saturated_Oil_Options_Enum {
  /** Beggs & Robinson */
  BeggsRobinson = 'beggs_robinson',
  /** De Ghetto Heavy Oil */
  DeGhettoHeavyOil = 'de_ghetto_heavy_oil',
  /** Glaso (North Sea) */
  GlasoNorthSea = 'glaso_north_sea',
  /** Kartoatmodjo & Schmidt */
  KartoatmodjoSchmidt = 'kartoatmodjo_schmidt'
}

/** Boolean expression to compare columns of type "saturated_oil_options_enum". All fields are combined with logical 'AND'. */
export type Saturated_Oil_Options_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Saturated_Oil_Options_Enum>;
  _in?: InputMaybe<Array<Saturated_Oil_Options_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Saturated_Oil_Options_Enum>;
  _nin?: InputMaybe<Array<Saturated_Oil_Options_Enum>>;
};

/** input type for inserting data into table "saturated_oil_options" */
export type Saturated_Oil_Options_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Saturated_Oil_Options_Max_Fields = {
  __typename: 'saturated_oil_options_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Saturated_Oil_Options_Min_Fields = {
  __typename: 'saturated_oil_options_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "saturated_oil_options" */
export type Saturated_Oil_Options_Mutation_Response = {
  __typename: 'saturated_oil_options_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Saturated_Oil_Options>;
};

/** input type for inserting object relation for remote table "saturated_oil_options" */
export type Saturated_Oil_Options_Obj_Rel_Insert_Input = {
  data: Saturated_Oil_Options_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Saturated_Oil_Options_On_Conflict>;
};

/** on_conflict condition type for table "saturated_oil_options" */
export type Saturated_Oil_Options_On_Conflict = {
  constraint: Saturated_Oil_Options_Constraint;
  update_columns?: Array<Saturated_Oil_Options_Update_Column>;
  where?: InputMaybe<Saturated_Oil_Options_Bool_Exp>;
};

/** Ordering options when selecting data from "saturated_oil_options". */
export type Saturated_Oil_Options_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: saturated_oil_options */
export type Saturated_Oil_Options_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "saturated_oil_options" */
export enum Saturated_Oil_Options_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "saturated_oil_options" */
export type Saturated_Oil_Options_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "saturated_oil_options" */
export type Saturated_Oil_Options_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Saturated_Oil_Options_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Saturated_Oil_Options_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "saturated_oil_options" */
export enum Saturated_Oil_Options_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Saturated_Oil_Options_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Saturated_Oil_Options_Set_Input>;
  /** filter the rows which have to be updated */
  where: Saturated_Oil_Options_Bool_Exp;
};

/** columns and relationships of "sc_equip_xref_downhole_ytool_bypass_tubings" */
export type Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings = {
  __typename: 'sc_equip_xref_downhole_ytool_bypass_tubings';
  id?: Maybe<Scalars['uuid']['output']>;
  journal_author_id?: Maybe<Scalars['String']['output']>;
  journal_created_at?: Maybe<Scalars['timestamptz']['output']>;
  journal_deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  journal_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  length_feet?: Maybe<Scalars['numeric']['output']>;
  parent_id?: Maybe<Scalars['uuid']['output']>;
  scenario_equipment_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  tubing?: Maybe<Tubings>;
  tubing_id?: Maybe<Scalars['uuid']['output']>;
  winning_revision_author_id?: Maybe<Scalars['String']['output']>;
  winning_revision_created_at?: Maybe<Scalars['timestamptz']['output']>;
  winning_revision_deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  winning_revision_id?: Maybe<Scalars['uuid']['output']>;
  winning_revision_parent_id?: Maybe<Scalars['uuid']['output']>;
  winning_revision_updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregated selection of "sc_equip_xref_downhole_ytool_bypass_tubings" */
export type Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Aggregate = {
  __typename: 'sc_equip_xref_downhole_ytool_bypass_tubings_aggregate';
  aggregate?: Maybe<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Aggregate_Fields>;
  nodes: Array<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings>;
};

export type Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Aggregate_Bool_Exp = {
  count?: InputMaybe<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Aggregate_Bool_Exp_Count>;
};

export type Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "sc_equip_xref_downhole_ytool_bypass_tubings" */
export type Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Aggregate_Fields = {
  __typename: 'sc_equip_xref_downhole_ytool_bypass_tubings_aggregate_fields';
  avg?: Maybe<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Max_Fields>;
  min?: Maybe<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Min_Fields>;
  stddev?: Maybe<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Stddev_Fields>;
  stddev_pop?: Maybe<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Stddev_Samp_Fields>;
  sum?: Maybe<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Sum_Fields>;
  var_pop?: Maybe<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Var_Pop_Fields>;
  var_samp?: Maybe<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Var_Samp_Fields>;
  variance?: Maybe<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Variance_Fields>;
};


/** aggregate fields of "sc_equip_xref_downhole_ytool_bypass_tubings" */
export type Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "sc_equip_xref_downhole_ytool_bypass_tubings" */
export type Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Aggregate_Order_By = {
  avg?: InputMaybe<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Max_Order_By>;
  min?: InputMaybe<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Min_Order_By>;
  stddev?: InputMaybe<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Sum_Order_By>;
  var_pop?: InputMaybe<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Var_Samp_Order_By>;
  variance?: InputMaybe<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "sc_equip_xref_downhole_ytool_bypass_tubings" */
export type Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Arr_Rel_Insert_Input = {
  data: Array<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Insert_Input>;
};

/** aggregate avg on columns */
export type Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Avg_Fields = {
  __typename: 'sc_equip_xref_downhole_ytool_bypass_tubings_avg_fields';
  length_feet?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "sc_equip_xref_downhole_ytool_bypass_tubings" */
export type Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Avg_Order_By = {
  length_feet?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "sc_equip_xref_downhole_ytool_bypass_tubings". All fields are combined with a logical 'AND'. */
export type Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Bool_Exp = {
  _and?: InputMaybe<Array<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Bool_Exp>>;
  _not?: InputMaybe<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Bool_Exp>;
  _or?: InputMaybe<Array<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Bool_Exp>>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  journal_author_id?: InputMaybe<String_Comparison_Exp>;
  journal_created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  journal_deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  journal_updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  length_feet?: InputMaybe<Numeric_Comparison_Exp>;
  parent_id?: InputMaybe<Uuid_Comparison_Exp>;
  scenario_equipment_id?: InputMaybe<Uuid_Comparison_Exp>;
  tubing?: InputMaybe<Tubings_Bool_Exp>;
  tubing_id?: InputMaybe<Uuid_Comparison_Exp>;
  winning_revision_author_id?: InputMaybe<String_Comparison_Exp>;
  winning_revision_created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  winning_revision_deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  winning_revision_id?: InputMaybe<Uuid_Comparison_Exp>;
  winning_revision_parent_id?: InputMaybe<Uuid_Comparison_Exp>;
  winning_revision_updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** input type for inserting data into table "sc_equip_xref_downhole_ytool_bypass_tubings" */
export type Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Insert_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  journal_author_id?: InputMaybe<Scalars['String']['input']>;
  journal_created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  journal_deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  journal_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  length_feet?: InputMaybe<Scalars['numeric']['input']>;
  parent_id?: InputMaybe<Scalars['uuid']['input']>;
  scenario_equipment_id?: InputMaybe<Scalars['uuid']['input']>;
  tubing?: InputMaybe<Tubings_Obj_Rel_Insert_Input>;
  tubing_id?: InputMaybe<Scalars['uuid']['input']>;
  winning_revision_author_id?: InputMaybe<Scalars['String']['input']>;
  winning_revision_created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  winning_revision_deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  winning_revision_id?: InputMaybe<Scalars['uuid']['input']>;
  winning_revision_parent_id?: InputMaybe<Scalars['uuid']['input']>;
  winning_revision_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Max_Fields = {
  __typename: 'sc_equip_xref_downhole_ytool_bypass_tubings_max_fields';
  id?: Maybe<Scalars['uuid']['output']>;
  journal_author_id?: Maybe<Scalars['String']['output']>;
  journal_created_at?: Maybe<Scalars['timestamptz']['output']>;
  journal_deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  journal_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  length_feet?: Maybe<Scalars['numeric']['output']>;
  parent_id?: Maybe<Scalars['uuid']['output']>;
  scenario_equipment_id?: Maybe<Scalars['uuid']['output']>;
  tubing_id?: Maybe<Scalars['uuid']['output']>;
  winning_revision_author_id?: Maybe<Scalars['String']['output']>;
  winning_revision_created_at?: Maybe<Scalars['timestamptz']['output']>;
  winning_revision_deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  winning_revision_id?: Maybe<Scalars['uuid']['output']>;
  winning_revision_parent_id?: Maybe<Scalars['uuid']['output']>;
  winning_revision_updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "sc_equip_xref_downhole_ytool_bypass_tubings" */
export type Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  journal_author_id?: InputMaybe<Order_By>;
  journal_created_at?: InputMaybe<Order_By>;
  journal_deleted_at?: InputMaybe<Order_By>;
  journal_updated_at?: InputMaybe<Order_By>;
  length_feet?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  scenario_equipment_id?: InputMaybe<Order_By>;
  tubing_id?: InputMaybe<Order_By>;
  winning_revision_author_id?: InputMaybe<Order_By>;
  winning_revision_created_at?: InputMaybe<Order_By>;
  winning_revision_deleted_at?: InputMaybe<Order_By>;
  winning_revision_id?: InputMaybe<Order_By>;
  winning_revision_parent_id?: InputMaybe<Order_By>;
  winning_revision_updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Min_Fields = {
  __typename: 'sc_equip_xref_downhole_ytool_bypass_tubings_min_fields';
  id?: Maybe<Scalars['uuid']['output']>;
  journal_author_id?: Maybe<Scalars['String']['output']>;
  journal_created_at?: Maybe<Scalars['timestamptz']['output']>;
  journal_deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  journal_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  length_feet?: Maybe<Scalars['numeric']['output']>;
  parent_id?: Maybe<Scalars['uuid']['output']>;
  scenario_equipment_id?: Maybe<Scalars['uuid']['output']>;
  tubing_id?: Maybe<Scalars['uuid']['output']>;
  winning_revision_author_id?: Maybe<Scalars['String']['output']>;
  winning_revision_created_at?: Maybe<Scalars['timestamptz']['output']>;
  winning_revision_deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  winning_revision_id?: Maybe<Scalars['uuid']['output']>;
  winning_revision_parent_id?: Maybe<Scalars['uuid']['output']>;
  winning_revision_updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "sc_equip_xref_downhole_ytool_bypass_tubings" */
export type Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  journal_author_id?: InputMaybe<Order_By>;
  journal_created_at?: InputMaybe<Order_By>;
  journal_deleted_at?: InputMaybe<Order_By>;
  journal_updated_at?: InputMaybe<Order_By>;
  length_feet?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  scenario_equipment_id?: InputMaybe<Order_By>;
  tubing_id?: InputMaybe<Order_By>;
  winning_revision_author_id?: InputMaybe<Order_By>;
  winning_revision_created_at?: InputMaybe<Order_By>;
  winning_revision_deleted_at?: InputMaybe<Order_By>;
  winning_revision_id?: InputMaybe<Order_By>;
  winning_revision_parent_id?: InputMaybe<Order_By>;
  winning_revision_updated_at?: InputMaybe<Order_By>;
};

/** input type for inserting object relation for remote table "sc_equip_xref_downhole_ytool_bypass_tubings" */
export type Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Obj_Rel_Insert_Input = {
  data: Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Insert_Input;
};

/** Ordering options when selecting data from "sc_equip_xref_downhole_ytool_bypass_tubings". */
export type Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Order_By = {
  id?: InputMaybe<Order_By>;
  journal_author_id?: InputMaybe<Order_By>;
  journal_created_at?: InputMaybe<Order_By>;
  journal_deleted_at?: InputMaybe<Order_By>;
  journal_updated_at?: InputMaybe<Order_By>;
  length_feet?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  scenario_equipment_id?: InputMaybe<Order_By>;
  tubing?: InputMaybe<Tubings_Order_By>;
  tubing_id?: InputMaybe<Order_By>;
  winning_revision_author_id?: InputMaybe<Order_By>;
  winning_revision_created_at?: InputMaybe<Order_By>;
  winning_revision_deleted_at?: InputMaybe<Order_By>;
  winning_revision_id?: InputMaybe<Order_By>;
  winning_revision_parent_id?: InputMaybe<Order_By>;
  winning_revision_updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "sc_equip_xref_downhole_ytool_bypass_tubings" */
export enum Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  JournalAuthorId = 'journal_author_id',
  /** column name */
  JournalCreatedAt = 'journal_created_at',
  /** column name */
  JournalDeletedAt = 'journal_deleted_at',
  /** column name */
  JournalUpdatedAt = 'journal_updated_at',
  /** column name */
  LengthFeet = 'length_feet',
  /** column name */
  ParentId = 'parent_id',
  /** column name */
  ScenarioEquipmentId = 'scenario_equipment_id',
  /** column name */
  TubingId = 'tubing_id',
  /** column name */
  WinningRevisionAuthorId = 'winning_revision_author_id',
  /** column name */
  WinningRevisionCreatedAt = 'winning_revision_created_at',
  /** column name */
  WinningRevisionDeletedAt = 'winning_revision_deleted_at',
  /** column name */
  WinningRevisionId = 'winning_revision_id',
  /** column name */
  WinningRevisionParentId = 'winning_revision_parent_id',
  /** column name */
  WinningRevisionUpdatedAt = 'winning_revision_updated_at'
}

/** aggregate stddev on columns */
export type Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Stddev_Fields = {
  __typename: 'sc_equip_xref_downhole_ytool_bypass_tubings_stddev_fields';
  length_feet?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "sc_equip_xref_downhole_ytool_bypass_tubings" */
export type Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Stddev_Order_By = {
  length_feet?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Stddev_Pop_Fields = {
  __typename: 'sc_equip_xref_downhole_ytool_bypass_tubings_stddev_pop_fields';
  length_feet?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "sc_equip_xref_downhole_ytool_bypass_tubings" */
export type Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Stddev_Pop_Order_By = {
  length_feet?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Stddev_Samp_Fields = {
  __typename: 'sc_equip_xref_downhole_ytool_bypass_tubings_stddev_samp_fields';
  length_feet?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "sc_equip_xref_downhole_ytool_bypass_tubings" */
export type Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Stddev_Samp_Order_By = {
  length_feet?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "sc_equip_xref_downhole_ytool_bypass_tubings" */
export type Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  journal_author_id?: InputMaybe<Scalars['String']['input']>;
  journal_created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  journal_deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  journal_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  length_feet?: InputMaybe<Scalars['numeric']['input']>;
  parent_id?: InputMaybe<Scalars['uuid']['input']>;
  scenario_equipment_id?: InputMaybe<Scalars['uuid']['input']>;
  tubing_id?: InputMaybe<Scalars['uuid']['input']>;
  winning_revision_author_id?: InputMaybe<Scalars['String']['input']>;
  winning_revision_created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  winning_revision_deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  winning_revision_id?: InputMaybe<Scalars['uuid']['input']>;
  winning_revision_parent_id?: InputMaybe<Scalars['uuid']['input']>;
  winning_revision_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Sum_Fields = {
  __typename: 'sc_equip_xref_downhole_ytool_bypass_tubings_sum_fields';
  length_feet?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "sc_equip_xref_downhole_ytool_bypass_tubings" */
export type Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Sum_Order_By = {
  length_feet?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Var_Pop_Fields = {
  __typename: 'sc_equip_xref_downhole_ytool_bypass_tubings_var_pop_fields';
  length_feet?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "sc_equip_xref_downhole_ytool_bypass_tubings" */
export type Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Var_Pop_Order_By = {
  length_feet?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Var_Samp_Fields = {
  __typename: 'sc_equip_xref_downhole_ytool_bypass_tubings_var_samp_fields';
  length_feet?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "sc_equip_xref_downhole_ytool_bypass_tubings" */
export type Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Var_Samp_Order_By = {
  length_feet?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Variance_Fields = {
  __typename: 'sc_equip_xref_downhole_ytool_bypass_tubings_variance_fields';
  length_feet?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "sc_equip_xref_downhole_ytool_bypass_tubings" */
export type Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Variance_Order_By = {
  length_feet?: InputMaybe<Order_By>;
};

/** columns and relationships of "sc_equip_xref_downhole_ytool_equip_tubings" */
export type Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings = {
  __typename: 'sc_equip_xref_downhole_ytool_equip_tubings';
  id?: Maybe<Scalars['uuid']['output']>;
  journal_author_id?: Maybe<Scalars['String']['output']>;
  journal_created_at?: Maybe<Scalars['timestamptz']['output']>;
  journal_deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  journal_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  length_feet?: Maybe<Scalars['numeric']['output']>;
  parent_id?: Maybe<Scalars['uuid']['output']>;
  scenario_equipment_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  tubing?: Maybe<Tubings>;
  tubing_id?: Maybe<Scalars['uuid']['output']>;
  winning_revision_author_id?: Maybe<Scalars['String']['output']>;
  winning_revision_created_at?: Maybe<Scalars['timestamptz']['output']>;
  winning_revision_deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  winning_revision_id?: Maybe<Scalars['uuid']['output']>;
  winning_revision_parent_id?: Maybe<Scalars['uuid']['output']>;
  winning_revision_updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregated selection of "sc_equip_xref_downhole_ytool_equip_tubings" */
export type Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Aggregate = {
  __typename: 'sc_equip_xref_downhole_ytool_equip_tubings_aggregate';
  aggregate?: Maybe<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Aggregate_Fields>;
  nodes: Array<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings>;
};

export type Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Aggregate_Bool_Exp = {
  count?: InputMaybe<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Aggregate_Bool_Exp_Count>;
};

export type Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "sc_equip_xref_downhole_ytool_equip_tubings" */
export type Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Aggregate_Fields = {
  __typename: 'sc_equip_xref_downhole_ytool_equip_tubings_aggregate_fields';
  avg?: Maybe<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Max_Fields>;
  min?: Maybe<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Min_Fields>;
  stddev?: Maybe<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Stddev_Fields>;
  stddev_pop?: Maybe<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Stddev_Samp_Fields>;
  sum?: Maybe<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Sum_Fields>;
  var_pop?: Maybe<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Var_Pop_Fields>;
  var_samp?: Maybe<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Var_Samp_Fields>;
  variance?: Maybe<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Variance_Fields>;
};


/** aggregate fields of "sc_equip_xref_downhole_ytool_equip_tubings" */
export type Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "sc_equip_xref_downhole_ytool_equip_tubings" */
export type Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Aggregate_Order_By = {
  avg?: InputMaybe<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Max_Order_By>;
  min?: InputMaybe<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Min_Order_By>;
  stddev?: InputMaybe<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Sum_Order_By>;
  var_pop?: InputMaybe<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Var_Samp_Order_By>;
  variance?: InputMaybe<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "sc_equip_xref_downhole_ytool_equip_tubings" */
export type Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Arr_Rel_Insert_Input = {
  data: Array<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Insert_Input>;
};

/** aggregate avg on columns */
export type Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Avg_Fields = {
  __typename: 'sc_equip_xref_downhole_ytool_equip_tubings_avg_fields';
  length_feet?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "sc_equip_xref_downhole_ytool_equip_tubings" */
export type Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Avg_Order_By = {
  length_feet?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "sc_equip_xref_downhole_ytool_equip_tubings". All fields are combined with a logical 'AND'. */
export type Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Bool_Exp = {
  _and?: InputMaybe<Array<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Bool_Exp>>;
  _not?: InputMaybe<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Bool_Exp>;
  _or?: InputMaybe<Array<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Bool_Exp>>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  journal_author_id?: InputMaybe<String_Comparison_Exp>;
  journal_created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  journal_deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  journal_updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  length_feet?: InputMaybe<Numeric_Comparison_Exp>;
  parent_id?: InputMaybe<Uuid_Comparison_Exp>;
  scenario_equipment_id?: InputMaybe<Uuid_Comparison_Exp>;
  tubing?: InputMaybe<Tubings_Bool_Exp>;
  tubing_id?: InputMaybe<Uuid_Comparison_Exp>;
  winning_revision_author_id?: InputMaybe<String_Comparison_Exp>;
  winning_revision_created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  winning_revision_deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  winning_revision_id?: InputMaybe<Uuid_Comparison_Exp>;
  winning_revision_parent_id?: InputMaybe<Uuid_Comparison_Exp>;
  winning_revision_updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** input type for inserting data into table "sc_equip_xref_downhole_ytool_equip_tubings" */
export type Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Insert_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  journal_author_id?: InputMaybe<Scalars['String']['input']>;
  journal_created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  journal_deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  journal_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  length_feet?: InputMaybe<Scalars['numeric']['input']>;
  parent_id?: InputMaybe<Scalars['uuid']['input']>;
  scenario_equipment_id?: InputMaybe<Scalars['uuid']['input']>;
  tubing?: InputMaybe<Tubings_Obj_Rel_Insert_Input>;
  tubing_id?: InputMaybe<Scalars['uuid']['input']>;
  winning_revision_author_id?: InputMaybe<Scalars['String']['input']>;
  winning_revision_created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  winning_revision_deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  winning_revision_id?: InputMaybe<Scalars['uuid']['input']>;
  winning_revision_parent_id?: InputMaybe<Scalars['uuid']['input']>;
  winning_revision_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Max_Fields = {
  __typename: 'sc_equip_xref_downhole_ytool_equip_tubings_max_fields';
  id?: Maybe<Scalars['uuid']['output']>;
  journal_author_id?: Maybe<Scalars['String']['output']>;
  journal_created_at?: Maybe<Scalars['timestamptz']['output']>;
  journal_deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  journal_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  length_feet?: Maybe<Scalars['numeric']['output']>;
  parent_id?: Maybe<Scalars['uuid']['output']>;
  scenario_equipment_id?: Maybe<Scalars['uuid']['output']>;
  tubing_id?: Maybe<Scalars['uuid']['output']>;
  winning_revision_author_id?: Maybe<Scalars['String']['output']>;
  winning_revision_created_at?: Maybe<Scalars['timestamptz']['output']>;
  winning_revision_deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  winning_revision_id?: Maybe<Scalars['uuid']['output']>;
  winning_revision_parent_id?: Maybe<Scalars['uuid']['output']>;
  winning_revision_updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "sc_equip_xref_downhole_ytool_equip_tubings" */
export type Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  journal_author_id?: InputMaybe<Order_By>;
  journal_created_at?: InputMaybe<Order_By>;
  journal_deleted_at?: InputMaybe<Order_By>;
  journal_updated_at?: InputMaybe<Order_By>;
  length_feet?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  scenario_equipment_id?: InputMaybe<Order_By>;
  tubing_id?: InputMaybe<Order_By>;
  winning_revision_author_id?: InputMaybe<Order_By>;
  winning_revision_created_at?: InputMaybe<Order_By>;
  winning_revision_deleted_at?: InputMaybe<Order_By>;
  winning_revision_id?: InputMaybe<Order_By>;
  winning_revision_parent_id?: InputMaybe<Order_By>;
  winning_revision_updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Min_Fields = {
  __typename: 'sc_equip_xref_downhole_ytool_equip_tubings_min_fields';
  id?: Maybe<Scalars['uuid']['output']>;
  journal_author_id?: Maybe<Scalars['String']['output']>;
  journal_created_at?: Maybe<Scalars['timestamptz']['output']>;
  journal_deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  journal_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  length_feet?: Maybe<Scalars['numeric']['output']>;
  parent_id?: Maybe<Scalars['uuid']['output']>;
  scenario_equipment_id?: Maybe<Scalars['uuid']['output']>;
  tubing_id?: Maybe<Scalars['uuid']['output']>;
  winning_revision_author_id?: Maybe<Scalars['String']['output']>;
  winning_revision_created_at?: Maybe<Scalars['timestamptz']['output']>;
  winning_revision_deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  winning_revision_id?: Maybe<Scalars['uuid']['output']>;
  winning_revision_parent_id?: Maybe<Scalars['uuid']['output']>;
  winning_revision_updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "sc_equip_xref_downhole_ytool_equip_tubings" */
export type Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  journal_author_id?: InputMaybe<Order_By>;
  journal_created_at?: InputMaybe<Order_By>;
  journal_deleted_at?: InputMaybe<Order_By>;
  journal_updated_at?: InputMaybe<Order_By>;
  length_feet?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  scenario_equipment_id?: InputMaybe<Order_By>;
  tubing_id?: InputMaybe<Order_By>;
  winning_revision_author_id?: InputMaybe<Order_By>;
  winning_revision_created_at?: InputMaybe<Order_By>;
  winning_revision_deleted_at?: InputMaybe<Order_By>;
  winning_revision_id?: InputMaybe<Order_By>;
  winning_revision_parent_id?: InputMaybe<Order_By>;
  winning_revision_updated_at?: InputMaybe<Order_By>;
};

/** input type for inserting object relation for remote table "sc_equip_xref_downhole_ytool_equip_tubings" */
export type Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Obj_Rel_Insert_Input = {
  data: Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Insert_Input;
};

/** Ordering options when selecting data from "sc_equip_xref_downhole_ytool_equip_tubings". */
export type Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Order_By = {
  id?: InputMaybe<Order_By>;
  journal_author_id?: InputMaybe<Order_By>;
  journal_created_at?: InputMaybe<Order_By>;
  journal_deleted_at?: InputMaybe<Order_By>;
  journal_updated_at?: InputMaybe<Order_By>;
  length_feet?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  scenario_equipment_id?: InputMaybe<Order_By>;
  tubing?: InputMaybe<Tubings_Order_By>;
  tubing_id?: InputMaybe<Order_By>;
  winning_revision_author_id?: InputMaybe<Order_By>;
  winning_revision_created_at?: InputMaybe<Order_By>;
  winning_revision_deleted_at?: InputMaybe<Order_By>;
  winning_revision_id?: InputMaybe<Order_By>;
  winning_revision_parent_id?: InputMaybe<Order_By>;
  winning_revision_updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "sc_equip_xref_downhole_ytool_equip_tubings" */
export enum Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  JournalAuthorId = 'journal_author_id',
  /** column name */
  JournalCreatedAt = 'journal_created_at',
  /** column name */
  JournalDeletedAt = 'journal_deleted_at',
  /** column name */
  JournalUpdatedAt = 'journal_updated_at',
  /** column name */
  LengthFeet = 'length_feet',
  /** column name */
  ParentId = 'parent_id',
  /** column name */
  ScenarioEquipmentId = 'scenario_equipment_id',
  /** column name */
  TubingId = 'tubing_id',
  /** column name */
  WinningRevisionAuthorId = 'winning_revision_author_id',
  /** column name */
  WinningRevisionCreatedAt = 'winning_revision_created_at',
  /** column name */
  WinningRevisionDeletedAt = 'winning_revision_deleted_at',
  /** column name */
  WinningRevisionId = 'winning_revision_id',
  /** column name */
  WinningRevisionParentId = 'winning_revision_parent_id',
  /** column name */
  WinningRevisionUpdatedAt = 'winning_revision_updated_at'
}

/** aggregate stddev on columns */
export type Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Stddev_Fields = {
  __typename: 'sc_equip_xref_downhole_ytool_equip_tubings_stddev_fields';
  length_feet?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "sc_equip_xref_downhole_ytool_equip_tubings" */
export type Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Stddev_Order_By = {
  length_feet?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Stddev_Pop_Fields = {
  __typename: 'sc_equip_xref_downhole_ytool_equip_tubings_stddev_pop_fields';
  length_feet?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "sc_equip_xref_downhole_ytool_equip_tubings" */
export type Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Stddev_Pop_Order_By = {
  length_feet?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Stddev_Samp_Fields = {
  __typename: 'sc_equip_xref_downhole_ytool_equip_tubings_stddev_samp_fields';
  length_feet?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "sc_equip_xref_downhole_ytool_equip_tubings" */
export type Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Stddev_Samp_Order_By = {
  length_feet?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "sc_equip_xref_downhole_ytool_equip_tubings" */
export type Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  journal_author_id?: InputMaybe<Scalars['String']['input']>;
  journal_created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  journal_deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  journal_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  length_feet?: InputMaybe<Scalars['numeric']['input']>;
  parent_id?: InputMaybe<Scalars['uuid']['input']>;
  scenario_equipment_id?: InputMaybe<Scalars['uuid']['input']>;
  tubing_id?: InputMaybe<Scalars['uuid']['input']>;
  winning_revision_author_id?: InputMaybe<Scalars['String']['input']>;
  winning_revision_created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  winning_revision_deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  winning_revision_id?: InputMaybe<Scalars['uuid']['input']>;
  winning_revision_parent_id?: InputMaybe<Scalars['uuid']['input']>;
  winning_revision_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Sum_Fields = {
  __typename: 'sc_equip_xref_downhole_ytool_equip_tubings_sum_fields';
  length_feet?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "sc_equip_xref_downhole_ytool_equip_tubings" */
export type Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Sum_Order_By = {
  length_feet?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Var_Pop_Fields = {
  __typename: 'sc_equip_xref_downhole_ytool_equip_tubings_var_pop_fields';
  length_feet?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "sc_equip_xref_downhole_ytool_equip_tubings" */
export type Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Var_Pop_Order_By = {
  length_feet?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Var_Samp_Fields = {
  __typename: 'sc_equip_xref_downhole_ytool_equip_tubings_var_samp_fields';
  length_feet?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "sc_equip_xref_downhole_ytool_equip_tubings" */
export type Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Var_Samp_Order_By = {
  length_feet?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Variance_Fields = {
  __typename: 'sc_equip_xref_downhole_ytool_equip_tubings_variance_fields';
  length_feet?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "sc_equip_xref_downhole_ytool_equip_tubings" */
export type Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Variance_Order_By = {
  length_feet?: InputMaybe<Order_By>;
};

/** columns and relationships of "sc_equip_xref_uphole_ytool_bypass_tubings" */
export type Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings = {
  __typename: 'sc_equip_xref_uphole_ytool_bypass_tubings';
  id?: Maybe<Scalars['uuid']['output']>;
  journal_author_id?: Maybe<Scalars['String']['output']>;
  journal_created_at?: Maybe<Scalars['timestamptz']['output']>;
  journal_deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  journal_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  length_feet?: Maybe<Scalars['numeric']['output']>;
  parent_id?: Maybe<Scalars['uuid']['output']>;
  scenario_equipment_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  tubing?: Maybe<Tubings>;
  tubing_id?: Maybe<Scalars['uuid']['output']>;
  winning_revision_author_id?: Maybe<Scalars['String']['output']>;
  winning_revision_created_at?: Maybe<Scalars['timestamptz']['output']>;
  winning_revision_deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  winning_revision_id?: Maybe<Scalars['uuid']['output']>;
  winning_revision_parent_id?: Maybe<Scalars['uuid']['output']>;
  winning_revision_updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregated selection of "sc_equip_xref_uphole_ytool_bypass_tubings" */
export type Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Aggregate = {
  __typename: 'sc_equip_xref_uphole_ytool_bypass_tubings_aggregate';
  aggregate?: Maybe<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Aggregate_Fields>;
  nodes: Array<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings>;
};

export type Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Aggregate_Bool_Exp = {
  count?: InputMaybe<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Aggregate_Bool_Exp_Count>;
};

export type Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "sc_equip_xref_uphole_ytool_bypass_tubings" */
export type Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Aggregate_Fields = {
  __typename: 'sc_equip_xref_uphole_ytool_bypass_tubings_aggregate_fields';
  avg?: Maybe<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Max_Fields>;
  min?: Maybe<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Min_Fields>;
  stddev?: Maybe<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Stddev_Fields>;
  stddev_pop?: Maybe<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Stddev_Samp_Fields>;
  sum?: Maybe<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Sum_Fields>;
  var_pop?: Maybe<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Var_Pop_Fields>;
  var_samp?: Maybe<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Var_Samp_Fields>;
  variance?: Maybe<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Variance_Fields>;
};


/** aggregate fields of "sc_equip_xref_uphole_ytool_bypass_tubings" */
export type Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "sc_equip_xref_uphole_ytool_bypass_tubings" */
export type Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Aggregate_Order_By = {
  avg?: InputMaybe<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Max_Order_By>;
  min?: InputMaybe<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Min_Order_By>;
  stddev?: InputMaybe<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Sum_Order_By>;
  var_pop?: InputMaybe<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Var_Samp_Order_By>;
  variance?: InputMaybe<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "sc_equip_xref_uphole_ytool_bypass_tubings" */
export type Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Arr_Rel_Insert_Input = {
  data: Array<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Insert_Input>;
};

/** aggregate avg on columns */
export type Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Avg_Fields = {
  __typename: 'sc_equip_xref_uphole_ytool_bypass_tubings_avg_fields';
  length_feet?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "sc_equip_xref_uphole_ytool_bypass_tubings" */
export type Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Avg_Order_By = {
  length_feet?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "sc_equip_xref_uphole_ytool_bypass_tubings". All fields are combined with a logical 'AND'. */
export type Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Bool_Exp = {
  _and?: InputMaybe<Array<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Bool_Exp>>;
  _not?: InputMaybe<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Bool_Exp>;
  _or?: InputMaybe<Array<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Bool_Exp>>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  journal_author_id?: InputMaybe<String_Comparison_Exp>;
  journal_created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  journal_deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  journal_updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  length_feet?: InputMaybe<Numeric_Comparison_Exp>;
  parent_id?: InputMaybe<Uuid_Comparison_Exp>;
  scenario_equipment_id?: InputMaybe<Uuid_Comparison_Exp>;
  tubing?: InputMaybe<Tubings_Bool_Exp>;
  tubing_id?: InputMaybe<Uuid_Comparison_Exp>;
  winning_revision_author_id?: InputMaybe<String_Comparison_Exp>;
  winning_revision_created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  winning_revision_deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  winning_revision_id?: InputMaybe<Uuid_Comparison_Exp>;
  winning_revision_parent_id?: InputMaybe<Uuid_Comparison_Exp>;
  winning_revision_updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** input type for inserting data into table "sc_equip_xref_uphole_ytool_bypass_tubings" */
export type Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Insert_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  journal_author_id?: InputMaybe<Scalars['String']['input']>;
  journal_created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  journal_deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  journal_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  length_feet?: InputMaybe<Scalars['numeric']['input']>;
  parent_id?: InputMaybe<Scalars['uuid']['input']>;
  scenario_equipment_id?: InputMaybe<Scalars['uuid']['input']>;
  tubing?: InputMaybe<Tubings_Obj_Rel_Insert_Input>;
  tubing_id?: InputMaybe<Scalars['uuid']['input']>;
  winning_revision_author_id?: InputMaybe<Scalars['String']['input']>;
  winning_revision_created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  winning_revision_deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  winning_revision_id?: InputMaybe<Scalars['uuid']['input']>;
  winning_revision_parent_id?: InputMaybe<Scalars['uuid']['input']>;
  winning_revision_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Max_Fields = {
  __typename: 'sc_equip_xref_uphole_ytool_bypass_tubings_max_fields';
  id?: Maybe<Scalars['uuid']['output']>;
  journal_author_id?: Maybe<Scalars['String']['output']>;
  journal_created_at?: Maybe<Scalars['timestamptz']['output']>;
  journal_deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  journal_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  length_feet?: Maybe<Scalars['numeric']['output']>;
  parent_id?: Maybe<Scalars['uuid']['output']>;
  scenario_equipment_id?: Maybe<Scalars['uuid']['output']>;
  tubing_id?: Maybe<Scalars['uuid']['output']>;
  winning_revision_author_id?: Maybe<Scalars['String']['output']>;
  winning_revision_created_at?: Maybe<Scalars['timestamptz']['output']>;
  winning_revision_deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  winning_revision_id?: Maybe<Scalars['uuid']['output']>;
  winning_revision_parent_id?: Maybe<Scalars['uuid']['output']>;
  winning_revision_updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "sc_equip_xref_uphole_ytool_bypass_tubings" */
export type Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  journal_author_id?: InputMaybe<Order_By>;
  journal_created_at?: InputMaybe<Order_By>;
  journal_deleted_at?: InputMaybe<Order_By>;
  journal_updated_at?: InputMaybe<Order_By>;
  length_feet?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  scenario_equipment_id?: InputMaybe<Order_By>;
  tubing_id?: InputMaybe<Order_By>;
  winning_revision_author_id?: InputMaybe<Order_By>;
  winning_revision_created_at?: InputMaybe<Order_By>;
  winning_revision_deleted_at?: InputMaybe<Order_By>;
  winning_revision_id?: InputMaybe<Order_By>;
  winning_revision_parent_id?: InputMaybe<Order_By>;
  winning_revision_updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Min_Fields = {
  __typename: 'sc_equip_xref_uphole_ytool_bypass_tubings_min_fields';
  id?: Maybe<Scalars['uuid']['output']>;
  journal_author_id?: Maybe<Scalars['String']['output']>;
  journal_created_at?: Maybe<Scalars['timestamptz']['output']>;
  journal_deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  journal_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  length_feet?: Maybe<Scalars['numeric']['output']>;
  parent_id?: Maybe<Scalars['uuid']['output']>;
  scenario_equipment_id?: Maybe<Scalars['uuid']['output']>;
  tubing_id?: Maybe<Scalars['uuid']['output']>;
  winning_revision_author_id?: Maybe<Scalars['String']['output']>;
  winning_revision_created_at?: Maybe<Scalars['timestamptz']['output']>;
  winning_revision_deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  winning_revision_id?: Maybe<Scalars['uuid']['output']>;
  winning_revision_parent_id?: Maybe<Scalars['uuid']['output']>;
  winning_revision_updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "sc_equip_xref_uphole_ytool_bypass_tubings" */
export type Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  journal_author_id?: InputMaybe<Order_By>;
  journal_created_at?: InputMaybe<Order_By>;
  journal_deleted_at?: InputMaybe<Order_By>;
  journal_updated_at?: InputMaybe<Order_By>;
  length_feet?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  scenario_equipment_id?: InputMaybe<Order_By>;
  tubing_id?: InputMaybe<Order_By>;
  winning_revision_author_id?: InputMaybe<Order_By>;
  winning_revision_created_at?: InputMaybe<Order_By>;
  winning_revision_deleted_at?: InputMaybe<Order_By>;
  winning_revision_id?: InputMaybe<Order_By>;
  winning_revision_parent_id?: InputMaybe<Order_By>;
  winning_revision_updated_at?: InputMaybe<Order_By>;
};

/** input type for inserting object relation for remote table "sc_equip_xref_uphole_ytool_bypass_tubings" */
export type Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Obj_Rel_Insert_Input = {
  data: Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Insert_Input;
};

/** Ordering options when selecting data from "sc_equip_xref_uphole_ytool_bypass_tubings". */
export type Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Order_By = {
  id?: InputMaybe<Order_By>;
  journal_author_id?: InputMaybe<Order_By>;
  journal_created_at?: InputMaybe<Order_By>;
  journal_deleted_at?: InputMaybe<Order_By>;
  journal_updated_at?: InputMaybe<Order_By>;
  length_feet?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  scenario_equipment_id?: InputMaybe<Order_By>;
  tubing?: InputMaybe<Tubings_Order_By>;
  tubing_id?: InputMaybe<Order_By>;
  winning_revision_author_id?: InputMaybe<Order_By>;
  winning_revision_created_at?: InputMaybe<Order_By>;
  winning_revision_deleted_at?: InputMaybe<Order_By>;
  winning_revision_id?: InputMaybe<Order_By>;
  winning_revision_parent_id?: InputMaybe<Order_By>;
  winning_revision_updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "sc_equip_xref_uphole_ytool_bypass_tubings" */
export enum Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  JournalAuthorId = 'journal_author_id',
  /** column name */
  JournalCreatedAt = 'journal_created_at',
  /** column name */
  JournalDeletedAt = 'journal_deleted_at',
  /** column name */
  JournalUpdatedAt = 'journal_updated_at',
  /** column name */
  LengthFeet = 'length_feet',
  /** column name */
  ParentId = 'parent_id',
  /** column name */
  ScenarioEquipmentId = 'scenario_equipment_id',
  /** column name */
  TubingId = 'tubing_id',
  /** column name */
  WinningRevisionAuthorId = 'winning_revision_author_id',
  /** column name */
  WinningRevisionCreatedAt = 'winning_revision_created_at',
  /** column name */
  WinningRevisionDeletedAt = 'winning_revision_deleted_at',
  /** column name */
  WinningRevisionId = 'winning_revision_id',
  /** column name */
  WinningRevisionParentId = 'winning_revision_parent_id',
  /** column name */
  WinningRevisionUpdatedAt = 'winning_revision_updated_at'
}

/** aggregate stddev on columns */
export type Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Stddev_Fields = {
  __typename: 'sc_equip_xref_uphole_ytool_bypass_tubings_stddev_fields';
  length_feet?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "sc_equip_xref_uphole_ytool_bypass_tubings" */
export type Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Stddev_Order_By = {
  length_feet?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Stddev_Pop_Fields = {
  __typename: 'sc_equip_xref_uphole_ytool_bypass_tubings_stddev_pop_fields';
  length_feet?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "sc_equip_xref_uphole_ytool_bypass_tubings" */
export type Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Stddev_Pop_Order_By = {
  length_feet?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Stddev_Samp_Fields = {
  __typename: 'sc_equip_xref_uphole_ytool_bypass_tubings_stddev_samp_fields';
  length_feet?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "sc_equip_xref_uphole_ytool_bypass_tubings" */
export type Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Stddev_Samp_Order_By = {
  length_feet?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "sc_equip_xref_uphole_ytool_bypass_tubings" */
export type Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  journal_author_id?: InputMaybe<Scalars['String']['input']>;
  journal_created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  journal_deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  journal_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  length_feet?: InputMaybe<Scalars['numeric']['input']>;
  parent_id?: InputMaybe<Scalars['uuid']['input']>;
  scenario_equipment_id?: InputMaybe<Scalars['uuid']['input']>;
  tubing_id?: InputMaybe<Scalars['uuid']['input']>;
  winning_revision_author_id?: InputMaybe<Scalars['String']['input']>;
  winning_revision_created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  winning_revision_deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  winning_revision_id?: InputMaybe<Scalars['uuid']['input']>;
  winning_revision_parent_id?: InputMaybe<Scalars['uuid']['input']>;
  winning_revision_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Sum_Fields = {
  __typename: 'sc_equip_xref_uphole_ytool_bypass_tubings_sum_fields';
  length_feet?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "sc_equip_xref_uphole_ytool_bypass_tubings" */
export type Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Sum_Order_By = {
  length_feet?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Var_Pop_Fields = {
  __typename: 'sc_equip_xref_uphole_ytool_bypass_tubings_var_pop_fields';
  length_feet?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "sc_equip_xref_uphole_ytool_bypass_tubings" */
export type Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Var_Pop_Order_By = {
  length_feet?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Var_Samp_Fields = {
  __typename: 'sc_equip_xref_uphole_ytool_bypass_tubings_var_samp_fields';
  length_feet?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "sc_equip_xref_uphole_ytool_bypass_tubings" */
export type Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Var_Samp_Order_By = {
  length_feet?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Variance_Fields = {
  __typename: 'sc_equip_xref_uphole_ytool_bypass_tubings_variance_fields';
  length_feet?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "sc_equip_xref_uphole_ytool_bypass_tubings" */
export type Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Variance_Order_By = {
  length_feet?: InputMaybe<Order_By>;
};

/** columns and relationships of "sc_equip_xref_uphole_ytool_equip_tubings" */
export type Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings = {
  __typename: 'sc_equip_xref_uphole_ytool_equip_tubings';
  id?: Maybe<Scalars['uuid']['output']>;
  journal_author_id?: Maybe<Scalars['String']['output']>;
  journal_created_at?: Maybe<Scalars['timestamptz']['output']>;
  journal_deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  journal_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  length_feet?: Maybe<Scalars['numeric']['output']>;
  parent_id?: Maybe<Scalars['uuid']['output']>;
  scenario_equipment_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  tubing?: Maybe<Tubings>;
  tubing_id?: Maybe<Scalars['uuid']['output']>;
  winning_revision_author_id?: Maybe<Scalars['String']['output']>;
  winning_revision_created_at?: Maybe<Scalars['timestamptz']['output']>;
  winning_revision_deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  winning_revision_id?: Maybe<Scalars['uuid']['output']>;
  winning_revision_parent_id?: Maybe<Scalars['uuid']['output']>;
  winning_revision_updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregated selection of "sc_equip_xref_uphole_ytool_equip_tubings" */
export type Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Aggregate = {
  __typename: 'sc_equip_xref_uphole_ytool_equip_tubings_aggregate';
  aggregate?: Maybe<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Aggregate_Fields>;
  nodes: Array<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings>;
};

export type Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Aggregate_Bool_Exp = {
  count?: InputMaybe<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Aggregate_Bool_Exp_Count>;
};

export type Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "sc_equip_xref_uphole_ytool_equip_tubings" */
export type Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Aggregate_Fields = {
  __typename: 'sc_equip_xref_uphole_ytool_equip_tubings_aggregate_fields';
  avg?: Maybe<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Max_Fields>;
  min?: Maybe<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Min_Fields>;
  stddev?: Maybe<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Stddev_Fields>;
  stddev_pop?: Maybe<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Stddev_Samp_Fields>;
  sum?: Maybe<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Sum_Fields>;
  var_pop?: Maybe<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Var_Pop_Fields>;
  var_samp?: Maybe<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Var_Samp_Fields>;
  variance?: Maybe<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Variance_Fields>;
};


/** aggregate fields of "sc_equip_xref_uphole_ytool_equip_tubings" */
export type Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "sc_equip_xref_uphole_ytool_equip_tubings" */
export type Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Aggregate_Order_By = {
  avg?: InputMaybe<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Max_Order_By>;
  min?: InputMaybe<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Min_Order_By>;
  stddev?: InputMaybe<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Sum_Order_By>;
  var_pop?: InputMaybe<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Var_Samp_Order_By>;
  variance?: InputMaybe<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "sc_equip_xref_uphole_ytool_equip_tubings" */
export type Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Arr_Rel_Insert_Input = {
  data: Array<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Insert_Input>;
};

/** aggregate avg on columns */
export type Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Avg_Fields = {
  __typename: 'sc_equip_xref_uphole_ytool_equip_tubings_avg_fields';
  length_feet?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "sc_equip_xref_uphole_ytool_equip_tubings" */
export type Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Avg_Order_By = {
  length_feet?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "sc_equip_xref_uphole_ytool_equip_tubings". All fields are combined with a logical 'AND'. */
export type Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Bool_Exp = {
  _and?: InputMaybe<Array<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Bool_Exp>>;
  _not?: InputMaybe<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Bool_Exp>;
  _or?: InputMaybe<Array<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Bool_Exp>>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  journal_author_id?: InputMaybe<String_Comparison_Exp>;
  journal_created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  journal_deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  journal_updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  length_feet?: InputMaybe<Numeric_Comparison_Exp>;
  parent_id?: InputMaybe<Uuid_Comparison_Exp>;
  scenario_equipment_id?: InputMaybe<Uuid_Comparison_Exp>;
  tubing?: InputMaybe<Tubings_Bool_Exp>;
  tubing_id?: InputMaybe<Uuid_Comparison_Exp>;
  winning_revision_author_id?: InputMaybe<String_Comparison_Exp>;
  winning_revision_created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  winning_revision_deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  winning_revision_id?: InputMaybe<Uuid_Comparison_Exp>;
  winning_revision_parent_id?: InputMaybe<Uuid_Comparison_Exp>;
  winning_revision_updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** input type for inserting data into table "sc_equip_xref_uphole_ytool_equip_tubings" */
export type Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Insert_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  journal_author_id?: InputMaybe<Scalars['String']['input']>;
  journal_created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  journal_deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  journal_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  length_feet?: InputMaybe<Scalars['numeric']['input']>;
  parent_id?: InputMaybe<Scalars['uuid']['input']>;
  scenario_equipment_id?: InputMaybe<Scalars['uuid']['input']>;
  tubing?: InputMaybe<Tubings_Obj_Rel_Insert_Input>;
  tubing_id?: InputMaybe<Scalars['uuid']['input']>;
  winning_revision_author_id?: InputMaybe<Scalars['String']['input']>;
  winning_revision_created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  winning_revision_deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  winning_revision_id?: InputMaybe<Scalars['uuid']['input']>;
  winning_revision_parent_id?: InputMaybe<Scalars['uuid']['input']>;
  winning_revision_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Max_Fields = {
  __typename: 'sc_equip_xref_uphole_ytool_equip_tubings_max_fields';
  id?: Maybe<Scalars['uuid']['output']>;
  journal_author_id?: Maybe<Scalars['String']['output']>;
  journal_created_at?: Maybe<Scalars['timestamptz']['output']>;
  journal_deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  journal_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  length_feet?: Maybe<Scalars['numeric']['output']>;
  parent_id?: Maybe<Scalars['uuid']['output']>;
  scenario_equipment_id?: Maybe<Scalars['uuid']['output']>;
  tubing_id?: Maybe<Scalars['uuid']['output']>;
  winning_revision_author_id?: Maybe<Scalars['String']['output']>;
  winning_revision_created_at?: Maybe<Scalars['timestamptz']['output']>;
  winning_revision_deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  winning_revision_id?: Maybe<Scalars['uuid']['output']>;
  winning_revision_parent_id?: Maybe<Scalars['uuid']['output']>;
  winning_revision_updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "sc_equip_xref_uphole_ytool_equip_tubings" */
export type Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  journal_author_id?: InputMaybe<Order_By>;
  journal_created_at?: InputMaybe<Order_By>;
  journal_deleted_at?: InputMaybe<Order_By>;
  journal_updated_at?: InputMaybe<Order_By>;
  length_feet?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  scenario_equipment_id?: InputMaybe<Order_By>;
  tubing_id?: InputMaybe<Order_By>;
  winning_revision_author_id?: InputMaybe<Order_By>;
  winning_revision_created_at?: InputMaybe<Order_By>;
  winning_revision_deleted_at?: InputMaybe<Order_By>;
  winning_revision_id?: InputMaybe<Order_By>;
  winning_revision_parent_id?: InputMaybe<Order_By>;
  winning_revision_updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Min_Fields = {
  __typename: 'sc_equip_xref_uphole_ytool_equip_tubings_min_fields';
  id?: Maybe<Scalars['uuid']['output']>;
  journal_author_id?: Maybe<Scalars['String']['output']>;
  journal_created_at?: Maybe<Scalars['timestamptz']['output']>;
  journal_deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  journal_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  length_feet?: Maybe<Scalars['numeric']['output']>;
  parent_id?: Maybe<Scalars['uuid']['output']>;
  scenario_equipment_id?: Maybe<Scalars['uuid']['output']>;
  tubing_id?: Maybe<Scalars['uuid']['output']>;
  winning_revision_author_id?: Maybe<Scalars['String']['output']>;
  winning_revision_created_at?: Maybe<Scalars['timestamptz']['output']>;
  winning_revision_deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  winning_revision_id?: Maybe<Scalars['uuid']['output']>;
  winning_revision_parent_id?: Maybe<Scalars['uuid']['output']>;
  winning_revision_updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "sc_equip_xref_uphole_ytool_equip_tubings" */
export type Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  journal_author_id?: InputMaybe<Order_By>;
  journal_created_at?: InputMaybe<Order_By>;
  journal_deleted_at?: InputMaybe<Order_By>;
  journal_updated_at?: InputMaybe<Order_By>;
  length_feet?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  scenario_equipment_id?: InputMaybe<Order_By>;
  tubing_id?: InputMaybe<Order_By>;
  winning_revision_author_id?: InputMaybe<Order_By>;
  winning_revision_created_at?: InputMaybe<Order_By>;
  winning_revision_deleted_at?: InputMaybe<Order_By>;
  winning_revision_id?: InputMaybe<Order_By>;
  winning_revision_parent_id?: InputMaybe<Order_By>;
  winning_revision_updated_at?: InputMaybe<Order_By>;
};

/** input type for inserting object relation for remote table "sc_equip_xref_uphole_ytool_equip_tubings" */
export type Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Obj_Rel_Insert_Input = {
  data: Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Insert_Input;
};

/** Ordering options when selecting data from "sc_equip_xref_uphole_ytool_equip_tubings". */
export type Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Order_By = {
  id?: InputMaybe<Order_By>;
  journal_author_id?: InputMaybe<Order_By>;
  journal_created_at?: InputMaybe<Order_By>;
  journal_deleted_at?: InputMaybe<Order_By>;
  journal_updated_at?: InputMaybe<Order_By>;
  length_feet?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  scenario_equipment_id?: InputMaybe<Order_By>;
  tubing?: InputMaybe<Tubings_Order_By>;
  tubing_id?: InputMaybe<Order_By>;
  winning_revision_author_id?: InputMaybe<Order_By>;
  winning_revision_created_at?: InputMaybe<Order_By>;
  winning_revision_deleted_at?: InputMaybe<Order_By>;
  winning_revision_id?: InputMaybe<Order_By>;
  winning_revision_parent_id?: InputMaybe<Order_By>;
  winning_revision_updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "sc_equip_xref_uphole_ytool_equip_tubings" */
export enum Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  JournalAuthorId = 'journal_author_id',
  /** column name */
  JournalCreatedAt = 'journal_created_at',
  /** column name */
  JournalDeletedAt = 'journal_deleted_at',
  /** column name */
  JournalUpdatedAt = 'journal_updated_at',
  /** column name */
  LengthFeet = 'length_feet',
  /** column name */
  ParentId = 'parent_id',
  /** column name */
  ScenarioEquipmentId = 'scenario_equipment_id',
  /** column name */
  TubingId = 'tubing_id',
  /** column name */
  WinningRevisionAuthorId = 'winning_revision_author_id',
  /** column name */
  WinningRevisionCreatedAt = 'winning_revision_created_at',
  /** column name */
  WinningRevisionDeletedAt = 'winning_revision_deleted_at',
  /** column name */
  WinningRevisionId = 'winning_revision_id',
  /** column name */
  WinningRevisionParentId = 'winning_revision_parent_id',
  /** column name */
  WinningRevisionUpdatedAt = 'winning_revision_updated_at'
}

/** aggregate stddev on columns */
export type Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Stddev_Fields = {
  __typename: 'sc_equip_xref_uphole_ytool_equip_tubings_stddev_fields';
  length_feet?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "sc_equip_xref_uphole_ytool_equip_tubings" */
export type Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Stddev_Order_By = {
  length_feet?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Stddev_Pop_Fields = {
  __typename: 'sc_equip_xref_uphole_ytool_equip_tubings_stddev_pop_fields';
  length_feet?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "sc_equip_xref_uphole_ytool_equip_tubings" */
export type Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Stddev_Pop_Order_By = {
  length_feet?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Stddev_Samp_Fields = {
  __typename: 'sc_equip_xref_uphole_ytool_equip_tubings_stddev_samp_fields';
  length_feet?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "sc_equip_xref_uphole_ytool_equip_tubings" */
export type Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Stddev_Samp_Order_By = {
  length_feet?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "sc_equip_xref_uphole_ytool_equip_tubings" */
export type Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  journal_author_id?: InputMaybe<Scalars['String']['input']>;
  journal_created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  journal_deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  journal_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  length_feet?: InputMaybe<Scalars['numeric']['input']>;
  parent_id?: InputMaybe<Scalars['uuid']['input']>;
  scenario_equipment_id?: InputMaybe<Scalars['uuid']['input']>;
  tubing_id?: InputMaybe<Scalars['uuid']['input']>;
  winning_revision_author_id?: InputMaybe<Scalars['String']['input']>;
  winning_revision_created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  winning_revision_deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  winning_revision_id?: InputMaybe<Scalars['uuid']['input']>;
  winning_revision_parent_id?: InputMaybe<Scalars['uuid']['input']>;
  winning_revision_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Sum_Fields = {
  __typename: 'sc_equip_xref_uphole_ytool_equip_tubings_sum_fields';
  length_feet?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "sc_equip_xref_uphole_ytool_equip_tubings" */
export type Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Sum_Order_By = {
  length_feet?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Var_Pop_Fields = {
  __typename: 'sc_equip_xref_uphole_ytool_equip_tubings_var_pop_fields';
  length_feet?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "sc_equip_xref_uphole_ytool_equip_tubings" */
export type Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Var_Pop_Order_By = {
  length_feet?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Var_Samp_Fields = {
  __typename: 'sc_equip_xref_uphole_ytool_equip_tubings_var_samp_fields';
  length_feet?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "sc_equip_xref_uphole_ytool_equip_tubings" */
export type Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Var_Samp_Order_By = {
  length_feet?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Variance_Fields = {
  __typename: 'sc_equip_xref_uphole_ytool_equip_tubings_variance_fields';
  length_feet?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "sc_equip_xref_uphole_ytool_equip_tubings" */
export type Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Variance_Order_By = {
  length_feet?: InputMaybe<Order_By>;
};

/** columns and relationships of "scenario_correlations" */
export type Scenario_Correlations = {
  __typename: 'scenario_correlations';
  bubble_point?: Maybe<Scalars['String']['output']>;
  casing_apply_hazen_williams_correction?: Maybe<Scalars['Boolean']['output']>;
  casing_flow?: Maybe<Scalars['String']['output']>;
  casing_griffith_wallis?: Maybe<Scalars['Boolean']['output']>;
  casing_hazen_williams_coefficient?: Maybe<Scalars['numeric']['output']>;
  casing_palmer_correction?: Maybe<Scalars['Boolean']['output']>;
  casing_roughness_inches?: Maybe<Scalars['numeric']['output']>;
  dead_oil?: Maybe<Scalars['String']['output']>;
  friction_loss?: Maybe<Scalars['String']['output']>;
  gas_compressibility?: Maybe<Scalars['String']['output']>;
  gas_viscosity?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  journal_author_id?: Maybe<Scalars['String']['output']>;
  journal_created_at?: Maybe<Scalars['timestamptz']['output']>;
  journal_deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  journal_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  natural_gas_separation?: Maybe<Scalars['String']['output']>;
  oil_density?: Maybe<Scalars['String']['output']>;
  oil_volume_factor_saturated?: Maybe<Scalars['String']['output']>;
  oil_volume_factor_undersaturated?: Maybe<Scalars['String']['output']>;
  parent_id?: Maybe<Scalars['uuid']['output']>;
  salinity_ppm?: Maybe<Scalars['numeric']['output']>;
  saturated_oil?: Maybe<Scalars['String']['output']>;
  solution_gor?: Maybe<Scalars['String']['output']>;
  tdh_tuning_factor_ratio?: Maybe<Scalars['numeric']['output']>;
  tubing_apply_hazen_williams_correction?: Maybe<Scalars['Boolean']['output']>;
  tubing_flow?: Maybe<Scalars['String']['output']>;
  tubing_griffith_wallis?: Maybe<Scalars['Boolean']['output']>;
  tubing_hazen_williams_coefficient?: Maybe<Scalars['numeric']['output']>;
  tubing_palmer_correction?: Maybe<Scalars['Boolean']['output']>;
  tubing_roughness_inches?: Maybe<Scalars['numeric']['output']>;
  under_saturated_oil?: Maybe<Scalars['String']['output']>;
  water_density?: Maybe<Scalars['String']['output']>;
  water_solution_gas?: Maybe<Scalars['String']['output']>;
  water_viscosity?: Maybe<Scalars['String']['output']>;
  water_volume_factor?: Maybe<Scalars['String']['output']>;
  winning_revision_author_id?: Maybe<Scalars['String']['output']>;
  winning_revision_created_at?: Maybe<Scalars['timestamptz']['output']>;
  winning_revision_deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  winning_revision_id?: Maybe<Scalars['uuid']['output']>;
  winning_revision_parent_id?: Maybe<Scalars['uuid']['output']>;
  winning_revision_updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregated selection of "scenario_correlations" */
export type Scenario_Correlations_Aggregate = {
  __typename: 'scenario_correlations_aggregate';
  aggregate?: Maybe<Scenario_Correlations_Aggregate_Fields>;
  nodes: Array<Scenario_Correlations>;
};

/** aggregate fields of "scenario_correlations" */
export type Scenario_Correlations_Aggregate_Fields = {
  __typename: 'scenario_correlations_aggregate_fields';
  avg?: Maybe<Scenario_Correlations_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Scenario_Correlations_Max_Fields>;
  min?: Maybe<Scenario_Correlations_Min_Fields>;
  stddev?: Maybe<Scenario_Correlations_Stddev_Fields>;
  stddev_pop?: Maybe<Scenario_Correlations_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Scenario_Correlations_Stddev_Samp_Fields>;
  sum?: Maybe<Scenario_Correlations_Sum_Fields>;
  var_pop?: Maybe<Scenario_Correlations_Var_Pop_Fields>;
  var_samp?: Maybe<Scenario_Correlations_Var_Samp_Fields>;
  variance?: Maybe<Scenario_Correlations_Variance_Fields>;
};


/** aggregate fields of "scenario_correlations" */
export type Scenario_Correlations_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Scenario_Correlations_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Scenario_Correlations_Avg_Fields = {
  __typename: 'scenario_correlations_avg_fields';
  casing_hazen_williams_coefficient?: Maybe<Scalars['Float']['output']>;
  casing_roughness_inches?: Maybe<Scalars['Float']['output']>;
  salinity_ppm?: Maybe<Scalars['Float']['output']>;
  tdh_tuning_factor_ratio?: Maybe<Scalars['Float']['output']>;
  tubing_hazen_williams_coefficient?: Maybe<Scalars['Float']['output']>;
  tubing_roughness_inches?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "scenario_correlations". All fields are combined with a logical 'AND'. */
export type Scenario_Correlations_Bool_Exp = {
  _and?: InputMaybe<Array<Scenario_Correlations_Bool_Exp>>;
  _not?: InputMaybe<Scenario_Correlations_Bool_Exp>;
  _or?: InputMaybe<Array<Scenario_Correlations_Bool_Exp>>;
  bubble_point?: InputMaybe<String_Comparison_Exp>;
  casing_apply_hazen_williams_correction?: InputMaybe<Boolean_Comparison_Exp>;
  casing_flow?: InputMaybe<String_Comparison_Exp>;
  casing_griffith_wallis?: InputMaybe<Boolean_Comparison_Exp>;
  casing_hazen_williams_coefficient?: InputMaybe<Numeric_Comparison_Exp>;
  casing_palmer_correction?: InputMaybe<Boolean_Comparison_Exp>;
  casing_roughness_inches?: InputMaybe<Numeric_Comparison_Exp>;
  dead_oil?: InputMaybe<String_Comparison_Exp>;
  friction_loss?: InputMaybe<String_Comparison_Exp>;
  gas_compressibility?: InputMaybe<String_Comparison_Exp>;
  gas_viscosity?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  journal_author_id?: InputMaybe<String_Comparison_Exp>;
  journal_created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  journal_deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  journal_updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  natural_gas_separation?: InputMaybe<String_Comparison_Exp>;
  oil_density?: InputMaybe<String_Comparison_Exp>;
  oil_volume_factor_saturated?: InputMaybe<String_Comparison_Exp>;
  oil_volume_factor_undersaturated?: InputMaybe<String_Comparison_Exp>;
  parent_id?: InputMaybe<Uuid_Comparison_Exp>;
  salinity_ppm?: InputMaybe<Numeric_Comparison_Exp>;
  saturated_oil?: InputMaybe<String_Comparison_Exp>;
  solution_gor?: InputMaybe<String_Comparison_Exp>;
  tdh_tuning_factor_ratio?: InputMaybe<Numeric_Comparison_Exp>;
  tubing_apply_hazen_williams_correction?: InputMaybe<Boolean_Comparison_Exp>;
  tubing_flow?: InputMaybe<String_Comparison_Exp>;
  tubing_griffith_wallis?: InputMaybe<Boolean_Comparison_Exp>;
  tubing_hazen_williams_coefficient?: InputMaybe<Numeric_Comparison_Exp>;
  tubing_palmer_correction?: InputMaybe<Boolean_Comparison_Exp>;
  tubing_roughness_inches?: InputMaybe<Numeric_Comparison_Exp>;
  under_saturated_oil?: InputMaybe<String_Comparison_Exp>;
  water_density?: InputMaybe<String_Comparison_Exp>;
  water_solution_gas?: InputMaybe<String_Comparison_Exp>;
  water_viscosity?: InputMaybe<String_Comparison_Exp>;
  water_volume_factor?: InputMaybe<String_Comparison_Exp>;
  winning_revision_author_id?: InputMaybe<String_Comparison_Exp>;
  winning_revision_created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  winning_revision_deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  winning_revision_id?: InputMaybe<Uuid_Comparison_Exp>;
  winning_revision_parent_id?: InputMaybe<Uuid_Comparison_Exp>;
  winning_revision_updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** input type for inserting data into table "scenario_correlations" */
export type Scenario_Correlations_Insert_Input = {
  bubble_point?: InputMaybe<Scalars['String']['input']>;
  casing_apply_hazen_williams_correction?: InputMaybe<Scalars['Boolean']['input']>;
  casing_flow?: InputMaybe<Scalars['String']['input']>;
  casing_griffith_wallis?: InputMaybe<Scalars['Boolean']['input']>;
  casing_hazen_williams_coefficient?: InputMaybe<Scalars['numeric']['input']>;
  casing_palmer_correction?: InputMaybe<Scalars['Boolean']['input']>;
  casing_roughness_inches?: InputMaybe<Scalars['numeric']['input']>;
  dead_oil?: InputMaybe<Scalars['String']['input']>;
  friction_loss?: InputMaybe<Scalars['String']['input']>;
  gas_compressibility?: InputMaybe<Scalars['String']['input']>;
  gas_viscosity?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  journal_author_id?: InputMaybe<Scalars['String']['input']>;
  journal_created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  journal_deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  journal_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  natural_gas_separation?: InputMaybe<Scalars['String']['input']>;
  oil_density?: InputMaybe<Scalars['String']['input']>;
  oil_volume_factor_saturated?: InputMaybe<Scalars['String']['input']>;
  oil_volume_factor_undersaturated?: InputMaybe<Scalars['String']['input']>;
  parent_id?: InputMaybe<Scalars['uuid']['input']>;
  salinity_ppm?: InputMaybe<Scalars['numeric']['input']>;
  saturated_oil?: InputMaybe<Scalars['String']['input']>;
  solution_gor?: InputMaybe<Scalars['String']['input']>;
  tdh_tuning_factor_ratio?: InputMaybe<Scalars['numeric']['input']>;
  tubing_apply_hazen_williams_correction?: InputMaybe<Scalars['Boolean']['input']>;
  tubing_flow?: InputMaybe<Scalars['String']['input']>;
  tubing_griffith_wallis?: InputMaybe<Scalars['Boolean']['input']>;
  tubing_hazen_williams_coefficient?: InputMaybe<Scalars['numeric']['input']>;
  tubing_palmer_correction?: InputMaybe<Scalars['Boolean']['input']>;
  tubing_roughness_inches?: InputMaybe<Scalars['numeric']['input']>;
  under_saturated_oil?: InputMaybe<Scalars['String']['input']>;
  water_density?: InputMaybe<Scalars['String']['input']>;
  water_solution_gas?: InputMaybe<Scalars['String']['input']>;
  water_viscosity?: InputMaybe<Scalars['String']['input']>;
  water_volume_factor?: InputMaybe<Scalars['String']['input']>;
  winning_revision_author_id?: InputMaybe<Scalars['String']['input']>;
  winning_revision_created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  winning_revision_deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  winning_revision_id?: InputMaybe<Scalars['uuid']['input']>;
  winning_revision_parent_id?: InputMaybe<Scalars['uuid']['input']>;
  winning_revision_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Scenario_Correlations_Max_Fields = {
  __typename: 'scenario_correlations_max_fields';
  bubble_point?: Maybe<Scalars['String']['output']>;
  casing_flow?: Maybe<Scalars['String']['output']>;
  casing_hazen_williams_coefficient?: Maybe<Scalars['numeric']['output']>;
  casing_roughness_inches?: Maybe<Scalars['numeric']['output']>;
  dead_oil?: Maybe<Scalars['String']['output']>;
  friction_loss?: Maybe<Scalars['String']['output']>;
  gas_compressibility?: Maybe<Scalars['String']['output']>;
  gas_viscosity?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  journal_author_id?: Maybe<Scalars['String']['output']>;
  journal_created_at?: Maybe<Scalars['timestamptz']['output']>;
  journal_deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  journal_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  natural_gas_separation?: Maybe<Scalars['String']['output']>;
  oil_density?: Maybe<Scalars['String']['output']>;
  oil_volume_factor_saturated?: Maybe<Scalars['String']['output']>;
  oil_volume_factor_undersaturated?: Maybe<Scalars['String']['output']>;
  parent_id?: Maybe<Scalars['uuid']['output']>;
  salinity_ppm?: Maybe<Scalars['numeric']['output']>;
  saturated_oil?: Maybe<Scalars['String']['output']>;
  solution_gor?: Maybe<Scalars['String']['output']>;
  tdh_tuning_factor_ratio?: Maybe<Scalars['numeric']['output']>;
  tubing_flow?: Maybe<Scalars['String']['output']>;
  tubing_hazen_williams_coefficient?: Maybe<Scalars['numeric']['output']>;
  tubing_roughness_inches?: Maybe<Scalars['numeric']['output']>;
  under_saturated_oil?: Maybe<Scalars['String']['output']>;
  water_density?: Maybe<Scalars['String']['output']>;
  water_solution_gas?: Maybe<Scalars['String']['output']>;
  water_viscosity?: Maybe<Scalars['String']['output']>;
  water_volume_factor?: Maybe<Scalars['String']['output']>;
  winning_revision_author_id?: Maybe<Scalars['String']['output']>;
  winning_revision_created_at?: Maybe<Scalars['timestamptz']['output']>;
  winning_revision_deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  winning_revision_id?: Maybe<Scalars['uuid']['output']>;
  winning_revision_parent_id?: Maybe<Scalars['uuid']['output']>;
  winning_revision_updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Scenario_Correlations_Min_Fields = {
  __typename: 'scenario_correlations_min_fields';
  bubble_point?: Maybe<Scalars['String']['output']>;
  casing_flow?: Maybe<Scalars['String']['output']>;
  casing_hazen_williams_coefficient?: Maybe<Scalars['numeric']['output']>;
  casing_roughness_inches?: Maybe<Scalars['numeric']['output']>;
  dead_oil?: Maybe<Scalars['String']['output']>;
  friction_loss?: Maybe<Scalars['String']['output']>;
  gas_compressibility?: Maybe<Scalars['String']['output']>;
  gas_viscosity?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  journal_author_id?: Maybe<Scalars['String']['output']>;
  journal_created_at?: Maybe<Scalars['timestamptz']['output']>;
  journal_deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  journal_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  natural_gas_separation?: Maybe<Scalars['String']['output']>;
  oil_density?: Maybe<Scalars['String']['output']>;
  oil_volume_factor_saturated?: Maybe<Scalars['String']['output']>;
  oil_volume_factor_undersaturated?: Maybe<Scalars['String']['output']>;
  parent_id?: Maybe<Scalars['uuid']['output']>;
  salinity_ppm?: Maybe<Scalars['numeric']['output']>;
  saturated_oil?: Maybe<Scalars['String']['output']>;
  solution_gor?: Maybe<Scalars['String']['output']>;
  tdh_tuning_factor_ratio?: Maybe<Scalars['numeric']['output']>;
  tubing_flow?: Maybe<Scalars['String']['output']>;
  tubing_hazen_williams_coefficient?: Maybe<Scalars['numeric']['output']>;
  tubing_roughness_inches?: Maybe<Scalars['numeric']['output']>;
  under_saturated_oil?: Maybe<Scalars['String']['output']>;
  water_density?: Maybe<Scalars['String']['output']>;
  water_solution_gas?: Maybe<Scalars['String']['output']>;
  water_viscosity?: Maybe<Scalars['String']['output']>;
  water_volume_factor?: Maybe<Scalars['String']['output']>;
  winning_revision_author_id?: Maybe<Scalars['String']['output']>;
  winning_revision_created_at?: Maybe<Scalars['timestamptz']['output']>;
  winning_revision_deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  winning_revision_id?: Maybe<Scalars['uuid']['output']>;
  winning_revision_parent_id?: Maybe<Scalars['uuid']['output']>;
  winning_revision_updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** input type for inserting object relation for remote table "scenario_correlations" */
export type Scenario_Correlations_Obj_Rel_Insert_Input = {
  data: Scenario_Correlations_Insert_Input;
};

/** Ordering options when selecting data from "scenario_correlations". */
export type Scenario_Correlations_Order_By = {
  bubble_point?: InputMaybe<Order_By>;
  casing_apply_hazen_williams_correction?: InputMaybe<Order_By>;
  casing_flow?: InputMaybe<Order_By>;
  casing_griffith_wallis?: InputMaybe<Order_By>;
  casing_hazen_williams_coefficient?: InputMaybe<Order_By>;
  casing_palmer_correction?: InputMaybe<Order_By>;
  casing_roughness_inches?: InputMaybe<Order_By>;
  dead_oil?: InputMaybe<Order_By>;
  friction_loss?: InputMaybe<Order_By>;
  gas_compressibility?: InputMaybe<Order_By>;
  gas_viscosity?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  journal_author_id?: InputMaybe<Order_By>;
  journal_created_at?: InputMaybe<Order_By>;
  journal_deleted_at?: InputMaybe<Order_By>;
  journal_updated_at?: InputMaybe<Order_By>;
  natural_gas_separation?: InputMaybe<Order_By>;
  oil_density?: InputMaybe<Order_By>;
  oil_volume_factor_saturated?: InputMaybe<Order_By>;
  oil_volume_factor_undersaturated?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  salinity_ppm?: InputMaybe<Order_By>;
  saturated_oil?: InputMaybe<Order_By>;
  solution_gor?: InputMaybe<Order_By>;
  tdh_tuning_factor_ratio?: InputMaybe<Order_By>;
  tubing_apply_hazen_williams_correction?: InputMaybe<Order_By>;
  tubing_flow?: InputMaybe<Order_By>;
  tubing_griffith_wallis?: InputMaybe<Order_By>;
  tubing_hazen_williams_coefficient?: InputMaybe<Order_By>;
  tubing_palmer_correction?: InputMaybe<Order_By>;
  tubing_roughness_inches?: InputMaybe<Order_By>;
  under_saturated_oil?: InputMaybe<Order_By>;
  water_density?: InputMaybe<Order_By>;
  water_solution_gas?: InputMaybe<Order_By>;
  water_viscosity?: InputMaybe<Order_By>;
  water_volume_factor?: InputMaybe<Order_By>;
  winning_revision_author_id?: InputMaybe<Order_By>;
  winning_revision_created_at?: InputMaybe<Order_By>;
  winning_revision_deleted_at?: InputMaybe<Order_By>;
  winning_revision_id?: InputMaybe<Order_By>;
  winning_revision_parent_id?: InputMaybe<Order_By>;
  winning_revision_updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "scenario_correlations" */
export enum Scenario_Correlations_Select_Column {
  /** column name */
  BubblePoint = 'bubble_point',
  /** column name */
  CasingApplyHazenWilliamsCorrection = 'casing_apply_hazen_williams_correction',
  /** column name */
  CasingFlow = 'casing_flow',
  /** column name */
  CasingGriffithWallis = 'casing_griffith_wallis',
  /** column name */
  CasingHazenWilliamsCoefficient = 'casing_hazen_williams_coefficient',
  /** column name */
  CasingPalmerCorrection = 'casing_palmer_correction',
  /** column name */
  CasingRoughnessInches = 'casing_roughness_inches',
  /** column name */
  DeadOil = 'dead_oil',
  /** column name */
  FrictionLoss = 'friction_loss',
  /** column name */
  GasCompressibility = 'gas_compressibility',
  /** column name */
  GasViscosity = 'gas_viscosity',
  /** column name */
  Id = 'id',
  /** column name */
  JournalAuthorId = 'journal_author_id',
  /** column name */
  JournalCreatedAt = 'journal_created_at',
  /** column name */
  JournalDeletedAt = 'journal_deleted_at',
  /** column name */
  JournalUpdatedAt = 'journal_updated_at',
  /** column name */
  NaturalGasSeparation = 'natural_gas_separation',
  /** column name */
  OilDensity = 'oil_density',
  /** column name */
  OilVolumeFactorSaturated = 'oil_volume_factor_saturated',
  /** column name */
  OilVolumeFactorUndersaturated = 'oil_volume_factor_undersaturated',
  /** column name */
  ParentId = 'parent_id',
  /** column name */
  SalinityPpm = 'salinity_ppm',
  /** column name */
  SaturatedOil = 'saturated_oil',
  /** column name */
  SolutionGor = 'solution_gor',
  /** column name */
  TdhTuningFactorRatio = 'tdh_tuning_factor_ratio',
  /** column name */
  TubingApplyHazenWilliamsCorrection = 'tubing_apply_hazen_williams_correction',
  /** column name */
  TubingFlow = 'tubing_flow',
  /** column name */
  TubingGriffithWallis = 'tubing_griffith_wallis',
  /** column name */
  TubingHazenWilliamsCoefficient = 'tubing_hazen_williams_coefficient',
  /** column name */
  TubingPalmerCorrection = 'tubing_palmer_correction',
  /** column name */
  TubingRoughnessInches = 'tubing_roughness_inches',
  /** column name */
  UnderSaturatedOil = 'under_saturated_oil',
  /** column name */
  WaterDensity = 'water_density',
  /** column name */
  WaterSolutionGas = 'water_solution_gas',
  /** column name */
  WaterViscosity = 'water_viscosity',
  /** column name */
  WaterVolumeFactor = 'water_volume_factor',
  /** column name */
  WinningRevisionAuthorId = 'winning_revision_author_id',
  /** column name */
  WinningRevisionCreatedAt = 'winning_revision_created_at',
  /** column name */
  WinningRevisionDeletedAt = 'winning_revision_deleted_at',
  /** column name */
  WinningRevisionId = 'winning_revision_id',
  /** column name */
  WinningRevisionParentId = 'winning_revision_parent_id',
  /** column name */
  WinningRevisionUpdatedAt = 'winning_revision_updated_at'
}

/** aggregate stddev on columns */
export type Scenario_Correlations_Stddev_Fields = {
  __typename: 'scenario_correlations_stddev_fields';
  casing_hazen_williams_coefficient?: Maybe<Scalars['Float']['output']>;
  casing_roughness_inches?: Maybe<Scalars['Float']['output']>;
  salinity_ppm?: Maybe<Scalars['Float']['output']>;
  tdh_tuning_factor_ratio?: Maybe<Scalars['Float']['output']>;
  tubing_hazen_williams_coefficient?: Maybe<Scalars['Float']['output']>;
  tubing_roughness_inches?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Scenario_Correlations_Stddev_Pop_Fields = {
  __typename: 'scenario_correlations_stddev_pop_fields';
  casing_hazen_williams_coefficient?: Maybe<Scalars['Float']['output']>;
  casing_roughness_inches?: Maybe<Scalars['Float']['output']>;
  salinity_ppm?: Maybe<Scalars['Float']['output']>;
  tdh_tuning_factor_ratio?: Maybe<Scalars['Float']['output']>;
  tubing_hazen_williams_coefficient?: Maybe<Scalars['Float']['output']>;
  tubing_roughness_inches?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Scenario_Correlations_Stddev_Samp_Fields = {
  __typename: 'scenario_correlations_stddev_samp_fields';
  casing_hazen_williams_coefficient?: Maybe<Scalars['Float']['output']>;
  casing_roughness_inches?: Maybe<Scalars['Float']['output']>;
  salinity_ppm?: Maybe<Scalars['Float']['output']>;
  tdh_tuning_factor_ratio?: Maybe<Scalars['Float']['output']>;
  tubing_hazen_williams_coefficient?: Maybe<Scalars['Float']['output']>;
  tubing_roughness_inches?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "scenario_correlations" */
export type Scenario_Correlations_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Scenario_Correlations_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Scenario_Correlations_Stream_Cursor_Value_Input = {
  bubble_point?: InputMaybe<Scalars['String']['input']>;
  casing_apply_hazen_williams_correction?: InputMaybe<Scalars['Boolean']['input']>;
  casing_flow?: InputMaybe<Scalars['String']['input']>;
  casing_griffith_wallis?: InputMaybe<Scalars['Boolean']['input']>;
  casing_hazen_williams_coefficient?: InputMaybe<Scalars['numeric']['input']>;
  casing_palmer_correction?: InputMaybe<Scalars['Boolean']['input']>;
  casing_roughness_inches?: InputMaybe<Scalars['numeric']['input']>;
  dead_oil?: InputMaybe<Scalars['String']['input']>;
  friction_loss?: InputMaybe<Scalars['String']['input']>;
  gas_compressibility?: InputMaybe<Scalars['String']['input']>;
  gas_viscosity?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  journal_author_id?: InputMaybe<Scalars['String']['input']>;
  journal_created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  journal_deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  journal_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  natural_gas_separation?: InputMaybe<Scalars['String']['input']>;
  oil_density?: InputMaybe<Scalars['String']['input']>;
  oil_volume_factor_saturated?: InputMaybe<Scalars['String']['input']>;
  oil_volume_factor_undersaturated?: InputMaybe<Scalars['String']['input']>;
  parent_id?: InputMaybe<Scalars['uuid']['input']>;
  salinity_ppm?: InputMaybe<Scalars['numeric']['input']>;
  saturated_oil?: InputMaybe<Scalars['String']['input']>;
  solution_gor?: InputMaybe<Scalars['String']['input']>;
  tdh_tuning_factor_ratio?: InputMaybe<Scalars['numeric']['input']>;
  tubing_apply_hazen_williams_correction?: InputMaybe<Scalars['Boolean']['input']>;
  tubing_flow?: InputMaybe<Scalars['String']['input']>;
  tubing_griffith_wallis?: InputMaybe<Scalars['Boolean']['input']>;
  tubing_hazen_williams_coefficient?: InputMaybe<Scalars['numeric']['input']>;
  tubing_palmer_correction?: InputMaybe<Scalars['Boolean']['input']>;
  tubing_roughness_inches?: InputMaybe<Scalars['numeric']['input']>;
  under_saturated_oil?: InputMaybe<Scalars['String']['input']>;
  water_density?: InputMaybe<Scalars['String']['input']>;
  water_solution_gas?: InputMaybe<Scalars['String']['input']>;
  water_viscosity?: InputMaybe<Scalars['String']['input']>;
  water_volume_factor?: InputMaybe<Scalars['String']['input']>;
  winning_revision_author_id?: InputMaybe<Scalars['String']['input']>;
  winning_revision_created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  winning_revision_deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  winning_revision_id?: InputMaybe<Scalars['uuid']['input']>;
  winning_revision_parent_id?: InputMaybe<Scalars['uuid']['input']>;
  winning_revision_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Scenario_Correlations_Sum_Fields = {
  __typename: 'scenario_correlations_sum_fields';
  casing_hazen_williams_coefficient?: Maybe<Scalars['numeric']['output']>;
  casing_roughness_inches?: Maybe<Scalars['numeric']['output']>;
  salinity_ppm?: Maybe<Scalars['numeric']['output']>;
  tdh_tuning_factor_ratio?: Maybe<Scalars['numeric']['output']>;
  tubing_hazen_williams_coefficient?: Maybe<Scalars['numeric']['output']>;
  tubing_roughness_inches?: Maybe<Scalars['numeric']['output']>;
};

/** aggregate var_pop on columns */
export type Scenario_Correlations_Var_Pop_Fields = {
  __typename: 'scenario_correlations_var_pop_fields';
  casing_hazen_williams_coefficient?: Maybe<Scalars['Float']['output']>;
  casing_roughness_inches?: Maybe<Scalars['Float']['output']>;
  salinity_ppm?: Maybe<Scalars['Float']['output']>;
  tdh_tuning_factor_ratio?: Maybe<Scalars['Float']['output']>;
  tubing_hazen_williams_coefficient?: Maybe<Scalars['Float']['output']>;
  tubing_roughness_inches?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Scenario_Correlations_Var_Samp_Fields = {
  __typename: 'scenario_correlations_var_samp_fields';
  casing_hazen_williams_coefficient?: Maybe<Scalars['Float']['output']>;
  casing_roughness_inches?: Maybe<Scalars['Float']['output']>;
  salinity_ppm?: Maybe<Scalars['Float']['output']>;
  tdh_tuning_factor_ratio?: Maybe<Scalars['Float']['output']>;
  tubing_hazen_williams_coefficient?: Maybe<Scalars['Float']['output']>;
  tubing_roughness_inches?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Scenario_Correlations_Variance_Fields = {
  __typename: 'scenario_correlations_variance_fields';
  casing_hazen_williams_coefficient?: Maybe<Scalars['Float']['output']>;
  casing_roughness_inches?: Maybe<Scalars['Float']['output']>;
  salinity_ppm?: Maybe<Scalars['Float']['output']>;
  tdh_tuning_factor_ratio?: Maybe<Scalars['Float']['output']>;
  tubing_hazen_williams_coefficient?: Maybe<Scalars['Float']['output']>;
  tubing_roughness_inches?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "scenario_equipment" */
export type Scenario_Equipment = {
  __typename: 'scenario_equipment';
  /** An object relationship */
  bolt_on_discharge?: Maybe<Bolt_On_Discharges>;
  bolt_on_discharge_id?: Maybe<Scalars['uuid']['output']>;
  cables_order?: Maybe<Array<Scalars['uuid']['output']>>;
  down_trans_id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  downhole_xref_y_tool_bypass_tubings: Array<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings>;
  /** An aggregate relationship */
  downhole_xref_y_tool_bypass_tubings_aggregate: Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Aggregate;
  /** An array relationship */
  downhole_xref_y_tool_equipment_tubings: Array<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings>;
  /** An aggregate relationship */
  downhole_xref_y_tool_equipment_tubings_aggregate: Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Aggregate;
  /** An object relationship */
  downhole_y_tool?: Maybe<Y_Tools>;
  downhole_y_tool_bypass_tubing_order?: Maybe<Array<Scalars['uuid']['output']>>;
  downhole_y_tool_equipment_tubing_order?: Maybe<Array<Scalars['uuid']['output']>>;
  downhole_y_tool_id?: Maybe<Scalars['uuid']['output']>;
  has_lower_equip_stack?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  include_y_tool?: Maybe<Scalars['Boolean']['output']>;
  intakes_order?: Maybe<Array<Scalars['uuid']['output']>>;
  journal_author_id?: Maybe<Scalars['String']['output']>;
  journal_created_at?: Maybe<Scalars['timestamptz']['output']>;
  journal_deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  journal_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  lower_bolt_on_discharge?: Maybe<Bolt_On_Discharges>;
  lower_bolt_on_discharge_id?: Maybe<Scalars['uuid']['output']>;
  lower_cables_order?: Maybe<Array<Scalars['uuid']['output']>>;
  lower_intakes_order?: Maybe<Array<Scalars['uuid']['output']>>;
  /** An object relationship */
  lower_mle?: Maybe<Motor_Lead_Extensions>;
  lower_mle_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  lower_motor?: Maybe<Motors>;
  lower_motor_id?: Maybe<Scalars['uuid']['output']>;
  lower_pumps_order?: Maybe<Array<Scalars['uuid']['output']>>;
  /** An object relationship */
  lower_seal_motor_oil?: Maybe<Seal_Motor_Oil>;
  lower_seal_motor_oil_id?: Maybe<Scalars['uuid']['output']>;
  lower_seals_order?: Maybe<Array<Scalars['uuid']['output']>>;
  /** An object relationship */
  lower_sensor?: Maybe<Sensors>;
  lower_sensor_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  lower_shroud?: Maybe<Casings>;
  lower_shroud_id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  lower_xref_cables: Array<Scenario_Equipment_Xref_Cables>;
  /** An aggregate relationship */
  lower_xref_cables_aggregate: Scenario_Equipment_Xref_Cables_Aggregate;
  /** An array relationship */
  lower_xref_intakes: Array<Scenario_Equipment_Xref_Intakes>;
  /** An aggregate relationship */
  lower_xref_intakes_aggregate: Scenario_Equipment_Xref_Intakes_Aggregate;
  /** An array relationship */
  lower_xref_pumps: Array<Scenario_Equipment_Xref_Pumps>;
  /** An aggregate relationship */
  lower_xref_pumps_aggregate: Scenario_Equipment_Xref_Pumps_Aggregate;
  /** An array relationship */
  lower_xref_seals: Array<Scenario_Equipment_Xref_Seals>;
  /** An aggregate relationship */
  lower_xref_seals_aggregate: Scenario_Equipment_Xref_Seals_Aggregate;
  /** An object relationship */
  mle?: Maybe<Motor_Lead_Extensions>;
  mle_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  motor?: Maybe<Motors>;
  motor_id?: Maybe<Scalars['uuid']['output']>;
  parent_id?: Maybe<Scalars['uuid']['output']>;
  pumps_order?: Maybe<Array<Scalars['uuid']['output']>>;
  /** An object relationship */
  seal_motor_oil?: Maybe<Seal_Motor_Oil>;
  seal_motor_oil_id?: Maybe<Scalars['uuid']['output']>;
  seals_order?: Maybe<Array<Scalars['uuid']['output']>>;
  /** An object relationship */
  sensor?: Maybe<Sensors>;
  sensor_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  shroud?: Maybe<Casings>;
  shroud_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  step_down_transformer?: Maybe<Step_Down_Transformers>;
  /** An object relationship */
  step_up_transformer?: Maybe<Step_Up_Transformers>;
  /** An object relationship */
  switchboard?: Maybe<Switchboards>;
  switchboard_id?: Maybe<Scalars['uuid']['output']>;
  up_trans_id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  uphole_xref_y_tool_bypass_tubings: Array<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings>;
  /** An aggregate relationship */
  uphole_xref_y_tool_bypass_tubings_aggregate: Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Aggregate;
  /** An array relationship */
  uphole_xref_y_tool_equipment_tubings: Array<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings>;
  /** An aggregate relationship */
  uphole_xref_y_tool_equipment_tubings_aggregate: Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Aggregate;
  /** An object relationship */
  uphole_y_tool?: Maybe<Y_Tools>;
  uphole_y_tool_bypass_tubing_order?: Maybe<Array<Scalars['uuid']['output']>>;
  uphole_y_tool_equipment_tubing_order?: Maybe<Array<Scalars['uuid']['output']>>;
  uphole_y_tool_id?: Maybe<Scalars['uuid']['output']>;
  use_downhole_y_tool?: Maybe<Scalars['Boolean']['output']>;
  use_uphole_y_tool?: Maybe<Scalars['Boolean']['output']>;
  use_vsd?: Maybe<Scalars['Boolean']['output']>;
  /** An object relationship */
  vsd?: Maybe<Variable_Speed_Drives>;
  vsd_id?: Maybe<Scalars['uuid']['output']>;
  winning_revision_author_id?: Maybe<Scalars['String']['output']>;
  winning_revision_created_at?: Maybe<Scalars['timestamptz']['output']>;
  winning_revision_deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  winning_revision_id?: Maybe<Scalars['uuid']['output']>;
  winning_revision_parent_id?: Maybe<Scalars['uuid']['output']>;
  winning_revision_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An array relationship */
  xref_cables: Array<Scenario_Equipment_Xref_Cables>;
  /** An aggregate relationship */
  xref_cables_aggregate: Scenario_Equipment_Xref_Cables_Aggregate;
  /** An array relationship */
  xref_intakes: Array<Scenario_Equipment_Xref_Intakes>;
  /** An aggregate relationship */
  xref_intakes_aggregate: Scenario_Equipment_Xref_Intakes_Aggregate;
  /** An array relationship */
  xref_pumps: Array<Scenario_Equipment_Xref_Pumps>;
  /** An aggregate relationship */
  xref_pumps_aggregate: Scenario_Equipment_Xref_Pumps_Aggregate;
  /** An array relationship */
  xref_seals: Array<Scenario_Equipment_Xref_Seals>;
  /** An aggregate relationship */
  xref_seals_aggregate: Scenario_Equipment_Xref_Seals_Aggregate;
};


/** columns and relationships of "scenario_equipment" */
export type Scenario_EquipmentDownhole_Xref_Y_Tool_Bypass_TubingsArgs = {
  distinct_on?: InputMaybe<Array<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Order_By>>;
  where?: InputMaybe<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Bool_Exp>;
};


/** columns and relationships of "scenario_equipment" */
export type Scenario_EquipmentDownhole_Xref_Y_Tool_Bypass_Tubings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Order_By>>;
  where?: InputMaybe<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Bool_Exp>;
};


/** columns and relationships of "scenario_equipment" */
export type Scenario_EquipmentDownhole_Xref_Y_Tool_Equipment_TubingsArgs = {
  distinct_on?: InputMaybe<Array<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Order_By>>;
  where?: InputMaybe<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Bool_Exp>;
};


/** columns and relationships of "scenario_equipment" */
export type Scenario_EquipmentDownhole_Xref_Y_Tool_Equipment_Tubings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Order_By>>;
  where?: InputMaybe<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Bool_Exp>;
};


/** columns and relationships of "scenario_equipment" */
export type Scenario_EquipmentLower_Xref_CablesArgs = {
  distinct_on?: InputMaybe<Array<Scenario_Equipment_Xref_Cables_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Scenario_Equipment_Xref_Cables_Order_By>>;
  where?: InputMaybe<Scenario_Equipment_Xref_Cables_Bool_Exp>;
};


/** columns and relationships of "scenario_equipment" */
export type Scenario_EquipmentLower_Xref_Cables_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Scenario_Equipment_Xref_Cables_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Scenario_Equipment_Xref_Cables_Order_By>>;
  where?: InputMaybe<Scenario_Equipment_Xref_Cables_Bool_Exp>;
};


/** columns and relationships of "scenario_equipment" */
export type Scenario_EquipmentLower_Xref_IntakesArgs = {
  distinct_on?: InputMaybe<Array<Scenario_Equipment_Xref_Intakes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Scenario_Equipment_Xref_Intakes_Order_By>>;
  where?: InputMaybe<Scenario_Equipment_Xref_Intakes_Bool_Exp>;
};


/** columns and relationships of "scenario_equipment" */
export type Scenario_EquipmentLower_Xref_Intakes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Scenario_Equipment_Xref_Intakes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Scenario_Equipment_Xref_Intakes_Order_By>>;
  where?: InputMaybe<Scenario_Equipment_Xref_Intakes_Bool_Exp>;
};


/** columns and relationships of "scenario_equipment" */
export type Scenario_EquipmentLower_Xref_PumpsArgs = {
  distinct_on?: InputMaybe<Array<Scenario_Equipment_Xref_Pumps_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Scenario_Equipment_Xref_Pumps_Order_By>>;
  where?: InputMaybe<Scenario_Equipment_Xref_Pumps_Bool_Exp>;
};


/** columns and relationships of "scenario_equipment" */
export type Scenario_EquipmentLower_Xref_Pumps_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Scenario_Equipment_Xref_Pumps_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Scenario_Equipment_Xref_Pumps_Order_By>>;
  where?: InputMaybe<Scenario_Equipment_Xref_Pumps_Bool_Exp>;
};


/** columns and relationships of "scenario_equipment" */
export type Scenario_EquipmentLower_Xref_SealsArgs = {
  distinct_on?: InputMaybe<Array<Scenario_Equipment_Xref_Seals_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Scenario_Equipment_Xref_Seals_Order_By>>;
  where?: InputMaybe<Scenario_Equipment_Xref_Seals_Bool_Exp>;
};


/** columns and relationships of "scenario_equipment" */
export type Scenario_EquipmentLower_Xref_Seals_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Scenario_Equipment_Xref_Seals_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Scenario_Equipment_Xref_Seals_Order_By>>;
  where?: InputMaybe<Scenario_Equipment_Xref_Seals_Bool_Exp>;
};


/** columns and relationships of "scenario_equipment" */
export type Scenario_EquipmentUphole_Xref_Y_Tool_Bypass_TubingsArgs = {
  distinct_on?: InputMaybe<Array<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Order_By>>;
  where?: InputMaybe<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Bool_Exp>;
};


/** columns and relationships of "scenario_equipment" */
export type Scenario_EquipmentUphole_Xref_Y_Tool_Bypass_Tubings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Order_By>>;
  where?: InputMaybe<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Bool_Exp>;
};


/** columns and relationships of "scenario_equipment" */
export type Scenario_EquipmentUphole_Xref_Y_Tool_Equipment_TubingsArgs = {
  distinct_on?: InputMaybe<Array<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Order_By>>;
  where?: InputMaybe<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Bool_Exp>;
};


/** columns and relationships of "scenario_equipment" */
export type Scenario_EquipmentUphole_Xref_Y_Tool_Equipment_Tubings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Order_By>>;
  where?: InputMaybe<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Bool_Exp>;
};


/** columns and relationships of "scenario_equipment" */
export type Scenario_EquipmentXref_CablesArgs = {
  distinct_on?: InputMaybe<Array<Scenario_Equipment_Xref_Cables_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Scenario_Equipment_Xref_Cables_Order_By>>;
  where?: InputMaybe<Scenario_Equipment_Xref_Cables_Bool_Exp>;
};


/** columns and relationships of "scenario_equipment" */
export type Scenario_EquipmentXref_Cables_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Scenario_Equipment_Xref_Cables_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Scenario_Equipment_Xref_Cables_Order_By>>;
  where?: InputMaybe<Scenario_Equipment_Xref_Cables_Bool_Exp>;
};


/** columns and relationships of "scenario_equipment" */
export type Scenario_EquipmentXref_IntakesArgs = {
  distinct_on?: InputMaybe<Array<Scenario_Equipment_Xref_Intakes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Scenario_Equipment_Xref_Intakes_Order_By>>;
  where?: InputMaybe<Scenario_Equipment_Xref_Intakes_Bool_Exp>;
};


/** columns and relationships of "scenario_equipment" */
export type Scenario_EquipmentXref_Intakes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Scenario_Equipment_Xref_Intakes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Scenario_Equipment_Xref_Intakes_Order_By>>;
  where?: InputMaybe<Scenario_Equipment_Xref_Intakes_Bool_Exp>;
};


/** columns and relationships of "scenario_equipment" */
export type Scenario_EquipmentXref_PumpsArgs = {
  distinct_on?: InputMaybe<Array<Scenario_Equipment_Xref_Pumps_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Scenario_Equipment_Xref_Pumps_Order_By>>;
  where?: InputMaybe<Scenario_Equipment_Xref_Pumps_Bool_Exp>;
};


/** columns and relationships of "scenario_equipment" */
export type Scenario_EquipmentXref_Pumps_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Scenario_Equipment_Xref_Pumps_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Scenario_Equipment_Xref_Pumps_Order_By>>;
  where?: InputMaybe<Scenario_Equipment_Xref_Pumps_Bool_Exp>;
};


/** columns and relationships of "scenario_equipment" */
export type Scenario_EquipmentXref_SealsArgs = {
  distinct_on?: InputMaybe<Array<Scenario_Equipment_Xref_Seals_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Scenario_Equipment_Xref_Seals_Order_By>>;
  where?: InputMaybe<Scenario_Equipment_Xref_Seals_Bool_Exp>;
};


/** columns and relationships of "scenario_equipment" */
export type Scenario_EquipmentXref_Seals_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Scenario_Equipment_Xref_Seals_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Scenario_Equipment_Xref_Seals_Order_By>>;
  where?: InputMaybe<Scenario_Equipment_Xref_Seals_Bool_Exp>;
};

/** aggregated selection of "scenario_equipment" */
export type Scenario_Equipment_Aggregate = {
  __typename: 'scenario_equipment_aggregate';
  aggregate?: Maybe<Scenario_Equipment_Aggregate_Fields>;
  nodes: Array<Scenario_Equipment>;
};

/** aggregate fields of "scenario_equipment" */
export type Scenario_Equipment_Aggregate_Fields = {
  __typename: 'scenario_equipment_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Scenario_Equipment_Max_Fields>;
  min?: Maybe<Scenario_Equipment_Min_Fields>;
};


/** aggregate fields of "scenario_equipment" */
export type Scenario_Equipment_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Scenario_Equipment_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "scenario_equipment". All fields are combined with a logical 'AND'. */
export type Scenario_Equipment_Bool_Exp = {
  _and?: InputMaybe<Array<Scenario_Equipment_Bool_Exp>>;
  _not?: InputMaybe<Scenario_Equipment_Bool_Exp>;
  _or?: InputMaybe<Array<Scenario_Equipment_Bool_Exp>>;
  bolt_on_discharge?: InputMaybe<Bolt_On_Discharges_Bool_Exp>;
  bolt_on_discharge_id?: InputMaybe<Uuid_Comparison_Exp>;
  cables_order?: InputMaybe<Uuid_Array_Comparison_Exp>;
  down_trans_id?: InputMaybe<Uuid_Comparison_Exp>;
  downhole_xref_y_tool_bypass_tubings?: InputMaybe<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Bool_Exp>;
  downhole_xref_y_tool_bypass_tubings_aggregate?: InputMaybe<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Aggregate_Bool_Exp>;
  downhole_xref_y_tool_equipment_tubings?: InputMaybe<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Bool_Exp>;
  downhole_xref_y_tool_equipment_tubings_aggregate?: InputMaybe<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Aggregate_Bool_Exp>;
  downhole_y_tool?: InputMaybe<Y_Tools_Bool_Exp>;
  downhole_y_tool_bypass_tubing_order?: InputMaybe<Uuid_Array_Comparison_Exp>;
  downhole_y_tool_equipment_tubing_order?: InputMaybe<Uuid_Array_Comparison_Exp>;
  downhole_y_tool_id?: InputMaybe<Uuid_Comparison_Exp>;
  has_lower_equip_stack?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  include_y_tool?: InputMaybe<Boolean_Comparison_Exp>;
  intakes_order?: InputMaybe<Uuid_Array_Comparison_Exp>;
  journal_author_id?: InputMaybe<String_Comparison_Exp>;
  journal_created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  journal_deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  journal_updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  lower_bolt_on_discharge?: InputMaybe<Bolt_On_Discharges_Bool_Exp>;
  lower_bolt_on_discharge_id?: InputMaybe<Uuid_Comparison_Exp>;
  lower_cables_order?: InputMaybe<Uuid_Array_Comparison_Exp>;
  lower_intakes_order?: InputMaybe<Uuid_Array_Comparison_Exp>;
  lower_mle?: InputMaybe<Motor_Lead_Extensions_Bool_Exp>;
  lower_mle_id?: InputMaybe<Uuid_Comparison_Exp>;
  lower_motor?: InputMaybe<Motors_Bool_Exp>;
  lower_motor_id?: InputMaybe<Uuid_Comparison_Exp>;
  lower_pumps_order?: InputMaybe<Uuid_Array_Comparison_Exp>;
  lower_seal_motor_oil?: InputMaybe<Seal_Motor_Oil_Bool_Exp>;
  lower_seal_motor_oil_id?: InputMaybe<Uuid_Comparison_Exp>;
  lower_seals_order?: InputMaybe<Uuid_Array_Comparison_Exp>;
  lower_sensor?: InputMaybe<Sensors_Bool_Exp>;
  lower_sensor_id?: InputMaybe<Uuid_Comparison_Exp>;
  lower_shroud?: InputMaybe<Casings_Bool_Exp>;
  lower_shroud_id?: InputMaybe<Uuid_Comparison_Exp>;
  lower_xref_cables?: InputMaybe<Scenario_Equipment_Xref_Cables_Bool_Exp>;
  lower_xref_cables_aggregate?: InputMaybe<Scenario_Equipment_Xref_Cables_Aggregate_Bool_Exp>;
  lower_xref_intakes?: InputMaybe<Scenario_Equipment_Xref_Intakes_Bool_Exp>;
  lower_xref_intakes_aggregate?: InputMaybe<Scenario_Equipment_Xref_Intakes_Aggregate_Bool_Exp>;
  lower_xref_pumps?: InputMaybe<Scenario_Equipment_Xref_Pumps_Bool_Exp>;
  lower_xref_pumps_aggregate?: InputMaybe<Scenario_Equipment_Xref_Pumps_Aggregate_Bool_Exp>;
  lower_xref_seals?: InputMaybe<Scenario_Equipment_Xref_Seals_Bool_Exp>;
  lower_xref_seals_aggregate?: InputMaybe<Scenario_Equipment_Xref_Seals_Aggregate_Bool_Exp>;
  mle?: InputMaybe<Motor_Lead_Extensions_Bool_Exp>;
  mle_id?: InputMaybe<Uuid_Comparison_Exp>;
  motor?: InputMaybe<Motors_Bool_Exp>;
  motor_id?: InputMaybe<Uuid_Comparison_Exp>;
  parent_id?: InputMaybe<Uuid_Comparison_Exp>;
  pumps_order?: InputMaybe<Uuid_Array_Comparison_Exp>;
  seal_motor_oil?: InputMaybe<Seal_Motor_Oil_Bool_Exp>;
  seal_motor_oil_id?: InputMaybe<Uuid_Comparison_Exp>;
  seals_order?: InputMaybe<Uuid_Array_Comparison_Exp>;
  sensor?: InputMaybe<Sensors_Bool_Exp>;
  sensor_id?: InputMaybe<Uuid_Comparison_Exp>;
  shroud?: InputMaybe<Casings_Bool_Exp>;
  shroud_id?: InputMaybe<Uuid_Comparison_Exp>;
  step_down_transformer?: InputMaybe<Step_Down_Transformers_Bool_Exp>;
  step_up_transformer?: InputMaybe<Step_Up_Transformers_Bool_Exp>;
  switchboard?: InputMaybe<Switchboards_Bool_Exp>;
  switchboard_id?: InputMaybe<Uuid_Comparison_Exp>;
  up_trans_id?: InputMaybe<Uuid_Comparison_Exp>;
  uphole_xref_y_tool_bypass_tubings?: InputMaybe<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Bool_Exp>;
  uphole_xref_y_tool_bypass_tubings_aggregate?: InputMaybe<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Aggregate_Bool_Exp>;
  uphole_xref_y_tool_equipment_tubings?: InputMaybe<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Bool_Exp>;
  uphole_xref_y_tool_equipment_tubings_aggregate?: InputMaybe<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Aggregate_Bool_Exp>;
  uphole_y_tool?: InputMaybe<Y_Tools_Bool_Exp>;
  uphole_y_tool_bypass_tubing_order?: InputMaybe<Uuid_Array_Comparison_Exp>;
  uphole_y_tool_equipment_tubing_order?: InputMaybe<Uuid_Array_Comparison_Exp>;
  uphole_y_tool_id?: InputMaybe<Uuid_Comparison_Exp>;
  use_downhole_y_tool?: InputMaybe<Boolean_Comparison_Exp>;
  use_uphole_y_tool?: InputMaybe<Boolean_Comparison_Exp>;
  use_vsd?: InputMaybe<Boolean_Comparison_Exp>;
  vsd?: InputMaybe<Variable_Speed_Drives_Bool_Exp>;
  vsd_id?: InputMaybe<Uuid_Comparison_Exp>;
  winning_revision_author_id?: InputMaybe<String_Comparison_Exp>;
  winning_revision_created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  winning_revision_deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  winning_revision_id?: InputMaybe<Uuid_Comparison_Exp>;
  winning_revision_parent_id?: InputMaybe<Uuid_Comparison_Exp>;
  winning_revision_updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  xref_cables?: InputMaybe<Scenario_Equipment_Xref_Cables_Bool_Exp>;
  xref_cables_aggregate?: InputMaybe<Scenario_Equipment_Xref_Cables_Aggregate_Bool_Exp>;
  xref_intakes?: InputMaybe<Scenario_Equipment_Xref_Intakes_Bool_Exp>;
  xref_intakes_aggregate?: InputMaybe<Scenario_Equipment_Xref_Intakes_Aggregate_Bool_Exp>;
  xref_pumps?: InputMaybe<Scenario_Equipment_Xref_Pumps_Bool_Exp>;
  xref_pumps_aggregate?: InputMaybe<Scenario_Equipment_Xref_Pumps_Aggregate_Bool_Exp>;
  xref_seals?: InputMaybe<Scenario_Equipment_Xref_Seals_Bool_Exp>;
  xref_seals_aggregate?: InputMaybe<Scenario_Equipment_Xref_Seals_Aggregate_Bool_Exp>;
};

/** input type for inserting data into table "scenario_equipment" */
export type Scenario_Equipment_Insert_Input = {
  bolt_on_discharge?: InputMaybe<Bolt_On_Discharges_Obj_Rel_Insert_Input>;
  bolt_on_discharge_id?: InputMaybe<Scalars['uuid']['input']>;
  cables_order?: InputMaybe<Array<Scalars['uuid']['input']>>;
  down_trans_id?: InputMaybe<Scalars['uuid']['input']>;
  downhole_xref_y_tool_bypass_tubings?: InputMaybe<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Arr_Rel_Insert_Input>;
  downhole_xref_y_tool_equipment_tubings?: InputMaybe<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Arr_Rel_Insert_Input>;
  downhole_y_tool?: InputMaybe<Y_Tools_Obj_Rel_Insert_Input>;
  downhole_y_tool_bypass_tubing_order?: InputMaybe<Array<Scalars['uuid']['input']>>;
  downhole_y_tool_equipment_tubing_order?: InputMaybe<Array<Scalars['uuid']['input']>>;
  downhole_y_tool_id?: InputMaybe<Scalars['uuid']['input']>;
  has_lower_equip_stack?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  include_y_tool?: InputMaybe<Scalars['Boolean']['input']>;
  intakes_order?: InputMaybe<Array<Scalars['uuid']['input']>>;
  journal_author_id?: InputMaybe<Scalars['String']['input']>;
  journal_created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  journal_deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  journal_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  lower_bolt_on_discharge?: InputMaybe<Bolt_On_Discharges_Obj_Rel_Insert_Input>;
  lower_bolt_on_discharge_id?: InputMaybe<Scalars['uuid']['input']>;
  lower_cables_order?: InputMaybe<Array<Scalars['uuid']['input']>>;
  lower_intakes_order?: InputMaybe<Array<Scalars['uuid']['input']>>;
  lower_mle?: InputMaybe<Motor_Lead_Extensions_Obj_Rel_Insert_Input>;
  lower_mle_id?: InputMaybe<Scalars['uuid']['input']>;
  lower_motor?: InputMaybe<Motors_Obj_Rel_Insert_Input>;
  lower_motor_id?: InputMaybe<Scalars['uuid']['input']>;
  lower_pumps_order?: InputMaybe<Array<Scalars['uuid']['input']>>;
  lower_seal_motor_oil?: InputMaybe<Seal_Motor_Oil_Obj_Rel_Insert_Input>;
  lower_seal_motor_oil_id?: InputMaybe<Scalars['uuid']['input']>;
  lower_seals_order?: InputMaybe<Array<Scalars['uuid']['input']>>;
  lower_sensor?: InputMaybe<Sensors_Obj_Rel_Insert_Input>;
  lower_sensor_id?: InputMaybe<Scalars['uuid']['input']>;
  lower_shroud?: InputMaybe<Casings_Obj_Rel_Insert_Input>;
  lower_shroud_id?: InputMaybe<Scalars['uuid']['input']>;
  lower_xref_cables?: InputMaybe<Scenario_Equipment_Xref_Cables_Arr_Rel_Insert_Input>;
  lower_xref_intakes?: InputMaybe<Scenario_Equipment_Xref_Intakes_Arr_Rel_Insert_Input>;
  lower_xref_pumps?: InputMaybe<Scenario_Equipment_Xref_Pumps_Arr_Rel_Insert_Input>;
  lower_xref_seals?: InputMaybe<Scenario_Equipment_Xref_Seals_Arr_Rel_Insert_Input>;
  mle?: InputMaybe<Motor_Lead_Extensions_Obj_Rel_Insert_Input>;
  mle_id?: InputMaybe<Scalars['uuid']['input']>;
  motor?: InputMaybe<Motors_Obj_Rel_Insert_Input>;
  motor_id?: InputMaybe<Scalars['uuid']['input']>;
  parent_id?: InputMaybe<Scalars['uuid']['input']>;
  pumps_order?: InputMaybe<Array<Scalars['uuid']['input']>>;
  seal_motor_oil?: InputMaybe<Seal_Motor_Oil_Obj_Rel_Insert_Input>;
  seal_motor_oil_id?: InputMaybe<Scalars['uuid']['input']>;
  seals_order?: InputMaybe<Array<Scalars['uuid']['input']>>;
  sensor?: InputMaybe<Sensors_Obj_Rel_Insert_Input>;
  sensor_id?: InputMaybe<Scalars['uuid']['input']>;
  shroud?: InputMaybe<Casings_Obj_Rel_Insert_Input>;
  shroud_id?: InputMaybe<Scalars['uuid']['input']>;
  step_down_transformer?: InputMaybe<Step_Down_Transformers_Obj_Rel_Insert_Input>;
  step_up_transformer?: InputMaybe<Step_Up_Transformers_Obj_Rel_Insert_Input>;
  switchboard?: InputMaybe<Switchboards_Obj_Rel_Insert_Input>;
  switchboard_id?: InputMaybe<Scalars['uuid']['input']>;
  up_trans_id?: InputMaybe<Scalars['uuid']['input']>;
  uphole_xref_y_tool_bypass_tubings?: InputMaybe<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Arr_Rel_Insert_Input>;
  uphole_xref_y_tool_equipment_tubings?: InputMaybe<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Arr_Rel_Insert_Input>;
  uphole_y_tool?: InputMaybe<Y_Tools_Obj_Rel_Insert_Input>;
  uphole_y_tool_bypass_tubing_order?: InputMaybe<Array<Scalars['uuid']['input']>>;
  uphole_y_tool_equipment_tubing_order?: InputMaybe<Array<Scalars['uuid']['input']>>;
  uphole_y_tool_id?: InputMaybe<Scalars['uuid']['input']>;
  use_downhole_y_tool?: InputMaybe<Scalars['Boolean']['input']>;
  use_uphole_y_tool?: InputMaybe<Scalars['Boolean']['input']>;
  use_vsd?: InputMaybe<Scalars['Boolean']['input']>;
  vsd?: InputMaybe<Variable_Speed_Drives_Obj_Rel_Insert_Input>;
  vsd_id?: InputMaybe<Scalars['uuid']['input']>;
  winning_revision_author_id?: InputMaybe<Scalars['String']['input']>;
  winning_revision_created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  winning_revision_deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  winning_revision_id?: InputMaybe<Scalars['uuid']['input']>;
  winning_revision_parent_id?: InputMaybe<Scalars['uuid']['input']>;
  winning_revision_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  xref_cables?: InputMaybe<Scenario_Equipment_Xref_Cables_Arr_Rel_Insert_Input>;
  xref_intakes?: InputMaybe<Scenario_Equipment_Xref_Intakes_Arr_Rel_Insert_Input>;
  xref_pumps?: InputMaybe<Scenario_Equipment_Xref_Pumps_Arr_Rel_Insert_Input>;
  xref_seals?: InputMaybe<Scenario_Equipment_Xref_Seals_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Scenario_Equipment_Max_Fields = {
  __typename: 'scenario_equipment_max_fields';
  bolt_on_discharge_id?: Maybe<Scalars['uuid']['output']>;
  cables_order?: Maybe<Array<Scalars['uuid']['output']>>;
  down_trans_id?: Maybe<Scalars['uuid']['output']>;
  downhole_y_tool_bypass_tubing_order?: Maybe<Array<Scalars['uuid']['output']>>;
  downhole_y_tool_equipment_tubing_order?: Maybe<Array<Scalars['uuid']['output']>>;
  downhole_y_tool_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  intakes_order?: Maybe<Array<Scalars['uuid']['output']>>;
  journal_author_id?: Maybe<Scalars['String']['output']>;
  journal_created_at?: Maybe<Scalars['timestamptz']['output']>;
  journal_deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  journal_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  lower_bolt_on_discharge_id?: Maybe<Scalars['uuid']['output']>;
  lower_cables_order?: Maybe<Array<Scalars['uuid']['output']>>;
  lower_intakes_order?: Maybe<Array<Scalars['uuid']['output']>>;
  lower_mle_id?: Maybe<Scalars['uuid']['output']>;
  lower_motor_id?: Maybe<Scalars['uuid']['output']>;
  lower_pumps_order?: Maybe<Array<Scalars['uuid']['output']>>;
  lower_seal_motor_oil_id?: Maybe<Scalars['uuid']['output']>;
  lower_seals_order?: Maybe<Array<Scalars['uuid']['output']>>;
  lower_sensor_id?: Maybe<Scalars['uuid']['output']>;
  lower_shroud_id?: Maybe<Scalars['uuid']['output']>;
  mle_id?: Maybe<Scalars['uuid']['output']>;
  motor_id?: Maybe<Scalars['uuid']['output']>;
  parent_id?: Maybe<Scalars['uuid']['output']>;
  pumps_order?: Maybe<Array<Scalars['uuid']['output']>>;
  seal_motor_oil_id?: Maybe<Scalars['uuid']['output']>;
  seals_order?: Maybe<Array<Scalars['uuid']['output']>>;
  sensor_id?: Maybe<Scalars['uuid']['output']>;
  shroud_id?: Maybe<Scalars['uuid']['output']>;
  switchboard_id?: Maybe<Scalars['uuid']['output']>;
  up_trans_id?: Maybe<Scalars['uuid']['output']>;
  uphole_y_tool_bypass_tubing_order?: Maybe<Array<Scalars['uuid']['output']>>;
  uphole_y_tool_equipment_tubing_order?: Maybe<Array<Scalars['uuid']['output']>>;
  uphole_y_tool_id?: Maybe<Scalars['uuid']['output']>;
  vsd_id?: Maybe<Scalars['uuid']['output']>;
  winning_revision_author_id?: Maybe<Scalars['String']['output']>;
  winning_revision_created_at?: Maybe<Scalars['timestamptz']['output']>;
  winning_revision_deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  winning_revision_id?: Maybe<Scalars['uuid']['output']>;
  winning_revision_parent_id?: Maybe<Scalars['uuid']['output']>;
  winning_revision_updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Scenario_Equipment_Min_Fields = {
  __typename: 'scenario_equipment_min_fields';
  bolt_on_discharge_id?: Maybe<Scalars['uuid']['output']>;
  cables_order?: Maybe<Array<Scalars['uuid']['output']>>;
  down_trans_id?: Maybe<Scalars['uuid']['output']>;
  downhole_y_tool_bypass_tubing_order?: Maybe<Array<Scalars['uuid']['output']>>;
  downhole_y_tool_equipment_tubing_order?: Maybe<Array<Scalars['uuid']['output']>>;
  downhole_y_tool_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  intakes_order?: Maybe<Array<Scalars['uuid']['output']>>;
  journal_author_id?: Maybe<Scalars['String']['output']>;
  journal_created_at?: Maybe<Scalars['timestamptz']['output']>;
  journal_deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  journal_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  lower_bolt_on_discharge_id?: Maybe<Scalars['uuid']['output']>;
  lower_cables_order?: Maybe<Array<Scalars['uuid']['output']>>;
  lower_intakes_order?: Maybe<Array<Scalars['uuid']['output']>>;
  lower_mle_id?: Maybe<Scalars['uuid']['output']>;
  lower_motor_id?: Maybe<Scalars['uuid']['output']>;
  lower_pumps_order?: Maybe<Array<Scalars['uuid']['output']>>;
  lower_seal_motor_oil_id?: Maybe<Scalars['uuid']['output']>;
  lower_seals_order?: Maybe<Array<Scalars['uuid']['output']>>;
  lower_sensor_id?: Maybe<Scalars['uuid']['output']>;
  lower_shroud_id?: Maybe<Scalars['uuid']['output']>;
  mle_id?: Maybe<Scalars['uuid']['output']>;
  motor_id?: Maybe<Scalars['uuid']['output']>;
  parent_id?: Maybe<Scalars['uuid']['output']>;
  pumps_order?: Maybe<Array<Scalars['uuid']['output']>>;
  seal_motor_oil_id?: Maybe<Scalars['uuid']['output']>;
  seals_order?: Maybe<Array<Scalars['uuid']['output']>>;
  sensor_id?: Maybe<Scalars['uuid']['output']>;
  shroud_id?: Maybe<Scalars['uuid']['output']>;
  switchboard_id?: Maybe<Scalars['uuid']['output']>;
  up_trans_id?: Maybe<Scalars['uuid']['output']>;
  uphole_y_tool_bypass_tubing_order?: Maybe<Array<Scalars['uuid']['output']>>;
  uphole_y_tool_equipment_tubing_order?: Maybe<Array<Scalars['uuid']['output']>>;
  uphole_y_tool_id?: Maybe<Scalars['uuid']['output']>;
  vsd_id?: Maybe<Scalars['uuid']['output']>;
  winning_revision_author_id?: Maybe<Scalars['String']['output']>;
  winning_revision_created_at?: Maybe<Scalars['timestamptz']['output']>;
  winning_revision_deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  winning_revision_id?: Maybe<Scalars['uuid']['output']>;
  winning_revision_parent_id?: Maybe<Scalars['uuid']['output']>;
  winning_revision_updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** input type for inserting object relation for remote table "scenario_equipment" */
export type Scenario_Equipment_Obj_Rel_Insert_Input = {
  data: Scenario_Equipment_Insert_Input;
};

/** Ordering options when selecting data from "scenario_equipment". */
export type Scenario_Equipment_Order_By = {
  bolt_on_discharge?: InputMaybe<Bolt_On_Discharges_Order_By>;
  bolt_on_discharge_id?: InputMaybe<Order_By>;
  cables_order?: InputMaybe<Order_By>;
  down_trans_id?: InputMaybe<Order_By>;
  downhole_xref_y_tool_bypass_tubings_aggregate?: InputMaybe<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Aggregate_Order_By>;
  downhole_xref_y_tool_equipment_tubings_aggregate?: InputMaybe<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Aggregate_Order_By>;
  downhole_y_tool?: InputMaybe<Y_Tools_Order_By>;
  downhole_y_tool_bypass_tubing_order?: InputMaybe<Order_By>;
  downhole_y_tool_equipment_tubing_order?: InputMaybe<Order_By>;
  downhole_y_tool_id?: InputMaybe<Order_By>;
  has_lower_equip_stack?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  include_y_tool?: InputMaybe<Order_By>;
  intakes_order?: InputMaybe<Order_By>;
  journal_author_id?: InputMaybe<Order_By>;
  journal_created_at?: InputMaybe<Order_By>;
  journal_deleted_at?: InputMaybe<Order_By>;
  journal_updated_at?: InputMaybe<Order_By>;
  lower_bolt_on_discharge?: InputMaybe<Bolt_On_Discharges_Order_By>;
  lower_bolt_on_discharge_id?: InputMaybe<Order_By>;
  lower_cables_order?: InputMaybe<Order_By>;
  lower_intakes_order?: InputMaybe<Order_By>;
  lower_mle?: InputMaybe<Motor_Lead_Extensions_Order_By>;
  lower_mle_id?: InputMaybe<Order_By>;
  lower_motor?: InputMaybe<Motors_Order_By>;
  lower_motor_id?: InputMaybe<Order_By>;
  lower_pumps_order?: InputMaybe<Order_By>;
  lower_seal_motor_oil?: InputMaybe<Seal_Motor_Oil_Order_By>;
  lower_seal_motor_oil_id?: InputMaybe<Order_By>;
  lower_seals_order?: InputMaybe<Order_By>;
  lower_sensor?: InputMaybe<Sensors_Order_By>;
  lower_sensor_id?: InputMaybe<Order_By>;
  lower_shroud?: InputMaybe<Casings_Order_By>;
  lower_shroud_id?: InputMaybe<Order_By>;
  lower_xref_cables_aggregate?: InputMaybe<Scenario_Equipment_Xref_Cables_Aggregate_Order_By>;
  lower_xref_intakes_aggregate?: InputMaybe<Scenario_Equipment_Xref_Intakes_Aggregate_Order_By>;
  lower_xref_pumps_aggregate?: InputMaybe<Scenario_Equipment_Xref_Pumps_Aggregate_Order_By>;
  lower_xref_seals_aggregate?: InputMaybe<Scenario_Equipment_Xref_Seals_Aggregate_Order_By>;
  mle?: InputMaybe<Motor_Lead_Extensions_Order_By>;
  mle_id?: InputMaybe<Order_By>;
  motor?: InputMaybe<Motors_Order_By>;
  motor_id?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  pumps_order?: InputMaybe<Order_By>;
  seal_motor_oil?: InputMaybe<Seal_Motor_Oil_Order_By>;
  seal_motor_oil_id?: InputMaybe<Order_By>;
  seals_order?: InputMaybe<Order_By>;
  sensor?: InputMaybe<Sensors_Order_By>;
  sensor_id?: InputMaybe<Order_By>;
  shroud?: InputMaybe<Casings_Order_By>;
  shroud_id?: InputMaybe<Order_By>;
  step_down_transformer?: InputMaybe<Step_Down_Transformers_Order_By>;
  step_up_transformer?: InputMaybe<Step_Up_Transformers_Order_By>;
  switchboard?: InputMaybe<Switchboards_Order_By>;
  switchboard_id?: InputMaybe<Order_By>;
  up_trans_id?: InputMaybe<Order_By>;
  uphole_xref_y_tool_bypass_tubings_aggregate?: InputMaybe<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Aggregate_Order_By>;
  uphole_xref_y_tool_equipment_tubings_aggregate?: InputMaybe<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Aggregate_Order_By>;
  uphole_y_tool?: InputMaybe<Y_Tools_Order_By>;
  uphole_y_tool_bypass_tubing_order?: InputMaybe<Order_By>;
  uphole_y_tool_equipment_tubing_order?: InputMaybe<Order_By>;
  uphole_y_tool_id?: InputMaybe<Order_By>;
  use_downhole_y_tool?: InputMaybe<Order_By>;
  use_uphole_y_tool?: InputMaybe<Order_By>;
  use_vsd?: InputMaybe<Order_By>;
  vsd?: InputMaybe<Variable_Speed_Drives_Order_By>;
  vsd_id?: InputMaybe<Order_By>;
  winning_revision_author_id?: InputMaybe<Order_By>;
  winning_revision_created_at?: InputMaybe<Order_By>;
  winning_revision_deleted_at?: InputMaybe<Order_By>;
  winning_revision_id?: InputMaybe<Order_By>;
  winning_revision_parent_id?: InputMaybe<Order_By>;
  winning_revision_updated_at?: InputMaybe<Order_By>;
  xref_cables_aggregate?: InputMaybe<Scenario_Equipment_Xref_Cables_Aggregate_Order_By>;
  xref_intakes_aggregate?: InputMaybe<Scenario_Equipment_Xref_Intakes_Aggregate_Order_By>;
  xref_pumps_aggregate?: InputMaybe<Scenario_Equipment_Xref_Pumps_Aggregate_Order_By>;
  xref_seals_aggregate?: InputMaybe<Scenario_Equipment_Xref_Seals_Aggregate_Order_By>;
};

/** select columns of table "scenario_equipment" */
export enum Scenario_Equipment_Select_Column {
  /** column name */
  BoltOnDischargeId = 'bolt_on_discharge_id',
  /** column name */
  CablesOrder = 'cables_order',
  /** column name */
  DownTransId = 'down_trans_id',
  /** column name */
  DownholeYToolBypassTubingOrder = 'downhole_y_tool_bypass_tubing_order',
  /** column name */
  DownholeYToolEquipmentTubingOrder = 'downhole_y_tool_equipment_tubing_order',
  /** column name */
  DownholeYToolId = 'downhole_y_tool_id',
  /** column name */
  HasLowerEquipStack = 'has_lower_equip_stack',
  /** column name */
  Id = 'id',
  /** column name */
  IncludeYTool = 'include_y_tool',
  /** column name */
  IntakesOrder = 'intakes_order',
  /** column name */
  JournalAuthorId = 'journal_author_id',
  /** column name */
  JournalCreatedAt = 'journal_created_at',
  /** column name */
  JournalDeletedAt = 'journal_deleted_at',
  /** column name */
  JournalUpdatedAt = 'journal_updated_at',
  /** column name */
  LowerBoltOnDischargeId = 'lower_bolt_on_discharge_id',
  /** column name */
  LowerCablesOrder = 'lower_cables_order',
  /** column name */
  LowerIntakesOrder = 'lower_intakes_order',
  /** column name */
  LowerMleId = 'lower_mle_id',
  /** column name */
  LowerMotorId = 'lower_motor_id',
  /** column name */
  LowerPumpsOrder = 'lower_pumps_order',
  /** column name */
  LowerSealMotorOilId = 'lower_seal_motor_oil_id',
  /** column name */
  LowerSealsOrder = 'lower_seals_order',
  /** column name */
  LowerSensorId = 'lower_sensor_id',
  /** column name */
  LowerShroudId = 'lower_shroud_id',
  /** column name */
  MleId = 'mle_id',
  /** column name */
  MotorId = 'motor_id',
  /** column name */
  ParentId = 'parent_id',
  /** column name */
  PumpsOrder = 'pumps_order',
  /** column name */
  SealMotorOilId = 'seal_motor_oil_id',
  /** column name */
  SealsOrder = 'seals_order',
  /** column name */
  SensorId = 'sensor_id',
  /** column name */
  ShroudId = 'shroud_id',
  /** column name */
  SwitchboardId = 'switchboard_id',
  /** column name */
  UpTransId = 'up_trans_id',
  /** column name */
  UpholeYToolBypassTubingOrder = 'uphole_y_tool_bypass_tubing_order',
  /** column name */
  UpholeYToolEquipmentTubingOrder = 'uphole_y_tool_equipment_tubing_order',
  /** column name */
  UpholeYToolId = 'uphole_y_tool_id',
  /** column name */
  UseDownholeYTool = 'use_downhole_y_tool',
  /** column name */
  UseUpholeYTool = 'use_uphole_y_tool',
  /** column name */
  UseVsd = 'use_vsd',
  /** column name */
  VsdId = 'vsd_id',
  /** column name */
  WinningRevisionAuthorId = 'winning_revision_author_id',
  /** column name */
  WinningRevisionCreatedAt = 'winning_revision_created_at',
  /** column name */
  WinningRevisionDeletedAt = 'winning_revision_deleted_at',
  /** column name */
  WinningRevisionId = 'winning_revision_id',
  /** column name */
  WinningRevisionParentId = 'winning_revision_parent_id',
  /** column name */
  WinningRevisionUpdatedAt = 'winning_revision_updated_at'
}

/** Streaming cursor of the table "scenario_equipment" */
export type Scenario_Equipment_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Scenario_Equipment_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Scenario_Equipment_Stream_Cursor_Value_Input = {
  bolt_on_discharge_id?: InputMaybe<Scalars['uuid']['input']>;
  cables_order?: InputMaybe<Array<Scalars['uuid']['input']>>;
  down_trans_id?: InputMaybe<Scalars['uuid']['input']>;
  downhole_y_tool_bypass_tubing_order?: InputMaybe<Array<Scalars['uuid']['input']>>;
  downhole_y_tool_equipment_tubing_order?: InputMaybe<Array<Scalars['uuid']['input']>>;
  downhole_y_tool_id?: InputMaybe<Scalars['uuid']['input']>;
  has_lower_equip_stack?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  include_y_tool?: InputMaybe<Scalars['Boolean']['input']>;
  intakes_order?: InputMaybe<Array<Scalars['uuid']['input']>>;
  journal_author_id?: InputMaybe<Scalars['String']['input']>;
  journal_created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  journal_deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  journal_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  lower_bolt_on_discharge_id?: InputMaybe<Scalars['uuid']['input']>;
  lower_cables_order?: InputMaybe<Array<Scalars['uuid']['input']>>;
  lower_intakes_order?: InputMaybe<Array<Scalars['uuid']['input']>>;
  lower_mle_id?: InputMaybe<Scalars['uuid']['input']>;
  lower_motor_id?: InputMaybe<Scalars['uuid']['input']>;
  lower_pumps_order?: InputMaybe<Array<Scalars['uuid']['input']>>;
  lower_seal_motor_oil_id?: InputMaybe<Scalars['uuid']['input']>;
  lower_seals_order?: InputMaybe<Array<Scalars['uuid']['input']>>;
  lower_sensor_id?: InputMaybe<Scalars['uuid']['input']>;
  lower_shroud_id?: InputMaybe<Scalars['uuid']['input']>;
  mle_id?: InputMaybe<Scalars['uuid']['input']>;
  motor_id?: InputMaybe<Scalars['uuid']['input']>;
  parent_id?: InputMaybe<Scalars['uuid']['input']>;
  pumps_order?: InputMaybe<Array<Scalars['uuid']['input']>>;
  seal_motor_oil_id?: InputMaybe<Scalars['uuid']['input']>;
  seals_order?: InputMaybe<Array<Scalars['uuid']['input']>>;
  sensor_id?: InputMaybe<Scalars['uuid']['input']>;
  shroud_id?: InputMaybe<Scalars['uuid']['input']>;
  switchboard_id?: InputMaybe<Scalars['uuid']['input']>;
  up_trans_id?: InputMaybe<Scalars['uuid']['input']>;
  uphole_y_tool_bypass_tubing_order?: InputMaybe<Array<Scalars['uuid']['input']>>;
  uphole_y_tool_equipment_tubing_order?: InputMaybe<Array<Scalars['uuid']['input']>>;
  uphole_y_tool_id?: InputMaybe<Scalars['uuid']['input']>;
  use_downhole_y_tool?: InputMaybe<Scalars['Boolean']['input']>;
  use_uphole_y_tool?: InputMaybe<Scalars['Boolean']['input']>;
  use_vsd?: InputMaybe<Scalars['Boolean']['input']>;
  vsd_id?: InputMaybe<Scalars['uuid']['input']>;
  winning_revision_author_id?: InputMaybe<Scalars['String']['input']>;
  winning_revision_created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  winning_revision_deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  winning_revision_id?: InputMaybe<Scalars['uuid']['input']>;
  winning_revision_parent_id?: InputMaybe<Scalars['uuid']['input']>;
  winning_revision_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** columns and relationships of "scenario_equipment_xref_cables" */
export type Scenario_Equipment_Xref_Cables = {
  __typename: 'scenario_equipment_xref_cables';
  /** An object relationship */
  cable?: Maybe<Cables>;
  cable_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  journal_author_id?: Maybe<Scalars['String']['output']>;
  journal_created_at?: Maybe<Scalars['timestamptz']['output']>;
  journal_deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  journal_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  length_feet?: Maybe<Scalars['numeric']['output']>;
  parent_id?: Maybe<Scalars['uuid']['output']>;
  scenario_equipment_id?: Maybe<Scalars['uuid']['output']>;
  winning_revision_author_id?: Maybe<Scalars['String']['output']>;
  winning_revision_created_at?: Maybe<Scalars['timestamptz']['output']>;
  winning_revision_deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  winning_revision_id?: Maybe<Scalars['uuid']['output']>;
  winning_revision_parent_id?: Maybe<Scalars['uuid']['output']>;
  winning_revision_updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregated selection of "scenario_equipment_xref_cables" */
export type Scenario_Equipment_Xref_Cables_Aggregate = {
  __typename: 'scenario_equipment_xref_cables_aggregate';
  aggregate?: Maybe<Scenario_Equipment_Xref_Cables_Aggregate_Fields>;
  nodes: Array<Scenario_Equipment_Xref_Cables>;
};

export type Scenario_Equipment_Xref_Cables_Aggregate_Bool_Exp = {
  count?: InputMaybe<Scenario_Equipment_Xref_Cables_Aggregate_Bool_Exp_Count>;
};

export type Scenario_Equipment_Xref_Cables_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Scenario_Equipment_Xref_Cables_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Scenario_Equipment_Xref_Cables_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "scenario_equipment_xref_cables" */
export type Scenario_Equipment_Xref_Cables_Aggregate_Fields = {
  __typename: 'scenario_equipment_xref_cables_aggregate_fields';
  avg?: Maybe<Scenario_Equipment_Xref_Cables_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Scenario_Equipment_Xref_Cables_Max_Fields>;
  min?: Maybe<Scenario_Equipment_Xref_Cables_Min_Fields>;
  stddev?: Maybe<Scenario_Equipment_Xref_Cables_Stddev_Fields>;
  stddev_pop?: Maybe<Scenario_Equipment_Xref_Cables_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Scenario_Equipment_Xref_Cables_Stddev_Samp_Fields>;
  sum?: Maybe<Scenario_Equipment_Xref_Cables_Sum_Fields>;
  var_pop?: Maybe<Scenario_Equipment_Xref_Cables_Var_Pop_Fields>;
  var_samp?: Maybe<Scenario_Equipment_Xref_Cables_Var_Samp_Fields>;
  variance?: Maybe<Scenario_Equipment_Xref_Cables_Variance_Fields>;
};


/** aggregate fields of "scenario_equipment_xref_cables" */
export type Scenario_Equipment_Xref_Cables_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Scenario_Equipment_Xref_Cables_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "scenario_equipment_xref_cables" */
export type Scenario_Equipment_Xref_Cables_Aggregate_Order_By = {
  avg?: InputMaybe<Scenario_Equipment_Xref_Cables_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Scenario_Equipment_Xref_Cables_Max_Order_By>;
  min?: InputMaybe<Scenario_Equipment_Xref_Cables_Min_Order_By>;
  stddev?: InputMaybe<Scenario_Equipment_Xref_Cables_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Scenario_Equipment_Xref_Cables_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Scenario_Equipment_Xref_Cables_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Scenario_Equipment_Xref_Cables_Sum_Order_By>;
  var_pop?: InputMaybe<Scenario_Equipment_Xref_Cables_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Scenario_Equipment_Xref_Cables_Var_Samp_Order_By>;
  variance?: InputMaybe<Scenario_Equipment_Xref_Cables_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "scenario_equipment_xref_cables" */
export type Scenario_Equipment_Xref_Cables_Arr_Rel_Insert_Input = {
  data: Array<Scenario_Equipment_Xref_Cables_Insert_Input>;
};

/** aggregate avg on columns */
export type Scenario_Equipment_Xref_Cables_Avg_Fields = {
  __typename: 'scenario_equipment_xref_cables_avg_fields';
  length_feet?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "scenario_equipment_xref_cables" */
export type Scenario_Equipment_Xref_Cables_Avg_Order_By = {
  length_feet?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "scenario_equipment_xref_cables". All fields are combined with a logical 'AND'. */
export type Scenario_Equipment_Xref_Cables_Bool_Exp = {
  _and?: InputMaybe<Array<Scenario_Equipment_Xref_Cables_Bool_Exp>>;
  _not?: InputMaybe<Scenario_Equipment_Xref_Cables_Bool_Exp>;
  _or?: InputMaybe<Array<Scenario_Equipment_Xref_Cables_Bool_Exp>>;
  cable?: InputMaybe<Cables_Bool_Exp>;
  cable_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  journal_author_id?: InputMaybe<String_Comparison_Exp>;
  journal_created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  journal_deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  journal_updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  length_feet?: InputMaybe<Numeric_Comparison_Exp>;
  parent_id?: InputMaybe<Uuid_Comparison_Exp>;
  scenario_equipment_id?: InputMaybe<Uuid_Comparison_Exp>;
  winning_revision_author_id?: InputMaybe<String_Comparison_Exp>;
  winning_revision_created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  winning_revision_deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  winning_revision_id?: InputMaybe<Uuid_Comparison_Exp>;
  winning_revision_parent_id?: InputMaybe<Uuid_Comparison_Exp>;
  winning_revision_updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** input type for inserting data into table "scenario_equipment_xref_cables" */
export type Scenario_Equipment_Xref_Cables_Insert_Input = {
  cable?: InputMaybe<Cables_Obj_Rel_Insert_Input>;
  cable_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  journal_author_id?: InputMaybe<Scalars['String']['input']>;
  journal_created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  journal_deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  journal_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  length_feet?: InputMaybe<Scalars['numeric']['input']>;
  parent_id?: InputMaybe<Scalars['uuid']['input']>;
  scenario_equipment_id?: InputMaybe<Scalars['uuid']['input']>;
  winning_revision_author_id?: InputMaybe<Scalars['String']['input']>;
  winning_revision_created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  winning_revision_deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  winning_revision_id?: InputMaybe<Scalars['uuid']['input']>;
  winning_revision_parent_id?: InputMaybe<Scalars['uuid']['input']>;
  winning_revision_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Scenario_Equipment_Xref_Cables_Max_Fields = {
  __typename: 'scenario_equipment_xref_cables_max_fields';
  cable_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  journal_author_id?: Maybe<Scalars['String']['output']>;
  journal_created_at?: Maybe<Scalars['timestamptz']['output']>;
  journal_deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  journal_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  length_feet?: Maybe<Scalars['numeric']['output']>;
  parent_id?: Maybe<Scalars['uuid']['output']>;
  scenario_equipment_id?: Maybe<Scalars['uuid']['output']>;
  winning_revision_author_id?: Maybe<Scalars['String']['output']>;
  winning_revision_created_at?: Maybe<Scalars['timestamptz']['output']>;
  winning_revision_deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  winning_revision_id?: Maybe<Scalars['uuid']['output']>;
  winning_revision_parent_id?: Maybe<Scalars['uuid']['output']>;
  winning_revision_updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "scenario_equipment_xref_cables" */
export type Scenario_Equipment_Xref_Cables_Max_Order_By = {
  cable_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  journal_author_id?: InputMaybe<Order_By>;
  journal_created_at?: InputMaybe<Order_By>;
  journal_deleted_at?: InputMaybe<Order_By>;
  journal_updated_at?: InputMaybe<Order_By>;
  length_feet?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  scenario_equipment_id?: InputMaybe<Order_By>;
  winning_revision_author_id?: InputMaybe<Order_By>;
  winning_revision_created_at?: InputMaybe<Order_By>;
  winning_revision_deleted_at?: InputMaybe<Order_By>;
  winning_revision_id?: InputMaybe<Order_By>;
  winning_revision_parent_id?: InputMaybe<Order_By>;
  winning_revision_updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Scenario_Equipment_Xref_Cables_Min_Fields = {
  __typename: 'scenario_equipment_xref_cables_min_fields';
  cable_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  journal_author_id?: Maybe<Scalars['String']['output']>;
  journal_created_at?: Maybe<Scalars['timestamptz']['output']>;
  journal_deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  journal_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  length_feet?: Maybe<Scalars['numeric']['output']>;
  parent_id?: Maybe<Scalars['uuid']['output']>;
  scenario_equipment_id?: Maybe<Scalars['uuid']['output']>;
  winning_revision_author_id?: Maybe<Scalars['String']['output']>;
  winning_revision_created_at?: Maybe<Scalars['timestamptz']['output']>;
  winning_revision_deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  winning_revision_id?: Maybe<Scalars['uuid']['output']>;
  winning_revision_parent_id?: Maybe<Scalars['uuid']['output']>;
  winning_revision_updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "scenario_equipment_xref_cables" */
export type Scenario_Equipment_Xref_Cables_Min_Order_By = {
  cable_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  journal_author_id?: InputMaybe<Order_By>;
  journal_created_at?: InputMaybe<Order_By>;
  journal_deleted_at?: InputMaybe<Order_By>;
  journal_updated_at?: InputMaybe<Order_By>;
  length_feet?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  scenario_equipment_id?: InputMaybe<Order_By>;
  winning_revision_author_id?: InputMaybe<Order_By>;
  winning_revision_created_at?: InputMaybe<Order_By>;
  winning_revision_deleted_at?: InputMaybe<Order_By>;
  winning_revision_id?: InputMaybe<Order_By>;
  winning_revision_parent_id?: InputMaybe<Order_By>;
  winning_revision_updated_at?: InputMaybe<Order_By>;
};

/** input type for inserting object relation for remote table "scenario_equipment_xref_cables" */
export type Scenario_Equipment_Xref_Cables_Obj_Rel_Insert_Input = {
  data: Scenario_Equipment_Xref_Cables_Insert_Input;
};

/** Ordering options when selecting data from "scenario_equipment_xref_cables". */
export type Scenario_Equipment_Xref_Cables_Order_By = {
  cable?: InputMaybe<Cables_Order_By>;
  cable_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  journal_author_id?: InputMaybe<Order_By>;
  journal_created_at?: InputMaybe<Order_By>;
  journal_deleted_at?: InputMaybe<Order_By>;
  journal_updated_at?: InputMaybe<Order_By>;
  length_feet?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  scenario_equipment_id?: InputMaybe<Order_By>;
  winning_revision_author_id?: InputMaybe<Order_By>;
  winning_revision_created_at?: InputMaybe<Order_By>;
  winning_revision_deleted_at?: InputMaybe<Order_By>;
  winning_revision_id?: InputMaybe<Order_By>;
  winning_revision_parent_id?: InputMaybe<Order_By>;
  winning_revision_updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "scenario_equipment_xref_cables" */
export enum Scenario_Equipment_Xref_Cables_Select_Column {
  /** column name */
  CableId = 'cable_id',
  /** column name */
  Id = 'id',
  /** column name */
  JournalAuthorId = 'journal_author_id',
  /** column name */
  JournalCreatedAt = 'journal_created_at',
  /** column name */
  JournalDeletedAt = 'journal_deleted_at',
  /** column name */
  JournalUpdatedAt = 'journal_updated_at',
  /** column name */
  LengthFeet = 'length_feet',
  /** column name */
  ParentId = 'parent_id',
  /** column name */
  ScenarioEquipmentId = 'scenario_equipment_id',
  /** column name */
  WinningRevisionAuthorId = 'winning_revision_author_id',
  /** column name */
  WinningRevisionCreatedAt = 'winning_revision_created_at',
  /** column name */
  WinningRevisionDeletedAt = 'winning_revision_deleted_at',
  /** column name */
  WinningRevisionId = 'winning_revision_id',
  /** column name */
  WinningRevisionParentId = 'winning_revision_parent_id',
  /** column name */
  WinningRevisionUpdatedAt = 'winning_revision_updated_at'
}

/** aggregate stddev on columns */
export type Scenario_Equipment_Xref_Cables_Stddev_Fields = {
  __typename: 'scenario_equipment_xref_cables_stddev_fields';
  length_feet?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "scenario_equipment_xref_cables" */
export type Scenario_Equipment_Xref_Cables_Stddev_Order_By = {
  length_feet?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Scenario_Equipment_Xref_Cables_Stddev_Pop_Fields = {
  __typename: 'scenario_equipment_xref_cables_stddev_pop_fields';
  length_feet?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "scenario_equipment_xref_cables" */
export type Scenario_Equipment_Xref_Cables_Stddev_Pop_Order_By = {
  length_feet?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Scenario_Equipment_Xref_Cables_Stddev_Samp_Fields = {
  __typename: 'scenario_equipment_xref_cables_stddev_samp_fields';
  length_feet?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "scenario_equipment_xref_cables" */
export type Scenario_Equipment_Xref_Cables_Stddev_Samp_Order_By = {
  length_feet?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "scenario_equipment_xref_cables" */
export type Scenario_Equipment_Xref_Cables_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Scenario_Equipment_Xref_Cables_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Scenario_Equipment_Xref_Cables_Stream_Cursor_Value_Input = {
  cable_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  journal_author_id?: InputMaybe<Scalars['String']['input']>;
  journal_created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  journal_deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  journal_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  length_feet?: InputMaybe<Scalars['numeric']['input']>;
  parent_id?: InputMaybe<Scalars['uuid']['input']>;
  scenario_equipment_id?: InputMaybe<Scalars['uuid']['input']>;
  winning_revision_author_id?: InputMaybe<Scalars['String']['input']>;
  winning_revision_created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  winning_revision_deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  winning_revision_id?: InputMaybe<Scalars['uuid']['input']>;
  winning_revision_parent_id?: InputMaybe<Scalars['uuid']['input']>;
  winning_revision_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Scenario_Equipment_Xref_Cables_Sum_Fields = {
  __typename: 'scenario_equipment_xref_cables_sum_fields';
  length_feet?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "scenario_equipment_xref_cables" */
export type Scenario_Equipment_Xref_Cables_Sum_Order_By = {
  length_feet?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Scenario_Equipment_Xref_Cables_Var_Pop_Fields = {
  __typename: 'scenario_equipment_xref_cables_var_pop_fields';
  length_feet?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "scenario_equipment_xref_cables" */
export type Scenario_Equipment_Xref_Cables_Var_Pop_Order_By = {
  length_feet?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Scenario_Equipment_Xref_Cables_Var_Samp_Fields = {
  __typename: 'scenario_equipment_xref_cables_var_samp_fields';
  length_feet?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "scenario_equipment_xref_cables" */
export type Scenario_Equipment_Xref_Cables_Var_Samp_Order_By = {
  length_feet?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Scenario_Equipment_Xref_Cables_Variance_Fields = {
  __typename: 'scenario_equipment_xref_cables_variance_fields';
  length_feet?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "scenario_equipment_xref_cables" */
export type Scenario_Equipment_Xref_Cables_Variance_Order_By = {
  length_feet?: InputMaybe<Order_By>;
};

/** columns and relationships of "scenario_equipment_xref_housings" */
export type Scenario_Equipment_Xref_Housings = {
  __typename: 'scenario_equipment_xref_housings';
  /** An object relationship */
  housing?: Maybe<Housings>;
  housing_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  journal_author_id?: Maybe<Scalars['String']['output']>;
  journal_created_at?: Maybe<Scalars['timestamptz']['output']>;
  journal_deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  journal_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  length_inches?: Maybe<Scalars['numeric']['output']>;
  parent_id?: Maybe<Scalars['uuid']['output']>;
  scenario_equipment_xref_pump_id?: Maybe<Scalars['uuid']['output']>;
  stage_count?: Maybe<Scalars['Int']['output']>;
  winning_revision_author_id?: Maybe<Scalars['String']['output']>;
  winning_revision_created_at?: Maybe<Scalars['timestamptz']['output']>;
  winning_revision_deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  winning_revision_id?: Maybe<Scalars['uuid']['output']>;
  winning_revision_parent_id?: Maybe<Scalars['uuid']['output']>;
  winning_revision_updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregated selection of "scenario_equipment_xref_housings" */
export type Scenario_Equipment_Xref_Housings_Aggregate = {
  __typename: 'scenario_equipment_xref_housings_aggregate';
  aggregate?: Maybe<Scenario_Equipment_Xref_Housings_Aggregate_Fields>;
  nodes: Array<Scenario_Equipment_Xref_Housings>;
};

export type Scenario_Equipment_Xref_Housings_Aggregate_Bool_Exp = {
  count?: InputMaybe<Scenario_Equipment_Xref_Housings_Aggregate_Bool_Exp_Count>;
};

export type Scenario_Equipment_Xref_Housings_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Scenario_Equipment_Xref_Housings_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Scenario_Equipment_Xref_Housings_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "scenario_equipment_xref_housings" */
export type Scenario_Equipment_Xref_Housings_Aggregate_Fields = {
  __typename: 'scenario_equipment_xref_housings_aggregate_fields';
  avg?: Maybe<Scenario_Equipment_Xref_Housings_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Scenario_Equipment_Xref_Housings_Max_Fields>;
  min?: Maybe<Scenario_Equipment_Xref_Housings_Min_Fields>;
  stddev?: Maybe<Scenario_Equipment_Xref_Housings_Stddev_Fields>;
  stddev_pop?: Maybe<Scenario_Equipment_Xref_Housings_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Scenario_Equipment_Xref_Housings_Stddev_Samp_Fields>;
  sum?: Maybe<Scenario_Equipment_Xref_Housings_Sum_Fields>;
  var_pop?: Maybe<Scenario_Equipment_Xref_Housings_Var_Pop_Fields>;
  var_samp?: Maybe<Scenario_Equipment_Xref_Housings_Var_Samp_Fields>;
  variance?: Maybe<Scenario_Equipment_Xref_Housings_Variance_Fields>;
};


/** aggregate fields of "scenario_equipment_xref_housings" */
export type Scenario_Equipment_Xref_Housings_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Scenario_Equipment_Xref_Housings_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "scenario_equipment_xref_housings" */
export type Scenario_Equipment_Xref_Housings_Aggregate_Order_By = {
  avg?: InputMaybe<Scenario_Equipment_Xref_Housings_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Scenario_Equipment_Xref_Housings_Max_Order_By>;
  min?: InputMaybe<Scenario_Equipment_Xref_Housings_Min_Order_By>;
  stddev?: InputMaybe<Scenario_Equipment_Xref_Housings_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Scenario_Equipment_Xref_Housings_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Scenario_Equipment_Xref_Housings_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Scenario_Equipment_Xref_Housings_Sum_Order_By>;
  var_pop?: InputMaybe<Scenario_Equipment_Xref_Housings_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Scenario_Equipment_Xref_Housings_Var_Samp_Order_By>;
  variance?: InputMaybe<Scenario_Equipment_Xref_Housings_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "scenario_equipment_xref_housings" */
export type Scenario_Equipment_Xref_Housings_Arr_Rel_Insert_Input = {
  data: Array<Scenario_Equipment_Xref_Housings_Insert_Input>;
};

/** aggregate avg on columns */
export type Scenario_Equipment_Xref_Housings_Avg_Fields = {
  __typename: 'scenario_equipment_xref_housings_avg_fields';
  length_inches?: Maybe<Scalars['Float']['output']>;
  stage_count?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "scenario_equipment_xref_housings" */
export type Scenario_Equipment_Xref_Housings_Avg_Order_By = {
  length_inches?: InputMaybe<Order_By>;
  stage_count?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "scenario_equipment_xref_housings". All fields are combined with a logical 'AND'. */
export type Scenario_Equipment_Xref_Housings_Bool_Exp = {
  _and?: InputMaybe<Array<Scenario_Equipment_Xref_Housings_Bool_Exp>>;
  _not?: InputMaybe<Scenario_Equipment_Xref_Housings_Bool_Exp>;
  _or?: InputMaybe<Array<Scenario_Equipment_Xref_Housings_Bool_Exp>>;
  housing?: InputMaybe<Housings_Bool_Exp>;
  housing_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  journal_author_id?: InputMaybe<String_Comparison_Exp>;
  journal_created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  journal_deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  journal_updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  length_inches?: InputMaybe<Numeric_Comparison_Exp>;
  parent_id?: InputMaybe<Uuid_Comparison_Exp>;
  scenario_equipment_xref_pump_id?: InputMaybe<Uuid_Comparison_Exp>;
  stage_count?: InputMaybe<Int_Comparison_Exp>;
  winning_revision_author_id?: InputMaybe<String_Comparison_Exp>;
  winning_revision_created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  winning_revision_deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  winning_revision_id?: InputMaybe<Uuid_Comparison_Exp>;
  winning_revision_parent_id?: InputMaybe<Uuid_Comparison_Exp>;
  winning_revision_updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** input type for inserting data into table "scenario_equipment_xref_housings" */
export type Scenario_Equipment_Xref_Housings_Insert_Input = {
  housing?: InputMaybe<Housings_Obj_Rel_Insert_Input>;
  housing_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  journal_author_id?: InputMaybe<Scalars['String']['input']>;
  journal_created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  journal_deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  journal_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  length_inches?: InputMaybe<Scalars['numeric']['input']>;
  parent_id?: InputMaybe<Scalars['uuid']['input']>;
  scenario_equipment_xref_pump_id?: InputMaybe<Scalars['uuid']['input']>;
  stage_count?: InputMaybe<Scalars['Int']['input']>;
  winning_revision_author_id?: InputMaybe<Scalars['String']['input']>;
  winning_revision_created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  winning_revision_deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  winning_revision_id?: InputMaybe<Scalars['uuid']['input']>;
  winning_revision_parent_id?: InputMaybe<Scalars['uuid']['input']>;
  winning_revision_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Scenario_Equipment_Xref_Housings_Max_Fields = {
  __typename: 'scenario_equipment_xref_housings_max_fields';
  housing_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  journal_author_id?: Maybe<Scalars['String']['output']>;
  journal_created_at?: Maybe<Scalars['timestamptz']['output']>;
  journal_deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  journal_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  length_inches?: Maybe<Scalars['numeric']['output']>;
  parent_id?: Maybe<Scalars['uuid']['output']>;
  scenario_equipment_xref_pump_id?: Maybe<Scalars['uuid']['output']>;
  stage_count?: Maybe<Scalars['Int']['output']>;
  winning_revision_author_id?: Maybe<Scalars['String']['output']>;
  winning_revision_created_at?: Maybe<Scalars['timestamptz']['output']>;
  winning_revision_deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  winning_revision_id?: Maybe<Scalars['uuid']['output']>;
  winning_revision_parent_id?: Maybe<Scalars['uuid']['output']>;
  winning_revision_updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "scenario_equipment_xref_housings" */
export type Scenario_Equipment_Xref_Housings_Max_Order_By = {
  housing_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  journal_author_id?: InputMaybe<Order_By>;
  journal_created_at?: InputMaybe<Order_By>;
  journal_deleted_at?: InputMaybe<Order_By>;
  journal_updated_at?: InputMaybe<Order_By>;
  length_inches?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  scenario_equipment_xref_pump_id?: InputMaybe<Order_By>;
  stage_count?: InputMaybe<Order_By>;
  winning_revision_author_id?: InputMaybe<Order_By>;
  winning_revision_created_at?: InputMaybe<Order_By>;
  winning_revision_deleted_at?: InputMaybe<Order_By>;
  winning_revision_id?: InputMaybe<Order_By>;
  winning_revision_parent_id?: InputMaybe<Order_By>;
  winning_revision_updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Scenario_Equipment_Xref_Housings_Min_Fields = {
  __typename: 'scenario_equipment_xref_housings_min_fields';
  housing_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  journal_author_id?: Maybe<Scalars['String']['output']>;
  journal_created_at?: Maybe<Scalars['timestamptz']['output']>;
  journal_deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  journal_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  length_inches?: Maybe<Scalars['numeric']['output']>;
  parent_id?: Maybe<Scalars['uuid']['output']>;
  scenario_equipment_xref_pump_id?: Maybe<Scalars['uuid']['output']>;
  stage_count?: Maybe<Scalars['Int']['output']>;
  winning_revision_author_id?: Maybe<Scalars['String']['output']>;
  winning_revision_created_at?: Maybe<Scalars['timestamptz']['output']>;
  winning_revision_deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  winning_revision_id?: Maybe<Scalars['uuid']['output']>;
  winning_revision_parent_id?: Maybe<Scalars['uuid']['output']>;
  winning_revision_updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "scenario_equipment_xref_housings" */
export type Scenario_Equipment_Xref_Housings_Min_Order_By = {
  housing_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  journal_author_id?: InputMaybe<Order_By>;
  journal_created_at?: InputMaybe<Order_By>;
  journal_deleted_at?: InputMaybe<Order_By>;
  journal_updated_at?: InputMaybe<Order_By>;
  length_inches?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  scenario_equipment_xref_pump_id?: InputMaybe<Order_By>;
  stage_count?: InputMaybe<Order_By>;
  winning_revision_author_id?: InputMaybe<Order_By>;
  winning_revision_created_at?: InputMaybe<Order_By>;
  winning_revision_deleted_at?: InputMaybe<Order_By>;
  winning_revision_id?: InputMaybe<Order_By>;
  winning_revision_parent_id?: InputMaybe<Order_By>;
  winning_revision_updated_at?: InputMaybe<Order_By>;
};

/** input type for inserting object relation for remote table "scenario_equipment_xref_housings" */
export type Scenario_Equipment_Xref_Housings_Obj_Rel_Insert_Input = {
  data: Scenario_Equipment_Xref_Housings_Insert_Input;
};

/** Ordering options when selecting data from "scenario_equipment_xref_housings". */
export type Scenario_Equipment_Xref_Housings_Order_By = {
  housing?: InputMaybe<Housings_Order_By>;
  housing_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  journal_author_id?: InputMaybe<Order_By>;
  journal_created_at?: InputMaybe<Order_By>;
  journal_deleted_at?: InputMaybe<Order_By>;
  journal_updated_at?: InputMaybe<Order_By>;
  length_inches?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  scenario_equipment_xref_pump_id?: InputMaybe<Order_By>;
  stage_count?: InputMaybe<Order_By>;
  winning_revision_author_id?: InputMaybe<Order_By>;
  winning_revision_created_at?: InputMaybe<Order_By>;
  winning_revision_deleted_at?: InputMaybe<Order_By>;
  winning_revision_id?: InputMaybe<Order_By>;
  winning_revision_parent_id?: InputMaybe<Order_By>;
  winning_revision_updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "scenario_equipment_xref_housings" */
export enum Scenario_Equipment_Xref_Housings_Select_Column {
  /** column name */
  HousingId = 'housing_id',
  /** column name */
  Id = 'id',
  /** column name */
  JournalAuthorId = 'journal_author_id',
  /** column name */
  JournalCreatedAt = 'journal_created_at',
  /** column name */
  JournalDeletedAt = 'journal_deleted_at',
  /** column name */
  JournalUpdatedAt = 'journal_updated_at',
  /** column name */
  LengthInches = 'length_inches',
  /** column name */
  ParentId = 'parent_id',
  /** column name */
  ScenarioEquipmentXrefPumpId = 'scenario_equipment_xref_pump_id',
  /** column name */
  StageCount = 'stage_count',
  /** column name */
  WinningRevisionAuthorId = 'winning_revision_author_id',
  /** column name */
  WinningRevisionCreatedAt = 'winning_revision_created_at',
  /** column name */
  WinningRevisionDeletedAt = 'winning_revision_deleted_at',
  /** column name */
  WinningRevisionId = 'winning_revision_id',
  /** column name */
  WinningRevisionParentId = 'winning_revision_parent_id',
  /** column name */
  WinningRevisionUpdatedAt = 'winning_revision_updated_at'
}

/** aggregate stddev on columns */
export type Scenario_Equipment_Xref_Housings_Stddev_Fields = {
  __typename: 'scenario_equipment_xref_housings_stddev_fields';
  length_inches?: Maybe<Scalars['Float']['output']>;
  stage_count?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "scenario_equipment_xref_housings" */
export type Scenario_Equipment_Xref_Housings_Stddev_Order_By = {
  length_inches?: InputMaybe<Order_By>;
  stage_count?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Scenario_Equipment_Xref_Housings_Stddev_Pop_Fields = {
  __typename: 'scenario_equipment_xref_housings_stddev_pop_fields';
  length_inches?: Maybe<Scalars['Float']['output']>;
  stage_count?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "scenario_equipment_xref_housings" */
export type Scenario_Equipment_Xref_Housings_Stddev_Pop_Order_By = {
  length_inches?: InputMaybe<Order_By>;
  stage_count?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Scenario_Equipment_Xref_Housings_Stddev_Samp_Fields = {
  __typename: 'scenario_equipment_xref_housings_stddev_samp_fields';
  length_inches?: Maybe<Scalars['Float']['output']>;
  stage_count?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "scenario_equipment_xref_housings" */
export type Scenario_Equipment_Xref_Housings_Stddev_Samp_Order_By = {
  length_inches?: InputMaybe<Order_By>;
  stage_count?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "scenario_equipment_xref_housings" */
export type Scenario_Equipment_Xref_Housings_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Scenario_Equipment_Xref_Housings_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Scenario_Equipment_Xref_Housings_Stream_Cursor_Value_Input = {
  housing_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  journal_author_id?: InputMaybe<Scalars['String']['input']>;
  journal_created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  journal_deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  journal_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  length_inches?: InputMaybe<Scalars['numeric']['input']>;
  parent_id?: InputMaybe<Scalars['uuid']['input']>;
  scenario_equipment_xref_pump_id?: InputMaybe<Scalars['uuid']['input']>;
  stage_count?: InputMaybe<Scalars['Int']['input']>;
  winning_revision_author_id?: InputMaybe<Scalars['String']['input']>;
  winning_revision_created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  winning_revision_deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  winning_revision_id?: InputMaybe<Scalars['uuid']['input']>;
  winning_revision_parent_id?: InputMaybe<Scalars['uuid']['input']>;
  winning_revision_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Scenario_Equipment_Xref_Housings_Sum_Fields = {
  __typename: 'scenario_equipment_xref_housings_sum_fields';
  length_inches?: Maybe<Scalars['numeric']['output']>;
  stage_count?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "scenario_equipment_xref_housings" */
export type Scenario_Equipment_Xref_Housings_Sum_Order_By = {
  length_inches?: InputMaybe<Order_By>;
  stage_count?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Scenario_Equipment_Xref_Housings_Var_Pop_Fields = {
  __typename: 'scenario_equipment_xref_housings_var_pop_fields';
  length_inches?: Maybe<Scalars['Float']['output']>;
  stage_count?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "scenario_equipment_xref_housings" */
export type Scenario_Equipment_Xref_Housings_Var_Pop_Order_By = {
  length_inches?: InputMaybe<Order_By>;
  stage_count?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Scenario_Equipment_Xref_Housings_Var_Samp_Fields = {
  __typename: 'scenario_equipment_xref_housings_var_samp_fields';
  length_inches?: Maybe<Scalars['Float']['output']>;
  stage_count?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "scenario_equipment_xref_housings" */
export type Scenario_Equipment_Xref_Housings_Var_Samp_Order_By = {
  length_inches?: InputMaybe<Order_By>;
  stage_count?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Scenario_Equipment_Xref_Housings_Variance_Fields = {
  __typename: 'scenario_equipment_xref_housings_variance_fields';
  length_inches?: Maybe<Scalars['Float']['output']>;
  stage_count?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "scenario_equipment_xref_housings" */
export type Scenario_Equipment_Xref_Housings_Variance_Order_By = {
  length_inches?: InputMaybe<Order_By>;
  stage_count?: InputMaybe<Order_By>;
};

/** columns and relationships of "scenario_equipment_xref_intakes" */
export type Scenario_Equipment_Xref_Intakes = {
  __typename: 'scenario_equipment_xref_intakes';
  id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  intake?: Maybe<Intakes>;
  intake_id?: Maybe<Scalars['uuid']['output']>;
  journal_author_id?: Maybe<Scalars['String']['output']>;
  journal_created_at?: Maybe<Scalars['timestamptz']['output']>;
  journal_deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  journal_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  parent_id?: Maybe<Scalars['uuid']['output']>;
  scenario_equipment_id?: Maybe<Scalars['uuid']['output']>;
  use_high_strength_shaft?: Maybe<Scalars['Boolean']['output']>;
  winning_revision_author_id?: Maybe<Scalars['String']['output']>;
  winning_revision_created_at?: Maybe<Scalars['timestamptz']['output']>;
  winning_revision_deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  winning_revision_id?: Maybe<Scalars['uuid']['output']>;
  winning_revision_parent_id?: Maybe<Scalars['uuid']['output']>;
  winning_revision_updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregated selection of "scenario_equipment_xref_intakes" */
export type Scenario_Equipment_Xref_Intakes_Aggregate = {
  __typename: 'scenario_equipment_xref_intakes_aggregate';
  aggregate?: Maybe<Scenario_Equipment_Xref_Intakes_Aggregate_Fields>;
  nodes: Array<Scenario_Equipment_Xref_Intakes>;
};

export type Scenario_Equipment_Xref_Intakes_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Scenario_Equipment_Xref_Intakes_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Scenario_Equipment_Xref_Intakes_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Scenario_Equipment_Xref_Intakes_Aggregate_Bool_Exp_Count>;
};

export type Scenario_Equipment_Xref_Intakes_Aggregate_Bool_Exp_Bool_And = {
  arguments: Scenario_Equipment_Xref_Intakes_Select_Column_Scenario_Equipment_Xref_Intakes_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Scenario_Equipment_Xref_Intakes_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Scenario_Equipment_Xref_Intakes_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Scenario_Equipment_Xref_Intakes_Select_Column_Scenario_Equipment_Xref_Intakes_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Scenario_Equipment_Xref_Intakes_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Scenario_Equipment_Xref_Intakes_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Scenario_Equipment_Xref_Intakes_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Scenario_Equipment_Xref_Intakes_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "scenario_equipment_xref_intakes" */
export type Scenario_Equipment_Xref_Intakes_Aggregate_Fields = {
  __typename: 'scenario_equipment_xref_intakes_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Scenario_Equipment_Xref_Intakes_Max_Fields>;
  min?: Maybe<Scenario_Equipment_Xref_Intakes_Min_Fields>;
};


/** aggregate fields of "scenario_equipment_xref_intakes" */
export type Scenario_Equipment_Xref_Intakes_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Scenario_Equipment_Xref_Intakes_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "scenario_equipment_xref_intakes" */
export type Scenario_Equipment_Xref_Intakes_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Scenario_Equipment_Xref_Intakes_Max_Order_By>;
  min?: InputMaybe<Scenario_Equipment_Xref_Intakes_Min_Order_By>;
};

/** input type for inserting array relation for remote table "scenario_equipment_xref_intakes" */
export type Scenario_Equipment_Xref_Intakes_Arr_Rel_Insert_Input = {
  data: Array<Scenario_Equipment_Xref_Intakes_Insert_Input>;
};

/** Boolean expression to filter rows from the table "scenario_equipment_xref_intakes". All fields are combined with a logical 'AND'. */
export type Scenario_Equipment_Xref_Intakes_Bool_Exp = {
  _and?: InputMaybe<Array<Scenario_Equipment_Xref_Intakes_Bool_Exp>>;
  _not?: InputMaybe<Scenario_Equipment_Xref_Intakes_Bool_Exp>;
  _or?: InputMaybe<Array<Scenario_Equipment_Xref_Intakes_Bool_Exp>>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  intake?: InputMaybe<Intakes_Bool_Exp>;
  intake_id?: InputMaybe<Uuid_Comparison_Exp>;
  journal_author_id?: InputMaybe<String_Comparison_Exp>;
  journal_created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  journal_deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  journal_updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  parent_id?: InputMaybe<Uuid_Comparison_Exp>;
  scenario_equipment_id?: InputMaybe<Uuid_Comparison_Exp>;
  use_high_strength_shaft?: InputMaybe<Boolean_Comparison_Exp>;
  winning_revision_author_id?: InputMaybe<String_Comparison_Exp>;
  winning_revision_created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  winning_revision_deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  winning_revision_id?: InputMaybe<Uuid_Comparison_Exp>;
  winning_revision_parent_id?: InputMaybe<Uuid_Comparison_Exp>;
  winning_revision_updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** input type for inserting data into table "scenario_equipment_xref_intakes" */
export type Scenario_Equipment_Xref_Intakes_Insert_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  intake?: InputMaybe<Intakes_Obj_Rel_Insert_Input>;
  intake_id?: InputMaybe<Scalars['uuid']['input']>;
  journal_author_id?: InputMaybe<Scalars['String']['input']>;
  journal_created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  journal_deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  journal_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  parent_id?: InputMaybe<Scalars['uuid']['input']>;
  scenario_equipment_id?: InputMaybe<Scalars['uuid']['input']>;
  use_high_strength_shaft?: InputMaybe<Scalars['Boolean']['input']>;
  winning_revision_author_id?: InputMaybe<Scalars['String']['input']>;
  winning_revision_created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  winning_revision_deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  winning_revision_id?: InputMaybe<Scalars['uuid']['input']>;
  winning_revision_parent_id?: InputMaybe<Scalars['uuid']['input']>;
  winning_revision_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Scenario_Equipment_Xref_Intakes_Max_Fields = {
  __typename: 'scenario_equipment_xref_intakes_max_fields';
  id?: Maybe<Scalars['uuid']['output']>;
  intake_id?: Maybe<Scalars['uuid']['output']>;
  journal_author_id?: Maybe<Scalars['String']['output']>;
  journal_created_at?: Maybe<Scalars['timestamptz']['output']>;
  journal_deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  journal_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  parent_id?: Maybe<Scalars['uuid']['output']>;
  scenario_equipment_id?: Maybe<Scalars['uuid']['output']>;
  winning_revision_author_id?: Maybe<Scalars['String']['output']>;
  winning_revision_created_at?: Maybe<Scalars['timestamptz']['output']>;
  winning_revision_deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  winning_revision_id?: Maybe<Scalars['uuid']['output']>;
  winning_revision_parent_id?: Maybe<Scalars['uuid']['output']>;
  winning_revision_updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "scenario_equipment_xref_intakes" */
export type Scenario_Equipment_Xref_Intakes_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  intake_id?: InputMaybe<Order_By>;
  journal_author_id?: InputMaybe<Order_By>;
  journal_created_at?: InputMaybe<Order_By>;
  journal_deleted_at?: InputMaybe<Order_By>;
  journal_updated_at?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  scenario_equipment_id?: InputMaybe<Order_By>;
  winning_revision_author_id?: InputMaybe<Order_By>;
  winning_revision_created_at?: InputMaybe<Order_By>;
  winning_revision_deleted_at?: InputMaybe<Order_By>;
  winning_revision_id?: InputMaybe<Order_By>;
  winning_revision_parent_id?: InputMaybe<Order_By>;
  winning_revision_updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Scenario_Equipment_Xref_Intakes_Min_Fields = {
  __typename: 'scenario_equipment_xref_intakes_min_fields';
  id?: Maybe<Scalars['uuid']['output']>;
  intake_id?: Maybe<Scalars['uuid']['output']>;
  journal_author_id?: Maybe<Scalars['String']['output']>;
  journal_created_at?: Maybe<Scalars['timestamptz']['output']>;
  journal_deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  journal_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  parent_id?: Maybe<Scalars['uuid']['output']>;
  scenario_equipment_id?: Maybe<Scalars['uuid']['output']>;
  winning_revision_author_id?: Maybe<Scalars['String']['output']>;
  winning_revision_created_at?: Maybe<Scalars['timestamptz']['output']>;
  winning_revision_deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  winning_revision_id?: Maybe<Scalars['uuid']['output']>;
  winning_revision_parent_id?: Maybe<Scalars['uuid']['output']>;
  winning_revision_updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "scenario_equipment_xref_intakes" */
export type Scenario_Equipment_Xref_Intakes_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  intake_id?: InputMaybe<Order_By>;
  journal_author_id?: InputMaybe<Order_By>;
  journal_created_at?: InputMaybe<Order_By>;
  journal_deleted_at?: InputMaybe<Order_By>;
  journal_updated_at?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  scenario_equipment_id?: InputMaybe<Order_By>;
  winning_revision_author_id?: InputMaybe<Order_By>;
  winning_revision_created_at?: InputMaybe<Order_By>;
  winning_revision_deleted_at?: InputMaybe<Order_By>;
  winning_revision_id?: InputMaybe<Order_By>;
  winning_revision_parent_id?: InputMaybe<Order_By>;
  winning_revision_updated_at?: InputMaybe<Order_By>;
};

/** input type for inserting object relation for remote table "scenario_equipment_xref_intakes" */
export type Scenario_Equipment_Xref_Intakes_Obj_Rel_Insert_Input = {
  data: Scenario_Equipment_Xref_Intakes_Insert_Input;
};

/** Ordering options when selecting data from "scenario_equipment_xref_intakes". */
export type Scenario_Equipment_Xref_Intakes_Order_By = {
  id?: InputMaybe<Order_By>;
  intake?: InputMaybe<Intakes_Order_By>;
  intake_id?: InputMaybe<Order_By>;
  journal_author_id?: InputMaybe<Order_By>;
  journal_created_at?: InputMaybe<Order_By>;
  journal_deleted_at?: InputMaybe<Order_By>;
  journal_updated_at?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  scenario_equipment_id?: InputMaybe<Order_By>;
  use_high_strength_shaft?: InputMaybe<Order_By>;
  winning_revision_author_id?: InputMaybe<Order_By>;
  winning_revision_created_at?: InputMaybe<Order_By>;
  winning_revision_deleted_at?: InputMaybe<Order_By>;
  winning_revision_id?: InputMaybe<Order_By>;
  winning_revision_parent_id?: InputMaybe<Order_By>;
  winning_revision_updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "scenario_equipment_xref_intakes" */
export enum Scenario_Equipment_Xref_Intakes_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  IntakeId = 'intake_id',
  /** column name */
  JournalAuthorId = 'journal_author_id',
  /** column name */
  JournalCreatedAt = 'journal_created_at',
  /** column name */
  JournalDeletedAt = 'journal_deleted_at',
  /** column name */
  JournalUpdatedAt = 'journal_updated_at',
  /** column name */
  ParentId = 'parent_id',
  /** column name */
  ScenarioEquipmentId = 'scenario_equipment_id',
  /** column name */
  UseHighStrengthShaft = 'use_high_strength_shaft',
  /** column name */
  WinningRevisionAuthorId = 'winning_revision_author_id',
  /** column name */
  WinningRevisionCreatedAt = 'winning_revision_created_at',
  /** column name */
  WinningRevisionDeletedAt = 'winning_revision_deleted_at',
  /** column name */
  WinningRevisionId = 'winning_revision_id',
  /** column name */
  WinningRevisionParentId = 'winning_revision_parent_id',
  /** column name */
  WinningRevisionUpdatedAt = 'winning_revision_updated_at'
}

/** select "scenario_equipment_xref_intakes_aggregate_bool_exp_bool_and_arguments_columns" columns of table "scenario_equipment_xref_intakes" */
export enum Scenario_Equipment_Xref_Intakes_Select_Column_Scenario_Equipment_Xref_Intakes_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  UseHighStrengthShaft = 'use_high_strength_shaft'
}

/** select "scenario_equipment_xref_intakes_aggregate_bool_exp_bool_or_arguments_columns" columns of table "scenario_equipment_xref_intakes" */
export enum Scenario_Equipment_Xref_Intakes_Select_Column_Scenario_Equipment_Xref_Intakes_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  UseHighStrengthShaft = 'use_high_strength_shaft'
}

/** Streaming cursor of the table "scenario_equipment_xref_intakes" */
export type Scenario_Equipment_Xref_Intakes_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Scenario_Equipment_Xref_Intakes_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Scenario_Equipment_Xref_Intakes_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  intake_id?: InputMaybe<Scalars['uuid']['input']>;
  journal_author_id?: InputMaybe<Scalars['String']['input']>;
  journal_created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  journal_deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  journal_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  parent_id?: InputMaybe<Scalars['uuid']['input']>;
  scenario_equipment_id?: InputMaybe<Scalars['uuid']['input']>;
  use_high_strength_shaft?: InputMaybe<Scalars['Boolean']['input']>;
  winning_revision_author_id?: InputMaybe<Scalars['String']['input']>;
  winning_revision_created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  winning_revision_deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  winning_revision_id?: InputMaybe<Scalars['uuid']['input']>;
  winning_revision_parent_id?: InputMaybe<Scalars['uuid']['input']>;
  winning_revision_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** columns and relationships of "scenario_equipment_xref_pumps" */
export type Scenario_Equipment_Xref_Pumps = {
  __typename: 'scenario_equipment_xref_pumps';
  brake_horsepower_correction_ratio?: Maybe<Scalars['numeric']['output']>;
  head_correction_ratio?: Maybe<Scalars['numeric']['output']>;
  housings_order?: Maybe<Array<Scalars['uuid']['output']>>;
  id?: Maybe<Scalars['uuid']['output']>;
  journal_author_id?: Maybe<Scalars['String']['output']>;
  journal_created_at?: Maybe<Scalars['timestamptz']['output']>;
  journal_deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  journal_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  length_feet?: Maybe<Scalars['numeric']['output']>;
  parent_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  pump?: Maybe<Pumps>;
  pump_id?: Maybe<Scalars['uuid']['output']>;
  rate_correction_ratio?: Maybe<Scalars['numeric']['output']>;
  scenario_equipment_id?: Maybe<Scalars['uuid']['output']>;
  total_stages?: Maybe<Scalars['Int']['output']>;
  use_high_strength_shaft?: Maybe<Scalars['Boolean']['output']>;
  weight_pounds?: Maybe<Scalars['numeric']['output']>;
  winning_revision_author_id?: Maybe<Scalars['String']['output']>;
  winning_revision_created_at?: Maybe<Scalars['timestamptz']['output']>;
  winning_revision_deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  winning_revision_id?: Maybe<Scalars['uuid']['output']>;
  winning_revision_parent_id?: Maybe<Scalars['uuid']['output']>;
  winning_revision_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An array relationship */
  xref_housings: Array<Scenario_Equipment_Xref_Housings>;
  /** An aggregate relationship */
  xref_housings_aggregate: Scenario_Equipment_Xref_Housings_Aggregate;
};


/** columns and relationships of "scenario_equipment_xref_pumps" */
export type Scenario_Equipment_Xref_PumpsXref_HousingsArgs = {
  distinct_on?: InputMaybe<Array<Scenario_Equipment_Xref_Housings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Scenario_Equipment_Xref_Housings_Order_By>>;
  where?: InputMaybe<Scenario_Equipment_Xref_Housings_Bool_Exp>;
};


/** columns and relationships of "scenario_equipment_xref_pumps" */
export type Scenario_Equipment_Xref_PumpsXref_Housings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Scenario_Equipment_Xref_Housings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Scenario_Equipment_Xref_Housings_Order_By>>;
  where?: InputMaybe<Scenario_Equipment_Xref_Housings_Bool_Exp>;
};

/** aggregated selection of "scenario_equipment_xref_pumps" */
export type Scenario_Equipment_Xref_Pumps_Aggregate = {
  __typename: 'scenario_equipment_xref_pumps_aggregate';
  aggregate?: Maybe<Scenario_Equipment_Xref_Pumps_Aggregate_Fields>;
  nodes: Array<Scenario_Equipment_Xref_Pumps>;
};

export type Scenario_Equipment_Xref_Pumps_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Scenario_Equipment_Xref_Pumps_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Scenario_Equipment_Xref_Pumps_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Scenario_Equipment_Xref_Pumps_Aggregate_Bool_Exp_Count>;
};

export type Scenario_Equipment_Xref_Pumps_Aggregate_Bool_Exp_Bool_And = {
  arguments: Scenario_Equipment_Xref_Pumps_Select_Column_Scenario_Equipment_Xref_Pumps_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Scenario_Equipment_Xref_Pumps_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Scenario_Equipment_Xref_Pumps_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Scenario_Equipment_Xref_Pumps_Select_Column_Scenario_Equipment_Xref_Pumps_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Scenario_Equipment_Xref_Pumps_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Scenario_Equipment_Xref_Pumps_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Scenario_Equipment_Xref_Pumps_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Scenario_Equipment_Xref_Pumps_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "scenario_equipment_xref_pumps" */
export type Scenario_Equipment_Xref_Pumps_Aggregate_Fields = {
  __typename: 'scenario_equipment_xref_pumps_aggregate_fields';
  avg?: Maybe<Scenario_Equipment_Xref_Pumps_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Scenario_Equipment_Xref_Pumps_Max_Fields>;
  min?: Maybe<Scenario_Equipment_Xref_Pumps_Min_Fields>;
  stddev?: Maybe<Scenario_Equipment_Xref_Pumps_Stddev_Fields>;
  stddev_pop?: Maybe<Scenario_Equipment_Xref_Pumps_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Scenario_Equipment_Xref_Pumps_Stddev_Samp_Fields>;
  sum?: Maybe<Scenario_Equipment_Xref_Pumps_Sum_Fields>;
  var_pop?: Maybe<Scenario_Equipment_Xref_Pumps_Var_Pop_Fields>;
  var_samp?: Maybe<Scenario_Equipment_Xref_Pumps_Var_Samp_Fields>;
  variance?: Maybe<Scenario_Equipment_Xref_Pumps_Variance_Fields>;
};


/** aggregate fields of "scenario_equipment_xref_pumps" */
export type Scenario_Equipment_Xref_Pumps_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Scenario_Equipment_Xref_Pumps_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "scenario_equipment_xref_pumps" */
export type Scenario_Equipment_Xref_Pumps_Aggregate_Order_By = {
  avg?: InputMaybe<Scenario_Equipment_Xref_Pumps_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Scenario_Equipment_Xref_Pumps_Max_Order_By>;
  min?: InputMaybe<Scenario_Equipment_Xref_Pumps_Min_Order_By>;
  stddev?: InputMaybe<Scenario_Equipment_Xref_Pumps_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Scenario_Equipment_Xref_Pumps_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Scenario_Equipment_Xref_Pumps_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Scenario_Equipment_Xref_Pumps_Sum_Order_By>;
  var_pop?: InputMaybe<Scenario_Equipment_Xref_Pumps_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Scenario_Equipment_Xref_Pumps_Var_Samp_Order_By>;
  variance?: InputMaybe<Scenario_Equipment_Xref_Pumps_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "scenario_equipment_xref_pumps" */
export type Scenario_Equipment_Xref_Pumps_Arr_Rel_Insert_Input = {
  data: Array<Scenario_Equipment_Xref_Pumps_Insert_Input>;
};

/** aggregate avg on columns */
export type Scenario_Equipment_Xref_Pumps_Avg_Fields = {
  __typename: 'scenario_equipment_xref_pumps_avg_fields';
  brake_horsepower_correction_ratio?: Maybe<Scalars['Float']['output']>;
  head_correction_ratio?: Maybe<Scalars['Float']['output']>;
  length_feet?: Maybe<Scalars['Float']['output']>;
  rate_correction_ratio?: Maybe<Scalars['Float']['output']>;
  total_stages?: Maybe<Scalars['Float']['output']>;
  weight_pounds?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "scenario_equipment_xref_pumps" */
export type Scenario_Equipment_Xref_Pumps_Avg_Order_By = {
  brake_horsepower_correction_ratio?: InputMaybe<Order_By>;
  head_correction_ratio?: InputMaybe<Order_By>;
  length_feet?: InputMaybe<Order_By>;
  rate_correction_ratio?: InputMaybe<Order_By>;
  total_stages?: InputMaybe<Order_By>;
  weight_pounds?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "scenario_equipment_xref_pumps". All fields are combined with a logical 'AND'. */
export type Scenario_Equipment_Xref_Pumps_Bool_Exp = {
  _and?: InputMaybe<Array<Scenario_Equipment_Xref_Pumps_Bool_Exp>>;
  _not?: InputMaybe<Scenario_Equipment_Xref_Pumps_Bool_Exp>;
  _or?: InputMaybe<Array<Scenario_Equipment_Xref_Pumps_Bool_Exp>>;
  brake_horsepower_correction_ratio?: InputMaybe<Numeric_Comparison_Exp>;
  head_correction_ratio?: InputMaybe<Numeric_Comparison_Exp>;
  housings_order?: InputMaybe<Uuid_Array_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  journal_author_id?: InputMaybe<String_Comparison_Exp>;
  journal_created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  journal_deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  journal_updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  length_feet?: InputMaybe<Numeric_Comparison_Exp>;
  parent_id?: InputMaybe<Uuid_Comparison_Exp>;
  pump?: InputMaybe<Pumps_Bool_Exp>;
  pump_id?: InputMaybe<Uuid_Comparison_Exp>;
  rate_correction_ratio?: InputMaybe<Numeric_Comparison_Exp>;
  scenario_equipment_id?: InputMaybe<Uuid_Comparison_Exp>;
  total_stages?: InputMaybe<Int_Comparison_Exp>;
  use_high_strength_shaft?: InputMaybe<Boolean_Comparison_Exp>;
  weight_pounds?: InputMaybe<Numeric_Comparison_Exp>;
  winning_revision_author_id?: InputMaybe<String_Comparison_Exp>;
  winning_revision_created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  winning_revision_deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  winning_revision_id?: InputMaybe<Uuid_Comparison_Exp>;
  winning_revision_parent_id?: InputMaybe<Uuid_Comparison_Exp>;
  winning_revision_updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  xref_housings?: InputMaybe<Scenario_Equipment_Xref_Housings_Bool_Exp>;
  xref_housings_aggregate?: InputMaybe<Scenario_Equipment_Xref_Housings_Aggregate_Bool_Exp>;
};

/** input type for inserting data into table "scenario_equipment_xref_pumps" */
export type Scenario_Equipment_Xref_Pumps_Insert_Input = {
  brake_horsepower_correction_ratio?: InputMaybe<Scalars['numeric']['input']>;
  head_correction_ratio?: InputMaybe<Scalars['numeric']['input']>;
  housings_order?: InputMaybe<Array<Scalars['uuid']['input']>>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  journal_author_id?: InputMaybe<Scalars['String']['input']>;
  journal_created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  journal_deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  journal_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  length_feet?: InputMaybe<Scalars['numeric']['input']>;
  parent_id?: InputMaybe<Scalars['uuid']['input']>;
  pump?: InputMaybe<Pumps_Obj_Rel_Insert_Input>;
  pump_id?: InputMaybe<Scalars['uuid']['input']>;
  rate_correction_ratio?: InputMaybe<Scalars['numeric']['input']>;
  scenario_equipment_id?: InputMaybe<Scalars['uuid']['input']>;
  total_stages?: InputMaybe<Scalars['Int']['input']>;
  use_high_strength_shaft?: InputMaybe<Scalars['Boolean']['input']>;
  weight_pounds?: InputMaybe<Scalars['numeric']['input']>;
  winning_revision_author_id?: InputMaybe<Scalars['String']['input']>;
  winning_revision_created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  winning_revision_deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  winning_revision_id?: InputMaybe<Scalars['uuid']['input']>;
  winning_revision_parent_id?: InputMaybe<Scalars['uuid']['input']>;
  winning_revision_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  xref_housings?: InputMaybe<Scenario_Equipment_Xref_Housings_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Scenario_Equipment_Xref_Pumps_Max_Fields = {
  __typename: 'scenario_equipment_xref_pumps_max_fields';
  brake_horsepower_correction_ratio?: Maybe<Scalars['numeric']['output']>;
  head_correction_ratio?: Maybe<Scalars['numeric']['output']>;
  housings_order?: Maybe<Array<Scalars['uuid']['output']>>;
  id?: Maybe<Scalars['uuid']['output']>;
  journal_author_id?: Maybe<Scalars['String']['output']>;
  journal_created_at?: Maybe<Scalars['timestamptz']['output']>;
  journal_deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  journal_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  length_feet?: Maybe<Scalars['numeric']['output']>;
  parent_id?: Maybe<Scalars['uuid']['output']>;
  pump_id?: Maybe<Scalars['uuid']['output']>;
  rate_correction_ratio?: Maybe<Scalars['numeric']['output']>;
  scenario_equipment_id?: Maybe<Scalars['uuid']['output']>;
  total_stages?: Maybe<Scalars['Int']['output']>;
  weight_pounds?: Maybe<Scalars['numeric']['output']>;
  winning_revision_author_id?: Maybe<Scalars['String']['output']>;
  winning_revision_created_at?: Maybe<Scalars['timestamptz']['output']>;
  winning_revision_deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  winning_revision_id?: Maybe<Scalars['uuid']['output']>;
  winning_revision_parent_id?: Maybe<Scalars['uuid']['output']>;
  winning_revision_updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "scenario_equipment_xref_pumps" */
export type Scenario_Equipment_Xref_Pumps_Max_Order_By = {
  brake_horsepower_correction_ratio?: InputMaybe<Order_By>;
  head_correction_ratio?: InputMaybe<Order_By>;
  housings_order?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  journal_author_id?: InputMaybe<Order_By>;
  journal_created_at?: InputMaybe<Order_By>;
  journal_deleted_at?: InputMaybe<Order_By>;
  journal_updated_at?: InputMaybe<Order_By>;
  length_feet?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  pump_id?: InputMaybe<Order_By>;
  rate_correction_ratio?: InputMaybe<Order_By>;
  scenario_equipment_id?: InputMaybe<Order_By>;
  total_stages?: InputMaybe<Order_By>;
  weight_pounds?: InputMaybe<Order_By>;
  winning_revision_author_id?: InputMaybe<Order_By>;
  winning_revision_created_at?: InputMaybe<Order_By>;
  winning_revision_deleted_at?: InputMaybe<Order_By>;
  winning_revision_id?: InputMaybe<Order_By>;
  winning_revision_parent_id?: InputMaybe<Order_By>;
  winning_revision_updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Scenario_Equipment_Xref_Pumps_Min_Fields = {
  __typename: 'scenario_equipment_xref_pumps_min_fields';
  brake_horsepower_correction_ratio?: Maybe<Scalars['numeric']['output']>;
  head_correction_ratio?: Maybe<Scalars['numeric']['output']>;
  housings_order?: Maybe<Array<Scalars['uuid']['output']>>;
  id?: Maybe<Scalars['uuid']['output']>;
  journal_author_id?: Maybe<Scalars['String']['output']>;
  journal_created_at?: Maybe<Scalars['timestamptz']['output']>;
  journal_deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  journal_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  length_feet?: Maybe<Scalars['numeric']['output']>;
  parent_id?: Maybe<Scalars['uuid']['output']>;
  pump_id?: Maybe<Scalars['uuid']['output']>;
  rate_correction_ratio?: Maybe<Scalars['numeric']['output']>;
  scenario_equipment_id?: Maybe<Scalars['uuid']['output']>;
  total_stages?: Maybe<Scalars['Int']['output']>;
  weight_pounds?: Maybe<Scalars['numeric']['output']>;
  winning_revision_author_id?: Maybe<Scalars['String']['output']>;
  winning_revision_created_at?: Maybe<Scalars['timestamptz']['output']>;
  winning_revision_deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  winning_revision_id?: Maybe<Scalars['uuid']['output']>;
  winning_revision_parent_id?: Maybe<Scalars['uuid']['output']>;
  winning_revision_updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "scenario_equipment_xref_pumps" */
export type Scenario_Equipment_Xref_Pumps_Min_Order_By = {
  brake_horsepower_correction_ratio?: InputMaybe<Order_By>;
  head_correction_ratio?: InputMaybe<Order_By>;
  housings_order?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  journal_author_id?: InputMaybe<Order_By>;
  journal_created_at?: InputMaybe<Order_By>;
  journal_deleted_at?: InputMaybe<Order_By>;
  journal_updated_at?: InputMaybe<Order_By>;
  length_feet?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  pump_id?: InputMaybe<Order_By>;
  rate_correction_ratio?: InputMaybe<Order_By>;
  scenario_equipment_id?: InputMaybe<Order_By>;
  total_stages?: InputMaybe<Order_By>;
  weight_pounds?: InputMaybe<Order_By>;
  winning_revision_author_id?: InputMaybe<Order_By>;
  winning_revision_created_at?: InputMaybe<Order_By>;
  winning_revision_deleted_at?: InputMaybe<Order_By>;
  winning_revision_id?: InputMaybe<Order_By>;
  winning_revision_parent_id?: InputMaybe<Order_By>;
  winning_revision_updated_at?: InputMaybe<Order_By>;
};

/** input type for inserting object relation for remote table "scenario_equipment_xref_pumps" */
export type Scenario_Equipment_Xref_Pumps_Obj_Rel_Insert_Input = {
  data: Scenario_Equipment_Xref_Pumps_Insert_Input;
};

/** Ordering options when selecting data from "scenario_equipment_xref_pumps". */
export type Scenario_Equipment_Xref_Pumps_Order_By = {
  brake_horsepower_correction_ratio?: InputMaybe<Order_By>;
  head_correction_ratio?: InputMaybe<Order_By>;
  housings_order?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  journal_author_id?: InputMaybe<Order_By>;
  journal_created_at?: InputMaybe<Order_By>;
  journal_deleted_at?: InputMaybe<Order_By>;
  journal_updated_at?: InputMaybe<Order_By>;
  length_feet?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  pump?: InputMaybe<Pumps_Order_By>;
  pump_id?: InputMaybe<Order_By>;
  rate_correction_ratio?: InputMaybe<Order_By>;
  scenario_equipment_id?: InputMaybe<Order_By>;
  total_stages?: InputMaybe<Order_By>;
  use_high_strength_shaft?: InputMaybe<Order_By>;
  weight_pounds?: InputMaybe<Order_By>;
  winning_revision_author_id?: InputMaybe<Order_By>;
  winning_revision_created_at?: InputMaybe<Order_By>;
  winning_revision_deleted_at?: InputMaybe<Order_By>;
  winning_revision_id?: InputMaybe<Order_By>;
  winning_revision_parent_id?: InputMaybe<Order_By>;
  winning_revision_updated_at?: InputMaybe<Order_By>;
  xref_housings_aggregate?: InputMaybe<Scenario_Equipment_Xref_Housings_Aggregate_Order_By>;
};

/** select columns of table "scenario_equipment_xref_pumps" */
export enum Scenario_Equipment_Xref_Pumps_Select_Column {
  /** column name */
  BrakeHorsepowerCorrectionRatio = 'brake_horsepower_correction_ratio',
  /** column name */
  HeadCorrectionRatio = 'head_correction_ratio',
  /** column name */
  HousingsOrder = 'housings_order',
  /** column name */
  Id = 'id',
  /** column name */
  JournalAuthorId = 'journal_author_id',
  /** column name */
  JournalCreatedAt = 'journal_created_at',
  /** column name */
  JournalDeletedAt = 'journal_deleted_at',
  /** column name */
  JournalUpdatedAt = 'journal_updated_at',
  /** column name */
  LengthFeet = 'length_feet',
  /** column name */
  ParentId = 'parent_id',
  /** column name */
  PumpId = 'pump_id',
  /** column name */
  RateCorrectionRatio = 'rate_correction_ratio',
  /** column name */
  ScenarioEquipmentId = 'scenario_equipment_id',
  /** column name */
  TotalStages = 'total_stages',
  /** column name */
  UseHighStrengthShaft = 'use_high_strength_shaft',
  /** column name */
  WeightPounds = 'weight_pounds',
  /** column name */
  WinningRevisionAuthorId = 'winning_revision_author_id',
  /** column name */
  WinningRevisionCreatedAt = 'winning_revision_created_at',
  /** column name */
  WinningRevisionDeletedAt = 'winning_revision_deleted_at',
  /** column name */
  WinningRevisionId = 'winning_revision_id',
  /** column name */
  WinningRevisionParentId = 'winning_revision_parent_id',
  /** column name */
  WinningRevisionUpdatedAt = 'winning_revision_updated_at'
}

/** select "scenario_equipment_xref_pumps_aggregate_bool_exp_bool_and_arguments_columns" columns of table "scenario_equipment_xref_pumps" */
export enum Scenario_Equipment_Xref_Pumps_Select_Column_Scenario_Equipment_Xref_Pumps_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  UseHighStrengthShaft = 'use_high_strength_shaft'
}

/** select "scenario_equipment_xref_pumps_aggregate_bool_exp_bool_or_arguments_columns" columns of table "scenario_equipment_xref_pumps" */
export enum Scenario_Equipment_Xref_Pumps_Select_Column_Scenario_Equipment_Xref_Pumps_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  UseHighStrengthShaft = 'use_high_strength_shaft'
}

/** aggregate stddev on columns */
export type Scenario_Equipment_Xref_Pumps_Stddev_Fields = {
  __typename: 'scenario_equipment_xref_pumps_stddev_fields';
  brake_horsepower_correction_ratio?: Maybe<Scalars['Float']['output']>;
  head_correction_ratio?: Maybe<Scalars['Float']['output']>;
  length_feet?: Maybe<Scalars['Float']['output']>;
  rate_correction_ratio?: Maybe<Scalars['Float']['output']>;
  total_stages?: Maybe<Scalars['Float']['output']>;
  weight_pounds?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "scenario_equipment_xref_pumps" */
export type Scenario_Equipment_Xref_Pumps_Stddev_Order_By = {
  brake_horsepower_correction_ratio?: InputMaybe<Order_By>;
  head_correction_ratio?: InputMaybe<Order_By>;
  length_feet?: InputMaybe<Order_By>;
  rate_correction_ratio?: InputMaybe<Order_By>;
  total_stages?: InputMaybe<Order_By>;
  weight_pounds?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Scenario_Equipment_Xref_Pumps_Stddev_Pop_Fields = {
  __typename: 'scenario_equipment_xref_pumps_stddev_pop_fields';
  brake_horsepower_correction_ratio?: Maybe<Scalars['Float']['output']>;
  head_correction_ratio?: Maybe<Scalars['Float']['output']>;
  length_feet?: Maybe<Scalars['Float']['output']>;
  rate_correction_ratio?: Maybe<Scalars['Float']['output']>;
  total_stages?: Maybe<Scalars['Float']['output']>;
  weight_pounds?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "scenario_equipment_xref_pumps" */
export type Scenario_Equipment_Xref_Pumps_Stddev_Pop_Order_By = {
  brake_horsepower_correction_ratio?: InputMaybe<Order_By>;
  head_correction_ratio?: InputMaybe<Order_By>;
  length_feet?: InputMaybe<Order_By>;
  rate_correction_ratio?: InputMaybe<Order_By>;
  total_stages?: InputMaybe<Order_By>;
  weight_pounds?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Scenario_Equipment_Xref_Pumps_Stddev_Samp_Fields = {
  __typename: 'scenario_equipment_xref_pumps_stddev_samp_fields';
  brake_horsepower_correction_ratio?: Maybe<Scalars['Float']['output']>;
  head_correction_ratio?: Maybe<Scalars['Float']['output']>;
  length_feet?: Maybe<Scalars['Float']['output']>;
  rate_correction_ratio?: Maybe<Scalars['Float']['output']>;
  total_stages?: Maybe<Scalars['Float']['output']>;
  weight_pounds?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "scenario_equipment_xref_pumps" */
export type Scenario_Equipment_Xref_Pumps_Stddev_Samp_Order_By = {
  brake_horsepower_correction_ratio?: InputMaybe<Order_By>;
  head_correction_ratio?: InputMaybe<Order_By>;
  length_feet?: InputMaybe<Order_By>;
  rate_correction_ratio?: InputMaybe<Order_By>;
  total_stages?: InputMaybe<Order_By>;
  weight_pounds?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "scenario_equipment_xref_pumps" */
export type Scenario_Equipment_Xref_Pumps_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Scenario_Equipment_Xref_Pumps_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Scenario_Equipment_Xref_Pumps_Stream_Cursor_Value_Input = {
  brake_horsepower_correction_ratio?: InputMaybe<Scalars['numeric']['input']>;
  head_correction_ratio?: InputMaybe<Scalars['numeric']['input']>;
  housings_order?: InputMaybe<Array<Scalars['uuid']['input']>>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  journal_author_id?: InputMaybe<Scalars['String']['input']>;
  journal_created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  journal_deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  journal_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  length_feet?: InputMaybe<Scalars['numeric']['input']>;
  parent_id?: InputMaybe<Scalars['uuid']['input']>;
  pump_id?: InputMaybe<Scalars['uuid']['input']>;
  rate_correction_ratio?: InputMaybe<Scalars['numeric']['input']>;
  scenario_equipment_id?: InputMaybe<Scalars['uuid']['input']>;
  total_stages?: InputMaybe<Scalars['Int']['input']>;
  use_high_strength_shaft?: InputMaybe<Scalars['Boolean']['input']>;
  weight_pounds?: InputMaybe<Scalars['numeric']['input']>;
  winning_revision_author_id?: InputMaybe<Scalars['String']['input']>;
  winning_revision_created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  winning_revision_deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  winning_revision_id?: InputMaybe<Scalars['uuid']['input']>;
  winning_revision_parent_id?: InputMaybe<Scalars['uuid']['input']>;
  winning_revision_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Scenario_Equipment_Xref_Pumps_Sum_Fields = {
  __typename: 'scenario_equipment_xref_pumps_sum_fields';
  brake_horsepower_correction_ratio?: Maybe<Scalars['numeric']['output']>;
  head_correction_ratio?: Maybe<Scalars['numeric']['output']>;
  length_feet?: Maybe<Scalars['numeric']['output']>;
  rate_correction_ratio?: Maybe<Scalars['numeric']['output']>;
  total_stages?: Maybe<Scalars['Int']['output']>;
  weight_pounds?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "scenario_equipment_xref_pumps" */
export type Scenario_Equipment_Xref_Pumps_Sum_Order_By = {
  brake_horsepower_correction_ratio?: InputMaybe<Order_By>;
  head_correction_ratio?: InputMaybe<Order_By>;
  length_feet?: InputMaybe<Order_By>;
  rate_correction_ratio?: InputMaybe<Order_By>;
  total_stages?: InputMaybe<Order_By>;
  weight_pounds?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Scenario_Equipment_Xref_Pumps_Var_Pop_Fields = {
  __typename: 'scenario_equipment_xref_pumps_var_pop_fields';
  brake_horsepower_correction_ratio?: Maybe<Scalars['Float']['output']>;
  head_correction_ratio?: Maybe<Scalars['Float']['output']>;
  length_feet?: Maybe<Scalars['Float']['output']>;
  rate_correction_ratio?: Maybe<Scalars['Float']['output']>;
  total_stages?: Maybe<Scalars['Float']['output']>;
  weight_pounds?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "scenario_equipment_xref_pumps" */
export type Scenario_Equipment_Xref_Pumps_Var_Pop_Order_By = {
  brake_horsepower_correction_ratio?: InputMaybe<Order_By>;
  head_correction_ratio?: InputMaybe<Order_By>;
  length_feet?: InputMaybe<Order_By>;
  rate_correction_ratio?: InputMaybe<Order_By>;
  total_stages?: InputMaybe<Order_By>;
  weight_pounds?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Scenario_Equipment_Xref_Pumps_Var_Samp_Fields = {
  __typename: 'scenario_equipment_xref_pumps_var_samp_fields';
  brake_horsepower_correction_ratio?: Maybe<Scalars['Float']['output']>;
  head_correction_ratio?: Maybe<Scalars['Float']['output']>;
  length_feet?: Maybe<Scalars['Float']['output']>;
  rate_correction_ratio?: Maybe<Scalars['Float']['output']>;
  total_stages?: Maybe<Scalars['Float']['output']>;
  weight_pounds?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "scenario_equipment_xref_pumps" */
export type Scenario_Equipment_Xref_Pumps_Var_Samp_Order_By = {
  brake_horsepower_correction_ratio?: InputMaybe<Order_By>;
  head_correction_ratio?: InputMaybe<Order_By>;
  length_feet?: InputMaybe<Order_By>;
  rate_correction_ratio?: InputMaybe<Order_By>;
  total_stages?: InputMaybe<Order_By>;
  weight_pounds?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Scenario_Equipment_Xref_Pumps_Variance_Fields = {
  __typename: 'scenario_equipment_xref_pumps_variance_fields';
  brake_horsepower_correction_ratio?: Maybe<Scalars['Float']['output']>;
  head_correction_ratio?: Maybe<Scalars['Float']['output']>;
  length_feet?: Maybe<Scalars['Float']['output']>;
  rate_correction_ratio?: Maybe<Scalars['Float']['output']>;
  total_stages?: Maybe<Scalars['Float']['output']>;
  weight_pounds?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "scenario_equipment_xref_pumps" */
export type Scenario_Equipment_Xref_Pumps_Variance_Order_By = {
  brake_horsepower_correction_ratio?: InputMaybe<Order_By>;
  head_correction_ratio?: InputMaybe<Order_By>;
  length_feet?: InputMaybe<Order_By>;
  rate_correction_ratio?: InputMaybe<Order_By>;
  total_stages?: InputMaybe<Order_By>;
  weight_pounds?: InputMaybe<Order_By>;
};

/** columns and relationships of "scenario_equipment_xref_seals" */
export type Scenario_Equipment_Xref_Seals = {
  __typename: 'scenario_equipment_xref_seals';
  id?: Maybe<Scalars['uuid']['output']>;
  journal_author_id?: Maybe<Scalars['String']['output']>;
  journal_created_at?: Maybe<Scalars['timestamptz']['output']>;
  journal_deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  journal_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  parent_id?: Maybe<Scalars['uuid']['output']>;
  scenario_equipment_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  seal?: Maybe<Seals>;
  seal_id?: Maybe<Scalars['uuid']['output']>;
  use_high_strength_shaft?: Maybe<Scalars['Boolean']['output']>;
  winning_revision_author_id?: Maybe<Scalars['String']['output']>;
  winning_revision_created_at?: Maybe<Scalars['timestamptz']['output']>;
  winning_revision_deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  winning_revision_id?: Maybe<Scalars['uuid']['output']>;
  winning_revision_parent_id?: Maybe<Scalars['uuid']['output']>;
  winning_revision_updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregated selection of "scenario_equipment_xref_seals" */
export type Scenario_Equipment_Xref_Seals_Aggregate = {
  __typename: 'scenario_equipment_xref_seals_aggregate';
  aggregate?: Maybe<Scenario_Equipment_Xref_Seals_Aggregate_Fields>;
  nodes: Array<Scenario_Equipment_Xref_Seals>;
};

export type Scenario_Equipment_Xref_Seals_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Scenario_Equipment_Xref_Seals_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Scenario_Equipment_Xref_Seals_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Scenario_Equipment_Xref_Seals_Aggregate_Bool_Exp_Count>;
};

export type Scenario_Equipment_Xref_Seals_Aggregate_Bool_Exp_Bool_And = {
  arguments: Scenario_Equipment_Xref_Seals_Select_Column_Scenario_Equipment_Xref_Seals_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Scenario_Equipment_Xref_Seals_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Scenario_Equipment_Xref_Seals_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Scenario_Equipment_Xref_Seals_Select_Column_Scenario_Equipment_Xref_Seals_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Scenario_Equipment_Xref_Seals_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Scenario_Equipment_Xref_Seals_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Scenario_Equipment_Xref_Seals_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Scenario_Equipment_Xref_Seals_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "scenario_equipment_xref_seals" */
export type Scenario_Equipment_Xref_Seals_Aggregate_Fields = {
  __typename: 'scenario_equipment_xref_seals_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Scenario_Equipment_Xref_Seals_Max_Fields>;
  min?: Maybe<Scenario_Equipment_Xref_Seals_Min_Fields>;
};


/** aggregate fields of "scenario_equipment_xref_seals" */
export type Scenario_Equipment_Xref_Seals_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Scenario_Equipment_Xref_Seals_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "scenario_equipment_xref_seals" */
export type Scenario_Equipment_Xref_Seals_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Scenario_Equipment_Xref_Seals_Max_Order_By>;
  min?: InputMaybe<Scenario_Equipment_Xref_Seals_Min_Order_By>;
};

/** input type for inserting array relation for remote table "scenario_equipment_xref_seals" */
export type Scenario_Equipment_Xref_Seals_Arr_Rel_Insert_Input = {
  data: Array<Scenario_Equipment_Xref_Seals_Insert_Input>;
};

/** Boolean expression to filter rows from the table "scenario_equipment_xref_seals". All fields are combined with a logical 'AND'. */
export type Scenario_Equipment_Xref_Seals_Bool_Exp = {
  _and?: InputMaybe<Array<Scenario_Equipment_Xref_Seals_Bool_Exp>>;
  _not?: InputMaybe<Scenario_Equipment_Xref_Seals_Bool_Exp>;
  _or?: InputMaybe<Array<Scenario_Equipment_Xref_Seals_Bool_Exp>>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  journal_author_id?: InputMaybe<String_Comparison_Exp>;
  journal_created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  journal_deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  journal_updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  parent_id?: InputMaybe<Uuid_Comparison_Exp>;
  scenario_equipment_id?: InputMaybe<Uuid_Comparison_Exp>;
  seal?: InputMaybe<Seals_Bool_Exp>;
  seal_id?: InputMaybe<Uuid_Comparison_Exp>;
  use_high_strength_shaft?: InputMaybe<Boolean_Comparison_Exp>;
  winning_revision_author_id?: InputMaybe<String_Comparison_Exp>;
  winning_revision_created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  winning_revision_deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  winning_revision_id?: InputMaybe<Uuid_Comparison_Exp>;
  winning_revision_parent_id?: InputMaybe<Uuid_Comparison_Exp>;
  winning_revision_updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** input type for inserting data into table "scenario_equipment_xref_seals" */
export type Scenario_Equipment_Xref_Seals_Insert_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  journal_author_id?: InputMaybe<Scalars['String']['input']>;
  journal_created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  journal_deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  journal_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  parent_id?: InputMaybe<Scalars['uuid']['input']>;
  scenario_equipment_id?: InputMaybe<Scalars['uuid']['input']>;
  seal?: InputMaybe<Seals_Obj_Rel_Insert_Input>;
  seal_id?: InputMaybe<Scalars['uuid']['input']>;
  use_high_strength_shaft?: InputMaybe<Scalars['Boolean']['input']>;
  winning_revision_author_id?: InputMaybe<Scalars['String']['input']>;
  winning_revision_created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  winning_revision_deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  winning_revision_id?: InputMaybe<Scalars['uuid']['input']>;
  winning_revision_parent_id?: InputMaybe<Scalars['uuid']['input']>;
  winning_revision_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Scenario_Equipment_Xref_Seals_Max_Fields = {
  __typename: 'scenario_equipment_xref_seals_max_fields';
  id?: Maybe<Scalars['uuid']['output']>;
  journal_author_id?: Maybe<Scalars['String']['output']>;
  journal_created_at?: Maybe<Scalars['timestamptz']['output']>;
  journal_deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  journal_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  parent_id?: Maybe<Scalars['uuid']['output']>;
  scenario_equipment_id?: Maybe<Scalars['uuid']['output']>;
  seal_id?: Maybe<Scalars['uuid']['output']>;
  winning_revision_author_id?: Maybe<Scalars['String']['output']>;
  winning_revision_created_at?: Maybe<Scalars['timestamptz']['output']>;
  winning_revision_deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  winning_revision_id?: Maybe<Scalars['uuid']['output']>;
  winning_revision_parent_id?: Maybe<Scalars['uuid']['output']>;
  winning_revision_updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "scenario_equipment_xref_seals" */
export type Scenario_Equipment_Xref_Seals_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  journal_author_id?: InputMaybe<Order_By>;
  journal_created_at?: InputMaybe<Order_By>;
  journal_deleted_at?: InputMaybe<Order_By>;
  journal_updated_at?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  scenario_equipment_id?: InputMaybe<Order_By>;
  seal_id?: InputMaybe<Order_By>;
  winning_revision_author_id?: InputMaybe<Order_By>;
  winning_revision_created_at?: InputMaybe<Order_By>;
  winning_revision_deleted_at?: InputMaybe<Order_By>;
  winning_revision_id?: InputMaybe<Order_By>;
  winning_revision_parent_id?: InputMaybe<Order_By>;
  winning_revision_updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Scenario_Equipment_Xref_Seals_Min_Fields = {
  __typename: 'scenario_equipment_xref_seals_min_fields';
  id?: Maybe<Scalars['uuid']['output']>;
  journal_author_id?: Maybe<Scalars['String']['output']>;
  journal_created_at?: Maybe<Scalars['timestamptz']['output']>;
  journal_deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  journal_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  parent_id?: Maybe<Scalars['uuid']['output']>;
  scenario_equipment_id?: Maybe<Scalars['uuid']['output']>;
  seal_id?: Maybe<Scalars['uuid']['output']>;
  winning_revision_author_id?: Maybe<Scalars['String']['output']>;
  winning_revision_created_at?: Maybe<Scalars['timestamptz']['output']>;
  winning_revision_deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  winning_revision_id?: Maybe<Scalars['uuid']['output']>;
  winning_revision_parent_id?: Maybe<Scalars['uuid']['output']>;
  winning_revision_updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "scenario_equipment_xref_seals" */
export type Scenario_Equipment_Xref_Seals_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  journal_author_id?: InputMaybe<Order_By>;
  journal_created_at?: InputMaybe<Order_By>;
  journal_deleted_at?: InputMaybe<Order_By>;
  journal_updated_at?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  scenario_equipment_id?: InputMaybe<Order_By>;
  seal_id?: InputMaybe<Order_By>;
  winning_revision_author_id?: InputMaybe<Order_By>;
  winning_revision_created_at?: InputMaybe<Order_By>;
  winning_revision_deleted_at?: InputMaybe<Order_By>;
  winning_revision_id?: InputMaybe<Order_By>;
  winning_revision_parent_id?: InputMaybe<Order_By>;
  winning_revision_updated_at?: InputMaybe<Order_By>;
};

/** input type for inserting object relation for remote table "scenario_equipment_xref_seals" */
export type Scenario_Equipment_Xref_Seals_Obj_Rel_Insert_Input = {
  data: Scenario_Equipment_Xref_Seals_Insert_Input;
};

/** Ordering options when selecting data from "scenario_equipment_xref_seals". */
export type Scenario_Equipment_Xref_Seals_Order_By = {
  id?: InputMaybe<Order_By>;
  journal_author_id?: InputMaybe<Order_By>;
  journal_created_at?: InputMaybe<Order_By>;
  journal_deleted_at?: InputMaybe<Order_By>;
  journal_updated_at?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  scenario_equipment_id?: InputMaybe<Order_By>;
  seal?: InputMaybe<Seals_Order_By>;
  seal_id?: InputMaybe<Order_By>;
  use_high_strength_shaft?: InputMaybe<Order_By>;
  winning_revision_author_id?: InputMaybe<Order_By>;
  winning_revision_created_at?: InputMaybe<Order_By>;
  winning_revision_deleted_at?: InputMaybe<Order_By>;
  winning_revision_id?: InputMaybe<Order_By>;
  winning_revision_parent_id?: InputMaybe<Order_By>;
  winning_revision_updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "scenario_equipment_xref_seals" */
export enum Scenario_Equipment_Xref_Seals_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  JournalAuthorId = 'journal_author_id',
  /** column name */
  JournalCreatedAt = 'journal_created_at',
  /** column name */
  JournalDeletedAt = 'journal_deleted_at',
  /** column name */
  JournalUpdatedAt = 'journal_updated_at',
  /** column name */
  ParentId = 'parent_id',
  /** column name */
  ScenarioEquipmentId = 'scenario_equipment_id',
  /** column name */
  SealId = 'seal_id',
  /** column name */
  UseHighStrengthShaft = 'use_high_strength_shaft',
  /** column name */
  WinningRevisionAuthorId = 'winning_revision_author_id',
  /** column name */
  WinningRevisionCreatedAt = 'winning_revision_created_at',
  /** column name */
  WinningRevisionDeletedAt = 'winning_revision_deleted_at',
  /** column name */
  WinningRevisionId = 'winning_revision_id',
  /** column name */
  WinningRevisionParentId = 'winning_revision_parent_id',
  /** column name */
  WinningRevisionUpdatedAt = 'winning_revision_updated_at'
}

/** select "scenario_equipment_xref_seals_aggregate_bool_exp_bool_and_arguments_columns" columns of table "scenario_equipment_xref_seals" */
export enum Scenario_Equipment_Xref_Seals_Select_Column_Scenario_Equipment_Xref_Seals_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  UseHighStrengthShaft = 'use_high_strength_shaft'
}

/** select "scenario_equipment_xref_seals_aggregate_bool_exp_bool_or_arguments_columns" columns of table "scenario_equipment_xref_seals" */
export enum Scenario_Equipment_Xref_Seals_Select_Column_Scenario_Equipment_Xref_Seals_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  UseHighStrengthShaft = 'use_high_strength_shaft'
}

/** Streaming cursor of the table "scenario_equipment_xref_seals" */
export type Scenario_Equipment_Xref_Seals_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Scenario_Equipment_Xref_Seals_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Scenario_Equipment_Xref_Seals_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  journal_author_id?: InputMaybe<Scalars['String']['input']>;
  journal_created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  journal_deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  journal_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  parent_id?: InputMaybe<Scalars['uuid']['input']>;
  scenario_equipment_id?: InputMaybe<Scalars['uuid']['input']>;
  seal_id?: InputMaybe<Scalars['uuid']['input']>;
  use_high_strength_shaft?: InputMaybe<Scalars['Boolean']['input']>;
  winning_revision_author_id?: InputMaybe<Scalars['String']['input']>;
  winning_revision_created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  winning_revision_deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  winning_revision_id?: InputMaybe<Scalars['uuid']['input']>;
  winning_revision_parent_id?: InputMaybe<Scalars['uuid']['input']>;
  winning_revision_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** columns and relationships of "scenario_parameters" */
export type Scenario_Parameters = {
  __typename: 'scenario_parameters';
  bottom_casing_pressure_psia?: Maybe<Scalars['numeric']['output']>;
  bottom_tubing_pressure_psia?: Maybe<Scalars['numeric']['output']>;
  cable_cost_kw_hr_usd?: Maybe<Scalars['numeric']['output']>;
  elevation_feet_asl?: Maybe<Scalars['numeric']['output']>;
  flow_model?: Maybe<Scalars['String']['output']>;
  has_compression_pump?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  include_casing_friction_loss?: Maybe<Scalars['Boolean']['output']>;
  intake_gas_separation_override_type?: Maybe<Scalars['String']['output']>;
  intake_override_gas_separation_percent?: Maybe<Scalars['numeric']['output']>;
  intake_packer_installed?: Maybe<Scalars['Boolean']['output']>;
  journal_author_id?: Maybe<Scalars['String']['output']>;
  journal_created_at?: Maybe<Scalars['timestamptz']['output']>;
  journal_deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  journal_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  lower_has_compression_pump?: Maybe<Scalars['Boolean']['output']>;
  lower_include_casing_friction_loss?: Maybe<Scalars['Boolean']['output']>;
  lower_intake_gas_separation_override_type?: Maybe<Scalars['String']['output']>;
  lower_intake_override_gas_separation_percent?: Maybe<Scalars['numeric']['output']>;
  lower_intake_packer_installed?: Maybe<Scalars['Boolean']['output']>;
  lower_motor_rerate_ratio?: Maybe<Scalars['numeric']['output']>;
  lower_motor_shroud_interior_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  lower_natural_gas_separation_override_type?: Maybe<Scalars['String']['output']>;
  lower_natural_override_gas_separation_percent?: Maybe<Scalars['numeric']['output']>;
  lower_pump_hz?: Maybe<Scalars['numeric']['output']>;
  lower_pump_override_gas_correction_percent?: Maybe<Scalars['numeric']['output']>;
  lower_pump_wear_brake_horsepower_correction_ratio?: Maybe<Scalars['numeric']['output']>;
  lower_pump_wear_head_correction_ratio?: Maybe<Scalars['numeric']['output']>;
  lower_use_legacy_gas_head_rerate?: Maybe<Scalars['Boolean']['output']>;
  maximum_frequency?: Maybe<Scalars['numeric']['output']>;
  minimum_frequency?: Maybe<Scalars['numeric']['output']>;
  motor_rerate_ratio?: Maybe<Scalars['numeric']['output']>;
  motor_shroud_interior_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  natural_gas_separation_override_type?: Maybe<Scalars['String']['output']>;
  natural_override_gas_separation_percent?: Maybe<Scalars['numeric']['output']>;
  parent_id?: Maybe<Scalars['uuid']['output']>;
  pump_hz?: Maybe<Scalars['numeric']['output']>;
  pump_override_gas_correction_percent?: Maybe<Scalars['numeric']['output']>;
  pump_wear_brake_horsepower_correction_ratio?: Maybe<Scalars['numeric']['output']>;
  pump_wear_head_correction_ratio?: Maybe<Scalars['numeric']['output']>;
  surface_drive_incoming_power_volts?: Maybe<Scalars['numeric']['output']>;
  target_liquid_rate_std_barrel_day?: Maybe<Scalars['numeric']['output']>;
  use_legacy_gas_head_rerate?: Maybe<Scalars['Boolean']['output']>;
  vsd_input_voltage?: Maybe<Scalars['numeric']['output']>;
  winning_revision_author_id?: Maybe<Scalars['String']['output']>;
  winning_revision_created_at?: Maybe<Scalars['timestamptz']['output']>;
  winning_revision_deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  winning_revision_id?: Maybe<Scalars['uuid']['output']>;
  winning_revision_parent_id?: Maybe<Scalars['uuid']['output']>;
  winning_revision_updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregated selection of "scenario_parameters" */
export type Scenario_Parameters_Aggregate = {
  __typename: 'scenario_parameters_aggregate';
  aggregate?: Maybe<Scenario_Parameters_Aggregate_Fields>;
  nodes: Array<Scenario_Parameters>;
};

/** aggregate fields of "scenario_parameters" */
export type Scenario_Parameters_Aggregate_Fields = {
  __typename: 'scenario_parameters_aggregate_fields';
  avg?: Maybe<Scenario_Parameters_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Scenario_Parameters_Max_Fields>;
  min?: Maybe<Scenario_Parameters_Min_Fields>;
  stddev?: Maybe<Scenario_Parameters_Stddev_Fields>;
  stddev_pop?: Maybe<Scenario_Parameters_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Scenario_Parameters_Stddev_Samp_Fields>;
  sum?: Maybe<Scenario_Parameters_Sum_Fields>;
  var_pop?: Maybe<Scenario_Parameters_Var_Pop_Fields>;
  var_samp?: Maybe<Scenario_Parameters_Var_Samp_Fields>;
  variance?: Maybe<Scenario_Parameters_Variance_Fields>;
};


/** aggregate fields of "scenario_parameters" */
export type Scenario_Parameters_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Scenario_Parameters_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Scenario_Parameters_Avg_Fields = {
  __typename: 'scenario_parameters_avg_fields';
  bottom_casing_pressure_psia?: Maybe<Scalars['Float']['output']>;
  bottom_tubing_pressure_psia?: Maybe<Scalars['Float']['output']>;
  cable_cost_kw_hr_usd?: Maybe<Scalars['Float']['output']>;
  elevation_feet_asl?: Maybe<Scalars['Float']['output']>;
  intake_override_gas_separation_percent?: Maybe<Scalars['Float']['output']>;
  lower_intake_override_gas_separation_percent?: Maybe<Scalars['Float']['output']>;
  lower_motor_rerate_ratio?: Maybe<Scalars['Float']['output']>;
  lower_motor_shroud_interior_diameter_inches?: Maybe<Scalars['Float']['output']>;
  lower_natural_override_gas_separation_percent?: Maybe<Scalars['Float']['output']>;
  lower_pump_hz?: Maybe<Scalars['Float']['output']>;
  lower_pump_override_gas_correction_percent?: Maybe<Scalars['Float']['output']>;
  lower_pump_wear_brake_horsepower_correction_ratio?: Maybe<Scalars['Float']['output']>;
  lower_pump_wear_head_correction_ratio?: Maybe<Scalars['Float']['output']>;
  maximum_frequency?: Maybe<Scalars['Float']['output']>;
  minimum_frequency?: Maybe<Scalars['Float']['output']>;
  motor_rerate_ratio?: Maybe<Scalars['Float']['output']>;
  motor_shroud_interior_diameter_inches?: Maybe<Scalars['Float']['output']>;
  natural_override_gas_separation_percent?: Maybe<Scalars['Float']['output']>;
  pump_hz?: Maybe<Scalars['Float']['output']>;
  pump_override_gas_correction_percent?: Maybe<Scalars['Float']['output']>;
  pump_wear_brake_horsepower_correction_ratio?: Maybe<Scalars['Float']['output']>;
  pump_wear_head_correction_ratio?: Maybe<Scalars['Float']['output']>;
  surface_drive_incoming_power_volts?: Maybe<Scalars['Float']['output']>;
  target_liquid_rate_std_barrel_day?: Maybe<Scalars['Float']['output']>;
  vsd_input_voltage?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "scenario_parameters". All fields are combined with a logical 'AND'. */
export type Scenario_Parameters_Bool_Exp = {
  _and?: InputMaybe<Array<Scenario_Parameters_Bool_Exp>>;
  _not?: InputMaybe<Scenario_Parameters_Bool_Exp>;
  _or?: InputMaybe<Array<Scenario_Parameters_Bool_Exp>>;
  bottom_casing_pressure_psia?: InputMaybe<Numeric_Comparison_Exp>;
  bottom_tubing_pressure_psia?: InputMaybe<Numeric_Comparison_Exp>;
  cable_cost_kw_hr_usd?: InputMaybe<Numeric_Comparison_Exp>;
  elevation_feet_asl?: InputMaybe<Numeric_Comparison_Exp>;
  flow_model?: InputMaybe<String_Comparison_Exp>;
  has_compression_pump?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  include_casing_friction_loss?: InputMaybe<Boolean_Comparison_Exp>;
  intake_gas_separation_override_type?: InputMaybe<String_Comparison_Exp>;
  intake_override_gas_separation_percent?: InputMaybe<Numeric_Comparison_Exp>;
  intake_packer_installed?: InputMaybe<Boolean_Comparison_Exp>;
  journal_author_id?: InputMaybe<String_Comparison_Exp>;
  journal_created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  journal_deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  journal_updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  lower_has_compression_pump?: InputMaybe<Boolean_Comparison_Exp>;
  lower_include_casing_friction_loss?: InputMaybe<Boolean_Comparison_Exp>;
  lower_intake_gas_separation_override_type?: InputMaybe<String_Comparison_Exp>;
  lower_intake_override_gas_separation_percent?: InputMaybe<Numeric_Comparison_Exp>;
  lower_intake_packer_installed?: InputMaybe<Boolean_Comparison_Exp>;
  lower_motor_rerate_ratio?: InputMaybe<Numeric_Comparison_Exp>;
  lower_motor_shroud_interior_diameter_inches?: InputMaybe<Numeric_Comparison_Exp>;
  lower_natural_gas_separation_override_type?: InputMaybe<String_Comparison_Exp>;
  lower_natural_override_gas_separation_percent?: InputMaybe<Numeric_Comparison_Exp>;
  lower_pump_hz?: InputMaybe<Numeric_Comparison_Exp>;
  lower_pump_override_gas_correction_percent?: InputMaybe<Numeric_Comparison_Exp>;
  lower_pump_wear_brake_horsepower_correction_ratio?: InputMaybe<Numeric_Comparison_Exp>;
  lower_pump_wear_head_correction_ratio?: InputMaybe<Numeric_Comparison_Exp>;
  lower_use_legacy_gas_head_rerate?: InputMaybe<Boolean_Comparison_Exp>;
  maximum_frequency?: InputMaybe<Numeric_Comparison_Exp>;
  minimum_frequency?: InputMaybe<Numeric_Comparison_Exp>;
  motor_rerate_ratio?: InputMaybe<Numeric_Comparison_Exp>;
  motor_shroud_interior_diameter_inches?: InputMaybe<Numeric_Comparison_Exp>;
  natural_gas_separation_override_type?: InputMaybe<String_Comparison_Exp>;
  natural_override_gas_separation_percent?: InputMaybe<Numeric_Comparison_Exp>;
  parent_id?: InputMaybe<Uuid_Comparison_Exp>;
  pump_hz?: InputMaybe<Numeric_Comparison_Exp>;
  pump_override_gas_correction_percent?: InputMaybe<Numeric_Comparison_Exp>;
  pump_wear_brake_horsepower_correction_ratio?: InputMaybe<Numeric_Comparison_Exp>;
  pump_wear_head_correction_ratio?: InputMaybe<Numeric_Comparison_Exp>;
  surface_drive_incoming_power_volts?: InputMaybe<Numeric_Comparison_Exp>;
  target_liquid_rate_std_barrel_day?: InputMaybe<Numeric_Comparison_Exp>;
  use_legacy_gas_head_rerate?: InputMaybe<Boolean_Comparison_Exp>;
  vsd_input_voltage?: InputMaybe<Numeric_Comparison_Exp>;
  winning_revision_author_id?: InputMaybe<String_Comparison_Exp>;
  winning_revision_created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  winning_revision_deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  winning_revision_id?: InputMaybe<Uuid_Comparison_Exp>;
  winning_revision_parent_id?: InputMaybe<Uuid_Comparison_Exp>;
  winning_revision_updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** input type for inserting data into table "scenario_parameters" */
export type Scenario_Parameters_Insert_Input = {
  bottom_casing_pressure_psia?: InputMaybe<Scalars['numeric']['input']>;
  bottom_tubing_pressure_psia?: InputMaybe<Scalars['numeric']['input']>;
  cable_cost_kw_hr_usd?: InputMaybe<Scalars['numeric']['input']>;
  elevation_feet_asl?: InputMaybe<Scalars['numeric']['input']>;
  flow_model?: InputMaybe<Scalars['String']['input']>;
  has_compression_pump?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  include_casing_friction_loss?: InputMaybe<Scalars['Boolean']['input']>;
  intake_gas_separation_override_type?: InputMaybe<Scalars['String']['input']>;
  intake_override_gas_separation_percent?: InputMaybe<Scalars['numeric']['input']>;
  intake_packer_installed?: InputMaybe<Scalars['Boolean']['input']>;
  journal_author_id?: InputMaybe<Scalars['String']['input']>;
  journal_created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  journal_deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  journal_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  lower_has_compression_pump?: InputMaybe<Scalars['Boolean']['input']>;
  lower_include_casing_friction_loss?: InputMaybe<Scalars['Boolean']['input']>;
  lower_intake_gas_separation_override_type?: InputMaybe<Scalars['String']['input']>;
  lower_intake_override_gas_separation_percent?: InputMaybe<Scalars['numeric']['input']>;
  lower_intake_packer_installed?: InputMaybe<Scalars['Boolean']['input']>;
  lower_motor_rerate_ratio?: InputMaybe<Scalars['numeric']['input']>;
  lower_motor_shroud_interior_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  lower_natural_gas_separation_override_type?: InputMaybe<Scalars['String']['input']>;
  lower_natural_override_gas_separation_percent?: InputMaybe<Scalars['numeric']['input']>;
  lower_pump_hz?: InputMaybe<Scalars['numeric']['input']>;
  lower_pump_override_gas_correction_percent?: InputMaybe<Scalars['numeric']['input']>;
  lower_pump_wear_brake_horsepower_correction_ratio?: InputMaybe<Scalars['numeric']['input']>;
  lower_pump_wear_head_correction_ratio?: InputMaybe<Scalars['numeric']['input']>;
  lower_use_legacy_gas_head_rerate?: InputMaybe<Scalars['Boolean']['input']>;
  maximum_frequency?: InputMaybe<Scalars['numeric']['input']>;
  minimum_frequency?: InputMaybe<Scalars['numeric']['input']>;
  motor_rerate_ratio?: InputMaybe<Scalars['numeric']['input']>;
  motor_shroud_interior_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  natural_gas_separation_override_type?: InputMaybe<Scalars['String']['input']>;
  natural_override_gas_separation_percent?: InputMaybe<Scalars['numeric']['input']>;
  parent_id?: InputMaybe<Scalars['uuid']['input']>;
  pump_hz?: InputMaybe<Scalars['numeric']['input']>;
  pump_override_gas_correction_percent?: InputMaybe<Scalars['numeric']['input']>;
  pump_wear_brake_horsepower_correction_ratio?: InputMaybe<Scalars['numeric']['input']>;
  pump_wear_head_correction_ratio?: InputMaybe<Scalars['numeric']['input']>;
  surface_drive_incoming_power_volts?: InputMaybe<Scalars['numeric']['input']>;
  target_liquid_rate_std_barrel_day?: InputMaybe<Scalars['numeric']['input']>;
  use_legacy_gas_head_rerate?: InputMaybe<Scalars['Boolean']['input']>;
  vsd_input_voltage?: InputMaybe<Scalars['numeric']['input']>;
  winning_revision_author_id?: InputMaybe<Scalars['String']['input']>;
  winning_revision_created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  winning_revision_deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  winning_revision_id?: InputMaybe<Scalars['uuid']['input']>;
  winning_revision_parent_id?: InputMaybe<Scalars['uuid']['input']>;
  winning_revision_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Scenario_Parameters_Max_Fields = {
  __typename: 'scenario_parameters_max_fields';
  bottom_casing_pressure_psia?: Maybe<Scalars['numeric']['output']>;
  bottom_tubing_pressure_psia?: Maybe<Scalars['numeric']['output']>;
  cable_cost_kw_hr_usd?: Maybe<Scalars['numeric']['output']>;
  elevation_feet_asl?: Maybe<Scalars['numeric']['output']>;
  flow_model?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  intake_gas_separation_override_type?: Maybe<Scalars['String']['output']>;
  intake_override_gas_separation_percent?: Maybe<Scalars['numeric']['output']>;
  journal_author_id?: Maybe<Scalars['String']['output']>;
  journal_created_at?: Maybe<Scalars['timestamptz']['output']>;
  journal_deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  journal_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  lower_intake_gas_separation_override_type?: Maybe<Scalars['String']['output']>;
  lower_intake_override_gas_separation_percent?: Maybe<Scalars['numeric']['output']>;
  lower_motor_rerate_ratio?: Maybe<Scalars['numeric']['output']>;
  lower_motor_shroud_interior_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  lower_natural_gas_separation_override_type?: Maybe<Scalars['String']['output']>;
  lower_natural_override_gas_separation_percent?: Maybe<Scalars['numeric']['output']>;
  lower_pump_hz?: Maybe<Scalars['numeric']['output']>;
  lower_pump_override_gas_correction_percent?: Maybe<Scalars['numeric']['output']>;
  lower_pump_wear_brake_horsepower_correction_ratio?: Maybe<Scalars['numeric']['output']>;
  lower_pump_wear_head_correction_ratio?: Maybe<Scalars['numeric']['output']>;
  maximum_frequency?: Maybe<Scalars['numeric']['output']>;
  minimum_frequency?: Maybe<Scalars['numeric']['output']>;
  motor_rerate_ratio?: Maybe<Scalars['numeric']['output']>;
  motor_shroud_interior_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  natural_gas_separation_override_type?: Maybe<Scalars['String']['output']>;
  natural_override_gas_separation_percent?: Maybe<Scalars['numeric']['output']>;
  parent_id?: Maybe<Scalars['uuid']['output']>;
  pump_hz?: Maybe<Scalars['numeric']['output']>;
  pump_override_gas_correction_percent?: Maybe<Scalars['numeric']['output']>;
  pump_wear_brake_horsepower_correction_ratio?: Maybe<Scalars['numeric']['output']>;
  pump_wear_head_correction_ratio?: Maybe<Scalars['numeric']['output']>;
  surface_drive_incoming_power_volts?: Maybe<Scalars['numeric']['output']>;
  target_liquid_rate_std_barrel_day?: Maybe<Scalars['numeric']['output']>;
  vsd_input_voltage?: Maybe<Scalars['numeric']['output']>;
  winning_revision_author_id?: Maybe<Scalars['String']['output']>;
  winning_revision_created_at?: Maybe<Scalars['timestamptz']['output']>;
  winning_revision_deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  winning_revision_id?: Maybe<Scalars['uuid']['output']>;
  winning_revision_parent_id?: Maybe<Scalars['uuid']['output']>;
  winning_revision_updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Scenario_Parameters_Min_Fields = {
  __typename: 'scenario_parameters_min_fields';
  bottom_casing_pressure_psia?: Maybe<Scalars['numeric']['output']>;
  bottom_tubing_pressure_psia?: Maybe<Scalars['numeric']['output']>;
  cable_cost_kw_hr_usd?: Maybe<Scalars['numeric']['output']>;
  elevation_feet_asl?: Maybe<Scalars['numeric']['output']>;
  flow_model?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  intake_gas_separation_override_type?: Maybe<Scalars['String']['output']>;
  intake_override_gas_separation_percent?: Maybe<Scalars['numeric']['output']>;
  journal_author_id?: Maybe<Scalars['String']['output']>;
  journal_created_at?: Maybe<Scalars['timestamptz']['output']>;
  journal_deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  journal_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  lower_intake_gas_separation_override_type?: Maybe<Scalars['String']['output']>;
  lower_intake_override_gas_separation_percent?: Maybe<Scalars['numeric']['output']>;
  lower_motor_rerate_ratio?: Maybe<Scalars['numeric']['output']>;
  lower_motor_shroud_interior_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  lower_natural_gas_separation_override_type?: Maybe<Scalars['String']['output']>;
  lower_natural_override_gas_separation_percent?: Maybe<Scalars['numeric']['output']>;
  lower_pump_hz?: Maybe<Scalars['numeric']['output']>;
  lower_pump_override_gas_correction_percent?: Maybe<Scalars['numeric']['output']>;
  lower_pump_wear_brake_horsepower_correction_ratio?: Maybe<Scalars['numeric']['output']>;
  lower_pump_wear_head_correction_ratio?: Maybe<Scalars['numeric']['output']>;
  maximum_frequency?: Maybe<Scalars['numeric']['output']>;
  minimum_frequency?: Maybe<Scalars['numeric']['output']>;
  motor_rerate_ratio?: Maybe<Scalars['numeric']['output']>;
  motor_shroud_interior_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  natural_gas_separation_override_type?: Maybe<Scalars['String']['output']>;
  natural_override_gas_separation_percent?: Maybe<Scalars['numeric']['output']>;
  parent_id?: Maybe<Scalars['uuid']['output']>;
  pump_hz?: Maybe<Scalars['numeric']['output']>;
  pump_override_gas_correction_percent?: Maybe<Scalars['numeric']['output']>;
  pump_wear_brake_horsepower_correction_ratio?: Maybe<Scalars['numeric']['output']>;
  pump_wear_head_correction_ratio?: Maybe<Scalars['numeric']['output']>;
  surface_drive_incoming_power_volts?: Maybe<Scalars['numeric']['output']>;
  target_liquid_rate_std_barrel_day?: Maybe<Scalars['numeric']['output']>;
  vsd_input_voltage?: Maybe<Scalars['numeric']['output']>;
  winning_revision_author_id?: Maybe<Scalars['String']['output']>;
  winning_revision_created_at?: Maybe<Scalars['timestamptz']['output']>;
  winning_revision_deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  winning_revision_id?: Maybe<Scalars['uuid']['output']>;
  winning_revision_parent_id?: Maybe<Scalars['uuid']['output']>;
  winning_revision_updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** input type for inserting object relation for remote table "scenario_parameters" */
export type Scenario_Parameters_Obj_Rel_Insert_Input = {
  data: Scenario_Parameters_Insert_Input;
};

/** Ordering options when selecting data from "scenario_parameters". */
export type Scenario_Parameters_Order_By = {
  bottom_casing_pressure_psia?: InputMaybe<Order_By>;
  bottom_tubing_pressure_psia?: InputMaybe<Order_By>;
  cable_cost_kw_hr_usd?: InputMaybe<Order_By>;
  elevation_feet_asl?: InputMaybe<Order_By>;
  flow_model?: InputMaybe<Order_By>;
  has_compression_pump?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  include_casing_friction_loss?: InputMaybe<Order_By>;
  intake_gas_separation_override_type?: InputMaybe<Order_By>;
  intake_override_gas_separation_percent?: InputMaybe<Order_By>;
  intake_packer_installed?: InputMaybe<Order_By>;
  journal_author_id?: InputMaybe<Order_By>;
  journal_created_at?: InputMaybe<Order_By>;
  journal_deleted_at?: InputMaybe<Order_By>;
  journal_updated_at?: InputMaybe<Order_By>;
  lower_has_compression_pump?: InputMaybe<Order_By>;
  lower_include_casing_friction_loss?: InputMaybe<Order_By>;
  lower_intake_gas_separation_override_type?: InputMaybe<Order_By>;
  lower_intake_override_gas_separation_percent?: InputMaybe<Order_By>;
  lower_intake_packer_installed?: InputMaybe<Order_By>;
  lower_motor_rerate_ratio?: InputMaybe<Order_By>;
  lower_motor_shroud_interior_diameter_inches?: InputMaybe<Order_By>;
  lower_natural_gas_separation_override_type?: InputMaybe<Order_By>;
  lower_natural_override_gas_separation_percent?: InputMaybe<Order_By>;
  lower_pump_hz?: InputMaybe<Order_By>;
  lower_pump_override_gas_correction_percent?: InputMaybe<Order_By>;
  lower_pump_wear_brake_horsepower_correction_ratio?: InputMaybe<Order_By>;
  lower_pump_wear_head_correction_ratio?: InputMaybe<Order_By>;
  lower_use_legacy_gas_head_rerate?: InputMaybe<Order_By>;
  maximum_frequency?: InputMaybe<Order_By>;
  minimum_frequency?: InputMaybe<Order_By>;
  motor_rerate_ratio?: InputMaybe<Order_By>;
  motor_shroud_interior_diameter_inches?: InputMaybe<Order_By>;
  natural_gas_separation_override_type?: InputMaybe<Order_By>;
  natural_override_gas_separation_percent?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  pump_hz?: InputMaybe<Order_By>;
  pump_override_gas_correction_percent?: InputMaybe<Order_By>;
  pump_wear_brake_horsepower_correction_ratio?: InputMaybe<Order_By>;
  pump_wear_head_correction_ratio?: InputMaybe<Order_By>;
  surface_drive_incoming_power_volts?: InputMaybe<Order_By>;
  target_liquid_rate_std_barrel_day?: InputMaybe<Order_By>;
  use_legacy_gas_head_rerate?: InputMaybe<Order_By>;
  vsd_input_voltage?: InputMaybe<Order_By>;
  winning_revision_author_id?: InputMaybe<Order_By>;
  winning_revision_created_at?: InputMaybe<Order_By>;
  winning_revision_deleted_at?: InputMaybe<Order_By>;
  winning_revision_id?: InputMaybe<Order_By>;
  winning_revision_parent_id?: InputMaybe<Order_By>;
  winning_revision_updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "scenario_parameters" */
export enum Scenario_Parameters_Select_Column {
  /** column name */
  BottomCasingPressurePsia = 'bottom_casing_pressure_psia',
  /** column name */
  BottomTubingPressurePsia = 'bottom_tubing_pressure_psia',
  /** column name */
  CableCostKwHrUsd = 'cable_cost_kw_hr_usd',
  /** column name */
  ElevationFeetAsl = 'elevation_feet_asl',
  /** column name */
  FlowModel = 'flow_model',
  /** column name */
  HasCompressionPump = 'has_compression_pump',
  /** column name */
  Id = 'id',
  /** column name */
  IncludeCasingFrictionLoss = 'include_casing_friction_loss',
  /** column name */
  IntakeGasSeparationOverrideType = 'intake_gas_separation_override_type',
  /** column name */
  IntakeOverrideGasSeparationPercent = 'intake_override_gas_separation_percent',
  /** column name */
  IntakePackerInstalled = 'intake_packer_installed',
  /** column name */
  JournalAuthorId = 'journal_author_id',
  /** column name */
  JournalCreatedAt = 'journal_created_at',
  /** column name */
  JournalDeletedAt = 'journal_deleted_at',
  /** column name */
  JournalUpdatedAt = 'journal_updated_at',
  /** column name */
  LowerHasCompressionPump = 'lower_has_compression_pump',
  /** column name */
  LowerIncludeCasingFrictionLoss = 'lower_include_casing_friction_loss',
  /** column name */
  LowerIntakeGasSeparationOverrideType = 'lower_intake_gas_separation_override_type',
  /** column name */
  LowerIntakeOverrideGasSeparationPercent = 'lower_intake_override_gas_separation_percent',
  /** column name */
  LowerIntakePackerInstalled = 'lower_intake_packer_installed',
  /** column name */
  LowerMotorRerateRatio = 'lower_motor_rerate_ratio',
  /** column name */
  LowerMotorShroudInteriorDiameterInches = 'lower_motor_shroud_interior_diameter_inches',
  /** column name */
  LowerNaturalGasSeparationOverrideType = 'lower_natural_gas_separation_override_type',
  /** column name */
  LowerNaturalOverrideGasSeparationPercent = 'lower_natural_override_gas_separation_percent',
  /** column name */
  LowerPumpHz = 'lower_pump_hz',
  /** column name */
  LowerPumpOverrideGasCorrectionPercent = 'lower_pump_override_gas_correction_percent',
  /** column name */
  LowerPumpWearBrakeHorsepowerCorrectionRatio = 'lower_pump_wear_brake_horsepower_correction_ratio',
  /** column name */
  LowerPumpWearHeadCorrectionRatio = 'lower_pump_wear_head_correction_ratio',
  /** column name */
  LowerUseLegacyGasHeadRerate = 'lower_use_legacy_gas_head_rerate',
  /** column name */
  MaximumFrequency = 'maximum_frequency',
  /** column name */
  MinimumFrequency = 'minimum_frequency',
  /** column name */
  MotorRerateRatio = 'motor_rerate_ratio',
  /** column name */
  MotorShroudInteriorDiameterInches = 'motor_shroud_interior_diameter_inches',
  /** column name */
  NaturalGasSeparationOverrideType = 'natural_gas_separation_override_type',
  /** column name */
  NaturalOverrideGasSeparationPercent = 'natural_override_gas_separation_percent',
  /** column name */
  ParentId = 'parent_id',
  /** column name */
  PumpHz = 'pump_hz',
  /** column name */
  PumpOverrideGasCorrectionPercent = 'pump_override_gas_correction_percent',
  /** column name */
  PumpWearBrakeHorsepowerCorrectionRatio = 'pump_wear_brake_horsepower_correction_ratio',
  /** column name */
  PumpWearHeadCorrectionRatio = 'pump_wear_head_correction_ratio',
  /** column name */
  SurfaceDriveIncomingPowerVolts = 'surface_drive_incoming_power_volts',
  /** column name */
  TargetLiquidRateStdBarrelDay = 'target_liquid_rate_std_barrel_day',
  /** column name */
  UseLegacyGasHeadRerate = 'use_legacy_gas_head_rerate',
  /** column name */
  VsdInputVoltage = 'vsd_input_voltage',
  /** column name */
  WinningRevisionAuthorId = 'winning_revision_author_id',
  /** column name */
  WinningRevisionCreatedAt = 'winning_revision_created_at',
  /** column name */
  WinningRevisionDeletedAt = 'winning_revision_deleted_at',
  /** column name */
  WinningRevisionId = 'winning_revision_id',
  /** column name */
  WinningRevisionParentId = 'winning_revision_parent_id',
  /** column name */
  WinningRevisionUpdatedAt = 'winning_revision_updated_at'
}

/** aggregate stddev on columns */
export type Scenario_Parameters_Stddev_Fields = {
  __typename: 'scenario_parameters_stddev_fields';
  bottom_casing_pressure_psia?: Maybe<Scalars['Float']['output']>;
  bottom_tubing_pressure_psia?: Maybe<Scalars['Float']['output']>;
  cable_cost_kw_hr_usd?: Maybe<Scalars['Float']['output']>;
  elevation_feet_asl?: Maybe<Scalars['Float']['output']>;
  intake_override_gas_separation_percent?: Maybe<Scalars['Float']['output']>;
  lower_intake_override_gas_separation_percent?: Maybe<Scalars['Float']['output']>;
  lower_motor_rerate_ratio?: Maybe<Scalars['Float']['output']>;
  lower_motor_shroud_interior_diameter_inches?: Maybe<Scalars['Float']['output']>;
  lower_natural_override_gas_separation_percent?: Maybe<Scalars['Float']['output']>;
  lower_pump_hz?: Maybe<Scalars['Float']['output']>;
  lower_pump_override_gas_correction_percent?: Maybe<Scalars['Float']['output']>;
  lower_pump_wear_brake_horsepower_correction_ratio?: Maybe<Scalars['Float']['output']>;
  lower_pump_wear_head_correction_ratio?: Maybe<Scalars['Float']['output']>;
  maximum_frequency?: Maybe<Scalars['Float']['output']>;
  minimum_frequency?: Maybe<Scalars['Float']['output']>;
  motor_rerate_ratio?: Maybe<Scalars['Float']['output']>;
  motor_shroud_interior_diameter_inches?: Maybe<Scalars['Float']['output']>;
  natural_override_gas_separation_percent?: Maybe<Scalars['Float']['output']>;
  pump_hz?: Maybe<Scalars['Float']['output']>;
  pump_override_gas_correction_percent?: Maybe<Scalars['Float']['output']>;
  pump_wear_brake_horsepower_correction_ratio?: Maybe<Scalars['Float']['output']>;
  pump_wear_head_correction_ratio?: Maybe<Scalars['Float']['output']>;
  surface_drive_incoming_power_volts?: Maybe<Scalars['Float']['output']>;
  target_liquid_rate_std_barrel_day?: Maybe<Scalars['Float']['output']>;
  vsd_input_voltage?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Scenario_Parameters_Stddev_Pop_Fields = {
  __typename: 'scenario_parameters_stddev_pop_fields';
  bottom_casing_pressure_psia?: Maybe<Scalars['Float']['output']>;
  bottom_tubing_pressure_psia?: Maybe<Scalars['Float']['output']>;
  cable_cost_kw_hr_usd?: Maybe<Scalars['Float']['output']>;
  elevation_feet_asl?: Maybe<Scalars['Float']['output']>;
  intake_override_gas_separation_percent?: Maybe<Scalars['Float']['output']>;
  lower_intake_override_gas_separation_percent?: Maybe<Scalars['Float']['output']>;
  lower_motor_rerate_ratio?: Maybe<Scalars['Float']['output']>;
  lower_motor_shroud_interior_diameter_inches?: Maybe<Scalars['Float']['output']>;
  lower_natural_override_gas_separation_percent?: Maybe<Scalars['Float']['output']>;
  lower_pump_hz?: Maybe<Scalars['Float']['output']>;
  lower_pump_override_gas_correction_percent?: Maybe<Scalars['Float']['output']>;
  lower_pump_wear_brake_horsepower_correction_ratio?: Maybe<Scalars['Float']['output']>;
  lower_pump_wear_head_correction_ratio?: Maybe<Scalars['Float']['output']>;
  maximum_frequency?: Maybe<Scalars['Float']['output']>;
  minimum_frequency?: Maybe<Scalars['Float']['output']>;
  motor_rerate_ratio?: Maybe<Scalars['Float']['output']>;
  motor_shroud_interior_diameter_inches?: Maybe<Scalars['Float']['output']>;
  natural_override_gas_separation_percent?: Maybe<Scalars['Float']['output']>;
  pump_hz?: Maybe<Scalars['Float']['output']>;
  pump_override_gas_correction_percent?: Maybe<Scalars['Float']['output']>;
  pump_wear_brake_horsepower_correction_ratio?: Maybe<Scalars['Float']['output']>;
  pump_wear_head_correction_ratio?: Maybe<Scalars['Float']['output']>;
  surface_drive_incoming_power_volts?: Maybe<Scalars['Float']['output']>;
  target_liquid_rate_std_barrel_day?: Maybe<Scalars['Float']['output']>;
  vsd_input_voltage?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Scenario_Parameters_Stddev_Samp_Fields = {
  __typename: 'scenario_parameters_stddev_samp_fields';
  bottom_casing_pressure_psia?: Maybe<Scalars['Float']['output']>;
  bottom_tubing_pressure_psia?: Maybe<Scalars['Float']['output']>;
  cable_cost_kw_hr_usd?: Maybe<Scalars['Float']['output']>;
  elevation_feet_asl?: Maybe<Scalars['Float']['output']>;
  intake_override_gas_separation_percent?: Maybe<Scalars['Float']['output']>;
  lower_intake_override_gas_separation_percent?: Maybe<Scalars['Float']['output']>;
  lower_motor_rerate_ratio?: Maybe<Scalars['Float']['output']>;
  lower_motor_shroud_interior_diameter_inches?: Maybe<Scalars['Float']['output']>;
  lower_natural_override_gas_separation_percent?: Maybe<Scalars['Float']['output']>;
  lower_pump_hz?: Maybe<Scalars['Float']['output']>;
  lower_pump_override_gas_correction_percent?: Maybe<Scalars['Float']['output']>;
  lower_pump_wear_brake_horsepower_correction_ratio?: Maybe<Scalars['Float']['output']>;
  lower_pump_wear_head_correction_ratio?: Maybe<Scalars['Float']['output']>;
  maximum_frequency?: Maybe<Scalars['Float']['output']>;
  minimum_frequency?: Maybe<Scalars['Float']['output']>;
  motor_rerate_ratio?: Maybe<Scalars['Float']['output']>;
  motor_shroud_interior_diameter_inches?: Maybe<Scalars['Float']['output']>;
  natural_override_gas_separation_percent?: Maybe<Scalars['Float']['output']>;
  pump_hz?: Maybe<Scalars['Float']['output']>;
  pump_override_gas_correction_percent?: Maybe<Scalars['Float']['output']>;
  pump_wear_brake_horsepower_correction_ratio?: Maybe<Scalars['Float']['output']>;
  pump_wear_head_correction_ratio?: Maybe<Scalars['Float']['output']>;
  surface_drive_incoming_power_volts?: Maybe<Scalars['Float']['output']>;
  target_liquid_rate_std_barrel_day?: Maybe<Scalars['Float']['output']>;
  vsd_input_voltage?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "scenario_parameters" */
export type Scenario_Parameters_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Scenario_Parameters_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Scenario_Parameters_Stream_Cursor_Value_Input = {
  bottom_casing_pressure_psia?: InputMaybe<Scalars['numeric']['input']>;
  bottom_tubing_pressure_psia?: InputMaybe<Scalars['numeric']['input']>;
  cable_cost_kw_hr_usd?: InputMaybe<Scalars['numeric']['input']>;
  elevation_feet_asl?: InputMaybe<Scalars['numeric']['input']>;
  flow_model?: InputMaybe<Scalars['String']['input']>;
  has_compression_pump?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  include_casing_friction_loss?: InputMaybe<Scalars['Boolean']['input']>;
  intake_gas_separation_override_type?: InputMaybe<Scalars['String']['input']>;
  intake_override_gas_separation_percent?: InputMaybe<Scalars['numeric']['input']>;
  intake_packer_installed?: InputMaybe<Scalars['Boolean']['input']>;
  journal_author_id?: InputMaybe<Scalars['String']['input']>;
  journal_created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  journal_deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  journal_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  lower_has_compression_pump?: InputMaybe<Scalars['Boolean']['input']>;
  lower_include_casing_friction_loss?: InputMaybe<Scalars['Boolean']['input']>;
  lower_intake_gas_separation_override_type?: InputMaybe<Scalars['String']['input']>;
  lower_intake_override_gas_separation_percent?: InputMaybe<Scalars['numeric']['input']>;
  lower_intake_packer_installed?: InputMaybe<Scalars['Boolean']['input']>;
  lower_motor_rerate_ratio?: InputMaybe<Scalars['numeric']['input']>;
  lower_motor_shroud_interior_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  lower_natural_gas_separation_override_type?: InputMaybe<Scalars['String']['input']>;
  lower_natural_override_gas_separation_percent?: InputMaybe<Scalars['numeric']['input']>;
  lower_pump_hz?: InputMaybe<Scalars['numeric']['input']>;
  lower_pump_override_gas_correction_percent?: InputMaybe<Scalars['numeric']['input']>;
  lower_pump_wear_brake_horsepower_correction_ratio?: InputMaybe<Scalars['numeric']['input']>;
  lower_pump_wear_head_correction_ratio?: InputMaybe<Scalars['numeric']['input']>;
  lower_use_legacy_gas_head_rerate?: InputMaybe<Scalars['Boolean']['input']>;
  maximum_frequency?: InputMaybe<Scalars['numeric']['input']>;
  minimum_frequency?: InputMaybe<Scalars['numeric']['input']>;
  motor_rerate_ratio?: InputMaybe<Scalars['numeric']['input']>;
  motor_shroud_interior_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  natural_gas_separation_override_type?: InputMaybe<Scalars['String']['input']>;
  natural_override_gas_separation_percent?: InputMaybe<Scalars['numeric']['input']>;
  parent_id?: InputMaybe<Scalars['uuid']['input']>;
  pump_hz?: InputMaybe<Scalars['numeric']['input']>;
  pump_override_gas_correction_percent?: InputMaybe<Scalars['numeric']['input']>;
  pump_wear_brake_horsepower_correction_ratio?: InputMaybe<Scalars['numeric']['input']>;
  pump_wear_head_correction_ratio?: InputMaybe<Scalars['numeric']['input']>;
  surface_drive_incoming_power_volts?: InputMaybe<Scalars['numeric']['input']>;
  target_liquid_rate_std_barrel_day?: InputMaybe<Scalars['numeric']['input']>;
  use_legacy_gas_head_rerate?: InputMaybe<Scalars['Boolean']['input']>;
  vsd_input_voltage?: InputMaybe<Scalars['numeric']['input']>;
  winning_revision_author_id?: InputMaybe<Scalars['String']['input']>;
  winning_revision_created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  winning_revision_deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  winning_revision_id?: InputMaybe<Scalars['uuid']['input']>;
  winning_revision_parent_id?: InputMaybe<Scalars['uuid']['input']>;
  winning_revision_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Scenario_Parameters_Sum_Fields = {
  __typename: 'scenario_parameters_sum_fields';
  bottom_casing_pressure_psia?: Maybe<Scalars['numeric']['output']>;
  bottom_tubing_pressure_psia?: Maybe<Scalars['numeric']['output']>;
  cable_cost_kw_hr_usd?: Maybe<Scalars['numeric']['output']>;
  elevation_feet_asl?: Maybe<Scalars['numeric']['output']>;
  intake_override_gas_separation_percent?: Maybe<Scalars['numeric']['output']>;
  lower_intake_override_gas_separation_percent?: Maybe<Scalars['numeric']['output']>;
  lower_motor_rerate_ratio?: Maybe<Scalars['numeric']['output']>;
  lower_motor_shroud_interior_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  lower_natural_override_gas_separation_percent?: Maybe<Scalars['numeric']['output']>;
  lower_pump_hz?: Maybe<Scalars['numeric']['output']>;
  lower_pump_override_gas_correction_percent?: Maybe<Scalars['numeric']['output']>;
  lower_pump_wear_brake_horsepower_correction_ratio?: Maybe<Scalars['numeric']['output']>;
  lower_pump_wear_head_correction_ratio?: Maybe<Scalars['numeric']['output']>;
  maximum_frequency?: Maybe<Scalars['numeric']['output']>;
  minimum_frequency?: Maybe<Scalars['numeric']['output']>;
  motor_rerate_ratio?: Maybe<Scalars['numeric']['output']>;
  motor_shroud_interior_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  natural_override_gas_separation_percent?: Maybe<Scalars['numeric']['output']>;
  pump_hz?: Maybe<Scalars['numeric']['output']>;
  pump_override_gas_correction_percent?: Maybe<Scalars['numeric']['output']>;
  pump_wear_brake_horsepower_correction_ratio?: Maybe<Scalars['numeric']['output']>;
  pump_wear_head_correction_ratio?: Maybe<Scalars['numeric']['output']>;
  surface_drive_incoming_power_volts?: Maybe<Scalars['numeric']['output']>;
  target_liquid_rate_std_barrel_day?: Maybe<Scalars['numeric']['output']>;
  vsd_input_voltage?: Maybe<Scalars['numeric']['output']>;
};

/** aggregate var_pop on columns */
export type Scenario_Parameters_Var_Pop_Fields = {
  __typename: 'scenario_parameters_var_pop_fields';
  bottom_casing_pressure_psia?: Maybe<Scalars['Float']['output']>;
  bottom_tubing_pressure_psia?: Maybe<Scalars['Float']['output']>;
  cable_cost_kw_hr_usd?: Maybe<Scalars['Float']['output']>;
  elevation_feet_asl?: Maybe<Scalars['Float']['output']>;
  intake_override_gas_separation_percent?: Maybe<Scalars['Float']['output']>;
  lower_intake_override_gas_separation_percent?: Maybe<Scalars['Float']['output']>;
  lower_motor_rerate_ratio?: Maybe<Scalars['Float']['output']>;
  lower_motor_shroud_interior_diameter_inches?: Maybe<Scalars['Float']['output']>;
  lower_natural_override_gas_separation_percent?: Maybe<Scalars['Float']['output']>;
  lower_pump_hz?: Maybe<Scalars['Float']['output']>;
  lower_pump_override_gas_correction_percent?: Maybe<Scalars['Float']['output']>;
  lower_pump_wear_brake_horsepower_correction_ratio?: Maybe<Scalars['Float']['output']>;
  lower_pump_wear_head_correction_ratio?: Maybe<Scalars['Float']['output']>;
  maximum_frequency?: Maybe<Scalars['Float']['output']>;
  minimum_frequency?: Maybe<Scalars['Float']['output']>;
  motor_rerate_ratio?: Maybe<Scalars['Float']['output']>;
  motor_shroud_interior_diameter_inches?: Maybe<Scalars['Float']['output']>;
  natural_override_gas_separation_percent?: Maybe<Scalars['Float']['output']>;
  pump_hz?: Maybe<Scalars['Float']['output']>;
  pump_override_gas_correction_percent?: Maybe<Scalars['Float']['output']>;
  pump_wear_brake_horsepower_correction_ratio?: Maybe<Scalars['Float']['output']>;
  pump_wear_head_correction_ratio?: Maybe<Scalars['Float']['output']>;
  surface_drive_incoming_power_volts?: Maybe<Scalars['Float']['output']>;
  target_liquid_rate_std_barrel_day?: Maybe<Scalars['Float']['output']>;
  vsd_input_voltage?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Scenario_Parameters_Var_Samp_Fields = {
  __typename: 'scenario_parameters_var_samp_fields';
  bottom_casing_pressure_psia?: Maybe<Scalars['Float']['output']>;
  bottom_tubing_pressure_psia?: Maybe<Scalars['Float']['output']>;
  cable_cost_kw_hr_usd?: Maybe<Scalars['Float']['output']>;
  elevation_feet_asl?: Maybe<Scalars['Float']['output']>;
  intake_override_gas_separation_percent?: Maybe<Scalars['Float']['output']>;
  lower_intake_override_gas_separation_percent?: Maybe<Scalars['Float']['output']>;
  lower_motor_rerate_ratio?: Maybe<Scalars['Float']['output']>;
  lower_motor_shroud_interior_diameter_inches?: Maybe<Scalars['Float']['output']>;
  lower_natural_override_gas_separation_percent?: Maybe<Scalars['Float']['output']>;
  lower_pump_hz?: Maybe<Scalars['Float']['output']>;
  lower_pump_override_gas_correction_percent?: Maybe<Scalars['Float']['output']>;
  lower_pump_wear_brake_horsepower_correction_ratio?: Maybe<Scalars['Float']['output']>;
  lower_pump_wear_head_correction_ratio?: Maybe<Scalars['Float']['output']>;
  maximum_frequency?: Maybe<Scalars['Float']['output']>;
  minimum_frequency?: Maybe<Scalars['Float']['output']>;
  motor_rerate_ratio?: Maybe<Scalars['Float']['output']>;
  motor_shroud_interior_diameter_inches?: Maybe<Scalars['Float']['output']>;
  natural_override_gas_separation_percent?: Maybe<Scalars['Float']['output']>;
  pump_hz?: Maybe<Scalars['Float']['output']>;
  pump_override_gas_correction_percent?: Maybe<Scalars['Float']['output']>;
  pump_wear_brake_horsepower_correction_ratio?: Maybe<Scalars['Float']['output']>;
  pump_wear_head_correction_ratio?: Maybe<Scalars['Float']['output']>;
  surface_drive_incoming_power_volts?: Maybe<Scalars['Float']['output']>;
  target_liquid_rate_std_barrel_day?: Maybe<Scalars['Float']['output']>;
  vsd_input_voltage?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Scenario_Parameters_Variance_Fields = {
  __typename: 'scenario_parameters_variance_fields';
  bottom_casing_pressure_psia?: Maybe<Scalars['Float']['output']>;
  bottom_tubing_pressure_psia?: Maybe<Scalars['Float']['output']>;
  cable_cost_kw_hr_usd?: Maybe<Scalars['Float']['output']>;
  elevation_feet_asl?: Maybe<Scalars['Float']['output']>;
  intake_override_gas_separation_percent?: Maybe<Scalars['Float']['output']>;
  lower_intake_override_gas_separation_percent?: Maybe<Scalars['Float']['output']>;
  lower_motor_rerate_ratio?: Maybe<Scalars['Float']['output']>;
  lower_motor_shroud_interior_diameter_inches?: Maybe<Scalars['Float']['output']>;
  lower_natural_override_gas_separation_percent?: Maybe<Scalars['Float']['output']>;
  lower_pump_hz?: Maybe<Scalars['Float']['output']>;
  lower_pump_override_gas_correction_percent?: Maybe<Scalars['Float']['output']>;
  lower_pump_wear_brake_horsepower_correction_ratio?: Maybe<Scalars['Float']['output']>;
  lower_pump_wear_head_correction_ratio?: Maybe<Scalars['Float']['output']>;
  maximum_frequency?: Maybe<Scalars['Float']['output']>;
  minimum_frequency?: Maybe<Scalars['Float']['output']>;
  motor_rerate_ratio?: Maybe<Scalars['Float']['output']>;
  motor_shroud_interior_diameter_inches?: Maybe<Scalars['Float']['output']>;
  natural_override_gas_separation_percent?: Maybe<Scalars['Float']['output']>;
  pump_hz?: Maybe<Scalars['Float']['output']>;
  pump_override_gas_correction_percent?: Maybe<Scalars['Float']['output']>;
  pump_wear_brake_horsepower_correction_ratio?: Maybe<Scalars['Float']['output']>;
  pump_wear_head_correction_ratio?: Maybe<Scalars['Float']['output']>;
  surface_drive_incoming_power_volts?: Maybe<Scalars['Float']['output']>;
  target_liquid_rate_std_barrel_day?: Maybe<Scalars['Float']['output']>;
  vsd_input_voltage?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "scenario_reasons" */
export type Scenario_Reasons = {
  __typename: 'scenario_reasons';
  comment?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

/** aggregated selection of "scenario_reasons" */
export type Scenario_Reasons_Aggregate = {
  __typename: 'scenario_reasons_aggregate';
  aggregate?: Maybe<Scenario_Reasons_Aggregate_Fields>;
  nodes: Array<Scenario_Reasons>;
};

/** aggregate fields of "scenario_reasons" */
export type Scenario_Reasons_Aggregate_Fields = {
  __typename: 'scenario_reasons_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Scenario_Reasons_Max_Fields>;
  min?: Maybe<Scenario_Reasons_Min_Fields>;
};


/** aggregate fields of "scenario_reasons" */
export type Scenario_Reasons_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Scenario_Reasons_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "scenario_reasons". All fields are combined with a logical 'AND'. */
export type Scenario_Reasons_Bool_Exp = {
  _and?: InputMaybe<Array<Scenario_Reasons_Bool_Exp>>;
  _not?: InputMaybe<Scenario_Reasons_Bool_Exp>;
  _or?: InputMaybe<Array<Scenario_Reasons_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "scenario_reasons" */
export enum Scenario_Reasons_Constraint {
  /** unique or primary key constraint on columns "value" */
  ScenarioReasonsPkey = 'scenario_reasons_pkey'
}

export enum Scenario_Reasons_Enum {
  /** Performance Evaluation */
  PerformanceEvaluation = 'performance_evaluation',
  /** Performance Evaluation (Legacy Only) */
  PerformanceEvaluationLegacy = 'performance_evaluation_legacy',
  /** Quote */
  Quote = 'quote',
  /** Resize (Legacy Only) */
  ResizeLegacy = 'resize_legacy',
  /** Tender */
  Tender = 'tender'
}

/** Boolean expression to compare columns of type "scenario_reasons_enum". All fields are combined with logical 'AND'. */
export type Scenario_Reasons_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Scenario_Reasons_Enum>;
  _in?: InputMaybe<Array<Scenario_Reasons_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Scenario_Reasons_Enum>;
  _nin?: InputMaybe<Array<Scenario_Reasons_Enum>>;
};

/** input type for inserting data into table "scenario_reasons" */
export type Scenario_Reasons_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Scenario_Reasons_Max_Fields = {
  __typename: 'scenario_reasons_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Scenario_Reasons_Min_Fields = {
  __typename: 'scenario_reasons_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "scenario_reasons" */
export type Scenario_Reasons_Mutation_Response = {
  __typename: 'scenario_reasons_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Scenario_Reasons>;
};

/** input type for inserting object relation for remote table "scenario_reasons" */
export type Scenario_Reasons_Obj_Rel_Insert_Input = {
  data: Scenario_Reasons_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Scenario_Reasons_On_Conflict>;
};

/** on_conflict condition type for table "scenario_reasons" */
export type Scenario_Reasons_On_Conflict = {
  constraint: Scenario_Reasons_Constraint;
  update_columns?: Array<Scenario_Reasons_Update_Column>;
  where?: InputMaybe<Scenario_Reasons_Bool_Exp>;
};

/** Ordering options when selecting data from "scenario_reasons". */
export type Scenario_Reasons_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: scenario_reasons */
export type Scenario_Reasons_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "scenario_reasons" */
export enum Scenario_Reasons_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "scenario_reasons" */
export type Scenario_Reasons_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "scenario_reasons" */
export type Scenario_Reasons_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Scenario_Reasons_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Scenario_Reasons_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "scenario_reasons" */
export enum Scenario_Reasons_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Scenario_Reasons_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Scenario_Reasons_Set_Input>;
  /** filter the rows which have to be updated */
  where: Scenario_Reasons_Bool_Exp;
};

/** columns and relationships of "scenario_well_properties" */
export type Scenario_Well_Properties = {
  __typename: 'scenario_well_properties';
  ar_percent?: Maybe<Scalars['numeric']['output']>;
  average_dls?: Maybe<Scalars['numeric']['output']>;
  /** An object relationship */
  bottom_casing?: Maybe<Casings>;
  bottom_casing_id?: Maybe<Scalars['uuid']['output']>;
  bottom_casing_length_feet?: Maybe<Scalars['numeric']['output']>;
  /** An object relationship */
  bottom_tubing?: Maybe<Tubings>;
  bottom_tubing_id?: Maybe<Scalars['uuid']['output']>;
  bottom_tubing_length_feet?: Maybe<Scalars['numeric']['output']>;
  bottomhole_temperature_fahrenheit?: Maybe<Scalars['numeric']['output']>;
  bubble_point_pressure_psia?: Maybe<Scalars['numeric']['output']>;
  c1_methane_percent?: Maybe<Scalars['numeric']['output']>;
  c2_ethane_percent?: Maybe<Scalars['numeric']['output']>;
  c3_propane_percent?: Maybe<Scalars['numeric']['output']>;
  c6_hexane_percent?: Maybe<Scalars['numeric']['output']>;
  c7_heptane_percent?: Maybe<Scalars['numeric']['output']>;
  co2_percent?: Maybe<Scalars['numeric']['output']>;
  condensate_api_override?: Maybe<Scalars['numeric']['output']>;
  custom_fluid_properties?: Maybe<Scalars['jsonb']['output']>;
  custom_viscosities_properties?: Maybe<Scalars['jsonb']['output']>;
  /** An object relationship */
  deviation_survey?: Maybe<Deviation_Survey>;
  deviation_survey_id?: Maybe<Scalars['uuid']['output']>;
  dew_point_pressure_psia_override?: Maybe<Scalars['numeric']['output']>;
  fluid_viscosity_override_cp?: Maybe<Scalars['numeric']['output']>;
  gas_specific_gravity?: Maybe<Scalars['numeric']['output']>;
  gas_type?: Maybe<Scalars['String']['output']>;
  h2s_percent?: Maybe<Scalars['numeric']['output']>;
  hps_liquid_type?: Maybe<Scalars['String']['output']>;
  hps_pump_inlet_pressure_psia?: Maybe<Scalars['numeric']['output']>;
  hps_pump_inlet_temperature_fahrenheit?: Maybe<Scalars['numeric']['output']>;
  hps_required_discharge_pressure_psia?: Maybe<Scalars['numeric']['output']>;
  ic4_isobutene_percent?: Maybe<Scalars['numeric']['output']>;
  ic5_isopentane_percent?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  journal_author_id?: Maybe<Scalars['String']['output']>;
  journal_created_at?: Maybe<Scalars['timestamptz']['output']>;
  journal_deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  journal_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  n2_percent?: Maybe<Scalars['numeric']['output']>;
  nc4_butane_percent?: Maybe<Scalars['numeric']['output']>;
  nc5_bentane_percent?: Maybe<Scalars['numeric']['output']>;
  npsha_ft?: Maybe<Scalars['numeric']['output']>;
  o2_percent?: Maybe<Scalars['numeric']['output']>;
  oil_gravity_api?: Maybe<Scalars['numeric']['output']>;
  parent_id?: Maybe<Scalars['uuid']['output']>;
  surface_temperature_fahrenheit?: Maybe<Scalars['numeric']['output']>;
  /** An object relationship */
  top_casing?: Maybe<Casings>;
  top_casing_id?: Maybe<Scalars['uuid']['output']>;
  top_casing_length_feet?: Maybe<Scalars['numeric']['output']>;
  top_of_perforations_measured_depth_feet?: Maybe<Scalars['numeric']['output']>;
  top_of_perforations_true_vertical_depth_feet?: Maybe<Scalars['numeric']['output']>;
  /** An object relationship */
  top_tubing?: Maybe<Tubings>;
  top_tubing_id?: Maybe<Scalars['uuid']['output']>;
  top_tubing_length_feet?: Maybe<Scalars['numeric']['output']>;
  water_specific_gravity?: Maybe<Scalars['numeric']['output']>;
  well_test_datum_point_measured_depth_feet?: Maybe<Scalars['numeric']['output']>;
  well_test_gas_input_type?: Maybe<Scalars['String']['output']>;
  well_test_gas_rate_mscf_day?: Maybe<Scalars['numeric']['output']>;
  well_test_liquid_input_type?: Maybe<Scalars['String']['output']>;
  well_test_oil_rate_stb_day?: Maybe<Scalars['numeric']['output']>;
  well_test_pressure_input_type?: Maybe<Scalars['String']['output']>;
  well_test_producing_bottom_hole_pressure_psia?: Maybe<Scalars['numeric']['output']>;
  well_test_productivity_index?: Maybe<Scalars['numeric']['output']>;
  well_test_static_bottom_hole_pressure_psia?: Maybe<Scalars['numeric']['output']>;
  well_test_test_date?: Maybe<Scalars['timestamptz']['output']>;
  well_test_water_rate_stb_day?: Maybe<Scalars['numeric']['output']>;
  winning_revision_author_id?: Maybe<Scalars['String']['output']>;
  winning_revision_created_at?: Maybe<Scalars['timestamptz']['output']>;
  winning_revision_deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  winning_revision_id?: Maybe<Scalars['uuid']['output']>;
  winning_revision_parent_id?: Maybe<Scalars['uuid']['output']>;
  winning_revision_updated_at?: Maybe<Scalars['timestamptz']['output']>;
};


/** columns and relationships of "scenario_well_properties" */
export type Scenario_Well_PropertiesCustom_Fluid_PropertiesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "scenario_well_properties" */
export type Scenario_Well_PropertiesCustom_Viscosities_PropertiesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "scenario_well_properties" */
export type Scenario_Well_Properties_Aggregate = {
  __typename: 'scenario_well_properties_aggregate';
  aggregate?: Maybe<Scenario_Well_Properties_Aggregate_Fields>;
  nodes: Array<Scenario_Well_Properties>;
};

/** aggregate fields of "scenario_well_properties" */
export type Scenario_Well_Properties_Aggregate_Fields = {
  __typename: 'scenario_well_properties_aggregate_fields';
  avg?: Maybe<Scenario_Well_Properties_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Scenario_Well_Properties_Max_Fields>;
  min?: Maybe<Scenario_Well_Properties_Min_Fields>;
  stddev?: Maybe<Scenario_Well_Properties_Stddev_Fields>;
  stddev_pop?: Maybe<Scenario_Well_Properties_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Scenario_Well_Properties_Stddev_Samp_Fields>;
  sum?: Maybe<Scenario_Well_Properties_Sum_Fields>;
  var_pop?: Maybe<Scenario_Well_Properties_Var_Pop_Fields>;
  var_samp?: Maybe<Scenario_Well_Properties_Var_Samp_Fields>;
  variance?: Maybe<Scenario_Well_Properties_Variance_Fields>;
};


/** aggregate fields of "scenario_well_properties" */
export type Scenario_Well_Properties_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Scenario_Well_Properties_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Scenario_Well_Properties_Avg_Fields = {
  __typename: 'scenario_well_properties_avg_fields';
  ar_percent?: Maybe<Scalars['Float']['output']>;
  average_dls?: Maybe<Scalars['Float']['output']>;
  bottom_casing_length_feet?: Maybe<Scalars['Float']['output']>;
  bottom_tubing_length_feet?: Maybe<Scalars['Float']['output']>;
  bottomhole_temperature_fahrenheit?: Maybe<Scalars['Float']['output']>;
  bubble_point_pressure_psia?: Maybe<Scalars['Float']['output']>;
  c1_methane_percent?: Maybe<Scalars['Float']['output']>;
  c2_ethane_percent?: Maybe<Scalars['Float']['output']>;
  c3_propane_percent?: Maybe<Scalars['Float']['output']>;
  c6_hexane_percent?: Maybe<Scalars['Float']['output']>;
  c7_heptane_percent?: Maybe<Scalars['Float']['output']>;
  co2_percent?: Maybe<Scalars['Float']['output']>;
  condensate_api_override?: Maybe<Scalars['Float']['output']>;
  dew_point_pressure_psia_override?: Maybe<Scalars['Float']['output']>;
  fluid_viscosity_override_cp?: Maybe<Scalars['Float']['output']>;
  gas_specific_gravity?: Maybe<Scalars['Float']['output']>;
  h2s_percent?: Maybe<Scalars['Float']['output']>;
  hps_pump_inlet_pressure_psia?: Maybe<Scalars['Float']['output']>;
  hps_pump_inlet_temperature_fahrenheit?: Maybe<Scalars['Float']['output']>;
  hps_required_discharge_pressure_psia?: Maybe<Scalars['Float']['output']>;
  ic4_isobutene_percent?: Maybe<Scalars['Float']['output']>;
  ic5_isopentane_percent?: Maybe<Scalars['Float']['output']>;
  n2_percent?: Maybe<Scalars['Float']['output']>;
  nc4_butane_percent?: Maybe<Scalars['Float']['output']>;
  nc5_bentane_percent?: Maybe<Scalars['Float']['output']>;
  npsha_ft?: Maybe<Scalars['Float']['output']>;
  o2_percent?: Maybe<Scalars['Float']['output']>;
  oil_gravity_api?: Maybe<Scalars['Float']['output']>;
  surface_temperature_fahrenheit?: Maybe<Scalars['Float']['output']>;
  top_casing_length_feet?: Maybe<Scalars['Float']['output']>;
  top_of_perforations_measured_depth_feet?: Maybe<Scalars['Float']['output']>;
  top_of_perforations_true_vertical_depth_feet?: Maybe<Scalars['Float']['output']>;
  top_tubing_length_feet?: Maybe<Scalars['Float']['output']>;
  water_specific_gravity?: Maybe<Scalars['Float']['output']>;
  well_test_datum_point_measured_depth_feet?: Maybe<Scalars['Float']['output']>;
  well_test_gas_rate_mscf_day?: Maybe<Scalars['Float']['output']>;
  well_test_oil_rate_stb_day?: Maybe<Scalars['Float']['output']>;
  well_test_producing_bottom_hole_pressure_psia?: Maybe<Scalars['Float']['output']>;
  well_test_productivity_index?: Maybe<Scalars['Float']['output']>;
  well_test_static_bottom_hole_pressure_psia?: Maybe<Scalars['Float']['output']>;
  well_test_water_rate_stb_day?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "scenario_well_properties". All fields are combined with a logical 'AND'. */
export type Scenario_Well_Properties_Bool_Exp = {
  _and?: InputMaybe<Array<Scenario_Well_Properties_Bool_Exp>>;
  _not?: InputMaybe<Scenario_Well_Properties_Bool_Exp>;
  _or?: InputMaybe<Array<Scenario_Well_Properties_Bool_Exp>>;
  ar_percent?: InputMaybe<Numeric_Comparison_Exp>;
  average_dls?: InputMaybe<Numeric_Comparison_Exp>;
  bottom_casing?: InputMaybe<Casings_Bool_Exp>;
  bottom_casing_id?: InputMaybe<Uuid_Comparison_Exp>;
  bottom_casing_length_feet?: InputMaybe<Numeric_Comparison_Exp>;
  bottom_tubing?: InputMaybe<Tubings_Bool_Exp>;
  bottom_tubing_id?: InputMaybe<Uuid_Comparison_Exp>;
  bottom_tubing_length_feet?: InputMaybe<Numeric_Comparison_Exp>;
  bottomhole_temperature_fahrenheit?: InputMaybe<Numeric_Comparison_Exp>;
  bubble_point_pressure_psia?: InputMaybe<Numeric_Comparison_Exp>;
  c1_methane_percent?: InputMaybe<Numeric_Comparison_Exp>;
  c2_ethane_percent?: InputMaybe<Numeric_Comparison_Exp>;
  c3_propane_percent?: InputMaybe<Numeric_Comparison_Exp>;
  c6_hexane_percent?: InputMaybe<Numeric_Comparison_Exp>;
  c7_heptane_percent?: InputMaybe<Numeric_Comparison_Exp>;
  co2_percent?: InputMaybe<Numeric_Comparison_Exp>;
  condensate_api_override?: InputMaybe<Numeric_Comparison_Exp>;
  custom_fluid_properties?: InputMaybe<Jsonb_Comparison_Exp>;
  custom_viscosities_properties?: InputMaybe<Jsonb_Comparison_Exp>;
  deviation_survey?: InputMaybe<Deviation_Survey_Bool_Exp>;
  deviation_survey_id?: InputMaybe<Uuid_Comparison_Exp>;
  dew_point_pressure_psia_override?: InputMaybe<Numeric_Comparison_Exp>;
  fluid_viscosity_override_cp?: InputMaybe<Numeric_Comparison_Exp>;
  gas_specific_gravity?: InputMaybe<Numeric_Comparison_Exp>;
  gas_type?: InputMaybe<String_Comparison_Exp>;
  h2s_percent?: InputMaybe<Numeric_Comparison_Exp>;
  hps_liquid_type?: InputMaybe<String_Comparison_Exp>;
  hps_pump_inlet_pressure_psia?: InputMaybe<Numeric_Comparison_Exp>;
  hps_pump_inlet_temperature_fahrenheit?: InputMaybe<Numeric_Comparison_Exp>;
  hps_required_discharge_pressure_psia?: InputMaybe<Numeric_Comparison_Exp>;
  ic4_isobutene_percent?: InputMaybe<Numeric_Comparison_Exp>;
  ic5_isopentane_percent?: InputMaybe<Numeric_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  journal_author_id?: InputMaybe<String_Comparison_Exp>;
  journal_created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  journal_deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  journal_updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  n2_percent?: InputMaybe<Numeric_Comparison_Exp>;
  nc4_butane_percent?: InputMaybe<Numeric_Comparison_Exp>;
  nc5_bentane_percent?: InputMaybe<Numeric_Comparison_Exp>;
  npsha_ft?: InputMaybe<Numeric_Comparison_Exp>;
  o2_percent?: InputMaybe<Numeric_Comparison_Exp>;
  oil_gravity_api?: InputMaybe<Numeric_Comparison_Exp>;
  parent_id?: InputMaybe<Uuid_Comparison_Exp>;
  surface_temperature_fahrenheit?: InputMaybe<Numeric_Comparison_Exp>;
  top_casing?: InputMaybe<Casings_Bool_Exp>;
  top_casing_id?: InputMaybe<Uuid_Comparison_Exp>;
  top_casing_length_feet?: InputMaybe<Numeric_Comparison_Exp>;
  top_of_perforations_measured_depth_feet?: InputMaybe<Numeric_Comparison_Exp>;
  top_of_perforations_true_vertical_depth_feet?: InputMaybe<Numeric_Comparison_Exp>;
  top_tubing?: InputMaybe<Tubings_Bool_Exp>;
  top_tubing_id?: InputMaybe<Uuid_Comparison_Exp>;
  top_tubing_length_feet?: InputMaybe<Numeric_Comparison_Exp>;
  water_specific_gravity?: InputMaybe<Numeric_Comparison_Exp>;
  well_test_datum_point_measured_depth_feet?: InputMaybe<Numeric_Comparison_Exp>;
  well_test_gas_input_type?: InputMaybe<String_Comparison_Exp>;
  well_test_gas_rate_mscf_day?: InputMaybe<Numeric_Comparison_Exp>;
  well_test_liquid_input_type?: InputMaybe<String_Comparison_Exp>;
  well_test_oil_rate_stb_day?: InputMaybe<Numeric_Comparison_Exp>;
  well_test_pressure_input_type?: InputMaybe<String_Comparison_Exp>;
  well_test_producing_bottom_hole_pressure_psia?: InputMaybe<Numeric_Comparison_Exp>;
  well_test_productivity_index?: InputMaybe<Numeric_Comparison_Exp>;
  well_test_static_bottom_hole_pressure_psia?: InputMaybe<Numeric_Comparison_Exp>;
  well_test_test_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  well_test_water_rate_stb_day?: InputMaybe<Numeric_Comparison_Exp>;
  winning_revision_author_id?: InputMaybe<String_Comparison_Exp>;
  winning_revision_created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  winning_revision_deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  winning_revision_id?: InputMaybe<Uuid_Comparison_Exp>;
  winning_revision_parent_id?: InputMaybe<Uuid_Comparison_Exp>;
  winning_revision_updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** input type for inserting data into table "scenario_well_properties" */
export type Scenario_Well_Properties_Insert_Input = {
  ar_percent?: InputMaybe<Scalars['numeric']['input']>;
  average_dls?: InputMaybe<Scalars['numeric']['input']>;
  bottom_casing?: InputMaybe<Casings_Obj_Rel_Insert_Input>;
  bottom_casing_id?: InputMaybe<Scalars['uuid']['input']>;
  bottom_casing_length_feet?: InputMaybe<Scalars['numeric']['input']>;
  bottom_tubing?: InputMaybe<Tubings_Obj_Rel_Insert_Input>;
  bottom_tubing_id?: InputMaybe<Scalars['uuid']['input']>;
  bottom_tubing_length_feet?: InputMaybe<Scalars['numeric']['input']>;
  bottomhole_temperature_fahrenheit?: InputMaybe<Scalars['numeric']['input']>;
  bubble_point_pressure_psia?: InputMaybe<Scalars['numeric']['input']>;
  c1_methane_percent?: InputMaybe<Scalars['numeric']['input']>;
  c2_ethane_percent?: InputMaybe<Scalars['numeric']['input']>;
  c3_propane_percent?: InputMaybe<Scalars['numeric']['input']>;
  c6_hexane_percent?: InputMaybe<Scalars['numeric']['input']>;
  c7_heptane_percent?: InputMaybe<Scalars['numeric']['input']>;
  co2_percent?: InputMaybe<Scalars['numeric']['input']>;
  condensate_api_override?: InputMaybe<Scalars['numeric']['input']>;
  custom_fluid_properties?: InputMaybe<Scalars['jsonb']['input']>;
  custom_viscosities_properties?: InputMaybe<Scalars['jsonb']['input']>;
  deviation_survey?: InputMaybe<Deviation_Survey_Obj_Rel_Insert_Input>;
  deviation_survey_id?: InputMaybe<Scalars['uuid']['input']>;
  dew_point_pressure_psia_override?: InputMaybe<Scalars['numeric']['input']>;
  fluid_viscosity_override_cp?: InputMaybe<Scalars['numeric']['input']>;
  gas_specific_gravity?: InputMaybe<Scalars['numeric']['input']>;
  gas_type?: InputMaybe<Scalars['String']['input']>;
  h2s_percent?: InputMaybe<Scalars['numeric']['input']>;
  hps_liquid_type?: InputMaybe<Scalars['String']['input']>;
  hps_pump_inlet_pressure_psia?: InputMaybe<Scalars['numeric']['input']>;
  hps_pump_inlet_temperature_fahrenheit?: InputMaybe<Scalars['numeric']['input']>;
  hps_required_discharge_pressure_psia?: InputMaybe<Scalars['numeric']['input']>;
  ic4_isobutene_percent?: InputMaybe<Scalars['numeric']['input']>;
  ic5_isopentane_percent?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  journal_author_id?: InputMaybe<Scalars['String']['input']>;
  journal_created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  journal_deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  journal_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  n2_percent?: InputMaybe<Scalars['numeric']['input']>;
  nc4_butane_percent?: InputMaybe<Scalars['numeric']['input']>;
  nc5_bentane_percent?: InputMaybe<Scalars['numeric']['input']>;
  npsha_ft?: InputMaybe<Scalars['numeric']['input']>;
  o2_percent?: InputMaybe<Scalars['numeric']['input']>;
  oil_gravity_api?: InputMaybe<Scalars['numeric']['input']>;
  parent_id?: InputMaybe<Scalars['uuid']['input']>;
  surface_temperature_fahrenheit?: InputMaybe<Scalars['numeric']['input']>;
  top_casing?: InputMaybe<Casings_Obj_Rel_Insert_Input>;
  top_casing_id?: InputMaybe<Scalars['uuid']['input']>;
  top_casing_length_feet?: InputMaybe<Scalars['numeric']['input']>;
  top_of_perforations_measured_depth_feet?: InputMaybe<Scalars['numeric']['input']>;
  top_of_perforations_true_vertical_depth_feet?: InputMaybe<Scalars['numeric']['input']>;
  top_tubing?: InputMaybe<Tubings_Obj_Rel_Insert_Input>;
  top_tubing_id?: InputMaybe<Scalars['uuid']['input']>;
  top_tubing_length_feet?: InputMaybe<Scalars['numeric']['input']>;
  water_specific_gravity?: InputMaybe<Scalars['numeric']['input']>;
  well_test_datum_point_measured_depth_feet?: InputMaybe<Scalars['numeric']['input']>;
  well_test_gas_input_type?: InputMaybe<Scalars['String']['input']>;
  well_test_gas_rate_mscf_day?: InputMaybe<Scalars['numeric']['input']>;
  well_test_liquid_input_type?: InputMaybe<Scalars['String']['input']>;
  well_test_oil_rate_stb_day?: InputMaybe<Scalars['numeric']['input']>;
  well_test_pressure_input_type?: InputMaybe<Scalars['String']['input']>;
  well_test_producing_bottom_hole_pressure_psia?: InputMaybe<Scalars['numeric']['input']>;
  well_test_productivity_index?: InputMaybe<Scalars['numeric']['input']>;
  well_test_static_bottom_hole_pressure_psia?: InputMaybe<Scalars['numeric']['input']>;
  well_test_test_date?: InputMaybe<Scalars['timestamptz']['input']>;
  well_test_water_rate_stb_day?: InputMaybe<Scalars['numeric']['input']>;
  winning_revision_author_id?: InputMaybe<Scalars['String']['input']>;
  winning_revision_created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  winning_revision_deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  winning_revision_id?: InputMaybe<Scalars['uuid']['input']>;
  winning_revision_parent_id?: InputMaybe<Scalars['uuid']['input']>;
  winning_revision_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Scenario_Well_Properties_Max_Fields = {
  __typename: 'scenario_well_properties_max_fields';
  ar_percent?: Maybe<Scalars['numeric']['output']>;
  average_dls?: Maybe<Scalars['numeric']['output']>;
  bottom_casing_id?: Maybe<Scalars['uuid']['output']>;
  bottom_casing_length_feet?: Maybe<Scalars['numeric']['output']>;
  bottom_tubing_id?: Maybe<Scalars['uuid']['output']>;
  bottom_tubing_length_feet?: Maybe<Scalars['numeric']['output']>;
  bottomhole_temperature_fahrenheit?: Maybe<Scalars['numeric']['output']>;
  bubble_point_pressure_psia?: Maybe<Scalars['numeric']['output']>;
  c1_methane_percent?: Maybe<Scalars['numeric']['output']>;
  c2_ethane_percent?: Maybe<Scalars['numeric']['output']>;
  c3_propane_percent?: Maybe<Scalars['numeric']['output']>;
  c6_hexane_percent?: Maybe<Scalars['numeric']['output']>;
  c7_heptane_percent?: Maybe<Scalars['numeric']['output']>;
  co2_percent?: Maybe<Scalars['numeric']['output']>;
  condensate_api_override?: Maybe<Scalars['numeric']['output']>;
  deviation_survey_id?: Maybe<Scalars['uuid']['output']>;
  dew_point_pressure_psia_override?: Maybe<Scalars['numeric']['output']>;
  fluid_viscosity_override_cp?: Maybe<Scalars['numeric']['output']>;
  gas_specific_gravity?: Maybe<Scalars['numeric']['output']>;
  gas_type?: Maybe<Scalars['String']['output']>;
  h2s_percent?: Maybe<Scalars['numeric']['output']>;
  hps_liquid_type?: Maybe<Scalars['String']['output']>;
  hps_pump_inlet_pressure_psia?: Maybe<Scalars['numeric']['output']>;
  hps_pump_inlet_temperature_fahrenheit?: Maybe<Scalars['numeric']['output']>;
  hps_required_discharge_pressure_psia?: Maybe<Scalars['numeric']['output']>;
  ic4_isobutene_percent?: Maybe<Scalars['numeric']['output']>;
  ic5_isopentane_percent?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  journal_author_id?: Maybe<Scalars['String']['output']>;
  journal_created_at?: Maybe<Scalars['timestamptz']['output']>;
  journal_deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  journal_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  n2_percent?: Maybe<Scalars['numeric']['output']>;
  nc4_butane_percent?: Maybe<Scalars['numeric']['output']>;
  nc5_bentane_percent?: Maybe<Scalars['numeric']['output']>;
  npsha_ft?: Maybe<Scalars['numeric']['output']>;
  o2_percent?: Maybe<Scalars['numeric']['output']>;
  oil_gravity_api?: Maybe<Scalars['numeric']['output']>;
  parent_id?: Maybe<Scalars['uuid']['output']>;
  surface_temperature_fahrenheit?: Maybe<Scalars['numeric']['output']>;
  top_casing_id?: Maybe<Scalars['uuid']['output']>;
  top_casing_length_feet?: Maybe<Scalars['numeric']['output']>;
  top_of_perforations_measured_depth_feet?: Maybe<Scalars['numeric']['output']>;
  top_of_perforations_true_vertical_depth_feet?: Maybe<Scalars['numeric']['output']>;
  top_tubing_id?: Maybe<Scalars['uuid']['output']>;
  top_tubing_length_feet?: Maybe<Scalars['numeric']['output']>;
  water_specific_gravity?: Maybe<Scalars['numeric']['output']>;
  well_test_datum_point_measured_depth_feet?: Maybe<Scalars['numeric']['output']>;
  well_test_gas_input_type?: Maybe<Scalars['String']['output']>;
  well_test_gas_rate_mscf_day?: Maybe<Scalars['numeric']['output']>;
  well_test_liquid_input_type?: Maybe<Scalars['String']['output']>;
  well_test_oil_rate_stb_day?: Maybe<Scalars['numeric']['output']>;
  well_test_pressure_input_type?: Maybe<Scalars['String']['output']>;
  well_test_producing_bottom_hole_pressure_psia?: Maybe<Scalars['numeric']['output']>;
  well_test_productivity_index?: Maybe<Scalars['numeric']['output']>;
  well_test_static_bottom_hole_pressure_psia?: Maybe<Scalars['numeric']['output']>;
  well_test_test_date?: Maybe<Scalars['timestamptz']['output']>;
  well_test_water_rate_stb_day?: Maybe<Scalars['numeric']['output']>;
  winning_revision_author_id?: Maybe<Scalars['String']['output']>;
  winning_revision_created_at?: Maybe<Scalars['timestamptz']['output']>;
  winning_revision_deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  winning_revision_id?: Maybe<Scalars['uuid']['output']>;
  winning_revision_parent_id?: Maybe<Scalars['uuid']['output']>;
  winning_revision_updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Scenario_Well_Properties_Min_Fields = {
  __typename: 'scenario_well_properties_min_fields';
  ar_percent?: Maybe<Scalars['numeric']['output']>;
  average_dls?: Maybe<Scalars['numeric']['output']>;
  bottom_casing_id?: Maybe<Scalars['uuid']['output']>;
  bottom_casing_length_feet?: Maybe<Scalars['numeric']['output']>;
  bottom_tubing_id?: Maybe<Scalars['uuid']['output']>;
  bottom_tubing_length_feet?: Maybe<Scalars['numeric']['output']>;
  bottomhole_temperature_fahrenheit?: Maybe<Scalars['numeric']['output']>;
  bubble_point_pressure_psia?: Maybe<Scalars['numeric']['output']>;
  c1_methane_percent?: Maybe<Scalars['numeric']['output']>;
  c2_ethane_percent?: Maybe<Scalars['numeric']['output']>;
  c3_propane_percent?: Maybe<Scalars['numeric']['output']>;
  c6_hexane_percent?: Maybe<Scalars['numeric']['output']>;
  c7_heptane_percent?: Maybe<Scalars['numeric']['output']>;
  co2_percent?: Maybe<Scalars['numeric']['output']>;
  condensate_api_override?: Maybe<Scalars['numeric']['output']>;
  deviation_survey_id?: Maybe<Scalars['uuid']['output']>;
  dew_point_pressure_psia_override?: Maybe<Scalars['numeric']['output']>;
  fluid_viscosity_override_cp?: Maybe<Scalars['numeric']['output']>;
  gas_specific_gravity?: Maybe<Scalars['numeric']['output']>;
  gas_type?: Maybe<Scalars['String']['output']>;
  h2s_percent?: Maybe<Scalars['numeric']['output']>;
  hps_liquid_type?: Maybe<Scalars['String']['output']>;
  hps_pump_inlet_pressure_psia?: Maybe<Scalars['numeric']['output']>;
  hps_pump_inlet_temperature_fahrenheit?: Maybe<Scalars['numeric']['output']>;
  hps_required_discharge_pressure_psia?: Maybe<Scalars['numeric']['output']>;
  ic4_isobutene_percent?: Maybe<Scalars['numeric']['output']>;
  ic5_isopentane_percent?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  journal_author_id?: Maybe<Scalars['String']['output']>;
  journal_created_at?: Maybe<Scalars['timestamptz']['output']>;
  journal_deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  journal_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  n2_percent?: Maybe<Scalars['numeric']['output']>;
  nc4_butane_percent?: Maybe<Scalars['numeric']['output']>;
  nc5_bentane_percent?: Maybe<Scalars['numeric']['output']>;
  npsha_ft?: Maybe<Scalars['numeric']['output']>;
  o2_percent?: Maybe<Scalars['numeric']['output']>;
  oil_gravity_api?: Maybe<Scalars['numeric']['output']>;
  parent_id?: Maybe<Scalars['uuid']['output']>;
  surface_temperature_fahrenheit?: Maybe<Scalars['numeric']['output']>;
  top_casing_id?: Maybe<Scalars['uuid']['output']>;
  top_casing_length_feet?: Maybe<Scalars['numeric']['output']>;
  top_of_perforations_measured_depth_feet?: Maybe<Scalars['numeric']['output']>;
  top_of_perforations_true_vertical_depth_feet?: Maybe<Scalars['numeric']['output']>;
  top_tubing_id?: Maybe<Scalars['uuid']['output']>;
  top_tubing_length_feet?: Maybe<Scalars['numeric']['output']>;
  water_specific_gravity?: Maybe<Scalars['numeric']['output']>;
  well_test_datum_point_measured_depth_feet?: Maybe<Scalars['numeric']['output']>;
  well_test_gas_input_type?: Maybe<Scalars['String']['output']>;
  well_test_gas_rate_mscf_day?: Maybe<Scalars['numeric']['output']>;
  well_test_liquid_input_type?: Maybe<Scalars['String']['output']>;
  well_test_oil_rate_stb_day?: Maybe<Scalars['numeric']['output']>;
  well_test_pressure_input_type?: Maybe<Scalars['String']['output']>;
  well_test_producing_bottom_hole_pressure_psia?: Maybe<Scalars['numeric']['output']>;
  well_test_productivity_index?: Maybe<Scalars['numeric']['output']>;
  well_test_static_bottom_hole_pressure_psia?: Maybe<Scalars['numeric']['output']>;
  well_test_test_date?: Maybe<Scalars['timestamptz']['output']>;
  well_test_water_rate_stb_day?: Maybe<Scalars['numeric']['output']>;
  winning_revision_author_id?: Maybe<Scalars['String']['output']>;
  winning_revision_created_at?: Maybe<Scalars['timestamptz']['output']>;
  winning_revision_deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  winning_revision_id?: Maybe<Scalars['uuid']['output']>;
  winning_revision_parent_id?: Maybe<Scalars['uuid']['output']>;
  winning_revision_updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** input type for inserting object relation for remote table "scenario_well_properties" */
export type Scenario_Well_Properties_Obj_Rel_Insert_Input = {
  data: Scenario_Well_Properties_Insert_Input;
};

/** Ordering options when selecting data from "scenario_well_properties". */
export type Scenario_Well_Properties_Order_By = {
  ar_percent?: InputMaybe<Order_By>;
  average_dls?: InputMaybe<Order_By>;
  bottom_casing?: InputMaybe<Casings_Order_By>;
  bottom_casing_id?: InputMaybe<Order_By>;
  bottom_casing_length_feet?: InputMaybe<Order_By>;
  bottom_tubing?: InputMaybe<Tubings_Order_By>;
  bottom_tubing_id?: InputMaybe<Order_By>;
  bottom_tubing_length_feet?: InputMaybe<Order_By>;
  bottomhole_temperature_fahrenheit?: InputMaybe<Order_By>;
  bubble_point_pressure_psia?: InputMaybe<Order_By>;
  c1_methane_percent?: InputMaybe<Order_By>;
  c2_ethane_percent?: InputMaybe<Order_By>;
  c3_propane_percent?: InputMaybe<Order_By>;
  c6_hexane_percent?: InputMaybe<Order_By>;
  c7_heptane_percent?: InputMaybe<Order_By>;
  co2_percent?: InputMaybe<Order_By>;
  condensate_api_override?: InputMaybe<Order_By>;
  custom_fluid_properties?: InputMaybe<Order_By>;
  custom_viscosities_properties?: InputMaybe<Order_By>;
  deviation_survey?: InputMaybe<Deviation_Survey_Order_By>;
  deviation_survey_id?: InputMaybe<Order_By>;
  dew_point_pressure_psia_override?: InputMaybe<Order_By>;
  fluid_viscosity_override_cp?: InputMaybe<Order_By>;
  gas_specific_gravity?: InputMaybe<Order_By>;
  gas_type?: InputMaybe<Order_By>;
  h2s_percent?: InputMaybe<Order_By>;
  hps_liquid_type?: InputMaybe<Order_By>;
  hps_pump_inlet_pressure_psia?: InputMaybe<Order_By>;
  hps_pump_inlet_temperature_fahrenheit?: InputMaybe<Order_By>;
  hps_required_discharge_pressure_psia?: InputMaybe<Order_By>;
  ic4_isobutene_percent?: InputMaybe<Order_By>;
  ic5_isopentane_percent?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  journal_author_id?: InputMaybe<Order_By>;
  journal_created_at?: InputMaybe<Order_By>;
  journal_deleted_at?: InputMaybe<Order_By>;
  journal_updated_at?: InputMaybe<Order_By>;
  n2_percent?: InputMaybe<Order_By>;
  nc4_butane_percent?: InputMaybe<Order_By>;
  nc5_bentane_percent?: InputMaybe<Order_By>;
  npsha_ft?: InputMaybe<Order_By>;
  o2_percent?: InputMaybe<Order_By>;
  oil_gravity_api?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  surface_temperature_fahrenheit?: InputMaybe<Order_By>;
  top_casing?: InputMaybe<Casings_Order_By>;
  top_casing_id?: InputMaybe<Order_By>;
  top_casing_length_feet?: InputMaybe<Order_By>;
  top_of_perforations_measured_depth_feet?: InputMaybe<Order_By>;
  top_of_perforations_true_vertical_depth_feet?: InputMaybe<Order_By>;
  top_tubing?: InputMaybe<Tubings_Order_By>;
  top_tubing_id?: InputMaybe<Order_By>;
  top_tubing_length_feet?: InputMaybe<Order_By>;
  water_specific_gravity?: InputMaybe<Order_By>;
  well_test_datum_point_measured_depth_feet?: InputMaybe<Order_By>;
  well_test_gas_input_type?: InputMaybe<Order_By>;
  well_test_gas_rate_mscf_day?: InputMaybe<Order_By>;
  well_test_liquid_input_type?: InputMaybe<Order_By>;
  well_test_oil_rate_stb_day?: InputMaybe<Order_By>;
  well_test_pressure_input_type?: InputMaybe<Order_By>;
  well_test_producing_bottom_hole_pressure_psia?: InputMaybe<Order_By>;
  well_test_productivity_index?: InputMaybe<Order_By>;
  well_test_static_bottom_hole_pressure_psia?: InputMaybe<Order_By>;
  well_test_test_date?: InputMaybe<Order_By>;
  well_test_water_rate_stb_day?: InputMaybe<Order_By>;
  winning_revision_author_id?: InputMaybe<Order_By>;
  winning_revision_created_at?: InputMaybe<Order_By>;
  winning_revision_deleted_at?: InputMaybe<Order_By>;
  winning_revision_id?: InputMaybe<Order_By>;
  winning_revision_parent_id?: InputMaybe<Order_By>;
  winning_revision_updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "scenario_well_properties" */
export enum Scenario_Well_Properties_Select_Column {
  /** column name */
  ArPercent = 'ar_percent',
  /** column name */
  AverageDls = 'average_dls',
  /** column name */
  BottomCasingId = 'bottom_casing_id',
  /** column name */
  BottomCasingLengthFeet = 'bottom_casing_length_feet',
  /** column name */
  BottomTubingId = 'bottom_tubing_id',
  /** column name */
  BottomTubingLengthFeet = 'bottom_tubing_length_feet',
  /** column name */
  BottomholeTemperatureFahrenheit = 'bottomhole_temperature_fahrenheit',
  /** column name */
  BubblePointPressurePsia = 'bubble_point_pressure_psia',
  /** column name */
  C1MethanePercent = 'c1_methane_percent',
  /** column name */
  C2EthanePercent = 'c2_ethane_percent',
  /** column name */
  C3PropanePercent = 'c3_propane_percent',
  /** column name */
  C6HexanePercent = 'c6_hexane_percent',
  /** column name */
  C7HeptanePercent = 'c7_heptane_percent',
  /** column name */
  Co2Percent = 'co2_percent',
  /** column name */
  CondensateApiOverride = 'condensate_api_override',
  /** column name */
  CustomFluidProperties = 'custom_fluid_properties',
  /** column name */
  CustomViscositiesProperties = 'custom_viscosities_properties',
  /** column name */
  DeviationSurveyId = 'deviation_survey_id',
  /** column name */
  DewPointPressurePsiaOverride = 'dew_point_pressure_psia_override',
  /** column name */
  FluidViscosityOverrideCp = 'fluid_viscosity_override_cp',
  /** column name */
  GasSpecificGravity = 'gas_specific_gravity',
  /** column name */
  GasType = 'gas_type',
  /** column name */
  H2sPercent = 'h2s_percent',
  /** column name */
  HpsLiquidType = 'hps_liquid_type',
  /** column name */
  HpsPumpInletPressurePsia = 'hps_pump_inlet_pressure_psia',
  /** column name */
  HpsPumpInletTemperatureFahrenheit = 'hps_pump_inlet_temperature_fahrenheit',
  /** column name */
  HpsRequiredDischargePressurePsia = 'hps_required_discharge_pressure_psia',
  /** column name */
  Ic4IsobutenePercent = 'ic4_isobutene_percent',
  /** column name */
  Ic5IsopentanePercent = 'ic5_isopentane_percent',
  /** column name */
  Id = 'id',
  /** column name */
  JournalAuthorId = 'journal_author_id',
  /** column name */
  JournalCreatedAt = 'journal_created_at',
  /** column name */
  JournalDeletedAt = 'journal_deleted_at',
  /** column name */
  JournalUpdatedAt = 'journal_updated_at',
  /** column name */
  N2Percent = 'n2_percent',
  /** column name */
  Nc4ButanePercent = 'nc4_butane_percent',
  /** column name */
  Nc5BentanePercent = 'nc5_bentane_percent',
  /** column name */
  NpshaFt = 'npsha_ft',
  /** column name */
  O2Percent = 'o2_percent',
  /** column name */
  OilGravityApi = 'oil_gravity_api',
  /** column name */
  ParentId = 'parent_id',
  /** column name */
  SurfaceTemperatureFahrenheit = 'surface_temperature_fahrenheit',
  /** column name */
  TopCasingId = 'top_casing_id',
  /** column name */
  TopCasingLengthFeet = 'top_casing_length_feet',
  /** column name */
  TopOfPerforationsMeasuredDepthFeet = 'top_of_perforations_measured_depth_feet',
  /** column name */
  TopOfPerforationsTrueVerticalDepthFeet = 'top_of_perforations_true_vertical_depth_feet',
  /** column name */
  TopTubingId = 'top_tubing_id',
  /** column name */
  TopTubingLengthFeet = 'top_tubing_length_feet',
  /** column name */
  WaterSpecificGravity = 'water_specific_gravity',
  /** column name */
  WellTestDatumPointMeasuredDepthFeet = 'well_test_datum_point_measured_depth_feet',
  /** column name */
  WellTestGasInputType = 'well_test_gas_input_type',
  /** column name */
  WellTestGasRateMscfDay = 'well_test_gas_rate_mscf_day',
  /** column name */
  WellTestLiquidInputType = 'well_test_liquid_input_type',
  /** column name */
  WellTestOilRateStbDay = 'well_test_oil_rate_stb_day',
  /** column name */
  WellTestPressureInputType = 'well_test_pressure_input_type',
  /** column name */
  WellTestProducingBottomHolePressurePsia = 'well_test_producing_bottom_hole_pressure_psia',
  /** column name */
  WellTestProductivityIndex = 'well_test_productivity_index',
  /** column name */
  WellTestStaticBottomHolePressurePsia = 'well_test_static_bottom_hole_pressure_psia',
  /** column name */
  WellTestTestDate = 'well_test_test_date',
  /** column name */
  WellTestWaterRateStbDay = 'well_test_water_rate_stb_day',
  /** column name */
  WinningRevisionAuthorId = 'winning_revision_author_id',
  /** column name */
  WinningRevisionCreatedAt = 'winning_revision_created_at',
  /** column name */
  WinningRevisionDeletedAt = 'winning_revision_deleted_at',
  /** column name */
  WinningRevisionId = 'winning_revision_id',
  /** column name */
  WinningRevisionParentId = 'winning_revision_parent_id',
  /** column name */
  WinningRevisionUpdatedAt = 'winning_revision_updated_at'
}

/** aggregate stddev on columns */
export type Scenario_Well_Properties_Stddev_Fields = {
  __typename: 'scenario_well_properties_stddev_fields';
  ar_percent?: Maybe<Scalars['Float']['output']>;
  average_dls?: Maybe<Scalars['Float']['output']>;
  bottom_casing_length_feet?: Maybe<Scalars['Float']['output']>;
  bottom_tubing_length_feet?: Maybe<Scalars['Float']['output']>;
  bottomhole_temperature_fahrenheit?: Maybe<Scalars['Float']['output']>;
  bubble_point_pressure_psia?: Maybe<Scalars['Float']['output']>;
  c1_methane_percent?: Maybe<Scalars['Float']['output']>;
  c2_ethane_percent?: Maybe<Scalars['Float']['output']>;
  c3_propane_percent?: Maybe<Scalars['Float']['output']>;
  c6_hexane_percent?: Maybe<Scalars['Float']['output']>;
  c7_heptane_percent?: Maybe<Scalars['Float']['output']>;
  co2_percent?: Maybe<Scalars['Float']['output']>;
  condensate_api_override?: Maybe<Scalars['Float']['output']>;
  dew_point_pressure_psia_override?: Maybe<Scalars['Float']['output']>;
  fluid_viscosity_override_cp?: Maybe<Scalars['Float']['output']>;
  gas_specific_gravity?: Maybe<Scalars['Float']['output']>;
  h2s_percent?: Maybe<Scalars['Float']['output']>;
  hps_pump_inlet_pressure_psia?: Maybe<Scalars['Float']['output']>;
  hps_pump_inlet_temperature_fahrenheit?: Maybe<Scalars['Float']['output']>;
  hps_required_discharge_pressure_psia?: Maybe<Scalars['Float']['output']>;
  ic4_isobutene_percent?: Maybe<Scalars['Float']['output']>;
  ic5_isopentane_percent?: Maybe<Scalars['Float']['output']>;
  n2_percent?: Maybe<Scalars['Float']['output']>;
  nc4_butane_percent?: Maybe<Scalars['Float']['output']>;
  nc5_bentane_percent?: Maybe<Scalars['Float']['output']>;
  npsha_ft?: Maybe<Scalars['Float']['output']>;
  o2_percent?: Maybe<Scalars['Float']['output']>;
  oil_gravity_api?: Maybe<Scalars['Float']['output']>;
  surface_temperature_fahrenheit?: Maybe<Scalars['Float']['output']>;
  top_casing_length_feet?: Maybe<Scalars['Float']['output']>;
  top_of_perforations_measured_depth_feet?: Maybe<Scalars['Float']['output']>;
  top_of_perforations_true_vertical_depth_feet?: Maybe<Scalars['Float']['output']>;
  top_tubing_length_feet?: Maybe<Scalars['Float']['output']>;
  water_specific_gravity?: Maybe<Scalars['Float']['output']>;
  well_test_datum_point_measured_depth_feet?: Maybe<Scalars['Float']['output']>;
  well_test_gas_rate_mscf_day?: Maybe<Scalars['Float']['output']>;
  well_test_oil_rate_stb_day?: Maybe<Scalars['Float']['output']>;
  well_test_producing_bottom_hole_pressure_psia?: Maybe<Scalars['Float']['output']>;
  well_test_productivity_index?: Maybe<Scalars['Float']['output']>;
  well_test_static_bottom_hole_pressure_psia?: Maybe<Scalars['Float']['output']>;
  well_test_water_rate_stb_day?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Scenario_Well_Properties_Stddev_Pop_Fields = {
  __typename: 'scenario_well_properties_stddev_pop_fields';
  ar_percent?: Maybe<Scalars['Float']['output']>;
  average_dls?: Maybe<Scalars['Float']['output']>;
  bottom_casing_length_feet?: Maybe<Scalars['Float']['output']>;
  bottom_tubing_length_feet?: Maybe<Scalars['Float']['output']>;
  bottomhole_temperature_fahrenheit?: Maybe<Scalars['Float']['output']>;
  bubble_point_pressure_psia?: Maybe<Scalars['Float']['output']>;
  c1_methane_percent?: Maybe<Scalars['Float']['output']>;
  c2_ethane_percent?: Maybe<Scalars['Float']['output']>;
  c3_propane_percent?: Maybe<Scalars['Float']['output']>;
  c6_hexane_percent?: Maybe<Scalars['Float']['output']>;
  c7_heptane_percent?: Maybe<Scalars['Float']['output']>;
  co2_percent?: Maybe<Scalars['Float']['output']>;
  condensate_api_override?: Maybe<Scalars['Float']['output']>;
  dew_point_pressure_psia_override?: Maybe<Scalars['Float']['output']>;
  fluid_viscosity_override_cp?: Maybe<Scalars['Float']['output']>;
  gas_specific_gravity?: Maybe<Scalars['Float']['output']>;
  h2s_percent?: Maybe<Scalars['Float']['output']>;
  hps_pump_inlet_pressure_psia?: Maybe<Scalars['Float']['output']>;
  hps_pump_inlet_temperature_fahrenheit?: Maybe<Scalars['Float']['output']>;
  hps_required_discharge_pressure_psia?: Maybe<Scalars['Float']['output']>;
  ic4_isobutene_percent?: Maybe<Scalars['Float']['output']>;
  ic5_isopentane_percent?: Maybe<Scalars['Float']['output']>;
  n2_percent?: Maybe<Scalars['Float']['output']>;
  nc4_butane_percent?: Maybe<Scalars['Float']['output']>;
  nc5_bentane_percent?: Maybe<Scalars['Float']['output']>;
  npsha_ft?: Maybe<Scalars['Float']['output']>;
  o2_percent?: Maybe<Scalars['Float']['output']>;
  oil_gravity_api?: Maybe<Scalars['Float']['output']>;
  surface_temperature_fahrenheit?: Maybe<Scalars['Float']['output']>;
  top_casing_length_feet?: Maybe<Scalars['Float']['output']>;
  top_of_perforations_measured_depth_feet?: Maybe<Scalars['Float']['output']>;
  top_of_perforations_true_vertical_depth_feet?: Maybe<Scalars['Float']['output']>;
  top_tubing_length_feet?: Maybe<Scalars['Float']['output']>;
  water_specific_gravity?: Maybe<Scalars['Float']['output']>;
  well_test_datum_point_measured_depth_feet?: Maybe<Scalars['Float']['output']>;
  well_test_gas_rate_mscf_day?: Maybe<Scalars['Float']['output']>;
  well_test_oil_rate_stb_day?: Maybe<Scalars['Float']['output']>;
  well_test_producing_bottom_hole_pressure_psia?: Maybe<Scalars['Float']['output']>;
  well_test_productivity_index?: Maybe<Scalars['Float']['output']>;
  well_test_static_bottom_hole_pressure_psia?: Maybe<Scalars['Float']['output']>;
  well_test_water_rate_stb_day?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Scenario_Well_Properties_Stddev_Samp_Fields = {
  __typename: 'scenario_well_properties_stddev_samp_fields';
  ar_percent?: Maybe<Scalars['Float']['output']>;
  average_dls?: Maybe<Scalars['Float']['output']>;
  bottom_casing_length_feet?: Maybe<Scalars['Float']['output']>;
  bottom_tubing_length_feet?: Maybe<Scalars['Float']['output']>;
  bottomhole_temperature_fahrenheit?: Maybe<Scalars['Float']['output']>;
  bubble_point_pressure_psia?: Maybe<Scalars['Float']['output']>;
  c1_methane_percent?: Maybe<Scalars['Float']['output']>;
  c2_ethane_percent?: Maybe<Scalars['Float']['output']>;
  c3_propane_percent?: Maybe<Scalars['Float']['output']>;
  c6_hexane_percent?: Maybe<Scalars['Float']['output']>;
  c7_heptane_percent?: Maybe<Scalars['Float']['output']>;
  co2_percent?: Maybe<Scalars['Float']['output']>;
  condensate_api_override?: Maybe<Scalars['Float']['output']>;
  dew_point_pressure_psia_override?: Maybe<Scalars['Float']['output']>;
  fluid_viscosity_override_cp?: Maybe<Scalars['Float']['output']>;
  gas_specific_gravity?: Maybe<Scalars['Float']['output']>;
  h2s_percent?: Maybe<Scalars['Float']['output']>;
  hps_pump_inlet_pressure_psia?: Maybe<Scalars['Float']['output']>;
  hps_pump_inlet_temperature_fahrenheit?: Maybe<Scalars['Float']['output']>;
  hps_required_discharge_pressure_psia?: Maybe<Scalars['Float']['output']>;
  ic4_isobutene_percent?: Maybe<Scalars['Float']['output']>;
  ic5_isopentane_percent?: Maybe<Scalars['Float']['output']>;
  n2_percent?: Maybe<Scalars['Float']['output']>;
  nc4_butane_percent?: Maybe<Scalars['Float']['output']>;
  nc5_bentane_percent?: Maybe<Scalars['Float']['output']>;
  npsha_ft?: Maybe<Scalars['Float']['output']>;
  o2_percent?: Maybe<Scalars['Float']['output']>;
  oil_gravity_api?: Maybe<Scalars['Float']['output']>;
  surface_temperature_fahrenheit?: Maybe<Scalars['Float']['output']>;
  top_casing_length_feet?: Maybe<Scalars['Float']['output']>;
  top_of_perforations_measured_depth_feet?: Maybe<Scalars['Float']['output']>;
  top_of_perforations_true_vertical_depth_feet?: Maybe<Scalars['Float']['output']>;
  top_tubing_length_feet?: Maybe<Scalars['Float']['output']>;
  water_specific_gravity?: Maybe<Scalars['Float']['output']>;
  well_test_datum_point_measured_depth_feet?: Maybe<Scalars['Float']['output']>;
  well_test_gas_rate_mscf_day?: Maybe<Scalars['Float']['output']>;
  well_test_oil_rate_stb_day?: Maybe<Scalars['Float']['output']>;
  well_test_producing_bottom_hole_pressure_psia?: Maybe<Scalars['Float']['output']>;
  well_test_productivity_index?: Maybe<Scalars['Float']['output']>;
  well_test_static_bottom_hole_pressure_psia?: Maybe<Scalars['Float']['output']>;
  well_test_water_rate_stb_day?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "scenario_well_properties" */
export type Scenario_Well_Properties_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Scenario_Well_Properties_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Scenario_Well_Properties_Stream_Cursor_Value_Input = {
  ar_percent?: InputMaybe<Scalars['numeric']['input']>;
  average_dls?: InputMaybe<Scalars['numeric']['input']>;
  bottom_casing_id?: InputMaybe<Scalars['uuid']['input']>;
  bottom_casing_length_feet?: InputMaybe<Scalars['numeric']['input']>;
  bottom_tubing_id?: InputMaybe<Scalars['uuid']['input']>;
  bottom_tubing_length_feet?: InputMaybe<Scalars['numeric']['input']>;
  bottomhole_temperature_fahrenheit?: InputMaybe<Scalars['numeric']['input']>;
  bubble_point_pressure_psia?: InputMaybe<Scalars['numeric']['input']>;
  c1_methane_percent?: InputMaybe<Scalars['numeric']['input']>;
  c2_ethane_percent?: InputMaybe<Scalars['numeric']['input']>;
  c3_propane_percent?: InputMaybe<Scalars['numeric']['input']>;
  c6_hexane_percent?: InputMaybe<Scalars['numeric']['input']>;
  c7_heptane_percent?: InputMaybe<Scalars['numeric']['input']>;
  co2_percent?: InputMaybe<Scalars['numeric']['input']>;
  condensate_api_override?: InputMaybe<Scalars['numeric']['input']>;
  custom_fluid_properties?: InputMaybe<Scalars['jsonb']['input']>;
  custom_viscosities_properties?: InputMaybe<Scalars['jsonb']['input']>;
  deviation_survey_id?: InputMaybe<Scalars['uuid']['input']>;
  dew_point_pressure_psia_override?: InputMaybe<Scalars['numeric']['input']>;
  fluid_viscosity_override_cp?: InputMaybe<Scalars['numeric']['input']>;
  gas_specific_gravity?: InputMaybe<Scalars['numeric']['input']>;
  gas_type?: InputMaybe<Scalars['String']['input']>;
  h2s_percent?: InputMaybe<Scalars['numeric']['input']>;
  hps_liquid_type?: InputMaybe<Scalars['String']['input']>;
  hps_pump_inlet_pressure_psia?: InputMaybe<Scalars['numeric']['input']>;
  hps_pump_inlet_temperature_fahrenheit?: InputMaybe<Scalars['numeric']['input']>;
  hps_required_discharge_pressure_psia?: InputMaybe<Scalars['numeric']['input']>;
  ic4_isobutene_percent?: InputMaybe<Scalars['numeric']['input']>;
  ic5_isopentane_percent?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  journal_author_id?: InputMaybe<Scalars['String']['input']>;
  journal_created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  journal_deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  journal_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  n2_percent?: InputMaybe<Scalars['numeric']['input']>;
  nc4_butane_percent?: InputMaybe<Scalars['numeric']['input']>;
  nc5_bentane_percent?: InputMaybe<Scalars['numeric']['input']>;
  npsha_ft?: InputMaybe<Scalars['numeric']['input']>;
  o2_percent?: InputMaybe<Scalars['numeric']['input']>;
  oil_gravity_api?: InputMaybe<Scalars['numeric']['input']>;
  parent_id?: InputMaybe<Scalars['uuid']['input']>;
  surface_temperature_fahrenheit?: InputMaybe<Scalars['numeric']['input']>;
  top_casing_id?: InputMaybe<Scalars['uuid']['input']>;
  top_casing_length_feet?: InputMaybe<Scalars['numeric']['input']>;
  top_of_perforations_measured_depth_feet?: InputMaybe<Scalars['numeric']['input']>;
  top_of_perforations_true_vertical_depth_feet?: InputMaybe<Scalars['numeric']['input']>;
  top_tubing_id?: InputMaybe<Scalars['uuid']['input']>;
  top_tubing_length_feet?: InputMaybe<Scalars['numeric']['input']>;
  water_specific_gravity?: InputMaybe<Scalars['numeric']['input']>;
  well_test_datum_point_measured_depth_feet?: InputMaybe<Scalars['numeric']['input']>;
  well_test_gas_input_type?: InputMaybe<Scalars['String']['input']>;
  well_test_gas_rate_mscf_day?: InputMaybe<Scalars['numeric']['input']>;
  well_test_liquid_input_type?: InputMaybe<Scalars['String']['input']>;
  well_test_oil_rate_stb_day?: InputMaybe<Scalars['numeric']['input']>;
  well_test_pressure_input_type?: InputMaybe<Scalars['String']['input']>;
  well_test_producing_bottom_hole_pressure_psia?: InputMaybe<Scalars['numeric']['input']>;
  well_test_productivity_index?: InputMaybe<Scalars['numeric']['input']>;
  well_test_static_bottom_hole_pressure_psia?: InputMaybe<Scalars['numeric']['input']>;
  well_test_test_date?: InputMaybe<Scalars['timestamptz']['input']>;
  well_test_water_rate_stb_day?: InputMaybe<Scalars['numeric']['input']>;
  winning_revision_author_id?: InputMaybe<Scalars['String']['input']>;
  winning_revision_created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  winning_revision_deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  winning_revision_id?: InputMaybe<Scalars['uuid']['input']>;
  winning_revision_parent_id?: InputMaybe<Scalars['uuid']['input']>;
  winning_revision_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Scenario_Well_Properties_Sum_Fields = {
  __typename: 'scenario_well_properties_sum_fields';
  ar_percent?: Maybe<Scalars['numeric']['output']>;
  average_dls?: Maybe<Scalars['numeric']['output']>;
  bottom_casing_length_feet?: Maybe<Scalars['numeric']['output']>;
  bottom_tubing_length_feet?: Maybe<Scalars['numeric']['output']>;
  bottomhole_temperature_fahrenheit?: Maybe<Scalars['numeric']['output']>;
  bubble_point_pressure_psia?: Maybe<Scalars['numeric']['output']>;
  c1_methane_percent?: Maybe<Scalars['numeric']['output']>;
  c2_ethane_percent?: Maybe<Scalars['numeric']['output']>;
  c3_propane_percent?: Maybe<Scalars['numeric']['output']>;
  c6_hexane_percent?: Maybe<Scalars['numeric']['output']>;
  c7_heptane_percent?: Maybe<Scalars['numeric']['output']>;
  co2_percent?: Maybe<Scalars['numeric']['output']>;
  condensate_api_override?: Maybe<Scalars['numeric']['output']>;
  dew_point_pressure_psia_override?: Maybe<Scalars['numeric']['output']>;
  fluid_viscosity_override_cp?: Maybe<Scalars['numeric']['output']>;
  gas_specific_gravity?: Maybe<Scalars['numeric']['output']>;
  h2s_percent?: Maybe<Scalars['numeric']['output']>;
  hps_pump_inlet_pressure_psia?: Maybe<Scalars['numeric']['output']>;
  hps_pump_inlet_temperature_fahrenheit?: Maybe<Scalars['numeric']['output']>;
  hps_required_discharge_pressure_psia?: Maybe<Scalars['numeric']['output']>;
  ic4_isobutene_percent?: Maybe<Scalars['numeric']['output']>;
  ic5_isopentane_percent?: Maybe<Scalars['numeric']['output']>;
  n2_percent?: Maybe<Scalars['numeric']['output']>;
  nc4_butane_percent?: Maybe<Scalars['numeric']['output']>;
  nc5_bentane_percent?: Maybe<Scalars['numeric']['output']>;
  npsha_ft?: Maybe<Scalars['numeric']['output']>;
  o2_percent?: Maybe<Scalars['numeric']['output']>;
  oil_gravity_api?: Maybe<Scalars['numeric']['output']>;
  surface_temperature_fahrenheit?: Maybe<Scalars['numeric']['output']>;
  top_casing_length_feet?: Maybe<Scalars['numeric']['output']>;
  top_of_perforations_measured_depth_feet?: Maybe<Scalars['numeric']['output']>;
  top_of_perforations_true_vertical_depth_feet?: Maybe<Scalars['numeric']['output']>;
  top_tubing_length_feet?: Maybe<Scalars['numeric']['output']>;
  water_specific_gravity?: Maybe<Scalars['numeric']['output']>;
  well_test_datum_point_measured_depth_feet?: Maybe<Scalars['numeric']['output']>;
  well_test_gas_rate_mscf_day?: Maybe<Scalars['numeric']['output']>;
  well_test_oil_rate_stb_day?: Maybe<Scalars['numeric']['output']>;
  well_test_producing_bottom_hole_pressure_psia?: Maybe<Scalars['numeric']['output']>;
  well_test_productivity_index?: Maybe<Scalars['numeric']['output']>;
  well_test_static_bottom_hole_pressure_psia?: Maybe<Scalars['numeric']['output']>;
  well_test_water_rate_stb_day?: Maybe<Scalars['numeric']['output']>;
};

/** aggregate var_pop on columns */
export type Scenario_Well_Properties_Var_Pop_Fields = {
  __typename: 'scenario_well_properties_var_pop_fields';
  ar_percent?: Maybe<Scalars['Float']['output']>;
  average_dls?: Maybe<Scalars['Float']['output']>;
  bottom_casing_length_feet?: Maybe<Scalars['Float']['output']>;
  bottom_tubing_length_feet?: Maybe<Scalars['Float']['output']>;
  bottomhole_temperature_fahrenheit?: Maybe<Scalars['Float']['output']>;
  bubble_point_pressure_psia?: Maybe<Scalars['Float']['output']>;
  c1_methane_percent?: Maybe<Scalars['Float']['output']>;
  c2_ethane_percent?: Maybe<Scalars['Float']['output']>;
  c3_propane_percent?: Maybe<Scalars['Float']['output']>;
  c6_hexane_percent?: Maybe<Scalars['Float']['output']>;
  c7_heptane_percent?: Maybe<Scalars['Float']['output']>;
  co2_percent?: Maybe<Scalars['Float']['output']>;
  condensate_api_override?: Maybe<Scalars['Float']['output']>;
  dew_point_pressure_psia_override?: Maybe<Scalars['Float']['output']>;
  fluid_viscosity_override_cp?: Maybe<Scalars['Float']['output']>;
  gas_specific_gravity?: Maybe<Scalars['Float']['output']>;
  h2s_percent?: Maybe<Scalars['Float']['output']>;
  hps_pump_inlet_pressure_psia?: Maybe<Scalars['Float']['output']>;
  hps_pump_inlet_temperature_fahrenheit?: Maybe<Scalars['Float']['output']>;
  hps_required_discharge_pressure_psia?: Maybe<Scalars['Float']['output']>;
  ic4_isobutene_percent?: Maybe<Scalars['Float']['output']>;
  ic5_isopentane_percent?: Maybe<Scalars['Float']['output']>;
  n2_percent?: Maybe<Scalars['Float']['output']>;
  nc4_butane_percent?: Maybe<Scalars['Float']['output']>;
  nc5_bentane_percent?: Maybe<Scalars['Float']['output']>;
  npsha_ft?: Maybe<Scalars['Float']['output']>;
  o2_percent?: Maybe<Scalars['Float']['output']>;
  oil_gravity_api?: Maybe<Scalars['Float']['output']>;
  surface_temperature_fahrenheit?: Maybe<Scalars['Float']['output']>;
  top_casing_length_feet?: Maybe<Scalars['Float']['output']>;
  top_of_perforations_measured_depth_feet?: Maybe<Scalars['Float']['output']>;
  top_of_perforations_true_vertical_depth_feet?: Maybe<Scalars['Float']['output']>;
  top_tubing_length_feet?: Maybe<Scalars['Float']['output']>;
  water_specific_gravity?: Maybe<Scalars['Float']['output']>;
  well_test_datum_point_measured_depth_feet?: Maybe<Scalars['Float']['output']>;
  well_test_gas_rate_mscf_day?: Maybe<Scalars['Float']['output']>;
  well_test_oil_rate_stb_day?: Maybe<Scalars['Float']['output']>;
  well_test_producing_bottom_hole_pressure_psia?: Maybe<Scalars['Float']['output']>;
  well_test_productivity_index?: Maybe<Scalars['Float']['output']>;
  well_test_static_bottom_hole_pressure_psia?: Maybe<Scalars['Float']['output']>;
  well_test_water_rate_stb_day?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Scenario_Well_Properties_Var_Samp_Fields = {
  __typename: 'scenario_well_properties_var_samp_fields';
  ar_percent?: Maybe<Scalars['Float']['output']>;
  average_dls?: Maybe<Scalars['Float']['output']>;
  bottom_casing_length_feet?: Maybe<Scalars['Float']['output']>;
  bottom_tubing_length_feet?: Maybe<Scalars['Float']['output']>;
  bottomhole_temperature_fahrenheit?: Maybe<Scalars['Float']['output']>;
  bubble_point_pressure_psia?: Maybe<Scalars['Float']['output']>;
  c1_methane_percent?: Maybe<Scalars['Float']['output']>;
  c2_ethane_percent?: Maybe<Scalars['Float']['output']>;
  c3_propane_percent?: Maybe<Scalars['Float']['output']>;
  c6_hexane_percent?: Maybe<Scalars['Float']['output']>;
  c7_heptane_percent?: Maybe<Scalars['Float']['output']>;
  co2_percent?: Maybe<Scalars['Float']['output']>;
  condensate_api_override?: Maybe<Scalars['Float']['output']>;
  dew_point_pressure_psia_override?: Maybe<Scalars['Float']['output']>;
  fluid_viscosity_override_cp?: Maybe<Scalars['Float']['output']>;
  gas_specific_gravity?: Maybe<Scalars['Float']['output']>;
  h2s_percent?: Maybe<Scalars['Float']['output']>;
  hps_pump_inlet_pressure_psia?: Maybe<Scalars['Float']['output']>;
  hps_pump_inlet_temperature_fahrenheit?: Maybe<Scalars['Float']['output']>;
  hps_required_discharge_pressure_psia?: Maybe<Scalars['Float']['output']>;
  ic4_isobutene_percent?: Maybe<Scalars['Float']['output']>;
  ic5_isopentane_percent?: Maybe<Scalars['Float']['output']>;
  n2_percent?: Maybe<Scalars['Float']['output']>;
  nc4_butane_percent?: Maybe<Scalars['Float']['output']>;
  nc5_bentane_percent?: Maybe<Scalars['Float']['output']>;
  npsha_ft?: Maybe<Scalars['Float']['output']>;
  o2_percent?: Maybe<Scalars['Float']['output']>;
  oil_gravity_api?: Maybe<Scalars['Float']['output']>;
  surface_temperature_fahrenheit?: Maybe<Scalars['Float']['output']>;
  top_casing_length_feet?: Maybe<Scalars['Float']['output']>;
  top_of_perforations_measured_depth_feet?: Maybe<Scalars['Float']['output']>;
  top_of_perforations_true_vertical_depth_feet?: Maybe<Scalars['Float']['output']>;
  top_tubing_length_feet?: Maybe<Scalars['Float']['output']>;
  water_specific_gravity?: Maybe<Scalars['Float']['output']>;
  well_test_datum_point_measured_depth_feet?: Maybe<Scalars['Float']['output']>;
  well_test_gas_rate_mscf_day?: Maybe<Scalars['Float']['output']>;
  well_test_oil_rate_stb_day?: Maybe<Scalars['Float']['output']>;
  well_test_producing_bottom_hole_pressure_psia?: Maybe<Scalars['Float']['output']>;
  well_test_productivity_index?: Maybe<Scalars['Float']['output']>;
  well_test_static_bottom_hole_pressure_psia?: Maybe<Scalars['Float']['output']>;
  well_test_water_rate_stb_day?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Scenario_Well_Properties_Variance_Fields = {
  __typename: 'scenario_well_properties_variance_fields';
  ar_percent?: Maybe<Scalars['Float']['output']>;
  average_dls?: Maybe<Scalars['Float']['output']>;
  bottom_casing_length_feet?: Maybe<Scalars['Float']['output']>;
  bottom_tubing_length_feet?: Maybe<Scalars['Float']['output']>;
  bottomhole_temperature_fahrenheit?: Maybe<Scalars['Float']['output']>;
  bubble_point_pressure_psia?: Maybe<Scalars['Float']['output']>;
  c1_methane_percent?: Maybe<Scalars['Float']['output']>;
  c2_ethane_percent?: Maybe<Scalars['Float']['output']>;
  c3_propane_percent?: Maybe<Scalars['Float']['output']>;
  c6_hexane_percent?: Maybe<Scalars['Float']['output']>;
  c7_heptane_percent?: Maybe<Scalars['Float']['output']>;
  co2_percent?: Maybe<Scalars['Float']['output']>;
  condensate_api_override?: Maybe<Scalars['Float']['output']>;
  dew_point_pressure_psia_override?: Maybe<Scalars['Float']['output']>;
  fluid_viscosity_override_cp?: Maybe<Scalars['Float']['output']>;
  gas_specific_gravity?: Maybe<Scalars['Float']['output']>;
  h2s_percent?: Maybe<Scalars['Float']['output']>;
  hps_pump_inlet_pressure_psia?: Maybe<Scalars['Float']['output']>;
  hps_pump_inlet_temperature_fahrenheit?: Maybe<Scalars['Float']['output']>;
  hps_required_discharge_pressure_psia?: Maybe<Scalars['Float']['output']>;
  ic4_isobutene_percent?: Maybe<Scalars['Float']['output']>;
  ic5_isopentane_percent?: Maybe<Scalars['Float']['output']>;
  n2_percent?: Maybe<Scalars['Float']['output']>;
  nc4_butane_percent?: Maybe<Scalars['Float']['output']>;
  nc5_bentane_percent?: Maybe<Scalars['Float']['output']>;
  npsha_ft?: Maybe<Scalars['Float']['output']>;
  o2_percent?: Maybe<Scalars['Float']['output']>;
  oil_gravity_api?: Maybe<Scalars['Float']['output']>;
  surface_temperature_fahrenheit?: Maybe<Scalars['Float']['output']>;
  top_casing_length_feet?: Maybe<Scalars['Float']['output']>;
  top_of_perforations_measured_depth_feet?: Maybe<Scalars['Float']['output']>;
  top_of_perforations_true_vertical_depth_feet?: Maybe<Scalars['Float']['output']>;
  top_tubing_length_feet?: Maybe<Scalars['Float']['output']>;
  water_specific_gravity?: Maybe<Scalars['Float']['output']>;
  well_test_datum_point_measured_depth_feet?: Maybe<Scalars['Float']['output']>;
  well_test_gas_rate_mscf_day?: Maybe<Scalars['Float']['output']>;
  well_test_oil_rate_stb_day?: Maybe<Scalars['Float']['output']>;
  well_test_producing_bottom_hole_pressure_psia?: Maybe<Scalars['Float']['output']>;
  well_test_productivity_index?: Maybe<Scalars['Float']['output']>;
  well_test_static_bottom_hole_pressure_psia?: Maybe<Scalars['Float']['output']>;
  well_test_water_rate_stb_day?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "scenarios" */
export type Scenarios = {
  __typename: 'scenarios';
  /** An object relationship */
  author?: Maybe<Users>;
  /** An object relationship */
  clonedFrom?: Maybe<Scenarios>;
  /** An object relationship */
  correlations?: Maybe<Scenario_Correlations>;
  correlations_id?: Maybe<Scalars['uuid']['output']>;
  display_unit_overrides?: Maybe<Scalars['jsonb']['output']>;
  /** An object relationship */
  equipment?: Maybe<Scenario_Equipment>;
  id?: Maybe<Scalars['uuid']['output']>;
  internal_notes?: Maybe<Scalars['String']['output']>;
  journal_author_id?: Maybe<Scalars['String']['output']>;
  journal_created_at?: Maybe<Scalars['timestamptz']['output']>;
  journal_deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  journal_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  parameters?: Maybe<Scenario_Parameters>;
  parameters_id?: Maybe<Scalars['uuid']['output']>;
  parent_id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  performance_evaluations: Array<Performance_Evaluations>;
  /** An aggregate relationship */
  performance_evaluations_aggregate: Performance_Evaluations_Aggregate;
  pumping_type?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  quotes: Array<Quotes>;
  /** An aggregate relationship */
  quotes_aggregate: Quotes_Aggregate;
  reason?: Maybe<Scalars['String']['output']>;
  scenario_equipment_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  sizing?: Maybe<Sizings>;
  sizing_id?: Maybe<Scalars['uuid']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  well_properties?: Maybe<Scenario_Well_Properties>;
  well_properties_id?: Maybe<Scalars['uuid']['output']>;
  winning_revision_author_id?: Maybe<Scalars['String']['output']>;
  winning_revision_created_at?: Maybe<Scalars['timestamptz']['output']>;
  winning_revision_deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  winning_revision_id?: Maybe<Scalars['uuid']['output']>;
  winning_revision_parent_id?: Maybe<Scalars['uuid']['output']>;
  winning_revision_updated_at?: Maybe<Scalars['timestamptz']['output']>;
};


/** columns and relationships of "scenarios" */
export type ScenariosDisplay_Unit_OverridesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "scenarios" */
export type ScenariosPerformance_EvaluationsArgs = {
  distinct_on?: InputMaybe<Array<Performance_Evaluations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Performance_Evaluations_Order_By>>;
  where?: InputMaybe<Performance_Evaluations_Bool_Exp>;
};


/** columns and relationships of "scenarios" */
export type ScenariosPerformance_Evaluations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Performance_Evaluations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Performance_Evaluations_Order_By>>;
  where?: InputMaybe<Performance_Evaluations_Bool_Exp>;
};


/** columns and relationships of "scenarios" */
export type ScenariosQuotesArgs = {
  distinct_on?: InputMaybe<Array<Quotes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quotes_Order_By>>;
  where?: InputMaybe<Quotes_Bool_Exp>;
};


/** columns and relationships of "scenarios" */
export type ScenariosQuotes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quotes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quotes_Order_By>>;
  where?: InputMaybe<Quotes_Bool_Exp>;
};

/** aggregated selection of "scenarios" */
export type Scenarios_Aggregate = {
  __typename: 'scenarios_aggregate';
  aggregate?: Maybe<Scenarios_Aggregate_Fields>;
  nodes: Array<Scenarios>;
};

export type Scenarios_Aggregate_Bool_Exp = {
  count?: InputMaybe<Scenarios_Aggregate_Bool_Exp_Count>;
};

export type Scenarios_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Scenarios_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Scenarios_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "scenarios" */
export type Scenarios_Aggregate_Fields = {
  __typename: 'scenarios_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Scenarios_Max_Fields>;
  min?: Maybe<Scenarios_Min_Fields>;
};


/** aggregate fields of "scenarios" */
export type Scenarios_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Scenarios_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "scenarios" */
export type Scenarios_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Scenarios_Max_Order_By>;
  min?: InputMaybe<Scenarios_Min_Order_By>;
};

/** input type for inserting array relation for remote table "scenarios" */
export type Scenarios_Arr_Rel_Insert_Input = {
  data: Array<Scenarios_Insert_Input>;
};

/** Boolean expression to filter rows from the table "scenarios". All fields are combined with a logical 'AND'. */
export type Scenarios_Bool_Exp = {
  _and?: InputMaybe<Array<Scenarios_Bool_Exp>>;
  _not?: InputMaybe<Scenarios_Bool_Exp>;
  _or?: InputMaybe<Array<Scenarios_Bool_Exp>>;
  author?: InputMaybe<Users_Bool_Exp>;
  clonedFrom?: InputMaybe<Scenarios_Bool_Exp>;
  correlations?: InputMaybe<Scenario_Correlations_Bool_Exp>;
  correlations_id?: InputMaybe<Uuid_Comparison_Exp>;
  display_unit_overrides?: InputMaybe<Jsonb_Comparison_Exp>;
  equipment?: InputMaybe<Scenario_Equipment_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  internal_notes?: InputMaybe<String_Comparison_Exp>;
  journal_author_id?: InputMaybe<String_Comparison_Exp>;
  journal_created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  journal_deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  journal_updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  notes?: InputMaybe<String_Comparison_Exp>;
  parameters?: InputMaybe<Scenario_Parameters_Bool_Exp>;
  parameters_id?: InputMaybe<Uuid_Comparison_Exp>;
  parent_id?: InputMaybe<Uuid_Comparison_Exp>;
  performance_evaluations?: InputMaybe<Performance_Evaluations_Bool_Exp>;
  performance_evaluations_aggregate?: InputMaybe<Performance_Evaluations_Aggregate_Bool_Exp>;
  pumping_type?: InputMaybe<String_Comparison_Exp>;
  quotes?: InputMaybe<Quotes_Bool_Exp>;
  quotes_aggregate?: InputMaybe<Quotes_Aggregate_Bool_Exp>;
  reason?: InputMaybe<String_Comparison_Exp>;
  scenario_equipment_id?: InputMaybe<Uuid_Comparison_Exp>;
  sizing?: InputMaybe<Sizings_Bool_Exp>;
  sizing_id?: InputMaybe<Uuid_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  well_properties?: InputMaybe<Scenario_Well_Properties_Bool_Exp>;
  well_properties_id?: InputMaybe<Uuid_Comparison_Exp>;
  winning_revision_author_id?: InputMaybe<String_Comparison_Exp>;
  winning_revision_created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  winning_revision_deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  winning_revision_id?: InputMaybe<Uuid_Comparison_Exp>;
  winning_revision_parent_id?: InputMaybe<Uuid_Comparison_Exp>;
  winning_revision_updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** input type for inserting data into table "scenarios" */
export type Scenarios_Insert_Input = {
  author?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  clonedFrom?: InputMaybe<Scenarios_Obj_Rel_Insert_Input>;
  correlations?: InputMaybe<Scenario_Correlations_Obj_Rel_Insert_Input>;
  correlations_id?: InputMaybe<Scalars['uuid']['input']>;
  display_unit_overrides?: InputMaybe<Scalars['jsonb']['input']>;
  equipment?: InputMaybe<Scenario_Equipment_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  internal_notes?: InputMaybe<Scalars['String']['input']>;
  journal_author_id?: InputMaybe<Scalars['String']['input']>;
  journal_created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  journal_deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  journal_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  parameters?: InputMaybe<Scenario_Parameters_Obj_Rel_Insert_Input>;
  parameters_id?: InputMaybe<Scalars['uuid']['input']>;
  parent_id?: InputMaybe<Scalars['uuid']['input']>;
  performance_evaluations?: InputMaybe<Performance_Evaluations_Arr_Rel_Insert_Input>;
  pumping_type?: InputMaybe<Scalars['String']['input']>;
  quotes?: InputMaybe<Quotes_Arr_Rel_Insert_Input>;
  reason?: InputMaybe<Scalars['String']['input']>;
  scenario_equipment_id?: InputMaybe<Scalars['uuid']['input']>;
  sizing?: InputMaybe<Sizings_Obj_Rel_Insert_Input>;
  sizing_id?: InputMaybe<Scalars['uuid']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  well_properties?: InputMaybe<Scenario_Well_Properties_Obj_Rel_Insert_Input>;
  well_properties_id?: InputMaybe<Scalars['uuid']['input']>;
  winning_revision_author_id?: InputMaybe<Scalars['String']['input']>;
  winning_revision_created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  winning_revision_deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  winning_revision_id?: InputMaybe<Scalars['uuid']['input']>;
  winning_revision_parent_id?: InputMaybe<Scalars['uuid']['input']>;
  winning_revision_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Scenarios_Max_Fields = {
  __typename: 'scenarios_max_fields';
  correlations_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  internal_notes?: Maybe<Scalars['String']['output']>;
  journal_author_id?: Maybe<Scalars['String']['output']>;
  journal_created_at?: Maybe<Scalars['timestamptz']['output']>;
  journal_deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  journal_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  parameters_id?: Maybe<Scalars['uuid']['output']>;
  parent_id?: Maybe<Scalars['uuid']['output']>;
  pumping_type?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  scenario_equipment_id?: Maybe<Scalars['uuid']['output']>;
  sizing_id?: Maybe<Scalars['uuid']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  well_properties_id?: Maybe<Scalars['uuid']['output']>;
  winning_revision_author_id?: Maybe<Scalars['String']['output']>;
  winning_revision_created_at?: Maybe<Scalars['timestamptz']['output']>;
  winning_revision_deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  winning_revision_id?: Maybe<Scalars['uuid']['output']>;
  winning_revision_parent_id?: Maybe<Scalars['uuid']['output']>;
  winning_revision_updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "scenarios" */
export type Scenarios_Max_Order_By = {
  correlations_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  internal_notes?: InputMaybe<Order_By>;
  journal_author_id?: InputMaybe<Order_By>;
  journal_created_at?: InputMaybe<Order_By>;
  journal_deleted_at?: InputMaybe<Order_By>;
  journal_updated_at?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  parameters_id?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  pumping_type?: InputMaybe<Order_By>;
  reason?: InputMaybe<Order_By>;
  scenario_equipment_id?: InputMaybe<Order_By>;
  sizing_id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  well_properties_id?: InputMaybe<Order_By>;
  winning_revision_author_id?: InputMaybe<Order_By>;
  winning_revision_created_at?: InputMaybe<Order_By>;
  winning_revision_deleted_at?: InputMaybe<Order_By>;
  winning_revision_id?: InputMaybe<Order_By>;
  winning_revision_parent_id?: InputMaybe<Order_By>;
  winning_revision_updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Scenarios_Min_Fields = {
  __typename: 'scenarios_min_fields';
  correlations_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  internal_notes?: Maybe<Scalars['String']['output']>;
  journal_author_id?: Maybe<Scalars['String']['output']>;
  journal_created_at?: Maybe<Scalars['timestamptz']['output']>;
  journal_deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  journal_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  parameters_id?: Maybe<Scalars['uuid']['output']>;
  parent_id?: Maybe<Scalars['uuid']['output']>;
  pumping_type?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  scenario_equipment_id?: Maybe<Scalars['uuid']['output']>;
  sizing_id?: Maybe<Scalars['uuid']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  well_properties_id?: Maybe<Scalars['uuid']['output']>;
  winning_revision_author_id?: Maybe<Scalars['String']['output']>;
  winning_revision_created_at?: Maybe<Scalars['timestamptz']['output']>;
  winning_revision_deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  winning_revision_id?: Maybe<Scalars['uuid']['output']>;
  winning_revision_parent_id?: Maybe<Scalars['uuid']['output']>;
  winning_revision_updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "scenarios" */
export type Scenarios_Min_Order_By = {
  correlations_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  internal_notes?: InputMaybe<Order_By>;
  journal_author_id?: InputMaybe<Order_By>;
  journal_created_at?: InputMaybe<Order_By>;
  journal_deleted_at?: InputMaybe<Order_By>;
  journal_updated_at?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  parameters_id?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  pumping_type?: InputMaybe<Order_By>;
  reason?: InputMaybe<Order_By>;
  scenario_equipment_id?: InputMaybe<Order_By>;
  sizing_id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  well_properties_id?: InputMaybe<Order_By>;
  winning_revision_author_id?: InputMaybe<Order_By>;
  winning_revision_created_at?: InputMaybe<Order_By>;
  winning_revision_deleted_at?: InputMaybe<Order_By>;
  winning_revision_id?: InputMaybe<Order_By>;
  winning_revision_parent_id?: InputMaybe<Order_By>;
  winning_revision_updated_at?: InputMaybe<Order_By>;
};

/** input type for inserting object relation for remote table "scenarios" */
export type Scenarios_Obj_Rel_Insert_Input = {
  data: Scenarios_Insert_Input;
};

/** Ordering options when selecting data from "scenarios". */
export type Scenarios_Order_By = {
  author?: InputMaybe<Users_Order_By>;
  clonedFrom?: InputMaybe<Scenarios_Order_By>;
  correlations?: InputMaybe<Scenario_Correlations_Order_By>;
  correlations_id?: InputMaybe<Order_By>;
  display_unit_overrides?: InputMaybe<Order_By>;
  equipment?: InputMaybe<Scenario_Equipment_Order_By>;
  id?: InputMaybe<Order_By>;
  internal_notes?: InputMaybe<Order_By>;
  journal_author_id?: InputMaybe<Order_By>;
  journal_created_at?: InputMaybe<Order_By>;
  journal_deleted_at?: InputMaybe<Order_By>;
  journal_updated_at?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  parameters?: InputMaybe<Scenario_Parameters_Order_By>;
  parameters_id?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  performance_evaluations_aggregate?: InputMaybe<Performance_Evaluations_Aggregate_Order_By>;
  pumping_type?: InputMaybe<Order_By>;
  quotes_aggregate?: InputMaybe<Quotes_Aggregate_Order_By>;
  reason?: InputMaybe<Order_By>;
  scenario_equipment_id?: InputMaybe<Order_By>;
  sizing?: InputMaybe<Sizings_Order_By>;
  sizing_id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  well_properties?: InputMaybe<Scenario_Well_Properties_Order_By>;
  well_properties_id?: InputMaybe<Order_By>;
  winning_revision_author_id?: InputMaybe<Order_By>;
  winning_revision_created_at?: InputMaybe<Order_By>;
  winning_revision_deleted_at?: InputMaybe<Order_By>;
  winning_revision_id?: InputMaybe<Order_By>;
  winning_revision_parent_id?: InputMaybe<Order_By>;
  winning_revision_updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "scenarios" */
export enum Scenarios_Select_Column {
  /** column name */
  CorrelationsId = 'correlations_id',
  /** column name */
  DisplayUnitOverrides = 'display_unit_overrides',
  /** column name */
  Id = 'id',
  /** column name */
  InternalNotes = 'internal_notes',
  /** column name */
  JournalAuthorId = 'journal_author_id',
  /** column name */
  JournalCreatedAt = 'journal_created_at',
  /** column name */
  JournalDeletedAt = 'journal_deleted_at',
  /** column name */
  JournalUpdatedAt = 'journal_updated_at',
  /** column name */
  Notes = 'notes',
  /** column name */
  ParametersId = 'parameters_id',
  /** column name */
  ParentId = 'parent_id',
  /** column name */
  PumpingType = 'pumping_type',
  /** column name */
  Reason = 'reason',
  /** column name */
  ScenarioEquipmentId = 'scenario_equipment_id',
  /** column name */
  SizingId = 'sizing_id',
  /** column name */
  Title = 'title',
  /** column name */
  WellPropertiesId = 'well_properties_id',
  /** column name */
  WinningRevisionAuthorId = 'winning_revision_author_id',
  /** column name */
  WinningRevisionCreatedAt = 'winning_revision_created_at',
  /** column name */
  WinningRevisionDeletedAt = 'winning_revision_deleted_at',
  /** column name */
  WinningRevisionId = 'winning_revision_id',
  /** column name */
  WinningRevisionParentId = 'winning_revision_parent_id',
  /** column name */
  WinningRevisionUpdatedAt = 'winning_revision_updated_at'
}

/** Streaming cursor of the table "scenarios" */
export type Scenarios_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Scenarios_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Scenarios_Stream_Cursor_Value_Input = {
  correlations_id?: InputMaybe<Scalars['uuid']['input']>;
  display_unit_overrides?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  internal_notes?: InputMaybe<Scalars['String']['input']>;
  journal_author_id?: InputMaybe<Scalars['String']['input']>;
  journal_created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  journal_deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  journal_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  parameters_id?: InputMaybe<Scalars['uuid']['input']>;
  parent_id?: InputMaybe<Scalars['uuid']['input']>;
  pumping_type?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  scenario_equipment_id?: InputMaybe<Scalars['uuid']['input']>;
  sizing_id?: InputMaybe<Scalars['uuid']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  well_properties_id?: InputMaybe<Scalars['uuid']['input']>;
  winning_revision_author_id?: InputMaybe<Scalars['String']['input']>;
  winning_revision_created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  winning_revision_deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  winning_revision_id?: InputMaybe<Scalars['uuid']['input']>;
  winning_revision_parent_id?: InputMaybe<Scalars['uuid']['input']>;
  winning_revision_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** columns and relationships of "seal_motor_oil" */
export type Seal_Motor_Oil = {
  __typename: 'seal_motor_oil';
  created_at: Scalars['timestamptz']['output'];
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  include_ecopetrol_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  include_koc_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  max_temp_fahrenheit?: Maybe<Scalars['Int']['output']>;
  mf_test_temp1_celsius?: Maybe<Scalars['Int']['output']>;
  mf_test_temp2_celsius?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  only_ecopetrol_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  only_koc_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  specific_gravity?: Maybe<Scalars['numeric']['output']>;
  thermal_expansion_factor?: Maybe<Scalars['numeric']['output']>;
  updated_at: Scalars['timestamptz']['output'];
  viscosity_test1_centistroke?: Maybe<Scalars['numeric']['output']>;
  viscosity_test2_centistroke?: Maybe<Scalars['numeric']['output']>;
};

/** aggregated selection of "seal_motor_oil" */
export type Seal_Motor_Oil_Aggregate = {
  __typename: 'seal_motor_oil_aggregate';
  aggregate?: Maybe<Seal_Motor_Oil_Aggregate_Fields>;
  nodes: Array<Seal_Motor_Oil>;
};

/** aggregate fields of "seal_motor_oil" */
export type Seal_Motor_Oil_Aggregate_Fields = {
  __typename: 'seal_motor_oil_aggregate_fields';
  avg?: Maybe<Seal_Motor_Oil_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Seal_Motor_Oil_Max_Fields>;
  min?: Maybe<Seal_Motor_Oil_Min_Fields>;
  stddev?: Maybe<Seal_Motor_Oil_Stddev_Fields>;
  stddev_pop?: Maybe<Seal_Motor_Oil_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Seal_Motor_Oil_Stddev_Samp_Fields>;
  sum?: Maybe<Seal_Motor_Oil_Sum_Fields>;
  var_pop?: Maybe<Seal_Motor_Oil_Var_Pop_Fields>;
  var_samp?: Maybe<Seal_Motor_Oil_Var_Samp_Fields>;
  variance?: Maybe<Seal_Motor_Oil_Variance_Fields>;
};


/** aggregate fields of "seal_motor_oil" */
export type Seal_Motor_Oil_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Seal_Motor_Oil_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Seal_Motor_Oil_Avg_Fields = {
  __typename: 'seal_motor_oil_avg_fields';
  max_temp_fahrenheit?: Maybe<Scalars['Float']['output']>;
  mf_test_temp1_celsius?: Maybe<Scalars['Float']['output']>;
  mf_test_temp2_celsius?: Maybe<Scalars['Float']['output']>;
  specific_gravity?: Maybe<Scalars['Float']['output']>;
  thermal_expansion_factor?: Maybe<Scalars['Float']['output']>;
  viscosity_test1_centistroke?: Maybe<Scalars['Float']['output']>;
  viscosity_test2_centistroke?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "seal_motor_oil". All fields are combined with a logical 'AND'. */
export type Seal_Motor_Oil_Bool_Exp = {
  _and?: InputMaybe<Array<Seal_Motor_Oil_Bool_Exp>>;
  _not?: InputMaybe<Seal_Motor_Oil_Bool_Exp>;
  _or?: InputMaybe<Array<Seal_Motor_Oil_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  include_ecopetrol_timestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  include_koc_timestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  max_temp_fahrenheit?: InputMaybe<Int_Comparison_Exp>;
  mf_test_temp1_celsius?: InputMaybe<Int_Comparison_Exp>;
  mf_test_temp2_celsius?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  only_ecopetrol_timestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  only_koc_timestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  specific_gravity?: InputMaybe<Numeric_Comparison_Exp>;
  thermal_expansion_factor?: InputMaybe<Numeric_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  viscosity_test1_centistroke?: InputMaybe<Numeric_Comparison_Exp>;
  viscosity_test2_centistroke?: InputMaybe<Numeric_Comparison_Exp>;
};

/** unique or primary key constraints on table "seal_motor_oil" */
export enum Seal_Motor_Oil_Constraint {
  /** unique or primary key constraint on columns "id" */
  SealMotorOilPkey = 'seal_motor_oil_pkey'
}

/** input type for incrementing numeric columns in table "seal_motor_oil" */
export type Seal_Motor_Oil_Inc_Input = {
  max_temp_fahrenheit?: InputMaybe<Scalars['Int']['input']>;
  mf_test_temp1_celsius?: InputMaybe<Scalars['Int']['input']>;
  mf_test_temp2_celsius?: InputMaybe<Scalars['Int']['input']>;
  specific_gravity?: InputMaybe<Scalars['numeric']['input']>;
  thermal_expansion_factor?: InputMaybe<Scalars['numeric']['input']>;
  viscosity_test1_centistroke?: InputMaybe<Scalars['numeric']['input']>;
  viscosity_test2_centistroke?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "seal_motor_oil" */
export type Seal_Motor_Oil_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  include_ecopetrol_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  include_koc_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  max_temp_fahrenheit?: InputMaybe<Scalars['Int']['input']>;
  mf_test_temp1_celsius?: InputMaybe<Scalars['Int']['input']>;
  mf_test_temp2_celsius?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  only_ecopetrol_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  only_koc_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  specific_gravity?: InputMaybe<Scalars['numeric']['input']>;
  thermal_expansion_factor?: InputMaybe<Scalars['numeric']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  viscosity_test1_centistroke?: InputMaybe<Scalars['numeric']['input']>;
  viscosity_test2_centistroke?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate max on columns */
export type Seal_Motor_Oil_Max_Fields = {
  __typename: 'seal_motor_oil_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  include_ecopetrol_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  include_koc_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  max_temp_fahrenheit?: Maybe<Scalars['Int']['output']>;
  mf_test_temp1_celsius?: Maybe<Scalars['Int']['output']>;
  mf_test_temp2_celsius?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  only_ecopetrol_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  only_koc_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  specific_gravity?: Maybe<Scalars['numeric']['output']>;
  thermal_expansion_factor?: Maybe<Scalars['numeric']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  viscosity_test1_centistroke?: Maybe<Scalars['numeric']['output']>;
  viscosity_test2_centistroke?: Maybe<Scalars['numeric']['output']>;
};

/** aggregate min on columns */
export type Seal_Motor_Oil_Min_Fields = {
  __typename: 'seal_motor_oil_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  include_ecopetrol_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  include_koc_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  max_temp_fahrenheit?: Maybe<Scalars['Int']['output']>;
  mf_test_temp1_celsius?: Maybe<Scalars['Int']['output']>;
  mf_test_temp2_celsius?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  only_ecopetrol_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  only_koc_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  specific_gravity?: Maybe<Scalars['numeric']['output']>;
  thermal_expansion_factor?: Maybe<Scalars['numeric']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  viscosity_test1_centistroke?: Maybe<Scalars['numeric']['output']>;
  viscosity_test2_centistroke?: Maybe<Scalars['numeric']['output']>;
};

/** response of any mutation on the table "seal_motor_oil" */
export type Seal_Motor_Oil_Mutation_Response = {
  __typename: 'seal_motor_oil_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Seal_Motor_Oil>;
};

/** input type for inserting object relation for remote table "seal_motor_oil" */
export type Seal_Motor_Oil_Obj_Rel_Insert_Input = {
  data: Seal_Motor_Oil_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Seal_Motor_Oil_On_Conflict>;
};

/** on_conflict condition type for table "seal_motor_oil" */
export type Seal_Motor_Oil_On_Conflict = {
  constraint: Seal_Motor_Oil_Constraint;
  update_columns?: Array<Seal_Motor_Oil_Update_Column>;
  where?: InputMaybe<Seal_Motor_Oil_Bool_Exp>;
};

/** Ordering options when selecting data from "seal_motor_oil". */
export type Seal_Motor_Oil_Order_By = {
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  include_ecopetrol_timestamp?: InputMaybe<Order_By>;
  include_koc_timestamp?: InputMaybe<Order_By>;
  max_temp_fahrenheit?: InputMaybe<Order_By>;
  mf_test_temp1_celsius?: InputMaybe<Order_By>;
  mf_test_temp2_celsius?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  only_ecopetrol_timestamp?: InputMaybe<Order_By>;
  only_koc_timestamp?: InputMaybe<Order_By>;
  specific_gravity?: InputMaybe<Order_By>;
  thermal_expansion_factor?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  viscosity_test1_centistroke?: InputMaybe<Order_By>;
  viscosity_test2_centistroke?: InputMaybe<Order_By>;
};

/** primary key columns input for table: seal_motor_oil */
export type Seal_Motor_Oil_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "seal_motor_oil" */
export enum Seal_Motor_Oil_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  IncludeEcopetrolTimestamp = 'include_ecopetrol_timestamp',
  /** column name */
  IncludeKocTimestamp = 'include_koc_timestamp',
  /** column name */
  MaxTempFahrenheit = 'max_temp_fahrenheit',
  /** column name */
  MfTestTemp1Celsius = 'mf_test_temp1_celsius',
  /** column name */
  MfTestTemp2Celsius = 'mf_test_temp2_celsius',
  /** column name */
  Name = 'name',
  /** column name */
  OnlyEcopetrolTimestamp = 'only_ecopetrol_timestamp',
  /** column name */
  OnlyKocTimestamp = 'only_koc_timestamp',
  /** column name */
  SpecificGravity = 'specific_gravity',
  /** column name */
  ThermalExpansionFactor = 'thermal_expansion_factor',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  ViscosityTest1Centistroke = 'viscosity_test1_centistroke',
  /** column name */
  ViscosityTest2Centistroke = 'viscosity_test2_centistroke'
}

/** input type for updating data in table "seal_motor_oil" */
export type Seal_Motor_Oil_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  include_ecopetrol_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  include_koc_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  max_temp_fahrenheit?: InputMaybe<Scalars['Int']['input']>;
  mf_test_temp1_celsius?: InputMaybe<Scalars['Int']['input']>;
  mf_test_temp2_celsius?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  only_ecopetrol_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  only_koc_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  specific_gravity?: InputMaybe<Scalars['numeric']['input']>;
  thermal_expansion_factor?: InputMaybe<Scalars['numeric']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  viscosity_test1_centistroke?: InputMaybe<Scalars['numeric']['input']>;
  viscosity_test2_centistroke?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate stddev on columns */
export type Seal_Motor_Oil_Stddev_Fields = {
  __typename: 'seal_motor_oil_stddev_fields';
  max_temp_fahrenheit?: Maybe<Scalars['Float']['output']>;
  mf_test_temp1_celsius?: Maybe<Scalars['Float']['output']>;
  mf_test_temp2_celsius?: Maybe<Scalars['Float']['output']>;
  specific_gravity?: Maybe<Scalars['Float']['output']>;
  thermal_expansion_factor?: Maybe<Scalars['Float']['output']>;
  viscosity_test1_centistroke?: Maybe<Scalars['Float']['output']>;
  viscosity_test2_centistroke?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Seal_Motor_Oil_Stddev_Pop_Fields = {
  __typename: 'seal_motor_oil_stddev_pop_fields';
  max_temp_fahrenheit?: Maybe<Scalars['Float']['output']>;
  mf_test_temp1_celsius?: Maybe<Scalars['Float']['output']>;
  mf_test_temp2_celsius?: Maybe<Scalars['Float']['output']>;
  specific_gravity?: Maybe<Scalars['Float']['output']>;
  thermal_expansion_factor?: Maybe<Scalars['Float']['output']>;
  viscosity_test1_centistroke?: Maybe<Scalars['Float']['output']>;
  viscosity_test2_centistroke?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Seal_Motor_Oil_Stddev_Samp_Fields = {
  __typename: 'seal_motor_oil_stddev_samp_fields';
  max_temp_fahrenheit?: Maybe<Scalars['Float']['output']>;
  mf_test_temp1_celsius?: Maybe<Scalars['Float']['output']>;
  mf_test_temp2_celsius?: Maybe<Scalars['Float']['output']>;
  specific_gravity?: Maybe<Scalars['Float']['output']>;
  thermal_expansion_factor?: Maybe<Scalars['Float']['output']>;
  viscosity_test1_centistroke?: Maybe<Scalars['Float']['output']>;
  viscosity_test2_centistroke?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "seal_motor_oil" */
export type Seal_Motor_Oil_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Seal_Motor_Oil_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Seal_Motor_Oil_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  include_ecopetrol_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  include_koc_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  max_temp_fahrenheit?: InputMaybe<Scalars['Int']['input']>;
  mf_test_temp1_celsius?: InputMaybe<Scalars['Int']['input']>;
  mf_test_temp2_celsius?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  only_ecopetrol_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  only_koc_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  specific_gravity?: InputMaybe<Scalars['numeric']['input']>;
  thermal_expansion_factor?: InputMaybe<Scalars['numeric']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  viscosity_test1_centistroke?: InputMaybe<Scalars['numeric']['input']>;
  viscosity_test2_centistroke?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate sum on columns */
export type Seal_Motor_Oil_Sum_Fields = {
  __typename: 'seal_motor_oil_sum_fields';
  max_temp_fahrenheit?: Maybe<Scalars['Int']['output']>;
  mf_test_temp1_celsius?: Maybe<Scalars['Int']['output']>;
  mf_test_temp2_celsius?: Maybe<Scalars['Int']['output']>;
  specific_gravity?: Maybe<Scalars['numeric']['output']>;
  thermal_expansion_factor?: Maybe<Scalars['numeric']['output']>;
  viscosity_test1_centistroke?: Maybe<Scalars['numeric']['output']>;
  viscosity_test2_centistroke?: Maybe<Scalars['numeric']['output']>;
};

/** update columns of table "seal_motor_oil" */
export enum Seal_Motor_Oil_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  IncludeEcopetrolTimestamp = 'include_ecopetrol_timestamp',
  /** column name */
  IncludeKocTimestamp = 'include_koc_timestamp',
  /** column name */
  MaxTempFahrenheit = 'max_temp_fahrenheit',
  /** column name */
  MfTestTemp1Celsius = 'mf_test_temp1_celsius',
  /** column name */
  MfTestTemp2Celsius = 'mf_test_temp2_celsius',
  /** column name */
  Name = 'name',
  /** column name */
  OnlyEcopetrolTimestamp = 'only_ecopetrol_timestamp',
  /** column name */
  OnlyKocTimestamp = 'only_koc_timestamp',
  /** column name */
  SpecificGravity = 'specific_gravity',
  /** column name */
  ThermalExpansionFactor = 'thermal_expansion_factor',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  ViscosityTest1Centistroke = 'viscosity_test1_centistroke',
  /** column name */
  ViscosityTest2Centistroke = 'viscosity_test2_centistroke'
}

export type Seal_Motor_Oil_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Seal_Motor_Oil_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Seal_Motor_Oil_Set_Input>;
  /** filter the rows which have to be updated */
  where: Seal_Motor_Oil_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Seal_Motor_Oil_Var_Pop_Fields = {
  __typename: 'seal_motor_oil_var_pop_fields';
  max_temp_fahrenheit?: Maybe<Scalars['Float']['output']>;
  mf_test_temp1_celsius?: Maybe<Scalars['Float']['output']>;
  mf_test_temp2_celsius?: Maybe<Scalars['Float']['output']>;
  specific_gravity?: Maybe<Scalars['Float']['output']>;
  thermal_expansion_factor?: Maybe<Scalars['Float']['output']>;
  viscosity_test1_centistroke?: Maybe<Scalars['Float']['output']>;
  viscosity_test2_centistroke?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Seal_Motor_Oil_Var_Samp_Fields = {
  __typename: 'seal_motor_oil_var_samp_fields';
  max_temp_fahrenheit?: Maybe<Scalars['Float']['output']>;
  mf_test_temp1_celsius?: Maybe<Scalars['Float']['output']>;
  mf_test_temp2_celsius?: Maybe<Scalars['Float']['output']>;
  specific_gravity?: Maybe<Scalars['Float']['output']>;
  thermal_expansion_factor?: Maybe<Scalars['Float']['output']>;
  viscosity_test1_centistroke?: Maybe<Scalars['Float']['output']>;
  viscosity_test2_centistroke?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Seal_Motor_Oil_Variance_Fields = {
  __typename: 'seal_motor_oil_variance_fields';
  max_temp_fahrenheit?: Maybe<Scalars['Float']['output']>;
  mf_test_temp1_celsius?: Maybe<Scalars['Float']['output']>;
  mf_test_temp2_celsius?: Maybe<Scalars['Float']['output']>;
  specific_gravity?: Maybe<Scalars['Float']['output']>;
  thermal_expansion_factor?: Maybe<Scalars['Float']['output']>;
  viscosity_test1_centistroke?: Maybe<Scalars['Float']['output']>;
  viscosity_test2_centistroke?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "seals" */
export type Seals = {
  __typename: 'seals';
  author_id: Scalars['String']['output'];
  bag_capacity_gallons?: Maybe<Scalars['numeric']['output']>;
  bag_chambers?: Maybe<Scalars['Int']['output']>;
  bearing_type?: Maybe<Scalars['String']['output']>;
  configuration?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  high_strength_bearing_rating_pounds?: Maybe<Scalars['Int']['output']>;
  high_strength_shaft_limit_hp?: Maybe<Scalars['Int']['output']>;
  housing_material?: Maybe<Scalars['String']['output']>;
  hps_thrust_chamber: Scalars['Boolean']['output'];
  id: Scalars['uuid']['output'];
  imported_sizing_id?: Maybe<Scalars['Int']['output']>;
  include_ecopetrol_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  include_koc_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  inner_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  length_inches?: Maybe<Scalars['numeric']['output']>;
  load_c1_pounds?: Maybe<Scalars['numeric']['output']>;
  load_cb_pounds?: Maybe<Scalars['numeric']['output']>;
  load_test_temperature_fahrenheit?: Maybe<Scalars['Int']['output']>;
  manufacturer?: Maybe<Scalars['String']['output']>;
  max_temperature_fahrenheit?: Maybe<Scalars['Int']['output']>;
  neck_inner_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  neck_outer_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  only_ecopetrol_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  only_koc_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  outer_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  part_number?: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "prioritizesealmanufacturer" */
  prioritized_manufacturer?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  sizing_import?: Maybe<Sizing_Imports>;
  standard_bearing_rating_pounds?: Maybe<Scalars['Int']['output']>;
  standard_shaft_limit_hp?: Maybe<Scalars['Int']['output']>;
  string_load_pounds?: Maybe<Scalars['numeric']['output']>;
  thrust_collar_inner_diameter_inches: Scalars['numeric']['output'];
  thrust_collar_outer_diameter_inches: Scalars['numeric']['output'];
  total_seal_volume_gallons?: Maybe<Scalars['numeric']['output']>;
  updated_at: Scalars['timestamptz']['output'];
  upper_chamber_pull_volume_gallons?: Maybe<Scalars['numeric']['output']>;
  /** An object relationship */
  user: Users;
  volume_for_bag_expansion_lower_tandem_gallons?: Maybe<Scalars['numeric']['output']>;
  volume_for_bag_expansion_upper_tandem_gallons?: Maybe<Scalars['numeric']['output']>;
  weight_pounds?: Maybe<Scalars['numeric']['output']>;
};

/** aggregated selection of "seals" */
export type Seals_Aggregate = {
  __typename: 'seals_aggregate';
  aggregate?: Maybe<Seals_Aggregate_Fields>;
  nodes: Array<Seals>;
};

export type Seals_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Seals_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Seals_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Seals_Aggregate_Bool_Exp_Count>;
};

export type Seals_Aggregate_Bool_Exp_Bool_And = {
  arguments: Seals_Select_Column_Seals_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Seals_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Seals_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Seals_Select_Column_Seals_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Seals_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Seals_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Seals_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Seals_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "seals" */
export type Seals_Aggregate_Fields = {
  __typename: 'seals_aggregate_fields';
  avg?: Maybe<Seals_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Seals_Max_Fields>;
  min?: Maybe<Seals_Min_Fields>;
  stddev?: Maybe<Seals_Stddev_Fields>;
  stddev_pop?: Maybe<Seals_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Seals_Stddev_Samp_Fields>;
  sum?: Maybe<Seals_Sum_Fields>;
  var_pop?: Maybe<Seals_Var_Pop_Fields>;
  var_samp?: Maybe<Seals_Var_Samp_Fields>;
  variance?: Maybe<Seals_Variance_Fields>;
};


/** aggregate fields of "seals" */
export type Seals_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Seals_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "seals" */
export type Seals_Aggregate_Order_By = {
  avg?: InputMaybe<Seals_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Seals_Max_Order_By>;
  min?: InputMaybe<Seals_Min_Order_By>;
  stddev?: InputMaybe<Seals_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Seals_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Seals_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Seals_Sum_Order_By>;
  var_pop?: InputMaybe<Seals_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Seals_Var_Samp_Order_By>;
  variance?: InputMaybe<Seals_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "seals" */
export type Seals_Arr_Rel_Insert_Input = {
  data: Array<Seals_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Seals_On_Conflict>;
};

/** aggregate avg on columns */
export type Seals_Avg_Fields = {
  __typename: 'seals_avg_fields';
  bag_capacity_gallons?: Maybe<Scalars['Float']['output']>;
  bag_chambers?: Maybe<Scalars['Float']['output']>;
  high_strength_bearing_rating_pounds?: Maybe<Scalars['Float']['output']>;
  high_strength_shaft_limit_hp?: Maybe<Scalars['Float']['output']>;
  imported_sizing_id?: Maybe<Scalars['Float']['output']>;
  inner_diameter_inches?: Maybe<Scalars['Float']['output']>;
  length_inches?: Maybe<Scalars['Float']['output']>;
  load_c1_pounds?: Maybe<Scalars['Float']['output']>;
  load_cb_pounds?: Maybe<Scalars['Float']['output']>;
  load_test_temperature_fahrenheit?: Maybe<Scalars['Float']['output']>;
  max_temperature_fahrenheit?: Maybe<Scalars['Float']['output']>;
  neck_inner_diameter_inches?: Maybe<Scalars['Float']['output']>;
  neck_outer_diameter_inches?: Maybe<Scalars['Float']['output']>;
  outer_diameter_inches?: Maybe<Scalars['Float']['output']>;
  standard_bearing_rating_pounds?: Maybe<Scalars['Float']['output']>;
  standard_shaft_limit_hp?: Maybe<Scalars['Float']['output']>;
  string_load_pounds?: Maybe<Scalars['Float']['output']>;
  thrust_collar_inner_diameter_inches?: Maybe<Scalars['Float']['output']>;
  thrust_collar_outer_diameter_inches?: Maybe<Scalars['Float']['output']>;
  total_seal_volume_gallons?: Maybe<Scalars['Float']['output']>;
  upper_chamber_pull_volume_gallons?: Maybe<Scalars['Float']['output']>;
  volume_for_bag_expansion_lower_tandem_gallons?: Maybe<Scalars['Float']['output']>;
  volume_for_bag_expansion_upper_tandem_gallons?: Maybe<Scalars['Float']['output']>;
  weight_pounds?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "seals" */
export type Seals_Avg_Order_By = {
  bag_capacity_gallons?: InputMaybe<Order_By>;
  bag_chambers?: InputMaybe<Order_By>;
  high_strength_bearing_rating_pounds?: InputMaybe<Order_By>;
  high_strength_shaft_limit_hp?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  inner_diameter_inches?: InputMaybe<Order_By>;
  length_inches?: InputMaybe<Order_By>;
  load_c1_pounds?: InputMaybe<Order_By>;
  load_cb_pounds?: InputMaybe<Order_By>;
  load_test_temperature_fahrenheit?: InputMaybe<Order_By>;
  max_temperature_fahrenheit?: InputMaybe<Order_By>;
  neck_inner_diameter_inches?: InputMaybe<Order_By>;
  neck_outer_diameter_inches?: InputMaybe<Order_By>;
  outer_diameter_inches?: InputMaybe<Order_By>;
  standard_bearing_rating_pounds?: InputMaybe<Order_By>;
  standard_shaft_limit_hp?: InputMaybe<Order_By>;
  string_load_pounds?: InputMaybe<Order_By>;
  thrust_collar_inner_diameter_inches?: InputMaybe<Order_By>;
  thrust_collar_outer_diameter_inches?: InputMaybe<Order_By>;
  total_seal_volume_gallons?: InputMaybe<Order_By>;
  upper_chamber_pull_volume_gallons?: InputMaybe<Order_By>;
  volume_for_bag_expansion_lower_tandem_gallons?: InputMaybe<Order_By>;
  volume_for_bag_expansion_upper_tandem_gallons?: InputMaybe<Order_By>;
  weight_pounds?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "seals". All fields are combined with a logical 'AND'. */
export type Seals_Bool_Exp = {
  _and?: InputMaybe<Array<Seals_Bool_Exp>>;
  _not?: InputMaybe<Seals_Bool_Exp>;
  _or?: InputMaybe<Array<Seals_Bool_Exp>>;
  author_id?: InputMaybe<String_Comparison_Exp>;
  bag_capacity_gallons?: InputMaybe<Numeric_Comparison_Exp>;
  bag_chambers?: InputMaybe<Int_Comparison_Exp>;
  bearing_type?: InputMaybe<String_Comparison_Exp>;
  configuration?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  high_strength_bearing_rating_pounds?: InputMaybe<Int_Comparison_Exp>;
  high_strength_shaft_limit_hp?: InputMaybe<Int_Comparison_Exp>;
  housing_material?: InputMaybe<String_Comparison_Exp>;
  hps_thrust_chamber?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  imported_sizing_id?: InputMaybe<Int_Comparison_Exp>;
  include_ecopetrol_timestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  include_koc_timestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  inner_diameter_inches?: InputMaybe<Numeric_Comparison_Exp>;
  length_inches?: InputMaybe<Numeric_Comparison_Exp>;
  load_c1_pounds?: InputMaybe<Numeric_Comparison_Exp>;
  load_cb_pounds?: InputMaybe<Numeric_Comparison_Exp>;
  load_test_temperature_fahrenheit?: InputMaybe<Int_Comparison_Exp>;
  manufacturer?: InputMaybe<String_Comparison_Exp>;
  max_temperature_fahrenheit?: InputMaybe<Int_Comparison_Exp>;
  neck_inner_diameter_inches?: InputMaybe<Numeric_Comparison_Exp>;
  neck_outer_diameter_inches?: InputMaybe<Numeric_Comparison_Exp>;
  only_ecopetrol_timestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  only_koc_timestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  outer_diameter_inches?: InputMaybe<Numeric_Comparison_Exp>;
  part_number?: InputMaybe<String_Comparison_Exp>;
  prioritized_manufacturer?: InputMaybe<String_Comparison_Exp>;
  sizing_import?: InputMaybe<Sizing_Imports_Bool_Exp>;
  standard_bearing_rating_pounds?: InputMaybe<Int_Comparison_Exp>;
  standard_shaft_limit_hp?: InputMaybe<Int_Comparison_Exp>;
  string_load_pounds?: InputMaybe<Numeric_Comparison_Exp>;
  thrust_collar_inner_diameter_inches?: InputMaybe<Numeric_Comparison_Exp>;
  thrust_collar_outer_diameter_inches?: InputMaybe<Numeric_Comparison_Exp>;
  total_seal_volume_gallons?: InputMaybe<Numeric_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  upper_chamber_pull_volume_gallons?: InputMaybe<Numeric_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  volume_for_bag_expansion_lower_tandem_gallons?: InputMaybe<Numeric_Comparison_Exp>;
  volume_for_bag_expansion_upper_tandem_gallons?: InputMaybe<Numeric_Comparison_Exp>;
  weight_pounds?: InputMaybe<Numeric_Comparison_Exp>;
};

/** unique or primary key constraints on table "seals" */
export enum Seals_Constraint {
  /** unique or primary key constraint on columns "id" */
  SealsPkey = 'seals_pkey'
}

/** input type for incrementing numeric columns in table "seals" */
export type Seals_Inc_Input = {
  bag_capacity_gallons?: InputMaybe<Scalars['numeric']['input']>;
  bag_chambers?: InputMaybe<Scalars['Int']['input']>;
  high_strength_bearing_rating_pounds?: InputMaybe<Scalars['Int']['input']>;
  high_strength_shaft_limit_hp?: InputMaybe<Scalars['Int']['input']>;
  imported_sizing_id?: InputMaybe<Scalars['Int']['input']>;
  inner_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  length_inches?: InputMaybe<Scalars['numeric']['input']>;
  load_c1_pounds?: InputMaybe<Scalars['numeric']['input']>;
  load_cb_pounds?: InputMaybe<Scalars['numeric']['input']>;
  load_test_temperature_fahrenheit?: InputMaybe<Scalars['Int']['input']>;
  max_temperature_fahrenheit?: InputMaybe<Scalars['Int']['input']>;
  neck_inner_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  neck_outer_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  outer_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  standard_bearing_rating_pounds?: InputMaybe<Scalars['Int']['input']>;
  standard_shaft_limit_hp?: InputMaybe<Scalars['Int']['input']>;
  string_load_pounds?: InputMaybe<Scalars['numeric']['input']>;
  thrust_collar_inner_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  thrust_collar_outer_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  total_seal_volume_gallons?: InputMaybe<Scalars['numeric']['input']>;
  upper_chamber_pull_volume_gallons?: InputMaybe<Scalars['numeric']['input']>;
  volume_for_bag_expansion_lower_tandem_gallons?: InputMaybe<Scalars['numeric']['input']>;
  volume_for_bag_expansion_upper_tandem_gallons?: InputMaybe<Scalars['numeric']['input']>;
  weight_pounds?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "seals" */
export type Seals_Insert_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  bag_capacity_gallons?: InputMaybe<Scalars['numeric']['input']>;
  bag_chambers?: InputMaybe<Scalars['Int']['input']>;
  bearing_type?: InputMaybe<Scalars['String']['input']>;
  configuration?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  high_strength_bearing_rating_pounds?: InputMaybe<Scalars['Int']['input']>;
  high_strength_shaft_limit_hp?: InputMaybe<Scalars['Int']['input']>;
  housing_material?: InputMaybe<Scalars['String']['input']>;
  hps_thrust_chamber?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  imported_sizing_id?: InputMaybe<Scalars['Int']['input']>;
  include_ecopetrol_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  include_koc_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  inner_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  length_inches?: InputMaybe<Scalars['numeric']['input']>;
  load_c1_pounds?: InputMaybe<Scalars['numeric']['input']>;
  load_cb_pounds?: InputMaybe<Scalars['numeric']['input']>;
  load_test_temperature_fahrenheit?: InputMaybe<Scalars['Int']['input']>;
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  max_temperature_fahrenheit?: InputMaybe<Scalars['Int']['input']>;
  neck_inner_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  neck_outer_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  only_ecopetrol_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  only_koc_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  outer_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  part_number?: InputMaybe<Scalars['String']['input']>;
  sizing_import?: InputMaybe<Sizing_Imports_Obj_Rel_Insert_Input>;
  standard_bearing_rating_pounds?: InputMaybe<Scalars['Int']['input']>;
  standard_shaft_limit_hp?: InputMaybe<Scalars['Int']['input']>;
  string_load_pounds?: InputMaybe<Scalars['numeric']['input']>;
  thrust_collar_inner_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  thrust_collar_outer_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  total_seal_volume_gallons?: InputMaybe<Scalars['numeric']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  upper_chamber_pull_volume_gallons?: InputMaybe<Scalars['numeric']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  volume_for_bag_expansion_lower_tandem_gallons?: InputMaybe<Scalars['numeric']['input']>;
  volume_for_bag_expansion_upper_tandem_gallons?: InputMaybe<Scalars['numeric']['input']>;
  weight_pounds?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate max on columns */
export type Seals_Max_Fields = {
  __typename: 'seals_max_fields';
  author_id?: Maybe<Scalars['String']['output']>;
  bag_capacity_gallons?: Maybe<Scalars['numeric']['output']>;
  bag_chambers?: Maybe<Scalars['Int']['output']>;
  bearing_type?: Maybe<Scalars['String']['output']>;
  configuration?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  high_strength_bearing_rating_pounds?: Maybe<Scalars['Int']['output']>;
  high_strength_shaft_limit_hp?: Maybe<Scalars['Int']['output']>;
  housing_material?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  imported_sizing_id?: Maybe<Scalars['Int']['output']>;
  include_ecopetrol_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  include_koc_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  inner_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  length_inches?: Maybe<Scalars['numeric']['output']>;
  load_c1_pounds?: Maybe<Scalars['numeric']['output']>;
  load_cb_pounds?: Maybe<Scalars['numeric']['output']>;
  load_test_temperature_fahrenheit?: Maybe<Scalars['Int']['output']>;
  manufacturer?: Maybe<Scalars['String']['output']>;
  max_temperature_fahrenheit?: Maybe<Scalars['Int']['output']>;
  neck_inner_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  neck_outer_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  only_ecopetrol_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  only_koc_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  outer_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  part_number?: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "prioritizesealmanufacturer" */
  prioritized_manufacturer?: Maybe<Scalars['String']['output']>;
  standard_bearing_rating_pounds?: Maybe<Scalars['Int']['output']>;
  standard_shaft_limit_hp?: Maybe<Scalars['Int']['output']>;
  string_load_pounds?: Maybe<Scalars['numeric']['output']>;
  thrust_collar_inner_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  thrust_collar_outer_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  total_seal_volume_gallons?: Maybe<Scalars['numeric']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  upper_chamber_pull_volume_gallons?: Maybe<Scalars['numeric']['output']>;
  volume_for_bag_expansion_lower_tandem_gallons?: Maybe<Scalars['numeric']['output']>;
  volume_for_bag_expansion_upper_tandem_gallons?: Maybe<Scalars['numeric']['output']>;
  weight_pounds?: Maybe<Scalars['numeric']['output']>;
};

/** order by max() on columns of table "seals" */
export type Seals_Max_Order_By = {
  author_id?: InputMaybe<Order_By>;
  bag_capacity_gallons?: InputMaybe<Order_By>;
  bag_chambers?: InputMaybe<Order_By>;
  bearing_type?: InputMaybe<Order_By>;
  configuration?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  high_strength_bearing_rating_pounds?: InputMaybe<Order_By>;
  high_strength_shaft_limit_hp?: InputMaybe<Order_By>;
  housing_material?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  include_ecopetrol_timestamp?: InputMaybe<Order_By>;
  include_koc_timestamp?: InputMaybe<Order_By>;
  inner_diameter_inches?: InputMaybe<Order_By>;
  length_inches?: InputMaybe<Order_By>;
  load_c1_pounds?: InputMaybe<Order_By>;
  load_cb_pounds?: InputMaybe<Order_By>;
  load_test_temperature_fahrenheit?: InputMaybe<Order_By>;
  manufacturer?: InputMaybe<Order_By>;
  max_temperature_fahrenheit?: InputMaybe<Order_By>;
  neck_inner_diameter_inches?: InputMaybe<Order_By>;
  neck_outer_diameter_inches?: InputMaybe<Order_By>;
  only_ecopetrol_timestamp?: InputMaybe<Order_By>;
  only_koc_timestamp?: InputMaybe<Order_By>;
  outer_diameter_inches?: InputMaybe<Order_By>;
  part_number?: InputMaybe<Order_By>;
  standard_bearing_rating_pounds?: InputMaybe<Order_By>;
  standard_shaft_limit_hp?: InputMaybe<Order_By>;
  string_load_pounds?: InputMaybe<Order_By>;
  thrust_collar_inner_diameter_inches?: InputMaybe<Order_By>;
  thrust_collar_outer_diameter_inches?: InputMaybe<Order_By>;
  total_seal_volume_gallons?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  upper_chamber_pull_volume_gallons?: InputMaybe<Order_By>;
  volume_for_bag_expansion_lower_tandem_gallons?: InputMaybe<Order_By>;
  volume_for_bag_expansion_upper_tandem_gallons?: InputMaybe<Order_By>;
  weight_pounds?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Seals_Min_Fields = {
  __typename: 'seals_min_fields';
  author_id?: Maybe<Scalars['String']['output']>;
  bag_capacity_gallons?: Maybe<Scalars['numeric']['output']>;
  bag_chambers?: Maybe<Scalars['Int']['output']>;
  bearing_type?: Maybe<Scalars['String']['output']>;
  configuration?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  high_strength_bearing_rating_pounds?: Maybe<Scalars['Int']['output']>;
  high_strength_shaft_limit_hp?: Maybe<Scalars['Int']['output']>;
  housing_material?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  imported_sizing_id?: Maybe<Scalars['Int']['output']>;
  include_ecopetrol_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  include_koc_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  inner_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  length_inches?: Maybe<Scalars['numeric']['output']>;
  load_c1_pounds?: Maybe<Scalars['numeric']['output']>;
  load_cb_pounds?: Maybe<Scalars['numeric']['output']>;
  load_test_temperature_fahrenheit?: Maybe<Scalars['Int']['output']>;
  manufacturer?: Maybe<Scalars['String']['output']>;
  max_temperature_fahrenheit?: Maybe<Scalars['Int']['output']>;
  neck_inner_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  neck_outer_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  only_ecopetrol_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  only_koc_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  outer_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  part_number?: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "prioritizesealmanufacturer" */
  prioritized_manufacturer?: Maybe<Scalars['String']['output']>;
  standard_bearing_rating_pounds?: Maybe<Scalars['Int']['output']>;
  standard_shaft_limit_hp?: Maybe<Scalars['Int']['output']>;
  string_load_pounds?: Maybe<Scalars['numeric']['output']>;
  thrust_collar_inner_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  thrust_collar_outer_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  total_seal_volume_gallons?: Maybe<Scalars['numeric']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  upper_chamber_pull_volume_gallons?: Maybe<Scalars['numeric']['output']>;
  volume_for_bag_expansion_lower_tandem_gallons?: Maybe<Scalars['numeric']['output']>;
  volume_for_bag_expansion_upper_tandem_gallons?: Maybe<Scalars['numeric']['output']>;
  weight_pounds?: Maybe<Scalars['numeric']['output']>;
};

/** order by min() on columns of table "seals" */
export type Seals_Min_Order_By = {
  author_id?: InputMaybe<Order_By>;
  bag_capacity_gallons?: InputMaybe<Order_By>;
  bag_chambers?: InputMaybe<Order_By>;
  bearing_type?: InputMaybe<Order_By>;
  configuration?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  high_strength_bearing_rating_pounds?: InputMaybe<Order_By>;
  high_strength_shaft_limit_hp?: InputMaybe<Order_By>;
  housing_material?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  include_ecopetrol_timestamp?: InputMaybe<Order_By>;
  include_koc_timestamp?: InputMaybe<Order_By>;
  inner_diameter_inches?: InputMaybe<Order_By>;
  length_inches?: InputMaybe<Order_By>;
  load_c1_pounds?: InputMaybe<Order_By>;
  load_cb_pounds?: InputMaybe<Order_By>;
  load_test_temperature_fahrenheit?: InputMaybe<Order_By>;
  manufacturer?: InputMaybe<Order_By>;
  max_temperature_fahrenheit?: InputMaybe<Order_By>;
  neck_inner_diameter_inches?: InputMaybe<Order_By>;
  neck_outer_diameter_inches?: InputMaybe<Order_By>;
  only_ecopetrol_timestamp?: InputMaybe<Order_By>;
  only_koc_timestamp?: InputMaybe<Order_By>;
  outer_diameter_inches?: InputMaybe<Order_By>;
  part_number?: InputMaybe<Order_By>;
  standard_bearing_rating_pounds?: InputMaybe<Order_By>;
  standard_shaft_limit_hp?: InputMaybe<Order_By>;
  string_load_pounds?: InputMaybe<Order_By>;
  thrust_collar_inner_diameter_inches?: InputMaybe<Order_By>;
  thrust_collar_outer_diameter_inches?: InputMaybe<Order_By>;
  total_seal_volume_gallons?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  upper_chamber_pull_volume_gallons?: InputMaybe<Order_By>;
  volume_for_bag_expansion_lower_tandem_gallons?: InputMaybe<Order_By>;
  volume_for_bag_expansion_upper_tandem_gallons?: InputMaybe<Order_By>;
  weight_pounds?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "seals" */
export type Seals_Mutation_Response = {
  __typename: 'seals_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Seals>;
};

/** input type for inserting object relation for remote table "seals" */
export type Seals_Obj_Rel_Insert_Input = {
  data: Seals_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Seals_On_Conflict>;
};

/** on_conflict condition type for table "seals" */
export type Seals_On_Conflict = {
  constraint: Seals_Constraint;
  update_columns?: Array<Seals_Update_Column>;
  where?: InputMaybe<Seals_Bool_Exp>;
};

/** Ordering options when selecting data from "seals". */
export type Seals_Order_By = {
  author_id?: InputMaybe<Order_By>;
  bag_capacity_gallons?: InputMaybe<Order_By>;
  bag_chambers?: InputMaybe<Order_By>;
  bearing_type?: InputMaybe<Order_By>;
  configuration?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  high_strength_bearing_rating_pounds?: InputMaybe<Order_By>;
  high_strength_shaft_limit_hp?: InputMaybe<Order_By>;
  housing_material?: InputMaybe<Order_By>;
  hps_thrust_chamber?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  include_ecopetrol_timestamp?: InputMaybe<Order_By>;
  include_koc_timestamp?: InputMaybe<Order_By>;
  inner_diameter_inches?: InputMaybe<Order_By>;
  length_inches?: InputMaybe<Order_By>;
  load_c1_pounds?: InputMaybe<Order_By>;
  load_cb_pounds?: InputMaybe<Order_By>;
  load_test_temperature_fahrenheit?: InputMaybe<Order_By>;
  manufacturer?: InputMaybe<Order_By>;
  max_temperature_fahrenheit?: InputMaybe<Order_By>;
  neck_inner_diameter_inches?: InputMaybe<Order_By>;
  neck_outer_diameter_inches?: InputMaybe<Order_By>;
  only_ecopetrol_timestamp?: InputMaybe<Order_By>;
  only_koc_timestamp?: InputMaybe<Order_By>;
  outer_diameter_inches?: InputMaybe<Order_By>;
  part_number?: InputMaybe<Order_By>;
  prioritized_manufacturer?: InputMaybe<Order_By>;
  sizing_import?: InputMaybe<Sizing_Imports_Order_By>;
  standard_bearing_rating_pounds?: InputMaybe<Order_By>;
  standard_shaft_limit_hp?: InputMaybe<Order_By>;
  string_load_pounds?: InputMaybe<Order_By>;
  thrust_collar_inner_diameter_inches?: InputMaybe<Order_By>;
  thrust_collar_outer_diameter_inches?: InputMaybe<Order_By>;
  total_seal_volume_gallons?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  upper_chamber_pull_volume_gallons?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  volume_for_bag_expansion_lower_tandem_gallons?: InputMaybe<Order_By>;
  volume_for_bag_expansion_upper_tandem_gallons?: InputMaybe<Order_By>;
  weight_pounds?: InputMaybe<Order_By>;
};

/** primary key columns input for table: seals */
export type Seals_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "seals" */
export enum Seals_Select_Column {
  /** column name */
  AuthorId = 'author_id',
  /** column name */
  BagCapacityGallons = 'bag_capacity_gallons',
  /** column name */
  BagChambers = 'bag_chambers',
  /** column name */
  BearingType = 'bearing_type',
  /** column name */
  Configuration = 'configuration',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Description = 'description',
  /** column name */
  HighStrengthBearingRatingPounds = 'high_strength_bearing_rating_pounds',
  /** column name */
  HighStrengthShaftLimitHp = 'high_strength_shaft_limit_hp',
  /** column name */
  HousingMaterial = 'housing_material',
  /** column name */
  HpsThrustChamber = 'hps_thrust_chamber',
  /** column name */
  Id = 'id',
  /** column name */
  ImportedSizingId = 'imported_sizing_id',
  /** column name */
  IncludeEcopetrolTimestamp = 'include_ecopetrol_timestamp',
  /** column name */
  IncludeKocTimestamp = 'include_koc_timestamp',
  /** column name */
  InnerDiameterInches = 'inner_diameter_inches',
  /** column name */
  LengthInches = 'length_inches',
  /** column name */
  LoadC1Pounds = 'load_c1_pounds',
  /** column name */
  LoadCbPounds = 'load_cb_pounds',
  /** column name */
  LoadTestTemperatureFahrenheit = 'load_test_temperature_fahrenheit',
  /** column name */
  Manufacturer = 'manufacturer',
  /** column name */
  MaxTemperatureFahrenheit = 'max_temperature_fahrenheit',
  /** column name */
  NeckInnerDiameterInches = 'neck_inner_diameter_inches',
  /** column name */
  NeckOuterDiameterInches = 'neck_outer_diameter_inches',
  /** column name */
  OnlyEcopetrolTimestamp = 'only_ecopetrol_timestamp',
  /** column name */
  OnlyKocTimestamp = 'only_koc_timestamp',
  /** column name */
  OuterDiameterInches = 'outer_diameter_inches',
  /** column name */
  PartNumber = 'part_number',
  /** column name */
  StandardBearingRatingPounds = 'standard_bearing_rating_pounds',
  /** column name */
  StandardShaftLimitHp = 'standard_shaft_limit_hp',
  /** column name */
  StringLoadPounds = 'string_load_pounds',
  /** column name */
  ThrustCollarInnerDiameterInches = 'thrust_collar_inner_diameter_inches',
  /** column name */
  ThrustCollarOuterDiameterInches = 'thrust_collar_outer_diameter_inches',
  /** column name */
  TotalSealVolumeGallons = 'total_seal_volume_gallons',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpperChamberPullVolumeGallons = 'upper_chamber_pull_volume_gallons',
  /** column name */
  VolumeForBagExpansionLowerTandemGallons = 'volume_for_bag_expansion_lower_tandem_gallons',
  /** column name */
  VolumeForBagExpansionUpperTandemGallons = 'volume_for_bag_expansion_upper_tandem_gallons',
  /** column name */
  WeightPounds = 'weight_pounds'
}

/** select "seals_aggregate_bool_exp_bool_and_arguments_columns" columns of table "seals" */
export enum Seals_Select_Column_Seals_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  HpsThrustChamber = 'hps_thrust_chamber'
}

/** select "seals_aggregate_bool_exp_bool_or_arguments_columns" columns of table "seals" */
export enum Seals_Select_Column_Seals_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  HpsThrustChamber = 'hps_thrust_chamber'
}

/** input type for updating data in table "seals" */
export type Seals_Set_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  bag_capacity_gallons?: InputMaybe<Scalars['numeric']['input']>;
  bag_chambers?: InputMaybe<Scalars['Int']['input']>;
  bearing_type?: InputMaybe<Scalars['String']['input']>;
  configuration?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  high_strength_bearing_rating_pounds?: InputMaybe<Scalars['Int']['input']>;
  high_strength_shaft_limit_hp?: InputMaybe<Scalars['Int']['input']>;
  housing_material?: InputMaybe<Scalars['String']['input']>;
  hps_thrust_chamber?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  imported_sizing_id?: InputMaybe<Scalars['Int']['input']>;
  include_ecopetrol_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  include_koc_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  inner_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  length_inches?: InputMaybe<Scalars['numeric']['input']>;
  load_c1_pounds?: InputMaybe<Scalars['numeric']['input']>;
  load_cb_pounds?: InputMaybe<Scalars['numeric']['input']>;
  load_test_temperature_fahrenheit?: InputMaybe<Scalars['Int']['input']>;
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  max_temperature_fahrenheit?: InputMaybe<Scalars['Int']['input']>;
  neck_inner_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  neck_outer_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  only_ecopetrol_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  only_koc_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  outer_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  part_number?: InputMaybe<Scalars['String']['input']>;
  standard_bearing_rating_pounds?: InputMaybe<Scalars['Int']['input']>;
  standard_shaft_limit_hp?: InputMaybe<Scalars['Int']['input']>;
  string_load_pounds?: InputMaybe<Scalars['numeric']['input']>;
  thrust_collar_inner_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  thrust_collar_outer_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  total_seal_volume_gallons?: InputMaybe<Scalars['numeric']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  upper_chamber_pull_volume_gallons?: InputMaybe<Scalars['numeric']['input']>;
  volume_for_bag_expansion_lower_tandem_gallons?: InputMaybe<Scalars['numeric']['input']>;
  volume_for_bag_expansion_upper_tandem_gallons?: InputMaybe<Scalars['numeric']['input']>;
  weight_pounds?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate stddev on columns */
export type Seals_Stddev_Fields = {
  __typename: 'seals_stddev_fields';
  bag_capacity_gallons?: Maybe<Scalars['Float']['output']>;
  bag_chambers?: Maybe<Scalars['Float']['output']>;
  high_strength_bearing_rating_pounds?: Maybe<Scalars['Float']['output']>;
  high_strength_shaft_limit_hp?: Maybe<Scalars['Float']['output']>;
  imported_sizing_id?: Maybe<Scalars['Float']['output']>;
  inner_diameter_inches?: Maybe<Scalars['Float']['output']>;
  length_inches?: Maybe<Scalars['Float']['output']>;
  load_c1_pounds?: Maybe<Scalars['Float']['output']>;
  load_cb_pounds?: Maybe<Scalars['Float']['output']>;
  load_test_temperature_fahrenheit?: Maybe<Scalars['Float']['output']>;
  max_temperature_fahrenheit?: Maybe<Scalars['Float']['output']>;
  neck_inner_diameter_inches?: Maybe<Scalars['Float']['output']>;
  neck_outer_diameter_inches?: Maybe<Scalars['Float']['output']>;
  outer_diameter_inches?: Maybe<Scalars['Float']['output']>;
  standard_bearing_rating_pounds?: Maybe<Scalars['Float']['output']>;
  standard_shaft_limit_hp?: Maybe<Scalars['Float']['output']>;
  string_load_pounds?: Maybe<Scalars['Float']['output']>;
  thrust_collar_inner_diameter_inches?: Maybe<Scalars['Float']['output']>;
  thrust_collar_outer_diameter_inches?: Maybe<Scalars['Float']['output']>;
  total_seal_volume_gallons?: Maybe<Scalars['Float']['output']>;
  upper_chamber_pull_volume_gallons?: Maybe<Scalars['Float']['output']>;
  volume_for_bag_expansion_lower_tandem_gallons?: Maybe<Scalars['Float']['output']>;
  volume_for_bag_expansion_upper_tandem_gallons?: Maybe<Scalars['Float']['output']>;
  weight_pounds?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "seals" */
export type Seals_Stddev_Order_By = {
  bag_capacity_gallons?: InputMaybe<Order_By>;
  bag_chambers?: InputMaybe<Order_By>;
  high_strength_bearing_rating_pounds?: InputMaybe<Order_By>;
  high_strength_shaft_limit_hp?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  inner_diameter_inches?: InputMaybe<Order_By>;
  length_inches?: InputMaybe<Order_By>;
  load_c1_pounds?: InputMaybe<Order_By>;
  load_cb_pounds?: InputMaybe<Order_By>;
  load_test_temperature_fahrenheit?: InputMaybe<Order_By>;
  max_temperature_fahrenheit?: InputMaybe<Order_By>;
  neck_inner_diameter_inches?: InputMaybe<Order_By>;
  neck_outer_diameter_inches?: InputMaybe<Order_By>;
  outer_diameter_inches?: InputMaybe<Order_By>;
  standard_bearing_rating_pounds?: InputMaybe<Order_By>;
  standard_shaft_limit_hp?: InputMaybe<Order_By>;
  string_load_pounds?: InputMaybe<Order_By>;
  thrust_collar_inner_diameter_inches?: InputMaybe<Order_By>;
  thrust_collar_outer_diameter_inches?: InputMaybe<Order_By>;
  total_seal_volume_gallons?: InputMaybe<Order_By>;
  upper_chamber_pull_volume_gallons?: InputMaybe<Order_By>;
  volume_for_bag_expansion_lower_tandem_gallons?: InputMaybe<Order_By>;
  volume_for_bag_expansion_upper_tandem_gallons?: InputMaybe<Order_By>;
  weight_pounds?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Seals_Stddev_Pop_Fields = {
  __typename: 'seals_stddev_pop_fields';
  bag_capacity_gallons?: Maybe<Scalars['Float']['output']>;
  bag_chambers?: Maybe<Scalars['Float']['output']>;
  high_strength_bearing_rating_pounds?: Maybe<Scalars['Float']['output']>;
  high_strength_shaft_limit_hp?: Maybe<Scalars['Float']['output']>;
  imported_sizing_id?: Maybe<Scalars['Float']['output']>;
  inner_diameter_inches?: Maybe<Scalars['Float']['output']>;
  length_inches?: Maybe<Scalars['Float']['output']>;
  load_c1_pounds?: Maybe<Scalars['Float']['output']>;
  load_cb_pounds?: Maybe<Scalars['Float']['output']>;
  load_test_temperature_fahrenheit?: Maybe<Scalars['Float']['output']>;
  max_temperature_fahrenheit?: Maybe<Scalars['Float']['output']>;
  neck_inner_diameter_inches?: Maybe<Scalars['Float']['output']>;
  neck_outer_diameter_inches?: Maybe<Scalars['Float']['output']>;
  outer_diameter_inches?: Maybe<Scalars['Float']['output']>;
  standard_bearing_rating_pounds?: Maybe<Scalars['Float']['output']>;
  standard_shaft_limit_hp?: Maybe<Scalars['Float']['output']>;
  string_load_pounds?: Maybe<Scalars['Float']['output']>;
  thrust_collar_inner_diameter_inches?: Maybe<Scalars['Float']['output']>;
  thrust_collar_outer_diameter_inches?: Maybe<Scalars['Float']['output']>;
  total_seal_volume_gallons?: Maybe<Scalars['Float']['output']>;
  upper_chamber_pull_volume_gallons?: Maybe<Scalars['Float']['output']>;
  volume_for_bag_expansion_lower_tandem_gallons?: Maybe<Scalars['Float']['output']>;
  volume_for_bag_expansion_upper_tandem_gallons?: Maybe<Scalars['Float']['output']>;
  weight_pounds?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "seals" */
export type Seals_Stddev_Pop_Order_By = {
  bag_capacity_gallons?: InputMaybe<Order_By>;
  bag_chambers?: InputMaybe<Order_By>;
  high_strength_bearing_rating_pounds?: InputMaybe<Order_By>;
  high_strength_shaft_limit_hp?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  inner_diameter_inches?: InputMaybe<Order_By>;
  length_inches?: InputMaybe<Order_By>;
  load_c1_pounds?: InputMaybe<Order_By>;
  load_cb_pounds?: InputMaybe<Order_By>;
  load_test_temperature_fahrenheit?: InputMaybe<Order_By>;
  max_temperature_fahrenheit?: InputMaybe<Order_By>;
  neck_inner_diameter_inches?: InputMaybe<Order_By>;
  neck_outer_diameter_inches?: InputMaybe<Order_By>;
  outer_diameter_inches?: InputMaybe<Order_By>;
  standard_bearing_rating_pounds?: InputMaybe<Order_By>;
  standard_shaft_limit_hp?: InputMaybe<Order_By>;
  string_load_pounds?: InputMaybe<Order_By>;
  thrust_collar_inner_diameter_inches?: InputMaybe<Order_By>;
  thrust_collar_outer_diameter_inches?: InputMaybe<Order_By>;
  total_seal_volume_gallons?: InputMaybe<Order_By>;
  upper_chamber_pull_volume_gallons?: InputMaybe<Order_By>;
  volume_for_bag_expansion_lower_tandem_gallons?: InputMaybe<Order_By>;
  volume_for_bag_expansion_upper_tandem_gallons?: InputMaybe<Order_By>;
  weight_pounds?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Seals_Stddev_Samp_Fields = {
  __typename: 'seals_stddev_samp_fields';
  bag_capacity_gallons?: Maybe<Scalars['Float']['output']>;
  bag_chambers?: Maybe<Scalars['Float']['output']>;
  high_strength_bearing_rating_pounds?: Maybe<Scalars['Float']['output']>;
  high_strength_shaft_limit_hp?: Maybe<Scalars['Float']['output']>;
  imported_sizing_id?: Maybe<Scalars['Float']['output']>;
  inner_diameter_inches?: Maybe<Scalars['Float']['output']>;
  length_inches?: Maybe<Scalars['Float']['output']>;
  load_c1_pounds?: Maybe<Scalars['Float']['output']>;
  load_cb_pounds?: Maybe<Scalars['Float']['output']>;
  load_test_temperature_fahrenheit?: Maybe<Scalars['Float']['output']>;
  max_temperature_fahrenheit?: Maybe<Scalars['Float']['output']>;
  neck_inner_diameter_inches?: Maybe<Scalars['Float']['output']>;
  neck_outer_diameter_inches?: Maybe<Scalars['Float']['output']>;
  outer_diameter_inches?: Maybe<Scalars['Float']['output']>;
  standard_bearing_rating_pounds?: Maybe<Scalars['Float']['output']>;
  standard_shaft_limit_hp?: Maybe<Scalars['Float']['output']>;
  string_load_pounds?: Maybe<Scalars['Float']['output']>;
  thrust_collar_inner_diameter_inches?: Maybe<Scalars['Float']['output']>;
  thrust_collar_outer_diameter_inches?: Maybe<Scalars['Float']['output']>;
  total_seal_volume_gallons?: Maybe<Scalars['Float']['output']>;
  upper_chamber_pull_volume_gallons?: Maybe<Scalars['Float']['output']>;
  volume_for_bag_expansion_lower_tandem_gallons?: Maybe<Scalars['Float']['output']>;
  volume_for_bag_expansion_upper_tandem_gallons?: Maybe<Scalars['Float']['output']>;
  weight_pounds?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "seals" */
export type Seals_Stddev_Samp_Order_By = {
  bag_capacity_gallons?: InputMaybe<Order_By>;
  bag_chambers?: InputMaybe<Order_By>;
  high_strength_bearing_rating_pounds?: InputMaybe<Order_By>;
  high_strength_shaft_limit_hp?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  inner_diameter_inches?: InputMaybe<Order_By>;
  length_inches?: InputMaybe<Order_By>;
  load_c1_pounds?: InputMaybe<Order_By>;
  load_cb_pounds?: InputMaybe<Order_By>;
  load_test_temperature_fahrenheit?: InputMaybe<Order_By>;
  max_temperature_fahrenheit?: InputMaybe<Order_By>;
  neck_inner_diameter_inches?: InputMaybe<Order_By>;
  neck_outer_diameter_inches?: InputMaybe<Order_By>;
  outer_diameter_inches?: InputMaybe<Order_By>;
  standard_bearing_rating_pounds?: InputMaybe<Order_By>;
  standard_shaft_limit_hp?: InputMaybe<Order_By>;
  string_load_pounds?: InputMaybe<Order_By>;
  thrust_collar_inner_diameter_inches?: InputMaybe<Order_By>;
  thrust_collar_outer_diameter_inches?: InputMaybe<Order_By>;
  total_seal_volume_gallons?: InputMaybe<Order_By>;
  upper_chamber_pull_volume_gallons?: InputMaybe<Order_By>;
  volume_for_bag_expansion_lower_tandem_gallons?: InputMaybe<Order_By>;
  volume_for_bag_expansion_upper_tandem_gallons?: InputMaybe<Order_By>;
  weight_pounds?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "seals" */
export type Seals_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Seals_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Seals_Stream_Cursor_Value_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  bag_capacity_gallons?: InputMaybe<Scalars['numeric']['input']>;
  bag_chambers?: InputMaybe<Scalars['Int']['input']>;
  bearing_type?: InputMaybe<Scalars['String']['input']>;
  configuration?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  high_strength_bearing_rating_pounds?: InputMaybe<Scalars['Int']['input']>;
  high_strength_shaft_limit_hp?: InputMaybe<Scalars['Int']['input']>;
  housing_material?: InputMaybe<Scalars['String']['input']>;
  hps_thrust_chamber?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  imported_sizing_id?: InputMaybe<Scalars['Int']['input']>;
  include_ecopetrol_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  include_koc_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  inner_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  length_inches?: InputMaybe<Scalars['numeric']['input']>;
  load_c1_pounds?: InputMaybe<Scalars['numeric']['input']>;
  load_cb_pounds?: InputMaybe<Scalars['numeric']['input']>;
  load_test_temperature_fahrenheit?: InputMaybe<Scalars['Int']['input']>;
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  max_temperature_fahrenheit?: InputMaybe<Scalars['Int']['input']>;
  neck_inner_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  neck_outer_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  only_ecopetrol_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  only_koc_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  outer_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  part_number?: InputMaybe<Scalars['String']['input']>;
  standard_bearing_rating_pounds?: InputMaybe<Scalars['Int']['input']>;
  standard_shaft_limit_hp?: InputMaybe<Scalars['Int']['input']>;
  string_load_pounds?: InputMaybe<Scalars['numeric']['input']>;
  thrust_collar_inner_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  thrust_collar_outer_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  total_seal_volume_gallons?: InputMaybe<Scalars['numeric']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  upper_chamber_pull_volume_gallons?: InputMaybe<Scalars['numeric']['input']>;
  volume_for_bag_expansion_lower_tandem_gallons?: InputMaybe<Scalars['numeric']['input']>;
  volume_for_bag_expansion_upper_tandem_gallons?: InputMaybe<Scalars['numeric']['input']>;
  weight_pounds?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate sum on columns */
export type Seals_Sum_Fields = {
  __typename: 'seals_sum_fields';
  bag_capacity_gallons?: Maybe<Scalars['numeric']['output']>;
  bag_chambers?: Maybe<Scalars['Int']['output']>;
  high_strength_bearing_rating_pounds?: Maybe<Scalars['Int']['output']>;
  high_strength_shaft_limit_hp?: Maybe<Scalars['Int']['output']>;
  imported_sizing_id?: Maybe<Scalars['Int']['output']>;
  inner_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  length_inches?: Maybe<Scalars['numeric']['output']>;
  load_c1_pounds?: Maybe<Scalars['numeric']['output']>;
  load_cb_pounds?: Maybe<Scalars['numeric']['output']>;
  load_test_temperature_fahrenheit?: Maybe<Scalars['Int']['output']>;
  max_temperature_fahrenheit?: Maybe<Scalars['Int']['output']>;
  neck_inner_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  neck_outer_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  outer_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  standard_bearing_rating_pounds?: Maybe<Scalars['Int']['output']>;
  standard_shaft_limit_hp?: Maybe<Scalars['Int']['output']>;
  string_load_pounds?: Maybe<Scalars['numeric']['output']>;
  thrust_collar_inner_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  thrust_collar_outer_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  total_seal_volume_gallons?: Maybe<Scalars['numeric']['output']>;
  upper_chamber_pull_volume_gallons?: Maybe<Scalars['numeric']['output']>;
  volume_for_bag_expansion_lower_tandem_gallons?: Maybe<Scalars['numeric']['output']>;
  volume_for_bag_expansion_upper_tandem_gallons?: Maybe<Scalars['numeric']['output']>;
  weight_pounds?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "seals" */
export type Seals_Sum_Order_By = {
  bag_capacity_gallons?: InputMaybe<Order_By>;
  bag_chambers?: InputMaybe<Order_By>;
  high_strength_bearing_rating_pounds?: InputMaybe<Order_By>;
  high_strength_shaft_limit_hp?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  inner_diameter_inches?: InputMaybe<Order_By>;
  length_inches?: InputMaybe<Order_By>;
  load_c1_pounds?: InputMaybe<Order_By>;
  load_cb_pounds?: InputMaybe<Order_By>;
  load_test_temperature_fahrenheit?: InputMaybe<Order_By>;
  max_temperature_fahrenheit?: InputMaybe<Order_By>;
  neck_inner_diameter_inches?: InputMaybe<Order_By>;
  neck_outer_diameter_inches?: InputMaybe<Order_By>;
  outer_diameter_inches?: InputMaybe<Order_By>;
  standard_bearing_rating_pounds?: InputMaybe<Order_By>;
  standard_shaft_limit_hp?: InputMaybe<Order_By>;
  string_load_pounds?: InputMaybe<Order_By>;
  thrust_collar_inner_diameter_inches?: InputMaybe<Order_By>;
  thrust_collar_outer_diameter_inches?: InputMaybe<Order_By>;
  total_seal_volume_gallons?: InputMaybe<Order_By>;
  upper_chamber_pull_volume_gallons?: InputMaybe<Order_By>;
  volume_for_bag_expansion_lower_tandem_gallons?: InputMaybe<Order_By>;
  volume_for_bag_expansion_upper_tandem_gallons?: InputMaybe<Order_By>;
  weight_pounds?: InputMaybe<Order_By>;
};

/** update columns of table "seals" */
export enum Seals_Update_Column {
  /** column name */
  AuthorId = 'author_id',
  /** column name */
  BagCapacityGallons = 'bag_capacity_gallons',
  /** column name */
  BagChambers = 'bag_chambers',
  /** column name */
  BearingType = 'bearing_type',
  /** column name */
  Configuration = 'configuration',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Description = 'description',
  /** column name */
  HighStrengthBearingRatingPounds = 'high_strength_bearing_rating_pounds',
  /** column name */
  HighStrengthShaftLimitHp = 'high_strength_shaft_limit_hp',
  /** column name */
  HousingMaterial = 'housing_material',
  /** column name */
  HpsThrustChamber = 'hps_thrust_chamber',
  /** column name */
  Id = 'id',
  /** column name */
  ImportedSizingId = 'imported_sizing_id',
  /** column name */
  IncludeEcopetrolTimestamp = 'include_ecopetrol_timestamp',
  /** column name */
  IncludeKocTimestamp = 'include_koc_timestamp',
  /** column name */
  InnerDiameterInches = 'inner_diameter_inches',
  /** column name */
  LengthInches = 'length_inches',
  /** column name */
  LoadC1Pounds = 'load_c1_pounds',
  /** column name */
  LoadCbPounds = 'load_cb_pounds',
  /** column name */
  LoadTestTemperatureFahrenheit = 'load_test_temperature_fahrenheit',
  /** column name */
  Manufacturer = 'manufacturer',
  /** column name */
  MaxTemperatureFahrenheit = 'max_temperature_fahrenheit',
  /** column name */
  NeckInnerDiameterInches = 'neck_inner_diameter_inches',
  /** column name */
  NeckOuterDiameterInches = 'neck_outer_diameter_inches',
  /** column name */
  OnlyEcopetrolTimestamp = 'only_ecopetrol_timestamp',
  /** column name */
  OnlyKocTimestamp = 'only_koc_timestamp',
  /** column name */
  OuterDiameterInches = 'outer_diameter_inches',
  /** column name */
  PartNumber = 'part_number',
  /** column name */
  StandardBearingRatingPounds = 'standard_bearing_rating_pounds',
  /** column name */
  StandardShaftLimitHp = 'standard_shaft_limit_hp',
  /** column name */
  StringLoadPounds = 'string_load_pounds',
  /** column name */
  ThrustCollarInnerDiameterInches = 'thrust_collar_inner_diameter_inches',
  /** column name */
  ThrustCollarOuterDiameterInches = 'thrust_collar_outer_diameter_inches',
  /** column name */
  TotalSealVolumeGallons = 'total_seal_volume_gallons',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpperChamberPullVolumeGallons = 'upper_chamber_pull_volume_gallons',
  /** column name */
  VolumeForBagExpansionLowerTandemGallons = 'volume_for_bag_expansion_lower_tandem_gallons',
  /** column name */
  VolumeForBagExpansionUpperTandemGallons = 'volume_for_bag_expansion_upper_tandem_gallons',
  /** column name */
  WeightPounds = 'weight_pounds'
}

export type Seals_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Seals_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Seals_Set_Input>;
  /** filter the rows which have to be updated */
  where: Seals_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Seals_Var_Pop_Fields = {
  __typename: 'seals_var_pop_fields';
  bag_capacity_gallons?: Maybe<Scalars['Float']['output']>;
  bag_chambers?: Maybe<Scalars['Float']['output']>;
  high_strength_bearing_rating_pounds?: Maybe<Scalars['Float']['output']>;
  high_strength_shaft_limit_hp?: Maybe<Scalars['Float']['output']>;
  imported_sizing_id?: Maybe<Scalars['Float']['output']>;
  inner_diameter_inches?: Maybe<Scalars['Float']['output']>;
  length_inches?: Maybe<Scalars['Float']['output']>;
  load_c1_pounds?: Maybe<Scalars['Float']['output']>;
  load_cb_pounds?: Maybe<Scalars['Float']['output']>;
  load_test_temperature_fahrenheit?: Maybe<Scalars['Float']['output']>;
  max_temperature_fahrenheit?: Maybe<Scalars['Float']['output']>;
  neck_inner_diameter_inches?: Maybe<Scalars['Float']['output']>;
  neck_outer_diameter_inches?: Maybe<Scalars['Float']['output']>;
  outer_diameter_inches?: Maybe<Scalars['Float']['output']>;
  standard_bearing_rating_pounds?: Maybe<Scalars['Float']['output']>;
  standard_shaft_limit_hp?: Maybe<Scalars['Float']['output']>;
  string_load_pounds?: Maybe<Scalars['Float']['output']>;
  thrust_collar_inner_diameter_inches?: Maybe<Scalars['Float']['output']>;
  thrust_collar_outer_diameter_inches?: Maybe<Scalars['Float']['output']>;
  total_seal_volume_gallons?: Maybe<Scalars['Float']['output']>;
  upper_chamber_pull_volume_gallons?: Maybe<Scalars['Float']['output']>;
  volume_for_bag_expansion_lower_tandem_gallons?: Maybe<Scalars['Float']['output']>;
  volume_for_bag_expansion_upper_tandem_gallons?: Maybe<Scalars['Float']['output']>;
  weight_pounds?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "seals" */
export type Seals_Var_Pop_Order_By = {
  bag_capacity_gallons?: InputMaybe<Order_By>;
  bag_chambers?: InputMaybe<Order_By>;
  high_strength_bearing_rating_pounds?: InputMaybe<Order_By>;
  high_strength_shaft_limit_hp?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  inner_diameter_inches?: InputMaybe<Order_By>;
  length_inches?: InputMaybe<Order_By>;
  load_c1_pounds?: InputMaybe<Order_By>;
  load_cb_pounds?: InputMaybe<Order_By>;
  load_test_temperature_fahrenheit?: InputMaybe<Order_By>;
  max_temperature_fahrenheit?: InputMaybe<Order_By>;
  neck_inner_diameter_inches?: InputMaybe<Order_By>;
  neck_outer_diameter_inches?: InputMaybe<Order_By>;
  outer_diameter_inches?: InputMaybe<Order_By>;
  standard_bearing_rating_pounds?: InputMaybe<Order_By>;
  standard_shaft_limit_hp?: InputMaybe<Order_By>;
  string_load_pounds?: InputMaybe<Order_By>;
  thrust_collar_inner_diameter_inches?: InputMaybe<Order_By>;
  thrust_collar_outer_diameter_inches?: InputMaybe<Order_By>;
  total_seal_volume_gallons?: InputMaybe<Order_By>;
  upper_chamber_pull_volume_gallons?: InputMaybe<Order_By>;
  volume_for_bag_expansion_lower_tandem_gallons?: InputMaybe<Order_By>;
  volume_for_bag_expansion_upper_tandem_gallons?: InputMaybe<Order_By>;
  weight_pounds?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Seals_Var_Samp_Fields = {
  __typename: 'seals_var_samp_fields';
  bag_capacity_gallons?: Maybe<Scalars['Float']['output']>;
  bag_chambers?: Maybe<Scalars['Float']['output']>;
  high_strength_bearing_rating_pounds?: Maybe<Scalars['Float']['output']>;
  high_strength_shaft_limit_hp?: Maybe<Scalars['Float']['output']>;
  imported_sizing_id?: Maybe<Scalars['Float']['output']>;
  inner_diameter_inches?: Maybe<Scalars['Float']['output']>;
  length_inches?: Maybe<Scalars['Float']['output']>;
  load_c1_pounds?: Maybe<Scalars['Float']['output']>;
  load_cb_pounds?: Maybe<Scalars['Float']['output']>;
  load_test_temperature_fahrenheit?: Maybe<Scalars['Float']['output']>;
  max_temperature_fahrenheit?: Maybe<Scalars['Float']['output']>;
  neck_inner_diameter_inches?: Maybe<Scalars['Float']['output']>;
  neck_outer_diameter_inches?: Maybe<Scalars['Float']['output']>;
  outer_diameter_inches?: Maybe<Scalars['Float']['output']>;
  standard_bearing_rating_pounds?: Maybe<Scalars['Float']['output']>;
  standard_shaft_limit_hp?: Maybe<Scalars['Float']['output']>;
  string_load_pounds?: Maybe<Scalars['Float']['output']>;
  thrust_collar_inner_diameter_inches?: Maybe<Scalars['Float']['output']>;
  thrust_collar_outer_diameter_inches?: Maybe<Scalars['Float']['output']>;
  total_seal_volume_gallons?: Maybe<Scalars['Float']['output']>;
  upper_chamber_pull_volume_gallons?: Maybe<Scalars['Float']['output']>;
  volume_for_bag_expansion_lower_tandem_gallons?: Maybe<Scalars['Float']['output']>;
  volume_for_bag_expansion_upper_tandem_gallons?: Maybe<Scalars['Float']['output']>;
  weight_pounds?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "seals" */
export type Seals_Var_Samp_Order_By = {
  bag_capacity_gallons?: InputMaybe<Order_By>;
  bag_chambers?: InputMaybe<Order_By>;
  high_strength_bearing_rating_pounds?: InputMaybe<Order_By>;
  high_strength_shaft_limit_hp?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  inner_diameter_inches?: InputMaybe<Order_By>;
  length_inches?: InputMaybe<Order_By>;
  load_c1_pounds?: InputMaybe<Order_By>;
  load_cb_pounds?: InputMaybe<Order_By>;
  load_test_temperature_fahrenheit?: InputMaybe<Order_By>;
  max_temperature_fahrenheit?: InputMaybe<Order_By>;
  neck_inner_diameter_inches?: InputMaybe<Order_By>;
  neck_outer_diameter_inches?: InputMaybe<Order_By>;
  outer_diameter_inches?: InputMaybe<Order_By>;
  standard_bearing_rating_pounds?: InputMaybe<Order_By>;
  standard_shaft_limit_hp?: InputMaybe<Order_By>;
  string_load_pounds?: InputMaybe<Order_By>;
  thrust_collar_inner_diameter_inches?: InputMaybe<Order_By>;
  thrust_collar_outer_diameter_inches?: InputMaybe<Order_By>;
  total_seal_volume_gallons?: InputMaybe<Order_By>;
  upper_chamber_pull_volume_gallons?: InputMaybe<Order_By>;
  volume_for_bag_expansion_lower_tandem_gallons?: InputMaybe<Order_By>;
  volume_for_bag_expansion_upper_tandem_gallons?: InputMaybe<Order_By>;
  weight_pounds?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Seals_Variance_Fields = {
  __typename: 'seals_variance_fields';
  bag_capacity_gallons?: Maybe<Scalars['Float']['output']>;
  bag_chambers?: Maybe<Scalars['Float']['output']>;
  high_strength_bearing_rating_pounds?: Maybe<Scalars['Float']['output']>;
  high_strength_shaft_limit_hp?: Maybe<Scalars['Float']['output']>;
  imported_sizing_id?: Maybe<Scalars['Float']['output']>;
  inner_diameter_inches?: Maybe<Scalars['Float']['output']>;
  length_inches?: Maybe<Scalars['Float']['output']>;
  load_c1_pounds?: Maybe<Scalars['Float']['output']>;
  load_cb_pounds?: Maybe<Scalars['Float']['output']>;
  load_test_temperature_fahrenheit?: Maybe<Scalars['Float']['output']>;
  max_temperature_fahrenheit?: Maybe<Scalars['Float']['output']>;
  neck_inner_diameter_inches?: Maybe<Scalars['Float']['output']>;
  neck_outer_diameter_inches?: Maybe<Scalars['Float']['output']>;
  outer_diameter_inches?: Maybe<Scalars['Float']['output']>;
  standard_bearing_rating_pounds?: Maybe<Scalars['Float']['output']>;
  standard_shaft_limit_hp?: Maybe<Scalars['Float']['output']>;
  string_load_pounds?: Maybe<Scalars['Float']['output']>;
  thrust_collar_inner_diameter_inches?: Maybe<Scalars['Float']['output']>;
  thrust_collar_outer_diameter_inches?: Maybe<Scalars['Float']['output']>;
  total_seal_volume_gallons?: Maybe<Scalars['Float']['output']>;
  upper_chamber_pull_volume_gallons?: Maybe<Scalars['Float']['output']>;
  volume_for_bag_expansion_lower_tandem_gallons?: Maybe<Scalars['Float']['output']>;
  volume_for_bag_expansion_upper_tandem_gallons?: Maybe<Scalars['Float']['output']>;
  weight_pounds?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "seals" */
export type Seals_Variance_Order_By = {
  bag_capacity_gallons?: InputMaybe<Order_By>;
  bag_chambers?: InputMaybe<Order_By>;
  high_strength_bearing_rating_pounds?: InputMaybe<Order_By>;
  high_strength_shaft_limit_hp?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  inner_diameter_inches?: InputMaybe<Order_By>;
  length_inches?: InputMaybe<Order_By>;
  load_c1_pounds?: InputMaybe<Order_By>;
  load_cb_pounds?: InputMaybe<Order_By>;
  load_test_temperature_fahrenheit?: InputMaybe<Order_By>;
  max_temperature_fahrenheit?: InputMaybe<Order_By>;
  neck_inner_diameter_inches?: InputMaybe<Order_By>;
  neck_outer_diameter_inches?: InputMaybe<Order_By>;
  outer_diameter_inches?: InputMaybe<Order_By>;
  standard_bearing_rating_pounds?: InputMaybe<Order_By>;
  standard_shaft_limit_hp?: InputMaybe<Order_By>;
  string_load_pounds?: InputMaybe<Order_By>;
  thrust_collar_inner_diameter_inches?: InputMaybe<Order_By>;
  thrust_collar_outer_diameter_inches?: InputMaybe<Order_By>;
  total_seal_volume_gallons?: InputMaybe<Order_By>;
  upper_chamber_pull_volume_gallons?: InputMaybe<Order_By>;
  volume_for_bag_expansion_lower_tandem_gallons?: InputMaybe<Order_By>;
  volume_for_bag_expansion_upper_tandem_gallons?: InputMaybe<Order_By>;
  weight_pounds?: InputMaybe<Order_By>;
};

/** columns and relationships of "sensors" */
export type Sensors = {
  __typename: 'sensors';
  author_id: Scalars['String']['output'];
  channels?: Maybe<Scalars['Int']['output']>;
  created_at: Scalars['timestamptz']['output'];
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  housing_material?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  imported_sizing_id?: Maybe<Scalars['Int']['output']>;
  include_ecopetrol_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  include_koc_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  inner_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  length_inches?: Maybe<Scalars['Int']['output']>;
  manufacturer?: Maybe<Scalars['String']['output']>;
  max_intake_pressure_psi?: Maybe<Scalars['Int']['output']>;
  max_intake_temperature_fahrenheit?: Maybe<Scalars['Int']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  neck_inner_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  neck_outer_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  only_ecopetrol_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  only_koc_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  outer_diameter_inches: Scalars['numeric']['output'];
  part_number?: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "prioritizesensormanufacturer" */
  prioritized_manufacturer?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  sizing_import?: Maybe<Sizing_Imports>;
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Users;
  weight_pounds?: Maybe<Scalars['Int']['output']>;
};

/** aggregated selection of "sensors" */
export type Sensors_Aggregate = {
  __typename: 'sensors_aggregate';
  aggregate?: Maybe<Sensors_Aggregate_Fields>;
  nodes: Array<Sensors>;
};

export type Sensors_Aggregate_Bool_Exp = {
  count?: InputMaybe<Sensors_Aggregate_Bool_Exp_Count>;
};

export type Sensors_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Sensors_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Sensors_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "sensors" */
export type Sensors_Aggregate_Fields = {
  __typename: 'sensors_aggregate_fields';
  avg?: Maybe<Sensors_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Sensors_Max_Fields>;
  min?: Maybe<Sensors_Min_Fields>;
  stddev?: Maybe<Sensors_Stddev_Fields>;
  stddev_pop?: Maybe<Sensors_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Sensors_Stddev_Samp_Fields>;
  sum?: Maybe<Sensors_Sum_Fields>;
  var_pop?: Maybe<Sensors_Var_Pop_Fields>;
  var_samp?: Maybe<Sensors_Var_Samp_Fields>;
  variance?: Maybe<Sensors_Variance_Fields>;
};


/** aggregate fields of "sensors" */
export type Sensors_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Sensors_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "sensors" */
export type Sensors_Aggregate_Order_By = {
  avg?: InputMaybe<Sensors_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Sensors_Max_Order_By>;
  min?: InputMaybe<Sensors_Min_Order_By>;
  stddev?: InputMaybe<Sensors_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Sensors_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Sensors_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Sensors_Sum_Order_By>;
  var_pop?: InputMaybe<Sensors_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Sensors_Var_Samp_Order_By>;
  variance?: InputMaybe<Sensors_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "sensors" */
export type Sensors_Arr_Rel_Insert_Input = {
  data: Array<Sensors_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Sensors_On_Conflict>;
};

/** aggregate avg on columns */
export type Sensors_Avg_Fields = {
  __typename: 'sensors_avg_fields';
  channels?: Maybe<Scalars['Float']['output']>;
  imported_sizing_id?: Maybe<Scalars['Float']['output']>;
  inner_diameter_inches?: Maybe<Scalars['Float']['output']>;
  length_inches?: Maybe<Scalars['Float']['output']>;
  max_intake_pressure_psi?: Maybe<Scalars['Float']['output']>;
  max_intake_temperature_fahrenheit?: Maybe<Scalars['Float']['output']>;
  neck_inner_diameter_inches?: Maybe<Scalars['Float']['output']>;
  neck_outer_diameter_inches?: Maybe<Scalars['Float']['output']>;
  outer_diameter_inches?: Maybe<Scalars['Float']['output']>;
  weight_pounds?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "sensors" */
export type Sensors_Avg_Order_By = {
  channels?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  inner_diameter_inches?: InputMaybe<Order_By>;
  length_inches?: InputMaybe<Order_By>;
  max_intake_pressure_psi?: InputMaybe<Order_By>;
  max_intake_temperature_fahrenheit?: InputMaybe<Order_By>;
  neck_inner_diameter_inches?: InputMaybe<Order_By>;
  neck_outer_diameter_inches?: InputMaybe<Order_By>;
  outer_diameter_inches?: InputMaybe<Order_By>;
  weight_pounds?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "sensors". All fields are combined with a logical 'AND'. */
export type Sensors_Bool_Exp = {
  _and?: InputMaybe<Array<Sensors_Bool_Exp>>;
  _not?: InputMaybe<Sensors_Bool_Exp>;
  _or?: InputMaybe<Array<Sensors_Bool_Exp>>;
  author_id?: InputMaybe<String_Comparison_Exp>;
  channels?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  housing_material?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  imported_sizing_id?: InputMaybe<Int_Comparison_Exp>;
  include_ecopetrol_timestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  include_koc_timestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  inner_diameter_inches?: InputMaybe<Numeric_Comparison_Exp>;
  length_inches?: InputMaybe<Int_Comparison_Exp>;
  manufacturer?: InputMaybe<String_Comparison_Exp>;
  max_intake_pressure_psi?: InputMaybe<Int_Comparison_Exp>;
  max_intake_temperature_fahrenheit?: InputMaybe<Int_Comparison_Exp>;
  model?: InputMaybe<String_Comparison_Exp>;
  neck_inner_diameter_inches?: InputMaybe<Numeric_Comparison_Exp>;
  neck_outer_diameter_inches?: InputMaybe<Numeric_Comparison_Exp>;
  only_ecopetrol_timestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  only_koc_timestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  outer_diameter_inches?: InputMaybe<Numeric_Comparison_Exp>;
  part_number?: InputMaybe<String_Comparison_Exp>;
  prioritized_manufacturer?: InputMaybe<String_Comparison_Exp>;
  sizing_import?: InputMaybe<Sizing_Imports_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  weight_pounds?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "sensors" */
export enum Sensors_Constraint {
  /** unique or primary key constraint on columns "id" */
  SensorsPkey = 'sensors_pkey'
}

/** input type for incrementing numeric columns in table "sensors" */
export type Sensors_Inc_Input = {
  channels?: InputMaybe<Scalars['Int']['input']>;
  imported_sizing_id?: InputMaybe<Scalars['Int']['input']>;
  inner_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  length_inches?: InputMaybe<Scalars['Int']['input']>;
  max_intake_pressure_psi?: InputMaybe<Scalars['Int']['input']>;
  max_intake_temperature_fahrenheit?: InputMaybe<Scalars['Int']['input']>;
  neck_inner_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  neck_outer_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  outer_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  weight_pounds?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "sensors" */
export type Sensors_Insert_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  channels?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  housing_material?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  imported_sizing_id?: InputMaybe<Scalars['Int']['input']>;
  include_ecopetrol_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  include_koc_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  inner_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  length_inches?: InputMaybe<Scalars['Int']['input']>;
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  max_intake_pressure_psi?: InputMaybe<Scalars['Int']['input']>;
  max_intake_temperature_fahrenheit?: InputMaybe<Scalars['Int']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  neck_inner_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  neck_outer_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  only_ecopetrol_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  only_koc_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  outer_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  part_number?: InputMaybe<Scalars['String']['input']>;
  sizing_import?: InputMaybe<Sizing_Imports_Obj_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  weight_pounds?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type Sensors_Max_Fields = {
  __typename: 'sensors_max_fields';
  author_id?: Maybe<Scalars['String']['output']>;
  channels?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  housing_material?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  imported_sizing_id?: Maybe<Scalars['Int']['output']>;
  include_ecopetrol_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  include_koc_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  inner_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  length_inches?: Maybe<Scalars['Int']['output']>;
  manufacturer?: Maybe<Scalars['String']['output']>;
  max_intake_pressure_psi?: Maybe<Scalars['Int']['output']>;
  max_intake_temperature_fahrenheit?: Maybe<Scalars['Int']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  neck_inner_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  neck_outer_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  only_ecopetrol_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  only_koc_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  outer_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  part_number?: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "prioritizesensormanufacturer" */
  prioritized_manufacturer?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  weight_pounds?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "sensors" */
export type Sensors_Max_Order_By = {
  author_id?: InputMaybe<Order_By>;
  channels?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  housing_material?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  include_ecopetrol_timestamp?: InputMaybe<Order_By>;
  include_koc_timestamp?: InputMaybe<Order_By>;
  inner_diameter_inches?: InputMaybe<Order_By>;
  length_inches?: InputMaybe<Order_By>;
  manufacturer?: InputMaybe<Order_By>;
  max_intake_pressure_psi?: InputMaybe<Order_By>;
  max_intake_temperature_fahrenheit?: InputMaybe<Order_By>;
  model?: InputMaybe<Order_By>;
  neck_inner_diameter_inches?: InputMaybe<Order_By>;
  neck_outer_diameter_inches?: InputMaybe<Order_By>;
  only_ecopetrol_timestamp?: InputMaybe<Order_By>;
  only_koc_timestamp?: InputMaybe<Order_By>;
  outer_diameter_inches?: InputMaybe<Order_By>;
  part_number?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  weight_pounds?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Sensors_Min_Fields = {
  __typename: 'sensors_min_fields';
  author_id?: Maybe<Scalars['String']['output']>;
  channels?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  housing_material?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  imported_sizing_id?: Maybe<Scalars['Int']['output']>;
  include_ecopetrol_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  include_koc_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  inner_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  length_inches?: Maybe<Scalars['Int']['output']>;
  manufacturer?: Maybe<Scalars['String']['output']>;
  max_intake_pressure_psi?: Maybe<Scalars['Int']['output']>;
  max_intake_temperature_fahrenheit?: Maybe<Scalars['Int']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  neck_inner_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  neck_outer_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  only_ecopetrol_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  only_koc_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  outer_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  part_number?: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "prioritizesensormanufacturer" */
  prioritized_manufacturer?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  weight_pounds?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "sensors" */
export type Sensors_Min_Order_By = {
  author_id?: InputMaybe<Order_By>;
  channels?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  housing_material?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  include_ecopetrol_timestamp?: InputMaybe<Order_By>;
  include_koc_timestamp?: InputMaybe<Order_By>;
  inner_diameter_inches?: InputMaybe<Order_By>;
  length_inches?: InputMaybe<Order_By>;
  manufacturer?: InputMaybe<Order_By>;
  max_intake_pressure_psi?: InputMaybe<Order_By>;
  max_intake_temperature_fahrenheit?: InputMaybe<Order_By>;
  model?: InputMaybe<Order_By>;
  neck_inner_diameter_inches?: InputMaybe<Order_By>;
  neck_outer_diameter_inches?: InputMaybe<Order_By>;
  only_ecopetrol_timestamp?: InputMaybe<Order_By>;
  only_koc_timestamp?: InputMaybe<Order_By>;
  outer_diameter_inches?: InputMaybe<Order_By>;
  part_number?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  weight_pounds?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "sensors" */
export type Sensors_Mutation_Response = {
  __typename: 'sensors_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Sensors>;
};

/** input type for inserting object relation for remote table "sensors" */
export type Sensors_Obj_Rel_Insert_Input = {
  data: Sensors_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Sensors_On_Conflict>;
};

/** on_conflict condition type for table "sensors" */
export type Sensors_On_Conflict = {
  constraint: Sensors_Constraint;
  update_columns?: Array<Sensors_Update_Column>;
  where?: InputMaybe<Sensors_Bool_Exp>;
};

/** Ordering options when selecting data from "sensors". */
export type Sensors_Order_By = {
  author_id?: InputMaybe<Order_By>;
  channels?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  housing_material?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  include_ecopetrol_timestamp?: InputMaybe<Order_By>;
  include_koc_timestamp?: InputMaybe<Order_By>;
  inner_diameter_inches?: InputMaybe<Order_By>;
  length_inches?: InputMaybe<Order_By>;
  manufacturer?: InputMaybe<Order_By>;
  max_intake_pressure_psi?: InputMaybe<Order_By>;
  max_intake_temperature_fahrenheit?: InputMaybe<Order_By>;
  model?: InputMaybe<Order_By>;
  neck_inner_diameter_inches?: InputMaybe<Order_By>;
  neck_outer_diameter_inches?: InputMaybe<Order_By>;
  only_ecopetrol_timestamp?: InputMaybe<Order_By>;
  only_koc_timestamp?: InputMaybe<Order_By>;
  outer_diameter_inches?: InputMaybe<Order_By>;
  part_number?: InputMaybe<Order_By>;
  prioritized_manufacturer?: InputMaybe<Order_By>;
  sizing_import?: InputMaybe<Sizing_Imports_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  weight_pounds?: InputMaybe<Order_By>;
};

/** primary key columns input for table: sensors */
export type Sensors_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "sensors" */
export enum Sensors_Select_Column {
  /** column name */
  AuthorId = 'author_id',
  /** column name */
  Channels = 'channels',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  HousingMaterial = 'housing_material',
  /** column name */
  Id = 'id',
  /** column name */
  ImportedSizingId = 'imported_sizing_id',
  /** column name */
  IncludeEcopetrolTimestamp = 'include_ecopetrol_timestamp',
  /** column name */
  IncludeKocTimestamp = 'include_koc_timestamp',
  /** column name */
  InnerDiameterInches = 'inner_diameter_inches',
  /** column name */
  LengthInches = 'length_inches',
  /** column name */
  Manufacturer = 'manufacturer',
  /** column name */
  MaxIntakePressurePsi = 'max_intake_pressure_psi',
  /** column name */
  MaxIntakeTemperatureFahrenheit = 'max_intake_temperature_fahrenheit',
  /** column name */
  Model = 'model',
  /** column name */
  NeckInnerDiameterInches = 'neck_inner_diameter_inches',
  /** column name */
  NeckOuterDiameterInches = 'neck_outer_diameter_inches',
  /** column name */
  OnlyEcopetrolTimestamp = 'only_ecopetrol_timestamp',
  /** column name */
  OnlyKocTimestamp = 'only_koc_timestamp',
  /** column name */
  OuterDiameterInches = 'outer_diameter_inches',
  /** column name */
  PartNumber = 'part_number',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WeightPounds = 'weight_pounds'
}

/** input type for updating data in table "sensors" */
export type Sensors_Set_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  channels?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  housing_material?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  imported_sizing_id?: InputMaybe<Scalars['Int']['input']>;
  include_ecopetrol_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  include_koc_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  inner_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  length_inches?: InputMaybe<Scalars['Int']['input']>;
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  max_intake_pressure_psi?: InputMaybe<Scalars['Int']['input']>;
  max_intake_temperature_fahrenheit?: InputMaybe<Scalars['Int']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  neck_inner_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  neck_outer_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  only_ecopetrol_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  only_koc_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  outer_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  part_number?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  weight_pounds?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Sensors_Stddev_Fields = {
  __typename: 'sensors_stddev_fields';
  channels?: Maybe<Scalars['Float']['output']>;
  imported_sizing_id?: Maybe<Scalars['Float']['output']>;
  inner_diameter_inches?: Maybe<Scalars['Float']['output']>;
  length_inches?: Maybe<Scalars['Float']['output']>;
  max_intake_pressure_psi?: Maybe<Scalars['Float']['output']>;
  max_intake_temperature_fahrenheit?: Maybe<Scalars['Float']['output']>;
  neck_inner_diameter_inches?: Maybe<Scalars['Float']['output']>;
  neck_outer_diameter_inches?: Maybe<Scalars['Float']['output']>;
  outer_diameter_inches?: Maybe<Scalars['Float']['output']>;
  weight_pounds?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "sensors" */
export type Sensors_Stddev_Order_By = {
  channels?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  inner_diameter_inches?: InputMaybe<Order_By>;
  length_inches?: InputMaybe<Order_By>;
  max_intake_pressure_psi?: InputMaybe<Order_By>;
  max_intake_temperature_fahrenheit?: InputMaybe<Order_By>;
  neck_inner_diameter_inches?: InputMaybe<Order_By>;
  neck_outer_diameter_inches?: InputMaybe<Order_By>;
  outer_diameter_inches?: InputMaybe<Order_By>;
  weight_pounds?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Sensors_Stddev_Pop_Fields = {
  __typename: 'sensors_stddev_pop_fields';
  channels?: Maybe<Scalars['Float']['output']>;
  imported_sizing_id?: Maybe<Scalars['Float']['output']>;
  inner_diameter_inches?: Maybe<Scalars['Float']['output']>;
  length_inches?: Maybe<Scalars['Float']['output']>;
  max_intake_pressure_psi?: Maybe<Scalars['Float']['output']>;
  max_intake_temperature_fahrenheit?: Maybe<Scalars['Float']['output']>;
  neck_inner_diameter_inches?: Maybe<Scalars['Float']['output']>;
  neck_outer_diameter_inches?: Maybe<Scalars['Float']['output']>;
  outer_diameter_inches?: Maybe<Scalars['Float']['output']>;
  weight_pounds?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "sensors" */
export type Sensors_Stddev_Pop_Order_By = {
  channels?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  inner_diameter_inches?: InputMaybe<Order_By>;
  length_inches?: InputMaybe<Order_By>;
  max_intake_pressure_psi?: InputMaybe<Order_By>;
  max_intake_temperature_fahrenheit?: InputMaybe<Order_By>;
  neck_inner_diameter_inches?: InputMaybe<Order_By>;
  neck_outer_diameter_inches?: InputMaybe<Order_By>;
  outer_diameter_inches?: InputMaybe<Order_By>;
  weight_pounds?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Sensors_Stddev_Samp_Fields = {
  __typename: 'sensors_stddev_samp_fields';
  channels?: Maybe<Scalars['Float']['output']>;
  imported_sizing_id?: Maybe<Scalars['Float']['output']>;
  inner_diameter_inches?: Maybe<Scalars['Float']['output']>;
  length_inches?: Maybe<Scalars['Float']['output']>;
  max_intake_pressure_psi?: Maybe<Scalars['Float']['output']>;
  max_intake_temperature_fahrenheit?: Maybe<Scalars['Float']['output']>;
  neck_inner_diameter_inches?: Maybe<Scalars['Float']['output']>;
  neck_outer_diameter_inches?: Maybe<Scalars['Float']['output']>;
  outer_diameter_inches?: Maybe<Scalars['Float']['output']>;
  weight_pounds?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "sensors" */
export type Sensors_Stddev_Samp_Order_By = {
  channels?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  inner_diameter_inches?: InputMaybe<Order_By>;
  length_inches?: InputMaybe<Order_By>;
  max_intake_pressure_psi?: InputMaybe<Order_By>;
  max_intake_temperature_fahrenheit?: InputMaybe<Order_By>;
  neck_inner_diameter_inches?: InputMaybe<Order_By>;
  neck_outer_diameter_inches?: InputMaybe<Order_By>;
  outer_diameter_inches?: InputMaybe<Order_By>;
  weight_pounds?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "sensors" */
export type Sensors_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Sensors_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Sensors_Stream_Cursor_Value_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  channels?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  housing_material?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  imported_sizing_id?: InputMaybe<Scalars['Int']['input']>;
  include_ecopetrol_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  include_koc_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  inner_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  length_inches?: InputMaybe<Scalars['Int']['input']>;
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  max_intake_pressure_psi?: InputMaybe<Scalars['Int']['input']>;
  max_intake_temperature_fahrenheit?: InputMaybe<Scalars['Int']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  neck_inner_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  neck_outer_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  only_ecopetrol_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  only_koc_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  outer_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  part_number?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  weight_pounds?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Sensors_Sum_Fields = {
  __typename: 'sensors_sum_fields';
  channels?: Maybe<Scalars['Int']['output']>;
  imported_sizing_id?: Maybe<Scalars['Int']['output']>;
  inner_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  length_inches?: Maybe<Scalars['Int']['output']>;
  max_intake_pressure_psi?: Maybe<Scalars['Int']['output']>;
  max_intake_temperature_fahrenheit?: Maybe<Scalars['Int']['output']>;
  neck_inner_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  neck_outer_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  outer_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  weight_pounds?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "sensors" */
export type Sensors_Sum_Order_By = {
  channels?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  inner_diameter_inches?: InputMaybe<Order_By>;
  length_inches?: InputMaybe<Order_By>;
  max_intake_pressure_psi?: InputMaybe<Order_By>;
  max_intake_temperature_fahrenheit?: InputMaybe<Order_By>;
  neck_inner_diameter_inches?: InputMaybe<Order_By>;
  neck_outer_diameter_inches?: InputMaybe<Order_By>;
  outer_diameter_inches?: InputMaybe<Order_By>;
  weight_pounds?: InputMaybe<Order_By>;
};

/** update columns of table "sensors" */
export enum Sensors_Update_Column {
  /** column name */
  AuthorId = 'author_id',
  /** column name */
  Channels = 'channels',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  HousingMaterial = 'housing_material',
  /** column name */
  Id = 'id',
  /** column name */
  ImportedSizingId = 'imported_sizing_id',
  /** column name */
  IncludeEcopetrolTimestamp = 'include_ecopetrol_timestamp',
  /** column name */
  IncludeKocTimestamp = 'include_koc_timestamp',
  /** column name */
  InnerDiameterInches = 'inner_diameter_inches',
  /** column name */
  LengthInches = 'length_inches',
  /** column name */
  Manufacturer = 'manufacturer',
  /** column name */
  MaxIntakePressurePsi = 'max_intake_pressure_psi',
  /** column name */
  MaxIntakeTemperatureFahrenheit = 'max_intake_temperature_fahrenheit',
  /** column name */
  Model = 'model',
  /** column name */
  NeckInnerDiameterInches = 'neck_inner_diameter_inches',
  /** column name */
  NeckOuterDiameterInches = 'neck_outer_diameter_inches',
  /** column name */
  OnlyEcopetrolTimestamp = 'only_ecopetrol_timestamp',
  /** column name */
  OnlyKocTimestamp = 'only_koc_timestamp',
  /** column name */
  OuterDiameterInches = 'outer_diameter_inches',
  /** column name */
  PartNumber = 'part_number',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WeightPounds = 'weight_pounds'
}

export type Sensors_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Sensors_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Sensors_Set_Input>;
  /** filter the rows which have to be updated */
  where: Sensors_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Sensors_Var_Pop_Fields = {
  __typename: 'sensors_var_pop_fields';
  channels?: Maybe<Scalars['Float']['output']>;
  imported_sizing_id?: Maybe<Scalars['Float']['output']>;
  inner_diameter_inches?: Maybe<Scalars['Float']['output']>;
  length_inches?: Maybe<Scalars['Float']['output']>;
  max_intake_pressure_psi?: Maybe<Scalars['Float']['output']>;
  max_intake_temperature_fahrenheit?: Maybe<Scalars['Float']['output']>;
  neck_inner_diameter_inches?: Maybe<Scalars['Float']['output']>;
  neck_outer_diameter_inches?: Maybe<Scalars['Float']['output']>;
  outer_diameter_inches?: Maybe<Scalars['Float']['output']>;
  weight_pounds?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "sensors" */
export type Sensors_Var_Pop_Order_By = {
  channels?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  inner_diameter_inches?: InputMaybe<Order_By>;
  length_inches?: InputMaybe<Order_By>;
  max_intake_pressure_psi?: InputMaybe<Order_By>;
  max_intake_temperature_fahrenheit?: InputMaybe<Order_By>;
  neck_inner_diameter_inches?: InputMaybe<Order_By>;
  neck_outer_diameter_inches?: InputMaybe<Order_By>;
  outer_diameter_inches?: InputMaybe<Order_By>;
  weight_pounds?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Sensors_Var_Samp_Fields = {
  __typename: 'sensors_var_samp_fields';
  channels?: Maybe<Scalars['Float']['output']>;
  imported_sizing_id?: Maybe<Scalars['Float']['output']>;
  inner_diameter_inches?: Maybe<Scalars['Float']['output']>;
  length_inches?: Maybe<Scalars['Float']['output']>;
  max_intake_pressure_psi?: Maybe<Scalars['Float']['output']>;
  max_intake_temperature_fahrenheit?: Maybe<Scalars['Float']['output']>;
  neck_inner_diameter_inches?: Maybe<Scalars['Float']['output']>;
  neck_outer_diameter_inches?: Maybe<Scalars['Float']['output']>;
  outer_diameter_inches?: Maybe<Scalars['Float']['output']>;
  weight_pounds?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "sensors" */
export type Sensors_Var_Samp_Order_By = {
  channels?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  inner_diameter_inches?: InputMaybe<Order_By>;
  length_inches?: InputMaybe<Order_By>;
  max_intake_pressure_psi?: InputMaybe<Order_By>;
  max_intake_temperature_fahrenheit?: InputMaybe<Order_By>;
  neck_inner_diameter_inches?: InputMaybe<Order_By>;
  neck_outer_diameter_inches?: InputMaybe<Order_By>;
  outer_diameter_inches?: InputMaybe<Order_By>;
  weight_pounds?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Sensors_Variance_Fields = {
  __typename: 'sensors_variance_fields';
  channels?: Maybe<Scalars['Float']['output']>;
  imported_sizing_id?: Maybe<Scalars['Float']['output']>;
  inner_diameter_inches?: Maybe<Scalars['Float']['output']>;
  length_inches?: Maybe<Scalars['Float']['output']>;
  max_intake_pressure_psi?: Maybe<Scalars['Float']['output']>;
  max_intake_temperature_fahrenheit?: Maybe<Scalars['Float']['output']>;
  neck_inner_diameter_inches?: Maybe<Scalars['Float']['output']>;
  neck_outer_diameter_inches?: Maybe<Scalars['Float']['output']>;
  outer_diameter_inches?: Maybe<Scalars['Float']['output']>;
  weight_pounds?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "sensors" */
export type Sensors_Variance_Order_By = {
  channels?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  inner_diameter_inches?: InputMaybe<Order_By>;
  length_inches?: InputMaybe<Order_By>;
  max_intake_pressure_psi?: InputMaybe<Order_By>;
  max_intake_temperature_fahrenheit?: InputMaybe<Order_By>;
  neck_inner_diameter_inches?: InputMaybe<Order_By>;
  neck_outer_diameter_inches?: InputMaybe<Order_By>;
  outer_diameter_inches?: InputMaybe<Order_By>;
  weight_pounds?: InputMaybe<Order_By>;
};

/** columns and relationships of "sizing_dispositions" */
export type Sizing_Dispositions = {
  __typename: 'sizing_dispositions';
  comment?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

/** aggregated selection of "sizing_dispositions" */
export type Sizing_Dispositions_Aggregate = {
  __typename: 'sizing_dispositions_aggregate';
  aggregate?: Maybe<Sizing_Dispositions_Aggregate_Fields>;
  nodes: Array<Sizing_Dispositions>;
};

/** aggregate fields of "sizing_dispositions" */
export type Sizing_Dispositions_Aggregate_Fields = {
  __typename: 'sizing_dispositions_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Sizing_Dispositions_Max_Fields>;
  min?: Maybe<Sizing_Dispositions_Min_Fields>;
};


/** aggregate fields of "sizing_dispositions" */
export type Sizing_Dispositions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Sizing_Dispositions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "sizing_dispositions". All fields are combined with a logical 'AND'. */
export type Sizing_Dispositions_Bool_Exp = {
  _and?: InputMaybe<Array<Sizing_Dispositions_Bool_Exp>>;
  _not?: InputMaybe<Sizing_Dispositions_Bool_Exp>;
  _or?: InputMaybe<Array<Sizing_Dispositions_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "sizing_dispositions" */
export enum Sizing_Dispositions_Constraint {
  /** unique or primary key constraint on columns "value" */
  SizingDispositionsPkey = 'sizing_dispositions_pkey'
}

export enum Sizing_Dispositions_Enum {
  /** Accepted */
  Accepted = 'accepted',
  /** Closed */
  Closed = 'closed',
  /** Rejected */
  Rejected = 'rejected',
  /** Unknown */
  Unknown = 'unknown'
}

/** Boolean expression to compare columns of type "sizing_dispositions_enum". All fields are combined with logical 'AND'. */
export type Sizing_Dispositions_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Sizing_Dispositions_Enum>;
  _in?: InputMaybe<Array<Sizing_Dispositions_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Sizing_Dispositions_Enum>;
  _nin?: InputMaybe<Array<Sizing_Dispositions_Enum>>;
};

/** input type for inserting data into table "sizing_dispositions" */
export type Sizing_Dispositions_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Sizing_Dispositions_Max_Fields = {
  __typename: 'sizing_dispositions_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Sizing_Dispositions_Min_Fields = {
  __typename: 'sizing_dispositions_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "sizing_dispositions" */
export type Sizing_Dispositions_Mutation_Response = {
  __typename: 'sizing_dispositions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Sizing_Dispositions>;
};

/** input type for inserting object relation for remote table "sizing_dispositions" */
export type Sizing_Dispositions_Obj_Rel_Insert_Input = {
  data: Sizing_Dispositions_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Sizing_Dispositions_On_Conflict>;
};

/** on_conflict condition type for table "sizing_dispositions" */
export type Sizing_Dispositions_On_Conflict = {
  constraint: Sizing_Dispositions_Constraint;
  update_columns?: Array<Sizing_Dispositions_Update_Column>;
  where?: InputMaybe<Sizing_Dispositions_Bool_Exp>;
};

/** Ordering options when selecting data from "sizing_dispositions". */
export type Sizing_Dispositions_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: sizing_dispositions */
export type Sizing_Dispositions_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "sizing_dispositions" */
export enum Sizing_Dispositions_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "sizing_dispositions" */
export type Sizing_Dispositions_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "sizing_dispositions" */
export type Sizing_Dispositions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Sizing_Dispositions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Sizing_Dispositions_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "sizing_dispositions" */
export enum Sizing_Dispositions_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Sizing_Dispositions_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Sizing_Dispositions_Set_Input>;
  /** filter the rows which have to be updated */
  where: Sizing_Dispositions_Bool_Exp;
};

/**
 * Table will hold full JSON sizings from legacy reaver, once inserted a trigger
 * will take care of routing all the various subkeys of the json to the proper tables.
 */
export type Sizing_Imports = {
  __typename: 'sizing_imports';
  author_id: Scalars['String']['output'];
  /** An array relationship */
  cables: Array<Cables>;
  /** An aggregate relationship */
  cables_aggregate: Cables_Aggregate;
  /** An array relationship */
  casings: Array<Casings>;
  /** An aggregate relationship */
  casings_aggregate: Casings_Aggregate;
  created_at: Scalars['timestamp']['output'];
  /** An array relationship */
  customers: Array<Customers>;
  /** An aggregate relationship */
  customers_aggregate: Customers_Aggregate;
  /** An array relationship */
  deviation_surveys: Array<Deviation_Survey>;
  /** An aggregate relationship */
  deviation_surveys_aggregate: Deviation_Survey_Aggregate;
  /** Concatenated PID of error, SQL State, message and PostgreSQL context. */
  error?: Maybe<Scalars['jsonb']['output']>;
  /** An array relationship */
  housings: Array<Housings>;
  /** An aggregate relationship */
  housings_aggregate: Housings_Aggregate;
  id: Scalars['Int']['output'];
  imported_at?: Maybe<Scalars['timestamp']['output']>;
  /** An array relationship */
  intakes: Array<Intakes>;
  /** An aggregate relationship */
  intakes_aggregate: Intakes_Aggregate;
  legacy_author_id?: Maybe<Scalars['String']['output']>;
  legacy_sizing_name?: Maybe<Scalars['String']['output']>;
  legacy_sizing_reaver_id?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  legacy_user?: Maybe<Legacy_Users>;
  /** An array relationship */
  motor_lead_extensions: Array<Motor_Lead_Extensions>;
  /** An aggregate relationship */
  motor_lead_extensions_aggregate: Motor_Lead_Extensions_Aggregate;
  /** An array relationship */
  motors: Array<Motors>;
  /** An aggregate relationship */
  motors_aggregate: Motors_Aggregate;
  payload?: Maybe<Scalars['jsonb']['output']>;
  payload_hash?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  pumps: Array<Pumps>;
  /** An aggregate relationship */
  pumps_aggregate: Pumps_Aggregate;
  /** An array relationship */
  seals: Array<Seals>;
  /** An aggregate relationship */
  seals_aggregate: Seals_Aggregate;
  /** An array relationship */
  sensors: Array<Sensors>;
  /** An aggregate relationship */
  sensors_aggregate: Sensors_Aggregate;
  /** An array relationship */
  step_down_transformers: Array<Step_Down_Transformers>;
  /** An aggregate relationship */
  step_down_transformers_aggregate: Step_Down_Transformers_Aggregate;
  /** An array relationship */
  step_up_transformers: Array<Step_Up_Transformers>;
  /** An aggregate relationship */
  step_up_transformers_aggregate: Step_Up_Transformers_Aggregate;
  /** An array relationship */
  switchboards: Array<Switchboards>;
  /** An aggregate relationship */
  switchboards_aggregate: Switchboards_Aggregate;
  /** An array relationship */
  tubings: Array<Tubings>;
  /** An aggregate relationship */
  tubings_aggregate: Tubings_Aggregate;
  /** An object relationship */
  user: Users;
  /** An array relationship */
  variable_speed_drives: Array<Variable_Speed_Drives>;
  /** An aggregate relationship */
  variable_speed_drives_aggregate: Variable_Speed_Drives_Aggregate;
  /** An array relationship */
  wells: Array<Wells>;
  /** An aggregate relationship */
  wells_aggregate: Wells_Aggregate;
};


/**
 * Table will hold full JSON sizings from legacy reaver, once inserted a trigger
 * will take care of routing all the various subkeys of the json to the proper tables.
 */
export type Sizing_ImportsCablesArgs = {
  distinct_on?: InputMaybe<Array<Cables_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cables_Order_By>>;
  where?: InputMaybe<Cables_Bool_Exp>;
};


/**
 * Table will hold full JSON sizings from legacy reaver, once inserted a trigger
 * will take care of routing all the various subkeys of the json to the proper tables.
 */
export type Sizing_ImportsCables_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Cables_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cables_Order_By>>;
  where?: InputMaybe<Cables_Bool_Exp>;
};


/**
 * Table will hold full JSON sizings from legacy reaver, once inserted a trigger
 * will take care of routing all the various subkeys of the json to the proper tables.
 */
export type Sizing_ImportsCasingsArgs = {
  distinct_on?: InputMaybe<Array<Casings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Casings_Order_By>>;
  where?: InputMaybe<Casings_Bool_Exp>;
};


/**
 * Table will hold full JSON sizings from legacy reaver, once inserted a trigger
 * will take care of routing all the various subkeys of the json to the proper tables.
 */
export type Sizing_ImportsCasings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Casings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Casings_Order_By>>;
  where?: InputMaybe<Casings_Bool_Exp>;
};


/**
 * Table will hold full JSON sizings from legacy reaver, once inserted a trigger
 * will take care of routing all the various subkeys of the json to the proper tables.
 */
export type Sizing_ImportsCustomersArgs = {
  distinct_on?: InputMaybe<Array<Customers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customers_Order_By>>;
  where?: InputMaybe<Customers_Bool_Exp>;
};


/**
 * Table will hold full JSON sizings from legacy reaver, once inserted a trigger
 * will take care of routing all the various subkeys of the json to the proper tables.
 */
export type Sizing_ImportsCustomers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customers_Order_By>>;
  where?: InputMaybe<Customers_Bool_Exp>;
};


/**
 * Table will hold full JSON sizings from legacy reaver, once inserted a trigger
 * will take care of routing all the various subkeys of the json to the proper tables.
 */
export type Sizing_ImportsDeviation_SurveysArgs = {
  distinct_on?: InputMaybe<Array<Deviation_Survey_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Deviation_Survey_Order_By>>;
  where?: InputMaybe<Deviation_Survey_Bool_Exp>;
};


/**
 * Table will hold full JSON sizings from legacy reaver, once inserted a trigger
 * will take care of routing all the various subkeys of the json to the proper tables.
 */
export type Sizing_ImportsDeviation_Surveys_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Deviation_Survey_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Deviation_Survey_Order_By>>;
  where?: InputMaybe<Deviation_Survey_Bool_Exp>;
};


/**
 * Table will hold full JSON sizings from legacy reaver, once inserted a trigger
 * will take care of routing all the various subkeys of the json to the proper tables.
 */
export type Sizing_ImportsErrorArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Table will hold full JSON sizings from legacy reaver, once inserted a trigger
 * will take care of routing all the various subkeys of the json to the proper tables.
 */
export type Sizing_ImportsHousingsArgs = {
  distinct_on?: InputMaybe<Array<Housings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Housings_Order_By>>;
  where?: InputMaybe<Housings_Bool_Exp>;
};


/**
 * Table will hold full JSON sizings from legacy reaver, once inserted a trigger
 * will take care of routing all the various subkeys of the json to the proper tables.
 */
export type Sizing_ImportsHousings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Housings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Housings_Order_By>>;
  where?: InputMaybe<Housings_Bool_Exp>;
};


/**
 * Table will hold full JSON sizings from legacy reaver, once inserted a trigger
 * will take care of routing all the various subkeys of the json to the proper tables.
 */
export type Sizing_ImportsIntakesArgs = {
  distinct_on?: InputMaybe<Array<Intakes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Intakes_Order_By>>;
  where?: InputMaybe<Intakes_Bool_Exp>;
};


/**
 * Table will hold full JSON sizings from legacy reaver, once inserted a trigger
 * will take care of routing all the various subkeys of the json to the proper tables.
 */
export type Sizing_ImportsIntakes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Intakes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Intakes_Order_By>>;
  where?: InputMaybe<Intakes_Bool_Exp>;
};


/**
 * Table will hold full JSON sizings from legacy reaver, once inserted a trigger
 * will take care of routing all the various subkeys of the json to the proper tables.
 */
export type Sizing_ImportsMotor_Lead_ExtensionsArgs = {
  distinct_on?: InputMaybe<Array<Motor_Lead_Extensions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Motor_Lead_Extensions_Order_By>>;
  where?: InputMaybe<Motor_Lead_Extensions_Bool_Exp>;
};


/**
 * Table will hold full JSON sizings from legacy reaver, once inserted a trigger
 * will take care of routing all the various subkeys of the json to the proper tables.
 */
export type Sizing_ImportsMotor_Lead_Extensions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Motor_Lead_Extensions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Motor_Lead_Extensions_Order_By>>;
  where?: InputMaybe<Motor_Lead_Extensions_Bool_Exp>;
};


/**
 * Table will hold full JSON sizings from legacy reaver, once inserted a trigger
 * will take care of routing all the various subkeys of the json to the proper tables.
 */
export type Sizing_ImportsMotorsArgs = {
  distinct_on?: InputMaybe<Array<Motors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Motors_Order_By>>;
  where?: InputMaybe<Motors_Bool_Exp>;
};


/**
 * Table will hold full JSON sizings from legacy reaver, once inserted a trigger
 * will take care of routing all the various subkeys of the json to the proper tables.
 */
export type Sizing_ImportsMotors_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Motors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Motors_Order_By>>;
  where?: InputMaybe<Motors_Bool_Exp>;
};


/**
 * Table will hold full JSON sizings from legacy reaver, once inserted a trigger
 * will take care of routing all the various subkeys of the json to the proper tables.
 */
export type Sizing_ImportsPayloadArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Table will hold full JSON sizings from legacy reaver, once inserted a trigger
 * will take care of routing all the various subkeys of the json to the proper tables.
 */
export type Sizing_ImportsPumpsArgs = {
  distinct_on?: InputMaybe<Array<Pumps_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pumps_Order_By>>;
  where?: InputMaybe<Pumps_Bool_Exp>;
};


/**
 * Table will hold full JSON sizings from legacy reaver, once inserted a trigger
 * will take care of routing all the various subkeys of the json to the proper tables.
 */
export type Sizing_ImportsPumps_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pumps_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pumps_Order_By>>;
  where?: InputMaybe<Pumps_Bool_Exp>;
};


/**
 * Table will hold full JSON sizings from legacy reaver, once inserted a trigger
 * will take care of routing all the various subkeys of the json to the proper tables.
 */
export type Sizing_ImportsSealsArgs = {
  distinct_on?: InputMaybe<Array<Seals_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Seals_Order_By>>;
  where?: InputMaybe<Seals_Bool_Exp>;
};


/**
 * Table will hold full JSON sizings from legacy reaver, once inserted a trigger
 * will take care of routing all the various subkeys of the json to the proper tables.
 */
export type Sizing_ImportsSeals_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Seals_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Seals_Order_By>>;
  where?: InputMaybe<Seals_Bool_Exp>;
};


/**
 * Table will hold full JSON sizings from legacy reaver, once inserted a trigger
 * will take care of routing all the various subkeys of the json to the proper tables.
 */
export type Sizing_ImportsSensorsArgs = {
  distinct_on?: InputMaybe<Array<Sensors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sensors_Order_By>>;
  where?: InputMaybe<Sensors_Bool_Exp>;
};


/**
 * Table will hold full JSON sizings from legacy reaver, once inserted a trigger
 * will take care of routing all the various subkeys of the json to the proper tables.
 */
export type Sizing_ImportsSensors_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sensors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sensors_Order_By>>;
  where?: InputMaybe<Sensors_Bool_Exp>;
};


/**
 * Table will hold full JSON sizings from legacy reaver, once inserted a trigger
 * will take care of routing all the various subkeys of the json to the proper tables.
 */
export type Sizing_ImportsStep_Down_TransformersArgs = {
  distinct_on?: InputMaybe<Array<Step_Down_Transformers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Step_Down_Transformers_Order_By>>;
  where?: InputMaybe<Step_Down_Transformers_Bool_Exp>;
};


/**
 * Table will hold full JSON sizings from legacy reaver, once inserted a trigger
 * will take care of routing all the various subkeys of the json to the proper tables.
 */
export type Sizing_ImportsStep_Down_Transformers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Step_Down_Transformers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Step_Down_Transformers_Order_By>>;
  where?: InputMaybe<Step_Down_Transformers_Bool_Exp>;
};


/**
 * Table will hold full JSON sizings from legacy reaver, once inserted a trigger
 * will take care of routing all the various subkeys of the json to the proper tables.
 */
export type Sizing_ImportsStep_Up_TransformersArgs = {
  distinct_on?: InputMaybe<Array<Step_Up_Transformers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Step_Up_Transformers_Order_By>>;
  where?: InputMaybe<Step_Up_Transformers_Bool_Exp>;
};


/**
 * Table will hold full JSON sizings from legacy reaver, once inserted a trigger
 * will take care of routing all the various subkeys of the json to the proper tables.
 */
export type Sizing_ImportsStep_Up_Transformers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Step_Up_Transformers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Step_Up_Transformers_Order_By>>;
  where?: InputMaybe<Step_Up_Transformers_Bool_Exp>;
};


/**
 * Table will hold full JSON sizings from legacy reaver, once inserted a trigger
 * will take care of routing all the various subkeys of the json to the proper tables.
 */
export type Sizing_ImportsSwitchboardsArgs = {
  distinct_on?: InputMaybe<Array<Switchboards_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Switchboards_Order_By>>;
  where?: InputMaybe<Switchboards_Bool_Exp>;
};


/**
 * Table will hold full JSON sizings from legacy reaver, once inserted a trigger
 * will take care of routing all the various subkeys of the json to the proper tables.
 */
export type Sizing_ImportsSwitchboards_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Switchboards_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Switchboards_Order_By>>;
  where?: InputMaybe<Switchboards_Bool_Exp>;
};


/**
 * Table will hold full JSON sizings from legacy reaver, once inserted a trigger
 * will take care of routing all the various subkeys of the json to the proper tables.
 */
export type Sizing_ImportsTubingsArgs = {
  distinct_on?: InputMaybe<Array<Tubings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tubings_Order_By>>;
  where?: InputMaybe<Tubings_Bool_Exp>;
};


/**
 * Table will hold full JSON sizings from legacy reaver, once inserted a trigger
 * will take care of routing all the various subkeys of the json to the proper tables.
 */
export type Sizing_ImportsTubings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tubings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tubings_Order_By>>;
  where?: InputMaybe<Tubings_Bool_Exp>;
};


/**
 * Table will hold full JSON sizings from legacy reaver, once inserted a trigger
 * will take care of routing all the various subkeys of the json to the proper tables.
 */
export type Sizing_ImportsVariable_Speed_DrivesArgs = {
  distinct_on?: InputMaybe<Array<Variable_Speed_Drives_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variable_Speed_Drives_Order_By>>;
  where?: InputMaybe<Variable_Speed_Drives_Bool_Exp>;
};


/**
 * Table will hold full JSON sizings from legacy reaver, once inserted a trigger
 * will take care of routing all the various subkeys of the json to the proper tables.
 */
export type Sizing_ImportsVariable_Speed_Drives_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Variable_Speed_Drives_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variable_Speed_Drives_Order_By>>;
  where?: InputMaybe<Variable_Speed_Drives_Bool_Exp>;
};


/**
 * Table will hold full JSON sizings from legacy reaver, once inserted a trigger
 * will take care of routing all the various subkeys of the json to the proper tables.
 */
export type Sizing_ImportsWellsArgs = {
  distinct_on?: InputMaybe<Array<Wells_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Wells_Order_By>>;
  where?: InputMaybe<Wells_Bool_Exp>;
};


/**
 * Table will hold full JSON sizings from legacy reaver, once inserted a trigger
 * will take care of routing all the various subkeys of the json to the proper tables.
 */
export type Sizing_ImportsWells_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Wells_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Wells_Order_By>>;
  where?: InputMaybe<Wells_Bool_Exp>;
};

/** aggregated selection of "sizing_imports" */
export type Sizing_Imports_Aggregate = {
  __typename: 'sizing_imports_aggregate';
  aggregate?: Maybe<Sizing_Imports_Aggregate_Fields>;
  nodes: Array<Sizing_Imports>;
};

export type Sizing_Imports_Aggregate_Bool_Exp = {
  count?: InputMaybe<Sizing_Imports_Aggregate_Bool_Exp_Count>;
};

export type Sizing_Imports_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Sizing_Imports_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Sizing_Imports_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "sizing_imports" */
export type Sizing_Imports_Aggregate_Fields = {
  __typename: 'sizing_imports_aggregate_fields';
  avg?: Maybe<Sizing_Imports_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Sizing_Imports_Max_Fields>;
  min?: Maybe<Sizing_Imports_Min_Fields>;
  stddev?: Maybe<Sizing_Imports_Stddev_Fields>;
  stddev_pop?: Maybe<Sizing_Imports_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Sizing_Imports_Stddev_Samp_Fields>;
  sum?: Maybe<Sizing_Imports_Sum_Fields>;
  var_pop?: Maybe<Sizing_Imports_Var_Pop_Fields>;
  var_samp?: Maybe<Sizing_Imports_Var_Samp_Fields>;
  variance?: Maybe<Sizing_Imports_Variance_Fields>;
};


/** aggregate fields of "sizing_imports" */
export type Sizing_Imports_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Sizing_Imports_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "sizing_imports" */
export type Sizing_Imports_Aggregate_Order_By = {
  avg?: InputMaybe<Sizing_Imports_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Sizing_Imports_Max_Order_By>;
  min?: InputMaybe<Sizing_Imports_Min_Order_By>;
  stddev?: InputMaybe<Sizing_Imports_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Sizing_Imports_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Sizing_Imports_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Sizing_Imports_Sum_Order_By>;
  var_pop?: InputMaybe<Sizing_Imports_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Sizing_Imports_Var_Samp_Order_By>;
  variance?: InputMaybe<Sizing_Imports_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Sizing_Imports_Append_Input = {
  /** Concatenated PID of error, SQL State, message and PostgreSQL context. */
  error?: InputMaybe<Scalars['jsonb']['input']>;
  payload?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "sizing_imports" */
export type Sizing_Imports_Arr_Rel_Insert_Input = {
  data: Array<Sizing_Imports_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Sizing_Imports_On_Conflict>;
};

/** aggregate avg on columns */
export type Sizing_Imports_Avg_Fields = {
  __typename: 'sizing_imports_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "sizing_imports" */
export type Sizing_Imports_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "sizing_imports". All fields are combined with a logical 'AND'. */
export type Sizing_Imports_Bool_Exp = {
  _and?: InputMaybe<Array<Sizing_Imports_Bool_Exp>>;
  _not?: InputMaybe<Sizing_Imports_Bool_Exp>;
  _or?: InputMaybe<Array<Sizing_Imports_Bool_Exp>>;
  author_id?: InputMaybe<String_Comparison_Exp>;
  cables?: InputMaybe<Cables_Bool_Exp>;
  cables_aggregate?: InputMaybe<Cables_Aggregate_Bool_Exp>;
  casings?: InputMaybe<Casings_Bool_Exp>;
  casings_aggregate?: InputMaybe<Casings_Aggregate_Bool_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  customers?: InputMaybe<Customers_Bool_Exp>;
  customers_aggregate?: InputMaybe<Customers_Aggregate_Bool_Exp>;
  deviation_surveys?: InputMaybe<Deviation_Survey_Bool_Exp>;
  deviation_surveys_aggregate?: InputMaybe<Deviation_Survey_Aggregate_Bool_Exp>;
  error?: InputMaybe<Jsonb_Comparison_Exp>;
  housings?: InputMaybe<Housings_Bool_Exp>;
  housings_aggregate?: InputMaybe<Housings_Aggregate_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  imported_at?: InputMaybe<Timestamp_Comparison_Exp>;
  intakes?: InputMaybe<Intakes_Bool_Exp>;
  intakes_aggregate?: InputMaybe<Intakes_Aggregate_Bool_Exp>;
  legacy_author_id?: InputMaybe<String_Comparison_Exp>;
  legacy_sizing_name?: InputMaybe<String_Comparison_Exp>;
  legacy_sizing_reaver_id?: InputMaybe<String_Comparison_Exp>;
  legacy_user?: InputMaybe<Legacy_Users_Bool_Exp>;
  motor_lead_extensions?: InputMaybe<Motor_Lead_Extensions_Bool_Exp>;
  motor_lead_extensions_aggregate?: InputMaybe<Motor_Lead_Extensions_Aggregate_Bool_Exp>;
  motors?: InputMaybe<Motors_Bool_Exp>;
  motors_aggregate?: InputMaybe<Motors_Aggregate_Bool_Exp>;
  payload?: InputMaybe<Jsonb_Comparison_Exp>;
  payload_hash?: InputMaybe<String_Comparison_Exp>;
  pumps?: InputMaybe<Pumps_Bool_Exp>;
  pumps_aggregate?: InputMaybe<Pumps_Aggregate_Bool_Exp>;
  seals?: InputMaybe<Seals_Bool_Exp>;
  seals_aggregate?: InputMaybe<Seals_Aggregate_Bool_Exp>;
  sensors?: InputMaybe<Sensors_Bool_Exp>;
  sensors_aggregate?: InputMaybe<Sensors_Aggregate_Bool_Exp>;
  step_down_transformers?: InputMaybe<Step_Down_Transformers_Bool_Exp>;
  step_down_transformers_aggregate?: InputMaybe<Step_Down_Transformers_Aggregate_Bool_Exp>;
  step_up_transformers?: InputMaybe<Step_Up_Transformers_Bool_Exp>;
  step_up_transformers_aggregate?: InputMaybe<Step_Up_Transformers_Aggregate_Bool_Exp>;
  switchboards?: InputMaybe<Switchboards_Bool_Exp>;
  switchboards_aggregate?: InputMaybe<Switchboards_Aggregate_Bool_Exp>;
  tubings?: InputMaybe<Tubings_Bool_Exp>;
  tubings_aggregate?: InputMaybe<Tubings_Aggregate_Bool_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  variable_speed_drives?: InputMaybe<Variable_Speed_Drives_Bool_Exp>;
  variable_speed_drives_aggregate?: InputMaybe<Variable_Speed_Drives_Aggregate_Bool_Exp>;
  wells?: InputMaybe<Wells_Bool_Exp>;
  wells_aggregate?: InputMaybe<Wells_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "sizing_imports" */
export enum Sizing_Imports_Constraint {
  /** unique or primary key constraint on columns "id" */
  SizingImportsPkey = 'sizing_imports_pkey',
  /** unique or primary key constraint on columns "payload_hash" */
  UniquePayloadHashWhenErrorIsNull = 'unique_payload_hash_when_error_is_null'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Sizing_Imports_Delete_At_Path_Input = {
  /** Concatenated PID of error, SQL State, message and PostgreSQL context. */
  error?: InputMaybe<Array<Scalars['String']['input']>>;
  payload?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Sizing_Imports_Delete_Elem_Input = {
  /** Concatenated PID of error, SQL State, message and PostgreSQL context. */
  error?: InputMaybe<Scalars['Int']['input']>;
  payload?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Sizing_Imports_Delete_Key_Input = {
  /** Concatenated PID of error, SQL State, message and PostgreSQL context. */
  error?: InputMaybe<Scalars['String']['input']>;
  payload?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "sizing_imports" */
export type Sizing_Imports_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "sizing_imports" */
export type Sizing_Imports_Insert_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  cables?: InputMaybe<Cables_Arr_Rel_Insert_Input>;
  casings?: InputMaybe<Casings_Arr_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  customers?: InputMaybe<Customers_Arr_Rel_Insert_Input>;
  deviation_surveys?: InputMaybe<Deviation_Survey_Arr_Rel_Insert_Input>;
  /** Concatenated PID of error, SQL State, message and PostgreSQL context. */
  error?: InputMaybe<Scalars['jsonb']['input']>;
  housings?: InputMaybe<Housings_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['Int']['input']>;
  imported_at?: InputMaybe<Scalars['timestamp']['input']>;
  intakes?: InputMaybe<Intakes_Arr_Rel_Insert_Input>;
  legacy_author_id?: InputMaybe<Scalars['String']['input']>;
  legacy_sizing_name?: InputMaybe<Scalars['String']['input']>;
  legacy_sizing_reaver_id?: InputMaybe<Scalars['String']['input']>;
  legacy_user?: InputMaybe<Legacy_Users_Obj_Rel_Insert_Input>;
  motor_lead_extensions?: InputMaybe<Motor_Lead_Extensions_Arr_Rel_Insert_Input>;
  motors?: InputMaybe<Motors_Arr_Rel_Insert_Input>;
  payload?: InputMaybe<Scalars['jsonb']['input']>;
  payload_hash?: InputMaybe<Scalars['String']['input']>;
  pumps?: InputMaybe<Pumps_Arr_Rel_Insert_Input>;
  seals?: InputMaybe<Seals_Arr_Rel_Insert_Input>;
  sensors?: InputMaybe<Sensors_Arr_Rel_Insert_Input>;
  step_down_transformers?: InputMaybe<Step_Down_Transformers_Arr_Rel_Insert_Input>;
  step_up_transformers?: InputMaybe<Step_Up_Transformers_Arr_Rel_Insert_Input>;
  switchboards?: InputMaybe<Switchboards_Arr_Rel_Insert_Input>;
  tubings?: InputMaybe<Tubings_Arr_Rel_Insert_Input>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  variable_speed_drives?: InputMaybe<Variable_Speed_Drives_Arr_Rel_Insert_Input>;
  wells?: InputMaybe<Wells_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Sizing_Imports_Max_Fields = {
  __typename: 'sizing_imports_max_fields';
  author_id?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  imported_at?: Maybe<Scalars['timestamp']['output']>;
  legacy_author_id?: Maybe<Scalars['String']['output']>;
  legacy_sizing_name?: Maybe<Scalars['String']['output']>;
  legacy_sizing_reaver_id?: Maybe<Scalars['String']['output']>;
  payload_hash?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "sizing_imports" */
export type Sizing_Imports_Max_Order_By = {
  author_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  imported_at?: InputMaybe<Order_By>;
  legacy_author_id?: InputMaybe<Order_By>;
  legacy_sizing_name?: InputMaybe<Order_By>;
  legacy_sizing_reaver_id?: InputMaybe<Order_By>;
  payload_hash?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Sizing_Imports_Min_Fields = {
  __typename: 'sizing_imports_min_fields';
  author_id?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  imported_at?: Maybe<Scalars['timestamp']['output']>;
  legacy_author_id?: Maybe<Scalars['String']['output']>;
  legacy_sizing_name?: Maybe<Scalars['String']['output']>;
  legacy_sizing_reaver_id?: Maybe<Scalars['String']['output']>;
  payload_hash?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "sizing_imports" */
export type Sizing_Imports_Min_Order_By = {
  author_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  imported_at?: InputMaybe<Order_By>;
  legacy_author_id?: InputMaybe<Order_By>;
  legacy_sizing_name?: InputMaybe<Order_By>;
  legacy_sizing_reaver_id?: InputMaybe<Order_By>;
  payload_hash?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "sizing_imports" */
export type Sizing_Imports_Mutation_Response = {
  __typename: 'sizing_imports_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Sizing_Imports>;
};

/** input type for inserting object relation for remote table "sizing_imports" */
export type Sizing_Imports_Obj_Rel_Insert_Input = {
  data: Sizing_Imports_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Sizing_Imports_On_Conflict>;
};

/** on_conflict condition type for table "sizing_imports" */
export type Sizing_Imports_On_Conflict = {
  constraint: Sizing_Imports_Constraint;
  update_columns?: Array<Sizing_Imports_Update_Column>;
  where?: InputMaybe<Sizing_Imports_Bool_Exp>;
};

/** Ordering options when selecting data from "sizing_imports". */
export type Sizing_Imports_Order_By = {
  author_id?: InputMaybe<Order_By>;
  cables_aggregate?: InputMaybe<Cables_Aggregate_Order_By>;
  casings_aggregate?: InputMaybe<Casings_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  customers_aggregate?: InputMaybe<Customers_Aggregate_Order_By>;
  deviation_surveys_aggregate?: InputMaybe<Deviation_Survey_Aggregate_Order_By>;
  error?: InputMaybe<Order_By>;
  housings_aggregate?: InputMaybe<Housings_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  imported_at?: InputMaybe<Order_By>;
  intakes_aggregate?: InputMaybe<Intakes_Aggregate_Order_By>;
  legacy_author_id?: InputMaybe<Order_By>;
  legacy_sizing_name?: InputMaybe<Order_By>;
  legacy_sizing_reaver_id?: InputMaybe<Order_By>;
  legacy_user?: InputMaybe<Legacy_Users_Order_By>;
  motor_lead_extensions_aggregate?: InputMaybe<Motor_Lead_Extensions_Aggregate_Order_By>;
  motors_aggregate?: InputMaybe<Motors_Aggregate_Order_By>;
  payload?: InputMaybe<Order_By>;
  payload_hash?: InputMaybe<Order_By>;
  pumps_aggregate?: InputMaybe<Pumps_Aggregate_Order_By>;
  seals_aggregate?: InputMaybe<Seals_Aggregate_Order_By>;
  sensors_aggregate?: InputMaybe<Sensors_Aggregate_Order_By>;
  step_down_transformers_aggregate?: InputMaybe<Step_Down_Transformers_Aggregate_Order_By>;
  step_up_transformers_aggregate?: InputMaybe<Step_Up_Transformers_Aggregate_Order_By>;
  switchboards_aggregate?: InputMaybe<Switchboards_Aggregate_Order_By>;
  tubings_aggregate?: InputMaybe<Tubings_Aggregate_Order_By>;
  user?: InputMaybe<Users_Order_By>;
  variable_speed_drives_aggregate?: InputMaybe<Variable_Speed_Drives_Aggregate_Order_By>;
  wells_aggregate?: InputMaybe<Wells_Aggregate_Order_By>;
};

/** primary key columns input for table: sizing_imports */
export type Sizing_Imports_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Sizing_Imports_Prepend_Input = {
  /** Concatenated PID of error, SQL State, message and PostgreSQL context. */
  error?: InputMaybe<Scalars['jsonb']['input']>;
  payload?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "sizing_imports" */
export enum Sizing_Imports_Select_Column {
  /** column name */
  AuthorId = 'author_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Error = 'error',
  /** column name */
  Id = 'id',
  /** column name */
  ImportedAt = 'imported_at',
  /** column name */
  LegacyAuthorId = 'legacy_author_id',
  /** column name */
  LegacySizingName = 'legacy_sizing_name',
  /** column name */
  LegacySizingReaverId = 'legacy_sizing_reaver_id',
  /** column name */
  Payload = 'payload',
  /** column name */
  PayloadHash = 'payload_hash'
}

/** input type for updating data in table "sizing_imports" */
export type Sizing_Imports_Set_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  /** Concatenated PID of error, SQL State, message and PostgreSQL context. */
  error?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  imported_at?: InputMaybe<Scalars['timestamp']['input']>;
  legacy_author_id?: InputMaybe<Scalars['String']['input']>;
  legacy_sizing_name?: InputMaybe<Scalars['String']['input']>;
  legacy_sizing_reaver_id?: InputMaybe<Scalars['String']['input']>;
  payload?: InputMaybe<Scalars['jsonb']['input']>;
  payload_hash?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Sizing_Imports_Stddev_Fields = {
  __typename: 'sizing_imports_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "sizing_imports" */
export type Sizing_Imports_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Sizing_Imports_Stddev_Pop_Fields = {
  __typename: 'sizing_imports_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "sizing_imports" */
export type Sizing_Imports_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Sizing_Imports_Stddev_Samp_Fields = {
  __typename: 'sizing_imports_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "sizing_imports" */
export type Sizing_Imports_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "sizing_imports" */
export type Sizing_Imports_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Sizing_Imports_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Sizing_Imports_Stream_Cursor_Value_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  /** Concatenated PID of error, SQL State, message and PostgreSQL context. */
  error?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  imported_at?: InputMaybe<Scalars['timestamp']['input']>;
  legacy_author_id?: InputMaybe<Scalars['String']['input']>;
  legacy_sizing_name?: InputMaybe<Scalars['String']['input']>;
  legacy_sizing_reaver_id?: InputMaybe<Scalars['String']['input']>;
  payload?: InputMaybe<Scalars['jsonb']['input']>;
  payload_hash?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Sizing_Imports_Sum_Fields = {
  __typename: 'sizing_imports_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "sizing_imports" */
export type Sizing_Imports_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** update columns of table "sizing_imports" */
export enum Sizing_Imports_Update_Column {
  /** column name */
  AuthorId = 'author_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Error = 'error',
  /** column name */
  Id = 'id',
  /** column name */
  ImportedAt = 'imported_at',
  /** column name */
  LegacyAuthorId = 'legacy_author_id',
  /** column name */
  LegacySizingName = 'legacy_sizing_name',
  /** column name */
  LegacySizingReaverId = 'legacy_sizing_reaver_id',
  /** column name */
  Payload = 'payload',
  /** column name */
  PayloadHash = 'payload_hash'
}

export type Sizing_Imports_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Sizing_Imports_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Sizing_Imports_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Sizing_Imports_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Sizing_Imports_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Sizing_Imports_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Sizing_Imports_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Sizing_Imports_Set_Input>;
  /** filter the rows which have to be updated */
  where: Sizing_Imports_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Sizing_Imports_Var_Pop_Fields = {
  __typename: 'sizing_imports_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "sizing_imports" */
export type Sizing_Imports_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Sizing_Imports_Var_Samp_Fields = {
  __typename: 'sizing_imports_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "sizing_imports" */
export type Sizing_Imports_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Sizing_Imports_Variance_Fields = {
  __typename: 'sizing_imports_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "sizing_imports" */
export type Sizing_Imports_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "sizing_pumping_type" */
export type Sizing_Pumping_Type = {
  __typename: 'sizing_pumping_type';
  comment?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

/** aggregated selection of "sizing_pumping_type" */
export type Sizing_Pumping_Type_Aggregate = {
  __typename: 'sizing_pumping_type_aggregate';
  aggregate?: Maybe<Sizing_Pumping_Type_Aggregate_Fields>;
  nodes: Array<Sizing_Pumping_Type>;
};

/** aggregate fields of "sizing_pumping_type" */
export type Sizing_Pumping_Type_Aggregate_Fields = {
  __typename: 'sizing_pumping_type_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Sizing_Pumping_Type_Max_Fields>;
  min?: Maybe<Sizing_Pumping_Type_Min_Fields>;
};


/** aggregate fields of "sizing_pumping_type" */
export type Sizing_Pumping_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Sizing_Pumping_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "sizing_pumping_type". All fields are combined with a logical 'AND'. */
export type Sizing_Pumping_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Sizing_Pumping_Type_Bool_Exp>>;
  _not?: InputMaybe<Sizing_Pumping_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Sizing_Pumping_Type_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "sizing_pumping_type" */
export enum Sizing_Pumping_Type_Constraint {
  /** unique or primary key constraint on columns "value" */
  SizingPumpingTypePkey = 'sizing_pumping_type_pkey'
}

export enum Sizing_Pumping_Type_Enum {
  /** ESP On-Shore */
  EspOnShore = 'esp_on_shore',
  /** HPS */
  Hps = 'hps'
}

/** Boolean expression to compare columns of type "sizing_pumping_type_enum". All fields are combined with logical 'AND'. */
export type Sizing_Pumping_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Sizing_Pumping_Type_Enum>;
  _in?: InputMaybe<Array<Sizing_Pumping_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Sizing_Pumping_Type_Enum>;
  _nin?: InputMaybe<Array<Sizing_Pumping_Type_Enum>>;
};

/** input type for inserting data into table "sizing_pumping_type" */
export type Sizing_Pumping_Type_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Sizing_Pumping_Type_Max_Fields = {
  __typename: 'sizing_pumping_type_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Sizing_Pumping_Type_Min_Fields = {
  __typename: 'sizing_pumping_type_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "sizing_pumping_type" */
export type Sizing_Pumping_Type_Mutation_Response = {
  __typename: 'sizing_pumping_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Sizing_Pumping_Type>;
};

/** on_conflict condition type for table "sizing_pumping_type" */
export type Sizing_Pumping_Type_On_Conflict = {
  constraint: Sizing_Pumping_Type_Constraint;
  update_columns?: Array<Sizing_Pumping_Type_Update_Column>;
  where?: InputMaybe<Sizing_Pumping_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "sizing_pumping_type". */
export type Sizing_Pumping_Type_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: sizing_pumping_type */
export type Sizing_Pumping_Type_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "sizing_pumping_type" */
export enum Sizing_Pumping_Type_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "sizing_pumping_type" */
export type Sizing_Pumping_Type_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "sizing_pumping_type" */
export type Sizing_Pumping_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Sizing_Pumping_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Sizing_Pumping_Type_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "sizing_pumping_type" */
export enum Sizing_Pumping_Type_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Sizing_Pumping_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Sizing_Pumping_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Sizing_Pumping_Type_Bool_Exp;
};

/** columns and relationships of "sizings" */
export type Sizings = {
  __typename: 'sizings';
  /** An object relationship */
  author?: Maybe<Users>;
  /** An object relationship */
  customer?: Maybe<Customers>;
  customer_id?: Maybe<Scalars['Int']['output']>;
  default_display_units?: Maybe<Scalars['String']['output']>;
  disposition?: Maybe<Scalars['String']['output']>;
  hps_location?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  imported_from_sizing?: Maybe<Sizing_Imports>;
  imported_sizing_id?: Maybe<Scalars['Int']['output']>;
  installed_scenario_id?: Maybe<Scalars['uuid']['output']>;
  is_shared?: Maybe<Scalars['Boolean']['output']>;
  journal_author_id?: Maybe<Scalars['String']['output']>;
  journal_created_at?: Maybe<Scalars['timestamptz']['output']>;
  journal_deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  journal_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  parent_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  parent_sizing?: Maybe<Sizings>;
  pumping_type?: Maybe<Scalars['String']['output']>;
  scenario_order?: Maybe<Array<Scalars['uuid']['output']>>;
  /** An array relationship */
  scenarios: Array<Scenarios>;
  /** An aggregate relationship */
  scenarios_aggregate: Scenarios_Aggregate;
  share_with_customer?: Maybe<Scalars['Boolean']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  well?: Maybe<Wells>;
  well_id?: Maybe<Scalars['Int']['output']>;
  winning_revision_author_id?: Maybe<Scalars['String']['output']>;
  winning_revision_created_at?: Maybe<Scalars['timestamptz']['output']>;
  winning_revision_deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  winning_revision_id?: Maybe<Scalars['uuid']['output']>;
  winning_revision_parent_id?: Maybe<Scalars['uuid']['output']>;
  winning_revision_updated_at?: Maybe<Scalars['timestamptz']['output']>;
};


/** columns and relationships of "sizings" */
export type SizingsScenariosArgs = {
  distinct_on?: InputMaybe<Array<Scenarios_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Scenarios_Order_By>>;
  where?: InputMaybe<Scenarios_Bool_Exp>;
};


/** columns and relationships of "sizings" */
export type SizingsScenarios_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Scenarios_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Scenarios_Order_By>>;
  where?: InputMaybe<Scenarios_Bool_Exp>;
};

/** aggregated selection of "sizings" */
export type Sizings_Aggregate = {
  __typename: 'sizings_aggregate';
  aggregate?: Maybe<Sizings_Aggregate_Fields>;
  nodes: Array<Sizings>;
};

export type Sizings_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Sizings_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Sizings_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Sizings_Aggregate_Bool_Exp_Count>;
};

export type Sizings_Aggregate_Bool_Exp_Bool_And = {
  arguments: Sizings_Select_Column_Sizings_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Sizings_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Sizings_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Sizings_Select_Column_Sizings_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Sizings_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Sizings_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Sizings_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Sizings_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "sizings" */
export type Sizings_Aggregate_Fields = {
  __typename: 'sizings_aggregate_fields';
  avg?: Maybe<Sizings_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Sizings_Max_Fields>;
  min?: Maybe<Sizings_Min_Fields>;
  stddev?: Maybe<Sizings_Stddev_Fields>;
  stddev_pop?: Maybe<Sizings_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Sizings_Stddev_Samp_Fields>;
  sum?: Maybe<Sizings_Sum_Fields>;
  var_pop?: Maybe<Sizings_Var_Pop_Fields>;
  var_samp?: Maybe<Sizings_Var_Samp_Fields>;
  variance?: Maybe<Sizings_Variance_Fields>;
};


/** aggregate fields of "sizings" */
export type Sizings_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Sizings_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "sizings" */
export type Sizings_Aggregate_Order_By = {
  avg?: InputMaybe<Sizings_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Sizings_Max_Order_By>;
  min?: InputMaybe<Sizings_Min_Order_By>;
  stddev?: InputMaybe<Sizings_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Sizings_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Sizings_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Sizings_Sum_Order_By>;
  var_pop?: InputMaybe<Sizings_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Sizings_Var_Samp_Order_By>;
  variance?: InputMaybe<Sizings_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "sizings" */
export type Sizings_Arr_Rel_Insert_Input = {
  data: Array<Sizings_Insert_Input>;
};

/** aggregate avg on columns */
export type Sizings_Avg_Fields = {
  __typename: 'sizings_avg_fields';
  customer_id?: Maybe<Scalars['Float']['output']>;
  imported_sizing_id?: Maybe<Scalars['Float']['output']>;
  well_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "sizings" */
export type Sizings_Avg_Order_By = {
  customer_id?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  well_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "sizings". All fields are combined with a logical 'AND'. */
export type Sizings_Bool_Exp = {
  _and?: InputMaybe<Array<Sizings_Bool_Exp>>;
  _not?: InputMaybe<Sizings_Bool_Exp>;
  _or?: InputMaybe<Array<Sizings_Bool_Exp>>;
  author?: InputMaybe<Users_Bool_Exp>;
  customer?: InputMaybe<Customers_Bool_Exp>;
  customer_id?: InputMaybe<Int_Comparison_Exp>;
  default_display_units?: InputMaybe<String_Comparison_Exp>;
  disposition?: InputMaybe<String_Comparison_Exp>;
  hps_location?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  imported_from_sizing?: InputMaybe<Sizing_Imports_Bool_Exp>;
  imported_sizing_id?: InputMaybe<Int_Comparison_Exp>;
  installed_scenario_id?: InputMaybe<Uuid_Comparison_Exp>;
  is_shared?: InputMaybe<Boolean_Comparison_Exp>;
  journal_author_id?: InputMaybe<String_Comparison_Exp>;
  journal_created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  journal_deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  journal_updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  notes?: InputMaybe<String_Comparison_Exp>;
  parent_id?: InputMaybe<Uuid_Comparison_Exp>;
  parent_sizing?: InputMaybe<Sizings_Bool_Exp>;
  pumping_type?: InputMaybe<String_Comparison_Exp>;
  scenario_order?: InputMaybe<Uuid_Array_Comparison_Exp>;
  scenarios?: InputMaybe<Scenarios_Bool_Exp>;
  scenarios_aggregate?: InputMaybe<Scenarios_Aggregate_Bool_Exp>;
  share_with_customer?: InputMaybe<Boolean_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  well?: InputMaybe<Wells_Bool_Exp>;
  well_id?: InputMaybe<Int_Comparison_Exp>;
  winning_revision_author_id?: InputMaybe<String_Comparison_Exp>;
  winning_revision_created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  winning_revision_deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  winning_revision_id?: InputMaybe<Uuid_Comparison_Exp>;
  winning_revision_parent_id?: InputMaybe<Uuid_Comparison_Exp>;
  winning_revision_updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** input type for inserting data into table "sizings" */
export type Sizings_Insert_Input = {
  author?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  customer?: InputMaybe<Customers_Obj_Rel_Insert_Input>;
  customer_id?: InputMaybe<Scalars['Int']['input']>;
  default_display_units?: InputMaybe<Scalars['String']['input']>;
  disposition?: InputMaybe<Scalars['String']['input']>;
  hps_location?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  imported_from_sizing?: InputMaybe<Sizing_Imports_Obj_Rel_Insert_Input>;
  imported_sizing_id?: InputMaybe<Scalars['Int']['input']>;
  installed_scenario_id?: InputMaybe<Scalars['uuid']['input']>;
  is_shared?: InputMaybe<Scalars['Boolean']['input']>;
  journal_author_id?: InputMaybe<Scalars['String']['input']>;
  journal_created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  journal_deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  journal_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  parent_id?: InputMaybe<Scalars['uuid']['input']>;
  parent_sizing?: InputMaybe<Sizings_Obj_Rel_Insert_Input>;
  pumping_type?: InputMaybe<Scalars['String']['input']>;
  scenario_order?: InputMaybe<Array<Scalars['uuid']['input']>>;
  scenarios?: InputMaybe<Scenarios_Arr_Rel_Insert_Input>;
  share_with_customer?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  well?: InputMaybe<Wells_Obj_Rel_Insert_Input>;
  well_id?: InputMaybe<Scalars['Int']['input']>;
  winning_revision_author_id?: InputMaybe<Scalars['String']['input']>;
  winning_revision_created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  winning_revision_deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  winning_revision_id?: InputMaybe<Scalars['uuid']['input']>;
  winning_revision_parent_id?: InputMaybe<Scalars['uuid']['input']>;
  winning_revision_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Sizings_Max_Fields = {
  __typename: 'sizings_max_fields';
  customer_id?: Maybe<Scalars['Int']['output']>;
  default_display_units?: Maybe<Scalars['String']['output']>;
  disposition?: Maybe<Scalars['String']['output']>;
  hps_location?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  imported_sizing_id?: Maybe<Scalars['Int']['output']>;
  installed_scenario_id?: Maybe<Scalars['uuid']['output']>;
  journal_author_id?: Maybe<Scalars['String']['output']>;
  journal_created_at?: Maybe<Scalars['timestamptz']['output']>;
  journal_deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  journal_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  parent_id?: Maybe<Scalars['uuid']['output']>;
  pumping_type?: Maybe<Scalars['String']['output']>;
  scenario_order?: Maybe<Array<Scalars['uuid']['output']>>;
  title?: Maybe<Scalars['String']['output']>;
  well_id?: Maybe<Scalars['Int']['output']>;
  winning_revision_author_id?: Maybe<Scalars['String']['output']>;
  winning_revision_created_at?: Maybe<Scalars['timestamptz']['output']>;
  winning_revision_deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  winning_revision_id?: Maybe<Scalars['uuid']['output']>;
  winning_revision_parent_id?: Maybe<Scalars['uuid']['output']>;
  winning_revision_updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "sizings" */
export type Sizings_Max_Order_By = {
  customer_id?: InputMaybe<Order_By>;
  default_display_units?: InputMaybe<Order_By>;
  disposition?: InputMaybe<Order_By>;
  hps_location?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  installed_scenario_id?: InputMaybe<Order_By>;
  journal_author_id?: InputMaybe<Order_By>;
  journal_created_at?: InputMaybe<Order_By>;
  journal_deleted_at?: InputMaybe<Order_By>;
  journal_updated_at?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  pumping_type?: InputMaybe<Order_By>;
  scenario_order?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  well_id?: InputMaybe<Order_By>;
  winning_revision_author_id?: InputMaybe<Order_By>;
  winning_revision_created_at?: InputMaybe<Order_By>;
  winning_revision_deleted_at?: InputMaybe<Order_By>;
  winning_revision_id?: InputMaybe<Order_By>;
  winning_revision_parent_id?: InputMaybe<Order_By>;
  winning_revision_updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Sizings_Min_Fields = {
  __typename: 'sizings_min_fields';
  customer_id?: Maybe<Scalars['Int']['output']>;
  default_display_units?: Maybe<Scalars['String']['output']>;
  disposition?: Maybe<Scalars['String']['output']>;
  hps_location?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  imported_sizing_id?: Maybe<Scalars['Int']['output']>;
  installed_scenario_id?: Maybe<Scalars['uuid']['output']>;
  journal_author_id?: Maybe<Scalars['String']['output']>;
  journal_created_at?: Maybe<Scalars['timestamptz']['output']>;
  journal_deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  journal_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  parent_id?: Maybe<Scalars['uuid']['output']>;
  pumping_type?: Maybe<Scalars['String']['output']>;
  scenario_order?: Maybe<Array<Scalars['uuid']['output']>>;
  title?: Maybe<Scalars['String']['output']>;
  well_id?: Maybe<Scalars['Int']['output']>;
  winning_revision_author_id?: Maybe<Scalars['String']['output']>;
  winning_revision_created_at?: Maybe<Scalars['timestamptz']['output']>;
  winning_revision_deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  winning_revision_id?: Maybe<Scalars['uuid']['output']>;
  winning_revision_parent_id?: Maybe<Scalars['uuid']['output']>;
  winning_revision_updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "sizings" */
export type Sizings_Min_Order_By = {
  customer_id?: InputMaybe<Order_By>;
  default_display_units?: InputMaybe<Order_By>;
  disposition?: InputMaybe<Order_By>;
  hps_location?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  installed_scenario_id?: InputMaybe<Order_By>;
  journal_author_id?: InputMaybe<Order_By>;
  journal_created_at?: InputMaybe<Order_By>;
  journal_deleted_at?: InputMaybe<Order_By>;
  journal_updated_at?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  pumping_type?: InputMaybe<Order_By>;
  scenario_order?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  well_id?: InputMaybe<Order_By>;
  winning_revision_author_id?: InputMaybe<Order_By>;
  winning_revision_created_at?: InputMaybe<Order_By>;
  winning_revision_deleted_at?: InputMaybe<Order_By>;
  winning_revision_id?: InputMaybe<Order_By>;
  winning_revision_parent_id?: InputMaybe<Order_By>;
  winning_revision_updated_at?: InputMaybe<Order_By>;
};

/** input type for inserting object relation for remote table "sizings" */
export type Sizings_Obj_Rel_Insert_Input = {
  data: Sizings_Insert_Input;
};

/** Ordering options when selecting data from "sizings". */
export type Sizings_Order_By = {
  author?: InputMaybe<Users_Order_By>;
  customer?: InputMaybe<Customers_Order_By>;
  customer_id?: InputMaybe<Order_By>;
  default_display_units?: InputMaybe<Order_By>;
  disposition?: InputMaybe<Order_By>;
  hps_location?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  imported_from_sizing?: InputMaybe<Sizing_Imports_Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  installed_scenario_id?: InputMaybe<Order_By>;
  is_shared?: InputMaybe<Order_By>;
  journal_author_id?: InputMaybe<Order_By>;
  journal_created_at?: InputMaybe<Order_By>;
  journal_deleted_at?: InputMaybe<Order_By>;
  journal_updated_at?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  parent_sizing?: InputMaybe<Sizings_Order_By>;
  pumping_type?: InputMaybe<Order_By>;
  scenario_order?: InputMaybe<Order_By>;
  scenarios_aggregate?: InputMaybe<Scenarios_Aggregate_Order_By>;
  share_with_customer?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  well?: InputMaybe<Wells_Order_By>;
  well_id?: InputMaybe<Order_By>;
  winning_revision_author_id?: InputMaybe<Order_By>;
  winning_revision_created_at?: InputMaybe<Order_By>;
  winning_revision_deleted_at?: InputMaybe<Order_By>;
  winning_revision_id?: InputMaybe<Order_By>;
  winning_revision_parent_id?: InputMaybe<Order_By>;
  winning_revision_updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "sizings" */
export enum Sizings_Select_Column {
  /** column name */
  CustomerId = 'customer_id',
  /** column name */
  DefaultDisplayUnits = 'default_display_units',
  /** column name */
  Disposition = 'disposition',
  /** column name */
  HpsLocation = 'hps_location',
  /** column name */
  Id = 'id',
  /** column name */
  ImportedSizingId = 'imported_sizing_id',
  /** column name */
  InstalledScenarioId = 'installed_scenario_id',
  /** column name */
  IsShared = 'is_shared',
  /** column name */
  JournalAuthorId = 'journal_author_id',
  /** column name */
  JournalCreatedAt = 'journal_created_at',
  /** column name */
  JournalDeletedAt = 'journal_deleted_at',
  /** column name */
  JournalUpdatedAt = 'journal_updated_at',
  /** column name */
  Notes = 'notes',
  /** column name */
  ParentId = 'parent_id',
  /** column name */
  PumpingType = 'pumping_type',
  /** column name */
  ScenarioOrder = 'scenario_order',
  /** column name */
  ShareWithCustomer = 'share_with_customer',
  /** column name */
  Title = 'title',
  /** column name */
  WellId = 'well_id',
  /** column name */
  WinningRevisionAuthorId = 'winning_revision_author_id',
  /** column name */
  WinningRevisionCreatedAt = 'winning_revision_created_at',
  /** column name */
  WinningRevisionDeletedAt = 'winning_revision_deleted_at',
  /** column name */
  WinningRevisionId = 'winning_revision_id',
  /** column name */
  WinningRevisionParentId = 'winning_revision_parent_id',
  /** column name */
  WinningRevisionUpdatedAt = 'winning_revision_updated_at'
}

/** select "sizings_aggregate_bool_exp_bool_and_arguments_columns" columns of table "sizings" */
export enum Sizings_Select_Column_Sizings_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsShared = 'is_shared',
  /** column name */
  ShareWithCustomer = 'share_with_customer'
}

/** select "sizings_aggregate_bool_exp_bool_or_arguments_columns" columns of table "sizings" */
export enum Sizings_Select_Column_Sizings_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsShared = 'is_shared',
  /** column name */
  ShareWithCustomer = 'share_with_customer'
}

/** aggregate stddev on columns */
export type Sizings_Stddev_Fields = {
  __typename: 'sizings_stddev_fields';
  customer_id?: Maybe<Scalars['Float']['output']>;
  imported_sizing_id?: Maybe<Scalars['Float']['output']>;
  well_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "sizings" */
export type Sizings_Stddev_Order_By = {
  customer_id?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  well_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Sizings_Stddev_Pop_Fields = {
  __typename: 'sizings_stddev_pop_fields';
  customer_id?: Maybe<Scalars['Float']['output']>;
  imported_sizing_id?: Maybe<Scalars['Float']['output']>;
  well_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "sizings" */
export type Sizings_Stddev_Pop_Order_By = {
  customer_id?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  well_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Sizings_Stddev_Samp_Fields = {
  __typename: 'sizings_stddev_samp_fields';
  customer_id?: Maybe<Scalars['Float']['output']>;
  imported_sizing_id?: Maybe<Scalars['Float']['output']>;
  well_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "sizings" */
export type Sizings_Stddev_Samp_Order_By = {
  customer_id?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  well_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "sizings" */
export type Sizings_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Sizings_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Sizings_Stream_Cursor_Value_Input = {
  customer_id?: InputMaybe<Scalars['Int']['input']>;
  default_display_units?: InputMaybe<Scalars['String']['input']>;
  disposition?: InputMaybe<Scalars['String']['input']>;
  hps_location?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  imported_sizing_id?: InputMaybe<Scalars['Int']['input']>;
  installed_scenario_id?: InputMaybe<Scalars['uuid']['input']>;
  is_shared?: InputMaybe<Scalars['Boolean']['input']>;
  journal_author_id?: InputMaybe<Scalars['String']['input']>;
  journal_created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  journal_deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  journal_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  parent_id?: InputMaybe<Scalars['uuid']['input']>;
  pumping_type?: InputMaybe<Scalars['String']['input']>;
  scenario_order?: InputMaybe<Array<Scalars['uuid']['input']>>;
  share_with_customer?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  well_id?: InputMaybe<Scalars['Int']['input']>;
  winning_revision_author_id?: InputMaybe<Scalars['String']['input']>;
  winning_revision_created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  winning_revision_deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  winning_revision_id?: InputMaybe<Scalars['uuid']['input']>;
  winning_revision_parent_id?: InputMaybe<Scalars['uuid']['input']>;
  winning_revision_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Sizings_Sum_Fields = {
  __typename: 'sizings_sum_fields';
  customer_id?: Maybe<Scalars['Int']['output']>;
  imported_sizing_id?: Maybe<Scalars['Int']['output']>;
  well_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "sizings" */
export type Sizings_Sum_Order_By = {
  customer_id?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  well_id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Sizings_Var_Pop_Fields = {
  __typename: 'sizings_var_pop_fields';
  customer_id?: Maybe<Scalars['Float']['output']>;
  imported_sizing_id?: Maybe<Scalars['Float']['output']>;
  well_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "sizings" */
export type Sizings_Var_Pop_Order_By = {
  customer_id?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  well_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Sizings_Var_Samp_Fields = {
  __typename: 'sizings_var_samp_fields';
  customer_id?: Maybe<Scalars['Float']['output']>;
  imported_sizing_id?: Maybe<Scalars['Float']['output']>;
  well_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "sizings" */
export type Sizings_Var_Samp_Order_By = {
  customer_id?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  well_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Sizings_Variance_Fields = {
  __typename: 'sizings_variance_fields';
  customer_id?: Maybe<Scalars['Float']['output']>;
  imported_sizing_id?: Maybe<Scalars['Float']['output']>;
  well_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "sizings" */
export type Sizings_Variance_Order_By = {
  customer_id?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  well_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "solution_gas_oil_ratio_options" */
export type Solution_Gas_Oil_Ratio_Options = {
  __typename: 'solution_gas_oil_ratio_options';
  comment?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

/** aggregated selection of "solution_gas_oil_ratio_options" */
export type Solution_Gas_Oil_Ratio_Options_Aggregate = {
  __typename: 'solution_gas_oil_ratio_options_aggregate';
  aggregate?: Maybe<Solution_Gas_Oil_Ratio_Options_Aggregate_Fields>;
  nodes: Array<Solution_Gas_Oil_Ratio_Options>;
};

/** aggregate fields of "solution_gas_oil_ratio_options" */
export type Solution_Gas_Oil_Ratio_Options_Aggregate_Fields = {
  __typename: 'solution_gas_oil_ratio_options_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Solution_Gas_Oil_Ratio_Options_Max_Fields>;
  min?: Maybe<Solution_Gas_Oil_Ratio_Options_Min_Fields>;
};


/** aggregate fields of "solution_gas_oil_ratio_options" */
export type Solution_Gas_Oil_Ratio_Options_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Solution_Gas_Oil_Ratio_Options_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "solution_gas_oil_ratio_options". All fields are combined with a logical 'AND'. */
export type Solution_Gas_Oil_Ratio_Options_Bool_Exp = {
  _and?: InputMaybe<Array<Solution_Gas_Oil_Ratio_Options_Bool_Exp>>;
  _not?: InputMaybe<Solution_Gas_Oil_Ratio_Options_Bool_Exp>;
  _or?: InputMaybe<Array<Solution_Gas_Oil_Ratio_Options_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "solution_gas_oil_ratio_options" */
export enum Solution_Gas_Oil_Ratio_Options_Constraint {
  /** unique or primary key constraint on columns "value" */
  SolutionGasOilRatioOptionsPkey = 'solution_gas_oil_ratio_options_pkey'
}

export enum Solution_Gas_Oil_Ratio_Options_Enum {
  /** De Ghetto Heavy Oil */
  DeGhettoHeavyOil = 'de_ghetto_heavy_oil',
  /** Glaso (North Sea) */
  GlasoNorthSea = 'glaso_north_sea',
  /** Kartoatmodjo & Schmidt */
  KartoatmodjoSchmidt = 'kartoatmodjo_schmidt',
  /** Lasater */
  Lasater = 'lasater',
  /** Petrosky & Farshad (GOM) */
  PetroskyFarshadGom = 'petrosky_farshad_gom',
  /** Standing */
  Standing = 'standing',
  /** Vasquez Beggs */
  VasquezBeggs = 'vasquez_beggs'
}

/** Boolean expression to compare columns of type "solution_gas_oil_ratio_options_enum". All fields are combined with logical 'AND'. */
export type Solution_Gas_Oil_Ratio_Options_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Solution_Gas_Oil_Ratio_Options_Enum>;
  _in?: InputMaybe<Array<Solution_Gas_Oil_Ratio_Options_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Solution_Gas_Oil_Ratio_Options_Enum>;
  _nin?: InputMaybe<Array<Solution_Gas_Oil_Ratio_Options_Enum>>;
};

/** input type for inserting data into table "solution_gas_oil_ratio_options" */
export type Solution_Gas_Oil_Ratio_Options_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Solution_Gas_Oil_Ratio_Options_Max_Fields = {
  __typename: 'solution_gas_oil_ratio_options_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Solution_Gas_Oil_Ratio_Options_Min_Fields = {
  __typename: 'solution_gas_oil_ratio_options_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "solution_gas_oil_ratio_options" */
export type Solution_Gas_Oil_Ratio_Options_Mutation_Response = {
  __typename: 'solution_gas_oil_ratio_options_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Solution_Gas_Oil_Ratio_Options>;
};

/** input type for inserting object relation for remote table "solution_gas_oil_ratio_options" */
export type Solution_Gas_Oil_Ratio_Options_Obj_Rel_Insert_Input = {
  data: Solution_Gas_Oil_Ratio_Options_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Solution_Gas_Oil_Ratio_Options_On_Conflict>;
};

/** on_conflict condition type for table "solution_gas_oil_ratio_options" */
export type Solution_Gas_Oil_Ratio_Options_On_Conflict = {
  constraint: Solution_Gas_Oil_Ratio_Options_Constraint;
  update_columns?: Array<Solution_Gas_Oil_Ratio_Options_Update_Column>;
  where?: InputMaybe<Solution_Gas_Oil_Ratio_Options_Bool_Exp>;
};

/** Ordering options when selecting data from "solution_gas_oil_ratio_options". */
export type Solution_Gas_Oil_Ratio_Options_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: solution_gas_oil_ratio_options */
export type Solution_Gas_Oil_Ratio_Options_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "solution_gas_oil_ratio_options" */
export enum Solution_Gas_Oil_Ratio_Options_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "solution_gas_oil_ratio_options" */
export type Solution_Gas_Oil_Ratio_Options_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "solution_gas_oil_ratio_options" */
export type Solution_Gas_Oil_Ratio_Options_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Solution_Gas_Oil_Ratio_Options_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Solution_Gas_Oil_Ratio_Options_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "solution_gas_oil_ratio_options" */
export enum Solution_Gas_Oil_Ratio_Options_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Solution_Gas_Oil_Ratio_Options_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Solution_Gas_Oil_Ratio_Options_Set_Input>;
  /** filter the rows which have to be updated */
  where: Solution_Gas_Oil_Ratio_Options_Bool_Exp;
};

/** columns and relationships of "status" */
export type Status = {
  __typename: 'status';
  status?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "status" */
export type Status_Aggregate = {
  __typename: 'status_aggregate';
  aggregate?: Maybe<Status_Aggregate_Fields>;
  nodes: Array<Status>;
};

/** aggregate fields of "status" */
export type Status_Aggregate_Fields = {
  __typename: 'status_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Status_Max_Fields>;
  min?: Maybe<Status_Min_Fields>;
};


/** aggregate fields of "status" */
export type Status_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Status_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "status". All fields are combined with a logical 'AND'. */
export type Status_Bool_Exp = {
  _and?: InputMaybe<Array<Status_Bool_Exp>>;
  _not?: InputMaybe<Status_Bool_Exp>;
  _or?: InputMaybe<Array<Status_Bool_Exp>>;
  status?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Status_Max_Fields = {
  __typename: 'status_max_fields';
  status?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Status_Min_Fields = {
  __typename: 'status_min_fields';
  status?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "status". */
export type Status_Order_By = {
  status?: InputMaybe<Order_By>;
};

/** select columns of table "status" */
export enum Status_Select_Column {
  /** column name */
  Status = 'status'
}

/** Streaming cursor of the table "status" */
export type Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Status_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Status_Stream_Cursor_Value_Input = {
  status?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "step_down_transformers" */
export type Step_Down_Transformers = {
  __typename: 'step_down_transformers';
  author_id: Scalars['String']['output'];
  created_at: Scalars['timestamptz']['output'];
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  enclosure?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  imported_sizing_id?: Maybe<Scalars['Int']['output']>;
  include_ecopetrol_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  include_koc_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  kva?: Maybe<Scalars['Int']['output']>;
  manufacturer?: Maybe<Scalars['String']['output']>;
  max_secondary_voltage?: Maybe<Scalars['Int']['output']>;
  min_secondary_voltage?: Maybe<Scalars['Int']['output']>;
  only_ecopetrol_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  only_koc_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  part_number?: Maybe<Scalars['String']['output']>;
  primary_voltage_delta?: Maybe<Scalars['Int']['output']>;
  primary_voltage_wye?: Maybe<Scalars['Int']['output']>;
  /** A computed field, executes function "prioritizestepdnmanufacturer" */
  prioritized_manufacturer?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  sizing_import?: Maybe<Sizing_Imports>;
  transformer_type?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Users;
  weight_pounds?: Maybe<Scalars['Int']['output']>;
};

/** aggregated selection of "step_down_transformers" */
export type Step_Down_Transformers_Aggregate = {
  __typename: 'step_down_transformers_aggregate';
  aggregate?: Maybe<Step_Down_Transformers_Aggregate_Fields>;
  nodes: Array<Step_Down_Transformers>;
};

export type Step_Down_Transformers_Aggregate_Bool_Exp = {
  count?: InputMaybe<Step_Down_Transformers_Aggregate_Bool_Exp_Count>;
};

export type Step_Down_Transformers_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Step_Down_Transformers_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Step_Down_Transformers_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "step_down_transformers" */
export type Step_Down_Transformers_Aggregate_Fields = {
  __typename: 'step_down_transformers_aggregate_fields';
  avg?: Maybe<Step_Down_Transformers_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Step_Down_Transformers_Max_Fields>;
  min?: Maybe<Step_Down_Transformers_Min_Fields>;
  stddev?: Maybe<Step_Down_Transformers_Stddev_Fields>;
  stddev_pop?: Maybe<Step_Down_Transformers_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Step_Down_Transformers_Stddev_Samp_Fields>;
  sum?: Maybe<Step_Down_Transformers_Sum_Fields>;
  var_pop?: Maybe<Step_Down_Transformers_Var_Pop_Fields>;
  var_samp?: Maybe<Step_Down_Transformers_Var_Samp_Fields>;
  variance?: Maybe<Step_Down_Transformers_Variance_Fields>;
};


/** aggregate fields of "step_down_transformers" */
export type Step_Down_Transformers_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Step_Down_Transformers_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "step_down_transformers" */
export type Step_Down_Transformers_Aggregate_Order_By = {
  avg?: InputMaybe<Step_Down_Transformers_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Step_Down_Transformers_Max_Order_By>;
  min?: InputMaybe<Step_Down_Transformers_Min_Order_By>;
  stddev?: InputMaybe<Step_Down_Transformers_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Step_Down_Transformers_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Step_Down_Transformers_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Step_Down_Transformers_Sum_Order_By>;
  var_pop?: InputMaybe<Step_Down_Transformers_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Step_Down_Transformers_Var_Samp_Order_By>;
  variance?: InputMaybe<Step_Down_Transformers_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "step_down_transformers" */
export type Step_Down_Transformers_Arr_Rel_Insert_Input = {
  data: Array<Step_Down_Transformers_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Step_Down_Transformers_On_Conflict>;
};

/** aggregate avg on columns */
export type Step_Down_Transformers_Avg_Fields = {
  __typename: 'step_down_transformers_avg_fields';
  imported_sizing_id?: Maybe<Scalars['Float']['output']>;
  kva?: Maybe<Scalars['Float']['output']>;
  max_secondary_voltage?: Maybe<Scalars['Float']['output']>;
  min_secondary_voltage?: Maybe<Scalars['Float']['output']>;
  primary_voltage_delta?: Maybe<Scalars['Float']['output']>;
  primary_voltage_wye?: Maybe<Scalars['Float']['output']>;
  weight_pounds?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "step_down_transformers" */
export type Step_Down_Transformers_Avg_Order_By = {
  imported_sizing_id?: InputMaybe<Order_By>;
  kva?: InputMaybe<Order_By>;
  max_secondary_voltage?: InputMaybe<Order_By>;
  min_secondary_voltage?: InputMaybe<Order_By>;
  primary_voltage_delta?: InputMaybe<Order_By>;
  primary_voltage_wye?: InputMaybe<Order_By>;
  weight_pounds?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "step_down_transformers". All fields are combined with a logical 'AND'. */
export type Step_Down_Transformers_Bool_Exp = {
  _and?: InputMaybe<Array<Step_Down_Transformers_Bool_Exp>>;
  _not?: InputMaybe<Step_Down_Transformers_Bool_Exp>;
  _or?: InputMaybe<Array<Step_Down_Transformers_Bool_Exp>>;
  author_id?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  enclosure?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  imported_sizing_id?: InputMaybe<Int_Comparison_Exp>;
  include_ecopetrol_timestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  include_koc_timestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  kva?: InputMaybe<Int_Comparison_Exp>;
  manufacturer?: InputMaybe<String_Comparison_Exp>;
  max_secondary_voltage?: InputMaybe<Int_Comparison_Exp>;
  min_secondary_voltage?: InputMaybe<Int_Comparison_Exp>;
  only_ecopetrol_timestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  only_koc_timestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  part_number?: InputMaybe<String_Comparison_Exp>;
  primary_voltage_delta?: InputMaybe<Int_Comparison_Exp>;
  primary_voltage_wye?: InputMaybe<Int_Comparison_Exp>;
  prioritized_manufacturer?: InputMaybe<String_Comparison_Exp>;
  sizing_import?: InputMaybe<Sizing_Imports_Bool_Exp>;
  transformer_type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  weight_pounds?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "step_down_transformers" */
export enum Step_Down_Transformers_Constraint {
  /** unique or primary key constraint on columns "id" */
  StepDownTransformersPkey = 'step_down_transformers_pkey'
}

/** input type for incrementing numeric columns in table "step_down_transformers" */
export type Step_Down_Transformers_Inc_Input = {
  imported_sizing_id?: InputMaybe<Scalars['Int']['input']>;
  kva?: InputMaybe<Scalars['Int']['input']>;
  max_secondary_voltage?: InputMaybe<Scalars['Int']['input']>;
  min_secondary_voltage?: InputMaybe<Scalars['Int']['input']>;
  primary_voltage_delta?: InputMaybe<Scalars['Int']['input']>;
  primary_voltage_wye?: InputMaybe<Scalars['Int']['input']>;
  weight_pounds?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "step_down_transformers" */
export type Step_Down_Transformers_Insert_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  enclosure?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  imported_sizing_id?: InputMaybe<Scalars['Int']['input']>;
  include_ecopetrol_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  include_koc_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  kva?: InputMaybe<Scalars['Int']['input']>;
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  max_secondary_voltage?: InputMaybe<Scalars['Int']['input']>;
  min_secondary_voltage?: InputMaybe<Scalars['Int']['input']>;
  only_ecopetrol_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  only_koc_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  part_number?: InputMaybe<Scalars['String']['input']>;
  primary_voltage_delta?: InputMaybe<Scalars['Int']['input']>;
  primary_voltage_wye?: InputMaybe<Scalars['Int']['input']>;
  sizing_import?: InputMaybe<Sizing_Imports_Obj_Rel_Insert_Input>;
  transformer_type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  weight_pounds?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type Step_Down_Transformers_Max_Fields = {
  __typename: 'step_down_transformers_max_fields';
  author_id?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  enclosure?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  imported_sizing_id?: Maybe<Scalars['Int']['output']>;
  include_ecopetrol_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  include_koc_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  kva?: Maybe<Scalars['Int']['output']>;
  manufacturer?: Maybe<Scalars['String']['output']>;
  max_secondary_voltage?: Maybe<Scalars['Int']['output']>;
  min_secondary_voltage?: Maybe<Scalars['Int']['output']>;
  only_ecopetrol_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  only_koc_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  part_number?: Maybe<Scalars['String']['output']>;
  primary_voltage_delta?: Maybe<Scalars['Int']['output']>;
  primary_voltage_wye?: Maybe<Scalars['Int']['output']>;
  /** A computed field, executes function "prioritizestepdnmanufacturer" */
  prioritized_manufacturer?: Maybe<Scalars['String']['output']>;
  transformer_type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  weight_pounds?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "step_down_transformers" */
export type Step_Down_Transformers_Max_Order_By = {
  author_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  enclosure?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  include_ecopetrol_timestamp?: InputMaybe<Order_By>;
  include_koc_timestamp?: InputMaybe<Order_By>;
  kva?: InputMaybe<Order_By>;
  manufacturer?: InputMaybe<Order_By>;
  max_secondary_voltage?: InputMaybe<Order_By>;
  min_secondary_voltage?: InputMaybe<Order_By>;
  only_ecopetrol_timestamp?: InputMaybe<Order_By>;
  only_koc_timestamp?: InputMaybe<Order_By>;
  part_number?: InputMaybe<Order_By>;
  primary_voltage_delta?: InputMaybe<Order_By>;
  primary_voltage_wye?: InputMaybe<Order_By>;
  transformer_type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  weight_pounds?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Step_Down_Transformers_Min_Fields = {
  __typename: 'step_down_transformers_min_fields';
  author_id?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  enclosure?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  imported_sizing_id?: Maybe<Scalars['Int']['output']>;
  include_ecopetrol_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  include_koc_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  kva?: Maybe<Scalars['Int']['output']>;
  manufacturer?: Maybe<Scalars['String']['output']>;
  max_secondary_voltage?: Maybe<Scalars['Int']['output']>;
  min_secondary_voltage?: Maybe<Scalars['Int']['output']>;
  only_ecopetrol_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  only_koc_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  part_number?: Maybe<Scalars['String']['output']>;
  primary_voltage_delta?: Maybe<Scalars['Int']['output']>;
  primary_voltage_wye?: Maybe<Scalars['Int']['output']>;
  /** A computed field, executes function "prioritizestepdnmanufacturer" */
  prioritized_manufacturer?: Maybe<Scalars['String']['output']>;
  transformer_type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  weight_pounds?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "step_down_transformers" */
export type Step_Down_Transformers_Min_Order_By = {
  author_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  enclosure?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  include_ecopetrol_timestamp?: InputMaybe<Order_By>;
  include_koc_timestamp?: InputMaybe<Order_By>;
  kva?: InputMaybe<Order_By>;
  manufacturer?: InputMaybe<Order_By>;
  max_secondary_voltage?: InputMaybe<Order_By>;
  min_secondary_voltage?: InputMaybe<Order_By>;
  only_ecopetrol_timestamp?: InputMaybe<Order_By>;
  only_koc_timestamp?: InputMaybe<Order_By>;
  part_number?: InputMaybe<Order_By>;
  primary_voltage_delta?: InputMaybe<Order_By>;
  primary_voltage_wye?: InputMaybe<Order_By>;
  transformer_type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  weight_pounds?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "step_down_transformers" */
export type Step_Down_Transformers_Mutation_Response = {
  __typename: 'step_down_transformers_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Step_Down_Transformers>;
};

/** input type for inserting object relation for remote table "step_down_transformers" */
export type Step_Down_Transformers_Obj_Rel_Insert_Input = {
  data: Step_Down_Transformers_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Step_Down_Transformers_On_Conflict>;
};

/** on_conflict condition type for table "step_down_transformers" */
export type Step_Down_Transformers_On_Conflict = {
  constraint: Step_Down_Transformers_Constraint;
  update_columns?: Array<Step_Down_Transformers_Update_Column>;
  where?: InputMaybe<Step_Down_Transformers_Bool_Exp>;
};

/** Ordering options when selecting data from "step_down_transformers". */
export type Step_Down_Transformers_Order_By = {
  author_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  enclosure?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  include_ecopetrol_timestamp?: InputMaybe<Order_By>;
  include_koc_timestamp?: InputMaybe<Order_By>;
  kva?: InputMaybe<Order_By>;
  manufacturer?: InputMaybe<Order_By>;
  max_secondary_voltage?: InputMaybe<Order_By>;
  min_secondary_voltage?: InputMaybe<Order_By>;
  only_ecopetrol_timestamp?: InputMaybe<Order_By>;
  only_koc_timestamp?: InputMaybe<Order_By>;
  part_number?: InputMaybe<Order_By>;
  primary_voltage_delta?: InputMaybe<Order_By>;
  primary_voltage_wye?: InputMaybe<Order_By>;
  prioritized_manufacturer?: InputMaybe<Order_By>;
  sizing_import?: InputMaybe<Sizing_Imports_Order_By>;
  transformer_type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  weight_pounds?: InputMaybe<Order_By>;
};

/** primary key columns input for table: step_down_transformers */
export type Step_Down_Transformers_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "step_down_transformers" */
export enum Step_Down_Transformers_Select_Column {
  /** column name */
  AuthorId = 'author_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Enclosure = 'enclosure',
  /** column name */
  Id = 'id',
  /** column name */
  ImportedSizingId = 'imported_sizing_id',
  /** column name */
  IncludeEcopetrolTimestamp = 'include_ecopetrol_timestamp',
  /** column name */
  IncludeKocTimestamp = 'include_koc_timestamp',
  /** column name */
  Kva = 'kva',
  /** column name */
  Manufacturer = 'manufacturer',
  /** column name */
  MaxSecondaryVoltage = 'max_secondary_voltage',
  /** column name */
  MinSecondaryVoltage = 'min_secondary_voltage',
  /** column name */
  OnlyEcopetrolTimestamp = 'only_ecopetrol_timestamp',
  /** column name */
  OnlyKocTimestamp = 'only_koc_timestamp',
  /** column name */
  PartNumber = 'part_number',
  /** column name */
  PrimaryVoltageDelta = 'primary_voltage_delta',
  /** column name */
  PrimaryVoltageWye = 'primary_voltage_wye',
  /** column name */
  TransformerType = 'transformer_type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WeightPounds = 'weight_pounds'
}

/** input type for updating data in table "step_down_transformers" */
export type Step_Down_Transformers_Set_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  enclosure?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  imported_sizing_id?: InputMaybe<Scalars['Int']['input']>;
  include_ecopetrol_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  include_koc_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  kva?: InputMaybe<Scalars['Int']['input']>;
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  max_secondary_voltage?: InputMaybe<Scalars['Int']['input']>;
  min_secondary_voltage?: InputMaybe<Scalars['Int']['input']>;
  only_ecopetrol_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  only_koc_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  part_number?: InputMaybe<Scalars['String']['input']>;
  primary_voltage_delta?: InputMaybe<Scalars['Int']['input']>;
  primary_voltage_wye?: InputMaybe<Scalars['Int']['input']>;
  transformer_type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  weight_pounds?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Step_Down_Transformers_Stddev_Fields = {
  __typename: 'step_down_transformers_stddev_fields';
  imported_sizing_id?: Maybe<Scalars['Float']['output']>;
  kva?: Maybe<Scalars['Float']['output']>;
  max_secondary_voltage?: Maybe<Scalars['Float']['output']>;
  min_secondary_voltage?: Maybe<Scalars['Float']['output']>;
  primary_voltage_delta?: Maybe<Scalars['Float']['output']>;
  primary_voltage_wye?: Maybe<Scalars['Float']['output']>;
  weight_pounds?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "step_down_transformers" */
export type Step_Down_Transformers_Stddev_Order_By = {
  imported_sizing_id?: InputMaybe<Order_By>;
  kva?: InputMaybe<Order_By>;
  max_secondary_voltage?: InputMaybe<Order_By>;
  min_secondary_voltage?: InputMaybe<Order_By>;
  primary_voltage_delta?: InputMaybe<Order_By>;
  primary_voltage_wye?: InputMaybe<Order_By>;
  weight_pounds?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Step_Down_Transformers_Stddev_Pop_Fields = {
  __typename: 'step_down_transformers_stddev_pop_fields';
  imported_sizing_id?: Maybe<Scalars['Float']['output']>;
  kva?: Maybe<Scalars['Float']['output']>;
  max_secondary_voltage?: Maybe<Scalars['Float']['output']>;
  min_secondary_voltage?: Maybe<Scalars['Float']['output']>;
  primary_voltage_delta?: Maybe<Scalars['Float']['output']>;
  primary_voltage_wye?: Maybe<Scalars['Float']['output']>;
  weight_pounds?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "step_down_transformers" */
export type Step_Down_Transformers_Stddev_Pop_Order_By = {
  imported_sizing_id?: InputMaybe<Order_By>;
  kva?: InputMaybe<Order_By>;
  max_secondary_voltage?: InputMaybe<Order_By>;
  min_secondary_voltage?: InputMaybe<Order_By>;
  primary_voltage_delta?: InputMaybe<Order_By>;
  primary_voltage_wye?: InputMaybe<Order_By>;
  weight_pounds?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Step_Down_Transformers_Stddev_Samp_Fields = {
  __typename: 'step_down_transformers_stddev_samp_fields';
  imported_sizing_id?: Maybe<Scalars['Float']['output']>;
  kva?: Maybe<Scalars['Float']['output']>;
  max_secondary_voltage?: Maybe<Scalars['Float']['output']>;
  min_secondary_voltage?: Maybe<Scalars['Float']['output']>;
  primary_voltage_delta?: Maybe<Scalars['Float']['output']>;
  primary_voltage_wye?: Maybe<Scalars['Float']['output']>;
  weight_pounds?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "step_down_transformers" */
export type Step_Down_Transformers_Stddev_Samp_Order_By = {
  imported_sizing_id?: InputMaybe<Order_By>;
  kva?: InputMaybe<Order_By>;
  max_secondary_voltage?: InputMaybe<Order_By>;
  min_secondary_voltage?: InputMaybe<Order_By>;
  primary_voltage_delta?: InputMaybe<Order_By>;
  primary_voltage_wye?: InputMaybe<Order_By>;
  weight_pounds?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "step_down_transformers" */
export type Step_Down_Transformers_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Step_Down_Transformers_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Step_Down_Transformers_Stream_Cursor_Value_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  enclosure?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  imported_sizing_id?: InputMaybe<Scalars['Int']['input']>;
  include_ecopetrol_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  include_koc_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  kva?: InputMaybe<Scalars['Int']['input']>;
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  max_secondary_voltage?: InputMaybe<Scalars['Int']['input']>;
  min_secondary_voltage?: InputMaybe<Scalars['Int']['input']>;
  only_ecopetrol_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  only_koc_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  part_number?: InputMaybe<Scalars['String']['input']>;
  primary_voltage_delta?: InputMaybe<Scalars['Int']['input']>;
  primary_voltage_wye?: InputMaybe<Scalars['Int']['input']>;
  transformer_type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  weight_pounds?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Step_Down_Transformers_Sum_Fields = {
  __typename: 'step_down_transformers_sum_fields';
  imported_sizing_id?: Maybe<Scalars['Int']['output']>;
  kva?: Maybe<Scalars['Int']['output']>;
  max_secondary_voltage?: Maybe<Scalars['Int']['output']>;
  min_secondary_voltage?: Maybe<Scalars['Int']['output']>;
  primary_voltage_delta?: Maybe<Scalars['Int']['output']>;
  primary_voltage_wye?: Maybe<Scalars['Int']['output']>;
  weight_pounds?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "step_down_transformers" */
export type Step_Down_Transformers_Sum_Order_By = {
  imported_sizing_id?: InputMaybe<Order_By>;
  kva?: InputMaybe<Order_By>;
  max_secondary_voltage?: InputMaybe<Order_By>;
  min_secondary_voltage?: InputMaybe<Order_By>;
  primary_voltage_delta?: InputMaybe<Order_By>;
  primary_voltage_wye?: InputMaybe<Order_By>;
  weight_pounds?: InputMaybe<Order_By>;
};

/** update columns of table "step_down_transformers" */
export enum Step_Down_Transformers_Update_Column {
  /** column name */
  AuthorId = 'author_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Enclosure = 'enclosure',
  /** column name */
  Id = 'id',
  /** column name */
  ImportedSizingId = 'imported_sizing_id',
  /** column name */
  IncludeEcopetrolTimestamp = 'include_ecopetrol_timestamp',
  /** column name */
  IncludeKocTimestamp = 'include_koc_timestamp',
  /** column name */
  Kva = 'kva',
  /** column name */
  Manufacturer = 'manufacturer',
  /** column name */
  MaxSecondaryVoltage = 'max_secondary_voltage',
  /** column name */
  MinSecondaryVoltage = 'min_secondary_voltage',
  /** column name */
  OnlyEcopetrolTimestamp = 'only_ecopetrol_timestamp',
  /** column name */
  OnlyKocTimestamp = 'only_koc_timestamp',
  /** column name */
  PartNumber = 'part_number',
  /** column name */
  PrimaryVoltageDelta = 'primary_voltage_delta',
  /** column name */
  PrimaryVoltageWye = 'primary_voltage_wye',
  /** column name */
  TransformerType = 'transformer_type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WeightPounds = 'weight_pounds'
}

export type Step_Down_Transformers_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Step_Down_Transformers_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Step_Down_Transformers_Set_Input>;
  /** filter the rows which have to be updated */
  where: Step_Down_Transformers_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Step_Down_Transformers_Var_Pop_Fields = {
  __typename: 'step_down_transformers_var_pop_fields';
  imported_sizing_id?: Maybe<Scalars['Float']['output']>;
  kva?: Maybe<Scalars['Float']['output']>;
  max_secondary_voltage?: Maybe<Scalars['Float']['output']>;
  min_secondary_voltage?: Maybe<Scalars['Float']['output']>;
  primary_voltage_delta?: Maybe<Scalars['Float']['output']>;
  primary_voltage_wye?: Maybe<Scalars['Float']['output']>;
  weight_pounds?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "step_down_transformers" */
export type Step_Down_Transformers_Var_Pop_Order_By = {
  imported_sizing_id?: InputMaybe<Order_By>;
  kva?: InputMaybe<Order_By>;
  max_secondary_voltage?: InputMaybe<Order_By>;
  min_secondary_voltage?: InputMaybe<Order_By>;
  primary_voltage_delta?: InputMaybe<Order_By>;
  primary_voltage_wye?: InputMaybe<Order_By>;
  weight_pounds?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Step_Down_Transformers_Var_Samp_Fields = {
  __typename: 'step_down_transformers_var_samp_fields';
  imported_sizing_id?: Maybe<Scalars['Float']['output']>;
  kva?: Maybe<Scalars['Float']['output']>;
  max_secondary_voltage?: Maybe<Scalars['Float']['output']>;
  min_secondary_voltage?: Maybe<Scalars['Float']['output']>;
  primary_voltage_delta?: Maybe<Scalars['Float']['output']>;
  primary_voltage_wye?: Maybe<Scalars['Float']['output']>;
  weight_pounds?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "step_down_transformers" */
export type Step_Down_Transformers_Var_Samp_Order_By = {
  imported_sizing_id?: InputMaybe<Order_By>;
  kva?: InputMaybe<Order_By>;
  max_secondary_voltage?: InputMaybe<Order_By>;
  min_secondary_voltage?: InputMaybe<Order_By>;
  primary_voltage_delta?: InputMaybe<Order_By>;
  primary_voltage_wye?: InputMaybe<Order_By>;
  weight_pounds?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Step_Down_Transformers_Variance_Fields = {
  __typename: 'step_down_transformers_variance_fields';
  imported_sizing_id?: Maybe<Scalars['Float']['output']>;
  kva?: Maybe<Scalars['Float']['output']>;
  max_secondary_voltage?: Maybe<Scalars['Float']['output']>;
  min_secondary_voltage?: Maybe<Scalars['Float']['output']>;
  primary_voltage_delta?: Maybe<Scalars['Float']['output']>;
  primary_voltage_wye?: Maybe<Scalars['Float']['output']>;
  weight_pounds?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "step_down_transformers" */
export type Step_Down_Transformers_Variance_Order_By = {
  imported_sizing_id?: InputMaybe<Order_By>;
  kva?: InputMaybe<Order_By>;
  max_secondary_voltage?: InputMaybe<Order_By>;
  min_secondary_voltage?: InputMaybe<Order_By>;
  primary_voltage_delta?: InputMaybe<Order_By>;
  primary_voltage_wye?: InputMaybe<Order_By>;
  weight_pounds?: InputMaybe<Order_By>;
};

/** columns and relationships of "step_up_transformers" */
export type Step_Up_Transformers = {
  __typename: 'step_up_transformers';
  author_id: Scalars['String']['output'];
  created_at: Scalars['timestamptz']['output'];
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  enclosure?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  imported_sizing_id?: Maybe<Scalars['Int']['output']>;
  include_ecopetrol_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  include_koc_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  kva?: Maybe<Scalars['Int']['output']>;
  manufacturer?: Maybe<Scalars['String']['output']>;
  max_secondary_voltage?: Maybe<Scalars['Int']['output']>;
  min_secondary_voltage?: Maybe<Scalars['Int']['output']>;
  only_ecopetrol_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  only_koc_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  part_number?: Maybe<Scalars['String']['output']>;
  primary_voltage?: Maybe<Scalars['Int']['output']>;
  /** A computed field, executes function "prioritizestepupmanufacturer" */
  prioritized_manufacturer?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  sizing_import?: Maybe<Sizing_Imports>;
  transformer_type?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Users;
  weight_pounds?: Maybe<Scalars['Int']['output']>;
};

/** aggregated selection of "step_up_transformers" */
export type Step_Up_Transformers_Aggregate = {
  __typename: 'step_up_transformers_aggregate';
  aggregate?: Maybe<Step_Up_Transformers_Aggregate_Fields>;
  nodes: Array<Step_Up_Transformers>;
};

export type Step_Up_Transformers_Aggregate_Bool_Exp = {
  count?: InputMaybe<Step_Up_Transformers_Aggregate_Bool_Exp_Count>;
};

export type Step_Up_Transformers_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Step_Up_Transformers_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Step_Up_Transformers_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "step_up_transformers" */
export type Step_Up_Transformers_Aggregate_Fields = {
  __typename: 'step_up_transformers_aggregate_fields';
  avg?: Maybe<Step_Up_Transformers_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Step_Up_Transformers_Max_Fields>;
  min?: Maybe<Step_Up_Transformers_Min_Fields>;
  stddev?: Maybe<Step_Up_Transformers_Stddev_Fields>;
  stddev_pop?: Maybe<Step_Up_Transformers_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Step_Up_Transformers_Stddev_Samp_Fields>;
  sum?: Maybe<Step_Up_Transformers_Sum_Fields>;
  var_pop?: Maybe<Step_Up_Transformers_Var_Pop_Fields>;
  var_samp?: Maybe<Step_Up_Transformers_Var_Samp_Fields>;
  variance?: Maybe<Step_Up_Transformers_Variance_Fields>;
};


/** aggregate fields of "step_up_transformers" */
export type Step_Up_Transformers_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Step_Up_Transformers_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "step_up_transformers" */
export type Step_Up_Transformers_Aggregate_Order_By = {
  avg?: InputMaybe<Step_Up_Transformers_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Step_Up_Transformers_Max_Order_By>;
  min?: InputMaybe<Step_Up_Transformers_Min_Order_By>;
  stddev?: InputMaybe<Step_Up_Transformers_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Step_Up_Transformers_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Step_Up_Transformers_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Step_Up_Transformers_Sum_Order_By>;
  var_pop?: InputMaybe<Step_Up_Transformers_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Step_Up_Transformers_Var_Samp_Order_By>;
  variance?: InputMaybe<Step_Up_Transformers_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "step_up_transformers" */
export type Step_Up_Transformers_Arr_Rel_Insert_Input = {
  data: Array<Step_Up_Transformers_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Step_Up_Transformers_On_Conflict>;
};

/** aggregate avg on columns */
export type Step_Up_Transformers_Avg_Fields = {
  __typename: 'step_up_transformers_avg_fields';
  imported_sizing_id?: Maybe<Scalars['Float']['output']>;
  kva?: Maybe<Scalars['Float']['output']>;
  max_secondary_voltage?: Maybe<Scalars['Float']['output']>;
  min_secondary_voltage?: Maybe<Scalars['Float']['output']>;
  primary_voltage?: Maybe<Scalars['Float']['output']>;
  weight_pounds?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "step_up_transformers" */
export type Step_Up_Transformers_Avg_Order_By = {
  imported_sizing_id?: InputMaybe<Order_By>;
  kva?: InputMaybe<Order_By>;
  max_secondary_voltage?: InputMaybe<Order_By>;
  min_secondary_voltage?: InputMaybe<Order_By>;
  primary_voltage?: InputMaybe<Order_By>;
  weight_pounds?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "step_up_transformers". All fields are combined with a logical 'AND'. */
export type Step_Up_Transformers_Bool_Exp = {
  _and?: InputMaybe<Array<Step_Up_Transformers_Bool_Exp>>;
  _not?: InputMaybe<Step_Up_Transformers_Bool_Exp>;
  _or?: InputMaybe<Array<Step_Up_Transformers_Bool_Exp>>;
  author_id?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  enclosure?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  imported_sizing_id?: InputMaybe<Int_Comparison_Exp>;
  include_ecopetrol_timestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  include_koc_timestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  kva?: InputMaybe<Int_Comparison_Exp>;
  manufacturer?: InputMaybe<String_Comparison_Exp>;
  max_secondary_voltage?: InputMaybe<Int_Comparison_Exp>;
  min_secondary_voltage?: InputMaybe<Int_Comparison_Exp>;
  only_ecopetrol_timestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  only_koc_timestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  part_number?: InputMaybe<String_Comparison_Exp>;
  primary_voltage?: InputMaybe<Int_Comparison_Exp>;
  prioritized_manufacturer?: InputMaybe<String_Comparison_Exp>;
  sizing_import?: InputMaybe<Sizing_Imports_Bool_Exp>;
  transformer_type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  weight_pounds?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "step_up_transformers" */
export enum Step_Up_Transformers_Constraint {
  /** unique or primary key constraint on columns "id" */
  StepUpTransformersPkey = 'step_up_transformers_pkey'
}

/** input type for incrementing numeric columns in table "step_up_transformers" */
export type Step_Up_Transformers_Inc_Input = {
  imported_sizing_id?: InputMaybe<Scalars['Int']['input']>;
  kva?: InputMaybe<Scalars['Int']['input']>;
  max_secondary_voltage?: InputMaybe<Scalars['Int']['input']>;
  min_secondary_voltage?: InputMaybe<Scalars['Int']['input']>;
  primary_voltage?: InputMaybe<Scalars['Int']['input']>;
  weight_pounds?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "step_up_transformers" */
export type Step_Up_Transformers_Insert_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  enclosure?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  imported_sizing_id?: InputMaybe<Scalars['Int']['input']>;
  include_ecopetrol_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  include_koc_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  kva?: InputMaybe<Scalars['Int']['input']>;
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  max_secondary_voltage?: InputMaybe<Scalars['Int']['input']>;
  min_secondary_voltage?: InputMaybe<Scalars['Int']['input']>;
  only_ecopetrol_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  only_koc_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  part_number?: InputMaybe<Scalars['String']['input']>;
  primary_voltage?: InputMaybe<Scalars['Int']['input']>;
  sizing_import?: InputMaybe<Sizing_Imports_Obj_Rel_Insert_Input>;
  transformer_type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  weight_pounds?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type Step_Up_Transformers_Max_Fields = {
  __typename: 'step_up_transformers_max_fields';
  author_id?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  enclosure?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  imported_sizing_id?: Maybe<Scalars['Int']['output']>;
  include_ecopetrol_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  include_koc_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  kva?: Maybe<Scalars['Int']['output']>;
  manufacturer?: Maybe<Scalars['String']['output']>;
  max_secondary_voltage?: Maybe<Scalars['Int']['output']>;
  min_secondary_voltage?: Maybe<Scalars['Int']['output']>;
  only_ecopetrol_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  only_koc_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  part_number?: Maybe<Scalars['String']['output']>;
  primary_voltage?: Maybe<Scalars['Int']['output']>;
  /** A computed field, executes function "prioritizestepupmanufacturer" */
  prioritized_manufacturer?: Maybe<Scalars['String']['output']>;
  transformer_type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  weight_pounds?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "step_up_transformers" */
export type Step_Up_Transformers_Max_Order_By = {
  author_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  enclosure?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  include_ecopetrol_timestamp?: InputMaybe<Order_By>;
  include_koc_timestamp?: InputMaybe<Order_By>;
  kva?: InputMaybe<Order_By>;
  manufacturer?: InputMaybe<Order_By>;
  max_secondary_voltage?: InputMaybe<Order_By>;
  min_secondary_voltage?: InputMaybe<Order_By>;
  only_ecopetrol_timestamp?: InputMaybe<Order_By>;
  only_koc_timestamp?: InputMaybe<Order_By>;
  part_number?: InputMaybe<Order_By>;
  primary_voltage?: InputMaybe<Order_By>;
  transformer_type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  weight_pounds?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Step_Up_Transformers_Min_Fields = {
  __typename: 'step_up_transformers_min_fields';
  author_id?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  enclosure?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  imported_sizing_id?: Maybe<Scalars['Int']['output']>;
  include_ecopetrol_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  include_koc_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  kva?: Maybe<Scalars['Int']['output']>;
  manufacturer?: Maybe<Scalars['String']['output']>;
  max_secondary_voltage?: Maybe<Scalars['Int']['output']>;
  min_secondary_voltage?: Maybe<Scalars['Int']['output']>;
  only_ecopetrol_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  only_koc_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  part_number?: Maybe<Scalars['String']['output']>;
  primary_voltage?: Maybe<Scalars['Int']['output']>;
  /** A computed field, executes function "prioritizestepupmanufacturer" */
  prioritized_manufacturer?: Maybe<Scalars['String']['output']>;
  transformer_type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  weight_pounds?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "step_up_transformers" */
export type Step_Up_Transformers_Min_Order_By = {
  author_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  enclosure?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  include_ecopetrol_timestamp?: InputMaybe<Order_By>;
  include_koc_timestamp?: InputMaybe<Order_By>;
  kva?: InputMaybe<Order_By>;
  manufacturer?: InputMaybe<Order_By>;
  max_secondary_voltage?: InputMaybe<Order_By>;
  min_secondary_voltage?: InputMaybe<Order_By>;
  only_ecopetrol_timestamp?: InputMaybe<Order_By>;
  only_koc_timestamp?: InputMaybe<Order_By>;
  part_number?: InputMaybe<Order_By>;
  primary_voltage?: InputMaybe<Order_By>;
  transformer_type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  weight_pounds?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "step_up_transformers" */
export type Step_Up_Transformers_Mutation_Response = {
  __typename: 'step_up_transformers_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Step_Up_Transformers>;
};

/** input type for inserting object relation for remote table "step_up_transformers" */
export type Step_Up_Transformers_Obj_Rel_Insert_Input = {
  data: Step_Up_Transformers_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Step_Up_Transformers_On_Conflict>;
};

/** on_conflict condition type for table "step_up_transformers" */
export type Step_Up_Transformers_On_Conflict = {
  constraint: Step_Up_Transformers_Constraint;
  update_columns?: Array<Step_Up_Transformers_Update_Column>;
  where?: InputMaybe<Step_Up_Transformers_Bool_Exp>;
};

/** Ordering options when selecting data from "step_up_transformers". */
export type Step_Up_Transformers_Order_By = {
  author_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  enclosure?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  include_ecopetrol_timestamp?: InputMaybe<Order_By>;
  include_koc_timestamp?: InputMaybe<Order_By>;
  kva?: InputMaybe<Order_By>;
  manufacturer?: InputMaybe<Order_By>;
  max_secondary_voltage?: InputMaybe<Order_By>;
  min_secondary_voltage?: InputMaybe<Order_By>;
  only_ecopetrol_timestamp?: InputMaybe<Order_By>;
  only_koc_timestamp?: InputMaybe<Order_By>;
  part_number?: InputMaybe<Order_By>;
  primary_voltage?: InputMaybe<Order_By>;
  prioritized_manufacturer?: InputMaybe<Order_By>;
  sizing_import?: InputMaybe<Sizing_Imports_Order_By>;
  transformer_type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  weight_pounds?: InputMaybe<Order_By>;
};

/** primary key columns input for table: step_up_transformers */
export type Step_Up_Transformers_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "step_up_transformers" */
export enum Step_Up_Transformers_Select_Column {
  /** column name */
  AuthorId = 'author_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Enclosure = 'enclosure',
  /** column name */
  Id = 'id',
  /** column name */
  ImportedSizingId = 'imported_sizing_id',
  /** column name */
  IncludeEcopetrolTimestamp = 'include_ecopetrol_timestamp',
  /** column name */
  IncludeKocTimestamp = 'include_koc_timestamp',
  /** column name */
  Kva = 'kva',
  /** column name */
  Manufacturer = 'manufacturer',
  /** column name */
  MaxSecondaryVoltage = 'max_secondary_voltage',
  /** column name */
  MinSecondaryVoltage = 'min_secondary_voltage',
  /** column name */
  OnlyEcopetrolTimestamp = 'only_ecopetrol_timestamp',
  /** column name */
  OnlyKocTimestamp = 'only_koc_timestamp',
  /** column name */
  PartNumber = 'part_number',
  /** column name */
  PrimaryVoltage = 'primary_voltage',
  /** column name */
  TransformerType = 'transformer_type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WeightPounds = 'weight_pounds'
}

/** input type for updating data in table "step_up_transformers" */
export type Step_Up_Transformers_Set_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  enclosure?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  imported_sizing_id?: InputMaybe<Scalars['Int']['input']>;
  include_ecopetrol_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  include_koc_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  kva?: InputMaybe<Scalars['Int']['input']>;
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  max_secondary_voltage?: InputMaybe<Scalars['Int']['input']>;
  min_secondary_voltage?: InputMaybe<Scalars['Int']['input']>;
  only_ecopetrol_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  only_koc_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  part_number?: InputMaybe<Scalars['String']['input']>;
  primary_voltage?: InputMaybe<Scalars['Int']['input']>;
  transformer_type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  weight_pounds?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Step_Up_Transformers_Stddev_Fields = {
  __typename: 'step_up_transformers_stddev_fields';
  imported_sizing_id?: Maybe<Scalars['Float']['output']>;
  kva?: Maybe<Scalars['Float']['output']>;
  max_secondary_voltage?: Maybe<Scalars['Float']['output']>;
  min_secondary_voltage?: Maybe<Scalars['Float']['output']>;
  primary_voltage?: Maybe<Scalars['Float']['output']>;
  weight_pounds?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "step_up_transformers" */
export type Step_Up_Transformers_Stddev_Order_By = {
  imported_sizing_id?: InputMaybe<Order_By>;
  kva?: InputMaybe<Order_By>;
  max_secondary_voltage?: InputMaybe<Order_By>;
  min_secondary_voltage?: InputMaybe<Order_By>;
  primary_voltage?: InputMaybe<Order_By>;
  weight_pounds?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Step_Up_Transformers_Stddev_Pop_Fields = {
  __typename: 'step_up_transformers_stddev_pop_fields';
  imported_sizing_id?: Maybe<Scalars['Float']['output']>;
  kva?: Maybe<Scalars['Float']['output']>;
  max_secondary_voltage?: Maybe<Scalars['Float']['output']>;
  min_secondary_voltage?: Maybe<Scalars['Float']['output']>;
  primary_voltage?: Maybe<Scalars['Float']['output']>;
  weight_pounds?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "step_up_transformers" */
export type Step_Up_Transformers_Stddev_Pop_Order_By = {
  imported_sizing_id?: InputMaybe<Order_By>;
  kva?: InputMaybe<Order_By>;
  max_secondary_voltage?: InputMaybe<Order_By>;
  min_secondary_voltage?: InputMaybe<Order_By>;
  primary_voltage?: InputMaybe<Order_By>;
  weight_pounds?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Step_Up_Transformers_Stddev_Samp_Fields = {
  __typename: 'step_up_transformers_stddev_samp_fields';
  imported_sizing_id?: Maybe<Scalars['Float']['output']>;
  kva?: Maybe<Scalars['Float']['output']>;
  max_secondary_voltage?: Maybe<Scalars['Float']['output']>;
  min_secondary_voltage?: Maybe<Scalars['Float']['output']>;
  primary_voltage?: Maybe<Scalars['Float']['output']>;
  weight_pounds?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "step_up_transformers" */
export type Step_Up_Transformers_Stddev_Samp_Order_By = {
  imported_sizing_id?: InputMaybe<Order_By>;
  kva?: InputMaybe<Order_By>;
  max_secondary_voltage?: InputMaybe<Order_By>;
  min_secondary_voltage?: InputMaybe<Order_By>;
  primary_voltage?: InputMaybe<Order_By>;
  weight_pounds?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "step_up_transformers" */
export type Step_Up_Transformers_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Step_Up_Transformers_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Step_Up_Transformers_Stream_Cursor_Value_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  enclosure?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  imported_sizing_id?: InputMaybe<Scalars['Int']['input']>;
  include_ecopetrol_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  include_koc_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  kva?: InputMaybe<Scalars['Int']['input']>;
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  max_secondary_voltage?: InputMaybe<Scalars['Int']['input']>;
  min_secondary_voltage?: InputMaybe<Scalars['Int']['input']>;
  only_ecopetrol_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  only_koc_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  part_number?: InputMaybe<Scalars['String']['input']>;
  primary_voltage?: InputMaybe<Scalars['Int']['input']>;
  transformer_type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  weight_pounds?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Step_Up_Transformers_Sum_Fields = {
  __typename: 'step_up_transformers_sum_fields';
  imported_sizing_id?: Maybe<Scalars['Int']['output']>;
  kva?: Maybe<Scalars['Int']['output']>;
  max_secondary_voltage?: Maybe<Scalars['Int']['output']>;
  min_secondary_voltage?: Maybe<Scalars['Int']['output']>;
  primary_voltage?: Maybe<Scalars['Int']['output']>;
  weight_pounds?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "step_up_transformers" */
export type Step_Up_Transformers_Sum_Order_By = {
  imported_sizing_id?: InputMaybe<Order_By>;
  kva?: InputMaybe<Order_By>;
  max_secondary_voltage?: InputMaybe<Order_By>;
  min_secondary_voltage?: InputMaybe<Order_By>;
  primary_voltage?: InputMaybe<Order_By>;
  weight_pounds?: InputMaybe<Order_By>;
};

/** update columns of table "step_up_transformers" */
export enum Step_Up_Transformers_Update_Column {
  /** column name */
  AuthorId = 'author_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Enclosure = 'enclosure',
  /** column name */
  Id = 'id',
  /** column name */
  ImportedSizingId = 'imported_sizing_id',
  /** column name */
  IncludeEcopetrolTimestamp = 'include_ecopetrol_timestamp',
  /** column name */
  IncludeKocTimestamp = 'include_koc_timestamp',
  /** column name */
  Kva = 'kva',
  /** column name */
  Manufacturer = 'manufacturer',
  /** column name */
  MaxSecondaryVoltage = 'max_secondary_voltage',
  /** column name */
  MinSecondaryVoltage = 'min_secondary_voltage',
  /** column name */
  OnlyEcopetrolTimestamp = 'only_ecopetrol_timestamp',
  /** column name */
  OnlyKocTimestamp = 'only_koc_timestamp',
  /** column name */
  PartNumber = 'part_number',
  /** column name */
  PrimaryVoltage = 'primary_voltage',
  /** column name */
  TransformerType = 'transformer_type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WeightPounds = 'weight_pounds'
}

export type Step_Up_Transformers_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Step_Up_Transformers_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Step_Up_Transformers_Set_Input>;
  /** filter the rows which have to be updated */
  where: Step_Up_Transformers_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Step_Up_Transformers_Var_Pop_Fields = {
  __typename: 'step_up_transformers_var_pop_fields';
  imported_sizing_id?: Maybe<Scalars['Float']['output']>;
  kva?: Maybe<Scalars['Float']['output']>;
  max_secondary_voltage?: Maybe<Scalars['Float']['output']>;
  min_secondary_voltage?: Maybe<Scalars['Float']['output']>;
  primary_voltage?: Maybe<Scalars['Float']['output']>;
  weight_pounds?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "step_up_transformers" */
export type Step_Up_Transformers_Var_Pop_Order_By = {
  imported_sizing_id?: InputMaybe<Order_By>;
  kva?: InputMaybe<Order_By>;
  max_secondary_voltage?: InputMaybe<Order_By>;
  min_secondary_voltage?: InputMaybe<Order_By>;
  primary_voltage?: InputMaybe<Order_By>;
  weight_pounds?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Step_Up_Transformers_Var_Samp_Fields = {
  __typename: 'step_up_transformers_var_samp_fields';
  imported_sizing_id?: Maybe<Scalars['Float']['output']>;
  kva?: Maybe<Scalars['Float']['output']>;
  max_secondary_voltage?: Maybe<Scalars['Float']['output']>;
  min_secondary_voltage?: Maybe<Scalars['Float']['output']>;
  primary_voltage?: Maybe<Scalars['Float']['output']>;
  weight_pounds?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "step_up_transformers" */
export type Step_Up_Transformers_Var_Samp_Order_By = {
  imported_sizing_id?: InputMaybe<Order_By>;
  kva?: InputMaybe<Order_By>;
  max_secondary_voltage?: InputMaybe<Order_By>;
  min_secondary_voltage?: InputMaybe<Order_By>;
  primary_voltage?: InputMaybe<Order_By>;
  weight_pounds?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Step_Up_Transformers_Variance_Fields = {
  __typename: 'step_up_transformers_variance_fields';
  imported_sizing_id?: Maybe<Scalars['Float']['output']>;
  kva?: Maybe<Scalars['Float']['output']>;
  max_secondary_voltage?: Maybe<Scalars['Float']['output']>;
  min_secondary_voltage?: Maybe<Scalars['Float']['output']>;
  primary_voltage?: Maybe<Scalars['Float']['output']>;
  weight_pounds?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "step_up_transformers" */
export type Step_Up_Transformers_Variance_Order_By = {
  imported_sizing_id?: InputMaybe<Order_By>;
  kva?: InputMaybe<Order_By>;
  max_secondary_voltage?: InputMaybe<Order_By>;
  min_secondary_voltage?: InputMaybe<Order_By>;
  primary_voltage?: InputMaybe<Order_By>;
  weight_pounds?: InputMaybe<Order_By>;
};

export type Subscription_Root = {
  __typename: 'subscription_root';
  /** fetch data from the table: "bolt_on_discharges" */
  bolt_on_discharges: Array<Bolt_On_Discharges>;
  /** fetch aggregated fields from the table: "bolt_on_discharges" */
  bolt_on_discharges_aggregate: Bolt_On_Discharges_Aggregate;
  /** fetch data from the table: "bolt_on_discharges" using primary key columns */
  bolt_on_discharges_by_pk?: Maybe<Bolt_On_Discharges>;
  /** fetch data from the table in a streaming manner: "bolt_on_discharges" */
  bolt_on_discharges_stream: Array<Bolt_On_Discharges>;
  /** fetch data from the table: "bubble_point_options" */
  bubble_point_options: Array<Bubble_Point_Options>;
  /** fetch aggregated fields from the table: "bubble_point_options" */
  bubble_point_options_aggregate: Bubble_Point_Options_Aggregate;
  /** fetch data from the table: "bubble_point_options" using primary key columns */
  bubble_point_options_by_pk?: Maybe<Bubble_Point_Options>;
  /** fetch data from the table in a streaming manner: "bubble_point_options" */
  bubble_point_options_stream: Array<Bubble_Point_Options>;
  /** An array relationship */
  cables: Array<Cables>;
  /** An aggregate relationship */
  cables_aggregate: Cables_Aggregate;
  /** fetch data from the table: "cables" using primary key columns */
  cables_by_pk?: Maybe<Cables>;
  /** fetch data from the table in a streaming manner: "cables" */
  cables_stream: Array<Cables>;
  /** fetch data from the table: "casing_flow_options" */
  casing_flow_options: Array<Casing_Flow_Options>;
  /** fetch aggregated fields from the table: "casing_flow_options" */
  casing_flow_options_aggregate: Casing_Flow_Options_Aggregate;
  /** fetch data from the table: "casing_flow_options" using primary key columns */
  casing_flow_options_by_pk?: Maybe<Casing_Flow_Options>;
  /** fetch data from the table in a streaming manner: "casing_flow_options" */
  casing_flow_options_stream: Array<Casing_Flow_Options>;
  /** An array relationship */
  casings: Array<Casings>;
  /** An aggregate relationship */
  casings_aggregate: Casings_Aggregate;
  /** fetch data from the table: "casings" using primary key columns */
  casings_by_pk?: Maybe<Casings>;
  /** fetch data from the table in a streaming manner: "casings" */
  casings_stream: Array<Casings>;
  /** fetch data from the table: "casings_type" */
  casings_type: Array<Casings_Type>;
  /** fetch aggregated fields from the table: "casings_type" */
  casings_type_aggregate: Casings_Type_Aggregate;
  /** fetch data from the table: "casings_type" using primary key columns */
  casings_type_by_pk?: Maybe<Casings_Type>;
  /** fetch data from the table in a streaming manner: "casings_type" */
  casings_type_stream: Array<Casings_Type>;
  /** An array relationship */
  customers: Array<Customers>;
  /** An aggregate relationship */
  customers_aggregate: Customers_Aggregate;
  /** fetch data from the table: "customers" using primary key columns */
  customers_by_pk?: Maybe<Customers>;
  /** fetch data from the table in a streaming manner: "customers" */
  customers_stream: Array<Customers>;
  /** fetch data from the table: "dead_oil_options" */
  dead_oil_options: Array<Dead_Oil_Options>;
  /** fetch aggregated fields from the table: "dead_oil_options" */
  dead_oil_options_aggregate: Dead_Oil_Options_Aggregate;
  /** fetch data from the table: "dead_oil_options" using primary key columns */
  dead_oil_options_by_pk?: Maybe<Dead_Oil_Options>;
  /** fetch data from the table in a streaming manner: "dead_oil_options" */
  dead_oil_options_stream: Array<Dead_Oil_Options>;
  /** fetch data from the table: "deviation_survey" */
  deviation_survey: Array<Deviation_Survey>;
  /** fetch aggregated fields from the table: "deviation_survey" */
  deviation_survey_aggregate: Deviation_Survey_Aggregate;
  /** fetch data from the table: "deviation_survey" using primary key columns */
  deviation_survey_by_pk?: Maybe<Deviation_Survey>;
  /** fetch data from the table: "deviation_survey_directional_dataset" */
  deviation_survey_directional_dataset: Array<Deviation_Survey_Directional_Dataset>;
  /** fetch aggregated fields from the table: "deviation_survey_directional_dataset" */
  deviation_survey_directional_dataset_aggregate: Deviation_Survey_Directional_Dataset_Aggregate;
  /** fetch data from the table: "deviation_survey_directional_dataset" using primary key columns */
  deviation_survey_directional_dataset_by_pk?: Maybe<Deviation_Survey_Directional_Dataset>;
  /** fetch data from the table in a streaming manner: "deviation_survey_directional_dataset" */
  deviation_survey_directional_dataset_stream: Array<Deviation_Survey_Directional_Dataset>;
  /** fetch data from the table in a streaming manner: "deviation_survey" */
  deviation_survey_stream: Array<Deviation_Survey>;
  /** fetch data from the table: "display_units" */
  display_units: Array<Display_Units>;
  /** fetch aggregated fields from the table: "display_units" */
  display_units_aggregate: Display_Units_Aggregate;
  /** fetch data from the table: "display_units" using primary key columns */
  display_units_by_pk?: Maybe<Display_Units>;
  /** fetch data from the table in a streaming manner: "display_units" */
  display_units_stream: Array<Display_Units>;
  /** fetch data from the table: "eula" */
  eula: Array<Eula>;
  /** fetch aggregated fields from the table: "eula" */
  eula_aggregate: Eula_Aggregate;
  /** fetch data from the table: "eula" using primary key columns */
  eula_by_pk?: Maybe<Eula>;
  /** fetch data from the table in a streaming manner: "eula" */
  eula_stream: Array<Eula>;
  /** fetch data from the table: "flow_model" */
  flow_model: Array<Flow_Model>;
  /** fetch data from the table: "flow_model_active" */
  flow_model_active: Array<Flow_Model_Active>;
  /** fetch aggregated fields from the table: "flow_model_active" */
  flow_model_active_aggregate: Flow_Model_Active_Aggregate;
  /** fetch data from the table in a streaming manner: "flow_model_active" */
  flow_model_active_stream: Array<Flow_Model_Active>;
  /** fetch aggregated fields from the table: "flow_model" */
  flow_model_aggregate: Flow_Model_Aggregate;
  /** fetch data from the table: "flow_model" using primary key columns */
  flow_model_by_pk?: Maybe<Flow_Model>;
  /** fetch data from the table: "flow_model_deprecated" */
  flow_model_deprecated: Array<Flow_Model_Deprecated>;
  /** fetch aggregated fields from the table: "flow_model_deprecated" */
  flow_model_deprecated_aggregate: Flow_Model_Deprecated_Aggregate;
  /** fetch data from the table: "flow_model_deprecated" using primary key columns */
  flow_model_deprecated_by_pk?: Maybe<Flow_Model_Deprecated>;
  /** fetch data from the table in a streaming manner: "flow_model_deprecated" */
  flow_model_deprecated_stream: Array<Flow_Model_Deprecated>;
  /** fetch data from the table in a streaming manner: "flow_model" */
  flow_model_stream: Array<Flow_Model>;
  /** fetch data from the table: "friction_loss_options" */
  friction_loss_options: Array<Friction_Loss_Options>;
  /** fetch aggregated fields from the table: "friction_loss_options" */
  friction_loss_options_aggregate: Friction_Loss_Options_Aggregate;
  /** fetch data from the table: "friction_loss_options" using primary key columns */
  friction_loss_options_by_pk?: Maybe<Friction_Loss_Options>;
  /** fetch data from the table in a streaming manner: "friction_loss_options" */
  friction_loss_options_stream: Array<Friction_Loss_Options>;
  /** fetch data from the table: "gas_compressibility_options" */
  gas_compressibility_options: Array<Gas_Compressibility_Options>;
  /** fetch aggregated fields from the table: "gas_compressibility_options" */
  gas_compressibility_options_aggregate: Gas_Compressibility_Options_Aggregate;
  /** fetch data from the table: "gas_compressibility_options" using primary key columns */
  gas_compressibility_options_by_pk?: Maybe<Gas_Compressibility_Options>;
  /** fetch data from the table in a streaming manner: "gas_compressibility_options" */
  gas_compressibility_options_stream: Array<Gas_Compressibility_Options>;
  /** fetch data from the table: "gas_viscosity_options" */
  gas_viscosity_options: Array<Gas_Viscosity_Options>;
  /** fetch aggregated fields from the table: "gas_viscosity_options" */
  gas_viscosity_options_aggregate: Gas_Viscosity_Options_Aggregate;
  /** fetch data from the table: "gas_viscosity_options" using primary key columns */
  gas_viscosity_options_by_pk?: Maybe<Gas_Viscosity_Options>;
  /** fetch data from the table in a streaming manner: "gas_viscosity_options" */
  gas_viscosity_options_stream: Array<Gas_Viscosity_Options>;
  /** An array relationship */
  housings: Array<Housings>;
  /** An aggregate relationship */
  housings_aggregate: Housings_Aggregate;
  /** fetch data from the table: "housings" using primary key columns */
  housings_by_pk?: Maybe<Housings>;
  /** fetch data from the table in a streaming manner: "housings" */
  housings_stream: Array<Housings>;
  /** fetch data from the table: "hps_liquid_type" */
  hps_liquid_type: Array<Hps_Liquid_Type>;
  /** fetch aggregated fields from the table: "hps_liquid_type" */
  hps_liquid_type_aggregate: Hps_Liquid_Type_Aggregate;
  /** fetch data from the table: "hps_liquid_type" using primary key columns */
  hps_liquid_type_by_pk?: Maybe<Hps_Liquid_Type>;
  /** fetch data from the table in a streaming manner: "hps_liquid_type" */
  hps_liquid_type_stream: Array<Hps_Liquid_Type>;
  /** An array relationship */
  intakes: Array<Intakes>;
  /** An aggregate relationship */
  intakes_aggregate: Intakes_Aggregate;
  /** fetch data from the table: "intakes" using primary key columns */
  intakes_by_pk?: Maybe<Intakes>;
  /** fetch data from the table in a streaming manner: "intakes" */
  intakes_stream: Array<Intakes>;
  /** fetch data from the table: "legacy_users" */
  legacy_users: Array<Legacy_Users>;
  /** fetch aggregated fields from the table: "legacy_users" */
  legacy_users_aggregate: Legacy_Users_Aggregate;
  /** fetch data from the table: "legacy_users" using primary key columns */
  legacy_users_by_pk?: Maybe<Legacy_Users>;
  /** fetch data from the table in a streaming manner: "legacy_users" */
  legacy_users_stream: Array<Legacy_Users>;
  /** An array relationship */
  motor_lead_extensions: Array<Motor_Lead_Extensions>;
  /** An aggregate relationship */
  motor_lead_extensions_aggregate: Motor_Lead_Extensions_Aggregate;
  /** fetch data from the table: "motor_lead_extensions" using primary key columns */
  motor_lead_extensions_by_pk?: Maybe<Motor_Lead_Extensions>;
  /** fetch data from the table in a streaming manner: "motor_lead_extensions" */
  motor_lead_extensions_stream: Array<Motor_Lead_Extensions>;
  /** An array relationship */
  motors: Array<Motors>;
  /** An aggregate relationship */
  motors_aggregate: Motors_Aggregate;
  /** fetch data from the table: "motors" using primary key columns */
  motors_by_pk?: Maybe<Motors>;
  /** fetch data from the table in a streaming manner: "motors" */
  motors_stream: Array<Motors>;
  /** fetch data from the table: "natural_gas_separation_options" */
  natural_gas_separation_options: Array<Natural_Gas_Separation_Options>;
  /** fetch aggregated fields from the table: "natural_gas_separation_options" */
  natural_gas_separation_options_aggregate: Natural_Gas_Separation_Options_Aggregate;
  /** fetch data from the table: "natural_gas_separation_options" using primary key columns */
  natural_gas_separation_options_by_pk?: Maybe<Natural_Gas_Separation_Options>;
  /** fetch data from the table in a streaming manner: "natural_gas_separation_options" */
  natural_gas_separation_options_stream: Array<Natural_Gas_Separation_Options>;
  /** fetch data from the table: "oil_density_options" */
  oil_density_options: Array<Oil_Density_Options>;
  /** fetch aggregated fields from the table: "oil_density_options" */
  oil_density_options_aggregate: Oil_Density_Options_Aggregate;
  /** fetch data from the table: "oil_density_options" using primary key columns */
  oil_density_options_by_pk?: Maybe<Oil_Density_Options>;
  /** fetch data from the table in a streaming manner: "oil_density_options" */
  oil_density_options_stream: Array<Oil_Density_Options>;
  /** fetch data from the table: "oil_volume_factor_options" */
  oil_volume_factor_options: Array<Oil_Volume_Factor_Options>;
  /** fetch aggregated fields from the table: "oil_volume_factor_options" */
  oil_volume_factor_options_aggregate: Oil_Volume_Factor_Options_Aggregate;
  /** fetch data from the table: "oil_volume_factor_options" using primary key columns */
  oil_volume_factor_options_by_pk?: Maybe<Oil_Volume_Factor_Options>;
  /** fetch data from the table in a streaming manner: "oil_volume_factor_options" */
  oil_volume_factor_options_stream: Array<Oil_Volume_Factor_Options>;
  /** fetch data from the table: "override_options" */
  override_options: Array<Override_Options>;
  /** fetch aggregated fields from the table: "override_options" */
  override_options_aggregate: Override_Options_Aggregate;
  /** fetch data from the table: "override_options" using primary key columns */
  override_options_by_pk?: Maybe<Override_Options>;
  /** fetch data from the table in a streaming manner: "override_options" */
  override_options_stream: Array<Override_Options>;
  /** An array relationship */
  performance_evaluations: Array<Performance_Evaluations>;
  /** An aggregate relationship */
  performance_evaluations_aggregate: Performance_Evaluations_Aggregate;
  /** fetch data from the table in a streaming manner: "performance_evaluations" */
  performance_evaluations_stream: Array<Performance_Evaluations>;
  /** fetch data from the table: "performance_evaluations_xref_pumps" */
  performance_evaluations_xref_pumps: Array<Performance_Evaluations_Xref_Pumps>;
  /** fetch aggregated fields from the table: "performance_evaluations_xref_pumps" */
  performance_evaluations_xref_pumps_aggregate: Performance_Evaluations_Xref_Pumps_Aggregate;
  /** fetch data from the table in a streaming manner: "performance_evaluations_xref_pumps" */
  performance_evaluations_xref_pumps_stream: Array<Performance_Evaluations_Xref_Pumps>;
  /** An array relationship */
  pumps: Array<Pumps>;
  /** An aggregate relationship */
  pumps_aggregate: Pumps_Aggregate;
  /** fetch data from the table: "pumps" using primary key columns */
  pumps_by_pk?: Maybe<Pumps>;
  /** fetch data from the table in a streaming manner: "pumps" */
  pumps_stream: Array<Pumps>;
  /** fetch data from the table: "quote_line_item_category_dataset" */
  quote_line_item_category_dataset: Array<Quote_Line_Item_Category_Dataset>;
  /** fetch aggregated fields from the table: "quote_line_item_category_dataset" */
  quote_line_item_category_dataset_aggregate: Quote_Line_Item_Category_Dataset_Aggregate;
  /** fetch data from the table: "quote_line_item_category_dataset" using primary key columns */
  quote_line_item_category_dataset_by_pk?: Maybe<Quote_Line_Item_Category_Dataset>;
  /** fetch data from the table in a streaming manner: "quote_line_item_category_dataset" */
  quote_line_item_category_dataset_stream: Array<Quote_Line_Item_Category_Dataset>;
  /** fetch data from the table: "quote_line_item_serialized_dataset" */
  quote_line_item_serialized_dataset: Array<Quote_Line_Item_Serialized_Dataset>;
  /** fetch aggregated fields from the table: "quote_line_item_serialized_dataset" */
  quote_line_item_serialized_dataset_aggregate: Quote_Line_Item_Serialized_Dataset_Aggregate;
  /** fetch data from the table: "quote_line_item_serialized_dataset" using primary key columns */
  quote_line_item_serialized_dataset_by_pk?: Maybe<Quote_Line_Item_Serialized_Dataset>;
  /** fetch data from the table in a streaming manner: "quote_line_item_serialized_dataset" */
  quote_line_item_serialized_dataset_stream: Array<Quote_Line_Item_Serialized_Dataset>;
  /** fetch data from the table: "quote_line_item_source_dataset" */
  quote_line_item_source_dataset: Array<Quote_Line_Item_Source_Dataset>;
  /** fetch aggregated fields from the table: "quote_line_item_source_dataset" */
  quote_line_item_source_dataset_aggregate: Quote_Line_Item_Source_Dataset_Aggregate;
  /** fetch data from the table: "quote_line_item_source_dataset" using primary key columns */
  quote_line_item_source_dataset_by_pk?: Maybe<Quote_Line_Item_Source_Dataset>;
  /** fetch data from the table in a streaming manner: "quote_line_item_source_dataset" */
  quote_line_item_source_dataset_stream: Array<Quote_Line_Item_Source_Dataset>;
  /** fetch data from the table: "quote_line_item_subcategory_dataset" */
  quote_line_item_subcategory_dataset: Array<Quote_Line_Item_Subcategory_Dataset>;
  /** fetch aggregated fields from the table: "quote_line_item_subcategory_dataset" */
  quote_line_item_subcategory_dataset_aggregate: Quote_Line_Item_Subcategory_Dataset_Aggregate;
  /** fetch data from the table: "quote_line_item_subcategory_dataset" using primary key columns */
  quote_line_item_subcategory_dataset_by_pk?: Maybe<Quote_Line_Item_Subcategory_Dataset>;
  /** fetch data from the table in a streaming manner: "quote_line_item_subcategory_dataset" */
  quote_line_item_subcategory_dataset_stream: Array<Quote_Line_Item_Subcategory_Dataset>;
  /** fetch data from the table: "quote_line_item_tax_type_dataset" */
  quote_line_item_tax_type_dataset: Array<Quote_Line_Item_Tax_Type_Dataset>;
  /** fetch aggregated fields from the table: "quote_line_item_tax_type_dataset" */
  quote_line_item_tax_type_dataset_aggregate: Quote_Line_Item_Tax_Type_Dataset_Aggregate;
  /** fetch data from the table: "quote_line_item_tax_type_dataset" using primary key columns */
  quote_line_item_tax_type_dataset_by_pk?: Maybe<Quote_Line_Item_Tax_Type_Dataset>;
  /** fetch data from the table in a streaming manner: "quote_line_item_tax_type_dataset" */
  quote_line_item_tax_type_dataset_stream: Array<Quote_Line_Item_Tax_Type_Dataset>;
  /** fetch data from the table: "quote_line_item_type_dataset" */
  quote_line_item_type_dataset: Array<Quote_Line_Item_Type_Dataset>;
  /** fetch aggregated fields from the table: "quote_line_item_type_dataset" */
  quote_line_item_type_dataset_aggregate: Quote_Line_Item_Type_Dataset_Aggregate;
  /** fetch data from the table: "quote_line_item_type_dataset" using primary key columns */
  quote_line_item_type_dataset_by_pk?: Maybe<Quote_Line_Item_Type_Dataset>;
  /** fetch data from the table in a streaming manner: "quote_line_item_type_dataset" */
  quote_line_item_type_dataset_stream: Array<Quote_Line_Item_Type_Dataset>;
  /** An array relationship */
  quote_line_items: Array<Quote_Line_Items>;
  /** An aggregate relationship */
  quote_line_items_aggregate: Quote_Line_Items_Aggregate;
  /** fetch data from the table: "quote_line_items" using primary key columns */
  quote_line_items_by_pk?: Maybe<Quote_Line_Items>;
  /** fetch data from the table in a streaming manner: "quote_line_items" */
  quote_line_items_stream: Array<Quote_Line_Items>;
  /** fetch data from the table: "quote_sk_job_type_dataset" */
  quote_sk_job_type_dataset: Array<Quote_Sk_Job_Type_Dataset>;
  /** fetch aggregated fields from the table: "quote_sk_job_type_dataset" */
  quote_sk_job_type_dataset_aggregate: Quote_Sk_Job_Type_Dataset_Aggregate;
  /** fetch data from the table: "quote_sk_job_type_dataset" using primary key columns */
  quote_sk_job_type_dataset_by_pk?: Maybe<Quote_Sk_Job_Type_Dataset>;
  /** fetch data from the table in a streaming manner: "quote_sk_job_type_dataset" */
  quote_sk_job_type_dataset_stream: Array<Quote_Sk_Job_Type_Dataset>;
  /** fetch data from the table: "quote_source_dataset" */
  quote_source_dataset: Array<Quote_Source_Dataset>;
  /** fetch aggregated fields from the table: "quote_source_dataset" */
  quote_source_dataset_aggregate: Quote_Source_Dataset_Aggregate;
  /** fetch data from the table: "quote_source_dataset" using primary key columns */
  quote_source_dataset_by_pk?: Maybe<Quote_Source_Dataset>;
  /** fetch data from the table in a streaming manner: "quote_source_dataset" */
  quote_source_dataset_stream: Array<Quote_Source_Dataset>;
  /** fetch data from the table: "quote_status_dataset" */
  quote_status_dataset: Array<Quote_Status_Dataset>;
  /** fetch aggregated fields from the table: "quote_status_dataset" */
  quote_status_dataset_aggregate: Quote_Status_Dataset_Aggregate;
  /** fetch data from the table: "quote_status_dataset" using primary key columns */
  quote_status_dataset_by_pk?: Maybe<Quote_Status_Dataset>;
  /** fetch data from the table in a streaming manner: "quote_status_dataset" */
  quote_status_dataset_stream: Array<Quote_Status_Dataset>;
  /** fetch data from the table: "quote_user_messages" */
  quote_user_messages: Array<Quote_User_Messages>;
  /** fetch aggregated fields from the table: "quote_user_messages" */
  quote_user_messages_aggregate: Quote_User_Messages_Aggregate;
  /** fetch data from the table: "quote_user_messages" using primary key columns */
  quote_user_messages_by_pk?: Maybe<Quote_User_Messages>;
  /** fetch data from the table in a streaming manner: "quote_user_messages" */
  quote_user_messages_stream: Array<Quote_User_Messages>;
  /** An array relationship */
  quotes: Array<Quotes>;
  /** An aggregate relationship */
  quotes_aggregate: Quotes_Aggregate;
  /** fetch data from the table: "quotes" using primary key columns */
  quotes_by_pk?: Maybe<Quotes>;
  /** fetch data from the table in a streaming manner: "quotes" */
  quotes_stream: Array<Quotes>;
  /** fetch data from the table: "revisions.performance_evaluations_journal" */
  revisions_performance_evaluations_journal: Array<Revisions_Performance_Evaluations_Journal>;
  /** fetch aggregated fields from the table: "revisions.performance_evaluations_journal" */
  revisions_performance_evaluations_journal_aggregate: Revisions_Performance_Evaluations_Journal_Aggregate;
  /** fetch data from the table: "revisions.performance_evaluations_journal" using primary key columns */
  revisions_performance_evaluations_journal_by_pk?: Maybe<Revisions_Performance_Evaluations_Journal>;
  /** fetch data from the table in a streaming manner: "revisions.performance_evaluations_journal" */
  revisions_performance_evaluations_journal_stream: Array<Revisions_Performance_Evaluations_Journal>;
  /** fetch data from the table: "revisions.performance_evaluations_revisions" */
  revisions_performance_evaluations_revisions: Array<Revisions_Performance_Evaluations_Revisions>;
  /** fetch aggregated fields from the table: "revisions.performance_evaluations_revisions" */
  revisions_performance_evaluations_revisions_aggregate: Revisions_Performance_Evaluations_Revisions_Aggregate;
  /** fetch data from the table: "revisions.performance_evaluations_revisions" using primary key columns */
  revisions_performance_evaluations_revisions_by_pk?: Maybe<Revisions_Performance_Evaluations_Revisions>;
  /** fetch data from the table in a streaming manner: "revisions.performance_evaluations_revisions" */
  revisions_performance_evaluations_revisions_stream: Array<Revisions_Performance_Evaluations_Revisions>;
  /** fetch data from the table: "revisions.performance_evaluations_xref_pumps_journal" */
  revisions_performance_evaluations_xref_pumps_journal: Array<Revisions_Performance_Evaluations_Xref_Pumps_Journal>;
  /** fetch aggregated fields from the table: "revisions.performance_evaluations_xref_pumps_journal" */
  revisions_performance_evaluations_xref_pumps_journal_aggregate: Revisions_Performance_Evaluations_Xref_Pumps_Journal_Aggregate;
  /** fetch data from the table: "revisions.performance_evaluations_xref_pumps_journal" using primary key columns */
  revisions_performance_evaluations_xref_pumps_journal_by_pk?: Maybe<Revisions_Performance_Evaluations_Xref_Pumps_Journal>;
  /** fetch data from the table in a streaming manner: "revisions.performance_evaluations_xref_pumps_journal" */
  revisions_performance_evaluations_xref_pumps_journal_stream: Array<Revisions_Performance_Evaluations_Xref_Pumps_Journal>;
  /** fetch data from the table: "revisions.performance_evaluations_xref_pumps_revisions" */
  revisions_performance_evaluations_xref_pumps_revisions: Array<Revisions_Performance_Evaluations_Xref_Pumps_Revisions>;
  /** fetch aggregated fields from the table: "revisions.performance_evaluations_xref_pumps_revisions" */
  revisions_performance_evaluations_xref_pumps_revisions_aggregate: Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Aggregate;
  /** fetch data from the table: "revisions.performance_evaluations_xref_pumps_revisions" using primary key columns */
  revisions_performance_evaluations_xref_pumps_revisions_by_pk?: Maybe<Revisions_Performance_Evaluations_Xref_Pumps_Revisions>;
  /** fetch data from the table in a streaming manner: "revisions.performance_evaluations_xref_pumps_revisions" */
  revisions_performance_evaluations_xref_pumps_revisions_stream: Array<Revisions_Performance_Evaluations_Xref_Pumps_Revisions>;
  /** fetch data from the table: "revisions.sc_equip_xref_downhole_ytool_bypass_tubings_journal" */
  revisions_sc_equip_xref_downhole_ytool_bypass_tubings_journal: Array<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal>;
  /** fetch aggregated fields from the table: "revisions.sc_equip_xref_downhole_ytool_bypass_tubings_journal" */
  revisions_sc_equip_xref_downhole_ytool_bypass_tubings_journal_aggregate: Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_Aggregate;
  /** fetch data from the table: "revisions.sc_equip_xref_downhole_ytool_bypass_tubings_journal" using primary key columns */
  revisions_sc_equip_xref_downhole_ytool_bypass_tubings_journal_by_pk?: Maybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal>;
  /** fetch data from the table in a streaming manner: "revisions.sc_equip_xref_downhole_ytool_bypass_tubings_journal" */
  revisions_sc_equip_xref_downhole_ytool_bypass_tubings_journal_stream: Array<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal>;
  /** fetch data from the table: "revisions.sc_equip_xref_downhole_ytool_bypass_tubings_revisions" */
  revisions_sc_equip_xref_downhole_ytool_bypass_tubings_revisions: Array<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions>;
  /** fetch aggregated fields from the table: "revisions.sc_equip_xref_downhole_ytool_bypass_tubings_revisions" */
  revisions_sc_equip_xref_downhole_ytool_bypass_tubings_revisions_aggregate: Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Aggregate;
  /** fetch data from the table: "revisions.sc_equip_xref_downhole_ytool_bypass_tubings_revisions" using primary key columns */
  revisions_sc_equip_xref_downhole_ytool_bypass_tubings_revisions_by_pk?: Maybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions>;
  /** fetch data from the table in a streaming manner: "revisions.sc_equip_xref_downhole_ytool_bypass_tubings_revisions" */
  revisions_sc_equip_xref_downhole_ytool_bypass_tubings_revisions_stream: Array<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions>;
  /** fetch data from the table: "revisions.sc_equip_xref_downhole_ytool_equip_tubings_journal" */
  revisions_sc_equip_xref_downhole_ytool_equip_tubings_journal: Array<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal>;
  /** fetch aggregated fields from the table: "revisions.sc_equip_xref_downhole_ytool_equip_tubings_journal" */
  revisions_sc_equip_xref_downhole_ytool_equip_tubings_journal_aggregate: Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_Aggregate;
  /** fetch data from the table: "revisions.sc_equip_xref_downhole_ytool_equip_tubings_journal" using primary key columns */
  revisions_sc_equip_xref_downhole_ytool_equip_tubings_journal_by_pk?: Maybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal>;
  /** fetch data from the table in a streaming manner: "revisions.sc_equip_xref_downhole_ytool_equip_tubings_journal" */
  revisions_sc_equip_xref_downhole_ytool_equip_tubings_journal_stream: Array<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal>;
  /** fetch data from the table: "revisions.sc_equip_xref_downhole_ytool_equip_tubings_revisions" */
  revisions_sc_equip_xref_downhole_ytool_equip_tubings_revisions: Array<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions>;
  /** fetch aggregated fields from the table: "revisions.sc_equip_xref_downhole_ytool_equip_tubings_revisions" */
  revisions_sc_equip_xref_downhole_ytool_equip_tubings_revisions_aggregate: Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Aggregate;
  /** fetch data from the table: "revisions.sc_equip_xref_downhole_ytool_equip_tubings_revisions" using primary key columns */
  revisions_sc_equip_xref_downhole_ytool_equip_tubings_revisions_by_pk?: Maybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions>;
  /** fetch data from the table in a streaming manner: "revisions.sc_equip_xref_downhole_ytool_equip_tubings_revisions" */
  revisions_sc_equip_xref_downhole_ytool_equip_tubings_revisions_stream: Array<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions>;
  /** fetch data from the table: "revisions.sc_equip_xref_uphole_ytool_bypass_tubings_journal" */
  revisions_sc_equip_xref_uphole_ytool_bypass_tubings_journal: Array<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal>;
  /** fetch aggregated fields from the table: "revisions.sc_equip_xref_uphole_ytool_bypass_tubings_journal" */
  revisions_sc_equip_xref_uphole_ytool_bypass_tubings_journal_aggregate: Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_Aggregate;
  /** fetch data from the table: "revisions.sc_equip_xref_uphole_ytool_bypass_tubings_journal" using primary key columns */
  revisions_sc_equip_xref_uphole_ytool_bypass_tubings_journal_by_pk?: Maybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal>;
  /** fetch data from the table in a streaming manner: "revisions.sc_equip_xref_uphole_ytool_bypass_tubings_journal" */
  revisions_sc_equip_xref_uphole_ytool_bypass_tubings_journal_stream: Array<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal>;
  /** fetch data from the table: "revisions.sc_equip_xref_uphole_ytool_bypass_tubings_revisions" */
  revisions_sc_equip_xref_uphole_ytool_bypass_tubings_revisions: Array<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions>;
  /** fetch aggregated fields from the table: "revisions.sc_equip_xref_uphole_ytool_bypass_tubings_revisions" */
  revisions_sc_equip_xref_uphole_ytool_bypass_tubings_revisions_aggregate: Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Aggregate;
  /** fetch data from the table: "revisions.sc_equip_xref_uphole_ytool_bypass_tubings_revisions" using primary key columns */
  revisions_sc_equip_xref_uphole_ytool_bypass_tubings_revisions_by_pk?: Maybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions>;
  /** fetch data from the table in a streaming manner: "revisions.sc_equip_xref_uphole_ytool_bypass_tubings_revisions" */
  revisions_sc_equip_xref_uphole_ytool_bypass_tubings_revisions_stream: Array<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions>;
  /** fetch data from the table: "revisions.sc_equip_xref_uphole_ytool_equip_tubings_journal" */
  revisions_sc_equip_xref_uphole_ytool_equip_tubings_journal: Array<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal>;
  /** fetch aggregated fields from the table: "revisions.sc_equip_xref_uphole_ytool_equip_tubings_journal" */
  revisions_sc_equip_xref_uphole_ytool_equip_tubings_journal_aggregate: Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_Aggregate;
  /** fetch data from the table: "revisions.sc_equip_xref_uphole_ytool_equip_tubings_journal" using primary key columns */
  revisions_sc_equip_xref_uphole_ytool_equip_tubings_journal_by_pk?: Maybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal>;
  /** fetch data from the table in a streaming manner: "revisions.sc_equip_xref_uphole_ytool_equip_tubings_journal" */
  revisions_sc_equip_xref_uphole_ytool_equip_tubings_journal_stream: Array<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal>;
  /** fetch data from the table: "revisions.sc_equip_xref_uphole_ytool_equip_tubings_revisions" */
  revisions_sc_equip_xref_uphole_ytool_equip_tubings_revisions: Array<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions>;
  /** fetch aggregated fields from the table: "revisions.sc_equip_xref_uphole_ytool_equip_tubings_revisions" */
  revisions_sc_equip_xref_uphole_ytool_equip_tubings_revisions_aggregate: Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Aggregate;
  /** fetch data from the table: "revisions.sc_equip_xref_uphole_ytool_equip_tubings_revisions" using primary key columns */
  revisions_sc_equip_xref_uphole_ytool_equip_tubings_revisions_by_pk?: Maybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions>;
  /** fetch data from the table in a streaming manner: "revisions.sc_equip_xref_uphole_ytool_equip_tubings_revisions" */
  revisions_sc_equip_xref_uphole_ytool_equip_tubings_revisions_stream: Array<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions>;
  /** fetch data from the table: "revisions.scenario_correlations_journal" */
  revisions_scenario_correlations_journal: Array<Revisions_Scenario_Correlations_Journal>;
  /** fetch aggregated fields from the table: "revisions.scenario_correlations_journal" */
  revisions_scenario_correlations_journal_aggregate: Revisions_Scenario_Correlations_Journal_Aggregate;
  /** fetch data from the table: "revisions.scenario_correlations_journal" using primary key columns */
  revisions_scenario_correlations_journal_by_pk?: Maybe<Revisions_Scenario_Correlations_Journal>;
  /** fetch data from the table in a streaming manner: "revisions.scenario_correlations_journal" */
  revisions_scenario_correlations_journal_stream: Array<Revisions_Scenario_Correlations_Journal>;
  /** fetch data from the table: "revisions.scenario_correlations_revisions" */
  revisions_scenario_correlations_revisions: Array<Revisions_Scenario_Correlations_Revisions>;
  /** fetch aggregated fields from the table: "revisions.scenario_correlations_revisions" */
  revisions_scenario_correlations_revisions_aggregate: Revisions_Scenario_Correlations_Revisions_Aggregate;
  /** fetch data from the table: "revisions.scenario_correlations_revisions" using primary key columns */
  revisions_scenario_correlations_revisions_by_pk?: Maybe<Revisions_Scenario_Correlations_Revisions>;
  /** fetch data from the table in a streaming manner: "revisions.scenario_correlations_revisions" */
  revisions_scenario_correlations_revisions_stream: Array<Revisions_Scenario_Correlations_Revisions>;
  /** fetch data from the table: "revisions.scenario_equipment_journal" */
  revisions_scenario_equipment_journal: Array<Revisions_Scenario_Equipment_Journal>;
  /** fetch aggregated fields from the table: "revisions.scenario_equipment_journal" */
  revisions_scenario_equipment_journal_aggregate: Revisions_Scenario_Equipment_Journal_Aggregate;
  /** fetch data from the table: "revisions.scenario_equipment_journal" using primary key columns */
  revisions_scenario_equipment_journal_by_pk?: Maybe<Revisions_Scenario_Equipment_Journal>;
  /** fetch data from the table in a streaming manner: "revisions.scenario_equipment_journal" */
  revisions_scenario_equipment_journal_stream: Array<Revisions_Scenario_Equipment_Journal>;
  /** fetch data from the table: "revisions.scenario_equipment_revisions" */
  revisions_scenario_equipment_revisions: Array<Revisions_Scenario_Equipment_Revisions>;
  /** fetch aggregated fields from the table: "revisions.scenario_equipment_revisions" */
  revisions_scenario_equipment_revisions_aggregate: Revisions_Scenario_Equipment_Revisions_Aggregate;
  /** fetch data from the table: "revisions.scenario_equipment_revisions" using primary key columns */
  revisions_scenario_equipment_revisions_by_pk?: Maybe<Revisions_Scenario_Equipment_Revisions>;
  /** fetch data from the table in a streaming manner: "revisions.scenario_equipment_revisions" */
  revisions_scenario_equipment_revisions_stream: Array<Revisions_Scenario_Equipment_Revisions>;
  /** fetch data from the table: "revisions.scenario_equipment_xref_cables_journal" */
  revisions_scenario_equipment_xref_cables_journal: Array<Revisions_Scenario_Equipment_Xref_Cables_Journal>;
  /** fetch aggregated fields from the table: "revisions.scenario_equipment_xref_cables_journal" */
  revisions_scenario_equipment_xref_cables_journal_aggregate: Revisions_Scenario_Equipment_Xref_Cables_Journal_Aggregate;
  /** fetch data from the table: "revisions.scenario_equipment_xref_cables_journal" using primary key columns */
  revisions_scenario_equipment_xref_cables_journal_by_pk?: Maybe<Revisions_Scenario_Equipment_Xref_Cables_Journal>;
  /** fetch data from the table in a streaming manner: "revisions.scenario_equipment_xref_cables_journal" */
  revisions_scenario_equipment_xref_cables_journal_stream: Array<Revisions_Scenario_Equipment_Xref_Cables_Journal>;
  /** fetch data from the table: "revisions.scenario_equipment_xref_cables_revisions" */
  revisions_scenario_equipment_xref_cables_revisions: Array<Revisions_Scenario_Equipment_Xref_Cables_Revisions>;
  /** fetch aggregated fields from the table: "revisions.scenario_equipment_xref_cables_revisions" */
  revisions_scenario_equipment_xref_cables_revisions_aggregate: Revisions_Scenario_Equipment_Xref_Cables_Revisions_Aggregate;
  /** fetch data from the table: "revisions.scenario_equipment_xref_cables_revisions" using primary key columns */
  revisions_scenario_equipment_xref_cables_revisions_by_pk?: Maybe<Revisions_Scenario_Equipment_Xref_Cables_Revisions>;
  /** fetch data from the table in a streaming manner: "revisions.scenario_equipment_xref_cables_revisions" */
  revisions_scenario_equipment_xref_cables_revisions_stream: Array<Revisions_Scenario_Equipment_Xref_Cables_Revisions>;
  /** fetch data from the table: "revisions.scenario_equipment_xref_housings_journal" */
  revisions_scenario_equipment_xref_housings_journal: Array<Revisions_Scenario_Equipment_Xref_Housings_Journal>;
  /** fetch aggregated fields from the table: "revisions.scenario_equipment_xref_housings_journal" */
  revisions_scenario_equipment_xref_housings_journal_aggregate: Revisions_Scenario_Equipment_Xref_Housings_Journal_Aggregate;
  /** fetch data from the table: "revisions.scenario_equipment_xref_housings_journal" using primary key columns */
  revisions_scenario_equipment_xref_housings_journal_by_pk?: Maybe<Revisions_Scenario_Equipment_Xref_Housings_Journal>;
  /** fetch data from the table in a streaming manner: "revisions.scenario_equipment_xref_housings_journal" */
  revisions_scenario_equipment_xref_housings_journal_stream: Array<Revisions_Scenario_Equipment_Xref_Housings_Journal>;
  /** fetch data from the table: "revisions.scenario_equipment_xref_housings_revisions" */
  revisions_scenario_equipment_xref_housings_revisions: Array<Revisions_Scenario_Equipment_Xref_Housings_Revisions>;
  /** fetch aggregated fields from the table: "revisions.scenario_equipment_xref_housings_revisions" */
  revisions_scenario_equipment_xref_housings_revisions_aggregate: Revisions_Scenario_Equipment_Xref_Housings_Revisions_Aggregate;
  /** fetch data from the table: "revisions.scenario_equipment_xref_housings_revisions" using primary key columns */
  revisions_scenario_equipment_xref_housings_revisions_by_pk?: Maybe<Revisions_Scenario_Equipment_Xref_Housings_Revisions>;
  /** fetch data from the table in a streaming manner: "revisions.scenario_equipment_xref_housings_revisions" */
  revisions_scenario_equipment_xref_housings_revisions_stream: Array<Revisions_Scenario_Equipment_Xref_Housings_Revisions>;
  /** fetch data from the table: "revisions.scenario_equipment_xref_intakes_journal" */
  revisions_scenario_equipment_xref_intakes_journal: Array<Revisions_Scenario_Equipment_Xref_Intakes_Journal>;
  /** fetch aggregated fields from the table: "revisions.scenario_equipment_xref_intakes_journal" */
  revisions_scenario_equipment_xref_intakes_journal_aggregate: Revisions_Scenario_Equipment_Xref_Intakes_Journal_Aggregate;
  /** fetch data from the table: "revisions.scenario_equipment_xref_intakes_journal" using primary key columns */
  revisions_scenario_equipment_xref_intakes_journal_by_pk?: Maybe<Revisions_Scenario_Equipment_Xref_Intakes_Journal>;
  /** fetch data from the table in a streaming manner: "revisions.scenario_equipment_xref_intakes_journal" */
  revisions_scenario_equipment_xref_intakes_journal_stream: Array<Revisions_Scenario_Equipment_Xref_Intakes_Journal>;
  /** fetch data from the table: "revisions.scenario_equipment_xref_intakes_revisions" */
  revisions_scenario_equipment_xref_intakes_revisions: Array<Revisions_Scenario_Equipment_Xref_Intakes_Revisions>;
  /** fetch aggregated fields from the table: "revisions.scenario_equipment_xref_intakes_revisions" */
  revisions_scenario_equipment_xref_intakes_revisions_aggregate: Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Aggregate;
  /** fetch data from the table: "revisions.scenario_equipment_xref_intakes_revisions" using primary key columns */
  revisions_scenario_equipment_xref_intakes_revisions_by_pk?: Maybe<Revisions_Scenario_Equipment_Xref_Intakes_Revisions>;
  /** fetch data from the table in a streaming manner: "revisions.scenario_equipment_xref_intakes_revisions" */
  revisions_scenario_equipment_xref_intakes_revisions_stream: Array<Revisions_Scenario_Equipment_Xref_Intakes_Revisions>;
  /** fetch data from the table: "revisions.scenario_equipment_xref_pumps_journal" */
  revisions_scenario_equipment_xref_pumps_journal: Array<Revisions_Scenario_Equipment_Xref_Pumps_Journal>;
  /** fetch aggregated fields from the table: "revisions.scenario_equipment_xref_pumps_journal" */
  revisions_scenario_equipment_xref_pumps_journal_aggregate: Revisions_Scenario_Equipment_Xref_Pumps_Journal_Aggregate;
  /** fetch data from the table: "revisions.scenario_equipment_xref_pumps_journal" using primary key columns */
  revisions_scenario_equipment_xref_pumps_journal_by_pk?: Maybe<Revisions_Scenario_Equipment_Xref_Pumps_Journal>;
  /** fetch data from the table in a streaming manner: "revisions.scenario_equipment_xref_pumps_journal" */
  revisions_scenario_equipment_xref_pumps_journal_stream: Array<Revisions_Scenario_Equipment_Xref_Pumps_Journal>;
  /** fetch data from the table: "revisions.scenario_equipment_xref_pumps_revisions" */
  revisions_scenario_equipment_xref_pumps_revisions: Array<Revisions_Scenario_Equipment_Xref_Pumps_Revisions>;
  /** fetch aggregated fields from the table: "revisions.scenario_equipment_xref_pumps_revisions" */
  revisions_scenario_equipment_xref_pumps_revisions_aggregate: Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Aggregate;
  /** fetch data from the table: "revisions.scenario_equipment_xref_pumps_revisions" using primary key columns */
  revisions_scenario_equipment_xref_pumps_revisions_by_pk?: Maybe<Revisions_Scenario_Equipment_Xref_Pumps_Revisions>;
  /** fetch data from the table in a streaming manner: "revisions.scenario_equipment_xref_pumps_revisions" */
  revisions_scenario_equipment_xref_pumps_revisions_stream: Array<Revisions_Scenario_Equipment_Xref_Pumps_Revisions>;
  /** fetch data from the table: "revisions.scenario_equipment_xref_seals_journal" */
  revisions_scenario_equipment_xref_seals_journal: Array<Revisions_Scenario_Equipment_Xref_Seals_Journal>;
  /** fetch aggregated fields from the table: "revisions.scenario_equipment_xref_seals_journal" */
  revisions_scenario_equipment_xref_seals_journal_aggregate: Revisions_Scenario_Equipment_Xref_Seals_Journal_Aggregate;
  /** fetch data from the table: "revisions.scenario_equipment_xref_seals_journal" using primary key columns */
  revisions_scenario_equipment_xref_seals_journal_by_pk?: Maybe<Revisions_Scenario_Equipment_Xref_Seals_Journal>;
  /** fetch data from the table in a streaming manner: "revisions.scenario_equipment_xref_seals_journal" */
  revisions_scenario_equipment_xref_seals_journal_stream: Array<Revisions_Scenario_Equipment_Xref_Seals_Journal>;
  /** fetch data from the table: "revisions.scenario_equipment_xref_seals_revisions" */
  revisions_scenario_equipment_xref_seals_revisions: Array<Revisions_Scenario_Equipment_Xref_Seals_Revisions>;
  /** fetch aggregated fields from the table: "revisions.scenario_equipment_xref_seals_revisions" */
  revisions_scenario_equipment_xref_seals_revisions_aggregate: Revisions_Scenario_Equipment_Xref_Seals_Revisions_Aggregate;
  /** fetch data from the table: "revisions.scenario_equipment_xref_seals_revisions" using primary key columns */
  revisions_scenario_equipment_xref_seals_revisions_by_pk?: Maybe<Revisions_Scenario_Equipment_Xref_Seals_Revisions>;
  /** fetch data from the table in a streaming manner: "revisions.scenario_equipment_xref_seals_revisions" */
  revisions_scenario_equipment_xref_seals_revisions_stream: Array<Revisions_Scenario_Equipment_Xref_Seals_Revisions>;
  /** fetch data from the table: "revisions.scenario_parameters_journal" */
  revisions_scenario_parameters_journal: Array<Revisions_Scenario_Parameters_Journal>;
  /** fetch aggregated fields from the table: "revisions.scenario_parameters_journal" */
  revisions_scenario_parameters_journal_aggregate: Revisions_Scenario_Parameters_Journal_Aggregate;
  /** fetch data from the table: "revisions.scenario_parameters_journal" using primary key columns */
  revisions_scenario_parameters_journal_by_pk?: Maybe<Revisions_Scenario_Parameters_Journal>;
  /** fetch data from the table in a streaming manner: "revisions.scenario_parameters_journal" */
  revisions_scenario_parameters_journal_stream: Array<Revisions_Scenario_Parameters_Journal>;
  /** fetch data from the table: "revisions.scenario_parameters_revisions" */
  revisions_scenario_parameters_revisions: Array<Revisions_Scenario_Parameters_Revisions>;
  /** fetch aggregated fields from the table: "revisions.scenario_parameters_revisions" */
  revisions_scenario_parameters_revisions_aggregate: Revisions_Scenario_Parameters_Revisions_Aggregate;
  /** fetch data from the table: "revisions.scenario_parameters_revisions" using primary key columns */
  revisions_scenario_parameters_revisions_by_pk?: Maybe<Revisions_Scenario_Parameters_Revisions>;
  /** fetch data from the table in a streaming manner: "revisions.scenario_parameters_revisions" */
  revisions_scenario_parameters_revisions_stream: Array<Revisions_Scenario_Parameters_Revisions>;
  /** fetch data from the table: "revisions.scenario_well_properties_journal" */
  revisions_scenario_well_properties_journal: Array<Revisions_Scenario_Well_Properties_Journal>;
  /** fetch aggregated fields from the table: "revisions.scenario_well_properties_journal" */
  revisions_scenario_well_properties_journal_aggregate: Revisions_Scenario_Well_Properties_Journal_Aggregate;
  /** fetch data from the table: "revisions.scenario_well_properties_journal" using primary key columns */
  revisions_scenario_well_properties_journal_by_pk?: Maybe<Revisions_Scenario_Well_Properties_Journal>;
  /** fetch data from the table in a streaming manner: "revisions.scenario_well_properties_journal" */
  revisions_scenario_well_properties_journal_stream: Array<Revisions_Scenario_Well_Properties_Journal>;
  /** fetch data from the table: "revisions.scenario_well_properties_revisions" */
  revisions_scenario_well_properties_revisions: Array<Revisions_Scenario_Well_Properties_Revisions>;
  /** fetch aggregated fields from the table: "revisions.scenario_well_properties_revisions" */
  revisions_scenario_well_properties_revisions_aggregate: Revisions_Scenario_Well_Properties_Revisions_Aggregate;
  /** fetch data from the table: "revisions.scenario_well_properties_revisions" using primary key columns */
  revisions_scenario_well_properties_revisions_by_pk?: Maybe<Revisions_Scenario_Well_Properties_Revisions>;
  /** fetch data from the table in a streaming manner: "revisions.scenario_well_properties_revisions" */
  revisions_scenario_well_properties_revisions_stream: Array<Revisions_Scenario_Well_Properties_Revisions>;
  /** fetch data from the table: "revisions.scenarios_journal" */
  revisions_scenarios_journal: Array<Revisions_Scenarios_Journal>;
  /** fetch aggregated fields from the table: "revisions.scenarios_journal" */
  revisions_scenarios_journal_aggregate: Revisions_Scenarios_Journal_Aggregate;
  /** fetch data from the table: "revisions.scenarios_journal" using primary key columns */
  revisions_scenarios_journal_by_pk?: Maybe<Revisions_Scenarios_Journal>;
  /** fetch data from the table in a streaming manner: "revisions.scenarios_journal" */
  revisions_scenarios_journal_stream: Array<Revisions_Scenarios_Journal>;
  /** fetch data from the table: "revisions.scenarios_revisions" */
  revisions_scenarios_revisions: Array<Revisions_Scenarios_Revisions>;
  /** fetch aggregated fields from the table: "revisions.scenarios_revisions" */
  revisions_scenarios_revisions_aggregate: Revisions_Scenarios_Revisions_Aggregate;
  /** fetch data from the table: "revisions.scenarios_revisions" using primary key columns */
  revisions_scenarios_revisions_by_pk?: Maybe<Revisions_Scenarios_Revisions>;
  /** fetch data from the table in a streaming manner: "revisions.scenarios_revisions" */
  revisions_scenarios_revisions_stream: Array<Revisions_Scenarios_Revisions>;
  /** fetch data from the table: "revisions.sizings_journal" */
  revisions_sizings_journal: Array<Revisions_Sizings_Journal>;
  /** fetch aggregated fields from the table: "revisions.sizings_journal" */
  revisions_sizings_journal_aggregate: Revisions_Sizings_Journal_Aggregate;
  /** fetch data from the table: "revisions.sizings_journal" using primary key columns */
  revisions_sizings_journal_by_pk?: Maybe<Revisions_Sizings_Journal>;
  /** fetch data from the table in a streaming manner: "revisions.sizings_journal" */
  revisions_sizings_journal_stream: Array<Revisions_Sizings_Journal>;
  /** fetch data from the table: "revisions.sizings_revisions" */
  revisions_sizings_revisions: Array<Revisions_Sizings_Revisions>;
  /** fetch aggregated fields from the table: "revisions.sizings_revisions" */
  revisions_sizings_revisions_aggregate: Revisions_Sizings_Revisions_Aggregate;
  /** fetch data from the table: "revisions.sizings_revisions" using primary key columns */
  revisions_sizings_revisions_by_pk?: Maybe<Revisions_Sizings_Revisions>;
  /** fetch data from the table in a streaming manner: "revisions.sizings_revisions" */
  revisions_sizings_revisions_stream: Array<Revisions_Sizings_Revisions>;
  /** fetch data from the table: "saturated_oil_options" */
  saturated_oil_options: Array<Saturated_Oil_Options>;
  /** fetch aggregated fields from the table: "saturated_oil_options" */
  saturated_oil_options_aggregate: Saturated_Oil_Options_Aggregate;
  /** fetch data from the table: "saturated_oil_options" using primary key columns */
  saturated_oil_options_by_pk?: Maybe<Saturated_Oil_Options>;
  /** fetch data from the table in a streaming manner: "saturated_oil_options" */
  saturated_oil_options_stream: Array<Saturated_Oil_Options>;
  /** fetch data from the table: "sc_equip_xref_downhole_ytool_bypass_tubings" */
  sc_equip_xref_downhole_ytool_bypass_tubings: Array<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings>;
  /** fetch aggregated fields from the table: "sc_equip_xref_downhole_ytool_bypass_tubings" */
  sc_equip_xref_downhole_ytool_bypass_tubings_aggregate: Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Aggregate;
  /** fetch data from the table in a streaming manner: "sc_equip_xref_downhole_ytool_bypass_tubings" */
  sc_equip_xref_downhole_ytool_bypass_tubings_stream: Array<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings>;
  /** fetch data from the table: "sc_equip_xref_downhole_ytool_equip_tubings" */
  sc_equip_xref_downhole_ytool_equip_tubings: Array<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings>;
  /** fetch aggregated fields from the table: "sc_equip_xref_downhole_ytool_equip_tubings" */
  sc_equip_xref_downhole_ytool_equip_tubings_aggregate: Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Aggregate;
  /** fetch data from the table in a streaming manner: "sc_equip_xref_downhole_ytool_equip_tubings" */
  sc_equip_xref_downhole_ytool_equip_tubings_stream: Array<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings>;
  /** fetch data from the table: "sc_equip_xref_uphole_ytool_bypass_tubings" */
  sc_equip_xref_uphole_ytool_bypass_tubings: Array<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings>;
  /** fetch aggregated fields from the table: "sc_equip_xref_uphole_ytool_bypass_tubings" */
  sc_equip_xref_uphole_ytool_bypass_tubings_aggregate: Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Aggregate;
  /** fetch data from the table in a streaming manner: "sc_equip_xref_uphole_ytool_bypass_tubings" */
  sc_equip_xref_uphole_ytool_bypass_tubings_stream: Array<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings>;
  /** fetch data from the table: "sc_equip_xref_uphole_ytool_equip_tubings" */
  sc_equip_xref_uphole_ytool_equip_tubings: Array<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings>;
  /** fetch aggregated fields from the table: "sc_equip_xref_uphole_ytool_equip_tubings" */
  sc_equip_xref_uphole_ytool_equip_tubings_aggregate: Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Aggregate;
  /** fetch data from the table in a streaming manner: "sc_equip_xref_uphole_ytool_equip_tubings" */
  sc_equip_xref_uphole_ytool_equip_tubings_stream: Array<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings>;
  /** fetch data from the table: "scenario_correlations" */
  scenario_correlations: Array<Scenario_Correlations>;
  /** fetch aggregated fields from the table: "scenario_correlations" */
  scenario_correlations_aggregate: Scenario_Correlations_Aggregate;
  /** fetch data from the table in a streaming manner: "scenario_correlations" */
  scenario_correlations_stream: Array<Scenario_Correlations>;
  /** fetch data from the table: "scenario_equipment" */
  scenario_equipment: Array<Scenario_Equipment>;
  /** fetch aggregated fields from the table: "scenario_equipment" */
  scenario_equipment_aggregate: Scenario_Equipment_Aggregate;
  /** fetch data from the table in a streaming manner: "scenario_equipment" */
  scenario_equipment_stream: Array<Scenario_Equipment>;
  /** fetch data from the table: "scenario_equipment_xref_cables" */
  scenario_equipment_xref_cables: Array<Scenario_Equipment_Xref_Cables>;
  /** fetch aggregated fields from the table: "scenario_equipment_xref_cables" */
  scenario_equipment_xref_cables_aggregate: Scenario_Equipment_Xref_Cables_Aggregate;
  /** fetch data from the table in a streaming manner: "scenario_equipment_xref_cables" */
  scenario_equipment_xref_cables_stream: Array<Scenario_Equipment_Xref_Cables>;
  /** fetch data from the table: "scenario_equipment_xref_housings" */
  scenario_equipment_xref_housings: Array<Scenario_Equipment_Xref_Housings>;
  /** fetch aggregated fields from the table: "scenario_equipment_xref_housings" */
  scenario_equipment_xref_housings_aggregate: Scenario_Equipment_Xref_Housings_Aggregate;
  /** fetch data from the table in a streaming manner: "scenario_equipment_xref_housings" */
  scenario_equipment_xref_housings_stream: Array<Scenario_Equipment_Xref_Housings>;
  /** fetch data from the table: "scenario_equipment_xref_intakes" */
  scenario_equipment_xref_intakes: Array<Scenario_Equipment_Xref_Intakes>;
  /** fetch aggregated fields from the table: "scenario_equipment_xref_intakes" */
  scenario_equipment_xref_intakes_aggregate: Scenario_Equipment_Xref_Intakes_Aggregate;
  /** fetch data from the table in a streaming manner: "scenario_equipment_xref_intakes" */
  scenario_equipment_xref_intakes_stream: Array<Scenario_Equipment_Xref_Intakes>;
  /** fetch data from the table: "scenario_equipment_xref_pumps" */
  scenario_equipment_xref_pumps: Array<Scenario_Equipment_Xref_Pumps>;
  /** fetch aggregated fields from the table: "scenario_equipment_xref_pumps" */
  scenario_equipment_xref_pumps_aggregate: Scenario_Equipment_Xref_Pumps_Aggregate;
  /** fetch data from the table in a streaming manner: "scenario_equipment_xref_pumps" */
  scenario_equipment_xref_pumps_stream: Array<Scenario_Equipment_Xref_Pumps>;
  /** fetch data from the table: "scenario_equipment_xref_seals" */
  scenario_equipment_xref_seals: Array<Scenario_Equipment_Xref_Seals>;
  /** fetch aggregated fields from the table: "scenario_equipment_xref_seals" */
  scenario_equipment_xref_seals_aggregate: Scenario_Equipment_Xref_Seals_Aggregate;
  /** fetch data from the table in a streaming manner: "scenario_equipment_xref_seals" */
  scenario_equipment_xref_seals_stream: Array<Scenario_Equipment_Xref_Seals>;
  /** fetch data from the table: "scenario_parameters" */
  scenario_parameters: Array<Scenario_Parameters>;
  /** fetch aggregated fields from the table: "scenario_parameters" */
  scenario_parameters_aggregate: Scenario_Parameters_Aggregate;
  /** fetch data from the table in a streaming manner: "scenario_parameters" */
  scenario_parameters_stream: Array<Scenario_Parameters>;
  /** fetch data from the table: "scenario_reasons" */
  scenario_reasons: Array<Scenario_Reasons>;
  /** fetch aggregated fields from the table: "scenario_reasons" */
  scenario_reasons_aggregate: Scenario_Reasons_Aggregate;
  /** fetch data from the table: "scenario_reasons" using primary key columns */
  scenario_reasons_by_pk?: Maybe<Scenario_Reasons>;
  /** fetch data from the table in a streaming manner: "scenario_reasons" */
  scenario_reasons_stream: Array<Scenario_Reasons>;
  /** fetch data from the table: "scenario_well_properties" */
  scenario_well_properties: Array<Scenario_Well_Properties>;
  /** fetch aggregated fields from the table: "scenario_well_properties" */
  scenario_well_properties_aggregate: Scenario_Well_Properties_Aggregate;
  /** fetch data from the table in a streaming manner: "scenario_well_properties" */
  scenario_well_properties_stream: Array<Scenario_Well_Properties>;
  /** An array relationship */
  scenarios: Array<Scenarios>;
  /** An aggregate relationship */
  scenarios_aggregate: Scenarios_Aggregate;
  /** fetch data from the table in a streaming manner: "scenarios" */
  scenarios_stream: Array<Scenarios>;
  /** fetch data from the table: "seal_motor_oil" */
  seal_motor_oil: Array<Seal_Motor_Oil>;
  /** fetch aggregated fields from the table: "seal_motor_oil" */
  seal_motor_oil_aggregate: Seal_Motor_Oil_Aggregate;
  /** fetch data from the table: "seal_motor_oil" using primary key columns */
  seal_motor_oil_by_pk?: Maybe<Seal_Motor_Oil>;
  /** fetch data from the table in a streaming manner: "seal_motor_oil" */
  seal_motor_oil_stream: Array<Seal_Motor_Oil>;
  /** An array relationship */
  seals: Array<Seals>;
  /** An aggregate relationship */
  seals_aggregate: Seals_Aggregate;
  /** fetch data from the table: "seals" using primary key columns */
  seals_by_pk?: Maybe<Seals>;
  /** fetch data from the table in a streaming manner: "seals" */
  seals_stream: Array<Seals>;
  /** An array relationship */
  sensors: Array<Sensors>;
  /** An aggregate relationship */
  sensors_aggregate: Sensors_Aggregate;
  /** fetch data from the table: "sensors" using primary key columns */
  sensors_by_pk?: Maybe<Sensors>;
  /** fetch data from the table in a streaming manner: "sensors" */
  sensors_stream: Array<Sensors>;
  /** fetch data from the table: "sizing_dispositions" */
  sizing_dispositions: Array<Sizing_Dispositions>;
  /** fetch aggregated fields from the table: "sizing_dispositions" */
  sizing_dispositions_aggregate: Sizing_Dispositions_Aggregate;
  /** fetch data from the table: "sizing_dispositions" using primary key columns */
  sizing_dispositions_by_pk?: Maybe<Sizing_Dispositions>;
  /** fetch data from the table in a streaming manner: "sizing_dispositions" */
  sizing_dispositions_stream: Array<Sizing_Dispositions>;
  /** An array relationship */
  sizing_imports: Array<Sizing_Imports>;
  /** An aggregate relationship */
  sizing_imports_aggregate: Sizing_Imports_Aggregate;
  /** fetch data from the table: "sizing_imports" using primary key columns */
  sizing_imports_by_pk?: Maybe<Sizing_Imports>;
  /** fetch data from the table in a streaming manner: "sizing_imports" */
  sizing_imports_stream: Array<Sizing_Imports>;
  /** fetch data from the table: "sizing_pumping_type" */
  sizing_pumping_type: Array<Sizing_Pumping_Type>;
  /** fetch aggregated fields from the table: "sizing_pumping_type" */
  sizing_pumping_type_aggregate: Sizing_Pumping_Type_Aggregate;
  /** fetch data from the table: "sizing_pumping_type" using primary key columns */
  sizing_pumping_type_by_pk?: Maybe<Sizing_Pumping_Type>;
  /** fetch data from the table in a streaming manner: "sizing_pumping_type" */
  sizing_pumping_type_stream: Array<Sizing_Pumping_Type>;
  /** An array relationship */
  sizings: Array<Sizings>;
  /** An aggregate relationship */
  sizings_aggregate: Sizings_Aggregate;
  /** fetch data from the table in a streaming manner: "sizings" */
  sizings_stream: Array<Sizings>;
  /** fetch data from the table: "solution_gas_oil_ratio_options" */
  solution_gas_oil_ratio_options: Array<Solution_Gas_Oil_Ratio_Options>;
  /** fetch aggregated fields from the table: "solution_gas_oil_ratio_options" */
  solution_gas_oil_ratio_options_aggregate: Solution_Gas_Oil_Ratio_Options_Aggregate;
  /** fetch data from the table: "solution_gas_oil_ratio_options" using primary key columns */
  solution_gas_oil_ratio_options_by_pk?: Maybe<Solution_Gas_Oil_Ratio_Options>;
  /** fetch data from the table in a streaming manner: "solution_gas_oil_ratio_options" */
  solution_gas_oil_ratio_options_stream: Array<Solution_Gas_Oil_Ratio_Options>;
  /** fetch data from the table: "status" */
  status: Array<Status>;
  /** fetch aggregated fields from the table: "status" */
  status_aggregate: Status_Aggregate;
  /** fetch data from the table in a streaming manner: "status" */
  status_stream: Array<Status>;
  /** An array relationship */
  step_down_transformers: Array<Step_Down_Transformers>;
  /** An aggregate relationship */
  step_down_transformers_aggregate: Step_Down_Transformers_Aggregate;
  /** fetch data from the table: "step_down_transformers" using primary key columns */
  step_down_transformers_by_pk?: Maybe<Step_Down_Transformers>;
  /** fetch data from the table in a streaming manner: "step_down_transformers" */
  step_down_transformers_stream: Array<Step_Down_Transformers>;
  /** An array relationship */
  step_up_transformers: Array<Step_Up_Transformers>;
  /** An aggregate relationship */
  step_up_transformers_aggregate: Step_Up_Transformers_Aggregate;
  /** fetch data from the table: "step_up_transformers" using primary key columns */
  step_up_transformers_by_pk?: Maybe<Step_Up_Transformers>;
  /** fetch data from the table in a streaming manner: "step_up_transformers" */
  step_up_transformers_stream: Array<Step_Up_Transformers>;
  /** An array relationship */
  switchboards: Array<Switchboards>;
  /** An aggregate relationship */
  switchboards_aggregate: Switchboards_Aggregate;
  /** fetch data from the table: "switchboards" using primary key columns */
  switchboards_by_pk?: Maybe<Switchboards>;
  /** fetch data from the table in a streaming manner: "switchboards" */
  switchboards_stream: Array<Switchboards>;
  /** fetch data from the table: "tubing_flow_options" */
  tubing_flow_options: Array<Tubing_Flow_Options>;
  /** fetch aggregated fields from the table: "tubing_flow_options" */
  tubing_flow_options_aggregate: Tubing_Flow_Options_Aggregate;
  /** fetch data from the table: "tubing_flow_options" using primary key columns */
  tubing_flow_options_by_pk?: Maybe<Tubing_Flow_Options>;
  /** fetch data from the table in a streaming manner: "tubing_flow_options" */
  tubing_flow_options_stream: Array<Tubing_Flow_Options>;
  /** An array relationship */
  tubings: Array<Tubings>;
  /** An aggregate relationship */
  tubings_aggregate: Tubings_Aggregate;
  /** fetch data from the table: "tubings" using primary key columns */
  tubings_by_pk?: Maybe<Tubings>;
  /** fetch data from the table in a streaming manner: "tubings" */
  tubings_stream: Array<Tubings>;
  /** fetch data from the table: "tubings_type" */
  tubings_type: Array<Tubings_Type>;
  /** fetch aggregated fields from the table: "tubings_type" */
  tubings_type_aggregate: Tubings_Type_Aggregate;
  /** fetch data from the table: "tubings_type" using primary key columns */
  tubings_type_by_pk?: Maybe<Tubings_Type>;
  /** fetch data from the table in a streaming manner: "tubings_type" */
  tubings_type_stream: Array<Tubings_Type>;
  /** fetch data from the table: "under_saturated_oil_options" */
  under_saturated_oil_options: Array<Under_Saturated_Oil_Options>;
  /** fetch aggregated fields from the table: "under_saturated_oil_options" */
  under_saturated_oil_options_aggregate: Under_Saturated_Oil_Options_Aggregate;
  /** fetch data from the table: "under_saturated_oil_options" using primary key columns */
  under_saturated_oil_options_by_pk?: Maybe<Under_Saturated_Oil_Options>;
  /** fetch data from the table in a streaming manner: "under_saturated_oil_options" */
  under_saturated_oil_options_stream: Array<Under_Saturated_Oil_Options>;
  /** fetch data from the table: "user_eula_acceptance" */
  user_eula_acceptance: Array<User_Eula_Acceptance>;
  /** fetch aggregated fields from the table: "user_eula_acceptance" */
  user_eula_acceptance_aggregate: User_Eula_Acceptance_Aggregate;
  /** fetch data from the table: "user_eula_acceptance" using primary key columns */
  user_eula_acceptance_by_pk?: Maybe<User_Eula_Acceptance>;
  /** fetch data from the table in a streaming manner: "user_eula_acceptance" */
  user_eula_acceptance_stream: Array<User_Eula_Acceptance>;
  /** fetch data from the table: "users" */
  users: Array<Users>;
  /** fetch aggregated fields from the table: "users" */
  users_aggregate: Users_Aggregate;
  /** fetch data from the table: "users" using primary key columns */
  users_by_pk?: Maybe<Users>;
  /** fetch data from the table in a streaming manner: "users" */
  users_stream: Array<Users>;
  /** An array relationship */
  variable_speed_drives: Array<Variable_Speed_Drives>;
  /** An aggregate relationship */
  variable_speed_drives_aggregate: Variable_Speed_Drives_Aggregate;
  /** fetch data from the table: "variable_speed_drives" using primary key columns */
  variable_speed_drives_by_pk?: Maybe<Variable_Speed_Drives>;
  /** fetch data from the table in a streaming manner: "variable_speed_drives" */
  variable_speed_drives_stream: Array<Variable_Speed_Drives>;
  /** fetch data from the table: "water_density_options" */
  water_density_options: Array<Water_Density_Options>;
  /** fetch aggregated fields from the table: "water_density_options" */
  water_density_options_aggregate: Water_Density_Options_Aggregate;
  /** fetch data from the table: "water_density_options" using primary key columns */
  water_density_options_by_pk?: Maybe<Water_Density_Options>;
  /** fetch data from the table in a streaming manner: "water_density_options" */
  water_density_options_stream: Array<Water_Density_Options>;
  /** fetch data from the table: "water_solution_gas_options" */
  water_solution_gas_options: Array<Water_Solution_Gas_Options>;
  /** fetch aggregated fields from the table: "water_solution_gas_options" */
  water_solution_gas_options_aggregate: Water_Solution_Gas_Options_Aggregate;
  /** fetch data from the table: "water_solution_gas_options" using primary key columns */
  water_solution_gas_options_by_pk?: Maybe<Water_Solution_Gas_Options>;
  /** fetch data from the table in a streaming manner: "water_solution_gas_options" */
  water_solution_gas_options_stream: Array<Water_Solution_Gas_Options>;
  /** fetch data from the table: "water_viscosity_options" */
  water_viscosity_options: Array<Water_Viscosity_Options>;
  /** fetch aggregated fields from the table: "water_viscosity_options" */
  water_viscosity_options_aggregate: Water_Viscosity_Options_Aggregate;
  /** fetch data from the table: "water_viscosity_options" using primary key columns */
  water_viscosity_options_by_pk?: Maybe<Water_Viscosity_Options>;
  /** fetch data from the table in a streaming manner: "water_viscosity_options" */
  water_viscosity_options_stream: Array<Water_Viscosity_Options>;
  /** fetch data from the table: "water_volume_factor_options" */
  water_volume_factor_options: Array<Water_Volume_Factor_Options>;
  /** fetch aggregated fields from the table: "water_volume_factor_options" */
  water_volume_factor_options_aggregate: Water_Volume_Factor_Options_Aggregate;
  /** fetch data from the table: "water_volume_factor_options" using primary key columns */
  water_volume_factor_options_by_pk?: Maybe<Water_Volume_Factor_Options>;
  /** fetch data from the table in a streaming manner: "water_volume_factor_options" */
  water_volume_factor_options_stream: Array<Water_Volume_Factor_Options>;
  /** fetch data from the table: "well_gas_type_options" */
  well_gas_type_options: Array<Well_Gas_Type_Options>;
  /** fetch aggregated fields from the table: "well_gas_type_options" */
  well_gas_type_options_aggregate: Well_Gas_Type_Options_Aggregate;
  /** fetch data from the table: "well_gas_type_options" using primary key columns */
  well_gas_type_options_by_pk?: Maybe<Well_Gas_Type_Options>;
  /** fetch data from the table in a streaming manner: "well_gas_type_options" */
  well_gas_type_options_stream: Array<Well_Gas_Type_Options>;
  /** fetch data from the table: "well_test_gas_input_options" */
  well_test_gas_input_options: Array<Well_Test_Gas_Input_Options>;
  /** fetch aggregated fields from the table: "well_test_gas_input_options" */
  well_test_gas_input_options_aggregate: Well_Test_Gas_Input_Options_Aggregate;
  /** fetch data from the table: "well_test_gas_input_options" using primary key columns */
  well_test_gas_input_options_by_pk?: Maybe<Well_Test_Gas_Input_Options>;
  /** fetch data from the table in a streaming manner: "well_test_gas_input_options" */
  well_test_gas_input_options_stream: Array<Well_Test_Gas_Input_Options>;
  /** fetch data from the table: "well_test_liquid_input_options" */
  well_test_liquid_input_options: Array<Well_Test_Liquid_Input_Options>;
  /** fetch aggregated fields from the table: "well_test_liquid_input_options" */
  well_test_liquid_input_options_aggregate: Well_Test_Liquid_Input_Options_Aggregate;
  /** fetch data from the table: "well_test_liquid_input_options" using primary key columns */
  well_test_liquid_input_options_by_pk?: Maybe<Well_Test_Liquid_Input_Options>;
  /** fetch data from the table in a streaming manner: "well_test_liquid_input_options" */
  well_test_liquid_input_options_stream: Array<Well_Test_Liquid_Input_Options>;
  /** fetch data from the table: "well_test_pressure_input_options" */
  well_test_pressure_input_options: Array<Well_Test_Pressure_Input_Options>;
  /** fetch aggregated fields from the table: "well_test_pressure_input_options" */
  well_test_pressure_input_options_aggregate: Well_Test_Pressure_Input_Options_Aggregate;
  /** fetch data from the table: "well_test_pressure_input_options" using primary key columns */
  well_test_pressure_input_options_by_pk?: Maybe<Well_Test_Pressure_Input_Options>;
  /** fetch data from the table in a streaming manner: "well_test_pressure_input_options" */
  well_test_pressure_input_options_stream: Array<Well_Test_Pressure_Input_Options>;
  /** An array relationship */
  wells: Array<Wells>;
  /** An aggregate relationship */
  wells_aggregate: Wells_Aggregate;
  /** fetch data from the table: "wells" using primary key columns */
  wells_by_pk?: Maybe<Wells>;
  /** fetch data from the table in a streaming manner: "wells" */
  wells_stream: Array<Wells>;
  /** fetch data from the table: "y_tools" */
  y_tools: Array<Y_Tools>;
  /** fetch aggregated fields from the table: "y_tools" */
  y_tools_aggregate: Y_Tools_Aggregate;
  /** fetch data from the table: "y_tools" using primary key columns */
  y_tools_by_pk?: Maybe<Y_Tools>;
  /** fetch data from the table in a streaming manner: "y_tools" */
  y_tools_stream: Array<Y_Tools>;
};


export type Subscription_RootBolt_On_DischargesArgs = {
  distinct_on?: InputMaybe<Array<Bolt_On_Discharges_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Bolt_On_Discharges_Order_By>>;
  where?: InputMaybe<Bolt_On_Discharges_Bool_Exp>;
};


export type Subscription_RootBolt_On_Discharges_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Bolt_On_Discharges_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Bolt_On_Discharges_Order_By>>;
  where?: InputMaybe<Bolt_On_Discharges_Bool_Exp>;
};


export type Subscription_RootBolt_On_Discharges_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootBolt_On_Discharges_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Bolt_On_Discharges_Stream_Cursor_Input>>;
  where?: InputMaybe<Bolt_On_Discharges_Bool_Exp>;
};


export type Subscription_RootBubble_Point_OptionsArgs = {
  distinct_on?: InputMaybe<Array<Bubble_Point_Options_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Bubble_Point_Options_Order_By>>;
  where?: InputMaybe<Bubble_Point_Options_Bool_Exp>;
};


export type Subscription_RootBubble_Point_Options_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Bubble_Point_Options_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Bubble_Point_Options_Order_By>>;
  where?: InputMaybe<Bubble_Point_Options_Bool_Exp>;
};


export type Subscription_RootBubble_Point_Options_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootBubble_Point_Options_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Bubble_Point_Options_Stream_Cursor_Input>>;
  where?: InputMaybe<Bubble_Point_Options_Bool_Exp>;
};


export type Subscription_RootCablesArgs = {
  distinct_on?: InputMaybe<Array<Cables_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cables_Order_By>>;
  where?: InputMaybe<Cables_Bool_Exp>;
};


export type Subscription_RootCables_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Cables_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cables_Order_By>>;
  where?: InputMaybe<Cables_Bool_Exp>;
};


export type Subscription_RootCables_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootCables_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Cables_Stream_Cursor_Input>>;
  where?: InputMaybe<Cables_Bool_Exp>;
};


export type Subscription_RootCasing_Flow_OptionsArgs = {
  distinct_on?: InputMaybe<Array<Casing_Flow_Options_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Casing_Flow_Options_Order_By>>;
  where?: InputMaybe<Casing_Flow_Options_Bool_Exp>;
};


export type Subscription_RootCasing_Flow_Options_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Casing_Flow_Options_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Casing_Flow_Options_Order_By>>;
  where?: InputMaybe<Casing_Flow_Options_Bool_Exp>;
};


export type Subscription_RootCasing_Flow_Options_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootCasing_Flow_Options_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Casing_Flow_Options_Stream_Cursor_Input>>;
  where?: InputMaybe<Casing_Flow_Options_Bool_Exp>;
};


export type Subscription_RootCasingsArgs = {
  distinct_on?: InputMaybe<Array<Casings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Casings_Order_By>>;
  where?: InputMaybe<Casings_Bool_Exp>;
};


export type Subscription_RootCasings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Casings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Casings_Order_By>>;
  where?: InputMaybe<Casings_Bool_Exp>;
};


export type Subscription_RootCasings_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootCasings_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Casings_Stream_Cursor_Input>>;
  where?: InputMaybe<Casings_Bool_Exp>;
};


export type Subscription_RootCasings_TypeArgs = {
  distinct_on?: InputMaybe<Array<Casings_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Casings_Type_Order_By>>;
  where?: InputMaybe<Casings_Type_Bool_Exp>;
};


export type Subscription_RootCasings_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Casings_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Casings_Type_Order_By>>;
  where?: InputMaybe<Casings_Type_Bool_Exp>;
};


export type Subscription_RootCasings_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootCasings_Type_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Casings_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Casings_Type_Bool_Exp>;
};


export type Subscription_RootCustomersArgs = {
  distinct_on?: InputMaybe<Array<Customers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customers_Order_By>>;
  where?: InputMaybe<Customers_Bool_Exp>;
};


export type Subscription_RootCustomers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customers_Order_By>>;
  where?: InputMaybe<Customers_Bool_Exp>;
};


export type Subscription_RootCustomers_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootCustomers_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Customers_Stream_Cursor_Input>>;
  where?: InputMaybe<Customers_Bool_Exp>;
};


export type Subscription_RootDead_Oil_OptionsArgs = {
  distinct_on?: InputMaybe<Array<Dead_Oil_Options_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Dead_Oil_Options_Order_By>>;
  where?: InputMaybe<Dead_Oil_Options_Bool_Exp>;
};


export type Subscription_RootDead_Oil_Options_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Dead_Oil_Options_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Dead_Oil_Options_Order_By>>;
  where?: InputMaybe<Dead_Oil_Options_Bool_Exp>;
};


export type Subscription_RootDead_Oil_Options_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootDead_Oil_Options_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Dead_Oil_Options_Stream_Cursor_Input>>;
  where?: InputMaybe<Dead_Oil_Options_Bool_Exp>;
};


export type Subscription_RootDeviation_SurveyArgs = {
  distinct_on?: InputMaybe<Array<Deviation_Survey_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Deviation_Survey_Order_By>>;
  where?: InputMaybe<Deviation_Survey_Bool_Exp>;
};


export type Subscription_RootDeviation_Survey_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Deviation_Survey_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Deviation_Survey_Order_By>>;
  where?: InputMaybe<Deviation_Survey_Bool_Exp>;
};


export type Subscription_RootDeviation_Survey_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootDeviation_Survey_Directional_DatasetArgs = {
  distinct_on?: InputMaybe<Array<Deviation_Survey_Directional_Dataset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Deviation_Survey_Directional_Dataset_Order_By>>;
  where?: InputMaybe<Deviation_Survey_Directional_Dataset_Bool_Exp>;
};


export type Subscription_RootDeviation_Survey_Directional_Dataset_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Deviation_Survey_Directional_Dataset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Deviation_Survey_Directional_Dataset_Order_By>>;
  where?: InputMaybe<Deviation_Survey_Directional_Dataset_Bool_Exp>;
};


export type Subscription_RootDeviation_Survey_Directional_Dataset_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootDeviation_Survey_Directional_Dataset_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Deviation_Survey_Directional_Dataset_Stream_Cursor_Input>>;
  where?: InputMaybe<Deviation_Survey_Directional_Dataset_Bool_Exp>;
};


export type Subscription_RootDeviation_Survey_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Deviation_Survey_Stream_Cursor_Input>>;
  where?: InputMaybe<Deviation_Survey_Bool_Exp>;
};


export type Subscription_RootDisplay_UnitsArgs = {
  distinct_on?: InputMaybe<Array<Display_Units_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Display_Units_Order_By>>;
  where?: InputMaybe<Display_Units_Bool_Exp>;
};


export type Subscription_RootDisplay_Units_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Display_Units_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Display_Units_Order_By>>;
  where?: InputMaybe<Display_Units_Bool_Exp>;
};


export type Subscription_RootDisplay_Units_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootDisplay_Units_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Display_Units_Stream_Cursor_Input>>;
  where?: InputMaybe<Display_Units_Bool_Exp>;
};


export type Subscription_RootEulaArgs = {
  distinct_on?: InputMaybe<Array<Eula_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eula_Order_By>>;
  where?: InputMaybe<Eula_Bool_Exp>;
};


export type Subscription_RootEula_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eula_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eula_Order_By>>;
  where?: InputMaybe<Eula_Bool_Exp>;
};


export type Subscription_RootEula_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootEula_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Eula_Stream_Cursor_Input>>;
  where?: InputMaybe<Eula_Bool_Exp>;
};


export type Subscription_RootFlow_ModelArgs = {
  distinct_on?: InputMaybe<Array<Flow_Model_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Flow_Model_Order_By>>;
  where?: InputMaybe<Flow_Model_Bool_Exp>;
};


export type Subscription_RootFlow_Model_ActiveArgs = {
  distinct_on?: InputMaybe<Array<Flow_Model_Active_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Flow_Model_Active_Order_By>>;
  where?: InputMaybe<Flow_Model_Active_Bool_Exp>;
};


export type Subscription_RootFlow_Model_Active_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Flow_Model_Active_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Flow_Model_Active_Order_By>>;
  where?: InputMaybe<Flow_Model_Active_Bool_Exp>;
};


export type Subscription_RootFlow_Model_Active_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Flow_Model_Active_Stream_Cursor_Input>>;
  where?: InputMaybe<Flow_Model_Active_Bool_Exp>;
};


export type Subscription_RootFlow_Model_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Flow_Model_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Flow_Model_Order_By>>;
  where?: InputMaybe<Flow_Model_Bool_Exp>;
};


export type Subscription_RootFlow_Model_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootFlow_Model_DeprecatedArgs = {
  distinct_on?: InputMaybe<Array<Flow_Model_Deprecated_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Flow_Model_Deprecated_Order_By>>;
  where?: InputMaybe<Flow_Model_Deprecated_Bool_Exp>;
};


export type Subscription_RootFlow_Model_Deprecated_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Flow_Model_Deprecated_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Flow_Model_Deprecated_Order_By>>;
  where?: InputMaybe<Flow_Model_Deprecated_Bool_Exp>;
};


export type Subscription_RootFlow_Model_Deprecated_By_PkArgs = {
  value: Flow_Model_Enum;
};


export type Subscription_RootFlow_Model_Deprecated_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Flow_Model_Deprecated_Stream_Cursor_Input>>;
  where?: InputMaybe<Flow_Model_Deprecated_Bool_Exp>;
};


export type Subscription_RootFlow_Model_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Flow_Model_Stream_Cursor_Input>>;
  where?: InputMaybe<Flow_Model_Bool_Exp>;
};


export type Subscription_RootFriction_Loss_OptionsArgs = {
  distinct_on?: InputMaybe<Array<Friction_Loss_Options_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Friction_Loss_Options_Order_By>>;
  where?: InputMaybe<Friction_Loss_Options_Bool_Exp>;
};


export type Subscription_RootFriction_Loss_Options_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Friction_Loss_Options_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Friction_Loss_Options_Order_By>>;
  where?: InputMaybe<Friction_Loss_Options_Bool_Exp>;
};


export type Subscription_RootFriction_Loss_Options_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootFriction_Loss_Options_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Friction_Loss_Options_Stream_Cursor_Input>>;
  where?: InputMaybe<Friction_Loss_Options_Bool_Exp>;
};


export type Subscription_RootGas_Compressibility_OptionsArgs = {
  distinct_on?: InputMaybe<Array<Gas_Compressibility_Options_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Gas_Compressibility_Options_Order_By>>;
  where?: InputMaybe<Gas_Compressibility_Options_Bool_Exp>;
};


export type Subscription_RootGas_Compressibility_Options_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Gas_Compressibility_Options_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Gas_Compressibility_Options_Order_By>>;
  where?: InputMaybe<Gas_Compressibility_Options_Bool_Exp>;
};


export type Subscription_RootGas_Compressibility_Options_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootGas_Compressibility_Options_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Gas_Compressibility_Options_Stream_Cursor_Input>>;
  where?: InputMaybe<Gas_Compressibility_Options_Bool_Exp>;
};


export type Subscription_RootGas_Viscosity_OptionsArgs = {
  distinct_on?: InputMaybe<Array<Gas_Viscosity_Options_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Gas_Viscosity_Options_Order_By>>;
  where?: InputMaybe<Gas_Viscosity_Options_Bool_Exp>;
};


export type Subscription_RootGas_Viscosity_Options_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Gas_Viscosity_Options_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Gas_Viscosity_Options_Order_By>>;
  where?: InputMaybe<Gas_Viscosity_Options_Bool_Exp>;
};


export type Subscription_RootGas_Viscosity_Options_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootGas_Viscosity_Options_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Gas_Viscosity_Options_Stream_Cursor_Input>>;
  where?: InputMaybe<Gas_Viscosity_Options_Bool_Exp>;
};


export type Subscription_RootHousingsArgs = {
  distinct_on?: InputMaybe<Array<Housings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Housings_Order_By>>;
  where?: InputMaybe<Housings_Bool_Exp>;
};


export type Subscription_RootHousings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Housings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Housings_Order_By>>;
  where?: InputMaybe<Housings_Bool_Exp>;
};


export type Subscription_RootHousings_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootHousings_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Housings_Stream_Cursor_Input>>;
  where?: InputMaybe<Housings_Bool_Exp>;
};


export type Subscription_RootHps_Liquid_TypeArgs = {
  distinct_on?: InputMaybe<Array<Hps_Liquid_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Hps_Liquid_Type_Order_By>>;
  where?: InputMaybe<Hps_Liquid_Type_Bool_Exp>;
};


export type Subscription_RootHps_Liquid_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Hps_Liquid_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Hps_Liquid_Type_Order_By>>;
  where?: InputMaybe<Hps_Liquid_Type_Bool_Exp>;
};


export type Subscription_RootHps_Liquid_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootHps_Liquid_Type_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Hps_Liquid_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Hps_Liquid_Type_Bool_Exp>;
};


export type Subscription_RootIntakesArgs = {
  distinct_on?: InputMaybe<Array<Intakes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Intakes_Order_By>>;
  where?: InputMaybe<Intakes_Bool_Exp>;
};


export type Subscription_RootIntakes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Intakes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Intakes_Order_By>>;
  where?: InputMaybe<Intakes_Bool_Exp>;
};


export type Subscription_RootIntakes_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootIntakes_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Intakes_Stream_Cursor_Input>>;
  where?: InputMaybe<Intakes_Bool_Exp>;
};


export type Subscription_RootLegacy_UsersArgs = {
  distinct_on?: InputMaybe<Array<Legacy_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Legacy_Users_Order_By>>;
  where?: InputMaybe<Legacy_Users_Bool_Exp>;
};


export type Subscription_RootLegacy_Users_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Legacy_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Legacy_Users_Order_By>>;
  where?: InputMaybe<Legacy_Users_Bool_Exp>;
};


export type Subscription_RootLegacy_Users_By_PkArgs = {
  hal_identifier: Scalars['String']['input'];
};


export type Subscription_RootLegacy_Users_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Legacy_Users_Stream_Cursor_Input>>;
  where?: InputMaybe<Legacy_Users_Bool_Exp>;
};


export type Subscription_RootMotor_Lead_ExtensionsArgs = {
  distinct_on?: InputMaybe<Array<Motor_Lead_Extensions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Motor_Lead_Extensions_Order_By>>;
  where?: InputMaybe<Motor_Lead_Extensions_Bool_Exp>;
};


export type Subscription_RootMotor_Lead_Extensions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Motor_Lead_Extensions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Motor_Lead_Extensions_Order_By>>;
  where?: InputMaybe<Motor_Lead_Extensions_Bool_Exp>;
};


export type Subscription_RootMotor_Lead_Extensions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootMotor_Lead_Extensions_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Motor_Lead_Extensions_Stream_Cursor_Input>>;
  where?: InputMaybe<Motor_Lead_Extensions_Bool_Exp>;
};


export type Subscription_RootMotorsArgs = {
  distinct_on?: InputMaybe<Array<Motors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Motors_Order_By>>;
  where?: InputMaybe<Motors_Bool_Exp>;
};


export type Subscription_RootMotors_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Motors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Motors_Order_By>>;
  where?: InputMaybe<Motors_Bool_Exp>;
};


export type Subscription_RootMotors_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootMotors_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Motors_Stream_Cursor_Input>>;
  where?: InputMaybe<Motors_Bool_Exp>;
};


export type Subscription_RootNatural_Gas_Separation_OptionsArgs = {
  distinct_on?: InputMaybe<Array<Natural_Gas_Separation_Options_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Natural_Gas_Separation_Options_Order_By>>;
  where?: InputMaybe<Natural_Gas_Separation_Options_Bool_Exp>;
};


export type Subscription_RootNatural_Gas_Separation_Options_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Natural_Gas_Separation_Options_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Natural_Gas_Separation_Options_Order_By>>;
  where?: InputMaybe<Natural_Gas_Separation_Options_Bool_Exp>;
};


export type Subscription_RootNatural_Gas_Separation_Options_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootNatural_Gas_Separation_Options_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Natural_Gas_Separation_Options_Stream_Cursor_Input>>;
  where?: InputMaybe<Natural_Gas_Separation_Options_Bool_Exp>;
};


export type Subscription_RootOil_Density_OptionsArgs = {
  distinct_on?: InputMaybe<Array<Oil_Density_Options_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Oil_Density_Options_Order_By>>;
  where?: InputMaybe<Oil_Density_Options_Bool_Exp>;
};


export type Subscription_RootOil_Density_Options_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Oil_Density_Options_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Oil_Density_Options_Order_By>>;
  where?: InputMaybe<Oil_Density_Options_Bool_Exp>;
};


export type Subscription_RootOil_Density_Options_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootOil_Density_Options_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Oil_Density_Options_Stream_Cursor_Input>>;
  where?: InputMaybe<Oil_Density_Options_Bool_Exp>;
};


export type Subscription_RootOil_Volume_Factor_OptionsArgs = {
  distinct_on?: InputMaybe<Array<Oil_Volume_Factor_Options_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Oil_Volume_Factor_Options_Order_By>>;
  where?: InputMaybe<Oil_Volume_Factor_Options_Bool_Exp>;
};


export type Subscription_RootOil_Volume_Factor_Options_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Oil_Volume_Factor_Options_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Oil_Volume_Factor_Options_Order_By>>;
  where?: InputMaybe<Oil_Volume_Factor_Options_Bool_Exp>;
};


export type Subscription_RootOil_Volume_Factor_Options_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootOil_Volume_Factor_Options_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Oil_Volume_Factor_Options_Stream_Cursor_Input>>;
  where?: InputMaybe<Oil_Volume_Factor_Options_Bool_Exp>;
};


export type Subscription_RootOverride_OptionsArgs = {
  distinct_on?: InputMaybe<Array<Override_Options_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Override_Options_Order_By>>;
  where?: InputMaybe<Override_Options_Bool_Exp>;
};


export type Subscription_RootOverride_Options_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Override_Options_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Override_Options_Order_By>>;
  where?: InputMaybe<Override_Options_Bool_Exp>;
};


export type Subscription_RootOverride_Options_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootOverride_Options_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Override_Options_Stream_Cursor_Input>>;
  where?: InputMaybe<Override_Options_Bool_Exp>;
};


export type Subscription_RootPerformance_EvaluationsArgs = {
  distinct_on?: InputMaybe<Array<Performance_Evaluations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Performance_Evaluations_Order_By>>;
  where?: InputMaybe<Performance_Evaluations_Bool_Exp>;
};


export type Subscription_RootPerformance_Evaluations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Performance_Evaluations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Performance_Evaluations_Order_By>>;
  where?: InputMaybe<Performance_Evaluations_Bool_Exp>;
};


export type Subscription_RootPerformance_Evaluations_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Performance_Evaluations_Stream_Cursor_Input>>;
  where?: InputMaybe<Performance_Evaluations_Bool_Exp>;
};


export type Subscription_RootPerformance_Evaluations_Xref_PumpsArgs = {
  distinct_on?: InputMaybe<Array<Performance_Evaluations_Xref_Pumps_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Performance_Evaluations_Xref_Pumps_Order_By>>;
  where?: InputMaybe<Performance_Evaluations_Xref_Pumps_Bool_Exp>;
};


export type Subscription_RootPerformance_Evaluations_Xref_Pumps_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Performance_Evaluations_Xref_Pumps_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Performance_Evaluations_Xref_Pumps_Order_By>>;
  where?: InputMaybe<Performance_Evaluations_Xref_Pumps_Bool_Exp>;
};


export type Subscription_RootPerformance_Evaluations_Xref_Pumps_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Performance_Evaluations_Xref_Pumps_Stream_Cursor_Input>>;
  where?: InputMaybe<Performance_Evaluations_Xref_Pumps_Bool_Exp>;
};


export type Subscription_RootPumpsArgs = {
  distinct_on?: InputMaybe<Array<Pumps_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pumps_Order_By>>;
  where?: InputMaybe<Pumps_Bool_Exp>;
};


export type Subscription_RootPumps_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pumps_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pumps_Order_By>>;
  where?: InputMaybe<Pumps_Bool_Exp>;
};


export type Subscription_RootPumps_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootPumps_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Pumps_Stream_Cursor_Input>>;
  where?: InputMaybe<Pumps_Bool_Exp>;
};


export type Subscription_RootQuote_Line_Item_Category_DatasetArgs = {
  distinct_on?: InputMaybe<Array<Quote_Line_Item_Category_Dataset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quote_Line_Item_Category_Dataset_Order_By>>;
  where?: InputMaybe<Quote_Line_Item_Category_Dataset_Bool_Exp>;
};


export type Subscription_RootQuote_Line_Item_Category_Dataset_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quote_Line_Item_Category_Dataset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quote_Line_Item_Category_Dataset_Order_By>>;
  where?: InputMaybe<Quote_Line_Item_Category_Dataset_Bool_Exp>;
};


export type Subscription_RootQuote_Line_Item_Category_Dataset_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootQuote_Line_Item_Category_Dataset_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Quote_Line_Item_Category_Dataset_Stream_Cursor_Input>>;
  where?: InputMaybe<Quote_Line_Item_Category_Dataset_Bool_Exp>;
};


export type Subscription_RootQuote_Line_Item_Serialized_DatasetArgs = {
  distinct_on?: InputMaybe<Array<Quote_Line_Item_Serialized_Dataset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quote_Line_Item_Serialized_Dataset_Order_By>>;
  where?: InputMaybe<Quote_Line_Item_Serialized_Dataset_Bool_Exp>;
};


export type Subscription_RootQuote_Line_Item_Serialized_Dataset_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quote_Line_Item_Serialized_Dataset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quote_Line_Item_Serialized_Dataset_Order_By>>;
  where?: InputMaybe<Quote_Line_Item_Serialized_Dataset_Bool_Exp>;
};


export type Subscription_RootQuote_Line_Item_Serialized_Dataset_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootQuote_Line_Item_Serialized_Dataset_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Quote_Line_Item_Serialized_Dataset_Stream_Cursor_Input>>;
  where?: InputMaybe<Quote_Line_Item_Serialized_Dataset_Bool_Exp>;
};


export type Subscription_RootQuote_Line_Item_Source_DatasetArgs = {
  distinct_on?: InputMaybe<Array<Quote_Line_Item_Source_Dataset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quote_Line_Item_Source_Dataset_Order_By>>;
  where?: InputMaybe<Quote_Line_Item_Source_Dataset_Bool_Exp>;
};


export type Subscription_RootQuote_Line_Item_Source_Dataset_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quote_Line_Item_Source_Dataset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quote_Line_Item_Source_Dataset_Order_By>>;
  where?: InputMaybe<Quote_Line_Item_Source_Dataset_Bool_Exp>;
};


export type Subscription_RootQuote_Line_Item_Source_Dataset_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootQuote_Line_Item_Source_Dataset_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Quote_Line_Item_Source_Dataset_Stream_Cursor_Input>>;
  where?: InputMaybe<Quote_Line_Item_Source_Dataset_Bool_Exp>;
};


export type Subscription_RootQuote_Line_Item_Subcategory_DatasetArgs = {
  distinct_on?: InputMaybe<Array<Quote_Line_Item_Subcategory_Dataset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quote_Line_Item_Subcategory_Dataset_Order_By>>;
  where?: InputMaybe<Quote_Line_Item_Subcategory_Dataset_Bool_Exp>;
};


export type Subscription_RootQuote_Line_Item_Subcategory_Dataset_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quote_Line_Item_Subcategory_Dataset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quote_Line_Item_Subcategory_Dataset_Order_By>>;
  where?: InputMaybe<Quote_Line_Item_Subcategory_Dataset_Bool_Exp>;
};


export type Subscription_RootQuote_Line_Item_Subcategory_Dataset_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootQuote_Line_Item_Subcategory_Dataset_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Quote_Line_Item_Subcategory_Dataset_Stream_Cursor_Input>>;
  where?: InputMaybe<Quote_Line_Item_Subcategory_Dataset_Bool_Exp>;
};


export type Subscription_RootQuote_Line_Item_Tax_Type_DatasetArgs = {
  distinct_on?: InputMaybe<Array<Quote_Line_Item_Tax_Type_Dataset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quote_Line_Item_Tax_Type_Dataset_Order_By>>;
  where?: InputMaybe<Quote_Line_Item_Tax_Type_Dataset_Bool_Exp>;
};


export type Subscription_RootQuote_Line_Item_Tax_Type_Dataset_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quote_Line_Item_Tax_Type_Dataset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quote_Line_Item_Tax_Type_Dataset_Order_By>>;
  where?: InputMaybe<Quote_Line_Item_Tax_Type_Dataset_Bool_Exp>;
};


export type Subscription_RootQuote_Line_Item_Tax_Type_Dataset_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootQuote_Line_Item_Tax_Type_Dataset_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Quote_Line_Item_Tax_Type_Dataset_Stream_Cursor_Input>>;
  where?: InputMaybe<Quote_Line_Item_Tax_Type_Dataset_Bool_Exp>;
};


export type Subscription_RootQuote_Line_Item_Type_DatasetArgs = {
  distinct_on?: InputMaybe<Array<Quote_Line_Item_Type_Dataset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quote_Line_Item_Type_Dataset_Order_By>>;
  where?: InputMaybe<Quote_Line_Item_Type_Dataset_Bool_Exp>;
};


export type Subscription_RootQuote_Line_Item_Type_Dataset_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quote_Line_Item_Type_Dataset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quote_Line_Item_Type_Dataset_Order_By>>;
  where?: InputMaybe<Quote_Line_Item_Type_Dataset_Bool_Exp>;
};


export type Subscription_RootQuote_Line_Item_Type_Dataset_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootQuote_Line_Item_Type_Dataset_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Quote_Line_Item_Type_Dataset_Stream_Cursor_Input>>;
  where?: InputMaybe<Quote_Line_Item_Type_Dataset_Bool_Exp>;
};


export type Subscription_RootQuote_Line_ItemsArgs = {
  distinct_on?: InputMaybe<Array<Quote_Line_Items_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quote_Line_Items_Order_By>>;
  where?: InputMaybe<Quote_Line_Items_Bool_Exp>;
};


export type Subscription_RootQuote_Line_Items_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quote_Line_Items_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quote_Line_Items_Order_By>>;
  where?: InputMaybe<Quote_Line_Items_Bool_Exp>;
};


export type Subscription_RootQuote_Line_Items_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootQuote_Line_Items_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Quote_Line_Items_Stream_Cursor_Input>>;
  where?: InputMaybe<Quote_Line_Items_Bool_Exp>;
};


export type Subscription_RootQuote_Sk_Job_Type_DatasetArgs = {
  distinct_on?: InputMaybe<Array<Quote_Sk_Job_Type_Dataset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quote_Sk_Job_Type_Dataset_Order_By>>;
  where?: InputMaybe<Quote_Sk_Job_Type_Dataset_Bool_Exp>;
};


export type Subscription_RootQuote_Sk_Job_Type_Dataset_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quote_Sk_Job_Type_Dataset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quote_Sk_Job_Type_Dataset_Order_By>>;
  where?: InputMaybe<Quote_Sk_Job_Type_Dataset_Bool_Exp>;
};


export type Subscription_RootQuote_Sk_Job_Type_Dataset_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootQuote_Sk_Job_Type_Dataset_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Quote_Sk_Job_Type_Dataset_Stream_Cursor_Input>>;
  where?: InputMaybe<Quote_Sk_Job_Type_Dataset_Bool_Exp>;
};


export type Subscription_RootQuote_Source_DatasetArgs = {
  distinct_on?: InputMaybe<Array<Quote_Source_Dataset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quote_Source_Dataset_Order_By>>;
  where?: InputMaybe<Quote_Source_Dataset_Bool_Exp>;
};


export type Subscription_RootQuote_Source_Dataset_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quote_Source_Dataset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quote_Source_Dataset_Order_By>>;
  where?: InputMaybe<Quote_Source_Dataset_Bool_Exp>;
};


export type Subscription_RootQuote_Source_Dataset_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootQuote_Source_Dataset_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Quote_Source_Dataset_Stream_Cursor_Input>>;
  where?: InputMaybe<Quote_Source_Dataset_Bool_Exp>;
};


export type Subscription_RootQuote_Status_DatasetArgs = {
  distinct_on?: InputMaybe<Array<Quote_Status_Dataset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quote_Status_Dataset_Order_By>>;
  where?: InputMaybe<Quote_Status_Dataset_Bool_Exp>;
};


export type Subscription_RootQuote_Status_Dataset_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quote_Status_Dataset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quote_Status_Dataset_Order_By>>;
  where?: InputMaybe<Quote_Status_Dataset_Bool_Exp>;
};


export type Subscription_RootQuote_Status_Dataset_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootQuote_Status_Dataset_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Quote_Status_Dataset_Stream_Cursor_Input>>;
  where?: InputMaybe<Quote_Status_Dataset_Bool_Exp>;
};


export type Subscription_RootQuote_User_MessagesArgs = {
  distinct_on?: InputMaybe<Array<Quote_User_Messages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quote_User_Messages_Order_By>>;
  where?: InputMaybe<Quote_User_Messages_Bool_Exp>;
};


export type Subscription_RootQuote_User_Messages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quote_User_Messages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quote_User_Messages_Order_By>>;
  where?: InputMaybe<Quote_User_Messages_Bool_Exp>;
};


export type Subscription_RootQuote_User_Messages_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootQuote_User_Messages_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Quote_User_Messages_Stream_Cursor_Input>>;
  where?: InputMaybe<Quote_User_Messages_Bool_Exp>;
};


export type Subscription_RootQuotesArgs = {
  distinct_on?: InputMaybe<Array<Quotes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quotes_Order_By>>;
  where?: InputMaybe<Quotes_Bool_Exp>;
};


export type Subscription_RootQuotes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quotes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quotes_Order_By>>;
  where?: InputMaybe<Quotes_Bool_Exp>;
};


export type Subscription_RootQuotes_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootQuotes_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Quotes_Stream_Cursor_Input>>;
  where?: InputMaybe<Quotes_Bool_Exp>;
};


export type Subscription_RootRevisions_Performance_Evaluations_JournalArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Performance_Evaluations_Journal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Performance_Evaluations_Journal_Order_By>>;
  where?: InputMaybe<Revisions_Performance_Evaluations_Journal_Bool_Exp>;
};


export type Subscription_RootRevisions_Performance_Evaluations_Journal_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Performance_Evaluations_Journal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Performance_Evaluations_Journal_Order_By>>;
  where?: InputMaybe<Revisions_Performance_Evaluations_Journal_Bool_Exp>;
};


export type Subscription_RootRevisions_Performance_Evaluations_Journal_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootRevisions_Performance_Evaluations_Journal_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Revisions_Performance_Evaluations_Journal_Stream_Cursor_Input>>;
  where?: InputMaybe<Revisions_Performance_Evaluations_Journal_Bool_Exp>;
};


export type Subscription_RootRevisions_Performance_Evaluations_RevisionsArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Performance_Evaluations_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Performance_Evaluations_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Performance_Evaluations_Revisions_Bool_Exp>;
};


export type Subscription_RootRevisions_Performance_Evaluations_Revisions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Performance_Evaluations_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Performance_Evaluations_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Performance_Evaluations_Revisions_Bool_Exp>;
};


export type Subscription_RootRevisions_Performance_Evaluations_Revisions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootRevisions_Performance_Evaluations_Revisions_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Revisions_Performance_Evaluations_Revisions_Stream_Cursor_Input>>;
  where?: InputMaybe<Revisions_Performance_Evaluations_Revisions_Bool_Exp>;
};


export type Subscription_RootRevisions_Performance_Evaluations_Xref_Pumps_JournalArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Performance_Evaluations_Xref_Pumps_Journal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Performance_Evaluations_Xref_Pumps_Journal_Order_By>>;
  where?: InputMaybe<Revisions_Performance_Evaluations_Xref_Pumps_Journal_Bool_Exp>;
};


export type Subscription_RootRevisions_Performance_Evaluations_Xref_Pumps_Journal_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Performance_Evaluations_Xref_Pumps_Journal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Performance_Evaluations_Xref_Pumps_Journal_Order_By>>;
  where?: InputMaybe<Revisions_Performance_Evaluations_Xref_Pumps_Journal_Bool_Exp>;
};


export type Subscription_RootRevisions_Performance_Evaluations_Xref_Pumps_Journal_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootRevisions_Performance_Evaluations_Xref_Pumps_Journal_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Revisions_Performance_Evaluations_Xref_Pumps_Journal_Stream_Cursor_Input>>;
  where?: InputMaybe<Revisions_Performance_Evaluations_Xref_Pumps_Journal_Bool_Exp>;
};


export type Subscription_RootRevisions_Performance_Evaluations_Xref_Pumps_RevisionsArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Bool_Exp>;
};


export type Subscription_RootRevisions_Performance_Evaluations_Xref_Pumps_Revisions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Bool_Exp>;
};


export type Subscription_RootRevisions_Performance_Evaluations_Xref_Pumps_Revisions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootRevisions_Performance_Evaluations_Xref_Pumps_Revisions_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Stream_Cursor_Input>>;
  where?: InputMaybe<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Bool_Exp>;
};


export type Subscription_RootRevisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_JournalArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_Order_By>>;
  where?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_Bool_Exp>;
};


export type Subscription_RootRevisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_Order_By>>;
  where?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_Bool_Exp>;
};


export type Subscription_RootRevisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootRevisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_Stream_Cursor_Input>>;
  where?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_Bool_Exp>;
};


export type Subscription_RootRevisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_RevisionsArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Bool_Exp>;
};


export type Subscription_RootRevisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Bool_Exp>;
};


export type Subscription_RootRevisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootRevisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Stream_Cursor_Input>>;
  where?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Bool_Exp>;
};


export type Subscription_RootRevisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_JournalArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_Order_By>>;
  where?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_Bool_Exp>;
};


export type Subscription_RootRevisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_Order_By>>;
  where?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_Bool_Exp>;
};


export type Subscription_RootRevisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootRevisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_Stream_Cursor_Input>>;
  where?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_Bool_Exp>;
};


export type Subscription_RootRevisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_RevisionsArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Bool_Exp>;
};


export type Subscription_RootRevisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Bool_Exp>;
};


export type Subscription_RootRevisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootRevisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Stream_Cursor_Input>>;
  where?: InputMaybe<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Bool_Exp>;
};


export type Subscription_RootRevisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_JournalArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_Order_By>>;
  where?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_Bool_Exp>;
};


export type Subscription_RootRevisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_Order_By>>;
  where?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_Bool_Exp>;
};


export type Subscription_RootRevisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootRevisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_Stream_Cursor_Input>>;
  where?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_Bool_Exp>;
};


export type Subscription_RootRevisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_RevisionsArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Bool_Exp>;
};


export type Subscription_RootRevisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Bool_Exp>;
};


export type Subscription_RootRevisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootRevisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Stream_Cursor_Input>>;
  where?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Bool_Exp>;
};


export type Subscription_RootRevisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_JournalArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_Order_By>>;
  where?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_Bool_Exp>;
};


export type Subscription_RootRevisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_Order_By>>;
  where?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_Bool_Exp>;
};


export type Subscription_RootRevisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootRevisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_Stream_Cursor_Input>>;
  where?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_Bool_Exp>;
};


export type Subscription_RootRevisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_RevisionsArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Bool_Exp>;
};


export type Subscription_RootRevisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Bool_Exp>;
};


export type Subscription_RootRevisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootRevisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Stream_Cursor_Input>>;
  where?: InputMaybe<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Bool_Exp>;
};


export type Subscription_RootRevisions_Scenario_Correlations_JournalArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Correlations_Journal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Correlations_Journal_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Correlations_Journal_Bool_Exp>;
};


export type Subscription_RootRevisions_Scenario_Correlations_Journal_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Correlations_Journal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Correlations_Journal_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Correlations_Journal_Bool_Exp>;
};


export type Subscription_RootRevisions_Scenario_Correlations_Journal_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootRevisions_Scenario_Correlations_Journal_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Revisions_Scenario_Correlations_Journal_Stream_Cursor_Input>>;
  where?: InputMaybe<Revisions_Scenario_Correlations_Journal_Bool_Exp>;
};


export type Subscription_RootRevisions_Scenario_Correlations_RevisionsArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Correlations_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Correlations_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Correlations_Revisions_Bool_Exp>;
};


export type Subscription_RootRevisions_Scenario_Correlations_Revisions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Correlations_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Correlations_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Correlations_Revisions_Bool_Exp>;
};


export type Subscription_RootRevisions_Scenario_Correlations_Revisions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootRevisions_Scenario_Correlations_Revisions_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Revisions_Scenario_Correlations_Revisions_Stream_Cursor_Input>>;
  where?: InputMaybe<Revisions_Scenario_Correlations_Revisions_Bool_Exp>;
};


export type Subscription_RootRevisions_Scenario_Equipment_JournalArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Equipment_Journal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Equipment_Journal_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Equipment_Journal_Bool_Exp>;
};


export type Subscription_RootRevisions_Scenario_Equipment_Journal_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Equipment_Journal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Equipment_Journal_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Equipment_Journal_Bool_Exp>;
};


export type Subscription_RootRevisions_Scenario_Equipment_Journal_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootRevisions_Scenario_Equipment_Journal_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Revisions_Scenario_Equipment_Journal_Stream_Cursor_Input>>;
  where?: InputMaybe<Revisions_Scenario_Equipment_Journal_Bool_Exp>;
};


export type Subscription_RootRevisions_Scenario_Equipment_RevisionsArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Equipment_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Equipment_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Equipment_Revisions_Bool_Exp>;
};


export type Subscription_RootRevisions_Scenario_Equipment_Revisions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Equipment_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Equipment_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Equipment_Revisions_Bool_Exp>;
};


export type Subscription_RootRevisions_Scenario_Equipment_Revisions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootRevisions_Scenario_Equipment_Revisions_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Revisions_Scenario_Equipment_Revisions_Stream_Cursor_Input>>;
  where?: InputMaybe<Revisions_Scenario_Equipment_Revisions_Bool_Exp>;
};


export type Subscription_RootRevisions_Scenario_Equipment_Xref_Cables_JournalArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Cables_Journal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Cables_Journal_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Equipment_Xref_Cables_Journal_Bool_Exp>;
};


export type Subscription_RootRevisions_Scenario_Equipment_Xref_Cables_Journal_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Cables_Journal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Cables_Journal_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Equipment_Xref_Cables_Journal_Bool_Exp>;
};


export type Subscription_RootRevisions_Scenario_Equipment_Xref_Cables_Journal_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootRevisions_Scenario_Equipment_Xref_Cables_Journal_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Revisions_Scenario_Equipment_Xref_Cables_Journal_Stream_Cursor_Input>>;
  where?: InputMaybe<Revisions_Scenario_Equipment_Xref_Cables_Journal_Bool_Exp>;
};


export type Subscription_RootRevisions_Scenario_Equipment_Xref_Cables_RevisionsArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Bool_Exp>;
};


export type Subscription_RootRevisions_Scenario_Equipment_Xref_Cables_Revisions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Bool_Exp>;
};


export type Subscription_RootRevisions_Scenario_Equipment_Xref_Cables_Revisions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootRevisions_Scenario_Equipment_Xref_Cables_Revisions_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Stream_Cursor_Input>>;
  where?: InputMaybe<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Bool_Exp>;
};


export type Subscription_RootRevisions_Scenario_Equipment_Xref_Housings_JournalArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Housings_Journal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Housings_Journal_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Equipment_Xref_Housings_Journal_Bool_Exp>;
};


export type Subscription_RootRevisions_Scenario_Equipment_Xref_Housings_Journal_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Housings_Journal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Housings_Journal_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Equipment_Xref_Housings_Journal_Bool_Exp>;
};


export type Subscription_RootRevisions_Scenario_Equipment_Xref_Housings_Journal_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootRevisions_Scenario_Equipment_Xref_Housings_Journal_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Revisions_Scenario_Equipment_Xref_Housings_Journal_Stream_Cursor_Input>>;
  where?: InputMaybe<Revisions_Scenario_Equipment_Xref_Housings_Journal_Bool_Exp>;
};


export type Subscription_RootRevisions_Scenario_Equipment_Xref_Housings_RevisionsArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Bool_Exp>;
};


export type Subscription_RootRevisions_Scenario_Equipment_Xref_Housings_Revisions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Bool_Exp>;
};


export type Subscription_RootRevisions_Scenario_Equipment_Xref_Housings_Revisions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootRevisions_Scenario_Equipment_Xref_Housings_Revisions_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Stream_Cursor_Input>>;
  where?: InputMaybe<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Bool_Exp>;
};


export type Subscription_RootRevisions_Scenario_Equipment_Xref_Intakes_JournalArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Intakes_Journal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Intakes_Journal_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Equipment_Xref_Intakes_Journal_Bool_Exp>;
};


export type Subscription_RootRevisions_Scenario_Equipment_Xref_Intakes_Journal_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Intakes_Journal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Intakes_Journal_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Equipment_Xref_Intakes_Journal_Bool_Exp>;
};


export type Subscription_RootRevisions_Scenario_Equipment_Xref_Intakes_Journal_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootRevisions_Scenario_Equipment_Xref_Intakes_Journal_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Revisions_Scenario_Equipment_Xref_Intakes_Journal_Stream_Cursor_Input>>;
  where?: InputMaybe<Revisions_Scenario_Equipment_Xref_Intakes_Journal_Bool_Exp>;
};


export type Subscription_RootRevisions_Scenario_Equipment_Xref_Intakes_RevisionsArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Bool_Exp>;
};


export type Subscription_RootRevisions_Scenario_Equipment_Xref_Intakes_Revisions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Bool_Exp>;
};


export type Subscription_RootRevisions_Scenario_Equipment_Xref_Intakes_Revisions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootRevisions_Scenario_Equipment_Xref_Intakes_Revisions_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Stream_Cursor_Input>>;
  where?: InputMaybe<Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Bool_Exp>;
};


export type Subscription_RootRevisions_Scenario_Equipment_Xref_Pumps_JournalArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Pumps_Journal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Pumps_Journal_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Equipment_Xref_Pumps_Journal_Bool_Exp>;
};


export type Subscription_RootRevisions_Scenario_Equipment_Xref_Pumps_Journal_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Pumps_Journal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Pumps_Journal_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Equipment_Xref_Pumps_Journal_Bool_Exp>;
};


export type Subscription_RootRevisions_Scenario_Equipment_Xref_Pumps_Journal_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootRevisions_Scenario_Equipment_Xref_Pumps_Journal_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Revisions_Scenario_Equipment_Xref_Pumps_Journal_Stream_Cursor_Input>>;
  where?: InputMaybe<Revisions_Scenario_Equipment_Xref_Pumps_Journal_Bool_Exp>;
};


export type Subscription_RootRevisions_Scenario_Equipment_Xref_Pumps_RevisionsArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Bool_Exp>;
};


export type Subscription_RootRevisions_Scenario_Equipment_Xref_Pumps_Revisions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Bool_Exp>;
};


export type Subscription_RootRevisions_Scenario_Equipment_Xref_Pumps_Revisions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootRevisions_Scenario_Equipment_Xref_Pumps_Revisions_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Stream_Cursor_Input>>;
  where?: InputMaybe<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Bool_Exp>;
};


export type Subscription_RootRevisions_Scenario_Equipment_Xref_Seals_JournalArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Seals_Journal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Seals_Journal_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Equipment_Xref_Seals_Journal_Bool_Exp>;
};


export type Subscription_RootRevisions_Scenario_Equipment_Xref_Seals_Journal_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Seals_Journal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Seals_Journal_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Equipment_Xref_Seals_Journal_Bool_Exp>;
};


export type Subscription_RootRevisions_Scenario_Equipment_Xref_Seals_Journal_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootRevisions_Scenario_Equipment_Xref_Seals_Journal_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Revisions_Scenario_Equipment_Xref_Seals_Journal_Stream_Cursor_Input>>;
  where?: InputMaybe<Revisions_Scenario_Equipment_Xref_Seals_Journal_Bool_Exp>;
};


export type Subscription_RootRevisions_Scenario_Equipment_Xref_Seals_RevisionsArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Seals_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Seals_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Equipment_Xref_Seals_Revisions_Bool_Exp>;
};


export type Subscription_RootRevisions_Scenario_Equipment_Xref_Seals_Revisions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Seals_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Equipment_Xref_Seals_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Equipment_Xref_Seals_Revisions_Bool_Exp>;
};


export type Subscription_RootRevisions_Scenario_Equipment_Xref_Seals_Revisions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootRevisions_Scenario_Equipment_Xref_Seals_Revisions_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Revisions_Scenario_Equipment_Xref_Seals_Revisions_Stream_Cursor_Input>>;
  where?: InputMaybe<Revisions_Scenario_Equipment_Xref_Seals_Revisions_Bool_Exp>;
};


export type Subscription_RootRevisions_Scenario_Parameters_JournalArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Parameters_Journal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Parameters_Journal_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Parameters_Journal_Bool_Exp>;
};


export type Subscription_RootRevisions_Scenario_Parameters_Journal_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Parameters_Journal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Parameters_Journal_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Parameters_Journal_Bool_Exp>;
};


export type Subscription_RootRevisions_Scenario_Parameters_Journal_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootRevisions_Scenario_Parameters_Journal_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Revisions_Scenario_Parameters_Journal_Stream_Cursor_Input>>;
  where?: InputMaybe<Revisions_Scenario_Parameters_Journal_Bool_Exp>;
};


export type Subscription_RootRevisions_Scenario_Parameters_RevisionsArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Parameters_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Parameters_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Parameters_Revisions_Bool_Exp>;
};


export type Subscription_RootRevisions_Scenario_Parameters_Revisions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Parameters_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Parameters_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Parameters_Revisions_Bool_Exp>;
};


export type Subscription_RootRevisions_Scenario_Parameters_Revisions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootRevisions_Scenario_Parameters_Revisions_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Revisions_Scenario_Parameters_Revisions_Stream_Cursor_Input>>;
  where?: InputMaybe<Revisions_Scenario_Parameters_Revisions_Bool_Exp>;
};


export type Subscription_RootRevisions_Scenario_Well_Properties_JournalArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Well_Properties_Journal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Well_Properties_Journal_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Well_Properties_Journal_Bool_Exp>;
};


export type Subscription_RootRevisions_Scenario_Well_Properties_Journal_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Well_Properties_Journal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Well_Properties_Journal_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Well_Properties_Journal_Bool_Exp>;
};


export type Subscription_RootRevisions_Scenario_Well_Properties_Journal_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootRevisions_Scenario_Well_Properties_Journal_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Revisions_Scenario_Well_Properties_Journal_Stream_Cursor_Input>>;
  where?: InputMaybe<Revisions_Scenario_Well_Properties_Journal_Bool_Exp>;
};


export type Subscription_RootRevisions_Scenario_Well_Properties_RevisionsArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Well_Properties_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Well_Properties_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Well_Properties_Revisions_Bool_Exp>;
};


export type Subscription_RootRevisions_Scenario_Well_Properties_Revisions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Well_Properties_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Well_Properties_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Well_Properties_Revisions_Bool_Exp>;
};


export type Subscription_RootRevisions_Scenario_Well_Properties_Revisions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootRevisions_Scenario_Well_Properties_Revisions_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Revisions_Scenario_Well_Properties_Revisions_Stream_Cursor_Input>>;
  where?: InputMaybe<Revisions_Scenario_Well_Properties_Revisions_Bool_Exp>;
};


export type Subscription_RootRevisions_Scenarios_JournalArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenarios_Journal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenarios_Journal_Order_By>>;
  where?: InputMaybe<Revisions_Scenarios_Journal_Bool_Exp>;
};


export type Subscription_RootRevisions_Scenarios_Journal_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenarios_Journal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenarios_Journal_Order_By>>;
  where?: InputMaybe<Revisions_Scenarios_Journal_Bool_Exp>;
};


export type Subscription_RootRevisions_Scenarios_Journal_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootRevisions_Scenarios_Journal_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Revisions_Scenarios_Journal_Stream_Cursor_Input>>;
  where?: InputMaybe<Revisions_Scenarios_Journal_Bool_Exp>;
};


export type Subscription_RootRevisions_Scenarios_RevisionsArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenarios_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenarios_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Scenarios_Revisions_Bool_Exp>;
};


export type Subscription_RootRevisions_Scenarios_Revisions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenarios_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenarios_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Scenarios_Revisions_Bool_Exp>;
};


export type Subscription_RootRevisions_Scenarios_Revisions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootRevisions_Scenarios_Revisions_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Revisions_Scenarios_Revisions_Stream_Cursor_Input>>;
  where?: InputMaybe<Revisions_Scenarios_Revisions_Bool_Exp>;
};


export type Subscription_RootRevisions_Sizings_JournalArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Sizings_Journal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Sizings_Journal_Order_By>>;
  where?: InputMaybe<Revisions_Sizings_Journal_Bool_Exp>;
};


export type Subscription_RootRevisions_Sizings_Journal_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Sizings_Journal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Sizings_Journal_Order_By>>;
  where?: InputMaybe<Revisions_Sizings_Journal_Bool_Exp>;
};


export type Subscription_RootRevisions_Sizings_Journal_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootRevisions_Sizings_Journal_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Revisions_Sizings_Journal_Stream_Cursor_Input>>;
  where?: InputMaybe<Revisions_Sizings_Journal_Bool_Exp>;
};


export type Subscription_RootRevisions_Sizings_RevisionsArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Sizings_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Sizings_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Sizings_Revisions_Bool_Exp>;
};


export type Subscription_RootRevisions_Sizings_Revisions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Sizings_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Sizings_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Sizings_Revisions_Bool_Exp>;
};


export type Subscription_RootRevisions_Sizings_Revisions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootRevisions_Sizings_Revisions_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Revisions_Sizings_Revisions_Stream_Cursor_Input>>;
  where?: InputMaybe<Revisions_Sizings_Revisions_Bool_Exp>;
};


export type Subscription_RootSaturated_Oil_OptionsArgs = {
  distinct_on?: InputMaybe<Array<Saturated_Oil_Options_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Saturated_Oil_Options_Order_By>>;
  where?: InputMaybe<Saturated_Oil_Options_Bool_Exp>;
};


export type Subscription_RootSaturated_Oil_Options_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Saturated_Oil_Options_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Saturated_Oil_Options_Order_By>>;
  where?: InputMaybe<Saturated_Oil_Options_Bool_Exp>;
};


export type Subscription_RootSaturated_Oil_Options_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootSaturated_Oil_Options_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Saturated_Oil_Options_Stream_Cursor_Input>>;
  where?: InputMaybe<Saturated_Oil_Options_Bool_Exp>;
};


export type Subscription_RootSc_Equip_Xref_Downhole_Ytool_Bypass_TubingsArgs = {
  distinct_on?: InputMaybe<Array<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Order_By>>;
  where?: InputMaybe<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Bool_Exp>;
};


export type Subscription_RootSc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Order_By>>;
  where?: InputMaybe<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Bool_Exp>;
};


export type Subscription_RootSc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Stream_Cursor_Input>>;
  where?: InputMaybe<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Bool_Exp>;
};


export type Subscription_RootSc_Equip_Xref_Downhole_Ytool_Equip_TubingsArgs = {
  distinct_on?: InputMaybe<Array<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Order_By>>;
  where?: InputMaybe<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Bool_Exp>;
};


export type Subscription_RootSc_Equip_Xref_Downhole_Ytool_Equip_Tubings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Order_By>>;
  where?: InputMaybe<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Bool_Exp>;
};


export type Subscription_RootSc_Equip_Xref_Downhole_Ytool_Equip_Tubings_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Stream_Cursor_Input>>;
  where?: InputMaybe<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Bool_Exp>;
};


export type Subscription_RootSc_Equip_Xref_Uphole_Ytool_Bypass_TubingsArgs = {
  distinct_on?: InputMaybe<Array<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Order_By>>;
  where?: InputMaybe<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Bool_Exp>;
};


export type Subscription_RootSc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Order_By>>;
  where?: InputMaybe<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Bool_Exp>;
};


export type Subscription_RootSc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Stream_Cursor_Input>>;
  where?: InputMaybe<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Bool_Exp>;
};


export type Subscription_RootSc_Equip_Xref_Uphole_Ytool_Equip_TubingsArgs = {
  distinct_on?: InputMaybe<Array<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Order_By>>;
  where?: InputMaybe<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Bool_Exp>;
};


export type Subscription_RootSc_Equip_Xref_Uphole_Ytool_Equip_Tubings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Order_By>>;
  where?: InputMaybe<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Bool_Exp>;
};


export type Subscription_RootSc_Equip_Xref_Uphole_Ytool_Equip_Tubings_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Stream_Cursor_Input>>;
  where?: InputMaybe<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Bool_Exp>;
};


export type Subscription_RootScenario_CorrelationsArgs = {
  distinct_on?: InputMaybe<Array<Scenario_Correlations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Scenario_Correlations_Order_By>>;
  where?: InputMaybe<Scenario_Correlations_Bool_Exp>;
};


export type Subscription_RootScenario_Correlations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Scenario_Correlations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Scenario_Correlations_Order_By>>;
  where?: InputMaybe<Scenario_Correlations_Bool_Exp>;
};


export type Subscription_RootScenario_Correlations_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Scenario_Correlations_Stream_Cursor_Input>>;
  where?: InputMaybe<Scenario_Correlations_Bool_Exp>;
};


export type Subscription_RootScenario_EquipmentArgs = {
  distinct_on?: InputMaybe<Array<Scenario_Equipment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Scenario_Equipment_Order_By>>;
  where?: InputMaybe<Scenario_Equipment_Bool_Exp>;
};


export type Subscription_RootScenario_Equipment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Scenario_Equipment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Scenario_Equipment_Order_By>>;
  where?: InputMaybe<Scenario_Equipment_Bool_Exp>;
};


export type Subscription_RootScenario_Equipment_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Scenario_Equipment_Stream_Cursor_Input>>;
  where?: InputMaybe<Scenario_Equipment_Bool_Exp>;
};


export type Subscription_RootScenario_Equipment_Xref_CablesArgs = {
  distinct_on?: InputMaybe<Array<Scenario_Equipment_Xref_Cables_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Scenario_Equipment_Xref_Cables_Order_By>>;
  where?: InputMaybe<Scenario_Equipment_Xref_Cables_Bool_Exp>;
};


export type Subscription_RootScenario_Equipment_Xref_Cables_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Scenario_Equipment_Xref_Cables_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Scenario_Equipment_Xref_Cables_Order_By>>;
  where?: InputMaybe<Scenario_Equipment_Xref_Cables_Bool_Exp>;
};


export type Subscription_RootScenario_Equipment_Xref_Cables_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Scenario_Equipment_Xref_Cables_Stream_Cursor_Input>>;
  where?: InputMaybe<Scenario_Equipment_Xref_Cables_Bool_Exp>;
};


export type Subscription_RootScenario_Equipment_Xref_HousingsArgs = {
  distinct_on?: InputMaybe<Array<Scenario_Equipment_Xref_Housings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Scenario_Equipment_Xref_Housings_Order_By>>;
  where?: InputMaybe<Scenario_Equipment_Xref_Housings_Bool_Exp>;
};


export type Subscription_RootScenario_Equipment_Xref_Housings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Scenario_Equipment_Xref_Housings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Scenario_Equipment_Xref_Housings_Order_By>>;
  where?: InputMaybe<Scenario_Equipment_Xref_Housings_Bool_Exp>;
};


export type Subscription_RootScenario_Equipment_Xref_Housings_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Scenario_Equipment_Xref_Housings_Stream_Cursor_Input>>;
  where?: InputMaybe<Scenario_Equipment_Xref_Housings_Bool_Exp>;
};


export type Subscription_RootScenario_Equipment_Xref_IntakesArgs = {
  distinct_on?: InputMaybe<Array<Scenario_Equipment_Xref_Intakes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Scenario_Equipment_Xref_Intakes_Order_By>>;
  where?: InputMaybe<Scenario_Equipment_Xref_Intakes_Bool_Exp>;
};


export type Subscription_RootScenario_Equipment_Xref_Intakes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Scenario_Equipment_Xref_Intakes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Scenario_Equipment_Xref_Intakes_Order_By>>;
  where?: InputMaybe<Scenario_Equipment_Xref_Intakes_Bool_Exp>;
};


export type Subscription_RootScenario_Equipment_Xref_Intakes_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Scenario_Equipment_Xref_Intakes_Stream_Cursor_Input>>;
  where?: InputMaybe<Scenario_Equipment_Xref_Intakes_Bool_Exp>;
};


export type Subscription_RootScenario_Equipment_Xref_PumpsArgs = {
  distinct_on?: InputMaybe<Array<Scenario_Equipment_Xref_Pumps_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Scenario_Equipment_Xref_Pumps_Order_By>>;
  where?: InputMaybe<Scenario_Equipment_Xref_Pumps_Bool_Exp>;
};


export type Subscription_RootScenario_Equipment_Xref_Pumps_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Scenario_Equipment_Xref_Pumps_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Scenario_Equipment_Xref_Pumps_Order_By>>;
  where?: InputMaybe<Scenario_Equipment_Xref_Pumps_Bool_Exp>;
};


export type Subscription_RootScenario_Equipment_Xref_Pumps_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Scenario_Equipment_Xref_Pumps_Stream_Cursor_Input>>;
  where?: InputMaybe<Scenario_Equipment_Xref_Pumps_Bool_Exp>;
};


export type Subscription_RootScenario_Equipment_Xref_SealsArgs = {
  distinct_on?: InputMaybe<Array<Scenario_Equipment_Xref_Seals_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Scenario_Equipment_Xref_Seals_Order_By>>;
  where?: InputMaybe<Scenario_Equipment_Xref_Seals_Bool_Exp>;
};


export type Subscription_RootScenario_Equipment_Xref_Seals_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Scenario_Equipment_Xref_Seals_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Scenario_Equipment_Xref_Seals_Order_By>>;
  where?: InputMaybe<Scenario_Equipment_Xref_Seals_Bool_Exp>;
};


export type Subscription_RootScenario_Equipment_Xref_Seals_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Scenario_Equipment_Xref_Seals_Stream_Cursor_Input>>;
  where?: InputMaybe<Scenario_Equipment_Xref_Seals_Bool_Exp>;
};


export type Subscription_RootScenario_ParametersArgs = {
  distinct_on?: InputMaybe<Array<Scenario_Parameters_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Scenario_Parameters_Order_By>>;
  where?: InputMaybe<Scenario_Parameters_Bool_Exp>;
};


export type Subscription_RootScenario_Parameters_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Scenario_Parameters_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Scenario_Parameters_Order_By>>;
  where?: InputMaybe<Scenario_Parameters_Bool_Exp>;
};


export type Subscription_RootScenario_Parameters_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Scenario_Parameters_Stream_Cursor_Input>>;
  where?: InputMaybe<Scenario_Parameters_Bool_Exp>;
};


export type Subscription_RootScenario_ReasonsArgs = {
  distinct_on?: InputMaybe<Array<Scenario_Reasons_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Scenario_Reasons_Order_By>>;
  where?: InputMaybe<Scenario_Reasons_Bool_Exp>;
};


export type Subscription_RootScenario_Reasons_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Scenario_Reasons_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Scenario_Reasons_Order_By>>;
  where?: InputMaybe<Scenario_Reasons_Bool_Exp>;
};


export type Subscription_RootScenario_Reasons_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootScenario_Reasons_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Scenario_Reasons_Stream_Cursor_Input>>;
  where?: InputMaybe<Scenario_Reasons_Bool_Exp>;
};


export type Subscription_RootScenario_Well_PropertiesArgs = {
  distinct_on?: InputMaybe<Array<Scenario_Well_Properties_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Scenario_Well_Properties_Order_By>>;
  where?: InputMaybe<Scenario_Well_Properties_Bool_Exp>;
};


export type Subscription_RootScenario_Well_Properties_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Scenario_Well_Properties_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Scenario_Well_Properties_Order_By>>;
  where?: InputMaybe<Scenario_Well_Properties_Bool_Exp>;
};


export type Subscription_RootScenario_Well_Properties_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Scenario_Well_Properties_Stream_Cursor_Input>>;
  where?: InputMaybe<Scenario_Well_Properties_Bool_Exp>;
};


export type Subscription_RootScenariosArgs = {
  distinct_on?: InputMaybe<Array<Scenarios_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Scenarios_Order_By>>;
  where?: InputMaybe<Scenarios_Bool_Exp>;
};


export type Subscription_RootScenarios_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Scenarios_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Scenarios_Order_By>>;
  where?: InputMaybe<Scenarios_Bool_Exp>;
};


export type Subscription_RootScenarios_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Scenarios_Stream_Cursor_Input>>;
  where?: InputMaybe<Scenarios_Bool_Exp>;
};


export type Subscription_RootSeal_Motor_OilArgs = {
  distinct_on?: InputMaybe<Array<Seal_Motor_Oil_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Seal_Motor_Oil_Order_By>>;
  where?: InputMaybe<Seal_Motor_Oil_Bool_Exp>;
};


export type Subscription_RootSeal_Motor_Oil_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Seal_Motor_Oil_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Seal_Motor_Oil_Order_By>>;
  where?: InputMaybe<Seal_Motor_Oil_Bool_Exp>;
};


export type Subscription_RootSeal_Motor_Oil_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootSeal_Motor_Oil_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Seal_Motor_Oil_Stream_Cursor_Input>>;
  where?: InputMaybe<Seal_Motor_Oil_Bool_Exp>;
};


export type Subscription_RootSealsArgs = {
  distinct_on?: InputMaybe<Array<Seals_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Seals_Order_By>>;
  where?: InputMaybe<Seals_Bool_Exp>;
};


export type Subscription_RootSeals_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Seals_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Seals_Order_By>>;
  where?: InputMaybe<Seals_Bool_Exp>;
};


export type Subscription_RootSeals_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootSeals_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Seals_Stream_Cursor_Input>>;
  where?: InputMaybe<Seals_Bool_Exp>;
};


export type Subscription_RootSensorsArgs = {
  distinct_on?: InputMaybe<Array<Sensors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sensors_Order_By>>;
  where?: InputMaybe<Sensors_Bool_Exp>;
};


export type Subscription_RootSensors_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sensors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sensors_Order_By>>;
  where?: InputMaybe<Sensors_Bool_Exp>;
};


export type Subscription_RootSensors_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootSensors_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Sensors_Stream_Cursor_Input>>;
  where?: InputMaybe<Sensors_Bool_Exp>;
};


export type Subscription_RootSizing_DispositionsArgs = {
  distinct_on?: InputMaybe<Array<Sizing_Dispositions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sizing_Dispositions_Order_By>>;
  where?: InputMaybe<Sizing_Dispositions_Bool_Exp>;
};


export type Subscription_RootSizing_Dispositions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sizing_Dispositions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sizing_Dispositions_Order_By>>;
  where?: InputMaybe<Sizing_Dispositions_Bool_Exp>;
};


export type Subscription_RootSizing_Dispositions_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootSizing_Dispositions_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Sizing_Dispositions_Stream_Cursor_Input>>;
  where?: InputMaybe<Sizing_Dispositions_Bool_Exp>;
};


export type Subscription_RootSizing_ImportsArgs = {
  distinct_on?: InputMaybe<Array<Sizing_Imports_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sizing_Imports_Order_By>>;
  where?: InputMaybe<Sizing_Imports_Bool_Exp>;
};


export type Subscription_RootSizing_Imports_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sizing_Imports_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sizing_Imports_Order_By>>;
  where?: InputMaybe<Sizing_Imports_Bool_Exp>;
};


export type Subscription_RootSizing_Imports_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootSizing_Imports_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Sizing_Imports_Stream_Cursor_Input>>;
  where?: InputMaybe<Sizing_Imports_Bool_Exp>;
};


export type Subscription_RootSizing_Pumping_TypeArgs = {
  distinct_on?: InputMaybe<Array<Sizing_Pumping_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sizing_Pumping_Type_Order_By>>;
  where?: InputMaybe<Sizing_Pumping_Type_Bool_Exp>;
};


export type Subscription_RootSizing_Pumping_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sizing_Pumping_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sizing_Pumping_Type_Order_By>>;
  where?: InputMaybe<Sizing_Pumping_Type_Bool_Exp>;
};


export type Subscription_RootSizing_Pumping_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootSizing_Pumping_Type_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Sizing_Pumping_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Sizing_Pumping_Type_Bool_Exp>;
};


export type Subscription_RootSizingsArgs = {
  distinct_on?: InputMaybe<Array<Sizings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sizings_Order_By>>;
  where?: InputMaybe<Sizings_Bool_Exp>;
};


export type Subscription_RootSizings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sizings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sizings_Order_By>>;
  where?: InputMaybe<Sizings_Bool_Exp>;
};


export type Subscription_RootSizings_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Sizings_Stream_Cursor_Input>>;
  where?: InputMaybe<Sizings_Bool_Exp>;
};


export type Subscription_RootSolution_Gas_Oil_Ratio_OptionsArgs = {
  distinct_on?: InputMaybe<Array<Solution_Gas_Oil_Ratio_Options_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Solution_Gas_Oil_Ratio_Options_Order_By>>;
  where?: InputMaybe<Solution_Gas_Oil_Ratio_Options_Bool_Exp>;
};


export type Subscription_RootSolution_Gas_Oil_Ratio_Options_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Solution_Gas_Oil_Ratio_Options_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Solution_Gas_Oil_Ratio_Options_Order_By>>;
  where?: InputMaybe<Solution_Gas_Oil_Ratio_Options_Bool_Exp>;
};


export type Subscription_RootSolution_Gas_Oil_Ratio_Options_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootSolution_Gas_Oil_Ratio_Options_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Solution_Gas_Oil_Ratio_Options_Stream_Cursor_Input>>;
  where?: InputMaybe<Solution_Gas_Oil_Ratio_Options_Bool_Exp>;
};


export type Subscription_RootStatusArgs = {
  distinct_on?: InputMaybe<Array<Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Status_Order_By>>;
  where?: InputMaybe<Status_Bool_Exp>;
};


export type Subscription_RootStatus_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Status_Order_By>>;
  where?: InputMaybe<Status_Bool_Exp>;
};


export type Subscription_RootStatus_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Status_Stream_Cursor_Input>>;
  where?: InputMaybe<Status_Bool_Exp>;
};


export type Subscription_RootStep_Down_TransformersArgs = {
  distinct_on?: InputMaybe<Array<Step_Down_Transformers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Step_Down_Transformers_Order_By>>;
  where?: InputMaybe<Step_Down_Transformers_Bool_Exp>;
};


export type Subscription_RootStep_Down_Transformers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Step_Down_Transformers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Step_Down_Transformers_Order_By>>;
  where?: InputMaybe<Step_Down_Transformers_Bool_Exp>;
};


export type Subscription_RootStep_Down_Transformers_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootStep_Down_Transformers_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Step_Down_Transformers_Stream_Cursor_Input>>;
  where?: InputMaybe<Step_Down_Transformers_Bool_Exp>;
};


export type Subscription_RootStep_Up_TransformersArgs = {
  distinct_on?: InputMaybe<Array<Step_Up_Transformers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Step_Up_Transformers_Order_By>>;
  where?: InputMaybe<Step_Up_Transformers_Bool_Exp>;
};


export type Subscription_RootStep_Up_Transformers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Step_Up_Transformers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Step_Up_Transformers_Order_By>>;
  where?: InputMaybe<Step_Up_Transformers_Bool_Exp>;
};


export type Subscription_RootStep_Up_Transformers_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootStep_Up_Transformers_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Step_Up_Transformers_Stream_Cursor_Input>>;
  where?: InputMaybe<Step_Up_Transformers_Bool_Exp>;
};


export type Subscription_RootSwitchboardsArgs = {
  distinct_on?: InputMaybe<Array<Switchboards_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Switchboards_Order_By>>;
  where?: InputMaybe<Switchboards_Bool_Exp>;
};


export type Subscription_RootSwitchboards_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Switchboards_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Switchboards_Order_By>>;
  where?: InputMaybe<Switchboards_Bool_Exp>;
};


export type Subscription_RootSwitchboards_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootSwitchboards_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Switchboards_Stream_Cursor_Input>>;
  where?: InputMaybe<Switchboards_Bool_Exp>;
};


export type Subscription_RootTubing_Flow_OptionsArgs = {
  distinct_on?: InputMaybe<Array<Tubing_Flow_Options_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tubing_Flow_Options_Order_By>>;
  where?: InputMaybe<Tubing_Flow_Options_Bool_Exp>;
};


export type Subscription_RootTubing_Flow_Options_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tubing_Flow_Options_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tubing_Flow_Options_Order_By>>;
  where?: InputMaybe<Tubing_Flow_Options_Bool_Exp>;
};


export type Subscription_RootTubing_Flow_Options_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootTubing_Flow_Options_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Tubing_Flow_Options_Stream_Cursor_Input>>;
  where?: InputMaybe<Tubing_Flow_Options_Bool_Exp>;
};


export type Subscription_RootTubingsArgs = {
  distinct_on?: InputMaybe<Array<Tubings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tubings_Order_By>>;
  where?: InputMaybe<Tubings_Bool_Exp>;
};


export type Subscription_RootTubings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tubings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tubings_Order_By>>;
  where?: InputMaybe<Tubings_Bool_Exp>;
};


export type Subscription_RootTubings_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootTubings_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Tubings_Stream_Cursor_Input>>;
  where?: InputMaybe<Tubings_Bool_Exp>;
};


export type Subscription_RootTubings_TypeArgs = {
  distinct_on?: InputMaybe<Array<Tubings_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tubings_Type_Order_By>>;
  where?: InputMaybe<Tubings_Type_Bool_Exp>;
};


export type Subscription_RootTubings_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tubings_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tubings_Type_Order_By>>;
  where?: InputMaybe<Tubings_Type_Bool_Exp>;
};


export type Subscription_RootTubings_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootTubings_Type_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Tubings_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Tubings_Type_Bool_Exp>;
};


export type Subscription_RootUnder_Saturated_Oil_OptionsArgs = {
  distinct_on?: InputMaybe<Array<Under_Saturated_Oil_Options_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Under_Saturated_Oil_Options_Order_By>>;
  where?: InputMaybe<Under_Saturated_Oil_Options_Bool_Exp>;
};


export type Subscription_RootUnder_Saturated_Oil_Options_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Under_Saturated_Oil_Options_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Under_Saturated_Oil_Options_Order_By>>;
  where?: InputMaybe<Under_Saturated_Oil_Options_Bool_Exp>;
};


export type Subscription_RootUnder_Saturated_Oil_Options_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootUnder_Saturated_Oil_Options_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Under_Saturated_Oil_Options_Stream_Cursor_Input>>;
  where?: InputMaybe<Under_Saturated_Oil_Options_Bool_Exp>;
};


export type Subscription_RootUser_Eula_AcceptanceArgs = {
  distinct_on?: InputMaybe<Array<User_Eula_Acceptance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Eula_Acceptance_Order_By>>;
  where?: InputMaybe<User_Eula_Acceptance_Bool_Exp>;
};


export type Subscription_RootUser_Eula_Acceptance_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Eula_Acceptance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Eula_Acceptance_Order_By>>;
  where?: InputMaybe<User_Eula_Acceptance_Bool_Exp>;
};


export type Subscription_RootUser_Eula_Acceptance_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootUser_Eula_Acceptance_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<User_Eula_Acceptance_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Eula_Acceptance_Bool_Exp>;
};


export type Subscription_RootUsersArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Subscription_RootUsers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Subscription_RootUsers_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Subscription_RootUsers_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Users_Stream_Cursor_Input>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Subscription_RootVariable_Speed_DrivesArgs = {
  distinct_on?: InputMaybe<Array<Variable_Speed_Drives_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variable_Speed_Drives_Order_By>>;
  where?: InputMaybe<Variable_Speed_Drives_Bool_Exp>;
};


export type Subscription_RootVariable_Speed_Drives_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Variable_Speed_Drives_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variable_Speed_Drives_Order_By>>;
  where?: InputMaybe<Variable_Speed_Drives_Bool_Exp>;
};


export type Subscription_RootVariable_Speed_Drives_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootVariable_Speed_Drives_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Variable_Speed_Drives_Stream_Cursor_Input>>;
  where?: InputMaybe<Variable_Speed_Drives_Bool_Exp>;
};


export type Subscription_RootWater_Density_OptionsArgs = {
  distinct_on?: InputMaybe<Array<Water_Density_Options_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Water_Density_Options_Order_By>>;
  where?: InputMaybe<Water_Density_Options_Bool_Exp>;
};


export type Subscription_RootWater_Density_Options_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Water_Density_Options_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Water_Density_Options_Order_By>>;
  where?: InputMaybe<Water_Density_Options_Bool_Exp>;
};


export type Subscription_RootWater_Density_Options_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootWater_Density_Options_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Water_Density_Options_Stream_Cursor_Input>>;
  where?: InputMaybe<Water_Density_Options_Bool_Exp>;
};


export type Subscription_RootWater_Solution_Gas_OptionsArgs = {
  distinct_on?: InputMaybe<Array<Water_Solution_Gas_Options_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Water_Solution_Gas_Options_Order_By>>;
  where?: InputMaybe<Water_Solution_Gas_Options_Bool_Exp>;
};


export type Subscription_RootWater_Solution_Gas_Options_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Water_Solution_Gas_Options_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Water_Solution_Gas_Options_Order_By>>;
  where?: InputMaybe<Water_Solution_Gas_Options_Bool_Exp>;
};


export type Subscription_RootWater_Solution_Gas_Options_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootWater_Solution_Gas_Options_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Water_Solution_Gas_Options_Stream_Cursor_Input>>;
  where?: InputMaybe<Water_Solution_Gas_Options_Bool_Exp>;
};


export type Subscription_RootWater_Viscosity_OptionsArgs = {
  distinct_on?: InputMaybe<Array<Water_Viscosity_Options_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Water_Viscosity_Options_Order_By>>;
  where?: InputMaybe<Water_Viscosity_Options_Bool_Exp>;
};


export type Subscription_RootWater_Viscosity_Options_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Water_Viscosity_Options_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Water_Viscosity_Options_Order_By>>;
  where?: InputMaybe<Water_Viscosity_Options_Bool_Exp>;
};


export type Subscription_RootWater_Viscosity_Options_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootWater_Viscosity_Options_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Water_Viscosity_Options_Stream_Cursor_Input>>;
  where?: InputMaybe<Water_Viscosity_Options_Bool_Exp>;
};


export type Subscription_RootWater_Volume_Factor_OptionsArgs = {
  distinct_on?: InputMaybe<Array<Water_Volume_Factor_Options_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Water_Volume_Factor_Options_Order_By>>;
  where?: InputMaybe<Water_Volume_Factor_Options_Bool_Exp>;
};


export type Subscription_RootWater_Volume_Factor_Options_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Water_Volume_Factor_Options_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Water_Volume_Factor_Options_Order_By>>;
  where?: InputMaybe<Water_Volume_Factor_Options_Bool_Exp>;
};


export type Subscription_RootWater_Volume_Factor_Options_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootWater_Volume_Factor_Options_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Water_Volume_Factor_Options_Stream_Cursor_Input>>;
  where?: InputMaybe<Water_Volume_Factor_Options_Bool_Exp>;
};


export type Subscription_RootWell_Gas_Type_OptionsArgs = {
  distinct_on?: InputMaybe<Array<Well_Gas_Type_Options_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Well_Gas_Type_Options_Order_By>>;
  where?: InputMaybe<Well_Gas_Type_Options_Bool_Exp>;
};


export type Subscription_RootWell_Gas_Type_Options_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Well_Gas_Type_Options_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Well_Gas_Type_Options_Order_By>>;
  where?: InputMaybe<Well_Gas_Type_Options_Bool_Exp>;
};


export type Subscription_RootWell_Gas_Type_Options_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootWell_Gas_Type_Options_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Well_Gas_Type_Options_Stream_Cursor_Input>>;
  where?: InputMaybe<Well_Gas_Type_Options_Bool_Exp>;
};


export type Subscription_RootWell_Test_Gas_Input_OptionsArgs = {
  distinct_on?: InputMaybe<Array<Well_Test_Gas_Input_Options_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Well_Test_Gas_Input_Options_Order_By>>;
  where?: InputMaybe<Well_Test_Gas_Input_Options_Bool_Exp>;
};


export type Subscription_RootWell_Test_Gas_Input_Options_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Well_Test_Gas_Input_Options_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Well_Test_Gas_Input_Options_Order_By>>;
  where?: InputMaybe<Well_Test_Gas_Input_Options_Bool_Exp>;
};


export type Subscription_RootWell_Test_Gas_Input_Options_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootWell_Test_Gas_Input_Options_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Well_Test_Gas_Input_Options_Stream_Cursor_Input>>;
  where?: InputMaybe<Well_Test_Gas_Input_Options_Bool_Exp>;
};


export type Subscription_RootWell_Test_Liquid_Input_OptionsArgs = {
  distinct_on?: InputMaybe<Array<Well_Test_Liquid_Input_Options_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Well_Test_Liquid_Input_Options_Order_By>>;
  where?: InputMaybe<Well_Test_Liquid_Input_Options_Bool_Exp>;
};


export type Subscription_RootWell_Test_Liquid_Input_Options_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Well_Test_Liquid_Input_Options_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Well_Test_Liquid_Input_Options_Order_By>>;
  where?: InputMaybe<Well_Test_Liquid_Input_Options_Bool_Exp>;
};


export type Subscription_RootWell_Test_Liquid_Input_Options_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootWell_Test_Liquid_Input_Options_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Well_Test_Liquid_Input_Options_Stream_Cursor_Input>>;
  where?: InputMaybe<Well_Test_Liquid_Input_Options_Bool_Exp>;
};


export type Subscription_RootWell_Test_Pressure_Input_OptionsArgs = {
  distinct_on?: InputMaybe<Array<Well_Test_Pressure_Input_Options_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Well_Test_Pressure_Input_Options_Order_By>>;
  where?: InputMaybe<Well_Test_Pressure_Input_Options_Bool_Exp>;
};


export type Subscription_RootWell_Test_Pressure_Input_Options_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Well_Test_Pressure_Input_Options_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Well_Test_Pressure_Input_Options_Order_By>>;
  where?: InputMaybe<Well_Test_Pressure_Input_Options_Bool_Exp>;
};


export type Subscription_RootWell_Test_Pressure_Input_Options_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootWell_Test_Pressure_Input_Options_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Well_Test_Pressure_Input_Options_Stream_Cursor_Input>>;
  where?: InputMaybe<Well_Test_Pressure_Input_Options_Bool_Exp>;
};


export type Subscription_RootWellsArgs = {
  distinct_on?: InputMaybe<Array<Wells_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Wells_Order_By>>;
  where?: InputMaybe<Wells_Bool_Exp>;
};


export type Subscription_RootWells_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Wells_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Wells_Order_By>>;
  where?: InputMaybe<Wells_Bool_Exp>;
};


export type Subscription_RootWells_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootWells_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Wells_Stream_Cursor_Input>>;
  where?: InputMaybe<Wells_Bool_Exp>;
};


export type Subscription_RootY_ToolsArgs = {
  distinct_on?: InputMaybe<Array<Y_Tools_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Y_Tools_Order_By>>;
  where?: InputMaybe<Y_Tools_Bool_Exp>;
};


export type Subscription_RootY_Tools_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Y_Tools_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Y_Tools_Order_By>>;
  where?: InputMaybe<Y_Tools_Bool_Exp>;
};


export type Subscription_RootY_Tools_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootY_Tools_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Y_Tools_Stream_Cursor_Input>>;
  where?: InputMaybe<Y_Tools_Bool_Exp>;
};

/** columns and relationships of "switchboards" */
export type Switchboards = {
  __typename: 'switchboards';
  amps?: Maybe<Scalars['Int']['output']>;
  author_id: Scalars['String']['output'];
  created_at: Scalars['timestamptz']['output'];
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  enclosure?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  imported_sizing_id?: Maybe<Scalars['Int']['output']>;
  include_ecopetrol_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  include_koc_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  kv?: Maybe<Scalars['numeric']['output']>;
  manufacturer?: Maybe<Scalars['String']['output']>;
  only_ecopetrol_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  only_koc_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  part_number?: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "prioritizeswitchboardmanufacturer" */
  prioritized_manufacturer?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  sizing_import?: Maybe<Sizing_Imports>;
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Users;
};

/** aggregated selection of "switchboards" */
export type Switchboards_Aggregate = {
  __typename: 'switchboards_aggregate';
  aggregate?: Maybe<Switchboards_Aggregate_Fields>;
  nodes: Array<Switchboards>;
};

export type Switchboards_Aggregate_Bool_Exp = {
  count?: InputMaybe<Switchboards_Aggregate_Bool_Exp_Count>;
};

export type Switchboards_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Switchboards_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Switchboards_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "switchboards" */
export type Switchboards_Aggregate_Fields = {
  __typename: 'switchboards_aggregate_fields';
  avg?: Maybe<Switchboards_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Switchboards_Max_Fields>;
  min?: Maybe<Switchboards_Min_Fields>;
  stddev?: Maybe<Switchboards_Stddev_Fields>;
  stddev_pop?: Maybe<Switchboards_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Switchboards_Stddev_Samp_Fields>;
  sum?: Maybe<Switchboards_Sum_Fields>;
  var_pop?: Maybe<Switchboards_Var_Pop_Fields>;
  var_samp?: Maybe<Switchboards_Var_Samp_Fields>;
  variance?: Maybe<Switchboards_Variance_Fields>;
};


/** aggregate fields of "switchboards" */
export type Switchboards_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Switchboards_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "switchboards" */
export type Switchboards_Aggregate_Order_By = {
  avg?: InputMaybe<Switchboards_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Switchboards_Max_Order_By>;
  min?: InputMaybe<Switchboards_Min_Order_By>;
  stddev?: InputMaybe<Switchboards_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Switchboards_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Switchboards_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Switchboards_Sum_Order_By>;
  var_pop?: InputMaybe<Switchboards_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Switchboards_Var_Samp_Order_By>;
  variance?: InputMaybe<Switchboards_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "switchboards" */
export type Switchboards_Arr_Rel_Insert_Input = {
  data: Array<Switchboards_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Switchboards_On_Conflict>;
};

/** aggregate avg on columns */
export type Switchboards_Avg_Fields = {
  __typename: 'switchboards_avg_fields';
  amps?: Maybe<Scalars['Float']['output']>;
  imported_sizing_id?: Maybe<Scalars['Float']['output']>;
  kv?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "switchboards" */
export type Switchboards_Avg_Order_By = {
  amps?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  kv?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "switchboards". All fields are combined with a logical 'AND'. */
export type Switchboards_Bool_Exp = {
  _and?: InputMaybe<Array<Switchboards_Bool_Exp>>;
  _not?: InputMaybe<Switchboards_Bool_Exp>;
  _or?: InputMaybe<Array<Switchboards_Bool_Exp>>;
  amps?: InputMaybe<Int_Comparison_Exp>;
  author_id?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  enclosure?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  imported_sizing_id?: InputMaybe<Int_Comparison_Exp>;
  include_ecopetrol_timestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  include_koc_timestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  kv?: InputMaybe<Numeric_Comparison_Exp>;
  manufacturer?: InputMaybe<String_Comparison_Exp>;
  only_ecopetrol_timestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  only_koc_timestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  part_number?: InputMaybe<String_Comparison_Exp>;
  prioritized_manufacturer?: InputMaybe<String_Comparison_Exp>;
  sizing_import?: InputMaybe<Sizing_Imports_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
};

/** unique or primary key constraints on table "switchboards" */
export enum Switchboards_Constraint {
  /** unique or primary key constraint on columns "id" */
  SwitchboardsPkey = 'switchboards_pkey'
}

/** input type for incrementing numeric columns in table "switchboards" */
export type Switchboards_Inc_Input = {
  amps?: InputMaybe<Scalars['Int']['input']>;
  imported_sizing_id?: InputMaybe<Scalars['Int']['input']>;
  kv?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "switchboards" */
export type Switchboards_Insert_Input = {
  amps?: InputMaybe<Scalars['Int']['input']>;
  author_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  enclosure?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  imported_sizing_id?: InputMaybe<Scalars['Int']['input']>;
  include_ecopetrol_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  include_koc_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  kv?: InputMaybe<Scalars['numeric']['input']>;
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  only_ecopetrol_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  only_koc_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  part_number?: InputMaybe<Scalars['String']['input']>;
  sizing_import?: InputMaybe<Sizing_Imports_Obj_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Switchboards_Max_Fields = {
  __typename: 'switchboards_max_fields';
  amps?: Maybe<Scalars['Int']['output']>;
  author_id?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  enclosure?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  imported_sizing_id?: Maybe<Scalars['Int']['output']>;
  include_ecopetrol_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  include_koc_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  kv?: Maybe<Scalars['numeric']['output']>;
  manufacturer?: Maybe<Scalars['String']['output']>;
  only_ecopetrol_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  only_koc_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  part_number?: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "prioritizeswitchboardmanufacturer" */
  prioritized_manufacturer?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "switchboards" */
export type Switchboards_Max_Order_By = {
  amps?: InputMaybe<Order_By>;
  author_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  enclosure?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  include_ecopetrol_timestamp?: InputMaybe<Order_By>;
  include_koc_timestamp?: InputMaybe<Order_By>;
  kv?: InputMaybe<Order_By>;
  manufacturer?: InputMaybe<Order_By>;
  only_ecopetrol_timestamp?: InputMaybe<Order_By>;
  only_koc_timestamp?: InputMaybe<Order_By>;
  part_number?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Switchboards_Min_Fields = {
  __typename: 'switchboards_min_fields';
  amps?: Maybe<Scalars['Int']['output']>;
  author_id?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  enclosure?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  imported_sizing_id?: Maybe<Scalars['Int']['output']>;
  include_ecopetrol_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  include_koc_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  kv?: Maybe<Scalars['numeric']['output']>;
  manufacturer?: Maybe<Scalars['String']['output']>;
  only_ecopetrol_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  only_koc_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  part_number?: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "prioritizeswitchboardmanufacturer" */
  prioritized_manufacturer?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "switchboards" */
export type Switchboards_Min_Order_By = {
  amps?: InputMaybe<Order_By>;
  author_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  enclosure?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  include_ecopetrol_timestamp?: InputMaybe<Order_By>;
  include_koc_timestamp?: InputMaybe<Order_By>;
  kv?: InputMaybe<Order_By>;
  manufacturer?: InputMaybe<Order_By>;
  only_ecopetrol_timestamp?: InputMaybe<Order_By>;
  only_koc_timestamp?: InputMaybe<Order_By>;
  part_number?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "switchboards" */
export type Switchboards_Mutation_Response = {
  __typename: 'switchboards_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Switchboards>;
};

/** input type for inserting object relation for remote table "switchboards" */
export type Switchboards_Obj_Rel_Insert_Input = {
  data: Switchboards_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Switchboards_On_Conflict>;
};

/** on_conflict condition type for table "switchboards" */
export type Switchboards_On_Conflict = {
  constraint: Switchboards_Constraint;
  update_columns?: Array<Switchboards_Update_Column>;
  where?: InputMaybe<Switchboards_Bool_Exp>;
};

/** Ordering options when selecting data from "switchboards". */
export type Switchboards_Order_By = {
  amps?: InputMaybe<Order_By>;
  author_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  enclosure?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  include_ecopetrol_timestamp?: InputMaybe<Order_By>;
  include_koc_timestamp?: InputMaybe<Order_By>;
  kv?: InputMaybe<Order_By>;
  manufacturer?: InputMaybe<Order_By>;
  only_ecopetrol_timestamp?: InputMaybe<Order_By>;
  only_koc_timestamp?: InputMaybe<Order_By>;
  part_number?: InputMaybe<Order_By>;
  prioritized_manufacturer?: InputMaybe<Order_By>;
  sizing_import?: InputMaybe<Sizing_Imports_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
};

/** primary key columns input for table: switchboards */
export type Switchboards_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "switchboards" */
export enum Switchboards_Select_Column {
  /** column name */
  Amps = 'amps',
  /** column name */
  AuthorId = 'author_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Enclosure = 'enclosure',
  /** column name */
  Id = 'id',
  /** column name */
  ImportedSizingId = 'imported_sizing_id',
  /** column name */
  IncludeEcopetrolTimestamp = 'include_ecopetrol_timestamp',
  /** column name */
  IncludeKocTimestamp = 'include_koc_timestamp',
  /** column name */
  Kv = 'kv',
  /** column name */
  Manufacturer = 'manufacturer',
  /** column name */
  OnlyEcopetrolTimestamp = 'only_ecopetrol_timestamp',
  /** column name */
  OnlyKocTimestamp = 'only_koc_timestamp',
  /** column name */
  PartNumber = 'part_number',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "switchboards" */
export type Switchboards_Set_Input = {
  amps?: InputMaybe<Scalars['Int']['input']>;
  author_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  enclosure?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  imported_sizing_id?: InputMaybe<Scalars['Int']['input']>;
  include_ecopetrol_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  include_koc_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  kv?: InputMaybe<Scalars['numeric']['input']>;
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  only_ecopetrol_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  only_koc_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  part_number?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Switchboards_Stddev_Fields = {
  __typename: 'switchboards_stddev_fields';
  amps?: Maybe<Scalars['Float']['output']>;
  imported_sizing_id?: Maybe<Scalars['Float']['output']>;
  kv?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "switchboards" */
export type Switchboards_Stddev_Order_By = {
  amps?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  kv?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Switchboards_Stddev_Pop_Fields = {
  __typename: 'switchboards_stddev_pop_fields';
  amps?: Maybe<Scalars['Float']['output']>;
  imported_sizing_id?: Maybe<Scalars['Float']['output']>;
  kv?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "switchboards" */
export type Switchboards_Stddev_Pop_Order_By = {
  amps?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  kv?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Switchboards_Stddev_Samp_Fields = {
  __typename: 'switchboards_stddev_samp_fields';
  amps?: Maybe<Scalars['Float']['output']>;
  imported_sizing_id?: Maybe<Scalars['Float']['output']>;
  kv?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "switchboards" */
export type Switchboards_Stddev_Samp_Order_By = {
  amps?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  kv?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "switchboards" */
export type Switchboards_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Switchboards_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Switchboards_Stream_Cursor_Value_Input = {
  amps?: InputMaybe<Scalars['Int']['input']>;
  author_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  enclosure?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  imported_sizing_id?: InputMaybe<Scalars['Int']['input']>;
  include_ecopetrol_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  include_koc_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  kv?: InputMaybe<Scalars['numeric']['input']>;
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  only_ecopetrol_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  only_koc_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  part_number?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Switchboards_Sum_Fields = {
  __typename: 'switchboards_sum_fields';
  amps?: Maybe<Scalars['Int']['output']>;
  imported_sizing_id?: Maybe<Scalars['Int']['output']>;
  kv?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "switchboards" */
export type Switchboards_Sum_Order_By = {
  amps?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  kv?: InputMaybe<Order_By>;
};

/** update columns of table "switchboards" */
export enum Switchboards_Update_Column {
  /** column name */
  Amps = 'amps',
  /** column name */
  AuthorId = 'author_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Enclosure = 'enclosure',
  /** column name */
  Id = 'id',
  /** column name */
  ImportedSizingId = 'imported_sizing_id',
  /** column name */
  IncludeEcopetrolTimestamp = 'include_ecopetrol_timestamp',
  /** column name */
  IncludeKocTimestamp = 'include_koc_timestamp',
  /** column name */
  Kv = 'kv',
  /** column name */
  Manufacturer = 'manufacturer',
  /** column name */
  OnlyEcopetrolTimestamp = 'only_ecopetrol_timestamp',
  /** column name */
  OnlyKocTimestamp = 'only_koc_timestamp',
  /** column name */
  PartNumber = 'part_number',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Switchboards_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Switchboards_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Switchboards_Set_Input>;
  /** filter the rows which have to be updated */
  where: Switchboards_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Switchboards_Var_Pop_Fields = {
  __typename: 'switchboards_var_pop_fields';
  amps?: Maybe<Scalars['Float']['output']>;
  imported_sizing_id?: Maybe<Scalars['Float']['output']>;
  kv?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "switchboards" */
export type Switchboards_Var_Pop_Order_By = {
  amps?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  kv?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Switchboards_Var_Samp_Fields = {
  __typename: 'switchboards_var_samp_fields';
  amps?: Maybe<Scalars['Float']['output']>;
  imported_sizing_id?: Maybe<Scalars['Float']['output']>;
  kv?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "switchboards" */
export type Switchboards_Var_Samp_Order_By = {
  amps?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  kv?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Switchboards_Variance_Fields = {
  __typename: 'switchboards_variance_fields';
  amps?: Maybe<Scalars['Float']['output']>;
  imported_sizing_id?: Maybe<Scalars['Float']['output']>;
  kv?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "switchboards" */
export type Switchboards_Variance_Order_By = {
  amps?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  kv?: InputMaybe<Order_By>;
};

/** Boolean expression to compare columns of type "timestamp". All fields are combined with logical 'AND'. */
export type Timestamp_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['timestamp']['input']>;
  _gt?: InputMaybe<Scalars['timestamp']['input']>;
  _gte?: InputMaybe<Scalars['timestamp']['input']>;
  _in?: InputMaybe<Array<Scalars['timestamp']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['timestamp']['input']>;
  _lte?: InputMaybe<Scalars['timestamp']['input']>;
  _neq?: InputMaybe<Scalars['timestamp']['input']>;
  _nin?: InputMaybe<Array<Scalars['timestamp']['input']>>;
};

/** Boolean expression to compare columns of type "timestamptz". All fields are combined with logical 'AND'. */
export type Timestamptz_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['timestamptz']['input']>;
  _gt?: InputMaybe<Scalars['timestamptz']['input']>;
  _gte?: InputMaybe<Scalars['timestamptz']['input']>;
  _in?: InputMaybe<Array<Scalars['timestamptz']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['timestamptz']['input']>;
  _lte?: InputMaybe<Scalars['timestamptz']['input']>;
  _neq?: InputMaybe<Scalars['timestamptz']['input']>;
  _nin?: InputMaybe<Array<Scalars['timestamptz']['input']>>;
};

/** columns and relationships of "tubing_flow_options" */
export type Tubing_Flow_Options = {
  __typename: 'tubing_flow_options';
  comment?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

/** aggregated selection of "tubing_flow_options" */
export type Tubing_Flow_Options_Aggregate = {
  __typename: 'tubing_flow_options_aggregate';
  aggregate?: Maybe<Tubing_Flow_Options_Aggregate_Fields>;
  nodes: Array<Tubing_Flow_Options>;
};

/** aggregate fields of "tubing_flow_options" */
export type Tubing_Flow_Options_Aggregate_Fields = {
  __typename: 'tubing_flow_options_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Tubing_Flow_Options_Max_Fields>;
  min?: Maybe<Tubing_Flow_Options_Min_Fields>;
};


/** aggregate fields of "tubing_flow_options" */
export type Tubing_Flow_Options_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tubing_Flow_Options_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "tubing_flow_options". All fields are combined with a logical 'AND'. */
export type Tubing_Flow_Options_Bool_Exp = {
  _and?: InputMaybe<Array<Tubing_Flow_Options_Bool_Exp>>;
  _not?: InputMaybe<Tubing_Flow_Options_Bool_Exp>;
  _or?: InputMaybe<Array<Tubing_Flow_Options_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "tubing_flow_options" */
export enum Tubing_Flow_Options_Constraint {
  /** unique or primary key constraint on columns "value" */
  TubingFlowOptionsPkey = 'tubing_flow_options_pkey'
}

export enum Tubing_Flow_Options_Enum {
  /** Beggs & Brill */
  BeggsBrill = 'beggs_brill',
  /** Duns & Ros */
  DunsRos = 'duns_ros',
  /** Hagedorn & Brown */
  HagedornBrown = 'hagedorn_brown',
  /** Orkiszewski */
  Orkiszewski = 'orkiszewski'
}

/** Boolean expression to compare columns of type "tubing_flow_options_enum". All fields are combined with logical 'AND'. */
export type Tubing_Flow_Options_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Tubing_Flow_Options_Enum>;
  _in?: InputMaybe<Array<Tubing_Flow_Options_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Tubing_Flow_Options_Enum>;
  _nin?: InputMaybe<Array<Tubing_Flow_Options_Enum>>;
};

/** input type for inserting data into table "tubing_flow_options" */
export type Tubing_Flow_Options_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Tubing_Flow_Options_Max_Fields = {
  __typename: 'tubing_flow_options_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Tubing_Flow_Options_Min_Fields = {
  __typename: 'tubing_flow_options_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "tubing_flow_options" */
export type Tubing_Flow_Options_Mutation_Response = {
  __typename: 'tubing_flow_options_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Tubing_Flow_Options>;
};

/** input type for inserting object relation for remote table "tubing_flow_options" */
export type Tubing_Flow_Options_Obj_Rel_Insert_Input = {
  data: Tubing_Flow_Options_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Tubing_Flow_Options_On_Conflict>;
};

/** on_conflict condition type for table "tubing_flow_options" */
export type Tubing_Flow_Options_On_Conflict = {
  constraint: Tubing_Flow_Options_Constraint;
  update_columns?: Array<Tubing_Flow_Options_Update_Column>;
  where?: InputMaybe<Tubing_Flow_Options_Bool_Exp>;
};

/** Ordering options when selecting data from "tubing_flow_options". */
export type Tubing_Flow_Options_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: tubing_flow_options */
export type Tubing_Flow_Options_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "tubing_flow_options" */
export enum Tubing_Flow_Options_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "tubing_flow_options" */
export type Tubing_Flow_Options_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "tubing_flow_options" */
export type Tubing_Flow_Options_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tubing_Flow_Options_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Tubing_Flow_Options_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "tubing_flow_options" */
export enum Tubing_Flow_Options_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Tubing_Flow_Options_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tubing_Flow_Options_Set_Input>;
  /** filter the rows which have to be updated */
  where: Tubing_Flow_Options_Bool_Exp;
};

/** columns and relationships of "tubings" */
export type Tubings = {
  __typename: 'tubings';
  author_id: Scalars['String']['output'];
  coupling_outer_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  created_at: Scalars['timestamptz']['output'];
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  drift_inches?: Maybe<Scalars['numeric']['output']>;
  id: Scalars['uuid']['output'];
  imperial_name?: Maybe<Scalars['String']['output']>;
  imported_sizing_id?: Maybe<Scalars['Int']['output']>;
  include_ecopetrol_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  include_koc_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  interior_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  metric_name?: Maybe<Scalars['String']['output']>;
  only_ecopetrol_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  only_koc_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  outer_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  pound_per_foot?: Maybe<Scalars['numeric']['output']>;
  /** An object relationship */
  sizing_import?: Maybe<Sizing_Imports>;
  tubing_type: Tubings_Type_Enum;
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Users;
};

/** aggregated selection of "tubings" */
export type Tubings_Aggregate = {
  __typename: 'tubings_aggregate';
  aggregate?: Maybe<Tubings_Aggregate_Fields>;
  nodes: Array<Tubings>;
};

export type Tubings_Aggregate_Bool_Exp = {
  count?: InputMaybe<Tubings_Aggregate_Bool_Exp_Count>;
};

export type Tubings_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Tubings_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Tubings_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "tubings" */
export type Tubings_Aggregate_Fields = {
  __typename: 'tubings_aggregate_fields';
  avg?: Maybe<Tubings_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Tubings_Max_Fields>;
  min?: Maybe<Tubings_Min_Fields>;
  stddev?: Maybe<Tubings_Stddev_Fields>;
  stddev_pop?: Maybe<Tubings_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Tubings_Stddev_Samp_Fields>;
  sum?: Maybe<Tubings_Sum_Fields>;
  var_pop?: Maybe<Tubings_Var_Pop_Fields>;
  var_samp?: Maybe<Tubings_Var_Samp_Fields>;
  variance?: Maybe<Tubings_Variance_Fields>;
};


/** aggregate fields of "tubings" */
export type Tubings_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tubings_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "tubings" */
export type Tubings_Aggregate_Order_By = {
  avg?: InputMaybe<Tubings_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Tubings_Max_Order_By>;
  min?: InputMaybe<Tubings_Min_Order_By>;
  stddev?: InputMaybe<Tubings_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Tubings_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Tubings_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Tubings_Sum_Order_By>;
  var_pop?: InputMaybe<Tubings_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Tubings_Var_Samp_Order_By>;
  variance?: InputMaybe<Tubings_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "tubings" */
export type Tubings_Arr_Rel_Insert_Input = {
  data: Array<Tubings_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Tubings_On_Conflict>;
};

/** aggregate avg on columns */
export type Tubings_Avg_Fields = {
  __typename: 'tubings_avg_fields';
  coupling_outer_diameter_inches?: Maybe<Scalars['Float']['output']>;
  drift_inches?: Maybe<Scalars['Float']['output']>;
  imported_sizing_id?: Maybe<Scalars['Float']['output']>;
  interior_diameter_inches?: Maybe<Scalars['Float']['output']>;
  outer_diameter_inches?: Maybe<Scalars['Float']['output']>;
  pound_per_foot?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "tubings" */
export type Tubings_Avg_Order_By = {
  coupling_outer_diameter_inches?: InputMaybe<Order_By>;
  drift_inches?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  interior_diameter_inches?: InputMaybe<Order_By>;
  outer_diameter_inches?: InputMaybe<Order_By>;
  pound_per_foot?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "tubings". All fields are combined with a logical 'AND'. */
export type Tubings_Bool_Exp = {
  _and?: InputMaybe<Array<Tubings_Bool_Exp>>;
  _not?: InputMaybe<Tubings_Bool_Exp>;
  _or?: InputMaybe<Array<Tubings_Bool_Exp>>;
  author_id?: InputMaybe<String_Comparison_Exp>;
  coupling_outer_diameter_inches?: InputMaybe<Numeric_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  drift_inches?: InputMaybe<Numeric_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  imperial_name?: InputMaybe<String_Comparison_Exp>;
  imported_sizing_id?: InputMaybe<Int_Comparison_Exp>;
  include_ecopetrol_timestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  include_koc_timestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  interior_diameter_inches?: InputMaybe<Numeric_Comparison_Exp>;
  metric_name?: InputMaybe<String_Comparison_Exp>;
  only_ecopetrol_timestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  only_koc_timestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  outer_diameter_inches?: InputMaybe<Numeric_Comparison_Exp>;
  pound_per_foot?: InputMaybe<Numeric_Comparison_Exp>;
  sizing_import?: InputMaybe<Sizing_Imports_Bool_Exp>;
  tubing_type?: InputMaybe<Tubings_Type_Enum_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
};

/** unique or primary key constraints on table "tubings" */
export enum Tubings_Constraint {
  /** unique or primary key constraint on columns "id" */
  TubingsPkey = 'tubings_pkey'
}

/** input type for incrementing numeric columns in table "tubings" */
export type Tubings_Inc_Input = {
  coupling_outer_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  drift_inches?: InputMaybe<Scalars['numeric']['input']>;
  imported_sizing_id?: InputMaybe<Scalars['Int']['input']>;
  interior_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  outer_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  pound_per_foot?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "tubings" */
export type Tubings_Insert_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  coupling_outer_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  drift_inches?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  imperial_name?: InputMaybe<Scalars['String']['input']>;
  imported_sizing_id?: InputMaybe<Scalars['Int']['input']>;
  include_ecopetrol_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  include_koc_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  interior_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  metric_name?: InputMaybe<Scalars['String']['input']>;
  only_ecopetrol_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  only_koc_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  outer_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  pound_per_foot?: InputMaybe<Scalars['numeric']['input']>;
  sizing_import?: InputMaybe<Sizing_Imports_Obj_Rel_Insert_Input>;
  tubing_type?: InputMaybe<Tubings_Type_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Tubings_Max_Fields = {
  __typename: 'tubings_max_fields';
  author_id?: Maybe<Scalars['String']['output']>;
  coupling_outer_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  drift_inches?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  imperial_name?: Maybe<Scalars['String']['output']>;
  imported_sizing_id?: Maybe<Scalars['Int']['output']>;
  include_ecopetrol_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  include_koc_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  interior_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  metric_name?: Maybe<Scalars['String']['output']>;
  only_ecopetrol_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  only_koc_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  outer_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  pound_per_foot?: Maybe<Scalars['numeric']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "tubings" */
export type Tubings_Max_Order_By = {
  author_id?: InputMaybe<Order_By>;
  coupling_outer_diameter_inches?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  drift_inches?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  imperial_name?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  include_ecopetrol_timestamp?: InputMaybe<Order_By>;
  include_koc_timestamp?: InputMaybe<Order_By>;
  interior_diameter_inches?: InputMaybe<Order_By>;
  metric_name?: InputMaybe<Order_By>;
  only_ecopetrol_timestamp?: InputMaybe<Order_By>;
  only_koc_timestamp?: InputMaybe<Order_By>;
  outer_diameter_inches?: InputMaybe<Order_By>;
  pound_per_foot?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Tubings_Min_Fields = {
  __typename: 'tubings_min_fields';
  author_id?: Maybe<Scalars['String']['output']>;
  coupling_outer_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  drift_inches?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  imperial_name?: Maybe<Scalars['String']['output']>;
  imported_sizing_id?: Maybe<Scalars['Int']['output']>;
  include_ecopetrol_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  include_koc_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  interior_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  metric_name?: Maybe<Scalars['String']['output']>;
  only_ecopetrol_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  only_koc_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  outer_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  pound_per_foot?: Maybe<Scalars['numeric']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "tubings" */
export type Tubings_Min_Order_By = {
  author_id?: InputMaybe<Order_By>;
  coupling_outer_diameter_inches?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  drift_inches?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  imperial_name?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  include_ecopetrol_timestamp?: InputMaybe<Order_By>;
  include_koc_timestamp?: InputMaybe<Order_By>;
  interior_diameter_inches?: InputMaybe<Order_By>;
  metric_name?: InputMaybe<Order_By>;
  only_ecopetrol_timestamp?: InputMaybe<Order_By>;
  only_koc_timestamp?: InputMaybe<Order_By>;
  outer_diameter_inches?: InputMaybe<Order_By>;
  pound_per_foot?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "tubings" */
export type Tubings_Mutation_Response = {
  __typename: 'tubings_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Tubings>;
};

/** input type for inserting object relation for remote table "tubings" */
export type Tubings_Obj_Rel_Insert_Input = {
  data: Tubings_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Tubings_On_Conflict>;
};

/** on_conflict condition type for table "tubings" */
export type Tubings_On_Conflict = {
  constraint: Tubings_Constraint;
  update_columns?: Array<Tubings_Update_Column>;
  where?: InputMaybe<Tubings_Bool_Exp>;
};

/** Ordering options when selecting data from "tubings". */
export type Tubings_Order_By = {
  author_id?: InputMaybe<Order_By>;
  coupling_outer_diameter_inches?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  drift_inches?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  imperial_name?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  include_ecopetrol_timestamp?: InputMaybe<Order_By>;
  include_koc_timestamp?: InputMaybe<Order_By>;
  interior_diameter_inches?: InputMaybe<Order_By>;
  metric_name?: InputMaybe<Order_By>;
  only_ecopetrol_timestamp?: InputMaybe<Order_By>;
  only_koc_timestamp?: InputMaybe<Order_By>;
  outer_diameter_inches?: InputMaybe<Order_By>;
  pound_per_foot?: InputMaybe<Order_By>;
  sizing_import?: InputMaybe<Sizing_Imports_Order_By>;
  tubing_type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
};

/** primary key columns input for table: tubings */
export type Tubings_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "tubings" */
export enum Tubings_Select_Column {
  /** column name */
  AuthorId = 'author_id',
  /** column name */
  CouplingOuterDiameterInches = 'coupling_outer_diameter_inches',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  DriftInches = 'drift_inches',
  /** column name */
  Id = 'id',
  /** column name */
  ImperialName = 'imperial_name',
  /** column name */
  ImportedSizingId = 'imported_sizing_id',
  /** column name */
  IncludeEcopetrolTimestamp = 'include_ecopetrol_timestamp',
  /** column name */
  IncludeKocTimestamp = 'include_koc_timestamp',
  /** column name */
  InteriorDiameterInches = 'interior_diameter_inches',
  /** column name */
  MetricName = 'metric_name',
  /** column name */
  OnlyEcopetrolTimestamp = 'only_ecopetrol_timestamp',
  /** column name */
  OnlyKocTimestamp = 'only_koc_timestamp',
  /** column name */
  OuterDiameterInches = 'outer_diameter_inches',
  /** column name */
  PoundPerFoot = 'pound_per_foot',
  /** column name */
  TubingType = 'tubing_type',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "tubings" */
export type Tubings_Set_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  coupling_outer_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  drift_inches?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  imperial_name?: InputMaybe<Scalars['String']['input']>;
  imported_sizing_id?: InputMaybe<Scalars['Int']['input']>;
  include_ecopetrol_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  include_koc_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  interior_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  metric_name?: InputMaybe<Scalars['String']['input']>;
  only_ecopetrol_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  only_koc_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  outer_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  pound_per_foot?: InputMaybe<Scalars['numeric']['input']>;
  tubing_type?: InputMaybe<Tubings_Type_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Tubings_Stddev_Fields = {
  __typename: 'tubings_stddev_fields';
  coupling_outer_diameter_inches?: Maybe<Scalars['Float']['output']>;
  drift_inches?: Maybe<Scalars['Float']['output']>;
  imported_sizing_id?: Maybe<Scalars['Float']['output']>;
  interior_diameter_inches?: Maybe<Scalars['Float']['output']>;
  outer_diameter_inches?: Maybe<Scalars['Float']['output']>;
  pound_per_foot?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "tubings" */
export type Tubings_Stddev_Order_By = {
  coupling_outer_diameter_inches?: InputMaybe<Order_By>;
  drift_inches?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  interior_diameter_inches?: InputMaybe<Order_By>;
  outer_diameter_inches?: InputMaybe<Order_By>;
  pound_per_foot?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Tubings_Stddev_Pop_Fields = {
  __typename: 'tubings_stddev_pop_fields';
  coupling_outer_diameter_inches?: Maybe<Scalars['Float']['output']>;
  drift_inches?: Maybe<Scalars['Float']['output']>;
  imported_sizing_id?: Maybe<Scalars['Float']['output']>;
  interior_diameter_inches?: Maybe<Scalars['Float']['output']>;
  outer_diameter_inches?: Maybe<Scalars['Float']['output']>;
  pound_per_foot?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "tubings" */
export type Tubings_Stddev_Pop_Order_By = {
  coupling_outer_diameter_inches?: InputMaybe<Order_By>;
  drift_inches?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  interior_diameter_inches?: InputMaybe<Order_By>;
  outer_diameter_inches?: InputMaybe<Order_By>;
  pound_per_foot?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Tubings_Stddev_Samp_Fields = {
  __typename: 'tubings_stddev_samp_fields';
  coupling_outer_diameter_inches?: Maybe<Scalars['Float']['output']>;
  drift_inches?: Maybe<Scalars['Float']['output']>;
  imported_sizing_id?: Maybe<Scalars['Float']['output']>;
  interior_diameter_inches?: Maybe<Scalars['Float']['output']>;
  outer_diameter_inches?: Maybe<Scalars['Float']['output']>;
  pound_per_foot?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "tubings" */
export type Tubings_Stddev_Samp_Order_By = {
  coupling_outer_diameter_inches?: InputMaybe<Order_By>;
  drift_inches?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  interior_diameter_inches?: InputMaybe<Order_By>;
  outer_diameter_inches?: InputMaybe<Order_By>;
  pound_per_foot?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "tubings" */
export type Tubings_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tubings_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Tubings_Stream_Cursor_Value_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  coupling_outer_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  drift_inches?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  imperial_name?: InputMaybe<Scalars['String']['input']>;
  imported_sizing_id?: InputMaybe<Scalars['Int']['input']>;
  include_ecopetrol_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  include_koc_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  interior_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  metric_name?: InputMaybe<Scalars['String']['input']>;
  only_ecopetrol_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  only_koc_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  outer_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  pound_per_foot?: InputMaybe<Scalars['numeric']['input']>;
  tubing_type?: InputMaybe<Tubings_Type_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Tubings_Sum_Fields = {
  __typename: 'tubings_sum_fields';
  coupling_outer_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  drift_inches?: Maybe<Scalars['numeric']['output']>;
  imported_sizing_id?: Maybe<Scalars['Int']['output']>;
  interior_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  outer_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  pound_per_foot?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "tubings" */
export type Tubings_Sum_Order_By = {
  coupling_outer_diameter_inches?: InputMaybe<Order_By>;
  drift_inches?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  interior_diameter_inches?: InputMaybe<Order_By>;
  outer_diameter_inches?: InputMaybe<Order_By>;
  pound_per_foot?: InputMaybe<Order_By>;
};

/** columns and relationships of "tubings_type" */
export type Tubings_Type = {
  __typename: 'tubings_type';
  comment?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

/** aggregated selection of "tubings_type" */
export type Tubings_Type_Aggregate = {
  __typename: 'tubings_type_aggregate';
  aggregate?: Maybe<Tubings_Type_Aggregate_Fields>;
  nodes: Array<Tubings_Type>;
};

/** aggregate fields of "tubings_type" */
export type Tubings_Type_Aggregate_Fields = {
  __typename: 'tubings_type_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Tubings_Type_Max_Fields>;
  min?: Maybe<Tubings_Type_Min_Fields>;
};


/** aggregate fields of "tubings_type" */
export type Tubings_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tubings_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "tubings_type". All fields are combined with a logical 'AND'. */
export type Tubings_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Tubings_Type_Bool_Exp>>;
  _not?: InputMaybe<Tubings_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Tubings_Type_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "tubings_type" */
export enum Tubings_Type_Constraint {
  /** unique or primary key constraint on columns "value" */
  TubingsTypePkey = 'tubings_type_pkey'
}

export enum Tubings_Type_Enum {
  /** Both */
  Both = 'both',
  /** Bypass */
  Bypass = 'bypass',
  /** Normal */
  Normal = 'normal'
}

/** Boolean expression to compare columns of type "tubings_type_enum". All fields are combined with logical 'AND'. */
export type Tubings_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Tubings_Type_Enum>;
  _in?: InputMaybe<Array<Tubings_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Tubings_Type_Enum>;
  _nin?: InputMaybe<Array<Tubings_Type_Enum>>;
};

/** input type for inserting data into table "tubings_type" */
export type Tubings_Type_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Tubings_Type_Max_Fields = {
  __typename: 'tubings_type_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Tubings_Type_Min_Fields = {
  __typename: 'tubings_type_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "tubings_type" */
export type Tubings_Type_Mutation_Response = {
  __typename: 'tubings_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Tubings_Type>;
};

/** on_conflict condition type for table "tubings_type" */
export type Tubings_Type_On_Conflict = {
  constraint: Tubings_Type_Constraint;
  update_columns?: Array<Tubings_Type_Update_Column>;
  where?: InputMaybe<Tubings_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "tubings_type". */
export type Tubings_Type_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: tubings_type */
export type Tubings_Type_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "tubings_type" */
export enum Tubings_Type_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "tubings_type" */
export type Tubings_Type_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "tubings_type" */
export type Tubings_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tubings_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Tubings_Type_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "tubings_type" */
export enum Tubings_Type_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Tubings_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tubings_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Tubings_Type_Bool_Exp;
};

/** update columns of table "tubings" */
export enum Tubings_Update_Column {
  /** column name */
  AuthorId = 'author_id',
  /** column name */
  CouplingOuterDiameterInches = 'coupling_outer_diameter_inches',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  DriftInches = 'drift_inches',
  /** column name */
  Id = 'id',
  /** column name */
  ImperialName = 'imperial_name',
  /** column name */
  ImportedSizingId = 'imported_sizing_id',
  /** column name */
  IncludeEcopetrolTimestamp = 'include_ecopetrol_timestamp',
  /** column name */
  IncludeKocTimestamp = 'include_koc_timestamp',
  /** column name */
  InteriorDiameterInches = 'interior_diameter_inches',
  /** column name */
  MetricName = 'metric_name',
  /** column name */
  OnlyEcopetrolTimestamp = 'only_ecopetrol_timestamp',
  /** column name */
  OnlyKocTimestamp = 'only_koc_timestamp',
  /** column name */
  OuterDiameterInches = 'outer_diameter_inches',
  /** column name */
  PoundPerFoot = 'pound_per_foot',
  /** column name */
  TubingType = 'tubing_type',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Tubings_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Tubings_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tubings_Set_Input>;
  /** filter the rows which have to be updated */
  where: Tubings_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Tubings_Var_Pop_Fields = {
  __typename: 'tubings_var_pop_fields';
  coupling_outer_diameter_inches?: Maybe<Scalars['Float']['output']>;
  drift_inches?: Maybe<Scalars['Float']['output']>;
  imported_sizing_id?: Maybe<Scalars['Float']['output']>;
  interior_diameter_inches?: Maybe<Scalars['Float']['output']>;
  outer_diameter_inches?: Maybe<Scalars['Float']['output']>;
  pound_per_foot?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "tubings" */
export type Tubings_Var_Pop_Order_By = {
  coupling_outer_diameter_inches?: InputMaybe<Order_By>;
  drift_inches?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  interior_diameter_inches?: InputMaybe<Order_By>;
  outer_diameter_inches?: InputMaybe<Order_By>;
  pound_per_foot?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Tubings_Var_Samp_Fields = {
  __typename: 'tubings_var_samp_fields';
  coupling_outer_diameter_inches?: Maybe<Scalars['Float']['output']>;
  drift_inches?: Maybe<Scalars['Float']['output']>;
  imported_sizing_id?: Maybe<Scalars['Float']['output']>;
  interior_diameter_inches?: Maybe<Scalars['Float']['output']>;
  outer_diameter_inches?: Maybe<Scalars['Float']['output']>;
  pound_per_foot?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "tubings" */
export type Tubings_Var_Samp_Order_By = {
  coupling_outer_diameter_inches?: InputMaybe<Order_By>;
  drift_inches?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  interior_diameter_inches?: InputMaybe<Order_By>;
  outer_diameter_inches?: InputMaybe<Order_By>;
  pound_per_foot?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Tubings_Variance_Fields = {
  __typename: 'tubings_variance_fields';
  coupling_outer_diameter_inches?: Maybe<Scalars['Float']['output']>;
  drift_inches?: Maybe<Scalars['Float']['output']>;
  imported_sizing_id?: Maybe<Scalars['Float']['output']>;
  interior_diameter_inches?: Maybe<Scalars['Float']['output']>;
  outer_diameter_inches?: Maybe<Scalars['Float']['output']>;
  pound_per_foot?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "tubings" */
export type Tubings_Variance_Order_By = {
  coupling_outer_diameter_inches?: InputMaybe<Order_By>;
  drift_inches?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  interior_diameter_inches?: InputMaybe<Order_By>;
  outer_diameter_inches?: InputMaybe<Order_By>;
  pound_per_foot?: InputMaybe<Order_By>;
};

/** columns and relationships of "under_saturated_oil_options" */
export type Under_Saturated_Oil_Options = {
  __typename: 'under_saturated_oil_options';
  comment?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

/** aggregated selection of "under_saturated_oil_options" */
export type Under_Saturated_Oil_Options_Aggregate = {
  __typename: 'under_saturated_oil_options_aggregate';
  aggregate?: Maybe<Under_Saturated_Oil_Options_Aggregate_Fields>;
  nodes: Array<Under_Saturated_Oil_Options>;
};

/** aggregate fields of "under_saturated_oil_options" */
export type Under_Saturated_Oil_Options_Aggregate_Fields = {
  __typename: 'under_saturated_oil_options_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Under_Saturated_Oil_Options_Max_Fields>;
  min?: Maybe<Under_Saturated_Oil_Options_Min_Fields>;
};


/** aggregate fields of "under_saturated_oil_options" */
export type Under_Saturated_Oil_Options_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Under_Saturated_Oil_Options_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "under_saturated_oil_options". All fields are combined with a logical 'AND'. */
export type Under_Saturated_Oil_Options_Bool_Exp = {
  _and?: InputMaybe<Array<Under_Saturated_Oil_Options_Bool_Exp>>;
  _not?: InputMaybe<Under_Saturated_Oil_Options_Bool_Exp>;
  _or?: InputMaybe<Array<Under_Saturated_Oil_Options_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "under_saturated_oil_options" */
export enum Under_Saturated_Oil_Options_Constraint {
  /** unique or primary key constraint on columns "value" */
  UnderSaturatedOilOptionsPkey = 'under_saturated_oil_options_pkey'
}

export enum Under_Saturated_Oil_Options_Enum {
  /** Beggs & Robinson */
  BeggsRobinson = 'beggs_robinson',
  /** De Ghetto Heavy Oil */
  DeGhettoHeavyOil = 'de_ghetto_heavy_oil',
  /** Glaso (North Sea) */
  GlasoNorthSea = 'glaso_north_sea',
  /** Kartoatmodjo & Schmidt */
  KartoatmodjoSchmidt = 'kartoatmodjo_schmidt'
}

/** Boolean expression to compare columns of type "under_saturated_oil_options_enum". All fields are combined with logical 'AND'. */
export type Under_Saturated_Oil_Options_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Under_Saturated_Oil_Options_Enum>;
  _in?: InputMaybe<Array<Under_Saturated_Oil_Options_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Under_Saturated_Oil_Options_Enum>;
  _nin?: InputMaybe<Array<Under_Saturated_Oil_Options_Enum>>;
};

/** input type for inserting data into table "under_saturated_oil_options" */
export type Under_Saturated_Oil_Options_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Under_Saturated_Oil_Options_Max_Fields = {
  __typename: 'under_saturated_oil_options_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Under_Saturated_Oil_Options_Min_Fields = {
  __typename: 'under_saturated_oil_options_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "under_saturated_oil_options" */
export type Under_Saturated_Oil_Options_Mutation_Response = {
  __typename: 'under_saturated_oil_options_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Under_Saturated_Oil_Options>;
};

/** input type for inserting object relation for remote table "under_saturated_oil_options" */
export type Under_Saturated_Oil_Options_Obj_Rel_Insert_Input = {
  data: Under_Saturated_Oil_Options_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Under_Saturated_Oil_Options_On_Conflict>;
};

/** on_conflict condition type for table "under_saturated_oil_options" */
export type Under_Saturated_Oil_Options_On_Conflict = {
  constraint: Under_Saturated_Oil_Options_Constraint;
  update_columns?: Array<Under_Saturated_Oil_Options_Update_Column>;
  where?: InputMaybe<Under_Saturated_Oil_Options_Bool_Exp>;
};

/** Ordering options when selecting data from "under_saturated_oil_options". */
export type Under_Saturated_Oil_Options_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: under_saturated_oil_options */
export type Under_Saturated_Oil_Options_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "under_saturated_oil_options" */
export enum Under_Saturated_Oil_Options_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "under_saturated_oil_options" */
export type Under_Saturated_Oil_Options_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "under_saturated_oil_options" */
export type Under_Saturated_Oil_Options_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Under_Saturated_Oil_Options_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Under_Saturated_Oil_Options_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "under_saturated_oil_options" */
export enum Under_Saturated_Oil_Options_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Under_Saturated_Oil_Options_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Under_Saturated_Oil_Options_Set_Input>;
  /** filter the rows which have to be updated */
  where: Under_Saturated_Oil_Options_Bool_Exp;
};

/** columns and relationships of "user_eula_acceptance" */
export type User_Eula_Acceptance = {
  __typename: 'user_eula_acceptance';
  /** An object relationship */
  eula: Eula;
  eula_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  signed_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Users;
  user_id: Scalars['String']['output'];
};

/** aggregated selection of "user_eula_acceptance" */
export type User_Eula_Acceptance_Aggregate = {
  __typename: 'user_eula_acceptance_aggregate';
  aggregate?: Maybe<User_Eula_Acceptance_Aggregate_Fields>;
  nodes: Array<User_Eula_Acceptance>;
};

/** aggregate fields of "user_eula_acceptance" */
export type User_Eula_Acceptance_Aggregate_Fields = {
  __typename: 'user_eula_acceptance_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<User_Eula_Acceptance_Max_Fields>;
  min?: Maybe<User_Eula_Acceptance_Min_Fields>;
};


/** aggregate fields of "user_eula_acceptance" */
export type User_Eula_Acceptance_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Eula_Acceptance_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "user_eula_acceptance". All fields are combined with a logical 'AND'. */
export type User_Eula_Acceptance_Bool_Exp = {
  _and?: InputMaybe<Array<User_Eula_Acceptance_Bool_Exp>>;
  _not?: InputMaybe<User_Eula_Acceptance_Bool_Exp>;
  _or?: InputMaybe<Array<User_Eula_Acceptance_Bool_Exp>>;
  eula?: InputMaybe<Eula_Bool_Exp>;
  eula_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  signed_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_eula_acceptance" */
export enum User_Eula_Acceptance_Constraint {
  /** unique or primary key constraint on columns "user_id", "eula_id" */
  UniqueUserEulaAcceptance = 'unique_user_eula_acceptance',
  /** unique or primary key constraint on columns "id" */
  UserEulaAcceptancePkey = 'user_eula_acceptance_pkey'
}

/** input type for inserting data into table "user_eula_acceptance" */
export type User_Eula_Acceptance_Insert_Input = {
  eula?: InputMaybe<Eula_Obj_Rel_Insert_Input>;
  eula_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  signed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type User_Eula_Acceptance_Max_Fields = {
  __typename: 'user_eula_acceptance_max_fields';
  eula_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  signed_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type User_Eula_Acceptance_Min_Fields = {
  __typename: 'user_eula_acceptance_min_fields';
  eula_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  signed_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "user_eula_acceptance" */
export type User_Eula_Acceptance_Mutation_Response = {
  __typename: 'user_eula_acceptance_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Eula_Acceptance>;
};

/** on_conflict condition type for table "user_eula_acceptance" */
export type User_Eula_Acceptance_On_Conflict = {
  constraint: User_Eula_Acceptance_Constraint;
  update_columns?: Array<User_Eula_Acceptance_Update_Column>;
  where?: InputMaybe<User_Eula_Acceptance_Bool_Exp>;
};

/** Ordering options when selecting data from "user_eula_acceptance". */
export type User_Eula_Acceptance_Order_By = {
  eula?: InputMaybe<Eula_Order_By>;
  eula_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  signed_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_eula_acceptance */
export type User_Eula_Acceptance_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "user_eula_acceptance" */
export enum User_Eula_Acceptance_Select_Column {
  /** column name */
  EulaId = 'eula_id',
  /** column name */
  Id = 'id',
  /** column name */
  SignedAt = 'signed_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "user_eula_acceptance" */
export type User_Eula_Acceptance_Set_Input = {
  eula_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  signed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "user_eula_acceptance" */
export type User_Eula_Acceptance_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Eula_Acceptance_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Eula_Acceptance_Stream_Cursor_Value_Input = {
  eula_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  signed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "user_eula_acceptance" */
export enum User_Eula_Acceptance_Update_Column {
  /** column name */
  EulaId = 'eula_id',
  /** column name */
  Id = 'id',
  /** column name */
  SignedAt = 'signed_at',
  /** column name */
  UserId = 'user_id'
}

export type User_Eula_Acceptance_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Eula_Acceptance_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Eula_Acceptance_Bool_Exp;
};

/** columns and relationships of "users" */
export type Users = {
  __typename: 'users';
  /** An array relationship */
  cables: Array<Cables>;
  /** An aggregate relationship */
  cables_aggregate: Cables_Aggregate;
  /** An array relationship */
  casings: Array<Casings>;
  /** An aggregate relationship */
  casings_aggregate: Casings_Aggregate;
  created_at: Scalars['timestamptz']['output'];
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An array relationship */
  deviation_surveys: Array<Deviation_Survey>;
  /** An aggregate relationship */
  deviation_surveys_aggregate: Deviation_Survey_Aggregate;
  display_name?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  hal_identifier?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  housings: Array<Housings>;
  /** An aggregate relationship */
  housings_aggregate: Housings_Aggregate;
  id: Scalars['String']['output'];
  /** An array relationship */
  intakes: Array<Intakes>;
  /** An aggregate relationship */
  intakes_aggregate: Intakes_Aggregate;
  /** An array relationship */
  motor_lead_extensions: Array<Motor_Lead_Extensions>;
  /** An aggregate relationship */
  motor_lead_extensions_aggregate: Motor_Lead_Extensions_Aggregate;
  /** An array relationship */
  motors: Array<Motors>;
  /** An aggregate relationship */
  motors_aggregate: Motors_Aggregate;
  /** An array relationship */
  pumps: Array<Pumps>;
  /** An aggregate relationship */
  pumps_aggregate: Pumps_Aggregate;
  /** An array relationship */
  seals: Array<Seals>;
  /** An aggregate relationship */
  seals_aggregate: Seals_Aggregate;
  /** An array relationship */
  sensors: Array<Sensors>;
  /** An aggregate relationship */
  sensors_aggregate: Sensors_Aggregate;
  /** An array relationship */
  sizing_imports: Array<Sizing_Imports>;
  /** An aggregate relationship */
  sizing_imports_aggregate: Sizing_Imports_Aggregate;
  /** An array relationship */
  step_down_transformers: Array<Step_Down_Transformers>;
  /** An aggregate relationship */
  step_down_transformers_aggregate: Step_Down_Transformers_Aggregate;
  /** An array relationship */
  step_up_transformers: Array<Step_Up_Transformers>;
  /** An aggregate relationship */
  step_up_transformers_aggregate: Step_Up_Transformers_Aggregate;
  /** An array relationship */
  switchboards: Array<Switchboards>;
  /** An aggregate relationship */
  switchboards_aggregate: Switchboards_Aggregate;
  /** An array relationship */
  tubings: Array<Tubings>;
  /** An aggregate relationship */
  tubings_aggregate: Tubings_Aggregate;
  updated_at: Scalars['timestamptz']['output'];
  username?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  variable_speed_drives: Array<Variable_Speed_Drives>;
  /** An aggregate relationship */
  variable_speed_drives_aggregate: Variable_Speed_Drives_Aggregate;
};


/** columns and relationships of "users" */
export type UsersCablesArgs = {
  distinct_on?: InputMaybe<Array<Cables_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cables_Order_By>>;
  where?: InputMaybe<Cables_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersCables_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Cables_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cables_Order_By>>;
  where?: InputMaybe<Cables_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersCasingsArgs = {
  distinct_on?: InputMaybe<Array<Casings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Casings_Order_By>>;
  where?: InputMaybe<Casings_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersCasings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Casings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Casings_Order_By>>;
  where?: InputMaybe<Casings_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersDeviation_SurveysArgs = {
  distinct_on?: InputMaybe<Array<Deviation_Survey_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Deviation_Survey_Order_By>>;
  where?: InputMaybe<Deviation_Survey_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersDeviation_Surveys_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Deviation_Survey_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Deviation_Survey_Order_By>>;
  where?: InputMaybe<Deviation_Survey_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersHousingsArgs = {
  distinct_on?: InputMaybe<Array<Housings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Housings_Order_By>>;
  where?: InputMaybe<Housings_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersHousings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Housings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Housings_Order_By>>;
  where?: InputMaybe<Housings_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersIntakesArgs = {
  distinct_on?: InputMaybe<Array<Intakes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Intakes_Order_By>>;
  where?: InputMaybe<Intakes_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersIntakes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Intakes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Intakes_Order_By>>;
  where?: InputMaybe<Intakes_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersMotor_Lead_ExtensionsArgs = {
  distinct_on?: InputMaybe<Array<Motor_Lead_Extensions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Motor_Lead_Extensions_Order_By>>;
  where?: InputMaybe<Motor_Lead_Extensions_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersMotor_Lead_Extensions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Motor_Lead_Extensions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Motor_Lead_Extensions_Order_By>>;
  where?: InputMaybe<Motor_Lead_Extensions_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersMotorsArgs = {
  distinct_on?: InputMaybe<Array<Motors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Motors_Order_By>>;
  where?: InputMaybe<Motors_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersMotors_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Motors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Motors_Order_By>>;
  where?: InputMaybe<Motors_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersPumpsArgs = {
  distinct_on?: InputMaybe<Array<Pumps_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pumps_Order_By>>;
  where?: InputMaybe<Pumps_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersPumps_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pumps_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pumps_Order_By>>;
  where?: InputMaybe<Pumps_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersSealsArgs = {
  distinct_on?: InputMaybe<Array<Seals_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Seals_Order_By>>;
  where?: InputMaybe<Seals_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersSeals_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Seals_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Seals_Order_By>>;
  where?: InputMaybe<Seals_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersSensorsArgs = {
  distinct_on?: InputMaybe<Array<Sensors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sensors_Order_By>>;
  where?: InputMaybe<Sensors_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersSensors_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sensors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sensors_Order_By>>;
  where?: InputMaybe<Sensors_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersSizing_ImportsArgs = {
  distinct_on?: InputMaybe<Array<Sizing_Imports_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sizing_Imports_Order_By>>;
  where?: InputMaybe<Sizing_Imports_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersSizing_Imports_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sizing_Imports_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sizing_Imports_Order_By>>;
  where?: InputMaybe<Sizing_Imports_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersStep_Down_TransformersArgs = {
  distinct_on?: InputMaybe<Array<Step_Down_Transformers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Step_Down_Transformers_Order_By>>;
  where?: InputMaybe<Step_Down_Transformers_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersStep_Down_Transformers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Step_Down_Transformers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Step_Down_Transformers_Order_By>>;
  where?: InputMaybe<Step_Down_Transformers_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersStep_Up_TransformersArgs = {
  distinct_on?: InputMaybe<Array<Step_Up_Transformers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Step_Up_Transformers_Order_By>>;
  where?: InputMaybe<Step_Up_Transformers_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersStep_Up_Transformers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Step_Up_Transformers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Step_Up_Transformers_Order_By>>;
  where?: InputMaybe<Step_Up_Transformers_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersSwitchboardsArgs = {
  distinct_on?: InputMaybe<Array<Switchboards_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Switchboards_Order_By>>;
  where?: InputMaybe<Switchboards_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersSwitchboards_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Switchboards_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Switchboards_Order_By>>;
  where?: InputMaybe<Switchboards_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersTubingsArgs = {
  distinct_on?: InputMaybe<Array<Tubings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tubings_Order_By>>;
  where?: InputMaybe<Tubings_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersTubings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tubings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tubings_Order_By>>;
  where?: InputMaybe<Tubings_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersVariable_Speed_DrivesArgs = {
  distinct_on?: InputMaybe<Array<Variable_Speed_Drives_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variable_Speed_Drives_Order_By>>;
  where?: InputMaybe<Variable_Speed_Drives_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersVariable_Speed_Drives_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Variable_Speed_Drives_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variable_Speed_Drives_Order_By>>;
  where?: InputMaybe<Variable_Speed_Drives_Bool_Exp>;
};

/** aggregated selection of "users" */
export type Users_Aggregate = {
  __typename: 'users_aggregate';
  aggregate?: Maybe<Users_Aggregate_Fields>;
  nodes: Array<Users>;
};

/** aggregate fields of "users" */
export type Users_Aggregate_Fields = {
  __typename: 'users_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Users_Max_Fields>;
  min?: Maybe<Users_Min_Fields>;
};


/** aggregate fields of "users" */
export type Users_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Users_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "users". All fields are combined with a logical 'AND'. */
export type Users_Bool_Exp = {
  _and?: InputMaybe<Array<Users_Bool_Exp>>;
  _not?: InputMaybe<Users_Bool_Exp>;
  _or?: InputMaybe<Array<Users_Bool_Exp>>;
  cables?: InputMaybe<Cables_Bool_Exp>;
  cables_aggregate?: InputMaybe<Cables_Aggregate_Bool_Exp>;
  casings?: InputMaybe<Casings_Bool_Exp>;
  casings_aggregate?: InputMaybe<Casings_Aggregate_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deviation_surveys?: InputMaybe<Deviation_Survey_Bool_Exp>;
  deviation_surveys_aggregate?: InputMaybe<Deviation_Survey_Aggregate_Bool_Exp>;
  display_name?: InputMaybe<String_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  hal_identifier?: InputMaybe<String_Comparison_Exp>;
  housings?: InputMaybe<Housings_Bool_Exp>;
  housings_aggregate?: InputMaybe<Housings_Aggregate_Bool_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  intakes?: InputMaybe<Intakes_Bool_Exp>;
  intakes_aggregate?: InputMaybe<Intakes_Aggregate_Bool_Exp>;
  motor_lead_extensions?: InputMaybe<Motor_Lead_Extensions_Bool_Exp>;
  motor_lead_extensions_aggregate?: InputMaybe<Motor_Lead_Extensions_Aggregate_Bool_Exp>;
  motors?: InputMaybe<Motors_Bool_Exp>;
  motors_aggregate?: InputMaybe<Motors_Aggregate_Bool_Exp>;
  pumps?: InputMaybe<Pumps_Bool_Exp>;
  pumps_aggregate?: InputMaybe<Pumps_Aggregate_Bool_Exp>;
  seals?: InputMaybe<Seals_Bool_Exp>;
  seals_aggregate?: InputMaybe<Seals_Aggregate_Bool_Exp>;
  sensors?: InputMaybe<Sensors_Bool_Exp>;
  sensors_aggregate?: InputMaybe<Sensors_Aggregate_Bool_Exp>;
  sizing_imports?: InputMaybe<Sizing_Imports_Bool_Exp>;
  sizing_imports_aggregate?: InputMaybe<Sizing_Imports_Aggregate_Bool_Exp>;
  step_down_transformers?: InputMaybe<Step_Down_Transformers_Bool_Exp>;
  step_down_transformers_aggregate?: InputMaybe<Step_Down_Transformers_Aggregate_Bool_Exp>;
  step_up_transformers?: InputMaybe<Step_Up_Transformers_Bool_Exp>;
  step_up_transformers_aggregate?: InputMaybe<Step_Up_Transformers_Aggregate_Bool_Exp>;
  switchboards?: InputMaybe<Switchboards_Bool_Exp>;
  switchboards_aggregate?: InputMaybe<Switchboards_Aggregate_Bool_Exp>;
  tubings?: InputMaybe<Tubings_Bool_Exp>;
  tubings_aggregate?: InputMaybe<Tubings_Aggregate_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  username?: InputMaybe<String_Comparison_Exp>;
  variable_speed_drives?: InputMaybe<Variable_Speed_Drives_Bool_Exp>;
  variable_speed_drives_aggregate?: InputMaybe<Variable_Speed_Drives_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "users" */
export enum Users_Constraint {
  /** unique or primary key constraint on columns "id" */
  UsersPkey = 'users_pkey'
}

/** input type for inserting data into table "users" */
export type Users_Insert_Input = {
  cables?: InputMaybe<Cables_Arr_Rel_Insert_Input>;
  casings?: InputMaybe<Casings_Arr_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deviation_surveys?: InputMaybe<Deviation_Survey_Arr_Rel_Insert_Input>;
  display_name?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  hal_identifier?: InputMaybe<Scalars['String']['input']>;
  housings?: InputMaybe<Housings_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['String']['input']>;
  intakes?: InputMaybe<Intakes_Arr_Rel_Insert_Input>;
  motor_lead_extensions?: InputMaybe<Motor_Lead_Extensions_Arr_Rel_Insert_Input>;
  motors?: InputMaybe<Motors_Arr_Rel_Insert_Input>;
  pumps?: InputMaybe<Pumps_Arr_Rel_Insert_Input>;
  seals?: InputMaybe<Seals_Arr_Rel_Insert_Input>;
  sensors?: InputMaybe<Sensors_Arr_Rel_Insert_Input>;
  sizing_imports?: InputMaybe<Sizing_Imports_Arr_Rel_Insert_Input>;
  step_down_transformers?: InputMaybe<Step_Down_Transformers_Arr_Rel_Insert_Input>;
  step_up_transformers?: InputMaybe<Step_Up_Transformers_Arr_Rel_Insert_Input>;
  switchboards?: InputMaybe<Switchboards_Arr_Rel_Insert_Input>;
  tubings?: InputMaybe<Tubings_Arr_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
  variable_speed_drives?: InputMaybe<Variable_Speed_Drives_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Users_Max_Fields = {
  __typename: 'users_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  display_name?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  hal_identifier?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Users_Min_Fields = {
  __typename: 'users_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  display_name?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  hal_identifier?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "users" */
export type Users_Mutation_Response = {
  __typename: 'users_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Users>;
};

/** input type for inserting object relation for remote table "users" */
export type Users_Obj_Rel_Insert_Input = {
  data: Users_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Users_On_Conflict>;
};

/** on_conflict condition type for table "users" */
export type Users_On_Conflict = {
  constraint: Users_Constraint;
  update_columns?: Array<Users_Update_Column>;
  where?: InputMaybe<Users_Bool_Exp>;
};

/** Ordering options when selecting data from "users". */
export type Users_Order_By = {
  cables_aggregate?: InputMaybe<Cables_Aggregate_Order_By>;
  casings_aggregate?: InputMaybe<Casings_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  deviation_surveys_aggregate?: InputMaybe<Deviation_Survey_Aggregate_Order_By>;
  display_name?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  hal_identifier?: InputMaybe<Order_By>;
  housings_aggregate?: InputMaybe<Housings_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  intakes_aggregate?: InputMaybe<Intakes_Aggregate_Order_By>;
  motor_lead_extensions_aggregate?: InputMaybe<Motor_Lead_Extensions_Aggregate_Order_By>;
  motors_aggregate?: InputMaybe<Motors_Aggregate_Order_By>;
  pumps_aggregate?: InputMaybe<Pumps_Aggregate_Order_By>;
  seals_aggregate?: InputMaybe<Seals_Aggregate_Order_By>;
  sensors_aggregate?: InputMaybe<Sensors_Aggregate_Order_By>;
  sizing_imports_aggregate?: InputMaybe<Sizing_Imports_Aggregate_Order_By>;
  step_down_transformers_aggregate?: InputMaybe<Step_Down_Transformers_Aggregate_Order_By>;
  step_up_transformers_aggregate?: InputMaybe<Step_Up_Transformers_Aggregate_Order_By>;
  switchboards_aggregate?: InputMaybe<Switchboards_Aggregate_Order_By>;
  tubings_aggregate?: InputMaybe<Tubings_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  username?: InputMaybe<Order_By>;
  variable_speed_drives_aggregate?: InputMaybe<Variable_Speed_Drives_Aggregate_Order_By>;
};

/** primary key columns input for table: users */
export type Users_Pk_Columns_Input = {
  id: Scalars['String']['input'];
};

/** select columns of table "users" */
export enum Users_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  Email = 'email',
  /** column name */
  HalIdentifier = 'hal_identifier',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Username = 'username'
}

/** input type for updating data in table "users" */
export type Users_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  display_name?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  hal_identifier?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "users" */
export type Users_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Users_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Users_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  display_name?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  hal_identifier?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "users" */
export enum Users_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  Email = 'email',
  /** column name */
  HalIdentifier = 'hal_identifier',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Username = 'username'
}

export type Users_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Users_Set_Input>;
  /** filter the rows which have to be updated */
  where: Users_Bool_Exp;
};

/** Boolean expression to compare columns of type "uuid". All fields are combined with logical 'AND'. */
export type Uuid_Array_Comparison_Exp = {
  /** is the array contained in the given array value */
  _contained_in?: InputMaybe<Array<Scalars['uuid']['input']>>;
  /** does the array contain the given value */
  _contains?: InputMaybe<Array<Scalars['uuid']['input']>>;
  _eq?: InputMaybe<Array<Scalars['uuid']['input']>>;
  _gt?: InputMaybe<Array<Scalars['uuid']['input']>>;
  _gte?: InputMaybe<Array<Scalars['uuid']['input']>>;
  _in?: InputMaybe<Array<Array<Scalars['uuid']['input']>>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Array<Scalars['uuid']['input']>>;
  _lte?: InputMaybe<Array<Scalars['uuid']['input']>>;
  _neq?: InputMaybe<Array<Scalars['uuid']['input']>>;
  _nin?: InputMaybe<Array<Array<Scalars['uuid']['input']>>>;
};

/** Boolean expression to compare columns of type "uuid". All fields are combined with logical 'AND'. */
export type Uuid_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['uuid']['input']>;
  _gt?: InputMaybe<Scalars['uuid']['input']>;
  _gte?: InputMaybe<Scalars['uuid']['input']>;
  _in?: InputMaybe<Array<Scalars['uuid']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['uuid']['input']>;
  _lte?: InputMaybe<Scalars['uuid']['input']>;
  _neq?: InputMaybe<Scalars['uuid']['input']>;
  _nin?: InputMaybe<Array<Scalars['uuid']['input']>>;
};

/** columns and relationships of "variable_speed_drives" */
export type Variable_Speed_Drives = {
  __typename: 'variable_speed_drives';
  author_id: Scalars['String']['output'];
  created_at: Scalars['timestamptz']['output'];
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  enclosure?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  imported_sizing_id?: Maybe<Scalars['Int']['output']>;
  include_ecopetrol_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  include_koc_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  kva?: Maybe<Scalars['Int']['output']>;
  manufacturer?: Maybe<Scalars['String']['output']>;
  max_amps?: Maybe<Scalars['Int']['output']>;
  only_ecopetrol_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  only_koc_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  part_number?: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "prioritizevsdmanufacturer" */
  prioritized_manufacturer?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  sizing_import?: Maybe<Sizing_Imports>;
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Users;
  vsd_type?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "variable_speed_drives" */
export type Variable_Speed_Drives_Aggregate = {
  __typename: 'variable_speed_drives_aggregate';
  aggregate?: Maybe<Variable_Speed_Drives_Aggregate_Fields>;
  nodes: Array<Variable_Speed_Drives>;
};

export type Variable_Speed_Drives_Aggregate_Bool_Exp = {
  count?: InputMaybe<Variable_Speed_Drives_Aggregate_Bool_Exp_Count>;
};

export type Variable_Speed_Drives_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Variable_Speed_Drives_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Variable_Speed_Drives_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "variable_speed_drives" */
export type Variable_Speed_Drives_Aggregate_Fields = {
  __typename: 'variable_speed_drives_aggregate_fields';
  avg?: Maybe<Variable_Speed_Drives_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Variable_Speed_Drives_Max_Fields>;
  min?: Maybe<Variable_Speed_Drives_Min_Fields>;
  stddev?: Maybe<Variable_Speed_Drives_Stddev_Fields>;
  stddev_pop?: Maybe<Variable_Speed_Drives_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Variable_Speed_Drives_Stddev_Samp_Fields>;
  sum?: Maybe<Variable_Speed_Drives_Sum_Fields>;
  var_pop?: Maybe<Variable_Speed_Drives_Var_Pop_Fields>;
  var_samp?: Maybe<Variable_Speed_Drives_Var_Samp_Fields>;
  variance?: Maybe<Variable_Speed_Drives_Variance_Fields>;
};


/** aggregate fields of "variable_speed_drives" */
export type Variable_Speed_Drives_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Variable_Speed_Drives_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "variable_speed_drives" */
export type Variable_Speed_Drives_Aggregate_Order_By = {
  avg?: InputMaybe<Variable_Speed_Drives_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Variable_Speed_Drives_Max_Order_By>;
  min?: InputMaybe<Variable_Speed_Drives_Min_Order_By>;
  stddev?: InputMaybe<Variable_Speed_Drives_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Variable_Speed_Drives_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Variable_Speed_Drives_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Variable_Speed_Drives_Sum_Order_By>;
  var_pop?: InputMaybe<Variable_Speed_Drives_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Variable_Speed_Drives_Var_Samp_Order_By>;
  variance?: InputMaybe<Variable_Speed_Drives_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "variable_speed_drives" */
export type Variable_Speed_Drives_Arr_Rel_Insert_Input = {
  data: Array<Variable_Speed_Drives_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Variable_Speed_Drives_On_Conflict>;
};

/** aggregate avg on columns */
export type Variable_Speed_Drives_Avg_Fields = {
  __typename: 'variable_speed_drives_avg_fields';
  imported_sizing_id?: Maybe<Scalars['Float']['output']>;
  kva?: Maybe<Scalars['Float']['output']>;
  max_amps?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "variable_speed_drives" */
export type Variable_Speed_Drives_Avg_Order_By = {
  imported_sizing_id?: InputMaybe<Order_By>;
  kva?: InputMaybe<Order_By>;
  max_amps?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "variable_speed_drives". All fields are combined with a logical 'AND'. */
export type Variable_Speed_Drives_Bool_Exp = {
  _and?: InputMaybe<Array<Variable_Speed_Drives_Bool_Exp>>;
  _not?: InputMaybe<Variable_Speed_Drives_Bool_Exp>;
  _or?: InputMaybe<Array<Variable_Speed_Drives_Bool_Exp>>;
  author_id?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  enclosure?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  imported_sizing_id?: InputMaybe<Int_Comparison_Exp>;
  include_ecopetrol_timestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  include_koc_timestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  kva?: InputMaybe<Int_Comparison_Exp>;
  manufacturer?: InputMaybe<String_Comparison_Exp>;
  max_amps?: InputMaybe<Int_Comparison_Exp>;
  only_ecopetrol_timestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  only_koc_timestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  part_number?: InputMaybe<String_Comparison_Exp>;
  prioritized_manufacturer?: InputMaybe<String_Comparison_Exp>;
  sizing_import?: InputMaybe<Sizing_Imports_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  vsd_type?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "variable_speed_drives" */
export enum Variable_Speed_Drives_Constraint {
  /** unique or primary key constraint on columns "id" */
  VariableSpeedDrivesPkey = 'variable_speed_drives_pkey'
}

/** input type for incrementing numeric columns in table "variable_speed_drives" */
export type Variable_Speed_Drives_Inc_Input = {
  imported_sizing_id?: InputMaybe<Scalars['Int']['input']>;
  kva?: InputMaybe<Scalars['Int']['input']>;
  max_amps?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "variable_speed_drives" */
export type Variable_Speed_Drives_Insert_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  enclosure?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  imported_sizing_id?: InputMaybe<Scalars['Int']['input']>;
  include_ecopetrol_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  include_koc_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  kva?: InputMaybe<Scalars['Int']['input']>;
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  max_amps?: InputMaybe<Scalars['Int']['input']>;
  only_ecopetrol_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  only_koc_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  part_number?: InputMaybe<Scalars['String']['input']>;
  sizing_import?: InputMaybe<Sizing_Imports_Obj_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  vsd_type?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Variable_Speed_Drives_Max_Fields = {
  __typename: 'variable_speed_drives_max_fields';
  author_id?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  enclosure?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  imported_sizing_id?: Maybe<Scalars['Int']['output']>;
  include_ecopetrol_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  include_koc_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  kva?: Maybe<Scalars['Int']['output']>;
  manufacturer?: Maybe<Scalars['String']['output']>;
  max_amps?: Maybe<Scalars['Int']['output']>;
  only_ecopetrol_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  only_koc_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  part_number?: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "prioritizevsdmanufacturer" */
  prioritized_manufacturer?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  vsd_type?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "variable_speed_drives" */
export type Variable_Speed_Drives_Max_Order_By = {
  author_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  enclosure?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  include_ecopetrol_timestamp?: InputMaybe<Order_By>;
  include_koc_timestamp?: InputMaybe<Order_By>;
  kva?: InputMaybe<Order_By>;
  manufacturer?: InputMaybe<Order_By>;
  max_amps?: InputMaybe<Order_By>;
  only_ecopetrol_timestamp?: InputMaybe<Order_By>;
  only_koc_timestamp?: InputMaybe<Order_By>;
  part_number?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  vsd_type?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Variable_Speed_Drives_Min_Fields = {
  __typename: 'variable_speed_drives_min_fields';
  author_id?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  enclosure?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  imported_sizing_id?: Maybe<Scalars['Int']['output']>;
  include_ecopetrol_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  include_koc_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  kva?: Maybe<Scalars['Int']['output']>;
  manufacturer?: Maybe<Scalars['String']['output']>;
  max_amps?: Maybe<Scalars['Int']['output']>;
  only_ecopetrol_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  only_koc_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  part_number?: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "prioritizevsdmanufacturer" */
  prioritized_manufacturer?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  vsd_type?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "variable_speed_drives" */
export type Variable_Speed_Drives_Min_Order_By = {
  author_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  enclosure?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  include_ecopetrol_timestamp?: InputMaybe<Order_By>;
  include_koc_timestamp?: InputMaybe<Order_By>;
  kva?: InputMaybe<Order_By>;
  manufacturer?: InputMaybe<Order_By>;
  max_amps?: InputMaybe<Order_By>;
  only_ecopetrol_timestamp?: InputMaybe<Order_By>;
  only_koc_timestamp?: InputMaybe<Order_By>;
  part_number?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  vsd_type?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "variable_speed_drives" */
export type Variable_Speed_Drives_Mutation_Response = {
  __typename: 'variable_speed_drives_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Variable_Speed_Drives>;
};

/** input type for inserting object relation for remote table "variable_speed_drives" */
export type Variable_Speed_Drives_Obj_Rel_Insert_Input = {
  data: Variable_Speed_Drives_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Variable_Speed_Drives_On_Conflict>;
};

/** on_conflict condition type for table "variable_speed_drives" */
export type Variable_Speed_Drives_On_Conflict = {
  constraint: Variable_Speed_Drives_Constraint;
  update_columns?: Array<Variable_Speed_Drives_Update_Column>;
  where?: InputMaybe<Variable_Speed_Drives_Bool_Exp>;
};

/** Ordering options when selecting data from "variable_speed_drives". */
export type Variable_Speed_Drives_Order_By = {
  author_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  enclosure?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  include_ecopetrol_timestamp?: InputMaybe<Order_By>;
  include_koc_timestamp?: InputMaybe<Order_By>;
  kva?: InputMaybe<Order_By>;
  manufacturer?: InputMaybe<Order_By>;
  max_amps?: InputMaybe<Order_By>;
  only_ecopetrol_timestamp?: InputMaybe<Order_By>;
  only_koc_timestamp?: InputMaybe<Order_By>;
  part_number?: InputMaybe<Order_By>;
  prioritized_manufacturer?: InputMaybe<Order_By>;
  sizing_import?: InputMaybe<Sizing_Imports_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  vsd_type?: InputMaybe<Order_By>;
};

/** primary key columns input for table: variable_speed_drives */
export type Variable_Speed_Drives_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "variable_speed_drives" */
export enum Variable_Speed_Drives_Select_Column {
  /** column name */
  AuthorId = 'author_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Enclosure = 'enclosure',
  /** column name */
  Id = 'id',
  /** column name */
  ImportedSizingId = 'imported_sizing_id',
  /** column name */
  IncludeEcopetrolTimestamp = 'include_ecopetrol_timestamp',
  /** column name */
  IncludeKocTimestamp = 'include_koc_timestamp',
  /** column name */
  Kva = 'kva',
  /** column name */
  Manufacturer = 'manufacturer',
  /** column name */
  MaxAmps = 'max_amps',
  /** column name */
  OnlyEcopetrolTimestamp = 'only_ecopetrol_timestamp',
  /** column name */
  OnlyKocTimestamp = 'only_koc_timestamp',
  /** column name */
  PartNumber = 'part_number',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  VsdType = 'vsd_type'
}

/** input type for updating data in table "variable_speed_drives" */
export type Variable_Speed_Drives_Set_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  enclosure?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  imported_sizing_id?: InputMaybe<Scalars['Int']['input']>;
  include_ecopetrol_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  include_koc_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  kva?: InputMaybe<Scalars['Int']['input']>;
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  max_amps?: InputMaybe<Scalars['Int']['input']>;
  only_ecopetrol_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  only_koc_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  part_number?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  vsd_type?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Variable_Speed_Drives_Stddev_Fields = {
  __typename: 'variable_speed_drives_stddev_fields';
  imported_sizing_id?: Maybe<Scalars['Float']['output']>;
  kva?: Maybe<Scalars['Float']['output']>;
  max_amps?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "variable_speed_drives" */
export type Variable_Speed_Drives_Stddev_Order_By = {
  imported_sizing_id?: InputMaybe<Order_By>;
  kva?: InputMaybe<Order_By>;
  max_amps?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Variable_Speed_Drives_Stddev_Pop_Fields = {
  __typename: 'variable_speed_drives_stddev_pop_fields';
  imported_sizing_id?: Maybe<Scalars['Float']['output']>;
  kva?: Maybe<Scalars['Float']['output']>;
  max_amps?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "variable_speed_drives" */
export type Variable_Speed_Drives_Stddev_Pop_Order_By = {
  imported_sizing_id?: InputMaybe<Order_By>;
  kva?: InputMaybe<Order_By>;
  max_amps?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Variable_Speed_Drives_Stddev_Samp_Fields = {
  __typename: 'variable_speed_drives_stddev_samp_fields';
  imported_sizing_id?: Maybe<Scalars['Float']['output']>;
  kva?: Maybe<Scalars['Float']['output']>;
  max_amps?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "variable_speed_drives" */
export type Variable_Speed_Drives_Stddev_Samp_Order_By = {
  imported_sizing_id?: InputMaybe<Order_By>;
  kva?: InputMaybe<Order_By>;
  max_amps?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "variable_speed_drives" */
export type Variable_Speed_Drives_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Variable_Speed_Drives_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Variable_Speed_Drives_Stream_Cursor_Value_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  enclosure?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  imported_sizing_id?: InputMaybe<Scalars['Int']['input']>;
  include_ecopetrol_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  include_koc_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  kva?: InputMaybe<Scalars['Int']['input']>;
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  max_amps?: InputMaybe<Scalars['Int']['input']>;
  only_ecopetrol_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  only_koc_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  part_number?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  vsd_type?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Variable_Speed_Drives_Sum_Fields = {
  __typename: 'variable_speed_drives_sum_fields';
  imported_sizing_id?: Maybe<Scalars['Int']['output']>;
  kva?: Maybe<Scalars['Int']['output']>;
  max_amps?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "variable_speed_drives" */
export type Variable_Speed_Drives_Sum_Order_By = {
  imported_sizing_id?: InputMaybe<Order_By>;
  kva?: InputMaybe<Order_By>;
  max_amps?: InputMaybe<Order_By>;
};

/** update columns of table "variable_speed_drives" */
export enum Variable_Speed_Drives_Update_Column {
  /** column name */
  AuthorId = 'author_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Enclosure = 'enclosure',
  /** column name */
  Id = 'id',
  /** column name */
  ImportedSizingId = 'imported_sizing_id',
  /** column name */
  IncludeEcopetrolTimestamp = 'include_ecopetrol_timestamp',
  /** column name */
  IncludeKocTimestamp = 'include_koc_timestamp',
  /** column name */
  Kva = 'kva',
  /** column name */
  Manufacturer = 'manufacturer',
  /** column name */
  MaxAmps = 'max_amps',
  /** column name */
  OnlyEcopetrolTimestamp = 'only_ecopetrol_timestamp',
  /** column name */
  OnlyKocTimestamp = 'only_koc_timestamp',
  /** column name */
  PartNumber = 'part_number',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  VsdType = 'vsd_type'
}

export type Variable_Speed_Drives_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Variable_Speed_Drives_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Variable_Speed_Drives_Set_Input>;
  /** filter the rows which have to be updated */
  where: Variable_Speed_Drives_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Variable_Speed_Drives_Var_Pop_Fields = {
  __typename: 'variable_speed_drives_var_pop_fields';
  imported_sizing_id?: Maybe<Scalars['Float']['output']>;
  kva?: Maybe<Scalars['Float']['output']>;
  max_amps?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "variable_speed_drives" */
export type Variable_Speed_Drives_Var_Pop_Order_By = {
  imported_sizing_id?: InputMaybe<Order_By>;
  kva?: InputMaybe<Order_By>;
  max_amps?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Variable_Speed_Drives_Var_Samp_Fields = {
  __typename: 'variable_speed_drives_var_samp_fields';
  imported_sizing_id?: Maybe<Scalars['Float']['output']>;
  kva?: Maybe<Scalars['Float']['output']>;
  max_amps?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "variable_speed_drives" */
export type Variable_Speed_Drives_Var_Samp_Order_By = {
  imported_sizing_id?: InputMaybe<Order_By>;
  kva?: InputMaybe<Order_By>;
  max_amps?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Variable_Speed_Drives_Variance_Fields = {
  __typename: 'variable_speed_drives_variance_fields';
  imported_sizing_id?: Maybe<Scalars['Float']['output']>;
  kva?: Maybe<Scalars['Float']['output']>;
  max_amps?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "variable_speed_drives" */
export type Variable_Speed_Drives_Variance_Order_By = {
  imported_sizing_id?: InputMaybe<Order_By>;
  kva?: InputMaybe<Order_By>;
  max_amps?: InputMaybe<Order_By>;
};

/** columns and relationships of "water_density_options" */
export type Water_Density_Options = {
  __typename: 'water_density_options';
  comment?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

/** aggregated selection of "water_density_options" */
export type Water_Density_Options_Aggregate = {
  __typename: 'water_density_options_aggregate';
  aggregate?: Maybe<Water_Density_Options_Aggregate_Fields>;
  nodes: Array<Water_Density_Options>;
};

/** aggregate fields of "water_density_options" */
export type Water_Density_Options_Aggregate_Fields = {
  __typename: 'water_density_options_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Water_Density_Options_Max_Fields>;
  min?: Maybe<Water_Density_Options_Min_Fields>;
};


/** aggregate fields of "water_density_options" */
export type Water_Density_Options_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Water_Density_Options_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "water_density_options". All fields are combined with a logical 'AND'. */
export type Water_Density_Options_Bool_Exp = {
  _and?: InputMaybe<Array<Water_Density_Options_Bool_Exp>>;
  _not?: InputMaybe<Water_Density_Options_Bool_Exp>;
  _or?: InputMaybe<Array<Water_Density_Options_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "water_density_options" */
export enum Water_Density_Options_Constraint {
  /** unique or primary key constraint on columns "value" */
  WaterDensityOptionsPkey = 'water_density_options_pkey'
}

export enum Water_Density_Options_Enum {
  /** Gould */
  Gould = 'gould',
  /** McCain */
  Mccain = 'mccain',
  /** Spivey et al */
  Spivey = 'spivey'
}

/** Boolean expression to compare columns of type "water_density_options_enum". All fields are combined with logical 'AND'. */
export type Water_Density_Options_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Water_Density_Options_Enum>;
  _in?: InputMaybe<Array<Water_Density_Options_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Water_Density_Options_Enum>;
  _nin?: InputMaybe<Array<Water_Density_Options_Enum>>;
};

/** input type for inserting data into table "water_density_options" */
export type Water_Density_Options_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Water_Density_Options_Max_Fields = {
  __typename: 'water_density_options_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Water_Density_Options_Min_Fields = {
  __typename: 'water_density_options_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "water_density_options" */
export type Water_Density_Options_Mutation_Response = {
  __typename: 'water_density_options_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Water_Density_Options>;
};

/** on_conflict condition type for table "water_density_options" */
export type Water_Density_Options_On_Conflict = {
  constraint: Water_Density_Options_Constraint;
  update_columns?: Array<Water_Density_Options_Update_Column>;
  where?: InputMaybe<Water_Density_Options_Bool_Exp>;
};

/** Ordering options when selecting data from "water_density_options". */
export type Water_Density_Options_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: water_density_options */
export type Water_Density_Options_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "water_density_options" */
export enum Water_Density_Options_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "water_density_options" */
export type Water_Density_Options_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "water_density_options" */
export type Water_Density_Options_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Water_Density_Options_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Water_Density_Options_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "water_density_options" */
export enum Water_Density_Options_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Water_Density_Options_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Water_Density_Options_Set_Input>;
  /** filter the rows which have to be updated */
  where: Water_Density_Options_Bool_Exp;
};

/** columns and relationships of "water_solution_gas_options" */
export type Water_Solution_Gas_Options = {
  __typename: 'water_solution_gas_options';
  comment?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

/** aggregated selection of "water_solution_gas_options" */
export type Water_Solution_Gas_Options_Aggregate = {
  __typename: 'water_solution_gas_options_aggregate';
  aggregate?: Maybe<Water_Solution_Gas_Options_Aggregate_Fields>;
  nodes: Array<Water_Solution_Gas_Options>;
};

/** aggregate fields of "water_solution_gas_options" */
export type Water_Solution_Gas_Options_Aggregate_Fields = {
  __typename: 'water_solution_gas_options_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Water_Solution_Gas_Options_Max_Fields>;
  min?: Maybe<Water_Solution_Gas_Options_Min_Fields>;
};


/** aggregate fields of "water_solution_gas_options" */
export type Water_Solution_Gas_Options_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Water_Solution_Gas_Options_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "water_solution_gas_options". All fields are combined with a logical 'AND'. */
export type Water_Solution_Gas_Options_Bool_Exp = {
  _and?: InputMaybe<Array<Water_Solution_Gas_Options_Bool_Exp>>;
  _not?: InputMaybe<Water_Solution_Gas_Options_Bool_Exp>;
  _or?: InputMaybe<Array<Water_Solution_Gas_Options_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "water_solution_gas_options" */
export enum Water_Solution_Gas_Options_Constraint {
  /** unique or primary key constraint on columns "value" */
  WaterSolutionGasOptionsPkey = 'water_solution_gas_options_pkey'
}

export enum Water_Solution_Gas_Options_Enum {
  /** McCain */
  Mccain = 'mccain',
  /** Spivey et al */
  Spivey = 'spivey'
}

/** Boolean expression to compare columns of type "water_solution_gas_options_enum". All fields are combined with logical 'AND'. */
export type Water_Solution_Gas_Options_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Water_Solution_Gas_Options_Enum>;
  _in?: InputMaybe<Array<Water_Solution_Gas_Options_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Water_Solution_Gas_Options_Enum>;
  _nin?: InputMaybe<Array<Water_Solution_Gas_Options_Enum>>;
};

/** input type for inserting data into table "water_solution_gas_options" */
export type Water_Solution_Gas_Options_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Water_Solution_Gas_Options_Max_Fields = {
  __typename: 'water_solution_gas_options_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Water_Solution_Gas_Options_Min_Fields = {
  __typename: 'water_solution_gas_options_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "water_solution_gas_options" */
export type Water_Solution_Gas_Options_Mutation_Response = {
  __typename: 'water_solution_gas_options_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Water_Solution_Gas_Options>;
};

/** on_conflict condition type for table "water_solution_gas_options" */
export type Water_Solution_Gas_Options_On_Conflict = {
  constraint: Water_Solution_Gas_Options_Constraint;
  update_columns?: Array<Water_Solution_Gas_Options_Update_Column>;
  where?: InputMaybe<Water_Solution_Gas_Options_Bool_Exp>;
};

/** Ordering options when selecting data from "water_solution_gas_options". */
export type Water_Solution_Gas_Options_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: water_solution_gas_options */
export type Water_Solution_Gas_Options_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "water_solution_gas_options" */
export enum Water_Solution_Gas_Options_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "water_solution_gas_options" */
export type Water_Solution_Gas_Options_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "water_solution_gas_options" */
export type Water_Solution_Gas_Options_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Water_Solution_Gas_Options_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Water_Solution_Gas_Options_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "water_solution_gas_options" */
export enum Water_Solution_Gas_Options_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Water_Solution_Gas_Options_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Water_Solution_Gas_Options_Set_Input>;
  /** filter the rows which have to be updated */
  where: Water_Solution_Gas_Options_Bool_Exp;
};

/** columns and relationships of "water_viscosity_options" */
export type Water_Viscosity_Options = {
  __typename: 'water_viscosity_options';
  comment?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

/** aggregated selection of "water_viscosity_options" */
export type Water_Viscosity_Options_Aggregate = {
  __typename: 'water_viscosity_options_aggregate';
  aggregate?: Maybe<Water_Viscosity_Options_Aggregate_Fields>;
  nodes: Array<Water_Viscosity_Options>;
};

/** aggregate fields of "water_viscosity_options" */
export type Water_Viscosity_Options_Aggregate_Fields = {
  __typename: 'water_viscosity_options_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Water_Viscosity_Options_Max_Fields>;
  min?: Maybe<Water_Viscosity_Options_Min_Fields>;
};


/** aggregate fields of "water_viscosity_options" */
export type Water_Viscosity_Options_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Water_Viscosity_Options_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "water_viscosity_options". All fields are combined with a logical 'AND'. */
export type Water_Viscosity_Options_Bool_Exp = {
  _and?: InputMaybe<Array<Water_Viscosity_Options_Bool_Exp>>;
  _not?: InputMaybe<Water_Viscosity_Options_Bool_Exp>;
  _or?: InputMaybe<Array<Water_Viscosity_Options_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "water_viscosity_options" */
export enum Water_Viscosity_Options_Constraint {
  /** unique or primary key constraint on columns "value" */
  WaterViscosityOptionsPkey = 'water_viscosity_options_pkey'
}

export enum Water_Viscosity_Options_Enum {
  /** Matthews and Russel */
  MatthewsRussel = 'matthews_russel',
  /** McCain */
  Mccain = 'mccain',
  /** Van Wingen */
  VanWingen = 'van_wingen'
}

/** Boolean expression to compare columns of type "water_viscosity_options_enum". All fields are combined with logical 'AND'. */
export type Water_Viscosity_Options_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Water_Viscosity_Options_Enum>;
  _in?: InputMaybe<Array<Water_Viscosity_Options_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Water_Viscosity_Options_Enum>;
  _nin?: InputMaybe<Array<Water_Viscosity_Options_Enum>>;
};

/** input type for inserting data into table "water_viscosity_options" */
export type Water_Viscosity_Options_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Water_Viscosity_Options_Max_Fields = {
  __typename: 'water_viscosity_options_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Water_Viscosity_Options_Min_Fields = {
  __typename: 'water_viscosity_options_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "water_viscosity_options" */
export type Water_Viscosity_Options_Mutation_Response = {
  __typename: 'water_viscosity_options_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Water_Viscosity_Options>;
};

/** input type for inserting object relation for remote table "water_viscosity_options" */
export type Water_Viscosity_Options_Obj_Rel_Insert_Input = {
  data: Water_Viscosity_Options_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Water_Viscosity_Options_On_Conflict>;
};

/** on_conflict condition type for table "water_viscosity_options" */
export type Water_Viscosity_Options_On_Conflict = {
  constraint: Water_Viscosity_Options_Constraint;
  update_columns?: Array<Water_Viscosity_Options_Update_Column>;
  where?: InputMaybe<Water_Viscosity_Options_Bool_Exp>;
};

/** Ordering options when selecting data from "water_viscosity_options". */
export type Water_Viscosity_Options_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: water_viscosity_options */
export type Water_Viscosity_Options_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "water_viscosity_options" */
export enum Water_Viscosity_Options_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "water_viscosity_options" */
export type Water_Viscosity_Options_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "water_viscosity_options" */
export type Water_Viscosity_Options_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Water_Viscosity_Options_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Water_Viscosity_Options_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "water_viscosity_options" */
export enum Water_Viscosity_Options_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Water_Viscosity_Options_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Water_Viscosity_Options_Set_Input>;
  /** filter the rows which have to be updated */
  where: Water_Viscosity_Options_Bool_Exp;
};

/** columns and relationships of "water_volume_factor_options" */
export type Water_Volume_Factor_Options = {
  __typename: 'water_volume_factor_options';
  comment?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

/** aggregated selection of "water_volume_factor_options" */
export type Water_Volume_Factor_Options_Aggregate = {
  __typename: 'water_volume_factor_options_aggregate';
  aggregate?: Maybe<Water_Volume_Factor_Options_Aggregate_Fields>;
  nodes: Array<Water_Volume_Factor_Options>;
};

/** aggregate fields of "water_volume_factor_options" */
export type Water_Volume_Factor_Options_Aggregate_Fields = {
  __typename: 'water_volume_factor_options_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Water_Volume_Factor_Options_Max_Fields>;
  min?: Maybe<Water_Volume_Factor_Options_Min_Fields>;
};


/** aggregate fields of "water_volume_factor_options" */
export type Water_Volume_Factor_Options_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Water_Volume_Factor_Options_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "water_volume_factor_options". All fields are combined with a logical 'AND'. */
export type Water_Volume_Factor_Options_Bool_Exp = {
  _and?: InputMaybe<Array<Water_Volume_Factor_Options_Bool_Exp>>;
  _not?: InputMaybe<Water_Volume_Factor_Options_Bool_Exp>;
  _or?: InputMaybe<Array<Water_Volume_Factor_Options_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "water_volume_factor_options" */
export enum Water_Volume_Factor_Options_Constraint {
  /** unique or primary key constraint on columns "value" */
  WaterVolumeFactorOptionsPkey = 'water_volume_factor_options_pkey'
}

export enum Water_Volume_Factor_Options_Enum {
  /** Gould */
  Gould = 'gould',
  /** Jones */
  Jones = 'jones',
  /** McCain */
  Mccain = 'mccain',
  /** Spivey et al */
  Spivey = 'spivey'
}

/** Boolean expression to compare columns of type "water_volume_factor_options_enum". All fields are combined with logical 'AND'. */
export type Water_Volume_Factor_Options_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Water_Volume_Factor_Options_Enum>;
  _in?: InputMaybe<Array<Water_Volume_Factor_Options_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Water_Volume_Factor_Options_Enum>;
  _nin?: InputMaybe<Array<Water_Volume_Factor_Options_Enum>>;
};

/** input type for inserting data into table "water_volume_factor_options" */
export type Water_Volume_Factor_Options_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Water_Volume_Factor_Options_Max_Fields = {
  __typename: 'water_volume_factor_options_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Water_Volume_Factor_Options_Min_Fields = {
  __typename: 'water_volume_factor_options_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "water_volume_factor_options" */
export type Water_Volume_Factor_Options_Mutation_Response = {
  __typename: 'water_volume_factor_options_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Water_Volume_Factor_Options>;
};

/** input type for inserting object relation for remote table "water_volume_factor_options" */
export type Water_Volume_Factor_Options_Obj_Rel_Insert_Input = {
  data: Water_Volume_Factor_Options_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Water_Volume_Factor_Options_On_Conflict>;
};

/** on_conflict condition type for table "water_volume_factor_options" */
export type Water_Volume_Factor_Options_On_Conflict = {
  constraint: Water_Volume_Factor_Options_Constraint;
  update_columns?: Array<Water_Volume_Factor_Options_Update_Column>;
  where?: InputMaybe<Water_Volume_Factor_Options_Bool_Exp>;
};

/** Ordering options when selecting data from "water_volume_factor_options". */
export type Water_Volume_Factor_Options_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: water_volume_factor_options */
export type Water_Volume_Factor_Options_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "water_volume_factor_options" */
export enum Water_Volume_Factor_Options_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "water_volume_factor_options" */
export type Water_Volume_Factor_Options_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "water_volume_factor_options" */
export type Water_Volume_Factor_Options_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Water_Volume_Factor_Options_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Water_Volume_Factor_Options_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "water_volume_factor_options" */
export enum Water_Volume_Factor_Options_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Water_Volume_Factor_Options_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Water_Volume_Factor_Options_Set_Input>;
  /** filter the rows which have to be updated */
  where: Water_Volume_Factor_Options_Bool_Exp;
};

/** columns and relationships of "well_gas_type_options" */
export type Well_Gas_Type_Options = {
  __typename: 'well_gas_type_options';
  comment?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

/** aggregated selection of "well_gas_type_options" */
export type Well_Gas_Type_Options_Aggregate = {
  __typename: 'well_gas_type_options_aggregate';
  aggregate?: Maybe<Well_Gas_Type_Options_Aggregate_Fields>;
  nodes: Array<Well_Gas_Type_Options>;
};

/** aggregate fields of "well_gas_type_options" */
export type Well_Gas_Type_Options_Aggregate_Fields = {
  __typename: 'well_gas_type_options_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Well_Gas_Type_Options_Max_Fields>;
  min?: Maybe<Well_Gas_Type_Options_Min_Fields>;
};


/** aggregate fields of "well_gas_type_options" */
export type Well_Gas_Type_Options_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Well_Gas_Type_Options_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "well_gas_type_options". All fields are combined with a logical 'AND'. */
export type Well_Gas_Type_Options_Bool_Exp = {
  _and?: InputMaybe<Array<Well_Gas_Type_Options_Bool_Exp>>;
  _not?: InputMaybe<Well_Gas_Type_Options_Bool_Exp>;
  _or?: InputMaybe<Array<Well_Gas_Type_Options_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "well_gas_type_options" */
export enum Well_Gas_Type_Options_Constraint {
  /** unique or primary key constraint on columns "value" */
  WellGasTypeOptionsPkey = 'well_gas_type_options_pkey'
}

export enum Well_Gas_Type_Options_Enum {
  /** Dry Gas */
  Dry = 'dry',
  /** Wet Gas */
  Wet = 'wet'
}

/** Boolean expression to compare columns of type "well_gas_type_options_enum". All fields are combined with logical 'AND'. */
export type Well_Gas_Type_Options_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Well_Gas_Type_Options_Enum>;
  _in?: InputMaybe<Array<Well_Gas_Type_Options_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Well_Gas_Type_Options_Enum>;
  _nin?: InputMaybe<Array<Well_Gas_Type_Options_Enum>>;
};

/** input type for inserting data into table "well_gas_type_options" */
export type Well_Gas_Type_Options_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Well_Gas_Type_Options_Max_Fields = {
  __typename: 'well_gas_type_options_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Well_Gas_Type_Options_Min_Fields = {
  __typename: 'well_gas_type_options_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "well_gas_type_options" */
export type Well_Gas_Type_Options_Mutation_Response = {
  __typename: 'well_gas_type_options_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Well_Gas_Type_Options>;
};

/** on_conflict condition type for table "well_gas_type_options" */
export type Well_Gas_Type_Options_On_Conflict = {
  constraint: Well_Gas_Type_Options_Constraint;
  update_columns?: Array<Well_Gas_Type_Options_Update_Column>;
  where?: InputMaybe<Well_Gas_Type_Options_Bool_Exp>;
};

/** Ordering options when selecting data from "well_gas_type_options". */
export type Well_Gas_Type_Options_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: well_gas_type_options */
export type Well_Gas_Type_Options_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "well_gas_type_options" */
export enum Well_Gas_Type_Options_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "well_gas_type_options" */
export type Well_Gas_Type_Options_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "well_gas_type_options" */
export type Well_Gas_Type_Options_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Well_Gas_Type_Options_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Well_Gas_Type_Options_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "well_gas_type_options" */
export enum Well_Gas_Type_Options_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Well_Gas_Type_Options_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Well_Gas_Type_Options_Set_Input>;
  /** filter the rows which have to be updated */
  where: Well_Gas_Type_Options_Bool_Exp;
};

/** columns and relationships of "well_test_gas_input_options" */
export type Well_Test_Gas_Input_Options = {
  __typename: 'well_test_gas_input_options';
  comment?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

/** aggregated selection of "well_test_gas_input_options" */
export type Well_Test_Gas_Input_Options_Aggregate = {
  __typename: 'well_test_gas_input_options_aggregate';
  aggregate?: Maybe<Well_Test_Gas_Input_Options_Aggregate_Fields>;
  nodes: Array<Well_Test_Gas_Input_Options>;
};

/** aggregate fields of "well_test_gas_input_options" */
export type Well_Test_Gas_Input_Options_Aggregate_Fields = {
  __typename: 'well_test_gas_input_options_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Well_Test_Gas_Input_Options_Max_Fields>;
  min?: Maybe<Well_Test_Gas_Input_Options_Min_Fields>;
};


/** aggregate fields of "well_test_gas_input_options" */
export type Well_Test_Gas_Input_Options_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Well_Test_Gas_Input_Options_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "well_test_gas_input_options". All fields are combined with a logical 'AND'. */
export type Well_Test_Gas_Input_Options_Bool_Exp = {
  _and?: InputMaybe<Array<Well_Test_Gas_Input_Options_Bool_Exp>>;
  _not?: InputMaybe<Well_Test_Gas_Input_Options_Bool_Exp>;
  _or?: InputMaybe<Array<Well_Test_Gas_Input_Options_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "well_test_gas_input_options" */
export enum Well_Test_Gas_Input_Options_Constraint {
  /** unique or primary key constraint on columns "value" */
  WellTestGasInputOptionsPkey = 'well_test_gas_input_options_pkey'
}

export enum Well_Test_Gas_Input_Options_Enum {
  /** Gas/Liquid Ratio */
  GasLiquidRatio = 'gas_liquid_ratio',
  /** Gas/Oil Ratio */
  GasOilRatio = 'gas_oil_ratio',
  /** Gas Rate */
  GasRate = 'gas_rate'
}

/** Boolean expression to compare columns of type "well_test_gas_input_options_enum". All fields are combined with logical 'AND'. */
export type Well_Test_Gas_Input_Options_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Well_Test_Gas_Input_Options_Enum>;
  _in?: InputMaybe<Array<Well_Test_Gas_Input_Options_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Well_Test_Gas_Input_Options_Enum>;
  _nin?: InputMaybe<Array<Well_Test_Gas_Input_Options_Enum>>;
};

/** input type for inserting data into table "well_test_gas_input_options" */
export type Well_Test_Gas_Input_Options_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Well_Test_Gas_Input_Options_Max_Fields = {
  __typename: 'well_test_gas_input_options_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Well_Test_Gas_Input_Options_Min_Fields = {
  __typename: 'well_test_gas_input_options_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "well_test_gas_input_options" */
export type Well_Test_Gas_Input_Options_Mutation_Response = {
  __typename: 'well_test_gas_input_options_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Well_Test_Gas_Input_Options>;
};

/** input type for inserting object relation for remote table "well_test_gas_input_options" */
export type Well_Test_Gas_Input_Options_Obj_Rel_Insert_Input = {
  data: Well_Test_Gas_Input_Options_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Well_Test_Gas_Input_Options_On_Conflict>;
};

/** on_conflict condition type for table "well_test_gas_input_options" */
export type Well_Test_Gas_Input_Options_On_Conflict = {
  constraint: Well_Test_Gas_Input_Options_Constraint;
  update_columns?: Array<Well_Test_Gas_Input_Options_Update_Column>;
  where?: InputMaybe<Well_Test_Gas_Input_Options_Bool_Exp>;
};

/** Ordering options when selecting data from "well_test_gas_input_options". */
export type Well_Test_Gas_Input_Options_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: well_test_gas_input_options */
export type Well_Test_Gas_Input_Options_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "well_test_gas_input_options" */
export enum Well_Test_Gas_Input_Options_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "well_test_gas_input_options" */
export type Well_Test_Gas_Input_Options_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "well_test_gas_input_options" */
export type Well_Test_Gas_Input_Options_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Well_Test_Gas_Input_Options_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Well_Test_Gas_Input_Options_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "well_test_gas_input_options" */
export enum Well_Test_Gas_Input_Options_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Well_Test_Gas_Input_Options_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Well_Test_Gas_Input_Options_Set_Input>;
  /** filter the rows which have to be updated */
  where: Well_Test_Gas_Input_Options_Bool_Exp;
};

/** columns and relationships of "well_test_liquid_input_options" */
export type Well_Test_Liquid_Input_Options = {
  __typename: 'well_test_liquid_input_options';
  comment?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

/** aggregated selection of "well_test_liquid_input_options" */
export type Well_Test_Liquid_Input_Options_Aggregate = {
  __typename: 'well_test_liquid_input_options_aggregate';
  aggregate?: Maybe<Well_Test_Liquid_Input_Options_Aggregate_Fields>;
  nodes: Array<Well_Test_Liquid_Input_Options>;
};

/** aggregate fields of "well_test_liquid_input_options" */
export type Well_Test_Liquid_Input_Options_Aggregate_Fields = {
  __typename: 'well_test_liquid_input_options_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Well_Test_Liquid_Input_Options_Max_Fields>;
  min?: Maybe<Well_Test_Liquid_Input_Options_Min_Fields>;
};


/** aggregate fields of "well_test_liquid_input_options" */
export type Well_Test_Liquid_Input_Options_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Well_Test_Liquid_Input_Options_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "well_test_liquid_input_options". All fields are combined with a logical 'AND'. */
export type Well_Test_Liquid_Input_Options_Bool_Exp = {
  _and?: InputMaybe<Array<Well_Test_Liquid_Input_Options_Bool_Exp>>;
  _not?: InputMaybe<Well_Test_Liquid_Input_Options_Bool_Exp>;
  _or?: InputMaybe<Array<Well_Test_Liquid_Input_Options_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "well_test_liquid_input_options" */
export enum Well_Test_Liquid_Input_Options_Constraint {
  /** unique or primary key constraint on columns "value" */
  WellTestLiquidInputOptionsPkey = 'well_test_liquid_input_options_pkey'
}

export enum Well_Test_Liquid_Input_Options_Enum {
  /** Oil Rate / Water Cut */
  OilRateWaterCut = 'oil_rate_water_cut',
  /** Oil Rate / Water Rate */
  OilRateWaterRate = 'oil_rate_water_rate',
  /** PI/Water Cut */
  ProductivityIndexWaterCut = 'productivity_index_water_cut',
  /** Total Liquid Rate / Water Cut */
  TotalRateWaterCut = 'total_rate_water_cut'
}

/** Boolean expression to compare columns of type "well_test_liquid_input_options_enum". All fields are combined with logical 'AND'. */
export type Well_Test_Liquid_Input_Options_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Well_Test_Liquid_Input_Options_Enum>;
  _in?: InputMaybe<Array<Well_Test_Liquid_Input_Options_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Well_Test_Liquid_Input_Options_Enum>;
  _nin?: InputMaybe<Array<Well_Test_Liquid_Input_Options_Enum>>;
};

/** input type for inserting data into table "well_test_liquid_input_options" */
export type Well_Test_Liquid_Input_Options_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Well_Test_Liquid_Input_Options_Max_Fields = {
  __typename: 'well_test_liquid_input_options_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Well_Test_Liquid_Input_Options_Min_Fields = {
  __typename: 'well_test_liquid_input_options_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "well_test_liquid_input_options" */
export type Well_Test_Liquid_Input_Options_Mutation_Response = {
  __typename: 'well_test_liquid_input_options_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Well_Test_Liquid_Input_Options>;
};

/** input type for inserting object relation for remote table "well_test_liquid_input_options" */
export type Well_Test_Liquid_Input_Options_Obj_Rel_Insert_Input = {
  data: Well_Test_Liquid_Input_Options_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Well_Test_Liquid_Input_Options_On_Conflict>;
};

/** on_conflict condition type for table "well_test_liquid_input_options" */
export type Well_Test_Liquid_Input_Options_On_Conflict = {
  constraint: Well_Test_Liquid_Input_Options_Constraint;
  update_columns?: Array<Well_Test_Liquid_Input_Options_Update_Column>;
  where?: InputMaybe<Well_Test_Liquid_Input_Options_Bool_Exp>;
};

/** Ordering options when selecting data from "well_test_liquid_input_options". */
export type Well_Test_Liquid_Input_Options_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: well_test_liquid_input_options */
export type Well_Test_Liquid_Input_Options_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "well_test_liquid_input_options" */
export enum Well_Test_Liquid_Input_Options_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "well_test_liquid_input_options" */
export type Well_Test_Liquid_Input_Options_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "well_test_liquid_input_options" */
export type Well_Test_Liquid_Input_Options_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Well_Test_Liquid_Input_Options_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Well_Test_Liquid_Input_Options_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "well_test_liquid_input_options" */
export enum Well_Test_Liquid_Input_Options_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Well_Test_Liquid_Input_Options_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Well_Test_Liquid_Input_Options_Set_Input>;
  /** filter the rows which have to be updated */
  where: Well_Test_Liquid_Input_Options_Bool_Exp;
};

/** columns and relationships of "well_test_pressure_input_options" */
export type Well_Test_Pressure_Input_Options = {
  __typename: 'well_test_pressure_input_options';
  comment?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

/** aggregated selection of "well_test_pressure_input_options" */
export type Well_Test_Pressure_Input_Options_Aggregate = {
  __typename: 'well_test_pressure_input_options_aggregate';
  aggregate?: Maybe<Well_Test_Pressure_Input_Options_Aggregate_Fields>;
  nodes: Array<Well_Test_Pressure_Input_Options>;
};

/** aggregate fields of "well_test_pressure_input_options" */
export type Well_Test_Pressure_Input_Options_Aggregate_Fields = {
  __typename: 'well_test_pressure_input_options_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Well_Test_Pressure_Input_Options_Max_Fields>;
  min?: Maybe<Well_Test_Pressure_Input_Options_Min_Fields>;
};


/** aggregate fields of "well_test_pressure_input_options" */
export type Well_Test_Pressure_Input_Options_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Well_Test_Pressure_Input_Options_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "well_test_pressure_input_options". All fields are combined with a logical 'AND'. */
export type Well_Test_Pressure_Input_Options_Bool_Exp = {
  _and?: InputMaybe<Array<Well_Test_Pressure_Input_Options_Bool_Exp>>;
  _not?: InputMaybe<Well_Test_Pressure_Input_Options_Bool_Exp>;
  _or?: InputMaybe<Array<Well_Test_Pressure_Input_Options_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "well_test_pressure_input_options" */
export enum Well_Test_Pressure_Input_Options_Constraint {
  /** unique or primary key constraint on columns "value" */
  WellTestPressureInputOptionsPkey = 'well_test_pressure_input_options_pkey'
}

export enum Well_Test_Pressure_Input_Options_Enum {
  /** Fluid Level */
  FluidLevel = 'fluid_level',
  /** Pressure */
  Pressure = 'pressure'
}

/** Boolean expression to compare columns of type "well_test_pressure_input_options_enum". All fields are combined with logical 'AND'. */
export type Well_Test_Pressure_Input_Options_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Well_Test_Pressure_Input_Options_Enum>;
  _in?: InputMaybe<Array<Well_Test_Pressure_Input_Options_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Well_Test_Pressure_Input_Options_Enum>;
  _nin?: InputMaybe<Array<Well_Test_Pressure_Input_Options_Enum>>;
};

/** input type for inserting data into table "well_test_pressure_input_options" */
export type Well_Test_Pressure_Input_Options_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Well_Test_Pressure_Input_Options_Max_Fields = {
  __typename: 'well_test_pressure_input_options_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Well_Test_Pressure_Input_Options_Min_Fields = {
  __typename: 'well_test_pressure_input_options_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "well_test_pressure_input_options" */
export type Well_Test_Pressure_Input_Options_Mutation_Response = {
  __typename: 'well_test_pressure_input_options_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Well_Test_Pressure_Input_Options>;
};

/** on_conflict condition type for table "well_test_pressure_input_options" */
export type Well_Test_Pressure_Input_Options_On_Conflict = {
  constraint: Well_Test_Pressure_Input_Options_Constraint;
  update_columns?: Array<Well_Test_Pressure_Input_Options_Update_Column>;
  where?: InputMaybe<Well_Test_Pressure_Input_Options_Bool_Exp>;
};

/** Ordering options when selecting data from "well_test_pressure_input_options". */
export type Well_Test_Pressure_Input_Options_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: well_test_pressure_input_options */
export type Well_Test_Pressure_Input_Options_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "well_test_pressure_input_options" */
export enum Well_Test_Pressure_Input_Options_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "well_test_pressure_input_options" */
export type Well_Test_Pressure_Input_Options_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "well_test_pressure_input_options" */
export type Well_Test_Pressure_Input_Options_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Well_Test_Pressure_Input_Options_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Well_Test_Pressure_Input_Options_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "well_test_pressure_input_options" */
export enum Well_Test_Pressure_Input_Options_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Well_Test_Pressure_Input_Options_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Well_Test_Pressure_Input_Options_Set_Input>;
  /** filter the rows which have to be updated */
  where: Well_Test_Pressure_Input_Options_Bool_Exp;
};

/** columns and relationships of "wells" */
export type Wells = {
  __typename: 'wells';
  address_erp_id?: Maybe<Scalars['String']['output']>;
  erp_well_address_slug?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  imported_sizing_id?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  sizing_import?: Maybe<Sizing_Imports>;
  /** An array relationship */
  sizings: Array<Sizings>;
  /** An aggregate relationship */
  sizings_aggregate: Sizings_Aggregate;
  well_erp_id?: Maybe<Scalars['String']['output']>;
  well_name?: Maybe<Scalars['String']['output']>;
  well_uwi?: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "wells" */
export type WellsSizingsArgs = {
  distinct_on?: InputMaybe<Array<Sizings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sizings_Order_By>>;
  where?: InputMaybe<Sizings_Bool_Exp>;
};


/** columns and relationships of "wells" */
export type WellsSizings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sizings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sizings_Order_By>>;
  where?: InputMaybe<Sizings_Bool_Exp>;
};

/** aggregated selection of "wells" */
export type Wells_Aggregate = {
  __typename: 'wells_aggregate';
  aggregate?: Maybe<Wells_Aggregate_Fields>;
  nodes: Array<Wells>;
};

export type Wells_Aggregate_Bool_Exp = {
  count?: InputMaybe<Wells_Aggregate_Bool_Exp_Count>;
};

export type Wells_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Wells_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Wells_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "wells" */
export type Wells_Aggregate_Fields = {
  __typename: 'wells_aggregate_fields';
  avg?: Maybe<Wells_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Wells_Max_Fields>;
  min?: Maybe<Wells_Min_Fields>;
  stddev?: Maybe<Wells_Stddev_Fields>;
  stddev_pop?: Maybe<Wells_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Wells_Stddev_Samp_Fields>;
  sum?: Maybe<Wells_Sum_Fields>;
  var_pop?: Maybe<Wells_Var_Pop_Fields>;
  var_samp?: Maybe<Wells_Var_Samp_Fields>;
  variance?: Maybe<Wells_Variance_Fields>;
};


/** aggregate fields of "wells" */
export type Wells_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Wells_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "wells" */
export type Wells_Aggregate_Order_By = {
  avg?: InputMaybe<Wells_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Wells_Max_Order_By>;
  min?: InputMaybe<Wells_Min_Order_By>;
  stddev?: InputMaybe<Wells_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Wells_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Wells_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Wells_Sum_Order_By>;
  var_pop?: InputMaybe<Wells_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Wells_Var_Samp_Order_By>;
  variance?: InputMaybe<Wells_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "wells" */
export type Wells_Arr_Rel_Insert_Input = {
  data: Array<Wells_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Wells_On_Conflict>;
};

/** aggregate avg on columns */
export type Wells_Avg_Fields = {
  __typename: 'wells_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  imported_sizing_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "wells" */
export type Wells_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "wells". All fields are combined with a logical 'AND'. */
export type Wells_Bool_Exp = {
  _and?: InputMaybe<Array<Wells_Bool_Exp>>;
  _not?: InputMaybe<Wells_Bool_Exp>;
  _or?: InputMaybe<Array<Wells_Bool_Exp>>;
  address_erp_id?: InputMaybe<String_Comparison_Exp>;
  erp_well_address_slug?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  imported_sizing_id?: InputMaybe<Int_Comparison_Exp>;
  sizing_import?: InputMaybe<Sizing_Imports_Bool_Exp>;
  sizings?: InputMaybe<Sizings_Bool_Exp>;
  sizings_aggregate?: InputMaybe<Sizings_Aggregate_Bool_Exp>;
  well_erp_id?: InputMaybe<String_Comparison_Exp>;
  well_name?: InputMaybe<String_Comparison_Exp>;
  well_uwi?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "wells" */
export enum Wells_Constraint {
  /** unique or primary key constraint on columns "erp_well_address_slug" */
  WellsErpWellAddressSlugUniqueKey = 'wells_erp_well_address_slug_unique_key',
  /** unique or primary key constraint on columns "id" */
  WellsPkey = 'wells_pkey'
}

/** input type for incrementing numeric columns in table "wells" */
export type Wells_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  imported_sizing_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "wells" */
export type Wells_Insert_Input = {
  address_erp_id?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  imported_sizing_id?: InputMaybe<Scalars['Int']['input']>;
  sizing_import?: InputMaybe<Sizing_Imports_Obj_Rel_Insert_Input>;
  sizings?: InputMaybe<Sizings_Arr_Rel_Insert_Input>;
  well_erp_id?: InputMaybe<Scalars['String']['input']>;
  well_name?: InputMaybe<Scalars['String']['input']>;
  well_uwi?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Wells_Max_Fields = {
  __typename: 'wells_max_fields';
  address_erp_id?: Maybe<Scalars['String']['output']>;
  erp_well_address_slug?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  imported_sizing_id?: Maybe<Scalars['Int']['output']>;
  well_erp_id?: Maybe<Scalars['String']['output']>;
  well_name?: Maybe<Scalars['String']['output']>;
  well_uwi?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "wells" */
export type Wells_Max_Order_By = {
  address_erp_id?: InputMaybe<Order_By>;
  erp_well_address_slug?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  well_erp_id?: InputMaybe<Order_By>;
  well_name?: InputMaybe<Order_By>;
  well_uwi?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Wells_Min_Fields = {
  __typename: 'wells_min_fields';
  address_erp_id?: Maybe<Scalars['String']['output']>;
  erp_well_address_slug?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  imported_sizing_id?: Maybe<Scalars['Int']['output']>;
  well_erp_id?: Maybe<Scalars['String']['output']>;
  well_name?: Maybe<Scalars['String']['output']>;
  well_uwi?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "wells" */
export type Wells_Min_Order_By = {
  address_erp_id?: InputMaybe<Order_By>;
  erp_well_address_slug?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  well_erp_id?: InputMaybe<Order_By>;
  well_name?: InputMaybe<Order_By>;
  well_uwi?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "wells" */
export type Wells_Mutation_Response = {
  __typename: 'wells_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Wells>;
};

/** input type for inserting object relation for remote table "wells" */
export type Wells_Obj_Rel_Insert_Input = {
  data: Wells_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Wells_On_Conflict>;
};

/** on_conflict condition type for table "wells" */
export type Wells_On_Conflict = {
  constraint: Wells_Constraint;
  update_columns?: Array<Wells_Update_Column>;
  where?: InputMaybe<Wells_Bool_Exp>;
};

/** Ordering options when selecting data from "wells". */
export type Wells_Order_By = {
  address_erp_id?: InputMaybe<Order_By>;
  erp_well_address_slug?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
  sizing_import?: InputMaybe<Sizing_Imports_Order_By>;
  sizings_aggregate?: InputMaybe<Sizings_Aggregate_Order_By>;
  well_erp_id?: InputMaybe<Order_By>;
  well_name?: InputMaybe<Order_By>;
  well_uwi?: InputMaybe<Order_By>;
};

/** primary key columns input for table: wells */
export type Wells_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "wells" */
export enum Wells_Select_Column {
  /** column name */
  AddressErpId = 'address_erp_id',
  /** column name */
  ErpWellAddressSlug = 'erp_well_address_slug',
  /** column name */
  Id = 'id',
  /** column name */
  ImportedSizingId = 'imported_sizing_id',
  /** column name */
  WellErpId = 'well_erp_id',
  /** column name */
  WellName = 'well_name',
  /** column name */
  WellUwi = 'well_uwi'
}

/** input type for updating data in table "wells" */
export type Wells_Set_Input = {
  address_erp_id?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  imported_sizing_id?: InputMaybe<Scalars['Int']['input']>;
  well_erp_id?: InputMaybe<Scalars['String']['input']>;
  well_name?: InputMaybe<Scalars['String']['input']>;
  well_uwi?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Wells_Stddev_Fields = {
  __typename: 'wells_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  imported_sizing_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "wells" */
export type Wells_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Wells_Stddev_Pop_Fields = {
  __typename: 'wells_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  imported_sizing_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "wells" */
export type Wells_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Wells_Stddev_Samp_Fields = {
  __typename: 'wells_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  imported_sizing_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "wells" */
export type Wells_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "wells" */
export type Wells_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Wells_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Wells_Stream_Cursor_Value_Input = {
  address_erp_id?: InputMaybe<Scalars['String']['input']>;
  erp_well_address_slug?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  imported_sizing_id?: InputMaybe<Scalars['Int']['input']>;
  well_erp_id?: InputMaybe<Scalars['String']['input']>;
  well_name?: InputMaybe<Scalars['String']['input']>;
  well_uwi?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Wells_Sum_Fields = {
  __typename: 'wells_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
  imported_sizing_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "wells" */
export type Wells_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
};

/** update columns of table "wells" */
export enum Wells_Update_Column {
  /** column name */
  AddressErpId = 'address_erp_id',
  /** column name */
  Id = 'id',
  /** column name */
  ImportedSizingId = 'imported_sizing_id',
  /** column name */
  WellErpId = 'well_erp_id',
  /** column name */
  WellName = 'well_name',
  /** column name */
  WellUwi = 'well_uwi'
}

export type Wells_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Wells_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Wells_Set_Input>;
  /** filter the rows which have to be updated */
  where: Wells_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Wells_Var_Pop_Fields = {
  __typename: 'wells_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  imported_sizing_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "wells" */
export type Wells_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Wells_Var_Samp_Fields = {
  __typename: 'wells_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  imported_sizing_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "wells" */
export type Wells_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Wells_Variance_Fields = {
  __typename: 'wells_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  imported_sizing_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "wells" */
export type Wells_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  imported_sizing_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "y_tools" */
export type Y_Tools = {
  __typename: 'y_tools';
  author_id: Scalars['String']['output'];
  bypass_connection_inches?: Maybe<Scalars['numeric']['output']>;
  created_at: Scalars['timestamptz']['output'];
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An array relationship */
  downhole_scenario_equipment_revisions: Array<Revisions_Scenario_Equipment_Revisions>;
  /** An aggregate relationship */
  downhole_scenario_equipment_revisions_aggregate: Revisions_Scenario_Equipment_Revisions_Aggregate;
  handling_sub_connection_inches?: Maybe<Scalars['numeric']['output']>;
  id: Scalars['uuid']['output'];
  include_ecopetrol_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  include_koc_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  length_inches?: Maybe<Scalars['numeric']['output']>;
  manufacturer?: Maybe<Scalars['String']['output']>;
  material_type?: Maybe<Scalars['String']['output']>;
  maximum_inches?: Maybe<Scalars['numeric']['output']>;
  minimum_inches?: Maybe<Scalars['numeric']['output']>;
  only_ecopetrol_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  only_koc_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  outer_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  pressure_rating_psi?: Maybe<Scalars['Int']['output']>;
  series_model?: Maybe<Scalars['String']['output']>;
  teleswivel_stroke_length_inches?: Maybe<Scalars['numeric']['output']>;
  temperature_rating_fahrenheit?: Maybe<Scalars['Int']['output']>;
  updated_at: Scalars['timestamptz']['output'];
  /** An array relationship */
  uphole_scenario_equipment_revisions: Array<Revisions_Scenario_Equipment_Revisions>;
  /** An aggregate relationship */
  uphole_scenario_equipment_revisions_aggregate: Revisions_Scenario_Equipment_Revisions_Aggregate;
  /** An object relationship */
  user: Users;
  weight_pounds?: Maybe<Scalars['numeric']['output']>;
  width_inches?: Maybe<Scalars['numeric']['output']>;
};


/** columns and relationships of "y_tools" */
export type Y_ToolsDownhole_Scenario_Equipment_RevisionsArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Equipment_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Equipment_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Equipment_Revisions_Bool_Exp>;
};


/** columns and relationships of "y_tools" */
export type Y_ToolsDownhole_Scenario_Equipment_Revisions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Equipment_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Equipment_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Equipment_Revisions_Bool_Exp>;
};


/** columns and relationships of "y_tools" */
export type Y_ToolsUphole_Scenario_Equipment_RevisionsArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Equipment_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Equipment_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Equipment_Revisions_Bool_Exp>;
};


/** columns and relationships of "y_tools" */
export type Y_ToolsUphole_Scenario_Equipment_Revisions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Revisions_Scenario_Equipment_Revisions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Revisions_Scenario_Equipment_Revisions_Order_By>>;
  where?: InputMaybe<Revisions_Scenario_Equipment_Revisions_Bool_Exp>;
};

/** aggregated selection of "y_tools" */
export type Y_Tools_Aggregate = {
  __typename: 'y_tools_aggregate';
  aggregate?: Maybe<Y_Tools_Aggregate_Fields>;
  nodes: Array<Y_Tools>;
};

/** aggregate fields of "y_tools" */
export type Y_Tools_Aggregate_Fields = {
  __typename: 'y_tools_aggregate_fields';
  avg?: Maybe<Y_Tools_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Y_Tools_Max_Fields>;
  min?: Maybe<Y_Tools_Min_Fields>;
  stddev?: Maybe<Y_Tools_Stddev_Fields>;
  stddev_pop?: Maybe<Y_Tools_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Y_Tools_Stddev_Samp_Fields>;
  sum?: Maybe<Y_Tools_Sum_Fields>;
  var_pop?: Maybe<Y_Tools_Var_Pop_Fields>;
  var_samp?: Maybe<Y_Tools_Var_Samp_Fields>;
  variance?: Maybe<Y_Tools_Variance_Fields>;
};


/** aggregate fields of "y_tools" */
export type Y_Tools_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Y_Tools_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Y_Tools_Avg_Fields = {
  __typename: 'y_tools_avg_fields';
  bypass_connection_inches?: Maybe<Scalars['Float']['output']>;
  handling_sub_connection_inches?: Maybe<Scalars['Float']['output']>;
  length_inches?: Maybe<Scalars['Float']['output']>;
  maximum_inches?: Maybe<Scalars['Float']['output']>;
  minimum_inches?: Maybe<Scalars['Float']['output']>;
  outer_diameter_inches?: Maybe<Scalars['Float']['output']>;
  pressure_rating_psi?: Maybe<Scalars['Float']['output']>;
  teleswivel_stroke_length_inches?: Maybe<Scalars['Float']['output']>;
  temperature_rating_fahrenheit?: Maybe<Scalars['Float']['output']>;
  weight_pounds?: Maybe<Scalars['Float']['output']>;
  width_inches?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "y_tools". All fields are combined with a logical 'AND'. */
export type Y_Tools_Bool_Exp = {
  _and?: InputMaybe<Array<Y_Tools_Bool_Exp>>;
  _not?: InputMaybe<Y_Tools_Bool_Exp>;
  _or?: InputMaybe<Array<Y_Tools_Bool_Exp>>;
  author_id?: InputMaybe<String_Comparison_Exp>;
  bypass_connection_inches?: InputMaybe<Numeric_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  downhole_scenario_equipment_revisions?: InputMaybe<Revisions_Scenario_Equipment_Revisions_Bool_Exp>;
  downhole_scenario_equipment_revisions_aggregate?: InputMaybe<Revisions_Scenario_Equipment_Revisions_Aggregate_Bool_Exp>;
  handling_sub_connection_inches?: InputMaybe<Numeric_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  include_ecopetrol_timestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  include_koc_timestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  length_inches?: InputMaybe<Numeric_Comparison_Exp>;
  manufacturer?: InputMaybe<String_Comparison_Exp>;
  material_type?: InputMaybe<String_Comparison_Exp>;
  maximum_inches?: InputMaybe<Numeric_Comparison_Exp>;
  minimum_inches?: InputMaybe<Numeric_Comparison_Exp>;
  only_ecopetrol_timestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  only_koc_timestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  outer_diameter_inches?: InputMaybe<Numeric_Comparison_Exp>;
  pressure_rating_psi?: InputMaybe<Int_Comparison_Exp>;
  series_model?: InputMaybe<String_Comparison_Exp>;
  teleswivel_stroke_length_inches?: InputMaybe<Numeric_Comparison_Exp>;
  temperature_rating_fahrenheit?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  uphole_scenario_equipment_revisions?: InputMaybe<Revisions_Scenario_Equipment_Revisions_Bool_Exp>;
  uphole_scenario_equipment_revisions_aggregate?: InputMaybe<Revisions_Scenario_Equipment_Revisions_Aggregate_Bool_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  weight_pounds?: InputMaybe<Numeric_Comparison_Exp>;
  width_inches?: InputMaybe<Numeric_Comparison_Exp>;
};

/** unique or primary key constraints on table "y_tools" */
export enum Y_Tools_Constraint {
  /** unique or primary key constraint on columns "id" */
  YToolsPkey = 'y_tools_pkey'
}

/** input type for incrementing numeric columns in table "y_tools" */
export type Y_Tools_Inc_Input = {
  bypass_connection_inches?: InputMaybe<Scalars['numeric']['input']>;
  handling_sub_connection_inches?: InputMaybe<Scalars['numeric']['input']>;
  length_inches?: InputMaybe<Scalars['numeric']['input']>;
  maximum_inches?: InputMaybe<Scalars['numeric']['input']>;
  minimum_inches?: InputMaybe<Scalars['numeric']['input']>;
  outer_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  pressure_rating_psi?: InputMaybe<Scalars['Int']['input']>;
  teleswivel_stroke_length_inches?: InputMaybe<Scalars['numeric']['input']>;
  temperature_rating_fahrenheit?: InputMaybe<Scalars['Int']['input']>;
  weight_pounds?: InputMaybe<Scalars['numeric']['input']>;
  width_inches?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "y_tools" */
export type Y_Tools_Insert_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  bypass_connection_inches?: InputMaybe<Scalars['numeric']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  downhole_scenario_equipment_revisions?: InputMaybe<Revisions_Scenario_Equipment_Revisions_Arr_Rel_Insert_Input>;
  handling_sub_connection_inches?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  include_ecopetrol_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  include_koc_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  length_inches?: InputMaybe<Scalars['numeric']['input']>;
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  material_type?: InputMaybe<Scalars['String']['input']>;
  maximum_inches?: InputMaybe<Scalars['numeric']['input']>;
  minimum_inches?: InputMaybe<Scalars['numeric']['input']>;
  only_ecopetrol_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  only_koc_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  outer_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  pressure_rating_psi?: InputMaybe<Scalars['Int']['input']>;
  series_model?: InputMaybe<Scalars['String']['input']>;
  teleswivel_stroke_length_inches?: InputMaybe<Scalars['numeric']['input']>;
  temperature_rating_fahrenheit?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  uphole_scenario_equipment_revisions?: InputMaybe<Revisions_Scenario_Equipment_Revisions_Arr_Rel_Insert_Input>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  weight_pounds?: InputMaybe<Scalars['numeric']['input']>;
  width_inches?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate max on columns */
export type Y_Tools_Max_Fields = {
  __typename: 'y_tools_max_fields';
  author_id?: Maybe<Scalars['String']['output']>;
  bypass_connection_inches?: Maybe<Scalars['numeric']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  handling_sub_connection_inches?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  include_ecopetrol_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  include_koc_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  length_inches?: Maybe<Scalars['numeric']['output']>;
  manufacturer?: Maybe<Scalars['String']['output']>;
  material_type?: Maybe<Scalars['String']['output']>;
  maximum_inches?: Maybe<Scalars['numeric']['output']>;
  minimum_inches?: Maybe<Scalars['numeric']['output']>;
  only_ecopetrol_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  only_koc_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  outer_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  pressure_rating_psi?: Maybe<Scalars['Int']['output']>;
  series_model?: Maybe<Scalars['String']['output']>;
  teleswivel_stroke_length_inches?: Maybe<Scalars['numeric']['output']>;
  temperature_rating_fahrenheit?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  weight_pounds?: Maybe<Scalars['numeric']['output']>;
  width_inches?: Maybe<Scalars['numeric']['output']>;
};

/** aggregate min on columns */
export type Y_Tools_Min_Fields = {
  __typename: 'y_tools_min_fields';
  author_id?: Maybe<Scalars['String']['output']>;
  bypass_connection_inches?: Maybe<Scalars['numeric']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  handling_sub_connection_inches?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  include_ecopetrol_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  include_koc_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  length_inches?: Maybe<Scalars['numeric']['output']>;
  manufacturer?: Maybe<Scalars['String']['output']>;
  material_type?: Maybe<Scalars['String']['output']>;
  maximum_inches?: Maybe<Scalars['numeric']['output']>;
  minimum_inches?: Maybe<Scalars['numeric']['output']>;
  only_ecopetrol_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  only_koc_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  outer_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  pressure_rating_psi?: Maybe<Scalars['Int']['output']>;
  series_model?: Maybe<Scalars['String']['output']>;
  teleswivel_stroke_length_inches?: Maybe<Scalars['numeric']['output']>;
  temperature_rating_fahrenheit?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  weight_pounds?: Maybe<Scalars['numeric']['output']>;
  width_inches?: Maybe<Scalars['numeric']['output']>;
};

/** response of any mutation on the table "y_tools" */
export type Y_Tools_Mutation_Response = {
  __typename: 'y_tools_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Y_Tools>;
};

/** input type for inserting object relation for remote table "y_tools" */
export type Y_Tools_Obj_Rel_Insert_Input = {
  data: Y_Tools_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Y_Tools_On_Conflict>;
};

/** on_conflict condition type for table "y_tools" */
export type Y_Tools_On_Conflict = {
  constraint: Y_Tools_Constraint;
  update_columns?: Array<Y_Tools_Update_Column>;
  where?: InputMaybe<Y_Tools_Bool_Exp>;
};

/** Ordering options when selecting data from "y_tools". */
export type Y_Tools_Order_By = {
  author_id?: InputMaybe<Order_By>;
  bypass_connection_inches?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  downhole_scenario_equipment_revisions_aggregate?: InputMaybe<Revisions_Scenario_Equipment_Revisions_Aggregate_Order_By>;
  handling_sub_connection_inches?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  include_ecopetrol_timestamp?: InputMaybe<Order_By>;
  include_koc_timestamp?: InputMaybe<Order_By>;
  length_inches?: InputMaybe<Order_By>;
  manufacturer?: InputMaybe<Order_By>;
  material_type?: InputMaybe<Order_By>;
  maximum_inches?: InputMaybe<Order_By>;
  minimum_inches?: InputMaybe<Order_By>;
  only_ecopetrol_timestamp?: InputMaybe<Order_By>;
  only_koc_timestamp?: InputMaybe<Order_By>;
  outer_diameter_inches?: InputMaybe<Order_By>;
  pressure_rating_psi?: InputMaybe<Order_By>;
  series_model?: InputMaybe<Order_By>;
  teleswivel_stroke_length_inches?: InputMaybe<Order_By>;
  temperature_rating_fahrenheit?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  uphole_scenario_equipment_revisions_aggregate?: InputMaybe<Revisions_Scenario_Equipment_Revisions_Aggregate_Order_By>;
  user?: InputMaybe<Users_Order_By>;
  weight_pounds?: InputMaybe<Order_By>;
  width_inches?: InputMaybe<Order_By>;
};

/** primary key columns input for table: y_tools */
export type Y_Tools_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "y_tools" */
export enum Y_Tools_Select_Column {
  /** column name */
  AuthorId = 'author_id',
  /** column name */
  BypassConnectionInches = 'bypass_connection_inches',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  HandlingSubConnectionInches = 'handling_sub_connection_inches',
  /** column name */
  Id = 'id',
  /** column name */
  IncludeEcopetrolTimestamp = 'include_ecopetrol_timestamp',
  /** column name */
  IncludeKocTimestamp = 'include_koc_timestamp',
  /** column name */
  LengthInches = 'length_inches',
  /** column name */
  Manufacturer = 'manufacturer',
  /** column name */
  MaterialType = 'material_type',
  /** column name */
  MaximumInches = 'maximum_inches',
  /** column name */
  MinimumInches = 'minimum_inches',
  /** column name */
  OnlyEcopetrolTimestamp = 'only_ecopetrol_timestamp',
  /** column name */
  OnlyKocTimestamp = 'only_koc_timestamp',
  /** column name */
  OuterDiameterInches = 'outer_diameter_inches',
  /** column name */
  PressureRatingPsi = 'pressure_rating_psi',
  /** column name */
  SeriesModel = 'series_model',
  /** column name */
  TeleswivelStrokeLengthInches = 'teleswivel_stroke_length_inches',
  /** column name */
  TemperatureRatingFahrenheit = 'temperature_rating_fahrenheit',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WeightPounds = 'weight_pounds',
  /** column name */
  WidthInches = 'width_inches'
}

/** input type for updating data in table "y_tools" */
export type Y_Tools_Set_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  bypass_connection_inches?: InputMaybe<Scalars['numeric']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  handling_sub_connection_inches?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  include_ecopetrol_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  include_koc_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  length_inches?: InputMaybe<Scalars['numeric']['input']>;
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  material_type?: InputMaybe<Scalars['String']['input']>;
  maximum_inches?: InputMaybe<Scalars['numeric']['input']>;
  minimum_inches?: InputMaybe<Scalars['numeric']['input']>;
  only_ecopetrol_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  only_koc_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  outer_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  pressure_rating_psi?: InputMaybe<Scalars['Int']['input']>;
  series_model?: InputMaybe<Scalars['String']['input']>;
  teleswivel_stroke_length_inches?: InputMaybe<Scalars['numeric']['input']>;
  temperature_rating_fahrenheit?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  weight_pounds?: InputMaybe<Scalars['numeric']['input']>;
  width_inches?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate stddev on columns */
export type Y_Tools_Stddev_Fields = {
  __typename: 'y_tools_stddev_fields';
  bypass_connection_inches?: Maybe<Scalars['Float']['output']>;
  handling_sub_connection_inches?: Maybe<Scalars['Float']['output']>;
  length_inches?: Maybe<Scalars['Float']['output']>;
  maximum_inches?: Maybe<Scalars['Float']['output']>;
  minimum_inches?: Maybe<Scalars['Float']['output']>;
  outer_diameter_inches?: Maybe<Scalars['Float']['output']>;
  pressure_rating_psi?: Maybe<Scalars['Float']['output']>;
  teleswivel_stroke_length_inches?: Maybe<Scalars['Float']['output']>;
  temperature_rating_fahrenheit?: Maybe<Scalars['Float']['output']>;
  weight_pounds?: Maybe<Scalars['Float']['output']>;
  width_inches?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Y_Tools_Stddev_Pop_Fields = {
  __typename: 'y_tools_stddev_pop_fields';
  bypass_connection_inches?: Maybe<Scalars['Float']['output']>;
  handling_sub_connection_inches?: Maybe<Scalars['Float']['output']>;
  length_inches?: Maybe<Scalars['Float']['output']>;
  maximum_inches?: Maybe<Scalars['Float']['output']>;
  minimum_inches?: Maybe<Scalars['Float']['output']>;
  outer_diameter_inches?: Maybe<Scalars['Float']['output']>;
  pressure_rating_psi?: Maybe<Scalars['Float']['output']>;
  teleswivel_stroke_length_inches?: Maybe<Scalars['Float']['output']>;
  temperature_rating_fahrenheit?: Maybe<Scalars['Float']['output']>;
  weight_pounds?: Maybe<Scalars['Float']['output']>;
  width_inches?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Y_Tools_Stddev_Samp_Fields = {
  __typename: 'y_tools_stddev_samp_fields';
  bypass_connection_inches?: Maybe<Scalars['Float']['output']>;
  handling_sub_connection_inches?: Maybe<Scalars['Float']['output']>;
  length_inches?: Maybe<Scalars['Float']['output']>;
  maximum_inches?: Maybe<Scalars['Float']['output']>;
  minimum_inches?: Maybe<Scalars['Float']['output']>;
  outer_diameter_inches?: Maybe<Scalars['Float']['output']>;
  pressure_rating_psi?: Maybe<Scalars['Float']['output']>;
  teleswivel_stroke_length_inches?: Maybe<Scalars['Float']['output']>;
  temperature_rating_fahrenheit?: Maybe<Scalars['Float']['output']>;
  weight_pounds?: Maybe<Scalars['Float']['output']>;
  width_inches?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "y_tools" */
export type Y_Tools_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Y_Tools_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Y_Tools_Stream_Cursor_Value_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  bypass_connection_inches?: InputMaybe<Scalars['numeric']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  handling_sub_connection_inches?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  include_ecopetrol_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  include_koc_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  length_inches?: InputMaybe<Scalars['numeric']['input']>;
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  material_type?: InputMaybe<Scalars['String']['input']>;
  maximum_inches?: InputMaybe<Scalars['numeric']['input']>;
  minimum_inches?: InputMaybe<Scalars['numeric']['input']>;
  only_ecopetrol_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  only_koc_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  outer_diameter_inches?: InputMaybe<Scalars['numeric']['input']>;
  pressure_rating_psi?: InputMaybe<Scalars['Int']['input']>;
  series_model?: InputMaybe<Scalars['String']['input']>;
  teleswivel_stroke_length_inches?: InputMaybe<Scalars['numeric']['input']>;
  temperature_rating_fahrenheit?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  weight_pounds?: InputMaybe<Scalars['numeric']['input']>;
  width_inches?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate sum on columns */
export type Y_Tools_Sum_Fields = {
  __typename: 'y_tools_sum_fields';
  bypass_connection_inches?: Maybe<Scalars['numeric']['output']>;
  handling_sub_connection_inches?: Maybe<Scalars['numeric']['output']>;
  length_inches?: Maybe<Scalars['numeric']['output']>;
  maximum_inches?: Maybe<Scalars['numeric']['output']>;
  minimum_inches?: Maybe<Scalars['numeric']['output']>;
  outer_diameter_inches?: Maybe<Scalars['numeric']['output']>;
  pressure_rating_psi?: Maybe<Scalars['Int']['output']>;
  teleswivel_stroke_length_inches?: Maybe<Scalars['numeric']['output']>;
  temperature_rating_fahrenheit?: Maybe<Scalars['Int']['output']>;
  weight_pounds?: Maybe<Scalars['numeric']['output']>;
  width_inches?: Maybe<Scalars['numeric']['output']>;
};

/** update columns of table "y_tools" */
export enum Y_Tools_Update_Column {
  /** column name */
  AuthorId = 'author_id',
  /** column name */
  BypassConnectionInches = 'bypass_connection_inches',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  HandlingSubConnectionInches = 'handling_sub_connection_inches',
  /** column name */
  Id = 'id',
  /** column name */
  IncludeEcopetrolTimestamp = 'include_ecopetrol_timestamp',
  /** column name */
  IncludeKocTimestamp = 'include_koc_timestamp',
  /** column name */
  LengthInches = 'length_inches',
  /** column name */
  Manufacturer = 'manufacturer',
  /** column name */
  MaterialType = 'material_type',
  /** column name */
  MaximumInches = 'maximum_inches',
  /** column name */
  MinimumInches = 'minimum_inches',
  /** column name */
  OnlyEcopetrolTimestamp = 'only_ecopetrol_timestamp',
  /** column name */
  OnlyKocTimestamp = 'only_koc_timestamp',
  /** column name */
  OuterDiameterInches = 'outer_diameter_inches',
  /** column name */
  PressureRatingPsi = 'pressure_rating_psi',
  /** column name */
  SeriesModel = 'series_model',
  /** column name */
  TeleswivelStrokeLengthInches = 'teleswivel_stroke_length_inches',
  /** column name */
  TemperatureRatingFahrenheit = 'temperature_rating_fahrenheit',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WeightPounds = 'weight_pounds',
  /** column name */
  WidthInches = 'width_inches'
}

export type Y_Tools_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Y_Tools_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Y_Tools_Set_Input>;
  /** filter the rows which have to be updated */
  where: Y_Tools_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Y_Tools_Var_Pop_Fields = {
  __typename: 'y_tools_var_pop_fields';
  bypass_connection_inches?: Maybe<Scalars['Float']['output']>;
  handling_sub_connection_inches?: Maybe<Scalars['Float']['output']>;
  length_inches?: Maybe<Scalars['Float']['output']>;
  maximum_inches?: Maybe<Scalars['Float']['output']>;
  minimum_inches?: Maybe<Scalars['Float']['output']>;
  outer_diameter_inches?: Maybe<Scalars['Float']['output']>;
  pressure_rating_psi?: Maybe<Scalars['Float']['output']>;
  teleswivel_stroke_length_inches?: Maybe<Scalars['Float']['output']>;
  temperature_rating_fahrenheit?: Maybe<Scalars['Float']['output']>;
  weight_pounds?: Maybe<Scalars['Float']['output']>;
  width_inches?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Y_Tools_Var_Samp_Fields = {
  __typename: 'y_tools_var_samp_fields';
  bypass_connection_inches?: Maybe<Scalars['Float']['output']>;
  handling_sub_connection_inches?: Maybe<Scalars['Float']['output']>;
  length_inches?: Maybe<Scalars['Float']['output']>;
  maximum_inches?: Maybe<Scalars['Float']['output']>;
  minimum_inches?: Maybe<Scalars['Float']['output']>;
  outer_diameter_inches?: Maybe<Scalars['Float']['output']>;
  pressure_rating_psi?: Maybe<Scalars['Float']['output']>;
  teleswivel_stroke_length_inches?: Maybe<Scalars['Float']['output']>;
  temperature_rating_fahrenheit?: Maybe<Scalars['Float']['output']>;
  weight_pounds?: Maybe<Scalars['Float']['output']>;
  width_inches?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Y_Tools_Variance_Fields = {
  __typename: 'y_tools_variance_fields';
  bypass_connection_inches?: Maybe<Scalars['Float']['output']>;
  handling_sub_connection_inches?: Maybe<Scalars['Float']['output']>;
  length_inches?: Maybe<Scalars['Float']['output']>;
  maximum_inches?: Maybe<Scalars['Float']['output']>;
  minimum_inches?: Maybe<Scalars['Float']['output']>;
  outer_diameter_inches?: Maybe<Scalars['Float']['output']>;
  pressure_rating_psi?: Maybe<Scalars['Float']['output']>;
  teleswivel_stroke_length_inches?: Maybe<Scalars['Float']['output']>;
  temperature_rating_fahrenheit?: Maybe<Scalars['Float']['output']>;
  weight_pounds?: Maybe<Scalars['Float']['output']>;
  width_inches?: Maybe<Scalars['Float']['output']>;
};

export type CasingsTypeFieldsFragment = { __typename: 'casings_type', value: string, comment?: string | null, id: string };

export type CasingsTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type CasingsTypesQuery = { __typename: 'query_root', casings_type: Array<{ __typename: 'casings_type', value: string, comment?: string | null, id: string }> };

export type TubingFlowOptionsFieldsFragment = { __typename: 'tubing_flow_options', comment?: string | null, value: string, id: string };

export type CasingFlowOptionsFieldsFragment = { __typename: 'casing_flow_options', comment?: string | null, value: string, id: string };

export type BubblePointOptionsFieldsFragment = { __typename: 'bubble_point_options', comment?: string | null, value: string, id: string };

export type WaterVolumeFactorOptionsFieldsFragment = { __typename: 'water_volume_factor_options', comment?: string | null, value: string, id: string };

export type SolutionGasOilRatioOptionsFieldsFragment = { __typename: 'solution_gas_oil_ratio_options', comment?: string | null, value: string, id: string };

export type GasCompressibilityOptionsFieldsFragment = { __typename: 'gas_compressibility_options', comment?: string | null, value: string, id: string };

export type WellGasTypeOptionsFieldsFragment = { __typename: 'well_gas_type_options', comment?: string | null, value: string, id: string };

export type OilVolumeFactorOptionsFieldsFragment = { __typename: 'oil_volume_factor_options', comment?: string | null, value: string, id: string };

export type OilDensityOptionsFieldsFragment = { __typename: 'oil_density_options', comment?: string | null, value: string, id: string };

export type DeadOilOptionsFieldsFragment = { __typename: 'dead_oil_options', comment?: string | null, value: string, id: string };

export type WaterViscosityOptionsFieldsFragment = { __typename: 'water_viscosity_options', comment?: string | null, value: string, id: string };

export type SaturatedOilOptionsFieldsFragment = { __typename: 'saturated_oil_options', comment?: string | null, value: string, id: string };

export type GasViscosityOptionsFieldsFragment = { __typename: 'gas_viscosity_options', comment?: string | null, value: string, id: string };

export type UnderSaturatedOilOptionsFieldsFragment = { __typename: 'under_saturated_oil_options', comment?: string | null, value: string, id: string };

export type FrictionLossOptionsFieldsFragment = { __typename: 'friction_loss_options', comment?: string | null, value: string, id: string };

export type WaterDensityOptionsFieldsFragment = { __typename: 'water_density_options', comment?: string | null, value: string, id: string };

export type WaterSolutionGasOptionsFieldsFragment = { __typename: 'water_solution_gas_options', comment?: string | null, value: string, id: string };

export type NaturalGasSeparationOptionsFieldsFragment = { __typename: 'natural_gas_separation_options', value: string, comment?: string | null, id: string };

export type TubingFlowOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type TubingFlowOptionsQuery = { __typename: 'query_root', tubing_flow_options: Array<{ __typename: 'tubing_flow_options', comment?: string | null, value: string, id: string }> };

export type CasingFlowOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type CasingFlowOptionsQuery = { __typename: 'query_root', casing_flow_options: Array<{ __typename: 'casing_flow_options', comment?: string | null, value: string, id: string }> };

export type FrictionLossOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type FrictionLossOptionsQuery = { __typename: 'query_root', friction_loss_options: Array<{ __typename: 'friction_loss_options', comment?: string | null, value: string, id: string }> };

export type BubblePointOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type BubblePointOptionsQuery = { __typename: 'query_root', bubble_point_options: Array<{ __typename: 'bubble_point_options', comment?: string | null, value: string, id: string }> };

export type WaterVolumeFactorOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type WaterVolumeFactorOptionsQuery = { __typename: 'query_root', water_volume_factor_options: Array<{ __typename: 'water_volume_factor_options', comment?: string | null, value: string, id: string }> };

export type SolutionGasOilRatioOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type SolutionGasOilRatioOptionsQuery = { __typename: 'query_root', solution_gas_oil_ratio_options: Array<{ __typename: 'solution_gas_oil_ratio_options', comment?: string | null, value: string, id: string }> };

export type GasCompressibilityOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GasCompressibilityOptionsQuery = { __typename: 'query_root', gas_compressibility_options: Array<{ __typename: 'gas_compressibility_options', comment?: string | null, value: string, id: string }> };

export type WellGasTypeOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type WellGasTypeOptionsQuery = { __typename: 'query_root', well_gas_type_options: Array<{ __typename: 'well_gas_type_options', comment?: string | null, value: string, id: string }> };

export type OilVolumeFactorOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type OilVolumeFactorOptionsQuery = { __typename: 'query_root', oil_volume_factor_options: Array<{ __typename: 'oil_volume_factor_options', comment?: string | null, value: string, id: string }> };

export type OilDensityOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type OilDensityOptionsQuery = { __typename: 'query_root', oil_density_options: Array<{ __typename: 'oil_density_options', comment?: string | null, value: string, id: string }> };

export type DeadOilOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type DeadOilOptionsQuery = { __typename: 'query_root', dead_oil_options: Array<{ __typename: 'dead_oil_options', comment?: string | null, value: string, id: string }> };

export type WaterViscosityOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type WaterViscosityOptionsQuery = { __typename: 'query_root', water_viscosity_options: Array<{ __typename: 'water_viscosity_options', comment?: string | null, value: string, id: string }> };

export type SaturatedOilOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type SaturatedOilOptionsQuery = { __typename: 'query_root', saturated_oil_options: Array<{ __typename: 'saturated_oil_options', comment?: string | null, value: string, id: string }> };

export type GasViscosityOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GasViscosityOptionsQuery = { __typename: 'query_root', gas_viscosity_options: Array<{ __typename: 'gas_viscosity_options', comment?: string | null, value: string, id: string }> };

export type UnderSaturatedOilOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type UnderSaturatedOilOptionsQuery = { __typename: 'query_root', under_saturated_oil_options: Array<{ __typename: 'under_saturated_oil_options', comment?: string | null, value: string, id: string }> };

export type WaterDensityOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type WaterDensityOptionsQuery = { __typename: 'query_root', water_density_options: Array<{ __typename: 'water_density_options', comment?: string | null, value: string, id: string }> };

export type WaterSolutionGasOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type WaterSolutionGasOptionsQuery = { __typename: 'query_root', water_solution_gas_options: Array<{ __typename: 'water_solution_gas_options', comment?: string | null, value: string, id: string }> };

export type NaturalGasSeparationOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type NaturalGasSeparationOptionsQuery = { __typename: 'query_root', natural_gas_separation_options: Array<{ __typename: 'natural_gas_separation_options', value: string, comment?: string | null, id: string }> };

export type CorrelationsOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type CorrelationsOptionsQuery = { __typename: 'query_root', tubing_flow_options: Array<{ __typename: 'tubing_flow_options', comment?: string | null, value: string, id: string }>, casing_flow_options: Array<{ __typename: 'casing_flow_options', comment?: string | null, value: string, id: string }>, friction_loss_options: Array<{ __typename: 'friction_loss_options', comment?: string | null, value: string, id: string }>, bubble_point_options: Array<{ __typename: 'bubble_point_options', comment?: string | null, value: string, id: string }>, water_volume_factor_options: Array<{ __typename: 'water_volume_factor_options', comment?: string | null, value: string, id: string }>, solution_gas_oil_ratio_options: Array<{ __typename: 'solution_gas_oil_ratio_options', comment?: string | null, value: string, id: string }>, gas_compressibility_options: Array<{ __typename: 'gas_compressibility_options', comment?: string | null, value: string, id: string }>, oil_volume_factor_options: Array<{ __typename: 'oil_volume_factor_options', comment?: string | null, value: string, id: string }>, oil_density_options: Array<{ __typename: 'oil_density_options', comment?: string | null, value: string, id: string }>, dead_oil_options: Array<{ __typename: 'dead_oil_options', comment?: string | null, value: string, id: string }>, water_viscosity_options: Array<{ __typename: 'water_viscosity_options', comment?: string | null, value: string, id: string }>, saturated_oil_options: Array<{ __typename: 'saturated_oil_options', comment?: string | null, value: string, id: string }>, gas_viscosity_options: Array<{ __typename: 'gas_viscosity_options', comment?: string | null, value: string, id: string }>, under_saturated_oil_options: Array<{ __typename: 'under_saturated_oil_options', comment?: string | null, value: string, id: string }>, water_density_options: Array<{ __typename: 'water_density_options', comment?: string | null, value: string, id: string }>, water_solution_gas_options: Array<{ __typename: 'water_solution_gas_options', comment?: string | null, value: string, id: string }>, natural_gas_separation_options: Array<{ __typename: 'natural_gas_separation_options', value: string, comment?: string | null, id: string }> };

export type CustomersFieldsFragment = { __typename: 'customers', id: number, customer_name?: string | null, customer_erp_id: string, imported_sizing_id?: number | null };

export type CustomersQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Customers_Bool_Exp>;
  order_by?: InputMaybe<Array<Customers_Order_By>>;
}>;


export type CustomersQuery = { __typename: 'query_root', customers: Array<{ __typename: 'customers', id: number, customer_name?: string | null, customer_erp_id: string, imported_sizing_id?: number | null }> };

export type UpsertCustomerMutationVariables = Exact<{
  object: Customers_Insert_Input;
}>;


export type UpsertCustomerMutation = { __typename: 'mutation_root', insert_customers_one?: { __typename: 'customers', id: number, customer_name?: string | null, customer_erp_id: string, imported_sizing_id?: number | null } | null };

export type AnalyzeQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Sizings_Bool_Exp>;
  scenarioWhere?: Scenarios_Bool_Exp;
  order_by?: InputMaybe<Array<Sizings_Order_By>>;
  withAggregate?: Scalars['Boolean']['input'];
  withImportUser?: Scalars['Boolean']['input'];
}>;


export type AnalyzeQuery = { __typename: 'query_root', sizings: Array<{ __typename: 'sizings', id?: any | null, parent_id?: any | null, journal_author_id?: string | null, journal_created_at?: any | null, journal_updated_at?: any | null, journal_deleted_at?: any | null, winning_revision_id?: any | null, winning_revision_author_id?: string | null, well_id?: number | null, customer_id?: number | null, installed_scenario_id?: any | null, title?: string | null, notes?: string | null, default_display_units?: string | null, disposition?: string | null, pumping_type?: string | null, is_shared?: boolean | null, imported_sizing_id?: number | null, share_with_customer?: boolean | null, hps_location?: string | null, scenario_order?: Array<any> | null, parent_sizing?: { __typename: 'sizings', id?: any | null, title?: string | null, journal_deleted_at?: any | null } | null, author?: { __typename: 'users', id: string, email?: string | null, username?: string | null, display_name?: string | null, hal_identifier?: string | null } | null, well?: { __typename: 'wells', id: number, well_name?: string | null, well_uwi?: string | null, well_erp_id?: string | null, address_erp_id?: string | null } | null, customer?: { __typename: 'customers', id: number, customer_name?: string | null, customer_erp_id: string, imported_sizing_id?: number | null } | null, imported_from_sizing?: { __typename: 'sizing_imports', id: number, legacy_author_id?: string | null, legacy_user?: { __typename: 'legacy_users', hal_identifier: string, display_name?: string | null } | null } | null, scenarios_aggregate: { __typename: 'scenarios_aggregate', aggregate?: { __typename: 'scenarios_aggregate_fields', count_active: number } | null }, scenarios_deleted_aggregate: { __typename: 'scenarios_aggregate', aggregate?: { __typename: 'scenarios_aggregate_fields', count_deleted: number } | null }, scenarios: Array<{ __typename: 'scenarios', id?: any | null, journal_author_id?: string | null, journal_created_at?: any | null, journal_updated_at?: any | null, journal_deleted_at?: any | null, winning_revision_id?: any | null, title?: string | null, notes?: string | null, internal_notes?: string | null, reason?: string | null, sizing_id?: any | null, well_properties_id?: any | null, scenario_equipment_id?: any | null, parameters_id?: any | null, correlations_id?: any | null, display_unit_overrides?: any | null, pumping_type?: string | null, author?: { __typename: 'users', id: string, email?: string | null, username?: string | null, display_name?: string | null, hal_identifier?: string | null } | null, correlations?: { __typename: 'scenario_correlations', id?: any | null, journal_author_id?: string | null, journal_deleted_at?: any | null, winning_revision_id?: any | null, bubble_point?: string | null, dead_oil?: string | null, friction_loss?: string | null, gas_compressibility?: string | null, gas_viscosity?: string | null, tubing_hazen_williams_coefficient?: any | null, casing_hazen_williams_coefficient?: any | null, tubing_apply_hazen_williams_correction?: boolean | null, casing_apply_hazen_williams_correction?: boolean | null, oil_density?: string | null, oil_volume_factor_saturated?: string | null, oil_volume_factor_undersaturated?: string | null, tubing_palmer_correction?: boolean | null, casing_palmer_correction?: boolean | null, tubing_griffith_wallis?: boolean | null, casing_griffith_wallis?: boolean | null, salinity_ppm?: any | null, saturated_oil?: string | null, solution_gor?: string | null, tubing_flow?: string | null, casing_flow?: string | null, tubing_roughness_inches?: any | null, casing_roughness_inches?: any | null, under_saturated_oil?: string | null, water_density?: string | null, water_solution_gas?: string | null, water_viscosity?: string | null, water_volume_factor?: string | null, natural_gas_separation?: string | null, tdh_tuning_factor_ratio?: any | null } | null, equipment?: { __typename: 'scenario_equipment', id?: any | null, journal_author_id?: string | null, journal_created_at?: any | null, journal_updated_at?: any | null, journal_deleted_at?: any | null, mle_id?: any | null, lower_mle_id?: any | null, motor_id?: any | null, lower_motor_id?: any | null, bolt_on_discharge_id?: any | null, lower_bolt_on_discharge_id?: any | null, shroud_id?: any | null, lower_shroud_id?: any | null, parent_id?: any | null, sensor_id?: any | null, lower_sensor_id?: any | null, switchboard_id?: any | null, down_trans_id?: any | null, up_trans_id?: any | null, use_vsd?: boolean | null, use_uphole_y_tool?: boolean | null, use_downhole_y_tool?: boolean | null, has_lower_equip_stack?: boolean | null, vsd_id?: any | null, seals_order?: Array<any> | null, lower_seals_order?: Array<any> | null, winning_revision_author_id?: string | null, winning_revision_id?: any | null, intakes_order?: Array<any> | null, lower_intakes_order?: Array<any> | null, cables_order?: Array<any> | null, lower_cables_order?: Array<any> | null, pumps_order?: Array<any> | null, lower_pumps_order?: Array<any> | null, seal_motor_oil_id?: any | null, lower_seal_motor_oil_id?: any | null, uphole_y_tool_id?: any | null, downhole_y_tool_id?: any | null, include_y_tool?: boolean | null, uphole_y_tool_bypass_tubing_order?: Array<any> | null, uphole_y_tool_equipment_tubing_order?: Array<any> | null, downhole_y_tool_bypass_tubing_order?: Array<any> | null, downhole_y_tool_equipment_tubing_order?: Array<any> | null, r_sensor?: { __typename: 'sensors', id: any, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, manufacturer?: string | null, part_number?: string | null, length_inches?: number | null, weight_pounds?: number | null, model?: string | null, channels?: number | null, max_intake_temperature_fahrenheit?: number | null, max_intake_pressure_psi?: number | null, housing_material?: string | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, inner_diameter_inches?: any | null, outer_diameter_inches: any, neck_inner_diameter_inches?: any | null, neck_outer_diameter_inches?: any | null } | null, r_lower_sensor?: { __typename: 'sensors', id: any, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, manufacturer?: string | null, part_number?: string | null, length_inches?: number | null, weight_pounds?: number | null, model?: string | null, channels?: number | null, max_intake_temperature_fahrenheit?: number | null, max_intake_pressure_psi?: number | null, housing_material?: string | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, inner_diameter_inches?: any | null, outer_diameter_inches: any, neck_inner_diameter_inches?: any | null, neck_outer_diameter_inches?: any | null } | null, r_mle?: { __typename: 'motor_lead_extensions', id: any, manufacturer?: string | null, part_number?: string | null, series?: number | null, family?: string | null, gauge?: number | null, kv?: number | null, max_pothead_temperature_fahrenheit?: number | null, max_temperature_fahrenheit?: number | null, resistance_per_1000_ft?: any | null, impedance_60_hz_per_1000_ft?: any | null, amp_factor?: any | null, width_inches?: any | null, depth_inches?: any | null, pound_per_foot?: any | null, length_feet?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null } | null, r_lower_mle?: { __typename: 'motor_lead_extensions', id: any, manufacturer?: string | null, part_number?: string | null, series?: number | null, family?: string | null, gauge?: number | null, kv?: number | null, max_pothead_temperature_fahrenheit?: number | null, max_temperature_fahrenheit?: number | null, resistance_per_1000_ft?: any | null, impedance_60_hz_per_1000_ft?: any | null, amp_factor?: any | null, width_inches?: any | null, depth_inches?: any | null, pound_per_foot?: any | null, length_feet?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null } | null, r_motor?: { __typename: 'motors', id: any, author_id: string, allow_rerate: boolean, configuration?: string | null, created_at: any, deleted_at?: any | null, eff1?: any | null, eff2?: any | null, eff3?: any | null, eff4?: any | null, eff5?: any | null, effb?: any | null, i1?: any | null, i2?: any | null, i3?: any | null, i4?: any | null, i5?: any | null, ib?: any | null, imported_sizing_id?: number | null, length_inches?: any | null, manufacturer?: string | null, n1?: any | null, n2?: any | null, n3?: any | null, n4?: any | null, n5?: any | null, nameplate_current?: number | null, nameplate_horsepower?: number | null, nameplate_voltage?: number | null, nb?: any | null, oil_volume_gallons?: any | null, part_number?: string | null, pf1?: any | null, pf2?: any | null, pf3?: any | null, pf4?: any | null, pf5?: any | null, pfb?: any | null, rr_l1?: any | null, rr_l2?: any | null, rr_lb?: any | null, rr_v3: any, rr_v2: any, rr_v1?: any | null, rr_vb?: any | null, shaft_horsepower?: number | null, nv0: any, nv1: any, nv2: any, iv0: any, iv1: any, iv2: any, pfv0: any, pfv1: any, pfv2: any, effv0: any, effv1: any, effv2: any, tv0: any, tv1: any, tv2: any, temperature_rating_fahrenheit?: number | null, updated_at: any, weight_pounds?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, poles?: number | null, stator_inner_diameter_inches?: any | null, stator_outer_diameter_inches?: any | null, k3?: any | null, nameplate_rerate_ratio?: any | null, inner_diameter_inches?: any | null, outer_diameter_inches?: any | null, neck_inner_diameter_inches?: any | null, neck_outer_diameter_inches?: any | null, mle_offset_depth_inches: any, outer_diameter_rub_inches: any, is_hps: boolean } | null, r_bolt_on_discharge?: { __typename: 'bolt_on_discharges', id: any, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, manufacturer?: string | null, series_model?: string | null, is_hps: boolean, outer_diameter_inches?: any | null, inner_diameter_inches?: any | null, flange_outer_diameter_inches?: any | null, neck_outer_diameter_inches?: any | null, neck_inner_diameter_inches?: any | null, length_inches?: any | null, weight_pounds?: any | null, tubing_diameter_inches?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null } | null, r_lower_bolt_on_discharge?: { __typename: 'bolt_on_discharges', id: any, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, manufacturer?: string | null, series_model?: string | null, is_hps: boolean, outer_diameter_inches?: any | null, inner_diameter_inches?: any | null, flange_outer_diameter_inches?: any | null, neck_outer_diameter_inches?: any | null, neck_inner_diameter_inches?: any | null, length_inches?: any | null, weight_pounds?: any | null, tubing_diameter_inches?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null } | null, r_lower_motor?: { __typename: 'motors', id: any, author_id: string, allow_rerate: boolean, configuration?: string | null, created_at: any, deleted_at?: any | null, eff1?: any | null, eff2?: any | null, eff3?: any | null, eff4?: any | null, eff5?: any | null, effb?: any | null, i1?: any | null, i2?: any | null, i3?: any | null, i4?: any | null, i5?: any | null, ib?: any | null, imported_sizing_id?: number | null, length_inches?: any | null, manufacturer?: string | null, n1?: any | null, n2?: any | null, n3?: any | null, n4?: any | null, n5?: any | null, nameplate_current?: number | null, nameplate_horsepower?: number | null, nameplate_voltage?: number | null, nb?: any | null, oil_volume_gallons?: any | null, part_number?: string | null, pf1?: any | null, pf2?: any | null, pf3?: any | null, pf4?: any | null, pf5?: any | null, pfb?: any | null, rr_l1?: any | null, rr_l2?: any | null, rr_lb?: any | null, rr_v3: any, rr_v2: any, rr_v1?: any | null, rr_vb?: any | null, shaft_horsepower?: number | null, nv0: any, nv1: any, nv2: any, iv0: any, iv1: any, iv2: any, pfv0: any, pfv1: any, pfv2: any, effv0: any, effv1: any, effv2: any, tv0: any, tv1: any, tv2: any, temperature_rating_fahrenheit?: number | null, updated_at: any, weight_pounds?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, poles?: number | null, stator_inner_diameter_inches?: any | null, stator_outer_diameter_inches?: any | null, k3?: any | null, nameplate_rerate_ratio?: any | null, inner_diameter_inches?: any | null, outer_diameter_inches?: any | null, neck_inner_diameter_inches?: any | null, neck_outer_diameter_inches?: any | null, mle_offset_depth_inches: any, outer_diameter_rub_inches: any, is_hps: boolean } | null, r_shroud?: { __typename: 'casings', id: any, casing_type: Casings_Type_Enum, imperial_name?: string | null, metric_name?: string | null, outer_diameter_inches?: any | null, interior_diameter_inches?: any | null, drift_inches?: any | null, coupling_outer_diameter_inches?: any | null, pound_per_foot?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null } | null, r_lower_shroud?: { __typename: 'casings', id: any, casing_type: Casings_Type_Enum, imperial_name?: string | null, metric_name?: string | null, outer_diameter_inches?: any | null, interior_diameter_inches?: any | null, drift_inches?: any | null, coupling_outer_diameter_inches?: any | null, pound_per_foot?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null } | null, r_step_down_transformer?: { __typename: 'step_down_transformers', id: any, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, manufacturer?: string | null, part_number?: string | null, transformer_type?: string | null, primary_voltage_delta?: number | null, primary_voltage_wye?: number | null, min_secondary_voltage?: number | null, max_secondary_voltage?: number | null, weight_pounds?: number | null, enclosure?: string | null, kva?: number | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null } | null, r_step_up_transformer?: { __typename: 'step_up_transformers', id: any, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, manufacturer?: string | null, part_number?: string | null, transformer_type?: string | null, primary_voltage?: number | null, min_secondary_voltage?: number | null, max_secondary_voltage?: number | null, weight_pounds?: number | null, enclosure?: string | null, kva?: number | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null } | null, r_vsd?: { __typename: 'variable_speed_drives', id: any, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, enclosure?: string | null, kva?: number | null, manufacturer?: string | null, max_amps?: number | null, part_number?: string | null, vsd_type?: string | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null } | null, r_switchboard?: { __typename: 'switchboards', id: any, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, amps?: number | null, enclosure?: string | null, kv?: any | null, manufacturer?: string | null, part_number?: string | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null } | null, r_seal_motor_oil?: { __typename: 'seal_motor_oil', created_at: any, updated_at: any, deleted_at?: any | null, id: any, name: string, thermal_expansion_factor?: any | null, max_temp_fahrenheit?: number | null, mf_test_temp1_celsius?: number | null, mf_test_temp2_celsius?: number | null, viscosity_test1_centistroke?: any | null, viscosity_test2_centistroke?: any | null, specific_gravity?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null } | null, r_lower_seal_motor_oil?: { __typename: 'seal_motor_oil', created_at: any, updated_at: any, deleted_at?: any | null, id: any, name: string, thermal_expansion_factor?: any | null, max_temp_fahrenheit?: number | null, mf_test_temp1_celsius?: number | null, mf_test_temp2_celsius?: number | null, viscosity_test1_centistroke?: any | null, viscosity_test2_centistroke?: any | null, specific_gravity?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null } | null, r_uphole_y_tool?: { __typename: 'y_tools', id: any, author_id: string, created_at: any, deleted_at?: any | null, updated_at: any, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, minimum_inches?: any | null, maximum_inches?: any | null, length_inches?: any | null, width_inches?: any | null, series_model?: string | null, outer_diameter_inches?: any | null, teleswivel_stroke_length_inches?: any | null, pressure_rating_psi?: number | null, temperature_rating_fahrenheit?: number | null, handling_sub_connection_inches?: any | null, bypass_connection_inches?: any | null, material_type?: string | null, weight_pounds?: any | null, manufacturer?: string | null } | null, r_downhole_y_tool?: { __typename: 'y_tools', id: any, author_id: string, created_at: any, deleted_at?: any | null, updated_at: any, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, minimum_inches?: any | null, maximum_inches?: any | null, length_inches?: any | null, width_inches?: any | null, series_model?: string | null, outer_diameter_inches?: any | null, teleswivel_stroke_length_inches?: any | null, pressure_rating_psi?: number | null, temperature_rating_fahrenheit?: number | null, handling_sub_connection_inches?: any | null, bypass_connection_inches?: any | null, material_type?: string | null, weight_pounds?: any | null, manufacturer?: string | null } | null, r_xref_pumps: Array<{ __typename: 'scenario_equipment_xref_pumps', id?: any | null, scenario_equipment_id?: any | null, pump_id?: any | null, rate_correction_ratio?: any | null, head_correction_ratio?: any | null, brake_horsepower_correction_ratio?: any | null, total_stages?: number | null, length_feet?: any | null, housings_order?: Array<any> | null, use_high_strength_shaft?: boolean | null, weight_pounds?: any | null, parent_id?: any | null, journal_author_id?: string | null, journal_created_at?: any | null, journal_updated_at?: any | null, journal_deleted_at?: any | null, winning_revision_id?: any | null, winning_revision_parent_id?: any | null, winning_revision_author_id?: string | null, winning_revision_created_at?: any | null, winning_revision_updated_at?: any | null, winning_revision_deleted_at?: any | null, r_pump?: { __typename: 'pumps', id: any, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, manufacturer?: string | null, rotation?: string | null, part_number?: string | null, compression_thrust_per_stage?: any | null, series_model?: string | null, stage_type?: number | null, shaft_diameter_inches?: any | null, standard_housing_pressure_rating_psi?: number | null, high_strength_housing_pressure_rating_psi?: number | null, standard_shaft_rating_hp?: number | null, high_strength_shaft_rating_hp?: number | null, construction?: string | null, min_rate_standard_pump_bpd?: number | null, bep_rate_standard_pump_bpd?: number | null, max_rate_standard_pump_bpd?: number | null, max_graph_rate_standard_pump_bpd?: number | null, hb?: any | null, h1?: any | null, h2?: any | null, h3?: any | null, h4?: any | null, h5?: any | null, bhpb?: any | null, bhp1?: any | null, bhp2?: any | null, bhp3?: any | null, bhp4?: any | null, bhp5?: any | null, npsh1?: any | null, npsh2?: any | null, npsh3?: any | null, npsh4?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, max_bolt_load_pounds?: any | null, is_compression_pump: boolean, housing_inner_diameter_inches?: any | null, housing_outer_diameter_inches?: any | null, neck_inner_diameter_inches?: any | null, neck_outer_diameter_inches?: any | null, r_housings: Array<{ __typename: 'housings', id: any, housing_number?: number | null, stage_count?: number | null, length_inches?: any | null, weight_pounds?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, pump_id?: any | null }> } | null, r_xref_housings: Array<{ __typename: 'scenario_equipment_xref_housings', housing_id?: any | null, id?: any | null, journal_author_id?: string | null, journal_created_at?: any | null, journal_deleted_at?: any | null, journal_updated_at?: any | null, length_inches?: any | null, parent_id?: any | null, scenario_equipment_xref_pump_id?: any | null, stage_count?: number | null, winning_revision_author_id?: string | null, winning_revision_created_at?: any | null, winning_revision_deleted_at?: any | null, winning_revision_id?: any | null, winning_revision_parent_id?: any | null, winning_revision_updated_at?: any | null, r_housing?: { __typename: 'housings', id: any, housing_number?: number | null, stage_count?: number | null, length_inches?: any | null, weight_pounds?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, pump_id?: any | null } | null }> }>, r_xref_intakes: Array<{ __typename: 'scenario_equipment_xref_intakes', id?: any | null, intake_id?: any | null, scenario_equipment_id?: any | null, use_high_strength_shaft?: boolean | null, parent_id?: any | null, journal_author_id?: string | null, journal_created_at?: any | null, journal_updated_at?: any | null, journal_deleted_at?: any | null, winning_revision_id?: any | null, winning_revision_parent_id?: any | null, winning_revision_author_id?: string | null, winning_revision_created_at?: any | null, winning_revision_updated_at?: any | null, winning_revision_deleted_at?: any | null, r_intake?: { __typename: 'intakes', id: any, manufacturer?: string | null, intake_type?: string | null, part_number?: string | null, configuration?: string | null, length_inches?: any | null, weight_pounds?: any | null, shaft_material?: string | null, shaft_limit_hp?: number | null, housing_material?: string | null, max_rate_bpd?: number | null, hp?: any | null, eff1?: any | null, eff2?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, high_strength_shaft_limit_hp?: number | null, stage_count?: number | null, bhp0?: any | null, bhp1?: any | null, bhp2?: any | null, bhp3?: any | null, bhp4?: any | null, bhp5?: any | null, bolt_on?: boolean | null, port_area_square_inches: any, inner_diameter_inches?: any | null, outer_diameter_inches?: any | null, neck_inner_diameter_inches?: any | null, neck_outer_diameter_inches?: any | null, is_hps: boolean, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null } | null }>, r_xref_seals: Array<{ __typename: 'scenario_equipment_xref_seals', id?: any | null, use_high_strength_shaft?: boolean | null, parent_id?: any | null, journal_author_id?: string | null, journal_created_at?: any | null, journal_updated_at?: any | null, journal_deleted_at?: any | null, winning_revision_id?: any | null, winning_revision_parent_id?: any | null, scenario_equipment_id?: any | null, seal_id?: any | null, winning_revision_author_id?: string | null, winning_revision_created_at?: any | null, winning_revision_updated_at?: any | null, winning_revision_deleted_at?: any | null, r_seal?: { __typename: 'seals', id: any, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, manufacturer?: string | null, part_number?: string | null, length_inches?: any | null, weight_pounds?: any | null, configuration?: string | null, max_temperature_fahrenheit?: number | null, standard_shaft_limit_hp?: number | null, high_strength_shaft_limit_hp?: number | null, standard_bearing_rating_pounds?: number | null, high_strength_bearing_rating_pounds?: number | null, housing_material?: string | null, bearing_type?: string | null, total_seal_volume_gallons?: any | null, volume_for_bag_expansion_lower_tandem_gallons?: any | null, volume_for_bag_expansion_upper_tandem_gallons?: any | null, upper_chamber_pull_volume_gallons?: any | null, bag_chambers?: number | null, bag_capacity_gallons?: any | null, string_load_pounds?: any | null, load_cb_pounds?: any | null, load_c1_pounds?: any | null, hps_thrust_chamber: boolean, load_test_temperature_fahrenheit?: number | null, description?: string | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, inner_diameter_inches?: any | null, outer_diameter_inches?: any | null, neck_inner_diameter_inches?: any | null, neck_outer_diameter_inches?: any | null, thrust_collar_inner_diameter_inches: any, thrust_collar_outer_diameter_inches: any } | null }>, r_xref_cables: Array<{ __typename: 'scenario_equipment_xref_cables', id?: any | null, length_feet?: any | null, cable_id?: any | null, scenario_equipment_id?: any | null, parent_id?: any | null, journal_author_id?: string | null, journal_created_at?: any | null, journal_updated_at?: any | null, journal_deleted_at?: any | null, winning_revision_id?: any | null, winning_revision_parent_id?: any | null, winning_revision_author_id?: string | null, winning_revision_created_at?: any | null, winning_revision_updated_at?: any | null, winning_revision_deleted_at?: any | null, r_cable?: { __typename: 'cables', id: any, amp_factor?: any | null, armor?: string | null, construction?: string | null, depth_inches?: any | null, family?: string | null, gauge?: string | null, kv?: number | null, manufacturer?: string | null, max_temperature_fahrenheit?: number | null, part_number?: string | null, pound_per_foot?: any | null, width_inches?: any | null, impedance_60_hz_per_1000_ft?: any | null, resistance_per_1000_ft?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, author_id: string, created_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, updated_at: any } | null }>, r_xref_uphole_y_tool_bypass_tubings: Array<{ __typename: 'sc_equip_xref_uphole_ytool_bypass_tubings', id?: any | null, length_feet?: any | null, tubing_id?: any | null, scenario_equipment_id?: any | null, parent_id?: any | null, journal_author_id?: string | null, journal_created_at?: any | null, journal_updated_at?: any | null, journal_deleted_at?: any | null, winning_revision_id?: any | null, winning_revision_parent_id?: any | null, winning_revision_author_id?: string | null, winning_revision_created_at?: any | null, winning_revision_updated_at?: any | null, winning_revision_deleted_at?: any | null, r_tubing?: { __typename: 'tubings', id: any, author_id: string, coupling_outer_diameter_inches?: any | null, created_at: any, deleted_at?: any | null, drift_inches?: any | null, imperial_name?: string | null, imported_sizing_id?: number | null, interior_diameter_inches?: any | null, metric_name?: string | null, outer_diameter_inches?: any | null, pound_per_foot?: any | null, tubing_type: Tubings_Type_Enum, updated_at: any, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null } | null }>, r_xref_uphole_y_tool_equipment_tubings: Array<{ __typename: 'sc_equip_xref_uphole_ytool_equip_tubings', id?: any | null, length_feet?: any | null, tubing_id?: any | null, scenario_equipment_id?: any | null, parent_id?: any | null, journal_author_id?: string | null, journal_created_at?: any | null, journal_updated_at?: any | null, journal_deleted_at?: any | null, winning_revision_id?: any | null, winning_revision_parent_id?: any | null, winning_revision_author_id?: string | null, winning_revision_created_at?: any | null, winning_revision_updated_at?: any | null, winning_revision_deleted_at?: any | null, r_tubing?: { __typename: 'tubings', id: any, author_id: string, coupling_outer_diameter_inches?: any | null, created_at: any, deleted_at?: any | null, drift_inches?: any | null, imperial_name?: string | null, imported_sizing_id?: number | null, interior_diameter_inches?: any | null, metric_name?: string | null, outer_diameter_inches?: any | null, pound_per_foot?: any | null, tubing_type: Tubings_Type_Enum, updated_at: any, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null } | null }>, r_xref_downhole_y_tool_bypass_tubings: Array<{ __typename: 'sc_equip_xref_downhole_ytool_bypass_tubings', id?: any | null, length_feet?: any | null, tubing_id?: any | null, scenario_equipment_id?: any | null, parent_id?: any | null, journal_author_id?: string | null, journal_created_at?: any | null, journal_updated_at?: any | null, journal_deleted_at?: any | null, winning_revision_id?: any | null, winning_revision_parent_id?: any | null, winning_revision_author_id?: string | null, winning_revision_created_at?: any | null, winning_revision_updated_at?: any | null, winning_revision_deleted_at?: any | null, r_tubing?: { __typename: 'tubings', id: any, author_id: string, coupling_outer_diameter_inches?: any | null, created_at: any, deleted_at?: any | null, drift_inches?: any | null, imperial_name?: string | null, imported_sizing_id?: number | null, interior_diameter_inches?: any | null, metric_name?: string | null, outer_diameter_inches?: any | null, pound_per_foot?: any | null, tubing_type: Tubings_Type_Enum, updated_at: any, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null } | null }>, r_xref_downhole_y_tool_equipment_tubings: Array<{ __typename: 'sc_equip_xref_downhole_ytool_equip_tubings', id?: any | null, length_feet?: any | null, tubing_id?: any | null, scenario_equipment_id?: any | null, parent_id?: any | null, journal_author_id?: string | null, journal_created_at?: any | null, journal_updated_at?: any | null, journal_deleted_at?: any | null, winning_revision_id?: any | null, winning_revision_parent_id?: any | null, winning_revision_author_id?: string | null, winning_revision_created_at?: any | null, winning_revision_updated_at?: any | null, winning_revision_deleted_at?: any | null, r_tubing?: { __typename: 'tubings', id: any, author_id: string, coupling_outer_diameter_inches?: any | null, created_at: any, deleted_at?: any | null, drift_inches?: any | null, imperial_name?: string | null, imported_sizing_id?: number | null, interior_diameter_inches?: any | null, metric_name?: string | null, outer_diameter_inches?: any | null, pound_per_foot?: any | null, tubing_type: Tubings_Type_Enum, updated_at: any, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null } | null }> } | null, parameters?: { __typename: 'scenario_parameters', id?: any | null, journal_author_id?: string | null, journal_created_at?: any | null, journal_updated_at?: any | null, journal_deleted_at?: any | null, bottom_casing_pressure_psia?: any | null, cable_cost_kw_hr_usd?: any | null, bottom_tubing_pressure_psia?: any | null, has_compression_pump?: boolean | null, intake_override_gas_separation_percent?: any | null, intake_gas_separation_override_type?: string | null, natural_override_gas_separation_percent?: any | null, natural_gas_separation_override_type?: string | null, intake_packer_installed?: boolean | null, use_legacy_gas_head_rerate?: boolean | null, include_casing_friction_loss?: boolean | null, maximum_frequency?: any | null, minimum_frequency?: any | null, motor_rerate_ratio?: any | null, motor_shroud_interior_diameter_inches?: any | null, pump_hz?: any | null, pump_override_gas_correction_percent?: any | null, pump_wear_head_correction_ratio?: any | null, pump_wear_brake_horsepower_correction_ratio?: any | null, surface_drive_incoming_power_volts?: any | null, target_liquid_rate_std_barrel_day?: any | null, vsd_input_voltage?: any | null, flow_model?: string | null, winning_revision_id?: any | null, lower_intake_packer_installed?: boolean | null, lower_intake_override_gas_separation_percent?: any | null, lower_intake_gas_separation_override_type?: string | null, lower_natural_override_gas_separation_percent?: any | null, lower_natural_gas_separation_override_type?: string | null, lower_pump_hz?: any | null, lower_has_compression_pump?: boolean | null, lower_pump_override_gas_correction_percent?: any | null, lower_motor_rerate_ratio?: any | null, lower_motor_shroud_interior_diameter_inches?: any | null, lower_use_legacy_gas_head_rerate?: boolean | null, lower_include_casing_friction_loss?: boolean | null, lower_pump_wear_head_correction_ratio?: any | null, lower_pump_wear_brake_horsepower_correction_ratio?: any | null, elevation_feet_asl?: any | null } | null, well_properties?: { __typename: 'scenario_well_properties', average_dls?: any | null, bottom_casing_id?: any | null, bottom_casing_length_feet?: any | null, bottom_tubing_id?: any | null, bottom_tubing_length_feet?: any | null, bottomhole_temperature_fahrenheit?: any | null, bubble_point_pressure_psia?: any | null, fluid_viscosity_override_cp?: any | null, condensate_api_override?: any | null, dew_point_pressure_psia_override?: any | null, co2_percent?: any | null, deviation_survey_id?: any | null, gas_specific_gravity?: any | null, gas_type?: string | null, h2s_percent?: any | null, id?: any | null, n2_percent?: any | null, c1_methane_percent?: any | null, c2_ethane_percent?: any | null, c3_propane_percent?: any | null, ic4_isobutene_percent?: any | null, nc4_butane_percent?: any | null, ic5_isopentane_percent?: any | null, nc5_bentane_percent?: any | null, c6_hexane_percent?: any | null, c7_heptane_percent?: any | null, oil_gravity_api?: any | null, surface_temperature_fahrenheit?: any | null, top_casing_id?: any | null, top_casing_length_feet?: any | null, top_of_perforations_measured_depth_feet?: any | null, top_of_perforations_true_vertical_depth_feet?: any | null, top_tubing_id?: any | null, top_tubing_length_feet?: any | null, water_specific_gravity?: any | null, well_test_datum_point_measured_depth_feet?: any | null, well_test_gas_input_type?: string | null, well_test_gas_rate_mscf_day?: any | null, well_test_liquid_input_type?: string | null, well_test_pressure_input_type?: string | null, well_test_productivity_index?: any | null, well_test_oil_rate_stb_day?: any | null, well_test_producing_bottom_hole_pressure_psia?: any | null, well_test_static_bottom_hole_pressure_psia?: any | null, hps_pump_inlet_pressure_psia?: any | null, hps_required_discharge_pressure_psia?: any | null, hps_pump_inlet_temperature_fahrenheit?: any | null, hps_liquid_type?: string | null, npsha_ft?: any | null, well_test_test_date?: any | null, well_test_water_rate_stb_day?: any | null, journal_author_id?: string | null, journal_created_at?: any | null, journal_updated_at?: any | null, journal_deleted_at?: any | null, winning_revision_id?: any | null, custom_fluid_properties?: any | null, custom_viscosities_properties?: any | null, o2_percent?: any | null, ar_percent?: any | null, r_top_tubing?: { __typename: 'tubings', id: any, author_id: string, coupling_outer_diameter_inches?: any | null, created_at: any, deleted_at?: any | null, drift_inches?: any | null, imperial_name?: string | null, imported_sizing_id?: number | null, interior_diameter_inches?: any | null, metric_name?: string | null, outer_diameter_inches?: any | null, pound_per_foot?: any | null, tubing_type: Tubings_Type_Enum, updated_at: any, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null } | null, r_bottom_tubing?: { __typename: 'tubings', id: any, author_id: string, coupling_outer_diameter_inches?: any | null, created_at: any, deleted_at?: any | null, drift_inches?: any | null, imperial_name?: string | null, imported_sizing_id?: number | null, interior_diameter_inches?: any | null, metric_name?: string | null, outer_diameter_inches?: any | null, pound_per_foot?: any | null, tubing_type: Tubings_Type_Enum, updated_at: any, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null } | null, r_top_casing?: { __typename: 'casings', id: any, casing_type: Casings_Type_Enum, imperial_name?: string | null, metric_name?: string | null, outer_diameter_inches?: any | null, interior_diameter_inches?: any | null, drift_inches?: any | null, coupling_outer_diameter_inches?: any | null, pound_per_foot?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null } | null, r_bottom_casing?: { __typename: 'casings', id: any, casing_type: Casings_Type_Enum, imperial_name?: string | null, metric_name?: string | null, outer_diameter_inches?: any | null, interior_diameter_inches?: any | null, drift_inches?: any | null, coupling_outer_diameter_inches?: any | null, pound_per_foot?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null } | null, r_deviation_survey?: { __typename: 'deviation_survey', id: any, created_at: any, updated_at: any, deleted_at?: any | null, title?: string | null, directional_data_set: Deviation_Survey_Directional_Dataset_Enum, imported_sizing_id?: number | null, entry_rows?: Array<any> | null } | null } | null, r_performance_evaluations: Array<{ __typename: 'performance_evaluations', id?: any | null, title?: string | null, pump_hz?: any | null, water_rate_std_barrel_day?: any | null, gas_rate_mscf_day?: any | null, oil_rate_std_barrel_day?: any | null, tubing_pressure_psia?: any | null, casing_pressure_psia?: any | null, pump_intake_pressure_psia?: any | null, pump_wear_head_correction_ratio?: any | null, pump_wear_brake_horsepower_correction_ratio?: any | null, intake_override_gas_separation_percent?: any | null, intake_gas_separation_override_type?: string | null, natural_override_gas_separation_percent?: any | null, natural_gas_separation_override_type?: string | null, journal_author_id?: string | null, journal_created_at?: any | null, journal_deleted_at?: any | null, journal_updated_at?: any | null, winning_revision_id?: any | null, scenario_id?: any | null, parent_id?: any | null, r_scenario?: { __typename: 'scenarios', id?: any | null, sizing_id?: any | null, journal_author_id?: string | null, journal_deleted_at?: any | null, well_properties_id?: any | null, scenario_equipment_id?: any | null, parameters_id?: any | null, correlations_id?: any | null, title?: string | null, pumping_type?: string | null, sizing?: { __typename: 'sizings', id?: any | null, journal_author_id?: string | null, journal_deleted_at?: any | null, well_id?: number | null, customer_id?: number | null, title?: string | null, notes?: string | null, well?: { __typename: 'wells', id: number, well_name?: string | null, well_uwi?: string | null, well_erp_id?: string | null, address_erp_id?: string | null } | null, customer?: { __typename: 'customers', id: number, customer_name?: string | null, customer_erp_id: string, imported_sizing_id?: number | null } | null } | null } | null, r_author?: { __typename: 'users', id: string, email?: string | null, username?: string | null, display_name?: string | null, hal_identifier?: string | null } | null, r_xref_pumps: Array<{ __typename: 'performance_evaluations_xref_pumps', id?: any | null, journal_author_id?: string | null, journal_created_at?: any | null, journal_deleted_at?: any | null, journal_updated_at?: any | null, winning_revision_id?: any | null, xref_pump_id?: any | null, performance_evaluation_id?: any | null, rate_correction_ratio?: any | null, head_correction_ratio?: any | null, brake_horsepower_correction_ratio?: any | null }> }> }> }>, sizings_aggregate?: { __typename: 'sizings_aggregate', id: 'sizings_aggregate', aggregate?: { __typename: 'sizings_aggregate_fields', count: number, id: 'sizings_aggregate_fields' } | null }, scenarios_aggregate: { __typename: 'scenarios_aggregate', aggregate?: { __typename: 'scenarios_aggregate_fields', count: number } | null }, performance_evaluations_aggregate: { __typename: 'performance_evaluations_aggregate', id: 'performance_evaluations_aggregate', aggregate?: { __typename: 'performance_evaluations_aggregate_fields', count: number, id: 'performance_evaluations_aggregate_fields' } | null } };

export type DeviationSurveyDirectionalDataSetBaseFieldsFragment = { __typename: 'deviation_survey_directional_dataset', value: string, comment?: string | null };

export type DirectionalDataSetQueryVariables = Exact<{ [key: string]: never; }>;


export type DirectionalDataSetQuery = { __typename: 'query_root', deviation_survey_directional_dataset: Array<{ __typename: 'deviation_survey_directional_dataset', value: string, comment?: string | null }> };

export type DeviationSurveyBaseFieldsFragment = { __typename: 'deviation_survey', id: any, created_at: any, updated_at: any, deleted_at?: any | null, title?: string | null, directional_data_set: Deviation_Survey_Directional_Dataset_Enum, imported_sizing_id?: number | null, entry_rows?: Array<any> | null };

export type DeviationSurveyQueryVariables = Exact<{
  distinct_on?: InputMaybe<Array<Deviation_Survey_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Deviation_Survey_Order_By>>;
  where?: InputMaybe<Deviation_Survey_Bool_Exp>;
}>;


export type DeviationSurveyQuery = { __typename: 'query_root', deviation_survey: Array<{ __typename: 'deviation_survey', id: any, created_at: any, updated_at: any, deleted_at?: any | null, title?: string | null, directional_data_set: Deviation_Survey_Directional_Dataset_Enum, imported_sizing_id?: number | null, entry_rows?: Array<any> | null }> };

export type DisplayUnitsFieldsFragment = { __typename: 'display_units', comment?: string | null, value: string, id: string };

export type DisplayUnitsQueryVariables = Exact<{ [key: string]: never; }>;


export type DisplayUnitsQuery = { __typename: 'query_root', display_units: Array<{ __typename: 'display_units', comment?: string | null, value: string, id: string }> };

export type AllEnumsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllEnumsQuery = { __typename: 'query_root', tubing_flow_options: Array<{ __typename: 'tubing_flow_options', comment?: string | null, value: string, id: string }>, casing_flow_options: Array<{ __typename: 'casing_flow_options', comment?: string | null, value: string, id: string }>, bubble_point_options: Array<{ __typename: 'bubble_point_options', comment?: string | null, value: string, id: string }>, water_volume_factor_options: Array<{ __typename: 'water_volume_factor_options', comment?: string | null, value: string, id: string }>, water_density_options: Array<{ __typename: 'water_density_options', comment?: string | null, value: string, id: string }>, water_solution_gas_options: Array<{ __typename: 'water_solution_gas_options', comment?: string | null, value: string, id: string }>, solution_gas_oil_ratio_options: Array<{ __typename: 'solution_gas_oil_ratio_options', comment?: string | null, value: string, id: string }>, gas_compressibility_options: Array<{ __typename: 'gas_compressibility_options', comment?: string | null, value: string, id: string }>, well_gas_type_options: Array<{ __typename: 'well_gas_type_options', comment?: string | null, value: string, id: string }>, oil_volume_factor_options: Array<{ __typename: 'oil_volume_factor_options', comment?: string | null, value: string, id: string }>, oil_density_options: Array<{ __typename: 'oil_density_options', comment?: string | null, value: string, id: string }>, dead_oil_options: Array<{ __typename: 'dead_oil_options', comment?: string | null, value: string, id: string }>, water_viscosity_options: Array<{ __typename: 'water_viscosity_options', comment?: string | null, value: string, id: string }>, saturated_oil_options: Array<{ __typename: 'saturated_oil_options', comment?: string | null, value: string, id: string }>, gas_viscosity_options: Array<{ __typename: 'gas_viscosity_options', comment?: string | null, value: string, id: string }>, under_saturated_oil_options: Array<{ __typename: 'under_saturated_oil_options', comment?: string | null, value: string, id: string }>, display_units: Array<{ __typename: 'display_units', comment?: string | null, value: string, id: string }>, flow_model_active: Array<{ __typename: 'flow_model_active', comment?: string | null, value?: string | null, id?: string | null }>, scenario_reasons: Array<{ __typename: 'scenario_reasons', comment?: string | null, value: string, id: string }>, sizing_dispositions: Array<{ __typename: 'sizing_dispositions', comment?: string | null, value: string, id: string }>, sizing_pumping_type: Array<{ __typename: 'sizing_pumping_type', comment?: string | null, value: string, id: string }>, well_test_liquid_input_options: Array<{ __typename: 'well_test_liquid_input_options', comment?: string | null, value: string, id: string }>, well_test_gas_input_options: Array<{ __typename: 'well_test_gas_input_options', comment?: string | null, value: string, id: string }>, well_test_pressure_input_options: Array<{ __typename: 'well_test_pressure_input_options', comment?: string | null, value: string, id: string }>, friction_loss_options: Array<{ __typename: 'friction_loss_options', comment?: string | null, value: string, id: string }>, override_options: Array<{ __typename: 'override_options', value: string, comment?: string | null, id: string }>, tubings_type: Array<{ __typename: 'tubings_type', value: string, comment?: string | null, id: string }>, casings_type: Array<{ __typename: 'casings_type', value: string, comment?: string | null, id: string }> };

export type BoltOnDischargesBaseFieldsFragment = { __typename: 'bolt_on_discharges', id: any, manufacturer?: string | null, series_model?: string | null, is_hps: boolean, outer_diameter_inches?: any | null, inner_diameter_inches?: any | null, flange_outer_diameter_inches?: any | null, neck_outer_diameter_inches?: any | null, neck_inner_diameter_inches?: any | null, length_inches?: any | null, weight_pounds?: any | null, tubing_diameter_inches?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null };

export type BoltOnDischargesAllFieldsFragment = { __typename: 'bolt_on_discharges', id: any, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, manufacturer?: string | null, series_model?: string | null, is_hps: boolean, outer_diameter_inches?: any | null, inner_diameter_inches?: any | null, flange_outer_diameter_inches?: any | null, neck_outer_diameter_inches?: any | null, neck_inner_diameter_inches?: any | null, length_inches?: any | null, weight_pounds?: any | null, tubing_diameter_inches?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null };

export type BoltOnDischargesInsertFieldsFragment = { __typename: 'bolt_on_discharges', id: any, created_at: any, updated_at: any, manufacturer?: string | null, series_model?: string | null, is_hps: boolean, outer_diameter_inches?: any | null, inner_diameter_inches?: any | null, flange_outer_diameter_inches?: any | null, neck_outer_diameter_inches?: any | null, neck_inner_diameter_inches?: any | null, length_inches?: any | null, weight_pounds?: any | null, tubing_diameter_inches?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null };

export type BoltOnDischargesBaseQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Bolt_On_Discharges_Bool_Exp>;
  order_by?: InputMaybe<Array<Bolt_On_Discharges_Order_By>>;
}>;


export type BoltOnDischargesBaseQuery = { __typename: 'query_root', bolt_on_discharges: Array<{ __typename: 'bolt_on_discharges', id: any, manufacturer?: string | null, series_model?: string | null, is_hps: boolean, outer_diameter_inches?: any | null, inner_diameter_inches?: any | null, flange_outer_diameter_inches?: any | null, neck_outer_diameter_inches?: any | null, neck_inner_diameter_inches?: any | null, length_inches?: any | null, weight_pounds?: any | null, tubing_diameter_inches?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null }>, bolt_on_discharges_aggregate: { __typename: 'bolt_on_discharges_aggregate', aggregate?: { __typename: 'bolt_on_discharges_aggregate_fields', count: number } | null } };

export type BoltOnDischargesQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Bolt_On_Discharges_Bool_Exp>;
  order_by?: InputMaybe<Array<Bolt_On_Discharges_Order_By>>;
}>;


export type BoltOnDischargesQuery = { __typename: 'query_root', bolt_on_discharges: Array<{ __typename: 'bolt_on_discharges', id: any, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, manufacturer?: string | null, series_model?: string | null, is_hps: boolean, outer_diameter_inches?: any | null, inner_diameter_inches?: any | null, flange_outer_diameter_inches?: any | null, neck_outer_diameter_inches?: any | null, neck_inner_diameter_inches?: any | null, length_inches?: any | null, weight_pounds?: any | null, tubing_diameter_inches?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null }>, bolt_on_discharges_aggregate: { __typename: 'bolt_on_discharges_aggregate', id: 'bolt_on_discharges_aggregate', aggregate?: { __typename: 'bolt_on_discharges_aggregate_fields', count: number, id: 'bolt_on_discharges_aggregate_fields' } | null } };

export type BoltOnDischargesSubSubscriptionVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Bolt_On_Discharges_Bool_Exp>;
  order_by?: InputMaybe<Array<Bolt_On_Discharges_Order_By>>;
}>;


export type BoltOnDischargesSubSubscription = { __typename: 'subscription_root', bolt_on_discharges: Array<{ __typename: 'bolt_on_discharges', id: any, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, manufacturer?: string | null, series_model?: string | null, is_hps: boolean, outer_diameter_inches?: any | null, inner_diameter_inches?: any | null, flange_outer_diameter_inches?: any | null, neck_outer_diameter_inches?: any | null, neck_inner_diameter_inches?: any | null, length_inches?: any | null, weight_pounds?: any | null, tubing_diameter_inches?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null }> };

export type DeleteBoltOnDischargesMutationVariables = Exact<{
  where: Bolt_On_Discharges_Bool_Exp;
}>;


export type DeleteBoltOnDischargesMutation = { __typename: 'mutation_root', update_bolt_on_discharges?: { __typename: 'bolt_on_discharges_mutation_response', returning: Array<{ __typename: 'bolt_on_discharges', id: any }> } | null };

export type RestoreBoltOnDischargesMutationVariables = Exact<{
  where: Bolt_On_Discharges_Bool_Exp;
}>;


export type RestoreBoltOnDischargesMutation = { __typename: 'mutation_root', update_bolt_on_discharges?: { __typename: 'bolt_on_discharges_mutation_response', returning: Array<{ __typename: 'bolt_on_discharges', id: any }> } | null };

export type UpdateBoltOnDischargeByPkMutationVariables = Exact<{
  object?: InputMaybe<Bolt_On_Discharges_Set_Input>;
  id: Scalars['uuid']['input'];
}>;


export type UpdateBoltOnDischargeByPkMutation = { __typename: 'mutation_root', update_bolt_on_discharges_by_pk?: { __typename: 'bolt_on_discharges', id: any, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, manufacturer?: string | null, series_model?: string | null, is_hps: boolean, outer_diameter_inches?: any | null, inner_diameter_inches?: any | null, flange_outer_diameter_inches?: any | null, neck_outer_diameter_inches?: any | null, neck_inner_diameter_inches?: any | null, length_inches?: any | null, weight_pounds?: any | null, tubing_diameter_inches?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null } | null };

export type InsertBoltOnDischargeMutationVariables = Exact<{
  object: Bolt_On_Discharges_Insert_Input;
}>;


export type InsertBoltOnDischargeMutation = { __typename: 'mutation_root', insert_bolt_on_discharges_one?: { __typename: 'bolt_on_discharges', id: any, created_at: any, updated_at: any, manufacturer?: string | null, series_model?: string | null, is_hps: boolean, outer_diameter_inches?: any | null, inner_diameter_inches?: any | null, flange_outer_diameter_inches?: any | null, neck_outer_diameter_inches?: any | null, neck_inner_diameter_inches?: any | null, length_inches?: any | null, weight_pounds?: any | null, tubing_diameter_inches?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null } | null };

export type CablesBaseFieldsFragment = { __typename: 'cables', id: any, amp_factor?: any | null, armor?: string | null, construction?: string | null, depth_inches?: any | null, family?: string | null, gauge?: string | null, kv?: number | null, manufacturer?: string | null, max_temperature_fahrenheit?: number | null, part_number?: string | null, pound_per_foot?: any | null, width_inches?: any | null, impedance_60_hz_per_1000_ft?: any | null, resistance_per_1000_ft?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null };

export type CablesMetaFieldsFragment = { __typename: 'cables', id: any, author_id: string, created_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, updated_at: any };

export type CablesAllFieldsFragment = { __typename: 'cables', id: any, amp_factor?: any | null, armor?: string | null, construction?: string | null, depth_inches?: any | null, family?: string | null, gauge?: string | null, kv?: number | null, manufacturer?: string | null, max_temperature_fahrenheit?: number | null, part_number?: string | null, pound_per_foot?: any | null, width_inches?: any | null, impedance_60_hz_per_1000_ft?: any | null, resistance_per_1000_ft?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, author_id: string, created_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, updated_at: any };

export type CablesBaseQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Cables_Bool_Exp>;
  order_by?: InputMaybe<Array<Cables_Order_By>>;
}>;


export type CablesBaseQuery = { __typename: 'query_root', cables: Array<{ __typename: 'cables', id: any, amp_factor?: any | null, armor?: string | null, construction?: string | null, depth_inches?: any | null, family?: string | null, gauge?: string | null, kv?: number | null, manufacturer?: string | null, max_temperature_fahrenheit?: number | null, part_number?: string | null, pound_per_foot?: any | null, width_inches?: any | null, impedance_60_hz_per_1000_ft?: any | null, resistance_per_1000_ft?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null }>, cables_aggregate: { __typename: 'cables_aggregate', aggregate?: { __typename: 'cables_aggregate_fields', count: number } | null } };

export type CablesQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Cables_Bool_Exp>;
  order_by?: InputMaybe<Array<Cables_Order_By>>;
}>;


export type CablesQuery = { __typename: 'query_root', cables: Array<{ __typename: 'cables', id: any, amp_factor?: any | null, armor?: string | null, construction?: string | null, depth_inches?: any | null, family?: string | null, gauge?: string | null, kv?: number | null, manufacturer?: string | null, max_temperature_fahrenheit?: number | null, part_number?: string | null, pound_per_foot?: any | null, width_inches?: any | null, impedance_60_hz_per_1000_ft?: any | null, resistance_per_1000_ft?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, author_id: string, created_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, updated_at: any }>, cables_aggregate: { __typename: 'cables_aggregate', id: 'cables_aggregate', aggregate?: { __typename: 'cables_aggregate_fields', count: number, id: 'cables_aggregate_fields' } | null } };

export type DeleteCablesMutationVariables = Exact<{
  where: Cables_Bool_Exp;
}>;


export type DeleteCablesMutation = { __typename: 'mutation_root', update_cables?: { __typename: 'cables_mutation_response', returning: Array<{ __typename: 'cables', id: any }> } | null };

export type RestoreCablesMutationVariables = Exact<{
  where: Cables_Bool_Exp;
}>;


export type RestoreCablesMutation = { __typename: 'mutation_root', update_cables?: { __typename: 'cables_mutation_response', returning: Array<{ __typename: 'cables', id: any }> } | null };

export type InsertCableMutationVariables = Exact<{
  object: Cables_Insert_Input;
}>;


export type InsertCableMutation = { __typename: 'mutation_root', insert_cables_one?: { __typename: 'cables', id: any, amp_factor?: any | null, armor?: string | null, construction?: string | null, depth_inches?: any | null, family?: string | null, gauge?: string | null, kv?: number | null, manufacturer?: string | null, max_temperature_fahrenheit?: number | null, part_number?: string | null, pound_per_foot?: any | null, width_inches?: any | null, impedance_60_hz_per_1000_ft?: any | null, resistance_per_1000_ft?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, author_id: string, created_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, updated_at: any } | null };

export type UpdateCableByPkMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  object: Cables_Set_Input;
}>;


export type UpdateCableByPkMutation = { __typename: 'mutation_root', update_cables_by_pk?: { __typename: 'cables', id: any, amp_factor?: any | null, armor?: string | null, construction?: string | null, depth_inches?: any | null, family?: string | null, gauge?: string | null, kv?: number | null, manufacturer?: string | null, max_temperature_fahrenheit?: number | null, part_number?: string | null, pound_per_foot?: any | null, width_inches?: any | null, impedance_60_hz_per_1000_ft?: any | null, resistance_per_1000_ft?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, author_id: string, created_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, updated_at: any } | null };

export type CablesSubSubscriptionVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Cables_Bool_Exp>;
  order_by?: InputMaybe<Array<Cables_Order_By>>;
}>;


export type CablesSubSubscription = { __typename: 'subscription_root', cables: Array<{ __typename: 'cables', id: any, amp_factor?: any | null, armor?: string | null, construction?: string | null, depth_inches?: any | null, family?: string | null, gauge?: string | null, kv?: number | null, manufacturer?: string | null, max_temperature_fahrenheit?: number | null, part_number?: string | null, pound_per_foot?: any | null, width_inches?: any | null, impedance_60_hz_per_1000_ft?: any | null, resistance_per_1000_ft?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, author_id: string, created_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, updated_at: any }> };

export type CasingsBaseFieldsFragment = { __typename: 'casings', id: any, casing_type: Casings_Type_Enum, imperial_name?: string | null, metric_name?: string | null, outer_diameter_inches?: any | null, interior_diameter_inches?: any | null, drift_inches?: any | null, coupling_outer_diameter_inches?: any | null, pound_per_foot?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null };

export type CasingsMetaFieldsFragment = { __typename: 'casings', id: any, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null };

export type CasingsAllFieldsFragment = { __typename: 'casings', id: any, casing_type: Casings_Type_Enum, imperial_name?: string | null, metric_name?: string | null, outer_diameter_inches?: any | null, interior_diameter_inches?: any | null, drift_inches?: any | null, coupling_outer_diameter_inches?: any | null, pound_per_foot?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null };

export type CasingsBaseQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Casings_Bool_Exp>;
  order_by?: InputMaybe<Array<Casings_Order_By>>;
}>;


export type CasingsBaseQuery = { __typename: 'query_root', casings: Array<{ __typename: 'casings', id: any, casing_type: Casings_Type_Enum, imperial_name?: string | null, metric_name?: string | null, outer_diameter_inches?: any | null, interior_diameter_inches?: any | null, drift_inches?: any | null, coupling_outer_diameter_inches?: any | null, pound_per_foot?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null }>, casings_aggregate: { __typename: 'casings_aggregate', aggregate?: { __typename: 'casings_aggregate_fields', count: number } | null } };

export type CasingsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Casings_Bool_Exp>;
  order_by?: InputMaybe<Array<Casings_Order_By>>;
}>;


export type CasingsQuery = { __typename: 'query_root', casings: Array<{ __typename: 'casings', id: any, casing_type: Casings_Type_Enum, imperial_name?: string | null, metric_name?: string | null, outer_diameter_inches?: any | null, interior_diameter_inches?: any | null, drift_inches?: any | null, coupling_outer_diameter_inches?: any | null, pound_per_foot?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null }>, casings_aggregate: { __typename: 'casings_aggregate', id: 'casings_aggregate', aggregate?: { __typename: 'casings_aggregate_fields', count: number, id: 'casings_aggregate_fields' } | null } };

export type DeleteCasingsMutationVariables = Exact<{
  where: Casings_Bool_Exp;
}>;


export type DeleteCasingsMutation = { __typename: 'mutation_root', update_casings?: { __typename: 'casings_mutation_response', returning: Array<{ __typename: 'casings', id: any }> } | null };

export type RestoreCasingsMutationVariables = Exact<{
  where: Casings_Bool_Exp;
}>;


export type RestoreCasingsMutation = { __typename: 'mutation_root', update_casings?: { __typename: 'casings_mutation_response', returning: Array<{ __typename: 'casings', id: any }> } | null };

export type InsertCasingMutationVariables = Exact<{
  object: Casings_Insert_Input;
}>;


export type InsertCasingMutation = { __typename: 'mutation_root', insert_casings_one?: { __typename: 'casings', id: any, casing_type: Casings_Type_Enum, imperial_name?: string | null, metric_name?: string | null, outer_diameter_inches?: any | null, interior_diameter_inches?: any | null, drift_inches?: any | null, coupling_outer_diameter_inches?: any | null, pound_per_foot?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null } | null };

export type UpdateCasingByPkMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  object: Casings_Set_Input;
}>;


export type UpdateCasingByPkMutation = { __typename: 'mutation_root', update_casings_by_pk?: { __typename: 'casings', id: any, casing_type: Casings_Type_Enum, imperial_name?: string | null, metric_name?: string | null, outer_diameter_inches?: any | null, interior_diameter_inches?: any | null, drift_inches?: any | null, coupling_outer_diameter_inches?: any | null, pound_per_foot?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null } | null };

export type CasingsSubSubscriptionVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Casings_Bool_Exp>;
  order_by?: InputMaybe<Array<Casings_Order_By>>;
}>;


export type CasingsSubSubscription = { __typename: 'subscription_root', casings: Array<{ __typename: 'casings', id: any, casing_type: Casings_Type_Enum, imperial_name?: string | null, metric_name?: string | null, outer_diameter_inches?: any | null, interior_diameter_inches?: any | null, drift_inches?: any | null, coupling_outer_diameter_inches?: any | null, pound_per_foot?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null }> };

export type HousingBaseFieldsFragment = { __typename: 'housings', id: any, housing_number?: number | null, stage_count?: number | null, length_inches?: any | null, weight_pounds?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null };

export type HousingsMetaFieldsFragment = { __typename: 'housings', id: any, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, pump_id?: any | null };

export type HousingsAllFieldsFragment = { __typename: 'housings', id: any, housing_number?: number | null, stage_count?: number | null, length_inches?: any | null, weight_pounds?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, pump_id?: any | null };

export type HousingsBaseQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Housings_Bool_Exp>;
  order_by?: InputMaybe<Array<Housings_Order_By>>;
}>;


export type HousingsBaseQuery = { __typename: 'query_root', housings: Array<{ __typename: 'housings', id: any, housing_number?: number | null, stage_count?: number | null, length_inches?: any | null, weight_pounds?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null }>, housings_aggregate: { __typename: 'housings_aggregate', aggregate?: { __typename: 'housings_aggregate_fields', count: number } | null } };

export type HousingsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Housings_Bool_Exp>;
  order_by?: InputMaybe<Array<Housings_Order_By>>;
}>;


export type HousingsQuery = { __typename: 'query_root', housings: Array<{ __typename: 'housings', id: any, housing_number?: number | null, stage_count?: number | null, length_inches?: any | null, weight_pounds?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, pump_id?: any | null }>, housings_aggregate: { __typename: 'housings_aggregate', id: 'housings_aggregate', aggregate?: { __typename: 'housings_aggregate_fields', count: number, id: 'housings_aggregate_fields' } | null } };

export type DeleteHousingsMutationVariables = Exact<{
  where: Housings_Bool_Exp;
}>;


export type DeleteHousingsMutation = { __typename: 'mutation_root', update_housings?: { __typename: 'housings_mutation_response', returning: Array<{ __typename: 'housings', id: any }> } | null };

export type RestoreHousingsMutationVariables = Exact<{
  where: Housings_Bool_Exp;
}>;


export type RestoreHousingsMutation = { __typename: 'mutation_root', update_housings?: { __typename: 'housings_mutation_response', returning: Array<{ __typename: 'housings', id: any }> } | null };

export type UpsertHousingsMutationVariables = Exact<{
  objects: Array<Housings_Insert_Input>;
}>;


export type UpsertHousingsMutation = { __typename: 'mutation_root', insert_housings?: { __typename: 'housings_mutation_response', returning: Array<{ __typename: 'housings', id: any, housing_number?: number | null, stage_count?: number | null, length_inches?: any | null, weight_pounds?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, pump_id?: any | null }> } | null };

export type HousingsSubSubscriptionVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Housings_Bool_Exp>;
  order_by?: InputMaybe<Array<Housings_Order_By>>;
}>;


export type HousingsSubSubscription = { __typename: 'subscription_root', housings: Array<{ __typename: 'housings', id: any, housing_number?: number | null, stage_count?: number | null, length_inches?: any | null, weight_pounds?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, pump_id?: any | null, pump?: { __typename: 'pumps', id: any, manufacturer?: string | null, series_model?: string | null } | null }> };

export type HpsBoltOnDischargesBaseFieldsFragment = { __typename: 'bolt_on_discharges', id: any, manufacturer?: string | null, series_model?: string | null, is_hps: boolean, outer_diameter_inches?: any | null, inner_diameter_inches?: any | null, flange_outer_diameter_inches?: any | null, neck_outer_diameter_inches?: any | null, neck_inner_diameter_inches?: any | null, length_inches?: any | null, weight_pounds?: any | null, tubing_diameter_inches?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null };

export type HpsBoltOnDischargesAllFieldsFragment = { __typename: 'bolt_on_discharges', id: any, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, manufacturer?: string | null, series_model?: string | null, is_hps: boolean, outer_diameter_inches?: any | null, inner_diameter_inches?: any | null, flange_outer_diameter_inches?: any | null, neck_outer_diameter_inches?: any | null, neck_inner_diameter_inches?: any | null, length_inches?: any | null, weight_pounds?: any | null, tubing_diameter_inches?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null };

export type HpsBoltOnDischargesInsertFieldsFragment = { __typename: 'bolt_on_discharges', id: any, created_at: any, updated_at: any, manufacturer?: string | null, series_model?: string | null, is_hps: boolean, outer_diameter_inches?: any | null, inner_diameter_inches?: any | null, flange_outer_diameter_inches?: any | null, neck_outer_diameter_inches?: any | null, neck_inner_diameter_inches?: any | null, length_inches?: any | null, weight_pounds?: any | null, tubing_diameter_inches?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null };

export type HpsBoltOnDischargesBaseQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Bolt_On_Discharges_Bool_Exp>;
  order_by?: InputMaybe<Array<Bolt_On_Discharges_Order_By>>;
}>;


export type HpsBoltOnDischargesBaseQuery = { __typename: 'query_root', bolt_on_discharges: Array<{ __typename: 'bolt_on_discharges', id: any, manufacturer?: string | null, series_model?: string | null, is_hps: boolean, outer_diameter_inches?: any | null, inner_diameter_inches?: any | null, flange_outer_diameter_inches?: any | null, neck_outer_diameter_inches?: any | null, neck_inner_diameter_inches?: any | null, length_inches?: any | null, weight_pounds?: any | null, tubing_diameter_inches?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null }>, bolt_on_discharges_aggregate: { __typename: 'bolt_on_discharges_aggregate', aggregate?: { __typename: 'bolt_on_discharges_aggregate_fields', count: number } | null } };

export type HpsBoltOnDischargesQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Bolt_On_Discharges_Bool_Exp>;
  order_by?: InputMaybe<Array<Bolt_On_Discharges_Order_By>>;
}>;


export type HpsBoltOnDischargesQuery = { __typename: 'query_root', bolt_on_discharges: Array<{ __typename: 'bolt_on_discharges', id: any, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, manufacturer?: string | null, series_model?: string | null, is_hps: boolean, outer_diameter_inches?: any | null, inner_diameter_inches?: any | null, flange_outer_diameter_inches?: any | null, neck_outer_diameter_inches?: any | null, neck_inner_diameter_inches?: any | null, length_inches?: any | null, weight_pounds?: any | null, tubing_diameter_inches?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null }>, bolt_on_discharges_aggregate: { __typename: 'bolt_on_discharges_aggregate', id: 'bolt_on_discharges_aggregate', aggregate?: { __typename: 'bolt_on_discharges_aggregate_fields', count: number, id: 'bolt_on_discharges_aggregate_fields' } | null } };

export type HpsBoltOnDischargesSubSubscriptionVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Bolt_On_Discharges_Bool_Exp>;
  order_by?: InputMaybe<Array<Bolt_On_Discharges_Order_By>>;
}>;


export type HpsBoltOnDischargesSubSubscription = { __typename: 'subscription_root', bolt_on_discharges: Array<{ __typename: 'bolt_on_discharges', id: any, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, manufacturer?: string | null, series_model?: string | null, is_hps: boolean, outer_diameter_inches?: any | null, inner_diameter_inches?: any | null, flange_outer_diameter_inches?: any | null, neck_outer_diameter_inches?: any | null, neck_inner_diameter_inches?: any | null, length_inches?: any | null, weight_pounds?: any | null, tubing_diameter_inches?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null }> };

export type DeleteHpsBoltOnDischargesMutationVariables = Exact<{
  where: Bolt_On_Discharges_Bool_Exp;
}>;


export type DeleteHpsBoltOnDischargesMutation = { __typename: 'mutation_root', update_bolt_on_discharges?: { __typename: 'bolt_on_discharges_mutation_response', returning: Array<{ __typename: 'bolt_on_discharges', id: any }> } | null };

export type RestoreHpsBoltOnDischargesMutationVariables = Exact<{
  where: Bolt_On_Discharges_Bool_Exp;
}>;


export type RestoreHpsBoltOnDischargesMutation = { __typename: 'mutation_root', update_bolt_on_discharges?: { __typename: 'bolt_on_discharges_mutation_response', returning: Array<{ __typename: 'bolt_on_discharges', id: any }> } | null };

export type UpdateHpsBoltOnDischargeByPkMutationVariables = Exact<{
  object?: InputMaybe<Bolt_On_Discharges_Set_Input>;
  id: Scalars['uuid']['input'];
}>;


export type UpdateHpsBoltOnDischargeByPkMutation = { __typename: 'mutation_root', update_bolt_on_discharges_by_pk?: { __typename: 'bolt_on_discharges', id: any, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, manufacturer?: string | null, series_model?: string | null, is_hps: boolean, outer_diameter_inches?: any | null, inner_diameter_inches?: any | null, flange_outer_diameter_inches?: any | null, neck_outer_diameter_inches?: any | null, neck_inner_diameter_inches?: any | null, length_inches?: any | null, weight_pounds?: any | null, tubing_diameter_inches?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null } | null };

export type InsertHpsBoltOnDischargeMutationVariables = Exact<{
  object: Bolt_On_Discharges_Insert_Input;
}>;


export type InsertHpsBoltOnDischargeMutation = { __typename: 'mutation_root', insert_bolt_on_discharges_one?: { __typename: 'bolt_on_discharges', id: any, created_at: any, updated_at: any, manufacturer?: string | null, series_model?: string | null, is_hps: boolean, outer_diameter_inches?: any | null, inner_diameter_inches?: any | null, flange_outer_diameter_inches?: any | null, neck_outer_diameter_inches?: any | null, neck_inner_diameter_inches?: any | null, length_inches?: any | null, weight_pounds?: any | null, tubing_diameter_inches?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null } | null };

export type HpsIntakesBaseQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Intakes_Bool_Exp>;
  order_by?: InputMaybe<Array<Intakes_Order_By>>;
}>;


export type HpsIntakesBaseQuery = { __typename: 'query_root', intakes: Array<{ __typename: 'intakes', id: any, manufacturer?: string | null, intake_type?: string | null, part_number?: string | null, configuration?: string | null, length_inches?: any | null, weight_pounds?: any | null, shaft_material?: string | null, shaft_limit_hp?: number | null, housing_material?: string | null, max_rate_bpd?: number | null, hp?: any | null, eff1?: any | null, eff2?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, high_strength_shaft_limit_hp?: number | null, stage_count?: number | null, bhp0?: any | null, bhp1?: any | null, bhp2?: any | null, bhp3?: any | null, bhp4?: any | null, bhp5?: any | null, bolt_on?: boolean | null, port_area_square_inches: any, inner_diameter_inches?: any | null, outer_diameter_inches?: any | null, neck_inner_diameter_inches?: any | null, neck_outer_diameter_inches?: any | null, is_hps: boolean }>, intakes_aggregate: { __typename: 'intakes_aggregate', aggregate?: { __typename: 'intakes_aggregate_fields', count: number } | null } };

export type HpsIntakesQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Intakes_Bool_Exp>;
  order_by?: InputMaybe<Array<Intakes_Order_By>>;
}>;


export type HpsIntakesQuery = { __typename: 'query_root', intakes: Array<{ __typename: 'intakes', id: any, manufacturer?: string | null, intake_type?: string | null, part_number?: string | null, configuration?: string | null, length_inches?: any | null, weight_pounds?: any | null, shaft_material?: string | null, shaft_limit_hp?: number | null, housing_material?: string | null, max_rate_bpd?: number | null, hp?: any | null, eff1?: any | null, eff2?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, high_strength_shaft_limit_hp?: number | null, stage_count?: number | null, bhp0?: any | null, bhp1?: any | null, bhp2?: any | null, bhp3?: any | null, bhp4?: any | null, bhp5?: any | null, bolt_on?: boolean | null, port_area_square_inches: any, inner_diameter_inches?: any | null, outer_diameter_inches?: any | null, neck_inner_diameter_inches?: any | null, neck_outer_diameter_inches?: any | null, is_hps: boolean, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null }>, intakes_aggregate: { __typename: 'intakes_aggregate', id: 'intakes_aggregate', aggregate?: { __typename: 'intakes_aggregate_fields', count: number, id: 'intakes_aggregate_fields' } | null } };

export type HpsIntakesSubSubscriptionVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Intakes_Bool_Exp>;
  order_by?: InputMaybe<Array<Intakes_Order_By>>;
}>;


export type HpsIntakesSubSubscription = { __typename: 'subscription_root', intakes: Array<{ __typename: 'intakes', id: any, manufacturer?: string | null, intake_type?: string | null, part_number?: string | null, configuration?: string | null, length_inches?: any | null, weight_pounds?: any | null, shaft_material?: string | null, shaft_limit_hp?: number | null, housing_material?: string | null, max_rate_bpd?: number | null, hp?: any | null, eff1?: any | null, eff2?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, high_strength_shaft_limit_hp?: number | null, stage_count?: number | null, bhp0?: any | null, bhp1?: any | null, bhp2?: any | null, bhp3?: any | null, bhp4?: any | null, bhp5?: any | null, bolt_on?: boolean | null, port_area_square_inches: any, inner_diameter_inches?: any | null, outer_diameter_inches?: any | null, neck_inner_diameter_inches?: any | null, neck_outer_diameter_inches?: any | null, is_hps: boolean, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null }> };

export type DeleteHpsIntakesMutationVariables = Exact<{
  where: Intakes_Bool_Exp;
}>;


export type DeleteHpsIntakesMutation = { __typename: 'mutation_root', update_intakes?: { __typename: 'intakes_mutation_response', returning: Array<{ __typename: 'intakes', id: any }> } | null };

export type RestoreHpsIntakesMutationVariables = Exact<{
  where: Intakes_Bool_Exp;
}>;


export type RestoreHpsIntakesMutation = { __typename: 'mutation_root', update_intakes?: { __typename: 'intakes_mutation_response', returning: Array<{ __typename: 'intakes', id: any }> } | null };

export type InsertHpsIntakeMutationVariables = Exact<{
  object: Intakes_Insert_Input;
}>;


export type InsertHpsIntakeMutation = { __typename: 'mutation_root', insert_intakes_one?: { __typename: 'intakes', id: any, manufacturer?: string | null, intake_type?: string | null, part_number?: string | null, configuration?: string | null, length_inches?: any | null, weight_pounds?: any | null, shaft_material?: string | null, shaft_limit_hp?: number | null, housing_material?: string | null, max_rate_bpd?: number | null, hp?: any | null, eff1?: any | null, eff2?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, high_strength_shaft_limit_hp?: number | null, stage_count?: number | null, bhp0?: any | null, bhp1?: any | null, bhp2?: any | null, bhp3?: any | null, bhp4?: any | null, bhp5?: any | null, bolt_on?: boolean | null, port_area_square_inches: any, inner_diameter_inches?: any | null, outer_diameter_inches?: any | null, neck_inner_diameter_inches?: any | null, neck_outer_diameter_inches?: any | null, is_hps: boolean, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null } | null };

export type UpdateHpsIntakeByPkMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  object: Intakes_Set_Input;
}>;


export type UpdateHpsIntakeByPkMutation = { __typename: 'mutation_root', update_intakes_by_pk?: { __typename: 'intakes', id: any, manufacturer?: string | null, intake_type?: string | null, part_number?: string | null, configuration?: string | null, length_inches?: any | null, weight_pounds?: any | null, shaft_material?: string | null, shaft_limit_hp?: number | null, housing_material?: string | null, max_rate_bpd?: number | null, hp?: any | null, eff1?: any | null, eff2?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, high_strength_shaft_limit_hp?: number | null, stage_count?: number | null, bhp0?: any | null, bhp1?: any | null, bhp2?: any | null, bhp3?: any | null, bhp4?: any | null, bhp5?: any | null, bolt_on?: boolean | null, port_area_square_inches: any, inner_diameter_inches?: any | null, outer_diameter_inches?: any | null, neck_inner_diameter_inches?: any | null, neck_outer_diameter_inches?: any | null, is_hps: boolean, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null } | null };

export type HpsMotorsBaseFieldsFragment = { __typename: 'motors', id: any, length_inches?: any | null, manufacturer?: string | null, nameplate_current?: number | null, nameplate_horsepower?: number | null, nameplate_voltage?: number | null, part_number?: string | null, shaft_horsepower?: number | null, weight_pounds?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, allow_rerate: boolean, inner_diameter_inches?: any | null, outer_diameter_inches?: any | null, neck_inner_diameter_inches?: any | null, neck_outer_diameter_inches?: any | null, is_hps: boolean };

export type HpsMotorsAllFieldsFragment = { __typename: 'motors', id: any, author_id: string, allow_rerate: boolean, configuration?: string | null, created_at: any, deleted_at?: any | null, eff1?: any | null, eff2?: any | null, eff3?: any | null, eff4?: any | null, eff5?: any | null, effb?: any | null, i1?: any | null, i2?: any | null, i3?: any | null, i4?: any | null, i5?: any | null, ib?: any | null, imported_sizing_id?: number | null, length_inches?: any | null, manufacturer?: string | null, n1?: any | null, n2?: any | null, n3?: any | null, n4?: any | null, n5?: any | null, nameplate_current?: number | null, nameplate_horsepower?: number | null, nameplate_voltage?: number | null, nb?: any | null, oil_volume_gallons?: any | null, part_number?: string | null, pf1?: any | null, pf2?: any | null, pf3?: any | null, pf4?: any | null, pf5?: any | null, pfb?: any | null, rr_l1?: any | null, rr_l2?: any | null, rr_lb?: any | null, rr_v3: any, rr_v2: any, rr_v1?: any | null, rr_vb?: any | null, shaft_horsepower?: number | null, nv0: any, nv1: any, nv2: any, iv0: any, iv1: any, iv2: any, pfv0: any, pfv1: any, pfv2: any, effv0: any, effv1: any, effv2: any, tv0: any, tv1: any, tv2: any, shaft_height_inches?: any | null, temperature_rating_fahrenheit?: number | null, updated_at: any, weight_pounds?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, poles?: number | null, stator_inner_diameter_inches?: any | null, stator_outer_diameter_inches?: any | null, k3?: any | null, nameplate_rerate_ratio?: any | null, inner_diameter_inches?: any | null, outer_diameter_inches?: any | null, neck_inner_diameter_inches?: any | null, neck_outer_diameter_inches?: any | null, mle_offset_depth_inches: any, outer_diameter_rub_inches: any, is_hps: boolean };

export type HpsMotorsInsertFieldsFragment = { __typename: 'motors', id: any, allow_rerate: boolean, created_at: any, updated_at: any, manufacturer?: string | null, part_number?: string | null, outer_diameter_inches?: any | null, length_inches?: any | null, weight_pounds?: any | null, nameplate_horsepower?: number | null, nameplate_voltage?: number | null, nameplate_current?: number | null, shaft_horsepower?: number | null, temperature_rating_fahrenheit?: number | null, eff1?: any | null, eff2?: any | null, eff3?: any | null, eff4?: any | null, eff5?: any | null, effb?: any | null, i1?: any | null, i2?: any | null, i3?: any | null, i4?: any | null, i5?: any | null, ib?: any | null, n1?: any | null, n2?: any | null, n3?: any | null, n4?: any | null, n5?: any | null, nb?: any | null, pf1?: any | null, pf2?: any | null, pf3?: any | null, pf4?: any | null, pf5?: any | null, pfb?: any | null, rr_l1?: any | null, rr_l2?: any | null, rr_lb?: any | null, rr_v3: any, rr_v2: any, rr_v1?: any | null, rr_vb?: any | null, shaft_height_inches?: any | null, nv0: any, nv1: any, nv2: any, iv0: any, iv1: any, iv2: any, pfv0: any, pfv1: any, pfv2: any, effv0: any, effv1: any, effv2: any, tv0: any, tv1: any, tv2: any, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, poles?: number | null, stator_inner_diameter_inches?: any | null, stator_outer_diameter_inches?: any | null, k3?: any | null, nameplate_rerate_ratio?: any | null, inner_diameter_inches?: any | null, neck_inner_diameter_inches?: any | null, neck_outer_diameter_inches?: any | null, mle_offset_depth_inches: any, outer_diameter_rub_inches: any, is_hps: boolean };

export type HpsMotorsBaseQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Motors_Bool_Exp>;
  order_by?: InputMaybe<Array<Motors_Order_By>>;
}>;


export type HpsMotorsBaseQuery = { __typename: 'query_root', motors: Array<{ __typename: 'motors', id: any, length_inches?: any | null, manufacturer?: string | null, nameplate_current?: number | null, nameplate_horsepower?: number | null, nameplate_voltage?: number | null, part_number?: string | null, shaft_horsepower?: number | null, weight_pounds?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, allow_rerate: boolean, inner_diameter_inches?: any | null, outer_diameter_inches?: any | null, neck_inner_diameter_inches?: any | null, neck_outer_diameter_inches?: any | null, is_hps: boolean }>, motors_aggregate: { __typename: 'motors_aggregate', aggregate?: { __typename: 'motors_aggregate_fields', count: number } | null } };

export type HpsMotorsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Motors_Bool_Exp>;
  order_by?: InputMaybe<Array<Motors_Order_By>>;
}>;


export type HpsMotorsQuery = { __typename: 'query_root', motors: Array<{ __typename: 'motors', id: any, author_id: string, allow_rerate: boolean, configuration?: string | null, created_at: any, deleted_at?: any | null, eff1?: any | null, eff2?: any | null, eff3?: any | null, eff4?: any | null, eff5?: any | null, effb?: any | null, i1?: any | null, i2?: any | null, i3?: any | null, i4?: any | null, i5?: any | null, ib?: any | null, imported_sizing_id?: number | null, length_inches?: any | null, manufacturer?: string | null, n1?: any | null, n2?: any | null, n3?: any | null, n4?: any | null, n5?: any | null, nameplate_current?: number | null, nameplate_horsepower?: number | null, nameplate_voltage?: number | null, nb?: any | null, oil_volume_gallons?: any | null, part_number?: string | null, pf1?: any | null, pf2?: any | null, pf3?: any | null, pf4?: any | null, pf5?: any | null, pfb?: any | null, rr_l1?: any | null, rr_l2?: any | null, rr_lb?: any | null, rr_v3: any, rr_v2: any, rr_v1?: any | null, rr_vb?: any | null, shaft_horsepower?: number | null, nv0: any, nv1: any, nv2: any, iv0: any, iv1: any, iv2: any, pfv0: any, pfv1: any, pfv2: any, effv0: any, effv1: any, effv2: any, tv0: any, tv1: any, tv2: any, shaft_height_inches?: any | null, temperature_rating_fahrenheit?: number | null, updated_at: any, weight_pounds?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, poles?: number | null, stator_inner_diameter_inches?: any | null, stator_outer_diameter_inches?: any | null, k3?: any | null, nameplate_rerate_ratio?: any | null, inner_diameter_inches?: any | null, outer_diameter_inches?: any | null, neck_inner_diameter_inches?: any | null, neck_outer_diameter_inches?: any | null, mle_offset_depth_inches: any, outer_diameter_rub_inches: any, is_hps: boolean }>, motors_aggregate: { __typename: 'motors_aggregate', id: 'motors_aggregate', aggregate?: { __typename: 'motors_aggregate_fields', count: number, id: 'motors_aggregate_fields' } | null } };

export type HpsMotorsSubSubscriptionVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Motors_Bool_Exp>;
  order_by?: InputMaybe<Array<Motors_Order_By>>;
}>;


export type HpsMotorsSubSubscription = { __typename: 'subscription_root', motors: Array<{ __typename: 'motors', id: any, author_id: string, allow_rerate: boolean, configuration?: string | null, created_at: any, deleted_at?: any | null, eff1?: any | null, eff2?: any | null, eff3?: any | null, eff4?: any | null, eff5?: any | null, effb?: any | null, i1?: any | null, i2?: any | null, i3?: any | null, i4?: any | null, i5?: any | null, ib?: any | null, imported_sizing_id?: number | null, length_inches?: any | null, manufacturer?: string | null, n1?: any | null, n2?: any | null, n3?: any | null, n4?: any | null, n5?: any | null, nameplate_current?: number | null, nameplate_horsepower?: number | null, nameplate_voltage?: number | null, nb?: any | null, oil_volume_gallons?: any | null, part_number?: string | null, pf1?: any | null, pf2?: any | null, pf3?: any | null, pf4?: any | null, pf5?: any | null, pfb?: any | null, rr_l1?: any | null, rr_l2?: any | null, rr_lb?: any | null, rr_v3: any, rr_v2: any, rr_v1?: any | null, rr_vb?: any | null, shaft_horsepower?: number | null, nv0: any, nv1: any, nv2: any, iv0: any, iv1: any, iv2: any, pfv0: any, pfv1: any, pfv2: any, effv0: any, effv1: any, effv2: any, tv0: any, tv1: any, tv2: any, shaft_height_inches?: any | null, temperature_rating_fahrenheit?: number | null, updated_at: any, weight_pounds?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, poles?: number | null, stator_inner_diameter_inches?: any | null, stator_outer_diameter_inches?: any | null, k3?: any | null, nameplate_rerate_ratio?: any | null, inner_diameter_inches?: any | null, outer_diameter_inches?: any | null, neck_inner_diameter_inches?: any | null, neck_outer_diameter_inches?: any | null, mle_offset_depth_inches: any, outer_diameter_rub_inches: any, is_hps: boolean }> };

export type DeleteHpsMotorsMutationVariables = Exact<{
  where: Motors_Bool_Exp;
}>;


export type DeleteHpsMotorsMutation = { __typename: 'mutation_root', update_motors?: { __typename: 'motors_mutation_response', returning: Array<{ __typename: 'motors', id: any }> } | null };

export type RestoreHpsMotorsMutationVariables = Exact<{
  where: Motors_Bool_Exp;
}>;


export type RestoreHpsMotorsMutation = { __typename: 'mutation_root', update_motors?: { __typename: 'motors_mutation_response', returning: Array<{ __typename: 'motors', id: any }> } | null };

export type UpdateHpsMotorByPkMutationVariables = Exact<{
  object?: InputMaybe<Motors_Set_Input>;
  id: Scalars['uuid']['input'];
}>;


export type UpdateHpsMotorByPkMutation = { __typename: 'mutation_root', update_motors_by_pk?: { __typename: 'motors', id: any, author_id: string, allow_rerate: boolean, configuration?: string | null, created_at: any, deleted_at?: any | null, eff1?: any | null, eff2?: any | null, eff3?: any | null, eff4?: any | null, eff5?: any | null, effb?: any | null, i1?: any | null, i2?: any | null, i3?: any | null, i4?: any | null, i5?: any | null, ib?: any | null, imported_sizing_id?: number | null, length_inches?: any | null, manufacturer?: string | null, n1?: any | null, n2?: any | null, n3?: any | null, n4?: any | null, n5?: any | null, nameplate_current?: number | null, nameplate_horsepower?: number | null, nameplate_voltage?: number | null, nb?: any | null, oil_volume_gallons?: any | null, part_number?: string | null, pf1?: any | null, pf2?: any | null, pf3?: any | null, pf4?: any | null, pf5?: any | null, pfb?: any | null, rr_l1?: any | null, rr_l2?: any | null, rr_lb?: any | null, rr_v3: any, rr_v2: any, rr_v1?: any | null, rr_vb?: any | null, shaft_horsepower?: number | null, nv0: any, nv1: any, nv2: any, iv0: any, iv1: any, iv2: any, pfv0: any, pfv1: any, pfv2: any, effv0: any, effv1: any, effv2: any, tv0: any, tv1: any, tv2: any, shaft_height_inches?: any | null, temperature_rating_fahrenheit?: number | null, updated_at: any, weight_pounds?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, poles?: number | null, stator_inner_diameter_inches?: any | null, stator_outer_diameter_inches?: any | null, k3?: any | null, nameplate_rerate_ratio?: any | null, inner_diameter_inches?: any | null, outer_diameter_inches?: any | null, neck_inner_diameter_inches?: any | null, neck_outer_diameter_inches?: any | null, mle_offset_depth_inches: any, outer_diameter_rub_inches: any, is_hps: boolean } | null };

export type InsertHpsMotorMutationVariables = Exact<{
  object: Motors_Insert_Input;
}>;


export type InsertHpsMotorMutation = { __typename: 'mutation_root', insert_motors_one?: { __typename: 'motors', id: any, allow_rerate: boolean, created_at: any, updated_at: any, manufacturer?: string | null, part_number?: string | null, outer_diameter_inches?: any | null, length_inches?: any | null, weight_pounds?: any | null, nameplate_horsepower?: number | null, nameplate_voltage?: number | null, nameplate_current?: number | null, shaft_horsepower?: number | null, temperature_rating_fahrenheit?: number | null, eff1?: any | null, eff2?: any | null, eff3?: any | null, eff4?: any | null, eff5?: any | null, effb?: any | null, i1?: any | null, i2?: any | null, i3?: any | null, i4?: any | null, i5?: any | null, ib?: any | null, n1?: any | null, n2?: any | null, n3?: any | null, n4?: any | null, n5?: any | null, nb?: any | null, pf1?: any | null, pf2?: any | null, pf3?: any | null, pf4?: any | null, pf5?: any | null, pfb?: any | null, rr_l1?: any | null, rr_l2?: any | null, rr_lb?: any | null, rr_v3: any, rr_v2: any, rr_v1?: any | null, rr_vb?: any | null, shaft_height_inches?: any | null, nv0: any, nv1: any, nv2: any, iv0: any, iv1: any, iv2: any, pfv0: any, pfv1: any, pfv2: any, effv0: any, effv1: any, effv2: any, tv0: any, tv1: any, tv2: any, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, poles?: number | null, stator_inner_diameter_inches?: any | null, stator_outer_diameter_inches?: any | null, k3?: any | null, nameplate_rerate_ratio?: any | null, inner_diameter_inches?: any | null, neck_inner_diameter_inches?: any | null, neck_outer_diameter_inches?: any | null, mle_offset_depth_inches: any, outer_diameter_rub_inches: any, is_hps: boolean } | null };

export type IntakesBaseFieldsFragment = { __typename: 'intakes', id: any, manufacturer?: string | null, intake_type?: string | null, part_number?: string | null, configuration?: string | null, length_inches?: any | null, weight_pounds?: any | null, shaft_material?: string | null, shaft_limit_hp?: number | null, housing_material?: string | null, max_rate_bpd?: number | null, hp?: any | null, eff1?: any | null, eff2?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, high_strength_shaft_limit_hp?: number | null, stage_count?: number | null, bhp0?: any | null, bhp1?: any | null, bhp2?: any | null, bhp3?: any | null, bhp4?: any | null, bhp5?: any | null, bolt_on?: boolean | null, port_area_square_inches: any, inner_diameter_inches?: any | null, outer_diameter_inches?: any | null, neck_inner_diameter_inches?: any | null, neck_outer_diameter_inches?: any | null, is_hps: boolean };

export type IntakesMetaFieldsFragment = { __typename: 'intakes', id: any, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null };

export type IntakesAllFieldsFragment = { __typename: 'intakes', id: any, manufacturer?: string | null, intake_type?: string | null, part_number?: string | null, configuration?: string | null, length_inches?: any | null, weight_pounds?: any | null, shaft_material?: string | null, shaft_limit_hp?: number | null, housing_material?: string | null, max_rate_bpd?: number | null, hp?: any | null, eff1?: any | null, eff2?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, high_strength_shaft_limit_hp?: number | null, stage_count?: number | null, bhp0?: any | null, bhp1?: any | null, bhp2?: any | null, bhp3?: any | null, bhp4?: any | null, bhp5?: any | null, bolt_on?: boolean | null, port_area_square_inches: any, inner_diameter_inches?: any | null, outer_diameter_inches?: any | null, neck_inner_diameter_inches?: any | null, neck_outer_diameter_inches?: any | null, is_hps: boolean, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null };

export type IntakesBaseQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Intakes_Bool_Exp>;
  order_by?: InputMaybe<Array<Intakes_Order_By>>;
}>;


export type IntakesBaseQuery = { __typename: 'query_root', intakes: Array<{ __typename: 'intakes', id: any, manufacturer?: string | null, intake_type?: string | null, part_number?: string | null, configuration?: string | null, length_inches?: any | null, weight_pounds?: any | null, shaft_material?: string | null, shaft_limit_hp?: number | null, housing_material?: string | null, max_rate_bpd?: number | null, hp?: any | null, eff1?: any | null, eff2?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, high_strength_shaft_limit_hp?: number | null, stage_count?: number | null, bhp0?: any | null, bhp1?: any | null, bhp2?: any | null, bhp3?: any | null, bhp4?: any | null, bhp5?: any | null, bolt_on?: boolean | null, port_area_square_inches: any, inner_diameter_inches?: any | null, outer_diameter_inches?: any | null, neck_inner_diameter_inches?: any | null, neck_outer_diameter_inches?: any | null, is_hps: boolean }>, intakes_aggregate: { __typename: 'intakes_aggregate', aggregate?: { __typename: 'intakes_aggregate_fields', count: number } | null } };

export type IntakesQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Intakes_Bool_Exp>;
  order_by?: InputMaybe<Array<Intakes_Order_By>>;
}>;


export type IntakesQuery = { __typename: 'query_root', intakes: Array<{ __typename: 'intakes', id: any, manufacturer?: string | null, intake_type?: string | null, part_number?: string | null, configuration?: string | null, length_inches?: any | null, weight_pounds?: any | null, shaft_material?: string | null, shaft_limit_hp?: number | null, housing_material?: string | null, max_rate_bpd?: number | null, hp?: any | null, eff1?: any | null, eff2?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, high_strength_shaft_limit_hp?: number | null, stage_count?: number | null, bhp0?: any | null, bhp1?: any | null, bhp2?: any | null, bhp3?: any | null, bhp4?: any | null, bhp5?: any | null, bolt_on?: boolean | null, port_area_square_inches: any, inner_diameter_inches?: any | null, outer_diameter_inches?: any | null, neck_inner_diameter_inches?: any | null, neck_outer_diameter_inches?: any | null, is_hps: boolean, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null }>, intakes_aggregate: { __typename: 'intakes_aggregate', id: 'intakes_aggregate', aggregate?: { __typename: 'intakes_aggregate_fields', count: number, id: 'intakes_aggregate_fields' } | null } };

export type IntakesSubSubscriptionVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Intakes_Bool_Exp>;
  order_by?: InputMaybe<Array<Intakes_Order_By>>;
}>;


export type IntakesSubSubscription = { __typename: 'subscription_root', intakes: Array<{ __typename: 'intakes', id: any, manufacturer?: string | null, intake_type?: string | null, part_number?: string | null, configuration?: string | null, length_inches?: any | null, weight_pounds?: any | null, shaft_material?: string | null, shaft_limit_hp?: number | null, housing_material?: string | null, max_rate_bpd?: number | null, hp?: any | null, eff1?: any | null, eff2?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, high_strength_shaft_limit_hp?: number | null, stage_count?: number | null, bhp0?: any | null, bhp1?: any | null, bhp2?: any | null, bhp3?: any | null, bhp4?: any | null, bhp5?: any | null, bolt_on?: boolean | null, port_area_square_inches: any, inner_diameter_inches?: any | null, outer_diameter_inches?: any | null, neck_inner_diameter_inches?: any | null, neck_outer_diameter_inches?: any | null, is_hps: boolean, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null }> };

export type DeleteIntakesMutationVariables = Exact<{
  where: Intakes_Bool_Exp;
}>;


export type DeleteIntakesMutation = { __typename: 'mutation_root', update_intakes?: { __typename: 'intakes_mutation_response', returning: Array<{ __typename: 'intakes', id: any }> } | null };

export type RestoreIntakesMutationVariables = Exact<{
  where: Intakes_Bool_Exp;
}>;


export type RestoreIntakesMutation = { __typename: 'mutation_root', update_intakes?: { __typename: 'intakes_mutation_response', returning: Array<{ __typename: 'intakes', id: any }> } | null };

export type InsertIntakeMutationVariables = Exact<{
  object: Intakes_Insert_Input;
}>;


export type InsertIntakeMutation = { __typename: 'mutation_root', insert_intakes_one?: { __typename: 'intakes', id: any, manufacturer?: string | null, intake_type?: string | null, part_number?: string | null, configuration?: string | null, length_inches?: any | null, weight_pounds?: any | null, shaft_material?: string | null, shaft_limit_hp?: number | null, housing_material?: string | null, max_rate_bpd?: number | null, hp?: any | null, eff1?: any | null, eff2?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, high_strength_shaft_limit_hp?: number | null, stage_count?: number | null, bhp0?: any | null, bhp1?: any | null, bhp2?: any | null, bhp3?: any | null, bhp4?: any | null, bhp5?: any | null, bolt_on?: boolean | null, port_area_square_inches: any, inner_diameter_inches?: any | null, outer_diameter_inches?: any | null, neck_inner_diameter_inches?: any | null, neck_outer_diameter_inches?: any | null, is_hps: boolean, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null } | null };

export type UpdateIntakeByPkMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  object: Intakes_Set_Input;
}>;


export type UpdateIntakeByPkMutation = { __typename: 'mutation_root', update_intakes_by_pk?: { __typename: 'intakes', id: any, manufacturer?: string | null, intake_type?: string | null, part_number?: string | null, configuration?: string | null, length_inches?: any | null, weight_pounds?: any | null, shaft_material?: string | null, shaft_limit_hp?: number | null, housing_material?: string | null, max_rate_bpd?: number | null, hp?: any | null, eff1?: any | null, eff2?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, high_strength_shaft_limit_hp?: number | null, stage_count?: number | null, bhp0?: any | null, bhp1?: any | null, bhp2?: any | null, bhp3?: any | null, bhp4?: any | null, bhp5?: any | null, bolt_on?: boolean | null, port_area_square_inches: any, inner_diameter_inches?: any | null, outer_diameter_inches?: any | null, neck_inner_diameter_inches?: any | null, neck_outer_diameter_inches?: any | null, is_hps: boolean, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null } | null };

export type MleBaseFieldsFragment = { __typename: 'motor_lead_extensions', id: any, manufacturer?: string | null, part_number?: string | null, series?: number | null, family?: string | null, gauge?: number | null, kv?: number | null, max_pothead_temperature_fahrenheit?: number | null, max_temperature_fahrenheit?: number | null, resistance_per_1000_ft?: any | null, impedance_60_hz_per_1000_ft?: any | null, amp_factor?: any | null, width_inches?: any | null, depth_inches?: any | null, pound_per_foot?: any | null, length_feet?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null };

export type MleMetaFieldsFragment = { __typename: 'motor_lead_extensions', id: any, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null };

export type MleAllFieldsFragment = { __typename: 'motor_lead_extensions', id: any, manufacturer?: string | null, part_number?: string | null, series?: number | null, family?: string | null, gauge?: number | null, kv?: number | null, max_pothead_temperature_fahrenheit?: number | null, max_temperature_fahrenheit?: number | null, resistance_per_1000_ft?: any | null, impedance_60_hz_per_1000_ft?: any | null, amp_factor?: any | null, width_inches?: any | null, depth_inches?: any | null, pound_per_foot?: any | null, length_feet?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null };

export type MotorLeadExtensionsBaseQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Motor_Lead_Extensions_Bool_Exp>;
  order_by?: InputMaybe<Array<Motor_Lead_Extensions_Order_By>>;
}>;


export type MotorLeadExtensionsBaseQuery = { __typename: 'query_root', motor_lead_extensions: Array<{ __typename: 'motor_lead_extensions', id: any, manufacturer?: string | null, part_number?: string | null, series?: number | null, family?: string | null, gauge?: number | null, kv?: number | null, max_pothead_temperature_fahrenheit?: number | null, max_temperature_fahrenheit?: number | null, resistance_per_1000_ft?: any | null, impedance_60_hz_per_1000_ft?: any | null, amp_factor?: any | null, width_inches?: any | null, depth_inches?: any | null, pound_per_foot?: any | null, length_feet?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null }>, motor_lead_extensions_aggregate: { __typename: 'motor_lead_extensions_aggregate', aggregate?: { __typename: 'motor_lead_extensions_aggregate_fields', count: number } | null } };

export type MotorLeadExtensionsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Motor_Lead_Extensions_Bool_Exp>;
  order_by?: InputMaybe<Array<Motor_Lead_Extensions_Order_By>>;
}>;


export type MotorLeadExtensionsQuery = { __typename: 'query_root', motor_lead_extensions: Array<{ __typename: 'motor_lead_extensions', id: any, manufacturer?: string | null, part_number?: string | null, series?: number | null, family?: string | null, gauge?: number | null, kv?: number | null, max_pothead_temperature_fahrenheit?: number | null, max_temperature_fahrenheit?: number | null, resistance_per_1000_ft?: any | null, impedance_60_hz_per_1000_ft?: any | null, amp_factor?: any | null, width_inches?: any | null, depth_inches?: any | null, pound_per_foot?: any | null, length_feet?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null }>, motor_lead_extensions_aggregate: { __typename: 'motor_lead_extensions_aggregate', id: 'motor_lead_extensions_aggregate', aggregate?: { __typename: 'motor_lead_extensions_aggregate_fields', count: number, id: 'motor_lead_extensions_aggregate_fields' } | null } };

export type DeleteMlesMutationVariables = Exact<{
  where: Motor_Lead_Extensions_Bool_Exp;
}>;


export type DeleteMlesMutation = { __typename: 'mutation_root', update_motor_lead_extensions?: { __typename: 'motor_lead_extensions_mutation_response', returning: Array<{ __typename: 'motor_lead_extensions', id: any }> } | null };

export type RestoreMlesMutationVariables = Exact<{
  where: Motor_Lead_Extensions_Bool_Exp;
}>;


export type RestoreMlesMutation = { __typename: 'mutation_root', update_motor_lead_extensions?: { __typename: 'motor_lead_extensions_mutation_response', returning: Array<{ __typename: 'motor_lead_extensions', id: any }> } | null };

export type InsertMleMutationVariables = Exact<{
  object: Motor_Lead_Extensions_Insert_Input;
}>;


export type InsertMleMutation = { __typename: 'mutation_root', insert_motor_lead_extensions_one?: { __typename: 'motor_lead_extensions', id: any, manufacturer?: string | null, part_number?: string | null, series?: number | null, family?: string | null, gauge?: number | null, kv?: number | null, max_pothead_temperature_fahrenheit?: number | null, max_temperature_fahrenheit?: number | null, resistance_per_1000_ft?: any | null, impedance_60_hz_per_1000_ft?: any | null, amp_factor?: any | null, width_inches?: any | null, depth_inches?: any | null, pound_per_foot?: any | null, length_feet?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null } | null };

export type UpdateMleByPkMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  object: Motor_Lead_Extensions_Set_Input;
}>;


export type UpdateMleByPkMutation = { __typename: 'mutation_root', update_motor_lead_extensions_by_pk?: { __typename: 'motor_lead_extensions', id: any, manufacturer?: string | null, part_number?: string | null, series?: number | null, family?: string | null, gauge?: number | null, kv?: number | null, max_pothead_temperature_fahrenheit?: number | null, max_temperature_fahrenheit?: number | null, resistance_per_1000_ft?: any | null, impedance_60_hz_per_1000_ft?: any | null, amp_factor?: any | null, width_inches?: any | null, depth_inches?: any | null, pound_per_foot?: any | null, length_feet?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null } | null };

export type MotorLeadExtensionsSubSubscriptionVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Motor_Lead_Extensions_Bool_Exp>;
  order_by?: InputMaybe<Array<Motor_Lead_Extensions_Order_By>>;
}>;


export type MotorLeadExtensionsSubSubscription = { __typename: 'subscription_root', motor_lead_extensions: Array<{ __typename: 'motor_lead_extensions', id: any, manufacturer?: string | null, part_number?: string | null, series?: number | null, family?: string | null, gauge?: number | null, kv?: number | null, max_pothead_temperature_fahrenheit?: number | null, max_temperature_fahrenheit?: number | null, resistance_per_1000_ft?: any | null, impedance_60_hz_per_1000_ft?: any | null, amp_factor?: any | null, width_inches?: any | null, depth_inches?: any | null, pound_per_foot?: any | null, length_feet?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null }> };

export type MotorsBaseFieldsFragment = { __typename: 'motors', id: any, length_inches?: any | null, manufacturer?: string | null, nameplate_current?: number | null, nameplate_horsepower?: number | null, nameplate_voltage?: number | null, part_number?: string | null, shaft_horsepower?: number | null, weight_pounds?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, allow_rerate: boolean, inner_diameter_inches?: any | null, outer_diameter_inches?: any | null, neck_inner_diameter_inches?: any | null, neck_outer_diameter_inches?: any | null, is_hps: boolean };

export type MotorsAllFieldsFragment = { __typename: 'motors', id: any, author_id: string, allow_rerate: boolean, configuration?: string | null, created_at: any, deleted_at?: any | null, eff1?: any | null, eff2?: any | null, eff3?: any | null, eff4?: any | null, eff5?: any | null, effb?: any | null, i1?: any | null, i2?: any | null, i3?: any | null, i4?: any | null, i5?: any | null, ib?: any | null, imported_sizing_id?: number | null, length_inches?: any | null, manufacturer?: string | null, n1?: any | null, n2?: any | null, n3?: any | null, n4?: any | null, n5?: any | null, nameplate_current?: number | null, nameplate_horsepower?: number | null, nameplate_voltage?: number | null, nb?: any | null, oil_volume_gallons?: any | null, part_number?: string | null, pf1?: any | null, pf2?: any | null, pf3?: any | null, pf4?: any | null, pf5?: any | null, pfb?: any | null, rr_l1?: any | null, rr_l2?: any | null, rr_lb?: any | null, rr_v3: any, rr_v2: any, rr_v1?: any | null, rr_vb?: any | null, shaft_horsepower?: number | null, nv0: any, nv1: any, nv2: any, iv0: any, iv1: any, iv2: any, pfv0: any, pfv1: any, pfv2: any, effv0: any, effv1: any, effv2: any, tv0: any, tv1: any, tv2: any, temperature_rating_fahrenheit?: number | null, updated_at: any, weight_pounds?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, poles?: number | null, stator_inner_diameter_inches?: any | null, stator_outer_diameter_inches?: any | null, k3?: any | null, nameplate_rerate_ratio?: any | null, inner_diameter_inches?: any | null, outer_diameter_inches?: any | null, neck_inner_diameter_inches?: any | null, neck_outer_diameter_inches?: any | null, mle_offset_depth_inches: any, outer_diameter_rub_inches: any, is_hps: boolean };

export type MotorsInsertFieldsFragment = { __typename: 'motors', id: any, allow_rerate: boolean, created_at: any, updated_at: any, manufacturer?: string | null, part_number?: string | null, outer_diameter_inches?: any | null, length_inches?: any | null, weight_pounds?: any | null, nameplate_horsepower?: number | null, nameplate_voltage?: number | null, nameplate_current?: number | null, shaft_horsepower?: number | null, temperature_rating_fahrenheit?: number | null, eff1?: any | null, eff2?: any | null, eff3?: any | null, eff4?: any | null, eff5?: any | null, effb?: any | null, i1?: any | null, i2?: any | null, i3?: any | null, i4?: any | null, i5?: any | null, ib?: any | null, n1?: any | null, n2?: any | null, n3?: any | null, n4?: any | null, n5?: any | null, nb?: any | null, pf1?: any | null, pf2?: any | null, pf3?: any | null, pf4?: any | null, pf5?: any | null, pfb?: any | null, rr_l1?: any | null, rr_l2?: any | null, rr_lb?: any | null, rr_v3: any, rr_v2: any, rr_v1?: any | null, rr_vb?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, poles?: number | null, stator_inner_diameter_inches?: any | null, stator_outer_diameter_inches?: any | null, k3?: any | null, nameplate_rerate_ratio?: any | null, inner_diameter_inches?: any | null, neck_inner_diameter_inches?: any | null, neck_outer_diameter_inches?: any | null, mle_offset_depth_inches: any, outer_diameter_rub_inches: any, is_hps: boolean, nv0: any, nv1: any, nv2: any, iv0: any, iv1: any, iv2: any, pfv0: any, pfv1: any, pfv2: any, effv0: any, effv1: any, effv2: any, tv0: any, tv1: any, tv2: any };

export type MotorsBaseQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Motors_Bool_Exp>;
  order_by?: InputMaybe<Array<Motors_Order_By>>;
}>;


export type MotorsBaseQuery = { __typename: 'query_root', motors: Array<{ __typename: 'motors', id: any, length_inches?: any | null, manufacturer?: string | null, nameplate_current?: number | null, nameplate_horsepower?: number | null, nameplate_voltage?: number | null, part_number?: string | null, shaft_horsepower?: number | null, weight_pounds?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, allow_rerate: boolean, inner_diameter_inches?: any | null, outer_diameter_inches?: any | null, neck_inner_diameter_inches?: any | null, neck_outer_diameter_inches?: any | null, is_hps: boolean }>, motors_aggregate: { __typename: 'motors_aggregate', aggregate?: { __typename: 'motors_aggregate_fields', count: number } | null } };

export type MotorsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Motors_Bool_Exp>;
  order_by?: InputMaybe<Array<Motors_Order_By>>;
}>;


export type MotorsQuery = { __typename: 'query_root', motors: Array<{ __typename: 'motors', id: any, author_id: string, allow_rerate: boolean, configuration?: string | null, created_at: any, deleted_at?: any | null, eff1?: any | null, eff2?: any | null, eff3?: any | null, eff4?: any | null, eff5?: any | null, effb?: any | null, i1?: any | null, i2?: any | null, i3?: any | null, i4?: any | null, i5?: any | null, ib?: any | null, imported_sizing_id?: number | null, length_inches?: any | null, manufacturer?: string | null, n1?: any | null, n2?: any | null, n3?: any | null, n4?: any | null, n5?: any | null, nameplate_current?: number | null, nameplate_horsepower?: number | null, nameplate_voltage?: number | null, nb?: any | null, oil_volume_gallons?: any | null, part_number?: string | null, pf1?: any | null, pf2?: any | null, pf3?: any | null, pf4?: any | null, pf5?: any | null, pfb?: any | null, rr_l1?: any | null, rr_l2?: any | null, rr_lb?: any | null, rr_v3: any, rr_v2: any, rr_v1?: any | null, rr_vb?: any | null, shaft_horsepower?: number | null, nv0: any, nv1: any, nv2: any, iv0: any, iv1: any, iv2: any, pfv0: any, pfv1: any, pfv2: any, effv0: any, effv1: any, effv2: any, tv0: any, tv1: any, tv2: any, temperature_rating_fahrenheit?: number | null, updated_at: any, weight_pounds?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, poles?: number | null, stator_inner_diameter_inches?: any | null, stator_outer_diameter_inches?: any | null, k3?: any | null, nameplate_rerate_ratio?: any | null, inner_diameter_inches?: any | null, outer_diameter_inches?: any | null, neck_inner_diameter_inches?: any | null, neck_outer_diameter_inches?: any | null, mle_offset_depth_inches: any, outer_diameter_rub_inches: any, is_hps: boolean }>, motors_aggregate: { __typename: 'motors_aggregate', id: 'motors_aggregate', aggregate?: { __typename: 'motors_aggregate_fields', count: number, id: 'motors_aggregate_fields' } | null } };

export type MotorsSubSubscriptionVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Motors_Bool_Exp>;
  order_by?: InputMaybe<Array<Motors_Order_By>>;
}>;


export type MotorsSubSubscription = { __typename: 'subscription_root', motors: Array<{ __typename: 'motors', id: any, author_id: string, allow_rerate: boolean, configuration?: string | null, created_at: any, deleted_at?: any | null, eff1?: any | null, eff2?: any | null, eff3?: any | null, eff4?: any | null, eff5?: any | null, effb?: any | null, i1?: any | null, i2?: any | null, i3?: any | null, i4?: any | null, i5?: any | null, ib?: any | null, imported_sizing_id?: number | null, length_inches?: any | null, manufacturer?: string | null, n1?: any | null, n2?: any | null, n3?: any | null, n4?: any | null, n5?: any | null, nameplate_current?: number | null, nameplate_horsepower?: number | null, nameplate_voltage?: number | null, nb?: any | null, oil_volume_gallons?: any | null, part_number?: string | null, pf1?: any | null, pf2?: any | null, pf3?: any | null, pf4?: any | null, pf5?: any | null, pfb?: any | null, rr_l1?: any | null, rr_l2?: any | null, rr_lb?: any | null, rr_v3: any, rr_v2: any, rr_v1?: any | null, rr_vb?: any | null, shaft_horsepower?: number | null, nv0: any, nv1: any, nv2: any, iv0: any, iv1: any, iv2: any, pfv0: any, pfv1: any, pfv2: any, effv0: any, effv1: any, effv2: any, tv0: any, tv1: any, tv2: any, temperature_rating_fahrenheit?: number | null, updated_at: any, weight_pounds?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, poles?: number | null, stator_inner_diameter_inches?: any | null, stator_outer_diameter_inches?: any | null, k3?: any | null, nameplate_rerate_ratio?: any | null, inner_diameter_inches?: any | null, outer_diameter_inches?: any | null, neck_inner_diameter_inches?: any | null, neck_outer_diameter_inches?: any | null, mle_offset_depth_inches: any, outer_diameter_rub_inches: any, is_hps: boolean }> };

export type DeleteMotorsMutationVariables = Exact<{
  where: Motors_Bool_Exp;
}>;


export type DeleteMotorsMutation = { __typename: 'mutation_root', update_motors?: { __typename: 'motors_mutation_response', returning: Array<{ __typename: 'motors', id: any }> } | null };

export type RestoreMotorsMutationVariables = Exact<{
  where: Motors_Bool_Exp;
}>;


export type RestoreMotorsMutation = { __typename: 'mutation_root', update_motors?: { __typename: 'motors_mutation_response', returning: Array<{ __typename: 'motors', id: any }> } | null };

export type UpdateMotorByPkMutationVariables = Exact<{
  object?: InputMaybe<Motors_Set_Input>;
  id: Scalars['uuid']['input'];
}>;


export type UpdateMotorByPkMutation = { __typename: 'mutation_root', update_motors_by_pk?: { __typename: 'motors', id: any, author_id: string, allow_rerate: boolean, configuration?: string | null, created_at: any, deleted_at?: any | null, eff1?: any | null, eff2?: any | null, eff3?: any | null, eff4?: any | null, eff5?: any | null, effb?: any | null, i1?: any | null, i2?: any | null, i3?: any | null, i4?: any | null, i5?: any | null, ib?: any | null, imported_sizing_id?: number | null, length_inches?: any | null, manufacturer?: string | null, n1?: any | null, n2?: any | null, n3?: any | null, n4?: any | null, n5?: any | null, nameplate_current?: number | null, nameplate_horsepower?: number | null, nameplate_voltage?: number | null, nb?: any | null, oil_volume_gallons?: any | null, part_number?: string | null, pf1?: any | null, pf2?: any | null, pf3?: any | null, pf4?: any | null, pf5?: any | null, pfb?: any | null, rr_l1?: any | null, rr_l2?: any | null, rr_lb?: any | null, rr_v3: any, rr_v2: any, rr_v1?: any | null, rr_vb?: any | null, shaft_horsepower?: number | null, nv0: any, nv1: any, nv2: any, iv0: any, iv1: any, iv2: any, pfv0: any, pfv1: any, pfv2: any, effv0: any, effv1: any, effv2: any, tv0: any, tv1: any, tv2: any, temperature_rating_fahrenheit?: number | null, updated_at: any, weight_pounds?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, poles?: number | null, stator_inner_diameter_inches?: any | null, stator_outer_diameter_inches?: any | null, k3?: any | null, nameplate_rerate_ratio?: any | null, inner_diameter_inches?: any | null, outer_diameter_inches?: any | null, neck_inner_diameter_inches?: any | null, neck_outer_diameter_inches?: any | null, mle_offset_depth_inches: any, outer_diameter_rub_inches: any, is_hps: boolean } | null };

export type InsertMotorMutationVariables = Exact<{
  object: Motors_Insert_Input;
}>;


export type InsertMotorMutation = { __typename: 'mutation_root', insert_motors_one?: { __typename: 'motors', id: any, allow_rerate: boolean, created_at: any, updated_at: any, manufacturer?: string | null, part_number?: string | null, outer_diameter_inches?: any | null, length_inches?: any | null, weight_pounds?: any | null, nameplate_horsepower?: number | null, nameplate_voltage?: number | null, nameplate_current?: number | null, shaft_horsepower?: number | null, temperature_rating_fahrenheit?: number | null, eff1?: any | null, eff2?: any | null, eff3?: any | null, eff4?: any | null, eff5?: any | null, effb?: any | null, i1?: any | null, i2?: any | null, i3?: any | null, i4?: any | null, i5?: any | null, ib?: any | null, n1?: any | null, n2?: any | null, n3?: any | null, n4?: any | null, n5?: any | null, nb?: any | null, pf1?: any | null, pf2?: any | null, pf3?: any | null, pf4?: any | null, pf5?: any | null, pfb?: any | null, rr_l1?: any | null, rr_l2?: any | null, rr_lb?: any | null, rr_v3: any, rr_v2: any, rr_v1?: any | null, rr_vb?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, poles?: number | null, stator_inner_diameter_inches?: any | null, stator_outer_diameter_inches?: any | null, k3?: any | null, nameplate_rerate_ratio?: any | null, inner_diameter_inches?: any | null, neck_inner_diameter_inches?: any | null, neck_outer_diameter_inches?: any | null, mle_offset_depth_inches: any, outer_diameter_rub_inches: any, is_hps: boolean, nv0: any, nv1: any, nv2: any, iv0: any, iv1: any, iv2: any, pfv0: any, pfv1: any, pfv2: any, effv0: any, effv1: any, effv2: any, tv0: any, tv1: any, tv2: any } | null };

export type PumpsBaseFieldsFragment = { __typename: 'pumps', id: any, manufacturer?: string | null, series_model?: string | null, rotation?: string | null, part_number?: string | null, compression_thrust_per_stage?: any | null, shaft_diameter_inches?: any | null, max_bolt_load_pounds?: any | null, is_compression_pump: boolean, housing_inner_diameter_inches?: any | null, housing_outer_diameter_inches?: any | null, neck_inner_diameter_inches?: any | null, neck_outer_diameter_inches?: any | null };

export type PumpsInsertFieldsFragment = { __typename: 'pumps', id: any, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, manufacturer?: string | null, rotation?: string | null, part_number?: string | null, compression_thrust_per_stage?: any | null, series_model?: string | null, stage_type?: number | null, shaft_diameter_inches?: any | null, standard_housing_pressure_rating_psi?: number | null, high_strength_housing_pressure_rating_psi?: number | null, standard_shaft_rating_hp?: number | null, high_strength_shaft_rating_hp?: number | null, construction?: string | null, min_rate_standard_pump_bpd?: number | null, bep_rate_standard_pump_bpd?: number | null, max_rate_standard_pump_bpd?: number | null, max_graph_rate_standard_pump_bpd?: number | null, hb?: any | null, h1?: any | null, h2?: any | null, h3?: any | null, h4?: any | null, h5?: any | null, bhpb?: any | null, bhp1?: any | null, bhp2?: any | null, bhp3?: any | null, bhp4?: any | null, bhp5?: any | null, npsh1?: any | null, npsh2?: any | null, npsh3?: any | null, npsh4?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, is_compression_pump: boolean, housing_inner_diameter_inches?: any | null, housing_outer_diameter_inches?: any | null, neck_inner_diameter_inches?: any | null, neck_outer_diameter_inches?: any | null };

export type PumpsAllFieldsFragment = { __typename: 'pumps', id: any, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, manufacturer?: string | null, rotation?: string | null, part_number?: string | null, compression_thrust_per_stage?: any | null, series_model?: string | null, stage_type?: number | null, shaft_diameter_inches?: any | null, standard_housing_pressure_rating_psi?: number | null, high_strength_housing_pressure_rating_psi?: number | null, standard_shaft_rating_hp?: number | null, high_strength_shaft_rating_hp?: number | null, construction?: string | null, min_rate_standard_pump_bpd?: number | null, bep_rate_standard_pump_bpd?: number | null, max_rate_standard_pump_bpd?: number | null, max_graph_rate_standard_pump_bpd?: number | null, hb?: any | null, h1?: any | null, h2?: any | null, h3?: any | null, h4?: any | null, h5?: any | null, bhpb?: any | null, bhp1?: any | null, bhp2?: any | null, bhp3?: any | null, bhp4?: any | null, bhp5?: any | null, npsh1?: any | null, npsh2?: any | null, npsh3?: any | null, npsh4?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, max_bolt_load_pounds?: any | null, is_compression_pump: boolean, housing_inner_diameter_inches?: any | null, housing_outer_diameter_inches?: any | null, neck_inner_diameter_inches?: any | null, neck_outer_diameter_inches?: any | null };

export type PumpsBaseQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Pumps_Bool_Exp>;
  order_by?: InputMaybe<Array<Pumps_Order_By>>;
}>;


export type PumpsBaseQuery = { __typename: 'query_root', pumps: Array<{ __typename: 'pumps', id: any, manufacturer?: string | null, series_model?: string | null, rotation?: string | null, part_number?: string | null, compression_thrust_per_stage?: any | null, shaft_diameter_inches?: any | null, max_bolt_load_pounds?: any | null, is_compression_pump: boolean, housing_inner_diameter_inches?: any | null, housing_outer_diameter_inches?: any | null, neck_inner_diameter_inches?: any | null, neck_outer_diameter_inches?: any | null }>, pumps_aggregate: { __typename: 'pumps_aggregate', id: 'pumps_aggregate', aggregate?: { __typename: 'pumps_aggregate_fields', count: number, id: 'pumps_aggregate_fields' } | null } };

export type PumpsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Pumps_Bool_Exp>;
  order_by?: InputMaybe<Array<Pumps_Order_By>>;
  include_housings?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type PumpsQuery = { __typename: 'query_root', pumps: Array<{ __typename: 'pumps', id: any, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, manufacturer?: string | null, rotation?: string | null, part_number?: string | null, compression_thrust_per_stage?: any | null, series_model?: string | null, stage_type?: number | null, shaft_diameter_inches?: any | null, standard_housing_pressure_rating_psi?: number | null, high_strength_housing_pressure_rating_psi?: number | null, standard_shaft_rating_hp?: number | null, high_strength_shaft_rating_hp?: number | null, construction?: string | null, min_rate_standard_pump_bpd?: number | null, bep_rate_standard_pump_bpd?: number | null, max_rate_standard_pump_bpd?: number | null, max_graph_rate_standard_pump_bpd?: number | null, hb?: any | null, h1?: any | null, h2?: any | null, h3?: any | null, h4?: any | null, h5?: any | null, bhpb?: any | null, bhp1?: any | null, bhp2?: any | null, bhp3?: any | null, bhp4?: any | null, bhp5?: any | null, npsh1?: any | null, npsh2?: any | null, npsh3?: any | null, npsh4?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, max_bolt_load_pounds?: any | null, is_compression_pump: boolean, housing_inner_diameter_inches?: any | null, housing_outer_diameter_inches?: any | null, neck_inner_diameter_inches?: any | null, neck_outer_diameter_inches?: any | null, r_housings: Array<{ __typename: 'housings', id: any, housing_number?: number | null, stage_count?: number | null, length_inches?: any | null, weight_pounds?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, pump_id?: any | null }> }>, pumps_aggregate: { __typename: 'pumps_aggregate', id: 'pumps_aggregate', aggregate?: { __typename: 'pumps_aggregate_fields', count: number, id: 'pumps_aggregate_fields' } | null } };

export type PumpsSubSubscriptionVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Pumps_Bool_Exp>;
  order_by?: InputMaybe<Array<Pumps_Order_By>>;
}>;


export type PumpsSubSubscription = { __typename: 'subscription_root', pumps: Array<{ __typename: 'pumps', id: any, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, manufacturer?: string | null, rotation?: string | null, part_number?: string | null, compression_thrust_per_stage?: any | null, series_model?: string | null, stage_type?: number | null, shaft_diameter_inches?: any | null, standard_housing_pressure_rating_psi?: number | null, high_strength_housing_pressure_rating_psi?: number | null, standard_shaft_rating_hp?: number | null, high_strength_shaft_rating_hp?: number | null, construction?: string | null, min_rate_standard_pump_bpd?: number | null, bep_rate_standard_pump_bpd?: number | null, max_rate_standard_pump_bpd?: number | null, max_graph_rate_standard_pump_bpd?: number | null, hb?: any | null, h1?: any | null, h2?: any | null, h3?: any | null, h4?: any | null, h5?: any | null, bhpb?: any | null, bhp1?: any | null, bhp2?: any | null, bhp3?: any | null, bhp4?: any | null, bhp5?: any | null, npsh1?: any | null, npsh2?: any | null, npsh3?: any | null, npsh4?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, max_bolt_load_pounds?: any | null, is_compression_pump: boolean, housing_inner_diameter_inches?: any | null, housing_outer_diameter_inches?: any | null, neck_inner_diameter_inches?: any | null, neck_outer_diameter_inches?: any | null }> };

export type DeletePumpsMutationVariables = Exact<{
  where: Pumps_Bool_Exp;
}>;


export type DeletePumpsMutation = { __typename: 'mutation_root', update_pumps?: { __typename: 'pumps_mutation_response', returning: Array<{ __typename: 'pumps', id: any }> } | null };

export type RestorePumpsMutationVariables = Exact<{
  where: Pumps_Bool_Exp;
}>;


export type RestorePumpsMutation = { __typename: 'mutation_root', update_pumps?: { __typename: 'pumps_mutation_response', returning: Array<{ __typename: 'pumps', id: any }> } | null };

export type InsertPumpMutationVariables = Exact<{
  object: Pumps_Insert_Input;
}>;


export type InsertPumpMutation = { __typename: 'mutation_root', insert_pumps_one?: { __typename: 'pumps', id: any, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, manufacturer?: string | null, rotation?: string | null, part_number?: string | null, compression_thrust_per_stage?: any | null, series_model?: string | null, stage_type?: number | null, shaft_diameter_inches?: any | null, standard_housing_pressure_rating_psi?: number | null, high_strength_housing_pressure_rating_psi?: number | null, standard_shaft_rating_hp?: number | null, high_strength_shaft_rating_hp?: number | null, construction?: string | null, min_rate_standard_pump_bpd?: number | null, bep_rate_standard_pump_bpd?: number | null, max_rate_standard_pump_bpd?: number | null, max_graph_rate_standard_pump_bpd?: number | null, hb?: any | null, h1?: any | null, h2?: any | null, h3?: any | null, h4?: any | null, h5?: any | null, bhpb?: any | null, bhp1?: any | null, bhp2?: any | null, bhp3?: any | null, bhp4?: any | null, bhp5?: any | null, npsh1?: any | null, npsh2?: any | null, npsh3?: any | null, npsh4?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, is_compression_pump: boolean, housing_inner_diameter_inches?: any | null, housing_outer_diameter_inches?: any | null, neck_inner_diameter_inches?: any | null, neck_outer_diameter_inches?: any | null } | null };

export type UpdatePumpByPkMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  object: Pumps_Set_Input;
}>;


export type UpdatePumpByPkMutation = { __typename: 'mutation_root', update_pumps_by_pk?: { __typename: 'pumps', id: any, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, manufacturer?: string | null, rotation?: string | null, part_number?: string | null, compression_thrust_per_stage?: any | null, series_model?: string | null, stage_type?: number | null, shaft_diameter_inches?: any | null, standard_housing_pressure_rating_psi?: number | null, high_strength_housing_pressure_rating_psi?: number | null, standard_shaft_rating_hp?: number | null, high_strength_shaft_rating_hp?: number | null, construction?: string | null, min_rate_standard_pump_bpd?: number | null, bep_rate_standard_pump_bpd?: number | null, max_rate_standard_pump_bpd?: number | null, max_graph_rate_standard_pump_bpd?: number | null, hb?: any | null, h1?: any | null, h2?: any | null, h3?: any | null, h4?: any | null, h5?: any | null, bhpb?: any | null, bhp1?: any | null, bhp2?: any | null, bhp3?: any | null, bhp4?: any | null, bhp5?: any | null, npsh1?: any | null, npsh2?: any | null, npsh3?: any | null, npsh4?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, is_compression_pump: boolean, housing_inner_diameter_inches?: any | null, housing_outer_diameter_inches?: any | null, neck_inner_diameter_inches?: any | null, neck_outer_diameter_inches?: any | null } | null };

export type SealsBaseQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Seals_Bool_Exp>;
  order_by?: InputMaybe<Array<Seals_Order_By>>;
}>;


export type SealsBaseQuery = { __typename: 'query_root', seals: Array<{ __typename: 'seals', id: any, manufacturer?: string | null, part_number?: string | null, configuration?: string | null, length_inches?: any | null, weight_pounds?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, inner_diameter_inches?: any | null, outer_diameter_inches?: any | null, neck_inner_diameter_inches?: any | null, neck_outer_diameter_inches?: any | null, thrust_collar_inner_diameter_inches: any, thrust_collar_outer_diameter_inches: any }>, seals_aggregate: { __typename: 'seals_aggregate', aggregate?: { __typename: 'seals_aggregate_fields', count: number } | null } };

export type SealThrustChambersQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Seals_Bool_Exp>;
  order_by?: InputMaybe<Array<Seals_Order_By>>;
}>;


export type SealThrustChambersQuery = { __typename: 'query_root', seals: Array<{ __typename: 'seals', id: any, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, manufacturer?: string | null, part_number?: string | null, length_inches?: any | null, weight_pounds?: any | null, configuration?: string | null, max_temperature_fahrenheit?: number | null, standard_shaft_limit_hp?: number | null, high_strength_shaft_limit_hp?: number | null, standard_bearing_rating_pounds?: number | null, high_strength_bearing_rating_pounds?: number | null, housing_material?: string | null, bearing_type?: string | null, total_seal_volume_gallons?: any | null, volume_for_bag_expansion_lower_tandem_gallons?: any | null, volume_for_bag_expansion_upper_tandem_gallons?: any | null, upper_chamber_pull_volume_gallons?: any | null, bag_chambers?: number | null, bag_capacity_gallons?: any | null, string_load_pounds?: any | null, load_cb_pounds?: any | null, load_c1_pounds?: any | null, hps_thrust_chamber: boolean, load_test_temperature_fahrenheit?: number | null, description?: string | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, inner_diameter_inches?: any | null, outer_diameter_inches?: any | null, neck_inner_diameter_inches?: any | null, neck_outer_diameter_inches?: any | null, thrust_collar_inner_diameter_inches: any, thrust_collar_outer_diameter_inches: any }>, seals_aggregate: { __typename: 'seals_aggregate', id: 'seals_aggregate', aggregate?: { __typename: 'seals_aggregate_fields', count: number, id: 'seals_aggregate_fields' } | null } };

export type DeleteSealsMutationVariables = Exact<{
  where: Seals_Bool_Exp;
}>;


export type DeleteSealsMutation = { __typename: 'mutation_root', update_seals?: { __typename: 'seals_mutation_response', returning: Array<{ __typename: 'seals', id: any }> } | null };

export type RestoreSealsMutationVariables = Exact<{
  where: Seals_Bool_Exp;
}>;


export type RestoreSealsMutation = { __typename: 'mutation_root', update_seals?: { __typename: 'seals_mutation_response', returning: Array<{ __typename: 'seals', id: any }> } | null };

export type InsertSealMutationVariables = Exact<{
  object: Seals_Insert_Input;
}>;


export type InsertSealMutation = { __typename: 'mutation_root', insert_seals_one?: { __typename: 'seals', id: any, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, manufacturer?: string | null, part_number?: string | null, length_inches?: any | null, weight_pounds?: any | null, configuration?: string | null, max_temperature_fahrenheit?: number | null, standard_shaft_limit_hp?: number | null, high_strength_shaft_limit_hp?: number | null, standard_bearing_rating_pounds?: number | null, high_strength_bearing_rating_pounds?: number | null, housing_material?: string | null, bearing_type?: string | null, total_seal_volume_gallons?: any | null, volume_for_bag_expansion_lower_tandem_gallons?: any | null, volume_for_bag_expansion_upper_tandem_gallons?: any | null, upper_chamber_pull_volume_gallons?: any | null, bag_chambers?: number | null, bag_capacity_gallons?: any | null, string_load_pounds?: any | null, load_cb_pounds?: any | null, load_c1_pounds?: any | null, hps_thrust_chamber: boolean, load_test_temperature_fahrenheit?: number | null, description?: string | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, inner_diameter_inches?: any | null, outer_diameter_inches?: any | null, neck_inner_diameter_inches?: any | null, neck_outer_diameter_inches?: any | null, thrust_collar_inner_diameter_inches: any, thrust_collar_outer_diameter_inches: any } | null };

export type UpdateSealByPkMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  object: Seals_Set_Input;
}>;


export type UpdateSealByPkMutation = { __typename: 'mutation_root', update_seals_by_pk?: { __typename: 'seals', id: any, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, manufacturer?: string | null, part_number?: string | null, length_inches?: any | null, weight_pounds?: any | null, configuration?: string | null, max_temperature_fahrenheit?: number | null, standard_shaft_limit_hp?: number | null, high_strength_shaft_limit_hp?: number | null, standard_bearing_rating_pounds?: number | null, high_strength_bearing_rating_pounds?: number | null, housing_material?: string | null, bearing_type?: string | null, total_seal_volume_gallons?: any | null, volume_for_bag_expansion_lower_tandem_gallons?: any | null, volume_for_bag_expansion_upper_tandem_gallons?: any | null, upper_chamber_pull_volume_gallons?: any | null, bag_chambers?: number | null, bag_capacity_gallons?: any | null, string_load_pounds?: any | null, load_cb_pounds?: any | null, load_c1_pounds?: any | null, hps_thrust_chamber: boolean, load_test_temperature_fahrenheit?: number | null, description?: string | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, inner_diameter_inches?: any | null, outer_diameter_inches?: any | null, neck_inner_diameter_inches?: any | null, neck_outer_diameter_inches?: any | null, thrust_collar_inner_diameter_inches: any, thrust_collar_outer_diameter_inches: any } | null };

export type SealsSubSubscriptionVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Seals_Bool_Exp>;
  order_by?: InputMaybe<Array<Seals_Order_By>>;
}>;


export type SealsSubSubscription = { __typename: 'subscription_root', seals: Array<{ __typename: 'seals', id: any, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, manufacturer?: string | null, part_number?: string | null, length_inches?: any | null, weight_pounds?: any | null, configuration?: string | null, max_temperature_fahrenheit?: number | null, standard_shaft_limit_hp?: number | null, high_strength_shaft_limit_hp?: number | null, standard_bearing_rating_pounds?: number | null, high_strength_bearing_rating_pounds?: number | null, housing_material?: string | null, bearing_type?: string | null, total_seal_volume_gallons?: any | null, volume_for_bag_expansion_lower_tandem_gallons?: any | null, volume_for_bag_expansion_upper_tandem_gallons?: any | null, upper_chamber_pull_volume_gallons?: any | null, bag_chambers?: number | null, bag_capacity_gallons?: any | null, string_load_pounds?: any | null, load_cb_pounds?: any | null, load_c1_pounds?: any | null, hps_thrust_chamber: boolean, load_test_temperature_fahrenheit?: number | null, description?: string | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, inner_diameter_inches?: any | null, outer_diameter_inches?: any | null, neck_inner_diameter_inches?: any | null, neck_outer_diameter_inches?: any | null, thrust_collar_inner_diameter_inches: any, thrust_collar_outer_diameter_inches: any }> };

export type SealMotorOilAllFieldsFragment = { __typename: 'seal_motor_oil', created_at: any, updated_at: any, deleted_at?: any | null, id: any, name: string, thermal_expansion_factor?: any | null, max_temp_fahrenheit?: number | null, mf_test_temp1_celsius?: number | null, mf_test_temp2_celsius?: number | null, viscosity_test1_centistroke?: any | null, viscosity_test2_centistroke?: any | null, specific_gravity?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null };

export type SealMotorOilQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Seal_Motor_Oil_Bool_Exp>;
  order_by?: InputMaybe<Array<Seal_Motor_Oil_Order_By>>;
}>;


export type SealMotorOilQuery = { __typename: 'query_root', seal_motor_oil: Array<{ __typename: 'seal_motor_oil', created_at: any, updated_at: any, deleted_at?: any | null, id: any, name: string, thermal_expansion_factor?: any | null, max_temp_fahrenheit?: number | null, mf_test_temp1_celsius?: number | null, mf_test_temp2_celsius?: number | null, viscosity_test1_centistroke?: any | null, viscosity_test2_centistroke?: any | null, specific_gravity?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null }>, seal_motor_oil_aggregate: { __typename: 'seal_motor_oil_aggregate', id: 'seal_motor_oil_aggregate', aggregate?: { __typename: 'seal_motor_oil_aggregate_fields', count: number, id: 'seal_motor_oil_aggregate_fields' } | null } };

export type InsertSealMotorOilMutationVariables = Exact<{
  object: Seal_Motor_Oil_Insert_Input;
}>;


export type InsertSealMotorOilMutation = { __typename: 'mutation_root', insert_seal_motor_oil_one?: { __typename: 'seal_motor_oil', created_at: any, updated_at: any, deleted_at?: any | null, id: any, name: string, thermal_expansion_factor?: any | null, max_temp_fahrenheit?: number | null, mf_test_temp1_celsius?: number | null, mf_test_temp2_celsius?: number | null, viscosity_test1_centistroke?: any | null, viscosity_test2_centistroke?: any | null, specific_gravity?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null } | null };

export type UpdateSealMotorOilMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  object: Seal_Motor_Oil_Set_Input;
}>;


export type UpdateSealMotorOilMutation = { __typename: 'mutation_root', update_seal_motor_oil_by_pk?: { __typename: 'seal_motor_oil', created_at: any, updated_at: any, deleted_at?: any | null, id: any, name: string, thermal_expansion_factor?: any | null, max_temp_fahrenheit?: number | null, mf_test_temp1_celsius?: number | null, mf_test_temp2_celsius?: number | null, viscosity_test1_centistroke?: any | null, viscosity_test2_centistroke?: any | null, specific_gravity?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null } | null };

export type DeleteSealMotorOilsMutationVariables = Exact<{
  where: Seal_Motor_Oil_Bool_Exp;
}>;


export type DeleteSealMotorOilsMutation = { __typename: 'mutation_root', update_seal_motor_oil?: { __typename: 'seal_motor_oil_mutation_response', affected_rows: number, returning: Array<{ __typename: 'seal_motor_oil', id: any }> } | null };

export type RestoreSealMotorOilsMutationVariables = Exact<{
  where: Seal_Motor_Oil_Bool_Exp;
}>;


export type RestoreSealMotorOilsMutation = { __typename: 'mutation_root', update_seal_motor_oil?: { __typename: 'seal_motor_oil_mutation_response', affected_rows: number, returning: Array<{ __typename: 'seal_motor_oil', id: any }> } | null };

export type SealsBaseFieldsFragment = { __typename: 'seals', id: any, manufacturer?: string | null, part_number?: string | null, configuration?: string | null, length_inches?: any | null, weight_pounds?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, inner_diameter_inches?: any | null, outer_diameter_inches?: any | null, neck_inner_diameter_inches?: any | null, neck_outer_diameter_inches?: any | null, thrust_collar_inner_diameter_inches: any, thrust_collar_outer_diameter_inches: any };

export type SealsAllFieldsFragment = { __typename: 'seals', id: any, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, manufacturer?: string | null, part_number?: string | null, length_inches?: any | null, weight_pounds?: any | null, configuration?: string | null, max_temperature_fahrenheit?: number | null, standard_shaft_limit_hp?: number | null, high_strength_shaft_limit_hp?: number | null, standard_bearing_rating_pounds?: number | null, high_strength_bearing_rating_pounds?: number | null, housing_material?: string | null, bearing_type?: string | null, total_seal_volume_gallons?: any | null, volume_for_bag_expansion_lower_tandem_gallons?: any | null, volume_for_bag_expansion_upper_tandem_gallons?: any | null, upper_chamber_pull_volume_gallons?: any | null, bag_chambers?: number | null, bag_capacity_gallons?: any | null, string_load_pounds?: any | null, load_cb_pounds?: any | null, load_c1_pounds?: any | null, hps_thrust_chamber: boolean, load_test_temperature_fahrenheit?: number | null, description?: string | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, inner_diameter_inches?: any | null, outer_diameter_inches?: any | null, neck_inner_diameter_inches?: any | null, neck_outer_diameter_inches?: any | null, thrust_collar_inner_diameter_inches: any, thrust_collar_outer_diameter_inches: any };

export type SealsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Seals_Bool_Exp>;
  order_by?: InputMaybe<Array<Seals_Order_By>>;
}>;


export type SealsQuery = { __typename: 'query_root', seals: Array<{ __typename: 'seals', id: any, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, manufacturer?: string | null, part_number?: string | null, length_inches?: any | null, weight_pounds?: any | null, configuration?: string | null, max_temperature_fahrenheit?: number | null, standard_shaft_limit_hp?: number | null, high_strength_shaft_limit_hp?: number | null, standard_bearing_rating_pounds?: number | null, high_strength_bearing_rating_pounds?: number | null, housing_material?: string | null, bearing_type?: string | null, total_seal_volume_gallons?: any | null, volume_for_bag_expansion_lower_tandem_gallons?: any | null, volume_for_bag_expansion_upper_tandem_gallons?: any | null, upper_chamber_pull_volume_gallons?: any | null, bag_chambers?: number | null, bag_capacity_gallons?: any | null, string_load_pounds?: any | null, load_cb_pounds?: any | null, load_c1_pounds?: any | null, hps_thrust_chamber: boolean, load_test_temperature_fahrenheit?: number | null, description?: string | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, inner_diameter_inches?: any | null, outer_diameter_inches?: any | null, neck_inner_diameter_inches?: any | null, neck_outer_diameter_inches?: any | null, thrust_collar_inner_diameter_inches: any, thrust_collar_outer_diameter_inches: any }>, seals_aggregate: { __typename: 'seals_aggregate', id: 'seals_aggregate', aggregate?: { __typename: 'seals_aggregate_fields', count: number, id: 'seals_aggregate_fields' } | null } };

export type SensorsBaseFieldsFragment = { __typename: 'sensors', id: any, manufacturer?: string | null, part_number?: string | null, model?: string | null, length_inches?: number | null, weight_pounds?: number | null, inner_diameter_inches?: any | null, outer_diameter_inches: any, neck_inner_diameter_inches?: any | null, neck_outer_diameter_inches?: any | null };

export type SensorsInsertFieldsFragment = { __typename: 'sensors', id: any, created_at: any, updated_at: any, manufacturer?: string | null, part_number?: string | null, length_inches?: number | null, weight_pounds?: number | null, model?: string | null, channels?: number | null, max_intake_temperature_fahrenheit?: number | null, max_intake_pressure_psi?: number | null, housing_material?: string | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, inner_diameter_inches?: any | null, outer_diameter_inches: any, neck_inner_diameter_inches?: any | null, neck_outer_diameter_inches?: any | null };

export type SensorsAllFieldsFragment = { __typename: 'sensors', id: any, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, manufacturer?: string | null, part_number?: string | null, length_inches?: number | null, weight_pounds?: number | null, model?: string | null, channels?: number | null, max_intake_temperature_fahrenheit?: number | null, max_intake_pressure_psi?: number | null, housing_material?: string | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, inner_diameter_inches?: any | null, outer_diameter_inches: any, neck_inner_diameter_inches?: any | null, neck_outer_diameter_inches?: any | null };

export type SensorsBaseQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Sensors_Bool_Exp>;
  order_by?: InputMaybe<Array<Sensors_Order_By>>;
}>;


export type SensorsBaseQuery = { __typename: 'query_root', sensors: Array<{ __typename: 'sensors', id: any, manufacturer?: string | null, part_number?: string | null, model?: string | null, length_inches?: number | null, weight_pounds?: number | null, inner_diameter_inches?: any | null, outer_diameter_inches: any, neck_inner_diameter_inches?: any | null, neck_outer_diameter_inches?: any | null }>, sensors_aggregate: { __typename: 'sensors_aggregate', id: 'sensors_aggregate', aggregate?: { __typename: 'sensors_aggregate_fields', count: number, id: 'sensors_aggregate_fields' } | null } };

export type SensorsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Sensors_Bool_Exp>;
  order_by?: InputMaybe<Array<Sensors_Order_By>>;
}>;


export type SensorsQuery = { __typename: 'query_root', sensors: Array<{ __typename: 'sensors', id: any, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, manufacturer?: string | null, part_number?: string | null, length_inches?: number | null, weight_pounds?: number | null, model?: string | null, channels?: number | null, max_intake_temperature_fahrenheit?: number | null, max_intake_pressure_psi?: number | null, housing_material?: string | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, inner_diameter_inches?: any | null, outer_diameter_inches: any, neck_inner_diameter_inches?: any | null, neck_outer_diameter_inches?: any | null }>, sensors_aggregate: { __typename: 'sensors_aggregate', id: 'sensors_aggregate', aggregate?: { __typename: 'sensors_aggregate_fields', count: number, id: 'sensors_aggregate_fields' } | null } };

export type SensorsSubSubscriptionVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Sensors_Bool_Exp>;
  order_by?: InputMaybe<Array<Sensors_Order_By>>;
}>;


export type SensorsSubSubscription = { __typename: 'subscription_root', sensors: Array<{ __typename: 'sensors', id: any, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, manufacturer?: string | null, part_number?: string | null, length_inches?: number | null, weight_pounds?: number | null, model?: string | null, channels?: number | null, max_intake_temperature_fahrenheit?: number | null, max_intake_pressure_psi?: number | null, housing_material?: string | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, inner_diameter_inches?: any | null, outer_diameter_inches: any, neck_inner_diameter_inches?: any | null, neck_outer_diameter_inches?: any | null }> };

export type DeleteSensorsMutationVariables = Exact<{
  where: Sensors_Bool_Exp;
}>;


export type DeleteSensorsMutation = { __typename: 'mutation_root', update_sensors?: { __typename: 'sensors_mutation_response', returning: Array<{ __typename: 'sensors', id: any }> } | null };

export type UpdateSensorMutationVariables = Exact<{
  object?: InputMaybe<Sensors_Set_Input>;
  id: Scalars['uuid']['input'];
}>;


export type UpdateSensorMutation = { __typename: 'mutation_root', update_sensors_by_pk?: { __typename: 'sensors', id: any, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, manufacturer?: string | null, part_number?: string | null, length_inches?: number | null, weight_pounds?: number | null, model?: string | null, channels?: number | null, max_intake_temperature_fahrenheit?: number | null, max_intake_pressure_psi?: number | null, housing_material?: string | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, inner_diameter_inches?: any | null, outer_diameter_inches: any, neck_inner_diameter_inches?: any | null, neck_outer_diameter_inches?: any | null } | null };

export type RestoreSensorsMutationVariables = Exact<{
  where: Sensors_Bool_Exp;
}>;


export type RestoreSensorsMutation = { __typename: 'mutation_root', update_sensors?: { __typename: 'sensors_mutation_response', returning: Array<{ __typename: 'sensors', id: any }> } | null };

export type InsertSensorMutationVariables = Exact<{
  object: Sensors_Insert_Input;
}>;


export type InsertSensorMutation = { __typename: 'mutation_root', insert_sensors_one?: { __typename: 'sensors', id: any, created_at: any, updated_at: any, manufacturer?: string | null, part_number?: string | null, length_inches?: number | null, weight_pounds?: number | null, model?: string | null, channels?: number | null, max_intake_temperature_fahrenheit?: number | null, max_intake_pressure_psi?: number | null, housing_material?: string | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, inner_diameter_inches?: any | null, outer_diameter_inches: any, neck_inner_diameter_inches?: any | null, neck_outer_diameter_inches?: any | null } | null };

export type StepDownTransformersBaseFieldsFragment = { __typename: 'step_down_transformers', id: any, manufacturer?: string | null, part_number?: string | null, transformer_type?: string | null, weight_pounds?: number | null, primary_voltage_delta?: number | null, primary_voltage_wye?: number | null, min_secondary_voltage?: number | null, max_secondary_voltage?: number | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null };

export type DownTransAllFieldsFragment = { __typename: 'step_down_transformers', id: any, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, manufacturer?: string | null, part_number?: string | null, transformer_type?: string | null, primary_voltage_delta?: number | null, primary_voltage_wye?: number | null, min_secondary_voltage?: number | null, max_secondary_voltage?: number | null, weight_pounds?: number | null, enclosure?: string | null, kva?: number | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null };

export type StepDownTransformersBaseQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Step_Down_Transformers_Bool_Exp>;
  order_by?: InputMaybe<Array<Step_Down_Transformers_Order_By>>;
}>;


export type StepDownTransformersBaseQuery = { __typename: 'query_root', step_down_transformers: Array<{ __typename: 'step_down_transformers', id: any, manufacturer?: string | null, part_number?: string | null, transformer_type?: string | null, weight_pounds?: number | null, primary_voltage_delta?: number | null, primary_voltage_wye?: number | null, min_secondary_voltage?: number | null, max_secondary_voltage?: number | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null }>, step_down_transformers_aggregate: { __typename: 'step_down_transformers_aggregate', aggregate?: { __typename: 'step_down_transformers_aggregate_fields', count: number } | null } };

export type StepDownTransformersQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Step_Down_Transformers_Bool_Exp>;
  order_by?: InputMaybe<Array<Step_Down_Transformers_Order_By>>;
}>;


export type StepDownTransformersQuery = { __typename: 'query_root', step_down_transformers: Array<{ __typename: 'step_down_transformers', id: any, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, manufacturer?: string | null, part_number?: string | null, transformer_type?: string | null, primary_voltage_delta?: number | null, primary_voltage_wye?: number | null, min_secondary_voltage?: number | null, max_secondary_voltage?: number | null, weight_pounds?: number | null, enclosure?: string | null, kva?: number | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null }>, step_down_transformers_aggregate: { __typename: 'step_down_transformers_aggregate', id: 'step_down_transformers_aggregate', aggregate?: { __typename: 'step_down_transformers_aggregate_fields', count: number, id: 'step_down_transformers_aggregate_fields' } | null } };

export type DeleteDownTransMutationVariables = Exact<{
  where: Step_Down_Transformers_Bool_Exp;
}>;


export type DeleteDownTransMutation = { __typename: 'mutation_root', update_step_down_transformers?: { __typename: 'step_down_transformers_mutation_response', returning: Array<{ __typename: 'step_down_transformers', id: any }> } | null };

export type RestoreDownTransMutationVariables = Exact<{
  where: Step_Down_Transformers_Bool_Exp;
}>;


export type RestoreDownTransMutation = { __typename: 'mutation_root', update_step_down_transformers?: { __typename: 'step_down_transformers_mutation_response', returning: Array<{ __typename: 'step_down_transformers', id: any }> } | null };

export type InsertDownTransMutationVariables = Exact<{
  object: Step_Down_Transformers_Insert_Input;
}>;


export type InsertDownTransMutation = { __typename: 'mutation_root', insert_step_down_transformers_one?: { __typename: 'step_down_transformers', id: any, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, manufacturer?: string | null, part_number?: string | null, transformer_type?: string | null, primary_voltage_delta?: number | null, primary_voltage_wye?: number | null, min_secondary_voltage?: number | null, max_secondary_voltage?: number | null, weight_pounds?: number | null, enclosure?: string | null, kva?: number | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null } | null };

export type UpdateDownTransByPkMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  object: Step_Down_Transformers_Set_Input;
}>;


export type UpdateDownTransByPkMutation = { __typename: 'mutation_root', update_step_down_transformers_by_pk?: { __typename: 'step_down_transformers', id: any, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, manufacturer?: string | null, part_number?: string | null, transformer_type?: string | null, primary_voltage_delta?: number | null, primary_voltage_wye?: number | null, min_secondary_voltage?: number | null, max_secondary_voltage?: number | null, weight_pounds?: number | null, enclosure?: string | null, kva?: number | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null } | null };

export type StepDownTransformersSubSubscriptionVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Step_Down_Transformers_Bool_Exp>;
  order_by?: InputMaybe<Array<Step_Down_Transformers_Order_By>>;
}>;


export type StepDownTransformersSubSubscription = { __typename: 'subscription_root', step_down_transformers: Array<{ __typename: 'step_down_transformers', id: any, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, manufacturer?: string | null, part_number?: string | null, transformer_type?: string | null, primary_voltage_delta?: number | null, primary_voltage_wye?: number | null, min_secondary_voltage?: number | null, max_secondary_voltage?: number | null, weight_pounds?: number | null, enclosure?: string | null, kva?: number | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null }> };

export type StepUpTransformersBaseFieldsFragment = { __typename: 'step_up_transformers', id: any, manufacturer?: string | null, part_number?: string | null, transformer_type?: string | null, weight_pounds?: number | null, primary_voltage?: number | null, min_secondary_voltage?: number | null, max_secondary_voltage?: number | null, include_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, only_koc_timestamp?: any | null };

export type UpTransAllFieldsFragment = { __typename: 'step_up_transformers', id: any, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, manufacturer?: string | null, part_number?: string | null, transformer_type?: string | null, primary_voltage?: number | null, min_secondary_voltage?: number | null, max_secondary_voltage?: number | null, weight_pounds?: number | null, enclosure?: string | null, kva?: number | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null };

export type StepUpTransformersBaseQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Step_Up_Transformers_Bool_Exp>;
  order_by?: InputMaybe<Array<Step_Up_Transformers_Order_By>>;
}>;


export type StepUpTransformersBaseQuery = { __typename: 'query_root', step_up_transformers: Array<{ __typename: 'step_up_transformers', id: any, manufacturer?: string | null, part_number?: string | null, transformer_type?: string | null, weight_pounds?: number | null, primary_voltage?: number | null, min_secondary_voltage?: number | null, max_secondary_voltage?: number | null, include_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, only_koc_timestamp?: any | null }>, step_up_transformers_aggregate: { __typename: 'step_up_transformers_aggregate', aggregate?: { __typename: 'step_up_transformers_aggregate_fields', count: number } | null } };

export type StepUpTransformersQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Step_Up_Transformers_Bool_Exp>;
  order_by?: InputMaybe<Array<Step_Up_Transformers_Order_By>>;
}>;


export type StepUpTransformersQuery = { __typename: 'query_root', step_up_transformers: Array<{ __typename: 'step_up_transformers', id: any, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, manufacturer?: string | null, part_number?: string | null, transformer_type?: string | null, primary_voltage?: number | null, min_secondary_voltage?: number | null, max_secondary_voltage?: number | null, weight_pounds?: number | null, enclosure?: string | null, kva?: number | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null }>, step_up_transformers_aggregate: { __typename: 'step_up_transformers_aggregate', id: 'step_up_transformers_aggregate', aggregate?: { __typename: 'step_up_transformers_aggregate_fields', count: number, id: 'step_up_transformers_aggregate_fields' } | null } };

export type DeleteUpTransMutationVariables = Exact<{
  where: Step_Up_Transformers_Bool_Exp;
}>;


export type DeleteUpTransMutation = { __typename: 'mutation_root', update_step_up_transformers?: { __typename: 'step_up_transformers_mutation_response', returning: Array<{ __typename: 'step_up_transformers', id: any }> } | null };

export type RestoreUpTransMutationVariables = Exact<{
  where: Step_Up_Transformers_Bool_Exp;
}>;


export type RestoreUpTransMutation = { __typename: 'mutation_root', update_step_up_transformers?: { __typename: 'step_up_transformers_mutation_response', returning: Array<{ __typename: 'step_up_transformers', id: any }> } | null };

export type InsertUpTransMutationVariables = Exact<{
  object: Step_Up_Transformers_Insert_Input;
}>;


export type InsertUpTransMutation = { __typename: 'mutation_root', insert_step_up_transformers_one?: { __typename: 'step_up_transformers', id: any, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, manufacturer?: string | null, part_number?: string | null, transformer_type?: string | null, primary_voltage?: number | null, min_secondary_voltage?: number | null, max_secondary_voltage?: number | null, weight_pounds?: number | null, enclosure?: string | null, kva?: number | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null } | null };

export type UpdateUpTransByPkMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  object: Step_Up_Transformers_Set_Input;
}>;


export type UpdateUpTransByPkMutation = { __typename: 'mutation_root', update_step_up_transformers_by_pk?: { __typename: 'step_up_transformers', id: any, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, manufacturer?: string | null, part_number?: string | null, transformer_type?: string | null, primary_voltage?: number | null, min_secondary_voltage?: number | null, max_secondary_voltage?: number | null, weight_pounds?: number | null, enclosure?: string | null, kva?: number | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null } | null };

export type StepUpTransformersSubSubscriptionVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Step_Up_Transformers_Bool_Exp>;
  order_by?: InputMaybe<Array<Step_Up_Transformers_Order_By>>;
}>;


export type StepUpTransformersSubSubscription = { __typename: 'subscription_root', step_up_transformers: Array<{ __typename: 'step_up_transformers', id: any, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, manufacturer?: string | null, part_number?: string | null, transformer_type?: string | null, primary_voltage?: number | null, min_secondary_voltage?: number | null, max_secondary_voltage?: number | null, weight_pounds?: number | null, enclosure?: string | null, kva?: number | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null }> };

export type SwitchboardsBaseFieldsFragment = { __typename: 'switchboards', id: any, amps?: number | null, enclosure?: string | null, kv?: any | null, manufacturer?: string | null, part_number?: string | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null };

export type SwitchboardsAllFieldsFragment = { __typename: 'switchboards', id: any, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, amps?: number | null, enclosure?: string | null, kv?: any | null, manufacturer?: string | null, part_number?: string | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null };

export type SwitchboardsBaseQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Switchboards_Bool_Exp>;
  order_by?: InputMaybe<Array<Switchboards_Order_By>>;
}>;


export type SwitchboardsBaseQuery = { __typename: 'query_root', switchboards: Array<{ __typename: 'switchboards', id: any, amps?: number | null, enclosure?: string | null, kv?: any | null, manufacturer?: string | null, part_number?: string | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null }>, switchboards_aggregate: { __typename: 'switchboards_aggregate', aggregate?: { __typename: 'switchboards_aggregate_fields', count: number } | null } };

export type SwitchboardsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Switchboards_Bool_Exp>;
  order_by?: InputMaybe<Array<Switchboards_Order_By>>;
}>;


export type SwitchboardsQuery = { __typename: 'query_root', switchboards: Array<{ __typename: 'switchboards', id: any, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, amps?: number | null, enclosure?: string | null, kv?: any | null, manufacturer?: string | null, part_number?: string | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null }>, switchboards_aggregate: { __typename: 'switchboards_aggregate', id: 'switchboards_aggregate', aggregate?: { __typename: 'switchboards_aggregate_fields', count: number, id: 'switchboards_aggregate_fields' } | null } };

export type DeleteSwitchboardsMutationVariables = Exact<{
  where: Switchboards_Bool_Exp;
}>;


export type DeleteSwitchboardsMutation = { __typename: 'mutation_root', update_switchboards?: { __typename: 'switchboards_mutation_response', returning: Array<{ __typename: 'switchboards', id: any }> } | null };

export type RestoreSwitchboardsMutationVariables = Exact<{
  where: Switchboards_Bool_Exp;
}>;


export type RestoreSwitchboardsMutation = { __typename: 'mutation_root', update_switchboards?: { __typename: 'switchboards_mutation_response', returning: Array<{ __typename: 'switchboards', id: any }> } | null };

export type InsertSwitchboardMutationVariables = Exact<{
  object: Switchboards_Insert_Input;
}>;


export type InsertSwitchboardMutation = { __typename: 'mutation_root', insert_switchboards_one?: { __typename: 'switchboards', id: any, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, amps?: number | null, enclosure?: string | null, kv?: any | null, manufacturer?: string | null, part_number?: string | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null } | null };

export type UpdateSwitchboardByPkMutationVariables = Exact<{
  object?: InputMaybe<Switchboards_Set_Input>;
  id: Scalars['uuid']['input'];
}>;


export type UpdateSwitchboardByPkMutation = { __typename: 'mutation_root', update_switchboards_by_pk?: { __typename: 'switchboards', id: any, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, amps?: number | null, enclosure?: string | null, kv?: any | null, manufacturer?: string | null, part_number?: string | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null } | null };

export type SwitchboardsSubSubscriptionVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Switchboards_Bool_Exp>;
  order_by?: InputMaybe<Array<Switchboards_Order_By>>;
}>;


export type SwitchboardsSubSubscription = { __typename: 'subscription_root', switchboards: Array<{ __typename: 'switchboards', id: any, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, amps?: number | null, enclosure?: string | null, kv?: any | null, manufacturer?: string | null, part_number?: string | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null }> };

export type TubingsBaseFieldsFragment = { __typename: 'tubings', id: any, coupling_outer_diameter_inches?: any | null, drift_inches?: any | null, imperial_name?: string | null, interior_diameter_inches?: any | null, metric_name?: string | null, outer_diameter_inches?: any | null, pound_per_foot?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, tubing_type: Tubings_Type_Enum };

export type TubingsAllFieldsFragment = { __typename: 'tubings', id: any, author_id: string, coupling_outer_diameter_inches?: any | null, created_at: any, deleted_at?: any | null, drift_inches?: any | null, imperial_name?: string | null, imported_sizing_id?: number | null, interior_diameter_inches?: any | null, metric_name?: string | null, outer_diameter_inches?: any | null, pound_per_foot?: any | null, tubing_type: Tubings_Type_Enum, updated_at: any, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null };

export type TubingsBaseQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Tubings_Bool_Exp>;
  order_by?: InputMaybe<Array<Tubings_Order_By>>;
}>;


export type TubingsBaseQuery = { __typename: 'query_root', tubings: Array<{ __typename: 'tubings', id: any, coupling_outer_diameter_inches?: any | null, drift_inches?: any | null, imperial_name?: string | null, interior_diameter_inches?: any | null, metric_name?: string | null, outer_diameter_inches?: any | null, pound_per_foot?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, tubing_type: Tubings_Type_Enum }>, tubings_aggregate: { __typename: 'tubings_aggregate', aggregate?: { __typename: 'tubings_aggregate_fields', count: number } | null } };

export type TubingsListQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Tubings_Bool_Exp>;
  order_by?: InputMaybe<Array<Tubings_Order_By>>;
}>;


export type TubingsListQuery = { __typename: 'query_root', tubings: Array<{ __typename: 'tubings', id: any, author_id: string, coupling_outer_diameter_inches?: any | null, created_at: any, deleted_at?: any | null, drift_inches?: any | null, imperial_name?: string | null, imported_sizing_id?: number | null, interior_diameter_inches?: any | null, metric_name?: string | null, outer_diameter_inches?: any | null, pound_per_foot?: any | null, tubing_type: Tubings_Type_Enum, updated_at: any, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null }>, tubings_aggregate: { __typename: 'tubings_aggregate', aggregate?: { __typename: 'tubings_aggregate_fields', count: number } | null } };

export type TubingsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Tubings_Bool_Exp>;
  order_by?: InputMaybe<Array<Tubings_Order_By>>;
}>;


export type TubingsQuery = { __typename: 'query_root', tubings: Array<{ __typename: 'tubings', id: any, author_id: string, coupling_outer_diameter_inches?: any | null, created_at: any, deleted_at?: any | null, drift_inches?: any | null, imperial_name?: string | null, imported_sizing_id?: number | null, interior_diameter_inches?: any | null, metric_name?: string | null, outer_diameter_inches?: any | null, pound_per_foot?: any | null, tubing_type: Tubings_Type_Enum, updated_at: any, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null }>, tubings_aggregate: { __typename: 'tubings_aggregate', id: 'tubings_aggregate', aggregate?: { __typename: 'tubings_aggregate_fields', count: number, id: 'tubings_aggregate_fields' } | null } };

export type DeleteTubingsMutationVariables = Exact<{
  where: Tubings_Bool_Exp;
}>;


export type DeleteTubingsMutation = { __typename: 'mutation_root', update_tubings?: { __typename: 'tubings_mutation_response', returning: Array<{ __typename: 'tubings', id: any }> } | null };

export type RestoreTubingsMutationVariables = Exact<{
  where: Tubings_Bool_Exp;
}>;


export type RestoreTubingsMutation = { __typename: 'mutation_root', update_tubings?: { __typename: 'tubings_mutation_response', returning: Array<{ __typename: 'tubings', id: any }> } | null };

export type InsertTubingMutationVariables = Exact<{
  object: Tubings_Insert_Input;
}>;


export type InsertTubingMutation = { __typename: 'mutation_root', insert_tubings_one?: { __typename: 'tubings', id: any, author_id: string, coupling_outer_diameter_inches?: any | null, created_at: any, deleted_at?: any | null, drift_inches?: any | null, imperial_name?: string | null, imported_sizing_id?: number | null, interior_diameter_inches?: any | null, metric_name?: string | null, outer_diameter_inches?: any | null, pound_per_foot?: any | null, tubing_type: Tubings_Type_Enum, updated_at: any, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null } | null };

export type UpdateTubingByPkMutationVariables = Exact<{
  object?: InputMaybe<Tubings_Set_Input>;
  id: Scalars['uuid']['input'];
}>;


export type UpdateTubingByPkMutation = { __typename: 'mutation_root', update_tubings_by_pk?: { __typename: 'tubings', id: any, author_id: string, coupling_outer_diameter_inches?: any | null, created_at: any, deleted_at?: any | null, drift_inches?: any | null, imperial_name?: string | null, imported_sizing_id?: number | null, interior_diameter_inches?: any | null, metric_name?: string | null, outer_diameter_inches?: any | null, pound_per_foot?: any | null, tubing_type: Tubings_Type_Enum, updated_at: any, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null } | null };

export type TubingsSubSubscriptionVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Tubings_Bool_Exp>;
  order_by?: InputMaybe<Array<Tubings_Order_By>>;
}>;


export type TubingsSubSubscription = { __typename: 'subscription_root', tubings: Array<{ __typename: 'tubings', id: any, author_id: string, coupling_outer_diameter_inches?: any | null, created_at: any, deleted_at?: any | null, drift_inches?: any | null, imperial_name?: string | null, imported_sizing_id?: number | null, interior_diameter_inches?: any | null, metric_name?: string | null, outer_diameter_inches?: any | null, pound_per_foot?: any | null, tubing_type: Tubings_Type_Enum, updated_at: any, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null }> };

export type VsdBaseFieldsFragment = { __typename: 'variable_speed_drives', id: any, manufacturer?: string | null, part_number?: string | null, vsd_type?: string | null, max_amps?: number | null, kva?: number | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null };

export type VsdAllFieldsFragment = { __typename: 'variable_speed_drives', id: any, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, enclosure?: string | null, kva?: number | null, manufacturer?: string | null, max_amps?: number | null, part_number?: string | null, vsd_type?: string | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null };

export type VsdBaseListQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Variable_Speed_Drives_Bool_Exp>;
  order_by?: InputMaybe<Array<Variable_Speed_Drives_Order_By>>;
}>;


export type VsdBaseListQuery = { __typename: 'query_root', variable_speed_drives: Array<{ __typename: 'variable_speed_drives', id: any, manufacturer?: string | null, part_number?: string | null, vsd_type?: string | null, max_amps?: number | null, kva?: number | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null }>, variable_speed_drives_aggregate: { __typename: 'variable_speed_drives_aggregate', aggregate?: { __typename: 'variable_speed_drives_aggregate_fields', count: number } | null } };

export type VariableSpeedDrivesQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Variable_Speed_Drives_Bool_Exp>;
  order_by?: InputMaybe<Array<Variable_Speed_Drives_Order_By>>;
}>;


export type VariableSpeedDrivesQuery = { __typename: 'query_root', variable_speed_drives: Array<{ __typename: 'variable_speed_drives', id: any, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, enclosure?: string | null, kva?: number | null, manufacturer?: string | null, max_amps?: number | null, part_number?: string | null, vsd_type?: string | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null }>, variable_speed_drives_aggregate: { __typename: 'variable_speed_drives_aggregate', id: 'variable_speed_drives_aggregate', aggregate?: { __typename: 'variable_speed_drives_aggregate_fields', count: number, id: 'variable_speed_drives_aggregate_fields' } | null } };

export type DeleteVsdsMutationVariables = Exact<{
  where: Variable_Speed_Drives_Bool_Exp;
}>;


export type DeleteVsdsMutation = { __typename: 'mutation_root', update_variable_speed_drives?: { __typename: 'variable_speed_drives_mutation_response', returning: Array<{ __typename: 'variable_speed_drives', id: any }> } | null };

export type RestoreVsdsMutationVariables = Exact<{
  where: Variable_Speed_Drives_Bool_Exp;
}>;


export type RestoreVsdsMutation = { __typename: 'mutation_root', update_variable_speed_drives?: { __typename: 'variable_speed_drives_mutation_response', returning: Array<{ __typename: 'variable_speed_drives', id: any }> } | null };

export type InsertVsdMutationVariables = Exact<{
  object: Variable_Speed_Drives_Insert_Input;
}>;


export type InsertVsdMutation = { __typename: 'mutation_root', insert_variable_speed_drives_one?: { __typename: 'variable_speed_drives', id: any, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, enclosure?: string | null, kva?: number | null, manufacturer?: string | null, max_amps?: number | null, part_number?: string | null, vsd_type?: string | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null } | null };

export type UpdateVsdByPkMutationVariables = Exact<{
  object?: InputMaybe<Variable_Speed_Drives_Set_Input>;
  id: Scalars['uuid']['input'];
}>;


export type UpdateVsdByPkMutation = { __typename: 'mutation_root', update_variable_speed_drives_by_pk?: { __typename: 'variable_speed_drives', id: any, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, enclosure?: string | null, kva?: number | null, manufacturer?: string | null, max_amps?: number | null, part_number?: string | null, vsd_type?: string | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null } | null };

export type VsdSubSubscriptionVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Variable_Speed_Drives_Bool_Exp>;
  order_by?: InputMaybe<Array<Variable_Speed_Drives_Order_By>>;
}>;


export type VsdSubSubscription = { __typename: 'subscription_root', variable_speed_drives: Array<{ __typename: 'variable_speed_drives', id: any, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, enclosure?: string | null, kva?: number | null, manufacturer?: string | null, max_amps?: number | null, part_number?: string | null, vsd_type?: string | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null }> };

export type YToolBaseFieldsFragment = { __typename: 'y_tools', id: any, minimum_inches?: any | null, maximum_inches?: any | null, length_inches?: any | null, width_inches?: any | null, series_model?: string | null, outer_diameter_inches?: any | null, teleswivel_stroke_length_inches?: any | null, pressure_rating_psi?: number | null, temperature_rating_fahrenheit?: number | null, handling_sub_connection_inches?: any | null, bypass_connection_inches?: any | null, material_type?: string | null, weight_pounds?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, manufacturer?: string | null };

export type YToolAllFieldsFragment = { __typename: 'y_tools', id: any, author_id: string, created_at: any, deleted_at?: any | null, updated_at: any, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, minimum_inches?: any | null, maximum_inches?: any | null, length_inches?: any | null, width_inches?: any | null, series_model?: string | null, outer_diameter_inches?: any | null, teleswivel_stroke_length_inches?: any | null, pressure_rating_psi?: number | null, temperature_rating_fahrenheit?: number | null, handling_sub_connection_inches?: any | null, bypass_connection_inches?: any | null, material_type?: string | null, weight_pounds?: any | null, manufacturer?: string | null };

export type YToolBaseListQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Y_Tools_Bool_Exp>;
  order_by?: InputMaybe<Array<Y_Tools_Order_By>>;
}>;


export type YToolBaseListQuery = { __typename: 'query_root', y_tools: Array<{ __typename: 'y_tools', id: any, minimum_inches?: any | null, maximum_inches?: any | null, length_inches?: any | null, width_inches?: any | null, series_model?: string | null, outer_diameter_inches?: any | null, teleswivel_stroke_length_inches?: any | null, pressure_rating_psi?: number | null, temperature_rating_fahrenheit?: number | null, handling_sub_connection_inches?: any | null, bypass_connection_inches?: any | null, material_type?: string | null, weight_pounds?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, manufacturer?: string | null }>, y_tools_aggregate: { __typename: 'y_tools_aggregate', aggregate?: { __typename: 'y_tools_aggregate_fields', count: number } | null } };

export type YToolsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Y_Tools_Bool_Exp>;
  order_by?: InputMaybe<Array<Y_Tools_Order_By>>;
}>;


export type YToolsQuery = { __typename: 'query_root', y_tools: Array<{ __typename: 'y_tools', id: any, author_id: string, created_at: any, deleted_at?: any | null, updated_at: any, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, minimum_inches?: any | null, maximum_inches?: any | null, length_inches?: any | null, width_inches?: any | null, series_model?: string | null, outer_diameter_inches?: any | null, teleswivel_stroke_length_inches?: any | null, pressure_rating_psi?: number | null, temperature_rating_fahrenheit?: number | null, handling_sub_connection_inches?: any | null, bypass_connection_inches?: any | null, material_type?: string | null, weight_pounds?: any | null, manufacturer?: string | null }>, y_tools_aggregate: { __typename: 'y_tools_aggregate', id: 'y_tools_aggregate', aggregate?: { __typename: 'y_tools_aggregate_fields', count: number, id: 'y_tools_aggregate_fields' } | null } };

export type YToolByPkQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type YToolByPkQuery = { __typename: 'query_root', y_tools_by_pk?: { __typename: 'y_tools', id: any, author_id: string, created_at: any, deleted_at?: any | null, updated_at: any, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, minimum_inches?: any | null, maximum_inches?: any | null, length_inches?: any | null, width_inches?: any | null, series_model?: string | null, outer_diameter_inches?: any | null, teleswivel_stroke_length_inches?: any | null, pressure_rating_psi?: number | null, temperature_rating_fahrenheit?: number | null, handling_sub_connection_inches?: any | null, bypass_connection_inches?: any | null, material_type?: string | null, weight_pounds?: any | null, manufacturer?: string | null } | null };

export type DeleteYToolsMutationVariables = Exact<{
  where: Y_Tools_Bool_Exp;
}>;


export type DeleteYToolsMutation = { __typename: 'mutation_root', update_y_tools?: { __typename: 'y_tools_mutation_response', returning: Array<{ __typename: 'y_tools', id: any }> } | null };

export type RestoreYToolsMutationVariables = Exact<{
  where: Y_Tools_Bool_Exp;
}>;


export type RestoreYToolsMutation = { __typename: 'mutation_root', update_y_tools?: { __typename: 'y_tools_mutation_response', returning: Array<{ __typename: 'y_tools', id: any }> } | null };

export type InsertYToolMutationVariables = Exact<{
  object: Y_Tools_Insert_Input;
}>;


export type InsertYToolMutation = { __typename: 'mutation_root', insert_y_tools_one?: { __typename: 'y_tools', id: any, author_id: string, created_at: any, deleted_at?: any | null, updated_at: any, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, minimum_inches?: any | null, maximum_inches?: any | null, length_inches?: any | null, width_inches?: any | null, series_model?: string | null, outer_diameter_inches?: any | null, teleswivel_stroke_length_inches?: any | null, pressure_rating_psi?: number | null, temperature_rating_fahrenheit?: number | null, handling_sub_connection_inches?: any | null, bypass_connection_inches?: any | null, material_type?: string | null, weight_pounds?: any | null, manufacturer?: string | null } | null };

export type UpdateYToolByPkMutationVariables = Exact<{
  object?: InputMaybe<Y_Tools_Set_Input>;
  id: Scalars['uuid']['input'];
}>;


export type UpdateYToolByPkMutation = { __typename: 'mutation_root', update_y_tools_by_pk?: { __typename: 'y_tools', id: any, author_id: string, created_at: any, deleted_at?: any | null, updated_at: any, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, minimum_inches?: any | null, maximum_inches?: any | null, length_inches?: any | null, width_inches?: any | null, series_model?: string | null, outer_diameter_inches?: any | null, teleswivel_stroke_length_inches?: any | null, pressure_rating_psi?: number | null, temperature_rating_fahrenheit?: number | null, handling_sub_connection_inches?: any | null, bypass_connection_inches?: any | null, material_type?: string | null, weight_pounds?: any | null, manufacturer?: string | null } | null };

export type YToolSubSubscriptionVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Y_Tools_Bool_Exp>;
  order_by?: InputMaybe<Array<Y_Tools_Order_By>>;
}>;


export type YToolSubSubscription = { __typename: 'subscription_root', y_tools: Array<{ __typename: 'y_tools', id: any, author_id: string, created_at: any, deleted_at?: any | null, updated_at: any, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, minimum_inches?: any | null, maximum_inches?: any | null, length_inches?: any | null, width_inches?: any | null, series_model?: string | null, outer_diameter_inches?: any | null, teleswivel_stroke_length_inches?: any | null, pressure_rating_psi?: number | null, temperature_rating_fahrenheit?: number | null, handling_sub_connection_inches?: any | null, bypass_connection_inches?: any | null, material_type?: string | null, weight_pounds?: any | null, manufacturer?: string | null }> };

export type ErpCustomersQueryVariables = Exact<{
  name: Scalars['String']['input'];
  customer_erp_id: Scalars['String']['input'];
  is_customer?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ErpCustomersQuery = { __typename: 'query_root', getERPCustomers?: Array<{ __typename: 'ERPCustomer', customer_name?: string | null, customer_erp_id?: string | null } | null> | null };

export type ErpWellAddressesQueryVariables = Exact<{
  well_name: Scalars['String']['input'];
  customer_erp_id: Scalars['String']['input'];
  is_customer?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ErpWellAddressesQuery = { __typename: 'query_root', getERPWellAddresses?: Array<{ __typename: 'ERPWellAddress', customer_erp_id?: string | null, address_erp_id?: string | null, customer_name?: string | null, well_erp_id?: string | null, well_name?: string | null, well_uwi?: string | null } | null> | null };

export type ErpWellReadingsFragmentFragment = { __typename: 'ErpWellReadings', id?: string | null, reading_date?: any | null, motor_current?: number | null, motor_frequency?: number | null, pump_intake_pressure?: number | null, fluid_temperature?: number | null, tubing_pressure?: number | null, casing_pressure?: number | null, produced_oil_rate?: number | null, produced_gas_rate?: number | null, produced_water_rate?: number | null };

export type ErpWellReadingsQueryVariables = Exact<{
  id: Scalars['String']['input'];
  id_type: ErpWellReadingsIdType;
}>;


export type ErpWellReadingsQuery = { __typename: 'query_root', getErpWellReadings?: Array<{ __typename: 'ErpWellReadings', id?: string | null, reading_date?: any | null, motor_current?: number | null, motor_frequency?: number | null, pump_intake_pressure?: number | null, fluid_temperature?: number | null, tubing_pressure?: number | null, casing_pressure?: number | null, produced_oil_rate?: number | null, produced_gas_rate?: number | null, produced_water_rate?: number | null } | null> | null };

export type EulaFieldsFragment = { __typename: 'eula', id: any, activated: boolean, activated_on?: any | null, updated_at: any, created_at: any, license: string, version?: string | null };

export type GetActivatedEulaQueryVariables = Exact<{ [key: string]: never; }>;


export type GetActivatedEulaQuery = { __typename: 'query_root', eula: Array<{ __typename: 'eula', id: any, activated: boolean, activated_on?: any | null, updated_at: any, created_at: any, license: string, version?: string | null }> };

export type EulasSubSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type EulasSubSubscription = { __typename: 'subscription_root', eula: Array<{ __typename: 'eula', id: any, activated: boolean, activated_on?: any | null, updated_at: any, created_at: any, license: string, version?: string | null }> };

export type InsertEulaMutationVariables = Exact<{
  license: Scalars['String']['input'];
  activated: Scalars['Boolean']['input'];
}>;


export type InsertEulaMutation = { __typename: 'mutation_root', insert_eula_one?: { __typename: 'eula', id: any, activated: boolean, activated_on?: any | null, updated_at: any, created_at: any, license: string, version?: string | null } | null };

export type UpdateEulaLicenseMutationVariables = Exact<{
  eulaId: Scalars['uuid']['input'];
  license: Scalars['String']['input'];
}>;


export type UpdateEulaLicenseMutation = { __typename: 'mutation_root', update_eula?: { __typename: 'eula_mutation_response', returning: Array<{ __typename: 'eula', id: any, activated: boolean, activated_on?: any | null, updated_at: any, created_at: any, license: string, version?: string | null }> } | null };

export type ActivateEulaMutationVariables = Exact<{
  eulaId: Scalars['uuid']['input'];
}>;


export type ActivateEulaMutation = { __typename: 'mutation_root', deactivateEULAs?: { __typename: 'eula_mutation_response', returning: Array<{ __typename: 'eula', id: any, activated: boolean, activated_on?: any | null, updated_at: any, created_at: any, license: string, version?: string | null }> } | null, activateEULA?: { __typename: 'eula_mutation_response', returning: Array<{ __typename: 'eula', id: any, activated: boolean, activated_on?: any | null, updated_at: any, created_at: any, license: string, version?: string | null }> } | null };

export type DeactivateEulaMutationVariables = Exact<{
  eulaId: Scalars['uuid']['input'];
}>;


export type DeactivateEulaMutation = { __typename: 'mutation_root', deactivateEULAs?: { __typename: 'eula_mutation_response', returning: Array<{ __typename: 'eula', id: any, activated: boolean, activated_on?: any | null, updated_at: any, created_at: any, license: string, version?: string | null }> } | null };

export type FlowModelFieldsFragment = { __typename: 'flow_model_active', comment?: string | null, value?: string | null, id?: string | null };

export type FlowModelQueryVariables = Exact<{ [key: string]: never; }>;


export type FlowModelQuery = { __typename: 'query_root', flow_model_active: Array<{ __typename: 'flow_model_active', comment?: string | null, value?: string | null, id?: string | null }> };

export type HpsLiquidTypeFieldsFragment = { __typename: 'hps_liquid_type', comment?: string | null, value: string, id: string };

export type HpsLiquidTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type HpsLiquidTypesQuery = { __typename: 'query_root', hps_liquid_type: Array<{ __typename: 'hps_liquid_type', comment?: string | null, value: string, id: string }> };

export type OverrideOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type OverrideOptionsQuery = { __typename: 'query_root', override_options: Array<{ __typename: 'override_options', value: string, comment?: string | null, id: string }> };

export type PerformanceEvaluationAllFieldsFragment = { __typename: 'performance_evaluations', id?: any | null, title?: string | null, pump_hz?: any | null, water_rate_std_barrel_day?: any | null, gas_rate_mscf_day?: any | null, oil_rate_std_barrel_day?: any | null, tubing_pressure_psia?: any | null, casing_pressure_psia?: any | null, pump_intake_pressure_psia?: any | null, pump_wear_head_correction_ratio?: any | null, pump_wear_brake_horsepower_correction_ratio?: any | null, intake_override_gas_separation_percent?: any | null, intake_gas_separation_override_type?: string | null, natural_override_gas_separation_percent?: any | null, natural_gas_separation_override_type?: string | null, journal_author_id?: string | null, journal_created_at?: any | null, journal_deleted_at?: any | null, journal_updated_at?: any | null, winning_revision_id?: any | null, scenario_id?: any | null, parent_id?: any | null };

export type PerformanceEvaluationMetaFieldsFragment = { __typename: 'performance_evaluations', journal_author_id?: string | null, journal_created_at?: any | null, journal_deleted_at?: any | null, journal_updated_at?: any | null, winning_revision_id?: any | null, scenario_id?: any | null, parent_id?: any | null };

export type PerformanceEvaluationBaseFieldsFragment = { __typename: 'performance_evaluations', id?: any | null, title?: string | null, pump_hz?: any | null, water_rate_std_barrel_day?: any | null, gas_rate_mscf_day?: any | null, oil_rate_std_barrel_day?: any | null, tubing_pressure_psia?: any | null, casing_pressure_psia?: any | null, pump_intake_pressure_psia?: any | null, pump_wear_head_correction_ratio?: any | null, pump_wear_brake_horsepower_correction_ratio?: any | null, intake_override_gas_separation_percent?: any | null, intake_gas_separation_override_type?: string | null, natural_override_gas_separation_percent?: any | null, natural_gas_separation_override_type?: string | null };

export type PerformanceEvaluationXrefPumpFieldsFragment = { __typename: 'performance_evaluations_xref_pumps', id?: any | null, journal_author_id?: string | null, journal_created_at?: any | null, journal_deleted_at?: any | null, journal_updated_at?: any | null, winning_revision_id?: any | null, xref_pump_id?: any | null, performance_evaluation_id?: any | null, rate_correction_ratio?: any | null, head_correction_ratio?: any | null, brake_horsepower_correction_ratio?: any | null };

export type PerformanceEvaluationsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Performance_Evaluations_Bool_Exp>;
  order_by?: InputMaybe<Array<Performance_Evaluations_Order_By>>;
  withAggregate?: Scalars['Boolean']['input'];
}>;


export type PerformanceEvaluationsQuery = { __typename: 'query_root', performance_evaluations: Array<{ __typename: 'performance_evaluations', id?: any | null, title?: string | null, pump_hz?: any | null, water_rate_std_barrel_day?: any | null, gas_rate_mscf_day?: any | null, oil_rate_std_barrel_day?: any | null, tubing_pressure_psia?: any | null, casing_pressure_psia?: any | null, pump_intake_pressure_psia?: any | null, pump_wear_head_correction_ratio?: any | null, pump_wear_brake_horsepower_correction_ratio?: any | null, intake_override_gas_separation_percent?: any | null, intake_gas_separation_override_type?: string | null, natural_override_gas_separation_percent?: any | null, natural_gas_separation_override_type?: string | null, journal_author_id?: string | null, journal_created_at?: any | null, journal_deleted_at?: any | null, journal_updated_at?: any | null, winning_revision_id?: any | null, scenario_id?: any | null, parent_id?: any | null, r_scenario?: { __typename: 'scenarios', id?: any | null, sizing_id?: any | null, journal_author_id?: string | null, journal_deleted_at?: any | null, well_properties_id?: any | null, scenario_equipment_id?: any | null, parameters_id?: any | null, correlations_id?: any | null, title?: string | null, pumping_type?: string | null, sizing?: { __typename: 'sizings', id?: any | null, journal_author_id?: string | null, journal_deleted_at?: any | null, well_id?: number | null, customer_id?: number | null, title?: string | null, notes?: string | null, well?: { __typename: 'wells', id: number, well_name?: string | null, well_uwi?: string | null, well_erp_id?: string | null, address_erp_id?: string | null } | null, customer?: { __typename: 'customers', id: number, customer_name?: string | null, customer_erp_id: string, imported_sizing_id?: number | null } | null } | null } | null, r_author?: { __typename: 'users', id: string, email?: string | null, username?: string | null, display_name?: string | null, hal_identifier?: string | null } | null, r_xref_pumps: Array<{ __typename: 'performance_evaluations_xref_pumps', id?: any | null, journal_author_id?: string | null, journal_created_at?: any | null, journal_deleted_at?: any | null, journal_updated_at?: any | null, winning_revision_id?: any | null, xref_pump_id?: any | null, performance_evaluation_id?: any | null, rate_correction_ratio?: any | null, head_correction_ratio?: any | null, brake_horsepower_correction_ratio?: any | null }> }>, performance_evaluations_aggregate?: { __typename: 'performance_evaluations_aggregate', id: 'performance_evaluations_aggregate', aggregate?: { __typename: 'performance_evaluations_aggregate_fields', count: number, id: 'performance_evaluations_aggregate_fields' } | null } };

export type InsertPerformanceEvaluationRevisionMutationVariables = Exact<{
  update_performance_evaluations?: InputMaybe<Scalars['Boolean']['input']>;
  update_pumps?: InputMaybe<Scalars['Boolean']['input']>;
  performance_evaluations_revisions: Array<Revisions_Performance_Evaluations_Revisions_Insert_Input>;
  performance_evaluations_xref_pumps_revisions: Array<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Insert_Input>;
}>;


export type InsertPerformanceEvaluationRevisionMutation = { __typename: 'mutation_root', insert_revisions_performance_evaluations_revisions?: { __typename: 'revisions_performance_evaluations_revisions_mutation_response', affected_rows: number, returning: Array<{ __typename: 'revisions_performance_evaluations_revisions', id: any, performance_evaluations_view?: { __typename: 'performance_evaluations', id?: any | null, title?: string | null, pump_hz?: any | null, water_rate_std_barrel_day?: any | null, gas_rate_mscf_day?: any | null, oil_rate_std_barrel_day?: any | null, tubing_pressure_psia?: any | null, casing_pressure_psia?: any | null, pump_intake_pressure_psia?: any | null, pump_wear_head_correction_ratio?: any | null, pump_wear_brake_horsepower_correction_ratio?: any | null, intake_override_gas_separation_percent?: any | null, intake_gas_separation_override_type?: string | null, natural_override_gas_separation_percent?: any | null, natural_gas_separation_override_type?: string | null, journal_author_id?: string | null, journal_created_at?: any | null, journal_deleted_at?: any | null, journal_updated_at?: any | null, winning_revision_id?: any | null, scenario_id?: any | null, parent_id?: any | null } | null }> } | null, insert_revisions_performance_evaluations_xref_pumps_revisions?: { __typename: 'revisions_performance_evaluations_xref_pumps_revisions_mutation_response', affected_rows: number, returning: Array<{ __typename: 'revisions_performance_evaluations_xref_pumps_revisions', id: any, performance_evaluations_xref_pumps_view?: { __typename: 'performance_evaluations_xref_pumps', id?: any | null, xref_pump_id?: any | null, performance_evaluation_id?: any | null, rate_correction_ratio?: any | null, head_correction_ratio?: any | null, brake_horsepower_correction_ratio?: any | null, parent_id?: any | null, journal_author_id?: string | null, journal_created_at?: any | null, journal_updated_at?: any | null, journal_deleted_at?: any | null, winning_revision_id?: any | null, winning_revision_parent_id?: any | null, winning_revision_author_id?: string | null, winning_revision_created_at?: any | null, winning_revision_updated_at?: any | null, winning_revision_deleted_at?: any | null } | null }> } | null };

export type PerformanceEvaluationPumpsFieldsFragment = { __typename: 'performance_evaluations_xref_pumps', id?: any | null, xref_pump_id?: any | null, performance_evaluation_id?: any | null, rate_correction_ratio?: any | null, head_correction_ratio?: any | null, brake_horsepower_correction_ratio?: any | null, parent_id?: any | null, journal_author_id?: string | null, journal_created_at?: any | null, journal_updated_at?: any | null, journal_deleted_at?: any | null, winning_revision_id?: any | null, winning_revision_parent_id?: any | null, winning_revision_author_id?: string | null, winning_revision_created_at?: any | null, winning_revision_updated_at?: any | null, winning_revision_deleted_at?: any | null };

export type PerformanceEvaluationXrefPumpsQueryVariables = Exact<{
  distinct_on?: InputMaybe<Array<Performance_Evaluations_Xref_Pumps_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Performance_Evaluations_Xref_Pumps_Order_By>>;
  where?: InputMaybe<Performance_Evaluations_Xref_Pumps_Bool_Exp>;
}>;


export type PerformanceEvaluationXrefPumpsQuery = { __typename: 'query_root', performance_evaluations_xref_pumps: Array<{ __typename: 'performance_evaluations_xref_pumps', id?: any | null, xref_pump_id?: any | null, performance_evaluation_id?: any | null, rate_correction_ratio?: any | null, head_correction_ratio?: any | null, brake_horsepower_correction_ratio?: any | null, parent_id?: any | null, journal_author_id?: string | null, journal_created_at?: any | null, journal_updated_at?: any | null, journal_deleted_at?: any | null, winning_revision_id?: any | null, winning_revision_parent_id?: any | null, winning_revision_author_id?: string | null, winning_revision_created_at?: any | null, winning_revision_updated_at?: any | null, winning_revision_deleted_at?: any | null }> };

export type QuoteEnumsQueryVariables = Exact<{ [key: string]: never; }>;


export type QuoteEnumsQuery = { __typename: 'query_root', quote_line_item_category_dataset: Array<{ __typename: 'quote_line_item_category_dataset', comment?: string | null, value: string, id: string }>, quote_line_item_subcategory_dataset: Array<{ __typename: 'quote_line_item_subcategory_dataset', comment?: string | null, value: string, id: string }>, quote_line_item_type_dataset: Array<{ __typename: 'quote_line_item_type_dataset', comment?: string | null, value: string, id: string }>, quote_sk_job_type_dataset: Array<{ __typename: 'quote_sk_job_type_dataset', comment?: string | null, value: string, id: string }>, quote_status_dataset: Array<{ __typename: 'quote_status_dataset', comment?: string | null, value: string, id: string }>, override_options: Array<{ __typename: 'override_options', value: string, comment?: string | null, id: string }> };

export type QuoteLineItemCategoryDatasetFieldsFragment = { __typename: 'quote_line_item_category_dataset', comment?: string | null, value: string, id: string };

export type GetQuoteLineItemCategoryDatasetQueryVariables = Exact<{ [key: string]: never; }>;


export type GetQuoteLineItemCategoryDatasetQuery = { __typename: 'query_root', quote_line_item_category_dataset: Array<{ __typename: 'quote_line_item_category_dataset', comment?: string | null, value: string, id: string }> };

export type QuoteLineItemSubcategoryDatasetFieldsFragment = { __typename: 'quote_line_item_subcategory_dataset', comment?: string | null, value: string, id: string };

export type GetQuoteLineItemSubcategoryDatasetQueryVariables = Exact<{ [key: string]: never; }>;


export type GetQuoteLineItemSubcategoryDatasetQuery = { __typename: 'query_root', quote_line_item_subcategory_dataset: Array<{ __typename: 'quote_line_item_subcategory_dataset', comment?: string | null, value: string, id: string }> };

export type QuoteLineItemTypeDatasetFieldsFragment = { __typename: 'quote_line_item_type_dataset', comment?: string | null, value: string, id: string };

export type GetQuoteLineItemTypeDatasetQueryVariables = Exact<{ [key: string]: never; }>;


export type GetQuoteLineItemTypeDatasetQuery = { __typename: 'query_root', quote_line_item_type_dataset: Array<{ __typename: 'quote_line_item_type_dataset', comment?: string | null, value: string, id: string }> };

export type QuoteSkJobTypeDatasetFieldsFragment = { __typename: 'quote_sk_job_type_dataset', comment?: string | null, value: string, id: string };

export type GetQuoteSkJobTypeDatasetQueryVariables = Exact<{ [key: string]: never; }>;


export type GetQuoteSkJobTypeDatasetQuery = { __typename: 'query_root', quote_sk_job_type_dataset: Array<{ __typename: 'quote_sk_job_type_dataset', comment?: string | null, value: string, id: string }> };

export type QuoteStatusDatasetFieldsFragment = { __typename: 'quote_status_dataset', comment?: string | null, value: string, id: string };

export type GetQuoteStatusDatasetQueryVariables = Exact<{ [key: string]: never; }>;


export type GetQuoteStatusDatasetQuery = { __typename: 'query_root', quote_status_dataset: Array<{ __typename: 'quote_status_dataset', comment?: string | null, value: string, id: string }> };

export type QuoteUserMessagesFieldsFragment = { __typename: 'quote_user_messages', author_id?: string | null, created_at: any, deleted_at?: any | null, id: any, message?: string | null, title?: string | null, updated_at: any, created_by?: { __typename: 'users', username?: string | null, display_name?: string | null, email?: string | null, hal_identifier?: string | null, id: string } | null };

export type GetQuoteUserMessagesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetQuoteUserMessagesQuery = { __typename: 'query_root', quote_user_messages: Array<{ __typename: 'quote_user_messages', author_id?: string | null, created_at: any, deleted_at?: any | null, id: any, message?: string | null, title?: string | null, updated_at: any, created_by?: { __typename: 'users', username?: string | null, display_name?: string | null, email?: string | null, hal_identifier?: string | null, id: string } | null }> };

export type QuoteFieldsFragment = { __typename: 'quotes', comments?: string | null, created_at: any, currency?: string | null, customer_rep_name?: string | null, customer_rep_email?: string | null, customer_rep_phone_number?: string | null, deleted_at?: any | null, directions?: string | null, erp_contract_number?: string | null, erp_customer_name?: string | null, erp_customer_number?: string | null, erp_nwa_id?: string | null, erp_nwa_name?: string | null, erp_plant_id?: string | null, erp_plant_name?: string | null, erp_price_list_name?: string | null, erp_price_list_number?: string | null, erp_well_country?: string | null, erp_well_id?: string | null, erp_well_name?: string | null, erp_well_uwi?: string | null, erp_well_region?: string | null, erp_address_id?: string | null, erp_address_name?: string | null, erp_full_address?: string | null, id: any, name?: string | null, note?: string | null, prepared_by_id?: string | null, pricing_date?: any | null, proposed_start_date?: any | null, sk_job_id?: number | null, sk_job_number?: string | null, sk_job_type?: Quote_Sk_Job_Type_Dataset_Enum | null, sk_planning_order?: string | null, sk_proposal_number?: string | null, source?: Quote_Source_Dataset_Enum | null, spyglass_scenario_id?: any | null, spyglass_scenario_import_json?: any | null, status: Quote_Status_Dataset_Enum, updated_at: any, version_number?: number | null, error_log_json?: any | null, quote_line_items: Array<{ __typename: 'quote_line_items', category?: Quote_Line_Item_Category_Dataset_Enum | null, created_at: any, credit?: any | null, erp_material_long_description?: string | null, erp_material_number?: string | null, erp_material_short_description?: string | null, erp_price?: any | null, erp_serialized?: Quote_Line_Item_Serialized_Dataset_Enum | null, price_override?: any | null, erp_product_hierarchy?: string | null, erp_uom?: string | null, id: any, line_item_type?: Quote_Line_Item_Type_Dataset_Enum | null, margin?: any | null, note?: string | null, parent_order?: number | null, pricing_date?: any | null, quantity?: number | null, source?: Quote_Line_Item_Source_Dataset_Enum | null, subcategory?: Quote_Line_Item_Subcategory_Dataset_Enum | null, sub_order?: number | null, tax_type?: Quote_Line_Item_Tax_Type_Dataset_Enum | null, updated_at: any, spyglass_equipment_import_json?: any | null, cable?: { __typename: 'cables', id: any } | null, intake?: { __typename: 'intakes', id: any } | null, motor?: { __typename: 'motors', id: any } | null, motor_lead_extension?: { __typename: 'motor_lead_extensions', id: any } | null, pump?: { __typename: 'pumps', id: any } | null, seal?: { __typename: 'seals', id: any } | null, sensor?: { __typename: 'sensors', id: any } | null, step_down_transformer?: { __typename: 'step_down_transformers', id: any } | null, step_up_transformer?: { __typename: 'step_up_transformers', id: any } | null, switchboard?: { __typename: 'switchboards', id: any } | null, variable_speed_drive?: { __typename: 'variable_speed_drives', id: any } | null }> };

export type AllQuoteFieldsFragment = { __typename: 'quotes', comments?: string | null, created_at: any, currency?: string | null, customer_rep_name?: string | null, customer_rep_email?: string | null, customer_rep_phone_number?: string | null, deleted_at?: any | null, directions?: string | null, erp_contract_number?: string | null, erp_customer_name?: string | null, erp_customer_number?: string | null, erp_nwa_id?: string | null, erp_nwa_name?: string | null, erp_plant_id?: string | null, erp_plant_name?: string | null, erp_price_list_name?: string | null, erp_price_list_number?: string | null, erp_well_country?: string | null, erp_well_id?: string | null, erp_well_name?: string | null, erp_well_uwi?: string | null, erp_well_region?: string | null, erp_address_id?: string | null, erp_address_name?: string | null, erp_full_address?: string | null, id: any, name?: string | null, note?: string | null, prepared_by_id?: string | null, pricing_date?: any | null, proposed_start_date?: any | null, sk_job_id?: number | null, sk_job_number?: string | null, sk_job_type?: Quote_Sk_Job_Type_Dataset_Enum | null, sk_planning_order?: string | null, sk_proposal_number?: string | null, source?: Quote_Source_Dataset_Enum | null, spyglass_scenario_id?: any | null, spyglass_scenario_import_json?: any | null, status: Quote_Status_Dataset_Enum, updated_at: any, version_number?: number | null, error_log_json?: any | null, parent?: { __typename: 'quotes', id: any, name?: string | null, version_number?: number | null } | null, quote_line_items: Array<{ __typename: 'quote_line_items', category?: Quote_Line_Item_Category_Dataset_Enum | null, created_at: any, credit?: any | null, erp_material_long_description?: string | null, erp_material_number?: string | null, erp_material_short_description?: string | null, erp_price?: any | null, erp_serialized?: Quote_Line_Item_Serialized_Dataset_Enum | null, price_override?: any | null, erp_product_hierarchy?: string | null, erp_uom?: string | null, id: any, line_item_type?: Quote_Line_Item_Type_Dataset_Enum | null, margin?: any | null, note?: string | null, parent_order?: number | null, pricing_date?: any | null, quantity?: number | null, source?: Quote_Line_Item_Source_Dataset_Enum | null, subcategory?: Quote_Line_Item_Subcategory_Dataset_Enum | null, sub_order?: number | null, tax_type?: Quote_Line_Item_Tax_Type_Dataset_Enum | null, updated_at: any, spyglass_equipment_import_json?: any | null, quote_id: any, deleted_at?: any | null, cable?: { __typename: 'cables', id: any, amp_factor?: any | null, armor?: string | null, construction?: string | null, depth_inches?: any | null, family?: string | null, gauge?: string | null, kv?: number | null, manufacturer?: string | null, max_temperature_fahrenheit?: number | null, part_number?: string | null, pound_per_foot?: any | null, width_inches?: any | null, impedance_60_hz_per_1000_ft?: any | null, resistance_per_1000_ft?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, author_id: string, created_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, updated_at: any } | null, intake?: { __typename: 'intakes', id: any, manufacturer?: string | null, intake_type?: string | null, part_number?: string | null, configuration?: string | null, length_inches?: any | null, weight_pounds?: any | null, shaft_material?: string | null, shaft_limit_hp?: number | null, housing_material?: string | null, max_rate_bpd?: number | null, hp?: any | null, eff1?: any | null, eff2?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, high_strength_shaft_limit_hp?: number | null, stage_count?: number | null, bhp0?: any | null, bhp1?: any | null, bhp2?: any | null, bhp3?: any | null, bhp4?: any | null, bhp5?: any | null, bolt_on?: boolean | null, port_area_square_inches: any, inner_diameter_inches?: any | null, outer_diameter_inches?: any | null, neck_inner_diameter_inches?: any | null, neck_outer_diameter_inches?: any | null, is_hps: boolean, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null } | null, motor?: { __typename: 'motors', id: any, author_id: string, allow_rerate: boolean, configuration?: string | null, created_at: any, deleted_at?: any | null, eff1?: any | null, eff2?: any | null, eff3?: any | null, eff4?: any | null, eff5?: any | null, effb?: any | null, i1?: any | null, i2?: any | null, i3?: any | null, i4?: any | null, i5?: any | null, ib?: any | null, imported_sizing_id?: number | null, length_inches?: any | null, manufacturer?: string | null, n1?: any | null, n2?: any | null, n3?: any | null, n4?: any | null, n5?: any | null, nameplate_current?: number | null, nameplate_horsepower?: number | null, nameplate_voltage?: number | null, nb?: any | null, oil_volume_gallons?: any | null, part_number?: string | null, pf1?: any | null, pf2?: any | null, pf3?: any | null, pf4?: any | null, pf5?: any | null, pfb?: any | null, rr_l1?: any | null, rr_l2?: any | null, rr_lb?: any | null, rr_v3: any, rr_v2: any, rr_v1?: any | null, rr_vb?: any | null, shaft_horsepower?: number | null, nv0: any, nv1: any, nv2: any, iv0: any, iv1: any, iv2: any, pfv0: any, pfv1: any, pfv2: any, effv0: any, effv1: any, effv2: any, tv0: any, tv1: any, tv2: any, temperature_rating_fahrenheit?: number | null, updated_at: any, weight_pounds?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, poles?: number | null, stator_inner_diameter_inches?: any | null, stator_outer_diameter_inches?: any | null, k3?: any | null, nameplate_rerate_ratio?: any | null, inner_diameter_inches?: any | null, outer_diameter_inches?: any | null, neck_inner_diameter_inches?: any | null, neck_outer_diameter_inches?: any | null, mle_offset_depth_inches: any, outer_diameter_rub_inches: any, is_hps: boolean } | null, motor_lead_extension?: { __typename: 'motor_lead_extensions', id: any, manufacturer?: string | null, part_number?: string | null, series?: number | null, family?: string | null, gauge?: number | null, kv?: number | null, max_pothead_temperature_fahrenheit?: number | null, max_temperature_fahrenheit?: number | null, resistance_per_1000_ft?: any | null, impedance_60_hz_per_1000_ft?: any | null, amp_factor?: any | null, width_inches?: any | null, depth_inches?: any | null, pound_per_foot?: any | null, length_feet?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null } | null, pump?: { __typename: 'pumps', id: any, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, manufacturer?: string | null, rotation?: string | null, part_number?: string | null, compression_thrust_per_stage?: any | null, series_model?: string | null, stage_type?: number | null, shaft_diameter_inches?: any | null, standard_housing_pressure_rating_psi?: number | null, high_strength_housing_pressure_rating_psi?: number | null, standard_shaft_rating_hp?: number | null, high_strength_shaft_rating_hp?: number | null, construction?: string | null, min_rate_standard_pump_bpd?: number | null, bep_rate_standard_pump_bpd?: number | null, max_rate_standard_pump_bpd?: number | null, max_graph_rate_standard_pump_bpd?: number | null, hb?: any | null, h1?: any | null, h2?: any | null, h3?: any | null, h4?: any | null, h5?: any | null, bhpb?: any | null, bhp1?: any | null, bhp2?: any | null, bhp3?: any | null, bhp4?: any | null, bhp5?: any | null, npsh1?: any | null, npsh2?: any | null, npsh3?: any | null, npsh4?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, max_bolt_load_pounds?: any | null, is_compression_pump: boolean, housing_inner_diameter_inches?: any | null, housing_outer_diameter_inches?: any | null, neck_inner_diameter_inches?: any | null, neck_outer_diameter_inches?: any | null } | null, seal?: { __typename: 'seals', id: any, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, manufacturer?: string | null, part_number?: string | null, length_inches?: any | null, weight_pounds?: any | null, configuration?: string | null, max_temperature_fahrenheit?: number | null, standard_shaft_limit_hp?: number | null, high_strength_shaft_limit_hp?: number | null, standard_bearing_rating_pounds?: number | null, high_strength_bearing_rating_pounds?: number | null, housing_material?: string | null, bearing_type?: string | null, total_seal_volume_gallons?: any | null, volume_for_bag_expansion_lower_tandem_gallons?: any | null, volume_for_bag_expansion_upper_tandem_gallons?: any | null, upper_chamber_pull_volume_gallons?: any | null, bag_chambers?: number | null, bag_capacity_gallons?: any | null, string_load_pounds?: any | null, load_cb_pounds?: any | null, load_c1_pounds?: any | null, hps_thrust_chamber: boolean, load_test_temperature_fahrenheit?: number | null, description?: string | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, inner_diameter_inches?: any | null, outer_diameter_inches?: any | null, neck_inner_diameter_inches?: any | null, neck_outer_diameter_inches?: any | null, thrust_collar_inner_diameter_inches: any, thrust_collar_outer_diameter_inches: any } | null, sensor?: { __typename: 'sensors', id: any, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, manufacturer?: string | null, part_number?: string | null, length_inches?: number | null, weight_pounds?: number | null, model?: string | null, channels?: number | null, max_intake_temperature_fahrenheit?: number | null, max_intake_pressure_psi?: number | null, housing_material?: string | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, inner_diameter_inches?: any | null, outer_diameter_inches: any, neck_inner_diameter_inches?: any | null, neck_outer_diameter_inches?: any | null } | null, step_down_transformer?: { __typename: 'step_down_transformers', id: any, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, manufacturer?: string | null, part_number?: string | null, transformer_type?: string | null, primary_voltage_delta?: number | null, primary_voltage_wye?: number | null, min_secondary_voltage?: number | null, max_secondary_voltage?: number | null, weight_pounds?: number | null, enclosure?: string | null, kva?: number | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null } | null, step_up_transformer?: { __typename: 'step_up_transformers', id: any, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, manufacturer?: string | null, part_number?: string | null, transformer_type?: string | null, primary_voltage?: number | null, min_secondary_voltage?: number | null, max_secondary_voltage?: number | null, weight_pounds?: number | null, enclosure?: string | null, kva?: number | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null } | null, switchboard?: { __typename: 'switchboards', id: any, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, amps?: number | null, enclosure?: string | null, kv?: any | null, manufacturer?: string | null, part_number?: string | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null } | null, variable_speed_drive?: { __typename: 'variable_speed_drives', id: any, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, enclosure?: string | null, kva?: number | null, manufacturer?: string | null, max_amps?: number | null, part_number?: string | null, vsd_type?: string | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null } | null }>, quote_scenario?: { __typename: 'scenarios', id?: any | null, journal_author_id?: string | null, journal_created_at?: any | null, journal_updated_at?: any | null, journal_deleted_at?: any | null, winning_revision_id?: any | null, title?: string | null, notes?: string | null, internal_notes?: string | null, reason?: string | null, sizing_id?: any | null, well_properties_id?: any | null, scenario_equipment_id?: any | null, parameters_id?: any | null, correlations_id?: any | null, display_unit_overrides?: any | null, pumping_type?: string | null, author?: { __typename: 'users', id: string, email?: string | null, username?: string | null, display_name?: string | null, hal_identifier?: string | null } | null, sizing?: { __typename: 'sizings', id?: any | null, journal_author_id?: string | null, journal_deleted_at?: any | null, well_id?: number | null, customer_id?: number | null, title?: string | null, notes?: string | null, well?: { __typename: 'wells', id: number, well_name?: string | null, well_uwi?: string | null, well_erp_id?: string | null, address_erp_id?: string | null } | null, customer?: { __typename: 'customers', id: number, customer_name?: string | null, customer_erp_id: string, imported_sizing_id?: number | null } | null } | null } | null, user?: { __typename: 'users', id: string, email?: string | null, username?: string | null, display_name?: string | null, hal_identifier?: string | null } | null };

export type AllQuotePriceHistoryFieldsFragment = { __typename: 'quotes', id: any, erp_customer_name?: string | null, updated_at: any, status: Quote_Status_Dataset_Enum, quote_line_items: Array<{ __typename: 'quote_line_items', erp_material_number?: string | null, price_override?: any | null, margin?: any | null, erp_price?: any | null }> };

export type AllQuoteFieldsWithoutLineItemsFragment = { __typename: 'quotes', created_at: any, deleted_at?: any | null, directions?: string | null, erp_contract_number?: string | null, erp_customer_name?: string | null, erp_customer_number?: string | null, erp_nwa_id?: string | null, erp_nwa_name?: string | null, erp_plant_id?: string | null, erp_plant_name?: string | null, erp_price_list_name?: string | null, erp_price_list_number?: string | null, erp_well_country?: string | null, erp_well_id?: string | null, erp_well_name?: string | null, erp_well_uwi?: string | null, erp_well_region?: string | null, erp_address_id?: string | null, erp_address_name?: string | null, erp_full_address?: string | null, id: any, name?: string | null, prepared_by_id?: string | null, pricing_date?: any | null, sk_job_id?: number | null, sk_job_number?: string | null, sk_job_type?: Quote_Sk_Job_Type_Dataset_Enum | null, sk_planning_order?: string | null, sk_proposal_number?: string | null, status: Quote_Status_Dataset_Enum, updated_at: any, version_number?: number | null, error_log_json?: any | null, parent?: { __typename: 'quotes', id: any, name?: string | null, version_number?: number | null } | null, user?: { __typename: 'users', id: string, email?: string | null, username?: string | null, display_name?: string | null, hal_identifier?: string | null } | null };

export type GetQuoteByPkQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetQuoteByPkQuery = { __typename: 'query_root', quotes_by_pk?: { __typename: 'quotes', comments?: string | null, created_at: any, currency?: string | null, customer_rep_name?: string | null, customer_rep_email?: string | null, customer_rep_phone_number?: string | null, deleted_at?: any | null, directions?: string | null, erp_contract_number?: string | null, erp_customer_name?: string | null, erp_customer_number?: string | null, erp_nwa_id?: string | null, erp_nwa_name?: string | null, erp_plant_id?: string | null, erp_plant_name?: string | null, erp_price_list_name?: string | null, erp_price_list_number?: string | null, erp_well_country?: string | null, erp_well_id?: string | null, erp_well_name?: string | null, erp_well_uwi?: string | null, erp_well_region?: string | null, erp_address_id?: string | null, erp_address_name?: string | null, erp_full_address?: string | null, id: any, name?: string | null, note?: string | null, prepared_by_id?: string | null, pricing_date?: any | null, proposed_start_date?: any | null, sk_job_id?: number | null, sk_job_number?: string | null, sk_job_type?: Quote_Sk_Job_Type_Dataset_Enum | null, sk_planning_order?: string | null, sk_proposal_number?: string | null, source?: Quote_Source_Dataset_Enum | null, spyglass_scenario_id?: any | null, spyglass_scenario_import_json?: any | null, status: Quote_Status_Dataset_Enum, updated_at: any, version_number?: number | null, error_log_json?: any | null, parent?: { __typename: 'quotes', id: any, name?: string | null, version_number?: number | null } | null, quote_line_items: Array<{ __typename: 'quote_line_items', category?: Quote_Line_Item_Category_Dataset_Enum | null, created_at: any, credit?: any | null, erp_material_long_description?: string | null, erp_material_number?: string | null, erp_material_short_description?: string | null, erp_price?: any | null, erp_serialized?: Quote_Line_Item_Serialized_Dataset_Enum | null, price_override?: any | null, erp_product_hierarchy?: string | null, erp_uom?: string | null, id: any, line_item_type?: Quote_Line_Item_Type_Dataset_Enum | null, margin?: any | null, note?: string | null, parent_order?: number | null, pricing_date?: any | null, quantity?: number | null, source?: Quote_Line_Item_Source_Dataset_Enum | null, subcategory?: Quote_Line_Item_Subcategory_Dataset_Enum | null, sub_order?: number | null, tax_type?: Quote_Line_Item_Tax_Type_Dataset_Enum | null, updated_at: any, spyglass_equipment_import_json?: any | null, quote_id: any, deleted_at?: any | null, cable?: { __typename: 'cables', id: any, amp_factor?: any | null, armor?: string | null, construction?: string | null, depth_inches?: any | null, family?: string | null, gauge?: string | null, kv?: number | null, manufacturer?: string | null, max_temperature_fahrenheit?: number | null, part_number?: string | null, pound_per_foot?: any | null, width_inches?: any | null, impedance_60_hz_per_1000_ft?: any | null, resistance_per_1000_ft?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, author_id: string, created_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, updated_at: any } | null, intake?: { __typename: 'intakes', id: any, manufacturer?: string | null, intake_type?: string | null, part_number?: string | null, configuration?: string | null, length_inches?: any | null, weight_pounds?: any | null, shaft_material?: string | null, shaft_limit_hp?: number | null, housing_material?: string | null, max_rate_bpd?: number | null, hp?: any | null, eff1?: any | null, eff2?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, high_strength_shaft_limit_hp?: number | null, stage_count?: number | null, bhp0?: any | null, bhp1?: any | null, bhp2?: any | null, bhp3?: any | null, bhp4?: any | null, bhp5?: any | null, bolt_on?: boolean | null, port_area_square_inches: any, inner_diameter_inches?: any | null, outer_diameter_inches?: any | null, neck_inner_diameter_inches?: any | null, neck_outer_diameter_inches?: any | null, is_hps: boolean, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null } | null, motor?: { __typename: 'motors', id: any, author_id: string, allow_rerate: boolean, configuration?: string | null, created_at: any, deleted_at?: any | null, eff1?: any | null, eff2?: any | null, eff3?: any | null, eff4?: any | null, eff5?: any | null, effb?: any | null, i1?: any | null, i2?: any | null, i3?: any | null, i4?: any | null, i5?: any | null, ib?: any | null, imported_sizing_id?: number | null, length_inches?: any | null, manufacturer?: string | null, n1?: any | null, n2?: any | null, n3?: any | null, n4?: any | null, n5?: any | null, nameplate_current?: number | null, nameplate_horsepower?: number | null, nameplate_voltage?: number | null, nb?: any | null, oil_volume_gallons?: any | null, part_number?: string | null, pf1?: any | null, pf2?: any | null, pf3?: any | null, pf4?: any | null, pf5?: any | null, pfb?: any | null, rr_l1?: any | null, rr_l2?: any | null, rr_lb?: any | null, rr_v3: any, rr_v2: any, rr_v1?: any | null, rr_vb?: any | null, shaft_horsepower?: number | null, nv0: any, nv1: any, nv2: any, iv0: any, iv1: any, iv2: any, pfv0: any, pfv1: any, pfv2: any, effv0: any, effv1: any, effv2: any, tv0: any, tv1: any, tv2: any, temperature_rating_fahrenheit?: number | null, updated_at: any, weight_pounds?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, poles?: number | null, stator_inner_diameter_inches?: any | null, stator_outer_diameter_inches?: any | null, k3?: any | null, nameplate_rerate_ratio?: any | null, inner_diameter_inches?: any | null, outer_diameter_inches?: any | null, neck_inner_diameter_inches?: any | null, neck_outer_diameter_inches?: any | null, mle_offset_depth_inches: any, outer_diameter_rub_inches: any, is_hps: boolean } | null, motor_lead_extension?: { __typename: 'motor_lead_extensions', id: any, manufacturer?: string | null, part_number?: string | null, series?: number | null, family?: string | null, gauge?: number | null, kv?: number | null, max_pothead_temperature_fahrenheit?: number | null, max_temperature_fahrenheit?: number | null, resistance_per_1000_ft?: any | null, impedance_60_hz_per_1000_ft?: any | null, amp_factor?: any | null, width_inches?: any | null, depth_inches?: any | null, pound_per_foot?: any | null, length_feet?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null } | null, pump?: { __typename: 'pumps', id: any, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, manufacturer?: string | null, rotation?: string | null, part_number?: string | null, compression_thrust_per_stage?: any | null, series_model?: string | null, stage_type?: number | null, shaft_diameter_inches?: any | null, standard_housing_pressure_rating_psi?: number | null, high_strength_housing_pressure_rating_psi?: number | null, standard_shaft_rating_hp?: number | null, high_strength_shaft_rating_hp?: number | null, construction?: string | null, min_rate_standard_pump_bpd?: number | null, bep_rate_standard_pump_bpd?: number | null, max_rate_standard_pump_bpd?: number | null, max_graph_rate_standard_pump_bpd?: number | null, hb?: any | null, h1?: any | null, h2?: any | null, h3?: any | null, h4?: any | null, h5?: any | null, bhpb?: any | null, bhp1?: any | null, bhp2?: any | null, bhp3?: any | null, bhp4?: any | null, bhp5?: any | null, npsh1?: any | null, npsh2?: any | null, npsh3?: any | null, npsh4?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, max_bolt_load_pounds?: any | null, is_compression_pump: boolean, housing_inner_diameter_inches?: any | null, housing_outer_diameter_inches?: any | null, neck_inner_diameter_inches?: any | null, neck_outer_diameter_inches?: any | null } | null, seal?: { __typename: 'seals', id: any, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, manufacturer?: string | null, part_number?: string | null, length_inches?: any | null, weight_pounds?: any | null, configuration?: string | null, max_temperature_fahrenheit?: number | null, standard_shaft_limit_hp?: number | null, high_strength_shaft_limit_hp?: number | null, standard_bearing_rating_pounds?: number | null, high_strength_bearing_rating_pounds?: number | null, housing_material?: string | null, bearing_type?: string | null, total_seal_volume_gallons?: any | null, volume_for_bag_expansion_lower_tandem_gallons?: any | null, volume_for_bag_expansion_upper_tandem_gallons?: any | null, upper_chamber_pull_volume_gallons?: any | null, bag_chambers?: number | null, bag_capacity_gallons?: any | null, string_load_pounds?: any | null, load_cb_pounds?: any | null, load_c1_pounds?: any | null, hps_thrust_chamber: boolean, load_test_temperature_fahrenheit?: number | null, description?: string | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, inner_diameter_inches?: any | null, outer_diameter_inches?: any | null, neck_inner_diameter_inches?: any | null, neck_outer_diameter_inches?: any | null, thrust_collar_inner_diameter_inches: any, thrust_collar_outer_diameter_inches: any } | null, sensor?: { __typename: 'sensors', id: any, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, manufacturer?: string | null, part_number?: string | null, length_inches?: number | null, weight_pounds?: number | null, model?: string | null, channels?: number | null, max_intake_temperature_fahrenheit?: number | null, max_intake_pressure_psi?: number | null, housing_material?: string | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, inner_diameter_inches?: any | null, outer_diameter_inches: any, neck_inner_diameter_inches?: any | null, neck_outer_diameter_inches?: any | null } | null, step_down_transformer?: { __typename: 'step_down_transformers', id: any, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, manufacturer?: string | null, part_number?: string | null, transformer_type?: string | null, primary_voltage_delta?: number | null, primary_voltage_wye?: number | null, min_secondary_voltage?: number | null, max_secondary_voltage?: number | null, weight_pounds?: number | null, enclosure?: string | null, kva?: number | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null } | null, step_up_transformer?: { __typename: 'step_up_transformers', id: any, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, manufacturer?: string | null, part_number?: string | null, transformer_type?: string | null, primary_voltage?: number | null, min_secondary_voltage?: number | null, max_secondary_voltage?: number | null, weight_pounds?: number | null, enclosure?: string | null, kva?: number | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null } | null, switchboard?: { __typename: 'switchboards', id: any, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, amps?: number | null, enclosure?: string | null, kv?: any | null, manufacturer?: string | null, part_number?: string | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null } | null, variable_speed_drive?: { __typename: 'variable_speed_drives', id: any, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, enclosure?: string | null, kva?: number | null, manufacturer?: string | null, max_amps?: number | null, part_number?: string | null, vsd_type?: string | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null } | null }>, quote_scenario?: { __typename: 'scenarios', id?: any | null, journal_author_id?: string | null, journal_created_at?: any | null, journal_updated_at?: any | null, journal_deleted_at?: any | null, winning_revision_id?: any | null, title?: string | null, notes?: string | null, internal_notes?: string | null, reason?: string | null, sizing_id?: any | null, well_properties_id?: any | null, scenario_equipment_id?: any | null, parameters_id?: any | null, correlations_id?: any | null, display_unit_overrides?: any | null, pumping_type?: string | null, author?: { __typename: 'users', id: string, email?: string | null, username?: string | null, display_name?: string | null, hal_identifier?: string | null } | null, sizing?: { __typename: 'sizings', id?: any | null, journal_author_id?: string | null, journal_deleted_at?: any | null, well_id?: number | null, customer_id?: number | null, title?: string | null, notes?: string | null, well?: { __typename: 'wells', id: number, well_name?: string | null, well_uwi?: string | null, well_erp_id?: string | null, address_erp_id?: string | null } | null, customer?: { __typename: 'customers', id: number, customer_name?: string | null, customer_erp_id: string, imported_sizing_id?: number | null } | null } | null } | null, user?: { __typename: 'users', id: string, email?: string | null, username?: string | null, display_name?: string | null, hal_identifier?: string | null } | null } | null };

export type GetQuotesQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Quotes_Bool_Exp>;
  order_by?: InputMaybe<Array<Quotes_Order_By>>;
}>;


export type GetQuotesQuery = { __typename: 'query_root', quotes: Array<{ __typename: 'quotes', comments?: string | null, created_at: any, currency?: string | null, customer_rep_name?: string | null, customer_rep_email?: string | null, customer_rep_phone_number?: string | null, deleted_at?: any | null, directions?: string | null, erp_contract_number?: string | null, erp_customer_name?: string | null, erp_customer_number?: string | null, erp_nwa_id?: string | null, erp_nwa_name?: string | null, erp_plant_id?: string | null, erp_plant_name?: string | null, erp_price_list_name?: string | null, erp_price_list_number?: string | null, erp_well_country?: string | null, erp_well_id?: string | null, erp_well_name?: string | null, erp_well_uwi?: string | null, erp_well_region?: string | null, erp_address_id?: string | null, erp_address_name?: string | null, erp_full_address?: string | null, id: any, name?: string | null, note?: string | null, prepared_by_id?: string | null, pricing_date?: any | null, proposed_start_date?: any | null, sk_job_id?: number | null, sk_job_number?: string | null, sk_job_type?: Quote_Sk_Job_Type_Dataset_Enum | null, sk_planning_order?: string | null, sk_proposal_number?: string | null, source?: Quote_Source_Dataset_Enum | null, spyglass_scenario_id?: any | null, spyglass_scenario_import_json?: any | null, status: Quote_Status_Dataset_Enum, updated_at: any, version_number?: number | null, error_log_json?: any | null, parent?: { __typename: 'quotes', id: any, name?: string | null, version_number?: number | null } | null, quote_line_items: Array<{ __typename: 'quote_line_items', category?: Quote_Line_Item_Category_Dataset_Enum | null, created_at: any, credit?: any | null, erp_material_long_description?: string | null, erp_material_number?: string | null, erp_material_short_description?: string | null, erp_price?: any | null, erp_serialized?: Quote_Line_Item_Serialized_Dataset_Enum | null, price_override?: any | null, erp_product_hierarchy?: string | null, erp_uom?: string | null, id: any, line_item_type?: Quote_Line_Item_Type_Dataset_Enum | null, margin?: any | null, note?: string | null, parent_order?: number | null, pricing_date?: any | null, quantity?: number | null, source?: Quote_Line_Item_Source_Dataset_Enum | null, subcategory?: Quote_Line_Item_Subcategory_Dataset_Enum | null, sub_order?: number | null, tax_type?: Quote_Line_Item_Tax_Type_Dataset_Enum | null, updated_at: any, spyglass_equipment_import_json?: any | null, quote_id: any, deleted_at?: any | null, cable?: { __typename: 'cables', id: any, amp_factor?: any | null, armor?: string | null, construction?: string | null, depth_inches?: any | null, family?: string | null, gauge?: string | null, kv?: number | null, manufacturer?: string | null, max_temperature_fahrenheit?: number | null, part_number?: string | null, pound_per_foot?: any | null, width_inches?: any | null, impedance_60_hz_per_1000_ft?: any | null, resistance_per_1000_ft?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, author_id: string, created_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, updated_at: any } | null, intake?: { __typename: 'intakes', id: any, manufacturer?: string | null, intake_type?: string | null, part_number?: string | null, configuration?: string | null, length_inches?: any | null, weight_pounds?: any | null, shaft_material?: string | null, shaft_limit_hp?: number | null, housing_material?: string | null, max_rate_bpd?: number | null, hp?: any | null, eff1?: any | null, eff2?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, high_strength_shaft_limit_hp?: number | null, stage_count?: number | null, bhp0?: any | null, bhp1?: any | null, bhp2?: any | null, bhp3?: any | null, bhp4?: any | null, bhp5?: any | null, bolt_on?: boolean | null, port_area_square_inches: any, inner_diameter_inches?: any | null, outer_diameter_inches?: any | null, neck_inner_diameter_inches?: any | null, neck_outer_diameter_inches?: any | null, is_hps: boolean, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null } | null, motor?: { __typename: 'motors', id: any, author_id: string, allow_rerate: boolean, configuration?: string | null, created_at: any, deleted_at?: any | null, eff1?: any | null, eff2?: any | null, eff3?: any | null, eff4?: any | null, eff5?: any | null, effb?: any | null, i1?: any | null, i2?: any | null, i3?: any | null, i4?: any | null, i5?: any | null, ib?: any | null, imported_sizing_id?: number | null, length_inches?: any | null, manufacturer?: string | null, n1?: any | null, n2?: any | null, n3?: any | null, n4?: any | null, n5?: any | null, nameplate_current?: number | null, nameplate_horsepower?: number | null, nameplate_voltage?: number | null, nb?: any | null, oil_volume_gallons?: any | null, part_number?: string | null, pf1?: any | null, pf2?: any | null, pf3?: any | null, pf4?: any | null, pf5?: any | null, pfb?: any | null, rr_l1?: any | null, rr_l2?: any | null, rr_lb?: any | null, rr_v3: any, rr_v2: any, rr_v1?: any | null, rr_vb?: any | null, shaft_horsepower?: number | null, nv0: any, nv1: any, nv2: any, iv0: any, iv1: any, iv2: any, pfv0: any, pfv1: any, pfv2: any, effv0: any, effv1: any, effv2: any, tv0: any, tv1: any, tv2: any, temperature_rating_fahrenheit?: number | null, updated_at: any, weight_pounds?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, poles?: number | null, stator_inner_diameter_inches?: any | null, stator_outer_diameter_inches?: any | null, k3?: any | null, nameplate_rerate_ratio?: any | null, inner_diameter_inches?: any | null, outer_diameter_inches?: any | null, neck_inner_diameter_inches?: any | null, neck_outer_diameter_inches?: any | null, mle_offset_depth_inches: any, outer_diameter_rub_inches: any, is_hps: boolean } | null, motor_lead_extension?: { __typename: 'motor_lead_extensions', id: any, manufacturer?: string | null, part_number?: string | null, series?: number | null, family?: string | null, gauge?: number | null, kv?: number | null, max_pothead_temperature_fahrenheit?: number | null, max_temperature_fahrenheit?: number | null, resistance_per_1000_ft?: any | null, impedance_60_hz_per_1000_ft?: any | null, amp_factor?: any | null, width_inches?: any | null, depth_inches?: any | null, pound_per_foot?: any | null, length_feet?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null } | null, pump?: { __typename: 'pumps', id: any, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, manufacturer?: string | null, rotation?: string | null, part_number?: string | null, compression_thrust_per_stage?: any | null, series_model?: string | null, stage_type?: number | null, shaft_diameter_inches?: any | null, standard_housing_pressure_rating_psi?: number | null, high_strength_housing_pressure_rating_psi?: number | null, standard_shaft_rating_hp?: number | null, high_strength_shaft_rating_hp?: number | null, construction?: string | null, min_rate_standard_pump_bpd?: number | null, bep_rate_standard_pump_bpd?: number | null, max_rate_standard_pump_bpd?: number | null, max_graph_rate_standard_pump_bpd?: number | null, hb?: any | null, h1?: any | null, h2?: any | null, h3?: any | null, h4?: any | null, h5?: any | null, bhpb?: any | null, bhp1?: any | null, bhp2?: any | null, bhp3?: any | null, bhp4?: any | null, bhp5?: any | null, npsh1?: any | null, npsh2?: any | null, npsh3?: any | null, npsh4?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, max_bolt_load_pounds?: any | null, is_compression_pump: boolean, housing_inner_diameter_inches?: any | null, housing_outer_diameter_inches?: any | null, neck_inner_diameter_inches?: any | null, neck_outer_diameter_inches?: any | null } | null, seal?: { __typename: 'seals', id: any, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, manufacturer?: string | null, part_number?: string | null, length_inches?: any | null, weight_pounds?: any | null, configuration?: string | null, max_temperature_fahrenheit?: number | null, standard_shaft_limit_hp?: number | null, high_strength_shaft_limit_hp?: number | null, standard_bearing_rating_pounds?: number | null, high_strength_bearing_rating_pounds?: number | null, housing_material?: string | null, bearing_type?: string | null, total_seal_volume_gallons?: any | null, volume_for_bag_expansion_lower_tandem_gallons?: any | null, volume_for_bag_expansion_upper_tandem_gallons?: any | null, upper_chamber_pull_volume_gallons?: any | null, bag_chambers?: number | null, bag_capacity_gallons?: any | null, string_load_pounds?: any | null, load_cb_pounds?: any | null, load_c1_pounds?: any | null, hps_thrust_chamber: boolean, load_test_temperature_fahrenheit?: number | null, description?: string | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, inner_diameter_inches?: any | null, outer_diameter_inches?: any | null, neck_inner_diameter_inches?: any | null, neck_outer_diameter_inches?: any | null, thrust_collar_inner_diameter_inches: any, thrust_collar_outer_diameter_inches: any } | null, sensor?: { __typename: 'sensors', id: any, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, manufacturer?: string | null, part_number?: string | null, length_inches?: number | null, weight_pounds?: number | null, model?: string | null, channels?: number | null, max_intake_temperature_fahrenheit?: number | null, max_intake_pressure_psi?: number | null, housing_material?: string | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, inner_diameter_inches?: any | null, outer_diameter_inches: any, neck_inner_diameter_inches?: any | null, neck_outer_diameter_inches?: any | null } | null, step_down_transformer?: { __typename: 'step_down_transformers', id: any, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, manufacturer?: string | null, part_number?: string | null, transformer_type?: string | null, primary_voltage_delta?: number | null, primary_voltage_wye?: number | null, min_secondary_voltage?: number | null, max_secondary_voltage?: number | null, weight_pounds?: number | null, enclosure?: string | null, kva?: number | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null } | null, step_up_transformer?: { __typename: 'step_up_transformers', id: any, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, manufacturer?: string | null, part_number?: string | null, transformer_type?: string | null, primary_voltage?: number | null, min_secondary_voltage?: number | null, max_secondary_voltage?: number | null, weight_pounds?: number | null, enclosure?: string | null, kva?: number | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null } | null, switchboard?: { __typename: 'switchboards', id: any, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, amps?: number | null, enclosure?: string | null, kv?: any | null, manufacturer?: string | null, part_number?: string | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null } | null, variable_speed_drive?: { __typename: 'variable_speed_drives', id: any, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, enclosure?: string | null, kva?: number | null, manufacturer?: string | null, max_amps?: number | null, part_number?: string | null, vsd_type?: string | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null } | null }>, quote_scenario?: { __typename: 'scenarios', id?: any | null, journal_author_id?: string | null, journal_created_at?: any | null, journal_updated_at?: any | null, journal_deleted_at?: any | null, winning_revision_id?: any | null, title?: string | null, notes?: string | null, internal_notes?: string | null, reason?: string | null, sizing_id?: any | null, well_properties_id?: any | null, scenario_equipment_id?: any | null, parameters_id?: any | null, correlations_id?: any | null, display_unit_overrides?: any | null, pumping_type?: string | null, author?: { __typename: 'users', id: string, email?: string | null, username?: string | null, display_name?: string | null, hal_identifier?: string | null } | null, sizing?: { __typename: 'sizings', id?: any | null, journal_author_id?: string | null, journal_deleted_at?: any | null, well_id?: number | null, customer_id?: number | null, title?: string | null, notes?: string | null, well?: { __typename: 'wells', id: number, well_name?: string | null, well_uwi?: string | null, well_erp_id?: string | null, address_erp_id?: string | null } | null, customer?: { __typename: 'customers', id: number, customer_name?: string | null, customer_erp_id: string, imported_sizing_id?: number | null } | null } | null } | null, user?: { __typename: 'users', id: string, email?: string | null, username?: string | null, display_name?: string | null, hal_identifier?: string | null } | null }> };

export type GetQuotesWithPriceHistoryQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Quotes_Bool_Exp>;
  order_by?: InputMaybe<Array<Quotes_Order_By>>;
}>;


export type GetQuotesWithPriceHistoryQuery = { __typename: 'query_root', quotes: Array<{ __typename: 'quotes', id: any, erp_customer_name?: string | null, updated_at: any, status: Quote_Status_Dataset_Enum, quote_line_items: Array<{ __typename: 'quote_line_items', erp_material_number?: string | null, price_override?: any | null, margin?: any | null, erp_price?: any | null }> }> };

export type GetQuotesWithoutLineItemsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Quotes_Bool_Exp>;
  order_by?: InputMaybe<Array<Quotes_Order_By>>;
}>;


export type GetQuotesWithoutLineItemsQuery = { __typename: 'query_root', quotes: Array<{ __typename: 'quotes', created_at: any, deleted_at?: any | null, directions?: string | null, erp_contract_number?: string | null, erp_customer_name?: string | null, erp_customer_number?: string | null, erp_nwa_id?: string | null, erp_nwa_name?: string | null, erp_plant_id?: string | null, erp_plant_name?: string | null, erp_price_list_name?: string | null, erp_price_list_number?: string | null, erp_well_country?: string | null, erp_well_id?: string | null, erp_well_name?: string | null, erp_well_uwi?: string | null, erp_well_region?: string | null, erp_address_id?: string | null, erp_address_name?: string | null, erp_full_address?: string | null, id: any, name?: string | null, prepared_by_id?: string | null, pricing_date?: any | null, sk_job_id?: number | null, sk_job_number?: string | null, sk_job_type?: Quote_Sk_Job_Type_Dataset_Enum | null, sk_planning_order?: string | null, sk_proposal_number?: string | null, status: Quote_Status_Dataset_Enum, updated_at: any, version_number?: number | null, error_log_json?: any | null, parent?: { __typename: 'quotes', id: any, name?: string | null, version_number?: number | null } | null, user?: { __typename: 'users', id: string, email?: string | null, username?: string | null, display_name?: string | null, hal_identifier?: string | null } | null }> };

export type GetQuotesCountQueryVariables = Exact<{
  where?: InputMaybe<Quotes_Bool_Exp>;
}>;


export type GetQuotesCountQuery = { __typename: 'query_root', quotes_aggregate: { __typename: 'quotes_aggregate', id: 'quotes_aggregate', aggregate?: { __typename: 'quotes_aggregate_fields', count: number, id: 'quotes_aggregate_fields' } | null } };

export type GetQuoteLineItemsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Quote_Line_Items_Bool_Exp>;
  order_by?: InputMaybe<Array<Quote_Line_Items_Order_By>>;
  distinct_on?: InputMaybe<Array<Quote_Line_Items_Select_Column>>;
}>;


export type GetQuoteLineItemsQuery = { __typename: 'query_root', quote_line_items: Array<{ __typename: 'quote_line_items', quote_id: any, category?: Quote_Line_Item_Category_Dataset_Enum | null, created_at: any, credit?: any | null, deleted_at?: any | null, erp_material_long_description?: string | null, erp_material_number?: string | null, erp_material_short_description?: string | null, erp_price?: any | null, erp_product_hierarchy?: string | null, erp_uom?: string | null, erp_serialized?: Quote_Line_Item_Serialized_Dataset_Enum | null, id: any, line_item_type?: Quote_Line_Item_Type_Dataset_Enum | null, margin?: any | null, note?: string | null, parent_order?: number | null, price_override?: any | null, pricing_date?: any | null, quantity?: number | null, source?: Quote_Line_Item_Source_Dataset_Enum | null, subcategory?: Quote_Line_Item_Subcategory_Dataset_Enum | null, sub_order?: number | null, tax_type?: Quote_Line_Item_Tax_Type_Dataset_Enum | null, updated_at: any, spyglass_equipment_import_json?: any | null, cable?: { __typename: 'cables', id: any, amp_factor?: any | null, armor?: string | null, construction?: string | null, depth_inches?: any | null, family?: string | null, gauge?: string | null, kv?: number | null, manufacturer?: string | null, max_temperature_fahrenheit?: number | null, part_number?: string | null, pound_per_foot?: any | null, width_inches?: any | null, impedance_60_hz_per_1000_ft?: any | null, resistance_per_1000_ft?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, author_id: string, created_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, updated_at: any } | null, intake?: { __typename: 'intakes', id: any, manufacturer?: string | null, intake_type?: string | null, part_number?: string | null, configuration?: string | null, length_inches?: any | null, weight_pounds?: any | null, shaft_material?: string | null, shaft_limit_hp?: number | null, housing_material?: string | null, max_rate_bpd?: number | null, hp?: any | null, eff1?: any | null, eff2?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, high_strength_shaft_limit_hp?: number | null, stage_count?: number | null, bhp0?: any | null, bhp1?: any | null, bhp2?: any | null, bhp3?: any | null, bhp4?: any | null, bhp5?: any | null, bolt_on?: boolean | null, port_area_square_inches: any, inner_diameter_inches?: any | null, outer_diameter_inches?: any | null, neck_inner_diameter_inches?: any | null, neck_outer_diameter_inches?: any | null, is_hps: boolean, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null } | null, motor?: { __typename: 'motors', id: any, author_id: string, allow_rerate: boolean, configuration?: string | null, created_at: any, deleted_at?: any | null, eff1?: any | null, eff2?: any | null, eff3?: any | null, eff4?: any | null, eff5?: any | null, effb?: any | null, i1?: any | null, i2?: any | null, i3?: any | null, i4?: any | null, i5?: any | null, ib?: any | null, imported_sizing_id?: number | null, length_inches?: any | null, manufacturer?: string | null, n1?: any | null, n2?: any | null, n3?: any | null, n4?: any | null, n5?: any | null, nameplate_current?: number | null, nameplate_horsepower?: number | null, nameplate_voltage?: number | null, nb?: any | null, oil_volume_gallons?: any | null, part_number?: string | null, pf1?: any | null, pf2?: any | null, pf3?: any | null, pf4?: any | null, pf5?: any | null, pfb?: any | null, rr_l1?: any | null, rr_l2?: any | null, rr_lb?: any | null, rr_v3: any, rr_v2: any, rr_v1?: any | null, rr_vb?: any | null, shaft_horsepower?: number | null, nv0: any, nv1: any, nv2: any, iv0: any, iv1: any, iv2: any, pfv0: any, pfv1: any, pfv2: any, effv0: any, effv1: any, effv2: any, tv0: any, tv1: any, tv2: any, temperature_rating_fahrenheit?: number | null, updated_at: any, weight_pounds?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, poles?: number | null, stator_inner_diameter_inches?: any | null, stator_outer_diameter_inches?: any | null, k3?: any | null, nameplate_rerate_ratio?: any | null, inner_diameter_inches?: any | null, outer_diameter_inches?: any | null, neck_inner_diameter_inches?: any | null, neck_outer_diameter_inches?: any | null, mle_offset_depth_inches: any, outer_diameter_rub_inches: any, is_hps: boolean } | null, motor_lead_extension?: { __typename: 'motor_lead_extensions', id: any, manufacturer?: string | null, part_number?: string | null, series?: number | null, family?: string | null, gauge?: number | null, kv?: number | null, max_pothead_temperature_fahrenheit?: number | null, max_temperature_fahrenheit?: number | null, resistance_per_1000_ft?: any | null, impedance_60_hz_per_1000_ft?: any | null, amp_factor?: any | null, width_inches?: any | null, depth_inches?: any | null, pound_per_foot?: any | null, length_feet?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null } | null, pump?: { __typename: 'pumps', id: any, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, manufacturer?: string | null, rotation?: string | null, part_number?: string | null, compression_thrust_per_stage?: any | null, series_model?: string | null, stage_type?: number | null, shaft_diameter_inches?: any | null, standard_housing_pressure_rating_psi?: number | null, high_strength_housing_pressure_rating_psi?: number | null, standard_shaft_rating_hp?: number | null, high_strength_shaft_rating_hp?: number | null, construction?: string | null, min_rate_standard_pump_bpd?: number | null, bep_rate_standard_pump_bpd?: number | null, max_rate_standard_pump_bpd?: number | null, max_graph_rate_standard_pump_bpd?: number | null, hb?: any | null, h1?: any | null, h2?: any | null, h3?: any | null, h4?: any | null, h5?: any | null, bhpb?: any | null, bhp1?: any | null, bhp2?: any | null, bhp3?: any | null, bhp4?: any | null, bhp5?: any | null, npsh1?: any | null, npsh2?: any | null, npsh3?: any | null, npsh4?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, max_bolt_load_pounds?: any | null, is_compression_pump: boolean, housing_inner_diameter_inches?: any | null, housing_outer_diameter_inches?: any | null, neck_inner_diameter_inches?: any | null, neck_outer_diameter_inches?: any | null } | null, seal?: { __typename: 'seals', id: any, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, manufacturer?: string | null, part_number?: string | null, length_inches?: any | null, weight_pounds?: any | null, configuration?: string | null, max_temperature_fahrenheit?: number | null, standard_shaft_limit_hp?: number | null, high_strength_shaft_limit_hp?: number | null, standard_bearing_rating_pounds?: number | null, high_strength_bearing_rating_pounds?: number | null, housing_material?: string | null, bearing_type?: string | null, total_seal_volume_gallons?: any | null, volume_for_bag_expansion_lower_tandem_gallons?: any | null, volume_for_bag_expansion_upper_tandem_gallons?: any | null, upper_chamber_pull_volume_gallons?: any | null, bag_chambers?: number | null, bag_capacity_gallons?: any | null, string_load_pounds?: any | null, load_cb_pounds?: any | null, load_c1_pounds?: any | null, hps_thrust_chamber: boolean, load_test_temperature_fahrenheit?: number | null, description?: string | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, inner_diameter_inches?: any | null, outer_diameter_inches?: any | null, neck_inner_diameter_inches?: any | null, neck_outer_diameter_inches?: any | null, thrust_collar_inner_diameter_inches: any, thrust_collar_outer_diameter_inches: any } | null, sensor?: { __typename: 'sensors', id: any, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, manufacturer?: string | null, part_number?: string | null, length_inches?: number | null, weight_pounds?: number | null, model?: string | null, channels?: number | null, max_intake_temperature_fahrenheit?: number | null, max_intake_pressure_psi?: number | null, housing_material?: string | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, inner_diameter_inches?: any | null, outer_diameter_inches: any, neck_inner_diameter_inches?: any | null, neck_outer_diameter_inches?: any | null } | null, step_down_transformer?: { __typename: 'step_down_transformers', id: any, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, manufacturer?: string | null, part_number?: string | null, transformer_type?: string | null, primary_voltage_delta?: number | null, primary_voltage_wye?: number | null, min_secondary_voltage?: number | null, max_secondary_voltage?: number | null, weight_pounds?: number | null, enclosure?: string | null, kva?: number | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null } | null, step_up_transformer?: { __typename: 'step_up_transformers', id: any, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, manufacturer?: string | null, part_number?: string | null, transformer_type?: string | null, primary_voltage?: number | null, min_secondary_voltage?: number | null, max_secondary_voltage?: number | null, weight_pounds?: number | null, enclosure?: string | null, kva?: number | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null } | null, switchboard?: { __typename: 'switchboards', id: any, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, amps?: number | null, enclosure?: string | null, kv?: any | null, manufacturer?: string | null, part_number?: string | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null } | null, variable_speed_drive?: { __typename: 'variable_speed_drives', id: any, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, enclosure?: string | null, kva?: number | null, manufacturer?: string | null, max_amps?: number | null, part_number?: string | null, vsd_type?: string | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null } | null }> };

export type InsertQuoteMutationVariables = Exact<{
  object: Quotes_Insert_Input;
}>;


export type InsertQuoteMutation = { __typename: 'mutation_root', insert_quotes_one?: { __typename: 'quotes', comments?: string | null, created_at: any, currency?: string | null, customer_rep_name?: string | null, customer_rep_email?: string | null, customer_rep_phone_number?: string | null, deleted_at?: any | null, directions?: string | null, erp_contract_number?: string | null, erp_customer_name?: string | null, erp_customer_number?: string | null, erp_nwa_id?: string | null, erp_nwa_name?: string | null, erp_plant_id?: string | null, erp_plant_name?: string | null, erp_price_list_name?: string | null, erp_price_list_number?: string | null, erp_well_country?: string | null, erp_well_id?: string | null, erp_well_name?: string | null, erp_well_uwi?: string | null, erp_well_region?: string | null, erp_address_id?: string | null, erp_address_name?: string | null, erp_full_address?: string | null, id: any, name?: string | null, note?: string | null, prepared_by_id?: string | null, pricing_date?: any | null, proposed_start_date?: any | null, sk_job_id?: number | null, sk_job_number?: string | null, sk_job_type?: Quote_Sk_Job_Type_Dataset_Enum | null, sk_planning_order?: string | null, sk_proposal_number?: string | null, source?: Quote_Source_Dataset_Enum | null, spyglass_scenario_id?: any | null, spyglass_scenario_import_json?: any | null, status: Quote_Status_Dataset_Enum, updated_at: any, version_number?: number | null, error_log_json?: any | null, quote_line_items: Array<{ __typename: 'quote_line_items', category?: Quote_Line_Item_Category_Dataset_Enum | null, created_at: any, credit?: any | null, erp_material_long_description?: string | null, erp_material_number?: string | null, erp_material_short_description?: string | null, erp_price?: any | null, erp_serialized?: Quote_Line_Item_Serialized_Dataset_Enum | null, price_override?: any | null, erp_product_hierarchy?: string | null, erp_uom?: string | null, id: any, line_item_type?: Quote_Line_Item_Type_Dataset_Enum | null, margin?: any | null, note?: string | null, parent_order?: number | null, pricing_date?: any | null, quantity?: number | null, source?: Quote_Line_Item_Source_Dataset_Enum | null, subcategory?: Quote_Line_Item_Subcategory_Dataset_Enum | null, sub_order?: number | null, tax_type?: Quote_Line_Item_Tax_Type_Dataset_Enum | null, updated_at: any, spyglass_equipment_import_json?: any | null, cable?: { __typename: 'cables', id: any } | null, intake?: { __typename: 'intakes', id: any } | null, motor?: { __typename: 'motors', id: any } | null, motor_lead_extension?: { __typename: 'motor_lead_extensions', id: any } | null, pump?: { __typename: 'pumps', id: any } | null, seal?: { __typename: 'seals', id: any } | null, sensor?: { __typename: 'sensors', id: any } | null, step_down_transformer?: { __typename: 'step_down_transformers', id: any } | null, step_up_transformer?: { __typename: 'step_up_transformers', id: any } | null, switchboard?: { __typename: 'switchboards', id: any } | null, variable_speed_drive?: { __typename: 'variable_speed_drives', id: any } | null }> } | null };

export type UpdateQuoteByPkMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  object: Quotes_Set_Input;
  create_line_items: Array<Quote_Line_Items_Insert_Input>;
  update_line_items: Array<Quote_Line_Items_Updates>;
}>;


export type UpdateQuoteByPkMutation = { __typename: 'mutation_root', update_quotes_by_pk?: { __typename: 'quotes', comments?: string | null, created_at: any, currency?: string | null, customer_rep_name?: string | null, customer_rep_email?: string | null, customer_rep_phone_number?: string | null, deleted_at?: any | null, directions?: string | null, erp_contract_number?: string | null, erp_customer_name?: string | null, erp_customer_number?: string | null, erp_nwa_id?: string | null, erp_nwa_name?: string | null, erp_plant_id?: string | null, erp_plant_name?: string | null, erp_price_list_name?: string | null, erp_price_list_number?: string | null, erp_well_country?: string | null, erp_well_id?: string | null, erp_well_name?: string | null, erp_well_uwi?: string | null, erp_well_region?: string | null, erp_address_id?: string | null, erp_address_name?: string | null, erp_full_address?: string | null, id: any, name?: string | null, note?: string | null, prepared_by_id?: string | null, pricing_date?: any | null, proposed_start_date?: any | null, sk_job_id?: number | null, sk_job_number?: string | null, sk_job_type?: Quote_Sk_Job_Type_Dataset_Enum | null, sk_planning_order?: string | null, sk_proposal_number?: string | null, source?: Quote_Source_Dataset_Enum | null, spyglass_scenario_id?: any | null, spyglass_scenario_import_json?: any | null, status: Quote_Status_Dataset_Enum, updated_at: any, version_number?: number | null, error_log_json?: any | null, parent?: { __typename: 'quotes', id: any, name?: string | null, version_number?: number | null } | null, quote_line_items: Array<{ __typename: 'quote_line_items', category?: Quote_Line_Item_Category_Dataset_Enum | null, created_at: any, credit?: any | null, erp_material_long_description?: string | null, erp_material_number?: string | null, erp_material_short_description?: string | null, erp_price?: any | null, erp_serialized?: Quote_Line_Item_Serialized_Dataset_Enum | null, price_override?: any | null, erp_product_hierarchy?: string | null, erp_uom?: string | null, id: any, line_item_type?: Quote_Line_Item_Type_Dataset_Enum | null, margin?: any | null, note?: string | null, parent_order?: number | null, pricing_date?: any | null, quantity?: number | null, source?: Quote_Line_Item_Source_Dataset_Enum | null, subcategory?: Quote_Line_Item_Subcategory_Dataset_Enum | null, sub_order?: number | null, tax_type?: Quote_Line_Item_Tax_Type_Dataset_Enum | null, updated_at: any, spyglass_equipment_import_json?: any | null, quote_id: any, deleted_at?: any | null, cable?: { __typename: 'cables', id: any, amp_factor?: any | null, armor?: string | null, construction?: string | null, depth_inches?: any | null, family?: string | null, gauge?: string | null, kv?: number | null, manufacturer?: string | null, max_temperature_fahrenheit?: number | null, part_number?: string | null, pound_per_foot?: any | null, width_inches?: any | null, impedance_60_hz_per_1000_ft?: any | null, resistance_per_1000_ft?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, author_id: string, created_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, updated_at: any } | null, intake?: { __typename: 'intakes', id: any, manufacturer?: string | null, intake_type?: string | null, part_number?: string | null, configuration?: string | null, length_inches?: any | null, weight_pounds?: any | null, shaft_material?: string | null, shaft_limit_hp?: number | null, housing_material?: string | null, max_rate_bpd?: number | null, hp?: any | null, eff1?: any | null, eff2?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, high_strength_shaft_limit_hp?: number | null, stage_count?: number | null, bhp0?: any | null, bhp1?: any | null, bhp2?: any | null, bhp3?: any | null, bhp4?: any | null, bhp5?: any | null, bolt_on?: boolean | null, port_area_square_inches: any, inner_diameter_inches?: any | null, outer_diameter_inches?: any | null, neck_inner_diameter_inches?: any | null, neck_outer_diameter_inches?: any | null, is_hps: boolean, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null } | null, motor?: { __typename: 'motors', id: any, author_id: string, allow_rerate: boolean, configuration?: string | null, created_at: any, deleted_at?: any | null, eff1?: any | null, eff2?: any | null, eff3?: any | null, eff4?: any | null, eff5?: any | null, effb?: any | null, i1?: any | null, i2?: any | null, i3?: any | null, i4?: any | null, i5?: any | null, ib?: any | null, imported_sizing_id?: number | null, length_inches?: any | null, manufacturer?: string | null, n1?: any | null, n2?: any | null, n3?: any | null, n4?: any | null, n5?: any | null, nameplate_current?: number | null, nameplate_horsepower?: number | null, nameplate_voltage?: number | null, nb?: any | null, oil_volume_gallons?: any | null, part_number?: string | null, pf1?: any | null, pf2?: any | null, pf3?: any | null, pf4?: any | null, pf5?: any | null, pfb?: any | null, rr_l1?: any | null, rr_l2?: any | null, rr_lb?: any | null, rr_v3: any, rr_v2: any, rr_v1?: any | null, rr_vb?: any | null, shaft_horsepower?: number | null, nv0: any, nv1: any, nv2: any, iv0: any, iv1: any, iv2: any, pfv0: any, pfv1: any, pfv2: any, effv0: any, effv1: any, effv2: any, tv0: any, tv1: any, tv2: any, temperature_rating_fahrenheit?: number | null, updated_at: any, weight_pounds?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, poles?: number | null, stator_inner_diameter_inches?: any | null, stator_outer_diameter_inches?: any | null, k3?: any | null, nameplate_rerate_ratio?: any | null, inner_diameter_inches?: any | null, outer_diameter_inches?: any | null, neck_inner_diameter_inches?: any | null, neck_outer_diameter_inches?: any | null, mle_offset_depth_inches: any, outer_diameter_rub_inches: any, is_hps: boolean } | null, motor_lead_extension?: { __typename: 'motor_lead_extensions', id: any, manufacturer?: string | null, part_number?: string | null, series?: number | null, family?: string | null, gauge?: number | null, kv?: number | null, max_pothead_temperature_fahrenheit?: number | null, max_temperature_fahrenheit?: number | null, resistance_per_1000_ft?: any | null, impedance_60_hz_per_1000_ft?: any | null, amp_factor?: any | null, width_inches?: any | null, depth_inches?: any | null, pound_per_foot?: any | null, length_feet?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null } | null, pump?: { __typename: 'pumps', id: any, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, manufacturer?: string | null, rotation?: string | null, part_number?: string | null, compression_thrust_per_stage?: any | null, series_model?: string | null, stage_type?: number | null, shaft_diameter_inches?: any | null, standard_housing_pressure_rating_psi?: number | null, high_strength_housing_pressure_rating_psi?: number | null, standard_shaft_rating_hp?: number | null, high_strength_shaft_rating_hp?: number | null, construction?: string | null, min_rate_standard_pump_bpd?: number | null, bep_rate_standard_pump_bpd?: number | null, max_rate_standard_pump_bpd?: number | null, max_graph_rate_standard_pump_bpd?: number | null, hb?: any | null, h1?: any | null, h2?: any | null, h3?: any | null, h4?: any | null, h5?: any | null, bhpb?: any | null, bhp1?: any | null, bhp2?: any | null, bhp3?: any | null, bhp4?: any | null, bhp5?: any | null, npsh1?: any | null, npsh2?: any | null, npsh3?: any | null, npsh4?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, max_bolt_load_pounds?: any | null, is_compression_pump: boolean, housing_inner_diameter_inches?: any | null, housing_outer_diameter_inches?: any | null, neck_inner_diameter_inches?: any | null, neck_outer_diameter_inches?: any | null } | null, seal?: { __typename: 'seals', id: any, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, manufacturer?: string | null, part_number?: string | null, length_inches?: any | null, weight_pounds?: any | null, configuration?: string | null, max_temperature_fahrenheit?: number | null, standard_shaft_limit_hp?: number | null, high_strength_shaft_limit_hp?: number | null, standard_bearing_rating_pounds?: number | null, high_strength_bearing_rating_pounds?: number | null, housing_material?: string | null, bearing_type?: string | null, total_seal_volume_gallons?: any | null, volume_for_bag_expansion_lower_tandem_gallons?: any | null, volume_for_bag_expansion_upper_tandem_gallons?: any | null, upper_chamber_pull_volume_gallons?: any | null, bag_chambers?: number | null, bag_capacity_gallons?: any | null, string_load_pounds?: any | null, load_cb_pounds?: any | null, load_c1_pounds?: any | null, hps_thrust_chamber: boolean, load_test_temperature_fahrenheit?: number | null, description?: string | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, inner_diameter_inches?: any | null, outer_diameter_inches?: any | null, neck_inner_diameter_inches?: any | null, neck_outer_diameter_inches?: any | null, thrust_collar_inner_diameter_inches: any, thrust_collar_outer_diameter_inches: any } | null, sensor?: { __typename: 'sensors', id: any, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, manufacturer?: string | null, part_number?: string | null, length_inches?: number | null, weight_pounds?: number | null, model?: string | null, channels?: number | null, max_intake_temperature_fahrenheit?: number | null, max_intake_pressure_psi?: number | null, housing_material?: string | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, inner_diameter_inches?: any | null, outer_diameter_inches: any, neck_inner_diameter_inches?: any | null, neck_outer_diameter_inches?: any | null } | null, step_down_transformer?: { __typename: 'step_down_transformers', id: any, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, manufacturer?: string | null, part_number?: string | null, transformer_type?: string | null, primary_voltage_delta?: number | null, primary_voltage_wye?: number | null, min_secondary_voltage?: number | null, max_secondary_voltage?: number | null, weight_pounds?: number | null, enclosure?: string | null, kva?: number | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null } | null, step_up_transformer?: { __typename: 'step_up_transformers', id: any, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, manufacturer?: string | null, part_number?: string | null, transformer_type?: string | null, primary_voltage?: number | null, min_secondary_voltage?: number | null, max_secondary_voltage?: number | null, weight_pounds?: number | null, enclosure?: string | null, kva?: number | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null } | null, switchboard?: { __typename: 'switchboards', id: any, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, amps?: number | null, enclosure?: string | null, kv?: any | null, manufacturer?: string | null, part_number?: string | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null } | null, variable_speed_drive?: { __typename: 'variable_speed_drives', id: any, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, enclosure?: string | null, kva?: number | null, manufacturer?: string | null, max_amps?: number | null, part_number?: string | null, vsd_type?: string | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null } | null }>, quote_scenario?: { __typename: 'scenarios', id?: any | null, journal_author_id?: string | null, journal_created_at?: any | null, journal_updated_at?: any | null, journal_deleted_at?: any | null, winning_revision_id?: any | null, title?: string | null, notes?: string | null, internal_notes?: string | null, reason?: string | null, sizing_id?: any | null, well_properties_id?: any | null, scenario_equipment_id?: any | null, parameters_id?: any | null, correlations_id?: any | null, display_unit_overrides?: any | null, pumping_type?: string | null, author?: { __typename: 'users', id: string, email?: string | null, username?: string | null, display_name?: string | null, hal_identifier?: string | null } | null, sizing?: { __typename: 'sizings', id?: any | null, journal_author_id?: string | null, journal_deleted_at?: any | null, well_id?: number | null, customer_id?: number | null, title?: string | null, notes?: string | null, well?: { __typename: 'wells', id: number, well_name?: string | null, well_uwi?: string | null, well_erp_id?: string | null, address_erp_id?: string | null } | null, customer?: { __typename: 'customers', id: number, customer_name?: string | null, customer_erp_id: string, imported_sizing_id?: number | null } | null } | null } | null, user?: { __typename: 'users', id: string, email?: string | null, username?: string | null, display_name?: string | null, hal_identifier?: string | null } | null } | null, insert_quote_line_items?: { __typename: 'quote_line_items_mutation_response', returning: Array<{ __typename: 'quote_line_items', quote_id: any, category?: Quote_Line_Item_Category_Dataset_Enum | null, created_at: any, credit?: any | null, deleted_at?: any | null, erp_material_long_description?: string | null, erp_material_number?: string | null, erp_material_short_description?: string | null, erp_price?: any | null, erp_product_hierarchy?: string | null, erp_uom?: string | null, erp_serialized?: Quote_Line_Item_Serialized_Dataset_Enum | null, id: any, line_item_type?: Quote_Line_Item_Type_Dataset_Enum | null, margin?: any | null, note?: string | null, parent_order?: number | null, price_override?: any | null, pricing_date?: any | null, quantity?: number | null, source?: Quote_Line_Item_Source_Dataset_Enum | null, subcategory?: Quote_Line_Item_Subcategory_Dataset_Enum | null, sub_order?: number | null, tax_type?: Quote_Line_Item_Tax_Type_Dataset_Enum | null, updated_at: any, spyglass_equipment_import_json?: any | null, cable?: { __typename: 'cables', id: any, amp_factor?: any | null, armor?: string | null, construction?: string | null, depth_inches?: any | null, family?: string | null, gauge?: string | null, kv?: number | null, manufacturer?: string | null, max_temperature_fahrenheit?: number | null, part_number?: string | null, pound_per_foot?: any | null, width_inches?: any | null, impedance_60_hz_per_1000_ft?: any | null, resistance_per_1000_ft?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, author_id: string, created_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, updated_at: any } | null, intake?: { __typename: 'intakes', id: any, manufacturer?: string | null, intake_type?: string | null, part_number?: string | null, configuration?: string | null, length_inches?: any | null, weight_pounds?: any | null, shaft_material?: string | null, shaft_limit_hp?: number | null, housing_material?: string | null, max_rate_bpd?: number | null, hp?: any | null, eff1?: any | null, eff2?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, high_strength_shaft_limit_hp?: number | null, stage_count?: number | null, bhp0?: any | null, bhp1?: any | null, bhp2?: any | null, bhp3?: any | null, bhp4?: any | null, bhp5?: any | null, bolt_on?: boolean | null, port_area_square_inches: any, inner_diameter_inches?: any | null, outer_diameter_inches?: any | null, neck_inner_diameter_inches?: any | null, neck_outer_diameter_inches?: any | null, is_hps: boolean, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null } | null, motor?: { __typename: 'motors', id: any, author_id: string, allow_rerate: boolean, configuration?: string | null, created_at: any, deleted_at?: any | null, eff1?: any | null, eff2?: any | null, eff3?: any | null, eff4?: any | null, eff5?: any | null, effb?: any | null, i1?: any | null, i2?: any | null, i3?: any | null, i4?: any | null, i5?: any | null, ib?: any | null, imported_sizing_id?: number | null, length_inches?: any | null, manufacturer?: string | null, n1?: any | null, n2?: any | null, n3?: any | null, n4?: any | null, n5?: any | null, nameplate_current?: number | null, nameplate_horsepower?: number | null, nameplate_voltage?: number | null, nb?: any | null, oil_volume_gallons?: any | null, part_number?: string | null, pf1?: any | null, pf2?: any | null, pf3?: any | null, pf4?: any | null, pf5?: any | null, pfb?: any | null, rr_l1?: any | null, rr_l2?: any | null, rr_lb?: any | null, rr_v3: any, rr_v2: any, rr_v1?: any | null, rr_vb?: any | null, shaft_horsepower?: number | null, nv0: any, nv1: any, nv2: any, iv0: any, iv1: any, iv2: any, pfv0: any, pfv1: any, pfv2: any, effv0: any, effv1: any, effv2: any, tv0: any, tv1: any, tv2: any, temperature_rating_fahrenheit?: number | null, updated_at: any, weight_pounds?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, poles?: number | null, stator_inner_diameter_inches?: any | null, stator_outer_diameter_inches?: any | null, k3?: any | null, nameplate_rerate_ratio?: any | null, inner_diameter_inches?: any | null, outer_diameter_inches?: any | null, neck_inner_diameter_inches?: any | null, neck_outer_diameter_inches?: any | null, mle_offset_depth_inches: any, outer_diameter_rub_inches: any, is_hps: boolean } | null, motor_lead_extension?: { __typename: 'motor_lead_extensions', id: any, manufacturer?: string | null, part_number?: string | null, series?: number | null, family?: string | null, gauge?: number | null, kv?: number | null, max_pothead_temperature_fahrenheit?: number | null, max_temperature_fahrenheit?: number | null, resistance_per_1000_ft?: any | null, impedance_60_hz_per_1000_ft?: any | null, amp_factor?: any | null, width_inches?: any | null, depth_inches?: any | null, pound_per_foot?: any | null, length_feet?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null } | null, pump?: { __typename: 'pumps', id: any, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, manufacturer?: string | null, rotation?: string | null, part_number?: string | null, compression_thrust_per_stage?: any | null, series_model?: string | null, stage_type?: number | null, shaft_diameter_inches?: any | null, standard_housing_pressure_rating_psi?: number | null, high_strength_housing_pressure_rating_psi?: number | null, standard_shaft_rating_hp?: number | null, high_strength_shaft_rating_hp?: number | null, construction?: string | null, min_rate_standard_pump_bpd?: number | null, bep_rate_standard_pump_bpd?: number | null, max_rate_standard_pump_bpd?: number | null, max_graph_rate_standard_pump_bpd?: number | null, hb?: any | null, h1?: any | null, h2?: any | null, h3?: any | null, h4?: any | null, h5?: any | null, bhpb?: any | null, bhp1?: any | null, bhp2?: any | null, bhp3?: any | null, bhp4?: any | null, bhp5?: any | null, npsh1?: any | null, npsh2?: any | null, npsh3?: any | null, npsh4?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, max_bolt_load_pounds?: any | null, is_compression_pump: boolean, housing_inner_diameter_inches?: any | null, housing_outer_diameter_inches?: any | null, neck_inner_diameter_inches?: any | null, neck_outer_diameter_inches?: any | null } | null, seal?: { __typename: 'seals', id: any, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, manufacturer?: string | null, part_number?: string | null, length_inches?: any | null, weight_pounds?: any | null, configuration?: string | null, max_temperature_fahrenheit?: number | null, standard_shaft_limit_hp?: number | null, high_strength_shaft_limit_hp?: number | null, standard_bearing_rating_pounds?: number | null, high_strength_bearing_rating_pounds?: number | null, housing_material?: string | null, bearing_type?: string | null, total_seal_volume_gallons?: any | null, volume_for_bag_expansion_lower_tandem_gallons?: any | null, volume_for_bag_expansion_upper_tandem_gallons?: any | null, upper_chamber_pull_volume_gallons?: any | null, bag_chambers?: number | null, bag_capacity_gallons?: any | null, string_load_pounds?: any | null, load_cb_pounds?: any | null, load_c1_pounds?: any | null, hps_thrust_chamber: boolean, load_test_temperature_fahrenheit?: number | null, description?: string | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, inner_diameter_inches?: any | null, outer_diameter_inches?: any | null, neck_inner_diameter_inches?: any | null, neck_outer_diameter_inches?: any | null, thrust_collar_inner_diameter_inches: any, thrust_collar_outer_diameter_inches: any } | null, sensor?: { __typename: 'sensors', id: any, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, manufacturer?: string | null, part_number?: string | null, length_inches?: number | null, weight_pounds?: number | null, model?: string | null, channels?: number | null, max_intake_temperature_fahrenheit?: number | null, max_intake_pressure_psi?: number | null, housing_material?: string | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, inner_diameter_inches?: any | null, outer_diameter_inches: any, neck_inner_diameter_inches?: any | null, neck_outer_diameter_inches?: any | null } | null, step_down_transformer?: { __typename: 'step_down_transformers', id: any, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, manufacturer?: string | null, part_number?: string | null, transformer_type?: string | null, primary_voltage_delta?: number | null, primary_voltage_wye?: number | null, min_secondary_voltage?: number | null, max_secondary_voltage?: number | null, weight_pounds?: number | null, enclosure?: string | null, kva?: number | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null } | null, step_up_transformer?: { __typename: 'step_up_transformers', id: any, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, manufacturer?: string | null, part_number?: string | null, transformer_type?: string | null, primary_voltage?: number | null, min_secondary_voltage?: number | null, max_secondary_voltage?: number | null, weight_pounds?: number | null, enclosure?: string | null, kva?: number | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null } | null, switchboard?: { __typename: 'switchboards', id: any, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, amps?: number | null, enclosure?: string | null, kv?: any | null, manufacturer?: string | null, part_number?: string | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null } | null, variable_speed_drive?: { __typename: 'variable_speed_drives', id: any, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, enclosure?: string | null, kva?: number | null, manufacturer?: string | null, max_amps?: number | null, part_number?: string | null, vsd_type?: string | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null } | null }> } | null, update_quote_line_items_many?: Array<{ __typename: 'quote_line_items_mutation_response', returning: Array<{ __typename: 'quote_line_items', quote_id: any, category?: Quote_Line_Item_Category_Dataset_Enum | null, created_at: any, credit?: any | null, deleted_at?: any | null, erp_material_long_description?: string | null, erp_material_number?: string | null, erp_material_short_description?: string | null, erp_price?: any | null, erp_product_hierarchy?: string | null, erp_uom?: string | null, erp_serialized?: Quote_Line_Item_Serialized_Dataset_Enum | null, id: any, line_item_type?: Quote_Line_Item_Type_Dataset_Enum | null, margin?: any | null, note?: string | null, parent_order?: number | null, price_override?: any | null, pricing_date?: any | null, quantity?: number | null, source?: Quote_Line_Item_Source_Dataset_Enum | null, subcategory?: Quote_Line_Item_Subcategory_Dataset_Enum | null, sub_order?: number | null, tax_type?: Quote_Line_Item_Tax_Type_Dataset_Enum | null, updated_at: any, spyglass_equipment_import_json?: any | null, cable?: { __typename: 'cables', id: any, amp_factor?: any | null, armor?: string | null, construction?: string | null, depth_inches?: any | null, family?: string | null, gauge?: string | null, kv?: number | null, manufacturer?: string | null, max_temperature_fahrenheit?: number | null, part_number?: string | null, pound_per_foot?: any | null, width_inches?: any | null, impedance_60_hz_per_1000_ft?: any | null, resistance_per_1000_ft?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, author_id: string, created_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, updated_at: any } | null, intake?: { __typename: 'intakes', id: any, manufacturer?: string | null, intake_type?: string | null, part_number?: string | null, configuration?: string | null, length_inches?: any | null, weight_pounds?: any | null, shaft_material?: string | null, shaft_limit_hp?: number | null, housing_material?: string | null, max_rate_bpd?: number | null, hp?: any | null, eff1?: any | null, eff2?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, high_strength_shaft_limit_hp?: number | null, stage_count?: number | null, bhp0?: any | null, bhp1?: any | null, bhp2?: any | null, bhp3?: any | null, bhp4?: any | null, bhp5?: any | null, bolt_on?: boolean | null, port_area_square_inches: any, inner_diameter_inches?: any | null, outer_diameter_inches?: any | null, neck_inner_diameter_inches?: any | null, neck_outer_diameter_inches?: any | null, is_hps: boolean, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null } | null, motor?: { __typename: 'motors', id: any, author_id: string, allow_rerate: boolean, configuration?: string | null, created_at: any, deleted_at?: any | null, eff1?: any | null, eff2?: any | null, eff3?: any | null, eff4?: any | null, eff5?: any | null, effb?: any | null, i1?: any | null, i2?: any | null, i3?: any | null, i4?: any | null, i5?: any | null, ib?: any | null, imported_sizing_id?: number | null, length_inches?: any | null, manufacturer?: string | null, n1?: any | null, n2?: any | null, n3?: any | null, n4?: any | null, n5?: any | null, nameplate_current?: number | null, nameplate_horsepower?: number | null, nameplate_voltage?: number | null, nb?: any | null, oil_volume_gallons?: any | null, part_number?: string | null, pf1?: any | null, pf2?: any | null, pf3?: any | null, pf4?: any | null, pf5?: any | null, pfb?: any | null, rr_l1?: any | null, rr_l2?: any | null, rr_lb?: any | null, rr_v3: any, rr_v2: any, rr_v1?: any | null, rr_vb?: any | null, shaft_horsepower?: number | null, nv0: any, nv1: any, nv2: any, iv0: any, iv1: any, iv2: any, pfv0: any, pfv1: any, pfv2: any, effv0: any, effv1: any, effv2: any, tv0: any, tv1: any, tv2: any, temperature_rating_fahrenheit?: number | null, updated_at: any, weight_pounds?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, poles?: number | null, stator_inner_diameter_inches?: any | null, stator_outer_diameter_inches?: any | null, k3?: any | null, nameplate_rerate_ratio?: any | null, inner_diameter_inches?: any | null, outer_diameter_inches?: any | null, neck_inner_diameter_inches?: any | null, neck_outer_diameter_inches?: any | null, mle_offset_depth_inches: any, outer_diameter_rub_inches: any, is_hps: boolean } | null, motor_lead_extension?: { __typename: 'motor_lead_extensions', id: any, manufacturer?: string | null, part_number?: string | null, series?: number | null, family?: string | null, gauge?: number | null, kv?: number | null, max_pothead_temperature_fahrenheit?: number | null, max_temperature_fahrenheit?: number | null, resistance_per_1000_ft?: any | null, impedance_60_hz_per_1000_ft?: any | null, amp_factor?: any | null, width_inches?: any | null, depth_inches?: any | null, pound_per_foot?: any | null, length_feet?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null } | null, pump?: { __typename: 'pumps', id: any, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, manufacturer?: string | null, rotation?: string | null, part_number?: string | null, compression_thrust_per_stage?: any | null, series_model?: string | null, stage_type?: number | null, shaft_diameter_inches?: any | null, standard_housing_pressure_rating_psi?: number | null, high_strength_housing_pressure_rating_psi?: number | null, standard_shaft_rating_hp?: number | null, high_strength_shaft_rating_hp?: number | null, construction?: string | null, min_rate_standard_pump_bpd?: number | null, bep_rate_standard_pump_bpd?: number | null, max_rate_standard_pump_bpd?: number | null, max_graph_rate_standard_pump_bpd?: number | null, hb?: any | null, h1?: any | null, h2?: any | null, h3?: any | null, h4?: any | null, h5?: any | null, bhpb?: any | null, bhp1?: any | null, bhp2?: any | null, bhp3?: any | null, bhp4?: any | null, bhp5?: any | null, npsh1?: any | null, npsh2?: any | null, npsh3?: any | null, npsh4?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, max_bolt_load_pounds?: any | null, is_compression_pump: boolean, housing_inner_diameter_inches?: any | null, housing_outer_diameter_inches?: any | null, neck_inner_diameter_inches?: any | null, neck_outer_diameter_inches?: any | null } | null, seal?: { __typename: 'seals', id: any, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, manufacturer?: string | null, part_number?: string | null, length_inches?: any | null, weight_pounds?: any | null, configuration?: string | null, max_temperature_fahrenheit?: number | null, standard_shaft_limit_hp?: number | null, high_strength_shaft_limit_hp?: number | null, standard_bearing_rating_pounds?: number | null, high_strength_bearing_rating_pounds?: number | null, housing_material?: string | null, bearing_type?: string | null, total_seal_volume_gallons?: any | null, volume_for_bag_expansion_lower_tandem_gallons?: any | null, volume_for_bag_expansion_upper_tandem_gallons?: any | null, upper_chamber_pull_volume_gallons?: any | null, bag_chambers?: number | null, bag_capacity_gallons?: any | null, string_load_pounds?: any | null, load_cb_pounds?: any | null, load_c1_pounds?: any | null, hps_thrust_chamber: boolean, load_test_temperature_fahrenheit?: number | null, description?: string | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, inner_diameter_inches?: any | null, outer_diameter_inches?: any | null, neck_inner_diameter_inches?: any | null, neck_outer_diameter_inches?: any | null, thrust_collar_inner_diameter_inches: any, thrust_collar_outer_diameter_inches: any } | null, sensor?: { __typename: 'sensors', id: any, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, manufacturer?: string | null, part_number?: string | null, length_inches?: number | null, weight_pounds?: number | null, model?: string | null, channels?: number | null, max_intake_temperature_fahrenheit?: number | null, max_intake_pressure_psi?: number | null, housing_material?: string | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, inner_diameter_inches?: any | null, outer_diameter_inches: any, neck_inner_diameter_inches?: any | null, neck_outer_diameter_inches?: any | null } | null, step_down_transformer?: { __typename: 'step_down_transformers', id: any, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, manufacturer?: string | null, part_number?: string | null, transformer_type?: string | null, primary_voltage_delta?: number | null, primary_voltage_wye?: number | null, min_secondary_voltage?: number | null, max_secondary_voltage?: number | null, weight_pounds?: number | null, enclosure?: string | null, kva?: number | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null } | null, step_up_transformer?: { __typename: 'step_up_transformers', id: any, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, manufacturer?: string | null, part_number?: string | null, transformer_type?: string | null, primary_voltage?: number | null, min_secondary_voltage?: number | null, max_secondary_voltage?: number | null, weight_pounds?: number | null, enclosure?: string | null, kva?: number | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null } | null, switchboard?: { __typename: 'switchboards', id: any, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, amps?: number | null, enclosure?: string | null, kv?: any | null, manufacturer?: string | null, part_number?: string | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null } | null, variable_speed_drive?: { __typename: 'variable_speed_drives', id: any, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, enclosure?: string | null, kva?: number | null, manufacturer?: string | null, max_amps?: number | null, part_number?: string | null, vsd_type?: string | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null } | null }> } | null> | null };

export type InsertQuoteLineItemMutationVariables = Exact<{
  object: Quote_Line_Items_Insert_Input;
}>;


export type InsertQuoteLineItemMutation = { __typename: 'mutation_root', insert_quote_line_items_one?: { __typename: 'quote_line_items', category?: Quote_Line_Item_Category_Dataset_Enum | null, created_at: any, credit?: any | null, deleted_at?: any | null, erp_material_long_description?: string | null, erp_material_number?: string | null, erp_material_short_description?: string | null, erp_price?: any | null, erp_product_hierarchy?: string | null, erp_uom?: string | null, erp_serialized?: Quote_Line_Item_Serialized_Dataset_Enum | null, id: any, line_item_type?: Quote_Line_Item_Type_Dataset_Enum | null, margin?: any | null, note?: string | null, parent_order?: number | null, price_override?: any | null, pricing_date?: any | null, quantity?: number | null, source?: Quote_Line_Item_Source_Dataset_Enum | null, subcategory?: Quote_Line_Item_Subcategory_Dataset_Enum | null, sub_order?: number | null, tax_type?: Quote_Line_Item_Tax_Type_Dataset_Enum | null, updated_at: any, spyglass_equipment_import_json?: any | null, spyglass_cable?: any | null, spyglass_intake?: any | null, spyglass_motor?: any | null, spyglass_motor_lead_extension?: any | null, spyglass_pump?: any | null, spyglass_seal?: any | null, spyglass_sensor?: any | null, spyglass_step_down_transformer?: any | null, spyglass_step_up_transformer?: any | null, spyglass_switchboard?: any | null, spyglass_variable_speed_drive?: any | null, cable?: { __typename: 'cables', id: any } | null, intake?: { __typename: 'intakes', id: any } | null, motor?: { __typename: 'motors', id: any } | null, motor_lead_extension?: { __typename: 'motor_lead_extensions', id: any } | null, pump?: { __typename: 'pumps', id: any } | null, seal?: { __typename: 'seals', id: any } | null, sensor?: { __typename: 'sensors', id: any } | null, step_down_transformer?: { __typename: 'step_down_transformers', id: any } | null, step_up_transformer?: { __typename: 'step_up_transformers', id: any } | null, switchboard?: { __typename: 'switchboards', id: any } | null, variable_speed_drive?: { __typename: 'variable_speed_drives', id: any } | null } | null };

export type UpdateQuoteLineItemByPkMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  object: Quote_Line_Items_Set_Input;
}>;


export type UpdateQuoteLineItemByPkMutation = { __typename: 'mutation_root', update_quote_line_items_by_pk?: { __typename: 'quote_line_items', category?: Quote_Line_Item_Category_Dataset_Enum | null, created_at: any, credit?: any | null, deleted_at?: any | null, erp_material_long_description?: string | null, erp_material_number?: string | null, erp_material_short_description?: string | null, erp_price?: any | null, erp_product_hierarchy?: string | null, erp_uom?: string | null, erp_serialized?: Quote_Line_Item_Serialized_Dataset_Enum | null, id: any, line_item_type?: Quote_Line_Item_Type_Dataset_Enum | null, margin?: any | null, note?: string | null, parent_order?: number | null, price_override?: any | null, pricing_date?: any | null, quantity?: number | null, source?: Quote_Line_Item_Source_Dataset_Enum | null, subcategory?: Quote_Line_Item_Subcategory_Dataset_Enum | null, sub_order?: number | null, tax_type?: Quote_Line_Item_Tax_Type_Dataset_Enum | null, updated_at: any, spyglass_equipment_import_json?: any | null, spyglass_cable?: any | null, spyglass_intake?: any | null, spyglass_motor?: any | null, spyglass_motor_lead_extension?: any | null, spyglass_pump?: any | null, spyglass_seal?: any | null, spyglass_sensor?: any | null, spyglass_step_down_transformer?: any | null, spyglass_step_up_transformer?: any | null, spyglass_switchboard?: any | null, spyglass_variable_speed_drive?: any | null, cable?: { __typename: 'cables', id: any } | null, intake?: { __typename: 'intakes', id: any } | null, motor?: { __typename: 'motors', id: any } | null, motor_lead_extension?: { __typename: 'motor_lead_extensions', id: any } | null, pump?: { __typename: 'pumps', id: any } | null, seal?: { __typename: 'seals', id: any } | null, sensor?: { __typename: 'sensors', id: any } | null, step_down_transformer?: { __typename: 'step_down_transformers', id: any } | null, step_up_transformer?: { __typename: 'step_up_transformers', id: any } | null, switchboard?: { __typename: 'switchboards', id: any } | null, variable_speed_drive?: { __typename: 'variable_speed_drives', id: any } | null } | null };

export type UpdateManyQuoteLineItemsMutationVariables = Exact<{
  object: Array<Quote_Line_Items_Updates>;
}>;


export type UpdateManyQuoteLineItemsMutation = { __typename: 'mutation_root', update_quote_line_items_many?: Array<{ __typename: 'quote_line_items_mutation_response', affected_rows: number } | null> | null };

export type QuoteParentFieldsFragment = { __typename: 'quotes', id: any, name?: string | null, version_number?: number | null };

export type QuoteLineItemFieldsFragment = { __typename: 'quote_line_items', quote_id: any, category?: Quote_Line_Item_Category_Dataset_Enum | null, created_at: any, credit?: any | null, deleted_at?: any | null, erp_material_long_description?: string | null, erp_material_number?: string | null, erp_material_short_description?: string | null, erp_price?: any | null, erp_product_hierarchy?: string | null, erp_uom?: string | null, erp_serialized?: Quote_Line_Item_Serialized_Dataset_Enum | null, id: any, line_item_type?: Quote_Line_Item_Type_Dataset_Enum | null, margin?: any | null, note?: string | null, parent_order?: number | null, price_override?: any | null, pricing_date?: any | null, quantity?: number | null, source?: Quote_Line_Item_Source_Dataset_Enum | null, subcategory?: Quote_Line_Item_Subcategory_Dataset_Enum | null, sub_order?: number | null, tax_type?: Quote_Line_Item_Tax_Type_Dataset_Enum | null, updated_at: any, spyglass_equipment_import_json?: any | null, cable?: { __typename: 'cables', id: any, amp_factor?: any | null, armor?: string | null, construction?: string | null, depth_inches?: any | null, family?: string | null, gauge?: string | null, kv?: number | null, manufacturer?: string | null, max_temperature_fahrenheit?: number | null, part_number?: string | null, pound_per_foot?: any | null, width_inches?: any | null, impedance_60_hz_per_1000_ft?: any | null, resistance_per_1000_ft?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, author_id: string, created_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, updated_at: any } | null, intake?: { __typename: 'intakes', id: any, manufacturer?: string | null, intake_type?: string | null, part_number?: string | null, configuration?: string | null, length_inches?: any | null, weight_pounds?: any | null, shaft_material?: string | null, shaft_limit_hp?: number | null, housing_material?: string | null, max_rate_bpd?: number | null, hp?: any | null, eff1?: any | null, eff2?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, high_strength_shaft_limit_hp?: number | null, stage_count?: number | null, bhp0?: any | null, bhp1?: any | null, bhp2?: any | null, bhp3?: any | null, bhp4?: any | null, bhp5?: any | null, bolt_on?: boolean | null, port_area_square_inches: any, inner_diameter_inches?: any | null, outer_diameter_inches?: any | null, neck_inner_diameter_inches?: any | null, neck_outer_diameter_inches?: any | null, is_hps: boolean, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null } | null, motor?: { __typename: 'motors', id: any, author_id: string, allow_rerate: boolean, configuration?: string | null, created_at: any, deleted_at?: any | null, eff1?: any | null, eff2?: any | null, eff3?: any | null, eff4?: any | null, eff5?: any | null, effb?: any | null, i1?: any | null, i2?: any | null, i3?: any | null, i4?: any | null, i5?: any | null, ib?: any | null, imported_sizing_id?: number | null, length_inches?: any | null, manufacturer?: string | null, n1?: any | null, n2?: any | null, n3?: any | null, n4?: any | null, n5?: any | null, nameplate_current?: number | null, nameplate_horsepower?: number | null, nameplate_voltage?: number | null, nb?: any | null, oil_volume_gallons?: any | null, part_number?: string | null, pf1?: any | null, pf2?: any | null, pf3?: any | null, pf4?: any | null, pf5?: any | null, pfb?: any | null, rr_l1?: any | null, rr_l2?: any | null, rr_lb?: any | null, rr_v3: any, rr_v2: any, rr_v1?: any | null, rr_vb?: any | null, shaft_horsepower?: number | null, nv0: any, nv1: any, nv2: any, iv0: any, iv1: any, iv2: any, pfv0: any, pfv1: any, pfv2: any, effv0: any, effv1: any, effv2: any, tv0: any, tv1: any, tv2: any, temperature_rating_fahrenheit?: number | null, updated_at: any, weight_pounds?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, poles?: number | null, stator_inner_diameter_inches?: any | null, stator_outer_diameter_inches?: any | null, k3?: any | null, nameplate_rerate_ratio?: any | null, inner_diameter_inches?: any | null, outer_diameter_inches?: any | null, neck_inner_diameter_inches?: any | null, neck_outer_diameter_inches?: any | null, mle_offset_depth_inches: any, outer_diameter_rub_inches: any, is_hps: boolean } | null, motor_lead_extension?: { __typename: 'motor_lead_extensions', id: any, manufacturer?: string | null, part_number?: string | null, series?: number | null, family?: string | null, gauge?: number | null, kv?: number | null, max_pothead_temperature_fahrenheit?: number | null, max_temperature_fahrenheit?: number | null, resistance_per_1000_ft?: any | null, impedance_60_hz_per_1000_ft?: any | null, amp_factor?: any | null, width_inches?: any | null, depth_inches?: any | null, pound_per_foot?: any | null, length_feet?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null } | null, pump?: { __typename: 'pumps', id: any, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, manufacturer?: string | null, rotation?: string | null, part_number?: string | null, compression_thrust_per_stage?: any | null, series_model?: string | null, stage_type?: number | null, shaft_diameter_inches?: any | null, standard_housing_pressure_rating_psi?: number | null, high_strength_housing_pressure_rating_psi?: number | null, standard_shaft_rating_hp?: number | null, high_strength_shaft_rating_hp?: number | null, construction?: string | null, min_rate_standard_pump_bpd?: number | null, bep_rate_standard_pump_bpd?: number | null, max_rate_standard_pump_bpd?: number | null, max_graph_rate_standard_pump_bpd?: number | null, hb?: any | null, h1?: any | null, h2?: any | null, h3?: any | null, h4?: any | null, h5?: any | null, bhpb?: any | null, bhp1?: any | null, bhp2?: any | null, bhp3?: any | null, bhp4?: any | null, bhp5?: any | null, npsh1?: any | null, npsh2?: any | null, npsh3?: any | null, npsh4?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, max_bolt_load_pounds?: any | null, is_compression_pump: boolean, housing_inner_diameter_inches?: any | null, housing_outer_diameter_inches?: any | null, neck_inner_diameter_inches?: any | null, neck_outer_diameter_inches?: any | null } | null, seal?: { __typename: 'seals', id: any, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, manufacturer?: string | null, part_number?: string | null, length_inches?: any | null, weight_pounds?: any | null, configuration?: string | null, max_temperature_fahrenheit?: number | null, standard_shaft_limit_hp?: number | null, high_strength_shaft_limit_hp?: number | null, standard_bearing_rating_pounds?: number | null, high_strength_bearing_rating_pounds?: number | null, housing_material?: string | null, bearing_type?: string | null, total_seal_volume_gallons?: any | null, volume_for_bag_expansion_lower_tandem_gallons?: any | null, volume_for_bag_expansion_upper_tandem_gallons?: any | null, upper_chamber_pull_volume_gallons?: any | null, bag_chambers?: number | null, bag_capacity_gallons?: any | null, string_load_pounds?: any | null, load_cb_pounds?: any | null, load_c1_pounds?: any | null, hps_thrust_chamber: boolean, load_test_temperature_fahrenheit?: number | null, description?: string | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, inner_diameter_inches?: any | null, outer_diameter_inches?: any | null, neck_inner_diameter_inches?: any | null, neck_outer_diameter_inches?: any | null, thrust_collar_inner_diameter_inches: any, thrust_collar_outer_diameter_inches: any } | null, sensor?: { __typename: 'sensors', id: any, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, manufacturer?: string | null, part_number?: string | null, length_inches?: number | null, weight_pounds?: number | null, model?: string | null, channels?: number | null, max_intake_temperature_fahrenheit?: number | null, max_intake_pressure_psi?: number | null, housing_material?: string | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, inner_diameter_inches?: any | null, outer_diameter_inches: any, neck_inner_diameter_inches?: any | null, neck_outer_diameter_inches?: any | null } | null, step_down_transformer?: { __typename: 'step_down_transformers', id: any, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, manufacturer?: string | null, part_number?: string | null, transformer_type?: string | null, primary_voltage_delta?: number | null, primary_voltage_wye?: number | null, min_secondary_voltage?: number | null, max_secondary_voltage?: number | null, weight_pounds?: number | null, enclosure?: string | null, kva?: number | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null } | null, step_up_transformer?: { __typename: 'step_up_transformers', id: any, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, manufacturer?: string | null, part_number?: string | null, transformer_type?: string | null, primary_voltage?: number | null, min_secondary_voltage?: number | null, max_secondary_voltage?: number | null, weight_pounds?: number | null, enclosure?: string | null, kva?: number | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null } | null, switchboard?: { __typename: 'switchboards', id: any, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, amps?: number | null, enclosure?: string | null, kv?: any | null, manufacturer?: string | null, part_number?: string | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null } | null, variable_speed_drive?: { __typename: 'variable_speed_drives', id: any, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, enclosure?: string | null, kva?: number | null, manufacturer?: string | null, max_amps?: number | null, part_number?: string | null, vsd_type?: string | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null } | null };

export type QuoteLineItemsUpdateInsertFieldsFragment = { __typename: 'quote_line_items', category?: Quote_Line_Item_Category_Dataset_Enum | null, created_at: any, credit?: any | null, deleted_at?: any | null, erp_material_long_description?: string | null, erp_material_number?: string | null, erp_material_short_description?: string | null, erp_price?: any | null, erp_product_hierarchy?: string | null, erp_uom?: string | null, erp_serialized?: Quote_Line_Item_Serialized_Dataset_Enum | null, id: any, line_item_type?: Quote_Line_Item_Type_Dataset_Enum | null, margin?: any | null, note?: string | null, parent_order?: number | null, price_override?: any | null, pricing_date?: any | null, quantity?: number | null, source?: Quote_Line_Item_Source_Dataset_Enum | null, subcategory?: Quote_Line_Item_Subcategory_Dataset_Enum | null, sub_order?: number | null, tax_type?: Quote_Line_Item_Tax_Type_Dataset_Enum | null, updated_at: any, spyglass_equipment_import_json?: any | null, spyglass_cable?: any | null, spyglass_intake?: any | null, spyglass_motor?: any | null, spyglass_motor_lead_extension?: any | null, spyglass_pump?: any | null, spyglass_seal?: any | null, spyglass_sensor?: any | null, spyglass_step_down_transformer?: any | null, spyglass_step_up_transformer?: any | null, spyglass_switchboard?: any | null, spyglass_variable_speed_drive?: any | null, cable?: { __typename: 'cables', id: any } | null, intake?: { __typename: 'intakes', id: any } | null, motor?: { __typename: 'motors', id: any } | null, motor_lead_extension?: { __typename: 'motor_lead_extensions', id: any } | null, pump?: { __typename: 'pumps', id: any } | null, seal?: { __typename: 'seals', id: any } | null, sensor?: { __typename: 'sensors', id: any } | null, step_down_transformer?: { __typename: 'step_down_transformers', id: any } | null, step_up_transformer?: { __typename: 'step_up_transformers', id: any } | null, switchboard?: { __typename: 'switchboards', id: any } | null, variable_speed_drive?: { __typename: 'variable_speed_drives', id: any } | null };

export type ScenarioCorrelationsFieldsFragment = { __typename: 'scenario_correlations', id?: any | null, journal_author_id?: string | null, journal_deleted_at?: any | null, winning_revision_id?: any | null, bubble_point?: string | null, dead_oil?: string | null, friction_loss?: string | null, gas_compressibility?: string | null, gas_viscosity?: string | null, tubing_hazen_williams_coefficient?: any | null, casing_hazen_williams_coefficient?: any | null, tubing_apply_hazen_williams_correction?: boolean | null, casing_apply_hazen_williams_correction?: boolean | null, oil_density?: string | null, oil_volume_factor_saturated?: string | null, oil_volume_factor_undersaturated?: string | null, tubing_palmer_correction?: boolean | null, casing_palmer_correction?: boolean | null, tubing_griffith_wallis?: boolean | null, casing_griffith_wallis?: boolean | null, salinity_ppm?: any | null, saturated_oil?: string | null, solution_gor?: string | null, tubing_flow?: string | null, casing_flow?: string | null, tubing_roughness_inches?: any | null, casing_roughness_inches?: any | null, under_saturated_oil?: string | null, water_density?: string | null, water_solution_gas?: string | null, water_viscosity?: string | null, water_volume_factor?: string | null, natural_gas_separation?: string | null, tdh_tuning_factor_ratio?: any | null };

export type CorrelationsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scenario_Correlations_Bool_Exp>;
  order_by?: InputMaybe<Array<Scenario_Correlations_Order_By>>;
}>;


export type CorrelationsQuery = { __typename: 'query_root', scenario_correlations: Array<{ __typename: 'scenario_correlations', id?: any | null, journal_author_id?: string | null, journal_deleted_at?: any | null, winning_revision_id?: any | null, bubble_point?: string | null, dead_oil?: string | null, friction_loss?: string | null, gas_compressibility?: string | null, gas_viscosity?: string | null, tubing_hazen_williams_coefficient?: any | null, casing_hazen_williams_coefficient?: any | null, tubing_apply_hazen_williams_correction?: boolean | null, casing_apply_hazen_williams_correction?: boolean | null, oil_density?: string | null, oil_volume_factor_saturated?: string | null, oil_volume_factor_undersaturated?: string | null, tubing_palmer_correction?: boolean | null, casing_palmer_correction?: boolean | null, tubing_griffith_wallis?: boolean | null, casing_griffith_wallis?: boolean | null, salinity_ppm?: any | null, saturated_oil?: string | null, solution_gor?: string | null, tubing_flow?: string | null, casing_flow?: string | null, tubing_roughness_inches?: any | null, casing_roughness_inches?: any | null, under_saturated_oil?: string | null, water_density?: string | null, water_solution_gas?: string | null, water_viscosity?: string | null, water_volume_factor?: string | null, natural_gas_separation?: string | null, tdh_tuning_factor_ratio?: any | null }> };

export type InsertCorrelationsRevisionMutationVariables = Exact<{
  object: Revisions_Scenario_Correlations_Revisions_Insert_Input;
}>;


export type InsertCorrelationsRevisionMutation = { __typename: 'mutation_root', insert_revisions_scenario_correlations_revisions_one?: { __typename: 'revisions_scenario_correlations_revisions', id: any, scenario_correlations_view?: { __typename: 'scenario_correlations', id?: any | null, journal_author_id?: string | null, journal_deleted_at?: any | null, winning_revision_id?: any | null, bubble_point?: string | null, dead_oil?: string | null, friction_loss?: string | null, gas_compressibility?: string | null, gas_viscosity?: string | null, tubing_hazen_williams_coefficient?: any | null, casing_hazen_williams_coefficient?: any | null, tubing_apply_hazen_williams_correction?: boolean | null, casing_apply_hazen_williams_correction?: boolean | null, oil_density?: string | null, oil_volume_factor_saturated?: string | null, oil_volume_factor_undersaturated?: string | null, tubing_palmer_correction?: boolean | null, casing_palmer_correction?: boolean | null, tubing_griffith_wallis?: boolean | null, casing_griffith_wallis?: boolean | null, salinity_ppm?: any | null, saturated_oil?: string | null, solution_gor?: string | null, tubing_flow?: string | null, casing_flow?: string | null, tubing_roughness_inches?: any | null, casing_roughness_inches?: any | null, under_saturated_oil?: string | null, water_density?: string | null, water_solution_gas?: string | null, water_viscosity?: string | null, water_volume_factor?: string | null, natural_gas_separation?: string | null, tdh_tuning_factor_ratio?: any | null } | null } | null };

export type ScenarioEquipmentBaseFieldsFragment = { __typename: 'scenario_equipment', id?: any | null, journal_author_id?: string | null, journal_created_at?: any | null, journal_updated_at?: any | null, journal_deleted_at?: any | null, mle_id?: any | null, lower_mle_id?: any | null, motor_id?: any | null, lower_motor_id?: any | null, bolt_on_discharge_id?: any | null, lower_bolt_on_discharge_id?: any | null, shroud_id?: any | null, lower_shroud_id?: any | null, parent_id?: any | null, sensor_id?: any | null, lower_sensor_id?: any | null, switchboard_id?: any | null, down_trans_id?: any | null, up_trans_id?: any | null, use_vsd?: boolean | null, use_uphole_y_tool?: boolean | null, use_downhole_y_tool?: boolean | null, has_lower_equip_stack?: boolean | null, vsd_id?: any | null, seals_order?: Array<any> | null, lower_seals_order?: Array<any> | null, winning_revision_author_id?: string | null, winning_revision_id?: any | null, intakes_order?: Array<any> | null, lower_intakes_order?: Array<any> | null, cables_order?: Array<any> | null, lower_cables_order?: Array<any> | null, pumps_order?: Array<any> | null, lower_pumps_order?: Array<any> | null, seal_motor_oil_id?: any | null, lower_seal_motor_oil_id?: any | null, uphole_y_tool_id?: any | null, downhole_y_tool_id?: any | null, include_y_tool?: boolean | null, uphole_y_tool_bypass_tubing_order?: Array<any> | null, uphole_y_tool_equipment_tubing_order?: Array<any> | null, downhole_y_tool_bypass_tubing_order?: Array<any> | null, downhole_y_tool_equipment_tubing_order?: Array<any> | null };

export type ScenarioEquipmentQueryVariables = Exact<{
  distinct_on?: InputMaybe<Array<Scenario_Equipment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Scenario_Equipment_Order_By>>;
  where?: InputMaybe<Scenario_Equipment_Bool_Exp>;
}>;


export type ScenarioEquipmentQuery = { __typename: 'query_root', scenario_equipment: Array<{ __typename: 'scenario_equipment', id?: any | null, journal_author_id?: string | null, journal_created_at?: any | null, journal_updated_at?: any | null, journal_deleted_at?: any | null, mle_id?: any | null, lower_mle_id?: any | null, motor_id?: any | null, lower_motor_id?: any | null, bolt_on_discharge_id?: any | null, lower_bolt_on_discharge_id?: any | null, shroud_id?: any | null, lower_shroud_id?: any | null, parent_id?: any | null, sensor_id?: any | null, lower_sensor_id?: any | null, switchboard_id?: any | null, down_trans_id?: any | null, up_trans_id?: any | null, use_vsd?: boolean | null, use_uphole_y_tool?: boolean | null, use_downhole_y_tool?: boolean | null, has_lower_equip_stack?: boolean | null, vsd_id?: any | null, seals_order?: Array<any> | null, lower_seals_order?: Array<any> | null, winning_revision_author_id?: string | null, winning_revision_id?: any | null, intakes_order?: Array<any> | null, lower_intakes_order?: Array<any> | null, cables_order?: Array<any> | null, lower_cables_order?: Array<any> | null, pumps_order?: Array<any> | null, lower_pumps_order?: Array<any> | null, seal_motor_oil_id?: any | null, lower_seal_motor_oil_id?: any | null, uphole_y_tool_id?: any | null, downhole_y_tool_id?: any | null, include_y_tool?: boolean | null, uphole_y_tool_bypass_tubing_order?: Array<any> | null, uphole_y_tool_equipment_tubing_order?: Array<any> | null, downhole_y_tool_bypass_tubing_order?: Array<any> | null, downhole_y_tool_equipment_tubing_order?: Array<any> | null, r_sensor?: { __typename: 'sensors', id: any, manufacturer?: string | null, part_number?: string | null, model?: string | null, length_inches?: number | null, weight_pounds?: number | null, inner_diameter_inches?: any | null, outer_diameter_inches: any, neck_inner_diameter_inches?: any | null, neck_outer_diameter_inches?: any | null } | null, r_lower_sensor?: { __typename: 'sensors', id: any, manufacturer?: string | null, part_number?: string | null, model?: string | null, length_inches?: number | null, weight_pounds?: number | null, inner_diameter_inches?: any | null, outer_diameter_inches: any, neck_inner_diameter_inches?: any | null, neck_outer_diameter_inches?: any | null } | null, r_mle?: { __typename: 'motor_lead_extensions', id: any, manufacturer?: string | null, part_number?: string | null, series?: number | null, family?: string | null, gauge?: number | null, kv?: number | null, max_pothead_temperature_fahrenheit?: number | null, max_temperature_fahrenheit?: number | null, resistance_per_1000_ft?: any | null, impedance_60_hz_per_1000_ft?: any | null, amp_factor?: any | null, width_inches?: any | null, depth_inches?: any | null, pound_per_foot?: any | null, length_feet?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null } | null, r_lower_mle?: { __typename: 'motor_lead_extensions', id: any, manufacturer?: string | null, part_number?: string | null, series?: number | null, family?: string | null, gauge?: number | null, kv?: number | null, max_pothead_temperature_fahrenheit?: number | null, max_temperature_fahrenheit?: number | null, resistance_per_1000_ft?: any | null, impedance_60_hz_per_1000_ft?: any | null, amp_factor?: any | null, width_inches?: any | null, depth_inches?: any | null, pound_per_foot?: any | null, length_feet?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null } | null, r_motor?: { __typename: 'motors', id: any, author_id: string, allow_rerate: boolean, configuration?: string | null, created_at: any, deleted_at?: any | null, eff1?: any | null, eff2?: any | null, eff3?: any | null, eff4?: any | null, eff5?: any | null, effb?: any | null, i1?: any | null, i2?: any | null, i3?: any | null, i4?: any | null, i5?: any | null, ib?: any | null, imported_sizing_id?: number | null, length_inches?: any | null, manufacturer?: string | null, n1?: any | null, n2?: any | null, n3?: any | null, n4?: any | null, n5?: any | null, nameplate_current?: number | null, nameplate_horsepower?: number | null, nameplate_voltage?: number | null, nb?: any | null, oil_volume_gallons?: any | null, part_number?: string | null, pf1?: any | null, pf2?: any | null, pf3?: any | null, pf4?: any | null, pf5?: any | null, pfb?: any | null, rr_l1?: any | null, rr_l2?: any | null, rr_lb?: any | null, rr_v3: any, rr_v2: any, rr_v1?: any | null, rr_vb?: any | null, shaft_horsepower?: number | null, nv0: any, nv1: any, nv2: any, iv0: any, iv1: any, iv2: any, pfv0: any, pfv1: any, pfv2: any, effv0: any, effv1: any, effv2: any, tv0: any, tv1: any, tv2: any, temperature_rating_fahrenheit?: number | null, updated_at: any, weight_pounds?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, poles?: number | null, stator_inner_diameter_inches?: any | null, stator_outer_diameter_inches?: any | null, k3?: any | null, nameplate_rerate_ratio?: any | null, inner_diameter_inches?: any | null, outer_diameter_inches?: any | null, neck_inner_diameter_inches?: any | null, neck_outer_diameter_inches?: any | null, mle_offset_depth_inches: any, outer_diameter_rub_inches: any, is_hps: boolean } | null, r_bolt_on_discharge?: { __typename: 'bolt_on_discharges', id: any, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, manufacturer?: string | null, series_model?: string | null, is_hps: boolean, outer_diameter_inches?: any | null, inner_diameter_inches?: any | null, flange_outer_diameter_inches?: any | null, neck_outer_diameter_inches?: any | null, neck_inner_diameter_inches?: any | null, length_inches?: any | null, weight_pounds?: any | null, tubing_diameter_inches?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null } | null, r_lower_bolt_on_discharge?: { __typename: 'bolt_on_discharges', id: any, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, manufacturer?: string | null, series_model?: string | null, is_hps: boolean, outer_diameter_inches?: any | null, inner_diameter_inches?: any | null, flange_outer_diameter_inches?: any | null, neck_outer_diameter_inches?: any | null, neck_inner_diameter_inches?: any | null, length_inches?: any | null, weight_pounds?: any | null, tubing_diameter_inches?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null } | null, r_lower_motor?: { __typename: 'motors', id: any, author_id: string, allow_rerate: boolean, configuration?: string | null, created_at: any, deleted_at?: any | null, eff1?: any | null, eff2?: any | null, eff3?: any | null, eff4?: any | null, eff5?: any | null, effb?: any | null, i1?: any | null, i2?: any | null, i3?: any | null, i4?: any | null, i5?: any | null, ib?: any | null, imported_sizing_id?: number | null, length_inches?: any | null, manufacturer?: string | null, n1?: any | null, n2?: any | null, n3?: any | null, n4?: any | null, n5?: any | null, nameplate_current?: number | null, nameplate_horsepower?: number | null, nameplate_voltage?: number | null, nb?: any | null, oil_volume_gallons?: any | null, part_number?: string | null, pf1?: any | null, pf2?: any | null, pf3?: any | null, pf4?: any | null, pf5?: any | null, pfb?: any | null, rr_l1?: any | null, rr_l2?: any | null, rr_lb?: any | null, rr_v3: any, rr_v2: any, rr_v1?: any | null, rr_vb?: any | null, shaft_horsepower?: number | null, nv0: any, nv1: any, nv2: any, iv0: any, iv1: any, iv2: any, pfv0: any, pfv1: any, pfv2: any, effv0: any, effv1: any, effv2: any, tv0: any, tv1: any, tv2: any, temperature_rating_fahrenheit?: number | null, updated_at: any, weight_pounds?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, poles?: number | null, stator_inner_diameter_inches?: any | null, stator_outer_diameter_inches?: any | null, k3?: any | null, nameplate_rerate_ratio?: any | null, inner_diameter_inches?: any | null, outer_diameter_inches?: any | null, neck_inner_diameter_inches?: any | null, neck_outer_diameter_inches?: any | null, mle_offset_depth_inches: any, outer_diameter_rub_inches: any, is_hps: boolean } | null, r_shroud?: { __typename: 'casings', id: any, casing_type: Casings_Type_Enum, imperial_name?: string | null, metric_name?: string | null, outer_diameter_inches?: any | null, interior_diameter_inches?: any | null, drift_inches?: any | null, coupling_outer_diameter_inches?: any | null, pound_per_foot?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null } | null, r_lower_shroud?: { __typename: 'casings', id: any, casing_type: Casings_Type_Enum, imperial_name?: string | null, metric_name?: string | null, outer_diameter_inches?: any | null, interior_diameter_inches?: any | null, drift_inches?: any | null, coupling_outer_diameter_inches?: any | null, pound_per_foot?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null } | null, r_step_down_transformer?: { __typename: 'step_down_transformers', id: any, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, manufacturer?: string | null, part_number?: string | null, transformer_type?: string | null, primary_voltage_delta?: number | null, primary_voltage_wye?: number | null, min_secondary_voltage?: number | null, max_secondary_voltage?: number | null, weight_pounds?: number | null, enclosure?: string | null, kva?: number | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null } | null, r_step_up_transformer?: { __typename: 'step_up_transformers', id: any, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, manufacturer?: string | null, part_number?: string | null, transformer_type?: string | null, primary_voltage?: number | null, min_secondary_voltage?: number | null, max_secondary_voltage?: number | null, weight_pounds?: number | null, enclosure?: string | null, kva?: number | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null } | null, r_vsd?: { __typename: 'variable_speed_drives', id: any, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, enclosure?: string | null, kva?: number | null, manufacturer?: string | null, max_amps?: number | null, part_number?: string | null, vsd_type?: string | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null } | null, r_switchboard?: { __typename: 'switchboards', id: any, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, amps?: number | null, enclosure?: string | null, kv?: any | null, manufacturer?: string | null, part_number?: string | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null } | null, r_seal_motor_oil?: { __typename: 'seal_motor_oil', created_at: any, updated_at: any, deleted_at?: any | null, id: any, name: string, thermal_expansion_factor?: any | null, max_temp_fahrenheit?: number | null, mf_test_temp1_celsius?: number | null, mf_test_temp2_celsius?: number | null, viscosity_test1_centistroke?: any | null, viscosity_test2_centistroke?: any | null, specific_gravity?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null } | null, r_lower_seal_motor_oil?: { __typename: 'seal_motor_oil', created_at: any, updated_at: any, deleted_at?: any | null, id: any, name: string, thermal_expansion_factor?: any | null, max_temp_fahrenheit?: number | null, mf_test_temp1_celsius?: number | null, mf_test_temp2_celsius?: number | null, viscosity_test1_centistroke?: any | null, viscosity_test2_centistroke?: any | null, specific_gravity?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null } | null, r_uphole_y_tool?: { __typename: 'y_tools', id: any, author_id: string, created_at: any, deleted_at?: any | null, updated_at: any, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, minimum_inches?: any | null, maximum_inches?: any | null, length_inches?: any | null, width_inches?: any | null, series_model?: string | null, outer_diameter_inches?: any | null, teleswivel_stroke_length_inches?: any | null, pressure_rating_psi?: number | null, temperature_rating_fahrenheit?: number | null, handling_sub_connection_inches?: any | null, bypass_connection_inches?: any | null, material_type?: string | null, weight_pounds?: any | null, manufacturer?: string | null } | null, r_downhole_y_tool?: { __typename: 'y_tools', id: any, author_id: string, created_at: any, deleted_at?: any | null, updated_at: any, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, minimum_inches?: any | null, maximum_inches?: any | null, length_inches?: any | null, width_inches?: any | null, series_model?: string | null, outer_diameter_inches?: any | null, teleswivel_stroke_length_inches?: any | null, pressure_rating_psi?: number | null, temperature_rating_fahrenheit?: number | null, handling_sub_connection_inches?: any | null, bypass_connection_inches?: any | null, material_type?: string | null, weight_pounds?: any | null, manufacturer?: string | null } | null, r_xref_uphole_y_tool_bypass_tubings: Array<{ __typename: 'sc_equip_xref_uphole_ytool_bypass_tubings', id?: any | null, length_feet?: any | null, tubing_id?: any | null, scenario_equipment_id?: any | null, parent_id?: any | null, journal_author_id?: string | null, journal_created_at?: any | null, journal_updated_at?: any | null, journal_deleted_at?: any | null, winning_revision_id?: any | null, winning_revision_parent_id?: any | null, winning_revision_author_id?: string | null, winning_revision_created_at?: any | null, winning_revision_updated_at?: any | null, winning_revision_deleted_at?: any | null, r_tubing?: { __typename: 'tubings', id: any, author_id: string, coupling_outer_diameter_inches?: any | null, created_at: any, deleted_at?: any | null, drift_inches?: any | null, imperial_name?: string | null, imported_sizing_id?: number | null, interior_diameter_inches?: any | null, metric_name?: string | null, outer_diameter_inches?: any | null, pound_per_foot?: any | null, tubing_type: Tubings_Type_Enum, updated_at: any, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null } | null }>, r_xref_uphole_y_tool_equipment_tubings: Array<{ __typename: 'sc_equip_xref_uphole_ytool_equip_tubings', id?: any | null, length_feet?: any | null, tubing_id?: any | null, scenario_equipment_id?: any | null, parent_id?: any | null, journal_author_id?: string | null, journal_created_at?: any | null, journal_updated_at?: any | null, journal_deleted_at?: any | null, winning_revision_id?: any | null, winning_revision_parent_id?: any | null, winning_revision_author_id?: string | null, winning_revision_created_at?: any | null, winning_revision_updated_at?: any | null, winning_revision_deleted_at?: any | null, r_tubing?: { __typename: 'tubings', id: any, author_id: string, coupling_outer_diameter_inches?: any | null, created_at: any, deleted_at?: any | null, drift_inches?: any | null, imperial_name?: string | null, imported_sizing_id?: number | null, interior_diameter_inches?: any | null, metric_name?: string | null, outer_diameter_inches?: any | null, pound_per_foot?: any | null, tubing_type: Tubings_Type_Enum, updated_at: any, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null } | null }>, r_xref_downhole_y_tool_bypass_tubings: Array<{ __typename: 'sc_equip_xref_downhole_ytool_bypass_tubings', id?: any | null, length_feet?: any | null, tubing_id?: any | null, scenario_equipment_id?: any | null, parent_id?: any | null, journal_author_id?: string | null, journal_created_at?: any | null, journal_updated_at?: any | null, journal_deleted_at?: any | null, winning_revision_id?: any | null, winning_revision_parent_id?: any | null, winning_revision_author_id?: string | null, winning_revision_created_at?: any | null, winning_revision_updated_at?: any | null, winning_revision_deleted_at?: any | null, r_tubing?: { __typename: 'tubings', id: any, author_id: string, coupling_outer_diameter_inches?: any | null, created_at: any, deleted_at?: any | null, drift_inches?: any | null, imperial_name?: string | null, imported_sizing_id?: number | null, interior_diameter_inches?: any | null, metric_name?: string | null, outer_diameter_inches?: any | null, pound_per_foot?: any | null, tubing_type: Tubings_Type_Enum, updated_at: any, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null } | null }>, r_xref_downhole_y_tool_equipment_tubings: Array<{ __typename: 'sc_equip_xref_downhole_ytool_equip_tubings', id?: any | null, length_feet?: any | null, tubing_id?: any | null, scenario_equipment_id?: any | null, parent_id?: any | null, journal_author_id?: string | null, journal_created_at?: any | null, journal_updated_at?: any | null, journal_deleted_at?: any | null, winning_revision_id?: any | null, winning_revision_parent_id?: any | null, winning_revision_author_id?: string | null, winning_revision_created_at?: any | null, winning_revision_updated_at?: any | null, winning_revision_deleted_at?: any | null, r_tubing?: { __typename: 'tubings', id: any, author_id: string, coupling_outer_diameter_inches?: any | null, created_at: any, deleted_at?: any | null, drift_inches?: any | null, imperial_name?: string | null, imported_sizing_id?: number | null, interior_diameter_inches?: any | null, metric_name?: string | null, outer_diameter_inches?: any | null, pound_per_foot?: any | null, tubing_type: Tubings_Type_Enum, updated_at: any, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null } | null }> }> };

export type InsertScenarioEquipmentRevisionMutationVariables = Exact<{
  object: Revisions_Scenario_Equipment_Revisions_Insert_Input;
}>;


export type InsertScenarioEquipmentRevisionMutation = { __typename: 'mutation_root', insert_revisions_scenario_equipment_revisions_one?: { __typename: 'revisions_scenario_equipment_revisions', id: any, scenario_equipment_view?: { __typename: 'scenario_equipment', id?: any | null, journal_author_id?: string | null, journal_created_at?: any | null, journal_updated_at?: any | null, journal_deleted_at?: any | null, mle_id?: any | null, lower_mle_id?: any | null, motor_id?: any | null, lower_motor_id?: any | null, bolt_on_discharge_id?: any | null, lower_bolt_on_discharge_id?: any | null, shroud_id?: any | null, lower_shroud_id?: any | null, parent_id?: any | null, sensor_id?: any | null, lower_sensor_id?: any | null, switchboard_id?: any | null, down_trans_id?: any | null, up_trans_id?: any | null, use_vsd?: boolean | null, use_uphole_y_tool?: boolean | null, use_downhole_y_tool?: boolean | null, has_lower_equip_stack?: boolean | null, vsd_id?: any | null, seals_order?: Array<any> | null, lower_seals_order?: Array<any> | null, winning_revision_author_id?: string | null, winning_revision_id?: any | null, intakes_order?: Array<any> | null, lower_intakes_order?: Array<any> | null, cables_order?: Array<any> | null, lower_cables_order?: Array<any> | null, pumps_order?: Array<any> | null, lower_pumps_order?: Array<any> | null, seal_motor_oil_id?: any | null, lower_seal_motor_oil_id?: any | null, uphole_y_tool_id?: any | null, downhole_y_tool_id?: any | null, include_y_tool?: boolean | null, uphole_y_tool_bypass_tubing_order?: Array<any> | null, uphole_y_tool_equipment_tubing_order?: Array<any> | null, downhole_y_tool_bypass_tubing_order?: Array<any> | null, downhole_y_tool_equipment_tubing_order?: Array<any> | null } | null } | null };

export type ScenarioEquipmentCablesBaseFieldsFragment = { __typename: 'scenario_equipment_xref_cables', id?: any | null, length_feet?: any | null, cable_id?: any | null, scenario_equipment_id?: any | null, parent_id?: any | null, journal_author_id?: string | null, journal_created_at?: any | null, journal_updated_at?: any | null, journal_deleted_at?: any | null, winning_revision_id?: any | null, winning_revision_parent_id?: any | null, winning_revision_author_id?: string | null, winning_revision_created_at?: any | null, winning_revision_updated_at?: any | null, winning_revision_deleted_at?: any | null };

export type ScenarioEquipmentXrefCablesQueryVariables = Exact<{
  distinct_on?: InputMaybe<Array<Scenario_Equipment_Xref_Cables_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Scenario_Equipment_Xref_Cables_Order_By>>;
  where?: InputMaybe<Scenario_Equipment_Xref_Cables_Bool_Exp>;
}>;


export type ScenarioEquipmentXrefCablesQuery = { __typename: 'query_root', scenario_equipment_xref_cables: Array<{ __typename: 'scenario_equipment_xref_cables', id?: any | null, length_feet?: any | null, cable_id?: any | null, scenario_equipment_id?: any | null, parent_id?: any | null, journal_author_id?: string | null, journal_created_at?: any | null, journal_updated_at?: any | null, journal_deleted_at?: any | null, winning_revision_id?: any | null, winning_revision_parent_id?: any | null, winning_revision_author_id?: string | null, winning_revision_created_at?: any | null, winning_revision_updated_at?: any | null, winning_revision_deleted_at?: any | null, r_cable?: { __typename: 'cables', id: any, amp_factor?: any | null, armor?: string | null, construction?: string | null, depth_inches?: any | null, family?: string | null, gauge?: string | null, kv?: number | null, manufacturer?: string | null, max_temperature_fahrenheit?: number | null, part_number?: string | null, pound_per_foot?: any | null, width_inches?: any | null, impedance_60_hz_per_1000_ft?: any | null, resistance_per_1000_ft?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, author_id: string, created_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, updated_at: any } | null }> };

export type ScenarioEquipmentHousingsFieldsFragment = { __typename: 'scenario_equipment_xref_housings', housing_id?: any | null, id?: any | null, journal_author_id?: string | null, journal_created_at?: any | null, journal_deleted_at?: any | null, journal_updated_at?: any | null, length_inches?: any | null, parent_id?: any | null, scenario_equipment_xref_pump_id?: any | null, stage_count?: number | null, winning_revision_author_id?: string | null, winning_revision_created_at?: any | null, winning_revision_deleted_at?: any | null, winning_revision_id?: any | null, winning_revision_parent_id?: any | null, winning_revision_updated_at?: any | null };

export type ScenarioEquipmentXrefHousingsQueryVariables = Exact<{
  distinct_on?: InputMaybe<Array<Scenario_Equipment_Xref_Housings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Scenario_Equipment_Xref_Housings_Order_By>>;
  where?: InputMaybe<Scenario_Equipment_Xref_Housings_Bool_Exp>;
}>;


export type ScenarioEquipmentXrefHousingsQuery = { __typename: 'query_root', scenario_equipment_xref_housings: Array<{ __typename: 'scenario_equipment_xref_housings', housing_id?: any | null, id?: any | null, journal_author_id?: string | null, journal_created_at?: any | null, journal_deleted_at?: any | null, journal_updated_at?: any | null, length_inches?: any | null, parent_id?: any | null, scenario_equipment_xref_pump_id?: any | null, stage_count?: number | null, winning_revision_author_id?: string | null, winning_revision_created_at?: any | null, winning_revision_deleted_at?: any | null, winning_revision_id?: any | null, winning_revision_parent_id?: any | null, winning_revision_updated_at?: any | null, r_housing?: { __typename: 'housings', id: any, housing_number?: number | null, stage_count?: number | null, length_inches?: any | null, weight_pounds?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, pump_id?: any | null } | null }> };

export type ScenarioEquipmentIntakesBaseFieldsFragment = { __typename: 'scenario_equipment_xref_intakes', id?: any | null, intake_id?: any | null, scenario_equipment_id?: any | null, use_high_strength_shaft?: boolean | null, parent_id?: any | null, journal_author_id?: string | null, journal_created_at?: any | null, journal_updated_at?: any | null, journal_deleted_at?: any | null, winning_revision_id?: any | null, winning_revision_parent_id?: any | null, winning_revision_author_id?: string | null, winning_revision_created_at?: any | null, winning_revision_updated_at?: any | null, winning_revision_deleted_at?: any | null };

export type ScenarioEquipmentXrefIntakesQueryVariables = Exact<{
  distinct_on?: InputMaybe<Array<Scenario_Equipment_Xref_Intakes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Scenario_Equipment_Xref_Intakes_Order_By>>;
  where?: InputMaybe<Scenario_Equipment_Xref_Intakes_Bool_Exp>;
}>;


export type ScenarioEquipmentXrefIntakesQuery = { __typename: 'query_root', scenario_equipment_xref_intakes: Array<{ __typename: 'scenario_equipment_xref_intakes', id?: any | null, intake_id?: any | null, scenario_equipment_id?: any | null, use_high_strength_shaft?: boolean | null, parent_id?: any | null, journal_author_id?: string | null, journal_created_at?: any | null, journal_updated_at?: any | null, journal_deleted_at?: any | null, winning_revision_id?: any | null, winning_revision_parent_id?: any | null, winning_revision_author_id?: string | null, winning_revision_created_at?: any | null, winning_revision_updated_at?: any | null, winning_revision_deleted_at?: any | null, r_intake?: { __typename: 'intakes', id: any, manufacturer?: string | null, intake_type?: string | null, part_number?: string | null, configuration?: string | null, length_inches?: any | null, weight_pounds?: any | null, shaft_material?: string | null, shaft_limit_hp?: number | null, housing_material?: string | null, max_rate_bpd?: number | null, hp?: any | null, eff1?: any | null, eff2?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, high_strength_shaft_limit_hp?: number | null, stage_count?: number | null, bhp0?: any | null, bhp1?: any | null, bhp2?: any | null, bhp3?: any | null, bhp4?: any | null, bhp5?: any | null, bolt_on?: boolean | null, port_area_square_inches: any, inner_diameter_inches?: any | null, outer_diameter_inches?: any | null, neck_inner_diameter_inches?: any | null, neck_outer_diameter_inches?: any | null, is_hps: boolean, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null } | null }> };

export type ScenarioEquipmentXrefDownholeYToolBypassTubingsBaseFieldsFragment = { __typename: 'sc_equip_xref_downhole_ytool_bypass_tubings', id?: any | null, length_feet?: any | null, tubing_id?: any | null, scenario_equipment_id?: any | null, parent_id?: any | null, journal_author_id?: string | null, journal_created_at?: any | null, journal_updated_at?: any | null, journal_deleted_at?: any | null, winning_revision_id?: any | null, winning_revision_parent_id?: any | null, winning_revision_author_id?: string | null, winning_revision_created_at?: any | null, winning_revision_updated_at?: any | null, winning_revision_deleted_at?: any | null };

export type ScenarioEquipmentXrefDownholeYToolBypassTubingsQueryVariables = Exact<{
  distinct_on?: InputMaybe<Array<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Order_By>>;
  where?: InputMaybe<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Bool_Exp>;
}>;


export type ScenarioEquipmentXrefDownholeYToolBypassTubingsQuery = { __typename: 'query_root', sc_equip_xref_downhole_ytool_bypass_tubings: Array<{ __typename: 'sc_equip_xref_downhole_ytool_bypass_tubings', id?: any | null, length_feet?: any | null, tubing_id?: any | null, scenario_equipment_id?: any | null, parent_id?: any | null, journal_author_id?: string | null, journal_created_at?: any | null, journal_updated_at?: any | null, journal_deleted_at?: any | null, winning_revision_id?: any | null, winning_revision_parent_id?: any | null, winning_revision_author_id?: string | null, winning_revision_created_at?: any | null, winning_revision_updated_at?: any | null, winning_revision_deleted_at?: any | null, r_tubing?: { __typename: 'tubings', id: any, author_id: string, coupling_outer_diameter_inches?: any | null, created_at: any, deleted_at?: any | null, drift_inches?: any | null, imperial_name?: string | null, imported_sizing_id?: number | null, interior_diameter_inches?: any | null, metric_name?: string | null, outer_diameter_inches?: any | null, pound_per_foot?: any | null, tubing_type: Tubings_Type_Enum, updated_at: any, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null } | null }> };

export type ScenarioEquipmentXrefDownholeYToolEquipmentTubingsBaseFieldsFragment = { __typename: 'sc_equip_xref_downhole_ytool_equip_tubings', id?: any | null, length_feet?: any | null, tubing_id?: any | null, scenario_equipment_id?: any | null, parent_id?: any | null, journal_author_id?: string | null, journal_created_at?: any | null, journal_updated_at?: any | null, journal_deleted_at?: any | null, winning_revision_id?: any | null, winning_revision_parent_id?: any | null, winning_revision_author_id?: string | null, winning_revision_created_at?: any | null, winning_revision_updated_at?: any | null, winning_revision_deleted_at?: any | null };

export type ScenarioEquipmentXrefDownholeYToolEquipmentTubingsQueryVariables = Exact<{
  distinct_on?: InputMaybe<Array<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Order_By>>;
  where?: InputMaybe<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Bool_Exp>;
}>;


export type ScenarioEquipmentXrefDownholeYToolEquipmentTubingsQuery = { __typename: 'query_root', sc_equip_xref_downhole_ytool_equip_tubings: Array<{ __typename: 'sc_equip_xref_downhole_ytool_equip_tubings', id?: any | null, length_feet?: any | null, tubing_id?: any | null, scenario_equipment_id?: any | null, parent_id?: any | null, journal_author_id?: string | null, journal_created_at?: any | null, journal_updated_at?: any | null, journal_deleted_at?: any | null, winning_revision_id?: any | null, winning_revision_parent_id?: any | null, winning_revision_author_id?: string | null, winning_revision_created_at?: any | null, winning_revision_updated_at?: any | null, winning_revision_deleted_at?: any | null, r_tubing?: { __typename: 'tubings', id: any, author_id: string, coupling_outer_diameter_inches?: any | null, created_at: any, deleted_at?: any | null, drift_inches?: any | null, imperial_name?: string | null, imported_sizing_id?: number | null, interior_diameter_inches?: any | null, metric_name?: string | null, outer_diameter_inches?: any | null, pound_per_foot?: any | null, tubing_type: Tubings_Type_Enum, updated_at: any, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null } | null }> };

export type ScenarioEquipmentPumpsFieldsFragment = { __typename: 'scenario_equipment_xref_pumps', id?: any | null, scenario_equipment_id?: any | null, pump_id?: any | null, rate_correction_ratio?: any | null, head_correction_ratio?: any | null, brake_horsepower_correction_ratio?: any | null, total_stages?: number | null, length_feet?: any | null, housings_order?: Array<any> | null, use_high_strength_shaft?: boolean | null, weight_pounds?: any | null, parent_id?: any | null, journal_author_id?: string | null, journal_created_at?: any | null, journal_updated_at?: any | null, journal_deleted_at?: any | null, winning_revision_id?: any | null, winning_revision_parent_id?: any | null, winning_revision_author_id?: string | null, winning_revision_created_at?: any | null, winning_revision_updated_at?: any | null, winning_revision_deleted_at?: any | null };

export type ScenarioEquipmentXrefPumpsQueryVariables = Exact<{
  distinct_on?: InputMaybe<Array<Scenario_Equipment_Xref_Pumps_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Scenario_Equipment_Xref_Pumps_Order_By>>;
  where?: InputMaybe<Scenario_Equipment_Xref_Pumps_Bool_Exp>;
  housings_where?: InputMaybe<Scenario_Equipment_Xref_Housings_Bool_Exp>;
}>;


export type ScenarioEquipmentXrefPumpsQuery = { __typename: 'query_root', scenario_equipment_xref_pumps: Array<{ __typename: 'scenario_equipment_xref_pumps', id?: any | null, scenario_equipment_id?: any | null, pump_id?: any | null, rate_correction_ratio?: any | null, head_correction_ratio?: any | null, brake_horsepower_correction_ratio?: any | null, total_stages?: number | null, length_feet?: any | null, housings_order?: Array<any> | null, use_high_strength_shaft?: boolean | null, weight_pounds?: any | null, parent_id?: any | null, journal_author_id?: string | null, journal_created_at?: any | null, journal_updated_at?: any | null, journal_deleted_at?: any | null, winning_revision_id?: any | null, winning_revision_parent_id?: any | null, winning_revision_author_id?: string | null, winning_revision_created_at?: any | null, winning_revision_updated_at?: any | null, winning_revision_deleted_at?: any | null, r_pump?: { __typename: 'pumps', id: any, manufacturer?: string | null, series_model?: string | null, rotation?: string | null, part_number?: string | null, compression_thrust_per_stage?: any | null, shaft_diameter_inches?: any | null, max_bolt_load_pounds?: any | null, is_compression_pump: boolean, housing_inner_diameter_inches?: any | null, housing_outer_diameter_inches?: any | null, neck_inner_diameter_inches?: any | null, neck_outer_diameter_inches?: any | null } | null, r_xref_housings: Array<{ __typename: 'scenario_equipment_xref_housings', housing_id?: any | null, id?: any | null, journal_author_id?: string | null, journal_created_at?: any | null, journal_deleted_at?: any | null, journal_updated_at?: any | null, length_inches?: any | null, parent_id?: any | null, scenario_equipment_xref_pump_id?: any | null, stage_count?: number | null, winning_revision_author_id?: string | null, winning_revision_created_at?: any | null, winning_revision_deleted_at?: any | null, winning_revision_id?: any | null, winning_revision_parent_id?: any | null, winning_revision_updated_at?: any | null, r_housing?: { __typename: 'housings', id: any, housing_number?: number | null, stage_count?: number | null, length_inches?: any | null, weight_pounds?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, pump_id?: any | null } | null }> }> };

export type ScenarioEquipmentSealsBaseFieldsFragment = { __typename: 'scenario_equipment_xref_seals', id?: any | null, use_high_strength_shaft?: boolean | null, parent_id?: any | null, journal_author_id?: string | null, journal_created_at?: any | null, journal_updated_at?: any | null, journal_deleted_at?: any | null, winning_revision_id?: any | null, winning_revision_parent_id?: any | null, scenario_equipment_id?: any | null, seal_id?: any | null, winning_revision_author_id?: string | null, winning_revision_created_at?: any | null, winning_revision_updated_at?: any | null, winning_revision_deleted_at?: any | null };

export type ScenarioEquipmentXrefSealsQueryVariables = Exact<{
  distinct_on?: InputMaybe<Array<Scenario_Equipment_Xref_Seals_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Scenario_Equipment_Xref_Seals_Order_By>>;
  where?: InputMaybe<Scenario_Equipment_Xref_Seals_Bool_Exp>;
}>;


export type ScenarioEquipmentXrefSealsQuery = { __typename: 'query_root', scenario_equipment_xref_seals: Array<{ __typename: 'scenario_equipment_xref_seals', id?: any | null, use_high_strength_shaft?: boolean | null, parent_id?: any | null, journal_author_id?: string | null, journal_created_at?: any | null, journal_updated_at?: any | null, journal_deleted_at?: any | null, winning_revision_id?: any | null, winning_revision_parent_id?: any | null, scenario_equipment_id?: any | null, seal_id?: any | null, winning_revision_author_id?: string | null, winning_revision_created_at?: any | null, winning_revision_updated_at?: any | null, winning_revision_deleted_at?: any | null, r_seal?: { __typename: 'seals', id: any, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, manufacturer?: string | null, part_number?: string | null, length_inches?: any | null, weight_pounds?: any | null, configuration?: string | null, max_temperature_fahrenheit?: number | null, standard_shaft_limit_hp?: number | null, high_strength_shaft_limit_hp?: number | null, standard_bearing_rating_pounds?: number | null, high_strength_bearing_rating_pounds?: number | null, housing_material?: string | null, bearing_type?: string | null, total_seal_volume_gallons?: any | null, volume_for_bag_expansion_lower_tandem_gallons?: any | null, volume_for_bag_expansion_upper_tandem_gallons?: any | null, upper_chamber_pull_volume_gallons?: any | null, bag_chambers?: number | null, bag_capacity_gallons?: any | null, string_load_pounds?: any | null, load_cb_pounds?: any | null, load_c1_pounds?: any | null, hps_thrust_chamber: boolean, load_test_temperature_fahrenheit?: number | null, description?: string | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, inner_diameter_inches?: any | null, outer_diameter_inches?: any | null, neck_inner_diameter_inches?: any | null, neck_outer_diameter_inches?: any | null, thrust_collar_inner_diameter_inches: any, thrust_collar_outer_diameter_inches: any } | null }> };

export type ScenarioEquipmentXrefUpholeYToolBypassTubingsBaseFieldsFragment = { __typename: 'sc_equip_xref_uphole_ytool_bypass_tubings', id?: any | null, length_feet?: any | null, tubing_id?: any | null, scenario_equipment_id?: any | null, parent_id?: any | null, journal_author_id?: string | null, journal_created_at?: any | null, journal_updated_at?: any | null, journal_deleted_at?: any | null, winning_revision_id?: any | null, winning_revision_parent_id?: any | null, winning_revision_author_id?: string | null, winning_revision_created_at?: any | null, winning_revision_updated_at?: any | null, winning_revision_deleted_at?: any | null };

export type ScenarioEquipmentXrefUpholeYToolBypassTubingsQueryVariables = Exact<{
  distinct_on?: InputMaybe<Array<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Order_By>>;
  where?: InputMaybe<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Bool_Exp>;
}>;


export type ScenarioEquipmentXrefUpholeYToolBypassTubingsQuery = { __typename: 'query_root', sc_equip_xref_uphole_ytool_bypass_tubings: Array<{ __typename: 'sc_equip_xref_uphole_ytool_bypass_tubings', id?: any | null, length_feet?: any | null, tubing_id?: any | null, scenario_equipment_id?: any | null, parent_id?: any | null, journal_author_id?: string | null, journal_created_at?: any | null, journal_updated_at?: any | null, journal_deleted_at?: any | null, winning_revision_id?: any | null, winning_revision_parent_id?: any | null, winning_revision_author_id?: string | null, winning_revision_created_at?: any | null, winning_revision_updated_at?: any | null, winning_revision_deleted_at?: any | null, r_tubing?: { __typename: 'tubings', id: any, author_id: string, coupling_outer_diameter_inches?: any | null, created_at: any, deleted_at?: any | null, drift_inches?: any | null, imperial_name?: string | null, imported_sizing_id?: number | null, interior_diameter_inches?: any | null, metric_name?: string | null, outer_diameter_inches?: any | null, pound_per_foot?: any | null, tubing_type: Tubings_Type_Enum, updated_at: any, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null } | null }> };

export type ScenarioEquipmentXrefUpholeYToolEquipmentTubingsBaseFieldsFragment = { __typename: 'sc_equip_xref_uphole_ytool_equip_tubings', id?: any | null, length_feet?: any | null, tubing_id?: any | null, scenario_equipment_id?: any | null, parent_id?: any | null, journal_author_id?: string | null, journal_created_at?: any | null, journal_updated_at?: any | null, journal_deleted_at?: any | null, winning_revision_id?: any | null, winning_revision_parent_id?: any | null, winning_revision_author_id?: string | null, winning_revision_created_at?: any | null, winning_revision_updated_at?: any | null, winning_revision_deleted_at?: any | null };

export type ScenarioEquipmentXrefUpholeYToolEquipmentTubingsQueryVariables = Exact<{
  distinct_on?: InputMaybe<Array<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Order_By>>;
  where?: InputMaybe<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Bool_Exp>;
}>;


export type ScenarioEquipmentXrefUpholeYToolEquipmentTubingsQuery = { __typename: 'query_root', sc_equip_xref_uphole_ytool_equip_tubings: Array<{ __typename: 'sc_equip_xref_uphole_ytool_equip_tubings', id?: any | null, length_feet?: any | null, tubing_id?: any | null, scenario_equipment_id?: any | null, parent_id?: any | null, journal_author_id?: string | null, journal_created_at?: any | null, journal_updated_at?: any | null, journal_deleted_at?: any | null, winning_revision_id?: any | null, winning_revision_parent_id?: any | null, winning_revision_author_id?: string | null, winning_revision_created_at?: any | null, winning_revision_updated_at?: any | null, winning_revision_deleted_at?: any | null, r_tubing?: { __typename: 'tubings', id: any, author_id: string, coupling_outer_diameter_inches?: any | null, created_at: any, deleted_at?: any | null, drift_inches?: any | null, imperial_name?: string | null, imported_sizing_id?: number | null, interior_diameter_inches?: any | null, metric_name?: string | null, outer_diameter_inches?: any | null, pound_per_foot?: any | null, tubing_type: Tubings_Type_Enum, updated_at: any, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null } | null }> };

export type ScenariosFieldsFragment = { __typename: 'scenarios', id?: any | null, journal_author_id?: string | null, journal_created_at?: any | null, journal_updated_at?: any | null, journal_deleted_at?: any | null, winning_revision_id?: any | null, title?: string | null, notes?: string | null, internal_notes?: string | null, reason?: string | null, sizing_id?: any | null, well_properties_id?: any | null, scenario_equipment_id?: any | null, parameters_id?: any | null, correlations_id?: any | null, display_unit_overrides?: any | null, pumping_type?: string | null };

export type ScenariosListFieldsFragment = { __typename: 'scenarios', id?: any | null, sizing_id?: any | null, journal_author_id?: string | null, journal_deleted_at?: any | null, well_properties_id?: any | null, scenario_equipment_id?: any | null, parameters_id?: any | null, correlations_id?: any | null, title?: string | null, pumping_type?: string | null };

export type ScenariosQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scenarios_Bool_Exp>;
  order_by?: InputMaybe<Array<Scenarios_Order_By>>;
  withAggregate?: Scalars['Boolean']['input'];
}>;


export type ScenariosQuery = { __typename: 'query_root', scenarios: Array<{ __typename: 'scenarios', id?: any | null, journal_author_id?: string | null, journal_created_at?: any | null, journal_updated_at?: any | null, journal_deleted_at?: any | null, winning_revision_id?: any | null, title?: string | null, notes?: string | null, internal_notes?: string | null, reason?: string | null, sizing_id?: any | null, well_properties_id?: any | null, scenario_equipment_id?: any | null, parameters_id?: any | null, correlations_id?: any | null, display_unit_overrides?: any | null, pumping_type?: string | null, author?: { __typename: 'users', id: string, email?: string | null, username?: string | null, display_name?: string | null, hal_identifier?: string | null } | null, sizing?: { __typename: 'sizings', id?: any | null, journal_author_id?: string | null, journal_deleted_at?: any | null, well_id?: number | null, customer_id?: number | null, title?: string | null, notes?: string | null, well?: { __typename: 'wells', id: number, well_name?: string | null, well_uwi?: string | null, well_erp_id?: string | null, address_erp_id?: string | null } | null, customer?: { __typename: 'customers', id: number, customer_name?: string | null, customer_erp_id: string, imported_sizing_id?: number | null } | null } | null }>, scenarios_aggregate?: { __typename: 'scenarios_aggregate', id: 'scenarios_aggregate', aggregate?: { __typename: 'scenarios_aggregate_fields', count: number, id: 'scenarios_aggregate_fields' } | null } };

export type QuoteScenariosBySizingQueryVariables = Exact<{
  sizing_id?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type QuoteScenariosBySizingQuery = { __typename: 'query_root', scenarios: Array<{ __typename: 'scenarios', id?: any | null, parent_id?: any | null, title?: string | null, journal_author_id?: string | null, journal_created_at?: any | null, quotes: Array<{ __typename: 'quotes', name?: string | null, id: any, version_number?: number | null, spyglass_scenario_id?: any | null, status: Quote_Status_Dataset_Enum, prepared_by_id?: string | null, created_at: any, parent?: { __typename: 'quotes', id: any } | null }> }> };

export type ScenariosToGenerateQuotesQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scenarios_Bool_Exp>;
  order_by?: InputMaybe<Array<Scenarios_Order_By>>;
  withAggregate?: Scalars['Boolean']['input'];
}>;


export type ScenariosToGenerateQuotesQuery = { __typename: 'query_root', scenarios: Array<{ __typename: 'scenarios', id?: any | null, journal_author_id?: string | null, journal_created_at?: any | null, journal_updated_at?: any | null, journal_deleted_at?: any | null, winning_revision_id?: any | null, title?: string | null, notes?: string | null, internal_notes?: string | null, reason?: string | null, sizing_id?: any | null, well_properties_id?: any | null, scenario_equipment_id?: any | null, parameters_id?: any | null, correlations_id?: any | null, display_unit_overrides?: any | null, pumping_type?: string | null, author?: { __typename: 'users', id: string, email?: string | null, username?: string | null, display_name?: string | null, hal_identifier?: string | null } | null, equipment?: { __typename: 'scenario_equipment', id?: any | null, journal_author_id?: string | null, journal_created_at?: any | null, journal_updated_at?: any | null, journal_deleted_at?: any | null, mle_id?: any | null, lower_mle_id?: any | null, motor_id?: any | null, lower_motor_id?: any | null, bolt_on_discharge_id?: any | null, lower_bolt_on_discharge_id?: any | null, shroud_id?: any | null, lower_shroud_id?: any | null, parent_id?: any | null, sensor_id?: any | null, lower_sensor_id?: any | null, switchboard_id?: any | null, down_trans_id?: any | null, up_trans_id?: any | null, use_vsd?: boolean | null, use_uphole_y_tool?: boolean | null, use_downhole_y_tool?: boolean | null, has_lower_equip_stack?: boolean | null, vsd_id?: any | null, seals_order?: Array<any> | null, lower_seals_order?: Array<any> | null, winning_revision_author_id?: string | null, winning_revision_id?: any | null, intakes_order?: Array<any> | null, lower_intakes_order?: Array<any> | null, cables_order?: Array<any> | null, lower_cables_order?: Array<any> | null, pumps_order?: Array<any> | null, lower_pumps_order?: Array<any> | null, seal_motor_oil_id?: any | null, lower_seal_motor_oil_id?: any | null, uphole_y_tool_id?: any | null, downhole_y_tool_id?: any | null, include_y_tool?: boolean | null, uphole_y_tool_bypass_tubing_order?: Array<any> | null, uphole_y_tool_equipment_tubing_order?: Array<any> | null, downhole_y_tool_bypass_tubing_order?: Array<any> | null, downhole_y_tool_equipment_tubing_order?: Array<any> | null, r_sensor?: { __typename: 'sensors', id: any, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, manufacturer?: string | null, part_number?: string | null, length_inches?: number | null, weight_pounds?: number | null, model?: string | null, channels?: number | null, max_intake_temperature_fahrenheit?: number | null, max_intake_pressure_psi?: number | null, housing_material?: string | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, inner_diameter_inches?: any | null, outer_diameter_inches: any, neck_inner_diameter_inches?: any | null, neck_outer_diameter_inches?: any | null } | null, r_lower_sensor?: { __typename: 'sensors', id: any, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, manufacturer?: string | null, part_number?: string | null, length_inches?: number | null, weight_pounds?: number | null, model?: string | null, channels?: number | null, max_intake_temperature_fahrenheit?: number | null, max_intake_pressure_psi?: number | null, housing_material?: string | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, inner_diameter_inches?: any | null, outer_diameter_inches: any, neck_inner_diameter_inches?: any | null, neck_outer_diameter_inches?: any | null } | null, r_mle?: { __typename: 'motor_lead_extensions', id: any, manufacturer?: string | null, part_number?: string | null, series?: number | null, family?: string | null, gauge?: number | null, kv?: number | null, max_pothead_temperature_fahrenheit?: number | null, max_temperature_fahrenheit?: number | null, resistance_per_1000_ft?: any | null, impedance_60_hz_per_1000_ft?: any | null, amp_factor?: any | null, width_inches?: any | null, depth_inches?: any | null, pound_per_foot?: any | null, length_feet?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null } | null, r_lower_mle?: { __typename: 'motor_lead_extensions', id: any, manufacturer?: string | null, part_number?: string | null, series?: number | null, family?: string | null, gauge?: number | null, kv?: number | null, max_pothead_temperature_fahrenheit?: number | null, max_temperature_fahrenheit?: number | null, resistance_per_1000_ft?: any | null, impedance_60_hz_per_1000_ft?: any | null, amp_factor?: any | null, width_inches?: any | null, depth_inches?: any | null, pound_per_foot?: any | null, length_feet?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null } | null, r_motor?: { __typename: 'motors', id: any, author_id: string, allow_rerate: boolean, configuration?: string | null, created_at: any, deleted_at?: any | null, eff1?: any | null, eff2?: any | null, eff3?: any | null, eff4?: any | null, eff5?: any | null, effb?: any | null, i1?: any | null, i2?: any | null, i3?: any | null, i4?: any | null, i5?: any | null, ib?: any | null, imported_sizing_id?: number | null, length_inches?: any | null, manufacturer?: string | null, n1?: any | null, n2?: any | null, n3?: any | null, n4?: any | null, n5?: any | null, nameplate_current?: number | null, nameplate_horsepower?: number | null, nameplate_voltage?: number | null, nb?: any | null, oil_volume_gallons?: any | null, part_number?: string | null, pf1?: any | null, pf2?: any | null, pf3?: any | null, pf4?: any | null, pf5?: any | null, pfb?: any | null, rr_l1?: any | null, rr_l2?: any | null, rr_lb?: any | null, rr_v3: any, rr_v2: any, rr_v1?: any | null, rr_vb?: any | null, shaft_horsepower?: number | null, nv0: any, nv1: any, nv2: any, iv0: any, iv1: any, iv2: any, pfv0: any, pfv1: any, pfv2: any, effv0: any, effv1: any, effv2: any, tv0: any, tv1: any, tv2: any, temperature_rating_fahrenheit?: number | null, updated_at: any, weight_pounds?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, poles?: number | null, stator_inner_diameter_inches?: any | null, stator_outer_diameter_inches?: any | null, k3?: any | null, nameplate_rerate_ratio?: any | null, inner_diameter_inches?: any | null, outer_diameter_inches?: any | null, neck_inner_diameter_inches?: any | null, neck_outer_diameter_inches?: any | null, mle_offset_depth_inches: any, outer_diameter_rub_inches: any, is_hps: boolean } | null, r_bolt_on_discharge?: { __typename: 'bolt_on_discharges', id: any, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, manufacturer?: string | null, series_model?: string | null, is_hps: boolean, outer_diameter_inches?: any | null, inner_diameter_inches?: any | null, flange_outer_diameter_inches?: any | null, neck_outer_diameter_inches?: any | null, neck_inner_diameter_inches?: any | null, length_inches?: any | null, weight_pounds?: any | null, tubing_diameter_inches?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null } | null, r_lower_bolt_on_discharge?: { __typename: 'bolt_on_discharges', id: any, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, manufacturer?: string | null, series_model?: string | null, is_hps: boolean, outer_diameter_inches?: any | null, inner_diameter_inches?: any | null, flange_outer_diameter_inches?: any | null, neck_outer_diameter_inches?: any | null, neck_inner_diameter_inches?: any | null, length_inches?: any | null, weight_pounds?: any | null, tubing_diameter_inches?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null } | null, r_lower_motor?: { __typename: 'motors', id: any, author_id: string, allow_rerate: boolean, configuration?: string | null, created_at: any, deleted_at?: any | null, eff1?: any | null, eff2?: any | null, eff3?: any | null, eff4?: any | null, eff5?: any | null, effb?: any | null, i1?: any | null, i2?: any | null, i3?: any | null, i4?: any | null, i5?: any | null, ib?: any | null, imported_sizing_id?: number | null, length_inches?: any | null, manufacturer?: string | null, n1?: any | null, n2?: any | null, n3?: any | null, n4?: any | null, n5?: any | null, nameplate_current?: number | null, nameplate_horsepower?: number | null, nameplate_voltage?: number | null, nb?: any | null, oil_volume_gallons?: any | null, part_number?: string | null, pf1?: any | null, pf2?: any | null, pf3?: any | null, pf4?: any | null, pf5?: any | null, pfb?: any | null, rr_l1?: any | null, rr_l2?: any | null, rr_lb?: any | null, rr_v3: any, rr_v2: any, rr_v1?: any | null, rr_vb?: any | null, shaft_horsepower?: number | null, nv0: any, nv1: any, nv2: any, iv0: any, iv1: any, iv2: any, pfv0: any, pfv1: any, pfv2: any, effv0: any, effv1: any, effv2: any, tv0: any, tv1: any, tv2: any, temperature_rating_fahrenheit?: number | null, updated_at: any, weight_pounds?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, poles?: number | null, stator_inner_diameter_inches?: any | null, stator_outer_diameter_inches?: any | null, k3?: any | null, nameplate_rerate_ratio?: any | null, inner_diameter_inches?: any | null, outer_diameter_inches?: any | null, neck_inner_diameter_inches?: any | null, neck_outer_diameter_inches?: any | null, mle_offset_depth_inches: any, outer_diameter_rub_inches: any, is_hps: boolean } | null, r_shroud?: { __typename: 'casings', id: any, casing_type: Casings_Type_Enum, imperial_name?: string | null, metric_name?: string | null, outer_diameter_inches?: any | null, interior_diameter_inches?: any | null, drift_inches?: any | null, coupling_outer_diameter_inches?: any | null, pound_per_foot?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null } | null, r_lower_shroud?: { __typename: 'casings', id: any, casing_type: Casings_Type_Enum, imperial_name?: string | null, metric_name?: string | null, outer_diameter_inches?: any | null, interior_diameter_inches?: any | null, drift_inches?: any | null, coupling_outer_diameter_inches?: any | null, pound_per_foot?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null } | null, r_step_down_transformer?: { __typename: 'step_down_transformers', id: any, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, manufacturer?: string | null, part_number?: string | null, transformer_type?: string | null, primary_voltage_delta?: number | null, primary_voltage_wye?: number | null, min_secondary_voltage?: number | null, max_secondary_voltage?: number | null, weight_pounds?: number | null, enclosure?: string | null, kva?: number | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null } | null, r_step_up_transformer?: { __typename: 'step_up_transformers', id: any, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, manufacturer?: string | null, part_number?: string | null, transformer_type?: string | null, primary_voltage?: number | null, min_secondary_voltage?: number | null, max_secondary_voltage?: number | null, weight_pounds?: number | null, enclosure?: string | null, kva?: number | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null } | null, r_vsd?: { __typename: 'variable_speed_drives', id: any, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, enclosure?: string | null, kva?: number | null, manufacturer?: string | null, max_amps?: number | null, part_number?: string | null, vsd_type?: string | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null } | null, r_switchboard?: { __typename: 'switchboards', id: any, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, amps?: number | null, enclosure?: string | null, kv?: any | null, manufacturer?: string | null, part_number?: string | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null } | null, r_seal_motor_oil?: { __typename: 'seal_motor_oil', created_at: any, updated_at: any, deleted_at?: any | null, id: any, name: string, thermal_expansion_factor?: any | null, max_temp_fahrenheit?: number | null, mf_test_temp1_celsius?: number | null, mf_test_temp2_celsius?: number | null, viscosity_test1_centistroke?: any | null, viscosity_test2_centistroke?: any | null, specific_gravity?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null } | null, r_lower_seal_motor_oil?: { __typename: 'seal_motor_oil', created_at: any, updated_at: any, deleted_at?: any | null, id: any, name: string, thermal_expansion_factor?: any | null, max_temp_fahrenheit?: number | null, mf_test_temp1_celsius?: number | null, mf_test_temp2_celsius?: number | null, viscosity_test1_centistroke?: any | null, viscosity_test2_centistroke?: any | null, specific_gravity?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null } | null, r_uphole_y_tool?: { __typename: 'y_tools', id: any, author_id: string, created_at: any, deleted_at?: any | null, updated_at: any, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, minimum_inches?: any | null, maximum_inches?: any | null, length_inches?: any | null, width_inches?: any | null, series_model?: string | null, outer_diameter_inches?: any | null, teleswivel_stroke_length_inches?: any | null, pressure_rating_psi?: number | null, temperature_rating_fahrenheit?: number | null, handling_sub_connection_inches?: any | null, bypass_connection_inches?: any | null, material_type?: string | null, weight_pounds?: any | null, manufacturer?: string | null } | null, r_downhole_y_tool?: { __typename: 'y_tools', id: any, author_id: string, created_at: any, deleted_at?: any | null, updated_at: any, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, minimum_inches?: any | null, maximum_inches?: any | null, length_inches?: any | null, width_inches?: any | null, series_model?: string | null, outer_diameter_inches?: any | null, teleswivel_stroke_length_inches?: any | null, pressure_rating_psi?: number | null, temperature_rating_fahrenheit?: number | null, handling_sub_connection_inches?: any | null, bypass_connection_inches?: any | null, material_type?: string | null, weight_pounds?: any | null, manufacturer?: string | null } | null, r_xref_pumps: Array<{ __typename: 'scenario_equipment_xref_pumps', id?: any | null, scenario_equipment_id?: any | null, pump_id?: any | null, rate_correction_ratio?: any | null, head_correction_ratio?: any | null, brake_horsepower_correction_ratio?: any | null, total_stages?: number | null, length_feet?: any | null, housings_order?: Array<any> | null, use_high_strength_shaft?: boolean | null, weight_pounds?: any | null, parent_id?: any | null, journal_author_id?: string | null, journal_created_at?: any | null, journal_updated_at?: any | null, journal_deleted_at?: any | null, winning_revision_id?: any | null, winning_revision_parent_id?: any | null, winning_revision_author_id?: string | null, winning_revision_created_at?: any | null, winning_revision_updated_at?: any | null, winning_revision_deleted_at?: any | null, r_pump?: { __typename: 'pumps', id: any, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, manufacturer?: string | null, rotation?: string | null, part_number?: string | null, compression_thrust_per_stage?: any | null, series_model?: string | null, stage_type?: number | null, shaft_diameter_inches?: any | null, standard_housing_pressure_rating_psi?: number | null, high_strength_housing_pressure_rating_psi?: number | null, standard_shaft_rating_hp?: number | null, high_strength_shaft_rating_hp?: number | null, construction?: string | null, min_rate_standard_pump_bpd?: number | null, bep_rate_standard_pump_bpd?: number | null, max_rate_standard_pump_bpd?: number | null, max_graph_rate_standard_pump_bpd?: number | null, hb?: any | null, h1?: any | null, h2?: any | null, h3?: any | null, h4?: any | null, h5?: any | null, bhpb?: any | null, bhp1?: any | null, bhp2?: any | null, bhp3?: any | null, bhp4?: any | null, bhp5?: any | null, npsh1?: any | null, npsh2?: any | null, npsh3?: any | null, npsh4?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, max_bolt_load_pounds?: any | null, is_compression_pump: boolean, housing_inner_diameter_inches?: any | null, housing_outer_diameter_inches?: any | null, neck_inner_diameter_inches?: any | null, neck_outer_diameter_inches?: any | null, r_housings: Array<{ __typename: 'housings', id: any, housing_number?: number | null, stage_count?: number | null, length_inches?: any | null, weight_pounds?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, pump_id?: any | null }> } | null, r_xref_housings: Array<{ __typename: 'scenario_equipment_xref_housings', housing_id?: any | null, id?: any | null, journal_author_id?: string | null, journal_created_at?: any | null, journal_deleted_at?: any | null, journal_updated_at?: any | null, length_inches?: any | null, parent_id?: any | null, scenario_equipment_xref_pump_id?: any | null, stage_count?: number | null, winning_revision_author_id?: string | null, winning_revision_created_at?: any | null, winning_revision_deleted_at?: any | null, winning_revision_id?: any | null, winning_revision_parent_id?: any | null, winning_revision_updated_at?: any | null, r_housing?: { __typename: 'housings', id: any, housing_number?: number | null, stage_count?: number | null, length_inches?: any | null, weight_pounds?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, pump_id?: any | null } | null }> }>, r_xref_intakes: Array<{ __typename: 'scenario_equipment_xref_intakes', id?: any | null, intake_id?: any | null, scenario_equipment_id?: any | null, use_high_strength_shaft?: boolean | null, parent_id?: any | null, journal_author_id?: string | null, journal_created_at?: any | null, journal_updated_at?: any | null, journal_deleted_at?: any | null, winning_revision_id?: any | null, winning_revision_parent_id?: any | null, winning_revision_author_id?: string | null, winning_revision_created_at?: any | null, winning_revision_updated_at?: any | null, winning_revision_deleted_at?: any | null, r_intake?: { __typename: 'intakes', id: any, manufacturer?: string | null, intake_type?: string | null, part_number?: string | null, configuration?: string | null, length_inches?: any | null, weight_pounds?: any | null, shaft_material?: string | null, shaft_limit_hp?: number | null, housing_material?: string | null, max_rate_bpd?: number | null, hp?: any | null, eff1?: any | null, eff2?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, high_strength_shaft_limit_hp?: number | null, stage_count?: number | null, bhp0?: any | null, bhp1?: any | null, bhp2?: any | null, bhp3?: any | null, bhp4?: any | null, bhp5?: any | null, bolt_on?: boolean | null, port_area_square_inches: any, inner_diameter_inches?: any | null, outer_diameter_inches?: any | null, neck_inner_diameter_inches?: any | null, neck_outer_diameter_inches?: any | null, is_hps: boolean, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null } | null }>, r_xref_seals: Array<{ __typename: 'scenario_equipment_xref_seals', id?: any | null, use_high_strength_shaft?: boolean | null, parent_id?: any | null, journal_author_id?: string | null, journal_created_at?: any | null, journal_updated_at?: any | null, journal_deleted_at?: any | null, winning_revision_id?: any | null, winning_revision_parent_id?: any | null, scenario_equipment_id?: any | null, seal_id?: any | null, winning_revision_author_id?: string | null, winning_revision_created_at?: any | null, winning_revision_updated_at?: any | null, winning_revision_deleted_at?: any | null, r_seal?: { __typename: 'seals', id: any, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, manufacturer?: string | null, part_number?: string | null, length_inches?: any | null, weight_pounds?: any | null, configuration?: string | null, max_temperature_fahrenheit?: number | null, standard_shaft_limit_hp?: number | null, high_strength_shaft_limit_hp?: number | null, standard_bearing_rating_pounds?: number | null, high_strength_bearing_rating_pounds?: number | null, housing_material?: string | null, bearing_type?: string | null, total_seal_volume_gallons?: any | null, volume_for_bag_expansion_lower_tandem_gallons?: any | null, volume_for_bag_expansion_upper_tandem_gallons?: any | null, upper_chamber_pull_volume_gallons?: any | null, bag_chambers?: number | null, bag_capacity_gallons?: any | null, string_load_pounds?: any | null, load_cb_pounds?: any | null, load_c1_pounds?: any | null, hps_thrust_chamber: boolean, load_test_temperature_fahrenheit?: number | null, description?: string | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, inner_diameter_inches?: any | null, outer_diameter_inches?: any | null, neck_inner_diameter_inches?: any | null, neck_outer_diameter_inches?: any | null, thrust_collar_inner_diameter_inches: any, thrust_collar_outer_diameter_inches: any } | null }>, r_xref_cables: Array<{ __typename: 'scenario_equipment_xref_cables', id?: any | null, length_feet?: any | null, cable_id?: any | null, scenario_equipment_id?: any | null, parent_id?: any | null, journal_author_id?: string | null, journal_created_at?: any | null, journal_updated_at?: any | null, journal_deleted_at?: any | null, winning_revision_id?: any | null, winning_revision_parent_id?: any | null, winning_revision_author_id?: string | null, winning_revision_created_at?: any | null, winning_revision_updated_at?: any | null, winning_revision_deleted_at?: any | null, r_cable?: { __typename: 'cables', id: any, amp_factor?: any | null, armor?: string | null, construction?: string | null, depth_inches?: any | null, family?: string | null, gauge?: string | null, kv?: number | null, manufacturer?: string | null, max_temperature_fahrenheit?: number | null, part_number?: string | null, pound_per_foot?: any | null, width_inches?: any | null, impedance_60_hz_per_1000_ft?: any | null, resistance_per_1000_ft?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, author_id: string, created_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, updated_at: any } | null }>, r_xref_uphole_y_tool_bypass_tubings: Array<{ __typename: 'sc_equip_xref_uphole_ytool_bypass_tubings', id?: any | null, length_feet?: any | null, tubing_id?: any | null, scenario_equipment_id?: any | null, parent_id?: any | null, journal_author_id?: string | null, journal_created_at?: any | null, journal_updated_at?: any | null, journal_deleted_at?: any | null, winning_revision_id?: any | null, winning_revision_parent_id?: any | null, winning_revision_author_id?: string | null, winning_revision_created_at?: any | null, winning_revision_updated_at?: any | null, winning_revision_deleted_at?: any | null, r_tubing?: { __typename: 'tubings', id: any, author_id: string, coupling_outer_diameter_inches?: any | null, created_at: any, deleted_at?: any | null, drift_inches?: any | null, imperial_name?: string | null, imported_sizing_id?: number | null, interior_diameter_inches?: any | null, metric_name?: string | null, outer_diameter_inches?: any | null, pound_per_foot?: any | null, tubing_type: Tubings_Type_Enum, updated_at: any, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null } | null }>, r_xref_uphole_y_tool_equipment_tubings: Array<{ __typename: 'sc_equip_xref_uphole_ytool_equip_tubings', id?: any | null, length_feet?: any | null, tubing_id?: any | null, scenario_equipment_id?: any | null, parent_id?: any | null, journal_author_id?: string | null, journal_created_at?: any | null, journal_updated_at?: any | null, journal_deleted_at?: any | null, winning_revision_id?: any | null, winning_revision_parent_id?: any | null, winning_revision_author_id?: string | null, winning_revision_created_at?: any | null, winning_revision_updated_at?: any | null, winning_revision_deleted_at?: any | null, r_tubing?: { __typename: 'tubings', id: any, author_id: string, coupling_outer_diameter_inches?: any | null, created_at: any, deleted_at?: any | null, drift_inches?: any | null, imperial_name?: string | null, imported_sizing_id?: number | null, interior_diameter_inches?: any | null, metric_name?: string | null, outer_diameter_inches?: any | null, pound_per_foot?: any | null, tubing_type: Tubings_Type_Enum, updated_at: any, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null } | null }>, r_xref_downhole_y_tool_bypass_tubings: Array<{ __typename: 'sc_equip_xref_downhole_ytool_bypass_tubings', id?: any | null, length_feet?: any | null, tubing_id?: any | null, scenario_equipment_id?: any | null, parent_id?: any | null, journal_author_id?: string | null, journal_created_at?: any | null, journal_updated_at?: any | null, journal_deleted_at?: any | null, winning_revision_id?: any | null, winning_revision_parent_id?: any | null, winning_revision_author_id?: string | null, winning_revision_created_at?: any | null, winning_revision_updated_at?: any | null, winning_revision_deleted_at?: any | null, r_tubing?: { __typename: 'tubings', id: any, author_id: string, coupling_outer_diameter_inches?: any | null, created_at: any, deleted_at?: any | null, drift_inches?: any | null, imperial_name?: string | null, imported_sizing_id?: number | null, interior_diameter_inches?: any | null, metric_name?: string | null, outer_diameter_inches?: any | null, pound_per_foot?: any | null, tubing_type: Tubings_Type_Enum, updated_at: any, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null } | null }>, r_xref_downhole_y_tool_equipment_tubings: Array<{ __typename: 'sc_equip_xref_downhole_ytool_equip_tubings', id?: any | null, length_feet?: any | null, tubing_id?: any | null, scenario_equipment_id?: any | null, parent_id?: any | null, journal_author_id?: string | null, journal_created_at?: any | null, journal_updated_at?: any | null, journal_deleted_at?: any | null, winning_revision_id?: any | null, winning_revision_parent_id?: any | null, winning_revision_author_id?: string | null, winning_revision_created_at?: any | null, winning_revision_updated_at?: any | null, winning_revision_deleted_at?: any | null, r_tubing?: { __typename: 'tubings', id: any, author_id: string, coupling_outer_diameter_inches?: any | null, created_at: any, deleted_at?: any | null, drift_inches?: any | null, imperial_name?: string | null, imported_sizing_id?: number | null, interior_diameter_inches?: any | null, metric_name?: string | null, outer_diameter_inches?: any | null, pound_per_foot?: any | null, tubing_type: Tubings_Type_Enum, updated_at: any, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null } | null }> } | null, sizing?: { __typename: 'sizings', id?: any | null, journal_author_id?: string | null, journal_deleted_at?: any | null, well_id?: number | null, customer_id?: number | null, title?: string | null, notes?: string | null, well?: { __typename: 'wells', id: number, well_name?: string | null, well_uwi?: string | null, well_erp_id?: string | null, address_erp_id?: string | null } | null, customer?: { __typename: 'customers', id: number, customer_name?: string | null, customer_erp_id: string, imported_sizing_id?: number | null } | null } | null }>, scenarios_aggregate?: { __typename: 'scenarios_aggregate', id: 'scenarios_aggregate', aggregate?: { __typename: 'scenarios_aggregate_fields', count: number, id: 'scenarios_aggregate_fields' } | null } };

export type ScenarioParametersBaseFieldsFragment = { __typename: 'scenario_parameters', id?: any | null, journal_author_id?: string | null, journal_created_at?: any | null, journal_updated_at?: any | null, journal_deleted_at?: any | null, bottom_casing_pressure_psia?: any | null, cable_cost_kw_hr_usd?: any | null, bottom_tubing_pressure_psia?: any | null, has_compression_pump?: boolean | null, intake_override_gas_separation_percent?: any | null, intake_gas_separation_override_type?: string | null, natural_override_gas_separation_percent?: any | null, natural_gas_separation_override_type?: string | null, intake_packer_installed?: boolean | null, use_legacy_gas_head_rerate?: boolean | null, include_casing_friction_loss?: boolean | null, maximum_frequency?: any | null, minimum_frequency?: any | null, motor_rerate_ratio?: any | null, motor_shroud_interior_diameter_inches?: any | null, pump_hz?: any | null, pump_override_gas_correction_percent?: any | null, pump_wear_head_correction_ratio?: any | null, pump_wear_brake_horsepower_correction_ratio?: any | null, surface_drive_incoming_power_volts?: any | null, target_liquid_rate_std_barrel_day?: any | null, vsd_input_voltage?: any | null, flow_model?: string | null, winning_revision_id?: any | null, lower_intake_packer_installed?: boolean | null, lower_intake_override_gas_separation_percent?: any | null, lower_intake_gas_separation_override_type?: string | null, lower_natural_override_gas_separation_percent?: any | null, lower_natural_gas_separation_override_type?: string | null, lower_pump_hz?: any | null, lower_has_compression_pump?: boolean | null, lower_pump_override_gas_correction_percent?: any | null, lower_motor_rerate_ratio?: any | null, lower_motor_shroud_interior_diameter_inches?: any | null, lower_use_legacy_gas_head_rerate?: boolean | null, lower_include_casing_friction_loss?: boolean | null, lower_pump_wear_head_correction_ratio?: any | null, lower_pump_wear_brake_horsepower_correction_ratio?: any | null, elevation_feet_asl?: any | null };

export type ScenarioParametersQueryVariables = Exact<{
  distinct_on?: InputMaybe<Array<Scenario_Parameters_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Scenario_Parameters_Order_By>>;
  where?: InputMaybe<Scenario_Parameters_Bool_Exp>;
}>;


export type ScenarioParametersQuery = { __typename: 'query_root', scenario_parameters: Array<{ __typename: 'scenario_parameters', id?: any | null, journal_author_id?: string | null, journal_created_at?: any | null, journal_updated_at?: any | null, journal_deleted_at?: any | null, bottom_casing_pressure_psia?: any | null, cable_cost_kw_hr_usd?: any | null, bottom_tubing_pressure_psia?: any | null, has_compression_pump?: boolean | null, intake_override_gas_separation_percent?: any | null, intake_gas_separation_override_type?: string | null, natural_override_gas_separation_percent?: any | null, natural_gas_separation_override_type?: string | null, intake_packer_installed?: boolean | null, use_legacy_gas_head_rerate?: boolean | null, include_casing_friction_loss?: boolean | null, maximum_frequency?: any | null, minimum_frequency?: any | null, motor_rerate_ratio?: any | null, motor_shroud_interior_diameter_inches?: any | null, pump_hz?: any | null, pump_override_gas_correction_percent?: any | null, pump_wear_head_correction_ratio?: any | null, pump_wear_brake_horsepower_correction_ratio?: any | null, surface_drive_incoming_power_volts?: any | null, target_liquid_rate_std_barrel_day?: any | null, vsd_input_voltage?: any | null, flow_model?: string | null, winning_revision_id?: any | null, lower_intake_packer_installed?: boolean | null, lower_intake_override_gas_separation_percent?: any | null, lower_intake_gas_separation_override_type?: string | null, lower_natural_override_gas_separation_percent?: any | null, lower_natural_gas_separation_override_type?: string | null, lower_pump_hz?: any | null, lower_has_compression_pump?: boolean | null, lower_pump_override_gas_correction_percent?: any | null, lower_motor_rerate_ratio?: any | null, lower_motor_shroud_interior_diameter_inches?: any | null, lower_use_legacy_gas_head_rerate?: boolean | null, lower_include_casing_friction_loss?: boolean | null, lower_pump_wear_head_correction_ratio?: any | null, lower_pump_wear_brake_horsepower_correction_ratio?: any | null, elevation_feet_asl?: any | null }> };

export type InsertScenarioParametersRevisionMutationVariables = Exact<{
  object: Revisions_Scenario_Parameters_Revisions_Insert_Input;
}>;


export type InsertScenarioParametersRevisionMutation = { __typename: 'mutation_root', insert_revisions_scenario_parameters_revisions_one?: { __typename: 'revisions_scenario_parameters_revisions', id: any, scenario_parameters_view?: { __typename: 'scenario_parameters', id?: any | null, journal_author_id?: string | null, journal_created_at?: any | null, journal_updated_at?: any | null, journal_deleted_at?: any | null, bottom_casing_pressure_psia?: any | null, cable_cost_kw_hr_usd?: any | null, bottom_tubing_pressure_psia?: any | null, has_compression_pump?: boolean | null, intake_override_gas_separation_percent?: any | null, intake_gas_separation_override_type?: string | null, natural_override_gas_separation_percent?: any | null, natural_gas_separation_override_type?: string | null, intake_packer_installed?: boolean | null, use_legacy_gas_head_rerate?: boolean | null, include_casing_friction_loss?: boolean | null, maximum_frequency?: any | null, minimum_frequency?: any | null, motor_rerate_ratio?: any | null, motor_shroud_interior_diameter_inches?: any | null, pump_hz?: any | null, pump_override_gas_correction_percent?: any | null, pump_wear_head_correction_ratio?: any | null, pump_wear_brake_horsepower_correction_ratio?: any | null, surface_drive_incoming_power_volts?: any | null, target_liquid_rate_std_barrel_day?: any | null, vsd_input_voltage?: any | null, flow_model?: string | null, winning_revision_id?: any | null, lower_intake_packer_installed?: boolean | null, lower_intake_override_gas_separation_percent?: any | null, lower_intake_gas_separation_override_type?: string | null, lower_natural_override_gas_separation_percent?: any | null, lower_natural_gas_separation_override_type?: string | null, lower_pump_hz?: any | null, lower_has_compression_pump?: boolean | null, lower_pump_override_gas_correction_percent?: any | null, lower_motor_rerate_ratio?: any | null, lower_motor_shroud_interior_diameter_inches?: any | null, lower_use_legacy_gas_head_rerate?: boolean | null, lower_include_casing_friction_loss?: boolean | null, lower_pump_wear_head_correction_ratio?: any | null, lower_pump_wear_brake_horsepower_correction_ratio?: any | null, elevation_feet_asl?: any | null } | null } | null };

export type ScenarioReasonsFieldsFragment = { __typename: 'scenario_reasons', comment?: string | null, value: string, id: string };

export type ScenarioReasonsQueryVariables = Exact<{ [key: string]: never; }>;


export type ScenarioReasonsQuery = { __typename: 'query_root', scenario_reasons: Array<{ __typename: 'scenario_reasons', comment?: string | null, value: string, id: string }> };

export type ScenarioWellPropertiesBaseFieldsFragment = { __typename: 'scenario_well_properties', average_dls?: any | null, bottom_casing_id?: any | null, bottom_casing_length_feet?: any | null, bottom_tubing_id?: any | null, bottom_tubing_length_feet?: any | null, bottomhole_temperature_fahrenheit?: any | null, bubble_point_pressure_psia?: any | null, fluid_viscosity_override_cp?: any | null, condensate_api_override?: any | null, dew_point_pressure_psia_override?: any | null, co2_percent?: any | null, deviation_survey_id?: any | null, gas_specific_gravity?: any | null, gas_type?: string | null, h2s_percent?: any | null, id?: any | null, n2_percent?: any | null, c1_methane_percent?: any | null, c2_ethane_percent?: any | null, c3_propane_percent?: any | null, ic4_isobutene_percent?: any | null, nc4_butane_percent?: any | null, ic5_isopentane_percent?: any | null, nc5_bentane_percent?: any | null, c6_hexane_percent?: any | null, c7_heptane_percent?: any | null, oil_gravity_api?: any | null, surface_temperature_fahrenheit?: any | null, top_casing_id?: any | null, top_casing_length_feet?: any | null, top_of_perforations_measured_depth_feet?: any | null, top_of_perforations_true_vertical_depth_feet?: any | null, top_tubing_id?: any | null, top_tubing_length_feet?: any | null, water_specific_gravity?: any | null, well_test_datum_point_measured_depth_feet?: any | null, well_test_gas_input_type?: string | null, well_test_gas_rate_mscf_day?: any | null, well_test_liquid_input_type?: string | null, well_test_pressure_input_type?: string | null, well_test_productivity_index?: any | null, well_test_oil_rate_stb_day?: any | null, well_test_producing_bottom_hole_pressure_psia?: any | null, well_test_static_bottom_hole_pressure_psia?: any | null, hps_pump_inlet_pressure_psia?: any | null, hps_required_discharge_pressure_psia?: any | null, hps_pump_inlet_temperature_fahrenheit?: any | null, hps_liquid_type?: string | null, npsha_ft?: any | null, well_test_test_date?: any | null, well_test_water_rate_stb_day?: any | null, journal_author_id?: string | null, journal_created_at?: any | null, journal_updated_at?: any | null, journal_deleted_at?: any | null, winning_revision_id?: any | null, custom_fluid_properties?: any | null, custom_viscosities_properties?: any | null, o2_percent?: any | null, ar_percent?: any | null };

export type ScenarioWellPropertiesQueryVariables = Exact<{
  distinct_on?: InputMaybe<Array<Scenario_Well_Properties_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Scenario_Well_Properties_Order_By>>;
  where?: InputMaybe<Scenario_Well_Properties_Bool_Exp>;
}>;


export type ScenarioWellPropertiesQuery = { __typename: 'query_root', scenario_well_properties: Array<{ __typename: 'scenario_well_properties', average_dls?: any | null, bottom_casing_id?: any | null, bottom_casing_length_feet?: any | null, bottom_tubing_id?: any | null, bottom_tubing_length_feet?: any | null, bottomhole_temperature_fahrenheit?: any | null, bubble_point_pressure_psia?: any | null, fluid_viscosity_override_cp?: any | null, condensate_api_override?: any | null, dew_point_pressure_psia_override?: any | null, co2_percent?: any | null, deviation_survey_id?: any | null, gas_specific_gravity?: any | null, gas_type?: string | null, h2s_percent?: any | null, id?: any | null, n2_percent?: any | null, c1_methane_percent?: any | null, c2_ethane_percent?: any | null, c3_propane_percent?: any | null, ic4_isobutene_percent?: any | null, nc4_butane_percent?: any | null, ic5_isopentane_percent?: any | null, nc5_bentane_percent?: any | null, c6_hexane_percent?: any | null, c7_heptane_percent?: any | null, oil_gravity_api?: any | null, surface_temperature_fahrenheit?: any | null, top_casing_id?: any | null, top_casing_length_feet?: any | null, top_of_perforations_measured_depth_feet?: any | null, top_of_perforations_true_vertical_depth_feet?: any | null, top_tubing_id?: any | null, top_tubing_length_feet?: any | null, water_specific_gravity?: any | null, well_test_datum_point_measured_depth_feet?: any | null, well_test_gas_input_type?: string | null, well_test_gas_rate_mscf_day?: any | null, well_test_liquid_input_type?: string | null, well_test_pressure_input_type?: string | null, well_test_productivity_index?: any | null, well_test_oil_rate_stb_day?: any | null, well_test_producing_bottom_hole_pressure_psia?: any | null, well_test_static_bottom_hole_pressure_psia?: any | null, hps_pump_inlet_pressure_psia?: any | null, hps_required_discharge_pressure_psia?: any | null, hps_pump_inlet_temperature_fahrenheit?: any | null, hps_liquid_type?: string | null, npsha_ft?: any | null, well_test_test_date?: any | null, well_test_water_rate_stb_day?: any | null, journal_author_id?: string | null, journal_created_at?: any | null, journal_updated_at?: any | null, journal_deleted_at?: any | null, winning_revision_id?: any | null, custom_fluid_properties?: any | null, custom_viscosities_properties?: any | null, o2_percent?: any | null, ar_percent?: any | null, r_top_tubing?: { __typename: 'tubings', id: any, coupling_outer_diameter_inches?: any | null, drift_inches?: any | null, imperial_name?: string | null, interior_diameter_inches?: any | null, metric_name?: string | null, outer_diameter_inches?: any | null, pound_per_foot?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, tubing_type: Tubings_Type_Enum } | null, r_bottom_tubing?: { __typename: 'tubings', id: any, coupling_outer_diameter_inches?: any | null, drift_inches?: any | null, imperial_name?: string | null, interior_diameter_inches?: any | null, metric_name?: string | null, outer_diameter_inches?: any | null, pound_per_foot?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, tubing_type: Tubings_Type_Enum } | null, r_top_casing?: { __typename: 'casings', id: any, casing_type: Casings_Type_Enum, imperial_name?: string | null, metric_name?: string | null, outer_diameter_inches?: any | null, interior_diameter_inches?: any | null, drift_inches?: any | null, coupling_outer_diameter_inches?: any | null, pound_per_foot?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null } | null, r_bottom_casing?: { __typename: 'casings', id: any, casing_type: Casings_Type_Enum, imperial_name?: string | null, metric_name?: string | null, outer_diameter_inches?: any | null, interior_diameter_inches?: any | null, drift_inches?: any | null, coupling_outer_diameter_inches?: any | null, pound_per_foot?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null } | null, r_deviation_survey?: { __typename: 'deviation_survey', id: any, created_at: any, updated_at: any, deleted_at?: any | null, title?: string | null, directional_data_set: Deviation_Survey_Directional_Dataset_Enum, imported_sizing_id?: number | null, entry_rows?: Array<any> | null } | null }> };

export type InsertScenarioWellPropertiesRevisionMutationVariables = Exact<{
  object: Revisions_Scenario_Well_Properties_Revisions_Insert_Input;
}>;


export type InsertScenarioWellPropertiesRevisionMutation = { __typename: 'mutation_root', insert_revisions_scenario_well_properties_revisions_one?: { __typename: 'revisions_scenario_well_properties_revisions', id: any, scenario_well_properties_view?: { __typename: 'scenario_well_properties', average_dls?: any | null, bottom_casing_id?: any | null, bottom_casing_length_feet?: any | null, bottom_tubing_id?: any | null, bottom_tubing_length_feet?: any | null, bottomhole_temperature_fahrenheit?: any | null, bubble_point_pressure_psia?: any | null, fluid_viscosity_override_cp?: any | null, condensate_api_override?: any | null, dew_point_pressure_psia_override?: any | null, co2_percent?: any | null, deviation_survey_id?: any | null, gas_specific_gravity?: any | null, gas_type?: string | null, h2s_percent?: any | null, id?: any | null, n2_percent?: any | null, c1_methane_percent?: any | null, c2_ethane_percent?: any | null, c3_propane_percent?: any | null, ic4_isobutene_percent?: any | null, nc4_butane_percent?: any | null, ic5_isopentane_percent?: any | null, nc5_bentane_percent?: any | null, c6_hexane_percent?: any | null, c7_heptane_percent?: any | null, oil_gravity_api?: any | null, surface_temperature_fahrenheit?: any | null, top_casing_id?: any | null, top_casing_length_feet?: any | null, top_of_perforations_measured_depth_feet?: any | null, top_of_perforations_true_vertical_depth_feet?: any | null, top_tubing_id?: any | null, top_tubing_length_feet?: any | null, water_specific_gravity?: any | null, well_test_datum_point_measured_depth_feet?: any | null, well_test_gas_input_type?: string | null, well_test_gas_rate_mscf_day?: any | null, well_test_liquid_input_type?: string | null, well_test_pressure_input_type?: string | null, well_test_productivity_index?: any | null, well_test_oil_rate_stb_day?: any | null, well_test_producing_bottom_hole_pressure_psia?: any | null, well_test_static_bottom_hole_pressure_psia?: any | null, hps_pump_inlet_pressure_psia?: any | null, hps_required_discharge_pressure_psia?: any | null, hps_pump_inlet_temperature_fahrenheit?: any | null, hps_liquid_type?: string | null, npsha_ft?: any | null, well_test_test_date?: any | null, well_test_water_rate_stb_day?: any | null, journal_author_id?: string | null, journal_created_at?: any | null, journal_updated_at?: any | null, journal_deleted_at?: any | null, winning_revision_id?: any | null, custom_fluid_properties?: any | null, custom_viscosities_properties?: any | null, o2_percent?: any | null, ar_percent?: any | null } | null } | null };

export type InsertScenarioRevisionMutationVariables = Exact<{
  objects: Array<Revisions_Scenarios_Revisions_Insert_Input>;
}>;


export type InsertScenarioRevisionMutation = { __typename: 'mutation_root', insert_revisions_scenarios_revisions?: { __typename: 'revisions_scenarios_revisions_mutation_response', returning: Array<{ __typename: 'revisions_scenarios_revisions', id: any, scenarios_view?: { __typename: 'scenarios', id?: any | null, journal_author_id?: string | null, journal_created_at?: any | null, journal_updated_at?: any | null, journal_deleted_at?: any | null, winning_revision_id?: any | null, title?: string | null, notes?: string | null, internal_notes?: string | null, reason?: string | null, sizing_id?: any | null, well_properties_id?: any | null, scenario_equipment_id?: any | null, parameters_id?: any | null, correlations_id?: any | null, display_unit_overrides?: any | null, pumping_type?: string | null } | null }> } | null };

export type SizingDispositionsFieldsFragment = { __typename: 'sizing_dispositions', comment?: string | null, value: string, id: string };

export type SizingDispositionsQueryVariables = Exact<{ [key: string]: never; }>;


export type SizingDispositionsQuery = { __typename: 'query_root', sizing_dispositions: Array<{ __typename: 'sizing_dispositions', comment?: string | null, value: string, id: string }> };

export type SizingImportBaseFieldsFragment = { __typename: 'sizing_imports', created_at: any, error?: any | null, id: number, imported_at?: any | null, legacy_sizing_reaver_id?: string | null, legacy_sizing_name?: string | null };

export type SizingImportsQueryVariables = Exact<{
  distinct_on?: InputMaybe<Array<Sizing_Imports_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sizing_Imports_Order_By>>;
  where?: InputMaybe<Sizing_Imports_Bool_Exp>;
}>;


export type SizingImportsQuery = { __typename: 'query_root', sizing_imports: Array<{ __typename: 'sizing_imports', created_at: any, error?: any | null, id: number, imported_at?: any | null, legacy_sizing_reaver_id?: string | null, legacy_sizing_name?: string | null }> };

export type SizingImportsWithPayloadQueryVariables = Exact<{
  distinct_on?: InputMaybe<Array<Sizing_Imports_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sizing_Imports_Order_By>>;
  where?: InputMaybe<Sizing_Imports_Bool_Exp>;
}>;


export type SizingImportsWithPayloadQuery = { __typename: 'query_root', sizing_imports: Array<{ __typename: 'sizing_imports', payload?: any | null, created_at: any, error?: any | null, id: number, imported_at?: any | null, legacy_sizing_reaver_id?: string | null, legacy_sizing_name?: string | null }> };

export type InsertSizingImportMutationVariables = Exact<{
  object: Sizing_Imports_Insert_Input;
}>;


export type InsertSizingImportMutation = { __typename: 'mutation_root', insert_sizing_imports_one?: { __typename: 'sizing_imports', created_at: any, error?: any | null, id: number, imported_at?: any | null, legacy_sizing_reaver_id?: string | null, legacy_sizing_name?: string | null } | null };

export type SizingImportsSubSubscriptionVariables = Exact<{
  distinct_on?: InputMaybe<Array<Sizing_Imports_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sizing_Imports_Order_By>>;
  where?: InputMaybe<Sizing_Imports_Bool_Exp>;
}>;


export type SizingImportsSubSubscription = { __typename: 'subscription_root', sizing_imports: Array<{ __typename: 'sizing_imports', created_at: any, error?: any | null, id: number, imported_at?: any | null, legacy_sizing_reaver_id?: string | null, legacy_sizing_name?: string | null }> };

export type SizingPumpingTypeFieldsFragment = { __typename: 'sizing_pumping_type', comment?: string | null, value: string, id: string };

export type SizingPumpingTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type SizingPumpingTypesQuery = { __typename: 'query_root', sizing_pumping_type: Array<{ __typename: 'sizing_pumping_type', comment?: string | null, value: string, id: string }> };

export type SizingsFieldsFragment = { __typename: 'sizings', id?: any | null, parent_id?: any | null, journal_author_id?: string | null, journal_created_at?: any | null, journal_updated_at?: any | null, journal_deleted_at?: any | null, winning_revision_id?: any | null, winning_revision_author_id?: string | null, well_id?: number | null, customer_id?: number | null, installed_scenario_id?: any | null, title?: string | null, notes?: string | null, default_display_units?: string | null, disposition?: string | null, pumping_type?: string | null, is_shared?: boolean | null, imported_sizing_id?: number | null, share_with_customer?: boolean | null, hps_location?: string | null, scenario_order?: Array<any> | null };

export type SizingsListFieldsFragment = { __typename: 'sizings', id?: any | null, journal_author_id?: string | null, journal_deleted_at?: any | null, well_id?: number | null, customer_id?: number | null, title?: string | null, notes?: string | null };

export type SizingsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Sizings_Bool_Exp>;
  order_by?: InputMaybe<Array<Sizings_Order_By>>;
  withAggregate?: Scalars['Boolean']['input'];
  kitchenSink?: Scalars['Boolean']['input'];
  withImportUser?: Scalars['Boolean']['input'];
}>;


export type SizingsQuery = { __typename: 'query_root', sizings: Array<{ __typename: 'sizings', id?: any | null, parent_id?: any | null, journal_author_id?: string | null, journal_created_at?: any | null, journal_updated_at?: any | null, journal_deleted_at?: any | null, winning_revision_id?: any | null, winning_revision_author_id?: string | null, well_id?: number | null, customer_id?: number | null, installed_scenario_id?: any | null, title?: string | null, notes?: string | null, default_display_units?: string | null, disposition?: string | null, pumping_type?: string | null, is_shared?: boolean | null, imported_sizing_id?: number | null, share_with_customer?: boolean | null, hps_location?: string | null, scenario_order?: Array<any> | null, parent_sizing?: { __typename: 'sizings', id?: any | null, title?: string | null, journal_deleted_at?: any | null, installed_scenario_id?: any | null, scenarios: Array<{ __typename: 'scenarios', id?: any | null }> } | null, author?: { __typename: 'users', id: string, email?: string | null, username?: string | null, display_name?: string | null, hal_identifier?: string | null } | null, well?: { __typename: 'wells', id: number, well_name?: string | null, well_uwi?: string | null, well_erp_id?: string | null, address_erp_id?: string | null } | null, customer?: { __typename: 'customers', id: number, customer_name?: string | null, customer_erp_id: string, imported_sizing_id?: number | null } | null, imported_from_sizing?: { __typename: 'sizing_imports', id: number, legacy_author_id?: string | null, legacy_user?: { __typename: 'legacy_users', hal_identifier: string, display_name?: string | null } | null } | null, scenarios?: Array<{ __typename: 'scenarios', id?: any | null, journal_author_id?: string | null, journal_created_at?: any | null, journal_updated_at?: any | null, journal_deleted_at?: any | null, winning_revision_id?: any | null, title?: string | null, notes?: string | null, internal_notes?: string | null, reason?: string | null, sizing_id?: any | null, well_properties_id?: any | null, scenario_equipment_id?: any | null, parameters_id?: any | null, correlations_id?: any | null, display_unit_overrides?: any | null, pumping_type?: string | null, author?: { __typename: 'users', id: string, email?: string | null, username?: string | null, display_name?: string | null, hal_identifier?: string | null } | null, correlations?: { __typename: 'scenario_correlations', id?: any | null, journal_author_id?: string | null, journal_deleted_at?: any | null, winning_revision_id?: any | null, bubble_point?: string | null, dead_oil?: string | null, friction_loss?: string | null, gas_compressibility?: string | null, gas_viscosity?: string | null, tubing_hazen_williams_coefficient?: any | null, casing_hazen_williams_coefficient?: any | null, tubing_apply_hazen_williams_correction?: boolean | null, casing_apply_hazen_williams_correction?: boolean | null, oil_density?: string | null, oil_volume_factor_saturated?: string | null, oil_volume_factor_undersaturated?: string | null, tubing_palmer_correction?: boolean | null, casing_palmer_correction?: boolean | null, tubing_griffith_wallis?: boolean | null, casing_griffith_wallis?: boolean | null, salinity_ppm?: any | null, saturated_oil?: string | null, solution_gor?: string | null, tubing_flow?: string | null, casing_flow?: string | null, tubing_roughness_inches?: any | null, casing_roughness_inches?: any | null, under_saturated_oil?: string | null, water_density?: string | null, water_solution_gas?: string | null, water_viscosity?: string | null, water_volume_factor?: string | null, natural_gas_separation?: string | null, tdh_tuning_factor_ratio?: any | null } | null, equipment?: { __typename: 'scenario_equipment', id?: any | null, journal_author_id?: string | null, journal_created_at?: any | null, journal_updated_at?: any | null, journal_deleted_at?: any | null, mle_id?: any | null, lower_mle_id?: any | null, motor_id?: any | null, lower_motor_id?: any | null, bolt_on_discharge_id?: any | null, lower_bolt_on_discharge_id?: any | null, shroud_id?: any | null, lower_shroud_id?: any | null, parent_id?: any | null, sensor_id?: any | null, lower_sensor_id?: any | null, switchboard_id?: any | null, down_trans_id?: any | null, up_trans_id?: any | null, use_vsd?: boolean | null, use_uphole_y_tool?: boolean | null, use_downhole_y_tool?: boolean | null, has_lower_equip_stack?: boolean | null, vsd_id?: any | null, seals_order?: Array<any> | null, lower_seals_order?: Array<any> | null, winning_revision_author_id?: string | null, winning_revision_id?: any | null, intakes_order?: Array<any> | null, lower_intakes_order?: Array<any> | null, cables_order?: Array<any> | null, lower_cables_order?: Array<any> | null, pumps_order?: Array<any> | null, lower_pumps_order?: Array<any> | null, seal_motor_oil_id?: any | null, lower_seal_motor_oil_id?: any | null, uphole_y_tool_id?: any | null, downhole_y_tool_id?: any | null, include_y_tool?: boolean | null, uphole_y_tool_bypass_tubing_order?: Array<any> | null, uphole_y_tool_equipment_tubing_order?: Array<any> | null, downhole_y_tool_bypass_tubing_order?: Array<any> | null, downhole_y_tool_equipment_tubing_order?: Array<any> | null, r_sensor?: { __typename: 'sensors', id: any, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, manufacturer?: string | null, part_number?: string | null, length_inches?: number | null, weight_pounds?: number | null, model?: string | null, channels?: number | null, max_intake_temperature_fahrenheit?: number | null, max_intake_pressure_psi?: number | null, housing_material?: string | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, inner_diameter_inches?: any | null, outer_diameter_inches: any, neck_inner_diameter_inches?: any | null, neck_outer_diameter_inches?: any | null } | null, r_lower_sensor?: { __typename: 'sensors', id: any, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, manufacturer?: string | null, part_number?: string | null, length_inches?: number | null, weight_pounds?: number | null, model?: string | null, channels?: number | null, max_intake_temperature_fahrenheit?: number | null, max_intake_pressure_psi?: number | null, housing_material?: string | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, inner_diameter_inches?: any | null, outer_diameter_inches: any, neck_inner_diameter_inches?: any | null, neck_outer_diameter_inches?: any | null } | null, r_mle?: { __typename: 'motor_lead_extensions', id: any, manufacturer?: string | null, part_number?: string | null, series?: number | null, family?: string | null, gauge?: number | null, kv?: number | null, max_pothead_temperature_fahrenheit?: number | null, max_temperature_fahrenheit?: number | null, resistance_per_1000_ft?: any | null, impedance_60_hz_per_1000_ft?: any | null, amp_factor?: any | null, width_inches?: any | null, depth_inches?: any | null, pound_per_foot?: any | null, length_feet?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null } | null, r_lower_mle?: { __typename: 'motor_lead_extensions', id: any, manufacturer?: string | null, part_number?: string | null, series?: number | null, family?: string | null, gauge?: number | null, kv?: number | null, max_pothead_temperature_fahrenheit?: number | null, max_temperature_fahrenheit?: number | null, resistance_per_1000_ft?: any | null, impedance_60_hz_per_1000_ft?: any | null, amp_factor?: any | null, width_inches?: any | null, depth_inches?: any | null, pound_per_foot?: any | null, length_feet?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null } | null, r_motor?: { __typename: 'motors', id: any, author_id: string, allow_rerate: boolean, configuration?: string | null, created_at: any, deleted_at?: any | null, eff1?: any | null, eff2?: any | null, eff3?: any | null, eff4?: any | null, eff5?: any | null, effb?: any | null, i1?: any | null, i2?: any | null, i3?: any | null, i4?: any | null, i5?: any | null, ib?: any | null, imported_sizing_id?: number | null, length_inches?: any | null, manufacturer?: string | null, n1?: any | null, n2?: any | null, n3?: any | null, n4?: any | null, n5?: any | null, nameplate_current?: number | null, nameplate_horsepower?: number | null, nameplate_voltage?: number | null, nb?: any | null, oil_volume_gallons?: any | null, part_number?: string | null, pf1?: any | null, pf2?: any | null, pf3?: any | null, pf4?: any | null, pf5?: any | null, pfb?: any | null, rr_l1?: any | null, rr_l2?: any | null, rr_lb?: any | null, rr_v3: any, rr_v2: any, rr_v1?: any | null, rr_vb?: any | null, shaft_horsepower?: number | null, nv0: any, nv1: any, nv2: any, iv0: any, iv1: any, iv2: any, pfv0: any, pfv1: any, pfv2: any, effv0: any, effv1: any, effv2: any, tv0: any, tv1: any, tv2: any, temperature_rating_fahrenheit?: number | null, updated_at: any, weight_pounds?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, poles?: number | null, stator_inner_diameter_inches?: any | null, stator_outer_diameter_inches?: any | null, k3?: any | null, nameplate_rerate_ratio?: any | null, inner_diameter_inches?: any | null, outer_diameter_inches?: any | null, neck_inner_diameter_inches?: any | null, neck_outer_diameter_inches?: any | null, mle_offset_depth_inches: any, outer_diameter_rub_inches: any, is_hps: boolean } | null, r_bolt_on_discharge?: { __typename: 'bolt_on_discharges', id: any, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, manufacturer?: string | null, series_model?: string | null, is_hps: boolean, outer_diameter_inches?: any | null, inner_diameter_inches?: any | null, flange_outer_diameter_inches?: any | null, neck_outer_diameter_inches?: any | null, neck_inner_diameter_inches?: any | null, length_inches?: any | null, weight_pounds?: any | null, tubing_diameter_inches?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null } | null, r_lower_bolt_on_discharge?: { __typename: 'bolt_on_discharges', id: any, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, manufacturer?: string | null, series_model?: string | null, is_hps: boolean, outer_diameter_inches?: any | null, inner_diameter_inches?: any | null, flange_outer_diameter_inches?: any | null, neck_outer_diameter_inches?: any | null, neck_inner_diameter_inches?: any | null, length_inches?: any | null, weight_pounds?: any | null, tubing_diameter_inches?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null } | null, r_lower_motor?: { __typename: 'motors', id: any, author_id: string, allow_rerate: boolean, configuration?: string | null, created_at: any, deleted_at?: any | null, eff1?: any | null, eff2?: any | null, eff3?: any | null, eff4?: any | null, eff5?: any | null, effb?: any | null, i1?: any | null, i2?: any | null, i3?: any | null, i4?: any | null, i5?: any | null, ib?: any | null, imported_sizing_id?: number | null, length_inches?: any | null, manufacturer?: string | null, n1?: any | null, n2?: any | null, n3?: any | null, n4?: any | null, n5?: any | null, nameplate_current?: number | null, nameplate_horsepower?: number | null, nameplate_voltage?: number | null, nb?: any | null, oil_volume_gallons?: any | null, part_number?: string | null, pf1?: any | null, pf2?: any | null, pf3?: any | null, pf4?: any | null, pf5?: any | null, pfb?: any | null, rr_l1?: any | null, rr_l2?: any | null, rr_lb?: any | null, rr_v3: any, rr_v2: any, rr_v1?: any | null, rr_vb?: any | null, shaft_horsepower?: number | null, nv0: any, nv1: any, nv2: any, iv0: any, iv1: any, iv2: any, pfv0: any, pfv1: any, pfv2: any, effv0: any, effv1: any, effv2: any, tv0: any, tv1: any, tv2: any, temperature_rating_fahrenheit?: number | null, updated_at: any, weight_pounds?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, poles?: number | null, stator_inner_diameter_inches?: any | null, stator_outer_diameter_inches?: any | null, k3?: any | null, nameplate_rerate_ratio?: any | null, inner_diameter_inches?: any | null, outer_diameter_inches?: any | null, neck_inner_diameter_inches?: any | null, neck_outer_diameter_inches?: any | null, mle_offset_depth_inches: any, outer_diameter_rub_inches: any, is_hps: boolean } | null, r_shroud?: { __typename: 'casings', id: any, casing_type: Casings_Type_Enum, imperial_name?: string | null, metric_name?: string | null, outer_diameter_inches?: any | null, interior_diameter_inches?: any | null, drift_inches?: any | null, coupling_outer_diameter_inches?: any | null, pound_per_foot?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null } | null, r_lower_shroud?: { __typename: 'casings', id: any, casing_type: Casings_Type_Enum, imperial_name?: string | null, metric_name?: string | null, outer_diameter_inches?: any | null, interior_diameter_inches?: any | null, drift_inches?: any | null, coupling_outer_diameter_inches?: any | null, pound_per_foot?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null } | null, r_uphole_y_tool?: { __typename: 'y_tools', id: any, author_id: string, created_at: any, deleted_at?: any | null, updated_at: any, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, minimum_inches?: any | null, maximum_inches?: any | null, length_inches?: any | null, width_inches?: any | null, series_model?: string | null, outer_diameter_inches?: any | null, teleswivel_stroke_length_inches?: any | null, pressure_rating_psi?: number | null, temperature_rating_fahrenheit?: number | null, handling_sub_connection_inches?: any | null, bypass_connection_inches?: any | null, material_type?: string | null, weight_pounds?: any | null, manufacturer?: string | null } | null, r_downhole_y_tool?: { __typename: 'y_tools', id: any, author_id: string, created_at: any, deleted_at?: any | null, updated_at: any, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, minimum_inches?: any | null, maximum_inches?: any | null, length_inches?: any | null, width_inches?: any | null, series_model?: string | null, outer_diameter_inches?: any | null, teleswivel_stroke_length_inches?: any | null, pressure_rating_psi?: number | null, temperature_rating_fahrenheit?: number | null, handling_sub_connection_inches?: any | null, bypass_connection_inches?: any | null, material_type?: string | null, weight_pounds?: any | null, manufacturer?: string | null } | null, r_step_down_transformer?: { __typename: 'step_down_transformers', id: any, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, manufacturer?: string | null, part_number?: string | null, transformer_type?: string | null, primary_voltage_delta?: number | null, primary_voltage_wye?: number | null, min_secondary_voltage?: number | null, max_secondary_voltage?: number | null, weight_pounds?: number | null, enclosure?: string | null, kva?: number | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null } | null, r_step_up_transformer?: { __typename: 'step_up_transformers', id: any, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, manufacturer?: string | null, part_number?: string | null, transformer_type?: string | null, primary_voltage?: number | null, min_secondary_voltage?: number | null, max_secondary_voltage?: number | null, weight_pounds?: number | null, enclosure?: string | null, kva?: number | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null } | null, r_vsd?: { __typename: 'variable_speed_drives', id: any, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, enclosure?: string | null, kva?: number | null, manufacturer?: string | null, max_amps?: number | null, part_number?: string | null, vsd_type?: string | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null } | null, r_switchboard?: { __typename: 'switchboards', id: any, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, amps?: number | null, enclosure?: string | null, kv?: any | null, manufacturer?: string | null, part_number?: string | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null } | null, r_seal_motor_oil?: { __typename: 'seal_motor_oil', created_at: any, updated_at: any, deleted_at?: any | null, id: any, name: string, thermal_expansion_factor?: any | null, max_temp_fahrenheit?: number | null, mf_test_temp1_celsius?: number | null, mf_test_temp2_celsius?: number | null, viscosity_test1_centistroke?: any | null, viscosity_test2_centistroke?: any | null, specific_gravity?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null } | null, r_lower_seal_motor_oil?: { __typename: 'seal_motor_oil', created_at: any, updated_at: any, deleted_at?: any | null, id: any, name: string, thermal_expansion_factor?: any | null, max_temp_fahrenheit?: number | null, mf_test_temp1_celsius?: number | null, mf_test_temp2_celsius?: number | null, viscosity_test1_centistroke?: any | null, viscosity_test2_centistroke?: any | null, specific_gravity?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null } | null, r_xref_pumps: Array<{ __typename: 'scenario_equipment_xref_pumps', id?: any | null, scenario_equipment_id?: any | null, pump_id?: any | null, rate_correction_ratio?: any | null, head_correction_ratio?: any | null, brake_horsepower_correction_ratio?: any | null, total_stages?: number | null, length_feet?: any | null, housings_order?: Array<any> | null, use_high_strength_shaft?: boolean | null, weight_pounds?: any | null, parent_id?: any | null, journal_author_id?: string | null, journal_created_at?: any | null, journal_updated_at?: any | null, journal_deleted_at?: any | null, winning_revision_id?: any | null, winning_revision_parent_id?: any | null, winning_revision_author_id?: string | null, winning_revision_created_at?: any | null, winning_revision_updated_at?: any | null, winning_revision_deleted_at?: any | null, r_pump?: { __typename: 'pumps', id: any, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, manufacturer?: string | null, rotation?: string | null, part_number?: string | null, compression_thrust_per_stage?: any | null, series_model?: string | null, stage_type?: number | null, shaft_diameter_inches?: any | null, standard_housing_pressure_rating_psi?: number | null, high_strength_housing_pressure_rating_psi?: number | null, standard_shaft_rating_hp?: number | null, high_strength_shaft_rating_hp?: number | null, construction?: string | null, min_rate_standard_pump_bpd?: number | null, bep_rate_standard_pump_bpd?: number | null, max_rate_standard_pump_bpd?: number | null, max_graph_rate_standard_pump_bpd?: number | null, hb?: any | null, h1?: any | null, h2?: any | null, h3?: any | null, h4?: any | null, h5?: any | null, bhpb?: any | null, bhp1?: any | null, bhp2?: any | null, bhp3?: any | null, bhp4?: any | null, bhp5?: any | null, npsh1?: any | null, npsh2?: any | null, npsh3?: any | null, npsh4?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, max_bolt_load_pounds?: any | null, is_compression_pump: boolean, housing_inner_diameter_inches?: any | null, housing_outer_diameter_inches?: any | null, neck_inner_diameter_inches?: any | null, neck_outer_diameter_inches?: any | null, r_housings: Array<{ __typename: 'housings', id: any, housing_number?: number | null, stage_count?: number | null, length_inches?: any | null, weight_pounds?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, pump_id?: any | null }> } | null, r_xref_housings: Array<{ __typename: 'scenario_equipment_xref_housings', housing_id?: any | null, id?: any | null, journal_author_id?: string | null, journal_created_at?: any | null, journal_deleted_at?: any | null, journal_updated_at?: any | null, length_inches?: any | null, parent_id?: any | null, scenario_equipment_xref_pump_id?: any | null, stage_count?: number | null, winning_revision_author_id?: string | null, winning_revision_created_at?: any | null, winning_revision_deleted_at?: any | null, winning_revision_id?: any | null, winning_revision_parent_id?: any | null, winning_revision_updated_at?: any | null, r_housing?: { __typename: 'housings', id: any, housing_number?: number | null, stage_count?: number | null, length_inches?: any | null, weight_pounds?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, pump_id?: any | null } | null }> }>, r_xref_intakes: Array<{ __typename: 'scenario_equipment_xref_intakes', id?: any | null, intake_id?: any | null, scenario_equipment_id?: any | null, use_high_strength_shaft?: boolean | null, parent_id?: any | null, journal_author_id?: string | null, journal_created_at?: any | null, journal_updated_at?: any | null, journal_deleted_at?: any | null, winning_revision_id?: any | null, winning_revision_parent_id?: any | null, winning_revision_author_id?: string | null, winning_revision_created_at?: any | null, winning_revision_updated_at?: any | null, winning_revision_deleted_at?: any | null, r_intake?: { __typename: 'intakes', id: any, manufacturer?: string | null, intake_type?: string | null, part_number?: string | null, configuration?: string | null, length_inches?: any | null, weight_pounds?: any | null, shaft_material?: string | null, shaft_limit_hp?: number | null, housing_material?: string | null, max_rate_bpd?: number | null, hp?: any | null, eff1?: any | null, eff2?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, high_strength_shaft_limit_hp?: number | null, stage_count?: number | null, bhp0?: any | null, bhp1?: any | null, bhp2?: any | null, bhp3?: any | null, bhp4?: any | null, bhp5?: any | null, bolt_on?: boolean | null, port_area_square_inches: any, inner_diameter_inches?: any | null, outer_diameter_inches?: any | null, neck_inner_diameter_inches?: any | null, neck_outer_diameter_inches?: any | null, is_hps: boolean, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null } | null }>, r_xref_seals: Array<{ __typename: 'scenario_equipment_xref_seals', id?: any | null, use_high_strength_shaft?: boolean | null, parent_id?: any | null, journal_author_id?: string | null, journal_created_at?: any | null, journal_updated_at?: any | null, journal_deleted_at?: any | null, winning_revision_id?: any | null, winning_revision_parent_id?: any | null, scenario_equipment_id?: any | null, seal_id?: any | null, winning_revision_author_id?: string | null, winning_revision_created_at?: any | null, winning_revision_updated_at?: any | null, winning_revision_deleted_at?: any | null, r_seal?: { __typename: 'seals', id: any, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, manufacturer?: string | null, part_number?: string | null, length_inches?: any | null, weight_pounds?: any | null, configuration?: string | null, max_temperature_fahrenheit?: number | null, standard_shaft_limit_hp?: number | null, high_strength_shaft_limit_hp?: number | null, standard_bearing_rating_pounds?: number | null, high_strength_bearing_rating_pounds?: number | null, housing_material?: string | null, bearing_type?: string | null, total_seal_volume_gallons?: any | null, volume_for_bag_expansion_lower_tandem_gallons?: any | null, volume_for_bag_expansion_upper_tandem_gallons?: any | null, upper_chamber_pull_volume_gallons?: any | null, bag_chambers?: number | null, bag_capacity_gallons?: any | null, string_load_pounds?: any | null, load_cb_pounds?: any | null, load_c1_pounds?: any | null, hps_thrust_chamber: boolean, load_test_temperature_fahrenheit?: number | null, description?: string | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, inner_diameter_inches?: any | null, outer_diameter_inches?: any | null, neck_inner_diameter_inches?: any | null, neck_outer_diameter_inches?: any | null, thrust_collar_inner_diameter_inches: any, thrust_collar_outer_diameter_inches: any } | null }>, r_xref_cables: Array<{ __typename: 'scenario_equipment_xref_cables', id?: any | null, length_feet?: any | null, cable_id?: any | null, scenario_equipment_id?: any | null, parent_id?: any | null, journal_author_id?: string | null, journal_created_at?: any | null, journal_updated_at?: any | null, journal_deleted_at?: any | null, winning_revision_id?: any | null, winning_revision_parent_id?: any | null, winning_revision_author_id?: string | null, winning_revision_created_at?: any | null, winning_revision_updated_at?: any | null, winning_revision_deleted_at?: any | null, r_cable?: { __typename: 'cables', id: any, amp_factor?: any | null, armor?: string | null, construction?: string | null, depth_inches?: any | null, family?: string | null, gauge?: string | null, kv?: number | null, manufacturer?: string | null, max_temperature_fahrenheit?: number | null, part_number?: string | null, pound_per_foot?: any | null, width_inches?: any | null, impedance_60_hz_per_1000_ft?: any | null, resistance_per_1000_ft?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, author_id: string, created_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, updated_at: any } | null }>, r_xref_uphole_y_tool_bypass_tubings: Array<{ __typename: 'sc_equip_xref_uphole_ytool_bypass_tubings', id?: any | null, length_feet?: any | null, tubing_id?: any | null, scenario_equipment_id?: any | null, parent_id?: any | null, journal_author_id?: string | null, journal_created_at?: any | null, journal_updated_at?: any | null, journal_deleted_at?: any | null, winning_revision_id?: any | null, winning_revision_parent_id?: any | null, winning_revision_author_id?: string | null, winning_revision_created_at?: any | null, winning_revision_updated_at?: any | null, winning_revision_deleted_at?: any | null, r_tubing?: { __typename: 'tubings', id: any, author_id: string, coupling_outer_diameter_inches?: any | null, created_at: any, deleted_at?: any | null, drift_inches?: any | null, imperial_name?: string | null, imported_sizing_id?: number | null, interior_diameter_inches?: any | null, metric_name?: string | null, outer_diameter_inches?: any | null, pound_per_foot?: any | null, tubing_type: Tubings_Type_Enum, updated_at: any, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null } | null }>, r_xref_uphole_y_tool_equipment_tubings: Array<{ __typename: 'sc_equip_xref_uphole_ytool_equip_tubings', id?: any | null, length_feet?: any | null, tubing_id?: any | null, scenario_equipment_id?: any | null, parent_id?: any | null, journal_author_id?: string | null, journal_created_at?: any | null, journal_updated_at?: any | null, journal_deleted_at?: any | null, winning_revision_id?: any | null, winning_revision_parent_id?: any | null, winning_revision_author_id?: string | null, winning_revision_created_at?: any | null, winning_revision_updated_at?: any | null, winning_revision_deleted_at?: any | null, r_tubing?: { __typename: 'tubings', id: any, author_id: string, coupling_outer_diameter_inches?: any | null, created_at: any, deleted_at?: any | null, drift_inches?: any | null, imperial_name?: string | null, imported_sizing_id?: number | null, interior_diameter_inches?: any | null, metric_name?: string | null, outer_diameter_inches?: any | null, pound_per_foot?: any | null, tubing_type: Tubings_Type_Enum, updated_at: any, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null } | null }>, r_xref_downhole_y_tool_bypass_tubings: Array<{ __typename: 'sc_equip_xref_downhole_ytool_bypass_tubings', id?: any | null, length_feet?: any | null, tubing_id?: any | null, scenario_equipment_id?: any | null, parent_id?: any | null, journal_author_id?: string | null, journal_created_at?: any | null, journal_updated_at?: any | null, journal_deleted_at?: any | null, winning_revision_id?: any | null, winning_revision_parent_id?: any | null, winning_revision_author_id?: string | null, winning_revision_created_at?: any | null, winning_revision_updated_at?: any | null, winning_revision_deleted_at?: any | null, r_tubing?: { __typename: 'tubings', id: any, author_id: string, coupling_outer_diameter_inches?: any | null, created_at: any, deleted_at?: any | null, drift_inches?: any | null, imperial_name?: string | null, imported_sizing_id?: number | null, interior_diameter_inches?: any | null, metric_name?: string | null, outer_diameter_inches?: any | null, pound_per_foot?: any | null, tubing_type: Tubings_Type_Enum, updated_at: any, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null } | null }>, r_xref_downhole_y_tool_equipment_tubings: Array<{ __typename: 'sc_equip_xref_downhole_ytool_equip_tubings', id?: any | null, length_feet?: any | null, tubing_id?: any | null, scenario_equipment_id?: any | null, parent_id?: any | null, journal_author_id?: string | null, journal_created_at?: any | null, journal_updated_at?: any | null, journal_deleted_at?: any | null, winning_revision_id?: any | null, winning_revision_parent_id?: any | null, winning_revision_author_id?: string | null, winning_revision_created_at?: any | null, winning_revision_updated_at?: any | null, winning_revision_deleted_at?: any | null, r_tubing?: { __typename: 'tubings', id: any, author_id: string, coupling_outer_diameter_inches?: any | null, created_at: any, deleted_at?: any | null, drift_inches?: any | null, imperial_name?: string | null, imported_sizing_id?: number | null, interior_diameter_inches?: any | null, metric_name?: string | null, outer_diameter_inches?: any | null, pound_per_foot?: any | null, tubing_type: Tubings_Type_Enum, updated_at: any, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null } | null }> } | null, parameters?: { __typename: 'scenario_parameters', id?: any | null, journal_author_id?: string | null, journal_created_at?: any | null, journal_updated_at?: any | null, journal_deleted_at?: any | null, bottom_casing_pressure_psia?: any | null, cable_cost_kw_hr_usd?: any | null, bottom_tubing_pressure_psia?: any | null, has_compression_pump?: boolean | null, intake_override_gas_separation_percent?: any | null, intake_gas_separation_override_type?: string | null, natural_override_gas_separation_percent?: any | null, natural_gas_separation_override_type?: string | null, intake_packer_installed?: boolean | null, use_legacy_gas_head_rerate?: boolean | null, include_casing_friction_loss?: boolean | null, maximum_frequency?: any | null, minimum_frequency?: any | null, motor_rerate_ratio?: any | null, motor_shroud_interior_diameter_inches?: any | null, pump_hz?: any | null, pump_override_gas_correction_percent?: any | null, pump_wear_head_correction_ratio?: any | null, pump_wear_brake_horsepower_correction_ratio?: any | null, surface_drive_incoming_power_volts?: any | null, target_liquid_rate_std_barrel_day?: any | null, vsd_input_voltage?: any | null, flow_model?: string | null, winning_revision_id?: any | null, lower_intake_packer_installed?: boolean | null, lower_intake_override_gas_separation_percent?: any | null, lower_intake_gas_separation_override_type?: string | null, lower_natural_override_gas_separation_percent?: any | null, lower_natural_gas_separation_override_type?: string | null, lower_pump_hz?: any | null, lower_has_compression_pump?: boolean | null, lower_pump_override_gas_correction_percent?: any | null, lower_motor_rerate_ratio?: any | null, lower_motor_shroud_interior_diameter_inches?: any | null, lower_use_legacy_gas_head_rerate?: boolean | null, lower_include_casing_friction_loss?: boolean | null, lower_pump_wear_head_correction_ratio?: any | null, lower_pump_wear_brake_horsepower_correction_ratio?: any | null, elevation_feet_asl?: any | null } | null, well_properties?: { __typename: 'scenario_well_properties', average_dls?: any | null, bottom_casing_id?: any | null, bottom_casing_length_feet?: any | null, bottom_tubing_id?: any | null, bottom_tubing_length_feet?: any | null, bottomhole_temperature_fahrenheit?: any | null, bubble_point_pressure_psia?: any | null, fluid_viscosity_override_cp?: any | null, condensate_api_override?: any | null, dew_point_pressure_psia_override?: any | null, co2_percent?: any | null, deviation_survey_id?: any | null, gas_specific_gravity?: any | null, gas_type?: string | null, h2s_percent?: any | null, id?: any | null, n2_percent?: any | null, c1_methane_percent?: any | null, c2_ethane_percent?: any | null, c3_propane_percent?: any | null, ic4_isobutene_percent?: any | null, nc4_butane_percent?: any | null, ic5_isopentane_percent?: any | null, nc5_bentane_percent?: any | null, c6_hexane_percent?: any | null, c7_heptane_percent?: any | null, oil_gravity_api?: any | null, surface_temperature_fahrenheit?: any | null, top_casing_id?: any | null, top_casing_length_feet?: any | null, top_of_perforations_measured_depth_feet?: any | null, top_of_perforations_true_vertical_depth_feet?: any | null, top_tubing_id?: any | null, top_tubing_length_feet?: any | null, water_specific_gravity?: any | null, well_test_datum_point_measured_depth_feet?: any | null, well_test_gas_input_type?: string | null, well_test_gas_rate_mscf_day?: any | null, well_test_liquid_input_type?: string | null, well_test_pressure_input_type?: string | null, well_test_productivity_index?: any | null, well_test_oil_rate_stb_day?: any | null, well_test_producing_bottom_hole_pressure_psia?: any | null, well_test_static_bottom_hole_pressure_psia?: any | null, hps_pump_inlet_pressure_psia?: any | null, hps_required_discharge_pressure_psia?: any | null, hps_pump_inlet_temperature_fahrenheit?: any | null, hps_liquid_type?: string | null, npsha_ft?: any | null, well_test_test_date?: any | null, well_test_water_rate_stb_day?: any | null, journal_author_id?: string | null, journal_created_at?: any | null, journal_updated_at?: any | null, journal_deleted_at?: any | null, winning_revision_id?: any | null, custom_fluid_properties?: any | null, custom_viscosities_properties?: any | null, o2_percent?: any | null, ar_percent?: any | null, r_top_tubing?: { __typename: 'tubings', id: any, author_id: string, coupling_outer_diameter_inches?: any | null, created_at: any, deleted_at?: any | null, drift_inches?: any | null, imperial_name?: string | null, imported_sizing_id?: number | null, interior_diameter_inches?: any | null, metric_name?: string | null, outer_diameter_inches?: any | null, pound_per_foot?: any | null, tubing_type: Tubings_Type_Enum, updated_at: any, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null } | null, r_bottom_tubing?: { __typename: 'tubings', id: any, author_id: string, coupling_outer_diameter_inches?: any | null, created_at: any, deleted_at?: any | null, drift_inches?: any | null, imperial_name?: string | null, imported_sizing_id?: number | null, interior_diameter_inches?: any | null, metric_name?: string | null, outer_diameter_inches?: any | null, pound_per_foot?: any | null, tubing_type: Tubings_Type_Enum, updated_at: any, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null } | null, r_top_casing?: { __typename: 'casings', id: any, casing_type: Casings_Type_Enum, imperial_name?: string | null, metric_name?: string | null, outer_diameter_inches?: any | null, interior_diameter_inches?: any | null, drift_inches?: any | null, coupling_outer_diameter_inches?: any | null, pound_per_foot?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null } | null, r_bottom_casing?: { __typename: 'casings', id: any, casing_type: Casings_Type_Enum, imperial_name?: string | null, metric_name?: string | null, outer_diameter_inches?: any | null, interior_diameter_inches?: any | null, drift_inches?: any | null, coupling_outer_diameter_inches?: any | null, pound_per_foot?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null } | null, r_deviation_survey?: { __typename: 'deviation_survey', id: any, created_at: any, updated_at: any, deleted_at?: any | null, title?: string | null, directional_data_set: Deviation_Survey_Directional_Dataset_Enum, imported_sizing_id?: number | null, entry_rows?: Array<any> | null } | null } | null, r_performance_evaluations: Array<{ __typename: 'performance_evaluations', id?: any | null, title?: string | null, pump_hz?: any | null, water_rate_std_barrel_day?: any | null, gas_rate_mscf_day?: any | null, oil_rate_std_barrel_day?: any | null, tubing_pressure_psia?: any | null, casing_pressure_psia?: any | null, pump_intake_pressure_psia?: any | null, pump_wear_head_correction_ratio?: any | null, pump_wear_brake_horsepower_correction_ratio?: any | null, intake_override_gas_separation_percent?: any | null, intake_gas_separation_override_type?: string | null, natural_override_gas_separation_percent?: any | null, natural_gas_separation_override_type?: string | null, journal_author_id?: string | null, journal_created_at?: any | null, journal_deleted_at?: any | null, journal_updated_at?: any | null, winning_revision_id?: any | null, scenario_id?: any | null, parent_id?: any | null, r_scenario?: { __typename: 'scenarios', id?: any | null, sizing_id?: any | null, journal_author_id?: string | null, journal_deleted_at?: any | null, well_properties_id?: any | null, scenario_equipment_id?: any | null, parameters_id?: any | null, correlations_id?: any | null, title?: string | null, pumping_type?: string | null, sizing?: { __typename: 'sizings', id?: any | null, journal_author_id?: string | null, journal_deleted_at?: any | null, well_id?: number | null, customer_id?: number | null, title?: string | null, notes?: string | null, well?: { __typename: 'wells', id: number, well_name?: string | null, well_uwi?: string | null, well_erp_id?: string | null, address_erp_id?: string | null } | null, customer?: { __typename: 'customers', id: number, customer_name?: string | null, customer_erp_id: string, imported_sizing_id?: number | null } | null } | null } | null, r_author?: { __typename: 'users', id: string, email?: string | null, username?: string | null, display_name?: string | null, hal_identifier?: string | null } | null, r_xref_pumps: Array<{ __typename: 'performance_evaluations_xref_pumps', id?: any | null, journal_author_id?: string | null, journal_created_at?: any | null, journal_deleted_at?: any | null, journal_updated_at?: any | null, winning_revision_id?: any | null, xref_pump_id?: any | null, performance_evaluation_id?: any | null, rate_correction_ratio?: any | null, head_correction_ratio?: any | null, brake_horsepower_correction_ratio?: any | null }> }> }> }>, sizings_aggregate?: { __typename: 'sizings_aggregate', id: 'sizings_aggregate', aggregate?: { __typename: 'sizings_aggregate_fields', count: number, id: 'sizings_aggregate_fields' } | null } };

export type SizingsWithScenarioIdsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Sizings_Bool_Exp>;
  order_by?: InputMaybe<Array<Sizings_Order_By>>;
  withAggregate?: Scalars['Boolean']['input'];
  withImportUser?: Scalars['Boolean']['input'];
}>;


export type SizingsWithScenarioIdsQuery = { __typename: 'query_root', sizings: Array<{ __typename: 'sizings', id?: any | null, parent_id?: any | null, journal_author_id?: string | null, journal_created_at?: any | null, journal_updated_at?: any | null, journal_deleted_at?: any | null, winning_revision_id?: any | null, winning_revision_author_id?: string | null, well_id?: number | null, customer_id?: number | null, installed_scenario_id?: any | null, title?: string | null, notes?: string | null, default_display_units?: string | null, disposition?: string | null, pumping_type?: string | null, is_shared?: boolean | null, imported_sizing_id?: number | null, share_with_customer?: boolean | null, hps_location?: string | null, scenario_order?: Array<any> | null, parent_sizing?: { __typename: 'sizings', id?: any | null, title?: string | null, pumping_type?: string | null, journal_deleted_at?: any | null, installed_scenario_id?: any | null, scenarios: Array<{ __typename: 'scenarios', id?: any | null, title?: string | null }> } | null, author?: { __typename: 'users', id: string, email?: string | null, username?: string | null, display_name?: string | null, hal_identifier?: string | null } | null, well?: { __typename: 'wells', id: number, well_name?: string | null, well_uwi?: string | null, well_erp_id?: string | null, address_erp_id?: string | null } | null, customer?: { __typename: 'customers', id: number, customer_name?: string | null, customer_erp_id: string, imported_sizing_id?: number | null } | null, imported_from_sizing?: { __typename: 'sizing_imports', id: number, legacy_author_id?: string | null, legacy_user?: { __typename: 'legacy_users', hal_identifier: string, display_name?: string | null } | null } | null, scenarios: Array<{ __typename: 'scenarios', id?: any | null, title?: string | null }> }>, sizings_aggregate?: { __typename: 'sizings_aggregate', id: 'sizings_aggregate', aggregate?: { __typename: 'sizings_aggregate_fields', count: number, id: 'sizings_aggregate_fields' } | null } };

export type InsertSizingsRevisionMutationVariables = Exact<{
  objects: Array<Revisions_Sizings_Revisions_Insert_Input>;
}>;


export type InsertSizingsRevisionMutation = { __typename: 'mutation_root', insert_revisions_sizings_revisions?: { __typename: 'revisions_sizings_revisions_mutation_response', returning: Array<{ __typename: 'revisions_sizings_revisions', id: any, sizings_view?: { __typename: 'sizings', id?: any | null, parent_id?: any | null, journal_author_id?: string | null, journal_created_at?: any | null, journal_updated_at?: any | null, journal_deleted_at?: any | null, winning_revision_id?: any | null, winning_revision_author_id?: string | null, well_id?: number | null, customer_id?: number | null, installed_scenario_id?: any | null, title?: string | null, notes?: string | null, default_display_units?: string | null, disposition?: string | null, pumping_type?: string | null, is_shared?: boolean | null, imported_sizing_id?: number | null, share_with_customer?: boolean | null, hps_location?: string | null, scenario_order?: Array<any> | null, well?: { __typename: 'wells', id: number, well_name?: string | null, well_uwi?: string | null, well_erp_id?: string | null, address_erp_id?: string | null } | null, customer?: { __typename: 'customers', id: number, customer_name?: string | null, customer_erp_id: string, imported_sizing_id?: number | null } | null } | null }> } | null };

export type SizingsManifoldMutationVariables = Exact<{
  sizings_revisions: Array<Revisions_Sizings_Revisions_Insert_Input>;
  scenarios_revisions: Array<Revisions_Scenarios_Revisions_Insert_Input>;
  scenario_equipment_revisions: Array<Revisions_Scenario_Equipment_Revisions_Insert_Input>;
  scenario_parameters_revisions: Array<Revisions_Scenario_Parameters_Revisions_Insert_Input>;
  scenario_well_properties_revisions: Array<Revisions_Scenario_Well_Properties_Revisions_Insert_Input>;
  deviation_survey: Array<Deviation_Survey_Insert_Input>;
  scenario_correlations_revisions: Array<Revisions_Scenario_Correlations_Revisions_Insert_Input>;
  scenario_equipment_xref_seals_revisions: Array<Revisions_Scenario_Equipment_Xref_Seals_Revisions_Insert_Input>;
  scenario_equipment_xref_intakes_revisions: Array<Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Insert_Input>;
  scenario_equipment_xref_cables_revisions: Array<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Insert_Input>;
  scenario_equipment_xref_pumps_revisions: Array<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Insert_Input>;
  scenario_equipment_xref_housings_revisions: Array<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Insert_Input>;
  sc_equip_xref_uphole_ytool_bypass_tubings_revisions: Array<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Insert_Input>;
  sc_equip_xref_uphole_ytool_equip_tubings_revisions: Array<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Insert_Input>;
  sc_equip_xref_downhole_ytool_bypass_tubings_revisions: Array<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Insert_Input>;
  sc_equip_xref_downhole_ytool_equip_tubings_revisions: Array<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Insert_Input>;
}>;


export type SizingsManifoldMutation = { __typename: 'mutation_root', insert_revisions_sizings_revisions?: { __typename: 'revisions_sizings_revisions_mutation_response', affected_rows: number, returning: Array<{ __typename: 'revisions_sizings_revisions', id: any, sizings_view?: { __typename: 'sizings', id?: any | null, parent_id?: any | null, journal_author_id?: string | null, journal_created_at?: any | null, journal_updated_at?: any | null, journal_deleted_at?: any | null, winning_revision_id?: any | null, winning_revision_author_id?: string | null, well_id?: number | null, customer_id?: number | null, installed_scenario_id?: any | null, title?: string | null, notes?: string | null, default_display_units?: string | null, disposition?: string | null, pumping_type?: string | null, is_shared?: boolean | null, imported_sizing_id?: number | null, share_with_customer?: boolean | null, hps_location?: string | null, scenario_order?: Array<any> | null } | null }> } | null, insert_revisions_scenario_equipment_revisions?: { __typename: 'revisions_scenario_equipment_revisions_mutation_response', affected_rows: number, returning: Array<{ __typename: 'revisions_scenario_equipment_revisions', id: any, scenario_equipment_view?: { __typename: 'scenario_equipment', id?: any | null, journal_author_id?: string | null, journal_created_at?: any | null, journal_updated_at?: any | null, journal_deleted_at?: any | null, mle_id?: any | null, lower_mle_id?: any | null, motor_id?: any | null, lower_motor_id?: any | null, bolt_on_discharge_id?: any | null, lower_bolt_on_discharge_id?: any | null, shroud_id?: any | null, lower_shroud_id?: any | null, parent_id?: any | null, sensor_id?: any | null, lower_sensor_id?: any | null, switchboard_id?: any | null, down_trans_id?: any | null, up_trans_id?: any | null, use_vsd?: boolean | null, use_uphole_y_tool?: boolean | null, use_downhole_y_tool?: boolean | null, has_lower_equip_stack?: boolean | null, vsd_id?: any | null, seals_order?: Array<any> | null, lower_seals_order?: Array<any> | null, winning_revision_author_id?: string | null, winning_revision_id?: any | null, intakes_order?: Array<any> | null, lower_intakes_order?: Array<any> | null, cables_order?: Array<any> | null, lower_cables_order?: Array<any> | null, pumps_order?: Array<any> | null, lower_pumps_order?: Array<any> | null, seal_motor_oil_id?: any | null, lower_seal_motor_oil_id?: any | null, uphole_y_tool_id?: any | null, downhole_y_tool_id?: any | null, include_y_tool?: boolean | null, uphole_y_tool_bypass_tubing_order?: Array<any> | null, uphole_y_tool_equipment_tubing_order?: Array<any> | null, downhole_y_tool_bypass_tubing_order?: Array<any> | null, downhole_y_tool_equipment_tubing_order?: Array<any> | null, r_sensor?: { __typename: 'sensors', id: any, manufacturer?: string | null, part_number?: string | null, model?: string | null, length_inches?: number | null, weight_pounds?: number | null, inner_diameter_inches?: any | null, outer_diameter_inches: any, neck_inner_diameter_inches?: any | null, neck_outer_diameter_inches?: any | null } | null, r_lower_sensor?: { __typename: 'sensors', id: any, manufacturer?: string | null, part_number?: string | null, model?: string | null, length_inches?: number | null, weight_pounds?: number | null, inner_diameter_inches?: any | null, outer_diameter_inches: any, neck_inner_diameter_inches?: any | null, neck_outer_diameter_inches?: any | null } | null, r_mle?: { __typename: 'motor_lead_extensions', id: any, manufacturer?: string | null, part_number?: string | null, series?: number | null, family?: string | null, gauge?: number | null, kv?: number | null, max_pothead_temperature_fahrenheit?: number | null, max_temperature_fahrenheit?: number | null, resistance_per_1000_ft?: any | null, impedance_60_hz_per_1000_ft?: any | null, amp_factor?: any | null, width_inches?: any | null, depth_inches?: any | null, pound_per_foot?: any | null, length_feet?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null } | null, r_lower_mle?: { __typename: 'motor_lead_extensions', id: any, manufacturer?: string | null, part_number?: string | null, series?: number | null, family?: string | null, gauge?: number | null, kv?: number | null, max_pothead_temperature_fahrenheit?: number | null, max_temperature_fahrenheit?: number | null, resistance_per_1000_ft?: any | null, impedance_60_hz_per_1000_ft?: any | null, amp_factor?: any | null, width_inches?: any | null, depth_inches?: any | null, pound_per_foot?: any | null, length_feet?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null } | null, r_motor?: { __typename: 'motors', id: any, author_id: string, allow_rerate: boolean, configuration?: string | null, created_at: any, deleted_at?: any | null, eff1?: any | null, eff2?: any | null, eff3?: any | null, eff4?: any | null, eff5?: any | null, effb?: any | null, i1?: any | null, i2?: any | null, i3?: any | null, i4?: any | null, i5?: any | null, ib?: any | null, imported_sizing_id?: number | null, length_inches?: any | null, manufacturer?: string | null, n1?: any | null, n2?: any | null, n3?: any | null, n4?: any | null, n5?: any | null, nameplate_current?: number | null, nameplate_horsepower?: number | null, nameplate_voltage?: number | null, nb?: any | null, oil_volume_gallons?: any | null, part_number?: string | null, pf1?: any | null, pf2?: any | null, pf3?: any | null, pf4?: any | null, pf5?: any | null, pfb?: any | null, rr_l1?: any | null, rr_l2?: any | null, rr_lb?: any | null, rr_v3: any, rr_v2: any, rr_v1?: any | null, rr_vb?: any | null, shaft_horsepower?: number | null, nv0: any, nv1: any, nv2: any, iv0: any, iv1: any, iv2: any, pfv0: any, pfv1: any, pfv2: any, effv0: any, effv1: any, effv2: any, tv0: any, tv1: any, tv2: any, temperature_rating_fahrenheit?: number | null, updated_at: any, weight_pounds?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, poles?: number | null, stator_inner_diameter_inches?: any | null, stator_outer_diameter_inches?: any | null, k3?: any | null, nameplate_rerate_ratio?: any | null, inner_diameter_inches?: any | null, outer_diameter_inches?: any | null, neck_inner_diameter_inches?: any | null, neck_outer_diameter_inches?: any | null, mle_offset_depth_inches: any, outer_diameter_rub_inches: any, is_hps: boolean } | null, r_bolt_on_discharge?: { __typename: 'bolt_on_discharges', id: any, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, manufacturer?: string | null, series_model?: string | null, is_hps: boolean, outer_diameter_inches?: any | null, inner_diameter_inches?: any | null, flange_outer_diameter_inches?: any | null, neck_outer_diameter_inches?: any | null, neck_inner_diameter_inches?: any | null, length_inches?: any | null, weight_pounds?: any | null, tubing_diameter_inches?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null } | null, r_lower_bolt_on_discharge?: { __typename: 'bolt_on_discharges', id: any, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, manufacturer?: string | null, series_model?: string | null, is_hps: boolean, outer_diameter_inches?: any | null, inner_diameter_inches?: any | null, flange_outer_diameter_inches?: any | null, neck_outer_diameter_inches?: any | null, neck_inner_diameter_inches?: any | null, length_inches?: any | null, weight_pounds?: any | null, tubing_diameter_inches?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null } | null, r_lower_motor?: { __typename: 'motors', id: any, author_id: string, allow_rerate: boolean, configuration?: string | null, created_at: any, deleted_at?: any | null, eff1?: any | null, eff2?: any | null, eff3?: any | null, eff4?: any | null, eff5?: any | null, effb?: any | null, i1?: any | null, i2?: any | null, i3?: any | null, i4?: any | null, i5?: any | null, ib?: any | null, imported_sizing_id?: number | null, length_inches?: any | null, manufacturer?: string | null, n1?: any | null, n2?: any | null, n3?: any | null, n4?: any | null, n5?: any | null, nameplate_current?: number | null, nameplate_horsepower?: number | null, nameplate_voltage?: number | null, nb?: any | null, oil_volume_gallons?: any | null, part_number?: string | null, pf1?: any | null, pf2?: any | null, pf3?: any | null, pf4?: any | null, pf5?: any | null, pfb?: any | null, rr_l1?: any | null, rr_l2?: any | null, rr_lb?: any | null, rr_v3: any, rr_v2: any, rr_v1?: any | null, rr_vb?: any | null, shaft_horsepower?: number | null, nv0: any, nv1: any, nv2: any, iv0: any, iv1: any, iv2: any, pfv0: any, pfv1: any, pfv2: any, effv0: any, effv1: any, effv2: any, tv0: any, tv1: any, tv2: any, temperature_rating_fahrenheit?: number | null, updated_at: any, weight_pounds?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, poles?: number | null, stator_inner_diameter_inches?: any | null, stator_outer_diameter_inches?: any | null, k3?: any | null, nameplate_rerate_ratio?: any | null, inner_diameter_inches?: any | null, outer_diameter_inches?: any | null, neck_inner_diameter_inches?: any | null, neck_outer_diameter_inches?: any | null, mle_offset_depth_inches: any, outer_diameter_rub_inches: any, is_hps: boolean } | null, r_shroud?: { __typename: 'casings', id: any, casing_type: Casings_Type_Enum, imperial_name?: string | null, metric_name?: string | null, outer_diameter_inches?: any | null, interior_diameter_inches?: any | null, drift_inches?: any | null, coupling_outer_diameter_inches?: any | null, pound_per_foot?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null } | null, r_lower_shroud?: { __typename: 'casings', id: any, casing_type: Casings_Type_Enum, imperial_name?: string | null, metric_name?: string | null, outer_diameter_inches?: any | null, interior_diameter_inches?: any | null, drift_inches?: any | null, coupling_outer_diameter_inches?: any | null, pound_per_foot?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null } | null, r_step_down_transformer?: { __typename: 'step_down_transformers', id: any, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, manufacturer?: string | null, part_number?: string | null, transformer_type?: string | null, primary_voltage_delta?: number | null, primary_voltage_wye?: number | null, min_secondary_voltage?: number | null, max_secondary_voltage?: number | null, weight_pounds?: number | null, enclosure?: string | null, kva?: number | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null } | null, r_step_up_transformer?: { __typename: 'step_up_transformers', id: any, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, manufacturer?: string | null, part_number?: string | null, transformer_type?: string | null, primary_voltage?: number | null, min_secondary_voltage?: number | null, max_secondary_voltage?: number | null, weight_pounds?: number | null, enclosure?: string | null, kva?: number | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null } | null, r_vsd?: { __typename: 'variable_speed_drives', id: any, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, enclosure?: string | null, kva?: number | null, manufacturer?: string | null, max_amps?: number | null, part_number?: string | null, vsd_type?: string | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null } | null, r_switchboard?: { __typename: 'switchboards', id: any, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, amps?: number | null, enclosure?: string | null, kv?: any | null, manufacturer?: string | null, part_number?: string | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null } | null, r_seal_motor_oil?: { __typename: 'seal_motor_oil', created_at: any, updated_at: any, deleted_at?: any | null, id: any, name: string, thermal_expansion_factor?: any | null, max_temp_fahrenheit?: number | null, mf_test_temp1_celsius?: number | null, mf_test_temp2_celsius?: number | null, viscosity_test1_centistroke?: any | null, viscosity_test2_centistroke?: any | null, specific_gravity?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null } | null, r_lower_seal_motor_oil?: { __typename: 'seal_motor_oil', created_at: any, updated_at: any, deleted_at?: any | null, id: any, name: string, thermal_expansion_factor?: any | null, max_temp_fahrenheit?: number | null, mf_test_temp1_celsius?: number | null, mf_test_temp2_celsius?: number | null, viscosity_test1_centistroke?: any | null, viscosity_test2_centistroke?: any | null, specific_gravity?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null } | null, r_uphole_y_tool?: { __typename: 'y_tools', id: any, author_id: string, created_at: any, deleted_at?: any | null, updated_at: any, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, minimum_inches?: any | null, maximum_inches?: any | null, length_inches?: any | null, width_inches?: any | null, series_model?: string | null, outer_diameter_inches?: any | null, teleswivel_stroke_length_inches?: any | null, pressure_rating_psi?: number | null, temperature_rating_fahrenheit?: number | null, handling_sub_connection_inches?: any | null, bypass_connection_inches?: any | null, material_type?: string | null, weight_pounds?: any | null, manufacturer?: string | null } | null, r_downhole_y_tool?: { __typename: 'y_tools', id: any, author_id: string, created_at: any, deleted_at?: any | null, updated_at: any, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, minimum_inches?: any | null, maximum_inches?: any | null, length_inches?: any | null, width_inches?: any | null, series_model?: string | null, outer_diameter_inches?: any | null, teleswivel_stroke_length_inches?: any | null, pressure_rating_psi?: number | null, temperature_rating_fahrenheit?: number | null, handling_sub_connection_inches?: any | null, bypass_connection_inches?: any | null, material_type?: string | null, weight_pounds?: any | null, manufacturer?: string | null } | null } | null }> } | null, insert_revisions_scenario_parameters_revisions?: { __typename: 'revisions_scenario_parameters_revisions_mutation_response', affected_rows: number, returning: Array<{ __typename: 'revisions_scenario_parameters_revisions', id: any, scenario_parameters_view?: { __typename: 'scenario_parameters', id?: any | null, journal_author_id?: string | null, journal_created_at?: any | null, journal_updated_at?: any | null, journal_deleted_at?: any | null, bottom_casing_pressure_psia?: any | null, cable_cost_kw_hr_usd?: any | null, bottom_tubing_pressure_psia?: any | null, has_compression_pump?: boolean | null, intake_override_gas_separation_percent?: any | null, intake_gas_separation_override_type?: string | null, natural_override_gas_separation_percent?: any | null, natural_gas_separation_override_type?: string | null, intake_packer_installed?: boolean | null, use_legacy_gas_head_rerate?: boolean | null, include_casing_friction_loss?: boolean | null, maximum_frequency?: any | null, minimum_frequency?: any | null, motor_rerate_ratio?: any | null, motor_shroud_interior_diameter_inches?: any | null, pump_hz?: any | null, pump_override_gas_correction_percent?: any | null, pump_wear_head_correction_ratio?: any | null, pump_wear_brake_horsepower_correction_ratio?: any | null, surface_drive_incoming_power_volts?: any | null, target_liquid_rate_std_barrel_day?: any | null, vsd_input_voltage?: any | null, flow_model?: string | null, winning_revision_id?: any | null, lower_intake_packer_installed?: boolean | null, lower_intake_override_gas_separation_percent?: any | null, lower_intake_gas_separation_override_type?: string | null, lower_natural_override_gas_separation_percent?: any | null, lower_natural_gas_separation_override_type?: string | null, lower_pump_hz?: any | null, lower_has_compression_pump?: boolean | null, lower_pump_override_gas_correction_percent?: any | null, lower_motor_rerate_ratio?: any | null, lower_motor_shroud_interior_diameter_inches?: any | null, lower_use_legacy_gas_head_rerate?: boolean | null, lower_include_casing_friction_loss?: boolean | null, lower_pump_wear_head_correction_ratio?: any | null, lower_pump_wear_brake_horsepower_correction_ratio?: any | null, elevation_feet_asl?: any | null } | null }> } | null, insert_deviation_survey?: { __typename: 'deviation_survey_mutation_response', affected_rows: number, returning: Array<{ __typename: 'deviation_survey', id: any, created_at: any, updated_at: any, deleted_at?: any | null, title?: string | null, directional_data_set: Deviation_Survey_Directional_Dataset_Enum, imported_sizing_id?: number | null, entry_rows?: Array<any> | null }> } | null, insert_revisions_scenario_equipment_xref_seals_revisions?: { __typename: 'revisions_scenario_equipment_xref_seals_revisions_mutation_response', returning: Array<{ __typename: 'revisions_scenario_equipment_xref_seals_revisions', id: any, scenario_equipment_xref_seals_view?: { __typename: 'scenario_equipment_xref_seals', id?: any | null, use_high_strength_shaft?: boolean | null, parent_id?: any | null, journal_author_id?: string | null, journal_created_at?: any | null, journal_updated_at?: any | null, journal_deleted_at?: any | null, winning_revision_id?: any | null, winning_revision_parent_id?: any | null, scenario_equipment_id?: any | null, seal_id?: any | null, winning_revision_author_id?: string | null, winning_revision_created_at?: any | null, winning_revision_updated_at?: any | null, winning_revision_deleted_at?: any | null, seal?: { __typename: 'seals', id: any, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, manufacturer?: string | null, part_number?: string | null, length_inches?: any | null, weight_pounds?: any | null, configuration?: string | null, max_temperature_fahrenheit?: number | null, standard_shaft_limit_hp?: number | null, high_strength_shaft_limit_hp?: number | null, standard_bearing_rating_pounds?: number | null, high_strength_bearing_rating_pounds?: number | null, housing_material?: string | null, bearing_type?: string | null, total_seal_volume_gallons?: any | null, volume_for_bag_expansion_lower_tandem_gallons?: any | null, volume_for_bag_expansion_upper_tandem_gallons?: any | null, upper_chamber_pull_volume_gallons?: any | null, bag_chambers?: number | null, bag_capacity_gallons?: any | null, string_load_pounds?: any | null, load_cb_pounds?: any | null, load_c1_pounds?: any | null, hps_thrust_chamber: boolean, load_test_temperature_fahrenheit?: number | null, description?: string | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, inner_diameter_inches?: any | null, outer_diameter_inches?: any | null, neck_inner_diameter_inches?: any | null, neck_outer_diameter_inches?: any | null, thrust_collar_inner_diameter_inches: any, thrust_collar_outer_diameter_inches: any } | null } | null }> } | null, insert_revisions_scenario_well_properties_revisions?: { __typename: 'revisions_scenario_well_properties_revisions_mutation_response', affected_rows: number, returning: Array<{ __typename: 'revisions_scenario_well_properties_revisions', id: any, scenario_well_properties_view?: { __typename: 'scenario_well_properties', average_dls?: any | null, bottom_casing_id?: any | null, bottom_casing_length_feet?: any | null, bottom_tubing_id?: any | null, bottom_tubing_length_feet?: any | null, bottomhole_temperature_fahrenheit?: any | null, bubble_point_pressure_psia?: any | null, fluid_viscosity_override_cp?: any | null, condensate_api_override?: any | null, dew_point_pressure_psia_override?: any | null, co2_percent?: any | null, deviation_survey_id?: any | null, gas_specific_gravity?: any | null, gas_type?: string | null, h2s_percent?: any | null, id?: any | null, n2_percent?: any | null, c1_methane_percent?: any | null, c2_ethane_percent?: any | null, c3_propane_percent?: any | null, ic4_isobutene_percent?: any | null, nc4_butane_percent?: any | null, ic5_isopentane_percent?: any | null, nc5_bentane_percent?: any | null, c6_hexane_percent?: any | null, c7_heptane_percent?: any | null, oil_gravity_api?: any | null, surface_temperature_fahrenheit?: any | null, top_casing_id?: any | null, top_casing_length_feet?: any | null, top_of_perforations_measured_depth_feet?: any | null, top_of_perforations_true_vertical_depth_feet?: any | null, top_tubing_id?: any | null, top_tubing_length_feet?: any | null, water_specific_gravity?: any | null, well_test_datum_point_measured_depth_feet?: any | null, well_test_gas_input_type?: string | null, well_test_gas_rate_mscf_day?: any | null, well_test_liquid_input_type?: string | null, well_test_pressure_input_type?: string | null, well_test_productivity_index?: any | null, well_test_oil_rate_stb_day?: any | null, well_test_producing_bottom_hole_pressure_psia?: any | null, well_test_static_bottom_hole_pressure_psia?: any | null, hps_pump_inlet_pressure_psia?: any | null, hps_required_discharge_pressure_psia?: any | null, hps_pump_inlet_temperature_fahrenheit?: any | null, hps_liquid_type?: string | null, npsha_ft?: any | null, well_test_test_date?: any | null, well_test_water_rate_stb_day?: any | null, journal_author_id?: string | null, journal_created_at?: any | null, journal_updated_at?: any | null, journal_deleted_at?: any | null, winning_revision_id?: any | null, custom_fluid_properties?: any | null, custom_viscosities_properties?: any | null, o2_percent?: any | null, ar_percent?: any | null, deviation_survey?: { __typename: 'deviation_survey', id: any, created_at: any, updated_at: any, deleted_at?: any | null, title?: string | null, directional_data_set: Deviation_Survey_Directional_Dataset_Enum, imported_sizing_id?: number | null, entry_rows?: Array<any> | null } | null } | null }> } | null, insert_revisions_scenario_correlations_revisions?: { __typename: 'revisions_scenario_correlations_revisions_mutation_response', affected_rows: number, returning: Array<{ __typename: 'revisions_scenario_correlations_revisions', id: any, scenario_correlations_view?: { __typename: 'scenario_correlations', id?: any | null, journal_author_id?: string | null, journal_deleted_at?: any | null, winning_revision_id?: any | null, bubble_point?: string | null, dead_oil?: string | null, friction_loss?: string | null, gas_compressibility?: string | null, gas_viscosity?: string | null, tubing_hazen_williams_coefficient?: any | null, casing_hazen_williams_coefficient?: any | null, tubing_apply_hazen_williams_correction?: boolean | null, casing_apply_hazen_williams_correction?: boolean | null, oil_density?: string | null, oil_volume_factor_saturated?: string | null, oil_volume_factor_undersaturated?: string | null, tubing_palmer_correction?: boolean | null, casing_palmer_correction?: boolean | null, tubing_griffith_wallis?: boolean | null, casing_griffith_wallis?: boolean | null, salinity_ppm?: any | null, saturated_oil?: string | null, solution_gor?: string | null, tubing_flow?: string | null, casing_flow?: string | null, tubing_roughness_inches?: any | null, casing_roughness_inches?: any | null, under_saturated_oil?: string | null, water_density?: string | null, water_solution_gas?: string | null, water_viscosity?: string | null, water_volume_factor?: string | null, natural_gas_separation?: string | null, tdh_tuning_factor_ratio?: any | null } | null }> } | null, insert_revisions_scenario_equipment_xref_intakes_revisions?: { __typename: 'revisions_scenario_equipment_xref_intakes_revisions_mutation_response', returning: Array<{ __typename: 'revisions_scenario_equipment_xref_intakes_revisions', id: any, scenario_equipment_xref_intakes_view?: { __typename: 'scenario_equipment_xref_intakes', id?: any | null, intake_id?: any | null, scenario_equipment_id?: any | null, use_high_strength_shaft?: boolean | null, parent_id?: any | null, journal_author_id?: string | null, journal_created_at?: any | null, journal_updated_at?: any | null, journal_deleted_at?: any | null, winning_revision_id?: any | null, winning_revision_parent_id?: any | null, winning_revision_author_id?: string | null, winning_revision_created_at?: any | null, winning_revision_updated_at?: any | null, winning_revision_deleted_at?: any | null, intake?: { __typename: 'intakes', id: any, manufacturer?: string | null, intake_type?: string | null, part_number?: string | null, configuration?: string | null, length_inches?: any | null, weight_pounds?: any | null, shaft_material?: string | null, shaft_limit_hp?: number | null, housing_material?: string | null, max_rate_bpd?: number | null, hp?: any | null, eff1?: any | null, eff2?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, high_strength_shaft_limit_hp?: number | null, stage_count?: number | null, bhp0?: any | null, bhp1?: any | null, bhp2?: any | null, bhp3?: any | null, bhp4?: any | null, bhp5?: any | null, bolt_on?: boolean | null, port_area_square_inches: any, inner_diameter_inches?: any | null, outer_diameter_inches?: any | null, neck_inner_diameter_inches?: any | null, neck_outer_diameter_inches?: any | null, is_hps: boolean, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null } | null } | null }> } | null, insert_revisions_scenario_equipment_xref_cables_revisions?: { __typename: 'revisions_scenario_equipment_xref_cables_revisions_mutation_response', returning: Array<{ __typename: 'revisions_scenario_equipment_xref_cables_revisions', id: any, scenario_equipment_xref_cables_view?: { __typename: 'scenario_equipment_xref_cables', id?: any | null, length_feet?: any | null, cable_id?: any | null, scenario_equipment_id?: any | null, parent_id?: any | null, journal_author_id?: string | null, journal_created_at?: any | null, journal_updated_at?: any | null, journal_deleted_at?: any | null, winning_revision_id?: any | null, winning_revision_parent_id?: any | null, winning_revision_author_id?: string | null, winning_revision_created_at?: any | null, winning_revision_updated_at?: any | null, winning_revision_deleted_at?: any | null, cable?: { __typename: 'cables', id: any, amp_factor?: any | null, armor?: string | null, construction?: string | null, depth_inches?: any | null, family?: string | null, gauge?: string | null, kv?: number | null, manufacturer?: string | null, max_temperature_fahrenheit?: number | null, part_number?: string | null, pound_per_foot?: any | null, width_inches?: any | null, impedance_60_hz_per_1000_ft?: any | null, resistance_per_1000_ft?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, author_id: string, created_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, updated_at: any } | null } | null }> } | null, insert_revisions_scenario_equipment_xref_pumps_revisions?: { __typename: 'revisions_scenario_equipment_xref_pumps_revisions_mutation_response', returning: Array<{ __typename: 'revisions_scenario_equipment_xref_pumps_revisions', id: any, scenario_equipment_xref_pumps_view?: { __typename: 'scenario_equipment_xref_pumps', id?: any | null, scenario_equipment_id?: any | null, pump_id?: any | null, rate_correction_ratio?: any | null, head_correction_ratio?: any | null, brake_horsepower_correction_ratio?: any | null, total_stages?: number | null, length_feet?: any | null, housings_order?: Array<any> | null, use_high_strength_shaft?: boolean | null, weight_pounds?: any | null, parent_id?: any | null, journal_author_id?: string | null, journal_created_at?: any | null, journal_updated_at?: any | null, journal_deleted_at?: any | null, winning_revision_id?: any | null, winning_revision_parent_id?: any | null, winning_revision_author_id?: string | null, winning_revision_created_at?: any | null, winning_revision_updated_at?: any | null, winning_revision_deleted_at?: any | null, pump?: { __typename: 'pumps', id: any, manufacturer?: string | null, series_model?: string | null, rotation?: string | null, part_number?: string | null, compression_thrust_per_stage?: any | null, shaft_diameter_inches?: any | null, max_bolt_load_pounds?: any | null, is_compression_pump: boolean, housing_inner_diameter_inches?: any | null, housing_outer_diameter_inches?: any | null, neck_inner_diameter_inches?: any | null, neck_outer_diameter_inches?: any | null } | null, xref_housings: Array<{ __typename: 'scenario_equipment_xref_housings', housing_id?: any | null, id?: any | null, journal_author_id?: string | null, journal_created_at?: any | null, journal_deleted_at?: any | null, journal_updated_at?: any | null, length_inches?: any | null, parent_id?: any | null, scenario_equipment_xref_pump_id?: any | null, stage_count?: number | null, winning_revision_author_id?: string | null, winning_revision_created_at?: any | null, winning_revision_deleted_at?: any | null, winning_revision_id?: any | null, winning_revision_parent_id?: any | null, winning_revision_updated_at?: any | null, housing?: { __typename: 'housings', id: any, housing_number?: number | null, stage_count?: number | null, length_inches?: any | null, weight_pounds?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null } | null }> } | null }> } | null, insert_revisions_scenario_equipment_xref_housings_revisions?: { __typename: 'revisions_scenario_equipment_xref_housings_revisions_mutation_response', returning: Array<{ __typename: 'revisions_scenario_equipment_xref_housings_revisions', id: any, scenario_equipment_xref_housings_view?: { __typename: 'scenario_equipment_xref_housings', housing_id?: any | null, id?: any | null, journal_author_id?: string | null, journal_created_at?: any | null, journal_deleted_at?: any | null, journal_updated_at?: any | null, length_inches?: any | null, parent_id?: any | null, scenario_equipment_xref_pump_id?: any | null, stage_count?: number | null, winning_revision_author_id?: string | null, winning_revision_created_at?: any | null, winning_revision_deleted_at?: any | null, winning_revision_id?: any | null, winning_revision_parent_id?: any | null, winning_revision_updated_at?: any | null, housing?: { __typename: 'housings', id: any, housing_number?: number | null, stage_count?: number | null, length_inches?: any | null, weight_pounds?: any | null, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null, author_id: string, created_at: any, updated_at: any, deleted_at?: any | null, imported_sizing_id?: number | null, pump_id?: any | null } | null } | null }> } | null, insert_revisions_sc_equip_xref_uphole_ytool_bypass_tubings_revisions?: { __typename: 'revisions_sc_equip_xref_uphole_ytool_bypass_tubings_revisions_mutation_response', returning: Array<{ __typename: 'revisions_sc_equip_xref_uphole_ytool_bypass_tubings_revisions', id: any, sc_equip_xref_uphole_ytool_bypass_tubings_view?: { __typename: 'sc_equip_xref_uphole_ytool_bypass_tubings', id?: any | null, length_feet?: any | null, tubing_id?: any | null, scenario_equipment_id?: any | null, parent_id?: any | null, journal_author_id?: string | null, journal_created_at?: any | null, journal_updated_at?: any | null, journal_deleted_at?: any | null, winning_revision_id?: any | null, winning_revision_parent_id?: any | null, winning_revision_author_id?: string | null, winning_revision_created_at?: any | null, winning_revision_updated_at?: any | null, winning_revision_deleted_at?: any | null, tubing?: { __typename: 'tubings', id: any, author_id: string, coupling_outer_diameter_inches?: any | null, created_at: any, deleted_at?: any | null, drift_inches?: any | null, imperial_name?: string | null, imported_sizing_id?: number | null, interior_diameter_inches?: any | null, metric_name?: string | null, outer_diameter_inches?: any | null, pound_per_foot?: any | null, tubing_type: Tubings_Type_Enum, updated_at: any, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null } | null } | null }> } | null, insert_revisions_sc_equip_xref_uphole_ytool_equip_tubings_revisions?: { __typename: 'revisions_sc_equip_xref_uphole_ytool_equip_tubings_revisions_mutation_response', returning: Array<{ __typename: 'revisions_sc_equip_xref_uphole_ytool_equip_tubings_revisions', id: any, sc_equip_xref_uphole_ytool_equip_tubings_view?: { __typename: 'sc_equip_xref_uphole_ytool_equip_tubings', id?: any | null, length_feet?: any | null, tubing_id?: any | null, scenario_equipment_id?: any | null, parent_id?: any | null, journal_author_id?: string | null, journal_created_at?: any | null, journal_updated_at?: any | null, journal_deleted_at?: any | null, winning_revision_id?: any | null, winning_revision_parent_id?: any | null, winning_revision_author_id?: string | null, winning_revision_created_at?: any | null, winning_revision_updated_at?: any | null, winning_revision_deleted_at?: any | null, tubing?: { __typename: 'tubings', id: any, author_id: string, coupling_outer_diameter_inches?: any | null, created_at: any, deleted_at?: any | null, drift_inches?: any | null, imperial_name?: string | null, imported_sizing_id?: number | null, interior_diameter_inches?: any | null, metric_name?: string | null, outer_diameter_inches?: any | null, pound_per_foot?: any | null, tubing_type: Tubings_Type_Enum, updated_at: any, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null } | null } | null }> } | null, insert_revisions_sc_equip_xref_downhole_ytool_bypass_tubings_revisions?: { __typename: 'revisions_sc_equip_xref_downhole_ytool_bypass_tubings_revisions_mutation_response', returning: Array<{ __typename: 'revisions_sc_equip_xref_downhole_ytool_bypass_tubings_revisions', id: any, sc_equip_xref_downhole_ytool_bypass_tubings_view?: { __typename: 'sc_equip_xref_downhole_ytool_bypass_tubings', id?: any | null, length_feet?: any | null, tubing_id?: any | null, scenario_equipment_id?: any | null, parent_id?: any | null, journal_author_id?: string | null, journal_created_at?: any | null, journal_updated_at?: any | null, journal_deleted_at?: any | null, winning_revision_id?: any | null, winning_revision_parent_id?: any | null, winning_revision_author_id?: string | null, winning_revision_created_at?: any | null, winning_revision_updated_at?: any | null, winning_revision_deleted_at?: any | null, tubing?: { __typename: 'tubings', id: any, author_id: string, coupling_outer_diameter_inches?: any | null, created_at: any, deleted_at?: any | null, drift_inches?: any | null, imperial_name?: string | null, imported_sizing_id?: number | null, interior_diameter_inches?: any | null, metric_name?: string | null, outer_diameter_inches?: any | null, pound_per_foot?: any | null, tubing_type: Tubings_Type_Enum, updated_at: any, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null } | null } | null }> } | null, insert_revisions_sc_equip_xref_downhole_ytool_equip_tubings_revisions?: { __typename: 'revisions_sc_equip_xref_downhole_ytool_equip_tubings_revisions_mutation_response', returning: Array<{ __typename: 'revisions_sc_equip_xref_downhole_ytool_equip_tubings_revisions', id: any, sc_equip_xref_downhole_ytool_equip_tubings_view?: { __typename: 'sc_equip_xref_downhole_ytool_equip_tubings', id?: any | null, length_feet?: any | null, tubing_id?: any | null, scenario_equipment_id?: any | null, parent_id?: any | null, journal_author_id?: string | null, journal_created_at?: any | null, journal_updated_at?: any | null, journal_deleted_at?: any | null, winning_revision_id?: any | null, winning_revision_parent_id?: any | null, winning_revision_author_id?: string | null, winning_revision_created_at?: any | null, winning_revision_updated_at?: any | null, winning_revision_deleted_at?: any | null, tubing?: { __typename: 'tubings', id: any, author_id: string, coupling_outer_diameter_inches?: any | null, created_at: any, deleted_at?: any | null, drift_inches?: any | null, imperial_name?: string | null, imported_sizing_id?: number | null, interior_diameter_inches?: any | null, metric_name?: string | null, outer_diameter_inches?: any | null, pound_per_foot?: any | null, tubing_type: Tubings_Type_Enum, updated_at: any, include_koc_timestamp?: any | null, only_koc_timestamp?: any | null, include_ecopetrol_timestamp?: any | null, only_ecopetrol_timestamp?: any | null } | null } | null }> } | null, insert_revisions_scenarios_revisions?: { __typename: 'revisions_scenarios_revisions_mutation_response', affected_rows: number, returning: Array<{ __typename: 'revisions_scenarios_revisions', id: any, scenarios_view?: { __typename: 'scenarios', id?: any | null, journal_author_id?: string | null, journal_created_at?: any | null, journal_updated_at?: any | null, journal_deleted_at?: any | null, winning_revision_id?: any | null, title?: string | null, notes?: string | null, internal_notes?: string | null, reason?: string | null, sizing_id?: any | null, well_properties_id?: any | null, scenario_equipment_id?: any | null, parameters_id?: any | null, correlations_id?: any | null, display_unit_overrides?: any | null, pumping_type?: string | null, author?: { __typename: 'users', id: string, email?: string | null, username?: string | null, display_name?: string | null, hal_identifier?: string | null } | null } | null }> } | null };

export type SkBillablesQueryVariables = Exact<{
  summitQueryString: Scalars['String']['input'];
}>;


export type SkBillablesQuery = { __typename: 'query_root', getSKBillables?: Array<{ __typename: 'SKBillable', id?: number | null, margin?: number | null, material_description?: string | null, material_long_description?: string | null, material_number?: string | null, material_type?: string | null, price?: string | null, pricing_date?: string | null, quantity?: string | null, quote_price?: number | null, total?: string | null, notes_description?: string | null, serialized?: boolean | null, prod_hierarchy?: string | null } | null> | null };

export type SkContractsQueryVariables = Exact<{
  summitQueryString: Scalars['String']['input'];
}>;


export type SkContractsQuery = { __typename: 'query_root', getSKContracts?: Array<{ __typename: 'SKContract', active?: boolean | null, customer?: string | null, deleted?: boolean | null, name?: string | null, number?: string | null, pricing_date?: string | null, id?: string | null, date_range?: { __typename: 'SKMaterialDateRange', bounds?: string | null, lower?: string | null, upper?: string | null, id: 'SKMaterialDateRange' } | null, price_list?: { __typename: 'SKPriceList', active?: boolean | null, deleted?: boolean | null, name?: string | null, number?: string | null, id: 'SKPriceList' } | null } | null> | null };

export type GetSkCurrenciesQueryVariables = Exact<{
  summitQueryString?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetSkCurrenciesQuery = { __typename: 'query_root', getSKCurrencies?: Array<{ __typename: 'SKCurrency', code?: string | null, active?: boolean | null, deleted?: boolean | null, description?: string | null, id?: string | null } | null> | null };

export type SkCustomersQueryVariables = Exact<{
  summitQueryString?: InputMaybe<Scalars['String']['input']>;
}>;


export type SkCustomersQuery = { __typename: 'query_root', getSKCustomers?: Array<{ __typename: 'SKCustomer', id?: number | null, name?: string | null } | null> | null };

export type SkEquipmentTypeConversionsQueryVariables = Exact<{
  summitQueryString: Scalars['String']['input'];
}>;


export type SkEquipmentTypeConversionsQuery = { __typename: 'query_root', getSKEquipmentTypeConversions?: Array<{ __typename: 'SKEquipmentTypeConversion', id?: number | null, equipment_type?: string | null, sap_server?: string | null, label?: string | null, cable_type?: string | null, hierarchy_numbers?: Array<string | null> | null } | null> | null };

export type ErpWellFragment = { __typename: 'SKJob', erp_well?: { __typename: 'ErpWell', country_code?: string | null, country_name?: string | null, region_code?: string | null, region_name?: string | null, sap_id?: string | null, ship_to_address_id?: string | null, ship_to_address_name?: string | null, ship_to_full_address?: string | null, sold_to_customer_id?: string | null, sold_to_customer_msa_signed?: boolean | null, sold_to_customer_name?: string | null, uwi?: string | null, well_name?: string | null, welladdress_id?: string | null } | null };

export type JobTypeFragment = { __typename: 'SKJob', job_type?: { __typename: 'JobType', material_number?: string | null } | null };

export type JobFieldsFragment = { __typename: 'SKJob', id?: number | null, contract?: string | null, nwa_id?: string | null, natural_work_area?: string | null, planning_order?: string | null, plant_name?: string | null, plant_erp_id?: string | null, price_list_name?: string | null, price_list_number?: string | null, pricing_date?: string | null, proposed_job_start_date?: string | null, number?: string | null, date?: string | null, currency?: string | null, contract_name?: string | null, erp_well?: { __typename: 'ErpWell', country_code?: string | null, country_name?: string | null, region_code?: string | null, region_name?: string | null, sap_id?: string | null, ship_to_address_id?: string | null, ship_to_address_name?: string | null, ship_to_full_address?: string | null, sold_to_customer_id?: string | null, sold_to_customer_msa_signed?: boolean | null, sold_to_customer_name?: string | null, uwi?: string | null, well_name?: string | null, welladdress_id?: string | null } | null, job_type?: { __typename: 'JobType', material_number?: string | null } | null };

export type SkJobsQueryVariables = Exact<{
  summitQueryString?: InputMaybe<Scalars['String']['input']>;
}>;


export type SkJobsQuery = { __typename: 'query_root', getSKJobs?: Array<{ __typename: 'SKJob', id?: number | null, contract?: string | null, nwa_id?: string | null, natural_work_area?: string | null, planning_order?: string | null, plant_name?: string | null, plant_erp_id?: string | null, price_list_name?: string | null, price_list_number?: string | null, pricing_date?: string | null, proposed_job_start_date?: string | null, number?: string | null, date?: string | null, currency?: string | null, contract_name?: string | null, erp_well?: { __typename: 'ErpWell', country_code?: string | null, country_name?: string | null, region_code?: string | null, region_name?: string | null, sap_id?: string | null, ship_to_address_id?: string | null, ship_to_address_name?: string | null, ship_to_full_address?: string | null, sold_to_customer_id?: string | null, sold_to_customer_msa_signed?: boolean | null, sold_to_customer_name?: string | null, uwi?: string | null, well_name?: string | null, welladdress_id?: string | null } | null, job_type?: { __typename: 'JobType', material_number?: string | null } | null } | null> | null };

export type InsertJobMutationVariables = Exact<{
  object: SkJobInput;
}>;


export type InsertJobMutation = { __typename: 'mutation_root', createSKJob?: { __typename: 'SKJob', id?: number | null, contract?: string | null, nwa_id?: string | null, natural_work_area?: string | null, planning_order?: string | null, plant_name?: string | null, plant_erp_id?: string | null, price_list_name?: string | null, price_list_number?: string | null, pricing_date?: string | null, proposed_job_start_date?: string | null, number?: string | null, date?: string | null, currency?: string | null, contract_name?: string | null, erp_well?: { __typename: 'ErpWell', country_code?: string | null, country_name?: string | null, region_code?: string | null, region_name?: string | null, sap_id?: string | null, ship_to_address_id?: string | null, ship_to_address_name?: string | null, ship_to_full_address?: string | null, sold_to_customer_id?: string | null, sold_to_customer_msa_signed?: boolean | null, sold_to_customer_name?: string | null, uwi?: string | null, well_name?: string | null, welladdress_id?: string | null } | null, job_type?: { __typename: 'JobType', material_number?: string | null } | null } | null };

export type SkMaterialsQueryVariables = Exact<{
  summitQueryString?: InputMaybe<Scalars['String']['input']>;
}>;


export type SkMaterialsQuery = { __typename: 'query_root', getSKMaterials?: Array<{ __typename: 'SKMaterial', active?: boolean | null, api_response_count?: number | null, base_uom?: string | null, deleted?: boolean | null, description?: string | null, extended_to_plants?: Array<string | null> | null, long_description?: string | null, material_type?: string | null, number?: string | null, prod_hierarchy?: string | null, refurb_of?: string | null, serialized?: boolean | null, so_uom?: string | null, spooled_type?: string | null, standard_offering?: boolean | null, id?: string | null, pricing?: { __typename: 'SKMaterialPricing', currency?: string | null, floor?: string | null, number?: string | null, price?: string | null, pricing_date?: string | null, type?: number | null, uom?: string | null, date_range?: { __typename: 'SKMaterialDateRange', bounds?: string | null, lower?: string | null, upper?: string | null } | null } | null, cable_inventory?: { __typename: 'SKCableInventory', available?: string | null, available_count?: number | null, inventory_count?: number | null, reserved?: string | null } | null, inventory?: { __typename: 'SKInventory', available?: string | null, reserved?: string | null } | null } | null> | null };

export type SkMaterialsPaginatedQueryVariables = Exact<{
  summitQueryString?: InputMaybe<Scalars['String']['input']>;
}>;


export type SkMaterialsPaginatedQuery = { __typename: 'query_root', getSKMaterialsPaginated?: { __typename: 'SKMaterialsPaginated', count?: number | null, next?: string | null, previous?: string | null, results?: Array<{ __typename: 'SKMaterial', active?: boolean | null, base_uom?: string | null, deleted?: boolean | null, description?: string | null, extended_to_plants?: Array<string | null> | null, long_description?: string | null, material_type?: string | null, number?: string | null, prod_hierarchy?: string | null, refurb_of?: string | null, serialized?: boolean | null, so_uom?: string | null, spooled_type?: string | null, standard_offering?: boolean | null, id?: string | null, pricing?: { __typename: 'SKMaterialPricing', currency?: string | null, floor?: string | null, number?: string | null, price?: string | null, pricing_date?: string | null, type?: number | null, uom?: string | null, date_range?: { __typename: 'SKMaterialDateRange', bounds?: string | null, lower?: string | null, upper?: string | null } | null } | null, cable_inventory?: { __typename: 'SKCableInventory', available?: string | null, available_count?: number | null, inventory_count?: number | null, reserved?: string | null } | null, inventory?: { __typename: 'SKInventory', available?: string | null, reserved?: string | null } | null } | null> | null } | null };

export type GetSkNwasQueryVariables = Exact<{
  summitQueryString?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetSkNwasQuery = { __typename: 'query_root', getSKNwas?: Array<{ __typename: 'SKNwa', id?: string | null, name?: string | null, al_name?: string | null, display_name?: string | null, active?: boolean | null, deleted?: boolean | null, deprecated?: boolean | null, country?: string | null } | null> | null };

export type GetSkPlanningOrderQueryVariables = Exact<{
  summitQueryString: Scalars['String']['input'];
}>;


export type GetSkPlanningOrderQuery = { __typename: 'query_root', getSKPlanningOrder?: Array<{ __typename: 'SKPlanningOrder', planning_order?: string | null, currency?: string | null, contract?: string | null, natural_work_area?: string | null, nwa_id?: string | null, plant_erp_id?: string | null, plant_name?: string | null, price_list_number?: string | null, price_list_name?: string | null, id?: string | null } | null> | null };

export type SkPlantsQueryVariables = Exact<{
  summitQueryString: Scalars['String']['input'];
}>;


export type SkPlantsQuery = { __typename: 'query_root', getSKPlants?: Array<{ __typename: 'SKPlant', id?: string | null, active?: boolean | null, deleted?: boolean | null, name?: string | null } | null> | null };

export type SkPriceListsQueryVariables = Exact<{
  summitQueryString: Scalars['String']['input'];
}>;


export type SkPriceListsQuery = { __typename: 'query_root', getSKPriceLists?: Array<{ __typename: 'SKPriceList', name?: string | null, number?: string | null, deleted?: boolean | null, active?: boolean | null, id?: string | null } | null> | null };

export type SkQuoteFieldsFragment = { __typename: 'SKQuote', id?: number | null };

export type SkDeleteQuoteFieldsFragment = { __typename: 'SKDeleteQuote', id?: number | null };

export type InsertSkQuoteMutationVariables = Exact<{
  object: SkQuoteInput;
}>;


export type InsertSkQuoteMutation = { __typename: 'mutation_root', createSKQuote?: { __typename: 'SKQuote', id?: number | null } | null };

export type DeleteSkQuoteMutationVariables = Exact<{
  object: SkDeleteQuoteInput;
}>;


export type DeleteSkQuoteMutation = { __typename: 'mutation_root', deleteSKQuote?: { __typename: 'SKDeleteQuote', id?: number | null } | null };

export type UpdateSkQuoteJobMutationVariables = Exact<{
  object: SkQuoteInput;
}>;


export type UpdateSkQuoteJobMutation = { __typename: 'mutation_root', updateSKQuoteJob?: { __typename: 'SKQuote', id?: number | null } | null };

export type SkWellAddressesQueryVariables = Exact<{
  summitQueryString?: InputMaybe<Scalars['String']['input']>;
}>;


export type SkWellAddressesQuery = { __typename: 'query_root', getSKWellAddresses?: Array<{ __typename: 'SKWellAddress', well_address_id?: number | null, address?: { __typename: 'SKAddress', city?: string | null, district?: string | null, full_address?: string | null, id?: string | null, name?: string | null, name1?: string | null, name2?: string | null, name3?: string | null, name4?: string | null, phone_number?: string | null, postal_code?: string | null, street?: string | null, region?: { __typename: 'SKRegion', active?: boolean | null, code?: string | null, deleted?: boolean | null, id?: number | null, name?: string | null, country?: { __typename: 'SKCountry', active?: boolean | null, code?: string | null, deleted?: boolean | null, name?: string | null } | null } | null } | null, customer?: { __typename: 'SKWellAddressCustomer', active?: boolean | null, deleted?: boolean | null, id?: string | null, msa_signed?: boolean | null, name?: string | null, name1?: string | null, name2?: string | null, name3?: string | null, name4?: string | null } | null, well?: { __typename: 'SKWell', active?: boolean | null, deleted?: boolean | null, id?: string | null, latitude?: number | null, longitude?: number | null, name?: string | null, name1?: string | null, name2?: string | null, name3?: string | null, name4?: string | null, region?: number | null, uwi?: string | null, uwi_computed?: string | null, well_type?: string | null, coordinates?: { __typename: 'SKCoordinates', coordinates?: Array<number | null> | null, type?: string | null } | null } | null } | null> | null };

export type StatusFieldsFragment = { __typename: 'status', status?: string | null };

export type StatusSubscriptionVariables = Exact<{
  where?: InputMaybe<Status_Bool_Exp>;
  order_by?: InputMaybe<Array<Status_Order_By>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  distinct_on?: InputMaybe<Array<Status_Select_Column>>;
}>;


export type StatusSubscription = { __typename: 'subscription_root', status: Array<{ __typename: 'status', status?: string | null }> };

export type TubingsTypeFieldsFragment = { __typename: 'tubings_type', value: string, comment?: string | null, id: string };

export type TubingsTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type TubingsTypesQuery = { __typename: 'query_root', tubings_type: Array<{ __typename: 'tubings_type', value: string, comment?: string | null, id: string }> };

export type GetUserEulaAcceptancesQueryVariables = Exact<{
  id?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type GetUserEulaAcceptancesQuery = { __typename: 'query_root', user_eula_acceptance: Array<{ __typename: 'user_eula_acceptance', id: any, eula_id: any }> };

export type AcceptEulaMutationVariables = Exact<{
  eulaId: Scalars['uuid']['input'];
}>;


export type AcceptEulaMutation = { __typename: 'mutation_root', insert_user_eula_acceptance_one?: { __typename: 'user_eula_acceptance', id: any, user_id: string, eula_id: any, signed_at: any } | null };

export type GetAllEulaAcceptancesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllEulaAcceptancesQuery = { __typename: 'query_root', user_eula_acceptance: Array<{ __typename: 'user_eula_acceptance', id: any, signed_at: any, user: { __typename: 'users', id: string, display_name?: string | null, email?: string | null, hal_identifier?: string | null }, eula: { __typename: 'eula', id: any, created_at: any, activated_on?: any | null, activated: boolean } }> };

export type UsersFieldsFragment = { __typename: 'users', id: string, email?: string | null, username?: string | null, display_name?: string | null, hal_identifier?: string | null };

export type UsersQueryVariables = Exact<{
  where?: InputMaybe<Users_Bool_Exp>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
}>;


export type UsersQuery = { __typename: 'query_root', users: Array<{ __typename: 'users', id: string, email?: string | null, username?: string | null, display_name?: string | null, hal_identifier?: string | null }> };

export type WellTestGasInputOptionsFieldsFragment = { __typename: 'well_test_gas_input_options', comment?: string | null, value: string, id: string };

export type WellTestGasInputOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type WellTestGasInputOptionsQuery = { __typename: 'query_root', well_test_gas_input_options: Array<{ __typename: 'well_test_gas_input_options', comment?: string | null, value: string, id: string }> };

export type WellTestLiquidInputOptionsFieldsFragment = { __typename: 'well_test_liquid_input_options', comment?: string | null, value: string, id: string };

export type WellTestLiquidInputOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type WellTestLiquidInputOptionsQuery = { __typename: 'query_root', well_test_liquid_input_options: Array<{ __typename: 'well_test_liquid_input_options', comment?: string | null, value: string, id: string }> };

export type WellTestPressureInputOptionsFieldsFragment = { __typename: 'well_test_pressure_input_options', comment?: string | null, value: string, id: string };

export type WellTestPressureInputOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type WellTestPressureInputOptionsQuery = { __typename: 'query_root', well_test_pressure_input_options: Array<{ __typename: 'well_test_pressure_input_options', comment?: string | null, value: string, id: string }> };

export type WellsFieldsFragment = { __typename: 'wells', id: number, well_name?: string | null, well_uwi?: string | null, well_erp_id?: string | null, address_erp_id?: string | null };

export type WellsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Wells_Bool_Exp>;
  order_by?: InputMaybe<Array<Wells_Order_By>>;
  withAggregate: Scalars['Boolean']['input'];
  withSizings: Scalars['Boolean']['input'];
}>;


export type WellsQuery = { __typename: 'query_root', wells: Array<{ __typename: 'wells', id: number, well_name?: string | null, well_uwi?: string | null, well_erp_id?: string | null, sizings?: Array<{ __typename: 'sizings', id?: any | null, title?: string | null, journal_updated_at?: any | null }> }>, wells_aggregate?: { __typename: 'wells_aggregate', id: 'wells_aggregate', aggregate?: { __typename: 'wells_aggregate_fields', count: number, id: 'wells_aggregate_fields' } | null } };

export type UpsertWellMutationVariables = Exact<{
  object: Wells_Insert_Input;
}>;


export type UpsertWellMutation = { __typename: 'mutation_root', insert_wells_one?: { __typename: 'wells', id: number, well_name?: string | null, well_uwi?: string | null, well_erp_id?: string | null, address_erp_id?: string | null } | null };

export const CasingsTypeFieldsFragmentDoc = gql`
    fragment CasingsTypeFields on casings_type {
  id: value
  value
  comment
}
    `;
export const TubingFlowOptionsFieldsFragmentDoc = gql`
    fragment TubingFlowOptionsFields on tubing_flow_options {
  id: value
  comment
  value
}
    `;
export const CasingFlowOptionsFieldsFragmentDoc = gql`
    fragment CasingFlowOptionsFields on casing_flow_options {
  id: value
  comment
  value
}
    `;
export const BubblePointOptionsFieldsFragmentDoc = gql`
    fragment BubblePointOptionsFields on bubble_point_options {
  id: value
  comment
  value
}
    `;
export const WaterVolumeFactorOptionsFieldsFragmentDoc = gql`
    fragment WaterVolumeFactorOptionsFields on water_volume_factor_options {
  id: value
  comment
  value
}
    `;
export const SolutionGasOilRatioOptionsFieldsFragmentDoc = gql`
    fragment SolutionGasOilRatioOptionsFields on solution_gas_oil_ratio_options {
  id: value
  comment
  value
}
    `;
export const GasCompressibilityOptionsFieldsFragmentDoc = gql`
    fragment GasCompressibilityOptionsFields on gas_compressibility_options {
  id: value
  comment
  value
}
    `;
export const WellGasTypeOptionsFieldsFragmentDoc = gql`
    fragment WellGasTypeOptionsFields on well_gas_type_options {
  id: value
  comment
  value
}
    `;
export const OilVolumeFactorOptionsFieldsFragmentDoc = gql`
    fragment OilVolumeFactorOptionsFields on oil_volume_factor_options {
  id: value
  comment
  value
}
    `;
export const OilDensityOptionsFieldsFragmentDoc = gql`
    fragment OilDensityOptionsFields on oil_density_options {
  id: value
  comment
  value
}
    `;
export const DeadOilOptionsFieldsFragmentDoc = gql`
    fragment DeadOilOptionsFields on dead_oil_options {
  id: value
  comment
  value
}
    `;
export const WaterViscosityOptionsFieldsFragmentDoc = gql`
    fragment WaterViscosityOptionsFields on water_viscosity_options {
  id: value
  comment
  value
}
    `;
export const SaturatedOilOptionsFieldsFragmentDoc = gql`
    fragment SaturatedOilOptionsFields on saturated_oil_options {
  id: value
  comment
  value
}
    `;
export const GasViscosityOptionsFieldsFragmentDoc = gql`
    fragment GasViscosityOptionsFields on gas_viscosity_options {
  id: value
  comment
  value
}
    `;
export const UnderSaturatedOilOptionsFieldsFragmentDoc = gql`
    fragment UnderSaturatedOilOptionsFields on under_saturated_oil_options {
  id: value
  comment
  value
}
    `;
export const FrictionLossOptionsFieldsFragmentDoc = gql`
    fragment FrictionLossOptionsFields on friction_loss_options {
  id: value
  comment
  value
}
    `;
export const WaterDensityOptionsFieldsFragmentDoc = gql`
    fragment WaterDensityOptionsFields on water_density_options {
  id: value
  comment
  value
}
    `;
export const WaterSolutionGasOptionsFieldsFragmentDoc = gql`
    fragment WaterSolutionGasOptionsFields on water_solution_gas_options {
  id: value
  comment
  value
}
    `;
export const NaturalGasSeparationOptionsFieldsFragmentDoc = gql`
    fragment NaturalGasSeparationOptionsFields on natural_gas_separation_options {
  id: value
  value
  comment
}
    `;
export const DeviationSurveyDirectionalDataSetBaseFieldsFragmentDoc = gql`
    fragment DeviationSurveyDirectionalDataSetBaseFields on deviation_survey_directional_dataset {
  value
  comment
}
    `;
export const DeviationSurveyBaseFieldsFragmentDoc = gql`
    fragment DeviationSurveyBaseFields on deviation_survey {
  __typename
  id
  created_at
  updated_at
  deleted_at
  title
  directional_data_set
  imported_sizing_id
  entry_rows
}
    `;
export const DisplayUnitsFieldsFragmentDoc = gql`
    fragment DisplayUnitsFields on display_units {
  id: value
  comment
  value
}
    `;
export const BoltOnDischargesBaseFieldsFragmentDoc = gql`
    fragment BoltOnDischargesBaseFields on bolt_on_discharges {
  __typename
  id
  manufacturer
  series_model
  is_hps
  outer_diameter_inches
  inner_diameter_inches
  flange_outer_diameter_inches
  neck_outer_diameter_inches
  neck_inner_diameter_inches
  length_inches
  weight_pounds
  tubing_diameter_inches
  include_koc_timestamp
  only_koc_timestamp
  include_ecopetrol_timestamp
  only_ecopetrol_timestamp
}
    `;
export const BoltOnDischargesAllFieldsFragmentDoc = gql`
    fragment BoltOnDischargesAllFields on bolt_on_discharges {
  __typename
  id
  author_id
  created_at
  updated_at
  deleted_at
  manufacturer
  series_model
  is_hps
  outer_diameter_inches
  inner_diameter_inches
  flange_outer_diameter_inches
  neck_outer_diameter_inches
  neck_inner_diameter_inches
  length_inches
  weight_pounds
  tubing_diameter_inches
  include_koc_timestamp
  only_koc_timestamp
  include_ecopetrol_timestamp
  only_ecopetrol_timestamp
}
    `;
export const BoltOnDischargesInsertFieldsFragmentDoc = gql`
    fragment BoltOnDischargesInsertFields on bolt_on_discharges {
  id
  created_at
  updated_at
  manufacturer
  series_model
  is_hps
  outer_diameter_inches
  inner_diameter_inches
  flange_outer_diameter_inches
  neck_outer_diameter_inches
  neck_inner_diameter_inches
  length_inches
  weight_pounds
  tubing_diameter_inches
  include_koc_timestamp
  only_koc_timestamp
  include_ecopetrol_timestamp
  only_ecopetrol_timestamp
}
    `;
export const CasingsBaseFieldsFragmentDoc = gql`
    fragment CasingsBaseFields on casings {
  __typename
  id
  casing_type
  imperial_name
  metric_name
  outer_diameter_inches
  interior_diameter_inches
  drift_inches
  coupling_outer_diameter_inches
  pound_per_foot
  include_koc_timestamp
  only_koc_timestamp
  include_ecopetrol_timestamp
  only_ecopetrol_timestamp
}
    `;
export const CasingsMetaFieldsFragmentDoc = gql`
    fragment CasingsMetaFields on casings {
  id
  author_id
  created_at
  updated_at
  deleted_at
  imported_sizing_id
}
    `;
export const CasingsAllFieldsFragmentDoc = gql`
    fragment CasingsAllFields on casings {
  ...CasingsBaseFields
  ...CasingsMetaFields
}
    ${CasingsBaseFieldsFragmentDoc}
${CasingsMetaFieldsFragmentDoc}`;
export const HousingBaseFieldsFragmentDoc = gql`
    fragment HousingBaseFields on housings {
  __typename
  id
  housing_number
  stage_count
  length_inches
  weight_pounds
  include_koc_timestamp
  only_koc_timestamp
  include_ecopetrol_timestamp
  only_ecopetrol_timestamp
}
    `;
export const HousingsMetaFieldsFragmentDoc = gql`
    fragment HousingsMetaFields on housings {
  id
  author_id
  created_at
  updated_at
  deleted_at
  imported_sizing_id
  pump_id
}
    `;
export const HousingsAllFieldsFragmentDoc = gql`
    fragment HousingsAllFields on housings {
  ...HousingBaseFields
  ...HousingsMetaFields
}
    ${HousingBaseFieldsFragmentDoc}
${HousingsMetaFieldsFragmentDoc}`;
export const HpsBoltOnDischargesBaseFieldsFragmentDoc = gql`
    fragment HpsBoltOnDischargesBaseFields on bolt_on_discharges {
  __typename
  id
  manufacturer
  series_model
  is_hps
  outer_diameter_inches
  inner_diameter_inches
  flange_outer_diameter_inches
  neck_outer_diameter_inches
  neck_inner_diameter_inches
  length_inches
  weight_pounds
  tubing_diameter_inches
  include_koc_timestamp
  only_koc_timestamp
  include_ecopetrol_timestamp
  only_ecopetrol_timestamp
}
    `;
export const HpsBoltOnDischargesAllFieldsFragmentDoc = gql`
    fragment HpsBoltOnDischargesAllFields on bolt_on_discharges {
  __typename
  id
  author_id
  created_at
  updated_at
  deleted_at
  manufacturer
  series_model
  is_hps
  outer_diameter_inches
  inner_diameter_inches
  flange_outer_diameter_inches
  neck_outer_diameter_inches
  neck_inner_diameter_inches
  length_inches
  weight_pounds
  tubing_diameter_inches
  include_koc_timestamp
  only_koc_timestamp
  include_ecopetrol_timestamp
  only_ecopetrol_timestamp
}
    `;
export const HpsBoltOnDischargesInsertFieldsFragmentDoc = gql`
    fragment HpsBoltOnDischargesInsertFields on bolt_on_discharges {
  id
  created_at
  updated_at
  manufacturer
  series_model
  is_hps
  outer_diameter_inches
  inner_diameter_inches
  flange_outer_diameter_inches
  neck_outer_diameter_inches
  neck_inner_diameter_inches
  length_inches
  weight_pounds
  tubing_diameter_inches
  include_koc_timestamp
  only_koc_timestamp
  include_ecopetrol_timestamp
  only_ecopetrol_timestamp
}
    `;
export const HpsMotorsBaseFieldsFragmentDoc = gql`
    fragment HpsMotorsBaseFields on motors {
  __typename
  id
  length_inches
  manufacturer
  nameplate_current
  nameplate_horsepower
  nameplate_voltage
  part_number
  shaft_horsepower
  weight_pounds
  include_koc_timestamp
  only_koc_timestamp
  include_ecopetrol_timestamp
  only_ecopetrol_timestamp
  allow_rerate
  inner_diameter_inches
  outer_diameter_inches
  neck_inner_diameter_inches
  neck_outer_diameter_inches
  is_hps
}
    `;
export const HpsMotorsAllFieldsFragmentDoc = gql`
    fragment HpsMotorsAllFields on motors {
  __typename
  id
  author_id
  allow_rerate
  configuration
  created_at
  deleted_at
  eff1
  eff2
  eff3
  eff4
  eff5
  effb
  i1
  i2
  i3
  i4
  i5
  ib
  imported_sizing_id
  length_inches
  manufacturer
  n1
  n2
  n3
  n4
  n5
  nameplate_current
  nameplate_horsepower
  nameplate_voltage
  nb
  oil_volume_gallons
  part_number
  pf1
  pf2
  pf3
  pf4
  pf5
  pfb
  rr_l1
  rr_l2
  rr_lb
  rr_v3
  rr_v2
  rr_v1
  rr_vb
  shaft_horsepower
  nv0
  nv1
  nv2
  iv0
  iv1
  iv2
  pfv0
  pfv1
  pfv2
  effv0
  effv1
  effv2
  tv0
  tv1
  tv2
  shaft_height_inches
  temperature_rating_fahrenheit
  updated_at
  weight_pounds
  include_koc_timestamp
  only_koc_timestamp
  include_ecopetrol_timestamp
  only_ecopetrol_timestamp
  poles
  stator_inner_diameter_inches
  stator_outer_diameter_inches
  k3
  nameplate_rerate_ratio
  inner_diameter_inches
  outer_diameter_inches
  neck_inner_diameter_inches
  neck_outer_diameter_inches
  mle_offset_depth_inches
  outer_diameter_rub_inches
  is_hps
}
    `;
export const HpsMotorsInsertFieldsFragmentDoc = gql`
    fragment HpsMotorsInsertFields on motors {
  id
  allow_rerate
  created_at
  updated_at
  manufacturer
  part_number
  outer_diameter_inches
  length_inches
  weight_pounds
  nameplate_horsepower
  nameplate_voltage
  nameplate_current
  shaft_horsepower
  temperature_rating_fahrenheit
  eff1
  eff2
  eff3
  eff4
  eff5
  effb
  i1
  i2
  i3
  i4
  i5
  ib
  n1
  n2
  n3
  n4
  n5
  nb
  pf1
  pf2
  pf3
  pf4
  pf5
  pfb
  rr_l1
  rr_l2
  rr_lb
  rr_v3
  rr_v2
  rr_v1
  rr_vb
  shaft_height_inches
  nv0
  nv1
  nv2
  iv0
  iv1
  iv2
  pfv0
  pfv1
  pfv2
  effv0
  effv1
  effv2
  tv0
  tv1
  tv2
  include_koc_timestamp
  only_koc_timestamp
  include_ecopetrol_timestamp
  only_ecopetrol_timestamp
  poles
  stator_inner_diameter_inches
  stator_outer_diameter_inches
  k3
  nameplate_rerate_ratio
  inner_diameter_inches
  outer_diameter_inches
  neck_inner_diameter_inches
  neck_outer_diameter_inches
  mle_offset_depth_inches
  outer_diameter_rub_inches
  is_hps
}
    `;
export const MotorsBaseFieldsFragmentDoc = gql`
    fragment MotorsBaseFields on motors {
  __typename
  id
  length_inches
  manufacturer
  nameplate_current
  nameplate_horsepower
  nameplate_voltage
  part_number
  shaft_horsepower
  weight_pounds
  include_koc_timestamp
  only_koc_timestamp
  include_ecopetrol_timestamp
  only_ecopetrol_timestamp
  allow_rerate
  inner_diameter_inches
  outer_diameter_inches
  neck_inner_diameter_inches
  neck_outer_diameter_inches
  is_hps
}
    `;
export const MotorsInsertFieldsFragmentDoc = gql`
    fragment MotorsInsertFields on motors {
  id
  allow_rerate
  created_at
  updated_at
  manufacturer
  part_number
  outer_diameter_inches
  length_inches
  weight_pounds
  nameplate_horsepower
  nameplate_voltage
  nameplate_current
  shaft_horsepower
  temperature_rating_fahrenheit
  eff1
  eff2
  eff3
  eff4
  eff5
  effb
  i1
  i2
  i3
  i4
  i5
  ib
  n1
  n2
  n3
  n4
  n5
  nb
  pf1
  pf2
  pf3
  pf4
  pf5
  pfb
  rr_l1
  rr_l2
  rr_lb
  rr_v3
  rr_v2
  rr_v1
  rr_vb
  include_koc_timestamp
  only_koc_timestamp
  include_ecopetrol_timestamp
  only_ecopetrol_timestamp
  poles
  stator_inner_diameter_inches
  stator_outer_diameter_inches
  k3
  nameplate_rerate_ratio
  inner_diameter_inches
  outer_diameter_inches
  neck_inner_diameter_inches
  neck_outer_diameter_inches
  mle_offset_depth_inches
  outer_diameter_rub_inches
  is_hps
  nv0
  nv1
  nv2
  iv0
  iv1
  iv2
  pfv0
  pfv1
  pfv2
  effv0
  effv1
  effv2
  tv0
  tv1
  tv2
}
    `;
export const PumpsBaseFieldsFragmentDoc = gql`
    fragment PumpsBaseFields on pumps {
  __typename
  id
  manufacturer
  series_model
  rotation
  part_number
  compression_thrust_per_stage
  shaft_diameter_inches
  max_bolt_load_pounds
  is_compression_pump
  housing_inner_diameter_inches
  housing_outer_diameter_inches
  neck_inner_diameter_inches
  neck_outer_diameter_inches
}
    `;
export const PumpsInsertFieldsFragmentDoc = gql`
    fragment PumpsInsertFields on pumps {
  id
  author_id
  created_at
  updated_at
  deleted_at
  imported_sizing_id
  manufacturer
  rotation
  part_number
  compression_thrust_per_stage
  series_model
  stage_type
  shaft_diameter_inches
  standard_housing_pressure_rating_psi
  high_strength_housing_pressure_rating_psi
  standard_shaft_rating_hp
  high_strength_shaft_rating_hp
  construction
  min_rate_standard_pump_bpd
  bep_rate_standard_pump_bpd
  max_rate_standard_pump_bpd
  max_graph_rate_standard_pump_bpd
  hb
  h1
  h2
  h3
  h4
  h5
  bhpb
  bhp1
  bhp2
  bhp3
  bhp4
  bhp5
  npsh1
  npsh2
  npsh3
  npsh4
  include_koc_timestamp
  only_koc_timestamp
  include_ecopetrol_timestamp
  only_ecopetrol_timestamp
  is_compression_pump
  housing_inner_diameter_inches
  housing_outer_diameter_inches
  neck_inner_diameter_inches
  neck_outer_diameter_inches
}
    `;
export const SealMotorOilAllFieldsFragmentDoc = gql`
    fragment SealMotorOilAllFields on seal_motor_oil {
  __typename
  created_at
  updated_at
  deleted_at
  id
  name
  thermal_expansion_factor
  max_temp_fahrenheit
  mf_test_temp1_celsius
  mf_test_temp2_celsius
  viscosity_test1_centistroke
  viscosity_test2_centistroke
  specific_gravity
  include_koc_timestamp
  only_koc_timestamp
  include_ecopetrol_timestamp
  only_ecopetrol_timestamp
}
    `;
export const SealsBaseFieldsFragmentDoc = gql`
    fragment SealsBaseFields on seals {
  id
  manufacturer
  part_number
  configuration
  length_inches
  weight_pounds
  include_koc_timestamp
  only_koc_timestamp
  include_ecopetrol_timestamp
  only_ecopetrol_timestamp
  inner_diameter_inches
  outer_diameter_inches
  neck_inner_diameter_inches
  neck_outer_diameter_inches
  thrust_collar_inner_diameter_inches
  thrust_collar_outer_diameter_inches
}
    `;
export const SensorsBaseFieldsFragmentDoc = gql`
    fragment SensorsBaseFields on sensors {
  __typename
  id
  manufacturer
  part_number
  model
  length_inches
  weight_pounds
  inner_diameter_inches
  outer_diameter_inches
  neck_inner_diameter_inches
  neck_outer_diameter_inches
}
    `;
export const SensorsInsertFieldsFragmentDoc = gql`
    fragment SensorsInsertFields on sensors {
  id
  created_at
  updated_at
  manufacturer
  part_number
  length_inches
  weight_pounds
  model
  channels
  max_intake_temperature_fahrenheit
  max_intake_pressure_psi
  housing_material
  include_koc_timestamp
  only_koc_timestamp
  include_ecopetrol_timestamp
  only_ecopetrol_timestamp
  inner_diameter_inches
  outer_diameter_inches
  neck_inner_diameter_inches
  neck_outer_diameter_inches
}
    `;
export const StepDownTransformersBaseFieldsFragmentDoc = gql`
    fragment StepDownTransformersBaseFields on step_down_transformers {
  __typename
  id
  manufacturer
  part_number
  transformer_type
  weight_pounds
  primary_voltage_delta
  primary_voltage_wye
  min_secondary_voltage
  max_secondary_voltage
  include_koc_timestamp
  only_koc_timestamp
  include_ecopetrol_timestamp
  only_ecopetrol_timestamp
}
    `;
export const StepUpTransformersBaseFieldsFragmentDoc = gql`
    fragment StepUpTransformersBaseFields on step_up_transformers {
  __typename
  id
  manufacturer
  part_number
  transformer_type
  weight_pounds
  primary_voltage
  min_secondary_voltage
  max_secondary_voltage
  include_koc_timestamp
  include_ecopetrol_timestamp
  only_ecopetrol_timestamp
  only_koc_timestamp
}
    `;
export const SwitchboardsBaseFieldsFragmentDoc = gql`
    fragment SwitchboardsBaseFields on switchboards {
  __typename
  id
  amps
  enclosure
  kv
  manufacturer
  part_number
  include_koc_timestamp
  only_koc_timestamp
  include_ecopetrol_timestamp
  only_ecopetrol_timestamp
}
    `;
export const TubingsBaseFieldsFragmentDoc = gql`
    fragment TubingsBaseFields on tubings {
  __typename
  id
  coupling_outer_diameter_inches
  drift_inches
  imperial_name
  interior_diameter_inches
  metric_name
  outer_diameter_inches
  pound_per_foot
  include_koc_timestamp
  only_koc_timestamp
  include_ecopetrol_timestamp
  only_ecopetrol_timestamp
  tubing_type
}
    `;
export const TubingsAllFieldsFragmentDoc = gql`
    fragment TubingsAllFields on tubings {
  __typename
  id
  author_id
  coupling_outer_diameter_inches
  created_at
  deleted_at
  drift_inches
  imperial_name
  imported_sizing_id
  interior_diameter_inches
  metric_name
  outer_diameter_inches
  pound_per_foot
  tubing_type
  updated_at
  include_koc_timestamp
  only_koc_timestamp
  include_ecopetrol_timestamp
  only_ecopetrol_timestamp
}
    `;
export const VsdBaseFieldsFragmentDoc = gql`
    fragment VsdBaseFields on variable_speed_drives {
  __typename
  id
  manufacturer
  part_number
  vsd_type
  max_amps
  kva
  include_koc_timestamp
  only_koc_timestamp
  include_ecopetrol_timestamp
  only_ecopetrol_timestamp
}
    `;
export const YToolBaseFieldsFragmentDoc = gql`
    fragment YToolBaseFields on y_tools {
  __typename
  id
  minimum_inches
  maximum_inches
  length_inches
  width_inches
  series_model
  outer_diameter_inches
  teleswivel_stroke_length_inches
  pressure_rating_psi
  temperature_rating_fahrenheit
  handling_sub_connection_inches
  bypass_connection_inches
  material_type
  weight_pounds
  include_koc_timestamp
  only_koc_timestamp
  include_ecopetrol_timestamp
  only_ecopetrol_timestamp
  manufacturer
}
    `;
export const YToolAllFieldsFragmentDoc = gql`
    fragment YToolAllFields on y_tools {
  __typename
  id
  author_id
  created_at
  deleted_at
  updated_at
  include_koc_timestamp
  only_koc_timestamp
  include_ecopetrol_timestamp
  only_ecopetrol_timestamp
  minimum_inches
  maximum_inches
  length_inches
  width_inches
  series_model
  outer_diameter_inches
  teleswivel_stroke_length_inches
  pressure_rating_psi
  temperature_rating_fahrenheit
  handling_sub_connection_inches
  bypass_connection_inches
  material_type
  weight_pounds
  manufacturer
}
    `;
export const ErpWellReadingsFragmentFragmentDoc = gql`
    fragment ErpWellReadingsFragment on ErpWellReadings {
  id
  reading_date
  motor_current
  motor_frequency
  pump_intake_pressure
  fluid_temperature
  tubing_pressure
  casing_pressure
  produced_oil_rate
  produced_gas_rate
  produced_water_rate
}
    `;
export const EulaFieldsFragmentDoc = gql`
    fragment EulaFields on eula {
  id
  activated
  activated_on
  updated_at
  created_at
  license
  version
}
    `;
export const FlowModelFieldsFragmentDoc = gql`
    fragment FlowModelFields on flow_model_active {
  id: value
  comment
  value
}
    `;
export const HpsLiquidTypeFieldsFragmentDoc = gql`
    fragment HpsLiquidTypeFields on hps_liquid_type {
  id: value
  comment
  value
}
    `;
export const PerformanceEvaluationBaseFieldsFragmentDoc = gql`
    fragment PerformanceEvaluationBaseFields on performance_evaluations {
  __typename
  id
  title
  pump_hz
  water_rate_std_barrel_day
  gas_rate_mscf_day
  oil_rate_std_barrel_day
  tubing_pressure_psia
  casing_pressure_psia
  pump_intake_pressure_psia
  pump_wear_head_correction_ratio
  pump_wear_brake_horsepower_correction_ratio
  intake_override_gas_separation_percent
  intake_gas_separation_override_type
  natural_override_gas_separation_percent
  natural_gas_separation_override_type
}
    `;
export const PerformanceEvaluationMetaFieldsFragmentDoc = gql`
    fragment PerformanceEvaluationMetaFields on performance_evaluations {
  journal_author_id
  journal_created_at
  journal_deleted_at
  journal_updated_at
  winning_revision_id
  scenario_id
  parent_id
}
    `;
export const PerformanceEvaluationAllFieldsFragmentDoc = gql`
    fragment PerformanceEvaluationAllFields on performance_evaluations {
  ...PerformanceEvaluationBaseFields
  ...PerformanceEvaluationMetaFields
}
    ${PerformanceEvaluationBaseFieldsFragmentDoc}
${PerformanceEvaluationMetaFieldsFragmentDoc}`;
export const PerformanceEvaluationXrefPumpFieldsFragmentDoc = gql`
    fragment PerformanceEvaluationXrefPumpFields on performance_evaluations_xref_pumps {
  __typename
  id
  journal_author_id
  journal_created_at
  journal_deleted_at
  journal_updated_at
  winning_revision_id
  xref_pump_id
  performance_evaluation_id
  rate_correction_ratio
  head_correction_ratio
  brake_horsepower_correction_ratio
}
    `;
export const PerformanceEvaluationPumpsFieldsFragmentDoc = gql`
    fragment PerformanceEvaluationPumpsFields on performance_evaluations_xref_pumps {
  __typename
  id
  xref_pump_id
  performance_evaluation_id
  rate_correction_ratio
  head_correction_ratio
  brake_horsepower_correction_ratio
  parent_id
  journal_author_id
  journal_created_at
  journal_updated_at
  journal_deleted_at
  winning_revision_id
  winning_revision_parent_id
  winning_revision_author_id
  winning_revision_created_at
  winning_revision_updated_at
  winning_revision_deleted_at
}
    `;
export const QuoteLineItemCategoryDatasetFieldsFragmentDoc = gql`
    fragment QuoteLineItemCategoryDatasetFields on quote_line_item_category_dataset {
  id: value
  comment
  value
}
    `;
export const QuoteLineItemSubcategoryDatasetFieldsFragmentDoc = gql`
    fragment QuoteLineItemSubcategoryDatasetFields on quote_line_item_subcategory_dataset {
  id: value
  comment
  value
}
    `;
export const QuoteLineItemTypeDatasetFieldsFragmentDoc = gql`
    fragment QuoteLineItemTypeDatasetFields on quote_line_item_type_dataset {
  id: value
  comment
  value
}
    `;
export const QuoteSkJobTypeDatasetFieldsFragmentDoc = gql`
    fragment QuoteSkJobTypeDatasetFields on quote_sk_job_type_dataset {
  id: value
  comment
  value
}
    `;
export const QuoteStatusDatasetFieldsFragmentDoc = gql`
    fragment QuoteStatusDatasetFields on quote_status_dataset {
  id: value
  comment
  value
}
    `;
export const QuoteUserMessagesFieldsFragmentDoc = gql`
    fragment QuoteUserMessagesFields on quote_user_messages {
  author_id
  created_at
  deleted_at
  id
  message
  title
  updated_at
  created_by {
    username
    display_name
    email
    hal_identifier
    id
  }
}
    `;
export const QuoteFieldsFragmentDoc = gql`
    fragment QuoteFields on quotes {
  comments
  created_at
  currency
  customer_rep_name
  customer_rep_email
  customer_rep_phone_number
  deleted_at
  directions
  erp_contract_number
  erp_customer_name
  erp_customer_number
  erp_nwa_id
  erp_nwa_name
  erp_plant_id
  erp_plant_name
  erp_price_list_name
  erp_price_list_number
  erp_well_country
  erp_well_id
  erp_well_name
  erp_well_uwi
  erp_well_region
  erp_address_id
  erp_address_name
  erp_full_address
  id
  name
  note
  prepared_by_id
  pricing_date
  proposed_start_date
  sk_job_id
  sk_job_number
  sk_job_type
  sk_planning_order
  sk_proposal_number
  source
  spyglass_scenario_id
  spyglass_scenario_import_json
  status
  updated_at
  version_number
  error_log_json
  quote_line_items(
    where: {deleted_at: {_is_null: true}}
    order_by: {sub_order: asc}
  ) {
    category
    created_at
    credit
    erp_material_long_description
    erp_material_number
    erp_material_short_description
    erp_price
    erp_serialized
    price_override
    erp_product_hierarchy
    erp_uom
    id
    line_item_type
    margin
    note
    parent_order
    pricing_date
    quantity
    source
    subcategory
    sub_order
    tax_type
    updated_at
    spyglass_equipment_import_json
    cable {
      id
    }
    intake {
      id
    }
    motor {
      id
    }
    motor_lead_extension {
      id
    }
    pump {
      id
    }
    seal {
      id
    }
    sensor {
      id
    }
    step_down_transformer {
      id
    }
    step_up_transformer {
      id
    }
    switchboard {
      id
    }
    variable_speed_drive {
      id
    }
  }
}
    `;
export const QuoteParentFieldsFragmentDoc = gql`
    fragment QuoteParentFields on quotes {
  id
  name
  version_number
}
    `;
export const CablesBaseFieldsFragmentDoc = gql`
    fragment CablesBaseFields on cables {
  __typename
  id
  amp_factor
  armor
  construction
  depth_inches
  family
  gauge
  kv
  manufacturer
  max_temperature_fahrenheit
  part_number
  pound_per_foot
  width_inches
  impedance_60_hz_per_1000_ft
  resistance_per_1000_ft
  include_koc_timestamp
  only_koc_timestamp
  include_ecopetrol_timestamp
  only_ecopetrol_timestamp
}
    `;
export const CablesMetaFieldsFragmentDoc = gql`
    fragment CablesMetaFields on cables {
  id
  author_id
  created_at
  deleted_at
  imported_sizing_id
  updated_at
}
    `;
export const CablesAllFieldsFragmentDoc = gql`
    fragment CablesAllFields on cables {
  ...CablesBaseFields
  ...CablesMetaFields
}
    ${CablesBaseFieldsFragmentDoc}
${CablesMetaFieldsFragmentDoc}`;
export const IntakesBaseFieldsFragmentDoc = gql`
    fragment IntakesBaseFields on intakes {
  id
  manufacturer
  intake_type
  part_number
  configuration
  length_inches
  weight_pounds
  shaft_material
  shaft_limit_hp
  housing_material
  max_rate_bpd
  configuration
  hp
  eff1
  eff2
  include_koc_timestamp
  only_koc_timestamp
  include_ecopetrol_timestamp
  only_ecopetrol_timestamp
  high_strength_shaft_limit_hp
  stage_count
  bhp0
  bhp1
  bhp2
  bhp3
  bhp4
  bhp5
  bolt_on
  port_area_square_inches
  inner_diameter_inches
  outer_diameter_inches
  neck_inner_diameter_inches
  neck_outer_diameter_inches
  is_hps
}
    `;
export const IntakesMetaFieldsFragmentDoc = gql`
    fragment IntakesMetaFields on intakes {
  __typename
  id
  author_id
  created_at
  updated_at
  deleted_at
  imported_sizing_id
}
    `;
export const IntakesAllFieldsFragmentDoc = gql`
    fragment IntakesAllFields on intakes {
  ...IntakesBaseFields
  ...IntakesMetaFields
}
    ${IntakesBaseFieldsFragmentDoc}
${IntakesMetaFieldsFragmentDoc}`;
export const MotorsAllFieldsFragmentDoc = gql`
    fragment MotorsAllFields on motors {
  __typename
  id
  author_id
  allow_rerate
  configuration
  created_at
  deleted_at
  eff1
  eff2
  eff3
  eff4
  eff5
  effb
  i1
  i2
  i3
  i4
  i5
  ib
  imported_sizing_id
  length_inches
  manufacturer
  n1
  n2
  n3
  n4
  n5
  nameplate_current
  nameplate_horsepower
  nameplate_voltage
  nb
  oil_volume_gallons
  part_number
  pf1
  pf2
  pf3
  pf4
  pf5
  pfb
  rr_l1
  rr_l2
  rr_lb
  rr_v3
  rr_v2
  rr_v1
  rr_vb
  shaft_horsepower
  nv0
  nv1
  nv2
  iv0
  iv1
  iv2
  pfv0
  pfv1
  pfv2
  effv0
  effv1
  effv2
  tv0
  tv1
  tv2
  temperature_rating_fahrenheit
  updated_at
  weight_pounds
  include_koc_timestamp
  only_koc_timestamp
  include_ecopetrol_timestamp
  only_ecopetrol_timestamp
  poles
  stator_inner_diameter_inches
  stator_outer_diameter_inches
  k3
  nameplate_rerate_ratio
  inner_diameter_inches
  outer_diameter_inches
  neck_inner_diameter_inches
  neck_outer_diameter_inches
  mle_offset_depth_inches
  outer_diameter_rub_inches
  is_hps
}
    `;
export const MleBaseFieldsFragmentDoc = gql`
    fragment MleBaseFields on motor_lead_extensions {
  __typename
  id
  manufacturer
  part_number
  series
  family
  gauge
  kv
  max_pothead_temperature_fahrenheit
  max_temperature_fahrenheit
  resistance_per_1000_ft
  impedance_60_hz_per_1000_ft
  amp_factor
  width_inches
  depth_inches
  pound_per_foot
  length_feet
  include_koc_timestamp
  only_koc_timestamp
  include_ecopetrol_timestamp
  only_ecopetrol_timestamp
}
    `;
export const MleMetaFieldsFragmentDoc = gql`
    fragment MleMetaFields on motor_lead_extensions {
  id
  author_id
  created_at
  updated_at
  deleted_at
  imported_sizing_id
}
    `;
export const MleAllFieldsFragmentDoc = gql`
    fragment MleAllFields on motor_lead_extensions {
  ...MleBaseFields
  ...MleMetaFields
}
    ${MleBaseFieldsFragmentDoc}
${MleMetaFieldsFragmentDoc}`;
export const PumpsAllFieldsFragmentDoc = gql`
    fragment PumpsAllFields on pumps {
  id
  author_id
  created_at
  updated_at
  deleted_at
  imported_sizing_id
  manufacturer
  rotation
  part_number
  compression_thrust_per_stage
  series_model
  stage_type
  shaft_diameter_inches
  standard_housing_pressure_rating_psi
  high_strength_housing_pressure_rating_psi
  standard_shaft_rating_hp
  high_strength_shaft_rating_hp
  construction
  min_rate_standard_pump_bpd
  bep_rate_standard_pump_bpd
  max_rate_standard_pump_bpd
  max_graph_rate_standard_pump_bpd
  hb
  h1
  h2
  h3
  h4
  h5
  bhpb
  bhp1
  bhp2
  bhp3
  bhp4
  bhp5
  npsh1
  npsh2
  npsh3
  npsh4
  include_koc_timestamp
  only_koc_timestamp
  include_ecopetrol_timestamp
  only_ecopetrol_timestamp
  max_bolt_load_pounds
  is_compression_pump
  housing_inner_diameter_inches
  housing_outer_diameter_inches
  neck_inner_diameter_inches
  neck_outer_diameter_inches
}
    `;
export const SealsAllFieldsFragmentDoc = gql`
    fragment SealsAllFields on seals {
  __typename
  id
  author_id
  created_at
  updated_at
  deleted_at
  imported_sizing_id
  manufacturer
  part_number
  length_inches
  weight_pounds
  configuration
  max_temperature_fahrenheit
  standard_shaft_limit_hp
  high_strength_shaft_limit_hp
  standard_bearing_rating_pounds
  high_strength_bearing_rating_pounds
  housing_material
  bearing_type
  total_seal_volume_gallons
  volume_for_bag_expansion_lower_tandem_gallons
  volume_for_bag_expansion_upper_tandem_gallons
  upper_chamber_pull_volume_gallons
  bag_chambers
  bag_capacity_gallons
  string_load_pounds
  load_cb_pounds
  load_c1_pounds
  hps_thrust_chamber
  load_test_temperature_fahrenheit
  description
  include_koc_timestamp
  only_koc_timestamp
  include_ecopetrol_timestamp
  only_ecopetrol_timestamp
  inner_diameter_inches
  outer_diameter_inches
  neck_inner_diameter_inches
  neck_outer_diameter_inches
  thrust_collar_inner_diameter_inches
  thrust_collar_outer_diameter_inches
}
    `;
export const SensorsAllFieldsFragmentDoc = gql`
    fragment SensorsAllFields on sensors {
  id
  author_id
  created_at
  updated_at
  deleted_at
  imported_sizing_id
  manufacturer
  part_number
  length_inches
  weight_pounds
  model
  channels
  max_intake_temperature_fahrenheit
  max_intake_pressure_psi
  housing_material
  include_koc_timestamp
  only_koc_timestamp
  include_ecopetrol_timestamp
  only_ecopetrol_timestamp
  inner_diameter_inches
  outer_diameter_inches
  neck_inner_diameter_inches
  neck_outer_diameter_inches
}
    `;
export const DownTransAllFieldsFragmentDoc = gql`
    fragment DownTransAllFields on step_down_transformers {
  __typename
  id
  author_id
  created_at
  updated_at
  deleted_at
  imported_sizing_id
  manufacturer
  part_number
  transformer_type
  primary_voltage_delta
  primary_voltage_wye
  min_secondary_voltage
  max_secondary_voltage
  weight_pounds
  enclosure
  kva
  include_koc_timestamp
  only_koc_timestamp
  include_ecopetrol_timestamp
  only_ecopetrol_timestamp
}
    `;
export const UpTransAllFieldsFragmentDoc = gql`
    fragment UpTransAllFields on step_up_transformers {
  __typename
  id
  author_id
  created_at
  updated_at
  deleted_at
  imported_sizing_id
  manufacturer
  part_number
  transformer_type
  primary_voltage
  min_secondary_voltage
  max_secondary_voltage
  weight_pounds
  enclosure
  kva
  include_koc_timestamp
  only_koc_timestamp
  include_ecopetrol_timestamp
  only_ecopetrol_timestamp
}
    `;
export const SwitchboardsAllFieldsFragmentDoc = gql`
    fragment SwitchboardsAllFields on switchboards {
  __typename
  id
  author_id
  created_at
  updated_at
  deleted_at
  imported_sizing_id
  amps
  enclosure
  kv
  manufacturer
  part_number
  include_koc_timestamp
  only_koc_timestamp
  include_ecopetrol_timestamp
  only_ecopetrol_timestamp
}
    `;
export const VsdAllFieldsFragmentDoc = gql`
    fragment VsdAllFields on variable_speed_drives {
  __typename
  id
  author_id
  created_at
  updated_at
  deleted_at
  imported_sizing_id
  enclosure
  kva
  manufacturer
  max_amps
  part_number
  vsd_type
  include_koc_timestamp
  only_koc_timestamp
  include_ecopetrol_timestamp
  only_ecopetrol_timestamp
}
    `;
export const QuoteLineItemFieldsFragmentDoc = gql`
    fragment QuoteLineItemFields on quote_line_items {
  quote_id
  category
  created_at
  credit
  deleted_at
  erp_material_long_description
  erp_material_number
  erp_material_short_description
  erp_price
  erp_product_hierarchy
  erp_uom
  erp_serialized
  id
  line_item_type
  margin
  note
  parent_order
  price_override
  pricing_date
  quantity
  source
  subcategory
  sub_order
  tax_type
  updated_at
  spyglass_equipment_import_json
  cable {
    ...CablesAllFields
  }
  intake {
    ...IntakesAllFields
  }
  motor {
    ...MotorsAllFields
  }
  motor_lead_extension {
    ...MleAllFields
  }
  pump {
    ...PumpsAllFields
  }
  seal {
    ...SealsAllFields
  }
  sensor {
    ...SensorsAllFields
  }
  step_down_transformer {
    ...DownTransAllFields
  }
  step_up_transformer {
    ...UpTransAllFields
  }
  switchboard {
    ...SwitchboardsAllFields
  }
  variable_speed_drive {
    ...VsdAllFields
  }
}
    ${CablesAllFieldsFragmentDoc}
${IntakesAllFieldsFragmentDoc}
${MotorsAllFieldsFragmentDoc}
${MleAllFieldsFragmentDoc}
${PumpsAllFieldsFragmentDoc}
${SealsAllFieldsFragmentDoc}
${SensorsAllFieldsFragmentDoc}
${DownTransAllFieldsFragmentDoc}
${UpTransAllFieldsFragmentDoc}
${SwitchboardsAllFieldsFragmentDoc}
${VsdAllFieldsFragmentDoc}`;
export const ScenariosFieldsFragmentDoc = gql`
    fragment ScenariosFields on scenarios {
  __typename
  id
  journal_author_id
  journal_created_at
  journal_updated_at
  journal_deleted_at
  winning_revision_id
  title
  notes
  internal_notes
  reason
  sizing_id
  well_properties_id
  scenario_equipment_id
  parameters_id
  correlations_id
  display_unit_overrides
  pumping_type
}
    `;
export const UsersFieldsFragmentDoc = gql`
    fragment UsersFields on users {
  __typename
  id
  email
  username
  display_name
  hal_identifier
}
    `;
export const SizingsListFieldsFragmentDoc = gql`
    fragment SizingsListFields on sizings {
  __typename
  id
  journal_author_id
  journal_deleted_at
  well_id
  customer_id
  title
  notes
}
    `;
export const WellsFieldsFragmentDoc = gql`
    fragment WellsFields on wells {
  __typename
  id
  well_name
  well_uwi
  well_erp_id
  address_erp_id
}
    `;
export const CustomersFieldsFragmentDoc = gql`
    fragment CustomersFields on customers {
  __typename
  id
  customer_name
  customer_erp_id
  imported_sizing_id
}
    `;
export const AllQuoteFieldsFragmentDoc = gql`
    fragment AllQuoteFields on quotes {
  ...QuoteFields
  parent {
    ...QuoteParentFields
  }
  quote_line_items(
    where: {deleted_at: {_is_null: true}}
    order_by: {sub_order: asc}
  ) {
    ...QuoteLineItemFields
  }
  quote_scenario {
    ...ScenariosFields
    author {
      ...UsersFields
    }
    sizing {
      ...SizingsListFields
      well {
        ...WellsFields
      }
      customer {
        ...CustomersFields
      }
    }
  }
  user {
    ...UsersFields
  }
}
    ${QuoteFieldsFragmentDoc}
${QuoteParentFieldsFragmentDoc}
${QuoteLineItemFieldsFragmentDoc}
${ScenariosFieldsFragmentDoc}
${UsersFieldsFragmentDoc}
${SizingsListFieldsFragmentDoc}
${WellsFieldsFragmentDoc}
${CustomersFieldsFragmentDoc}`;
export const AllQuotePriceHistoryFieldsFragmentDoc = gql`
    fragment AllQuotePriceHistoryFields on quotes {
  id
  erp_customer_name
  updated_at
  status
  quote_line_items(
    where: {deleted_at: {_is_null: true}}
    order_by: {sub_order: asc}
  ) {
    erp_material_number
    price_override
    margin
    erp_price
  }
}
    `;
export const AllQuoteFieldsWithoutLineItemsFragmentDoc = gql`
    fragment AllQuoteFieldsWithoutLineItems on quotes {
  parent {
    ...QuoteParentFields
  }
  created_at
  deleted_at
  directions
  erp_contract_number
  erp_customer_name
  erp_customer_number
  erp_nwa_id
  erp_nwa_name
  erp_plant_id
  erp_plant_name
  erp_price_list_name
  erp_price_list_number
  erp_well_country
  erp_well_id
  erp_well_name
  erp_well_uwi
  erp_well_region
  erp_address_id
  erp_address_name
  erp_full_address
  id
  name
  prepared_by_id
  pricing_date
  sk_job_id
  sk_job_number
  sk_job_type
  sk_planning_order
  sk_proposal_number
  status
  updated_at
  user {
    ...UsersFields
  }
  version_number
  error_log_json
}
    ${QuoteParentFieldsFragmentDoc}
${UsersFieldsFragmentDoc}`;
export const QuoteLineItemsUpdateInsertFieldsFragmentDoc = gql`
    fragment QuoteLineItemsUpdateInsertFields on quote_line_items {
  category
  created_at
  credit
  deleted_at
  erp_material_long_description
  erp_material_number
  erp_material_short_description
  erp_price
  erp_product_hierarchy
  erp_uom
  erp_serialized
  id
  line_item_type
  margin
  note
  parent_order
  price_override
  pricing_date
  quantity
  source
  subcategory
  sub_order
  tax_type
  updated_at
  spyglass_equipment_import_json
  spyglass_cable
  cable {
    id
  }
  spyglass_intake
  intake {
    id
  }
  spyglass_motor
  motor {
    id
  }
  spyglass_motor_lead_extension
  motor_lead_extension {
    id
  }
  spyglass_pump
  pump {
    id
  }
  spyglass_seal
  seal {
    id
  }
  spyglass_sensor
  sensor {
    id
  }
  spyglass_step_down_transformer
  step_down_transformer {
    id
  }
  spyglass_step_up_transformer
  step_up_transformer {
    id
  }
  spyglass_switchboard
  switchboard {
    id
  }
  spyglass_variable_speed_drive
  variable_speed_drive {
    id
  }
}
    `;
export const ScenarioCorrelationsFieldsFragmentDoc = gql`
    fragment ScenarioCorrelationsFields on scenario_correlations {
  __typename
  id
  journal_author_id
  journal_deleted_at
  winning_revision_id
  bubble_point
  dead_oil
  friction_loss
  gas_compressibility
  gas_viscosity
  tubing_hazen_williams_coefficient
  casing_hazen_williams_coefficient
  tubing_apply_hazen_williams_correction
  casing_apply_hazen_williams_correction
  oil_density
  oil_volume_factor_saturated
  oil_volume_factor_undersaturated
  tubing_palmer_correction
  casing_palmer_correction
  tubing_griffith_wallis
  casing_griffith_wallis
  salinity_ppm
  saturated_oil
  solution_gor
  tubing_flow
  casing_flow
  tubing_roughness_inches
  casing_roughness_inches
  under_saturated_oil
  water_density
  water_solution_gas
  water_viscosity
  water_volume_factor
  natural_gas_separation
  tdh_tuning_factor_ratio
}
    `;
export const ScenarioEquipmentBaseFieldsFragmentDoc = gql`
    fragment ScenarioEquipmentBaseFields on scenario_equipment {
  __typename
  id
  journal_author_id
  journal_created_at
  journal_updated_at
  journal_deleted_at
  mle_id
  lower_mle_id
  motor_id
  lower_motor_id
  bolt_on_discharge_id
  lower_bolt_on_discharge_id
  shroud_id
  lower_shroud_id
  parent_id
  sensor_id
  lower_sensor_id
  switchboard_id
  down_trans_id
  up_trans_id
  use_vsd
  use_uphole_y_tool
  use_downhole_y_tool
  has_lower_equip_stack
  vsd_id
  seals_order
  lower_seals_order
  winning_revision_author_id
  winning_revision_id
  intakes_order
  lower_intakes_order
  cables_order
  lower_cables_order
  pumps_order
  lower_pumps_order
  seal_motor_oil_id
  lower_seal_motor_oil_id
  uphole_y_tool_id
  downhole_y_tool_id
  include_y_tool
  uphole_y_tool_bypass_tubing_order
  uphole_y_tool_equipment_tubing_order
  downhole_y_tool_bypass_tubing_order
  downhole_y_tool_equipment_tubing_order
}
    `;
export const ScenarioEquipmentCablesBaseFieldsFragmentDoc = gql`
    fragment ScenarioEquipmentCablesBaseFields on scenario_equipment_xref_cables {
  __typename
  id
  length_feet
  cable_id
  scenario_equipment_id
  parent_id
  journal_author_id
  journal_created_at
  journal_updated_at
  journal_deleted_at
  winning_revision_id
  winning_revision_parent_id
  winning_revision_author_id
  winning_revision_created_at
  winning_revision_updated_at
  winning_revision_deleted_at
}
    `;
export const ScenarioEquipmentHousingsFieldsFragmentDoc = gql`
    fragment ScenarioEquipmentHousingsFields on scenario_equipment_xref_housings {
  __typename
  housing_id
  id
  journal_author_id
  journal_created_at
  journal_deleted_at
  journal_updated_at
  length_inches
  parent_id
  scenario_equipment_xref_pump_id
  stage_count
  winning_revision_author_id
  winning_revision_created_at
  winning_revision_deleted_at
  winning_revision_id
  winning_revision_parent_id
  winning_revision_updated_at
}
    `;
export const ScenarioEquipmentIntakesBaseFieldsFragmentDoc = gql`
    fragment ScenarioEquipmentIntakesBaseFields on scenario_equipment_xref_intakes {
  __typename
  id
  intake_id
  scenario_equipment_id
  use_high_strength_shaft
  parent_id
  journal_author_id
  journal_created_at
  journal_updated_at
  journal_deleted_at
  winning_revision_id
  winning_revision_parent_id
  winning_revision_author_id
  winning_revision_created_at
  winning_revision_updated_at
  winning_revision_deleted_at
}
    `;
export const ScenarioEquipmentXrefDownholeYToolBypassTubingsBaseFieldsFragmentDoc = gql`
    fragment ScenarioEquipmentXrefDownholeYToolBypassTubingsBaseFields on sc_equip_xref_downhole_ytool_bypass_tubings {
  __typename
  id
  length_feet
  tubing_id
  scenario_equipment_id
  parent_id
  journal_author_id
  journal_created_at
  journal_updated_at
  journal_deleted_at
  winning_revision_id
  winning_revision_parent_id
  winning_revision_author_id
  winning_revision_created_at
  winning_revision_updated_at
  winning_revision_deleted_at
}
    `;
export const ScenarioEquipmentXrefDownholeYToolEquipmentTubingsBaseFieldsFragmentDoc = gql`
    fragment ScenarioEquipmentXrefDownholeYToolEquipmentTubingsBaseFields on sc_equip_xref_downhole_ytool_equip_tubings {
  __typename
  id
  length_feet
  tubing_id
  scenario_equipment_id
  parent_id
  journal_author_id
  journal_created_at
  journal_updated_at
  journal_deleted_at
  winning_revision_id
  winning_revision_parent_id
  winning_revision_author_id
  winning_revision_created_at
  winning_revision_updated_at
  winning_revision_deleted_at
}
    `;
export const ScenarioEquipmentPumpsFieldsFragmentDoc = gql`
    fragment ScenarioEquipmentPumpsFields on scenario_equipment_xref_pumps {
  __typename
  id
  scenario_equipment_id
  pump_id
  rate_correction_ratio
  head_correction_ratio
  brake_horsepower_correction_ratio
  total_stages
  length_feet
  housings_order
  use_high_strength_shaft
  weight_pounds
  parent_id
  journal_author_id
  journal_created_at
  journal_updated_at
  journal_deleted_at
  winning_revision_id
  winning_revision_parent_id
  winning_revision_author_id
  winning_revision_created_at
  winning_revision_updated_at
  winning_revision_deleted_at
}
    `;
export const ScenarioEquipmentSealsBaseFieldsFragmentDoc = gql`
    fragment ScenarioEquipmentSealsBaseFields on scenario_equipment_xref_seals {
  __typename
  id
  use_high_strength_shaft
  parent_id
  journal_author_id
  journal_created_at
  journal_updated_at
  journal_deleted_at
  winning_revision_id
  winning_revision_parent_id
  scenario_equipment_id
  seal_id
  winning_revision_author_id
  winning_revision_created_at
  winning_revision_updated_at
  winning_revision_deleted_at
}
    `;
export const ScenarioEquipmentXrefUpholeYToolBypassTubingsBaseFieldsFragmentDoc = gql`
    fragment ScenarioEquipmentXrefUpholeYToolBypassTubingsBaseFields on sc_equip_xref_uphole_ytool_bypass_tubings {
  __typename
  id
  length_feet
  tubing_id
  scenario_equipment_id
  parent_id
  journal_author_id
  journal_created_at
  journal_updated_at
  journal_deleted_at
  winning_revision_id
  winning_revision_parent_id
  winning_revision_author_id
  winning_revision_created_at
  winning_revision_updated_at
  winning_revision_deleted_at
}
    `;
export const ScenarioEquipmentXrefUpholeYToolEquipmentTubingsBaseFieldsFragmentDoc = gql`
    fragment ScenarioEquipmentXrefUpholeYToolEquipmentTubingsBaseFields on sc_equip_xref_uphole_ytool_equip_tubings {
  __typename
  id
  length_feet
  tubing_id
  scenario_equipment_id
  parent_id
  journal_author_id
  journal_created_at
  journal_updated_at
  journal_deleted_at
  winning_revision_id
  winning_revision_parent_id
  winning_revision_author_id
  winning_revision_created_at
  winning_revision_updated_at
  winning_revision_deleted_at
}
    `;
export const ScenariosListFieldsFragmentDoc = gql`
    fragment ScenariosListFields on scenarios {
  __typename
  id
  sizing_id
  journal_author_id
  journal_deleted_at
  well_properties_id
  scenario_equipment_id
  parameters_id
  correlations_id
  title
  pumping_type
}
    `;
export const ScenarioParametersBaseFieldsFragmentDoc = gql`
    fragment ScenarioParametersBaseFields on scenario_parameters {
  __typename
  id
  journal_author_id
  journal_created_at
  journal_updated_at
  journal_deleted_at
  bottom_casing_pressure_psia
  cable_cost_kw_hr_usd
  bottom_tubing_pressure_psia
  has_compression_pump
  intake_override_gas_separation_percent
  intake_gas_separation_override_type
  natural_override_gas_separation_percent
  natural_gas_separation_override_type
  intake_packer_installed
  use_legacy_gas_head_rerate
  include_casing_friction_loss
  maximum_frequency
  minimum_frequency
  motor_rerate_ratio
  motor_shroud_interior_diameter_inches
  pump_hz
  pump_override_gas_correction_percent
  pump_wear_head_correction_ratio
  pump_wear_brake_horsepower_correction_ratio
  surface_drive_incoming_power_volts
  target_liquid_rate_std_barrel_day
  vsd_input_voltage
  flow_model
  winning_revision_id
  journal_author_id
  lower_intake_packer_installed
  lower_intake_override_gas_separation_percent
  lower_intake_gas_separation_override_type
  lower_natural_override_gas_separation_percent
  lower_natural_gas_separation_override_type
  lower_pump_hz
  lower_has_compression_pump
  lower_pump_override_gas_correction_percent
  lower_motor_rerate_ratio
  lower_motor_shroud_interior_diameter_inches
  lower_use_legacy_gas_head_rerate
  lower_include_casing_friction_loss
  lower_pump_wear_head_correction_ratio
  lower_pump_wear_brake_horsepower_correction_ratio
  elevation_feet_asl
}
    `;
export const ScenarioReasonsFieldsFragmentDoc = gql`
    fragment ScenarioReasonsFields on scenario_reasons {
  id: value
  comment
  value
}
    `;
export const ScenarioWellPropertiesBaseFieldsFragmentDoc = gql`
    fragment ScenarioWellPropertiesBaseFields on scenario_well_properties {
  __typename
  average_dls
  bottom_casing_id
  bottom_casing_length_feet
  bottom_tubing_id
  bottom_tubing_length_feet
  bottomhole_temperature_fahrenheit
  bubble_point_pressure_psia
  fluid_viscosity_override_cp
  condensate_api_override
  dew_point_pressure_psia_override
  co2_percent
  deviation_survey_id
  gas_specific_gravity
  gas_type
  h2s_percent
  id
  n2_percent
  c1_methane_percent
  c2_ethane_percent
  c3_propane_percent
  ic4_isobutene_percent
  nc4_butane_percent
  ic5_isopentane_percent
  nc5_bentane_percent
  c6_hexane_percent
  c7_heptane_percent
  oil_gravity_api
  surface_temperature_fahrenheit
  top_casing_id
  top_casing_length_feet
  top_of_perforations_measured_depth_feet
  top_of_perforations_true_vertical_depth_feet
  top_tubing_id
  top_tubing_length_feet
  water_specific_gravity
  well_test_datum_point_measured_depth_feet
  well_test_gas_input_type
  well_test_gas_rate_mscf_day
  well_test_liquid_input_type
  well_test_pressure_input_type
  well_test_productivity_index
  well_test_oil_rate_stb_day
  well_test_producing_bottom_hole_pressure_psia
  well_test_static_bottom_hole_pressure_psia
  hps_pump_inlet_pressure_psia
  hps_required_discharge_pressure_psia
  hps_pump_inlet_temperature_fahrenheit
  hps_liquid_type
  npsha_ft
  well_test_test_date
  well_test_water_rate_stb_day
  journal_author_id
  journal_created_at
  journal_updated_at
  journal_deleted_at
  winning_revision_id
  custom_fluid_properties
  custom_viscosities_properties
  o2_percent
  ar_percent
}
    `;
export const SizingDispositionsFieldsFragmentDoc = gql`
    fragment SizingDispositionsFields on sizing_dispositions {
  id: value
  comment
  value
}
    `;
export const SizingImportBaseFieldsFragmentDoc = gql`
    fragment SizingImportBaseFields on sizing_imports {
  created_at
  error
  id
  imported_at
  legacy_sizing_reaver_id
  legacy_sizing_name
}
    `;
export const SizingPumpingTypeFieldsFragmentDoc = gql`
    fragment SizingPumpingTypeFields on sizing_pumping_type {
  id: value
  comment
  value
}
    `;
export const SizingsFieldsFragmentDoc = gql`
    fragment SizingsFields on sizings {
  __typename
  id
  parent_id
  journal_author_id
  journal_created_at
  journal_updated_at
  journal_deleted_at
  winning_revision_id
  winning_revision_author_id
  well_id
  customer_id
  installed_scenario_id
  title
  notes
  default_display_units
  disposition
  pumping_type
  is_shared
  imported_sizing_id
  share_with_customer
  hps_location
  scenario_order
}
    `;
export const ErpWellFragmentDoc = gql`
    fragment ERPWell on SKJob {
  erp_well {
    country_code
    country_name
    region_code
    region_name
    sap_id
    ship_to_address_id
    ship_to_address_name
    ship_to_full_address
    sold_to_customer_id
    sold_to_customer_msa_signed
    sold_to_customer_name
    uwi
    well_name
    welladdress_id
  }
}
    `;
export const JobTypeFragmentDoc = gql`
    fragment JobType on SKJob {
  job_type {
    material_number
  }
}
    `;
export const JobFieldsFragmentDoc = gql`
    fragment JobFields on SKJob {
  id
  contract
  ...ERPWell
  nwa_id
  natural_work_area
  planning_order
  plant_name
  plant_erp_id
  price_list_name
  price_list_number
  pricing_date
  proposed_job_start_date
  number
  date
  currency
  contract_name
  ...JobType
}
    ${ErpWellFragmentDoc}
${JobTypeFragmentDoc}`;
export const SkQuoteFieldsFragmentDoc = gql`
    fragment SKQuoteFields on SKQuote {
  id
}
    `;
export const SkDeleteQuoteFieldsFragmentDoc = gql`
    fragment SKDeleteQuoteFields on SKDeleteQuote {
  id
}
    `;
export const StatusFieldsFragmentDoc = gql`
    fragment StatusFields on status {
  __typename
  status
}
    `;
export const TubingsTypeFieldsFragmentDoc = gql`
    fragment TubingsTypeFields on tubings_type {
  id: value
  value
  comment
}
    `;
export const WellTestGasInputOptionsFieldsFragmentDoc = gql`
    fragment WellTestGasInputOptionsFields on well_test_gas_input_options {
  id: value
  comment
  value
}
    `;
export const WellTestLiquidInputOptionsFieldsFragmentDoc = gql`
    fragment WellTestLiquidInputOptionsFields on well_test_liquid_input_options {
  id: value
  comment
  value
}
    `;
export const WellTestPressureInputOptionsFieldsFragmentDoc = gql`
    fragment WellTestPressureInputOptionsFields on well_test_pressure_input_options {
  id: value
  comment
  value
}
    `;
export const CasingsTypesDocument = gql`
    query CasingsTypes {
  casings_type {
    ...CasingsTypeFields
  }
}
    ${CasingsTypeFieldsFragmentDoc}`;

export function useCasingsTypesQuery(options: Omit<Urql.UseQueryArgs<never, CasingsTypesQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<CasingsTypesQuery>({ query: CasingsTypesDocument, ...options });
};
export const TubingFlowOptionsDocument = gql`
    query TubingFlowOptions {
  tubing_flow_options {
    ...TubingFlowOptionsFields
  }
}
    ${TubingFlowOptionsFieldsFragmentDoc}`;

export function useTubingFlowOptionsQuery(options: Omit<Urql.UseQueryArgs<never, TubingFlowOptionsQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<TubingFlowOptionsQuery>({ query: TubingFlowOptionsDocument, ...options });
};
export const CasingFlowOptionsDocument = gql`
    query CasingFlowOptions {
  casing_flow_options {
    ...CasingFlowOptionsFields
  }
}
    ${CasingFlowOptionsFieldsFragmentDoc}`;

export function useCasingFlowOptionsQuery(options: Omit<Urql.UseQueryArgs<never, CasingFlowOptionsQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<CasingFlowOptionsQuery>({ query: CasingFlowOptionsDocument, ...options });
};
export const FrictionLossOptionsDocument = gql`
    query FrictionLossOptions {
  friction_loss_options {
    ...FrictionLossOptionsFields
  }
}
    ${FrictionLossOptionsFieldsFragmentDoc}`;

export function useFrictionLossOptionsQuery(options: Omit<Urql.UseQueryArgs<never, FrictionLossOptionsQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<FrictionLossOptionsQuery>({ query: FrictionLossOptionsDocument, ...options });
};
export const BubblePointOptionsDocument = gql`
    query BubblePointOptions {
  bubble_point_options {
    ...BubblePointOptionsFields
  }
}
    ${BubblePointOptionsFieldsFragmentDoc}`;

export function useBubblePointOptionsQuery(options: Omit<Urql.UseQueryArgs<never, BubblePointOptionsQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<BubblePointOptionsQuery>({ query: BubblePointOptionsDocument, ...options });
};
export const WaterVolumeFactorOptionsDocument = gql`
    query WaterVolumeFactorOptions {
  water_volume_factor_options {
    ...WaterVolumeFactorOptionsFields
  }
}
    ${WaterVolumeFactorOptionsFieldsFragmentDoc}`;

export function useWaterVolumeFactorOptionsQuery(options: Omit<Urql.UseQueryArgs<never, WaterVolumeFactorOptionsQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<WaterVolumeFactorOptionsQuery>({ query: WaterVolumeFactorOptionsDocument, ...options });
};
export const SolutionGasOilRatioOptionsDocument = gql`
    query SolutionGasOilRatioOptions {
  solution_gas_oil_ratio_options {
    ...SolutionGasOilRatioOptionsFields
  }
}
    ${SolutionGasOilRatioOptionsFieldsFragmentDoc}`;

export function useSolutionGasOilRatioOptionsQuery(options: Omit<Urql.UseQueryArgs<never, SolutionGasOilRatioOptionsQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<SolutionGasOilRatioOptionsQuery>({ query: SolutionGasOilRatioOptionsDocument, ...options });
};
export const GasCompressibilityOptionsDocument = gql`
    query GasCompressibilityOptions {
  gas_compressibility_options {
    ...GasCompressibilityOptionsFields
  }
}
    ${GasCompressibilityOptionsFieldsFragmentDoc}`;

export function useGasCompressibilityOptionsQuery(options: Omit<Urql.UseQueryArgs<never, GasCompressibilityOptionsQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<GasCompressibilityOptionsQuery>({ query: GasCompressibilityOptionsDocument, ...options });
};
export const WellGasTypeOptionsDocument = gql`
    query WellGasTypeOptions {
  well_gas_type_options {
    ...WellGasTypeOptionsFields
  }
}
    ${WellGasTypeOptionsFieldsFragmentDoc}`;

export function useWellGasTypeOptionsQuery(options: Omit<Urql.UseQueryArgs<never, WellGasTypeOptionsQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<WellGasTypeOptionsQuery>({ query: WellGasTypeOptionsDocument, ...options });
};
export const OilVolumeFactorOptionsDocument = gql`
    query OilVolumeFactorOptions {
  oil_volume_factor_options {
    ...OilVolumeFactorOptionsFields
  }
}
    ${OilVolumeFactorOptionsFieldsFragmentDoc}`;

export function useOilVolumeFactorOptionsQuery(options: Omit<Urql.UseQueryArgs<never, OilVolumeFactorOptionsQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<OilVolumeFactorOptionsQuery>({ query: OilVolumeFactorOptionsDocument, ...options });
};
export const OilDensityOptionsDocument = gql`
    query OilDensityOptions {
  oil_density_options {
    ...OilDensityOptionsFields
  }
}
    ${OilDensityOptionsFieldsFragmentDoc}`;

export function useOilDensityOptionsQuery(options: Omit<Urql.UseQueryArgs<never, OilDensityOptionsQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<OilDensityOptionsQuery>({ query: OilDensityOptionsDocument, ...options });
};
export const DeadOilOptionsDocument = gql`
    query DeadOilOptions {
  dead_oil_options {
    ...DeadOilOptionsFields
  }
}
    ${DeadOilOptionsFieldsFragmentDoc}`;

export function useDeadOilOptionsQuery(options: Omit<Urql.UseQueryArgs<never, DeadOilOptionsQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<DeadOilOptionsQuery>({ query: DeadOilOptionsDocument, ...options });
};
export const WaterViscosityOptionsDocument = gql`
    query WaterViscosityOptions {
  water_viscosity_options {
    ...WaterViscosityOptionsFields
  }
}
    ${WaterViscosityOptionsFieldsFragmentDoc}`;

export function useWaterViscosityOptionsQuery(options: Omit<Urql.UseQueryArgs<never, WaterViscosityOptionsQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<WaterViscosityOptionsQuery>({ query: WaterViscosityOptionsDocument, ...options });
};
export const SaturatedOilOptionsDocument = gql`
    query SaturatedOilOptions {
  saturated_oil_options {
    ...SaturatedOilOptionsFields
  }
}
    ${SaturatedOilOptionsFieldsFragmentDoc}`;

export function useSaturatedOilOptionsQuery(options: Omit<Urql.UseQueryArgs<never, SaturatedOilOptionsQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<SaturatedOilOptionsQuery>({ query: SaturatedOilOptionsDocument, ...options });
};
export const GasViscosityOptionsDocument = gql`
    query GasViscosityOptions {
  gas_viscosity_options {
    ...GasViscosityOptionsFields
  }
}
    ${GasViscosityOptionsFieldsFragmentDoc}`;

export function useGasViscosityOptionsQuery(options: Omit<Urql.UseQueryArgs<never, GasViscosityOptionsQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<GasViscosityOptionsQuery>({ query: GasViscosityOptionsDocument, ...options });
};
export const UnderSaturatedOilOptionsDocument = gql`
    query UnderSaturatedOilOptions {
  under_saturated_oil_options {
    ...UnderSaturatedOilOptionsFields
  }
}
    ${UnderSaturatedOilOptionsFieldsFragmentDoc}`;

export function useUnderSaturatedOilOptionsQuery(options: Omit<Urql.UseQueryArgs<never, UnderSaturatedOilOptionsQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<UnderSaturatedOilOptionsQuery>({ query: UnderSaturatedOilOptionsDocument, ...options });
};
export const WaterDensityOptionsDocument = gql`
    query WaterDensityOptions {
  water_density_options {
    ...WaterDensityOptionsFields
  }
}
    ${WaterDensityOptionsFieldsFragmentDoc}`;

export function useWaterDensityOptionsQuery(options: Omit<Urql.UseQueryArgs<never, WaterDensityOptionsQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<WaterDensityOptionsQuery>({ query: WaterDensityOptionsDocument, ...options });
};
export const WaterSolutionGasOptionsDocument = gql`
    query WaterSolutionGasOptions {
  water_solution_gas_options {
    ...WaterSolutionGasOptionsFields
  }
}
    ${WaterSolutionGasOptionsFieldsFragmentDoc}`;

export function useWaterSolutionGasOptionsQuery(options: Omit<Urql.UseQueryArgs<never, WaterSolutionGasOptionsQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<WaterSolutionGasOptionsQuery>({ query: WaterSolutionGasOptionsDocument, ...options });
};
export const NaturalGasSeparationOptionsDocument = gql`
    query NaturalGasSeparationOptions {
  natural_gas_separation_options {
    ...NaturalGasSeparationOptionsFields
  }
}
    ${NaturalGasSeparationOptionsFieldsFragmentDoc}`;

export function useNaturalGasSeparationOptionsQuery(options: Omit<Urql.UseQueryArgs<never, NaturalGasSeparationOptionsQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<NaturalGasSeparationOptionsQuery>({ query: NaturalGasSeparationOptionsDocument, ...options });
};
export const CorrelationsOptionsDocument = gql`
    query CorrelationsOptions {
  tubing_flow_options {
    ...TubingFlowOptionsFields
  }
  casing_flow_options {
    ...CasingFlowOptionsFields
  }
  friction_loss_options {
    ...FrictionLossOptionsFields
  }
  bubble_point_options {
    ...BubblePointOptionsFields
  }
  water_volume_factor_options {
    ...WaterVolumeFactorOptionsFields
  }
  solution_gas_oil_ratio_options {
    ...SolutionGasOilRatioOptionsFields
  }
  gas_compressibility_options {
    ...GasCompressibilityOptionsFields
  }
  oil_volume_factor_options {
    ...OilVolumeFactorOptionsFields
  }
  oil_density_options {
    ...OilDensityOptionsFields
  }
  dead_oil_options {
    ...DeadOilOptionsFields
  }
  water_viscosity_options {
    ...WaterViscosityOptionsFields
  }
  saturated_oil_options {
    ...SaturatedOilOptionsFields
  }
  gas_viscosity_options {
    ...GasViscosityOptionsFields
  }
  under_saturated_oil_options {
    ...UnderSaturatedOilOptionsFields
  }
  water_density_options {
    ...WaterDensityOptionsFields
  }
  water_solution_gas_options {
    ...WaterSolutionGasOptionsFields
  }
  natural_gas_separation_options {
    ...NaturalGasSeparationOptionsFields
  }
}
    ${TubingFlowOptionsFieldsFragmentDoc}
${CasingFlowOptionsFieldsFragmentDoc}
${FrictionLossOptionsFieldsFragmentDoc}
${BubblePointOptionsFieldsFragmentDoc}
${WaterVolumeFactorOptionsFieldsFragmentDoc}
${SolutionGasOilRatioOptionsFieldsFragmentDoc}
${GasCompressibilityOptionsFieldsFragmentDoc}
${OilVolumeFactorOptionsFieldsFragmentDoc}
${OilDensityOptionsFieldsFragmentDoc}
${DeadOilOptionsFieldsFragmentDoc}
${WaterViscosityOptionsFieldsFragmentDoc}
${SaturatedOilOptionsFieldsFragmentDoc}
${GasViscosityOptionsFieldsFragmentDoc}
${UnderSaturatedOilOptionsFieldsFragmentDoc}
${WaterDensityOptionsFieldsFragmentDoc}
${WaterSolutionGasOptionsFieldsFragmentDoc}
${NaturalGasSeparationOptionsFieldsFragmentDoc}`;

export function useCorrelationsOptionsQuery(options: Omit<Urql.UseQueryArgs<never, CorrelationsOptionsQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<CorrelationsOptionsQuery>({ query: CorrelationsOptionsDocument, ...options });
};
export const CustomersDocument = gql`
    query Customers($limit: Int, $offset: Int, $where: customers_bool_exp, $order_by: [customers_order_by!]) {
  customers(limit: $limit, offset: $offset, where: $where, order_by: $order_by) {
    ...CustomersFields
  }
}
    ${CustomersFieldsFragmentDoc}`;

export function useCustomersQuery(options: Omit<Urql.UseQueryArgs<never, CustomersQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<CustomersQuery>({ query: CustomersDocument, ...options });
};
export const UpsertCustomerDocument = gql`
    mutation UpsertCustomer($object: customers_insert_input!) {
  insert_customers_one(
    object: $object
    on_conflict: {constraint: customers_customer_erp_id_key, update_columns: [customer_name]}
  ) {
    ...CustomersFields
  }
}
    ${CustomersFieldsFragmentDoc}`;

export function useUpsertCustomerMutation() {
  return Urql.useMutation<UpsertCustomerMutation, UpsertCustomerMutationVariables>(UpsertCustomerDocument);
};
export const AnalyzeDocument = gql`
    query Analyze($limit: Int, $offset: Int, $where: sizings_bool_exp, $scenarioWhere: scenarios_bool_exp! = {}, $order_by: [sizings_order_by!], $withAggregate: Boolean! = false, $withImportUser: Boolean! = false) {
  sizings(limit: $limit, offset: $offset, where: $where, order_by: $order_by) {
    ...SizingsFields
    parent_sizing {
      id
      title
      journal_deleted_at
    }
    author {
      ...UsersFields
    }
    well {
      ...WellsFields
    }
    customer {
      ...CustomersFields
    }
    imported_from_sizing @include(if: $withImportUser) {
      id
      legacy_author_id
      legacy_user {
        hal_identifier
        display_name
      }
    }
    scenarios_aggregate(
      where: {_and: [$scenarioWhere, {journal_deleted_at: {_is_null: true}}]}
    ) {
      aggregate {
        count_active: count
      }
    }
    scenarios_deleted_aggregate: scenarios_aggregate(
      where: {_and: [$scenarioWhere, {journal_deleted_at: {_is_null: false}}]}
    ) {
      aggregate {
        count_deleted: count
      }
    }
    scenarios(where: $scenarioWhere, order_by: [{journal_created_at: asc}]) {
      ...ScenariosFields
      author {
        ...UsersFields
      }
      correlations {
        ...ScenarioCorrelationsFields
      }
      equipment {
        ...ScenarioEquipmentBaseFields
        r_sensor: sensor {
          ...SensorsAllFields
        }
        r_lower_sensor: lower_sensor {
          ...SensorsAllFields
        }
        r_mle: mle {
          ...MleAllFields
        }
        r_lower_mle: lower_mle {
          ...MleAllFields
        }
        r_motor: motor {
          ...MotorsAllFields
        }
        r_bolt_on_discharge: bolt_on_discharge {
          ...BoltOnDischargesAllFields
        }
        r_lower_bolt_on_discharge: lower_bolt_on_discharge {
          ...BoltOnDischargesAllFields
        }
        r_lower_motor: lower_motor {
          ...MotorsAllFields
        }
        r_shroud: shroud {
          ...CasingsAllFields
        }
        r_lower_shroud: lower_shroud {
          ...CasingsAllFields
        }
        r_step_down_transformer: step_down_transformer {
          ...DownTransAllFields
        }
        r_step_up_transformer: step_up_transformer {
          ...UpTransAllFields
        }
        r_vsd: vsd {
          ...VsdAllFields
        }
        r_switchboard: switchboard {
          ...SwitchboardsAllFields
        }
        r_seal_motor_oil: seal_motor_oil {
          ...SealMotorOilAllFields
        }
        r_lower_seal_motor_oil: lower_seal_motor_oil {
          ...SealMotorOilAllFields
        }
        r_uphole_y_tool: uphole_y_tool {
          ...YToolAllFields
        }
        r_downhole_y_tool: downhole_y_tool {
          ...YToolAllFields
        }
        r_xref_pumps: xref_pumps(where: {journal_deleted_at: {_is_null: true}}) {
          ...ScenarioEquipmentPumpsFields
          r_pump: pump {
            ...PumpsAllFields
            r_housings: housings(
              where: {deleted_at: {_is_null: true}}
              order_by: {housing_number: asc}
            ) {
              ...HousingsAllFields
            }
          }
          r_xref_housings: xref_housings(where: {journal_deleted_at: {_is_null: true}}) {
            ...ScenarioEquipmentHousingsFields
            r_housing: housing {
              ...HousingsAllFields
            }
          }
        }
        r_xref_intakes: xref_intakes(where: {journal_deleted_at: {_is_null: true}}) {
          ...ScenarioEquipmentIntakesBaseFields
          r_intake: intake {
            ...IntakesAllFields
          }
        }
        r_xref_seals: xref_seals(where: {journal_deleted_at: {_is_null: true}}) {
          ...ScenarioEquipmentSealsBaseFields
          r_seal: seal {
            ...SealsAllFields
          }
        }
        r_xref_cables: xref_cables(where: {journal_deleted_at: {_is_null: true}}) {
          ...ScenarioEquipmentCablesBaseFields
          r_cable: cable {
            ...CablesAllFields
          }
        }
        r_xref_uphole_y_tool_bypass_tubings: uphole_xref_y_tool_bypass_tubings(
          where: {journal_deleted_at: {_is_null: true}}
        ) {
          ...ScenarioEquipmentXrefUpholeYToolBypassTubingsBaseFields
          r_tubing: tubing {
            ...TubingsAllFields
          }
        }
        r_xref_uphole_y_tool_equipment_tubings: uphole_xref_y_tool_equipment_tubings(
          where: {journal_deleted_at: {_is_null: true}}
        ) {
          ...ScenarioEquipmentXrefUpholeYToolEquipmentTubingsBaseFields
          r_tubing: tubing {
            ...TubingsAllFields
          }
        }
        r_xref_downhole_y_tool_bypass_tubings: downhole_xref_y_tool_bypass_tubings(
          where: {journal_deleted_at: {_is_null: true}}
        ) {
          ...ScenarioEquipmentXrefDownholeYToolBypassTubingsBaseFields
          r_tubing: tubing {
            ...TubingsAllFields
          }
        }
        r_xref_downhole_y_tool_equipment_tubings: downhole_xref_y_tool_equipment_tubings(
          where: {journal_deleted_at: {_is_null: true}}
        ) {
          ...ScenarioEquipmentXrefDownholeYToolEquipmentTubingsBaseFields
          r_tubing: tubing {
            ...TubingsAllFields
          }
        }
      }
      parameters {
        ...ScenarioParametersBaseFields
      }
      well_properties {
        ...ScenarioWellPropertiesBaseFields
        r_top_tubing: top_tubing {
          ...TubingsAllFields
        }
        r_bottom_tubing: bottom_tubing {
          ...TubingsAllFields
        }
        r_top_casing: top_casing {
          ...CasingsAllFields
        }
        r_bottom_casing: bottom_casing {
          ...CasingsAllFields
        }
        r_deviation_survey: deviation_survey {
          ...DeviationSurveyBaseFields
        }
      }
      r_performance_evaluations: performance_evaluations(
        order_by: {journal_created_at: asc}
        where: {scenario: {journal_deleted_at: {_is_null: true}, sizing: {journal_deleted_at: {_is_null: true}}}, journal_deleted_at: {_is_null: true}}
      ) {
        ...PerformanceEvaluationAllFields
        r_scenario: scenario {
          ...ScenariosListFields
          sizing {
            ...SizingsListFields
            well {
              ...WellsFields
            }
            customer {
              ...CustomersFields
            }
          }
        }
        r_author: author {
          ...UsersFields
        }
        r_xref_pumps: xref_pumps(where: {journal_deleted_at: {_is_null: true}}) {
          ...PerformanceEvaluationXrefPumpFields
        }
      }
    }
  }
  sizings_aggregate(where: $where) @include(if: $withAggregate) {
    id: __typename
    aggregate {
      id: __typename
      count
    }
  }
  scenarios_aggregate(where: {_and: [$scenarioWhere, {sizing: $where}]}) {
    aggregate {
      count
    }
  }
  performance_evaluations_aggregate(
    where: {scenario: {_and: [$scenarioWhere, {journal_deleted_at: {_is_null: true}}, {sizing: {journal_deleted_at: {_is_null: true}}}, {sizing: $where}]}, journal_deleted_at: {_is_null: true}}
  ) {
    id: __typename
    aggregate {
      id: __typename
      count
    }
  }
}
    ${SizingsFieldsFragmentDoc}
${UsersFieldsFragmentDoc}
${WellsFieldsFragmentDoc}
${CustomersFieldsFragmentDoc}
${ScenariosFieldsFragmentDoc}
${ScenarioCorrelationsFieldsFragmentDoc}
${ScenarioEquipmentBaseFieldsFragmentDoc}
${SensorsAllFieldsFragmentDoc}
${MleAllFieldsFragmentDoc}
${MotorsAllFieldsFragmentDoc}
${BoltOnDischargesAllFieldsFragmentDoc}
${CasingsAllFieldsFragmentDoc}
${DownTransAllFieldsFragmentDoc}
${UpTransAllFieldsFragmentDoc}
${VsdAllFieldsFragmentDoc}
${SwitchboardsAllFieldsFragmentDoc}
${SealMotorOilAllFieldsFragmentDoc}
${YToolAllFieldsFragmentDoc}
${ScenarioEquipmentPumpsFieldsFragmentDoc}
${PumpsAllFieldsFragmentDoc}
${HousingsAllFieldsFragmentDoc}
${ScenarioEquipmentHousingsFieldsFragmentDoc}
${ScenarioEquipmentIntakesBaseFieldsFragmentDoc}
${IntakesAllFieldsFragmentDoc}
${ScenarioEquipmentSealsBaseFieldsFragmentDoc}
${SealsAllFieldsFragmentDoc}
${ScenarioEquipmentCablesBaseFieldsFragmentDoc}
${CablesAllFieldsFragmentDoc}
${ScenarioEquipmentXrefUpholeYToolBypassTubingsBaseFieldsFragmentDoc}
${TubingsAllFieldsFragmentDoc}
${ScenarioEquipmentXrefUpholeYToolEquipmentTubingsBaseFieldsFragmentDoc}
${ScenarioEquipmentXrefDownholeYToolBypassTubingsBaseFieldsFragmentDoc}
${ScenarioEquipmentXrefDownholeYToolEquipmentTubingsBaseFieldsFragmentDoc}
${ScenarioParametersBaseFieldsFragmentDoc}
${ScenarioWellPropertiesBaseFieldsFragmentDoc}
${DeviationSurveyBaseFieldsFragmentDoc}
${PerformanceEvaluationAllFieldsFragmentDoc}
${ScenariosListFieldsFragmentDoc}
${SizingsListFieldsFragmentDoc}
${PerformanceEvaluationXrefPumpFieldsFragmentDoc}`;

export function useAnalyzeQuery(options: Omit<Urql.UseQueryArgs<never, AnalyzeQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<AnalyzeQuery>({ query: AnalyzeDocument, ...options });
};
export const DirectionalDataSetDocument = gql`
    query DirectionalDataSet {
  deviation_survey_directional_dataset {
    ...DeviationSurveyDirectionalDataSetBaseFields
  }
}
    ${DeviationSurveyDirectionalDataSetBaseFieldsFragmentDoc}`;

export function useDirectionalDataSetQuery(options: Omit<Urql.UseQueryArgs<never, DirectionalDataSetQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<DirectionalDataSetQuery>({ query: DirectionalDataSetDocument, ...options });
};
export const DeviationSurveyDocument = gql`
    query DeviationSurvey($distinct_on: [deviation_survey_select_column!], $limit: Int, $offset: Int, $order_by: [deviation_survey_order_by!], $where: deviation_survey_bool_exp) {
  deviation_survey(
    where: $where
    distinct_on: $distinct_on
    limit: $limit
    offset: $offset
    order_by: $order_by
  ) {
    ...DeviationSurveyBaseFields
  }
}
    ${DeviationSurveyBaseFieldsFragmentDoc}`;

export function useDeviationSurveyQuery(options: Omit<Urql.UseQueryArgs<never, DeviationSurveyQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<DeviationSurveyQuery>({ query: DeviationSurveyDocument, ...options });
};
export const DisplayUnitsDocument = gql`
    query DisplayUnits {
  display_units(order_by: {value: asc}) {
    ...DisplayUnitsFields
  }
}
    ${DisplayUnitsFieldsFragmentDoc}`;

export function useDisplayUnitsQuery(options: Omit<Urql.UseQueryArgs<never, DisplayUnitsQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<DisplayUnitsQuery>({ query: DisplayUnitsDocument, ...options });
};
export const AllEnumsDocument = gql`
    query AllEnums {
  tubing_flow_options {
    ...TubingFlowOptionsFields
  }
  casing_flow_options {
    ...CasingFlowOptionsFields
  }
  bubble_point_options {
    ...BubblePointOptionsFields
  }
  water_volume_factor_options {
    ...WaterVolumeFactorOptionsFields
  }
  water_density_options {
    ...WaterDensityOptionsFields
  }
  water_solution_gas_options {
    ...WaterSolutionGasOptionsFields
  }
  solution_gas_oil_ratio_options {
    ...SolutionGasOilRatioOptionsFields
  }
  gas_compressibility_options {
    ...GasCompressibilityOptionsFields
  }
  well_gas_type_options {
    ...WellGasTypeOptionsFields
  }
  oil_volume_factor_options {
    ...OilVolumeFactorOptionsFields
  }
  oil_density_options {
    ...OilDensityOptionsFields
  }
  dead_oil_options {
    ...DeadOilOptionsFields
  }
  water_viscosity_options {
    ...WaterViscosityOptionsFields
  }
  saturated_oil_options {
    ...SaturatedOilOptionsFields
  }
  gas_viscosity_options {
    ...GasViscosityOptionsFields
  }
  under_saturated_oil_options {
    ...UnderSaturatedOilOptionsFields
  }
  water_density_options {
    ...WaterDensityOptionsFields
  }
  water_solution_gas_options {
    ...WaterSolutionGasOptionsFields
  }
  display_units {
    ...DisplayUnitsFields
  }
  flow_model_active {
    ...FlowModelFields
  }
  scenario_reasons {
    ...ScenarioReasonsFields
  }
  sizing_dispositions {
    ...SizingDispositionsFields
  }
  sizing_pumping_type {
    ...SizingPumpingTypeFields
  }
  well_test_liquid_input_options {
    ...WellTestLiquidInputOptionsFields
  }
  well_test_gas_input_options {
    ...WellTestGasInputOptionsFields
  }
  well_test_pressure_input_options {
    ...WellTestPressureInputOptionsFields
  }
  friction_loss_options {
    ...FrictionLossOptionsFields
  }
  override_options {
    id: value
    value
    comment
  }
  tubings_type {
    ...TubingsTypeFields
  }
  casings_type {
    ...CasingsTypeFields
  }
}
    ${TubingFlowOptionsFieldsFragmentDoc}
${CasingFlowOptionsFieldsFragmentDoc}
${BubblePointOptionsFieldsFragmentDoc}
${WaterVolumeFactorOptionsFieldsFragmentDoc}
${WaterDensityOptionsFieldsFragmentDoc}
${WaterSolutionGasOptionsFieldsFragmentDoc}
${SolutionGasOilRatioOptionsFieldsFragmentDoc}
${GasCompressibilityOptionsFieldsFragmentDoc}
${WellGasTypeOptionsFieldsFragmentDoc}
${OilVolumeFactorOptionsFieldsFragmentDoc}
${OilDensityOptionsFieldsFragmentDoc}
${DeadOilOptionsFieldsFragmentDoc}
${WaterViscosityOptionsFieldsFragmentDoc}
${SaturatedOilOptionsFieldsFragmentDoc}
${GasViscosityOptionsFieldsFragmentDoc}
${UnderSaturatedOilOptionsFieldsFragmentDoc}
${DisplayUnitsFieldsFragmentDoc}
${FlowModelFieldsFragmentDoc}
${ScenarioReasonsFieldsFragmentDoc}
${SizingDispositionsFieldsFragmentDoc}
${SizingPumpingTypeFieldsFragmentDoc}
${WellTestLiquidInputOptionsFieldsFragmentDoc}
${WellTestGasInputOptionsFieldsFragmentDoc}
${WellTestPressureInputOptionsFieldsFragmentDoc}
${FrictionLossOptionsFieldsFragmentDoc}
${TubingsTypeFieldsFragmentDoc}
${CasingsTypeFieldsFragmentDoc}`;

export function useAllEnumsQuery(options: Omit<Urql.UseQueryArgs<never, AllEnumsQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<AllEnumsQuery>({ query: AllEnumsDocument, ...options });
};
export const BoltOnDischargesBaseDocument = gql`
    query BoltOnDischargesBase($limit: Int, $offset: Int, $where: bolt_on_discharges_bool_exp, $order_by: [bolt_on_discharges_order_by!]) {
  bolt_on_discharges(
    limit: $limit
    offset: $offset
    where: $where
    order_by: $order_by
  ) {
    ...BoltOnDischargesBaseFields
  }
  bolt_on_discharges_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    ${BoltOnDischargesBaseFieldsFragmentDoc}`;

export function useBoltOnDischargesBaseQuery(options: Omit<Urql.UseQueryArgs<never, BoltOnDischargesBaseQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<BoltOnDischargesBaseQuery>({ query: BoltOnDischargesBaseDocument, ...options });
};
export const BoltOnDischargesDocument = gql`
    query BoltOnDischarges($limit: Int, $offset: Int, $where: bolt_on_discharges_bool_exp, $order_by: [bolt_on_discharges_order_by!]) {
  bolt_on_discharges(
    limit: $limit
    offset: $offset
    where: $where
    order_by: $order_by
  ) {
    ...BoltOnDischargesAllFields
  }
  bolt_on_discharges_aggregate(where: $where) {
    id: __typename
    aggregate {
      id: __typename
      count
    }
  }
}
    ${BoltOnDischargesAllFieldsFragmentDoc}`;

export function useBoltOnDischargesQuery(options: Omit<Urql.UseQueryArgs<never, BoltOnDischargesQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<BoltOnDischargesQuery>({ query: BoltOnDischargesDocument, ...options });
};
export const BoltOnDischargesSubDocument = gql`
    subscription BoltOnDischargesSub($limit: Int, $offset: Int, $where: bolt_on_discharges_bool_exp, $order_by: [bolt_on_discharges_order_by!]) {
  bolt_on_discharges(
    limit: $limit
    offset: $offset
    where: $where
    order_by: $order_by
  ) {
    ...BoltOnDischargesAllFields
  }
}
    ${BoltOnDischargesAllFieldsFragmentDoc}`;

export function useBoltOnDischargesSubSubscription<R = BoltOnDischargesSubSubscription>(options: Omit<Urql.UseSubscriptionArgs<never, BoltOnDischargesSubSubscriptionVariables>, 'query'> = {}, handler?: Urql.SubscriptionHandlerArg<BoltOnDischargesSubSubscription, R>) {
  return Urql.useSubscription<BoltOnDischargesSubSubscription, R, BoltOnDischargesSubSubscriptionVariables>({ query: BoltOnDischargesSubDocument, ...options }, handler);
};
export const DeleteBoltOnDischargesDocument = gql`
    mutation DeleteBoltOnDischarges($where: bolt_on_discharges_bool_exp!) {
  update_bolt_on_discharges(where: $where, _set: {deleted_at: "now()"}) {
    returning {
      id
    }
  }
}
    `;

export function useDeleteBoltOnDischargesMutation() {
  return Urql.useMutation<DeleteBoltOnDischargesMutation, DeleteBoltOnDischargesMutationVariables>(DeleteBoltOnDischargesDocument);
};
export const RestoreBoltOnDischargesDocument = gql`
    mutation RestoreBoltOnDischarges($where: bolt_on_discharges_bool_exp!) {
  update_bolt_on_discharges(where: $where, _set: {deleted_at: null}) {
    returning {
      id
    }
  }
}
    `;

export function useRestoreBoltOnDischargesMutation() {
  return Urql.useMutation<RestoreBoltOnDischargesMutation, RestoreBoltOnDischargesMutationVariables>(RestoreBoltOnDischargesDocument);
};
export const UpdateBoltOnDischargeByPkDocument = gql`
    mutation UpdateBoltOnDischargeByPk($object: bolt_on_discharges_set_input, $id: uuid!) {
  update_bolt_on_discharges_by_pk(pk_columns: {id: $id}, _set: $object) {
    ...BoltOnDischargesAllFields
  }
}
    ${BoltOnDischargesAllFieldsFragmentDoc}`;

export function useUpdateBoltOnDischargeByPkMutation() {
  return Urql.useMutation<UpdateBoltOnDischargeByPkMutation, UpdateBoltOnDischargeByPkMutationVariables>(UpdateBoltOnDischargeByPkDocument);
};
export const InsertBoltOnDischargeDocument = gql`
    mutation InsertBoltOnDischarge($object: bolt_on_discharges_insert_input!) {
  insert_bolt_on_discharges_one(object: $object) {
    ...BoltOnDischargesInsertFields
  }
}
    ${BoltOnDischargesInsertFieldsFragmentDoc}`;

export function useInsertBoltOnDischargeMutation() {
  return Urql.useMutation<InsertBoltOnDischargeMutation, InsertBoltOnDischargeMutationVariables>(InsertBoltOnDischargeDocument);
};
export const CablesBaseDocument = gql`
    query CablesBase($limit: Int, $offset: Int, $where: cables_bool_exp, $order_by: [cables_order_by!]) {
  cables(limit: $limit, offset: $offset, where: $where, order_by: $order_by) {
    ...CablesBaseFields
  }
  cables_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    ${CablesBaseFieldsFragmentDoc}`;

export function useCablesBaseQuery(options: Omit<Urql.UseQueryArgs<never, CablesBaseQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<CablesBaseQuery>({ query: CablesBaseDocument, ...options });
};
export const CablesDocument = gql`
    query Cables($limit: Int, $offset: Int, $where: cables_bool_exp, $order_by: [cables_order_by!]) {
  cables(limit: $limit, offset: $offset, where: $where, order_by: $order_by) {
    ...CablesAllFields
  }
  cables_aggregate(where: $where) {
    id: __typename
    aggregate {
      id: __typename
      count
    }
  }
}
    ${CablesAllFieldsFragmentDoc}`;

export function useCablesQuery(options: Omit<Urql.UseQueryArgs<never, CablesQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<CablesQuery>({ query: CablesDocument, ...options });
};
export const DeleteCablesDocument = gql`
    mutation DeleteCables($where: cables_bool_exp!) {
  update_cables(where: $where, _set: {deleted_at: "now()"}) {
    returning {
      id
    }
  }
}
    `;

export function useDeleteCablesMutation() {
  return Urql.useMutation<DeleteCablesMutation, DeleteCablesMutationVariables>(DeleteCablesDocument);
};
export const RestoreCablesDocument = gql`
    mutation RestoreCables($where: cables_bool_exp!) {
  update_cables(where: $where, _set: {deleted_at: null}) {
    returning {
      id
    }
  }
}
    `;

export function useRestoreCablesMutation() {
  return Urql.useMutation<RestoreCablesMutation, RestoreCablesMutationVariables>(RestoreCablesDocument);
};
export const InsertCableDocument = gql`
    mutation InsertCable($object: cables_insert_input!) {
  insert_cables_one(object: $object) {
    ...CablesAllFields
  }
}
    ${CablesAllFieldsFragmentDoc}`;

export function useInsertCableMutation() {
  return Urql.useMutation<InsertCableMutation, InsertCableMutationVariables>(InsertCableDocument);
};
export const UpdateCableByPkDocument = gql`
    mutation UpdateCableByPk($id: uuid!, $object: cables_set_input!) {
  update_cables_by_pk(pk_columns: {id: $id}, _set: $object) {
    ...CablesAllFields
  }
}
    ${CablesAllFieldsFragmentDoc}`;

export function useUpdateCableByPkMutation() {
  return Urql.useMutation<UpdateCableByPkMutation, UpdateCableByPkMutationVariables>(UpdateCableByPkDocument);
};
export const CablesSubDocument = gql`
    subscription CablesSub($limit: Int, $offset: Int, $where: cables_bool_exp, $order_by: [cables_order_by!]) {
  cables(limit: $limit, offset: $offset, where: $where, order_by: $order_by) {
    ...CablesAllFields
  }
}
    ${CablesAllFieldsFragmentDoc}`;

export function useCablesSubSubscription<R = CablesSubSubscription>(options: Omit<Urql.UseSubscriptionArgs<never, CablesSubSubscriptionVariables>, 'query'> = {}, handler?: Urql.SubscriptionHandlerArg<CablesSubSubscription, R>) {
  return Urql.useSubscription<CablesSubSubscription, R, CablesSubSubscriptionVariables>({ query: CablesSubDocument, ...options }, handler);
};
export const CasingsBaseDocument = gql`
    query CasingsBase($limit: Int, $offset: Int, $where: casings_bool_exp, $order_by: [casings_order_by!]) {
  casings(limit: $limit, offset: $offset, where: $where, order_by: $order_by) {
    ...CasingsBaseFields
  }
  casings_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    ${CasingsBaseFieldsFragmentDoc}`;

export function useCasingsBaseQuery(options: Omit<Urql.UseQueryArgs<never, CasingsBaseQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<CasingsBaseQuery>({ query: CasingsBaseDocument, ...options });
};
export const CasingsDocument = gql`
    query Casings($limit: Int, $offset: Int, $where: casings_bool_exp, $order_by: [casings_order_by!]) {
  casings(limit: $limit, offset: $offset, where: $where, order_by: $order_by) {
    ...CasingsAllFields
  }
  casings_aggregate(where: $where) {
    id: __typename
    aggregate {
      id: __typename
      count
    }
  }
}
    ${CasingsAllFieldsFragmentDoc}`;

export function useCasingsQuery(options: Omit<Urql.UseQueryArgs<never, CasingsQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<CasingsQuery>({ query: CasingsDocument, ...options });
};
export const DeleteCasingsDocument = gql`
    mutation DeleteCasings($where: casings_bool_exp!) {
  update_casings(where: $where, _set: {deleted_at: "now()"}) {
    returning {
      id
    }
  }
}
    `;

export function useDeleteCasingsMutation() {
  return Urql.useMutation<DeleteCasingsMutation, DeleteCasingsMutationVariables>(DeleteCasingsDocument);
};
export const RestoreCasingsDocument = gql`
    mutation RestoreCasings($where: casings_bool_exp!) {
  update_casings(where: $where, _set: {deleted_at: null}) {
    returning {
      id
    }
  }
}
    `;

export function useRestoreCasingsMutation() {
  return Urql.useMutation<RestoreCasingsMutation, RestoreCasingsMutationVariables>(RestoreCasingsDocument);
};
export const InsertCasingDocument = gql`
    mutation InsertCasing($object: casings_insert_input!) {
  insert_casings_one(object: $object) {
    ...CasingsAllFields
  }
}
    ${CasingsAllFieldsFragmentDoc}`;

export function useInsertCasingMutation() {
  return Urql.useMutation<InsertCasingMutation, InsertCasingMutationVariables>(InsertCasingDocument);
};
export const UpdateCasingByPkDocument = gql`
    mutation UpdateCasingByPk($id: uuid!, $object: casings_set_input!) {
  update_casings_by_pk(pk_columns: {id: $id}, _set: $object) {
    ...CasingsAllFields
  }
}
    ${CasingsAllFieldsFragmentDoc}`;

export function useUpdateCasingByPkMutation() {
  return Urql.useMutation<UpdateCasingByPkMutation, UpdateCasingByPkMutationVariables>(UpdateCasingByPkDocument);
};
export const CasingsSubDocument = gql`
    subscription CasingsSub($limit: Int, $offset: Int, $where: casings_bool_exp, $order_by: [casings_order_by!]) {
  casings(limit: $limit, offset: $offset, where: $where, order_by: $order_by) {
    ...CasingsAllFields
  }
}
    ${CasingsAllFieldsFragmentDoc}`;

export function useCasingsSubSubscription<R = CasingsSubSubscription>(options: Omit<Urql.UseSubscriptionArgs<never, CasingsSubSubscriptionVariables>, 'query'> = {}, handler?: Urql.SubscriptionHandlerArg<CasingsSubSubscription, R>) {
  return Urql.useSubscription<CasingsSubSubscription, R, CasingsSubSubscriptionVariables>({ query: CasingsSubDocument, ...options }, handler);
};
export const HousingsBaseDocument = gql`
    query HousingsBase($limit: Int, $offset: Int, $where: housings_bool_exp, $order_by: [housings_order_by!]) {
  housings(limit: $limit, offset: $offset, where: $where, order_by: $order_by) {
    ...HousingBaseFields
  }
  housings_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    ${HousingBaseFieldsFragmentDoc}`;

export function useHousingsBaseQuery(options: Omit<Urql.UseQueryArgs<never, HousingsBaseQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<HousingsBaseQuery>({ query: HousingsBaseDocument, ...options });
};
export const HousingsDocument = gql`
    query Housings($limit: Int, $offset: Int, $where: housings_bool_exp, $order_by: [housings_order_by!]) {
  housings(limit: $limit, offset: $offset, where: $where, order_by: $order_by) {
    ...HousingsAllFields
  }
  housings_aggregate(where: $where) {
    id: __typename
    aggregate {
      id: __typename
      count
    }
  }
}
    ${HousingsAllFieldsFragmentDoc}`;

export function useHousingsQuery(options: Omit<Urql.UseQueryArgs<never, HousingsQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<HousingsQuery>({ query: HousingsDocument, ...options });
};
export const DeleteHousingsDocument = gql`
    mutation DeleteHousings($where: housings_bool_exp!) {
  update_housings(where: $where, _set: {deleted_at: "now()"}) {
    returning {
      id
    }
  }
}
    `;

export function useDeleteHousingsMutation() {
  return Urql.useMutation<DeleteHousingsMutation, DeleteHousingsMutationVariables>(DeleteHousingsDocument);
};
export const RestoreHousingsDocument = gql`
    mutation RestoreHousings($where: housings_bool_exp!) {
  update_housings(where: $where, _set: {deleted_at: null}) {
    returning {
      id
    }
  }
}
    `;

export function useRestoreHousingsMutation() {
  return Urql.useMutation<RestoreHousingsMutation, RestoreHousingsMutationVariables>(RestoreHousingsDocument);
};
export const UpsertHousingsDocument = gql`
    mutation UpsertHousings($objects: [housings_insert_input!]!) {
  insert_housings(
    objects: $objects
    on_conflict: {constraint: housings_pkey, update_columns: [housing_number, stage_count, length_inches, weight_pounds, include_koc_timestamp, include_ecopetrol_timestamp, only_koc_timestamp, only_ecopetrol_timestamp]}
  ) {
    returning {
      ...HousingsAllFields
    }
  }
}
    ${HousingsAllFieldsFragmentDoc}`;

export function useUpsertHousingsMutation() {
  return Urql.useMutation<UpsertHousingsMutation, UpsertHousingsMutationVariables>(UpsertHousingsDocument);
};
export const HousingsSubDocument = gql`
    subscription HousingsSub($limit: Int, $offset: Int, $where: housings_bool_exp, $order_by: [housings_order_by!]) {
  housings(limit: $limit, offset: $offset, where: $where, order_by: $order_by) {
    ...HousingsAllFields
    pump {
      id
      manufacturer
      series_model
    }
  }
}
    ${HousingsAllFieldsFragmentDoc}`;

export function useHousingsSubSubscription<R = HousingsSubSubscription>(options: Omit<Urql.UseSubscriptionArgs<never, HousingsSubSubscriptionVariables>, 'query'> = {}, handler?: Urql.SubscriptionHandlerArg<HousingsSubSubscription, R>) {
  return Urql.useSubscription<HousingsSubSubscription, R, HousingsSubSubscriptionVariables>({ query: HousingsSubDocument, ...options }, handler);
};
export const HpsBoltOnDischargesBaseDocument = gql`
    query HpsBoltOnDischargesBase($limit: Int, $offset: Int, $where: bolt_on_discharges_bool_exp, $order_by: [bolt_on_discharges_order_by!]) {
  bolt_on_discharges(
    limit: $limit
    offset: $offset
    where: $where
    order_by: $order_by
  ) {
    ...HpsBoltOnDischargesBaseFields
  }
  bolt_on_discharges_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    ${HpsBoltOnDischargesBaseFieldsFragmentDoc}`;

export function useHpsBoltOnDischargesBaseQuery(options: Omit<Urql.UseQueryArgs<never, HpsBoltOnDischargesBaseQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<HpsBoltOnDischargesBaseQuery>({ query: HpsBoltOnDischargesBaseDocument, ...options });
};
export const HpsBoltOnDischargesDocument = gql`
    query HpsBoltOnDischarges($limit: Int, $offset: Int, $where: bolt_on_discharges_bool_exp, $order_by: [bolt_on_discharges_order_by!]) {
  bolt_on_discharges(
    limit: $limit
    offset: $offset
    where: $where
    order_by: $order_by
  ) {
    ...HpsBoltOnDischargesAllFields
  }
  bolt_on_discharges_aggregate(where: $where) {
    id: __typename
    aggregate {
      id: __typename
      count
    }
  }
}
    ${HpsBoltOnDischargesAllFieldsFragmentDoc}`;

export function useHpsBoltOnDischargesQuery(options: Omit<Urql.UseQueryArgs<never, HpsBoltOnDischargesQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<HpsBoltOnDischargesQuery>({ query: HpsBoltOnDischargesDocument, ...options });
};
export const HpsBoltOnDischargesSubDocument = gql`
    subscription HpsBoltOnDischargesSub($limit: Int, $offset: Int, $where: bolt_on_discharges_bool_exp, $order_by: [bolt_on_discharges_order_by!]) {
  bolt_on_discharges(
    limit: $limit
    offset: $offset
    where: $where
    order_by: $order_by
  ) {
    ...HpsBoltOnDischargesAllFields
  }
}
    ${HpsBoltOnDischargesAllFieldsFragmentDoc}`;

export function useHpsBoltOnDischargesSubSubscription<R = HpsBoltOnDischargesSubSubscription>(options: Omit<Urql.UseSubscriptionArgs<never, HpsBoltOnDischargesSubSubscriptionVariables>, 'query'> = {}, handler?: Urql.SubscriptionHandlerArg<HpsBoltOnDischargesSubSubscription, R>) {
  return Urql.useSubscription<HpsBoltOnDischargesSubSubscription, R, HpsBoltOnDischargesSubSubscriptionVariables>({ query: HpsBoltOnDischargesSubDocument, ...options }, handler);
};
export const DeleteHpsBoltOnDischargesDocument = gql`
    mutation DeleteHpsBoltOnDischarges($where: bolt_on_discharges_bool_exp!) {
  update_bolt_on_discharges(where: $where, _set: {deleted_at: "now()"}) {
    returning {
      id
    }
  }
}
    `;

export function useDeleteHpsBoltOnDischargesMutation() {
  return Urql.useMutation<DeleteHpsBoltOnDischargesMutation, DeleteHpsBoltOnDischargesMutationVariables>(DeleteHpsBoltOnDischargesDocument);
};
export const RestoreHpsBoltOnDischargesDocument = gql`
    mutation RestoreHpsBoltOnDischarges($where: bolt_on_discharges_bool_exp!) {
  update_bolt_on_discharges(where: $where, _set: {deleted_at: null}) {
    returning {
      id
    }
  }
}
    `;

export function useRestoreHpsBoltOnDischargesMutation() {
  return Urql.useMutation<RestoreHpsBoltOnDischargesMutation, RestoreHpsBoltOnDischargesMutationVariables>(RestoreHpsBoltOnDischargesDocument);
};
export const UpdateHpsBoltOnDischargeByPkDocument = gql`
    mutation UpdateHpsBoltOnDischargeByPk($object: bolt_on_discharges_set_input, $id: uuid!) {
  update_bolt_on_discharges_by_pk(pk_columns: {id: $id}, _set: $object) {
    ...HpsBoltOnDischargesAllFields
  }
}
    ${HpsBoltOnDischargesAllFieldsFragmentDoc}`;

export function useUpdateHpsBoltOnDischargeByPkMutation() {
  return Urql.useMutation<UpdateHpsBoltOnDischargeByPkMutation, UpdateHpsBoltOnDischargeByPkMutationVariables>(UpdateHpsBoltOnDischargeByPkDocument);
};
export const InsertHpsBoltOnDischargeDocument = gql`
    mutation InsertHpsBoltOnDischarge($object: bolt_on_discharges_insert_input!) {
  insert_bolt_on_discharges_one(object: $object) {
    ...HpsBoltOnDischargesInsertFields
  }
}
    ${HpsBoltOnDischargesInsertFieldsFragmentDoc}`;

export function useInsertHpsBoltOnDischargeMutation() {
  return Urql.useMutation<InsertHpsBoltOnDischargeMutation, InsertHpsBoltOnDischargeMutationVariables>(InsertHpsBoltOnDischargeDocument);
};
export const HpsIntakesBaseDocument = gql`
    query HpsIntakesBase($limit: Int, $offset: Int, $where: intakes_bool_exp, $order_by: [intakes_order_by!]) {
  intakes(limit: $limit, offset: $offset, where: $where, order_by: $order_by) {
    ...IntakesBaseFields
  }
  intakes_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    ${IntakesBaseFieldsFragmentDoc}`;

export function useHpsIntakesBaseQuery(options: Omit<Urql.UseQueryArgs<never, HpsIntakesBaseQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<HpsIntakesBaseQuery>({ query: HpsIntakesBaseDocument, ...options });
};
export const HpsIntakesDocument = gql`
    query HpsIntakes($limit: Int, $offset: Int, $where: intakes_bool_exp, $order_by: [intakes_order_by!]) {
  intakes(limit: $limit, offset: $offset, where: $where, order_by: $order_by) {
    ...IntakesAllFields
  }
  intakes_aggregate(where: $where) {
    id: __typename
    aggregate {
      id: __typename
      count
    }
  }
}
    ${IntakesAllFieldsFragmentDoc}`;

export function useHpsIntakesQuery(options: Omit<Urql.UseQueryArgs<never, HpsIntakesQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<HpsIntakesQuery>({ query: HpsIntakesDocument, ...options });
};
export const HpsIntakesSubDocument = gql`
    subscription HpsIntakesSub($limit: Int, $offset: Int, $where: intakes_bool_exp, $order_by: [intakes_order_by!]) {
  intakes(limit: $limit, offset: $offset, where: $where, order_by: $order_by) {
    ...IntakesAllFields
  }
}
    ${IntakesAllFieldsFragmentDoc}`;

export function useHpsIntakesSubSubscription<R = HpsIntakesSubSubscription>(options: Omit<Urql.UseSubscriptionArgs<never, HpsIntakesSubSubscriptionVariables>, 'query'> = {}, handler?: Urql.SubscriptionHandlerArg<HpsIntakesSubSubscription, R>) {
  return Urql.useSubscription<HpsIntakesSubSubscription, R, HpsIntakesSubSubscriptionVariables>({ query: HpsIntakesSubDocument, ...options }, handler);
};
export const DeleteHpsIntakesDocument = gql`
    mutation DeleteHpsIntakes($where: intakes_bool_exp!) {
  update_intakes(where: $where, _set: {deleted_at: "now()"}) {
    returning {
      id
    }
  }
}
    `;

export function useDeleteHpsIntakesMutation() {
  return Urql.useMutation<DeleteHpsIntakesMutation, DeleteHpsIntakesMutationVariables>(DeleteHpsIntakesDocument);
};
export const RestoreHpsIntakesDocument = gql`
    mutation RestoreHpsIntakes($where: intakes_bool_exp!) {
  update_intakes(where: $where, _set: {deleted_at: null}) {
    returning {
      id
    }
  }
}
    `;

export function useRestoreHpsIntakesMutation() {
  return Urql.useMutation<RestoreHpsIntakesMutation, RestoreHpsIntakesMutationVariables>(RestoreHpsIntakesDocument);
};
export const InsertHpsIntakeDocument = gql`
    mutation InsertHpsIntake($object: intakes_insert_input!) {
  insert_intakes_one(object: $object) {
    ...IntakesAllFields
  }
}
    ${IntakesAllFieldsFragmentDoc}`;

export function useInsertHpsIntakeMutation() {
  return Urql.useMutation<InsertHpsIntakeMutation, InsertHpsIntakeMutationVariables>(InsertHpsIntakeDocument);
};
export const UpdateHpsIntakeByPkDocument = gql`
    mutation UpdateHpsIntakeByPk($id: uuid!, $object: intakes_set_input!) {
  update_intakes_by_pk(pk_columns: {id: $id}, _set: $object) {
    ...IntakesAllFields
  }
}
    ${IntakesAllFieldsFragmentDoc}`;

export function useUpdateHpsIntakeByPkMutation() {
  return Urql.useMutation<UpdateHpsIntakeByPkMutation, UpdateHpsIntakeByPkMutationVariables>(UpdateHpsIntakeByPkDocument);
};
export const HpsMotorsBaseDocument = gql`
    query HpsMotorsBase($limit: Int, $offset: Int, $where: motors_bool_exp, $order_by: [motors_order_by!]) {
  motors(limit: $limit, offset: $offset, where: $where, order_by: $order_by) {
    ...HpsMotorsBaseFields
  }
  motors_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    ${HpsMotorsBaseFieldsFragmentDoc}`;

export function useHpsMotorsBaseQuery(options: Omit<Urql.UseQueryArgs<never, HpsMotorsBaseQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<HpsMotorsBaseQuery>({ query: HpsMotorsBaseDocument, ...options });
};
export const HpsMotorsDocument = gql`
    query HpsMotors($limit: Int, $offset: Int, $where: motors_bool_exp, $order_by: [motors_order_by!]) {
  motors(limit: $limit, offset: $offset, where: $where, order_by: $order_by) {
    ...HpsMotorsAllFields
  }
  motors_aggregate(where: $where) {
    id: __typename
    aggregate {
      id: __typename
      count
    }
  }
}
    ${HpsMotorsAllFieldsFragmentDoc}`;

export function useHpsMotorsQuery(options: Omit<Urql.UseQueryArgs<never, HpsMotorsQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<HpsMotorsQuery>({ query: HpsMotorsDocument, ...options });
};
export const HpsMotorsSubDocument = gql`
    subscription HpsMotorsSub($limit: Int, $offset: Int, $where: motors_bool_exp, $order_by: [motors_order_by!]) {
  motors(limit: $limit, offset: $offset, where: $where, order_by: $order_by) {
    ...HpsMotorsAllFields
  }
}
    ${HpsMotorsAllFieldsFragmentDoc}`;

export function useHpsMotorsSubSubscription<R = HpsMotorsSubSubscription>(options: Omit<Urql.UseSubscriptionArgs<never, HpsMotorsSubSubscriptionVariables>, 'query'> = {}, handler?: Urql.SubscriptionHandlerArg<HpsMotorsSubSubscription, R>) {
  return Urql.useSubscription<HpsMotorsSubSubscription, R, HpsMotorsSubSubscriptionVariables>({ query: HpsMotorsSubDocument, ...options }, handler);
};
export const DeleteHpsMotorsDocument = gql`
    mutation DeleteHpsMotors($where: motors_bool_exp!) {
  update_motors(where: $where, _set: {deleted_at: "now()"}) {
    returning {
      id
    }
  }
}
    `;

export function useDeleteHpsMotorsMutation() {
  return Urql.useMutation<DeleteHpsMotorsMutation, DeleteHpsMotorsMutationVariables>(DeleteHpsMotorsDocument);
};
export const RestoreHpsMotorsDocument = gql`
    mutation RestoreHpsMotors($where: motors_bool_exp!) {
  update_motors(where: $where, _set: {deleted_at: null}) {
    returning {
      id
    }
  }
}
    `;

export function useRestoreHpsMotorsMutation() {
  return Urql.useMutation<RestoreHpsMotorsMutation, RestoreHpsMotorsMutationVariables>(RestoreHpsMotorsDocument);
};
export const UpdateHpsMotorByPkDocument = gql`
    mutation UpdateHpsMotorByPk($object: motors_set_input, $id: uuid!) {
  update_motors_by_pk(pk_columns: {id: $id}, _set: $object) {
    ...HpsMotorsAllFields
  }
}
    ${HpsMotorsAllFieldsFragmentDoc}`;

export function useUpdateHpsMotorByPkMutation() {
  return Urql.useMutation<UpdateHpsMotorByPkMutation, UpdateHpsMotorByPkMutationVariables>(UpdateHpsMotorByPkDocument);
};
export const InsertHpsMotorDocument = gql`
    mutation InsertHpsMotor($object: motors_insert_input!) {
  insert_motors_one(object: $object) {
    ...HpsMotorsInsertFields
  }
}
    ${HpsMotorsInsertFieldsFragmentDoc}`;

export function useInsertHpsMotorMutation() {
  return Urql.useMutation<InsertHpsMotorMutation, InsertHpsMotorMutationVariables>(InsertHpsMotorDocument);
};
export const IntakesBaseDocument = gql`
    query IntakesBase($limit: Int, $offset: Int, $where: intakes_bool_exp, $order_by: [intakes_order_by!]) {
  intakes(limit: $limit, offset: $offset, where: $where, order_by: $order_by) {
    ...IntakesBaseFields
  }
  intakes_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    ${IntakesBaseFieldsFragmentDoc}`;

export function useIntakesBaseQuery(options: Omit<Urql.UseQueryArgs<never, IntakesBaseQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<IntakesBaseQuery>({ query: IntakesBaseDocument, ...options });
};
export const IntakesDocument = gql`
    query Intakes($limit: Int, $offset: Int, $where: intakes_bool_exp, $order_by: [intakes_order_by!]) {
  intakes(limit: $limit, offset: $offset, where: $where, order_by: $order_by) {
    ...IntakesAllFields
  }
  intakes_aggregate(where: $where) {
    id: __typename
    aggregate {
      id: __typename
      count
    }
  }
}
    ${IntakesAllFieldsFragmentDoc}`;

export function useIntakesQuery(options: Omit<Urql.UseQueryArgs<never, IntakesQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<IntakesQuery>({ query: IntakesDocument, ...options });
};
export const IntakesSubDocument = gql`
    subscription IntakesSub($limit: Int, $offset: Int, $where: intakes_bool_exp, $order_by: [intakes_order_by!]) {
  intakes(limit: $limit, offset: $offset, where: $where, order_by: $order_by) {
    ...IntakesAllFields
  }
}
    ${IntakesAllFieldsFragmentDoc}`;

export function useIntakesSubSubscription<R = IntakesSubSubscription>(options: Omit<Urql.UseSubscriptionArgs<never, IntakesSubSubscriptionVariables>, 'query'> = {}, handler?: Urql.SubscriptionHandlerArg<IntakesSubSubscription, R>) {
  return Urql.useSubscription<IntakesSubSubscription, R, IntakesSubSubscriptionVariables>({ query: IntakesSubDocument, ...options }, handler);
};
export const DeleteIntakesDocument = gql`
    mutation DeleteIntakes($where: intakes_bool_exp!) {
  update_intakes(where: $where, _set: {deleted_at: "now()"}) {
    returning {
      id
    }
  }
}
    `;

export function useDeleteIntakesMutation() {
  return Urql.useMutation<DeleteIntakesMutation, DeleteIntakesMutationVariables>(DeleteIntakesDocument);
};
export const RestoreIntakesDocument = gql`
    mutation RestoreIntakes($where: intakes_bool_exp!) {
  update_intakes(where: $where, _set: {deleted_at: null}) {
    returning {
      id
    }
  }
}
    `;

export function useRestoreIntakesMutation() {
  return Urql.useMutation<RestoreIntakesMutation, RestoreIntakesMutationVariables>(RestoreIntakesDocument);
};
export const InsertIntakeDocument = gql`
    mutation InsertIntake($object: intakes_insert_input!) {
  insert_intakes_one(object: $object) {
    ...IntakesAllFields
  }
}
    ${IntakesAllFieldsFragmentDoc}`;

export function useInsertIntakeMutation() {
  return Urql.useMutation<InsertIntakeMutation, InsertIntakeMutationVariables>(InsertIntakeDocument);
};
export const UpdateIntakeByPkDocument = gql`
    mutation UpdateIntakeByPk($id: uuid!, $object: intakes_set_input!) {
  update_intakes_by_pk(pk_columns: {id: $id}, _set: $object) {
    ...IntakesAllFields
  }
}
    ${IntakesAllFieldsFragmentDoc}`;

export function useUpdateIntakeByPkMutation() {
  return Urql.useMutation<UpdateIntakeByPkMutation, UpdateIntakeByPkMutationVariables>(UpdateIntakeByPkDocument);
};
export const MotorLeadExtensionsBaseDocument = gql`
    query MotorLeadExtensionsBase($limit: Int, $offset: Int, $where: motor_lead_extensions_bool_exp, $order_by: [motor_lead_extensions_order_by!]) {
  motor_lead_extensions(
    limit: $limit
    offset: $offset
    where: $where
    order_by: $order_by
  ) {
    ...MleBaseFields
  }
  motor_lead_extensions_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    ${MleBaseFieldsFragmentDoc}`;

export function useMotorLeadExtensionsBaseQuery(options: Omit<Urql.UseQueryArgs<never, MotorLeadExtensionsBaseQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<MotorLeadExtensionsBaseQuery>({ query: MotorLeadExtensionsBaseDocument, ...options });
};
export const MotorLeadExtensionsDocument = gql`
    query MotorLeadExtensions($limit: Int, $offset: Int, $where: motor_lead_extensions_bool_exp, $order_by: [motor_lead_extensions_order_by!]) {
  motor_lead_extensions(
    limit: $limit
    offset: $offset
    where: $where
    order_by: $order_by
  ) {
    ...MleAllFields
  }
  motor_lead_extensions_aggregate(where: $where) {
    id: __typename
    aggregate {
      id: __typename
      count
    }
  }
}
    ${MleAllFieldsFragmentDoc}`;

export function useMotorLeadExtensionsQuery(options: Omit<Urql.UseQueryArgs<never, MotorLeadExtensionsQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<MotorLeadExtensionsQuery>({ query: MotorLeadExtensionsDocument, ...options });
};
export const DeleteMlesDocument = gql`
    mutation DeleteMles($where: motor_lead_extensions_bool_exp!) {
  update_motor_lead_extensions(where: $where, _set: {deleted_at: "now()"}) {
    returning {
      id
    }
  }
}
    `;

export function useDeleteMlesMutation() {
  return Urql.useMutation<DeleteMlesMutation, DeleteMlesMutationVariables>(DeleteMlesDocument);
};
export const RestoreMlesDocument = gql`
    mutation RestoreMles($where: motor_lead_extensions_bool_exp!) {
  update_motor_lead_extensions(where: $where, _set: {deleted_at: null}) {
    returning {
      id
    }
  }
}
    `;

export function useRestoreMlesMutation() {
  return Urql.useMutation<RestoreMlesMutation, RestoreMlesMutationVariables>(RestoreMlesDocument);
};
export const InsertMleDocument = gql`
    mutation InsertMle($object: motor_lead_extensions_insert_input!) {
  insert_motor_lead_extensions_one(object: $object) {
    ...MleAllFields
  }
}
    ${MleAllFieldsFragmentDoc}`;

export function useInsertMleMutation() {
  return Urql.useMutation<InsertMleMutation, InsertMleMutationVariables>(InsertMleDocument);
};
export const UpdateMleByPkDocument = gql`
    mutation UpdateMleByPk($id: uuid!, $object: motor_lead_extensions_set_input!) {
  update_motor_lead_extensions_by_pk(pk_columns: {id: $id}, _set: $object) {
    ...MleAllFields
  }
}
    ${MleAllFieldsFragmentDoc}`;

export function useUpdateMleByPkMutation() {
  return Urql.useMutation<UpdateMleByPkMutation, UpdateMleByPkMutationVariables>(UpdateMleByPkDocument);
};
export const MotorLeadExtensionsSubDocument = gql`
    subscription MotorLeadExtensionsSub($limit: Int, $offset: Int, $where: motor_lead_extensions_bool_exp, $order_by: [motor_lead_extensions_order_by!]) {
  motor_lead_extensions(
    limit: $limit
    offset: $offset
    where: $where
    order_by: $order_by
  ) {
    ...MleAllFields
  }
}
    ${MleAllFieldsFragmentDoc}`;

export function useMotorLeadExtensionsSubSubscription<R = MotorLeadExtensionsSubSubscription>(options: Omit<Urql.UseSubscriptionArgs<never, MotorLeadExtensionsSubSubscriptionVariables>, 'query'> = {}, handler?: Urql.SubscriptionHandlerArg<MotorLeadExtensionsSubSubscription, R>) {
  return Urql.useSubscription<MotorLeadExtensionsSubSubscription, R, MotorLeadExtensionsSubSubscriptionVariables>({ query: MotorLeadExtensionsSubDocument, ...options }, handler);
};
export const MotorsBaseDocument = gql`
    query MotorsBase($limit: Int, $offset: Int, $where: motors_bool_exp, $order_by: [motors_order_by!]) {
  motors(limit: $limit, offset: $offset, where: $where, order_by: $order_by) {
    ...MotorsBaseFields
  }
  motors_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    ${MotorsBaseFieldsFragmentDoc}`;

export function useMotorsBaseQuery(options: Omit<Urql.UseQueryArgs<never, MotorsBaseQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<MotorsBaseQuery>({ query: MotorsBaseDocument, ...options });
};
export const MotorsDocument = gql`
    query Motors($limit: Int, $offset: Int, $where: motors_bool_exp, $order_by: [motors_order_by!]) {
  motors(limit: $limit, offset: $offset, where: $where, order_by: $order_by) {
    ...MotorsAllFields
  }
  motors_aggregate(where: $where) {
    id: __typename
    aggregate {
      id: __typename
      count
    }
  }
}
    ${MotorsAllFieldsFragmentDoc}`;

export function useMotorsQuery(options: Omit<Urql.UseQueryArgs<never, MotorsQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<MotorsQuery>({ query: MotorsDocument, ...options });
};
export const MotorsSubDocument = gql`
    subscription MotorsSub($limit: Int, $offset: Int, $where: motors_bool_exp, $order_by: [motors_order_by!]) {
  motors(limit: $limit, offset: $offset, where: $where, order_by: $order_by) {
    ...MotorsAllFields
  }
}
    ${MotorsAllFieldsFragmentDoc}`;

export function useMotorsSubSubscription<R = MotorsSubSubscription>(options: Omit<Urql.UseSubscriptionArgs<never, MotorsSubSubscriptionVariables>, 'query'> = {}, handler?: Urql.SubscriptionHandlerArg<MotorsSubSubscription, R>) {
  return Urql.useSubscription<MotorsSubSubscription, R, MotorsSubSubscriptionVariables>({ query: MotorsSubDocument, ...options }, handler);
};
export const DeleteMotorsDocument = gql`
    mutation DeleteMotors($where: motors_bool_exp!) {
  update_motors(where: $where, _set: {deleted_at: "now()"}) {
    returning {
      id
    }
  }
}
    `;

export function useDeleteMotorsMutation() {
  return Urql.useMutation<DeleteMotorsMutation, DeleteMotorsMutationVariables>(DeleteMotorsDocument);
};
export const RestoreMotorsDocument = gql`
    mutation RestoreMotors($where: motors_bool_exp!) {
  update_motors(where: $where, _set: {deleted_at: null}) {
    returning {
      id
    }
  }
}
    `;

export function useRestoreMotorsMutation() {
  return Urql.useMutation<RestoreMotorsMutation, RestoreMotorsMutationVariables>(RestoreMotorsDocument);
};
export const UpdateMotorByPkDocument = gql`
    mutation UpdateMotorByPk($object: motors_set_input, $id: uuid!) {
  update_motors_by_pk(pk_columns: {id: $id}, _set: $object) {
    ...MotorsAllFields
  }
}
    ${MotorsAllFieldsFragmentDoc}`;

export function useUpdateMotorByPkMutation() {
  return Urql.useMutation<UpdateMotorByPkMutation, UpdateMotorByPkMutationVariables>(UpdateMotorByPkDocument);
};
export const InsertMotorDocument = gql`
    mutation InsertMotor($object: motors_insert_input!) {
  insert_motors_one(object: $object) {
    ...MotorsInsertFields
  }
}
    ${MotorsInsertFieldsFragmentDoc}`;

export function useInsertMotorMutation() {
  return Urql.useMutation<InsertMotorMutation, InsertMotorMutationVariables>(InsertMotorDocument);
};
export const PumpsBaseDocument = gql`
    query PumpsBase($limit: Int, $offset: Int, $where: pumps_bool_exp, $order_by: [pumps_order_by!]) {
  pumps(limit: $limit, offset: $offset, where: $where, order_by: $order_by) {
    ...PumpsBaseFields
  }
  pumps_aggregate(where: $where) {
    id: __typename
    aggregate {
      id: __typename
      count
    }
  }
}
    ${PumpsBaseFieldsFragmentDoc}`;

export function usePumpsBaseQuery(options: Omit<Urql.UseQueryArgs<never, PumpsBaseQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<PumpsBaseQuery>({ query: PumpsBaseDocument, ...options });
};
export const PumpsDocument = gql`
    query Pumps($limit: Int, $offset: Int, $where: pumps_bool_exp, $order_by: [pumps_order_by!], $include_housings: Boolean = true) {
  pumps(limit: $limit, offset: $offset, where: $where, order_by: $order_by) {
    ...PumpsAllFields
    r_housings: housings(
      where: {deleted_at: {_is_null: true}}
      order_by: {housing_number: asc}
    ) @include(if: $include_housings) {
      ...HousingsAllFields
    }
  }
  pumps_aggregate(where: $where) {
    id: __typename
    aggregate {
      id: __typename
      count
    }
  }
}
    ${PumpsAllFieldsFragmentDoc}
${HousingsAllFieldsFragmentDoc}`;

export function usePumpsQuery(options: Omit<Urql.UseQueryArgs<never, PumpsQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<PumpsQuery>({ query: PumpsDocument, ...options });
};
export const PumpsSubDocument = gql`
    subscription PumpsSub($limit: Int, $offset: Int, $where: pumps_bool_exp, $order_by: [pumps_order_by!]) {
  pumps(limit: $limit, offset: $offset, where: $where, order_by: $order_by) {
    ...PumpsAllFields
  }
}
    ${PumpsAllFieldsFragmentDoc}`;

export function usePumpsSubSubscription<R = PumpsSubSubscription>(options: Omit<Urql.UseSubscriptionArgs<never, PumpsSubSubscriptionVariables>, 'query'> = {}, handler?: Urql.SubscriptionHandlerArg<PumpsSubSubscription, R>) {
  return Urql.useSubscription<PumpsSubSubscription, R, PumpsSubSubscriptionVariables>({ query: PumpsSubDocument, ...options }, handler);
};
export const DeletePumpsDocument = gql`
    mutation DeletePumps($where: pumps_bool_exp!) {
  update_pumps(where: $where, _set: {deleted_at: "now()"}) {
    returning {
      id
    }
  }
}
    `;

export function useDeletePumpsMutation() {
  return Urql.useMutation<DeletePumpsMutation, DeletePumpsMutationVariables>(DeletePumpsDocument);
};
export const RestorePumpsDocument = gql`
    mutation RestorePumps($where: pumps_bool_exp!) {
  update_pumps(where: $where, _set: {deleted_at: null}) {
    returning {
      id
    }
  }
}
    `;

export function useRestorePumpsMutation() {
  return Urql.useMutation<RestorePumpsMutation, RestorePumpsMutationVariables>(RestorePumpsDocument);
};
export const InsertPumpDocument = gql`
    mutation InsertPump($object: pumps_insert_input!) {
  insert_pumps_one(object: $object) {
    ...PumpsInsertFields
  }
}
    ${PumpsInsertFieldsFragmentDoc}`;

export function useInsertPumpMutation() {
  return Urql.useMutation<InsertPumpMutation, InsertPumpMutationVariables>(InsertPumpDocument);
};
export const UpdatePumpByPkDocument = gql`
    mutation UpdatePumpByPk($id: uuid!, $object: pumps_set_input!) {
  update_pumps_by_pk(pk_columns: {id: $id}, _set: $object) {
    ...PumpsInsertFields
  }
}
    ${PumpsInsertFieldsFragmentDoc}`;

export function useUpdatePumpByPkMutation() {
  return Urql.useMutation<UpdatePumpByPkMutation, UpdatePumpByPkMutationVariables>(UpdatePumpByPkDocument);
};
export const SealsBaseDocument = gql`
    query SealsBase($limit: Int, $offset: Int, $where: seals_bool_exp, $order_by: [seals_order_by!]) {
  seals(limit: $limit, offset: $offset, where: $where, order_by: $order_by) {
    ...SealsBaseFields
  }
  seals_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    ${SealsBaseFieldsFragmentDoc}`;

export function useSealsBaseQuery(options: Omit<Urql.UseQueryArgs<never, SealsBaseQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<SealsBaseQuery>({ query: SealsBaseDocument, ...options });
};
export const SealThrustChambersDocument = gql`
    query SealThrustChambers($limit: Int, $offset: Int, $where: seals_bool_exp, $order_by: [seals_order_by!]) {
  seals(limit: $limit, offset: $offset, where: $where, order_by: $order_by) {
    ...SealsAllFields
  }
  seals_aggregate(where: $where) {
    id: __typename
    aggregate {
      id: __typename
      count
    }
  }
}
    ${SealsAllFieldsFragmentDoc}`;

export function useSealThrustChambersQuery(options: Omit<Urql.UseQueryArgs<never, SealThrustChambersQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<SealThrustChambersQuery>({ query: SealThrustChambersDocument, ...options });
};
export const DeleteSealsDocument = gql`
    mutation DeleteSeals($where: seals_bool_exp!) {
  update_seals(where: $where, _set: {deleted_at: "now()"}) {
    returning {
      id
    }
  }
}
    `;

export function useDeleteSealsMutation() {
  return Urql.useMutation<DeleteSealsMutation, DeleteSealsMutationVariables>(DeleteSealsDocument);
};
export const RestoreSealsDocument = gql`
    mutation RestoreSeals($where: seals_bool_exp!) {
  update_seals(where: $where, _set: {deleted_at: null}) {
    returning {
      id
    }
  }
}
    `;

export function useRestoreSealsMutation() {
  return Urql.useMutation<RestoreSealsMutation, RestoreSealsMutationVariables>(RestoreSealsDocument);
};
export const InsertSealDocument = gql`
    mutation InsertSeal($object: seals_insert_input!) {
  insert_seals_one(object: $object) {
    ...SealsAllFields
  }
}
    ${SealsAllFieldsFragmentDoc}`;

export function useInsertSealMutation() {
  return Urql.useMutation<InsertSealMutation, InsertSealMutationVariables>(InsertSealDocument);
};
export const UpdateSealByPkDocument = gql`
    mutation UpdateSealByPk($id: uuid!, $object: seals_set_input!) {
  update_seals_by_pk(pk_columns: {id: $id}, _set: $object) {
    ...SealsAllFields
  }
}
    ${SealsAllFieldsFragmentDoc}`;

export function useUpdateSealByPkMutation() {
  return Urql.useMutation<UpdateSealByPkMutation, UpdateSealByPkMutationVariables>(UpdateSealByPkDocument);
};
export const SealsSubDocument = gql`
    subscription SealsSub($limit: Int, $offset: Int, $where: seals_bool_exp, $order_by: [seals_order_by!]) {
  seals(limit: $limit, offset: $offset, where: $where, order_by: $order_by) {
    ...SealsAllFields
  }
}
    ${SealsAllFieldsFragmentDoc}`;

export function useSealsSubSubscription<R = SealsSubSubscription>(options: Omit<Urql.UseSubscriptionArgs<never, SealsSubSubscriptionVariables>, 'query'> = {}, handler?: Urql.SubscriptionHandlerArg<SealsSubSubscription, R>) {
  return Urql.useSubscription<SealsSubSubscription, R, SealsSubSubscriptionVariables>({ query: SealsSubDocument, ...options }, handler);
};
export const SealMotorOilDocument = gql`
    query SealMotorOil($limit: Int, $offset: Int, $where: seal_motor_oil_bool_exp, $order_by: [seal_motor_oil_order_by!]) {
  seal_motor_oil(
    limit: $limit
    offset: $offset
    where: $where
    order_by: $order_by
  ) {
    ...SealMotorOilAllFields
  }
  seal_motor_oil_aggregate(where: $where) {
    id: __typename
    aggregate {
      id: __typename
      count
    }
  }
}
    ${SealMotorOilAllFieldsFragmentDoc}`;

export function useSealMotorOilQuery(options: Omit<Urql.UseQueryArgs<never, SealMotorOilQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<SealMotorOilQuery>({ query: SealMotorOilDocument, ...options });
};
export const InsertSealMotorOilDocument = gql`
    mutation InsertSealMotorOil($object: seal_motor_oil_insert_input!) {
  insert_seal_motor_oil_one(object: $object) {
    ...SealMotorOilAllFields
  }
}
    ${SealMotorOilAllFieldsFragmentDoc}`;

export function useInsertSealMotorOilMutation() {
  return Urql.useMutation<InsertSealMotorOilMutation, InsertSealMotorOilMutationVariables>(InsertSealMotorOilDocument);
};
export const UpdateSealMotorOilDocument = gql`
    mutation UpdateSealMotorOil($id: uuid!, $object: seal_motor_oil_set_input!) {
  update_seal_motor_oil_by_pk(pk_columns: {id: $id}, _set: $object) {
    ...SealMotorOilAllFields
  }
}
    ${SealMotorOilAllFieldsFragmentDoc}`;

export function useUpdateSealMotorOilMutation() {
  return Urql.useMutation<UpdateSealMotorOilMutation, UpdateSealMotorOilMutationVariables>(UpdateSealMotorOilDocument);
};
export const DeleteSealMotorOilsDocument = gql`
    mutation DeleteSealMotorOils($where: seal_motor_oil_bool_exp!) {
  update_seal_motor_oil(where: $where, _set: {deleted_at: "now()"}) {
    returning {
      id
    }
    affected_rows
  }
}
    `;

export function useDeleteSealMotorOilsMutation() {
  return Urql.useMutation<DeleteSealMotorOilsMutation, DeleteSealMotorOilsMutationVariables>(DeleteSealMotorOilsDocument);
};
export const RestoreSealMotorOilsDocument = gql`
    mutation RestoreSealMotorOils($where: seal_motor_oil_bool_exp!) {
  update_seal_motor_oil(where: $where, _set: {deleted_at: null}) {
    returning {
      id
    }
    affected_rows
  }
}
    `;

export function useRestoreSealMotorOilsMutation() {
  return Urql.useMutation<RestoreSealMotorOilsMutation, RestoreSealMotorOilsMutationVariables>(RestoreSealMotorOilsDocument);
};
export const SealsDocument = gql`
    query Seals($limit: Int, $offset: Int, $where: seals_bool_exp, $order_by: [seals_order_by!]) {
  seals(limit: $limit, offset: $offset, where: $where, order_by: $order_by) {
    ...SealsAllFields
  }
  seals_aggregate(where: $where) {
    id: __typename
    aggregate {
      id: __typename
      count
    }
  }
}
    ${SealsAllFieldsFragmentDoc}`;

export function useSealsQuery(options: Omit<Urql.UseQueryArgs<never, SealsQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<SealsQuery>({ query: SealsDocument, ...options });
};
export const SensorsBaseDocument = gql`
    query SensorsBase($limit: Int, $offset: Int, $where: sensors_bool_exp, $order_by: [sensors_order_by!]) {
  sensors(limit: $limit, offset: $offset, where: $where, order_by: $order_by) {
    ...SensorsBaseFields
  }
  sensors_aggregate(where: $where) {
    id: __typename
    aggregate {
      id: __typename
      count
    }
  }
}
    ${SensorsBaseFieldsFragmentDoc}`;

export function useSensorsBaseQuery(options: Omit<Urql.UseQueryArgs<never, SensorsBaseQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<SensorsBaseQuery>({ query: SensorsBaseDocument, ...options });
};
export const SensorsDocument = gql`
    query Sensors($limit: Int, $offset: Int, $where: sensors_bool_exp, $order_by: [sensors_order_by!]) {
  sensors(limit: $limit, offset: $offset, where: $where, order_by: $order_by) {
    ...SensorsAllFields
  }
  sensors_aggregate(where: $where) {
    id: __typename
    aggregate {
      id: __typename
      count
    }
  }
}
    ${SensorsAllFieldsFragmentDoc}`;

export function useSensorsQuery(options: Omit<Urql.UseQueryArgs<never, SensorsQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<SensorsQuery>({ query: SensorsDocument, ...options });
};
export const SensorsSubDocument = gql`
    subscription SensorsSub($limit: Int, $offset: Int, $where: sensors_bool_exp, $order_by: [sensors_order_by!]) {
  sensors(limit: $limit, offset: $offset, where: $where, order_by: $order_by) {
    ...SensorsAllFields
  }
}
    ${SensorsAllFieldsFragmentDoc}`;

export function useSensorsSubSubscription<R = SensorsSubSubscription>(options: Omit<Urql.UseSubscriptionArgs<never, SensorsSubSubscriptionVariables>, 'query'> = {}, handler?: Urql.SubscriptionHandlerArg<SensorsSubSubscription, R>) {
  return Urql.useSubscription<SensorsSubSubscription, R, SensorsSubSubscriptionVariables>({ query: SensorsSubDocument, ...options }, handler);
};
export const DeleteSensorsDocument = gql`
    mutation DeleteSensors($where: sensors_bool_exp!) {
  update_sensors(where: $where, _set: {deleted_at: "now()"}) {
    returning {
      id
    }
  }
}
    `;

export function useDeleteSensorsMutation() {
  return Urql.useMutation<DeleteSensorsMutation, DeleteSensorsMutationVariables>(DeleteSensorsDocument);
};
export const UpdateSensorDocument = gql`
    mutation UpdateSensor($object: sensors_set_input, $id: uuid!) {
  update_sensors_by_pk(pk_columns: {id: $id}, _set: $object) {
    ...SensorsAllFields
  }
}
    ${SensorsAllFieldsFragmentDoc}`;

export function useUpdateSensorMutation() {
  return Urql.useMutation<UpdateSensorMutation, UpdateSensorMutationVariables>(UpdateSensorDocument);
};
export const RestoreSensorsDocument = gql`
    mutation RestoreSensors($where: sensors_bool_exp!) {
  update_sensors(where: $where, _set: {deleted_at: null}) {
    returning {
      id
    }
  }
}
    `;

export function useRestoreSensorsMutation() {
  return Urql.useMutation<RestoreSensorsMutation, RestoreSensorsMutationVariables>(RestoreSensorsDocument);
};
export const InsertSensorDocument = gql`
    mutation InsertSensor($object: sensors_insert_input!) {
  insert_sensors_one(object: $object) {
    ...SensorsInsertFields
  }
}
    ${SensorsInsertFieldsFragmentDoc}`;

export function useInsertSensorMutation() {
  return Urql.useMutation<InsertSensorMutation, InsertSensorMutationVariables>(InsertSensorDocument);
};
export const StepDownTransformersBaseDocument = gql`
    query StepDownTransformersBase($limit: Int, $offset: Int, $where: step_down_transformers_bool_exp, $order_by: [step_down_transformers_order_by!]) {
  step_down_transformers(
    limit: $limit
    offset: $offset
    where: $where
    order_by: $order_by
  ) {
    ...StepDownTransformersBaseFields
  }
  step_down_transformers_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    ${StepDownTransformersBaseFieldsFragmentDoc}`;

export function useStepDownTransformersBaseQuery(options: Omit<Urql.UseQueryArgs<never, StepDownTransformersBaseQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<StepDownTransformersBaseQuery>({ query: StepDownTransformersBaseDocument, ...options });
};
export const StepDownTransformersDocument = gql`
    query StepDownTransformers($limit: Int, $offset: Int, $where: step_down_transformers_bool_exp, $order_by: [step_down_transformers_order_by!]) {
  step_down_transformers(
    limit: $limit
    offset: $offset
    where: $where
    order_by: $order_by
  ) {
    ...DownTransAllFields
  }
  step_down_transformers_aggregate(where: $where) {
    id: __typename
    aggregate {
      id: __typename
      count
    }
  }
}
    ${DownTransAllFieldsFragmentDoc}`;

export function useStepDownTransformersQuery(options: Omit<Urql.UseQueryArgs<never, StepDownTransformersQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<StepDownTransformersQuery>({ query: StepDownTransformersDocument, ...options });
};
export const DeleteDownTransDocument = gql`
    mutation DeleteDownTrans($where: step_down_transformers_bool_exp!) {
  update_step_down_transformers(where: $where, _set: {deleted_at: "now()"}) {
    returning {
      id
    }
  }
}
    `;

export function useDeleteDownTransMutation() {
  return Urql.useMutation<DeleteDownTransMutation, DeleteDownTransMutationVariables>(DeleteDownTransDocument);
};
export const RestoreDownTransDocument = gql`
    mutation RestoreDownTrans($where: step_down_transformers_bool_exp!) {
  update_step_down_transformers(where: $where, _set: {deleted_at: null}) {
    returning {
      id
    }
  }
}
    `;

export function useRestoreDownTransMutation() {
  return Urql.useMutation<RestoreDownTransMutation, RestoreDownTransMutationVariables>(RestoreDownTransDocument);
};
export const InsertDownTransDocument = gql`
    mutation InsertDownTrans($object: step_down_transformers_insert_input!) {
  insert_step_down_transformers_one(object: $object) {
    ...DownTransAllFields
  }
}
    ${DownTransAllFieldsFragmentDoc}`;

export function useInsertDownTransMutation() {
  return Urql.useMutation<InsertDownTransMutation, InsertDownTransMutationVariables>(InsertDownTransDocument);
};
export const UpdateDownTransByPkDocument = gql`
    mutation UpdateDownTransByPk($id: uuid!, $object: step_down_transformers_set_input!) {
  update_step_down_transformers_by_pk(pk_columns: {id: $id}, _set: $object) {
    ...DownTransAllFields
  }
}
    ${DownTransAllFieldsFragmentDoc}`;

export function useUpdateDownTransByPkMutation() {
  return Urql.useMutation<UpdateDownTransByPkMutation, UpdateDownTransByPkMutationVariables>(UpdateDownTransByPkDocument);
};
export const StepDownTransformersSubDocument = gql`
    subscription StepDownTransformersSub($limit: Int, $offset: Int, $where: step_down_transformers_bool_exp, $order_by: [step_down_transformers_order_by!]) {
  step_down_transformers(
    limit: $limit
    offset: $offset
    where: $where
    order_by: $order_by
  ) {
    ...DownTransAllFields
  }
}
    ${DownTransAllFieldsFragmentDoc}`;

export function useStepDownTransformersSubSubscription<R = StepDownTransformersSubSubscription>(options: Omit<Urql.UseSubscriptionArgs<never, StepDownTransformersSubSubscriptionVariables>, 'query'> = {}, handler?: Urql.SubscriptionHandlerArg<StepDownTransformersSubSubscription, R>) {
  return Urql.useSubscription<StepDownTransformersSubSubscription, R, StepDownTransformersSubSubscriptionVariables>({ query: StepDownTransformersSubDocument, ...options }, handler);
};
export const StepUpTransformersBaseDocument = gql`
    query StepUpTransformersBase($limit: Int, $offset: Int, $where: step_up_transformers_bool_exp, $order_by: [step_up_transformers_order_by!]) {
  step_up_transformers(
    limit: $limit
    offset: $offset
    where: $where
    order_by: $order_by
  ) {
    ...StepUpTransformersBaseFields
  }
  step_up_transformers_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    ${StepUpTransformersBaseFieldsFragmentDoc}`;

export function useStepUpTransformersBaseQuery(options: Omit<Urql.UseQueryArgs<never, StepUpTransformersBaseQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<StepUpTransformersBaseQuery>({ query: StepUpTransformersBaseDocument, ...options });
};
export const StepUpTransformersDocument = gql`
    query StepUpTransformers($limit: Int, $offset: Int, $where: step_up_transformers_bool_exp, $order_by: [step_up_transformers_order_by!]) {
  step_up_transformers(
    limit: $limit
    offset: $offset
    where: $where
    order_by: $order_by
  ) {
    ...UpTransAllFields
  }
  step_up_transformers_aggregate(where: $where) {
    id: __typename
    aggregate {
      id: __typename
      count
    }
  }
}
    ${UpTransAllFieldsFragmentDoc}`;

export function useStepUpTransformersQuery(options: Omit<Urql.UseQueryArgs<never, StepUpTransformersQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<StepUpTransformersQuery>({ query: StepUpTransformersDocument, ...options });
};
export const DeleteUpTransDocument = gql`
    mutation DeleteUpTrans($where: step_up_transformers_bool_exp!) {
  update_step_up_transformers(where: $where, _set: {deleted_at: "now()"}) {
    returning {
      id
    }
  }
}
    `;

export function useDeleteUpTransMutation() {
  return Urql.useMutation<DeleteUpTransMutation, DeleteUpTransMutationVariables>(DeleteUpTransDocument);
};
export const RestoreUpTransDocument = gql`
    mutation RestoreUpTrans($where: step_up_transformers_bool_exp!) {
  update_step_up_transformers(where: $where, _set: {deleted_at: null}) {
    returning {
      id
    }
  }
}
    `;

export function useRestoreUpTransMutation() {
  return Urql.useMutation<RestoreUpTransMutation, RestoreUpTransMutationVariables>(RestoreUpTransDocument);
};
export const InsertUpTransDocument = gql`
    mutation InsertUpTrans($object: step_up_transformers_insert_input!) {
  insert_step_up_transformers_one(object: $object) {
    ...UpTransAllFields
  }
}
    ${UpTransAllFieldsFragmentDoc}`;

export function useInsertUpTransMutation() {
  return Urql.useMutation<InsertUpTransMutation, InsertUpTransMutationVariables>(InsertUpTransDocument);
};
export const UpdateUpTransByPkDocument = gql`
    mutation UpdateUpTransByPk($id: uuid!, $object: step_up_transformers_set_input!) {
  update_step_up_transformers_by_pk(pk_columns: {id: $id}, _set: $object) {
    ...UpTransAllFields
  }
}
    ${UpTransAllFieldsFragmentDoc}`;

export function useUpdateUpTransByPkMutation() {
  return Urql.useMutation<UpdateUpTransByPkMutation, UpdateUpTransByPkMutationVariables>(UpdateUpTransByPkDocument);
};
export const StepUpTransformersSubDocument = gql`
    subscription StepUpTransformersSub($limit: Int, $offset: Int, $where: step_up_transformers_bool_exp, $order_by: [step_up_transformers_order_by!]) {
  step_up_transformers(
    limit: $limit
    offset: $offset
    where: $where
    order_by: $order_by
  ) {
    ...UpTransAllFields
  }
}
    ${UpTransAllFieldsFragmentDoc}`;

export function useStepUpTransformersSubSubscription<R = StepUpTransformersSubSubscription>(options: Omit<Urql.UseSubscriptionArgs<never, StepUpTransformersSubSubscriptionVariables>, 'query'> = {}, handler?: Urql.SubscriptionHandlerArg<StepUpTransformersSubSubscription, R>) {
  return Urql.useSubscription<StepUpTransformersSubSubscription, R, StepUpTransformersSubSubscriptionVariables>({ query: StepUpTransformersSubDocument, ...options }, handler);
};
export const SwitchboardsBaseDocument = gql`
    query SwitchboardsBase($limit: Int, $offset: Int, $where: switchboards_bool_exp, $order_by: [switchboards_order_by!]) {
  switchboards(limit: $limit, offset: $offset, where: $where, order_by: $order_by) {
    ...SwitchboardsBaseFields
  }
  switchboards_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    ${SwitchboardsBaseFieldsFragmentDoc}`;

export function useSwitchboardsBaseQuery(options: Omit<Urql.UseQueryArgs<never, SwitchboardsBaseQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<SwitchboardsBaseQuery>({ query: SwitchboardsBaseDocument, ...options });
};
export const SwitchboardsDocument = gql`
    query Switchboards($limit: Int, $offset: Int, $where: switchboards_bool_exp, $order_by: [switchboards_order_by!]) {
  switchboards(limit: $limit, offset: $offset, where: $where, order_by: $order_by) {
    ...SwitchboardsAllFields
  }
  switchboards_aggregate(where: $where) {
    id: __typename
    aggregate {
      id: __typename
      count
    }
  }
}
    ${SwitchboardsAllFieldsFragmentDoc}`;

export function useSwitchboardsQuery(options: Omit<Urql.UseQueryArgs<never, SwitchboardsQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<SwitchboardsQuery>({ query: SwitchboardsDocument, ...options });
};
export const DeleteSwitchboardsDocument = gql`
    mutation DeleteSwitchboards($where: switchboards_bool_exp!) {
  update_switchboards(where: $where, _set: {deleted_at: "now()"}) {
    returning {
      id
    }
  }
}
    `;

export function useDeleteSwitchboardsMutation() {
  return Urql.useMutation<DeleteSwitchboardsMutation, DeleteSwitchboardsMutationVariables>(DeleteSwitchboardsDocument);
};
export const RestoreSwitchboardsDocument = gql`
    mutation RestoreSwitchboards($where: switchboards_bool_exp!) {
  update_switchboards(where: $where, _set: {deleted_at: null}) {
    returning {
      id
    }
  }
}
    `;

export function useRestoreSwitchboardsMutation() {
  return Urql.useMutation<RestoreSwitchboardsMutation, RestoreSwitchboardsMutationVariables>(RestoreSwitchboardsDocument);
};
export const InsertSwitchboardDocument = gql`
    mutation InsertSwitchboard($object: switchboards_insert_input!) {
  insert_switchboards_one(object: $object) {
    ...SwitchboardsAllFields
  }
}
    ${SwitchboardsAllFieldsFragmentDoc}`;

export function useInsertSwitchboardMutation() {
  return Urql.useMutation<InsertSwitchboardMutation, InsertSwitchboardMutationVariables>(InsertSwitchboardDocument);
};
export const UpdateSwitchboardByPkDocument = gql`
    mutation UpdateSwitchboardByPk($object: switchboards_set_input, $id: uuid!) {
  update_switchboards_by_pk(pk_columns: {id: $id}, _set: $object) {
    ...SwitchboardsAllFields
  }
}
    ${SwitchboardsAllFieldsFragmentDoc}`;

export function useUpdateSwitchboardByPkMutation() {
  return Urql.useMutation<UpdateSwitchboardByPkMutation, UpdateSwitchboardByPkMutationVariables>(UpdateSwitchboardByPkDocument);
};
export const SwitchboardsSubDocument = gql`
    subscription SwitchboardsSub($limit: Int, $offset: Int, $where: switchboards_bool_exp, $order_by: [switchboards_order_by!]) {
  switchboards(limit: $limit, offset: $offset, where: $where, order_by: $order_by) {
    ...SwitchboardsAllFields
  }
}
    ${SwitchboardsAllFieldsFragmentDoc}`;

export function useSwitchboardsSubSubscription<R = SwitchboardsSubSubscription>(options: Omit<Urql.UseSubscriptionArgs<never, SwitchboardsSubSubscriptionVariables>, 'query'> = {}, handler?: Urql.SubscriptionHandlerArg<SwitchboardsSubSubscription, R>) {
  return Urql.useSubscription<SwitchboardsSubSubscription, R, SwitchboardsSubSubscriptionVariables>({ query: SwitchboardsSubDocument, ...options }, handler);
};
export const TubingsBaseDocument = gql`
    query TubingsBase($limit: Int, $offset: Int, $where: tubings_bool_exp, $order_by: [tubings_order_by!]) {
  tubings(limit: $limit, offset: $offset, where: $where, order_by: $order_by) {
    ...TubingsBaseFields
  }
  tubings_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    ${TubingsBaseFieldsFragmentDoc}`;

export function useTubingsBaseQuery(options: Omit<Urql.UseQueryArgs<never, TubingsBaseQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<TubingsBaseQuery>({ query: TubingsBaseDocument, ...options });
};
export const TubingsListDocument = gql`
    query TubingsList($limit: Int, $offset: Int, $where: tubings_bool_exp, $order_by: [tubings_order_by!]) {
  tubings(limit: $limit, offset: $offset, where: $where, order_by: $order_by) {
    ...TubingsAllFields
  }
  tubings_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    ${TubingsAllFieldsFragmentDoc}`;

export function useTubingsListQuery(options: Omit<Urql.UseQueryArgs<never, TubingsListQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<TubingsListQuery>({ query: TubingsListDocument, ...options });
};
export const TubingsDocument = gql`
    query Tubings($limit: Int, $offset: Int, $where: tubings_bool_exp, $order_by: [tubings_order_by!]) {
  tubings(limit: $limit, offset: $offset, where: $where, order_by: $order_by) {
    ...TubingsAllFields
  }
  tubings_aggregate(where: $where) {
    id: __typename
    aggregate {
      id: __typename
      count
    }
  }
}
    ${TubingsAllFieldsFragmentDoc}`;

export function useTubingsQuery(options: Omit<Urql.UseQueryArgs<never, TubingsQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<TubingsQuery>({ query: TubingsDocument, ...options });
};
export const DeleteTubingsDocument = gql`
    mutation DeleteTubings($where: tubings_bool_exp!) {
  update_tubings(where: $where, _set: {deleted_at: "now()"}) {
    returning {
      id
    }
  }
}
    `;

export function useDeleteTubingsMutation() {
  return Urql.useMutation<DeleteTubingsMutation, DeleteTubingsMutationVariables>(DeleteTubingsDocument);
};
export const RestoreTubingsDocument = gql`
    mutation RestoreTubings($where: tubings_bool_exp!) {
  update_tubings(where: $where, _set: {deleted_at: null}) {
    returning {
      id
    }
  }
}
    `;

export function useRestoreTubingsMutation() {
  return Urql.useMutation<RestoreTubingsMutation, RestoreTubingsMutationVariables>(RestoreTubingsDocument);
};
export const InsertTubingDocument = gql`
    mutation InsertTubing($object: tubings_insert_input!) {
  insert_tubings_one(object: $object) {
    ...TubingsAllFields
  }
}
    ${TubingsAllFieldsFragmentDoc}`;

export function useInsertTubingMutation() {
  return Urql.useMutation<InsertTubingMutation, InsertTubingMutationVariables>(InsertTubingDocument);
};
export const UpdateTubingByPkDocument = gql`
    mutation UpdateTubingByPk($object: tubings_set_input, $id: uuid!) {
  update_tubings_by_pk(pk_columns: {id: $id}, _set: $object) {
    ...TubingsAllFields
  }
}
    ${TubingsAllFieldsFragmentDoc}`;

export function useUpdateTubingByPkMutation() {
  return Urql.useMutation<UpdateTubingByPkMutation, UpdateTubingByPkMutationVariables>(UpdateTubingByPkDocument);
};
export const TubingsSubDocument = gql`
    subscription TubingsSub($limit: Int, $offset: Int, $where: tubings_bool_exp, $order_by: [tubings_order_by!]) {
  tubings(limit: $limit, offset: $offset, where: $where, order_by: $order_by) {
    ...TubingsAllFields
  }
}
    ${TubingsAllFieldsFragmentDoc}`;

export function useTubingsSubSubscription<R = TubingsSubSubscription>(options: Omit<Urql.UseSubscriptionArgs<never, TubingsSubSubscriptionVariables>, 'query'> = {}, handler?: Urql.SubscriptionHandlerArg<TubingsSubSubscription, R>) {
  return Urql.useSubscription<TubingsSubSubscription, R, TubingsSubSubscriptionVariables>({ query: TubingsSubDocument, ...options }, handler);
};
export const VsdBaseListDocument = gql`
    query VsdBaseList($limit: Int, $offset: Int, $where: variable_speed_drives_bool_exp, $order_by: [variable_speed_drives_order_by!]) {
  variable_speed_drives(
    limit: $limit
    offset: $offset
    where: $where
    order_by: $order_by
  ) {
    ...VsdBaseFields
  }
  variable_speed_drives_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    ${VsdBaseFieldsFragmentDoc}`;

export function useVsdBaseListQuery(options: Omit<Urql.UseQueryArgs<never, VsdBaseListQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<VsdBaseListQuery>({ query: VsdBaseListDocument, ...options });
};
export const VariableSpeedDrivesDocument = gql`
    query VariableSpeedDrives($limit: Int, $offset: Int, $where: variable_speed_drives_bool_exp, $order_by: [variable_speed_drives_order_by!]) {
  variable_speed_drives(
    limit: $limit
    offset: $offset
    where: $where
    order_by: $order_by
  ) {
    ...VsdAllFields
  }
  variable_speed_drives_aggregate(where: $where) {
    id: __typename
    aggregate {
      id: __typename
      count
    }
  }
}
    ${VsdAllFieldsFragmentDoc}`;

export function useVariableSpeedDrivesQuery(options: Omit<Urql.UseQueryArgs<never, VariableSpeedDrivesQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<VariableSpeedDrivesQuery>({ query: VariableSpeedDrivesDocument, ...options });
};
export const DeleteVsdsDocument = gql`
    mutation DeleteVsds($where: variable_speed_drives_bool_exp!) {
  update_variable_speed_drives(where: $where, _set: {deleted_at: "now()"}) {
    returning {
      id
    }
  }
}
    `;

export function useDeleteVsdsMutation() {
  return Urql.useMutation<DeleteVsdsMutation, DeleteVsdsMutationVariables>(DeleteVsdsDocument);
};
export const RestoreVsdsDocument = gql`
    mutation RestoreVsds($where: variable_speed_drives_bool_exp!) {
  update_variable_speed_drives(where: $where, _set: {deleted_at: null}) {
    returning {
      id
    }
  }
}
    `;

export function useRestoreVsdsMutation() {
  return Urql.useMutation<RestoreVsdsMutation, RestoreVsdsMutationVariables>(RestoreVsdsDocument);
};
export const InsertVsdDocument = gql`
    mutation InsertVsd($object: variable_speed_drives_insert_input!) {
  insert_variable_speed_drives_one(object: $object) {
    ...VsdAllFields
  }
}
    ${VsdAllFieldsFragmentDoc}`;

export function useInsertVsdMutation() {
  return Urql.useMutation<InsertVsdMutation, InsertVsdMutationVariables>(InsertVsdDocument);
};
export const UpdateVsdByPkDocument = gql`
    mutation UpdateVSDByPk($object: variable_speed_drives_set_input, $id: uuid!) {
  update_variable_speed_drives_by_pk(pk_columns: {id: $id}, _set: $object) {
    ...VsdAllFields
  }
}
    ${VsdAllFieldsFragmentDoc}`;

export function useUpdateVsdByPkMutation() {
  return Urql.useMutation<UpdateVsdByPkMutation, UpdateVsdByPkMutationVariables>(UpdateVsdByPkDocument);
};
export const VsdSubDocument = gql`
    subscription VsdSub($limit: Int, $offset: Int, $where: variable_speed_drives_bool_exp, $order_by: [variable_speed_drives_order_by!]) {
  variable_speed_drives(
    limit: $limit
    offset: $offset
    where: $where
    order_by: $order_by
  ) {
    ...VsdAllFields
  }
}
    ${VsdAllFieldsFragmentDoc}`;

export function useVsdSubSubscription<R = VsdSubSubscription>(options: Omit<Urql.UseSubscriptionArgs<never, VsdSubSubscriptionVariables>, 'query'> = {}, handler?: Urql.SubscriptionHandlerArg<VsdSubSubscription, R>) {
  return Urql.useSubscription<VsdSubSubscription, R, VsdSubSubscriptionVariables>({ query: VsdSubDocument, ...options }, handler);
};
export const YToolBaseListDocument = gql`
    query YToolBaseList($limit: Int, $offset: Int, $where: y_tools_bool_exp, $order_by: [y_tools_order_by!]) {
  y_tools(limit: $limit, offset: $offset, where: $where, order_by: $order_by) {
    ...YToolBaseFields
  }
  y_tools_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    ${YToolBaseFieldsFragmentDoc}`;

export function useYToolBaseListQuery(options: Omit<Urql.UseQueryArgs<never, YToolBaseListQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<YToolBaseListQuery>({ query: YToolBaseListDocument, ...options });
};
export const YToolsDocument = gql`
    query YTools($limit: Int, $offset: Int, $where: y_tools_bool_exp, $order_by: [y_tools_order_by!]) {
  y_tools(limit: $limit, offset: $offset, where: $where, order_by: $order_by) {
    ...YToolAllFields
  }
  y_tools_aggregate(where: $where) {
    id: __typename
    aggregate {
      id: __typename
      count
    }
  }
}
    ${YToolAllFieldsFragmentDoc}`;

export function useYToolsQuery(options: Omit<Urql.UseQueryArgs<never, YToolsQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<YToolsQuery>({ query: YToolsDocument, ...options });
};
export const YToolByPkDocument = gql`
    query YToolByPk($id: uuid!) {
  y_tools_by_pk(id: $id) {
    ...YToolAllFields
  }
}
    ${YToolAllFieldsFragmentDoc}`;

export function useYToolByPkQuery(options: Omit<Urql.UseQueryArgs<never, YToolByPkQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<YToolByPkQuery>({ query: YToolByPkDocument, ...options });
};
export const DeleteYToolsDocument = gql`
    mutation DeleteYTools($where: y_tools_bool_exp!) {
  update_y_tools(where: $where, _set: {deleted_at: "now()"}) {
    returning {
      id
    }
  }
}
    `;

export function useDeleteYToolsMutation() {
  return Urql.useMutation<DeleteYToolsMutation, DeleteYToolsMutationVariables>(DeleteYToolsDocument);
};
export const RestoreYToolsDocument = gql`
    mutation RestoreYTools($where: y_tools_bool_exp!) {
  update_y_tools(where: $where, _set: {deleted_at: null}) {
    returning {
      id
    }
  }
}
    `;

export function useRestoreYToolsMutation() {
  return Urql.useMutation<RestoreYToolsMutation, RestoreYToolsMutationVariables>(RestoreYToolsDocument);
};
export const InsertYToolDocument = gql`
    mutation InsertYTool($object: y_tools_insert_input!) {
  insert_y_tools_one(object: $object) {
    ...YToolAllFields
  }
}
    ${YToolAllFieldsFragmentDoc}`;

export function useInsertYToolMutation() {
  return Urql.useMutation<InsertYToolMutation, InsertYToolMutationVariables>(InsertYToolDocument);
};
export const UpdateYToolByPkDocument = gql`
    mutation UpdateYToolByPk($object: y_tools_set_input, $id: uuid!) {
  update_y_tools_by_pk(pk_columns: {id: $id}, _set: $object) {
    ...YToolAllFields
  }
}
    ${YToolAllFieldsFragmentDoc}`;

export function useUpdateYToolByPkMutation() {
  return Urql.useMutation<UpdateYToolByPkMutation, UpdateYToolByPkMutationVariables>(UpdateYToolByPkDocument);
};
export const YToolSubDocument = gql`
    subscription YToolSub($limit: Int, $offset: Int, $where: y_tools_bool_exp, $order_by: [y_tools_order_by!]) {
  y_tools(limit: $limit, offset: $offset, where: $where, order_by: $order_by) {
    ...YToolAllFields
  }
}
    ${YToolAllFieldsFragmentDoc}`;

export function useYToolSubSubscription<R = YToolSubSubscription>(options: Omit<Urql.UseSubscriptionArgs<never, YToolSubSubscriptionVariables>, 'query'> = {}, handler?: Urql.SubscriptionHandlerArg<YToolSubSubscription, R>) {
  return Urql.useSubscription<YToolSubSubscription, R, YToolSubSubscriptionVariables>({ query: YToolSubDocument, ...options }, handler);
};
export const ErpCustomersDocument = gql`
    query ERPCustomers($name: String!, $customer_erp_id: String!, $is_customer: Boolean) {
  getERPCustomers(
    name: $name
    customer_erp_id: $customer_erp_id
    is_customer: $is_customer
  ) {
    customer_name
    customer_erp_id
  }
}
    `;

export function useErpCustomersQuery(options: Omit<Urql.UseQueryArgs<never, ErpCustomersQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<ErpCustomersQuery>({ query: ErpCustomersDocument, ...options });
};
export const ErpWellAddressesDocument = gql`
    query ERPWellAddresses($well_name: String!, $customer_erp_id: String!, $is_customer: Boolean) {
  getERPWellAddresses(
    well_name: $well_name
    customer_erp_id: $customer_erp_id
    is_customer: $is_customer
  ) {
    customer_erp_id
    address_erp_id
    customer_name
    well_erp_id
    well_name
    well_uwi
  }
}
    `;

export function useErpWellAddressesQuery(options: Omit<Urql.UseQueryArgs<never, ErpWellAddressesQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<ErpWellAddressesQuery>({ query: ErpWellAddressesDocument, ...options });
};
export const ErpWellReadingsDocument = gql`
    query ErpWellReadings($id: String!, $id_type: ErpWellReadingsIdType!) {
  getErpWellReadings(id: $id, id_type: $id_type) {
    ...ErpWellReadingsFragment
  }
}
    ${ErpWellReadingsFragmentFragmentDoc}`;

export function useErpWellReadingsQuery(options: Omit<Urql.UseQueryArgs<never, ErpWellReadingsQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<ErpWellReadingsQuery>({ query: ErpWellReadingsDocument, ...options });
};
export const GetActivatedEulaDocument = gql`
    query GetActivatedEula {
  eula(where: {activated: {_eq: true}}, order_by: {activated_on: desc}, limit: 1) {
    ...EulaFields
  }
}
    ${EulaFieldsFragmentDoc}`;

export function useGetActivatedEulaQuery(options: Omit<Urql.UseQueryArgs<never, GetActivatedEulaQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<GetActivatedEulaQuery>({ query: GetActivatedEulaDocument, ...options });
};
export const EulasSubDocument = gql`
    subscription EulasSub {
  eula {
    ...EulaFields
  }
}
    ${EulaFieldsFragmentDoc}`;

export function useEulasSubSubscription<R = EulasSubSubscription>(options: Omit<Urql.UseSubscriptionArgs<never, EulasSubSubscriptionVariables>, 'query'> = {}, handler?: Urql.SubscriptionHandlerArg<EulasSubSubscription, R>) {
  return Urql.useSubscription<EulasSubSubscription, R, EulasSubSubscriptionVariables>({ query: EulasSubDocument, ...options }, handler);
};
export const InsertEulaDocument = gql`
    mutation InsertEula($license: String!, $activated: Boolean!) {
  insert_eula_one(object: {license: $license, activated: $activated}) {
    ...EulaFields
  }
}
    ${EulaFieldsFragmentDoc}`;

export function useInsertEulaMutation() {
  return Urql.useMutation<InsertEulaMutation, InsertEulaMutationVariables>(InsertEulaDocument);
};
export const UpdateEulaLicenseDocument = gql`
    mutation UpdateEulaLicense($eulaId: uuid!, $license: String!) {
  update_eula(
    where: {id: {_eq: $eulaId}}
    _set: {license: $license, updated_at: "now()"}
  ) {
    returning {
      ...EulaFields
    }
  }
}
    ${EulaFieldsFragmentDoc}`;

export function useUpdateEulaLicenseMutation() {
  return Urql.useMutation<UpdateEulaLicenseMutation, UpdateEulaLicenseMutationVariables>(UpdateEulaLicenseDocument);
};
export const ActivateEulaDocument = gql`
    mutation ActivateEula($eulaId: uuid!) {
  deactivateEULAs: update_eula(
    where: {activated: {_eq: true}, id: {_neq: $eulaId}}
    _set: {activated: false, deactivated_at: "now()"}
  ) {
    returning {
      ...EulaFields
    }
  }
  activateEULA: update_eula(
    where: {id: {_eq: $eulaId}}
    _set: {activated: true, activated_on: "now()"}
  ) {
    returning {
      ...EulaFields
    }
  }
}
    ${EulaFieldsFragmentDoc}`;

export function useActivateEulaMutation() {
  return Urql.useMutation<ActivateEulaMutation, ActivateEulaMutationVariables>(ActivateEulaDocument);
};
export const DeactivateEulaDocument = gql`
    mutation DeactivateEula($eulaId: uuid!) {
  deactivateEULAs: update_eula(
    where: {activated: {_eq: true}, id: {_eq: $eulaId}}
    _set: {activated: false, deactivated_at: "now()"}
  ) {
    returning {
      ...EulaFields
    }
  }
}
    ${EulaFieldsFragmentDoc}`;

export function useDeactivateEulaMutation() {
  return Urql.useMutation<DeactivateEulaMutation, DeactivateEulaMutationVariables>(DeactivateEulaDocument);
};
export const FlowModelDocument = gql`
    query FlowModel {
  flow_model_active {
    ...FlowModelFields
  }
}
    ${FlowModelFieldsFragmentDoc}`;

export function useFlowModelQuery(options: Omit<Urql.UseQueryArgs<never, FlowModelQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<FlowModelQuery>({ query: FlowModelDocument, ...options });
};
export const HpsLiquidTypesDocument = gql`
    query HpsLiquidTypes {
  hps_liquid_type {
    ...HpsLiquidTypeFields
  }
}
    ${HpsLiquidTypeFieldsFragmentDoc}`;

export function useHpsLiquidTypesQuery(options: Omit<Urql.UseQueryArgs<never, HpsLiquidTypesQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<HpsLiquidTypesQuery>({ query: HpsLiquidTypesDocument, ...options });
};
export const OverrideOptionsDocument = gql`
    query OverrideOptions {
  override_options {
    id: value
    value
    comment
  }
}
    `;

export function useOverrideOptionsQuery(options: Omit<Urql.UseQueryArgs<never, OverrideOptionsQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<OverrideOptionsQuery>({ query: OverrideOptionsDocument, ...options });
};
export const PerformanceEvaluationsDocument = gql`
    query PerformanceEvaluations($limit: Int, $offset: Int, $where: performance_evaluations_bool_exp, $order_by: [performance_evaluations_order_by!], $withAggregate: Boolean! = false) {
  performance_evaluations(
    limit: $limit
    offset: $offset
    where: $where
    order_by: $order_by
  ) {
    ...PerformanceEvaluationAllFields
    r_scenario: scenario {
      ...ScenariosListFields
      sizing {
        ...SizingsListFields
        well {
          ...WellsFields
        }
        customer {
          ...CustomersFields
        }
      }
    }
    r_author: author {
      ...UsersFields
    }
    r_xref_pumps: xref_pumps(where: {journal_deleted_at: {_is_null: true}}) {
      ...PerformanceEvaluationXrefPumpFields
    }
  }
  performance_evaluations_aggregate(where: $where) @include(if: $withAggregate) {
    id: __typename
    aggregate {
      id: __typename
      count
    }
  }
}
    ${PerformanceEvaluationAllFieldsFragmentDoc}
${ScenariosListFieldsFragmentDoc}
${SizingsListFieldsFragmentDoc}
${WellsFieldsFragmentDoc}
${CustomersFieldsFragmentDoc}
${UsersFieldsFragmentDoc}
${PerformanceEvaluationXrefPumpFieldsFragmentDoc}`;

export function usePerformanceEvaluationsQuery(options: Omit<Urql.UseQueryArgs<never, PerformanceEvaluationsQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<PerformanceEvaluationsQuery>({ query: PerformanceEvaluationsDocument, ...options });
};
export const InsertPerformanceEvaluationRevisionDocument = gql`
    mutation InsertPerformanceEvaluationRevision($update_performance_evaluations: Boolean = true, $update_pumps: Boolean = true, $performance_evaluations_revisions: [revisions_performance_evaluations_revisions_insert_input!]!, $performance_evaluations_xref_pumps_revisions: [revisions_performance_evaluations_xref_pumps_revisions_insert_input!]!) {
  insert_revisions_performance_evaluations_revisions(
    objects: $performance_evaluations_revisions
  ) @include(if: $update_performance_evaluations) {
    affected_rows
    returning {
      id
      performance_evaluations_view {
        ...PerformanceEvaluationAllFields
      }
    }
  }
  insert_revisions_performance_evaluations_xref_pumps_revisions(
    objects: $performance_evaluations_xref_pumps_revisions
  ) @include(if: $update_pumps) {
    affected_rows
    returning {
      id
      performance_evaluations_xref_pumps_view {
        ...PerformanceEvaluationPumpsFields
      }
    }
  }
}
    ${PerformanceEvaluationAllFieldsFragmentDoc}
${PerformanceEvaluationPumpsFieldsFragmentDoc}`;

export function useInsertPerformanceEvaluationRevisionMutation() {
  return Urql.useMutation<InsertPerformanceEvaluationRevisionMutation, InsertPerformanceEvaluationRevisionMutationVariables>(InsertPerformanceEvaluationRevisionDocument);
};
export const PerformanceEvaluationXrefPumpsDocument = gql`
    query PerformanceEvaluationXrefPumps($distinct_on: [performance_evaluations_xref_pumps_select_column!], $limit: Int, $offset: Int, $order_by: [performance_evaluations_xref_pumps_order_by!], $where: performance_evaluations_xref_pumps_bool_exp) {
  performance_evaluations_xref_pumps(
    where: $where
    distinct_on: $distinct_on
    limit: $limit
    offset: $offset
    order_by: $order_by
  ) {
    ...PerformanceEvaluationPumpsFields
  }
}
    ${PerformanceEvaluationPumpsFieldsFragmentDoc}`;

export function usePerformanceEvaluationXrefPumpsQuery(options: Omit<Urql.UseQueryArgs<never, PerformanceEvaluationXrefPumpsQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<PerformanceEvaluationXrefPumpsQuery>({ query: PerformanceEvaluationXrefPumpsDocument, ...options });
};
export const QuoteEnumsDocument = gql`
    query QuoteEnums {
  quote_line_item_category_dataset {
    ...QuoteLineItemCategoryDatasetFields
  }
  quote_line_item_subcategory_dataset {
    ...QuoteLineItemSubcategoryDatasetFields
  }
  quote_line_item_type_dataset {
    ...QuoteLineItemTypeDatasetFields
  }
  quote_sk_job_type_dataset {
    ...QuoteSkJobTypeDatasetFields
  }
  quote_status_dataset {
    ...QuoteStatusDatasetFields
  }
  override_options {
    id: value
    value
    comment
  }
}
    ${QuoteLineItemCategoryDatasetFieldsFragmentDoc}
${QuoteLineItemSubcategoryDatasetFieldsFragmentDoc}
${QuoteLineItemTypeDatasetFieldsFragmentDoc}
${QuoteSkJobTypeDatasetFieldsFragmentDoc}
${QuoteStatusDatasetFieldsFragmentDoc}`;

export function useQuoteEnumsQuery(options: Omit<Urql.UseQueryArgs<never, QuoteEnumsQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<QuoteEnumsQuery>({ query: QuoteEnumsDocument, ...options });
};
export const GetQuoteLineItemCategoryDatasetDocument = gql`
    query GetQuoteLineItemCategoryDataset {
  quote_line_item_category_dataset {
    ...QuoteLineItemCategoryDatasetFields
  }
}
    ${QuoteLineItemCategoryDatasetFieldsFragmentDoc}`;

export function useGetQuoteLineItemCategoryDatasetQuery(options: Omit<Urql.UseQueryArgs<never, GetQuoteLineItemCategoryDatasetQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<GetQuoteLineItemCategoryDatasetQuery>({ query: GetQuoteLineItemCategoryDatasetDocument, ...options });
};
export const GetQuoteLineItemSubcategoryDatasetDocument = gql`
    query GetQuoteLineItemSubcategoryDataset {
  quote_line_item_subcategory_dataset {
    ...QuoteLineItemSubcategoryDatasetFields
  }
}
    ${QuoteLineItemSubcategoryDatasetFieldsFragmentDoc}`;

export function useGetQuoteLineItemSubcategoryDatasetQuery(options: Omit<Urql.UseQueryArgs<never, GetQuoteLineItemSubcategoryDatasetQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<GetQuoteLineItemSubcategoryDatasetQuery>({ query: GetQuoteLineItemSubcategoryDatasetDocument, ...options });
};
export const GetQuoteLineItemTypeDatasetDocument = gql`
    query GetQuoteLineItemTypeDataset {
  quote_line_item_type_dataset {
    ...QuoteLineItemTypeDatasetFields
  }
}
    ${QuoteLineItemTypeDatasetFieldsFragmentDoc}`;

export function useGetQuoteLineItemTypeDatasetQuery(options: Omit<Urql.UseQueryArgs<never, GetQuoteLineItemTypeDatasetQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<GetQuoteLineItemTypeDatasetQuery>({ query: GetQuoteLineItemTypeDatasetDocument, ...options });
};
export const GetQuoteSkJobTypeDatasetDocument = gql`
    query GetQuoteSkJobTypeDataset {
  quote_sk_job_type_dataset {
    ...QuoteSkJobTypeDatasetFields
  }
}
    ${QuoteSkJobTypeDatasetFieldsFragmentDoc}`;

export function useGetQuoteSkJobTypeDatasetQuery(options: Omit<Urql.UseQueryArgs<never, GetQuoteSkJobTypeDatasetQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<GetQuoteSkJobTypeDatasetQuery>({ query: GetQuoteSkJobTypeDatasetDocument, ...options });
};
export const GetQuoteStatusDatasetDocument = gql`
    query GetQuoteStatusDataset {
  quote_status_dataset {
    ...QuoteStatusDatasetFields
  }
}
    ${QuoteStatusDatasetFieldsFragmentDoc}`;

export function useGetQuoteStatusDatasetQuery(options: Omit<Urql.UseQueryArgs<never, GetQuoteStatusDatasetQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<GetQuoteStatusDatasetQuery>({ query: GetQuoteStatusDatasetDocument, ...options });
};
export const GetQuoteUserMessagesDocument = gql`
    query GetQuoteUserMessages {
  quote_user_messages(where: {deleted_at: {_is_null: true}}) {
    ...QuoteUserMessagesFields
  }
}
    ${QuoteUserMessagesFieldsFragmentDoc}`;

export function useGetQuoteUserMessagesQuery(options: Omit<Urql.UseQueryArgs<never, GetQuoteUserMessagesQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<GetQuoteUserMessagesQuery>({ query: GetQuoteUserMessagesDocument, ...options });
};
export const GetQuoteByPkDocument = gql`
    query GetQuoteByPk($id: uuid!) {
  quotes_by_pk(id: $id) {
    ...AllQuoteFields
  }
}
    ${AllQuoteFieldsFragmentDoc}`;

export function useGetQuoteByPkQuery(options: Omit<Urql.UseQueryArgs<never, GetQuoteByPkQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<GetQuoteByPkQuery>({ query: GetQuoteByPkDocument, ...options });
};
export const GetQuotesDocument = gql`
    query GetQuotes($limit: Int, $offset: Int, $where: quotes_bool_exp, $order_by: [quotes_order_by!]) {
  quotes(limit: $limit, offset: $offset, where: $where, order_by: $order_by) {
    ...AllQuoteFields
  }
}
    ${AllQuoteFieldsFragmentDoc}`;

export function useGetQuotesQuery(options: Omit<Urql.UseQueryArgs<never, GetQuotesQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<GetQuotesQuery>({ query: GetQuotesDocument, ...options });
};
export const GetQuotesWithPriceHistoryDocument = gql`
    query GetQuotesWithPriceHistory($limit: Int, $offset: Int, $where: quotes_bool_exp, $order_by: [quotes_order_by!]) {
  quotes(limit: $limit, offset: $offset, where: $where, order_by: $order_by) {
    ...AllQuotePriceHistoryFields
  }
}
    ${AllQuotePriceHistoryFieldsFragmentDoc}`;

export function useGetQuotesWithPriceHistoryQuery(options: Omit<Urql.UseQueryArgs<never, GetQuotesWithPriceHistoryQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<GetQuotesWithPriceHistoryQuery>({ query: GetQuotesWithPriceHistoryDocument, ...options });
};
export const GetQuotesWithoutLineItemsDocument = gql`
    query GetQuotesWithoutLineItems($limit: Int, $offset: Int, $where: quotes_bool_exp, $order_by: [quotes_order_by!]) {
  quotes(limit: $limit, offset: $offset, where: $where, order_by: $order_by) {
    ...AllQuoteFieldsWithoutLineItems
  }
}
    ${AllQuoteFieldsWithoutLineItemsFragmentDoc}`;

export function useGetQuotesWithoutLineItemsQuery(options: Omit<Urql.UseQueryArgs<never, GetQuotesWithoutLineItemsQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<GetQuotesWithoutLineItemsQuery>({ query: GetQuotesWithoutLineItemsDocument, ...options });
};
export const GetQuotesCountDocument = gql`
    query GetQuotesCount($where: quotes_bool_exp) {
  quotes_aggregate(where: $where) {
    id: __typename
    aggregate {
      id: __typename
      count
    }
  }
}
    `;

export function useGetQuotesCountQuery(options: Omit<Urql.UseQueryArgs<never, GetQuotesCountQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<GetQuotesCountQuery>({ query: GetQuotesCountDocument, ...options });
};
export const GetQuoteLineItemsDocument = gql`
    query GetQuoteLineItems($limit: Int, $offset: Int, $where: quote_line_items_bool_exp, $order_by: [quote_line_items_order_by!], $distinct_on: [quote_line_items_select_column!]) {
  quote_line_items(
    limit: $limit
    offset: $offset
    where: $where
    order_by: $order_by
    distinct_on: $distinct_on
  ) {
    ...QuoteLineItemFields
  }
}
    ${QuoteLineItemFieldsFragmentDoc}`;

export function useGetQuoteLineItemsQuery(options: Omit<Urql.UseQueryArgs<never, GetQuoteLineItemsQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<GetQuoteLineItemsQuery>({ query: GetQuoteLineItemsDocument, ...options });
};
export const InsertQuoteDocument = gql`
    mutation InsertQuote($object: quotes_insert_input!) {
  insert_quotes_one(object: $object) {
    ...QuoteFields
  }
}
    ${QuoteFieldsFragmentDoc}`;

export function useInsertQuoteMutation() {
  return Urql.useMutation<InsertQuoteMutation, InsertQuoteMutationVariables>(InsertQuoteDocument);
};
export const UpdateQuoteByPkDocument = gql`
    mutation UpdateQuoteByPk($id: uuid!, $object: quotes_set_input!, $create_line_items: [quote_line_items_insert_input!]!, $update_line_items: [quote_line_items_updates!]!) {
  update_quotes_by_pk(pk_columns: {id: $id}, _set: $object) {
    ...AllQuoteFields
  }
  insert_quote_line_items(objects: $create_line_items) {
    returning {
      ...QuoteLineItemFields
    }
  }
  update_quote_line_items_many(updates: $update_line_items) {
    returning {
      ...QuoteLineItemFields
    }
  }
}
    ${AllQuoteFieldsFragmentDoc}
${QuoteLineItemFieldsFragmentDoc}`;

export function useUpdateQuoteByPkMutation() {
  return Urql.useMutation<UpdateQuoteByPkMutation, UpdateQuoteByPkMutationVariables>(UpdateQuoteByPkDocument);
};
export const InsertQuoteLineItemDocument = gql`
    mutation InsertQuoteLineItem($object: quote_line_items_insert_input!) {
  insert_quote_line_items_one(object: $object) {
    ...QuoteLineItemsUpdateInsertFields
  }
}
    ${QuoteLineItemsUpdateInsertFieldsFragmentDoc}`;

export function useInsertQuoteLineItemMutation() {
  return Urql.useMutation<InsertQuoteLineItemMutation, InsertQuoteLineItemMutationVariables>(InsertQuoteLineItemDocument);
};
export const UpdateQuoteLineItemByPkDocument = gql`
    mutation UpdateQuoteLineItemByPk($id: uuid!, $object: quote_line_items_set_input!) {
  update_quote_line_items_by_pk(pk_columns: {id: $id}, _set: $object) {
    ...QuoteLineItemsUpdateInsertFields
  }
}
    ${QuoteLineItemsUpdateInsertFieldsFragmentDoc}`;

export function useUpdateQuoteLineItemByPkMutation() {
  return Urql.useMutation<UpdateQuoteLineItemByPkMutation, UpdateQuoteLineItemByPkMutationVariables>(UpdateQuoteLineItemByPkDocument);
};
export const UpdateManyQuoteLineItemsDocument = gql`
    mutation UpdateManyQuoteLineItems($object: [quote_line_items_updates!]!) {
  update_quote_line_items_many(updates: $object) {
    affected_rows
  }
}
    `;

export function useUpdateManyQuoteLineItemsMutation() {
  return Urql.useMutation<UpdateManyQuoteLineItemsMutation, UpdateManyQuoteLineItemsMutationVariables>(UpdateManyQuoteLineItemsDocument);
};
export const CorrelationsDocument = gql`
    query Correlations($limit: Int, $offset: Int, $where: scenario_correlations_bool_exp, $order_by: [scenario_correlations_order_by!]) {
  scenario_correlations(
    limit: $limit
    offset: $offset
    where: $where
    order_by: $order_by
  ) {
    ...ScenarioCorrelationsFields
  }
}
    ${ScenarioCorrelationsFieldsFragmentDoc}`;

export function useCorrelationsQuery(options: Omit<Urql.UseQueryArgs<never, CorrelationsQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<CorrelationsQuery>({ query: CorrelationsDocument, ...options });
};
export const InsertCorrelationsRevisionDocument = gql`
    mutation InsertCorrelationsRevision($object: revisions_scenario_correlations_revisions_insert_input!) {
  insert_revisions_scenario_correlations_revisions_one(object: $object) {
    id
    scenario_correlations_view {
      ...ScenarioCorrelationsFields
    }
  }
}
    ${ScenarioCorrelationsFieldsFragmentDoc}`;

export function useInsertCorrelationsRevisionMutation() {
  return Urql.useMutation<InsertCorrelationsRevisionMutation, InsertCorrelationsRevisionMutationVariables>(InsertCorrelationsRevisionDocument);
};
export const ScenarioEquipmentDocument = gql`
    query ScenarioEquipment($distinct_on: [scenario_equipment_select_column!], $limit: Int, $offset: Int, $order_by: [scenario_equipment_order_by!], $where: scenario_equipment_bool_exp) {
  scenario_equipment(
    where: $where
    distinct_on: $distinct_on
    limit: $limit
    offset: $offset
    order_by: $order_by
  ) {
    ...ScenarioEquipmentBaseFields
    r_sensor: sensor {
      ...SensorsBaseFields
    }
    r_lower_sensor: lower_sensor {
      ...SensorsBaseFields
    }
    r_mle: mle {
      ...MleBaseFields
    }
    r_lower_mle: lower_mle {
      ...MleBaseFields
    }
    r_motor: motor {
      ...MotorsAllFields
    }
    r_bolt_on_discharge: bolt_on_discharge {
      ...BoltOnDischargesAllFields
    }
    r_lower_bolt_on_discharge: lower_bolt_on_discharge {
      ...BoltOnDischargesAllFields
    }
    r_lower_motor: lower_motor {
      ...MotorsAllFields
    }
    r_shroud: shroud {
      ...CasingsAllFields
    }
    r_lower_shroud: lower_shroud {
      ...CasingsAllFields
    }
    r_step_down_transformer: step_down_transformer {
      ...DownTransAllFields
    }
    r_step_up_transformer: step_up_transformer {
      ...UpTransAllFields
    }
    r_vsd: vsd {
      ...VsdAllFields
    }
    r_switchboard: switchboard {
      ...SwitchboardsAllFields
    }
    r_seal_motor_oil: seal_motor_oil {
      ...SealMotorOilAllFields
    }
    r_lower_seal_motor_oil: lower_seal_motor_oil {
      ...SealMotorOilAllFields
    }
    r_uphole_y_tool: uphole_y_tool {
      ...YToolAllFields
    }
    r_downhole_y_tool: downhole_y_tool {
      ...YToolAllFields
    }
    r_xref_uphole_y_tool_bypass_tubings: uphole_xref_y_tool_bypass_tubings(
      where: {journal_deleted_at: {_is_null: true}}
    ) {
      ...ScenarioEquipmentXrefUpholeYToolBypassTubingsBaseFields
      r_tubing: tubing {
        ...TubingsAllFields
      }
    }
    r_xref_uphole_y_tool_equipment_tubings: uphole_xref_y_tool_equipment_tubings(
      where: {journal_deleted_at: {_is_null: true}}
    ) {
      ...ScenarioEquipmentXrefUpholeYToolEquipmentTubingsBaseFields
      r_tubing: tubing {
        ...TubingsAllFields
      }
    }
    r_xref_downhole_y_tool_bypass_tubings: downhole_xref_y_tool_bypass_tubings(
      where: {journal_deleted_at: {_is_null: true}}
    ) {
      ...ScenarioEquipmentXrefDownholeYToolBypassTubingsBaseFields
      r_tubing: tubing {
        ...TubingsAllFields
      }
    }
    r_xref_downhole_y_tool_equipment_tubings: downhole_xref_y_tool_equipment_tubings(
      where: {journal_deleted_at: {_is_null: true}}
    ) {
      ...ScenarioEquipmentXrefDownholeYToolEquipmentTubingsBaseFields
      r_tubing: tubing {
        ...TubingsAllFields
      }
    }
  }
}
    ${ScenarioEquipmentBaseFieldsFragmentDoc}
${SensorsBaseFieldsFragmentDoc}
${MleBaseFieldsFragmentDoc}
${MotorsAllFieldsFragmentDoc}
${BoltOnDischargesAllFieldsFragmentDoc}
${CasingsAllFieldsFragmentDoc}
${DownTransAllFieldsFragmentDoc}
${UpTransAllFieldsFragmentDoc}
${VsdAllFieldsFragmentDoc}
${SwitchboardsAllFieldsFragmentDoc}
${SealMotorOilAllFieldsFragmentDoc}
${YToolAllFieldsFragmentDoc}
${ScenarioEquipmentXrefUpholeYToolBypassTubingsBaseFieldsFragmentDoc}
${TubingsAllFieldsFragmentDoc}
${ScenarioEquipmentXrefUpholeYToolEquipmentTubingsBaseFieldsFragmentDoc}
${ScenarioEquipmentXrefDownholeYToolBypassTubingsBaseFieldsFragmentDoc}
${ScenarioEquipmentXrefDownholeYToolEquipmentTubingsBaseFieldsFragmentDoc}`;

export function useScenarioEquipmentQuery(options: Omit<Urql.UseQueryArgs<never, ScenarioEquipmentQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<ScenarioEquipmentQuery>({ query: ScenarioEquipmentDocument, ...options });
};
export const InsertScenarioEquipmentRevisionDocument = gql`
    mutation InsertScenarioEquipmentRevision($object: revisions_scenario_equipment_revisions_insert_input!) {
  insert_revisions_scenario_equipment_revisions_one(object: $object) {
    id
    scenario_equipment_view {
      ...ScenarioEquipmentBaseFields
    }
  }
}
    ${ScenarioEquipmentBaseFieldsFragmentDoc}`;

export function useInsertScenarioEquipmentRevisionMutation() {
  return Urql.useMutation<InsertScenarioEquipmentRevisionMutation, InsertScenarioEquipmentRevisionMutationVariables>(InsertScenarioEquipmentRevisionDocument);
};
export const ScenarioEquipmentXrefCablesDocument = gql`
    query ScenarioEquipmentXrefCables($distinct_on: [scenario_equipment_xref_cables_select_column!], $limit: Int, $offset: Int, $order_by: [scenario_equipment_xref_cables_order_by!], $where: scenario_equipment_xref_cables_bool_exp) {
  scenario_equipment_xref_cables(
    where: $where
    distinct_on: $distinct_on
    limit: $limit
    offset: $offset
    order_by: $order_by
  ) {
    ...ScenarioEquipmentCablesBaseFields
    r_cable: cable {
      ...CablesAllFields
    }
  }
}
    ${ScenarioEquipmentCablesBaseFieldsFragmentDoc}
${CablesAllFieldsFragmentDoc}`;

export function useScenarioEquipmentXrefCablesQuery(options: Omit<Urql.UseQueryArgs<never, ScenarioEquipmentXrefCablesQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<ScenarioEquipmentXrefCablesQuery>({ query: ScenarioEquipmentXrefCablesDocument, ...options });
};
export const ScenarioEquipmentXrefHousingsDocument = gql`
    query ScenarioEquipmentXrefHousings($distinct_on: [scenario_equipment_xref_housings_select_column!], $limit: Int, $offset: Int, $order_by: [scenario_equipment_xref_housings_order_by!], $where: scenario_equipment_xref_housings_bool_exp) {
  scenario_equipment_xref_housings(
    distinct_on: $distinct_on
    limit: $limit
    offset: $offset
    order_by: $order_by
    where: $where
  ) {
    ...ScenarioEquipmentHousingsFields
    r_housing: housing {
      ...HousingsAllFields
    }
  }
}
    ${ScenarioEquipmentHousingsFieldsFragmentDoc}
${HousingsAllFieldsFragmentDoc}`;

export function useScenarioEquipmentXrefHousingsQuery(options: Omit<Urql.UseQueryArgs<never, ScenarioEquipmentXrefHousingsQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<ScenarioEquipmentXrefHousingsQuery>({ query: ScenarioEquipmentXrefHousingsDocument, ...options });
};
export const ScenarioEquipmentXrefIntakesDocument = gql`
    query ScenarioEquipmentXrefIntakes($distinct_on: [scenario_equipment_xref_intakes_select_column!], $limit: Int, $offset: Int, $order_by: [scenario_equipment_xref_intakes_order_by!], $where: scenario_equipment_xref_intakes_bool_exp) {
  scenario_equipment_xref_intakes(
    where: $where
    distinct_on: $distinct_on
    limit: $limit
    offset: $offset
    order_by: $order_by
  ) {
    ...ScenarioEquipmentIntakesBaseFields
    r_intake: intake {
      ...IntakesAllFields
    }
  }
}
    ${ScenarioEquipmentIntakesBaseFieldsFragmentDoc}
${IntakesAllFieldsFragmentDoc}`;

export function useScenarioEquipmentXrefIntakesQuery(options: Omit<Urql.UseQueryArgs<never, ScenarioEquipmentXrefIntakesQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<ScenarioEquipmentXrefIntakesQuery>({ query: ScenarioEquipmentXrefIntakesDocument, ...options });
};
export const ScenarioEquipmentXrefDownholeYToolBypassTubingsDocument = gql`
    query ScenarioEquipmentXrefDownholeYToolBypassTubings($distinct_on: [sc_equip_xref_downhole_ytool_bypass_tubings_select_column!], $limit: Int, $offset: Int, $order_by: [sc_equip_xref_downhole_ytool_bypass_tubings_order_by!], $where: sc_equip_xref_downhole_ytool_bypass_tubings_bool_exp) {
  sc_equip_xref_downhole_ytool_bypass_tubings(
    where: $where
    distinct_on: $distinct_on
    limit: $limit
    offset: $offset
    order_by: $order_by
  ) {
    ...ScenarioEquipmentXrefDownholeYToolBypassTubingsBaseFields
    r_tubing: tubing {
      ...TubingsAllFields
    }
  }
}
    ${ScenarioEquipmentXrefDownholeYToolBypassTubingsBaseFieldsFragmentDoc}
${TubingsAllFieldsFragmentDoc}`;

export function useScenarioEquipmentXrefDownholeYToolBypassTubingsQuery(options: Omit<Urql.UseQueryArgs<never, ScenarioEquipmentXrefDownholeYToolBypassTubingsQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<ScenarioEquipmentXrefDownholeYToolBypassTubingsQuery>({ query: ScenarioEquipmentXrefDownholeYToolBypassTubingsDocument, ...options });
};
export const ScenarioEquipmentXrefDownholeYToolEquipmentTubingsDocument = gql`
    query ScenarioEquipmentXrefDownholeYToolEquipmentTubings($distinct_on: [sc_equip_xref_downhole_ytool_equip_tubings_select_column!], $limit: Int, $offset: Int, $order_by: [sc_equip_xref_downhole_ytool_equip_tubings_order_by!], $where: sc_equip_xref_downhole_ytool_equip_tubings_bool_exp) {
  sc_equip_xref_downhole_ytool_equip_tubings(
    where: $where
    distinct_on: $distinct_on
    limit: $limit
    offset: $offset
    order_by: $order_by
  ) {
    ...ScenarioEquipmentXrefDownholeYToolEquipmentTubingsBaseFields
    r_tubing: tubing {
      ...TubingsAllFields
    }
  }
}
    ${ScenarioEquipmentXrefDownholeYToolEquipmentTubingsBaseFieldsFragmentDoc}
${TubingsAllFieldsFragmentDoc}`;

export function useScenarioEquipmentXrefDownholeYToolEquipmentTubingsQuery(options: Omit<Urql.UseQueryArgs<never, ScenarioEquipmentXrefDownholeYToolEquipmentTubingsQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<ScenarioEquipmentXrefDownholeYToolEquipmentTubingsQuery>({ query: ScenarioEquipmentXrefDownholeYToolEquipmentTubingsDocument, ...options });
};
export const ScenarioEquipmentXrefPumpsDocument = gql`
    query ScenarioEquipmentXrefPumps($distinct_on: [scenario_equipment_xref_pumps_select_column!], $limit: Int, $offset: Int, $order_by: [scenario_equipment_xref_pumps_order_by!], $where: scenario_equipment_xref_pumps_bool_exp, $housings_where: scenario_equipment_xref_housings_bool_exp) {
  scenario_equipment_xref_pumps(
    where: $where
    distinct_on: $distinct_on
    limit: $limit
    offset: $offset
    order_by: $order_by
  ) {
    ...ScenarioEquipmentPumpsFields
    r_pump: pump {
      ...PumpsBaseFields
    }
    r_xref_housings: xref_housings(where: $housings_where) {
      ...ScenarioEquipmentHousingsFields
      r_housing: housing {
        ...HousingsAllFields
      }
    }
  }
}
    ${ScenarioEquipmentPumpsFieldsFragmentDoc}
${PumpsBaseFieldsFragmentDoc}
${ScenarioEquipmentHousingsFieldsFragmentDoc}
${HousingsAllFieldsFragmentDoc}`;

export function useScenarioEquipmentXrefPumpsQuery(options: Omit<Urql.UseQueryArgs<never, ScenarioEquipmentXrefPumpsQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<ScenarioEquipmentXrefPumpsQuery>({ query: ScenarioEquipmentXrefPumpsDocument, ...options });
};
export const ScenarioEquipmentXrefSealsDocument = gql`
    query ScenarioEquipmentXrefSeals($distinct_on: [scenario_equipment_xref_seals_select_column!], $limit: Int, $offset: Int, $order_by: [scenario_equipment_xref_seals_order_by!], $where: scenario_equipment_xref_seals_bool_exp) {
  scenario_equipment_xref_seals(
    where: $where
    distinct_on: $distinct_on
    limit: $limit
    offset: $offset
    order_by: $order_by
  ) {
    ...ScenarioEquipmentSealsBaseFields
    r_seal: seal {
      ...SealsAllFields
    }
  }
}
    ${ScenarioEquipmentSealsBaseFieldsFragmentDoc}
${SealsAllFieldsFragmentDoc}`;

export function useScenarioEquipmentXrefSealsQuery(options: Omit<Urql.UseQueryArgs<never, ScenarioEquipmentXrefSealsQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<ScenarioEquipmentXrefSealsQuery>({ query: ScenarioEquipmentXrefSealsDocument, ...options });
};
export const ScenarioEquipmentXrefUpholeYToolBypassTubingsDocument = gql`
    query ScenarioEquipmentXrefUpholeYToolBypassTubings($distinct_on: [sc_equip_xref_uphole_ytool_bypass_tubings_select_column!], $limit: Int, $offset: Int, $order_by: [sc_equip_xref_uphole_ytool_bypass_tubings_order_by!], $where: sc_equip_xref_uphole_ytool_bypass_tubings_bool_exp) {
  sc_equip_xref_uphole_ytool_bypass_tubings(
    where: $where
    distinct_on: $distinct_on
    limit: $limit
    offset: $offset
    order_by: $order_by
  ) {
    ...ScenarioEquipmentXrefUpholeYToolBypassTubingsBaseFields
    r_tubing: tubing {
      ...TubingsAllFields
    }
  }
}
    ${ScenarioEquipmentXrefUpholeYToolBypassTubingsBaseFieldsFragmentDoc}
${TubingsAllFieldsFragmentDoc}`;

export function useScenarioEquipmentXrefUpholeYToolBypassTubingsQuery(options: Omit<Urql.UseQueryArgs<never, ScenarioEquipmentXrefUpholeYToolBypassTubingsQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<ScenarioEquipmentXrefUpholeYToolBypassTubingsQuery>({ query: ScenarioEquipmentXrefUpholeYToolBypassTubingsDocument, ...options });
};
export const ScenarioEquipmentXrefUpholeYToolEquipmentTubingsDocument = gql`
    query ScenarioEquipmentXrefUpholeYToolEquipmentTubings($distinct_on: [sc_equip_xref_uphole_ytool_equip_tubings_select_column!], $limit: Int, $offset: Int, $order_by: [sc_equip_xref_uphole_ytool_equip_tubings_order_by!], $where: sc_equip_xref_uphole_ytool_equip_tubings_bool_exp) {
  sc_equip_xref_uphole_ytool_equip_tubings(
    where: $where
    distinct_on: $distinct_on
    limit: $limit
    offset: $offset
    order_by: $order_by
  ) {
    ...ScenarioEquipmentXrefUpholeYToolEquipmentTubingsBaseFields
    r_tubing: tubing {
      ...TubingsAllFields
    }
  }
}
    ${ScenarioEquipmentXrefUpholeYToolEquipmentTubingsBaseFieldsFragmentDoc}
${TubingsAllFieldsFragmentDoc}`;

export function useScenarioEquipmentXrefUpholeYToolEquipmentTubingsQuery(options: Omit<Urql.UseQueryArgs<never, ScenarioEquipmentXrefUpholeYToolEquipmentTubingsQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<ScenarioEquipmentXrefUpholeYToolEquipmentTubingsQuery>({ query: ScenarioEquipmentXrefUpholeYToolEquipmentTubingsDocument, ...options });
};
export const ScenariosDocument = gql`
    query Scenarios($limit: Int, $offset: Int, $where: scenarios_bool_exp, $order_by: [scenarios_order_by!], $withAggregate: Boolean! = false) {
  scenarios(limit: $limit, offset: $offset, where: $where, order_by: $order_by) {
    ...ScenariosFields
    author {
      ...UsersFields
    }
    sizing {
      ...SizingsListFields
      well {
        ...WellsFields
      }
      customer {
        ...CustomersFields
      }
    }
  }
  scenarios_aggregate(where: $where) @include(if: $withAggregate) {
    id: __typename
    aggregate {
      id: __typename
      count
    }
  }
}
    ${ScenariosFieldsFragmentDoc}
${UsersFieldsFragmentDoc}
${SizingsListFieldsFragmentDoc}
${WellsFieldsFragmentDoc}
${CustomersFieldsFragmentDoc}`;

export function useScenariosQuery(options: Omit<Urql.UseQueryArgs<never, ScenariosQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<ScenariosQuery>({ query: ScenariosDocument, ...options });
};
export const QuoteScenariosBySizingDocument = gql`
    query QuoteScenariosBySizing($sizing_id: uuid) {
  scenarios(
    where: {sizing_id: {_eq: $sizing_id}, journal_deleted_at: {_is_null: true}, sizing: {journal_deleted_at: {_is_null: true}}}
    order_by: [{journal_created_at: asc}]
  ) {
    quotes {
      name
      id
      version_number
      spyglass_scenario_id
      status
      prepared_by_id
      created_at
      parent {
        id
      }
    }
    id
    parent_id
    title
    journal_author_id
    journal_created_at
  }
}
    `;

export function useQuoteScenariosBySizingQuery(options: Omit<Urql.UseQueryArgs<never, QuoteScenariosBySizingQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<QuoteScenariosBySizingQuery>({ query: QuoteScenariosBySizingDocument, ...options });
};
export const ScenariosToGenerateQuotesDocument = gql`
    query ScenariosToGenerateQuotes($limit: Int, $offset: Int, $where: scenarios_bool_exp, $order_by: [scenarios_order_by!], $withAggregate: Boolean! = false) {
  scenarios(limit: $limit, offset: $offset, where: $where, order_by: $order_by) {
    ...ScenariosFields
    author {
      ...UsersFields
    }
    equipment {
      ...ScenarioEquipmentBaseFields
      r_sensor: sensor {
        ...SensorsAllFields
      }
      r_lower_sensor: lower_sensor {
        ...SensorsAllFields
      }
      r_mle: mle {
        ...MleAllFields
      }
      r_lower_mle: lower_mle {
        ...MleAllFields
      }
      r_motor: motor {
        ...MotorsAllFields
      }
      r_bolt_on_discharge: bolt_on_discharge {
        ...BoltOnDischargesAllFields
      }
      r_lower_bolt_on_discharge: lower_bolt_on_discharge {
        ...BoltOnDischargesAllFields
      }
      r_lower_motor: lower_motor {
        ...MotorsAllFields
      }
      r_shroud: shroud {
        ...CasingsAllFields
      }
      r_lower_shroud: lower_shroud {
        ...CasingsAllFields
      }
      r_step_down_transformer: step_down_transformer {
        ...DownTransAllFields
      }
      r_step_up_transformer: step_up_transformer {
        ...UpTransAllFields
      }
      r_vsd: vsd {
        ...VsdAllFields
      }
      r_switchboard: switchboard {
        ...SwitchboardsAllFields
      }
      r_seal_motor_oil: seal_motor_oil {
        ...SealMotorOilAllFields
      }
      r_lower_seal_motor_oil: lower_seal_motor_oil {
        ...SealMotorOilAllFields
      }
      r_uphole_y_tool: uphole_y_tool {
        ...YToolAllFields
      }
      r_downhole_y_tool: downhole_y_tool {
        ...YToolAllFields
      }
      r_xref_pumps: xref_pumps(where: {journal_deleted_at: {_is_null: true}}) {
        ...ScenarioEquipmentPumpsFields
        r_pump: pump {
          ...PumpsAllFields
          r_housings: housings(
            where: {deleted_at: {_is_null: true}}
            order_by: {housing_number: asc}
          ) {
            ...HousingsAllFields
          }
        }
        r_xref_housings: xref_housings(where: {journal_deleted_at: {_is_null: true}}) {
          ...ScenarioEquipmentHousingsFields
          r_housing: housing {
            ...HousingsAllFields
          }
        }
      }
      r_xref_intakes: xref_intakes(where: {journal_deleted_at: {_is_null: true}}) {
        ...ScenarioEquipmentIntakesBaseFields
        r_intake: intake {
          ...IntakesAllFields
        }
      }
      r_xref_seals: xref_seals(where: {journal_deleted_at: {_is_null: true}}) {
        ...ScenarioEquipmentSealsBaseFields
        r_seal: seal {
          ...SealsAllFields
        }
      }
      r_xref_cables: xref_cables(where: {journal_deleted_at: {_is_null: true}}) {
        ...ScenarioEquipmentCablesBaseFields
        r_cable: cable {
          ...CablesAllFields
        }
      }
      r_xref_uphole_y_tool_bypass_tubings: uphole_xref_y_tool_bypass_tubings(
        where: {journal_deleted_at: {_is_null: true}}
      ) {
        ...ScenarioEquipmentXrefUpholeYToolBypassTubingsBaseFields
        r_tubing: tubing {
          ...TubingsAllFields
        }
      }
      r_xref_uphole_y_tool_equipment_tubings: uphole_xref_y_tool_equipment_tubings(
        where: {journal_deleted_at: {_is_null: true}}
      ) {
        ...ScenarioEquipmentXrefUpholeYToolEquipmentTubingsBaseFields
        r_tubing: tubing {
          ...TubingsAllFields
        }
      }
      r_xref_downhole_y_tool_bypass_tubings: downhole_xref_y_tool_bypass_tubings(
        where: {journal_deleted_at: {_is_null: true}}
      ) {
        ...ScenarioEquipmentXrefDownholeYToolBypassTubingsBaseFields
        r_tubing: tubing {
          ...TubingsAllFields
        }
      }
      r_xref_downhole_y_tool_equipment_tubings: downhole_xref_y_tool_equipment_tubings(
        where: {journal_deleted_at: {_is_null: true}}
      ) {
        ...ScenarioEquipmentXrefDownholeYToolEquipmentTubingsBaseFields
        r_tubing: tubing {
          ...TubingsAllFields
        }
      }
    }
    sizing {
      ...SizingsListFields
      well {
        ...WellsFields
      }
      customer {
        ...CustomersFields
      }
    }
  }
  scenarios_aggregate(where: $where) @include(if: $withAggregate) {
    id: __typename
    aggregate {
      id: __typename
      count
    }
  }
}
    ${ScenariosFieldsFragmentDoc}
${UsersFieldsFragmentDoc}
${ScenarioEquipmentBaseFieldsFragmentDoc}
${SensorsAllFieldsFragmentDoc}
${MleAllFieldsFragmentDoc}
${MotorsAllFieldsFragmentDoc}
${BoltOnDischargesAllFieldsFragmentDoc}
${CasingsAllFieldsFragmentDoc}
${DownTransAllFieldsFragmentDoc}
${UpTransAllFieldsFragmentDoc}
${VsdAllFieldsFragmentDoc}
${SwitchboardsAllFieldsFragmentDoc}
${SealMotorOilAllFieldsFragmentDoc}
${YToolAllFieldsFragmentDoc}
${ScenarioEquipmentPumpsFieldsFragmentDoc}
${PumpsAllFieldsFragmentDoc}
${HousingsAllFieldsFragmentDoc}
${ScenarioEquipmentHousingsFieldsFragmentDoc}
${ScenarioEquipmentIntakesBaseFieldsFragmentDoc}
${IntakesAllFieldsFragmentDoc}
${ScenarioEquipmentSealsBaseFieldsFragmentDoc}
${SealsAllFieldsFragmentDoc}
${ScenarioEquipmentCablesBaseFieldsFragmentDoc}
${CablesAllFieldsFragmentDoc}
${ScenarioEquipmentXrefUpholeYToolBypassTubingsBaseFieldsFragmentDoc}
${TubingsAllFieldsFragmentDoc}
${ScenarioEquipmentXrefUpholeYToolEquipmentTubingsBaseFieldsFragmentDoc}
${ScenarioEquipmentXrefDownholeYToolBypassTubingsBaseFieldsFragmentDoc}
${ScenarioEquipmentXrefDownholeYToolEquipmentTubingsBaseFieldsFragmentDoc}
${SizingsListFieldsFragmentDoc}
${WellsFieldsFragmentDoc}
${CustomersFieldsFragmentDoc}`;

export function useScenariosToGenerateQuotesQuery(options: Omit<Urql.UseQueryArgs<never, ScenariosToGenerateQuotesQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<ScenariosToGenerateQuotesQuery>({ query: ScenariosToGenerateQuotesDocument, ...options });
};
export const ScenarioParametersDocument = gql`
    query ScenarioParameters($distinct_on: [scenario_parameters_select_column!], $limit: Int, $offset: Int, $order_by: [scenario_parameters_order_by!], $where: scenario_parameters_bool_exp) {
  scenario_parameters(
    where: $where
    distinct_on: $distinct_on
    limit: $limit
    offset: $offset
    order_by: $order_by
  ) {
    ...ScenarioParametersBaseFields
  }
}
    ${ScenarioParametersBaseFieldsFragmentDoc}`;

export function useScenarioParametersQuery(options: Omit<Urql.UseQueryArgs<never, ScenarioParametersQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<ScenarioParametersQuery>({ query: ScenarioParametersDocument, ...options });
};
export const InsertScenarioParametersRevisionDocument = gql`
    mutation InsertScenarioParametersRevision($object: revisions_scenario_parameters_revisions_insert_input!) {
  insert_revisions_scenario_parameters_revisions_one(object: $object) {
    id
    scenario_parameters_view {
      ...ScenarioParametersBaseFields
    }
  }
}
    ${ScenarioParametersBaseFieldsFragmentDoc}`;

export function useInsertScenarioParametersRevisionMutation() {
  return Urql.useMutation<InsertScenarioParametersRevisionMutation, InsertScenarioParametersRevisionMutationVariables>(InsertScenarioParametersRevisionDocument);
};
export const ScenarioReasonsDocument = gql`
    query ScenarioReasons {
  scenario_reasons {
    ...ScenarioReasonsFields
  }
}
    ${ScenarioReasonsFieldsFragmentDoc}`;

export function useScenarioReasonsQuery(options: Omit<Urql.UseQueryArgs<never, ScenarioReasonsQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<ScenarioReasonsQuery>({ query: ScenarioReasonsDocument, ...options });
};
export const ScenarioWellPropertiesDocument = gql`
    query ScenarioWellProperties($distinct_on: [scenario_well_properties_select_column!], $limit: Int, $offset: Int, $order_by: [scenario_well_properties_order_by!], $where: scenario_well_properties_bool_exp) {
  scenario_well_properties(
    where: $where
    distinct_on: $distinct_on
    limit: $limit
    offset: $offset
    order_by: $order_by
  ) {
    ...ScenarioWellPropertiesBaseFields
    r_top_tubing: top_tubing {
      ...TubingsBaseFields
    }
    r_bottom_tubing: bottom_tubing {
      ...TubingsBaseFields
    }
    r_top_casing: top_casing {
      ...CasingsBaseFields
    }
    r_bottom_casing: bottom_casing {
      ...CasingsBaseFields
    }
    r_deviation_survey: deviation_survey {
      ...DeviationSurveyBaseFields
    }
  }
}
    ${ScenarioWellPropertiesBaseFieldsFragmentDoc}
${TubingsBaseFieldsFragmentDoc}
${CasingsBaseFieldsFragmentDoc}
${DeviationSurveyBaseFieldsFragmentDoc}`;

export function useScenarioWellPropertiesQuery(options: Omit<Urql.UseQueryArgs<never, ScenarioWellPropertiesQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<ScenarioWellPropertiesQuery>({ query: ScenarioWellPropertiesDocument, ...options });
};
export const InsertScenarioWellPropertiesRevisionDocument = gql`
    mutation InsertScenarioWellPropertiesRevision($object: revisions_scenario_well_properties_revisions_insert_input!) {
  insert_revisions_scenario_well_properties_revisions_one(object: $object) {
    id
    scenario_well_properties_view {
      ...ScenarioWellPropertiesBaseFields
    }
  }
}
    ${ScenarioWellPropertiesBaseFieldsFragmentDoc}`;

export function useInsertScenarioWellPropertiesRevisionMutation() {
  return Urql.useMutation<InsertScenarioWellPropertiesRevisionMutation, InsertScenarioWellPropertiesRevisionMutationVariables>(InsertScenarioWellPropertiesRevisionDocument);
};
export const InsertScenarioRevisionDocument = gql`
    mutation InsertScenarioRevision($objects: [revisions_scenarios_revisions_insert_input!]!) {
  insert_revisions_scenarios_revisions(objects: $objects) {
    returning {
      id
      scenarios_view {
        ...ScenariosFields
      }
    }
  }
}
    ${ScenariosFieldsFragmentDoc}`;

export function useInsertScenarioRevisionMutation() {
  return Urql.useMutation<InsertScenarioRevisionMutation, InsertScenarioRevisionMutationVariables>(InsertScenarioRevisionDocument);
};
export const SizingDispositionsDocument = gql`
    query SizingDispositions {
  sizing_dispositions {
    ...SizingDispositionsFields
  }
}
    ${SizingDispositionsFieldsFragmentDoc}`;

export function useSizingDispositionsQuery(options: Omit<Urql.UseQueryArgs<never, SizingDispositionsQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<SizingDispositionsQuery>({ query: SizingDispositionsDocument, ...options });
};
export const SizingImportsDocument = gql`
    query SizingImports($distinct_on: [sizing_imports_select_column!], $limit: Int, $offset: Int, $order_by: [sizing_imports_order_by!], $where: sizing_imports_bool_exp) {
  sizing_imports(
    distinct_on: $distinct_on
    limit: $limit
    offset: $offset
    order_by: $order_by
    where: $where
  ) {
    ...SizingImportBaseFields
  }
}
    ${SizingImportBaseFieldsFragmentDoc}`;

export function useSizingImportsQuery(options: Omit<Urql.UseQueryArgs<never, SizingImportsQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<SizingImportsQuery>({ query: SizingImportsDocument, ...options });
};
export const SizingImportsWithPayloadDocument = gql`
    query SizingImportsWithPayload($distinct_on: [sizing_imports_select_column!], $limit: Int, $offset: Int, $order_by: [sizing_imports_order_by!], $where: sizing_imports_bool_exp) {
  sizing_imports(
    distinct_on: $distinct_on
    limit: $limit
    offset: $offset
    order_by: $order_by
    where: $where
  ) {
    ...SizingImportBaseFields
    payload
  }
}
    ${SizingImportBaseFieldsFragmentDoc}`;

export function useSizingImportsWithPayloadQuery(options: Omit<Urql.UseQueryArgs<never, SizingImportsWithPayloadQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<SizingImportsWithPayloadQuery>({ query: SizingImportsWithPayloadDocument, ...options });
};
export const InsertSizingImportDocument = gql`
    mutation InsertSizingImport($object: sizing_imports_insert_input!) {
  insert_sizing_imports_one(object: $object) {
    ...SizingImportBaseFields
  }
}
    ${SizingImportBaseFieldsFragmentDoc}`;

export function useInsertSizingImportMutation() {
  return Urql.useMutation<InsertSizingImportMutation, InsertSizingImportMutationVariables>(InsertSizingImportDocument);
};
export const SizingImportsSubDocument = gql`
    subscription SizingImportsSub($distinct_on: [sizing_imports_select_column!], $limit: Int, $offset: Int, $order_by: [sizing_imports_order_by!], $where: sizing_imports_bool_exp) {
  sizing_imports(
    distinct_on: $distinct_on
    limit: $limit
    offset: $offset
    order_by: $order_by
    where: $where
  ) {
    ...SizingImportBaseFields
  }
}
    ${SizingImportBaseFieldsFragmentDoc}`;

export function useSizingImportsSubSubscription<R = SizingImportsSubSubscription>(options: Omit<Urql.UseSubscriptionArgs<never, SizingImportsSubSubscriptionVariables>, 'query'> = {}, handler?: Urql.SubscriptionHandlerArg<SizingImportsSubSubscription, R>) {
  return Urql.useSubscription<SizingImportsSubSubscription, R, SizingImportsSubSubscriptionVariables>({ query: SizingImportsSubDocument, ...options }, handler);
};
export const SizingPumpingTypesDocument = gql`
    query SizingPumpingTypes {
  sizing_pumping_type {
    ...SizingPumpingTypeFields
  }
}
    ${SizingPumpingTypeFieldsFragmentDoc}`;

export function useSizingPumpingTypesQuery(options: Omit<Urql.UseQueryArgs<never, SizingPumpingTypesQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<SizingPumpingTypesQuery>({ query: SizingPumpingTypesDocument, ...options });
};
export const SizingsDocument = gql`
    query Sizings($limit: Int, $offset: Int, $where: sizings_bool_exp, $order_by: [sizings_order_by!], $withAggregate: Boolean! = false, $kitchenSink: Boolean! = false, $withImportUser: Boolean! = false) {
  sizings(limit: $limit, offset: $offset, where: $where, order_by: $order_by) {
    ...SizingsFields
    parent_sizing {
      id
      title
      journal_deleted_at
      installed_scenario_id
      scenarios(
        where: {journal_deleted_at: {_is_null: true}, sizing: {journal_deleted_at: {_is_null: true}}}
        order_by: [{journal_created_at: asc}]
      ) {
        id
      }
    }
    author {
      ...UsersFields
    }
    well {
      ...WellsFields
    }
    customer {
      ...CustomersFields
    }
    imported_from_sizing @include(if: $withImportUser) {
      id
      legacy_author_id
      legacy_user {
        hal_identifier
        display_name
      }
    }
    scenarios(
      where: {journal_deleted_at: {_is_null: true}, sizing: {journal_deleted_at: {_is_null: true}}}
      order_by: [{journal_created_at: asc}]
    ) @include(if: $kitchenSink) {
      ...ScenariosFields
      author {
        ...UsersFields
      }
      correlations {
        ...ScenarioCorrelationsFields
      }
      equipment {
        ...ScenarioEquipmentBaseFields
        r_sensor: sensor {
          ...SensorsAllFields
        }
        r_lower_sensor: lower_sensor {
          ...SensorsAllFields
        }
        r_mle: mle {
          ...MleAllFields
        }
        r_lower_mle: lower_mle {
          ...MleAllFields
        }
        r_motor: motor {
          ...MotorsAllFields
        }
        r_bolt_on_discharge: bolt_on_discharge {
          ...BoltOnDischargesAllFields
        }
        r_lower_bolt_on_discharge: lower_bolt_on_discharge {
          ...BoltOnDischargesAllFields
        }
        r_lower_motor: lower_motor {
          ...MotorsAllFields
        }
        r_shroud: shroud {
          ...CasingsAllFields
        }
        r_lower_shroud: lower_shroud {
          ...CasingsAllFields
        }
        r_uphole_y_tool: uphole_y_tool {
          ...YToolAllFields
        }
        r_downhole_y_tool: downhole_y_tool {
          ...YToolAllFields
        }
        r_step_down_transformer: step_down_transformer {
          ...DownTransAllFields
        }
        r_step_up_transformer: step_up_transformer {
          ...UpTransAllFields
        }
        r_vsd: vsd {
          ...VsdAllFields
        }
        r_switchboard: switchboard {
          ...SwitchboardsAllFields
        }
        r_seal_motor_oil: seal_motor_oil {
          ...SealMotorOilAllFields
        }
        r_lower_seal_motor_oil: lower_seal_motor_oil {
          ...SealMotorOilAllFields
        }
        r_xref_pumps: xref_pumps(where: {journal_deleted_at: {_is_null: true}}) {
          ...ScenarioEquipmentPumpsFields
          r_pump: pump {
            ...PumpsAllFields
            r_housings: housings(
              where: {deleted_at: {_is_null: true}}
              order_by: {housing_number: asc}
            ) {
              ...HousingsAllFields
            }
          }
          r_xref_housings: xref_housings(where: {journal_deleted_at: {_is_null: true}}) {
            ...ScenarioEquipmentHousingsFields
            r_housing: housing {
              ...HousingsAllFields
            }
          }
        }
        r_xref_intakes: xref_intakes(where: {journal_deleted_at: {_is_null: true}}) {
          ...ScenarioEquipmentIntakesBaseFields
          r_intake: intake {
            ...IntakesAllFields
          }
        }
        r_xref_seals: xref_seals(where: {journal_deleted_at: {_is_null: true}}) {
          ...ScenarioEquipmentSealsBaseFields
          r_seal: seal {
            ...SealsAllFields
          }
        }
        r_xref_cables: xref_cables(where: {journal_deleted_at: {_is_null: true}}) {
          ...ScenarioEquipmentCablesBaseFields
          r_cable: cable {
            ...CablesAllFields
          }
        }
        r_xref_uphole_y_tool_bypass_tubings: uphole_xref_y_tool_bypass_tubings(
          where: {journal_deleted_at: {_is_null: true}}
        ) {
          ...ScenarioEquipmentXrefUpholeYToolBypassTubingsBaseFields
          r_tubing: tubing {
            ...TubingsAllFields
          }
        }
        r_xref_uphole_y_tool_equipment_tubings: uphole_xref_y_tool_equipment_tubings(
          where: {journal_deleted_at: {_is_null: true}}
        ) {
          ...ScenarioEquipmentXrefUpholeYToolEquipmentTubingsBaseFields
          r_tubing: tubing {
            ...TubingsAllFields
          }
        }
        r_xref_downhole_y_tool_bypass_tubings: downhole_xref_y_tool_bypass_tubings(
          where: {journal_deleted_at: {_is_null: true}}
        ) {
          ...ScenarioEquipmentXrefDownholeYToolBypassTubingsBaseFields
          r_tubing: tubing {
            ...TubingsAllFields
          }
        }
        r_xref_downhole_y_tool_equipment_tubings: downhole_xref_y_tool_equipment_tubings(
          where: {journal_deleted_at: {_is_null: true}}
        ) {
          ...ScenarioEquipmentXrefDownholeYToolEquipmentTubingsBaseFields
          r_tubing: tubing {
            ...TubingsAllFields
          }
        }
      }
      parameters {
        ...ScenarioParametersBaseFields
      }
      well_properties {
        ...ScenarioWellPropertiesBaseFields
        r_top_tubing: top_tubing {
          ...TubingsAllFields
        }
        r_bottom_tubing: bottom_tubing {
          ...TubingsAllFields
        }
        r_top_casing: top_casing {
          ...CasingsAllFields
        }
        r_bottom_casing: bottom_casing {
          ...CasingsAllFields
        }
        r_deviation_survey: deviation_survey {
          ...DeviationSurveyBaseFields
        }
      }
      r_performance_evaluations: performance_evaluations(
        order_by: {journal_created_at: asc}
        where: {journal_deleted_at: {_is_null: true}, scenario: {journal_deleted_at: {_is_null: true}, sizing: {journal_deleted_at: {_is_null: true}}}}
      ) {
        ...PerformanceEvaluationAllFields
        r_scenario: scenario {
          ...ScenariosListFields
          sizing {
            ...SizingsListFields
            well {
              ...WellsFields
            }
            customer {
              ...CustomersFields
            }
          }
        }
        r_author: author {
          ...UsersFields
        }
        r_xref_pumps: xref_pumps(where: {journal_deleted_at: {_is_null: true}}) {
          ...PerformanceEvaluationXrefPumpFields
        }
      }
    }
  }
  sizings_aggregate(where: $where) @include(if: $withAggregate) {
    id: __typename
    aggregate {
      id: __typename
      count
    }
  }
}
    ${SizingsFieldsFragmentDoc}
${UsersFieldsFragmentDoc}
${WellsFieldsFragmentDoc}
${CustomersFieldsFragmentDoc}
${ScenariosFieldsFragmentDoc}
${ScenarioCorrelationsFieldsFragmentDoc}
${ScenarioEquipmentBaseFieldsFragmentDoc}
${SensorsAllFieldsFragmentDoc}
${MleAllFieldsFragmentDoc}
${MotorsAllFieldsFragmentDoc}
${BoltOnDischargesAllFieldsFragmentDoc}
${CasingsAllFieldsFragmentDoc}
${YToolAllFieldsFragmentDoc}
${DownTransAllFieldsFragmentDoc}
${UpTransAllFieldsFragmentDoc}
${VsdAllFieldsFragmentDoc}
${SwitchboardsAllFieldsFragmentDoc}
${SealMotorOilAllFieldsFragmentDoc}
${ScenarioEquipmentPumpsFieldsFragmentDoc}
${PumpsAllFieldsFragmentDoc}
${HousingsAllFieldsFragmentDoc}
${ScenarioEquipmentHousingsFieldsFragmentDoc}
${ScenarioEquipmentIntakesBaseFieldsFragmentDoc}
${IntakesAllFieldsFragmentDoc}
${ScenarioEquipmentSealsBaseFieldsFragmentDoc}
${SealsAllFieldsFragmentDoc}
${ScenarioEquipmentCablesBaseFieldsFragmentDoc}
${CablesAllFieldsFragmentDoc}
${ScenarioEquipmentXrefUpholeYToolBypassTubingsBaseFieldsFragmentDoc}
${TubingsAllFieldsFragmentDoc}
${ScenarioEquipmentXrefUpholeYToolEquipmentTubingsBaseFieldsFragmentDoc}
${ScenarioEquipmentXrefDownholeYToolBypassTubingsBaseFieldsFragmentDoc}
${ScenarioEquipmentXrefDownholeYToolEquipmentTubingsBaseFieldsFragmentDoc}
${ScenarioParametersBaseFieldsFragmentDoc}
${ScenarioWellPropertiesBaseFieldsFragmentDoc}
${DeviationSurveyBaseFieldsFragmentDoc}
${PerformanceEvaluationAllFieldsFragmentDoc}
${ScenariosListFieldsFragmentDoc}
${SizingsListFieldsFragmentDoc}
${PerformanceEvaluationXrefPumpFieldsFragmentDoc}`;

export function useSizingsQuery(options: Omit<Urql.UseQueryArgs<never, SizingsQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<SizingsQuery>({ query: SizingsDocument, ...options });
};
export const SizingsWithScenarioIdsDocument = gql`
    query SizingsWithScenarioIds($limit: Int, $offset: Int, $where: sizings_bool_exp, $order_by: [sizings_order_by!], $withAggregate: Boolean! = false, $withImportUser: Boolean! = false) {
  sizings(limit: $limit, offset: $offset, where: $where, order_by: $order_by) {
    ...SizingsFields
    parent_sizing {
      id
      title
      pumping_type
      journal_deleted_at
      installed_scenario_id
      scenarios(
        where: {journal_deleted_at: {_is_null: true}, sizing: {journal_deleted_at: {_is_null: true}}}
        order_by: [{journal_created_at: asc}]
      ) {
        id
        title
      }
    }
    author {
      ...UsersFields
    }
    well {
      ...WellsFields
    }
    customer {
      ...CustomersFields
    }
    imported_from_sizing @include(if: $withImportUser) {
      id
      legacy_author_id
      legacy_user {
        hal_identifier
        display_name
      }
    }
    scenarios(
      where: {journal_deleted_at: {_is_null: true}, sizing: {journal_deleted_at: {_is_null: true}}}
      order_by: [{journal_created_at: asc}]
    ) {
      id
      title
    }
  }
  sizings_aggregate(where: $where) @include(if: $withAggregate) {
    id: __typename
    aggregate {
      id: __typename
      count
    }
  }
}
    ${SizingsFieldsFragmentDoc}
${UsersFieldsFragmentDoc}
${WellsFieldsFragmentDoc}
${CustomersFieldsFragmentDoc}`;

export function useSizingsWithScenarioIdsQuery(options: Omit<Urql.UseQueryArgs<never, SizingsWithScenarioIdsQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<SizingsWithScenarioIdsQuery>({ query: SizingsWithScenarioIdsDocument, ...options });
};
export const InsertSizingsRevisionDocument = gql`
    mutation InsertSizingsRevision($objects: [revisions_sizings_revisions_insert_input!]!) {
  insert_revisions_sizings_revisions(objects: $objects) {
    returning {
      id
      sizings_view {
        ...SizingsFields
        well {
          ...WellsFields
        }
        customer {
          ...CustomersFields
        }
      }
    }
  }
}
    ${SizingsFieldsFragmentDoc}
${WellsFieldsFragmentDoc}
${CustomersFieldsFragmentDoc}`;

export function useInsertSizingsRevisionMutation() {
  return Urql.useMutation<InsertSizingsRevisionMutation, InsertSizingsRevisionMutationVariables>(InsertSizingsRevisionDocument);
};
export const SizingsManifoldDocument = gql`
    mutation SizingsManifold($sizings_revisions: [revisions_sizings_revisions_insert_input!]!, $scenarios_revisions: [revisions_scenarios_revisions_insert_input!]!, $scenario_equipment_revisions: [revisions_scenario_equipment_revisions_insert_input!]!, $scenario_parameters_revisions: [revisions_scenario_parameters_revisions_insert_input!]!, $scenario_well_properties_revisions: [revisions_scenario_well_properties_revisions_insert_input!]!, $deviation_survey: [deviation_survey_insert_input!]!, $scenario_correlations_revisions: [revisions_scenario_correlations_revisions_insert_input!]!, $scenario_equipment_xref_seals_revisions: [revisions_scenario_equipment_xref_seals_revisions_insert_input!]!, $scenario_equipment_xref_intakes_revisions: [revisions_scenario_equipment_xref_intakes_revisions_insert_input!]!, $scenario_equipment_xref_cables_revisions: [revisions_scenario_equipment_xref_cables_revisions_insert_input!]!, $scenario_equipment_xref_pumps_revisions: [revisions_scenario_equipment_xref_pumps_revisions_insert_input!]!, $scenario_equipment_xref_housings_revisions: [revisions_scenario_equipment_xref_housings_revisions_insert_input!]!, $sc_equip_xref_uphole_ytool_bypass_tubings_revisions: [revisions_sc_equip_xref_uphole_ytool_bypass_tubings_revisions_insert_input!]!, $sc_equip_xref_uphole_ytool_equip_tubings_revisions: [revisions_sc_equip_xref_uphole_ytool_equip_tubings_revisions_insert_input!]!, $sc_equip_xref_downhole_ytool_bypass_tubings_revisions: [revisions_sc_equip_xref_downhole_ytool_bypass_tubings_revisions_insert_input!]!, $sc_equip_xref_downhole_ytool_equip_tubings_revisions: [revisions_sc_equip_xref_downhole_ytool_equip_tubings_revisions_insert_input!]!) {
  insert_revisions_sizings_revisions(objects: $sizings_revisions) {
    affected_rows
    returning {
      id
      sizings_view {
        ...SizingsFields
      }
    }
  }
  insert_revisions_scenario_equipment_revisions(
    objects: $scenario_equipment_revisions
  ) {
    affected_rows
    returning {
      id
      scenario_equipment_view {
        ...ScenarioEquipmentBaseFields
        r_sensor: sensor {
          ...SensorsBaseFields
        }
        r_lower_sensor: lower_sensor {
          ...SensorsBaseFields
        }
        r_mle: mle {
          ...MleBaseFields
        }
        r_lower_mle: lower_mle {
          ...MleBaseFields
        }
        r_motor: motor {
          ...MotorsAllFields
        }
        r_bolt_on_discharge: bolt_on_discharge {
          ...BoltOnDischargesAllFields
        }
        r_lower_bolt_on_discharge: lower_bolt_on_discharge {
          ...BoltOnDischargesAllFields
        }
        r_lower_motor: lower_motor {
          ...MotorsAllFields
        }
        r_shroud: shroud {
          ...CasingsAllFields
        }
        r_lower_shroud: lower_shroud {
          ...CasingsAllFields
        }
        r_step_down_transformer: step_down_transformer {
          ...DownTransAllFields
        }
        r_step_up_transformer: step_up_transformer {
          ...UpTransAllFields
        }
        r_vsd: vsd {
          ...VsdAllFields
        }
        r_switchboard: switchboard {
          ...SwitchboardsAllFields
        }
        r_seal_motor_oil: seal_motor_oil {
          ...SealMotorOilAllFields
        }
        r_lower_seal_motor_oil: lower_seal_motor_oil {
          ...SealMotorOilAllFields
        }
        r_uphole_y_tool: uphole_y_tool {
          ...YToolAllFields
        }
        r_downhole_y_tool: downhole_y_tool {
          ...YToolAllFields
        }
      }
    }
  }
  insert_revisions_scenario_parameters_revisions(
    objects: $scenario_parameters_revisions
  ) {
    affected_rows
    returning {
      id
      scenario_parameters_view {
        ...ScenarioParametersBaseFields
      }
    }
  }
  insert_deviation_survey(
    objects: $deviation_survey
    on_conflict: {constraint: deviation_survey_pkey, update_columns: [directional_data_set, title, deleted_at]}
  ) {
    affected_rows
    returning {
      ...DeviationSurveyBaseFields
    }
  }
  insert_revisions_scenario_equipment_xref_seals_revisions(
    objects: $scenario_equipment_xref_seals_revisions
  ) {
    returning {
      id
      scenario_equipment_xref_seals_view {
        ...ScenarioEquipmentSealsBaseFields
        seal {
          ...SealsAllFields
        }
      }
    }
  }
  insert_revisions_scenario_well_properties_revisions(
    objects: $scenario_well_properties_revisions
  ) {
    affected_rows
    returning {
      id
      scenario_well_properties_view {
        ...ScenarioWellPropertiesBaseFields
        deviation_survey {
          ...DeviationSurveyBaseFields
        }
      }
    }
  }
  insert_revisions_scenario_correlations_revisions(
    objects: $scenario_correlations_revisions
  ) {
    affected_rows
    returning {
      id
      scenario_correlations_view {
        ...ScenarioCorrelationsFields
      }
    }
  }
  insert_revisions_scenario_equipment_xref_intakes_revisions(
    objects: $scenario_equipment_xref_intakes_revisions
  ) {
    returning {
      id
      scenario_equipment_xref_intakes_view {
        ...ScenarioEquipmentIntakesBaseFields
        intake {
          ...IntakesAllFields
        }
      }
    }
  }
  insert_revisions_scenario_equipment_xref_cables_revisions(
    objects: $scenario_equipment_xref_cables_revisions
  ) {
    returning {
      id
      scenario_equipment_xref_cables_view {
        ...ScenarioEquipmentCablesBaseFields
        cable {
          ...CablesAllFields
        }
      }
    }
  }
  insert_revisions_scenario_equipment_xref_pumps_revisions(
    objects: $scenario_equipment_xref_pumps_revisions
  ) {
    returning {
      id
      scenario_equipment_xref_pumps_view {
        ...ScenarioEquipmentPumpsFields
        pump {
          ...PumpsBaseFields
        }
        xref_housings(where: {journal_deleted_at: {_is_null: true}}) {
          ...ScenarioEquipmentHousingsFields
          housing {
            ...HousingBaseFields
          }
        }
      }
    }
  }
  insert_revisions_scenario_equipment_xref_housings_revisions(
    objects: $scenario_equipment_xref_housings_revisions
  ) {
    returning {
      id
      scenario_equipment_xref_housings_view {
        ...ScenarioEquipmentHousingsFields
        housing {
          ...HousingsAllFields
        }
      }
    }
  }
  insert_revisions_sc_equip_xref_uphole_ytool_bypass_tubings_revisions(
    objects: $sc_equip_xref_uphole_ytool_bypass_tubings_revisions
  ) {
    returning {
      id
      sc_equip_xref_uphole_ytool_bypass_tubings_view {
        ...ScenarioEquipmentXrefUpholeYToolBypassTubingsBaseFields
        tubing {
          ...TubingsAllFields
        }
      }
    }
  }
  insert_revisions_sc_equip_xref_uphole_ytool_equip_tubings_revisions(
    objects: $sc_equip_xref_uphole_ytool_equip_tubings_revisions
  ) {
    returning {
      id
      sc_equip_xref_uphole_ytool_equip_tubings_view {
        ...ScenarioEquipmentXrefUpholeYToolEquipmentTubingsBaseFields
        tubing {
          ...TubingsAllFields
        }
      }
    }
  }
  insert_revisions_sc_equip_xref_downhole_ytool_bypass_tubings_revisions(
    objects: $sc_equip_xref_downhole_ytool_bypass_tubings_revisions
  ) {
    returning {
      id
      sc_equip_xref_downhole_ytool_bypass_tubings_view {
        ...ScenarioEquipmentXrefDownholeYToolBypassTubingsBaseFields
        tubing {
          ...TubingsAllFields
        }
      }
    }
  }
  insert_revisions_sc_equip_xref_downhole_ytool_equip_tubings_revisions(
    objects: $sc_equip_xref_downhole_ytool_equip_tubings_revisions
  ) {
    returning {
      id
      sc_equip_xref_downhole_ytool_equip_tubings_view {
        ...ScenarioEquipmentXrefDownholeYToolEquipmentTubingsBaseFields
        tubing {
          ...TubingsAllFields
        }
      }
    }
  }
  insert_revisions_scenarios_revisions(objects: $scenarios_revisions) {
    affected_rows
    returning {
      id
      scenarios_view {
        ...ScenariosFields
        author {
          ...UsersFields
        }
      }
    }
  }
}
    ${SizingsFieldsFragmentDoc}
${ScenarioEquipmentBaseFieldsFragmentDoc}
${SensorsBaseFieldsFragmentDoc}
${MleBaseFieldsFragmentDoc}
${MotorsAllFieldsFragmentDoc}
${BoltOnDischargesAllFieldsFragmentDoc}
${CasingsAllFieldsFragmentDoc}
${DownTransAllFieldsFragmentDoc}
${UpTransAllFieldsFragmentDoc}
${VsdAllFieldsFragmentDoc}
${SwitchboardsAllFieldsFragmentDoc}
${SealMotorOilAllFieldsFragmentDoc}
${YToolAllFieldsFragmentDoc}
${ScenarioParametersBaseFieldsFragmentDoc}
${DeviationSurveyBaseFieldsFragmentDoc}
${ScenarioEquipmentSealsBaseFieldsFragmentDoc}
${SealsAllFieldsFragmentDoc}
${ScenarioWellPropertiesBaseFieldsFragmentDoc}
${ScenarioCorrelationsFieldsFragmentDoc}
${ScenarioEquipmentIntakesBaseFieldsFragmentDoc}
${IntakesAllFieldsFragmentDoc}
${ScenarioEquipmentCablesBaseFieldsFragmentDoc}
${CablesAllFieldsFragmentDoc}
${ScenarioEquipmentPumpsFieldsFragmentDoc}
${PumpsBaseFieldsFragmentDoc}
${ScenarioEquipmentHousingsFieldsFragmentDoc}
${HousingBaseFieldsFragmentDoc}
${HousingsAllFieldsFragmentDoc}
${ScenarioEquipmentXrefUpholeYToolBypassTubingsBaseFieldsFragmentDoc}
${TubingsAllFieldsFragmentDoc}
${ScenarioEquipmentXrefUpholeYToolEquipmentTubingsBaseFieldsFragmentDoc}
${ScenarioEquipmentXrefDownholeYToolBypassTubingsBaseFieldsFragmentDoc}
${ScenarioEquipmentXrefDownholeYToolEquipmentTubingsBaseFieldsFragmentDoc}
${ScenariosFieldsFragmentDoc}
${UsersFieldsFragmentDoc}`;

export function useSizingsManifoldMutation() {
  return Urql.useMutation<SizingsManifoldMutation, SizingsManifoldMutationVariables>(SizingsManifoldDocument);
};
export const SkBillablesDocument = gql`
    query SKBillables($summitQueryString: String!) {
  getSKBillables(summitQueryString: $summitQueryString) {
    id
    margin
    material_description
    material_long_description
    material_number
    material_type
    price
    pricing_date
    quantity
    quote_price
    total
    notes_description
    serialized
    prod_hierarchy
  }
}
    `;

export function useSkBillablesQuery(options: Omit<Urql.UseQueryArgs<never, SkBillablesQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<SkBillablesQuery>({ query: SkBillablesDocument, ...options });
};
export const SkContractsDocument = gql`
    query SKContracts($summitQueryString: String!) {
  getSKContracts(summitQueryString: $summitQueryString) {
    id: number
    active
    customer
    date_range {
      id: __typename
      bounds
      lower
      upper
    }
    deleted
    name
    number
    price_list {
      id: __typename
      active
      deleted
      name
      number
    }
    pricing_date
  }
}
    `;

export function useSkContractsQuery(options: Omit<Urql.UseQueryArgs<never, SkContractsQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<SkContractsQuery>({ query: SkContractsDocument, ...options });
};
export const GetSkCurrenciesDocument = gql`
    query getSKCurrencies($summitQueryString: String) {
  getSKCurrencies(summitQueryString: $summitQueryString) {
    id: code
    code
    active
    deleted
    description
  }
}
    `;

export function useGetSkCurrenciesQuery(options: Omit<Urql.UseQueryArgs<never, GetSkCurrenciesQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<GetSkCurrenciesQuery>({ query: GetSkCurrenciesDocument, ...options });
};
export const SkCustomersDocument = gql`
    query SKCustomers($summitQueryString: String) {
  getSKCustomers(summitQueryString: $summitQueryString) {
    id
    name
  }
}
    `;

export function useSkCustomersQuery(options: Omit<Urql.UseQueryArgs<never, SkCustomersQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<SkCustomersQuery>({ query: SkCustomersDocument, ...options });
};
export const SkEquipmentTypeConversionsDocument = gql`
    query SKEquipmentTypeConversions($summitQueryString: String!) {
  getSKEquipmentTypeConversions(summitQueryString: $summitQueryString) {
    id
    equipment_type
    sap_server
    label
    cable_type
    hierarchy_numbers
  }
}
    `;

export function useSkEquipmentTypeConversionsQuery(options: Omit<Urql.UseQueryArgs<never, SkEquipmentTypeConversionsQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<SkEquipmentTypeConversionsQuery>({ query: SkEquipmentTypeConversionsDocument, ...options });
};
export const SkJobsDocument = gql`
    query SKJobs($summitQueryString: String) {
  getSKJobs(summitQueryString: $summitQueryString) {
    ...JobFields
  }
}
    ${JobFieldsFragmentDoc}`;

export function useSkJobsQuery(options: Omit<Urql.UseQueryArgs<never, SkJobsQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<SkJobsQuery>({ query: SkJobsDocument, ...options });
};
export const InsertJobDocument = gql`
    mutation InsertJob($object: SKJobInput!) {
  createSKJob(input: $object) {
    ...JobFields
  }
}
    ${JobFieldsFragmentDoc}`;

export function useInsertJobMutation() {
  return Urql.useMutation<InsertJobMutation, InsertJobMutationVariables>(InsertJobDocument);
};
export const SkMaterialsDocument = gql`
    query SKMaterials($summitQueryString: String) {
  getSKMaterials(summitQueryString: $summitQueryString) {
    id: number
    active
    api_response_count
    base_uom
    deleted
    description
    extended_to_plants
    long_description
    material_type
    number
    pricing {
      currency
      date_range {
        bounds
        lower
        upper
      }
      floor
      number
      price
      pricing_date
      type
      uom
    }
    cable_inventory {
      available
      available_count
      inventory_count
      reserved
    }
    inventory {
      available
      reserved
    }
    prod_hierarchy
    refurb_of
    serialized
    so_uom
    spooled_type
    standard_offering
  }
}
    `;

export function useSkMaterialsQuery(options: Omit<Urql.UseQueryArgs<never, SkMaterialsQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<SkMaterialsQuery>({ query: SkMaterialsDocument, ...options });
};
export const SkMaterialsPaginatedDocument = gql`
    query SKMaterialsPaginated($summitQueryString: String) {
  getSKMaterialsPaginated(summitQueryString: $summitQueryString) {
    count
    next
    previous
    results {
      id: number
      active
      base_uom
      deleted
      description
      extended_to_plants
      long_description
      material_type
      number
      pricing {
        currency
        date_range {
          bounds
          lower
          upper
        }
        floor
        number
        price
        pricing_date
        type
        uom
      }
      cable_inventory {
        available
        available_count
        inventory_count
        reserved
      }
      inventory {
        available
        reserved
      }
      prod_hierarchy
      refurb_of
      serialized
      so_uom
      spooled_type
      standard_offering
    }
  }
}
    `;

export function useSkMaterialsPaginatedQuery(options: Omit<Urql.UseQueryArgs<never, SkMaterialsPaginatedQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<SkMaterialsPaginatedQuery>({ query: SkMaterialsPaginatedDocument, ...options });
};
export const GetSkNwasDocument = gql`
    query getSKNwas($summitQueryString: String) {
  getSKNwas(summitQueryString: $summitQueryString) {
    id
    name
    al_name
    display_name
    active
    deleted
    deprecated
    country
  }
}
    `;

export function useGetSkNwasQuery(options: Omit<Urql.UseQueryArgs<never, GetSkNwasQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<GetSkNwasQuery>({ query: GetSkNwasDocument, ...options });
};
export const GetSkPlanningOrderDocument = gql`
    query getSKPlanningOrder($summitQueryString: String!) {
  getSKPlanningOrder(summitQueryString: $summitQueryString) {
    id: planning_order
    planning_order
    currency
    contract
    natural_work_area
    nwa_id
    plant_erp_id
    plant_name
    price_list_number
    price_list_name
  }
}
    `;

export function useGetSkPlanningOrderQuery(options: Omit<Urql.UseQueryArgs<never, GetSkPlanningOrderQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<GetSkPlanningOrderQuery>({ query: GetSkPlanningOrderDocument, ...options });
};
export const SkPlantsDocument = gql`
    query SKPlants($summitQueryString: String!) {
  getSKPlants(summitQueryString: $summitQueryString) {
    id
    active
    deleted
    name
  }
}
    `;

export function useSkPlantsQuery(options: Omit<Urql.UseQueryArgs<never, SkPlantsQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<SkPlantsQuery>({ query: SkPlantsDocument, ...options });
};
export const SkPriceListsDocument = gql`
    query SKPriceLists($summitQueryString: String!) {
  getSKPriceLists(summitQueryString: $summitQueryString) {
    id: name
    name
    number
    deleted
    active
  }
}
    `;

export function useSkPriceListsQuery(options: Omit<Urql.UseQueryArgs<never, SkPriceListsQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<SkPriceListsQuery>({ query: SkPriceListsDocument, ...options });
};
export const InsertSkQuoteDocument = gql`
    mutation InsertSKQuote($object: SKQuoteInput!) {
  createSKQuote(input: $object) {
    ...SKQuoteFields
  }
}
    ${SkQuoteFieldsFragmentDoc}`;

export function useInsertSkQuoteMutation() {
  return Urql.useMutation<InsertSkQuoteMutation, InsertSkQuoteMutationVariables>(InsertSkQuoteDocument);
};
export const DeleteSkQuoteDocument = gql`
    mutation DeleteSKQuote($object: SKDeleteQuoteInput!) {
  deleteSKQuote(input: $object) {
    ...SKDeleteQuoteFields
  }
}
    ${SkDeleteQuoteFieldsFragmentDoc}`;

export function useDeleteSkQuoteMutation() {
  return Urql.useMutation<DeleteSkQuoteMutation, DeleteSkQuoteMutationVariables>(DeleteSkQuoteDocument);
};
export const UpdateSkQuoteJobDocument = gql`
    mutation UpdateSKQuoteJob($object: SKQuoteInput!) {
  updateSKQuoteJob(input: $object) {
    ...SKQuoteFields
  }
}
    ${SkQuoteFieldsFragmentDoc}`;

export function useUpdateSkQuoteJobMutation() {
  return Urql.useMutation<UpdateSkQuoteJobMutation, UpdateSkQuoteJobMutationVariables>(UpdateSkQuoteJobDocument);
};
export const SkWellAddressesDocument = gql`
    query SKWellAddresses($summitQueryString: String) {
  getSKWellAddresses(summitQueryString: $summitQueryString) {
    address {
      city
      district
      full_address
      id
      name
      name1
      name2
      name3
      name4
      phone_number
      postal_code
      region {
        active
        code
        country {
          active
          code
          deleted
          name
        }
        deleted
        id
        name
      }
      street
    }
    customer {
      active
      deleted
      id
      msa_signed
      name
      name1
      name2
      name3
      name4
    }
    well {
      active
      coordinates {
        coordinates
        type
      }
      deleted
      id
      latitude
      longitude
      name
      name1
      name2
      name3
      name4
      region
      uwi
      uwi_computed
      well_type
    }
    well_address_id
  }
}
    `;

export function useSkWellAddressesQuery(options: Omit<Urql.UseQueryArgs<never, SkWellAddressesQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<SkWellAddressesQuery>({ query: SkWellAddressesDocument, ...options });
};
export const StatusDocument = gql`
    subscription Status($where: status_bool_exp, $order_by: [status_order_by!], $offset: Int, $limit: Int, $distinct_on: [status_select_column!]) {
  status(
    where: $where
    order_by: $order_by
    offset: $offset
    limit: $limit
    distinct_on: $distinct_on
  ) {
    ...StatusFields
  }
}
    ${StatusFieldsFragmentDoc}`;

export function useStatusSubscription<R = StatusSubscription>(options: Omit<Urql.UseSubscriptionArgs<never, StatusSubscriptionVariables>, 'query'> = {}, handler?: Urql.SubscriptionHandlerArg<StatusSubscription, R>) {
  return Urql.useSubscription<StatusSubscription, R, StatusSubscriptionVariables>({ query: StatusDocument, ...options }, handler);
};
export const TubingsTypesDocument = gql`
    query TubingsTypes {
  tubings_type {
    ...TubingsTypeFields
  }
}
    ${TubingsTypeFieldsFragmentDoc}`;

export function useTubingsTypesQuery(options: Omit<Urql.UseQueryArgs<never, TubingsTypesQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<TubingsTypesQuery>({ query: TubingsTypesDocument, ...options });
};
export const GetUserEulaAcceptancesDocument = gql`
    query GetUserEulaAcceptances($id: uuid) {
  user_eula_acceptance(where: {eula_id: {_eq: $id}}) {
    __typename
    id
    eula_id
  }
}
    `;

export function useGetUserEulaAcceptancesQuery(options: Omit<Urql.UseQueryArgs<never, GetUserEulaAcceptancesQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<GetUserEulaAcceptancesQuery>({ query: GetUserEulaAcceptancesDocument, ...options });
};
export const AcceptEulaDocument = gql`
    mutation AcceptEula($eulaId: uuid!) {
  insert_user_eula_acceptance_one(object: {eula_id: $eulaId}) {
    id
    user_id
    eula_id
    signed_at
  }
}
    `;

export function useAcceptEulaMutation() {
  return Urql.useMutation<AcceptEulaMutation, AcceptEulaMutationVariables>(AcceptEulaDocument);
};
export const GetAllEulaAcceptancesDocument = gql`
    query GetAllEulaAcceptances {
  user_eula_acceptance(order_by: {eula: {created_at: desc}}) {
    __typename
    id
    user {
      __typename
      id
      display_name
      email
      hal_identifier
    }
    signed_at
    eula {
      __typename
      id
      created_at
      activated_on
      activated
    }
  }
}
    `;

export function useGetAllEulaAcceptancesQuery(options: Omit<Urql.UseQueryArgs<never, GetAllEulaAcceptancesQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<GetAllEulaAcceptancesQuery>({ query: GetAllEulaAcceptancesDocument, ...options });
};
export const UsersDocument = gql`
    query Users($where: users_bool_exp, $order_by: [users_order_by!], $offset: Int, $limit: Int, $distinct_on: [users_select_column!]) {
  users(
    where: $where
    order_by: $order_by
    offset: $offset
    limit: $limit
    distinct_on: $distinct_on
  ) {
    ...UsersFields
  }
}
    ${UsersFieldsFragmentDoc}`;

export function useUsersQuery(options: Omit<Urql.UseQueryArgs<never, UsersQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<UsersQuery>({ query: UsersDocument, ...options });
};
export const WellTestGasInputOptionsDocument = gql`
    query WellTestGasInputOptions {
  well_test_gas_input_options {
    ...WellTestGasInputOptionsFields
  }
}
    ${WellTestGasInputOptionsFieldsFragmentDoc}`;

export function useWellTestGasInputOptionsQuery(options: Omit<Urql.UseQueryArgs<never, WellTestGasInputOptionsQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<WellTestGasInputOptionsQuery>({ query: WellTestGasInputOptionsDocument, ...options });
};
export const WellTestLiquidInputOptionsDocument = gql`
    query WellTestLiquidInputOptions {
  well_test_liquid_input_options {
    ...WellTestLiquidInputOptionsFields
  }
}
    ${WellTestLiquidInputOptionsFieldsFragmentDoc}`;

export function useWellTestLiquidInputOptionsQuery(options: Omit<Urql.UseQueryArgs<never, WellTestLiquidInputOptionsQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<WellTestLiquidInputOptionsQuery>({ query: WellTestLiquidInputOptionsDocument, ...options });
};
export const WellTestPressureInputOptionsDocument = gql`
    query WellTestPressureInputOptions {
  well_test_pressure_input_options {
    ...WellTestPressureInputOptionsFields
  }
}
    ${WellTestPressureInputOptionsFieldsFragmentDoc}`;

export function useWellTestPressureInputOptionsQuery(options: Omit<Urql.UseQueryArgs<never, WellTestPressureInputOptionsQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<WellTestPressureInputOptionsQuery>({ query: WellTestPressureInputOptionsDocument, ...options });
};
export const WellsDocument = gql`
    query Wells($limit: Int, $offset: Int, $where: wells_bool_exp, $order_by: [wells_order_by!], $withAggregate: Boolean!, $withSizings: Boolean!) {
  wells(limit: $limit, offset: $offset, where: $where, order_by: $order_by) {
    id
    well_name
    well_uwi
    well_erp_id
    sizings(limit: 1, order_by: [{journal_updated_at: desc}]) @include(if: $withSizings) {
      id
      title
      journal_updated_at
    }
  }
  wells_aggregate(where: $where) @include(if: $withAggregate) {
    id: __typename
    aggregate {
      id: __typename
      count
    }
  }
}
    `;

export function useWellsQuery(options: Omit<Urql.UseQueryArgs<never, WellsQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<WellsQuery>({ query: WellsDocument, ...options });
};
export const UpsertWellDocument = gql`
    mutation UpsertWell($object: wells_insert_input!) {
  insert_wells_one(
    object: $object
    on_conflict: {constraint: wells_erp_well_address_slug_unique_key, update_columns: [well_uwi, well_name]}
  ) {
    ...WellsFields
  }
}
    ${WellsFieldsFragmentDoc}`;

export function useUpsertWellMutation() {
  return Urql.useMutation<UpsertWellMutation, UpsertWellMutationVariables>(UpsertWellDocument);
};
export type WithTypename<T extends { __typename?: any }> = Partial<T> & { __typename: NonNullable<T['__typename']> };

export type GraphCacheKeysConfig = {
  AccountManager?: (data: WithTypename<AccountManager>) => null | string,
  CanBeMerged?: (data: WithTypename<CanBeMerged>) => null | string,
  CreditCheckOverrideUser?: (data: WithTypename<CreditCheckOverrideUser>) => null | string,
  ERPCustomer?: (data: WithTypename<ErpCustomer>) => null | string,
  ERPWellAddress?: (data: WithTypename<ErpWellAddress>) => null | string,
  ErpWell?: (data: WithTypename<ErpWell>) => null | string,
  ErpWellReadings?: (data: WithTypename<ErpWellReadings>) => null | string,
  JobType?: (data: WithTypename<JobType>) => null | string,
  Ocms?: (data: WithTypename<Ocms>) => null | string,
  PreparedBy?: (data: WithTypename<PreparedBy>) => null | string,
  SKAddress?: (data: WithTypename<SkAddress>) => null | string,
  SKBillable?: (data: WithTypename<SkBillable>) => null | string,
  SKCableInventory?: (data: WithTypename<SkCableInventory>) => null | string,
  SKContract?: (data: WithTypename<SkContract>) => null | string,
  SKCoordinates?: (data: WithTypename<SkCoordinates>) => null | string,
  SKCountry?: (data: WithTypename<SkCountry>) => null | string,
  SKCurrency?: (data: WithTypename<SkCurrency>) => null | string,
  SKCustomer?: (data: WithTypename<SkCustomer>) => null | string,
  SKDeleteQuote?: (data: WithTypename<SkDeleteQuote>) => null | string,
  SKEquipmentTypeConversion?: (data: WithTypename<SkEquipmentTypeConversion>) => null | string,
  SKInventory?: (data: WithTypename<SkInventory>) => null | string,
  SKJob?: (data: WithTypename<SkJob>) => null | string,
  SKMaterial?: (data: WithTypename<SkMaterial>) => null | string,
  SKMaterialDateRange?: (data: WithTypename<SkMaterialDateRange>) => null | string,
  SKMaterialPricing?: (data: WithTypename<SkMaterialPricing>) => null | string,
  SKMaterialsPaginated?: (data: WithTypename<SkMaterialsPaginated>) => null | string,
  SKNwa?: (data: WithTypename<SkNwa>) => null | string,
  SKPlanningOrder?: (data: WithTypename<SkPlanningOrder>) => null | string,
  SKPlant?: (data: WithTypename<SkPlant>) => null | string,
  SKPriceList?: (data: WithTypename<SkPriceList>) => null | string,
  SKQuote?: (data: WithTypename<SkQuote>) => null | string,
  SKRegion?: (data: WithTypename<SkRegion>) => null | string,
  SKWell?: (data: WithTypename<SkWell>) => null | string,
  SKWellAddress?: (data: WithTypename<SkWellAddress>) => null | string,
  SKWellAddressCustomer?: (data: WithTypename<SkWellAddressCustomer>) => null | string,
  bolt_on_discharges?: (data: WithTypename<Bolt_On_Discharges>) => null | string,
  bolt_on_discharges_aggregate?: (data: WithTypename<Bolt_On_Discharges_Aggregate>) => null | string,
  bolt_on_discharges_aggregate_fields?: (data: WithTypename<Bolt_On_Discharges_Aggregate_Fields>) => null | string,
  bolt_on_discharges_avg_fields?: (data: WithTypename<Bolt_On_Discharges_Avg_Fields>) => null | string,
  bolt_on_discharges_max_fields?: (data: WithTypename<Bolt_On_Discharges_Max_Fields>) => null | string,
  bolt_on_discharges_min_fields?: (data: WithTypename<Bolt_On_Discharges_Min_Fields>) => null | string,
  bolt_on_discharges_mutation_response?: (data: WithTypename<Bolt_On_Discharges_Mutation_Response>) => null | string,
  bolt_on_discharges_stddev_fields?: (data: WithTypename<Bolt_On_Discharges_Stddev_Fields>) => null | string,
  bolt_on_discharges_stddev_pop_fields?: (data: WithTypename<Bolt_On_Discharges_Stddev_Pop_Fields>) => null | string,
  bolt_on_discharges_stddev_samp_fields?: (data: WithTypename<Bolt_On_Discharges_Stddev_Samp_Fields>) => null | string,
  bolt_on_discharges_sum_fields?: (data: WithTypename<Bolt_On_Discharges_Sum_Fields>) => null | string,
  bolt_on_discharges_var_pop_fields?: (data: WithTypename<Bolt_On_Discharges_Var_Pop_Fields>) => null | string,
  bolt_on_discharges_var_samp_fields?: (data: WithTypename<Bolt_On_Discharges_Var_Samp_Fields>) => null | string,
  bolt_on_discharges_variance_fields?: (data: WithTypename<Bolt_On_Discharges_Variance_Fields>) => null | string,
  bubble_point_options?: (data: WithTypename<Bubble_Point_Options>) => null | string,
  bubble_point_options_aggregate?: (data: WithTypename<Bubble_Point_Options_Aggregate>) => null | string,
  bubble_point_options_aggregate_fields?: (data: WithTypename<Bubble_Point_Options_Aggregate_Fields>) => null | string,
  bubble_point_options_max_fields?: (data: WithTypename<Bubble_Point_Options_Max_Fields>) => null | string,
  bubble_point_options_min_fields?: (data: WithTypename<Bubble_Point_Options_Min_Fields>) => null | string,
  bubble_point_options_mutation_response?: (data: WithTypename<Bubble_Point_Options_Mutation_Response>) => null | string,
  cables?: (data: WithTypename<Cables>) => null | string,
  cables_aggregate?: (data: WithTypename<Cables_Aggregate>) => null | string,
  cables_aggregate_fields?: (data: WithTypename<Cables_Aggregate_Fields>) => null | string,
  cables_avg_fields?: (data: WithTypename<Cables_Avg_Fields>) => null | string,
  cables_max_fields?: (data: WithTypename<Cables_Max_Fields>) => null | string,
  cables_min_fields?: (data: WithTypename<Cables_Min_Fields>) => null | string,
  cables_mutation_response?: (data: WithTypename<Cables_Mutation_Response>) => null | string,
  cables_stddev_fields?: (data: WithTypename<Cables_Stddev_Fields>) => null | string,
  cables_stddev_pop_fields?: (data: WithTypename<Cables_Stddev_Pop_Fields>) => null | string,
  cables_stddev_samp_fields?: (data: WithTypename<Cables_Stddev_Samp_Fields>) => null | string,
  cables_sum_fields?: (data: WithTypename<Cables_Sum_Fields>) => null | string,
  cables_var_pop_fields?: (data: WithTypename<Cables_Var_Pop_Fields>) => null | string,
  cables_var_samp_fields?: (data: WithTypename<Cables_Var_Samp_Fields>) => null | string,
  cables_variance_fields?: (data: WithTypename<Cables_Variance_Fields>) => null | string,
  casing_flow_options?: (data: WithTypename<Casing_Flow_Options>) => null | string,
  casing_flow_options_aggregate?: (data: WithTypename<Casing_Flow_Options_Aggregate>) => null | string,
  casing_flow_options_aggregate_fields?: (data: WithTypename<Casing_Flow_Options_Aggregate_Fields>) => null | string,
  casing_flow_options_max_fields?: (data: WithTypename<Casing_Flow_Options_Max_Fields>) => null | string,
  casing_flow_options_min_fields?: (data: WithTypename<Casing_Flow_Options_Min_Fields>) => null | string,
  casing_flow_options_mutation_response?: (data: WithTypename<Casing_Flow_Options_Mutation_Response>) => null | string,
  casings?: (data: WithTypename<Casings>) => null | string,
  casings_aggregate?: (data: WithTypename<Casings_Aggregate>) => null | string,
  casings_aggregate_fields?: (data: WithTypename<Casings_Aggregate_Fields>) => null | string,
  casings_avg_fields?: (data: WithTypename<Casings_Avg_Fields>) => null | string,
  casings_max_fields?: (data: WithTypename<Casings_Max_Fields>) => null | string,
  casings_min_fields?: (data: WithTypename<Casings_Min_Fields>) => null | string,
  casings_mutation_response?: (data: WithTypename<Casings_Mutation_Response>) => null | string,
  casings_stddev_fields?: (data: WithTypename<Casings_Stddev_Fields>) => null | string,
  casings_stddev_pop_fields?: (data: WithTypename<Casings_Stddev_Pop_Fields>) => null | string,
  casings_stddev_samp_fields?: (data: WithTypename<Casings_Stddev_Samp_Fields>) => null | string,
  casings_sum_fields?: (data: WithTypename<Casings_Sum_Fields>) => null | string,
  casings_type?: (data: WithTypename<Casings_Type>) => null | string,
  casings_type_aggregate?: (data: WithTypename<Casings_Type_Aggregate>) => null | string,
  casings_type_aggregate_fields?: (data: WithTypename<Casings_Type_Aggregate_Fields>) => null | string,
  casings_type_max_fields?: (data: WithTypename<Casings_Type_Max_Fields>) => null | string,
  casings_type_min_fields?: (data: WithTypename<Casings_Type_Min_Fields>) => null | string,
  casings_type_mutation_response?: (data: WithTypename<Casings_Type_Mutation_Response>) => null | string,
  casings_var_pop_fields?: (data: WithTypename<Casings_Var_Pop_Fields>) => null | string,
  casings_var_samp_fields?: (data: WithTypename<Casings_Var_Samp_Fields>) => null | string,
  casings_variance_fields?: (data: WithTypename<Casings_Variance_Fields>) => null | string,
  customers?: (data: WithTypename<Customers>) => null | string,
  customers_aggregate?: (data: WithTypename<Customers_Aggregate>) => null | string,
  customers_aggregate_fields?: (data: WithTypename<Customers_Aggregate_Fields>) => null | string,
  customers_avg_fields?: (data: WithTypename<Customers_Avg_Fields>) => null | string,
  customers_max_fields?: (data: WithTypename<Customers_Max_Fields>) => null | string,
  customers_min_fields?: (data: WithTypename<Customers_Min_Fields>) => null | string,
  customers_mutation_response?: (data: WithTypename<Customers_Mutation_Response>) => null | string,
  customers_stddev_fields?: (data: WithTypename<Customers_Stddev_Fields>) => null | string,
  customers_stddev_pop_fields?: (data: WithTypename<Customers_Stddev_Pop_Fields>) => null | string,
  customers_stddev_samp_fields?: (data: WithTypename<Customers_Stddev_Samp_Fields>) => null | string,
  customers_sum_fields?: (data: WithTypename<Customers_Sum_Fields>) => null | string,
  customers_var_pop_fields?: (data: WithTypename<Customers_Var_Pop_Fields>) => null | string,
  customers_var_samp_fields?: (data: WithTypename<Customers_Var_Samp_Fields>) => null | string,
  customers_variance_fields?: (data: WithTypename<Customers_Variance_Fields>) => null | string,
  dead_oil_options?: (data: WithTypename<Dead_Oil_Options>) => null | string,
  dead_oil_options_aggregate?: (data: WithTypename<Dead_Oil_Options_Aggregate>) => null | string,
  dead_oil_options_aggregate_fields?: (data: WithTypename<Dead_Oil_Options_Aggregate_Fields>) => null | string,
  dead_oil_options_max_fields?: (data: WithTypename<Dead_Oil_Options_Max_Fields>) => null | string,
  dead_oil_options_min_fields?: (data: WithTypename<Dead_Oil_Options_Min_Fields>) => null | string,
  dead_oil_options_mutation_response?: (data: WithTypename<Dead_Oil_Options_Mutation_Response>) => null | string,
  deviation_survey?: (data: WithTypename<Deviation_Survey>) => null | string,
  deviation_survey_aggregate?: (data: WithTypename<Deviation_Survey_Aggregate>) => null | string,
  deviation_survey_aggregate_fields?: (data: WithTypename<Deviation_Survey_Aggregate_Fields>) => null | string,
  deviation_survey_avg_fields?: (data: WithTypename<Deviation_Survey_Avg_Fields>) => null | string,
  deviation_survey_directional_dataset?: (data: WithTypename<Deviation_Survey_Directional_Dataset>) => null | string,
  deviation_survey_directional_dataset_aggregate?: (data: WithTypename<Deviation_Survey_Directional_Dataset_Aggregate>) => null | string,
  deviation_survey_directional_dataset_aggregate_fields?: (data: WithTypename<Deviation_Survey_Directional_Dataset_Aggregate_Fields>) => null | string,
  deviation_survey_directional_dataset_max_fields?: (data: WithTypename<Deviation_Survey_Directional_Dataset_Max_Fields>) => null | string,
  deviation_survey_directional_dataset_min_fields?: (data: WithTypename<Deviation_Survey_Directional_Dataset_Min_Fields>) => null | string,
  deviation_survey_directional_dataset_mutation_response?: (data: WithTypename<Deviation_Survey_Directional_Dataset_Mutation_Response>) => null | string,
  deviation_survey_max_fields?: (data: WithTypename<Deviation_Survey_Max_Fields>) => null | string,
  deviation_survey_min_fields?: (data: WithTypename<Deviation_Survey_Min_Fields>) => null | string,
  deviation_survey_mutation_response?: (data: WithTypename<Deviation_Survey_Mutation_Response>) => null | string,
  deviation_survey_stddev_fields?: (data: WithTypename<Deviation_Survey_Stddev_Fields>) => null | string,
  deviation_survey_stddev_pop_fields?: (data: WithTypename<Deviation_Survey_Stddev_Pop_Fields>) => null | string,
  deviation_survey_stddev_samp_fields?: (data: WithTypename<Deviation_Survey_Stddev_Samp_Fields>) => null | string,
  deviation_survey_sum_fields?: (data: WithTypename<Deviation_Survey_Sum_Fields>) => null | string,
  deviation_survey_var_pop_fields?: (data: WithTypename<Deviation_Survey_Var_Pop_Fields>) => null | string,
  deviation_survey_var_samp_fields?: (data: WithTypename<Deviation_Survey_Var_Samp_Fields>) => null | string,
  deviation_survey_variance_fields?: (data: WithTypename<Deviation_Survey_Variance_Fields>) => null | string,
  display_units?: (data: WithTypename<Display_Units>) => null | string,
  display_units_aggregate?: (data: WithTypename<Display_Units_Aggregate>) => null | string,
  display_units_aggregate_fields?: (data: WithTypename<Display_Units_Aggregate_Fields>) => null | string,
  display_units_max_fields?: (data: WithTypename<Display_Units_Max_Fields>) => null | string,
  display_units_min_fields?: (data: WithTypename<Display_Units_Min_Fields>) => null | string,
  display_units_mutation_response?: (data: WithTypename<Display_Units_Mutation_Response>) => null | string,
  eula?: (data: WithTypename<Eula>) => null | string,
  eula_aggregate?: (data: WithTypename<Eula_Aggregate>) => null | string,
  eula_aggregate_fields?: (data: WithTypename<Eula_Aggregate_Fields>) => null | string,
  eula_max_fields?: (data: WithTypename<Eula_Max_Fields>) => null | string,
  eula_min_fields?: (data: WithTypename<Eula_Min_Fields>) => null | string,
  eula_mutation_response?: (data: WithTypename<Eula_Mutation_Response>) => null | string,
  flow_model?: (data: WithTypename<Flow_Model>) => null | string,
  flow_model_active?: (data: WithTypename<Flow_Model_Active>) => null | string,
  flow_model_active_aggregate?: (data: WithTypename<Flow_Model_Active_Aggregate>) => null | string,
  flow_model_active_aggregate_fields?: (data: WithTypename<Flow_Model_Active_Aggregate_Fields>) => null | string,
  flow_model_active_max_fields?: (data: WithTypename<Flow_Model_Active_Max_Fields>) => null | string,
  flow_model_active_min_fields?: (data: WithTypename<Flow_Model_Active_Min_Fields>) => null | string,
  flow_model_active_mutation_response?: (data: WithTypename<Flow_Model_Active_Mutation_Response>) => null | string,
  flow_model_aggregate?: (data: WithTypename<Flow_Model_Aggregate>) => null | string,
  flow_model_aggregate_fields?: (data: WithTypename<Flow_Model_Aggregate_Fields>) => null | string,
  flow_model_deprecated?: (data: WithTypename<Flow_Model_Deprecated>) => null | string,
  flow_model_deprecated_aggregate?: (data: WithTypename<Flow_Model_Deprecated_Aggregate>) => null | string,
  flow_model_deprecated_aggregate_fields?: (data: WithTypename<Flow_Model_Deprecated_Aggregate_Fields>) => null | string,
  flow_model_deprecated_mutation_response?: (data: WithTypename<Flow_Model_Deprecated_Mutation_Response>) => null | string,
  flow_model_max_fields?: (data: WithTypename<Flow_Model_Max_Fields>) => null | string,
  flow_model_min_fields?: (data: WithTypename<Flow_Model_Min_Fields>) => null | string,
  flow_model_mutation_response?: (data: WithTypename<Flow_Model_Mutation_Response>) => null | string,
  friction_loss_options?: (data: WithTypename<Friction_Loss_Options>) => null | string,
  friction_loss_options_aggregate?: (data: WithTypename<Friction_Loss_Options_Aggregate>) => null | string,
  friction_loss_options_aggregate_fields?: (data: WithTypename<Friction_Loss_Options_Aggregate_Fields>) => null | string,
  friction_loss_options_max_fields?: (data: WithTypename<Friction_Loss_Options_Max_Fields>) => null | string,
  friction_loss_options_min_fields?: (data: WithTypename<Friction_Loss_Options_Min_Fields>) => null | string,
  friction_loss_options_mutation_response?: (data: WithTypename<Friction_Loss_Options_Mutation_Response>) => null | string,
  gas_compressibility_options?: (data: WithTypename<Gas_Compressibility_Options>) => null | string,
  gas_compressibility_options_aggregate?: (data: WithTypename<Gas_Compressibility_Options_Aggregate>) => null | string,
  gas_compressibility_options_aggregate_fields?: (data: WithTypename<Gas_Compressibility_Options_Aggregate_Fields>) => null | string,
  gas_compressibility_options_max_fields?: (data: WithTypename<Gas_Compressibility_Options_Max_Fields>) => null | string,
  gas_compressibility_options_min_fields?: (data: WithTypename<Gas_Compressibility_Options_Min_Fields>) => null | string,
  gas_compressibility_options_mutation_response?: (data: WithTypename<Gas_Compressibility_Options_Mutation_Response>) => null | string,
  gas_viscosity_options?: (data: WithTypename<Gas_Viscosity_Options>) => null | string,
  gas_viscosity_options_aggregate?: (data: WithTypename<Gas_Viscosity_Options_Aggregate>) => null | string,
  gas_viscosity_options_aggregate_fields?: (data: WithTypename<Gas_Viscosity_Options_Aggregate_Fields>) => null | string,
  gas_viscosity_options_max_fields?: (data: WithTypename<Gas_Viscosity_Options_Max_Fields>) => null | string,
  gas_viscosity_options_min_fields?: (data: WithTypename<Gas_Viscosity_Options_Min_Fields>) => null | string,
  gas_viscosity_options_mutation_response?: (data: WithTypename<Gas_Viscosity_Options_Mutation_Response>) => null | string,
  housings?: (data: WithTypename<Housings>) => null | string,
  housings_aggregate?: (data: WithTypename<Housings_Aggregate>) => null | string,
  housings_aggregate_fields?: (data: WithTypename<Housings_Aggregate_Fields>) => null | string,
  housings_avg_fields?: (data: WithTypename<Housings_Avg_Fields>) => null | string,
  housings_max_fields?: (data: WithTypename<Housings_Max_Fields>) => null | string,
  housings_min_fields?: (data: WithTypename<Housings_Min_Fields>) => null | string,
  housings_mutation_response?: (data: WithTypename<Housings_Mutation_Response>) => null | string,
  housings_stddev_fields?: (data: WithTypename<Housings_Stddev_Fields>) => null | string,
  housings_stddev_pop_fields?: (data: WithTypename<Housings_Stddev_Pop_Fields>) => null | string,
  housings_stddev_samp_fields?: (data: WithTypename<Housings_Stddev_Samp_Fields>) => null | string,
  housings_sum_fields?: (data: WithTypename<Housings_Sum_Fields>) => null | string,
  housings_var_pop_fields?: (data: WithTypename<Housings_Var_Pop_Fields>) => null | string,
  housings_var_samp_fields?: (data: WithTypename<Housings_Var_Samp_Fields>) => null | string,
  housings_variance_fields?: (data: WithTypename<Housings_Variance_Fields>) => null | string,
  hps_liquid_type?: (data: WithTypename<Hps_Liquid_Type>) => null | string,
  hps_liquid_type_aggregate?: (data: WithTypename<Hps_Liquid_Type_Aggregate>) => null | string,
  hps_liquid_type_aggregate_fields?: (data: WithTypename<Hps_Liquid_Type_Aggregate_Fields>) => null | string,
  hps_liquid_type_max_fields?: (data: WithTypename<Hps_Liquid_Type_Max_Fields>) => null | string,
  hps_liquid_type_min_fields?: (data: WithTypename<Hps_Liquid_Type_Min_Fields>) => null | string,
  hps_liquid_type_mutation_response?: (data: WithTypename<Hps_Liquid_Type_Mutation_Response>) => null | string,
  intakes?: (data: WithTypename<Intakes>) => null | string,
  intakes_aggregate?: (data: WithTypename<Intakes_Aggregate>) => null | string,
  intakes_aggregate_fields?: (data: WithTypename<Intakes_Aggregate_Fields>) => null | string,
  intakes_avg_fields?: (data: WithTypename<Intakes_Avg_Fields>) => null | string,
  intakes_max_fields?: (data: WithTypename<Intakes_Max_Fields>) => null | string,
  intakes_min_fields?: (data: WithTypename<Intakes_Min_Fields>) => null | string,
  intakes_mutation_response?: (data: WithTypename<Intakes_Mutation_Response>) => null | string,
  intakes_stddev_fields?: (data: WithTypename<Intakes_Stddev_Fields>) => null | string,
  intakes_stddev_pop_fields?: (data: WithTypename<Intakes_Stddev_Pop_Fields>) => null | string,
  intakes_stddev_samp_fields?: (data: WithTypename<Intakes_Stddev_Samp_Fields>) => null | string,
  intakes_sum_fields?: (data: WithTypename<Intakes_Sum_Fields>) => null | string,
  intakes_var_pop_fields?: (data: WithTypename<Intakes_Var_Pop_Fields>) => null | string,
  intakes_var_samp_fields?: (data: WithTypename<Intakes_Var_Samp_Fields>) => null | string,
  intakes_variance_fields?: (data: WithTypename<Intakes_Variance_Fields>) => null | string,
  legacy_users?: (data: WithTypename<Legacy_Users>) => null | string,
  legacy_users_aggregate?: (data: WithTypename<Legacy_Users_Aggregate>) => null | string,
  legacy_users_aggregate_fields?: (data: WithTypename<Legacy_Users_Aggregate_Fields>) => null | string,
  legacy_users_max_fields?: (data: WithTypename<Legacy_Users_Max_Fields>) => null | string,
  legacy_users_min_fields?: (data: WithTypename<Legacy_Users_Min_Fields>) => null | string,
  legacy_users_mutation_response?: (data: WithTypename<Legacy_Users_Mutation_Response>) => null | string,
  motor_lead_extensions?: (data: WithTypename<Motor_Lead_Extensions>) => null | string,
  motor_lead_extensions_aggregate?: (data: WithTypename<Motor_Lead_Extensions_Aggregate>) => null | string,
  motor_lead_extensions_aggregate_fields?: (data: WithTypename<Motor_Lead_Extensions_Aggregate_Fields>) => null | string,
  motor_lead_extensions_avg_fields?: (data: WithTypename<Motor_Lead_Extensions_Avg_Fields>) => null | string,
  motor_lead_extensions_max_fields?: (data: WithTypename<Motor_Lead_Extensions_Max_Fields>) => null | string,
  motor_lead_extensions_min_fields?: (data: WithTypename<Motor_Lead_Extensions_Min_Fields>) => null | string,
  motor_lead_extensions_mutation_response?: (data: WithTypename<Motor_Lead_Extensions_Mutation_Response>) => null | string,
  motor_lead_extensions_stddev_fields?: (data: WithTypename<Motor_Lead_Extensions_Stddev_Fields>) => null | string,
  motor_lead_extensions_stddev_pop_fields?: (data: WithTypename<Motor_Lead_Extensions_Stddev_Pop_Fields>) => null | string,
  motor_lead_extensions_stddev_samp_fields?: (data: WithTypename<Motor_Lead_Extensions_Stddev_Samp_Fields>) => null | string,
  motor_lead_extensions_sum_fields?: (data: WithTypename<Motor_Lead_Extensions_Sum_Fields>) => null | string,
  motor_lead_extensions_var_pop_fields?: (data: WithTypename<Motor_Lead_Extensions_Var_Pop_Fields>) => null | string,
  motor_lead_extensions_var_samp_fields?: (data: WithTypename<Motor_Lead_Extensions_Var_Samp_Fields>) => null | string,
  motor_lead_extensions_variance_fields?: (data: WithTypename<Motor_Lead_Extensions_Variance_Fields>) => null | string,
  motors?: (data: WithTypename<Motors>) => null | string,
  motors_aggregate?: (data: WithTypename<Motors_Aggregate>) => null | string,
  motors_aggregate_fields?: (data: WithTypename<Motors_Aggregate_Fields>) => null | string,
  motors_avg_fields?: (data: WithTypename<Motors_Avg_Fields>) => null | string,
  motors_max_fields?: (data: WithTypename<Motors_Max_Fields>) => null | string,
  motors_min_fields?: (data: WithTypename<Motors_Min_Fields>) => null | string,
  motors_mutation_response?: (data: WithTypename<Motors_Mutation_Response>) => null | string,
  motors_stddev_fields?: (data: WithTypename<Motors_Stddev_Fields>) => null | string,
  motors_stddev_pop_fields?: (data: WithTypename<Motors_Stddev_Pop_Fields>) => null | string,
  motors_stddev_samp_fields?: (data: WithTypename<Motors_Stddev_Samp_Fields>) => null | string,
  motors_sum_fields?: (data: WithTypename<Motors_Sum_Fields>) => null | string,
  motors_var_pop_fields?: (data: WithTypename<Motors_Var_Pop_Fields>) => null | string,
  motors_var_samp_fields?: (data: WithTypename<Motors_Var_Samp_Fields>) => null | string,
  motors_variance_fields?: (data: WithTypename<Motors_Variance_Fields>) => null | string,
  natural_gas_separation_options?: (data: WithTypename<Natural_Gas_Separation_Options>) => null | string,
  natural_gas_separation_options_aggregate?: (data: WithTypename<Natural_Gas_Separation_Options_Aggregate>) => null | string,
  natural_gas_separation_options_aggregate_fields?: (data: WithTypename<Natural_Gas_Separation_Options_Aggregate_Fields>) => null | string,
  natural_gas_separation_options_max_fields?: (data: WithTypename<Natural_Gas_Separation_Options_Max_Fields>) => null | string,
  natural_gas_separation_options_min_fields?: (data: WithTypename<Natural_Gas_Separation_Options_Min_Fields>) => null | string,
  natural_gas_separation_options_mutation_response?: (data: WithTypename<Natural_Gas_Separation_Options_Mutation_Response>) => null | string,
  oil_density_options?: (data: WithTypename<Oil_Density_Options>) => null | string,
  oil_density_options_aggregate?: (data: WithTypename<Oil_Density_Options_Aggregate>) => null | string,
  oil_density_options_aggregate_fields?: (data: WithTypename<Oil_Density_Options_Aggregate_Fields>) => null | string,
  oil_density_options_max_fields?: (data: WithTypename<Oil_Density_Options_Max_Fields>) => null | string,
  oil_density_options_min_fields?: (data: WithTypename<Oil_Density_Options_Min_Fields>) => null | string,
  oil_density_options_mutation_response?: (data: WithTypename<Oil_Density_Options_Mutation_Response>) => null | string,
  oil_volume_factor_options?: (data: WithTypename<Oil_Volume_Factor_Options>) => null | string,
  oil_volume_factor_options_aggregate?: (data: WithTypename<Oil_Volume_Factor_Options_Aggregate>) => null | string,
  oil_volume_factor_options_aggregate_fields?: (data: WithTypename<Oil_Volume_Factor_Options_Aggregate_Fields>) => null | string,
  oil_volume_factor_options_max_fields?: (data: WithTypename<Oil_Volume_Factor_Options_Max_Fields>) => null | string,
  oil_volume_factor_options_min_fields?: (data: WithTypename<Oil_Volume_Factor_Options_Min_Fields>) => null | string,
  oil_volume_factor_options_mutation_response?: (data: WithTypename<Oil_Volume_Factor_Options_Mutation_Response>) => null | string,
  override_options?: (data: WithTypename<Override_Options>) => null | string,
  override_options_aggregate?: (data: WithTypename<Override_Options_Aggregate>) => null | string,
  override_options_aggregate_fields?: (data: WithTypename<Override_Options_Aggregate_Fields>) => null | string,
  override_options_max_fields?: (data: WithTypename<Override_Options_Max_Fields>) => null | string,
  override_options_min_fields?: (data: WithTypename<Override_Options_Min_Fields>) => null | string,
  override_options_mutation_response?: (data: WithTypename<Override_Options_Mutation_Response>) => null | string,
  performance_evaluations?: (data: WithTypename<Performance_Evaluations>) => null | string,
  performance_evaluations_aggregate?: (data: WithTypename<Performance_Evaluations_Aggregate>) => null | string,
  performance_evaluations_aggregate_fields?: (data: WithTypename<Performance_Evaluations_Aggregate_Fields>) => null | string,
  performance_evaluations_avg_fields?: (data: WithTypename<Performance_Evaluations_Avg_Fields>) => null | string,
  performance_evaluations_max_fields?: (data: WithTypename<Performance_Evaluations_Max_Fields>) => null | string,
  performance_evaluations_min_fields?: (data: WithTypename<Performance_Evaluations_Min_Fields>) => null | string,
  performance_evaluations_stddev_fields?: (data: WithTypename<Performance_Evaluations_Stddev_Fields>) => null | string,
  performance_evaluations_stddev_pop_fields?: (data: WithTypename<Performance_Evaluations_Stddev_Pop_Fields>) => null | string,
  performance_evaluations_stddev_samp_fields?: (data: WithTypename<Performance_Evaluations_Stddev_Samp_Fields>) => null | string,
  performance_evaluations_sum_fields?: (data: WithTypename<Performance_Evaluations_Sum_Fields>) => null | string,
  performance_evaluations_var_pop_fields?: (data: WithTypename<Performance_Evaluations_Var_Pop_Fields>) => null | string,
  performance_evaluations_var_samp_fields?: (data: WithTypename<Performance_Evaluations_Var_Samp_Fields>) => null | string,
  performance_evaluations_variance_fields?: (data: WithTypename<Performance_Evaluations_Variance_Fields>) => null | string,
  performance_evaluations_xref_pumps?: (data: WithTypename<Performance_Evaluations_Xref_Pumps>) => null | string,
  performance_evaluations_xref_pumps_aggregate?: (data: WithTypename<Performance_Evaluations_Xref_Pumps_Aggregate>) => null | string,
  performance_evaluations_xref_pumps_aggregate_fields?: (data: WithTypename<Performance_Evaluations_Xref_Pumps_Aggregate_Fields>) => null | string,
  performance_evaluations_xref_pumps_avg_fields?: (data: WithTypename<Performance_Evaluations_Xref_Pumps_Avg_Fields>) => null | string,
  performance_evaluations_xref_pumps_max_fields?: (data: WithTypename<Performance_Evaluations_Xref_Pumps_Max_Fields>) => null | string,
  performance_evaluations_xref_pumps_min_fields?: (data: WithTypename<Performance_Evaluations_Xref_Pumps_Min_Fields>) => null | string,
  performance_evaluations_xref_pumps_stddev_fields?: (data: WithTypename<Performance_Evaluations_Xref_Pumps_Stddev_Fields>) => null | string,
  performance_evaluations_xref_pumps_stddev_pop_fields?: (data: WithTypename<Performance_Evaluations_Xref_Pumps_Stddev_Pop_Fields>) => null | string,
  performance_evaluations_xref_pumps_stddev_samp_fields?: (data: WithTypename<Performance_Evaluations_Xref_Pumps_Stddev_Samp_Fields>) => null | string,
  performance_evaluations_xref_pumps_sum_fields?: (data: WithTypename<Performance_Evaluations_Xref_Pumps_Sum_Fields>) => null | string,
  performance_evaluations_xref_pumps_var_pop_fields?: (data: WithTypename<Performance_Evaluations_Xref_Pumps_Var_Pop_Fields>) => null | string,
  performance_evaluations_xref_pumps_var_samp_fields?: (data: WithTypename<Performance_Evaluations_Xref_Pumps_Var_Samp_Fields>) => null | string,
  performance_evaluations_xref_pumps_variance_fields?: (data: WithTypename<Performance_Evaluations_Xref_Pumps_Variance_Fields>) => null | string,
  pumps?: (data: WithTypename<Pumps>) => null | string,
  pumps_aggregate?: (data: WithTypename<Pumps_Aggregate>) => null | string,
  pumps_aggregate_fields?: (data: WithTypename<Pumps_Aggregate_Fields>) => null | string,
  pumps_avg_fields?: (data: WithTypename<Pumps_Avg_Fields>) => null | string,
  pumps_max_fields?: (data: WithTypename<Pumps_Max_Fields>) => null | string,
  pumps_min_fields?: (data: WithTypename<Pumps_Min_Fields>) => null | string,
  pumps_mutation_response?: (data: WithTypename<Pumps_Mutation_Response>) => null | string,
  pumps_stddev_fields?: (data: WithTypename<Pumps_Stddev_Fields>) => null | string,
  pumps_stddev_pop_fields?: (data: WithTypename<Pumps_Stddev_Pop_Fields>) => null | string,
  pumps_stddev_samp_fields?: (data: WithTypename<Pumps_Stddev_Samp_Fields>) => null | string,
  pumps_sum_fields?: (data: WithTypename<Pumps_Sum_Fields>) => null | string,
  pumps_var_pop_fields?: (data: WithTypename<Pumps_Var_Pop_Fields>) => null | string,
  pumps_var_samp_fields?: (data: WithTypename<Pumps_Var_Samp_Fields>) => null | string,
  pumps_variance_fields?: (data: WithTypename<Pumps_Variance_Fields>) => null | string,
  quote_line_item_category_dataset?: (data: WithTypename<Quote_Line_Item_Category_Dataset>) => null | string,
  quote_line_item_category_dataset_aggregate?: (data: WithTypename<Quote_Line_Item_Category_Dataset_Aggregate>) => null | string,
  quote_line_item_category_dataset_aggregate_fields?: (data: WithTypename<Quote_Line_Item_Category_Dataset_Aggregate_Fields>) => null | string,
  quote_line_item_category_dataset_max_fields?: (data: WithTypename<Quote_Line_Item_Category_Dataset_Max_Fields>) => null | string,
  quote_line_item_category_dataset_min_fields?: (data: WithTypename<Quote_Line_Item_Category_Dataset_Min_Fields>) => null | string,
  quote_line_item_category_dataset_mutation_response?: (data: WithTypename<Quote_Line_Item_Category_Dataset_Mutation_Response>) => null | string,
  quote_line_item_serialized_dataset?: (data: WithTypename<Quote_Line_Item_Serialized_Dataset>) => null | string,
  quote_line_item_serialized_dataset_aggregate?: (data: WithTypename<Quote_Line_Item_Serialized_Dataset_Aggregate>) => null | string,
  quote_line_item_serialized_dataset_aggregate_fields?: (data: WithTypename<Quote_Line_Item_Serialized_Dataset_Aggregate_Fields>) => null | string,
  quote_line_item_serialized_dataset_max_fields?: (data: WithTypename<Quote_Line_Item_Serialized_Dataset_Max_Fields>) => null | string,
  quote_line_item_serialized_dataset_min_fields?: (data: WithTypename<Quote_Line_Item_Serialized_Dataset_Min_Fields>) => null | string,
  quote_line_item_serialized_dataset_mutation_response?: (data: WithTypename<Quote_Line_Item_Serialized_Dataset_Mutation_Response>) => null | string,
  quote_line_item_source_dataset?: (data: WithTypename<Quote_Line_Item_Source_Dataset>) => null | string,
  quote_line_item_source_dataset_aggregate?: (data: WithTypename<Quote_Line_Item_Source_Dataset_Aggregate>) => null | string,
  quote_line_item_source_dataset_aggregate_fields?: (data: WithTypename<Quote_Line_Item_Source_Dataset_Aggregate_Fields>) => null | string,
  quote_line_item_source_dataset_max_fields?: (data: WithTypename<Quote_Line_Item_Source_Dataset_Max_Fields>) => null | string,
  quote_line_item_source_dataset_min_fields?: (data: WithTypename<Quote_Line_Item_Source_Dataset_Min_Fields>) => null | string,
  quote_line_item_source_dataset_mutation_response?: (data: WithTypename<Quote_Line_Item_Source_Dataset_Mutation_Response>) => null | string,
  quote_line_item_subcategory_dataset?: (data: WithTypename<Quote_Line_Item_Subcategory_Dataset>) => null | string,
  quote_line_item_subcategory_dataset_aggregate?: (data: WithTypename<Quote_Line_Item_Subcategory_Dataset_Aggregate>) => null | string,
  quote_line_item_subcategory_dataset_aggregate_fields?: (data: WithTypename<Quote_Line_Item_Subcategory_Dataset_Aggregate_Fields>) => null | string,
  quote_line_item_subcategory_dataset_max_fields?: (data: WithTypename<Quote_Line_Item_Subcategory_Dataset_Max_Fields>) => null | string,
  quote_line_item_subcategory_dataset_min_fields?: (data: WithTypename<Quote_Line_Item_Subcategory_Dataset_Min_Fields>) => null | string,
  quote_line_item_subcategory_dataset_mutation_response?: (data: WithTypename<Quote_Line_Item_Subcategory_Dataset_Mutation_Response>) => null | string,
  quote_line_item_tax_type_dataset?: (data: WithTypename<Quote_Line_Item_Tax_Type_Dataset>) => null | string,
  quote_line_item_tax_type_dataset_aggregate?: (data: WithTypename<Quote_Line_Item_Tax_Type_Dataset_Aggregate>) => null | string,
  quote_line_item_tax_type_dataset_aggregate_fields?: (data: WithTypename<Quote_Line_Item_Tax_Type_Dataset_Aggregate_Fields>) => null | string,
  quote_line_item_tax_type_dataset_max_fields?: (data: WithTypename<Quote_Line_Item_Tax_Type_Dataset_Max_Fields>) => null | string,
  quote_line_item_tax_type_dataset_min_fields?: (data: WithTypename<Quote_Line_Item_Tax_Type_Dataset_Min_Fields>) => null | string,
  quote_line_item_tax_type_dataset_mutation_response?: (data: WithTypename<Quote_Line_Item_Tax_Type_Dataset_Mutation_Response>) => null | string,
  quote_line_item_type_dataset?: (data: WithTypename<Quote_Line_Item_Type_Dataset>) => null | string,
  quote_line_item_type_dataset_aggregate?: (data: WithTypename<Quote_Line_Item_Type_Dataset_Aggregate>) => null | string,
  quote_line_item_type_dataset_aggregate_fields?: (data: WithTypename<Quote_Line_Item_Type_Dataset_Aggregate_Fields>) => null | string,
  quote_line_item_type_dataset_max_fields?: (data: WithTypename<Quote_Line_Item_Type_Dataset_Max_Fields>) => null | string,
  quote_line_item_type_dataset_min_fields?: (data: WithTypename<Quote_Line_Item_Type_Dataset_Min_Fields>) => null | string,
  quote_line_item_type_dataset_mutation_response?: (data: WithTypename<Quote_Line_Item_Type_Dataset_Mutation_Response>) => null | string,
  quote_line_items?: (data: WithTypename<Quote_Line_Items>) => null | string,
  quote_line_items_aggregate?: (data: WithTypename<Quote_Line_Items_Aggregate>) => null | string,
  quote_line_items_aggregate_fields?: (data: WithTypename<Quote_Line_Items_Aggregate_Fields>) => null | string,
  quote_line_items_avg_fields?: (data: WithTypename<Quote_Line_Items_Avg_Fields>) => null | string,
  quote_line_items_max_fields?: (data: WithTypename<Quote_Line_Items_Max_Fields>) => null | string,
  quote_line_items_min_fields?: (data: WithTypename<Quote_Line_Items_Min_Fields>) => null | string,
  quote_line_items_mutation_response?: (data: WithTypename<Quote_Line_Items_Mutation_Response>) => null | string,
  quote_line_items_stddev_fields?: (data: WithTypename<Quote_Line_Items_Stddev_Fields>) => null | string,
  quote_line_items_stddev_pop_fields?: (data: WithTypename<Quote_Line_Items_Stddev_Pop_Fields>) => null | string,
  quote_line_items_stddev_samp_fields?: (data: WithTypename<Quote_Line_Items_Stddev_Samp_Fields>) => null | string,
  quote_line_items_sum_fields?: (data: WithTypename<Quote_Line_Items_Sum_Fields>) => null | string,
  quote_line_items_var_pop_fields?: (data: WithTypename<Quote_Line_Items_Var_Pop_Fields>) => null | string,
  quote_line_items_var_samp_fields?: (data: WithTypename<Quote_Line_Items_Var_Samp_Fields>) => null | string,
  quote_line_items_variance_fields?: (data: WithTypename<Quote_Line_Items_Variance_Fields>) => null | string,
  quote_sk_job_type_dataset?: (data: WithTypename<Quote_Sk_Job_Type_Dataset>) => null | string,
  quote_sk_job_type_dataset_aggregate?: (data: WithTypename<Quote_Sk_Job_Type_Dataset_Aggregate>) => null | string,
  quote_sk_job_type_dataset_aggregate_fields?: (data: WithTypename<Quote_Sk_Job_Type_Dataset_Aggregate_Fields>) => null | string,
  quote_sk_job_type_dataset_max_fields?: (data: WithTypename<Quote_Sk_Job_Type_Dataset_Max_Fields>) => null | string,
  quote_sk_job_type_dataset_min_fields?: (data: WithTypename<Quote_Sk_Job_Type_Dataset_Min_Fields>) => null | string,
  quote_sk_job_type_dataset_mutation_response?: (data: WithTypename<Quote_Sk_Job_Type_Dataset_Mutation_Response>) => null | string,
  quote_source_dataset?: (data: WithTypename<Quote_Source_Dataset>) => null | string,
  quote_source_dataset_aggregate?: (data: WithTypename<Quote_Source_Dataset_Aggregate>) => null | string,
  quote_source_dataset_aggregate_fields?: (data: WithTypename<Quote_Source_Dataset_Aggregate_Fields>) => null | string,
  quote_source_dataset_max_fields?: (data: WithTypename<Quote_Source_Dataset_Max_Fields>) => null | string,
  quote_source_dataset_min_fields?: (data: WithTypename<Quote_Source_Dataset_Min_Fields>) => null | string,
  quote_source_dataset_mutation_response?: (data: WithTypename<Quote_Source_Dataset_Mutation_Response>) => null | string,
  quote_status_dataset?: (data: WithTypename<Quote_Status_Dataset>) => null | string,
  quote_status_dataset_aggregate?: (data: WithTypename<Quote_Status_Dataset_Aggregate>) => null | string,
  quote_status_dataset_aggregate_fields?: (data: WithTypename<Quote_Status_Dataset_Aggregate_Fields>) => null | string,
  quote_status_dataset_max_fields?: (data: WithTypename<Quote_Status_Dataset_Max_Fields>) => null | string,
  quote_status_dataset_min_fields?: (data: WithTypename<Quote_Status_Dataset_Min_Fields>) => null | string,
  quote_status_dataset_mutation_response?: (data: WithTypename<Quote_Status_Dataset_Mutation_Response>) => null | string,
  quote_user_messages?: (data: WithTypename<Quote_User_Messages>) => null | string,
  quote_user_messages_aggregate?: (data: WithTypename<Quote_User_Messages_Aggregate>) => null | string,
  quote_user_messages_aggregate_fields?: (data: WithTypename<Quote_User_Messages_Aggregate_Fields>) => null | string,
  quote_user_messages_max_fields?: (data: WithTypename<Quote_User_Messages_Max_Fields>) => null | string,
  quote_user_messages_min_fields?: (data: WithTypename<Quote_User_Messages_Min_Fields>) => null | string,
  quote_user_messages_mutation_response?: (data: WithTypename<Quote_User_Messages_Mutation_Response>) => null | string,
  quotes?: (data: WithTypename<Quotes>) => null | string,
  quotes_aggregate?: (data: WithTypename<Quotes_Aggregate>) => null | string,
  quotes_aggregate_fields?: (data: WithTypename<Quotes_Aggregate_Fields>) => null | string,
  quotes_avg_fields?: (data: WithTypename<Quotes_Avg_Fields>) => null | string,
  quotes_max_fields?: (data: WithTypename<Quotes_Max_Fields>) => null | string,
  quotes_min_fields?: (data: WithTypename<Quotes_Min_Fields>) => null | string,
  quotes_mutation_response?: (data: WithTypename<Quotes_Mutation_Response>) => null | string,
  quotes_stddev_fields?: (data: WithTypename<Quotes_Stddev_Fields>) => null | string,
  quotes_stddev_pop_fields?: (data: WithTypename<Quotes_Stddev_Pop_Fields>) => null | string,
  quotes_stddev_samp_fields?: (data: WithTypename<Quotes_Stddev_Samp_Fields>) => null | string,
  quotes_sum_fields?: (data: WithTypename<Quotes_Sum_Fields>) => null | string,
  quotes_var_pop_fields?: (data: WithTypename<Quotes_Var_Pop_Fields>) => null | string,
  quotes_var_samp_fields?: (data: WithTypename<Quotes_Var_Samp_Fields>) => null | string,
  quotes_variance_fields?: (data: WithTypename<Quotes_Variance_Fields>) => null | string,
  revisions_performance_evaluations_journal?: (data: WithTypename<Revisions_Performance_Evaluations_Journal>) => null | string,
  revisions_performance_evaluations_journal_aggregate?: (data: WithTypename<Revisions_Performance_Evaluations_Journal_Aggregate>) => null | string,
  revisions_performance_evaluations_journal_aggregate_fields?: (data: WithTypename<Revisions_Performance_Evaluations_Journal_Aggregate_Fields>) => null | string,
  revisions_performance_evaluations_journal_max_fields?: (data: WithTypename<Revisions_Performance_Evaluations_Journal_Max_Fields>) => null | string,
  revisions_performance_evaluations_journal_min_fields?: (data: WithTypename<Revisions_Performance_Evaluations_Journal_Min_Fields>) => null | string,
  revisions_performance_evaluations_journal_mutation_response?: (data: WithTypename<Revisions_Performance_Evaluations_Journal_Mutation_Response>) => null | string,
  revisions_performance_evaluations_revisions?: (data: WithTypename<Revisions_Performance_Evaluations_Revisions>) => null | string,
  revisions_performance_evaluations_revisions_aggregate?: (data: WithTypename<Revisions_Performance_Evaluations_Revisions_Aggregate>) => null | string,
  revisions_performance_evaluations_revisions_aggregate_fields?: (data: WithTypename<Revisions_Performance_Evaluations_Revisions_Aggregate_Fields>) => null | string,
  revisions_performance_evaluations_revisions_avg_fields?: (data: WithTypename<Revisions_Performance_Evaluations_Revisions_Avg_Fields>) => null | string,
  revisions_performance_evaluations_revisions_max_fields?: (data: WithTypename<Revisions_Performance_Evaluations_Revisions_Max_Fields>) => null | string,
  revisions_performance_evaluations_revisions_min_fields?: (data: WithTypename<Revisions_Performance_Evaluations_Revisions_Min_Fields>) => null | string,
  revisions_performance_evaluations_revisions_mutation_response?: (data: WithTypename<Revisions_Performance_Evaluations_Revisions_Mutation_Response>) => null | string,
  revisions_performance_evaluations_revisions_stddev_fields?: (data: WithTypename<Revisions_Performance_Evaluations_Revisions_Stddev_Fields>) => null | string,
  revisions_performance_evaluations_revisions_stddev_pop_fields?: (data: WithTypename<Revisions_Performance_Evaluations_Revisions_Stddev_Pop_Fields>) => null | string,
  revisions_performance_evaluations_revisions_stddev_samp_fields?: (data: WithTypename<Revisions_Performance_Evaluations_Revisions_Stddev_Samp_Fields>) => null | string,
  revisions_performance_evaluations_revisions_sum_fields?: (data: WithTypename<Revisions_Performance_Evaluations_Revisions_Sum_Fields>) => null | string,
  revisions_performance_evaluations_revisions_var_pop_fields?: (data: WithTypename<Revisions_Performance_Evaluations_Revisions_Var_Pop_Fields>) => null | string,
  revisions_performance_evaluations_revisions_var_samp_fields?: (data: WithTypename<Revisions_Performance_Evaluations_Revisions_Var_Samp_Fields>) => null | string,
  revisions_performance_evaluations_revisions_variance_fields?: (data: WithTypename<Revisions_Performance_Evaluations_Revisions_Variance_Fields>) => null | string,
  revisions_performance_evaluations_xref_pumps_journal?: (data: WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Journal>) => null | string,
  revisions_performance_evaluations_xref_pumps_journal_aggregate?: (data: WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Journal_Aggregate>) => null | string,
  revisions_performance_evaluations_xref_pumps_journal_aggregate_fields?: (data: WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Journal_Aggregate_Fields>) => null | string,
  revisions_performance_evaluations_xref_pumps_journal_max_fields?: (data: WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Journal_Max_Fields>) => null | string,
  revisions_performance_evaluations_xref_pumps_journal_min_fields?: (data: WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Journal_Min_Fields>) => null | string,
  revisions_performance_evaluations_xref_pumps_journal_mutation_response?: (data: WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Journal_Mutation_Response>) => null | string,
  revisions_performance_evaluations_xref_pumps_revisions?: (data: WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Revisions>) => null | string,
  revisions_performance_evaluations_xref_pumps_revisions_aggregate?: (data: WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Aggregate>) => null | string,
  revisions_performance_evaluations_xref_pumps_revisions_aggregate_fields?: (data: WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Aggregate_Fields>) => null | string,
  revisions_performance_evaluations_xref_pumps_revisions_avg_fields?: (data: WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Avg_Fields>) => null | string,
  revisions_performance_evaluations_xref_pumps_revisions_max_fields?: (data: WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Max_Fields>) => null | string,
  revisions_performance_evaluations_xref_pumps_revisions_min_fields?: (data: WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Min_Fields>) => null | string,
  revisions_performance_evaluations_xref_pumps_revisions_mutation_response?: (data: WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Mutation_Response>) => null | string,
  revisions_performance_evaluations_xref_pumps_revisions_stddev_fields?: (data: WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Stddev_Fields>) => null | string,
  revisions_performance_evaluations_xref_pumps_revisions_stddev_pop_fields?: (data: WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Stddev_Pop_Fields>) => null | string,
  revisions_performance_evaluations_xref_pumps_revisions_stddev_samp_fields?: (data: WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Stddev_Samp_Fields>) => null | string,
  revisions_performance_evaluations_xref_pumps_revisions_sum_fields?: (data: WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Sum_Fields>) => null | string,
  revisions_performance_evaluations_xref_pumps_revisions_var_pop_fields?: (data: WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Var_Pop_Fields>) => null | string,
  revisions_performance_evaluations_xref_pumps_revisions_var_samp_fields?: (data: WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Var_Samp_Fields>) => null | string,
  revisions_performance_evaluations_xref_pumps_revisions_variance_fields?: (data: WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Variance_Fields>) => null | string,
  revisions_sc_equip_xref_downhole_ytool_bypass_tubings_journal?: (data: WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal>) => null | string,
  revisions_sc_equip_xref_downhole_ytool_bypass_tubings_journal_aggregate?: (data: WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_Aggregate>) => null | string,
  revisions_sc_equip_xref_downhole_ytool_bypass_tubings_journal_aggregate_fields?: (data: WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_Aggregate_Fields>) => null | string,
  revisions_sc_equip_xref_downhole_ytool_bypass_tubings_journal_max_fields?: (data: WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_Max_Fields>) => null | string,
  revisions_sc_equip_xref_downhole_ytool_bypass_tubings_journal_min_fields?: (data: WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_Min_Fields>) => null | string,
  revisions_sc_equip_xref_downhole_ytool_bypass_tubings_journal_mutation_response?: (data: WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_Mutation_Response>) => null | string,
  revisions_sc_equip_xref_downhole_ytool_bypass_tubings_revisions?: (data: WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions>) => null | string,
  revisions_sc_equip_xref_downhole_ytool_bypass_tubings_revisions_aggregate?: (data: WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Aggregate>) => null | string,
  revisions_sc_equip_xref_downhole_ytool_bypass_tubings_revisions_aggregate_fields?: (data: WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Aggregate_Fields>) => null | string,
  revisions_sc_equip_xref_downhole_ytool_bypass_tubings_revisions_avg_fields?: (data: WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Avg_Fields>) => null | string,
  revisions_sc_equip_xref_downhole_ytool_bypass_tubings_revisions_max_fields?: (data: WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Max_Fields>) => null | string,
  revisions_sc_equip_xref_downhole_ytool_bypass_tubings_revisions_min_fields?: (data: WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Min_Fields>) => null | string,
  revisions_sc_equip_xref_downhole_ytool_bypass_tubings_revisions_mutation_response?: (data: WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Mutation_Response>) => null | string,
  revisions_sc_equip_xref_downhole_ytool_bypass_tubings_revisions_stddev_fields?: (data: WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Stddev_Fields>) => null | string,
  revisions_sc_equip_xref_downhole_ytool_bypass_tubings_revisions_stddev_pop_fields?: (data: WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Stddev_Pop_Fields>) => null | string,
  revisions_sc_equip_xref_downhole_ytool_bypass_tubings_revisions_stddev_samp_fields?: (data: WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Stddev_Samp_Fields>) => null | string,
  revisions_sc_equip_xref_downhole_ytool_bypass_tubings_revisions_sum_fields?: (data: WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Sum_Fields>) => null | string,
  revisions_sc_equip_xref_downhole_ytool_bypass_tubings_revisions_var_pop_fields?: (data: WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Var_Pop_Fields>) => null | string,
  revisions_sc_equip_xref_downhole_ytool_bypass_tubings_revisions_var_samp_fields?: (data: WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Var_Samp_Fields>) => null | string,
  revisions_sc_equip_xref_downhole_ytool_bypass_tubings_revisions_variance_fields?: (data: WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Variance_Fields>) => null | string,
  revisions_sc_equip_xref_downhole_ytool_equip_tubings_journal?: (data: WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal>) => null | string,
  revisions_sc_equip_xref_downhole_ytool_equip_tubings_journal_aggregate?: (data: WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_Aggregate>) => null | string,
  revisions_sc_equip_xref_downhole_ytool_equip_tubings_journal_aggregate_fields?: (data: WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_Aggregate_Fields>) => null | string,
  revisions_sc_equip_xref_downhole_ytool_equip_tubings_journal_max_fields?: (data: WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_Max_Fields>) => null | string,
  revisions_sc_equip_xref_downhole_ytool_equip_tubings_journal_min_fields?: (data: WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_Min_Fields>) => null | string,
  revisions_sc_equip_xref_downhole_ytool_equip_tubings_journal_mutation_response?: (data: WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_Mutation_Response>) => null | string,
  revisions_sc_equip_xref_downhole_ytool_equip_tubings_revisions?: (data: WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions>) => null | string,
  revisions_sc_equip_xref_downhole_ytool_equip_tubings_revisions_aggregate?: (data: WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Aggregate>) => null | string,
  revisions_sc_equip_xref_downhole_ytool_equip_tubings_revisions_aggregate_fields?: (data: WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Aggregate_Fields>) => null | string,
  revisions_sc_equip_xref_downhole_ytool_equip_tubings_revisions_avg_fields?: (data: WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Avg_Fields>) => null | string,
  revisions_sc_equip_xref_downhole_ytool_equip_tubings_revisions_max_fields?: (data: WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Max_Fields>) => null | string,
  revisions_sc_equip_xref_downhole_ytool_equip_tubings_revisions_min_fields?: (data: WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Min_Fields>) => null | string,
  revisions_sc_equip_xref_downhole_ytool_equip_tubings_revisions_mutation_response?: (data: WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Mutation_Response>) => null | string,
  revisions_sc_equip_xref_downhole_ytool_equip_tubings_revisions_stddev_fields?: (data: WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Stddev_Fields>) => null | string,
  revisions_sc_equip_xref_downhole_ytool_equip_tubings_revisions_stddev_pop_fields?: (data: WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Stddev_Pop_Fields>) => null | string,
  revisions_sc_equip_xref_downhole_ytool_equip_tubings_revisions_stddev_samp_fields?: (data: WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Stddev_Samp_Fields>) => null | string,
  revisions_sc_equip_xref_downhole_ytool_equip_tubings_revisions_sum_fields?: (data: WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Sum_Fields>) => null | string,
  revisions_sc_equip_xref_downhole_ytool_equip_tubings_revisions_var_pop_fields?: (data: WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Var_Pop_Fields>) => null | string,
  revisions_sc_equip_xref_downhole_ytool_equip_tubings_revisions_var_samp_fields?: (data: WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Var_Samp_Fields>) => null | string,
  revisions_sc_equip_xref_downhole_ytool_equip_tubings_revisions_variance_fields?: (data: WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Variance_Fields>) => null | string,
  revisions_sc_equip_xref_uphole_ytool_bypass_tubings_journal?: (data: WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal>) => null | string,
  revisions_sc_equip_xref_uphole_ytool_bypass_tubings_journal_aggregate?: (data: WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_Aggregate>) => null | string,
  revisions_sc_equip_xref_uphole_ytool_bypass_tubings_journal_aggregate_fields?: (data: WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_Aggregate_Fields>) => null | string,
  revisions_sc_equip_xref_uphole_ytool_bypass_tubings_journal_max_fields?: (data: WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_Max_Fields>) => null | string,
  revisions_sc_equip_xref_uphole_ytool_bypass_tubings_journal_min_fields?: (data: WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_Min_Fields>) => null | string,
  revisions_sc_equip_xref_uphole_ytool_bypass_tubings_journal_mutation_response?: (data: WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_Mutation_Response>) => null | string,
  revisions_sc_equip_xref_uphole_ytool_bypass_tubings_revisions?: (data: WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions>) => null | string,
  revisions_sc_equip_xref_uphole_ytool_bypass_tubings_revisions_aggregate?: (data: WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Aggregate>) => null | string,
  revisions_sc_equip_xref_uphole_ytool_bypass_tubings_revisions_aggregate_fields?: (data: WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Aggregate_Fields>) => null | string,
  revisions_sc_equip_xref_uphole_ytool_bypass_tubings_revisions_avg_fields?: (data: WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Avg_Fields>) => null | string,
  revisions_sc_equip_xref_uphole_ytool_bypass_tubings_revisions_max_fields?: (data: WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Max_Fields>) => null | string,
  revisions_sc_equip_xref_uphole_ytool_bypass_tubings_revisions_min_fields?: (data: WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Min_Fields>) => null | string,
  revisions_sc_equip_xref_uphole_ytool_bypass_tubings_revisions_mutation_response?: (data: WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Mutation_Response>) => null | string,
  revisions_sc_equip_xref_uphole_ytool_bypass_tubings_revisions_stddev_fields?: (data: WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Stddev_Fields>) => null | string,
  revisions_sc_equip_xref_uphole_ytool_bypass_tubings_revisions_stddev_pop_fields?: (data: WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Stddev_Pop_Fields>) => null | string,
  revisions_sc_equip_xref_uphole_ytool_bypass_tubings_revisions_stddev_samp_fields?: (data: WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Stddev_Samp_Fields>) => null | string,
  revisions_sc_equip_xref_uphole_ytool_bypass_tubings_revisions_sum_fields?: (data: WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Sum_Fields>) => null | string,
  revisions_sc_equip_xref_uphole_ytool_bypass_tubings_revisions_var_pop_fields?: (data: WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Var_Pop_Fields>) => null | string,
  revisions_sc_equip_xref_uphole_ytool_bypass_tubings_revisions_var_samp_fields?: (data: WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Var_Samp_Fields>) => null | string,
  revisions_sc_equip_xref_uphole_ytool_bypass_tubings_revisions_variance_fields?: (data: WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Variance_Fields>) => null | string,
  revisions_sc_equip_xref_uphole_ytool_equip_tubings_journal?: (data: WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal>) => null | string,
  revisions_sc_equip_xref_uphole_ytool_equip_tubings_journal_aggregate?: (data: WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_Aggregate>) => null | string,
  revisions_sc_equip_xref_uphole_ytool_equip_tubings_journal_aggregate_fields?: (data: WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_Aggregate_Fields>) => null | string,
  revisions_sc_equip_xref_uphole_ytool_equip_tubings_journal_max_fields?: (data: WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_Max_Fields>) => null | string,
  revisions_sc_equip_xref_uphole_ytool_equip_tubings_journal_min_fields?: (data: WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_Min_Fields>) => null | string,
  revisions_sc_equip_xref_uphole_ytool_equip_tubings_journal_mutation_response?: (data: WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_Mutation_Response>) => null | string,
  revisions_sc_equip_xref_uphole_ytool_equip_tubings_revisions?: (data: WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions>) => null | string,
  revisions_sc_equip_xref_uphole_ytool_equip_tubings_revisions_aggregate?: (data: WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Aggregate>) => null | string,
  revisions_sc_equip_xref_uphole_ytool_equip_tubings_revisions_aggregate_fields?: (data: WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Aggregate_Fields>) => null | string,
  revisions_sc_equip_xref_uphole_ytool_equip_tubings_revisions_avg_fields?: (data: WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Avg_Fields>) => null | string,
  revisions_sc_equip_xref_uphole_ytool_equip_tubings_revisions_max_fields?: (data: WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Max_Fields>) => null | string,
  revisions_sc_equip_xref_uphole_ytool_equip_tubings_revisions_min_fields?: (data: WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Min_Fields>) => null | string,
  revisions_sc_equip_xref_uphole_ytool_equip_tubings_revisions_mutation_response?: (data: WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Mutation_Response>) => null | string,
  revisions_sc_equip_xref_uphole_ytool_equip_tubings_revisions_stddev_fields?: (data: WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Stddev_Fields>) => null | string,
  revisions_sc_equip_xref_uphole_ytool_equip_tubings_revisions_stddev_pop_fields?: (data: WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Stddev_Pop_Fields>) => null | string,
  revisions_sc_equip_xref_uphole_ytool_equip_tubings_revisions_stddev_samp_fields?: (data: WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Stddev_Samp_Fields>) => null | string,
  revisions_sc_equip_xref_uphole_ytool_equip_tubings_revisions_sum_fields?: (data: WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Sum_Fields>) => null | string,
  revisions_sc_equip_xref_uphole_ytool_equip_tubings_revisions_var_pop_fields?: (data: WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Var_Pop_Fields>) => null | string,
  revisions_sc_equip_xref_uphole_ytool_equip_tubings_revisions_var_samp_fields?: (data: WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Var_Samp_Fields>) => null | string,
  revisions_sc_equip_xref_uphole_ytool_equip_tubings_revisions_variance_fields?: (data: WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Variance_Fields>) => null | string,
  revisions_scenario_correlations_journal?: (data: WithTypename<Revisions_Scenario_Correlations_Journal>) => null | string,
  revisions_scenario_correlations_journal_aggregate?: (data: WithTypename<Revisions_Scenario_Correlations_Journal_Aggregate>) => null | string,
  revisions_scenario_correlations_journal_aggregate_fields?: (data: WithTypename<Revisions_Scenario_Correlations_Journal_Aggregate_Fields>) => null | string,
  revisions_scenario_correlations_journal_max_fields?: (data: WithTypename<Revisions_Scenario_Correlations_Journal_Max_Fields>) => null | string,
  revisions_scenario_correlations_journal_min_fields?: (data: WithTypename<Revisions_Scenario_Correlations_Journal_Min_Fields>) => null | string,
  revisions_scenario_correlations_journal_mutation_response?: (data: WithTypename<Revisions_Scenario_Correlations_Journal_Mutation_Response>) => null | string,
  revisions_scenario_correlations_revisions?: (data: WithTypename<Revisions_Scenario_Correlations_Revisions>) => null | string,
  revisions_scenario_correlations_revisions_aggregate?: (data: WithTypename<Revisions_Scenario_Correlations_Revisions_Aggregate>) => null | string,
  revisions_scenario_correlations_revisions_aggregate_fields?: (data: WithTypename<Revisions_Scenario_Correlations_Revisions_Aggregate_Fields>) => null | string,
  revisions_scenario_correlations_revisions_avg_fields?: (data: WithTypename<Revisions_Scenario_Correlations_Revisions_Avg_Fields>) => null | string,
  revisions_scenario_correlations_revisions_max_fields?: (data: WithTypename<Revisions_Scenario_Correlations_Revisions_Max_Fields>) => null | string,
  revisions_scenario_correlations_revisions_min_fields?: (data: WithTypename<Revisions_Scenario_Correlations_Revisions_Min_Fields>) => null | string,
  revisions_scenario_correlations_revisions_mutation_response?: (data: WithTypename<Revisions_Scenario_Correlations_Revisions_Mutation_Response>) => null | string,
  revisions_scenario_correlations_revisions_stddev_fields?: (data: WithTypename<Revisions_Scenario_Correlations_Revisions_Stddev_Fields>) => null | string,
  revisions_scenario_correlations_revisions_stddev_pop_fields?: (data: WithTypename<Revisions_Scenario_Correlations_Revisions_Stddev_Pop_Fields>) => null | string,
  revisions_scenario_correlations_revisions_stddev_samp_fields?: (data: WithTypename<Revisions_Scenario_Correlations_Revisions_Stddev_Samp_Fields>) => null | string,
  revisions_scenario_correlations_revisions_sum_fields?: (data: WithTypename<Revisions_Scenario_Correlations_Revisions_Sum_Fields>) => null | string,
  revisions_scenario_correlations_revisions_var_pop_fields?: (data: WithTypename<Revisions_Scenario_Correlations_Revisions_Var_Pop_Fields>) => null | string,
  revisions_scenario_correlations_revisions_var_samp_fields?: (data: WithTypename<Revisions_Scenario_Correlations_Revisions_Var_Samp_Fields>) => null | string,
  revisions_scenario_correlations_revisions_variance_fields?: (data: WithTypename<Revisions_Scenario_Correlations_Revisions_Variance_Fields>) => null | string,
  revisions_scenario_equipment_journal?: (data: WithTypename<Revisions_Scenario_Equipment_Journal>) => null | string,
  revisions_scenario_equipment_journal_aggregate?: (data: WithTypename<Revisions_Scenario_Equipment_Journal_Aggregate>) => null | string,
  revisions_scenario_equipment_journal_aggregate_fields?: (data: WithTypename<Revisions_Scenario_Equipment_Journal_Aggregate_Fields>) => null | string,
  revisions_scenario_equipment_journal_max_fields?: (data: WithTypename<Revisions_Scenario_Equipment_Journal_Max_Fields>) => null | string,
  revisions_scenario_equipment_journal_min_fields?: (data: WithTypename<Revisions_Scenario_Equipment_Journal_Min_Fields>) => null | string,
  revisions_scenario_equipment_journal_mutation_response?: (data: WithTypename<Revisions_Scenario_Equipment_Journal_Mutation_Response>) => null | string,
  revisions_scenario_equipment_revisions?: (data: WithTypename<Revisions_Scenario_Equipment_Revisions>) => null | string,
  revisions_scenario_equipment_revisions_aggregate?: (data: WithTypename<Revisions_Scenario_Equipment_Revisions_Aggregate>) => null | string,
  revisions_scenario_equipment_revisions_aggregate_fields?: (data: WithTypename<Revisions_Scenario_Equipment_Revisions_Aggregate_Fields>) => null | string,
  revisions_scenario_equipment_revisions_max_fields?: (data: WithTypename<Revisions_Scenario_Equipment_Revisions_Max_Fields>) => null | string,
  revisions_scenario_equipment_revisions_min_fields?: (data: WithTypename<Revisions_Scenario_Equipment_Revisions_Min_Fields>) => null | string,
  revisions_scenario_equipment_revisions_mutation_response?: (data: WithTypename<Revisions_Scenario_Equipment_Revisions_Mutation_Response>) => null | string,
  revisions_scenario_equipment_xref_cables_journal?: (data: WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Journal>) => null | string,
  revisions_scenario_equipment_xref_cables_journal_aggregate?: (data: WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Journal_Aggregate>) => null | string,
  revisions_scenario_equipment_xref_cables_journal_aggregate_fields?: (data: WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Journal_Aggregate_Fields>) => null | string,
  revisions_scenario_equipment_xref_cables_journal_max_fields?: (data: WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Journal_Max_Fields>) => null | string,
  revisions_scenario_equipment_xref_cables_journal_min_fields?: (data: WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Journal_Min_Fields>) => null | string,
  revisions_scenario_equipment_xref_cables_journal_mutation_response?: (data: WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Journal_Mutation_Response>) => null | string,
  revisions_scenario_equipment_xref_cables_revisions?: (data: WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Revisions>) => null | string,
  revisions_scenario_equipment_xref_cables_revisions_aggregate?: (data: WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Aggregate>) => null | string,
  revisions_scenario_equipment_xref_cables_revisions_aggregate_fields?: (data: WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Aggregate_Fields>) => null | string,
  revisions_scenario_equipment_xref_cables_revisions_avg_fields?: (data: WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Avg_Fields>) => null | string,
  revisions_scenario_equipment_xref_cables_revisions_max_fields?: (data: WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Max_Fields>) => null | string,
  revisions_scenario_equipment_xref_cables_revisions_min_fields?: (data: WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Min_Fields>) => null | string,
  revisions_scenario_equipment_xref_cables_revisions_mutation_response?: (data: WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Mutation_Response>) => null | string,
  revisions_scenario_equipment_xref_cables_revisions_stddev_fields?: (data: WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Stddev_Fields>) => null | string,
  revisions_scenario_equipment_xref_cables_revisions_stddev_pop_fields?: (data: WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Stddev_Pop_Fields>) => null | string,
  revisions_scenario_equipment_xref_cables_revisions_stddev_samp_fields?: (data: WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Stddev_Samp_Fields>) => null | string,
  revisions_scenario_equipment_xref_cables_revisions_sum_fields?: (data: WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Sum_Fields>) => null | string,
  revisions_scenario_equipment_xref_cables_revisions_var_pop_fields?: (data: WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Var_Pop_Fields>) => null | string,
  revisions_scenario_equipment_xref_cables_revisions_var_samp_fields?: (data: WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Var_Samp_Fields>) => null | string,
  revisions_scenario_equipment_xref_cables_revisions_variance_fields?: (data: WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Variance_Fields>) => null | string,
  revisions_scenario_equipment_xref_housings_journal?: (data: WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Journal>) => null | string,
  revisions_scenario_equipment_xref_housings_journal_aggregate?: (data: WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Journal_Aggregate>) => null | string,
  revisions_scenario_equipment_xref_housings_journal_aggregate_fields?: (data: WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Journal_Aggregate_Fields>) => null | string,
  revisions_scenario_equipment_xref_housings_journal_max_fields?: (data: WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Journal_Max_Fields>) => null | string,
  revisions_scenario_equipment_xref_housings_journal_min_fields?: (data: WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Journal_Min_Fields>) => null | string,
  revisions_scenario_equipment_xref_housings_journal_mutation_response?: (data: WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Journal_Mutation_Response>) => null | string,
  revisions_scenario_equipment_xref_housings_revisions?: (data: WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Revisions>) => null | string,
  revisions_scenario_equipment_xref_housings_revisions_aggregate?: (data: WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Aggregate>) => null | string,
  revisions_scenario_equipment_xref_housings_revisions_aggregate_fields?: (data: WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Aggregate_Fields>) => null | string,
  revisions_scenario_equipment_xref_housings_revisions_avg_fields?: (data: WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Avg_Fields>) => null | string,
  revisions_scenario_equipment_xref_housings_revisions_max_fields?: (data: WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Max_Fields>) => null | string,
  revisions_scenario_equipment_xref_housings_revisions_min_fields?: (data: WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Min_Fields>) => null | string,
  revisions_scenario_equipment_xref_housings_revisions_mutation_response?: (data: WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Mutation_Response>) => null | string,
  revisions_scenario_equipment_xref_housings_revisions_stddev_fields?: (data: WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Stddev_Fields>) => null | string,
  revisions_scenario_equipment_xref_housings_revisions_stddev_pop_fields?: (data: WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Stddev_Pop_Fields>) => null | string,
  revisions_scenario_equipment_xref_housings_revisions_stddev_samp_fields?: (data: WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Stddev_Samp_Fields>) => null | string,
  revisions_scenario_equipment_xref_housings_revisions_sum_fields?: (data: WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Sum_Fields>) => null | string,
  revisions_scenario_equipment_xref_housings_revisions_var_pop_fields?: (data: WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Var_Pop_Fields>) => null | string,
  revisions_scenario_equipment_xref_housings_revisions_var_samp_fields?: (data: WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Var_Samp_Fields>) => null | string,
  revisions_scenario_equipment_xref_housings_revisions_variance_fields?: (data: WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Variance_Fields>) => null | string,
  revisions_scenario_equipment_xref_intakes_journal?: (data: WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Journal>) => null | string,
  revisions_scenario_equipment_xref_intakes_journal_aggregate?: (data: WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Journal_Aggregate>) => null | string,
  revisions_scenario_equipment_xref_intakes_journal_aggregate_fields?: (data: WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Journal_Aggregate_Fields>) => null | string,
  revisions_scenario_equipment_xref_intakes_journal_max_fields?: (data: WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Journal_Max_Fields>) => null | string,
  revisions_scenario_equipment_xref_intakes_journal_min_fields?: (data: WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Journal_Min_Fields>) => null | string,
  revisions_scenario_equipment_xref_intakes_journal_mutation_response?: (data: WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Journal_Mutation_Response>) => null | string,
  revisions_scenario_equipment_xref_intakes_revisions?: (data: WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Revisions>) => null | string,
  revisions_scenario_equipment_xref_intakes_revisions_aggregate?: (data: WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Aggregate>) => null | string,
  revisions_scenario_equipment_xref_intakes_revisions_aggregate_fields?: (data: WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Aggregate_Fields>) => null | string,
  revisions_scenario_equipment_xref_intakes_revisions_max_fields?: (data: WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Max_Fields>) => null | string,
  revisions_scenario_equipment_xref_intakes_revisions_min_fields?: (data: WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Min_Fields>) => null | string,
  revisions_scenario_equipment_xref_intakes_revisions_mutation_response?: (data: WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Mutation_Response>) => null | string,
  revisions_scenario_equipment_xref_pumps_journal?: (data: WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Journal>) => null | string,
  revisions_scenario_equipment_xref_pumps_journal_aggregate?: (data: WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Journal_Aggregate>) => null | string,
  revisions_scenario_equipment_xref_pumps_journal_aggregate_fields?: (data: WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Journal_Aggregate_Fields>) => null | string,
  revisions_scenario_equipment_xref_pumps_journal_max_fields?: (data: WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Journal_Max_Fields>) => null | string,
  revisions_scenario_equipment_xref_pumps_journal_min_fields?: (data: WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Journal_Min_Fields>) => null | string,
  revisions_scenario_equipment_xref_pumps_journal_mutation_response?: (data: WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Journal_Mutation_Response>) => null | string,
  revisions_scenario_equipment_xref_pumps_revisions?: (data: WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions>) => null | string,
  revisions_scenario_equipment_xref_pumps_revisions_aggregate?: (data: WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Aggregate>) => null | string,
  revisions_scenario_equipment_xref_pumps_revisions_aggregate_fields?: (data: WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Aggregate_Fields>) => null | string,
  revisions_scenario_equipment_xref_pumps_revisions_avg_fields?: (data: WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Avg_Fields>) => null | string,
  revisions_scenario_equipment_xref_pumps_revisions_max_fields?: (data: WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Max_Fields>) => null | string,
  revisions_scenario_equipment_xref_pumps_revisions_min_fields?: (data: WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Min_Fields>) => null | string,
  revisions_scenario_equipment_xref_pumps_revisions_mutation_response?: (data: WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Mutation_Response>) => null | string,
  revisions_scenario_equipment_xref_pumps_revisions_stddev_fields?: (data: WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Stddev_Fields>) => null | string,
  revisions_scenario_equipment_xref_pumps_revisions_stddev_pop_fields?: (data: WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Stddev_Pop_Fields>) => null | string,
  revisions_scenario_equipment_xref_pumps_revisions_stddev_samp_fields?: (data: WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Stddev_Samp_Fields>) => null | string,
  revisions_scenario_equipment_xref_pumps_revisions_sum_fields?: (data: WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Sum_Fields>) => null | string,
  revisions_scenario_equipment_xref_pumps_revisions_var_pop_fields?: (data: WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Var_Pop_Fields>) => null | string,
  revisions_scenario_equipment_xref_pumps_revisions_var_samp_fields?: (data: WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Var_Samp_Fields>) => null | string,
  revisions_scenario_equipment_xref_pumps_revisions_variance_fields?: (data: WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Variance_Fields>) => null | string,
  revisions_scenario_equipment_xref_seals_journal?: (data: WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Journal>) => null | string,
  revisions_scenario_equipment_xref_seals_journal_aggregate?: (data: WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Journal_Aggregate>) => null | string,
  revisions_scenario_equipment_xref_seals_journal_aggregate_fields?: (data: WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Journal_Aggregate_Fields>) => null | string,
  revisions_scenario_equipment_xref_seals_journal_max_fields?: (data: WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Journal_Max_Fields>) => null | string,
  revisions_scenario_equipment_xref_seals_journal_min_fields?: (data: WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Journal_Min_Fields>) => null | string,
  revisions_scenario_equipment_xref_seals_journal_mutation_response?: (data: WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Journal_Mutation_Response>) => null | string,
  revisions_scenario_equipment_xref_seals_revisions?: (data: WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Revisions>) => null | string,
  revisions_scenario_equipment_xref_seals_revisions_aggregate?: (data: WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Revisions_Aggregate>) => null | string,
  revisions_scenario_equipment_xref_seals_revisions_aggregate_fields?: (data: WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Revisions_Aggregate_Fields>) => null | string,
  revisions_scenario_equipment_xref_seals_revisions_max_fields?: (data: WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Revisions_Max_Fields>) => null | string,
  revisions_scenario_equipment_xref_seals_revisions_min_fields?: (data: WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Revisions_Min_Fields>) => null | string,
  revisions_scenario_equipment_xref_seals_revisions_mutation_response?: (data: WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Revisions_Mutation_Response>) => null | string,
  revisions_scenario_parameters_journal?: (data: WithTypename<Revisions_Scenario_Parameters_Journal>) => null | string,
  revisions_scenario_parameters_journal_aggregate?: (data: WithTypename<Revisions_Scenario_Parameters_Journal_Aggregate>) => null | string,
  revisions_scenario_parameters_journal_aggregate_fields?: (data: WithTypename<Revisions_Scenario_Parameters_Journal_Aggregate_Fields>) => null | string,
  revisions_scenario_parameters_journal_max_fields?: (data: WithTypename<Revisions_Scenario_Parameters_Journal_Max_Fields>) => null | string,
  revisions_scenario_parameters_journal_min_fields?: (data: WithTypename<Revisions_Scenario_Parameters_Journal_Min_Fields>) => null | string,
  revisions_scenario_parameters_journal_mutation_response?: (data: WithTypename<Revisions_Scenario_Parameters_Journal_Mutation_Response>) => null | string,
  revisions_scenario_parameters_revisions?: (data: WithTypename<Revisions_Scenario_Parameters_Revisions>) => null | string,
  revisions_scenario_parameters_revisions_aggregate?: (data: WithTypename<Revisions_Scenario_Parameters_Revisions_Aggregate>) => null | string,
  revisions_scenario_parameters_revisions_aggregate_fields?: (data: WithTypename<Revisions_Scenario_Parameters_Revisions_Aggregate_Fields>) => null | string,
  revisions_scenario_parameters_revisions_avg_fields?: (data: WithTypename<Revisions_Scenario_Parameters_Revisions_Avg_Fields>) => null | string,
  revisions_scenario_parameters_revisions_max_fields?: (data: WithTypename<Revisions_Scenario_Parameters_Revisions_Max_Fields>) => null | string,
  revisions_scenario_parameters_revisions_min_fields?: (data: WithTypename<Revisions_Scenario_Parameters_Revisions_Min_Fields>) => null | string,
  revisions_scenario_parameters_revisions_mutation_response?: (data: WithTypename<Revisions_Scenario_Parameters_Revisions_Mutation_Response>) => null | string,
  revisions_scenario_parameters_revisions_stddev_fields?: (data: WithTypename<Revisions_Scenario_Parameters_Revisions_Stddev_Fields>) => null | string,
  revisions_scenario_parameters_revisions_stddev_pop_fields?: (data: WithTypename<Revisions_Scenario_Parameters_Revisions_Stddev_Pop_Fields>) => null | string,
  revisions_scenario_parameters_revisions_stddev_samp_fields?: (data: WithTypename<Revisions_Scenario_Parameters_Revisions_Stddev_Samp_Fields>) => null | string,
  revisions_scenario_parameters_revisions_sum_fields?: (data: WithTypename<Revisions_Scenario_Parameters_Revisions_Sum_Fields>) => null | string,
  revisions_scenario_parameters_revisions_var_pop_fields?: (data: WithTypename<Revisions_Scenario_Parameters_Revisions_Var_Pop_Fields>) => null | string,
  revisions_scenario_parameters_revisions_var_samp_fields?: (data: WithTypename<Revisions_Scenario_Parameters_Revisions_Var_Samp_Fields>) => null | string,
  revisions_scenario_parameters_revisions_variance_fields?: (data: WithTypename<Revisions_Scenario_Parameters_Revisions_Variance_Fields>) => null | string,
  revisions_scenario_well_properties_journal?: (data: WithTypename<Revisions_Scenario_Well_Properties_Journal>) => null | string,
  revisions_scenario_well_properties_journal_aggregate?: (data: WithTypename<Revisions_Scenario_Well_Properties_Journal_Aggregate>) => null | string,
  revisions_scenario_well_properties_journal_aggregate_fields?: (data: WithTypename<Revisions_Scenario_Well_Properties_Journal_Aggregate_Fields>) => null | string,
  revisions_scenario_well_properties_journal_max_fields?: (data: WithTypename<Revisions_Scenario_Well_Properties_Journal_Max_Fields>) => null | string,
  revisions_scenario_well_properties_journal_min_fields?: (data: WithTypename<Revisions_Scenario_Well_Properties_Journal_Min_Fields>) => null | string,
  revisions_scenario_well_properties_journal_mutation_response?: (data: WithTypename<Revisions_Scenario_Well_Properties_Journal_Mutation_Response>) => null | string,
  revisions_scenario_well_properties_revisions?: (data: WithTypename<Revisions_Scenario_Well_Properties_Revisions>) => null | string,
  revisions_scenario_well_properties_revisions_aggregate?: (data: WithTypename<Revisions_Scenario_Well_Properties_Revisions_Aggregate>) => null | string,
  revisions_scenario_well_properties_revisions_aggregate_fields?: (data: WithTypename<Revisions_Scenario_Well_Properties_Revisions_Aggregate_Fields>) => null | string,
  revisions_scenario_well_properties_revisions_avg_fields?: (data: WithTypename<Revisions_Scenario_Well_Properties_Revisions_Avg_Fields>) => null | string,
  revisions_scenario_well_properties_revisions_max_fields?: (data: WithTypename<Revisions_Scenario_Well_Properties_Revisions_Max_Fields>) => null | string,
  revisions_scenario_well_properties_revisions_min_fields?: (data: WithTypename<Revisions_Scenario_Well_Properties_Revisions_Min_Fields>) => null | string,
  revisions_scenario_well_properties_revisions_mutation_response?: (data: WithTypename<Revisions_Scenario_Well_Properties_Revisions_Mutation_Response>) => null | string,
  revisions_scenario_well_properties_revisions_stddev_fields?: (data: WithTypename<Revisions_Scenario_Well_Properties_Revisions_Stddev_Fields>) => null | string,
  revisions_scenario_well_properties_revisions_stddev_pop_fields?: (data: WithTypename<Revisions_Scenario_Well_Properties_Revisions_Stddev_Pop_Fields>) => null | string,
  revisions_scenario_well_properties_revisions_stddev_samp_fields?: (data: WithTypename<Revisions_Scenario_Well_Properties_Revisions_Stddev_Samp_Fields>) => null | string,
  revisions_scenario_well_properties_revisions_sum_fields?: (data: WithTypename<Revisions_Scenario_Well_Properties_Revisions_Sum_Fields>) => null | string,
  revisions_scenario_well_properties_revisions_var_pop_fields?: (data: WithTypename<Revisions_Scenario_Well_Properties_Revisions_Var_Pop_Fields>) => null | string,
  revisions_scenario_well_properties_revisions_var_samp_fields?: (data: WithTypename<Revisions_Scenario_Well_Properties_Revisions_Var_Samp_Fields>) => null | string,
  revisions_scenario_well_properties_revisions_variance_fields?: (data: WithTypename<Revisions_Scenario_Well_Properties_Revisions_Variance_Fields>) => null | string,
  revisions_scenarios_journal?: (data: WithTypename<Revisions_Scenarios_Journal>) => null | string,
  revisions_scenarios_journal_aggregate?: (data: WithTypename<Revisions_Scenarios_Journal_Aggregate>) => null | string,
  revisions_scenarios_journal_aggregate_fields?: (data: WithTypename<Revisions_Scenarios_Journal_Aggregate_Fields>) => null | string,
  revisions_scenarios_journal_max_fields?: (data: WithTypename<Revisions_Scenarios_Journal_Max_Fields>) => null | string,
  revisions_scenarios_journal_min_fields?: (data: WithTypename<Revisions_Scenarios_Journal_Min_Fields>) => null | string,
  revisions_scenarios_journal_mutation_response?: (data: WithTypename<Revisions_Scenarios_Journal_Mutation_Response>) => null | string,
  revisions_scenarios_revisions?: (data: WithTypename<Revisions_Scenarios_Revisions>) => null | string,
  revisions_scenarios_revisions_aggregate?: (data: WithTypename<Revisions_Scenarios_Revisions_Aggregate>) => null | string,
  revisions_scenarios_revisions_aggregate_fields?: (data: WithTypename<Revisions_Scenarios_Revisions_Aggregate_Fields>) => null | string,
  revisions_scenarios_revisions_max_fields?: (data: WithTypename<Revisions_Scenarios_Revisions_Max_Fields>) => null | string,
  revisions_scenarios_revisions_min_fields?: (data: WithTypename<Revisions_Scenarios_Revisions_Min_Fields>) => null | string,
  revisions_scenarios_revisions_mutation_response?: (data: WithTypename<Revisions_Scenarios_Revisions_Mutation_Response>) => null | string,
  revisions_sizings_journal?: (data: WithTypename<Revisions_Sizings_Journal>) => null | string,
  revisions_sizings_journal_aggregate?: (data: WithTypename<Revisions_Sizings_Journal_Aggregate>) => null | string,
  revisions_sizings_journal_aggregate_fields?: (data: WithTypename<Revisions_Sizings_Journal_Aggregate_Fields>) => null | string,
  revisions_sizings_journal_max_fields?: (data: WithTypename<Revisions_Sizings_Journal_Max_Fields>) => null | string,
  revisions_sizings_journal_min_fields?: (data: WithTypename<Revisions_Sizings_Journal_Min_Fields>) => null | string,
  revisions_sizings_journal_mutation_response?: (data: WithTypename<Revisions_Sizings_Journal_Mutation_Response>) => null | string,
  revisions_sizings_revisions?: (data: WithTypename<Revisions_Sizings_Revisions>) => null | string,
  revisions_sizings_revisions_aggregate?: (data: WithTypename<Revisions_Sizings_Revisions_Aggregate>) => null | string,
  revisions_sizings_revisions_aggregate_fields?: (data: WithTypename<Revisions_Sizings_Revisions_Aggregate_Fields>) => null | string,
  revisions_sizings_revisions_avg_fields?: (data: WithTypename<Revisions_Sizings_Revisions_Avg_Fields>) => null | string,
  revisions_sizings_revisions_max_fields?: (data: WithTypename<Revisions_Sizings_Revisions_Max_Fields>) => null | string,
  revisions_sizings_revisions_min_fields?: (data: WithTypename<Revisions_Sizings_Revisions_Min_Fields>) => null | string,
  revisions_sizings_revisions_mutation_response?: (data: WithTypename<Revisions_Sizings_Revisions_Mutation_Response>) => null | string,
  revisions_sizings_revisions_stddev_fields?: (data: WithTypename<Revisions_Sizings_Revisions_Stddev_Fields>) => null | string,
  revisions_sizings_revisions_stddev_pop_fields?: (data: WithTypename<Revisions_Sizings_Revisions_Stddev_Pop_Fields>) => null | string,
  revisions_sizings_revisions_stddev_samp_fields?: (data: WithTypename<Revisions_Sizings_Revisions_Stddev_Samp_Fields>) => null | string,
  revisions_sizings_revisions_sum_fields?: (data: WithTypename<Revisions_Sizings_Revisions_Sum_Fields>) => null | string,
  revisions_sizings_revisions_var_pop_fields?: (data: WithTypename<Revisions_Sizings_Revisions_Var_Pop_Fields>) => null | string,
  revisions_sizings_revisions_var_samp_fields?: (data: WithTypename<Revisions_Sizings_Revisions_Var_Samp_Fields>) => null | string,
  revisions_sizings_revisions_variance_fields?: (data: WithTypename<Revisions_Sizings_Revisions_Variance_Fields>) => null | string,
  saturated_oil_options?: (data: WithTypename<Saturated_Oil_Options>) => null | string,
  saturated_oil_options_aggregate?: (data: WithTypename<Saturated_Oil_Options_Aggregate>) => null | string,
  saturated_oil_options_aggregate_fields?: (data: WithTypename<Saturated_Oil_Options_Aggregate_Fields>) => null | string,
  saturated_oil_options_max_fields?: (data: WithTypename<Saturated_Oil_Options_Max_Fields>) => null | string,
  saturated_oil_options_min_fields?: (data: WithTypename<Saturated_Oil_Options_Min_Fields>) => null | string,
  saturated_oil_options_mutation_response?: (data: WithTypename<Saturated_Oil_Options_Mutation_Response>) => null | string,
  sc_equip_xref_downhole_ytool_bypass_tubings?: (data: WithTypename<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings>) => null | string,
  sc_equip_xref_downhole_ytool_bypass_tubings_aggregate?: (data: WithTypename<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Aggregate>) => null | string,
  sc_equip_xref_downhole_ytool_bypass_tubings_aggregate_fields?: (data: WithTypename<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Aggregate_Fields>) => null | string,
  sc_equip_xref_downhole_ytool_bypass_tubings_avg_fields?: (data: WithTypename<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Avg_Fields>) => null | string,
  sc_equip_xref_downhole_ytool_bypass_tubings_max_fields?: (data: WithTypename<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Max_Fields>) => null | string,
  sc_equip_xref_downhole_ytool_bypass_tubings_min_fields?: (data: WithTypename<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Min_Fields>) => null | string,
  sc_equip_xref_downhole_ytool_bypass_tubings_stddev_fields?: (data: WithTypename<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Stddev_Fields>) => null | string,
  sc_equip_xref_downhole_ytool_bypass_tubings_stddev_pop_fields?: (data: WithTypename<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Stddev_Pop_Fields>) => null | string,
  sc_equip_xref_downhole_ytool_bypass_tubings_stddev_samp_fields?: (data: WithTypename<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Stddev_Samp_Fields>) => null | string,
  sc_equip_xref_downhole_ytool_bypass_tubings_sum_fields?: (data: WithTypename<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Sum_Fields>) => null | string,
  sc_equip_xref_downhole_ytool_bypass_tubings_var_pop_fields?: (data: WithTypename<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Var_Pop_Fields>) => null | string,
  sc_equip_xref_downhole_ytool_bypass_tubings_var_samp_fields?: (data: WithTypename<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Var_Samp_Fields>) => null | string,
  sc_equip_xref_downhole_ytool_bypass_tubings_variance_fields?: (data: WithTypename<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Variance_Fields>) => null | string,
  sc_equip_xref_downhole_ytool_equip_tubings?: (data: WithTypename<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings>) => null | string,
  sc_equip_xref_downhole_ytool_equip_tubings_aggregate?: (data: WithTypename<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Aggregate>) => null | string,
  sc_equip_xref_downhole_ytool_equip_tubings_aggregate_fields?: (data: WithTypename<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Aggregate_Fields>) => null | string,
  sc_equip_xref_downhole_ytool_equip_tubings_avg_fields?: (data: WithTypename<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Avg_Fields>) => null | string,
  sc_equip_xref_downhole_ytool_equip_tubings_max_fields?: (data: WithTypename<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Max_Fields>) => null | string,
  sc_equip_xref_downhole_ytool_equip_tubings_min_fields?: (data: WithTypename<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Min_Fields>) => null | string,
  sc_equip_xref_downhole_ytool_equip_tubings_stddev_fields?: (data: WithTypename<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Stddev_Fields>) => null | string,
  sc_equip_xref_downhole_ytool_equip_tubings_stddev_pop_fields?: (data: WithTypename<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Stddev_Pop_Fields>) => null | string,
  sc_equip_xref_downhole_ytool_equip_tubings_stddev_samp_fields?: (data: WithTypename<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Stddev_Samp_Fields>) => null | string,
  sc_equip_xref_downhole_ytool_equip_tubings_sum_fields?: (data: WithTypename<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Sum_Fields>) => null | string,
  sc_equip_xref_downhole_ytool_equip_tubings_var_pop_fields?: (data: WithTypename<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Var_Pop_Fields>) => null | string,
  sc_equip_xref_downhole_ytool_equip_tubings_var_samp_fields?: (data: WithTypename<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Var_Samp_Fields>) => null | string,
  sc_equip_xref_downhole_ytool_equip_tubings_variance_fields?: (data: WithTypename<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Variance_Fields>) => null | string,
  sc_equip_xref_uphole_ytool_bypass_tubings?: (data: WithTypename<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings>) => null | string,
  sc_equip_xref_uphole_ytool_bypass_tubings_aggregate?: (data: WithTypename<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Aggregate>) => null | string,
  sc_equip_xref_uphole_ytool_bypass_tubings_aggregate_fields?: (data: WithTypename<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Aggregate_Fields>) => null | string,
  sc_equip_xref_uphole_ytool_bypass_tubings_avg_fields?: (data: WithTypename<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Avg_Fields>) => null | string,
  sc_equip_xref_uphole_ytool_bypass_tubings_max_fields?: (data: WithTypename<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Max_Fields>) => null | string,
  sc_equip_xref_uphole_ytool_bypass_tubings_min_fields?: (data: WithTypename<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Min_Fields>) => null | string,
  sc_equip_xref_uphole_ytool_bypass_tubings_stddev_fields?: (data: WithTypename<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Stddev_Fields>) => null | string,
  sc_equip_xref_uphole_ytool_bypass_tubings_stddev_pop_fields?: (data: WithTypename<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Stddev_Pop_Fields>) => null | string,
  sc_equip_xref_uphole_ytool_bypass_tubings_stddev_samp_fields?: (data: WithTypename<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Stddev_Samp_Fields>) => null | string,
  sc_equip_xref_uphole_ytool_bypass_tubings_sum_fields?: (data: WithTypename<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Sum_Fields>) => null | string,
  sc_equip_xref_uphole_ytool_bypass_tubings_var_pop_fields?: (data: WithTypename<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Var_Pop_Fields>) => null | string,
  sc_equip_xref_uphole_ytool_bypass_tubings_var_samp_fields?: (data: WithTypename<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Var_Samp_Fields>) => null | string,
  sc_equip_xref_uphole_ytool_bypass_tubings_variance_fields?: (data: WithTypename<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Variance_Fields>) => null | string,
  sc_equip_xref_uphole_ytool_equip_tubings?: (data: WithTypename<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings>) => null | string,
  sc_equip_xref_uphole_ytool_equip_tubings_aggregate?: (data: WithTypename<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Aggregate>) => null | string,
  sc_equip_xref_uphole_ytool_equip_tubings_aggregate_fields?: (data: WithTypename<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Aggregate_Fields>) => null | string,
  sc_equip_xref_uphole_ytool_equip_tubings_avg_fields?: (data: WithTypename<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Avg_Fields>) => null | string,
  sc_equip_xref_uphole_ytool_equip_tubings_max_fields?: (data: WithTypename<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Max_Fields>) => null | string,
  sc_equip_xref_uphole_ytool_equip_tubings_min_fields?: (data: WithTypename<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Min_Fields>) => null | string,
  sc_equip_xref_uphole_ytool_equip_tubings_stddev_fields?: (data: WithTypename<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Stddev_Fields>) => null | string,
  sc_equip_xref_uphole_ytool_equip_tubings_stddev_pop_fields?: (data: WithTypename<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Stddev_Pop_Fields>) => null | string,
  sc_equip_xref_uphole_ytool_equip_tubings_stddev_samp_fields?: (data: WithTypename<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Stddev_Samp_Fields>) => null | string,
  sc_equip_xref_uphole_ytool_equip_tubings_sum_fields?: (data: WithTypename<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Sum_Fields>) => null | string,
  sc_equip_xref_uphole_ytool_equip_tubings_var_pop_fields?: (data: WithTypename<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Var_Pop_Fields>) => null | string,
  sc_equip_xref_uphole_ytool_equip_tubings_var_samp_fields?: (data: WithTypename<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Var_Samp_Fields>) => null | string,
  sc_equip_xref_uphole_ytool_equip_tubings_variance_fields?: (data: WithTypename<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Variance_Fields>) => null | string,
  scenario_correlations?: (data: WithTypename<Scenario_Correlations>) => null | string,
  scenario_correlations_aggregate?: (data: WithTypename<Scenario_Correlations_Aggregate>) => null | string,
  scenario_correlations_aggregate_fields?: (data: WithTypename<Scenario_Correlations_Aggregate_Fields>) => null | string,
  scenario_correlations_avg_fields?: (data: WithTypename<Scenario_Correlations_Avg_Fields>) => null | string,
  scenario_correlations_max_fields?: (data: WithTypename<Scenario_Correlations_Max_Fields>) => null | string,
  scenario_correlations_min_fields?: (data: WithTypename<Scenario_Correlations_Min_Fields>) => null | string,
  scenario_correlations_stddev_fields?: (data: WithTypename<Scenario_Correlations_Stddev_Fields>) => null | string,
  scenario_correlations_stddev_pop_fields?: (data: WithTypename<Scenario_Correlations_Stddev_Pop_Fields>) => null | string,
  scenario_correlations_stddev_samp_fields?: (data: WithTypename<Scenario_Correlations_Stddev_Samp_Fields>) => null | string,
  scenario_correlations_sum_fields?: (data: WithTypename<Scenario_Correlations_Sum_Fields>) => null | string,
  scenario_correlations_var_pop_fields?: (data: WithTypename<Scenario_Correlations_Var_Pop_Fields>) => null | string,
  scenario_correlations_var_samp_fields?: (data: WithTypename<Scenario_Correlations_Var_Samp_Fields>) => null | string,
  scenario_correlations_variance_fields?: (data: WithTypename<Scenario_Correlations_Variance_Fields>) => null | string,
  scenario_equipment?: (data: WithTypename<Scenario_Equipment>) => null | string,
  scenario_equipment_aggregate?: (data: WithTypename<Scenario_Equipment_Aggregate>) => null | string,
  scenario_equipment_aggregate_fields?: (data: WithTypename<Scenario_Equipment_Aggregate_Fields>) => null | string,
  scenario_equipment_max_fields?: (data: WithTypename<Scenario_Equipment_Max_Fields>) => null | string,
  scenario_equipment_min_fields?: (data: WithTypename<Scenario_Equipment_Min_Fields>) => null | string,
  scenario_equipment_xref_cables?: (data: WithTypename<Scenario_Equipment_Xref_Cables>) => null | string,
  scenario_equipment_xref_cables_aggregate?: (data: WithTypename<Scenario_Equipment_Xref_Cables_Aggregate>) => null | string,
  scenario_equipment_xref_cables_aggregate_fields?: (data: WithTypename<Scenario_Equipment_Xref_Cables_Aggregate_Fields>) => null | string,
  scenario_equipment_xref_cables_avg_fields?: (data: WithTypename<Scenario_Equipment_Xref_Cables_Avg_Fields>) => null | string,
  scenario_equipment_xref_cables_max_fields?: (data: WithTypename<Scenario_Equipment_Xref_Cables_Max_Fields>) => null | string,
  scenario_equipment_xref_cables_min_fields?: (data: WithTypename<Scenario_Equipment_Xref_Cables_Min_Fields>) => null | string,
  scenario_equipment_xref_cables_stddev_fields?: (data: WithTypename<Scenario_Equipment_Xref_Cables_Stddev_Fields>) => null | string,
  scenario_equipment_xref_cables_stddev_pop_fields?: (data: WithTypename<Scenario_Equipment_Xref_Cables_Stddev_Pop_Fields>) => null | string,
  scenario_equipment_xref_cables_stddev_samp_fields?: (data: WithTypename<Scenario_Equipment_Xref_Cables_Stddev_Samp_Fields>) => null | string,
  scenario_equipment_xref_cables_sum_fields?: (data: WithTypename<Scenario_Equipment_Xref_Cables_Sum_Fields>) => null | string,
  scenario_equipment_xref_cables_var_pop_fields?: (data: WithTypename<Scenario_Equipment_Xref_Cables_Var_Pop_Fields>) => null | string,
  scenario_equipment_xref_cables_var_samp_fields?: (data: WithTypename<Scenario_Equipment_Xref_Cables_Var_Samp_Fields>) => null | string,
  scenario_equipment_xref_cables_variance_fields?: (data: WithTypename<Scenario_Equipment_Xref_Cables_Variance_Fields>) => null | string,
  scenario_equipment_xref_housings?: (data: WithTypename<Scenario_Equipment_Xref_Housings>) => null | string,
  scenario_equipment_xref_housings_aggregate?: (data: WithTypename<Scenario_Equipment_Xref_Housings_Aggregate>) => null | string,
  scenario_equipment_xref_housings_aggregate_fields?: (data: WithTypename<Scenario_Equipment_Xref_Housings_Aggregate_Fields>) => null | string,
  scenario_equipment_xref_housings_avg_fields?: (data: WithTypename<Scenario_Equipment_Xref_Housings_Avg_Fields>) => null | string,
  scenario_equipment_xref_housings_max_fields?: (data: WithTypename<Scenario_Equipment_Xref_Housings_Max_Fields>) => null | string,
  scenario_equipment_xref_housings_min_fields?: (data: WithTypename<Scenario_Equipment_Xref_Housings_Min_Fields>) => null | string,
  scenario_equipment_xref_housings_stddev_fields?: (data: WithTypename<Scenario_Equipment_Xref_Housings_Stddev_Fields>) => null | string,
  scenario_equipment_xref_housings_stddev_pop_fields?: (data: WithTypename<Scenario_Equipment_Xref_Housings_Stddev_Pop_Fields>) => null | string,
  scenario_equipment_xref_housings_stddev_samp_fields?: (data: WithTypename<Scenario_Equipment_Xref_Housings_Stddev_Samp_Fields>) => null | string,
  scenario_equipment_xref_housings_sum_fields?: (data: WithTypename<Scenario_Equipment_Xref_Housings_Sum_Fields>) => null | string,
  scenario_equipment_xref_housings_var_pop_fields?: (data: WithTypename<Scenario_Equipment_Xref_Housings_Var_Pop_Fields>) => null | string,
  scenario_equipment_xref_housings_var_samp_fields?: (data: WithTypename<Scenario_Equipment_Xref_Housings_Var_Samp_Fields>) => null | string,
  scenario_equipment_xref_housings_variance_fields?: (data: WithTypename<Scenario_Equipment_Xref_Housings_Variance_Fields>) => null | string,
  scenario_equipment_xref_intakes?: (data: WithTypename<Scenario_Equipment_Xref_Intakes>) => null | string,
  scenario_equipment_xref_intakes_aggregate?: (data: WithTypename<Scenario_Equipment_Xref_Intakes_Aggregate>) => null | string,
  scenario_equipment_xref_intakes_aggregate_fields?: (data: WithTypename<Scenario_Equipment_Xref_Intakes_Aggregate_Fields>) => null | string,
  scenario_equipment_xref_intakes_max_fields?: (data: WithTypename<Scenario_Equipment_Xref_Intakes_Max_Fields>) => null | string,
  scenario_equipment_xref_intakes_min_fields?: (data: WithTypename<Scenario_Equipment_Xref_Intakes_Min_Fields>) => null | string,
  scenario_equipment_xref_pumps?: (data: WithTypename<Scenario_Equipment_Xref_Pumps>) => null | string,
  scenario_equipment_xref_pumps_aggregate?: (data: WithTypename<Scenario_Equipment_Xref_Pumps_Aggregate>) => null | string,
  scenario_equipment_xref_pumps_aggregate_fields?: (data: WithTypename<Scenario_Equipment_Xref_Pumps_Aggregate_Fields>) => null | string,
  scenario_equipment_xref_pumps_avg_fields?: (data: WithTypename<Scenario_Equipment_Xref_Pumps_Avg_Fields>) => null | string,
  scenario_equipment_xref_pumps_max_fields?: (data: WithTypename<Scenario_Equipment_Xref_Pumps_Max_Fields>) => null | string,
  scenario_equipment_xref_pumps_min_fields?: (data: WithTypename<Scenario_Equipment_Xref_Pumps_Min_Fields>) => null | string,
  scenario_equipment_xref_pumps_stddev_fields?: (data: WithTypename<Scenario_Equipment_Xref_Pumps_Stddev_Fields>) => null | string,
  scenario_equipment_xref_pumps_stddev_pop_fields?: (data: WithTypename<Scenario_Equipment_Xref_Pumps_Stddev_Pop_Fields>) => null | string,
  scenario_equipment_xref_pumps_stddev_samp_fields?: (data: WithTypename<Scenario_Equipment_Xref_Pumps_Stddev_Samp_Fields>) => null | string,
  scenario_equipment_xref_pumps_sum_fields?: (data: WithTypename<Scenario_Equipment_Xref_Pumps_Sum_Fields>) => null | string,
  scenario_equipment_xref_pumps_var_pop_fields?: (data: WithTypename<Scenario_Equipment_Xref_Pumps_Var_Pop_Fields>) => null | string,
  scenario_equipment_xref_pumps_var_samp_fields?: (data: WithTypename<Scenario_Equipment_Xref_Pumps_Var_Samp_Fields>) => null | string,
  scenario_equipment_xref_pumps_variance_fields?: (data: WithTypename<Scenario_Equipment_Xref_Pumps_Variance_Fields>) => null | string,
  scenario_equipment_xref_seals?: (data: WithTypename<Scenario_Equipment_Xref_Seals>) => null | string,
  scenario_equipment_xref_seals_aggregate?: (data: WithTypename<Scenario_Equipment_Xref_Seals_Aggregate>) => null | string,
  scenario_equipment_xref_seals_aggregate_fields?: (data: WithTypename<Scenario_Equipment_Xref_Seals_Aggregate_Fields>) => null | string,
  scenario_equipment_xref_seals_max_fields?: (data: WithTypename<Scenario_Equipment_Xref_Seals_Max_Fields>) => null | string,
  scenario_equipment_xref_seals_min_fields?: (data: WithTypename<Scenario_Equipment_Xref_Seals_Min_Fields>) => null | string,
  scenario_parameters?: (data: WithTypename<Scenario_Parameters>) => null | string,
  scenario_parameters_aggregate?: (data: WithTypename<Scenario_Parameters_Aggregate>) => null | string,
  scenario_parameters_aggregate_fields?: (data: WithTypename<Scenario_Parameters_Aggregate_Fields>) => null | string,
  scenario_parameters_avg_fields?: (data: WithTypename<Scenario_Parameters_Avg_Fields>) => null | string,
  scenario_parameters_max_fields?: (data: WithTypename<Scenario_Parameters_Max_Fields>) => null | string,
  scenario_parameters_min_fields?: (data: WithTypename<Scenario_Parameters_Min_Fields>) => null | string,
  scenario_parameters_stddev_fields?: (data: WithTypename<Scenario_Parameters_Stddev_Fields>) => null | string,
  scenario_parameters_stddev_pop_fields?: (data: WithTypename<Scenario_Parameters_Stddev_Pop_Fields>) => null | string,
  scenario_parameters_stddev_samp_fields?: (data: WithTypename<Scenario_Parameters_Stddev_Samp_Fields>) => null | string,
  scenario_parameters_sum_fields?: (data: WithTypename<Scenario_Parameters_Sum_Fields>) => null | string,
  scenario_parameters_var_pop_fields?: (data: WithTypename<Scenario_Parameters_Var_Pop_Fields>) => null | string,
  scenario_parameters_var_samp_fields?: (data: WithTypename<Scenario_Parameters_Var_Samp_Fields>) => null | string,
  scenario_parameters_variance_fields?: (data: WithTypename<Scenario_Parameters_Variance_Fields>) => null | string,
  scenario_reasons?: (data: WithTypename<Scenario_Reasons>) => null | string,
  scenario_reasons_aggregate?: (data: WithTypename<Scenario_Reasons_Aggregate>) => null | string,
  scenario_reasons_aggregate_fields?: (data: WithTypename<Scenario_Reasons_Aggregate_Fields>) => null | string,
  scenario_reasons_max_fields?: (data: WithTypename<Scenario_Reasons_Max_Fields>) => null | string,
  scenario_reasons_min_fields?: (data: WithTypename<Scenario_Reasons_Min_Fields>) => null | string,
  scenario_reasons_mutation_response?: (data: WithTypename<Scenario_Reasons_Mutation_Response>) => null | string,
  scenario_well_properties?: (data: WithTypename<Scenario_Well_Properties>) => null | string,
  scenario_well_properties_aggregate?: (data: WithTypename<Scenario_Well_Properties_Aggregate>) => null | string,
  scenario_well_properties_aggregate_fields?: (data: WithTypename<Scenario_Well_Properties_Aggregate_Fields>) => null | string,
  scenario_well_properties_avg_fields?: (data: WithTypename<Scenario_Well_Properties_Avg_Fields>) => null | string,
  scenario_well_properties_max_fields?: (data: WithTypename<Scenario_Well_Properties_Max_Fields>) => null | string,
  scenario_well_properties_min_fields?: (data: WithTypename<Scenario_Well_Properties_Min_Fields>) => null | string,
  scenario_well_properties_stddev_fields?: (data: WithTypename<Scenario_Well_Properties_Stddev_Fields>) => null | string,
  scenario_well_properties_stddev_pop_fields?: (data: WithTypename<Scenario_Well_Properties_Stddev_Pop_Fields>) => null | string,
  scenario_well_properties_stddev_samp_fields?: (data: WithTypename<Scenario_Well_Properties_Stddev_Samp_Fields>) => null | string,
  scenario_well_properties_sum_fields?: (data: WithTypename<Scenario_Well_Properties_Sum_Fields>) => null | string,
  scenario_well_properties_var_pop_fields?: (data: WithTypename<Scenario_Well_Properties_Var_Pop_Fields>) => null | string,
  scenario_well_properties_var_samp_fields?: (data: WithTypename<Scenario_Well_Properties_Var_Samp_Fields>) => null | string,
  scenario_well_properties_variance_fields?: (data: WithTypename<Scenario_Well_Properties_Variance_Fields>) => null | string,
  scenarios?: (data: WithTypename<Scenarios>) => null | string,
  scenarios_aggregate?: (data: WithTypename<Scenarios_Aggregate>) => null | string,
  scenarios_aggregate_fields?: (data: WithTypename<Scenarios_Aggregate_Fields>) => null | string,
  scenarios_max_fields?: (data: WithTypename<Scenarios_Max_Fields>) => null | string,
  scenarios_min_fields?: (data: WithTypename<Scenarios_Min_Fields>) => null | string,
  seal_motor_oil?: (data: WithTypename<Seal_Motor_Oil>) => null | string,
  seal_motor_oil_aggregate?: (data: WithTypename<Seal_Motor_Oil_Aggregate>) => null | string,
  seal_motor_oil_aggregate_fields?: (data: WithTypename<Seal_Motor_Oil_Aggregate_Fields>) => null | string,
  seal_motor_oil_avg_fields?: (data: WithTypename<Seal_Motor_Oil_Avg_Fields>) => null | string,
  seal_motor_oil_max_fields?: (data: WithTypename<Seal_Motor_Oil_Max_Fields>) => null | string,
  seal_motor_oil_min_fields?: (data: WithTypename<Seal_Motor_Oil_Min_Fields>) => null | string,
  seal_motor_oil_mutation_response?: (data: WithTypename<Seal_Motor_Oil_Mutation_Response>) => null | string,
  seal_motor_oil_stddev_fields?: (data: WithTypename<Seal_Motor_Oil_Stddev_Fields>) => null | string,
  seal_motor_oil_stddev_pop_fields?: (data: WithTypename<Seal_Motor_Oil_Stddev_Pop_Fields>) => null | string,
  seal_motor_oil_stddev_samp_fields?: (data: WithTypename<Seal_Motor_Oil_Stddev_Samp_Fields>) => null | string,
  seal_motor_oil_sum_fields?: (data: WithTypename<Seal_Motor_Oil_Sum_Fields>) => null | string,
  seal_motor_oil_var_pop_fields?: (data: WithTypename<Seal_Motor_Oil_Var_Pop_Fields>) => null | string,
  seal_motor_oil_var_samp_fields?: (data: WithTypename<Seal_Motor_Oil_Var_Samp_Fields>) => null | string,
  seal_motor_oil_variance_fields?: (data: WithTypename<Seal_Motor_Oil_Variance_Fields>) => null | string,
  seals?: (data: WithTypename<Seals>) => null | string,
  seals_aggregate?: (data: WithTypename<Seals_Aggregate>) => null | string,
  seals_aggregate_fields?: (data: WithTypename<Seals_Aggregate_Fields>) => null | string,
  seals_avg_fields?: (data: WithTypename<Seals_Avg_Fields>) => null | string,
  seals_max_fields?: (data: WithTypename<Seals_Max_Fields>) => null | string,
  seals_min_fields?: (data: WithTypename<Seals_Min_Fields>) => null | string,
  seals_mutation_response?: (data: WithTypename<Seals_Mutation_Response>) => null | string,
  seals_stddev_fields?: (data: WithTypename<Seals_Stddev_Fields>) => null | string,
  seals_stddev_pop_fields?: (data: WithTypename<Seals_Stddev_Pop_Fields>) => null | string,
  seals_stddev_samp_fields?: (data: WithTypename<Seals_Stddev_Samp_Fields>) => null | string,
  seals_sum_fields?: (data: WithTypename<Seals_Sum_Fields>) => null | string,
  seals_var_pop_fields?: (data: WithTypename<Seals_Var_Pop_Fields>) => null | string,
  seals_var_samp_fields?: (data: WithTypename<Seals_Var_Samp_Fields>) => null | string,
  seals_variance_fields?: (data: WithTypename<Seals_Variance_Fields>) => null | string,
  sensors?: (data: WithTypename<Sensors>) => null | string,
  sensors_aggregate?: (data: WithTypename<Sensors_Aggregate>) => null | string,
  sensors_aggregate_fields?: (data: WithTypename<Sensors_Aggregate_Fields>) => null | string,
  sensors_avg_fields?: (data: WithTypename<Sensors_Avg_Fields>) => null | string,
  sensors_max_fields?: (data: WithTypename<Sensors_Max_Fields>) => null | string,
  sensors_min_fields?: (data: WithTypename<Sensors_Min_Fields>) => null | string,
  sensors_mutation_response?: (data: WithTypename<Sensors_Mutation_Response>) => null | string,
  sensors_stddev_fields?: (data: WithTypename<Sensors_Stddev_Fields>) => null | string,
  sensors_stddev_pop_fields?: (data: WithTypename<Sensors_Stddev_Pop_Fields>) => null | string,
  sensors_stddev_samp_fields?: (data: WithTypename<Sensors_Stddev_Samp_Fields>) => null | string,
  sensors_sum_fields?: (data: WithTypename<Sensors_Sum_Fields>) => null | string,
  sensors_var_pop_fields?: (data: WithTypename<Sensors_Var_Pop_Fields>) => null | string,
  sensors_var_samp_fields?: (data: WithTypename<Sensors_Var_Samp_Fields>) => null | string,
  sensors_variance_fields?: (data: WithTypename<Sensors_Variance_Fields>) => null | string,
  sizing_dispositions?: (data: WithTypename<Sizing_Dispositions>) => null | string,
  sizing_dispositions_aggregate?: (data: WithTypename<Sizing_Dispositions_Aggregate>) => null | string,
  sizing_dispositions_aggregate_fields?: (data: WithTypename<Sizing_Dispositions_Aggregate_Fields>) => null | string,
  sizing_dispositions_max_fields?: (data: WithTypename<Sizing_Dispositions_Max_Fields>) => null | string,
  sizing_dispositions_min_fields?: (data: WithTypename<Sizing_Dispositions_Min_Fields>) => null | string,
  sizing_dispositions_mutation_response?: (data: WithTypename<Sizing_Dispositions_Mutation_Response>) => null | string,
  sizing_imports?: (data: WithTypename<Sizing_Imports>) => null | string,
  sizing_imports_aggregate?: (data: WithTypename<Sizing_Imports_Aggregate>) => null | string,
  sizing_imports_aggregate_fields?: (data: WithTypename<Sizing_Imports_Aggregate_Fields>) => null | string,
  sizing_imports_avg_fields?: (data: WithTypename<Sizing_Imports_Avg_Fields>) => null | string,
  sizing_imports_max_fields?: (data: WithTypename<Sizing_Imports_Max_Fields>) => null | string,
  sizing_imports_min_fields?: (data: WithTypename<Sizing_Imports_Min_Fields>) => null | string,
  sizing_imports_mutation_response?: (data: WithTypename<Sizing_Imports_Mutation_Response>) => null | string,
  sizing_imports_stddev_fields?: (data: WithTypename<Sizing_Imports_Stddev_Fields>) => null | string,
  sizing_imports_stddev_pop_fields?: (data: WithTypename<Sizing_Imports_Stddev_Pop_Fields>) => null | string,
  sizing_imports_stddev_samp_fields?: (data: WithTypename<Sizing_Imports_Stddev_Samp_Fields>) => null | string,
  sizing_imports_sum_fields?: (data: WithTypename<Sizing_Imports_Sum_Fields>) => null | string,
  sizing_imports_var_pop_fields?: (data: WithTypename<Sizing_Imports_Var_Pop_Fields>) => null | string,
  sizing_imports_var_samp_fields?: (data: WithTypename<Sizing_Imports_Var_Samp_Fields>) => null | string,
  sizing_imports_variance_fields?: (data: WithTypename<Sizing_Imports_Variance_Fields>) => null | string,
  sizing_pumping_type?: (data: WithTypename<Sizing_Pumping_Type>) => null | string,
  sizing_pumping_type_aggregate?: (data: WithTypename<Sizing_Pumping_Type_Aggregate>) => null | string,
  sizing_pumping_type_aggregate_fields?: (data: WithTypename<Sizing_Pumping_Type_Aggregate_Fields>) => null | string,
  sizing_pumping_type_max_fields?: (data: WithTypename<Sizing_Pumping_Type_Max_Fields>) => null | string,
  sizing_pumping_type_min_fields?: (data: WithTypename<Sizing_Pumping_Type_Min_Fields>) => null | string,
  sizing_pumping_type_mutation_response?: (data: WithTypename<Sizing_Pumping_Type_Mutation_Response>) => null | string,
  sizings?: (data: WithTypename<Sizings>) => null | string,
  sizings_aggregate?: (data: WithTypename<Sizings_Aggregate>) => null | string,
  sizings_aggregate_fields?: (data: WithTypename<Sizings_Aggregate_Fields>) => null | string,
  sizings_avg_fields?: (data: WithTypename<Sizings_Avg_Fields>) => null | string,
  sizings_max_fields?: (data: WithTypename<Sizings_Max_Fields>) => null | string,
  sizings_min_fields?: (data: WithTypename<Sizings_Min_Fields>) => null | string,
  sizings_stddev_fields?: (data: WithTypename<Sizings_Stddev_Fields>) => null | string,
  sizings_stddev_pop_fields?: (data: WithTypename<Sizings_Stddev_Pop_Fields>) => null | string,
  sizings_stddev_samp_fields?: (data: WithTypename<Sizings_Stddev_Samp_Fields>) => null | string,
  sizings_sum_fields?: (data: WithTypename<Sizings_Sum_Fields>) => null | string,
  sizings_var_pop_fields?: (data: WithTypename<Sizings_Var_Pop_Fields>) => null | string,
  sizings_var_samp_fields?: (data: WithTypename<Sizings_Var_Samp_Fields>) => null | string,
  sizings_variance_fields?: (data: WithTypename<Sizings_Variance_Fields>) => null | string,
  solution_gas_oil_ratio_options?: (data: WithTypename<Solution_Gas_Oil_Ratio_Options>) => null | string,
  solution_gas_oil_ratio_options_aggregate?: (data: WithTypename<Solution_Gas_Oil_Ratio_Options_Aggregate>) => null | string,
  solution_gas_oil_ratio_options_aggregate_fields?: (data: WithTypename<Solution_Gas_Oil_Ratio_Options_Aggregate_Fields>) => null | string,
  solution_gas_oil_ratio_options_max_fields?: (data: WithTypename<Solution_Gas_Oil_Ratio_Options_Max_Fields>) => null | string,
  solution_gas_oil_ratio_options_min_fields?: (data: WithTypename<Solution_Gas_Oil_Ratio_Options_Min_Fields>) => null | string,
  solution_gas_oil_ratio_options_mutation_response?: (data: WithTypename<Solution_Gas_Oil_Ratio_Options_Mutation_Response>) => null | string,
  status?: (data: WithTypename<Status>) => null | string,
  status_aggregate?: (data: WithTypename<Status_Aggregate>) => null | string,
  status_aggregate_fields?: (data: WithTypename<Status_Aggregate_Fields>) => null | string,
  status_max_fields?: (data: WithTypename<Status_Max_Fields>) => null | string,
  status_min_fields?: (data: WithTypename<Status_Min_Fields>) => null | string,
  step_down_transformers?: (data: WithTypename<Step_Down_Transformers>) => null | string,
  step_down_transformers_aggregate?: (data: WithTypename<Step_Down_Transformers_Aggregate>) => null | string,
  step_down_transformers_aggregate_fields?: (data: WithTypename<Step_Down_Transformers_Aggregate_Fields>) => null | string,
  step_down_transformers_avg_fields?: (data: WithTypename<Step_Down_Transformers_Avg_Fields>) => null | string,
  step_down_transformers_max_fields?: (data: WithTypename<Step_Down_Transformers_Max_Fields>) => null | string,
  step_down_transformers_min_fields?: (data: WithTypename<Step_Down_Transformers_Min_Fields>) => null | string,
  step_down_transformers_mutation_response?: (data: WithTypename<Step_Down_Transformers_Mutation_Response>) => null | string,
  step_down_transformers_stddev_fields?: (data: WithTypename<Step_Down_Transformers_Stddev_Fields>) => null | string,
  step_down_transformers_stddev_pop_fields?: (data: WithTypename<Step_Down_Transformers_Stddev_Pop_Fields>) => null | string,
  step_down_transformers_stddev_samp_fields?: (data: WithTypename<Step_Down_Transformers_Stddev_Samp_Fields>) => null | string,
  step_down_transformers_sum_fields?: (data: WithTypename<Step_Down_Transformers_Sum_Fields>) => null | string,
  step_down_transformers_var_pop_fields?: (data: WithTypename<Step_Down_Transformers_Var_Pop_Fields>) => null | string,
  step_down_transformers_var_samp_fields?: (data: WithTypename<Step_Down_Transformers_Var_Samp_Fields>) => null | string,
  step_down_transformers_variance_fields?: (data: WithTypename<Step_Down_Transformers_Variance_Fields>) => null | string,
  step_up_transformers?: (data: WithTypename<Step_Up_Transformers>) => null | string,
  step_up_transformers_aggregate?: (data: WithTypename<Step_Up_Transformers_Aggregate>) => null | string,
  step_up_transformers_aggregate_fields?: (data: WithTypename<Step_Up_Transformers_Aggregate_Fields>) => null | string,
  step_up_transformers_avg_fields?: (data: WithTypename<Step_Up_Transformers_Avg_Fields>) => null | string,
  step_up_transformers_max_fields?: (data: WithTypename<Step_Up_Transformers_Max_Fields>) => null | string,
  step_up_transformers_min_fields?: (data: WithTypename<Step_Up_Transformers_Min_Fields>) => null | string,
  step_up_transformers_mutation_response?: (data: WithTypename<Step_Up_Transformers_Mutation_Response>) => null | string,
  step_up_transformers_stddev_fields?: (data: WithTypename<Step_Up_Transformers_Stddev_Fields>) => null | string,
  step_up_transformers_stddev_pop_fields?: (data: WithTypename<Step_Up_Transformers_Stddev_Pop_Fields>) => null | string,
  step_up_transformers_stddev_samp_fields?: (data: WithTypename<Step_Up_Transformers_Stddev_Samp_Fields>) => null | string,
  step_up_transformers_sum_fields?: (data: WithTypename<Step_Up_Transformers_Sum_Fields>) => null | string,
  step_up_transformers_var_pop_fields?: (data: WithTypename<Step_Up_Transformers_Var_Pop_Fields>) => null | string,
  step_up_transformers_var_samp_fields?: (data: WithTypename<Step_Up_Transformers_Var_Samp_Fields>) => null | string,
  step_up_transformers_variance_fields?: (data: WithTypename<Step_Up_Transformers_Variance_Fields>) => null | string,
  switchboards?: (data: WithTypename<Switchboards>) => null | string,
  switchboards_aggregate?: (data: WithTypename<Switchboards_Aggregate>) => null | string,
  switchboards_aggregate_fields?: (data: WithTypename<Switchboards_Aggregate_Fields>) => null | string,
  switchboards_avg_fields?: (data: WithTypename<Switchboards_Avg_Fields>) => null | string,
  switchboards_max_fields?: (data: WithTypename<Switchboards_Max_Fields>) => null | string,
  switchboards_min_fields?: (data: WithTypename<Switchboards_Min_Fields>) => null | string,
  switchboards_mutation_response?: (data: WithTypename<Switchboards_Mutation_Response>) => null | string,
  switchboards_stddev_fields?: (data: WithTypename<Switchboards_Stddev_Fields>) => null | string,
  switchboards_stddev_pop_fields?: (data: WithTypename<Switchboards_Stddev_Pop_Fields>) => null | string,
  switchboards_stddev_samp_fields?: (data: WithTypename<Switchboards_Stddev_Samp_Fields>) => null | string,
  switchboards_sum_fields?: (data: WithTypename<Switchboards_Sum_Fields>) => null | string,
  switchboards_var_pop_fields?: (data: WithTypename<Switchboards_Var_Pop_Fields>) => null | string,
  switchboards_var_samp_fields?: (data: WithTypename<Switchboards_Var_Samp_Fields>) => null | string,
  switchboards_variance_fields?: (data: WithTypename<Switchboards_Variance_Fields>) => null | string,
  tubing_flow_options?: (data: WithTypename<Tubing_Flow_Options>) => null | string,
  tubing_flow_options_aggregate?: (data: WithTypename<Tubing_Flow_Options_Aggregate>) => null | string,
  tubing_flow_options_aggregate_fields?: (data: WithTypename<Tubing_Flow_Options_Aggregate_Fields>) => null | string,
  tubing_flow_options_max_fields?: (data: WithTypename<Tubing_Flow_Options_Max_Fields>) => null | string,
  tubing_flow_options_min_fields?: (data: WithTypename<Tubing_Flow_Options_Min_Fields>) => null | string,
  tubing_flow_options_mutation_response?: (data: WithTypename<Tubing_Flow_Options_Mutation_Response>) => null | string,
  tubings?: (data: WithTypename<Tubings>) => null | string,
  tubings_aggregate?: (data: WithTypename<Tubings_Aggregate>) => null | string,
  tubings_aggregate_fields?: (data: WithTypename<Tubings_Aggregate_Fields>) => null | string,
  tubings_avg_fields?: (data: WithTypename<Tubings_Avg_Fields>) => null | string,
  tubings_max_fields?: (data: WithTypename<Tubings_Max_Fields>) => null | string,
  tubings_min_fields?: (data: WithTypename<Tubings_Min_Fields>) => null | string,
  tubings_mutation_response?: (data: WithTypename<Tubings_Mutation_Response>) => null | string,
  tubings_stddev_fields?: (data: WithTypename<Tubings_Stddev_Fields>) => null | string,
  tubings_stddev_pop_fields?: (data: WithTypename<Tubings_Stddev_Pop_Fields>) => null | string,
  tubings_stddev_samp_fields?: (data: WithTypename<Tubings_Stddev_Samp_Fields>) => null | string,
  tubings_sum_fields?: (data: WithTypename<Tubings_Sum_Fields>) => null | string,
  tubings_type?: (data: WithTypename<Tubings_Type>) => null | string,
  tubings_type_aggregate?: (data: WithTypename<Tubings_Type_Aggregate>) => null | string,
  tubings_type_aggregate_fields?: (data: WithTypename<Tubings_Type_Aggregate_Fields>) => null | string,
  tubings_type_max_fields?: (data: WithTypename<Tubings_Type_Max_Fields>) => null | string,
  tubings_type_min_fields?: (data: WithTypename<Tubings_Type_Min_Fields>) => null | string,
  tubings_type_mutation_response?: (data: WithTypename<Tubings_Type_Mutation_Response>) => null | string,
  tubings_var_pop_fields?: (data: WithTypename<Tubings_Var_Pop_Fields>) => null | string,
  tubings_var_samp_fields?: (data: WithTypename<Tubings_Var_Samp_Fields>) => null | string,
  tubings_variance_fields?: (data: WithTypename<Tubings_Variance_Fields>) => null | string,
  under_saturated_oil_options?: (data: WithTypename<Under_Saturated_Oil_Options>) => null | string,
  under_saturated_oil_options_aggregate?: (data: WithTypename<Under_Saturated_Oil_Options_Aggregate>) => null | string,
  under_saturated_oil_options_aggregate_fields?: (data: WithTypename<Under_Saturated_Oil_Options_Aggregate_Fields>) => null | string,
  under_saturated_oil_options_max_fields?: (data: WithTypename<Under_Saturated_Oil_Options_Max_Fields>) => null | string,
  under_saturated_oil_options_min_fields?: (data: WithTypename<Under_Saturated_Oil_Options_Min_Fields>) => null | string,
  under_saturated_oil_options_mutation_response?: (data: WithTypename<Under_Saturated_Oil_Options_Mutation_Response>) => null | string,
  user_eula_acceptance?: (data: WithTypename<User_Eula_Acceptance>) => null | string,
  user_eula_acceptance_aggregate?: (data: WithTypename<User_Eula_Acceptance_Aggregate>) => null | string,
  user_eula_acceptance_aggregate_fields?: (data: WithTypename<User_Eula_Acceptance_Aggregate_Fields>) => null | string,
  user_eula_acceptance_max_fields?: (data: WithTypename<User_Eula_Acceptance_Max_Fields>) => null | string,
  user_eula_acceptance_min_fields?: (data: WithTypename<User_Eula_Acceptance_Min_Fields>) => null | string,
  user_eula_acceptance_mutation_response?: (data: WithTypename<User_Eula_Acceptance_Mutation_Response>) => null | string,
  users?: (data: WithTypename<Users>) => null | string,
  users_aggregate?: (data: WithTypename<Users_Aggregate>) => null | string,
  users_aggregate_fields?: (data: WithTypename<Users_Aggregate_Fields>) => null | string,
  users_max_fields?: (data: WithTypename<Users_Max_Fields>) => null | string,
  users_min_fields?: (data: WithTypename<Users_Min_Fields>) => null | string,
  users_mutation_response?: (data: WithTypename<Users_Mutation_Response>) => null | string,
  variable_speed_drives?: (data: WithTypename<Variable_Speed_Drives>) => null | string,
  variable_speed_drives_aggregate?: (data: WithTypename<Variable_Speed_Drives_Aggregate>) => null | string,
  variable_speed_drives_aggregate_fields?: (data: WithTypename<Variable_Speed_Drives_Aggregate_Fields>) => null | string,
  variable_speed_drives_avg_fields?: (data: WithTypename<Variable_Speed_Drives_Avg_Fields>) => null | string,
  variable_speed_drives_max_fields?: (data: WithTypename<Variable_Speed_Drives_Max_Fields>) => null | string,
  variable_speed_drives_min_fields?: (data: WithTypename<Variable_Speed_Drives_Min_Fields>) => null | string,
  variable_speed_drives_mutation_response?: (data: WithTypename<Variable_Speed_Drives_Mutation_Response>) => null | string,
  variable_speed_drives_stddev_fields?: (data: WithTypename<Variable_Speed_Drives_Stddev_Fields>) => null | string,
  variable_speed_drives_stddev_pop_fields?: (data: WithTypename<Variable_Speed_Drives_Stddev_Pop_Fields>) => null | string,
  variable_speed_drives_stddev_samp_fields?: (data: WithTypename<Variable_Speed_Drives_Stddev_Samp_Fields>) => null | string,
  variable_speed_drives_sum_fields?: (data: WithTypename<Variable_Speed_Drives_Sum_Fields>) => null | string,
  variable_speed_drives_var_pop_fields?: (data: WithTypename<Variable_Speed_Drives_Var_Pop_Fields>) => null | string,
  variable_speed_drives_var_samp_fields?: (data: WithTypename<Variable_Speed_Drives_Var_Samp_Fields>) => null | string,
  variable_speed_drives_variance_fields?: (data: WithTypename<Variable_Speed_Drives_Variance_Fields>) => null | string,
  water_density_options?: (data: WithTypename<Water_Density_Options>) => null | string,
  water_density_options_aggregate?: (data: WithTypename<Water_Density_Options_Aggregate>) => null | string,
  water_density_options_aggregate_fields?: (data: WithTypename<Water_Density_Options_Aggregate_Fields>) => null | string,
  water_density_options_max_fields?: (data: WithTypename<Water_Density_Options_Max_Fields>) => null | string,
  water_density_options_min_fields?: (data: WithTypename<Water_Density_Options_Min_Fields>) => null | string,
  water_density_options_mutation_response?: (data: WithTypename<Water_Density_Options_Mutation_Response>) => null | string,
  water_solution_gas_options?: (data: WithTypename<Water_Solution_Gas_Options>) => null | string,
  water_solution_gas_options_aggregate?: (data: WithTypename<Water_Solution_Gas_Options_Aggregate>) => null | string,
  water_solution_gas_options_aggregate_fields?: (data: WithTypename<Water_Solution_Gas_Options_Aggregate_Fields>) => null | string,
  water_solution_gas_options_max_fields?: (data: WithTypename<Water_Solution_Gas_Options_Max_Fields>) => null | string,
  water_solution_gas_options_min_fields?: (data: WithTypename<Water_Solution_Gas_Options_Min_Fields>) => null | string,
  water_solution_gas_options_mutation_response?: (data: WithTypename<Water_Solution_Gas_Options_Mutation_Response>) => null | string,
  water_viscosity_options?: (data: WithTypename<Water_Viscosity_Options>) => null | string,
  water_viscosity_options_aggregate?: (data: WithTypename<Water_Viscosity_Options_Aggregate>) => null | string,
  water_viscosity_options_aggregate_fields?: (data: WithTypename<Water_Viscosity_Options_Aggregate_Fields>) => null | string,
  water_viscosity_options_max_fields?: (data: WithTypename<Water_Viscosity_Options_Max_Fields>) => null | string,
  water_viscosity_options_min_fields?: (data: WithTypename<Water_Viscosity_Options_Min_Fields>) => null | string,
  water_viscosity_options_mutation_response?: (data: WithTypename<Water_Viscosity_Options_Mutation_Response>) => null | string,
  water_volume_factor_options?: (data: WithTypename<Water_Volume_Factor_Options>) => null | string,
  water_volume_factor_options_aggregate?: (data: WithTypename<Water_Volume_Factor_Options_Aggregate>) => null | string,
  water_volume_factor_options_aggregate_fields?: (data: WithTypename<Water_Volume_Factor_Options_Aggregate_Fields>) => null | string,
  water_volume_factor_options_max_fields?: (data: WithTypename<Water_Volume_Factor_Options_Max_Fields>) => null | string,
  water_volume_factor_options_min_fields?: (data: WithTypename<Water_Volume_Factor_Options_Min_Fields>) => null | string,
  water_volume_factor_options_mutation_response?: (data: WithTypename<Water_Volume_Factor_Options_Mutation_Response>) => null | string,
  well_gas_type_options?: (data: WithTypename<Well_Gas_Type_Options>) => null | string,
  well_gas_type_options_aggregate?: (data: WithTypename<Well_Gas_Type_Options_Aggregate>) => null | string,
  well_gas_type_options_aggregate_fields?: (data: WithTypename<Well_Gas_Type_Options_Aggregate_Fields>) => null | string,
  well_gas_type_options_max_fields?: (data: WithTypename<Well_Gas_Type_Options_Max_Fields>) => null | string,
  well_gas_type_options_min_fields?: (data: WithTypename<Well_Gas_Type_Options_Min_Fields>) => null | string,
  well_gas_type_options_mutation_response?: (data: WithTypename<Well_Gas_Type_Options_Mutation_Response>) => null | string,
  well_test_gas_input_options?: (data: WithTypename<Well_Test_Gas_Input_Options>) => null | string,
  well_test_gas_input_options_aggregate?: (data: WithTypename<Well_Test_Gas_Input_Options_Aggregate>) => null | string,
  well_test_gas_input_options_aggregate_fields?: (data: WithTypename<Well_Test_Gas_Input_Options_Aggregate_Fields>) => null | string,
  well_test_gas_input_options_max_fields?: (data: WithTypename<Well_Test_Gas_Input_Options_Max_Fields>) => null | string,
  well_test_gas_input_options_min_fields?: (data: WithTypename<Well_Test_Gas_Input_Options_Min_Fields>) => null | string,
  well_test_gas_input_options_mutation_response?: (data: WithTypename<Well_Test_Gas_Input_Options_Mutation_Response>) => null | string,
  well_test_liquid_input_options?: (data: WithTypename<Well_Test_Liquid_Input_Options>) => null | string,
  well_test_liquid_input_options_aggregate?: (data: WithTypename<Well_Test_Liquid_Input_Options_Aggregate>) => null | string,
  well_test_liquid_input_options_aggregate_fields?: (data: WithTypename<Well_Test_Liquid_Input_Options_Aggregate_Fields>) => null | string,
  well_test_liquid_input_options_max_fields?: (data: WithTypename<Well_Test_Liquid_Input_Options_Max_Fields>) => null | string,
  well_test_liquid_input_options_min_fields?: (data: WithTypename<Well_Test_Liquid_Input_Options_Min_Fields>) => null | string,
  well_test_liquid_input_options_mutation_response?: (data: WithTypename<Well_Test_Liquid_Input_Options_Mutation_Response>) => null | string,
  well_test_pressure_input_options?: (data: WithTypename<Well_Test_Pressure_Input_Options>) => null | string,
  well_test_pressure_input_options_aggregate?: (data: WithTypename<Well_Test_Pressure_Input_Options_Aggregate>) => null | string,
  well_test_pressure_input_options_aggregate_fields?: (data: WithTypename<Well_Test_Pressure_Input_Options_Aggregate_Fields>) => null | string,
  well_test_pressure_input_options_max_fields?: (data: WithTypename<Well_Test_Pressure_Input_Options_Max_Fields>) => null | string,
  well_test_pressure_input_options_min_fields?: (data: WithTypename<Well_Test_Pressure_Input_Options_Min_Fields>) => null | string,
  well_test_pressure_input_options_mutation_response?: (data: WithTypename<Well_Test_Pressure_Input_Options_Mutation_Response>) => null | string,
  wells?: (data: WithTypename<Wells>) => null | string,
  wells_aggregate?: (data: WithTypename<Wells_Aggregate>) => null | string,
  wells_aggregate_fields?: (data: WithTypename<Wells_Aggregate_Fields>) => null | string,
  wells_avg_fields?: (data: WithTypename<Wells_Avg_Fields>) => null | string,
  wells_max_fields?: (data: WithTypename<Wells_Max_Fields>) => null | string,
  wells_min_fields?: (data: WithTypename<Wells_Min_Fields>) => null | string,
  wells_mutation_response?: (data: WithTypename<Wells_Mutation_Response>) => null | string,
  wells_stddev_fields?: (data: WithTypename<Wells_Stddev_Fields>) => null | string,
  wells_stddev_pop_fields?: (data: WithTypename<Wells_Stddev_Pop_Fields>) => null | string,
  wells_stddev_samp_fields?: (data: WithTypename<Wells_Stddev_Samp_Fields>) => null | string,
  wells_sum_fields?: (data: WithTypename<Wells_Sum_Fields>) => null | string,
  wells_var_pop_fields?: (data: WithTypename<Wells_Var_Pop_Fields>) => null | string,
  wells_var_samp_fields?: (data: WithTypename<Wells_Var_Samp_Fields>) => null | string,
  wells_variance_fields?: (data: WithTypename<Wells_Variance_Fields>) => null | string,
  y_tools?: (data: WithTypename<Y_Tools>) => null | string,
  y_tools_aggregate?: (data: WithTypename<Y_Tools_Aggregate>) => null | string,
  y_tools_aggregate_fields?: (data: WithTypename<Y_Tools_Aggregate_Fields>) => null | string,
  y_tools_avg_fields?: (data: WithTypename<Y_Tools_Avg_Fields>) => null | string,
  y_tools_max_fields?: (data: WithTypename<Y_Tools_Max_Fields>) => null | string,
  y_tools_min_fields?: (data: WithTypename<Y_Tools_Min_Fields>) => null | string,
  y_tools_mutation_response?: (data: WithTypename<Y_Tools_Mutation_Response>) => null | string,
  y_tools_stddev_fields?: (data: WithTypename<Y_Tools_Stddev_Fields>) => null | string,
  y_tools_stddev_pop_fields?: (data: WithTypename<Y_Tools_Stddev_Pop_Fields>) => null | string,
  y_tools_stddev_samp_fields?: (data: WithTypename<Y_Tools_Stddev_Samp_Fields>) => null | string,
  y_tools_sum_fields?: (data: WithTypename<Y_Tools_Sum_Fields>) => null | string,
  y_tools_var_pop_fields?: (data: WithTypename<Y_Tools_Var_Pop_Fields>) => null | string,
  y_tools_var_samp_fields?: (data: WithTypename<Y_Tools_Var_Samp_Fields>) => null | string,
  y_tools_variance_fields?: (data: WithTypename<Y_Tools_Variance_Fields>) => null | string
}

export type GraphCacheResolvers = {
  query_root?: {
    bolt_on_discharges?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootBolt_On_DischargesArgs, Array<WithTypename<Bolt_On_Discharges> | string>>,
    bolt_on_discharges_aggregate?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootBolt_On_Discharges_AggregateArgs, WithTypename<Bolt_On_Discharges_Aggregate> | string>,
    bolt_on_discharges_by_pk?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootBolt_On_Discharges_By_PkArgs, WithTypename<Bolt_On_Discharges> | string>,
    bubble_point_options?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootBubble_Point_OptionsArgs, Array<WithTypename<Bubble_Point_Options> | string>>,
    bubble_point_options_aggregate?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootBubble_Point_Options_AggregateArgs, WithTypename<Bubble_Point_Options_Aggregate> | string>,
    bubble_point_options_by_pk?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootBubble_Point_Options_By_PkArgs, WithTypename<Bubble_Point_Options> | string>,
    cables?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootCablesArgs, Array<WithTypename<Cables> | string>>,
    cables_aggregate?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootCables_AggregateArgs, WithTypename<Cables_Aggregate> | string>,
    cables_by_pk?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootCables_By_PkArgs, WithTypename<Cables> | string>,
    casing_flow_options?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootCasing_Flow_OptionsArgs, Array<WithTypename<Casing_Flow_Options> | string>>,
    casing_flow_options_aggregate?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootCasing_Flow_Options_AggregateArgs, WithTypename<Casing_Flow_Options_Aggregate> | string>,
    casing_flow_options_by_pk?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootCasing_Flow_Options_By_PkArgs, WithTypename<Casing_Flow_Options> | string>,
    casings?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootCasingsArgs, Array<WithTypename<Casings> | string>>,
    casings_aggregate?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootCasings_AggregateArgs, WithTypename<Casings_Aggregate> | string>,
    casings_by_pk?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootCasings_By_PkArgs, WithTypename<Casings> | string>,
    casings_type?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootCasings_TypeArgs, Array<WithTypename<Casings_Type> | string>>,
    casings_type_aggregate?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootCasings_Type_AggregateArgs, WithTypename<Casings_Type_Aggregate> | string>,
    casings_type_by_pk?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootCasings_Type_By_PkArgs, WithTypename<Casings_Type> | string>,
    customers?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootCustomersArgs, Array<WithTypename<Customers> | string>>,
    customers_aggregate?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootCustomers_AggregateArgs, WithTypename<Customers_Aggregate> | string>,
    customers_by_pk?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootCustomers_By_PkArgs, WithTypename<Customers> | string>,
    dead_oil_options?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootDead_Oil_OptionsArgs, Array<WithTypename<Dead_Oil_Options> | string>>,
    dead_oil_options_aggregate?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootDead_Oil_Options_AggregateArgs, WithTypename<Dead_Oil_Options_Aggregate> | string>,
    dead_oil_options_by_pk?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootDead_Oil_Options_By_PkArgs, WithTypename<Dead_Oil_Options> | string>,
    deviation_survey?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootDeviation_SurveyArgs, Array<WithTypename<Deviation_Survey> | string>>,
    deviation_survey_aggregate?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootDeviation_Survey_AggregateArgs, WithTypename<Deviation_Survey_Aggregate> | string>,
    deviation_survey_by_pk?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootDeviation_Survey_By_PkArgs, WithTypename<Deviation_Survey> | string>,
    deviation_survey_directional_dataset?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootDeviation_Survey_Directional_DatasetArgs, Array<WithTypename<Deviation_Survey_Directional_Dataset> | string>>,
    deviation_survey_directional_dataset_aggregate?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootDeviation_Survey_Directional_Dataset_AggregateArgs, WithTypename<Deviation_Survey_Directional_Dataset_Aggregate> | string>,
    deviation_survey_directional_dataset_by_pk?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootDeviation_Survey_Directional_Dataset_By_PkArgs, WithTypename<Deviation_Survey_Directional_Dataset> | string>,
    display_units?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootDisplay_UnitsArgs, Array<WithTypename<Display_Units> | string>>,
    display_units_aggregate?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootDisplay_Units_AggregateArgs, WithTypename<Display_Units_Aggregate> | string>,
    display_units_by_pk?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootDisplay_Units_By_PkArgs, WithTypename<Display_Units> | string>,
    eula?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootEulaArgs, Array<WithTypename<Eula> | string>>,
    eula_aggregate?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootEula_AggregateArgs, WithTypename<Eula_Aggregate> | string>,
    eula_by_pk?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootEula_By_PkArgs, WithTypename<Eula> | string>,
    flow_model?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootFlow_ModelArgs, Array<WithTypename<Flow_Model> | string>>,
    flow_model_active?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootFlow_Model_ActiveArgs, Array<WithTypename<Flow_Model_Active> | string>>,
    flow_model_active_aggregate?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootFlow_Model_Active_AggregateArgs, WithTypename<Flow_Model_Active_Aggregate> | string>,
    flow_model_aggregate?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootFlow_Model_AggregateArgs, WithTypename<Flow_Model_Aggregate> | string>,
    flow_model_by_pk?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootFlow_Model_By_PkArgs, WithTypename<Flow_Model> | string>,
    flow_model_deprecated?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootFlow_Model_DeprecatedArgs, Array<WithTypename<Flow_Model_Deprecated> | string>>,
    flow_model_deprecated_aggregate?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootFlow_Model_Deprecated_AggregateArgs, WithTypename<Flow_Model_Deprecated_Aggregate> | string>,
    flow_model_deprecated_by_pk?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootFlow_Model_Deprecated_By_PkArgs, WithTypename<Flow_Model_Deprecated> | string>,
    friction_loss_options?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootFriction_Loss_OptionsArgs, Array<WithTypename<Friction_Loss_Options> | string>>,
    friction_loss_options_aggregate?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootFriction_Loss_Options_AggregateArgs, WithTypename<Friction_Loss_Options_Aggregate> | string>,
    friction_loss_options_by_pk?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootFriction_Loss_Options_By_PkArgs, WithTypename<Friction_Loss_Options> | string>,
    gas_compressibility_options?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootGas_Compressibility_OptionsArgs, Array<WithTypename<Gas_Compressibility_Options> | string>>,
    gas_compressibility_options_aggregate?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootGas_Compressibility_Options_AggregateArgs, WithTypename<Gas_Compressibility_Options_Aggregate> | string>,
    gas_compressibility_options_by_pk?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootGas_Compressibility_Options_By_PkArgs, WithTypename<Gas_Compressibility_Options> | string>,
    gas_viscosity_options?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootGas_Viscosity_OptionsArgs, Array<WithTypename<Gas_Viscosity_Options> | string>>,
    gas_viscosity_options_aggregate?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootGas_Viscosity_Options_AggregateArgs, WithTypename<Gas_Viscosity_Options_Aggregate> | string>,
    gas_viscosity_options_by_pk?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootGas_Viscosity_Options_By_PkArgs, WithTypename<Gas_Viscosity_Options> | string>,
    getERPCustomers?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootGetErpCustomersArgs, Array<WithTypename<ErpCustomer> | string>>,
    getERPWellAddresses?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootGetErpWellAddressesArgs, Array<WithTypename<ErpWellAddress> | string>>,
    getErpWellReadings?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootGetErpWellReadingsArgs, Array<WithTypename<ErpWellReadings> | string>>,
    getSKBillables?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootGetSkBillablesArgs, Array<WithTypename<SkBillable> | string>>,
    getSKContracts?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootGetSkContractsArgs, Array<WithTypename<SkContract> | string>>,
    getSKCurrencies?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootGetSkCurrenciesArgs, Array<WithTypename<SkCurrency> | string>>,
    getSKCustomers?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootGetSkCustomersArgs, Array<WithTypename<SkCustomer> | string>>,
    getSKEquipmentTypeConversions?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootGetSkEquipmentTypeConversionsArgs, Array<WithTypename<SkEquipmentTypeConversion> | string>>,
    getSKJobs?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootGetSkJobsArgs, Array<WithTypename<SkJob> | string>>,
    getSKMaterials?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootGetSkMaterialsArgs, Array<WithTypename<SkMaterial> | string>>,
    getSKMaterialsPaginated?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootGetSkMaterialsPaginatedArgs, WithTypename<SkMaterialsPaginated> | string>,
    getSKNwas?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootGetSkNwasArgs, Array<WithTypename<SkNwa> | string>>,
    getSKPlanningOrder?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootGetSkPlanningOrderArgs, Array<WithTypename<SkPlanningOrder> | string>>,
    getSKPlants?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootGetSkPlantsArgs, Array<WithTypename<SkPlant> | string>>,
    getSKPriceLists?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootGetSkPriceListsArgs, Array<WithTypename<SkPriceList> | string>>,
    getSKWellAddresses?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootGetSkWellAddressesArgs, Array<WithTypename<SkWellAddress> | string>>,
    housings?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootHousingsArgs, Array<WithTypename<Housings> | string>>,
    housings_aggregate?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootHousings_AggregateArgs, WithTypename<Housings_Aggregate> | string>,
    housings_by_pk?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootHousings_By_PkArgs, WithTypename<Housings> | string>,
    hps_liquid_type?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootHps_Liquid_TypeArgs, Array<WithTypename<Hps_Liquid_Type> | string>>,
    hps_liquid_type_aggregate?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootHps_Liquid_Type_AggregateArgs, WithTypename<Hps_Liquid_Type_Aggregate> | string>,
    hps_liquid_type_by_pk?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootHps_Liquid_Type_By_PkArgs, WithTypename<Hps_Liquid_Type> | string>,
    intakes?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootIntakesArgs, Array<WithTypename<Intakes> | string>>,
    intakes_aggregate?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootIntakes_AggregateArgs, WithTypename<Intakes_Aggregate> | string>,
    intakes_by_pk?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootIntakes_By_PkArgs, WithTypename<Intakes> | string>,
    legacy_users?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootLegacy_UsersArgs, Array<WithTypename<Legacy_Users> | string>>,
    legacy_users_aggregate?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootLegacy_Users_AggregateArgs, WithTypename<Legacy_Users_Aggregate> | string>,
    legacy_users_by_pk?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootLegacy_Users_By_PkArgs, WithTypename<Legacy_Users> | string>,
    motor_lead_extensions?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootMotor_Lead_ExtensionsArgs, Array<WithTypename<Motor_Lead_Extensions> | string>>,
    motor_lead_extensions_aggregate?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootMotor_Lead_Extensions_AggregateArgs, WithTypename<Motor_Lead_Extensions_Aggregate> | string>,
    motor_lead_extensions_by_pk?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootMotor_Lead_Extensions_By_PkArgs, WithTypename<Motor_Lead_Extensions> | string>,
    motors?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootMotorsArgs, Array<WithTypename<Motors> | string>>,
    motors_aggregate?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootMotors_AggregateArgs, WithTypename<Motors_Aggregate> | string>,
    motors_by_pk?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootMotors_By_PkArgs, WithTypename<Motors> | string>,
    natural_gas_separation_options?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootNatural_Gas_Separation_OptionsArgs, Array<WithTypename<Natural_Gas_Separation_Options> | string>>,
    natural_gas_separation_options_aggregate?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootNatural_Gas_Separation_Options_AggregateArgs, WithTypename<Natural_Gas_Separation_Options_Aggregate> | string>,
    natural_gas_separation_options_by_pk?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootNatural_Gas_Separation_Options_By_PkArgs, WithTypename<Natural_Gas_Separation_Options> | string>,
    oil_density_options?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootOil_Density_OptionsArgs, Array<WithTypename<Oil_Density_Options> | string>>,
    oil_density_options_aggregate?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootOil_Density_Options_AggregateArgs, WithTypename<Oil_Density_Options_Aggregate> | string>,
    oil_density_options_by_pk?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootOil_Density_Options_By_PkArgs, WithTypename<Oil_Density_Options> | string>,
    oil_volume_factor_options?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootOil_Volume_Factor_OptionsArgs, Array<WithTypename<Oil_Volume_Factor_Options> | string>>,
    oil_volume_factor_options_aggregate?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootOil_Volume_Factor_Options_AggregateArgs, WithTypename<Oil_Volume_Factor_Options_Aggregate> | string>,
    oil_volume_factor_options_by_pk?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootOil_Volume_Factor_Options_By_PkArgs, WithTypename<Oil_Volume_Factor_Options> | string>,
    override_options?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootOverride_OptionsArgs, Array<WithTypename<Override_Options> | string>>,
    override_options_aggregate?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootOverride_Options_AggregateArgs, WithTypename<Override_Options_Aggregate> | string>,
    override_options_by_pk?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootOverride_Options_By_PkArgs, WithTypename<Override_Options> | string>,
    performance_evaluations?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootPerformance_EvaluationsArgs, Array<WithTypename<Performance_Evaluations> | string>>,
    performance_evaluations_aggregate?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootPerformance_Evaluations_AggregateArgs, WithTypename<Performance_Evaluations_Aggregate> | string>,
    performance_evaluations_xref_pumps?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootPerformance_Evaluations_Xref_PumpsArgs, Array<WithTypename<Performance_Evaluations_Xref_Pumps> | string>>,
    performance_evaluations_xref_pumps_aggregate?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootPerformance_Evaluations_Xref_Pumps_AggregateArgs, WithTypename<Performance_Evaluations_Xref_Pumps_Aggregate> | string>,
    pumps?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootPumpsArgs, Array<WithTypename<Pumps> | string>>,
    pumps_aggregate?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootPumps_AggregateArgs, WithTypename<Pumps_Aggregate> | string>,
    pumps_by_pk?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootPumps_By_PkArgs, WithTypename<Pumps> | string>,
    quote_line_item_category_dataset?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootQuote_Line_Item_Category_DatasetArgs, Array<WithTypename<Quote_Line_Item_Category_Dataset> | string>>,
    quote_line_item_category_dataset_aggregate?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootQuote_Line_Item_Category_Dataset_AggregateArgs, WithTypename<Quote_Line_Item_Category_Dataset_Aggregate> | string>,
    quote_line_item_category_dataset_by_pk?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootQuote_Line_Item_Category_Dataset_By_PkArgs, WithTypename<Quote_Line_Item_Category_Dataset> | string>,
    quote_line_item_serialized_dataset?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootQuote_Line_Item_Serialized_DatasetArgs, Array<WithTypename<Quote_Line_Item_Serialized_Dataset> | string>>,
    quote_line_item_serialized_dataset_aggregate?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootQuote_Line_Item_Serialized_Dataset_AggregateArgs, WithTypename<Quote_Line_Item_Serialized_Dataset_Aggregate> | string>,
    quote_line_item_serialized_dataset_by_pk?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootQuote_Line_Item_Serialized_Dataset_By_PkArgs, WithTypename<Quote_Line_Item_Serialized_Dataset> | string>,
    quote_line_item_source_dataset?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootQuote_Line_Item_Source_DatasetArgs, Array<WithTypename<Quote_Line_Item_Source_Dataset> | string>>,
    quote_line_item_source_dataset_aggregate?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootQuote_Line_Item_Source_Dataset_AggregateArgs, WithTypename<Quote_Line_Item_Source_Dataset_Aggregate> | string>,
    quote_line_item_source_dataset_by_pk?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootQuote_Line_Item_Source_Dataset_By_PkArgs, WithTypename<Quote_Line_Item_Source_Dataset> | string>,
    quote_line_item_subcategory_dataset?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootQuote_Line_Item_Subcategory_DatasetArgs, Array<WithTypename<Quote_Line_Item_Subcategory_Dataset> | string>>,
    quote_line_item_subcategory_dataset_aggregate?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootQuote_Line_Item_Subcategory_Dataset_AggregateArgs, WithTypename<Quote_Line_Item_Subcategory_Dataset_Aggregate> | string>,
    quote_line_item_subcategory_dataset_by_pk?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootQuote_Line_Item_Subcategory_Dataset_By_PkArgs, WithTypename<Quote_Line_Item_Subcategory_Dataset> | string>,
    quote_line_item_tax_type_dataset?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootQuote_Line_Item_Tax_Type_DatasetArgs, Array<WithTypename<Quote_Line_Item_Tax_Type_Dataset> | string>>,
    quote_line_item_tax_type_dataset_aggregate?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootQuote_Line_Item_Tax_Type_Dataset_AggregateArgs, WithTypename<Quote_Line_Item_Tax_Type_Dataset_Aggregate> | string>,
    quote_line_item_tax_type_dataset_by_pk?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootQuote_Line_Item_Tax_Type_Dataset_By_PkArgs, WithTypename<Quote_Line_Item_Tax_Type_Dataset> | string>,
    quote_line_item_type_dataset?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootQuote_Line_Item_Type_DatasetArgs, Array<WithTypename<Quote_Line_Item_Type_Dataset> | string>>,
    quote_line_item_type_dataset_aggregate?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootQuote_Line_Item_Type_Dataset_AggregateArgs, WithTypename<Quote_Line_Item_Type_Dataset_Aggregate> | string>,
    quote_line_item_type_dataset_by_pk?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootQuote_Line_Item_Type_Dataset_By_PkArgs, WithTypename<Quote_Line_Item_Type_Dataset> | string>,
    quote_line_items?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootQuote_Line_ItemsArgs, Array<WithTypename<Quote_Line_Items> | string>>,
    quote_line_items_aggregate?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootQuote_Line_Items_AggregateArgs, WithTypename<Quote_Line_Items_Aggregate> | string>,
    quote_line_items_by_pk?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootQuote_Line_Items_By_PkArgs, WithTypename<Quote_Line_Items> | string>,
    quote_sk_job_type_dataset?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootQuote_Sk_Job_Type_DatasetArgs, Array<WithTypename<Quote_Sk_Job_Type_Dataset> | string>>,
    quote_sk_job_type_dataset_aggregate?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootQuote_Sk_Job_Type_Dataset_AggregateArgs, WithTypename<Quote_Sk_Job_Type_Dataset_Aggregate> | string>,
    quote_sk_job_type_dataset_by_pk?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootQuote_Sk_Job_Type_Dataset_By_PkArgs, WithTypename<Quote_Sk_Job_Type_Dataset> | string>,
    quote_source_dataset?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootQuote_Source_DatasetArgs, Array<WithTypename<Quote_Source_Dataset> | string>>,
    quote_source_dataset_aggregate?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootQuote_Source_Dataset_AggregateArgs, WithTypename<Quote_Source_Dataset_Aggregate> | string>,
    quote_source_dataset_by_pk?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootQuote_Source_Dataset_By_PkArgs, WithTypename<Quote_Source_Dataset> | string>,
    quote_status_dataset?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootQuote_Status_DatasetArgs, Array<WithTypename<Quote_Status_Dataset> | string>>,
    quote_status_dataset_aggregate?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootQuote_Status_Dataset_AggregateArgs, WithTypename<Quote_Status_Dataset_Aggregate> | string>,
    quote_status_dataset_by_pk?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootQuote_Status_Dataset_By_PkArgs, WithTypename<Quote_Status_Dataset> | string>,
    quote_user_messages?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootQuote_User_MessagesArgs, Array<WithTypename<Quote_User_Messages> | string>>,
    quote_user_messages_aggregate?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootQuote_User_Messages_AggregateArgs, WithTypename<Quote_User_Messages_Aggregate> | string>,
    quote_user_messages_by_pk?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootQuote_User_Messages_By_PkArgs, WithTypename<Quote_User_Messages> | string>,
    quotes?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootQuotesArgs, Array<WithTypename<Quotes> | string>>,
    quotes_aggregate?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootQuotes_AggregateArgs, WithTypename<Quotes_Aggregate> | string>,
    quotes_by_pk?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootQuotes_By_PkArgs, WithTypename<Quotes> | string>,
    revisions_performance_evaluations_journal?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootRevisions_Performance_Evaluations_JournalArgs, Array<WithTypename<Revisions_Performance_Evaluations_Journal> | string>>,
    revisions_performance_evaluations_journal_aggregate?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootRevisions_Performance_Evaluations_Journal_AggregateArgs, WithTypename<Revisions_Performance_Evaluations_Journal_Aggregate> | string>,
    revisions_performance_evaluations_journal_by_pk?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootRevisions_Performance_Evaluations_Journal_By_PkArgs, WithTypename<Revisions_Performance_Evaluations_Journal> | string>,
    revisions_performance_evaluations_revisions?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootRevisions_Performance_Evaluations_RevisionsArgs, Array<WithTypename<Revisions_Performance_Evaluations_Revisions> | string>>,
    revisions_performance_evaluations_revisions_aggregate?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootRevisions_Performance_Evaluations_Revisions_AggregateArgs, WithTypename<Revisions_Performance_Evaluations_Revisions_Aggregate> | string>,
    revisions_performance_evaluations_revisions_by_pk?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootRevisions_Performance_Evaluations_Revisions_By_PkArgs, WithTypename<Revisions_Performance_Evaluations_Revisions> | string>,
    revisions_performance_evaluations_xref_pumps_journal?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootRevisions_Performance_Evaluations_Xref_Pumps_JournalArgs, Array<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Journal> | string>>,
    revisions_performance_evaluations_xref_pumps_journal_aggregate?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootRevisions_Performance_Evaluations_Xref_Pumps_Journal_AggregateArgs, WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Journal_Aggregate> | string>,
    revisions_performance_evaluations_xref_pumps_journal_by_pk?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootRevisions_Performance_Evaluations_Xref_Pumps_Journal_By_PkArgs, WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Journal> | string>,
    revisions_performance_evaluations_xref_pumps_revisions?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootRevisions_Performance_Evaluations_Xref_Pumps_RevisionsArgs, Array<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Revisions> | string>>,
    revisions_performance_evaluations_xref_pumps_revisions_aggregate?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootRevisions_Performance_Evaluations_Xref_Pumps_Revisions_AggregateArgs, WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Aggregate> | string>,
    revisions_performance_evaluations_xref_pumps_revisions_by_pk?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootRevisions_Performance_Evaluations_Xref_Pumps_Revisions_By_PkArgs, WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Revisions> | string>,
    revisions_sc_equip_xref_downhole_ytool_bypass_tubings_journal?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootRevisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_JournalArgs, Array<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal> | string>>,
    revisions_sc_equip_xref_downhole_ytool_bypass_tubings_journal_aggregate?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootRevisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_AggregateArgs, WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_Aggregate> | string>,
    revisions_sc_equip_xref_downhole_ytool_bypass_tubings_journal_by_pk?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootRevisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_By_PkArgs, WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal> | string>,
    revisions_sc_equip_xref_downhole_ytool_bypass_tubings_revisions?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootRevisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_RevisionsArgs, Array<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions> | string>>,
    revisions_sc_equip_xref_downhole_ytool_bypass_tubings_revisions_aggregate?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootRevisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_AggregateArgs, WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Aggregate> | string>,
    revisions_sc_equip_xref_downhole_ytool_bypass_tubings_revisions_by_pk?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootRevisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_By_PkArgs, WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions> | string>,
    revisions_sc_equip_xref_downhole_ytool_equip_tubings_journal?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootRevisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_JournalArgs, Array<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal> | string>>,
    revisions_sc_equip_xref_downhole_ytool_equip_tubings_journal_aggregate?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootRevisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_AggregateArgs, WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_Aggregate> | string>,
    revisions_sc_equip_xref_downhole_ytool_equip_tubings_journal_by_pk?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootRevisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_By_PkArgs, WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal> | string>,
    revisions_sc_equip_xref_downhole_ytool_equip_tubings_revisions?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootRevisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_RevisionsArgs, Array<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions> | string>>,
    revisions_sc_equip_xref_downhole_ytool_equip_tubings_revisions_aggregate?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootRevisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_AggregateArgs, WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Aggregate> | string>,
    revisions_sc_equip_xref_downhole_ytool_equip_tubings_revisions_by_pk?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootRevisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_By_PkArgs, WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions> | string>,
    revisions_sc_equip_xref_uphole_ytool_bypass_tubings_journal?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootRevisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_JournalArgs, Array<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal> | string>>,
    revisions_sc_equip_xref_uphole_ytool_bypass_tubings_journal_aggregate?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootRevisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_AggregateArgs, WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_Aggregate> | string>,
    revisions_sc_equip_xref_uphole_ytool_bypass_tubings_journal_by_pk?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootRevisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_By_PkArgs, WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal> | string>,
    revisions_sc_equip_xref_uphole_ytool_bypass_tubings_revisions?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootRevisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_RevisionsArgs, Array<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions> | string>>,
    revisions_sc_equip_xref_uphole_ytool_bypass_tubings_revisions_aggregate?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootRevisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_AggregateArgs, WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Aggregate> | string>,
    revisions_sc_equip_xref_uphole_ytool_bypass_tubings_revisions_by_pk?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootRevisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_By_PkArgs, WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions> | string>,
    revisions_sc_equip_xref_uphole_ytool_equip_tubings_journal?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootRevisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_JournalArgs, Array<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal> | string>>,
    revisions_sc_equip_xref_uphole_ytool_equip_tubings_journal_aggregate?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootRevisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_AggregateArgs, WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_Aggregate> | string>,
    revisions_sc_equip_xref_uphole_ytool_equip_tubings_journal_by_pk?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootRevisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_By_PkArgs, WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal> | string>,
    revisions_sc_equip_xref_uphole_ytool_equip_tubings_revisions?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootRevisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_RevisionsArgs, Array<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions> | string>>,
    revisions_sc_equip_xref_uphole_ytool_equip_tubings_revisions_aggregate?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootRevisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_AggregateArgs, WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Aggregate> | string>,
    revisions_sc_equip_xref_uphole_ytool_equip_tubings_revisions_by_pk?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootRevisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_By_PkArgs, WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions> | string>,
    revisions_scenario_correlations_journal?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootRevisions_Scenario_Correlations_JournalArgs, Array<WithTypename<Revisions_Scenario_Correlations_Journal> | string>>,
    revisions_scenario_correlations_journal_aggregate?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootRevisions_Scenario_Correlations_Journal_AggregateArgs, WithTypename<Revisions_Scenario_Correlations_Journal_Aggregate> | string>,
    revisions_scenario_correlations_journal_by_pk?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootRevisions_Scenario_Correlations_Journal_By_PkArgs, WithTypename<Revisions_Scenario_Correlations_Journal> | string>,
    revisions_scenario_correlations_revisions?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootRevisions_Scenario_Correlations_RevisionsArgs, Array<WithTypename<Revisions_Scenario_Correlations_Revisions> | string>>,
    revisions_scenario_correlations_revisions_aggregate?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootRevisions_Scenario_Correlations_Revisions_AggregateArgs, WithTypename<Revisions_Scenario_Correlations_Revisions_Aggregate> | string>,
    revisions_scenario_correlations_revisions_by_pk?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootRevisions_Scenario_Correlations_Revisions_By_PkArgs, WithTypename<Revisions_Scenario_Correlations_Revisions> | string>,
    revisions_scenario_equipment_journal?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootRevisions_Scenario_Equipment_JournalArgs, Array<WithTypename<Revisions_Scenario_Equipment_Journal> | string>>,
    revisions_scenario_equipment_journal_aggregate?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootRevisions_Scenario_Equipment_Journal_AggregateArgs, WithTypename<Revisions_Scenario_Equipment_Journal_Aggregate> | string>,
    revisions_scenario_equipment_journal_by_pk?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootRevisions_Scenario_Equipment_Journal_By_PkArgs, WithTypename<Revisions_Scenario_Equipment_Journal> | string>,
    revisions_scenario_equipment_revisions?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootRevisions_Scenario_Equipment_RevisionsArgs, Array<WithTypename<Revisions_Scenario_Equipment_Revisions> | string>>,
    revisions_scenario_equipment_revisions_aggregate?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootRevisions_Scenario_Equipment_Revisions_AggregateArgs, WithTypename<Revisions_Scenario_Equipment_Revisions_Aggregate> | string>,
    revisions_scenario_equipment_revisions_by_pk?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootRevisions_Scenario_Equipment_Revisions_By_PkArgs, WithTypename<Revisions_Scenario_Equipment_Revisions> | string>,
    revisions_scenario_equipment_xref_cables_journal?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootRevisions_Scenario_Equipment_Xref_Cables_JournalArgs, Array<WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Journal> | string>>,
    revisions_scenario_equipment_xref_cables_journal_aggregate?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootRevisions_Scenario_Equipment_Xref_Cables_Journal_AggregateArgs, WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Journal_Aggregate> | string>,
    revisions_scenario_equipment_xref_cables_journal_by_pk?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootRevisions_Scenario_Equipment_Xref_Cables_Journal_By_PkArgs, WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Journal> | string>,
    revisions_scenario_equipment_xref_cables_revisions?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootRevisions_Scenario_Equipment_Xref_Cables_RevisionsArgs, Array<WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Revisions> | string>>,
    revisions_scenario_equipment_xref_cables_revisions_aggregate?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootRevisions_Scenario_Equipment_Xref_Cables_Revisions_AggregateArgs, WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Aggregate> | string>,
    revisions_scenario_equipment_xref_cables_revisions_by_pk?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootRevisions_Scenario_Equipment_Xref_Cables_Revisions_By_PkArgs, WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Revisions> | string>,
    revisions_scenario_equipment_xref_housings_journal?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootRevisions_Scenario_Equipment_Xref_Housings_JournalArgs, Array<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Journal> | string>>,
    revisions_scenario_equipment_xref_housings_journal_aggregate?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootRevisions_Scenario_Equipment_Xref_Housings_Journal_AggregateArgs, WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Journal_Aggregate> | string>,
    revisions_scenario_equipment_xref_housings_journal_by_pk?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootRevisions_Scenario_Equipment_Xref_Housings_Journal_By_PkArgs, WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Journal> | string>,
    revisions_scenario_equipment_xref_housings_revisions?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootRevisions_Scenario_Equipment_Xref_Housings_RevisionsArgs, Array<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Revisions> | string>>,
    revisions_scenario_equipment_xref_housings_revisions_aggregate?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootRevisions_Scenario_Equipment_Xref_Housings_Revisions_AggregateArgs, WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Aggregate> | string>,
    revisions_scenario_equipment_xref_housings_revisions_by_pk?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootRevisions_Scenario_Equipment_Xref_Housings_Revisions_By_PkArgs, WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Revisions> | string>,
    revisions_scenario_equipment_xref_intakes_journal?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootRevisions_Scenario_Equipment_Xref_Intakes_JournalArgs, Array<WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Journal> | string>>,
    revisions_scenario_equipment_xref_intakes_journal_aggregate?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootRevisions_Scenario_Equipment_Xref_Intakes_Journal_AggregateArgs, WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Journal_Aggregate> | string>,
    revisions_scenario_equipment_xref_intakes_journal_by_pk?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootRevisions_Scenario_Equipment_Xref_Intakes_Journal_By_PkArgs, WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Journal> | string>,
    revisions_scenario_equipment_xref_intakes_revisions?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootRevisions_Scenario_Equipment_Xref_Intakes_RevisionsArgs, Array<WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Revisions> | string>>,
    revisions_scenario_equipment_xref_intakes_revisions_aggregate?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootRevisions_Scenario_Equipment_Xref_Intakes_Revisions_AggregateArgs, WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Aggregate> | string>,
    revisions_scenario_equipment_xref_intakes_revisions_by_pk?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootRevisions_Scenario_Equipment_Xref_Intakes_Revisions_By_PkArgs, WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Revisions> | string>,
    revisions_scenario_equipment_xref_pumps_journal?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootRevisions_Scenario_Equipment_Xref_Pumps_JournalArgs, Array<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Journal> | string>>,
    revisions_scenario_equipment_xref_pumps_journal_aggregate?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootRevisions_Scenario_Equipment_Xref_Pumps_Journal_AggregateArgs, WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Journal_Aggregate> | string>,
    revisions_scenario_equipment_xref_pumps_journal_by_pk?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootRevisions_Scenario_Equipment_Xref_Pumps_Journal_By_PkArgs, WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Journal> | string>,
    revisions_scenario_equipment_xref_pumps_revisions?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootRevisions_Scenario_Equipment_Xref_Pumps_RevisionsArgs, Array<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions> | string>>,
    revisions_scenario_equipment_xref_pumps_revisions_aggregate?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootRevisions_Scenario_Equipment_Xref_Pumps_Revisions_AggregateArgs, WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Aggregate> | string>,
    revisions_scenario_equipment_xref_pumps_revisions_by_pk?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootRevisions_Scenario_Equipment_Xref_Pumps_Revisions_By_PkArgs, WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions> | string>,
    revisions_scenario_equipment_xref_seals_journal?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootRevisions_Scenario_Equipment_Xref_Seals_JournalArgs, Array<WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Journal> | string>>,
    revisions_scenario_equipment_xref_seals_journal_aggregate?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootRevisions_Scenario_Equipment_Xref_Seals_Journal_AggregateArgs, WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Journal_Aggregate> | string>,
    revisions_scenario_equipment_xref_seals_journal_by_pk?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootRevisions_Scenario_Equipment_Xref_Seals_Journal_By_PkArgs, WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Journal> | string>,
    revisions_scenario_equipment_xref_seals_revisions?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootRevisions_Scenario_Equipment_Xref_Seals_RevisionsArgs, Array<WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Revisions> | string>>,
    revisions_scenario_equipment_xref_seals_revisions_aggregate?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootRevisions_Scenario_Equipment_Xref_Seals_Revisions_AggregateArgs, WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Revisions_Aggregate> | string>,
    revisions_scenario_equipment_xref_seals_revisions_by_pk?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootRevisions_Scenario_Equipment_Xref_Seals_Revisions_By_PkArgs, WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Revisions> | string>,
    revisions_scenario_parameters_journal?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootRevisions_Scenario_Parameters_JournalArgs, Array<WithTypename<Revisions_Scenario_Parameters_Journal> | string>>,
    revisions_scenario_parameters_journal_aggregate?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootRevisions_Scenario_Parameters_Journal_AggregateArgs, WithTypename<Revisions_Scenario_Parameters_Journal_Aggregate> | string>,
    revisions_scenario_parameters_journal_by_pk?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootRevisions_Scenario_Parameters_Journal_By_PkArgs, WithTypename<Revisions_Scenario_Parameters_Journal> | string>,
    revisions_scenario_parameters_revisions?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootRevisions_Scenario_Parameters_RevisionsArgs, Array<WithTypename<Revisions_Scenario_Parameters_Revisions> | string>>,
    revisions_scenario_parameters_revisions_aggregate?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootRevisions_Scenario_Parameters_Revisions_AggregateArgs, WithTypename<Revisions_Scenario_Parameters_Revisions_Aggregate> | string>,
    revisions_scenario_parameters_revisions_by_pk?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootRevisions_Scenario_Parameters_Revisions_By_PkArgs, WithTypename<Revisions_Scenario_Parameters_Revisions> | string>,
    revisions_scenario_well_properties_journal?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootRevisions_Scenario_Well_Properties_JournalArgs, Array<WithTypename<Revisions_Scenario_Well_Properties_Journal> | string>>,
    revisions_scenario_well_properties_journal_aggregate?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootRevisions_Scenario_Well_Properties_Journal_AggregateArgs, WithTypename<Revisions_Scenario_Well_Properties_Journal_Aggregate> | string>,
    revisions_scenario_well_properties_journal_by_pk?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootRevisions_Scenario_Well_Properties_Journal_By_PkArgs, WithTypename<Revisions_Scenario_Well_Properties_Journal> | string>,
    revisions_scenario_well_properties_revisions?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootRevisions_Scenario_Well_Properties_RevisionsArgs, Array<WithTypename<Revisions_Scenario_Well_Properties_Revisions> | string>>,
    revisions_scenario_well_properties_revisions_aggregate?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootRevisions_Scenario_Well_Properties_Revisions_AggregateArgs, WithTypename<Revisions_Scenario_Well_Properties_Revisions_Aggregate> | string>,
    revisions_scenario_well_properties_revisions_by_pk?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootRevisions_Scenario_Well_Properties_Revisions_By_PkArgs, WithTypename<Revisions_Scenario_Well_Properties_Revisions> | string>,
    revisions_scenarios_journal?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootRevisions_Scenarios_JournalArgs, Array<WithTypename<Revisions_Scenarios_Journal> | string>>,
    revisions_scenarios_journal_aggregate?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootRevisions_Scenarios_Journal_AggregateArgs, WithTypename<Revisions_Scenarios_Journal_Aggregate> | string>,
    revisions_scenarios_journal_by_pk?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootRevisions_Scenarios_Journal_By_PkArgs, WithTypename<Revisions_Scenarios_Journal> | string>,
    revisions_scenarios_revisions?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootRevisions_Scenarios_RevisionsArgs, Array<WithTypename<Revisions_Scenarios_Revisions> | string>>,
    revisions_scenarios_revisions_aggregate?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootRevisions_Scenarios_Revisions_AggregateArgs, WithTypename<Revisions_Scenarios_Revisions_Aggregate> | string>,
    revisions_scenarios_revisions_by_pk?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootRevisions_Scenarios_Revisions_By_PkArgs, WithTypename<Revisions_Scenarios_Revisions> | string>,
    revisions_sizings_journal?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootRevisions_Sizings_JournalArgs, Array<WithTypename<Revisions_Sizings_Journal> | string>>,
    revisions_sizings_journal_aggregate?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootRevisions_Sizings_Journal_AggregateArgs, WithTypename<Revisions_Sizings_Journal_Aggregate> | string>,
    revisions_sizings_journal_by_pk?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootRevisions_Sizings_Journal_By_PkArgs, WithTypename<Revisions_Sizings_Journal> | string>,
    revisions_sizings_revisions?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootRevisions_Sizings_RevisionsArgs, Array<WithTypename<Revisions_Sizings_Revisions> | string>>,
    revisions_sizings_revisions_aggregate?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootRevisions_Sizings_Revisions_AggregateArgs, WithTypename<Revisions_Sizings_Revisions_Aggregate> | string>,
    revisions_sizings_revisions_by_pk?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootRevisions_Sizings_Revisions_By_PkArgs, WithTypename<Revisions_Sizings_Revisions> | string>,
    saturated_oil_options?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootSaturated_Oil_OptionsArgs, Array<WithTypename<Saturated_Oil_Options> | string>>,
    saturated_oil_options_aggregate?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootSaturated_Oil_Options_AggregateArgs, WithTypename<Saturated_Oil_Options_Aggregate> | string>,
    saturated_oil_options_by_pk?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootSaturated_Oil_Options_By_PkArgs, WithTypename<Saturated_Oil_Options> | string>,
    sc_equip_xref_downhole_ytool_bypass_tubings?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootSc_Equip_Xref_Downhole_Ytool_Bypass_TubingsArgs, Array<WithTypename<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings> | string>>,
    sc_equip_xref_downhole_ytool_bypass_tubings_aggregate?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootSc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_AggregateArgs, WithTypename<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Aggregate> | string>,
    sc_equip_xref_downhole_ytool_equip_tubings?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootSc_Equip_Xref_Downhole_Ytool_Equip_TubingsArgs, Array<WithTypename<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings> | string>>,
    sc_equip_xref_downhole_ytool_equip_tubings_aggregate?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootSc_Equip_Xref_Downhole_Ytool_Equip_Tubings_AggregateArgs, WithTypename<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Aggregate> | string>,
    sc_equip_xref_uphole_ytool_bypass_tubings?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootSc_Equip_Xref_Uphole_Ytool_Bypass_TubingsArgs, Array<WithTypename<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings> | string>>,
    sc_equip_xref_uphole_ytool_bypass_tubings_aggregate?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootSc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_AggregateArgs, WithTypename<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Aggregate> | string>,
    sc_equip_xref_uphole_ytool_equip_tubings?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootSc_Equip_Xref_Uphole_Ytool_Equip_TubingsArgs, Array<WithTypename<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings> | string>>,
    sc_equip_xref_uphole_ytool_equip_tubings_aggregate?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootSc_Equip_Xref_Uphole_Ytool_Equip_Tubings_AggregateArgs, WithTypename<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Aggregate> | string>,
    scenario_correlations?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootScenario_CorrelationsArgs, Array<WithTypename<Scenario_Correlations> | string>>,
    scenario_correlations_aggregate?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootScenario_Correlations_AggregateArgs, WithTypename<Scenario_Correlations_Aggregate> | string>,
    scenario_equipment?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootScenario_EquipmentArgs, Array<WithTypename<Scenario_Equipment> | string>>,
    scenario_equipment_aggregate?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootScenario_Equipment_AggregateArgs, WithTypename<Scenario_Equipment_Aggregate> | string>,
    scenario_equipment_xref_cables?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootScenario_Equipment_Xref_CablesArgs, Array<WithTypename<Scenario_Equipment_Xref_Cables> | string>>,
    scenario_equipment_xref_cables_aggregate?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootScenario_Equipment_Xref_Cables_AggregateArgs, WithTypename<Scenario_Equipment_Xref_Cables_Aggregate> | string>,
    scenario_equipment_xref_housings?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootScenario_Equipment_Xref_HousingsArgs, Array<WithTypename<Scenario_Equipment_Xref_Housings> | string>>,
    scenario_equipment_xref_housings_aggregate?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootScenario_Equipment_Xref_Housings_AggregateArgs, WithTypename<Scenario_Equipment_Xref_Housings_Aggregate> | string>,
    scenario_equipment_xref_intakes?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootScenario_Equipment_Xref_IntakesArgs, Array<WithTypename<Scenario_Equipment_Xref_Intakes> | string>>,
    scenario_equipment_xref_intakes_aggregate?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootScenario_Equipment_Xref_Intakes_AggregateArgs, WithTypename<Scenario_Equipment_Xref_Intakes_Aggregate> | string>,
    scenario_equipment_xref_pumps?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootScenario_Equipment_Xref_PumpsArgs, Array<WithTypename<Scenario_Equipment_Xref_Pumps> | string>>,
    scenario_equipment_xref_pumps_aggregate?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootScenario_Equipment_Xref_Pumps_AggregateArgs, WithTypename<Scenario_Equipment_Xref_Pumps_Aggregate> | string>,
    scenario_equipment_xref_seals?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootScenario_Equipment_Xref_SealsArgs, Array<WithTypename<Scenario_Equipment_Xref_Seals> | string>>,
    scenario_equipment_xref_seals_aggregate?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootScenario_Equipment_Xref_Seals_AggregateArgs, WithTypename<Scenario_Equipment_Xref_Seals_Aggregate> | string>,
    scenario_parameters?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootScenario_ParametersArgs, Array<WithTypename<Scenario_Parameters> | string>>,
    scenario_parameters_aggregate?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootScenario_Parameters_AggregateArgs, WithTypename<Scenario_Parameters_Aggregate> | string>,
    scenario_reasons?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootScenario_ReasonsArgs, Array<WithTypename<Scenario_Reasons> | string>>,
    scenario_reasons_aggregate?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootScenario_Reasons_AggregateArgs, WithTypename<Scenario_Reasons_Aggregate> | string>,
    scenario_reasons_by_pk?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootScenario_Reasons_By_PkArgs, WithTypename<Scenario_Reasons> | string>,
    scenario_well_properties?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootScenario_Well_PropertiesArgs, Array<WithTypename<Scenario_Well_Properties> | string>>,
    scenario_well_properties_aggregate?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootScenario_Well_Properties_AggregateArgs, WithTypename<Scenario_Well_Properties_Aggregate> | string>,
    scenarios?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootScenariosArgs, Array<WithTypename<Scenarios> | string>>,
    scenarios_aggregate?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootScenarios_AggregateArgs, WithTypename<Scenarios_Aggregate> | string>,
    seal_motor_oil?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootSeal_Motor_OilArgs, Array<WithTypename<Seal_Motor_Oil> | string>>,
    seal_motor_oil_aggregate?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootSeal_Motor_Oil_AggregateArgs, WithTypename<Seal_Motor_Oil_Aggregate> | string>,
    seal_motor_oil_by_pk?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootSeal_Motor_Oil_By_PkArgs, WithTypename<Seal_Motor_Oil> | string>,
    seals?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootSealsArgs, Array<WithTypename<Seals> | string>>,
    seals_aggregate?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootSeals_AggregateArgs, WithTypename<Seals_Aggregate> | string>,
    seals_by_pk?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootSeals_By_PkArgs, WithTypename<Seals> | string>,
    sensors?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootSensorsArgs, Array<WithTypename<Sensors> | string>>,
    sensors_aggregate?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootSensors_AggregateArgs, WithTypename<Sensors_Aggregate> | string>,
    sensors_by_pk?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootSensors_By_PkArgs, WithTypename<Sensors> | string>,
    sizing_dispositions?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootSizing_DispositionsArgs, Array<WithTypename<Sizing_Dispositions> | string>>,
    sizing_dispositions_aggregate?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootSizing_Dispositions_AggregateArgs, WithTypename<Sizing_Dispositions_Aggregate> | string>,
    sizing_dispositions_by_pk?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootSizing_Dispositions_By_PkArgs, WithTypename<Sizing_Dispositions> | string>,
    sizing_imports?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootSizing_ImportsArgs, Array<WithTypename<Sizing_Imports> | string>>,
    sizing_imports_aggregate?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootSizing_Imports_AggregateArgs, WithTypename<Sizing_Imports_Aggregate> | string>,
    sizing_imports_by_pk?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootSizing_Imports_By_PkArgs, WithTypename<Sizing_Imports> | string>,
    sizing_pumping_type?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootSizing_Pumping_TypeArgs, Array<WithTypename<Sizing_Pumping_Type> | string>>,
    sizing_pumping_type_aggregate?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootSizing_Pumping_Type_AggregateArgs, WithTypename<Sizing_Pumping_Type_Aggregate> | string>,
    sizing_pumping_type_by_pk?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootSizing_Pumping_Type_By_PkArgs, WithTypename<Sizing_Pumping_Type> | string>,
    sizings?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootSizingsArgs, Array<WithTypename<Sizings> | string>>,
    sizings_aggregate?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootSizings_AggregateArgs, WithTypename<Sizings_Aggregate> | string>,
    solution_gas_oil_ratio_options?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootSolution_Gas_Oil_Ratio_OptionsArgs, Array<WithTypename<Solution_Gas_Oil_Ratio_Options> | string>>,
    solution_gas_oil_ratio_options_aggregate?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootSolution_Gas_Oil_Ratio_Options_AggregateArgs, WithTypename<Solution_Gas_Oil_Ratio_Options_Aggregate> | string>,
    solution_gas_oil_ratio_options_by_pk?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootSolution_Gas_Oil_Ratio_Options_By_PkArgs, WithTypename<Solution_Gas_Oil_Ratio_Options> | string>,
    status?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootStatusArgs, Array<WithTypename<Status> | string>>,
    status_aggregate?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootStatus_AggregateArgs, WithTypename<Status_Aggregate> | string>,
    step_down_transformers?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootStep_Down_TransformersArgs, Array<WithTypename<Step_Down_Transformers> | string>>,
    step_down_transformers_aggregate?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootStep_Down_Transformers_AggregateArgs, WithTypename<Step_Down_Transformers_Aggregate> | string>,
    step_down_transformers_by_pk?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootStep_Down_Transformers_By_PkArgs, WithTypename<Step_Down_Transformers> | string>,
    step_up_transformers?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootStep_Up_TransformersArgs, Array<WithTypename<Step_Up_Transformers> | string>>,
    step_up_transformers_aggregate?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootStep_Up_Transformers_AggregateArgs, WithTypename<Step_Up_Transformers_Aggregate> | string>,
    step_up_transformers_by_pk?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootStep_Up_Transformers_By_PkArgs, WithTypename<Step_Up_Transformers> | string>,
    switchboards?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootSwitchboardsArgs, Array<WithTypename<Switchboards> | string>>,
    switchboards_aggregate?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootSwitchboards_AggregateArgs, WithTypename<Switchboards_Aggregate> | string>,
    switchboards_by_pk?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootSwitchboards_By_PkArgs, WithTypename<Switchboards> | string>,
    tubing_flow_options?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootTubing_Flow_OptionsArgs, Array<WithTypename<Tubing_Flow_Options> | string>>,
    tubing_flow_options_aggregate?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootTubing_Flow_Options_AggregateArgs, WithTypename<Tubing_Flow_Options_Aggregate> | string>,
    tubing_flow_options_by_pk?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootTubing_Flow_Options_By_PkArgs, WithTypename<Tubing_Flow_Options> | string>,
    tubings?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootTubingsArgs, Array<WithTypename<Tubings> | string>>,
    tubings_aggregate?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootTubings_AggregateArgs, WithTypename<Tubings_Aggregate> | string>,
    tubings_by_pk?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootTubings_By_PkArgs, WithTypename<Tubings> | string>,
    tubings_type?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootTubings_TypeArgs, Array<WithTypename<Tubings_Type> | string>>,
    tubings_type_aggregate?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootTubings_Type_AggregateArgs, WithTypename<Tubings_Type_Aggregate> | string>,
    tubings_type_by_pk?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootTubings_Type_By_PkArgs, WithTypename<Tubings_Type> | string>,
    under_saturated_oil_options?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootUnder_Saturated_Oil_OptionsArgs, Array<WithTypename<Under_Saturated_Oil_Options> | string>>,
    under_saturated_oil_options_aggregate?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootUnder_Saturated_Oil_Options_AggregateArgs, WithTypename<Under_Saturated_Oil_Options_Aggregate> | string>,
    under_saturated_oil_options_by_pk?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootUnder_Saturated_Oil_Options_By_PkArgs, WithTypename<Under_Saturated_Oil_Options> | string>,
    user_eula_acceptance?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootUser_Eula_AcceptanceArgs, Array<WithTypename<User_Eula_Acceptance> | string>>,
    user_eula_acceptance_aggregate?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootUser_Eula_Acceptance_AggregateArgs, WithTypename<User_Eula_Acceptance_Aggregate> | string>,
    user_eula_acceptance_by_pk?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootUser_Eula_Acceptance_By_PkArgs, WithTypename<User_Eula_Acceptance> | string>,
    users?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootUsersArgs, Array<WithTypename<Users> | string>>,
    users_aggregate?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootUsers_AggregateArgs, WithTypename<Users_Aggregate> | string>,
    users_by_pk?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootUsers_By_PkArgs, WithTypename<Users> | string>,
    variable_speed_drives?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootVariable_Speed_DrivesArgs, Array<WithTypename<Variable_Speed_Drives> | string>>,
    variable_speed_drives_aggregate?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootVariable_Speed_Drives_AggregateArgs, WithTypename<Variable_Speed_Drives_Aggregate> | string>,
    variable_speed_drives_by_pk?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootVariable_Speed_Drives_By_PkArgs, WithTypename<Variable_Speed_Drives> | string>,
    water_density_options?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootWater_Density_OptionsArgs, Array<WithTypename<Water_Density_Options> | string>>,
    water_density_options_aggregate?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootWater_Density_Options_AggregateArgs, WithTypename<Water_Density_Options_Aggregate> | string>,
    water_density_options_by_pk?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootWater_Density_Options_By_PkArgs, WithTypename<Water_Density_Options> | string>,
    water_solution_gas_options?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootWater_Solution_Gas_OptionsArgs, Array<WithTypename<Water_Solution_Gas_Options> | string>>,
    water_solution_gas_options_aggregate?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootWater_Solution_Gas_Options_AggregateArgs, WithTypename<Water_Solution_Gas_Options_Aggregate> | string>,
    water_solution_gas_options_by_pk?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootWater_Solution_Gas_Options_By_PkArgs, WithTypename<Water_Solution_Gas_Options> | string>,
    water_viscosity_options?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootWater_Viscosity_OptionsArgs, Array<WithTypename<Water_Viscosity_Options> | string>>,
    water_viscosity_options_aggregate?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootWater_Viscosity_Options_AggregateArgs, WithTypename<Water_Viscosity_Options_Aggregate> | string>,
    water_viscosity_options_by_pk?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootWater_Viscosity_Options_By_PkArgs, WithTypename<Water_Viscosity_Options> | string>,
    water_volume_factor_options?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootWater_Volume_Factor_OptionsArgs, Array<WithTypename<Water_Volume_Factor_Options> | string>>,
    water_volume_factor_options_aggregate?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootWater_Volume_Factor_Options_AggregateArgs, WithTypename<Water_Volume_Factor_Options_Aggregate> | string>,
    water_volume_factor_options_by_pk?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootWater_Volume_Factor_Options_By_PkArgs, WithTypename<Water_Volume_Factor_Options> | string>,
    well_gas_type_options?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootWell_Gas_Type_OptionsArgs, Array<WithTypename<Well_Gas_Type_Options> | string>>,
    well_gas_type_options_aggregate?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootWell_Gas_Type_Options_AggregateArgs, WithTypename<Well_Gas_Type_Options_Aggregate> | string>,
    well_gas_type_options_by_pk?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootWell_Gas_Type_Options_By_PkArgs, WithTypename<Well_Gas_Type_Options> | string>,
    well_test_gas_input_options?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootWell_Test_Gas_Input_OptionsArgs, Array<WithTypename<Well_Test_Gas_Input_Options> | string>>,
    well_test_gas_input_options_aggregate?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootWell_Test_Gas_Input_Options_AggregateArgs, WithTypename<Well_Test_Gas_Input_Options_Aggregate> | string>,
    well_test_gas_input_options_by_pk?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootWell_Test_Gas_Input_Options_By_PkArgs, WithTypename<Well_Test_Gas_Input_Options> | string>,
    well_test_liquid_input_options?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootWell_Test_Liquid_Input_OptionsArgs, Array<WithTypename<Well_Test_Liquid_Input_Options> | string>>,
    well_test_liquid_input_options_aggregate?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootWell_Test_Liquid_Input_Options_AggregateArgs, WithTypename<Well_Test_Liquid_Input_Options_Aggregate> | string>,
    well_test_liquid_input_options_by_pk?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootWell_Test_Liquid_Input_Options_By_PkArgs, WithTypename<Well_Test_Liquid_Input_Options> | string>,
    well_test_pressure_input_options?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootWell_Test_Pressure_Input_OptionsArgs, Array<WithTypename<Well_Test_Pressure_Input_Options> | string>>,
    well_test_pressure_input_options_aggregate?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootWell_Test_Pressure_Input_Options_AggregateArgs, WithTypename<Well_Test_Pressure_Input_Options_Aggregate> | string>,
    well_test_pressure_input_options_by_pk?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootWell_Test_Pressure_Input_Options_By_PkArgs, WithTypename<Well_Test_Pressure_Input_Options> | string>,
    wells?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootWellsArgs, Array<WithTypename<Wells> | string>>,
    wells_aggregate?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootWells_AggregateArgs, WithTypename<Wells_Aggregate> | string>,
    wells_by_pk?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootWells_By_PkArgs, WithTypename<Wells> | string>,
    y_tools?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootY_ToolsArgs, Array<WithTypename<Y_Tools> | string>>,
    y_tools_aggregate?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootY_Tools_AggregateArgs, WithTypename<Y_Tools_Aggregate> | string>,
    y_tools_by_pk?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootY_Tools_By_PkArgs, WithTypename<Y_Tools> | string>
  },
  AccountManager?: {
    email?: GraphCacheResolver<WithTypename<AccountManager>, Record<string, never>, Scalars['String'] | string>,
    first_name?: GraphCacheResolver<WithTypename<AccountManager>, Record<string, never>, Scalars['String'] | string>,
    full_name?: GraphCacheResolver<WithTypename<AccountManager>, Record<string, never>, Scalars['String'] | string>,
    h_number?: GraphCacheResolver<WithTypename<AccountManager>, Record<string, never>, Scalars['String'] | string>,
    identifier?: GraphCacheResolver<WithTypename<AccountManager>, Record<string, never>, Scalars['String'] | string>,
    last_name?: GraphCacheResolver<WithTypename<AccountManager>, Record<string, never>, Scalars['String'] | string>
  },
  CanBeMerged?: {
    can_be_merged?: GraphCacheResolver<WithTypename<CanBeMerged>, Record<string, never>, Scalars['Boolean'] | string>,
    reasons?: GraphCacheResolver<WithTypename<CanBeMerged>, Record<string, never>, Array<Scalars['String'] | string>>
  },
  CreditCheckOverrideUser?: {
    email?: GraphCacheResolver<WithTypename<CreditCheckOverrideUser>, Record<string, never>, Scalars['String'] | string>,
    first_name?: GraphCacheResolver<WithTypename<CreditCheckOverrideUser>, Record<string, never>, Scalars['String'] | string>,
    full_name?: GraphCacheResolver<WithTypename<CreditCheckOverrideUser>, Record<string, never>, Scalars['String'] | string>,
    h_number?: GraphCacheResolver<WithTypename<CreditCheckOverrideUser>, Record<string, never>, Scalars['String'] | string>,
    identifier?: GraphCacheResolver<WithTypename<CreditCheckOverrideUser>, Record<string, never>, Scalars['String'] | string>,
    last_name?: GraphCacheResolver<WithTypename<CreditCheckOverrideUser>, Record<string, never>, Scalars['String'] | string>
  },
  ERPCustomer?: {
    customer_erp_id?: GraphCacheResolver<WithTypename<ErpCustomer>, Record<string, never>, Scalars['String'] | string>,
    customer_name?: GraphCacheResolver<WithTypename<ErpCustomer>, Record<string, never>, Scalars['String'] | string>
  },
  ERPWellAddress?: {
    address_erp_id?: GraphCacheResolver<WithTypename<ErpWellAddress>, Record<string, never>, Scalars['String'] | string>,
    customer_erp_id?: GraphCacheResolver<WithTypename<ErpWellAddress>, Record<string, never>, Scalars['String'] | string>,
    customer_name?: GraphCacheResolver<WithTypename<ErpWellAddress>, Record<string, never>, Scalars['String'] | string>,
    well_erp_id?: GraphCacheResolver<WithTypename<ErpWellAddress>, Record<string, never>, Scalars['String'] | string>,
    well_name?: GraphCacheResolver<WithTypename<ErpWellAddress>, Record<string, never>, Scalars['String'] | string>,
    well_uwi?: GraphCacheResolver<WithTypename<ErpWellAddress>, Record<string, never>, Scalars['String'] | string>
  },
  ErpWell?: {
    country_code?: GraphCacheResolver<WithTypename<ErpWell>, Record<string, never>, Scalars['String'] | string>,
    country_name?: GraphCacheResolver<WithTypename<ErpWell>, Record<string, never>, Scalars['String'] | string>,
    id?: GraphCacheResolver<WithTypename<ErpWell>, Record<string, never>, Scalars['Int'] | string>,
    latitude?: GraphCacheResolver<WithTypename<ErpWell>, Record<string, never>, Scalars['String'] | string>,
    longitude?: GraphCacheResolver<WithTypename<ErpWell>, Record<string, never>, Scalars['String'] | string>,
    payer_id?: GraphCacheResolver<WithTypename<ErpWell>, Record<string, never>, Scalars['String'] | string>,
    payer_name?: GraphCacheResolver<WithTypename<ErpWell>, Record<string, never>, Scalars['String'] | string>,
    region_code?: GraphCacheResolver<WithTypename<ErpWell>, Record<string, never>, Scalars['String'] | string>,
    region_name?: GraphCacheResolver<WithTypename<ErpWell>, Record<string, never>, Scalars['String'] | string>,
    sap_id?: GraphCacheResolver<WithTypename<ErpWell>, Record<string, never>, Scalars['String'] | string>,
    ship_to_address_id?: GraphCacheResolver<WithTypename<ErpWell>, Record<string, never>, Scalars['String'] | string>,
    ship_to_address_name?: GraphCacheResolver<WithTypename<ErpWell>, Record<string, never>, Scalars['String'] | string>,
    ship_to_full_address?: GraphCacheResolver<WithTypename<ErpWell>, Record<string, never>, Scalars['String'] | string>,
    sold_to_customer_id?: GraphCacheResolver<WithTypename<ErpWell>, Record<string, never>, Scalars['String'] | string>,
    sold_to_customer_msa_signed?: GraphCacheResolver<WithTypename<ErpWell>, Record<string, never>, Scalars['Boolean'] | string>,
    sold_to_customer_name?: GraphCacheResolver<WithTypename<ErpWell>, Record<string, never>, Scalars['String'] | string>,
    uwi?: GraphCacheResolver<WithTypename<ErpWell>, Record<string, never>, Scalars['String'] | string>,
    well_name?: GraphCacheResolver<WithTypename<ErpWell>, Record<string, never>, Scalars['String'] | string>,
    welladdress_id?: GraphCacheResolver<WithTypename<ErpWell>, Record<string, never>, Scalars['String'] | string>
  },
  ErpWellReadings?: {
    casing_pressure?: GraphCacheResolver<WithTypename<ErpWellReadings>, Record<string, never>, Scalars['Float'] | string>,
    fluid_temperature?: GraphCacheResolver<WithTypename<ErpWellReadings>, Record<string, never>, Scalars['Float'] | string>,
    id?: GraphCacheResolver<WithTypename<ErpWellReadings>, Record<string, never>, Scalars['String'] | string>,
    motor_current?: GraphCacheResolver<WithTypename<ErpWellReadings>, Record<string, never>, Scalars['Float'] | string>,
    motor_frequency?: GraphCacheResolver<WithTypename<ErpWellReadings>, Record<string, never>, Scalars['Float'] | string>,
    produced_gas_rate?: GraphCacheResolver<WithTypename<ErpWellReadings>, Record<string, never>, Scalars['Float'] | string>,
    produced_oil_rate?: GraphCacheResolver<WithTypename<ErpWellReadings>, Record<string, never>, Scalars['Float'] | string>,
    produced_rate?: GraphCacheResolver<WithTypename<ErpWellReadings>, Record<string, never>, Scalars['Float'] | string>,
    produced_water_rate?: GraphCacheResolver<WithTypename<ErpWellReadings>, Record<string, never>, Scalars['Float'] | string>,
    pump_intake_pressure?: GraphCacheResolver<WithTypename<ErpWellReadings>, Record<string, never>, Scalars['Float'] | string>,
    reading_date?: GraphCacheResolver<WithTypename<ErpWellReadings>, Record<string, never>, Scalars['date'] | string>,
    tubing_pressure?: GraphCacheResolver<WithTypename<ErpWellReadings>, Record<string, never>, Scalars['Float'] | string>
  },
  JobType?: {
    category?: GraphCacheResolver<WithTypename<JobType>, Record<string, never>, Scalars['String'] | string>,
    id?: GraphCacheResolver<WithTypename<JobType>, Record<string, never>, Scalars['Int'] | string>,
    material_number?: GraphCacheResolver<WithTypename<JobType>, Record<string, never>, Scalars['String'] | string>,
    name?: GraphCacheResolver<WithTypename<JobType>, Record<string, never>, Scalars['String'] | string>,
    plant?: GraphCacheResolver<WithTypename<JobType>, Record<string, never>, Array<Scalars['String'] | string>>
  },
  Ocms?: {
    date?: GraphCacheResolver<WithTypename<Ocms>, Record<string, never>, Scalars['String'] | string>,
    id?: GraphCacheResolver<WithTypename<Ocms>, Record<string, never>, Scalars['Int'] | string>,
    number?: GraphCacheResolver<WithTypename<Ocms>, Record<string, never>, Scalars['String'] | string>,
    plant_erp_id?: GraphCacheResolver<WithTypename<Ocms>, Record<string, never>, Scalars['String'] | string>,
    plant_name?: GraphCacheResolver<WithTypename<Ocms>, Record<string, never>, Scalars['String'] | string>,
    shipping_status?: GraphCacheResolver<WithTypename<Ocms>, Record<string, never>, Scalars['String'] | string>
  },
  PreparedBy?: {
    email?: GraphCacheResolver<WithTypename<PreparedBy>, Record<string, never>, Scalars['String'] | string>,
    first_name?: GraphCacheResolver<WithTypename<PreparedBy>, Record<string, never>, Scalars['String'] | string>,
    full_name?: GraphCacheResolver<WithTypename<PreparedBy>, Record<string, never>, Scalars['String'] | string>,
    h_number?: GraphCacheResolver<WithTypename<PreparedBy>, Record<string, never>, Scalars['String'] | string>,
    identifier?: GraphCacheResolver<WithTypename<PreparedBy>, Record<string, never>, Scalars['String'] | string>,
    last_name?: GraphCacheResolver<WithTypename<PreparedBy>, Record<string, never>, Scalars['String'] | string>
  },
  SKAddress?: {
    city?: GraphCacheResolver<WithTypename<SkAddress>, Record<string, never>, Scalars['String'] | string>,
    district?: GraphCacheResolver<WithTypename<SkAddress>, Record<string, never>, Scalars['String'] | string>,
    full_address?: GraphCacheResolver<WithTypename<SkAddress>, Record<string, never>, Scalars['String'] | string>,
    id?: GraphCacheResolver<WithTypename<SkAddress>, Record<string, never>, Scalars['String'] | string>,
    name?: GraphCacheResolver<WithTypename<SkAddress>, Record<string, never>, Scalars['String'] | string>,
    name1?: GraphCacheResolver<WithTypename<SkAddress>, Record<string, never>, Scalars['String'] | string>,
    name2?: GraphCacheResolver<WithTypename<SkAddress>, Record<string, never>, Scalars['String'] | string>,
    name3?: GraphCacheResolver<WithTypename<SkAddress>, Record<string, never>, Scalars['String'] | string>,
    name4?: GraphCacheResolver<WithTypename<SkAddress>, Record<string, never>, Scalars['String'] | string>,
    phone_number?: GraphCacheResolver<WithTypename<SkAddress>, Record<string, never>, Scalars['String'] | string>,
    postal_code?: GraphCacheResolver<WithTypename<SkAddress>, Record<string, never>, Scalars['String'] | string>,
    region?: GraphCacheResolver<WithTypename<SkAddress>, Record<string, never>, WithTypename<SkRegion> | string>,
    street?: GraphCacheResolver<WithTypename<SkAddress>, Record<string, never>, Scalars['String'] | string>
  },
  SKBillable?: {
    id?: GraphCacheResolver<WithTypename<SkBillable>, Record<string, never>, Scalars['Int'] | string>,
    margin?: GraphCacheResolver<WithTypename<SkBillable>, Record<string, never>, Scalars['Float'] | string>,
    material_description?: GraphCacheResolver<WithTypename<SkBillable>, Record<string, never>, Scalars['String'] | string>,
    material_long_description?: GraphCacheResolver<WithTypename<SkBillable>, Record<string, never>, Scalars['String'] | string>,
    material_number?: GraphCacheResolver<WithTypename<SkBillable>, Record<string, never>, Scalars['String'] | string>,
    material_type?: GraphCacheResolver<WithTypename<SkBillable>, Record<string, never>, Scalars['String'] | string>,
    notes_description?: GraphCacheResolver<WithTypename<SkBillable>, Record<string, never>, Scalars['String'] | string>,
    price?: GraphCacheResolver<WithTypename<SkBillable>, Record<string, never>, Scalars['String'] | string>,
    pricing_date?: GraphCacheResolver<WithTypename<SkBillable>, Record<string, never>, Scalars['String'] | string>,
    prod_hierarchy?: GraphCacheResolver<WithTypename<SkBillable>, Record<string, never>, Scalars['String'] | string>,
    quantity?: GraphCacheResolver<WithTypename<SkBillable>, Record<string, never>, Scalars['String'] | string>,
    quote_price?: GraphCacheResolver<WithTypename<SkBillable>, Record<string, never>, Scalars['Float'] | string>,
    serialized?: GraphCacheResolver<WithTypename<SkBillable>, Record<string, never>, Scalars['Boolean'] | string>,
    total?: GraphCacheResolver<WithTypename<SkBillable>, Record<string, never>, Scalars['String'] | string>,
    uom?: GraphCacheResolver<WithTypename<SkBillable>, Record<string, never>, Scalars['String'] | string>
  },
  SKCableInventory?: {
    available?: GraphCacheResolver<WithTypename<SkCableInventory>, Record<string, never>, Scalars['String'] | string>,
    available_count?: GraphCacheResolver<WithTypename<SkCableInventory>, Record<string, never>, Scalars['Float'] | string>,
    inventory_count?: GraphCacheResolver<WithTypename<SkCableInventory>, Record<string, never>, Scalars['Float'] | string>,
    reserved?: GraphCacheResolver<WithTypename<SkCableInventory>, Record<string, never>, Scalars['String'] | string>
  },
  SKContract?: {
    active?: GraphCacheResolver<WithTypename<SkContract>, Record<string, never>, Scalars['Boolean'] | string>,
    customer?: GraphCacheResolver<WithTypename<SkContract>, Record<string, never>, Scalars['String'] | string>,
    date_range?: GraphCacheResolver<WithTypename<SkContract>, Record<string, never>, WithTypename<SkMaterialDateRange> | string>,
    deleted?: GraphCacheResolver<WithTypename<SkContract>, Record<string, never>, Scalars['Boolean'] | string>,
    name?: GraphCacheResolver<WithTypename<SkContract>, Record<string, never>, Scalars['String'] | string>,
    number?: GraphCacheResolver<WithTypename<SkContract>, Record<string, never>, Scalars['String'] | string>,
    price_list?: GraphCacheResolver<WithTypename<SkContract>, Record<string, never>, WithTypename<SkPriceList> | string>,
    pricing_date?: GraphCacheResolver<WithTypename<SkContract>, Record<string, never>, Scalars['String'] | string>
  },
  SKCoordinates?: {
    coordinates?: GraphCacheResolver<WithTypename<SkCoordinates>, Record<string, never>, Array<Scalars['Float'] | string>>,
    type?: GraphCacheResolver<WithTypename<SkCoordinates>, Record<string, never>, Scalars['String'] | string>
  },
  SKCountry?: {
    active?: GraphCacheResolver<WithTypename<SkCountry>, Record<string, never>, Scalars['Boolean'] | string>,
    code?: GraphCacheResolver<WithTypename<SkCountry>, Record<string, never>, Scalars['String'] | string>,
    deleted?: GraphCacheResolver<WithTypename<SkCountry>, Record<string, never>, Scalars['Boolean'] | string>,
    name?: GraphCacheResolver<WithTypename<SkCountry>, Record<string, never>, Scalars['String'] | string>
  },
  SKCurrency?: {
    active?: GraphCacheResolver<WithTypename<SkCurrency>, Record<string, never>, Scalars['Boolean'] | string>,
    code?: GraphCacheResolver<WithTypename<SkCurrency>, Record<string, never>, Scalars['String'] | string>,
    deleted?: GraphCacheResolver<WithTypename<SkCurrency>, Record<string, never>, Scalars['Boolean'] | string>,
    description?: GraphCacheResolver<WithTypename<SkCurrency>, Record<string, never>, Scalars['String'] | string>
  },
  SKCustomer?: {
    id?: GraphCacheResolver<WithTypename<SkCustomer>, Record<string, never>, Scalars['Int'] | string>,
    name?: GraphCacheResolver<WithTypename<SkCustomer>, Record<string, never>, Scalars['String'] | string>
  },
  SKDeleteQuote?: {
    id?: GraphCacheResolver<WithTypename<SkDeleteQuote>, Record<string, never>, Scalars['Int'] | string>
  },
  SKEquipmentTypeConversion?: {
    cable_type?: GraphCacheResolver<WithTypename<SkEquipmentTypeConversion>, Record<string, never>, Scalars['String'] | string>,
    equipment_type?: GraphCacheResolver<WithTypename<SkEquipmentTypeConversion>, Record<string, never>, Scalars['String'] | string>,
    hierarchy_numbers?: GraphCacheResolver<WithTypename<SkEquipmentTypeConversion>, Record<string, never>, Array<Scalars['String'] | string>>,
    id?: GraphCacheResolver<WithTypename<SkEquipmentTypeConversion>, Record<string, never>, Scalars['Int'] | string>,
    label?: GraphCacheResolver<WithTypename<SkEquipmentTypeConversion>, Record<string, never>, Scalars['String'] | string>,
    sap_server?: GraphCacheResolver<WithTypename<SkEquipmentTypeConversion>, Record<string, never>, Scalars['String'] | string>
  },
  SKInventory?: {
    available?: GraphCacheResolver<WithTypename<SkInventory>, Record<string, never>, Scalars['String'] | string>,
    reserved?: GraphCacheResolver<WithTypename<SkInventory>, Record<string, never>, Scalars['String'] | string>
  },
  SKJob?: {
    account_manager?: GraphCacheResolver<WithTypename<SkJob>, Record<string, never>, WithTypename<AccountManager> | string>,
    attachment_count?: GraphCacheResolver<WithTypename<SkJob>, Record<string, never>, Scalars['Int'] | string>,
    cable_ocms?: GraphCacheResolver<WithTypename<SkJob>, Record<string, never>, Array<Scalars['String'] | string>>,
    can_be_combined?: GraphCacheResolver<WithTypename<SkJob>, Record<string, never>, Scalars['Boolean'] | string>,
    can_be_deleted?: GraphCacheResolver<WithTypename<SkJob>, Record<string, never>, Scalars['Boolean'] | string>,
    can_be_merged?: GraphCacheResolver<WithTypename<SkJob>, Record<string, never>, WithTypename<CanBeMerged> | string>,
    contract?: GraphCacheResolver<WithTypename<SkJob>, Record<string, never>, Scalars['String'] | string>,
    contract_lower_date?: GraphCacheResolver<WithTypename<SkJob>, Record<string, never>, Scalars['String'] | string>,
    contract_name?: GraphCacheResolver<WithTypename<SkJob>, Record<string, never>, Scalars['String'] | string>,
    contract_original?: GraphCacheResolver<WithTypename<SkJob>, Record<string, never>, Scalars['String'] | string>,
    contract_upper_date?: GraphCacheResolver<WithTypename<SkJob>, Record<string, never>, Scalars['String'] | string>,
    credit_check_fail?: GraphCacheResolver<WithTypename<SkJob>, Record<string, never>, Scalars['Boolean'] | string>,
    credit_check_override?: GraphCacheResolver<WithTypename<SkJob>, Record<string, never>, Scalars['Boolean'] | string>,
    credit_check_override_user?: GraphCacheResolver<WithTypename<SkJob>, Record<string, never>, WithTypename<CreditCheckOverrideUser> | string>,
    credit_payer_status?: GraphCacheResolver<WithTypename<SkJob>, Record<string, never>, Scalars['String'] | string>,
    credit_rep_cell?: GraphCacheResolver<WithTypename<SkJob>, Record<string, never>, Scalars['String'] | string>,
    credit_rep_name?: GraphCacheResolver<WithTypename<SkJob>, Record<string, never>, Scalars['String'] | string>,
    credit_rep_number?: GraphCacheResolver<WithTypename<SkJob>, Record<string, never>, Scalars['String'] | string>,
    credit_rep_office?: GraphCacheResolver<WithTypename<SkJob>, Record<string, never>, Scalars['String'] | string>,
    credit_transaction_id?: GraphCacheResolver<WithTypename<SkJob>, Record<string, never>, Scalars['Int'] | string>,
    currency?: GraphCacheResolver<WithTypename<SkJob>, Record<string, never>, Scalars['String'] | string>,
    date?: GraphCacheResolver<WithTypename<SkJob>, Record<string, never>, Scalars['String'] | string>,
    deleted?: GraphCacheResolver<WithTypename<SkJob>, Record<string, never>, Scalars['Boolean'] | string>,
    discrepancies?: GraphCacheResolver<WithTypename<SkJob>, Record<string, never>, Scalars['String'] | string>,
    dispatches?: GraphCacheResolver<WithTypename<SkJob>, Record<string, never>, Array<Scalars['String'] | string>>,
    end_date?: GraphCacheResolver<WithTypename<SkJob>, Record<string, never>, Scalars['String'] | string>,
    erp_data_source?: GraphCacheResolver<WithTypename<SkJob>, Record<string, never>, Scalars['String'] | string>,
    erp_transaction_active?: GraphCacheResolver<WithTypename<SkJob>, Record<string, never>, Scalars['Boolean'] | string>,
    erp_well?: GraphCacheResolver<WithTypename<SkJob>, Record<string, never>, WithTypename<ErpWell> | string>,
    has_been_submitted?: GraphCacheResolver<WithTypename<SkJob>, Record<string, never>, Scalars['Boolean'] | string>,
    has_duplicate_job_number?: GraphCacheResolver<WithTypename<SkJob>, Record<string, never>, Scalars['Boolean'] | string>,
    has_erp_transactions_with_errors_or_pending?: GraphCacheResolver<WithTypename<SkJob>, Record<string, never>, Scalars['Boolean'] | string>,
    id?: GraphCacheResolver<WithTypename<SkJob>, Record<string, never>, Scalars['Int'] | string>,
    inbound_job?: GraphCacheResolver<WithTypename<SkJob>, Record<string, never>, Scalars['String'] | string>,
    install_override_message?: GraphCacheResolver<WithTypename<SkJob>, Record<string, never>, Scalars['String'] | string>,
    install_override_user?: GraphCacheResolver<WithTypename<SkJob>, Record<string, never>, Scalars['String'] | string>,
    iocms?: GraphCacheResolver<WithTypename<SkJob>, Record<string, never>, Array<Scalars['String'] | string>>,
    job_type?: GraphCacheResolver<WithTypename<SkJob>, Record<string, never>, WithTypename<JobType> | string>,
    natural_work_area?: GraphCacheResolver<WithTypename<SkJob>, Record<string, never>, Scalars['String'] | string>,
    non_well_job?: GraphCacheResolver<WithTypename<SkJob>, Record<string, never>, Scalars['Boolean'] | string>,
    note_count?: GraphCacheResolver<WithTypename<SkJob>, Record<string, never>, Scalars['Int'] | string>,
    number?: GraphCacheResolver<WithTypename<SkJob>, Record<string, never>, Scalars['String'] | string>,
    nwa_id?: GraphCacheResolver<WithTypename<SkJob>, Record<string, never>, Scalars['String'] | string>,
    ocms?: GraphCacheResolver<WithTypename<SkJob>, Record<string, never>, Array<WithTypename<Ocms> | string>>,
    planning_order?: GraphCacheResolver<WithTypename<SkJob>, Record<string, never>, Scalars['String'] | string>,
    planning_order_error?: GraphCacheResolver<WithTypename<SkJob>, Record<string, never>, Scalars['String'] | string>,
    plant_erp_id?: GraphCacheResolver<WithTypename<SkJob>, Record<string, never>, Scalars['String'] | string>,
    plant_name?: GraphCacheResolver<WithTypename<SkJob>, Record<string, never>, Scalars['String'] | string>,
    plant_profit_center?: GraphCacheResolver<WithTypename<SkJob>, Record<string, never>, Scalars['String'] | string>,
    plo_transaction_id?: GraphCacheResolver<WithTypename<SkJob>, Record<string, never>, Scalars['Int'] | string>,
    prepared_by?: GraphCacheResolver<WithTypename<SkJob>, Record<string, never>, WithTypename<PreparedBy> | string>,
    price_list_name?: GraphCacheResolver<WithTypename<SkJob>, Record<string, never>, Scalars['String'] | string>,
    price_list_number?: GraphCacheResolver<WithTypename<SkJob>, Record<string, never>, Scalars['String'] | string>,
    price_list_original?: GraphCacheResolver<WithTypename<SkJob>, Record<string, never>, Scalars['String'] | string>,
    pricing_date?: GraphCacheResolver<WithTypename<SkJob>, Record<string, never>, Scalars['String'] | string>,
    proposal_number?: GraphCacheResolver<WithTypename<SkJob>, Record<string, never>, Scalars['String'] | string>,
    proposal_version?: GraphCacheResolver<WithTypename<SkJob>, Record<string, never>, Scalars['String'] | string>,
    proposed_job_start_date?: GraphCacheResolver<WithTypename<SkJob>, Record<string, never>, Scalars['String'] | string>,
    quote_number?: GraphCacheResolver<WithTypename<SkJob>, Record<string, never>, Scalars['String'] | string>,
    quote_total?: GraphCacheResolver<WithTypename<SkJob>, Record<string, never>, Scalars['String'] | string>,
    sales_district?: GraphCacheResolver<WithTypename<SkJob>, Record<string, never>, Scalars['String'] | string>,
    sales_office?: GraphCacheResolver<WithTypename<SkJob>, Record<string, never>, Scalars['String'] | string>,
    sales_organization_id?: GraphCacheResolver<WithTypename<SkJob>, Record<string, never>, Scalars['String'] | string>,
    ship_to?: GraphCacheResolver<WithTypename<SkJob>, Record<string, never>, Scalars['String'] | string>,
    similar_jobs?: GraphCacheResolver<WithTypename<SkJob>, Record<string, never>, Array<Scalars['String'] | string>>,
    sold_to?: GraphCacheResolver<WithTypename<SkJob>, Record<string, never>, Scalars['String'] | string>,
    source?: GraphCacheResolver<WithTypename<SkJob>, Record<string, never>, Scalars['Int'] | string>,
    status?: GraphCacheResolver<WithTypename<SkJob>, Record<string, never>, Scalars['String'] | string>,
    ticket_manager_error_message?: GraphCacheResolver<WithTypename<SkJob>, Record<string, never>, Scalars['String'] | string>,
    ticket_manager_transaction_id?: GraphCacheResolver<WithTypename<SkJob>, Record<string, never>, Scalars['Int'] | string>,
    well?: GraphCacheResolver<WithTypename<SkJob>, Record<string, never>, Scalars['String'] | string>
  },
  SKMaterial?: {
    active?: GraphCacheResolver<WithTypename<SkMaterial>, Record<string, never>, Scalars['Boolean'] | string>,
    api_response_count?: GraphCacheResolver<WithTypename<SkMaterial>, Record<string, never>, Scalars['Int'] | string>,
    base_uom?: GraphCacheResolver<WithTypename<SkMaterial>, Record<string, never>, Scalars['String'] | string>,
    cable_inventory?: GraphCacheResolver<WithTypename<SkMaterial>, Record<string, never>, WithTypename<SkCableInventory> | string>,
    deleted?: GraphCacheResolver<WithTypename<SkMaterial>, Record<string, never>, Scalars['Boolean'] | string>,
    description?: GraphCacheResolver<WithTypename<SkMaterial>, Record<string, never>, Scalars['String'] | string>,
    extended_to_plants?: GraphCacheResolver<WithTypename<SkMaterial>, Record<string, never>, Array<Scalars['String'] | string>>,
    inventory?: GraphCacheResolver<WithTypename<SkMaterial>, Record<string, never>, WithTypename<SkInventory> | string>,
    long_description?: GraphCacheResolver<WithTypename<SkMaterial>, Record<string, never>, Scalars['String'] | string>,
    material_type?: GraphCacheResolver<WithTypename<SkMaterial>, Record<string, never>, Scalars['String'] | string>,
    number?: GraphCacheResolver<WithTypename<SkMaterial>, Record<string, never>, Scalars['String'] | string>,
    pricing?: GraphCacheResolver<WithTypename<SkMaterial>, Record<string, never>, WithTypename<SkMaterialPricing> | string>,
    prod_hierarchy?: GraphCacheResolver<WithTypename<SkMaterial>, Record<string, never>, Scalars['String'] | string>,
    refurb_of?: GraphCacheResolver<WithTypename<SkMaterial>, Record<string, never>, Scalars['String'] | string>,
    serialized?: GraphCacheResolver<WithTypename<SkMaterial>, Record<string, never>, Scalars['Boolean'] | string>,
    so_uom?: GraphCacheResolver<WithTypename<SkMaterial>, Record<string, never>, Scalars['String'] | string>,
    spooled_type?: GraphCacheResolver<WithTypename<SkMaterial>, Record<string, never>, Scalars['String'] | string>,
    standard_offering?: GraphCacheResolver<WithTypename<SkMaterial>, Record<string, never>, Scalars['Boolean'] | string>
  },
  SKMaterialDateRange?: {
    bounds?: GraphCacheResolver<WithTypename<SkMaterialDateRange>, Record<string, never>, Scalars['String'] | string>,
    lower?: GraphCacheResolver<WithTypename<SkMaterialDateRange>, Record<string, never>, Scalars['String'] | string>,
    upper?: GraphCacheResolver<WithTypename<SkMaterialDateRange>, Record<string, never>, Scalars['String'] | string>
  },
  SKMaterialPricing?: {
    currency?: GraphCacheResolver<WithTypename<SkMaterialPricing>, Record<string, never>, Scalars['String'] | string>,
    date_range?: GraphCacheResolver<WithTypename<SkMaterialPricing>, Record<string, never>, WithTypename<SkMaterialDateRange> | string>,
    floor?: GraphCacheResolver<WithTypename<SkMaterialPricing>, Record<string, never>, Scalars['String'] | string>,
    number?: GraphCacheResolver<WithTypename<SkMaterialPricing>, Record<string, never>, Scalars['String'] | string>,
    price?: GraphCacheResolver<WithTypename<SkMaterialPricing>, Record<string, never>, Scalars['String'] | string>,
    pricing_date?: GraphCacheResolver<WithTypename<SkMaterialPricing>, Record<string, never>, Scalars['String'] | string>,
    type?: GraphCacheResolver<WithTypename<SkMaterialPricing>, Record<string, never>, Scalars['Int'] | string>,
    uom?: GraphCacheResolver<WithTypename<SkMaterialPricing>, Record<string, never>, Scalars['String'] | string>
  },
  SKMaterialsPaginated?: {
    count?: GraphCacheResolver<WithTypename<SkMaterialsPaginated>, Record<string, never>, Scalars['Int'] | string>,
    erp_data_source?: GraphCacheResolver<WithTypename<SkMaterialsPaginated>, Record<string, never>, Scalars['String'] | string>,
    next?: GraphCacheResolver<WithTypename<SkMaterialsPaginated>, Record<string, never>, Scalars['String'] | string>,
    previous?: GraphCacheResolver<WithTypename<SkMaterialsPaginated>, Record<string, never>, Scalars['String'] | string>,
    results?: GraphCacheResolver<WithTypename<SkMaterialsPaginated>, Record<string, never>, Array<WithTypename<SkMaterial> | string>>,
    route_as_of?: GraphCacheResolver<WithTypename<SkMaterialsPaginated>, Record<string, never>, Scalars['String'] | string>,
    route_plant?: GraphCacheResolver<WithTypename<SkMaterialsPaginated>, Record<string, never>, Scalars['String'] | string>,
    route_source?: GraphCacheResolver<WithTypename<SkMaterialsPaginated>, Record<string, never>, Scalars['String'] | string>
  },
  SKNwa?: {
    active?: GraphCacheResolver<WithTypename<SkNwa>, Record<string, never>, Scalars['Boolean'] | string>,
    al_name?: GraphCacheResolver<WithTypename<SkNwa>, Record<string, never>, Scalars['String'] | string>,
    country?: GraphCacheResolver<WithTypename<SkNwa>, Record<string, never>, Scalars['String'] | string>,
    deleted?: GraphCacheResolver<WithTypename<SkNwa>, Record<string, never>, Scalars['Boolean'] | string>,
    deprecated?: GraphCacheResolver<WithTypename<SkNwa>, Record<string, never>, Scalars['Boolean'] | string>,
    display_name?: GraphCacheResolver<WithTypename<SkNwa>, Record<string, never>, Scalars['String'] | string>,
    id?: GraphCacheResolver<WithTypename<SkNwa>, Record<string, never>, Scalars['String'] | string>,
    name?: GraphCacheResolver<WithTypename<SkNwa>, Record<string, never>, Scalars['String'] | string>
  },
  SKPlanningOrder?: {
    contract?: GraphCacheResolver<WithTypename<SkPlanningOrder>, Record<string, never>, Scalars['String'] | string>,
    currency?: GraphCacheResolver<WithTypename<SkPlanningOrder>, Record<string, never>, Scalars['String'] | string>,
    natural_work_area?: GraphCacheResolver<WithTypename<SkPlanningOrder>, Record<string, never>, Scalars['String'] | string>,
    nwa_id?: GraphCacheResolver<WithTypename<SkPlanningOrder>, Record<string, never>, Scalars['String'] | string>,
    planning_order?: GraphCacheResolver<WithTypename<SkPlanningOrder>, Record<string, never>, Scalars['String'] | string>,
    plant_erp_id?: GraphCacheResolver<WithTypename<SkPlanningOrder>, Record<string, never>, Scalars['String'] | string>,
    plant_name?: GraphCacheResolver<WithTypename<SkPlanningOrder>, Record<string, never>, Scalars['String'] | string>,
    price_list_name?: GraphCacheResolver<WithTypename<SkPlanningOrder>, Record<string, never>, Scalars['String'] | string>,
    price_list_number?: GraphCacheResolver<WithTypename<SkPlanningOrder>, Record<string, never>, Scalars['String'] | string>
  },
  SKPlant?: {
    active?: GraphCacheResolver<WithTypename<SkPlant>, Record<string, never>, Scalars['Boolean'] | string>,
    deleted?: GraphCacheResolver<WithTypename<SkPlant>, Record<string, never>, Scalars['Boolean'] | string>,
    id?: GraphCacheResolver<WithTypename<SkPlant>, Record<string, never>, Scalars['String'] | string>,
    name?: GraphCacheResolver<WithTypename<SkPlant>, Record<string, never>, Scalars['String'] | string>,
    s4_cutover_date?: GraphCacheResolver<WithTypename<SkPlant>, Record<string, never>, Scalars['String'] | string>
  },
  SKPriceList?: {
    active?: GraphCacheResolver<WithTypename<SkPriceList>, Record<string, never>, Scalars['Boolean'] | string>,
    deleted?: GraphCacheResolver<WithTypename<SkPriceList>, Record<string, never>, Scalars['Boolean'] | string>,
    name?: GraphCacheResolver<WithTypename<SkPriceList>, Record<string, never>, Scalars['String'] | string>,
    number?: GraphCacheResolver<WithTypename<SkPriceList>, Record<string, never>, Scalars['String'] | string>
  },
  SKQuote?: {
    created_at?: GraphCacheResolver<WithTypename<SkQuote>, Record<string, never>, Scalars['String'] | string>,
    currency?: GraphCacheResolver<WithTypename<SkQuote>, Record<string, never>, Scalars['String'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<SkQuote>, Record<string, never>, Scalars['String'] | string>,
    erp_address_id?: GraphCacheResolver<WithTypename<SkQuote>, Record<string, never>, Scalars['String'] | string>,
    erp_address_name?: GraphCacheResolver<WithTypename<SkQuote>, Record<string, never>, Scalars['String'] | string>,
    erp_contract_number?: GraphCacheResolver<WithTypename<SkQuote>, Record<string, never>, Scalars['String'] | string>,
    erp_customer_name?: GraphCacheResolver<WithTypename<SkQuote>, Record<string, never>, Scalars['String'] | string>,
    erp_customer_number?: GraphCacheResolver<WithTypename<SkQuote>, Record<string, never>, Scalars['String'] | string>,
    erp_full_address?: GraphCacheResolver<WithTypename<SkQuote>, Record<string, never>, Scalars['String'] | string>,
    erp_nwa_id?: GraphCacheResolver<WithTypename<SkQuote>, Record<string, never>, Scalars['String'] | string>,
    erp_nwa_name?: GraphCacheResolver<WithTypename<SkQuote>, Record<string, never>, Scalars['String'] | string>,
    erp_plant_id?: GraphCacheResolver<WithTypename<SkQuote>, Record<string, never>, Scalars['String'] | string>,
    erp_plant_name?: GraphCacheResolver<WithTypename<SkQuote>, Record<string, never>, Scalars['String'] | string>,
    erp_price_list_name?: GraphCacheResolver<WithTypename<SkQuote>, Record<string, never>, Scalars['String'] | string>,
    erp_price_list_number?: GraphCacheResolver<WithTypename<SkQuote>, Record<string, never>, Scalars['String'] | string>,
    erp_well_country?: GraphCacheResolver<WithTypename<SkQuote>, Record<string, never>, Scalars['String'] | string>,
    erp_well_id?: GraphCacheResolver<WithTypename<SkQuote>, Record<string, never>, Scalars['String'] | string>,
    erp_well_name?: GraphCacheResolver<WithTypename<SkQuote>, Record<string, never>, Scalars['String'] | string>,
    erp_well_region?: GraphCacheResolver<WithTypename<SkQuote>, Record<string, never>, Scalars['String'] | string>,
    erp_well_uwi?: GraphCacheResolver<WithTypename<SkQuote>, Record<string, never>, Scalars['String'] | string>,
    id?: GraphCacheResolver<WithTypename<SkQuote>, Record<string, never>, Scalars['Int'] | string>,
    job?: GraphCacheResolver<WithTypename<SkQuote>, Record<string, never>, Scalars['Int'] | string>,
    name?: GraphCacheResolver<WithTypename<SkQuote>, Record<string, never>, Scalars['String'] | string>,
    pricing_date?: GraphCacheResolver<WithTypename<SkQuote>, Record<string, never>, Scalars['String'] | string>,
    proposed_start_date?: GraphCacheResolver<WithTypename<SkQuote>, Record<string, never>, Scalars['String'] | string>,
    sk_planning_order?: GraphCacheResolver<WithTypename<SkQuote>, Record<string, never>, Scalars['String'] | string>,
    sk_proposal_number?: GraphCacheResolver<WithTypename<SkQuote>, Record<string, never>, Scalars['String'] | string>,
    spyglass_id?: GraphCacheResolver<WithTypename<SkQuote>, Record<string, never>, Scalars['String'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<SkQuote>, Record<string, never>, Scalars['String'] | string>,
    version_number?: GraphCacheResolver<WithTypename<SkQuote>, Record<string, never>, Scalars['Int'] | string>
  },
  SKRegion?: {
    active?: GraphCacheResolver<WithTypename<SkRegion>, Record<string, never>, Scalars['Boolean'] | string>,
    code?: GraphCacheResolver<WithTypename<SkRegion>, Record<string, never>, Scalars['String'] | string>,
    country?: GraphCacheResolver<WithTypename<SkRegion>, Record<string, never>, WithTypename<SkCountry> | string>,
    deleted?: GraphCacheResolver<WithTypename<SkRegion>, Record<string, never>, Scalars['Boolean'] | string>,
    id?: GraphCacheResolver<WithTypename<SkRegion>, Record<string, never>, Scalars['Int'] | string>,
    name?: GraphCacheResolver<WithTypename<SkRegion>, Record<string, never>, Scalars['String'] | string>
  },
  SKWell?: {
    active?: GraphCacheResolver<WithTypename<SkWell>, Record<string, never>, Scalars['Boolean'] | string>,
    coordinates?: GraphCacheResolver<WithTypename<SkWell>, Record<string, never>, WithTypename<SkCoordinates> | string>,
    deleted?: GraphCacheResolver<WithTypename<SkWell>, Record<string, never>, Scalars['Boolean'] | string>,
    id?: GraphCacheResolver<WithTypename<SkWell>, Record<string, never>, Scalars['String'] | string>,
    latitude?: GraphCacheResolver<WithTypename<SkWell>, Record<string, never>, Scalars['Float'] | string>,
    longitude?: GraphCacheResolver<WithTypename<SkWell>, Record<string, never>, Scalars['Float'] | string>,
    name?: GraphCacheResolver<WithTypename<SkWell>, Record<string, never>, Scalars['String'] | string>,
    name1?: GraphCacheResolver<WithTypename<SkWell>, Record<string, never>, Scalars['String'] | string>,
    name2?: GraphCacheResolver<WithTypename<SkWell>, Record<string, never>, Scalars['String'] | string>,
    name3?: GraphCacheResolver<WithTypename<SkWell>, Record<string, never>, Scalars['String'] | string>,
    name4?: GraphCacheResolver<WithTypename<SkWell>, Record<string, never>, Scalars['String'] | string>,
    region?: GraphCacheResolver<WithTypename<SkWell>, Record<string, never>, Scalars['Int'] | string>,
    uwi?: GraphCacheResolver<WithTypename<SkWell>, Record<string, never>, Scalars['String'] | string>,
    uwi_computed?: GraphCacheResolver<WithTypename<SkWell>, Record<string, never>, Scalars['String'] | string>,
    well_type?: GraphCacheResolver<WithTypename<SkWell>, Record<string, never>, Scalars['String'] | string>
  },
  SKWellAddress?: {
    address?: GraphCacheResolver<WithTypename<SkWellAddress>, Record<string, never>, WithTypename<SkAddress> | string>,
    customer?: GraphCacheResolver<WithTypename<SkWellAddress>, Record<string, never>, WithTypename<SkWellAddressCustomer> | string>,
    well?: GraphCacheResolver<WithTypename<SkWellAddress>, Record<string, never>, WithTypename<SkWell> | string>,
    well_address_id?: GraphCacheResolver<WithTypename<SkWellAddress>, Record<string, never>, Scalars['Int'] | string>
  },
  SKWellAddressCustomer?: {
    active?: GraphCacheResolver<WithTypename<SkWellAddressCustomer>, Record<string, never>, Scalars['Boolean'] | string>,
    deleted?: GraphCacheResolver<WithTypename<SkWellAddressCustomer>, Record<string, never>, Scalars['Boolean'] | string>,
    id?: GraphCacheResolver<WithTypename<SkWellAddressCustomer>, Record<string, never>, Scalars['String'] | string>,
    msa_signed?: GraphCacheResolver<WithTypename<SkWellAddressCustomer>, Record<string, never>, Scalars['Boolean'] | string>,
    name?: GraphCacheResolver<WithTypename<SkWellAddressCustomer>, Record<string, never>, Scalars['String'] | string>,
    name1?: GraphCacheResolver<WithTypename<SkWellAddressCustomer>, Record<string, never>, Scalars['String'] | string>,
    name2?: GraphCacheResolver<WithTypename<SkWellAddressCustomer>, Record<string, never>, Scalars['String'] | string>,
    name3?: GraphCacheResolver<WithTypename<SkWellAddressCustomer>, Record<string, never>, Scalars['String'] | string>,
    name4?: GraphCacheResolver<WithTypename<SkWellAddressCustomer>, Record<string, never>, Scalars['String'] | string>
  },
  bolt_on_discharges?: {
    author_id?: GraphCacheResolver<WithTypename<Bolt_On_Discharges>, Record<string, never>, Scalars['String'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Bolt_On_Discharges>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Bolt_On_Discharges>, Record<string, never>, Scalars['timestamptz'] | string>,
    flange_outer_diameter_inches?: GraphCacheResolver<WithTypename<Bolt_On_Discharges>, Record<string, never>, Scalars['numeric'] | string>,
    id?: GraphCacheResolver<WithTypename<Bolt_On_Discharges>, Record<string, never>, Scalars['uuid'] | string>,
    include_ecopetrol_timestamp?: GraphCacheResolver<WithTypename<Bolt_On_Discharges>, Record<string, never>, Scalars['timestamptz'] | string>,
    include_koc_timestamp?: GraphCacheResolver<WithTypename<Bolt_On_Discharges>, Record<string, never>, Scalars['timestamptz'] | string>,
    inner_diameter_inches?: GraphCacheResolver<WithTypename<Bolt_On_Discharges>, Record<string, never>, Scalars['numeric'] | string>,
    is_hps?: GraphCacheResolver<WithTypename<Bolt_On_Discharges>, Record<string, never>, Scalars['Boolean'] | string>,
    length_inches?: GraphCacheResolver<WithTypename<Bolt_On_Discharges>, Record<string, never>, Scalars['numeric'] | string>,
    manufacturer?: GraphCacheResolver<WithTypename<Bolt_On_Discharges>, Record<string, never>, Scalars['String'] | string>,
    neck_inner_diameter_inches?: GraphCacheResolver<WithTypename<Bolt_On_Discharges>, Record<string, never>, Scalars['numeric'] | string>,
    neck_outer_diameter_inches?: GraphCacheResolver<WithTypename<Bolt_On_Discharges>, Record<string, never>, Scalars['numeric'] | string>,
    only_ecopetrol_timestamp?: GraphCacheResolver<WithTypename<Bolt_On_Discharges>, Record<string, never>, Scalars['timestamptz'] | string>,
    only_koc_timestamp?: GraphCacheResolver<WithTypename<Bolt_On_Discharges>, Record<string, never>, Scalars['timestamptz'] | string>,
    outer_diameter_inches?: GraphCacheResolver<WithTypename<Bolt_On_Discharges>, Record<string, never>, Scalars['numeric'] | string>,
    series_model?: GraphCacheResolver<WithTypename<Bolt_On_Discharges>, Record<string, never>, Scalars['String'] | string>,
    tubing_diameter_inches?: GraphCacheResolver<WithTypename<Bolt_On_Discharges>, Record<string, never>, Scalars['numeric'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Bolt_On_Discharges>, Record<string, never>, Scalars['timestamptz'] | string>,
    weight_pounds?: GraphCacheResolver<WithTypename<Bolt_On_Discharges>, Record<string, never>, Scalars['numeric'] | string>
  },
  bolt_on_discharges_aggregate?: {
    aggregate?: GraphCacheResolver<WithTypename<Bolt_On_Discharges_Aggregate>, Record<string, never>, WithTypename<Bolt_On_Discharges_Aggregate_Fields> | string>,
    nodes?: GraphCacheResolver<WithTypename<Bolt_On_Discharges_Aggregate>, Record<string, never>, Array<WithTypename<Bolt_On_Discharges> | string>>
  },
  bolt_on_discharges_aggregate_fields?: {
    avg?: GraphCacheResolver<WithTypename<Bolt_On_Discharges_Aggregate_Fields>, Record<string, never>, WithTypename<Bolt_On_Discharges_Avg_Fields> | string>,
    count?: GraphCacheResolver<WithTypename<Bolt_On_Discharges_Aggregate_Fields>, Bolt_On_Discharges_Aggregate_FieldsCountArgs, Scalars['Int'] | string>,
    max?: GraphCacheResolver<WithTypename<Bolt_On_Discharges_Aggregate_Fields>, Record<string, never>, WithTypename<Bolt_On_Discharges_Max_Fields> | string>,
    min?: GraphCacheResolver<WithTypename<Bolt_On_Discharges_Aggregate_Fields>, Record<string, never>, WithTypename<Bolt_On_Discharges_Min_Fields> | string>,
    stddev?: GraphCacheResolver<WithTypename<Bolt_On_Discharges_Aggregate_Fields>, Record<string, never>, WithTypename<Bolt_On_Discharges_Stddev_Fields> | string>,
    stddev_pop?: GraphCacheResolver<WithTypename<Bolt_On_Discharges_Aggregate_Fields>, Record<string, never>, WithTypename<Bolt_On_Discharges_Stddev_Pop_Fields> | string>,
    stddev_samp?: GraphCacheResolver<WithTypename<Bolt_On_Discharges_Aggregate_Fields>, Record<string, never>, WithTypename<Bolt_On_Discharges_Stddev_Samp_Fields> | string>,
    sum?: GraphCacheResolver<WithTypename<Bolt_On_Discharges_Aggregate_Fields>, Record<string, never>, WithTypename<Bolt_On_Discharges_Sum_Fields> | string>,
    var_pop?: GraphCacheResolver<WithTypename<Bolt_On_Discharges_Aggregate_Fields>, Record<string, never>, WithTypename<Bolt_On_Discharges_Var_Pop_Fields> | string>,
    var_samp?: GraphCacheResolver<WithTypename<Bolt_On_Discharges_Aggregate_Fields>, Record<string, never>, WithTypename<Bolt_On_Discharges_Var_Samp_Fields> | string>,
    variance?: GraphCacheResolver<WithTypename<Bolt_On_Discharges_Aggregate_Fields>, Record<string, never>, WithTypename<Bolt_On_Discharges_Variance_Fields> | string>
  },
  bolt_on_discharges_avg_fields?: {
    flange_outer_diameter_inches?: GraphCacheResolver<WithTypename<Bolt_On_Discharges_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    inner_diameter_inches?: GraphCacheResolver<WithTypename<Bolt_On_Discharges_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    length_inches?: GraphCacheResolver<WithTypename<Bolt_On_Discharges_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    neck_inner_diameter_inches?: GraphCacheResolver<WithTypename<Bolt_On_Discharges_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    neck_outer_diameter_inches?: GraphCacheResolver<WithTypename<Bolt_On_Discharges_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    outer_diameter_inches?: GraphCacheResolver<WithTypename<Bolt_On_Discharges_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    tubing_diameter_inches?: GraphCacheResolver<WithTypename<Bolt_On_Discharges_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    weight_pounds?: GraphCacheResolver<WithTypename<Bolt_On_Discharges_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  bolt_on_discharges_max_fields?: {
    author_id?: GraphCacheResolver<WithTypename<Bolt_On_Discharges_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Bolt_On_Discharges_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Bolt_On_Discharges_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    flange_outer_diameter_inches?: GraphCacheResolver<WithTypename<Bolt_On_Discharges_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    id?: GraphCacheResolver<WithTypename<Bolt_On_Discharges_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    include_ecopetrol_timestamp?: GraphCacheResolver<WithTypename<Bolt_On_Discharges_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    include_koc_timestamp?: GraphCacheResolver<WithTypename<Bolt_On_Discharges_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    inner_diameter_inches?: GraphCacheResolver<WithTypename<Bolt_On_Discharges_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    length_inches?: GraphCacheResolver<WithTypename<Bolt_On_Discharges_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    manufacturer?: GraphCacheResolver<WithTypename<Bolt_On_Discharges_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    neck_inner_diameter_inches?: GraphCacheResolver<WithTypename<Bolt_On_Discharges_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    neck_outer_diameter_inches?: GraphCacheResolver<WithTypename<Bolt_On_Discharges_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    only_ecopetrol_timestamp?: GraphCacheResolver<WithTypename<Bolt_On_Discharges_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    only_koc_timestamp?: GraphCacheResolver<WithTypename<Bolt_On_Discharges_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    outer_diameter_inches?: GraphCacheResolver<WithTypename<Bolt_On_Discharges_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    series_model?: GraphCacheResolver<WithTypename<Bolt_On_Discharges_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    tubing_diameter_inches?: GraphCacheResolver<WithTypename<Bolt_On_Discharges_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Bolt_On_Discharges_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    weight_pounds?: GraphCacheResolver<WithTypename<Bolt_On_Discharges_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>
  },
  bolt_on_discharges_min_fields?: {
    author_id?: GraphCacheResolver<WithTypename<Bolt_On_Discharges_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Bolt_On_Discharges_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Bolt_On_Discharges_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    flange_outer_diameter_inches?: GraphCacheResolver<WithTypename<Bolt_On_Discharges_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    id?: GraphCacheResolver<WithTypename<Bolt_On_Discharges_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    include_ecopetrol_timestamp?: GraphCacheResolver<WithTypename<Bolt_On_Discharges_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    include_koc_timestamp?: GraphCacheResolver<WithTypename<Bolt_On_Discharges_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    inner_diameter_inches?: GraphCacheResolver<WithTypename<Bolt_On_Discharges_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    length_inches?: GraphCacheResolver<WithTypename<Bolt_On_Discharges_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    manufacturer?: GraphCacheResolver<WithTypename<Bolt_On_Discharges_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    neck_inner_diameter_inches?: GraphCacheResolver<WithTypename<Bolt_On_Discharges_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    neck_outer_diameter_inches?: GraphCacheResolver<WithTypename<Bolt_On_Discharges_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    only_ecopetrol_timestamp?: GraphCacheResolver<WithTypename<Bolt_On_Discharges_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    only_koc_timestamp?: GraphCacheResolver<WithTypename<Bolt_On_Discharges_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    outer_diameter_inches?: GraphCacheResolver<WithTypename<Bolt_On_Discharges_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    series_model?: GraphCacheResolver<WithTypename<Bolt_On_Discharges_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    tubing_diameter_inches?: GraphCacheResolver<WithTypename<Bolt_On_Discharges_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Bolt_On_Discharges_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    weight_pounds?: GraphCacheResolver<WithTypename<Bolt_On_Discharges_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>
  },
  bolt_on_discharges_mutation_response?: {
    affected_rows?: GraphCacheResolver<WithTypename<Bolt_On_Discharges_Mutation_Response>, Record<string, never>, Scalars['Int'] | string>,
    returning?: GraphCacheResolver<WithTypename<Bolt_On_Discharges_Mutation_Response>, Record<string, never>, Array<WithTypename<Bolt_On_Discharges> | string>>
  },
  bolt_on_discharges_stddev_fields?: {
    flange_outer_diameter_inches?: GraphCacheResolver<WithTypename<Bolt_On_Discharges_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    inner_diameter_inches?: GraphCacheResolver<WithTypename<Bolt_On_Discharges_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    length_inches?: GraphCacheResolver<WithTypename<Bolt_On_Discharges_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    neck_inner_diameter_inches?: GraphCacheResolver<WithTypename<Bolt_On_Discharges_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    neck_outer_diameter_inches?: GraphCacheResolver<WithTypename<Bolt_On_Discharges_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    outer_diameter_inches?: GraphCacheResolver<WithTypename<Bolt_On_Discharges_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    tubing_diameter_inches?: GraphCacheResolver<WithTypename<Bolt_On_Discharges_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    weight_pounds?: GraphCacheResolver<WithTypename<Bolt_On_Discharges_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  bolt_on_discharges_stddev_pop_fields?: {
    flange_outer_diameter_inches?: GraphCacheResolver<WithTypename<Bolt_On_Discharges_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    inner_diameter_inches?: GraphCacheResolver<WithTypename<Bolt_On_Discharges_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    length_inches?: GraphCacheResolver<WithTypename<Bolt_On_Discharges_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    neck_inner_diameter_inches?: GraphCacheResolver<WithTypename<Bolt_On_Discharges_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    neck_outer_diameter_inches?: GraphCacheResolver<WithTypename<Bolt_On_Discharges_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    outer_diameter_inches?: GraphCacheResolver<WithTypename<Bolt_On_Discharges_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    tubing_diameter_inches?: GraphCacheResolver<WithTypename<Bolt_On_Discharges_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    weight_pounds?: GraphCacheResolver<WithTypename<Bolt_On_Discharges_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  bolt_on_discharges_stddev_samp_fields?: {
    flange_outer_diameter_inches?: GraphCacheResolver<WithTypename<Bolt_On_Discharges_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    inner_diameter_inches?: GraphCacheResolver<WithTypename<Bolt_On_Discharges_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    length_inches?: GraphCacheResolver<WithTypename<Bolt_On_Discharges_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    neck_inner_diameter_inches?: GraphCacheResolver<WithTypename<Bolt_On_Discharges_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    neck_outer_diameter_inches?: GraphCacheResolver<WithTypename<Bolt_On_Discharges_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    outer_diameter_inches?: GraphCacheResolver<WithTypename<Bolt_On_Discharges_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    tubing_diameter_inches?: GraphCacheResolver<WithTypename<Bolt_On_Discharges_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    weight_pounds?: GraphCacheResolver<WithTypename<Bolt_On_Discharges_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  bolt_on_discharges_sum_fields?: {
    flange_outer_diameter_inches?: GraphCacheResolver<WithTypename<Bolt_On_Discharges_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    inner_diameter_inches?: GraphCacheResolver<WithTypename<Bolt_On_Discharges_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    length_inches?: GraphCacheResolver<WithTypename<Bolt_On_Discharges_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    neck_inner_diameter_inches?: GraphCacheResolver<WithTypename<Bolt_On_Discharges_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    neck_outer_diameter_inches?: GraphCacheResolver<WithTypename<Bolt_On_Discharges_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    outer_diameter_inches?: GraphCacheResolver<WithTypename<Bolt_On_Discharges_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    tubing_diameter_inches?: GraphCacheResolver<WithTypename<Bolt_On_Discharges_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    weight_pounds?: GraphCacheResolver<WithTypename<Bolt_On_Discharges_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>
  },
  bolt_on_discharges_var_pop_fields?: {
    flange_outer_diameter_inches?: GraphCacheResolver<WithTypename<Bolt_On_Discharges_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    inner_diameter_inches?: GraphCacheResolver<WithTypename<Bolt_On_Discharges_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    length_inches?: GraphCacheResolver<WithTypename<Bolt_On_Discharges_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    neck_inner_diameter_inches?: GraphCacheResolver<WithTypename<Bolt_On_Discharges_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    neck_outer_diameter_inches?: GraphCacheResolver<WithTypename<Bolt_On_Discharges_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    outer_diameter_inches?: GraphCacheResolver<WithTypename<Bolt_On_Discharges_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    tubing_diameter_inches?: GraphCacheResolver<WithTypename<Bolt_On_Discharges_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    weight_pounds?: GraphCacheResolver<WithTypename<Bolt_On_Discharges_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  bolt_on_discharges_var_samp_fields?: {
    flange_outer_diameter_inches?: GraphCacheResolver<WithTypename<Bolt_On_Discharges_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    inner_diameter_inches?: GraphCacheResolver<WithTypename<Bolt_On_Discharges_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    length_inches?: GraphCacheResolver<WithTypename<Bolt_On_Discharges_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    neck_inner_diameter_inches?: GraphCacheResolver<WithTypename<Bolt_On_Discharges_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    neck_outer_diameter_inches?: GraphCacheResolver<WithTypename<Bolt_On_Discharges_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    outer_diameter_inches?: GraphCacheResolver<WithTypename<Bolt_On_Discharges_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    tubing_diameter_inches?: GraphCacheResolver<WithTypename<Bolt_On_Discharges_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    weight_pounds?: GraphCacheResolver<WithTypename<Bolt_On_Discharges_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  bolt_on_discharges_variance_fields?: {
    flange_outer_diameter_inches?: GraphCacheResolver<WithTypename<Bolt_On_Discharges_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    inner_diameter_inches?: GraphCacheResolver<WithTypename<Bolt_On_Discharges_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    length_inches?: GraphCacheResolver<WithTypename<Bolt_On_Discharges_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    neck_inner_diameter_inches?: GraphCacheResolver<WithTypename<Bolt_On_Discharges_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    neck_outer_diameter_inches?: GraphCacheResolver<WithTypename<Bolt_On_Discharges_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    outer_diameter_inches?: GraphCacheResolver<WithTypename<Bolt_On_Discharges_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    tubing_diameter_inches?: GraphCacheResolver<WithTypename<Bolt_On_Discharges_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    weight_pounds?: GraphCacheResolver<WithTypename<Bolt_On_Discharges_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  bubble_point_options?: {
    comment?: GraphCacheResolver<WithTypename<Bubble_Point_Options>, Record<string, never>, Scalars['String'] | string>,
    value?: GraphCacheResolver<WithTypename<Bubble_Point_Options>, Record<string, never>, Scalars['String'] | string>
  },
  bubble_point_options_aggregate?: {
    aggregate?: GraphCacheResolver<WithTypename<Bubble_Point_Options_Aggregate>, Record<string, never>, WithTypename<Bubble_Point_Options_Aggregate_Fields> | string>,
    nodes?: GraphCacheResolver<WithTypename<Bubble_Point_Options_Aggregate>, Record<string, never>, Array<WithTypename<Bubble_Point_Options> | string>>
  },
  bubble_point_options_aggregate_fields?: {
    count?: GraphCacheResolver<WithTypename<Bubble_Point_Options_Aggregate_Fields>, Bubble_Point_Options_Aggregate_FieldsCountArgs, Scalars['Int'] | string>,
    max?: GraphCacheResolver<WithTypename<Bubble_Point_Options_Aggregate_Fields>, Record<string, never>, WithTypename<Bubble_Point_Options_Max_Fields> | string>,
    min?: GraphCacheResolver<WithTypename<Bubble_Point_Options_Aggregate_Fields>, Record<string, never>, WithTypename<Bubble_Point_Options_Min_Fields> | string>
  },
  bubble_point_options_max_fields?: {
    comment?: GraphCacheResolver<WithTypename<Bubble_Point_Options_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    value?: GraphCacheResolver<WithTypename<Bubble_Point_Options_Max_Fields>, Record<string, never>, Scalars['String'] | string>
  },
  bubble_point_options_min_fields?: {
    comment?: GraphCacheResolver<WithTypename<Bubble_Point_Options_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    value?: GraphCacheResolver<WithTypename<Bubble_Point_Options_Min_Fields>, Record<string, never>, Scalars['String'] | string>
  },
  bubble_point_options_mutation_response?: {
    affected_rows?: GraphCacheResolver<WithTypename<Bubble_Point_Options_Mutation_Response>, Record<string, never>, Scalars['Int'] | string>,
    returning?: GraphCacheResolver<WithTypename<Bubble_Point_Options_Mutation_Response>, Record<string, never>, Array<WithTypename<Bubble_Point_Options> | string>>
  },
  cables?: {
    amp_factor?: GraphCacheResolver<WithTypename<Cables>, Record<string, never>, Scalars['numeric'] | string>,
    armor?: GraphCacheResolver<WithTypename<Cables>, Record<string, never>, Scalars['String'] | string>,
    author_id?: GraphCacheResolver<WithTypename<Cables>, Record<string, never>, Scalars['String'] | string>,
    construction?: GraphCacheResolver<WithTypename<Cables>, Record<string, never>, Scalars['String'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Cables>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Cables>, Record<string, never>, Scalars['timestamptz'] | string>,
    depth_inches?: GraphCacheResolver<WithTypename<Cables>, Record<string, never>, Scalars['numeric'] | string>,
    family?: GraphCacheResolver<WithTypename<Cables>, Record<string, never>, Scalars['String'] | string>,
    gauge?: GraphCacheResolver<WithTypename<Cables>, Record<string, never>, Scalars['String'] | string>,
    id?: GraphCacheResolver<WithTypename<Cables>, Record<string, never>, Scalars['uuid'] | string>,
    impedance_60_hz_per_1000_ft?: GraphCacheResolver<WithTypename<Cables>, Record<string, never>, Scalars['numeric'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Cables>, Record<string, never>, Scalars['Int'] | string>,
    include_ecopetrol_timestamp?: GraphCacheResolver<WithTypename<Cables>, Record<string, never>, Scalars['timestamptz'] | string>,
    include_koc_timestamp?: GraphCacheResolver<WithTypename<Cables>, Record<string, never>, Scalars['timestamptz'] | string>,
    kv?: GraphCacheResolver<WithTypename<Cables>, Record<string, never>, Scalars['Int'] | string>,
    manufacturer?: GraphCacheResolver<WithTypename<Cables>, Record<string, never>, Scalars['String'] | string>,
    max_temperature_fahrenheit?: GraphCacheResolver<WithTypename<Cables>, Record<string, never>, Scalars['Int'] | string>,
    only_ecopetrol_timestamp?: GraphCacheResolver<WithTypename<Cables>, Record<string, never>, Scalars['timestamptz'] | string>,
    only_koc_timestamp?: GraphCacheResolver<WithTypename<Cables>, Record<string, never>, Scalars['timestamptz'] | string>,
    part_number?: GraphCacheResolver<WithTypename<Cables>, Record<string, never>, Scalars['String'] | string>,
    pound_per_foot?: GraphCacheResolver<WithTypename<Cables>, Record<string, never>, Scalars['numeric'] | string>,
    prioritized_manufacturer?: GraphCacheResolver<WithTypename<Cables>, Record<string, never>, Scalars['String'] | string>,
    resistance_per_1000_ft?: GraphCacheResolver<WithTypename<Cables>, Record<string, never>, Scalars['numeric'] | string>,
    sizing_import?: GraphCacheResolver<WithTypename<Cables>, Record<string, never>, WithTypename<Sizing_Imports> | string>,
    updated_at?: GraphCacheResolver<WithTypename<Cables>, Record<string, never>, Scalars['timestamptz'] | string>,
    user?: GraphCacheResolver<WithTypename<Cables>, Record<string, never>, WithTypename<Users> | string>,
    width_inches?: GraphCacheResolver<WithTypename<Cables>, Record<string, never>, Scalars['numeric'] | string>
  },
  cables_aggregate?: {
    aggregate?: GraphCacheResolver<WithTypename<Cables_Aggregate>, Record<string, never>, WithTypename<Cables_Aggregate_Fields> | string>,
    nodes?: GraphCacheResolver<WithTypename<Cables_Aggregate>, Record<string, never>, Array<WithTypename<Cables> | string>>
  },
  cables_aggregate_fields?: {
    avg?: GraphCacheResolver<WithTypename<Cables_Aggregate_Fields>, Record<string, never>, WithTypename<Cables_Avg_Fields> | string>,
    count?: GraphCacheResolver<WithTypename<Cables_Aggregate_Fields>, Cables_Aggregate_FieldsCountArgs, Scalars['Int'] | string>,
    max?: GraphCacheResolver<WithTypename<Cables_Aggregate_Fields>, Record<string, never>, WithTypename<Cables_Max_Fields> | string>,
    min?: GraphCacheResolver<WithTypename<Cables_Aggregate_Fields>, Record<string, never>, WithTypename<Cables_Min_Fields> | string>,
    stddev?: GraphCacheResolver<WithTypename<Cables_Aggregate_Fields>, Record<string, never>, WithTypename<Cables_Stddev_Fields> | string>,
    stddev_pop?: GraphCacheResolver<WithTypename<Cables_Aggregate_Fields>, Record<string, never>, WithTypename<Cables_Stddev_Pop_Fields> | string>,
    stddev_samp?: GraphCacheResolver<WithTypename<Cables_Aggregate_Fields>, Record<string, never>, WithTypename<Cables_Stddev_Samp_Fields> | string>,
    sum?: GraphCacheResolver<WithTypename<Cables_Aggregate_Fields>, Record<string, never>, WithTypename<Cables_Sum_Fields> | string>,
    var_pop?: GraphCacheResolver<WithTypename<Cables_Aggregate_Fields>, Record<string, never>, WithTypename<Cables_Var_Pop_Fields> | string>,
    var_samp?: GraphCacheResolver<WithTypename<Cables_Aggregate_Fields>, Record<string, never>, WithTypename<Cables_Var_Samp_Fields> | string>,
    variance?: GraphCacheResolver<WithTypename<Cables_Aggregate_Fields>, Record<string, never>, WithTypename<Cables_Variance_Fields> | string>
  },
  cables_avg_fields?: {
    amp_factor?: GraphCacheResolver<WithTypename<Cables_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    depth_inches?: GraphCacheResolver<WithTypename<Cables_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    impedance_60_hz_per_1000_ft?: GraphCacheResolver<WithTypename<Cables_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Cables_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    kv?: GraphCacheResolver<WithTypename<Cables_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    max_temperature_fahrenheit?: GraphCacheResolver<WithTypename<Cables_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pound_per_foot?: GraphCacheResolver<WithTypename<Cables_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    resistance_per_1000_ft?: GraphCacheResolver<WithTypename<Cables_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    width_inches?: GraphCacheResolver<WithTypename<Cables_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  cables_max_fields?: {
    amp_factor?: GraphCacheResolver<WithTypename<Cables_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    armor?: GraphCacheResolver<WithTypename<Cables_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    author_id?: GraphCacheResolver<WithTypename<Cables_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    construction?: GraphCacheResolver<WithTypename<Cables_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Cables_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Cables_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    depth_inches?: GraphCacheResolver<WithTypename<Cables_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    family?: GraphCacheResolver<WithTypename<Cables_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    gauge?: GraphCacheResolver<WithTypename<Cables_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    id?: GraphCacheResolver<WithTypename<Cables_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    impedance_60_hz_per_1000_ft?: GraphCacheResolver<WithTypename<Cables_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Cables_Max_Fields>, Record<string, never>, Scalars['Int'] | string>,
    include_ecopetrol_timestamp?: GraphCacheResolver<WithTypename<Cables_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    include_koc_timestamp?: GraphCacheResolver<WithTypename<Cables_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    kv?: GraphCacheResolver<WithTypename<Cables_Max_Fields>, Record<string, never>, Scalars['Int'] | string>,
    manufacturer?: GraphCacheResolver<WithTypename<Cables_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    max_temperature_fahrenheit?: GraphCacheResolver<WithTypename<Cables_Max_Fields>, Record<string, never>, Scalars['Int'] | string>,
    only_ecopetrol_timestamp?: GraphCacheResolver<WithTypename<Cables_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    only_koc_timestamp?: GraphCacheResolver<WithTypename<Cables_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    part_number?: GraphCacheResolver<WithTypename<Cables_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    pound_per_foot?: GraphCacheResolver<WithTypename<Cables_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    prioritized_manufacturer?: GraphCacheResolver<WithTypename<Cables_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    resistance_per_1000_ft?: GraphCacheResolver<WithTypename<Cables_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Cables_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    width_inches?: GraphCacheResolver<WithTypename<Cables_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>
  },
  cables_min_fields?: {
    amp_factor?: GraphCacheResolver<WithTypename<Cables_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    armor?: GraphCacheResolver<WithTypename<Cables_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    author_id?: GraphCacheResolver<WithTypename<Cables_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    construction?: GraphCacheResolver<WithTypename<Cables_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Cables_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Cables_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    depth_inches?: GraphCacheResolver<WithTypename<Cables_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    family?: GraphCacheResolver<WithTypename<Cables_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    gauge?: GraphCacheResolver<WithTypename<Cables_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    id?: GraphCacheResolver<WithTypename<Cables_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    impedance_60_hz_per_1000_ft?: GraphCacheResolver<WithTypename<Cables_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Cables_Min_Fields>, Record<string, never>, Scalars['Int'] | string>,
    include_ecopetrol_timestamp?: GraphCacheResolver<WithTypename<Cables_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    include_koc_timestamp?: GraphCacheResolver<WithTypename<Cables_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    kv?: GraphCacheResolver<WithTypename<Cables_Min_Fields>, Record<string, never>, Scalars['Int'] | string>,
    manufacturer?: GraphCacheResolver<WithTypename<Cables_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    max_temperature_fahrenheit?: GraphCacheResolver<WithTypename<Cables_Min_Fields>, Record<string, never>, Scalars['Int'] | string>,
    only_ecopetrol_timestamp?: GraphCacheResolver<WithTypename<Cables_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    only_koc_timestamp?: GraphCacheResolver<WithTypename<Cables_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    part_number?: GraphCacheResolver<WithTypename<Cables_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    pound_per_foot?: GraphCacheResolver<WithTypename<Cables_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    prioritized_manufacturer?: GraphCacheResolver<WithTypename<Cables_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    resistance_per_1000_ft?: GraphCacheResolver<WithTypename<Cables_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Cables_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    width_inches?: GraphCacheResolver<WithTypename<Cables_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>
  },
  cables_mutation_response?: {
    affected_rows?: GraphCacheResolver<WithTypename<Cables_Mutation_Response>, Record<string, never>, Scalars['Int'] | string>,
    returning?: GraphCacheResolver<WithTypename<Cables_Mutation_Response>, Record<string, never>, Array<WithTypename<Cables> | string>>
  },
  cables_stddev_fields?: {
    amp_factor?: GraphCacheResolver<WithTypename<Cables_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    depth_inches?: GraphCacheResolver<WithTypename<Cables_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    impedance_60_hz_per_1000_ft?: GraphCacheResolver<WithTypename<Cables_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Cables_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    kv?: GraphCacheResolver<WithTypename<Cables_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    max_temperature_fahrenheit?: GraphCacheResolver<WithTypename<Cables_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pound_per_foot?: GraphCacheResolver<WithTypename<Cables_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    resistance_per_1000_ft?: GraphCacheResolver<WithTypename<Cables_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    width_inches?: GraphCacheResolver<WithTypename<Cables_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  cables_stddev_pop_fields?: {
    amp_factor?: GraphCacheResolver<WithTypename<Cables_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    depth_inches?: GraphCacheResolver<WithTypename<Cables_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    impedance_60_hz_per_1000_ft?: GraphCacheResolver<WithTypename<Cables_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Cables_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    kv?: GraphCacheResolver<WithTypename<Cables_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    max_temperature_fahrenheit?: GraphCacheResolver<WithTypename<Cables_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pound_per_foot?: GraphCacheResolver<WithTypename<Cables_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    resistance_per_1000_ft?: GraphCacheResolver<WithTypename<Cables_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    width_inches?: GraphCacheResolver<WithTypename<Cables_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  cables_stddev_samp_fields?: {
    amp_factor?: GraphCacheResolver<WithTypename<Cables_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    depth_inches?: GraphCacheResolver<WithTypename<Cables_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    impedance_60_hz_per_1000_ft?: GraphCacheResolver<WithTypename<Cables_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Cables_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    kv?: GraphCacheResolver<WithTypename<Cables_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    max_temperature_fahrenheit?: GraphCacheResolver<WithTypename<Cables_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pound_per_foot?: GraphCacheResolver<WithTypename<Cables_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    resistance_per_1000_ft?: GraphCacheResolver<WithTypename<Cables_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    width_inches?: GraphCacheResolver<WithTypename<Cables_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  cables_sum_fields?: {
    amp_factor?: GraphCacheResolver<WithTypename<Cables_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    depth_inches?: GraphCacheResolver<WithTypename<Cables_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    impedance_60_hz_per_1000_ft?: GraphCacheResolver<WithTypename<Cables_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Cables_Sum_Fields>, Record<string, never>, Scalars['Int'] | string>,
    kv?: GraphCacheResolver<WithTypename<Cables_Sum_Fields>, Record<string, never>, Scalars['Int'] | string>,
    max_temperature_fahrenheit?: GraphCacheResolver<WithTypename<Cables_Sum_Fields>, Record<string, never>, Scalars['Int'] | string>,
    pound_per_foot?: GraphCacheResolver<WithTypename<Cables_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    resistance_per_1000_ft?: GraphCacheResolver<WithTypename<Cables_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    width_inches?: GraphCacheResolver<WithTypename<Cables_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>
  },
  cables_var_pop_fields?: {
    amp_factor?: GraphCacheResolver<WithTypename<Cables_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    depth_inches?: GraphCacheResolver<WithTypename<Cables_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    impedance_60_hz_per_1000_ft?: GraphCacheResolver<WithTypename<Cables_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Cables_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    kv?: GraphCacheResolver<WithTypename<Cables_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    max_temperature_fahrenheit?: GraphCacheResolver<WithTypename<Cables_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pound_per_foot?: GraphCacheResolver<WithTypename<Cables_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    resistance_per_1000_ft?: GraphCacheResolver<WithTypename<Cables_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    width_inches?: GraphCacheResolver<WithTypename<Cables_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  cables_var_samp_fields?: {
    amp_factor?: GraphCacheResolver<WithTypename<Cables_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    depth_inches?: GraphCacheResolver<WithTypename<Cables_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    impedance_60_hz_per_1000_ft?: GraphCacheResolver<WithTypename<Cables_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Cables_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    kv?: GraphCacheResolver<WithTypename<Cables_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    max_temperature_fahrenheit?: GraphCacheResolver<WithTypename<Cables_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pound_per_foot?: GraphCacheResolver<WithTypename<Cables_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    resistance_per_1000_ft?: GraphCacheResolver<WithTypename<Cables_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    width_inches?: GraphCacheResolver<WithTypename<Cables_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  cables_variance_fields?: {
    amp_factor?: GraphCacheResolver<WithTypename<Cables_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    depth_inches?: GraphCacheResolver<WithTypename<Cables_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    impedance_60_hz_per_1000_ft?: GraphCacheResolver<WithTypename<Cables_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Cables_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    kv?: GraphCacheResolver<WithTypename<Cables_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    max_temperature_fahrenheit?: GraphCacheResolver<WithTypename<Cables_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pound_per_foot?: GraphCacheResolver<WithTypename<Cables_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    resistance_per_1000_ft?: GraphCacheResolver<WithTypename<Cables_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    width_inches?: GraphCacheResolver<WithTypename<Cables_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  casing_flow_options?: {
    comment?: GraphCacheResolver<WithTypename<Casing_Flow_Options>, Record<string, never>, Scalars['String'] | string>,
    value?: GraphCacheResolver<WithTypename<Casing_Flow_Options>, Record<string, never>, Scalars['String'] | string>
  },
  casing_flow_options_aggregate?: {
    aggregate?: GraphCacheResolver<WithTypename<Casing_Flow_Options_Aggregate>, Record<string, never>, WithTypename<Casing_Flow_Options_Aggregate_Fields> | string>,
    nodes?: GraphCacheResolver<WithTypename<Casing_Flow_Options_Aggregate>, Record<string, never>, Array<WithTypename<Casing_Flow_Options> | string>>
  },
  casing_flow_options_aggregate_fields?: {
    count?: GraphCacheResolver<WithTypename<Casing_Flow_Options_Aggregate_Fields>, Casing_Flow_Options_Aggregate_FieldsCountArgs, Scalars['Int'] | string>,
    max?: GraphCacheResolver<WithTypename<Casing_Flow_Options_Aggregate_Fields>, Record<string, never>, WithTypename<Casing_Flow_Options_Max_Fields> | string>,
    min?: GraphCacheResolver<WithTypename<Casing_Flow_Options_Aggregate_Fields>, Record<string, never>, WithTypename<Casing_Flow_Options_Min_Fields> | string>
  },
  casing_flow_options_max_fields?: {
    comment?: GraphCacheResolver<WithTypename<Casing_Flow_Options_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    value?: GraphCacheResolver<WithTypename<Casing_Flow_Options_Max_Fields>, Record<string, never>, Scalars['String'] | string>
  },
  casing_flow_options_min_fields?: {
    comment?: GraphCacheResolver<WithTypename<Casing_Flow_Options_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    value?: GraphCacheResolver<WithTypename<Casing_Flow_Options_Min_Fields>, Record<string, never>, Scalars['String'] | string>
  },
  casing_flow_options_mutation_response?: {
    affected_rows?: GraphCacheResolver<WithTypename<Casing_Flow_Options_Mutation_Response>, Record<string, never>, Scalars['Int'] | string>,
    returning?: GraphCacheResolver<WithTypename<Casing_Flow_Options_Mutation_Response>, Record<string, never>, Array<WithTypename<Casing_Flow_Options> | string>>
  },
  casings?: {
    author_id?: GraphCacheResolver<WithTypename<Casings>, Record<string, never>, Scalars['String'] | string>,
    casing_type?: GraphCacheResolver<WithTypename<Casings>, Record<string, never>, Casings_Type_Enum | string>,
    coupling_outer_diameter_inches?: GraphCacheResolver<WithTypename<Casings>, Record<string, never>, Scalars['numeric'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Casings>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Casings>, Record<string, never>, Scalars['timestamptz'] | string>,
    drift_inches?: GraphCacheResolver<WithTypename<Casings>, Record<string, never>, Scalars['numeric'] | string>,
    id?: GraphCacheResolver<WithTypename<Casings>, Record<string, never>, Scalars['uuid'] | string>,
    imperial_name?: GraphCacheResolver<WithTypename<Casings>, Record<string, never>, Scalars['String'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Casings>, Record<string, never>, Scalars['Int'] | string>,
    include_ecopetrol_timestamp?: GraphCacheResolver<WithTypename<Casings>, Record<string, never>, Scalars['timestamptz'] | string>,
    include_koc_timestamp?: GraphCacheResolver<WithTypename<Casings>, Record<string, never>, Scalars['timestamptz'] | string>,
    interior_diameter_inches?: GraphCacheResolver<WithTypename<Casings>, Record<string, never>, Scalars['numeric'] | string>,
    metric_name?: GraphCacheResolver<WithTypename<Casings>, Record<string, never>, Scalars['String'] | string>,
    only_ecopetrol_timestamp?: GraphCacheResolver<WithTypename<Casings>, Record<string, never>, Scalars['timestamptz'] | string>,
    only_koc_timestamp?: GraphCacheResolver<WithTypename<Casings>, Record<string, never>, Scalars['timestamptz'] | string>,
    outer_diameter_inches?: GraphCacheResolver<WithTypename<Casings>, Record<string, never>, Scalars['numeric'] | string>,
    pound_per_foot?: GraphCacheResolver<WithTypename<Casings>, Record<string, never>, Scalars['numeric'] | string>,
    sizing_import?: GraphCacheResolver<WithTypename<Casings>, Record<string, never>, WithTypename<Sizing_Imports> | string>,
    updated_at?: GraphCacheResolver<WithTypename<Casings>, Record<string, never>, Scalars['timestamptz'] | string>,
    user?: GraphCacheResolver<WithTypename<Casings>, Record<string, never>, WithTypename<Users> | string>
  },
  casings_aggregate?: {
    aggregate?: GraphCacheResolver<WithTypename<Casings_Aggregate>, Record<string, never>, WithTypename<Casings_Aggregate_Fields> | string>,
    nodes?: GraphCacheResolver<WithTypename<Casings_Aggregate>, Record<string, never>, Array<WithTypename<Casings> | string>>
  },
  casings_aggregate_fields?: {
    avg?: GraphCacheResolver<WithTypename<Casings_Aggregate_Fields>, Record<string, never>, WithTypename<Casings_Avg_Fields> | string>,
    count?: GraphCacheResolver<WithTypename<Casings_Aggregate_Fields>, Casings_Aggregate_FieldsCountArgs, Scalars['Int'] | string>,
    max?: GraphCacheResolver<WithTypename<Casings_Aggregate_Fields>, Record<string, never>, WithTypename<Casings_Max_Fields> | string>,
    min?: GraphCacheResolver<WithTypename<Casings_Aggregate_Fields>, Record<string, never>, WithTypename<Casings_Min_Fields> | string>,
    stddev?: GraphCacheResolver<WithTypename<Casings_Aggregate_Fields>, Record<string, never>, WithTypename<Casings_Stddev_Fields> | string>,
    stddev_pop?: GraphCacheResolver<WithTypename<Casings_Aggregate_Fields>, Record<string, never>, WithTypename<Casings_Stddev_Pop_Fields> | string>,
    stddev_samp?: GraphCacheResolver<WithTypename<Casings_Aggregate_Fields>, Record<string, never>, WithTypename<Casings_Stddev_Samp_Fields> | string>,
    sum?: GraphCacheResolver<WithTypename<Casings_Aggregate_Fields>, Record<string, never>, WithTypename<Casings_Sum_Fields> | string>,
    var_pop?: GraphCacheResolver<WithTypename<Casings_Aggregate_Fields>, Record<string, never>, WithTypename<Casings_Var_Pop_Fields> | string>,
    var_samp?: GraphCacheResolver<WithTypename<Casings_Aggregate_Fields>, Record<string, never>, WithTypename<Casings_Var_Samp_Fields> | string>,
    variance?: GraphCacheResolver<WithTypename<Casings_Aggregate_Fields>, Record<string, never>, WithTypename<Casings_Variance_Fields> | string>
  },
  casings_avg_fields?: {
    coupling_outer_diameter_inches?: GraphCacheResolver<WithTypename<Casings_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    drift_inches?: GraphCacheResolver<WithTypename<Casings_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Casings_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    interior_diameter_inches?: GraphCacheResolver<WithTypename<Casings_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    outer_diameter_inches?: GraphCacheResolver<WithTypename<Casings_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pound_per_foot?: GraphCacheResolver<WithTypename<Casings_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  casings_max_fields?: {
    author_id?: GraphCacheResolver<WithTypename<Casings_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    coupling_outer_diameter_inches?: GraphCacheResolver<WithTypename<Casings_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Casings_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Casings_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    drift_inches?: GraphCacheResolver<WithTypename<Casings_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    id?: GraphCacheResolver<WithTypename<Casings_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    imperial_name?: GraphCacheResolver<WithTypename<Casings_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Casings_Max_Fields>, Record<string, never>, Scalars['Int'] | string>,
    include_ecopetrol_timestamp?: GraphCacheResolver<WithTypename<Casings_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    include_koc_timestamp?: GraphCacheResolver<WithTypename<Casings_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    interior_diameter_inches?: GraphCacheResolver<WithTypename<Casings_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    metric_name?: GraphCacheResolver<WithTypename<Casings_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    only_ecopetrol_timestamp?: GraphCacheResolver<WithTypename<Casings_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    only_koc_timestamp?: GraphCacheResolver<WithTypename<Casings_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    outer_diameter_inches?: GraphCacheResolver<WithTypename<Casings_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    pound_per_foot?: GraphCacheResolver<WithTypename<Casings_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Casings_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>
  },
  casings_min_fields?: {
    author_id?: GraphCacheResolver<WithTypename<Casings_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    coupling_outer_diameter_inches?: GraphCacheResolver<WithTypename<Casings_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Casings_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Casings_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    drift_inches?: GraphCacheResolver<WithTypename<Casings_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    id?: GraphCacheResolver<WithTypename<Casings_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    imperial_name?: GraphCacheResolver<WithTypename<Casings_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Casings_Min_Fields>, Record<string, never>, Scalars['Int'] | string>,
    include_ecopetrol_timestamp?: GraphCacheResolver<WithTypename<Casings_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    include_koc_timestamp?: GraphCacheResolver<WithTypename<Casings_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    interior_diameter_inches?: GraphCacheResolver<WithTypename<Casings_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    metric_name?: GraphCacheResolver<WithTypename<Casings_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    only_ecopetrol_timestamp?: GraphCacheResolver<WithTypename<Casings_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    only_koc_timestamp?: GraphCacheResolver<WithTypename<Casings_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    outer_diameter_inches?: GraphCacheResolver<WithTypename<Casings_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    pound_per_foot?: GraphCacheResolver<WithTypename<Casings_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Casings_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>
  },
  casings_mutation_response?: {
    affected_rows?: GraphCacheResolver<WithTypename<Casings_Mutation_Response>, Record<string, never>, Scalars['Int'] | string>,
    returning?: GraphCacheResolver<WithTypename<Casings_Mutation_Response>, Record<string, never>, Array<WithTypename<Casings> | string>>
  },
  casings_stddev_fields?: {
    coupling_outer_diameter_inches?: GraphCacheResolver<WithTypename<Casings_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    drift_inches?: GraphCacheResolver<WithTypename<Casings_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Casings_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    interior_diameter_inches?: GraphCacheResolver<WithTypename<Casings_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    outer_diameter_inches?: GraphCacheResolver<WithTypename<Casings_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pound_per_foot?: GraphCacheResolver<WithTypename<Casings_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  casings_stddev_pop_fields?: {
    coupling_outer_diameter_inches?: GraphCacheResolver<WithTypename<Casings_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    drift_inches?: GraphCacheResolver<WithTypename<Casings_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Casings_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    interior_diameter_inches?: GraphCacheResolver<WithTypename<Casings_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    outer_diameter_inches?: GraphCacheResolver<WithTypename<Casings_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pound_per_foot?: GraphCacheResolver<WithTypename<Casings_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  casings_stddev_samp_fields?: {
    coupling_outer_diameter_inches?: GraphCacheResolver<WithTypename<Casings_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    drift_inches?: GraphCacheResolver<WithTypename<Casings_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Casings_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    interior_diameter_inches?: GraphCacheResolver<WithTypename<Casings_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    outer_diameter_inches?: GraphCacheResolver<WithTypename<Casings_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pound_per_foot?: GraphCacheResolver<WithTypename<Casings_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  casings_sum_fields?: {
    coupling_outer_diameter_inches?: GraphCacheResolver<WithTypename<Casings_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    drift_inches?: GraphCacheResolver<WithTypename<Casings_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Casings_Sum_Fields>, Record<string, never>, Scalars['Int'] | string>,
    interior_diameter_inches?: GraphCacheResolver<WithTypename<Casings_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    outer_diameter_inches?: GraphCacheResolver<WithTypename<Casings_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    pound_per_foot?: GraphCacheResolver<WithTypename<Casings_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>
  },
  casings_type?: {
    comment?: GraphCacheResolver<WithTypename<Casings_Type>, Record<string, never>, Scalars['String'] | string>,
    value?: GraphCacheResolver<WithTypename<Casings_Type>, Record<string, never>, Scalars['String'] | string>
  },
  casings_type_aggregate?: {
    aggregate?: GraphCacheResolver<WithTypename<Casings_Type_Aggregate>, Record<string, never>, WithTypename<Casings_Type_Aggregate_Fields> | string>,
    nodes?: GraphCacheResolver<WithTypename<Casings_Type_Aggregate>, Record<string, never>, Array<WithTypename<Casings_Type> | string>>
  },
  casings_type_aggregate_fields?: {
    count?: GraphCacheResolver<WithTypename<Casings_Type_Aggregate_Fields>, Casings_Type_Aggregate_FieldsCountArgs, Scalars['Int'] | string>,
    max?: GraphCacheResolver<WithTypename<Casings_Type_Aggregate_Fields>, Record<string, never>, WithTypename<Casings_Type_Max_Fields> | string>,
    min?: GraphCacheResolver<WithTypename<Casings_Type_Aggregate_Fields>, Record<string, never>, WithTypename<Casings_Type_Min_Fields> | string>
  },
  casings_type_max_fields?: {
    comment?: GraphCacheResolver<WithTypename<Casings_Type_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    value?: GraphCacheResolver<WithTypename<Casings_Type_Max_Fields>, Record<string, never>, Scalars['String'] | string>
  },
  casings_type_min_fields?: {
    comment?: GraphCacheResolver<WithTypename<Casings_Type_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    value?: GraphCacheResolver<WithTypename<Casings_Type_Min_Fields>, Record<string, never>, Scalars['String'] | string>
  },
  casings_type_mutation_response?: {
    affected_rows?: GraphCacheResolver<WithTypename<Casings_Type_Mutation_Response>, Record<string, never>, Scalars['Int'] | string>,
    returning?: GraphCacheResolver<WithTypename<Casings_Type_Mutation_Response>, Record<string, never>, Array<WithTypename<Casings_Type> | string>>
  },
  casings_var_pop_fields?: {
    coupling_outer_diameter_inches?: GraphCacheResolver<WithTypename<Casings_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    drift_inches?: GraphCacheResolver<WithTypename<Casings_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Casings_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    interior_diameter_inches?: GraphCacheResolver<WithTypename<Casings_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    outer_diameter_inches?: GraphCacheResolver<WithTypename<Casings_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pound_per_foot?: GraphCacheResolver<WithTypename<Casings_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  casings_var_samp_fields?: {
    coupling_outer_diameter_inches?: GraphCacheResolver<WithTypename<Casings_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    drift_inches?: GraphCacheResolver<WithTypename<Casings_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Casings_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    interior_diameter_inches?: GraphCacheResolver<WithTypename<Casings_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    outer_diameter_inches?: GraphCacheResolver<WithTypename<Casings_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pound_per_foot?: GraphCacheResolver<WithTypename<Casings_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  casings_variance_fields?: {
    coupling_outer_diameter_inches?: GraphCacheResolver<WithTypename<Casings_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    drift_inches?: GraphCacheResolver<WithTypename<Casings_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Casings_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    interior_diameter_inches?: GraphCacheResolver<WithTypename<Casings_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    outer_diameter_inches?: GraphCacheResolver<WithTypename<Casings_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pound_per_foot?: GraphCacheResolver<WithTypename<Casings_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  customers?: {
    customer_erp_id?: GraphCacheResolver<WithTypename<Customers>, Record<string, never>, Scalars['String'] | string>,
    customer_name?: GraphCacheResolver<WithTypename<Customers>, Record<string, never>, Scalars['String'] | string>,
    id?: GraphCacheResolver<WithTypename<Customers>, Record<string, never>, Scalars['Int'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Customers>, Record<string, never>, Scalars['Int'] | string>,
    sizing_import?: GraphCacheResolver<WithTypename<Customers>, Record<string, never>, WithTypename<Sizing_Imports> | string>
  },
  customers_aggregate?: {
    aggregate?: GraphCacheResolver<WithTypename<Customers_Aggregate>, Record<string, never>, WithTypename<Customers_Aggregate_Fields> | string>,
    nodes?: GraphCacheResolver<WithTypename<Customers_Aggregate>, Record<string, never>, Array<WithTypename<Customers> | string>>
  },
  customers_aggregate_fields?: {
    avg?: GraphCacheResolver<WithTypename<Customers_Aggregate_Fields>, Record<string, never>, WithTypename<Customers_Avg_Fields> | string>,
    count?: GraphCacheResolver<WithTypename<Customers_Aggregate_Fields>, Customers_Aggregate_FieldsCountArgs, Scalars['Int'] | string>,
    max?: GraphCacheResolver<WithTypename<Customers_Aggregate_Fields>, Record<string, never>, WithTypename<Customers_Max_Fields> | string>,
    min?: GraphCacheResolver<WithTypename<Customers_Aggregate_Fields>, Record<string, never>, WithTypename<Customers_Min_Fields> | string>,
    stddev?: GraphCacheResolver<WithTypename<Customers_Aggregate_Fields>, Record<string, never>, WithTypename<Customers_Stddev_Fields> | string>,
    stddev_pop?: GraphCacheResolver<WithTypename<Customers_Aggregate_Fields>, Record<string, never>, WithTypename<Customers_Stddev_Pop_Fields> | string>,
    stddev_samp?: GraphCacheResolver<WithTypename<Customers_Aggregate_Fields>, Record<string, never>, WithTypename<Customers_Stddev_Samp_Fields> | string>,
    sum?: GraphCacheResolver<WithTypename<Customers_Aggregate_Fields>, Record<string, never>, WithTypename<Customers_Sum_Fields> | string>,
    var_pop?: GraphCacheResolver<WithTypename<Customers_Aggregate_Fields>, Record<string, never>, WithTypename<Customers_Var_Pop_Fields> | string>,
    var_samp?: GraphCacheResolver<WithTypename<Customers_Aggregate_Fields>, Record<string, never>, WithTypename<Customers_Var_Samp_Fields> | string>,
    variance?: GraphCacheResolver<WithTypename<Customers_Aggregate_Fields>, Record<string, never>, WithTypename<Customers_Variance_Fields> | string>
  },
  customers_avg_fields?: {
    id?: GraphCacheResolver<WithTypename<Customers_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Customers_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  customers_max_fields?: {
    customer_erp_id?: GraphCacheResolver<WithTypename<Customers_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    customer_name?: GraphCacheResolver<WithTypename<Customers_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    id?: GraphCacheResolver<WithTypename<Customers_Max_Fields>, Record<string, never>, Scalars['Int'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Customers_Max_Fields>, Record<string, never>, Scalars['Int'] | string>
  },
  customers_min_fields?: {
    customer_erp_id?: GraphCacheResolver<WithTypename<Customers_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    customer_name?: GraphCacheResolver<WithTypename<Customers_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    id?: GraphCacheResolver<WithTypename<Customers_Min_Fields>, Record<string, never>, Scalars['Int'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Customers_Min_Fields>, Record<string, never>, Scalars['Int'] | string>
  },
  customers_mutation_response?: {
    affected_rows?: GraphCacheResolver<WithTypename<Customers_Mutation_Response>, Record<string, never>, Scalars['Int'] | string>,
    returning?: GraphCacheResolver<WithTypename<Customers_Mutation_Response>, Record<string, never>, Array<WithTypename<Customers> | string>>
  },
  customers_stddev_fields?: {
    id?: GraphCacheResolver<WithTypename<Customers_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Customers_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  customers_stddev_pop_fields?: {
    id?: GraphCacheResolver<WithTypename<Customers_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Customers_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  customers_stddev_samp_fields?: {
    id?: GraphCacheResolver<WithTypename<Customers_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Customers_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  customers_sum_fields?: {
    id?: GraphCacheResolver<WithTypename<Customers_Sum_Fields>, Record<string, never>, Scalars['Int'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Customers_Sum_Fields>, Record<string, never>, Scalars['Int'] | string>
  },
  customers_var_pop_fields?: {
    id?: GraphCacheResolver<WithTypename<Customers_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Customers_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  customers_var_samp_fields?: {
    id?: GraphCacheResolver<WithTypename<Customers_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Customers_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  customers_variance_fields?: {
    id?: GraphCacheResolver<WithTypename<Customers_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Customers_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  dead_oil_options?: {
    comment?: GraphCacheResolver<WithTypename<Dead_Oil_Options>, Record<string, never>, Scalars['String'] | string>,
    value?: GraphCacheResolver<WithTypename<Dead_Oil_Options>, Record<string, never>, Scalars['String'] | string>
  },
  dead_oil_options_aggregate?: {
    aggregate?: GraphCacheResolver<WithTypename<Dead_Oil_Options_Aggregate>, Record<string, never>, WithTypename<Dead_Oil_Options_Aggregate_Fields> | string>,
    nodes?: GraphCacheResolver<WithTypename<Dead_Oil_Options_Aggregate>, Record<string, never>, Array<WithTypename<Dead_Oil_Options> | string>>
  },
  dead_oil_options_aggregate_fields?: {
    count?: GraphCacheResolver<WithTypename<Dead_Oil_Options_Aggregate_Fields>, Dead_Oil_Options_Aggregate_FieldsCountArgs, Scalars['Int'] | string>,
    max?: GraphCacheResolver<WithTypename<Dead_Oil_Options_Aggregate_Fields>, Record<string, never>, WithTypename<Dead_Oil_Options_Max_Fields> | string>,
    min?: GraphCacheResolver<WithTypename<Dead_Oil_Options_Aggregate_Fields>, Record<string, never>, WithTypename<Dead_Oil_Options_Min_Fields> | string>
  },
  dead_oil_options_max_fields?: {
    comment?: GraphCacheResolver<WithTypename<Dead_Oil_Options_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    value?: GraphCacheResolver<WithTypename<Dead_Oil_Options_Max_Fields>, Record<string, never>, Scalars['String'] | string>
  },
  dead_oil_options_min_fields?: {
    comment?: GraphCacheResolver<WithTypename<Dead_Oil_Options_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    value?: GraphCacheResolver<WithTypename<Dead_Oil_Options_Min_Fields>, Record<string, never>, Scalars['String'] | string>
  },
  dead_oil_options_mutation_response?: {
    affected_rows?: GraphCacheResolver<WithTypename<Dead_Oil_Options_Mutation_Response>, Record<string, never>, Scalars['Int'] | string>,
    returning?: GraphCacheResolver<WithTypename<Dead_Oil_Options_Mutation_Response>, Record<string, never>, Array<WithTypename<Dead_Oil_Options> | string>>
  },
  deviation_survey?: {
    author_id?: GraphCacheResolver<WithTypename<Deviation_Survey>, Record<string, never>, Scalars['String'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Deviation_Survey>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Deviation_Survey>, Record<string, never>, Scalars['timestamptz'] | string>,
    directional_data_set?: GraphCacheResolver<WithTypename<Deviation_Survey>, Record<string, never>, Deviation_Survey_Directional_Dataset_Enum | string>,
    entry_rows?: GraphCacheResolver<WithTypename<Deviation_Survey>, Record<string, never>, Array<Scalars['float8'] | string>>,
    id?: GraphCacheResolver<WithTypename<Deviation_Survey>, Record<string, never>, Scalars['uuid'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Deviation_Survey>, Record<string, never>, Scalars['Int'] | string>,
    sizing_import?: GraphCacheResolver<WithTypename<Deviation_Survey>, Record<string, never>, WithTypename<Sizing_Imports> | string>,
    title?: GraphCacheResolver<WithTypename<Deviation_Survey>, Record<string, never>, Scalars['String'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Deviation_Survey>, Record<string, never>, Scalars['timestamptz'] | string>,
    user?: GraphCacheResolver<WithTypename<Deviation_Survey>, Record<string, never>, WithTypename<Users> | string>
  },
  deviation_survey_aggregate?: {
    aggregate?: GraphCacheResolver<WithTypename<Deviation_Survey_Aggregate>, Record<string, never>, WithTypename<Deviation_Survey_Aggregate_Fields> | string>,
    nodes?: GraphCacheResolver<WithTypename<Deviation_Survey_Aggregate>, Record<string, never>, Array<WithTypename<Deviation_Survey> | string>>
  },
  deviation_survey_aggregate_fields?: {
    avg?: GraphCacheResolver<WithTypename<Deviation_Survey_Aggregate_Fields>, Record<string, never>, WithTypename<Deviation_Survey_Avg_Fields> | string>,
    count?: GraphCacheResolver<WithTypename<Deviation_Survey_Aggregate_Fields>, Deviation_Survey_Aggregate_FieldsCountArgs, Scalars['Int'] | string>,
    max?: GraphCacheResolver<WithTypename<Deviation_Survey_Aggregate_Fields>, Record<string, never>, WithTypename<Deviation_Survey_Max_Fields> | string>,
    min?: GraphCacheResolver<WithTypename<Deviation_Survey_Aggregate_Fields>, Record<string, never>, WithTypename<Deviation_Survey_Min_Fields> | string>,
    stddev?: GraphCacheResolver<WithTypename<Deviation_Survey_Aggregate_Fields>, Record<string, never>, WithTypename<Deviation_Survey_Stddev_Fields> | string>,
    stddev_pop?: GraphCacheResolver<WithTypename<Deviation_Survey_Aggregate_Fields>, Record<string, never>, WithTypename<Deviation_Survey_Stddev_Pop_Fields> | string>,
    stddev_samp?: GraphCacheResolver<WithTypename<Deviation_Survey_Aggregate_Fields>, Record<string, never>, WithTypename<Deviation_Survey_Stddev_Samp_Fields> | string>,
    sum?: GraphCacheResolver<WithTypename<Deviation_Survey_Aggregate_Fields>, Record<string, never>, WithTypename<Deviation_Survey_Sum_Fields> | string>,
    var_pop?: GraphCacheResolver<WithTypename<Deviation_Survey_Aggregate_Fields>, Record<string, never>, WithTypename<Deviation_Survey_Var_Pop_Fields> | string>,
    var_samp?: GraphCacheResolver<WithTypename<Deviation_Survey_Aggregate_Fields>, Record<string, never>, WithTypename<Deviation_Survey_Var_Samp_Fields> | string>,
    variance?: GraphCacheResolver<WithTypename<Deviation_Survey_Aggregate_Fields>, Record<string, never>, WithTypename<Deviation_Survey_Variance_Fields> | string>
  },
  deviation_survey_avg_fields?: {
    imported_sizing_id?: GraphCacheResolver<WithTypename<Deviation_Survey_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  deviation_survey_directional_dataset?: {
    comment?: GraphCacheResolver<WithTypename<Deviation_Survey_Directional_Dataset>, Record<string, never>, Scalars['String'] | string>,
    deviation_surveys?: GraphCacheResolver<WithTypename<Deviation_Survey_Directional_Dataset>, Deviation_Survey_Directional_DatasetDeviation_SurveysArgs, Array<WithTypename<Deviation_Survey> | string>>,
    deviation_surveys_aggregate?: GraphCacheResolver<WithTypename<Deviation_Survey_Directional_Dataset>, Deviation_Survey_Directional_DatasetDeviation_Surveys_AggregateArgs, WithTypename<Deviation_Survey_Aggregate> | string>,
    value?: GraphCacheResolver<WithTypename<Deviation_Survey_Directional_Dataset>, Record<string, never>, Scalars['String'] | string>
  },
  deviation_survey_directional_dataset_aggregate?: {
    aggregate?: GraphCacheResolver<WithTypename<Deviation_Survey_Directional_Dataset_Aggregate>, Record<string, never>, WithTypename<Deviation_Survey_Directional_Dataset_Aggregate_Fields> | string>,
    nodes?: GraphCacheResolver<WithTypename<Deviation_Survey_Directional_Dataset_Aggregate>, Record<string, never>, Array<WithTypename<Deviation_Survey_Directional_Dataset> | string>>
  },
  deviation_survey_directional_dataset_aggregate_fields?: {
    count?: GraphCacheResolver<WithTypename<Deviation_Survey_Directional_Dataset_Aggregate_Fields>, Deviation_Survey_Directional_Dataset_Aggregate_FieldsCountArgs, Scalars['Int'] | string>,
    max?: GraphCacheResolver<WithTypename<Deviation_Survey_Directional_Dataset_Aggregate_Fields>, Record<string, never>, WithTypename<Deviation_Survey_Directional_Dataset_Max_Fields> | string>,
    min?: GraphCacheResolver<WithTypename<Deviation_Survey_Directional_Dataset_Aggregate_Fields>, Record<string, never>, WithTypename<Deviation_Survey_Directional_Dataset_Min_Fields> | string>
  },
  deviation_survey_directional_dataset_max_fields?: {
    comment?: GraphCacheResolver<WithTypename<Deviation_Survey_Directional_Dataset_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    value?: GraphCacheResolver<WithTypename<Deviation_Survey_Directional_Dataset_Max_Fields>, Record<string, never>, Scalars['String'] | string>
  },
  deviation_survey_directional_dataset_min_fields?: {
    comment?: GraphCacheResolver<WithTypename<Deviation_Survey_Directional_Dataset_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    value?: GraphCacheResolver<WithTypename<Deviation_Survey_Directional_Dataset_Min_Fields>, Record<string, never>, Scalars['String'] | string>
  },
  deviation_survey_directional_dataset_mutation_response?: {
    affected_rows?: GraphCacheResolver<WithTypename<Deviation_Survey_Directional_Dataset_Mutation_Response>, Record<string, never>, Scalars['Int'] | string>,
    returning?: GraphCacheResolver<WithTypename<Deviation_Survey_Directional_Dataset_Mutation_Response>, Record<string, never>, Array<WithTypename<Deviation_Survey_Directional_Dataset> | string>>
  },
  deviation_survey_max_fields?: {
    author_id?: GraphCacheResolver<WithTypename<Deviation_Survey_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Deviation_Survey_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Deviation_Survey_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    entry_rows?: GraphCacheResolver<WithTypename<Deviation_Survey_Max_Fields>, Record<string, never>, Array<Scalars['float8'] | string>>,
    id?: GraphCacheResolver<WithTypename<Deviation_Survey_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Deviation_Survey_Max_Fields>, Record<string, never>, Scalars['Int'] | string>,
    title?: GraphCacheResolver<WithTypename<Deviation_Survey_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Deviation_Survey_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>
  },
  deviation_survey_min_fields?: {
    author_id?: GraphCacheResolver<WithTypename<Deviation_Survey_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Deviation_Survey_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Deviation_Survey_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    entry_rows?: GraphCacheResolver<WithTypename<Deviation_Survey_Min_Fields>, Record<string, never>, Array<Scalars['float8'] | string>>,
    id?: GraphCacheResolver<WithTypename<Deviation_Survey_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Deviation_Survey_Min_Fields>, Record<string, never>, Scalars['Int'] | string>,
    title?: GraphCacheResolver<WithTypename<Deviation_Survey_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Deviation_Survey_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>
  },
  deviation_survey_mutation_response?: {
    affected_rows?: GraphCacheResolver<WithTypename<Deviation_Survey_Mutation_Response>, Record<string, never>, Scalars['Int'] | string>,
    returning?: GraphCacheResolver<WithTypename<Deviation_Survey_Mutation_Response>, Record<string, never>, Array<WithTypename<Deviation_Survey> | string>>
  },
  deviation_survey_stddev_fields?: {
    imported_sizing_id?: GraphCacheResolver<WithTypename<Deviation_Survey_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  deviation_survey_stddev_pop_fields?: {
    imported_sizing_id?: GraphCacheResolver<WithTypename<Deviation_Survey_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  deviation_survey_stddev_samp_fields?: {
    imported_sizing_id?: GraphCacheResolver<WithTypename<Deviation_Survey_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  deviation_survey_sum_fields?: {
    imported_sizing_id?: GraphCacheResolver<WithTypename<Deviation_Survey_Sum_Fields>, Record<string, never>, Scalars['Int'] | string>
  },
  deviation_survey_var_pop_fields?: {
    imported_sizing_id?: GraphCacheResolver<WithTypename<Deviation_Survey_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  deviation_survey_var_samp_fields?: {
    imported_sizing_id?: GraphCacheResolver<WithTypename<Deviation_Survey_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  deviation_survey_variance_fields?: {
    imported_sizing_id?: GraphCacheResolver<WithTypename<Deviation_Survey_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  display_units?: {
    comment?: GraphCacheResolver<WithTypename<Display_Units>, Record<string, never>, Scalars['String'] | string>,
    value?: GraphCacheResolver<WithTypename<Display_Units>, Record<string, never>, Scalars['String'] | string>
  },
  display_units_aggregate?: {
    aggregate?: GraphCacheResolver<WithTypename<Display_Units_Aggregate>, Record<string, never>, WithTypename<Display_Units_Aggregate_Fields> | string>,
    nodes?: GraphCacheResolver<WithTypename<Display_Units_Aggregate>, Record<string, never>, Array<WithTypename<Display_Units> | string>>
  },
  display_units_aggregate_fields?: {
    count?: GraphCacheResolver<WithTypename<Display_Units_Aggregate_Fields>, Display_Units_Aggregate_FieldsCountArgs, Scalars['Int'] | string>,
    max?: GraphCacheResolver<WithTypename<Display_Units_Aggregate_Fields>, Record<string, never>, WithTypename<Display_Units_Max_Fields> | string>,
    min?: GraphCacheResolver<WithTypename<Display_Units_Aggregate_Fields>, Record<string, never>, WithTypename<Display_Units_Min_Fields> | string>
  },
  display_units_max_fields?: {
    comment?: GraphCacheResolver<WithTypename<Display_Units_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    value?: GraphCacheResolver<WithTypename<Display_Units_Max_Fields>, Record<string, never>, Scalars['String'] | string>
  },
  display_units_min_fields?: {
    comment?: GraphCacheResolver<WithTypename<Display_Units_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    value?: GraphCacheResolver<WithTypename<Display_Units_Min_Fields>, Record<string, never>, Scalars['String'] | string>
  },
  display_units_mutation_response?: {
    affected_rows?: GraphCacheResolver<WithTypename<Display_Units_Mutation_Response>, Record<string, never>, Scalars['Int'] | string>,
    returning?: GraphCacheResolver<WithTypename<Display_Units_Mutation_Response>, Record<string, never>, Array<WithTypename<Display_Units> | string>>
  },
  eula?: {
    activated?: GraphCacheResolver<WithTypename<Eula>, Record<string, never>, Scalars['Boolean'] | string>,
    activated_on?: GraphCacheResolver<WithTypename<Eula>, Record<string, never>, Scalars['timestamptz'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Eula>, Record<string, never>, Scalars['timestamptz'] | string>,
    deactivated_at?: GraphCacheResolver<WithTypename<Eula>, Record<string, never>, Scalars['timestamptz'] | string>,
    id?: GraphCacheResolver<WithTypename<Eula>, Record<string, never>, Scalars['uuid'] | string>,
    license?: GraphCacheResolver<WithTypename<Eula>, Record<string, never>, Scalars['String'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Eula>, Record<string, never>, Scalars['timestamptz'] | string>,
    version?: GraphCacheResolver<WithTypename<Eula>, Record<string, never>, Scalars['String'] | string>
  },
  eula_aggregate?: {
    aggregate?: GraphCacheResolver<WithTypename<Eula_Aggregate>, Record<string, never>, WithTypename<Eula_Aggregate_Fields> | string>,
    nodes?: GraphCacheResolver<WithTypename<Eula_Aggregate>, Record<string, never>, Array<WithTypename<Eula> | string>>
  },
  eula_aggregate_fields?: {
    count?: GraphCacheResolver<WithTypename<Eula_Aggregate_Fields>, Eula_Aggregate_FieldsCountArgs, Scalars['Int'] | string>,
    max?: GraphCacheResolver<WithTypename<Eula_Aggregate_Fields>, Record<string, never>, WithTypename<Eula_Max_Fields> | string>,
    min?: GraphCacheResolver<WithTypename<Eula_Aggregate_Fields>, Record<string, never>, WithTypename<Eula_Min_Fields> | string>
  },
  eula_max_fields?: {
    activated_on?: GraphCacheResolver<WithTypename<Eula_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Eula_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    deactivated_at?: GraphCacheResolver<WithTypename<Eula_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    id?: GraphCacheResolver<WithTypename<Eula_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    license?: GraphCacheResolver<WithTypename<Eula_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Eula_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    version?: GraphCacheResolver<WithTypename<Eula_Max_Fields>, Record<string, never>, Scalars['String'] | string>
  },
  eula_min_fields?: {
    activated_on?: GraphCacheResolver<WithTypename<Eula_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Eula_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    deactivated_at?: GraphCacheResolver<WithTypename<Eula_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    id?: GraphCacheResolver<WithTypename<Eula_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    license?: GraphCacheResolver<WithTypename<Eula_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Eula_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    version?: GraphCacheResolver<WithTypename<Eula_Min_Fields>, Record<string, never>, Scalars['String'] | string>
  },
  eula_mutation_response?: {
    affected_rows?: GraphCacheResolver<WithTypename<Eula_Mutation_Response>, Record<string, never>, Scalars['Int'] | string>,
    returning?: GraphCacheResolver<WithTypename<Eula_Mutation_Response>, Record<string, never>, Array<WithTypename<Eula> | string>>
  },
  flow_model?: {
    comment?: GraphCacheResolver<WithTypename<Flow_Model>, Record<string, never>, Scalars['String'] | string>,
    value?: GraphCacheResolver<WithTypename<Flow_Model>, Record<string, never>, Scalars['String'] | string>
  },
  flow_model_active?: {
    comment?: GraphCacheResolver<WithTypename<Flow_Model_Active>, Record<string, never>, Scalars['String'] | string>,
    value?: GraphCacheResolver<WithTypename<Flow_Model_Active>, Record<string, never>, Scalars['String'] | string>
  },
  flow_model_active_aggregate?: {
    aggregate?: GraphCacheResolver<WithTypename<Flow_Model_Active_Aggregate>, Record<string, never>, WithTypename<Flow_Model_Active_Aggregate_Fields> | string>,
    nodes?: GraphCacheResolver<WithTypename<Flow_Model_Active_Aggregate>, Record<string, never>, Array<WithTypename<Flow_Model_Active> | string>>
  },
  flow_model_active_aggregate_fields?: {
    count?: GraphCacheResolver<WithTypename<Flow_Model_Active_Aggregate_Fields>, Flow_Model_Active_Aggregate_FieldsCountArgs, Scalars['Int'] | string>,
    max?: GraphCacheResolver<WithTypename<Flow_Model_Active_Aggregate_Fields>, Record<string, never>, WithTypename<Flow_Model_Active_Max_Fields> | string>,
    min?: GraphCacheResolver<WithTypename<Flow_Model_Active_Aggregate_Fields>, Record<string, never>, WithTypename<Flow_Model_Active_Min_Fields> | string>
  },
  flow_model_active_max_fields?: {
    comment?: GraphCacheResolver<WithTypename<Flow_Model_Active_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    value?: GraphCacheResolver<WithTypename<Flow_Model_Active_Max_Fields>, Record<string, never>, Scalars['String'] | string>
  },
  flow_model_active_min_fields?: {
    comment?: GraphCacheResolver<WithTypename<Flow_Model_Active_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    value?: GraphCacheResolver<WithTypename<Flow_Model_Active_Min_Fields>, Record<string, never>, Scalars['String'] | string>
  },
  flow_model_active_mutation_response?: {
    affected_rows?: GraphCacheResolver<WithTypename<Flow_Model_Active_Mutation_Response>, Record<string, never>, Scalars['Int'] | string>,
    returning?: GraphCacheResolver<WithTypename<Flow_Model_Active_Mutation_Response>, Record<string, never>, Array<WithTypename<Flow_Model_Active> | string>>
  },
  flow_model_aggregate?: {
    aggregate?: GraphCacheResolver<WithTypename<Flow_Model_Aggregate>, Record<string, never>, WithTypename<Flow_Model_Aggregate_Fields> | string>,
    nodes?: GraphCacheResolver<WithTypename<Flow_Model_Aggregate>, Record<string, never>, Array<WithTypename<Flow_Model> | string>>
  },
  flow_model_aggregate_fields?: {
    count?: GraphCacheResolver<WithTypename<Flow_Model_Aggregate_Fields>, Flow_Model_Aggregate_FieldsCountArgs, Scalars['Int'] | string>,
    max?: GraphCacheResolver<WithTypename<Flow_Model_Aggregate_Fields>, Record<string, never>, WithTypename<Flow_Model_Max_Fields> | string>,
    min?: GraphCacheResolver<WithTypename<Flow_Model_Aggregate_Fields>, Record<string, never>, WithTypename<Flow_Model_Min_Fields> | string>
  },
  flow_model_deprecated?: {
    value?: GraphCacheResolver<WithTypename<Flow_Model_Deprecated>, Record<string, never>, Flow_Model_Enum | string>
  },
  flow_model_deprecated_aggregate?: {
    aggregate?: GraphCacheResolver<WithTypename<Flow_Model_Deprecated_Aggregate>, Record<string, never>, WithTypename<Flow_Model_Deprecated_Aggregate_Fields> | string>,
    nodes?: GraphCacheResolver<WithTypename<Flow_Model_Deprecated_Aggregate>, Record<string, never>, Array<WithTypename<Flow_Model_Deprecated> | string>>
  },
  flow_model_deprecated_aggregate_fields?: {
    count?: GraphCacheResolver<WithTypename<Flow_Model_Deprecated_Aggregate_Fields>, Flow_Model_Deprecated_Aggregate_FieldsCountArgs, Scalars['Int'] | string>
  },
  flow_model_deprecated_mutation_response?: {
    affected_rows?: GraphCacheResolver<WithTypename<Flow_Model_Deprecated_Mutation_Response>, Record<string, never>, Scalars['Int'] | string>,
    returning?: GraphCacheResolver<WithTypename<Flow_Model_Deprecated_Mutation_Response>, Record<string, never>, Array<WithTypename<Flow_Model_Deprecated> | string>>
  },
  flow_model_max_fields?: {
    comment?: GraphCacheResolver<WithTypename<Flow_Model_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    value?: GraphCacheResolver<WithTypename<Flow_Model_Max_Fields>, Record<string, never>, Scalars['String'] | string>
  },
  flow_model_min_fields?: {
    comment?: GraphCacheResolver<WithTypename<Flow_Model_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    value?: GraphCacheResolver<WithTypename<Flow_Model_Min_Fields>, Record<string, never>, Scalars['String'] | string>
  },
  flow_model_mutation_response?: {
    affected_rows?: GraphCacheResolver<WithTypename<Flow_Model_Mutation_Response>, Record<string, never>, Scalars['Int'] | string>,
    returning?: GraphCacheResolver<WithTypename<Flow_Model_Mutation_Response>, Record<string, never>, Array<WithTypename<Flow_Model> | string>>
  },
  friction_loss_options?: {
    comment?: GraphCacheResolver<WithTypename<Friction_Loss_Options>, Record<string, never>, Scalars['String'] | string>,
    value?: GraphCacheResolver<WithTypename<Friction_Loss_Options>, Record<string, never>, Scalars['String'] | string>
  },
  friction_loss_options_aggregate?: {
    aggregate?: GraphCacheResolver<WithTypename<Friction_Loss_Options_Aggregate>, Record<string, never>, WithTypename<Friction_Loss_Options_Aggregate_Fields> | string>,
    nodes?: GraphCacheResolver<WithTypename<Friction_Loss_Options_Aggregate>, Record<string, never>, Array<WithTypename<Friction_Loss_Options> | string>>
  },
  friction_loss_options_aggregate_fields?: {
    count?: GraphCacheResolver<WithTypename<Friction_Loss_Options_Aggregate_Fields>, Friction_Loss_Options_Aggregate_FieldsCountArgs, Scalars['Int'] | string>,
    max?: GraphCacheResolver<WithTypename<Friction_Loss_Options_Aggregate_Fields>, Record<string, never>, WithTypename<Friction_Loss_Options_Max_Fields> | string>,
    min?: GraphCacheResolver<WithTypename<Friction_Loss_Options_Aggregate_Fields>, Record<string, never>, WithTypename<Friction_Loss_Options_Min_Fields> | string>
  },
  friction_loss_options_max_fields?: {
    comment?: GraphCacheResolver<WithTypename<Friction_Loss_Options_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    value?: GraphCacheResolver<WithTypename<Friction_Loss_Options_Max_Fields>, Record<string, never>, Scalars['String'] | string>
  },
  friction_loss_options_min_fields?: {
    comment?: GraphCacheResolver<WithTypename<Friction_Loss_Options_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    value?: GraphCacheResolver<WithTypename<Friction_Loss_Options_Min_Fields>, Record<string, never>, Scalars['String'] | string>
  },
  friction_loss_options_mutation_response?: {
    affected_rows?: GraphCacheResolver<WithTypename<Friction_Loss_Options_Mutation_Response>, Record<string, never>, Scalars['Int'] | string>,
    returning?: GraphCacheResolver<WithTypename<Friction_Loss_Options_Mutation_Response>, Record<string, never>, Array<WithTypename<Friction_Loss_Options> | string>>
  },
  gas_compressibility_options?: {
    comment?: GraphCacheResolver<WithTypename<Gas_Compressibility_Options>, Record<string, never>, Scalars['String'] | string>,
    value?: GraphCacheResolver<WithTypename<Gas_Compressibility_Options>, Record<string, never>, Scalars['String'] | string>
  },
  gas_compressibility_options_aggregate?: {
    aggregate?: GraphCacheResolver<WithTypename<Gas_Compressibility_Options_Aggregate>, Record<string, never>, WithTypename<Gas_Compressibility_Options_Aggregate_Fields> | string>,
    nodes?: GraphCacheResolver<WithTypename<Gas_Compressibility_Options_Aggregate>, Record<string, never>, Array<WithTypename<Gas_Compressibility_Options> | string>>
  },
  gas_compressibility_options_aggregate_fields?: {
    count?: GraphCacheResolver<WithTypename<Gas_Compressibility_Options_Aggregate_Fields>, Gas_Compressibility_Options_Aggregate_FieldsCountArgs, Scalars['Int'] | string>,
    max?: GraphCacheResolver<WithTypename<Gas_Compressibility_Options_Aggregate_Fields>, Record<string, never>, WithTypename<Gas_Compressibility_Options_Max_Fields> | string>,
    min?: GraphCacheResolver<WithTypename<Gas_Compressibility_Options_Aggregate_Fields>, Record<string, never>, WithTypename<Gas_Compressibility_Options_Min_Fields> | string>
  },
  gas_compressibility_options_max_fields?: {
    comment?: GraphCacheResolver<WithTypename<Gas_Compressibility_Options_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    value?: GraphCacheResolver<WithTypename<Gas_Compressibility_Options_Max_Fields>, Record<string, never>, Scalars['String'] | string>
  },
  gas_compressibility_options_min_fields?: {
    comment?: GraphCacheResolver<WithTypename<Gas_Compressibility_Options_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    value?: GraphCacheResolver<WithTypename<Gas_Compressibility_Options_Min_Fields>, Record<string, never>, Scalars['String'] | string>
  },
  gas_compressibility_options_mutation_response?: {
    affected_rows?: GraphCacheResolver<WithTypename<Gas_Compressibility_Options_Mutation_Response>, Record<string, never>, Scalars['Int'] | string>,
    returning?: GraphCacheResolver<WithTypename<Gas_Compressibility_Options_Mutation_Response>, Record<string, never>, Array<WithTypename<Gas_Compressibility_Options> | string>>
  },
  gas_viscosity_options?: {
    comment?: GraphCacheResolver<WithTypename<Gas_Viscosity_Options>, Record<string, never>, Scalars['String'] | string>,
    value?: GraphCacheResolver<WithTypename<Gas_Viscosity_Options>, Record<string, never>, Scalars['String'] | string>
  },
  gas_viscosity_options_aggregate?: {
    aggregate?: GraphCacheResolver<WithTypename<Gas_Viscosity_Options_Aggregate>, Record<string, never>, WithTypename<Gas_Viscosity_Options_Aggregate_Fields> | string>,
    nodes?: GraphCacheResolver<WithTypename<Gas_Viscosity_Options_Aggregate>, Record<string, never>, Array<WithTypename<Gas_Viscosity_Options> | string>>
  },
  gas_viscosity_options_aggregate_fields?: {
    count?: GraphCacheResolver<WithTypename<Gas_Viscosity_Options_Aggregate_Fields>, Gas_Viscosity_Options_Aggregate_FieldsCountArgs, Scalars['Int'] | string>,
    max?: GraphCacheResolver<WithTypename<Gas_Viscosity_Options_Aggregate_Fields>, Record<string, never>, WithTypename<Gas_Viscosity_Options_Max_Fields> | string>,
    min?: GraphCacheResolver<WithTypename<Gas_Viscosity_Options_Aggregate_Fields>, Record<string, never>, WithTypename<Gas_Viscosity_Options_Min_Fields> | string>
  },
  gas_viscosity_options_max_fields?: {
    comment?: GraphCacheResolver<WithTypename<Gas_Viscosity_Options_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    value?: GraphCacheResolver<WithTypename<Gas_Viscosity_Options_Max_Fields>, Record<string, never>, Scalars['String'] | string>
  },
  gas_viscosity_options_min_fields?: {
    comment?: GraphCacheResolver<WithTypename<Gas_Viscosity_Options_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    value?: GraphCacheResolver<WithTypename<Gas_Viscosity_Options_Min_Fields>, Record<string, never>, Scalars['String'] | string>
  },
  gas_viscosity_options_mutation_response?: {
    affected_rows?: GraphCacheResolver<WithTypename<Gas_Viscosity_Options_Mutation_Response>, Record<string, never>, Scalars['Int'] | string>,
    returning?: GraphCacheResolver<WithTypename<Gas_Viscosity_Options_Mutation_Response>, Record<string, never>, Array<WithTypename<Gas_Viscosity_Options> | string>>
  },
  housings?: {
    author_id?: GraphCacheResolver<WithTypename<Housings>, Record<string, never>, Scalars['String'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Housings>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Housings>, Record<string, never>, Scalars['timestamptz'] | string>,
    housing_number?: GraphCacheResolver<WithTypename<Housings>, Record<string, never>, Scalars['Int'] | string>,
    id?: GraphCacheResolver<WithTypename<Housings>, Record<string, never>, Scalars['uuid'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Housings>, Record<string, never>, Scalars['Int'] | string>,
    include_ecopetrol_timestamp?: GraphCacheResolver<WithTypename<Housings>, Record<string, never>, Scalars['timestamptz'] | string>,
    include_koc_timestamp?: GraphCacheResolver<WithTypename<Housings>, Record<string, never>, Scalars['timestamptz'] | string>,
    length_inches?: GraphCacheResolver<WithTypename<Housings>, Record<string, never>, Scalars['numeric'] | string>,
    only_ecopetrol_timestamp?: GraphCacheResolver<WithTypename<Housings>, Record<string, never>, Scalars['timestamptz'] | string>,
    only_koc_timestamp?: GraphCacheResolver<WithTypename<Housings>, Record<string, never>, Scalars['timestamptz'] | string>,
    pump?: GraphCacheResolver<WithTypename<Housings>, Record<string, never>, WithTypename<Pumps> | string>,
    pump_id?: GraphCacheResolver<WithTypename<Housings>, Record<string, never>, Scalars['uuid'] | string>,
    sizing_import?: GraphCacheResolver<WithTypename<Housings>, Record<string, never>, WithTypename<Sizing_Imports> | string>,
    stage_count?: GraphCacheResolver<WithTypename<Housings>, Record<string, never>, Scalars['Int'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Housings>, Record<string, never>, Scalars['timestamptz'] | string>,
    user?: GraphCacheResolver<WithTypename<Housings>, Record<string, never>, WithTypename<Users> | string>,
    weight_pounds?: GraphCacheResolver<WithTypename<Housings>, Record<string, never>, Scalars['numeric'] | string>
  },
  housings_aggregate?: {
    aggregate?: GraphCacheResolver<WithTypename<Housings_Aggregate>, Record<string, never>, WithTypename<Housings_Aggregate_Fields> | string>,
    nodes?: GraphCacheResolver<WithTypename<Housings_Aggregate>, Record<string, never>, Array<WithTypename<Housings> | string>>
  },
  housings_aggregate_fields?: {
    avg?: GraphCacheResolver<WithTypename<Housings_Aggregate_Fields>, Record<string, never>, WithTypename<Housings_Avg_Fields> | string>,
    count?: GraphCacheResolver<WithTypename<Housings_Aggregate_Fields>, Housings_Aggregate_FieldsCountArgs, Scalars['Int'] | string>,
    max?: GraphCacheResolver<WithTypename<Housings_Aggregate_Fields>, Record<string, never>, WithTypename<Housings_Max_Fields> | string>,
    min?: GraphCacheResolver<WithTypename<Housings_Aggregate_Fields>, Record<string, never>, WithTypename<Housings_Min_Fields> | string>,
    stddev?: GraphCacheResolver<WithTypename<Housings_Aggregate_Fields>, Record<string, never>, WithTypename<Housings_Stddev_Fields> | string>,
    stddev_pop?: GraphCacheResolver<WithTypename<Housings_Aggregate_Fields>, Record<string, never>, WithTypename<Housings_Stddev_Pop_Fields> | string>,
    stddev_samp?: GraphCacheResolver<WithTypename<Housings_Aggregate_Fields>, Record<string, never>, WithTypename<Housings_Stddev_Samp_Fields> | string>,
    sum?: GraphCacheResolver<WithTypename<Housings_Aggregate_Fields>, Record<string, never>, WithTypename<Housings_Sum_Fields> | string>,
    var_pop?: GraphCacheResolver<WithTypename<Housings_Aggregate_Fields>, Record<string, never>, WithTypename<Housings_Var_Pop_Fields> | string>,
    var_samp?: GraphCacheResolver<WithTypename<Housings_Aggregate_Fields>, Record<string, never>, WithTypename<Housings_Var_Samp_Fields> | string>,
    variance?: GraphCacheResolver<WithTypename<Housings_Aggregate_Fields>, Record<string, never>, WithTypename<Housings_Variance_Fields> | string>
  },
  housings_avg_fields?: {
    housing_number?: GraphCacheResolver<WithTypename<Housings_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Housings_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    length_inches?: GraphCacheResolver<WithTypename<Housings_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    stage_count?: GraphCacheResolver<WithTypename<Housings_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    weight_pounds?: GraphCacheResolver<WithTypename<Housings_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  housings_max_fields?: {
    author_id?: GraphCacheResolver<WithTypename<Housings_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Housings_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Housings_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    housing_number?: GraphCacheResolver<WithTypename<Housings_Max_Fields>, Record<string, never>, Scalars['Int'] | string>,
    id?: GraphCacheResolver<WithTypename<Housings_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Housings_Max_Fields>, Record<string, never>, Scalars['Int'] | string>,
    include_ecopetrol_timestamp?: GraphCacheResolver<WithTypename<Housings_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    include_koc_timestamp?: GraphCacheResolver<WithTypename<Housings_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    length_inches?: GraphCacheResolver<WithTypename<Housings_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    only_ecopetrol_timestamp?: GraphCacheResolver<WithTypename<Housings_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    only_koc_timestamp?: GraphCacheResolver<WithTypename<Housings_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    pump_id?: GraphCacheResolver<WithTypename<Housings_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    stage_count?: GraphCacheResolver<WithTypename<Housings_Max_Fields>, Record<string, never>, Scalars['Int'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Housings_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    weight_pounds?: GraphCacheResolver<WithTypename<Housings_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>
  },
  housings_min_fields?: {
    author_id?: GraphCacheResolver<WithTypename<Housings_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Housings_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Housings_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    housing_number?: GraphCacheResolver<WithTypename<Housings_Min_Fields>, Record<string, never>, Scalars['Int'] | string>,
    id?: GraphCacheResolver<WithTypename<Housings_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Housings_Min_Fields>, Record<string, never>, Scalars['Int'] | string>,
    include_ecopetrol_timestamp?: GraphCacheResolver<WithTypename<Housings_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    include_koc_timestamp?: GraphCacheResolver<WithTypename<Housings_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    length_inches?: GraphCacheResolver<WithTypename<Housings_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    only_ecopetrol_timestamp?: GraphCacheResolver<WithTypename<Housings_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    only_koc_timestamp?: GraphCacheResolver<WithTypename<Housings_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    pump_id?: GraphCacheResolver<WithTypename<Housings_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    stage_count?: GraphCacheResolver<WithTypename<Housings_Min_Fields>, Record<string, never>, Scalars['Int'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Housings_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    weight_pounds?: GraphCacheResolver<WithTypename<Housings_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>
  },
  housings_mutation_response?: {
    affected_rows?: GraphCacheResolver<WithTypename<Housings_Mutation_Response>, Record<string, never>, Scalars['Int'] | string>,
    returning?: GraphCacheResolver<WithTypename<Housings_Mutation_Response>, Record<string, never>, Array<WithTypename<Housings> | string>>
  },
  housings_stddev_fields?: {
    housing_number?: GraphCacheResolver<WithTypename<Housings_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Housings_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    length_inches?: GraphCacheResolver<WithTypename<Housings_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    stage_count?: GraphCacheResolver<WithTypename<Housings_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    weight_pounds?: GraphCacheResolver<WithTypename<Housings_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  housings_stddev_pop_fields?: {
    housing_number?: GraphCacheResolver<WithTypename<Housings_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Housings_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    length_inches?: GraphCacheResolver<WithTypename<Housings_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    stage_count?: GraphCacheResolver<WithTypename<Housings_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    weight_pounds?: GraphCacheResolver<WithTypename<Housings_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  housings_stddev_samp_fields?: {
    housing_number?: GraphCacheResolver<WithTypename<Housings_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Housings_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    length_inches?: GraphCacheResolver<WithTypename<Housings_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    stage_count?: GraphCacheResolver<WithTypename<Housings_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    weight_pounds?: GraphCacheResolver<WithTypename<Housings_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  housings_sum_fields?: {
    housing_number?: GraphCacheResolver<WithTypename<Housings_Sum_Fields>, Record<string, never>, Scalars['Int'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Housings_Sum_Fields>, Record<string, never>, Scalars['Int'] | string>,
    length_inches?: GraphCacheResolver<WithTypename<Housings_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    stage_count?: GraphCacheResolver<WithTypename<Housings_Sum_Fields>, Record<string, never>, Scalars['Int'] | string>,
    weight_pounds?: GraphCacheResolver<WithTypename<Housings_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>
  },
  housings_var_pop_fields?: {
    housing_number?: GraphCacheResolver<WithTypename<Housings_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Housings_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    length_inches?: GraphCacheResolver<WithTypename<Housings_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    stage_count?: GraphCacheResolver<WithTypename<Housings_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    weight_pounds?: GraphCacheResolver<WithTypename<Housings_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  housings_var_samp_fields?: {
    housing_number?: GraphCacheResolver<WithTypename<Housings_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Housings_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    length_inches?: GraphCacheResolver<WithTypename<Housings_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    stage_count?: GraphCacheResolver<WithTypename<Housings_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    weight_pounds?: GraphCacheResolver<WithTypename<Housings_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  housings_variance_fields?: {
    housing_number?: GraphCacheResolver<WithTypename<Housings_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Housings_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    length_inches?: GraphCacheResolver<WithTypename<Housings_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    stage_count?: GraphCacheResolver<WithTypename<Housings_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    weight_pounds?: GraphCacheResolver<WithTypename<Housings_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  hps_liquid_type?: {
    comment?: GraphCacheResolver<WithTypename<Hps_Liquid_Type>, Record<string, never>, Scalars['String'] | string>,
    value?: GraphCacheResolver<WithTypename<Hps_Liquid_Type>, Record<string, never>, Scalars['String'] | string>
  },
  hps_liquid_type_aggregate?: {
    aggregate?: GraphCacheResolver<WithTypename<Hps_Liquid_Type_Aggregate>, Record<string, never>, WithTypename<Hps_Liquid_Type_Aggregate_Fields> | string>,
    nodes?: GraphCacheResolver<WithTypename<Hps_Liquid_Type_Aggregate>, Record<string, never>, Array<WithTypename<Hps_Liquid_Type> | string>>
  },
  hps_liquid_type_aggregate_fields?: {
    count?: GraphCacheResolver<WithTypename<Hps_Liquid_Type_Aggregate_Fields>, Hps_Liquid_Type_Aggregate_FieldsCountArgs, Scalars['Int'] | string>,
    max?: GraphCacheResolver<WithTypename<Hps_Liquid_Type_Aggregate_Fields>, Record<string, never>, WithTypename<Hps_Liquid_Type_Max_Fields> | string>,
    min?: GraphCacheResolver<WithTypename<Hps_Liquid_Type_Aggregate_Fields>, Record<string, never>, WithTypename<Hps_Liquid_Type_Min_Fields> | string>
  },
  hps_liquid_type_max_fields?: {
    comment?: GraphCacheResolver<WithTypename<Hps_Liquid_Type_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    value?: GraphCacheResolver<WithTypename<Hps_Liquid_Type_Max_Fields>, Record<string, never>, Scalars['String'] | string>
  },
  hps_liquid_type_min_fields?: {
    comment?: GraphCacheResolver<WithTypename<Hps_Liquid_Type_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    value?: GraphCacheResolver<WithTypename<Hps_Liquid_Type_Min_Fields>, Record<string, never>, Scalars['String'] | string>
  },
  hps_liquid_type_mutation_response?: {
    affected_rows?: GraphCacheResolver<WithTypename<Hps_Liquid_Type_Mutation_Response>, Record<string, never>, Scalars['Int'] | string>,
    returning?: GraphCacheResolver<WithTypename<Hps_Liquid_Type_Mutation_Response>, Record<string, never>, Array<WithTypename<Hps_Liquid_Type> | string>>
  },
  intakes?: {
    author_id?: GraphCacheResolver<WithTypename<Intakes>, Record<string, never>, Scalars['String'] | string>,
    bhp0?: GraphCacheResolver<WithTypename<Intakes>, Record<string, never>, Scalars['numeric'] | string>,
    bhp1?: GraphCacheResolver<WithTypename<Intakes>, Record<string, never>, Scalars['numeric'] | string>,
    bhp2?: GraphCacheResolver<WithTypename<Intakes>, Record<string, never>, Scalars['numeric'] | string>,
    bhp3?: GraphCacheResolver<WithTypename<Intakes>, Record<string, never>, Scalars['numeric'] | string>,
    bhp4?: GraphCacheResolver<WithTypename<Intakes>, Record<string, never>, Scalars['numeric'] | string>,
    bhp5?: GraphCacheResolver<WithTypename<Intakes>, Record<string, never>, Scalars['numeric'] | string>,
    bolt_on?: GraphCacheResolver<WithTypename<Intakes>, Record<string, never>, Scalars['Boolean'] | string>,
    configuration?: GraphCacheResolver<WithTypename<Intakes>, Record<string, never>, Scalars['String'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Intakes>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Intakes>, Record<string, never>, Scalars['timestamptz'] | string>,
    eff1?: GraphCacheResolver<WithTypename<Intakes>, Record<string, never>, Scalars['numeric'] | string>,
    eff2?: GraphCacheResolver<WithTypename<Intakes>, Record<string, never>, Scalars['numeric'] | string>,
    high_strength_shaft_limit_hp?: GraphCacheResolver<WithTypename<Intakes>, Record<string, never>, Scalars['Int'] | string>,
    housing_material?: GraphCacheResolver<WithTypename<Intakes>, Record<string, never>, Scalars['String'] | string>,
    hp?: GraphCacheResolver<WithTypename<Intakes>, Record<string, never>, Scalars['numeric'] | string>,
    id?: GraphCacheResolver<WithTypename<Intakes>, Record<string, never>, Scalars['uuid'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Intakes>, Record<string, never>, Scalars['Int'] | string>,
    include_ecopetrol_timestamp?: GraphCacheResolver<WithTypename<Intakes>, Record<string, never>, Scalars['timestamptz'] | string>,
    include_koc_timestamp?: GraphCacheResolver<WithTypename<Intakes>, Record<string, never>, Scalars['timestamptz'] | string>,
    inner_diameter_inches?: GraphCacheResolver<WithTypename<Intakes>, Record<string, never>, Scalars['numeric'] | string>,
    intake_type?: GraphCacheResolver<WithTypename<Intakes>, Record<string, never>, Scalars['String'] | string>,
    is_hps?: GraphCacheResolver<WithTypename<Intakes>, Record<string, never>, Scalars['Boolean'] | string>,
    length_inches?: GraphCacheResolver<WithTypename<Intakes>, Record<string, never>, Scalars['numeric'] | string>,
    manufacturer?: GraphCacheResolver<WithTypename<Intakes>, Record<string, never>, Scalars['String'] | string>,
    max_rate_bpd?: GraphCacheResolver<WithTypename<Intakes>, Record<string, never>, Scalars['Int'] | string>,
    neck_inner_diameter_inches?: GraphCacheResolver<WithTypename<Intakes>, Record<string, never>, Scalars['numeric'] | string>,
    neck_outer_diameter_inches?: GraphCacheResolver<WithTypename<Intakes>, Record<string, never>, Scalars['numeric'] | string>,
    only_ecopetrol_timestamp?: GraphCacheResolver<WithTypename<Intakes>, Record<string, never>, Scalars['timestamptz'] | string>,
    only_koc_timestamp?: GraphCacheResolver<WithTypename<Intakes>, Record<string, never>, Scalars['timestamptz'] | string>,
    outer_diameter_inches?: GraphCacheResolver<WithTypename<Intakes>, Record<string, never>, Scalars['numeric'] | string>,
    part_number?: GraphCacheResolver<WithTypename<Intakes>, Record<string, never>, Scalars['String'] | string>,
    port_area_square_inches?: GraphCacheResolver<WithTypename<Intakes>, Record<string, never>, Scalars['numeric'] | string>,
    prioritized_manufacturer?: GraphCacheResolver<WithTypename<Intakes>, Record<string, never>, Scalars['String'] | string>,
    shaft_limit_hp?: GraphCacheResolver<WithTypename<Intakes>, Record<string, never>, Scalars['Int'] | string>,
    shaft_material?: GraphCacheResolver<WithTypename<Intakes>, Record<string, never>, Scalars['String'] | string>,
    sizing_import?: GraphCacheResolver<WithTypename<Intakes>, Record<string, never>, WithTypename<Sizing_Imports> | string>,
    stage_count?: GraphCacheResolver<WithTypename<Intakes>, Record<string, never>, Scalars['Int'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Intakes>, Record<string, never>, Scalars['timestamptz'] | string>,
    user?: GraphCacheResolver<WithTypename<Intakes>, Record<string, never>, WithTypename<Users> | string>,
    weight_pounds?: GraphCacheResolver<WithTypename<Intakes>, Record<string, never>, Scalars['numeric'] | string>
  },
  intakes_aggregate?: {
    aggregate?: GraphCacheResolver<WithTypename<Intakes_Aggregate>, Record<string, never>, WithTypename<Intakes_Aggregate_Fields> | string>,
    nodes?: GraphCacheResolver<WithTypename<Intakes_Aggregate>, Record<string, never>, Array<WithTypename<Intakes> | string>>
  },
  intakes_aggregate_fields?: {
    avg?: GraphCacheResolver<WithTypename<Intakes_Aggregate_Fields>, Record<string, never>, WithTypename<Intakes_Avg_Fields> | string>,
    count?: GraphCacheResolver<WithTypename<Intakes_Aggregate_Fields>, Intakes_Aggregate_FieldsCountArgs, Scalars['Int'] | string>,
    max?: GraphCacheResolver<WithTypename<Intakes_Aggregate_Fields>, Record<string, never>, WithTypename<Intakes_Max_Fields> | string>,
    min?: GraphCacheResolver<WithTypename<Intakes_Aggregate_Fields>, Record<string, never>, WithTypename<Intakes_Min_Fields> | string>,
    stddev?: GraphCacheResolver<WithTypename<Intakes_Aggregate_Fields>, Record<string, never>, WithTypename<Intakes_Stddev_Fields> | string>,
    stddev_pop?: GraphCacheResolver<WithTypename<Intakes_Aggregate_Fields>, Record<string, never>, WithTypename<Intakes_Stddev_Pop_Fields> | string>,
    stddev_samp?: GraphCacheResolver<WithTypename<Intakes_Aggregate_Fields>, Record<string, never>, WithTypename<Intakes_Stddev_Samp_Fields> | string>,
    sum?: GraphCacheResolver<WithTypename<Intakes_Aggregate_Fields>, Record<string, never>, WithTypename<Intakes_Sum_Fields> | string>,
    var_pop?: GraphCacheResolver<WithTypename<Intakes_Aggregate_Fields>, Record<string, never>, WithTypename<Intakes_Var_Pop_Fields> | string>,
    var_samp?: GraphCacheResolver<WithTypename<Intakes_Aggregate_Fields>, Record<string, never>, WithTypename<Intakes_Var_Samp_Fields> | string>,
    variance?: GraphCacheResolver<WithTypename<Intakes_Aggregate_Fields>, Record<string, never>, WithTypename<Intakes_Variance_Fields> | string>
  },
  intakes_avg_fields?: {
    bhp0?: GraphCacheResolver<WithTypename<Intakes_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bhp1?: GraphCacheResolver<WithTypename<Intakes_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bhp2?: GraphCacheResolver<WithTypename<Intakes_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bhp3?: GraphCacheResolver<WithTypename<Intakes_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bhp4?: GraphCacheResolver<WithTypename<Intakes_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bhp5?: GraphCacheResolver<WithTypename<Intakes_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    eff1?: GraphCacheResolver<WithTypename<Intakes_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    eff2?: GraphCacheResolver<WithTypename<Intakes_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    high_strength_shaft_limit_hp?: GraphCacheResolver<WithTypename<Intakes_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    hp?: GraphCacheResolver<WithTypename<Intakes_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Intakes_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    inner_diameter_inches?: GraphCacheResolver<WithTypename<Intakes_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    length_inches?: GraphCacheResolver<WithTypename<Intakes_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    max_rate_bpd?: GraphCacheResolver<WithTypename<Intakes_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    neck_inner_diameter_inches?: GraphCacheResolver<WithTypename<Intakes_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    neck_outer_diameter_inches?: GraphCacheResolver<WithTypename<Intakes_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    outer_diameter_inches?: GraphCacheResolver<WithTypename<Intakes_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    port_area_square_inches?: GraphCacheResolver<WithTypename<Intakes_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    shaft_limit_hp?: GraphCacheResolver<WithTypename<Intakes_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    stage_count?: GraphCacheResolver<WithTypename<Intakes_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    weight_pounds?: GraphCacheResolver<WithTypename<Intakes_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  intakes_max_fields?: {
    author_id?: GraphCacheResolver<WithTypename<Intakes_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    bhp0?: GraphCacheResolver<WithTypename<Intakes_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    bhp1?: GraphCacheResolver<WithTypename<Intakes_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    bhp2?: GraphCacheResolver<WithTypename<Intakes_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    bhp3?: GraphCacheResolver<WithTypename<Intakes_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    bhp4?: GraphCacheResolver<WithTypename<Intakes_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    bhp5?: GraphCacheResolver<WithTypename<Intakes_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    configuration?: GraphCacheResolver<WithTypename<Intakes_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Intakes_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Intakes_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    eff1?: GraphCacheResolver<WithTypename<Intakes_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    eff2?: GraphCacheResolver<WithTypename<Intakes_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    high_strength_shaft_limit_hp?: GraphCacheResolver<WithTypename<Intakes_Max_Fields>, Record<string, never>, Scalars['Int'] | string>,
    housing_material?: GraphCacheResolver<WithTypename<Intakes_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    hp?: GraphCacheResolver<WithTypename<Intakes_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    id?: GraphCacheResolver<WithTypename<Intakes_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Intakes_Max_Fields>, Record<string, never>, Scalars['Int'] | string>,
    include_ecopetrol_timestamp?: GraphCacheResolver<WithTypename<Intakes_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    include_koc_timestamp?: GraphCacheResolver<WithTypename<Intakes_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    inner_diameter_inches?: GraphCacheResolver<WithTypename<Intakes_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    intake_type?: GraphCacheResolver<WithTypename<Intakes_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    length_inches?: GraphCacheResolver<WithTypename<Intakes_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    manufacturer?: GraphCacheResolver<WithTypename<Intakes_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    max_rate_bpd?: GraphCacheResolver<WithTypename<Intakes_Max_Fields>, Record<string, never>, Scalars['Int'] | string>,
    neck_inner_diameter_inches?: GraphCacheResolver<WithTypename<Intakes_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    neck_outer_diameter_inches?: GraphCacheResolver<WithTypename<Intakes_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    only_ecopetrol_timestamp?: GraphCacheResolver<WithTypename<Intakes_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    only_koc_timestamp?: GraphCacheResolver<WithTypename<Intakes_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    outer_diameter_inches?: GraphCacheResolver<WithTypename<Intakes_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    part_number?: GraphCacheResolver<WithTypename<Intakes_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    port_area_square_inches?: GraphCacheResolver<WithTypename<Intakes_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    prioritized_manufacturer?: GraphCacheResolver<WithTypename<Intakes_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    shaft_limit_hp?: GraphCacheResolver<WithTypename<Intakes_Max_Fields>, Record<string, never>, Scalars['Int'] | string>,
    shaft_material?: GraphCacheResolver<WithTypename<Intakes_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    stage_count?: GraphCacheResolver<WithTypename<Intakes_Max_Fields>, Record<string, never>, Scalars['Int'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Intakes_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    weight_pounds?: GraphCacheResolver<WithTypename<Intakes_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>
  },
  intakes_min_fields?: {
    author_id?: GraphCacheResolver<WithTypename<Intakes_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    bhp0?: GraphCacheResolver<WithTypename<Intakes_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    bhp1?: GraphCacheResolver<WithTypename<Intakes_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    bhp2?: GraphCacheResolver<WithTypename<Intakes_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    bhp3?: GraphCacheResolver<WithTypename<Intakes_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    bhp4?: GraphCacheResolver<WithTypename<Intakes_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    bhp5?: GraphCacheResolver<WithTypename<Intakes_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    configuration?: GraphCacheResolver<WithTypename<Intakes_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Intakes_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Intakes_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    eff1?: GraphCacheResolver<WithTypename<Intakes_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    eff2?: GraphCacheResolver<WithTypename<Intakes_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    high_strength_shaft_limit_hp?: GraphCacheResolver<WithTypename<Intakes_Min_Fields>, Record<string, never>, Scalars['Int'] | string>,
    housing_material?: GraphCacheResolver<WithTypename<Intakes_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    hp?: GraphCacheResolver<WithTypename<Intakes_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    id?: GraphCacheResolver<WithTypename<Intakes_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Intakes_Min_Fields>, Record<string, never>, Scalars['Int'] | string>,
    include_ecopetrol_timestamp?: GraphCacheResolver<WithTypename<Intakes_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    include_koc_timestamp?: GraphCacheResolver<WithTypename<Intakes_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    inner_diameter_inches?: GraphCacheResolver<WithTypename<Intakes_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    intake_type?: GraphCacheResolver<WithTypename<Intakes_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    length_inches?: GraphCacheResolver<WithTypename<Intakes_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    manufacturer?: GraphCacheResolver<WithTypename<Intakes_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    max_rate_bpd?: GraphCacheResolver<WithTypename<Intakes_Min_Fields>, Record<string, never>, Scalars['Int'] | string>,
    neck_inner_diameter_inches?: GraphCacheResolver<WithTypename<Intakes_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    neck_outer_diameter_inches?: GraphCacheResolver<WithTypename<Intakes_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    only_ecopetrol_timestamp?: GraphCacheResolver<WithTypename<Intakes_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    only_koc_timestamp?: GraphCacheResolver<WithTypename<Intakes_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    outer_diameter_inches?: GraphCacheResolver<WithTypename<Intakes_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    part_number?: GraphCacheResolver<WithTypename<Intakes_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    port_area_square_inches?: GraphCacheResolver<WithTypename<Intakes_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    prioritized_manufacturer?: GraphCacheResolver<WithTypename<Intakes_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    shaft_limit_hp?: GraphCacheResolver<WithTypename<Intakes_Min_Fields>, Record<string, never>, Scalars['Int'] | string>,
    shaft_material?: GraphCacheResolver<WithTypename<Intakes_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    stage_count?: GraphCacheResolver<WithTypename<Intakes_Min_Fields>, Record<string, never>, Scalars['Int'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Intakes_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    weight_pounds?: GraphCacheResolver<WithTypename<Intakes_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>
  },
  intakes_mutation_response?: {
    affected_rows?: GraphCacheResolver<WithTypename<Intakes_Mutation_Response>, Record<string, never>, Scalars['Int'] | string>,
    returning?: GraphCacheResolver<WithTypename<Intakes_Mutation_Response>, Record<string, never>, Array<WithTypename<Intakes> | string>>
  },
  intakes_stddev_fields?: {
    bhp0?: GraphCacheResolver<WithTypename<Intakes_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bhp1?: GraphCacheResolver<WithTypename<Intakes_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bhp2?: GraphCacheResolver<WithTypename<Intakes_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bhp3?: GraphCacheResolver<WithTypename<Intakes_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bhp4?: GraphCacheResolver<WithTypename<Intakes_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bhp5?: GraphCacheResolver<WithTypename<Intakes_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    eff1?: GraphCacheResolver<WithTypename<Intakes_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    eff2?: GraphCacheResolver<WithTypename<Intakes_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    high_strength_shaft_limit_hp?: GraphCacheResolver<WithTypename<Intakes_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    hp?: GraphCacheResolver<WithTypename<Intakes_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Intakes_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    inner_diameter_inches?: GraphCacheResolver<WithTypename<Intakes_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    length_inches?: GraphCacheResolver<WithTypename<Intakes_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    max_rate_bpd?: GraphCacheResolver<WithTypename<Intakes_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    neck_inner_diameter_inches?: GraphCacheResolver<WithTypename<Intakes_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    neck_outer_diameter_inches?: GraphCacheResolver<WithTypename<Intakes_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    outer_diameter_inches?: GraphCacheResolver<WithTypename<Intakes_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    port_area_square_inches?: GraphCacheResolver<WithTypename<Intakes_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    shaft_limit_hp?: GraphCacheResolver<WithTypename<Intakes_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    stage_count?: GraphCacheResolver<WithTypename<Intakes_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    weight_pounds?: GraphCacheResolver<WithTypename<Intakes_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  intakes_stddev_pop_fields?: {
    bhp0?: GraphCacheResolver<WithTypename<Intakes_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bhp1?: GraphCacheResolver<WithTypename<Intakes_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bhp2?: GraphCacheResolver<WithTypename<Intakes_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bhp3?: GraphCacheResolver<WithTypename<Intakes_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bhp4?: GraphCacheResolver<WithTypename<Intakes_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bhp5?: GraphCacheResolver<WithTypename<Intakes_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    eff1?: GraphCacheResolver<WithTypename<Intakes_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    eff2?: GraphCacheResolver<WithTypename<Intakes_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    high_strength_shaft_limit_hp?: GraphCacheResolver<WithTypename<Intakes_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    hp?: GraphCacheResolver<WithTypename<Intakes_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Intakes_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    inner_diameter_inches?: GraphCacheResolver<WithTypename<Intakes_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    length_inches?: GraphCacheResolver<WithTypename<Intakes_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    max_rate_bpd?: GraphCacheResolver<WithTypename<Intakes_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    neck_inner_diameter_inches?: GraphCacheResolver<WithTypename<Intakes_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    neck_outer_diameter_inches?: GraphCacheResolver<WithTypename<Intakes_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    outer_diameter_inches?: GraphCacheResolver<WithTypename<Intakes_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    port_area_square_inches?: GraphCacheResolver<WithTypename<Intakes_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    shaft_limit_hp?: GraphCacheResolver<WithTypename<Intakes_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    stage_count?: GraphCacheResolver<WithTypename<Intakes_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    weight_pounds?: GraphCacheResolver<WithTypename<Intakes_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  intakes_stddev_samp_fields?: {
    bhp0?: GraphCacheResolver<WithTypename<Intakes_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bhp1?: GraphCacheResolver<WithTypename<Intakes_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bhp2?: GraphCacheResolver<WithTypename<Intakes_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bhp3?: GraphCacheResolver<WithTypename<Intakes_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bhp4?: GraphCacheResolver<WithTypename<Intakes_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bhp5?: GraphCacheResolver<WithTypename<Intakes_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    eff1?: GraphCacheResolver<WithTypename<Intakes_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    eff2?: GraphCacheResolver<WithTypename<Intakes_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    high_strength_shaft_limit_hp?: GraphCacheResolver<WithTypename<Intakes_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    hp?: GraphCacheResolver<WithTypename<Intakes_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Intakes_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    inner_diameter_inches?: GraphCacheResolver<WithTypename<Intakes_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    length_inches?: GraphCacheResolver<WithTypename<Intakes_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    max_rate_bpd?: GraphCacheResolver<WithTypename<Intakes_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    neck_inner_diameter_inches?: GraphCacheResolver<WithTypename<Intakes_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    neck_outer_diameter_inches?: GraphCacheResolver<WithTypename<Intakes_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    outer_diameter_inches?: GraphCacheResolver<WithTypename<Intakes_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    port_area_square_inches?: GraphCacheResolver<WithTypename<Intakes_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    shaft_limit_hp?: GraphCacheResolver<WithTypename<Intakes_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    stage_count?: GraphCacheResolver<WithTypename<Intakes_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    weight_pounds?: GraphCacheResolver<WithTypename<Intakes_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  intakes_sum_fields?: {
    bhp0?: GraphCacheResolver<WithTypename<Intakes_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    bhp1?: GraphCacheResolver<WithTypename<Intakes_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    bhp2?: GraphCacheResolver<WithTypename<Intakes_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    bhp3?: GraphCacheResolver<WithTypename<Intakes_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    bhp4?: GraphCacheResolver<WithTypename<Intakes_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    bhp5?: GraphCacheResolver<WithTypename<Intakes_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    eff1?: GraphCacheResolver<WithTypename<Intakes_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    eff2?: GraphCacheResolver<WithTypename<Intakes_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    high_strength_shaft_limit_hp?: GraphCacheResolver<WithTypename<Intakes_Sum_Fields>, Record<string, never>, Scalars['Int'] | string>,
    hp?: GraphCacheResolver<WithTypename<Intakes_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Intakes_Sum_Fields>, Record<string, never>, Scalars['Int'] | string>,
    inner_diameter_inches?: GraphCacheResolver<WithTypename<Intakes_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    length_inches?: GraphCacheResolver<WithTypename<Intakes_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    max_rate_bpd?: GraphCacheResolver<WithTypename<Intakes_Sum_Fields>, Record<string, never>, Scalars['Int'] | string>,
    neck_inner_diameter_inches?: GraphCacheResolver<WithTypename<Intakes_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    neck_outer_diameter_inches?: GraphCacheResolver<WithTypename<Intakes_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    outer_diameter_inches?: GraphCacheResolver<WithTypename<Intakes_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    port_area_square_inches?: GraphCacheResolver<WithTypename<Intakes_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    shaft_limit_hp?: GraphCacheResolver<WithTypename<Intakes_Sum_Fields>, Record<string, never>, Scalars['Int'] | string>,
    stage_count?: GraphCacheResolver<WithTypename<Intakes_Sum_Fields>, Record<string, never>, Scalars['Int'] | string>,
    weight_pounds?: GraphCacheResolver<WithTypename<Intakes_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>
  },
  intakes_var_pop_fields?: {
    bhp0?: GraphCacheResolver<WithTypename<Intakes_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bhp1?: GraphCacheResolver<WithTypename<Intakes_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bhp2?: GraphCacheResolver<WithTypename<Intakes_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bhp3?: GraphCacheResolver<WithTypename<Intakes_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bhp4?: GraphCacheResolver<WithTypename<Intakes_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bhp5?: GraphCacheResolver<WithTypename<Intakes_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    eff1?: GraphCacheResolver<WithTypename<Intakes_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    eff2?: GraphCacheResolver<WithTypename<Intakes_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    high_strength_shaft_limit_hp?: GraphCacheResolver<WithTypename<Intakes_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    hp?: GraphCacheResolver<WithTypename<Intakes_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Intakes_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    inner_diameter_inches?: GraphCacheResolver<WithTypename<Intakes_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    length_inches?: GraphCacheResolver<WithTypename<Intakes_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    max_rate_bpd?: GraphCacheResolver<WithTypename<Intakes_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    neck_inner_diameter_inches?: GraphCacheResolver<WithTypename<Intakes_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    neck_outer_diameter_inches?: GraphCacheResolver<WithTypename<Intakes_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    outer_diameter_inches?: GraphCacheResolver<WithTypename<Intakes_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    port_area_square_inches?: GraphCacheResolver<WithTypename<Intakes_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    shaft_limit_hp?: GraphCacheResolver<WithTypename<Intakes_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    stage_count?: GraphCacheResolver<WithTypename<Intakes_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    weight_pounds?: GraphCacheResolver<WithTypename<Intakes_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  intakes_var_samp_fields?: {
    bhp0?: GraphCacheResolver<WithTypename<Intakes_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bhp1?: GraphCacheResolver<WithTypename<Intakes_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bhp2?: GraphCacheResolver<WithTypename<Intakes_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bhp3?: GraphCacheResolver<WithTypename<Intakes_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bhp4?: GraphCacheResolver<WithTypename<Intakes_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bhp5?: GraphCacheResolver<WithTypename<Intakes_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    eff1?: GraphCacheResolver<WithTypename<Intakes_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    eff2?: GraphCacheResolver<WithTypename<Intakes_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    high_strength_shaft_limit_hp?: GraphCacheResolver<WithTypename<Intakes_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    hp?: GraphCacheResolver<WithTypename<Intakes_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Intakes_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    inner_diameter_inches?: GraphCacheResolver<WithTypename<Intakes_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    length_inches?: GraphCacheResolver<WithTypename<Intakes_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    max_rate_bpd?: GraphCacheResolver<WithTypename<Intakes_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    neck_inner_diameter_inches?: GraphCacheResolver<WithTypename<Intakes_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    neck_outer_diameter_inches?: GraphCacheResolver<WithTypename<Intakes_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    outer_diameter_inches?: GraphCacheResolver<WithTypename<Intakes_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    port_area_square_inches?: GraphCacheResolver<WithTypename<Intakes_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    shaft_limit_hp?: GraphCacheResolver<WithTypename<Intakes_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    stage_count?: GraphCacheResolver<WithTypename<Intakes_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    weight_pounds?: GraphCacheResolver<WithTypename<Intakes_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  intakes_variance_fields?: {
    bhp0?: GraphCacheResolver<WithTypename<Intakes_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bhp1?: GraphCacheResolver<WithTypename<Intakes_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bhp2?: GraphCacheResolver<WithTypename<Intakes_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bhp3?: GraphCacheResolver<WithTypename<Intakes_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bhp4?: GraphCacheResolver<WithTypename<Intakes_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bhp5?: GraphCacheResolver<WithTypename<Intakes_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    eff1?: GraphCacheResolver<WithTypename<Intakes_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    eff2?: GraphCacheResolver<WithTypename<Intakes_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    high_strength_shaft_limit_hp?: GraphCacheResolver<WithTypename<Intakes_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    hp?: GraphCacheResolver<WithTypename<Intakes_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Intakes_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    inner_diameter_inches?: GraphCacheResolver<WithTypename<Intakes_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    length_inches?: GraphCacheResolver<WithTypename<Intakes_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    max_rate_bpd?: GraphCacheResolver<WithTypename<Intakes_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    neck_inner_diameter_inches?: GraphCacheResolver<WithTypename<Intakes_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    neck_outer_diameter_inches?: GraphCacheResolver<WithTypename<Intakes_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    outer_diameter_inches?: GraphCacheResolver<WithTypename<Intakes_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    port_area_square_inches?: GraphCacheResolver<WithTypename<Intakes_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    shaft_limit_hp?: GraphCacheResolver<WithTypename<Intakes_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    stage_count?: GraphCacheResolver<WithTypename<Intakes_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    weight_pounds?: GraphCacheResolver<WithTypename<Intakes_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  legacy_users?: {
    display_name?: GraphCacheResolver<WithTypename<Legacy_Users>, Record<string, never>, Scalars['String'] | string>,
    email?: GraphCacheResolver<WithTypename<Legacy_Users>, Record<string, never>, Scalars['String'] | string>,
    hal_identifier?: GraphCacheResolver<WithTypename<Legacy_Users>, Record<string, never>, Scalars['String'] | string>,
    sizing_imports?: GraphCacheResolver<WithTypename<Legacy_Users>, Legacy_UsersSizing_ImportsArgs, Array<WithTypename<Sizing_Imports> | string>>,
    sizing_imports_aggregate?: GraphCacheResolver<WithTypename<Legacy_Users>, Legacy_UsersSizing_Imports_AggregateArgs, WithTypename<Sizing_Imports_Aggregate> | string>
  },
  legacy_users_aggregate?: {
    aggregate?: GraphCacheResolver<WithTypename<Legacy_Users_Aggregate>, Record<string, never>, WithTypename<Legacy_Users_Aggregate_Fields> | string>,
    nodes?: GraphCacheResolver<WithTypename<Legacy_Users_Aggregate>, Record<string, never>, Array<WithTypename<Legacy_Users> | string>>
  },
  legacy_users_aggregate_fields?: {
    count?: GraphCacheResolver<WithTypename<Legacy_Users_Aggregate_Fields>, Legacy_Users_Aggregate_FieldsCountArgs, Scalars['Int'] | string>,
    max?: GraphCacheResolver<WithTypename<Legacy_Users_Aggregate_Fields>, Record<string, never>, WithTypename<Legacy_Users_Max_Fields> | string>,
    min?: GraphCacheResolver<WithTypename<Legacy_Users_Aggregate_Fields>, Record<string, never>, WithTypename<Legacy_Users_Min_Fields> | string>
  },
  legacy_users_max_fields?: {
    display_name?: GraphCacheResolver<WithTypename<Legacy_Users_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    email?: GraphCacheResolver<WithTypename<Legacy_Users_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    hal_identifier?: GraphCacheResolver<WithTypename<Legacy_Users_Max_Fields>, Record<string, never>, Scalars['String'] | string>
  },
  legacy_users_min_fields?: {
    display_name?: GraphCacheResolver<WithTypename<Legacy_Users_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    email?: GraphCacheResolver<WithTypename<Legacy_Users_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    hal_identifier?: GraphCacheResolver<WithTypename<Legacy_Users_Min_Fields>, Record<string, never>, Scalars['String'] | string>
  },
  legacy_users_mutation_response?: {
    affected_rows?: GraphCacheResolver<WithTypename<Legacy_Users_Mutation_Response>, Record<string, never>, Scalars['Int'] | string>,
    returning?: GraphCacheResolver<WithTypename<Legacy_Users_Mutation_Response>, Record<string, never>, Array<WithTypename<Legacy_Users> | string>>
  },
  motor_lead_extensions?: {
    amp_factor?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions>, Record<string, never>, Scalars['numeric'] | string>,
    author_id?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions>, Record<string, never>, Scalars['String'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions>, Record<string, never>, Scalars['timestamptz'] | string>,
    depth_inches?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions>, Record<string, never>, Scalars['numeric'] | string>,
    family?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions>, Record<string, never>, Scalars['String'] | string>,
    gauge?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions>, Record<string, never>, Scalars['Int'] | string>,
    id?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions>, Record<string, never>, Scalars['uuid'] | string>,
    impedance_60_hz_per_1000_ft?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions>, Record<string, never>, Scalars['numeric'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions>, Record<string, never>, Scalars['Int'] | string>,
    include_ecopetrol_timestamp?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions>, Record<string, never>, Scalars['timestamptz'] | string>,
    include_koc_timestamp?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions>, Record<string, never>, Scalars['timestamptz'] | string>,
    kv?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions>, Record<string, never>, Scalars['Int'] | string>,
    length_feet?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions>, Record<string, never>, Scalars['numeric'] | string>,
    manufacturer?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions>, Record<string, never>, Scalars['String'] | string>,
    max_pothead_temperature_fahrenheit?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions>, Record<string, never>, Scalars['Int'] | string>,
    max_temperature_fahrenheit?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions>, Record<string, never>, Scalars['Int'] | string>,
    only_ecopetrol_timestamp?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions>, Record<string, never>, Scalars['timestamptz'] | string>,
    only_koc_timestamp?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions>, Record<string, never>, Scalars['timestamptz'] | string>,
    part_number?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions>, Record<string, never>, Scalars['String'] | string>,
    pound_per_foot?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions>, Record<string, never>, Scalars['numeric'] | string>,
    prioritized_manufacturer?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions>, Record<string, never>, Scalars['String'] | string>,
    resistance_per_1000_ft?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions>, Record<string, never>, Scalars['numeric'] | string>,
    series?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions>, Record<string, never>, Scalars['Int'] | string>,
    sizing_import?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions>, Record<string, never>, WithTypename<Sizing_Imports> | string>,
    updated_at?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions>, Record<string, never>, Scalars['timestamptz'] | string>,
    user?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions>, Record<string, never>, WithTypename<Users> | string>,
    width_inches?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions>, Record<string, never>, Scalars['numeric'] | string>
  },
  motor_lead_extensions_aggregate?: {
    aggregate?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Aggregate>, Record<string, never>, WithTypename<Motor_Lead_Extensions_Aggregate_Fields> | string>,
    nodes?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Aggregate>, Record<string, never>, Array<WithTypename<Motor_Lead_Extensions> | string>>
  },
  motor_lead_extensions_aggregate_fields?: {
    avg?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Aggregate_Fields>, Record<string, never>, WithTypename<Motor_Lead_Extensions_Avg_Fields> | string>,
    count?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Aggregate_Fields>, Motor_Lead_Extensions_Aggregate_FieldsCountArgs, Scalars['Int'] | string>,
    max?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Aggregate_Fields>, Record<string, never>, WithTypename<Motor_Lead_Extensions_Max_Fields> | string>,
    min?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Aggregate_Fields>, Record<string, never>, WithTypename<Motor_Lead_Extensions_Min_Fields> | string>,
    stddev?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Aggregate_Fields>, Record<string, never>, WithTypename<Motor_Lead_Extensions_Stddev_Fields> | string>,
    stddev_pop?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Aggregate_Fields>, Record<string, never>, WithTypename<Motor_Lead_Extensions_Stddev_Pop_Fields> | string>,
    stddev_samp?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Aggregate_Fields>, Record<string, never>, WithTypename<Motor_Lead_Extensions_Stddev_Samp_Fields> | string>,
    sum?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Aggregate_Fields>, Record<string, never>, WithTypename<Motor_Lead_Extensions_Sum_Fields> | string>,
    var_pop?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Aggregate_Fields>, Record<string, never>, WithTypename<Motor_Lead_Extensions_Var_Pop_Fields> | string>,
    var_samp?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Aggregate_Fields>, Record<string, never>, WithTypename<Motor_Lead_Extensions_Var_Samp_Fields> | string>,
    variance?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Aggregate_Fields>, Record<string, never>, WithTypename<Motor_Lead_Extensions_Variance_Fields> | string>
  },
  motor_lead_extensions_avg_fields?: {
    amp_factor?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    depth_inches?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    gauge?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    impedance_60_hz_per_1000_ft?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    kv?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    length_feet?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    max_pothead_temperature_fahrenheit?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    max_temperature_fahrenheit?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pound_per_foot?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    resistance_per_1000_ft?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    series?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    width_inches?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  motor_lead_extensions_max_fields?: {
    amp_factor?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    author_id?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    depth_inches?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    family?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    gauge?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Max_Fields>, Record<string, never>, Scalars['Int'] | string>,
    id?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    impedance_60_hz_per_1000_ft?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Max_Fields>, Record<string, never>, Scalars['Int'] | string>,
    include_ecopetrol_timestamp?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    include_koc_timestamp?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    kv?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Max_Fields>, Record<string, never>, Scalars['Int'] | string>,
    length_feet?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    manufacturer?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    max_pothead_temperature_fahrenheit?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Max_Fields>, Record<string, never>, Scalars['Int'] | string>,
    max_temperature_fahrenheit?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Max_Fields>, Record<string, never>, Scalars['Int'] | string>,
    only_ecopetrol_timestamp?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    only_koc_timestamp?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    part_number?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    pound_per_foot?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    prioritized_manufacturer?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    resistance_per_1000_ft?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    series?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Max_Fields>, Record<string, never>, Scalars['Int'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    width_inches?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>
  },
  motor_lead_extensions_min_fields?: {
    amp_factor?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    author_id?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    depth_inches?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    family?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    gauge?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Min_Fields>, Record<string, never>, Scalars['Int'] | string>,
    id?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    impedance_60_hz_per_1000_ft?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Min_Fields>, Record<string, never>, Scalars['Int'] | string>,
    include_ecopetrol_timestamp?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    include_koc_timestamp?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    kv?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Min_Fields>, Record<string, never>, Scalars['Int'] | string>,
    length_feet?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    manufacturer?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    max_pothead_temperature_fahrenheit?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Min_Fields>, Record<string, never>, Scalars['Int'] | string>,
    max_temperature_fahrenheit?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Min_Fields>, Record<string, never>, Scalars['Int'] | string>,
    only_ecopetrol_timestamp?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    only_koc_timestamp?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    part_number?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    pound_per_foot?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    prioritized_manufacturer?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    resistance_per_1000_ft?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    series?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Min_Fields>, Record<string, never>, Scalars['Int'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    width_inches?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>
  },
  motor_lead_extensions_mutation_response?: {
    affected_rows?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Mutation_Response>, Record<string, never>, Scalars['Int'] | string>,
    returning?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Mutation_Response>, Record<string, never>, Array<WithTypename<Motor_Lead_Extensions> | string>>
  },
  motor_lead_extensions_stddev_fields?: {
    amp_factor?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    depth_inches?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    gauge?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    impedance_60_hz_per_1000_ft?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    kv?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    length_feet?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    max_pothead_temperature_fahrenheit?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    max_temperature_fahrenheit?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pound_per_foot?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    resistance_per_1000_ft?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    series?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    width_inches?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  motor_lead_extensions_stddev_pop_fields?: {
    amp_factor?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    depth_inches?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    gauge?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    impedance_60_hz_per_1000_ft?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    kv?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    length_feet?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    max_pothead_temperature_fahrenheit?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    max_temperature_fahrenheit?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pound_per_foot?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    resistance_per_1000_ft?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    series?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    width_inches?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  motor_lead_extensions_stddev_samp_fields?: {
    amp_factor?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    depth_inches?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    gauge?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    impedance_60_hz_per_1000_ft?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    kv?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    length_feet?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    max_pothead_temperature_fahrenheit?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    max_temperature_fahrenheit?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pound_per_foot?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    resistance_per_1000_ft?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    series?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    width_inches?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  motor_lead_extensions_sum_fields?: {
    amp_factor?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    depth_inches?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    gauge?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Sum_Fields>, Record<string, never>, Scalars['Int'] | string>,
    impedance_60_hz_per_1000_ft?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Sum_Fields>, Record<string, never>, Scalars['Int'] | string>,
    kv?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Sum_Fields>, Record<string, never>, Scalars['Int'] | string>,
    length_feet?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    max_pothead_temperature_fahrenheit?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Sum_Fields>, Record<string, never>, Scalars['Int'] | string>,
    max_temperature_fahrenheit?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Sum_Fields>, Record<string, never>, Scalars['Int'] | string>,
    pound_per_foot?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    resistance_per_1000_ft?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    series?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Sum_Fields>, Record<string, never>, Scalars['Int'] | string>,
    width_inches?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>
  },
  motor_lead_extensions_var_pop_fields?: {
    amp_factor?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    depth_inches?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    gauge?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    impedance_60_hz_per_1000_ft?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    kv?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    length_feet?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    max_pothead_temperature_fahrenheit?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    max_temperature_fahrenheit?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pound_per_foot?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    resistance_per_1000_ft?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    series?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    width_inches?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  motor_lead_extensions_var_samp_fields?: {
    amp_factor?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    depth_inches?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    gauge?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    impedance_60_hz_per_1000_ft?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    kv?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    length_feet?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    max_pothead_temperature_fahrenheit?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    max_temperature_fahrenheit?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pound_per_foot?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    resistance_per_1000_ft?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    series?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    width_inches?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  motor_lead_extensions_variance_fields?: {
    amp_factor?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    depth_inches?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    gauge?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    impedance_60_hz_per_1000_ft?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    kv?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    length_feet?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    max_pothead_temperature_fahrenheit?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    max_temperature_fahrenheit?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pound_per_foot?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    resistance_per_1000_ft?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    series?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    width_inches?: GraphCacheResolver<WithTypename<Motor_Lead_Extensions_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  motors?: {
    allow_rerate?: GraphCacheResolver<WithTypename<Motors>, Record<string, never>, Scalars['Boolean'] | string>,
    author_id?: GraphCacheResolver<WithTypename<Motors>, Record<string, never>, Scalars['String'] | string>,
    configuration?: GraphCacheResolver<WithTypename<Motors>, Record<string, never>, Scalars['String'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Motors>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Motors>, Record<string, never>, Scalars['timestamptz'] | string>,
    eff1?: GraphCacheResolver<WithTypename<Motors>, Record<string, never>, Scalars['numeric'] | string>,
    eff2?: GraphCacheResolver<WithTypename<Motors>, Record<string, never>, Scalars['numeric'] | string>,
    eff3?: GraphCacheResolver<WithTypename<Motors>, Record<string, never>, Scalars['numeric'] | string>,
    eff4?: GraphCacheResolver<WithTypename<Motors>, Record<string, never>, Scalars['numeric'] | string>,
    eff5?: GraphCacheResolver<WithTypename<Motors>, Record<string, never>, Scalars['numeric'] | string>,
    effb?: GraphCacheResolver<WithTypename<Motors>, Record<string, never>, Scalars['numeric'] | string>,
    effv0?: GraphCacheResolver<WithTypename<Motors>, Record<string, never>, Scalars['numeric'] | string>,
    effv1?: GraphCacheResolver<WithTypename<Motors>, Record<string, never>, Scalars['numeric'] | string>,
    effv2?: GraphCacheResolver<WithTypename<Motors>, Record<string, never>, Scalars['numeric'] | string>,
    i1?: GraphCacheResolver<WithTypename<Motors>, Record<string, never>, Scalars['numeric'] | string>,
    i2?: GraphCacheResolver<WithTypename<Motors>, Record<string, never>, Scalars['numeric'] | string>,
    i3?: GraphCacheResolver<WithTypename<Motors>, Record<string, never>, Scalars['numeric'] | string>,
    i4?: GraphCacheResolver<WithTypename<Motors>, Record<string, never>, Scalars['numeric'] | string>,
    i5?: GraphCacheResolver<WithTypename<Motors>, Record<string, never>, Scalars['numeric'] | string>,
    ib?: GraphCacheResolver<WithTypename<Motors>, Record<string, never>, Scalars['numeric'] | string>,
    id?: GraphCacheResolver<WithTypename<Motors>, Record<string, never>, Scalars['uuid'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Motors>, Record<string, never>, Scalars['Int'] | string>,
    include_ecopetrol_timestamp?: GraphCacheResolver<WithTypename<Motors>, Record<string, never>, Scalars['timestamptz'] | string>,
    include_koc_timestamp?: GraphCacheResolver<WithTypename<Motors>, Record<string, never>, Scalars['timestamptz'] | string>,
    inner_diameter_inches?: GraphCacheResolver<WithTypename<Motors>, Record<string, never>, Scalars['numeric'] | string>,
    is_hps?: GraphCacheResolver<WithTypename<Motors>, Record<string, never>, Scalars['Boolean'] | string>,
    iv0?: GraphCacheResolver<WithTypename<Motors>, Record<string, never>, Scalars['numeric'] | string>,
    iv1?: GraphCacheResolver<WithTypename<Motors>, Record<string, never>, Scalars['numeric'] | string>,
    iv2?: GraphCacheResolver<WithTypename<Motors>, Record<string, never>, Scalars['numeric'] | string>,
    k3?: GraphCacheResolver<WithTypename<Motors>, Record<string, never>, Scalars['numeric'] | string>,
    length_inches?: GraphCacheResolver<WithTypename<Motors>, Record<string, never>, Scalars['numeric'] | string>,
    manufacturer?: GraphCacheResolver<WithTypename<Motors>, Record<string, never>, Scalars['String'] | string>,
    mle_offset_depth_inches?: GraphCacheResolver<WithTypename<Motors>, Record<string, never>, Scalars['numeric'] | string>,
    n1?: GraphCacheResolver<WithTypename<Motors>, Record<string, never>, Scalars['numeric'] | string>,
    n2?: GraphCacheResolver<WithTypename<Motors>, Record<string, never>, Scalars['numeric'] | string>,
    n3?: GraphCacheResolver<WithTypename<Motors>, Record<string, never>, Scalars['numeric'] | string>,
    n4?: GraphCacheResolver<WithTypename<Motors>, Record<string, never>, Scalars['numeric'] | string>,
    n5?: GraphCacheResolver<WithTypename<Motors>, Record<string, never>, Scalars['numeric'] | string>,
    nameplate_current?: GraphCacheResolver<WithTypename<Motors>, Record<string, never>, Scalars['Int'] | string>,
    nameplate_horsepower?: GraphCacheResolver<WithTypename<Motors>, Record<string, never>, Scalars['Int'] | string>,
    nameplate_rerate_ratio?: GraphCacheResolver<WithTypename<Motors>, Record<string, never>, Scalars['numeric'] | string>,
    nameplate_voltage?: GraphCacheResolver<WithTypename<Motors>, Record<string, never>, Scalars['Int'] | string>,
    nb?: GraphCacheResolver<WithTypename<Motors>, Record<string, never>, Scalars['numeric'] | string>,
    neck_inner_diameter_inches?: GraphCacheResolver<WithTypename<Motors>, Record<string, never>, Scalars['numeric'] | string>,
    neck_outer_diameter_inches?: GraphCacheResolver<WithTypename<Motors>, Record<string, never>, Scalars['numeric'] | string>,
    nv0?: GraphCacheResolver<WithTypename<Motors>, Record<string, never>, Scalars['numeric'] | string>,
    nv1?: GraphCacheResolver<WithTypename<Motors>, Record<string, never>, Scalars['numeric'] | string>,
    nv2?: GraphCacheResolver<WithTypename<Motors>, Record<string, never>, Scalars['numeric'] | string>,
    oil_volume_gallons?: GraphCacheResolver<WithTypename<Motors>, Record<string, never>, Scalars['numeric'] | string>,
    only_ecopetrol_timestamp?: GraphCacheResolver<WithTypename<Motors>, Record<string, never>, Scalars['timestamptz'] | string>,
    only_koc_timestamp?: GraphCacheResolver<WithTypename<Motors>, Record<string, never>, Scalars['timestamptz'] | string>,
    outer_diameter_inches?: GraphCacheResolver<WithTypename<Motors>, Record<string, never>, Scalars['numeric'] | string>,
    outer_diameter_rub_inches?: GraphCacheResolver<WithTypename<Motors>, Record<string, never>, Scalars['numeric'] | string>,
    part_number?: GraphCacheResolver<WithTypename<Motors>, Record<string, never>, Scalars['String'] | string>,
    pf1?: GraphCacheResolver<WithTypename<Motors>, Record<string, never>, Scalars['numeric'] | string>,
    pf2?: GraphCacheResolver<WithTypename<Motors>, Record<string, never>, Scalars['numeric'] | string>,
    pf3?: GraphCacheResolver<WithTypename<Motors>, Record<string, never>, Scalars['numeric'] | string>,
    pf4?: GraphCacheResolver<WithTypename<Motors>, Record<string, never>, Scalars['numeric'] | string>,
    pf5?: GraphCacheResolver<WithTypename<Motors>, Record<string, never>, Scalars['numeric'] | string>,
    pfb?: GraphCacheResolver<WithTypename<Motors>, Record<string, never>, Scalars['numeric'] | string>,
    pfv0?: GraphCacheResolver<WithTypename<Motors>, Record<string, never>, Scalars['numeric'] | string>,
    pfv1?: GraphCacheResolver<WithTypename<Motors>, Record<string, never>, Scalars['numeric'] | string>,
    pfv2?: GraphCacheResolver<WithTypename<Motors>, Record<string, never>, Scalars['numeric'] | string>,
    poles?: GraphCacheResolver<WithTypename<Motors>, Record<string, never>, Scalars['Int'] | string>,
    prioritized_manufacturer?: GraphCacheResolver<WithTypename<Motors>, Record<string, never>, Scalars['String'] | string>,
    rr_l1?: GraphCacheResolver<WithTypename<Motors>, Record<string, never>, Scalars['numeric'] | string>,
    rr_l2?: GraphCacheResolver<WithTypename<Motors>, Record<string, never>, Scalars['numeric'] | string>,
    rr_lb?: GraphCacheResolver<WithTypename<Motors>, Record<string, never>, Scalars['numeric'] | string>,
    rr_v1?: GraphCacheResolver<WithTypename<Motors>, Record<string, never>, Scalars['numeric'] | string>,
    rr_v2?: GraphCacheResolver<WithTypename<Motors>, Record<string, never>, Scalars['numeric'] | string>,
    rr_v3?: GraphCacheResolver<WithTypename<Motors>, Record<string, never>, Scalars['numeric'] | string>,
    rr_vb?: GraphCacheResolver<WithTypename<Motors>, Record<string, never>, Scalars['numeric'] | string>,
    shaft_height_inches?: GraphCacheResolver<WithTypename<Motors>, Record<string, never>, Scalars['numeric'] | string>,
    shaft_horsepower?: GraphCacheResolver<WithTypename<Motors>, Record<string, never>, Scalars['Int'] | string>,
    sizing_import?: GraphCacheResolver<WithTypename<Motors>, Record<string, never>, WithTypename<Sizing_Imports> | string>,
    stator_inner_diameter_inches?: GraphCacheResolver<WithTypename<Motors>, Record<string, never>, Scalars['numeric'] | string>,
    stator_outer_diameter_inches?: GraphCacheResolver<WithTypename<Motors>, Record<string, never>, Scalars['numeric'] | string>,
    temperature_rating_fahrenheit?: GraphCacheResolver<WithTypename<Motors>, Record<string, never>, Scalars['Int'] | string>,
    tv0?: GraphCacheResolver<WithTypename<Motors>, Record<string, never>, Scalars['numeric'] | string>,
    tv1?: GraphCacheResolver<WithTypename<Motors>, Record<string, never>, Scalars['numeric'] | string>,
    tv2?: GraphCacheResolver<WithTypename<Motors>, Record<string, never>, Scalars['numeric'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Motors>, Record<string, never>, Scalars['timestamptz'] | string>,
    user?: GraphCacheResolver<WithTypename<Motors>, Record<string, never>, WithTypename<Users> | string>,
    weight_pounds?: GraphCacheResolver<WithTypename<Motors>, Record<string, never>, Scalars['numeric'] | string>
  },
  motors_aggregate?: {
    aggregate?: GraphCacheResolver<WithTypename<Motors_Aggregate>, Record<string, never>, WithTypename<Motors_Aggregate_Fields> | string>,
    nodes?: GraphCacheResolver<WithTypename<Motors_Aggregate>, Record<string, never>, Array<WithTypename<Motors> | string>>
  },
  motors_aggregate_fields?: {
    avg?: GraphCacheResolver<WithTypename<Motors_Aggregate_Fields>, Record<string, never>, WithTypename<Motors_Avg_Fields> | string>,
    count?: GraphCacheResolver<WithTypename<Motors_Aggregate_Fields>, Motors_Aggregate_FieldsCountArgs, Scalars['Int'] | string>,
    max?: GraphCacheResolver<WithTypename<Motors_Aggregate_Fields>, Record<string, never>, WithTypename<Motors_Max_Fields> | string>,
    min?: GraphCacheResolver<WithTypename<Motors_Aggregate_Fields>, Record<string, never>, WithTypename<Motors_Min_Fields> | string>,
    stddev?: GraphCacheResolver<WithTypename<Motors_Aggregate_Fields>, Record<string, never>, WithTypename<Motors_Stddev_Fields> | string>,
    stddev_pop?: GraphCacheResolver<WithTypename<Motors_Aggregate_Fields>, Record<string, never>, WithTypename<Motors_Stddev_Pop_Fields> | string>,
    stddev_samp?: GraphCacheResolver<WithTypename<Motors_Aggregate_Fields>, Record<string, never>, WithTypename<Motors_Stddev_Samp_Fields> | string>,
    sum?: GraphCacheResolver<WithTypename<Motors_Aggregate_Fields>, Record<string, never>, WithTypename<Motors_Sum_Fields> | string>,
    var_pop?: GraphCacheResolver<WithTypename<Motors_Aggregate_Fields>, Record<string, never>, WithTypename<Motors_Var_Pop_Fields> | string>,
    var_samp?: GraphCacheResolver<WithTypename<Motors_Aggregate_Fields>, Record<string, never>, WithTypename<Motors_Var_Samp_Fields> | string>,
    variance?: GraphCacheResolver<WithTypename<Motors_Aggregate_Fields>, Record<string, never>, WithTypename<Motors_Variance_Fields> | string>
  },
  motors_avg_fields?: {
    eff1?: GraphCacheResolver<WithTypename<Motors_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    eff2?: GraphCacheResolver<WithTypename<Motors_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    eff3?: GraphCacheResolver<WithTypename<Motors_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    eff4?: GraphCacheResolver<WithTypename<Motors_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    eff5?: GraphCacheResolver<WithTypename<Motors_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    effb?: GraphCacheResolver<WithTypename<Motors_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    effv0?: GraphCacheResolver<WithTypename<Motors_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    effv1?: GraphCacheResolver<WithTypename<Motors_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    effv2?: GraphCacheResolver<WithTypename<Motors_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    i1?: GraphCacheResolver<WithTypename<Motors_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    i2?: GraphCacheResolver<WithTypename<Motors_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    i3?: GraphCacheResolver<WithTypename<Motors_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    i4?: GraphCacheResolver<WithTypename<Motors_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    i5?: GraphCacheResolver<WithTypename<Motors_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    ib?: GraphCacheResolver<WithTypename<Motors_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Motors_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    inner_diameter_inches?: GraphCacheResolver<WithTypename<Motors_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    iv0?: GraphCacheResolver<WithTypename<Motors_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    iv1?: GraphCacheResolver<WithTypename<Motors_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    iv2?: GraphCacheResolver<WithTypename<Motors_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    k3?: GraphCacheResolver<WithTypename<Motors_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    length_inches?: GraphCacheResolver<WithTypename<Motors_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    mle_offset_depth_inches?: GraphCacheResolver<WithTypename<Motors_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    n1?: GraphCacheResolver<WithTypename<Motors_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    n2?: GraphCacheResolver<WithTypename<Motors_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    n3?: GraphCacheResolver<WithTypename<Motors_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    n4?: GraphCacheResolver<WithTypename<Motors_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    n5?: GraphCacheResolver<WithTypename<Motors_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    nameplate_current?: GraphCacheResolver<WithTypename<Motors_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    nameplate_horsepower?: GraphCacheResolver<WithTypename<Motors_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    nameplate_rerate_ratio?: GraphCacheResolver<WithTypename<Motors_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    nameplate_voltage?: GraphCacheResolver<WithTypename<Motors_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    nb?: GraphCacheResolver<WithTypename<Motors_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    neck_inner_diameter_inches?: GraphCacheResolver<WithTypename<Motors_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    neck_outer_diameter_inches?: GraphCacheResolver<WithTypename<Motors_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    nv0?: GraphCacheResolver<WithTypename<Motors_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    nv1?: GraphCacheResolver<WithTypename<Motors_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    nv2?: GraphCacheResolver<WithTypename<Motors_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    oil_volume_gallons?: GraphCacheResolver<WithTypename<Motors_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    outer_diameter_inches?: GraphCacheResolver<WithTypename<Motors_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    outer_diameter_rub_inches?: GraphCacheResolver<WithTypename<Motors_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pf1?: GraphCacheResolver<WithTypename<Motors_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pf2?: GraphCacheResolver<WithTypename<Motors_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pf3?: GraphCacheResolver<WithTypename<Motors_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pf4?: GraphCacheResolver<WithTypename<Motors_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pf5?: GraphCacheResolver<WithTypename<Motors_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pfb?: GraphCacheResolver<WithTypename<Motors_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pfv0?: GraphCacheResolver<WithTypename<Motors_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pfv1?: GraphCacheResolver<WithTypename<Motors_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pfv2?: GraphCacheResolver<WithTypename<Motors_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    poles?: GraphCacheResolver<WithTypename<Motors_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    rr_l1?: GraphCacheResolver<WithTypename<Motors_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    rr_l2?: GraphCacheResolver<WithTypename<Motors_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    rr_lb?: GraphCacheResolver<WithTypename<Motors_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    rr_v1?: GraphCacheResolver<WithTypename<Motors_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    rr_v2?: GraphCacheResolver<WithTypename<Motors_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    rr_v3?: GraphCacheResolver<WithTypename<Motors_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    rr_vb?: GraphCacheResolver<WithTypename<Motors_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    shaft_height_inches?: GraphCacheResolver<WithTypename<Motors_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    shaft_horsepower?: GraphCacheResolver<WithTypename<Motors_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    stator_inner_diameter_inches?: GraphCacheResolver<WithTypename<Motors_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    stator_outer_diameter_inches?: GraphCacheResolver<WithTypename<Motors_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    temperature_rating_fahrenheit?: GraphCacheResolver<WithTypename<Motors_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    tv0?: GraphCacheResolver<WithTypename<Motors_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    tv1?: GraphCacheResolver<WithTypename<Motors_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    tv2?: GraphCacheResolver<WithTypename<Motors_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    weight_pounds?: GraphCacheResolver<WithTypename<Motors_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  motors_max_fields?: {
    author_id?: GraphCacheResolver<WithTypename<Motors_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    configuration?: GraphCacheResolver<WithTypename<Motors_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Motors_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Motors_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    eff1?: GraphCacheResolver<WithTypename<Motors_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    eff2?: GraphCacheResolver<WithTypename<Motors_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    eff3?: GraphCacheResolver<WithTypename<Motors_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    eff4?: GraphCacheResolver<WithTypename<Motors_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    eff5?: GraphCacheResolver<WithTypename<Motors_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    effb?: GraphCacheResolver<WithTypename<Motors_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    effv0?: GraphCacheResolver<WithTypename<Motors_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    effv1?: GraphCacheResolver<WithTypename<Motors_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    effv2?: GraphCacheResolver<WithTypename<Motors_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    i1?: GraphCacheResolver<WithTypename<Motors_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    i2?: GraphCacheResolver<WithTypename<Motors_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    i3?: GraphCacheResolver<WithTypename<Motors_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    i4?: GraphCacheResolver<WithTypename<Motors_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    i5?: GraphCacheResolver<WithTypename<Motors_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    ib?: GraphCacheResolver<WithTypename<Motors_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    id?: GraphCacheResolver<WithTypename<Motors_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Motors_Max_Fields>, Record<string, never>, Scalars['Int'] | string>,
    include_ecopetrol_timestamp?: GraphCacheResolver<WithTypename<Motors_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    include_koc_timestamp?: GraphCacheResolver<WithTypename<Motors_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    inner_diameter_inches?: GraphCacheResolver<WithTypename<Motors_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    iv0?: GraphCacheResolver<WithTypename<Motors_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    iv1?: GraphCacheResolver<WithTypename<Motors_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    iv2?: GraphCacheResolver<WithTypename<Motors_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    k3?: GraphCacheResolver<WithTypename<Motors_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    length_inches?: GraphCacheResolver<WithTypename<Motors_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    manufacturer?: GraphCacheResolver<WithTypename<Motors_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    mle_offset_depth_inches?: GraphCacheResolver<WithTypename<Motors_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    n1?: GraphCacheResolver<WithTypename<Motors_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    n2?: GraphCacheResolver<WithTypename<Motors_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    n3?: GraphCacheResolver<WithTypename<Motors_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    n4?: GraphCacheResolver<WithTypename<Motors_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    n5?: GraphCacheResolver<WithTypename<Motors_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    nameplate_current?: GraphCacheResolver<WithTypename<Motors_Max_Fields>, Record<string, never>, Scalars['Int'] | string>,
    nameplate_horsepower?: GraphCacheResolver<WithTypename<Motors_Max_Fields>, Record<string, never>, Scalars['Int'] | string>,
    nameplate_rerate_ratio?: GraphCacheResolver<WithTypename<Motors_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    nameplate_voltage?: GraphCacheResolver<WithTypename<Motors_Max_Fields>, Record<string, never>, Scalars['Int'] | string>,
    nb?: GraphCacheResolver<WithTypename<Motors_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    neck_inner_diameter_inches?: GraphCacheResolver<WithTypename<Motors_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    neck_outer_diameter_inches?: GraphCacheResolver<WithTypename<Motors_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    nv0?: GraphCacheResolver<WithTypename<Motors_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    nv1?: GraphCacheResolver<WithTypename<Motors_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    nv2?: GraphCacheResolver<WithTypename<Motors_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    oil_volume_gallons?: GraphCacheResolver<WithTypename<Motors_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    only_ecopetrol_timestamp?: GraphCacheResolver<WithTypename<Motors_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    only_koc_timestamp?: GraphCacheResolver<WithTypename<Motors_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    outer_diameter_inches?: GraphCacheResolver<WithTypename<Motors_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    outer_diameter_rub_inches?: GraphCacheResolver<WithTypename<Motors_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    part_number?: GraphCacheResolver<WithTypename<Motors_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    pf1?: GraphCacheResolver<WithTypename<Motors_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    pf2?: GraphCacheResolver<WithTypename<Motors_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    pf3?: GraphCacheResolver<WithTypename<Motors_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    pf4?: GraphCacheResolver<WithTypename<Motors_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    pf5?: GraphCacheResolver<WithTypename<Motors_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    pfb?: GraphCacheResolver<WithTypename<Motors_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    pfv0?: GraphCacheResolver<WithTypename<Motors_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    pfv1?: GraphCacheResolver<WithTypename<Motors_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    pfv2?: GraphCacheResolver<WithTypename<Motors_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    poles?: GraphCacheResolver<WithTypename<Motors_Max_Fields>, Record<string, never>, Scalars['Int'] | string>,
    prioritized_manufacturer?: GraphCacheResolver<WithTypename<Motors_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    rr_l1?: GraphCacheResolver<WithTypename<Motors_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    rr_l2?: GraphCacheResolver<WithTypename<Motors_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    rr_lb?: GraphCacheResolver<WithTypename<Motors_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    rr_v1?: GraphCacheResolver<WithTypename<Motors_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    rr_v2?: GraphCacheResolver<WithTypename<Motors_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    rr_v3?: GraphCacheResolver<WithTypename<Motors_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    rr_vb?: GraphCacheResolver<WithTypename<Motors_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    shaft_height_inches?: GraphCacheResolver<WithTypename<Motors_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    shaft_horsepower?: GraphCacheResolver<WithTypename<Motors_Max_Fields>, Record<string, never>, Scalars['Int'] | string>,
    stator_inner_diameter_inches?: GraphCacheResolver<WithTypename<Motors_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    stator_outer_diameter_inches?: GraphCacheResolver<WithTypename<Motors_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    temperature_rating_fahrenheit?: GraphCacheResolver<WithTypename<Motors_Max_Fields>, Record<string, never>, Scalars['Int'] | string>,
    tv0?: GraphCacheResolver<WithTypename<Motors_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    tv1?: GraphCacheResolver<WithTypename<Motors_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    tv2?: GraphCacheResolver<WithTypename<Motors_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Motors_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    weight_pounds?: GraphCacheResolver<WithTypename<Motors_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>
  },
  motors_min_fields?: {
    author_id?: GraphCacheResolver<WithTypename<Motors_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    configuration?: GraphCacheResolver<WithTypename<Motors_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Motors_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Motors_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    eff1?: GraphCacheResolver<WithTypename<Motors_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    eff2?: GraphCacheResolver<WithTypename<Motors_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    eff3?: GraphCacheResolver<WithTypename<Motors_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    eff4?: GraphCacheResolver<WithTypename<Motors_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    eff5?: GraphCacheResolver<WithTypename<Motors_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    effb?: GraphCacheResolver<WithTypename<Motors_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    effv0?: GraphCacheResolver<WithTypename<Motors_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    effv1?: GraphCacheResolver<WithTypename<Motors_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    effv2?: GraphCacheResolver<WithTypename<Motors_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    i1?: GraphCacheResolver<WithTypename<Motors_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    i2?: GraphCacheResolver<WithTypename<Motors_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    i3?: GraphCacheResolver<WithTypename<Motors_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    i4?: GraphCacheResolver<WithTypename<Motors_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    i5?: GraphCacheResolver<WithTypename<Motors_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    ib?: GraphCacheResolver<WithTypename<Motors_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    id?: GraphCacheResolver<WithTypename<Motors_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Motors_Min_Fields>, Record<string, never>, Scalars['Int'] | string>,
    include_ecopetrol_timestamp?: GraphCacheResolver<WithTypename<Motors_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    include_koc_timestamp?: GraphCacheResolver<WithTypename<Motors_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    inner_diameter_inches?: GraphCacheResolver<WithTypename<Motors_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    iv0?: GraphCacheResolver<WithTypename<Motors_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    iv1?: GraphCacheResolver<WithTypename<Motors_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    iv2?: GraphCacheResolver<WithTypename<Motors_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    k3?: GraphCacheResolver<WithTypename<Motors_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    length_inches?: GraphCacheResolver<WithTypename<Motors_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    manufacturer?: GraphCacheResolver<WithTypename<Motors_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    mle_offset_depth_inches?: GraphCacheResolver<WithTypename<Motors_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    n1?: GraphCacheResolver<WithTypename<Motors_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    n2?: GraphCacheResolver<WithTypename<Motors_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    n3?: GraphCacheResolver<WithTypename<Motors_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    n4?: GraphCacheResolver<WithTypename<Motors_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    n5?: GraphCacheResolver<WithTypename<Motors_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    nameplate_current?: GraphCacheResolver<WithTypename<Motors_Min_Fields>, Record<string, never>, Scalars['Int'] | string>,
    nameplate_horsepower?: GraphCacheResolver<WithTypename<Motors_Min_Fields>, Record<string, never>, Scalars['Int'] | string>,
    nameplate_rerate_ratio?: GraphCacheResolver<WithTypename<Motors_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    nameplate_voltage?: GraphCacheResolver<WithTypename<Motors_Min_Fields>, Record<string, never>, Scalars['Int'] | string>,
    nb?: GraphCacheResolver<WithTypename<Motors_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    neck_inner_diameter_inches?: GraphCacheResolver<WithTypename<Motors_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    neck_outer_diameter_inches?: GraphCacheResolver<WithTypename<Motors_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    nv0?: GraphCacheResolver<WithTypename<Motors_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    nv1?: GraphCacheResolver<WithTypename<Motors_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    nv2?: GraphCacheResolver<WithTypename<Motors_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    oil_volume_gallons?: GraphCacheResolver<WithTypename<Motors_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    only_ecopetrol_timestamp?: GraphCacheResolver<WithTypename<Motors_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    only_koc_timestamp?: GraphCacheResolver<WithTypename<Motors_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    outer_diameter_inches?: GraphCacheResolver<WithTypename<Motors_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    outer_diameter_rub_inches?: GraphCacheResolver<WithTypename<Motors_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    part_number?: GraphCacheResolver<WithTypename<Motors_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    pf1?: GraphCacheResolver<WithTypename<Motors_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    pf2?: GraphCacheResolver<WithTypename<Motors_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    pf3?: GraphCacheResolver<WithTypename<Motors_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    pf4?: GraphCacheResolver<WithTypename<Motors_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    pf5?: GraphCacheResolver<WithTypename<Motors_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    pfb?: GraphCacheResolver<WithTypename<Motors_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    pfv0?: GraphCacheResolver<WithTypename<Motors_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    pfv1?: GraphCacheResolver<WithTypename<Motors_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    pfv2?: GraphCacheResolver<WithTypename<Motors_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    poles?: GraphCacheResolver<WithTypename<Motors_Min_Fields>, Record<string, never>, Scalars['Int'] | string>,
    prioritized_manufacturer?: GraphCacheResolver<WithTypename<Motors_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    rr_l1?: GraphCacheResolver<WithTypename<Motors_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    rr_l2?: GraphCacheResolver<WithTypename<Motors_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    rr_lb?: GraphCacheResolver<WithTypename<Motors_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    rr_v1?: GraphCacheResolver<WithTypename<Motors_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    rr_v2?: GraphCacheResolver<WithTypename<Motors_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    rr_v3?: GraphCacheResolver<WithTypename<Motors_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    rr_vb?: GraphCacheResolver<WithTypename<Motors_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    shaft_height_inches?: GraphCacheResolver<WithTypename<Motors_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    shaft_horsepower?: GraphCacheResolver<WithTypename<Motors_Min_Fields>, Record<string, never>, Scalars['Int'] | string>,
    stator_inner_diameter_inches?: GraphCacheResolver<WithTypename<Motors_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    stator_outer_diameter_inches?: GraphCacheResolver<WithTypename<Motors_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    temperature_rating_fahrenheit?: GraphCacheResolver<WithTypename<Motors_Min_Fields>, Record<string, never>, Scalars['Int'] | string>,
    tv0?: GraphCacheResolver<WithTypename<Motors_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    tv1?: GraphCacheResolver<WithTypename<Motors_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    tv2?: GraphCacheResolver<WithTypename<Motors_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Motors_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    weight_pounds?: GraphCacheResolver<WithTypename<Motors_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>
  },
  motors_mutation_response?: {
    affected_rows?: GraphCacheResolver<WithTypename<Motors_Mutation_Response>, Record<string, never>, Scalars['Int'] | string>,
    returning?: GraphCacheResolver<WithTypename<Motors_Mutation_Response>, Record<string, never>, Array<WithTypename<Motors> | string>>
  },
  motors_stddev_fields?: {
    eff1?: GraphCacheResolver<WithTypename<Motors_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    eff2?: GraphCacheResolver<WithTypename<Motors_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    eff3?: GraphCacheResolver<WithTypename<Motors_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    eff4?: GraphCacheResolver<WithTypename<Motors_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    eff5?: GraphCacheResolver<WithTypename<Motors_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    effb?: GraphCacheResolver<WithTypename<Motors_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    effv0?: GraphCacheResolver<WithTypename<Motors_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    effv1?: GraphCacheResolver<WithTypename<Motors_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    effv2?: GraphCacheResolver<WithTypename<Motors_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    i1?: GraphCacheResolver<WithTypename<Motors_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    i2?: GraphCacheResolver<WithTypename<Motors_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    i3?: GraphCacheResolver<WithTypename<Motors_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    i4?: GraphCacheResolver<WithTypename<Motors_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    i5?: GraphCacheResolver<WithTypename<Motors_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    ib?: GraphCacheResolver<WithTypename<Motors_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Motors_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    inner_diameter_inches?: GraphCacheResolver<WithTypename<Motors_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    iv0?: GraphCacheResolver<WithTypename<Motors_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    iv1?: GraphCacheResolver<WithTypename<Motors_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    iv2?: GraphCacheResolver<WithTypename<Motors_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    k3?: GraphCacheResolver<WithTypename<Motors_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    length_inches?: GraphCacheResolver<WithTypename<Motors_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    mle_offset_depth_inches?: GraphCacheResolver<WithTypename<Motors_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    n1?: GraphCacheResolver<WithTypename<Motors_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    n2?: GraphCacheResolver<WithTypename<Motors_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    n3?: GraphCacheResolver<WithTypename<Motors_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    n4?: GraphCacheResolver<WithTypename<Motors_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    n5?: GraphCacheResolver<WithTypename<Motors_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    nameplate_current?: GraphCacheResolver<WithTypename<Motors_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    nameplate_horsepower?: GraphCacheResolver<WithTypename<Motors_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    nameplate_rerate_ratio?: GraphCacheResolver<WithTypename<Motors_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    nameplate_voltage?: GraphCacheResolver<WithTypename<Motors_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    nb?: GraphCacheResolver<WithTypename<Motors_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    neck_inner_diameter_inches?: GraphCacheResolver<WithTypename<Motors_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    neck_outer_diameter_inches?: GraphCacheResolver<WithTypename<Motors_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    nv0?: GraphCacheResolver<WithTypename<Motors_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    nv1?: GraphCacheResolver<WithTypename<Motors_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    nv2?: GraphCacheResolver<WithTypename<Motors_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    oil_volume_gallons?: GraphCacheResolver<WithTypename<Motors_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    outer_diameter_inches?: GraphCacheResolver<WithTypename<Motors_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    outer_diameter_rub_inches?: GraphCacheResolver<WithTypename<Motors_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pf1?: GraphCacheResolver<WithTypename<Motors_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pf2?: GraphCacheResolver<WithTypename<Motors_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pf3?: GraphCacheResolver<WithTypename<Motors_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pf4?: GraphCacheResolver<WithTypename<Motors_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pf5?: GraphCacheResolver<WithTypename<Motors_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pfb?: GraphCacheResolver<WithTypename<Motors_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pfv0?: GraphCacheResolver<WithTypename<Motors_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pfv1?: GraphCacheResolver<WithTypename<Motors_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pfv2?: GraphCacheResolver<WithTypename<Motors_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    poles?: GraphCacheResolver<WithTypename<Motors_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    rr_l1?: GraphCacheResolver<WithTypename<Motors_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    rr_l2?: GraphCacheResolver<WithTypename<Motors_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    rr_lb?: GraphCacheResolver<WithTypename<Motors_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    rr_v1?: GraphCacheResolver<WithTypename<Motors_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    rr_v2?: GraphCacheResolver<WithTypename<Motors_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    rr_v3?: GraphCacheResolver<WithTypename<Motors_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    rr_vb?: GraphCacheResolver<WithTypename<Motors_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    shaft_height_inches?: GraphCacheResolver<WithTypename<Motors_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    shaft_horsepower?: GraphCacheResolver<WithTypename<Motors_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    stator_inner_diameter_inches?: GraphCacheResolver<WithTypename<Motors_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    stator_outer_diameter_inches?: GraphCacheResolver<WithTypename<Motors_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    temperature_rating_fahrenheit?: GraphCacheResolver<WithTypename<Motors_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    tv0?: GraphCacheResolver<WithTypename<Motors_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    tv1?: GraphCacheResolver<WithTypename<Motors_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    tv2?: GraphCacheResolver<WithTypename<Motors_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    weight_pounds?: GraphCacheResolver<WithTypename<Motors_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  motors_stddev_pop_fields?: {
    eff1?: GraphCacheResolver<WithTypename<Motors_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    eff2?: GraphCacheResolver<WithTypename<Motors_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    eff3?: GraphCacheResolver<WithTypename<Motors_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    eff4?: GraphCacheResolver<WithTypename<Motors_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    eff5?: GraphCacheResolver<WithTypename<Motors_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    effb?: GraphCacheResolver<WithTypename<Motors_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    effv0?: GraphCacheResolver<WithTypename<Motors_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    effv1?: GraphCacheResolver<WithTypename<Motors_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    effv2?: GraphCacheResolver<WithTypename<Motors_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    i1?: GraphCacheResolver<WithTypename<Motors_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    i2?: GraphCacheResolver<WithTypename<Motors_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    i3?: GraphCacheResolver<WithTypename<Motors_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    i4?: GraphCacheResolver<WithTypename<Motors_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    i5?: GraphCacheResolver<WithTypename<Motors_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    ib?: GraphCacheResolver<WithTypename<Motors_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Motors_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    inner_diameter_inches?: GraphCacheResolver<WithTypename<Motors_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    iv0?: GraphCacheResolver<WithTypename<Motors_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    iv1?: GraphCacheResolver<WithTypename<Motors_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    iv2?: GraphCacheResolver<WithTypename<Motors_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    k3?: GraphCacheResolver<WithTypename<Motors_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    length_inches?: GraphCacheResolver<WithTypename<Motors_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    mle_offset_depth_inches?: GraphCacheResolver<WithTypename<Motors_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    n1?: GraphCacheResolver<WithTypename<Motors_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    n2?: GraphCacheResolver<WithTypename<Motors_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    n3?: GraphCacheResolver<WithTypename<Motors_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    n4?: GraphCacheResolver<WithTypename<Motors_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    n5?: GraphCacheResolver<WithTypename<Motors_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    nameplate_current?: GraphCacheResolver<WithTypename<Motors_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    nameplate_horsepower?: GraphCacheResolver<WithTypename<Motors_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    nameplate_rerate_ratio?: GraphCacheResolver<WithTypename<Motors_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    nameplate_voltage?: GraphCacheResolver<WithTypename<Motors_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    nb?: GraphCacheResolver<WithTypename<Motors_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    neck_inner_diameter_inches?: GraphCacheResolver<WithTypename<Motors_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    neck_outer_diameter_inches?: GraphCacheResolver<WithTypename<Motors_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    nv0?: GraphCacheResolver<WithTypename<Motors_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    nv1?: GraphCacheResolver<WithTypename<Motors_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    nv2?: GraphCacheResolver<WithTypename<Motors_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    oil_volume_gallons?: GraphCacheResolver<WithTypename<Motors_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    outer_diameter_inches?: GraphCacheResolver<WithTypename<Motors_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    outer_diameter_rub_inches?: GraphCacheResolver<WithTypename<Motors_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pf1?: GraphCacheResolver<WithTypename<Motors_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pf2?: GraphCacheResolver<WithTypename<Motors_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pf3?: GraphCacheResolver<WithTypename<Motors_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pf4?: GraphCacheResolver<WithTypename<Motors_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pf5?: GraphCacheResolver<WithTypename<Motors_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pfb?: GraphCacheResolver<WithTypename<Motors_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pfv0?: GraphCacheResolver<WithTypename<Motors_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pfv1?: GraphCacheResolver<WithTypename<Motors_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pfv2?: GraphCacheResolver<WithTypename<Motors_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    poles?: GraphCacheResolver<WithTypename<Motors_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    rr_l1?: GraphCacheResolver<WithTypename<Motors_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    rr_l2?: GraphCacheResolver<WithTypename<Motors_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    rr_lb?: GraphCacheResolver<WithTypename<Motors_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    rr_v1?: GraphCacheResolver<WithTypename<Motors_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    rr_v2?: GraphCacheResolver<WithTypename<Motors_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    rr_v3?: GraphCacheResolver<WithTypename<Motors_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    rr_vb?: GraphCacheResolver<WithTypename<Motors_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    shaft_height_inches?: GraphCacheResolver<WithTypename<Motors_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    shaft_horsepower?: GraphCacheResolver<WithTypename<Motors_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    stator_inner_diameter_inches?: GraphCacheResolver<WithTypename<Motors_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    stator_outer_diameter_inches?: GraphCacheResolver<WithTypename<Motors_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    temperature_rating_fahrenheit?: GraphCacheResolver<WithTypename<Motors_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    tv0?: GraphCacheResolver<WithTypename<Motors_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    tv1?: GraphCacheResolver<WithTypename<Motors_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    tv2?: GraphCacheResolver<WithTypename<Motors_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    weight_pounds?: GraphCacheResolver<WithTypename<Motors_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  motors_stddev_samp_fields?: {
    eff1?: GraphCacheResolver<WithTypename<Motors_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    eff2?: GraphCacheResolver<WithTypename<Motors_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    eff3?: GraphCacheResolver<WithTypename<Motors_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    eff4?: GraphCacheResolver<WithTypename<Motors_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    eff5?: GraphCacheResolver<WithTypename<Motors_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    effb?: GraphCacheResolver<WithTypename<Motors_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    effv0?: GraphCacheResolver<WithTypename<Motors_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    effv1?: GraphCacheResolver<WithTypename<Motors_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    effv2?: GraphCacheResolver<WithTypename<Motors_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    i1?: GraphCacheResolver<WithTypename<Motors_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    i2?: GraphCacheResolver<WithTypename<Motors_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    i3?: GraphCacheResolver<WithTypename<Motors_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    i4?: GraphCacheResolver<WithTypename<Motors_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    i5?: GraphCacheResolver<WithTypename<Motors_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    ib?: GraphCacheResolver<WithTypename<Motors_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Motors_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    inner_diameter_inches?: GraphCacheResolver<WithTypename<Motors_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    iv0?: GraphCacheResolver<WithTypename<Motors_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    iv1?: GraphCacheResolver<WithTypename<Motors_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    iv2?: GraphCacheResolver<WithTypename<Motors_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    k3?: GraphCacheResolver<WithTypename<Motors_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    length_inches?: GraphCacheResolver<WithTypename<Motors_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    mle_offset_depth_inches?: GraphCacheResolver<WithTypename<Motors_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    n1?: GraphCacheResolver<WithTypename<Motors_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    n2?: GraphCacheResolver<WithTypename<Motors_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    n3?: GraphCacheResolver<WithTypename<Motors_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    n4?: GraphCacheResolver<WithTypename<Motors_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    n5?: GraphCacheResolver<WithTypename<Motors_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    nameplate_current?: GraphCacheResolver<WithTypename<Motors_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    nameplate_horsepower?: GraphCacheResolver<WithTypename<Motors_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    nameplate_rerate_ratio?: GraphCacheResolver<WithTypename<Motors_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    nameplate_voltage?: GraphCacheResolver<WithTypename<Motors_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    nb?: GraphCacheResolver<WithTypename<Motors_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    neck_inner_diameter_inches?: GraphCacheResolver<WithTypename<Motors_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    neck_outer_diameter_inches?: GraphCacheResolver<WithTypename<Motors_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    nv0?: GraphCacheResolver<WithTypename<Motors_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    nv1?: GraphCacheResolver<WithTypename<Motors_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    nv2?: GraphCacheResolver<WithTypename<Motors_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    oil_volume_gallons?: GraphCacheResolver<WithTypename<Motors_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    outer_diameter_inches?: GraphCacheResolver<WithTypename<Motors_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    outer_diameter_rub_inches?: GraphCacheResolver<WithTypename<Motors_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pf1?: GraphCacheResolver<WithTypename<Motors_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pf2?: GraphCacheResolver<WithTypename<Motors_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pf3?: GraphCacheResolver<WithTypename<Motors_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pf4?: GraphCacheResolver<WithTypename<Motors_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pf5?: GraphCacheResolver<WithTypename<Motors_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pfb?: GraphCacheResolver<WithTypename<Motors_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pfv0?: GraphCacheResolver<WithTypename<Motors_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pfv1?: GraphCacheResolver<WithTypename<Motors_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pfv2?: GraphCacheResolver<WithTypename<Motors_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    poles?: GraphCacheResolver<WithTypename<Motors_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    rr_l1?: GraphCacheResolver<WithTypename<Motors_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    rr_l2?: GraphCacheResolver<WithTypename<Motors_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    rr_lb?: GraphCacheResolver<WithTypename<Motors_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    rr_v1?: GraphCacheResolver<WithTypename<Motors_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    rr_v2?: GraphCacheResolver<WithTypename<Motors_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    rr_v3?: GraphCacheResolver<WithTypename<Motors_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    rr_vb?: GraphCacheResolver<WithTypename<Motors_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    shaft_height_inches?: GraphCacheResolver<WithTypename<Motors_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    shaft_horsepower?: GraphCacheResolver<WithTypename<Motors_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    stator_inner_diameter_inches?: GraphCacheResolver<WithTypename<Motors_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    stator_outer_diameter_inches?: GraphCacheResolver<WithTypename<Motors_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    temperature_rating_fahrenheit?: GraphCacheResolver<WithTypename<Motors_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    tv0?: GraphCacheResolver<WithTypename<Motors_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    tv1?: GraphCacheResolver<WithTypename<Motors_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    tv2?: GraphCacheResolver<WithTypename<Motors_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    weight_pounds?: GraphCacheResolver<WithTypename<Motors_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  motors_sum_fields?: {
    eff1?: GraphCacheResolver<WithTypename<Motors_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    eff2?: GraphCacheResolver<WithTypename<Motors_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    eff3?: GraphCacheResolver<WithTypename<Motors_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    eff4?: GraphCacheResolver<WithTypename<Motors_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    eff5?: GraphCacheResolver<WithTypename<Motors_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    effb?: GraphCacheResolver<WithTypename<Motors_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    effv0?: GraphCacheResolver<WithTypename<Motors_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    effv1?: GraphCacheResolver<WithTypename<Motors_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    effv2?: GraphCacheResolver<WithTypename<Motors_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    i1?: GraphCacheResolver<WithTypename<Motors_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    i2?: GraphCacheResolver<WithTypename<Motors_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    i3?: GraphCacheResolver<WithTypename<Motors_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    i4?: GraphCacheResolver<WithTypename<Motors_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    i5?: GraphCacheResolver<WithTypename<Motors_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    ib?: GraphCacheResolver<WithTypename<Motors_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Motors_Sum_Fields>, Record<string, never>, Scalars['Int'] | string>,
    inner_diameter_inches?: GraphCacheResolver<WithTypename<Motors_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    iv0?: GraphCacheResolver<WithTypename<Motors_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    iv1?: GraphCacheResolver<WithTypename<Motors_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    iv2?: GraphCacheResolver<WithTypename<Motors_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    k3?: GraphCacheResolver<WithTypename<Motors_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    length_inches?: GraphCacheResolver<WithTypename<Motors_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    mle_offset_depth_inches?: GraphCacheResolver<WithTypename<Motors_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    n1?: GraphCacheResolver<WithTypename<Motors_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    n2?: GraphCacheResolver<WithTypename<Motors_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    n3?: GraphCacheResolver<WithTypename<Motors_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    n4?: GraphCacheResolver<WithTypename<Motors_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    n5?: GraphCacheResolver<WithTypename<Motors_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    nameplate_current?: GraphCacheResolver<WithTypename<Motors_Sum_Fields>, Record<string, never>, Scalars['Int'] | string>,
    nameplate_horsepower?: GraphCacheResolver<WithTypename<Motors_Sum_Fields>, Record<string, never>, Scalars['Int'] | string>,
    nameplate_rerate_ratio?: GraphCacheResolver<WithTypename<Motors_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    nameplate_voltage?: GraphCacheResolver<WithTypename<Motors_Sum_Fields>, Record<string, never>, Scalars['Int'] | string>,
    nb?: GraphCacheResolver<WithTypename<Motors_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    neck_inner_diameter_inches?: GraphCacheResolver<WithTypename<Motors_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    neck_outer_diameter_inches?: GraphCacheResolver<WithTypename<Motors_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    nv0?: GraphCacheResolver<WithTypename<Motors_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    nv1?: GraphCacheResolver<WithTypename<Motors_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    nv2?: GraphCacheResolver<WithTypename<Motors_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    oil_volume_gallons?: GraphCacheResolver<WithTypename<Motors_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    outer_diameter_inches?: GraphCacheResolver<WithTypename<Motors_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    outer_diameter_rub_inches?: GraphCacheResolver<WithTypename<Motors_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    pf1?: GraphCacheResolver<WithTypename<Motors_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    pf2?: GraphCacheResolver<WithTypename<Motors_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    pf3?: GraphCacheResolver<WithTypename<Motors_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    pf4?: GraphCacheResolver<WithTypename<Motors_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    pf5?: GraphCacheResolver<WithTypename<Motors_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    pfb?: GraphCacheResolver<WithTypename<Motors_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    pfv0?: GraphCacheResolver<WithTypename<Motors_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    pfv1?: GraphCacheResolver<WithTypename<Motors_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    pfv2?: GraphCacheResolver<WithTypename<Motors_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    poles?: GraphCacheResolver<WithTypename<Motors_Sum_Fields>, Record<string, never>, Scalars['Int'] | string>,
    rr_l1?: GraphCacheResolver<WithTypename<Motors_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    rr_l2?: GraphCacheResolver<WithTypename<Motors_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    rr_lb?: GraphCacheResolver<WithTypename<Motors_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    rr_v1?: GraphCacheResolver<WithTypename<Motors_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    rr_v2?: GraphCacheResolver<WithTypename<Motors_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    rr_v3?: GraphCacheResolver<WithTypename<Motors_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    rr_vb?: GraphCacheResolver<WithTypename<Motors_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    shaft_height_inches?: GraphCacheResolver<WithTypename<Motors_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    shaft_horsepower?: GraphCacheResolver<WithTypename<Motors_Sum_Fields>, Record<string, never>, Scalars['Int'] | string>,
    stator_inner_diameter_inches?: GraphCacheResolver<WithTypename<Motors_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    stator_outer_diameter_inches?: GraphCacheResolver<WithTypename<Motors_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    temperature_rating_fahrenheit?: GraphCacheResolver<WithTypename<Motors_Sum_Fields>, Record<string, never>, Scalars['Int'] | string>,
    tv0?: GraphCacheResolver<WithTypename<Motors_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    tv1?: GraphCacheResolver<WithTypename<Motors_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    tv2?: GraphCacheResolver<WithTypename<Motors_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    weight_pounds?: GraphCacheResolver<WithTypename<Motors_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>
  },
  motors_var_pop_fields?: {
    eff1?: GraphCacheResolver<WithTypename<Motors_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    eff2?: GraphCacheResolver<WithTypename<Motors_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    eff3?: GraphCacheResolver<WithTypename<Motors_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    eff4?: GraphCacheResolver<WithTypename<Motors_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    eff5?: GraphCacheResolver<WithTypename<Motors_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    effb?: GraphCacheResolver<WithTypename<Motors_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    effv0?: GraphCacheResolver<WithTypename<Motors_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    effv1?: GraphCacheResolver<WithTypename<Motors_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    effv2?: GraphCacheResolver<WithTypename<Motors_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    i1?: GraphCacheResolver<WithTypename<Motors_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    i2?: GraphCacheResolver<WithTypename<Motors_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    i3?: GraphCacheResolver<WithTypename<Motors_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    i4?: GraphCacheResolver<WithTypename<Motors_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    i5?: GraphCacheResolver<WithTypename<Motors_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    ib?: GraphCacheResolver<WithTypename<Motors_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Motors_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    inner_diameter_inches?: GraphCacheResolver<WithTypename<Motors_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    iv0?: GraphCacheResolver<WithTypename<Motors_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    iv1?: GraphCacheResolver<WithTypename<Motors_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    iv2?: GraphCacheResolver<WithTypename<Motors_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    k3?: GraphCacheResolver<WithTypename<Motors_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    length_inches?: GraphCacheResolver<WithTypename<Motors_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    mle_offset_depth_inches?: GraphCacheResolver<WithTypename<Motors_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    n1?: GraphCacheResolver<WithTypename<Motors_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    n2?: GraphCacheResolver<WithTypename<Motors_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    n3?: GraphCacheResolver<WithTypename<Motors_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    n4?: GraphCacheResolver<WithTypename<Motors_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    n5?: GraphCacheResolver<WithTypename<Motors_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    nameplate_current?: GraphCacheResolver<WithTypename<Motors_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    nameplate_horsepower?: GraphCacheResolver<WithTypename<Motors_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    nameplate_rerate_ratio?: GraphCacheResolver<WithTypename<Motors_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    nameplate_voltage?: GraphCacheResolver<WithTypename<Motors_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    nb?: GraphCacheResolver<WithTypename<Motors_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    neck_inner_diameter_inches?: GraphCacheResolver<WithTypename<Motors_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    neck_outer_diameter_inches?: GraphCacheResolver<WithTypename<Motors_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    nv0?: GraphCacheResolver<WithTypename<Motors_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    nv1?: GraphCacheResolver<WithTypename<Motors_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    nv2?: GraphCacheResolver<WithTypename<Motors_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    oil_volume_gallons?: GraphCacheResolver<WithTypename<Motors_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    outer_diameter_inches?: GraphCacheResolver<WithTypename<Motors_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    outer_diameter_rub_inches?: GraphCacheResolver<WithTypename<Motors_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pf1?: GraphCacheResolver<WithTypename<Motors_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pf2?: GraphCacheResolver<WithTypename<Motors_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pf3?: GraphCacheResolver<WithTypename<Motors_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pf4?: GraphCacheResolver<WithTypename<Motors_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pf5?: GraphCacheResolver<WithTypename<Motors_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pfb?: GraphCacheResolver<WithTypename<Motors_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pfv0?: GraphCacheResolver<WithTypename<Motors_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pfv1?: GraphCacheResolver<WithTypename<Motors_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pfv2?: GraphCacheResolver<WithTypename<Motors_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    poles?: GraphCacheResolver<WithTypename<Motors_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    rr_l1?: GraphCacheResolver<WithTypename<Motors_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    rr_l2?: GraphCacheResolver<WithTypename<Motors_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    rr_lb?: GraphCacheResolver<WithTypename<Motors_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    rr_v1?: GraphCacheResolver<WithTypename<Motors_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    rr_v2?: GraphCacheResolver<WithTypename<Motors_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    rr_v3?: GraphCacheResolver<WithTypename<Motors_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    rr_vb?: GraphCacheResolver<WithTypename<Motors_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    shaft_height_inches?: GraphCacheResolver<WithTypename<Motors_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    shaft_horsepower?: GraphCacheResolver<WithTypename<Motors_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    stator_inner_diameter_inches?: GraphCacheResolver<WithTypename<Motors_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    stator_outer_diameter_inches?: GraphCacheResolver<WithTypename<Motors_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    temperature_rating_fahrenheit?: GraphCacheResolver<WithTypename<Motors_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    tv0?: GraphCacheResolver<WithTypename<Motors_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    tv1?: GraphCacheResolver<WithTypename<Motors_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    tv2?: GraphCacheResolver<WithTypename<Motors_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    weight_pounds?: GraphCacheResolver<WithTypename<Motors_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  motors_var_samp_fields?: {
    eff1?: GraphCacheResolver<WithTypename<Motors_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    eff2?: GraphCacheResolver<WithTypename<Motors_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    eff3?: GraphCacheResolver<WithTypename<Motors_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    eff4?: GraphCacheResolver<WithTypename<Motors_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    eff5?: GraphCacheResolver<WithTypename<Motors_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    effb?: GraphCacheResolver<WithTypename<Motors_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    effv0?: GraphCacheResolver<WithTypename<Motors_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    effv1?: GraphCacheResolver<WithTypename<Motors_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    effv2?: GraphCacheResolver<WithTypename<Motors_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    i1?: GraphCacheResolver<WithTypename<Motors_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    i2?: GraphCacheResolver<WithTypename<Motors_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    i3?: GraphCacheResolver<WithTypename<Motors_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    i4?: GraphCacheResolver<WithTypename<Motors_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    i5?: GraphCacheResolver<WithTypename<Motors_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    ib?: GraphCacheResolver<WithTypename<Motors_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Motors_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    inner_diameter_inches?: GraphCacheResolver<WithTypename<Motors_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    iv0?: GraphCacheResolver<WithTypename<Motors_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    iv1?: GraphCacheResolver<WithTypename<Motors_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    iv2?: GraphCacheResolver<WithTypename<Motors_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    k3?: GraphCacheResolver<WithTypename<Motors_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    length_inches?: GraphCacheResolver<WithTypename<Motors_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    mle_offset_depth_inches?: GraphCacheResolver<WithTypename<Motors_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    n1?: GraphCacheResolver<WithTypename<Motors_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    n2?: GraphCacheResolver<WithTypename<Motors_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    n3?: GraphCacheResolver<WithTypename<Motors_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    n4?: GraphCacheResolver<WithTypename<Motors_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    n5?: GraphCacheResolver<WithTypename<Motors_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    nameplate_current?: GraphCacheResolver<WithTypename<Motors_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    nameplate_horsepower?: GraphCacheResolver<WithTypename<Motors_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    nameplate_rerate_ratio?: GraphCacheResolver<WithTypename<Motors_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    nameplate_voltage?: GraphCacheResolver<WithTypename<Motors_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    nb?: GraphCacheResolver<WithTypename<Motors_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    neck_inner_diameter_inches?: GraphCacheResolver<WithTypename<Motors_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    neck_outer_diameter_inches?: GraphCacheResolver<WithTypename<Motors_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    nv0?: GraphCacheResolver<WithTypename<Motors_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    nv1?: GraphCacheResolver<WithTypename<Motors_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    nv2?: GraphCacheResolver<WithTypename<Motors_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    oil_volume_gallons?: GraphCacheResolver<WithTypename<Motors_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    outer_diameter_inches?: GraphCacheResolver<WithTypename<Motors_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    outer_diameter_rub_inches?: GraphCacheResolver<WithTypename<Motors_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pf1?: GraphCacheResolver<WithTypename<Motors_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pf2?: GraphCacheResolver<WithTypename<Motors_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pf3?: GraphCacheResolver<WithTypename<Motors_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pf4?: GraphCacheResolver<WithTypename<Motors_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pf5?: GraphCacheResolver<WithTypename<Motors_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pfb?: GraphCacheResolver<WithTypename<Motors_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pfv0?: GraphCacheResolver<WithTypename<Motors_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pfv1?: GraphCacheResolver<WithTypename<Motors_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pfv2?: GraphCacheResolver<WithTypename<Motors_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    poles?: GraphCacheResolver<WithTypename<Motors_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    rr_l1?: GraphCacheResolver<WithTypename<Motors_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    rr_l2?: GraphCacheResolver<WithTypename<Motors_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    rr_lb?: GraphCacheResolver<WithTypename<Motors_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    rr_v1?: GraphCacheResolver<WithTypename<Motors_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    rr_v2?: GraphCacheResolver<WithTypename<Motors_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    rr_v3?: GraphCacheResolver<WithTypename<Motors_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    rr_vb?: GraphCacheResolver<WithTypename<Motors_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    shaft_height_inches?: GraphCacheResolver<WithTypename<Motors_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    shaft_horsepower?: GraphCacheResolver<WithTypename<Motors_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    stator_inner_diameter_inches?: GraphCacheResolver<WithTypename<Motors_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    stator_outer_diameter_inches?: GraphCacheResolver<WithTypename<Motors_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    temperature_rating_fahrenheit?: GraphCacheResolver<WithTypename<Motors_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    tv0?: GraphCacheResolver<WithTypename<Motors_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    tv1?: GraphCacheResolver<WithTypename<Motors_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    tv2?: GraphCacheResolver<WithTypename<Motors_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    weight_pounds?: GraphCacheResolver<WithTypename<Motors_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  motors_variance_fields?: {
    eff1?: GraphCacheResolver<WithTypename<Motors_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    eff2?: GraphCacheResolver<WithTypename<Motors_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    eff3?: GraphCacheResolver<WithTypename<Motors_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    eff4?: GraphCacheResolver<WithTypename<Motors_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    eff5?: GraphCacheResolver<WithTypename<Motors_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    effb?: GraphCacheResolver<WithTypename<Motors_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    effv0?: GraphCacheResolver<WithTypename<Motors_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    effv1?: GraphCacheResolver<WithTypename<Motors_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    effv2?: GraphCacheResolver<WithTypename<Motors_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    i1?: GraphCacheResolver<WithTypename<Motors_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    i2?: GraphCacheResolver<WithTypename<Motors_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    i3?: GraphCacheResolver<WithTypename<Motors_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    i4?: GraphCacheResolver<WithTypename<Motors_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    i5?: GraphCacheResolver<WithTypename<Motors_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    ib?: GraphCacheResolver<WithTypename<Motors_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Motors_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    inner_diameter_inches?: GraphCacheResolver<WithTypename<Motors_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    iv0?: GraphCacheResolver<WithTypename<Motors_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    iv1?: GraphCacheResolver<WithTypename<Motors_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    iv2?: GraphCacheResolver<WithTypename<Motors_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    k3?: GraphCacheResolver<WithTypename<Motors_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    length_inches?: GraphCacheResolver<WithTypename<Motors_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    mle_offset_depth_inches?: GraphCacheResolver<WithTypename<Motors_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    n1?: GraphCacheResolver<WithTypename<Motors_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    n2?: GraphCacheResolver<WithTypename<Motors_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    n3?: GraphCacheResolver<WithTypename<Motors_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    n4?: GraphCacheResolver<WithTypename<Motors_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    n5?: GraphCacheResolver<WithTypename<Motors_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    nameplate_current?: GraphCacheResolver<WithTypename<Motors_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    nameplate_horsepower?: GraphCacheResolver<WithTypename<Motors_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    nameplate_rerate_ratio?: GraphCacheResolver<WithTypename<Motors_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    nameplate_voltage?: GraphCacheResolver<WithTypename<Motors_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    nb?: GraphCacheResolver<WithTypename<Motors_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    neck_inner_diameter_inches?: GraphCacheResolver<WithTypename<Motors_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    neck_outer_diameter_inches?: GraphCacheResolver<WithTypename<Motors_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    nv0?: GraphCacheResolver<WithTypename<Motors_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    nv1?: GraphCacheResolver<WithTypename<Motors_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    nv2?: GraphCacheResolver<WithTypename<Motors_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    oil_volume_gallons?: GraphCacheResolver<WithTypename<Motors_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    outer_diameter_inches?: GraphCacheResolver<WithTypename<Motors_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    outer_diameter_rub_inches?: GraphCacheResolver<WithTypename<Motors_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pf1?: GraphCacheResolver<WithTypename<Motors_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pf2?: GraphCacheResolver<WithTypename<Motors_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pf3?: GraphCacheResolver<WithTypename<Motors_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pf4?: GraphCacheResolver<WithTypename<Motors_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pf5?: GraphCacheResolver<WithTypename<Motors_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pfb?: GraphCacheResolver<WithTypename<Motors_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pfv0?: GraphCacheResolver<WithTypename<Motors_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pfv1?: GraphCacheResolver<WithTypename<Motors_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pfv2?: GraphCacheResolver<WithTypename<Motors_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    poles?: GraphCacheResolver<WithTypename<Motors_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    rr_l1?: GraphCacheResolver<WithTypename<Motors_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    rr_l2?: GraphCacheResolver<WithTypename<Motors_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    rr_lb?: GraphCacheResolver<WithTypename<Motors_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    rr_v1?: GraphCacheResolver<WithTypename<Motors_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    rr_v2?: GraphCacheResolver<WithTypename<Motors_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    rr_v3?: GraphCacheResolver<WithTypename<Motors_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    rr_vb?: GraphCacheResolver<WithTypename<Motors_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    shaft_height_inches?: GraphCacheResolver<WithTypename<Motors_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    shaft_horsepower?: GraphCacheResolver<WithTypename<Motors_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    stator_inner_diameter_inches?: GraphCacheResolver<WithTypename<Motors_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    stator_outer_diameter_inches?: GraphCacheResolver<WithTypename<Motors_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    temperature_rating_fahrenheit?: GraphCacheResolver<WithTypename<Motors_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    tv0?: GraphCacheResolver<WithTypename<Motors_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    tv1?: GraphCacheResolver<WithTypename<Motors_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    tv2?: GraphCacheResolver<WithTypename<Motors_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    weight_pounds?: GraphCacheResolver<WithTypename<Motors_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  natural_gas_separation_options?: {
    comment?: GraphCacheResolver<WithTypename<Natural_Gas_Separation_Options>, Record<string, never>, Scalars['String'] | string>,
    value?: GraphCacheResolver<WithTypename<Natural_Gas_Separation_Options>, Record<string, never>, Scalars['String'] | string>
  },
  natural_gas_separation_options_aggregate?: {
    aggregate?: GraphCacheResolver<WithTypename<Natural_Gas_Separation_Options_Aggregate>, Record<string, never>, WithTypename<Natural_Gas_Separation_Options_Aggregate_Fields> | string>,
    nodes?: GraphCacheResolver<WithTypename<Natural_Gas_Separation_Options_Aggregate>, Record<string, never>, Array<WithTypename<Natural_Gas_Separation_Options> | string>>
  },
  natural_gas_separation_options_aggregate_fields?: {
    count?: GraphCacheResolver<WithTypename<Natural_Gas_Separation_Options_Aggregate_Fields>, Natural_Gas_Separation_Options_Aggregate_FieldsCountArgs, Scalars['Int'] | string>,
    max?: GraphCacheResolver<WithTypename<Natural_Gas_Separation_Options_Aggregate_Fields>, Record<string, never>, WithTypename<Natural_Gas_Separation_Options_Max_Fields> | string>,
    min?: GraphCacheResolver<WithTypename<Natural_Gas_Separation_Options_Aggregate_Fields>, Record<string, never>, WithTypename<Natural_Gas_Separation_Options_Min_Fields> | string>
  },
  natural_gas_separation_options_max_fields?: {
    comment?: GraphCacheResolver<WithTypename<Natural_Gas_Separation_Options_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    value?: GraphCacheResolver<WithTypename<Natural_Gas_Separation_Options_Max_Fields>, Record<string, never>, Scalars['String'] | string>
  },
  natural_gas_separation_options_min_fields?: {
    comment?: GraphCacheResolver<WithTypename<Natural_Gas_Separation_Options_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    value?: GraphCacheResolver<WithTypename<Natural_Gas_Separation_Options_Min_Fields>, Record<string, never>, Scalars['String'] | string>
  },
  natural_gas_separation_options_mutation_response?: {
    affected_rows?: GraphCacheResolver<WithTypename<Natural_Gas_Separation_Options_Mutation_Response>, Record<string, never>, Scalars['Int'] | string>,
    returning?: GraphCacheResolver<WithTypename<Natural_Gas_Separation_Options_Mutation_Response>, Record<string, never>, Array<WithTypename<Natural_Gas_Separation_Options> | string>>
  },
  oil_density_options?: {
    comment?: GraphCacheResolver<WithTypename<Oil_Density_Options>, Record<string, never>, Scalars['String'] | string>,
    value?: GraphCacheResolver<WithTypename<Oil_Density_Options>, Record<string, never>, Scalars['String'] | string>
  },
  oil_density_options_aggregate?: {
    aggregate?: GraphCacheResolver<WithTypename<Oil_Density_Options_Aggregate>, Record<string, never>, WithTypename<Oil_Density_Options_Aggregate_Fields> | string>,
    nodes?: GraphCacheResolver<WithTypename<Oil_Density_Options_Aggregate>, Record<string, never>, Array<WithTypename<Oil_Density_Options> | string>>
  },
  oil_density_options_aggregate_fields?: {
    count?: GraphCacheResolver<WithTypename<Oil_Density_Options_Aggregate_Fields>, Oil_Density_Options_Aggregate_FieldsCountArgs, Scalars['Int'] | string>,
    max?: GraphCacheResolver<WithTypename<Oil_Density_Options_Aggregate_Fields>, Record<string, never>, WithTypename<Oil_Density_Options_Max_Fields> | string>,
    min?: GraphCacheResolver<WithTypename<Oil_Density_Options_Aggregate_Fields>, Record<string, never>, WithTypename<Oil_Density_Options_Min_Fields> | string>
  },
  oil_density_options_max_fields?: {
    comment?: GraphCacheResolver<WithTypename<Oil_Density_Options_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    value?: GraphCacheResolver<WithTypename<Oil_Density_Options_Max_Fields>, Record<string, never>, Scalars['String'] | string>
  },
  oil_density_options_min_fields?: {
    comment?: GraphCacheResolver<WithTypename<Oil_Density_Options_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    value?: GraphCacheResolver<WithTypename<Oil_Density_Options_Min_Fields>, Record<string, never>, Scalars['String'] | string>
  },
  oil_density_options_mutation_response?: {
    affected_rows?: GraphCacheResolver<WithTypename<Oil_Density_Options_Mutation_Response>, Record<string, never>, Scalars['Int'] | string>,
    returning?: GraphCacheResolver<WithTypename<Oil_Density_Options_Mutation_Response>, Record<string, never>, Array<WithTypename<Oil_Density_Options> | string>>
  },
  oil_volume_factor_options?: {
    comment?: GraphCacheResolver<WithTypename<Oil_Volume_Factor_Options>, Record<string, never>, Scalars['String'] | string>,
    value?: GraphCacheResolver<WithTypename<Oil_Volume_Factor_Options>, Record<string, never>, Scalars['String'] | string>
  },
  oil_volume_factor_options_aggregate?: {
    aggregate?: GraphCacheResolver<WithTypename<Oil_Volume_Factor_Options_Aggregate>, Record<string, never>, WithTypename<Oil_Volume_Factor_Options_Aggregate_Fields> | string>,
    nodes?: GraphCacheResolver<WithTypename<Oil_Volume_Factor_Options_Aggregate>, Record<string, never>, Array<WithTypename<Oil_Volume_Factor_Options> | string>>
  },
  oil_volume_factor_options_aggregate_fields?: {
    count?: GraphCacheResolver<WithTypename<Oil_Volume_Factor_Options_Aggregate_Fields>, Oil_Volume_Factor_Options_Aggregate_FieldsCountArgs, Scalars['Int'] | string>,
    max?: GraphCacheResolver<WithTypename<Oil_Volume_Factor_Options_Aggregate_Fields>, Record<string, never>, WithTypename<Oil_Volume_Factor_Options_Max_Fields> | string>,
    min?: GraphCacheResolver<WithTypename<Oil_Volume_Factor_Options_Aggregate_Fields>, Record<string, never>, WithTypename<Oil_Volume_Factor_Options_Min_Fields> | string>
  },
  oil_volume_factor_options_max_fields?: {
    comment?: GraphCacheResolver<WithTypename<Oil_Volume_Factor_Options_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    value?: GraphCacheResolver<WithTypename<Oil_Volume_Factor_Options_Max_Fields>, Record<string, never>, Scalars['String'] | string>
  },
  oil_volume_factor_options_min_fields?: {
    comment?: GraphCacheResolver<WithTypename<Oil_Volume_Factor_Options_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    value?: GraphCacheResolver<WithTypename<Oil_Volume_Factor_Options_Min_Fields>, Record<string, never>, Scalars['String'] | string>
  },
  oil_volume_factor_options_mutation_response?: {
    affected_rows?: GraphCacheResolver<WithTypename<Oil_Volume_Factor_Options_Mutation_Response>, Record<string, never>, Scalars['Int'] | string>,
    returning?: GraphCacheResolver<WithTypename<Oil_Volume_Factor_Options_Mutation_Response>, Record<string, never>, Array<WithTypename<Oil_Volume_Factor_Options> | string>>
  },
  override_options?: {
    comment?: GraphCacheResolver<WithTypename<Override_Options>, Record<string, never>, Scalars['String'] | string>,
    value?: GraphCacheResolver<WithTypename<Override_Options>, Record<string, never>, Scalars['String'] | string>
  },
  override_options_aggregate?: {
    aggregate?: GraphCacheResolver<WithTypename<Override_Options_Aggregate>, Record<string, never>, WithTypename<Override_Options_Aggregate_Fields> | string>,
    nodes?: GraphCacheResolver<WithTypename<Override_Options_Aggregate>, Record<string, never>, Array<WithTypename<Override_Options> | string>>
  },
  override_options_aggregate_fields?: {
    count?: GraphCacheResolver<WithTypename<Override_Options_Aggregate_Fields>, Override_Options_Aggregate_FieldsCountArgs, Scalars['Int'] | string>,
    max?: GraphCacheResolver<WithTypename<Override_Options_Aggregate_Fields>, Record<string, never>, WithTypename<Override_Options_Max_Fields> | string>,
    min?: GraphCacheResolver<WithTypename<Override_Options_Aggregate_Fields>, Record<string, never>, WithTypename<Override_Options_Min_Fields> | string>
  },
  override_options_max_fields?: {
    comment?: GraphCacheResolver<WithTypename<Override_Options_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    value?: GraphCacheResolver<WithTypename<Override_Options_Max_Fields>, Record<string, never>, Scalars['String'] | string>
  },
  override_options_min_fields?: {
    comment?: GraphCacheResolver<WithTypename<Override_Options_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    value?: GraphCacheResolver<WithTypename<Override_Options_Min_Fields>, Record<string, never>, Scalars['String'] | string>
  },
  override_options_mutation_response?: {
    affected_rows?: GraphCacheResolver<WithTypename<Override_Options_Mutation_Response>, Record<string, never>, Scalars['Int'] | string>,
    returning?: GraphCacheResolver<WithTypename<Override_Options_Mutation_Response>, Record<string, never>, Array<WithTypename<Override_Options> | string>>
  },
  performance_evaluations?: {
    author?: GraphCacheResolver<WithTypename<Performance_Evaluations>, Record<string, never>, WithTypename<Users> | string>,
    casing_pressure_psia?: GraphCacheResolver<WithTypename<Performance_Evaluations>, Record<string, never>, Scalars['numeric'] | string>,
    gas_rate_mscf_day?: GraphCacheResolver<WithTypename<Performance_Evaluations>, Record<string, never>, Scalars['numeric'] | string>,
    id?: GraphCacheResolver<WithTypename<Performance_Evaluations>, Record<string, never>, Scalars['uuid'] | string>,
    intake_gas_separation_override_type?: GraphCacheResolver<WithTypename<Performance_Evaluations>, Record<string, never>, Scalars['String'] | string>,
    intake_override_gas_separation_percent?: GraphCacheResolver<WithTypename<Performance_Evaluations>, Record<string, never>, Scalars['numeric'] | string>,
    journal_author_id?: GraphCacheResolver<WithTypename<Performance_Evaluations>, Record<string, never>, Scalars['String'] | string>,
    journal_created_at?: GraphCacheResolver<WithTypename<Performance_Evaluations>, Record<string, never>, Scalars['timestamptz'] | string>,
    journal_deleted_at?: GraphCacheResolver<WithTypename<Performance_Evaluations>, Record<string, never>, Scalars['timestamptz'] | string>,
    journal_updated_at?: GraphCacheResolver<WithTypename<Performance_Evaluations>, Record<string, never>, Scalars['timestamptz'] | string>,
    natural_gas_separation_override_type?: GraphCacheResolver<WithTypename<Performance_Evaluations>, Record<string, never>, Scalars['String'] | string>,
    natural_override_gas_separation_percent?: GraphCacheResolver<WithTypename<Performance_Evaluations>, Record<string, never>, Scalars['numeric'] | string>,
    oil_rate_std_barrel_day?: GraphCacheResolver<WithTypename<Performance_Evaluations>, Record<string, never>, Scalars['numeric'] | string>,
    parent_id?: GraphCacheResolver<WithTypename<Performance_Evaluations>, Record<string, never>, Scalars['uuid'] | string>,
    pump_hz?: GraphCacheResolver<WithTypename<Performance_Evaluations>, Record<string, never>, Scalars['numeric'] | string>,
    pump_intake_pressure_psia?: GraphCacheResolver<WithTypename<Performance_Evaluations>, Record<string, never>, Scalars['numeric'] | string>,
    pump_wear_brake_horsepower_correction_ratio?: GraphCacheResolver<WithTypename<Performance_Evaluations>, Record<string, never>, Scalars['numeric'] | string>,
    pump_wear_head_correction_ratio?: GraphCacheResolver<WithTypename<Performance_Evaluations>, Record<string, never>, Scalars['numeric'] | string>,
    scenario?: GraphCacheResolver<WithTypename<Performance_Evaluations>, Record<string, never>, WithTypename<Scenarios> | string>,
    scenario_id?: GraphCacheResolver<WithTypename<Performance_Evaluations>, Record<string, never>, Scalars['uuid'] | string>,
    title?: GraphCacheResolver<WithTypename<Performance_Evaluations>, Record<string, never>, Scalars['String'] | string>,
    tubing_pressure_psia?: GraphCacheResolver<WithTypename<Performance_Evaluations>, Record<string, never>, Scalars['numeric'] | string>,
    water_rate_std_barrel_day?: GraphCacheResolver<WithTypename<Performance_Evaluations>, Record<string, never>, Scalars['numeric'] | string>,
    winning_revision_author_id?: GraphCacheResolver<WithTypename<Performance_Evaluations>, Record<string, never>, Scalars['String'] | string>,
    winning_revision_created_at?: GraphCacheResolver<WithTypename<Performance_Evaluations>, Record<string, never>, Scalars['timestamptz'] | string>,
    winning_revision_deleted_at?: GraphCacheResolver<WithTypename<Performance_Evaluations>, Record<string, never>, Scalars['timestamptz'] | string>,
    winning_revision_id?: GraphCacheResolver<WithTypename<Performance_Evaluations>, Record<string, never>, Scalars['uuid'] | string>,
    winning_revision_parent_id?: GraphCacheResolver<WithTypename<Performance_Evaluations>, Record<string, never>, Scalars['uuid'] | string>,
    winning_revision_updated_at?: GraphCacheResolver<WithTypename<Performance_Evaluations>, Record<string, never>, Scalars['timestamptz'] | string>,
    xref_pumps?: GraphCacheResolver<WithTypename<Performance_Evaluations>, Performance_EvaluationsXref_PumpsArgs, Array<WithTypename<Performance_Evaluations_Xref_Pumps> | string>>,
    xref_pumps_aggregate?: GraphCacheResolver<WithTypename<Performance_Evaluations>, Performance_EvaluationsXref_Pumps_AggregateArgs, WithTypename<Performance_Evaluations_Xref_Pumps_Aggregate> | string>
  },
  performance_evaluations_aggregate?: {
    aggregate?: GraphCacheResolver<WithTypename<Performance_Evaluations_Aggregate>, Record<string, never>, WithTypename<Performance_Evaluations_Aggregate_Fields> | string>,
    nodes?: GraphCacheResolver<WithTypename<Performance_Evaluations_Aggregate>, Record<string, never>, Array<WithTypename<Performance_Evaluations> | string>>
  },
  performance_evaluations_aggregate_fields?: {
    avg?: GraphCacheResolver<WithTypename<Performance_Evaluations_Aggregate_Fields>, Record<string, never>, WithTypename<Performance_Evaluations_Avg_Fields> | string>,
    count?: GraphCacheResolver<WithTypename<Performance_Evaluations_Aggregate_Fields>, Performance_Evaluations_Aggregate_FieldsCountArgs, Scalars['Int'] | string>,
    max?: GraphCacheResolver<WithTypename<Performance_Evaluations_Aggregate_Fields>, Record<string, never>, WithTypename<Performance_Evaluations_Max_Fields> | string>,
    min?: GraphCacheResolver<WithTypename<Performance_Evaluations_Aggregate_Fields>, Record<string, never>, WithTypename<Performance_Evaluations_Min_Fields> | string>,
    stddev?: GraphCacheResolver<WithTypename<Performance_Evaluations_Aggregate_Fields>, Record<string, never>, WithTypename<Performance_Evaluations_Stddev_Fields> | string>,
    stddev_pop?: GraphCacheResolver<WithTypename<Performance_Evaluations_Aggregate_Fields>, Record<string, never>, WithTypename<Performance_Evaluations_Stddev_Pop_Fields> | string>,
    stddev_samp?: GraphCacheResolver<WithTypename<Performance_Evaluations_Aggregate_Fields>, Record<string, never>, WithTypename<Performance_Evaluations_Stddev_Samp_Fields> | string>,
    sum?: GraphCacheResolver<WithTypename<Performance_Evaluations_Aggregate_Fields>, Record<string, never>, WithTypename<Performance_Evaluations_Sum_Fields> | string>,
    var_pop?: GraphCacheResolver<WithTypename<Performance_Evaluations_Aggregate_Fields>, Record<string, never>, WithTypename<Performance_Evaluations_Var_Pop_Fields> | string>,
    var_samp?: GraphCacheResolver<WithTypename<Performance_Evaluations_Aggregate_Fields>, Record<string, never>, WithTypename<Performance_Evaluations_Var_Samp_Fields> | string>,
    variance?: GraphCacheResolver<WithTypename<Performance_Evaluations_Aggregate_Fields>, Record<string, never>, WithTypename<Performance_Evaluations_Variance_Fields> | string>
  },
  performance_evaluations_avg_fields?: {
    casing_pressure_psia?: GraphCacheResolver<WithTypename<Performance_Evaluations_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    gas_rate_mscf_day?: GraphCacheResolver<WithTypename<Performance_Evaluations_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    intake_override_gas_separation_percent?: GraphCacheResolver<WithTypename<Performance_Evaluations_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    natural_override_gas_separation_percent?: GraphCacheResolver<WithTypename<Performance_Evaluations_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    oil_rate_std_barrel_day?: GraphCacheResolver<WithTypename<Performance_Evaluations_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pump_hz?: GraphCacheResolver<WithTypename<Performance_Evaluations_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pump_intake_pressure_psia?: GraphCacheResolver<WithTypename<Performance_Evaluations_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pump_wear_brake_horsepower_correction_ratio?: GraphCacheResolver<WithTypename<Performance_Evaluations_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pump_wear_head_correction_ratio?: GraphCacheResolver<WithTypename<Performance_Evaluations_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    tubing_pressure_psia?: GraphCacheResolver<WithTypename<Performance_Evaluations_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    water_rate_std_barrel_day?: GraphCacheResolver<WithTypename<Performance_Evaluations_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  performance_evaluations_max_fields?: {
    casing_pressure_psia?: GraphCacheResolver<WithTypename<Performance_Evaluations_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    gas_rate_mscf_day?: GraphCacheResolver<WithTypename<Performance_Evaluations_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    id?: GraphCacheResolver<WithTypename<Performance_Evaluations_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    intake_gas_separation_override_type?: GraphCacheResolver<WithTypename<Performance_Evaluations_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    intake_override_gas_separation_percent?: GraphCacheResolver<WithTypename<Performance_Evaluations_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    journal_author_id?: GraphCacheResolver<WithTypename<Performance_Evaluations_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    journal_created_at?: GraphCacheResolver<WithTypename<Performance_Evaluations_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    journal_deleted_at?: GraphCacheResolver<WithTypename<Performance_Evaluations_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    journal_updated_at?: GraphCacheResolver<WithTypename<Performance_Evaluations_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    natural_gas_separation_override_type?: GraphCacheResolver<WithTypename<Performance_Evaluations_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    natural_override_gas_separation_percent?: GraphCacheResolver<WithTypename<Performance_Evaluations_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    oil_rate_std_barrel_day?: GraphCacheResolver<WithTypename<Performance_Evaluations_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    parent_id?: GraphCacheResolver<WithTypename<Performance_Evaluations_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    pump_hz?: GraphCacheResolver<WithTypename<Performance_Evaluations_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    pump_intake_pressure_psia?: GraphCacheResolver<WithTypename<Performance_Evaluations_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    pump_wear_brake_horsepower_correction_ratio?: GraphCacheResolver<WithTypename<Performance_Evaluations_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    pump_wear_head_correction_ratio?: GraphCacheResolver<WithTypename<Performance_Evaluations_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    scenario_id?: GraphCacheResolver<WithTypename<Performance_Evaluations_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    title?: GraphCacheResolver<WithTypename<Performance_Evaluations_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    tubing_pressure_psia?: GraphCacheResolver<WithTypename<Performance_Evaluations_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    water_rate_std_barrel_day?: GraphCacheResolver<WithTypename<Performance_Evaluations_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    winning_revision_author_id?: GraphCacheResolver<WithTypename<Performance_Evaluations_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    winning_revision_created_at?: GraphCacheResolver<WithTypename<Performance_Evaluations_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    winning_revision_deleted_at?: GraphCacheResolver<WithTypename<Performance_Evaluations_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    winning_revision_id?: GraphCacheResolver<WithTypename<Performance_Evaluations_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    winning_revision_parent_id?: GraphCacheResolver<WithTypename<Performance_Evaluations_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    winning_revision_updated_at?: GraphCacheResolver<WithTypename<Performance_Evaluations_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>
  },
  performance_evaluations_min_fields?: {
    casing_pressure_psia?: GraphCacheResolver<WithTypename<Performance_Evaluations_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    gas_rate_mscf_day?: GraphCacheResolver<WithTypename<Performance_Evaluations_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    id?: GraphCacheResolver<WithTypename<Performance_Evaluations_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    intake_gas_separation_override_type?: GraphCacheResolver<WithTypename<Performance_Evaluations_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    intake_override_gas_separation_percent?: GraphCacheResolver<WithTypename<Performance_Evaluations_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    journal_author_id?: GraphCacheResolver<WithTypename<Performance_Evaluations_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    journal_created_at?: GraphCacheResolver<WithTypename<Performance_Evaluations_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    journal_deleted_at?: GraphCacheResolver<WithTypename<Performance_Evaluations_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    journal_updated_at?: GraphCacheResolver<WithTypename<Performance_Evaluations_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    natural_gas_separation_override_type?: GraphCacheResolver<WithTypename<Performance_Evaluations_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    natural_override_gas_separation_percent?: GraphCacheResolver<WithTypename<Performance_Evaluations_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    oil_rate_std_barrel_day?: GraphCacheResolver<WithTypename<Performance_Evaluations_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    parent_id?: GraphCacheResolver<WithTypename<Performance_Evaluations_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    pump_hz?: GraphCacheResolver<WithTypename<Performance_Evaluations_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    pump_intake_pressure_psia?: GraphCacheResolver<WithTypename<Performance_Evaluations_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    pump_wear_brake_horsepower_correction_ratio?: GraphCacheResolver<WithTypename<Performance_Evaluations_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    pump_wear_head_correction_ratio?: GraphCacheResolver<WithTypename<Performance_Evaluations_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    scenario_id?: GraphCacheResolver<WithTypename<Performance_Evaluations_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    title?: GraphCacheResolver<WithTypename<Performance_Evaluations_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    tubing_pressure_psia?: GraphCacheResolver<WithTypename<Performance_Evaluations_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    water_rate_std_barrel_day?: GraphCacheResolver<WithTypename<Performance_Evaluations_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    winning_revision_author_id?: GraphCacheResolver<WithTypename<Performance_Evaluations_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    winning_revision_created_at?: GraphCacheResolver<WithTypename<Performance_Evaluations_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    winning_revision_deleted_at?: GraphCacheResolver<WithTypename<Performance_Evaluations_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    winning_revision_id?: GraphCacheResolver<WithTypename<Performance_Evaluations_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    winning_revision_parent_id?: GraphCacheResolver<WithTypename<Performance_Evaluations_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    winning_revision_updated_at?: GraphCacheResolver<WithTypename<Performance_Evaluations_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>
  },
  performance_evaluations_stddev_fields?: {
    casing_pressure_psia?: GraphCacheResolver<WithTypename<Performance_Evaluations_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    gas_rate_mscf_day?: GraphCacheResolver<WithTypename<Performance_Evaluations_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    intake_override_gas_separation_percent?: GraphCacheResolver<WithTypename<Performance_Evaluations_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    natural_override_gas_separation_percent?: GraphCacheResolver<WithTypename<Performance_Evaluations_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    oil_rate_std_barrel_day?: GraphCacheResolver<WithTypename<Performance_Evaluations_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pump_hz?: GraphCacheResolver<WithTypename<Performance_Evaluations_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pump_intake_pressure_psia?: GraphCacheResolver<WithTypename<Performance_Evaluations_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pump_wear_brake_horsepower_correction_ratio?: GraphCacheResolver<WithTypename<Performance_Evaluations_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pump_wear_head_correction_ratio?: GraphCacheResolver<WithTypename<Performance_Evaluations_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    tubing_pressure_psia?: GraphCacheResolver<WithTypename<Performance_Evaluations_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    water_rate_std_barrel_day?: GraphCacheResolver<WithTypename<Performance_Evaluations_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  performance_evaluations_stddev_pop_fields?: {
    casing_pressure_psia?: GraphCacheResolver<WithTypename<Performance_Evaluations_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    gas_rate_mscf_day?: GraphCacheResolver<WithTypename<Performance_Evaluations_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    intake_override_gas_separation_percent?: GraphCacheResolver<WithTypename<Performance_Evaluations_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    natural_override_gas_separation_percent?: GraphCacheResolver<WithTypename<Performance_Evaluations_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    oil_rate_std_barrel_day?: GraphCacheResolver<WithTypename<Performance_Evaluations_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pump_hz?: GraphCacheResolver<WithTypename<Performance_Evaluations_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pump_intake_pressure_psia?: GraphCacheResolver<WithTypename<Performance_Evaluations_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pump_wear_brake_horsepower_correction_ratio?: GraphCacheResolver<WithTypename<Performance_Evaluations_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pump_wear_head_correction_ratio?: GraphCacheResolver<WithTypename<Performance_Evaluations_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    tubing_pressure_psia?: GraphCacheResolver<WithTypename<Performance_Evaluations_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    water_rate_std_barrel_day?: GraphCacheResolver<WithTypename<Performance_Evaluations_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  performance_evaluations_stddev_samp_fields?: {
    casing_pressure_psia?: GraphCacheResolver<WithTypename<Performance_Evaluations_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    gas_rate_mscf_day?: GraphCacheResolver<WithTypename<Performance_Evaluations_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    intake_override_gas_separation_percent?: GraphCacheResolver<WithTypename<Performance_Evaluations_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    natural_override_gas_separation_percent?: GraphCacheResolver<WithTypename<Performance_Evaluations_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    oil_rate_std_barrel_day?: GraphCacheResolver<WithTypename<Performance_Evaluations_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pump_hz?: GraphCacheResolver<WithTypename<Performance_Evaluations_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pump_intake_pressure_psia?: GraphCacheResolver<WithTypename<Performance_Evaluations_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pump_wear_brake_horsepower_correction_ratio?: GraphCacheResolver<WithTypename<Performance_Evaluations_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pump_wear_head_correction_ratio?: GraphCacheResolver<WithTypename<Performance_Evaluations_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    tubing_pressure_psia?: GraphCacheResolver<WithTypename<Performance_Evaluations_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    water_rate_std_barrel_day?: GraphCacheResolver<WithTypename<Performance_Evaluations_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  performance_evaluations_sum_fields?: {
    casing_pressure_psia?: GraphCacheResolver<WithTypename<Performance_Evaluations_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    gas_rate_mscf_day?: GraphCacheResolver<WithTypename<Performance_Evaluations_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    intake_override_gas_separation_percent?: GraphCacheResolver<WithTypename<Performance_Evaluations_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    natural_override_gas_separation_percent?: GraphCacheResolver<WithTypename<Performance_Evaluations_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    oil_rate_std_barrel_day?: GraphCacheResolver<WithTypename<Performance_Evaluations_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    pump_hz?: GraphCacheResolver<WithTypename<Performance_Evaluations_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    pump_intake_pressure_psia?: GraphCacheResolver<WithTypename<Performance_Evaluations_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    pump_wear_brake_horsepower_correction_ratio?: GraphCacheResolver<WithTypename<Performance_Evaluations_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    pump_wear_head_correction_ratio?: GraphCacheResolver<WithTypename<Performance_Evaluations_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    tubing_pressure_psia?: GraphCacheResolver<WithTypename<Performance_Evaluations_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    water_rate_std_barrel_day?: GraphCacheResolver<WithTypename<Performance_Evaluations_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>
  },
  performance_evaluations_var_pop_fields?: {
    casing_pressure_psia?: GraphCacheResolver<WithTypename<Performance_Evaluations_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    gas_rate_mscf_day?: GraphCacheResolver<WithTypename<Performance_Evaluations_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    intake_override_gas_separation_percent?: GraphCacheResolver<WithTypename<Performance_Evaluations_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    natural_override_gas_separation_percent?: GraphCacheResolver<WithTypename<Performance_Evaluations_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    oil_rate_std_barrel_day?: GraphCacheResolver<WithTypename<Performance_Evaluations_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pump_hz?: GraphCacheResolver<WithTypename<Performance_Evaluations_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pump_intake_pressure_psia?: GraphCacheResolver<WithTypename<Performance_Evaluations_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pump_wear_brake_horsepower_correction_ratio?: GraphCacheResolver<WithTypename<Performance_Evaluations_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pump_wear_head_correction_ratio?: GraphCacheResolver<WithTypename<Performance_Evaluations_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    tubing_pressure_psia?: GraphCacheResolver<WithTypename<Performance_Evaluations_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    water_rate_std_barrel_day?: GraphCacheResolver<WithTypename<Performance_Evaluations_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  performance_evaluations_var_samp_fields?: {
    casing_pressure_psia?: GraphCacheResolver<WithTypename<Performance_Evaluations_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    gas_rate_mscf_day?: GraphCacheResolver<WithTypename<Performance_Evaluations_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    intake_override_gas_separation_percent?: GraphCacheResolver<WithTypename<Performance_Evaluations_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    natural_override_gas_separation_percent?: GraphCacheResolver<WithTypename<Performance_Evaluations_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    oil_rate_std_barrel_day?: GraphCacheResolver<WithTypename<Performance_Evaluations_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pump_hz?: GraphCacheResolver<WithTypename<Performance_Evaluations_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pump_intake_pressure_psia?: GraphCacheResolver<WithTypename<Performance_Evaluations_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pump_wear_brake_horsepower_correction_ratio?: GraphCacheResolver<WithTypename<Performance_Evaluations_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pump_wear_head_correction_ratio?: GraphCacheResolver<WithTypename<Performance_Evaluations_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    tubing_pressure_psia?: GraphCacheResolver<WithTypename<Performance_Evaluations_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    water_rate_std_barrel_day?: GraphCacheResolver<WithTypename<Performance_Evaluations_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  performance_evaluations_variance_fields?: {
    casing_pressure_psia?: GraphCacheResolver<WithTypename<Performance_Evaluations_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    gas_rate_mscf_day?: GraphCacheResolver<WithTypename<Performance_Evaluations_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    intake_override_gas_separation_percent?: GraphCacheResolver<WithTypename<Performance_Evaluations_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    natural_override_gas_separation_percent?: GraphCacheResolver<WithTypename<Performance_Evaluations_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    oil_rate_std_barrel_day?: GraphCacheResolver<WithTypename<Performance_Evaluations_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pump_hz?: GraphCacheResolver<WithTypename<Performance_Evaluations_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pump_intake_pressure_psia?: GraphCacheResolver<WithTypename<Performance_Evaluations_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pump_wear_brake_horsepower_correction_ratio?: GraphCacheResolver<WithTypename<Performance_Evaluations_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pump_wear_head_correction_ratio?: GraphCacheResolver<WithTypename<Performance_Evaluations_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    tubing_pressure_psia?: GraphCacheResolver<WithTypename<Performance_Evaluations_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    water_rate_std_barrel_day?: GraphCacheResolver<WithTypename<Performance_Evaluations_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  performance_evaluations_xref_pumps?: {
    brake_horsepower_correction_ratio?: GraphCacheResolver<WithTypename<Performance_Evaluations_Xref_Pumps>, Record<string, never>, Scalars['numeric'] | string>,
    head_correction_ratio?: GraphCacheResolver<WithTypename<Performance_Evaluations_Xref_Pumps>, Record<string, never>, Scalars['numeric'] | string>,
    id?: GraphCacheResolver<WithTypename<Performance_Evaluations_Xref_Pumps>, Record<string, never>, Scalars['uuid'] | string>,
    journal_author_id?: GraphCacheResolver<WithTypename<Performance_Evaluations_Xref_Pumps>, Record<string, never>, Scalars['String'] | string>,
    journal_created_at?: GraphCacheResolver<WithTypename<Performance_Evaluations_Xref_Pumps>, Record<string, never>, Scalars['timestamptz'] | string>,
    journal_deleted_at?: GraphCacheResolver<WithTypename<Performance_Evaluations_Xref_Pumps>, Record<string, never>, Scalars['timestamptz'] | string>,
    journal_updated_at?: GraphCacheResolver<WithTypename<Performance_Evaluations_Xref_Pumps>, Record<string, never>, Scalars['timestamptz'] | string>,
    parent_id?: GraphCacheResolver<WithTypename<Performance_Evaluations_Xref_Pumps>, Record<string, never>, Scalars['uuid'] | string>,
    performance_evaluation?: GraphCacheResolver<WithTypename<Performance_Evaluations_Xref_Pumps>, Record<string, never>, WithTypename<Performance_Evaluations> | string>,
    performance_evaluation_id?: GraphCacheResolver<WithTypename<Performance_Evaluations_Xref_Pumps>, Record<string, never>, Scalars['uuid'] | string>,
    rate_correction_ratio?: GraphCacheResolver<WithTypename<Performance_Evaluations_Xref_Pumps>, Record<string, never>, Scalars['numeric'] | string>,
    winning_revision_author_id?: GraphCacheResolver<WithTypename<Performance_Evaluations_Xref_Pumps>, Record<string, never>, Scalars['String'] | string>,
    winning_revision_created_at?: GraphCacheResolver<WithTypename<Performance_Evaluations_Xref_Pumps>, Record<string, never>, Scalars['timestamptz'] | string>,
    winning_revision_deleted_at?: GraphCacheResolver<WithTypename<Performance_Evaluations_Xref_Pumps>, Record<string, never>, Scalars['timestamptz'] | string>,
    winning_revision_id?: GraphCacheResolver<WithTypename<Performance_Evaluations_Xref_Pumps>, Record<string, never>, Scalars['uuid'] | string>,
    winning_revision_parent_id?: GraphCacheResolver<WithTypename<Performance_Evaluations_Xref_Pumps>, Record<string, never>, Scalars['uuid'] | string>,
    winning_revision_updated_at?: GraphCacheResolver<WithTypename<Performance_Evaluations_Xref_Pumps>, Record<string, never>, Scalars['timestamptz'] | string>,
    xref_pump_id?: GraphCacheResolver<WithTypename<Performance_Evaluations_Xref_Pumps>, Record<string, never>, Scalars['uuid'] | string>
  },
  performance_evaluations_xref_pumps_aggregate?: {
    aggregate?: GraphCacheResolver<WithTypename<Performance_Evaluations_Xref_Pumps_Aggregate>, Record<string, never>, WithTypename<Performance_Evaluations_Xref_Pumps_Aggregate_Fields> | string>,
    nodes?: GraphCacheResolver<WithTypename<Performance_Evaluations_Xref_Pumps_Aggregate>, Record<string, never>, Array<WithTypename<Performance_Evaluations_Xref_Pumps> | string>>
  },
  performance_evaluations_xref_pumps_aggregate_fields?: {
    avg?: GraphCacheResolver<WithTypename<Performance_Evaluations_Xref_Pumps_Aggregate_Fields>, Record<string, never>, WithTypename<Performance_Evaluations_Xref_Pumps_Avg_Fields> | string>,
    count?: GraphCacheResolver<WithTypename<Performance_Evaluations_Xref_Pumps_Aggregate_Fields>, Performance_Evaluations_Xref_Pumps_Aggregate_FieldsCountArgs, Scalars['Int'] | string>,
    max?: GraphCacheResolver<WithTypename<Performance_Evaluations_Xref_Pumps_Aggregate_Fields>, Record<string, never>, WithTypename<Performance_Evaluations_Xref_Pumps_Max_Fields> | string>,
    min?: GraphCacheResolver<WithTypename<Performance_Evaluations_Xref_Pumps_Aggregate_Fields>, Record<string, never>, WithTypename<Performance_Evaluations_Xref_Pumps_Min_Fields> | string>,
    stddev?: GraphCacheResolver<WithTypename<Performance_Evaluations_Xref_Pumps_Aggregate_Fields>, Record<string, never>, WithTypename<Performance_Evaluations_Xref_Pumps_Stddev_Fields> | string>,
    stddev_pop?: GraphCacheResolver<WithTypename<Performance_Evaluations_Xref_Pumps_Aggregate_Fields>, Record<string, never>, WithTypename<Performance_Evaluations_Xref_Pumps_Stddev_Pop_Fields> | string>,
    stddev_samp?: GraphCacheResolver<WithTypename<Performance_Evaluations_Xref_Pumps_Aggregate_Fields>, Record<string, never>, WithTypename<Performance_Evaluations_Xref_Pumps_Stddev_Samp_Fields> | string>,
    sum?: GraphCacheResolver<WithTypename<Performance_Evaluations_Xref_Pumps_Aggregate_Fields>, Record<string, never>, WithTypename<Performance_Evaluations_Xref_Pumps_Sum_Fields> | string>,
    var_pop?: GraphCacheResolver<WithTypename<Performance_Evaluations_Xref_Pumps_Aggregate_Fields>, Record<string, never>, WithTypename<Performance_Evaluations_Xref_Pumps_Var_Pop_Fields> | string>,
    var_samp?: GraphCacheResolver<WithTypename<Performance_Evaluations_Xref_Pumps_Aggregate_Fields>, Record<string, never>, WithTypename<Performance_Evaluations_Xref_Pumps_Var_Samp_Fields> | string>,
    variance?: GraphCacheResolver<WithTypename<Performance_Evaluations_Xref_Pumps_Aggregate_Fields>, Record<string, never>, WithTypename<Performance_Evaluations_Xref_Pumps_Variance_Fields> | string>
  },
  performance_evaluations_xref_pumps_avg_fields?: {
    brake_horsepower_correction_ratio?: GraphCacheResolver<WithTypename<Performance_Evaluations_Xref_Pumps_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    head_correction_ratio?: GraphCacheResolver<WithTypename<Performance_Evaluations_Xref_Pumps_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    rate_correction_ratio?: GraphCacheResolver<WithTypename<Performance_Evaluations_Xref_Pumps_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  performance_evaluations_xref_pumps_max_fields?: {
    brake_horsepower_correction_ratio?: GraphCacheResolver<WithTypename<Performance_Evaluations_Xref_Pumps_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    head_correction_ratio?: GraphCacheResolver<WithTypename<Performance_Evaluations_Xref_Pumps_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    id?: GraphCacheResolver<WithTypename<Performance_Evaluations_Xref_Pumps_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    journal_author_id?: GraphCacheResolver<WithTypename<Performance_Evaluations_Xref_Pumps_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    journal_created_at?: GraphCacheResolver<WithTypename<Performance_Evaluations_Xref_Pumps_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    journal_deleted_at?: GraphCacheResolver<WithTypename<Performance_Evaluations_Xref_Pumps_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    journal_updated_at?: GraphCacheResolver<WithTypename<Performance_Evaluations_Xref_Pumps_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    parent_id?: GraphCacheResolver<WithTypename<Performance_Evaluations_Xref_Pumps_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    performance_evaluation_id?: GraphCacheResolver<WithTypename<Performance_Evaluations_Xref_Pumps_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    rate_correction_ratio?: GraphCacheResolver<WithTypename<Performance_Evaluations_Xref_Pumps_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    winning_revision_author_id?: GraphCacheResolver<WithTypename<Performance_Evaluations_Xref_Pumps_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    winning_revision_created_at?: GraphCacheResolver<WithTypename<Performance_Evaluations_Xref_Pumps_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    winning_revision_deleted_at?: GraphCacheResolver<WithTypename<Performance_Evaluations_Xref_Pumps_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    winning_revision_id?: GraphCacheResolver<WithTypename<Performance_Evaluations_Xref_Pumps_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    winning_revision_parent_id?: GraphCacheResolver<WithTypename<Performance_Evaluations_Xref_Pumps_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    winning_revision_updated_at?: GraphCacheResolver<WithTypename<Performance_Evaluations_Xref_Pumps_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    xref_pump_id?: GraphCacheResolver<WithTypename<Performance_Evaluations_Xref_Pumps_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>
  },
  performance_evaluations_xref_pumps_min_fields?: {
    brake_horsepower_correction_ratio?: GraphCacheResolver<WithTypename<Performance_Evaluations_Xref_Pumps_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    head_correction_ratio?: GraphCacheResolver<WithTypename<Performance_Evaluations_Xref_Pumps_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    id?: GraphCacheResolver<WithTypename<Performance_Evaluations_Xref_Pumps_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    journal_author_id?: GraphCacheResolver<WithTypename<Performance_Evaluations_Xref_Pumps_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    journal_created_at?: GraphCacheResolver<WithTypename<Performance_Evaluations_Xref_Pumps_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    journal_deleted_at?: GraphCacheResolver<WithTypename<Performance_Evaluations_Xref_Pumps_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    journal_updated_at?: GraphCacheResolver<WithTypename<Performance_Evaluations_Xref_Pumps_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    parent_id?: GraphCacheResolver<WithTypename<Performance_Evaluations_Xref_Pumps_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    performance_evaluation_id?: GraphCacheResolver<WithTypename<Performance_Evaluations_Xref_Pumps_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    rate_correction_ratio?: GraphCacheResolver<WithTypename<Performance_Evaluations_Xref_Pumps_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    winning_revision_author_id?: GraphCacheResolver<WithTypename<Performance_Evaluations_Xref_Pumps_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    winning_revision_created_at?: GraphCacheResolver<WithTypename<Performance_Evaluations_Xref_Pumps_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    winning_revision_deleted_at?: GraphCacheResolver<WithTypename<Performance_Evaluations_Xref_Pumps_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    winning_revision_id?: GraphCacheResolver<WithTypename<Performance_Evaluations_Xref_Pumps_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    winning_revision_parent_id?: GraphCacheResolver<WithTypename<Performance_Evaluations_Xref_Pumps_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    winning_revision_updated_at?: GraphCacheResolver<WithTypename<Performance_Evaluations_Xref_Pumps_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    xref_pump_id?: GraphCacheResolver<WithTypename<Performance_Evaluations_Xref_Pumps_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>
  },
  performance_evaluations_xref_pumps_stddev_fields?: {
    brake_horsepower_correction_ratio?: GraphCacheResolver<WithTypename<Performance_Evaluations_Xref_Pumps_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    head_correction_ratio?: GraphCacheResolver<WithTypename<Performance_Evaluations_Xref_Pumps_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    rate_correction_ratio?: GraphCacheResolver<WithTypename<Performance_Evaluations_Xref_Pumps_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  performance_evaluations_xref_pumps_stddev_pop_fields?: {
    brake_horsepower_correction_ratio?: GraphCacheResolver<WithTypename<Performance_Evaluations_Xref_Pumps_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    head_correction_ratio?: GraphCacheResolver<WithTypename<Performance_Evaluations_Xref_Pumps_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    rate_correction_ratio?: GraphCacheResolver<WithTypename<Performance_Evaluations_Xref_Pumps_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  performance_evaluations_xref_pumps_stddev_samp_fields?: {
    brake_horsepower_correction_ratio?: GraphCacheResolver<WithTypename<Performance_Evaluations_Xref_Pumps_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    head_correction_ratio?: GraphCacheResolver<WithTypename<Performance_Evaluations_Xref_Pumps_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    rate_correction_ratio?: GraphCacheResolver<WithTypename<Performance_Evaluations_Xref_Pumps_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  performance_evaluations_xref_pumps_sum_fields?: {
    brake_horsepower_correction_ratio?: GraphCacheResolver<WithTypename<Performance_Evaluations_Xref_Pumps_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    head_correction_ratio?: GraphCacheResolver<WithTypename<Performance_Evaluations_Xref_Pumps_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    rate_correction_ratio?: GraphCacheResolver<WithTypename<Performance_Evaluations_Xref_Pumps_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>
  },
  performance_evaluations_xref_pumps_var_pop_fields?: {
    brake_horsepower_correction_ratio?: GraphCacheResolver<WithTypename<Performance_Evaluations_Xref_Pumps_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    head_correction_ratio?: GraphCacheResolver<WithTypename<Performance_Evaluations_Xref_Pumps_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    rate_correction_ratio?: GraphCacheResolver<WithTypename<Performance_Evaluations_Xref_Pumps_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  performance_evaluations_xref_pumps_var_samp_fields?: {
    brake_horsepower_correction_ratio?: GraphCacheResolver<WithTypename<Performance_Evaluations_Xref_Pumps_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    head_correction_ratio?: GraphCacheResolver<WithTypename<Performance_Evaluations_Xref_Pumps_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    rate_correction_ratio?: GraphCacheResolver<WithTypename<Performance_Evaluations_Xref_Pumps_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  performance_evaluations_xref_pumps_variance_fields?: {
    brake_horsepower_correction_ratio?: GraphCacheResolver<WithTypename<Performance_Evaluations_Xref_Pumps_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    head_correction_ratio?: GraphCacheResolver<WithTypename<Performance_Evaluations_Xref_Pumps_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    rate_correction_ratio?: GraphCacheResolver<WithTypename<Performance_Evaluations_Xref_Pumps_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  pumps?: {
    author_id?: GraphCacheResolver<WithTypename<Pumps>, Record<string, never>, Scalars['String'] | string>,
    bep_rate_standard_pump_bpd?: GraphCacheResolver<WithTypename<Pumps>, Record<string, never>, Scalars['Int'] | string>,
    bhp1?: GraphCacheResolver<WithTypename<Pumps>, Record<string, never>, Scalars['numeric'] | string>,
    bhp2?: GraphCacheResolver<WithTypename<Pumps>, Record<string, never>, Scalars['numeric'] | string>,
    bhp3?: GraphCacheResolver<WithTypename<Pumps>, Record<string, never>, Scalars['numeric'] | string>,
    bhp4?: GraphCacheResolver<WithTypename<Pumps>, Record<string, never>, Scalars['numeric'] | string>,
    bhp5?: GraphCacheResolver<WithTypename<Pumps>, Record<string, never>, Scalars['numeric'] | string>,
    bhpb?: GraphCacheResolver<WithTypename<Pumps>, Record<string, never>, Scalars['numeric'] | string>,
    compression_thrust_per_stage?: GraphCacheResolver<WithTypename<Pumps>, Record<string, never>, Scalars['numeric'] | string>,
    construction?: GraphCacheResolver<WithTypename<Pumps>, Record<string, never>, Scalars['String'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Pumps>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Pumps>, Record<string, never>, Scalars['timestamptz'] | string>,
    h1?: GraphCacheResolver<WithTypename<Pumps>, Record<string, never>, Scalars['numeric'] | string>,
    h2?: GraphCacheResolver<WithTypename<Pumps>, Record<string, never>, Scalars['numeric'] | string>,
    h3?: GraphCacheResolver<WithTypename<Pumps>, Record<string, never>, Scalars['numeric'] | string>,
    h4?: GraphCacheResolver<WithTypename<Pumps>, Record<string, never>, Scalars['numeric'] | string>,
    h5?: GraphCacheResolver<WithTypename<Pumps>, Record<string, never>, Scalars['numeric'] | string>,
    hb?: GraphCacheResolver<WithTypename<Pumps>, Record<string, never>, Scalars['numeric'] | string>,
    high_strength_housing_pressure_rating_psi?: GraphCacheResolver<WithTypename<Pumps>, Record<string, never>, Scalars['Int'] | string>,
    high_strength_shaft_rating_hp?: GraphCacheResolver<WithTypename<Pumps>, Record<string, never>, Scalars['Int'] | string>,
    housing_inner_diameter_inches?: GraphCacheResolver<WithTypename<Pumps>, Record<string, never>, Scalars['numeric'] | string>,
    housing_outer_diameter_inches?: GraphCacheResolver<WithTypename<Pumps>, Record<string, never>, Scalars['numeric'] | string>,
    housings?: GraphCacheResolver<WithTypename<Pumps>, PumpsHousingsArgs, Array<WithTypename<Housings> | string>>,
    housings_aggregate?: GraphCacheResolver<WithTypename<Pumps>, PumpsHousings_AggregateArgs, WithTypename<Housings_Aggregate> | string>,
    id?: GraphCacheResolver<WithTypename<Pumps>, Record<string, never>, Scalars['uuid'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Pumps>, Record<string, never>, Scalars['Int'] | string>,
    include_ecopetrol_timestamp?: GraphCacheResolver<WithTypename<Pumps>, Record<string, never>, Scalars['timestamptz'] | string>,
    include_koc_timestamp?: GraphCacheResolver<WithTypename<Pumps>, Record<string, never>, Scalars['timestamptz'] | string>,
    is_compression_pump?: GraphCacheResolver<WithTypename<Pumps>, Record<string, never>, Scalars['Boolean'] | string>,
    manufacturer?: GraphCacheResolver<WithTypename<Pumps>, Record<string, never>, Scalars['String'] | string>,
    max_bolt_load_pounds?: GraphCacheResolver<WithTypename<Pumps>, Record<string, never>, Scalars['numeric'] | string>,
    max_graph_rate_standard_pump_bpd?: GraphCacheResolver<WithTypename<Pumps>, Record<string, never>, Scalars['Int'] | string>,
    max_rate_standard_pump_bpd?: GraphCacheResolver<WithTypename<Pumps>, Record<string, never>, Scalars['Int'] | string>,
    min_rate_standard_pump_bpd?: GraphCacheResolver<WithTypename<Pumps>, Record<string, never>, Scalars['Int'] | string>,
    neck_inner_diameter_inches?: GraphCacheResolver<WithTypename<Pumps>, Record<string, never>, Scalars['numeric'] | string>,
    neck_outer_diameter_inches?: GraphCacheResolver<WithTypename<Pumps>, Record<string, never>, Scalars['numeric'] | string>,
    npsh1?: GraphCacheResolver<WithTypename<Pumps>, Record<string, never>, Scalars['numeric'] | string>,
    npsh2?: GraphCacheResolver<WithTypename<Pumps>, Record<string, never>, Scalars['numeric'] | string>,
    npsh3?: GraphCacheResolver<WithTypename<Pumps>, Record<string, never>, Scalars['numeric'] | string>,
    npsh4?: GraphCacheResolver<WithTypename<Pumps>, Record<string, never>, Scalars['numeric'] | string>,
    only_ecopetrol_timestamp?: GraphCacheResolver<WithTypename<Pumps>, Record<string, never>, Scalars['timestamptz'] | string>,
    only_koc_timestamp?: GraphCacheResolver<WithTypename<Pumps>, Record<string, never>, Scalars['timestamptz'] | string>,
    part_number?: GraphCacheResolver<WithTypename<Pumps>, Record<string, never>, Scalars['String'] | string>,
    prioritized_manufacturer?: GraphCacheResolver<WithTypename<Pumps>, Record<string, never>, Scalars['String'] | string>,
    rotation?: GraphCacheResolver<WithTypename<Pumps>, Record<string, never>, Scalars['String'] | string>,
    series_model?: GraphCacheResolver<WithTypename<Pumps>, Record<string, never>, Scalars['String'] | string>,
    shaft_diameter_inches?: GraphCacheResolver<WithTypename<Pumps>, Record<string, never>, Scalars['numeric'] | string>,
    sizing_import?: GraphCacheResolver<WithTypename<Pumps>, Record<string, never>, WithTypename<Sizing_Imports> | string>,
    stage_type?: GraphCacheResolver<WithTypename<Pumps>, Record<string, never>, Scalars['Int'] | string>,
    standard_housing_pressure_rating_psi?: GraphCacheResolver<WithTypename<Pumps>, Record<string, never>, Scalars['Int'] | string>,
    standard_shaft_rating_hp?: GraphCacheResolver<WithTypename<Pumps>, Record<string, never>, Scalars['Int'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Pumps>, Record<string, never>, Scalars['timestamptz'] | string>,
    user?: GraphCacheResolver<WithTypename<Pumps>, Record<string, never>, WithTypename<Users> | string>
  },
  pumps_aggregate?: {
    aggregate?: GraphCacheResolver<WithTypename<Pumps_Aggregate>, Record<string, never>, WithTypename<Pumps_Aggregate_Fields> | string>,
    nodes?: GraphCacheResolver<WithTypename<Pumps_Aggregate>, Record<string, never>, Array<WithTypename<Pumps> | string>>
  },
  pumps_aggregate_fields?: {
    avg?: GraphCacheResolver<WithTypename<Pumps_Aggregate_Fields>, Record<string, never>, WithTypename<Pumps_Avg_Fields> | string>,
    count?: GraphCacheResolver<WithTypename<Pumps_Aggregate_Fields>, Pumps_Aggregate_FieldsCountArgs, Scalars['Int'] | string>,
    max?: GraphCacheResolver<WithTypename<Pumps_Aggregate_Fields>, Record<string, never>, WithTypename<Pumps_Max_Fields> | string>,
    min?: GraphCacheResolver<WithTypename<Pumps_Aggregate_Fields>, Record<string, never>, WithTypename<Pumps_Min_Fields> | string>,
    stddev?: GraphCacheResolver<WithTypename<Pumps_Aggregate_Fields>, Record<string, never>, WithTypename<Pumps_Stddev_Fields> | string>,
    stddev_pop?: GraphCacheResolver<WithTypename<Pumps_Aggregate_Fields>, Record<string, never>, WithTypename<Pumps_Stddev_Pop_Fields> | string>,
    stddev_samp?: GraphCacheResolver<WithTypename<Pumps_Aggregate_Fields>, Record<string, never>, WithTypename<Pumps_Stddev_Samp_Fields> | string>,
    sum?: GraphCacheResolver<WithTypename<Pumps_Aggregate_Fields>, Record<string, never>, WithTypename<Pumps_Sum_Fields> | string>,
    var_pop?: GraphCacheResolver<WithTypename<Pumps_Aggregate_Fields>, Record<string, never>, WithTypename<Pumps_Var_Pop_Fields> | string>,
    var_samp?: GraphCacheResolver<WithTypename<Pumps_Aggregate_Fields>, Record<string, never>, WithTypename<Pumps_Var_Samp_Fields> | string>,
    variance?: GraphCacheResolver<WithTypename<Pumps_Aggregate_Fields>, Record<string, never>, WithTypename<Pumps_Variance_Fields> | string>
  },
  pumps_avg_fields?: {
    bep_rate_standard_pump_bpd?: GraphCacheResolver<WithTypename<Pumps_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bhp1?: GraphCacheResolver<WithTypename<Pumps_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bhp2?: GraphCacheResolver<WithTypename<Pumps_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bhp3?: GraphCacheResolver<WithTypename<Pumps_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bhp4?: GraphCacheResolver<WithTypename<Pumps_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bhp5?: GraphCacheResolver<WithTypename<Pumps_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bhpb?: GraphCacheResolver<WithTypename<Pumps_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    compression_thrust_per_stage?: GraphCacheResolver<WithTypename<Pumps_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    h1?: GraphCacheResolver<WithTypename<Pumps_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    h2?: GraphCacheResolver<WithTypename<Pumps_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    h3?: GraphCacheResolver<WithTypename<Pumps_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    h4?: GraphCacheResolver<WithTypename<Pumps_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    h5?: GraphCacheResolver<WithTypename<Pumps_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    hb?: GraphCacheResolver<WithTypename<Pumps_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    high_strength_housing_pressure_rating_psi?: GraphCacheResolver<WithTypename<Pumps_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    high_strength_shaft_rating_hp?: GraphCacheResolver<WithTypename<Pumps_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    housing_inner_diameter_inches?: GraphCacheResolver<WithTypename<Pumps_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    housing_outer_diameter_inches?: GraphCacheResolver<WithTypename<Pumps_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Pumps_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    max_bolt_load_pounds?: GraphCacheResolver<WithTypename<Pumps_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    max_graph_rate_standard_pump_bpd?: GraphCacheResolver<WithTypename<Pumps_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    max_rate_standard_pump_bpd?: GraphCacheResolver<WithTypename<Pumps_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    min_rate_standard_pump_bpd?: GraphCacheResolver<WithTypename<Pumps_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    neck_inner_diameter_inches?: GraphCacheResolver<WithTypename<Pumps_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    neck_outer_diameter_inches?: GraphCacheResolver<WithTypename<Pumps_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    npsh1?: GraphCacheResolver<WithTypename<Pumps_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    npsh2?: GraphCacheResolver<WithTypename<Pumps_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    npsh3?: GraphCacheResolver<WithTypename<Pumps_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    npsh4?: GraphCacheResolver<WithTypename<Pumps_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    shaft_diameter_inches?: GraphCacheResolver<WithTypename<Pumps_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    stage_type?: GraphCacheResolver<WithTypename<Pumps_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    standard_housing_pressure_rating_psi?: GraphCacheResolver<WithTypename<Pumps_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    standard_shaft_rating_hp?: GraphCacheResolver<WithTypename<Pumps_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  pumps_max_fields?: {
    author_id?: GraphCacheResolver<WithTypename<Pumps_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    bep_rate_standard_pump_bpd?: GraphCacheResolver<WithTypename<Pumps_Max_Fields>, Record<string, never>, Scalars['Int'] | string>,
    bhp1?: GraphCacheResolver<WithTypename<Pumps_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    bhp2?: GraphCacheResolver<WithTypename<Pumps_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    bhp3?: GraphCacheResolver<WithTypename<Pumps_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    bhp4?: GraphCacheResolver<WithTypename<Pumps_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    bhp5?: GraphCacheResolver<WithTypename<Pumps_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    bhpb?: GraphCacheResolver<WithTypename<Pumps_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    compression_thrust_per_stage?: GraphCacheResolver<WithTypename<Pumps_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    construction?: GraphCacheResolver<WithTypename<Pumps_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Pumps_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Pumps_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    h1?: GraphCacheResolver<WithTypename<Pumps_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    h2?: GraphCacheResolver<WithTypename<Pumps_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    h3?: GraphCacheResolver<WithTypename<Pumps_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    h4?: GraphCacheResolver<WithTypename<Pumps_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    h5?: GraphCacheResolver<WithTypename<Pumps_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    hb?: GraphCacheResolver<WithTypename<Pumps_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    high_strength_housing_pressure_rating_psi?: GraphCacheResolver<WithTypename<Pumps_Max_Fields>, Record<string, never>, Scalars['Int'] | string>,
    high_strength_shaft_rating_hp?: GraphCacheResolver<WithTypename<Pumps_Max_Fields>, Record<string, never>, Scalars['Int'] | string>,
    housing_inner_diameter_inches?: GraphCacheResolver<WithTypename<Pumps_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    housing_outer_diameter_inches?: GraphCacheResolver<WithTypename<Pumps_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    id?: GraphCacheResolver<WithTypename<Pumps_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Pumps_Max_Fields>, Record<string, never>, Scalars['Int'] | string>,
    include_ecopetrol_timestamp?: GraphCacheResolver<WithTypename<Pumps_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    include_koc_timestamp?: GraphCacheResolver<WithTypename<Pumps_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    manufacturer?: GraphCacheResolver<WithTypename<Pumps_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    max_bolt_load_pounds?: GraphCacheResolver<WithTypename<Pumps_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    max_graph_rate_standard_pump_bpd?: GraphCacheResolver<WithTypename<Pumps_Max_Fields>, Record<string, never>, Scalars['Int'] | string>,
    max_rate_standard_pump_bpd?: GraphCacheResolver<WithTypename<Pumps_Max_Fields>, Record<string, never>, Scalars['Int'] | string>,
    min_rate_standard_pump_bpd?: GraphCacheResolver<WithTypename<Pumps_Max_Fields>, Record<string, never>, Scalars['Int'] | string>,
    neck_inner_diameter_inches?: GraphCacheResolver<WithTypename<Pumps_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    neck_outer_diameter_inches?: GraphCacheResolver<WithTypename<Pumps_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    npsh1?: GraphCacheResolver<WithTypename<Pumps_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    npsh2?: GraphCacheResolver<WithTypename<Pumps_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    npsh3?: GraphCacheResolver<WithTypename<Pumps_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    npsh4?: GraphCacheResolver<WithTypename<Pumps_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    only_ecopetrol_timestamp?: GraphCacheResolver<WithTypename<Pumps_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    only_koc_timestamp?: GraphCacheResolver<WithTypename<Pumps_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    part_number?: GraphCacheResolver<WithTypename<Pumps_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    prioritized_manufacturer?: GraphCacheResolver<WithTypename<Pumps_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    rotation?: GraphCacheResolver<WithTypename<Pumps_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    series_model?: GraphCacheResolver<WithTypename<Pumps_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    shaft_diameter_inches?: GraphCacheResolver<WithTypename<Pumps_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    stage_type?: GraphCacheResolver<WithTypename<Pumps_Max_Fields>, Record<string, never>, Scalars['Int'] | string>,
    standard_housing_pressure_rating_psi?: GraphCacheResolver<WithTypename<Pumps_Max_Fields>, Record<string, never>, Scalars['Int'] | string>,
    standard_shaft_rating_hp?: GraphCacheResolver<WithTypename<Pumps_Max_Fields>, Record<string, never>, Scalars['Int'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Pumps_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>
  },
  pumps_min_fields?: {
    author_id?: GraphCacheResolver<WithTypename<Pumps_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    bep_rate_standard_pump_bpd?: GraphCacheResolver<WithTypename<Pumps_Min_Fields>, Record<string, never>, Scalars['Int'] | string>,
    bhp1?: GraphCacheResolver<WithTypename<Pumps_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    bhp2?: GraphCacheResolver<WithTypename<Pumps_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    bhp3?: GraphCacheResolver<WithTypename<Pumps_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    bhp4?: GraphCacheResolver<WithTypename<Pumps_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    bhp5?: GraphCacheResolver<WithTypename<Pumps_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    bhpb?: GraphCacheResolver<WithTypename<Pumps_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    compression_thrust_per_stage?: GraphCacheResolver<WithTypename<Pumps_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    construction?: GraphCacheResolver<WithTypename<Pumps_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Pumps_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Pumps_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    h1?: GraphCacheResolver<WithTypename<Pumps_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    h2?: GraphCacheResolver<WithTypename<Pumps_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    h3?: GraphCacheResolver<WithTypename<Pumps_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    h4?: GraphCacheResolver<WithTypename<Pumps_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    h5?: GraphCacheResolver<WithTypename<Pumps_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    hb?: GraphCacheResolver<WithTypename<Pumps_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    high_strength_housing_pressure_rating_psi?: GraphCacheResolver<WithTypename<Pumps_Min_Fields>, Record<string, never>, Scalars['Int'] | string>,
    high_strength_shaft_rating_hp?: GraphCacheResolver<WithTypename<Pumps_Min_Fields>, Record<string, never>, Scalars['Int'] | string>,
    housing_inner_diameter_inches?: GraphCacheResolver<WithTypename<Pumps_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    housing_outer_diameter_inches?: GraphCacheResolver<WithTypename<Pumps_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    id?: GraphCacheResolver<WithTypename<Pumps_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Pumps_Min_Fields>, Record<string, never>, Scalars['Int'] | string>,
    include_ecopetrol_timestamp?: GraphCacheResolver<WithTypename<Pumps_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    include_koc_timestamp?: GraphCacheResolver<WithTypename<Pumps_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    manufacturer?: GraphCacheResolver<WithTypename<Pumps_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    max_bolt_load_pounds?: GraphCacheResolver<WithTypename<Pumps_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    max_graph_rate_standard_pump_bpd?: GraphCacheResolver<WithTypename<Pumps_Min_Fields>, Record<string, never>, Scalars['Int'] | string>,
    max_rate_standard_pump_bpd?: GraphCacheResolver<WithTypename<Pumps_Min_Fields>, Record<string, never>, Scalars['Int'] | string>,
    min_rate_standard_pump_bpd?: GraphCacheResolver<WithTypename<Pumps_Min_Fields>, Record<string, never>, Scalars['Int'] | string>,
    neck_inner_diameter_inches?: GraphCacheResolver<WithTypename<Pumps_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    neck_outer_diameter_inches?: GraphCacheResolver<WithTypename<Pumps_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    npsh1?: GraphCacheResolver<WithTypename<Pumps_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    npsh2?: GraphCacheResolver<WithTypename<Pumps_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    npsh3?: GraphCacheResolver<WithTypename<Pumps_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    npsh4?: GraphCacheResolver<WithTypename<Pumps_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    only_ecopetrol_timestamp?: GraphCacheResolver<WithTypename<Pumps_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    only_koc_timestamp?: GraphCacheResolver<WithTypename<Pumps_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    part_number?: GraphCacheResolver<WithTypename<Pumps_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    prioritized_manufacturer?: GraphCacheResolver<WithTypename<Pumps_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    rotation?: GraphCacheResolver<WithTypename<Pumps_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    series_model?: GraphCacheResolver<WithTypename<Pumps_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    shaft_diameter_inches?: GraphCacheResolver<WithTypename<Pumps_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    stage_type?: GraphCacheResolver<WithTypename<Pumps_Min_Fields>, Record<string, never>, Scalars['Int'] | string>,
    standard_housing_pressure_rating_psi?: GraphCacheResolver<WithTypename<Pumps_Min_Fields>, Record<string, never>, Scalars['Int'] | string>,
    standard_shaft_rating_hp?: GraphCacheResolver<WithTypename<Pumps_Min_Fields>, Record<string, never>, Scalars['Int'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Pumps_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>
  },
  pumps_mutation_response?: {
    affected_rows?: GraphCacheResolver<WithTypename<Pumps_Mutation_Response>, Record<string, never>, Scalars['Int'] | string>,
    returning?: GraphCacheResolver<WithTypename<Pumps_Mutation_Response>, Record<string, never>, Array<WithTypename<Pumps> | string>>
  },
  pumps_stddev_fields?: {
    bep_rate_standard_pump_bpd?: GraphCacheResolver<WithTypename<Pumps_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bhp1?: GraphCacheResolver<WithTypename<Pumps_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bhp2?: GraphCacheResolver<WithTypename<Pumps_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bhp3?: GraphCacheResolver<WithTypename<Pumps_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bhp4?: GraphCacheResolver<WithTypename<Pumps_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bhp5?: GraphCacheResolver<WithTypename<Pumps_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bhpb?: GraphCacheResolver<WithTypename<Pumps_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    compression_thrust_per_stage?: GraphCacheResolver<WithTypename<Pumps_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    h1?: GraphCacheResolver<WithTypename<Pumps_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    h2?: GraphCacheResolver<WithTypename<Pumps_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    h3?: GraphCacheResolver<WithTypename<Pumps_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    h4?: GraphCacheResolver<WithTypename<Pumps_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    h5?: GraphCacheResolver<WithTypename<Pumps_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    hb?: GraphCacheResolver<WithTypename<Pumps_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    high_strength_housing_pressure_rating_psi?: GraphCacheResolver<WithTypename<Pumps_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    high_strength_shaft_rating_hp?: GraphCacheResolver<WithTypename<Pumps_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    housing_inner_diameter_inches?: GraphCacheResolver<WithTypename<Pumps_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    housing_outer_diameter_inches?: GraphCacheResolver<WithTypename<Pumps_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Pumps_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    max_bolt_load_pounds?: GraphCacheResolver<WithTypename<Pumps_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    max_graph_rate_standard_pump_bpd?: GraphCacheResolver<WithTypename<Pumps_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    max_rate_standard_pump_bpd?: GraphCacheResolver<WithTypename<Pumps_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    min_rate_standard_pump_bpd?: GraphCacheResolver<WithTypename<Pumps_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    neck_inner_diameter_inches?: GraphCacheResolver<WithTypename<Pumps_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    neck_outer_diameter_inches?: GraphCacheResolver<WithTypename<Pumps_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    npsh1?: GraphCacheResolver<WithTypename<Pumps_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    npsh2?: GraphCacheResolver<WithTypename<Pumps_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    npsh3?: GraphCacheResolver<WithTypename<Pumps_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    npsh4?: GraphCacheResolver<WithTypename<Pumps_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    shaft_diameter_inches?: GraphCacheResolver<WithTypename<Pumps_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    stage_type?: GraphCacheResolver<WithTypename<Pumps_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    standard_housing_pressure_rating_psi?: GraphCacheResolver<WithTypename<Pumps_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    standard_shaft_rating_hp?: GraphCacheResolver<WithTypename<Pumps_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  pumps_stddev_pop_fields?: {
    bep_rate_standard_pump_bpd?: GraphCacheResolver<WithTypename<Pumps_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bhp1?: GraphCacheResolver<WithTypename<Pumps_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bhp2?: GraphCacheResolver<WithTypename<Pumps_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bhp3?: GraphCacheResolver<WithTypename<Pumps_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bhp4?: GraphCacheResolver<WithTypename<Pumps_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bhp5?: GraphCacheResolver<WithTypename<Pumps_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bhpb?: GraphCacheResolver<WithTypename<Pumps_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    compression_thrust_per_stage?: GraphCacheResolver<WithTypename<Pumps_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    h1?: GraphCacheResolver<WithTypename<Pumps_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    h2?: GraphCacheResolver<WithTypename<Pumps_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    h3?: GraphCacheResolver<WithTypename<Pumps_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    h4?: GraphCacheResolver<WithTypename<Pumps_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    h5?: GraphCacheResolver<WithTypename<Pumps_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    hb?: GraphCacheResolver<WithTypename<Pumps_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    high_strength_housing_pressure_rating_psi?: GraphCacheResolver<WithTypename<Pumps_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    high_strength_shaft_rating_hp?: GraphCacheResolver<WithTypename<Pumps_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    housing_inner_diameter_inches?: GraphCacheResolver<WithTypename<Pumps_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    housing_outer_diameter_inches?: GraphCacheResolver<WithTypename<Pumps_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Pumps_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    max_bolt_load_pounds?: GraphCacheResolver<WithTypename<Pumps_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    max_graph_rate_standard_pump_bpd?: GraphCacheResolver<WithTypename<Pumps_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    max_rate_standard_pump_bpd?: GraphCacheResolver<WithTypename<Pumps_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    min_rate_standard_pump_bpd?: GraphCacheResolver<WithTypename<Pumps_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    neck_inner_diameter_inches?: GraphCacheResolver<WithTypename<Pumps_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    neck_outer_diameter_inches?: GraphCacheResolver<WithTypename<Pumps_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    npsh1?: GraphCacheResolver<WithTypename<Pumps_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    npsh2?: GraphCacheResolver<WithTypename<Pumps_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    npsh3?: GraphCacheResolver<WithTypename<Pumps_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    npsh4?: GraphCacheResolver<WithTypename<Pumps_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    shaft_diameter_inches?: GraphCacheResolver<WithTypename<Pumps_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    stage_type?: GraphCacheResolver<WithTypename<Pumps_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    standard_housing_pressure_rating_psi?: GraphCacheResolver<WithTypename<Pumps_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    standard_shaft_rating_hp?: GraphCacheResolver<WithTypename<Pumps_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  pumps_stddev_samp_fields?: {
    bep_rate_standard_pump_bpd?: GraphCacheResolver<WithTypename<Pumps_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bhp1?: GraphCacheResolver<WithTypename<Pumps_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bhp2?: GraphCacheResolver<WithTypename<Pumps_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bhp3?: GraphCacheResolver<WithTypename<Pumps_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bhp4?: GraphCacheResolver<WithTypename<Pumps_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bhp5?: GraphCacheResolver<WithTypename<Pumps_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bhpb?: GraphCacheResolver<WithTypename<Pumps_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    compression_thrust_per_stage?: GraphCacheResolver<WithTypename<Pumps_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    h1?: GraphCacheResolver<WithTypename<Pumps_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    h2?: GraphCacheResolver<WithTypename<Pumps_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    h3?: GraphCacheResolver<WithTypename<Pumps_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    h4?: GraphCacheResolver<WithTypename<Pumps_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    h5?: GraphCacheResolver<WithTypename<Pumps_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    hb?: GraphCacheResolver<WithTypename<Pumps_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    high_strength_housing_pressure_rating_psi?: GraphCacheResolver<WithTypename<Pumps_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    high_strength_shaft_rating_hp?: GraphCacheResolver<WithTypename<Pumps_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    housing_inner_diameter_inches?: GraphCacheResolver<WithTypename<Pumps_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    housing_outer_diameter_inches?: GraphCacheResolver<WithTypename<Pumps_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Pumps_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    max_bolt_load_pounds?: GraphCacheResolver<WithTypename<Pumps_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    max_graph_rate_standard_pump_bpd?: GraphCacheResolver<WithTypename<Pumps_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    max_rate_standard_pump_bpd?: GraphCacheResolver<WithTypename<Pumps_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    min_rate_standard_pump_bpd?: GraphCacheResolver<WithTypename<Pumps_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    neck_inner_diameter_inches?: GraphCacheResolver<WithTypename<Pumps_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    neck_outer_diameter_inches?: GraphCacheResolver<WithTypename<Pumps_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    npsh1?: GraphCacheResolver<WithTypename<Pumps_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    npsh2?: GraphCacheResolver<WithTypename<Pumps_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    npsh3?: GraphCacheResolver<WithTypename<Pumps_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    npsh4?: GraphCacheResolver<WithTypename<Pumps_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    shaft_diameter_inches?: GraphCacheResolver<WithTypename<Pumps_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    stage_type?: GraphCacheResolver<WithTypename<Pumps_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    standard_housing_pressure_rating_psi?: GraphCacheResolver<WithTypename<Pumps_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    standard_shaft_rating_hp?: GraphCacheResolver<WithTypename<Pumps_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  pumps_sum_fields?: {
    bep_rate_standard_pump_bpd?: GraphCacheResolver<WithTypename<Pumps_Sum_Fields>, Record<string, never>, Scalars['Int'] | string>,
    bhp1?: GraphCacheResolver<WithTypename<Pumps_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    bhp2?: GraphCacheResolver<WithTypename<Pumps_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    bhp3?: GraphCacheResolver<WithTypename<Pumps_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    bhp4?: GraphCacheResolver<WithTypename<Pumps_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    bhp5?: GraphCacheResolver<WithTypename<Pumps_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    bhpb?: GraphCacheResolver<WithTypename<Pumps_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    compression_thrust_per_stage?: GraphCacheResolver<WithTypename<Pumps_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    h1?: GraphCacheResolver<WithTypename<Pumps_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    h2?: GraphCacheResolver<WithTypename<Pumps_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    h3?: GraphCacheResolver<WithTypename<Pumps_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    h4?: GraphCacheResolver<WithTypename<Pumps_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    h5?: GraphCacheResolver<WithTypename<Pumps_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    hb?: GraphCacheResolver<WithTypename<Pumps_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    high_strength_housing_pressure_rating_psi?: GraphCacheResolver<WithTypename<Pumps_Sum_Fields>, Record<string, never>, Scalars['Int'] | string>,
    high_strength_shaft_rating_hp?: GraphCacheResolver<WithTypename<Pumps_Sum_Fields>, Record<string, never>, Scalars['Int'] | string>,
    housing_inner_diameter_inches?: GraphCacheResolver<WithTypename<Pumps_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    housing_outer_diameter_inches?: GraphCacheResolver<WithTypename<Pumps_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Pumps_Sum_Fields>, Record<string, never>, Scalars['Int'] | string>,
    max_bolt_load_pounds?: GraphCacheResolver<WithTypename<Pumps_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    max_graph_rate_standard_pump_bpd?: GraphCacheResolver<WithTypename<Pumps_Sum_Fields>, Record<string, never>, Scalars['Int'] | string>,
    max_rate_standard_pump_bpd?: GraphCacheResolver<WithTypename<Pumps_Sum_Fields>, Record<string, never>, Scalars['Int'] | string>,
    min_rate_standard_pump_bpd?: GraphCacheResolver<WithTypename<Pumps_Sum_Fields>, Record<string, never>, Scalars['Int'] | string>,
    neck_inner_diameter_inches?: GraphCacheResolver<WithTypename<Pumps_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    neck_outer_diameter_inches?: GraphCacheResolver<WithTypename<Pumps_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    npsh1?: GraphCacheResolver<WithTypename<Pumps_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    npsh2?: GraphCacheResolver<WithTypename<Pumps_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    npsh3?: GraphCacheResolver<WithTypename<Pumps_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    npsh4?: GraphCacheResolver<WithTypename<Pumps_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    shaft_diameter_inches?: GraphCacheResolver<WithTypename<Pumps_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    stage_type?: GraphCacheResolver<WithTypename<Pumps_Sum_Fields>, Record<string, never>, Scalars['Int'] | string>,
    standard_housing_pressure_rating_psi?: GraphCacheResolver<WithTypename<Pumps_Sum_Fields>, Record<string, never>, Scalars['Int'] | string>,
    standard_shaft_rating_hp?: GraphCacheResolver<WithTypename<Pumps_Sum_Fields>, Record<string, never>, Scalars['Int'] | string>
  },
  pumps_var_pop_fields?: {
    bep_rate_standard_pump_bpd?: GraphCacheResolver<WithTypename<Pumps_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bhp1?: GraphCacheResolver<WithTypename<Pumps_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bhp2?: GraphCacheResolver<WithTypename<Pumps_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bhp3?: GraphCacheResolver<WithTypename<Pumps_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bhp4?: GraphCacheResolver<WithTypename<Pumps_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bhp5?: GraphCacheResolver<WithTypename<Pumps_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bhpb?: GraphCacheResolver<WithTypename<Pumps_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    compression_thrust_per_stage?: GraphCacheResolver<WithTypename<Pumps_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    h1?: GraphCacheResolver<WithTypename<Pumps_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    h2?: GraphCacheResolver<WithTypename<Pumps_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    h3?: GraphCacheResolver<WithTypename<Pumps_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    h4?: GraphCacheResolver<WithTypename<Pumps_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    h5?: GraphCacheResolver<WithTypename<Pumps_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    hb?: GraphCacheResolver<WithTypename<Pumps_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    high_strength_housing_pressure_rating_psi?: GraphCacheResolver<WithTypename<Pumps_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    high_strength_shaft_rating_hp?: GraphCacheResolver<WithTypename<Pumps_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    housing_inner_diameter_inches?: GraphCacheResolver<WithTypename<Pumps_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    housing_outer_diameter_inches?: GraphCacheResolver<WithTypename<Pumps_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Pumps_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    max_bolt_load_pounds?: GraphCacheResolver<WithTypename<Pumps_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    max_graph_rate_standard_pump_bpd?: GraphCacheResolver<WithTypename<Pumps_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    max_rate_standard_pump_bpd?: GraphCacheResolver<WithTypename<Pumps_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    min_rate_standard_pump_bpd?: GraphCacheResolver<WithTypename<Pumps_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    neck_inner_diameter_inches?: GraphCacheResolver<WithTypename<Pumps_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    neck_outer_diameter_inches?: GraphCacheResolver<WithTypename<Pumps_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    npsh1?: GraphCacheResolver<WithTypename<Pumps_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    npsh2?: GraphCacheResolver<WithTypename<Pumps_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    npsh3?: GraphCacheResolver<WithTypename<Pumps_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    npsh4?: GraphCacheResolver<WithTypename<Pumps_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    shaft_diameter_inches?: GraphCacheResolver<WithTypename<Pumps_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    stage_type?: GraphCacheResolver<WithTypename<Pumps_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    standard_housing_pressure_rating_psi?: GraphCacheResolver<WithTypename<Pumps_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    standard_shaft_rating_hp?: GraphCacheResolver<WithTypename<Pumps_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  pumps_var_samp_fields?: {
    bep_rate_standard_pump_bpd?: GraphCacheResolver<WithTypename<Pumps_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bhp1?: GraphCacheResolver<WithTypename<Pumps_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bhp2?: GraphCacheResolver<WithTypename<Pumps_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bhp3?: GraphCacheResolver<WithTypename<Pumps_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bhp4?: GraphCacheResolver<WithTypename<Pumps_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bhp5?: GraphCacheResolver<WithTypename<Pumps_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bhpb?: GraphCacheResolver<WithTypename<Pumps_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    compression_thrust_per_stage?: GraphCacheResolver<WithTypename<Pumps_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    h1?: GraphCacheResolver<WithTypename<Pumps_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    h2?: GraphCacheResolver<WithTypename<Pumps_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    h3?: GraphCacheResolver<WithTypename<Pumps_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    h4?: GraphCacheResolver<WithTypename<Pumps_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    h5?: GraphCacheResolver<WithTypename<Pumps_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    hb?: GraphCacheResolver<WithTypename<Pumps_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    high_strength_housing_pressure_rating_psi?: GraphCacheResolver<WithTypename<Pumps_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    high_strength_shaft_rating_hp?: GraphCacheResolver<WithTypename<Pumps_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    housing_inner_diameter_inches?: GraphCacheResolver<WithTypename<Pumps_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    housing_outer_diameter_inches?: GraphCacheResolver<WithTypename<Pumps_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Pumps_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    max_bolt_load_pounds?: GraphCacheResolver<WithTypename<Pumps_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    max_graph_rate_standard_pump_bpd?: GraphCacheResolver<WithTypename<Pumps_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    max_rate_standard_pump_bpd?: GraphCacheResolver<WithTypename<Pumps_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    min_rate_standard_pump_bpd?: GraphCacheResolver<WithTypename<Pumps_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    neck_inner_diameter_inches?: GraphCacheResolver<WithTypename<Pumps_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    neck_outer_diameter_inches?: GraphCacheResolver<WithTypename<Pumps_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    npsh1?: GraphCacheResolver<WithTypename<Pumps_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    npsh2?: GraphCacheResolver<WithTypename<Pumps_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    npsh3?: GraphCacheResolver<WithTypename<Pumps_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    npsh4?: GraphCacheResolver<WithTypename<Pumps_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    shaft_diameter_inches?: GraphCacheResolver<WithTypename<Pumps_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    stage_type?: GraphCacheResolver<WithTypename<Pumps_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    standard_housing_pressure_rating_psi?: GraphCacheResolver<WithTypename<Pumps_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    standard_shaft_rating_hp?: GraphCacheResolver<WithTypename<Pumps_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  pumps_variance_fields?: {
    bep_rate_standard_pump_bpd?: GraphCacheResolver<WithTypename<Pumps_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bhp1?: GraphCacheResolver<WithTypename<Pumps_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bhp2?: GraphCacheResolver<WithTypename<Pumps_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bhp3?: GraphCacheResolver<WithTypename<Pumps_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bhp4?: GraphCacheResolver<WithTypename<Pumps_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bhp5?: GraphCacheResolver<WithTypename<Pumps_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bhpb?: GraphCacheResolver<WithTypename<Pumps_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    compression_thrust_per_stage?: GraphCacheResolver<WithTypename<Pumps_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    h1?: GraphCacheResolver<WithTypename<Pumps_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    h2?: GraphCacheResolver<WithTypename<Pumps_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    h3?: GraphCacheResolver<WithTypename<Pumps_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    h4?: GraphCacheResolver<WithTypename<Pumps_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    h5?: GraphCacheResolver<WithTypename<Pumps_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    hb?: GraphCacheResolver<WithTypename<Pumps_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    high_strength_housing_pressure_rating_psi?: GraphCacheResolver<WithTypename<Pumps_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    high_strength_shaft_rating_hp?: GraphCacheResolver<WithTypename<Pumps_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    housing_inner_diameter_inches?: GraphCacheResolver<WithTypename<Pumps_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    housing_outer_diameter_inches?: GraphCacheResolver<WithTypename<Pumps_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Pumps_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    max_bolt_load_pounds?: GraphCacheResolver<WithTypename<Pumps_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    max_graph_rate_standard_pump_bpd?: GraphCacheResolver<WithTypename<Pumps_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    max_rate_standard_pump_bpd?: GraphCacheResolver<WithTypename<Pumps_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    min_rate_standard_pump_bpd?: GraphCacheResolver<WithTypename<Pumps_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    neck_inner_diameter_inches?: GraphCacheResolver<WithTypename<Pumps_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    neck_outer_diameter_inches?: GraphCacheResolver<WithTypename<Pumps_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    npsh1?: GraphCacheResolver<WithTypename<Pumps_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    npsh2?: GraphCacheResolver<WithTypename<Pumps_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    npsh3?: GraphCacheResolver<WithTypename<Pumps_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    npsh4?: GraphCacheResolver<WithTypename<Pumps_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    shaft_diameter_inches?: GraphCacheResolver<WithTypename<Pumps_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    stage_type?: GraphCacheResolver<WithTypename<Pumps_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    standard_housing_pressure_rating_psi?: GraphCacheResolver<WithTypename<Pumps_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    standard_shaft_rating_hp?: GraphCacheResolver<WithTypename<Pumps_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  quote_line_item_category_dataset?: {
    comment?: GraphCacheResolver<WithTypename<Quote_Line_Item_Category_Dataset>, Record<string, never>, Scalars['String'] | string>,
    value?: GraphCacheResolver<WithTypename<Quote_Line_Item_Category_Dataset>, Record<string, never>, Scalars['String'] | string>
  },
  quote_line_item_category_dataset_aggregate?: {
    aggregate?: GraphCacheResolver<WithTypename<Quote_Line_Item_Category_Dataset_Aggregate>, Record<string, never>, WithTypename<Quote_Line_Item_Category_Dataset_Aggregate_Fields> | string>,
    nodes?: GraphCacheResolver<WithTypename<Quote_Line_Item_Category_Dataset_Aggregate>, Record<string, never>, Array<WithTypename<Quote_Line_Item_Category_Dataset> | string>>
  },
  quote_line_item_category_dataset_aggregate_fields?: {
    count?: GraphCacheResolver<WithTypename<Quote_Line_Item_Category_Dataset_Aggregate_Fields>, Quote_Line_Item_Category_Dataset_Aggregate_FieldsCountArgs, Scalars['Int'] | string>,
    max?: GraphCacheResolver<WithTypename<Quote_Line_Item_Category_Dataset_Aggregate_Fields>, Record<string, never>, WithTypename<Quote_Line_Item_Category_Dataset_Max_Fields> | string>,
    min?: GraphCacheResolver<WithTypename<Quote_Line_Item_Category_Dataset_Aggregate_Fields>, Record<string, never>, WithTypename<Quote_Line_Item_Category_Dataset_Min_Fields> | string>
  },
  quote_line_item_category_dataset_max_fields?: {
    comment?: GraphCacheResolver<WithTypename<Quote_Line_Item_Category_Dataset_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    value?: GraphCacheResolver<WithTypename<Quote_Line_Item_Category_Dataset_Max_Fields>, Record<string, never>, Scalars['String'] | string>
  },
  quote_line_item_category_dataset_min_fields?: {
    comment?: GraphCacheResolver<WithTypename<Quote_Line_Item_Category_Dataset_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    value?: GraphCacheResolver<WithTypename<Quote_Line_Item_Category_Dataset_Min_Fields>, Record<string, never>, Scalars['String'] | string>
  },
  quote_line_item_category_dataset_mutation_response?: {
    affected_rows?: GraphCacheResolver<WithTypename<Quote_Line_Item_Category_Dataset_Mutation_Response>, Record<string, never>, Scalars['Int'] | string>,
    returning?: GraphCacheResolver<WithTypename<Quote_Line_Item_Category_Dataset_Mutation_Response>, Record<string, never>, Array<WithTypename<Quote_Line_Item_Category_Dataset> | string>>
  },
  quote_line_item_serialized_dataset?: {
    comment?: GraphCacheResolver<WithTypename<Quote_Line_Item_Serialized_Dataset>, Record<string, never>, Scalars['String'] | string>,
    value?: GraphCacheResolver<WithTypename<Quote_Line_Item_Serialized_Dataset>, Record<string, never>, Scalars['String'] | string>
  },
  quote_line_item_serialized_dataset_aggregate?: {
    aggregate?: GraphCacheResolver<WithTypename<Quote_Line_Item_Serialized_Dataset_Aggregate>, Record<string, never>, WithTypename<Quote_Line_Item_Serialized_Dataset_Aggregate_Fields> | string>,
    nodes?: GraphCacheResolver<WithTypename<Quote_Line_Item_Serialized_Dataset_Aggregate>, Record<string, never>, Array<WithTypename<Quote_Line_Item_Serialized_Dataset> | string>>
  },
  quote_line_item_serialized_dataset_aggregate_fields?: {
    count?: GraphCacheResolver<WithTypename<Quote_Line_Item_Serialized_Dataset_Aggregate_Fields>, Quote_Line_Item_Serialized_Dataset_Aggregate_FieldsCountArgs, Scalars['Int'] | string>,
    max?: GraphCacheResolver<WithTypename<Quote_Line_Item_Serialized_Dataset_Aggregate_Fields>, Record<string, never>, WithTypename<Quote_Line_Item_Serialized_Dataset_Max_Fields> | string>,
    min?: GraphCacheResolver<WithTypename<Quote_Line_Item_Serialized_Dataset_Aggregate_Fields>, Record<string, never>, WithTypename<Quote_Line_Item_Serialized_Dataset_Min_Fields> | string>
  },
  quote_line_item_serialized_dataset_max_fields?: {
    comment?: GraphCacheResolver<WithTypename<Quote_Line_Item_Serialized_Dataset_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    value?: GraphCacheResolver<WithTypename<Quote_Line_Item_Serialized_Dataset_Max_Fields>, Record<string, never>, Scalars['String'] | string>
  },
  quote_line_item_serialized_dataset_min_fields?: {
    comment?: GraphCacheResolver<WithTypename<Quote_Line_Item_Serialized_Dataset_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    value?: GraphCacheResolver<WithTypename<Quote_Line_Item_Serialized_Dataset_Min_Fields>, Record<string, never>, Scalars['String'] | string>
  },
  quote_line_item_serialized_dataset_mutation_response?: {
    affected_rows?: GraphCacheResolver<WithTypename<Quote_Line_Item_Serialized_Dataset_Mutation_Response>, Record<string, never>, Scalars['Int'] | string>,
    returning?: GraphCacheResolver<WithTypename<Quote_Line_Item_Serialized_Dataset_Mutation_Response>, Record<string, never>, Array<WithTypename<Quote_Line_Item_Serialized_Dataset> | string>>
  },
  quote_line_item_source_dataset?: {
    comment?: GraphCacheResolver<WithTypename<Quote_Line_Item_Source_Dataset>, Record<string, never>, Scalars['String'] | string>,
    value?: GraphCacheResolver<WithTypename<Quote_Line_Item_Source_Dataset>, Record<string, never>, Scalars['String'] | string>
  },
  quote_line_item_source_dataset_aggregate?: {
    aggregate?: GraphCacheResolver<WithTypename<Quote_Line_Item_Source_Dataset_Aggregate>, Record<string, never>, WithTypename<Quote_Line_Item_Source_Dataset_Aggregate_Fields> | string>,
    nodes?: GraphCacheResolver<WithTypename<Quote_Line_Item_Source_Dataset_Aggregate>, Record<string, never>, Array<WithTypename<Quote_Line_Item_Source_Dataset> | string>>
  },
  quote_line_item_source_dataset_aggregate_fields?: {
    count?: GraphCacheResolver<WithTypename<Quote_Line_Item_Source_Dataset_Aggregate_Fields>, Quote_Line_Item_Source_Dataset_Aggregate_FieldsCountArgs, Scalars['Int'] | string>,
    max?: GraphCacheResolver<WithTypename<Quote_Line_Item_Source_Dataset_Aggregate_Fields>, Record<string, never>, WithTypename<Quote_Line_Item_Source_Dataset_Max_Fields> | string>,
    min?: GraphCacheResolver<WithTypename<Quote_Line_Item_Source_Dataset_Aggregate_Fields>, Record<string, never>, WithTypename<Quote_Line_Item_Source_Dataset_Min_Fields> | string>
  },
  quote_line_item_source_dataset_max_fields?: {
    comment?: GraphCacheResolver<WithTypename<Quote_Line_Item_Source_Dataset_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    value?: GraphCacheResolver<WithTypename<Quote_Line_Item_Source_Dataset_Max_Fields>, Record<string, never>, Scalars['String'] | string>
  },
  quote_line_item_source_dataset_min_fields?: {
    comment?: GraphCacheResolver<WithTypename<Quote_Line_Item_Source_Dataset_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    value?: GraphCacheResolver<WithTypename<Quote_Line_Item_Source_Dataset_Min_Fields>, Record<string, never>, Scalars['String'] | string>
  },
  quote_line_item_source_dataset_mutation_response?: {
    affected_rows?: GraphCacheResolver<WithTypename<Quote_Line_Item_Source_Dataset_Mutation_Response>, Record<string, never>, Scalars['Int'] | string>,
    returning?: GraphCacheResolver<WithTypename<Quote_Line_Item_Source_Dataset_Mutation_Response>, Record<string, never>, Array<WithTypename<Quote_Line_Item_Source_Dataset> | string>>
  },
  quote_line_item_subcategory_dataset?: {
    comment?: GraphCacheResolver<WithTypename<Quote_Line_Item_Subcategory_Dataset>, Record<string, never>, Scalars['String'] | string>,
    value?: GraphCacheResolver<WithTypename<Quote_Line_Item_Subcategory_Dataset>, Record<string, never>, Scalars['String'] | string>
  },
  quote_line_item_subcategory_dataset_aggregate?: {
    aggregate?: GraphCacheResolver<WithTypename<Quote_Line_Item_Subcategory_Dataset_Aggregate>, Record<string, never>, WithTypename<Quote_Line_Item_Subcategory_Dataset_Aggregate_Fields> | string>,
    nodes?: GraphCacheResolver<WithTypename<Quote_Line_Item_Subcategory_Dataset_Aggregate>, Record<string, never>, Array<WithTypename<Quote_Line_Item_Subcategory_Dataset> | string>>
  },
  quote_line_item_subcategory_dataset_aggregate_fields?: {
    count?: GraphCacheResolver<WithTypename<Quote_Line_Item_Subcategory_Dataset_Aggregate_Fields>, Quote_Line_Item_Subcategory_Dataset_Aggregate_FieldsCountArgs, Scalars['Int'] | string>,
    max?: GraphCacheResolver<WithTypename<Quote_Line_Item_Subcategory_Dataset_Aggregate_Fields>, Record<string, never>, WithTypename<Quote_Line_Item_Subcategory_Dataset_Max_Fields> | string>,
    min?: GraphCacheResolver<WithTypename<Quote_Line_Item_Subcategory_Dataset_Aggregate_Fields>, Record<string, never>, WithTypename<Quote_Line_Item_Subcategory_Dataset_Min_Fields> | string>
  },
  quote_line_item_subcategory_dataset_max_fields?: {
    comment?: GraphCacheResolver<WithTypename<Quote_Line_Item_Subcategory_Dataset_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    value?: GraphCacheResolver<WithTypename<Quote_Line_Item_Subcategory_Dataset_Max_Fields>, Record<string, never>, Scalars['String'] | string>
  },
  quote_line_item_subcategory_dataset_min_fields?: {
    comment?: GraphCacheResolver<WithTypename<Quote_Line_Item_Subcategory_Dataset_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    value?: GraphCacheResolver<WithTypename<Quote_Line_Item_Subcategory_Dataset_Min_Fields>, Record<string, never>, Scalars['String'] | string>
  },
  quote_line_item_subcategory_dataset_mutation_response?: {
    affected_rows?: GraphCacheResolver<WithTypename<Quote_Line_Item_Subcategory_Dataset_Mutation_Response>, Record<string, never>, Scalars['Int'] | string>,
    returning?: GraphCacheResolver<WithTypename<Quote_Line_Item_Subcategory_Dataset_Mutation_Response>, Record<string, never>, Array<WithTypename<Quote_Line_Item_Subcategory_Dataset> | string>>
  },
  quote_line_item_tax_type_dataset?: {
    comment?: GraphCacheResolver<WithTypename<Quote_Line_Item_Tax_Type_Dataset>, Record<string, never>, Scalars['String'] | string>,
    value?: GraphCacheResolver<WithTypename<Quote_Line_Item_Tax_Type_Dataset>, Record<string, never>, Scalars['String'] | string>
  },
  quote_line_item_tax_type_dataset_aggregate?: {
    aggregate?: GraphCacheResolver<WithTypename<Quote_Line_Item_Tax_Type_Dataset_Aggregate>, Record<string, never>, WithTypename<Quote_Line_Item_Tax_Type_Dataset_Aggregate_Fields> | string>,
    nodes?: GraphCacheResolver<WithTypename<Quote_Line_Item_Tax_Type_Dataset_Aggregate>, Record<string, never>, Array<WithTypename<Quote_Line_Item_Tax_Type_Dataset> | string>>
  },
  quote_line_item_tax_type_dataset_aggregate_fields?: {
    count?: GraphCacheResolver<WithTypename<Quote_Line_Item_Tax_Type_Dataset_Aggregate_Fields>, Quote_Line_Item_Tax_Type_Dataset_Aggregate_FieldsCountArgs, Scalars['Int'] | string>,
    max?: GraphCacheResolver<WithTypename<Quote_Line_Item_Tax_Type_Dataset_Aggregate_Fields>, Record<string, never>, WithTypename<Quote_Line_Item_Tax_Type_Dataset_Max_Fields> | string>,
    min?: GraphCacheResolver<WithTypename<Quote_Line_Item_Tax_Type_Dataset_Aggregate_Fields>, Record<string, never>, WithTypename<Quote_Line_Item_Tax_Type_Dataset_Min_Fields> | string>
  },
  quote_line_item_tax_type_dataset_max_fields?: {
    comment?: GraphCacheResolver<WithTypename<Quote_Line_Item_Tax_Type_Dataset_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    value?: GraphCacheResolver<WithTypename<Quote_Line_Item_Tax_Type_Dataset_Max_Fields>, Record<string, never>, Scalars['String'] | string>
  },
  quote_line_item_tax_type_dataset_min_fields?: {
    comment?: GraphCacheResolver<WithTypename<Quote_Line_Item_Tax_Type_Dataset_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    value?: GraphCacheResolver<WithTypename<Quote_Line_Item_Tax_Type_Dataset_Min_Fields>, Record<string, never>, Scalars['String'] | string>
  },
  quote_line_item_tax_type_dataset_mutation_response?: {
    affected_rows?: GraphCacheResolver<WithTypename<Quote_Line_Item_Tax_Type_Dataset_Mutation_Response>, Record<string, never>, Scalars['Int'] | string>,
    returning?: GraphCacheResolver<WithTypename<Quote_Line_Item_Tax_Type_Dataset_Mutation_Response>, Record<string, never>, Array<WithTypename<Quote_Line_Item_Tax_Type_Dataset> | string>>
  },
  quote_line_item_type_dataset?: {
    comment?: GraphCacheResolver<WithTypename<Quote_Line_Item_Type_Dataset>, Record<string, never>, Scalars['String'] | string>,
    value?: GraphCacheResolver<WithTypename<Quote_Line_Item_Type_Dataset>, Record<string, never>, Scalars['String'] | string>
  },
  quote_line_item_type_dataset_aggregate?: {
    aggregate?: GraphCacheResolver<WithTypename<Quote_Line_Item_Type_Dataset_Aggregate>, Record<string, never>, WithTypename<Quote_Line_Item_Type_Dataset_Aggregate_Fields> | string>,
    nodes?: GraphCacheResolver<WithTypename<Quote_Line_Item_Type_Dataset_Aggregate>, Record<string, never>, Array<WithTypename<Quote_Line_Item_Type_Dataset> | string>>
  },
  quote_line_item_type_dataset_aggregate_fields?: {
    count?: GraphCacheResolver<WithTypename<Quote_Line_Item_Type_Dataset_Aggregate_Fields>, Quote_Line_Item_Type_Dataset_Aggregate_FieldsCountArgs, Scalars['Int'] | string>,
    max?: GraphCacheResolver<WithTypename<Quote_Line_Item_Type_Dataset_Aggregate_Fields>, Record<string, never>, WithTypename<Quote_Line_Item_Type_Dataset_Max_Fields> | string>,
    min?: GraphCacheResolver<WithTypename<Quote_Line_Item_Type_Dataset_Aggregate_Fields>, Record<string, never>, WithTypename<Quote_Line_Item_Type_Dataset_Min_Fields> | string>
  },
  quote_line_item_type_dataset_max_fields?: {
    comment?: GraphCacheResolver<WithTypename<Quote_Line_Item_Type_Dataset_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    value?: GraphCacheResolver<WithTypename<Quote_Line_Item_Type_Dataset_Max_Fields>, Record<string, never>, Scalars['String'] | string>
  },
  quote_line_item_type_dataset_min_fields?: {
    comment?: GraphCacheResolver<WithTypename<Quote_Line_Item_Type_Dataset_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    value?: GraphCacheResolver<WithTypename<Quote_Line_Item_Type_Dataset_Min_Fields>, Record<string, never>, Scalars['String'] | string>
  },
  quote_line_item_type_dataset_mutation_response?: {
    affected_rows?: GraphCacheResolver<WithTypename<Quote_Line_Item_Type_Dataset_Mutation_Response>, Record<string, never>, Scalars['Int'] | string>,
    returning?: GraphCacheResolver<WithTypename<Quote_Line_Item_Type_Dataset_Mutation_Response>, Record<string, never>, Array<WithTypename<Quote_Line_Item_Type_Dataset> | string>>
  },
  quote_line_items?: {
    cable?: GraphCacheResolver<WithTypename<Quote_Line_Items>, Record<string, never>, WithTypename<Cables> | string>,
    category?: GraphCacheResolver<WithTypename<Quote_Line_Items>, Record<string, never>, Quote_Line_Item_Category_Dataset_Enum | string>,
    created_at?: GraphCacheResolver<WithTypename<Quote_Line_Items>, Record<string, never>, Scalars['timestamptz'] | string>,
    credit?: GraphCacheResolver<WithTypename<Quote_Line_Items>, Record<string, never>, Scalars['numeric'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Quote_Line_Items>, Record<string, never>, Scalars['timestamptz'] | string>,
    erp_material_long_description?: GraphCacheResolver<WithTypename<Quote_Line_Items>, Record<string, never>, Scalars['String'] | string>,
    erp_material_number?: GraphCacheResolver<WithTypename<Quote_Line_Items>, Record<string, never>, Scalars['String'] | string>,
    erp_material_short_description?: GraphCacheResolver<WithTypename<Quote_Line_Items>, Record<string, never>, Scalars['String'] | string>,
    erp_price?: GraphCacheResolver<WithTypename<Quote_Line_Items>, Record<string, never>, Scalars['numeric'] | string>,
    erp_product_hierarchy?: GraphCacheResolver<WithTypename<Quote_Line_Items>, Record<string, never>, Scalars['String'] | string>,
    erp_serialized?: GraphCacheResolver<WithTypename<Quote_Line_Items>, Record<string, never>, Quote_Line_Item_Serialized_Dataset_Enum | string>,
    erp_uom?: GraphCacheResolver<WithTypename<Quote_Line_Items>, Record<string, never>, Scalars['String'] | string>,
    id?: GraphCacheResolver<WithTypename<Quote_Line_Items>, Record<string, never>, Scalars['uuid'] | string>,
    intake?: GraphCacheResolver<WithTypename<Quote_Line_Items>, Record<string, never>, WithTypename<Intakes> | string>,
    line_item_type?: GraphCacheResolver<WithTypename<Quote_Line_Items>, Record<string, never>, Quote_Line_Item_Type_Dataset_Enum | string>,
    margin?: GraphCacheResolver<WithTypename<Quote_Line_Items>, Record<string, never>, Scalars['numeric'] | string>,
    motor?: GraphCacheResolver<WithTypename<Quote_Line_Items>, Record<string, never>, WithTypename<Motors> | string>,
    motor_lead_extension?: GraphCacheResolver<WithTypename<Quote_Line_Items>, Record<string, never>, WithTypename<Motor_Lead_Extensions> | string>,
    note?: GraphCacheResolver<WithTypename<Quote_Line_Items>, Record<string, never>, Scalars['String'] | string>,
    parent_order?: GraphCacheResolver<WithTypename<Quote_Line_Items>, Record<string, never>, Scalars['Int'] | string>,
    price_override?: GraphCacheResolver<WithTypename<Quote_Line_Items>, Record<string, never>, Scalars['numeric'] | string>,
    pricing_date?: GraphCacheResolver<WithTypename<Quote_Line_Items>, Record<string, never>, Scalars['date'] | string>,
    pump?: GraphCacheResolver<WithTypename<Quote_Line_Items>, Record<string, never>, WithTypename<Pumps> | string>,
    quantity?: GraphCacheResolver<WithTypename<Quote_Line_Items>, Record<string, never>, Scalars['Int'] | string>,
    quote_id?: GraphCacheResolver<WithTypename<Quote_Line_Items>, Record<string, never>, Scalars['uuid'] | string>,
    seal?: GraphCacheResolver<WithTypename<Quote_Line_Items>, Record<string, never>, WithTypename<Seals> | string>,
    sensor?: GraphCacheResolver<WithTypename<Quote_Line_Items>, Record<string, never>, WithTypename<Sensors> | string>,
    source?: GraphCacheResolver<WithTypename<Quote_Line_Items>, Record<string, never>, Quote_Line_Item_Source_Dataset_Enum | string>,
    spyglass_cable?: GraphCacheResolver<WithTypename<Quote_Line_Items>, Record<string, never>, Scalars['uuid'] | string>,
    spyglass_equipment_import_json?: GraphCacheResolver<WithTypename<Quote_Line_Items>, Quote_Line_ItemsSpyglass_Equipment_Import_JsonArgs, Scalars['jsonb'] | string>,
    spyglass_intake?: GraphCacheResolver<WithTypename<Quote_Line_Items>, Record<string, never>, Scalars['uuid'] | string>,
    spyglass_motor?: GraphCacheResolver<WithTypename<Quote_Line_Items>, Record<string, never>, Scalars['uuid'] | string>,
    spyglass_motor_lead_extension?: GraphCacheResolver<WithTypename<Quote_Line_Items>, Record<string, never>, Scalars['uuid'] | string>,
    spyglass_pump?: GraphCacheResolver<WithTypename<Quote_Line_Items>, Record<string, never>, Scalars['uuid'] | string>,
    spyglass_seal?: GraphCacheResolver<WithTypename<Quote_Line_Items>, Record<string, never>, Scalars['uuid'] | string>,
    spyglass_sensor?: GraphCacheResolver<WithTypename<Quote_Line_Items>, Record<string, never>, Scalars['uuid'] | string>,
    spyglass_step_down_transformer?: GraphCacheResolver<WithTypename<Quote_Line_Items>, Record<string, never>, Scalars['uuid'] | string>,
    spyglass_step_up_transformer?: GraphCacheResolver<WithTypename<Quote_Line_Items>, Record<string, never>, Scalars['uuid'] | string>,
    spyglass_switchboard?: GraphCacheResolver<WithTypename<Quote_Line_Items>, Record<string, never>, Scalars['uuid'] | string>,
    spyglass_variable_speed_drive?: GraphCacheResolver<WithTypename<Quote_Line_Items>, Record<string, never>, Scalars['uuid'] | string>,
    step_down_transformer?: GraphCacheResolver<WithTypename<Quote_Line_Items>, Record<string, never>, WithTypename<Step_Down_Transformers> | string>,
    step_up_transformer?: GraphCacheResolver<WithTypename<Quote_Line_Items>, Record<string, never>, WithTypename<Step_Up_Transformers> | string>,
    sub_order?: GraphCacheResolver<WithTypename<Quote_Line_Items>, Record<string, never>, Scalars['Int'] | string>,
    subcategory?: GraphCacheResolver<WithTypename<Quote_Line_Items>, Record<string, never>, Quote_Line_Item_Subcategory_Dataset_Enum | string>,
    switchboard?: GraphCacheResolver<WithTypename<Quote_Line_Items>, Record<string, never>, WithTypename<Switchboards> | string>,
    tax_type?: GraphCacheResolver<WithTypename<Quote_Line_Items>, Record<string, never>, Quote_Line_Item_Tax_Type_Dataset_Enum | string>,
    updated_at?: GraphCacheResolver<WithTypename<Quote_Line_Items>, Record<string, never>, Scalars['timestamptz'] | string>,
    variable_speed_drive?: GraphCacheResolver<WithTypename<Quote_Line_Items>, Record<string, never>, WithTypename<Variable_Speed_Drives> | string>
  },
  quote_line_items_aggregate?: {
    aggregate?: GraphCacheResolver<WithTypename<Quote_Line_Items_Aggregate>, Record<string, never>, WithTypename<Quote_Line_Items_Aggregate_Fields> | string>,
    nodes?: GraphCacheResolver<WithTypename<Quote_Line_Items_Aggregate>, Record<string, never>, Array<WithTypename<Quote_Line_Items> | string>>
  },
  quote_line_items_aggregate_fields?: {
    avg?: GraphCacheResolver<WithTypename<Quote_Line_Items_Aggregate_Fields>, Record<string, never>, WithTypename<Quote_Line_Items_Avg_Fields> | string>,
    count?: GraphCacheResolver<WithTypename<Quote_Line_Items_Aggregate_Fields>, Quote_Line_Items_Aggregate_FieldsCountArgs, Scalars['Int'] | string>,
    max?: GraphCacheResolver<WithTypename<Quote_Line_Items_Aggregate_Fields>, Record<string, never>, WithTypename<Quote_Line_Items_Max_Fields> | string>,
    min?: GraphCacheResolver<WithTypename<Quote_Line_Items_Aggregate_Fields>, Record<string, never>, WithTypename<Quote_Line_Items_Min_Fields> | string>,
    stddev?: GraphCacheResolver<WithTypename<Quote_Line_Items_Aggregate_Fields>, Record<string, never>, WithTypename<Quote_Line_Items_Stddev_Fields> | string>,
    stddev_pop?: GraphCacheResolver<WithTypename<Quote_Line_Items_Aggregate_Fields>, Record<string, never>, WithTypename<Quote_Line_Items_Stddev_Pop_Fields> | string>,
    stddev_samp?: GraphCacheResolver<WithTypename<Quote_Line_Items_Aggregate_Fields>, Record<string, never>, WithTypename<Quote_Line_Items_Stddev_Samp_Fields> | string>,
    sum?: GraphCacheResolver<WithTypename<Quote_Line_Items_Aggregate_Fields>, Record<string, never>, WithTypename<Quote_Line_Items_Sum_Fields> | string>,
    var_pop?: GraphCacheResolver<WithTypename<Quote_Line_Items_Aggregate_Fields>, Record<string, never>, WithTypename<Quote_Line_Items_Var_Pop_Fields> | string>,
    var_samp?: GraphCacheResolver<WithTypename<Quote_Line_Items_Aggregate_Fields>, Record<string, never>, WithTypename<Quote_Line_Items_Var_Samp_Fields> | string>,
    variance?: GraphCacheResolver<WithTypename<Quote_Line_Items_Aggregate_Fields>, Record<string, never>, WithTypename<Quote_Line_Items_Variance_Fields> | string>
  },
  quote_line_items_avg_fields?: {
    credit?: GraphCacheResolver<WithTypename<Quote_Line_Items_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    erp_price?: GraphCacheResolver<WithTypename<Quote_Line_Items_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    margin?: GraphCacheResolver<WithTypename<Quote_Line_Items_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    parent_order?: GraphCacheResolver<WithTypename<Quote_Line_Items_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    price_override?: GraphCacheResolver<WithTypename<Quote_Line_Items_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    quantity?: GraphCacheResolver<WithTypename<Quote_Line_Items_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    sub_order?: GraphCacheResolver<WithTypename<Quote_Line_Items_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  quote_line_items_max_fields?: {
    created_at?: GraphCacheResolver<WithTypename<Quote_Line_Items_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    credit?: GraphCacheResolver<WithTypename<Quote_Line_Items_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Quote_Line_Items_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    erp_material_long_description?: GraphCacheResolver<WithTypename<Quote_Line_Items_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    erp_material_number?: GraphCacheResolver<WithTypename<Quote_Line_Items_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    erp_material_short_description?: GraphCacheResolver<WithTypename<Quote_Line_Items_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    erp_price?: GraphCacheResolver<WithTypename<Quote_Line_Items_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    erp_product_hierarchy?: GraphCacheResolver<WithTypename<Quote_Line_Items_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    erp_uom?: GraphCacheResolver<WithTypename<Quote_Line_Items_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    id?: GraphCacheResolver<WithTypename<Quote_Line_Items_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    margin?: GraphCacheResolver<WithTypename<Quote_Line_Items_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    note?: GraphCacheResolver<WithTypename<Quote_Line_Items_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    parent_order?: GraphCacheResolver<WithTypename<Quote_Line_Items_Max_Fields>, Record<string, never>, Scalars['Int'] | string>,
    price_override?: GraphCacheResolver<WithTypename<Quote_Line_Items_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    pricing_date?: GraphCacheResolver<WithTypename<Quote_Line_Items_Max_Fields>, Record<string, never>, Scalars['date'] | string>,
    quantity?: GraphCacheResolver<WithTypename<Quote_Line_Items_Max_Fields>, Record<string, never>, Scalars['Int'] | string>,
    quote_id?: GraphCacheResolver<WithTypename<Quote_Line_Items_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    spyglass_cable?: GraphCacheResolver<WithTypename<Quote_Line_Items_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    spyglass_intake?: GraphCacheResolver<WithTypename<Quote_Line_Items_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    spyglass_motor?: GraphCacheResolver<WithTypename<Quote_Line_Items_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    spyglass_motor_lead_extension?: GraphCacheResolver<WithTypename<Quote_Line_Items_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    spyglass_pump?: GraphCacheResolver<WithTypename<Quote_Line_Items_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    spyglass_seal?: GraphCacheResolver<WithTypename<Quote_Line_Items_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    spyglass_sensor?: GraphCacheResolver<WithTypename<Quote_Line_Items_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    spyglass_step_down_transformer?: GraphCacheResolver<WithTypename<Quote_Line_Items_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    spyglass_step_up_transformer?: GraphCacheResolver<WithTypename<Quote_Line_Items_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    spyglass_switchboard?: GraphCacheResolver<WithTypename<Quote_Line_Items_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    spyglass_variable_speed_drive?: GraphCacheResolver<WithTypename<Quote_Line_Items_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    sub_order?: GraphCacheResolver<WithTypename<Quote_Line_Items_Max_Fields>, Record<string, never>, Scalars['Int'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Quote_Line_Items_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>
  },
  quote_line_items_min_fields?: {
    created_at?: GraphCacheResolver<WithTypename<Quote_Line_Items_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    credit?: GraphCacheResolver<WithTypename<Quote_Line_Items_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Quote_Line_Items_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    erp_material_long_description?: GraphCacheResolver<WithTypename<Quote_Line_Items_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    erp_material_number?: GraphCacheResolver<WithTypename<Quote_Line_Items_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    erp_material_short_description?: GraphCacheResolver<WithTypename<Quote_Line_Items_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    erp_price?: GraphCacheResolver<WithTypename<Quote_Line_Items_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    erp_product_hierarchy?: GraphCacheResolver<WithTypename<Quote_Line_Items_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    erp_uom?: GraphCacheResolver<WithTypename<Quote_Line_Items_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    id?: GraphCacheResolver<WithTypename<Quote_Line_Items_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    margin?: GraphCacheResolver<WithTypename<Quote_Line_Items_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    note?: GraphCacheResolver<WithTypename<Quote_Line_Items_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    parent_order?: GraphCacheResolver<WithTypename<Quote_Line_Items_Min_Fields>, Record<string, never>, Scalars['Int'] | string>,
    price_override?: GraphCacheResolver<WithTypename<Quote_Line_Items_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    pricing_date?: GraphCacheResolver<WithTypename<Quote_Line_Items_Min_Fields>, Record<string, never>, Scalars['date'] | string>,
    quantity?: GraphCacheResolver<WithTypename<Quote_Line_Items_Min_Fields>, Record<string, never>, Scalars['Int'] | string>,
    quote_id?: GraphCacheResolver<WithTypename<Quote_Line_Items_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    spyglass_cable?: GraphCacheResolver<WithTypename<Quote_Line_Items_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    spyglass_intake?: GraphCacheResolver<WithTypename<Quote_Line_Items_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    spyglass_motor?: GraphCacheResolver<WithTypename<Quote_Line_Items_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    spyglass_motor_lead_extension?: GraphCacheResolver<WithTypename<Quote_Line_Items_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    spyglass_pump?: GraphCacheResolver<WithTypename<Quote_Line_Items_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    spyglass_seal?: GraphCacheResolver<WithTypename<Quote_Line_Items_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    spyglass_sensor?: GraphCacheResolver<WithTypename<Quote_Line_Items_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    spyglass_step_down_transformer?: GraphCacheResolver<WithTypename<Quote_Line_Items_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    spyglass_step_up_transformer?: GraphCacheResolver<WithTypename<Quote_Line_Items_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    spyglass_switchboard?: GraphCacheResolver<WithTypename<Quote_Line_Items_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    spyglass_variable_speed_drive?: GraphCacheResolver<WithTypename<Quote_Line_Items_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    sub_order?: GraphCacheResolver<WithTypename<Quote_Line_Items_Min_Fields>, Record<string, never>, Scalars['Int'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Quote_Line_Items_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>
  },
  quote_line_items_mutation_response?: {
    affected_rows?: GraphCacheResolver<WithTypename<Quote_Line_Items_Mutation_Response>, Record<string, never>, Scalars['Int'] | string>,
    returning?: GraphCacheResolver<WithTypename<Quote_Line_Items_Mutation_Response>, Record<string, never>, Array<WithTypename<Quote_Line_Items> | string>>
  },
  quote_line_items_stddev_fields?: {
    credit?: GraphCacheResolver<WithTypename<Quote_Line_Items_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    erp_price?: GraphCacheResolver<WithTypename<Quote_Line_Items_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    margin?: GraphCacheResolver<WithTypename<Quote_Line_Items_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    parent_order?: GraphCacheResolver<WithTypename<Quote_Line_Items_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    price_override?: GraphCacheResolver<WithTypename<Quote_Line_Items_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    quantity?: GraphCacheResolver<WithTypename<Quote_Line_Items_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    sub_order?: GraphCacheResolver<WithTypename<Quote_Line_Items_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  quote_line_items_stddev_pop_fields?: {
    credit?: GraphCacheResolver<WithTypename<Quote_Line_Items_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    erp_price?: GraphCacheResolver<WithTypename<Quote_Line_Items_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    margin?: GraphCacheResolver<WithTypename<Quote_Line_Items_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    parent_order?: GraphCacheResolver<WithTypename<Quote_Line_Items_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    price_override?: GraphCacheResolver<WithTypename<Quote_Line_Items_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    quantity?: GraphCacheResolver<WithTypename<Quote_Line_Items_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    sub_order?: GraphCacheResolver<WithTypename<Quote_Line_Items_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  quote_line_items_stddev_samp_fields?: {
    credit?: GraphCacheResolver<WithTypename<Quote_Line_Items_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    erp_price?: GraphCacheResolver<WithTypename<Quote_Line_Items_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    margin?: GraphCacheResolver<WithTypename<Quote_Line_Items_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    parent_order?: GraphCacheResolver<WithTypename<Quote_Line_Items_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    price_override?: GraphCacheResolver<WithTypename<Quote_Line_Items_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    quantity?: GraphCacheResolver<WithTypename<Quote_Line_Items_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    sub_order?: GraphCacheResolver<WithTypename<Quote_Line_Items_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  quote_line_items_sum_fields?: {
    credit?: GraphCacheResolver<WithTypename<Quote_Line_Items_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    erp_price?: GraphCacheResolver<WithTypename<Quote_Line_Items_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    margin?: GraphCacheResolver<WithTypename<Quote_Line_Items_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    parent_order?: GraphCacheResolver<WithTypename<Quote_Line_Items_Sum_Fields>, Record<string, never>, Scalars['Int'] | string>,
    price_override?: GraphCacheResolver<WithTypename<Quote_Line_Items_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    quantity?: GraphCacheResolver<WithTypename<Quote_Line_Items_Sum_Fields>, Record<string, never>, Scalars['Int'] | string>,
    sub_order?: GraphCacheResolver<WithTypename<Quote_Line_Items_Sum_Fields>, Record<string, never>, Scalars['Int'] | string>
  },
  quote_line_items_var_pop_fields?: {
    credit?: GraphCacheResolver<WithTypename<Quote_Line_Items_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    erp_price?: GraphCacheResolver<WithTypename<Quote_Line_Items_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    margin?: GraphCacheResolver<WithTypename<Quote_Line_Items_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    parent_order?: GraphCacheResolver<WithTypename<Quote_Line_Items_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    price_override?: GraphCacheResolver<WithTypename<Quote_Line_Items_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    quantity?: GraphCacheResolver<WithTypename<Quote_Line_Items_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    sub_order?: GraphCacheResolver<WithTypename<Quote_Line_Items_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  quote_line_items_var_samp_fields?: {
    credit?: GraphCacheResolver<WithTypename<Quote_Line_Items_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    erp_price?: GraphCacheResolver<WithTypename<Quote_Line_Items_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    margin?: GraphCacheResolver<WithTypename<Quote_Line_Items_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    parent_order?: GraphCacheResolver<WithTypename<Quote_Line_Items_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    price_override?: GraphCacheResolver<WithTypename<Quote_Line_Items_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    quantity?: GraphCacheResolver<WithTypename<Quote_Line_Items_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    sub_order?: GraphCacheResolver<WithTypename<Quote_Line_Items_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  quote_line_items_variance_fields?: {
    credit?: GraphCacheResolver<WithTypename<Quote_Line_Items_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    erp_price?: GraphCacheResolver<WithTypename<Quote_Line_Items_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    margin?: GraphCacheResolver<WithTypename<Quote_Line_Items_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    parent_order?: GraphCacheResolver<WithTypename<Quote_Line_Items_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    price_override?: GraphCacheResolver<WithTypename<Quote_Line_Items_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    quantity?: GraphCacheResolver<WithTypename<Quote_Line_Items_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    sub_order?: GraphCacheResolver<WithTypename<Quote_Line_Items_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  quote_sk_job_type_dataset?: {
    comment?: GraphCacheResolver<WithTypename<Quote_Sk_Job_Type_Dataset>, Record<string, never>, Scalars['String'] | string>,
    value?: GraphCacheResolver<WithTypename<Quote_Sk_Job_Type_Dataset>, Record<string, never>, Scalars['String'] | string>
  },
  quote_sk_job_type_dataset_aggregate?: {
    aggregate?: GraphCacheResolver<WithTypename<Quote_Sk_Job_Type_Dataset_Aggregate>, Record<string, never>, WithTypename<Quote_Sk_Job_Type_Dataset_Aggregate_Fields> | string>,
    nodes?: GraphCacheResolver<WithTypename<Quote_Sk_Job_Type_Dataset_Aggregate>, Record<string, never>, Array<WithTypename<Quote_Sk_Job_Type_Dataset> | string>>
  },
  quote_sk_job_type_dataset_aggregate_fields?: {
    count?: GraphCacheResolver<WithTypename<Quote_Sk_Job_Type_Dataset_Aggregate_Fields>, Quote_Sk_Job_Type_Dataset_Aggregate_FieldsCountArgs, Scalars['Int'] | string>,
    max?: GraphCacheResolver<WithTypename<Quote_Sk_Job_Type_Dataset_Aggregate_Fields>, Record<string, never>, WithTypename<Quote_Sk_Job_Type_Dataset_Max_Fields> | string>,
    min?: GraphCacheResolver<WithTypename<Quote_Sk_Job_Type_Dataset_Aggregate_Fields>, Record<string, never>, WithTypename<Quote_Sk_Job_Type_Dataset_Min_Fields> | string>
  },
  quote_sk_job_type_dataset_max_fields?: {
    comment?: GraphCacheResolver<WithTypename<Quote_Sk_Job_Type_Dataset_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    value?: GraphCacheResolver<WithTypename<Quote_Sk_Job_Type_Dataset_Max_Fields>, Record<string, never>, Scalars['String'] | string>
  },
  quote_sk_job_type_dataset_min_fields?: {
    comment?: GraphCacheResolver<WithTypename<Quote_Sk_Job_Type_Dataset_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    value?: GraphCacheResolver<WithTypename<Quote_Sk_Job_Type_Dataset_Min_Fields>, Record<string, never>, Scalars['String'] | string>
  },
  quote_sk_job_type_dataset_mutation_response?: {
    affected_rows?: GraphCacheResolver<WithTypename<Quote_Sk_Job_Type_Dataset_Mutation_Response>, Record<string, never>, Scalars['Int'] | string>,
    returning?: GraphCacheResolver<WithTypename<Quote_Sk_Job_Type_Dataset_Mutation_Response>, Record<string, never>, Array<WithTypename<Quote_Sk_Job_Type_Dataset> | string>>
  },
  quote_source_dataset?: {
    comment?: GraphCacheResolver<WithTypename<Quote_Source_Dataset>, Record<string, never>, Scalars['String'] | string>,
    value?: GraphCacheResolver<WithTypename<Quote_Source_Dataset>, Record<string, never>, Scalars['String'] | string>
  },
  quote_source_dataset_aggregate?: {
    aggregate?: GraphCacheResolver<WithTypename<Quote_Source_Dataset_Aggregate>, Record<string, never>, WithTypename<Quote_Source_Dataset_Aggregate_Fields> | string>,
    nodes?: GraphCacheResolver<WithTypename<Quote_Source_Dataset_Aggregate>, Record<string, never>, Array<WithTypename<Quote_Source_Dataset> | string>>
  },
  quote_source_dataset_aggregate_fields?: {
    count?: GraphCacheResolver<WithTypename<Quote_Source_Dataset_Aggregate_Fields>, Quote_Source_Dataset_Aggregate_FieldsCountArgs, Scalars['Int'] | string>,
    max?: GraphCacheResolver<WithTypename<Quote_Source_Dataset_Aggregate_Fields>, Record<string, never>, WithTypename<Quote_Source_Dataset_Max_Fields> | string>,
    min?: GraphCacheResolver<WithTypename<Quote_Source_Dataset_Aggregate_Fields>, Record<string, never>, WithTypename<Quote_Source_Dataset_Min_Fields> | string>
  },
  quote_source_dataset_max_fields?: {
    comment?: GraphCacheResolver<WithTypename<Quote_Source_Dataset_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    value?: GraphCacheResolver<WithTypename<Quote_Source_Dataset_Max_Fields>, Record<string, never>, Scalars['String'] | string>
  },
  quote_source_dataset_min_fields?: {
    comment?: GraphCacheResolver<WithTypename<Quote_Source_Dataset_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    value?: GraphCacheResolver<WithTypename<Quote_Source_Dataset_Min_Fields>, Record<string, never>, Scalars['String'] | string>
  },
  quote_source_dataset_mutation_response?: {
    affected_rows?: GraphCacheResolver<WithTypename<Quote_Source_Dataset_Mutation_Response>, Record<string, never>, Scalars['Int'] | string>,
    returning?: GraphCacheResolver<WithTypename<Quote_Source_Dataset_Mutation_Response>, Record<string, never>, Array<WithTypename<Quote_Source_Dataset> | string>>
  },
  quote_status_dataset?: {
    comment?: GraphCacheResolver<WithTypename<Quote_Status_Dataset>, Record<string, never>, Scalars['String'] | string>,
    value?: GraphCacheResolver<WithTypename<Quote_Status_Dataset>, Record<string, never>, Scalars['String'] | string>
  },
  quote_status_dataset_aggregate?: {
    aggregate?: GraphCacheResolver<WithTypename<Quote_Status_Dataset_Aggregate>, Record<string, never>, WithTypename<Quote_Status_Dataset_Aggregate_Fields> | string>,
    nodes?: GraphCacheResolver<WithTypename<Quote_Status_Dataset_Aggregate>, Record<string, never>, Array<WithTypename<Quote_Status_Dataset> | string>>
  },
  quote_status_dataset_aggregate_fields?: {
    count?: GraphCacheResolver<WithTypename<Quote_Status_Dataset_Aggregate_Fields>, Quote_Status_Dataset_Aggregate_FieldsCountArgs, Scalars['Int'] | string>,
    max?: GraphCacheResolver<WithTypename<Quote_Status_Dataset_Aggregate_Fields>, Record<string, never>, WithTypename<Quote_Status_Dataset_Max_Fields> | string>,
    min?: GraphCacheResolver<WithTypename<Quote_Status_Dataset_Aggregate_Fields>, Record<string, never>, WithTypename<Quote_Status_Dataset_Min_Fields> | string>
  },
  quote_status_dataset_max_fields?: {
    comment?: GraphCacheResolver<WithTypename<Quote_Status_Dataset_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    value?: GraphCacheResolver<WithTypename<Quote_Status_Dataset_Max_Fields>, Record<string, never>, Scalars['String'] | string>
  },
  quote_status_dataset_min_fields?: {
    comment?: GraphCacheResolver<WithTypename<Quote_Status_Dataset_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    value?: GraphCacheResolver<WithTypename<Quote_Status_Dataset_Min_Fields>, Record<string, never>, Scalars['String'] | string>
  },
  quote_status_dataset_mutation_response?: {
    affected_rows?: GraphCacheResolver<WithTypename<Quote_Status_Dataset_Mutation_Response>, Record<string, never>, Scalars['Int'] | string>,
    returning?: GraphCacheResolver<WithTypename<Quote_Status_Dataset_Mutation_Response>, Record<string, never>, Array<WithTypename<Quote_Status_Dataset> | string>>
  },
  quote_user_messages?: {
    author_id?: GraphCacheResolver<WithTypename<Quote_User_Messages>, Record<string, never>, Scalars['String'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Quote_User_Messages>, Record<string, never>, Scalars['timestamptz'] | string>,
    created_by?: GraphCacheResolver<WithTypename<Quote_User_Messages>, Record<string, never>, WithTypename<Users> | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Quote_User_Messages>, Record<string, never>, Scalars['timestamptz'] | string>,
    id?: GraphCacheResolver<WithTypename<Quote_User_Messages>, Record<string, never>, Scalars['uuid'] | string>,
    message?: GraphCacheResolver<WithTypename<Quote_User_Messages>, Record<string, never>, Scalars['String'] | string>,
    title?: GraphCacheResolver<WithTypename<Quote_User_Messages>, Record<string, never>, Scalars['String'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Quote_User_Messages>, Record<string, never>, Scalars['timestamptz'] | string>
  },
  quote_user_messages_aggregate?: {
    aggregate?: GraphCacheResolver<WithTypename<Quote_User_Messages_Aggregate>, Record<string, never>, WithTypename<Quote_User_Messages_Aggregate_Fields> | string>,
    nodes?: GraphCacheResolver<WithTypename<Quote_User_Messages_Aggregate>, Record<string, never>, Array<WithTypename<Quote_User_Messages> | string>>
  },
  quote_user_messages_aggregate_fields?: {
    count?: GraphCacheResolver<WithTypename<Quote_User_Messages_Aggregate_Fields>, Quote_User_Messages_Aggregate_FieldsCountArgs, Scalars['Int'] | string>,
    max?: GraphCacheResolver<WithTypename<Quote_User_Messages_Aggregate_Fields>, Record<string, never>, WithTypename<Quote_User_Messages_Max_Fields> | string>,
    min?: GraphCacheResolver<WithTypename<Quote_User_Messages_Aggregate_Fields>, Record<string, never>, WithTypename<Quote_User_Messages_Min_Fields> | string>
  },
  quote_user_messages_max_fields?: {
    author_id?: GraphCacheResolver<WithTypename<Quote_User_Messages_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Quote_User_Messages_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Quote_User_Messages_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    id?: GraphCacheResolver<WithTypename<Quote_User_Messages_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    message?: GraphCacheResolver<WithTypename<Quote_User_Messages_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    title?: GraphCacheResolver<WithTypename<Quote_User_Messages_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Quote_User_Messages_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>
  },
  quote_user_messages_min_fields?: {
    author_id?: GraphCacheResolver<WithTypename<Quote_User_Messages_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Quote_User_Messages_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Quote_User_Messages_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    id?: GraphCacheResolver<WithTypename<Quote_User_Messages_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    message?: GraphCacheResolver<WithTypename<Quote_User_Messages_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    title?: GraphCacheResolver<WithTypename<Quote_User_Messages_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Quote_User_Messages_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>
  },
  quote_user_messages_mutation_response?: {
    affected_rows?: GraphCacheResolver<WithTypename<Quote_User_Messages_Mutation_Response>, Record<string, never>, Scalars['Int'] | string>,
    returning?: GraphCacheResolver<WithTypename<Quote_User_Messages_Mutation_Response>, Record<string, never>, Array<WithTypename<Quote_User_Messages> | string>>
  },
  quotes?: {
    comments?: GraphCacheResolver<WithTypename<Quotes>, Record<string, never>, Scalars['String'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Quotes>, Record<string, never>, Scalars['timestamptz'] | string>,
    currency?: GraphCacheResolver<WithTypename<Quotes>, Record<string, never>, Scalars['String'] | string>,
    customer_rep_email?: GraphCacheResolver<WithTypename<Quotes>, Record<string, never>, Scalars['String'] | string>,
    customer_rep_name?: GraphCacheResolver<WithTypename<Quotes>, Record<string, never>, Scalars['String'] | string>,
    customer_rep_phone_number?: GraphCacheResolver<WithTypename<Quotes>, Record<string, never>, Scalars['String'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Quotes>, Record<string, never>, Scalars['timestamptz'] | string>,
    directions?: GraphCacheResolver<WithTypename<Quotes>, Record<string, never>, Scalars['String'] | string>,
    erp_address_id?: GraphCacheResolver<WithTypename<Quotes>, Record<string, never>, Scalars['String'] | string>,
    erp_address_name?: GraphCacheResolver<WithTypename<Quotes>, Record<string, never>, Scalars['String'] | string>,
    erp_contract_number?: GraphCacheResolver<WithTypename<Quotes>, Record<string, never>, Scalars['String'] | string>,
    erp_customer_name?: GraphCacheResolver<WithTypename<Quotes>, Record<string, never>, Scalars['String'] | string>,
    erp_customer_number?: GraphCacheResolver<WithTypename<Quotes>, Record<string, never>, Scalars['String'] | string>,
    erp_full_address?: GraphCacheResolver<WithTypename<Quotes>, Record<string, never>, Scalars['String'] | string>,
    erp_nwa_id?: GraphCacheResolver<WithTypename<Quotes>, Record<string, never>, Scalars['String'] | string>,
    erp_nwa_name?: GraphCacheResolver<WithTypename<Quotes>, Record<string, never>, Scalars['String'] | string>,
    erp_plant_id?: GraphCacheResolver<WithTypename<Quotes>, Record<string, never>, Scalars['String'] | string>,
    erp_plant_name?: GraphCacheResolver<WithTypename<Quotes>, Record<string, never>, Scalars['String'] | string>,
    erp_price_list_name?: GraphCacheResolver<WithTypename<Quotes>, Record<string, never>, Scalars['String'] | string>,
    erp_price_list_number?: GraphCacheResolver<WithTypename<Quotes>, Record<string, never>, Scalars['String'] | string>,
    erp_well_country?: GraphCacheResolver<WithTypename<Quotes>, Record<string, never>, Scalars['String'] | string>,
    erp_well_id?: GraphCacheResolver<WithTypename<Quotes>, Record<string, never>, Scalars['String'] | string>,
    erp_well_name?: GraphCacheResolver<WithTypename<Quotes>, Record<string, never>, Scalars['String'] | string>,
    erp_well_region?: GraphCacheResolver<WithTypename<Quotes>, Record<string, never>, Scalars['String'] | string>,
    erp_well_uwi?: GraphCacheResolver<WithTypename<Quotes>, Record<string, never>, Scalars['String'] | string>,
    error_log_json?: GraphCacheResolver<WithTypename<Quotes>, QuotesError_Log_JsonArgs, Scalars['jsonb'] | string>,
    id?: GraphCacheResolver<WithTypename<Quotes>, Record<string, never>, Scalars['uuid'] | string>,
    name?: GraphCacheResolver<WithTypename<Quotes>, Record<string, never>, Scalars['String'] | string>,
    note?: GraphCacheResolver<WithTypename<Quotes>, Record<string, never>, Scalars['String'] | string>,
    parent?: GraphCacheResolver<WithTypename<Quotes>, Record<string, never>, WithTypename<Quotes> | string>,
    parent_id?: GraphCacheResolver<WithTypename<Quotes>, Record<string, never>, Scalars['uuid'] | string>,
    prepared_by_id?: GraphCacheResolver<WithTypename<Quotes>, Record<string, never>, Scalars['String'] | string>,
    pricing_date?: GraphCacheResolver<WithTypename<Quotes>, Record<string, never>, Scalars['date'] | string>,
    proposed_start_date?: GraphCacheResolver<WithTypename<Quotes>, Record<string, never>, Scalars['date'] | string>,
    quote_line_items?: GraphCacheResolver<WithTypename<Quotes>, QuotesQuote_Line_ItemsArgs, Array<WithTypename<Quote_Line_Items> | string>>,
    quote_line_items_aggregate?: GraphCacheResolver<WithTypename<Quotes>, QuotesQuote_Line_Items_AggregateArgs, WithTypename<Quote_Line_Items_Aggregate> | string>,
    quote_scenario?: GraphCacheResolver<WithTypename<Quotes>, Record<string, never>, WithTypename<Scenarios> | string>,
    quote_source?: GraphCacheResolver<WithTypename<Quotes>, Record<string, never>, WithTypename<Quote_Source_Dataset> | string>,
    quote_status?: GraphCacheResolver<WithTypename<Quotes>, Record<string, never>, WithTypename<Quote_Status_Dataset> | string>,
    sk_job_id?: GraphCacheResolver<WithTypename<Quotes>, Record<string, never>, Scalars['Int'] | string>,
    sk_job_number?: GraphCacheResolver<WithTypename<Quotes>, Record<string, never>, Scalars['String'] | string>,
    sk_job_type?: GraphCacheResolver<WithTypename<Quotes>, Record<string, never>, Quote_Sk_Job_Type_Dataset_Enum | string>,
    sk_planning_order?: GraphCacheResolver<WithTypename<Quotes>, Record<string, never>, Scalars['String'] | string>,
    sk_proposal_number?: GraphCacheResolver<WithTypename<Quotes>, Record<string, never>, Scalars['String'] | string>,
    source?: GraphCacheResolver<WithTypename<Quotes>, Record<string, never>, Quote_Source_Dataset_Enum | string>,
    spyglass_scenario_id?: GraphCacheResolver<WithTypename<Quotes>, Record<string, never>, Scalars['uuid'] | string>,
    spyglass_scenario_import_json?: GraphCacheResolver<WithTypename<Quotes>, QuotesSpyglass_Scenario_Import_JsonArgs, Scalars['jsonb'] | string>,
    status?: GraphCacheResolver<WithTypename<Quotes>, Record<string, never>, Quote_Status_Dataset_Enum | string>,
    updated_at?: GraphCacheResolver<WithTypename<Quotes>, Record<string, never>, Scalars['timestamptz'] | string>,
    user?: GraphCacheResolver<WithTypename<Quotes>, Record<string, never>, WithTypename<Users> | string>,
    version_number?: GraphCacheResolver<WithTypename<Quotes>, Record<string, never>, Scalars['Int'] | string>
  },
  quotes_aggregate?: {
    aggregate?: GraphCacheResolver<WithTypename<Quotes_Aggregate>, Record<string, never>, WithTypename<Quotes_Aggregate_Fields> | string>,
    nodes?: GraphCacheResolver<WithTypename<Quotes_Aggregate>, Record<string, never>, Array<WithTypename<Quotes> | string>>
  },
  quotes_aggregate_fields?: {
    avg?: GraphCacheResolver<WithTypename<Quotes_Aggregate_Fields>, Record<string, never>, WithTypename<Quotes_Avg_Fields> | string>,
    count?: GraphCacheResolver<WithTypename<Quotes_Aggregate_Fields>, Quotes_Aggregate_FieldsCountArgs, Scalars['Int'] | string>,
    max?: GraphCacheResolver<WithTypename<Quotes_Aggregate_Fields>, Record<string, never>, WithTypename<Quotes_Max_Fields> | string>,
    min?: GraphCacheResolver<WithTypename<Quotes_Aggregate_Fields>, Record<string, never>, WithTypename<Quotes_Min_Fields> | string>,
    stddev?: GraphCacheResolver<WithTypename<Quotes_Aggregate_Fields>, Record<string, never>, WithTypename<Quotes_Stddev_Fields> | string>,
    stddev_pop?: GraphCacheResolver<WithTypename<Quotes_Aggregate_Fields>, Record<string, never>, WithTypename<Quotes_Stddev_Pop_Fields> | string>,
    stddev_samp?: GraphCacheResolver<WithTypename<Quotes_Aggregate_Fields>, Record<string, never>, WithTypename<Quotes_Stddev_Samp_Fields> | string>,
    sum?: GraphCacheResolver<WithTypename<Quotes_Aggregate_Fields>, Record<string, never>, WithTypename<Quotes_Sum_Fields> | string>,
    var_pop?: GraphCacheResolver<WithTypename<Quotes_Aggregate_Fields>, Record<string, never>, WithTypename<Quotes_Var_Pop_Fields> | string>,
    var_samp?: GraphCacheResolver<WithTypename<Quotes_Aggregate_Fields>, Record<string, never>, WithTypename<Quotes_Var_Samp_Fields> | string>,
    variance?: GraphCacheResolver<WithTypename<Quotes_Aggregate_Fields>, Record<string, never>, WithTypename<Quotes_Variance_Fields> | string>
  },
  quotes_avg_fields?: {
    sk_job_id?: GraphCacheResolver<WithTypename<Quotes_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    version_number?: GraphCacheResolver<WithTypename<Quotes_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  quotes_max_fields?: {
    comments?: GraphCacheResolver<WithTypename<Quotes_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Quotes_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    currency?: GraphCacheResolver<WithTypename<Quotes_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    customer_rep_email?: GraphCacheResolver<WithTypename<Quotes_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    customer_rep_name?: GraphCacheResolver<WithTypename<Quotes_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    customer_rep_phone_number?: GraphCacheResolver<WithTypename<Quotes_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Quotes_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    directions?: GraphCacheResolver<WithTypename<Quotes_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    erp_address_id?: GraphCacheResolver<WithTypename<Quotes_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    erp_address_name?: GraphCacheResolver<WithTypename<Quotes_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    erp_contract_number?: GraphCacheResolver<WithTypename<Quotes_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    erp_customer_name?: GraphCacheResolver<WithTypename<Quotes_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    erp_customer_number?: GraphCacheResolver<WithTypename<Quotes_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    erp_full_address?: GraphCacheResolver<WithTypename<Quotes_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    erp_nwa_id?: GraphCacheResolver<WithTypename<Quotes_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    erp_nwa_name?: GraphCacheResolver<WithTypename<Quotes_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    erp_plant_id?: GraphCacheResolver<WithTypename<Quotes_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    erp_plant_name?: GraphCacheResolver<WithTypename<Quotes_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    erp_price_list_name?: GraphCacheResolver<WithTypename<Quotes_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    erp_price_list_number?: GraphCacheResolver<WithTypename<Quotes_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    erp_well_country?: GraphCacheResolver<WithTypename<Quotes_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    erp_well_id?: GraphCacheResolver<WithTypename<Quotes_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    erp_well_name?: GraphCacheResolver<WithTypename<Quotes_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    erp_well_region?: GraphCacheResolver<WithTypename<Quotes_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    erp_well_uwi?: GraphCacheResolver<WithTypename<Quotes_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    id?: GraphCacheResolver<WithTypename<Quotes_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    name?: GraphCacheResolver<WithTypename<Quotes_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    note?: GraphCacheResolver<WithTypename<Quotes_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    parent_id?: GraphCacheResolver<WithTypename<Quotes_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    prepared_by_id?: GraphCacheResolver<WithTypename<Quotes_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    pricing_date?: GraphCacheResolver<WithTypename<Quotes_Max_Fields>, Record<string, never>, Scalars['date'] | string>,
    proposed_start_date?: GraphCacheResolver<WithTypename<Quotes_Max_Fields>, Record<string, never>, Scalars['date'] | string>,
    sk_job_id?: GraphCacheResolver<WithTypename<Quotes_Max_Fields>, Record<string, never>, Scalars['Int'] | string>,
    sk_job_number?: GraphCacheResolver<WithTypename<Quotes_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    sk_planning_order?: GraphCacheResolver<WithTypename<Quotes_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    sk_proposal_number?: GraphCacheResolver<WithTypename<Quotes_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    spyglass_scenario_id?: GraphCacheResolver<WithTypename<Quotes_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Quotes_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    version_number?: GraphCacheResolver<WithTypename<Quotes_Max_Fields>, Record<string, never>, Scalars['Int'] | string>
  },
  quotes_min_fields?: {
    comments?: GraphCacheResolver<WithTypename<Quotes_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Quotes_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    currency?: GraphCacheResolver<WithTypename<Quotes_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    customer_rep_email?: GraphCacheResolver<WithTypename<Quotes_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    customer_rep_name?: GraphCacheResolver<WithTypename<Quotes_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    customer_rep_phone_number?: GraphCacheResolver<WithTypename<Quotes_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Quotes_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    directions?: GraphCacheResolver<WithTypename<Quotes_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    erp_address_id?: GraphCacheResolver<WithTypename<Quotes_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    erp_address_name?: GraphCacheResolver<WithTypename<Quotes_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    erp_contract_number?: GraphCacheResolver<WithTypename<Quotes_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    erp_customer_name?: GraphCacheResolver<WithTypename<Quotes_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    erp_customer_number?: GraphCacheResolver<WithTypename<Quotes_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    erp_full_address?: GraphCacheResolver<WithTypename<Quotes_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    erp_nwa_id?: GraphCacheResolver<WithTypename<Quotes_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    erp_nwa_name?: GraphCacheResolver<WithTypename<Quotes_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    erp_plant_id?: GraphCacheResolver<WithTypename<Quotes_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    erp_plant_name?: GraphCacheResolver<WithTypename<Quotes_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    erp_price_list_name?: GraphCacheResolver<WithTypename<Quotes_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    erp_price_list_number?: GraphCacheResolver<WithTypename<Quotes_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    erp_well_country?: GraphCacheResolver<WithTypename<Quotes_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    erp_well_id?: GraphCacheResolver<WithTypename<Quotes_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    erp_well_name?: GraphCacheResolver<WithTypename<Quotes_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    erp_well_region?: GraphCacheResolver<WithTypename<Quotes_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    erp_well_uwi?: GraphCacheResolver<WithTypename<Quotes_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    id?: GraphCacheResolver<WithTypename<Quotes_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    name?: GraphCacheResolver<WithTypename<Quotes_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    note?: GraphCacheResolver<WithTypename<Quotes_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    parent_id?: GraphCacheResolver<WithTypename<Quotes_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    prepared_by_id?: GraphCacheResolver<WithTypename<Quotes_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    pricing_date?: GraphCacheResolver<WithTypename<Quotes_Min_Fields>, Record<string, never>, Scalars['date'] | string>,
    proposed_start_date?: GraphCacheResolver<WithTypename<Quotes_Min_Fields>, Record<string, never>, Scalars['date'] | string>,
    sk_job_id?: GraphCacheResolver<WithTypename<Quotes_Min_Fields>, Record<string, never>, Scalars['Int'] | string>,
    sk_job_number?: GraphCacheResolver<WithTypename<Quotes_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    sk_planning_order?: GraphCacheResolver<WithTypename<Quotes_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    sk_proposal_number?: GraphCacheResolver<WithTypename<Quotes_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    spyglass_scenario_id?: GraphCacheResolver<WithTypename<Quotes_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Quotes_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    version_number?: GraphCacheResolver<WithTypename<Quotes_Min_Fields>, Record<string, never>, Scalars['Int'] | string>
  },
  quotes_mutation_response?: {
    affected_rows?: GraphCacheResolver<WithTypename<Quotes_Mutation_Response>, Record<string, never>, Scalars['Int'] | string>,
    returning?: GraphCacheResolver<WithTypename<Quotes_Mutation_Response>, Record<string, never>, Array<WithTypename<Quotes> | string>>
  },
  quotes_stddev_fields?: {
    sk_job_id?: GraphCacheResolver<WithTypename<Quotes_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    version_number?: GraphCacheResolver<WithTypename<Quotes_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  quotes_stddev_pop_fields?: {
    sk_job_id?: GraphCacheResolver<WithTypename<Quotes_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    version_number?: GraphCacheResolver<WithTypename<Quotes_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  quotes_stddev_samp_fields?: {
    sk_job_id?: GraphCacheResolver<WithTypename<Quotes_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    version_number?: GraphCacheResolver<WithTypename<Quotes_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  quotes_sum_fields?: {
    sk_job_id?: GraphCacheResolver<WithTypename<Quotes_Sum_Fields>, Record<string, never>, Scalars['Int'] | string>,
    version_number?: GraphCacheResolver<WithTypename<Quotes_Sum_Fields>, Record<string, never>, Scalars['Int'] | string>
  },
  quotes_var_pop_fields?: {
    sk_job_id?: GraphCacheResolver<WithTypename<Quotes_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    version_number?: GraphCacheResolver<WithTypename<Quotes_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  quotes_var_samp_fields?: {
    sk_job_id?: GraphCacheResolver<WithTypename<Quotes_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    version_number?: GraphCacheResolver<WithTypename<Quotes_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  quotes_variance_fields?: {
    sk_job_id?: GraphCacheResolver<WithTypename<Quotes_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    version_number?: GraphCacheResolver<WithTypename<Quotes_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  revisions_performance_evaluations_journal?: {
    author_id?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Journal>, Record<string, never>, Scalars['String'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Journal>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Journal>, Record<string, never>, Scalars['timestamptz'] | string>,
    id?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Journal>, Record<string, never>, Scalars['uuid'] | string>,
    parent_journal_id?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Journal>, Record<string, never>, Scalars['uuid'] | string>,
    performance_evaluations_journal?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Journal>, Record<string, never>, WithTypename<Revisions_Performance_Evaluations_Journal> | string>,
    performance_evaluations_journals?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Journal>, Revisions_Performance_Evaluations_JournalPerformance_Evaluations_JournalsArgs, Array<WithTypename<Revisions_Performance_Evaluations_Journal> | string>>,
    performance_evaluations_journals_aggregate?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Journal>, Revisions_Performance_Evaluations_JournalPerformance_Evaluations_Journals_AggregateArgs, WithTypename<Revisions_Performance_Evaluations_Journal_Aggregate> | string>,
    performance_evaluations_revision?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Journal>, Record<string, never>, WithTypename<Revisions_Performance_Evaluations_Revisions> | string>,
    performance_evaluations_revisions?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Journal>, Revisions_Performance_Evaluations_JournalPerformance_Evaluations_RevisionsArgs, Array<WithTypename<Revisions_Performance_Evaluations_Revisions> | string>>,
    performance_evaluations_revisions_aggregate?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Journal>, Revisions_Performance_Evaluations_JournalPerformance_Evaluations_Revisions_AggregateArgs, WithTypename<Revisions_Performance_Evaluations_Revisions_Aggregate> | string>,
    updated_at?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Journal>, Record<string, never>, Scalars['timestamptz'] | string>,
    user?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Journal>, Record<string, never>, WithTypename<Users> | string>,
    winning_revision_id?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Journal>, Record<string, never>, Scalars['uuid'] | string>
  },
  revisions_performance_evaluations_journal_aggregate?: {
    aggregate?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Journal_Aggregate>, Record<string, never>, WithTypename<Revisions_Performance_Evaluations_Journal_Aggregate_Fields> | string>,
    nodes?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Journal_Aggregate>, Record<string, never>, Array<WithTypename<Revisions_Performance_Evaluations_Journal> | string>>
  },
  revisions_performance_evaluations_journal_aggregate_fields?: {
    count?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Journal_Aggregate_Fields>, Revisions_Performance_Evaluations_Journal_Aggregate_FieldsCountArgs, Scalars['Int'] | string>,
    max?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Journal_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Performance_Evaluations_Journal_Max_Fields> | string>,
    min?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Journal_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Performance_Evaluations_Journal_Min_Fields> | string>
  },
  revisions_performance_evaluations_journal_max_fields?: {
    author_id?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Journal_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Journal_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Journal_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    id?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Journal_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    parent_journal_id?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Journal_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Journal_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    winning_revision_id?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Journal_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>
  },
  revisions_performance_evaluations_journal_min_fields?: {
    author_id?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Journal_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Journal_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Journal_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    id?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Journal_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    parent_journal_id?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Journal_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Journal_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    winning_revision_id?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Journal_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>
  },
  revisions_performance_evaluations_journal_mutation_response?: {
    affected_rows?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Journal_Mutation_Response>, Record<string, never>, Scalars['Int'] | string>,
    returning?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Journal_Mutation_Response>, Record<string, never>, Array<WithTypename<Revisions_Performance_Evaluations_Journal> | string>>
  },
  revisions_performance_evaluations_revisions?: {
    author_id?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions>, Record<string, never>, Scalars['String'] | string>,
    casing_pressure_psia?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions>, Record<string, never>, Scalars['numeric'] | string>,
    cloned_from_journal_id?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions>, Record<string, never>, Scalars['uuid'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions>, Record<string, never>, Scalars['timestamptz'] | string>,
    gas_rate_mscf_day?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions>, Record<string, never>, Scalars['numeric'] | string>,
    id?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions>, Record<string, never>, Scalars['uuid'] | string>,
    intake_gas_separation_override_type?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions>, Record<string, never>, Override_Options_Enum | string>,
    intake_override_gas_separation_percent?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions>, Record<string, never>, Scalars['numeric'] | string>,
    journal_id?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions>, Record<string, never>, Scalars['uuid'] | string>,
    natural_gas_separation_override_type?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions>, Record<string, never>, Override_Options_Enum | string>,
    natural_override_gas_separation_percent?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions>, Record<string, never>, Scalars['numeric'] | string>,
    oil_rate_std_barrel_day?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions>, Record<string, never>, Scalars['numeric'] | string>,
    parent_revision_id?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions>, Record<string, never>, Scalars['uuid'] | string>,
    performance_evaluations_journal?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions>, Record<string, never>, WithTypename<Revisions_Performance_Evaluations_Journal> | string>,
    performance_evaluations_journals?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions>, Revisions_Performance_Evaluations_RevisionsPerformance_Evaluations_JournalsArgs, Array<WithTypename<Revisions_Performance_Evaluations_Journal> | string>>,
    performance_evaluations_journals_aggregate?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions>, Revisions_Performance_Evaluations_RevisionsPerformance_Evaluations_Journals_AggregateArgs, WithTypename<Revisions_Performance_Evaluations_Journal_Aggregate> | string>,
    performance_evaluations_revision?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions>, Record<string, never>, WithTypename<Revisions_Performance_Evaluations_Revisions> | string>,
    performance_evaluations_revisions?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions>, Revisions_Performance_Evaluations_RevisionsPerformance_Evaluations_RevisionsArgs, Array<WithTypename<Revisions_Performance_Evaluations_Revisions> | string>>,
    performance_evaluations_revisions_aggregate?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions>, Revisions_Performance_Evaluations_RevisionsPerformance_Evaluations_Revisions_AggregateArgs, WithTypename<Revisions_Performance_Evaluations_Revisions_Aggregate> | string>,
    performance_evaluations_view?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions>, Record<string, never>, WithTypename<Performance_Evaluations> | string>,
    pump_hz?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions>, Record<string, never>, Scalars['numeric'] | string>,
    pump_intake_pressure_psia?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions>, Record<string, never>, Scalars['numeric'] | string>,
    pump_wear_brake_horsepower_correction_ratio?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions>, Record<string, never>, Scalars['numeric'] | string>,
    pump_wear_head_correction_ratio?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions>, Record<string, never>, Scalars['numeric'] | string>,
    scenario_id?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions>, Record<string, never>, Scalars['uuid'] | string>,
    scenarios_journal?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions>, Record<string, never>, WithTypename<Revisions_Scenarios_Journal> | string>,
    title?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions>, Record<string, never>, Scalars['String'] | string>,
    tubing_pressure_psia?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions>, Record<string, never>, Scalars['numeric'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions>, Record<string, never>, Scalars['timestamptz'] | string>,
    user?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions>, Record<string, never>, WithTypename<Users> | string>,
    water_rate_std_barrel_day?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions>, Record<string, never>, Scalars['numeric'] | string>
  },
  revisions_performance_evaluations_revisions_aggregate?: {
    aggregate?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions_Aggregate>, Record<string, never>, WithTypename<Revisions_Performance_Evaluations_Revisions_Aggregate_Fields> | string>,
    nodes?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions_Aggregate>, Record<string, never>, Array<WithTypename<Revisions_Performance_Evaluations_Revisions> | string>>
  },
  revisions_performance_evaluations_revisions_aggregate_fields?: {
    avg?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Performance_Evaluations_Revisions_Avg_Fields> | string>,
    count?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions_Aggregate_Fields>, Revisions_Performance_Evaluations_Revisions_Aggregate_FieldsCountArgs, Scalars['Int'] | string>,
    max?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Performance_Evaluations_Revisions_Max_Fields> | string>,
    min?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Performance_Evaluations_Revisions_Min_Fields> | string>,
    stddev?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Performance_Evaluations_Revisions_Stddev_Fields> | string>,
    stddev_pop?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Performance_Evaluations_Revisions_Stddev_Pop_Fields> | string>,
    stddev_samp?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Performance_Evaluations_Revisions_Stddev_Samp_Fields> | string>,
    sum?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Performance_Evaluations_Revisions_Sum_Fields> | string>,
    var_pop?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Performance_Evaluations_Revisions_Var_Pop_Fields> | string>,
    var_samp?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Performance_Evaluations_Revisions_Var_Samp_Fields> | string>,
    variance?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Performance_Evaluations_Revisions_Variance_Fields> | string>
  },
  revisions_performance_evaluations_revisions_avg_fields?: {
    casing_pressure_psia?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    gas_rate_mscf_day?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    intake_override_gas_separation_percent?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    natural_override_gas_separation_percent?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    oil_rate_std_barrel_day?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pump_hz?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pump_intake_pressure_psia?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pump_wear_brake_horsepower_correction_ratio?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pump_wear_head_correction_ratio?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    tubing_pressure_psia?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    water_rate_std_barrel_day?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  revisions_performance_evaluations_revisions_max_fields?: {
    author_id?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    casing_pressure_psia?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    cloned_from_journal_id?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    gas_rate_mscf_day?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    id?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    intake_override_gas_separation_percent?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    journal_id?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    natural_override_gas_separation_percent?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    oil_rate_std_barrel_day?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    parent_revision_id?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    pump_hz?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    pump_intake_pressure_psia?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    pump_wear_brake_horsepower_correction_ratio?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    pump_wear_head_correction_ratio?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    scenario_id?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    title?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    tubing_pressure_psia?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    water_rate_std_barrel_day?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>
  },
  revisions_performance_evaluations_revisions_min_fields?: {
    author_id?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    casing_pressure_psia?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    cloned_from_journal_id?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    gas_rate_mscf_day?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    id?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    intake_override_gas_separation_percent?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    journal_id?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    natural_override_gas_separation_percent?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    oil_rate_std_barrel_day?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    parent_revision_id?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    pump_hz?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    pump_intake_pressure_psia?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    pump_wear_brake_horsepower_correction_ratio?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    pump_wear_head_correction_ratio?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    scenario_id?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    title?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    tubing_pressure_psia?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    water_rate_std_barrel_day?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>
  },
  revisions_performance_evaluations_revisions_mutation_response?: {
    affected_rows?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions_Mutation_Response>, Record<string, never>, Scalars['Int'] | string>,
    returning?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions_Mutation_Response>, Record<string, never>, Array<WithTypename<Revisions_Performance_Evaluations_Revisions> | string>>
  },
  revisions_performance_evaluations_revisions_stddev_fields?: {
    casing_pressure_psia?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    gas_rate_mscf_day?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    intake_override_gas_separation_percent?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    natural_override_gas_separation_percent?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    oil_rate_std_barrel_day?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pump_hz?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pump_intake_pressure_psia?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pump_wear_brake_horsepower_correction_ratio?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pump_wear_head_correction_ratio?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    tubing_pressure_psia?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    water_rate_std_barrel_day?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  revisions_performance_evaluations_revisions_stddev_pop_fields?: {
    casing_pressure_psia?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    gas_rate_mscf_day?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    intake_override_gas_separation_percent?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    natural_override_gas_separation_percent?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    oil_rate_std_barrel_day?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pump_hz?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pump_intake_pressure_psia?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pump_wear_brake_horsepower_correction_ratio?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pump_wear_head_correction_ratio?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    tubing_pressure_psia?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    water_rate_std_barrel_day?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  revisions_performance_evaluations_revisions_stddev_samp_fields?: {
    casing_pressure_psia?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    gas_rate_mscf_day?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    intake_override_gas_separation_percent?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    natural_override_gas_separation_percent?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    oil_rate_std_barrel_day?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pump_hz?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pump_intake_pressure_psia?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pump_wear_brake_horsepower_correction_ratio?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pump_wear_head_correction_ratio?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    tubing_pressure_psia?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    water_rate_std_barrel_day?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  revisions_performance_evaluations_revisions_sum_fields?: {
    casing_pressure_psia?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    gas_rate_mscf_day?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    intake_override_gas_separation_percent?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    natural_override_gas_separation_percent?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    oil_rate_std_barrel_day?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    pump_hz?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    pump_intake_pressure_psia?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    pump_wear_brake_horsepower_correction_ratio?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    pump_wear_head_correction_ratio?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    tubing_pressure_psia?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    water_rate_std_barrel_day?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>
  },
  revisions_performance_evaluations_revisions_var_pop_fields?: {
    casing_pressure_psia?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    gas_rate_mscf_day?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    intake_override_gas_separation_percent?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    natural_override_gas_separation_percent?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    oil_rate_std_barrel_day?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pump_hz?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pump_intake_pressure_psia?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pump_wear_brake_horsepower_correction_ratio?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pump_wear_head_correction_ratio?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    tubing_pressure_psia?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    water_rate_std_barrel_day?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  revisions_performance_evaluations_revisions_var_samp_fields?: {
    casing_pressure_psia?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    gas_rate_mscf_day?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    intake_override_gas_separation_percent?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    natural_override_gas_separation_percent?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    oil_rate_std_barrel_day?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pump_hz?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pump_intake_pressure_psia?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pump_wear_brake_horsepower_correction_ratio?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pump_wear_head_correction_ratio?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    tubing_pressure_psia?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    water_rate_std_barrel_day?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  revisions_performance_evaluations_revisions_variance_fields?: {
    casing_pressure_psia?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    gas_rate_mscf_day?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    intake_override_gas_separation_percent?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    natural_override_gas_separation_percent?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    oil_rate_std_barrel_day?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pump_hz?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pump_intake_pressure_psia?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pump_wear_brake_horsepower_correction_ratio?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pump_wear_head_correction_ratio?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    tubing_pressure_psia?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    water_rate_std_barrel_day?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Revisions_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  revisions_performance_evaluations_xref_pumps_journal?: {
    author_id?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Journal>, Record<string, never>, Scalars['String'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Journal>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Journal>, Record<string, never>, Scalars['timestamptz'] | string>,
    id?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Journal>, Record<string, never>, Scalars['uuid'] | string>,
    parent_journal_id?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Journal>, Record<string, never>, Scalars['uuid'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Journal>, Record<string, never>, Scalars['timestamptz'] | string>,
    winning_revision_id?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Journal>, Record<string, never>, Scalars['uuid'] | string>
  },
  revisions_performance_evaluations_xref_pumps_journal_aggregate?: {
    aggregate?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Journal_Aggregate>, Record<string, never>, WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Journal_Aggregate_Fields> | string>,
    nodes?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Journal_Aggregate>, Record<string, never>, Array<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Journal> | string>>
  },
  revisions_performance_evaluations_xref_pumps_journal_aggregate_fields?: {
    count?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Journal_Aggregate_Fields>, Revisions_Performance_Evaluations_Xref_Pumps_Journal_Aggregate_FieldsCountArgs, Scalars['Int'] | string>,
    max?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Journal_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Journal_Max_Fields> | string>,
    min?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Journal_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Journal_Min_Fields> | string>
  },
  revisions_performance_evaluations_xref_pumps_journal_max_fields?: {
    author_id?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Journal_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Journal_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Journal_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    id?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Journal_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    parent_journal_id?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Journal_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Journal_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    winning_revision_id?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Journal_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>
  },
  revisions_performance_evaluations_xref_pumps_journal_min_fields?: {
    author_id?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Journal_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Journal_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Journal_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    id?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Journal_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    parent_journal_id?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Journal_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Journal_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    winning_revision_id?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Journal_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>
  },
  revisions_performance_evaluations_xref_pumps_journal_mutation_response?: {
    affected_rows?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Journal_Mutation_Response>, Record<string, never>, Scalars['Int'] | string>,
    returning?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Journal_Mutation_Response>, Record<string, never>, Array<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Journal> | string>>
  },
  revisions_performance_evaluations_xref_pumps_revisions?: {
    author_id?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Revisions>, Record<string, never>, Scalars['String'] | string>,
    brake_horsepower_correction_ratio?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Revisions>, Record<string, never>, Scalars['numeric'] | string>,
    cloned_from_journal_id?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Revisions>, Record<string, never>, Scalars['uuid'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Revisions>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Revisions>, Record<string, never>, Scalars['timestamptz'] | string>,
    head_correction_ratio?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Revisions>, Record<string, never>, Scalars['numeric'] | string>,
    id?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Revisions>, Record<string, never>, Scalars['uuid'] | string>,
    journal_id?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Revisions>, Record<string, never>, Scalars['uuid'] | string>,
    parent_revision_id?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Revisions>, Record<string, never>, Scalars['uuid'] | string>,
    performance_evaluation_id?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Revisions>, Record<string, never>, Scalars['uuid'] | string>,
    performance_evaluations_journal?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Revisions>, Record<string, never>, WithTypename<Revisions_Performance_Evaluations_Journal> | string>,
    performance_evaluations_xref_pumps_journals?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Revisions>, Revisions_Performance_Evaluations_Xref_Pumps_RevisionsPerformance_Evaluations_Xref_Pumps_JournalsArgs, Array<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Journal> | string>>,
    performance_evaluations_xref_pumps_journals_aggregate?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Revisions>, Revisions_Performance_Evaluations_Xref_Pumps_RevisionsPerformance_Evaluations_Xref_Pumps_Journals_AggregateArgs, WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Journal_Aggregate> | string>,
    performance_evaluations_xref_pumps_revisions?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Revisions>, Revisions_Performance_Evaluations_Xref_Pumps_RevisionsPerformance_Evaluations_Xref_Pumps_RevisionsArgs, Array<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Revisions> | string>>,
    performance_evaluations_xref_pumps_revisions_aggregate?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Revisions>, Revisions_Performance_Evaluations_Xref_Pumps_RevisionsPerformance_Evaluations_Xref_Pumps_Revisions_AggregateArgs, WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Aggregate> | string>,
    performance_evaluations_xref_pumps_view?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Revisions>, Record<string, never>, WithTypename<Performance_Evaluations_Xref_Pumps> | string>,
    rate_correction_ratio?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Revisions>, Record<string, never>, Scalars['numeric'] | string>,
    scenario_equipment_xref_pumps_journal?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Revisions>, Record<string, never>, WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Journal> | string>,
    updated_at?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Revisions>, Record<string, never>, Scalars['timestamptz'] | string>,
    user?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Revisions>, Record<string, never>, WithTypename<Users> | string>,
    xref_pump_id?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Revisions>, Record<string, never>, Scalars['uuid'] | string>
  },
  revisions_performance_evaluations_xref_pumps_revisions_aggregate?: {
    aggregate?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Aggregate>, Record<string, never>, WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Aggregate_Fields> | string>,
    nodes?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Aggregate>, Record<string, never>, Array<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Revisions> | string>>
  },
  revisions_performance_evaluations_xref_pumps_revisions_aggregate_fields?: {
    avg?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Avg_Fields> | string>,
    count?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Aggregate_Fields>, Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Aggregate_FieldsCountArgs, Scalars['Int'] | string>,
    max?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Max_Fields> | string>,
    min?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Min_Fields> | string>,
    stddev?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Stddev_Fields> | string>,
    stddev_pop?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Stddev_Pop_Fields> | string>,
    stddev_samp?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Stddev_Samp_Fields> | string>,
    sum?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Sum_Fields> | string>,
    var_pop?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Var_Pop_Fields> | string>,
    var_samp?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Var_Samp_Fields> | string>,
    variance?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Variance_Fields> | string>
  },
  revisions_performance_evaluations_xref_pumps_revisions_avg_fields?: {
    brake_horsepower_correction_ratio?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    head_correction_ratio?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    rate_correction_ratio?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  revisions_performance_evaluations_xref_pumps_revisions_max_fields?: {
    author_id?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    brake_horsepower_correction_ratio?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    cloned_from_journal_id?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    head_correction_ratio?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    id?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    journal_id?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    parent_revision_id?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    performance_evaluation_id?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    rate_correction_ratio?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    xref_pump_id?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>
  },
  revisions_performance_evaluations_xref_pumps_revisions_min_fields?: {
    author_id?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    brake_horsepower_correction_ratio?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    cloned_from_journal_id?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    head_correction_ratio?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    id?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    journal_id?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    parent_revision_id?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    performance_evaluation_id?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    rate_correction_ratio?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    xref_pump_id?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>
  },
  revisions_performance_evaluations_xref_pumps_revisions_mutation_response?: {
    affected_rows?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Mutation_Response>, Record<string, never>, Scalars['Int'] | string>,
    returning?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Mutation_Response>, Record<string, never>, Array<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Revisions> | string>>
  },
  revisions_performance_evaluations_xref_pumps_revisions_stddev_fields?: {
    brake_horsepower_correction_ratio?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    head_correction_ratio?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    rate_correction_ratio?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  revisions_performance_evaluations_xref_pumps_revisions_stddev_pop_fields?: {
    brake_horsepower_correction_ratio?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    head_correction_ratio?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    rate_correction_ratio?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  revisions_performance_evaluations_xref_pumps_revisions_stddev_samp_fields?: {
    brake_horsepower_correction_ratio?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    head_correction_ratio?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    rate_correction_ratio?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  revisions_performance_evaluations_xref_pumps_revisions_sum_fields?: {
    brake_horsepower_correction_ratio?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    head_correction_ratio?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    rate_correction_ratio?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>
  },
  revisions_performance_evaluations_xref_pumps_revisions_var_pop_fields?: {
    brake_horsepower_correction_ratio?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    head_correction_ratio?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    rate_correction_ratio?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  revisions_performance_evaluations_xref_pumps_revisions_var_samp_fields?: {
    brake_horsepower_correction_ratio?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    head_correction_ratio?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    rate_correction_ratio?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  revisions_performance_evaluations_xref_pumps_revisions_variance_fields?: {
    brake_horsepower_correction_ratio?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    head_correction_ratio?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    rate_correction_ratio?: GraphCacheResolver<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  revisions_sc_equip_xref_downhole_ytool_bypass_tubings_journal?: {
    author_id?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal>, Record<string, never>, Scalars['String'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal>, Record<string, never>, Scalars['timestamptz'] | string>,
    id?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal>, Record<string, never>, Scalars['uuid'] | string>,
    parent_journal_id?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal>, Record<string, never>, Scalars['uuid'] | string>,
    sc_equip_xref_downhole_ytool_bypass_tubings_journal?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal>, Record<string, never>, WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal> | string>,
    sc_equip_xref_downhole_ytool_bypass_tubings_journals?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal>, Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_JournalSc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_JournalsArgs, Array<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal> | string>>,
    sc_equip_xref_downhole_ytool_bypass_tubings_journals_aggregate?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal>, Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_JournalSc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journals_AggregateArgs, WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_Aggregate> | string>,
    sc_equip_xref_downhole_ytool_bypass_tubings_revision?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal>, Record<string, never>, WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions> | string>,
    sc_equip_xref_downhole_ytool_bypass_tubings_revisions?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal>, Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_JournalSc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_RevisionsArgs, Array<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions> | string>>,
    sc_equip_xref_downhole_ytool_bypass_tubings_revisions_aggregate?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal>, Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_JournalSc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_AggregateArgs, WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Aggregate> | string>,
    updated_at?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal>, Record<string, never>, Scalars['timestamptz'] | string>,
    user?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal>, Record<string, never>, WithTypename<Users> | string>,
    winning_revision_id?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal>, Record<string, never>, Scalars['uuid'] | string>
  },
  revisions_sc_equip_xref_downhole_ytool_bypass_tubings_journal_aggregate?: {
    aggregate?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_Aggregate>, Record<string, never>, WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_Aggregate_Fields> | string>,
    nodes?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_Aggregate>, Record<string, never>, Array<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal> | string>>
  },
  revisions_sc_equip_xref_downhole_ytool_bypass_tubings_journal_aggregate_fields?: {
    count?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_Aggregate_Fields>, Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_Aggregate_FieldsCountArgs, Scalars['Int'] | string>,
    max?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_Max_Fields> | string>,
    min?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_Min_Fields> | string>
  },
  revisions_sc_equip_xref_downhole_ytool_bypass_tubings_journal_max_fields?: {
    author_id?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    id?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    parent_journal_id?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    winning_revision_id?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>
  },
  revisions_sc_equip_xref_downhole_ytool_bypass_tubings_journal_min_fields?: {
    author_id?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    id?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    parent_journal_id?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    winning_revision_id?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>
  },
  revisions_sc_equip_xref_downhole_ytool_bypass_tubings_journal_mutation_response?: {
    affected_rows?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_Mutation_Response>, Record<string, never>, Scalars['Int'] | string>,
    returning?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_Mutation_Response>, Record<string, never>, Array<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal> | string>>
  },
  revisions_sc_equip_xref_downhole_ytool_bypass_tubings_revisions?: {
    author_id?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions>, Record<string, never>, Scalars['String'] | string>,
    cloned_from_journal_id?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions>, Record<string, never>, Scalars['uuid'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions>, Record<string, never>, Scalars['timestamptz'] | string>,
    id?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions>, Record<string, never>, Scalars['uuid'] | string>,
    journal_id?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions>, Record<string, never>, Scalars['uuid'] | string>,
    length_feet?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions>, Record<string, never>, Scalars['numeric'] | string>,
    parent_revision_id?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions>, Record<string, never>, Scalars['uuid'] | string>,
    sc_equip_xref_downhole_ytool_bypass_tubings_journal?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions>, Record<string, never>, WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal> | string>,
    sc_equip_xref_downhole_ytool_bypass_tubings_journals?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions>, Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_RevisionsSc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_JournalsArgs, Array<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal> | string>>,
    sc_equip_xref_downhole_ytool_bypass_tubings_journals_aggregate?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions>, Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_RevisionsSc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journals_AggregateArgs, WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_Aggregate> | string>,
    sc_equip_xref_downhole_ytool_bypass_tubings_revision?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions>, Record<string, never>, WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions> | string>,
    sc_equip_xref_downhole_ytool_bypass_tubings_revisions?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions>, Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_RevisionsSc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_RevisionsArgs, Array<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions> | string>>,
    sc_equip_xref_downhole_ytool_bypass_tubings_revisions_aggregate?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions>, Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_RevisionsSc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_AggregateArgs, WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Aggregate> | string>,
    sc_equip_xref_downhole_ytool_bypass_tubings_view?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions>, Record<string, never>, WithTypename<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings> | string>,
    scenario_equipment_id?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions>, Record<string, never>, Scalars['uuid'] | string>,
    scenario_equipment_journal?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions>, Record<string, never>, WithTypename<Revisions_Scenario_Equipment_Journal> | string>,
    tubing?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions>, Record<string, never>, WithTypename<Tubings> | string>,
    tubing_id?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions>, Record<string, never>, Scalars['uuid'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions>, Record<string, never>, Scalars['timestamptz'] | string>,
    user?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions>, Record<string, never>, WithTypename<Users> | string>
  },
  revisions_sc_equip_xref_downhole_ytool_bypass_tubings_revisions_aggregate?: {
    aggregate?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Aggregate>, Record<string, never>, WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Aggregate_Fields> | string>,
    nodes?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Aggregate>, Record<string, never>, Array<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions> | string>>
  },
  revisions_sc_equip_xref_downhole_ytool_bypass_tubings_revisions_aggregate_fields?: {
    avg?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Avg_Fields> | string>,
    count?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Aggregate_Fields>, Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Aggregate_FieldsCountArgs, Scalars['Int'] | string>,
    max?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Max_Fields> | string>,
    min?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Min_Fields> | string>,
    stddev?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Stddev_Fields> | string>,
    stddev_pop?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Stddev_Pop_Fields> | string>,
    stddev_samp?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Stddev_Samp_Fields> | string>,
    sum?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Sum_Fields> | string>,
    var_pop?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Var_Pop_Fields> | string>,
    var_samp?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Var_Samp_Fields> | string>,
    variance?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Variance_Fields> | string>
  },
  revisions_sc_equip_xref_downhole_ytool_bypass_tubings_revisions_avg_fields?: {
    length_feet?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  revisions_sc_equip_xref_downhole_ytool_bypass_tubings_revisions_max_fields?: {
    author_id?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    cloned_from_journal_id?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    id?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    journal_id?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    length_feet?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    parent_revision_id?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    scenario_equipment_id?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    tubing_id?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>
  },
  revisions_sc_equip_xref_downhole_ytool_bypass_tubings_revisions_min_fields?: {
    author_id?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    cloned_from_journal_id?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    id?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    journal_id?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    length_feet?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    parent_revision_id?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    scenario_equipment_id?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    tubing_id?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>
  },
  revisions_sc_equip_xref_downhole_ytool_bypass_tubings_revisions_mutation_response?: {
    affected_rows?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Mutation_Response>, Record<string, never>, Scalars['Int'] | string>,
    returning?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Mutation_Response>, Record<string, never>, Array<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions> | string>>
  },
  revisions_sc_equip_xref_downhole_ytool_bypass_tubings_revisions_stddev_fields?: {
    length_feet?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  revisions_sc_equip_xref_downhole_ytool_bypass_tubings_revisions_stddev_pop_fields?: {
    length_feet?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  revisions_sc_equip_xref_downhole_ytool_bypass_tubings_revisions_stddev_samp_fields?: {
    length_feet?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  revisions_sc_equip_xref_downhole_ytool_bypass_tubings_revisions_sum_fields?: {
    length_feet?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>
  },
  revisions_sc_equip_xref_downhole_ytool_bypass_tubings_revisions_var_pop_fields?: {
    length_feet?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  revisions_sc_equip_xref_downhole_ytool_bypass_tubings_revisions_var_samp_fields?: {
    length_feet?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  revisions_sc_equip_xref_downhole_ytool_bypass_tubings_revisions_variance_fields?: {
    length_feet?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  revisions_sc_equip_xref_downhole_ytool_equip_tubings_journal?: {
    author_id?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal>, Record<string, never>, Scalars['String'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal>, Record<string, never>, Scalars['timestamptz'] | string>,
    id?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal>, Record<string, never>, Scalars['uuid'] | string>,
    parent_journal_id?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal>, Record<string, never>, Scalars['uuid'] | string>,
    sc_equip_xref_downhole_ytool_equip_tubings_journal?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal>, Record<string, never>, WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal> | string>,
    sc_equip_xref_downhole_ytool_equip_tubings_journals?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal>, Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_JournalSc_Equip_Xref_Downhole_Ytool_Equip_Tubings_JournalsArgs, Array<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal> | string>>,
    sc_equip_xref_downhole_ytool_equip_tubings_journals_aggregate?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal>, Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_JournalSc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journals_AggregateArgs, WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_Aggregate> | string>,
    sc_equip_xref_downhole_ytool_equip_tubings_revisions?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal>, Record<string, never>, WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions> | string>,
    updated_at?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal>, Record<string, never>, Scalars['timestamptz'] | string>,
    user?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal>, Record<string, never>, WithTypename<Users> | string>,
    winning_revision_id?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal>, Record<string, never>, Scalars['uuid'] | string>
  },
  revisions_sc_equip_xref_downhole_ytool_equip_tubings_journal_aggregate?: {
    aggregate?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_Aggregate>, Record<string, never>, WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_Aggregate_Fields> | string>,
    nodes?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_Aggregate>, Record<string, never>, Array<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal> | string>>
  },
  revisions_sc_equip_xref_downhole_ytool_equip_tubings_journal_aggregate_fields?: {
    count?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_Aggregate_Fields>, Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_Aggregate_FieldsCountArgs, Scalars['Int'] | string>,
    max?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_Max_Fields> | string>,
    min?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_Min_Fields> | string>
  },
  revisions_sc_equip_xref_downhole_ytool_equip_tubings_journal_max_fields?: {
    author_id?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    id?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    parent_journal_id?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    winning_revision_id?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>
  },
  revisions_sc_equip_xref_downhole_ytool_equip_tubings_journal_min_fields?: {
    author_id?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    id?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    parent_journal_id?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    winning_revision_id?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>
  },
  revisions_sc_equip_xref_downhole_ytool_equip_tubings_journal_mutation_response?: {
    affected_rows?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_Mutation_Response>, Record<string, never>, Scalars['Int'] | string>,
    returning?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_Mutation_Response>, Record<string, never>, Array<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal> | string>>
  },
  revisions_sc_equip_xref_downhole_ytool_equip_tubings_revisions?: {
    author_id?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions>, Record<string, never>, Scalars['String'] | string>,
    cloned_from_journal_id?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions>, Record<string, never>, Scalars['uuid'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions>, Record<string, never>, Scalars['timestamptz'] | string>,
    id?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions>, Record<string, never>, Scalars['uuid'] | string>,
    journal_id?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions>, Record<string, never>, Scalars['uuid'] | string>,
    length_feet?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions>, Record<string, never>, Scalars['numeric'] | string>,
    parent_revision_id?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions>, Record<string, never>, Scalars['uuid'] | string>,
    sc_equip_xref_downhole_ytool_equip_tubings_journal?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions>, Record<string, never>, WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal> | string>,
    sc_equip_xref_downhole_ytool_equip_tubings_journals?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions>, Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_RevisionsSc_Equip_Xref_Downhole_Ytool_Equip_Tubings_JournalsArgs, Array<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal> | string>>,
    sc_equip_xref_downhole_ytool_equip_tubings_journals_aggregate?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions>, Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_RevisionsSc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journals_AggregateArgs, WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_Aggregate> | string>,
    sc_equip_xref_downhole_ytool_equip_tubings_revisions?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions>, Record<string, never>, WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions> | string>,
    sc_equip_xref_downhole_ytool_equip_tubings_view?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions>, Record<string, never>, WithTypename<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings> | string>,
    scenario_equipment_id?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions>, Record<string, never>, Scalars['uuid'] | string>,
    scenario_equipment_journal?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions>, Record<string, never>, WithTypename<Revisions_Scenario_Equipment_Journal> | string>,
    tubing?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions>, Record<string, never>, WithTypename<Tubings> | string>,
    tubing_id?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions>, Record<string, never>, Scalars['uuid'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions>, Record<string, never>, Scalars['timestamptz'] | string>,
    user?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions>, Record<string, never>, WithTypename<Users> | string>
  },
  revisions_sc_equip_xref_downhole_ytool_equip_tubings_revisions_aggregate?: {
    aggregate?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Aggregate>, Record<string, never>, WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Aggregate_Fields> | string>,
    nodes?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Aggregate>, Record<string, never>, Array<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions> | string>>
  },
  revisions_sc_equip_xref_downhole_ytool_equip_tubings_revisions_aggregate_fields?: {
    avg?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Avg_Fields> | string>,
    count?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Aggregate_Fields>, Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Aggregate_FieldsCountArgs, Scalars['Int'] | string>,
    max?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Max_Fields> | string>,
    min?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Min_Fields> | string>,
    stddev?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Stddev_Fields> | string>,
    stddev_pop?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Stddev_Pop_Fields> | string>,
    stddev_samp?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Stddev_Samp_Fields> | string>,
    sum?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Sum_Fields> | string>,
    var_pop?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Var_Pop_Fields> | string>,
    var_samp?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Var_Samp_Fields> | string>,
    variance?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Variance_Fields> | string>
  },
  revisions_sc_equip_xref_downhole_ytool_equip_tubings_revisions_avg_fields?: {
    length_feet?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  revisions_sc_equip_xref_downhole_ytool_equip_tubings_revisions_max_fields?: {
    author_id?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    cloned_from_journal_id?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    id?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    journal_id?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    length_feet?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    parent_revision_id?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    scenario_equipment_id?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    tubing_id?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>
  },
  revisions_sc_equip_xref_downhole_ytool_equip_tubings_revisions_min_fields?: {
    author_id?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    cloned_from_journal_id?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    id?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    journal_id?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    length_feet?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    parent_revision_id?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    scenario_equipment_id?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    tubing_id?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>
  },
  revisions_sc_equip_xref_downhole_ytool_equip_tubings_revisions_mutation_response?: {
    affected_rows?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Mutation_Response>, Record<string, never>, Scalars['Int'] | string>,
    returning?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Mutation_Response>, Record<string, never>, Array<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions> | string>>
  },
  revisions_sc_equip_xref_downhole_ytool_equip_tubings_revisions_stddev_fields?: {
    length_feet?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  revisions_sc_equip_xref_downhole_ytool_equip_tubings_revisions_stddev_pop_fields?: {
    length_feet?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  revisions_sc_equip_xref_downhole_ytool_equip_tubings_revisions_stddev_samp_fields?: {
    length_feet?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  revisions_sc_equip_xref_downhole_ytool_equip_tubings_revisions_sum_fields?: {
    length_feet?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>
  },
  revisions_sc_equip_xref_downhole_ytool_equip_tubings_revisions_var_pop_fields?: {
    length_feet?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  revisions_sc_equip_xref_downhole_ytool_equip_tubings_revisions_var_samp_fields?: {
    length_feet?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  revisions_sc_equip_xref_downhole_ytool_equip_tubings_revisions_variance_fields?: {
    length_feet?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  revisions_sc_equip_xref_uphole_ytool_bypass_tubings_journal?: {
    author_id?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal>, Record<string, never>, Scalars['String'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal>, Record<string, never>, Scalars['timestamptz'] | string>,
    id?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal>, Record<string, never>, Scalars['uuid'] | string>,
    parent_journal_id?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal>, Record<string, never>, Scalars['uuid'] | string>,
    sc_equip_xref_uphole_ytool_bypass_tubings_journal?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal>, Record<string, never>, WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal> | string>,
    sc_equip_xref_uphole_ytool_bypass_tubings_journals?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal>, Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_JournalSc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_JournalsArgs, Array<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal> | string>>,
    sc_equip_xref_uphole_ytool_bypass_tubings_journals_aggregate?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal>, Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_JournalSc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journals_AggregateArgs, WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_Aggregate> | string>,
    sc_equip_xref_uphole_ytool_bypass_tubings_revision?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal>, Record<string, never>, WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions> | string>,
    sc_equip_xref_uphole_ytool_bypass_tubings_revisions?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal>, Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_JournalSc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_RevisionsArgs, Array<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions> | string>>,
    sc_equip_xref_uphole_ytool_bypass_tubings_revisions_aggregate?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal>, Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_JournalSc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_AggregateArgs, WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Aggregate> | string>,
    updated_at?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal>, Record<string, never>, Scalars['timestamptz'] | string>,
    user?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal>, Record<string, never>, WithTypename<Users> | string>,
    winning_revision_id?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal>, Record<string, never>, Scalars['uuid'] | string>
  },
  revisions_sc_equip_xref_uphole_ytool_bypass_tubings_journal_aggregate?: {
    aggregate?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_Aggregate>, Record<string, never>, WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_Aggregate_Fields> | string>,
    nodes?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_Aggregate>, Record<string, never>, Array<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal> | string>>
  },
  revisions_sc_equip_xref_uphole_ytool_bypass_tubings_journal_aggregate_fields?: {
    count?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_Aggregate_Fields>, Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_Aggregate_FieldsCountArgs, Scalars['Int'] | string>,
    max?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_Max_Fields> | string>,
    min?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_Min_Fields> | string>
  },
  revisions_sc_equip_xref_uphole_ytool_bypass_tubings_journal_max_fields?: {
    author_id?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    id?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    parent_journal_id?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    winning_revision_id?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>
  },
  revisions_sc_equip_xref_uphole_ytool_bypass_tubings_journal_min_fields?: {
    author_id?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    id?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    parent_journal_id?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    winning_revision_id?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>
  },
  revisions_sc_equip_xref_uphole_ytool_bypass_tubings_journal_mutation_response?: {
    affected_rows?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_Mutation_Response>, Record<string, never>, Scalars['Int'] | string>,
    returning?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_Mutation_Response>, Record<string, never>, Array<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal> | string>>
  },
  revisions_sc_equip_xref_uphole_ytool_bypass_tubings_revisions?: {
    author_id?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions>, Record<string, never>, Scalars['String'] | string>,
    cloned_from_journal_id?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions>, Record<string, never>, Scalars['uuid'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions>, Record<string, never>, Scalars['timestamptz'] | string>,
    id?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions>, Record<string, never>, Scalars['uuid'] | string>,
    journal_id?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions>, Record<string, never>, Scalars['uuid'] | string>,
    length_feet?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions>, Record<string, never>, Scalars['numeric'] | string>,
    parent_revision_id?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions>, Record<string, never>, Scalars['uuid'] | string>,
    sc_equip_xref_uphole_ytool_bypass_tubings_journal?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions>, Record<string, never>, WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal> | string>,
    sc_equip_xref_uphole_ytool_bypass_tubings_journals?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions>, Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_RevisionsSc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_JournalsArgs, Array<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal> | string>>,
    sc_equip_xref_uphole_ytool_bypass_tubings_journals_aggregate?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions>, Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_RevisionsSc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journals_AggregateArgs, WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_Aggregate> | string>,
    sc_equip_xref_uphole_ytool_bypass_tubings_revision?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions>, Record<string, never>, WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions> | string>,
    sc_equip_xref_uphole_ytool_bypass_tubings_revisions?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions>, Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_RevisionsSc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_RevisionsArgs, Array<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions> | string>>,
    sc_equip_xref_uphole_ytool_bypass_tubings_revisions_aggregate?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions>, Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_RevisionsSc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_AggregateArgs, WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Aggregate> | string>,
    sc_equip_xref_uphole_ytool_bypass_tubings_view?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions>, Record<string, never>, WithTypename<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings> | string>,
    scenario_equipment_id?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions>, Record<string, never>, Scalars['uuid'] | string>,
    scenario_equipment_journal?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions>, Record<string, never>, WithTypename<Revisions_Scenario_Equipment_Journal> | string>,
    tubing?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions>, Record<string, never>, WithTypename<Tubings> | string>,
    tubing_id?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions>, Record<string, never>, Scalars['uuid'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions>, Record<string, never>, Scalars['timestamptz'] | string>,
    user?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions>, Record<string, never>, WithTypename<Users> | string>
  },
  revisions_sc_equip_xref_uphole_ytool_bypass_tubings_revisions_aggregate?: {
    aggregate?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Aggregate>, Record<string, never>, WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Aggregate_Fields> | string>,
    nodes?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Aggregate>, Record<string, never>, Array<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions> | string>>
  },
  revisions_sc_equip_xref_uphole_ytool_bypass_tubings_revisions_aggregate_fields?: {
    avg?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Avg_Fields> | string>,
    count?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Aggregate_Fields>, Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Aggregate_FieldsCountArgs, Scalars['Int'] | string>,
    max?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Max_Fields> | string>,
    min?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Min_Fields> | string>,
    stddev?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Stddev_Fields> | string>,
    stddev_pop?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Stddev_Pop_Fields> | string>,
    stddev_samp?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Stddev_Samp_Fields> | string>,
    sum?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Sum_Fields> | string>,
    var_pop?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Var_Pop_Fields> | string>,
    var_samp?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Var_Samp_Fields> | string>,
    variance?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Variance_Fields> | string>
  },
  revisions_sc_equip_xref_uphole_ytool_bypass_tubings_revisions_avg_fields?: {
    length_feet?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  revisions_sc_equip_xref_uphole_ytool_bypass_tubings_revisions_max_fields?: {
    author_id?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    cloned_from_journal_id?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    id?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    journal_id?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    length_feet?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    parent_revision_id?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    scenario_equipment_id?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    tubing_id?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>
  },
  revisions_sc_equip_xref_uphole_ytool_bypass_tubings_revisions_min_fields?: {
    author_id?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    cloned_from_journal_id?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    id?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    journal_id?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    length_feet?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    parent_revision_id?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    scenario_equipment_id?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    tubing_id?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>
  },
  revisions_sc_equip_xref_uphole_ytool_bypass_tubings_revisions_mutation_response?: {
    affected_rows?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Mutation_Response>, Record<string, never>, Scalars['Int'] | string>,
    returning?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Mutation_Response>, Record<string, never>, Array<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions> | string>>
  },
  revisions_sc_equip_xref_uphole_ytool_bypass_tubings_revisions_stddev_fields?: {
    length_feet?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  revisions_sc_equip_xref_uphole_ytool_bypass_tubings_revisions_stddev_pop_fields?: {
    length_feet?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  revisions_sc_equip_xref_uphole_ytool_bypass_tubings_revisions_stddev_samp_fields?: {
    length_feet?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  revisions_sc_equip_xref_uphole_ytool_bypass_tubings_revisions_sum_fields?: {
    length_feet?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>
  },
  revisions_sc_equip_xref_uphole_ytool_bypass_tubings_revisions_var_pop_fields?: {
    length_feet?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  revisions_sc_equip_xref_uphole_ytool_bypass_tubings_revisions_var_samp_fields?: {
    length_feet?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  revisions_sc_equip_xref_uphole_ytool_bypass_tubings_revisions_variance_fields?: {
    length_feet?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  revisions_sc_equip_xref_uphole_ytool_equip_tubings_journal?: {
    author_id?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal>, Record<string, never>, Scalars['String'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal>, Record<string, never>, Scalars['timestamptz'] | string>,
    id?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal>, Record<string, never>, Scalars['uuid'] | string>,
    parent_journal_id?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal>, Record<string, never>, Scalars['uuid'] | string>,
    sc_equip_xref_uphole_ytool_equip_tubings_journal?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal>, Record<string, never>, WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal> | string>,
    sc_equip_xref_uphole_ytool_equip_tubings_journals?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal>, Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_JournalSc_Equip_Xref_Uphole_Ytool_Equip_Tubings_JournalsArgs, Array<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal> | string>>,
    sc_equip_xref_uphole_ytool_equip_tubings_journals_aggregate?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal>, Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_JournalSc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journals_AggregateArgs, WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_Aggregate> | string>,
    sc_equip_xref_uphole_ytool_equip_tubings_revisions?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal>, Record<string, never>, WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions> | string>,
    updated_at?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal>, Record<string, never>, Scalars['timestamptz'] | string>,
    user?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal>, Record<string, never>, WithTypename<Users> | string>,
    winning_revision_id?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal>, Record<string, never>, Scalars['uuid'] | string>
  },
  revisions_sc_equip_xref_uphole_ytool_equip_tubings_journal_aggregate?: {
    aggregate?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_Aggregate>, Record<string, never>, WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_Aggregate_Fields> | string>,
    nodes?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_Aggregate>, Record<string, never>, Array<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal> | string>>
  },
  revisions_sc_equip_xref_uphole_ytool_equip_tubings_journal_aggregate_fields?: {
    count?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_Aggregate_Fields>, Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_Aggregate_FieldsCountArgs, Scalars['Int'] | string>,
    max?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_Max_Fields> | string>,
    min?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_Min_Fields> | string>
  },
  revisions_sc_equip_xref_uphole_ytool_equip_tubings_journal_max_fields?: {
    author_id?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    id?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    parent_journal_id?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    winning_revision_id?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>
  },
  revisions_sc_equip_xref_uphole_ytool_equip_tubings_journal_min_fields?: {
    author_id?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    id?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    parent_journal_id?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    winning_revision_id?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>
  },
  revisions_sc_equip_xref_uphole_ytool_equip_tubings_journal_mutation_response?: {
    affected_rows?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_Mutation_Response>, Record<string, never>, Scalars['Int'] | string>,
    returning?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_Mutation_Response>, Record<string, never>, Array<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal> | string>>
  },
  revisions_sc_equip_xref_uphole_ytool_equip_tubings_revisions?: {
    author_id?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions>, Record<string, never>, Scalars['String'] | string>,
    cloned_from_journal_id?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions>, Record<string, never>, Scalars['uuid'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions>, Record<string, never>, Scalars['timestamptz'] | string>,
    id?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions>, Record<string, never>, Scalars['uuid'] | string>,
    journal_id?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions>, Record<string, never>, Scalars['uuid'] | string>,
    length_feet?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions>, Record<string, never>, Scalars['numeric'] | string>,
    parent_revision_id?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions>, Record<string, never>, Scalars['uuid'] | string>,
    sc_equip_xref_uphole_ytool_equip_tubings_journal?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions>, Record<string, never>, WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal> | string>,
    sc_equip_xref_uphole_ytool_equip_tubings_journals?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions>, Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_RevisionsSc_Equip_Xref_Uphole_Ytool_Equip_Tubings_JournalsArgs, Array<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal> | string>>,
    sc_equip_xref_uphole_ytool_equip_tubings_journals_aggregate?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions>, Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_RevisionsSc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journals_AggregateArgs, WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_Aggregate> | string>,
    sc_equip_xref_uphole_ytool_equip_tubings_revisions?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions>, Record<string, never>, WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions> | string>,
    sc_equip_xref_uphole_ytool_equip_tubings_view?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions>, Record<string, never>, WithTypename<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings> | string>,
    scenario_equipment_id?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions>, Record<string, never>, Scalars['uuid'] | string>,
    scenario_equipment_journal?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions>, Record<string, never>, WithTypename<Revisions_Scenario_Equipment_Journal> | string>,
    tubing?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions>, Record<string, never>, WithTypename<Tubings> | string>,
    tubing_id?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions>, Record<string, never>, Scalars['uuid'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions>, Record<string, never>, Scalars['timestamptz'] | string>,
    user?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions>, Record<string, never>, WithTypename<Users> | string>
  },
  revisions_sc_equip_xref_uphole_ytool_equip_tubings_revisions_aggregate?: {
    aggregate?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Aggregate>, Record<string, never>, WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Aggregate_Fields> | string>,
    nodes?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Aggregate>, Record<string, never>, Array<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions> | string>>
  },
  revisions_sc_equip_xref_uphole_ytool_equip_tubings_revisions_aggregate_fields?: {
    avg?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Avg_Fields> | string>,
    count?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Aggregate_Fields>, Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Aggregate_FieldsCountArgs, Scalars['Int'] | string>,
    max?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Max_Fields> | string>,
    min?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Min_Fields> | string>,
    stddev?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Stddev_Fields> | string>,
    stddev_pop?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Stddev_Pop_Fields> | string>,
    stddev_samp?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Stddev_Samp_Fields> | string>,
    sum?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Sum_Fields> | string>,
    var_pop?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Var_Pop_Fields> | string>,
    var_samp?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Var_Samp_Fields> | string>,
    variance?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Variance_Fields> | string>
  },
  revisions_sc_equip_xref_uphole_ytool_equip_tubings_revisions_avg_fields?: {
    length_feet?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  revisions_sc_equip_xref_uphole_ytool_equip_tubings_revisions_max_fields?: {
    author_id?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    cloned_from_journal_id?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    id?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    journal_id?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    length_feet?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    parent_revision_id?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    scenario_equipment_id?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    tubing_id?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>
  },
  revisions_sc_equip_xref_uphole_ytool_equip_tubings_revisions_min_fields?: {
    author_id?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    cloned_from_journal_id?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    id?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    journal_id?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    length_feet?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    parent_revision_id?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    scenario_equipment_id?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    tubing_id?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>
  },
  revisions_sc_equip_xref_uphole_ytool_equip_tubings_revisions_mutation_response?: {
    affected_rows?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Mutation_Response>, Record<string, never>, Scalars['Int'] | string>,
    returning?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Mutation_Response>, Record<string, never>, Array<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions> | string>>
  },
  revisions_sc_equip_xref_uphole_ytool_equip_tubings_revisions_stddev_fields?: {
    length_feet?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  revisions_sc_equip_xref_uphole_ytool_equip_tubings_revisions_stddev_pop_fields?: {
    length_feet?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  revisions_sc_equip_xref_uphole_ytool_equip_tubings_revisions_stddev_samp_fields?: {
    length_feet?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  revisions_sc_equip_xref_uphole_ytool_equip_tubings_revisions_sum_fields?: {
    length_feet?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>
  },
  revisions_sc_equip_xref_uphole_ytool_equip_tubings_revisions_var_pop_fields?: {
    length_feet?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  revisions_sc_equip_xref_uphole_ytool_equip_tubings_revisions_var_samp_fields?: {
    length_feet?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  revisions_sc_equip_xref_uphole_ytool_equip_tubings_revisions_variance_fields?: {
    length_feet?: GraphCacheResolver<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  revisions_scenario_correlations_journal?: {
    author_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Journal>, Record<string, never>, Scalars['String'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Journal>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Journal>, Record<string, never>, Scalars['timestamptz'] | string>,
    id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Journal>, Record<string, never>, Scalars['uuid'] | string>,
    parent_journal_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Journal>, Record<string, never>, Scalars['uuid'] | string>,
    scenario_correlations_journal?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Journal>, Record<string, never>, WithTypename<Revisions_Scenario_Correlations_Journal> | string>,
    scenario_correlations_journals?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Journal>, Revisions_Scenario_Correlations_JournalScenario_Correlations_JournalsArgs, Array<WithTypename<Revisions_Scenario_Correlations_Journal> | string>>,
    scenario_correlations_journals_aggregate?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Journal>, Revisions_Scenario_Correlations_JournalScenario_Correlations_Journals_AggregateArgs, WithTypename<Revisions_Scenario_Correlations_Journal_Aggregate> | string>,
    scenario_correlations_revision?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Journal>, Record<string, never>, WithTypename<Revisions_Scenario_Correlations_Revisions> | string>,
    scenario_correlations_revisions?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Journal>, Revisions_Scenario_Correlations_JournalScenario_Correlations_RevisionsArgs, Array<WithTypename<Revisions_Scenario_Correlations_Revisions> | string>>,
    scenario_correlations_revisions_aggregate?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Journal>, Revisions_Scenario_Correlations_JournalScenario_Correlations_Revisions_AggregateArgs, WithTypename<Revisions_Scenario_Correlations_Revisions_Aggregate> | string>,
    scenarios_revisions?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Journal>, Revisions_Scenario_Correlations_JournalScenarios_RevisionsArgs, Array<WithTypename<Revisions_Scenarios_Revisions> | string>>,
    scenarios_revisions_aggregate?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Journal>, Revisions_Scenario_Correlations_JournalScenarios_Revisions_AggregateArgs, WithTypename<Revisions_Scenarios_Revisions_Aggregate> | string>,
    updated_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Journal>, Record<string, never>, Scalars['timestamptz'] | string>,
    user?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Journal>, Record<string, never>, WithTypename<Users> | string>,
    winning_revision_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Journal>, Record<string, never>, Scalars['uuid'] | string>
  },
  revisions_scenario_correlations_journal_aggregate?: {
    aggregate?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Journal_Aggregate>, Record<string, never>, WithTypename<Revisions_Scenario_Correlations_Journal_Aggregate_Fields> | string>,
    nodes?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Journal_Aggregate>, Record<string, never>, Array<WithTypename<Revisions_Scenario_Correlations_Journal> | string>>
  },
  revisions_scenario_correlations_journal_aggregate_fields?: {
    count?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Journal_Aggregate_Fields>, Revisions_Scenario_Correlations_Journal_Aggregate_FieldsCountArgs, Scalars['Int'] | string>,
    max?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Journal_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Scenario_Correlations_Journal_Max_Fields> | string>,
    min?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Journal_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Scenario_Correlations_Journal_Min_Fields> | string>
  },
  revisions_scenario_correlations_journal_max_fields?: {
    author_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Journal_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Journal_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Journal_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Journal_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    parent_journal_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Journal_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Journal_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    winning_revision_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Journal_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>
  },
  revisions_scenario_correlations_journal_min_fields?: {
    author_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Journal_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Journal_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Journal_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Journal_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    parent_journal_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Journal_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Journal_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    winning_revision_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Journal_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>
  },
  revisions_scenario_correlations_journal_mutation_response?: {
    affected_rows?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Journal_Mutation_Response>, Record<string, never>, Scalars['Int'] | string>,
    returning?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Journal_Mutation_Response>, Record<string, never>, Array<WithTypename<Revisions_Scenario_Correlations_Journal> | string>>
  },
  revisions_scenario_correlations_revisions?: {
    author_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Revisions>, Record<string, never>, Scalars['String'] | string>,
    bubble_point?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Revisions>, Record<string, never>, Bubble_Point_Options_Enum | string>,
    bubble_point_option?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Revisions>, Record<string, never>, WithTypename<Bubble_Point_Options> | string>,
    casing_apply_hazen_williams_correction?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Revisions>, Record<string, never>, Scalars['Boolean'] | string>,
    casing_flow?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Revisions>, Record<string, never>, Casing_Flow_Options_Enum | string>,
    casing_griffith_wallis?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Revisions>, Record<string, never>, Scalars['Boolean'] | string>,
    casing_hazen_williams_coefficient?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Revisions>, Record<string, never>, Scalars['numeric'] | string>,
    casing_palmer_correction?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Revisions>, Record<string, never>, Scalars['Boolean'] | string>,
    casing_roughness_inches?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Revisions>, Record<string, never>, Scalars['numeric'] | string>,
    cloned_from_journal_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Revisions>, Record<string, never>, Scalars['uuid'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Revisions>, Record<string, never>, Scalars['timestamptz'] | string>,
    dead_oil?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Revisions>, Record<string, never>, Dead_Oil_Options_Enum | string>,
    dead_oil_option?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Revisions>, Record<string, never>, WithTypename<Dead_Oil_Options> | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Revisions>, Record<string, never>, Scalars['timestamptz'] | string>,
    friction_loss?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Revisions>, Record<string, never>, Friction_Loss_Options_Enum | string>,
    gas_compressibility?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Revisions>, Record<string, never>, Gas_Compressibility_Options_Enum | string>,
    gas_compressibility_option?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Revisions>, Record<string, never>, WithTypename<Gas_Compressibility_Options> | string>,
    gas_viscosity?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Revisions>, Record<string, never>, Gas_Viscosity_Options_Enum | string>,
    gas_viscosity_option?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Revisions>, Record<string, never>, WithTypename<Gas_Viscosity_Options> | string>,
    id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Revisions>, Record<string, never>, Scalars['uuid'] | string>,
    journal_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Revisions>, Record<string, never>, Scalars['uuid'] | string>,
    natural_gas_separation?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Revisions>, Record<string, never>, Natural_Gas_Separation_Options_Enum | string>,
    oil_density?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Revisions>, Record<string, never>, Oil_Density_Options_Enum | string>,
    oil_density_option?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Revisions>, Record<string, never>, WithTypename<Oil_Density_Options> | string>,
    oil_volume_factor_saturated?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Revisions>, Record<string, never>, Scalars['String'] | string>,
    oil_volume_factor_saturated_option?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Revisions>, Record<string, never>, WithTypename<Oil_Volume_Factor_Options> | string>,
    oil_volume_factor_undersaturated?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Revisions>, Record<string, never>, Oil_Volume_Factor_Options_Enum | string>,
    oil_volume_factor_undersaturated_option?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Revisions>, Record<string, never>, WithTypename<Oil_Volume_Factor_Options> | string>,
    parent_revision_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Revisions>, Record<string, never>, Scalars['uuid'] | string>,
    salinity_ppm?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Revisions>, Record<string, never>, Scalars['numeric'] | string>,
    saturated_oil?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Revisions>, Record<string, never>, Saturated_Oil_Options_Enum | string>,
    saturated_oil_option?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Revisions>, Record<string, never>, WithTypename<Saturated_Oil_Options> | string>,
    scenario_correlations_journal?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Revisions>, Record<string, never>, WithTypename<Revisions_Scenario_Correlations_Journal> | string>,
    scenario_correlations_journals?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Revisions>, Revisions_Scenario_Correlations_RevisionsScenario_Correlations_JournalsArgs, Array<WithTypename<Revisions_Scenario_Correlations_Journal> | string>>,
    scenario_correlations_journals_aggregate?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Revisions>, Revisions_Scenario_Correlations_RevisionsScenario_Correlations_Journals_AggregateArgs, WithTypename<Revisions_Scenario_Correlations_Journal_Aggregate> | string>,
    scenario_correlations_revision?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Revisions>, Record<string, never>, WithTypename<Revisions_Scenario_Correlations_Revisions> | string>,
    scenario_correlations_revisions?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Revisions>, Revisions_Scenario_Correlations_RevisionsScenario_Correlations_RevisionsArgs, Array<WithTypename<Revisions_Scenario_Correlations_Revisions> | string>>,
    scenario_correlations_revisions_aggregate?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Revisions>, Revisions_Scenario_Correlations_RevisionsScenario_Correlations_Revisions_AggregateArgs, WithTypename<Revisions_Scenario_Correlations_Revisions_Aggregate> | string>,
    scenario_correlations_view?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Revisions>, Record<string, never>, WithTypename<Scenario_Correlations> | string>,
    solution_gas_oil_ratio_option?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Revisions>, Record<string, never>, WithTypename<Solution_Gas_Oil_Ratio_Options> | string>,
    solution_gor?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Revisions>, Record<string, never>, Solution_Gas_Oil_Ratio_Options_Enum | string>,
    tdh_tuning_factor_ratio?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Revisions>, Record<string, never>, Scalars['numeric'] | string>,
    tubing_apply_hazen_williams_correction?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Revisions>, Record<string, never>, Scalars['Boolean'] | string>,
    tubing_flow?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Revisions>, Record<string, never>, Tubing_Flow_Options_Enum | string>,
    tubing_flow_option?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Revisions>, Record<string, never>, WithTypename<Tubing_Flow_Options> | string>,
    tubing_griffith_wallis?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Revisions>, Record<string, never>, Scalars['Boolean'] | string>,
    tubing_hazen_williams_coefficient?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Revisions>, Record<string, never>, Scalars['numeric'] | string>,
    tubing_palmer_correction?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Revisions>, Record<string, never>, Scalars['Boolean'] | string>,
    tubing_roughness_inches?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Revisions>, Record<string, never>, Scalars['numeric'] | string>,
    under_saturated_oil?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Revisions>, Record<string, never>, Under_Saturated_Oil_Options_Enum | string>,
    under_saturated_oil_option?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Revisions>, Record<string, never>, WithTypename<Under_Saturated_Oil_Options> | string>,
    updated_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Revisions>, Record<string, never>, Scalars['timestamptz'] | string>,
    user?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Revisions>, Record<string, never>, WithTypename<Users> | string>,
    water_density?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Revisions>, Record<string, never>, Water_Density_Options_Enum | string>,
    water_solution_gas?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Revisions>, Record<string, never>, Water_Solution_Gas_Options_Enum | string>,
    water_viscosity?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Revisions>, Record<string, never>, Water_Viscosity_Options_Enum | string>,
    water_viscosity_option?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Revisions>, Record<string, never>, WithTypename<Water_Viscosity_Options> | string>,
    water_volume_factor?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Revisions>, Record<string, never>, Water_Volume_Factor_Options_Enum | string>,
    water_volume_factor_option?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Revisions>, Record<string, never>, WithTypename<Water_Volume_Factor_Options> | string>
  },
  revisions_scenario_correlations_revisions_aggregate?: {
    aggregate?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Revisions_Aggregate>, Record<string, never>, WithTypename<Revisions_Scenario_Correlations_Revisions_Aggregate_Fields> | string>,
    nodes?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Revisions_Aggregate>, Record<string, never>, Array<WithTypename<Revisions_Scenario_Correlations_Revisions> | string>>
  },
  revisions_scenario_correlations_revisions_aggregate_fields?: {
    avg?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Revisions_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Scenario_Correlations_Revisions_Avg_Fields> | string>,
    count?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Revisions_Aggregate_Fields>, Revisions_Scenario_Correlations_Revisions_Aggregate_FieldsCountArgs, Scalars['Int'] | string>,
    max?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Revisions_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Scenario_Correlations_Revisions_Max_Fields> | string>,
    min?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Revisions_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Scenario_Correlations_Revisions_Min_Fields> | string>,
    stddev?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Revisions_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Scenario_Correlations_Revisions_Stddev_Fields> | string>,
    stddev_pop?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Revisions_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Scenario_Correlations_Revisions_Stddev_Pop_Fields> | string>,
    stddev_samp?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Revisions_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Scenario_Correlations_Revisions_Stddev_Samp_Fields> | string>,
    sum?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Revisions_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Scenario_Correlations_Revisions_Sum_Fields> | string>,
    var_pop?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Revisions_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Scenario_Correlations_Revisions_Var_Pop_Fields> | string>,
    var_samp?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Revisions_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Scenario_Correlations_Revisions_Var_Samp_Fields> | string>,
    variance?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Revisions_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Scenario_Correlations_Revisions_Variance_Fields> | string>
  },
  revisions_scenario_correlations_revisions_avg_fields?: {
    casing_hazen_williams_coefficient?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Revisions_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    casing_roughness_inches?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Revisions_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    salinity_ppm?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Revisions_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    tdh_tuning_factor_ratio?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Revisions_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    tubing_hazen_williams_coefficient?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Revisions_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    tubing_roughness_inches?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Revisions_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  revisions_scenario_correlations_revisions_max_fields?: {
    author_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Revisions_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    casing_hazen_williams_coefficient?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Revisions_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    casing_roughness_inches?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Revisions_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    cloned_from_journal_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Revisions_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Revisions_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Revisions_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Revisions_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    journal_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Revisions_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    oil_volume_factor_saturated?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Revisions_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    parent_revision_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Revisions_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    salinity_ppm?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Revisions_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    tdh_tuning_factor_ratio?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Revisions_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    tubing_hazen_williams_coefficient?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Revisions_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    tubing_roughness_inches?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Revisions_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Revisions_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>
  },
  revisions_scenario_correlations_revisions_min_fields?: {
    author_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Revisions_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    casing_hazen_williams_coefficient?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Revisions_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    casing_roughness_inches?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Revisions_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    cloned_from_journal_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Revisions_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Revisions_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Revisions_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Revisions_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    journal_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Revisions_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    oil_volume_factor_saturated?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Revisions_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    parent_revision_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Revisions_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    salinity_ppm?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Revisions_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    tdh_tuning_factor_ratio?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Revisions_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    tubing_hazen_williams_coefficient?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Revisions_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    tubing_roughness_inches?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Revisions_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Revisions_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>
  },
  revisions_scenario_correlations_revisions_mutation_response?: {
    affected_rows?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Revisions_Mutation_Response>, Record<string, never>, Scalars['Int'] | string>,
    returning?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Revisions_Mutation_Response>, Record<string, never>, Array<WithTypename<Revisions_Scenario_Correlations_Revisions> | string>>
  },
  revisions_scenario_correlations_revisions_stddev_fields?: {
    casing_hazen_williams_coefficient?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Revisions_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    casing_roughness_inches?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Revisions_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    salinity_ppm?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Revisions_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    tdh_tuning_factor_ratio?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Revisions_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    tubing_hazen_williams_coefficient?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Revisions_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    tubing_roughness_inches?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Revisions_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  revisions_scenario_correlations_revisions_stddev_pop_fields?: {
    casing_hazen_williams_coefficient?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Revisions_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    casing_roughness_inches?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Revisions_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    salinity_ppm?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Revisions_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    tdh_tuning_factor_ratio?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Revisions_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    tubing_hazen_williams_coefficient?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Revisions_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    tubing_roughness_inches?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Revisions_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  revisions_scenario_correlations_revisions_stddev_samp_fields?: {
    casing_hazen_williams_coefficient?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Revisions_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    casing_roughness_inches?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Revisions_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    salinity_ppm?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Revisions_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    tdh_tuning_factor_ratio?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Revisions_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    tubing_hazen_williams_coefficient?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Revisions_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    tubing_roughness_inches?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Revisions_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  revisions_scenario_correlations_revisions_sum_fields?: {
    casing_hazen_williams_coefficient?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Revisions_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    casing_roughness_inches?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Revisions_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    salinity_ppm?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Revisions_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    tdh_tuning_factor_ratio?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Revisions_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    tubing_hazen_williams_coefficient?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Revisions_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    tubing_roughness_inches?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Revisions_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>
  },
  revisions_scenario_correlations_revisions_var_pop_fields?: {
    casing_hazen_williams_coefficient?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Revisions_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    casing_roughness_inches?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Revisions_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    salinity_ppm?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Revisions_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    tdh_tuning_factor_ratio?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Revisions_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    tubing_hazen_williams_coefficient?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Revisions_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    tubing_roughness_inches?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Revisions_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  revisions_scenario_correlations_revisions_var_samp_fields?: {
    casing_hazen_williams_coefficient?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Revisions_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    casing_roughness_inches?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Revisions_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    salinity_ppm?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Revisions_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    tdh_tuning_factor_ratio?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Revisions_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    tubing_hazen_williams_coefficient?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Revisions_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    tubing_roughness_inches?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Revisions_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  revisions_scenario_correlations_revisions_variance_fields?: {
    casing_hazen_williams_coefficient?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Revisions_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    casing_roughness_inches?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Revisions_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    salinity_ppm?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Revisions_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    tdh_tuning_factor_ratio?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Revisions_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    tubing_hazen_williams_coefficient?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Revisions_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    tubing_roughness_inches?: GraphCacheResolver<WithTypename<Revisions_Scenario_Correlations_Revisions_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  revisions_scenario_equipment_journal?: {
    author_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Journal>, Record<string, never>, Scalars['String'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Journal>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Journal>, Record<string, never>, Scalars['timestamptz'] | string>,
    id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Journal>, Record<string, never>, Scalars['uuid'] | string>,
    parent_journal_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Journal>, Record<string, never>, Scalars['uuid'] | string>,
    sc_equip_xref_downhole_ytool_bypass_tubings_revisions?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Journal>, Revisions_Scenario_Equipment_JournalSc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_RevisionsArgs, Array<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions> | string>>,
    sc_equip_xref_downhole_ytool_bypass_tubings_revisions_aggregate?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Journal>, Revisions_Scenario_Equipment_JournalSc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_AggregateArgs, WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Aggregate> | string>,
    sc_equip_xref_downhole_ytool_equip_tubings_revisions?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Journal>, Revisions_Scenario_Equipment_JournalSc_Equip_Xref_Downhole_Ytool_Equip_Tubings_RevisionsArgs, Array<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions> | string>>,
    sc_equip_xref_downhole_ytool_equip_tubings_revisions_aggregate?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Journal>, Revisions_Scenario_Equipment_JournalSc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_AggregateArgs, WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Aggregate> | string>,
    sc_equip_xref_uphole_ytool_bypass_tubings_revisions?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Journal>, Revisions_Scenario_Equipment_JournalSc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_RevisionsArgs, Array<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions> | string>>,
    sc_equip_xref_uphole_ytool_bypass_tubings_revisions_aggregate?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Journal>, Revisions_Scenario_Equipment_JournalSc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_AggregateArgs, WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Aggregate> | string>,
    sc_equip_xref_uphole_ytool_equip_tubings_revisions?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Journal>, Revisions_Scenario_Equipment_JournalSc_Equip_Xref_Uphole_Ytool_Equip_Tubings_RevisionsArgs, Array<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions> | string>>,
    sc_equip_xref_uphole_ytool_equip_tubings_revisions_aggregate?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Journal>, Revisions_Scenario_Equipment_JournalSc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_AggregateArgs, WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Aggregate> | string>,
    scenario_equipment_journal?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Journal>, Record<string, never>, WithTypename<Revisions_Scenario_Equipment_Journal> | string>,
    scenario_equipment_journals?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Journal>, Revisions_Scenario_Equipment_JournalScenario_Equipment_JournalsArgs, Array<WithTypename<Revisions_Scenario_Equipment_Journal> | string>>,
    scenario_equipment_journals_aggregate?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Journal>, Revisions_Scenario_Equipment_JournalScenario_Equipment_Journals_AggregateArgs, WithTypename<Revisions_Scenario_Equipment_Journal_Aggregate> | string>,
    scenario_equipment_revision?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Journal>, Record<string, never>, WithTypename<Revisions_Scenario_Equipment_Revisions> | string>,
    scenario_equipment_revisions?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Journal>, Revisions_Scenario_Equipment_JournalScenario_Equipment_RevisionsArgs, Array<WithTypename<Revisions_Scenario_Equipment_Revisions> | string>>,
    scenario_equipment_revisions_aggregate?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Journal>, Revisions_Scenario_Equipment_JournalScenario_Equipment_Revisions_AggregateArgs, WithTypename<Revisions_Scenario_Equipment_Revisions_Aggregate> | string>,
    scenario_equipment_xref_cables_revisions?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Journal>, Revisions_Scenario_Equipment_JournalScenario_Equipment_Xref_Cables_RevisionsArgs, Array<WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Revisions> | string>>,
    scenario_equipment_xref_cables_revisions_aggregate?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Journal>, Revisions_Scenario_Equipment_JournalScenario_Equipment_Xref_Cables_Revisions_AggregateArgs, WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Aggregate> | string>,
    scenario_equipment_xref_intakes_revisions?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Journal>, Revisions_Scenario_Equipment_JournalScenario_Equipment_Xref_Intakes_RevisionsArgs, Array<WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Revisions> | string>>,
    scenario_equipment_xref_intakes_revisions_aggregate?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Journal>, Revisions_Scenario_Equipment_JournalScenario_Equipment_Xref_Intakes_Revisions_AggregateArgs, WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Aggregate> | string>,
    scenario_equipment_xref_pumps_revisions?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Journal>, Revisions_Scenario_Equipment_JournalScenario_Equipment_Xref_Pumps_RevisionsArgs, Array<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions> | string>>,
    scenario_equipment_xref_pumps_revisions_aggregate?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Journal>, Revisions_Scenario_Equipment_JournalScenario_Equipment_Xref_Pumps_Revisions_AggregateArgs, WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Aggregate> | string>,
    scenario_equipment_xref_seals_revisions?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Journal>, Revisions_Scenario_Equipment_JournalScenario_Equipment_Xref_Seals_RevisionsArgs, Array<WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Revisions> | string>>,
    scenario_equipment_xref_seals_revisions_aggregate?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Journal>, Revisions_Scenario_Equipment_JournalScenario_Equipment_Xref_Seals_Revisions_AggregateArgs, WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Revisions_Aggregate> | string>,
    scenarios_revisions?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Journal>, Revisions_Scenario_Equipment_JournalScenarios_RevisionsArgs, Array<WithTypename<Revisions_Scenarios_Revisions> | string>>,
    scenarios_revisions_aggregate?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Journal>, Revisions_Scenario_Equipment_JournalScenarios_Revisions_AggregateArgs, WithTypename<Revisions_Scenarios_Revisions_Aggregate> | string>,
    updated_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Journal>, Record<string, never>, Scalars['timestamptz'] | string>,
    user?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Journal>, Record<string, never>, WithTypename<Users> | string>,
    winning_revision_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Journal>, Record<string, never>, Scalars['uuid'] | string>
  },
  revisions_scenario_equipment_journal_aggregate?: {
    aggregate?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Journal_Aggregate>, Record<string, never>, WithTypename<Revisions_Scenario_Equipment_Journal_Aggregate_Fields> | string>,
    nodes?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Journal_Aggregate>, Record<string, never>, Array<WithTypename<Revisions_Scenario_Equipment_Journal> | string>>
  },
  revisions_scenario_equipment_journal_aggregate_fields?: {
    count?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Journal_Aggregate_Fields>, Revisions_Scenario_Equipment_Journal_Aggregate_FieldsCountArgs, Scalars['Int'] | string>,
    max?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Journal_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Scenario_Equipment_Journal_Max_Fields> | string>,
    min?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Journal_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Scenario_Equipment_Journal_Min_Fields> | string>
  },
  revisions_scenario_equipment_journal_max_fields?: {
    author_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Journal_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Journal_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Journal_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Journal_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    parent_journal_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Journal_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Journal_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    winning_revision_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Journal_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>
  },
  revisions_scenario_equipment_journal_min_fields?: {
    author_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Journal_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Journal_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Journal_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Journal_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    parent_journal_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Journal_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Journal_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    winning_revision_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Journal_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>
  },
  revisions_scenario_equipment_journal_mutation_response?: {
    affected_rows?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Journal_Mutation_Response>, Record<string, never>, Scalars['Int'] | string>,
    returning?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Journal_Mutation_Response>, Record<string, never>, Array<WithTypename<Revisions_Scenario_Equipment_Journal> | string>>
  },
  revisions_scenario_equipment_revisions?: {
    author_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Revisions>, Record<string, never>, Scalars['String'] | string>,
    bolt_on_discharge_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Revisions>, Record<string, never>, Scalars['uuid'] | string>,
    cables_order?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Revisions>, Record<string, never>, Array<Scalars['uuid'] | string>>,
    cloned_from_journal_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Revisions>, Record<string, never>, Scalars['uuid'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Revisions>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Revisions>, Record<string, never>, Scalars['timestamptz'] | string>,
    down_trans_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Revisions>, Record<string, never>, Scalars['uuid'] | string>,
    downhole_y_tool?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Revisions>, Record<string, never>, WithTypename<Y_Tools> | string>,
    downhole_y_tool_bypass_tubing_order?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Revisions>, Record<string, never>, Array<Scalars['uuid'] | string>>,
    downhole_y_tool_equipment_tubing_order?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Revisions>, Record<string, never>, Array<Scalars['uuid'] | string>>,
    downhole_y_tool_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Revisions>, Record<string, never>, Scalars['uuid'] | string>,
    has_lower_equip_stack?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Revisions>, Record<string, never>, Scalars['Boolean'] | string>,
    id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Revisions>, Record<string, never>, Scalars['uuid'] | string>,
    include_y_tool?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Revisions>, Record<string, never>, Scalars['Boolean'] | string>,
    intakes_order?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Revisions>, Record<string, never>, Array<Scalars['uuid'] | string>>,
    journal_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Revisions>, Record<string, never>, Scalars['uuid'] | string>,
    lower_bolt_on_discharge_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Revisions>, Record<string, never>, Scalars['uuid'] | string>,
    lower_cables_order?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Revisions>, Record<string, never>, Array<Scalars['uuid'] | string>>,
    lower_intakes_order?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Revisions>, Record<string, never>, Array<Scalars['uuid'] | string>>,
    lower_mle_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Revisions>, Record<string, never>, Scalars['uuid'] | string>,
    lower_motor_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Revisions>, Record<string, never>, Scalars['uuid'] | string>,
    lower_pumps_order?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Revisions>, Record<string, never>, Array<Scalars['uuid'] | string>>,
    lower_seal_motor_oil_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Revisions>, Record<string, never>, Scalars['uuid'] | string>,
    lower_seals_order?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Revisions>, Record<string, never>, Array<Scalars['uuid'] | string>>,
    lower_sensor_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Revisions>, Record<string, never>, Scalars['uuid'] | string>,
    lower_shroud?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Revisions>, Record<string, never>, WithTypename<Casings> | string>,
    lower_shroud_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Revisions>, Record<string, never>, Scalars['uuid'] | string>,
    mle_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Revisions>, Record<string, never>, Scalars['uuid'] | string>,
    motor?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Revisions>, Record<string, never>, WithTypename<Motors> | string>,
    motor_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Revisions>, Record<string, never>, Scalars['uuid'] | string>,
    motor_lead_extension?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Revisions>, Record<string, never>, WithTypename<Motor_Lead_Extensions> | string>,
    parent_revision_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Revisions>, Record<string, never>, Scalars['uuid'] | string>,
    pumps_order?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Revisions>, Record<string, never>, Array<Scalars['uuid'] | string>>,
    scenario_equipment_journal?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Revisions>, Record<string, never>, WithTypename<Revisions_Scenario_Equipment_Journal> | string>,
    scenario_equipment_journals?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Revisions>, Revisions_Scenario_Equipment_RevisionsScenario_Equipment_JournalsArgs, Array<WithTypename<Revisions_Scenario_Equipment_Journal> | string>>,
    scenario_equipment_journals_aggregate?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Revisions>, Revisions_Scenario_Equipment_RevisionsScenario_Equipment_Journals_AggregateArgs, WithTypename<Revisions_Scenario_Equipment_Journal_Aggregate> | string>,
    scenario_equipment_revision?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Revisions>, Record<string, never>, WithTypename<Revisions_Scenario_Equipment_Revisions> | string>,
    scenario_equipment_revisions?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Revisions>, Revisions_Scenario_Equipment_RevisionsScenario_Equipment_RevisionsArgs, Array<WithTypename<Revisions_Scenario_Equipment_Revisions> | string>>,
    scenario_equipment_revisions_aggregate?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Revisions>, Revisions_Scenario_Equipment_RevisionsScenario_Equipment_Revisions_AggregateArgs, WithTypename<Revisions_Scenario_Equipment_Revisions_Aggregate> | string>,
    scenario_equipment_view?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Revisions>, Record<string, never>, WithTypename<Scenario_Equipment> | string>,
    seal_motor_oil?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Revisions>, Record<string, never>, WithTypename<Seal_Motor_Oil> | string>,
    seal_motor_oil_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Revisions>, Record<string, never>, Scalars['uuid'] | string>,
    seals_order?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Revisions>, Record<string, never>, Array<Scalars['uuid'] | string>>,
    sensor?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Revisions>, Record<string, never>, WithTypename<Sensors> | string>,
    sensor_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Revisions>, Record<string, never>, Scalars['uuid'] | string>,
    shroud?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Revisions>, Record<string, never>, WithTypename<Casings> | string>,
    shroud_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Revisions>, Record<string, never>, Scalars['uuid'] | string>,
    step_down_transformer?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Revisions>, Record<string, never>, WithTypename<Step_Down_Transformers> | string>,
    step_up_transformer?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Revisions>, Record<string, never>, WithTypename<Step_Up_Transformers> | string>,
    switchboard?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Revisions>, Record<string, never>, WithTypename<Switchboards> | string>,
    switchboard_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Revisions>, Record<string, never>, Scalars['uuid'] | string>,
    up_trans_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Revisions>, Record<string, never>, Scalars['uuid'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Revisions>, Record<string, never>, Scalars['timestamptz'] | string>,
    uphole_y_tool?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Revisions>, Record<string, never>, WithTypename<Y_Tools> | string>,
    uphole_y_tool_bypass_tubing_order?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Revisions>, Record<string, never>, Array<Scalars['uuid'] | string>>,
    uphole_y_tool_equipment_tubing_order?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Revisions>, Record<string, never>, Array<Scalars['uuid'] | string>>,
    uphole_y_tool_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Revisions>, Record<string, never>, Scalars['uuid'] | string>,
    use_downhole_y_tool?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Revisions>, Record<string, never>, Scalars['Boolean'] | string>,
    use_uphole_y_tool?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Revisions>, Record<string, never>, Scalars['Boolean'] | string>,
    use_vsd?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Revisions>, Record<string, never>, Scalars['Boolean'] | string>,
    user?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Revisions>, Record<string, never>, WithTypename<Users> | string>,
    variable_speed_drive?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Revisions>, Record<string, never>, WithTypename<Variable_Speed_Drives> | string>,
    vsd_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Revisions>, Record<string, never>, Scalars['uuid'] | string>
  },
  revisions_scenario_equipment_revisions_aggregate?: {
    aggregate?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Revisions_Aggregate>, Record<string, never>, WithTypename<Revisions_Scenario_Equipment_Revisions_Aggregate_Fields> | string>,
    nodes?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Revisions_Aggregate>, Record<string, never>, Array<WithTypename<Revisions_Scenario_Equipment_Revisions> | string>>
  },
  revisions_scenario_equipment_revisions_aggregate_fields?: {
    count?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Revisions_Aggregate_Fields>, Revisions_Scenario_Equipment_Revisions_Aggregate_FieldsCountArgs, Scalars['Int'] | string>,
    max?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Revisions_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Scenario_Equipment_Revisions_Max_Fields> | string>,
    min?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Revisions_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Scenario_Equipment_Revisions_Min_Fields> | string>
  },
  revisions_scenario_equipment_revisions_max_fields?: {
    author_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Revisions_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    bolt_on_discharge_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Revisions_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    cables_order?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Revisions_Max_Fields>, Record<string, never>, Array<Scalars['uuid'] | string>>,
    cloned_from_journal_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Revisions_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Revisions_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Revisions_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    down_trans_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Revisions_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    downhole_y_tool_bypass_tubing_order?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Revisions_Max_Fields>, Record<string, never>, Array<Scalars['uuid'] | string>>,
    downhole_y_tool_equipment_tubing_order?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Revisions_Max_Fields>, Record<string, never>, Array<Scalars['uuid'] | string>>,
    downhole_y_tool_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Revisions_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Revisions_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    intakes_order?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Revisions_Max_Fields>, Record<string, never>, Array<Scalars['uuid'] | string>>,
    journal_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Revisions_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    lower_bolt_on_discharge_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Revisions_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    lower_cables_order?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Revisions_Max_Fields>, Record<string, never>, Array<Scalars['uuid'] | string>>,
    lower_intakes_order?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Revisions_Max_Fields>, Record<string, never>, Array<Scalars['uuid'] | string>>,
    lower_mle_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Revisions_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    lower_motor_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Revisions_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    lower_pumps_order?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Revisions_Max_Fields>, Record<string, never>, Array<Scalars['uuid'] | string>>,
    lower_seal_motor_oil_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Revisions_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    lower_seals_order?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Revisions_Max_Fields>, Record<string, never>, Array<Scalars['uuid'] | string>>,
    lower_sensor_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Revisions_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    lower_shroud_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Revisions_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    mle_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Revisions_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    motor_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Revisions_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    parent_revision_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Revisions_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    pumps_order?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Revisions_Max_Fields>, Record<string, never>, Array<Scalars['uuid'] | string>>,
    seal_motor_oil_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Revisions_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    seals_order?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Revisions_Max_Fields>, Record<string, never>, Array<Scalars['uuid'] | string>>,
    sensor_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Revisions_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    shroud_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Revisions_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    switchboard_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Revisions_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    up_trans_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Revisions_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Revisions_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    uphole_y_tool_bypass_tubing_order?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Revisions_Max_Fields>, Record<string, never>, Array<Scalars['uuid'] | string>>,
    uphole_y_tool_equipment_tubing_order?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Revisions_Max_Fields>, Record<string, never>, Array<Scalars['uuid'] | string>>,
    uphole_y_tool_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Revisions_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    vsd_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Revisions_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>
  },
  revisions_scenario_equipment_revisions_min_fields?: {
    author_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Revisions_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    bolt_on_discharge_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Revisions_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    cables_order?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Revisions_Min_Fields>, Record<string, never>, Array<Scalars['uuid'] | string>>,
    cloned_from_journal_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Revisions_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Revisions_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Revisions_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    down_trans_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Revisions_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    downhole_y_tool_bypass_tubing_order?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Revisions_Min_Fields>, Record<string, never>, Array<Scalars['uuid'] | string>>,
    downhole_y_tool_equipment_tubing_order?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Revisions_Min_Fields>, Record<string, never>, Array<Scalars['uuid'] | string>>,
    downhole_y_tool_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Revisions_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Revisions_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    intakes_order?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Revisions_Min_Fields>, Record<string, never>, Array<Scalars['uuid'] | string>>,
    journal_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Revisions_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    lower_bolt_on_discharge_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Revisions_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    lower_cables_order?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Revisions_Min_Fields>, Record<string, never>, Array<Scalars['uuid'] | string>>,
    lower_intakes_order?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Revisions_Min_Fields>, Record<string, never>, Array<Scalars['uuid'] | string>>,
    lower_mle_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Revisions_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    lower_motor_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Revisions_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    lower_pumps_order?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Revisions_Min_Fields>, Record<string, never>, Array<Scalars['uuid'] | string>>,
    lower_seal_motor_oil_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Revisions_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    lower_seals_order?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Revisions_Min_Fields>, Record<string, never>, Array<Scalars['uuid'] | string>>,
    lower_sensor_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Revisions_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    lower_shroud_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Revisions_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    mle_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Revisions_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    motor_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Revisions_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    parent_revision_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Revisions_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    pumps_order?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Revisions_Min_Fields>, Record<string, never>, Array<Scalars['uuid'] | string>>,
    seal_motor_oil_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Revisions_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    seals_order?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Revisions_Min_Fields>, Record<string, never>, Array<Scalars['uuid'] | string>>,
    sensor_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Revisions_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    shroud_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Revisions_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    switchboard_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Revisions_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    up_trans_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Revisions_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Revisions_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    uphole_y_tool_bypass_tubing_order?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Revisions_Min_Fields>, Record<string, never>, Array<Scalars['uuid'] | string>>,
    uphole_y_tool_equipment_tubing_order?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Revisions_Min_Fields>, Record<string, never>, Array<Scalars['uuid'] | string>>,
    uphole_y_tool_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Revisions_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    vsd_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Revisions_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>
  },
  revisions_scenario_equipment_revisions_mutation_response?: {
    affected_rows?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Revisions_Mutation_Response>, Record<string, never>, Scalars['Int'] | string>,
    returning?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Revisions_Mutation_Response>, Record<string, never>, Array<WithTypename<Revisions_Scenario_Equipment_Revisions> | string>>
  },
  revisions_scenario_equipment_xref_cables_journal?: {
    author_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Journal>, Record<string, never>, Scalars['String'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Journal>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Journal>, Record<string, never>, Scalars['timestamptz'] | string>,
    id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Journal>, Record<string, never>, Scalars['uuid'] | string>,
    parent_journal_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Journal>, Record<string, never>, Scalars['uuid'] | string>,
    scenario_equipment_xref_cables_journal?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Journal>, Record<string, never>, WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Journal> | string>,
    scenario_equipment_xref_cables_journals?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Journal>, Revisions_Scenario_Equipment_Xref_Cables_JournalScenario_Equipment_Xref_Cables_JournalsArgs, Array<WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Journal> | string>>,
    scenario_equipment_xref_cables_journals_aggregate?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Journal>, Revisions_Scenario_Equipment_Xref_Cables_JournalScenario_Equipment_Xref_Cables_Journals_AggregateArgs, WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Journal_Aggregate> | string>,
    scenario_equipment_xref_cables_revision?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Journal>, Record<string, never>, WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Revisions> | string>,
    scenario_equipment_xref_cables_revisions?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Journal>, Revisions_Scenario_Equipment_Xref_Cables_JournalScenario_Equipment_Xref_Cables_RevisionsArgs, Array<WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Revisions> | string>>,
    scenario_equipment_xref_cables_revisions_aggregate?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Journal>, Revisions_Scenario_Equipment_Xref_Cables_JournalScenario_Equipment_Xref_Cables_Revisions_AggregateArgs, WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Aggregate> | string>,
    updated_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Journal>, Record<string, never>, Scalars['timestamptz'] | string>,
    user?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Journal>, Record<string, never>, WithTypename<Users> | string>,
    winning_revision_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Journal>, Record<string, never>, Scalars['uuid'] | string>
  },
  revisions_scenario_equipment_xref_cables_journal_aggregate?: {
    aggregate?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Journal_Aggregate>, Record<string, never>, WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Journal_Aggregate_Fields> | string>,
    nodes?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Journal_Aggregate>, Record<string, never>, Array<WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Journal> | string>>
  },
  revisions_scenario_equipment_xref_cables_journal_aggregate_fields?: {
    count?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Journal_Aggregate_Fields>, Revisions_Scenario_Equipment_Xref_Cables_Journal_Aggregate_FieldsCountArgs, Scalars['Int'] | string>,
    max?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Journal_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Journal_Max_Fields> | string>,
    min?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Journal_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Journal_Min_Fields> | string>
  },
  revisions_scenario_equipment_xref_cables_journal_max_fields?: {
    author_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Journal_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Journal_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Journal_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Journal_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    parent_journal_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Journal_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Journal_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    winning_revision_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Journal_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>
  },
  revisions_scenario_equipment_xref_cables_journal_min_fields?: {
    author_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Journal_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Journal_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Journal_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Journal_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    parent_journal_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Journal_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Journal_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    winning_revision_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Journal_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>
  },
  revisions_scenario_equipment_xref_cables_journal_mutation_response?: {
    affected_rows?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Journal_Mutation_Response>, Record<string, never>, Scalars['Int'] | string>,
    returning?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Journal_Mutation_Response>, Record<string, never>, Array<WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Journal> | string>>
  },
  revisions_scenario_equipment_xref_cables_revisions?: {
    author_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Revisions>, Record<string, never>, Scalars['String'] | string>,
    cable?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Revisions>, Record<string, never>, WithTypename<Cables> | string>,
    cable_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Revisions>, Record<string, never>, Scalars['uuid'] | string>,
    cloned_from_journal_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Revisions>, Record<string, never>, Scalars['uuid'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Revisions>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Revisions>, Record<string, never>, Scalars['timestamptz'] | string>,
    id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Revisions>, Record<string, never>, Scalars['uuid'] | string>,
    journal_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Revisions>, Record<string, never>, Scalars['uuid'] | string>,
    length_feet?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Revisions>, Record<string, never>, Scalars['numeric'] | string>,
    parent_revision_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Revisions>, Record<string, never>, Scalars['uuid'] | string>,
    scenario_equipment_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Revisions>, Record<string, never>, Scalars['uuid'] | string>,
    scenario_equipment_journal?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Revisions>, Record<string, never>, WithTypename<Revisions_Scenario_Equipment_Journal> | string>,
    scenario_equipment_xref_cables_journal?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Revisions>, Record<string, never>, WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Journal> | string>,
    scenario_equipment_xref_cables_journals?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Revisions>, Revisions_Scenario_Equipment_Xref_Cables_RevisionsScenario_Equipment_Xref_Cables_JournalsArgs, Array<WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Journal> | string>>,
    scenario_equipment_xref_cables_journals_aggregate?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Revisions>, Revisions_Scenario_Equipment_Xref_Cables_RevisionsScenario_Equipment_Xref_Cables_Journals_AggregateArgs, WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Journal_Aggregate> | string>,
    scenario_equipment_xref_cables_revision?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Revisions>, Record<string, never>, WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Revisions> | string>,
    scenario_equipment_xref_cables_revisions?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Revisions>, Revisions_Scenario_Equipment_Xref_Cables_RevisionsScenario_Equipment_Xref_Cables_RevisionsArgs, Array<WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Revisions> | string>>,
    scenario_equipment_xref_cables_revisions_aggregate?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Revisions>, Revisions_Scenario_Equipment_Xref_Cables_RevisionsScenario_Equipment_Xref_Cables_Revisions_AggregateArgs, WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Aggregate> | string>,
    scenario_equipment_xref_cables_view?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Revisions>, Record<string, never>, WithTypename<Scenario_Equipment_Xref_Cables> | string>,
    updated_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Revisions>, Record<string, never>, Scalars['timestamptz'] | string>,
    user?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Revisions>, Record<string, never>, WithTypename<Users> | string>
  },
  revisions_scenario_equipment_xref_cables_revisions_aggregate?: {
    aggregate?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Aggregate>, Record<string, never>, WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Aggregate_Fields> | string>,
    nodes?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Aggregate>, Record<string, never>, Array<WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Revisions> | string>>
  },
  revisions_scenario_equipment_xref_cables_revisions_aggregate_fields?: {
    avg?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Avg_Fields> | string>,
    count?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Aggregate_Fields>, Revisions_Scenario_Equipment_Xref_Cables_Revisions_Aggregate_FieldsCountArgs, Scalars['Int'] | string>,
    max?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Max_Fields> | string>,
    min?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Min_Fields> | string>,
    stddev?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Stddev_Fields> | string>,
    stddev_pop?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Stddev_Pop_Fields> | string>,
    stddev_samp?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Stddev_Samp_Fields> | string>,
    sum?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Sum_Fields> | string>,
    var_pop?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Var_Pop_Fields> | string>,
    var_samp?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Var_Samp_Fields> | string>,
    variance?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Variance_Fields> | string>
  },
  revisions_scenario_equipment_xref_cables_revisions_avg_fields?: {
    length_feet?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  revisions_scenario_equipment_xref_cables_revisions_max_fields?: {
    author_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    cable_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    cloned_from_journal_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    journal_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    length_feet?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    parent_revision_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    scenario_equipment_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>
  },
  revisions_scenario_equipment_xref_cables_revisions_min_fields?: {
    author_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    cable_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    cloned_from_journal_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    journal_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    length_feet?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    parent_revision_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    scenario_equipment_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>
  },
  revisions_scenario_equipment_xref_cables_revisions_mutation_response?: {
    affected_rows?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Mutation_Response>, Record<string, never>, Scalars['Int'] | string>,
    returning?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Mutation_Response>, Record<string, never>, Array<WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Revisions> | string>>
  },
  revisions_scenario_equipment_xref_cables_revisions_stddev_fields?: {
    length_feet?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  revisions_scenario_equipment_xref_cables_revisions_stddev_pop_fields?: {
    length_feet?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  revisions_scenario_equipment_xref_cables_revisions_stddev_samp_fields?: {
    length_feet?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  revisions_scenario_equipment_xref_cables_revisions_sum_fields?: {
    length_feet?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>
  },
  revisions_scenario_equipment_xref_cables_revisions_var_pop_fields?: {
    length_feet?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  revisions_scenario_equipment_xref_cables_revisions_var_samp_fields?: {
    length_feet?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  revisions_scenario_equipment_xref_cables_revisions_variance_fields?: {
    length_feet?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  revisions_scenario_equipment_xref_housings_journal?: {
    author_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Journal>, Record<string, never>, Scalars['String'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Journal>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Journal>, Record<string, never>, Scalars['timestamptz'] | string>,
    id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Journal>, Record<string, never>, Scalars['uuid'] | string>,
    parent_journal_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Journal>, Record<string, never>, Scalars['uuid'] | string>,
    scenario_equipment_xref_housings_journal?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Journal>, Record<string, never>, WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Journal> | string>,
    scenario_equipment_xref_housings_journals?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Journal>, Revisions_Scenario_Equipment_Xref_Housings_JournalScenario_Equipment_Xref_Housings_JournalsArgs, Array<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Journal> | string>>,
    scenario_equipment_xref_housings_journals_aggregate?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Journal>, Revisions_Scenario_Equipment_Xref_Housings_JournalScenario_Equipment_Xref_Housings_Journals_AggregateArgs, WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Journal_Aggregate> | string>,
    scenario_equipment_xref_housings_revision?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Journal>, Record<string, never>, WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Revisions> | string>,
    scenario_equipment_xref_housings_revisions?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Journal>, Revisions_Scenario_Equipment_Xref_Housings_JournalScenario_Equipment_Xref_Housings_RevisionsArgs, Array<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Revisions> | string>>,
    scenario_equipment_xref_housings_revisions_aggregate?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Journal>, Revisions_Scenario_Equipment_Xref_Housings_JournalScenario_Equipment_Xref_Housings_Revisions_AggregateArgs, WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Aggregate> | string>,
    updated_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Journal>, Record<string, never>, Scalars['timestamptz'] | string>,
    user?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Journal>, Record<string, never>, WithTypename<Users> | string>,
    winning_revision_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Journal>, Record<string, never>, Scalars['uuid'] | string>
  },
  revisions_scenario_equipment_xref_housings_journal_aggregate?: {
    aggregate?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Journal_Aggregate>, Record<string, never>, WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Journal_Aggregate_Fields> | string>,
    nodes?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Journal_Aggregate>, Record<string, never>, Array<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Journal> | string>>
  },
  revisions_scenario_equipment_xref_housings_journal_aggregate_fields?: {
    count?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Journal_Aggregate_Fields>, Revisions_Scenario_Equipment_Xref_Housings_Journal_Aggregate_FieldsCountArgs, Scalars['Int'] | string>,
    max?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Journal_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Journal_Max_Fields> | string>,
    min?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Journal_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Journal_Min_Fields> | string>
  },
  revisions_scenario_equipment_xref_housings_journal_max_fields?: {
    author_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Journal_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Journal_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Journal_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Journal_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    parent_journal_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Journal_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Journal_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    winning_revision_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Journal_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>
  },
  revisions_scenario_equipment_xref_housings_journal_min_fields?: {
    author_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Journal_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Journal_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Journal_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Journal_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    parent_journal_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Journal_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Journal_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    winning_revision_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Journal_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>
  },
  revisions_scenario_equipment_xref_housings_journal_mutation_response?: {
    affected_rows?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Journal_Mutation_Response>, Record<string, never>, Scalars['Int'] | string>,
    returning?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Journal_Mutation_Response>, Record<string, never>, Array<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Journal> | string>>
  },
  revisions_scenario_equipment_xref_housings_revisions?: {
    author_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Revisions>, Record<string, never>, Scalars['String'] | string>,
    cloned_from_journal_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Revisions>, Record<string, never>, Scalars['uuid'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Revisions>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Revisions>, Record<string, never>, Scalars['timestamptz'] | string>,
    housing?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Revisions>, Record<string, never>, WithTypename<Housings> | string>,
    housing_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Revisions>, Record<string, never>, Scalars['uuid'] | string>,
    id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Revisions>, Record<string, never>, Scalars['uuid'] | string>,
    journal_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Revisions>, Record<string, never>, Scalars['uuid'] | string>,
    length_inches?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Revisions>, Record<string, never>, Scalars['numeric'] | string>,
    parent_revision_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Revisions>, Record<string, never>, Scalars['uuid'] | string>,
    scenario_equipment_xref_housings_journal?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Revisions>, Record<string, never>, WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Journal> | string>,
    scenario_equipment_xref_housings_journals?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Revisions>, Revisions_Scenario_Equipment_Xref_Housings_RevisionsScenario_Equipment_Xref_Housings_JournalsArgs, Array<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Journal> | string>>,
    scenario_equipment_xref_housings_journals_aggregate?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Revisions>, Revisions_Scenario_Equipment_Xref_Housings_RevisionsScenario_Equipment_Xref_Housings_Journals_AggregateArgs, WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Journal_Aggregate> | string>,
    scenario_equipment_xref_housings_revision?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Revisions>, Record<string, never>, WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Revisions> | string>,
    scenario_equipment_xref_housings_revisions?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Revisions>, Revisions_Scenario_Equipment_Xref_Housings_RevisionsScenario_Equipment_Xref_Housings_RevisionsArgs, Array<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Revisions> | string>>,
    scenario_equipment_xref_housings_revisions_aggregate?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Revisions>, Revisions_Scenario_Equipment_Xref_Housings_RevisionsScenario_Equipment_Xref_Housings_Revisions_AggregateArgs, WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Aggregate> | string>,
    scenario_equipment_xref_housings_view?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Revisions>, Record<string, never>, WithTypename<Scenario_Equipment_Xref_Housings> | string>,
    scenario_equipment_xref_pump_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Revisions>, Record<string, never>, Scalars['uuid'] | string>,
    scenario_equipment_xref_pumps_journal?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Revisions>, Record<string, never>, WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Journal> | string>,
    stage_count?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Revisions>, Record<string, never>, Scalars['Int'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Revisions>, Record<string, never>, Scalars['timestamptz'] | string>,
    user?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Revisions>, Record<string, never>, WithTypename<Users> | string>
  },
  revisions_scenario_equipment_xref_housings_revisions_aggregate?: {
    aggregate?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Aggregate>, Record<string, never>, WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Aggregate_Fields> | string>,
    nodes?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Aggregate>, Record<string, never>, Array<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Revisions> | string>>
  },
  revisions_scenario_equipment_xref_housings_revisions_aggregate_fields?: {
    avg?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Avg_Fields> | string>,
    count?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Aggregate_Fields>, Revisions_Scenario_Equipment_Xref_Housings_Revisions_Aggregate_FieldsCountArgs, Scalars['Int'] | string>,
    max?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Max_Fields> | string>,
    min?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Min_Fields> | string>,
    stddev?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Stddev_Fields> | string>,
    stddev_pop?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Stddev_Pop_Fields> | string>,
    stddev_samp?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Stddev_Samp_Fields> | string>,
    sum?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Sum_Fields> | string>,
    var_pop?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Var_Pop_Fields> | string>,
    var_samp?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Var_Samp_Fields> | string>,
    variance?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Variance_Fields> | string>
  },
  revisions_scenario_equipment_xref_housings_revisions_avg_fields?: {
    length_inches?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    stage_count?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  revisions_scenario_equipment_xref_housings_revisions_max_fields?: {
    author_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    cloned_from_journal_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    housing_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    journal_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    length_inches?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    parent_revision_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    scenario_equipment_xref_pump_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    stage_count?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Max_Fields>, Record<string, never>, Scalars['Int'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>
  },
  revisions_scenario_equipment_xref_housings_revisions_min_fields?: {
    author_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    cloned_from_journal_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    housing_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    journal_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    length_inches?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    parent_revision_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    scenario_equipment_xref_pump_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    stage_count?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Min_Fields>, Record<string, never>, Scalars['Int'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>
  },
  revisions_scenario_equipment_xref_housings_revisions_mutation_response?: {
    affected_rows?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Mutation_Response>, Record<string, never>, Scalars['Int'] | string>,
    returning?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Mutation_Response>, Record<string, never>, Array<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Revisions> | string>>
  },
  revisions_scenario_equipment_xref_housings_revisions_stddev_fields?: {
    length_inches?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    stage_count?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  revisions_scenario_equipment_xref_housings_revisions_stddev_pop_fields?: {
    length_inches?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    stage_count?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  revisions_scenario_equipment_xref_housings_revisions_stddev_samp_fields?: {
    length_inches?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    stage_count?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  revisions_scenario_equipment_xref_housings_revisions_sum_fields?: {
    length_inches?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    stage_count?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Sum_Fields>, Record<string, never>, Scalars['Int'] | string>
  },
  revisions_scenario_equipment_xref_housings_revisions_var_pop_fields?: {
    length_inches?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    stage_count?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  revisions_scenario_equipment_xref_housings_revisions_var_samp_fields?: {
    length_inches?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    stage_count?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  revisions_scenario_equipment_xref_housings_revisions_variance_fields?: {
    length_inches?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    stage_count?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  revisions_scenario_equipment_xref_intakes_journal?: {
    author_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Journal>, Record<string, never>, Scalars['String'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Journal>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Journal>, Record<string, never>, Scalars['timestamptz'] | string>,
    id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Journal>, Record<string, never>, Scalars['uuid'] | string>,
    parent_journal_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Journal>, Record<string, never>, Scalars['uuid'] | string>,
    scenario_equipment_xref_intakes_journal?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Journal>, Record<string, never>, WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Journal> | string>,
    scenario_equipment_xref_intakes_journals?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Journal>, Revisions_Scenario_Equipment_Xref_Intakes_JournalScenario_Equipment_Xref_Intakes_JournalsArgs, Array<WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Journal> | string>>,
    scenario_equipment_xref_intakes_journals_aggregate?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Journal>, Revisions_Scenario_Equipment_Xref_Intakes_JournalScenario_Equipment_Xref_Intakes_Journals_AggregateArgs, WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Journal_Aggregate> | string>,
    scenario_equipment_xref_intakes_revision?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Journal>, Record<string, never>, WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Revisions> | string>,
    scenario_equipment_xref_intakes_revisions?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Journal>, Revisions_Scenario_Equipment_Xref_Intakes_JournalScenario_Equipment_Xref_Intakes_RevisionsArgs, Array<WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Revisions> | string>>,
    scenario_equipment_xref_intakes_revisions_aggregate?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Journal>, Revisions_Scenario_Equipment_Xref_Intakes_JournalScenario_Equipment_Xref_Intakes_Revisions_AggregateArgs, WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Aggregate> | string>,
    updated_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Journal>, Record<string, never>, Scalars['timestamptz'] | string>,
    user?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Journal>, Record<string, never>, WithTypename<Users> | string>,
    winning_revision_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Journal>, Record<string, never>, Scalars['uuid'] | string>
  },
  revisions_scenario_equipment_xref_intakes_journal_aggregate?: {
    aggregate?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Journal_Aggregate>, Record<string, never>, WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Journal_Aggregate_Fields> | string>,
    nodes?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Journal_Aggregate>, Record<string, never>, Array<WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Journal> | string>>
  },
  revisions_scenario_equipment_xref_intakes_journal_aggregate_fields?: {
    count?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Journal_Aggregate_Fields>, Revisions_Scenario_Equipment_Xref_Intakes_Journal_Aggregate_FieldsCountArgs, Scalars['Int'] | string>,
    max?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Journal_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Journal_Max_Fields> | string>,
    min?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Journal_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Journal_Min_Fields> | string>
  },
  revisions_scenario_equipment_xref_intakes_journal_max_fields?: {
    author_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Journal_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Journal_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Journal_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Journal_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    parent_journal_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Journal_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Journal_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    winning_revision_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Journal_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>
  },
  revisions_scenario_equipment_xref_intakes_journal_min_fields?: {
    author_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Journal_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Journal_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Journal_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Journal_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    parent_journal_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Journal_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Journal_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    winning_revision_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Journal_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>
  },
  revisions_scenario_equipment_xref_intakes_journal_mutation_response?: {
    affected_rows?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Journal_Mutation_Response>, Record<string, never>, Scalars['Int'] | string>,
    returning?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Journal_Mutation_Response>, Record<string, never>, Array<WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Journal> | string>>
  },
  revisions_scenario_equipment_xref_intakes_revisions?: {
    author_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Revisions>, Record<string, never>, Scalars['String'] | string>,
    cloned_from_journal_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Revisions>, Record<string, never>, Scalars['uuid'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Revisions>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Revisions>, Record<string, never>, Scalars['timestamptz'] | string>,
    id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Revisions>, Record<string, never>, Scalars['uuid'] | string>,
    intake?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Revisions>, Record<string, never>, WithTypename<Intakes> | string>,
    intake_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Revisions>, Record<string, never>, Scalars['uuid'] | string>,
    journal_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Revisions>, Record<string, never>, Scalars['uuid'] | string>,
    parent_revision_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Revisions>, Record<string, never>, Scalars['uuid'] | string>,
    scenario_equipment_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Revisions>, Record<string, never>, Scalars['uuid'] | string>,
    scenario_equipment_journal?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Revisions>, Record<string, never>, WithTypename<Revisions_Scenario_Equipment_Journal> | string>,
    scenario_equipment_xref_intakes_journal?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Revisions>, Record<string, never>, WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Journal> | string>,
    scenario_equipment_xref_intakes_journals?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Revisions>, Revisions_Scenario_Equipment_Xref_Intakes_RevisionsScenario_Equipment_Xref_Intakes_JournalsArgs, Array<WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Journal> | string>>,
    scenario_equipment_xref_intakes_journals_aggregate?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Revisions>, Revisions_Scenario_Equipment_Xref_Intakes_RevisionsScenario_Equipment_Xref_Intakes_Journals_AggregateArgs, WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Journal_Aggregate> | string>,
    scenario_equipment_xref_intakes_revision?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Revisions>, Record<string, never>, WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Revisions> | string>,
    scenario_equipment_xref_intakes_revisions?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Revisions>, Revisions_Scenario_Equipment_Xref_Intakes_RevisionsScenario_Equipment_Xref_Intakes_RevisionsArgs, Array<WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Revisions> | string>>,
    scenario_equipment_xref_intakes_revisions_aggregate?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Revisions>, Revisions_Scenario_Equipment_Xref_Intakes_RevisionsScenario_Equipment_Xref_Intakes_Revisions_AggregateArgs, WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Aggregate> | string>,
    scenario_equipment_xref_intakes_view?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Revisions>, Record<string, never>, WithTypename<Scenario_Equipment_Xref_Intakes> | string>,
    updated_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Revisions>, Record<string, never>, Scalars['timestamptz'] | string>,
    use_high_strength_shaft?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Revisions>, Record<string, never>, Scalars['Boolean'] | string>,
    user?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Revisions>, Record<string, never>, WithTypename<Users> | string>
  },
  revisions_scenario_equipment_xref_intakes_revisions_aggregate?: {
    aggregate?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Aggregate>, Record<string, never>, WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Aggregate_Fields> | string>,
    nodes?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Aggregate>, Record<string, never>, Array<WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Revisions> | string>>
  },
  revisions_scenario_equipment_xref_intakes_revisions_aggregate_fields?: {
    count?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Aggregate_Fields>, Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Aggregate_FieldsCountArgs, Scalars['Int'] | string>,
    max?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Max_Fields> | string>,
    min?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Min_Fields> | string>
  },
  revisions_scenario_equipment_xref_intakes_revisions_max_fields?: {
    author_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    cloned_from_journal_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    intake_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    journal_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    parent_revision_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    scenario_equipment_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>
  },
  revisions_scenario_equipment_xref_intakes_revisions_min_fields?: {
    author_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    cloned_from_journal_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    intake_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    journal_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    parent_revision_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    scenario_equipment_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>
  },
  revisions_scenario_equipment_xref_intakes_revisions_mutation_response?: {
    affected_rows?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Mutation_Response>, Record<string, never>, Scalars['Int'] | string>,
    returning?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Mutation_Response>, Record<string, never>, Array<WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Revisions> | string>>
  },
  revisions_scenario_equipment_xref_pumps_journal?: {
    author_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Journal>, Record<string, never>, Scalars['String'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Journal>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Journal>, Record<string, never>, Scalars['timestamptz'] | string>,
    id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Journal>, Record<string, never>, Scalars['uuid'] | string>,
    parent_journal_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Journal>, Record<string, never>, Scalars['uuid'] | string>,
    scenario_equipment_xref_housings_revisions?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Journal>, Revisions_Scenario_Equipment_Xref_Pumps_JournalScenario_Equipment_Xref_Housings_RevisionsArgs, Array<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Revisions> | string>>,
    scenario_equipment_xref_housings_revisions_aggregate?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Journal>, Revisions_Scenario_Equipment_Xref_Pumps_JournalScenario_Equipment_Xref_Housings_Revisions_AggregateArgs, WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Aggregate> | string>,
    scenario_equipment_xref_pumps_journal?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Journal>, Record<string, never>, WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Journal> | string>,
    scenario_equipment_xref_pumps_journals?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Journal>, Revisions_Scenario_Equipment_Xref_Pumps_JournalScenario_Equipment_Xref_Pumps_JournalsArgs, Array<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Journal> | string>>,
    scenario_equipment_xref_pumps_journals_aggregate?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Journal>, Revisions_Scenario_Equipment_Xref_Pumps_JournalScenario_Equipment_Xref_Pumps_Journals_AggregateArgs, WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Journal_Aggregate> | string>,
    scenario_equipment_xref_pumps_revision?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Journal>, Record<string, never>, WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions> | string>,
    scenario_equipment_xref_pumps_revisions?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Journal>, Revisions_Scenario_Equipment_Xref_Pumps_JournalScenario_Equipment_Xref_Pumps_RevisionsArgs, Array<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions> | string>>,
    scenario_equipment_xref_pumps_revisions_aggregate?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Journal>, Revisions_Scenario_Equipment_Xref_Pumps_JournalScenario_Equipment_Xref_Pumps_Revisions_AggregateArgs, WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Aggregate> | string>,
    updated_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Journal>, Record<string, never>, Scalars['timestamptz'] | string>,
    user?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Journal>, Record<string, never>, WithTypename<Users> | string>,
    winning_revision_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Journal>, Record<string, never>, Scalars['uuid'] | string>
  },
  revisions_scenario_equipment_xref_pumps_journal_aggregate?: {
    aggregate?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Journal_Aggregate>, Record<string, never>, WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Journal_Aggregate_Fields> | string>,
    nodes?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Journal_Aggregate>, Record<string, never>, Array<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Journal> | string>>
  },
  revisions_scenario_equipment_xref_pumps_journal_aggregate_fields?: {
    count?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Journal_Aggregate_Fields>, Revisions_Scenario_Equipment_Xref_Pumps_Journal_Aggregate_FieldsCountArgs, Scalars['Int'] | string>,
    max?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Journal_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Journal_Max_Fields> | string>,
    min?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Journal_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Journal_Min_Fields> | string>
  },
  revisions_scenario_equipment_xref_pumps_journal_max_fields?: {
    author_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Journal_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Journal_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Journal_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Journal_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    parent_journal_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Journal_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Journal_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    winning_revision_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Journal_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>
  },
  revisions_scenario_equipment_xref_pumps_journal_min_fields?: {
    author_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Journal_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Journal_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Journal_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Journal_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    parent_journal_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Journal_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Journal_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    winning_revision_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Journal_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>
  },
  revisions_scenario_equipment_xref_pumps_journal_mutation_response?: {
    affected_rows?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Journal_Mutation_Response>, Record<string, never>, Scalars['Int'] | string>,
    returning?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Journal_Mutation_Response>, Record<string, never>, Array<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Journal> | string>>
  },
  revisions_scenario_equipment_xref_pumps_revisions?: {
    author_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions>, Record<string, never>, Scalars['String'] | string>,
    brake_horsepower_correction_ratio?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions>, Record<string, never>, Scalars['numeric'] | string>,
    cloned_from_journal_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions>, Record<string, never>, Scalars['uuid'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions>, Record<string, never>, Scalars['timestamptz'] | string>,
    head_correction_ratio?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions>, Record<string, never>, Scalars['numeric'] | string>,
    housings_order?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions>, Record<string, never>, Array<Scalars['uuid'] | string>>,
    id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions>, Record<string, never>, Scalars['uuid'] | string>,
    journal_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions>, Record<string, never>, Scalars['uuid'] | string>,
    length_feet?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions>, Record<string, never>, Scalars['numeric'] | string>,
    parent_revision_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions>, Record<string, never>, Scalars['uuid'] | string>,
    pump?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions>, Record<string, never>, WithTypename<Pumps> | string>,
    pump_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions>, Record<string, never>, Scalars['uuid'] | string>,
    rate_correction_ratio?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions>, Record<string, never>, Scalars['numeric'] | string>,
    scenario_equipment_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions>, Record<string, never>, Scalars['uuid'] | string>,
    scenario_equipment_journal?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions>, Record<string, never>, WithTypename<Revisions_Scenario_Equipment_Journal> | string>,
    scenario_equipment_xref_pumps_journal?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions>, Record<string, never>, WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Journal> | string>,
    scenario_equipment_xref_pumps_journals?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions>, Revisions_Scenario_Equipment_Xref_Pumps_RevisionsScenario_Equipment_Xref_Pumps_JournalsArgs, Array<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Journal> | string>>,
    scenario_equipment_xref_pumps_journals_aggregate?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions>, Revisions_Scenario_Equipment_Xref_Pumps_RevisionsScenario_Equipment_Xref_Pumps_Journals_AggregateArgs, WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Journal_Aggregate> | string>,
    scenario_equipment_xref_pumps_revision?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions>, Record<string, never>, WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions> | string>,
    scenario_equipment_xref_pumps_revisions?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions>, Revisions_Scenario_Equipment_Xref_Pumps_RevisionsScenario_Equipment_Xref_Pumps_RevisionsArgs, Array<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions> | string>>,
    scenario_equipment_xref_pumps_revisions_aggregate?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions>, Revisions_Scenario_Equipment_Xref_Pumps_RevisionsScenario_Equipment_Xref_Pumps_Revisions_AggregateArgs, WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Aggregate> | string>,
    scenario_equipment_xref_pumps_view?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions>, Record<string, never>, WithTypename<Scenario_Equipment_Xref_Pumps> | string>,
    total_stages?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions>, Record<string, never>, Scalars['Int'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions>, Record<string, never>, Scalars['timestamptz'] | string>,
    use_high_strength_shaft?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions>, Record<string, never>, Scalars['Boolean'] | string>,
    user?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions>, Record<string, never>, WithTypename<Users> | string>,
    weight_pounds?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions>, Record<string, never>, Scalars['numeric'] | string>
  },
  revisions_scenario_equipment_xref_pumps_revisions_aggregate?: {
    aggregate?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Aggregate>, Record<string, never>, WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Aggregate_Fields> | string>,
    nodes?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Aggregate>, Record<string, never>, Array<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions> | string>>
  },
  revisions_scenario_equipment_xref_pumps_revisions_aggregate_fields?: {
    avg?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Avg_Fields> | string>,
    count?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Aggregate_Fields>, Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Aggregate_FieldsCountArgs, Scalars['Int'] | string>,
    max?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Max_Fields> | string>,
    min?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Min_Fields> | string>,
    stddev?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Stddev_Fields> | string>,
    stddev_pop?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Stddev_Pop_Fields> | string>,
    stddev_samp?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Stddev_Samp_Fields> | string>,
    sum?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Sum_Fields> | string>,
    var_pop?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Var_Pop_Fields> | string>,
    var_samp?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Var_Samp_Fields> | string>,
    variance?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Variance_Fields> | string>
  },
  revisions_scenario_equipment_xref_pumps_revisions_avg_fields?: {
    brake_horsepower_correction_ratio?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    head_correction_ratio?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    length_feet?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    rate_correction_ratio?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    total_stages?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    weight_pounds?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  revisions_scenario_equipment_xref_pumps_revisions_max_fields?: {
    author_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    brake_horsepower_correction_ratio?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    cloned_from_journal_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    head_correction_ratio?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    housings_order?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Max_Fields>, Record<string, never>, Array<Scalars['uuid'] | string>>,
    id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    journal_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    length_feet?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    parent_revision_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    pump_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    rate_correction_ratio?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    scenario_equipment_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    total_stages?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Max_Fields>, Record<string, never>, Scalars['Int'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    weight_pounds?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>
  },
  revisions_scenario_equipment_xref_pumps_revisions_min_fields?: {
    author_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    brake_horsepower_correction_ratio?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    cloned_from_journal_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    head_correction_ratio?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    housings_order?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Min_Fields>, Record<string, never>, Array<Scalars['uuid'] | string>>,
    id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    journal_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    length_feet?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    parent_revision_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    pump_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    rate_correction_ratio?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    scenario_equipment_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    total_stages?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Min_Fields>, Record<string, never>, Scalars['Int'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    weight_pounds?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>
  },
  revisions_scenario_equipment_xref_pumps_revisions_mutation_response?: {
    affected_rows?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Mutation_Response>, Record<string, never>, Scalars['Int'] | string>,
    returning?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Mutation_Response>, Record<string, never>, Array<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions> | string>>
  },
  revisions_scenario_equipment_xref_pumps_revisions_stddev_fields?: {
    brake_horsepower_correction_ratio?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    head_correction_ratio?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    length_feet?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    rate_correction_ratio?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    total_stages?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    weight_pounds?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  revisions_scenario_equipment_xref_pumps_revisions_stddev_pop_fields?: {
    brake_horsepower_correction_ratio?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    head_correction_ratio?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    length_feet?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    rate_correction_ratio?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    total_stages?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    weight_pounds?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  revisions_scenario_equipment_xref_pumps_revisions_stddev_samp_fields?: {
    brake_horsepower_correction_ratio?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    head_correction_ratio?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    length_feet?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    rate_correction_ratio?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    total_stages?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    weight_pounds?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  revisions_scenario_equipment_xref_pumps_revisions_sum_fields?: {
    brake_horsepower_correction_ratio?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    head_correction_ratio?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    length_feet?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    rate_correction_ratio?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    total_stages?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Sum_Fields>, Record<string, never>, Scalars['Int'] | string>,
    weight_pounds?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>
  },
  revisions_scenario_equipment_xref_pumps_revisions_var_pop_fields?: {
    brake_horsepower_correction_ratio?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    head_correction_ratio?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    length_feet?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    rate_correction_ratio?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    total_stages?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    weight_pounds?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  revisions_scenario_equipment_xref_pumps_revisions_var_samp_fields?: {
    brake_horsepower_correction_ratio?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    head_correction_ratio?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    length_feet?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    rate_correction_ratio?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    total_stages?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    weight_pounds?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  revisions_scenario_equipment_xref_pumps_revisions_variance_fields?: {
    brake_horsepower_correction_ratio?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    head_correction_ratio?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    length_feet?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    rate_correction_ratio?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    total_stages?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    weight_pounds?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  revisions_scenario_equipment_xref_seals_journal?: {
    author_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Journal>, Record<string, never>, Scalars['String'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Journal>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Journal>, Record<string, never>, Scalars['timestamptz'] | string>,
    id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Journal>, Record<string, never>, Scalars['uuid'] | string>,
    parent_journal_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Journal>, Record<string, never>, Scalars['uuid'] | string>,
    scenario_equipment_xref_seals_journal?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Journal>, Record<string, never>, WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Journal> | string>,
    scenario_equipment_xref_seals_journals?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Journal>, Revisions_Scenario_Equipment_Xref_Seals_JournalScenario_Equipment_Xref_Seals_JournalsArgs, Array<WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Journal> | string>>,
    scenario_equipment_xref_seals_journals_aggregate?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Journal>, Revisions_Scenario_Equipment_Xref_Seals_JournalScenario_Equipment_Xref_Seals_Journals_AggregateArgs, WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Journal_Aggregate> | string>,
    scenario_equipment_xref_seals_revision?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Journal>, Record<string, never>, WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Revisions> | string>,
    scenario_equipment_xref_seals_revisions?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Journal>, Revisions_Scenario_Equipment_Xref_Seals_JournalScenario_Equipment_Xref_Seals_RevisionsArgs, Array<WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Revisions> | string>>,
    scenario_equipment_xref_seals_revisions_aggregate?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Journal>, Revisions_Scenario_Equipment_Xref_Seals_JournalScenario_Equipment_Xref_Seals_Revisions_AggregateArgs, WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Revisions_Aggregate> | string>,
    updated_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Journal>, Record<string, never>, Scalars['timestamptz'] | string>,
    user?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Journal>, Record<string, never>, WithTypename<Users> | string>,
    winning_revision_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Journal>, Record<string, never>, Scalars['uuid'] | string>
  },
  revisions_scenario_equipment_xref_seals_journal_aggregate?: {
    aggregate?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Journal_Aggregate>, Record<string, never>, WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Journal_Aggregate_Fields> | string>,
    nodes?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Journal_Aggregate>, Record<string, never>, Array<WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Journal> | string>>
  },
  revisions_scenario_equipment_xref_seals_journal_aggregate_fields?: {
    count?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Journal_Aggregate_Fields>, Revisions_Scenario_Equipment_Xref_Seals_Journal_Aggregate_FieldsCountArgs, Scalars['Int'] | string>,
    max?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Journal_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Journal_Max_Fields> | string>,
    min?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Journal_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Journal_Min_Fields> | string>
  },
  revisions_scenario_equipment_xref_seals_journal_max_fields?: {
    author_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Journal_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Journal_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Journal_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Journal_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    parent_journal_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Journal_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Journal_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    winning_revision_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Journal_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>
  },
  revisions_scenario_equipment_xref_seals_journal_min_fields?: {
    author_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Journal_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Journal_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Journal_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Journal_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    parent_journal_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Journal_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Journal_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    winning_revision_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Journal_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>
  },
  revisions_scenario_equipment_xref_seals_journal_mutation_response?: {
    affected_rows?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Journal_Mutation_Response>, Record<string, never>, Scalars['Int'] | string>,
    returning?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Journal_Mutation_Response>, Record<string, never>, Array<WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Journal> | string>>
  },
  revisions_scenario_equipment_xref_seals_revisions?: {
    author_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Revisions>, Record<string, never>, Scalars['String'] | string>,
    cloned_from_journal_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Revisions>, Record<string, never>, Scalars['uuid'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Revisions>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Revisions>, Record<string, never>, Scalars['timestamptz'] | string>,
    id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Revisions>, Record<string, never>, Scalars['uuid'] | string>,
    journal_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Revisions>, Record<string, never>, Scalars['uuid'] | string>,
    parent_revision_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Revisions>, Record<string, never>, Scalars['uuid'] | string>,
    scenario_equipment_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Revisions>, Record<string, never>, Scalars['uuid'] | string>,
    scenario_equipment_journal?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Revisions>, Record<string, never>, WithTypename<Revisions_Scenario_Equipment_Journal> | string>,
    scenario_equipment_xref_seals_journal?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Revisions>, Record<string, never>, WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Journal> | string>,
    scenario_equipment_xref_seals_journals?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Revisions>, Revisions_Scenario_Equipment_Xref_Seals_RevisionsScenario_Equipment_Xref_Seals_JournalsArgs, Array<WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Journal> | string>>,
    scenario_equipment_xref_seals_journals_aggregate?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Revisions>, Revisions_Scenario_Equipment_Xref_Seals_RevisionsScenario_Equipment_Xref_Seals_Journals_AggregateArgs, WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Journal_Aggregate> | string>,
    scenario_equipment_xref_seals_revision?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Revisions>, Record<string, never>, WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Revisions> | string>,
    scenario_equipment_xref_seals_revisions?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Revisions>, Revisions_Scenario_Equipment_Xref_Seals_RevisionsScenario_Equipment_Xref_Seals_RevisionsArgs, Array<WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Revisions> | string>>,
    scenario_equipment_xref_seals_revisions_aggregate?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Revisions>, Revisions_Scenario_Equipment_Xref_Seals_RevisionsScenario_Equipment_Xref_Seals_Revisions_AggregateArgs, WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Revisions_Aggregate> | string>,
    scenario_equipment_xref_seals_view?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Revisions>, Record<string, never>, WithTypename<Scenario_Equipment_Xref_Seals> | string>,
    seal?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Revisions>, Record<string, never>, WithTypename<Seals> | string>,
    seal_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Revisions>, Record<string, never>, Scalars['uuid'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Revisions>, Record<string, never>, Scalars['timestamptz'] | string>,
    use_high_strength_shaft?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Revisions>, Record<string, never>, Scalars['Boolean'] | string>,
    user?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Revisions>, Record<string, never>, WithTypename<Users> | string>
  },
  revisions_scenario_equipment_xref_seals_revisions_aggregate?: {
    aggregate?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Revisions_Aggregate>, Record<string, never>, WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Revisions_Aggregate_Fields> | string>,
    nodes?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Revisions_Aggregate>, Record<string, never>, Array<WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Revisions> | string>>
  },
  revisions_scenario_equipment_xref_seals_revisions_aggregate_fields?: {
    count?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Revisions_Aggregate_Fields>, Revisions_Scenario_Equipment_Xref_Seals_Revisions_Aggregate_FieldsCountArgs, Scalars['Int'] | string>,
    max?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Revisions_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Revisions_Max_Fields> | string>,
    min?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Revisions_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Revisions_Min_Fields> | string>
  },
  revisions_scenario_equipment_xref_seals_revisions_max_fields?: {
    author_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Revisions_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    cloned_from_journal_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Revisions_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Revisions_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Revisions_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Revisions_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    journal_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Revisions_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    parent_revision_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Revisions_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    scenario_equipment_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Revisions_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    seal_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Revisions_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Revisions_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>
  },
  revisions_scenario_equipment_xref_seals_revisions_min_fields?: {
    author_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Revisions_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    cloned_from_journal_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Revisions_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Revisions_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Revisions_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Revisions_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    journal_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Revisions_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    parent_revision_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Revisions_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    scenario_equipment_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Revisions_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    seal_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Revisions_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Revisions_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>
  },
  revisions_scenario_equipment_xref_seals_revisions_mutation_response?: {
    affected_rows?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Revisions_Mutation_Response>, Record<string, never>, Scalars['Int'] | string>,
    returning?: GraphCacheResolver<WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Revisions_Mutation_Response>, Record<string, never>, Array<WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Revisions> | string>>
  },
  revisions_scenario_parameters_journal?: {
    author_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Journal>, Record<string, never>, Scalars['String'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Journal>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Journal>, Record<string, never>, Scalars['timestamptz'] | string>,
    id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Journal>, Record<string, never>, Scalars['uuid'] | string>,
    parent_journal_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Journal>, Record<string, never>, Scalars['uuid'] | string>,
    scenario_parameters_journal?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Journal>, Record<string, never>, WithTypename<Revisions_Scenario_Parameters_Journal> | string>,
    scenario_parameters_journals?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Journal>, Revisions_Scenario_Parameters_JournalScenario_Parameters_JournalsArgs, Array<WithTypename<Revisions_Scenario_Parameters_Journal> | string>>,
    scenario_parameters_journals_aggregate?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Journal>, Revisions_Scenario_Parameters_JournalScenario_Parameters_Journals_AggregateArgs, WithTypename<Revisions_Scenario_Parameters_Journal_Aggregate> | string>,
    scenario_parameters_revision?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Journal>, Record<string, never>, WithTypename<Revisions_Scenario_Parameters_Revisions> | string>,
    scenario_parameters_revisions?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Journal>, Revisions_Scenario_Parameters_JournalScenario_Parameters_RevisionsArgs, Array<WithTypename<Revisions_Scenario_Parameters_Revisions> | string>>,
    scenario_parameters_revisions_aggregate?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Journal>, Revisions_Scenario_Parameters_JournalScenario_Parameters_Revisions_AggregateArgs, WithTypename<Revisions_Scenario_Parameters_Revisions_Aggregate> | string>,
    scenarios_revisions?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Journal>, Revisions_Scenario_Parameters_JournalScenarios_RevisionsArgs, Array<WithTypename<Revisions_Scenarios_Revisions> | string>>,
    scenarios_revisions_aggregate?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Journal>, Revisions_Scenario_Parameters_JournalScenarios_Revisions_AggregateArgs, WithTypename<Revisions_Scenarios_Revisions_Aggregate> | string>,
    updated_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Journal>, Record<string, never>, Scalars['timestamptz'] | string>,
    user?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Journal>, Record<string, never>, WithTypename<Users> | string>,
    winning_revision_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Journal>, Record<string, never>, Scalars['uuid'] | string>
  },
  revisions_scenario_parameters_journal_aggregate?: {
    aggregate?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Journal_Aggregate>, Record<string, never>, WithTypename<Revisions_Scenario_Parameters_Journal_Aggregate_Fields> | string>,
    nodes?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Journal_Aggregate>, Record<string, never>, Array<WithTypename<Revisions_Scenario_Parameters_Journal> | string>>
  },
  revisions_scenario_parameters_journal_aggregate_fields?: {
    count?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Journal_Aggregate_Fields>, Revisions_Scenario_Parameters_Journal_Aggregate_FieldsCountArgs, Scalars['Int'] | string>,
    max?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Journal_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Scenario_Parameters_Journal_Max_Fields> | string>,
    min?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Journal_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Scenario_Parameters_Journal_Min_Fields> | string>
  },
  revisions_scenario_parameters_journal_max_fields?: {
    author_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Journal_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Journal_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Journal_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Journal_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    parent_journal_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Journal_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Journal_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    winning_revision_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Journal_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>
  },
  revisions_scenario_parameters_journal_min_fields?: {
    author_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Journal_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Journal_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Journal_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Journal_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    parent_journal_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Journal_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Journal_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    winning_revision_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Journal_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>
  },
  revisions_scenario_parameters_journal_mutation_response?: {
    affected_rows?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Journal_Mutation_Response>, Record<string, never>, Scalars['Int'] | string>,
    returning?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Journal_Mutation_Response>, Record<string, never>, Array<WithTypename<Revisions_Scenario_Parameters_Journal> | string>>
  },
  revisions_scenario_parameters_revisions?: {
    author_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions>, Record<string, never>, Scalars['String'] | string>,
    bottom_casing_pressure_psia?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions>, Record<string, never>, Scalars['numeric'] | string>,
    bottom_tubing_pressure_psia?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions>, Record<string, never>, Scalars['numeric'] | string>,
    cable_cost_kw_hr_usd?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions>, Record<string, never>, Scalars['numeric'] | string>,
    cloned_from_journal_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions>, Record<string, never>, Scalars['uuid'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions>, Record<string, never>, Scalars['timestamptz'] | string>,
    elevation_feet_asl?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions>, Record<string, never>, Scalars['numeric'] | string>,
    flowModelByFlowModel?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions>, Record<string, never>, WithTypename<Flow_Model> | string>,
    flow_model?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions>, Record<string, never>, Flow_Model_Enum | string>,
    has_compression_pump?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions>, Record<string, never>, Scalars['Boolean'] | string>,
    id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions>, Record<string, never>, Scalars['uuid'] | string>,
    include_casing_friction_loss?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions>, Record<string, never>, Scalars['Boolean'] | string>,
    intake_gas_separation_override_type?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions>, Record<string, never>, Override_Options_Enum | string>,
    intake_override_gas_separation_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions>, Record<string, never>, Scalars['numeric'] | string>,
    intake_packer_installed?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions>, Record<string, never>, Scalars['Boolean'] | string>,
    journal_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions>, Record<string, never>, Scalars['uuid'] | string>,
    lower_has_compression_pump?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions>, Record<string, never>, Scalars['Boolean'] | string>,
    lower_include_casing_friction_loss?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions>, Record<string, never>, Scalars['Boolean'] | string>,
    lower_intake_gas_separation_override_type?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions>, Record<string, never>, Override_Options_Enum | string>,
    lower_intake_override_gas_separation_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions>, Record<string, never>, Scalars['numeric'] | string>,
    lower_intake_packer_installed?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions>, Record<string, never>, Scalars['Boolean'] | string>,
    lower_motor_rerate_ratio?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions>, Record<string, never>, Scalars['numeric'] | string>,
    lower_motor_shroud_interior_diameter_inches?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions>, Record<string, never>, Scalars['numeric'] | string>,
    lower_natural_gas_separation_override_type?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions>, Record<string, never>, Override_Options_Enum | string>,
    lower_natural_override_gas_separation_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions>, Record<string, never>, Scalars['numeric'] | string>,
    lower_pump_hz?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions>, Record<string, never>, Scalars['numeric'] | string>,
    lower_pump_override_gas_correction_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions>, Record<string, never>, Scalars['numeric'] | string>,
    lower_pump_wear_brake_horsepower_correction_ratio?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions>, Record<string, never>, Scalars['numeric'] | string>,
    lower_pump_wear_head_correction_ratio?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions>, Record<string, never>, Scalars['numeric'] | string>,
    lower_use_legacy_gas_head_rerate?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions>, Record<string, never>, Scalars['Boolean'] | string>,
    maximum_frequency?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions>, Record<string, never>, Scalars['numeric'] | string>,
    minimum_frequency?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions>, Record<string, never>, Scalars['numeric'] | string>,
    motor_rerate_ratio?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions>, Record<string, never>, Scalars['numeric'] | string>,
    motor_shroud_interior_diameter_inches?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions>, Record<string, never>, Scalars['numeric'] | string>,
    natural_gas_separation_override_type?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions>, Record<string, never>, Override_Options_Enum | string>,
    natural_override_gas_separation_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions>, Record<string, never>, Scalars['numeric'] | string>,
    parent_revision_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions>, Record<string, never>, Scalars['uuid'] | string>,
    pump_hz?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions>, Record<string, never>, Scalars['numeric'] | string>,
    pump_override_gas_correction_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions>, Record<string, never>, Scalars['numeric'] | string>,
    pump_wear_brake_horsepower_correction_ratio?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions>, Record<string, never>, Scalars['numeric'] | string>,
    pump_wear_head_correction_ratio?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions>, Record<string, never>, Scalars['numeric'] | string>,
    scenario_parameters_journal?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions>, Record<string, never>, WithTypename<Revisions_Scenario_Parameters_Journal> | string>,
    scenario_parameters_journals?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions>, Revisions_Scenario_Parameters_RevisionsScenario_Parameters_JournalsArgs, Array<WithTypename<Revisions_Scenario_Parameters_Journal> | string>>,
    scenario_parameters_journals_aggregate?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions>, Revisions_Scenario_Parameters_RevisionsScenario_Parameters_Journals_AggregateArgs, WithTypename<Revisions_Scenario_Parameters_Journal_Aggregate> | string>,
    scenario_parameters_revision?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions>, Record<string, never>, WithTypename<Revisions_Scenario_Parameters_Revisions> | string>,
    scenario_parameters_revisions?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions>, Revisions_Scenario_Parameters_RevisionsScenario_Parameters_RevisionsArgs, Array<WithTypename<Revisions_Scenario_Parameters_Revisions> | string>>,
    scenario_parameters_revisions_aggregate?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions>, Revisions_Scenario_Parameters_RevisionsScenario_Parameters_Revisions_AggregateArgs, WithTypename<Revisions_Scenario_Parameters_Revisions_Aggregate> | string>,
    scenario_parameters_view?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions>, Record<string, never>, WithTypename<Scenario_Parameters> | string>,
    surface_drive_incoming_power_volts?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions>, Record<string, never>, Scalars['numeric'] | string>,
    target_liquid_rate_std_barrel_day?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions>, Record<string, never>, Scalars['numeric'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions>, Record<string, never>, Scalars['timestamptz'] | string>,
    use_legacy_gas_head_rerate?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions>, Record<string, never>, Scalars['Boolean'] | string>,
    user?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions>, Record<string, never>, WithTypename<Users> | string>,
    vsd_input_voltage?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions>, Record<string, never>, Scalars['numeric'] | string>
  },
  revisions_scenario_parameters_revisions_aggregate?: {
    aggregate?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Aggregate>, Record<string, never>, WithTypename<Revisions_Scenario_Parameters_Revisions_Aggregate_Fields> | string>,
    nodes?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Aggregate>, Record<string, never>, Array<WithTypename<Revisions_Scenario_Parameters_Revisions> | string>>
  },
  revisions_scenario_parameters_revisions_aggregate_fields?: {
    avg?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Scenario_Parameters_Revisions_Avg_Fields> | string>,
    count?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Aggregate_Fields>, Revisions_Scenario_Parameters_Revisions_Aggregate_FieldsCountArgs, Scalars['Int'] | string>,
    max?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Scenario_Parameters_Revisions_Max_Fields> | string>,
    min?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Scenario_Parameters_Revisions_Min_Fields> | string>,
    stddev?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Scenario_Parameters_Revisions_Stddev_Fields> | string>,
    stddev_pop?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Scenario_Parameters_Revisions_Stddev_Pop_Fields> | string>,
    stddev_samp?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Scenario_Parameters_Revisions_Stddev_Samp_Fields> | string>,
    sum?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Scenario_Parameters_Revisions_Sum_Fields> | string>,
    var_pop?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Scenario_Parameters_Revisions_Var_Pop_Fields> | string>,
    var_samp?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Scenario_Parameters_Revisions_Var_Samp_Fields> | string>,
    variance?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Scenario_Parameters_Revisions_Variance_Fields> | string>
  },
  revisions_scenario_parameters_revisions_avg_fields?: {
    bottom_casing_pressure_psia?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bottom_tubing_pressure_psia?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    cable_cost_kw_hr_usd?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    elevation_feet_asl?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    intake_override_gas_separation_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    lower_intake_override_gas_separation_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    lower_motor_rerate_ratio?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    lower_motor_shroud_interior_diameter_inches?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    lower_natural_override_gas_separation_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    lower_pump_hz?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    lower_pump_override_gas_correction_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    lower_pump_wear_brake_horsepower_correction_ratio?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    lower_pump_wear_head_correction_ratio?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    maximum_frequency?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    minimum_frequency?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    motor_rerate_ratio?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    motor_shroud_interior_diameter_inches?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    natural_override_gas_separation_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pump_hz?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pump_override_gas_correction_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pump_wear_brake_horsepower_correction_ratio?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pump_wear_head_correction_ratio?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    surface_drive_incoming_power_volts?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    target_liquid_rate_std_barrel_day?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    vsd_input_voltage?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  revisions_scenario_parameters_revisions_max_fields?: {
    author_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    bottom_casing_pressure_psia?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    bottom_tubing_pressure_psia?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    cable_cost_kw_hr_usd?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    cloned_from_journal_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    elevation_feet_asl?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    intake_override_gas_separation_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    journal_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    lower_intake_override_gas_separation_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    lower_motor_rerate_ratio?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    lower_motor_shroud_interior_diameter_inches?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    lower_natural_override_gas_separation_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    lower_pump_hz?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    lower_pump_override_gas_correction_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    lower_pump_wear_brake_horsepower_correction_ratio?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    lower_pump_wear_head_correction_ratio?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    maximum_frequency?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    minimum_frequency?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    motor_rerate_ratio?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    motor_shroud_interior_diameter_inches?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    natural_override_gas_separation_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    parent_revision_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    pump_hz?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    pump_override_gas_correction_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    pump_wear_brake_horsepower_correction_ratio?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    pump_wear_head_correction_ratio?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    surface_drive_incoming_power_volts?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    target_liquid_rate_std_barrel_day?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    vsd_input_voltage?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>
  },
  revisions_scenario_parameters_revisions_min_fields?: {
    author_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    bottom_casing_pressure_psia?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    bottom_tubing_pressure_psia?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    cable_cost_kw_hr_usd?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    cloned_from_journal_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    elevation_feet_asl?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    intake_override_gas_separation_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    journal_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    lower_intake_override_gas_separation_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    lower_motor_rerate_ratio?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    lower_motor_shroud_interior_diameter_inches?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    lower_natural_override_gas_separation_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    lower_pump_hz?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    lower_pump_override_gas_correction_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    lower_pump_wear_brake_horsepower_correction_ratio?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    lower_pump_wear_head_correction_ratio?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    maximum_frequency?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    minimum_frequency?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    motor_rerate_ratio?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    motor_shroud_interior_diameter_inches?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    natural_override_gas_separation_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    parent_revision_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    pump_hz?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    pump_override_gas_correction_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    pump_wear_brake_horsepower_correction_ratio?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    pump_wear_head_correction_ratio?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    surface_drive_incoming_power_volts?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    target_liquid_rate_std_barrel_day?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    vsd_input_voltage?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>
  },
  revisions_scenario_parameters_revisions_mutation_response?: {
    affected_rows?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Mutation_Response>, Record<string, never>, Scalars['Int'] | string>,
    returning?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Mutation_Response>, Record<string, never>, Array<WithTypename<Revisions_Scenario_Parameters_Revisions> | string>>
  },
  revisions_scenario_parameters_revisions_stddev_fields?: {
    bottom_casing_pressure_psia?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bottom_tubing_pressure_psia?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    cable_cost_kw_hr_usd?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    elevation_feet_asl?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    intake_override_gas_separation_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    lower_intake_override_gas_separation_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    lower_motor_rerate_ratio?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    lower_motor_shroud_interior_diameter_inches?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    lower_natural_override_gas_separation_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    lower_pump_hz?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    lower_pump_override_gas_correction_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    lower_pump_wear_brake_horsepower_correction_ratio?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    lower_pump_wear_head_correction_ratio?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    maximum_frequency?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    minimum_frequency?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    motor_rerate_ratio?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    motor_shroud_interior_diameter_inches?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    natural_override_gas_separation_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pump_hz?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pump_override_gas_correction_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pump_wear_brake_horsepower_correction_ratio?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pump_wear_head_correction_ratio?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    surface_drive_incoming_power_volts?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    target_liquid_rate_std_barrel_day?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    vsd_input_voltage?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  revisions_scenario_parameters_revisions_stddev_pop_fields?: {
    bottom_casing_pressure_psia?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bottom_tubing_pressure_psia?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    cable_cost_kw_hr_usd?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    elevation_feet_asl?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    intake_override_gas_separation_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    lower_intake_override_gas_separation_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    lower_motor_rerate_ratio?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    lower_motor_shroud_interior_diameter_inches?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    lower_natural_override_gas_separation_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    lower_pump_hz?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    lower_pump_override_gas_correction_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    lower_pump_wear_brake_horsepower_correction_ratio?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    lower_pump_wear_head_correction_ratio?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    maximum_frequency?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    minimum_frequency?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    motor_rerate_ratio?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    motor_shroud_interior_diameter_inches?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    natural_override_gas_separation_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pump_hz?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pump_override_gas_correction_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pump_wear_brake_horsepower_correction_ratio?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pump_wear_head_correction_ratio?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    surface_drive_incoming_power_volts?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    target_liquid_rate_std_barrel_day?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    vsd_input_voltage?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  revisions_scenario_parameters_revisions_stddev_samp_fields?: {
    bottom_casing_pressure_psia?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bottom_tubing_pressure_psia?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    cable_cost_kw_hr_usd?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    elevation_feet_asl?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    intake_override_gas_separation_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    lower_intake_override_gas_separation_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    lower_motor_rerate_ratio?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    lower_motor_shroud_interior_diameter_inches?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    lower_natural_override_gas_separation_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    lower_pump_hz?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    lower_pump_override_gas_correction_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    lower_pump_wear_brake_horsepower_correction_ratio?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    lower_pump_wear_head_correction_ratio?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    maximum_frequency?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    minimum_frequency?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    motor_rerate_ratio?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    motor_shroud_interior_diameter_inches?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    natural_override_gas_separation_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pump_hz?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pump_override_gas_correction_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pump_wear_brake_horsepower_correction_ratio?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pump_wear_head_correction_ratio?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    surface_drive_incoming_power_volts?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    target_liquid_rate_std_barrel_day?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    vsd_input_voltage?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  revisions_scenario_parameters_revisions_sum_fields?: {
    bottom_casing_pressure_psia?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    bottom_tubing_pressure_psia?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    cable_cost_kw_hr_usd?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    elevation_feet_asl?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    intake_override_gas_separation_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    lower_intake_override_gas_separation_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    lower_motor_rerate_ratio?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    lower_motor_shroud_interior_diameter_inches?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    lower_natural_override_gas_separation_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    lower_pump_hz?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    lower_pump_override_gas_correction_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    lower_pump_wear_brake_horsepower_correction_ratio?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    lower_pump_wear_head_correction_ratio?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    maximum_frequency?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    minimum_frequency?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    motor_rerate_ratio?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    motor_shroud_interior_diameter_inches?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    natural_override_gas_separation_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    pump_hz?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    pump_override_gas_correction_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    pump_wear_brake_horsepower_correction_ratio?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    pump_wear_head_correction_ratio?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    surface_drive_incoming_power_volts?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    target_liquid_rate_std_barrel_day?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    vsd_input_voltage?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>
  },
  revisions_scenario_parameters_revisions_var_pop_fields?: {
    bottom_casing_pressure_psia?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bottom_tubing_pressure_psia?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    cable_cost_kw_hr_usd?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    elevation_feet_asl?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    intake_override_gas_separation_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    lower_intake_override_gas_separation_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    lower_motor_rerate_ratio?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    lower_motor_shroud_interior_diameter_inches?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    lower_natural_override_gas_separation_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    lower_pump_hz?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    lower_pump_override_gas_correction_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    lower_pump_wear_brake_horsepower_correction_ratio?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    lower_pump_wear_head_correction_ratio?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    maximum_frequency?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    minimum_frequency?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    motor_rerate_ratio?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    motor_shroud_interior_diameter_inches?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    natural_override_gas_separation_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pump_hz?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pump_override_gas_correction_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pump_wear_brake_horsepower_correction_ratio?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pump_wear_head_correction_ratio?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    surface_drive_incoming_power_volts?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    target_liquid_rate_std_barrel_day?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    vsd_input_voltage?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  revisions_scenario_parameters_revisions_var_samp_fields?: {
    bottom_casing_pressure_psia?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bottom_tubing_pressure_psia?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    cable_cost_kw_hr_usd?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    elevation_feet_asl?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    intake_override_gas_separation_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    lower_intake_override_gas_separation_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    lower_motor_rerate_ratio?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    lower_motor_shroud_interior_diameter_inches?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    lower_natural_override_gas_separation_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    lower_pump_hz?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    lower_pump_override_gas_correction_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    lower_pump_wear_brake_horsepower_correction_ratio?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    lower_pump_wear_head_correction_ratio?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    maximum_frequency?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    minimum_frequency?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    motor_rerate_ratio?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    motor_shroud_interior_diameter_inches?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    natural_override_gas_separation_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pump_hz?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pump_override_gas_correction_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pump_wear_brake_horsepower_correction_ratio?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pump_wear_head_correction_ratio?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    surface_drive_incoming_power_volts?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    target_liquid_rate_std_barrel_day?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    vsd_input_voltage?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  revisions_scenario_parameters_revisions_variance_fields?: {
    bottom_casing_pressure_psia?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bottom_tubing_pressure_psia?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    cable_cost_kw_hr_usd?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    elevation_feet_asl?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    intake_override_gas_separation_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    lower_intake_override_gas_separation_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    lower_motor_rerate_ratio?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    lower_motor_shroud_interior_diameter_inches?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    lower_natural_override_gas_separation_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    lower_pump_hz?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    lower_pump_override_gas_correction_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    lower_pump_wear_brake_horsepower_correction_ratio?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    lower_pump_wear_head_correction_ratio?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    maximum_frequency?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    minimum_frequency?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    motor_rerate_ratio?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    motor_shroud_interior_diameter_inches?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    natural_override_gas_separation_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pump_hz?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pump_override_gas_correction_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pump_wear_brake_horsepower_correction_ratio?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pump_wear_head_correction_ratio?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    surface_drive_incoming_power_volts?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    target_liquid_rate_std_barrel_day?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    vsd_input_voltage?: GraphCacheResolver<WithTypename<Revisions_Scenario_Parameters_Revisions_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  revisions_scenario_well_properties_journal?: {
    author_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Journal>, Record<string, never>, Scalars['String'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Journal>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Journal>, Record<string, never>, Scalars['timestamptz'] | string>,
    id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Journal>, Record<string, never>, Scalars['uuid'] | string>,
    parent_journal_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Journal>, Record<string, never>, Scalars['uuid'] | string>,
    scenario_well_properties_journal?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Journal>, Record<string, never>, WithTypename<Revisions_Scenario_Well_Properties_Journal> | string>,
    scenario_well_properties_journals?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Journal>, Revisions_Scenario_Well_Properties_JournalScenario_Well_Properties_JournalsArgs, Array<WithTypename<Revisions_Scenario_Well_Properties_Journal> | string>>,
    scenario_well_properties_journals_aggregate?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Journal>, Revisions_Scenario_Well_Properties_JournalScenario_Well_Properties_Journals_AggregateArgs, WithTypename<Revisions_Scenario_Well_Properties_Journal_Aggregate> | string>,
    scenario_well_properties_revision?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Journal>, Record<string, never>, WithTypename<Revisions_Scenario_Well_Properties_Revisions> | string>,
    scenario_well_properties_revisions?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Journal>, Revisions_Scenario_Well_Properties_JournalScenario_Well_Properties_RevisionsArgs, Array<WithTypename<Revisions_Scenario_Well_Properties_Revisions> | string>>,
    scenario_well_properties_revisions_aggregate?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Journal>, Revisions_Scenario_Well_Properties_JournalScenario_Well_Properties_Revisions_AggregateArgs, WithTypename<Revisions_Scenario_Well_Properties_Revisions_Aggregate> | string>,
    scenarios_revisions?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Journal>, Revisions_Scenario_Well_Properties_JournalScenarios_RevisionsArgs, Array<WithTypename<Revisions_Scenarios_Revisions> | string>>,
    scenarios_revisions_aggregate?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Journal>, Revisions_Scenario_Well_Properties_JournalScenarios_Revisions_AggregateArgs, WithTypename<Revisions_Scenarios_Revisions_Aggregate> | string>,
    updated_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Journal>, Record<string, never>, Scalars['timestamptz'] | string>,
    user?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Journal>, Record<string, never>, WithTypename<Users> | string>,
    winning_revision_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Journal>, Record<string, never>, Scalars['uuid'] | string>
  },
  revisions_scenario_well_properties_journal_aggregate?: {
    aggregate?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Journal_Aggregate>, Record<string, never>, WithTypename<Revisions_Scenario_Well_Properties_Journal_Aggregate_Fields> | string>,
    nodes?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Journal_Aggregate>, Record<string, never>, Array<WithTypename<Revisions_Scenario_Well_Properties_Journal> | string>>
  },
  revisions_scenario_well_properties_journal_aggregate_fields?: {
    count?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Journal_Aggregate_Fields>, Revisions_Scenario_Well_Properties_Journal_Aggregate_FieldsCountArgs, Scalars['Int'] | string>,
    max?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Journal_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Scenario_Well_Properties_Journal_Max_Fields> | string>,
    min?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Journal_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Scenario_Well_Properties_Journal_Min_Fields> | string>
  },
  revisions_scenario_well_properties_journal_max_fields?: {
    author_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Journal_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Journal_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Journal_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Journal_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    parent_journal_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Journal_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Journal_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    winning_revision_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Journal_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>
  },
  revisions_scenario_well_properties_journal_min_fields?: {
    author_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Journal_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Journal_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Journal_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Journal_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    parent_journal_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Journal_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Journal_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    winning_revision_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Journal_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>
  },
  revisions_scenario_well_properties_journal_mutation_response?: {
    affected_rows?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Journal_Mutation_Response>, Record<string, never>, Scalars['Int'] | string>,
    returning?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Journal_Mutation_Response>, Record<string, never>, Array<WithTypename<Revisions_Scenario_Well_Properties_Journal> | string>>
  },
  revisions_scenario_well_properties_revisions?: {
    ar_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions>, Record<string, never>, Scalars['numeric'] | string>,
    author_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions>, Record<string, never>, Scalars['String'] | string>,
    average_dls?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions>, Record<string, never>, Scalars['numeric'] | string>,
    bottom_casing?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions>, Record<string, never>, WithTypename<Casings> | string>,
    bottom_casing_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions>, Record<string, never>, Scalars['uuid'] | string>,
    bottom_casing_length_feet?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions>, Record<string, never>, Scalars['numeric'] | string>,
    bottom_tubing?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions>, Record<string, never>, WithTypename<Tubings> | string>,
    bottom_tubing_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions>, Record<string, never>, Scalars['uuid'] | string>,
    bottom_tubing_length_feet?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions>, Record<string, never>, Scalars['numeric'] | string>,
    bottomhole_temperature_fahrenheit?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions>, Record<string, never>, Scalars['numeric'] | string>,
    bubble_point_pressure_psia?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions>, Record<string, never>, Scalars['numeric'] | string>,
    c1_methane_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions>, Record<string, never>, Scalars['numeric'] | string>,
    c2_ethane_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions>, Record<string, never>, Scalars['numeric'] | string>,
    c3_propane_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions>, Record<string, never>, Scalars['numeric'] | string>,
    c6_hexane_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions>, Record<string, never>, Scalars['numeric'] | string>,
    c7_heptane_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions>, Record<string, never>, Scalars['numeric'] | string>,
    cloned_from_journal_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions>, Record<string, never>, Scalars['uuid'] | string>,
    co2_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions>, Record<string, never>, Scalars['numeric'] | string>,
    condensate_api_override?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions>, Record<string, never>, Scalars['numeric'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions>, Record<string, never>, Scalars['timestamptz'] | string>,
    custom_fluid_properties?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions>, Revisions_Scenario_Well_Properties_RevisionsCustom_Fluid_PropertiesArgs, Scalars['jsonb'] | string>,
    custom_viscosities_properties?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions>, Revisions_Scenario_Well_Properties_RevisionsCustom_Viscosities_PropertiesArgs, Scalars['jsonb'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions>, Record<string, never>, Scalars['timestamptz'] | string>,
    deviation_survey?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions>, Record<string, never>, WithTypename<Deviation_Survey> | string>,
    deviation_survey_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions>, Record<string, never>, Scalars['uuid'] | string>,
    dew_point_pressure_psia_override?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions>, Record<string, never>, Scalars['numeric'] | string>,
    fluid_viscosity_override_cp?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions>, Record<string, never>, Scalars['numeric'] | string>,
    gas_specific_gravity?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions>, Record<string, never>, Scalars['numeric'] | string>,
    gas_type?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions>, Record<string, never>, Well_Gas_Type_Options_Enum | string>,
    h2s_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions>, Record<string, never>, Scalars['numeric'] | string>,
    hps_liquid_type?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions>, Record<string, never>, Hps_Liquid_Type_Enum | string>,
    hps_pump_inlet_pressure_psia?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions>, Record<string, never>, Scalars['numeric'] | string>,
    hps_pump_inlet_temperature_fahrenheit?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions>, Record<string, never>, Scalars['numeric'] | string>,
    hps_required_discharge_pressure_psia?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions>, Record<string, never>, Scalars['numeric'] | string>,
    ic4_isobutene_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions>, Record<string, never>, Scalars['numeric'] | string>,
    ic5_isopentane_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions>, Record<string, never>, Scalars['numeric'] | string>,
    id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions>, Record<string, never>, Scalars['uuid'] | string>,
    journal_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions>, Record<string, never>, Scalars['uuid'] | string>,
    n2_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions>, Record<string, never>, Scalars['numeric'] | string>,
    nc4_butane_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions>, Record<string, never>, Scalars['numeric'] | string>,
    nc5_bentane_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions>, Record<string, never>, Scalars['numeric'] | string>,
    npsha_ft?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions>, Record<string, never>, Scalars['numeric'] | string>,
    o2_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions>, Record<string, never>, Scalars['numeric'] | string>,
    oil_gravity_api?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions>, Record<string, never>, Scalars['numeric'] | string>,
    parent_revision_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions>, Record<string, never>, Scalars['uuid'] | string>,
    scenario_well_properties_journal?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions>, Record<string, never>, WithTypename<Revisions_Scenario_Well_Properties_Journal> | string>,
    scenario_well_properties_journals?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions>, Revisions_Scenario_Well_Properties_RevisionsScenario_Well_Properties_JournalsArgs, Array<WithTypename<Revisions_Scenario_Well_Properties_Journal> | string>>,
    scenario_well_properties_journals_aggregate?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions>, Revisions_Scenario_Well_Properties_RevisionsScenario_Well_Properties_Journals_AggregateArgs, WithTypename<Revisions_Scenario_Well_Properties_Journal_Aggregate> | string>,
    scenario_well_properties_revision?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions>, Record<string, never>, WithTypename<Revisions_Scenario_Well_Properties_Revisions> | string>,
    scenario_well_properties_revisions?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions>, Revisions_Scenario_Well_Properties_RevisionsScenario_Well_Properties_RevisionsArgs, Array<WithTypename<Revisions_Scenario_Well_Properties_Revisions> | string>>,
    scenario_well_properties_revisions_aggregate?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions>, Revisions_Scenario_Well_Properties_RevisionsScenario_Well_Properties_Revisions_AggregateArgs, WithTypename<Revisions_Scenario_Well_Properties_Revisions_Aggregate> | string>,
    scenario_well_properties_view?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions>, Record<string, never>, WithTypename<Scenario_Well_Properties> | string>,
    surface_temperature_fahrenheit?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions>, Record<string, never>, Scalars['numeric'] | string>,
    top_casing?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions>, Record<string, never>, WithTypename<Casings> | string>,
    top_casing_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions>, Record<string, never>, Scalars['uuid'] | string>,
    top_casing_length_feet?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions>, Record<string, never>, Scalars['numeric'] | string>,
    top_of_perforations_measured_depth_feet?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions>, Record<string, never>, Scalars['numeric'] | string>,
    top_of_perforations_true_vertical_depth_feet?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions>, Record<string, never>, Scalars['numeric'] | string>,
    top_tubing?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions>, Record<string, never>, WithTypename<Tubings> | string>,
    top_tubing_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions>, Record<string, never>, Scalars['uuid'] | string>,
    top_tubing_length_feet?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions>, Record<string, never>, Scalars['numeric'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions>, Record<string, never>, Scalars['timestamptz'] | string>,
    user?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions>, Record<string, never>, WithTypename<Users> | string>,
    water_specific_gravity?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions>, Record<string, never>, Scalars['numeric'] | string>,
    well_test_datum_point_measured_depth_feet?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions>, Record<string, never>, Scalars['numeric'] | string>,
    well_test_gas_input_option?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions>, Record<string, never>, WithTypename<Well_Test_Gas_Input_Options> | string>,
    well_test_gas_input_type?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions>, Record<string, never>, Well_Test_Gas_Input_Options_Enum | string>,
    well_test_gas_rate_mscf_day?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions>, Record<string, never>, Scalars['numeric'] | string>,
    well_test_liquid_input_option?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions>, Record<string, never>, WithTypename<Well_Test_Liquid_Input_Options> | string>,
    well_test_liquid_input_type?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions>, Record<string, never>, Well_Test_Liquid_Input_Options_Enum | string>,
    well_test_oil_rate_stb_day?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions>, Record<string, never>, Scalars['numeric'] | string>,
    well_test_pressure_input_type?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions>, Record<string, never>, Well_Test_Pressure_Input_Options_Enum | string>,
    well_test_producing_bottom_hole_pressure_psia?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions>, Record<string, never>, Scalars['numeric'] | string>,
    well_test_productivity_index?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions>, Record<string, never>, Scalars['numeric'] | string>,
    well_test_static_bottom_hole_pressure_psia?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions>, Record<string, never>, Scalars['numeric'] | string>,
    well_test_test_date?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions>, Record<string, never>, Scalars['timestamptz'] | string>,
    well_test_water_rate_stb_day?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions>, Record<string, never>, Scalars['numeric'] | string>
  },
  revisions_scenario_well_properties_revisions_aggregate?: {
    aggregate?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Aggregate>, Record<string, never>, WithTypename<Revisions_Scenario_Well_Properties_Revisions_Aggregate_Fields> | string>,
    nodes?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Aggregate>, Record<string, never>, Array<WithTypename<Revisions_Scenario_Well_Properties_Revisions> | string>>
  },
  revisions_scenario_well_properties_revisions_aggregate_fields?: {
    avg?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Scenario_Well_Properties_Revisions_Avg_Fields> | string>,
    count?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Aggregate_Fields>, Revisions_Scenario_Well_Properties_Revisions_Aggregate_FieldsCountArgs, Scalars['Int'] | string>,
    max?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Scenario_Well_Properties_Revisions_Max_Fields> | string>,
    min?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Scenario_Well_Properties_Revisions_Min_Fields> | string>,
    stddev?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Scenario_Well_Properties_Revisions_Stddev_Fields> | string>,
    stddev_pop?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Scenario_Well_Properties_Revisions_Stddev_Pop_Fields> | string>,
    stddev_samp?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Scenario_Well_Properties_Revisions_Stddev_Samp_Fields> | string>,
    sum?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Scenario_Well_Properties_Revisions_Sum_Fields> | string>,
    var_pop?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Scenario_Well_Properties_Revisions_Var_Pop_Fields> | string>,
    var_samp?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Scenario_Well_Properties_Revisions_Var_Samp_Fields> | string>,
    variance?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Scenario_Well_Properties_Revisions_Variance_Fields> | string>
  },
  revisions_scenario_well_properties_revisions_avg_fields?: {
    ar_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    average_dls?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bottom_casing_length_feet?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bottom_tubing_length_feet?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bottomhole_temperature_fahrenheit?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bubble_point_pressure_psia?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    c1_methane_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    c2_ethane_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    c3_propane_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    c6_hexane_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    c7_heptane_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    co2_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    condensate_api_override?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    dew_point_pressure_psia_override?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    fluid_viscosity_override_cp?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    gas_specific_gravity?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    h2s_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    hps_pump_inlet_pressure_psia?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    hps_pump_inlet_temperature_fahrenheit?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    hps_required_discharge_pressure_psia?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    ic4_isobutene_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    ic5_isopentane_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    n2_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    nc4_butane_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    nc5_bentane_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    npsha_ft?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    o2_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    oil_gravity_api?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    surface_temperature_fahrenheit?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    top_casing_length_feet?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    top_of_perforations_measured_depth_feet?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    top_of_perforations_true_vertical_depth_feet?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    top_tubing_length_feet?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    water_specific_gravity?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    well_test_datum_point_measured_depth_feet?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    well_test_gas_rate_mscf_day?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    well_test_oil_rate_stb_day?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    well_test_producing_bottom_hole_pressure_psia?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    well_test_productivity_index?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    well_test_static_bottom_hole_pressure_psia?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    well_test_water_rate_stb_day?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  revisions_scenario_well_properties_revisions_max_fields?: {
    ar_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    author_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    average_dls?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    bottom_casing_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    bottom_casing_length_feet?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    bottom_tubing_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    bottom_tubing_length_feet?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    bottomhole_temperature_fahrenheit?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    bubble_point_pressure_psia?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    c1_methane_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    c2_ethane_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    c3_propane_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    c6_hexane_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    c7_heptane_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    cloned_from_journal_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    co2_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    condensate_api_override?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    deviation_survey_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    dew_point_pressure_psia_override?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    fluid_viscosity_override_cp?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    gas_specific_gravity?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    h2s_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    hps_pump_inlet_pressure_psia?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    hps_pump_inlet_temperature_fahrenheit?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    hps_required_discharge_pressure_psia?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    ic4_isobutene_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    ic5_isopentane_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    journal_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    n2_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    nc4_butane_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    nc5_bentane_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    npsha_ft?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    o2_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    oil_gravity_api?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    parent_revision_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    surface_temperature_fahrenheit?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    top_casing_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    top_casing_length_feet?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    top_of_perforations_measured_depth_feet?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    top_of_perforations_true_vertical_depth_feet?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    top_tubing_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    top_tubing_length_feet?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    water_specific_gravity?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    well_test_datum_point_measured_depth_feet?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    well_test_gas_rate_mscf_day?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    well_test_oil_rate_stb_day?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    well_test_producing_bottom_hole_pressure_psia?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    well_test_productivity_index?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    well_test_static_bottom_hole_pressure_psia?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    well_test_test_date?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    well_test_water_rate_stb_day?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>
  },
  revisions_scenario_well_properties_revisions_min_fields?: {
    ar_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    author_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    average_dls?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    bottom_casing_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    bottom_casing_length_feet?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    bottom_tubing_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    bottom_tubing_length_feet?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    bottomhole_temperature_fahrenheit?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    bubble_point_pressure_psia?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    c1_methane_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    c2_ethane_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    c3_propane_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    c6_hexane_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    c7_heptane_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    cloned_from_journal_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    co2_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    condensate_api_override?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    deviation_survey_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    dew_point_pressure_psia_override?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    fluid_viscosity_override_cp?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    gas_specific_gravity?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    h2s_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    hps_pump_inlet_pressure_psia?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    hps_pump_inlet_temperature_fahrenheit?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    hps_required_discharge_pressure_psia?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    ic4_isobutene_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    ic5_isopentane_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    journal_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    n2_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    nc4_butane_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    nc5_bentane_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    npsha_ft?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    o2_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    oil_gravity_api?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    parent_revision_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    surface_temperature_fahrenheit?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    top_casing_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    top_casing_length_feet?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    top_of_perforations_measured_depth_feet?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    top_of_perforations_true_vertical_depth_feet?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    top_tubing_id?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    top_tubing_length_feet?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    water_specific_gravity?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    well_test_datum_point_measured_depth_feet?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    well_test_gas_rate_mscf_day?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    well_test_oil_rate_stb_day?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    well_test_producing_bottom_hole_pressure_psia?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    well_test_productivity_index?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    well_test_static_bottom_hole_pressure_psia?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    well_test_test_date?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    well_test_water_rate_stb_day?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>
  },
  revisions_scenario_well_properties_revisions_mutation_response?: {
    affected_rows?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Mutation_Response>, Record<string, never>, Scalars['Int'] | string>,
    returning?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Mutation_Response>, Record<string, never>, Array<WithTypename<Revisions_Scenario_Well_Properties_Revisions> | string>>
  },
  revisions_scenario_well_properties_revisions_stddev_fields?: {
    ar_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    average_dls?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bottom_casing_length_feet?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bottom_tubing_length_feet?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bottomhole_temperature_fahrenheit?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bubble_point_pressure_psia?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    c1_methane_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    c2_ethane_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    c3_propane_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    c6_hexane_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    c7_heptane_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    co2_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    condensate_api_override?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    dew_point_pressure_psia_override?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    fluid_viscosity_override_cp?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    gas_specific_gravity?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    h2s_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    hps_pump_inlet_pressure_psia?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    hps_pump_inlet_temperature_fahrenheit?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    hps_required_discharge_pressure_psia?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    ic4_isobutene_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    ic5_isopentane_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    n2_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    nc4_butane_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    nc5_bentane_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    npsha_ft?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    o2_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    oil_gravity_api?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    surface_temperature_fahrenheit?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    top_casing_length_feet?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    top_of_perforations_measured_depth_feet?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    top_of_perforations_true_vertical_depth_feet?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    top_tubing_length_feet?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    water_specific_gravity?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    well_test_datum_point_measured_depth_feet?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    well_test_gas_rate_mscf_day?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    well_test_oil_rate_stb_day?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    well_test_producing_bottom_hole_pressure_psia?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    well_test_productivity_index?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    well_test_static_bottom_hole_pressure_psia?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    well_test_water_rate_stb_day?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  revisions_scenario_well_properties_revisions_stddev_pop_fields?: {
    ar_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    average_dls?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bottom_casing_length_feet?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bottom_tubing_length_feet?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bottomhole_temperature_fahrenheit?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bubble_point_pressure_psia?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    c1_methane_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    c2_ethane_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    c3_propane_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    c6_hexane_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    c7_heptane_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    co2_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    condensate_api_override?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    dew_point_pressure_psia_override?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    fluid_viscosity_override_cp?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    gas_specific_gravity?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    h2s_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    hps_pump_inlet_pressure_psia?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    hps_pump_inlet_temperature_fahrenheit?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    hps_required_discharge_pressure_psia?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    ic4_isobutene_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    ic5_isopentane_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    n2_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    nc4_butane_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    nc5_bentane_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    npsha_ft?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    o2_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    oil_gravity_api?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    surface_temperature_fahrenheit?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    top_casing_length_feet?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    top_of_perforations_measured_depth_feet?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    top_of_perforations_true_vertical_depth_feet?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    top_tubing_length_feet?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    water_specific_gravity?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    well_test_datum_point_measured_depth_feet?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    well_test_gas_rate_mscf_day?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    well_test_oil_rate_stb_day?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    well_test_producing_bottom_hole_pressure_psia?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    well_test_productivity_index?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    well_test_static_bottom_hole_pressure_psia?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    well_test_water_rate_stb_day?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  revisions_scenario_well_properties_revisions_stddev_samp_fields?: {
    ar_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    average_dls?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bottom_casing_length_feet?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bottom_tubing_length_feet?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bottomhole_temperature_fahrenheit?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bubble_point_pressure_psia?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    c1_methane_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    c2_ethane_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    c3_propane_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    c6_hexane_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    c7_heptane_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    co2_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    condensate_api_override?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    dew_point_pressure_psia_override?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    fluid_viscosity_override_cp?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    gas_specific_gravity?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    h2s_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    hps_pump_inlet_pressure_psia?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    hps_pump_inlet_temperature_fahrenheit?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    hps_required_discharge_pressure_psia?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    ic4_isobutene_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    ic5_isopentane_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    n2_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    nc4_butane_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    nc5_bentane_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    npsha_ft?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    o2_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    oil_gravity_api?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    surface_temperature_fahrenheit?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    top_casing_length_feet?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    top_of_perforations_measured_depth_feet?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    top_of_perforations_true_vertical_depth_feet?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    top_tubing_length_feet?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    water_specific_gravity?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    well_test_datum_point_measured_depth_feet?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    well_test_gas_rate_mscf_day?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    well_test_oil_rate_stb_day?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    well_test_producing_bottom_hole_pressure_psia?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    well_test_productivity_index?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    well_test_static_bottom_hole_pressure_psia?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    well_test_water_rate_stb_day?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  revisions_scenario_well_properties_revisions_sum_fields?: {
    ar_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    average_dls?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    bottom_casing_length_feet?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    bottom_tubing_length_feet?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    bottomhole_temperature_fahrenheit?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    bubble_point_pressure_psia?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    c1_methane_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    c2_ethane_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    c3_propane_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    c6_hexane_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    c7_heptane_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    co2_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    condensate_api_override?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    dew_point_pressure_psia_override?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    fluid_viscosity_override_cp?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    gas_specific_gravity?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    h2s_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    hps_pump_inlet_pressure_psia?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    hps_pump_inlet_temperature_fahrenheit?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    hps_required_discharge_pressure_psia?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    ic4_isobutene_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    ic5_isopentane_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    n2_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    nc4_butane_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    nc5_bentane_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    npsha_ft?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    o2_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    oil_gravity_api?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    surface_temperature_fahrenheit?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    top_casing_length_feet?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    top_of_perforations_measured_depth_feet?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    top_of_perforations_true_vertical_depth_feet?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    top_tubing_length_feet?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    water_specific_gravity?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    well_test_datum_point_measured_depth_feet?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    well_test_gas_rate_mscf_day?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    well_test_oil_rate_stb_day?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    well_test_producing_bottom_hole_pressure_psia?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    well_test_productivity_index?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    well_test_static_bottom_hole_pressure_psia?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    well_test_water_rate_stb_day?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>
  },
  revisions_scenario_well_properties_revisions_var_pop_fields?: {
    ar_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    average_dls?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bottom_casing_length_feet?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bottom_tubing_length_feet?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bottomhole_temperature_fahrenheit?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bubble_point_pressure_psia?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    c1_methane_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    c2_ethane_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    c3_propane_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    c6_hexane_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    c7_heptane_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    co2_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    condensate_api_override?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    dew_point_pressure_psia_override?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    fluid_viscosity_override_cp?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    gas_specific_gravity?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    h2s_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    hps_pump_inlet_pressure_psia?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    hps_pump_inlet_temperature_fahrenheit?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    hps_required_discharge_pressure_psia?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    ic4_isobutene_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    ic5_isopentane_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    n2_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    nc4_butane_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    nc5_bentane_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    npsha_ft?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    o2_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    oil_gravity_api?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    surface_temperature_fahrenheit?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    top_casing_length_feet?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    top_of_perforations_measured_depth_feet?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    top_of_perforations_true_vertical_depth_feet?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    top_tubing_length_feet?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    water_specific_gravity?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    well_test_datum_point_measured_depth_feet?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    well_test_gas_rate_mscf_day?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    well_test_oil_rate_stb_day?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    well_test_producing_bottom_hole_pressure_psia?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    well_test_productivity_index?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    well_test_static_bottom_hole_pressure_psia?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    well_test_water_rate_stb_day?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  revisions_scenario_well_properties_revisions_var_samp_fields?: {
    ar_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    average_dls?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bottom_casing_length_feet?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bottom_tubing_length_feet?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bottomhole_temperature_fahrenheit?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bubble_point_pressure_psia?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    c1_methane_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    c2_ethane_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    c3_propane_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    c6_hexane_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    c7_heptane_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    co2_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    condensate_api_override?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    dew_point_pressure_psia_override?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    fluid_viscosity_override_cp?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    gas_specific_gravity?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    h2s_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    hps_pump_inlet_pressure_psia?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    hps_pump_inlet_temperature_fahrenheit?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    hps_required_discharge_pressure_psia?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    ic4_isobutene_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    ic5_isopentane_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    n2_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    nc4_butane_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    nc5_bentane_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    npsha_ft?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    o2_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    oil_gravity_api?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    surface_temperature_fahrenheit?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    top_casing_length_feet?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    top_of_perforations_measured_depth_feet?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    top_of_perforations_true_vertical_depth_feet?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    top_tubing_length_feet?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    water_specific_gravity?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    well_test_datum_point_measured_depth_feet?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    well_test_gas_rate_mscf_day?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    well_test_oil_rate_stb_day?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    well_test_producing_bottom_hole_pressure_psia?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    well_test_productivity_index?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    well_test_static_bottom_hole_pressure_psia?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    well_test_water_rate_stb_day?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  revisions_scenario_well_properties_revisions_variance_fields?: {
    ar_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    average_dls?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bottom_casing_length_feet?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bottom_tubing_length_feet?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bottomhole_temperature_fahrenheit?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bubble_point_pressure_psia?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    c1_methane_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    c2_ethane_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    c3_propane_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    c6_hexane_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    c7_heptane_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    co2_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    condensate_api_override?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    dew_point_pressure_psia_override?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    fluid_viscosity_override_cp?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    gas_specific_gravity?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    h2s_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    hps_pump_inlet_pressure_psia?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    hps_pump_inlet_temperature_fahrenheit?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    hps_required_discharge_pressure_psia?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    ic4_isobutene_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    ic5_isopentane_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    n2_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    nc4_butane_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    nc5_bentane_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    npsha_ft?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    o2_percent?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    oil_gravity_api?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    surface_temperature_fahrenheit?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    top_casing_length_feet?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    top_of_perforations_measured_depth_feet?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    top_of_perforations_true_vertical_depth_feet?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    top_tubing_length_feet?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    water_specific_gravity?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    well_test_datum_point_measured_depth_feet?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    well_test_gas_rate_mscf_day?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    well_test_oil_rate_stb_day?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    well_test_producing_bottom_hole_pressure_psia?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    well_test_productivity_index?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    well_test_static_bottom_hole_pressure_psia?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    well_test_water_rate_stb_day?: GraphCacheResolver<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  revisions_scenarios_journal?: {
    author?: GraphCacheResolver<WithTypename<Revisions_Scenarios_Journal>, Record<string, never>, WithTypename<Users> | string>,
    author_id?: GraphCacheResolver<WithTypename<Revisions_Scenarios_Journal>, Record<string, never>, Scalars['String'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Revisions_Scenarios_Journal>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Revisions_Scenarios_Journal>, Record<string, never>, Scalars['timestamptz'] | string>,
    id?: GraphCacheResolver<WithTypename<Revisions_Scenarios_Journal>, Record<string, never>, Scalars['uuid'] | string>,
    parent_journal_id?: GraphCacheResolver<WithTypename<Revisions_Scenarios_Journal>, Record<string, never>, Scalars['uuid'] | string>,
    parent_scenarios_journal?: GraphCacheResolver<WithTypename<Revisions_Scenarios_Journal>, Record<string, never>, WithTypename<Revisions_Scenarios_Journal> | string>,
    performance_evaluations_revisions?: GraphCacheResolver<WithTypename<Revisions_Scenarios_Journal>, Revisions_Scenarios_JournalPerformance_Evaluations_RevisionsArgs, Array<WithTypename<Revisions_Performance_Evaluations_Revisions> | string>>,
    performance_evaluations_revisions_aggregate?: GraphCacheResolver<WithTypename<Revisions_Scenarios_Journal>, Revisions_Scenarios_JournalPerformance_Evaluations_Revisions_AggregateArgs, WithTypename<Revisions_Performance_Evaluations_Revisions_Aggregate> | string>,
    scenarios_journals_children?: GraphCacheResolver<WithTypename<Revisions_Scenarios_Journal>, Revisions_Scenarios_JournalScenarios_Journals_ChildrenArgs, Array<WithTypename<Revisions_Scenarios_Journal> | string>>,
    scenarios_journals_children_aggregate?: GraphCacheResolver<WithTypename<Revisions_Scenarios_Journal>, Revisions_Scenarios_JournalScenarios_Journals_Children_AggregateArgs, WithTypename<Revisions_Scenarios_Journal_Aggregate> | string>,
    scenarios_revisions?: GraphCacheResolver<WithTypename<Revisions_Scenarios_Journal>, Revisions_Scenarios_JournalScenarios_RevisionsArgs, Array<WithTypename<Revisions_Scenarios_Revisions> | string>>,
    scenarios_revisions_aggregate?: GraphCacheResolver<WithTypename<Revisions_Scenarios_Journal>, Revisions_Scenarios_JournalScenarios_Revisions_AggregateArgs, WithTypename<Revisions_Scenarios_Revisions_Aggregate> | string>,
    sizings_revisions_installed_on?: GraphCacheResolver<WithTypename<Revisions_Scenarios_Journal>, Revisions_Scenarios_JournalSizings_Revisions_Installed_OnArgs, Array<WithTypename<Revisions_Sizings_Revisions> | string>>,
    sizings_revisions_installed_on_aggregate?: GraphCacheResolver<WithTypename<Revisions_Scenarios_Journal>, Revisions_Scenarios_JournalSizings_Revisions_Installed_On_AggregateArgs, WithTypename<Revisions_Sizings_Revisions_Aggregate> | string>,
    updated_at?: GraphCacheResolver<WithTypename<Revisions_Scenarios_Journal>, Record<string, never>, Scalars['timestamptz'] | string>,
    winning_revision_id?: GraphCacheResolver<WithTypename<Revisions_Scenarios_Journal>, Record<string, never>, Scalars['uuid'] | string>,
    winning_scenarios_revision?: GraphCacheResolver<WithTypename<Revisions_Scenarios_Journal>, Record<string, never>, WithTypename<Revisions_Scenarios_Revisions> | string>
  },
  revisions_scenarios_journal_aggregate?: {
    aggregate?: GraphCacheResolver<WithTypename<Revisions_Scenarios_Journal_Aggregate>, Record<string, never>, WithTypename<Revisions_Scenarios_Journal_Aggregate_Fields> | string>,
    nodes?: GraphCacheResolver<WithTypename<Revisions_Scenarios_Journal_Aggregate>, Record<string, never>, Array<WithTypename<Revisions_Scenarios_Journal> | string>>
  },
  revisions_scenarios_journal_aggregate_fields?: {
    count?: GraphCacheResolver<WithTypename<Revisions_Scenarios_Journal_Aggregate_Fields>, Revisions_Scenarios_Journal_Aggregate_FieldsCountArgs, Scalars['Int'] | string>,
    max?: GraphCacheResolver<WithTypename<Revisions_Scenarios_Journal_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Scenarios_Journal_Max_Fields> | string>,
    min?: GraphCacheResolver<WithTypename<Revisions_Scenarios_Journal_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Scenarios_Journal_Min_Fields> | string>
  },
  revisions_scenarios_journal_max_fields?: {
    author_id?: GraphCacheResolver<WithTypename<Revisions_Scenarios_Journal_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Revisions_Scenarios_Journal_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Revisions_Scenarios_Journal_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    id?: GraphCacheResolver<WithTypename<Revisions_Scenarios_Journal_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    parent_journal_id?: GraphCacheResolver<WithTypename<Revisions_Scenarios_Journal_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Revisions_Scenarios_Journal_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    winning_revision_id?: GraphCacheResolver<WithTypename<Revisions_Scenarios_Journal_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>
  },
  revisions_scenarios_journal_min_fields?: {
    author_id?: GraphCacheResolver<WithTypename<Revisions_Scenarios_Journal_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Revisions_Scenarios_Journal_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Revisions_Scenarios_Journal_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    id?: GraphCacheResolver<WithTypename<Revisions_Scenarios_Journal_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    parent_journal_id?: GraphCacheResolver<WithTypename<Revisions_Scenarios_Journal_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Revisions_Scenarios_Journal_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    winning_revision_id?: GraphCacheResolver<WithTypename<Revisions_Scenarios_Journal_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>
  },
  revisions_scenarios_journal_mutation_response?: {
    affected_rows?: GraphCacheResolver<WithTypename<Revisions_Scenarios_Journal_Mutation_Response>, Record<string, never>, Scalars['Int'] | string>,
    returning?: GraphCacheResolver<WithTypename<Revisions_Scenarios_Journal_Mutation_Response>, Record<string, never>, Array<WithTypename<Revisions_Scenarios_Journal> | string>>
  },
  revisions_scenarios_revisions?: {
    author?: GraphCacheResolver<WithTypename<Revisions_Scenarios_Revisions>, Record<string, never>, WithTypename<Users> | string>,
    author_id?: GraphCacheResolver<WithTypename<Revisions_Scenarios_Revisions>, Record<string, never>, Scalars['String'] | string>,
    cloned_from_journal_id?: GraphCacheResolver<WithTypename<Revisions_Scenarios_Revisions>, Record<string, never>, Scalars['uuid'] | string>,
    cloned_from_scenario?: GraphCacheResolver<WithTypename<Revisions_Scenarios_Revisions>, Record<string, never>, WithTypename<Revisions_Scenarios_Journal> | string>,
    correlations_id?: GraphCacheResolver<WithTypename<Revisions_Scenarios_Revisions>, Record<string, never>, Scalars['uuid'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Revisions_Scenarios_Revisions>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Revisions_Scenarios_Revisions>, Record<string, never>, Scalars['timestamptz'] | string>,
    display_unit_overrides?: GraphCacheResolver<WithTypename<Revisions_Scenarios_Revisions>, Revisions_Scenarios_RevisionsDisplay_Unit_OverridesArgs, Scalars['jsonb'] | string>,
    id?: GraphCacheResolver<WithTypename<Revisions_Scenarios_Revisions>, Record<string, never>, Scalars['uuid'] | string>,
    internal_notes?: GraphCacheResolver<WithTypename<Revisions_Scenarios_Revisions>, Record<string, never>, Scalars['String'] | string>,
    journal_id?: GraphCacheResolver<WithTypename<Revisions_Scenarios_Revisions>, Record<string, never>, Scalars['uuid'] | string>,
    notes?: GraphCacheResolver<WithTypename<Revisions_Scenarios_Revisions>, Record<string, never>, Scalars['String'] | string>,
    parameters_id?: GraphCacheResolver<WithTypename<Revisions_Scenarios_Revisions>, Record<string, never>, Scalars['uuid'] | string>,
    parent_revision_id?: GraphCacheResolver<WithTypename<Revisions_Scenarios_Revisions>, Record<string, never>, Scalars['uuid'] | string>,
    parent_scenarios_revision?: GraphCacheResolver<WithTypename<Revisions_Scenarios_Revisions>, Record<string, never>, WithTypename<Revisions_Scenarios_Revisions> | string>,
    pumping_type?: GraphCacheResolver<WithTypename<Revisions_Scenarios_Revisions>, Record<string, never>, Sizing_Pumping_Type_Enum | string>,
    reason?: GraphCacheResolver<WithTypename<Revisions_Scenarios_Revisions>, Record<string, never>, Scenario_Reasons_Enum | string>,
    scenario_correlations_journal?: GraphCacheResolver<WithTypename<Revisions_Scenarios_Revisions>, Record<string, never>, WithTypename<Revisions_Scenario_Correlations_Journal> | string>,
    scenario_equipment_id?: GraphCacheResolver<WithTypename<Revisions_Scenarios_Revisions>, Record<string, never>, Scalars['uuid'] | string>,
    scenario_equipment_journal?: GraphCacheResolver<WithTypename<Revisions_Scenarios_Revisions>, Record<string, never>, WithTypename<Revisions_Scenario_Equipment_Journal> | string>,
    scenario_parameters_journal?: GraphCacheResolver<WithTypename<Revisions_Scenarios_Revisions>, Record<string, never>, WithTypename<Revisions_Scenario_Parameters_Journal> | string>,
    scenario_reason?: GraphCacheResolver<WithTypename<Revisions_Scenarios_Revisions>, Record<string, never>, WithTypename<Scenario_Reasons> | string>,
    scenario_well_properties_journal?: GraphCacheResolver<WithTypename<Revisions_Scenarios_Revisions>, Record<string, never>, WithTypename<Revisions_Scenario_Well_Properties_Journal> | string>,
    scenarios_journal?: GraphCacheResolver<WithTypename<Revisions_Scenarios_Revisions>, Record<string, never>, WithTypename<Revisions_Scenarios_Journal> | string>,
    scenarios_journals?: GraphCacheResolver<WithTypename<Revisions_Scenarios_Revisions>, Revisions_Scenarios_RevisionsScenarios_JournalsArgs, Array<WithTypename<Revisions_Scenarios_Journal> | string>>,
    scenarios_journals_aggregate?: GraphCacheResolver<WithTypename<Revisions_Scenarios_Revisions>, Revisions_Scenarios_RevisionsScenarios_Journals_AggregateArgs, WithTypename<Revisions_Scenarios_Journal_Aggregate> | string>,
    scenarios_revisions_parents?: GraphCacheResolver<WithTypename<Revisions_Scenarios_Revisions>, Revisions_Scenarios_RevisionsScenarios_Revisions_ParentsArgs, Array<WithTypename<Revisions_Scenarios_Revisions> | string>>,
    scenarios_revisions_parents_aggregate?: GraphCacheResolver<WithTypename<Revisions_Scenarios_Revisions>, Revisions_Scenarios_RevisionsScenarios_Revisions_Parents_AggregateArgs, WithTypename<Revisions_Scenarios_Revisions_Aggregate> | string>,
    scenarios_view?: GraphCacheResolver<WithTypename<Revisions_Scenarios_Revisions>, Record<string, never>, WithTypename<Scenarios> | string>,
    sizing_id?: GraphCacheResolver<WithTypename<Revisions_Scenarios_Revisions>, Record<string, never>, Scalars['uuid'] | string>,
    sizings_journal?: GraphCacheResolver<WithTypename<Revisions_Scenarios_Revisions>, Record<string, never>, WithTypename<Revisions_Sizings_Journal> | string>,
    title?: GraphCacheResolver<WithTypename<Revisions_Scenarios_Revisions>, Record<string, never>, Scalars['String'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Revisions_Scenarios_Revisions>, Record<string, never>, Scalars['timestamptz'] | string>,
    well_properties_id?: GraphCacheResolver<WithTypename<Revisions_Scenarios_Revisions>, Record<string, never>, Scalars['uuid'] | string>
  },
  revisions_scenarios_revisions_aggregate?: {
    aggregate?: GraphCacheResolver<WithTypename<Revisions_Scenarios_Revisions_Aggregate>, Record<string, never>, WithTypename<Revisions_Scenarios_Revisions_Aggregate_Fields> | string>,
    nodes?: GraphCacheResolver<WithTypename<Revisions_Scenarios_Revisions_Aggregate>, Record<string, never>, Array<WithTypename<Revisions_Scenarios_Revisions> | string>>
  },
  revisions_scenarios_revisions_aggregate_fields?: {
    count?: GraphCacheResolver<WithTypename<Revisions_Scenarios_Revisions_Aggregate_Fields>, Revisions_Scenarios_Revisions_Aggregate_FieldsCountArgs, Scalars['Int'] | string>,
    max?: GraphCacheResolver<WithTypename<Revisions_Scenarios_Revisions_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Scenarios_Revisions_Max_Fields> | string>,
    min?: GraphCacheResolver<WithTypename<Revisions_Scenarios_Revisions_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Scenarios_Revisions_Min_Fields> | string>
  },
  revisions_scenarios_revisions_max_fields?: {
    author_id?: GraphCacheResolver<WithTypename<Revisions_Scenarios_Revisions_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    cloned_from_journal_id?: GraphCacheResolver<WithTypename<Revisions_Scenarios_Revisions_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    correlations_id?: GraphCacheResolver<WithTypename<Revisions_Scenarios_Revisions_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Revisions_Scenarios_Revisions_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Revisions_Scenarios_Revisions_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    id?: GraphCacheResolver<WithTypename<Revisions_Scenarios_Revisions_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    internal_notes?: GraphCacheResolver<WithTypename<Revisions_Scenarios_Revisions_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    journal_id?: GraphCacheResolver<WithTypename<Revisions_Scenarios_Revisions_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    notes?: GraphCacheResolver<WithTypename<Revisions_Scenarios_Revisions_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    parameters_id?: GraphCacheResolver<WithTypename<Revisions_Scenarios_Revisions_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    parent_revision_id?: GraphCacheResolver<WithTypename<Revisions_Scenarios_Revisions_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    scenario_equipment_id?: GraphCacheResolver<WithTypename<Revisions_Scenarios_Revisions_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    sizing_id?: GraphCacheResolver<WithTypename<Revisions_Scenarios_Revisions_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    title?: GraphCacheResolver<WithTypename<Revisions_Scenarios_Revisions_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Revisions_Scenarios_Revisions_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    well_properties_id?: GraphCacheResolver<WithTypename<Revisions_Scenarios_Revisions_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>
  },
  revisions_scenarios_revisions_min_fields?: {
    author_id?: GraphCacheResolver<WithTypename<Revisions_Scenarios_Revisions_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    cloned_from_journal_id?: GraphCacheResolver<WithTypename<Revisions_Scenarios_Revisions_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    correlations_id?: GraphCacheResolver<WithTypename<Revisions_Scenarios_Revisions_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Revisions_Scenarios_Revisions_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Revisions_Scenarios_Revisions_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    id?: GraphCacheResolver<WithTypename<Revisions_Scenarios_Revisions_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    internal_notes?: GraphCacheResolver<WithTypename<Revisions_Scenarios_Revisions_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    journal_id?: GraphCacheResolver<WithTypename<Revisions_Scenarios_Revisions_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    notes?: GraphCacheResolver<WithTypename<Revisions_Scenarios_Revisions_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    parameters_id?: GraphCacheResolver<WithTypename<Revisions_Scenarios_Revisions_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    parent_revision_id?: GraphCacheResolver<WithTypename<Revisions_Scenarios_Revisions_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    scenario_equipment_id?: GraphCacheResolver<WithTypename<Revisions_Scenarios_Revisions_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    sizing_id?: GraphCacheResolver<WithTypename<Revisions_Scenarios_Revisions_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    title?: GraphCacheResolver<WithTypename<Revisions_Scenarios_Revisions_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Revisions_Scenarios_Revisions_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    well_properties_id?: GraphCacheResolver<WithTypename<Revisions_Scenarios_Revisions_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>
  },
  revisions_scenarios_revisions_mutation_response?: {
    affected_rows?: GraphCacheResolver<WithTypename<Revisions_Scenarios_Revisions_Mutation_Response>, Record<string, never>, Scalars['Int'] | string>,
    returning?: GraphCacheResolver<WithTypename<Revisions_Scenarios_Revisions_Mutation_Response>, Record<string, never>, Array<WithTypename<Revisions_Scenarios_Revisions> | string>>
  },
  revisions_sizings_journal?: {
    author?: GraphCacheResolver<WithTypename<Revisions_Sizings_Journal>, Record<string, never>, WithTypename<Users> | string>,
    author_id?: GraphCacheResolver<WithTypename<Revisions_Sizings_Journal>, Record<string, never>, Scalars['String'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Revisions_Sizings_Journal>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Revisions_Sizings_Journal>, Record<string, never>, Scalars['timestamptz'] | string>,
    id?: GraphCacheResolver<WithTypename<Revisions_Sizings_Journal>, Record<string, never>, Scalars['uuid'] | string>,
    parent_journal_id?: GraphCacheResolver<WithTypename<Revisions_Sizings_Journal>, Record<string, never>, Scalars['uuid'] | string>,
    parent_sizings_journal?: GraphCacheResolver<WithTypename<Revisions_Sizings_Journal>, Record<string, never>, WithTypename<Revisions_Sizings_Journal> | string>,
    scenarios_revisions?: GraphCacheResolver<WithTypename<Revisions_Sizings_Journal>, Revisions_Sizings_JournalScenarios_RevisionsArgs, Array<WithTypename<Revisions_Scenarios_Revisions> | string>>,
    scenarios_revisions_aggregate?: GraphCacheResolver<WithTypename<Revisions_Sizings_Journal>, Revisions_Sizings_JournalScenarios_Revisions_AggregateArgs, WithTypename<Revisions_Scenarios_Revisions_Aggregate> | string>,
    sizings_journals_children?: GraphCacheResolver<WithTypename<Revisions_Sizings_Journal>, Revisions_Sizings_JournalSizings_Journals_ChildrenArgs, Array<WithTypename<Revisions_Sizings_Journal> | string>>,
    sizings_journals_children_aggregate?: GraphCacheResolver<WithTypename<Revisions_Sizings_Journal>, Revisions_Sizings_JournalSizings_Journals_Children_AggregateArgs, WithTypename<Revisions_Sizings_Journal_Aggregate> | string>,
    sizings_revisions?: GraphCacheResolver<WithTypename<Revisions_Sizings_Journal>, Revisions_Sizings_JournalSizings_RevisionsArgs, Array<WithTypename<Revisions_Sizings_Revisions> | string>>,
    sizings_revisions_aggregate?: GraphCacheResolver<WithTypename<Revisions_Sizings_Journal>, Revisions_Sizings_JournalSizings_Revisions_AggregateArgs, WithTypename<Revisions_Sizings_Revisions_Aggregate> | string>,
    updated_at?: GraphCacheResolver<WithTypename<Revisions_Sizings_Journal>, Record<string, never>, Scalars['timestamptz'] | string>,
    winning_revision_id?: GraphCacheResolver<WithTypename<Revisions_Sizings_Journal>, Record<string, never>, Scalars['uuid'] | string>,
    winning_sizings_revision?: GraphCacheResolver<WithTypename<Revisions_Sizings_Journal>, Record<string, never>, WithTypename<Revisions_Sizings_Revisions> | string>
  },
  revisions_sizings_journal_aggregate?: {
    aggregate?: GraphCacheResolver<WithTypename<Revisions_Sizings_Journal_Aggregate>, Record<string, never>, WithTypename<Revisions_Sizings_Journal_Aggregate_Fields> | string>,
    nodes?: GraphCacheResolver<WithTypename<Revisions_Sizings_Journal_Aggregate>, Record<string, never>, Array<WithTypename<Revisions_Sizings_Journal> | string>>
  },
  revisions_sizings_journal_aggregate_fields?: {
    count?: GraphCacheResolver<WithTypename<Revisions_Sizings_Journal_Aggregate_Fields>, Revisions_Sizings_Journal_Aggregate_FieldsCountArgs, Scalars['Int'] | string>,
    max?: GraphCacheResolver<WithTypename<Revisions_Sizings_Journal_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Sizings_Journal_Max_Fields> | string>,
    min?: GraphCacheResolver<WithTypename<Revisions_Sizings_Journal_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Sizings_Journal_Min_Fields> | string>
  },
  revisions_sizings_journal_max_fields?: {
    author_id?: GraphCacheResolver<WithTypename<Revisions_Sizings_Journal_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Revisions_Sizings_Journal_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Revisions_Sizings_Journal_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    id?: GraphCacheResolver<WithTypename<Revisions_Sizings_Journal_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    parent_journal_id?: GraphCacheResolver<WithTypename<Revisions_Sizings_Journal_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Revisions_Sizings_Journal_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    winning_revision_id?: GraphCacheResolver<WithTypename<Revisions_Sizings_Journal_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>
  },
  revisions_sizings_journal_min_fields?: {
    author_id?: GraphCacheResolver<WithTypename<Revisions_Sizings_Journal_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Revisions_Sizings_Journal_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Revisions_Sizings_Journal_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    id?: GraphCacheResolver<WithTypename<Revisions_Sizings_Journal_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    parent_journal_id?: GraphCacheResolver<WithTypename<Revisions_Sizings_Journal_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Revisions_Sizings_Journal_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    winning_revision_id?: GraphCacheResolver<WithTypename<Revisions_Sizings_Journal_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>
  },
  revisions_sizings_journal_mutation_response?: {
    affected_rows?: GraphCacheResolver<WithTypename<Revisions_Sizings_Journal_Mutation_Response>, Record<string, never>, Scalars['Int'] | string>,
    returning?: GraphCacheResolver<WithTypename<Revisions_Sizings_Journal_Mutation_Response>, Record<string, never>, Array<WithTypename<Revisions_Sizings_Journal> | string>>
  },
  revisions_sizings_revisions?: {
    author?: GraphCacheResolver<WithTypename<Revisions_Sizings_Revisions>, Record<string, never>, WithTypename<Users> | string>,
    author_id?: GraphCacheResolver<WithTypename<Revisions_Sizings_Revisions>, Record<string, never>, Scalars['String'] | string>,
    cloned_from_journal_id?: GraphCacheResolver<WithTypename<Revisions_Sizings_Revisions>, Record<string, never>, Scalars['uuid'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Revisions_Sizings_Revisions>, Record<string, never>, Scalars['timestamptz'] | string>,
    customer?: GraphCacheResolver<WithTypename<Revisions_Sizings_Revisions>, Record<string, never>, WithTypename<Customers> | string>,
    customer_id?: GraphCacheResolver<WithTypename<Revisions_Sizings_Revisions>, Record<string, never>, Scalars['Int'] | string>,
    default_display_units?: GraphCacheResolver<WithTypename<Revisions_Sizings_Revisions>, Record<string, never>, Display_Units_Enum | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Revisions_Sizings_Revisions>, Record<string, never>, Scalars['timestamptz'] | string>,
    display_unit?: GraphCacheResolver<WithTypename<Revisions_Sizings_Revisions>, Record<string, never>, WithTypename<Display_Units> | string>,
    disposition?: GraphCacheResolver<WithTypename<Revisions_Sizings_Revisions>, Record<string, never>, Sizing_Dispositions_Enum | string>,
    hps_location?: GraphCacheResolver<WithTypename<Revisions_Sizings_Revisions>, Record<string, never>, Scalars['String'] | string>,
    id?: GraphCacheResolver<WithTypename<Revisions_Sizings_Revisions>, Record<string, never>, Scalars['uuid'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Revisions_Sizings_Revisions>, Record<string, never>, Scalars['Int'] | string>,
    installed_scenario_id?: GraphCacheResolver<WithTypename<Revisions_Sizings_Revisions>, Record<string, never>, Scalars['uuid'] | string>,
    installed_scenarios_journal?: GraphCacheResolver<WithTypename<Revisions_Sizings_Revisions>, Record<string, never>, WithTypename<Revisions_Scenarios_Journal> | string>,
    is_shared?: GraphCacheResolver<WithTypename<Revisions_Sizings_Revisions>, Record<string, never>, Scalars['Boolean'] | string>,
    journal_id?: GraphCacheResolver<WithTypename<Revisions_Sizings_Revisions>, Record<string, never>, Scalars['uuid'] | string>,
    notes?: GraphCacheResolver<WithTypename<Revisions_Sizings_Revisions>, Record<string, never>, Scalars['String'] | string>,
    parent_revision_id?: GraphCacheResolver<WithTypename<Revisions_Sizings_Revisions>, Record<string, never>, Scalars['uuid'] | string>,
    parent_sizings_revision?: GraphCacheResolver<WithTypename<Revisions_Sizings_Revisions>, Record<string, never>, WithTypename<Revisions_Sizings_Revisions> | string>,
    pumping_type?: GraphCacheResolver<WithTypename<Revisions_Sizings_Revisions>, Record<string, never>, Sizing_Pumping_Type_Enum | string>,
    scenario_order?: GraphCacheResolver<WithTypename<Revisions_Sizings_Revisions>, Record<string, never>, Array<Scalars['uuid'] | string>>,
    share_with_customer?: GraphCacheResolver<WithTypename<Revisions_Sizings_Revisions>, Record<string, never>, Scalars['Boolean'] | string>,
    sizing_disposition?: GraphCacheResolver<WithTypename<Revisions_Sizings_Revisions>, Record<string, never>, WithTypename<Sizing_Dispositions> | string>,
    sizing_import?: GraphCacheResolver<WithTypename<Revisions_Sizings_Revisions>, Record<string, never>, WithTypename<Sizing_Imports> | string>,
    sizings_journal?: GraphCacheResolver<WithTypename<Revisions_Sizings_Revisions>, Record<string, never>, WithTypename<Revisions_Sizings_Journal> | string>,
    sizings_journals?: GraphCacheResolver<WithTypename<Revisions_Sizings_Revisions>, Revisions_Sizings_RevisionsSizings_JournalsArgs, Array<WithTypename<Revisions_Sizings_Journal> | string>>,
    sizings_journals_aggregate?: GraphCacheResolver<WithTypename<Revisions_Sizings_Revisions>, Revisions_Sizings_RevisionsSizings_Journals_AggregateArgs, WithTypename<Revisions_Sizings_Journal_Aggregate> | string>,
    sizings_revisions_parents?: GraphCacheResolver<WithTypename<Revisions_Sizings_Revisions>, Revisions_Sizings_RevisionsSizings_Revisions_ParentsArgs, Array<WithTypename<Revisions_Sizings_Revisions> | string>>,
    sizings_revisions_parents_aggregate?: GraphCacheResolver<WithTypename<Revisions_Sizings_Revisions>, Revisions_Sizings_RevisionsSizings_Revisions_Parents_AggregateArgs, WithTypename<Revisions_Sizings_Revisions_Aggregate> | string>,
    sizings_view?: GraphCacheResolver<WithTypename<Revisions_Sizings_Revisions>, Record<string, never>, WithTypename<Sizings> | string>,
    title?: GraphCacheResolver<WithTypename<Revisions_Sizings_Revisions>, Record<string, never>, Scalars['String'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Revisions_Sizings_Revisions>, Record<string, never>, Scalars['timestamptz'] | string>,
    well?: GraphCacheResolver<WithTypename<Revisions_Sizings_Revisions>, Record<string, never>, WithTypename<Wells> | string>,
    well_id?: GraphCacheResolver<WithTypename<Revisions_Sizings_Revisions>, Record<string, never>, Scalars['Int'] | string>
  },
  revisions_sizings_revisions_aggregate?: {
    aggregate?: GraphCacheResolver<WithTypename<Revisions_Sizings_Revisions_Aggregate>, Record<string, never>, WithTypename<Revisions_Sizings_Revisions_Aggregate_Fields> | string>,
    nodes?: GraphCacheResolver<WithTypename<Revisions_Sizings_Revisions_Aggregate>, Record<string, never>, Array<WithTypename<Revisions_Sizings_Revisions> | string>>
  },
  revisions_sizings_revisions_aggregate_fields?: {
    avg?: GraphCacheResolver<WithTypename<Revisions_Sizings_Revisions_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Sizings_Revisions_Avg_Fields> | string>,
    count?: GraphCacheResolver<WithTypename<Revisions_Sizings_Revisions_Aggregate_Fields>, Revisions_Sizings_Revisions_Aggregate_FieldsCountArgs, Scalars['Int'] | string>,
    max?: GraphCacheResolver<WithTypename<Revisions_Sizings_Revisions_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Sizings_Revisions_Max_Fields> | string>,
    min?: GraphCacheResolver<WithTypename<Revisions_Sizings_Revisions_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Sizings_Revisions_Min_Fields> | string>,
    stddev?: GraphCacheResolver<WithTypename<Revisions_Sizings_Revisions_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Sizings_Revisions_Stddev_Fields> | string>,
    stddev_pop?: GraphCacheResolver<WithTypename<Revisions_Sizings_Revisions_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Sizings_Revisions_Stddev_Pop_Fields> | string>,
    stddev_samp?: GraphCacheResolver<WithTypename<Revisions_Sizings_Revisions_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Sizings_Revisions_Stddev_Samp_Fields> | string>,
    sum?: GraphCacheResolver<WithTypename<Revisions_Sizings_Revisions_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Sizings_Revisions_Sum_Fields> | string>,
    var_pop?: GraphCacheResolver<WithTypename<Revisions_Sizings_Revisions_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Sizings_Revisions_Var_Pop_Fields> | string>,
    var_samp?: GraphCacheResolver<WithTypename<Revisions_Sizings_Revisions_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Sizings_Revisions_Var_Samp_Fields> | string>,
    variance?: GraphCacheResolver<WithTypename<Revisions_Sizings_Revisions_Aggregate_Fields>, Record<string, never>, WithTypename<Revisions_Sizings_Revisions_Variance_Fields> | string>
  },
  revisions_sizings_revisions_avg_fields?: {
    customer_id?: GraphCacheResolver<WithTypename<Revisions_Sizings_Revisions_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Revisions_Sizings_Revisions_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    well_id?: GraphCacheResolver<WithTypename<Revisions_Sizings_Revisions_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  revisions_sizings_revisions_max_fields?: {
    author_id?: GraphCacheResolver<WithTypename<Revisions_Sizings_Revisions_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    cloned_from_journal_id?: GraphCacheResolver<WithTypename<Revisions_Sizings_Revisions_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Revisions_Sizings_Revisions_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    customer_id?: GraphCacheResolver<WithTypename<Revisions_Sizings_Revisions_Max_Fields>, Record<string, never>, Scalars['Int'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Revisions_Sizings_Revisions_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    hps_location?: GraphCacheResolver<WithTypename<Revisions_Sizings_Revisions_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    id?: GraphCacheResolver<WithTypename<Revisions_Sizings_Revisions_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Revisions_Sizings_Revisions_Max_Fields>, Record<string, never>, Scalars['Int'] | string>,
    installed_scenario_id?: GraphCacheResolver<WithTypename<Revisions_Sizings_Revisions_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    journal_id?: GraphCacheResolver<WithTypename<Revisions_Sizings_Revisions_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    notes?: GraphCacheResolver<WithTypename<Revisions_Sizings_Revisions_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    parent_revision_id?: GraphCacheResolver<WithTypename<Revisions_Sizings_Revisions_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    scenario_order?: GraphCacheResolver<WithTypename<Revisions_Sizings_Revisions_Max_Fields>, Record<string, never>, Array<Scalars['uuid'] | string>>,
    title?: GraphCacheResolver<WithTypename<Revisions_Sizings_Revisions_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Revisions_Sizings_Revisions_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    well_id?: GraphCacheResolver<WithTypename<Revisions_Sizings_Revisions_Max_Fields>, Record<string, never>, Scalars['Int'] | string>
  },
  revisions_sizings_revisions_min_fields?: {
    author_id?: GraphCacheResolver<WithTypename<Revisions_Sizings_Revisions_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    cloned_from_journal_id?: GraphCacheResolver<WithTypename<Revisions_Sizings_Revisions_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Revisions_Sizings_Revisions_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    customer_id?: GraphCacheResolver<WithTypename<Revisions_Sizings_Revisions_Min_Fields>, Record<string, never>, Scalars['Int'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Revisions_Sizings_Revisions_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    hps_location?: GraphCacheResolver<WithTypename<Revisions_Sizings_Revisions_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    id?: GraphCacheResolver<WithTypename<Revisions_Sizings_Revisions_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Revisions_Sizings_Revisions_Min_Fields>, Record<string, never>, Scalars['Int'] | string>,
    installed_scenario_id?: GraphCacheResolver<WithTypename<Revisions_Sizings_Revisions_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    journal_id?: GraphCacheResolver<WithTypename<Revisions_Sizings_Revisions_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    notes?: GraphCacheResolver<WithTypename<Revisions_Sizings_Revisions_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    parent_revision_id?: GraphCacheResolver<WithTypename<Revisions_Sizings_Revisions_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    scenario_order?: GraphCacheResolver<WithTypename<Revisions_Sizings_Revisions_Min_Fields>, Record<string, never>, Array<Scalars['uuid'] | string>>,
    title?: GraphCacheResolver<WithTypename<Revisions_Sizings_Revisions_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Revisions_Sizings_Revisions_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    well_id?: GraphCacheResolver<WithTypename<Revisions_Sizings_Revisions_Min_Fields>, Record<string, never>, Scalars['Int'] | string>
  },
  revisions_sizings_revisions_mutation_response?: {
    affected_rows?: GraphCacheResolver<WithTypename<Revisions_Sizings_Revisions_Mutation_Response>, Record<string, never>, Scalars['Int'] | string>,
    returning?: GraphCacheResolver<WithTypename<Revisions_Sizings_Revisions_Mutation_Response>, Record<string, never>, Array<WithTypename<Revisions_Sizings_Revisions> | string>>
  },
  revisions_sizings_revisions_stddev_fields?: {
    customer_id?: GraphCacheResolver<WithTypename<Revisions_Sizings_Revisions_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Revisions_Sizings_Revisions_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    well_id?: GraphCacheResolver<WithTypename<Revisions_Sizings_Revisions_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  revisions_sizings_revisions_stddev_pop_fields?: {
    customer_id?: GraphCacheResolver<WithTypename<Revisions_Sizings_Revisions_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Revisions_Sizings_Revisions_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    well_id?: GraphCacheResolver<WithTypename<Revisions_Sizings_Revisions_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  revisions_sizings_revisions_stddev_samp_fields?: {
    customer_id?: GraphCacheResolver<WithTypename<Revisions_Sizings_Revisions_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Revisions_Sizings_Revisions_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    well_id?: GraphCacheResolver<WithTypename<Revisions_Sizings_Revisions_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  revisions_sizings_revisions_sum_fields?: {
    customer_id?: GraphCacheResolver<WithTypename<Revisions_Sizings_Revisions_Sum_Fields>, Record<string, never>, Scalars['Int'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Revisions_Sizings_Revisions_Sum_Fields>, Record<string, never>, Scalars['Int'] | string>,
    well_id?: GraphCacheResolver<WithTypename<Revisions_Sizings_Revisions_Sum_Fields>, Record<string, never>, Scalars['Int'] | string>
  },
  revisions_sizings_revisions_var_pop_fields?: {
    customer_id?: GraphCacheResolver<WithTypename<Revisions_Sizings_Revisions_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Revisions_Sizings_Revisions_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    well_id?: GraphCacheResolver<WithTypename<Revisions_Sizings_Revisions_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  revisions_sizings_revisions_var_samp_fields?: {
    customer_id?: GraphCacheResolver<WithTypename<Revisions_Sizings_Revisions_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Revisions_Sizings_Revisions_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    well_id?: GraphCacheResolver<WithTypename<Revisions_Sizings_Revisions_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  revisions_sizings_revisions_variance_fields?: {
    customer_id?: GraphCacheResolver<WithTypename<Revisions_Sizings_Revisions_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Revisions_Sizings_Revisions_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    well_id?: GraphCacheResolver<WithTypename<Revisions_Sizings_Revisions_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  saturated_oil_options?: {
    comment?: GraphCacheResolver<WithTypename<Saturated_Oil_Options>, Record<string, never>, Scalars['String'] | string>,
    value?: GraphCacheResolver<WithTypename<Saturated_Oil_Options>, Record<string, never>, Scalars['String'] | string>
  },
  saturated_oil_options_aggregate?: {
    aggregate?: GraphCacheResolver<WithTypename<Saturated_Oil_Options_Aggregate>, Record<string, never>, WithTypename<Saturated_Oil_Options_Aggregate_Fields> | string>,
    nodes?: GraphCacheResolver<WithTypename<Saturated_Oil_Options_Aggregate>, Record<string, never>, Array<WithTypename<Saturated_Oil_Options> | string>>
  },
  saturated_oil_options_aggregate_fields?: {
    count?: GraphCacheResolver<WithTypename<Saturated_Oil_Options_Aggregate_Fields>, Saturated_Oil_Options_Aggregate_FieldsCountArgs, Scalars['Int'] | string>,
    max?: GraphCacheResolver<WithTypename<Saturated_Oil_Options_Aggregate_Fields>, Record<string, never>, WithTypename<Saturated_Oil_Options_Max_Fields> | string>,
    min?: GraphCacheResolver<WithTypename<Saturated_Oil_Options_Aggregate_Fields>, Record<string, never>, WithTypename<Saturated_Oil_Options_Min_Fields> | string>
  },
  saturated_oil_options_max_fields?: {
    comment?: GraphCacheResolver<WithTypename<Saturated_Oil_Options_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    value?: GraphCacheResolver<WithTypename<Saturated_Oil_Options_Max_Fields>, Record<string, never>, Scalars['String'] | string>
  },
  saturated_oil_options_min_fields?: {
    comment?: GraphCacheResolver<WithTypename<Saturated_Oil_Options_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    value?: GraphCacheResolver<WithTypename<Saturated_Oil_Options_Min_Fields>, Record<string, never>, Scalars['String'] | string>
  },
  saturated_oil_options_mutation_response?: {
    affected_rows?: GraphCacheResolver<WithTypename<Saturated_Oil_Options_Mutation_Response>, Record<string, never>, Scalars['Int'] | string>,
    returning?: GraphCacheResolver<WithTypename<Saturated_Oil_Options_Mutation_Response>, Record<string, never>, Array<WithTypename<Saturated_Oil_Options> | string>>
  },
  sc_equip_xref_downhole_ytool_bypass_tubings?: {
    id?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings>, Record<string, never>, Scalars['uuid'] | string>,
    journal_author_id?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings>, Record<string, never>, Scalars['String'] | string>,
    journal_created_at?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings>, Record<string, never>, Scalars['timestamptz'] | string>,
    journal_deleted_at?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings>, Record<string, never>, Scalars['timestamptz'] | string>,
    journal_updated_at?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings>, Record<string, never>, Scalars['timestamptz'] | string>,
    length_feet?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings>, Record<string, never>, Scalars['numeric'] | string>,
    parent_id?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings>, Record<string, never>, Scalars['uuid'] | string>,
    scenario_equipment_id?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings>, Record<string, never>, Scalars['uuid'] | string>,
    tubing?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings>, Record<string, never>, WithTypename<Tubings> | string>,
    tubing_id?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings>, Record<string, never>, Scalars['uuid'] | string>,
    winning_revision_author_id?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings>, Record<string, never>, Scalars['String'] | string>,
    winning_revision_created_at?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings>, Record<string, never>, Scalars['timestamptz'] | string>,
    winning_revision_deleted_at?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings>, Record<string, never>, Scalars['timestamptz'] | string>,
    winning_revision_id?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings>, Record<string, never>, Scalars['uuid'] | string>,
    winning_revision_parent_id?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings>, Record<string, never>, Scalars['uuid'] | string>,
    winning_revision_updated_at?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings>, Record<string, never>, Scalars['timestamptz'] | string>
  },
  sc_equip_xref_downhole_ytool_bypass_tubings_aggregate?: {
    aggregate?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Aggregate>, Record<string, never>, WithTypename<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Aggregate_Fields> | string>,
    nodes?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Aggregate>, Record<string, never>, Array<WithTypename<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings> | string>>
  },
  sc_equip_xref_downhole_ytool_bypass_tubings_aggregate_fields?: {
    avg?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Aggregate_Fields>, Record<string, never>, WithTypename<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Avg_Fields> | string>,
    count?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Aggregate_Fields>, Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Aggregate_FieldsCountArgs, Scalars['Int'] | string>,
    max?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Aggregate_Fields>, Record<string, never>, WithTypename<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Max_Fields> | string>,
    min?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Aggregate_Fields>, Record<string, never>, WithTypename<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Min_Fields> | string>,
    stddev?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Aggregate_Fields>, Record<string, never>, WithTypename<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Stddev_Fields> | string>,
    stddev_pop?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Aggregate_Fields>, Record<string, never>, WithTypename<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Stddev_Pop_Fields> | string>,
    stddev_samp?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Aggregate_Fields>, Record<string, never>, WithTypename<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Stddev_Samp_Fields> | string>,
    sum?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Aggregate_Fields>, Record<string, never>, WithTypename<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Sum_Fields> | string>,
    var_pop?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Aggregate_Fields>, Record<string, never>, WithTypename<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Var_Pop_Fields> | string>,
    var_samp?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Aggregate_Fields>, Record<string, never>, WithTypename<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Var_Samp_Fields> | string>,
    variance?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Aggregate_Fields>, Record<string, never>, WithTypename<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Variance_Fields> | string>
  },
  sc_equip_xref_downhole_ytool_bypass_tubings_avg_fields?: {
    length_feet?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  sc_equip_xref_downhole_ytool_bypass_tubings_max_fields?: {
    id?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    journal_author_id?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    journal_created_at?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    journal_deleted_at?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    journal_updated_at?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    length_feet?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    parent_id?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    scenario_equipment_id?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    tubing_id?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    winning_revision_author_id?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    winning_revision_created_at?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    winning_revision_deleted_at?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    winning_revision_id?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    winning_revision_parent_id?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    winning_revision_updated_at?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>
  },
  sc_equip_xref_downhole_ytool_bypass_tubings_min_fields?: {
    id?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    journal_author_id?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    journal_created_at?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    journal_deleted_at?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    journal_updated_at?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    length_feet?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    parent_id?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    scenario_equipment_id?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    tubing_id?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    winning_revision_author_id?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    winning_revision_created_at?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    winning_revision_deleted_at?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    winning_revision_id?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    winning_revision_parent_id?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    winning_revision_updated_at?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>
  },
  sc_equip_xref_downhole_ytool_bypass_tubings_stddev_fields?: {
    length_feet?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  sc_equip_xref_downhole_ytool_bypass_tubings_stddev_pop_fields?: {
    length_feet?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  sc_equip_xref_downhole_ytool_bypass_tubings_stddev_samp_fields?: {
    length_feet?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  sc_equip_xref_downhole_ytool_bypass_tubings_sum_fields?: {
    length_feet?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>
  },
  sc_equip_xref_downhole_ytool_bypass_tubings_var_pop_fields?: {
    length_feet?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  sc_equip_xref_downhole_ytool_bypass_tubings_var_samp_fields?: {
    length_feet?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  sc_equip_xref_downhole_ytool_bypass_tubings_variance_fields?: {
    length_feet?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  sc_equip_xref_downhole_ytool_equip_tubings?: {
    id?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings>, Record<string, never>, Scalars['uuid'] | string>,
    journal_author_id?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings>, Record<string, never>, Scalars['String'] | string>,
    journal_created_at?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings>, Record<string, never>, Scalars['timestamptz'] | string>,
    journal_deleted_at?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings>, Record<string, never>, Scalars['timestamptz'] | string>,
    journal_updated_at?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings>, Record<string, never>, Scalars['timestamptz'] | string>,
    length_feet?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings>, Record<string, never>, Scalars['numeric'] | string>,
    parent_id?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings>, Record<string, never>, Scalars['uuid'] | string>,
    scenario_equipment_id?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings>, Record<string, never>, Scalars['uuid'] | string>,
    tubing?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings>, Record<string, never>, WithTypename<Tubings> | string>,
    tubing_id?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings>, Record<string, never>, Scalars['uuid'] | string>,
    winning_revision_author_id?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings>, Record<string, never>, Scalars['String'] | string>,
    winning_revision_created_at?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings>, Record<string, never>, Scalars['timestamptz'] | string>,
    winning_revision_deleted_at?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings>, Record<string, never>, Scalars['timestamptz'] | string>,
    winning_revision_id?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings>, Record<string, never>, Scalars['uuid'] | string>,
    winning_revision_parent_id?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings>, Record<string, never>, Scalars['uuid'] | string>,
    winning_revision_updated_at?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings>, Record<string, never>, Scalars['timestamptz'] | string>
  },
  sc_equip_xref_downhole_ytool_equip_tubings_aggregate?: {
    aggregate?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Aggregate>, Record<string, never>, WithTypename<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Aggregate_Fields> | string>,
    nodes?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Aggregate>, Record<string, never>, Array<WithTypename<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings> | string>>
  },
  sc_equip_xref_downhole_ytool_equip_tubings_aggregate_fields?: {
    avg?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Aggregate_Fields>, Record<string, never>, WithTypename<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Avg_Fields> | string>,
    count?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Aggregate_Fields>, Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Aggregate_FieldsCountArgs, Scalars['Int'] | string>,
    max?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Aggregate_Fields>, Record<string, never>, WithTypename<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Max_Fields> | string>,
    min?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Aggregate_Fields>, Record<string, never>, WithTypename<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Min_Fields> | string>,
    stddev?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Aggregate_Fields>, Record<string, never>, WithTypename<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Stddev_Fields> | string>,
    stddev_pop?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Aggregate_Fields>, Record<string, never>, WithTypename<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Stddev_Pop_Fields> | string>,
    stddev_samp?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Aggregate_Fields>, Record<string, never>, WithTypename<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Stddev_Samp_Fields> | string>,
    sum?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Aggregate_Fields>, Record<string, never>, WithTypename<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Sum_Fields> | string>,
    var_pop?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Aggregate_Fields>, Record<string, never>, WithTypename<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Var_Pop_Fields> | string>,
    var_samp?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Aggregate_Fields>, Record<string, never>, WithTypename<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Var_Samp_Fields> | string>,
    variance?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Aggregate_Fields>, Record<string, never>, WithTypename<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Variance_Fields> | string>
  },
  sc_equip_xref_downhole_ytool_equip_tubings_avg_fields?: {
    length_feet?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  sc_equip_xref_downhole_ytool_equip_tubings_max_fields?: {
    id?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    journal_author_id?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    journal_created_at?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    journal_deleted_at?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    journal_updated_at?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    length_feet?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    parent_id?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    scenario_equipment_id?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    tubing_id?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    winning_revision_author_id?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    winning_revision_created_at?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    winning_revision_deleted_at?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    winning_revision_id?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    winning_revision_parent_id?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    winning_revision_updated_at?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>
  },
  sc_equip_xref_downhole_ytool_equip_tubings_min_fields?: {
    id?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    journal_author_id?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    journal_created_at?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    journal_deleted_at?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    journal_updated_at?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    length_feet?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    parent_id?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    scenario_equipment_id?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    tubing_id?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    winning_revision_author_id?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    winning_revision_created_at?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    winning_revision_deleted_at?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    winning_revision_id?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    winning_revision_parent_id?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    winning_revision_updated_at?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>
  },
  sc_equip_xref_downhole_ytool_equip_tubings_stddev_fields?: {
    length_feet?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  sc_equip_xref_downhole_ytool_equip_tubings_stddev_pop_fields?: {
    length_feet?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  sc_equip_xref_downhole_ytool_equip_tubings_stddev_samp_fields?: {
    length_feet?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  sc_equip_xref_downhole_ytool_equip_tubings_sum_fields?: {
    length_feet?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>
  },
  sc_equip_xref_downhole_ytool_equip_tubings_var_pop_fields?: {
    length_feet?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  sc_equip_xref_downhole_ytool_equip_tubings_var_samp_fields?: {
    length_feet?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  sc_equip_xref_downhole_ytool_equip_tubings_variance_fields?: {
    length_feet?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  sc_equip_xref_uphole_ytool_bypass_tubings?: {
    id?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings>, Record<string, never>, Scalars['uuid'] | string>,
    journal_author_id?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings>, Record<string, never>, Scalars['String'] | string>,
    journal_created_at?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings>, Record<string, never>, Scalars['timestamptz'] | string>,
    journal_deleted_at?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings>, Record<string, never>, Scalars['timestamptz'] | string>,
    journal_updated_at?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings>, Record<string, never>, Scalars['timestamptz'] | string>,
    length_feet?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings>, Record<string, never>, Scalars['numeric'] | string>,
    parent_id?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings>, Record<string, never>, Scalars['uuid'] | string>,
    scenario_equipment_id?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings>, Record<string, never>, Scalars['uuid'] | string>,
    tubing?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings>, Record<string, never>, WithTypename<Tubings> | string>,
    tubing_id?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings>, Record<string, never>, Scalars['uuid'] | string>,
    winning_revision_author_id?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings>, Record<string, never>, Scalars['String'] | string>,
    winning_revision_created_at?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings>, Record<string, never>, Scalars['timestamptz'] | string>,
    winning_revision_deleted_at?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings>, Record<string, never>, Scalars['timestamptz'] | string>,
    winning_revision_id?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings>, Record<string, never>, Scalars['uuid'] | string>,
    winning_revision_parent_id?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings>, Record<string, never>, Scalars['uuid'] | string>,
    winning_revision_updated_at?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings>, Record<string, never>, Scalars['timestamptz'] | string>
  },
  sc_equip_xref_uphole_ytool_bypass_tubings_aggregate?: {
    aggregate?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Aggregate>, Record<string, never>, WithTypename<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Aggregate_Fields> | string>,
    nodes?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Aggregate>, Record<string, never>, Array<WithTypename<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings> | string>>
  },
  sc_equip_xref_uphole_ytool_bypass_tubings_aggregate_fields?: {
    avg?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Aggregate_Fields>, Record<string, never>, WithTypename<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Avg_Fields> | string>,
    count?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Aggregate_Fields>, Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Aggregate_FieldsCountArgs, Scalars['Int'] | string>,
    max?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Aggregate_Fields>, Record<string, never>, WithTypename<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Max_Fields> | string>,
    min?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Aggregate_Fields>, Record<string, never>, WithTypename<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Min_Fields> | string>,
    stddev?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Aggregate_Fields>, Record<string, never>, WithTypename<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Stddev_Fields> | string>,
    stddev_pop?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Aggregate_Fields>, Record<string, never>, WithTypename<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Stddev_Pop_Fields> | string>,
    stddev_samp?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Aggregate_Fields>, Record<string, never>, WithTypename<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Stddev_Samp_Fields> | string>,
    sum?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Aggregate_Fields>, Record<string, never>, WithTypename<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Sum_Fields> | string>,
    var_pop?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Aggregate_Fields>, Record<string, never>, WithTypename<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Var_Pop_Fields> | string>,
    var_samp?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Aggregate_Fields>, Record<string, never>, WithTypename<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Var_Samp_Fields> | string>,
    variance?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Aggregate_Fields>, Record<string, never>, WithTypename<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Variance_Fields> | string>
  },
  sc_equip_xref_uphole_ytool_bypass_tubings_avg_fields?: {
    length_feet?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  sc_equip_xref_uphole_ytool_bypass_tubings_max_fields?: {
    id?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    journal_author_id?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    journal_created_at?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    journal_deleted_at?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    journal_updated_at?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    length_feet?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    parent_id?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    scenario_equipment_id?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    tubing_id?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    winning_revision_author_id?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    winning_revision_created_at?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    winning_revision_deleted_at?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    winning_revision_id?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    winning_revision_parent_id?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    winning_revision_updated_at?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>
  },
  sc_equip_xref_uphole_ytool_bypass_tubings_min_fields?: {
    id?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    journal_author_id?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    journal_created_at?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    journal_deleted_at?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    journal_updated_at?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    length_feet?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    parent_id?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    scenario_equipment_id?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    tubing_id?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    winning_revision_author_id?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    winning_revision_created_at?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    winning_revision_deleted_at?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    winning_revision_id?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    winning_revision_parent_id?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    winning_revision_updated_at?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>
  },
  sc_equip_xref_uphole_ytool_bypass_tubings_stddev_fields?: {
    length_feet?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  sc_equip_xref_uphole_ytool_bypass_tubings_stddev_pop_fields?: {
    length_feet?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  sc_equip_xref_uphole_ytool_bypass_tubings_stddev_samp_fields?: {
    length_feet?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  sc_equip_xref_uphole_ytool_bypass_tubings_sum_fields?: {
    length_feet?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>
  },
  sc_equip_xref_uphole_ytool_bypass_tubings_var_pop_fields?: {
    length_feet?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  sc_equip_xref_uphole_ytool_bypass_tubings_var_samp_fields?: {
    length_feet?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  sc_equip_xref_uphole_ytool_bypass_tubings_variance_fields?: {
    length_feet?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  sc_equip_xref_uphole_ytool_equip_tubings?: {
    id?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings>, Record<string, never>, Scalars['uuid'] | string>,
    journal_author_id?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings>, Record<string, never>, Scalars['String'] | string>,
    journal_created_at?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings>, Record<string, never>, Scalars['timestamptz'] | string>,
    journal_deleted_at?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings>, Record<string, never>, Scalars['timestamptz'] | string>,
    journal_updated_at?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings>, Record<string, never>, Scalars['timestamptz'] | string>,
    length_feet?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings>, Record<string, never>, Scalars['numeric'] | string>,
    parent_id?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings>, Record<string, never>, Scalars['uuid'] | string>,
    scenario_equipment_id?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings>, Record<string, never>, Scalars['uuid'] | string>,
    tubing?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings>, Record<string, never>, WithTypename<Tubings> | string>,
    tubing_id?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings>, Record<string, never>, Scalars['uuid'] | string>,
    winning_revision_author_id?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings>, Record<string, never>, Scalars['String'] | string>,
    winning_revision_created_at?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings>, Record<string, never>, Scalars['timestamptz'] | string>,
    winning_revision_deleted_at?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings>, Record<string, never>, Scalars['timestamptz'] | string>,
    winning_revision_id?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings>, Record<string, never>, Scalars['uuid'] | string>,
    winning_revision_parent_id?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings>, Record<string, never>, Scalars['uuid'] | string>,
    winning_revision_updated_at?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings>, Record<string, never>, Scalars['timestamptz'] | string>
  },
  sc_equip_xref_uphole_ytool_equip_tubings_aggregate?: {
    aggregate?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Aggregate>, Record<string, never>, WithTypename<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Aggregate_Fields> | string>,
    nodes?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Aggregate>, Record<string, never>, Array<WithTypename<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings> | string>>
  },
  sc_equip_xref_uphole_ytool_equip_tubings_aggregate_fields?: {
    avg?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Aggregate_Fields>, Record<string, never>, WithTypename<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Avg_Fields> | string>,
    count?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Aggregate_Fields>, Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Aggregate_FieldsCountArgs, Scalars['Int'] | string>,
    max?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Aggregate_Fields>, Record<string, never>, WithTypename<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Max_Fields> | string>,
    min?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Aggregate_Fields>, Record<string, never>, WithTypename<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Min_Fields> | string>,
    stddev?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Aggregate_Fields>, Record<string, never>, WithTypename<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Stddev_Fields> | string>,
    stddev_pop?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Aggregate_Fields>, Record<string, never>, WithTypename<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Stddev_Pop_Fields> | string>,
    stddev_samp?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Aggregate_Fields>, Record<string, never>, WithTypename<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Stddev_Samp_Fields> | string>,
    sum?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Aggregate_Fields>, Record<string, never>, WithTypename<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Sum_Fields> | string>,
    var_pop?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Aggregate_Fields>, Record<string, never>, WithTypename<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Var_Pop_Fields> | string>,
    var_samp?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Aggregate_Fields>, Record<string, never>, WithTypename<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Var_Samp_Fields> | string>,
    variance?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Aggregate_Fields>, Record<string, never>, WithTypename<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Variance_Fields> | string>
  },
  sc_equip_xref_uphole_ytool_equip_tubings_avg_fields?: {
    length_feet?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  sc_equip_xref_uphole_ytool_equip_tubings_max_fields?: {
    id?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    journal_author_id?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    journal_created_at?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    journal_deleted_at?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    journal_updated_at?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    length_feet?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    parent_id?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    scenario_equipment_id?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    tubing_id?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    winning_revision_author_id?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    winning_revision_created_at?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    winning_revision_deleted_at?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    winning_revision_id?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    winning_revision_parent_id?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    winning_revision_updated_at?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>
  },
  sc_equip_xref_uphole_ytool_equip_tubings_min_fields?: {
    id?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    journal_author_id?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    journal_created_at?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    journal_deleted_at?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    journal_updated_at?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    length_feet?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    parent_id?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    scenario_equipment_id?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    tubing_id?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    winning_revision_author_id?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    winning_revision_created_at?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    winning_revision_deleted_at?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    winning_revision_id?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    winning_revision_parent_id?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    winning_revision_updated_at?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>
  },
  sc_equip_xref_uphole_ytool_equip_tubings_stddev_fields?: {
    length_feet?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  sc_equip_xref_uphole_ytool_equip_tubings_stddev_pop_fields?: {
    length_feet?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  sc_equip_xref_uphole_ytool_equip_tubings_stddev_samp_fields?: {
    length_feet?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  sc_equip_xref_uphole_ytool_equip_tubings_sum_fields?: {
    length_feet?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>
  },
  sc_equip_xref_uphole_ytool_equip_tubings_var_pop_fields?: {
    length_feet?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  sc_equip_xref_uphole_ytool_equip_tubings_var_samp_fields?: {
    length_feet?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  sc_equip_xref_uphole_ytool_equip_tubings_variance_fields?: {
    length_feet?: GraphCacheResolver<WithTypename<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  scenario_correlations?: {
    bubble_point?: GraphCacheResolver<WithTypename<Scenario_Correlations>, Record<string, never>, Scalars['String'] | string>,
    casing_apply_hazen_williams_correction?: GraphCacheResolver<WithTypename<Scenario_Correlations>, Record<string, never>, Scalars['Boolean'] | string>,
    casing_flow?: GraphCacheResolver<WithTypename<Scenario_Correlations>, Record<string, never>, Scalars['String'] | string>,
    casing_griffith_wallis?: GraphCacheResolver<WithTypename<Scenario_Correlations>, Record<string, never>, Scalars['Boolean'] | string>,
    casing_hazen_williams_coefficient?: GraphCacheResolver<WithTypename<Scenario_Correlations>, Record<string, never>, Scalars['numeric'] | string>,
    casing_palmer_correction?: GraphCacheResolver<WithTypename<Scenario_Correlations>, Record<string, never>, Scalars['Boolean'] | string>,
    casing_roughness_inches?: GraphCacheResolver<WithTypename<Scenario_Correlations>, Record<string, never>, Scalars['numeric'] | string>,
    dead_oil?: GraphCacheResolver<WithTypename<Scenario_Correlations>, Record<string, never>, Scalars['String'] | string>,
    friction_loss?: GraphCacheResolver<WithTypename<Scenario_Correlations>, Record<string, never>, Scalars['String'] | string>,
    gas_compressibility?: GraphCacheResolver<WithTypename<Scenario_Correlations>, Record<string, never>, Scalars['String'] | string>,
    gas_viscosity?: GraphCacheResolver<WithTypename<Scenario_Correlations>, Record<string, never>, Scalars['String'] | string>,
    id?: GraphCacheResolver<WithTypename<Scenario_Correlations>, Record<string, never>, Scalars['uuid'] | string>,
    journal_author_id?: GraphCacheResolver<WithTypename<Scenario_Correlations>, Record<string, never>, Scalars['String'] | string>,
    journal_created_at?: GraphCacheResolver<WithTypename<Scenario_Correlations>, Record<string, never>, Scalars['timestamptz'] | string>,
    journal_deleted_at?: GraphCacheResolver<WithTypename<Scenario_Correlations>, Record<string, never>, Scalars['timestamptz'] | string>,
    journal_updated_at?: GraphCacheResolver<WithTypename<Scenario_Correlations>, Record<string, never>, Scalars['timestamptz'] | string>,
    natural_gas_separation?: GraphCacheResolver<WithTypename<Scenario_Correlations>, Record<string, never>, Scalars['String'] | string>,
    oil_density?: GraphCacheResolver<WithTypename<Scenario_Correlations>, Record<string, never>, Scalars['String'] | string>,
    oil_volume_factor_saturated?: GraphCacheResolver<WithTypename<Scenario_Correlations>, Record<string, never>, Scalars['String'] | string>,
    oil_volume_factor_undersaturated?: GraphCacheResolver<WithTypename<Scenario_Correlations>, Record<string, never>, Scalars['String'] | string>,
    parent_id?: GraphCacheResolver<WithTypename<Scenario_Correlations>, Record<string, never>, Scalars['uuid'] | string>,
    salinity_ppm?: GraphCacheResolver<WithTypename<Scenario_Correlations>, Record<string, never>, Scalars['numeric'] | string>,
    saturated_oil?: GraphCacheResolver<WithTypename<Scenario_Correlations>, Record<string, never>, Scalars['String'] | string>,
    solution_gor?: GraphCacheResolver<WithTypename<Scenario_Correlations>, Record<string, never>, Scalars['String'] | string>,
    tdh_tuning_factor_ratio?: GraphCacheResolver<WithTypename<Scenario_Correlations>, Record<string, never>, Scalars['numeric'] | string>,
    tubing_apply_hazen_williams_correction?: GraphCacheResolver<WithTypename<Scenario_Correlations>, Record<string, never>, Scalars['Boolean'] | string>,
    tubing_flow?: GraphCacheResolver<WithTypename<Scenario_Correlations>, Record<string, never>, Scalars['String'] | string>,
    tubing_griffith_wallis?: GraphCacheResolver<WithTypename<Scenario_Correlations>, Record<string, never>, Scalars['Boolean'] | string>,
    tubing_hazen_williams_coefficient?: GraphCacheResolver<WithTypename<Scenario_Correlations>, Record<string, never>, Scalars['numeric'] | string>,
    tubing_palmer_correction?: GraphCacheResolver<WithTypename<Scenario_Correlations>, Record<string, never>, Scalars['Boolean'] | string>,
    tubing_roughness_inches?: GraphCacheResolver<WithTypename<Scenario_Correlations>, Record<string, never>, Scalars['numeric'] | string>,
    under_saturated_oil?: GraphCacheResolver<WithTypename<Scenario_Correlations>, Record<string, never>, Scalars['String'] | string>,
    water_density?: GraphCacheResolver<WithTypename<Scenario_Correlations>, Record<string, never>, Scalars['String'] | string>,
    water_solution_gas?: GraphCacheResolver<WithTypename<Scenario_Correlations>, Record<string, never>, Scalars['String'] | string>,
    water_viscosity?: GraphCacheResolver<WithTypename<Scenario_Correlations>, Record<string, never>, Scalars['String'] | string>,
    water_volume_factor?: GraphCacheResolver<WithTypename<Scenario_Correlations>, Record<string, never>, Scalars['String'] | string>,
    winning_revision_author_id?: GraphCacheResolver<WithTypename<Scenario_Correlations>, Record<string, never>, Scalars['String'] | string>,
    winning_revision_created_at?: GraphCacheResolver<WithTypename<Scenario_Correlations>, Record<string, never>, Scalars['timestamptz'] | string>,
    winning_revision_deleted_at?: GraphCacheResolver<WithTypename<Scenario_Correlations>, Record<string, never>, Scalars['timestamptz'] | string>,
    winning_revision_id?: GraphCacheResolver<WithTypename<Scenario_Correlations>, Record<string, never>, Scalars['uuid'] | string>,
    winning_revision_parent_id?: GraphCacheResolver<WithTypename<Scenario_Correlations>, Record<string, never>, Scalars['uuid'] | string>,
    winning_revision_updated_at?: GraphCacheResolver<WithTypename<Scenario_Correlations>, Record<string, never>, Scalars['timestamptz'] | string>
  },
  scenario_correlations_aggregate?: {
    aggregate?: GraphCacheResolver<WithTypename<Scenario_Correlations_Aggregate>, Record<string, never>, WithTypename<Scenario_Correlations_Aggregate_Fields> | string>,
    nodes?: GraphCacheResolver<WithTypename<Scenario_Correlations_Aggregate>, Record<string, never>, Array<WithTypename<Scenario_Correlations> | string>>
  },
  scenario_correlations_aggregate_fields?: {
    avg?: GraphCacheResolver<WithTypename<Scenario_Correlations_Aggregate_Fields>, Record<string, never>, WithTypename<Scenario_Correlations_Avg_Fields> | string>,
    count?: GraphCacheResolver<WithTypename<Scenario_Correlations_Aggregate_Fields>, Scenario_Correlations_Aggregate_FieldsCountArgs, Scalars['Int'] | string>,
    max?: GraphCacheResolver<WithTypename<Scenario_Correlations_Aggregate_Fields>, Record<string, never>, WithTypename<Scenario_Correlations_Max_Fields> | string>,
    min?: GraphCacheResolver<WithTypename<Scenario_Correlations_Aggregate_Fields>, Record<string, never>, WithTypename<Scenario_Correlations_Min_Fields> | string>,
    stddev?: GraphCacheResolver<WithTypename<Scenario_Correlations_Aggregate_Fields>, Record<string, never>, WithTypename<Scenario_Correlations_Stddev_Fields> | string>,
    stddev_pop?: GraphCacheResolver<WithTypename<Scenario_Correlations_Aggregate_Fields>, Record<string, never>, WithTypename<Scenario_Correlations_Stddev_Pop_Fields> | string>,
    stddev_samp?: GraphCacheResolver<WithTypename<Scenario_Correlations_Aggregate_Fields>, Record<string, never>, WithTypename<Scenario_Correlations_Stddev_Samp_Fields> | string>,
    sum?: GraphCacheResolver<WithTypename<Scenario_Correlations_Aggregate_Fields>, Record<string, never>, WithTypename<Scenario_Correlations_Sum_Fields> | string>,
    var_pop?: GraphCacheResolver<WithTypename<Scenario_Correlations_Aggregate_Fields>, Record<string, never>, WithTypename<Scenario_Correlations_Var_Pop_Fields> | string>,
    var_samp?: GraphCacheResolver<WithTypename<Scenario_Correlations_Aggregate_Fields>, Record<string, never>, WithTypename<Scenario_Correlations_Var_Samp_Fields> | string>,
    variance?: GraphCacheResolver<WithTypename<Scenario_Correlations_Aggregate_Fields>, Record<string, never>, WithTypename<Scenario_Correlations_Variance_Fields> | string>
  },
  scenario_correlations_avg_fields?: {
    casing_hazen_williams_coefficient?: GraphCacheResolver<WithTypename<Scenario_Correlations_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    casing_roughness_inches?: GraphCacheResolver<WithTypename<Scenario_Correlations_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    salinity_ppm?: GraphCacheResolver<WithTypename<Scenario_Correlations_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    tdh_tuning_factor_ratio?: GraphCacheResolver<WithTypename<Scenario_Correlations_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    tubing_hazen_williams_coefficient?: GraphCacheResolver<WithTypename<Scenario_Correlations_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    tubing_roughness_inches?: GraphCacheResolver<WithTypename<Scenario_Correlations_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  scenario_correlations_max_fields?: {
    bubble_point?: GraphCacheResolver<WithTypename<Scenario_Correlations_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    casing_flow?: GraphCacheResolver<WithTypename<Scenario_Correlations_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    casing_hazen_williams_coefficient?: GraphCacheResolver<WithTypename<Scenario_Correlations_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    casing_roughness_inches?: GraphCacheResolver<WithTypename<Scenario_Correlations_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    dead_oil?: GraphCacheResolver<WithTypename<Scenario_Correlations_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    friction_loss?: GraphCacheResolver<WithTypename<Scenario_Correlations_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    gas_compressibility?: GraphCacheResolver<WithTypename<Scenario_Correlations_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    gas_viscosity?: GraphCacheResolver<WithTypename<Scenario_Correlations_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    id?: GraphCacheResolver<WithTypename<Scenario_Correlations_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    journal_author_id?: GraphCacheResolver<WithTypename<Scenario_Correlations_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    journal_created_at?: GraphCacheResolver<WithTypename<Scenario_Correlations_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    journal_deleted_at?: GraphCacheResolver<WithTypename<Scenario_Correlations_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    journal_updated_at?: GraphCacheResolver<WithTypename<Scenario_Correlations_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    natural_gas_separation?: GraphCacheResolver<WithTypename<Scenario_Correlations_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    oil_density?: GraphCacheResolver<WithTypename<Scenario_Correlations_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    oil_volume_factor_saturated?: GraphCacheResolver<WithTypename<Scenario_Correlations_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    oil_volume_factor_undersaturated?: GraphCacheResolver<WithTypename<Scenario_Correlations_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    parent_id?: GraphCacheResolver<WithTypename<Scenario_Correlations_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    salinity_ppm?: GraphCacheResolver<WithTypename<Scenario_Correlations_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    saturated_oil?: GraphCacheResolver<WithTypename<Scenario_Correlations_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    solution_gor?: GraphCacheResolver<WithTypename<Scenario_Correlations_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    tdh_tuning_factor_ratio?: GraphCacheResolver<WithTypename<Scenario_Correlations_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    tubing_flow?: GraphCacheResolver<WithTypename<Scenario_Correlations_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    tubing_hazen_williams_coefficient?: GraphCacheResolver<WithTypename<Scenario_Correlations_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    tubing_roughness_inches?: GraphCacheResolver<WithTypename<Scenario_Correlations_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    under_saturated_oil?: GraphCacheResolver<WithTypename<Scenario_Correlations_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    water_density?: GraphCacheResolver<WithTypename<Scenario_Correlations_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    water_solution_gas?: GraphCacheResolver<WithTypename<Scenario_Correlations_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    water_viscosity?: GraphCacheResolver<WithTypename<Scenario_Correlations_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    water_volume_factor?: GraphCacheResolver<WithTypename<Scenario_Correlations_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    winning_revision_author_id?: GraphCacheResolver<WithTypename<Scenario_Correlations_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    winning_revision_created_at?: GraphCacheResolver<WithTypename<Scenario_Correlations_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    winning_revision_deleted_at?: GraphCacheResolver<WithTypename<Scenario_Correlations_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    winning_revision_id?: GraphCacheResolver<WithTypename<Scenario_Correlations_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    winning_revision_parent_id?: GraphCacheResolver<WithTypename<Scenario_Correlations_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    winning_revision_updated_at?: GraphCacheResolver<WithTypename<Scenario_Correlations_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>
  },
  scenario_correlations_min_fields?: {
    bubble_point?: GraphCacheResolver<WithTypename<Scenario_Correlations_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    casing_flow?: GraphCacheResolver<WithTypename<Scenario_Correlations_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    casing_hazen_williams_coefficient?: GraphCacheResolver<WithTypename<Scenario_Correlations_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    casing_roughness_inches?: GraphCacheResolver<WithTypename<Scenario_Correlations_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    dead_oil?: GraphCacheResolver<WithTypename<Scenario_Correlations_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    friction_loss?: GraphCacheResolver<WithTypename<Scenario_Correlations_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    gas_compressibility?: GraphCacheResolver<WithTypename<Scenario_Correlations_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    gas_viscosity?: GraphCacheResolver<WithTypename<Scenario_Correlations_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    id?: GraphCacheResolver<WithTypename<Scenario_Correlations_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    journal_author_id?: GraphCacheResolver<WithTypename<Scenario_Correlations_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    journal_created_at?: GraphCacheResolver<WithTypename<Scenario_Correlations_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    journal_deleted_at?: GraphCacheResolver<WithTypename<Scenario_Correlations_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    journal_updated_at?: GraphCacheResolver<WithTypename<Scenario_Correlations_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    natural_gas_separation?: GraphCacheResolver<WithTypename<Scenario_Correlations_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    oil_density?: GraphCacheResolver<WithTypename<Scenario_Correlations_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    oil_volume_factor_saturated?: GraphCacheResolver<WithTypename<Scenario_Correlations_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    oil_volume_factor_undersaturated?: GraphCacheResolver<WithTypename<Scenario_Correlations_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    parent_id?: GraphCacheResolver<WithTypename<Scenario_Correlations_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    salinity_ppm?: GraphCacheResolver<WithTypename<Scenario_Correlations_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    saturated_oil?: GraphCacheResolver<WithTypename<Scenario_Correlations_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    solution_gor?: GraphCacheResolver<WithTypename<Scenario_Correlations_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    tdh_tuning_factor_ratio?: GraphCacheResolver<WithTypename<Scenario_Correlations_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    tubing_flow?: GraphCacheResolver<WithTypename<Scenario_Correlations_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    tubing_hazen_williams_coefficient?: GraphCacheResolver<WithTypename<Scenario_Correlations_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    tubing_roughness_inches?: GraphCacheResolver<WithTypename<Scenario_Correlations_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    under_saturated_oil?: GraphCacheResolver<WithTypename<Scenario_Correlations_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    water_density?: GraphCacheResolver<WithTypename<Scenario_Correlations_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    water_solution_gas?: GraphCacheResolver<WithTypename<Scenario_Correlations_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    water_viscosity?: GraphCacheResolver<WithTypename<Scenario_Correlations_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    water_volume_factor?: GraphCacheResolver<WithTypename<Scenario_Correlations_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    winning_revision_author_id?: GraphCacheResolver<WithTypename<Scenario_Correlations_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    winning_revision_created_at?: GraphCacheResolver<WithTypename<Scenario_Correlations_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    winning_revision_deleted_at?: GraphCacheResolver<WithTypename<Scenario_Correlations_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    winning_revision_id?: GraphCacheResolver<WithTypename<Scenario_Correlations_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    winning_revision_parent_id?: GraphCacheResolver<WithTypename<Scenario_Correlations_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    winning_revision_updated_at?: GraphCacheResolver<WithTypename<Scenario_Correlations_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>
  },
  scenario_correlations_stddev_fields?: {
    casing_hazen_williams_coefficient?: GraphCacheResolver<WithTypename<Scenario_Correlations_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    casing_roughness_inches?: GraphCacheResolver<WithTypename<Scenario_Correlations_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    salinity_ppm?: GraphCacheResolver<WithTypename<Scenario_Correlations_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    tdh_tuning_factor_ratio?: GraphCacheResolver<WithTypename<Scenario_Correlations_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    tubing_hazen_williams_coefficient?: GraphCacheResolver<WithTypename<Scenario_Correlations_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    tubing_roughness_inches?: GraphCacheResolver<WithTypename<Scenario_Correlations_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  scenario_correlations_stddev_pop_fields?: {
    casing_hazen_williams_coefficient?: GraphCacheResolver<WithTypename<Scenario_Correlations_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    casing_roughness_inches?: GraphCacheResolver<WithTypename<Scenario_Correlations_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    salinity_ppm?: GraphCacheResolver<WithTypename<Scenario_Correlations_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    tdh_tuning_factor_ratio?: GraphCacheResolver<WithTypename<Scenario_Correlations_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    tubing_hazen_williams_coefficient?: GraphCacheResolver<WithTypename<Scenario_Correlations_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    tubing_roughness_inches?: GraphCacheResolver<WithTypename<Scenario_Correlations_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  scenario_correlations_stddev_samp_fields?: {
    casing_hazen_williams_coefficient?: GraphCacheResolver<WithTypename<Scenario_Correlations_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    casing_roughness_inches?: GraphCacheResolver<WithTypename<Scenario_Correlations_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    salinity_ppm?: GraphCacheResolver<WithTypename<Scenario_Correlations_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    tdh_tuning_factor_ratio?: GraphCacheResolver<WithTypename<Scenario_Correlations_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    tubing_hazen_williams_coefficient?: GraphCacheResolver<WithTypename<Scenario_Correlations_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    tubing_roughness_inches?: GraphCacheResolver<WithTypename<Scenario_Correlations_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  scenario_correlations_sum_fields?: {
    casing_hazen_williams_coefficient?: GraphCacheResolver<WithTypename<Scenario_Correlations_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    casing_roughness_inches?: GraphCacheResolver<WithTypename<Scenario_Correlations_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    salinity_ppm?: GraphCacheResolver<WithTypename<Scenario_Correlations_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    tdh_tuning_factor_ratio?: GraphCacheResolver<WithTypename<Scenario_Correlations_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    tubing_hazen_williams_coefficient?: GraphCacheResolver<WithTypename<Scenario_Correlations_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    tubing_roughness_inches?: GraphCacheResolver<WithTypename<Scenario_Correlations_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>
  },
  scenario_correlations_var_pop_fields?: {
    casing_hazen_williams_coefficient?: GraphCacheResolver<WithTypename<Scenario_Correlations_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    casing_roughness_inches?: GraphCacheResolver<WithTypename<Scenario_Correlations_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    salinity_ppm?: GraphCacheResolver<WithTypename<Scenario_Correlations_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    tdh_tuning_factor_ratio?: GraphCacheResolver<WithTypename<Scenario_Correlations_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    tubing_hazen_williams_coefficient?: GraphCacheResolver<WithTypename<Scenario_Correlations_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    tubing_roughness_inches?: GraphCacheResolver<WithTypename<Scenario_Correlations_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  scenario_correlations_var_samp_fields?: {
    casing_hazen_williams_coefficient?: GraphCacheResolver<WithTypename<Scenario_Correlations_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    casing_roughness_inches?: GraphCacheResolver<WithTypename<Scenario_Correlations_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    salinity_ppm?: GraphCacheResolver<WithTypename<Scenario_Correlations_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    tdh_tuning_factor_ratio?: GraphCacheResolver<WithTypename<Scenario_Correlations_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    tubing_hazen_williams_coefficient?: GraphCacheResolver<WithTypename<Scenario_Correlations_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    tubing_roughness_inches?: GraphCacheResolver<WithTypename<Scenario_Correlations_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  scenario_correlations_variance_fields?: {
    casing_hazen_williams_coefficient?: GraphCacheResolver<WithTypename<Scenario_Correlations_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    casing_roughness_inches?: GraphCacheResolver<WithTypename<Scenario_Correlations_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    salinity_ppm?: GraphCacheResolver<WithTypename<Scenario_Correlations_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    tdh_tuning_factor_ratio?: GraphCacheResolver<WithTypename<Scenario_Correlations_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    tubing_hazen_williams_coefficient?: GraphCacheResolver<WithTypename<Scenario_Correlations_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    tubing_roughness_inches?: GraphCacheResolver<WithTypename<Scenario_Correlations_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  scenario_equipment?: {
    bolt_on_discharge?: GraphCacheResolver<WithTypename<Scenario_Equipment>, Record<string, never>, WithTypename<Bolt_On_Discharges> | string>,
    bolt_on_discharge_id?: GraphCacheResolver<WithTypename<Scenario_Equipment>, Record<string, never>, Scalars['uuid'] | string>,
    cables_order?: GraphCacheResolver<WithTypename<Scenario_Equipment>, Record<string, never>, Array<Scalars['uuid'] | string>>,
    down_trans_id?: GraphCacheResolver<WithTypename<Scenario_Equipment>, Record<string, never>, Scalars['uuid'] | string>,
    downhole_xref_y_tool_bypass_tubings?: GraphCacheResolver<WithTypename<Scenario_Equipment>, Scenario_EquipmentDownhole_Xref_Y_Tool_Bypass_TubingsArgs, Array<WithTypename<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings> | string>>,
    downhole_xref_y_tool_bypass_tubings_aggregate?: GraphCacheResolver<WithTypename<Scenario_Equipment>, Scenario_EquipmentDownhole_Xref_Y_Tool_Bypass_Tubings_AggregateArgs, WithTypename<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Aggregate> | string>,
    downhole_xref_y_tool_equipment_tubings?: GraphCacheResolver<WithTypename<Scenario_Equipment>, Scenario_EquipmentDownhole_Xref_Y_Tool_Equipment_TubingsArgs, Array<WithTypename<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings> | string>>,
    downhole_xref_y_tool_equipment_tubings_aggregate?: GraphCacheResolver<WithTypename<Scenario_Equipment>, Scenario_EquipmentDownhole_Xref_Y_Tool_Equipment_Tubings_AggregateArgs, WithTypename<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Aggregate> | string>,
    downhole_y_tool?: GraphCacheResolver<WithTypename<Scenario_Equipment>, Record<string, never>, WithTypename<Y_Tools> | string>,
    downhole_y_tool_bypass_tubing_order?: GraphCacheResolver<WithTypename<Scenario_Equipment>, Record<string, never>, Array<Scalars['uuid'] | string>>,
    downhole_y_tool_equipment_tubing_order?: GraphCacheResolver<WithTypename<Scenario_Equipment>, Record<string, never>, Array<Scalars['uuid'] | string>>,
    downhole_y_tool_id?: GraphCacheResolver<WithTypename<Scenario_Equipment>, Record<string, never>, Scalars['uuid'] | string>,
    has_lower_equip_stack?: GraphCacheResolver<WithTypename<Scenario_Equipment>, Record<string, never>, Scalars['Boolean'] | string>,
    id?: GraphCacheResolver<WithTypename<Scenario_Equipment>, Record<string, never>, Scalars['uuid'] | string>,
    include_y_tool?: GraphCacheResolver<WithTypename<Scenario_Equipment>, Record<string, never>, Scalars['Boolean'] | string>,
    intakes_order?: GraphCacheResolver<WithTypename<Scenario_Equipment>, Record<string, never>, Array<Scalars['uuid'] | string>>,
    journal_author_id?: GraphCacheResolver<WithTypename<Scenario_Equipment>, Record<string, never>, Scalars['String'] | string>,
    journal_created_at?: GraphCacheResolver<WithTypename<Scenario_Equipment>, Record<string, never>, Scalars['timestamptz'] | string>,
    journal_deleted_at?: GraphCacheResolver<WithTypename<Scenario_Equipment>, Record<string, never>, Scalars['timestamptz'] | string>,
    journal_updated_at?: GraphCacheResolver<WithTypename<Scenario_Equipment>, Record<string, never>, Scalars['timestamptz'] | string>,
    lower_bolt_on_discharge?: GraphCacheResolver<WithTypename<Scenario_Equipment>, Record<string, never>, WithTypename<Bolt_On_Discharges> | string>,
    lower_bolt_on_discharge_id?: GraphCacheResolver<WithTypename<Scenario_Equipment>, Record<string, never>, Scalars['uuid'] | string>,
    lower_cables_order?: GraphCacheResolver<WithTypename<Scenario_Equipment>, Record<string, never>, Array<Scalars['uuid'] | string>>,
    lower_intakes_order?: GraphCacheResolver<WithTypename<Scenario_Equipment>, Record<string, never>, Array<Scalars['uuid'] | string>>,
    lower_mle?: GraphCacheResolver<WithTypename<Scenario_Equipment>, Record<string, never>, WithTypename<Motor_Lead_Extensions> | string>,
    lower_mle_id?: GraphCacheResolver<WithTypename<Scenario_Equipment>, Record<string, never>, Scalars['uuid'] | string>,
    lower_motor?: GraphCacheResolver<WithTypename<Scenario_Equipment>, Record<string, never>, WithTypename<Motors> | string>,
    lower_motor_id?: GraphCacheResolver<WithTypename<Scenario_Equipment>, Record<string, never>, Scalars['uuid'] | string>,
    lower_pumps_order?: GraphCacheResolver<WithTypename<Scenario_Equipment>, Record<string, never>, Array<Scalars['uuid'] | string>>,
    lower_seal_motor_oil?: GraphCacheResolver<WithTypename<Scenario_Equipment>, Record<string, never>, WithTypename<Seal_Motor_Oil> | string>,
    lower_seal_motor_oil_id?: GraphCacheResolver<WithTypename<Scenario_Equipment>, Record<string, never>, Scalars['uuid'] | string>,
    lower_seals_order?: GraphCacheResolver<WithTypename<Scenario_Equipment>, Record<string, never>, Array<Scalars['uuid'] | string>>,
    lower_sensor?: GraphCacheResolver<WithTypename<Scenario_Equipment>, Record<string, never>, WithTypename<Sensors> | string>,
    lower_sensor_id?: GraphCacheResolver<WithTypename<Scenario_Equipment>, Record<string, never>, Scalars['uuid'] | string>,
    lower_shroud?: GraphCacheResolver<WithTypename<Scenario_Equipment>, Record<string, never>, WithTypename<Casings> | string>,
    lower_shroud_id?: GraphCacheResolver<WithTypename<Scenario_Equipment>, Record<string, never>, Scalars['uuid'] | string>,
    lower_xref_cables?: GraphCacheResolver<WithTypename<Scenario_Equipment>, Scenario_EquipmentLower_Xref_CablesArgs, Array<WithTypename<Scenario_Equipment_Xref_Cables> | string>>,
    lower_xref_cables_aggregate?: GraphCacheResolver<WithTypename<Scenario_Equipment>, Scenario_EquipmentLower_Xref_Cables_AggregateArgs, WithTypename<Scenario_Equipment_Xref_Cables_Aggregate> | string>,
    lower_xref_intakes?: GraphCacheResolver<WithTypename<Scenario_Equipment>, Scenario_EquipmentLower_Xref_IntakesArgs, Array<WithTypename<Scenario_Equipment_Xref_Intakes> | string>>,
    lower_xref_intakes_aggregate?: GraphCacheResolver<WithTypename<Scenario_Equipment>, Scenario_EquipmentLower_Xref_Intakes_AggregateArgs, WithTypename<Scenario_Equipment_Xref_Intakes_Aggregate> | string>,
    lower_xref_pumps?: GraphCacheResolver<WithTypename<Scenario_Equipment>, Scenario_EquipmentLower_Xref_PumpsArgs, Array<WithTypename<Scenario_Equipment_Xref_Pumps> | string>>,
    lower_xref_pumps_aggregate?: GraphCacheResolver<WithTypename<Scenario_Equipment>, Scenario_EquipmentLower_Xref_Pumps_AggregateArgs, WithTypename<Scenario_Equipment_Xref_Pumps_Aggregate> | string>,
    lower_xref_seals?: GraphCacheResolver<WithTypename<Scenario_Equipment>, Scenario_EquipmentLower_Xref_SealsArgs, Array<WithTypename<Scenario_Equipment_Xref_Seals> | string>>,
    lower_xref_seals_aggregate?: GraphCacheResolver<WithTypename<Scenario_Equipment>, Scenario_EquipmentLower_Xref_Seals_AggregateArgs, WithTypename<Scenario_Equipment_Xref_Seals_Aggregate> | string>,
    mle?: GraphCacheResolver<WithTypename<Scenario_Equipment>, Record<string, never>, WithTypename<Motor_Lead_Extensions> | string>,
    mle_id?: GraphCacheResolver<WithTypename<Scenario_Equipment>, Record<string, never>, Scalars['uuid'] | string>,
    motor?: GraphCacheResolver<WithTypename<Scenario_Equipment>, Record<string, never>, WithTypename<Motors> | string>,
    motor_id?: GraphCacheResolver<WithTypename<Scenario_Equipment>, Record<string, never>, Scalars['uuid'] | string>,
    parent_id?: GraphCacheResolver<WithTypename<Scenario_Equipment>, Record<string, never>, Scalars['uuid'] | string>,
    pumps_order?: GraphCacheResolver<WithTypename<Scenario_Equipment>, Record<string, never>, Array<Scalars['uuid'] | string>>,
    seal_motor_oil?: GraphCacheResolver<WithTypename<Scenario_Equipment>, Record<string, never>, WithTypename<Seal_Motor_Oil> | string>,
    seal_motor_oil_id?: GraphCacheResolver<WithTypename<Scenario_Equipment>, Record<string, never>, Scalars['uuid'] | string>,
    seals_order?: GraphCacheResolver<WithTypename<Scenario_Equipment>, Record<string, never>, Array<Scalars['uuid'] | string>>,
    sensor?: GraphCacheResolver<WithTypename<Scenario_Equipment>, Record<string, never>, WithTypename<Sensors> | string>,
    sensor_id?: GraphCacheResolver<WithTypename<Scenario_Equipment>, Record<string, never>, Scalars['uuid'] | string>,
    shroud?: GraphCacheResolver<WithTypename<Scenario_Equipment>, Record<string, never>, WithTypename<Casings> | string>,
    shroud_id?: GraphCacheResolver<WithTypename<Scenario_Equipment>, Record<string, never>, Scalars['uuid'] | string>,
    step_down_transformer?: GraphCacheResolver<WithTypename<Scenario_Equipment>, Record<string, never>, WithTypename<Step_Down_Transformers> | string>,
    step_up_transformer?: GraphCacheResolver<WithTypename<Scenario_Equipment>, Record<string, never>, WithTypename<Step_Up_Transformers> | string>,
    switchboard?: GraphCacheResolver<WithTypename<Scenario_Equipment>, Record<string, never>, WithTypename<Switchboards> | string>,
    switchboard_id?: GraphCacheResolver<WithTypename<Scenario_Equipment>, Record<string, never>, Scalars['uuid'] | string>,
    up_trans_id?: GraphCacheResolver<WithTypename<Scenario_Equipment>, Record<string, never>, Scalars['uuid'] | string>,
    uphole_xref_y_tool_bypass_tubings?: GraphCacheResolver<WithTypename<Scenario_Equipment>, Scenario_EquipmentUphole_Xref_Y_Tool_Bypass_TubingsArgs, Array<WithTypename<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings> | string>>,
    uphole_xref_y_tool_bypass_tubings_aggregate?: GraphCacheResolver<WithTypename<Scenario_Equipment>, Scenario_EquipmentUphole_Xref_Y_Tool_Bypass_Tubings_AggregateArgs, WithTypename<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Aggregate> | string>,
    uphole_xref_y_tool_equipment_tubings?: GraphCacheResolver<WithTypename<Scenario_Equipment>, Scenario_EquipmentUphole_Xref_Y_Tool_Equipment_TubingsArgs, Array<WithTypename<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings> | string>>,
    uphole_xref_y_tool_equipment_tubings_aggregate?: GraphCacheResolver<WithTypename<Scenario_Equipment>, Scenario_EquipmentUphole_Xref_Y_Tool_Equipment_Tubings_AggregateArgs, WithTypename<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Aggregate> | string>,
    uphole_y_tool?: GraphCacheResolver<WithTypename<Scenario_Equipment>, Record<string, never>, WithTypename<Y_Tools> | string>,
    uphole_y_tool_bypass_tubing_order?: GraphCacheResolver<WithTypename<Scenario_Equipment>, Record<string, never>, Array<Scalars['uuid'] | string>>,
    uphole_y_tool_equipment_tubing_order?: GraphCacheResolver<WithTypename<Scenario_Equipment>, Record<string, never>, Array<Scalars['uuid'] | string>>,
    uphole_y_tool_id?: GraphCacheResolver<WithTypename<Scenario_Equipment>, Record<string, never>, Scalars['uuid'] | string>,
    use_downhole_y_tool?: GraphCacheResolver<WithTypename<Scenario_Equipment>, Record<string, never>, Scalars['Boolean'] | string>,
    use_uphole_y_tool?: GraphCacheResolver<WithTypename<Scenario_Equipment>, Record<string, never>, Scalars['Boolean'] | string>,
    use_vsd?: GraphCacheResolver<WithTypename<Scenario_Equipment>, Record<string, never>, Scalars['Boolean'] | string>,
    vsd?: GraphCacheResolver<WithTypename<Scenario_Equipment>, Record<string, never>, WithTypename<Variable_Speed_Drives> | string>,
    vsd_id?: GraphCacheResolver<WithTypename<Scenario_Equipment>, Record<string, never>, Scalars['uuid'] | string>,
    winning_revision_author_id?: GraphCacheResolver<WithTypename<Scenario_Equipment>, Record<string, never>, Scalars['String'] | string>,
    winning_revision_created_at?: GraphCacheResolver<WithTypename<Scenario_Equipment>, Record<string, never>, Scalars['timestamptz'] | string>,
    winning_revision_deleted_at?: GraphCacheResolver<WithTypename<Scenario_Equipment>, Record<string, never>, Scalars['timestamptz'] | string>,
    winning_revision_id?: GraphCacheResolver<WithTypename<Scenario_Equipment>, Record<string, never>, Scalars['uuid'] | string>,
    winning_revision_parent_id?: GraphCacheResolver<WithTypename<Scenario_Equipment>, Record<string, never>, Scalars['uuid'] | string>,
    winning_revision_updated_at?: GraphCacheResolver<WithTypename<Scenario_Equipment>, Record<string, never>, Scalars['timestamptz'] | string>,
    xref_cables?: GraphCacheResolver<WithTypename<Scenario_Equipment>, Scenario_EquipmentXref_CablesArgs, Array<WithTypename<Scenario_Equipment_Xref_Cables> | string>>,
    xref_cables_aggregate?: GraphCacheResolver<WithTypename<Scenario_Equipment>, Scenario_EquipmentXref_Cables_AggregateArgs, WithTypename<Scenario_Equipment_Xref_Cables_Aggregate> | string>,
    xref_intakes?: GraphCacheResolver<WithTypename<Scenario_Equipment>, Scenario_EquipmentXref_IntakesArgs, Array<WithTypename<Scenario_Equipment_Xref_Intakes> | string>>,
    xref_intakes_aggregate?: GraphCacheResolver<WithTypename<Scenario_Equipment>, Scenario_EquipmentXref_Intakes_AggregateArgs, WithTypename<Scenario_Equipment_Xref_Intakes_Aggregate> | string>,
    xref_pumps?: GraphCacheResolver<WithTypename<Scenario_Equipment>, Scenario_EquipmentXref_PumpsArgs, Array<WithTypename<Scenario_Equipment_Xref_Pumps> | string>>,
    xref_pumps_aggregate?: GraphCacheResolver<WithTypename<Scenario_Equipment>, Scenario_EquipmentXref_Pumps_AggregateArgs, WithTypename<Scenario_Equipment_Xref_Pumps_Aggregate> | string>,
    xref_seals?: GraphCacheResolver<WithTypename<Scenario_Equipment>, Scenario_EquipmentXref_SealsArgs, Array<WithTypename<Scenario_Equipment_Xref_Seals> | string>>,
    xref_seals_aggregate?: GraphCacheResolver<WithTypename<Scenario_Equipment>, Scenario_EquipmentXref_Seals_AggregateArgs, WithTypename<Scenario_Equipment_Xref_Seals_Aggregate> | string>
  },
  scenario_equipment_aggregate?: {
    aggregate?: GraphCacheResolver<WithTypename<Scenario_Equipment_Aggregate>, Record<string, never>, WithTypename<Scenario_Equipment_Aggregate_Fields> | string>,
    nodes?: GraphCacheResolver<WithTypename<Scenario_Equipment_Aggregate>, Record<string, never>, Array<WithTypename<Scenario_Equipment> | string>>
  },
  scenario_equipment_aggregate_fields?: {
    count?: GraphCacheResolver<WithTypename<Scenario_Equipment_Aggregate_Fields>, Scenario_Equipment_Aggregate_FieldsCountArgs, Scalars['Int'] | string>,
    max?: GraphCacheResolver<WithTypename<Scenario_Equipment_Aggregate_Fields>, Record<string, never>, WithTypename<Scenario_Equipment_Max_Fields> | string>,
    min?: GraphCacheResolver<WithTypename<Scenario_Equipment_Aggregate_Fields>, Record<string, never>, WithTypename<Scenario_Equipment_Min_Fields> | string>
  },
  scenario_equipment_max_fields?: {
    bolt_on_discharge_id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    cables_order?: GraphCacheResolver<WithTypename<Scenario_Equipment_Max_Fields>, Record<string, never>, Array<Scalars['uuid'] | string>>,
    down_trans_id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    downhole_y_tool_bypass_tubing_order?: GraphCacheResolver<WithTypename<Scenario_Equipment_Max_Fields>, Record<string, never>, Array<Scalars['uuid'] | string>>,
    downhole_y_tool_equipment_tubing_order?: GraphCacheResolver<WithTypename<Scenario_Equipment_Max_Fields>, Record<string, never>, Array<Scalars['uuid'] | string>>,
    downhole_y_tool_id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    intakes_order?: GraphCacheResolver<WithTypename<Scenario_Equipment_Max_Fields>, Record<string, never>, Array<Scalars['uuid'] | string>>,
    journal_author_id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    journal_created_at?: GraphCacheResolver<WithTypename<Scenario_Equipment_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    journal_deleted_at?: GraphCacheResolver<WithTypename<Scenario_Equipment_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    journal_updated_at?: GraphCacheResolver<WithTypename<Scenario_Equipment_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    lower_bolt_on_discharge_id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    lower_cables_order?: GraphCacheResolver<WithTypename<Scenario_Equipment_Max_Fields>, Record<string, never>, Array<Scalars['uuid'] | string>>,
    lower_intakes_order?: GraphCacheResolver<WithTypename<Scenario_Equipment_Max_Fields>, Record<string, never>, Array<Scalars['uuid'] | string>>,
    lower_mle_id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    lower_motor_id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    lower_pumps_order?: GraphCacheResolver<WithTypename<Scenario_Equipment_Max_Fields>, Record<string, never>, Array<Scalars['uuid'] | string>>,
    lower_seal_motor_oil_id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    lower_seals_order?: GraphCacheResolver<WithTypename<Scenario_Equipment_Max_Fields>, Record<string, never>, Array<Scalars['uuid'] | string>>,
    lower_sensor_id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    lower_shroud_id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    mle_id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    motor_id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    parent_id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    pumps_order?: GraphCacheResolver<WithTypename<Scenario_Equipment_Max_Fields>, Record<string, never>, Array<Scalars['uuid'] | string>>,
    seal_motor_oil_id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    seals_order?: GraphCacheResolver<WithTypename<Scenario_Equipment_Max_Fields>, Record<string, never>, Array<Scalars['uuid'] | string>>,
    sensor_id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    shroud_id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    switchboard_id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    up_trans_id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    uphole_y_tool_bypass_tubing_order?: GraphCacheResolver<WithTypename<Scenario_Equipment_Max_Fields>, Record<string, never>, Array<Scalars['uuid'] | string>>,
    uphole_y_tool_equipment_tubing_order?: GraphCacheResolver<WithTypename<Scenario_Equipment_Max_Fields>, Record<string, never>, Array<Scalars['uuid'] | string>>,
    uphole_y_tool_id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    vsd_id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    winning_revision_author_id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    winning_revision_created_at?: GraphCacheResolver<WithTypename<Scenario_Equipment_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    winning_revision_deleted_at?: GraphCacheResolver<WithTypename<Scenario_Equipment_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    winning_revision_id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    winning_revision_parent_id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    winning_revision_updated_at?: GraphCacheResolver<WithTypename<Scenario_Equipment_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>
  },
  scenario_equipment_min_fields?: {
    bolt_on_discharge_id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    cables_order?: GraphCacheResolver<WithTypename<Scenario_Equipment_Min_Fields>, Record<string, never>, Array<Scalars['uuid'] | string>>,
    down_trans_id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    downhole_y_tool_bypass_tubing_order?: GraphCacheResolver<WithTypename<Scenario_Equipment_Min_Fields>, Record<string, never>, Array<Scalars['uuid'] | string>>,
    downhole_y_tool_equipment_tubing_order?: GraphCacheResolver<WithTypename<Scenario_Equipment_Min_Fields>, Record<string, never>, Array<Scalars['uuid'] | string>>,
    downhole_y_tool_id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    intakes_order?: GraphCacheResolver<WithTypename<Scenario_Equipment_Min_Fields>, Record<string, never>, Array<Scalars['uuid'] | string>>,
    journal_author_id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    journal_created_at?: GraphCacheResolver<WithTypename<Scenario_Equipment_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    journal_deleted_at?: GraphCacheResolver<WithTypename<Scenario_Equipment_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    journal_updated_at?: GraphCacheResolver<WithTypename<Scenario_Equipment_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    lower_bolt_on_discharge_id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    lower_cables_order?: GraphCacheResolver<WithTypename<Scenario_Equipment_Min_Fields>, Record<string, never>, Array<Scalars['uuid'] | string>>,
    lower_intakes_order?: GraphCacheResolver<WithTypename<Scenario_Equipment_Min_Fields>, Record<string, never>, Array<Scalars['uuid'] | string>>,
    lower_mle_id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    lower_motor_id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    lower_pumps_order?: GraphCacheResolver<WithTypename<Scenario_Equipment_Min_Fields>, Record<string, never>, Array<Scalars['uuid'] | string>>,
    lower_seal_motor_oil_id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    lower_seals_order?: GraphCacheResolver<WithTypename<Scenario_Equipment_Min_Fields>, Record<string, never>, Array<Scalars['uuid'] | string>>,
    lower_sensor_id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    lower_shroud_id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    mle_id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    motor_id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    parent_id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    pumps_order?: GraphCacheResolver<WithTypename<Scenario_Equipment_Min_Fields>, Record<string, never>, Array<Scalars['uuid'] | string>>,
    seal_motor_oil_id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    seals_order?: GraphCacheResolver<WithTypename<Scenario_Equipment_Min_Fields>, Record<string, never>, Array<Scalars['uuid'] | string>>,
    sensor_id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    shroud_id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    switchboard_id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    up_trans_id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    uphole_y_tool_bypass_tubing_order?: GraphCacheResolver<WithTypename<Scenario_Equipment_Min_Fields>, Record<string, never>, Array<Scalars['uuid'] | string>>,
    uphole_y_tool_equipment_tubing_order?: GraphCacheResolver<WithTypename<Scenario_Equipment_Min_Fields>, Record<string, never>, Array<Scalars['uuid'] | string>>,
    uphole_y_tool_id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    vsd_id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    winning_revision_author_id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    winning_revision_created_at?: GraphCacheResolver<WithTypename<Scenario_Equipment_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    winning_revision_deleted_at?: GraphCacheResolver<WithTypename<Scenario_Equipment_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    winning_revision_id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    winning_revision_parent_id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    winning_revision_updated_at?: GraphCacheResolver<WithTypename<Scenario_Equipment_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>
  },
  scenario_equipment_xref_cables?: {
    cable?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Cables>, Record<string, never>, WithTypename<Cables> | string>,
    cable_id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Cables>, Record<string, never>, Scalars['uuid'] | string>,
    id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Cables>, Record<string, never>, Scalars['uuid'] | string>,
    journal_author_id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Cables>, Record<string, never>, Scalars['String'] | string>,
    journal_created_at?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Cables>, Record<string, never>, Scalars['timestamptz'] | string>,
    journal_deleted_at?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Cables>, Record<string, never>, Scalars['timestamptz'] | string>,
    journal_updated_at?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Cables>, Record<string, never>, Scalars['timestamptz'] | string>,
    length_feet?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Cables>, Record<string, never>, Scalars['numeric'] | string>,
    parent_id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Cables>, Record<string, never>, Scalars['uuid'] | string>,
    scenario_equipment_id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Cables>, Record<string, never>, Scalars['uuid'] | string>,
    winning_revision_author_id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Cables>, Record<string, never>, Scalars['String'] | string>,
    winning_revision_created_at?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Cables>, Record<string, never>, Scalars['timestamptz'] | string>,
    winning_revision_deleted_at?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Cables>, Record<string, never>, Scalars['timestamptz'] | string>,
    winning_revision_id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Cables>, Record<string, never>, Scalars['uuid'] | string>,
    winning_revision_parent_id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Cables>, Record<string, never>, Scalars['uuid'] | string>,
    winning_revision_updated_at?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Cables>, Record<string, never>, Scalars['timestamptz'] | string>
  },
  scenario_equipment_xref_cables_aggregate?: {
    aggregate?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Cables_Aggregate>, Record<string, never>, WithTypename<Scenario_Equipment_Xref_Cables_Aggregate_Fields> | string>,
    nodes?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Cables_Aggregate>, Record<string, never>, Array<WithTypename<Scenario_Equipment_Xref_Cables> | string>>
  },
  scenario_equipment_xref_cables_aggregate_fields?: {
    avg?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Cables_Aggregate_Fields>, Record<string, never>, WithTypename<Scenario_Equipment_Xref_Cables_Avg_Fields> | string>,
    count?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Cables_Aggregate_Fields>, Scenario_Equipment_Xref_Cables_Aggregate_FieldsCountArgs, Scalars['Int'] | string>,
    max?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Cables_Aggregate_Fields>, Record<string, never>, WithTypename<Scenario_Equipment_Xref_Cables_Max_Fields> | string>,
    min?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Cables_Aggregate_Fields>, Record<string, never>, WithTypename<Scenario_Equipment_Xref_Cables_Min_Fields> | string>,
    stddev?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Cables_Aggregate_Fields>, Record<string, never>, WithTypename<Scenario_Equipment_Xref_Cables_Stddev_Fields> | string>,
    stddev_pop?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Cables_Aggregate_Fields>, Record<string, never>, WithTypename<Scenario_Equipment_Xref_Cables_Stddev_Pop_Fields> | string>,
    stddev_samp?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Cables_Aggregate_Fields>, Record<string, never>, WithTypename<Scenario_Equipment_Xref_Cables_Stddev_Samp_Fields> | string>,
    sum?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Cables_Aggregate_Fields>, Record<string, never>, WithTypename<Scenario_Equipment_Xref_Cables_Sum_Fields> | string>,
    var_pop?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Cables_Aggregate_Fields>, Record<string, never>, WithTypename<Scenario_Equipment_Xref_Cables_Var_Pop_Fields> | string>,
    var_samp?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Cables_Aggregate_Fields>, Record<string, never>, WithTypename<Scenario_Equipment_Xref_Cables_Var_Samp_Fields> | string>,
    variance?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Cables_Aggregate_Fields>, Record<string, never>, WithTypename<Scenario_Equipment_Xref_Cables_Variance_Fields> | string>
  },
  scenario_equipment_xref_cables_avg_fields?: {
    length_feet?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Cables_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  scenario_equipment_xref_cables_max_fields?: {
    cable_id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Cables_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Cables_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    journal_author_id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Cables_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    journal_created_at?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Cables_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    journal_deleted_at?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Cables_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    journal_updated_at?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Cables_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    length_feet?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Cables_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    parent_id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Cables_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    scenario_equipment_id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Cables_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    winning_revision_author_id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Cables_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    winning_revision_created_at?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Cables_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    winning_revision_deleted_at?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Cables_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    winning_revision_id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Cables_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    winning_revision_parent_id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Cables_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    winning_revision_updated_at?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Cables_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>
  },
  scenario_equipment_xref_cables_min_fields?: {
    cable_id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Cables_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Cables_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    journal_author_id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Cables_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    journal_created_at?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Cables_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    journal_deleted_at?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Cables_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    journal_updated_at?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Cables_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    length_feet?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Cables_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    parent_id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Cables_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    scenario_equipment_id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Cables_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    winning_revision_author_id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Cables_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    winning_revision_created_at?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Cables_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    winning_revision_deleted_at?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Cables_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    winning_revision_id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Cables_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    winning_revision_parent_id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Cables_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    winning_revision_updated_at?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Cables_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>
  },
  scenario_equipment_xref_cables_stddev_fields?: {
    length_feet?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Cables_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  scenario_equipment_xref_cables_stddev_pop_fields?: {
    length_feet?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Cables_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  scenario_equipment_xref_cables_stddev_samp_fields?: {
    length_feet?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Cables_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  scenario_equipment_xref_cables_sum_fields?: {
    length_feet?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Cables_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>
  },
  scenario_equipment_xref_cables_var_pop_fields?: {
    length_feet?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Cables_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  scenario_equipment_xref_cables_var_samp_fields?: {
    length_feet?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Cables_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  scenario_equipment_xref_cables_variance_fields?: {
    length_feet?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Cables_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  scenario_equipment_xref_housings?: {
    housing?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Housings>, Record<string, never>, WithTypename<Housings> | string>,
    housing_id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Housings>, Record<string, never>, Scalars['uuid'] | string>,
    id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Housings>, Record<string, never>, Scalars['uuid'] | string>,
    journal_author_id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Housings>, Record<string, never>, Scalars['String'] | string>,
    journal_created_at?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Housings>, Record<string, never>, Scalars['timestamptz'] | string>,
    journal_deleted_at?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Housings>, Record<string, never>, Scalars['timestamptz'] | string>,
    journal_updated_at?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Housings>, Record<string, never>, Scalars['timestamptz'] | string>,
    length_inches?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Housings>, Record<string, never>, Scalars['numeric'] | string>,
    parent_id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Housings>, Record<string, never>, Scalars['uuid'] | string>,
    scenario_equipment_xref_pump_id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Housings>, Record<string, never>, Scalars['uuid'] | string>,
    stage_count?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Housings>, Record<string, never>, Scalars['Int'] | string>,
    winning_revision_author_id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Housings>, Record<string, never>, Scalars['String'] | string>,
    winning_revision_created_at?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Housings>, Record<string, never>, Scalars['timestamptz'] | string>,
    winning_revision_deleted_at?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Housings>, Record<string, never>, Scalars['timestamptz'] | string>,
    winning_revision_id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Housings>, Record<string, never>, Scalars['uuid'] | string>,
    winning_revision_parent_id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Housings>, Record<string, never>, Scalars['uuid'] | string>,
    winning_revision_updated_at?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Housings>, Record<string, never>, Scalars['timestamptz'] | string>
  },
  scenario_equipment_xref_housings_aggregate?: {
    aggregate?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Housings_Aggregate>, Record<string, never>, WithTypename<Scenario_Equipment_Xref_Housings_Aggregate_Fields> | string>,
    nodes?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Housings_Aggregate>, Record<string, never>, Array<WithTypename<Scenario_Equipment_Xref_Housings> | string>>
  },
  scenario_equipment_xref_housings_aggregate_fields?: {
    avg?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Housings_Aggregate_Fields>, Record<string, never>, WithTypename<Scenario_Equipment_Xref_Housings_Avg_Fields> | string>,
    count?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Housings_Aggregate_Fields>, Scenario_Equipment_Xref_Housings_Aggregate_FieldsCountArgs, Scalars['Int'] | string>,
    max?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Housings_Aggregate_Fields>, Record<string, never>, WithTypename<Scenario_Equipment_Xref_Housings_Max_Fields> | string>,
    min?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Housings_Aggregate_Fields>, Record<string, never>, WithTypename<Scenario_Equipment_Xref_Housings_Min_Fields> | string>,
    stddev?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Housings_Aggregate_Fields>, Record<string, never>, WithTypename<Scenario_Equipment_Xref_Housings_Stddev_Fields> | string>,
    stddev_pop?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Housings_Aggregate_Fields>, Record<string, never>, WithTypename<Scenario_Equipment_Xref_Housings_Stddev_Pop_Fields> | string>,
    stddev_samp?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Housings_Aggregate_Fields>, Record<string, never>, WithTypename<Scenario_Equipment_Xref_Housings_Stddev_Samp_Fields> | string>,
    sum?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Housings_Aggregate_Fields>, Record<string, never>, WithTypename<Scenario_Equipment_Xref_Housings_Sum_Fields> | string>,
    var_pop?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Housings_Aggregate_Fields>, Record<string, never>, WithTypename<Scenario_Equipment_Xref_Housings_Var_Pop_Fields> | string>,
    var_samp?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Housings_Aggregate_Fields>, Record<string, never>, WithTypename<Scenario_Equipment_Xref_Housings_Var_Samp_Fields> | string>,
    variance?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Housings_Aggregate_Fields>, Record<string, never>, WithTypename<Scenario_Equipment_Xref_Housings_Variance_Fields> | string>
  },
  scenario_equipment_xref_housings_avg_fields?: {
    length_inches?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Housings_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    stage_count?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Housings_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  scenario_equipment_xref_housings_max_fields?: {
    housing_id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Housings_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Housings_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    journal_author_id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Housings_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    journal_created_at?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Housings_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    journal_deleted_at?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Housings_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    journal_updated_at?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Housings_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    length_inches?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Housings_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    parent_id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Housings_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    scenario_equipment_xref_pump_id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Housings_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    stage_count?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Housings_Max_Fields>, Record<string, never>, Scalars['Int'] | string>,
    winning_revision_author_id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Housings_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    winning_revision_created_at?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Housings_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    winning_revision_deleted_at?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Housings_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    winning_revision_id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Housings_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    winning_revision_parent_id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Housings_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    winning_revision_updated_at?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Housings_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>
  },
  scenario_equipment_xref_housings_min_fields?: {
    housing_id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Housings_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Housings_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    journal_author_id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Housings_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    journal_created_at?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Housings_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    journal_deleted_at?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Housings_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    journal_updated_at?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Housings_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    length_inches?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Housings_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    parent_id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Housings_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    scenario_equipment_xref_pump_id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Housings_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    stage_count?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Housings_Min_Fields>, Record<string, never>, Scalars['Int'] | string>,
    winning_revision_author_id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Housings_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    winning_revision_created_at?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Housings_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    winning_revision_deleted_at?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Housings_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    winning_revision_id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Housings_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    winning_revision_parent_id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Housings_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    winning_revision_updated_at?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Housings_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>
  },
  scenario_equipment_xref_housings_stddev_fields?: {
    length_inches?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Housings_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    stage_count?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Housings_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  scenario_equipment_xref_housings_stddev_pop_fields?: {
    length_inches?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Housings_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    stage_count?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Housings_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  scenario_equipment_xref_housings_stddev_samp_fields?: {
    length_inches?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Housings_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    stage_count?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Housings_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  scenario_equipment_xref_housings_sum_fields?: {
    length_inches?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Housings_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    stage_count?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Housings_Sum_Fields>, Record<string, never>, Scalars['Int'] | string>
  },
  scenario_equipment_xref_housings_var_pop_fields?: {
    length_inches?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Housings_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    stage_count?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Housings_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  scenario_equipment_xref_housings_var_samp_fields?: {
    length_inches?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Housings_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    stage_count?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Housings_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  scenario_equipment_xref_housings_variance_fields?: {
    length_inches?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Housings_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    stage_count?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Housings_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  scenario_equipment_xref_intakes?: {
    id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Intakes>, Record<string, never>, Scalars['uuid'] | string>,
    intake?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Intakes>, Record<string, never>, WithTypename<Intakes> | string>,
    intake_id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Intakes>, Record<string, never>, Scalars['uuid'] | string>,
    journal_author_id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Intakes>, Record<string, never>, Scalars['String'] | string>,
    journal_created_at?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Intakes>, Record<string, never>, Scalars['timestamptz'] | string>,
    journal_deleted_at?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Intakes>, Record<string, never>, Scalars['timestamptz'] | string>,
    journal_updated_at?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Intakes>, Record<string, never>, Scalars['timestamptz'] | string>,
    parent_id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Intakes>, Record<string, never>, Scalars['uuid'] | string>,
    scenario_equipment_id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Intakes>, Record<string, never>, Scalars['uuid'] | string>,
    use_high_strength_shaft?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Intakes>, Record<string, never>, Scalars['Boolean'] | string>,
    winning_revision_author_id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Intakes>, Record<string, never>, Scalars['String'] | string>,
    winning_revision_created_at?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Intakes>, Record<string, never>, Scalars['timestamptz'] | string>,
    winning_revision_deleted_at?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Intakes>, Record<string, never>, Scalars['timestamptz'] | string>,
    winning_revision_id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Intakes>, Record<string, never>, Scalars['uuid'] | string>,
    winning_revision_parent_id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Intakes>, Record<string, never>, Scalars['uuid'] | string>,
    winning_revision_updated_at?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Intakes>, Record<string, never>, Scalars['timestamptz'] | string>
  },
  scenario_equipment_xref_intakes_aggregate?: {
    aggregate?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Intakes_Aggregate>, Record<string, never>, WithTypename<Scenario_Equipment_Xref_Intakes_Aggregate_Fields> | string>,
    nodes?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Intakes_Aggregate>, Record<string, never>, Array<WithTypename<Scenario_Equipment_Xref_Intakes> | string>>
  },
  scenario_equipment_xref_intakes_aggregate_fields?: {
    count?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Intakes_Aggregate_Fields>, Scenario_Equipment_Xref_Intakes_Aggregate_FieldsCountArgs, Scalars['Int'] | string>,
    max?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Intakes_Aggregate_Fields>, Record<string, never>, WithTypename<Scenario_Equipment_Xref_Intakes_Max_Fields> | string>,
    min?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Intakes_Aggregate_Fields>, Record<string, never>, WithTypename<Scenario_Equipment_Xref_Intakes_Min_Fields> | string>
  },
  scenario_equipment_xref_intakes_max_fields?: {
    id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Intakes_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    intake_id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Intakes_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    journal_author_id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Intakes_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    journal_created_at?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Intakes_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    journal_deleted_at?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Intakes_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    journal_updated_at?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Intakes_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    parent_id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Intakes_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    scenario_equipment_id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Intakes_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    winning_revision_author_id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Intakes_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    winning_revision_created_at?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Intakes_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    winning_revision_deleted_at?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Intakes_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    winning_revision_id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Intakes_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    winning_revision_parent_id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Intakes_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    winning_revision_updated_at?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Intakes_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>
  },
  scenario_equipment_xref_intakes_min_fields?: {
    id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Intakes_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    intake_id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Intakes_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    journal_author_id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Intakes_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    journal_created_at?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Intakes_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    journal_deleted_at?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Intakes_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    journal_updated_at?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Intakes_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    parent_id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Intakes_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    scenario_equipment_id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Intakes_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    winning_revision_author_id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Intakes_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    winning_revision_created_at?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Intakes_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    winning_revision_deleted_at?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Intakes_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    winning_revision_id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Intakes_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    winning_revision_parent_id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Intakes_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    winning_revision_updated_at?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Intakes_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>
  },
  scenario_equipment_xref_pumps?: {
    brake_horsepower_correction_ratio?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Pumps>, Record<string, never>, Scalars['numeric'] | string>,
    head_correction_ratio?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Pumps>, Record<string, never>, Scalars['numeric'] | string>,
    housings_order?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Pumps>, Record<string, never>, Array<Scalars['uuid'] | string>>,
    id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Pumps>, Record<string, never>, Scalars['uuid'] | string>,
    journal_author_id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Pumps>, Record<string, never>, Scalars['String'] | string>,
    journal_created_at?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Pumps>, Record<string, never>, Scalars['timestamptz'] | string>,
    journal_deleted_at?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Pumps>, Record<string, never>, Scalars['timestamptz'] | string>,
    journal_updated_at?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Pumps>, Record<string, never>, Scalars['timestamptz'] | string>,
    length_feet?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Pumps>, Record<string, never>, Scalars['numeric'] | string>,
    parent_id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Pumps>, Record<string, never>, Scalars['uuid'] | string>,
    pump?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Pumps>, Record<string, never>, WithTypename<Pumps> | string>,
    pump_id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Pumps>, Record<string, never>, Scalars['uuid'] | string>,
    rate_correction_ratio?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Pumps>, Record<string, never>, Scalars['numeric'] | string>,
    scenario_equipment_id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Pumps>, Record<string, never>, Scalars['uuid'] | string>,
    total_stages?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Pumps>, Record<string, never>, Scalars['Int'] | string>,
    use_high_strength_shaft?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Pumps>, Record<string, never>, Scalars['Boolean'] | string>,
    weight_pounds?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Pumps>, Record<string, never>, Scalars['numeric'] | string>,
    winning_revision_author_id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Pumps>, Record<string, never>, Scalars['String'] | string>,
    winning_revision_created_at?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Pumps>, Record<string, never>, Scalars['timestamptz'] | string>,
    winning_revision_deleted_at?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Pumps>, Record<string, never>, Scalars['timestamptz'] | string>,
    winning_revision_id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Pumps>, Record<string, never>, Scalars['uuid'] | string>,
    winning_revision_parent_id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Pumps>, Record<string, never>, Scalars['uuid'] | string>,
    winning_revision_updated_at?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Pumps>, Record<string, never>, Scalars['timestamptz'] | string>,
    xref_housings?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Pumps>, Scenario_Equipment_Xref_PumpsXref_HousingsArgs, Array<WithTypename<Scenario_Equipment_Xref_Housings> | string>>,
    xref_housings_aggregate?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Pumps>, Scenario_Equipment_Xref_PumpsXref_Housings_AggregateArgs, WithTypename<Scenario_Equipment_Xref_Housings_Aggregate> | string>
  },
  scenario_equipment_xref_pumps_aggregate?: {
    aggregate?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Pumps_Aggregate>, Record<string, never>, WithTypename<Scenario_Equipment_Xref_Pumps_Aggregate_Fields> | string>,
    nodes?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Pumps_Aggregate>, Record<string, never>, Array<WithTypename<Scenario_Equipment_Xref_Pumps> | string>>
  },
  scenario_equipment_xref_pumps_aggregate_fields?: {
    avg?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Pumps_Aggregate_Fields>, Record<string, never>, WithTypename<Scenario_Equipment_Xref_Pumps_Avg_Fields> | string>,
    count?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Pumps_Aggregate_Fields>, Scenario_Equipment_Xref_Pumps_Aggregate_FieldsCountArgs, Scalars['Int'] | string>,
    max?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Pumps_Aggregate_Fields>, Record<string, never>, WithTypename<Scenario_Equipment_Xref_Pumps_Max_Fields> | string>,
    min?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Pumps_Aggregate_Fields>, Record<string, never>, WithTypename<Scenario_Equipment_Xref_Pumps_Min_Fields> | string>,
    stddev?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Pumps_Aggregate_Fields>, Record<string, never>, WithTypename<Scenario_Equipment_Xref_Pumps_Stddev_Fields> | string>,
    stddev_pop?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Pumps_Aggregate_Fields>, Record<string, never>, WithTypename<Scenario_Equipment_Xref_Pumps_Stddev_Pop_Fields> | string>,
    stddev_samp?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Pumps_Aggregate_Fields>, Record<string, never>, WithTypename<Scenario_Equipment_Xref_Pumps_Stddev_Samp_Fields> | string>,
    sum?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Pumps_Aggregate_Fields>, Record<string, never>, WithTypename<Scenario_Equipment_Xref_Pumps_Sum_Fields> | string>,
    var_pop?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Pumps_Aggregate_Fields>, Record<string, never>, WithTypename<Scenario_Equipment_Xref_Pumps_Var_Pop_Fields> | string>,
    var_samp?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Pumps_Aggregate_Fields>, Record<string, never>, WithTypename<Scenario_Equipment_Xref_Pumps_Var_Samp_Fields> | string>,
    variance?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Pumps_Aggregate_Fields>, Record<string, never>, WithTypename<Scenario_Equipment_Xref_Pumps_Variance_Fields> | string>
  },
  scenario_equipment_xref_pumps_avg_fields?: {
    brake_horsepower_correction_ratio?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Pumps_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    head_correction_ratio?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Pumps_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    length_feet?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Pumps_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    rate_correction_ratio?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Pumps_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    total_stages?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Pumps_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    weight_pounds?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Pumps_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  scenario_equipment_xref_pumps_max_fields?: {
    brake_horsepower_correction_ratio?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Pumps_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    head_correction_ratio?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Pumps_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    housings_order?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Pumps_Max_Fields>, Record<string, never>, Array<Scalars['uuid'] | string>>,
    id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Pumps_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    journal_author_id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Pumps_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    journal_created_at?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Pumps_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    journal_deleted_at?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Pumps_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    journal_updated_at?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Pumps_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    length_feet?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Pumps_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    parent_id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Pumps_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    pump_id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Pumps_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    rate_correction_ratio?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Pumps_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    scenario_equipment_id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Pumps_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    total_stages?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Pumps_Max_Fields>, Record<string, never>, Scalars['Int'] | string>,
    weight_pounds?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Pumps_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    winning_revision_author_id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Pumps_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    winning_revision_created_at?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Pumps_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    winning_revision_deleted_at?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Pumps_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    winning_revision_id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Pumps_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    winning_revision_parent_id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Pumps_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    winning_revision_updated_at?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Pumps_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>
  },
  scenario_equipment_xref_pumps_min_fields?: {
    brake_horsepower_correction_ratio?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Pumps_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    head_correction_ratio?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Pumps_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    housings_order?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Pumps_Min_Fields>, Record<string, never>, Array<Scalars['uuid'] | string>>,
    id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Pumps_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    journal_author_id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Pumps_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    journal_created_at?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Pumps_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    journal_deleted_at?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Pumps_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    journal_updated_at?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Pumps_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    length_feet?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Pumps_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    parent_id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Pumps_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    pump_id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Pumps_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    rate_correction_ratio?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Pumps_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    scenario_equipment_id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Pumps_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    total_stages?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Pumps_Min_Fields>, Record<string, never>, Scalars['Int'] | string>,
    weight_pounds?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Pumps_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    winning_revision_author_id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Pumps_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    winning_revision_created_at?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Pumps_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    winning_revision_deleted_at?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Pumps_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    winning_revision_id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Pumps_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    winning_revision_parent_id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Pumps_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    winning_revision_updated_at?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Pumps_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>
  },
  scenario_equipment_xref_pumps_stddev_fields?: {
    brake_horsepower_correction_ratio?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Pumps_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    head_correction_ratio?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Pumps_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    length_feet?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Pumps_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    rate_correction_ratio?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Pumps_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    total_stages?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Pumps_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    weight_pounds?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Pumps_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  scenario_equipment_xref_pumps_stddev_pop_fields?: {
    brake_horsepower_correction_ratio?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Pumps_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    head_correction_ratio?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Pumps_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    length_feet?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Pumps_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    rate_correction_ratio?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Pumps_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    total_stages?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Pumps_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    weight_pounds?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Pumps_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  scenario_equipment_xref_pumps_stddev_samp_fields?: {
    brake_horsepower_correction_ratio?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Pumps_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    head_correction_ratio?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Pumps_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    length_feet?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Pumps_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    rate_correction_ratio?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Pumps_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    total_stages?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Pumps_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    weight_pounds?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Pumps_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  scenario_equipment_xref_pumps_sum_fields?: {
    brake_horsepower_correction_ratio?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Pumps_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    head_correction_ratio?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Pumps_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    length_feet?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Pumps_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    rate_correction_ratio?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Pumps_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    total_stages?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Pumps_Sum_Fields>, Record<string, never>, Scalars['Int'] | string>,
    weight_pounds?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Pumps_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>
  },
  scenario_equipment_xref_pumps_var_pop_fields?: {
    brake_horsepower_correction_ratio?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Pumps_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    head_correction_ratio?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Pumps_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    length_feet?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Pumps_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    rate_correction_ratio?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Pumps_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    total_stages?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Pumps_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    weight_pounds?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Pumps_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  scenario_equipment_xref_pumps_var_samp_fields?: {
    brake_horsepower_correction_ratio?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Pumps_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    head_correction_ratio?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Pumps_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    length_feet?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Pumps_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    rate_correction_ratio?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Pumps_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    total_stages?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Pumps_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    weight_pounds?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Pumps_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  scenario_equipment_xref_pumps_variance_fields?: {
    brake_horsepower_correction_ratio?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Pumps_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    head_correction_ratio?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Pumps_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    length_feet?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Pumps_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    rate_correction_ratio?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Pumps_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    total_stages?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Pumps_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    weight_pounds?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Pumps_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  scenario_equipment_xref_seals?: {
    id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Seals>, Record<string, never>, Scalars['uuid'] | string>,
    journal_author_id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Seals>, Record<string, never>, Scalars['String'] | string>,
    journal_created_at?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Seals>, Record<string, never>, Scalars['timestamptz'] | string>,
    journal_deleted_at?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Seals>, Record<string, never>, Scalars['timestamptz'] | string>,
    journal_updated_at?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Seals>, Record<string, never>, Scalars['timestamptz'] | string>,
    parent_id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Seals>, Record<string, never>, Scalars['uuid'] | string>,
    scenario_equipment_id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Seals>, Record<string, never>, Scalars['uuid'] | string>,
    seal?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Seals>, Record<string, never>, WithTypename<Seals> | string>,
    seal_id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Seals>, Record<string, never>, Scalars['uuid'] | string>,
    use_high_strength_shaft?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Seals>, Record<string, never>, Scalars['Boolean'] | string>,
    winning_revision_author_id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Seals>, Record<string, never>, Scalars['String'] | string>,
    winning_revision_created_at?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Seals>, Record<string, never>, Scalars['timestamptz'] | string>,
    winning_revision_deleted_at?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Seals>, Record<string, never>, Scalars['timestamptz'] | string>,
    winning_revision_id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Seals>, Record<string, never>, Scalars['uuid'] | string>,
    winning_revision_parent_id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Seals>, Record<string, never>, Scalars['uuid'] | string>,
    winning_revision_updated_at?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Seals>, Record<string, never>, Scalars['timestamptz'] | string>
  },
  scenario_equipment_xref_seals_aggregate?: {
    aggregate?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Seals_Aggregate>, Record<string, never>, WithTypename<Scenario_Equipment_Xref_Seals_Aggregate_Fields> | string>,
    nodes?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Seals_Aggregate>, Record<string, never>, Array<WithTypename<Scenario_Equipment_Xref_Seals> | string>>
  },
  scenario_equipment_xref_seals_aggregate_fields?: {
    count?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Seals_Aggregate_Fields>, Scenario_Equipment_Xref_Seals_Aggregate_FieldsCountArgs, Scalars['Int'] | string>,
    max?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Seals_Aggregate_Fields>, Record<string, never>, WithTypename<Scenario_Equipment_Xref_Seals_Max_Fields> | string>,
    min?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Seals_Aggregate_Fields>, Record<string, never>, WithTypename<Scenario_Equipment_Xref_Seals_Min_Fields> | string>
  },
  scenario_equipment_xref_seals_max_fields?: {
    id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Seals_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    journal_author_id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Seals_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    journal_created_at?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Seals_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    journal_deleted_at?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Seals_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    journal_updated_at?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Seals_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    parent_id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Seals_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    scenario_equipment_id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Seals_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    seal_id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Seals_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    winning_revision_author_id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Seals_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    winning_revision_created_at?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Seals_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    winning_revision_deleted_at?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Seals_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    winning_revision_id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Seals_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    winning_revision_parent_id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Seals_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    winning_revision_updated_at?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Seals_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>
  },
  scenario_equipment_xref_seals_min_fields?: {
    id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Seals_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    journal_author_id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Seals_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    journal_created_at?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Seals_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    journal_deleted_at?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Seals_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    journal_updated_at?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Seals_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    parent_id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Seals_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    scenario_equipment_id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Seals_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    seal_id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Seals_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    winning_revision_author_id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Seals_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    winning_revision_created_at?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Seals_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    winning_revision_deleted_at?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Seals_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    winning_revision_id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Seals_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    winning_revision_parent_id?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Seals_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    winning_revision_updated_at?: GraphCacheResolver<WithTypename<Scenario_Equipment_Xref_Seals_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>
  },
  scenario_parameters?: {
    bottom_casing_pressure_psia?: GraphCacheResolver<WithTypename<Scenario_Parameters>, Record<string, never>, Scalars['numeric'] | string>,
    bottom_tubing_pressure_psia?: GraphCacheResolver<WithTypename<Scenario_Parameters>, Record<string, never>, Scalars['numeric'] | string>,
    cable_cost_kw_hr_usd?: GraphCacheResolver<WithTypename<Scenario_Parameters>, Record<string, never>, Scalars['numeric'] | string>,
    elevation_feet_asl?: GraphCacheResolver<WithTypename<Scenario_Parameters>, Record<string, never>, Scalars['numeric'] | string>,
    flow_model?: GraphCacheResolver<WithTypename<Scenario_Parameters>, Record<string, never>, Scalars['String'] | string>,
    has_compression_pump?: GraphCacheResolver<WithTypename<Scenario_Parameters>, Record<string, never>, Scalars['Boolean'] | string>,
    id?: GraphCacheResolver<WithTypename<Scenario_Parameters>, Record<string, never>, Scalars['uuid'] | string>,
    include_casing_friction_loss?: GraphCacheResolver<WithTypename<Scenario_Parameters>, Record<string, never>, Scalars['Boolean'] | string>,
    intake_gas_separation_override_type?: GraphCacheResolver<WithTypename<Scenario_Parameters>, Record<string, never>, Scalars['String'] | string>,
    intake_override_gas_separation_percent?: GraphCacheResolver<WithTypename<Scenario_Parameters>, Record<string, never>, Scalars['numeric'] | string>,
    intake_packer_installed?: GraphCacheResolver<WithTypename<Scenario_Parameters>, Record<string, never>, Scalars['Boolean'] | string>,
    journal_author_id?: GraphCacheResolver<WithTypename<Scenario_Parameters>, Record<string, never>, Scalars['String'] | string>,
    journal_created_at?: GraphCacheResolver<WithTypename<Scenario_Parameters>, Record<string, never>, Scalars['timestamptz'] | string>,
    journal_deleted_at?: GraphCacheResolver<WithTypename<Scenario_Parameters>, Record<string, never>, Scalars['timestamptz'] | string>,
    journal_updated_at?: GraphCacheResolver<WithTypename<Scenario_Parameters>, Record<string, never>, Scalars['timestamptz'] | string>,
    lower_has_compression_pump?: GraphCacheResolver<WithTypename<Scenario_Parameters>, Record<string, never>, Scalars['Boolean'] | string>,
    lower_include_casing_friction_loss?: GraphCacheResolver<WithTypename<Scenario_Parameters>, Record<string, never>, Scalars['Boolean'] | string>,
    lower_intake_gas_separation_override_type?: GraphCacheResolver<WithTypename<Scenario_Parameters>, Record<string, never>, Scalars['String'] | string>,
    lower_intake_override_gas_separation_percent?: GraphCacheResolver<WithTypename<Scenario_Parameters>, Record<string, never>, Scalars['numeric'] | string>,
    lower_intake_packer_installed?: GraphCacheResolver<WithTypename<Scenario_Parameters>, Record<string, never>, Scalars['Boolean'] | string>,
    lower_motor_rerate_ratio?: GraphCacheResolver<WithTypename<Scenario_Parameters>, Record<string, never>, Scalars['numeric'] | string>,
    lower_motor_shroud_interior_diameter_inches?: GraphCacheResolver<WithTypename<Scenario_Parameters>, Record<string, never>, Scalars['numeric'] | string>,
    lower_natural_gas_separation_override_type?: GraphCacheResolver<WithTypename<Scenario_Parameters>, Record<string, never>, Scalars['String'] | string>,
    lower_natural_override_gas_separation_percent?: GraphCacheResolver<WithTypename<Scenario_Parameters>, Record<string, never>, Scalars['numeric'] | string>,
    lower_pump_hz?: GraphCacheResolver<WithTypename<Scenario_Parameters>, Record<string, never>, Scalars['numeric'] | string>,
    lower_pump_override_gas_correction_percent?: GraphCacheResolver<WithTypename<Scenario_Parameters>, Record<string, never>, Scalars['numeric'] | string>,
    lower_pump_wear_brake_horsepower_correction_ratio?: GraphCacheResolver<WithTypename<Scenario_Parameters>, Record<string, never>, Scalars['numeric'] | string>,
    lower_pump_wear_head_correction_ratio?: GraphCacheResolver<WithTypename<Scenario_Parameters>, Record<string, never>, Scalars['numeric'] | string>,
    lower_use_legacy_gas_head_rerate?: GraphCacheResolver<WithTypename<Scenario_Parameters>, Record<string, never>, Scalars['Boolean'] | string>,
    maximum_frequency?: GraphCacheResolver<WithTypename<Scenario_Parameters>, Record<string, never>, Scalars['numeric'] | string>,
    minimum_frequency?: GraphCacheResolver<WithTypename<Scenario_Parameters>, Record<string, never>, Scalars['numeric'] | string>,
    motor_rerate_ratio?: GraphCacheResolver<WithTypename<Scenario_Parameters>, Record<string, never>, Scalars['numeric'] | string>,
    motor_shroud_interior_diameter_inches?: GraphCacheResolver<WithTypename<Scenario_Parameters>, Record<string, never>, Scalars['numeric'] | string>,
    natural_gas_separation_override_type?: GraphCacheResolver<WithTypename<Scenario_Parameters>, Record<string, never>, Scalars['String'] | string>,
    natural_override_gas_separation_percent?: GraphCacheResolver<WithTypename<Scenario_Parameters>, Record<string, never>, Scalars['numeric'] | string>,
    parent_id?: GraphCacheResolver<WithTypename<Scenario_Parameters>, Record<string, never>, Scalars['uuid'] | string>,
    pump_hz?: GraphCacheResolver<WithTypename<Scenario_Parameters>, Record<string, never>, Scalars['numeric'] | string>,
    pump_override_gas_correction_percent?: GraphCacheResolver<WithTypename<Scenario_Parameters>, Record<string, never>, Scalars['numeric'] | string>,
    pump_wear_brake_horsepower_correction_ratio?: GraphCacheResolver<WithTypename<Scenario_Parameters>, Record<string, never>, Scalars['numeric'] | string>,
    pump_wear_head_correction_ratio?: GraphCacheResolver<WithTypename<Scenario_Parameters>, Record<string, never>, Scalars['numeric'] | string>,
    surface_drive_incoming_power_volts?: GraphCacheResolver<WithTypename<Scenario_Parameters>, Record<string, never>, Scalars['numeric'] | string>,
    target_liquid_rate_std_barrel_day?: GraphCacheResolver<WithTypename<Scenario_Parameters>, Record<string, never>, Scalars['numeric'] | string>,
    use_legacy_gas_head_rerate?: GraphCacheResolver<WithTypename<Scenario_Parameters>, Record<string, never>, Scalars['Boolean'] | string>,
    vsd_input_voltage?: GraphCacheResolver<WithTypename<Scenario_Parameters>, Record<string, never>, Scalars['numeric'] | string>,
    winning_revision_author_id?: GraphCacheResolver<WithTypename<Scenario_Parameters>, Record<string, never>, Scalars['String'] | string>,
    winning_revision_created_at?: GraphCacheResolver<WithTypename<Scenario_Parameters>, Record<string, never>, Scalars['timestamptz'] | string>,
    winning_revision_deleted_at?: GraphCacheResolver<WithTypename<Scenario_Parameters>, Record<string, never>, Scalars['timestamptz'] | string>,
    winning_revision_id?: GraphCacheResolver<WithTypename<Scenario_Parameters>, Record<string, never>, Scalars['uuid'] | string>,
    winning_revision_parent_id?: GraphCacheResolver<WithTypename<Scenario_Parameters>, Record<string, never>, Scalars['uuid'] | string>,
    winning_revision_updated_at?: GraphCacheResolver<WithTypename<Scenario_Parameters>, Record<string, never>, Scalars['timestamptz'] | string>
  },
  scenario_parameters_aggregate?: {
    aggregate?: GraphCacheResolver<WithTypename<Scenario_Parameters_Aggregate>, Record<string, never>, WithTypename<Scenario_Parameters_Aggregate_Fields> | string>,
    nodes?: GraphCacheResolver<WithTypename<Scenario_Parameters_Aggregate>, Record<string, never>, Array<WithTypename<Scenario_Parameters> | string>>
  },
  scenario_parameters_aggregate_fields?: {
    avg?: GraphCacheResolver<WithTypename<Scenario_Parameters_Aggregate_Fields>, Record<string, never>, WithTypename<Scenario_Parameters_Avg_Fields> | string>,
    count?: GraphCacheResolver<WithTypename<Scenario_Parameters_Aggregate_Fields>, Scenario_Parameters_Aggregate_FieldsCountArgs, Scalars['Int'] | string>,
    max?: GraphCacheResolver<WithTypename<Scenario_Parameters_Aggregate_Fields>, Record<string, never>, WithTypename<Scenario_Parameters_Max_Fields> | string>,
    min?: GraphCacheResolver<WithTypename<Scenario_Parameters_Aggregate_Fields>, Record<string, never>, WithTypename<Scenario_Parameters_Min_Fields> | string>,
    stddev?: GraphCacheResolver<WithTypename<Scenario_Parameters_Aggregate_Fields>, Record<string, never>, WithTypename<Scenario_Parameters_Stddev_Fields> | string>,
    stddev_pop?: GraphCacheResolver<WithTypename<Scenario_Parameters_Aggregate_Fields>, Record<string, never>, WithTypename<Scenario_Parameters_Stddev_Pop_Fields> | string>,
    stddev_samp?: GraphCacheResolver<WithTypename<Scenario_Parameters_Aggregate_Fields>, Record<string, never>, WithTypename<Scenario_Parameters_Stddev_Samp_Fields> | string>,
    sum?: GraphCacheResolver<WithTypename<Scenario_Parameters_Aggregate_Fields>, Record<string, never>, WithTypename<Scenario_Parameters_Sum_Fields> | string>,
    var_pop?: GraphCacheResolver<WithTypename<Scenario_Parameters_Aggregate_Fields>, Record<string, never>, WithTypename<Scenario_Parameters_Var_Pop_Fields> | string>,
    var_samp?: GraphCacheResolver<WithTypename<Scenario_Parameters_Aggregate_Fields>, Record<string, never>, WithTypename<Scenario_Parameters_Var_Samp_Fields> | string>,
    variance?: GraphCacheResolver<WithTypename<Scenario_Parameters_Aggregate_Fields>, Record<string, never>, WithTypename<Scenario_Parameters_Variance_Fields> | string>
  },
  scenario_parameters_avg_fields?: {
    bottom_casing_pressure_psia?: GraphCacheResolver<WithTypename<Scenario_Parameters_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bottom_tubing_pressure_psia?: GraphCacheResolver<WithTypename<Scenario_Parameters_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    cable_cost_kw_hr_usd?: GraphCacheResolver<WithTypename<Scenario_Parameters_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    elevation_feet_asl?: GraphCacheResolver<WithTypename<Scenario_Parameters_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    intake_override_gas_separation_percent?: GraphCacheResolver<WithTypename<Scenario_Parameters_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    lower_intake_override_gas_separation_percent?: GraphCacheResolver<WithTypename<Scenario_Parameters_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    lower_motor_rerate_ratio?: GraphCacheResolver<WithTypename<Scenario_Parameters_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    lower_motor_shroud_interior_diameter_inches?: GraphCacheResolver<WithTypename<Scenario_Parameters_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    lower_natural_override_gas_separation_percent?: GraphCacheResolver<WithTypename<Scenario_Parameters_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    lower_pump_hz?: GraphCacheResolver<WithTypename<Scenario_Parameters_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    lower_pump_override_gas_correction_percent?: GraphCacheResolver<WithTypename<Scenario_Parameters_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    lower_pump_wear_brake_horsepower_correction_ratio?: GraphCacheResolver<WithTypename<Scenario_Parameters_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    lower_pump_wear_head_correction_ratio?: GraphCacheResolver<WithTypename<Scenario_Parameters_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    maximum_frequency?: GraphCacheResolver<WithTypename<Scenario_Parameters_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    minimum_frequency?: GraphCacheResolver<WithTypename<Scenario_Parameters_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    motor_rerate_ratio?: GraphCacheResolver<WithTypename<Scenario_Parameters_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    motor_shroud_interior_diameter_inches?: GraphCacheResolver<WithTypename<Scenario_Parameters_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    natural_override_gas_separation_percent?: GraphCacheResolver<WithTypename<Scenario_Parameters_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pump_hz?: GraphCacheResolver<WithTypename<Scenario_Parameters_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pump_override_gas_correction_percent?: GraphCacheResolver<WithTypename<Scenario_Parameters_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pump_wear_brake_horsepower_correction_ratio?: GraphCacheResolver<WithTypename<Scenario_Parameters_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pump_wear_head_correction_ratio?: GraphCacheResolver<WithTypename<Scenario_Parameters_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    surface_drive_incoming_power_volts?: GraphCacheResolver<WithTypename<Scenario_Parameters_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    target_liquid_rate_std_barrel_day?: GraphCacheResolver<WithTypename<Scenario_Parameters_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    vsd_input_voltage?: GraphCacheResolver<WithTypename<Scenario_Parameters_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  scenario_parameters_max_fields?: {
    bottom_casing_pressure_psia?: GraphCacheResolver<WithTypename<Scenario_Parameters_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    bottom_tubing_pressure_psia?: GraphCacheResolver<WithTypename<Scenario_Parameters_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    cable_cost_kw_hr_usd?: GraphCacheResolver<WithTypename<Scenario_Parameters_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    elevation_feet_asl?: GraphCacheResolver<WithTypename<Scenario_Parameters_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    flow_model?: GraphCacheResolver<WithTypename<Scenario_Parameters_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    id?: GraphCacheResolver<WithTypename<Scenario_Parameters_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    intake_gas_separation_override_type?: GraphCacheResolver<WithTypename<Scenario_Parameters_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    intake_override_gas_separation_percent?: GraphCacheResolver<WithTypename<Scenario_Parameters_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    journal_author_id?: GraphCacheResolver<WithTypename<Scenario_Parameters_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    journal_created_at?: GraphCacheResolver<WithTypename<Scenario_Parameters_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    journal_deleted_at?: GraphCacheResolver<WithTypename<Scenario_Parameters_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    journal_updated_at?: GraphCacheResolver<WithTypename<Scenario_Parameters_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    lower_intake_gas_separation_override_type?: GraphCacheResolver<WithTypename<Scenario_Parameters_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    lower_intake_override_gas_separation_percent?: GraphCacheResolver<WithTypename<Scenario_Parameters_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    lower_motor_rerate_ratio?: GraphCacheResolver<WithTypename<Scenario_Parameters_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    lower_motor_shroud_interior_diameter_inches?: GraphCacheResolver<WithTypename<Scenario_Parameters_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    lower_natural_gas_separation_override_type?: GraphCacheResolver<WithTypename<Scenario_Parameters_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    lower_natural_override_gas_separation_percent?: GraphCacheResolver<WithTypename<Scenario_Parameters_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    lower_pump_hz?: GraphCacheResolver<WithTypename<Scenario_Parameters_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    lower_pump_override_gas_correction_percent?: GraphCacheResolver<WithTypename<Scenario_Parameters_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    lower_pump_wear_brake_horsepower_correction_ratio?: GraphCacheResolver<WithTypename<Scenario_Parameters_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    lower_pump_wear_head_correction_ratio?: GraphCacheResolver<WithTypename<Scenario_Parameters_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    maximum_frequency?: GraphCacheResolver<WithTypename<Scenario_Parameters_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    minimum_frequency?: GraphCacheResolver<WithTypename<Scenario_Parameters_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    motor_rerate_ratio?: GraphCacheResolver<WithTypename<Scenario_Parameters_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    motor_shroud_interior_diameter_inches?: GraphCacheResolver<WithTypename<Scenario_Parameters_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    natural_gas_separation_override_type?: GraphCacheResolver<WithTypename<Scenario_Parameters_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    natural_override_gas_separation_percent?: GraphCacheResolver<WithTypename<Scenario_Parameters_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    parent_id?: GraphCacheResolver<WithTypename<Scenario_Parameters_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    pump_hz?: GraphCacheResolver<WithTypename<Scenario_Parameters_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    pump_override_gas_correction_percent?: GraphCacheResolver<WithTypename<Scenario_Parameters_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    pump_wear_brake_horsepower_correction_ratio?: GraphCacheResolver<WithTypename<Scenario_Parameters_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    pump_wear_head_correction_ratio?: GraphCacheResolver<WithTypename<Scenario_Parameters_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    surface_drive_incoming_power_volts?: GraphCacheResolver<WithTypename<Scenario_Parameters_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    target_liquid_rate_std_barrel_day?: GraphCacheResolver<WithTypename<Scenario_Parameters_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    vsd_input_voltage?: GraphCacheResolver<WithTypename<Scenario_Parameters_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    winning_revision_author_id?: GraphCacheResolver<WithTypename<Scenario_Parameters_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    winning_revision_created_at?: GraphCacheResolver<WithTypename<Scenario_Parameters_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    winning_revision_deleted_at?: GraphCacheResolver<WithTypename<Scenario_Parameters_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    winning_revision_id?: GraphCacheResolver<WithTypename<Scenario_Parameters_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    winning_revision_parent_id?: GraphCacheResolver<WithTypename<Scenario_Parameters_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    winning_revision_updated_at?: GraphCacheResolver<WithTypename<Scenario_Parameters_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>
  },
  scenario_parameters_min_fields?: {
    bottom_casing_pressure_psia?: GraphCacheResolver<WithTypename<Scenario_Parameters_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    bottom_tubing_pressure_psia?: GraphCacheResolver<WithTypename<Scenario_Parameters_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    cable_cost_kw_hr_usd?: GraphCacheResolver<WithTypename<Scenario_Parameters_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    elevation_feet_asl?: GraphCacheResolver<WithTypename<Scenario_Parameters_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    flow_model?: GraphCacheResolver<WithTypename<Scenario_Parameters_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    id?: GraphCacheResolver<WithTypename<Scenario_Parameters_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    intake_gas_separation_override_type?: GraphCacheResolver<WithTypename<Scenario_Parameters_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    intake_override_gas_separation_percent?: GraphCacheResolver<WithTypename<Scenario_Parameters_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    journal_author_id?: GraphCacheResolver<WithTypename<Scenario_Parameters_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    journal_created_at?: GraphCacheResolver<WithTypename<Scenario_Parameters_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    journal_deleted_at?: GraphCacheResolver<WithTypename<Scenario_Parameters_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    journal_updated_at?: GraphCacheResolver<WithTypename<Scenario_Parameters_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    lower_intake_gas_separation_override_type?: GraphCacheResolver<WithTypename<Scenario_Parameters_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    lower_intake_override_gas_separation_percent?: GraphCacheResolver<WithTypename<Scenario_Parameters_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    lower_motor_rerate_ratio?: GraphCacheResolver<WithTypename<Scenario_Parameters_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    lower_motor_shroud_interior_diameter_inches?: GraphCacheResolver<WithTypename<Scenario_Parameters_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    lower_natural_gas_separation_override_type?: GraphCacheResolver<WithTypename<Scenario_Parameters_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    lower_natural_override_gas_separation_percent?: GraphCacheResolver<WithTypename<Scenario_Parameters_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    lower_pump_hz?: GraphCacheResolver<WithTypename<Scenario_Parameters_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    lower_pump_override_gas_correction_percent?: GraphCacheResolver<WithTypename<Scenario_Parameters_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    lower_pump_wear_brake_horsepower_correction_ratio?: GraphCacheResolver<WithTypename<Scenario_Parameters_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    lower_pump_wear_head_correction_ratio?: GraphCacheResolver<WithTypename<Scenario_Parameters_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    maximum_frequency?: GraphCacheResolver<WithTypename<Scenario_Parameters_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    minimum_frequency?: GraphCacheResolver<WithTypename<Scenario_Parameters_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    motor_rerate_ratio?: GraphCacheResolver<WithTypename<Scenario_Parameters_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    motor_shroud_interior_diameter_inches?: GraphCacheResolver<WithTypename<Scenario_Parameters_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    natural_gas_separation_override_type?: GraphCacheResolver<WithTypename<Scenario_Parameters_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    natural_override_gas_separation_percent?: GraphCacheResolver<WithTypename<Scenario_Parameters_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    parent_id?: GraphCacheResolver<WithTypename<Scenario_Parameters_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    pump_hz?: GraphCacheResolver<WithTypename<Scenario_Parameters_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    pump_override_gas_correction_percent?: GraphCacheResolver<WithTypename<Scenario_Parameters_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    pump_wear_brake_horsepower_correction_ratio?: GraphCacheResolver<WithTypename<Scenario_Parameters_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    pump_wear_head_correction_ratio?: GraphCacheResolver<WithTypename<Scenario_Parameters_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    surface_drive_incoming_power_volts?: GraphCacheResolver<WithTypename<Scenario_Parameters_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    target_liquid_rate_std_barrel_day?: GraphCacheResolver<WithTypename<Scenario_Parameters_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    vsd_input_voltage?: GraphCacheResolver<WithTypename<Scenario_Parameters_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    winning_revision_author_id?: GraphCacheResolver<WithTypename<Scenario_Parameters_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    winning_revision_created_at?: GraphCacheResolver<WithTypename<Scenario_Parameters_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    winning_revision_deleted_at?: GraphCacheResolver<WithTypename<Scenario_Parameters_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    winning_revision_id?: GraphCacheResolver<WithTypename<Scenario_Parameters_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    winning_revision_parent_id?: GraphCacheResolver<WithTypename<Scenario_Parameters_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    winning_revision_updated_at?: GraphCacheResolver<WithTypename<Scenario_Parameters_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>
  },
  scenario_parameters_stddev_fields?: {
    bottom_casing_pressure_psia?: GraphCacheResolver<WithTypename<Scenario_Parameters_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bottom_tubing_pressure_psia?: GraphCacheResolver<WithTypename<Scenario_Parameters_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    cable_cost_kw_hr_usd?: GraphCacheResolver<WithTypename<Scenario_Parameters_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    elevation_feet_asl?: GraphCacheResolver<WithTypename<Scenario_Parameters_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    intake_override_gas_separation_percent?: GraphCacheResolver<WithTypename<Scenario_Parameters_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    lower_intake_override_gas_separation_percent?: GraphCacheResolver<WithTypename<Scenario_Parameters_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    lower_motor_rerate_ratio?: GraphCacheResolver<WithTypename<Scenario_Parameters_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    lower_motor_shroud_interior_diameter_inches?: GraphCacheResolver<WithTypename<Scenario_Parameters_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    lower_natural_override_gas_separation_percent?: GraphCacheResolver<WithTypename<Scenario_Parameters_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    lower_pump_hz?: GraphCacheResolver<WithTypename<Scenario_Parameters_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    lower_pump_override_gas_correction_percent?: GraphCacheResolver<WithTypename<Scenario_Parameters_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    lower_pump_wear_brake_horsepower_correction_ratio?: GraphCacheResolver<WithTypename<Scenario_Parameters_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    lower_pump_wear_head_correction_ratio?: GraphCacheResolver<WithTypename<Scenario_Parameters_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    maximum_frequency?: GraphCacheResolver<WithTypename<Scenario_Parameters_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    minimum_frequency?: GraphCacheResolver<WithTypename<Scenario_Parameters_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    motor_rerate_ratio?: GraphCacheResolver<WithTypename<Scenario_Parameters_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    motor_shroud_interior_diameter_inches?: GraphCacheResolver<WithTypename<Scenario_Parameters_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    natural_override_gas_separation_percent?: GraphCacheResolver<WithTypename<Scenario_Parameters_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pump_hz?: GraphCacheResolver<WithTypename<Scenario_Parameters_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pump_override_gas_correction_percent?: GraphCacheResolver<WithTypename<Scenario_Parameters_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pump_wear_brake_horsepower_correction_ratio?: GraphCacheResolver<WithTypename<Scenario_Parameters_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pump_wear_head_correction_ratio?: GraphCacheResolver<WithTypename<Scenario_Parameters_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    surface_drive_incoming_power_volts?: GraphCacheResolver<WithTypename<Scenario_Parameters_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    target_liquid_rate_std_barrel_day?: GraphCacheResolver<WithTypename<Scenario_Parameters_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    vsd_input_voltage?: GraphCacheResolver<WithTypename<Scenario_Parameters_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  scenario_parameters_stddev_pop_fields?: {
    bottom_casing_pressure_psia?: GraphCacheResolver<WithTypename<Scenario_Parameters_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bottom_tubing_pressure_psia?: GraphCacheResolver<WithTypename<Scenario_Parameters_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    cable_cost_kw_hr_usd?: GraphCacheResolver<WithTypename<Scenario_Parameters_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    elevation_feet_asl?: GraphCacheResolver<WithTypename<Scenario_Parameters_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    intake_override_gas_separation_percent?: GraphCacheResolver<WithTypename<Scenario_Parameters_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    lower_intake_override_gas_separation_percent?: GraphCacheResolver<WithTypename<Scenario_Parameters_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    lower_motor_rerate_ratio?: GraphCacheResolver<WithTypename<Scenario_Parameters_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    lower_motor_shroud_interior_diameter_inches?: GraphCacheResolver<WithTypename<Scenario_Parameters_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    lower_natural_override_gas_separation_percent?: GraphCacheResolver<WithTypename<Scenario_Parameters_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    lower_pump_hz?: GraphCacheResolver<WithTypename<Scenario_Parameters_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    lower_pump_override_gas_correction_percent?: GraphCacheResolver<WithTypename<Scenario_Parameters_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    lower_pump_wear_brake_horsepower_correction_ratio?: GraphCacheResolver<WithTypename<Scenario_Parameters_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    lower_pump_wear_head_correction_ratio?: GraphCacheResolver<WithTypename<Scenario_Parameters_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    maximum_frequency?: GraphCacheResolver<WithTypename<Scenario_Parameters_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    minimum_frequency?: GraphCacheResolver<WithTypename<Scenario_Parameters_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    motor_rerate_ratio?: GraphCacheResolver<WithTypename<Scenario_Parameters_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    motor_shroud_interior_diameter_inches?: GraphCacheResolver<WithTypename<Scenario_Parameters_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    natural_override_gas_separation_percent?: GraphCacheResolver<WithTypename<Scenario_Parameters_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pump_hz?: GraphCacheResolver<WithTypename<Scenario_Parameters_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pump_override_gas_correction_percent?: GraphCacheResolver<WithTypename<Scenario_Parameters_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pump_wear_brake_horsepower_correction_ratio?: GraphCacheResolver<WithTypename<Scenario_Parameters_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pump_wear_head_correction_ratio?: GraphCacheResolver<WithTypename<Scenario_Parameters_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    surface_drive_incoming_power_volts?: GraphCacheResolver<WithTypename<Scenario_Parameters_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    target_liquid_rate_std_barrel_day?: GraphCacheResolver<WithTypename<Scenario_Parameters_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    vsd_input_voltage?: GraphCacheResolver<WithTypename<Scenario_Parameters_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  scenario_parameters_stddev_samp_fields?: {
    bottom_casing_pressure_psia?: GraphCacheResolver<WithTypename<Scenario_Parameters_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bottom_tubing_pressure_psia?: GraphCacheResolver<WithTypename<Scenario_Parameters_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    cable_cost_kw_hr_usd?: GraphCacheResolver<WithTypename<Scenario_Parameters_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    elevation_feet_asl?: GraphCacheResolver<WithTypename<Scenario_Parameters_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    intake_override_gas_separation_percent?: GraphCacheResolver<WithTypename<Scenario_Parameters_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    lower_intake_override_gas_separation_percent?: GraphCacheResolver<WithTypename<Scenario_Parameters_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    lower_motor_rerate_ratio?: GraphCacheResolver<WithTypename<Scenario_Parameters_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    lower_motor_shroud_interior_diameter_inches?: GraphCacheResolver<WithTypename<Scenario_Parameters_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    lower_natural_override_gas_separation_percent?: GraphCacheResolver<WithTypename<Scenario_Parameters_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    lower_pump_hz?: GraphCacheResolver<WithTypename<Scenario_Parameters_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    lower_pump_override_gas_correction_percent?: GraphCacheResolver<WithTypename<Scenario_Parameters_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    lower_pump_wear_brake_horsepower_correction_ratio?: GraphCacheResolver<WithTypename<Scenario_Parameters_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    lower_pump_wear_head_correction_ratio?: GraphCacheResolver<WithTypename<Scenario_Parameters_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    maximum_frequency?: GraphCacheResolver<WithTypename<Scenario_Parameters_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    minimum_frequency?: GraphCacheResolver<WithTypename<Scenario_Parameters_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    motor_rerate_ratio?: GraphCacheResolver<WithTypename<Scenario_Parameters_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    motor_shroud_interior_diameter_inches?: GraphCacheResolver<WithTypename<Scenario_Parameters_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    natural_override_gas_separation_percent?: GraphCacheResolver<WithTypename<Scenario_Parameters_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pump_hz?: GraphCacheResolver<WithTypename<Scenario_Parameters_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pump_override_gas_correction_percent?: GraphCacheResolver<WithTypename<Scenario_Parameters_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pump_wear_brake_horsepower_correction_ratio?: GraphCacheResolver<WithTypename<Scenario_Parameters_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pump_wear_head_correction_ratio?: GraphCacheResolver<WithTypename<Scenario_Parameters_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    surface_drive_incoming_power_volts?: GraphCacheResolver<WithTypename<Scenario_Parameters_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    target_liquid_rate_std_barrel_day?: GraphCacheResolver<WithTypename<Scenario_Parameters_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    vsd_input_voltage?: GraphCacheResolver<WithTypename<Scenario_Parameters_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  scenario_parameters_sum_fields?: {
    bottom_casing_pressure_psia?: GraphCacheResolver<WithTypename<Scenario_Parameters_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    bottom_tubing_pressure_psia?: GraphCacheResolver<WithTypename<Scenario_Parameters_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    cable_cost_kw_hr_usd?: GraphCacheResolver<WithTypename<Scenario_Parameters_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    elevation_feet_asl?: GraphCacheResolver<WithTypename<Scenario_Parameters_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    intake_override_gas_separation_percent?: GraphCacheResolver<WithTypename<Scenario_Parameters_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    lower_intake_override_gas_separation_percent?: GraphCacheResolver<WithTypename<Scenario_Parameters_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    lower_motor_rerate_ratio?: GraphCacheResolver<WithTypename<Scenario_Parameters_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    lower_motor_shroud_interior_diameter_inches?: GraphCacheResolver<WithTypename<Scenario_Parameters_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    lower_natural_override_gas_separation_percent?: GraphCacheResolver<WithTypename<Scenario_Parameters_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    lower_pump_hz?: GraphCacheResolver<WithTypename<Scenario_Parameters_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    lower_pump_override_gas_correction_percent?: GraphCacheResolver<WithTypename<Scenario_Parameters_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    lower_pump_wear_brake_horsepower_correction_ratio?: GraphCacheResolver<WithTypename<Scenario_Parameters_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    lower_pump_wear_head_correction_ratio?: GraphCacheResolver<WithTypename<Scenario_Parameters_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    maximum_frequency?: GraphCacheResolver<WithTypename<Scenario_Parameters_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    minimum_frequency?: GraphCacheResolver<WithTypename<Scenario_Parameters_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    motor_rerate_ratio?: GraphCacheResolver<WithTypename<Scenario_Parameters_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    motor_shroud_interior_diameter_inches?: GraphCacheResolver<WithTypename<Scenario_Parameters_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    natural_override_gas_separation_percent?: GraphCacheResolver<WithTypename<Scenario_Parameters_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    pump_hz?: GraphCacheResolver<WithTypename<Scenario_Parameters_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    pump_override_gas_correction_percent?: GraphCacheResolver<WithTypename<Scenario_Parameters_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    pump_wear_brake_horsepower_correction_ratio?: GraphCacheResolver<WithTypename<Scenario_Parameters_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    pump_wear_head_correction_ratio?: GraphCacheResolver<WithTypename<Scenario_Parameters_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    surface_drive_incoming_power_volts?: GraphCacheResolver<WithTypename<Scenario_Parameters_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    target_liquid_rate_std_barrel_day?: GraphCacheResolver<WithTypename<Scenario_Parameters_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    vsd_input_voltage?: GraphCacheResolver<WithTypename<Scenario_Parameters_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>
  },
  scenario_parameters_var_pop_fields?: {
    bottom_casing_pressure_psia?: GraphCacheResolver<WithTypename<Scenario_Parameters_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bottom_tubing_pressure_psia?: GraphCacheResolver<WithTypename<Scenario_Parameters_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    cable_cost_kw_hr_usd?: GraphCacheResolver<WithTypename<Scenario_Parameters_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    elevation_feet_asl?: GraphCacheResolver<WithTypename<Scenario_Parameters_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    intake_override_gas_separation_percent?: GraphCacheResolver<WithTypename<Scenario_Parameters_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    lower_intake_override_gas_separation_percent?: GraphCacheResolver<WithTypename<Scenario_Parameters_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    lower_motor_rerate_ratio?: GraphCacheResolver<WithTypename<Scenario_Parameters_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    lower_motor_shroud_interior_diameter_inches?: GraphCacheResolver<WithTypename<Scenario_Parameters_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    lower_natural_override_gas_separation_percent?: GraphCacheResolver<WithTypename<Scenario_Parameters_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    lower_pump_hz?: GraphCacheResolver<WithTypename<Scenario_Parameters_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    lower_pump_override_gas_correction_percent?: GraphCacheResolver<WithTypename<Scenario_Parameters_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    lower_pump_wear_brake_horsepower_correction_ratio?: GraphCacheResolver<WithTypename<Scenario_Parameters_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    lower_pump_wear_head_correction_ratio?: GraphCacheResolver<WithTypename<Scenario_Parameters_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    maximum_frequency?: GraphCacheResolver<WithTypename<Scenario_Parameters_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    minimum_frequency?: GraphCacheResolver<WithTypename<Scenario_Parameters_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    motor_rerate_ratio?: GraphCacheResolver<WithTypename<Scenario_Parameters_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    motor_shroud_interior_diameter_inches?: GraphCacheResolver<WithTypename<Scenario_Parameters_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    natural_override_gas_separation_percent?: GraphCacheResolver<WithTypename<Scenario_Parameters_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pump_hz?: GraphCacheResolver<WithTypename<Scenario_Parameters_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pump_override_gas_correction_percent?: GraphCacheResolver<WithTypename<Scenario_Parameters_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pump_wear_brake_horsepower_correction_ratio?: GraphCacheResolver<WithTypename<Scenario_Parameters_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pump_wear_head_correction_ratio?: GraphCacheResolver<WithTypename<Scenario_Parameters_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    surface_drive_incoming_power_volts?: GraphCacheResolver<WithTypename<Scenario_Parameters_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    target_liquid_rate_std_barrel_day?: GraphCacheResolver<WithTypename<Scenario_Parameters_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    vsd_input_voltage?: GraphCacheResolver<WithTypename<Scenario_Parameters_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  scenario_parameters_var_samp_fields?: {
    bottom_casing_pressure_psia?: GraphCacheResolver<WithTypename<Scenario_Parameters_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bottom_tubing_pressure_psia?: GraphCacheResolver<WithTypename<Scenario_Parameters_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    cable_cost_kw_hr_usd?: GraphCacheResolver<WithTypename<Scenario_Parameters_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    elevation_feet_asl?: GraphCacheResolver<WithTypename<Scenario_Parameters_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    intake_override_gas_separation_percent?: GraphCacheResolver<WithTypename<Scenario_Parameters_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    lower_intake_override_gas_separation_percent?: GraphCacheResolver<WithTypename<Scenario_Parameters_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    lower_motor_rerate_ratio?: GraphCacheResolver<WithTypename<Scenario_Parameters_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    lower_motor_shroud_interior_diameter_inches?: GraphCacheResolver<WithTypename<Scenario_Parameters_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    lower_natural_override_gas_separation_percent?: GraphCacheResolver<WithTypename<Scenario_Parameters_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    lower_pump_hz?: GraphCacheResolver<WithTypename<Scenario_Parameters_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    lower_pump_override_gas_correction_percent?: GraphCacheResolver<WithTypename<Scenario_Parameters_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    lower_pump_wear_brake_horsepower_correction_ratio?: GraphCacheResolver<WithTypename<Scenario_Parameters_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    lower_pump_wear_head_correction_ratio?: GraphCacheResolver<WithTypename<Scenario_Parameters_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    maximum_frequency?: GraphCacheResolver<WithTypename<Scenario_Parameters_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    minimum_frequency?: GraphCacheResolver<WithTypename<Scenario_Parameters_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    motor_rerate_ratio?: GraphCacheResolver<WithTypename<Scenario_Parameters_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    motor_shroud_interior_diameter_inches?: GraphCacheResolver<WithTypename<Scenario_Parameters_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    natural_override_gas_separation_percent?: GraphCacheResolver<WithTypename<Scenario_Parameters_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pump_hz?: GraphCacheResolver<WithTypename<Scenario_Parameters_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pump_override_gas_correction_percent?: GraphCacheResolver<WithTypename<Scenario_Parameters_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pump_wear_brake_horsepower_correction_ratio?: GraphCacheResolver<WithTypename<Scenario_Parameters_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pump_wear_head_correction_ratio?: GraphCacheResolver<WithTypename<Scenario_Parameters_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    surface_drive_incoming_power_volts?: GraphCacheResolver<WithTypename<Scenario_Parameters_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    target_liquid_rate_std_barrel_day?: GraphCacheResolver<WithTypename<Scenario_Parameters_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    vsd_input_voltage?: GraphCacheResolver<WithTypename<Scenario_Parameters_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  scenario_parameters_variance_fields?: {
    bottom_casing_pressure_psia?: GraphCacheResolver<WithTypename<Scenario_Parameters_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bottom_tubing_pressure_psia?: GraphCacheResolver<WithTypename<Scenario_Parameters_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    cable_cost_kw_hr_usd?: GraphCacheResolver<WithTypename<Scenario_Parameters_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    elevation_feet_asl?: GraphCacheResolver<WithTypename<Scenario_Parameters_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    intake_override_gas_separation_percent?: GraphCacheResolver<WithTypename<Scenario_Parameters_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    lower_intake_override_gas_separation_percent?: GraphCacheResolver<WithTypename<Scenario_Parameters_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    lower_motor_rerate_ratio?: GraphCacheResolver<WithTypename<Scenario_Parameters_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    lower_motor_shroud_interior_diameter_inches?: GraphCacheResolver<WithTypename<Scenario_Parameters_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    lower_natural_override_gas_separation_percent?: GraphCacheResolver<WithTypename<Scenario_Parameters_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    lower_pump_hz?: GraphCacheResolver<WithTypename<Scenario_Parameters_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    lower_pump_override_gas_correction_percent?: GraphCacheResolver<WithTypename<Scenario_Parameters_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    lower_pump_wear_brake_horsepower_correction_ratio?: GraphCacheResolver<WithTypename<Scenario_Parameters_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    lower_pump_wear_head_correction_ratio?: GraphCacheResolver<WithTypename<Scenario_Parameters_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    maximum_frequency?: GraphCacheResolver<WithTypename<Scenario_Parameters_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    minimum_frequency?: GraphCacheResolver<WithTypename<Scenario_Parameters_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    motor_rerate_ratio?: GraphCacheResolver<WithTypename<Scenario_Parameters_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    motor_shroud_interior_diameter_inches?: GraphCacheResolver<WithTypename<Scenario_Parameters_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    natural_override_gas_separation_percent?: GraphCacheResolver<WithTypename<Scenario_Parameters_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pump_hz?: GraphCacheResolver<WithTypename<Scenario_Parameters_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pump_override_gas_correction_percent?: GraphCacheResolver<WithTypename<Scenario_Parameters_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pump_wear_brake_horsepower_correction_ratio?: GraphCacheResolver<WithTypename<Scenario_Parameters_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pump_wear_head_correction_ratio?: GraphCacheResolver<WithTypename<Scenario_Parameters_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    surface_drive_incoming_power_volts?: GraphCacheResolver<WithTypename<Scenario_Parameters_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    target_liquid_rate_std_barrel_day?: GraphCacheResolver<WithTypename<Scenario_Parameters_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    vsd_input_voltage?: GraphCacheResolver<WithTypename<Scenario_Parameters_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  scenario_reasons?: {
    comment?: GraphCacheResolver<WithTypename<Scenario_Reasons>, Record<string, never>, Scalars['String'] | string>,
    value?: GraphCacheResolver<WithTypename<Scenario_Reasons>, Record<string, never>, Scalars['String'] | string>
  },
  scenario_reasons_aggregate?: {
    aggregate?: GraphCacheResolver<WithTypename<Scenario_Reasons_Aggregate>, Record<string, never>, WithTypename<Scenario_Reasons_Aggregate_Fields> | string>,
    nodes?: GraphCacheResolver<WithTypename<Scenario_Reasons_Aggregate>, Record<string, never>, Array<WithTypename<Scenario_Reasons> | string>>
  },
  scenario_reasons_aggregate_fields?: {
    count?: GraphCacheResolver<WithTypename<Scenario_Reasons_Aggregate_Fields>, Scenario_Reasons_Aggregate_FieldsCountArgs, Scalars['Int'] | string>,
    max?: GraphCacheResolver<WithTypename<Scenario_Reasons_Aggregate_Fields>, Record<string, never>, WithTypename<Scenario_Reasons_Max_Fields> | string>,
    min?: GraphCacheResolver<WithTypename<Scenario_Reasons_Aggregate_Fields>, Record<string, never>, WithTypename<Scenario_Reasons_Min_Fields> | string>
  },
  scenario_reasons_max_fields?: {
    comment?: GraphCacheResolver<WithTypename<Scenario_Reasons_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    value?: GraphCacheResolver<WithTypename<Scenario_Reasons_Max_Fields>, Record<string, never>, Scalars['String'] | string>
  },
  scenario_reasons_min_fields?: {
    comment?: GraphCacheResolver<WithTypename<Scenario_Reasons_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    value?: GraphCacheResolver<WithTypename<Scenario_Reasons_Min_Fields>, Record<string, never>, Scalars['String'] | string>
  },
  scenario_reasons_mutation_response?: {
    affected_rows?: GraphCacheResolver<WithTypename<Scenario_Reasons_Mutation_Response>, Record<string, never>, Scalars['Int'] | string>,
    returning?: GraphCacheResolver<WithTypename<Scenario_Reasons_Mutation_Response>, Record<string, never>, Array<WithTypename<Scenario_Reasons> | string>>
  },
  scenario_well_properties?: {
    ar_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties>, Record<string, never>, Scalars['numeric'] | string>,
    average_dls?: GraphCacheResolver<WithTypename<Scenario_Well_Properties>, Record<string, never>, Scalars['numeric'] | string>,
    bottom_casing?: GraphCacheResolver<WithTypename<Scenario_Well_Properties>, Record<string, never>, WithTypename<Casings> | string>,
    bottom_casing_id?: GraphCacheResolver<WithTypename<Scenario_Well_Properties>, Record<string, never>, Scalars['uuid'] | string>,
    bottom_casing_length_feet?: GraphCacheResolver<WithTypename<Scenario_Well_Properties>, Record<string, never>, Scalars['numeric'] | string>,
    bottom_tubing?: GraphCacheResolver<WithTypename<Scenario_Well_Properties>, Record<string, never>, WithTypename<Tubings> | string>,
    bottom_tubing_id?: GraphCacheResolver<WithTypename<Scenario_Well_Properties>, Record<string, never>, Scalars['uuid'] | string>,
    bottom_tubing_length_feet?: GraphCacheResolver<WithTypename<Scenario_Well_Properties>, Record<string, never>, Scalars['numeric'] | string>,
    bottomhole_temperature_fahrenheit?: GraphCacheResolver<WithTypename<Scenario_Well_Properties>, Record<string, never>, Scalars['numeric'] | string>,
    bubble_point_pressure_psia?: GraphCacheResolver<WithTypename<Scenario_Well_Properties>, Record<string, never>, Scalars['numeric'] | string>,
    c1_methane_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties>, Record<string, never>, Scalars['numeric'] | string>,
    c2_ethane_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties>, Record<string, never>, Scalars['numeric'] | string>,
    c3_propane_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties>, Record<string, never>, Scalars['numeric'] | string>,
    c6_hexane_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties>, Record<string, never>, Scalars['numeric'] | string>,
    c7_heptane_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties>, Record<string, never>, Scalars['numeric'] | string>,
    co2_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties>, Record<string, never>, Scalars['numeric'] | string>,
    condensate_api_override?: GraphCacheResolver<WithTypename<Scenario_Well_Properties>, Record<string, never>, Scalars['numeric'] | string>,
    custom_fluid_properties?: GraphCacheResolver<WithTypename<Scenario_Well_Properties>, Scenario_Well_PropertiesCustom_Fluid_PropertiesArgs, Scalars['jsonb'] | string>,
    custom_viscosities_properties?: GraphCacheResolver<WithTypename<Scenario_Well_Properties>, Scenario_Well_PropertiesCustom_Viscosities_PropertiesArgs, Scalars['jsonb'] | string>,
    deviation_survey?: GraphCacheResolver<WithTypename<Scenario_Well_Properties>, Record<string, never>, WithTypename<Deviation_Survey> | string>,
    deviation_survey_id?: GraphCacheResolver<WithTypename<Scenario_Well_Properties>, Record<string, never>, Scalars['uuid'] | string>,
    dew_point_pressure_psia_override?: GraphCacheResolver<WithTypename<Scenario_Well_Properties>, Record<string, never>, Scalars['numeric'] | string>,
    fluid_viscosity_override_cp?: GraphCacheResolver<WithTypename<Scenario_Well_Properties>, Record<string, never>, Scalars['numeric'] | string>,
    gas_specific_gravity?: GraphCacheResolver<WithTypename<Scenario_Well_Properties>, Record<string, never>, Scalars['numeric'] | string>,
    gas_type?: GraphCacheResolver<WithTypename<Scenario_Well_Properties>, Record<string, never>, Scalars['String'] | string>,
    h2s_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties>, Record<string, never>, Scalars['numeric'] | string>,
    hps_liquid_type?: GraphCacheResolver<WithTypename<Scenario_Well_Properties>, Record<string, never>, Scalars['String'] | string>,
    hps_pump_inlet_pressure_psia?: GraphCacheResolver<WithTypename<Scenario_Well_Properties>, Record<string, never>, Scalars['numeric'] | string>,
    hps_pump_inlet_temperature_fahrenheit?: GraphCacheResolver<WithTypename<Scenario_Well_Properties>, Record<string, never>, Scalars['numeric'] | string>,
    hps_required_discharge_pressure_psia?: GraphCacheResolver<WithTypename<Scenario_Well_Properties>, Record<string, never>, Scalars['numeric'] | string>,
    ic4_isobutene_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties>, Record<string, never>, Scalars['numeric'] | string>,
    ic5_isopentane_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties>, Record<string, never>, Scalars['numeric'] | string>,
    id?: GraphCacheResolver<WithTypename<Scenario_Well_Properties>, Record<string, never>, Scalars['uuid'] | string>,
    journal_author_id?: GraphCacheResolver<WithTypename<Scenario_Well_Properties>, Record<string, never>, Scalars['String'] | string>,
    journal_created_at?: GraphCacheResolver<WithTypename<Scenario_Well_Properties>, Record<string, never>, Scalars['timestamptz'] | string>,
    journal_deleted_at?: GraphCacheResolver<WithTypename<Scenario_Well_Properties>, Record<string, never>, Scalars['timestamptz'] | string>,
    journal_updated_at?: GraphCacheResolver<WithTypename<Scenario_Well_Properties>, Record<string, never>, Scalars['timestamptz'] | string>,
    n2_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties>, Record<string, never>, Scalars['numeric'] | string>,
    nc4_butane_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties>, Record<string, never>, Scalars['numeric'] | string>,
    nc5_bentane_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties>, Record<string, never>, Scalars['numeric'] | string>,
    npsha_ft?: GraphCacheResolver<WithTypename<Scenario_Well_Properties>, Record<string, never>, Scalars['numeric'] | string>,
    o2_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties>, Record<string, never>, Scalars['numeric'] | string>,
    oil_gravity_api?: GraphCacheResolver<WithTypename<Scenario_Well_Properties>, Record<string, never>, Scalars['numeric'] | string>,
    parent_id?: GraphCacheResolver<WithTypename<Scenario_Well_Properties>, Record<string, never>, Scalars['uuid'] | string>,
    surface_temperature_fahrenheit?: GraphCacheResolver<WithTypename<Scenario_Well_Properties>, Record<string, never>, Scalars['numeric'] | string>,
    top_casing?: GraphCacheResolver<WithTypename<Scenario_Well_Properties>, Record<string, never>, WithTypename<Casings> | string>,
    top_casing_id?: GraphCacheResolver<WithTypename<Scenario_Well_Properties>, Record<string, never>, Scalars['uuid'] | string>,
    top_casing_length_feet?: GraphCacheResolver<WithTypename<Scenario_Well_Properties>, Record<string, never>, Scalars['numeric'] | string>,
    top_of_perforations_measured_depth_feet?: GraphCacheResolver<WithTypename<Scenario_Well_Properties>, Record<string, never>, Scalars['numeric'] | string>,
    top_of_perforations_true_vertical_depth_feet?: GraphCacheResolver<WithTypename<Scenario_Well_Properties>, Record<string, never>, Scalars['numeric'] | string>,
    top_tubing?: GraphCacheResolver<WithTypename<Scenario_Well_Properties>, Record<string, never>, WithTypename<Tubings> | string>,
    top_tubing_id?: GraphCacheResolver<WithTypename<Scenario_Well_Properties>, Record<string, never>, Scalars['uuid'] | string>,
    top_tubing_length_feet?: GraphCacheResolver<WithTypename<Scenario_Well_Properties>, Record<string, never>, Scalars['numeric'] | string>,
    water_specific_gravity?: GraphCacheResolver<WithTypename<Scenario_Well_Properties>, Record<string, never>, Scalars['numeric'] | string>,
    well_test_datum_point_measured_depth_feet?: GraphCacheResolver<WithTypename<Scenario_Well_Properties>, Record<string, never>, Scalars['numeric'] | string>,
    well_test_gas_input_type?: GraphCacheResolver<WithTypename<Scenario_Well_Properties>, Record<string, never>, Scalars['String'] | string>,
    well_test_gas_rate_mscf_day?: GraphCacheResolver<WithTypename<Scenario_Well_Properties>, Record<string, never>, Scalars['numeric'] | string>,
    well_test_liquid_input_type?: GraphCacheResolver<WithTypename<Scenario_Well_Properties>, Record<string, never>, Scalars['String'] | string>,
    well_test_oil_rate_stb_day?: GraphCacheResolver<WithTypename<Scenario_Well_Properties>, Record<string, never>, Scalars['numeric'] | string>,
    well_test_pressure_input_type?: GraphCacheResolver<WithTypename<Scenario_Well_Properties>, Record<string, never>, Scalars['String'] | string>,
    well_test_producing_bottom_hole_pressure_psia?: GraphCacheResolver<WithTypename<Scenario_Well_Properties>, Record<string, never>, Scalars['numeric'] | string>,
    well_test_productivity_index?: GraphCacheResolver<WithTypename<Scenario_Well_Properties>, Record<string, never>, Scalars['numeric'] | string>,
    well_test_static_bottom_hole_pressure_psia?: GraphCacheResolver<WithTypename<Scenario_Well_Properties>, Record<string, never>, Scalars['numeric'] | string>,
    well_test_test_date?: GraphCacheResolver<WithTypename<Scenario_Well_Properties>, Record<string, never>, Scalars['timestamptz'] | string>,
    well_test_water_rate_stb_day?: GraphCacheResolver<WithTypename<Scenario_Well_Properties>, Record<string, never>, Scalars['numeric'] | string>,
    winning_revision_author_id?: GraphCacheResolver<WithTypename<Scenario_Well_Properties>, Record<string, never>, Scalars['String'] | string>,
    winning_revision_created_at?: GraphCacheResolver<WithTypename<Scenario_Well_Properties>, Record<string, never>, Scalars['timestamptz'] | string>,
    winning_revision_deleted_at?: GraphCacheResolver<WithTypename<Scenario_Well_Properties>, Record<string, never>, Scalars['timestamptz'] | string>,
    winning_revision_id?: GraphCacheResolver<WithTypename<Scenario_Well_Properties>, Record<string, never>, Scalars['uuid'] | string>,
    winning_revision_parent_id?: GraphCacheResolver<WithTypename<Scenario_Well_Properties>, Record<string, never>, Scalars['uuid'] | string>,
    winning_revision_updated_at?: GraphCacheResolver<WithTypename<Scenario_Well_Properties>, Record<string, never>, Scalars['timestamptz'] | string>
  },
  scenario_well_properties_aggregate?: {
    aggregate?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Aggregate>, Record<string, never>, WithTypename<Scenario_Well_Properties_Aggregate_Fields> | string>,
    nodes?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Aggregate>, Record<string, never>, Array<WithTypename<Scenario_Well_Properties> | string>>
  },
  scenario_well_properties_aggregate_fields?: {
    avg?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Aggregate_Fields>, Record<string, never>, WithTypename<Scenario_Well_Properties_Avg_Fields> | string>,
    count?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Aggregate_Fields>, Scenario_Well_Properties_Aggregate_FieldsCountArgs, Scalars['Int'] | string>,
    max?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Aggregate_Fields>, Record<string, never>, WithTypename<Scenario_Well_Properties_Max_Fields> | string>,
    min?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Aggregate_Fields>, Record<string, never>, WithTypename<Scenario_Well_Properties_Min_Fields> | string>,
    stddev?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Aggregate_Fields>, Record<string, never>, WithTypename<Scenario_Well_Properties_Stddev_Fields> | string>,
    stddev_pop?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Aggregate_Fields>, Record<string, never>, WithTypename<Scenario_Well_Properties_Stddev_Pop_Fields> | string>,
    stddev_samp?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Aggregate_Fields>, Record<string, never>, WithTypename<Scenario_Well_Properties_Stddev_Samp_Fields> | string>,
    sum?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Aggregate_Fields>, Record<string, never>, WithTypename<Scenario_Well_Properties_Sum_Fields> | string>,
    var_pop?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Aggregate_Fields>, Record<string, never>, WithTypename<Scenario_Well_Properties_Var_Pop_Fields> | string>,
    var_samp?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Aggregate_Fields>, Record<string, never>, WithTypename<Scenario_Well_Properties_Var_Samp_Fields> | string>,
    variance?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Aggregate_Fields>, Record<string, never>, WithTypename<Scenario_Well_Properties_Variance_Fields> | string>
  },
  scenario_well_properties_avg_fields?: {
    ar_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    average_dls?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bottom_casing_length_feet?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bottom_tubing_length_feet?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bottomhole_temperature_fahrenheit?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bubble_point_pressure_psia?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    c1_methane_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    c2_ethane_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    c3_propane_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    c6_hexane_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    c7_heptane_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    co2_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    condensate_api_override?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    dew_point_pressure_psia_override?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    fluid_viscosity_override_cp?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    gas_specific_gravity?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    h2s_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    hps_pump_inlet_pressure_psia?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    hps_pump_inlet_temperature_fahrenheit?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    hps_required_discharge_pressure_psia?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    ic4_isobutene_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    ic5_isopentane_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    n2_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    nc4_butane_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    nc5_bentane_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    npsha_ft?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    o2_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    oil_gravity_api?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    surface_temperature_fahrenheit?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    top_casing_length_feet?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    top_of_perforations_measured_depth_feet?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    top_of_perforations_true_vertical_depth_feet?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    top_tubing_length_feet?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    water_specific_gravity?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    well_test_datum_point_measured_depth_feet?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    well_test_gas_rate_mscf_day?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    well_test_oil_rate_stb_day?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    well_test_producing_bottom_hole_pressure_psia?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    well_test_productivity_index?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    well_test_static_bottom_hole_pressure_psia?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    well_test_water_rate_stb_day?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  scenario_well_properties_max_fields?: {
    ar_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    average_dls?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    bottom_casing_id?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    bottom_casing_length_feet?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    bottom_tubing_id?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    bottom_tubing_length_feet?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    bottomhole_temperature_fahrenheit?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    bubble_point_pressure_psia?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    c1_methane_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    c2_ethane_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    c3_propane_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    c6_hexane_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    c7_heptane_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    co2_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    condensate_api_override?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    deviation_survey_id?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    dew_point_pressure_psia_override?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    fluid_viscosity_override_cp?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    gas_specific_gravity?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    gas_type?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    h2s_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    hps_liquid_type?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    hps_pump_inlet_pressure_psia?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    hps_pump_inlet_temperature_fahrenheit?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    hps_required_discharge_pressure_psia?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    ic4_isobutene_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    ic5_isopentane_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    id?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    journal_author_id?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    journal_created_at?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    journal_deleted_at?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    journal_updated_at?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    n2_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    nc4_butane_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    nc5_bentane_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    npsha_ft?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    o2_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    oil_gravity_api?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    parent_id?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    surface_temperature_fahrenheit?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    top_casing_id?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    top_casing_length_feet?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    top_of_perforations_measured_depth_feet?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    top_of_perforations_true_vertical_depth_feet?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    top_tubing_id?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    top_tubing_length_feet?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    water_specific_gravity?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    well_test_datum_point_measured_depth_feet?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    well_test_gas_input_type?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    well_test_gas_rate_mscf_day?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    well_test_liquid_input_type?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    well_test_oil_rate_stb_day?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    well_test_pressure_input_type?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    well_test_producing_bottom_hole_pressure_psia?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    well_test_productivity_index?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    well_test_static_bottom_hole_pressure_psia?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    well_test_test_date?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    well_test_water_rate_stb_day?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    winning_revision_author_id?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    winning_revision_created_at?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    winning_revision_deleted_at?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    winning_revision_id?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    winning_revision_parent_id?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    winning_revision_updated_at?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>
  },
  scenario_well_properties_min_fields?: {
    ar_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    average_dls?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    bottom_casing_id?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    bottom_casing_length_feet?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    bottom_tubing_id?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    bottom_tubing_length_feet?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    bottomhole_temperature_fahrenheit?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    bubble_point_pressure_psia?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    c1_methane_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    c2_ethane_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    c3_propane_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    c6_hexane_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    c7_heptane_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    co2_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    condensate_api_override?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    deviation_survey_id?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    dew_point_pressure_psia_override?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    fluid_viscosity_override_cp?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    gas_specific_gravity?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    gas_type?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    h2s_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    hps_liquid_type?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    hps_pump_inlet_pressure_psia?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    hps_pump_inlet_temperature_fahrenheit?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    hps_required_discharge_pressure_psia?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    ic4_isobutene_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    ic5_isopentane_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    id?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    journal_author_id?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    journal_created_at?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    journal_deleted_at?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    journal_updated_at?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    n2_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    nc4_butane_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    nc5_bentane_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    npsha_ft?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    o2_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    oil_gravity_api?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    parent_id?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    surface_temperature_fahrenheit?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    top_casing_id?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    top_casing_length_feet?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    top_of_perforations_measured_depth_feet?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    top_of_perforations_true_vertical_depth_feet?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    top_tubing_id?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    top_tubing_length_feet?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    water_specific_gravity?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    well_test_datum_point_measured_depth_feet?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    well_test_gas_input_type?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    well_test_gas_rate_mscf_day?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    well_test_liquid_input_type?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    well_test_oil_rate_stb_day?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    well_test_pressure_input_type?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    well_test_producing_bottom_hole_pressure_psia?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    well_test_productivity_index?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    well_test_static_bottom_hole_pressure_psia?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    well_test_test_date?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    well_test_water_rate_stb_day?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    winning_revision_author_id?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    winning_revision_created_at?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    winning_revision_deleted_at?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    winning_revision_id?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    winning_revision_parent_id?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    winning_revision_updated_at?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>
  },
  scenario_well_properties_stddev_fields?: {
    ar_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    average_dls?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bottom_casing_length_feet?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bottom_tubing_length_feet?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bottomhole_temperature_fahrenheit?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bubble_point_pressure_psia?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    c1_methane_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    c2_ethane_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    c3_propane_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    c6_hexane_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    c7_heptane_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    co2_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    condensate_api_override?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    dew_point_pressure_psia_override?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    fluid_viscosity_override_cp?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    gas_specific_gravity?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    h2s_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    hps_pump_inlet_pressure_psia?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    hps_pump_inlet_temperature_fahrenheit?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    hps_required_discharge_pressure_psia?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    ic4_isobutene_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    ic5_isopentane_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    n2_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    nc4_butane_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    nc5_bentane_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    npsha_ft?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    o2_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    oil_gravity_api?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    surface_temperature_fahrenheit?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    top_casing_length_feet?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    top_of_perforations_measured_depth_feet?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    top_of_perforations_true_vertical_depth_feet?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    top_tubing_length_feet?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    water_specific_gravity?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    well_test_datum_point_measured_depth_feet?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    well_test_gas_rate_mscf_day?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    well_test_oil_rate_stb_day?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    well_test_producing_bottom_hole_pressure_psia?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    well_test_productivity_index?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    well_test_static_bottom_hole_pressure_psia?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    well_test_water_rate_stb_day?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  scenario_well_properties_stddev_pop_fields?: {
    ar_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    average_dls?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bottom_casing_length_feet?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bottom_tubing_length_feet?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bottomhole_temperature_fahrenheit?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bubble_point_pressure_psia?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    c1_methane_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    c2_ethane_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    c3_propane_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    c6_hexane_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    c7_heptane_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    co2_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    condensate_api_override?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    dew_point_pressure_psia_override?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    fluid_viscosity_override_cp?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    gas_specific_gravity?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    h2s_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    hps_pump_inlet_pressure_psia?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    hps_pump_inlet_temperature_fahrenheit?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    hps_required_discharge_pressure_psia?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    ic4_isobutene_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    ic5_isopentane_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    n2_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    nc4_butane_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    nc5_bentane_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    npsha_ft?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    o2_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    oil_gravity_api?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    surface_temperature_fahrenheit?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    top_casing_length_feet?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    top_of_perforations_measured_depth_feet?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    top_of_perforations_true_vertical_depth_feet?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    top_tubing_length_feet?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    water_specific_gravity?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    well_test_datum_point_measured_depth_feet?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    well_test_gas_rate_mscf_day?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    well_test_oil_rate_stb_day?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    well_test_producing_bottom_hole_pressure_psia?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    well_test_productivity_index?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    well_test_static_bottom_hole_pressure_psia?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    well_test_water_rate_stb_day?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  scenario_well_properties_stddev_samp_fields?: {
    ar_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    average_dls?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bottom_casing_length_feet?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bottom_tubing_length_feet?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bottomhole_temperature_fahrenheit?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bubble_point_pressure_psia?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    c1_methane_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    c2_ethane_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    c3_propane_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    c6_hexane_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    c7_heptane_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    co2_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    condensate_api_override?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    dew_point_pressure_psia_override?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    fluid_viscosity_override_cp?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    gas_specific_gravity?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    h2s_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    hps_pump_inlet_pressure_psia?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    hps_pump_inlet_temperature_fahrenheit?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    hps_required_discharge_pressure_psia?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    ic4_isobutene_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    ic5_isopentane_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    n2_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    nc4_butane_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    nc5_bentane_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    npsha_ft?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    o2_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    oil_gravity_api?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    surface_temperature_fahrenheit?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    top_casing_length_feet?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    top_of_perforations_measured_depth_feet?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    top_of_perforations_true_vertical_depth_feet?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    top_tubing_length_feet?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    water_specific_gravity?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    well_test_datum_point_measured_depth_feet?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    well_test_gas_rate_mscf_day?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    well_test_oil_rate_stb_day?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    well_test_producing_bottom_hole_pressure_psia?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    well_test_productivity_index?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    well_test_static_bottom_hole_pressure_psia?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    well_test_water_rate_stb_day?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  scenario_well_properties_sum_fields?: {
    ar_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    average_dls?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    bottom_casing_length_feet?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    bottom_tubing_length_feet?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    bottomhole_temperature_fahrenheit?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    bubble_point_pressure_psia?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    c1_methane_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    c2_ethane_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    c3_propane_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    c6_hexane_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    c7_heptane_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    co2_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    condensate_api_override?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    dew_point_pressure_psia_override?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    fluid_viscosity_override_cp?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    gas_specific_gravity?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    h2s_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    hps_pump_inlet_pressure_psia?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    hps_pump_inlet_temperature_fahrenheit?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    hps_required_discharge_pressure_psia?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    ic4_isobutene_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    ic5_isopentane_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    n2_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    nc4_butane_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    nc5_bentane_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    npsha_ft?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    o2_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    oil_gravity_api?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    surface_temperature_fahrenheit?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    top_casing_length_feet?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    top_of_perforations_measured_depth_feet?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    top_of_perforations_true_vertical_depth_feet?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    top_tubing_length_feet?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    water_specific_gravity?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    well_test_datum_point_measured_depth_feet?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    well_test_gas_rate_mscf_day?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    well_test_oil_rate_stb_day?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    well_test_producing_bottom_hole_pressure_psia?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    well_test_productivity_index?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    well_test_static_bottom_hole_pressure_psia?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    well_test_water_rate_stb_day?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>
  },
  scenario_well_properties_var_pop_fields?: {
    ar_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    average_dls?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bottom_casing_length_feet?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bottom_tubing_length_feet?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bottomhole_temperature_fahrenheit?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bubble_point_pressure_psia?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    c1_methane_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    c2_ethane_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    c3_propane_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    c6_hexane_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    c7_heptane_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    co2_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    condensate_api_override?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    dew_point_pressure_psia_override?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    fluid_viscosity_override_cp?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    gas_specific_gravity?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    h2s_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    hps_pump_inlet_pressure_psia?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    hps_pump_inlet_temperature_fahrenheit?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    hps_required_discharge_pressure_psia?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    ic4_isobutene_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    ic5_isopentane_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    n2_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    nc4_butane_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    nc5_bentane_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    npsha_ft?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    o2_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    oil_gravity_api?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    surface_temperature_fahrenheit?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    top_casing_length_feet?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    top_of_perforations_measured_depth_feet?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    top_of_perforations_true_vertical_depth_feet?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    top_tubing_length_feet?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    water_specific_gravity?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    well_test_datum_point_measured_depth_feet?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    well_test_gas_rate_mscf_day?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    well_test_oil_rate_stb_day?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    well_test_producing_bottom_hole_pressure_psia?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    well_test_productivity_index?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    well_test_static_bottom_hole_pressure_psia?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    well_test_water_rate_stb_day?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  scenario_well_properties_var_samp_fields?: {
    ar_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    average_dls?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bottom_casing_length_feet?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bottom_tubing_length_feet?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bottomhole_temperature_fahrenheit?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bubble_point_pressure_psia?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    c1_methane_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    c2_ethane_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    c3_propane_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    c6_hexane_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    c7_heptane_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    co2_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    condensate_api_override?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    dew_point_pressure_psia_override?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    fluid_viscosity_override_cp?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    gas_specific_gravity?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    h2s_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    hps_pump_inlet_pressure_psia?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    hps_pump_inlet_temperature_fahrenheit?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    hps_required_discharge_pressure_psia?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    ic4_isobutene_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    ic5_isopentane_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    n2_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    nc4_butane_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    nc5_bentane_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    npsha_ft?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    o2_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    oil_gravity_api?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    surface_temperature_fahrenheit?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    top_casing_length_feet?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    top_of_perforations_measured_depth_feet?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    top_of_perforations_true_vertical_depth_feet?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    top_tubing_length_feet?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    water_specific_gravity?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    well_test_datum_point_measured_depth_feet?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    well_test_gas_rate_mscf_day?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    well_test_oil_rate_stb_day?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    well_test_producing_bottom_hole_pressure_psia?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    well_test_productivity_index?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    well_test_static_bottom_hole_pressure_psia?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    well_test_water_rate_stb_day?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  scenario_well_properties_variance_fields?: {
    ar_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    average_dls?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bottom_casing_length_feet?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bottom_tubing_length_feet?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bottomhole_temperature_fahrenheit?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bubble_point_pressure_psia?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    c1_methane_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    c2_ethane_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    c3_propane_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    c6_hexane_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    c7_heptane_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    co2_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    condensate_api_override?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    dew_point_pressure_psia_override?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    fluid_viscosity_override_cp?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    gas_specific_gravity?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    h2s_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    hps_pump_inlet_pressure_psia?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    hps_pump_inlet_temperature_fahrenheit?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    hps_required_discharge_pressure_psia?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    ic4_isobutene_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    ic5_isopentane_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    n2_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    nc4_butane_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    nc5_bentane_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    npsha_ft?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    o2_percent?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    oil_gravity_api?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    surface_temperature_fahrenheit?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    top_casing_length_feet?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    top_of_perforations_measured_depth_feet?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    top_of_perforations_true_vertical_depth_feet?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    top_tubing_length_feet?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    water_specific_gravity?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    well_test_datum_point_measured_depth_feet?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    well_test_gas_rate_mscf_day?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    well_test_oil_rate_stb_day?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    well_test_producing_bottom_hole_pressure_psia?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    well_test_productivity_index?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    well_test_static_bottom_hole_pressure_psia?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    well_test_water_rate_stb_day?: GraphCacheResolver<WithTypename<Scenario_Well_Properties_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  scenarios?: {
    author?: GraphCacheResolver<WithTypename<Scenarios>, Record<string, never>, WithTypename<Users> | string>,
    clonedFrom?: GraphCacheResolver<WithTypename<Scenarios>, Record<string, never>, WithTypename<Scenarios> | string>,
    correlations?: GraphCacheResolver<WithTypename<Scenarios>, Record<string, never>, WithTypename<Scenario_Correlations> | string>,
    correlations_id?: GraphCacheResolver<WithTypename<Scenarios>, Record<string, never>, Scalars['uuid'] | string>,
    display_unit_overrides?: GraphCacheResolver<WithTypename<Scenarios>, ScenariosDisplay_Unit_OverridesArgs, Scalars['jsonb'] | string>,
    equipment?: GraphCacheResolver<WithTypename<Scenarios>, Record<string, never>, WithTypename<Scenario_Equipment> | string>,
    id?: GraphCacheResolver<WithTypename<Scenarios>, Record<string, never>, Scalars['uuid'] | string>,
    internal_notes?: GraphCacheResolver<WithTypename<Scenarios>, Record<string, never>, Scalars['String'] | string>,
    journal_author_id?: GraphCacheResolver<WithTypename<Scenarios>, Record<string, never>, Scalars['String'] | string>,
    journal_created_at?: GraphCacheResolver<WithTypename<Scenarios>, Record<string, never>, Scalars['timestamptz'] | string>,
    journal_deleted_at?: GraphCacheResolver<WithTypename<Scenarios>, Record<string, never>, Scalars['timestamptz'] | string>,
    journal_updated_at?: GraphCacheResolver<WithTypename<Scenarios>, Record<string, never>, Scalars['timestamptz'] | string>,
    notes?: GraphCacheResolver<WithTypename<Scenarios>, Record<string, never>, Scalars['String'] | string>,
    parameters?: GraphCacheResolver<WithTypename<Scenarios>, Record<string, never>, WithTypename<Scenario_Parameters> | string>,
    parameters_id?: GraphCacheResolver<WithTypename<Scenarios>, Record<string, never>, Scalars['uuid'] | string>,
    parent_id?: GraphCacheResolver<WithTypename<Scenarios>, Record<string, never>, Scalars['uuid'] | string>,
    performance_evaluations?: GraphCacheResolver<WithTypename<Scenarios>, ScenariosPerformance_EvaluationsArgs, Array<WithTypename<Performance_Evaluations> | string>>,
    performance_evaluations_aggregate?: GraphCacheResolver<WithTypename<Scenarios>, ScenariosPerformance_Evaluations_AggregateArgs, WithTypename<Performance_Evaluations_Aggregate> | string>,
    pumping_type?: GraphCacheResolver<WithTypename<Scenarios>, Record<string, never>, Scalars['String'] | string>,
    quotes?: GraphCacheResolver<WithTypename<Scenarios>, ScenariosQuotesArgs, Array<WithTypename<Quotes> | string>>,
    quotes_aggregate?: GraphCacheResolver<WithTypename<Scenarios>, ScenariosQuotes_AggregateArgs, WithTypename<Quotes_Aggregate> | string>,
    reason?: GraphCacheResolver<WithTypename<Scenarios>, Record<string, never>, Scalars['String'] | string>,
    scenario_equipment_id?: GraphCacheResolver<WithTypename<Scenarios>, Record<string, never>, Scalars['uuid'] | string>,
    sizing?: GraphCacheResolver<WithTypename<Scenarios>, Record<string, never>, WithTypename<Sizings> | string>,
    sizing_id?: GraphCacheResolver<WithTypename<Scenarios>, Record<string, never>, Scalars['uuid'] | string>,
    title?: GraphCacheResolver<WithTypename<Scenarios>, Record<string, never>, Scalars['String'] | string>,
    well_properties?: GraphCacheResolver<WithTypename<Scenarios>, Record<string, never>, WithTypename<Scenario_Well_Properties> | string>,
    well_properties_id?: GraphCacheResolver<WithTypename<Scenarios>, Record<string, never>, Scalars['uuid'] | string>,
    winning_revision_author_id?: GraphCacheResolver<WithTypename<Scenarios>, Record<string, never>, Scalars['String'] | string>,
    winning_revision_created_at?: GraphCacheResolver<WithTypename<Scenarios>, Record<string, never>, Scalars['timestamptz'] | string>,
    winning_revision_deleted_at?: GraphCacheResolver<WithTypename<Scenarios>, Record<string, never>, Scalars['timestamptz'] | string>,
    winning_revision_id?: GraphCacheResolver<WithTypename<Scenarios>, Record<string, never>, Scalars['uuid'] | string>,
    winning_revision_parent_id?: GraphCacheResolver<WithTypename<Scenarios>, Record<string, never>, Scalars['uuid'] | string>,
    winning_revision_updated_at?: GraphCacheResolver<WithTypename<Scenarios>, Record<string, never>, Scalars['timestamptz'] | string>
  },
  scenarios_aggregate?: {
    aggregate?: GraphCacheResolver<WithTypename<Scenarios_Aggregate>, Record<string, never>, WithTypename<Scenarios_Aggregate_Fields> | string>,
    nodes?: GraphCacheResolver<WithTypename<Scenarios_Aggregate>, Record<string, never>, Array<WithTypename<Scenarios> | string>>
  },
  scenarios_aggregate_fields?: {
    count?: GraphCacheResolver<WithTypename<Scenarios_Aggregate_Fields>, Scenarios_Aggregate_FieldsCountArgs, Scalars['Int'] | string>,
    max?: GraphCacheResolver<WithTypename<Scenarios_Aggregate_Fields>, Record<string, never>, WithTypename<Scenarios_Max_Fields> | string>,
    min?: GraphCacheResolver<WithTypename<Scenarios_Aggregate_Fields>, Record<string, never>, WithTypename<Scenarios_Min_Fields> | string>
  },
  scenarios_max_fields?: {
    correlations_id?: GraphCacheResolver<WithTypename<Scenarios_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    id?: GraphCacheResolver<WithTypename<Scenarios_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    internal_notes?: GraphCacheResolver<WithTypename<Scenarios_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    journal_author_id?: GraphCacheResolver<WithTypename<Scenarios_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    journal_created_at?: GraphCacheResolver<WithTypename<Scenarios_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    journal_deleted_at?: GraphCacheResolver<WithTypename<Scenarios_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    journal_updated_at?: GraphCacheResolver<WithTypename<Scenarios_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    notes?: GraphCacheResolver<WithTypename<Scenarios_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    parameters_id?: GraphCacheResolver<WithTypename<Scenarios_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    parent_id?: GraphCacheResolver<WithTypename<Scenarios_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    pumping_type?: GraphCacheResolver<WithTypename<Scenarios_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    reason?: GraphCacheResolver<WithTypename<Scenarios_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    scenario_equipment_id?: GraphCacheResolver<WithTypename<Scenarios_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    sizing_id?: GraphCacheResolver<WithTypename<Scenarios_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    title?: GraphCacheResolver<WithTypename<Scenarios_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    well_properties_id?: GraphCacheResolver<WithTypename<Scenarios_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    winning_revision_author_id?: GraphCacheResolver<WithTypename<Scenarios_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    winning_revision_created_at?: GraphCacheResolver<WithTypename<Scenarios_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    winning_revision_deleted_at?: GraphCacheResolver<WithTypename<Scenarios_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    winning_revision_id?: GraphCacheResolver<WithTypename<Scenarios_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    winning_revision_parent_id?: GraphCacheResolver<WithTypename<Scenarios_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    winning_revision_updated_at?: GraphCacheResolver<WithTypename<Scenarios_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>
  },
  scenarios_min_fields?: {
    correlations_id?: GraphCacheResolver<WithTypename<Scenarios_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    id?: GraphCacheResolver<WithTypename<Scenarios_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    internal_notes?: GraphCacheResolver<WithTypename<Scenarios_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    journal_author_id?: GraphCacheResolver<WithTypename<Scenarios_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    journal_created_at?: GraphCacheResolver<WithTypename<Scenarios_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    journal_deleted_at?: GraphCacheResolver<WithTypename<Scenarios_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    journal_updated_at?: GraphCacheResolver<WithTypename<Scenarios_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    notes?: GraphCacheResolver<WithTypename<Scenarios_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    parameters_id?: GraphCacheResolver<WithTypename<Scenarios_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    parent_id?: GraphCacheResolver<WithTypename<Scenarios_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    pumping_type?: GraphCacheResolver<WithTypename<Scenarios_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    reason?: GraphCacheResolver<WithTypename<Scenarios_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    scenario_equipment_id?: GraphCacheResolver<WithTypename<Scenarios_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    sizing_id?: GraphCacheResolver<WithTypename<Scenarios_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    title?: GraphCacheResolver<WithTypename<Scenarios_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    well_properties_id?: GraphCacheResolver<WithTypename<Scenarios_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    winning_revision_author_id?: GraphCacheResolver<WithTypename<Scenarios_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    winning_revision_created_at?: GraphCacheResolver<WithTypename<Scenarios_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    winning_revision_deleted_at?: GraphCacheResolver<WithTypename<Scenarios_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    winning_revision_id?: GraphCacheResolver<WithTypename<Scenarios_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    winning_revision_parent_id?: GraphCacheResolver<WithTypename<Scenarios_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    winning_revision_updated_at?: GraphCacheResolver<WithTypename<Scenarios_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>
  },
  seal_motor_oil?: {
    created_at?: GraphCacheResolver<WithTypename<Seal_Motor_Oil>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Seal_Motor_Oil>, Record<string, never>, Scalars['timestamptz'] | string>,
    id?: GraphCacheResolver<WithTypename<Seal_Motor_Oil>, Record<string, never>, Scalars['uuid'] | string>,
    include_ecopetrol_timestamp?: GraphCacheResolver<WithTypename<Seal_Motor_Oil>, Record<string, never>, Scalars['timestamptz'] | string>,
    include_koc_timestamp?: GraphCacheResolver<WithTypename<Seal_Motor_Oil>, Record<string, never>, Scalars['timestamptz'] | string>,
    max_temp_fahrenheit?: GraphCacheResolver<WithTypename<Seal_Motor_Oil>, Record<string, never>, Scalars['Int'] | string>,
    mf_test_temp1_celsius?: GraphCacheResolver<WithTypename<Seal_Motor_Oil>, Record<string, never>, Scalars['Int'] | string>,
    mf_test_temp2_celsius?: GraphCacheResolver<WithTypename<Seal_Motor_Oil>, Record<string, never>, Scalars['Int'] | string>,
    name?: GraphCacheResolver<WithTypename<Seal_Motor_Oil>, Record<string, never>, Scalars['String'] | string>,
    only_ecopetrol_timestamp?: GraphCacheResolver<WithTypename<Seal_Motor_Oil>, Record<string, never>, Scalars['timestamptz'] | string>,
    only_koc_timestamp?: GraphCacheResolver<WithTypename<Seal_Motor_Oil>, Record<string, never>, Scalars['timestamptz'] | string>,
    specific_gravity?: GraphCacheResolver<WithTypename<Seal_Motor_Oil>, Record<string, never>, Scalars['numeric'] | string>,
    thermal_expansion_factor?: GraphCacheResolver<WithTypename<Seal_Motor_Oil>, Record<string, never>, Scalars['numeric'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Seal_Motor_Oil>, Record<string, never>, Scalars['timestamptz'] | string>,
    viscosity_test1_centistroke?: GraphCacheResolver<WithTypename<Seal_Motor_Oil>, Record<string, never>, Scalars['numeric'] | string>,
    viscosity_test2_centistroke?: GraphCacheResolver<WithTypename<Seal_Motor_Oil>, Record<string, never>, Scalars['numeric'] | string>
  },
  seal_motor_oil_aggregate?: {
    aggregate?: GraphCacheResolver<WithTypename<Seal_Motor_Oil_Aggregate>, Record<string, never>, WithTypename<Seal_Motor_Oil_Aggregate_Fields> | string>,
    nodes?: GraphCacheResolver<WithTypename<Seal_Motor_Oil_Aggregate>, Record<string, never>, Array<WithTypename<Seal_Motor_Oil> | string>>
  },
  seal_motor_oil_aggregate_fields?: {
    avg?: GraphCacheResolver<WithTypename<Seal_Motor_Oil_Aggregate_Fields>, Record<string, never>, WithTypename<Seal_Motor_Oil_Avg_Fields> | string>,
    count?: GraphCacheResolver<WithTypename<Seal_Motor_Oil_Aggregate_Fields>, Seal_Motor_Oil_Aggregate_FieldsCountArgs, Scalars['Int'] | string>,
    max?: GraphCacheResolver<WithTypename<Seal_Motor_Oil_Aggregate_Fields>, Record<string, never>, WithTypename<Seal_Motor_Oil_Max_Fields> | string>,
    min?: GraphCacheResolver<WithTypename<Seal_Motor_Oil_Aggregate_Fields>, Record<string, never>, WithTypename<Seal_Motor_Oil_Min_Fields> | string>,
    stddev?: GraphCacheResolver<WithTypename<Seal_Motor_Oil_Aggregate_Fields>, Record<string, never>, WithTypename<Seal_Motor_Oil_Stddev_Fields> | string>,
    stddev_pop?: GraphCacheResolver<WithTypename<Seal_Motor_Oil_Aggregate_Fields>, Record<string, never>, WithTypename<Seal_Motor_Oil_Stddev_Pop_Fields> | string>,
    stddev_samp?: GraphCacheResolver<WithTypename<Seal_Motor_Oil_Aggregate_Fields>, Record<string, never>, WithTypename<Seal_Motor_Oil_Stddev_Samp_Fields> | string>,
    sum?: GraphCacheResolver<WithTypename<Seal_Motor_Oil_Aggregate_Fields>, Record<string, never>, WithTypename<Seal_Motor_Oil_Sum_Fields> | string>,
    var_pop?: GraphCacheResolver<WithTypename<Seal_Motor_Oil_Aggregate_Fields>, Record<string, never>, WithTypename<Seal_Motor_Oil_Var_Pop_Fields> | string>,
    var_samp?: GraphCacheResolver<WithTypename<Seal_Motor_Oil_Aggregate_Fields>, Record<string, never>, WithTypename<Seal_Motor_Oil_Var_Samp_Fields> | string>,
    variance?: GraphCacheResolver<WithTypename<Seal_Motor_Oil_Aggregate_Fields>, Record<string, never>, WithTypename<Seal_Motor_Oil_Variance_Fields> | string>
  },
  seal_motor_oil_avg_fields?: {
    max_temp_fahrenheit?: GraphCacheResolver<WithTypename<Seal_Motor_Oil_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    mf_test_temp1_celsius?: GraphCacheResolver<WithTypename<Seal_Motor_Oil_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    mf_test_temp2_celsius?: GraphCacheResolver<WithTypename<Seal_Motor_Oil_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    specific_gravity?: GraphCacheResolver<WithTypename<Seal_Motor_Oil_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    thermal_expansion_factor?: GraphCacheResolver<WithTypename<Seal_Motor_Oil_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    viscosity_test1_centistroke?: GraphCacheResolver<WithTypename<Seal_Motor_Oil_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    viscosity_test2_centistroke?: GraphCacheResolver<WithTypename<Seal_Motor_Oil_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  seal_motor_oil_max_fields?: {
    created_at?: GraphCacheResolver<WithTypename<Seal_Motor_Oil_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Seal_Motor_Oil_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    id?: GraphCacheResolver<WithTypename<Seal_Motor_Oil_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    include_ecopetrol_timestamp?: GraphCacheResolver<WithTypename<Seal_Motor_Oil_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    include_koc_timestamp?: GraphCacheResolver<WithTypename<Seal_Motor_Oil_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    max_temp_fahrenheit?: GraphCacheResolver<WithTypename<Seal_Motor_Oil_Max_Fields>, Record<string, never>, Scalars['Int'] | string>,
    mf_test_temp1_celsius?: GraphCacheResolver<WithTypename<Seal_Motor_Oil_Max_Fields>, Record<string, never>, Scalars['Int'] | string>,
    mf_test_temp2_celsius?: GraphCacheResolver<WithTypename<Seal_Motor_Oil_Max_Fields>, Record<string, never>, Scalars['Int'] | string>,
    name?: GraphCacheResolver<WithTypename<Seal_Motor_Oil_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    only_ecopetrol_timestamp?: GraphCacheResolver<WithTypename<Seal_Motor_Oil_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    only_koc_timestamp?: GraphCacheResolver<WithTypename<Seal_Motor_Oil_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    specific_gravity?: GraphCacheResolver<WithTypename<Seal_Motor_Oil_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    thermal_expansion_factor?: GraphCacheResolver<WithTypename<Seal_Motor_Oil_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Seal_Motor_Oil_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    viscosity_test1_centistroke?: GraphCacheResolver<WithTypename<Seal_Motor_Oil_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    viscosity_test2_centistroke?: GraphCacheResolver<WithTypename<Seal_Motor_Oil_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>
  },
  seal_motor_oil_min_fields?: {
    created_at?: GraphCacheResolver<WithTypename<Seal_Motor_Oil_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Seal_Motor_Oil_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    id?: GraphCacheResolver<WithTypename<Seal_Motor_Oil_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    include_ecopetrol_timestamp?: GraphCacheResolver<WithTypename<Seal_Motor_Oil_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    include_koc_timestamp?: GraphCacheResolver<WithTypename<Seal_Motor_Oil_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    max_temp_fahrenheit?: GraphCacheResolver<WithTypename<Seal_Motor_Oil_Min_Fields>, Record<string, never>, Scalars['Int'] | string>,
    mf_test_temp1_celsius?: GraphCacheResolver<WithTypename<Seal_Motor_Oil_Min_Fields>, Record<string, never>, Scalars['Int'] | string>,
    mf_test_temp2_celsius?: GraphCacheResolver<WithTypename<Seal_Motor_Oil_Min_Fields>, Record<string, never>, Scalars['Int'] | string>,
    name?: GraphCacheResolver<WithTypename<Seal_Motor_Oil_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    only_ecopetrol_timestamp?: GraphCacheResolver<WithTypename<Seal_Motor_Oil_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    only_koc_timestamp?: GraphCacheResolver<WithTypename<Seal_Motor_Oil_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    specific_gravity?: GraphCacheResolver<WithTypename<Seal_Motor_Oil_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    thermal_expansion_factor?: GraphCacheResolver<WithTypename<Seal_Motor_Oil_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Seal_Motor_Oil_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    viscosity_test1_centistroke?: GraphCacheResolver<WithTypename<Seal_Motor_Oil_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    viscosity_test2_centistroke?: GraphCacheResolver<WithTypename<Seal_Motor_Oil_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>
  },
  seal_motor_oil_mutation_response?: {
    affected_rows?: GraphCacheResolver<WithTypename<Seal_Motor_Oil_Mutation_Response>, Record<string, never>, Scalars['Int'] | string>,
    returning?: GraphCacheResolver<WithTypename<Seal_Motor_Oil_Mutation_Response>, Record<string, never>, Array<WithTypename<Seal_Motor_Oil> | string>>
  },
  seal_motor_oil_stddev_fields?: {
    max_temp_fahrenheit?: GraphCacheResolver<WithTypename<Seal_Motor_Oil_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    mf_test_temp1_celsius?: GraphCacheResolver<WithTypename<Seal_Motor_Oil_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    mf_test_temp2_celsius?: GraphCacheResolver<WithTypename<Seal_Motor_Oil_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    specific_gravity?: GraphCacheResolver<WithTypename<Seal_Motor_Oil_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    thermal_expansion_factor?: GraphCacheResolver<WithTypename<Seal_Motor_Oil_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    viscosity_test1_centistroke?: GraphCacheResolver<WithTypename<Seal_Motor_Oil_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    viscosity_test2_centistroke?: GraphCacheResolver<WithTypename<Seal_Motor_Oil_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  seal_motor_oil_stddev_pop_fields?: {
    max_temp_fahrenheit?: GraphCacheResolver<WithTypename<Seal_Motor_Oil_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    mf_test_temp1_celsius?: GraphCacheResolver<WithTypename<Seal_Motor_Oil_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    mf_test_temp2_celsius?: GraphCacheResolver<WithTypename<Seal_Motor_Oil_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    specific_gravity?: GraphCacheResolver<WithTypename<Seal_Motor_Oil_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    thermal_expansion_factor?: GraphCacheResolver<WithTypename<Seal_Motor_Oil_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    viscosity_test1_centistroke?: GraphCacheResolver<WithTypename<Seal_Motor_Oil_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    viscosity_test2_centistroke?: GraphCacheResolver<WithTypename<Seal_Motor_Oil_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  seal_motor_oil_stddev_samp_fields?: {
    max_temp_fahrenheit?: GraphCacheResolver<WithTypename<Seal_Motor_Oil_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    mf_test_temp1_celsius?: GraphCacheResolver<WithTypename<Seal_Motor_Oil_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    mf_test_temp2_celsius?: GraphCacheResolver<WithTypename<Seal_Motor_Oil_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    specific_gravity?: GraphCacheResolver<WithTypename<Seal_Motor_Oil_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    thermal_expansion_factor?: GraphCacheResolver<WithTypename<Seal_Motor_Oil_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    viscosity_test1_centistroke?: GraphCacheResolver<WithTypename<Seal_Motor_Oil_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    viscosity_test2_centistroke?: GraphCacheResolver<WithTypename<Seal_Motor_Oil_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  seal_motor_oil_sum_fields?: {
    max_temp_fahrenheit?: GraphCacheResolver<WithTypename<Seal_Motor_Oil_Sum_Fields>, Record<string, never>, Scalars['Int'] | string>,
    mf_test_temp1_celsius?: GraphCacheResolver<WithTypename<Seal_Motor_Oil_Sum_Fields>, Record<string, never>, Scalars['Int'] | string>,
    mf_test_temp2_celsius?: GraphCacheResolver<WithTypename<Seal_Motor_Oil_Sum_Fields>, Record<string, never>, Scalars['Int'] | string>,
    specific_gravity?: GraphCacheResolver<WithTypename<Seal_Motor_Oil_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    thermal_expansion_factor?: GraphCacheResolver<WithTypename<Seal_Motor_Oil_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    viscosity_test1_centistroke?: GraphCacheResolver<WithTypename<Seal_Motor_Oil_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    viscosity_test2_centistroke?: GraphCacheResolver<WithTypename<Seal_Motor_Oil_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>
  },
  seal_motor_oil_var_pop_fields?: {
    max_temp_fahrenheit?: GraphCacheResolver<WithTypename<Seal_Motor_Oil_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    mf_test_temp1_celsius?: GraphCacheResolver<WithTypename<Seal_Motor_Oil_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    mf_test_temp2_celsius?: GraphCacheResolver<WithTypename<Seal_Motor_Oil_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    specific_gravity?: GraphCacheResolver<WithTypename<Seal_Motor_Oil_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    thermal_expansion_factor?: GraphCacheResolver<WithTypename<Seal_Motor_Oil_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    viscosity_test1_centistroke?: GraphCacheResolver<WithTypename<Seal_Motor_Oil_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    viscosity_test2_centistroke?: GraphCacheResolver<WithTypename<Seal_Motor_Oil_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  seal_motor_oil_var_samp_fields?: {
    max_temp_fahrenheit?: GraphCacheResolver<WithTypename<Seal_Motor_Oil_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    mf_test_temp1_celsius?: GraphCacheResolver<WithTypename<Seal_Motor_Oil_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    mf_test_temp2_celsius?: GraphCacheResolver<WithTypename<Seal_Motor_Oil_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    specific_gravity?: GraphCacheResolver<WithTypename<Seal_Motor_Oil_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    thermal_expansion_factor?: GraphCacheResolver<WithTypename<Seal_Motor_Oil_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    viscosity_test1_centistroke?: GraphCacheResolver<WithTypename<Seal_Motor_Oil_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    viscosity_test2_centistroke?: GraphCacheResolver<WithTypename<Seal_Motor_Oil_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  seal_motor_oil_variance_fields?: {
    max_temp_fahrenheit?: GraphCacheResolver<WithTypename<Seal_Motor_Oil_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    mf_test_temp1_celsius?: GraphCacheResolver<WithTypename<Seal_Motor_Oil_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    mf_test_temp2_celsius?: GraphCacheResolver<WithTypename<Seal_Motor_Oil_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    specific_gravity?: GraphCacheResolver<WithTypename<Seal_Motor_Oil_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    thermal_expansion_factor?: GraphCacheResolver<WithTypename<Seal_Motor_Oil_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    viscosity_test1_centistroke?: GraphCacheResolver<WithTypename<Seal_Motor_Oil_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    viscosity_test2_centistroke?: GraphCacheResolver<WithTypename<Seal_Motor_Oil_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  seals?: {
    author_id?: GraphCacheResolver<WithTypename<Seals>, Record<string, never>, Scalars['String'] | string>,
    bag_capacity_gallons?: GraphCacheResolver<WithTypename<Seals>, Record<string, never>, Scalars['numeric'] | string>,
    bag_chambers?: GraphCacheResolver<WithTypename<Seals>, Record<string, never>, Scalars['Int'] | string>,
    bearing_type?: GraphCacheResolver<WithTypename<Seals>, Record<string, never>, Scalars['String'] | string>,
    configuration?: GraphCacheResolver<WithTypename<Seals>, Record<string, never>, Scalars['String'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Seals>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Seals>, Record<string, never>, Scalars['timestamptz'] | string>,
    description?: GraphCacheResolver<WithTypename<Seals>, Record<string, never>, Scalars['String'] | string>,
    high_strength_bearing_rating_pounds?: GraphCacheResolver<WithTypename<Seals>, Record<string, never>, Scalars['Int'] | string>,
    high_strength_shaft_limit_hp?: GraphCacheResolver<WithTypename<Seals>, Record<string, never>, Scalars['Int'] | string>,
    housing_material?: GraphCacheResolver<WithTypename<Seals>, Record<string, never>, Scalars['String'] | string>,
    hps_thrust_chamber?: GraphCacheResolver<WithTypename<Seals>, Record<string, never>, Scalars['Boolean'] | string>,
    id?: GraphCacheResolver<WithTypename<Seals>, Record<string, never>, Scalars['uuid'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Seals>, Record<string, never>, Scalars['Int'] | string>,
    include_ecopetrol_timestamp?: GraphCacheResolver<WithTypename<Seals>, Record<string, never>, Scalars['timestamptz'] | string>,
    include_koc_timestamp?: GraphCacheResolver<WithTypename<Seals>, Record<string, never>, Scalars['timestamptz'] | string>,
    inner_diameter_inches?: GraphCacheResolver<WithTypename<Seals>, Record<string, never>, Scalars['numeric'] | string>,
    length_inches?: GraphCacheResolver<WithTypename<Seals>, Record<string, never>, Scalars['numeric'] | string>,
    load_c1_pounds?: GraphCacheResolver<WithTypename<Seals>, Record<string, never>, Scalars['numeric'] | string>,
    load_cb_pounds?: GraphCacheResolver<WithTypename<Seals>, Record<string, never>, Scalars['numeric'] | string>,
    load_test_temperature_fahrenheit?: GraphCacheResolver<WithTypename<Seals>, Record<string, never>, Scalars['Int'] | string>,
    manufacturer?: GraphCacheResolver<WithTypename<Seals>, Record<string, never>, Scalars['String'] | string>,
    max_temperature_fahrenheit?: GraphCacheResolver<WithTypename<Seals>, Record<string, never>, Scalars['Int'] | string>,
    neck_inner_diameter_inches?: GraphCacheResolver<WithTypename<Seals>, Record<string, never>, Scalars['numeric'] | string>,
    neck_outer_diameter_inches?: GraphCacheResolver<WithTypename<Seals>, Record<string, never>, Scalars['numeric'] | string>,
    only_ecopetrol_timestamp?: GraphCacheResolver<WithTypename<Seals>, Record<string, never>, Scalars['timestamptz'] | string>,
    only_koc_timestamp?: GraphCacheResolver<WithTypename<Seals>, Record<string, never>, Scalars['timestamptz'] | string>,
    outer_diameter_inches?: GraphCacheResolver<WithTypename<Seals>, Record<string, never>, Scalars['numeric'] | string>,
    part_number?: GraphCacheResolver<WithTypename<Seals>, Record<string, never>, Scalars['String'] | string>,
    prioritized_manufacturer?: GraphCacheResolver<WithTypename<Seals>, Record<string, never>, Scalars['String'] | string>,
    sizing_import?: GraphCacheResolver<WithTypename<Seals>, Record<string, never>, WithTypename<Sizing_Imports> | string>,
    standard_bearing_rating_pounds?: GraphCacheResolver<WithTypename<Seals>, Record<string, never>, Scalars['Int'] | string>,
    standard_shaft_limit_hp?: GraphCacheResolver<WithTypename<Seals>, Record<string, never>, Scalars['Int'] | string>,
    string_load_pounds?: GraphCacheResolver<WithTypename<Seals>, Record<string, never>, Scalars['numeric'] | string>,
    thrust_collar_inner_diameter_inches?: GraphCacheResolver<WithTypename<Seals>, Record<string, never>, Scalars['numeric'] | string>,
    thrust_collar_outer_diameter_inches?: GraphCacheResolver<WithTypename<Seals>, Record<string, never>, Scalars['numeric'] | string>,
    total_seal_volume_gallons?: GraphCacheResolver<WithTypename<Seals>, Record<string, never>, Scalars['numeric'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Seals>, Record<string, never>, Scalars['timestamptz'] | string>,
    upper_chamber_pull_volume_gallons?: GraphCacheResolver<WithTypename<Seals>, Record<string, never>, Scalars['numeric'] | string>,
    user?: GraphCacheResolver<WithTypename<Seals>, Record<string, never>, WithTypename<Users> | string>,
    volume_for_bag_expansion_lower_tandem_gallons?: GraphCacheResolver<WithTypename<Seals>, Record<string, never>, Scalars['numeric'] | string>,
    volume_for_bag_expansion_upper_tandem_gallons?: GraphCacheResolver<WithTypename<Seals>, Record<string, never>, Scalars['numeric'] | string>,
    weight_pounds?: GraphCacheResolver<WithTypename<Seals>, Record<string, never>, Scalars['numeric'] | string>
  },
  seals_aggregate?: {
    aggregate?: GraphCacheResolver<WithTypename<Seals_Aggregate>, Record<string, never>, WithTypename<Seals_Aggregate_Fields> | string>,
    nodes?: GraphCacheResolver<WithTypename<Seals_Aggregate>, Record<string, never>, Array<WithTypename<Seals> | string>>
  },
  seals_aggregate_fields?: {
    avg?: GraphCacheResolver<WithTypename<Seals_Aggregate_Fields>, Record<string, never>, WithTypename<Seals_Avg_Fields> | string>,
    count?: GraphCacheResolver<WithTypename<Seals_Aggregate_Fields>, Seals_Aggregate_FieldsCountArgs, Scalars['Int'] | string>,
    max?: GraphCacheResolver<WithTypename<Seals_Aggregate_Fields>, Record<string, never>, WithTypename<Seals_Max_Fields> | string>,
    min?: GraphCacheResolver<WithTypename<Seals_Aggregate_Fields>, Record<string, never>, WithTypename<Seals_Min_Fields> | string>,
    stddev?: GraphCacheResolver<WithTypename<Seals_Aggregate_Fields>, Record<string, never>, WithTypename<Seals_Stddev_Fields> | string>,
    stddev_pop?: GraphCacheResolver<WithTypename<Seals_Aggregate_Fields>, Record<string, never>, WithTypename<Seals_Stddev_Pop_Fields> | string>,
    stddev_samp?: GraphCacheResolver<WithTypename<Seals_Aggregate_Fields>, Record<string, never>, WithTypename<Seals_Stddev_Samp_Fields> | string>,
    sum?: GraphCacheResolver<WithTypename<Seals_Aggregate_Fields>, Record<string, never>, WithTypename<Seals_Sum_Fields> | string>,
    var_pop?: GraphCacheResolver<WithTypename<Seals_Aggregate_Fields>, Record<string, never>, WithTypename<Seals_Var_Pop_Fields> | string>,
    var_samp?: GraphCacheResolver<WithTypename<Seals_Aggregate_Fields>, Record<string, never>, WithTypename<Seals_Var_Samp_Fields> | string>,
    variance?: GraphCacheResolver<WithTypename<Seals_Aggregate_Fields>, Record<string, never>, WithTypename<Seals_Variance_Fields> | string>
  },
  seals_avg_fields?: {
    bag_capacity_gallons?: GraphCacheResolver<WithTypename<Seals_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bag_chambers?: GraphCacheResolver<WithTypename<Seals_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    high_strength_bearing_rating_pounds?: GraphCacheResolver<WithTypename<Seals_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    high_strength_shaft_limit_hp?: GraphCacheResolver<WithTypename<Seals_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Seals_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    inner_diameter_inches?: GraphCacheResolver<WithTypename<Seals_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    length_inches?: GraphCacheResolver<WithTypename<Seals_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    load_c1_pounds?: GraphCacheResolver<WithTypename<Seals_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    load_cb_pounds?: GraphCacheResolver<WithTypename<Seals_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    load_test_temperature_fahrenheit?: GraphCacheResolver<WithTypename<Seals_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    max_temperature_fahrenheit?: GraphCacheResolver<WithTypename<Seals_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    neck_inner_diameter_inches?: GraphCacheResolver<WithTypename<Seals_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    neck_outer_diameter_inches?: GraphCacheResolver<WithTypename<Seals_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    outer_diameter_inches?: GraphCacheResolver<WithTypename<Seals_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    standard_bearing_rating_pounds?: GraphCacheResolver<WithTypename<Seals_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    standard_shaft_limit_hp?: GraphCacheResolver<WithTypename<Seals_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    string_load_pounds?: GraphCacheResolver<WithTypename<Seals_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    thrust_collar_inner_diameter_inches?: GraphCacheResolver<WithTypename<Seals_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    thrust_collar_outer_diameter_inches?: GraphCacheResolver<WithTypename<Seals_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    total_seal_volume_gallons?: GraphCacheResolver<WithTypename<Seals_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    upper_chamber_pull_volume_gallons?: GraphCacheResolver<WithTypename<Seals_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    volume_for_bag_expansion_lower_tandem_gallons?: GraphCacheResolver<WithTypename<Seals_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    volume_for_bag_expansion_upper_tandem_gallons?: GraphCacheResolver<WithTypename<Seals_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    weight_pounds?: GraphCacheResolver<WithTypename<Seals_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  seals_max_fields?: {
    author_id?: GraphCacheResolver<WithTypename<Seals_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    bag_capacity_gallons?: GraphCacheResolver<WithTypename<Seals_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    bag_chambers?: GraphCacheResolver<WithTypename<Seals_Max_Fields>, Record<string, never>, Scalars['Int'] | string>,
    bearing_type?: GraphCacheResolver<WithTypename<Seals_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    configuration?: GraphCacheResolver<WithTypename<Seals_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Seals_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Seals_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    description?: GraphCacheResolver<WithTypename<Seals_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    high_strength_bearing_rating_pounds?: GraphCacheResolver<WithTypename<Seals_Max_Fields>, Record<string, never>, Scalars['Int'] | string>,
    high_strength_shaft_limit_hp?: GraphCacheResolver<WithTypename<Seals_Max_Fields>, Record<string, never>, Scalars['Int'] | string>,
    housing_material?: GraphCacheResolver<WithTypename<Seals_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    id?: GraphCacheResolver<WithTypename<Seals_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Seals_Max_Fields>, Record<string, never>, Scalars['Int'] | string>,
    include_ecopetrol_timestamp?: GraphCacheResolver<WithTypename<Seals_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    include_koc_timestamp?: GraphCacheResolver<WithTypename<Seals_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    inner_diameter_inches?: GraphCacheResolver<WithTypename<Seals_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    length_inches?: GraphCacheResolver<WithTypename<Seals_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    load_c1_pounds?: GraphCacheResolver<WithTypename<Seals_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    load_cb_pounds?: GraphCacheResolver<WithTypename<Seals_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    load_test_temperature_fahrenheit?: GraphCacheResolver<WithTypename<Seals_Max_Fields>, Record<string, never>, Scalars['Int'] | string>,
    manufacturer?: GraphCacheResolver<WithTypename<Seals_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    max_temperature_fahrenheit?: GraphCacheResolver<WithTypename<Seals_Max_Fields>, Record<string, never>, Scalars['Int'] | string>,
    neck_inner_diameter_inches?: GraphCacheResolver<WithTypename<Seals_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    neck_outer_diameter_inches?: GraphCacheResolver<WithTypename<Seals_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    only_ecopetrol_timestamp?: GraphCacheResolver<WithTypename<Seals_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    only_koc_timestamp?: GraphCacheResolver<WithTypename<Seals_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    outer_diameter_inches?: GraphCacheResolver<WithTypename<Seals_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    part_number?: GraphCacheResolver<WithTypename<Seals_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    prioritized_manufacturer?: GraphCacheResolver<WithTypename<Seals_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    standard_bearing_rating_pounds?: GraphCacheResolver<WithTypename<Seals_Max_Fields>, Record<string, never>, Scalars['Int'] | string>,
    standard_shaft_limit_hp?: GraphCacheResolver<WithTypename<Seals_Max_Fields>, Record<string, never>, Scalars['Int'] | string>,
    string_load_pounds?: GraphCacheResolver<WithTypename<Seals_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    thrust_collar_inner_diameter_inches?: GraphCacheResolver<WithTypename<Seals_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    thrust_collar_outer_diameter_inches?: GraphCacheResolver<WithTypename<Seals_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    total_seal_volume_gallons?: GraphCacheResolver<WithTypename<Seals_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Seals_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    upper_chamber_pull_volume_gallons?: GraphCacheResolver<WithTypename<Seals_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    volume_for_bag_expansion_lower_tandem_gallons?: GraphCacheResolver<WithTypename<Seals_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    volume_for_bag_expansion_upper_tandem_gallons?: GraphCacheResolver<WithTypename<Seals_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    weight_pounds?: GraphCacheResolver<WithTypename<Seals_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>
  },
  seals_min_fields?: {
    author_id?: GraphCacheResolver<WithTypename<Seals_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    bag_capacity_gallons?: GraphCacheResolver<WithTypename<Seals_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    bag_chambers?: GraphCacheResolver<WithTypename<Seals_Min_Fields>, Record<string, never>, Scalars['Int'] | string>,
    bearing_type?: GraphCacheResolver<WithTypename<Seals_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    configuration?: GraphCacheResolver<WithTypename<Seals_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Seals_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Seals_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    description?: GraphCacheResolver<WithTypename<Seals_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    high_strength_bearing_rating_pounds?: GraphCacheResolver<WithTypename<Seals_Min_Fields>, Record<string, never>, Scalars['Int'] | string>,
    high_strength_shaft_limit_hp?: GraphCacheResolver<WithTypename<Seals_Min_Fields>, Record<string, never>, Scalars['Int'] | string>,
    housing_material?: GraphCacheResolver<WithTypename<Seals_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    id?: GraphCacheResolver<WithTypename<Seals_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Seals_Min_Fields>, Record<string, never>, Scalars['Int'] | string>,
    include_ecopetrol_timestamp?: GraphCacheResolver<WithTypename<Seals_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    include_koc_timestamp?: GraphCacheResolver<WithTypename<Seals_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    inner_diameter_inches?: GraphCacheResolver<WithTypename<Seals_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    length_inches?: GraphCacheResolver<WithTypename<Seals_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    load_c1_pounds?: GraphCacheResolver<WithTypename<Seals_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    load_cb_pounds?: GraphCacheResolver<WithTypename<Seals_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    load_test_temperature_fahrenheit?: GraphCacheResolver<WithTypename<Seals_Min_Fields>, Record<string, never>, Scalars['Int'] | string>,
    manufacturer?: GraphCacheResolver<WithTypename<Seals_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    max_temperature_fahrenheit?: GraphCacheResolver<WithTypename<Seals_Min_Fields>, Record<string, never>, Scalars['Int'] | string>,
    neck_inner_diameter_inches?: GraphCacheResolver<WithTypename<Seals_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    neck_outer_diameter_inches?: GraphCacheResolver<WithTypename<Seals_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    only_ecopetrol_timestamp?: GraphCacheResolver<WithTypename<Seals_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    only_koc_timestamp?: GraphCacheResolver<WithTypename<Seals_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    outer_diameter_inches?: GraphCacheResolver<WithTypename<Seals_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    part_number?: GraphCacheResolver<WithTypename<Seals_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    prioritized_manufacturer?: GraphCacheResolver<WithTypename<Seals_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    standard_bearing_rating_pounds?: GraphCacheResolver<WithTypename<Seals_Min_Fields>, Record<string, never>, Scalars['Int'] | string>,
    standard_shaft_limit_hp?: GraphCacheResolver<WithTypename<Seals_Min_Fields>, Record<string, never>, Scalars['Int'] | string>,
    string_load_pounds?: GraphCacheResolver<WithTypename<Seals_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    thrust_collar_inner_diameter_inches?: GraphCacheResolver<WithTypename<Seals_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    thrust_collar_outer_diameter_inches?: GraphCacheResolver<WithTypename<Seals_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    total_seal_volume_gallons?: GraphCacheResolver<WithTypename<Seals_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Seals_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    upper_chamber_pull_volume_gallons?: GraphCacheResolver<WithTypename<Seals_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    volume_for_bag_expansion_lower_tandem_gallons?: GraphCacheResolver<WithTypename<Seals_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    volume_for_bag_expansion_upper_tandem_gallons?: GraphCacheResolver<WithTypename<Seals_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    weight_pounds?: GraphCacheResolver<WithTypename<Seals_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>
  },
  seals_mutation_response?: {
    affected_rows?: GraphCacheResolver<WithTypename<Seals_Mutation_Response>, Record<string, never>, Scalars['Int'] | string>,
    returning?: GraphCacheResolver<WithTypename<Seals_Mutation_Response>, Record<string, never>, Array<WithTypename<Seals> | string>>
  },
  seals_stddev_fields?: {
    bag_capacity_gallons?: GraphCacheResolver<WithTypename<Seals_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bag_chambers?: GraphCacheResolver<WithTypename<Seals_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    high_strength_bearing_rating_pounds?: GraphCacheResolver<WithTypename<Seals_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    high_strength_shaft_limit_hp?: GraphCacheResolver<WithTypename<Seals_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Seals_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    inner_diameter_inches?: GraphCacheResolver<WithTypename<Seals_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    length_inches?: GraphCacheResolver<WithTypename<Seals_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    load_c1_pounds?: GraphCacheResolver<WithTypename<Seals_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    load_cb_pounds?: GraphCacheResolver<WithTypename<Seals_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    load_test_temperature_fahrenheit?: GraphCacheResolver<WithTypename<Seals_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    max_temperature_fahrenheit?: GraphCacheResolver<WithTypename<Seals_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    neck_inner_diameter_inches?: GraphCacheResolver<WithTypename<Seals_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    neck_outer_diameter_inches?: GraphCacheResolver<WithTypename<Seals_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    outer_diameter_inches?: GraphCacheResolver<WithTypename<Seals_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    standard_bearing_rating_pounds?: GraphCacheResolver<WithTypename<Seals_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    standard_shaft_limit_hp?: GraphCacheResolver<WithTypename<Seals_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    string_load_pounds?: GraphCacheResolver<WithTypename<Seals_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    thrust_collar_inner_diameter_inches?: GraphCacheResolver<WithTypename<Seals_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    thrust_collar_outer_diameter_inches?: GraphCacheResolver<WithTypename<Seals_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    total_seal_volume_gallons?: GraphCacheResolver<WithTypename<Seals_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    upper_chamber_pull_volume_gallons?: GraphCacheResolver<WithTypename<Seals_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    volume_for_bag_expansion_lower_tandem_gallons?: GraphCacheResolver<WithTypename<Seals_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    volume_for_bag_expansion_upper_tandem_gallons?: GraphCacheResolver<WithTypename<Seals_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    weight_pounds?: GraphCacheResolver<WithTypename<Seals_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  seals_stddev_pop_fields?: {
    bag_capacity_gallons?: GraphCacheResolver<WithTypename<Seals_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bag_chambers?: GraphCacheResolver<WithTypename<Seals_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    high_strength_bearing_rating_pounds?: GraphCacheResolver<WithTypename<Seals_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    high_strength_shaft_limit_hp?: GraphCacheResolver<WithTypename<Seals_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Seals_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    inner_diameter_inches?: GraphCacheResolver<WithTypename<Seals_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    length_inches?: GraphCacheResolver<WithTypename<Seals_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    load_c1_pounds?: GraphCacheResolver<WithTypename<Seals_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    load_cb_pounds?: GraphCacheResolver<WithTypename<Seals_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    load_test_temperature_fahrenheit?: GraphCacheResolver<WithTypename<Seals_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    max_temperature_fahrenheit?: GraphCacheResolver<WithTypename<Seals_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    neck_inner_diameter_inches?: GraphCacheResolver<WithTypename<Seals_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    neck_outer_diameter_inches?: GraphCacheResolver<WithTypename<Seals_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    outer_diameter_inches?: GraphCacheResolver<WithTypename<Seals_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    standard_bearing_rating_pounds?: GraphCacheResolver<WithTypename<Seals_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    standard_shaft_limit_hp?: GraphCacheResolver<WithTypename<Seals_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    string_load_pounds?: GraphCacheResolver<WithTypename<Seals_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    thrust_collar_inner_diameter_inches?: GraphCacheResolver<WithTypename<Seals_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    thrust_collar_outer_diameter_inches?: GraphCacheResolver<WithTypename<Seals_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    total_seal_volume_gallons?: GraphCacheResolver<WithTypename<Seals_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    upper_chamber_pull_volume_gallons?: GraphCacheResolver<WithTypename<Seals_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    volume_for_bag_expansion_lower_tandem_gallons?: GraphCacheResolver<WithTypename<Seals_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    volume_for_bag_expansion_upper_tandem_gallons?: GraphCacheResolver<WithTypename<Seals_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    weight_pounds?: GraphCacheResolver<WithTypename<Seals_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  seals_stddev_samp_fields?: {
    bag_capacity_gallons?: GraphCacheResolver<WithTypename<Seals_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bag_chambers?: GraphCacheResolver<WithTypename<Seals_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    high_strength_bearing_rating_pounds?: GraphCacheResolver<WithTypename<Seals_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    high_strength_shaft_limit_hp?: GraphCacheResolver<WithTypename<Seals_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Seals_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    inner_diameter_inches?: GraphCacheResolver<WithTypename<Seals_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    length_inches?: GraphCacheResolver<WithTypename<Seals_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    load_c1_pounds?: GraphCacheResolver<WithTypename<Seals_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    load_cb_pounds?: GraphCacheResolver<WithTypename<Seals_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    load_test_temperature_fahrenheit?: GraphCacheResolver<WithTypename<Seals_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    max_temperature_fahrenheit?: GraphCacheResolver<WithTypename<Seals_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    neck_inner_diameter_inches?: GraphCacheResolver<WithTypename<Seals_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    neck_outer_diameter_inches?: GraphCacheResolver<WithTypename<Seals_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    outer_diameter_inches?: GraphCacheResolver<WithTypename<Seals_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    standard_bearing_rating_pounds?: GraphCacheResolver<WithTypename<Seals_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    standard_shaft_limit_hp?: GraphCacheResolver<WithTypename<Seals_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    string_load_pounds?: GraphCacheResolver<WithTypename<Seals_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    thrust_collar_inner_diameter_inches?: GraphCacheResolver<WithTypename<Seals_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    thrust_collar_outer_diameter_inches?: GraphCacheResolver<WithTypename<Seals_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    total_seal_volume_gallons?: GraphCacheResolver<WithTypename<Seals_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    upper_chamber_pull_volume_gallons?: GraphCacheResolver<WithTypename<Seals_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    volume_for_bag_expansion_lower_tandem_gallons?: GraphCacheResolver<WithTypename<Seals_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    volume_for_bag_expansion_upper_tandem_gallons?: GraphCacheResolver<WithTypename<Seals_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    weight_pounds?: GraphCacheResolver<WithTypename<Seals_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  seals_sum_fields?: {
    bag_capacity_gallons?: GraphCacheResolver<WithTypename<Seals_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    bag_chambers?: GraphCacheResolver<WithTypename<Seals_Sum_Fields>, Record<string, never>, Scalars['Int'] | string>,
    high_strength_bearing_rating_pounds?: GraphCacheResolver<WithTypename<Seals_Sum_Fields>, Record<string, never>, Scalars['Int'] | string>,
    high_strength_shaft_limit_hp?: GraphCacheResolver<WithTypename<Seals_Sum_Fields>, Record<string, never>, Scalars['Int'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Seals_Sum_Fields>, Record<string, never>, Scalars['Int'] | string>,
    inner_diameter_inches?: GraphCacheResolver<WithTypename<Seals_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    length_inches?: GraphCacheResolver<WithTypename<Seals_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    load_c1_pounds?: GraphCacheResolver<WithTypename<Seals_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    load_cb_pounds?: GraphCacheResolver<WithTypename<Seals_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    load_test_temperature_fahrenheit?: GraphCacheResolver<WithTypename<Seals_Sum_Fields>, Record<string, never>, Scalars['Int'] | string>,
    max_temperature_fahrenheit?: GraphCacheResolver<WithTypename<Seals_Sum_Fields>, Record<string, never>, Scalars['Int'] | string>,
    neck_inner_diameter_inches?: GraphCacheResolver<WithTypename<Seals_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    neck_outer_diameter_inches?: GraphCacheResolver<WithTypename<Seals_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    outer_diameter_inches?: GraphCacheResolver<WithTypename<Seals_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    standard_bearing_rating_pounds?: GraphCacheResolver<WithTypename<Seals_Sum_Fields>, Record<string, never>, Scalars['Int'] | string>,
    standard_shaft_limit_hp?: GraphCacheResolver<WithTypename<Seals_Sum_Fields>, Record<string, never>, Scalars['Int'] | string>,
    string_load_pounds?: GraphCacheResolver<WithTypename<Seals_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    thrust_collar_inner_diameter_inches?: GraphCacheResolver<WithTypename<Seals_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    thrust_collar_outer_diameter_inches?: GraphCacheResolver<WithTypename<Seals_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    total_seal_volume_gallons?: GraphCacheResolver<WithTypename<Seals_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    upper_chamber_pull_volume_gallons?: GraphCacheResolver<WithTypename<Seals_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    volume_for_bag_expansion_lower_tandem_gallons?: GraphCacheResolver<WithTypename<Seals_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    volume_for_bag_expansion_upper_tandem_gallons?: GraphCacheResolver<WithTypename<Seals_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    weight_pounds?: GraphCacheResolver<WithTypename<Seals_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>
  },
  seals_var_pop_fields?: {
    bag_capacity_gallons?: GraphCacheResolver<WithTypename<Seals_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bag_chambers?: GraphCacheResolver<WithTypename<Seals_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    high_strength_bearing_rating_pounds?: GraphCacheResolver<WithTypename<Seals_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    high_strength_shaft_limit_hp?: GraphCacheResolver<WithTypename<Seals_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Seals_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    inner_diameter_inches?: GraphCacheResolver<WithTypename<Seals_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    length_inches?: GraphCacheResolver<WithTypename<Seals_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    load_c1_pounds?: GraphCacheResolver<WithTypename<Seals_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    load_cb_pounds?: GraphCacheResolver<WithTypename<Seals_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    load_test_temperature_fahrenheit?: GraphCacheResolver<WithTypename<Seals_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    max_temperature_fahrenheit?: GraphCacheResolver<WithTypename<Seals_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    neck_inner_diameter_inches?: GraphCacheResolver<WithTypename<Seals_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    neck_outer_diameter_inches?: GraphCacheResolver<WithTypename<Seals_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    outer_diameter_inches?: GraphCacheResolver<WithTypename<Seals_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    standard_bearing_rating_pounds?: GraphCacheResolver<WithTypename<Seals_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    standard_shaft_limit_hp?: GraphCacheResolver<WithTypename<Seals_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    string_load_pounds?: GraphCacheResolver<WithTypename<Seals_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    thrust_collar_inner_diameter_inches?: GraphCacheResolver<WithTypename<Seals_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    thrust_collar_outer_diameter_inches?: GraphCacheResolver<WithTypename<Seals_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    total_seal_volume_gallons?: GraphCacheResolver<WithTypename<Seals_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    upper_chamber_pull_volume_gallons?: GraphCacheResolver<WithTypename<Seals_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    volume_for_bag_expansion_lower_tandem_gallons?: GraphCacheResolver<WithTypename<Seals_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    volume_for_bag_expansion_upper_tandem_gallons?: GraphCacheResolver<WithTypename<Seals_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    weight_pounds?: GraphCacheResolver<WithTypename<Seals_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  seals_var_samp_fields?: {
    bag_capacity_gallons?: GraphCacheResolver<WithTypename<Seals_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bag_chambers?: GraphCacheResolver<WithTypename<Seals_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    high_strength_bearing_rating_pounds?: GraphCacheResolver<WithTypename<Seals_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    high_strength_shaft_limit_hp?: GraphCacheResolver<WithTypename<Seals_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Seals_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    inner_diameter_inches?: GraphCacheResolver<WithTypename<Seals_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    length_inches?: GraphCacheResolver<WithTypename<Seals_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    load_c1_pounds?: GraphCacheResolver<WithTypename<Seals_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    load_cb_pounds?: GraphCacheResolver<WithTypename<Seals_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    load_test_temperature_fahrenheit?: GraphCacheResolver<WithTypename<Seals_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    max_temperature_fahrenheit?: GraphCacheResolver<WithTypename<Seals_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    neck_inner_diameter_inches?: GraphCacheResolver<WithTypename<Seals_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    neck_outer_diameter_inches?: GraphCacheResolver<WithTypename<Seals_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    outer_diameter_inches?: GraphCacheResolver<WithTypename<Seals_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    standard_bearing_rating_pounds?: GraphCacheResolver<WithTypename<Seals_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    standard_shaft_limit_hp?: GraphCacheResolver<WithTypename<Seals_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    string_load_pounds?: GraphCacheResolver<WithTypename<Seals_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    thrust_collar_inner_diameter_inches?: GraphCacheResolver<WithTypename<Seals_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    thrust_collar_outer_diameter_inches?: GraphCacheResolver<WithTypename<Seals_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    total_seal_volume_gallons?: GraphCacheResolver<WithTypename<Seals_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    upper_chamber_pull_volume_gallons?: GraphCacheResolver<WithTypename<Seals_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    volume_for_bag_expansion_lower_tandem_gallons?: GraphCacheResolver<WithTypename<Seals_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    volume_for_bag_expansion_upper_tandem_gallons?: GraphCacheResolver<WithTypename<Seals_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    weight_pounds?: GraphCacheResolver<WithTypename<Seals_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  seals_variance_fields?: {
    bag_capacity_gallons?: GraphCacheResolver<WithTypename<Seals_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    bag_chambers?: GraphCacheResolver<WithTypename<Seals_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    high_strength_bearing_rating_pounds?: GraphCacheResolver<WithTypename<Seals_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    high_strength_shaft_limit_hp?: GraphCacheResolver<WithTypename<Seals_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Seals_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    inner_diameter_inches?: GraphCacheResolver<WithTypename<Seals_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    length_inches?: GraphCacheResolver<WithTypename<Seals_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    load_c1_pounds?: GraphCacheResolver<WithTypename<Seals_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    load_cb_pounds?: GraphCacheResolver<WithTypename<Seals_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    load_test_temperature_fahrenheit?: GraphCacheResolver<WithTypename<Seals_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    max_temperature_fahrenheit?: GraphCacheResolver<WithTypename<Seals_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    neck_inner_diameter_inches?: GraphCacheResolver<WithTypename<Seals_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    neck_outer_diameter_inches?: GraphCacheResolver<WithTypename<Seals_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    outer_diameter_inches?: GraphCacheResolver<WithTypename<Seals_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    standard_bearing_rating_pounds?: GraphCacheResolver<WithTypename<Seals_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    standard_shaft_limit_hp?: GraphCacheResolver<WithTypename<Seals_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    string_load_pounds?: GraphCacheResolver<WithTypename<Seals_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    thrust_collar_inner_diameter_inches?: GraphCacheResolver<WithTypename<Seals_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    thrust_collar_outer_diameter_inches?: GraphCacheResolver<WithTypename<Seals_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    total_seal_volume_gallons?: GraphCacheResolver<WithTypename<Seals_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    upper_chamber_pull_volume_gallons?: GraphCacheResolver<WithTypename<Seals_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    volume_for_bag_expansion_lower_tandem_gallons?: GraphCacheResolver<WithTypename<Seals_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    volume_for_bag_expansion_upper_tandem_gallons?: GraphCacheResolver<WithTypename<Seals_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    weight_pounds?: GraphCacheResolver<WithTypename<Seals_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  sensors?: {
    author_id?: GraphCacheResolver<WithTypename<Sensors>, Record<string, never>, Scalars['String'] | string>,
    channels?: GraphCacheResolver<WithTypename<Sensors>, Record<string, never>, Scalars['Int'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Sensors>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Sensors>, Record<string, never>, Scalars['timestamptz'] | string>,
    housing_material?: GraphCacheResolver<WithTypename<Sensors>, Record<string, never>, Scalars['String'] | string>,
    id?: GraphCacheResolver<WithTypename<Sensors>, Record<string, never>, Scalars['uuid'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Sensors>, Record<string, never>, Scalars['Int'] | string>,
    include_ecopetrol_timestamp?: GraphCacheResolver<WithTypename<Sensors>, Record<string, never>, Scalars['timestamptz'] | string>,
    include_koc_timestamp?: GraphCacheResolver<WithTypename<Sensors>, Record<string, never>, Scalars['timestamptz'] | string>,
    inner_diameter_inches?: GraphCacheResolver<WithTypename<Sensors>, Record<string, never>, Scalars['numeric'] | string>,
    length_inches?: GraphCacheResolver<WithTypename<Sensors>, Record<string, never>, Scalars['Int'] | string>,
    manufacturer?: GraphCacheResolver<WithTypename<Sensors>, Record<string, never>, Scalars['String'] | string>,
    max_intake_pressure_psi?: GraphCacheResolver<WithTypename<Sensors>, Record<string, never>, Scalars['Int'] | string>,
    max_intake_temperature_fahrenheit?: GraphCacheResolver<WithTypename<Sensors>, Record<string, never>, Scalars['Int'] | string>,
    model?: GraphCacheResolver<WithTypename<Sensors>, Record<string, never>, Scalars['String'] | string>,
    neck_inner_diameter_inches?: GraphCacheResolver<WithTypename<Sensors>, Record<string, never>, Scalars['numeric'] | string>,
    neck_outer_diameter_inches?: GraphCacheResolver<WithTypename<Sensors>, Record<string, never>, Scalars['numeric'] | string>,
    only_ecopetrol_timestamp?: GraphCacheResolver<WithTypename<Sensors>, Record<string, never>, Scalars['timestamptz'] | string>,
    only_koc_timestamp?: GraphCacheResolver<WithTypename<Sensors>, Record<string, never>, Scalars['timestamptz'] | string>,
    outer_diameter_inches?: GraphCacheResolver<WithTypename<Sensors>, Record<string, never>, Scalars['numeric'] | string>,
    part_number?: GraphCacheResolver<WithTypename<Sensors>, Record<string, never>, Scalars['String'] | string>,
    prioritized_manufacturer?: GraphCacheResolver<WithTypename<Sensors>, Record<string, never>, Scalars['String'] | string>,
    sizing_import?: GraphCacheResolver<WithTypename<Sensors>, Record<string, never>, WithTypename<Sizing_Imports> | string>,
    updated_at?: GraphCacheResolver<WithTypename<Sensors>, Record<string, never>, Scalars['timestamptz'] | string>,
    user?: GraphCacheResolver<WithTypename<Sensors>, Record<string, never>, WithTypename<Users> | string>,
    weight_pounds?: GraphCacheResolver<WithTypename<Sensors>, Record<string, never>, Scalars['Int'] | string>
  },
  sensors_aggregate?: {
    aggregate?: GraphCacheResolver<WithTypename<Sensors_Aggregate>, Record<string, never>, WithTypename<Sensors_Aggregate_Fields> | string>,
    nodes?: GraphCacheResolver<WithTypename<Sensors_Aggregate>, Record<string, never>, Array<WithTypename<Sensors> | string>>
  },
  sensors_aggregate_fields?: {
    avg?: GraphCacheResolver<WithTypename<Sensors_Aggregate_Fields>, Record<string, never>, WithTypename<Sensors_Avg_Fields> | string>,
    count?: GraphCacheResolver<WithTypename<Sensors_Aggregate_Fields>, Sensors_Aggregate_FieldsCountArgs, Scalars['Int'] | string>,
    max?: GraphCacheResolver<WithTypename<Sensors_Aggregate_Fields>, Record<string, never>, WithTypename<Sensors_Max_Fields> | string>,
    min?: GraphCacheResolver<WithTypename<Sensors_Aggregate_Fields>, Record<string, never>, WithTypename<Sensors_Min_Fields> | string>,
    stddev?: GraphCacheResolver<WithTypename<Sensors_Aggregate_Fields>, Record<string, never>, WithTypename<Sensors_Stddev_Fields> | string>,
    stddev_pop?: GraphCacheResolver<WithTypename<Sensors_Aggregate_Fields>, Record<string, never>, WithTypename<Sensors_Stddev_Pop_Fields> | string>,
    stddev_samp?: GraphCacheResolver<WithTypename<Sensors_Aggregate_Fields>, Record<string, never>, WithTypename<Sensors_Stddev_Samp_Fields> | string>,
    sum?: GraphCacheResolver<WithTypename<Sensors_Aggregate_Fields>, Record<string, never>, WithTypename<Sensors_Sum_Fields> | string>,
    var_pop?: GraphCacheResolver<WithTypename<Sensors_Aggregate_Fields>, Record<string, never>, WithTypename<Sensors_Var_Pop_Fields> | string>,
    var_samp?: GraphCacheResolver<WithTypename<Sensors_Aggregate_Fields>, Record<string, never>, WithTypename<Sensors_Var_Samp_Fields> | string>,
    variance?: GraphCacheResolver<WithTypename<Sensors_Aggregate_Fields>, Record<string, never>, WithTypename<Sensors_Variance_Fields> | string>
  },
  sensors_avg_fields?: {
    channels?: GraphCacheResolver<WithTypename<Sensors_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Sensors_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    inner_diameter_inches?: GraphCacheResolver<WithTypename<Sensors_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    length_inches?: GraphCacheResolver<WithTypename<Sensors_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    max_intake_pressure_psi?: GraphCacheResolver<WithTypename<Sensors_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    max_intake_temperature_fahrenheit?: GraphCacheResolver<WithTypename<Sensors_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    neck_inner_diameter_inches?: GraphCacheResolver<WithTypename<Sensors_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    neck_outer_diameter_inches?: GraphCacheResolver<WithTypename<Sensors_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    outer_diameter_inches?: GraphCacheResolver<WithTypename<Sensors_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    weight_pounds?: GraphCacheResolver<WithTypename<Sensors_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  sensors_max_fields?: {
    author_id?: GraphCacheResolver<WithTypename<Sensors_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    channels?: GraphCacheResolver<WithTypename<Sensors_Max_Fields>, Record<string, never>, Scalars['Int'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Sensors_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Sensors_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    housing_material?: GraphCacheResolver<WithTypename<Sensors_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    id?: GraphCacheResolver<WithTypename<Sensors_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Sensors_Max_Fields>, Record<string, never>, Scalars['Int'] | string>,
    include_ecopetrol_timestamp?: GraphCacheResolver<WithTypename<Sensors_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    include_koc_timestamp?: GraphCacheResolver<WithTypename<Sensors_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    inner_diameter_inches?: GraphCacheResolver<WithTypename<Sensors_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    length_inches?: GraphCacheResolver<WithTypename<Sensors_Max_Fields>, Record<string, never>, Scalars['Int'] | string>,
    manufacturer?: GraphCacheResolver<WithTypename<Sensors_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    max_intake_pressure_psi?: GraphCacheResolver<WithTypename<Sensors_Max_Fields>, Record<string, never>, Scalars['Int'] | string>,
    max_intake_temperature_fahrenheit?: GraphCacheResolver<WithTypename<Sensors_Max_Fields>, Record<string, never>, Scalars['Int'] | string>,
    model?: GraphCacheResolver<WithTypename<Sensors_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    neck_inner_diameter_inches?: GraphCacheResolver<WithTypename<Sensors_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    neck_outer_diameter_inches?: GraphCacheResolver<WithTypename<Sensors_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    only_ecopetrol_timestamp?: GraphCacheResolver<WithTypename<Sensors_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    only_koc_timestamp?: GraphCacheResolver<WithTypename<Sensors_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    outer_diameter_inches?: GraphCacheResolver<WithTypename<Sensors_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    part_number?: GraphCacheResolver<WithTypename<Sensors_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    prioritized_manufacturer?: GraphCacheResolver<WithTypename<Sensors_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Sensors_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    weight_pounds?: GraphCacheResolver<WithTypename<Sensors_Max_Fields>, Record<string, never>, Scalars['Int'] | string>
  },
  sensors_min_fields?: {
    author_id?: GraphCacheResolver<WithTypename<Sensors_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    channels?: GraphCacheResolver<WithTypename<Sensors_Min_Fields>, Record<string, never>, Scalars['Int'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Sensors_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Sensors_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    housing_material?: GraphCacheResolver<WithTypename<Sensors_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    id?: GraphCacheResolver<WithTypename<Sensors_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Sensors_Min_Fields>, Record<string, never>, Scalars['Int'] | string>,
    include_ecopetrol_timestamp?: GraphCacheResolver<WithTypename<Sensors_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    include_koc_timestamp?: GraphCacheResolver<WithTypename<Sensors_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    inner_diameter_inches?: GraphCacheResolver<WithTypename<Sensors_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    length_inches?: GraphCacheResolver<WithTypename<Sensors_Min_Fields>, Record<string, never>, Scalars['Int'] | string>,
    manufacturer?: GraphCacheResolver<WithTypename<Sensors_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    max_intake_pressure_psi?: GraphCacheResolver<WithTypename<Sensors_Min_Fields>, Record<string, never>, Scalars['Int'] | string>,
    max_intake_temperature_fahrenheit?: GraphCacheResolver<WithTypename<Sensors_Min_Fields>, Record<string, never>, Scalars['Int'] | string>,
    model?: GraphCacheResolver<WithTypename<Sensors_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    neck_inner_diameter_inches?: GraphCacheResolver<WithTypename<Sensors_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    neck_outer_diameter_inches?: GraphCacheResolver<WithTypename<Sensors_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    only_ecopetrol_timestamp?: GraphCacheResolver<WithTypename<Sensors_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    only_koc_timestamp?: GraphCacheResolver<WithTypename<Sensors_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    outer_diameter_inches?: GraphCacheResolver<WithTypename<Sensors_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    part_number?: GraphCacheResolver<WithTypename<Sensors_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    prioritized_manufacturer?: GraphCacheResolver<WithTypename<Sensors_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Sensors_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    weight_pounds?: GraphCacheResolver<WithTypename<Sensors_Min_Fields>, Record<string, never>, Scalars['Int'] | string>
  },
  sensors_mutation_response?: {
    affected_rows?: GraphCacheResolver<WithTypename<Sensors_Mutation_Response>, Record<string, never>, Scalars['Int'] | string>,
    returning?: GraphCacheResolver<WithTypename<Sensors_Mutation_Response>, Record<string, never>, Array<WithTypename<Sensors> | string>>
  },
  sensors_stddev_fields?: {
    channels?: GraphCacheResolver<WithTypename<Sensors_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Sensors_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    inner_diameter_inches?: GraphCacheResolver<WithTypename<Sensors_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    length_inches?: GraphCacheResolver<WithTypename<Sensors_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    max_intake_pressure_psi?: GraphCacheResolver<WithTypename<Sensors_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    max_intake_temperature_fahrenheit?: GraphCacheResolver<WithTypename<Sensors_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    neck_inner_diameter_inches?: GraphCacheResolver<WithTypename<Sensors_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    neck_outer_diameter_inches?: GraphCacheResolver<WithTypename<Sensors_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    outer_diameter_inches?: GraphCacheResolver<WithTypename<Sensors_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    weight_pounds?: GraphCacheResolver<WithTypename<Sensors_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  sensors_stddev_pop_fields?: {
    channels?: GraphCacheResolver<WithTypename<Sensors_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Sensors_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    inner_diameter_inches?: GraphCacheResolver<WithTypename<Sensors_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    length_inches?: GraphCacheResolver<WithTypename<Sensors_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    max_intake_pressure_psi?: GraphCacheResolver<WithTypename<Sensors_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    max_intake_temperature_fahrenheit?: GraphCacheResolver<WithTypename<Sensors_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    neck_inner_diameter_inches?: GraphCacheResolver<WithTypename<Sensors_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    neck_outer_diameter_inches?: GraphCacheResolver<WithTypename<Sensors_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    outer_diameter_inches?: GraphCacheResolver<WithTypename<Sensors_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    weight_pounds?: GraphCacheResolver<WithTypename<Sensors_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  sensors_stddev_samp_fields?: {
    channels?: GraphCacheResolver<WithTypename<Sensors_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Sensors_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    inner_diameter_inches?: GraphCacheResolver<WithTypename<Sensors_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    length_inches?: GraphCacheResolver<WithTypename<Sensors_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    max_intake_pressure_psi?: GraphCacheResolver<WithTypename<Sensors_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    max_intake_temperature_fahrenheit?: GraphCacheResolver<WithTypename<Sensors_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    neck_inner_diameter_inches?: GraphCacheResolver<WithTypename<Sensors_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    neck_outer_diameter_inches?: GraphCacheResolver<WithTypename<Sensors_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    outer_diameter_inches?: GraphCacheResolver<WithTypename<Sensors_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    weight_pounds?: GraphCacheResolver<WithTypename<Sensors_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  sensors_sum_fields?: {
    channels?: GraphCacheResolver<WithTypename<Sensors_Sum_Fields>, Record<string, never>, Scalars['Int'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Sensors_Sum_Fields>, Record<string, never>, Scalars['Int'] | string>,
    inner_diameter_inches?: GraphCacheResolver<WithTypename<Sensors_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    length_inches?: GraphCacheResolver<WithTypename<Sensors_Sum_Fields>, Record<string, never>, Scalars['Int'] | string>,
    max_intake_pressure_psi?: GraphCacheResolver<WithTypename<Sensors_Sum_Fields>, Record<string, never>, Scalars['Int'] | string>,
    max_intake_temperature_fahrenheit?: GraphCacheResolver<WithTypename<Sensors_Sum_Fields>, Record<string, never>, Scalars['Int'] | string>,
    neck_inner_diameter_inches?: GraphCacheResolver<WithTypename<Sensors_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    neck_outer_diameter_inches?: GraphCacheResolver<WithTypename<Sensors_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    outer_diameter_inches?: GraphCacheResolver<WithTypename<Sensors_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    weight_pounds?: GraphCacheResolver<WithTypename<Sensors_Sum_Fields>, Record<string, never>, Scalars['Int'] | string>
  },
  sensors_var_pop_fields?: {
    channels?: GraphCacheResolver<WithTypename<Sensors_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Sensors_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    inner_diameter_inches?: GraphCacheResolver<WithTypename<Sensors_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    length_inches?: GraphCacheResolver<WithTypename<Sensors_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    max_intake_pressure_psi?: GraphCacheResolver<WithTypename<Sensors_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    max_intake_temperature_fahrenheit?: GraphCacheResolver<WithTypename<Sensors_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    neck_inner_diameter_inches?: GraphCacheResolver<WithTypename<Sensors_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    neck_outer_diameter_inches?: GraphCacheResolver<WithTypename<Sensors_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    outer_diameter_inches?: GraphCacheResolver<WithTypename<Sensors_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    weight_pounds?: GraphCacheResolver<WithTypename<Sensors_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  sensors_var_samp_fields?: {
    channels?: GraphCacheResolver<WithTypename<Sensors_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Sensors_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    inner_diameter_inches?: GraphCacheResolver<WithTypename<Sensors_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    length_inches?: GraphCacheResolver<WithTypename<Sensors_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    max_intake_pressure_psi?: GraphCacheResolver<WithTypename<Sensors_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    max_intake_temperature_fahrenheit?: GraphCacheResolver<WithTypename<Sensors_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    neck_inner_diameter_inches?: GraphCacheResolver<WithTypename<Sensors_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    neck_outer_diameter_inches?: GraphCacheResolver<WithTypename<Sensors_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    outer_diameter_inches?: GraphCacheResolver<WithTypename<Sensors_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    weight_pounds?: GraphCacheResolver<WithTypename<Sensors_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  sensors_variance_fields?: {
    channels?: GraphCacheResolver<WithTypename<Sensors_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Sensors_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    inner_diameter_inches?: GraphCacheResolver<WithTypename<Sensors_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    length_inches?: GraphCacheResolver<WithTypename<Sensors_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    max_intake_pressure_psi?: GraphCacheResolver<WithTypename<Sensors_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    max_intake_temperature_fahrenheit?: GraphCacheResolver<WithTypename<Sensors_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    neck_inner_diameter_inches?: GraphCacheResolver<WithTypename<Sensors_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    neck_outer_diameter_inches?: GraphCacheResolver<WithTypename<Sensors_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    outer_diameter_inches?: GraphCacheResolver<WithTypename<Sensors_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    weight_pounds?: GraphCacheResolver<WithTypename<Sensors_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  sizing_dispositions?: {
    comment?: GraphCacheResolver<WithTypename<Sizing_Dispositions>, Record<string, never>, Scalars['String'] | string>,
    value?: GraphCacheResolver<WithTypename<Sizing_Dispositions>, Record<string, never>, Scalars['String'] | string>
  },
  sizing_dispositions_aggregate?: {
    aggregate?: GraphCacheResolver<WithTypename<Sizing_Dispositions_Aggregate>, Record<string, never>, WithTypename<Sizing_Dispositions_Aggregate_Fields> | string>,
    nodes?: GraphCacheResolver<WithTypename<Sizing_Dispositions_Aggregate>, Record<string, never>, Array<WithTypename<Sizing_Dispositions> | string>>
  },
  sizing_dispositions_aggregate_fields?: {
    count?: GraphCacheResolver<WithTypename<Sizing_Dispositions_Aggregate_Fields>, Sizing_Dispositions_Aggregate_FieldsCountArgs, Scalars['Int'] | string>,
    max?: GraphCacheResolver<WithTypename<Sizing_Dispositions_Aggregate_Fields>, Record<string, never>, WithTypename<Sizing_Dispositions_Max_Fields> | string>,
    min?: GraphCacheResolver<WithTypename<Sizing_Dispositions_Aggregate_Fields>, Record<string, never>, WithTypename<Sizing_Dispositions_Min_Fields> | string>
  },
  sizing_dispositions_max_fields?: {
    comment?: GraphCacheResolver<WithTypename<Sizing_Dispositions_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    value?: GraphCacheResolver<WithTypename<Sizing_Dispositions_Max_Fields>, Record<string, never>, Scalars['String'] | string>
  },
  sizing_dispositions_min_fields?: {
    comment?: GraphCacheResolver<WithTypename<Sizing_Dispositions_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    value?: GraphCacheResolver<WithTypename<Sizing_Dispositions_Min_Fields>, Record<string, never>, Scalars['String'] | string>
  },
  sizing_dispositions_mutation_response?: {
    affected_rows?: GraphCacheResolver<WithTypename<Sizing_Dispositions_Mutation_Response>, Record<string, never>, Scalars['Int'] | string>,
    returning?: GraphCacheResolver<WithTypename<Sizing_Dispositions_Mutation_Response>, Record<string, never>, Array<WithTypename<Sizing_Dispositions> | string>>
  },
  sizing_imports?: {
    author_id?: GraphCacheResolver<WithTypename<Sizing_Imports>, Record<string, never>, Scalars['String'] | string>,
    cables?: GraphCacheResolver<WithTypename<Sizing_Imports>, Sizing_ImportsCablesArgs, Array<WithTypename<Cables> | string>>,
    cables_aggregate?: GraphCacheResolver<WithTypename<Sizing_Imports>, Sizing_ImportsCables_AggregateArgs, WithTypename<Cables_Aggregate> | string>,
    casings?: GraphCacheResolver<WithTypename<Sizing_Imports>, Sizing_ImportsCasingsArgs, Array<WithTypename<Casings> | string>>,
    casings_aggregate?: GraphCacheResolver<WithTypename<Sizing_Imports>, Sizing_ImportsCasings_AggregateArgs, WithTypename<Casings_Aggregate> | string>,
    created_at?: GraphCacheResolver<WithTypename<Sizing_Imports>, Record<string, never>, Scalars['timestamp'] | string>,
    customers?: GraphCacheResolver<WithTypename<Sizing_Imports>, Sizing_ImportsCustomersArgs, Array<WithTypename<Customers> | string>>,
    customers_aggregate?: GraphCacheResolver<WithTypename<Sizing_Imports>, Sizing_ImportsCustomers_AggregateArgs, WithTypename<Customers_Aggregate> | string>,
    deviation_surveys?: GraphCacheResolver<WithTypename<Sizing_Imports>, Sizing_ImportsDeviation_SurveysArgs, Array<WithTypename<Deviation_Survey> | string>>,
    deviation_surveys_aggregate?: GraphCacheResolver<WithTypename<Sizing_Imports>, Sizing_ImportsDeviation_Surveys_AggregateArgs, WithTypename<Deviation_Survey_Aggregate> | string>,
    error?: GraphCacheResolver<WithTypename<Sizing_Imports>, Sizing_ImportsErrorArgs, Scalars['jsonb'] | string>,
    housings?: GraphCacheResolver<WithTypename<Sizing_Imports>, Sizing_ImportsHousingsArgs, Array<WithTypename<Housings> | string>>,
    housings_aggregate?: GraphCacheResolver<WithTypename<Sizing_Imports>, Sizing_ImportsHousings_AggregateArgs, WithTypename<Housings_Aggregate> | string>,
    id?: GraphCacheResolver<WithTypename<Sizing_Imports>, Record<string, never>, Scalars['Int'] | string>,
    imported_at?: GraphCacheResolver<WithTypename<Sizing_Imports>, Record<string, never>, Scalars['timestamp'] | string>,
    intakes?: GraphCacheResolver<WithTypename<Sizing_Imports>, Sizing_ImportsIntakesArgs, Array<WithTypename<Intakes> | string>>,
    intakes_aggregate?: GraphCacheResolver<WithTypename<Sizing_Imports>, Sizing_ImportsIntakes_AggregateArgs, WithTypename<Intakes_Aggregate> | string>,
    legacy_author_id?: GraphCacheResolver<WithTypename<Sizing_Imports>, Record<string, never>, Scalars['String'] | string>,
    legacy_sizing_name?: GraphCacheResolver<WithTypename<Sizing_Imports>, Record<string, never>, Scalars['String'] | string>,
    legacy_sizing_reaver_id?: GraphCacheResolver<WithTypename<Sizing_Imports>, Record<string, never>, Scalars['String'] | string>,
    legacy_user?: GraphCacheResolver<WithTypename<Sizing_Imports>, Record<string, never>, WithTypename<Legacy_Users> | string>,
    motor_lead_extensions?: GraphCacheResolver<WithTypename<Sizing_Imports>, Sizing_ImportsMotor_Lead_ExtensionsArgs, Array<WithTypename<Motor_Lead_Extensions> | string>>,
    motor_lead_extensions_aggregate?: GraphCacheResolver<WithTypename<Sizing_Imports>, Sizing_ImportsMotor_Lead_Extensions_AggregateArgs, WithTypename<Motor_Lead_Extensions_Aggregate> | string>,
    motors?: GraphCacheResolver<WithTypename<Sizing_Imports>, Sizing_ImportsMotorsArgs, Array<WithTypename<Motors> | string>>,
    motors_aggregate?: GraphCacheResolver<WithTypename<Sizing_Imports>, Sizing_ImportsMotors_AggregateArgs, WithTypename<Motors_Aggregate> | string>,
    payload?: GraphCacheResolver<WithTypename<Sizing_Imports>, Sizing_ImportsPayloadArgs, Scalars['jsonb'] | string>,
    payload_hash?: GraphCacheResolver<WithTypename<Sizing_Imports>, Record<string, never>, Scalars['String'] | string>,
    pumps?: GraphCacheResolver<WithTypename<Sizing_Imports>, Sizing_ImportsPumpsArgs, Array<WithTypename<Pumps> | string>>,
    pumps_aggregate?: GraphCacheResolver<WithTypename<Sizing_Imports>, Sizing_ImportsPumps_AggregateArgs, WithTypename<Pumps_Aggregate> | string>,
    seals?: GraphCacheResolver<WithTypename<Sizing_Imports>, Sizing_ImportsSealsArgs, Array<WithTypename<Seals> | string>>,
    seals_aggregate?: GraphCacheResolver<WithTypename<Sizing_Imports>, Sizing_ImportsSeals_AggregateArgs, WithTypename<Seals_Aggregate> | string>,
    sensors?: GraphCacheResolver<WithTypename<Sizing_Imports>, Sizing_ImportsSensorsArgs, Array<WithTypename<Sensors> | string>>,
    sensors_aggregate?: GraphCacheResolver<WithTypename<Sizing_Imports>, Sizing_ImportsSensors_AggregateArgs, WithTypename<Sensors_Aggregate> | string>,
    step_down_transformers?: GraphCacheResolver<WithTypename<Sizing_Imports>, Sizing_ImportsStep_Down_TransformersArgs, Array<WithTypename<Step_Down_Transformers> | string>>,
    step_down_transformers_aggregate?: GraphCacheResolver<WithTypename<Sizing_Imports>, Sizing_ImportsStep_Down_Transformers_AggregateArgs, WithTypename<Step_Down_Transformers_Aggregate> | string>,
    step_up_transformers?: GraphCacheResolver<WithTypename<Sizing_Imports>, Sizing_ImportsStep_Up_TransformersArgs, Array<WithTypename<Step_Up_Transformers> | string>>,
    step_up_transformers_aggregate?: GraphCacheResolver<WithTypename<Sizing_Imports>, Sizing_ImportsStep_Up_Transformers_AggregateArgs, WithTypename<Step_Up_Transformers_Aggregate> | string>,
    switchboards?: GraphCacheResolver<WithTypename<Sizing_Imports>, Sizing_ImportsSwitchboardsArgs, Array<WithTypename<Switchboards> | string>>,
    switchboards_aggregate?: GraphCacheResolver<WithTypename<Sizing_Imports>, Sizing_ImportsSwitchboards_AggregateArgs, WithTypename<Switchboards_Aggregate> | string>,
    tubings?: GraphCacheResolver<WithTypename<Sizing_Imports>, Sizing_ImportsTubingsArgs, Array<WithTypename<Tubings> | string>>,
    tubings_aggregate?: GraphCacheResolver<WithTypename<Sizing_Imports>, Sizing_ImportsTubings_AggregateArgs, WithTypename<Tubings_Aggregate> | string>,
    user?: GraphCacheResolver<WithTypename<Sizing_Imports>, Record<string, never>, WithTypename<Users> | string>,
    variable_speed_drives?: GraphCacheResolver<WithTypename<Sizing_Imports>, Sizing_ImportsVariable_Speed_DrivesArgs, Array<WithTypename<Variable_Speed_Drives> | string>>,
    variable_speed_drives_aggregate?: GraphCacheResolver<WithTypename<Sizing_Imports>, Sizing_ImportsVariable_Speed_Drives_AggregateArgs, WithTypename<Variable_Speed_Drives_Aggregate> | string>,
    wells?: GraphCacheResolver<WithTypename<Sizing_Imports>, Sizing_ImportsWellsArgs, Array<WithTypename<Wells> | string>>,
    wells_aggregate?: GraphCacheResolver<WithTypename<Sizing_Imports>, Sizing_ImportsWells_AggregateArgs, WithTypename<Wells_Aggregate> | string>
  },
  sizing_imports_aggregate?: {
    aggregate?: GraphCacheResolver<WithTypename<Sizing_Imports_Aggregate>, Record<string, never>, WithTypename<Sizing_Imports_Aggregate_Fields> | string>,
    nodes?: GraphCacheResolver<WithTypename<Sizing_Imports_Aggregate>, Record<string, never>, Array<WithTypename<Sizing_Imports> | string>>
  },
  sizing_imports_aggregate_fields?: {
    avg?: GraphCacheResolver<WithTypename<Sizing_Imports_Aggregate_Fields>, Record<string, never>, WithTypename<Sizing_Imports_Avg_Fields> | string>,
    count?: GraphCacheResolver<WithTypename<Sizing_Imports_Aggregate_Fields>, Sizing_Imports_Aggregate_FieldsCountArgs, Scalars['Int'] | string>,
    max?: GraphCacheResolver<WithTypename<Sizing_Imports_Aggregate_Fields>, Record<string, never>, WithTypename<Sizing_Imports_Max_Fields> | string>,
    min?: GraphCacheResolver<WithTypename<Sizing_Imports_Aggregate_Fields>, Record<string, never>, WithTypename<Sizing_Imports_Min_Fields> | string>,
    stddev?: GraphCacheResolver<WithTypename<Sizing_Imports_Aggregate_Fields>, Record<string, never>, WithTypename<Sizing_Imports_Stddev_Fields> | string>,
    stddev_pop?: GraphCacheResolver<WithTypename<Sizing_Imports_Aggregate_Fields>, Record<string, never>, WithTypename<Sizing_Imports_Stddev_Pop_Fields> | string>,
    stddev_samp?: GraphCacheResolver<WithTypename<Sizing_Imports_Aggregate_Fields>, Record<string, never>, WithTypename<Sizing_Imports_Stddev_Samp_Fields> | string>,
    sum?: GraphCacheResolver<WithTypename<Sizing_Imports_Aggregate_Fields>, Record<string, never>, WithTypename<Sizing_Imports_Sum_Fields> | string>,
    var_pop?: GraphCacheResolver<WithTypename<Sizing_Imports_Aggregate_Fields>, Record<string, never>, WithTypename<Sizing_Imports_Var_Pop_Fields> | string>,
    var_samp?: GraphCacheResolver<WithTypename<Sizing_Imports_Aggregate_Fields>, Record<string, never>, WithTypename<Sizing_Imports_Var_Samp_Fields> | string>,
    variance?: GraphCacheResolver<WithTypename<Sizing_Imports_Aggregate_Fields>, Record<string, never>, WithTypename<Sizing_Imports_Variance_Fields> | string>
  },
  sizing_imports_avg_fields?: {
    id?: GraphCacheResolver<WithTypename<Sizing_Imports_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  sizing_imports_max_fields?: {
    author_id?: GraphCacheResolver<WithTypename<Sizing_Imports_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Sizing_Imports_Max_Fields>, Record<string, never>, Scalars['timestamp'] | string>,
    id?: GraphCacheResolver<WithTypename<Sizing_Imports_Max_Fields>, Record<string, never>, Scalars['Int'] | string>,
    imported_at?: GraphCacheResolver<WithTypename<Sizing_Imports_Max_Fields>, Record<string, never>, Scalars['timestamp'] | string>,
    legacy_author_id?: GraphCacheResolver<WithTypename<Sizing_Imports_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    legacy_sizing_name?: GraphCacheResolver<WithTypename<Sizing_Imports_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    legacy_sizing_reaver_id?: GraphCacheResolver<WithTypename<Sizing_Imports_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    payload_hash?: GraphCacheResolver<WithTypename<Sizing_Imports_Max_Fields>, Record<string, never>, Scalars['String'] | string>
  },
  sizing_imports_min_fields?: {
    author_id?: GraphCacheResolver<WithTypename<Sizing_Imports_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Sizing_Imports_Min_Fields>, Record<string, never>, Scalars['timestamp'] | string>,
    id?: GraphCacheResolver<WithTypename<Sizing_Imports_Min_Fields>, Record<string, never>, Scalars['Int'] | string>,
    imported_at?: GraphCacheResolver<WithTypename<Sizing_Imports_Min_Fields>, Record<string, never>, Scalars['timestamp'] | string>,
    legacy_author_id?: GraphCacheResolver<WithTypename<Sizing_Imports_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    legacy_sizing_name?: GraphCacheResolver<WithTypename<Sizing_Imports_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    legacy_sizing_reaver_id?: GraphCacheResolver<WithTypename<Sizing_Imports_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    payload_hash?: GraphCacheResolver<WithTypename<Sizing_Imports_Min_Fields>, Record<string, never>, Scalars['String'] | string>
  },
  sizing_imports_mutation_response?: {
    affected_rows?: GraphCacheResolver<WithTypename<Sizing_Imports_Mutation_Response>, Record<string, never>, Scalars['Int'] | string>,
    returning?: GraphCacheResolver<WithTypename<Sizing_Imports_Mutation_Response>, Record<string, never>, Array<WithTypename<Sizing_Imports> | string>>
  },
  sizing_imports_stddev_fields?: {
    id?: GraphCacheResolver<WithTypename<Sizing_Imports_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  sizing_imports_stddev_pop_fields?: {
    id?: GraphCacheResolver<WithTypename<Sizing_Imports_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  sizing_imports_stddev_samp_fields?: {
    id?: GraphCacheResolver<WithTypename<Sizing_Imports_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  sizing_imports_sum_fields?: {
    id?: GraphCacheResolver<WithTypename<Sizing_Imports_Sum_Fields>, Record<string, never>, Scalars['Int'] | string>
  },
  sizing_imports_var_pop_fields?: {
    id?: GraphCacheResolver<WithTypename<Sizing_Imports_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  sizing_imports_var_samp_fields?: {
    id?: GraphCacheResolver<WithTypename<Sizing_Imports_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  sizing_imports_variance_fields?: {
    id?: GraphCacheResolver<WithTypename<Sizing_Imports_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  sizing_pumping_type?: {
    comment?: GraphCacheResolver<WithTypename<Sizing_Pumping_Type>, Record<string, never>, Scalars['String'] | string>,
    value?: GraphCacheResolver<WithTypename<Sizing_Pumping_Type>, Record<string, never>, Scalars['String'] | string>
  },
  sizing_pumping_type_aggregate?: {
    aggregate?: GraphCacheResolver<WithTypename<Sizing_Pumping_Type_Aggregate>, Record<string, never>, WithTypename<Sizing_Pumping_Type_Aggregate_Fields> | string>,
    nodes?: GraphCacheResolver<WithTypename<Sizing_Pumping_Type_Aggregate>, Record<string, never>, Array<WithTypename<Sizing_Pumping_Type> | string>>
  },
  sizing_pumping_type_aggregate_fields?: {
    count?: GraphCacheResolver<WithTypename<Sizing_Pumping_Type_Aggregate_Fields>, Sizing_Pumping_Type_Aggregate_FieldsCountArgs, Scalars['Int'] | string>,
    max?: GraphCacheResolver<WithTypename<Sizing_Pumping_Type_Aggregate_Fields>, Record<string, never>, WithTypename<Sizing_Pumping_Type_Max_Fields> | string>,
    min?: GraphCacheResolver<WithTypename<Sizing_Pumping_Type_Aggregate_Fields>, Record<string, never>, WithTypename<Sizing_Pumping_Type_Min_Fields> | string>
  },
  sizing_pumping_type_max_fields?: {
    comment?: GraphCacheResolver<WithTypename<Sizing_Pumping_Type_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    value?: GraphCacheResolver<WithTypename<Sizing_Pumping_Type_Max_Fields>, Record<string, never>, Scalars['String'] | string>
  },
  sizing_pumping_type_min_fields?: {
    comment?: GraphCacheResolver<WithTypename<Sizing_Pumping_Type_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    value?: GraphCacheResolver<WithTypename<Sizing_Pumping_Type_Min_Fields>, Record<string, never>, Scalars['String'] | string>
  },
  sizing_pumping_type_mutation_response?: {
    affected_rows?: GraphCacheResolver<WithTypename<Sizing_Pumping_Type_Mutation_Response>, Record<string, never>, Scalars['Int'] | string>,
    returning?: GraphCacheResolver<WithTypename<Sizing_Pumping_Type_Mutation_Response>, Record<string, never>, Array<WithTypename<Sizing_Pumping_Type> | string>>
  },
  sizings?: {
    author?: GraphCacheResolver<WithTypename<Sizings>, Record<string, never>, WithTypename<Users> | string>,
    customer?: GraphCacheResolver<WithTypename<Sizings>, Record<string, never>, WithTypename<Customers> | string>,
    customer_id?: GraphCacheResolver<WithTypename<Sizings>, Record<string, never>, Scalars['Int'] | string>,
    default_display_units?: GraphCacheResolver<WithTypename<Sizings>, Record<string, never>, Scalars['String'] | string>,
    disposition?: GraphCacheResolver<WithTypename<Sizings>, Record<string, never>, Scalars['String'] | string>,
    hps_location?: GraphCacheResolver<WithTypename<Sizings>, Record<string, never>, Scalars['String'] | string>,
    id?: GraphCacheResolver<WithTypename<Sizings>, Record<string, never>, Scalars['uuid'] | string>,
    imported_from_sizing?: GraphCacheResolver<WithTypename<Sizings>, Record<string, never>, WithTypename<Sizing_Imports> | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Sizings>, Record<string, never>, Scalars['Int'] | string>,
    installed_scenario_id?: GraphCacheResolver<WithTypename<Sizings>, Record<string, never>, Scalars['uuid'] | string>,
    is_shared?: GraphCacheResolver<WithTypename<Sizings>, Record<string, never>, Scalars['Boolean'] | string>,
    journal_author_id?: GraphCacheResolver<WithTypename<Sizings>, Record<string, never>, Scalars['String'] | string>,
    journal_created_at?: GraphCacheResolver<WithTypename<Sizings>, Record<string, never>, Scalars['timestamptz'] | string>,
    journal_deleted_at?: GraphCacheResolver<WithTypename<Sizings>, Record<string, never>, Scalars['timestamptz'] | string>,
    journal_updated_at?: GraphCacheResolver<WithTypename<Sizings>, Record<string, never>, Scalars['timestamptz'] | string>,
    notes?: GraphCacheResolver<WithTypename<Sizings>, Record<string, never>, Scalars['String'] | string>,
    parent_id?: GraphCacheResolver<WithTypename<Sizings>, Record<string, never>, Scalars['uuid'] | string>,
    parent_sizing?: GraphCacheResolver<WithTypename<Sizings>, Record<string, never>, WithTypename<Sizings> | string>,
    pumping_type?: GraphCacheResolver<WithTypename<Sizings>, Record<string, never>, Scalars['String'] | string>,
    scenario_order?: GraphCacheResolver<WithTypename<Sizings>, Record<string, never>, Array<Scalars['uuid'] | string>>,
    scenarios?: GraphCacheResolver<WithTypename<Sizings>, SizingsScenariosArgs, Array<WithTypename<Scenarios> | string>>,
    scenarios_aggregate?: GraphCacheResolver<WithTypename<Sizings>, SizingsScenarios_AggregateArgs, WithTypename<Scenarios_Aggregate> | string>,
    share_with_customer?: GraphCacheResolver<WithTypename<Sizings>, Record<string, never>, Scalars['Boolean'] | string>,
    title?: GraphCacheResolver<WithTypename<Sizings>, Record<string, never>, Scalars['String'] | string>,
    well?: GraphCacheResolver<WithTypename<Sizings>, Record<string, never>, WithTypename<Wells> | string>,
    well_id?: GraphCacheResolver<WithTypename<Sizings>, Record<string, never>, Scalars['Int'] | string>,
    winning_revision_author_id?: GraphCacheResolver<WithTypename<Sizings>, Record<string, never>, Scalars['String'] | string>,
    winning_revision_created_at?: GraphCacheResolver<WithTypename<Sizings>, Record<string, never>, Scalars['timestamptz'] | string>,
    winning_revision_deleted_at?: GraphCacheResolver<WithTypename<Sizings>, Record<string, never>, Scalars['timestamptz'] | string>,
    winning_revision_id?: GraphCacheResolver<WithTypename<Sizings>, Record<string, never>, Scalars['uuid'] | string>,
    winning_revision_parent_id?: GraphCacheResolver<WithTypename<Sizings>, Record<string, never>, Scalars['uuid'] | string>,
    winning_revision_updated_at?: GraphCacheResolver<WithTypename<Sizings>, Record<string, never>, Scalars['timestamptz'] | string>
  },
  sizings_aggregate?: {
    aggregate?: GraphCacheResolver<WithTypename<Sizings_Aggregate>, Record<string, never>, WithTypename<Sizings_Aggregate_Fields> | string>,
    nodes?: GraphCacheResolver<WithTypename<Sizings_Aggregate>, Record<string, never>, Array<WithTypename<Sizings> | string>>
  },
  sizings_aggregate_fields?: {
    avg?: GraphCacheResolver<WithTypename<Sizings_Aggregate_Fields>, Record<string, never>, WithTypename<Sizings_Avg_Fields> | string>,
    count?: GraphCacheResolver<WithTypename<Sizings_Aggregate_Fields>, Sizings_Aggregate_FieldsCountArgs, Scalars['Int'] | string>,
    max?: GraphCacheResolver<WithTypename<Sizings_Aggregate_Fields>, Record<string, never>, WithTypename<Sizings_Max_Fields> | string>,
    min?: GraphCacheResolver<WithTypename<Sizings_Aggregate_Fields>, Record<string, never>, WithTypename<Sizings_Min_Fields> | string>,
    stddev?: GraphCacheResolver<WithTypename<Sizings_Aggregate_Fields>, Record<string, never>, WithTypename<Sizings_Stddev_Fields> | string>,
    stddev_pop?: GraphCacheResolver<WithTypename<Sizings_Aggregate_Fields>, Record<string, never>, WithTypename<Sizings_Stddev_Pop_Fields> | string>,
    stddev_samp?: GraphCacheResolver<WithTypename<Sizings_Aggregate_Fields>, Record<string, never>, WithTypename<Sizings_Stddev_Samp_Fields> | string>,
    sum?: GraphCacheResolver<WithTypename<Sizings_Aggregate_Fields>, Record<string, never>, WithTypename<Sizings_Sum_Fields> | string>,
    var_pop?: GraphCacheResolver<WithTypename<Sizings_Aggregate_Fields>, Record<string, never>, WithTypename<Sizings_Var_Pop_Fields> | string>,
    var_samp?: GraphCacheResolver<WithTypename<Sizings_Aggregate_Fields>, Record<string, never>, WithTypename<Sizings_Var_Samp_Fields> | string>,
    variance?: GraphCacheResolver<WithTypename<Sizings_Aggregate_Fields>, Record<string, never>, WithTypename<Sizings_Variance_Fields> | string>
  },
  sizings_avg_fields?: {
    customer_id?: GraphCacheResolver<WithTypename<Sizings_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Sizings_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    well_id?: GraphCacheResolver<WithTypename<Sizings_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  sizings_max_fields?: {
    customer_id?: GraphCacheResolver<WithTypename<Sizings_Max_Fields>, Record<string, never>, Scalars['Int'] | string>,
    default_display_units?: GraphCacheResolver<WithTypename<Sizings_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    disposition?: GraphCacheResolver<WithTypename<Sizings_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    hps_location?: GraphCacheResolver<WithTypename<Sizings_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    id?: GraphCacheResolver<WithTypename<Sizings_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Sizings_Max_Fields>, Record<string, never>, Scalars['Int'] | string>,
    installed_scenario_id?: GraphCacheResolver<WithTypename<Sizings_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    journal_author_id?: GraphCacheResolver<WithTypename<Sizings_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    journal_created_at?: GraphCacheResolver<WithTypename<Sizings_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    journal_deleted_at?: GraphCacheResolver<WithTypename<Sizings_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    journal_updated_at?: GraphCacheResolver<WithTypename<Sizings_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    notes?: GraphCacheResolver<WithTypename<Sizings_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    parent_id?: GraphCacheResolver<WithTypename<Sizings_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    pumping_type?: GraphCacheResolver<WithTypename<Sizings_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    scenario_order?: GraphCacheResolver<WithTypename<Sizings_Max_Fields>, Record<string, never>, Array<Scalars['uuid'] | string>>,
    title?: GraphCacheResolver<WithTypename<Sizings_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    well_id?: GraphCacheResolver<WithTypename<Sizings_Max_Fields>, Record<string, never>, Scalars['Int'] | string>,
    winning_revision_author_id?: GraphCacheResolver<WithTypename<Sizings_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    winning_revision_created_at?: GraphCacheResolver<WithTypename<Sizings_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    winning_revision_deleted_at?: GraphCacheResolver<WithTypename<Sizings_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    winning_revision_id?: GraphCacheResolver<WithTypename<Sizings_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    winning_revision_parent_id?: GraphCacheResolver<WithTypename<Sizings_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    winning_revision_updated_at?: GraphCacheResolver<WithTypename<Sizings_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>
  },
  sizings_min_fields?: {
    customer_id?: GraphCacheResolver<WithTypename<Sizings_Min_Fields>, Record<string, never>, Scalars['Int'] | string>,
    default_display_units?: GraphCacheResolver<WithTypename<Sizings_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    disposition?: GraphCacheResolver<WithTypename<Sizings_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    hps_location?: GraphCacheResolver<WithTypename<Sizings_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    id?: GraphCacheResolver<WithTypename<Sizings_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Sizings_Min_Fields>, Record<string, never>, Scalars['Int'] | string>,
    installed_scenario_id?: GraphCacheResolver<WithTypename<Sizings_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    journal_author_id?: GraphCacheResolver<WithTypename<Sizings_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    journal_created_at?: GraphCacheResolver<WithTypename<Sizings_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    journal_deleted_at?: GraphCacheResolver<WithTypename<Sizings_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    journal_updated_at?: GraphCacheResolver<WithTypename<Sizings_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    notes?: GraphCacheResolver<WithTypename<Sizings_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    parent_id?: GraphCacheResolver<WithTypename<Sizings_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    pumping_type?: GraphCacheResolver<WithTypename<Sizings_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    scenario_order?: GraphCacheResolver<WithTypename<Sizings_Min_Fields>, Record<string, never>, Array<Scalars['uuid'] | string>>,
    title?: GraphCacheResolver<WithTypename<Sizings_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    well_id?: GraphCacheResolver<WithTypename<Sizings_Min_Fields>, Record<string, never>, Scalars['Int'] | string>,
    winning_revision_author_id?: GraphCacheResolver<WithTypename<Sizings_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    winning_revision_created_at?: GraphCacheResolver<WithTypename<Sizings_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    winning_revision_deleted_at?: GraphCacheResolver<WithTypename<Sizings_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    winning_revision_id?: GraphCacheResolver<WithTypename<Sizings_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    winning_revision_parent_id?: GraphCacheResolver<WithTypename<Sizings_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    winning_revision_updated_at?: GraphCacheResolver<WithTypename<Sizings_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>
  },
  sizings_stddev_fields?: {
    customer_id?: GraphCacheResolver<WithTypename<Sizings_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Sizings_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    well_id?: GraphCacheResolver<WithTypename<Sizings_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  sizings_stddev_pop_fields?: {
    customer_id?: GraphCacheResolver<WithTypename<Sizings_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Sizings_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    well_id?: GraphCacheResolver<WithTypename<Sizings_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  sizings_stddev_samp_fields?: {
    customer_id?: GraphCacheResolver<WithTypename<Sizings_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Sizings_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    well_id?: GraphCacheResolver<WithTypename<Sizings_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  sizings_sum_fields?: {
    customer_id?: GraphCacheResolver<WithTypename<Sizings_Sum_Fields>, Record<string, never>, Scalars['Int'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Sizings_Sum_Fields>, Record<string, never>, Scalars['Int'] | string>,
    well_id?: GraphCacheResolver<WithTypename<Sizings_Sum_Fields>, Record<string, never>, Scalars['Int'] | string>
  },
  sizings_var_pop_fields?: {
    customer_id?: GraphCacheResolver<WithTypename<Sizings_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Sizings_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    well_id?: GraphCacheResolver<WithTypename<Sizings_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  sizings_var_samp_fields?: {
    customer_id?: GraphCacheResolver<WithTypename<Sizings_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Sizings_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    well_id?: GraphCacheResolver<WithTypename<Sizings_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  sizings_variance_fields?: {
    customer_id?: GraphCacheResolver<WithTypename<Sizings_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Sizings_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    well_id?: GraphCacheResolver<WithTypename<Sizings_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  solution_gas_oil_ratio_options?: {
    comment?: GraphCacheResolver<WithTypename<Solution_Gas_Oil_Ratio_Options>, Record<string, never>, Scalars['String'] | string>,
    value?: GraphCacheResolver<WithTypename<Solution_Gas_Oil_Ratio_Options>, Record<string, never>, Scalars['String'] | string>
  },
  solution_gas_oil_ratio_options_aggregate?: {
    aggregate?: GraphCacheResolver<WithTypename<Solution_Gas_Oil_Ratio_Options_Aggregate>, Record<string, never>, WithTypename<Solution_Gas_Oil_Ratio_Options_Aggregate_Fields> | string>,
    nodes?: GraphCacheResolver<WithTypename<Solution_Gas_Oil_Ratio_Options_Aggregate>, Record<string, never>, Array<WithTypename<Solution_Gas_Oil_Ratio_Options> | string>>
  },
  solution_gas_oil_ratio_options_aggregate_fields?: {
    count?: GraphCacheResolver<WithTypename<Solution_Gas_Oil_Ratio_Options_Aggregate_Fields>, Solution_Gas_Oil_Ratio_Options_Aggregate_FieldsCountArgs, Scalars['Int'] | string>,
    max?: GraphCacheResolver<WithTypename<Solution_Gas_Oil_Ratio_Options_Aggregate_Fields>, Record<string, never>, WithTypename<Solution_Gas_Oil_Ratio_Options_Max_Fields> | string>,
    min?: GraphCacheResolver<WithTypename<Solution_Gas_Oil_Ratio_Options_Aggregate_Fields>, Record<string, never>, WithTypename<Solution_Gas_Oil_Ratio_Options_Min_Fields> | string>
  },
  solution_gas_oil_ratio_options_max_fields?: {
    comment?: GraphCacheResolver<WithTypename<Solution_Gas_Oil_Ratio_Options_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    value?: GraphCacheResolver<WithTypename<Solution_Gas_Oil_Ratio_Options_Max_Fields>, Record<string, never>, Scalars['String'] | string>
  },
  solution_gas_oil_ratio_options_min_fields?: {
    comment?: GraphCacheResolver<WithTypename<Solution_Gas_Oil_Ratio_Options_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    value?: GraphCacheResolver<WithTypename<Solution_Gas_Oil_Ratio_Options_Min_Fields>, Record<string, never>, Scalars['String'] | string>
  },
  solution_gas_oil_ratio_options_mutation_response?: {
    affected_rows?: GraphCacheResolver<WithTypename<Solution_Gas_Oil_Ratio_Options_Mutation_Response>, Record<string, never>, Scalars['Int'] | string>,
    returning?: GraphCacheResolver<WithTypename<Solution_Gas_Oil_Ratio_Options_Mutation_Response>, Record<string, never>, Array<WithTypename<Solution_Gas_Oil_Ratio_Options> | string>>
  },
  status?: {
    status?: GraphCacheResolver<WithTypename<Status>, Record<string, never>, Scalars['String'] | string>
  },
  status_aggregate?: {
    aggregate?: GraphCacheResolver<WithTypename<Status_Aggregate>, Record<string, never>, WithTypename<Status_Aggregate_Fields> | string>,
    nodes?: GraphCacheResolver<WithTypename<Status_Aggregate>, Record<string, never>, Array<WithTypename<Status> | string>>
  },
  status_aggregate_fields?: {
    count?: GraphCacheResolver<WithTypename<Status_Aggregate_Fields>, Status_Aggregate_FieldsCountArgs, Scalars['Int'] | string>,
    max?: GraphCacheResolver<WithTypename<Status_Aggregate_Fields>, Record<string, never>, WithTypename<Status_Max_Fields> | string>,
    min?: GraphCacheResolver<WithTypename<Status_Aggregate_Fields>, Record<string, never>, WithTypename<Status_Min_Fields> | string>
  },
  status_max_fields?: {
    status?: GraphCacheResolver<WithTypename<Status_Max_Fields>, Record<string, never>, Scalars['String'] | string>
  },
  status_min_fields?: {
    status?: GraphCacheResolver<WithTypename<Status_Min_Fields>, Record<string, never>, Scalars['String'] | string>
  },
  step_down_transformers?: {
    author_id?: GraphCacheResolver<WithTypename<Step_Down_Transformers>, Record<string, never>, Scalars['String'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Step_Down_Transformers>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Step_Down_Transformers>, Record<string, never>, Scalars['timestamptz'] | string>,
    enclosure?: GraphCacheResolver<WithTypename<Step_Down_Transformers>, Record<string, never>, Scalars['String'] | string>,
    id?: GraphCacheResolver<WithTypename<Step_Down_Transformers>, Record<string, never>, Scalars['uuid'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Step_Down_Transformers>, Record<string, never>, Scalars['Int'] | string>,
    include_ecopetrol_timestamp?: GraphCacheResolver<WithTypename<Step_Down_Transformers>, Record<string, never>, Scalars['timestamptz'] | string>,
    include_koc_timestamp?: GraphCacheResolver<WithTypename<Step_Down_Transformers>, Record<string, never>, Scalars['timestamptz'] | string>,
    kva?: GraphCacheResolver<WithTypename<Step_Down_Transformers>, Record<string, never>, Scalars['Int'] | string>,
    manufacturer?: GraphCacheResolver<WithTypename<Step_Down_Transformers>, Record<string, never>, Scalars['String'] | string>,
    max_secondary_voltage?: GraphCacheResolver<WithTypename<Step_Down_Transformers>, Record<string, never>, Scalars['Int'] | string>,
    min_secondary_voltage?: GraphCacheResolver<WithTypename<Step_Down_Transformers>, Record<string, never>, Scalars['Int'] | string>,
    only_ecopetrol_timestamp?: GraphCacheResolver<WithTypename<Step_Down_Transformers>, Record<string, never>, Scalars['timestamptz'] | string>,
    only_koc_timestamp?: GraphCacheResolver<WithTypename<Step_Down_Transformers>, Record<string, never>, Scalars['timestamptz'] | string>,
    part_number?: GraphCacheResolver<WithTypename<Step_Down_Transformers>, Record<string, never>, Scalars['String'] | string>,
    primary_voltage_delta?: GraphCacheResolver<WithTypename<Step_Down_Transformers>, Record<string, never>, Scalars['Int'] | string>,
    primary_voltage_wye?: GraphCacheResolver<WithTypename<Step_Down_Transformers>, Record<string, never>, Scalars['Int'] | string>,
    prioritized_manufacturer?: GraphCacheResolver<WithTypename<Step_Down_Transformers>, Record<string, never>, Scalars['String'] | string>,
    sizing_import?: GraphCacheResolver<WithTypename<Step_Down_Transformers>, Record<string, never>, WithTypename<Sizing_Imports> | string>,
    transformer_type?: GraphCacheResolver<WithTypename<Step_Down_Transformers>, Record<string, never>, Scalars['String'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Step_Down_Transformers>, Record<string, never>, Scalars['timestamptz'] | string>,
    user?: GraphCacheResolver<WithTypename<Step_Down_Transformers>, Record<string, never>, WithTypename<Users> | string>,
    weight_pounds?: GraphCacheResolver<WithTypename<Step_Down_Transformers>, Record<string, never>, Scalars['Int'] | string>
  },
  step_down_transformers_aggregate?: {
    aggregate?: GraphCacheResolver<WithTypename<Step_Down_Transformers_Aggregate>, Record<string, never>, WithTypename<Step_Down_Transformers_Aggregate_Fields> | string>,
    nodes?: GraphCacheResolver<WithTypename<Step_Down_Transformers_Aggregate>, Record<string, never>, Array<WithTypename<Step_Down_Transformers> | string>>
  },
  step_down_transformers_aggregate_fields?: {
    avg?: GraphCacheResolver<WithTypename<Step_Down_Transformers_Aggregate_Fields>, Record<string, never>, WithTypename<Step_Down_Transformers_Avg_Fields> | string>,
    count?: GraphCacheResolver<WithTypename<Step_Down_Transformers_Aggregate_Fields>, Step_Down_Transformers_Aggregate_FieldsCountArgs, Scalars['Int'] | string>,
    max?: GraphCacheResolver<WithTypename<Step_Down_Transformers_Aggregate_Fields>, Record<string, never>, WithTypename<Step_Down_Transformers_Max_Fields> | string>,
    min?: GraphCacheResolver<WithTypename<Step_Down_Transformers_Aggregate_Fields>, Record<string, never>, WithTypename<Step_Down_Transformers_Min_Fields> | string>,
    stddev?: GraphCacheResolver<WithTypename<Step_Down_Transformers_Aggregate_Fields>, Record<string, never>, WithTypename<Step_Down_Transformers_Stddev_Fields> | string>,
    stddev_pop?: GraphCacheResolver<WithTypename<Step_Down_Transformers_Aggregate_Fields>, Record<string, never>, WithTypename<Step_Down_Transformers_Stddev_Pop_Fields> | string>,
    stddev_samp?: GraphCacheResolver<WithTypename<Step_Down_Transformers_Aggregate_Fields>, Record<string, never>, WithTypename<Step_Down_Transformers_Stddev_Samp_Fields> | string>,
    sum?: GraphCacheResolver<WithTypename<Step_Down_Transformers_Aggregate_Fields>, Record<string, never>, WithTypename<Step_Down_Transformers_Sum_Fields> | string>,
    var_pop?: GraphCacheResolver<WithTypename<Step_Down_Transformers_Aggregate_Fields>, Record<string, never>, WithTypename<Step_Down_Transformers_Var_Pop_Fields> | string>,
    var_samp?: GraphCacheResolver<WithTypename<Step_Down_Transformers_Aggregate_Fields>, Record<string, never>, WithTypename<Step_Down_Transformers_Var_Samp_Fields> | string>,
    variance?: GraphCacheResolver<WithTypename<Step_Down_Transformers_Aggregate_Fields>, Record<string, never>, WithTypename<Step_Down_Transformers_Variance_Fields> | string>
  },
  step_down_transformers_avg_fields?: {
    imported_sizing_id?: GraphCacheResolver<WithTypename<Step_Down_Transformers_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    kva?: GraphCacheResolver<WithTypename<Step_Down_Transformers_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    max_secondary_voltage?: GraphCacheResolver<WithTypename<Step_Down_Transformers_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    min_secondary_voltage?: GraphCacheResolver<WithTypename<Step_Down_Transformers_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    primary_voltage_delta?: GraphCacheResolver<WithTypename<Step_Down_Transformers_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    primary_voltage_wye?: GraphCacheResolver<WithTypename<Step_Down_Transformers_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    weight_pounds?: GraphCacheResolver<WithTypename<Step_Down_Transformers_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  step_down_transformers_max_fields?: {
    author_id?: GraphCacheResolver<WithTypename<Step_Down_Transformers_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Step_Down_Transformers_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Step_Down_Transformers_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    enclosure?: GraphCacheResolver<WithTypename<Step_Down_Transformers_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    id?: GraphCacheResolver<WithTypename<Step_Down_Transformers_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Step_Down_Transformers_Max_Fields>, Record<string, never>, Scalars['Int'] | string>,
    include_ecopetrol_timestamp?: GraphCacheResolver<WithTypename<Step_Down_Transformers_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    include_koc_timestamp?: GraphCacheResolver<WithTypename<Step_Down_Transformers_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    kva?: GraphCacheResolver<WithTypename<Step_Down_Transformers_Max_Fields>, Record<string, never>, Scalars['Int'] | string>,
    manufacturer?: GraphCacheResolver<WithTypename<Step_Down_Transformers_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    max_secondary_voltage?: GraphCacheResolver<WithTypename<Step_Down_Transformers_Max_Fields>, Record<string, never>, Scalars['Int'] | string>,
    min_secondary_voltage?: GraphCacheResolver<WithTypename<Step_Down_Transformers_Max_Fields>, Record<string, never>, Scalars['Int'] | string>,
    only_ecopetrol_timestamp?: GraphCacheResolver<WithTypename<Step_Down_Transformers_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    only_koc_timestamp?: GraphCacheResolver<WithTypename<Step_Down_Transformers_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    part_number?: GraphCacheResolver<WithTypename<Step_Down_Transformers_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    primary_voltage_delta?: GraphCacheResolver<WithTypename<Step_Down_Transformers_Max_Fields>, Record<string, never>, Scalars['Int'] | string>,
    primary_voltage_wye?: GraphCacheResolver<WithTypename<Step_Down_Transformers_Max_Fields>, Record<string, never>, Scalars['Int'] | string>,
    prioritized_manufacturer?: GraphCacheResolver<WithTypename<Step_Down_Transformers_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    transformer_type?: GraphCacheResolver<WithTypename<Step_Down_Transformers_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Step_Down_Transformers_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    weight_pounds?: GraphCacheResolver<WithTypename<Step_Down_Transformers_Max_Fields>, Record<string, never>, Scalars['Int'] | string>
  },
  step_down_transformers_min_fields?: {
    author_id?: GraphCacheResolver<WithTypename<Step_Down_Transformers_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Step_Down_Transformers_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Step_Down_Transformers_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    enclosure?: GraphCacheResolver<WithTypename<Step_Down_Transformers_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    id?: GraphCacheResolver<WithTypename<Step_Down_Transformers_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Step_Down_Transformers_Min_Fields>, Record<string, never>, Scalars['Int'] | string>,
    include_ecopetrol_timestamp?: GraphCacheResolver<WithTypename<Step_Down_Transformers_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    include_koc_timestamp?: GraphCacheResolver<WithTypename<Step_Down_Transformers_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    kva?: GraphCacheResolver<WithTypename<Step_Down_Transformers_Min_Fields>, Record<string, never>, Scalars['Int'] | string>,
    manufacturer?: GraphCacheResolver<WithTypename<Step_Down_Transformers_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    max_secondary_voltage?: GraphCacheResolver<WithTypename<Step_Down_Transformers_Min_Fields>, Record<string, never>, Scalars['Int'] | string>,
    min_secondary_voltage?: GraphCacheResolver<WithTypename<Step_Down_Transformers_Min_Fields>, Record<string, never>, Scalars['Int'] | string>,
    only_ecopetrol_timestamp?: GraphCacheResolver<WithTypename<Step_Down_Transformers_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    only_koc_timestamp?: GraphCacheResolver<WithTypename<Step_Down_Transformers_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    part_number?: GraphCacheResolver<WithTypename<Step_Down_Transformers_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    primary_voltage_delta?: GraphCacheResolver<WithTypename<Step_Down_Transformers_Min_Fields>, Record<string, never>, Scalars['Int'] | string>,
    primary_voltage_wye?: GraphCacheResolver<WithTypename<Step_Down_Transformers_Min_Fields>, Record<string, never>, Scalars['Int'] | string>,
    prioritized_manufacturer?: GraphCacheResolver<WithTypename<Step_Down_Transformers_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    transformer_type?: GraphCacheResolver<WithTypename<Step_Down_Transformers_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Step_Down_Transformers_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    weight_pounds?: GraphCacheResolver<WithTypename<Step_Down_Transformers_Min_Fields>, Record<string, never>, Scalars['Int'] | string>
  },
  step_down_transformers_mutation_response?: {
    affected_rows?: GraphCacheResolver<WithTypename<Step_Down_Transformers_Mutation_Response>, Record<string, never>, Scalars['Int'] | string>,
    returning?: GraphCacheResolver<WithTypename<Step_Down_Transformers_Mutation_Response>, Record<string, never>, Array<WithTypename<Step_Down_Transformers> | string>>
  },
  step_down_transformers_stddev_fields?: {
    imported_sizing_id?: GraphCacheResolver<WithTypename<Step_Down_Transformers_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    kva?: GraphCacheResolver<WithTypename<Step_Down_Transformers_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    max_secondary_voltage?: GraphCacheResolver<WithTypename<Step_Down_Transformers_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    min_secondary_voltage?: GraphCacheResolver<WithTypename<Step_Down_Transformers_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    primary_voltage_delta?: GraphCacheResolver<WithTypename<Step_Down_Transformers_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    primary_voltage_wye?: GraphCacheResolver<WithTypename<Step_Down_Transformers_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    weight_pounds?: GraphCacheResolver<WithTypename<Step_Down_Transformers_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  step_down_transformers_stddev_pop_fields?: {
    imported_sizing_id?: GraphCacheResolver<WithTypename<Step_Down_Transformers_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    kva?: GraphCacheResolver<WithTypename<Step_Down_Transformers_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    max_secondary_voltage?: GraphCacheResolver<WithTypename<Step_Down_Transformers_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    min_secondary_voltage?: GraphCacheResolver<WithTypename<Step_Down_Transformers_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    primary_voltage_delta?: GraphCacheResolver<WithTypename<Step_Down_Transformers_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    primary_voltage_wye?: GraphCacheResolver<WithTypename<Step_Down_Transformers_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    weight_pounds?: GraphCacheResolver<WithTypename<Step_Down_Transformers_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  step_down_transformers_stddev_samp_fields?: {
    imported_sizing_id?: GraphCacheResolver<WithTypename<Step_Down_Transformers_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    kva?: GraphCacheResolver<WithTypename<Step_Down_Transformers_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    max_secondary_voltage?: GraphCacheResolver<WithTypename<Step_Down_Transformers_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    min_secondary_voltage?: GraphCacheResolver<WithTypename<Step_Down_Transformers_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    primary_voltage_delta?: GraphCacheResolver<WithTypename<Step_Down_Transformers_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    primary_voltage_wye?: GraphCacheResolver<WithTypename<Step_Down_Transformers_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    weight_pounds?: GraphCacheResolver<WithTypename<Step_Down_Transformers_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  step_down_transformers_sum_fields?: {
    imported_sizing_id?: GraphCacheResolver<WithTypename<Step_Down_Transformers_Sum_Fields>, Record<string, never>, Scalars['Int'] | string>,
    kva?: GraphCacheResolver<WithTypename<Step_Down_Transformers_Sum_Fields>, Record<string, never>, Scalars['Int'] | string>,
    max_secondary_voltage?: GraphCacheResolver<WithTypename<Step_Down_Transformers_Sum_Fields>, Record<string, never>, Scalars['Int'] | string>,
    min_secondary_voltage?: GraphCacheResolver<WithTypename<Step_Down_Transformers_Sum_Fields>, Record<string, never>, Scalars['Int'] | string>,
    primary_voltage_delta?: GraphCacheResolver<WithTypename<Step_Down_Transformers_Sum_Fields>, Record<string, never>, Scalars['Int'] | string>,
    primary_voltage_wye?: GraphCacheResolver<WithTypename<Step_Down_Transformers_Sum_Fields>, Record<string, never>, Scalars['Int'] | string>,
    weight_pounds?: GraphCacheResolver<WithTypename<Step_Down_Transformers_Sum_Fields>, Record<string, never>, Scalars['Int'] | string>
  },
  step_down_transformers_var_pop_fields?: {
    imported_sizing_id?: GraphCacheResolver<WithTypename<Step_Down_Transformers_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    kva?: GraphCacheResolver<WithTypename<Step_Down_Transformers_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    max_secondary_voltage?: GraphCacheResolver<WithTypename<Step_Down_Transformers_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    min_secondary_voltage?: GraphCacheResolver<WithTypename<Step_Down_Transformers_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    primary_voltage_delta?: GraphCacheResolver<WithTypename<Step_Down_Transformers_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    primary_voltage_wye?: GraphCacheResolver<WithTypename<Step_Down_Transformers_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    weight_pounds?: GraphCacheResolver<WithTypename<Step_Down_Transformers_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  step_down_transformers_var_samp_fields?: {
    imported_sizing_id?: GraphCacheResolver<WithTypename<Step_Down_Transformers_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    kva?: GraphCacheResolver<WithTypename<Step_Down_Transformers_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    max_secondary_voltage?: GraphCacheResolver<WithTypename<Step_Down_Transformers_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    min_secondary_voltage?: GraphCacheResolver<WithTypename<Step_Down_Transformers_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    primary_voltage_delta?: GraphCacheResolver<WithTypename<Step_Down_Transformers_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    primary_voltage_wye?: GraphCacheResolver<WithTypename<Step_Down_Transformers_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    weight_pounds?: GraphCacheResolver<WithTypename<Step_Down_Transformers_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  step_down_transformers_variance_fields?: {
    imported_sizing_id?: GraphCacheResolver<WithTypename<Step_Down_Transformers_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    kva?: GraphCacheResolver<WithTypename<Step_Down_Transformers_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    max_secondary_voltage?: GraphCacheResolver<WithTypename<Step_Down_Transformers_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    min_secondary_voltage?: GraphCacheResolver<WithTypename<Step_Down_Transformers_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    primary_voltage_delta?: GraphCacheResolver<WithTypename<Step_Down_Transformers_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    primary_voltage_wye?: GraphCacheResolver<WithTypename<Step_Down_Transformers_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    weight_pounds?: GraphCacheResolver<WithTypename<Step_Down_Transformers_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  step_up_transformers?: {
    author_id?: GraphCacheResolver<WithTypename<Step_Up_Transformers>, Record<string, never>, Scalars['String'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Step_Up_Transformers>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Step_Up_Transformers>, Record<string, never>, Scalars['timestamptz'] | string>,
    enclosure?: GraphCacheResolver<WithTypename<Step_Up_Transformers>, Record<string, never>, Scalars['String'] | string>,
    id?: GraphCacheResolver<WithTypename<Step_Up_Transformers>, Record<string, never>, Scalars['uuid'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Step_Up_Transformers>, Record<string, never>, Scalars['Int'] | string>,
    include_ecopetrol_timestamp?: GraphCacheResolver<WithTypename<Step_Up_Transformers>, Record<string, never>, Scalars['timestamptz'] | string>,
    include_koc_timestamp?: GraphCacheResolver<WithTypename<Step_Up_Transformers>, Record<string, never>, Scalars['timestamptz'] | string>,
    kva?: GraphCacheResolver<WithTypename<Step_Up_Transformers>, Record<string, never>, Scalars['Int'] | string>,
    manufacturer?: GraphCacheResolver<WithTypename<Step_Up_Transformers>, Record<string, never>, Scalars['String'] | string>,
    max_secondary_voltage?: GraphCacheResolver<WithTypename<Step_Up_Transformers>, Record<string, never>, Scalars['Int'] | string>,
    min_secondary_voltage?: GraphCacheResolver<WithTypename<Step_Up_Transformers>, Record<string, never>, Scalars['Int'] | string>,
    only_ecopetrol_timestamp?: GraphCacheResolver<WithTypename<Step_Up_Transformers>, Record<string, never>, Scalars['timestamptz'] | string>,
    only_koc_timestamp?: GraphCacheResolver<WithTypename<Step_Up_Transformers>, Record<string, never>, Scalars['timestamptz'] | string>,
    part_number?: GraphCacheResolver<WithTypename<Step_Up_Transformers>, Record<string, never>, Scalars['String'] | string>,
    primary_voltage?: GraphCacheResolver<WithTypename<Step_Up_Transformers>, Record<string, never>, Scalars['Int'] | string>,
    prioritized_manufacturer?: GraphCacheResolver<WithTypename<Step_Up_Transformers>, Record<string, never>, Scalars['String'] | string>,
    sizing_import?: GraphCacheResolver<WithTypename<Step_Up_Transformers>, Record<string, never>, WithTypename<Sizing_Imports> | string>,
    transformer_type?: GraphCacheResolver<WithTypename<Step_Up_Transformers>, Record<string, never>, Scalars['String'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Step_Up_Transformers>, Record<string, never>, Scalars['timestamptz'] | string>,
    user?: GraphCacheResolver<WithTypename<Step_Up_Transformers>, Record<string, never>, WithTypename<Users> | string>,
    weight_pounds?: GraphCacheResolver<WithTypename<Step_Up_Transformers>, Record<string, never>, Scalars['Int'] | string>
  },
  step_up_transformers_aggregate?: {
    aggregate?: GraphCacheResolver<WithTypename<Step_Up_Transformers_Aggregate>, Record<string, never>, WithTypename<Step_Up_Transformers_Aggregate_Fields> | string>,
    nodes?: GraphCacheResolver<WithTypename<Step_Up_Transformers_Aggregate>, Record<string, never>, Array<WithTypename<Step_Up_Transformers> | string>>
  },
  step_up_transformers_aggregate_fields?: {
    avg?: GraphCacheResolver<WithTypename<Step_Up_Transformers_Aggregate_Fields>, Record<string, never>, WithTypename<Step_Up_Transformers_Avg_Fields> | string>,
    count?: GraphCacheResolver<WithTypename<Step_Up_Transformers_Aggregate_Fields>, Step_Up_Transformers_Aggregate_FieldsCountArgs, Scalars['Int'] | string>,
    max?: GraphCacheResolver<WithTypename<Step_Up_Transformers_Aggregate_Fields>, Record<string, never>, WithTypename<Step_Up_Transformers_Max_Fields> | string>,
    min?: GraphCacheResolver<WithTypename<Step_Up_Transformers_Aggregate_Fields>, Record<string, never>, WithTypename<Step_Up_Transformers_Min_Fields> | string>,
    stddev?: GraphCacheResolver<WithTypename<Step_Up_Transformers_Aggregate_Fields>, Record<string, never>, WithTypename<Step_Up_Transformers_Stddev_Fields> | string>,
    stddev_pop?: GraphCacheResolver<WithTypename<Step_Up_Transformers_Aggregate_Fields>, Record<string, never>, WithTypename<Step_Up_Transformers_Stddev_Pop_Fields> | string>,
    stddev_samp?: GraphCacheResolver<WithTypename<Step_Up_Transformers_Aggregate_Fields>, Record<string, never>, WithTypename<Step_Up_Transformers_Stddev_Samp_Fields> | string>,
    sum?: GraphCacheResolver<WithTypename<Step_Up_Transformers_Aggregate_Fields>, Record<string, never>, WithTypename<Step_Up_Transformers_Sum_Fields> | string>,
    var_pop?: GraphCacheResolver<WithTypename<Step_Up_Transformers_Aggregate_Fields>, Record<string, never>, WithTypename<Step_Up_Transformers_Var_Pop_Fields> | string>,
    var_samp?: GraphCacheResolver<WithTypename<Step_Up_Transformers_Aggregate_Fields>, Record<string, never>, WithTypename<Step_Up_Transformers_Var_Samp_Fields> | string>,
    variance?: GraphCacheResolver<WithTypename<Step_Up_Transformers_Aggregate_Fields>, Record<string, never>, WithTypename<Step_Up_Transformers_Variance_Fields> | string>
  },
  step_up_transformers_avg_fields?: {
    imported_sizing_id?: GraphCacheResolver<WithTypename<Step_Up_Transformers_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    kva?: GraphCacheResolver<WithTypename<Step_Up_Transformers_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    max_secondary_voltage?: GraphCacheResolver<WithTypename<Step_Up_Transformers_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    min_secondary_voltage?: GraphCacheResolver<WithTypename<Step_Up_Transformers_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    primary_voltage?: GraphCacheResolver<WithTypename<Step_Up_Transformers_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    weight_pounds?: GraphCacheResolver<WithTypename<Step_Up_Transformers_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  step_up_transformers_max_fields?: {
    author_id?: GraphCacheResolver<WithTypename<Step_Up_Transformers_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Step_Up_Transformers_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Step_Up_Transformers_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    enclosure?: GraphCacheResolver<WithTypename<Step_Up_Transformers_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    id?: GraphCacheResolver<WithTypename<Step_Up_Transformers_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Step_Up_Transformers_Max_Fields>, Record<string, never>, Scalars['Int'] | string>,
    include_ecopetrol_timestamp?: GraphCacheResolver<WithTypename<Step_Up_Transformers_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    include_koc_timestamp?: GraphCacheResolver<WithTypename<Step_Up_Transformers_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    kva?: GraphCacheResolver<WithTypename<Step_Up_Transformers_Max_Fields>, Record<string, never>, Scalars['Int'] | string>,
    manufacturer?: GraphCacheResolver<WithTypename<Step_Up_Transformers_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    max_secondary_voltage?: GraphCacheResolver<WithTypename<Step_Up_Transformers_Max_Fields>, Record<string, never>, Scalars['Int'] | string>,
    min_secondary_voltage?: GraphCacheResolver<WithTypename<Step_Up_Transformers_Max_Fields>, Record<string, never>, Scalars['Int'] | string>,
    only_ecopetrol_timestamp?: GraphCacheResolver<WithTypename<Step_Up_Transformers_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    only_koc_timestamp?: GraphCacheResolver<WithTypename<Step_Up_Transformers_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    part_number?: GraphCacheResolver<WithTypename<Step_Up_Transformers_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    primary_voltage?: GraphCacheResolver<WithTypename<Step_Up_Transformers_Max_Fields>, Record<string, never>, Scalars['Int'] | string>,
    prioritized_manufacturer?: GraphCacheResolver<WithTypename<Step_Up_Transformers_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    transformer_type?: GraphCacheResolver<WithTypename<Step_Up_Transformers_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Step_Up_Transformers_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    weight_pounds?: GraphCacheResolver<WithTypename<Step_Up_Transformers_Max_Fields>, Record<string, never>, Scalars['Int'] | string>
  },
  step_up_transformers_min_fields?: {
    author_id?: GraphCacheResolver<WithTypename<Step_Up_Transformers_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Step_Up_Transformers_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Step_Up_Transformers_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    enclosure?: GraphCacheResolver<WithTypename<Step_Up_Transformers_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    id?: GraphCacheResolver<WithTypename<Step_Up_Transformers_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Step_Up_Transformers_Min_Fields>, Record<string, never>, Scalars['Int'] | string>,
    include_ecopetrol_timestamp?: GraphCacheResolver<WithTypename<Step_Up_Transformers_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    include_koc_timestamp?: GraphCacheResolver<WithTypename<Step_Up_Transformers_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    kva?: GraphCacheResolver<WithTypename<Step_Up_Transformers_Min_Fields>, Record<string, never>, Scalars['Int'] | string>,
    manufacturer?: GraphCacheResolver<WithTypename<Step_Up_Transformers_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    max_secondary_voltage?: GraphCacheResolver<WithTypename<Step_Up_Transformers_Min_Fields>, Record<string, never>, Scalars['Int'] | string>,
    min_secondary_voltage?: GraphCacheResolver<WithTypename<Step_Up_Transformers_Min_Fields>, Record<string, never>, Scalars['Int'] | string>,
    only_ecopetrol_timestamp?: GraphCacheResolver<WithTypename<Step_Up_Transformers_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    only_koc_timestamp?: GraphCacheResolver<WithTypename<Step_Up_Transformers_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    part_number?: GraphCacheResolver<WithTypename<Step_Up_Transformers_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    primary_voltage?: GraphCacheResolver<WithTypename<Step_Up_Transformers_Min_Fields>, Record<string, never>, Scalars['Int'] | string>,
    prioritized_manufacturer?: GraphCacheResolver<WithTypename<Step_Up_Transformers_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    transformer_type?: GraphCacheResolver<WithTypename<Step_Up_Transformers_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Step_Up_Transformers_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    weight_pounds?: GraphCacheResolver<WithTypename<Step_Up_Transformers_Min_Fields>, Record<string, never>, Scalars['Int'] | string>
  },
  step_up_transformers_mutation_response?: {
    affected_rows?: GraphCacheResolver<WithTypename<Step_Up_Transformers_Mutation_Response>, Record<string, never>, Scalars['Int'] | string>,
    returning?: GraphCacheResolver<WithTypename<Step_Up_Transformers_Mutation_Response>, Record<string, never>, Array<WithTypename<Step_Up_Transformers> | string>>
  },
  step_up_transformers_stddev_fields?: {
    imported_sizing_id?: GraphCacheResolver<WithTypename<Step_Up_Transformers_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    kva?: GraphCacheResolver<WithTypename<Step_Up_Transformers_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    max_secondary_voltage?: GraphCacheResolver<WithTypename<Step_Up_Transformers_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    min_secondary_voltage?: GraphCacheResolver<WithTypename<Step_Up_Transformers_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    primary_voltage?: GraphCacheResolver<WithTypename<Step_Up_Transformers_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    weight_pounds?: GraphCacheResolver<WithTypename<Step_Up_Transformers_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  step_up_transformers_stddev_pop_fields?: {
    imported_sizing_id?: GraphCacheResolver<WithTypename<Step_Up_Transformers_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    kva?: GraphCacheResolver<WithTypename<Step_Up_Transformers_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    max_secondary_voltage?: GraphCacheResolver<WithTypename<Step_Up_Transformers_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    min_secondary_voltage?: GraphCacheResolver<WithTypename<Step_Up_Transformers_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    primary_voltage?: GraphCacheResolver<WithTypename<Step_Up_Transformers_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    weight_pounds?: GraphCacheResolver<WithTypename<Step_Up_Transformers_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  step_up_transformers_stddev_samp_fields?: {
    imported_sizing_id?: GraphCacheResolver<WithTypename<Step_Up_Transformers_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    kva?: GraphCacheResolver<WithTypename<Step_Up_Transformers_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    max_secondary_voltage?: GraphCacheResolver<WithTypename<Step_Up_Transformers_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    min_secondary_voltage?: GraphCacheResolver<WithTypename<Step_Up_Transformers_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    primary_voltage?: GraphCacheResolver<WithTypename<Step_Up_Transformers_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    weight_pounds?: GraphCacheResolver<WithTypename<Step_Up_Transformers_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  step_up_transformers_sum_fields?: {
    imported_sizing_id?: GraphCacheResolver<WithTypename<Step_Up_Transformers_Sum_Fields>, Record<string, never>, Scalars['Int'] | string>,
    kva?: GraphCacheResolver<WithTypename<Step_Up_Transformers_Sum_Fields>, Record<string, never>, Scalars['Int'] | string>,
    max_secondary_voltage?: GraphCacheResolver<WithTypename<Step_Up_Transformers_Sum_Fields>, Record<string, never>, Scalars['Int'] | string>,
    min_secondary_voltage?: GraphCacheResolver<WithTypename<Step_Up_Transformers_Sum_Fields>, Record<string, never>, Scalars['Int'] | string>,
    primary_voltage?: GraphCacheResolver<WithTypename<Step_Up_Transformers_Sum_Fields>, Record<string, never>, Scalars['Int'] | string>,
    weight_pounds?: GraphCacheResolver<WithTypename<Step_Up_Transformers_Sum_Fields>, Record<string, never>, Scalars['Int'] | string>
  },
  step_up_transformers_var_pop_fields?: {
    imported_sizing_id?: GraphCacheResolver<WithTypename<Step_Up_Transformers_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    kva?: GraphCacheResolver<WithTypename<Step_Up_Transformers_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    max_secondary_voltage?: GraphCacheResolver<WithTypename<Step_Up_Transformers_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    min_secondary_voltage?: GraphCacheResolver<WithTypename<Step_Up_Transformers_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    primary_voltage?: GraphCacheResolver<WithTypename<Step_Up_Transformers_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    weight_pounds?: GraphCacheResolver<WithTypename<Step_Up_Transformers_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  step_up_transformers_var_samp_fields?: {
    imported_sizing_id?: GraphCacheResolver<WithTypename<Step_Up_Transformers_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    kva?: GraphCacheResolver<WithTypename<Step_Up_Transformers_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    max_secondary_voltage?: GraphCacheResolver<WithTypename<Step_Up_Transformers_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    min_secondary_voltage?: GraphCacheResolver<WithTypename<Step_Up_Transformers_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    primary_voltage?: GraphCacheResolver<WithTypename<Step_Up_Transformers_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    weight_pounds?: GraphCacheResolver<WithTypename<Step_Up_Transformers_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  step_up_transformers_variance_fields?: {
    imported_sizing_id?: GraphCacheResolver<WithTypename<Step_Up_Transformers_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    kva?: GraphCacheResolver<WithTypename<Step_Up_Transformers_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    max_secondary_voltage?: GraphCacheResolver<WithTypename<Step_Up_Transformers_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    min_secondary_voltage?: GraphCacheResolver<WithTypename<Step_Up_Transformers_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    primary_voltage?: GraphCacheResolver<WithTypename<Step_Up_Transformers_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    weight_pounds?: GraphCacheResolver<WithTypename<Step_Up_Transformers_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  switchboards?: {
    amps?: GraphCacheResolver<WithTypename<Switchboards>, Record<string, never>, Scalars['Int'] | string>,
    author_id?: GraphCacheResolver<WithTypename<Switchboards>, Record<string, never>, Scalars['String'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Switchboards>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Switchboards>, Record<string, never>, Scalars['timestamptz'] | string>,
    enclosure?: GraphCacheResolver<WithTypename<Switchboards>, Record<string, never>, Scalars['String'] | string>,
    id?: GraphCacheResolver<WithTypename<Switchboards>, Record<string, never>, Scalars['uuid'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Switchboards>, Record<string, never>, Scalars['Int'] | string>,
    include_ecopetrol_timestamp?: GraphCacheResolver<WithTypename<Switchboards>, Record<string, never>, Scalars['timestamptz'] | string>,
    include_koc_timestamp?: GraphCacheResolver<WithTypename<Switchboards>, Record<string, never>, Scalars['timestamptz'] | string>,
    kv?: GraphCacheResolver<WithTypename<Switchboards>, Record<string, never>, Scalars['numeric'] | string>,
    manufacturer?: GraphCacheResolver<WithTypename<Switchboards>, Record<string, never>, Scalars['String'] | string>,
    only_ecopetrol_timestamp?: GraphCacheResolver<WithTypename<Switchboards>, Record<string, never>, Scalars['timestamptz'] | string>,
    only_koc_timestamp?: GraphCacheResolver<WithTypename<Switchboards>, Record<string, never>, Scalars['timestamptz'] | string>,
    part_number?: GraphCacheResolver<WithTypename<Switchboards>, Record<string, never>, Scalars['String'] | string>,
    prioritized_manufacturer?: GraphCacheResolver<WithTypename<Switchboards>, Record<string, never>, Scalars['String'] | string>,
    sizing_import?: GraphCacheResolver<WithTypename<Switchboards>, Record<string, never>, WithTypename<Sizing_Imports> | string>,
    updated_at?: GraphCacheResolver<WithTypename<Switchboards>, Record<string, never>, Scalars['timestamptz'] | string>,
    user?: GraphCacheResolver<WithTypename<Switchboards>, Record<string, never>, WithTypename<Users> | string>
  },
  switchboards_aggregate?: {
    aggregate?: GraphCacheResolver<WithTypename<Switchboards_Aggregate>, Record<string, never>, WithTypename<Switchboards_Aggregate_Fields> | string>,
    nodes?: GraphCacheResolver<WithTypename<Switchboards_Aggregate>, Record<string, never>, Array<WithTypename<Switchboards> | string>>
  },
  switchboards_aggregate_fields?: {
    avg?: GraphCacheResolver<WithTypename<Switchboards_Aggregate_Fields>, Record<string, never>, WithTypename<Switchboards_Avg_Fields> | string>,
    count?: GraphCacheResolver<WithTypename<Switchboards_Aggregate_Fields>, Switchboards_Aggregate_FieldsCountArgs, Scalars['Int'] | string>,
    max?: GraphCacheResolver<WithTypename<Switchboards_Aggregate_Fields>, Record<string, never>, WithTypename<Switchboards_Max_Fields> | string>,
    min?: GraphCacheResolver<WithTypename<Switchboards_Aggregate_Fields>, Record<string, never>, WithTypename<Switchboards_Min_Fields> | string>,
    stddev?: GraphCacheResolver<WithTypename<Switchboards_Aggregate_Fields>, Record<string, never>, WithTypename<Switchboards_Stddev_Fields> | string>,
    stddev_pop?: GraphCacheResolver<WithTypename<Switchboards_Aggregate_Fields>, Record<string, never>, WithTypename<Switchboards_Stddev_Pop_Fields> | string>,
    stddev_samp?: GraphCacheResolver<WithTypename<Switchboards_Aggregate_Fields>, Record<string, never>, WithTypename<Switchboards_Stddev_Samp_Fields> | string>,
    sum?: GraphCacheResolver<WithTypename<Switchboards_Aggregate_Fields>, Record<string, never>, WithTypename<Switchboards_Sum_Fields> | string>,
    var_pop?: GraphCacheResolver<WithTypename<Switchboards_Aggregate_Fields>, Record<string, never>, WithTypename<Switchboards_Var_Pop_Fields> | string>,
    var_samp?: GraphCacheResolver<WithTypename<Switchboards_Aggregate_Fields>, Record<string, never>, WithTypename<Switchboards_Var_Samp_Fields> | string>,
    variance?: GraphCacheResolver<WithTypename<Switchboards_Aggregate_Fields>, Record<string, never>, WithTypename<Switchboards_Variance_Fields> | string>
  },
  switchboards_avg_fields?: {
    amps?: GraphCacheResolver<WithTypename<Switchboards_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Switchboards_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    kv?: GraphCacheResolver<WithTypename<Switchboards_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  switchboards_max_fields?: {
    amps?: GraphCacheResolver<WithTypename<Switchboards_Max_Fields>, Record<string, never>, Scalars['Int'] | string>,
    author_id?: GraphCacheResolver<WithTypename<Switchboards_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Switchboards_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Switchboards_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    enclosure?: GraphCacheResolver<WithTypename<Switchboards_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    id?: GraphCacheResolver<WithTypename<Switchboards_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Switchboards_Max_Fields>, Record<string, never>, Scalars['Int'] | string>,
    include_ecopetrol_timestamp?: GraphCacheResolver<WithTypename<Switchboards_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    include_koc_timestamp?: GraphCacheResolver<WithTypename<Switchboards_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    kv?: GraphCacheResolver<WithTypename<Switchboards_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    manufacturer?: GraphCacheResolver<WithTypename<Switchboards_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    only_ecopetrol_timestamp?: GraphCacheResolver<WithTypename<Switchboards_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    only_koc_timestamp?: GraphCacheResolver<WithTypename<Switchboards_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    part_number?: GraphCacheResolver<WithTypename<Switchboards_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    prioritized_manufacturer?: GraphCacheResolver<WithTypename<Switchboards_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Switchboards_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>
  },
  switchboards_min_fields?: {
    amps?: GraphCacheResolver<WithTypename<Switchboards_Min_Fields>, Record<string, never>, Scalars['Int'] | string>,
    author_id?: GraphCacheResolver<WithTypename<Switchboards_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Switchboards_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Switchboards_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    enclosure?: GraphCacheResolver<WithTypename<Switchboards_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    id?: GraphCacheResolver<WithTypename<Switchboards_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Switchboards_Min_Fields>, Record<string, never>, Scalars['Int'] | string>,
    include_ecopetrol_timestamp?: GraphCacheResolver<WithTypename<Switchboards_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    include_koc_timestamp?: GraphCacheResolver<WithTypename<Switchboards_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    kv?: GraphCacheResolver<WithTypename<Switchboards_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    manufacturer?: GraphCacheResolver<WithTypename<Switchboards_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    only_ecopetrol_timestamp?: GraphCacheResolver<WithTypename<Switchboards_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    only_koc_timestamp?: GraphCacheResolver<WithTypename<Switchboards_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    part_number?: GraphCacheResolver<WithTypename<Switchboards_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    prioritized_manufacturer?: GraphCacheResolver<WithTypename<Switchboards_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Switchboards_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>
  },
  switchboards_mutation_response?: {
    affected_rows?: GraphCacheResolver<WithTypename<Switchboards_Mutation_Response>, Record<string, never>, Scalars['Int'] | string>,
    returning?: GraphCacheResolver<WithTypename<Switchboards_Mutation_Response>, Record<string, never>, Array<WithTypename<Switchboards> | string>>
  },
  switchboards_stddev_fields?: {
    amps?: GraphCacheResolver<WithTypename<Switchboards_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Switchboards_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    kv?: GraphCacheResolver<WithTypename<Switchboards_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  switchboards_stddev_pop_fields?: {
    amps?: GraphCacheResolver<WithTypename<Switchboards_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Switchboards_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    kv?: GraphCacheResolver<WithTypename<Switchboards_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  switchboards_stddev_samp_fields?: {
    amps?: GraphCacheResolver<WithTypename<Switchboards_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Switchboards_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    kv?: GraphCacheResolver<WithTypename<Switchboards_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  switchboards_sum_fields?: {
    amps?: GraphCacheResolver<WithTypename<Switchboards_Sum_Fields>, Record<string, never>, Scalars['Int'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Switchboards_Sum_Fields>, Record<string, never>, Scalars['Int'] | string>,
    kv?: GraphCacheResolver<WithTypename<Switchboards_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>
  },
  switchboards_var_pop_fields?: {
    amps?: GraphCacheResolver<WithTypename<Switchboards_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Switchboards_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    kv?: GraphCacheResolver<WithTypename<Switchboards_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  switchboards_var_samp_fields?: {
    amps?: GraphCacheResolver<WithTypename<Switchboards_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Switchboards_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    kv?: GraphCacheResolver<WithTypename<Switchboards_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  switchboards_variance_fields?: {
    amps?: GraphCacheResolver<WithTypename<Switchboards_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Switchboards_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    kv?: GraphCacheResolver<WithTypename<Switchboards_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  tubing_flow_options?: {
    comment?: GraphCacheResolver<WithTypename<Tubing_Flow_Options>, Record<string, never>, Scalars['String'] | string>,
    value?: GraphCacheResolver<WithTypename<Tubing_Flow_Options>, Record<string, never>, Scalars['String'] | string>
  },
  tubing_flow_options_aggregate?: {
    aggregate?: GraphCacheResolver<WithTypename<Tubing_Flow_Options_Aggregate>, Record<string, never>, WithTypename<Tubing_Flow_Options_Aggregate_Fields> | string>,
    nodes?: GraphCacheResolver<WithTypename<Tubing_Flow_Options_Aggregate>, Record<string, never>, Array<WithTypename<Tubing_Flow_Options> | string>>
  },
  tubing_flow_options_aggregate_fields?: {
    count?: GraphCacheResolver<WithTypename<Tubing_Flow_Options_Aggregate_Fields>, Tubing_Flow_Options_Aggregate_FieldsCountArgs, Scalars['Int'] | string>,
    max?: GraphCacheResolver<WithTypename<Tubing_Flow_Options_Aggregate_Fields>, Record<string, never>, WithTypename<Tubing_Flow_Options_Max_Fields> | string>,
    min?: GraphCacheResolver<WithTypename<Tubing_Flow_Options_Aggregate_Fields>, Record<string, never>, WithTypename<Tubing_Flow_Options_Min_Fields> | string>
  },
  tubing_flow_options_max_fields?: {
    comment?: GraphCacheResolver<WithTypename<Tubing_Flow_Options_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    value?: GraphCacheResolver<WithTypename<Tubing_Flow_Options_Max_Fields>, Record<string, never>, Scalars['String'] | string>
  },
  tubing_flow_options_min_fields?: {
    comment?: GraphCacheResolver<WithTypename<Tubing_Flow_Options_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    value?: GraphCacheResolver<WithTypename<Tubing_Flow_Options_Min_Fields>, Record<string, never>, Scalars['String'] | string>
  },
  tubing_flow_options_mutation_response?: {
    affected_rows?: GraphCacheResolver<WithTypename<Tubing_Flow_Options_Mutation_Response>, Record<string, never>, Scalars['Int'] | string>,
    returning?: GraphCacheResolver<WithTypename<Tubing_Flow_Options_Mutation_Response>, Record<string, never>, Array<WithTypename<Tubing_Flow_Options> | string>>
  },
  tubings?: {
    author_id?: GraphCacheResolver<WithTypename<Tubings>, Record<string, never>, Scalars['String'] | string>,
    coupling_outer_diameter_inches?: GraphCacheResolver<WithTypename<Tubings>, Record<string, never>, Scalars['numeric'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Tubings>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Tubings>, Record<string, never>, Scalars['timestamptz'] | string>,
    drift_inches?: GraphCacheResolver<WithTypename<Tubings>, Record<string, never>, Scalars['numeric'] | string>,
    id?: GraphCacheResolver<WithTypename<Tubings>, Record<string, never>, Scalars['uuid'] | string>,
    imperial_name?: GraphCacheResolver<WithTypename<Tubings>, Record<string, never>, Scalars['String'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Tubings>, Record<string, never>, Scalars['Int'] | string>,
    include_ecopetrol_timestamp?: GraphCacheResolver<WithTypename<Tubings>, Record<string, never>, Scalars['timestamptz'] | string>,
    include_koc_timestamp?: GraphCacheResolver<WithTypename<Tubings>, Record<string, never>, Scalars['timestamptz'] | string>,
    interior_diameter_inches?: GraphCacheResolver<WithTypename<Tubings>, Record<string, never>, Scalars['numeric'] | string>,
    metric_name?: GraphCacheResolver<WithTypename<Tubings>, Record<string, never>, Scalars['String'] | string>,
    only_ecopetrol_timestamp?: GraphCacheResolver<WithTypename<Tubings>, Record<string, never>, Scalars['timestamptz'] | string>,
    only_koc_timestamp?: GraphCacheResolver<WithTypename<Tubings>, Record<string, never>, Scalars['timestamptz'] | string>,
    outer_diameter_inches?: GraphCacheResolver<WithTypename<Tubings>, Record<string, never>, Scalars['numeric'] | string>,
    pound_per_foot?: GraphCacheResolver<WithTypename<Tubings>, Record<string, never>, Scalars['numeric'] | string>,
    sizing_import?: GraphCacheResolver<WithTypename<Tubings>, Record<string, never>, WithTypename<Sizing_Imports> | string>,
    tubing_type?: GraphCacheResolver<WithTypename<Tubings>, Record<string, never>, Tubings_Type_Enum | string>,
    updated_at?: GraphCacheResolver<WithTypename<Tubings>, Record<string, never>, Scalars['timestamptz'] | string>,
    user?: GraphCacheResolver<WithTypename<Tubings>, Record<string, never>, WithTypename<Users> | string>
  },
  tubings_aggregate?: {
    aggregate?: GraphCacheResolver<WithTypename<Tubings_Aggregate>, Record<string, never>, WithTypename<Tubings_Aggregate_Fields> | string>,
    nodes?: GraphCacheResolver<WithTypename<Tubings_Aggregate>, Record<string, never>, Array<WithTypename<Tubings> | string>>
  },
  tubings_aggregate_fields?: {
    avg?: GraphCacheResolver<WithTypename<Tubings_Aggregate_Fields>, Record<string, never>, WithTypename<Tubings_Avg_Fields> | string>,
    count?: GraphCacheResolver<WithTypename<Tubings_Aggregate_Fields>, Tubings_Aggregate_FieldsCountArgs, Scalars['Int'] | string>,
    max?: GraphCacheResolver<WithTypename<Tubings_Aggregate_Fields>, Record<string, never>, WithTypename<Tubings_Max_Fields> | string>,
    min?: GraphCacheResolver<WithTypename<Tubings_Aggregate_Fields>, Record<string, never>, WithTypename<Tubings_Min_Fields> | string>,
    stddev?: GraphCacheResolver<WithTypename<Tubings_Aggregate_Fields>, Record<string, never>, WithTypename<Tubings_Stddev_Fields> | string>,
    stddev_pop?: GraphCacheResolver<WithTypename<Tubings_Aggregate_Fields>, Record<string, never>, WithTypename<Tubings_Stddev_Pop_Fields> | string>,
    stddev_samp?: GraphCacheResolver<WithTypename<Tubings_Aggregate_Fields>, Record<string, never>, WithTypename<Tubings_Stddev_Samp_Fields> | string>,
    sum?: GraphCacheResolver<WithTypename<Tubings_Aggregate_Fields>, Record<string, never>, WithTypename<Tubings_Sum_Fields> | string>,
    var_pop?: GraphCacheResolver<WithTypename<Tubings_Aggregate_Fields>, Record<string, never>, WithTypename<Tubings_Var_Pop_Fields> | string>,
    var_samp?: GraphCacheResolver<WithTypename<Tubings_Aggregate_Fields>, Record<string, never>, WithTypename<Tubings_Var_Samp_Fields> | string>,
    variance?: GraphCacheResolver<WithTypename<Tubings_Aggregate_Fields>, Record<string, never>, WithTypename<Tubings_Variance_Fields> | string>
  },
  tubings_avg_fields?: {
    coupling_outer_diameter_inches?: GraphCacheResolver<WithTypename<Tubings_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    drift_inches?: GraphCacheResolver<WithTypename<Tubings_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Tubings_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    interior_diameter_inches?: GraphCacheResolver<WithTypename<Tubings_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    outer_diameter_inches?: GraphCacheResolver<WithTypename<Tubings_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pound_per_foot?: GraphCacheResolver<WithTypename<Tubings_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  tubings_max_fields?: {
    author_id?: GraphCacheResolver<WithTypename<Tubings_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    coupling_outer_diameter_inches?: GraphCacheResolver<WithTypename<Tubings_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Tubings_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Tubings_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    drift_inches?: GraphCacheResolver<WithTypename<Tubings_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    id?: GraphCacheResolver<WithTypename<Tubings_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    imperial_name?: GraphCacheResolver<WithTypename<Tubings_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Tubings_Max_Fields>, Record<string, never>, Scalars['Int'] | string>,
    include_ecopetrol_timestamp?: GraphCacheResolver<WithTypename<Tubings_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    include_koc_timestamp?: GraphCacheResolver<WithTypename<Tubings_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    interior_diameter_inches?: GraphCacheResolver<WithTypename<Tubings_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    metric_name?: GraphCacheResolver<WithTypename<Tubings_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    only_ecopetrol_timestamp?: GraphCacheResolver<WithTypename<Tubings_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    only_koc_timestamp?: GraphCacheResolver<WithTypename<Tubings_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    outer_diameter_inches?: GraphCacheResolver<WithTypename<Tubings_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    pound_per_foot?: GraphCacheResolver<WithTypename<Tubings_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Tubings_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>
  },
  tubings_min_fields?: {
    author_id?: GraphCacheResolver<WithTypename<Tubings_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    coupling_outer_diameter_inches?: GraphCacheResolver<WithTypename<Tubings_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Tubings_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Tubings_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    drift_inches?: GraphCacheResolver<WithTypename<Tubings_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    id?: GraphCacheResolver<WithTypename<Tubings_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    imperial_name?: GraphCacheResolver<WithTypename<Tubings_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Tubings_Min_Fields>, Record<string, never>, Scalars['Int'] | string>,
    include_ecopetrol_timestamp?: GraphCacheResolver<WithTypename<Tubings_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    include_koc_timestamp?: GraphCacheResolver<WithTypename<Tubings_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    interior_diameter_inches?: GraphCacheResolver<WithTypename<Tubings_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    metric_name?: GraphCacheResolver<WithTypename<Tubings_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    only_ecopetrol_timestamp?: GraphCacheResolver<WithTypename<Tubings_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    only_koc_timestamp?: GraphCacheResolver<WithTypename<Tubings_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    outer_diameter_inches?: GraphCacheResolver<WithTypename<Tubings_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    pound_per_foot?: GraphCacheResolver<WithTypename<Tubings_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Tubings_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>
  },
  tubings_mutation_response?: {
    affected_rows?: GraphCacheResolver<WithTypename<Tubings_Mutation_Response>, Record<string, never>, Scalars['Int'] | string>,
    returning?: GraphCacheResolver<WithTypename<Tubings_Mutation_Response>, Record<string, never>, Array<WithTypename<Tubings> | string>>
  },
  tubings_stddev_fields?: {
    coupling_outer_diameter_inches?: GraphCacheResolver<WithTypename<Tubings_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    drift_inches?: GraphCacheResolver<WithTypename<Tubings_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Tubings_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    interior_diameter_inches?: GraphCacheResolver<WithTypename<Tubings_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    outer_diameter_inches?: GraphCacheResolver<WithTypename<Tubings_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pound_per_foot?: GraphCacheResolver<WithTypename<Tubings_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  tubings_stddev_pop_fields?: {
    coupling_outer_diameter_inches?: GraphCacheResolver<WithTypename<Tubings_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    drift_inches?: GraphCacheResolver<WithTypename<Tubings_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Tubings_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    interior_diameter_inches?: GraphCacheResolver<WithTypename<Tubings_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    outer_diameter_inches?: GraphCacheResolver<WithTypename<Tubings_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pound_per_foot?: GraphCacheResolver<WithTypename<Tubings_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  tubings_stddev_samp_fields?: {
    coupling_outer_diameter_inches?: GraphCacheResolver<WithTypename<Tubings_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    drift_inches?: GraphCacheResolver<WithTypename<Tubings_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Tubings_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    interior_diameter_inches?: GraphCacheResolver<WithTypename<Tubings_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    outer_diameter_inches?: GraphCacheResolver<WithTypename<Tubings_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pound_per_foot?: GraphCacheResolver<WithTypename<Tubings_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  tubings_sum_fields?: {
    coupling_outer_diameter_inches?: GraphCacheResolver<WithTypename<Tubings_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    drift_inches?: GraphCacheResolver<WithTypename<Tubings_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Tubings_Sum_Fields>, Record<string, never>, Scalars['Int'] | string>,
    interior_diameter_inches?: GraphCacheResolver<WithTypename<Tubings_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    outer_diameter_inches?: GraphCacheResolver<WithTypename<Tubings_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    pound_per_foot?: GraphCacheResolver<WithTypename<Tubings_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>
  },
  tubings_type?: {
    comment?: GraphCacheResolver<WithTypename<Tubings_Type>, Record<string, never>, Scalars['String'] | string>,
    value?: GraphCacheResolver<WithTypename<Tubings_Type>, Record<string, never>, Scalars['String'] | string>
  },
  tubings_type_aggregate?: {
    aggregate?: GraphCacheResolver<WithTypename<Tubings_Type_Aggregate>, Record<string, never>, WithTypename<Tubings_Type_Aggregate_Fields> | string>,
    nodes?: GraphCacheResolver<WithTypename<Tubings_Type_Aggregate>, Record<string, never>, Array<WithTypename<Tubings_Type> | string>>
  },
  tubings_type_aggregate_fields?: {
    count?: GraphCacheResolver<WithTypename<Tubings_Type_Aggregate_Fields>, Tubings_Type_Aggregate_FieldsCountArgs, Scalars['Int'] | string>,
    max?: GraphCacheResolver<WithTypename<Tubings_Type_Aggregate_Fields>, Record<string, never>, WithTypename<Tubings_Type_Max_Fields> | string>,
    min?: GraphCacheResolver<WithTypename<Tubings_Type_Aggregate_Fields>, Record<string, never>, WithTypename<Tubings_Type_Min_Fields> | string>
  },
  tubings_type_max_fields?: {
    comment?: GraphCacheResolver<WithTypename<Tubings_Type_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    value?: GraphCacheResolver<WithTypename<Tubings_Type_Max_Fields>, Record<string, never>, Scalars['String'] | string>
  },
  tubings_type_min_fields?: {
    comment?: GraphCacheResolver<WithTypename<Tubings_Type_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    value?: GraphCacheResolver<WithTypename<Tubings_Type_Min_Fields>, Record<string, never>, Scalars['String'] | string>
  },
  tubings_type_mutation_response?: {
    affected_rows?: GraphCacheResolver<WithTypename<Tubings_Type_Mutation_Response>, Record<string, never>, Scalars['Int'] | string>,
    returning?: GraphCacheResolver<WithTypename<Tubings_Type_Mutation_Response>, Record<string, never>, Array<WithTypename<Tubings_Type> | string>>
  },
  tubings_var_pop_fields?: {
    coupling_outer_diameter_inches?: GraphCacheResolver<WithTypename<Tubings_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    drift_inches?: GraphCacheResolver<WithTypename<Tubings_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Tubings_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    interior_diameter_inches?: GraphCacheResolver<WithTypename<Tubings_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    outer_diameter_inches?: GraphCacheResolver<WithTypename<Tubings_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pound_per_foot?: GraphCacheResolver<WithTypename<Tubings_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  tubings_var_samp_fields?: {
    coupling_outer_diameter_inches?: GraphCacheResolver<WithTypename<Tubings_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    drift_inches?: GraphCacheResolver<WithTypename<Tubings_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Tubings_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    interior_diameter_inches?: GraphCacheResolver<WithTypename<Tubings_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    outer_diameter_inches?: GraphCacheResolver<WithTypename<Tubings_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pound_per_foot?: GraphCacheResolver<WithTypename<Tubings_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  tubings_variance_fields?: {
    coupling_outer_diameter_inches?: GraphCacheResolver<WithTypename<Tubings_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    drift_inches?: GraphCacheResolver<WithTypename<Tubings_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Tubings_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    interior_diameter_inches?: GraphCacheResolver<WithTypename<Tubings_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    outer_diameter_inches?: GraphCacheResolver<WithTypename<Tubings_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pound_per_foot?: GraphCacheResolver<WithTypename<Tubings_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  under_saturated_oil_options?: {
    comment?: GraphCacheResolver<WithTypename<Under_Saturated_Oil_Options>, Record<string, never>, Scalars['String'] | string>,
    value?: GraphCacheResolver<WithTypename<Under_Saturated_Oil_Options>, Record<string, never>, Scalars['String'] | string>
  },
  under_saturated_oil_options_aggregate?: {
    aggregate?: GraphCacheResolver<WithTypename<Under_Saturated_Oil_Options_Aggregate>, Record<string, never>, WithTypename<Under_Saturated_Oil_Options_Aggregate_Fields> | string>,
    nodes?: GraphCacheResolver<WithTypename<Under_Saturated_Oil_Options_Aggregate>, Record<string, never>, Array<WithTypename<Under_Saturated_Oil_Options> | string>>
  },
  under_saturated_oil_options_aggregate_fields?: {
    count?: GraphCacheResolver<WithTypename<Under_Saturated_Oil_Options_Aggregate_Fields>, Under_Saturated_Oil_Options_Aggregate_FieldsCountArgs, Scalars['Int'] | string>,
    max?: GraphCacheResolver<WithTypename<Under_Saturated_Oil_Options_Aggregate_Fields>, Record<string, never>, WithTypename<Under_Saturated_Oil_Options_Max_Fields> | string>,
    min?: GraphCacheResolver<WithTypename<Under_Saturated_Oil_Options_Aggregate_Fields>, Record<string, never>, WithTypename<Under_Saturated_Oil_Options_Min_Fields> | string>
  },
  under_saturated_oil_options_max_fields?: {
    comment?: GraphCacheResolver<WithTypename<Under_Saturated_Oil_Options_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    value?: GraphCacheResolver<WithTypename<Under_Saturated_Oil_Options_Max_Fields>, Record<string, never>, Scalars['String'] | string>
  },
  under_saturated_oil_options_min_fields?: {
    comment?: GraphCacheResolver<WithTypename<Under_Saturated_Oil_Options_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    value?: GraphCacheResolver<WithTypename<Under_Saturated_Oil_Options_Min_Fields>, Record<string, never>, Scalars['String'] | string>
  },
  under_saturated_oil_options_mutation_response?: {
    affected_rows?: GraphCacheResolver<WithTypename<Under_Saturated_Oil_Options_Mutation_Response>, Record<string, never>, Scalars['Int'] | string>,
    returning?: GraphCacheResolver<WithTypename<Under_Saturated_Oil_Options_Mutation_Response>, Record<string, never>, Array<WithTypename<Under_Saturated_Oil_Options> | string>>
  },
  user_eula_acceptance?: {
    eula?: GraphCacheResolver<WithTypename<User_Eula_Acceptance>, Record<string, never>, WithTypename<Eula> | string>,
    eula_id?: GraphCacheResolver<WithTypename<User_Eula_Acceptance>, Record<string, never>, Scalars['uuid'] | string>,
    id?: GraphCacheResolver<WithTypename<User_Eula_Acceptance>, Record<string, never>, Scalars['uuid'] | string>,
    signed_at?: GraphCacheResolver<WithTypename<User_Eula_Acceptance>, Record<string, never>, Scalars['timestamptz'] | string>,
    user?: GraphCacheResolver<WithTypename<User_Eula_Acceptance>, Record<string, never>, WithTypename<Users> | string>,
    user_id?: GraphCacheResolver<WithTypename<User_Eula_Acceptance>, Record<string, never>, Scalars['String'] | string>
  },
  user_eula_acceptance_aggregate?: {
    aggregate?: GraphCacheResolver<WithTypename<User_Eula_Acceptance_Aggregate>, Record<string, never>, WithTypename<User_Eula_Acceptance_Aggregate_Fields> | string>,
    nodes?: GraphCacheResolver<WithTypename<User_Eula_Acceptance_Aggregate>, Record<string, never>, Array<WithTypename<User_Eula_Acceptance> | string>>
  },
  user_eula_acceptance_aggregate_fields?: {
    count?: GraphCacheResolver<WithTypename<User_Eula_Acceptance_Aggregate_Fields>, User_Eula_Acceptance_Aggregate_FieldsCountArgs, Scalars['Int'] | string>,
    max?: GraphCacheResolver<WithTypename<User_Eula_Acceptance_Aggregate_Fields>, Record<string, never>, WithTypename<User_Eula_Acceptance_Max_Fields> | string>,
    min?: GraphCacheResolver<WithTypename<User_Eula_Acceptance_Aggregate_Fields>, Record<string, never>, WithTypename<User_Eula_Acceptance_Min_Fields> | string>
  },
  user_eula_acceptance_max_fields?: {
    eula_id?: GraphCacheResolver<WithTypename<User_Eula_Acceptance_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    id?: GraphCacheResolver<WithTypename<User_Eula_Acceptance_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    signed_at?: GraphCacheResolver<WithTypename<User_Eula_Acceptance_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    user_id?: GraphCacheResolver<WithTypename<User_Eula_Acceptance_Max_Fields>, Record<string, never>, Scalars['String'] | string>
  },
  user_eula_acceptance_min_fields?: {
    eula_id?: GraphCacheResolver<WithTypename<User_Eula_Acceptance_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    id?: GraphCacheResolver<WithTypename<User_Eula_Acceptance_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    signed_at?: GraphCacheResolver<WithTypename<User_Eula_Acceptance_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    user_id?: GraphCacheResolver<WithTypename<User_Eula_Acceptance_Min_Fields>, Record<string, never>, Scalars['String'] | string>
  },
  user_eula_acceptance_mutation_response?: {
    affected_rows?: GraphCacheResolver<WithTypename<User_Eula_Acceptance_Mutation_Response>, Record<string, never>, Scalars['Int'] | string>,
    returning?: GraphCacheResolver<WithTypename<User_Eula_Acceptance_Mutation_Response>, Record<string, never>, Array<WithTypename<User_Eula_Acceptance> | string>>
  },
  users?: {
    cables?: GraphCacheResolver<WithTypename<Users>, UsersCablesArgs, Array<WithTypename<Cables> | string>>,
    cables_aggregate?: GraphCacheResolver<WithTypename<Users>, UsersCables_AggregateArgs, WithTypename<Cables_Aggregate> | string>,
    casings?: GraphCacheResolver<WithTypename<Users>, UsersCasingsArgs, Array<WithTypename<Casings> | string>>,
    casings_aggregate?: GraphCacheResolver<WithTypename<Users>, UsersCasings_AggregateArgs, WithTypename<Casings_Aggregate> | string>,
    created_at?: GraphCacheResolver<WithTypename<Users>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Users>, Record<string, never>, Scalars['timestamptz'] | string>,
    deviation_surveys?: GraphCacheResolver<WithTypename<Users>, UsersDeviation_SurveysArgs, Array<WithTypename<Deviation_Survey> | string>>,
    deviation_surveys_aggregate?: GraphCacheResolver<WithTypename<Users>, UsersDeviation_Surveys_AggregateArgs, WithTypename<Deviation_Survey_Aggregate> | string>,
    display_name?: GraphCacheResolver<WithTypename<Users>, Record<string, never>, Scalars['String'] | string>,
    email?: GraphCacheResolver<WithTypename<Users>, Record<string, never>, Scalars['String'] | string>,
    hal_identifier?: GraphCacheResolver<WithTypename<Users>, Record<string, never>, Scalars['String'] | string>,
    housings?: GraphCacheResolver<WithTypename<Users>, UsersHousingsArgs, Array<WithTypename<Housings> | string>>,
    housings_aggregate?: GraphCacheResolver<WithTypename<Users>, UsersHousings_AggregateArgs, WithTypename<Housings_Aggregate> | string>,
    id?: GraphCacheResolver<WithTypename<Users>, Record<string, never>, Scalars['String'] | string>,
    intakes?: GraphCacheResolver<WithTypename<Users>, UsersIntakesArgs, Array<WithTypename<Intakes> | string>>,
    intakes_aggregate?: GraphCacheResolver<WithTypename<Users>, UsersIntakes_AggregateArgs, WithTypename<Intakes_Aggregate> | string>,
    motor_lead_extensions?: GraphCacheResolver<WithTypename<Users>, UsersMotor_Lead_ExtensionsArgs, Array<WithTypename<Motor_Lead_Extensions> | string>>,
    motor_lead_extensions_aggregate?: GraphCacheResolver<WithTypename<Users>, UsersMotor_Lead_Extensions_AggregateArgs, WithTypename<Motor_Lead_Extensions_Aggregate> | string>,
    motors?: GraphCacheResolver<WithTypename<Users>, UsersMotorsArgs, Array<WithTypename<Motors> | string>>,
    motors_aggregate?: GraphCacheResolver<WithTypename<Users>, UsersMotors_AggregateArgs, WithTypename<Motors_Aggregate> | string>,
    pumps?: GraphCacheResolver<WithTypename<Users>, UsersPumpsArgs, Array<WithTypename<Pumps> | string>>,
    pumps_aggregate?: GraphCacheResolver<WithTypename<Users>, UsersPumps_AggregateArgs, WithTypename<Pumps_Aggregate> | string>,
    seals?: GraphCacheResolver<WithTypename<Users>, UsersSealsArgs, Array<WithTypename<Seals> | string>>,
    seals_aggregate?: GraphCacheResolver<WithTypename<Users>, UsersSeals_AggregateArgs, WithTypename<Seals_Aggregate> | string>,
    sensors?: GraphCacheResolver<WithTypename<Users>, UsersSensorsArgs, Array<WithTypename<Sensors> | string>>,
    sensors_aggregate?: GraphCacheResolver<WithTypename<Users>, UsersSensors_AggregateArgs, WithTypename<Sensors_Aggregate> | string>,
    sizing_imports?: GraphCacheResolver<WithTypename<Users>, UsersSizing_ImportsArgs, Array<WithTypename<Sizing_Imports> | string>>,
    sizing_imports_aggregate?: GraphCacheResolver<WithTypename<Users>, UsersSizing_Imports_AggregateArgs, WithTypename<Sizing_Imports_Aggregate> | string>,
    step_down_transformers?: GraphCacheResolver<WithTypename<Users>, UsersStep_Down_TransformersArgs, Array<WithTypename<Step_Down_Transformers> | string>>,
    step_down_transformers_aggregate?: GraphCacheResolver<WithTypename<Users>, UsersStep_Down_Transformers_AggregateArgs, WithTypename<Step_Down_Transformers_Aggregate> | string>,
    step_up_transformers?: GraphCacheResolver<WithTypename<Users>, UsersStep_Up_TransformersArgs, Array<WithTypename<Step_Up_Transformers> | string>>,
    step_up_transformers_aggregate?: GraphCacheResolver<WithTypename<Users>, UsersStep_Up_Transformers_AggregateArgs, WithTypename<Step_Up_Transformers_Aggregate> | string>,
    switchboards?: GraphCacheResolver<WithTypename<Users>, UsersSwitchboardsArgs, Array<WithTypename<Switchboards> | string>>,
    switchboards_aggregate?: GraphCacheResolver<WithTypename<Users>, UsersSwitchboards_AggregateArgs, WithTypename<Switchboards_Aggregate> | string>,
    tubings?: GraphCacheResolver<WithTypename<Users>, UsersTubingsArgs, Array<WithTypename<Tubings> | string>>,
    tubings_aggregate?: GraphCacheResolver<WithTypename<Users>, UsersTubings_AggregateArgs, WithTypename<Tubings_Aggregate> | string>,
    updated_at?: GraphCacheResolver<WithTypename<Users>, Record<string, never>, Scalars['timestamptz'] | string>,
    username?: GraphCacheResolver<WithTypename<Users>, Record<string, never>, Scalars['String'] | string>,
    variable_speed_drives?: GraphCacheResolver<WithTypename<Users>, UsersVariable_Speed_DrivesArgs, Array<WithTypename<Variable_Speed_Drives> | string>>,
    variable_speed_drives_aggregate?: GraphCacheResolver<WithTypename<Users>, UsersVariable_Speed_Drives_AggregateArgs, WithTypename<Variable_Speed_Drives_Aggregate> | string>
  },
  users_aggregate?: {
    aggregate?: GraphCacheResolver<WithTypename<Users_Aggregate>, Record<string, never>, WithTypename<Users_Aggregate_Fields> | string>,
    nodes?: GraphCacheResolver<WithTypename<Users_Aggregate>, Record<string, never>, Array<WithTypename<Users> | string>>
  },
  users_aggregate_fields?: {
    count?: GraphCacheResolver<WithTypename<Users_Aggregate_Fields>, Users_Aggregate_FieldsCountArgs, Scalars['Int'] | string>,
    max?: GraphCacheResolver<WithTypename<Users_Aggregate_Fields>, Record<string, never>, WithTypename<Users_Max_Fields> | string>,
    min?: GraphCacheResolver<WithTypename<Users_Aggregate_Fields>, Record<string, never>, WithTypename<Users_Min_Fields> | string>
  },
  users_max_fields?: {
    created_at?: GraphCacheResolver<WithTypename<Users_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Users_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    display_name?: GraphCacheResolver<WithTypename<Users_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    email?: GraphCacheResolver<WithTypename<Users_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    hal_identifier?: GraphCacheResolver<WithTypename<Users_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    id?: GraphCacheResolver<WithTypename<Users_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Users_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    username?: GraphCacheResolver<WithTypename<Users_Max_Fields>, Record<string, never>, Scalars['String'] | string>
  },
  users_min_fields?: {
    created_at?: GraphCacheResolver<WithTypename<Users_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Users_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    display_name?: GraphCacheResolver<WithTypename<Users_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    email?: GraphCacheResolver<WithTypename<Users_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    hal_identifier?: GraphCacheResolver<WithTypename<Users_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    id?: GraphCacheResolver<WithTypename<Users_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Users_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    username?: GraphCacheResolver<WithTypename<Users_Min_Fields>, Record<string, never>, Scalars['String'] | string>
  },
  users_mutation_response?: {
    affected_rows?: GraphCacheResolver<WithTypename<Users_Mutation_Response>, Record<string, never>, Scalars['Int'] | string>,
    returning?: GraphCacheResolver<WithTypename<Users_Mutation_Response>, Record<string, never>, Array<WithTypename<Users> | string>>
  },
  variable_speed_drives?: {
    author_id?: GraphCacheResolver<WithTypename<Variable_Speed_Drives>, Record<string, never>, Scalars['String'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Variable_Speed_Drives>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Variable_Speed_Drives>, Record<string, never>, Scalars['timestamptz'] | string>,
    enclosure?: GraphCacheResolver<WithTypename<Variable_Speed_Drives>, Record<string, never>, Scalars['String'] | string>,
    id?: GraphCacheResolver<WithTypename<Variable_Speed_Drives>, Record<string, never>, Scalars['uuid'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Variable_Speed_Drives>, Record<string, never>, Scalars['Int'] | string>,
    include_ecopetrol_timestamp?: GraphCacheResolver<WithTypename<Variable_Speed_Drives>, Record<string, never>, Scalars['timestamptz'] | string>,
    include_koc_timestamp?: GraphCacheResolver<WithTypename<Variable_Speed_Drives>, Record<string, never>, Scalars['timestamptz'] | string>,
    kva?: GraphCacheResolver<WithTypename<Variable_Speed_Drives>, Record<string, never>, Scalars['Int'] | string>,
    manufacturer?: GraphCacheResolver<WithTypename<Variable_Speed_Drives>, Record<string, never>, Scalars['String'] | string>,
    max_amps?: GraphCacheResolver<WithTypename<Variable_Speed_Drives>, Record<string, never>, Scalars['Int'] | string>,
    only_ecopetrol_timestamp?: GraphCacheResolver<WithTypename<Variable_Speed_Drives>, Record<string, never>, Scalars['timestamptz'] | string>,
    only_koc_timestamp?: GraphCacheResolver<WithTypename<Variable_Speed_Drives>, Record<string, never>, Scalars['timestamptz'] | string>,
    part_number?: GraphCacheResolver<WithTypename<Variable_Speed_Drives>, Record<string, never>, Scalars['String'] | string>,
    prioritized_manufacturer?: GraphCacheResolver<WithTypename<Variable_Speed_Drives>, Record<string, never>, Scalars['String'] | string>,
    sizing_import?: GraphCacheResolver<WithTypename<Variable_Speed_Drives>, Record<string, never>, WithTypename<Sizing_Imports> | string>,
    updated_at?: GraphCacheResolver<WithTypename<Variable_Speed_Drives>, Record<string, never>, Scalars['timestamptz'] | string>,
    user?: GraphCacheResolver<WithTypename<Variable_Speed_Drives>, Record<string, never>, WithTypename<Users> | string>,
    vsd_type?: GraphCacheResolver<WithTypename<Variable_Speed_Drives>, Record<string, never>, Scalars['String'] | string>
  },
  variable_speed_drives_aggregate?: {
    aggregate?: GraphCacheResolver<WithTypename<Variable_Speed_Drives_Aggregate>, Record<string, never>, WithTypename<Variable_Speed_Drives_Aggregate_Fields> | string>,
    nodes?: GraphCacheResolver<WithTypename<Variable_Speed_Drives_Aggregate>, Record<string, never>, Array<WithTypename<Variable_Speed_Drives> | string>>
  },
  variable_speed_drives_aggregate_fields?: {
    avg?: GraphCacheResolver<WithTypename<Variable_Speed_Drives_Aggregate_Fields>, Record<string, never>, WithTypename<Variable_Speed_Drives_Avg_Fields> | string>,
    count?: GraphCacheResolver<WithTypename<Variable_Speed_Drives_Aggregate_Fields>, Variable_Speed_Drives_Aggregate_FieldsCountArgs, Scalars['Int'] | string>,
    max?: GraphCacheResolver<WithTypename<Variable_Speed_Drives_Aggregate_Fields>, Record<string, never>, WithTypename<Variable_Speed_Drives_Max_Fields> | string>,
    min?: GraphCacheResolver<WithTypename<Variable_Speed_Drives_Aggregate_Fields>, Record<string, never>, WithTypename<Variable_Speed_Drives_Min_Fields> | string>,
    stddev?: GraphCacheResolver<WithTypename<Variable_Speed_Drives_Aggregate_Fields>, Record<string, never>, WithTypename<Variable_Speed_Drives_Stddev_Fields> | string>,
    stddev_pop?: GraphCacheResolver<WithTypename<Variable_Speed_Drives_Aggregate_Fields>, Record<string, never>, WithTypename<Variable_Speed_Drives_Stddev_Pop_Fields> | string>,
    stddev_samp?: GraphCacheResolver<WithTypename<Variable_Speed_Drives_Aggregate_Fields>, Record<string, never>, WithTypename<Variable_Speed_Drives_Stddev_Samp_Fields> | string>,
    sum?: GraphCacheResolver<WithTypename<Variable_Speed_Drives_Aggregate_Fields>, Record<string, never>, WithTypename<Variable_Speed_Drives_Sum_Fields> | string>,
    var_pop?: GraphCacheResolver<WithTypename<Variable_Speed_Drives_Aggregate_Fields>, Record<string, never>, WithTypename<Variable_Speed_Drives_Var_Pop_Fields> | string>,
    var_samp?: GraphCacheResolver<WithTypename<Variable_Speed_Drives_Aggregate_Fields>, Record<string, never>, WithTypename<Variable_Speed_Drives_Var_Samp_Fields> | string>,
    variance?: GraphCacheResolver<WithTypename<Variable_Speed_Drives_Aggregate_Fields>, Record<string, never>, WithTypename<Variable_Speed_Drives_Variance_Fields> | string>
  },
  variable_speed_drives_avg_fields?: {
    imported_sizing_id?: GraphCacheResolver<WithTypename<Variable_Speed_Drives_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    kva?: GraphCacheResolver<WithTypename<Variable_Speed_Drives_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    max_amps?: GraphCacheResolver<WithTypename<Variable_Speed_Drives_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  variable_speed_drives_max_fields?: {
    author_id?: GraphCacheResolver<WithTypename<Variable_Speed_Drives_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Variable_Speed_Drives_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Variable_Speed_Drives_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    enclosure?: GraphCacheResolver<WithTypename<Variable_Speed_Drives_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    id?: GraphCacheResolver<WithTypename<Variable_Speed_Drives_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Variable_Speed_Drives_Max_Fields>, Record<string, never>, Scalars['Int'] | string>,
    include_ecopetrol_timestamp?: GraphCacheResolver<WithTypename<Variable_Speed_Drives_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    include_koc_timestamp?: GraphCacheResolver<WithTypename<Variable_Speed_Drives_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    kva?: GraphCacheResolver<WithTypename<Variable_Speed_Drives_Max_Fields>, Record<string, never>, Scalars['Int'] | string>,
    manufacturer?: GraphCacheResolver<WithTypename<Variable_Speed_Drives_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    max_amps?: GraphCacheResolver<WithTypename<Variable_Speed_Drives_Max_Fields>, Record<string, never>, Scalars['Int'] | string>,
    only_ecopetrol_timestamp?: GraphCacheResolver<WithTypename<Variable_Speed_Drives_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    only_koc_timestamp?: GraphCacheResolver<WithTypename<Variable_Speed_Drives_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    part_number?: GraphCacheResolver<WithTypename<Variable_Speed_Drives_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    prioritized_manufacturer?: GraphCacheResolver<WithTypename<Variable_Speed_Drives_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Variable_Speed_Drives_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    vsd_type?: GraphCacheResolver<WithTypename<Variable_Speed_Drives_Max_Fields>, Record<string, never>, Scalars['String'] | string>
  },
  variable_speed_drives_min_fields?: {
    author_id?: GraphCacheResolver<WithTypename<Variable_Speed_Drives_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Variable_Speed_Drives_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Variable_Speed_Drives_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    enclosure?: GraphCacheResolver<WithTypename<Variable_Speed_Drives_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    id?: GraphCacheResolver<WithTypename<Variable_Speed_Drives_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Variable_Speed_Drives_Min_Fields>, Record<string, never>, Scalars['Int'] | string>,
    include_ecopetrol_timestamp?: GraphCacheResolver<WithTypename<Variable_Speed_Drives_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    include_koc_timestamp?: GraphCacheResolver<WithTypename<Variable_Speed_Drives_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    kva?: GraphCacheResolver<WithTypename<Variable_Speed_Drives_Min_Fields>, Record<string, never>, Scalars['Int'] | string>,
    manufacturer?: GraphCacheResolver<WithTypename<Variable_Speed_Drives_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    max_amps?: GraphCacheResolver<WithTypename<Variable_Speed_Drives_Min_Fields>, Record<string, never>, Scalars['Int'] | string>,
    only_ecopetrol_timestamp?: GraphCacheResolver<WithTypename<Variable_Speed_Drives_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    only_koc_timestamp?: GraphCacheResolver<WithTypename<Variable_Speed_Drives_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    part_number?: GraphCacheResolver<WithTypename<Variable_Speed_Drives_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    prioritized_manufacturer?: GraphCacheResolver<WithTypename<Variable_Speed_Drives_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Variable_Speed_Drives_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    vsd_type?: GraphCacheResolver<WithTypename<Variable_Speed_Drives_Min_Fields>, Record<string, never>, Scalars['String'] | string>
  },
  variable_speed_drives_mutation_response?: {
    affected_rows?: GraphCacheResolver<WithTypename<Variable_Speed_Drives_Mutation_Response>, Record<string, never>, Scalars['Int'] | string>,
    returning?: GraphCacheResolver<WithTypename<Variable_Speed_Drives_Mutation_Response>, Record<string, never>, Array<WithTypename<Variable_Speed_Drives> | string>>
  },
  variable_speed_drives_stddev_fields?: {
    imported_sizing_id?: GraphCacheResolver<WithTypename<Variable_Speed_Drives_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    kva?: GraphCacheResolver<WithTypename<Variable_Speed_Drives_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    max_amps?: GraphCacheResolver<WithTypename<Variable_Speed_Drives_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  variable_speed_drives_stddev_pop_fields?: {
    imported_sizing_id?: GraphCacheResolver<WithTypename<Variable_Speed_Drives_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    kva?: GraphCacheResolver<WithTypename<Variable_Speed_Drives_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    max_amps?: GraphCacheResolver<WithTypename<Variable_Speed_Drives_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  variable_speed_drives_stddev_samp_fields?: {
    imported_sizing_id?: GraphCacheResolver<WithTypename<Variable_Speed_Drives_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    kva?: GraphCacheResolver<WithTypename<Variable_Speed_Drives_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    max_amps?: GraphCacheResolver<WithTypename<Variable_Speed_Drives_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  variable_speed_drives_sum_fields?: {
    imported_sizing_id?: GraphCacheResolver<WithTypename<Variable_Speed_Drives_Sum_Fields>, Record<string, never>, Scalars['Int'] | string>,
    kva?: GraphCacheResolver<WithTypename<Variable_Speed_Drives_Sum_Fields>, Record<string, never>, Scalars['Int'] | string>,
    max_amps?: GraphCacheResolver<WithTypename<Variable_Speed_Drives_Sum_Fields>, Record<string, never>, Scalars['Int'] | string>
  },
  variable_speed_drives_var_pop_fields?: {
    imported_sizing_id?: GraphCacheResolver<WithTypename<Variable_Speed_Drives_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    kva?: GraphCacheResolver<WithTypename<Variable_Speed_Drives_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    max_amps?: GraphCacheResolver<WithTypename<Variable_Speed_Drives_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  variable_speed_drives_var_samp_fields?: {
    imported_sizing_id?: GraphCacheResolver<WithTypename<Variable_Speed_Drives_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    kva?: GraphCacheResolver<WithTypename<Variable_Speed_Drives_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    max_amps?: GraphCacheResolver<WithTypename<Variable_Speed_Drives_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  variable_speed_drives_variance_fields?: {
    imported_sizing_id?: GraphCacheResolver<WithTypename<Variable_Speed_Drives_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    kva?: GraphCacheResolver<WithTypename<Variable_Speed_Drives_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    max_amps?: GraphCacheResolver<WithTypename<Variable_Speed_Drives_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  water_density_options?: {
    comment?: GraphCacheResolver<WithTypename<Water_Density_Options>, Record<string, never>, Scalars['String'] | string>,
    value?: GraphCacheResolver<WithTypename<Water_Density_Options>, Record<string, never>, Scalars['String'] | string>
  },
  water_density_options_aggregate?: {
    aggregate?: GraphCacheResolver<WithTypename<Water_Density_Options_Aggregate>, Record<string, never>, WithTypename<Water_Density_Options_Aggregate_Fields> | string>,
    nodes?: GraphCacheResolver<WithTypename<Water_Density_Options_Aggregate>, Record<string, never>, Array<WithTypename<Water_Density_Options> | string>>
  },
  water_density_options_aggregate_fields?: {
    count?: GraphCacheResolver<WithTypename<Water_Density_Options_Aggregate_Fields>, Water_Density_Options_Aggregate_FieldsCountArgs, Scalars['Int'] | string>,
    max?: GraphCacheResolver<WithTypename<Water_Density_Options_Aggregate_Fields>, Record<string, never>, WithTypename<Water_Density_Options_Max_Fields> | string>,
    min?: GraphCacheResolver<WithTypename<Water_Density_Options_Aggregate_Fields>, Record<string, never>, WithTypename<Water_Density_Options_Min_Fields> | string>
  },
  water_density_options_max_fields?: {
    comment?: GraphCacheResolver<WithTypename<Water_Density_Options_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    value?: GraphCacheResolver<WithTypename<Water_Density_Options_Max_Fields>, Record<string, never>, Scalars['String'] | string>
  },
  water_density_options_min_fields?: {
    comment?: GraphCacheResolver<WithTypename<Water_Density_Options_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    value?: GraphCacheResolver<WithTypename<Water_Density_Options_Min_Fields>, Record<string, never>, Scalars['String'] | string>
  },
  water_density_options_mutation_response?: {
    affected_rows?: GraphCacheResolver<WithTypename<Water_Density_Options_Mutation_Response>, Record<string, never>, Scalars['Int'] | string>,
    returning?: GraphCacheResolver<WithTypename<Water_Density_Options_Mutation_Response>, Record<string, never>, Array<WithTypename<Water_Density_Options> | string>>
  },
  water_solution_gas_options?: {
    comment?: GraphCacheResolver<WithTypename<Water_Solution_Gas_Options>, Record<string, never>, Scalars['String'] | string>,
    value?: GraphCacheResolver<WithTypename<Water_Solution_Gas_Options>, Record<string, never>, Scalars['String'] | string>
  },
  water_solution_gas_options_aggregate?: {
    aggregate?: GraphCacheResolver<WithTypename<Water_Solution_Gas_Options_Aggregate>, Record<string, never>, WithTypename<Water_Solution_Gas_Options_Aggregate_Fields> | string>,
    nodes?: GraphCacheResolver<WithTypename<Water_Solution_Gas_Options_Aggregate>, Record<string, never>, Array<WithTypename<Water_Solution_Gas_Options> | string>>
  },
  water_solution_gas_options_aggregate_fields?: {
    count?: GraphCacheResolver<WithTypename<Water_Solution_Gas_Options_Aggregate_Fields>, Water_Solution_Gas_Options_Aggregate_FieldsCountArgs, Scalars['Int'] | string>,
    max?: GraphCacheResolver<WithTypename<Water_Solution_Gas_Options_Aggregate_Fields>, Record<string, never>, WithTypename<Water_Solution_Gas_Options_Max_Fields> | string>,
    min?: GraphCacheResolver<WithTypename<Water_Solution_Gas_Options_Aggregate_Fields>, Record<string, never>, WithTypename<Water_Solution_Gas_Options_Min_Fields> | string>
  },
  water_solution_gas_options_max_fields?: {
    comment?: GraphCacheResolver<WithTypename<Water_Solution_Gas_Options_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    value?: GraphCacheResolver<WithTypename<Water_Solution_Gas_Options_Max_Fields>, Record<string, never>, Scalars['String'] | string>
  },
  water_solution_gas_options_min_fields?: {
    comment?: GraphCacheResolver<WithTypename<Water_Solution_Gas_Options_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    value?: GraphCacheResolver<WithTypename<Water_Solution_Gas_Options_Min_Fields>, Record<string, never>, Scalars['String'] | string>
  },
  water_solution_gas_options_mutation_response?: {
    affected_rows?: GraphCacheResolver<WithTypename<Water_Solution_Gas_Options_Mutation_Response>, Record<string, never>, Scalars['Int'] | string>,
    returning?: GraphCacheResolver<WithTypename<Water_Solution_Gas_Options_Mutation_Response>, Record<string, never>, Array<WithTypename<Water_Solution_Gas_Options> | string>>
  },
  water_viscosity_options?: {
    comment?: GraphCacheResolver<WithTypename<Water_Viscosity_Options>, Record<string, never>, Scalars['String'] | string>,
    value?: GraphCacheResolver<WithTypename<Water_Viscosity_Options>, Record<string, never>, Scalars['String'] | string>
  },
  water_viscosity_options_aggregate?: {
    aggregate?: GraphCacheResolver<WithTypename<Water_Viscosity_Options_Aggregate>, Record<string, never>, WithTypename<Water_Viscosity_Options_Aggregate_Fields> | string>,
    nodes?: GraphCacheResolver<WithTypename<Water_Viscosity_Options_Aggregate>, Record<string, never>, Array<WithTypename<Water_Viscosity_Options> | string>>
  },
  water_viscosity_options_aggregate_fields?: {
    count?: GraphCacheResolver<WithTypename<Water_Viscosity_Options_Aggregate_Fields>, Water_Viscosity_Options_Aggregate_FieldsCountArgs, Scalars['Int'] | string>,
    max?: GraphCacheResolver<WithTypename<Water_Viscosity_Options_Aggregate_Fields>, Record<string, never>, WithTypename<Water_Viscosity_Options_Max_Fields> | string>,
    min?: GraphCacheResolver<WithTypename<Water_Viscosity_Options_Aggregate_Fields>, Record<string, never>, WithTypename<Water_Viscosity_Options_Min_Fields> | string>
  },
  water_viscosity_options_max_fields?: {
    comment?: GraphCacheResolver<WithTypename<Water_Viscosity_Options_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    value?: GraphCacheResolver<WithTypename<Water_Viscosity_Options_Max_Fields>, Record<string, never>, Scalars['String'] | string>
  },
  water_viscosity_options_min_fields?: {
    comment?: GraphCacheResolver<WithTypename<Water_Viscosity_Options_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    value?: GraphCacheResolver<WithTypename<Water_Viscosity_Options_Min_Fields>, Record<string, never>, Scalars['String'] | string>
  },
  water_viscosity_options_mutation_response?: {
    affected_rows?: GraphCacheResolver<WithTypename<Water_Viscosity_Options_Mutation_Response>, Record<string, never>, Scalars['Int'] | string>,
    returning?: GraphCacheResolver<WithTypename<Water_Viscosity_Options_Mutation_Response>, Record<string, never>, Array<WithTypename<Water_Viscosity_Options> | string>>
  },
  water_volume_factor_options?: {
    comment?: GraphCacheResolver<WithTypename<Water_Volume_Factor_Options>, Record<string, never>, Scalars['String'] | string>,
    value?: GraphCacheResolver<WithTypename<Water_Volume_Factor_Options>, Record<string, never>, Scalars['String'] | string>
  },
  water_volume_factor_options_aggregate?: {
    aggregate?: GraphCacheResolver<WithTypename<Water_Volume_Factor_Options_Aggregate>, Record<string, never>, WithTypename<Water_Volume_Factor_Options_Aggregate_Fields> | string>,
    nodes?: GraphCacheResolver<WithTypename<Water_Volume_Factor_Options_Aggregate>, Record<string, never>, Array<WithTypename<Water_Volume_Factor_Options> | string>>
  },
  water_volume_factor_options_aggregate_fields?: {
    count?: GraphCacheResolver<WithTypename<Water_Volume_Factor_Options_Aggregate_Fields>, Water_Volume_Factor_Options_Aggregate_FieldsCountArgs, Scalars['Int'] | string>,
    max?: GraphCacheResolver<WithTypename<Water_Volume_Factor_Options_Aggregate_Fields>, Record<string, never>, WithTypename<Water_Volume_Factor_Options_Max_Fields> | string>,
    min?: GraphCacheResolver<WithTypename<Water_Volume_Factor_Options_Aggregate_Fields>, Record<string, never>, WithTypename<Water_Volume_Factor_Options_Min_Fields> | string>
  },
  water_volume_factor_options_max_fields?: {
    comment?: GraphCacheResolver<WithTypename<Water_Volume_Factor_Options_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    value?: GraphCacheResolver<WithTypename<Water_Volume_Factor_Options_Max_Fields>, Record<string, never>, Scalars['String'] | string>
  },
  water_volume_factor_options_min_fields?: {
    comment?: GraphCacheResolver<WithTypename<Water_Volume_Factor_Options_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    value?: GraphCacheResolver<WithTypename<Water_Volume_Factor_Options_Min_Fields>, Record<string, never>, Scalars['String'] | string>
  },
  water_volume_factor_options_mutation_response?: {
    affected_rows?: GraphCacheResolver<WithTypename<Water_Volume_Factor_Options_Mutation_Response>, Record<string, never>, Scalars['Int'] | string>,
    returning?: GraphCacheResolver<WithTypename<Water_Volume_Factor_Options_Mutation_Response>, Record<string, never>, Array<WithTypename<Water_Volume_Factor_Options> | string>>
  },
  well_gas_type_options?: {
    comment?: GraphCacheResolver<WithTypename<Well_Gas_Type_Options>, Record<string, never>, Scalars['String'] | string>,
    value?: GraphCacheResolver<WithTypename<Well_Gas_Type_Options>, Record<string, never>, Scalars['String'] | string>
  },
  well_gas_type_options_aggregate?: {
    aggregate?: GraphCacheResolver<WithTypename<Well_Gas_Type_Options_Aggregate>, Record<string, never>, WithTypename<Well_Gas_Type_Options_Aggregate_Fields> | string>,
    nodes?: GraphCacheResolver<WithTypename<Well_Gas_Type_Options_Aggregate>, Record<string, never>, Array<WithTypename<Well_Gas_Type_Options> | string>>
  },
  well_gas_type_options_aggregate_fields?: {
    count?: GraphCacheResolver<WithTypename<Well_Gas_Type_Options_Aggregate_Fields>, Well_Gas_Type_Options_Aggregate_FieldsCountArgs, Scalars['Int'] | string>,
    max?: GraphCacheResolver<WithTypename<Well_Gas_Type_Options_Aggregate_Fields>, Record<string, never>, WithTypename<Well_Gas_Type_Options_Max_Fields> | string>,
    min?: GraphCacheResolver<WithTypename<Well_Gas_Type_Options_Aggregate_Fields>, Record<string, never>, WithTypename<Well_Gas_Type_Options_Min_Fields> | string>
  },
  well_gas_type_options_max_fields?: {
    comment?: GraphCacheResolver<WithTypename<Well_Gas_Type_Options_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    value?: GraphCacheResolver<WithTypename<Well_Gas_Type_Options_Max_Fields>, Record<string, never>, Scalars['String'] | string>
  },
  well_gas_type_options_min_fields?: {
    comment?: GraphCacheResolver<WithTypename<Well_Gas_Type_Options_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    value?: GraphCacheResolver<WithTypename<Well_Gas_Type_Options_Min_Fields>, Record<string, never>, Scalars['String'] | string>
  },
  well_gas_type_options_mutation_response?: {
    affected_rows?: GraphCacheResolver<WithTypename<Well_Gas_Type_Options_Mutation_Response>, Record<string, never>, Scalars['Int'] | string>,
    returning?: GraphCacheResolver<WithTypename<Well_Gas_Type_Options_Mutation_Response>, Record<string, never>, Array<WithTypename<Well_Gas_Type_Options> | string>>
  },
  well_test_gas_input_options?: {
    comment?: GraphCacheResolver<WithTypename<Well_Test_Gas_Input_Options>, Record<string, never>, Scalars['String'] | string>,
    value?: GraphCacheResolver<WithTypename<Well_Test_Gas_Input_Options>, Record<string, never>, Scalars['String'] | string>
  },
  well_test_gas_input_options_aggregate?: {
    aggregate?: GraphCacheResolver<WithTypename<Well_Test_Gas_Input_Options_Aggregate>, Record<string, never>, WithTypename<Well_Test_Gas_Input_Options_Aggregate_Fields> | string>,
    nodes?: GraphCacheResolver<WithTypename<Well_Test_Gas_Input_Options_Aggregate>, Record<string, never>, Array<WithTypename<Well_Test_Gas_Input_Options> | string>>
  },
  well_test_gas_input_options_aggregate_fields?: {
    count?: GraphCacheResolver<WithTypename<Well_Test_Gas_Input_Options_Aggregate_Fields>, Well_Test_Gas_Input_Options_Aggregate_FieldsCountArgs, Scalars['Int'] | string>,
    max?: GraphCacheResolver<WithTypename<Well_Test_Gas_Input_Options_Aggregate_Fields>, Record<string, never>, WithTypename<Well_Test_Gas_Input_Options_Max_Fields> | string>,
    min?: GraphCacheResolver<WithTypename<Well_Test_Gas_Input_Options_Aggregate_Fields>, Record<string, never>, WithTypename<Well_Test_Gas_Input_Options_Min_Fields> | string>
  },
  well_test_gas_input_options_max_fields?: {
    comment?: GraphCacheResolver<WithTypename<Well_Test_Gas_Input_Options_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    value?: GraphCacheResolver<WithTypename<Well_Test_Gas_Input_Options_Max_Fields>, Record<string, never>, Scalars['String'] | string>
  },
  well_test_gas_input_options_min_fields?: {
    comment?: GraphCacheResolver<WithTypename<Well_Test_Gas_Input_Options_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    value?: GraphCacheResolver<WithTypename<Well_Test_Gas_Input_Options_Min_Fields>, Record<string, never>, Scalars['String'] | string>
  },
  well_test_gas_input_options_mutation_response?: {
    affected_rows?: GraphCacheResolver<WithTypename<Well_Test_Gas_Input_Options_Mutation_Response>, Record<string, never>, Scalars['Int'] | string>,
    returning?: GraphCacheResolver<WithTypename<Well_Test_Gas_Input_Options_Mutation_Response>, Record<string, never>, Array<WithTypename<Well_Test_Gas_Input_Options> | string>>
  },
  well_test_liquid_input_options?: {
    comment?: GraphCacheResolver<WithTypename<Well_Test_Liquid_Input_Options>, Record<string, never>, Scalars['String'] | string>,
    value?: GraphCacheResolver<WithTypename<Well_Test_Liquid_Input_Options>, Record<string, never>, Scalars['String'] | string>
  },
  well_test_liquid_input_options_aggregate?: {
    aggregate?: GraphCacheResolver<WithTypename<Well_Test_Liquid_Input_Options_Aggregate>, Record<string, never>, WithTypename<Well_Test_Liquid_Input_Options_Aggregate_Fields> | string>,
    nodes?: GraphCacheResolver<WithTypename<Well_Test_Liquid_Input_Options_Aggregate>, Record<string, never>, Array<WithTypename<Well_Test_Liquid_Input_Options> | string>>
  },
  well_test_liquid_input_options_aggregate_fields?: {
    count?: GraphCacheResolver<WithTypename<Well_Test_Liquid_Input_Options_Aggregate_Fields>, Well_Test_Liquid_Input_Options_Aggregate_FieldsCountArgs, Scalars['Int'] | string>,
    max?: GraphCacheResolver<WithTypename<Well_Test_Liquid_Input_Options_Aggregate_Fields>, Record<string, never>, WithTypename<Well_Test_Liquid_Input_Options_Max_Fields> | string>,
    min?: GraphCacheResolver<WithTypename<Well_Test_Liquid_Input_Options_Aggregate_Fields>, Record<string, never>, WithTypename<Well_Test_Liquid_Input_Options_Min_Fields> | string>
  },
  well_test_liquid_input_options_max_fields?: {
    comment?: GraphCacheResolver<WithTypename<Well_Test_Liquid_Input_Options_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    value?: GraphCacheResolver<WithTypename<Well_Test_Liquid_Input_Options_Max_Fields>, Record<string, never>, Scalars['String'] | string>
  },
  well_test_liquid_input_options_min_fields?: {
    comment?: GraphCacheResolver<WithTypename<Well_Test_Liquid_Input_Options_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    value?: GraphCacheResolver<WithTypename<Well_Test_Liquid_Input_Options_Min_Fields>, Record<string, never>, Scalars['String'] | string>
  },
  well_test_liquid_input_options_mutation_response?: {
    affected_rows?: GraphCacheResolver<WithTypename<Well_Test_Liquid_Input_Options_Mutation_Response>, Record<string, never>, Scalars['Int'] | string>,
    returning?: GraphCacheResolver<WithTypename<Well_Test_Liquid_Input_Options_Mutation_Response>, Record<string, never>, Array<WithTypename<Well_Test_Liquid_Input_Options> | string>>
  },
  well_test_pressure_input_options?: {
    comment?: GraphCacheResolver<WithTypename<Well_Test_Pressure_Input_Options>, Record<string, never>, Scalars['String'] | string>,
    value?: GraphCacheResolver<WithTypename<Well_Test_Pressure_Input_Options>, Record<string, never>, Scalars['String'] | string>
  },
  well_test_pressure_input_options_aggregate?: {
    aggregate?: GraphCacheResolver<WithTypename<Well_Test_Pressure_Input_Options_Aggregate>, Record<string, never>, WithTypename<Well_Test_Pressure_Input_Options_Aggregate_Fields> | string>,
    nodes?: GraphCacheResolver<WithTypename<Well_Test_Pressure_Input_Options_Aggregate>, Record<string, never>, Array<WithTypename<Well_Test_Pressure_Input_Options> | string>>
  },
  well_test_pressure_input_options_aggregate_fields?: {
    count?: GraphCacheResolver<WithTypename<Well_Test_Pressure_Input_Options_Aggregate_Fields>, Well_Test_Pressure_Input_Options_Aggregate_FieldsCountArgs, Scalars['Int'] | string>,
    max?: GraphCacheResolver<WithTypename<Well_Test_Pressure_Input_Options_Aggregate_Fields>, Record<string, never>, WithTypename<Well_Test_Pressure_Input_Options_Max_Fields> | string>,
    min?: GraphCacheResolver<WithTypename<Well_Test_Pressure_Input_Options_Aggregate_Fields>, Record<string, never>, WithTypename<Well_Test_Pressure_Input_Options_Min_Fields> | string>
  },
  well_test_pressure_input_options_max_fields?: {
    comment?: GraphCacheResolver<WithTypename<Well_Test_Pressure_Input_Options_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    value?: GraphCacheResolver<WithTypename<Well_Test_Pressure_Input_Options_Max_Fields>, Record<string, never>, Scalars['String'] | string>
  },
  well_test_pressure_input_options_min_fields?: {
    comment?: GraphCacheResolver<WithTypename<Well_Test_Pressure_Input_Options_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    value?: GraphCacheResolver<WithTypename<Well_Test_Pressure_Input_Options_Min_Fields>, Record<string, never>, Scalars['String'] | string>
  },
  well_test_pressure_input_options_mutation_response?: {
    affected_rows?: GraphCacheResolver<WithTypename<Well_Test_Pressure_Input_Options_Mutation_Response>, Record<string, never>, Scalars['Int'] | string>,
    returning?: GraphCacheResolver<WithTypename<Well_Test_Pressure_Input_Options_Mutation_Response>, Record<string, never>, Array<WithTypename<Well_Test_Pressure_Input_Options> | string>>
  },
  wells?: {
    address_erp_id?: GraphCacheResolver<WithTypename<Wells>, Record<string, never>, Scalars['String'] | string>,
    erp_well_address_slug?: GraphCacheResolver<WithTypename<Wells>, Record<string, never>, Scalars['String'] | string>,
    id?: GraphCacheResolver<WithTypename<Wells>, Record<string, never>, Scalars['Int'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Wells>, Record<string, never>, Scalars['Int'] | string>,
    sizing_import?: GraphCacheResolver<WithTypename<Wells>, Record<string, never>, WithTypename<Sizing_Imports> | string>,
    sizings?: GraphCacheResolver<WithTypename<Wells>, WellsSizingsArgs, Array<WithTypename<Sizings> | string>>,
    sizings_aggregate?: GraphCacheResolver<WithTypename<Wells>, WellsSizings_AggregateArgs, WithTypename<Sizings_Aggregate> | string>,
    well_erp_id?: GraphCacheResolver<WithTypename<Wells>, Record<string, never>, Scalars['String'] | string>,
    well_name?: GraphCacheResolver<WithTypename<Wells>, Record<string, never>, Scalars['String'] | string>,
    well_uwi?: GraphCacheResolver<WithTypename<Wells>, Record<string, never>, Scalars['String'] | string>
  },
  wells_aggregate?: {
    aggregate?: GraphCacheResolver<WithTypename<Wells_Aggregate>, Record<string, never>, WithTypename<Wells_Aggregate_Fields> | string>,
    nodes?: GraphCacheResolver<WithTypename<Wells_Aggregate>, Record<string, never>, Array<WithTypename<Wells> | string>>
  },
  wells_aggregate_fields?: {
    avg?: GraphCacheResolver<WithTypename<Wells_Aggregate_Fields>, Record<string, never>, WithTypename<Wells_Avg_Fields> | string>,
    count?: GraphCacheResolver<WithTypename<Wells_Aggregate_Fields>, Wells_Aggregate_FieldsCountArgs, Scalars['Int'] | string>,
    max?: GraphCacheResolver<WithTypename<Wells_Aggregate_Fields>, Record<string, never>, WithTypename<Wells_Max_Fields> | string>,
    min?: GraphCacheResolver<WithTypename<Wells_Aggregate_Fields>, Record<string, never>, WithTypename<Wells_Min_Fields> | string>,
    stddev?: GraphCacheResolver<WithTypename<Wells_Aggregate_Fields>, Record<string, never>, WithTypename<Wells_Stddev_Fields> | string>,
    stddev_pop?: GraphCacheResolver<WithTypename<Wells_Aggregate_Fields>, Record<string, never>, WithTypename<Wells_Stddev_Pop_Fields> | string>,
    stddev_samp?: GraphCacheResolver<WithTypename<Wells_Aggregate_Fields>, Record<string, never>, WithTypename<Wells_Stddev_Samp_Fields> | string>,
    sum?: GraphCacheResolver<WithTypename<Wells_Aggregate_Fields>, Record<string, never>, WithTypename<Wells_Sum_Fields> | string>,
    var_pop?: GraphCacheResolver<WithTypename<Wells_Aggregate_Fields>, Record<string, never>, WithTypename<Wells_Var_Pop_Fields> | string>,
    var_samp?: GraphCacheResolver<WithTypename<Wells_Aggregate_Fields>, Record<string, never>, WithTypename<Wells_Var_Samp_Fields> | string>,
    variance?: GraphCacheResolver<WithTypename<Wells_Aggregate_Fields>, Record<string, never>, WithTypename<Wells_Variance_Fields> | string>
  },
  wells_avg_fields?: {
    id?: GraphCacheResolver<WithTypename<Wells_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Wells_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  wells_max_fields?: {
    address_erp_id?: GraphCacheResolver<WithTypename<Wells_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    erp_well_address_slug?: GraphCacheResolver<WithTypename<Wells_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    id?: GraphCacheResolver<WithTypename<Wells_Max_Fields>, Record<string, never>, Scalars['Int'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Wells_Max_Fields>, Record<string, never>, Scalars['Int'] | string>,
    well_erp_id?: GraphCacheResolver<WithTypename<Wells_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    well_name?: GraphCacheResolver<WithTypename<Wells_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    well_uwi?: GraphCacheResolver<WithTypename<Wells_Max_Fields>, Record<string, never>, Scalars['String'] | string>
  },
  wells_min_fields?: {
    address_erp_id?: GraphCacheResolver<WithTypename<Wells_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    erp_well_address_slug?: GraphCacheResolver<WithTypename<Wells_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    id?: GraphCacheResolver<WithTypename<Wells_Min_Fields>, Record<string, never>, Scalars['Int'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Wells_Min_Fields>, Record<string, never>, Scalars['Int'] | string>,
    well_erp_id?: GraphCacheResolver<WithTypename<Wells_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    well_name?: GraphCacheResolver<WithTypename<Wells_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    well_uwi?: GraphCacheResolver<WithTypename<Wells_Min_Fields>, Record<string, never>, Scalars['String'] | string>
  },
  wells_mutation_response?: {
    affected_rows?: GraphCacheResolver<WithTypename<Wells_Mutation_Response>, Record<string, never>, Scalars['Int'] | string>,
    returning?: GraphCacheResolver<WithTypename<Wells_Mutation_Response>, Record<string, never>, Array<WithTypename<Wells> | string>>
  },
  wells_stddev_fields?: {
    id?: GraphCacheResolver<WithTypename<Wells_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Wells_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  wells_stddev_pop_fields?: {
    id?: GraphCacheResolver<WithTypename<Wells_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Wells_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  wells_stddev_samp_fields?: {
    id?: GraphCacheResolver<WithTypename<Wells_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Wells_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  wells_sum_fields?: {
    id?: GraphCacheResolver<WithTypename<Wells_Sum_Fields>, Record<string, never>, Scalars['Int'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Wells_Sum_Fields>, Record<string, never>, Scalars['Int'] | string>
  },
  wells_var_pop_fields?: {
    id?: GraphCacheResolver<WithTypename<Wells_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Wells_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  wells_var_samp_fields?: {
    id?: GraphCacheResolver<WithTypename<Wells_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Wells_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  wells_variance_fields?: {
    id?: GraphCacheResolver<WithTypename<Wells_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    imported_sizing_id?: GraphCacheResolver<WithTypename<Wells_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  y_tools?: {
    author_id?: GraphCacheResolver<WithTypename<Y_Tools>, Record<string, never>, Scalars['String'] | string>,
    bypass_connection_inches?: GraphCacheResolver<WithTypename<Y_Tools>, Record<string, never>, Scalars['numeric'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Y_Tools>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Y_Tools>, Record<string, never>, Scalars['timestamptz'] | string>,
    downhole_scenario_equipment_revisions?: GraphCacheResolver<WithTypename<Y_Tools>, Y_ToolsDownhole_Scenario_Equipment_RevisionsArgs, Array<WithTypename<Revisions_Scenario_Equipment_Revisions> | string>>,
    downhole_scenario_equipment_revisions_aggregate?: GraphCacheResolver<WithTypename<Y_Tools>, Y_ToolsDownhole_Scenario_Equipment_Revisions_AggregateArgs, WithTypename<Revisions_Scenario_Equipment_Revisions_Aggregate> | string>,
    handling_sub_connection_inches?: GraphCacheResolver<WithTypename<Y_Tools>, Record<string, never>, Scalars['numeric'] | string>,
    id?: GraphCacheResolver<WithTypename<Y_Tools>, Record<string, never>, Scalars['uuid'] | string>,
    include_ecopetrol_timestamp?: GraphCacheResolver<WithTypename<Y_Tools>, Record<string, never>, Scalars['timestamptz'] | string>,
    include_koc_timestamp?: GraphCacheResolver<WithTypename<Y_Tools>, Record<string, never>, Scalars['timestamptz'] | string>,
    length_inches?: GraphCacheResolver<WithTypename<Y_Tools>, Record<string, never>, Scalars['numeric'] | string>,
    manufacturer?: GraphCacheResolver<WithTypename<Y_Tools>, Record<string, never>, Scalars['String'] | string>,
    material_type?: GraphCacheResolver<WithTypename<Y_Tools>, Record<string, never>, Scalars['String'] | string>,
    maximum_inches?: GraphCacheResolver<WithTypename<Y_Tools>, Record<string, never>, Scalars['numeric'] | string>,
    minimum_inches?: GraphCacheResolver<WithTypename<Y_Tools>, Record<string, never>, Scalars['numeric'] | string>,
    only_ecopetrol_timestamp?: GraphCacheResolver<WithTypename<Y_Tools>, Record<string, never>, Scalars['timestamptz'] | string>,
    only_koc_timestamp?: GraphCacheResolver<WithTypename<Y_Tools>, Record<string, never>, Scalars['timestamptz'] | string>,
    outer_diameter_inches?: GraphCacheResolver<WithTypename<Y_Tools>, Record<string, never>, Scalars['numeric'] | string>,
    pressure_rating_psi?: GraphCacheResolver<WithTypename<Y_Tools>, Record<string, never>, Scalars['Int'] | string>,
    series_model?: GraphCacheResolver<WithTypename<Y_Tools>, Record<string, never>, Scalars['String'] | string>,
    teleswivel_stroke_length_inches?: GraphCacheResolver<WithTypename<Y_Tools>, Record<string, never>, Scalars['numeric'] | string>,
    temperature_rating_fahrenheit?: GraphCacheResolver<WithTypename<Y_Tools>, Record<string, never>, Scalars['Int'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Y_Tools>, Record<string, never>, Scalars['timestamptz'] | string>,
    uphole_scenario_equipment_revisions?: GraphCacheResolver<WithTypename<Y_Tools>, Y_ToolsUphole_Scenario_Equipment_RevisionsArgs, Array<WithTypename<Revisions_Scenario_Equipment_Revisions> | string>>,
    uphole_scenario_equipment_revisions_aggregate?: GraphCacheResolver<WithTypename<Y_Tools>, Y_ToolsUphole_Scenario_Equipment_Revisions_AggregateArgs, WithTypename<Revisions_Scenario_Equipment_Revisions_Aggregate> | string>,
    user?: GraphCacheResolver<WithTypename<Y_Tools>, Record<string, never>, WithTypename<Users> | string>,
    weight_pounds?: GraphCacheResolver<WithTypename<Y_Tools>, Record<string, never>, Scalars['numeric'] | string>,
    width_inches?: GraphCacheResolver<WithTypename<Y_Tools>, Record<string, never>, Scalars['numeric'] | string>
  },
  y_tools_aggregate?: {
    aggregate?: GraphCacheResolver<WithTypename<Y_Tools_Aggregate>, Record<string, never>, WithTypename<Y_Tools_Aggregate_Fields> | string>,
    nodes?: GraphCacheResolver<WithTypename<Y_Tools_Aggregate>, Record<string, never>, Array<WithTypename<Y_Tools> | string>>
  },
  y_tools_aggregate_fields?: {
    avg?: GraphCacheResolver<WithTypename<Y_Tools_Aggregate_Fields>, Record<string, never>, WithTypename<Y_Tools_Avg_Fields> | string>,
    count?: GraphCacheResolver<WithTypename<Y_Tools_Aggregate_Fields>, Y_Tools_Aggregate_FieldsCountArgs, Scalars['Int'] | string>,
    max?: GraphCacheResolver<WithTypename<Y_Tools_Aggregate_Fields>, Record<string, never>, WithTypename<Y_Tools_Max_Fields> | string>,
    min?: GraphCacheResolver<WithTypename<Y_Tools_Aggregate_Fields>, Record<string, never>, WithTypename<Y_Tools_Min_Fields> | string>,
    stddev?: GraphCacheResolver<WithTypename<Y_Tools_Aggregate_Fields>, Record<string, never>, WithTypename<Y_Tools_Stddev_Fields> | string>,
    stddev_pop?: GraphCacheResolver<WithTypename<Y_Tools_Aggregate_Fields>, Record<string, never>, WithTypename<Y_Tools_Stddev_Pop_Fields> | string>,
    stddev_samp?: GraphCacheResolver<WithTypename<Y_Tools_Aggregate_Fields>, Record<string, never>, WithTypename<Y_Tools_Stddev_Samp_Fields> | string>,
    sum?: GraphCacheResolver<WithTypename<Y_Tools_Aggregate_Fields>, Record<string, never>, WithTypename<Y_Tools_Sum_Fields> | string>,
    var_pop?: GraphCacheResolver<WithTypename<Y_Tools_Aggregate_Fields>, Record<string, never>, WithTypename<Y_Tools_Var_Pop_Fields> | string>,
    var_samp?: GraphCacheResolver<WithTypename<Y_Tools_Aggregate_Fields>, Record<string, never>, WithTypename<Y_Tools_Var_Samp_Fields> | string>,
    variance?: GraphCacheResolver<WithTypename<Y_Tools_Aggregate_Fields>, Record<string, never>, WithTypename<Y_Tools_Variance_Fields> | string>
  },
  y_tools_avg_fields?: {
    bypass_connection_inches?: GraphCacheResolver<WithTypename<Y_Tools_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    handling_sub_connection_inches?: GraphCacheResolver<WithTypename<Y_Tools_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    length_inches?: GraphCacheResolver<WithTypename<Y_Tools_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    maximum_inches?: GraphCacheResolver<WithTypename<Y_Tools_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    minimum_inches?: GraphCacheResolver<WithTypename<Y_Tools_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    outer_diameter_inches?: GraphCacheResolver<WithTypename<Y_Tools_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pressure_rating_psi?: GraphCacheResolver<WithTypename<Y_Tools_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    teleswivel_stroke_length_inches?: GraphCacheResolver<WithTypename<Y_Tools_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    temperature_rating_fahrenheit?: GraphCacheResolver<WithTypename<Y_Tools_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    weight_pounds?: GraphCacheResolver<WithTypename<Y_Tools_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    width_inches?: GraphCacheResolver<WithTypename<Y_Tools_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  y_tools_max_fields?: {
    author_id?: GraphCacheResolver<WithTypename<Y_Tools_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    bypass_connection_inches?: GraphCacheResolver<WithTypename<Y_Tools_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Y_Tools_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Y_Tools_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    handling_sub_connection_inches?: GraphCacheResolver<WithTypename<Y_Tools_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    id?: GraphCacheResolver<WithTypename<Y_Tools_Max_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    include_ecopetrol_timestamp?: GraphCacheResolver<WithTypename<Y_Tools_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    include_koc_timestamp?: GraphCacheResolver<WithTypename<Y_Tools_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    length_inches?: GraphCacheResolver<WithTypename<Y_Tools_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    manufacturer?: GraphCacheResolver<WithTypename<Y_Tools_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    material_type?: GraphCacheResolver<WithTypename<Y_Tools_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    maximum_inches?: GraphCacheResolver<WithTypename<Y_Tools_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    minimum_inches?: GraphCacheResolver<WithTypename<Y_Tools_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    only_ecopetrol_timestamp?: GraphCacheResolver<WithTypename<Y_Tools_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    only_koc_timestamp?: GraphCacheResolver<WithTypename<Y_Tools_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    outer_diameter_inches?: GraphCacheResolver<WithTypename<Y_Tools_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    pressure_rating_psi?: GraphCacheResolver<WithTypename<Y_Tools_Max_Fields>, Record<string, never>, Scalars['Int'] | string>,
    series_model?: GraphCacheResolver<WithTypename<Y_Tools_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    teleswivel_stroke_length_inches?: GraphCacheResolver<WithTypename<Y_Tools_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    temperature_rating_fahrenheit?: GraphCacheResolver<WithTypename<Y_Tools_Max_Fields>, Record<string, never>, Scalars['Int'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Y_Tools_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    weight_pounds?: GraphCacheResolver<WithTypename<Y_Tools_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    width_inches?: GraphCacheResolver<WithTypename<Y_Tools_Max_Fields>, Record<string, never>, Scalars['numeric'] | string>
  },
  y_tools_min_fields?: {
    author_id?: GraphCacheResolver<WithTypename<Y_Tools_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    bypass_connection_inches?: GraphCacheResolver<WithTypename<Y_Tools_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Y_Tools_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    deleted_at?: GraphCacheResolver<WithTypename<Y_Tools_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    handling_sub_connection_inches?: GraphCacheResolver<WithTypename<Y_Tools_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    id?: GraphCacheResolver<WithTypename<Y_Tools_Min_Fields>, Record<string, never>, Scalars['uuid'] | string>,
    include_ecopetrol_timestamp?: GraphCacheResolver<WithTypename<Y_Tools_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    include_koc_timestamp?: GraphCacheResolver<WithTypename<Y_Tools_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    length_inches?: GraphCacheResolver<WithTypename<Y_Tools_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    manufacturer?: GraphCacheResolver<WithTypename<Y_Tools_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    material_type?: GraphCacheResolver<WithTypename<Y_Tools_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    maximum_inches?: GraphCacheResolver<WithTypename<Y_Tools_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    minimum_inches?: GraphCacheResolver<WithTypename<Y_Tools_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    only_ecopetrol_timestamp?: GraphCacheResolver<WithTypename<Y_Tools_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    only_koc_timestamp?: GraphCacheResolver<WithTypename<Y_Tools_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    outer_diameter_inches?: GraphCacheResolver<WithTypename<Y_Tools_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    pressure_rating_psi?: GraphCacheResolver<WithTypename<Y_Tools_Min_Fields>, Record<string, never>, Scalars['Int'] | string>,
    series_model?: GraphCacheResolver<WithTypename<Y_Tools_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    teleswivel_stroke_length_inches?: GraphCacheResolver<WithTypename<Y_Tools_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    temperature_rating_fahrenheit?: GraphCacheResolver<WithTypename<Y_Tools_Min_Fields>, Record<string, never>, Scalars['Int'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Y_Tools_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    weight_pounds?: GraphCacheResolver<WithTypename<Y_Tools_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    width_inches?: GraphCacheResolver<WithTypename<Y_Tools_Min_Fields>, Record<string, never>, Scalars['numeric'] | string>
  },
  y_tools_mutation_response?: {
    affected_rows?: GraphCacheResolver<WithTypename<Y_Tools_Mutation_Response>, Record<string, never>, Scalars['Int'] | string>,
    returning?: GraphCacheResolver<WithTypename<Y_Tools_Mutation_Response>, Record<string, never>, Array<WithTypename<Y_Tools> | string>>
  },
  y_tools_stddev_fields?: {
    bypass_connection_inches?: GraphCacheResolver<WithTypename<Y_Tools_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    handling_sub_connection_inches?: GraphCacheResolver<WithTypename<Y_Tools_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    length_inches?: GraphCacheResolver<WithTypename<Y_Tools_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    maximum_inches?: GraphCacheResolver<WithTypename<Y_Tools_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    minimum_inches?: GraphCacheResolver<WithTypename<Y_Tools_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    outer_diameter_inches?: GraphCacheResolver<WithTypename<Y_Tools_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pressure_rating_psi?: GraphCacheResolver<WithTypename<Y_Tools_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    teleswivel_stroke_length_inches?: GraphCacheResolver<WithTypename<Y_Tools_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    temperature_rating_fahrenheit?: GraphCacheResolver<WithTypename<Y_Tools_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    weight_pounds?: GraphCacheResolver<WithTypename<Y_Tools_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    width_inches?: GraphCacheResolver<WithTypename<Y_Tools_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  y_tools_stddev_pop_fields?: {
    bypass_connection_inches?: GraphCacheResolver<WithTypename<Y_Tools_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    handling_sub_connection_inches?: GraphCacheResolver<WithTypename<Y_Tools_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    length_inches?: GraphCacheResolver<WithTypename<Y_Tools_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    maximum_inches?: GraphCacheResolver<WithTypename<Y_Tools_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    minimum_inches?: GraphCacheResolver<WithTypename<Y_Tools_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    outer_diameter_inches?: GraphCacheResolver<WithTypename<Y_Tools_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pressure_rating_psi?: GraphCacheResolver<WithTypename<Y_Tools_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    teleswivel_stroke_length_inches?: GraphCacheResolver<WithTypename<Y_Tools_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    temperature_rating_fahrenheit?: GraphCacheResolver<WithTypename<Y_Tools_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    weight_pounds?: GraphCacheResolver<WithTypename<Y_Tools_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    width_inches?: GraphCacheResolver<WithTypename<Y_Tools_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  y_tools_stddev_samp_fields?: {
    bypass_connection_inches?: GraphCacheResolver<WithTypename<Y_Tools_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    handling_sub_connection_inches?: GraphCacheResolver<WithTypename<Y_Tools_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    length_inches?: GraphCacheResolver<WithTypename<Y_Tools_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    maximum_inches?: GraphCacheResolver<WithTypename<Y_Tools_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    minimum_inches?: GraphCacheResolver<WithTypename<Y_Tools_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    outer_diameter_inches?: GraphCacheResolver<WithTypename<Y_Tools_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pressure_rating_psi?: GraphCacheResolver<WithTypename<Y_Tools_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    teleswivel_stroke_length_inches?: GraphCacheResolver<WithTypename<Y_Tools_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    temperature_rating_fahrenheit?: GraphCacheResolver<WithTypename<Y_Tools_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    weight_pounds?: GraphCacheResolver<WithTypename<Y_Tools_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    width_inches?: GraphCacheResolver<WithTypename<Y_Tools_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  y_tools_sum_fields?: {
    bypass_connection_inches?: GraphCacheResolver<WithTypename<Y_Tools_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    handling_sub_connection_inches?: GraphCacheResolver<WithTypename<Y_Tools_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    length_inches?: GraphCacheResolver<WithTypename<Y_Tools_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    maximum_inches?: GraphCacheResolver<WithTypename<Y_Tools_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    minimum_inches?: GraphCacheResolver<WithTypename<Y_Tools_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    outer_diameter_inches?: GraphCacheResolver<WithTypename<Y_Tools_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    pressure_rating_psi?: GraphCacheResolver<WithTypename<Y_Tools_Sum_Fields>, Record<string, never>, Scalars['Int'] | string>,
    teleswivel_stroke_length_inches?: GraphCacheResolver<WithTypename<Y_Tools_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    temperature_rating_fahrenheit?: GraphCacheResolver<WithTypename<Y_Tools_Sum_Fields>, Record<string, never>, Scalars['Int'] | string>,
    weight_pounds?: GraphCacheResolver<WithTypename<Y_Tools_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>,
    width_inches?: GraphCacheResolver<WithTypename<Y_Tools_Sum_Fields>, Record<string, never>, Scalars['numeric'] | string>
  },
  y_tools_var_pop_fields?: {
    bypass_connection_inches?: GraphCacheResolver<WithTypename<Y_Tools_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    handling_sub_connection_inches?: GraphCacheResolver<WithTypename<Y_Tools_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    length_inches?: GraphCacheResolver<WithTypename<Y_Tools_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    maximum_inches?: GraphCacheResolver<WithTypename<Y_Tools_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    minimum_inches?: GraphCacheResolver<WithTypename<Y_Tools_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    outer_diameter_inches?: GraphCacheResolver<WithTypename<Y_Tools_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pressure_rating_psi?: GraphCacheResolver<WithTypename<Y_Tools_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    teleswivel_stroke_length_inches?: GraphCacheResolver<WithTypename<Y_Tools_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    temperature_rating_fahrenheit?: GraphCacheResolver<WithTypename<Y_Tools_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    weight_pounds?: GraphCacheResolver<WithTypename<Y_Tools_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    width_inches?: GraphCacheResolver<WithTypename<Y_Tools_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  y_tools_var_samp_fields?: {
    bypass_connection_inches?: GraphCacheResolver<WithTypename<Y_Tools_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    handling_sub_connection_inches?: GraphCacheResolver<WithTypename<Y_Tools_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    length_inches?: GraphCacheResolver<WithTypename<Y_Tools_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    maximum_inches?: GraphCacheResolver<WithTypename<Y_Tools_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    minimum_inches?: GraphCacheResolver<WithTypename<Y_Tools_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    outer_diameter_inches?: GraphCacheResolver<WithTypename<Y_Tools_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pressure_rating_psi?: GraphCacheResolver<WithTypename<Y_Tools_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    teleswivel_stroke_length_inches?: GraphCacheResolver<WithTypename<Y_Tools_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    temperature_rating_fahrenheit?: GraphCacheResolver<WithTypename<Y_Tools_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    weight_pounds?: GraphCacheResolver<WithTypename<Y_Tools_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    width_inches?: GraphCacheResolver<WithTypename<Y_Tools_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  y_tools_variance_fields?: {
    bypass_connection_inches?: GraphCacheResolver<WithTypename<Y_Tools_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    handling_sub_connection_inches?: GraphCacheResolver<WithTypename<Y_Tools_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    length_inches?: GraphCacheResolver<WithTypename<Y_Tools_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    maximum_inches?: GraphCacheResolver<WithTypename<Y_Tools_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    minimum_inches?: GraphCacheResolver<WithTypename<Y_Tools_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    outer_diameter_inches?: GraphCacheResolver<WithTypename<Y_Tools_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    pressure_rating_psi?: GraphCacheResolver<WithTypename<Y_Tools_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    teleswivel_stroke_length_inches?: GraphCacheResolver<WithTypename<Y_Tools_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    temperature_rating_fahrenheit?: GraphCacheResolver<WithTypename<Y_Tools_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    weight_pounds?: GraphCacheResolver<WithTypename<Y_Tools_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    width_inches?: GraphCacheResolver<WithTypename<Y_Tools_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>
  }
};

export type GraphCacheOptimisticUpdaters = {
  createSKJob?: GraphCacheOptimisticMutationResolver<Mutation_RootCreateSkJobArgs, Maybe<WithTypename<SkJob>>>,
  createSKQuote?: GraphCacheOptimisticMutationResolver<Mutation_RootCreateSkQuoteArgs, Maybe<WithTypename<SkQuote>>>,
  deleteSKQuote?: GraphCacheOptimisticMutationResolver<Mutation_RootDeleteSkQuoteArgs, Maybe<WithTypename<SkDeleteQuote>>>,
  delete_bolt_on_discharges?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Bolt_On_DischargesArgs, Maybe<WithTypename<Bolt_On_Discharges_Mutation_Response>>>,
  delete_bolt_on_discharges_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Bolt_On_Discharges_By_PkArgs, Maybe<WithTypename<Bolt_On_Discharges>>>,
  delete_bubble_point_options?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Bubble_Point_OptionsArgs, Maybe<WithTypename<Bubble_Point_Options_Mutation_Response>>>,
  delete_bubble_point_options_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Bubble_Point_Options_By_PkArgs, Maybe<WithTypename<Bubble_Point_Options>>>,
  delete_cables?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_CablesArgs, Maybe<WithTypename<Cables_Mutation_Response>>>,
  delete_cables_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Cables_By_PkArgs, Maybe<WithTypename<Cables>>>,
  delete_casing_flow_options?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Casing_Flow_OptionsArgs, Maybe<WithTypename<Casing_Flow_Options_Mutation_Response>>>,
  delete_casing_flow_options_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Casing_Flow_Options_By_PkArgs, Maybe<WithTypename<Casing_Flow_Options>>>,
  delete_casings?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_CasingsArgs, Maybe<WithTypename<Casings_Mutation_Response>>>,
  delete_casings_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Casings_By_PkArgs, Maybe<WithTypename<Casings>>>,
  delete_casings_type?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Casings_TypeArgs, Maybe<WithTypename<Casings_Type_Mutation_Response>>>,
  delete_casings_type_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Casings_Type_By_PkArgs, Maybe<WithTypename<Casings_Type>>>,
  delete_customers?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_CustomersArgs, Maybe<WithTypename<Customers_Mutation_Response>>>,
  delete_customers_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Customers_By_PkArgs, Maybe<WithTypename<Customers>>>,
  delete_dead_oil_options?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Dead_Oil_OptionsArgs, Maybe<WithTypename<Dead_Oil_Options_Mutation_Response>>>,
  delete_dead_oil_options_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Dead_Oil_Options_By_PkArgs, Maybe<WithTypename<Dead_Oil_Options>>>,
  delete_deviation_survey?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Deviation_SurveyArgs, Maybe<WithTypename<Deviation_Survey_Mutation_Response>>>,
  delete_deviation_survey_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Deviation_Survey_By_PkArgs, Maybe<WithTypename<Deviation_Survey>>>,
  delete_deviation_survey_directional_dataset?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Deviation_Survey_Directional_DatasetArgs, Maybe<WithTypename<Deviation_Survey_Directional_Dataset_Mutation_Response>>>,
  delete_deviation_survey_directional_dataset_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Deviation_Survey_Directional_Dataset_By_PkArgs, Maybe<WithTypename<Deviation_Survey_Directional_Dataset>>>,
  delete_display_units?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Display_UnitsArgs, Maybe<WithTypename<Display_Units_Mutation_Response>>>,
  delete_display_units_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Display_Units_By_PkArgs, Maybe<WithTypename<Display_Units>>>,
  delete_eula?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_EulaArgs, Maybe<WithTypename<Eula_Mutation_Response>>>,
  delete_eula_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Eula_By_PkArgs, Maybe<WithTypename<Eula>>>,
  delete_flow_model?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Flow_ModelArgs, Maybe<WithTypename<Flow_Model_Mutation_Response>>>,
  delete_flow_model_active?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Flow_Model_ActiveArgs, Maybe<WithTypename<Flow_Model_Active_Mutation_Response>>>,
  delete_flow_model_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Flow_Model_By_PkArgs, Maybe<WithTypename<Flow_Model>>>,
  delete_flow_model_deprecated?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Flow_Model_DeprecatedArgs, Maybe<WithTypename<Flow_Model_Deprecated_Mutation_Response>>>,
  delete_flow_model_deprecated_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Flow_Model_Deprecated_By_PkArgs, Maybe<WithTypename<Flow_Model_Deprecated>>>,
  delete_friction_loss_options?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Friction_Loss_OptionsArgs, Maybe<WithTypename<Friction_Loss_Options_Mutation_Response>>>,
  delete_friction_loss_options_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Friction_Loss_Options_By_PkArgs, Maybe<WithTypename<Friction_Loss_Options>>>,
  delete_gas_compressibility_options?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Gas_Compressibility_OptionsArgs, Maybe<WithTypename<Gas_Compressibility_Options_Mutation_Response>>>,
  delete_gas_compressibility_options_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Gas_Compressibility_Options_By_PkArgs, Maybe<WithTypename<Gas_Compressibility_Options>>>,
  delete_gas_viscosity_options?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Gas_Viscosity_OptionsArgs, Maybe<WithTypename<Gas_Viscosity_Options_Mutation_Response>>>,
  delete_gas_viscosity_options_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Gas_Viscosity_Options_By_PkArgs, Maybe<WithTypename<Gas_Viscosity_Options>>>,
  delete_housings?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_HousingsArgs, Maybe<WithTypename<Housings_Mutation_Response>>>,
  delete_housings_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Housings_By_PkArgs, Maybe<WithTypename<Housings>>>,
  delete_hps_liquid_type?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Hps_Liquid_TypeArgs, Maybe<WithTypename<Hps_Liquid_Type_Mutation_Response>>>,
  delete_hps_liquid_type_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Hps_Liquid_Type_By_PkArgs, Maybe<WithTypename<Hps_Liquid_Type>>>,
  delete_intakes?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_IntakesArgs, Maybe<WithTypename<Intakes_Mutation_Response>>>,
  delete_intakes_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Intakes_By_PkArgs, Maybe<WithTypename<Intakes>>>,
  delete_legacy_users?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Legacy_UsersArgs, Maybe<WithTypename<Legacy_Users_Mutation_Response>>>,
  delete_legacy_users_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Legacy_Users_By_PkArgs, Maybe<WithTypename<Legacy_Users>>>,
  delete_motor_lead_extensions?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Motor_Lead_ExtensionsArgs, Maybe<WithTypename<Motor_Lead_Extensions_Mutation_Response>>>,
  delete_motor_lead_extensions_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Motor_Lead_Extensions_By_PkArgs, Maybe<WithTypename<Motor_Lead_Extensions>>>,
  delete_motors?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_MotorsArgs, Maybe<WithTypename<Motors_Mutation_Response>>>,
  delete_motors_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Motors_By_PkArgs, Maybe<WithTypename<Motors>>>,
  delete_natural_gas_separation_options?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Natural_Gas_Separation_OptionsArgs, Maybe<WithTypename<Natural_Gas_Separation_Options_Mutation_Response>>>,
  delete_natural_gas_separation_options_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Natural_Gas_Separation_Options_By_PkArgs, Maybe<WithTypename<Natural_Gas_Separation_Options>>>,
  delete_oil_density_options?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Oil_Density_OptionsArgs, Maybe<WithTypename<Oil_Density_Options_Mutation_Response>>>,
  delete_oil_density_options_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Oil_Density_Options_By_PkArgs, Maybe<WithTypename<Oil_Density_Options>>>,
  delete_oil_volume_factor_options?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Oil_Volume_Factor_OptionsArgs, Maybe<WithTypename<Oil_Volume_Factor_Options_Mutation_Response>>>,
  delete_oil_volume_factor_options_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Oil_Volume_Factor_Options_By_PkArgs, Maybe<WithTypename<Oil_Volume_Factor_Options>>>,
  delete_override_options?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Override_OptionsArgs, Maybe<WithTypename<Override_Options_Mutation_Response>>>,
  delete_override_options_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Override_Options_By_PkArgs, Maybe<WithTypename<Override_Options>>>,
  delete_pumps?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_PumpsArgs, Maybe<WithTypename<Pumps_Mutation_Response>>>,
  delete_pumps_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Pumps_By_PkArgs, Maybe<WithTypename<Pumps>>>,
  delete_quote_line_item_category_dataset?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Quote_Line_Item_Category_DatasetArgs, Maybe<WithTypename<Quote_Line_Item_Category_Dataset_Mutation_Response>>>,
  delete_quote_line_item_category_dataset_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Quote_Line_Item_Category_Dataset_By_PkArgs, Maybe<WithTypename<Quote_Line_Item_Category_Dataset>>>,
  delete_quote_line_item_serialized_dataset?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Quote_Line_Item_Serialized_DatasetArgs, Maybe<WithTypename<Quote_Line_Item_Serialized_Dataset_Mutation_Response>>>,
  delete_quote_line_item_serialized_dataset_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Quote_Line_Item_Serialized_Dataset_By_PkArgs, Maybe<WithTypename<Quote_Line_Item_Serialized_Dataset>>>,
  delete_quote_line_item_source_dataset?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Quote_Line_Item_Source_DatasetArgs, Maybe<WithTypename<Quote_Line_Item_Source_Dataset_Mutation_Response>>>,
  delete_quote_line_item_source_dataset_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Quote_Line_Item_Source_Dataset_By_PkArgs, Maybe<WithTypename<Quote_Line_Item_Source_Dataset>>>,
  delete_quote_line_item_subcategory_dataset?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Quote_Line_Item_Subcategory_DatasetArgs, Maybe<WithTypename<Quote_Line_Item_Subcategory_Dataset_Mutation_Response>>>,
  delete_quote_line_item_subcategory_dataset_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Quote_Line_Item_Subcategory_Dataset_By_PkArgs, Maybe<WithTypename<Quote_Line_Item_Subcategory_Dataset>>>,
  delete_quote_line_item_tax_type_dataset?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Quote_Line_Item_Tax_Type_DatasetArgs, Maybe<WithTypename<Quote_Line_Item_Tax_Type_Dataset_Mutation_Response>>>,
  delete_quote_line_item_tax_type_dataset_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Quote_Line_Item_Tax_Type_Dataset_By_PkArgs, Maybe<WithTypename<Quote_Line_Item_Tax_Type_Dataset>>>,
  delete_quote_line_item_type_dataset?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Quote_Line_Item_Type_DatasetArgs, Maybe<WithTypename<Quote_Line_Item_Type_Dataset_Mutation_Response>>>,
  delete_quote_line_item_type_dataset_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Quote_Line_Item_Type_Dataset_By_PkArgs, Maybe<WithTypename<Quote_Line_Item_Type_Dataset>>>,
  delete_quote_line_items?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Quote_Line_ItemsArgs, Maybe<WithTypename<Quote_Line_Items_Mutation_Response>>>,
  delete_quote_line_items_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Quote_Line_Items_By_PkArgs, Maybe<WithTypename<Quote_Line_Items>>>,
  delete_quote_sk_job_type_dataset?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Quote_Sk_Job_Type_DatasetArgs, Maybe<WithTypename<Quote_Sk_Job_Type_Dataset_Mutation_Response>>>,
  delete_quote_sk_job_type_dataset_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Quote_Sk_Job_Type_Dataset_By_PkArgs, Maybe<WithTypename<Quote_Sk_Job_Type_Dataset>>>,
  delete_quote_source_dataset?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Quote_Source_DatasetArgs, Maybe<WithTypename<Quote_Source_Dataset_Mutation_Response>>>,
  delete_quote_source_dataset_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Quote_Source_Dataset_By_PkArgs, Maybe<WithTypename<Quote_Source_Dataset>>>,
  delete_quote_status_dataset?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Quote_Status_DatasetArgs, Maybe<WithTypename<Quote_Status_Dataset_Mutation_Response>>>,
  delete_quote_status_dataset_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Quote_Status_Dataset_By_PkArgs, Maybe<WithTypename<Quote_Status_Dataset>>>,
  delete_quote_user_messages?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Quote_User_MessagesArgs, Maybe<WithTypename<Quote_User_Messages_Mutation_Response>>>,
  delete_quote_user_messages_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Quote_User_Messages_By_PkArgs, Maybe<WithTypename<Quote_User_Messages>>>,
  delete_quotes?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_QuotesArgs, Maybe<WithTypename<Quotes_Mutation_Response>>>,
  delete_quotes_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Quotes_By_PkArgs, Maybe<WithTypename<Quotes>>>,
  delete_revisions_performance_evaluations_journal?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Revisions_Performance_Evaluations_JournalArgs, Maybe<WithTypename<Revisions_Performance_Evaluations_Journal_Mutation_Response>>>,
  delete_revisions_performance_evaluations_journal_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Revisions_Performance_Evaluations_Journal_By_PkArgs, Maybe<WithTypename<Revisions_Performance_Evaluations_Journal>>>,
  delete_revisions_performance_evaluations_revisions?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Revisions_Performance_Evaluations_RevisionsArgs, Maybe<WithTypename<Revisions_Performance_Evaluations_Revisions_Mutation_Response>>>,
  delete_revisions_performance_evaluations_revisions_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Revisions_Performance_Evaluations_Revisions_By_PkArgs, Maybe<WithTypename<Revisions_Performance_Evaluations_Revisions>>>,
  delete_revisions_performance_evaluations_xref_pumps_journal?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Revisions_Performance_Evaluations_Xref_Pumps_JournalArgs, Maybe<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Journal_Mutation_Response>>>,
  delete_revisions_performance_evaluations_xref_pumps_journal_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Revisions_Performance_Evaluations_Xref_Pumps_Journal_By_PkArgs, Maybe<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Journal>>>,
  delete_revisions_performance_evaluations_xref_pumps_revisions?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Revisions_Performance_Evaluations_Xref_Pumps_RevisionsArgs, Maybe<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Mutation_Response>>>,
  delete_revisions_performance_evaluations_xref_pumps_revisions_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Revisions_Performance_Evaluations_Xref_Pumps_Revisions_By_PkArgs, Maybe<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Revisions>>>,
  delete_revisions_sc_equip_xref_downhole_ytool_bypass_tubings_journal?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_JournalArgs, Maybe<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_Mutation_Response>>>,
  delete_revisions_sc_equip_xref_downhole_ytool_bypass_tubings_journal_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_By_PkArgs, Maybe<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal>>>,
  delete_revisions_sc_equip_xref_downhole_ytool_bypass_tubings_revisions?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_RevisionsArgs, Maybe<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Mutation_Response>>>,
  delete_revisions_sc_equip_xref_downhole_ytool_bypass_tubings_revisions_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_By_PkArgs, Maybe<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions>>>,
  delete_revisions_sc_equip_xref_downhole_ytool_equip_tubings_journal?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_JournalArgs, Maybe<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_Mutation_Response>>>,
  delete_revisions_sc_equip_xref_downhole_ytool_equip_tubings_journal_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_By_PkArgs, Maybe<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal>>>,
  delete_revisions_sc_equip_xref_downhole_ytool_equip_tubings_revisions?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_RevisionsArgs, Maybe<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Mutation_Response>>>,
  delete_revisions_sc_equip_xref_downhole_ytool_equip_tubings_revisions_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_By_PkArgs, Maybe<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions>>>,
  delete_revisions_sc_equip_xref_uphole_ytool_bypass_tubings_journal?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_JournalArgs, Maybe<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_Mutation_Response>>>,
  delete_revisions_sc_equip_xref_uphole_ytool_bypass_tubings_journal_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_By_PkArgs, Maybe<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal>>>,
  delete_revisions_sc_equip_xref_uphole_ytool_bypass_tubings_revisions?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_RevisionsArgs, Maybe<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Mutation_Response>>>,
  delete_revisions_sc_equip_xref_uphole_ytool_bypass_tubings_revisions_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_By_PkArgs, Maybe<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions>>>,
  delete_revisions_sc_equip_xref_uphole_ytool_equip_tubings_journal?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_JournalArgs, Maybe<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_Mutation_Response>>>,
  delete_revisions_sc_equip_xref_uphole_ytool_equip_tubings_journal_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_By_PkArgs, Maybe<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal>>>,
  delete_revisions_sc_equip_xref_uphole_ytool_equip_tubings_revisions?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_RevisionsArgs, Maybe<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Mutation_Response>>>,
  delete_revisions_sc_equip_xref_uphole_ytool_equip_tubings_revisions_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_By_PkArgs, Maybe<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions>>>,
  delete_revisions_scenario_correlations_journal?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Revisions_Scenario_Correlations_JournalArgs, Maybe<WithTypename<Revisions_Scenario_Correlations_Journal_Mutation_Response>>>,
  delete_revisions_scenario_correlations_journal_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Revisions_Scenario_Correlations_Journal_By_PkArgs, Maybe<WithTypename<Revisions_Scenario_Correlations_Journal>>>,
  delete_revisions_scenario_correlations_revisions?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Revisions_Scenario_Correlations_RevisionsArgs, Maybe<WithTypename<Revisions_Scenario_Correlations_Revisions_Mutation_Response>>>,
  delete_revisions_scenario_correlations_revisions_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Revisions_Scenario_Correlations_Revisions_By_PkArgs, Maybe<WithTypename<Revisions_Scenario_Correlations_Revisions>>>,
  delete_revisions_scenario_equipment_journal?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Revisions_Scenario_Equipment_JournalArgs, Maybe<WithTypename<Revisions_Scenario_Equipment_Journal_Mutation_Response>>>,
  delete_revisions_scenario_equipment_journal_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Revisions_Scenario_Equipment_Journal_By_PkArgs, Maybe<WithTypename<Revisions_Scenario_Equipment_Journal>>>,
  delete_revisions_scenario_equipment_revisions?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Revisions_Scenario_Equipment_RevisionsArgs, Maybe<WithTypename<Revisions_Scenario_Equipment_Revisions_Mutation_Response>>>,
  delete_revisions_scenario_equipment_revisions_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Revisions_Scenario_Equipment_Revisions_By_PkArgs, Maybe<WithTypename<Revisions_Scenario_Equipment_Revisions>>>,
  delete_revisions_scenario_equipment_xref_cables_journal?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Revisions_Scenario_Equipment_Xref_Cables_JournalArgs, Maybe<WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Journal_Mutation_Response>>>,
  delete_revisions_scenario_equipment_xref_cables_journal_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Revisions_Scenario_Equipment_Xref_Cables_Journal_By_PkArgs, Maybe<WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Journal>>>,
  delete_revisions_scenario_equipment_xref_cables_revisions?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Revisions_Scenario_Equipment_Xref_Cables_RevisionsArgs, Maybe<WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Mutation_Response>>>,
  delete_revisions_scenario_equipment_xref_cables_revisions_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Revisions_Scenario_Equipment_Xref_Cables_Revisions_By_PkArgs, Maybe<WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Revisions>>>,
  delete_revisions_scenario_equipment_xref_housings_journal?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Revisions_Scenario_Equipment_Xref_Housings_JournalArgs, Maybe<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Journal_Mutation_Response>>>,
  delete_revisions_scenario_equipment_xref_housings_journal_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Revisions_Scenario_Equipment_Xref_Housings_Journal_By_PkArgs, Maybe<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Journal>>>,
  delete_revisions_scenario_equipment_xref_housings_revisions?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Revisions_Scenario_Equipment_Xref_Housings_RevisionsArgs, Maybe<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Mutation_Response>>>,
  delete_revisions_scenario_equipment_xref_housings_revisions_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Revisions_Scenario_Equipment_Xref_Housings_Revisions_By_PkArgs, Maybe<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Revisions>>>,
  delete_revisions_scenario_equipment_xref_intakes_journal?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Revisions_Scenario_Equipment_Xref_Intakes_JournalArgs, Maybe<WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Journal_Mutation_Response>>>,
  delete_revisions_scenario_equipment_xref_intakes_journal_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Revisions_Scenario_Equipment_Xref_Intakes_Journal_By_PkArgs, Maybe<WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Journal>>>,
  delete_revisions_scenario_equipment_xref_intakes_revisions?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Revisions_Scenario_Equipment_Xref_Intakes_RevisionsArgs, Maybe<WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Mutation_Response>>>,
  delete_revisions_scenario_equipment_xref_intakes_revisions_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Revisions_Scenario_Equipment_Xref_Intakes_Revisions_By_PkArgs, Maybe<WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Revisions>>>,
  delete_revisions_scenario_equipment_xref_pumps_journal?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Revisions_Scenario_Equipment_Xref_Pumps_JournalArgs, Maybe<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Journal_Mutation_Response>>>,
  delete_revisions_scenario_equipment_xref_pumps_journal_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Revisions_Scenario_Equipment_Xref_Pumps_Journal_By_PkArgs, Maybe<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Journal>>>,
  delete_revisions_scenario_equipment_xref_pumps_revisions?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Revisions_Scenario_Equipment_Xref_Pumps_RevisionsArgs, Maybe<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Mutation_Response>>>,
  delete_revisions_scenario_equipment_xref_pumps_revisions_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Revisions_Scenario_Equipment_Xref_Pumps_Revisions_By_PkArgs, Maybe<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions>>>,
  delete_revisions_scenario_equipment_xref_seals_journal?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Revisions_Scenario_Equipment_Xref_Seals_JournalArgs, Maybe<WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Journal_Mutation_Response>>>,
  delete_revisions_scenario_equipment_xref_seals_journal_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Revisions_Scenario_Equipment_Xref_Seals_Journal_By_PkArgs, Maybe<WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Journal>>>,
  delete_revisions_scenario_equipment_xref_seals_revisions?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Revisions_Scenario_Equipment_Xref_Seals_RevisionsArgs, Maybe<WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Revisions_Mutation_Response>>>,
  delete_revisions_scenario_equipment_xref_seals_revisions_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Revisions_Scenario_Equipment_Xref_Seals_Revisions_By_PkArgs, Maybe<WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Revisions>>>,
  delete_revisions_scenario_parameters_journal?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Revisions_Scenario_Parameters_JournalArgs, Maybe<WithTypename<Revisions_Scenario_Parameters_Journal_Mutation_Response>>>,
  delete_revisions_scenario_parameters_journal_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Revisions_Scenario_Parameters_Journal_By_PkArgs, Maybe<WithTypename<Revisions_Scenario_Parameters_Journal>>>,
  delete_revisions_scenario_parameters_revisions?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Revisions_Scenario_Parameters_RevisionsArgs, Maybe<WithTypename<Revisions_Scenario_Parameters_Revisions_Mutation_Response>>>,
  delete_revisions_scenario_parameters_revisions_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Revisions_Scenario_Parameters_Revisions_By_PkArgs, Maybe<WithTypename<Revisions_Scenario_Parameters_Revisions>>>,
  delete_revisions_scenario_well_properties_journal?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Revisions_Scenario_Well_Properties_JournalArgs, Maybe<WithTypename<Revisions_Scenario_Well_Properties_Journal_Mutation_Response>>>,
  delete_revisions_scenario_well_properties_journal_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Revisions_Scenario_Well_Properties_Journal_By_PkArgs, Maybe<WithTypename<Revisions_Scenario_Well_Properties_Journal>>>,
  delete_revisions_scenario_well_properties_revisions?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Revisions_Scenario_Well_Properties_RevisionsArgs, Maybe<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Mutation_Response>>>,
  delete_revisions_scenario_well_properties_revisions_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Revisions_Scenario_Well_Properties_Revisions_By_PkArgs, Maybe<WithTypename<Revisions_Scenario_Well_Properties_Revisions>>>,
  delete_revisions_scenarios_journal?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Revisions_Scenarios_JournalArgs, Maybe<WithTypename<Revisions_Scenarios_Journal_Mutation_Response>>>,
  delete_revisions_scenarios_journal_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Revisions_Scenarios_Journal_By_PkArgs, Maybe<WithTypename<Revisions_Scenarios_Journal>>>,
  delete_revisions_scenarios_revisions?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Revisions_Scenarios_RevisionsArgs, Maybe<WithTypename<Revisions_Scenarios_Revisions_Mutation_Response>>>,
  delete_revisions_scenarios_revisions_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Revisions_Scenarios_Revisions_By_PkArgs, Maybe<WithTypename<Revisions_Scenarios_Revisions>>>,
  delete_revisions_sizings_journal?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Revisions_Sizings_JournalArgs, Maybe<WithTypename<Revisions_Sizings_Journal_Mutation_Response>>>,
  delete_revisions_sizings_journal_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Revisions_Sizings_Journal_By_PkArgs, Maybe<WithTypename<Revisions_Sizings_Journal>>>,
  delete_revisions_sizings_revisions?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Revisions_Sizings_RevisionsArgs, Maybe<WithTypename<Revisions_Sizings_Revisions_Mutation_Response>>>,
  delete_revisions_sizings_revisions_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Revisions_Sizings_Revisions_By_PkArgs, Maybe<WithTypename<Revisions_Sizings_Revisions>>>,
  delete_saturated_oil_options?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Saturated_Oil_OptionsArgs, Maybe<WithTypename<Saturated_Oil_Options_Mutation_Response>>>,
  delete_saturated_oil_options_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Saturated_Oil_Options_By_PkArgs, Maybe<WithTypename<Saturated_Oil_Options>>>,
  delete_scenario_reasons?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Scenario_ReasonsArgs, Maybe<WithTypename<Scenario_Reasons_Mutation_Response>>>,
  delete_scenario_reasons_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Scenario_Reasons_By_PkArgs, Maybe<WithTypename<Scenario_Reasons>>>,
  delete_seal_motor_oil?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Seal_Motor_OilArgs, Maybe<WithTypename<Seal_Motor_Oil_Mutation_Response>>>,
  delete_seal_motor_oil_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Seal_Motor_Oil_By_PkArgs, Maybe<WithTypename<Seal_Motor_Oil>>>,
  delete_seals?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_SealsArgs, Maybe<WithTypename<Seals_Mutation_Response>>>,
  delete_seals_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Seals_By_PkArgs, Maybe<WithTypename<Seals>>>,
  delete_sensors?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_SensorsArgs, Maybe<WithTypename<Sensors_Mutation_Response>>>,
  delete_sensors_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Sensors_By_PkArgs, Maybe<WithTypename<Sensors>>>,
  delete_sizing_dispositions?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Sizing_DispositionsArgs, Maybe<WithTypename<Sizing_Dispositions_Mutation_Response>>>,
  delete_sizing_dispositions_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Sizing_Dispositions_By_PkArgs, Maybe<WithTypename<Sizing_Dispositions>>>,
  delete_sizing_imports?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Sizing_ImportsArgs, Maybe<WithTypename<Sizing_Imports_Mutation_Response>>>,
  delete_sizing_imports_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Sizing_Imports_By_PkArgs, Maybe<WithTypename<Sizing_Imports>>>,
  delete_sizing_pumping_type?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Sizing_Pumping_TypeArgs, Maybe<WithTypename<Sizing_Pumping_Type_Mutation_Response>>>,
  delete_sizing_pumping_type_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Sizing_Pumping_Type_By_PkArgs, Maybe<WithTypename<Sizing_Pumping_Type>>>,
  delete_solution_gas_oil_ratio_options?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Solution_Gas_Oil_Ratio_OptionsArgs, Maybe<WithTypename<Solution_Gas_Oil_Ratio_Options_Mutation_Response>>>,
  delete_solution_gas_oil_ratio_options_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Solution_Gas_Oil_Ratio_Options_By_PkArgs, Maybe<WithTypename<Solution_Gas_Oil_Ratio_Options>>>,
  delete_step_down_transformers?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Step_Down_TransformersArgs, Maybe<WithTypename<Step_Down_Transformers_Mutation_Response>>>,
  delete_step_down_transformers_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Step_Down_Transformers_By_PkArgs, Maybe<WithTypename<Step_Down_Transformers>>>,
  delete_step_up_transformers?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Step_Up_TransformersArgs, Maybe<WithTypename<Step_Up_Transformers_Mutation_Response>>>,
  delete_step_up_transformers_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Step_Up_Transformers_By_PkArgs, Maybe<WithTypename<Step_Up_Transformers>>>,
  delete_switchboards?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_SwitchboardsArgs, Maybe<WithTypename<Switchboards_Mutation_Response>>>,
  delete_switchboards_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Switchboards_By_PkArgs, Maybe<WithTypename<Switchboards>>>,
  delete_tubing_flow_options?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Tubing_Flow_OptionsArgs, Maybe<WithTypename<Tubing_Flow_Options_Mutation_Response>>>,
  delete_tubing_flow_options_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Tubing_Flow_Options_By_PkArgs, Maybe<WithTypename<Tubing_Flow_Options>>>,
  delete_tubings?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_TubingsArgs, Maybe<WithTypename<Tubings_Mutation_Response>>>,
  delete_tubings_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Tubings_By_PkArgs, Maybe<WithTypename<Tubings>>>,
  delete_tubings_type?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Tubings_TypeArgs, Maybe<WithTypename<Tubings_Type_Mutation_Response>>>,
  delete_tubings_type_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Tubings_Type_By_PkArgs, Maybe<WithTypename<Tubings_Type>>>,
  delete_under_saturated_oil_options?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Under_Saturated_Oil_OptionsArgs, Maybe<WithTypename<Under_Saturated_Oil_Options_Mutation_Response>>>,
  delete_under_saturated_oil_options_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Under_Saturated_Oil_Options_By_PkArgs, Maybe<WithTypename<Under_Saturated_Oil_Options>>>,
  delete_user_eula_acceptance?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_User_Eula_AcceptanceArgs, Maybe<WithTypename<User_Eula_Acceptance_Mutation_Response>>>,
  delete_user_eula_acceptance_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_User_Eula_Acceptance_By_PkArgs, Maybe<WithTypename<User_Eula_Acceptance>>>,
  delete_users?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_UsersArgs, Maybe<WithTypename<Users_Mutation_Response>>>,
  delete_users_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Users_By_PkArgs, Maybe<WithTypename<Users>>>,
  delete_variable_speed_drives?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Variable_Speed_DrivesArgs, Maybe<WithTypename<Variable_Speed_Drives_Mutation_Response>>>,
  delete_variable_speed_drives_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Variable_Speed_Drives_By_PkArgs, Maybe<WithTypename<Variable_Speed_Drives>>>,
  delete_water_density_options?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Water_Density_OptionsArgs, Maybe<WithTypename<Water_Density_Options_Mutation_Response>>>,
  delete_water_density_options_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Water_Density_Options_By_PkArgs, Maybe<WithTypename<Water_Density_Options>>>,
  delete_water_solution_gas_options?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Water_Solution_Gas_OptionsArgs, Maybe<WithTypename<Water_Solution_Gas_Options_Mutation_Response>>>,
  delete_water_solution_gas_options_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Water_Solution_Gas_Options_By_PkArgs, Maybe<WithTypename<Water_Solution_Gas_Options>>>,
  delete_water_viscosity_options?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Water_Viscosity_OptionsArgs, Maybe<WithTypename<Water_Viscosity_Options_Mutation_Response>>>,
  delete_water_viscosity_options_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Water_Viscosity_Options_By_PkArgs, Maybe<WithTypename<Water_Viscosity_Options>>>,
  delete_water_volume_factor_options?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Water_Volume_Factor_OptionsArgs, Maybe<WithTypename<Water_Volume_Factor_Options_Mutation_Response>>>,
  delete_water_volume_factor_options_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Water_Volume_Factor_Options_By_PkArgs, Maybe<WithTypename<Water_Volume_Factor_Options>>>,
  delete_well_gas_type_options?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Well_Gas_Type_OptionsArgs, Maybe<WithTypename<Well_Gas_Type_Options_Mutation_Response>>>,
  delete_well_gas_type_options_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Well_Gas_Type_Options_By_PkArgs, Maybe<WithTypename<Well_Gas_Type_Options>>>,
  delete_well_test_gas_input_options?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Well_Test_Gas_Input_OptionsArgs, Maybe<WithTypename<Well_Test_Gas_Input_Options_Mutation_Response>>>,
  delete_well_test_gas_input_options_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Well_Test_Gas_Input_Options_By_PkArgs, Maybe<WithTypename<Well_Test_Gas_Input_Options>>>,
  delete_well_test_liquid_input_options?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Well_Test_Liquid_Input_OptionsArgs, Maybe<WithTypename<Well_Test_Liquid_Input_Options_Mutation_Response>>>,
  delete_well_test_liquid_input_options_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Well_Test_Liquid_Input_Options_By_PkArgs, Maybe<WithTypename<Well_Test_Liquid_Input_Options>>>,
  delete_well_test_pressure_input_options?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Well_Test_Pressure_Input_OptionsArgs, Maybe<WithTypename<Well_Test_Pressure_Input_Options_Mutation_Response>>>,
  delete_well_test_pressure_input_options_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Well_Test_Pressure_Input_Options_By_PkArgs, Maybe<WithTypename<Well_Test_Pressure_Input_Options>>>,
  delete_wells?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_WellsArgs, Maybe<WithTypename<Wells_Mutation_Response>>>,
  delete_wells_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Wells_By_PkArgs, Maybe<WithTypename<Wells>>>,
  delete_y_tools?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Y_ToolsArgs, Maybe<WithTypename<Y_Tools_Mutation_Response>>>,
  delete_y_tools_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Y_Tools_By_PkArgs, Maybe<WithTypename<Y_Tools>>>,
  insert_bolt_on_discharges?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Bolt_On_DischargesArgs, Maybe<WithTypename<Bolt_On_Discharges_Mutation_Response>>>,
  insert_bolt_on_discharges_one?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Bolt_On_Discharges_OneArgs, Maybe<WithTypename<Bolt_On_Discharges>>>,
  insert_bubble_point_options?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Bubble_Point_OptionsArgs, Maybe<WithTypename<Bubble_Point_Options_Mutation_Response>>>,
  insert_bubble_point_options_one?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Bubble_Point_Options_OneArgs, Maybe<WithTypename<Bubble_Point_Options>>>,
  insert_cables?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_CablesArgs, Maybe<WithTypename<Cables_Mutation_Response>>>,
  insert_cables_one?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Cables_OneArgs, Maybe<WithTypename<Cables>>>,
  insert_casing_flow_options?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Casing_Flow_OptionsArgs, Maybe<WithTypename<Casing_Flow_Options_Mutation_Response>>>,
  insert_casing_flow_options_one?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Casing_Flow_Options_OneArgs, Maybe<WithTypename<Casing_Flow_Options>>>,
  insert_casings?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_CasingsArgs, Maybe<WithTypename<Casings_Mutation_Response>>>,
  insert_casings_one?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Casings_OneArgs, Maybe<WithTypename<Casings>>>,
  insert_casings_type?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Casings_TypeArgs, Maybe<WithTypename<Casings_Type_Mutation_Response>>>,
  insert_casings_type_one?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Casings_Type_OneArgs, Maybe<WithTypename<Casings_Type>>>,
  insert_customers?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_CustomersArgs, Maybe<WithTypename<Customers_Mutation_Response>>>,
  insert_customers_one?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Customers_OneArgs, Maybe<WithTypename<Customers>>>,
  insert_dead_oil_options?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Dead_Oil_OptionsArgs, Maybe<WithTypename<Dead_Oil_Options_Mutation_Response>>>,
  insert_dead_oil_options_one?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Dead_Oil_Options_OneArgs, Maybe<WithTypename<Dead_Oil_Options>>>,
  insert_deviation_survey?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Deviation_SurveyArgs, Maybe<WithTypename<Deviation_Survey_Mutation_Response>>>,
  insert_deviation_survey_directional_dataset?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Deviation_Survey_Directional_DatasetArgs, Maybe<WithTypename<Deviation_Survey_Directional_Dataset_Mutation_Response>>>,
  insert_deviation_survey_directional_dataset_one?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Deviation_Survey_Directional_Dataset_OneArgs, Maybe<WithTypename<Deviation_Survey_Directional_Dataset>>>,
  insert_deviation_survey_one?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Deviation_Survey_OneArgs, Maybe<WithTypename<Deviation_Survey>>>,
  insert_display_units?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Display_UnitsArgs, Maybe<WithTypename<Display_Units_Mutation_Response>>>,
  insert_display_units_one?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Display_Units_OneArgs, Maybe<WithTypename<Display_Units>>>,
  insert_eula?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_EulaArgs, Maybe<WithTypename<Eula_Mutation_Response>>>,
  insert_eula_one?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Eula_OneArgs, Maybe<WithTypename<Eula>>>,
  insert_flow_model?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Flow_ModelArgs, Maybe<WithTypename<Flow_Model_Mutation_Response>>>,
  insert_flow_model_active?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Flow_Model_ActiveArgs, Maybe<WithTypename<Flow_Model_Active_Mutation_Response>>>,
  insert_flow_model_active_one?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Flow_Model_Active_OneArgs, Maybe<WithTypename<Flow_Model_Active>>>,
  insert_flow_model_deprecated?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Flow_Model_DeprecatedArgs, Maybe<WithTypename<Flow_Model_Deprecated_Mutation_Response>>>,
  insert_flow_model_deprecated_one?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Flow_Model_Deprecated_OneArgs, Maybe<WithTypename<Flow_Model_Deprecated>>>,
  insert_flow_model_one?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Flow_Model_OneArgs, Maybe<WithTypename<Flow_Model>>>,
  insert_friction_loss_options?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Friction_Loss_OptionsArgs, Maybe<WithTypename<Friction_Loss_Options_Mutation_Response>>>,
  insert_friction_loss_options_one?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Friction_Loss_Options_OneArgs, Maybe<WithTypename<Friction_Loss_Options>>>,
  insert_gas_compressibility_options?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Gas_Compressibility_OptionsArgs, Maybe<WithTypename<Gas_Compressibility_Options_Mutation_Response>>>,
  insert_gas_compressibility_options_one?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Gas_Compressibility_Options_OneArgs, Maybe<WithTypename<Gas_Compressibility_Options>>>,
  insert_gas_viscosity_options?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Gas_Viscosity_OptionsArgs, Maybe<WithTypename<Gas_Viscosity_Options_Mutation_Response>>>,
  insert_gas_viscosity_options_one?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Gas_Viscosity_Options_OneArgs, Maybe<WithTypename<Gas_Viscosity_Options>>>,
  insert_housings?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_HousingsArgs, Maybe<WithTypename<Housings_Mutation_Response>>>,
  insert_housings_one?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Housings_OneArgs, Maybe<WithTypename<Housings>>>,
  insert_hps_liquid_type?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Hps_Liquid_TypeArgs, Maybe<WithTypename<Hps_Liquid_Type_Mutation_Response>>>,
  insert_hps_liquid_type_one?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Hps_Liquid_Type_OneArgs, Maybe<WithTypename<Hps_Liquid_Type>>>,
  insert_intakes?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_IntakesArgs, Maybe<WithTypename<Intakes_Mutation_Response>>>,
  insert_intakes_one?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Intakes_OneArgs, Maybe<WithTypename<Intakes>>>,
  insert_legacy_users?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Legacy_UsersArgs, Maybe<WithTypename<Legacy_Users_Mutation_Response>>>,
  insert_legacy_users_one?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Legacy_Users_OneArgs, Maybe<WithTypename<Legacy_Users>>>,
  insert_motor_lead_extensions?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Motor_Lead_ExtensionsArgs, Maybe<WithTypename<Motor_Lead_Extensions_Mutation_Response>>>,
  insert_motor_lead_extensions_one?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Motor_Lead_Extensions_OneArgs, Maybe<WithTypename<Motor_Lead_Extensions>>>,
  insert_motors?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_MotorsArgs, Maybe<WithTypename<Motors_Mutation_Response>>>,
  insert_motors_one?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Motors_OneArgs, Maybe<WithTypename<Motors>>>,
  insert_natural_gas_separation_options?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Natural_Gas_Separation_OptionsArgs, Maybe<WithTypename<Natural_Gas_Separation_Options_Mutation_Response>>>,
  insert_natural_gas_separation_options_one?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Natural_Gas_Separation_Options_OneArgs, Maybe<WithTypename<Natural_Gas_Separation_Options>>>,
  insert_oil_density_options?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Oil_Density_OptionsArgs, Maybe<WithTypename<Oil_Density_Options_Mutation_Response>>>,
  insert_oil_density_options_one?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Oil_Density_Options_OneArgs, Maybe<WithTypename<Oil_Density_Options>>>,
  insert_oil_volume_factor_options?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Oil_Volume_Factor_OptionsArgs, Maybe<WithTypename<Oil_Volume_Factor_Options_Mutation_Response>>>,
  insert_oil_volume_factor_options_one?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Oil_Volume_Factor_Options_OneArgs, Maybe<WithTypename<Oil_Volume_Factor_Options>>>,
  insert_override_options?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Override_OptionsArgs, Maybe<WithTypename<Override_Options_Mutation_Response>>>,
  insert_override_options_one?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Override_Options_OneArgs, Maybe<WithTypename<Override_Options>>>,
  insert_pumps?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_PumpsArgs, Maybe<WithTypename<Pumps_Mutation_Response>>>,
  insert_pumps_one?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Pumps_OneArgs, Maybe<WithTypename<Pumps>>>,
  insert_quote_line_item_category_dataset?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Quote_Line_Item_Category_DatasetArgs, Maybe<WithTypename<Quote_Line_Item_Category_Dataset_Mutation_Response>>>,
  insert_quote_line_item_category_dataset_one?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Quote_Line_Item_Category_Dataset_OneArgs, Maybe<WithTypename<Quote_Line_Item_Category_Dataset>>>,
  insert_quote_line_item_serialized_dataset?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Quote_Line_Item_Serialized_DatasetArgs, Maybe<WithTypename<Quote_Line_Item_Serialized_Dataset_Mutation_Response>>>,
  insert_quote_line_item_serialized_dataset_one?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Quote_Line_Item_Serialized_Dataset_OneArgs, Maybe<WithTypename<Quote_Line_Item_Serialized_Dataset>>>,
  insert_quote_line_item_source_dataset?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Quote_Line_Item_Source_DatasetArgs, Maybe<WithTypename<Quote_Line_Item_Source_Dataset_Mutation_Response>>>,
  insert_quote_line_item_source_dataset_one?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Quote_Line_Item_Source_Dataset_OneArgs, Maybe<WithTypename<Quote_Line_Item_Source_Dataset>>>,
  insert_quote_line_item_subcategory_dataset?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Quote_Line_Item_Subcategory_DatasetArgs, Maybe<WithTypename<Quote_Line_Item_Subcategory_Dataset_Mutation_Response>>>,
  insert_quote_line_item_subcategory_dataset_one?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Quote_Line_Item_Subcategory_Dataset_OneArgs, Maybe<WithTypename<Quote_Line_Item_Subcategory_Dataset>>>,
  insert_quote_line_item_tax_type_dataset?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Quote_Line_Item_Tax_Type_DatasetArgs, Maybe<WithTypename<Quote_Line_Item_Tax_Type_Dataset_Mutation_Response>>>,
  insert_quote_line_item_tax_type_dataset_one?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Quote_Line_Item_Tax_Type_Dataset_OneArgs, Maybe<WithTypename<Quote_Line_Item_Tax_Type_Dataset>>>,
  insert_quote_line_item_type_dataset?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Quote_Line_Item_Type_DatasetArgs, Maybe<WithTypename<Quote_Line_Item_Type_Dataset_Mutation_Response>>>,
  insert_quote_line_item_type_dataset_one?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Quote_Line_Item_Type_Dataset_OneArgs, Maybe<WithTypename<Quote_Line_Item_Type_Dataset>>>,
  insert_quote_line_items?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Quote_Line_ItemsArgs, Maybe<WithTypename<Quote_Line_Items_Mutation_Response>>>,
  insert_quote_line_items_one?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Quote_Line_Items_OneArgs, Maybe<WithTypename<Quote_Line_Items>>>,
  insert_quote_sk_job_type_dataset?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Quote_Sk_Job_Type_DatasetArgs, Maybe<WithTypename<Quote_Sk_Job_Type_Dataset_Mutation_Response>>>,
  insert_quote_sk_job_type_dataset_one?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Quote_Sk_Job_Type_Dataset_OneArgs, Maybe<WithTypename<Quote_Sk_Job_Type_Dataset>>>,
  insert_quote_source_dataset?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Quote_Source_DatasetArgs, Maybe<WithTypename<Quote_Source_Dataset_Mutation_Response>>>,
  insert_quote_source_dataset_one?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Quote_Source_Dataset_OneArgs, Maybe<WithTypename<Quote_Source_Dataset>>>,
  insert_quote_status_dataset?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Quote_Status_DatasetArgs, Maybe<WithTypename<Quote_Status_Dataset_Mutation_Response>>>,
  insert_quote_status_dataset_one?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Quote_Status_Dataset_OneArgs, Maybe<WithTypename<Quote_Status_Dataset>>>,
  insert_quote_user_messages?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Quote_User_MessagesArgs, Maybe<WithTypename<Quote_User_Messages_Mutation_Response>>>,
  insert_quote_user_messages_one?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Quote_User_Messages_OneArgs, Maybe<WithTypename<Quote_User_Messages>>>,
  insert_quotes?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_QuotesArgs, Maybe<WithTypename<Quotes_Mutation_Response>>>,
  insert_quotes_one?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Quotes_OneArgs, Maybe<WithTypename<Quotes>>>,
  insert_revisions_performance_evaluations_journal?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Revisions_Performance_Evaluations_JournalArgs, Maybe<WithTypename<Revisions_Performance_Evaluations_Journal_Mutation_Response>>>,
  insert_revisions_performance_evaluations_journal_one?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Revisions_Performance_Evaluations_Journal_OneArgs, Maybe<WithTypename<Revisions_Performance_Evaluations_Journal>>>,
  insert_revisions_performance_evaluations_revisions?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Revisions_Performance_Evaluations_RevisionsArgs, Maybe<WithTypename<Revisions_Performance_Evaluations_Revisions_Mutation_Response>>>,
  insert_revisions_performance_evaluations_revisions_one?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Revisions_Performance_Evaluations_Revisions_OneArgs, Maybe<WithTypename<Revisions_Performance_Evaluations_Revisions>>>,
  insert_revisions_performance_evaluations_xref_pumps_journal?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Revisions_Performance_Evaluations_Xref_Pumps_JournalArgs, Maybe<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Journal_Mutation_Response>>>,
  insert_revisions_performance_evaluations_xref_pumps_journal_one?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Revisions_Performance_Evaluations_Xref_Pumps_Journal_OneArgs, Maybe<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Journal>>>,
  insert_revisions_performance_evaluations_xref_pumps_revisions?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Revisions_Performance_Evaluations_Xref_Pumps_RevisionsArgs, Maybe<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Mutation_Response>>>,
  insert_revisions_performance_evaluations_xref_pumps_revisions_one?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Revisions_Performance_Evaluations_Xref_Pumps_Revisions_OneArgs, Maybe<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Revisions>>>,
  insert_revisions_sc_equip_xref_downhole_ytool_bypass_tubings_journal?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_JournalArgs, Maybe<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_Mutation_Response>>>,
  insert_revisions_sc_equip_xref_downhole_ytool_bypass_tubings_journal_one?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_OneArgs, Maybe<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal>>>,
  insert_revisions_sc_equip_xref_downhole_ytool_bypass_tubings_revisions?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_RevisionsArgs, Maybe<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Mutation_Response>>>,
  insert_revisions_sc_equip_xref_downhole_ytool_bypass_tubings_revisions_one?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_OneArgs, Maybe<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions>>>,
  insert_revisions_sc_equip_xref_downhole_ytool_equip_tubings_journal?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_JournalArgs, Maybe<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_Mutation_Response>>>,
  insert_revisions_sc_equip_xref_downhole_ytool_equip_tubings_journal_one?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_OneArgs, Maybe<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal>>>,
  insert_revisions_sc_equip_xref_downhole_ytool_equip_tubings_revisions?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_RevisionsArgs, Maybe<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Mutation_Response>>>,
  insert_revisions_sc_equip_xref_downhole_ytool_equip_tubings_revisions_one?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_OneArgs, Maybe<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions>>>,
  insert_revisions_sc_equip_xref_uphole_ytool_bypass_tubings_journal?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_JournalArgs, Maybe<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_Mutation_Response>>>,
  insert_revisions_sc_equip_xref_uphole_ytool_bypass_tubings_journal_one?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_OneArgs, Maybe<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal>>>,
  insert_revisions_sc_equip_xref_uphole_ytool_bypass_tubings_revisions?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_RevisionsArgs, Maybe<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Mutation_Response>>>,
  insert_revisions_sc_equip_xref_uphole_ytool_bypass_tubings_revisions_one?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_OneArgs, Maybe<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions>>>,
  insert_revisions_sc_equip_xref_uphole_ytool_equip_tubings_journal?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_JournalArgs, Maybe<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_Mutation_Response>>>,
  insert_revisions_sc_equip_xref_uphole_ytool_equip_tubings_journal_one?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_OneArgs, Maybe<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal>>>,
  insert_revisions_sc_equip_xref_uphole_ytool_equip_tubings_revisions?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_RevisionsArgs, Maybe<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Mutation_Response>>>,
  insert_revisions_sc_equip_xref_uphole_ytool_equip_tubings_revisions_one?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_OneArgs, Maybe<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions>>>,
  insert_revisions_scenario_correlations_journal?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Revisions_Scenario_Correlations_JournalArgs, Maybe<WithTypename<Revisions_Scenario_Correlations_Journal_Mutation_Response>>>,
  insert_revisions_scenario_correlations_journal_one?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Revisions_Scenario_Correlations_Journal_OneArgs, Maybe<WithTypename<Revisions_Scenario_Correlations_Journal>>>,
  insert_revisions_scenario_correlations_revisions?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Revisions_Scenario_Correlations_RevisionsArgs, Maybe<WithTypename<Revisions_Scenario_Correlations_Revisions_Mutation_Response>>>,
  insert_revisions_scenario_correlations_revisions_one?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Revisions_Scenario_Correlations_Revisions_OneArgs, Maybe<WithTypename<Revisions_Scenario_Correlations_Revisions>>>,
  insert_revisions_scenario_equipment_journal?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Revisions_Scenario_Equipment_JournalArgs, Maybe<WithTypename<Revisions_Scenario_Equipment_Journal_Mutation_Response>>>,
  insert_revisions_scenario_equipment_journal_one?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Revisions_Scenario_Equipment_Journal_OneArgs, Maybe<WithTypename<Revisions_Scenario_Equipment_Journal>>>,
  insert_revisions_scenario_equipment_revisions?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Revisions_Scenario_Equipment_RevisionsArgs, Maybe<WithTypename<Revisions_Scenario_Equipment_Revisions_Mutation_Response>>>,
  insert_revisions_scenario_equipment_revisions_one?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Revisions_Scenario_Equipment_Revisions_OneArgs, Maybe<WithTypename<Revisions_Scenario_Equipment_Revisions>>>,
  insert_revisions_scenario_equipment_xref_cables_journal?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Revisions_Scenario_Equipment_Xref_Cables_JournalArgs, Maybe<WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Journal_Mutation_Response>>>,
  insert_revisions_scenario_equipment_xref_cables_journal_one?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Revisions_Scenario_Equipment_Xref_Cables_Journal_OneArgs, Maybe<WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Journal>>>,
  insert_revisions_scenario_equipment_xref_cables_revisions?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Revisions_Scenario_Equipment_Xref_Cables_RevisionsArgs, Maybe<WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Mutation_Response>>>,
  insert_revisions_scenario_equipment_xref_cables_revisions_one?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Revisions_Scenario_Equipment_Xref_Cables_Revisions_OneArgs, Maybe<WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Revisions>>>,
  insert_revisions_scenario_equipment_xref_housings_journal?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Revisions_Scenario_Equipment_Xref_Housings_JournalArgs, Maybe<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Journal_Mutation_Response>>>,
  insert_revisions_scenario_equipment_xref_housings_journal_one?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Revisions_Scenario_Equipment_Xref_Housings_Journal_OneArgs, Maybe<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Journal>>>,
  insert_revisions_scenario_equipment_xref_housings_revisions?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Revisions_Scenario_Equipment_Xref_Housings_RevisionsArgs, Maybe<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Mutation_Response>>>,
  insert_revisions_scenario_equipment_xref_housings_revisions_one?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Revisions_Scenario_Equipment_Xref_Housings_Revisions_OneArgs, Maybe<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Revisions>>>,
  insert_revisions_scenario_equipment_xref_intakes_journal?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Revisions_Scenario_Equipment_Xref_Intakes_JournalArgs, Maybe<WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Journal_Mutation_Response>>>,
  insert_revisions_scenario_equipment_xref_intakes_journal_one?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Revisions_Scenario_Equipment_Xref_Intakes_Journal_OneArgs, Maybe<WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Journal>>>,
  insert_revisions_scenario_equipment_xref_intakes_revisions?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Revisions_Scenario_Equipment_Xref_Intakes_RevisionsArgs, Maybe<WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Mutation_Response>>>,
  insert_revisions_scenario_equipment_xref_intakes_revisions_one?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Revisions_Scenario_Equipment_Xref_Intakes_Revisions_OneArgs, Maybe<WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Revisions>>>,
  insert_revisions_scenario_equipment_xref_pumps_journal?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Revisions_Scenario_Equipment_Xref_Pumps_JournalArgs, Maybe<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Journal_Mutation_Response>>>,
  insert_revisions_scenario_equipment_xref_pumps_journal_one?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Revisions_Scenario_Equipment_Xref_Pumps_Journal_OneArgs, Maybe<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Journal>>>,
  insert_revisions_scenario_equipment_xref_pumps_revisions?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Revisions_Scenario_Equipment_Xref_Pumps_RevisionsArgs, Maybe<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Mutation_Response>>>,
  insert_revisions_scenario_equipment_xref_pumps_revisions_one?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Revisions_Scenario_Equipment_Xref_Pumps_Revisions_OneArgs, Maybe<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions>>>,
  insert_revisions_scenario_equipment_xref_seals_journal?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Revisions_Scenario_Equipment_Xref_Seals_JournalArgs, Maybe<WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Journal_Mutation_Response>>>,
  insert_revisions_scenario_equipment_xref_seals_journal_one?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Revisions_Scenario_Equipment_Xref_Seals_Journal_OneArgs, Maybe<WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Journal>>>,
  insert_revisions_scenario_equipment_xref_seals_revisions?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Revisions_Scenario_Equipment_Xref_Seals_RevisionsArgs, Maybe<WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Revisions_Mutation_Response>>>,
  insert_revisions_scenario_equipment_xref_seals_revisions_one?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Revisions_Scenario_Equipment_Xref_Seals_Revisions_OneArgs, Maybe<WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Revisions>>>,
  insert_revisions_scenario_parameters_journal?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Revisions_Scenario_Parameters_JournalArgs, Maybe<WithTypename<Revisions_Scenario_Parameters_Journal_Mutation_Response>>>,
  insert_revisions_scenario_parameters_journal_one?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Revisions_Scenario_Parameters_Journal_OneArgs, Maybe<WithTypename<Revisions_Scenario_Parameters_Journal>>>,
  insert_revisions_scenario_parameters_revisions?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Revisions_Scenario_Parameters_RevisionsArgs, Maybe<WithTypename<Revisions_Scenario_Parameters_Revisions_Mutation_Response>>>,
  insert_revisions_scenario_parameters_revisions_one?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Revisions_Scenario_Parameters_Revisions_OneArgs, Maybe<WithTypename<Revisions_Scenario_Parameters_Revisions>>>,
  insert_revisions_scenario_well_properties_journal?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Revisions_Scenario_Well_Properties_JournalArgs, Maybe<WithTypename<Revisions_Scenario_Well_Properties_Journal_Mutation_Response>>>,
  insert_revisions_scenario_well_properties_journal_one?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Revisions_Scenario_Well_Properties_Journal_OneArgs, Maybe<WithTypename<Revisions_Scenario_Well_Properties_Journal>>>,
  insert_revisions_scenario_well_properties_revisions?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Revisions_Scenario_Well_Properties_RevisionsArgs, Maybe<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Mutation_Response>>>,
  insert_revisions_scenario_well_properties_revisions_one?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Revisions_Scenario_Well_Properties_Revisions_OneArgs, Maybe<WithTypename<Revisions_Scenario_Well_Properties_Revisions>>>,
  insert_revisions_scenarios_journal?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Revisions_Scenarios_JournalArgs, Maybe<WithTypename<Revisions_Scenarios_Journal_Mutation_Response>>>,
  insert_revisions_scenarios_journal_one?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Revisions_Scenarios_Journal_OneArgs, Maybe<WithTypename<Revisions_Scenarios_Journal>>>,
  insert_revisions_scenarios_revisions?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Revisions_Scenarios_RevisionsArgs, Maybe<WithTypename<Revisions_Scenarios_Revisions_Mutation_Response>>>,
  insert_revisions_scenarios_revisions_one?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Revisions_Scenarios_Revisions_OneArgs, Maybe<WithTypename<Revisions_Scenarios_Revisions>>>,
  insert_revisions_sizings_journal?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Revisions_Sizings_JournalArgs, Maybe<WithTypename<Revisions_Sizings_Journal_Mutation_Response>>>,
  insert_revisions_sizings_journal_one?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Revisions_Sizings_Journal_OneArgs, Maybe<WithTypename<Revisions_Sizings_Journal>>>,
  insert_revisions_sizings_revisions?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Revisions_Sizings_RevisionsArgs, Maybe<WithTypename<Revisions_Sizings_Revisions_Mutation_Response>>>,
  insert_revisions_sizings_revisions_one?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Revisions_Sizings_Revisions_OneArgs, Maybe<WithTypename<Revisions_Sizings_Revisions>>>,
  insert_saturated_oil_options?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Saturated_Oil_OptionsArgs, Maybe<WithTypename<Saturated_Oil_Options_Mutation_Response>>>,
  insert_saturated_oil_options_one?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Saturated_Oil_Options_OneArgs, Maybe<WithTypename<Saturated_Oil_Options>>>,
  insert_scenario_reasons?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Scenario_ReasonsArgs, Maybe<WithTypename<Scenario_Reasons_Mutation_Response>>>,
  insert_scenario_reasons_one?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Scenario_Reasons_OneArgs, Maybe<WithTypename<Scenario_Reasons>>>,
  insert_seal_motor_oil?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Seal_Motor_OilArgs, Maybe<WithTypename<Seal_Motor_Oil_Mutation_Response>>>,
  insert_seal_motor_oil_one?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Seal_Motor_Oil_OneArgs, Maybe<WithTypename<Seal_Motor_Oil>>>,
  insert_seals?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_SealsArgs, Maybe<WithTypename<Seals_Mutation_Response>>>,
  insert_seals_one?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Seals_OneArgs, Maybe<WithTypename<Seals>>>,
  insert_sensors?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_SensorsArgs, Maybe<WithTypename<Sensors_Mutation_Response>>>,
  insert_sensors_one?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Sensors_OneArgs, Maybe<WithTypename<Sensors>>>,
  insert_sizing_dispositions?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Sizing_DispositionsArgs, Maybe<WithTypename<Sizing_Dispositions_Mutation_Response>>>,
  insert_sizing_dispositions_one?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Sizing_Dispositions_OneArgs, Maybe<WithTypename<Sizing_Dispositions>>>,
  insert_sizing_imports?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Sizing_ImportsArgs, Maybe<WithTypename<Sizing_Imports_Mutation_Response>>>,
  insert_sizing_imports_one?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Sizing_Imports_OneArgs, Maybe<WithTypename<Sizing_Imports>>>,
  insert_sizing_pumping_type?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Sizing_Pumping_TypeArgs, Maybe<WithTypename<Sizing_Pumping_Type_Mutation_Response>>>,
  insert_sizing_pumping_type_one?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Sizing_Pumping_Type_OneArgs, Maybe<WithTypename<Sizing_Pumping_Type>>>,
  insert_solution_gas_oil_ratio_options?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Solution_Gas_Oil_Ratio_OptionsArgs, Maybe<WithTypename<Solution_Gas_Oil_Ratio_Options_Mutation_Response>>>,
  insert_solution_gas_oil_ratio_options_one?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Solution_Gas_Oil_Ratio_Options_OneArgs, Maybe<WithTypename<Solution_Gas_Oil_Ratio_Options>>>,
  insert_step_down_transformers?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Step_Down_TransformersArgs, Maybe<WithTypename<Step_Down_Transformers_Mutation_Response>>>,
  insert_step_down_transformers_one?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Step_Down_Transformers_OneArgs, Maybe<WithTypename<Step_Down_Transformers>>>,
  insert_step_up_transformers?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Step_Up_TransformersArgs, Maybe<WithTypename<Step_Up_Transformers_Mutation_Response>>>,
  insert_step_up_transformers_one?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Step_Up_Transformers_OneArgs, Maybe<WithTypename<Step_Up_Transformers>>>,
  insert_switchboards?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_SwitchboardsArgs, Maybe<WithTypename<Switchboards_Mutation_Response>>>,
  insert_switchboards_one?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Switchboards_OneArgs, Maybe<WithTypename<Switchboards>>>,
  insert_tubing_flow_options?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Tubing_Flow_OptionsArgs, Maybe<WithTypename<Tubing_Flow_Options_Mutation_Response>>>,
  insert_tubing_flow_options_one?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Tubing_Flow_Options_OneArgs, Maybe<WithTypename<Tubing_Flow_Options>>>,
  insert_tubings?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_TubingsArgs, Maybe<WithTypename<Tubings_Mutation_Response>>>,
  insert_tubings_one?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Tubings_OneArgs, Maybe<WithTypename<Tubings>>>,
  insert_tubings_type?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Tubings_TypeArgs, Maybe<WithTypename<Tubings_Type_Mutation_Response>>>,
  insert_tubings_type_one?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Tubings_Type_OneArgs, Maybe<WithTypename<Tubings_Type>>>,
  insert_under_saturated_oil_options?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Under_Saturated_Oil_OptionsArgs, Maybe<WithTypename<Under_Saturated_Oil_Options_Mutation_Response>>>,
  insert_under_saturated_oil_options_one?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Under_Saturated_Oil_Options_OneArgs, Maybe<WithTypename<Under_Saturated_Oil_Options>>>,
  insert_user_eula_acceptance?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_User_Eula_AcceptanceArgs, Maybe<WithTypename<User_Eula_Acceptance_Mutation_Response>>>,
  insert_user_eula_acceptance_one?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_User_Eula_Acceptance_OneArgs, Maybe<WithTypename<User_Eula_Acceptance>>>,
  insert_users?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_UsersArgs, Maybe<WithTypename<Users_Mutation_Response>>>,
  insert_users_one?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Users_OneArgs, Maybe<WithTypename<Users>>>,
  insert_variable_speed_drives?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Variable_Speed_DrivesArgs, Maybe<WithTypename<Variable_Speed_Drives_Mutation_Response>>>,
  insert_variable_speed_drives_one?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Variable_Speed_Drives_OneArgs, Maybe<WithTypename<Variable_Speed_Drives>>>,
  insert_water_density_options?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Water_Density_OptionsArgs, Maybe<WithTypename<Water_Density_Options_Mutation_Response>>>,
  insert_water_density_options_one?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Water_Density_Options_OneArgs, Maybe<WithTypename<Water_Density_Options>>>,
  insert_water_solution_gas_options?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Water_Solution_Gas_OptionsArgs, Maybe<WithTypename<Water_Solution_Gas_Options_Mutation_Response>>>,
  insert_water_solution_gas_options_one?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Water_Solution_Gas_Options_OneArgs, Maybe<WithTypename<Water_Solution_Gas_Options>>>,
  insert_water_viscosity_options?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Water_Viscosity_OptionsArgs, Maybe<WithTypename<Water_Viscosity_Options_Mutation_Response>>>,
  insert_water_viscosity_options_one?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Water_Viscosity_Options_OneArgs, Maybe<WithTypename<Water_Viscosity_Options>>>,
  insert_water_volume_factor_options?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Water_Volume_Factor_OptionsArgs, Maybe<WithTypename<Water_Volume_Factor_Options_Mutation_Response>>>,
  insert_water_volume_factor_options_one?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Water_Volume_Factor_Options_OneArgs, Maybe<WithTypename<Water_Volume_Factor_Options>>>,
  insert_well_gas_type_options?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Well_Gas_Type_OptionsArgs, Maybe<WithTypename<Well_Gas_Type_Options_Mutation_Response>>>,
  insert_well_gas_type_options_one?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Well_Gas_Type_Options_OneArgs, Maybe<WithTypename<Well_Gas_Type_Options>>>,
  insert_well_test_gas_input_options?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Well_Test_Gas_Input_OptionsArgs, Maybe<WithTypename<Well_Test_Gas_Input_Options_Mutation_Response>>>,
  insert_well_test_gas_input_options_one?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Well_Test_Gas_Input_Options_OneArgs, Maybe<WithTypename<Well_Test_Gas_Input_Options>>>,
  insert_well_test_liquid_input_options?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Well_Test_Liquid_Input_OptionsArgs, Maybe<WithTypename<Well_Test_Liquid_Input_Options_Mutation_Response>>>,
  insert_well_test_liquid_input_options_one?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Well_Test_Liquid_Input_Options_OneArgs, Maybe<WithTypename<Well_Test_Liquid_Input_Options>>>,
  insert_well_test_pressure_input_options?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Well_Test_Pressure_Input_OptionsArgs, Maybe<WithTypename<Well_Test_Pressure_Input_Options_Mutation_Response>>>,
  insert_well_test_pressure_input_options_one?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Well_Test_Pressure_Input_Options_OneArgs, Maybe<WithTypename<Well_Test_Pressure_Input_Options>>>,
  insert_wells?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_WellsArgs, Maybe<WithTypename<Wells_Mutation_Response>>>,
  insert_wells_one?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Wells_OneArgs, Maybe<WithTypename<Wells>>>,
  insert_y_tools?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Y_ToolsArgs, Maybe<WithTypename<Y_Tools_Mutation_Response>>>,
  insert_y_tools_one?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Y_Tools_OneArgs, Maybe<WithTypename<Y_Tools>>>,
  updateSKQuoteJob?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdateSkQuoteJobArgs, Maybe<WithTypename<SkQuote>>>,
  update_bolt_on_discharges?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Bolt_On_DischargesArgs, Maybe<WithTypename<Bolt_On_Discharges_Mutation_Response>>>,
  update_bolt_on_discharges_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Bolt_On_Discharges_By_PkArgs, Maybe<WithTypename<Bolt_On_Discharges>>>,
  update_bolt_on_discharges_many?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Bolt_On_Discharges_ManyArgs, Maybe<Array<WithTypename<Bolt_On_Discharges_Mutation_Response>>>>,
  update_bubble_point_options?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Bubble_Point_OptionsArgs, Maybe<WithTypename<Bubble_Point_Options_Mutation_Response>>>,
  update_bubble_point_options_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Bubble_Point_Options_By_PkArgs, Maybe<WithTypename<Bubble_Point_Options>>>,
  update_bubble_point_options_many?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Bubble_Point_Options_ManyArgs, Maybe<Array<WithTypename<Bubble_Point_Options_Mutation_Response>>>>,
  update_cables?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_CablesArgs, Maybe<WithTypename<Cables_Mutation_Response>>>,
  update_cables_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Cables_By_PkArgs, Maybe<WithTypename<Cables>>>,
  update_cables_many?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Cables_ManyArgs, Maybe<Array<WithTypename<Cables_Mutation_Response>>>>,
  update_casing_flow_options?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Casing_Flow_OptionsArgs, Maybe<WithTypename<Casing_Flow_Options_Mutation_Response>>>,
  update_casing_flow_options_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Casing_Flow_Options_By_PkArgs, Maybe<WithTypename<Casing_Flow_Options>>>,
  update_casing_flow_options_many?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Casing_Flow_Options_ManyArgs, Maybe<Array<WithTypename<Casing_Flow_Options_Mutation_Response>>>>,
  update_casings?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_CasingsArgs, Maybe<WithTypename<Casings_Mutation_Response>>>,
  update_casings_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Casings_By_PkArgs, Maybe<WithTypename<Casings>>>,
  update_casings_many?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Casings_ManyArgs, Maybe<Array<WithTypename<Casings_Mutation_Response>>>>,
  update_casings_type?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Casings_TypeArgs, Maybe<WithTypename<Casings_Type_Mutation_Response>>>,
  update_casings_type_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Casings_Type_By_PkArgs, Maybe<WithTypename<Casings_Type>>>,
  update_casings_type_many?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Casings_Type_ManyArgs, Maybe<Array<WithTypename<Casings_Type_Mutation_Response>>>>,
  update_customers?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_CustomersArgs, Maybe<WithTypename<Customers_Mutation_Response>>>,
  update_customers_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Customers_By_PkArgs, Maybe<WithTypename<Customers>>>,
  update_customers_many?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Customers_ManyArgs, Maybe<Array<WithTypename<Customers_Mutation_Response>>>>,
  update_dead_oil_options?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Dead_Oil_OptionsArgs, Maybe<WithTypename<Dead_Oil_Options_Mutation_Response>>>,
  update_dead_oil_options_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Dead_Oil_Options_By_PkArgs, Maybe<WithTypename<Dead_Oil_Options>>>,
  update_dead_oil_options_many?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Dead_Oil_Options_ManyArgs, Maybe<Array<WithTypename<Dead_Oil_Options_Mutation_Response>>>>,
  update_deviation_survey?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Deviation_SurveyArgs, Maybe<WithTypename<Deviation_Survey_Mutation_Response>>>,
  update_deviation_survey_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Deviation_Survey_By_PkArgs, Maybe<WithTypename<Deviation_Survey>>>,
  update_deviation_survey_directional_dataset?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Deviation_Survey_Directional_DatasetArgs, Maybe<WithTypename<Deviation_Survey_Directional_Dataset_Mutation_Response>>>,
  update_deviation_survey_directional_dataset_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Deviation_Survey_Directional_Dataset_By_PkArgs, Maybe<WithTypename<Deviation_Survey_Directional_Dataset>>>,
  update_deviation_survey_directional_dataset_many?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Deviation_Survey_Directional_Dataset_ManyArgs, Maybe<Array<WithTypename<Deviation_Survey_Directional_Dataset_Mutation_Response>>>>,
  update_deviation_survey_many?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Deviation_Survey_ManyArgs, Maybe<Array<WithTypename<Deviation_Survey_Mutation_Response>>>>,
  update_display_units?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Display_UnitsArgs, Maybe<WithTypename<Display_Units_Mutation_Response>>>,
  update_display_units_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Display_Units_By_PkArgs, Maybe<WithTypename<Display_Units>>>,
  update_display_units_many?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Display_Units_ManyArgs, Maybe<Array<WithTypename<Display_Units_Mutation_Response>>>>,
  update_eula?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_EulaArgs, Maybe<WithTypename<Eula_Mutation_Response>>>,
  update_eula_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Eula_By_PkArgs, Maybe<WithTypename<Eula>>>,
  update_eula_many?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Eula_ManyArgs, Maybe<Array<WithTypename<Eula_Mutation_Response>>>>,
  update_flow_model?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Flow_ModelArgs, Maybe<WithTypename<Flow_Model_Mutation_Response>>>,
  update_flow_model_active?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Flow_Model_ActiveArgs, Maybe<WithTypename<Flow_Model_Active_Mutation_Response>>>,
  update_flow_model_active_many?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Flow_Model_Active_ManyArgs, Maybe<Array<WithTypename<Flow_Model_Active_Mutation_Response>>>>,
  update_flow_model_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Flow_Model_By_PkArgs, Maybe<WithTypename<Flow_Model>>>,
  update_flow_model_deprecated?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Flow_Model_DeprecatedArgs, Maybe<WithTypename<Flow_Model_Deprecated_Mutation_Response>>>,
  update_flow_model_deprecated_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Flow_Model_Deprecated_By_PkArgs, Maybe<WithTypename<Flow_Model_Deprecated>>>,
  update_flow_model_deprecated_many?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Flow_Model_Deprecated_ManyArgs, Maybe<Array<WithTypename<Flow_Model_Deprecated_Mutation_Response>>>>,
  update_flow_model_many?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Flow_Model_ManyArgs, Maybe<Array<WithTypename<Flow_Model_Mutation_Response>>>>,
  update_friction_loss_options?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Friction_Loss_OptionsArgs, Maybe<WithTypename<Friction_Loss_Options_Mutation_Response>>>,
  update_friction_loss_options_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Friction_Loss_Options_By_PkArgs, Maybe<WithTypename<Friction_Loss_Options>>>,
  update_friction_loss_options_many?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Friction_Loss_Options_ManyArgs, Maybe<Array<WithTypename<Friction_Loss_Options_Mutation_Response>>>>,
  update_gas_compressibility_options?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Gas_Compressibility_OptionsArgs, Maybe<WithTypename<Gas_Compressibility_Options_Mutation_Response>>>,
  update_gas_compressibility_options_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Gas_Compressibility_Options_By_PkArgs, Maybe<WithTypename<Gas_Compressibility_Options>>>,
  update_gas_compressibility_options_many?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Gas_Compressibility_Options_ManyArgs, Maybe<Array<WithTypename<Gas_Compressibility_Options_Mutation_Response>>>>,
  update_gas_viscosity_options?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Gas_Viscosity_OptionsArgs, Maybe<WithTypename<Gas_Viscosity_Options_Mutation_Response>>>,
  update_gas_viscosity_options_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Gas_Viscosity_Options_By_PkArgs, Maybe<WithTypename<Gas_Viscosity_Options>>>,
  update_gas_viscosity_options_many?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Gas_Viscosity_Options_ManyArgs, Maybe<Array<WithTypename<Gas_Viscosity_Options_Mutation_Response>>>>,
  update_housings?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_HousingsArgs, Maybe<WithTypename<Housings_Mutation_Response>>>,
  update_housings_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Housings_By_PkArgs, Maybe<WithTypename<Housings>>>,
  update_housings_many?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Housings_ManyArgs, Maybe<Array<WithTypename<Housings_Mutation_Response>>>>,
  update_hps_liquid_type?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Hps_Liquid_TypeArgs, Maybe<WithTypename<Hps_Liquid_Type_Mutation_Response>>>,
  update_hps_liquid_type_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Hps_Liquid_Type_By_PkArgs, Maybe<WithTypename<Hps_Liquid_Type>>>,
  update_hps_liquid_type_many?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Hps_Liquid_Type_ManyArgs, Maybe<Array<WithTypename<Hps_Liquid_Type_Mutation_Response>>>>,
  update_intakes?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_IntakesArgs, Maybe<WithTypename<Intakes_Mutation_Response>>>,
  update_intakes_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Intakes_By_PkArgs, Maybe<WithTypename<Intakes>>>,
  update_intakes_many?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Intakes_ManyArgs, Maybe<Array<WithTypename<Intakes_Mutation_Response>>>>,
  update_legacy_users?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Legacy_UsersArgs, Maybe<WithTypename<Legacy_Users_Mutation_Response>>>,
  update_legacy_users_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Legacy_Users_By_PkArgs, Maybe<WithTypename<Legacy_Users>>>,
  update_legacy_users_many?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Legacy_Users_ManyArgs, Maybe<Array<WithTypename<Legacy_Users_Mutation_Response>>>>,
  update_motor_lead_extensions?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Motor_Lead_ExtensionsArgs, Maybe<WithTypename<Motor_Lead_Extensions_Mutation_Response>>>,
  update_motor_lead_extensions_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Motor_Lead_Extensions_By_PkArgs, Maybe<WithTypename<Motor_Lead_Extensions>>>,
  update_motor_lead_extensions_many?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Motor_Lead_Extensions_ManyArgs, Maybe<Array<WithTypename<Motor_Lead_Extensions_Mutation_Response>>>>,
  update_motors?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_MotorsArgs, Maybe<WithTypename<Motors_Mutation_Response>>>,
  update_motors_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Motors_By_PkArgs, Maybe<WithTypename<Motors>>>,
  update_motors_many?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Motors_ManyArgs, Maybe<Array<WithTypename<Motors_Mutation_Response>>>>,
  update_natural_gas_separation_options?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Natural_Gas_Separation_OptionsArgs, Maybe<WithTypename<Natural_Gas_Separation_Options_Mutation_Response>>>,
  update_natural_gas_separation_options_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Natural_Gas_Separation_Options_By_PkArgs, Maybe<WithTypename<Natural_Gas_Separation_Options>>>,
  update_natural_gas_separation_options_many?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Natural_Gas_Separation_Options_ManyArgs, Maybe<Array<WithTypename<Natural_Gas_Separation_Options_Mutation_Response>>>>,
  update_oil_density_options?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Oil_Density_OptionsArgs, Maybe<WithTypename<Oil_Density_Options_Mutation_Response>>>,
  update_oil_density_options_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Oil_Density_Options_By_PkArgs, Maybe<WithTypename<Oil_Density_Options>>>,
  update_oil_density_options_many?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Oil_Density_Options_ManyArgs, Maybe<Array<WithTypename<Oil_Density_Options_Mutation_Response>>>>,
  update_oil_volume_factor_options?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Oil_Volume_Factor_OptionsArgs, Maybe<WithTypename<Oil_Volume_Factor_Options_Mutation_Response>>>,
  update_oil_volume_factor_options_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Oil_Volume_Factor_Options_By_PkArgs, Maybe<WithTypename<Oil_Volume_Factor_Options>>>,
  update_oil_volume_factor_options_many?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Oil_Volume_Factor_Options_ManyArgs, Maybe<Array<WithTypename<Oil_Volume_Factor_Options_Mutation_Response>>>>,
  update_override_options?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Override_OptionsArgs, Maybe<WithTypename<Override_Options_Mutation_Response>>>,
  update_override_options_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Override_Options_By_PkArgs, Maybe<WithTypename<Override_Options>>>,
  update_override_options_many?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Override_Options_ManyArgs, Maybe<Array<WithTypename<Override_Options_Mutation_Response>>>>,
  update_pumps?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_PumpsArgs, Maybe<WithTypename<Pumps_Mutation_Response>>>,
  update_pumps_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Pumps_By_PkArgs, Maybe<WithTypename<Pumps>>>,
  update_pumps_many?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Pumps_ManyArgs, Maybe<Array<WithTypename<Pumps_Mutation_Response>>>>,
  update_quote_line_item_category_dataset?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Quote_Line_Item_Category_DatasetArgs, Maybe<WithTypename<Quote_Line_Item_Category_Dataset_Mutation_Response>>>,
  update_quote_line_item_category_dataset_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Quote_Line_Item_Category_Dataset_By_PkArgs, Maybe<WithTypename<Quote_Line_Item_Category_Dataset>>>,
  update_quote_line_item_category_dataset_many?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Quote_Line_Item_Category_Dataset_ManyArgs, Maybe<Array<WithTypename<Quote_Line_Item_Category_Dataset_Mutation_Response>>>>,
  update_quote_line_item_serialized_dataset?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Quote_Line_Item_Serialized_DatasetArgs, Maybe<WithTypename<Quote_Line_Item_Serialized_Dataset_Mutation_Response>>>,
  update_quote_line_item_serialized_dataset_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Quote_Line_Item_Serialized_Dataset_By_PkArgs, Maybe<WithTypename<Quote_Line_Item_Serialized_Dataset>>>,
  update_quote_line_item_serialized_dataset_many?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Quote_Line_Item_Serialized_Dataset_ManyArgs, Maybe<Array<WithTypename<Quote_Line_Item_Serialized_Dataset_Mutation_Response>>>>,
  update_quote_line_item_source_dataset?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Quote_Line_Item_Source_DatasetArgs, Maybe<WithTypename<Quote_Line_Item_Source_Dataset_Mutation_Response>>>,
  update_quote_line_item_source_dataset_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Quote_Line_Item_Source_Dataset_By_PkArgs, Maybe<WithTypename<Quote_Line_Item_Source_Dataset>>>,
  update_quote_line_item_source_dataset_many?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Quote_Line_Item_Source_Dataset_ManyArgs, Maybe<Array<WithTypename<Quote_Line_Item_Source_Dataset_Mutation_Response>>>>,
  update_quote_line_item_subcategory_dataset?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Quote_Line_Item_Subcategory_DatasetArgs, Maybe<WithTypename<Quote_Line_Item_Subcategory_Dataset_Mutation_Response>>>,
  update_quote_line_item_subcategory_dataset_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Quote_Line_Item_Subcategory_Dataset_By_PkArgs, Maybe<WithTypename<Quote_Line_Item_Subcategory_Dataset>>>,
  update_quote_line_item_subcategory_dataset_many?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Quote_Line_Item_Subcategory_Dataset_ManyArgs, Maybe<Array<WithTypename<Quote_Line_Item_Subcategory_Dataset_Mutation_Response>>>>,
  update_quote_line_item_tax_type_dataset?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Quote_Line_Item_Tax_Type_DatasetArgs, Maybe<WithTypename<Quote_Line_Item_Tax_Type_Dataset_Mutation_Response>>>,
  update_quote_line_item_tax_type_dataset_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Quote_Line_Item_Tax_Type_Dataset_By_PkArgs, Maybe<WithTypename<Quote_Line_Item_Tax_Type_Dataset>>>,
  update_quote_line_item_tax_type_dataset_many?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Quote_Line_Item_Tax_Type_Dataset_ManyArgs, Maybe<Array<WithTypename<Quote_Line_Item_Tax_Type_Dataset_Mutation_Response>>>>,
  update_quote_line_item_type_dataset?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Quote_Line_Item_Type_DatasetArgs, Maybe<WithTypename<Quote_Line_Item_Type_Dataset_Mutation_Response>>>,
  update_quote_line_item_type_dataset_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Quote_Line_Item_Type_Dataset_By_PkArgs, Maybe<WithTypename<Quote_Line_Item_Type_Dataset>>>,
  update_quote_line_item_type_dataset_many?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Quote_Line_Item_Type_Dataset_ManyArgs, Maybe<Array<WithTypename<Quote_Line_Item_Type_Dataset_Mutation_Response>>>>,
  update_quote_line_items?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Quote_Line_ItemsArgs, Maybe<WithTypename<Quote_Line_Items_Mutation_Response>>>,
  update_quote_line_items_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Quote_Line_Items_By_PkArgs, Maybe<WithTypename<Quote_Line_Items>>>,
  update_quote_line_items_many?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Quote_Line_Items_ManyArgs, Maybe<Array<WithTypename<Quote_Line_Items_Mutation_Response>>>>,
  update_quote_sk_job_type_dataset?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Quote_Sk_Job_Type_DatasetArgs, Maybe<WithTypename<Quote_Sk_Job_Type_Dataset_Mutation_Response>>>,
  update_quote_sk_job_type_dataset_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Quote_Sk_Job_Type_Dataset_By_PkArgs, Maybe<WithTypename<Quote_Sk_Job_Type_Dataset>>>,
  update_quote_sk_job_type_dataset_many?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Quote_Sk_Job_Type_Dataset_ManyArgs, Maybe<Array<WithTypename<Quote_Sk_Job_Type_Dataset_Mutation_Response>>>>,
  update_quote_source_dataset?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Quote_Source_DatasetArgs, Maybe<WithTypename<Quote_Source_Dataset_Mutation_Response>>>,
  update_quote_source_dataset_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Quote_Source_Dataset_By_PkArgs, Maybe<WithTypename<Quote_Source_Dataset>>>,
  update_quote_source_dataset_many?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Quote_Source_Dataset_ManyArgs, Maybe<Array<WithTypename<Quote_Source_Dataset_Mutation_Response>>>>,
  update_quote_status_dataset?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Quote_Status_DatasetArgs, Maybe<WithTypename<Quote_Status_Dataset_Mutation_Response>>>,
  update_quote_status_dataset_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Quote_Status_Dataset_By_PkArgs, Maybe<WithTypename<Quote_Status_Dataset>>>,
  update_quote_status_dataset_many?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Quote_Status_Dataset_ManyArgs, Maybe<Array<WithTypename<Quote_Status_Dataset_Mutation_Response>>>>,
  update_quote_user_messages?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Quote_User_MessagesArgs, Maybe<WithTypename<Quote_User_Messages_Mutation_Response>>>,
  update_quote_user_messages_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Quote_User_Messages_By_PkArgs, Maybe<WithTypename<Quote_User_Messages>>>,
  update_quote_user_messages_many?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Quote_User_Messages_ManyArgs, Maybe<Array<WithTypename<Quote_User_Messages_Mutation_Response>>>>,
  update_quotes?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_QuotesArgs, Maybe<WithTypename<Quotes_Mutation_Response>>>,
  update_quotes_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Quotes_By_PkArgs, Maybe<WithTypename<Quotes>>>,
  update_quotes_many?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Quotes_ManyArgs, Maybe<Array<WithTypename<Quotes_Mutation_Response>>>>,
  update_revisions_performance_evaluations_journal?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Revisions_Performance_Evaluations_JournalArgs, Maybe<WithTypename<Revisions_Performance_Evaluations_Journal_Mutation_Response>>>,
  update_revisions_performance_evaluations_journal_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Revisions_Performance_Evaluations_Journal_By_PkArgs, Maybe<WithTypename<Revisions_Performance_Evaluations_Journal>>>,
  update_revisions_performance_evaluations_journal_many?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Revisions_Performance_Evaluations_Journal_ManyArgs, Maybe<Array<WithTypename<Revisions_Performance_Evaluations_Journal_Mutation_Response>>>>,
  update_revisions_performance_evaluations_revisions?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Revisions_Performance_Evaluations_RevisionsArgs, Maybe<WithTypename<Revisions_Performance_Evaluations_Revisions_Mutation_Response>>>,
  update_revisions_performance_evaluations_revisions_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Revisions_Performance_Evaluations_Revisions_By_PkArgs, Maybe<WithTypename<Revisions_Performance_Evaluations_Revisions>>>,
  update_revisions_performance_evaluations_revisions_many?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Revisions_Performance_Evaluations_Revisions_ManyArgs, Maybe<Array<WithTypename<Revisions_Performance_Evaluations_Revisions_Mutation_Response>>>>,
  update_revisions_performance_evaluations_xref_pumps_journal?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Revisions_Performance_Evaluations_Xref_Pumps_JournalArgs, Maybe<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Journal_Mutation_Response>>>,
  update_revisions_performance_evaluations_xref_pumps_journal_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Revisions_Performance_Evaluations_Xref_Pumps_Journal_By_PkArgs, Maybe<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Journal>>>,
  update_revisions_performance_evaluations_xref_pumps_journal_many?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Revisions_Performance_Evaluations_Xref_Pumps_Journal_ManyArgs, Maybe<Array<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Journal_Mutation_Response>>>>,
  update_revisions_performance_evaluations_xref_pumps_revisions?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Revisions_Performance_Evaluations_Xref_Pumps_RevisionsArgs, Maybe<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Mutation_Response>>>,
  update_revisions_performance_evaluations_xref_pumps_revisions_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Revisions_Performance_Evaluations_Xref_Pumps_Revisions_By_PkArgs, Maybe<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Revisions>>>,
  update_revisions_performance_evaluations_xref_pumps_revisions_many?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Revisions_Performance_Evaluations_Xref_Pumps_Revisions_ManyArgs, Maybe<Array<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Mutation_Response>>>>,
  update_revisions_sc_equip_xref_downhole_ytool_bypass_tubings_journal?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_JournalArgs, Maybe<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_Mutation_Response>>>,
  update_revisions_sc_equip_xref_downhole_ytool_bypass_tubings_journal_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_By_PkArgs, Maybe<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal>>>,
  update_revisions_sc_equip_xref_downhole_ytool_bypass_tubings_journal_many?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_ManyArgs, Maybe<Array<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_Mutation_Response>>>>,
  update_revisions_sc_equip_xref_downhole_ytool_bypass_tubings_revisions?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_RevisionsArgs, Maybe<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Mutation_Response>>>,
  update_revisions_sc_equip_xref_downhole_ytool_bypass_tubings_revisions_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_By_PkArgs, Maybe<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions>>>,
  update_revisions_sc_equip_xref_downhole_ytool_bypass_tubings_revisions_many?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_ManyArgs, Maybe<Array<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Mutation_Response>>>>,
  update_revisions_sc_equip_xref_downhole_ytool_equip_tubings_journal?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_JournalArgs, Maybe<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_Mutation_Response>>>,
  update_revisions_sc_equip_xref_downhole_ytool_equip_tubings_journal_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_By_PkArgs, Maybe<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal>>>,
  update_revisions_sc_equip_xref_downhole_ytool_equip_tubings_journal_many?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_ManyArgs, Maybe<Array<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_Mutation_Response>>>>,
  update_revisions_sc_equip_xref_downhole_ytool_equip_tubings_revisions?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_RevisionsArgs, Maybe<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Mutation_Response>>>,
  update_revisions_sc_equip_xref_downhole_ytool_equip_tubings_revisions_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_By_PkArgs, Maybe<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions>>>,
  update_revisions_sc_equip_xref_downhole_ytool_equip_tubings_revisions_many?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_ManyArgs, Maybe<Array<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Mutation_Response>>>>,
  update_revisions_sc_equip_xref_uphole_ytool_bypass_tubings_journal?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_JournalArgs, Maybe<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_Mutation_Response>>>,
  update_revisions_sc_equip_xref_uphole_ytool_bypass_tubings_journal_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_By_PkArgs, Maybe<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal>>>,
  update_revisions_sc_equip_xref_uphole_ytool_bypass_tubings_journal_many?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_ManyArgs, Maybe<Array<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_Mutation_Response>>>>,
  update_revisions_sc_equip_xref_uphole_ytool_bypass_tubings_revisions?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_RevisionsArgs, Maybe<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Mutation_Response>>>,
  update_revisions_sc_equip_xref_uphole_ytool_bypass_tubings_revisions_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_By_PkArgs, Maybe<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions>>>,
  update_revisions_sc_equip_xref_uphole_ytool_bypass_tubings_revisions_many?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_ManyArgs, Maybe<Array<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Mutation_Response>>>>,
  update_revisions_sc_equip_xref_uphole_ytool_equip_tubings_journal?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_JournalArgs, Maybe<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_Mutation_Response>>>,
  update_revisions_sc_equip_xref_uphole_ytool_equip_tubings_journal_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_By_PkArgs, Maybe<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal>>>,
  update_revisions_sc_equip_xref_uphole_ytool_equip_tubings_journal_many?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_ManyArgs, Maybe<Array<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_Mutation_Response>>>>,
  update_revisions_sc_equip_xref_uphole_ytool_equip_tubings_revisions?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_RevisionsArgs, Maybe<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Mutation_Response>>>,
  update_revisions_sc_equip_xref_uphole_ytool_equip_tubings_revisions_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_By_PkArgs, Maybe<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions>>>,
  update_revisions_sc_equip_xref_uphole_ytool_equip_tubings_revisions_many?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_ManyArgs, Maybe<Array<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Mutation_Response>>>>,
  update_revisions_scenario_correlations_journal?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Revisions_Scenario_Correlations_JournalArgs, Maybe<WithTypename<Revisions_Scenario_Correlations_Journal_Mutation_Response>>>,
  update_revisions_scenario_correlations_journal_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Revisions_Scenario_Correlations_Journal_By_PkArgs, Maybe<WithTypename<Revisions_Scenario_Correlations_Journal>>>,
  update_revisions_scenario_correlations_journal_many?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Revisions_Scenario_Correlations_Journal_ManyArgs, Maybe<Array<WithTypename<Revisions_Scenario_Correlations_Journal_Mutation_Response>>>>,
  update_revisions_scenario_correlations_revisions?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Revisions_Scenario_Correlations_RevisionsArgs, Maybe<WithTypename<Revisions_Scenario_Correlations_Revisions_Mutation_Response>>>,
  update_revisions_scenario_correlations_revisions_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Revisions_Scenario_Correlations_Revisions_By_PkArgs, Maybe<WithTypename<Revisions_Scenario_Correlations_Revisions>>>,
  update_revisions_scenario_correlations_revisions_many?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Revisions_Scenario_Correlations_Revisions_ManyArgs, Maybe<Array<WithTypename<Revisions_Scenario_Correlations_Revisions_Mutation_Response>>>>,
  update_revisions_scenario_equipment_journal?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Revisions_Scenario_Equipment_JournalArgs, Maybe<WithTypename<Revisions_Scenario_Equipment_Journal_Mutation_Response>>>,
  update_revisions_scenario_equipment_journal_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Revisions_Scenario_Equipment_Journal_By_PkArgs, Maybe<WithTypename<Revisions_Scenario_Equipment_Journal>>>,
  update_revisions_scenario_equipment_journal_many?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Revisions_Scenario_Equipment_Journal_ManyArgs, Maybe<Array<WithTypename<Revisions_Scenario_Equipment_Journal_Mutation_Response>>>>,
  update_revisions_scenario_equipment_revisions?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Revisions_Scenario_Equipment_RevisionsArgs, Maybe<WithTypename<Revisions_Scenario_Equipment_Revisions_Mutation_Response>>>,
  update_revisions_scenario_equipment_revisions_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Revisions_Scenario_Equipment_Revisions_By_PkArgs, Maybe<WithTypename<Revisions_Scenario_Equipment_Revisions>>>,
  update_revisions_scenario_equipment_revisions_many?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Revisions_Scenario_Equipment_Revisions_ManyArgs, Maybe<Array<WithTypename<Revisions_Scenario_Equipment_Revisions_Mutation_Response>>>>,
  update_revisions_scenario_equipment_xref_cables_journal?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Revisions_Scenario_Equipment_Xref_Cables_JournalArgs, Maybe<WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Journal_Mutation_Response>>>,
  update_revisions_scenario_equipment_xref_cables_journal_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Revisions_Scenario_Equipment_Xref_Cables_Journal_By_PkArgs, Maybe<WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Journal>>>,
  update_revisions_scenario_equipment_xref_cables_journal_many?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Revisions_Scenario_Equipment_Xref_Cables_Journal_ManyArgs, Maybe<Array<WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Journal_Mutation_Response>>>>,
  update_revisions_scenario_equipment_xref_cables_revisions?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Revisions_Scenario_Equipment_Xref_Cables_RevisionsArgs, Maybe<WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Mutation_Response>>>,
  update_revisions_scenario_equipment_xref_cables_revisions_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Revisions_Scenario_Equipment_Xref_Cables_Revisions_By_PkArgs, Maybe<WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Revisions>>>,
  update_revisions_scenario_equipment_xref_cables_revisions_many?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Revisions_Scenario_Equipment_Xref_Cables_Revisions_ManyArgs, Maybe<Array<WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Mutation_Response>>>>,
  update_revisions_scenario_equipment_xref_housings_journal?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Revisions_Scenario_Equipment_Xref_Housings_JournalArgs, Maybe<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Journal_Mutation_Response>>>,
  update_revisions_scenario_equipment_xref_housings_journal_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Revisions_Scenario_Equipment_Xref_Housings_Journal_By_PkArgs, Maybe<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Journal>>>,
  update_revisions_scenario_equipment_xref_housings_journal_many?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Revisions_Scenario_Equipment_Xref_Housings_Journal_ManyArgs, Maybe<Array<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Journal_Mutation_Response>>>>,
  update_revisions_scenario_equipment_xref_housings_revisions?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Revisions_Scenario_Equipment_Xref_Housings_RevisionsArgs, Maybe<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Mutation_Response>>>,
  update_revisions_scenario_equipment_xref_housings_revisions_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Revisions_Scenario_Equipment_Xref_Housings_Revisions_By_PkArgs, Maybe<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Revisions>>>,
  update_revisions_scenario_equipment_xref_housings_revisions_many?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Revisions_Scenario_Equipment_Xref_Housings_Revisions_ManyArgs, Maybe<Array<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Mutation_Response>>>>,
  update_revisions_scenario_equipment_xref_intakes_journal?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Revisions_Scenario_Equipment_Xref_Intakes_JournalArgs, Maybe<WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Journal_Mutation_Response>>>,
  update_revisions_scenario_equipment_xref_intakes_journal_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Revisions_Scenario_Equipment_Xref_Intakes_Journal_By_PkArgs, Maybe<WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Journal>>>,
  update_revisions_scenario_equipment_xref_intakes_journal_many?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Revisions_Scenario_Equipment_Xref_Intakes_Journal_ManyArgs, Maybe<Array<WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Journal_Mutation_Response>>>>,
  update_revisions_scenario_equipment_xref_intakes_revisions?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Revisions_Scenario_Equipment_Xref_Intakes_RevisionsArgs, Maybe<WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Mutation_Response>>>,
  update_revisions_scenario_equipment_xref_intakes_revisions_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Revisions_Scenario_Equipment_Xref_Intakes_Revisions_By_PkArgs, Maybe<WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Revisions>>>,
  update_revisions_scenario_equipment_xref_intakes_revisions_many?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Revisions_Scenario_Equipment_Xref_Intakes_Revisions_ManyArgs, Maybe<Array<WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Mutation_Response>>>>,
  update_revisions_scenario_equipment_xref_pumps_journal?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Revisions_Scenario_Equipment_Xref_Pumps_JournalArgs, Maybe<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Journal_Mutation_Response>>>,
  update_revisions_scenario_equipment_xref_pumps_journal_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Revisions_Scenario_Equipment_Xref_Pumps_Journal_By_PkArgs, Maybe<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Journal>>>,
  update_revisions_scenario_equipment_xref_pumps_journal_many?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Revisions_Scenario_Equipment_Xref_Pumps_Journal_ManyArgs, Maybe<Array<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Journal_Mutation_Response>>>>,
  update_revisions_scenario_equipment_xref_pumps_revisions?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Revisions_Scenario_Equipment_Xref_Pumps_RevisionsArgs, Maybe<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Mutation_Response>>>,
  update_revisions_scenario_equipment_xref_pumps_revisions_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Revisions_Scenario_Equipment_Xref_Pumps_Revisions_By_PkArgs, Maybe<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions>>>,
  update_revisions_scenario_equipment_xref_pumps_revisions_many?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Revisions_Scenario_Equipment_Xref_Pumps_Revisions_ManyArgs, Maybe<Array<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Mutation_Response>>>>,
  update_revisions_scenario_equipment_xref_seals_journal?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Revisions_Scenario_Equipment_Xref_Seals_JournalArgs, Maybe<WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Journal_Mutation_Response>>>,
  update_revisions_scenario_equipment_xref_seals_journal_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Revisions_Scenario_Equipment_Xref_Seals_Journal_By_PkArgs, Maybe<WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Journal>>>,
  update_revisions_scenario_equipment_xref_seals_journal_many?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Revisions_Scenario_Equipment_Xref_Seals_Journal_ManyArgs, Maybe<Array<WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Journal_Mutation_Response>>>>,
  update_revisions_scenario_equipment_xref_seals_revisions?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Revisions_Scenario_Equipment_Xref_Seals_RevisionsArgs, Maybe<WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Revisions_Mutation_Response>>>,
  update_revisions_scenario_equipment_xref_seals_revisions_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Revisions_Scenario_Equipment_Xref_Seals_Revisions_By_PkArgs, Maybe<WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Revisions>>>,
  update_revisions_scenario_equipment_xref_seals_revisions_many?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Revisions_Scenario_Equipment_Xref_Seals_Revisions_ManyArgs, Maybe<Array<WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Revisions_Mutation_Response>>>>,
  update_revisions_scenario_parameters_journal?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Revisions_Scenario_Parameters_JournalArgs, Maybe<WithTypename<Revisions_Scenario_Parameters_Journal_Mutation_Response>>>,
  update_revisions_scenario_parameters_journal_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Revisions_Scenario_Parameters_Journal_By_PkArgs, Maybe<WithTypename<Revisions_Scenario_Parameters_Journal>>>,
  update_revisions_scenario_parameters_journal_many?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Revisions_Scenario_Parameters_Journal_ManyArgs, Maybe<Array<WithTypename<Revisions_Scenario_Parameters_Journal_Mutation_Response>>>>,
  update_revisions_scenario_parameters_revisions?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Revisions_Scenario_Parameters_RevisionsArgs, Maybe<WithTypename<Revisions_Scenario_Parameters_Revisions_Mutation_Response>>>,
  update_revisions_scenario_parameters_revisions_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Revisions_Scenario_Parameters_Revisions_By_PkArgs, Maybe<WithTypename<Revisions_Scenario_Parameters_Revisions>>>,
  update_revisions_scenario_parameters_revisions_many?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Revisions_Scenario_Parameters_Revisions_ManyArgs, Maybe<Array<WithTypename<Revisions_Scenario_Parameters_Revisions_Mutation_Response>>>>,
  update_revisions_scenario_well_properties_journal?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Revisions_Scenario_Well_Properties_JournalArgs, Maybe<WithTypename<Revisions_Scenario_Well_Properties_Journal_Mutation_Response>>>,
  update_revisions_scenario_well_properties_journal_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Revisions_Scenario_Well_Properties_Journal_By_PkArgs, Maybe<WithTypename<Revisions_Scenario_Well_Properties_Journal>>>,
  update_revisions_scenario_well_properties_journal_many?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Revisions_Scenario_Well_Properties_Journal_ManyArgs, Maybe<Array<WithTypename<Revisions_Scenario_Well_Properties_Journal_Mutation_Response>>>>,
  update_revisions_scenario_well_properties_revisions?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Revisions_Scenario_Well_Properties_RevisionsArgs, Maybe<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Mutation_Response>>>,
  update_revisions_scenario_well_properties_revisions_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Revisions_Scenario_Well_Properties_Revisions_By_PkArgs, Maybe<WithTypename<Revisions_Scenario_Well_Properties_Revisions>>>,
  update_revisions_scenario_well_properties_revisions_many?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Revisions_Scenario_Well_Properties_Revisions_ManyArgs, Maybe<Array<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Mutation_Response>>>>,
  update_revisions_scenarios_journal?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Revisions_Scenarios_JournalArgs, Maybe<WithTypename<Revisions_Scenarios_Journal_Mutation_Response>>>,
  update_revisions_scenarios_journal_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Revisions_Scenarios_Journal_By_PkArgs, Maybe<WithTypename<Revisions_Scenarios_Journal>>>,
  update_revisions_scenarios_journal_many?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Revisions_Scenarios_Journal_ManyArgs, Maybe<Array<WithTypename<Revisions_Scenarios_Journal_Mutation_Response>>>>,
  update_revisions_scenarios_revisions?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Revisions_Scenarios_RevisionsArgs, Maybe<WithTypename<Revisions_Scenarios_Revisions_Mutation_Response>>>,
  update_revisions_scenarios_revisions_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Revisions_Scenarios_Revisions_By_PkArgs, Maybe<WithTypename<Revisions_Scenarios_Revisions>>>,
  update_revisions_scenarios_revisions_many?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Revisions_Scenarios_Revisions_ManyArgs, Maybe<Array<WithTypename<Revisions_Scenarios_Revisions_Mutation_Response>>>>,
  update_revisions_sizings_journal?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Revisions_Sizings_JournalArgs, Maybe<WithTypename<Revisions_Sizings_Journal_Mutation_Response>>>,
  update_revisions_sizings_journal_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Revisions_Sizings_Journal_By_PkArgs, Maybe<WithTypename<Revisions_Sizings_Journal>>>,
  update_revisions_sizings_journal_many?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Revisions_Sizings_Journal_ManyArgs, Maybe<Array<WithTypename<Revisions_Sizings_Journal_Mutation_Response>>>>,
  update_revisions_sizings_revisions?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Revisions_Sizings_RevisionsArgs, Maybe<WithTypename<Revisions_Sizings_Revisions_Mutation_Response>>>,
  update_revisions_sizings_revisions_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Revisions_Sizings_Revisions_By_PkArgs, Maybe<WithTypename<Revisions_Sizings_Revisions>>>,
  update_revisions_sizings_revisions_many?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Revisions_Sizings_Revisions_ManyArgs, Maybe<Array<WithTypename<Revisions_Sizings_Revisions_Mutation_Response>>>>,
  update_saturated_oil_options?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Saturated_Oil_OptionsArgs, Maybe<WithTypename<Saturated_Oil_Options_Mutation_Response>>>,
  update_saturated_oil_options_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Saturated_Oil_Options_By_PkArgs, Maybe<WithTypename<Saturated_Oil_Options>>>,
  update_saturated_oil_options_many?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Saturated_Oil_Options_ManyArgs, Maybe<Array<WithTypename<Saturated_Oil_Options_Mutation_Response>>>>,
  update_scenario_reasons?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Scenario_ReasonsArgs, Maybe<WithTypename<Scenario_Reasons_Mutation_Response>>>,
  update_scenario_reasons_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Scenario_Reasons_By_PkArgs, Maybe<WithTypename<Scenario_Reasons>>>,
  update_scenario_reasons_many?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Scenario_Reasons_ManyArgs, Maybe<Array<WithTypename<Scenario_Reasons_Mutation_Response>>>>,
  update_seal_motor_oil?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Seal_Motor_OilArgs, Maybe<WithTypename<Seal_Motor_Oil_Mutation_Response>>>,
  update_seal_motor_oil_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Seal_Motor_Oil_By_PkArgs, Maybe<WithTypename<Seal_Motor_Oil>>>,
  update_seal_motor_oil_many?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Seal_Motor_Oil_ManyArgs, Maybe<Array<WithTypename<Seal_Motor_Oil_Mutation_Response>>>>,
  update_seals?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_SealsArgs, Maybe<WithTypename<Seals_Mutation_Response>>>,
  update_seals_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Seals_By_PkArgs, Maybe<WithTypename<Seals>>>,
  update_seals_many?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Seals_ManyArgs, Maybe<Array<WithTypename<Seals_Mutation_Response>>>>,
  update_sensors?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_SensorsArgs, Maybe<WithTypename<Sensors_Mutation_Response>>>,
  update_sensors_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Sensors_By_PkArgs, Maybe<WithTypename<Sensors>>>,
  update_sensors_many?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Sensors_ManyArgs, Maybe<Array<WithTypename<Sensors_Mutation_Response>>>>,
  update_sizing_dispositions?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Sizing_DispositionsArgs, Maybe<WithTypename<Sizing_Dispositions_Mutation_Response>>>,
  update_sizing_dispositions_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Sizing_Dispositions_By_PkArgs, Maybe<WithTypename<Sizing_Dispositions>>>,
  update_sizing_dispositions_many?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Sizing_Dispositions_ManyArgs, Maybe<Array<WithTypename<Sizing_Dispositions_Mutation_Response>>>>,
  update_sizing_imports?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Sizing_ImportsArgs, Maybe<WithTypename<Sizing_Imports_Mutation_Response>>>,
  update_sizing_imports_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Sizing_Imports_By_PkArgs, Maybe<WithTypename<Sizing_Imports>>>,
  update_sizing_imports_many?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Sizing_Imports_ManyArgs, Maybe<Array<WithTypename<Sizing_Imports_Mutation_Response>>>>,
  update_sizing_pumping_type?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Sizing_Pumping_TypeArgs, Maybe<WithTypename<Sizing_Pumping_Type_Mutation_Response>>>,
  update_sizing_pumping_type_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Sizing_Pumping_Type_By_PkArgs, Maybe<WithTypename<Sizing_Pumping_Type>>>,
  update_sizing_pumping_type_many?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Sizing_Pumping_Type_ManyArgs, Maybe<Array<WithTypename<Sizing_Pumping_Type_Mutation_Response>>>>,
  update_solution_gas_oil_ratio_options?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Solution_Gas_Oil_Ratio_OptionsArgs, Maybe<WithTypename<Solution_Gas_Oil_Ratio_Options_Mutation_Response>>>,
  update_solution_gas_oil_ratio_options_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Solution_Gas_Oil_Ratio_Options_By_PkArgs, Maybe<WithTypename<Solution_Gas_Oil_Ratio_Options>>>,
  update_solution_gas_oil_ratio_options_many?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Solution_Gas_Oil_Ratio_Options_ManyArgs, Maybe<Array<WithTypename<Solution_Gas_Oil_Ratio_Options_Mutation_Response>>>>,
  update_step_down_transformers?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Step_Down_TransformersArgs, Maybe<WithTypename<Step_Down_Transformers_Mutation_Response>>>,
  update_step_down_transformers_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Step_Down_Transformers_By_PkArgs, Maybe<WithTypename<Step_Down_Transformers>>>,
  update_step_down_transformers_many?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Step_Down_Transformers_ManyArgs, Maybe<Array<WithTypename<Step_Down_Transformers_Mutation_Response>>>>,
  update_step_up_transformers?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Step_Up_TransformersArgs, Maybe<WithTypename<Step_Up_Transformers_Mutation_Response>>>,
  update_step_up_transformers_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Step_Up_Transformers_By_PkArgs, Maybe<WithTypename<Step_Up_Transformers>>>,
  update_step_up_transformers_many?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Step_Up_Transformers_ManyArgs, Maybe<Array<WithTypename<Step_Up_Transformers_Mutation_Response>>>>,
  update_switchboards?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_SwitchboardsArgs, Maybe<WithTypename<Switchboards_Mutation_Response>>>,
  update_switchboards_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Switchboards_By_PkArgs, Maybe<WithTypename<Switchboards>>>,
  update_switchboards_many?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Switchboards_ManyArgs, Maybe<Array<WithTypename<Switchboards_Mutation_Response>>>>,
  update_tubing_flow_options?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Tubing_Flow_OptionsArgs, Maybe<WithTypename<Tubing_Flow_Options_Mutation_Response>>>,
  update_tubing_flow_options_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Tubing_Flow_Options_By_PkArgs, Maybe<WithTypename<Tubing_Flow_Options>>>,
  update_tubing_flow_options_many?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Tubing_Flow_Options_ManyArgs, Maybe<Array<WithTypename<Tubing_Flow_Options_Mutation_Response>>>>,
  update_tubings?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_TubingsArgs, Maybe<WithTypename<Tubings_Mutation_Response>>>,
  update_tubings_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Tubings_By_PkArgs, Maybe<WithTypename<Tubings>>>,
  update_tubings_many?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Tubings_ManyArgs, Maybe<Array<WithTypename<Tubings_Mutation_Response>>>>,
  update_tubings_type?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Tubings_TypeArgs, Maybe<WithTypename<Tubings_Type_Mutation_Response>>>,
  update_tubings_type_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Tubings_Type_By_PkArgs, Maybe<WithTypename<Tubings_Type>>>,
  update_tubings_type_many?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Tubings_Type_ManyArgs, Maybe<Array<WithTypename<Tubings_Type_Mutation_Response>>>>,
  update_under_saturated_oil_options?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Under_Saturated_Oil_OptionsArgs, Maybe<WithTypename<Under_Saturated_Oil_Options_Mutation_Response>>>,
  update_under_saturated_oil_options_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Under_Saturated_Oil_Options_By_PkArgs, Maybe<WithTypename<Under_Saturated_Oil_Options>>>,
  update_under_saturated_oil_options_many?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Under_Saturated_Oil_Options_ManyArgs, Maybe<Array<WithTypename<Under_Saturated_Oil_Options_Mutation_Response>>>>,
  update_user_eula_acceptance?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_User_Eula_AcceptanceArgs, Maybe<WithTypename<User_Eula_Acceptance_Mutation_Response>>>,
  update_user_eula_acceptance_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_User_Eula_Acceptance_By_PkArgs, Maybe<WithTypename<User_Eula_Acceptance>>>,
  update_user_eula_acceptance_many?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_User_Eula_Acceptance_ManyArgs, Maybe<Array<WithTypename<User_Eula_Acceptance_Mutation_Response>>>>,
  update_users?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_UsersArgs, Maybe<WithTypename<Users_Mutation_Response>>>,
  update_users_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Users_By_PkArgs, Maybe<WithTypename<Users>>>,
  update_users_many?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Users_ManyArgs, Maybe<Array<WithTypename<Users_Mutation_Response>>>>,
  update_variable_speed_drives?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Variable_Speed_DrivesArgs, Maybe<WithTypename<Variable_Speed_Drives_Mutation_Response>>>,
  update_variable_speed_drives_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Variable_Speed_Drives_By_PkArgs, Maybe<WithTypename<Variable_Speed_Drives>>>,
  update_variable_speed_drives_many?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Variable_Speed_Drives_ManyArgs, Maybe<Array<WithTypename<Variable_Speed_Drives_Mutation_Response>>>>,
  update_water_density_options?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Water_Density_OptionsArgs, Maybe<WithTypename<Water_Density_Options_Mutation_Response>>>,
  update_water_density_options_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Water_Density_Options_By_PkArgs, Maybe<WithTypename<Water_Density_Options>>>,
  update_water_density_options_many?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Water_Density_Options_ManyArgs, Maybe<Array<WithTypename<Water_Density_Options_Mutation_Response>>>>,
  update_water_solution_gas_options?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Water_Solution_Gas_OptionsArgs, Maybe<WithTypename<Water_Solution_Gas_Options_Mutation_Response>>>,
  update_water_solution_gas_options_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Water_Solution_Gas_Options_By_PkArgs, Maybe<WithTypename<Water_Solution_Gas_Options>>>,
  update_water_solution_gas_options_many?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Water_Solution_Gas_Options_ManyArgs, Maybe<Array<WithTypename<Water_Solution_Gas_Options_Mutation_Response>>>>,
  update_water_viscosity_options?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Water_Viscosity_OptionsArgs, Maybe<WithTypename<Water_Viscosity_Options_Mutation_Response>>>,
  update_water_viscosity_options_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Water_Viscosity_Options_By_PkArgs, Maybe<WithTypename<Water_Viscosity_Options>>>,
  update_water_viscosity_options_many?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Water_Viscosity_Options_ManyArgs, Maybe<Array<WithTypename<Water_Viscosity_Options_Mutation_Response>>>>,
  update_water_volume_factor_options?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Water_Volume_Factor_OptionsArgs, Maybe<WithTypename<Water_Volume_Factor_Options_Mutation_Response>>>,
  update_water_volume_factor_options_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Water_Volume_Factor_Options_By_PkArgs, Maybe<WithTypename<Water_Volume_Factor_Options>>>,
  update_water_volume_factor_options_many?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Water_Volume_Factor_Options_ManyArgs, Maybe<Array<WithTypename<Water_Volume_Factor_Options_Mutation_Response>>>>,
  update_well_gas_type_options?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Well_Gas_Type_OptionsArgs, Maybe<WithTypename<Well_Gas_Type_Options_Mutation_Response>>>,
  update_well_gas_type_options_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Well_Gas_Type_Options_By_PkArgs, Maybe<WithTypename<Well_Gas_Type_Options>>>,
  update_well_gas_type_options_many?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Well_Gas_Type_Options_ManyArgs, Maybe<Array<WithTypename<Well_Gas_Type_Options_Mutation_Response>>>>,
  update_well_test_gas_input_options?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Well_Test_Gas_Input_OptionsArgs, Maybe<WithTypename<Well_Test_Gas_Input_Options_Mutation_Response>>>,
  update_well_test_gas_input_options_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Well_Test_Gas_Input_Options_By_PkArgs, Maybe<WithTypename<Well_Test_Gas_Input_Options>>>,
  update_well_test_gas_input_options_many?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Well_Test_Gas_Input_Options_ManyArgs, Maybe<Array<WithTypename<Well_Test_Gas_Input_Options_Mutation_Response>>>>,
  update_well_test_liquid_input_options?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Well_Test_Liquid_Input_OptionsArgs, Maybe<WithTypename<Well_Test_Liquid_Input_Options_Mutation_Response>>>,
  update_well_test_liquid_input_options_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Well_Test_Liquid_Input_Options_By_PkArgs, Maybe<WithTypename<Well_Test_Liquid_Input_Options>>>,
  update_well_test_liquid_input_options_many?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Well_Test_Liquid_Input_Options_ManyArgs, Maybe<Array<WithTypename<Well_Test_Liquid_Input_Options_Mutation_Response>>>>,
  update_well_test_pressure_input_options?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Well_Test_Pressure_Input_OptionsArgs, Maybe<WithTypename<Well_Test_Pressure_Input_Options_Mutation_Response>>>,
  update_well_test_pressure_input_options_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Well_Test_Pressure_Input_Options_By_PkArgs, Maybe<WithTypename<Well_Test_Pressure_Input_Options>>>,
  update_well_test_pressure_input_options_many?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Well_Test_Pressure_Input_Options_ManyArgs, Maybe<Array<WithTypename<Well_Test_Pressure_Input_Options_Mutation_Response>>>>,
  update_wells?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_WellsArgs, Maybe<WithTypename<Wells_Mutation_Response>>>,
  update_wells_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Wells_By_PkArgs, Maybe<WithTypename<Wells>>>,
  update_wells_many?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Wells_ManyArgs, Maybe<Array<WithTypename<Wells_Mutation_Response>>>>,
  update_y_tools?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Y_ToolsArgs, Maybe<WithTypename<Y_Tools_Mutation_Response>>>,
  update_y_tools_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Y_Tools_By_PkArgs, Maybe<WithTypename<Y_Tools>>>,
  update_y_tools_many?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Y_Tools_ManyArgs, Maybe<Array<WithTypename<Y_Tools_Mutation_Response>>>>
};

export type GraphCacheUpdaters = {
  Mutation?: {
    createSKJob?: GraphCacheUpdateResolver<{ createSKJob: Maybe<WithTypename<SkJob>> }, Mutation_RootCreateSkJobArgs>,
    createSKQuote?: GraphCacheUpdateResolver<{ createSKQuote: Maybe<WithTypename<SkQuote>> }, Mutation_RootCreateSkQuoteArgs>,
    deleteSKQuote?: GraphCacheUpdateResolver<{ deleteSKQuote: Maybe<WithTypename<SkDeleteQuote>> }, Mutation_RootDeleteSkQuoteArgs>,
    delete_bolt_on_discharges?: GraphCacheUpdateResolver<{ delete_bolt_on_discharges: Maybe<WithTypename<Bolt_On_Discharges_Mutation_Response>> }, Mutation_RootDelete_Bolt_On_DischargesArgs>,
    delete_bolt_on_discharges_by_pk?: GraphCacheUpdateResolver<{ delete_bolt_on_discharges_by_pk: Maybe<WithTypename<Bolt_On_Discharges>> }, Mutation_RootDelete_Bolt_On_Discharges_By_PkArgs>,
    delete_bubble_point_options?: GraphCacheUpdateResolver<{ delete_bubble_point_options: Maybe<WithTypename<Bubble_Point_Options_Mutation_Response>> }, Mutation_RootDelete_Bubble_Point_OptionsArgs>,
    delete_bubble_point_options_by_pk?: GraphCacheUpdateResolver<{ delete_bubble_point_options_by_pk: Maybe<WithTypename<Bubble_Point_Options>> }, Mutation_RootDelete_Bubble_Point_Options_By_PkArgs>,
    delete_cables?: GraphCacheUpdateResolver<{ delete_cables: Maybe<WithTypename<Cables_Mutation_Response>> }, Mutation_RootDelete_CablesArgs>,
    delete_cables_by_pk?: GraphCacheUpdateResolver<{ delete_cables_by_pk: Maybe<WithTypename<Cables>> }, Mutation_RootDelete_Cables_By_PkArgs>,
    delete_casing_flow_options?: GraphCacheUpdateResolver<{ delete_casing_flow_options: Maybe<WithTypename<Casing_Flow_Options_Mutation_Response>> }, Mutation_RootDelete_Casing_Flow_OptionsArgs>,
    delete_casing_flow_options_by_pk?: GraphCacheUpdateResolver<{ delete_casing_flow_options_by_pk: Maybe<WithTypename<Casing_Flow_Options>> }, Mutation_RootDelete_Casing_Flow_Options_By_PkArgs>,
    delete_casings?: GraphCacheUpdateResolver<{ delete_casings: Maybe<WithTypename<Casings_Mutation_Response>> }, Mutation_RootDelete_CasingsArgs>,
    delete_casings_by_pk?: GraphCacheUpdateResolver<{ delete_casings_by_pk: Maybe<WithTypename<Casings>> }, Mutation_RootDelete_Casings_By_PkArgs>,
    delete_casings_type?: GraphCacheUpdateResolver<{ delete_casings_type: Maybe<WithTypename<Casings_Type_Mutation_Response>> }, Mutation_RootDelete_Casings_TypeArgs>,
    delete_casings_type_by_pk?: GraphCacheUpdateResolver<{ delete_casings_type_by_pk: Maybe<WithTypename<Casings_Type>> }, Mutation_RootDelete_Casings_Type_By_PkArgs>,
    delete_customers?: GraphCacheUpdateResolver<{ delete_customers: Maybe<WithTypename<Customers_Mutation_Response>> }, Mutation_RootDelete_CustomersArgs>,
    delete_customers_by_pk?: GraphCacheUpdateResolver<{ delete_customers_by_pk: Maybe<WithTypename<Customers>> }, Mutation_RootDelete_Customers_By_PkArgs>,
    delete_dead_oil_options?: GraphCacheUpdateResolver<{ delete_dead_oil_options: Maybe<WithTypename<Dead_Oil_Options_Mutation_Response>> }, Mutation_RootDelete_Dead_Oil_OptionsArgs>,
    delete_dead_oil_options_by_pk?: GraphCacheUpdateResolver<{ delete_dead_oil_options_by_pk: Maybe<WithTypename<Dead_Oil_Options>> }, Mutation_RootDelete_Dead_Oil_Options_By_PkArgs>,
    delete_deviation_survey?: GraphCacheUpdateResolver<{ delete_deviation_survey: Maybe<WithTypename<Deviation_Survey_Mutation_Response>> }, Mutation_RootDelete_Deviation_SurveyArgs>,
    delete_deviation_survey_by_pk?: GraphCacheUpdateResolver<{ delete_deviation_survey_by_pk: Maybe<WithTypename<Deviation_Survey>> }, Mutation_RootDelete_Deviation_Survey_By_PkArgs>,
    delete_deviation_survey_directional_dataset?: GraphCacheUpdateResolver<{ delete_deviation_survey_directional_dataset: Maybe<WithTypename<Deviation_Survey_Directional_Dataset_Mutation_Response>> }, Mutation_RootDelete_Deviation_Survey_Directional_DatasetArgs>,
    delete_deviation_survey_directional_dataset_by_pk?: GraphCacheUpdateResolver<{ delete_deviation_survey_directional_dataset_by_pk: Maybe<WithTypename<Deviation_Survey_Directional_Dataset>> }, Mutation_RootDelete_Deviation_Survey_Directional_Dataset_By_PkArgs>,
    delete_display_units?: GraphCacheUpdateResolver<{ delete_display_units: Maybe<WithTypename<Display_Units_Mutation_Response>> }, Mutation_RootDelete_Display_UnitsArgs>,
    delete_display_units_by_pk?: GraphCacheUpdateResolver<{ delete_display_units_by_pk: Maybe<WithTypename<Display_Units>> }, Mutation_RootDelete_Display_Units_By_PkArgs>,
    delete_eula?: GraphCacheUpdateResolver<{ delete_eula: Maybe<WithTypename<Eula_Mutation_Response>> }, Mutation_RootDelete_EulaArgs>,
    delete_eula_by_pk?: GraphCacheUpdateResolver<{ delete_eula_by_pk: Maybe<WithTypename<Eula>> }, Mutation_RootDelete_Eula_By_PkArgs>,
    delete_flow_model?: GraphCacheUpdateResolver<{ delete_flow_model: Maybe<WithTypename<Flow_Model_Mutation_Response>> }, Mutation_RootDelete_Flow_ModelArgs>,
    delete_flow_model_active?: GraphCacheUpdateResolver<{ delete_flow_model_active: Maybe<WithTypename<Flow_Model_Active_Mutation_Response>> }, Mutation_RootDelete_Flow_Model_ActiveArgs>,
    delete_flow_model_by_pk?: GraphCacheUpdateResolver<{ delete_flow_model_by_pk: Maybe<WithTypename<Flow_Model>> }, Mutation_RootDelete_Flow_Model_By_PkArgs>,
    delete_flow_model_deprecated?: GraphCacheUpdateResolver<{ delete_flow_model_deprecated: Maybe<WithTypename<Flow_Model_Deprecated_Mutation_Response>> }, Mutation_RootDelete_Flow_Model_DeprecatedArgs>,
    delete_flow_model_deprecated_by_pk?: GraphCacheUpdateResolver<{ delete_flow_model_deprecated_by_pk: Maybe<WithTypename<Flow_Model_Deprecated>> }, Mutation_RootDelete_Flow_Model_Deprecated_By_PkArgs>,
    delete_friction_loss_options?: GraphCacheUpdateResolver<{ delete_friction_loss_options: Maybe<WithTypename<Friction_Loss_Options_Mutation_Response>> }, Mutation_RootDelete_Friction_Loss_OptionsArgs>,
    delete_friction_loss_options_by_pk?: GraphCacheUpdateResolver<{ delete_friction_loss_options_by_pk: Maybe<WithTypename<Friction_Loss_Options>> }, Mutation_RootDelete_Friction_Loss_Options_By_PkArgs>,
    delete_gas_compressibility_options?: GraphCacheUpdateResolver<{ delete_gas_compressibility_options: Maybe<WithTypename<Gas_Compressibility_Options_Mutation_Response>> }, Mutation_RootDelete_Gas_Compressibility_OptionsArgs>,
    delete_gas_compressibility_options_by_pk?: GraphCacheUpdateResolver<{ delete_gas_compressibility_options_by_pk: Maybe<WithTypename<Gas_Compressibility_Options>> }, Mutation_RootDelete_Gas_Compressibility_Options_By_PkArgs>,
    delete_gas_viscosity_options?: GraphCacheUpdateResolver<{ delete_gas_viscosity_options: Maybe<WithTypename<Gas_Viscosity_Options_Mutation_Response>> }, Mutation_RootDelete_Gas_Viscosity_OptionsArgs>,
    delete_gas_viscosity_options_by_pk?: GraphCacheUpdateResolver<{ delete_gas_viscosity_options_by_pk: Maybe<WithTypename<Gas_Viscosity_Options>> }, Mutation_RootDelete_Gas_Viscosity_Options_By_PkArgs>,
    delete_housings?: GraphCacheUpdateResolver<{ delete_housings: Maybe<WithTypename<Housings_Mutation_Response>> }, Mutation_RootDelete_HousingsArgs>,
    delete_housings_by_pk?: GraphCacheUpdateResolver<{ delete_housings_by_pk: Maybe<WithTypename<Housings>> }, Mutation_RootDelete_Housings_By_PkArgs>,
    delete_hps_liquid_type?: GraphCacheUpdateResolver<{ delete_hps_liquid_type: Maybe<WithTypename<Hps_Liquid_Type_Mutation_Response>> }, Mutation_RootDelete_Hps_Liquid_TypeArgs>,
    delete_hps_liquid_type_by_pk?: GraphCacheUpdateResolver<{ delete_hps_liquid_type_by_pk: Maybe<WithTypename<Hps_Liquid_Type>> }, Mutation_RootDelete_Hps_Liquid_Type_By_PkArgs>,
    delete_intakes?: GraphCacheUpdateResolver<{ delete_intakes: Maybe<WithTypename<Intakes_Mutation_Response>> }, Mutation_RootDelete_IntakesArgs>,
    delete_intakes_by_pk?: GraphCacheUpdateResolver<{ delete_intakes_by_pk: Maybe<WithTypename<Intakes>> }, Mutation_RootDelete_Intakes_By_PkArgs>,
    delete_legacy_users?: GraphCacheUpdateResolver<{ delete_legacy_users: Maybe<WithTypename<Legacy_Users_Mutation_Response>> }, Mutation_RootDelete_Legacy_UsersArgs>,
    delete_legacy_users_by_pk?: GraphCacheUpdateResolver<{ delete_legacy_users_by_pk: Maybe<WithTypename<Legacy_Users>> }, Mutation_RootDelete_Legacy_Users_By_PkArgs>,
    delete_motor_lead_extensions?: GraphCacheUpdateResolver<{ delete_motor_lead_extensions: Maybe<WithTypename<Motor_Lead_Extensions_Mutation_Response>> }, Mutation_RootDelete_Motor_Lead_ExtensionsArgs>,
    delete_motor_lead_extensions_by_pk?: GraphCacheUpdateResolver<{ delete_motor_lead_extensions_by_pk: Maybe<WithTypename<Motor_Lead_Extensions>> }, Mutation_RootDelete_Motor_Lead_Extensions_By_PkArgs>,
    delete_motors?: GraphCacheUpdateResolver<{ delete_motors: Maybe<WithTypename<Motors_Mutation_Response>> }, Mutation_RootDelete_MotorsArgs>,
    delete_motors_by_pk?: GraphCacheUpdateResolver<{ delete_motors_by_pk: Maybe<WithTypename<Motors>> }, Mutation_RootDelete_Motors_By_PkArgs>,
    delete_natural_gas_separation_options?: GraphCacheUpdateResolver<{ delete_natural_gas_separation_options: Maybe<WithTypename<Natural_Gas_Separation_Options_Mutation_Response>> }, Mutation_RootDelete_Natural_Gas_Separation_OptionsArgs>,
    delete_natural_gas_separation_options_by_pk?: GraphCacheUpdateResolver<{ delete_natural_gas_separation_options_by_pk: Maybe<WithTypename<Natural_Gas_Separation_Options>> }, Mutation_RootDelete_Natural_Gas_Separation_Options_By_PkArgs>,
    delete_oil_density_options?: GraphCacheUpdateResolver<{ delete_oil_density_options: Maybe<WithTypename<Oil_Density_Options_Mutation_Response>> }, Mutation_RootDelete_Oil_Density_OptionsArgs>,
    delete_oil_density_options_by_pk?: GraphCacheUpdateResolver<{ delete_oil_density_options_by_pk: Maybe<WithTypename<Oil_Density_Options>> }, Mutation_RootDelete_Oil_Density_Options_By_PkArgs>,
    delete_oil_volume_factor_options?: GraphCacheUpdateResolver<{ delete_oil_volume_factor_options: Maybe<WithTypename<Oil_Volume_Factor_Options_Mutation_Response>> }, Mutation_RootDelete_Oil_Volume_Factor_OptionsArgs>,
    delete_oil_volume_factor_options_by_pk?: GraphCacheUpdateResolver<{ delete_oil_volume_factor_options_by_pk: Maybe<WithTypename<Oil_Volume_Factor_Options>> }, Mutation_RootDelete_Oil_Volume_Factor_Options_By_PkArgs>,
    delete_override_options?: GraphCacheUpdateResolver<{ delete_override_options: Maybe<WithTypename<Override_Options_Mutation_Response>> }, Mutation_RootDelete_Override_OptionsArgs>,
    delete_override_options_by_pk?: GraphCacheUpdateResolver<{ delete_override_options_by_pk: Maybe<WithTypename<Override_Options>> }, Mutation_RootDelete_Override_Options_By_PkArgs>,
    delete_pumps?: GraphCacheUpdateResolver<{ delete_pumps: Maybe<WithTypename<Pumps_Mutation_Response>> }, Mutation_RootDelete_PumpsArgs>,
    delete_pumps_by_pk?: GraphCacheUpdateResolver<{ delete_pumps_by_pk: Maybe<WithTypename<Pumps>> }, Mutation_RootDelete_Pumps_By_PkArgs>,
    delete_quote_line_item_category_dataset?: GraphCacheUpdateResolver<{ delete_quote_line_item_category_dataset: Maybe<WithTypename<Quote_Line_Item_Category_Dataset_Mutation_Response>> }, Mutation_RootDelete_Quote_Line_Item_Category_DatasetArgs>,
    delete_quote_line_item_category_dataset_by_pk?: GraphCacheUpdateResolver<{ delete_quote_line_item_category_dataset_by_pk: Maybe<WithTypename<Quote_Line_Item_Category_Dataset>> }, Mutation_RootDelete_Quote_Line_Item_Category_Dataset_By_PkArgs>,
    delete_quote_line_item_serialized_dataset?: GraphCacheUpdateResolver<{ delete_quote_line_item_serialized_dataset: Maybe<WithTypename<Quote_Line_Item_Serialized_Dataset_Mutation_Response>> }, Mutation_RootDelete_Quote_Line_Item_Serialized_DatasetArgs>,
    delete_quote_line_item_serialized_dataset_by_pk?: GraphCacheUpdateResolver<{ delete_quote_line_item_serialized_dataset_by_pk: Maybe<WithTypename<Quote_Line_Item_Serialized_Dataset>> }, Mutation_RootDelete_Quote_Line_Item_Serialized_Dataset_By_PkArgs>,
    delete_quote_line_item_source_dataset?: GraphCacheUpdateResolver<{ delete_quote_line_item_source_dataset: Maybe<WithTypename<Quote_Line_Item_Source_Dataset_Mutation_Response>> }, Mutation_RootDelete_Quote_Line_Item_Source_DatasetArgs>,
    delete_quote_line_item_source_dataset_by_pk?: GraphCacheUpdateResolver<{ delete_quote_line_item_source_dataset_by_pk: Maybe<WithTypename<Quote_Line_Item_Source_Dataset>> }, Mutation_RootDelete_Quote_Line_Item_Source_Dataset_By_PkArgs>,
    delete_quote_line_item_subcategory_dataset?: GraphCacheUpdateResolver<{ delete_quote_line_item_subcategory_dataset: Maybe<WithTypename<Quote_Line_Item_Subcategory_Dataset_Mutation_Response>> }, Mutation_RootDelete_Quote_Line_Item_Subcategory_DatasetArgs>,
    delete_quote_line_item_subcategory_dataset_by_pk?: GraphCacheUpdateResolver<{ delete_quote_line_item_subcategory_dataset_by_pk: Maybe<WithTypename<Quote_Line_Item_Subcategory_Dataset>> }, Mutation_RootDelete_Quote_Line_Item_Subcategory_Dataset_By_PkArgs>,
    delete_quote_line_item_tax_type_dataset?: GraphCacheUpdateResolver<{ delete_quote_line_item_tax_type_dataset: Maybe<WithTypename<Quote_Line_Item_Tax_Type_Dataset_Mutation_Response>> }, Mutation_RootDelete_Quote_Line_Item_Tax_Type_DatasetArgs>,
    delete_quote_line_item_tax_type_dataset_by_pk?: GraphCacheUpdateResolver<{ delete_quote_line_item_tax_type_dataset_by_pk: Maybe<WithTypename<Quote_Line_Item_Tax_Type_Dataset>> }, Mutation_RootDelete_Quote_Line_Item_Tax_Type_Dataset_By_PkArgs>,
    delete_quote_line_item_type_dataset?: GraphCacheUpdateResolver<{ delete_quote_line_item_type_dataset: Maybe<WithTypename<Quote_Line_Item_Type_Dataset_Mutation_Response>> }, Mutation_RootDelete_Quote_Line_Item_Type_DatasetArgs>,
    delete_quote_line_item_type_dataset_by_pk?: GraphCacheUpdateResolver<{ delete_quote_line_item_type_dataset_by_pk: Maybe<WithTypename<Quote_Line_Item_Type_Dataset>> }, Mutation_RootDelete_Quote_Line_Item_Type_Dataset_By_PkArgs>,
    delete_quote_line_items?: GraphCacheUpdateResolver<{ delete_quote_line_items: Maybe<WithTypename<Quote_Line_Items_Mutation_Response>> }, Mutation_RootDelete_Quote_Line_ItemsArgs>,
    delete_quote_line_items_by_pk?: GraphCacheUpdateResolver<{ delete_quote_line_items_by_pk: Maybe<WithTypename<Quote_Line_Items>> }, Mutation_RootDelete_Quote_Line_Items_By_PkArgs>,
    delete_quote_sk_job_type_dataset?: GraphCacheUpdateResolver<{ delete_quote_sk_job_type_dataset: Maybe<WithTypename<Quote_Sk_Job_Type_Dataset_Mutation_Response>> }, Mutation_RootDelete_Quote_Sk_Job_Type_DatasetArgs>,
    delete_quote_sk_job_type_dataset_by_pk?: GraphCacheUpdateResolver<{ delete_quote_sk_job_type_dataset_by_pk: Maybe<WithTypename<Quote_Sk_Job_Type_Dataset>> }, Mutation_RootDelete_Quote_Sk_Job_Type_Dataset_By_PkArgs>,
    delete_quote_source_dataset?: GraphCacheUpdateResolver<{ delete_quote_source_dataset: Maybe<WithTypename<Quote_Source_Dataset_Mutation_Response>> }, Mutation_RootDelete_Quote_Source_DatasetArgs>,
    delete_quote_source_dataset_by_pk?: GraphCacheUpdateResolver<{ delete_quote_source_dataset_by_pk: Maybe<WithTypename<Quote_Source_Dataset>> }, Mutation_RootDelete_Quote_Source_Dataset_By_PkArgs>,
    delete_quote_status_dataset?: GraphCacheUpdateResolver<{ delete_quote_status_dataset: Maybe<WithTypename<Quote_Status_Dataset_Mutation_Response>> }, Mutation_RootDelete_Quote_Status_DatasetArgs>,
    delete_quote_status_dataset_by_pk?: GraphCacheUpdateResolver<{ delete_quote_status_dataset_by_pk: Maybe<WithTypename<Quote_Status_Dataset>> }, Mutation_RootDelete_Quote_Status_Dataset_By_PkArgs>,
    delete_quote_user_messages?: GraphCacheUpdateResolver<{ delete_quote_user_messages: Maybe<WithTypename<Quote_User_Messages_Mutation_Response>> }, Mutation_RootDelete_Quote_User_MessagesArgs>,
    delete_quote_user_messages_by_pk?: GraphCacheUpdateResolver<{ delete_quote_user_messages_by_pk: Maybe<WithTypename<Quote_User_Messages>> }, Mutation_RootDelete_Quote_User_Messages_By_PkArgs>,
    delete_quotes?: GraphCacheUpdateResolver<{ delete_quotes: Maybe<WithTypename<Quotes_Mutation_Response>> }, Mutation_RootDelete_QuotesArgs>,
    delete_quotes_by_pk?: GraphCacheUpdateResolver<{ delete_quotes_by_pk: Maybe<WithTypename<Quotes>> }, Mutation_RootDelete_Quotes_By_PkArgs>,
    delete_revisions_performance_evaluations_journal?: GraphCacheUpdateResolver<{ delete_revisions_performance_evaluations_journal: Maybe<WithTypename<Revisions_Performance_Evaluations_Journal_Mutation_Response>> }, Mutation_RootDelete_Revisions_Performance_Evaluations_JournalArgs>,
    delete_revisions_performance_evaluations_journal_by_pk?: GraphCacheUpdateResolver<{ delete_revisions_performance_evaluations_journal_by_pk: Maybe<WithTypename<Revisions_Performance_Evaluations_Journal>> }, Mutation_RootDelete_Revisions_Performance_Evaluations_Journal_By_PkArgs>,
    delete_revisions_performance_evaluations_revisions?: GraphCacheUpdateResolver<{ delete_revisions_performance_evaluations_revisions: Maybe<WithTypename<Revisions_Performance_Evaluations_Revisions_Mutation_Response>> }, Mutation_RootDelete_Revisions_Performance_Evaluations_RevisionsArgs>,
    delete_revisions_performance_evaluations_revisions_by_pk?: GraphCacheUpdateResolver<{ delete_revisions_performance_evaluations_revisions_by_pk: Maybe<WithTypename<Revisions_Performance_Evaluations_Revisions>> }, Mutation_RootDelete_Revisions_Performance_Evaluations_Revisions_By_PkArgs>,
    delete_revisions_performance_evaluations_xref_pumps_journal?: GraphCacheUpdateResolver<{ delete_revisions_performance_evaluations_xref_pumps_journal: Maybe<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Journal_Mutation_Response>> }, Mutation_RootDelete_Revisions_Performance_Evaluations_Xref_Pumps_JournalArgs>,
    delete_revisions_performance_evaluations_xref_pumps_journal_by_pk?: GraphCacheUpdateResolver<{ delete_revisions_performance_evaluations_xref_pumps_journal_by_pk: Maybe<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Journal>> }, Mutation_RootDelete_Revisions_Performance_Evaluations_Xref_Pumps_Journal_By_PkArgs>,
    delete_revisions_performance_evaluations_xref_pumps_revisions?: GraphCacheUpdateResolver<{ delete_revisions_performance_evaluations_xref_pumps_revisions: Maybe<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Mutation_Response>> }, Mutation_RootDelete_Revisions_Performance_Evaluations_Xref_Pumps_RevisionsArgs>,
    delete_revisions_performance_evaluations_xref_pumps_revisions_by_pk?: GraphCacheUpdateResolver<{ delete_revisions_performance_evaluations_xref_pumps_revisions_by_pk: Maybe<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Revisions>> }, Mutation_RootDelete_Revisions_Performance_Evaluations_Xref_Pumps_Revisions_By_PkArgs>,
    delete_revisions_sc_equip_xref_downhole_ytool_bypass_tubings_journal?: GraphCacheUpdateResolver<{ delete_revisions_sc_equip_xref_downhole_ytool_bypass_tubings_journal: Maybe<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_Mutation_Response>> }, Mutation_RootDelete_Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_JournalArgs>,
    delete_revisions_sc_equip_xref_downhole_ytool_bypass_tubings_journal_by_pk?: GraphCacheUpdateResolver<{ delete_revisions_sc_equip_xref_downhole_ytool_bypass_tubings_journal_by_pk: Maybe<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal>> }, Mutation_RootDelete_Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_By_PkArgs>,
    delete_revisions_sc_equip_xref_downhole_ytool_bypass_tubings_revisions?: GraphCacheUpdateResolver<{ delete_revisions_sc_equip_xref_downhole_ytool_bypass_tubings_revisions: Maybe<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Mutation_Response>> }, Mutation_RootDelete_Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_RevisionsArgs>,
    delete_revisions_sc_equip_xref_downhole_ytool_bypass_tubings_revisions_by_pk?: GraphCacheUpdateResolver<{ delete_revisions_sc_equip_xref_downhole_ytool_bypass_tubings_revisions_by_pk: Maybe<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions>> }, Mutation_RootDelete_Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_By_PkArgs>,
    delete_revisions_sc_equip_xref_downhole_ytool_equip_tubings_journal?: GraphCacheUpdateResolver<{ delete_revisions_sc_equip_xref_downhole_ytool_equip_tubings_journal: Maybe<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_Mutation_Response>> }, Mutation_RootDelete_Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_JournalArgs>,
    delete_revisions_sc_equip_xref_downhole_ytool_equip_tubings_journal_by_pk?: GraphCacheUpdateResolver<{ delete_revisions_sc_equip_xref_downhole_ytool_equip_tubings_journal_by_pk: Maybe<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal>> }, Mutation_RootDelete_Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_By_PkArgs>,
    delete_revisions_sc_equip_xref_downhole_ytool_equip_tubings_revisions?: GraphCacheUpdateResolver<{ delete_revisions_sc_equip_xref_downhole_ytool_equip_tubings_revisions: Maybe<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Mutation_Response>> }, Mutation_RootDelete_Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_RevisionsArgs>,
    delete_revisions_sc_equip_xref_downhole_ytool_equip_tubings_revisions_by_pk?: GraphCacheUpdateResolver<{ delete_revisions_sc_equip_xref_downhole_ytool_equip_tubings_revisions_by_pk: Maybe<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions>> }, Mutation_RootDelete_Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_By_PkArgs>,
    delete_revisions_sc_equip_xref_uphole_ytool_bypass_tubings_journal?: GraphCacheUpdateResolver<{ delete_revisions_sc_equip_xref_uphole_ytool_bypass_tubings_journal: Maybe<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_Mutation_Response>> }, Mutation_RootDelete_Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_JournalArgs>,
    delete_revisions_sc_equip_xref_uphole_ytool_bypass_tubings_journal_by_pk?: GraphCacheUpdateResolver<{ delete_revisions_sc_equip_xref_uphole_ytool_bypass_tubings_journal_by_pk: Maybe<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal>> }, Mutation_RootDelete_Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_By_PkArgs>,
    delete_revisions_sc_equip_xref_uphole_ytool_bypass_tubings_revisions?: GraphCacheUpdateResolver<{ delete_revisions_sc_equip_xref_uphole_ytool_bypass_tubings_revisions: Maybe<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Mutation_Response>> }, Mutation_RootDelete_Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_RevisionsArgs>,
    delete_revisions_sc_equip_xref_uphole_ytool_bypass_tubings_revisions_by_pk?: GraphCacheUpdateResolver<{ delete_revisions_sc_equip_xref_uphole_ytool_bypass_tubings_revisions_by_pk: Maybe<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions>> }, Mutation_RootDelete_Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_By_PkArgs>,
    delete_revisions_sc_equip_xref_uphole_ytool_equip_tubings_journal?: GraphCacheUpdateResolver<{ delete_revisions_sc_equip_xref_uphole_ytool_equip_tubings_journal: Maybe<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_Mutation_Response>> }, Mutation_RootDelete_Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_JournalArgs>,
    delete_revisions_sc_equip_xref_uphole_ytool_equip_tubings_journal_by_pk?: GraphCacheUpdateResolver<{ delete_revisions_sc_equip_xref_uphole_ytool_equip_tubings_journal_by_pk: Maybe<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal>> }, Mutation_RootDelete_Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_By_PkArgs>,
    delete_revisions_sc_equip_xref_uphole_ytool_equip_tubings_revisions?: GraphCacheUpdateResolver<{ delete_revisions_sc_equip_xref_uphole_ytool_equip_tubings_revisions: Maybe<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Mutation_Response>> }, Mutation_RootDelete_Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_RevisionsArgs>,
    delete_revisions_sc_equip_xref_uphole_ytool_equip_tubings_revisions_by_pk?: GraphCacheUpdateResolver<{ delete_revisions_sc_equip_xref_uphole_ytool_equip_tubings_revisions_by_pk: Maybe<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions>> }, Mutation_RootDelete_Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_By_PkArgs>,
    delete_revisions_scenario_correlations_journal?: GraphCacheUpdateResolver<{ delete_revisions_scenario_correlations_journal: Maybe<WithTypename<Revisions_Scenario_Correlations_Journal_Mutation_Response>> }, Mutation_RootDelete_Revisions_Scenario_Correlations_JournalArgs>,
    delete_revisions_scenario_correlations_journal_by_pk?: GraphCacheUpdateResolver<{ delete_revisions_scenario_correlations_journal_by_pk: Maybe<WithTypename<Revisions_Scenario_Correlations_Journal>> }, Mutation_RootDelete_Revisions_Scenario_Correlations_Journal_By_PkArgs>,
    delete_revisions_scenario_correlations_revisions?: GraphCacheUpdateResolver<{ delete_revisions_scenario_correlations_revisions: Maybe<WithTypename<Revisions_Scenario_Correlations_Revisions_Mutation_Response>> }, Mutation_RootDelete_Revisions_Scenario_Correlations_RevisionsArgs>,
    delete_revisions_scenario_correlations_revisions_by_pk?: GraphCacheUpdateResolver<{ delete_revisions_scenario_correlations_revisions_by_pk: Maybe<WithTypename<Revisions_Scenario_Correlations_Revisions>> }, Mutation_RootDelete_Revisions_Scenario_Correlations_Revisions_By_PkArgs>,
    delete_revisions_scenario_equipment_journal?: GraphCacheUpdateResolver<{ delete_revisions_scenario_equipment_journal: Maybe<WithTypename<Revisions_Scenario_Equipment_Journal_Mutation_Response>> }, Mutation_RootDelete_Revisions_Scenario_Equipment_JournalArgs>,
    delete_revisions_scenario_equipment_journal_by_pk?: GraphCacheUpdateResolver<{ delete_revisions_scenario_equipment_journal_by_pk: Maybe<WithTypename<Revisions_Scenario_Equipment_Journal>> }, Mutation_RootDelete_Revisions_Scenario_Equipment_Journal_By_PkArgs>,
    delete_revisions_scenario_equipment_revisions?: GraphCacheUpdateResolver<{ delete_revisions_scenario_equipment_revisions: Maybe<WithTypename<Revisions_Scenario_Equipment_Revisions_Mutation_Response>> }, Mutation_RootDelete_Revisions_Scenario_Equipment_RevisionsArgs>,
    delete_revisions_scenario_equipment_revisions_by_pk?: GraphCacheUpdateResolver<{ delete_revisions_scenario_equipment_revisions_by_pk: Maybe<WithTypename<Revisions_Scenario_Equipment_Revisions>> }, Mutation_RootDelete_Revisions_Scenario_Equipment_Revisions_By_PkArgs>,
    delete_revisions_scenario_equipment_xref_cables_journal?: GraphCacheUpdateResolver<{ delete_revisions_scenario_equipment_xref_cables_journal: Maybe<WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Journal_Mutation_Response>> }, Mutation_RootDelete_Revisions_Scenario_Equipment_Xref_Cables_JournalArgs>,
    delete_revisions_scenario_equipment_xref_cables_journal_by_pk?: GraphCacheUpdateResolver<{ delete_revisions_scenario_equipment_xref_cables_journal_by_pk: Maybe<WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Journal>> }, Mutation_RootDelete_Revisions_Scenario_Equipment_Xref_Cables_Journal_By_PkArgs>,
    delete_revisions_scenario_equipment_xref_cables_revisions?: GraphCacheUpdateResolver<{ delete_revisions_scenario_equipment_xref_cables_revisions: Maybe<WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Mutation_Response>> }, Mutation_RootDelete_Revisions_Scenario_Equipment_Xref_Cables_RevisionsArgs>,
    delete_revisions_scenario_equipment_xref_cables_revisions_by_pk?: GraphCacheUpdateResolver<{ delete_revisions_scenario_equipment_xref_cables_revisions_by_pk: Maybe<WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Revisions>> }, Mutation_RootDelete_Revisions_Scenario_Equipment_Xref_Cables_Revisions_By_PkArgs>,
    delete_revisions_scenario_equipment_xref_housings_journal?: GraphCacheUpdateResolver<{ delete_revisions_scenario_equipment_xref_housings_journal: Maybe<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Journal_Mutation_Response>> }, Mutation_RootDelete_Revisions_Scenario_Equipment_Xref_Housings_JournalArgs>,
    delete_revisions_scenario_equipment_xref_housings_journal_by_pk?: GraphCacheUpdateResolver<{ delete_revisions_scenario_equipment_xref_housings_journal_by_pk: Maybe<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Journal>> }, Mutation_RootDelete_Revisions_Scenario_Equipment_Xref_Housings_Journal_By_PkArgs>,
    delete_revisions_scenario_equipment_xref_housings_revisions?: GraphCacheUpdateResolver<{ delete_revisions_scenario_equipment_xref_housings_revisions: Maybe<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Mutation_Response>> }, Mutation_RootDelete_Revisions_Scenario_Equipment_Xref_Housings_RevisionsArgs>,
    delete_revisions_scenario_equipment_xref_housings_revisions_by_pk?: GraphCacheUpdateResolver<{ delete_revisions_scenario_equipment_xref_housings_revisions_by_pk: Maybe<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Revisions>> }, Mutation_RootDelete_Revisions_Scenario_Equipment_Xref_Housings_Revisions_By_PkArgs>,
    delete_revisions_scenario_equipment_xref_intakes_journal?: GraphCacheUpdateResolver<{ delete_revisions_scenario_equipment_xref_intakes_journal: Maybe<WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Journal_Mutation_Response>> }, Mutation_RootDelete_Revisions_Scenario_Equipment_Xref_Intakes_JournalArgs>,
    delete_revisions_scenario_equipment_xref_intakes_journal_by_pk?: GraphCacheUpdateResolver<{ delete_revisions_scenario_equipment_xref_intakes_journal_by_pk: Maybe<WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Journal>> }, Mutation_RootDelete_Revisions_Scenario_Equipment_Xref_Intakes_Journal_By_PkArgs>,
    delete_revisions_scenario_equipment_xref_intakes_revisions?: GraphCacheUpdateResolver<{ delete_revisions_scenario_equipment_xref_intakes_revisions: Maybe<WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Mutation_Response>> }, Mutation_RootDelete_Revisions_Scenario_Equipment_Xref_Intakes_RevisionsArgs>,
    delete_revisions_scenario_equipment_xref_intakes_revisions_by_pk?: GraphCacheUpdateResolver<{ delete_revisions_scenario_equipment_xref_intakes_revisions_by_pk: Maybe<WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Revisions>> }, Mutation_RootDelete_Revisions_Scenario_Equipment_Xref_Intakes_Revisions_By_PkArgs>,
    delete_revisions_scenario_equipment_xref_pumps_journal?: GraphCacheUpdateResolver<{ delete_revisions_scenario_equipment_xref_pumps_journal: Maybe<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Journal_Mutation_Response>> }, Mutation_RootDelete_Revisions_Scenario_Equipment_Xref_Pumps_JournalArgs>,
    delete_revisions_scenario_equipment_xref_pumps_journal_by_pk?: GraphCacheUpdateResolver<{ delete_revisions_scenario_equipment_xref_pumps_journal_by_pk: Maybe<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Journal>> }, Mutation_RootDelete_Revisions_Scenario_Equipment_Xref_Pumps_Journal_By_PkArgs>,
    delete_revisions_scenario_equipment_xref_pumps_revisions?: GraphCacheUpdateResolver<{ delete_revisions_scenario_equipment_xref_pumps_revisions: Maybe<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Mutation_Response>> }, Mutation_RootDelete_Revisions_Scenario_Equipment_Xref_Pumps_RevisionsArgs>,
    delete_revisions_scenario_equipment_xref_pumps_revisions_by_pk?: GraphCacheUpdateResolver<{ delete_revisions_scenario_equipment_xref_pumps_revisions_by_pk: Maybe<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions>> }, Mutation_RootDelete_Revisions_Scenario_Equipment_Xref_Pumps_Revisions_By_PkArgs>,
    delete_revisions_scenario_equipment_xref_seals_journal?: GraphCacheUpdateResolver<{ delete_revisions_scenario_equipment_xref_seals_journal: Maybe<WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Journal_Mutation_Response>> }, Mutation_RootDelete_Revisions_Scenario_Equipment_Xref_Seals_JournalArgs>,
    delete_revisions_scenario_equipment_xref_seals_journal_by_pk?: GraphCacheUpdateResolver<{ delete_revisions_scenario_equipment_xref_seals_journal_by_pk: Maybe<WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Journal>> }, Mutation_RootDelete_Revisions_Scenario_Equipment_Xref_Seals_Journal_By_PkArgs>,
    delete_revisions_scenario_equipment_xref_seals_revisions?: GraphCacheUpdateResolver<{ delete_revisions_scenario_equipment_xref_seals_revisions: Maybe<WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Revisions_Mutation_Response>> }, Mutation_RootDelete_Revisions_Scenario_Equipment_Xref_Seals_RevisionsArgs>,
    delete_revisions_scenario_equipment_xref_seals_revisions_by_pk?: GraphCacheUpdateResolver<{ delete_revisions_scenario_equipment_xref_seals_revisions_by_pk: Maybe<WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Revisions>> }, Mutation_RootDelete_Revisions_Scenario_Equipment_Xref_Seals_Revisions_By_PkArgs>,
    delete_revisions_scenario_parameters_journal?: GraphCacheUpdateResolver<{ delete_revisions_scenario_parameters_journal: Maybe<WithTypename<Revisions_Scenario_Parameters_Journal_Mutation_Response>> }, Mutation_RootDelete_Revisions_Scenario_Parameters_JournalArgs>,
    delete_revisions_scenario_parameters_journal_by_pk?: GraphCacheUpdateResolver<{ delete_revisions_scenario_parameters_journal_by_pk: Maybe<WithTypename<Revisions_Scenario_Parameters_Journal>> }, Mutation_RootDelete_Revisions_Scenario_Parameters_Journal_By_PkArgs>,
    delete_revisions_scenario_parameters_revisions?: GraphCacheUpdateResolver<{ delete_revisions_scenario_parameters_revisions: Maybe<WithTypename<Revisions_Scenario_Parameters_Revisions_Mutation_Response>> }, Mutation_RootDelete_Revisions_Scenario_Parameters_RevisionsArgs>,
    delete_revisions_scenario_parameters_revisions_by_pk?: GraphCacheUpdateResolver<{ delete_revisions_scenario_parameters_revisions_by_pk: Maybe<WithTypename<Revisions_Scenario_Parameters_Revisions>> }, Mutation_RootDelete_Revisions_Scenario_Parameters_Revisions_By_PkArgs>,
    delete_revisions_scenario_well_properties_journal?: GraphCacheUpdateResolver<{ delete_revisions_scenario_well_properties_journal: Maybe<WithTypename<Revisions_Scenario_Well_Properties_Journal_Mutation_Response>> }, Mutation_RootDelete_Revisions_Scenario_Well_Properties_JournalArgs>,
    delete_revisions_scenario_well_properties_journal_by_pk?: GraphCacheUpdateResolver<{ delete_revisions_scenario_well_properties_journal_by_pk: Maybe<WithTypename<Revisions_Scenario_Well_Properties_Journal>> }, Mutation_RootDelete_Revisions_Scenario_Well_Properties_Journal_By_PkArgs>,
    delete_revisions_scenario_well_properties_revisions?: GraphCacheUpdateResolver<{ delete_revisions_scenario_well_properties_revisions: Maybe<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Mutation_Response>> }, Mutation_RootDelete_Revisions_Scenario_Well_Properties_RevisionsArgs>,
    delete_revisions_scenario_well_properties_revisions_by_pk?: GraphCacheUpdateResolver<{ delete_revisions_scenario_well_properties_revisions_by_pk: Maybe<WithTypename<Revisions_Scenario_Well_Properties_Revisions>> }, Mutation_RootDelete_Revisions_Scenario_Well_Properties_Revisions_By_PkArgs>,
    delete_revisions_scenarios_journal?: GraphCacheUpdateResolver<{ delete_revisions_scenarios_journal: Maybe<WithTypename<Revisions_Scenarios_Journal_Mutation_Response>> }, Mutation_RootDelete_Revisions_Scenarios_JournalArgs>,
    delete_revisions_scenarios_journal_by_pk?: GraphCacheUpdateResolver<{ delete_revisions_scenarios_journal_by_pk: Maybe<WithTypename<Revisions_Scenarios_Journal>> }, Mutation_RootDelete_Revisions_Scenarios_Journal_By_PkArgs>,
    delete_revisions_scenarios_revisions?: GraphCacheUpdateResolver<{ delete_revisions_scenarios_revisions: Maybe<WithTypename<Revisions_Scenarios_Revisions_Mutation_Response>> }, Mutation_RootDelete_Revisions_Scenarios_RevisionsArgs>,
    delete_revisions_scenarios_revisions_by_pk?: GraphCacheUpdateResolver<{ delete_revisions_scenarios_revisions_by_pk: Maybe<WithTypename<Revisions_Scenarios_Revisions>> }, Mutation_RootDelete_Revisions_Scenarios_Revisions_By_PkArgs>,
    delete_revisions_sizings_journal?: GraphCacheUpdateResolver<{ delete_revisions_sizings_journal: Maybe<WithTypename<Revisions_Sizings_Journal_Mutation_Response>> }, Mutation_RootDelete_Revisions_Sizings_JournalArgs>,
    delete_revisions_sizings_journal_by_pk?: GraphCacheUpdateResolver<{ delete_revisions_sizings_journal_by_pk: Maybe<WithTypename<Revisions_Sizings_Journal>> }, Mutation_RootDelete_Revisions_Sizings_Journal_By_PkArgs>,
    delete_revisions_sizings_revisions?: GraphCacheUpdateResolver<{ delete_revisions_sizings_revisions: Maybe<WithTypename<Revisions_Sizings_Revisions_Mutation_Response>> }, Mutation_RootDelete_Revisions_Sizings_RevisionsArgs>,
    delete_revisions_sizings_revisions_by_pk?: GraphCacheUpdateResolver<{ delete_revisions_sizings_revisions_by_pk: Maybe<WithTypename<Revisions_Sizings_Revisions>> }, Mutation_RootDelete_Revisions_Sizings_Revisions_By_PkArgs>,
    delete_saturated_oil_options?: GraphCacheUpdateResolver<{ delete_saturated_oil_options: Maybe<WithTypename<Saturated_Oil_Options_Mutation_Response>> }, Mutation_RootDelete_Saturated_Oil_OptionsArgs>,
    delete_saturated_oil_options_by_pk?: GraphCacheUpdateResolver<{ delete_saturated_oil_options_by_pk: Maybe<WithTypename<Saturated_Oil_Options>> }, Mutation_RootDelete_Saturated_Oil_Options_By_PkArgs>,
    delete_scenario_reasons?: GraphCacheUpdateResolver<{ delete_scenario_reasons: Maybe<WithTypename<Scenario_Reasons_Mutation_Response>> }, Mutation_RootDelete_Scenario_ReasonsArgs>,
    delete_scenario_reasons_by_pk?: GraphCacheUpdateResolver<{ delete_scenario_reasons_by_pk: Maybe<WithTypename<Scenario_Reasons>> }, Mutation_RootDelete_Scenario_Reasons_By_PkArgs>,
    delete_seal_motor_oil?: GraphCacheUpdateResolver<{ delete_seal_motor_oil: Maybe<WithTypename<Seal_Motor_Oil_Mutation_Response>> }, Mutation_RootDelete_Seal_Motor_OilArgs>,
    delete_seal_motor_oil_by_pk?: GraphCacheUpdateResolver<{ delete_seal_motor_oil_by_pk: Maybe<WithTypename<Seal_Motor_Oil>> }, Mutation_RootDelete_Seal_Motor_Oil_By_PkArgs>,
    delete_seals?: GraphCacheUpdateResolver<{ delete_seals: Maybe<WithTypename<Seals_Mutation_Response>> }, Mutation_RootDelete_SealsArgs>,
    delete_seals_by_pk?: GraphCacheUpdateResolver<{ delete_seals_by_pk: Maybe<WithTypename<Seals>> }, Mutation_RootDelete_Seals_By_PkArgs>,
    delete_sensors?: GraphCacheUpdateResolver<{ delete_sensors: Maybe<WithTypename<Sensors_Mutation_Response>> }, Mutation_RootDelete_SensorsArgs>,
    delete_sensors_by_pk?: GraphCacheUpdateResolver<{ delete_sensors_by_pk: Maybe<WithTypename<Sensors>> }, Mutation_RootDelete_Sensors_By_PkArgs>,
    delete_sizing_dispositions?: GraphCacheUpdateResolver<{ delete_sizing_dispositions: Maybe<WithTypename<Sizing_Dispositions_Mutation_Response>> }, Mutation_RootDelete_Sizing_DispositionsArgs>,
    delete_sizing_dispositions_by_pk?: GraphCacheUpdateResolver<{ delete_sizing_dispositions_by_pk: Maybe<WithTypename<Sizing_Dispositions>> }, Mutation_RootDelete_Sizing_Dispositions_By_PkArgs>,
    delete_sizing_imports?: GraphCacheUpdateResolver<{ delete_sizing_imports: Maybe<WithTypename<Sizing_Imports_Mutation_Response>> }, Mutation_RootDelete_Sizing_ImportsArgs>,
    delete_sizing_imports_by_pk?: GraphCacheUpdateResolver<{ delete_sizing_imports_by_pk: Maybe<WithTypename<Sizing_Imports>> }, Mutation_RootDelete_Sizing_Imports_By_PkArgs>,
    delete_sizing_pumping_type?: GraphCacheUpdateResolver<{ delete_sizing_pumping_type: Maybe<WithTypename<Sizing_Pumping_Type_Mutation_Response>> }, Mutation_RootDelete_Sizing_Pumping_TypeArgs>,
    delete_sizing_pumping_type_by_pk?: GraphCacheUpdateResolver<{ delete_sizing_pumping_type_by_pk: Maybe<WithTypename<Sizing_Pumping_Type>> }, Mutation_RootDelete_Sizing_Pumping_Type_By_PkArgs>,
    delete_solution_gas_oil_ratio_options?: GraphCacheUpdateResolver<{ delete_solution_gas_oil_ratio_options: Maybe<WithTypename<Solution_Gas_Oil_Ratio_Options_Mutation_Response>> }, Mutation_RootDelete_Solution_Gas_Oil_Ratio_OptionsArgs>,
    delete_solution_gas_oil_ratio_options_by_pk?: GraphCacheUpdateResolver<{ delete_solution_gas_oil_ratio_options_by_pk: Maybe<WithTypename<Solution_Gas_Oil_Ratio_Options>> }, Mutation_RootDelete_Solution_Gas_Oil_Ratio_Options_By_PkArgs>,
    delete_step_down_transformers?: GraphCacheUpdateResolver<{ delete_step_down_transformers: Maybe<WithTypename<Step_Down_Transformers_Mutation_Response>> }, Mutation_RootDelete_Step_Down_TransformersArgs>,
    delete_step_down_transformers_by_pk?: GraphCacheUpdateResolver<{ delete_step_down_transformers_by_pk: Maybe<WithTypename<Step_Down_Transformers>> }, Mutation_RootDelete_Step_Down_Transformers_By_PkArgs>,
    delete_step_up_transformers?: GraphCacheUpdateResolver<{ delete_step_up_transformers: Maybe<WithTypename<Step_Up_Transformers_Mutation_Response>> }, Mutation_RootDelete_Step_Up_TransformersArgs>,
    delete_step_up_transformers_by_pk?: GraphCacheUpdateResolver<{ delete_step_up_transformers_by_pk: Maybe<WithTypename<Step_Up_Transformers>> }, Mutation_RootDelete_Step_Up_Transformers_By_PkArgs>,
    delete_switchboards?: GraphCacheUpdateResolver<{ delete_switchboards: Maybe<WithTypename<Switchboards_Mutation_Response>> }, Mutation_RootDelete_SwitchboardsArgs>,
    delete_switchboards_by_pk?: GraphCacheUpdateResolver<{ delete_switchboards_by_pk: Maybe<WithTypename<Switchboards>> }, Mutation_RootDelete_Switchboards_By_PkArgs>,
    delete_tubing_flow_options?: GraphCacheUpdateResolver<{ delete_tubing_flow_options: Maybe<WithTypename<Tubing_Flow_Options_Mutation_Response>> }, Mutation_RootDelete_Tubing_Flow_OptionsArgs>,
    delete_tubing_flow_options_by_pk?: GraphCacheUpdateResolver<{ delete_tubing_flow_options_by_pk: Maybe<WithTypename<Tubing_Flow_Options>> }, Mutation_RootDelete_Tubing_Flow_Options_By_PkArgs>,
    delete_tubings?: GraphCacheUpdateResolver<{ delete_tubings: Maybe<WithTypename<Tubings_Mutation_Response>> }, Mutation_RootDelete_TubingsArgs>,
    delete_tubings_by_pk?: GraphCacheUpdateResolver<{ delete_tubings_by_pk: Maybe<WithTypename<Tubings>> }, Mutation_RootDelete_Tubings_By_PkArgs>,
    delete_tubings_type?: GraphCacheUpdateResolver<{ delete_tubings_type: Maybe<WithTypename<Tubings_Type_Mutation_Response>> }, Mutation_RootDelete_Tubings_TypeArgs>,
    delete_tubings_type_by_pk?: GraphCacheUpdateResolver<{ delete_tubings_type_by_pk: Maybe<WithTypename<Tubings_Type>> }, Mutation_RootDelete_Tubings_Type_By_PkArgs>,
    delete_under_saturated_oil_options?: GraphCacheUpdateResolver<{ delete_under_saturated_oil_options: Maybe<WithTypename<Under_Saturated_Oil_Options_Mutation_Response>> }, Mutation_RootDelete_Under_Saturated_Oil_OptionsArgs>,
    delete_under_saturated_oil_options_by_pk?: GraphCacheUpdateResolver<{ delete_under_saturated_oil_options_by_pk: Maybe<WithTypename<Under_Saturated_Oil_Options>> }, Mutation_RootDelete_Under_Saturated_Oil_Options_By_PkArgs>,
    delete_user_eula_acceptance?: GraphCacheUpdateResolver<{ delete_user_eula_acceptance: Maybe<WithTypename<User_Eula_Acceptance_Mutation_Response>> }, Mutation_RootDelete_User_Eula_AcceptanceArgs>,
    delete_user_eula_acceptance_by_pk?: GraphCacheUpdateResolver<{ delete_user_eula_acceptance_by_pk: Maybe<WithTypename<User_Eula_Acceptance>> }, Mutation_RootDelete_User_Eula_Acceptance_By_PkArgs>,
    delete_users?: GraphCacheUpdateResolver<{ delete_users: Maybe<WithTypename<Users_Mutation_Response>> }, Mutation_RootDelete_UsersArgs>,
    delete_users_by_pk?: GraphCacheUpdateResolver<{ delete_users_by_pk: Maybe<WithTypename<Users>> }, Mutation_RootDelete_Users_By_PkArgs>,
    delete_variable_speed_drives?: GraphCacheUpdateResolver<{ delete_variable_speed_drives: Maybe<WithTypename<Variable_Speed_Drives_Mutation_Response>> }, Mutation_RootDelete_Variable_Speed_DrivesArgs>,
    delete_variable_speed_drives_by_pk?: GraphCacheUpdateResolver<{ delete_variable_speed_drives_by_pk: Maybe<WithTypename<Variable_Speed_Drives>> }, Mutation_RootDelete_Variable_Speed_Drives_By_PkArgs>,
    delete_water_density_options?: GraphCacheUpdateResolver<{ delete_water_density_options: Maybe<WithTypename<Water_Density_Options_Mutation_Response>> }, Mutation_RootDelete_Water_Density_OptionsArgs>,
    delete_water_density_options_by_pk?: GraphCacheUpdateResolver<{ delete_water_density_options_by_pk: Maybe<WithTypename<Water_Density_Options>> }, Mutation_RootDelete_Water_Density_Options_By_PkArgs>,
    delete_water_solution_gas_options?: GraphCacheUpdateResolver<{ delete_water_solution_gas_options: Maybe<WithTypename<Water_Solution_Gas_Options_Mutation_Response>> }, Mutation_RootDelete_Water_Solution_Gas_OptionsArgs>,
    delete_water_solution_gas_options_by_pk?: GraphCacheUpdateResolver<{ delete_water_solution_gas_options_by_pk: Maybe<WithTypename<Water_Solution_Gas_Options>> }, Mutation_RootDelete_Water_Solution_Gas_Options_By_PkArgs>,
    delete_water_viscosity_options?: GraphCacheUpdateResolver<{ delete_water_viscosity_options: Maybe<WithTypename<Water_Viscosity_Options_Mutation_Response>> }, Mutation_RootDelete_Water_Viscosity_OptionsArgs>,
    delete_water_viscosity_options_by_pk?: GraphCacheUpdateResolver<{ delete_water_viscosity_options_by_pk: Maybe<WithTypename<Water_Viscosity_Options>> }, Mutation_RootDelete_Water_Viscosity_Options_By_PkArgs>,
    delete_water_volume_factor_options?: GraphCacheUpdateResolver<{ delete_water_volume_factor_options: Maybe<WithTypename<Water_Volume_Factor_Options_Mutation_Response>> }, Mutation_RootDelete_Water_Volume_Factor_OptionsArgs>,
    delete_water_volume_factor_options_by_pk?: GraphCacheUpdateResolver<{ delete_water_volume_factor_options_by_pk: Maybe<WithTypename<Water_Volume_Factor_Options>> }, Mutation_RootDelete_Water_Volume_Factor_Options_By_PkArgs>,
    delete_well_gas_type_options?: GraphCacheUpdateResolver<{ delete_well_gas_type_options: Maybe<WithTypename<Well_Gas_Type_Options_Mutation_Response>> }, Mutation_RootDelete_Well_Gas_Type_OptionsArgs>,
    delete_well_gas_type_options_by_pk?: GraphCacheUpdateResolver<{ delete_well_gas_type_options_by_pk: Maybe<WithTypename<Well_Gas_Type_Options>> }, Mutation_RootDelete_Well_Gas_Type_Options_By_PkArgs>,
    delete_well_test_gas_input_options?: GraphCacheUpdateResolver<{ delete_well_test_gas_input_options: Maybe<WithTypename<Well_Test_Gas_Input_Options_Mutation_Response>> }, Mutation_RootDelete_Well_Test_Gas_Input_OptionsArgs>,
    delete_well_test_gas_input_options_by_pk?: GraphCacheUpdateResolver<{ delete_well_test_gas_input_options_by_pk: Maybe<WithTypename<Well_Test_Gas_Input_Options>> }, Mutation_RootDelete_Well_Test_Gas_Input_Options_By_PkArgs>,
    delete_well_test_liquid_input_options?: GraphCacheUpdateResolver<{ delete_well_test_liquid_input_options: Maybe<WithTypename<Well_Test_Liquid_Input_Options_Mutation_Response>> }, Mutation_RootDelete_Well_Test_Liquid_Input_OptionsArgs>,
    delete_well_test_liquid_input_options_by_pk?: GraphCacheUpdateResolver<{ delete_well_test_liquid_input_options_by_pk: Maybe<WithTypename<Well_Test_Liquid_Input_Options>> }, Mutation_RootDelete_Well_Test_Liquid_Input_Options_By_PkArgs>,
    delete_well_test_pressure_input_options?: GraphCacheUpdateResolver<{ delete_well_test_pressure_input_options: Maybe<WithTypename<Well_Test_Pressure_Input_Options_Mutation_Response>> }, Mutation_RootDelete_Well_Test_Pressure_Input_OptionsArgs>,
    delete_well_test_pressure_input_options_by_pk?: GraphCacheUpdateResolver<{ delete_well_test_pressure_input_options_by_pk: Maybe<WithTypename<Well_Test_Pressure_Input_Options>> }, Mutation_RootDelete_Well_Test_Pressure_Input_Options_By_PkArgs>,
    delete_wells?: GraphCacheUpdateResolver<{ delete_wells: Maybe<WithTypename<Wells_Mutation_Response>> }, Mutation_RootDelete_WellsArgs>,
    delete_wells_by_pk?: GraphCacheUpdateResolver<{ delete_wells_by_pk: Maybe<WithTypename<Wells>> }, Mutation_RootDelete_Wells_By_PkArgs>,
    delete_y_tools?: GraphCacheUpdateResolver<{ delete_y_tools: Maybe<WithTypename<Y_Tools_Mutation_Response>> }, Mutation_RootDelete_Y_ToolsArgs>,
    delete_y_tools_by_pk?: GraphCacheUpdateResolver<{ delete_y_tools_by_pk: Maybe<WithTypename<Y_Tools>> }, Mutation_RootDelete_Y_Tools_By_PkArgs>,
    insert_bolt_on_discharges?: GraphCacheUpdateResolver<{ insert_bolt_on_discharges: Maybe<WithTypename<Bolt_On_Discharges_Mutation_Response>> }, Mutation_RootInsert_Bolt_On_DischargesArgs>,
    insert_bolt_on_discharges_one?: GraphCacheUpdateResolver<{ insert_bolt_on_discharges_one: Maybe<WithTypename<Bolt_On_Discharges>> }, Mutation_RootInsert_Bolt_On_Discharges_OneArgs>,
    insert_bubble_point_options?: GraphCacheUpdateResolver<{ insert_bubble_point_options: Maybe<WithTypename<Bubble_Point_Options_Mutation_Response>> }, Mutation_RootInsert_Bubble_Point_OptionsArgs>,
    insert_bubble_point_options_one?: GraphCacheUpdateResolver<{ insert_bubble_point_options_one: Maybe<WithTypename<Bubble_Point_Options>> }, Mutation_RootInsert_Bubble_Point_Options_OneArgs>,
    insert_cables?: GraphCacheUpdateResolver<{ insert_cables: Maybe<WithTypename<Cables_Mutation_Response>> }, Mutation_RootInsert_CablesArgs>,
    insert_cables_one?: GraphCacheUpdateResolver<{ insert_cables_one: Maybe<WithTypename<Cables>> }, Mutation_RootInsert_Cables_OneArgs>,
    insert_casing_flow_options?: GraphCacheUpdateResolver<{ insert_casing_flow_options: Maybe<WithTypename<Casing_Flow_Options_Mutation_Response>> }, Mutation_RootInsert_Casing_Flow_OptionsArgs>,
    insert_casing_flow_options_one?: GraphCacheUpdateResolver<{ insert_casing_flow_options_one: Maybe<WithTypename<Casing_Flow_Options>> }, Mutation_RootInsert_Casing_Flow_Options_OneArgs>,
    insert_casings?: GraphCacheUpdateResolver<{ insert_casings: Maybe<WithTypename<Casings_Mutation_Response>> }, Mutation_RootInsert_CasingsArgs>,
    insert_casings_one?: GraphCacheUpdateResolver<{ insert_casings_one: Maybe<WithTypename<Casings>> }, Mutation_RootInsert_Casings_OneArgs>,
    insert_casings_type?: GraphCacheUpdateResolver<{ insert_casings_type: Maybe<WithTypename<Casings_Type_Mutation_Response>> }, Mutation_RootInsert_Casings_TypeArgs>,
    insert_casings_type_one?: GraphCacheUpdateResolver<{ insert_casings_type_one: Maybe<WithTypename<Casings_Type>> }, Mutation_RootInsert_Casings_Type_OneArgs>,
    insert_customers?: GraphCacheUpdateResolver<{ insert_customers: Maybe<WithTypename<Customers_Mutation_Response>> }, Mutation_RootInsert_CustomersArgs>,
    insert_customers_one?: GraphCacheUpdateResolver<{ insert_customers_one: Maybe<WithTypename<Customers>> }, Mutation_RootInsert_Customers_OneArgs>,
    insert_dead_oil_options?: GraphCacheUpdateResolver<{ insert_dead_oil_options: Maybe<WithTypename<Dead_Oil_Options_Mutation_Response>> }, Mutation_RootInsert_Dead_Oil_OptionsArgs>,
    insert_dead_oil_options_one?: GraphCacheUpdateResolver<{ insert_dead_oil_options_one: Maybe<WithTypename<Dead_Oil_Options>> }, Mutation_RootInsert_Dead_Oil_Options_OneArgs>,
    insert_deviation_survey?: GraphCacheUpdateResolver<{ insert_deviation_survey: Maybe<WithTypename<Deviation_Survey_Mutation_Response>> }, Mutation_RootInsert_Deviation_SurveyArgs>,
    insert_deviation_survey_directional_dataset?: GraphCacheUpdateResolver<{ insert_deviation_survey_directional_dataset: Maybe<WithTypename<Deviation_Survey_Directional_Dataset_Mutation_Response>> }, Mutation_RootInsert_Deviation_Survey_Directional_DatasetArgs>,
    insert_deviation_survey_directional_dataset_one?: GraphCacheUpdateResolver<{ insert_deviation_survey_directional_dataset_one: Maybe<WithTypename<Deviation_Survey_Directional_Dataset>> }, Mutation_RootInsert_Deviation_Survey_Directional_Dataset_OneArgs>,
    insert_deviation_survey_one?: GraphCacheUpdateResolver<{ insert_deviation_survey_one: Maybe<WithTypename<Deviation_Survey>> }, Mutation_RootInsert_Deviation_Survey_OneArgs>,
    insert_display_units?: GraphCacheUpdateResolver<{ insert_display_units: Maybe<WithTypename<Display_Units_Mutation_Response>> }, Mutation_RootInsert_Display_UnitsArgs>,
    insert_display_units_one?: GraphCacheUpdateResolver<{ insert_display_units_one: Maybe<WithTypename<Display_Units>> }, Mutation_RootInsert_Display_Units_OneArgs>,
    insert_eula?: GraphCacheUpdateResolver<{ insert_eula: Maybe<WithTypename<Eula_Mutation_Response>> }, Mutation_RootInsert_EulaArgs>,
    insert_eula_one?: GraphCacheUpdateResolver<{ insert_eula_one: Maybe<WithTypename<Eula>> }, Mutation_RootInsert_Eula_OneArgs>,
    insert_flow_model?: GraphCacheUpdateResolver<{ insert_flow_model: Maybe<WithTypename<Flow_Model_Mutation_Response>> }, Mutation_RootInsert_Flow_ModelArgs>,
    insert_flow_model_active?: GraphCacheUpdateResolver<{ insert_flow_model_active: Maybe<WithTypename<Flow_Model_Active_Mutation_Response>> }, Mutation_RootInsert_Flow_Model_ActiveArgs>,
    insert_flow_model_active_one?: GraphCacheUpdateResolver<{ insert_flow_model_active_one: Maybe<WithTypename<Flow_Model_Active>> }, Mutation_RootInsert_Flow_Model_Active_OneArgs>,
    insert_flow_model_deprecated?: GraphCacheUpdateResolver<{ insert_flow_model_deprecated: Maybe<WithTypename<Flow_Model_Deprecated_Mutation_Response>> }, Mutation_RootInsert_Flow_Model_DeprecatedArgs>,
    insert_flow_model_deprecated_one?: GraphCacheUpdateResolver<{ insert_flow_model_deprecated_one: Maybe<WithTypename<Flow_Model_Deprecated>> }, Mutation_RootInsert_Flow_Model_Deprecated_OneArgs>,
    insert_flow_model_one?: GraphCacheUpdateResolver<{ insert_flow_model_one: Maybe<WithTypename<Flow_Model>> }, Mutation_RootInsert_Flow_Model_OneArgs>,
    insert_friction_loss_options?: GraphCacheUpdateResolver<{ insert_friction_loss_options: Maybe<WithTypename<Friction_Loss_Options_Mutation_Response>> }, Mutation_RootInsert_Friction_Loss_OptionsArgs>,
    insert_friction_loss_options_one?: GraphCacheUpdateResolver<{ insert_friction_loss_options_one: Maybe<WithTypename<Friction_Loss_Options>> }, Mutation_RootInsert_Friction_Loss_Options_OneArgs>,
    insert_gas_compressibility_options?: GraphCacheUpdateResolver<{ insert_gas_compressibility_options: Maybe<WithTypename<Gas_Compressibility_Options_Mutation_Response>> }, Mutation_RootInsert_Gas_Compressibility_OptionsArgs>,
    insert_gas_compressibility_options_one?: GraphCacheUpdateResolver<{ insert_gas_compressibility_options_one: Maybe<WithTypename<Gas_Compressibility_Options>> }, Mutation_RootInsert_Gas_Compressibility_Options_OneArgs>,
    insert_gas_viscosity_options?: GraphCacheUpdateResolver<{ insert_gas_viscosity_options: Maybe<WithTypename<Gas_Viscosity_Options_Mutation_Response>> }, Mutation_RootInsert_Gas_Viscosity_OptionsArgs>,
    insert_gas_viscosity_options_one?: GraphCacheUpdateResolver<{ insert_gas_viscosity_options_one: Maybe<WithTypename<Gas_Viscosity_Options>> }, Mutation_RootInsert_Gas_Viscosity_Options_OneArgs>,
    insert_housings?: GraphCacheUpdateResolver<{ insert_housings: Maybe<WithTypename<Housings_Mutation_Response>> }, Mutation_RootInsert_HousingsArgs>,
    insert_housings_one?: GraphCacheUpdateResolver<{ insert_housings_one: Maybe<WithTypename<Housings>> }, Mutation_RootInsert_Housings_OneArgs>,
    insert_hps_liquid_type?: GraphCacheUpdateResolver<{ insert_hps_liquid_type: Maybe<WithTypename<Hps_Liquid_Type_Mutation_Response>> }, Mutation_RootInsert_Hps_Liquid_TypeArgs>,
    insert_hps_liquid_type_one?: GraphCacheUpdateResolver<{ insert_hps_liquid_type_one: Maybe<WithTypename<Hps_Liquid_Type>> }, Mutation_RootInsert_Hps_Liquid_Type_OneArgs>,
    insert_intakes?: GraphCacheUpdateResolver<{ insert_intakes: Maybe<WithTypename<Intakes_Mutation_Response>> }, Mutation_RootInsert_IntakesArgs>,
    insert_intakes_one?: GraphCacheUpdateResolver<{ insert_intakes_one: Maybe<WithTypename<Intakes>> }, Mutation_RootInsert_Intakes_OneArgs>,
    insert_legacy_users?: GraphCacheUpdateResolver<{ insert_legacy_users: Maybe<WithTypename<Legacy_Users_Mutation_Response>> }, Mutation_RootInsert_Legacy_UsersArgs>,
    insert_legacy_users_one?: GraphCacheUpdateResolver<{ insert_legacy_users_one: Maybe<WithTypename<Legacy_Users>> }, Mutation_RootInsert_Legacy_Users_OneArgs>,
    insert_motor_lead_extensions?: GraphCacheUpdateResolver<{ insert_motor_lead_extensions: Maybe<WithTypename<Motor_Lead_Extensions_Mutation_Response>> }, Mutation_RootInsert_Motor_Lead_ExtensionsArgs>,
    insert_motor_lead_extensions_one?: GraphCacheUpdateResolver<{ insert_motor_lead_extensions_one: Maybe<WithTypename<Motor_Lead_Extensions>> }, Mutation_RootInsert_Motor_Lead_Extensions_OneArgs>,
    insert_motors?: GraphCacheUpdateResolver<{ insert_motors: Maybe<WithTypename<Motors_Mutation_Response>> }, Mutation_RootInsert_MotorsArgs>,
    insert_motors_one?: GraphCacheUpdateResolver<{ insert_motors_one: Maybe<WithTypename<Motors>> }, Mutation_RootInsert_Motors_OneArgs>,
    insert_natural_gas_separation_options?: GraphCacheUpdateResolver<{ insert_natural_gas_separation_options: Maybe<WithTypename<Natural_Gas_Separation_Options_Mutation_Response>> }, Mutation_RootInsert_Natural_Gas_Separation_OptionsArgs>,
    insert_natural_gas_separation_options_one?: GraphCacheUpdateResolver<{ insert_natural_gas_separation_options_one: Maybe<WithTypename<Natural_Gas_Separation_Options>> }, Mutation_RootInsert_Natural_Gas_Separation_Options_OneArgs>,
    insert_oil_density_options?: GraphCacheUpdateResolver<{ insert_oil_density_options: Maybe<WithTypename<Oil_Density_Options_Mutation_Response>> }, Mutation_RootInsert_Oil_Density_OptionsArgs>,
    insert_oil_density_options_one?: GraphCacheUpdateResolver<{ insert_oil_density_options_one: Maybe<WithTypename<Oil_Density_Options>> }, Mutation_RootInsert_Oil_Density_Options_OneArgs>,
    insert_oil_volume_factor_options?: GraphCacheUpdateResolver<{ insert_oil_volume_factor_options: Maybe<WithTypename<Oil_Volume_Factor_Options_Mutation_Response>> }, Mutation_RootInsert_Oil_Volume_Factor_OptionsArgs>,
    insert_oil_volume_factor_options_one?: GraphCacheUpdateResolver<{ insert_oil_volume_factor_options_one: Maybe<WithTypename<Oil_Volume_Factor_Options>> }, Mutation_RootInsert_Oil_Volume_Factor_Options_OneArgs>,
    insert_override_options?: GraphCacheUpdateResolver<{ insert_override_options: Maybe<WithTypename<Override_Options_Mutation_Response>> }, Mutation_RootInsert_Override_OptionsArgs>,
    insert_override_options_one?: GraphCacheUpdateResolver<{ insert_override_options_one: Maybe<WithTypename<Override_Options>> }, Mutation_RootInsert_Override_Options_OneArgs>,
    insert_pumps?: GraphCacheUpdateResolver<{ insert_pumps: Maybe<WithTypename<Pumps_Mutation_Response>> }, Mutation_RootInsert_PumpsArgs>,
    insert_pumps_one?: GraphCacheUpdateResolver<{ insert_pumps_one: Maybe<WithTypename<Pumps>> }, Mutation_RootInsert_Pumps_OneArgs>,
    insert_quote_line_item_category_dataset?: GraphCacheUpdateResolver<{ insert_quote_line_item_category_dataset: Maybe<WithTypename<Quote_Line_Item_Category_Dataset_Mutation_Response>> }, Mutation_RootInsert_Quote_Line_Item_Category_DatasetArgs>,
    insert_quote_line_item_category_dataset_one?: GraphCacheUpdateResolver<{ insert_quote_line_item_category_dataset_one: Maybe<WithTypename<Quote_Line_Item_Category_Dataset>> }, Mutation_RootInsert_Quote_Line_Item_Category_Dataset_OneArgs>,
    insert_quote_line_item_serialized_dataset?: GraphCacheUpdateResolver<{ insert_quote_line_item_serialized_dataset: Maybe<WithTypename<Quote_Line_Item_Serialized_Dataset_Mutation_Response>> }, Mutation_RootInsert_Quote_Line_Item_Serialized_DatasetArgs>,
    insert_quote_line_item_serialized_dataset_one?: GraphCacheUpdateResolver<{ insert_quote_line_item_serialized_dataset_one: Maybe<WithTypename<Quote_Line_Item_Serialized_Dataset>> }, Mutation_RootInsert_Quote_Line_Item_Serialized_Dataset_OneArgs>,
    insert_quote_line_item_source_dataset?: GraphCacheUpdateResolver<{ insert_quote_line_item_source_dataset: Maybe<WithTypename<Quote_Line_Item_Source_Dataset_Mutation_Response>> }, Mutation_RootInsert_Quote_Line_Item_Source_DatasetArgs>,
    insert_quote_line_item_source_dataset_one?: GraphCacheUpdateResolver<{ insert_quote_line_item_source_dataset_one: Maybe<WithTypename<Quote_Line_Item_Source_Dataset>> }, Mutation_RootInsert_Quote_Line_Item_Source_Dataset_OneArgs>,
    insert_quote_line_item_subcategory_dataset?: GraphCacheUpdateResolver<{ insert_quote_line_item_subcategory_dataset: Maybe<WithTypename<Quote_Line_Item_Subcategory_Dataset_Mutation_Response>> }, Mutation_RootInsert_Quote_Line_Item_Subcategory_DatasetArgs>,
    insert_quote_line_item_subcategory_dataset_one?: GraphCacheUpdateResolver<{ insert_quote_line_item_subcategory_dataset_one: Maybe<WithTypename<Quote_Line_Item_Subcategory_Dataset>> }, Mutation_RootInsert_Quote_Line_Item_Subcategory_Dataset_OneArgs>,
    insert_quote_line_item_tax_type_dataset?: GraphCacheUpdateResolver<{ insert_quote_line_item_tax_type_dataset: Maybe<WithTypename<Quote_Line_Item_Tax_Type_Dataset_Mutation_Response>> }, Mutation_RootInsert_Quote_Line_Item_Tax_Type_DatasetArgs>,
    insert_quote_line_item_tax_type_dataset_one?: GraphCacheUpdateResolver<{ insert_quote_line_item_tax_type_dataset_one: Maybe<WithTypename<Quote_Line_Item_Tax_Type_Dataset>> }, Mutation_RootInsert_Quote_Line_Item_Tax_Type_Dataset_OneArgs>,
    insert_quote_line_item_type_dataset?: GraphCacheUpdateResolver<{ insert_quote_line_item_type_dataset: Maybe<WithTypename<Quote_Line_Item_Type_Dataset_Mutation_Response>> }, Mutation_RootInsert_Quote_Line_Item_Type_DatasetArgs>,
    insert_quote_line_item_type_dataset_one?: GraphCacheUpdateResolver<{ insert_quote_line_item_type_dataset_one: Maybe<WithTypename<Quote_Line_Item_Type_Dataset>> }, Mutation_RootInsert_Quote_Line_Item_Type_Dataset_OneArgs>,
    insert_quote_line_items?: GraphCacheUpdateResolver<{ insert_quote_line_items: Maybe<WithTypename<Quote_Line_Items_Mutation_Response>> }, Mutation_RootInsert_Quote_Line_ItemsArgs>,
    insert_quote_line_items_one?: GraphCacheUpdateResolver<{ insert_quote_line_items_one: Maybe<WithTypename<Quote_Line_Items>> }, Mutation_RootInsert_Quote_Line_Items_OneArgs>,
    insert_quote_sk_job_type_dataset?: GraphCacheUpdateResolver<{ insert_quote_sk_job_type_dataset: Maybe<WithTypename<Quote_Sk_Job_Type_Dataset_Mutation_Response>> }, Mutation_RootInsert_Quote_Sk_Job_Type_DatasetArgs>,
    insert_quote_sk_job_type_dataset_one?: GraphCacheUpdateResolver<{ insert_quote_sk_job_type_dataset_one: Maybe<WithTypename<Quote_Sk_Job_Type_Dataset>> }, Mutation_RootInsert_Quote_Sk_Job_Type_Dataset_OneArgs>,
    insert_quote_source_dataset?: GraphCacheUpdateResolver<{ insert_quote_source_dataset: Maybe<WithTypename<Quote_Source_Dataset_Mutation_Response>> }, Mutation_RootInsert_Quote_Source_DatasetArgs>,
    insert_quote_source_dataset_one?: GraphCacheUpdateResolver<{ insert_quote_source_dataset_one: Maybe<WithTypename<Quote_Source_Dataset>> }, Mutation_RootInsert_Quote_Source_Dataset_OneArgs>,
    insert_quote_status_dataset?: GraphCacheUpdateResolver<{ insert_quote_status_dataset: Maybe<WithTypename<Quote_Status_Dataset_Mutation_Response>> }, Mutation_RootInsert_Quote_Status_DatasetArgs>,
    insert_quote_status_dataset_one?: GraphCacheUpdateResolver<{ insert_quote_status_dataset_one: Maybe<WithTypename<Quote_Status_Dataset>> }, Mutation_RootInsert_Quote_Status_Dataset_OneArgs>,
    insert_quote_user_messages?: GraphCacheUpdateResolver<{ insert_quote_user_messages: Maybe<WithTypename<Quote_User_Messages_Mutation_Response>> }, Mutation_RootInsert_Quote_User_MessagesArgs>,
    insert_quote_user_messages_one?: GraphCacheUpdateResolver<{ insert_quote_user_messages_one: Maybe<WithTypename<Quote_User_Messages>> }, Mutation_RootInsert_Quote_User_Messages_OneArgs>,
    insert_quotes?: GraphCacheUpdateResolver<{ insert_quotes: Maybe<WithTypename<Quotes_Mutation_Response>> }, Mutation_RootInsert_QuotesArgs>,
    insert_quotes_one?: GraphCacheUpdateResolver<{ insert_quotes_one: Maybe<WithTypename<Quotes>> }, Mutation_RootInsert_Quotes_OneArgs>,
    insert_revisions_performance_evaluations_journal?: GraphCacheUpdateResolver<{ insert_revisions_performance_evaluations_journal: Maybe<WithTypename<Revisions_Performance_Evaluations_Journal_Mutation_Response>> }, Mutation_RootInsert_Revisions_Performance_Evaluations_JournalArgs>,
    insert_revisions_performance_evaluations_journal_one?: GraphCacheUpdateResolver<{ insert_revisions_performance_evaluations_journal_one: Maybe<WithTypename<Revisions_Performance_Evaluations_Journal>> }, Mutation_RootInsert_Revisions_Performance_Evaluations_Journal_OneArgs>,
    insert_revisions_performance_evaluations_revisions?: GraphCacheUpdateResolver<{ insert_revisions_performance_evaluations_revisions: Maybe<WithTypename<Revisions_Performance_Evaluations_Revisions_Mutation_Response>> }, Mutation_RootInsert_Revisions_Performance_Evaluations_RevisionsArgs>,
    insert_revisions_performance_evaluations_revisions_one?: GraphCacheUpdateResolver<{ insert_revisions_performance_evaluations_revisions_one: Maybe<WithTypename<Revisions_Performance_Evaluations_Revisions>> }, Mutation_RootInsert_Revisions_Performance_Evaluations_Revisions_OneArgs>,
    insert_revisions_performance_evaluations_xref_pumps_journal?: GraphCacheUpdateResolver<{ insert_revisions_performance_evaluations_xref_pumps_journal: Maybe<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Journal_Mutation_Response>> }, Mutation_RootInsert_Revisions_Performance_Evaluations_Xref_Pumps_JournalArgs>,
    insert_revisions_performance_evaluations_xref_pumps_journal_one?: GraphCacheUpdateResolver<{ insert_revisions_performance_evaluations_xref_pumps_journal_one: Maybe<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Journal>> }, Mutation_RootInsert_Revisions_Performance_Evaluations_Xref_Pumps_Journal_OneArgs>,
    insert_revisions_performance_evaluations_xref_pumps_revisions?: GraphCacheUpdateResolver<{ insert_revisions_performance_evaluations_xref_pumps_revisions: Maybe<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Mutation_Response>> }, Mutation_RootInsert_Revisions_Performance_Evaluations_Xref_Pumps_RevisionsArgs>,
    insert_revisions_performance_evaluations_xref_pumps_revisions_one?: GraphCacheUpdateResolver<{ insert_revisions_performance_evaluations_xref_pumps_revisions_one: Maybe<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Revisions>> }, Mutation_RootInsert_Revisions_Performance_Evaluations_Xref_Pumps_Revisions_OneArgs>,
    insert_revisions_sc_equip_xref_downhole_ytool_bypass_tubings_journal?: GraphCacheUpdateResolver<{ insert_revisions_sc_equip_xref_downhole_ytool_bypass_tubings_journal: Maybe<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_Mutation_Response>> }, Mutation_RootInsert_Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_JournalArgs>,
    insert_revisions_sc_equip_xref_downhole_ytool_bypass_tubings_journal_one?: GraphCacheUpdateResolver<{ insert_revisions_sc_equip_xref_downhole_ytool_bypass_tubings_journal_one: Maybe<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal>> }, Mutation_RootInsert_Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_OneArgs>,
    insert_revisions_sc_equip_xref_downhole_ytool_bypass_tubings_revisions?: GraphCacheUpdateResolver<{ insert_revisions_sc_equip_xref_downhole_ytool_bypass_tubings_revisions: Maybe<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Mutation_Response>> }, Mutation_RootInsert_Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_RevisionsArgs>,
    insert_revisions_sc_equip_xref_downhole_ytool_bypass_tubings_revisions_one?: GraphCacheUpdateResolver<{ insert_revisions_sc_equip_xref_downhole_ytool_bypass_tubings_revisions_one: Maybe<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions>> }, Mutation_RootInsert_Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_OneArgs>,
    insert_revisions_sc_equip_xref_downhole_ytool_equip_tubings_journal?: GraphCacheUpdateResolver<{ insert_revisions_sc_equip_xref_downhole_ytool_equip_tubings_journal: Maybe<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_Mutation_Response>> }, Mutation_RootInsert_Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_JournalArgs>,
    insert_revisions_sc_equip_xref_downhole_ytool_equip_tubings_journal_one?: GraphCacheUpdateResolver<{ insert_revisions_sc_equip_xref_downhole_ytool_equip_tubings_journal_one: Maybe<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal>> }, Mutation_RootInsert_Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_OneArgs>,
    insert_revisions_sc_equip_xref_downhole_ytool_equip_tubings_revisions?: GraphCacheUpdateResolver<{ insert_revisions_sc_equip_xref_downhole_ytool_equip_tubings_revisions: Maybe<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Mutation_Response>> }, Mutation_RootInsert_Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_RevisionsArgs>,
    insert_revisions_sc_equip_xref_downhole_ytool_equip_tubings_revisions_one?: GraphCacheUpdateResolver<{ insert_revisions_sc_equip_xref_downhole_ytool_equip_tubings_revisions_one: Maybe<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions>> }, Mutation_RootInsert_Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_OneArgs>,
    insert_revisions_sc_equip_xref_uphole_ytool_bypass_tubings_journal?: GraphCacheUpdateResolver<{ insert_revisions_sc_equip_xref_uphole_ytool_bypass_tubings_journal: Maybe<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_Mutation_Response>> }, Mutation_RootInsert_Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_JournalArgs>,
    insert_revisions_sc_equip_xref_uphole_ytool_bypass_tubings_journal_one?: GraphCacheUpdateResolver<{ insert_revisions_sc_equip_xref_uphole_ytool_bypass_tubings_journal_one: Maybe<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal>> }, Mutation_RootInsert_Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_OneArgs>,
    insert_revisions_sc_equip_xref_uphole_ytool_bypass_tubings_revisions?: GraphCacheUpdateResolver<{ insert_revisions_sc_equip_xref_uphole_ytool_bypass_tubings_revisions: Maybe<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Mutation_Response>> }, Mutation_RootInsert_Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_RevisionsArgs>,
    insert_revisions_sc_equip_xref_uphole_ytool_bypass_tubings_revisions_one?: GraphCacheUpdateResolver<{ insert_revisions_sc_equip_xref_uphole_ytool_bypass_tubings_revisions_one: Maybe<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions>> }, Mutation_RootInsert_Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_OneArgs>,
    insert_revisions_sc_equip_xref_uphole_ytool_equip_tubings_journal?: GraphCacheUpdateResolver<{ insert_revisions_sc_equip_xref_uphole_ytool_equip_tubings_journal: Maybe<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_Mutation_Response>> }, Mutation_RootInsert_Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_JournalArgs>,
    insert_revisions_sc_equip_xref_uphole_ytool_equip_tubings_journal_one?: GraphCacheUpdateResolver<{ insert_revisions_sc_equip_xref_uphole_ytool_equip_tubings_journal_one: Maybe<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal>> }, Mutation_RootInsert_Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_OneArgs>,
    insert_revisions_sc_equip_xref_uphole_ytool_equip_tubings_revisions?: GraphCacheUpdateResolver<{ insert_revisions_sc_equip_xref_uphole_ytool_equip_tubings_revisions: Maybe<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Mutation_Response>> }, Mutation_RootInsert_Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_RevisionsArgs>,
    insert_revisions_sc_equip_xref_uphole_ytool_equip_tubings_revisions_one?: GraphCacheUpdateResolver<{ insert_revisions_sc_equip_xref_uphole_ytool_equip_tubings_revisions_one: Maybe<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions>> }, Mutation_RootInsert_Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_OneArgs>,
    insert_revisions_scenario_correlations_journal?: GraphCacheUpdateResolver<{ insert_revisions_scenario_correlations_journal: Maybe<WithTypename<Revisions_Scenario_Correlations_Journal_Mutation_Response>> }, Mutation_RootInsert_Revisions_Scenario_Correlations_JournalArgs>,
    insert_revisions_scenario_correlations_journal_one?: GraphCacheUpdateResolver<{ insert_revisions_scenario_correlations_journal_one: Maybe<WithTypename<Revisions_Scenario_Correlations_Journal>> }, Mutation_RootInsert_Revisions_Scenario_Correlations_Journal_OneArgs>,
    insert_revisions_scenario_correlations_revisions?: GraphCacheUpdateResolver<{ insert_revisions_scenario_correlations_revisions: Maybe<WithTypename<Revisions_Scenario_Correlations_Revisions_Mutation_Response>> }, Mutation_RootInsert_Revisions_Scenario_Correlations_RevisionsArgs>,
    insert_revisions_scenario_correlations_revisions_one?: GraphCacheUpdateResolver<{ insert_revisions_scenario_correlations_revisions_one: Maybe<WithTypename<Revisions_Scenario_Correlations_Revisions>> }, Mutation_RootInsert_Revisions_Scenario_Correlations_Revisions_OneArgs>,
    insert_revisions_scenario_equipment_journal?: GraphCacheUpdateResolver<{ insert_revisions_scenario_equipment_journal: Maybe<WithTypename<Revisions_Scenario_Equipment_Journal_Mutation_Response>> }, Mutation_RootInsert_Revisions_Scenario_Equipment_JournalArgs>,
    insert_revisions_scenario_equipment_journal_one?: GraphCacheUpdateResolver<{ insert_revisions_scenario_equipment_journal_one: Maybe<WithTypename<Revisions_Scenario_Equipment_Journal>> }, Mutation_RootInsert_Revisions_Scenario_Equipment_Journal_OneArgs>,
    insert_revisions_scenario_equipment_revisions?: GraphCacheUpdateResolver<{ insert_revisions_scenario_equipment_revisions: Maybe<WithTypename<Revisions_Scenario_Equipment_Revisions_Mutation_Response>> }, Mutation_RootInsert_Revisions_Scenario_Equipment_RevisionsArgs>,
    insert_revisions_scenario_equipment_revisions_one?: GraphCacheUpdateResolver<{ insert_revisions_scenario_equipment_revisions_one: Maybe<WithTypename<Revisions_Scenario_Equipment_Revisions>> }, Mutation_RootInsert_Revisions_Scenario_Equipment_Revisions_OneArgs>,
    insert_revisions_scenario_equipment_xref_cables_journal?: GraphCacheUpdateResolver<{ insert_revisions_scenario_equipment_xref_cables_journal: Maybe<WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Journal_Mutation_Response>> }, Mutation_RootInsert_Revisions_Scenario_Equipment_Xref_Cables_JournalArgs>,
    insert_revisions_scenario_equipment_xref_cables_journal_one?: GraphCacheUpdateResolver<{ insert_revisions_scenario_equipment_xref_cables_journal_one: Maybe<WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Journal>> }, Mutation_RootInsert_Revisions_Scenario_Equipment_Xref_Cables_Journal_OneArgs>,
    insert_revisions_scenario_equipment_xref_cables_revisions?: GraphCacheUpdateResolver<{ insert_revisions_scenario_equipment_xref_cables_revisions: Maybe<WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Mutation_Response>> }, Mutation_RootInsert_Revisions_Scenario_Equipment_Xref_Cables_RevisionsArgs>,
    insert_revisions_scenario_equipment_xref_cables_revisions_one?: GraphCacheUpdateResolver<{ insert_revisions_scenario_equipment_xref_cables_revisions_one: Maybe<WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Revisions>> }, Mutation_RootInsert_Revisions_Scenario_Equipment_Xref_Cables_Revisions_OneArgs>,
    insert_revisions_scenario_equipment_xref_housings_journal?: GraphCacheUpdateResolver<{ insert_revisions_scenario_equipment_xref_housings_journal: Maybe<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Journal_Mutation_Response>> }, Mutation_RootInsert_Revisions_Scenario_Equipment_Xref_Housings_JournalArgs>,
    insert_revisions_scenario_equipment_xref_housings_journal_one?: GraphCacheUpdateResolver<{ insert_revisions_scenario_equipment_xref_housings_journal_one: Maybe<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Journal>> }, Mutation_RootInsert_Revisions_Scenario_Equipment_Xref_Housings_Journal_OneArgs>,
    insert_revisions_scenario_equipment_xref_housings_revisions?: GraphCacheUpdateResolver<{ insert_revisions_scenario_equipment_xref_housings_revisions: Maybe<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Mutation_Response>> }, Mutation_RootInsert_Revisions_Scenario_Equipment_Xref_Housings_RevisionsArgs>,
    insert_revisions_scenario_equipment_xref_housings_revisions_one?: GraphCacheUpdateResolver<{ insert_revisions_scenario_equipment_xref_housings_revisions_one: Maybe<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Revisions>> }, Mutation_RootInsert_Revisions_Scenario_Equipment_Xref_Housings_Revisions_OneArgs>,
    insert_revisions_scenario_equipment_xref_intakes_journal?: GraphCacheUpdateResolver<{ insert_revisions_scenario_equipment_xref_intakes_journal: Maybe<WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Journal_Mutation_Response>> }, Mutation_RootInsert_Revisions_Scenario_Equipment_Xref_Intakes_JournalArgs>,
    insert_revisions_scenario_equipment_xref_intakes_journal_one?: GraphCacheUpdateResolver<{ insert_revisions_scenario_equipment_xref_intakes_journal_one: Maybe<WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Journal>> }, Mutation_RootInsert_Revisions_Scenario_Equipment_Xref_Intakes_Journal_OneArgs>,
    insert_revisions_scenario_equipment_xref_intakes_revisions?: GraphCacheUpdateResolver<{ insert_revisions_scenario_equipment_xref_intakes_revisions: Maybe<WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Mutation_Response>> }, Mutation_RootInsert_Revisions_Scenario_Equipment_Xref_Intakes_RevisionsArgs>,
    insert_revisions_scenario_equipment_xref_intakes_revisions_one?: GraphCacheUpdateResolver<{ insert_revisions_scenario_equipment_xref_intakes_revisions_one: Maybe<WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Revisions>> }, Mutation_RootInsert_Revisions_Scenario_Equipment_Xref_Intakes_Revisions_OneArgs>,
    insert_revisions_scenario_equipment_xref_pumps_journal?: GraphCacheUpdateResolver<{ insert_revisions_scenario_equipment_xref_pumps_journal: Maybe<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Journal_Mutation_Response>> }, Mutation_RootInsert_Revisions_Scenario_Equipment_Xref_Pumps_JournalArgs>,
    insert_revisions_scenario_equipment_xref_pumps_journal_one?: GraphCacheUpdateResolver<{ insert_revisions_scenario_equipment_xref_pumps_journal_one: Maybe<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Journal>> }, Mutation_RootInsert_Revisions_Scenario_Equipment_Xref_Pumps_Journal_OneArgs>,
    insert_revisions_scenario_equipment_xref_pumps_revisions?: GraphCacheUpdateResolver<{ insert_revisions_scenario_equipment_xref_pumps_revisions: Maybe<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Mutation_Response>> }, Mutation_RootInsert_Revisions_Scenario_Equipment_Xref_Pumps_RevisionsArgs>,
    insert_revisions_scenario_equipment_xref_pumps_revisions_one?: GraphCacheUpdateResolver<{ insert_revisions_scenario_equipment_xref_pumps_revisions_one: Maybe<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions>> }, Mutation_RootInsert_Revisions_Scenario_Equipment_Xref_Pumps_Revisions_OneArgs>,
    insert_revisions_scenario_equipment_xref_seals_journal?: GraphCacheUpdateResolver<{ insert_revisions_scenario_equipment_xref_seals_journal: Maybe<WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Journal_Mutation_Response>> }, Mutation_RootInsert_Revisions_Scenario_Equipment_Xref_Seals_JournalArgs>,
    insert_revisions_scenario_equipment_xref_seals_journal_one?: GraphCacheUpdateResolver<{ insert_revisions_scenario_equipment_xref_seals_journal_one: Maybe<WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Journal>> }, Mutation_RootInsert_Revisions_Scenario_Equipment_Xref_Seals_Journal_OneArgs>,
    insert_revisions_scenario_equipment_xref_seals_revisions?: GraphCacheUpdateResolver<{ insert_revisions_scenario_equipment_xref_seals_revisions: Maybe<WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Revisions_Mutation_Response>> }, Mutation_RootInsert_Revisions_Scenario_Equipment_Xref_Seals_RevisionsArgs>,
    insert_revisions_scenario_equipment_xref_seals_revisions_one?: GraphCacheUpdateResolver<{ insert_revisions_scenario_equipment_xref_seals_revisions_one: Maybe<WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Revisions>> }, Mutation_RootInsert_Revisions_Scenario_Equipment_Xref_Seals_Revisions_OneArgs>,
    insert_revisions_scenario_parameters_journal?: GraphCacheUpdateResolver<{ insert_revisions_scenario_parameters_journal: Maybe<WithTypename<Revisions_Scenario_Parameters_Journal_Mutation_Response>> }, Mutation_RootInsert_Revisions_Scenario_Parameters_JournalArgs>,
    insert_revisions_scenario_parameters_journal_one?: GraphCacheUpdateResolver<{ insert_revisions_scenario_parameters_journal_one: Maybe<WithTypename<Revisions_Scenario_Parameters_Journal>> }, Mutation_RootInsert_Revisions_Scenario_Parameters_Journal_OneArgs>,
    insert_revisions_scenario_parameters_revisions?: GraphCacheUpdateResolver<{ insert_revisions_scenario_parameters_revisions: Maybe<WithTypename<Revisions_Scenario_Parameters_Revisions_Mutation_Response>> }, Mutation_RootInsert_Revisions_Scenario_Parameters_RevisionsArgs>,
    insert_revisions_scenario_parameters_revisions_one?: GraphCacheUpdateResolver<{ insert_revisions_scenario_parameters_revisions_one: Maybe<WithTypename<Revisions_Scenario_Parameters_Revisions>> }, Mutation_RootInsert_Revisions_Scenario_Parameters_Revisions_OneArgs>,
    insert_revisions_scenario_well_properties_journal?: GraphCacheUpdateResolver<{ insert_revisions_scenario_well_properties_journal: Maybe<WithTypename<Revisions_Scenario_Well_Properties_Journal_Mutation_Response>> }, Mutation_RootInsert_Revisions_Scenario_Well_Properties_JournalArgs>,
    insert_revisions_scenario_well_properties_journal_one?: GraphCacheUpdateResolver<{ insert_revisions_scenario_well_properties_journal_one: Maybe<WithTypename<Revisions_Scenario_Well_Properties_Journal>> }, Mutation_RootInsert_Revisions_Scenario_Well_Properties_Journal_OneArgs>,
    insert_revisions_scenario_well_properties_revisions?: GraphCacheUpdateResolver<{ insert_revisions_scenario_well_properties_revisions: Maybe<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Mutation_Response>> }, Mutation_RootInsert_Revisions_Scenario_Well_Properties_RevisionsArgs>,
    insert_revisions_scenario_well_properties_revisions_one?: GraphCacheUpdateResolver<{ insert_revisions_scenario_well_properties_revisions_one: Maybe<WithTypename<Revisions_Scenario_Well_Properties_Revisions>> }, Mutation_RootInsert_Revisions_Scenario_Well_Properties_Revisions_OneArgs>,
    insert_revisions_scenarios_journal?: GraphCacheUpdateResolver<{ insert_revisions_scenarios_journal: Maybe<WithTypename<Revisions_Scenarios_Journal_Mutation_Response>> }, Mutation_RootInsert_Revisions_Scenarios_JournalArgs>,
    insert_revisions_scenarios_journal_one?: GraphCacheUpdateResolver<{ insert_revisions_scenarios_journal_one: Maybe<WithTypename<Revisions_Scenarios_Journal>> }, Mutation_RootInsert_Revisions_Scenarios_Journal_OneArgs>,
    insert_revisions_scenarios_revisions?: GraphCacheUpdateResolver<{ insert_revisions_scenarios_revisions: Maybe<WithTypename<Revisions_Scenarios_Revisions_Mutation_Response>> }, Mutation_RootInsert_Revisions_Scenarios_RevisionsArgs>,
    insert_revisions_scenarios_revisions_one?: GraphCacheUpdateResolver<{ insert_revisions_scenarios_revisions_one: Maybe<WithTypename<Revisions_Scenarios_Revisions>> }, Mutation_RootInsert_Revisions_Scenarios_Revisions_OneArgs>,
    insert_revisions_sizings_journal?: GraphCacheUpdateResolver<{ insert_revisions_sizings_journal: Maybe<WithTypename<Revisions_Sizings_Journal_Mutation_Response>> }, Mutation_RootInsert_Revisions_Sizings_JournalArgs>,
    insert_revisions_sizings_journal_one?: GraphCacheUpdateResolver<{ insert_revisions_sizings_journal_one: Maybe<WithTypename<Revisions_Sizings_Journal>> }, Mutation_RootInsert_Revisions_Sizings_Journal_OneArgs>,
    insert_revisions_sizings_revisions?: GraphCacheUpdateResolver<{ insert_revisions_sizings_revisions: Maybe<WithTypename<Revisions_Sizings_Revisions_Mutation_Response>> }, Mutation_RootInsert_Revisions_Sizings_RevisionsArgs>,
    insert_revisions_sizings_revisions_one?: GraphCacheUpdateResolver<{ insert_revisions_sizings_revisions_one: Maybe<WithTypename<Revisions_Sizings_Revisions>> }, Mutation_RootInsert_Revisions_Sizings_Revisions_OneArgs>,
    insert_saturated_oil_options?: GraphCacheUpdateResolver<{ insert_saturated_oil_options: Maybe<WithTypename<Saturated_Oil_Options_Mutation_Response>> }, Mutation_RootInsert_Saturated_Oil_OptionsArgs>,
    insert_saturated_oil_options_one?: GraphCacheUpdateResolver<{ insert_saturated_oil_options_one: Maybe<WithTypename<Saturated_Oil_Options>> }, Mutation_RootInsert_Saturated_Oil_Options_OneArgs>,
    insert_scenario_reasons?: GraphCacheUpdateResolver<{ insert_scenario_reasons: Maybe<WithTypename<Scenario_Reasons_Mutation_Response>> }, Mutation_RootInsert_Scenario_ReasonsArgs>,
    insert_scenario_reasons_one?: GraphCacheUpdateResolver<{ insert_scenario_reasons_one: Maybe<WithTypename<Scenario_Reasons>> }, Mutation_RootInsert_Scenario_Reasons_OneArgs>,
    insert_seal_motor_oil?: GraphCacheUpdateResolver<{ insert_seal_motor_oil: Maybe<WithTypename<Seal_Motor_Oil_Mutation_Response>> }, Mutation_RootInsert_Seal_Motor_OilArgs>,
    insert_seal_motor_oil_one?: GraphCacheUpdateResolver<{ insert_seal_motor_oil_one: Maybe<WithTypename<Seal_Motor_Oil>> }, Mutation_RootInsert_Seal_Motor_Oil_OneArgs>,
    insert_seals?: GraphCacheUpdateResolver<{ insert_seals: Maybe<WithTypename<Seals_Mutation_Response>> }, Mutation_RootInsert_SealsArgs>,
    insert_seals_one?: GraphCacheUpdateResolver<{ insert_seals_one: Maybe<WithTypename<Seals>> }, Mutation_RootInsert_Seals_OneArgs>,
    insert_sensors?: GraphCacheUpdateResolver<{ insert_sensors: Maybe<WithTypename<Sensors_Mutation_Response>> }, Mutation_RootInsert_SensorsArgs>,
    insert_sensors_one?: GraphCacheUpdateResolver<{ insert_sensors_one: Maybe<WithTypename<Sensors>> }, Mutation_RootInsert_Sensors_OneArgs>,
    insert_sizing_dispositions?: GraphCacheUpdateResolver<{ insert_sizing_dispositions: Maybe<WithTypename<Sizing_Dispositions_Mutation_Response>> }, Mutation_RootInsert_Sizing_DispositionsArgs>,
    insert_sizing_dispositions_one?: GraphCacheUpdateResolver<{ insert_sizing_dispositions_one: Maybe<WithTypename<Sizing_Dispositions>> }, Mutation_RootInsert_Sizing_Dispositions_OneArgs>,
    insert_sizing_imports?: GraphCacheUpdateResolver<{ insert_sizing_imports: Maybe<WithTypename<Sizing_Imports_Mutation_Response>> }, Mutation_RootInsert_Sizing_ImportsArgs>,
    insert_sizing_imports_one?: GraphCacheUpdateResolver<{ insert_sizing_imports_one: Maybe<WithTypename<Sizing_Imports>> }, Mutation_RootInsert_Sizing_Imports_OneArgs>,
    insert_sizing_pumping_type?: GraphCacheUpdateResolver<{ insert_sizing_pumping_type: Maybe<WithTypename<Sizing_Pumping_Type_Mutation_Response>> }, Mutation_RootInsert_Sizing_Pumping_TypeArgs>,
    insert_sizing_pumping_type_one?: GraphCacheUpdateResolver<{ insert_sizing_pumping_type_one: Maybe<WithTypename<Sizing_Pumping_Type>> }, Mutation_RootInsert_Sizing_Pumping_Type_OneArgs>,
    insert_solution_gas_oil_ratio_options?: GraphCacheUpdateResolver<{ insert_solution_gas_oil_ratio_options: Maybe<WithTypename<Solution_Gas_Oil_Ratio_Options_Mutation_Response>> }, Mutation_RootInsert_Solution_Gas_Oil_Ratio_OptionsArgs>,
    insert_solution_gas_oil_ratio_options_one?: GraphCacheUpdateResolver<{ insert_solution_gas_oil_ratio_options_one: Maybe<WithTypename<Solution_Gas_Oil_Ratio_Options>> }, Mutation_RootInsert_Solution_Gas_Oil_Ratio_Options_OneArgs>,
    insert_step_down_transformers?: GraphCacheUpdateResolver<{ insert_step_down_transformers: Maybe<WithTypename<Step_Down_Transformers_Mutation_Response>> }, Mutation_RootInsert_Step_Down_TransformersArgs>,
    insert_step_down_transformers_one?: GraphCacheUpdateResolver<{ insert_step_down_transformers_one: Maybe<WithTypename<Step_Down_Transformers>> }, Mutation_RootInsert_Step_Down_Transformers_OneArgs>,
    insert_step_up_transformers?: GraphCacheUpdateResolver<{ insert_step_up_transformers: Maybe<WithTypename<Step_Up_Transformers_Mutation_Response>> }, Mutation_RootInsert_Step_Up_TransformersArgs>,
    insert_step_up_transformers_one?: GraphCacheUpdateResolver<{ insert_step_up_transformers_one: Maybe<WithTypename<Step_Up_Transformers>> }, Mutation_RootInsert_Step_Up_Transformers_OneArgs>,
    insert_switchboards?: GraphCacheUpdateResolver<{ insert_switchboards: Maybe<WithTypename<Switchboards_Mutation_Response>> }, Mutation_RootInsert_SwitchboardsArgs>,
    insert_switchboards_one?: GraphCacheUpdateResolver<{ insert_switchboards_one: Maybe<WithTypename<Switchboards>> }, Mutation_RootInsert_Switchboards_OneArgs>,
    insert_tubing_flow_options?: GraphCacheUpdateResolver<{ insert_tubing_flow_options: Maybe<WithTypename<Tubing_Flow_Options_Mutation_Response>> }, Mutation_RootInsert_Tubing_Flow_OptionsArgs>,
    insert_tubing_flow_options_one?: GraphCacheUpdateResolver<{ insert_tubing_flow_options_one: Maybe<WithTypename<Tubing_Flow_Options>> }, Mutation_RootInsert_Tubing_Flow_Options_OneArgs>,
    insert_tubings?: GraphCacheUpdateResolver<{ insert_tubings: Maybe<WithTypename<Tubings_Mutation_Response>> }, Mutation_RootInsert_TubingsArgs>,
    insert_tubings_one?: GraphCacheUpdateResolver<{ insert_tubings_one: Maybe<WithTypename<Tubings>> }, Mutation_RootInsert_Tubings_OneArgs>,
    insert_tubings_type?: GraphCacheUpdateResolver<{ insert_tubings_type: Maybe<WithTypename<Tubings_Type_Mutation_Response>> }, Mutation_RootInsert_Tubings_TypeArgs>,
    insert_tubings_type_one?: GraphCacheUpdateResolver<{ insert_tubings_type_one: Maybe<WithTypename<Tubings_Type>> }, Mutation_RootInsert_Tubings_Type_OneArgs>,
    insert_under_saturated_oil_options?: GraphCacheUpdateResolver<{ insert_under_saturated_oil_options: Maybe<WithTypename<Under_Saturated_Oil_Options_Mutation_Response>> }, Mutation_RootInsert_Under_Saturated_Oil_OptionsArgs>,
    insert_under_saturated_oil_options_one?: GraphCacheUpdateResolver<{ insert_under_saturated_oil_options_one: Maybe<WithTypename<Under_Saturated_Oil_Options>> }, Mutation_RootInsert_Under_Saturated_Oil_Options_OneArgs>,
    insert_user_eula_acceptance?: GraphCacheUpdateResolver<{ insert_user_eula_acceptance: Maybe<WithTypename<User_Eula_Acceptance_Mutation_Response>> }, Mutation_RootInsert_User_Eula_AcceptanceArgs>,
    insert_user_eula_acceptance_one?: GraphCacheUpdateResolver<{ insert_user_eula_acceptance_one: Maybe<WithTypename<User_Eula_Acceptance>> }, Mutation_RootInsert_User_Eula_Acceptance_OneArgs>,
    insert_users?: GraphCacheUpdateResolver<{ insert_users: Maybe<WithTypename<Users_Mutation_Response>> }, Mutation_RootInsert_UsersArgs>,
    insert_users_one?: GraphCacheUpdateResolver<{ insert_users_one: Maybe<WithTypename<Users>> }, Mutation_RootInsert_Users_OneArgs>,
    insert_variable_speed_drives?: GraphCacheUpdateResolver<{ insert_variable_speed_drives: Maybe<WithTypename<Variable_Speed_Drives_Mutation_Response>> }, Mutation_RootInsert_Variable_Speed_DrivesArgs>,
    insert_variable_speed_drives_one?: GraphCacheUpdateResolver<{ insert_variable_speed_drives_one: Maybe<WithTypename<Variable_Speed_Drives>> }, Mutation_RootInsert_Variable_Speed_Drives_OneArgs>,
    insert_water_density_options?: GraphCacheUpdateResolver<{ insert_water_density_options: Maybe<WithTypename<Water_Density_Options_Mutation_Response>> }, Mutation_RootInsert_Water_Density_OptionsArgs>,
    insert_water_density_options_one?: GraphCacheUpdateResolver<{ insert_water_density_options_one: Maybe<WithTypename<Water_Density_Options>> }, Mutation_RootInsert_Water_Density_Options_OneArgs>,
    insert_water_solution_gas_options?: GraphCacheUpdateResolver<{ insert_water_solution_gas_options: Maybe<WithTypename<Water_Solution_Gas_Options_Mutation_Response>> }, Mutation_RootInsert_Water_Solution_Gas_OptionsArgs>,
    insert_water_solution_gas_options_one?: GraphCacheUpdateResolver<{ insert_water_solution_gas_options_one: Maybe<WithTypename<Water_Solution_Gas_Options>> }, Mutation_RootInsert_Water_Solution_Gas_Options_OneArgs>,
    insert_water_viscosity_options?: GraphCacheUpdateResolver<{ insert_water_viscosity_options: Maybe<WithTypename<Water_Viscosity_Options_Mutation_Response>> }, Mutation_RootInsert_Water_Viscosity_OptionsArgs>,
    insert_water_viscosity_options_one?: GraphCacheUpdateResolver<{ insert_water_viscosity_options_one: Maybe<WithTypename<Water_Viscosity_Options>> }, Mutation_RootInsert_Water_Viscosity_Options_OneArgs>,
    insert_water_volume_factor_options?: GraphCacheUpdateResolver<{ insert_water_volume_factor_options: Maybe<WithTypename<Water_Volume_Factor_Options_Mutation_Response>> }, Mutation_RootInsert_Water_Volume_Factor_OptionsArgs>,
    insert_water_volume_factor_options_one?: GraphCacheUpdateResolver<{ insert_water_volume_factor_options_one: Maybe<WithTypename<Water_Volume_Factor_Options>> }, Mutation_RootInsert_Water_Volume_Factor_Options_OneArgs>,
    insert_well_gas_type_options?: GraphCacheUpdateResolver<{ insert_well_gas_type_options: Maybe<WithTypename<Well_Gas_Type_Options_Mutation_Response>> }, Mutation_RootInsert_Well_Gas_Type_OptionsArgs>,
    insert_well_gas_type_options_one?: GraphCacheUpdateResolver<{ insert_well_gas_type_options_one: Maybe<WithTypename<Well_Gas_Type_Options>> }, Mutation_RootInsert_Well_Gas_Type_Options_OneArgs>,
    insert_well_test_gas_input_options?: GraphCacheUpdateResolver<{ insert_well_test_gas_input_options: Maybe<WithTypename<Well_Test_Gas_Input_Options_Mutation_Response>> }, Mutation_RootInsert_Well_Test_Gas_Input_OptionsArgs>,
    insert_well_test_gas_input_options_one?: GraphCacheUpdateResolver<{ insert_well_test_gas_input_options_one: Maybe<WithTypename<Well_Test_Gas_Input_Options>> }, Mutation_RootInsert_Well_Test_Gas_Input_Options_OneArgs>,
    insert_well_test_liquid_input_options?: GraphCacheUpdateResolver<{ insert_well_test_liquid_input_options: Maybe<WithTypename<Well_Test_Liquid_Input_Options_Mutation_Response>> }, Mutation_RootInsert_Well_Test_Liquid_Input_OptionsArgs>,
    insert_well_test_liquid_input_options_one?: GraphCacheUpdateResolver<{ insert_well_test_liquid_input_options_one: Maybe<WithTypename<Well_Test_Liquid_Input_Options>> }, Mutation_RootInsert_Well_Test_Liquid_Input_Options_OneArgs>,
    insert_well_test_pressure_input_options?: GraphCacheUpdateResolver<{ insert_well_test_pressure_input_options: Maybe<WithTypename<Well_Test_Pressure_Input_Options_Mutation_Response>> }, Mutation_RootInsert_Well_Test_Pressure_Input_OptionsArgs>,
    insert_well_test_pressure_input_options_one?: GraphCacheUpdateResolver<{ insert_well_test_pressure_input_options_one: Maybe<WithTypename<Well_Test_Pressure_Input_Options>> }, Mutation_RootInsert_Well_Test_Pressure_Input_Options_OneArgs>,
    insert_wells?: GraphCacheUpdateResolver<{ insert_wells: Maybe<WithTypename<Wells_Mutation_Response>> }, Mutation_RootInsert_WellsArgs>,
    insert_wells_one?: GraphCacheUpdateResolver<{ insert_wells_one: Maybe<WithTypename<Wells>> }, Mutation_RootInsert_Wells_OneArgs>,
    insert_y_tools?: GraphCacheUpdateResolver<{ insert_y_tools: Maybe<WithTypename<Y_Tools_Mutation_Response>> }, Mutation_RootInsert_Y_ToolsArgs>,
    insert_y_tools_one?: GraphCacheUpdateResolver<{ insert_y_tools_one: Maybe<WithTypename<Y_Tools>> }, Mutation_RootInsert_Y_Tools_OneArgs>,
    updateSKQuoteJob?: GraphCacheUpdateResolver<{ updateSKQuoteJob: Maybe<WithTypename<SkQuote>> }, Mutation_RootUpdateSkQuoteJobArgs>,
    update_bolt_on_discharges?: GraphCacheUpdateResolver<{ update_bolt_on_discharges: Maybe<WithTypename<Bolt_On_Discharges_Mutation_Response>> }, Mutation_RootUpdate_Bolt_On_DischargesArgs>,
    update_bolt_on_discharges_by_pk?: GraphCacheUpdateResolver<{ update_bolt_on_discharges_by_pk: Maybe<WithTypename<Bolt_On_Discharges>> }, Mutation_RootUpdate_Bolt_On_Discharges_By_PkArgs>,
    update_bolt_on_discharges_many?: GraphCacheUpdateResolver<{ update_bolt_on_discharges_many: Maybe<Array<WithTypename<Bolt_On_Discharges_Mutation_Response>>> }, Mutation_RootUpdate_Bolt_On_Discharges_ManyArgs>,
    update_bubble_point_options?: GraphCacheUpdateResolver<{ update_bubble_point_options: Maybe<WithTypename<Bubble_Point_Options_Mutation_Response>> }, Mutation_RootUpdate_Bubble_Point_OptionsArgs>,
    update_bubble_point_options_by_pk?: GraphCacheUpdateResolver<{ update_bubble_point_options_by_pk: Maybe<WithTypename<Bubble_Point_Options>> }, Mutation_RootUpdate_Bubble_Point_Options_By_PkArgs>,
    update_bubble_point_options_many?: GraphCacheUpdateResolver<{ update_bubble_point_options_many: Maybe<Array<WithTypename<Bubble_Point_Options_Mutation_Response>>> }, Mutation_RootUpdate_Bubble_Point_Options_ManyArgs>,
    update_cables?: GraphCacheUpdateResolver<{ update_cables: Maybe<WithTypename<Cables_Mutation_Response>> }, Mutation_RootUpdate_CablesArgs>,
    update_cables_by_pk?: GraphCacheUpdateResolver<{ update_cables_by_pk: Maybe<WithTypename<Cables>> }, Mutation_RootUpdate_Cables_By_PkArgs>,
    update_cables_many?: GraphCacheUpdateResolver<{ update_cables_many: Maybe<Array<WithTypename<Cables_Mutation_Response>>> }, Mutation_RootUpdate_Cables_ManyArgs>,
    update_casing_flow_options?: GraphCacheUpdateResolver<{ update_casing_flow_options: Maybe<WithTypename<Casing_Flow_Options_Mutation_Response>> }, Mutation_RootUpdate_Casing_Flow_OptionsArgs>,
    update_casing_flow_options_by_pk?: GraphCacheUpdateResolver<{ update_casing_flow_options_by_pk: Maybe<WithTypename<Casing_Flow_Options>> }, Mutation_RootUpdate_Casing_Flow_Options_By_PkArgs>,
    update_casing_flow_options_many?: GraphCacheUpdateResolver<{ update_casing_flow_options_many: Maybe<Array<WithTypename<Casing_Flow_Options_Mutation_Response>>> }, Mutation_RootUpdate_Casing_Flow_Options_ManyArgs>,
    update_casings?: GraphCacheUpdateResolver<{ update_casings: Maybe<WithTypename<Casings_Mutation_Response>> }, Mutation_RootUpdate_CasingsArgs>,
    update_casings_by_pk?: GraphCacheUpdateResolver<{ update_casings_by_pk: Maybe<WithTypename<Casings>> }, Mutation_RootUpdate_Casings_By_PkArgs>,
    update_casings_many?: GraphCacheUpdateResolver<{ update_casings_many: Maybe<Array<WithTypename<Casings_Mutation_Response>>> }, Mutation_RootUpdate_Casings_ManyArgs>,
    update_casings_type?: GraphCacheUpdateResolver<{ update_casings_type: Maybe<WithTypename<Casings_Type_Mutation_Response>> }, Mutation_RootUpdate_Casings_TypeArgs>,
    update_casings_type_by_pk?: GraphCacheUpdateResolver<{ update_casings_type_by_pk: Maybe<WithTypename<Casings_Type>> }, Mutation_RootUpdate_Casings_Type_By_PkArgs>,
    update_casings_type_many?: GraphCacheUpdateResolver<{ update_casings_type_many: Maybe<Array<WithTypename<Casings_Type_Mutation_Response>>> }, Mutation_RootUpdate_Casings_Type_ManyArgs>,
    update_customers?: GraphCacheUpdateResolver<{ update_customers: Maybe<WithTypename<Customers_Mutation_Response>> }, Mutation_RootUpdate_CustomersArgs>,
    update_customers_by_pk?: GraphCacheUpdateResolver<{ update_customers_by_pk: Maybe<WithTypename<Customers>> }, Mutation_RootUpdate_Customers_By_PkArgs>,
    update_customers_many?: GraphCacheUpdateResolver<{ update_customers_many: Maybe<Array<WithTypename<Customers_Mutation_Response>>> }, Mutation_RootUpdate_Customers_ManyArgs>,
    update_dead_oil_options?: GraphCacheUpdateResolver<{ update_dead_oil_options: Maybe<WithTypename<Dead_Oil_Options_Mutation_Response>> }, Mutation_RootUpdate_Dead_Oil_OptionsArgs>,
    update_dead_oil_options_by_pk?: GraphCacheUpdateResolver<{ update_dead_oil_options_by_pk: Maybe<WithTypename<Dead_Oil_Options>> }, Mutation_RootUpdate_Dead_Oil_Options_By_PkArgs>,
    update_dead_oil_options_many?: GraphCacheUpdateResolver<{ update_dead_oil_options_many: Maybe<Array<WithTypename<Dead_Oil_Options_Mutation_Response>>> }, Mutation_RootUpdate_Dead_Oil_Options_ManyArgs>,
    update_deviation_survey?: GraphCacheUpdateResolver<{ update_deviation_survey: Maybe<WithTypename<Deviation_Survey_Mutation_Response>> }, Mutation_RootUpdate_Deviation_SurveyArgs>,
    update_deviation_survey_by_pk?: GraphCacheUpdateResolver<{ update_deviation_survey_by_pk: Maybe<WithTypename<Deviation_Survey>> }, Mutation_RootUpdate_Deviation_Survey_By_PkArgs>,
    update_deviation_survey_directional_dataset?: GraphCacheUpdateResolver<{ update_deviation_survey_directional_dataset: Maybe<WithTypename<Deviation_Survey_Directional_Dataset_Mutation_Response>> }, Mutation_RootUpdate_Deviation_Survey_Directional_DatasetArgs>,
    update_deviation_survey_directional_dataset_by_pk?: GraphCacheUpdateResolver<{ update_deviation_survey_directional_dataset_by_pk: Maybe<WithTypename<Deviation_Survey_Directional_Dataset>> }, Mutation_RootUpdate_Deviation_Survey_Directional_Dataset_By_PkArgs>,
    update_deviation_survey_directional_dataset_many?: GraphCacheUpdateResolver<{ update_deviation_survey_directional_dataset_many: Maybe<Array<WithTypename<Deviation_Survey_Directional_Dataset_Mutation_Response>>> }, Mutation_RootUpdate_Deviation_Survey_Directional_Dataset_ManyArgs>,
    update_deviation_survey_many?: GraphCacheUpdateResolver<{ update_deviation_survey_many: Maybe<Array<WithTypename<Deviation_Survey_Mutation_Response>>> }, Mutation_RootUpdate_Deviation_Survey_ManyArgs>,
    update_display_units?: GraphCacheUpdateResolver<{ update_display_units: Maybe<WithTypename<Display_Units_Mutation_Response>> }, Mutation_RootUpdate_Display_UnitsArgs>,
    update_display_units_by_pk?: GraphCacheUpdateResolver<{ update_display_units_by_pk: Maybe<WithTypename<Display_Units>> }, Mutation_RootUpdate_Display_Units_By_PkArgs>,
    update_display_units_many?: GraphCacheUpdateResolver<{ update_display_units_many: Maybe<Array<WithTypename<Display_Units_Mutation_Response>>> }, Mutation_RootUpdate_Display_Units_ManyArgs>,
    update_eula?: GraphCacheUpdateResolver<{ update_eula: Maybe<WithTypename<Eula_Mutation_Response>> }, Mutation_RootUpdate_EulaArgs>,
    update_eula_by_pk?: GraphCacheUpdateResolver<{ update_eula_by_pk: Maybe<WithTypename<Eula>> }, Mutation_RootUpdate_Eula_By_PkArgs>,
    update_eula_many?: GraphCacheUpdateResolver<{ update_eula_many: Maybe<Array<WithTypename<Eula_Mutation_Response>>> }, Mutation_RootUpdate_Eula_ManyArgs>,
    update_flow_model?: GraphCacheUpdateResolver<{ update_flow_model: Maybe<WithTypename<Flow_Model_Mutation_Response>> }, Mutation_RootUpdate_Flow_ModelArgs>,
    update_flow_model_active?: GraphCacheUpdateResolver<{ update_flow_model_active: Maybe<WithTypename<Flow_Model_Active_Mutation_Response>> }, Mutation_RootUpdate_Flow_Model_ActiveArgs>,
    update_flow_model_active_many?: GraphCacheUpdateResolver<{ update_flow_model_active_many: Maybe<Array<WithTypename<Flow_Model_Active_Mutation_Response>>> }, Mutation_RootUpdate_Flow_Model_Active_ManyArgs>,
    update_flow_model_by_pk?: GraphCacheUpdateResolver<{ update_flow_model_by_pk: Maybe<WithTypename<Flow_Model>> }, Mutation_RootUpdate_Flow_Model_By_PkArgs>,
    update_flow_model_deprecated?: GraphCacheUpdateResolver<{ update_flow_model_deprecated: Maybe<WithTypename<Flow_Model_Deprecated_Mutation_Response>> }, Mutation_RootUpdate_Flow_Model_DeprecatedArgs>,
    update_flow_model_deprecated_by_pk?: GraphCacheUpdateResolver<{ update_flow_model_deprecated_by_pk: Maybe<WithTypename<Flow_Model_Deprecated>> }, Mutation_RootUpdate_Flow_Model_Deprecated_By_PkArgs>,
    update_flow_model_deprecated_many?: GraphCacheUpdateResolver<{ update_flow_model_deprecated_many: Maybe<Array<WithTypename<Flow_Model_Deprecated_Mutation_Response>>> }, Mutation_RootUpdate_Flow_Model_Deprecated_ManyArgs>,
    update_flow_model_many?: GraphCacheUpdateResolver<{ update_flow_model_many: Maybe<Array<WithTypename<Flow_Model_Mutation_Response>>> }, Mutation_RootUpdate_Flow_Model_ManyArgs>,
    update_friction_loss_options?: GraphCacheUpdateResolver<{ update_friction_loss_options: Maybe<WithTypename<Friction_Loss_Options_Mutation_Response>> }, Mutation_RootUpdate_Friction_Loss_OptionsArgs>,
    update_friction_loss_options_by_pk?: GraphCacheUpdateResolver<{ update_friction_loss_options_by_pk: Maybe<WithTypename<Friction_Loss_Options>> }, Mutation_RootUpdate_Friction_Loss_Options_By_PkArgs>,
    update_friction_loss_options_many?: GraphCacheUpdateResolver<{ update_friction_loss_options_many: Maybe<Array<WithTypename<Friction_Loss_Options_Mutation_Response>>> }, Mutation_RootUpdate_Friction_Loss_Options_ManyArgs>,
    update_gas_compressibility_options?: GraphCacheUpdateResolver<{ update_gas_compressibility_options: Maybe<WithTypename<Gas_Compressibility_Options_Mutation_Response>> }, Mutation_RootUpdate_Gas_Compressibility_OptionsArgs>,
    update_gas_compressibility_options_by_pk?: GraphCacheUpdateResolver<{ update_gas_compressibility_options_by_pk: Maybe<WithTypename<Gas_Compressibility_Options>> }, Mutation_RootUpdate_Gas_Compressibility_Options_By_PkArgs>,
    update_gas_compressibility_options_many?: GraphCacheUpdateResolver<{ update_gas_compressibility_options_many: Maybe<Array<WithTypename<Gas_Compressibility_Options_Mutation_Response>>> }, Mutation_RootUpdate_Gas_Compressibility_Options_ManyArgs>,
    update_gas_viscosity_options?: GraphCacheUpdateResolver<{ update_gas_viscosity_options: Maybe<WithTypename<Gas_Viscosity_Options_Mutation_Response>> }, Mutation_RootUpdate_Gas_Viscosity_OptionsArgs>,
    update_gas_viscosity_options_by_pk?: GraphCacheUpdateResolver<{ update_gas_viscosity_options_by_pk: Maybe<WithTypename<Gas_Viscosity_Options>> }, Mutation_RootUpdate_Gas_Viscosity_Options_By_PkArgs>,
    update_gas_viscosity_options_many?: GraphCacheUpdateResolver<{ update_gas_viscosity_options_many: Maybe<Array<WithTypename<Gas_Viscosity_Options_Mutation_Response>>> }, Mutation_RootUpdate_Gas_Viscosity_Options_ManyArgs>,
    update_housings?: GraphCacheUpdateResolver<{ update_housings: Maybe<WithTypename<Housings_Mutation_Response>> }, Mutation_RootUpdate_HousingsArgs>,
    update_housings_by_pk?: GraphCacheUpdateResolver<{ update_housings_by_pk: Maybe<WithTypename<Housings>> }, Mutation_RootUpdate_Housings_By_PkArgs>,
    update_housings_many?: GraphCacheUpdateResolver<{ update_housings_many: Maybe<Array<WithTypename<Housings_Mutation_Response>>> }, Mutation_RootUpdate_Housings_ManyArgs>,
    update_hps_liquid_type?: GraphCacheUpdateResolver<{ update_hps_liquid_type: Maybe<WithTypename<Hps_Liquid_Type_Mutation_Response>> }, Mutation_RootUpdate_Hps_Liquid_TypeArgs>,
    update_hps_liquid_type_by_pk?: GraphCacheUpdateResolver<{ update_hps_liquid_type_by_pk: Maybe<WithTypename<Hps_Liquid_Type>> }, Mutation_RootUpdate_Hps_Liquid_Type_By_PkArgs>,
    update_hps_liquid_type_many?: GraphCacheUpdateResolver<{ update_hps_liquid_type_many: Maybe<Array<WithTypename<Hps_Liquid_Type_Mutation_Response>>> }, Mutation_RootUpdate_Hps_Liquid_Type_ManyArgs>,
    update_intakes?: GraphCacheUpdateResolver<{ update_intakes: Maybe<WithTypename<Intakes_Mutation_Response>> }, Mutation_RootUpdate_IntakesArgs>,
    update_intakes_by_pk?: GraphCacheUpdateResolver<{ update_intakes_by_pk: Maybe<WithTypename<Intakes>> }, Mutation_RootUpdate_Intakes_By_PkArgs>,
    update_intakes_many?: GraphCacheUpdateResolver<{ update_intakes_many: Maybe<Array<WithTypename<Intakes_Mutation_Response>>> }, Mutation_RootUpdate_Intakes_ManyArgs>,
    update_legacy_users?: GraphCacheUpdateResolver<{ update_legacy_users: Maybe<WithTypename<Legacy_Users_Mutation_Response>> }, Mutation_RootUpdate_Legacy_UsersArgs>,
    update_legacy_users_by_pk?: GraphCacheUpdateResolver<{ update_legacy_users_by_pk: Maybe<WithTypename<Legacy_Users>> }, Mutation_RootUpdate_Legacy_Users_By_PkArgs>,
    update_legacy_users_many?: GraphCacheUpdateResolver<{ update_legacy_users_many: Maybe<Array<WithTypename<Legacy_Users_Mutation_Response>>> }, Mutation_RootUpdate_Legacy_Users_ManyArgs>,
    update_motor_lead_extensions?: GraphCacheUpdateResolver<{ update_motor_lead_extensions: Maybe<WithTypename<Motor_Lead_Extensions_Mutation_Response>> }, Mutation_RootUpdate_Motor_Lead_ExtensionsArgs>,
    update_motor_lead_extensions_by_pk?: GraphCacheUpdateResolver<{ update_motor_lead_extensions_by_pk: Maybe<WithTypename<Motor_Lead_Extensions>> }, Mutation_RootUpdate_Motor_Lead_Extensions_By_PkArgs>,
    update_motor_lead_extensions_many?: GraphCacheUpdateResolver<{ update_motor_lead_extensions_many: Maybe<Array<WithTypename<Motor_Lead_Extensions_Mutation_Response>>> }, Mutation_RootUpdate_Motor_Lead_Extensions_ManyArgs>,
    update_motors?: GraphCacheUpdateResolver<{ update_motors: Maybe<WithTypename<Motors_Mutation_Response>> }, Mutation_RootUpdate_MotorsArgs>,
    update_motors_by_pk?: GraphCacheUpdateResolver<{ update_motors_by_pk: Maybe<WithTypename<Motors>> }, Mutation_RootUpdate_Motors_By_PkArgs>,
    update_motors_many?: GraphCacheUpdateResolver<{ update_motors_many: Maybe<Array<WithTypename<Motors_Mutation_Response>>> }, Mutation_RootUpdate_Motors_ManyArgs>,
    update_natural_gas_separation_options?: GraphCacheUpdateResolver<{ update_natural_gas_separation_options: Maybe<WithTypename<Natural_Gas_Separation_Options_Mutation_Response>> }, Mutation_RootUpdate_Natural_Gas_Separation_OptionsArgs>,
    update_natural_gas_separation_options_by_pk?: GraphCacheUpdateResolver<{ update_natural_gas_separation_options_by_pk: Maybe<WithTypename<Natural_Gas_Separation_Options>> }, Mutation_RootUpdate_Natural_Gas_Separation_Options_By_PkArgs>,
    update_natural_gas_separation_options_many?: GraphCacheUpdateResolver<{ update_natural_gas_separation_options_many: Maybe<Array<WithTypename<Natural_Gas_Separation_Options_Mutation_Response>>> }, Mutation_RootUpdate_Natural_Gas_Separation_Options_ManyArgs>,
    update_oil_density_options?: GraphCacheUpdateResolver<{ update_oil_density_options: Maybe<WithTypename<Oil_Density_Options_Mutation_Response>> }, Mutation_RootUpdate_Oil_Density_OptionsArgs>,
    update_oil_density_options_by_pk?: GraphCacheUpdateResolver<{ update_oil_density_options_by_pk: Maybe<WithTypename<Oil_Density_Options>> }, Mutation_RootUpdate_Oil_Density_Options_By_PkArgs>,
    update_oil_density_options_many?: GraphCacheUpdateResolver<{ update_oil_density_options_many: Maybe<Array<WithTypename<Oil_Density_Options_Mutation_Response>>> }, Mutation_RootUpdate_Oil_Density_Options_ManyArgs>,
    update_oil_volume_factor_options?: GraphCacheUpdateResolver<{ update_oil_volume_factor_options: Maybe<WithTypename<Oil_Volume_Factor_Options_Mutation_Response>> }, Mutation_RootUpdate_Oil_Volume_Factor_OptionsArgs>,
    update_oil_volume_factor_options_by_pk?: GraphCacheUpdateResolver<{ update_oil_volume_factor_options_by_pk: Maybe<WithTypename<Oil_Volume_Factor_Options>> }, Mutation_RootUpdate_Oil_Volume_Factor_Options_By_PkArgs>,
    update_oil_volume_factor_options_many?: GraphCacheUpdateResolver<{ update_oil_volume_factor_options_many: Maybe<Array<WithTypename<Oil_Volume_Factor_Options_Mutation_Response>>> }, Mutation_RootUpdate_Oil_Volume_Factor_Options_ManyArgs>,
    update_override_options?: GraphCacheUpdateResolver<{ update_override_options: Maybe<WithTypename<Override_Options_Mutation_Response>> }, Mutation_RootUpdate_Override_OptionsArgs>,
    update_override_options_by_pk?: GraphCacheUpdateResolver<{ update_override_options_by_pk: Maybe<WithTypename<Override_Options>> }, Mutation_RootUpdate_Override_Options_By_PkArgs>,
    update_override_options_many?: GraphCacheUpdateResolver<{ update_override_options_many: Maybe<Array<WithTypename<Override_Options_Mutation_Response>>> }, Mutation_RootUpdate_Override_Options_ManyArgs>,
    update_pumps?: GraphCacheUpdateResolver<{ update_pumps: Maybe<WithTypename<Pumps_Mutation_Response>> }, Mutation_RootUpdate_PumpsArgs>,
    update_pumps_by_pk?: GraphCacheUpdateResolver<{ update_pumps_by_pk: Maybe<WithTypename<Pumps>> }, Mutation_RootUpdate_Pumps_By_PkArgs>,
    update_pumps_many?: GraphCacheUpdateResolver<{ update_pumps_many: Maybe<Array<WithTypename<Pumps_Mutation_Response>>> }, Mutation_RootUpdate_Pumps_ManyArgs>,
    update_quote_line_item_category_dataset?: GraphCacheUpdateResolver<{ update_quote_line_item_category_dataset: Maybe<WithTypename<Quote_Line_Item_Category_Dataset_Mutation_Response>> }, Mutation_RootUpdate_Quote_Line_Item_Category_DatasetArgs>,
    update_quote_line_item_category_dataset_by_pk?: GraphCacheUpdateResolver<{ update_quote_line_item_category_dataset_by_pk: Maybe<WithTypename<Quote_Line_Item_Category_Dataset>> }, Mutation_RootUpdate_Quote_Line_Item_Category_Dataset_By_PkArgs>,
    update_quote_line_item_category_dataset_many?: GraphCacheUpdateResolver<{ update_quote_line_item_category_dataset_many: Maybe<Array<WithTypename<Quote_Line_Item_Category_Dataset_Mutation_Response>>> }, Mutation_RootUpdate_Quote_Line_Item_Category_Dataset_ManyArgs>,
    update_quote_line_item_serialized_dataset?: GraphCacheUpdateResolver<{ update_quote_line_item_serialized_dataset: Maybe<WithTypename<Quote_Line_Item_Serialized_Dataset_Mutation_Response>> }, Mutation_RootUpdate_Quote_Line_Item_Serialized_DatasetArgs>,
    update_quote_line_item_serialized_dataset_by_pk?: GraphCacheUpdateResolver<{ update_quote_line_item_serialized_dataset_by_pk: Maybe<WithTypename<Quote_Line_Item_Serialized_Dataset>> }, Mutation_RootUpdate_Quote_Line_Item_Serialized_Dataset_By_PkArgs>,
    update_quote_line_item_serialized_dataset_many?: GraphCacheUpdateResolver<{ update_quote_line_item_serialized_dataset_many: Maybe<Array<WithTypename<Quote_Line_Item_Serialized_Dataset_Mutation_Response>>> }, Mutation_RootUpdate_Quote_Line_Item_Serialized_Dataset_ManyArgs>,
    update_quote_line_item_source_dataset?: GraphCacheUpdateResolver<{ update_quote_line_item_source_dataset: Maybe<WithTypename<Quote_Line_Item_Source_Dataset_Mutation_Response>> }, Mutation_RootUpdate_Quote_Line_Item_Source_DatasetArgs>,
    update_quote_line_item_source_dataset_by_pk?: GraphCacheUpdateResolver<{ update_quote_line_item_source_dataset_by_pk: Maybe<WithTypename<Quote_Line_Item_Source_Dataset>> }, Mutation_RootUpdate_Quote_Line_Item_Source_Dataset_By_PkArgs>,
    update_quote_line_item_source_dataset_many?: GraphCacheUpdateResolver<{ update_quote_line_item_source_dataset_many: Maybe<Array<WithTypename<Quote_Line_Item_Source_Dataset_Mutation_Response>>> }, Mutation_RootUpdate_Quote_Line_Item_Source_Dataset_ManyArgs>,
    update_quote_line_item_subcategory_dataset?: GraphCacheUpdateResolver<{ update_quote_line_item_subcategory_dataset: Maybe<WithTypename<Quote_Line_Item_Subcategory_Dataset_Mutation_Response>> }, Mutation_RootUpdate_Quote_Line_Item_Subcategory_DatasetArgs>,
    update_quote_line_item_subcategory_dataset_by_pk?: GraphCacheUpdateResolver<{ update_quote_line_item_subcategory_dataset_by_pk: Maybe<WithTypename<Quote_Line_Item_Subcategory_Dataset>> }, Mutation_RootUpdate_Quote_Line_Item_Subcategory_Dataset_By_PkArgs>,
    update_quote_line_item_subcategory_dataset_many?: GraphCacheUpdateResolver<{ update_quote_line_item_subcategory_dataset_many: Maybe<Array<WithTypename<Quote_Line_Item_Subcategory_Dataset_Mutation_Response>>> }, Mutation_RootUpdate_Quote_Line_Item_Subcategory_Dataset_ManyArgs>,
    update_quote_line_item_tax_type_dataset?: GraphCacheUpdateResolver<{ update_quote_line_item_tax_type_dataset: Maybe<WithTypename<Quote_Line_Item_Tax_Type_Dataset_Mutation_Response>> }, Mutation_RootUpdate_Quote_Line_Item_Tax_Type_DatasetArgs>,
    update_quote_line_item_tax_type_dataset_by_pk?: GraphCacheUpdateResolver<{ update_quote_line_item_tax_type_dataset_by_pk: Maybe<WithTypename<Quote_Line_Item_Tax_Type_Dataset>> }, Mutation_RootUpdate_Quote_Line_Item_Tax_Type_Dataset_By_PkArgs>,
    update_quote_line_item_tax_type_dataset_many?: GraphCacheUpdateResolver<{ update_quote_line_item_tax_type_dataset_many: Maybe<Array<WithTypename<Quote_Line_Item_Tax_Type_Dataset_Mutation_Response>>> }, Mutation_RootUpdate_Quote_Line_Item_Tax_Type_Dataset_ManyArgs>,
    update_quote_line_item_type_dataset?: GraphCacheUpdateResolver<{ update_quote_line_item_type_dataset: Maybe<WithTypename<Quote_Line_Item_Type_Dataset_Mutation_Response>> }, Mutation_RootUpdate_Quote_Line_Item_Type_DatasetArgs>,
    update_quote_line_item_type_dataset_by_pk?: GraphCacheUpdateResolver<{ update_quote_line_item_type_dataset_by_pk: Maybe<WithTypename<Quote_Line_Item_Type_Dataset>> }, Mutation_RootUpdate_Quote_Line_Item_Type_Dataset_By_PkArgs>,
    update_quote_line_item_type_dataset_many?: GraphCacheUpdateResolver<{ update_quote_line_item_type_dataset_many: Maybe<Array<WithTypename<Quote_Line_Item_Type_Dataset_Mutation_Response>>> }, Mutation_RootUpdate_Quote_Line_Item_Type_Dataset_ManyArgs>,
    update_quote_line_items?: GraphCacheUpdateResolver<{ update_quote_line_items: Maybe<WithTypename<Quote_Line_Items_Mutation_Response>> }, Mutation_RootUpdate_Quote_Line_ItemsArgs>,
    update_quote_line_items_by_pk?: GraphCacheUpdateResolver<{ update_quote_line_items_by_pk: Maybe<WithTypename<Quote_Line_Items>> }, Mutation_RootUpdate_Quote_Line_Items_By_PkArgs>,
    update_quote_line_items_many?: GraphCacheUpdateResolver<{ update_quote_line_items_many: Maybe<Array<WithTypename<Quote_Line_Items_Mutation_Response>>> }, Mutation_RootUpdate_Quote_Line_Items_ManyArgs>,
    update_quote_sk_job_type_dataset?: GraphCacheUpdateResolver<{ update_quote_sk_job_type_dataset: Maybe<WithTypename<Quote_Sk_Job_Type_Dataset_Mutation_Response>> }, Mutation_RootUpdate_Quote_Sk_Job_Type_DatasetArgs>,
    update_quote_sk_job_type_dataset_by_pk?: GraphCacheUpdateResolver<{ update_quote_sk_job_type_dataset_by_pk: Maybe<WithTypename<Quote_Sk_Job_Type_Dataset>> }, Mutation_RootUpdate_Quote_Sk_Job_Type_Dataset_By_PkArgs>,
    update_quote_sk_job_type_dataset_many?: GraphCacheUpdateResolver<{ update_quote_sk_job_type_dataset_many: Maybe<Array<WithTypename<Quote_Sk_Job_Type_Dataset_Mutation_Response>>> }, Mutation_RootUpdate_Quote_Sk_Job_Type_Dataset_ManyArgs>,
    update_quote_source_dataset?: GraphCacheUpdateResolver<{ update_quote_source_dataset: Maybe<WithTypename<Quote_Source_Dataset_Mutation_Response>> }, Mutation_RootUpdate_Quote_Source_DatasetArgs>,
    update_quote_source_dataset_by_pk?: GraphCacheUpdateResolver<{ update_quote_source_dataset_by_pk: Maybe<WithTypename<Quote_Source_Dataset>> }, Mutation_RootUpdate_Quote_Source_Dataset_By_PkArgs>,
    update_quote_source_dataset_many?: GraphCacheUpdateResolver<{ update_quote_source_dataset_many: Maybe<Array<WithTypename<Quote_Source_Dataset_Mutation_Response>>> }, Mutation_RootUpdate_Quote_Source_Dataset_ManyArgs>,
    update_quote_status_dataset?: GraphCacheUpdateResolver<{ update_quote_status_dataset: Maybe<WithTypename<Quote_Status_Dataset_Mutation_Response>> }, Mutation_RootUpdate_Quote_Status_DatasetArgs>,
    update_quote_status_dataset_by_pk?: GraphCacheUpdateResolver<{ update_quote_status_dataset_by_pk: Maybe<WithTypename<Quote_Status_Dataset>> }, Mutation_RootUpdate_Quote_Status_Dataset_By_PkArgs>,
    update_quote_status_dataset_many?: GraphCacheUpdateResolver<{ update_quote_status_dataset_many: Maybe<Array<WithTypename<Quote_Status_Dataset_Mutation_Response>>> }, Mutation_RootUpdate_Quote_Status_Dataset_ManyArgs>,
    update_quote_user_messages?: GraphCacheUpdateResolver<{ update_quote_user_messages: Maybe<WithTypename<Quote_User_Messages_Mutation_Response>> }, Mutation_RootUpdate_Quote_User_MessagesArgs>,
    update_quote_user_messages_by_pk?: GraphCacheUpdateResolver<{ update_quote_user_messages_by_pk: Maybe<WithTypename<Quote_User_Messages>> }, Mutation_RootUpdate_Quote_User_Messages_By_PkArgs>,
    update_quote_user_messages_many?: GraphCacheUpdateResolver<{ update_quote_user_messages_many: Maybe<Array<WithTypename<Quote_User_Messages_Mutation_Response>>> }, Mutation_RootUpdate_Quote_User_Messages_ManyArgs>,
    update_quotes?: GraphCacheUpdateResolver<{ update_quotes: Maybe<WithTypename<Quotes_Mutation_Response>> }, Mutation_RootUpdate_QuotesArgs>,
    update_quotes_by_pk?: GraphCacheUpdateResolver<{ update_quotes_by_pk: Maybe<WithTypename<Quotes>> }, Mutation_RootUpdate_Quotes_By_PkArgs>,
    update_quotes_many?: GraphCacheUpdateResolver<{ update_quotes_many: Maybe<Array<WithTypename<Quotes_Mutation_Response>>> }, Mutation_RootUpdate_Quotes_ManyArgs>,
    update_revisions_performance_evaluations_journal?: GraphCacheUpdateResolver<{ update_revisions_performance_evaluations_journal: Maybe<WithTypename<Revisions_Performance_Evaluations_Journal_Mutation_Response>> }, Mutation_RootUpdate_Revisions_Performance_Evaluations_JournalArgs>,
    update_revisions_performance_evaluations_journal_by_pk?: GraphCacheUpdateResolver<{ update_revisions_performance_evaluations_journal_by_pk: Maybe<WithTypename<Revisions_Performance_Evaluations_Journal>> }, Mutation_RootUpdate_Revisions_Performance_Evaluations_Journal_By_PkArgs>,
    update_revisions_performance_evaluations_journal_many?: GraphCacheUpdateResolver<{ update_revisions_performance_evaluations_journal_many: Maybe<Array<WithTypename<Revisions_Performance_Evaluations_Journal_Mutation_Response>>> }, Mutation_RootUpdate_Revisions_Performance_Evaluations_Journal_ManyArgs>,
    update_revisions_performance_evaluations_revisions?: GraphCacheUpdateResolver<{ update_revisions_performance_evaluations_revisions: Maybe<WithTypename<Revisions_Performance_Evaluations_Revisions_Mutation_Response>> }, Mutation_RootUpdate_Revisions_Performance_Evaluations_RevisionsArgs>,
    update_revisions_performance_evaluations_revisions_by_pk?: GraphCacheUpdateResolver<{ update_revisions_performance_evaluations_revisions_by_pk: Maybe<WithTypename<Revisions_Performance_Evaluations_Revisions>> }, Mutation_RootUpdate_Revisions_Performance_Evaluations_Revisions_By_PkArgs>,
    update_revisions_performance_evaluations_revisions_many?: GraphCacheUpdateResolver<{ update_revisions_performance_evaluations_revisions_many: Maybe<Array<WithTypename<Revisions_Performance_Evaluations_Revisions_Mutation_Response>>> }, Mutation_RootUpdate_Revisions_Performance_Evaluations_Revisions_ManyArgs>,
    update_revisions_performance_evaluations_xref_pumps_journal?: GraphCacheUpdateResolver<{ update_revisions_performance_evaluations_xref_pumps_journal: Maybe<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Journal_Mutation_Response>> }, Mutation_RootUpdate_Revisions_Performance_Evaluations_Xref_Pumps_JournalArgs>,
    update_revisions_performance_evaluations_xref_pumps_journal_by_pk?: GraphCacheUpdateResolver<{ update_revisions_performance_evaluations_xref_pumps_journal_by_pk: Maybe<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Journal>> }, Mutation_RootUpdate_Revisions_Performance_Evaluations_Xref_Pumps_Journal_By_PkArgs>,
    update_revisions_performance_evaluations_xref_pumps_journal_many?: GraphCacheUpdateResolver<{ update_revisions_performance_evaluations_xref_pumps_journal_many: Maybe<Array<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Journal_Mutation_Response>>> }, Mutation_RootUpdate_Revisions_Performance_Evaluations_Xref_Pumps_Journal_ManyArgs>,
    update_revisions_performance_evaluations_xref_pumps_revisions?: GraphCacheUpdateResolver<{ update_revisions_performance_evaluations_xref_pumps_revisions: Maybe<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Mutation_Response>> }, Mutation_RootUpdate_Revisions_Performance_Evaluations_Xref_Pumps_RevisionsArgs>,
    update_revisions_performance_evaluations_xref_pumps_revisions_by_pk?: GraphCacheUpdateResolver<{ update_revisions_performance_evaluations_xref_pumps_revisions_by_pk: Maybe<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Revisions>> }, Mutation_RootUpdate_Revisions_Performance_Evaluations_Xref_Pumps_Revisions_By_PkArgs>,
    update_revisions_performance_evaluations_xref_pumps_revisions_many?: GraphCacheUpdateResolver<{ update_revisions_performance_evaluations_xref_pumps_revisions_many: Maybe<Array<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Mutation_Response>>> }, Mutation_RootUpdate_Revisions_Performance_Evaluations_Xref_Pumps_Revisions_ManyArgs>,
    update_revisions_sc_equip_xref_downhole_ytool_bypass_tubings_journal?: GraphCacheUpdateResolver<{ update_revisions_sc_equip_xref_downhole_ytool_bypass_tubings_journal: Maybe<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_Mutation_Response>> }, Mutation_RootUpdate_Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_JournalArgs>,
    update_revisions_sc_equip_xref_downhole_ytool_bypass_tubings_journal_by_pk?: GraphCacheUpdateResolver<{ update_revisions_sc_equip_xref_downhole_ytool_bypass_tubings_journal_by_pk: Maybe<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal>> }, Mutation_RootUpdate_Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_By_PkArgs>,
    update_revisions_sc_equip_xref_downhole_ytool_bypass_tubings_journal_many?: GraphCacheUpdateResolver<{ update_revisions_sc_equip_xref_downhole_ytool_bypass_tubings_journal_many: Maybe<Array<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_Mutation_Response>>> }, Mutation_RootUpdate_Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_ManyArgs>,
    update_revisions_sc_equip_xref_downhole_ytool_bypass_tubings_revisions?: GraphCacheUpdateResolver<{ update_revisions_sc_equip_xref_downhole_ytool_bypass_tubings_revisions: Maybe<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Mutation_Response>> }, Mutation_RootUpdate_Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_RevisionsArgs>,
    update_revisions_sc_equip_xref_downhole_ytool_bypass_tubings_revisions_by_pk?: GraphCacheUpdateResolver<{ update_revisions_sc_equip_xref_downhole_ytool_bypass_tubings_revisions_by_pk: Maybe<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions>> }, Mutation_RootUpdate_Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_By_PkArgs>,
    update_revisions_sc_equip_xref_downhole_ytool_bypass_tubings_revisions_many?: GraphCacheUpdateResolver<{ update_revisions_sc_equip_xref_downhole_ytool_bypass_tubings_revisions_many: Maybe<Array<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Mutation_Response>>> }, Mutation_RootUpdate_Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_ManyArgs>,
    update_revisions_sc_equip_xref_downhole_ytool_equip_tubings_journal?: GraphCacheUpdateResolver<{ update_revisions_sc_equip_xref_downhole_ytool_equip_tubings_journal: Maybe<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_Mutation_Response>> }, Mutation_RootUpdate_Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_JournalArgs>,
    update_revisions_sc_equip_xref_downhole_ytool_equip_tubings_journal_by_pk?: GraphCacheUpdateResolver<{ update_revisions_sc_equip_xref_downhole_ytool_equip_tubings_journal_by_pk: Maybe<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal>> }, Mutation_RootUpdate_Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_By_PkArgs>,
    update_revisions_sc_equip_xref_downhole_ytool_equip_tubings_journal_many?: GraphCacheUpdateResolver<{ update_revisions_sc_equip_xref_downhole_ytool_equip_tubings_journal_many: Maybe<Array<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_Mutation_Response>>> }, Mutation_RootUpdate_Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_ManyArgs>,
    update_revisions_sc_equip_xref_downhole_ytool_equip_tubings_revisions?: GraphCacheUpdateResolver<{ update_revisions_sc_equip_xref_downhole_ytool_equip_tubings_revisions: Maybe<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Mutation_Response>> }, Mutation_RootUpdate_Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_RevisionsArgs>,
    update_revisions_sc_equip_xref_downhole_ytool_equip_tubings_revisions_by_pk?: GraphCacheUpdateResolver<{ update_revisions_sc_equip_xref_downhole_ytool_equip_tubings_revisions_by_pk: Maybe<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions>> }, Mutation_RootUpdate_Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_By_PkArgs>,
    update_revisions_sc_equip_xref_downhole_ytool_equip_tubings_revisions_many?: GraphCacheUpdateResolver<{ update_revisions_sc_equip_xref_downhole_ytool_equip_tubings_revisions_many: Maybe<Array<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Mutation_Response>>> }, Mutation_RootUpdate_Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_ManyArgs>,
    update_revisions_sc_equip_xref_uphole_ytool_bypass_tubings_journal?: GraphCacheUpdateResolver<{ update_revisions_sc_equip_xref_uphole_ytool_bypass_tubings_journal: Maybe<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_Mutation_Response>> }, Mutation_RootUpdate_Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_JournalArgs>,
    update_revisions_sc_equip_xref_uphole_ytool_bypass_tubings_journal_by_pk?: GraphCacheUpdateResolver<{ update_revisions_sc_equip_xref_uphole_ytool_bypass_tubings_journal_by_pk: Maybe<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal>> }, Mutation_RootUpdate_Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_By_PkArgs>,
    update_revisions_sc_equip_xref_uphole_ytool_bypass_tubings_journal_many?: GraphCacheUpdateResolver<{ update_revisions_sc_equip_xref_uphole_ytool_bypass_tubings_journal_many: Maybe<Array<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_Mutation_Response>>> }, Mutation_RootUpdate_Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_ManyArgs>,
    update_revisions_sc_equip_xref_uphole_ytool_bypass_tubings_revisions?: GraphCacheUpdateResolver<{ update_revisions_sc_equip_xref_uphole_ytool_bypass_tubings_revisions: Maybe<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Mutation_Response>> }, Mutation_RootUpdate_Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_RevisionsArgs>,
    update_revisions_sc_equip_xref_uphole_ytool_bypass_tubings_revisions_by_pk?: GraphCacheUpdateResolver<{ update_revisions_sc_equip_xref_uphole_ytool_bypass_tubings_revisions_by_pk: Maybe<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions>> }, Mutation_RootUpdate_Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_By_PkArgs>,
    update_revisions_sc_equip_xref_uphole_ytool_bypass_tubings_revisions_many?: GraphCacheUpdateResolver<{ update_revisions_sc_equip_xref_uphole_ytool_bypass_tubings_revisions_many: Maybe<Array<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Mutation_Response>>> }, Mutation_RootUpdate_Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_ManyArgs>,
    update_revisions_sc_equip_xref_uphole_ytool_equip_tubings_journal?: GraphCacheUpdateResolver<{ update_revisions_sc_equip_xref_uphole_ytool_equip_tubings_journal: Maybe<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_Mutation_Response>> }, Mutation_RootUpdate_Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_JournalArgs>,
    update_revisions_sc_equip_xref_uphole_ytool_equip_tubings_journal_by_pk?: GraphCacheUpdateResolver<{ update_revisions_sc_equip_xref_uphole_ytool_equip_tubings_journal_by_pk: Maybe<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal>> }, Mutation_RootUpdate_Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_By_PkArgs>,
    update_revisions_sc_equip_xref_uphole_ytool_equip_tubings_journal_many?: GraphCacheUpdateResolver<{ update_revisions_sc_equip_xref_uphole_ytool_equip_tubings_journal_many: Maybe<Array<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_Mutation_Response>>> }, Mutation_RootUpdate_Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_ManyArgs>,
    update_revisions_sc_equip_xref_uphole_ytool_equip_tubings_revisions?: GraphCacheUpdateResolver<{ update_revisions_sc_equip_xref_uphole_ytool_equip_tubings_revisions: Maybe<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Mutation_Response>> }, Mutation_RootUpdate_Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_RevisionsArgs>,
    update_revisions_sc_equip_xref_uphole_ytool_equip_tubings_revisions_by_pk?: GraphCacheUpdateResolver<{ update_revisions_sc_equip_xref_uphole_ytool_equip_tubings_revisions_by_pk: Maybe<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions>> }, Mutation_RootUpdate_Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_By_PkArgs>,
    update_revisions_sc_equip_xref_uphole_ytool_equip_tubings_revisions_many?: GraphCacheUpdateResolver<{ update_revisions_sc_equip_xref_uphole_ytool_equip_tubings_revisions_many: Maybe<Array<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Mutation_Response>>> }, Mutation_RootUpdate_Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_ManyArgs>,
    update_revisions_scenario_correlations_journal?: GraphCacheUpdateResolver<{ update_revisions_scenario_correlations_journal: Maybe<WithTypename<Revisions_Scenario_Correlations_Journal_Mutation_Response>> }, Mutation_RootUpdate_Revisions_Scenario_Correlations_JournalArgs>,
    update_revisions_scenario_correlations_journal_by_pk?: GraphCacheUpdateResolver<{ update_revisions_scenario_correlations_journal_by_pk: Maybe<WithTypename<Revisions_Scenario_Correlations_Journal>> }, Mutation_RootUpdate_Revisions_Scenario_Correlations_Journal_By_PkArgs>,
    update_revisions_scenario_correlations_journal_many?: GraphCacheUpdateResolver<{ update_revisions_scenario_correlations_journal_many: Maybe<Array<WithTypename<Revisions_Scenario_Correlations_Journal_Mutation_Response>>> }, Mutation_RootUpdate_Revisions_Scenario_Correlations_Journal_ManyArgs>,
    update_revisions_scenario_correlations_revisions?: GraphCacheUpdateResolver<{ update_revisions_scenario_correlations_revisions: Maybe<WithTypename<Revisions_Scenario_Correlations_Revisions_Mutation_Response>> }, Mutation_RootUpdate_Revisions_Scenario_Correlations_RevisionsArgs>,
    update_revisions_scenario_correlations_revisions_by_pk?: GraphCacheUpdateResolver<{ update_revisions_scenario_correlations_revisions_by_pk: Maybe<WithTypename<Revisions_Scenario_Correlations_Revisions>> }, Mutation_RootUpdate_Revisions_Scenario_Correlations_Revisions_By_PkArgs>,
    update_revisions_scenario_correlations_revisions_many?: GraphCacheUpdateResolver<{ update_revisions_scenario_correlations_revisions_many: Maybe<Array<WithTypename<Revisions_Scenario_Correlations_Revisions_Mutation_Response>>> }, Mutation_RootUpdate_Revisions_Scenario_Correlations_Revisions_ManyArgs>,
    update_revisions_scenario_equipment_journal?: GraphCacheUpdateResolver<{ update_revisions_scenario_equipment_journal: Maybe<WithTypename<Revisions_Scenario_Equipment_Journal_Mutation_Response>> }, Mutation_RootUpdate_Revisions_Scenario_Equipment_JournalArgs>,
    update_revisions_scenario_equipment_journal_by_pk?: GraphCacheUpdateResolver<{ update_revisions_scenario_equipment_journal_by_pk: Maybe<WithTypename<Revisions_Scenario_Equipment_Journal>> }, Mutation_RootUpdate_Revisions_Scenario_Equipment_Journal_By_PkArgs>,
    update_revisions_scenario_equipment_journal_many?: GraphCacheUpdateResolver<{ update_revisions_scenario_equipment_journal_many: Maybe<Array<WithTypename<Revisions_Scenario_Equipment_Journal_Mutation_Response>>> }, Mutation_RootUpdate_Revisions_Scenario_Equipment_Journal_ManyArgs>,
    update_revisions_scenario_equipment_revisions?: GraphCacheUpdateResolver<{ update_revisions_scenario_equipment_revisions: Maybe<WithTypename<Revisions_Scenario_Equipment_Revisions_Mutation_Response>> }, Mutation_RootUpdate_Revisions_Scenario_Equipment_RevisionsArgs>,
    update_revisions_scenario_equipment_revisions_by_pk?: GraphCacheUpdateResolver<{ update_revisions_scenario_equipment_revisions_by_pk: Maybe<WithTypename<Revisions_Scenario_Equipment_Revisions>> }, Mutation_RootUpdate_Revisions_Scenario_Equipment_Revisions_By_PkArgs>,
    update_revisions_scenario_equipment_revisions_many?: GraphCacheUpdateResolver<{ update_revisions_scenario_equipment_revisions_many: Maybe<Array<WithTypename<Revisions_Scenario_Equipment_Revisions_Mutation_Response>>> }, Mutation_RootUpdate_Revisions_Scenario_Equipment_Revisions_ManyArgs>,
    update_revisions_scenario_equipment_xref_cables_journal?: GraphCacheUpdateResolver<{ update_revisions_scenario_equipment_xref_cables_journal: Maybe<WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Journal_Mutation_Response>> }, Mutation_RootUpdate_Revisions_Scenario_Equipment_Xref_Cables_JournalArgs>,
    update_revisions_scenario_equipment_xref_cables_journal_by_pk?: GraphCacheUpdateResolver<{ update_revisions_scenario_equipment_xref_cables_journal_by_pk: Maybe<WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Journal>> }, Mutation_RootUpdate_Revisions_Scenario_Equipment_Xref_Cables_Journal_By_PkArgs>,
    update_revisions_scenario_equipment_xref_cables_journal_many?: GraphCacheUpdateResolver<{ update_revisions_scenario_equipment_xref_cables_journal_many: Maybe<Array<WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Journal_Mutation_Response>>> }, Mutation_RootUpdate_Revisions_Scenario_Equipment_Xref_Cables_Journal_ManyArgs>,
    update_revisions_scenario_equipment_xref_cables_revisions?: GraphCacheUpdateResolver<{ update_revisions_scenario_equipment_xref_cables_revisions: Maybe<WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Mutation_Response>> }, Mutation_RootUpdate_Revisions_Scenario_Equipment_Xref_Cables_RevisionsArgs>,
    update_revisions_scenario_equipment_xref_cables_revisions_by_pk?: GraphCacheUpdateResolver<{ update_revisions_scenario_equipment_xref_cables_revisions_by_pk: Maybe<WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Revisions>> }, Mutation_RootUpdate_Revisions_Scenario_Equipment_Xref_Cables_Revisions_By_PkArgs>,
    update_revisions_scenario_equipment_xref_cables_revisions_many?: GraphCacheUpdateResolver<{ update_revisions_scenario_equipment_xref_cables_revisions_many: Maybe<Array<WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Mutation_Response>>> }, Mutation_RootUpdate_Revisions_Scenario_Equipment_Xref_Cables_Revisions_ManyArgs>,
    update_revisions_scenario_equipment_xref_housings_journal?: GraphCacheUpdateResolver<{ update_revisions_scenario_equipment_xref_housings_journal: Maybe<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Journal_Mutation_Response>> }, Mutation_RootUpdate_Revisions_Scenario_Equipment_Xref_Housings_JournalArgs>,
    update_revisions_scenario_equipment_xref_housings_journal_by_pk?: GraphCacheUpdateResolver<{ update_revisions_scenario_equipment_xref_housings_journal_by_pk: Maybe<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Journal>> }, Mutation_RootUpdate_Revisions_Scenario_Equipment_Xref_Housings_Journal_By_PkArgs>,
    update_revisions_scenario_equipment_xref_housings_journal_many?: GraphCacheUpdateResolver<{ update_revisions_scenario_equipment_xref_housings_journal_many: Maybe<Array<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Journal_Mutation_Response>>> }, Mutation_RootUpdate_Revisions_Scenario_Equipment_Xref_Housings_Journal_ManyArgs>,
    update_revisions_scenario_equipment_xref_housings_revisions?: GraphCacheUpdateResolver<{ update_revisions_scenario_equipment_xref_housings_revisions: Maybe<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Mutation_Response>> }, Mutation_RootUpdate_Revisions_Scenario_Equipment_Xref_Housings_RevisionsArgs>,
    update_revisions_scenario_equipment_xref_housings_revisions_by_pk?: GraphCacheUpdateResolver<{ update_revisions_scenario_equipment_xref_housings_revisions_by_pk: Maybe<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Revisions>> }, Mutation_RootUpdate_Revisions_Scenario_Equipment_Xref_Housings_Revisions_By_PkArgs>,
    update_revisions_scenario_equipment_xref_housings_revisions_many?: GraphCacheUpdateResolver<{ update_revisions_scenario_equipment_xref_housings_revisions_many: Maybe<Array<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Mutation_Response>>> }, Mutation_RootUpdate_Revisions_Scenario_Equipment_Xref_Housings_Revisions_ManyArgs>,
    update_revisions_scenario_equipment_xref_intakes_journal?: GraphCacheUpdateResolver<{ update_revisions_scenario_equipment_xref_intakes_journal: Maybe<WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Journal_Mutation_Response>> }, Mutation_RootUpdate_Revisions_Scenario_Equipment_Xref_Intakes_JournalArgs>,
    update_revisions_scenario_equipment_xref_intakes_journal_by_pk?: GraphCacheUpdateResolver<{ update_revisions_scenario_equipment_xref_intakes_journal_by_pk: Maybe<WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Journal>> }, Mutation_RootUpdate_Revisions_Scenario_Equipment_Xref_Intakes_Journal_By_PkArgs>,
    update_revisions_scenario_equipment_xref_intakes_journal_many?: GraphCacheUpdateResolver<{ update_revisions_scenario_equipment_xref_intakes_journal_many: Maybe<Array<WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Journal_Mutation_Response>>> }, Mutation_RootUpdate_Revisions_Scenario_Equipment_Xref_Intakes_Journal_ManyArgs>,
    update_revisions_scenario_equipment_xref_intakes_revisions?: GraphCacheUpdateResolver<{ update_revisions_scenario_equipment_xref_intakes_revisions: Maybe<WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Mutation_Response>> }, Mutation_RootUpdate_Revisions_Scenario_Equipment_Xref_Intakes_RevisionsArgs>,
    update_revisions_scenario_equipment_xref_intakes_revisions_by_pk?: GraphCacheUpdateResolver<{ update_revisions_scenario_equipment_xref_intakes_revisions_by_pk: Maybe<WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Revisions>> }, Mutation_RootUpdate_Revisions_Scenario_Equipment_Xref_Intakes_Revisions_By_PkArgs>,
    update_revisions_scenario_equipment_xref_intakes_revisions_many?: GraphCacheUpdateResolver<{ update_revisions_scenario_equipment_xref_intakes_revisions_many: Maybe<Array<WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Mutation_Response>>> }, Mutation_RootUpdate_Revisions_Scenario_Equipment_Xref_Intakes_Revisions_ManyArgs>,
    update_revisions_scenario_equipment_xref_pumps_journal?: GraphCacheUpdateResolver<{ update_revisions_scenario_equipment_xref_pumps_journal: Maybe<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Journal_Mutation_Response>> }, Mutation_RootUpdate_Revisions_Scenario_Equipment_Xref_Pumps_JournalArgs>,
    update_revisions_scenario_equipment_xref_pumps_journal_by_pk?: GraphCacheUpdateResolver<{ update_revisions_scenario_equipment_xref_pumps_journal_by_pk: Maybe<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Journal>> }, Mutation_RootUpdate_Revisions_Scenario_Equipment_Xref_Pumps_Journal_By_PkArgs>,
    update_revisions_scenario_equipment_xref_pumps_journal_many?: GraphCacheUpdateResolver<{ update_revisions_scenario_equipment_xref_pumps_journal_many: Maybe<Array<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Journal_Mutation_Response>>> }, Mutation_RootUpdate_Revisions_Scenario_Equipment_Xref_Pumps_Journal_ManyArgs>,
    update_revisions_scenario_equipment_xref_pumps_revisions?: GraphCacheUpdateResolver<{ update_revisions_scenario_equipment_xref_pumps_revisions: Maybe<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Mutation_Response>> }, Mutation_RootUpdate_Revisions_Scenario_Equipment_Xref_Pumps_RevisionsArgs>,
    update_revisions_scenario_equipment_xref_pumps_revisions_by_pk?: GraphCacheUpdateResolver<{ update_revisions_scenario_equipment_xref_pumps_revisions_by_pk: Maybe<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions>> }, Mutation_RootUpdate_Revisions_Scenario_Equipment_Xref_Pumps_Revisions_By_PkArgs>,
    update_revisions_scenario_equipment_xref_pumps_revisions_many?: GraphCacheUpdateResolver<{ update_revisions_scenario_equipment_xref_pumps_revisions_many: Maybe<Array<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Mutation_Response>>> }, Mutation_RootUpdate_Revisions_Scenario_Equipment_Xref_Pumps_Revisions_ManyArgs>,
    update_revisions_scenario_equipment_xref_seals_journal?: GraphCacheUpdateResolver<{ update_revisions_scenario_equipment_xref_seals_journal: Maybe<WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Journal_Mutation_Response>> }, Mutation_RootUpdate_Revisions_Scenario_Equipment_Xref_Seals_JournalArgs>,
    update_revisions_scenario_equipment_xref_seals_journal_by_pk?: GraphCacheUpdateResolver<{ update_revisions_scenario_equipment_xref_seals_journal_by_pk: Maybe<WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Journal>> }, Mutation_RootUpdate_Revisions_Scenario_Equipment_Xref_Seals_Journal_By_PkArgs>,
    update_revisions_scenario_equipment_xref_seals_journal_many?: GraphCacheUpdateResolver<{ update_revisions_scenario_equipment_xref_seals_journal_many: Maybe<Array<WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Journal_Mutation_Response>>> }, Mutation_RootUpdate_Revisions_Scenario_Equipment_Xref_Seals_Journal_ManyArgs>,
    update_revisions_scenario_equipment_xref_seals_revisions?: GraphCacheUpdateResolver<{ update_revisions_scenario_equipment_xref_seals_revisions: Maybe<WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Revisions_Mutation_Response>> }, Mutation_RootUpdate_Revisions_Scenario_Equipment_Xref_Seals_RevisionsArgs>,
    update_revisions_scenario_equipment_xref_seals_revisions_by_pk?: GraphCacheUpdateResolver<{ update_revisions_scenario_equipment_xref_seals_revisions_by_pk: Maybe<WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Revisions>> }, Mutation_RootUpdate_Revisions_Scenario_Equipment_Xref_Seals_Revisions_By_PkArgs>,
    update_revisions_scenario_equipment_xref_seals_revisions_many?: GraphCacheUpdateResolver<{ update_revisions_scenario_equipment_xref_seals_revisions_many: Maybe<Array<WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Revisions_Mutation_Response>>> }, Mutation_RootUpdate_Revisions_Scenario_Equipment_Xref_Seals_Revisions_ManyArgs>,
    update_revisions_scenario_parameters_journal?: GraphCacheUpdateResolver<{ update_revisions_scenario_parameters_journal: Maybe<WithTypename<Revisions_Scenario_Parameters_Journal_Mutation_Response>> }, Mutation_RootUpdate_Revisions_Scenario_Parameters_JournalArgs>,
    update_revisions_scenario_parameters_journal_by_pk?: GraphCacheUpdateResolver<{ update_revisions_scenario_parameters_journal_by_pk: Maybe<WithTypename<Revisions_Scenario_Parameters_Journal>> }, Mutation_RootUpdate_Revisions_Scenario_Parameters_Journal_By_PkArgs>,
    update_revisions_scenario_parameters_journal_many?: GraphCacheUpdateResolver<{ update_revisions_scenario_parameters_journal_many: Maybe<Array<WithTypename<Revisions_Scenario_Parameters_Journal_Mutation_Response>>> }, Mutation_RootUpdate_Revisions_Scenario_Parameters_Journal_ManyArgs>,
    update_revisions_scenario_parameters_revisions?: GraphCacheUpdateResolver<{ update_revisions_scenario_parameters_revisions: Maybe<WithTypename<Revisions_Scenario_Parameters_Revisions_Mutation_Response>> }, Mutation_RootUpdate_Revisions_Scenario_Parameters_RevisionsArgs>,
    update_revisions_scenario_parameters_revisions_by_pk?: GraphCacheUpdateResolver<{ update_revisions_scenario_parameters_revisions_by_pk: Maybe<WithTypename<Revisions_Scenario_Parameters_Revisions>> }, Mutation_RootUpdate_Revisions_Scenario_Parameters_Revisions_By_PkArgs>,
    update_revisions_scenario_parameters_revisions_many?: GraphCacheUpdateResolver<{ update_revisions_scenario_parameters_revisions_many: Maybe<Array<WithTypename<Revisions_Scenario_Parameters_Revisions_Mutation_Response>>> }, Mutation_RootUpdate_Revisions_Scenario_Parameters_Revisions_ManyArgs>,
    update_revisions_scenario_well_properties_journal?: GraphCacheUpdateResolver<{ update_revisions_scenario_well_properties_journal: Maybe<WithTypename<Revisions_Scenario_Well_Properties_Journal_Mutation_Response>> }, Mutation_RootUpdate_Revisions_Scenario_Well_Properties_JournalArgs>,
    update_revisions_scenario_well_properties_journal_by_pk?: GraphCacheUpdateResolver<{ update_revisions_scenario_well_properties_journal_by_pk: Maybe<WithTypename<Revisions_Scenario_Well_Properties_Journal>> }, Mutation_RootUpdate_Revisions_Scenario_Well_Properties_Journal_By_PkArgs>,
    update_revisions_scenario_well_properties_journal_many?: GraphCacheUpdateResolver<{ update_revisions_scenario_well_properties_journal_many: Maybe<Array<WithTypename<Revisions_Scenario_Well_Properties_Journal_Mutation_Response>>> }, Mutation_RootUpdate_Revisions_Scenario_Well_Properties_Journal_ManyArgs>,
    update_revisions_scenario_well_properties_revisions?: GraphCacheUpdateResolver<{ update_revisions_scenario_well_properties_revisions: Maybe<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Mutation_Response>> }, Mutation_RootUpdate_Revisions_Scenario_Well_Properties_RevisionsArgs>,
    update_revisions_scenario_well_properties_revisions_by_pk?: GraphCacheUpdateResolver<{ update_revisions_scenario_well_properties_revisions_by_pk: Maybe<WithTypename<Revisions_Scenario_Well_Properties_Revisions>> }, Mutation_RootUpdate_Revisions_Scenario_Well_Properties_Revisions_By_PkArgs>,
    update_revisions_scenario_well_properties_revisions_many?: GraphCacheUpdateResolver<{ update_revisions_scenario_well_properties_revisions_many: Maybe<Array<WithTypename<Revisions_Scenario_Well_Properties_Revisions_Mutation_Response>>> }, Mutation_RootUpdate_Revisions_Scenario_Well_Properties_Revisions_ManyArgs>,
    update_revisions_scenarios_journal?: GraphCacheUpdateResolver<{ update_revisions_scenarios_journal: Maybe<WithTypename<Revisions_Scenarios_Journal_Mutation_Response>> }, Mutation_RootUpdate_Revisions_Scenarios_JournalArgs>,
    update_revisions_scenarios_journal_by_pk?: GraphCacheUpdateResolver<{ update_revisions_scenarios_journal_by_pk: Maybe<WithTypename<Revisions_Scenarios_Journal>> }, Mutation_RootUpdate_Revisions_Scenarios_Journal_By_PkArgs>,
    update_revisions_scenarios_journal_many?: GraphCacheUpdateResolver<{ update_revisions_scenarios_journal_many: Maybe<Array<WithTypename<Revisions_Scenarios_Journal_Mutation_Response>>> }, Mutation_RootUpdate_Revisions_Scenarios_Journal_ManyArgs>,
    update_revisions_scenarios_revisions?: GraphCacheUpdateResolver<{ update_revisions_scenarios_revisions: Maybe<WithTypename<Revisions_Scenarios_Revisions_Mutation_Response>> }, Mutation_RootUpdate_Revisions_Scenarios_RevisionsArgs>,
    update_revisions_scenarios_revisions_by_pk?: GraphCacheUpdateResolver<{ update_revisions_scenarios_revisions_by_pk: Maybe<WithTypename<Revisions_Scenarios_Revisions>> }, Mutation_RootUpdate_Revisions_Scenarios_Revisions_By_PkArgs>,
    update_revisions_scenarios_revisions_many?: GraphCacheUpdateResolver<{ update_revisions_scenarios_revisions_many: Maybe<Array<WithTypename<Revisions_Scenarios_Revisions_Mutation_Response>>> }, Mutation_RootUpdate_Revisions_Scenarios_Revisions_ManyArgs>,
    update_revisions_sizings_journal?: GraphCacheUpdateResolver<{ update_revisions_sizings_journal: Maybe<WithTypename<Revisions_Sizings_Journal_Mutation_Response>> }, Mutation_RootUpdate_Revisions_Sizings_JournalArgs>,
    update_revisions_sizings_journal_by_pk?: GraphCacheUpdateResolver<{ update_revisions_sizings_journal_by_pk: Maybe<WithTypename<Revisions_Sizings_Journal>> }, Mutation_RootUpdate_Revisions_Sizings_Journal_By_PkArgs>,
    update_revisions_sizings_journal_many?: GraphCacheUpdateResolver<{ update_revisions_sizings_journal_many: Maybe<Array<WithTypename<Revisions_Sizings_Journal_Mutation_Response>>> }, Mutation_RootUpdate_Revisions_Sizings_Journal_ManyArgs>,
    update_revisions_sizings_revisions?: GraphCacheUpdateResolver<{ update_revisions_sizings_revisions: Maybe<WithTypename<Revisions_Sizings_Revisions_Mutation_Response>> }, Mutation_RootUpdate_Revisions_Sizings_RevisionsArgs>,
    update_revisions_sizings_revisions_by_pk?: GraphCacheUpdateResolver<{ update_revisions_sizings_revisions_by_pk: Maybe<WithTypename<Revisions_Sizings_Revisions>> }, Mutation_RootUpdate_Revisions_Sizings_Revisions_By_PkArgs>,
    update_revisions_sizings_revisions_many?: GraphCacheUpdateResolver<{ update_revisions_sizings_revisions_many: Maybe<Array<WithTypename<Revisions_Sizings_Revisions_Mutation_Response>>> }, Mutation_RootUpdate_Revisions_Sizings_Revisions_ManyArgs>,
    update_saturated_oil_options?: GraphCacheUpdateResolver<{ update_saturated_oil_options: Maybe<WithTypename<Saturated_Oil_Options_Mutation_Response>> }, Mutation_RootUpdate_Saturated_Oil_OptionsArgs>,
    update_saturated_oil_options_by_pk?: GraphCacheUpdateResolver<{ update_saturated_oil_options_by_pk: Maybe<WithTypename<Saturated_Oil_Options>> }, Mutation_RootUpdate_Saturated_Oil_Options_By_PkArgs>,
    update_saturated_oil_options_many?: GraphCacheUpdateResolver<{ update_saturated_oil_options_many: Maybe<Array<WithTypename<Saturated_Oil_Options_Mutation_Response>>> }, Mutation_RootUpdate_Saturated_Oil_Options_ManyArgs>,
    update_scenario_reasons?: GraphCacheUpdateResolver<{ update_scenario_reasons: Maybe<WithTypename<Scenario_Reasons_Mutation_Response>> }, Mutation_RootUpdate_Scenario_ReasonsArgs>,
    update_scenario_reasons_by_pk?: GraphCacheUpdateResolver<{ update_scenario_reasons_by_pk: Maybe<WithTypename<Scenario_Reasons>> }, Mutation_RootUpdate_Scenario_Reasons_By_PkArgs>,
    update_scenario_reasons_many?: GraphCacheUpdateResolver<{ update_scenario_reasons_many: Maybe<Array<WithTypename<Scenario_Reasons_Mutation_Response>>> }, Mutation_RootUpdate_Scenario_Reasons_ManyArgs>,
    update_seal_motor_oil?: GraphCacheUpdateResolver<{ update_seal_motor_oil: Maybe<WithTypename<Seal_Motor_Oil_Mutation_Response>> }, Mutation_RootUpdate_Seal_Motor_OilArgs>,
    update_seal_motor_oil_by_pk?: GraphCacheUpdateResolver<{ update_seal_motor_oil_by_pk: Maybe<WithTypename<Seal_Motor_Oil>> }, Mutation_RootUpdate_Seal_Motor_Oil_By_PkArgs>,
    update_seal_motor_oil_many?: GraphCacheUpdateResolver<{ update_seal_motor_oil_many: Maybe<Array<WithTypename<Seal_Motor_Oil_Mutation_Response>>> }, Mutation_RootUpdate_Seal_Motor_Oil_ManyArgs>,
    update_seals?: GraphCacheUpdateResolver<{ update_seals: Maybe<WithTypename<Seals_Mutation_Response>> }, Mutation_RootUpdate_SealsArgs>,
    update_seals_by_pk?: GraphCacheUpdateResolver<{ update_seals_by_pk: Maybe<WithTypename<Seals>> }, Mutation_RootUpdate_Seals_By_PkArgs>,
    update_seals_many?: GraphCacheUpdateResolver<{ update_seals_many: Maybe<Array<WithTypename<Seals_Mutation_Response>>> }, Mutation_RootUpdate_Seals_ManyArgs>,
    update_sensors?: GraphCacheUpdateResolver<{ update_sensors: Maybe<WithTypename<Sensors_Mutation_Response>> }, Mutation_RootUpdate_SensorsArgs>,
    update_sensors_by_pk?: GraphCacheUpdateResolver<{ update_sensors_by_pk: Maybe<WithTypename<Sensors>> }, Mutation_RootUpdate_Sensors_By_PkArgs>,
    update_sensors_many?: GraphCacheUpdateResolver<{ update_sensors_many: Maybe<Array<WithTypename<Sensors_Mutation_Response>>> }, Mutation_RootUpdate_Sensors_ManyArgs>,
    update_sizing_dispositions?: GraphCacheUpdateResolver<{ update_sizing_dispositions: Maybe<WithTypename<Sizing_Dispositions_Mutation_Response>> }, Mutation_RootUpdate_Sizing_DispositionsArgs>,
    update_sizing_dispositions_by_pk?: GraphCacheUpdateResolver<{ update_sizing_dispositions_by_pk: Maybe<WithTypename<Sizing_Dispositions>> }, Mutation_RootUpdate_Sizing_Dispositions_By_PkArgs>,
    update_sizing_dispositions_many?: GraphCacheUpdateResolver<{ update_sizing_dispositions_many: Maybe<Array<WithTypename<Sizing_Dispositions_Mutation_Response>>> }, Mutation_RootUpdate_Sizing_Dispositions_ManyArgs>,
    update_sizing_imports?: GraphCacheUpdateResolver<{ update_sizing_imports: Maybe<WithTypename<Sizing_Imports_Mutation_Response>> }, Mutation_RootUpdate_Sizing_ImportsArgs>,
    update_sizing_imports_by_pk?: GraphCacheUpdateResolver<{ update_sizing_imports_by_pk: Maybe<WithTypename<Sizing_Imports>> }, Mutation_RootUpdate_Sizing_Imports_By_PkArgs>,
    update_sizing_imports_many?: GraphCacheUpdateResolver<{ update_sizing_imports_many: Maybe<Array<WithTypename<Sizing_Imports_Mutation_Response>>> }, Mutation_RootUpdate_Sizing_Imports_ManyArgs>,
    update_sizing_pumping_type?: GraphCacheUpdateResolver<{ update_sizing_pumping_type: Maybe<WithTypename<Sizing_Pumping_Type_Mutation_Response>> }, Mutation_RootUpdate_Sizing_Pumping_TypeArgs>,
    update_sizing_pumping_type_by_pk?: GraphCacheUpdateResolver<{ update_sizing_pumping_type_by_pk: Maybe<WithTypename<Sizing_Pumping_Type>> }, Mutation_RootUpdate_Sizing_Pumping_Type_By_PkArgs>,
    update_sizing_pumping_type_many?: GraphCacheUpdateResolver<{ update_sizing_pumping_type_many: Maybe<Array<WithTypename<Sizing_Pumping_Type_Mutation_Response>>> }, Mutation_RootUpdate_Sizing_Pumping_Type_ManyArgs>,
    update_solution_gas_oil_ratio_options?: GraphCacheUpdateResolver<{ update_solution_gas_oil_ratio_options: Maybe<WithTypename<Solution_Gas_Oil_Ratio_Options_Mutation_Response>> }, Mutation_RootUpdate_Solution_Gas_Oil_Ratio_OptionsArgs>,
    update_solution_gas_oil_ratio_options_by_pk?: GraphCacheUpdateResolver<{ update_solution_gas_oil_ratio_options_by_pk: Maybe<WithTypename<Solution_Gas_Oil_Ratio_Options>> }, Mutation_RootUpdate_Solution_Gas_Oil_Ratio_Options_By_PkArgs>,
    update_solution_gas_oil_ratio_options_many?: GraphCacheUpdateResolver<{ update_solution_gas_oil_ratio_options_many: Maybe<Array<WithTypename<Solution_Gas_Oil_Ratio_Options_Mutation_Response>>> }, Mutation_RootUpdate_Solution_Gas_Oil_Ratio_Options_ManyArgs>,
    update_step_down_transformers?: GraphCacheUpdateResolver<{ update_step_down_transformers: Maybe<WithTypename<Step_Down_Transformers_Mutation_Response>> }, Mutation_RootUpdate_Step_Down_TransformersArgs>,
    update_step_down_transformers_by_pk?: GraphCacheUpdateResolver<{ update_step_down_transformers_by_pk: Maybe<WithTypename<Step_Down_Transformers>> }, Mutation_RootUpdate_Step_Down_Transformers_By_PkArgs>,
    update_step_down_transformers_many?: GraphCacheUpdateResolver<{ update_step_down_transformers_many: Maybe<Array<WithTypename<Step_Down_Transformers_Mutation_Response>>> }, Mutation_RootUpdate_Step_Down_Transformers_ManyArgs>,
    update_step_up_transformers?: GraphCacheUpdateResolver<{ update_step_up_transformers: Maybe<WithTypename<Step_Up_Transformers_Mutation_Response>> }, Mutation_RootUpdate_Step_Up_TransformersArgs>,
    update_step_up_transformers_by_pk?: GraphCacheUpdateResolver<{ update_step_up_transformers_by_pk: Maybe<WithTypename<Step_Up_Transformers>> }, Mutation_RootUpdate_Step_Up_Transformers_By_PkArgs>,
    update_step_up_transformers_many?: GraphCacheUpdateResolver<{ update_step_up_transformers_many: Maybe<Array<WithTypename<Step_Up_Transformers_Mutation_Response>>> }, Mutation_RootUpdate_Step_Up_Transformers_ManyArgs>,
    update_switchboards?: GraphCacheUpdateResolver<{ update_switchboards: Maybe<WithTypename<Switchboards_Mutation_Response>> }, Mutation_RootUpdate_SwitchboardsArgs>,
    update_switchboards_by_pk?: GraphCacheUpdateResolver<{ update_switchboards_by_pk: Maybe<WithTypename<Switchboards>> }, Mutation_RootUpdate_Switchboards_By_PkArgs>,
    update_switchboards_many?: GraphCacheUpdateResolver<{ update_switchboards_many: Maybe<Array<WithTypename<Switchboards_Mutation_Response>>> }, Mutation_RootUpdate_Switchboards_ManyArgs>,
    update_tubing_flow_options?: GraphCacheUpdateResolver<{ update_tubing_flow_options: Maybe<WithTypename<Tubing_Flow_Options_Mutation_Response>> }, Mutation_RootUpdate_Tubing_Flow_OptionsArgs>,
    update_tubing_flow_options_by_pk?: GraphCacheUpdateResolver<{ update_tubing_flow_options_by_pk: Maybe<WithTypename<Tubing_Flow_Options>> }, Mutation_RootUpdate_Tubing_Flow_Options_By_PkArgs>,
    update_tubing_flow_options_many?: GraphCacheUpdateResolver<{ update_tubing_flow_options_many: Maybe<Array<WithTypename<Tubing_Flow_Options_Mutation_Response>>> }, Mutation_RootUpdate_Tubing_Flow_Options_ManyArgs>,
    update_tubings?: GraphCacheUpdateResolver<{ update_tubings: Maybe<WithTypename<Tubings_Mutation_Response>> }, Mutation_RootUpdate_TubingsArgs>,
    update_tubings_by_pk?: GraphCacheUpdateResolver<{ update_tubings_by_pk: Maybe<WithTypename<Tubings>> }, Mutation_RootUpdate_Tubings_By_PkArgs>,
    update_tubings_many?: GraphCacheUpdateResolver<{ update_tubings_many: Maybe<Array<WithTypename<Tubings_Mutation_Response>>> }, Mutation_RootUpdate_Tubings_ManyArgs>,
    update_tubings_type?: GraphCacheUpdateResolver<{ update_tubings_type: Maybe<WithTypename<Tubings_Type_Mutation_Response>> }, Mutation_RootUpdate_Tubings_TypeArgs>,
    update_tubings_type_by_pk?: GraphCacheUpdateResolver<{ update_tubings_type_by_pk: Maybe<WithTypename<Tubings_Type>> }, Mutation_RootUpdate_Tubings_Type_By_PkArgs>,
    update_tubings_type_many?: GraphCacheUpdateResolver<{ update_tubings_type_many: Maybe<Array<WithTypename<Tubings_Type_Mutation_Response>>> }, Mutation_RootUpdate_Tubings_Type_ManyArgs>,
    update_under_saturated_oil_options?: GraphCacheUpdateResolver<{ update_under_saturated_oil_options: Maybe<WithTypename<Under_Saturated_Oil_Options_Mutation_Response>> }, Mutation_RootUpdate_Under_Saturated_Oil_OptionsArgs>,
    update_under_saturated_oil_options_by_pk?: GraphCacheUpdateResolver<{ update_under_saturated_oil_options_by_pk: Maybe<WithTypename<Under_Saturated_Oil_Options>> }, Mutation_RootUpdate_Under_Saturated_Oil_Options_By_PkArgs>,
    update_under_saturated_oil_options_many?: GraphCacheUpdateResolver<{ update_under_saturated_oil_options_many: Maybe<Array<WithTypename<Under_Saturated_Oil_Options_Mutation_Response>>> }, Mutation_RootUpdate_Under_Saturated_Oil_Options_ManyArgs>,
    update_user_eula_acceptance?: GraphCacheUpdateResolver<{ update_user_eula_acceptance: Maybe<WithTypename<User_Eula_Acceptance_Mutation_Response>> }, Mutation_RootUpdate_User_Eula_AcceptanceArgs>,
    update_user_eula_acceptance_by_pk?: GraphCacheUpdateResolver<{ update_user_eula_acceptance_by_pk: Maybe<WithTypename<User_Eula_Acceptance>> }, Mutation_RootUpdate_User_Eula_Acceptance_By_PkArgs>,
    update_user_eula_acceptance_many?: GraphCacheUpdateResolver<{ update_user_eula_acceptance_many: Maybe<Array<WithTypename<User_Eula_Acceptance_Mutation_Response>>> }, Mutation_RootUpdate_User_Eula_Acceptance_ManyArgs>,
    update_users?: GraphCacheUpdateResolver<{ update_users: Maybe<WithTypename<Users_Mutation_Response>> }, Mutation_RootUpdate_UsersArgs>,
    update_users_by_pk?: GraphCacheUpdateResolver<{ update_users_by_pk: Maybe<WithTypename<Users>> }, Mutation_RootUpdate_Users_By_PkArgs>,
    update_users_many?: GraphCacheUpdateResolver<{ update_users_many: Maybe<Array<WithTypename<Users_Mutation_Response>>> }, Mutation_RootUpdate_Users_ManyArgs>,
    update_variable_speed_drives?: GraphCacheUpdateResolver<{ update_variable_speed_drives: Maybe<WithTypename<Variable_Speed_Drives_Mutation_Response>> }, Mutation_RootUpdate_Variable_Speed_DrivesArgs>,
    update_variable_speed_drives_by_pk?: GraphCacheUpdateResolver<{ update_variable_speed_drives_by_pk: Maybe<WithTypename<Variable_Speed_Drives>> }, Mutation_RootUpdate_Variable_Speed_Drives_By_PkArgs>,
    update_variable_speed_drives_many?: GraphCacheUpdateResolver<{ update_variable_speed_drives_many: Maybe<Array<WithTypename<Variable_Speed_Drives_Mutation_Response>>> }, Mutation_RootUpdate_Variable_Speed_Drives_ManyArgs>,
    update_water_density_options?: GraphCacheUpdateResolver<{ update_water_density_options: Maybe<WithTypename<Water_Density_Options_Mutation_Response>> }, Mutation_RootUpdate_Water_Density_OptionsArgs>,
    update_water_density_options_by_pk?: GraphCacheUpdateResolver<{ update_water_density_options_by_pk: Maybe<WithTypename<Water_Density_Options>> }, Mutation_RootUpdate_Water_Density_Options_By_PkArgs>,
    update_water_density_options_many?: GraphCacheUpdateResolver<{ update_water_density_options_many: Maybe<Array<WithTypename<Water_Density_Options_Mutation_Response>>> }, Mutation_RootUpdate_Water_Density_Options_ManyArgs>,
    update_water_solution_gas_options?: GraphCacheUpdateResolver<{ update_water_solution_gas_options: Maybe<WithTypename<Water_Solution_Gas_Options_Mutation_Response>> }, Mutation_RootUpdate_Water_Solution_Gas_OptionsArgs>,
    update_water_solution_gas_options_by_pk?: GraphCacheUpdateResolver<{ update_water_solution_gas_options_by_pk: Maybe<WithTypename<Water_Solution_Gas_Options>> }, Mutation_RootUpdate_Water_Solution_Gas_Options_By_PkArgs>,
    update_water_solution_gas_options_many?: GraphCacheUpdateResolver<{ update_water_solution_gas_options_many: Maybe<Array<WithTypename<Water_Solution_Gas_Options_Mutation_Response>>> }, Mutation_RootUpdate_Water_Solution_Gas_Options_ManyArgs>,
    update_water_viscosity_options?: GraphCacheUpdateResolver<{ update_water_viscosity_options: Maybe<WithTypename<Water_Viscosity_Options_Mutation_Response>> }, Mutation_RootUpdate_Water_Viscosity_OptionsArgs>,
    update_water_viscosity_options_by_pk?: GraphCacheUpdateResolver<{ update_water_viscosity_options_by_pk: Maybe<WithTypename<Water_Viscosity_Options>> }, Mutation_RootUpdate_Water_Viscosity_Options_By_PkArgs>,
    update_water_viscosity_options_many?: GraphCacheUpdateResolver<{ update_water_viscosity_options_many: Maybe<Array<WithTypename<Water_Viscosity_Options_Mutation_Response>>> }, Mutation_RootUpdate_Water_Viscosity_Options_ManyArgs>,
    update_water_volume_factor_options?: GraphCacheUpdateResolver<{ update_water_volume_factor_options: Maybe<WithTypename<Water_Volume_Factor_Options_Mutation_Response>> }, Mutation_RootUpdate_Water_Volume_Factor_OptionsArgs>,
    update_water_volume_factor_options_by_pk?: GraphCacheUpdateResolver<{ update_water_volume_factor_options_by_pk: Maybe<WithTypename<Water_Volume_Factor_Options>> }, Mutation_RootUpdate_Water_Volume_Factor_Options_By_PkArgs>,
    update_water_volume_factor_options_many?: GraphCacheUpdateResolver<{ update_water_volume_factor_options_many: Maybe<Array<WithTypename<Water_Volume_Factor_Options_Mutation_Response>>> }, Mutation_RootUpdate_Water_Volume_Factor_Options_ManyArgs>,
    update_well_gas_type_options?: GraphCacheUpdateResolver<{ update_well_gas_type_options: Maybe<WithTypename<Well_Gas_Type_Options_Mutation_Response>> }, Mutation_RootUpdate_Well_Gas_Type_OptionsArgs>,
    update_well_gas_type_options_by_pk?: GraphCacheUpdateResolver<{ update_well_gas_type_options_by_pk: Maybe<WithTypename<Well_Gas_Type_Options>> }, Mutation_RootUpdate_Well_Gas_Type_Options_By_PkArgs>,
    update_well_gas_type_options_many?: GraphCacheUpdateResolver<{ update_well_gas_type_options_many: Maybe<Array<WithTypename<Well_Gas_Type_Options_Mutation_Response>>> }, Mutation_RootUpdate_Well_Gas_Type_Options_ManyArgs>,
    update_well_test_gas_input_options?: GraphCacheUpdateResolver<{ update_well_test_gas_input_options: Maybe<WithTypename<Well_Test_Gas_Input_Options_Mutation_Response>> }, Mutation_RootUpdate_Well_Test_Gas_Input_OptionsArgs>,
    update_well_test_gas_input_options_by_pk?: GraphCacheUpdateResolver<{ update_well_test_gas_input_options_by_pk: Maybe<WithTypename<Well_Test_Gas_Input_Options>> }, Mutation_RootUpdate_Well_Test_Gas_Input_Options_By_PkArgs>,
    update_well_test_gas_input_options_many?: GraphCacheUpdateResolver<{ update_well_test_gas_input_options_many: Maybe<Array<WithTypename<Well_Test_Gas_Input_Options_Mutation_Response>>> }, Mutation_RootUpdate_Well_Test_Gas_Input_Options_ManyArgs>,
    update_well_test_liquid_input_options?: GraphCacheUpdateResolver<{ update_well_test_liquid_input_options: Maybe<WithTypename<Well_Test_Liquid_Input_Options_Mutation_Response>> }, Mutation_RootUpdate_Well_Test_Liquid_Input_OptionsArgs>,
    update_well_test_liquid_input_options_by_pk?: GraphCacheUpdateResolver<{ update_well_test_liquid_input_options_by_pk: Maybe<WithTypename<Well_Test_Liquid_Input_Options>> }, Mutation_RootUpdate_Well_Test_Liquid_Input_Options_By_PkArgs>,
    update_well_test_liquid_input_options_many?: GraphCacheUpdateResolver<{ update_well_test_liquid_input_options_many: Maybe<Array<WithTypename<Well_Test_Liquid_Input_Options_Mutation_Response>>> }, Mutation_RootUpdate_Well_Test_Liquid_Input_Options_ManyArgs>,
    update_well_test_pressure_input_options?: GraphCacheUpdateResolver<{ update_well_test_pressure_input_options: Maybe<WithTypename<Well_Test_Pressure_Input_Options_Mutation_Response>> }, Mutation_RootUpdate_Well_Test_Pressure_Input_OptionsArgs>,
    update_well_test_pressure_input_options_by_pk?: GraphCacheUpdateResolver<{ update_well_test_pressure_input_options_by_pk: Maybe<WithTypename<Well_Test_Pressure_Input_Options>> }, Mutation_RootUpdate_Well_Test_Pressure_Input_Options_By_PkArgs>,
    update_well_test_pressure_input_options_many?: GraphCacheUpdateResolver<{ update_well_test_pressure_input_options_many: Maybe<Array<WithTypename<Well_Test_Pressure_Input_Options_Mutation_Response>>> }, Mutation_RootUpdate_Well_Test_Pressure_Input_Options_ManyArgs>,
    update_wells?: GraphCacheUpdateResolver<{ update_wells: Maybe<WithTypename<Wells_Mutation_Response>> }, Mutation_RootUpdate_WellsArgs>,
    update_wells_by_pk?: GraphCacheUpdateResolver<{ update_wells_by_pk: Maybe<WithTypename<Wells>> }, Mutation_RootUpdate_Wells_By_PkArgs>,
    update_wells_many?: GraphCacheUpdateResolver<{ update_wells_many: Maybe<Array<WithTypename<Wells_Mutation_Response>>> }, Mutation_RootUpdate_Wells_ManyArgs>,
    update_y_tools?: GraphCacheUpdateResolver<{ update_y_tools: Maybe<WithTypename<Y_Tools_Mutation_Response>> }, Mutation_RootUpdate_Y_ToolsArgs>,
    update_y_tools_by_pk?: GraphCacheUpdateResolver<{ update_y_tools_by_pk: Maybe<WithTypename<Y_Tools>> }, Mutation_RootUpdate_Y_Tools_By_PkArgs>,
    update_y_tools_many?: GraphCacheUpdateResolver<{ update_y_tools_many: Maybe<Array<WithTypename<Y_Tools_Mutation_Response>>> }, Mutation_RootUpdate_Y_Tools_ManyArgs>
  },
  Subscription?: {
    bolt_on_discharges?: GraphCacheUpdateResolver<{ bolt_on_discharges: Array<WithTypename<Bolt_On_Discharges>> }, Subscription_RootBolt_On_DischargesArgs>,
    bolt_on_discharges_aggregate?: GraphCacheUpdateResolver<{ bolt_on_discharges_aggregate: WithTypename<Bolt_On_Discharges_Aggregate> }, Subscription_RootBolt_On_Discharges_AggregateArgs>,
    bolt_on_discharges_by_pk?: GraphCacheUpdateResolver<{ bolt_on_discharges_by_pk: Maybe<WithTypename<Bolt_On_Discharges>> }, Subscription_RootBolt_On_Discharges_By_PkArgs>,
    bolt_on_discharges_stream?: GraphCacheUpdateResolver<{ bolt_on_discharges_stream: Array<WithTypename<Bolt_On_Discharges>> }, Subscription_RootBolt_On_Discharges_StreamArgs>,
    bubble_point_options?: GraphCacheUpdateResolver<{ bubble_point_options: Array<WithTypename<Bubble_Point_Options>> }, Subscription_RootBubble_Point_OptionsArgs>,
    bubble_point_options_aggregate?: GraphCacheUpdateResolver<{ bubble_point_options_aggregate: WithTypename<Bubble_Point_Options_Aggregate> }, Subscription_RootBubble_Point_Options_AggregateArgs>,
    bubble_point_options_by_pk?: GraphCacheUpdateResolver<{ bubble_point_options_by_pk: Maybe<WithTypename<Bubble_Point_Options>> }, Subscription_RootBubble_Point_Options_By_PkArgs>,
    bubble_point_options_stream?: GraphCacheUpdateResolver<{ bubble_point_options_stream: Array<WithTypename<Bubble_Point_Options>> }, Subscription_RootBubble_Point_Options_StreamArgs>,
    cables?: GraphCacheUpdateResolver<{ cables: Array<WithTypename<Cables>> }, Subscription_RootCablesArgs>,
    cables_aggregate?: GraphCacheUpdateResolver<{ cables_aggregate: WithTypename<Cables_Aggregate> }, Subscription_RootCables_AggregateArgs>,
    cables_by_pk?: GraphCacheUpdateResolver<{ cables_by_pk: Maybe<WithTypename<Cables>> }, Subscription_RootCables_By_PkArgs>,
    cables_stream?: GraphCacheUpdateResolver<{ cables_stream: Array<WithTypename<Cables>> }, Subscription_RootCables_StreamArgs>,
    casing_flow_options?: GraphCacheUpdateResolver<{ casing_flow_options: Array<WithTypename<Casing_Flow_Options>> }, Subscription_RootCasing_Flow_OptionsArgs>,
    casing_flow_options_aggregate?: GraphCacheUpdateResolver<{ casing_flow_options_aggregate: WithTypename<Casing_Flow_Options_Aggregate> }, Subscription_RootCasing_Flow_Options_AggregateArgs>,
    casing_flow_options_by_pk?: GraphCacheUpdateResolver<{ casing_flow_options_by_pk: Maybe<WithTypename<Casing_Flow_Options>> }, Subscription_RootCasing_Flow_Options_By_PkArgs>,
    casing_flow_options_stream?: GraphCacheUpdateResolver<{ casing_flow_options_stream: Array<WithTypename<Casing_Flow_Options>> }, Subscription_RootCasing_Flow_Options_StreamArgs>,
    casings?: GraphCacheUpdateResolver<{ casings: Array<WithTypename<Casings>> }, Subscription_RootCasingsArgs>,
    casings_aggregate?: GraphCacheUpdateResolver<{ casings_aggregate: WithTypename<Casings_Aggregate> }, Subscription_RootCasings_AggregateArgs>,
    casings_by_pk?: GraphCacheUpdateResolver<{ casings_by_pk: Maybe<WithTypename<Casings>> }, Subscription_RootCasings_By_PkArgs>,
    casings_stream?: GraphCacheUpdateResolver<{ casings_stream: Array<WithTypename<Casings>> }, Subscription_RootCasings_StreamArgs>,
    casings_type?: GraphCacheUpdateResolver<{ casings_type: Array<WithTypename<Casings_Type>> }, Subscription_RootCasings_TypeArgs>,
    casings_type_aggregate?: GraphCacheUpdateResolver<{ casings_type_aggregate: WithTypename<Casings_Type_Aggregate> }, Subscription_RootCasings_Type_AggregateArgs>,
    casings_type_by_pk?: GraphCacheUpdateResolver<{ casings_type_by_pk: Maybe<WithTypename<Casings_Type>> }, Subscription_RootCasings_Type_By_PkArgs>,
    casings_type_stream?: GraphCacheUpdateResolver<{ casings_type_stream: Array<WithTypename<Casings_Type>> }, Subscription_RootCasings_Type_StreamArgs>,
    customers?: GraphCacheUpdateResolver<{ customers: Array<WithTypename<Customers>> }, Subscription_RootCustomersArgs>,
    customers_aggregate?: GraphCacheUpdateResolver<{ customers_aggregate: WithTypename<Customers_Aggregate> }, Subscription_RootCustomers_AggregateArgs>,
    customers_by_pk?: GraphCacheUpdateResolver<{ customers_by_pk: Maybe<WithTypename<Customers>> }, Subscription_RootCustomers_By_PkArgs>,
    customers_stream?: GraphCacheUpdateResolver<{ customers_stream: Array<WithTypename<Customers>> }, Subscription_RootCustomers_StreamArgs>,
    dead_oil_options?: GraphCacheUpdateResolver<{ dead_oil_options: Array<WithTypename<Dead_Oil_Options>> }, Subscription_RootDead_Oil_OptionsArgs>,
    dead_oil_options_aggregate?: GraphCacheUpdateResolver<{ dead_oil_options_aggregate: WithTypename<Dead_Oil_Options_Aggregate> }, Subscription_RootDead_Oil_Options_AggregateArgs>,
    dead_oil_options_by_pk?: GraphCacheUpdateResolver<{ dead_oil_options_by_pk: Maybe<WithTypename<Dead_Oil_Options>> }, Subscription_RootDead_Oil_Options_By_PkArgs>,
    dead_oil_options_stream?: GraphCacheUpdateResolver<{ dead_oil_options_stream: Array<WithTypename<Dead_Oil_Options>> }, Subscription_RootDead_Oil_Options_StreamArgs>,
    deviation_survey?: GraphCacheUpdateResolver<{ deviation_survey: Array<WithTypename<Deviation_Survey>> }, Subscription_RootDeviation_SurveyArgs>,
    deviation_survey_aggregate?: GraphCacheUpdateResolver<{ deviation_survey_aggregate: WithTypename<Deviation_Survey_Aggregate> }, Subscription_RootDeviation_Survey_AggregateArgs>,
    deviation_survey_by_pk?: GraphCacheUpdateResolver<{ deviation_survey_by_pk: Maybe<WithTypename<Deviation_Survey>> }, Subscription_RootDeviation_Survey_By_PkArgs>,
    deviation_survey_directional_dataset?: GraphCacheUpdateResolver<{ deviation_survey_directional_dataset: Array<WithTypename<Deviation_Survey_Directional_Dataset>> }, Subscription_RootDeviation_Survey_Directional_DatasetArgs>,
    deviation_survey_directional_dataset_aggregate?: GraphCacheUpdateResolver<{ deviation_survey_directional_dataset_aggregate: WithTypename<Deviation_Survey_Directional_Dataset_Aggregate> }, Subscription_RootDeviation_Survey_Directional_Dataset_AggregateArgs>,
    deviation_survey_directional_dataset_by_pk?: GraphCacheUpdateResolver<{ deviation_survey_directional_dataset_by_pk: Maybe<WithTypename<Deviation_Survey_Directional_Dataset>> }, Subscription_RootDeviation_Survey_Directional_Dataset_By_PkArgs>,
    deviation_survey_directional_dataset_stream?: GraphCacheUpdateResolver<{ deviation_survey_directional_dataset_stream: Array<WithTypename<Deviation_Survey_Directional_Dataset>> }, Subscription_RootDeviation_Survey_Directional_Dataset_StreamArgs>,
    deviation_survey_stream?: GraphCacheUpdateResolver<{ deviation_survey_stream: Array<WithTypename<Deviation_Survey>> }, Subscription_RootDeviation_Survey_StreamArgs>,
    display_units?: GraphCacheUpdateResolver<{ display_units: Array<WithTypename<Display_Units>> }, Subscription_RootDisplay_UnitsArgs>,
    display_units_aggregate?: GraphCacheUpdateResolver<{ display_units_aggregate: WithTypename<Display_Units_Aggregate> }, Subscription_RootDisplay_Units_AggregateArgs>,
    display_units_by_pk?: GraphCacheUpdateResolver<{ display_units_by_pk: Maybe<WithTypename<Display_Units>> }, Subscription_RootDisplay_Units_By_PkArgs>,
    display_units_stream?: GraphCacheUpdateResolver<{ display_units_stream: Array<WithTypename<Display_Units>> }, Subscription_RootDisplay_Units_StreamArgs>,
    eula?: GraphCacheUpdateResolver<{ eula: Array<WithTypename<Eula>> }, Subscription_RootEulaArgs>,
    eula_aggregate?: GraphCacheUpdateResolver<{ eula_aggregate: WithTypename<Eula_Aggregate> }, Subscription_RootEula_AggregateArgs>,
    eula_by_pk?: GraphCacheUpdateResolver<{ eula_by_pk: Maybe<WithTypename<Eula>> }, Subscription_RootEula_By_PkArgs>,
    eula_stream?: GraphCacheUpdateResolver<{ eula_stream: Array<WithTypename<Eula>> }, Subscription_RootEula_StreamArgs>,
    flow_model?: GraphCacheUpdateResolver<{ flow_model: Array<WithTypename<Flow_Model>> }, Subscription_RootFlow_ModelArgs>,
    flow_model_active?: GraphCacheUpdateResolver<{ flow_model_active: Array<WithTypename<Flow_Model_Active>> }, Subscription_RootFlow_Model_ActiveArgs>,
    flow_model_active_aggregate?: GraphCacheUpdateResolver<{ flow_model_active_aggregate: WithTypename<Flow_Model_Active_Aggregate> }, Subscription_RootFlow_Model_Active_AggregateArgs>,
    flow_model_active_stream?: GraphCacheUpdateResolver<{ flow_model_active_stream: Array<WithTypename<Flow_Model_Active>> }, Subscription_RootFlow_Model_Active_StreamArgs>,
    flow_model_aggregate?: GraphCacheUpdateResolver<{ flow_model_aggregate: WithTypename<Flow_Model_Aggregate> }, Subscription_RootFlow_Model_AggregateArgs>,
    flow_model_by_pk?: GraphCacheUpdateResolver<{ flow_model_by_pk: Maybe<WithTypename<Flow_Model>> }, Subscription_RootFlow_Model_By_PkArgs>,
    flow_model_deprecated?: GraphCacheUpdateResolver<{ flow_model_deprecated: Array<WithTypename<Flow_Model_Deprecated>> }, Subscription_RootFlow_Model_DeprecatedArgs>,
    flow_model_deprecated_aggregate?: GraphCacheUpdateResolver<{ flow_model_deprecated_aggregate: WithTypename<Flow_Model_Deprecated_Aggregate> }, Subscription_RootFlow_Model_Deprecated_AggregateArgs>,
    flow_model_deprecated_by_pk?: GraphCacheUpdateResolver<{ flow_model_deprecated_by_pk: Maybe<WithTypename<Flow_Model_Deprecated>> }, Subscription_RootFlow_Model_Deprecated_By_PkArgs>,
    flow_model_deprecated_stream?: GraphCacheUpdateResolver<{ flow_model_deprecated_stream: Array<WithTypename<Flow_Model_Deprecated>> }, Subscription_RootFlow_Model_Deprecated_StreamArgs>,
    flow_model_stream?: GraphCacheUpdateResolver<{ flow_model_stream: Array<WithTypename<Flow_Model>> }, Subscription_RootFlow_Model_StreamArgs>,
    friction_loss_options?: GraphCacheUpdateResolver<{ friction_loss_options: Array<WithTypename<Friction_Loss_Options>> }, Subscription_RootFriction_Loss_OptionsArgs>,
    friction_loss_options_aggregate?: GraphCacheUpdateResolver<{ friction_loss_options_aggregate: WithTypename<Friction_Loss_Options_Aggregate> }, Subscription_RootFriction_Loss_Options_AggregateArgs>,
    friction_loss_options_by_pk?: GraphCacheUpdateResolver<{ friction_loss_options_by_pk: Maybe<WithTypename<Friction_Loss_Options>> }, Subscription_RootFriction_Loss_Options_By_PkArgs>,
    friction_loss_options_stream?: GraphCacheUpdateResolver<{ friction_loss_options_stream: Array<WithTypename<Friction_Loss_Options>> }, Subscription_RootFriction_Loss_Options_StreamArgs>,
    gas_compressibility_options?: GraphCacheUpdateResolver<{ gas_compressibility_options: Array<WithTypename<Gas_Compressibility_Options>> }, Subscription_RootGas_Compressibility_OptionsArgs>,
    gas_compressibility_options_aggregate?: GraphCacheUpdateResolver<{ gas_compressibility_options_aggregate: WithTypename<Gas_Compressibility_Options_Aggregate> }, Subscription_RootGas_Compressibility_Options_AggregateArgs>,
    gas_compressibility_options_by_pk?: GraphCacheUpdateResolver<{ gas_compressibility_options_by_pk: Maybe<WithTypename<Gas_Compressibility_Options>> }, Subscription_RootGas_Compressibility_Options_By_PkArgs>,
    gas_compressibility_options_stream?: GraphCacheUpdateResolver<{ gas_compressibility_options_stream: Array<WithTypename<Gas_Compressibility_Options>> }, Subscription_RootGas_Compressibility_Options_StreamArgs>,
    gas_viscosity_options?: GraphCacheUpdateResolver<{ gas_viscosity_options: Array<WithTypename<Gas_Viscosity_Options>> }, Subscription_RootGas_Viscosity_OptionsArgs>,
    gas_viscosity_options_aggregate?: GraphCacheUpdateResolver<{ gas_viscosity_options_aggregate: WithTypename<Gas_Viscosity_Options_Aggregate> }, Subscription_RootGas_Viscosity_Options_AggregateArgs>,
    gas_viscosity_options_by_pk?: GraphCacheUpdateResolver<{ gas_viscosity_options_by_pk: Maybe<WithTypename<Gas_Viscosity_Options>> }, Subscription_RootGas_Viscosity_Options_By_PkArgs>,
    gas_viscosity_options_stream?: GraphCacheUpdateResolver<{ gas_viscosity_options_stream: Array<WithTypename<Gas_Viscosity_Options>> }, Subscription_RootGas_Viscosity_Options_StreamArgs>,
    housings?: GraphCacheUpdateResolver<{ housings: Array<WithTypename<Housings>> }, Subscription_RootHousingsArgs>,
    housings_aggregate?: GraphCacheUpdateResolver<{ housings_aggregate: WithTypename<Housings_Aggregate> }, Subscription_RootHousings_AggregateArgs>,
    housings_by_pk?: GraphCacheUpdateResolver<{ housings_by_pk: Maybe<WithTypename<Housings>> }, Subscription_RootHousings_By_PkArgs>,
    housings_stream?: GraphCacheUpdateResolver<{ housings_stream: Array<WithTypename<Housings>> }, Subscription_RootHousings_StreamArgs>,
    hps_liquid_type?: GraphCacheUpdateResolver<{ hps_liquid_type: Array<WithTypename<Hps_Liquid_Type>> }, Subscription_RootHps_Liquid_TypeArgs>,
    hps_liquid_type_aggregate?: GraphCacheUpdateResolver<{ hps_liquid_type_aggregate: WithTypename<Hps_Liquid_Type_Aggregate> }, Subscription_RootHps_Liquid_Type_AggregateArgs>,
    hps_liquid_type_by_pk?: GraphCacheUpdateResolver<{ hps_liquid_type_by_pk: Maybe<WithTypename<Hps_Liquid_Type>> }, Subscription_RootHps_Liquid_Type_By_PkArgs>,
    hps_liquid_type_stream?: GraphCacheUpdateResolver<{ hps_liquid_type_stream: Array<WithTypename<Hps_Liquid_Type>> }, Subscription_RootHps_Liquid_Type_StreamArgs>,
    intakes?: GraphCacheUpdateResolver<{ intakes: Array<WithTypename<Intakes>> }, Subscription_RootIntakesArgs>,
    intakes_aggregate?: GraphCacheUpdateResolver<{ intakes_aggregate: WithTypename<Intakes_Aggregate> }, Subscription_RootIntakes_AggregateArgs>,
    intakes_by_pk?: GraphCacheUpdateResolver<{ intakes_by_pk: Maybe<WithTypename<Intakes>> }, Subscription_RootIntakes_By_PkArgs>,
    intakes_stream?: GraphCacheUpdateResolver<{ intakes_stream: Array<WithTypename<Intakes>> }, Subscription_RootIntakes_StreamArgs>,
    legacy_users?: GraphCacheUpdateResolver<{ legacy_users: Array<WithTypename<Legacy_Users>> }, Subscription_RootLegacy_UsersArgs>,
    legacy_users_aggregate?: GraphCacheUpdateResolver<{ legacy_users_aggregate: WithTypename<Legacy_Users_Aggregate> }, Subscription_RootLegacy_Users_AggregateArgs>,
    legacy_users_by_pk?: GraphCacheUpdateResolver<{ legacy_users_by_pk: Maybe<WithTypename<Legacy_Users>> }, Subscription_RootLegacy_Users_By_PkArgs>,
    legacy_users_stream?: GraphCacheUpdateResolver<{ legacy_users_stream: Array<WithTypename<Legacy_Users>> }, Subscription_RootLegacy_Users_StreamArgs>,
    motor_lead_extensions?: GraphCacheUpdateResolver<{ motor_lead_extensions: Array<WithTypename<Motor_Lead_Extensions>> }, Subscription_RootMotor_Lead_ExtensionsArgs>,
    motor_lead_extensions_aggregate?: GraphCacheUpdateResolver<{ motor_lead_extensions_aggregate: WithTypename<Motor_Lead_Extensions_Aggregate> }, Subscription_RootMotor_Lead_Extensions_AggregateArgs>,
    motor_lead_extensions_by_pk?: GraphCacheUpdateResolver<{ motor_lead_extensions_by_pk: Maybe<WithTypename<Motor_Lead_Extensions>> }, Subscription_RootMotor_Lead_Extensions_By_PkArgs>,
    motor_lead_extensions_stream?: GraphCacheUpdateResolver<{ motor_lead_extensions_stream: Array<WithTypename<Motor_Lead_Extensions>> }, Subscription_RootMotor_Lead_Extensions_StreamArgs>,
    motors?: GraphCacheUpdateResolver<{ motors: Array<WithTypename<Motors>> }, Subscription_RootMotorsArgs>,
    motors_aggregate?: GraphCacheUpdateResolver<{ motors_aggregate: WithTypename<Motors_Aggregate> }, Subscription_RootMotors_AggregateArgs>,
    motors_by_pk?: GraphCacheUpdateResolver<{ motors_by_pk: Maybe<WithTypename<Motors>> }, Subscription_RootMotors_By_PkArgs>,
    motors_stream?: GraphCacheUpdateResolver<{ motors_stream: Array<WithTypename<Motors>> }, Subscription_RootMotors_StreamArgs>,
    natural_gas_separation_options?: GraphCacheUpdateResolver<{ natural_gas_separation_options: Array<WithTypename<Natural_Gas_Separation_Options>> }, Subscription_RootNatural_Gas_Separation_OptionsArgs>,
    natural_gas_separation_options_aggregate?: GraphCacheUpdateResolver<{ natural_gas_separation_options_aggregate: WithTypename<Natural_Gas_Separation_Options_Aggregate> }, Subscription_RootNatural_Gas_Separation_Options_AggregateArgs>,
    natural_gas_separation_options_by_pk?: GraphCacheUpdateResolver<{ natural_gas_separation_options_by_pk: Maybe<WithTypename<Natural_Gas_Separation_Options>> }, Subscription_RootNatural_Gas_Separation_Options_By_PkArgs>,
    natural_gas_separation_options_stream?: GraphCacheUpdateResolver<{ natural_gas_separation_options_stream: Array<WithTypename<Natural_Gas_Separation_Options>> }, Subscription_RootNatural_Gas_Separation_Options_StreamArgs>,
    oil_density_options?: GraphCacheUpdateResolver<{ oil_density_options: Array<WithTypename<Oil_Density_Options>> }, Subscription_RootOil_Density_OptionsArgs>,
    oil_density_options_aggregate?: GraphCacheUpdateResolver<{ oil_density_options_aggregate: WithTypename<Oil_Density_Options_Aggregate> }, Subscription_RootOil_Density_Options_AggregateArgs>,
    oil_density_options_by_pk?: GraphCacheUpdateResolver<{ oil_density_options_by_pk: Maybe<WithTypename<Oil_Density_Options>> }, Subscription_RootOil_Density_Options_By_PkArgs>,
    oil_density_options_stream?: GraphCacheUpdateResolver<{ oil_density_options_stream: Array<WithTypename<Oil_Density_Options>> }, Subscription_RootOil_Density_Options_StreamArgs>,
    oil_volume_factor_options?: GraphCacheUpdateResolver<{ oil_volume_factor_options: Array<WithTypename<Oil_Volume_Factor_Options>> }, Subscription_RootOil_Volume_Factor_OptionsArgs>,
    oil_volume_factor_options_aggregate?: GraphCacheUpdateResolver<{ oil_volume_factor_options_aggregate: WithTypename<Oil_Volume_Factor_Options_Aggregate> }, Subscription_RootOil_Volume_Factor_Options_AggregateArgs>,
    oil_volume_factor_options_by_pk?: GraphCacheUpdateResolver<{ oil_volume_factor_options_by_pk: Maybe<WithTypename<Oil_Volume_Factor_Options>> }, Subscription_RootOil_Volume_Factor_Options_By_PkArgs>,
    oil_volume_factor_options_stream?: GraphCacheUpdateResolver<{ oil_volume_factor_options_stream: Array<WithTypename<Oil_Volume_Factor_Options>> }, Subscription_RootOil_Volume_Factor_Options_StreamArgs>,
    override_options?: GraphCacheUpdateResolver<{ override_options: Array<WithTypename<Override_Options>> }, Subscription_RootOverride_OptionsArgs>,
    override_options_aggregate?: GraphCacheUpdateResolver<{ override_options_aggregate: WithTypename<Override_Options_Aggregate> }, Subscription_RootOverride_Options_AggregateArgs>,
    override_options_by_pk?: GraphCacheUpdateResolver<{ override_options_by_pk: Maybe<WithTypename<Override_Options>> }, Subscription_RootOverride_Options_By_PkArgs>,
    override_options_stream?: GraphCacheUpdateResolver<{ override_options_stream: Array<WithTypename<Override_Options>> }, Subscription_RootOverride_Options_StreamArgs>,
    performance_evaluations?: GraphCacheUpdateResolver<{ performance_evaluations: Array<WithTypename<Performance_Evaluations>> }, Subscription_RootPerformance_EvaluationsArgs>,
    performance_evaluations_aggregate?: GraphCacheUpdateResolver<{ performance_evaluations_aggregate: WithTypename<Performance_Evaluations_Aggregate> }, Subscription_RootPerformance_Evaluations_AggregateArgs>,
    performance_evaluations_stream?: GraphCacheUpdateResolver<{ performance_evaluations_stream: Array<WithTypename<Performance_Evaluations>> }, Subscription_RootPerformance_Evaluations_StreamArgs>,
    performance_evaluations_xref_pumps?: GraphCacheUpdateResolver<{ performance_evaluations_xref_pumps: Array<WithTypename<Performance_Evaluations_Xref_Pumps>> }, Subscription_RootPerformance_Evaluations_Xref_PumpsArgs>,
    performance_evaluations_xref_pumps_aggregate?: GraphCacheUpdateResolver<{ performance_evaluations_xref_pumps_aggregate: WithTypename<Performance_Evaluations_Xref_Pumps_Aggregate> }, Subscription_RootPerformance_Evaluations_Xref_Pumps_AggregateArgs>,
    performance_evaluations_xref_pumps_stream?: GraphCacheUpdateResolver<{ performance_evaluations_xref_pumps_stream: Array<WithTypename<Performance_Evaluations_Xref_Pumps>> }, Subscription_RootPerformance_Evaluations_Xref_Pumps_StreamArgs>,
    pumps?: GraphCacheUpdateResolver<{ pumps: Array<WithTypename<Pumps>> }, Subscription_RootPumpsArgs>,
    pumps_aggregate?: GraphCacheUpdateResolver<{ pumps_aggregate: WithTypename<Pumps_Aggregate> }, Subscription_RootPumps_AggregateArgs>,
    pumps_by_pk?: GraphCacheUpdateResolver<{ pumps_by_pk: Maybe<WithTypename<Pumps>> }, Subscription_RootPumps_By_PkArgs>,
    pumps_stream?: GraphCacheUpdateResolver<{ pumps_stream: Array<WithTypename<Pumps>> }, Subscription_RootPumps_StreamArgs>,
    quote_line_item_category_dataset?: GraphCacheUpdateResolver<{ quote_line_item_category_dataset: Array<WithTypename<Quote_Line_Item_Category_Dataset>> }, Subscription_RootQuote_Line_Item_Category_DatasetArgs>,
    quote_line_item_category_dataset_aggregate?: GraphCacheUpdateResolver<{ quote_line_item_category_dataset_aggregate: WithTypename<Quote_Line_Item_Category_Dataset_Aggregate> }, Subscription_RootQuote_Line_Item_Category_Dataset_AggregateArgs>,
    quote_line_item_category_dataset_by_pk?: GraphCacheUpdateResolver<{ quote_line_item_category_dataset_by_pk: Maybe<WithTypename<Quote_Line_Item_Category_Dataset>> }, Subscription_RootQuote_Line_Item_Category_Dataset_By_PkArgs>,
    quote_line_item_category_dataset_stream?: GraphCacheUpdateResolver<{ quote_line_item_category_dataset_stream: Array<WithTypename<Quote_Line_Item_Category_Dataset>> }, Subscription_RootQuote_Line_Item_Category_Dataset_StreamArgs>,
    quote_line_item_serialized_dataset?: GraphCacheUpdateResolver<{ quote_line_item_serialized_dataset: Array<WithTypename<Quote_Line_Item_Serialized_Dataset>> }, Subscription_RootQuote_Line_Item_Serialized_DatasetArgs>,
    quote_line_item_serialized_dataset_aggregate?: GraphCacheUpdateResolver<{ quote_line_item_serialized_dataset_aggregate: WithTypename<Quote_Line_Item_Serialized_Dataset_Aggregate> }, Subscription_RootQuote_Line_Item_Serialized_Dataset_AggregateArgs>,
    quote_line_item_serialized_dataset_by_pk?: GraphCacheUpdateResolver<{ quote_line_item_serialized_dataset_by_pk: Maybe<WithTypename<Quote_Line_Item_Serialized_Dataset>> }, Subscription_RootQuote_Line_Item_Serialized_Dataset_By_PkArgs>,
    quote_line_item_serialized_dataset_stream?: GraphCacheUpdateResolver<{ quote_line_item_serialized_dataset_stream: Array<WithTypename<Quote_Line_Item_Serialized_Dataset>> }, Subscription_RootQuote_Line_Item_Serialized_Dataset_StreamArgs>,
    quote_line_item_source_dataset?: GraphCacheUpdateResolver<{ quote_line_item_source_dataset: Array<WithTypename<Quote_Line_Item_Source_Dataset>> }, Subscription_RootQuote_Line_Item_Source_DatasetArgs>,
    quote_line_item_source_dataset_aggregate?: GraphCacheUpdateResolver<{ quote_line_item_source_dataset_aggregate: WithTypename<Quote_Line_Item_Source_Dataset_Aggregate> }, Subscription_RootQuote_Line_Item_Source_Dataset_AggregateArgs>,
    quote_line_item_source_dataset_by_pk?: GraphCacheUpdateResolver<{ quote_line_item_source_dataset_by_pk: Maybe<WithTypename<Quote_Line_Item_Source_Dataset>> }, Subscription_RootQuote_Line_Item_Source_Dataset_By_PkArgs>,
    quote_line_item_source_dataset_stream?: GraphCacheUpdateResolver<{ quote_line_item_source_dataset_stream: Array<WithTypename<Quote_Line_Item_Source_Dataset>> }, Subscription_RootQuote_Line_Item_Source_Dataset_StreamArgs>,
    quote_line_item_subcategory_dataset?: GraphCacheUpdateResolver<{ quote_line_item_subcategory_dataset: Array<WithTypename<Quote_Line_Item_Subcategory_Dataset>> }, Subscription_RootQuote_Line_Item_Subcategory_DatasetArgs>,
    quote_line_item_subcategory_dataset_aggregate?: GraphCacheUpdateResolver<{ quote_line_item_subcategory_dataset_aggregate: WithTypename<Quote_Line_Item_Subcategory_Dataset_Aggregate> }, Subscription_RootQuote_Line_Item_Subcategory_Dataset_AggregateArgs>,
    quote_line_item_subcategory_dataset_by_pk?: GraphCacheUpdateResolver<{ quote_line_item_subcategory_dataset_by_pk: Maybe<WithTypename<Quote_Line_Item_Subcategory_Dataset>> }, Subscription_RootQuote_Line_Item_Subcategory_Dataset_By_PkArgs>,
    quote_line_item_subcategory_dataset_stream?: GraphCacheUpdateResolver<{ quote_line_item_subcategory_dataset_stream: Array<WithTypename<Quote_Line_Item_Subcategory_Dataset>> }, Subscription_RootQuote_Line_Item_Subcategory_Dataset_StreamArgs>,
    quote_line_item_tax_type_dataset?: GraphCacheUpdateResolver<{ quote_line_item_tax_type_dataset: Array<WithTypename<Quote_Line_Item_Tax_Type_Dataset>> }, Subscription_RootQuote_Line_Item_Tax_Type_DatasetArgs>,
    quote_line_item_tax_type_dataset_aggregate?: GraphCacheUpdateResolver<{ quote_line_item_tax_type_dataset_aggregate: WithTypename<Quote_Line_Item_Tax_Type_Dataset_Aggregate> }, Subscription_RootQuote_Line_Item_Tax_Type_Dataset_AggregateArgs>,
    quote_line_item_tax_type_dataset_by_pk?: GraphCacheUpdateResolver<{ quote_line_item_tax_type_dataset_by_pk: Maybe<WithTypename<Quote_Line_Item_Tax_Type_Dataset>> }, Subscription_RootQuote_Line_Item_Tax_Type_Dataset_By_PkArgs>,
    quote_line_item_tax_type_dataset_stream?: GraphCacheUpdateResolver<{ quote_line_item_tax_type_dataset_stream: Array<WithTypename<Quote_Line_Item_Tax_Type_Dataset>> }, Subscription_RootQuote_Line_Item_Tax_Type_Dataset_StreamArgs>,
    quote_line_item_type_dataset?: GraphCacheUpdateResolver<{ quote_line_item_type_dataset: Array<WithTypename<Quote_Line_Item_Type_Dataset>> }, Subscription_RootQuote_Line_Item_Type_DatasetArgs>,
    quote_line_item_type_dataset_aggregate?: GraphCacheUpdateResolver<{ quote_line_item_type_dataset_aggregate: WithTypename<Quote_Line_Item_Type_Dataset_Aggregate> }, Subscription_RootQuote_Line_Item_Type_Dataset_AggregateArgs>,
    quote_line_item_type_dataset_by_pk?: GraphCacheUpdateResolver<{ quote_line_item_type_dataset_by_pk: Maybe<WithTypename<Quote_Line_Item_Type_Dataset>> }, Subscription_RootQuote_Line_Item_Type_Dataset_By_PkArgs>,
    quote_line_item_type_dataset_stream?: GraphCacheUpdateResolver<{ quote_line_item_type_dataset_stream: Array<WithTypename<Quote_Line_Item_Type_Dataset>> }, Subscription_RootQuote_Line_Item_Type_Dataset_StreamArgs>,
    quote_line_items?: GraphCacheUpdateResolver<{ quote_line_items: Array<WithTypename<Quote_Line_Items>> }, Subscription_RootQuote_Line_ItemsArgs>,
    quote_line_items_aggregate?: GraphCacheUpdateResolver<{ quote_line_items_aggregate: WithTypename<Quote_Line_Items_Aggregate> }, Subscription_RootQuote_Line_Items_AggregateArgs>,
    quote_line_items_by_pk?: GraphCacheUpdateResolver<{ quote_line_items_by_pk: Maybe<WithTypename<Quote_Line_Items>> }, Subscription_RootQuote_Line_Items_By_PkArgs>,
    quote_line_items_stream?: GraphCacheUpdateResolver<{ quote_line_items_stream: Array<WithTypename<Quote_Line_Items>> }, Subscription_RootQuote_Line_Items_StreamArgs>,
    quote_sk_job_type_dataset?: GraphCacheUpdateResolver<{ quote_sk_job_type_dataset: Array<WithTypename<Quote_Sk_Job_Type_Dataset>> }, Subscription_RootQuote_Sk_Job_Type_DatasetArgs>,
    quote_sk_job_type_dataset_aggregate?: GraphCacheUpdateResolver<{ quote_sk_job_type_dataset_aggregate: WithTypename<Quote_Sk_Job_Type_Dataset_Aggregate> }, Subscription_RootQuote_Sk_Job_Type_Dataset_AggregateArgs>,
    quote_sk_job_type_dataset_by_pk?: GraphCacheUpdateResolver<{ quote_sk_job_type_dataset_by_pk: Maybe<WithTypename<Quote_Sk_Job_Type_Dataset>> }, Subscription_RootQuote_Sk_Job_Type_Dataset_By_PkArgs>,
    quote_sk_job_type_dataset_stream?: GraphCacheUpdateResolver<{ quote_sk_job_type_dataset_stream: Array<WithTypename<Quote_Sk_Job_Type_Dataset>> }, Subscription_RootQuote_Sk_Job_Type_Dataset_StreamArgs>,
    quote_source_dataset?: GraphCacheUpdateResolver<{ quote_source_dataset: Array<WithTypename<Quote_Source_Dataset>> }, Subscription_RootQuote_Source_DatasetArgs>,
    quote_source_dataset_aggregate?: GraphCacheUpdateResolver<{ quote_source_dataset_aggregate: WithTypename<Quote_Source_Dataset_Aggregate> }, Subscription_RootQuote_Source_Dataset_AggregateArgs>,
    quote_source_dataset_by_pk?: GraphCacheUpdateResolver<{ quote_source_dataset_by_pk: Maybe<WithTypename<Quote_Source_Dataset>> }, Subscription_RootQuote_Source_Dataset_By_PkArgs>,
    quote_source_dataset_stream?: GraphCacheUpdateResolver<{ quote_source_dataset_stream: Array<WithTypename<Quote_Source_Dataset>> }, Subscription_RootQuote_Source_Dataset_StreamArgs>,
    quote_status_dataset?: GraphCacheUpdateResolver<{ quote_status_dataset: Array<WithTypename<Quote_Status_Dataset>> }, Subscription_RootQuote_Status_DatasetArgs>,
    quote_status_dataset_aggregate?: GraphCacheUpdateResolver<{ quote_status_dataset_aggregate: WithTypename<Quote_Status_Dataset_Aggregate> }, Subscription_RootQuote_Status_Dataset_AggregateArgs>,
    quote_status_dataset_by_pk?: GraphCacheUpdateResolver<{ quote_status_dataset_by_pk: Maybe<WithTypename<Quote_Status_Dataset>> }, Subscription_RootQuote_Status_Dataset_By_PkArgs>,
    quote_status_dataset_stream?: GraphCacheUpdateResolver<{ quote_status_dataset_stream: Array<WithTypename<Quote_Status_Dataset>> }, Subscription_RootQuote_Status_Dataset_StreamArgs>,
    quote_user_messages?: GraphCacheUpdateResolver<{ quote_user_messages: Array<WithTypename<Quote_User_Messages>> }, Subscription_RootQuote_User_MessagesArgs>,
    quote_user_messages_aggregate?: GraphCacheUpdateResolver<{ quote_user_messages_aggregate: WithTypename<Quote_User_Messages_Aggregate> }, Subscription_RootQuote_User_Messages_AggregateArgs>,
    quote_user_messages_by_pk?: GraphCacheUpdateResolver<{ quote_user_messages_by_pk: Maybe<WithTypename<Quote_User_Messages>> }, Subscription_RootQuote_User_Messages_By_PkArgs>,
    quote_user_messages_stream?: GraphCacheUpdateResolver<{ quote_user_messages_stream: Array<WithTypename<Quote_User_Messages>> }, Subscription_RootQuote_User_Messages_StreamArgs>,
    quotes?: GraphCacheUpdateResolver<{ quotes: Array<WithTypename<Quotes>> }, Subscription_RootQuotesArgs>,
    quotes_aggregate?: GraphCacheUpdateResolver<{ quotes_aggregate: WithTypename<Quotes_Aggregate> }, Subscription_RootQuotes_AggregateArgs>,
    quotes_by_pk?: GraphCacheUpdateResolver<{ quotes_by_pk: Maybe<WithTypename<Quotes>> }, Subscription_RootQuotes_By_PkArgs>,
    quotes_stream?: GraphCacheUpdateResolver<{ quotes_stream: Array<WithTypename<Quotes>> }, Subscription_RootQuotes_StreamArgs>,
    revisions_performance_evaluations_journal?: GraphCacheUpdateResolver<{ revisions_performance_evaluations_journal: Array<WithTypename<Revisions_Performance_Evaluations_Journal>> }, Subscription_RootRevisions_Performance_Evaluations_JournalArgs>,
    revisions_performance_evaluations_journal_aggregate?: GraphCacheUpdateResolver<{ revisions_performance_evaluations_journal_aggregate: WithTypename<Revisions_Performance_Evaluations_Journal_Aggregate> }, Subscription_RootRevisions_Performance_Evaluations_Journal_AggregateArgs>,
    revisions_performance_evaluations_journal_by_pk?: GraphCacheUpdateResolver<{ revisions_performance_evaluations_journal_by_pk: Maybe<WithTypename<Revisions_Performance_Evaluations_Journal>> }, Subscription_RootRevisions_Performance_Evaluations_Journal_By_PkArgs>,
    revisions_performance_evaluations_journal_stream?: GraphCacheUpdateResolver<{ revisions_performance_evaluations_journal_stream: Array<WithTypename<Revisions_Performance_Evaluations_Journal>> }, Subscription_RootRevisions_Performance_Evaluations_Journal_StreamArgs>,
    revisions_performance_evaluations_revisions?: GraphCacheUpdateResolver<{ revisions_performance_evaluations_revisions: Array<WithTypename<Revisions_Performance_Evaluations_Revisions>> }, Subscription_RootRevisions_Performance_Evaluations_RevisionsArgs>,
    revisions_performance_evaluations_revisions_aggregate?: GraphCacheUpdateResolver<{ revisions_performance_evaluations_revisions_aggregate: WithTypename<Revisions_Performance_Evaluations_Revisions_Aggregate> }, Subscription_RootRevisions_Performance_Evaluations_Revisions_AggregateArgs>,
    revisions_performance_evaluations_revisions_by_pk?: GraphCacheUpdateResolver<{ revisions_performance_evaluations_revisions_by_pk: Maybe<WithTypename<Revisions_Performance_Evaluations_Revisions>> }, Subscription_RootRevisions_Performance_Evaluations_Revisions_By_PkArgs>,
    revisions_performance_evaluations_revisions_stream?: GraphCacheUpdateResolver<{ revisions_performance_evaluations_revisions_stream: Array<WithTypename<Revisions_Performance_Evaluations_Revisions>> }, Subscription_RootRevisions_Performance_Evaluations_Revisions_StreamArgs>,
    revisions_performance_evaluations_xref_pumps_journal?: GraphCacheUpdateResolver<{ revisions_performance_evaluations_xref_pumps_journal: Array<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Journal>> }, Subscription_RootRevisions_Performance_Evaluations_Xref_Pumps_JournalArgs>,
    revisions_performance_evaluations_xref_pumps_journal_aggregate?: GraphCacheUpdateResolver<{ revisions_performance_evaluations_xref_pumps_journal_aggregate: WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Journal_Aggregate> }, Subscription_RootRevisions_Performance_Evaluations_Xref_Pumps_Journal_AggregateArgs>,
    revisions_performance_evaluations_xref_pumps_journal_by_pk?: GraphCacheUpdateResolver<{ revisions_performance_evaluations_xref_pumps_journal_by_pk: Maybe<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Journal>> }, Subscription_RootRevisions_Performance_Evaluations_Xref_Pumps_Journal_By_PkArgs>,
    revisions_performance_evaluations_xref_pumps_journal_stream?: GraphCacheUpdateResolver<{ revisions_performance_evaluations_xref_pumps_journal_stream: Array<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Journal>> }, Subscription_RootRevisions_Performance_Evaluations_Xref_Pumps_Journal_StreamArgs>,
    revisions_performance_evaluations_xref_pumps_revisions?: GraphCacheUpdateResolver<{ revisions_performance_evaluations_xref_pumps_revisions: Array<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Revisions>> }, Subscription_RootRevisions_Performance_Evaluations_Xref_Pumps_RevisionsArgs>,
    revisions_performance_evaluations_xref_pumps_revisions_aggregate?: GraphCacheUpdateResolver<{ revisions_performance_evaluations_xref_pumps_revisions_aggregate: WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Revisions_Aggregate> }, Subscription_RootRevisions_Performance_Evaluations_Xref_Pumps_Revisions_AggregateArgs>,
    revisions_performance_evaluations_xref_pumps_revisions_by_pk?: GraphCacheUpdateResolver<{ revisions_performance_evaluations_xref_pumps_revisions_by_pk: Maybe<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Revisions>> }, Subscription_RootRevisions_Performance_Evaluations_Xref_Pumps_Revisions_By_PkArgs>,
    revisions_performance_evaluations_xref_pumps_revisions_stream?: GraphCacheUpdateResolver<{ revisions_performance_evaluations_xref_pumps_revisions_stream: Array<WithTypename<Revisions_Performance_Evaluations_Xref_Pumps_Revisions>> }, Subscription_RootRevisions_Performance_Evaluations_Xref_Pumps_Revisions_StreamArgs>,
    revisions_sc_equip_xref_downhole_ytool_bypass_tubings_journal?: GraphCacheUpdateResolver<{ revisions_sc_equip_xref_downhole_ytool_bypass_tubings_journal: Array<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal>> }, Subscription_RootRevisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_JournalArgs>,
    revisions_sc_equip_xref_downhole_ytool_bypass_tubings_journal_aggregate?: GraphCacheUpdateResolver<{ revisions_sc_equip_xref_downhole_ytool_bypass_tubings_journal_aggregate: WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_Aggregate> }, Subscription_RootRevisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_AggregateArgs>,
    revisions_sc_equip_xref_downhole_ytool_bypass_tubings_journal_by_pk?: GraphCacheUpdateResolver<{ revisions_sc_equip_xref_downhole_ytool_bypass_tubings_journal_by_pk: Maybe<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal>> }, Subscription_RootRevisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_By_PkArgs>,
    revisions_sc_equip_xref_downhole_ytool_bypass_tubings_journal_stream?: GraphCacheUpdateResolver<{ revisions_sc_equip_xref_downhole_ytool_bypass_tubings_journal_stream: Array<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal>> }, Subscription_RootRevisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Journal_StreamArgs>,
    revisions_sc_equip_xref_downhole_ytool_bypass_tubings_revisions?: GraphCacheUpdateResolver<{ revisions_sc_equip_xref_downhole_ytool_bypass_tubings_revisions: Array<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions>> }, Subscription_RootRevisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_RevisionsArgs>,
    revisions_sc_equip_xref_downhole_ytool_bypass_tubings_revisions_aggregate?: GraphCacheUpdateResolver<{ revisions_sc_equip_xref_downhole_ytool_bypass_tubings_revisions_aggregate: WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_Aggregate> }, Subscription_RootRevisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_AggregateArgs>,
    revisions_sc_equip_xref_downhole_ytool_bypass_tubings_revisions_by_pk?: GraphCacheUpdateResolver<{ revisions_sc_equip_xref_downhole_ytool_bypass_tubings_revisions_by_pk: Maybe<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions>> }, Subscription_RootRevisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_By_PkArgs>,
    revisions_sc_equip_xref_downhole_ytool_bypass_tubings_revisions_stream?: GraphCacheUpdateResolver<{ revisions_sc_equip_xref_downhole_ytool_bypass_tubings_revisions_stream: Array<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions>> }, Subscription_RootRevisions_Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Revisions_StreamArgs>,
    revisions_sc_equip_xref_downhole_ytool_equip_tubings_journal?: GraphCacheUpdateResolver<{ revisions_sc_equip_xref_downhole_ytool_equip_tubings_journal: Array<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal>> }, Subscription_RootRevisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_JournalArgs>,
    revisions_sc_equip_xref_downhole_ytool_equip_tubings_journal_aggregate?: GraphCacheUpdateResolver<{ revisions_sc_equip_xref_downhole_ytool_equip_tubings_journal_aggregate: WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_Aggregate> }, Subscription_RootRevisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_AggregateArgs>,
    revisions_sc_equip_xref_downhole_ytool_equip_tubings_journal_by_pk?: GraphCacheUpdateResolver<{ revisions_sc_equip_xref_downhole_ytool_equip_tubings_journal_by_pk: Maybe<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal>> }, Subscription_RootRevisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_By_PkArgs>,
    revisions_sc_equip_xref_downhole_ytool_equip_tubings_journal_stream?: GraphCacheUpdateResolver<{ revisions_sc_equip_xref_downhole_ytool_equip_tubings_journal_stream: Array<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal>> }, Subscription_RootRevisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Journal_StreamArgs>,
    revisions_sc_equip_xref_downhole_ytool_equip_tubings_revisions?: GraphCacheUpdateResolver<{ revisions_sc_equip_xref_downhole_ytool_equip_tubings_revisions: Array<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions>> }, Subscription_RootRevisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_RevisionsArgs>,
    revisions_sc_equip_xref_downhole_ytool_equip_tubings_revisions_aggregate?: GraphCacheUpdateResolver<{ revisions_sc_equip_xref_downhole_ytool_equip_tubings_revisions_aggregate: WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_Aggregate> }, Subscription_RootRevisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_AggregateArgs>,
    revisions_sc_equip_xref_downhole_ytool_equip_tubings_revisions_by_pk?: GraphCacheUpdateResolver<{ revisions_sc_equip_xref_downhole_ytool_equip_tubings_revisions_by_pk: Maybe<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions>> }, Subscription_RootRevisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_By_PkArgs>,
    revisions_sc_equip_xref_downhole_ytool_equip_tubings_revisions_stream?: GraphCacheUpdateResolver<{ revisions_sc_equip_xref_downhole_ytool_equip_tubings_revisions_stream: Array<WithTypename<Revisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions>> }, Subscription_RootRevisions_Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Revisions_StreamArgs>,
    revisions_sc_equip_xref_uphole_ytool_bypass_tubings_journal?: GraphCacheUpdateResolver<{ revisions_sc_equip_xref_uphole_ytool_bypass_tubings_journal: Array<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal>> }, Subscription_RootRevisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_JournalArgs>,
    revisions_sc_equip_xref_uphole_ytool_bypass_tubings_journal_aggregate?: GraphCacheUpdateResolver<{ revisions_sc_equip_xref_uphole_ytool_bypass_tubings_journal_aggregate: WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_Aggregate> }, Subscription_RootRevisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_AggregateArgs>,
    revisions_sc_equip_xref_uphole_ytool_bypass_tubings_journal_by_pk?: GraphCacheUpdateResolver<{ revisions_sc_equip_xref_uphole_ytool_bypass_tubings_journal_by_pk: Maybe<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal>> }, Subscription_RootRevisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_By_PkArgs>,
    revisions_sc_equip_xref_uphole_ytool_bypass_tubings_journal_stream?: GraphCacheUpdateResolver<{ revisions_sc_equip_xref_uphole_ytool_bypass_tubings_journal_stream: Array<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal>> }, Subscription_RootRevisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Journal_StreamArgs>,
    revisions_sc_equip_xref_uphole_ytool_bypass_tubings_revisions?: GraphCacheUpdateResolver<{ revisions_sc_equip_xref_uphole_ytool_bypass_tubings_revisions: Array<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions>> }, Subscription_RootRevisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_RevisionsArgs>,
    revisions_sc_equip_xref_uphole_ytool_bypass_tubings_revisions_aggregate?: GraphCacheUpdateResolver<{ revisions_sc_equip_xref_uphole_ytool_bypass_tubings_revisions_aggregate: WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_Aggregate> }, Subscription_RootRevisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_AggregateArgs>,
    revisions_sc_equip_xref_uphole_ytool_bypass_tubings_revisions_by_pk?: GraphCacheUpdateResolver<{ revisions_sc_equip_xref_uphole_ytool_bypass_tubings_revisions_by_pk: Maybe<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions>> }, Subscription_RootRevisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_By_PkArgs>,
    revisions_sc_equip_xref_uphole_ytool_bypass_tubings_revisions_stream?: GraphCacheUpdateResolver<{ revisions_sc_equip_xref_uphole_ytool_bypass_tubings_revisions_stream: Array<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions>> }, Subscription_RootRevisions_Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Revisions_StreamArgs>,
    revisions_sc_equip_xref_uphole_ytool_equip_tubings_journal?: GraphCacheUpdateResolver<{ revisions_sc_equip_xref_uphole_ytool_equip_tubings_journal: Array<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal>> }, Subscription_RootRevisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_JournalArgs>,
    revisions_sc_equip_xref_uphole_ytool_equip_tubings_journal_aggregate?: GraphCacheUpdateResolver<{ revisions_sc_equip_xref_uphole_ytool_equip_tubings_journal_aggregate: WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_Aggregate> }, Subscription_RootRevisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_AggregateArgs>,
    revisions_sc_equip_xref_uphole_ytool_equip_tubings_journal_by_pk?: GraphCacheUpdateResolver<{ revisions_sc_equip_xref_uphole_ytool_equip_tubings_journal_by_pk: Maybe<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal>> }, Subscription_RootRevisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_By_PkArgs>,
    revisions_sc_equip_xref_uphole_ytool_equip_tubings_journal_stream?: GraphCacheUpdateResolver<{ revisions_sc_equip_xref_uphole_ytool_equip_tubings_journal_stream: Array<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal>> }, Subscription_RootRevisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Journal_StreamArgs>,
    revisions_sc_equip_xref_uphole_ytool_equip_tubings_revisions?: GraphCacheUpdateResolver<{ revisions_sc_equip_xref_uphole_ytool_equip_tubings_revisions: Array<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions>> }, Subscription_RootRevisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_RevisionsArgs>,
    revisions_sc_equip_xref_uphole_ytool_equip_tubings_revisions_aggregate?: GraphCacheUpdateResolver<{ revisions_sc_equip_xref_uphole_ytool_equip_tubings_revisions_aggregate: WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_Aggregate> }, Subscription_RootRevisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_AggregateArgs>,
    revisions_sc_equip_xref_uphole_ytool_equip_tubings_revisions_by_pk?: GraphCacheUpdateResolver<{ revisions_sc_equip_xref_uphole_ytool_equip_tubings_revisions_by_pk: Maybe<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions>> }, Subscription_RootRevisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_By_PkArgs>,
    revisions_sc_equip_xref_uphole_ytool_equip_tubings_revisions_stream?: GraphCacheUpdateResolver<{ revisions_sc_equip_xref_uphole_ytool_equip_tubings_revisions_stream: Array<WithTypename<Revisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions>> }, Subscription_RootRevisions_Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Revisions_StreamArgs>,
    revisions_scenario_correlations_journal?: GraphCacheUpdateResolver<{ revisions_scenario_correlations_journal: Array<WithTypename<Revisions_Scenario_Correlations_Journal>> }, Subscription_RootRevisions_Scenario_Correlations_JournalArgs>,
    revisions_scenario_correlations_journal_aggregate?: GraphCacheUpdateResolver<{ revisions_scenario_correlations_journal_aggregate: WithTypename<Revisions_Scenario_Correlations_Journal_Aggregate> }, Subscription_RootRevisions_Scenario_Correlations_Journal_AggregateArgs>,
    revisions_scenario_correlations_journal_by_pk?: GraphCacheUpdateResolver<{ revisions_scenario_correlations_journal_by_pk: Maybe<WithTypename<Revisions_Scenario_Correlations_Journal>> }, Subscription_RootRevisions_Scenario_Correlations_Journal_By_PkArgs>,
    revisions_scenario_correlations_journal_stream?: GraphCacheUpdateResolver<{ revisions_scenario_correlations_journal_stream: Array<WithTypename<Revisions_Scenario_Correlations_Journal>> }, Subscription_RootRevisions_Scenario_Correlations_Journal_StreamArgs>,
    revisions_scenario_correlations_revisions?: GraphCacheUpdateResolver<{ revisions_scenario_correlations_revisions: Array<WithTypename<Revisions_Scenario_Correlations_Revisions>> }, Subscription_RootRevisions_Scenario_Correlations_RevisionsArgs>,
    revisions_scenario_correlations_revisions_aggregate?: GraphCacheUpdateResolver<{ revisions_scenario_correlations_revisions_aggregate: WithTypename<Revisions_Scenario_Correlations_Revisions_Aggregate> }, Subscription_RootRevisions_Scenario_Correlations_Revisions_AggregateArgs>,
    revisions_scenario_correlations_revisions_by_pk?: GraphCacheUpdateResolver<{ revisions_scenario_correlations_revisions_by_pk: Maybe<WithTypename<Revisions_Scenario_Correlations_Revisions>> }, Subscription_RootRevisions_Scenario_Correlations_Revisions_By_PkArgs>,
    revisions_scenario_correlations_revisions_stream?: GraphCacheUpdateResolver<{ revisions_scenario_correlations_revisions_stream: Array<WithTypename<Revisions_Scenario_Correlations_Revisions>> }, Subscription_RootRevisions_Scenario_Correlations_Revisions_StreamArgs>,
    revisions_scenario_equipment_journal?: GraphCacheUpdateResolver<{ revisions_scenario_equipment_journal: Array<WithTypename<Revisions_Scenario_Equipment_Journal>> }, Subscription_RootRevisions_Scenario_Equipment_JournalArgs>,
    revisions_scenario_equipment_journal_aggregate?: GraphCacheUpdateResolver<{ revisions_scenario_equipment_journal_aggregate: WithTypename<Revisions_Scenario_Equipment_Journal_Aggregate> }, Subscription_RootRevisions_Scenario_Equipment_Journal_AggregateArgs>,
    revisions_scenario_equipment_journal_by_pk?: GraphCacheUpdateResolver<{ revisions_scenario_equipment_journal_by_pk: Maybe<WithTypename<Revisions_Scenario_Equipment_Journal>> }, Subscription_RootRevisions_Scenario_Equipment_Journal_By_PkArgs>,
    revisions_scenario_equipment_journal_stream?: GraphCacheUpdateResolver<{ revisions_scenario_equipment_journal_stream: Array<WithTypename<Revisions_Scenario_Equipment_Journal>> }, Subscription_RootRevisions_Scenario_Equipment_Journal_StreamArgs>,
    revisions_scenario_equipment_revisions?: GraphCacheUpdateResolver<{ revisions_scenario_equipment_revisions: Array<WithTypename<Revisions_Scenario_Equipment_Revisions>> }, Subscription_RootRevisions_Scenario_Equipment_RevisionsArgs>,
    revisions_scenario_equipment_revisions_aggregate?: GraphCacheUpdateResolver<{ revisions_scenario_equipment_revisions_aggregate: WithTypename<Revisions_Scenario_Equipment_Revisions_Aggregate> }, Subscription_RootRevisions_Scenario_Equipment_Revisions_AggregateArgs>,
    revisions_scenario_equipment_revisions_by_pk?: GraphCacheUpdateResolver<{ revisions_scenario_equipment_revisions_by_pk: Maybe<WithTypename<Revisions_Scenario_Equipment_Revisions>> }, Subscription_RootRevisions_Scenario_Equipment_Revisions_By_PkArgs>,
    revisions_scenario_equipment_revisions_stream?: GraphCacheUpdateResolver<{ revisions_scenario_equipment_revisions_stream: Array<WithTypename<Revisions_Scenario_Equipment_Revisions>> }, Subscription_RootRevisions_Scenario_Equipment_Revisions_StreamArgs>,
    revisions_scenario_equipment_xref_cables_journal?: GraphCacheUpdateResolver<{ revisions_scenario_equipment_xref_cables_journal: Array<WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Journal>> }, Subscription_RootRevisions_Scenario_Equipment_Xref_Cables_JournalArgs>,
    revisions_scenario_equipment_xref_cables_journal_aggregate?: GraphCacheUpdateResolver<{ revisions_scenario_equipment_xref_cables_journal_aggregate: WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Journal_Aggregate> }, Subscription_RootRevisions_Scenario_Equipment_Xref_Cables_Journal_AggregateArgs>,
    revisions_scenario_equipment_xref_cables_journal_by_pk?: GraphCacheUpdateResolver<{ revisions_scenario_equipment_xref_cables_journal_by_pk: Maybe<WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Journal>> }, Subscription_RootRevisions_Scenario_Equipment_Xref_Cables_Journal_By_PkArgs>,
    revisions_scenario_equipment_xref_cables_journal_stream?: GraphCacheUpdateResolver<{ revisions_scenario_equipment_xref_cables_journal_stream: Array<WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Journal>> }, Subscription_RootRevisions_Scenario_Equipment_Xref_Cables_Journal_StreamArgs>,
    revisions_scenario_equipment_xref_cables_revisions?: GraphCacheUpdateResolver<{ revisions_scenario_equipment_xref_cables_revisions: Array<WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Revisions>> }, Subscription_RootRevisions_Scenario_Equipment_Xref_Cables_RevisionsArgs>,
    revisions_scenario_equipment_xref_cables_revisions_aggregate?: GraphCacheUpdateResolver<{ revisions_scenario_equipment_xref_cables_revisions_aggregate: WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Revisions_Aggregate> }, Subscription_RootRevisions_Scenario_Equipment_Xref_Cables_Revisions_AggregateArgs>,
    revisions_scenario_equipment_xref_cables_revisions_by_pk?: GraphCacheUpdateResolver<{ revisions_scenario_equipment_xref_cables_revisions_by_pk: Maybe<WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Revisions>> }, Subscription_RootRevisions_Scenario_Equipment_Xref_Cables_Revisions_By_PkArgs>,
    revisions_scenario_equipment_xref_cables_revisions_stream?: GraphCacheUpdateResolver<{ revisions_scenario_equipment_xref_cables_revisions_stream: Array<WithTypename<Revisions_Scenario_Equipment_Xref_Cables_Revisions>> }, Subscription_RootRevisions_Scenario_Equipment_Xref_Cables_Revisions_StreamArgs>,
    revisions_scenario_equipment_xref_housings_journal?: GraphCacheUpdateResolver<{ revisions_scenario_equipment_xref_housings_journal: Array<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Journal>> }, Subscription_RootRevisions_Scenario_Equipment_Xref_Housings_JournalArgs>,
    revisions_scenario_equipment_xref_housings_journal_aggregate?: GraphCacheUpdateResolver<{ revisions_scenario_equipment_xref_housings_journal_aggregate: WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Journal_Aggregate> }, Subscription_RootRevisions_Scenario_Equipment_Xref_Housings_Journal_AggregateArgs>,
    revisions_scenario_equipment_xref_housings_journal_by_pk?: GraphCacheUpdateResolver<{ revisions_scenario_equipment_xref_housings_journal_by_pk: Maybe<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Journal>> }, Subscription_RootRevisions_Scenario_Equipment_Xref_Housings_Journal_By_PkArgs>,
    revisions_scenario_equipment_xref_housings_journal_stream?: GraphCacheUpdateResolver<{ revisions_scenario_equipment_xref_housings_journal_stream: Array<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Journal>> }, Subscription_RootRevisions_Scenario_Equipment_Xref_Housings_Journal_StreamArgs>,
    revisions_scenario_equipment_xref_housings_revisions?: GraphCacheUpdateResolver<{ revisions_scenario_equipment_xref_housings_revisions: Array<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Revisions>> }, Subscription_RootRevisions_Scenario_Equipment_Xref_Housings_RevisionsArgs>,
    revisions_scenario_equipment_xref_housings_revisions_aggregate?: GraphCacheUpdateResolver<{ revisions_scenario_equipment_xref_housings_revisions_aggregate: WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Revisions_Aggregate> }, Subscription_RootRevisions_Scenario_Equipment_Xref_Housings_Revisions_AggregateArgs>,
    revisions_scenario_equipment_xref_housings_revisions_by_pk?: GraphCacheUpdateResolver<{ revisions_scenario_equipment_xref_housings_revisions_by_pk: Maybe<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Revisions>> }, Subscription_RootRevisions_Scenario_Equipment_Xref_Housings_Revisions_By_PkArgs>,
    revisions_scenario_equipment_xref_housings_revisions_stream?: GraphCacheUpdateResolver<{ revisions_scenario_equipment_xref_housings_revisions_stream: Array<WithTypename<Revisions_Scenario_Equipment_Xref_Housings_Revisions>> }, Subscription_RootRevisions_Scenario_Equipment_Xref_Housings_Revisions_StreamArgs>,
    revisions_scenario_equipment_xref_intakes_journal?: GraphCacheUpdateResolver<{ revisions_scenario_equipment_xref_intakes_journal: Array<WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Journal>> }, Subscription_RootRevisions_Scenario_Equipment_Xref_Intakes_JournalArgs>,
    revisions_scenario_equipment_xref_intakes_journal_aggregate?: GraphCacheUpdateResolver<{ revisions_scenario_equipment_xref_intakes_journal_aggregate: WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Journal_Aggregate> }, Subscription_RootRevisions_Scenario_Equipment_Xref_Intakes_Journal_AggregateArgs>,
    revisions_scenario_equipment_xref_intakes_journal_by_pk?: GraphCacheUpdateResolver<{ revisions_scenario_equipment_xref_intakes_journal_by_pk: Maybe<WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Journal>> }, Subscription_RootRevisions_Scenario_Equipment_Xref_Intakes_Journal_By_PkArgs>,
    revisions_scenario_equipment_xref_intakes_journal_stream?: GraphCacheUpdateResolver<{ revisions_scenario_equipment_xref_intakes_journal_stream: Array<WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Journal>> }, Subscription_RootRevisions_Scenario_Equipment_Xref_Intakes_Journal_StreamArgs>,
    revisions_scenario_equipment_xref_intakes_revisions?: GraphCacheUpdateResolver<{ revisions_scenario_equipment_xref_intakes_revisions: Array<WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Revisions>> }, Subscription_RootRevisions_Scenario_Equipment_Xref_Intakes_RevisionsArgs>,
    revisions_scenario_equipment_xref_intakes_revisions_aggregate?: GraphCacheUpdateResolver<{ revisions_scenario_equipment_xref_intakes_revisions_aggregate: WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Revisions_Aggregate> }, Subscription_RootRevisions_Scenario_Equipment_Xref_Intakes_Revisions_AggregateArgs>,
    revisions_scenario_equipment_xref_intakes_revisions_by_pk?: GraphCacheUpdateResolver<{ revisions_scenario_equipment_xref_intakes_revisions_by_pk: Maybe<WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Revisions>> }, Subscription_RootRevisions_Scenario_Equipment_Xref_Intakes_Revisions_By_PkArgs>,
    revisions_scenario_equipment_xref_intakes_revisions_stream?: GraphCacheUpdateResolver<{ revisions_scenario_equipment_xref_intakes_revisions_stream: Array<WithTypename<Revisions_Scenario_Equipment_Xref_Intakes_Revisions>> }, Subscription_RootRevisions_Scenario_Equipment_Xref_Intakes_Revisions_StreamArgs>,
    revisions_scenario_equipment_xref_pumps_journal?: GraphCacheUpdateResolver<{ revisions_scenario_equipment_xref_pumps_journal: Array<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Journal>> }, Subscription_RootRevisions_Scenario_Equipment_Xref_Pumps_JournalArgs>,
    revisions_scenario_equipment_xref_pumps_journal_aggregate?: GraphCacheUpdateResolver<{ revisions_scenario_equipment_xref_pumps_journal_aggregate: WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Journal_Aggregate> }, Subscription_RootRevisions_Scenario_Equipment_Xref_Pumps_Journal_AggregateArgs>,
    revisions_scenario_equipment_xref_pumps_journal_by_pk?: GraphCacheUpdateResolver<{ revisions_scenario_equipment_xref_pumps_journal_by_pk: Maybe<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Journal>> }, Subscription_RootRevisions_Scenario_Equipment_Xref_Pumps_Journal_By_PkArgs>,
    revisions_scenario_equipment_xref_pumps_journal_stream?: GraphCacheUpdateResolver<{ revisions_scenario_equipment_xref_pumps_journal_stream: Array<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Journal>> }, Subscription_RootRevisions_Scenario_Equipment_Xref_Pumps_Journal_StreamArgs>,
    revisions_scenario_equipment_xref_pumps_revisions?: GraphCacheUpdateResolver<{ revisions_scenario_equipment_xref_pumps_revisions: Array<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions>> }, Subscription_RootRevisions_Scenario_Equipment_Xref_Pumps_RevisionsArgs>,
    revisions_scenario_equipment_xref_pumps_revisions_aggregate?: GraphCacheUpdateResolver<{ revisions_scenario_equipment_xref_pumps_revisions_aggregate: WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions_Aggregate> }, Subscription_RootRevisions_Scenario_Equipment_Xref_Pumps_Revisions_AggregateArgs>,
    revisions_scenario_equipment_xref_pumps_revisions_by_pk?: GraphCacheUpdateResolver<{ revisions_scenario_equipment_xref_pumps_revisions_by_pk: Maybe<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions>> }, Subscription_RootRevisions_Scenario_Equipment_Xref_Pumps_Revisions_By_PkArgs>,
    revisions_scenario_equipment_xref_pumps_revisions_stream?: GraphCacheUpdateResolver<{ revisions_scenario_equipment_xref_pumps_revisions_stream: Array<WithTypename<Revisions_Scenario_Equipment_Xref_Pumps_Revisions>> }, Subscription_RootRevisions_Scenario_Equipment_Xref_Pumps_Revisions_StreamArgs>,
    revisions_scenario_equipment_xref_seals_journal?: GraphCacheUpdateResolver<{ revisions_scenario_equipment_xref_seals_journal: Array<WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Journal>> }, Subscription_RootRevisions_Scenario_Equipment_Xref_Seals_JournalArgs>,
    revisions_scenario_equipment_xref_seals_journal_aggregate?: GraphCacheUpdateResolver<{ revisions_scenario_equipment_xref_seals_journal_aggregate: WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Journal_Aggregate> }, Subscription_RootRevisions_Scenario_Equipment_Xref_Seals_Journal_AggregateArgs>,
    revisions_scenario_equipment_xref_seals_journal_by_pk?: GraphCacheUpdateResolver<{ revisions_scenario_equipment_xref_seals_journal_by_pk: Maybe<WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Journal>> }, Subscription_RootRevisions_Scenario_Equipment_Xref_Seals_Journal_By_PkArgs>,
    revisions_scenario_equipment_xref_seals_journal_stream?: GraphCacheUpdateResolver<{ revisions_scenario_equipment_xref_seals_journal_stream: Array<WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Journal>> }, Subscription_RootRevisions_Scenario_Equipment_Xref_Seals_Journal_StreamArgs>,
    revisions_scenario_equipment_xref_seals_revisions?: GraphCacheUpdateResolver<{ revisions_scenario_equipment_xref_seals_revisions: Array<WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Revisions>> }, Subscription_RootRevisions_Scenario_Equipment_Xref_Seals_RevisionsArgs>,
    revisions_scenario_equipment_xref_seals_revisions_aggregate?: GraphCacheUpdateResolver<{ revisions_scenario_equipment_xref_seals_revisions_aggregate: WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Revisions_Aggregate> }, Subscription_RootRevisions_Scenario_Equipment_Xref_Seals_Revisions_AggregateArgs>,
    revisions_scenario_equipment_xref_seals_revisions_by_pk?: GraphCacheUpdateResolver<{ revisions_scenario_equipment_xref_seals_revisions_by_pk: Maybe<WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Revisions>> }, Subscription_RootRevisions_Scenario_Equipment_Xref_Seals_Revisions_By_PkArgs>,
    revisions_scenario_equipment_xref_seals_revisions_stream?: GraphCacheUpdateResolver<{ revisions_scenario_equipment_xref_seals_revisions_stream: Array<WithTypename<Revisions_Scenario_Equipment_Xref_Seals_Revisions>> }, Subscription_RootRevisions_Scenario_Equipment_Xref_Seals_Revisions_StreamArgs>,
    revisions_scenario_parameters_journal?: GraphCacheUpdateResolver<{ revisions_scenario_parameters_journal: Array<WithTypename<Revisions_Scenario_Parameters_Journal>> }, Subscription_RootRevisions_Scenario_Parameters_JournalArgs>,
    revisions_scenario_parameters_journal_aggregate?: GraphCacheUpdateResolver<{ revisions_scenario_parameters_journal_aggregate: WithTypename<Revisions_Scenario_Parameters_Journal_Aggregate> }, Subscription_RootRevisions_Scenario_Parameters_Journal_AggregateArgs>,
    revisions_scenario_parameters_journal_by_pk?: GraphCacheUpdateResolver<{ revisions_scenario_parameters_journal_by_pk: Maybe<WithTypename<Revisions_Scenario_Parameters_Journal>> }, Subscription_RootRevisions_Scenario_Parameters_Journal_By_PkArgs>,
    revisions_scenario_parameters_journal_stream?: GraphCacheUpdateResolver<{ revisions_scenario_parameters_journal_stream: Array<WithTypename<Revisions_Scenario_Parameters_Journal>> }, Subscription_RootRevisions_Scenario_Parameters_Journal_StreamArgs>,
    revisions_scenario_parameters_revisions?: GraphCacheUpdateResolver<{ revisions_scenario_parameters_revisions: Array<WithTypename<Revisions_Scenario_Parameters_Revisions>> }, Subscription_RootRevisions_Scenario_Parameters_RevisionsArgs>,
    revisions_scenario_parameters_revisions_aggregate?: GraphCacheUpdateResolver<{ revisions_scenario_parameters_revisions_aggregate: WithTypename<Revisions_Scenario_Parameters_Revisions_Aggregate> }, Subscription_RootRevisions_Scenario_Parameters_Revisions_AggregateArgs>,
    revisions_scenario_parameters_revisions_by_pk?: GraphCacheUpdateResolver<{ revisions_scenario_parameters_revisions_by_pk: Maybe<WithTypename<Revisions_Scenario_Parameters_Revisions>> }, Subscription_RootRevisions_Scenario_Parameters_Revisions_By_PkArgs>,
    revisions_scenario_parameters_revisions_stream?: GraphCacheUpdateResolver<{ revisions_scenario_parameters_revisions_stream: Array<WithTypename<Revisions_Scenario_Parameters_Revisions>> }, Subscription_RootRevisions_Scenario_Parameters_Revisions_StreamArgs>,
    revisions_scenario_well_properties_journal?: GraphCacheUpdateResolver<{ revisions_scenario_well_properties_journal: Array<WithTypename<Revisions_Scenario_Well_Properties_Journal>> }, Subscription_RootRevisions_Scenario_Well_Properties_JournalArgs>,
    revisions_scenario_well_properties_journal_aggregate?: GraphCacheUpdateResolver<{ revisions_scenario_well_properties_journal_aggregate: WithTypename<Revisions_Scenario_Well_Properties_Journal_Aggregate> }, Subscription_RootRevisions_Scenario_Well_Properties_Journal_AggregateArgs>,
    revisions_scenario_well_properties_journal_by_pk?: GraphCacheUpdateResolver<{ revisions_scenario_well_properties_journal_by_pk: Maybe<WithTypename<Revisions_Scenario_Well_Properties_Journal>> }, Subscription_RootRevisions_Scenario_Well_Properties_Journal_By_PkArgs>,
    revisions_scenario_well_properties_journal_stream?: GraphCacheUpdateResolver<{ revisions_scenario_well_properties_journal_stream: Array<WithTypename<Revisions_Scenario_Well_Properties_Journal>> }, Subscription_RootRevisions_Scenario_Well_Properties_Journal_StreamArgs>,
    revisions_scenario_well_properties_revisions?: GraphCacheUpdateResolver<{ revisions_scenario_well_properties_revisions: Array<WithTypename<Revisions_Scenario_Well_Properties_Revisions>> }, Subscription_RootRevisions_Scenario_Well_Properties_RevisionsArgs>,
    revisions_scenario_well_properties_revisions_aggregate?: GraphCacheUpdateResolver<{ revisions_scenario_well_properties_revisions_aggregate: WithTypename<Revisions_Scenario_Well_Properties_Revisions_Aggregate> }, Subscription_RootRevisions_Scenario_Well_Properties_Revisions_AggregateArgs>,
    revisions_scenario_well_properties_revisions_by_pk?: GraphCacheUpdateResolver<{ revisions_scenario_well_properties_revisions_by_pk: Maybe<WithTypename<Revisions_Scenario_Well_Properties_Revisions>> }, Subscription_RootRevisions_Scenario_Well_Properties_Revisions_By_PkArgs>,
    revisions_scenario_well_properties_revisions_stream?: GraphCacheUpdateResolver<{ revisions_scenario_well_properties_revisions_stream: Array<WithTypename<Revisions_Scenario_Well_Properties_Revisions>> }, Subscription_RootRevisions_Scenario_Well_Properties_Revisions_StreamArgs>,
    revisions_scenarios_journal?: GraphCacheUpdateResolver<{ revisions_scenarios_journal: Array<WithTypename<Revisions_Scenarios_Journal>> }, Subscription_RootRevisions_Scenarios_JournalArgs>,
    revisions_scenarios_journal_aggregate?: GraphCacheUpdateResolver<{ revisions_scenarios_journal_aggregate: WithTypename<Revisions_Scenarios_Journal_Aggregate> }, Subscription_RootRevisions_Scenarios_Journal_AggregateArgs>,
    revisions_scenarios_journal_by_pk?: GraphCacheUpdateResolver<{ revisions_scenarios_journal_by_pk: Maybe<WithTypename<Revisions_Scenarios_Journal>> }, Subscription_RootRevisions_Scenarios_Journal_By_PkArgs>,
    revisions_scenarios_journal_stream?: GraphCacheUpdateResolver<{ revisions_scenarios_journal_stream: Array<WithTypename<Revisions_Scenarios_Journal>> }, Subscription_RootRevisions_Scenarios_Journal_StreamArgs>,
    revisions_scenarios_revisions?: GraphCacheUpdateResolver<{ revisions_scenarios_revisions: Array<WithTypename<Revisions_Scenarios_Revisions>> }, Subscription_RootRevisions_Scenarios_RevisionsArgs>,
    revisions_scenarios_revisions_aggregate?: GraphCacheUpdateResolver<{ revisions_scenarios_revisions_aggregate: WithTypename<Revisions_Scenarios_Revisions_Aggregate> }, Subscription_RootRevisions_Scenarios_Revisions_AggregateArgs>,
    revisions_scenarios_revisions_by_pk?: GraphCacheUpdateResolver<{ revisions_scenarios_revisions_by_pk: Maybe<WithTypename<Revisions_Scenarios_Revisions>> }, Subscription_RootRevisions_Scenarios_Revisions_By_PkArgs>,
    revisions_scenarios_revisions_stream?: GraphCacheUpdateResolver<{ revisions_scenarios_revisions_stream: Array<WithTypename<Revisions_Scenarios_Revisions>> }, Subscription_RootRevisions_Scenarios_Revisions_StreamArgs>,
    revisions_sizings_journal?: GraphCacheUpdateResolver<{ revisions_sizings_journal: Array<WithTypename<Revisions_Sizings_Journal>> }, Subscription_RootRevisions_Sizings_JournalArgs>,
    revisions_sizings_journal_aggregate?: GraphCacheUpdateResolver<{ revisions_sizings_journal_aggregate: WithTypename<Revisions_Sizings_Journal_Aggregate> }, Subscription_RootRevisions_Sizings_Journal_AggregateArgs>,
    revisions_sizings_journal_by_pk?: GraphCacheUpdateResolver<{ revisions_sizings_journal_by_pk: Maybe<WithTypename<Revisions_Sizings_Journal>> }, Subscription_RootRevisions_Sizings_Journal_By_PkArgs>,
    revisions_sizings_journal_stream?: GraphCacheUpdateResolver<{ revisions_sizings_journal_stream: Array<WithTypename<Revisions_Sizings_Journal>> }, Subscription_RootRevisions_Sizings_Journal_StreamArgs>,
    revisions_sizings_revisions?: GraphCacheUpdateResolver<{ revisions_sizings_revisions: Array<WithTypename<Revisions_Sizings_Revisions>> }, Subscription_RootRevisions_Sizings_RevisionsArgs>,
    revisions_sizings_revisions_aggregate?: GraphCacheUpdateResolver<{ revisions_sizings_revisions_aggregate: WithTypename<Revisions_Sizings_Revisions_Aggregate> }, Subscription_RootRevisions_Sizings_Revisions_AggregateArgs>,
    revisions_sizings_revisions_by_pk?: GraphCacheUpdateResolver<{ revisions_sizings_revisions_by_pk: Maybe<WithTypename<Revisions_Sizings_Revisions>> }, Subscription_RootRevisions_Sizings_Revisions_By_PkArgs>,
    revisions_sizings_revisions_stream?: GraphCacheUpdateResolver<{ revisions_sizings_revisions_stream: Array<WithTypename<Revisions_Sizings_Revisions>> }, Subscription_RootRevisions_Sizings_Revisions_StreamArgs>,
    saturated_oil_options?: GraphCacheUpdateResolver<{ saturated_oil_options: Array<WithTypename<Saturated_Oil_Options>> }, Subscription_RootSaturated_Oil_OptionsArgs>,
    saturated_oil_options_aggregate?: GraphCacheUpdateResolver<{ saturated_oil_options_aggregate: WithTypename<Saturated_Oil_Options_Aggregate> }, Subscription_RootSaturated_Oil_Options_AggregateArgs>,
    saturated_oil_options_by_pk?: GraphCacheUpdateResolver<{ saturated_oil_options_by_pk: Maybe<WithTypename<Saturated_Oil_Options>> }, Subscription_RootSaturated_Oil_Options_By_PkArgs>,
    saturated_oil_options_stream?: GraphCacheUpdateResolver<{ saturated_oil_options_stream: Array<WithTypename<Saturated_Oil_Options>> }, Subscription_RootSaturated_Oil_Options_StreamArgs>,
    sc_equip_xref_downhole_ytool_bypass_tubings?: GraphCacheUpdateResolver<{ sc_equip_xref_downhole_ytool_bypass_tubings: Array<WithTypename<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings>> }, Subscription_RootSc_Equip_Xref_Downhole_Ytool_Bypass_TubingsArgs>,
    sc_equip_xref_downhole_ytool_bypass_tubings_aggregate?: GraphCacheUpdateResolver<{ sc_equip_xref_downhole_ytool_bypass_tubings_aggregate: WithTypename<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_Aggregate> }, Subscription_RootSc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_AggregateArgs>,
    sc_equip_xref_downhole_ytool_bypass_tubings_stream?: GraphCacheUpdateResolver<{ sc_equip_xref_downhole_ytool_bypass_tubings_stream: Array<WithTypename<Sc_Equip_Xref_Downhole_Ytool_Bypass_Tubings>> }, Subscription_RootSc_Equip_Xref_Downhole_Ytool_Bypass_Tubings_StreamArgs>,
    sc_equip_xref_downhole_ytool_equip_tubings?: GraphCacheUpdateResolver<{ sc_equip_xref_downhole_ytool_equip_tubings: Array<WithTypename<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings>> }, Subscription_RootSc_Equip_Xref_Downhole_Ytool_Equip_TubingsArgs>,
    sc_equip_xref_downhole_ytool_equip_tubings_aggregate?: GraphCacheUpdateResolver<{ sc_equip_xref_downhole_ytool_equip_tubings_aggregate: WithTypename<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings_Aggregate> }, Subscription_RootSc_Equip_Xref_Downhole_Ytool_Equip_Tubings_AggregateArgs>,
    sc_equip_xref_downhole_ytool_equip_tubings_stream?: GraphCacheUpdateResolver<{ sc_equip_xref_downhole_ytool_equip_tubings_stream: Array<WithTypename<Sc_Equip_Xref_Downhole_Ytool_Equip_Tubings>> }, Subscription_RootSc_Equip_Xref_Downhole_Ytool_Equip_Tubings_StreamArgs>,
    sc_equip_xref_uphole_ytool_bypass_tubings?: GraphCacheUpdateResolver<{ sc_equip_xref_uphole_ytool_bypass_tubings: Array<WithTypename<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings>> }, Subscription_RootSc_Equip_Xref_Uphole_Ytool_Bypass_TubingsArgs>,
    sc_equip_xref_uphole_ytool_bypass_tubings_aggregate?: GraphCacheUpdateResolver<{ sc_equip_xref_uphole_ytool_bypass_tubings_aggregate: WithTypename<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_Aggregate> }, Subscription_RootSc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_AggregateArgs>,
    sc_equip_xref_uphole_ytool_bypass_tubings_stream?: GraphCacheUpdateResolver<{ sc_equip_xref_uphole_ytool_bypass_tubings_stream: Array<WithTypename<Sc_Equip_Xref_Uphole_Ytool_Bypass_Tubings>> }, Subscription_RootSc_Equip_Xref_Uphole_Ytool_Bypass_Tubings_StreamArgs>,
    sc_equip_xref_uphole_ytool_equip_tubings?: GraphCacheUpdateResolver<{ sc_equip_xref_uphole_ytool_equip_tubings: Array<WithTypename<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings>> }, Subscription_RootSc_Equip_Xref_Uphole_Ytool_Equip_TubingsArgs>,
    sc_equip_xref_uphole_ytool_equip_tubings_aggregate?: GraphCacheUpdateResolver<{ sc_equip_xref_uphole_ytool_equip_tubings_aggregate: WithTypename<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings_Aggregate> }, Subscription_RootSc_Equip_Xref_Uphole_Ytool_Equip_Tubings_AggregateArgs>,
    sc_equip_xref_uphole_ytool_equip_tubings_stream?: GraphCacheUpdateResolver<{ sc_equip_xref_uphole_ytool_equip_tubings_stream: Array<WithTypename<Sc_Equip_Xref_Uphole_Ytool_Equip_Tubings>> }, Subscription_RootSc_Equip_Xref_Uphole_Ytool_Equip_Tubings_StreamArgs>,
    scenario_correlations?: GraphCacheUpdateResolver<{ scenario_correlations: Array<WithTypename<Scenario_Correlations>> }, Subscription_RootScenario_CorrelationsArgs>,
    scenario_correlations_aggregate?: GraphCacheUpdateResolver<{ scenario_correlations_aggregate: WithTypename<Scenario_Correlations_Aggregate> }, Subscription_RootScenario_Correlations_AggregateArgs>,
    scenario_correlations_stream?: GraphCacheUpdateResolver<{ scenario_correlations_stream: Array<WithTypename<Scenario_Correlations>> }, Subscription_RootScenario_Correlations_StreamArgs>,
    scenario_equipment?: GraphCacheUpdateResolver<{ scenario_equipment: Array<WithTypename<Scenario_Equipment>> }, Subscription_RootScenario_EquipmentArgs>,
    scenario_equipment_aggregate?: GraphCacheUpdateResolver<{ scenario_equipment_aggregate: WithTypename<Scenario_Equipment_Aggregate> }, Subscription_RootScenario_Equipment_AggregateArgs>,
    scenario_equipment_stream?: GraphCacheUpdateResolver<{ scenario_equipment_stream: Array<WithTypename<Scenario_Equipment>> }, Subscription_RootScenario_Equipment_StreamArgs>,
    scenario_equipment_xref_cables?: GraphCacheUpdateResolver<{ scenario_equipment_xref_cables: Array<WithTypename<Scenario_Equipment_Xref_Cables>> }, Subscription_RootScenario_Equipment_Xref_CablesArgs>,
    scenario_equipment_xref_cables_aggregate?: GraphCacheUpdateResolver<{ scenario_equipment_xref_cables_aggregate: WithTypename<Scenario_Equipment_Xref_Cables_Aggregate> }, Subscription_RootScenario_Equipment_Xref_Cables_AggregateArgs>,
    scenario_equipment_xref_cables_stream?: GraphCacheUpdateResolver<{ scenario_equipment_xref_cables_stream: Array<WithTypename<Scenario_Equipment_Xref_Cables>> }, Subscription_RootScenario_Equipment_Xref_Cables_StreamArgs>,
    scenario_equipment_xref_housings?: GraphCacheUpdateResolver<{ scenario_equipment_xref_housings: Array<WithTypename<Scenario_Equipment_Xref_Housings>> }, Subscription_RootScenario_Equipment_Xref_HousingsArgs>,
    scenario_equipment_xref_housings_aggregate?: GraphCacheUpdateResolver<{ scenario_equipment_xref_housings_aggregate: WithTypename<Scenario_Equipment_Xref_Housings_Aggregate> }, Subscription_RootScenario_Equipment_Xref_Housings_AggregateArgs>,
    scenario_equipment_xref_housings_stream?: GraphCacheUpdateResolver<{ scenario_equipment_xref_housings_stream: Array<WithTypename<Scenario_Equipment_Xref_Housings>> }, Subscription_RootScenario_Equipment_Xref_Housings_StreamArgs>,
    scenario_equipment_xref_intakes?: GraphCacheUpdateResolver<{ scenario_equipment_xref_intakes: Array<WithTypename<Scenario_Equipment_Xref_Intakes>> }, Subscription_RootScenario_Equipment_Xref_IntakesArgs>,
    scenario_equipment_xref_intakes_aggregate?: GraphCacheUpdateResolver<{ scenario_equipment_xref_intakes_aggregate: WithTypename<Scenario_Equipment_Xref_Intakes_Aggregate> }, Subscription_RootScenario_Equipment_Xref_Intakes_AggregateArgs>,
    scenario_equipment_xref_intakes_stream?: GraphCacheUpdateResolver<{ scenario_equipment_xref_intakes_stream: Array<WithTypename<Scenario_Equipment_Xref_Intakes>> }, Subscription_RootScenario_Equipment_Xref_Intakes_StreamArgs>,
    scenario_equipment_xref_pumps?: GraphCacheUpdateResolver<{ scenario_equipment_xref_pumps: Array<WithTypename<Scenario_Equipment_Xref_Pumps>> }, Subscription_RootScenario_Equipment_Xref_PumpsArgs>,
    scenario_equipment_xref_pumps_aggregate?: GraphCacheUpdateResolver<{ scenario_equipment_xref_pumps_aggregate: WithTypename<Scenario_Equipment_Xref_Pumps_Aggregate> }, Subscription_RootScenario_Equipment_Xref_Pumps_AggregateArgs>,
    scenario_equipment_xref_pumps_stream?: GraphCacheUpdateResolver<{ scenario_equipment_xref_pumps_stream: Array<WithTypename<Scenario_Equipment_Xref_Pumps>> }, Subscription_RootScenario_Equipment_Xref_Pumps_StreamArgs>,
    scenario_equipment_xref_seals?: GraphCacheUpdateResolver<{ scenario_equipment_xref_seals: Array<WithTypename<Scenario_Equipment_Xref_Seals>> }, Subscription_RootScenario_Equipment_Xref_SealsArgs>,
    scenario_equipment_xref_seals_aggregate?: GraphCacheUpdateResolver<{ scenario_equipment_xref_seals_aggregate: WithTypename<Scenario_Equipment_Xref_Seals_Aggregate> }, Subscription_RootScenario_Equipment_Xref_Seals_AggregateArgs>,
    scenario_equipment_xref_seals_stream?: GraphCacheUpdateResolver<{ scenario_equipment_xref_seals_stream: Array<WithTypename<Scenario_Equipment_Xref_Seals>> }, Subscription_RootScenario_Equipment_Xref_Seals_StreamArgs>,
    scenario_parameters?: GraphCacheUpdateResolver<{ scenario_parameters: Array<WithTypename<Scenario_Parameters>> }, Subscription_RootScenario_ParametersArgs>,
    scenario_parameters_aggregate?: GraphCacheUpdateResolver<{ scenario_parameters_aggregate: WithTypename<Scenario_Parameters_Aggregate> }, Subscription_RootScenario_Parameters_AggregateArgs>,
    scenario_parameters_stream?: GraphCacheUpdateResolver<{ scenario_parameters_stream: Array<WithTypename<Scenario_Parameters>> }, Subscription_RootScenario_Parameters_StreamArgs>,
    scenario_reasons?: GraphCacheUpdateResolver<{ scenario_reasons: Array<WithTypename<Scenario_Reasons>> }, Subscription_RootScenario_ReasonsArgs>,
    scenario_reasons_aggregate?: GraphCacheUpdateResolver<{ scenario_reasons_aggregate: WithTypename<Scenario_Reasons_Aggregate> }, Subscription_RootScenario_Reasons_AggregateArgs>,
    scenario_reasons_by_pk?: GraphCacheUpdateResolver<{ scenario_reasons_by_pk: Maybe<WithTypename<Scenario_Reasons>> }, Subscription_RootScenario_Reasons_By_PkArgs>,
    scenario_reasons_stream?: GraphCacheUpdateResolver<{ scenario_reasons_stream: Array<WithTypename<Scenario_Reasons>> }, Subscription_RootScenario_Reasons_StreamArgs>,
    scenario_well_properties?: GraphCacheUpdateResolver<{ scenario_well_properties: Array<WithTypename<Scenario_Well_Properties>> }, Subscription_RootScenario_Well_PropertiesArgs>,
    scenario_well_properties_aggregate?: GraphCacheUpdateResolver<{ scenario_well_properties_aggregate: WithTypename<Scenario_Well_Properties_Aggregate> }, Subscription_RootScenario_Well_Properties_AggregateArgs>,
    scenario_well_properties_stream?: GraphCacheUpdateResolver<{ scenario_well_properties_stream: Array<WithTypename<Scenario_Well_Properties>> }, Subscription_RootScenario_Well_Properties_StreamArgs>,
    scenarios?: GraphCacheUpdateResolver<{ scenarios: Array<WithTypename<Scenarios>> }, Subscription_RootScenariosArgs>,
    scenarios_aggregate?: GraphCacheUpdateResolver<{ scenarios_aggregate: WithTypename<Scenarios_Aggregate> }, Subscription_RootScenarios_AggregateArgs>,
    scenarios_stream?: GraphCacheUpdateResolver<{ scenarios_stream: Array<WithTypename<Scenarios>> }, Subscription_RootScenarios_StreamArgs>,
    seal_motor_oil?: GraphCacheUpdateResolver<{ seal_motor_oil: Array<WithTypename<Seal_Motor_Oil>> }, Subscription_RootSeal_Motor_OilArgs>,
    seal_motor_oil_aggregate?: GraphCacheUpdateResolver<{ seal_motor_oil_aggregate: WithTypename<Seal_Motor_Oil_Aggregate> }, Subscription_RootSeal_Motor_Oil_AggregateArgs>,
    seal_motor_oil_by_pk?: GraphCacheUpdateResolver<{ seal_motor_oil_by_pk: Maybe<WithTypename<Seal_Motor_Oil>> }, Subscription_RootSeal_Motor_Oil_By_PkArgs>,
    seal_motor_oil_stream?: GraphCacheUpdateResolver<{ seal_motor_oil_stream: Array<WithTypename<Seal_Motor_Oil>> }, Subscription_RootSeal_Motor_Oil_StreamArgs>,
    seals?: GraphCacheUpdateResolver<{ seals: Array<WithTypename<Seals>> }, Subscription_RootSealsArgs>,
    seals_aggregate?: GraphCacheUpdateResolver<{ seals_aggregate: WithTypename<Seals_Aggregate> }, Subscription_RootSeals_AggregateArgs>,
    seals_by_pk?: GraphCacheUpdateResolver<{ seals_by_pk: Maybe<WithTypename<Seals>> }, Subscription_RootSeals_By_PkArgs>,
    seals_stream?: GraphCacheUpdateResolver<{ seals_stream: Array<WithTypename<Seals>> }, Subscription_RootSeals_StreamArgs>,
    sensors?: GraphCacheUpdateResolver<{ sensors: Array<WithTypename<Sensors>> }, Subscription_RootSensorsArgs>,
    sensors_aggregate?: GraphCacheUpdateResolver<{ sensors_aggregate: WithTypename<Sensors_Aggregate> }, Subscription_RootSensors_AggregateArgs>,
    sensors_by_pk?: GraphCacheUpdateResolver<{ sensors_by_pk: Maybe<WithTypename<Sensors>> }, Subscription_RootSensors_By_PkArgs>,
    sensors_stream?: GraphCacheUpdateResolver<{ sensors_stream: Array<WithTypename<Sensors>> }, Subscription_RootSensors_StreamArgs>,
    sizing_dispositions?: GraphCacheUpdateResolver<{ sizing_dispositions: Array<WithTypename<Sizing_Dispositions>> }, Subscription_RootSizing_DispositionsArgs>,
    sizing_dispositions_aggregate?: GraphCacheUpdateResolver<{ sizing_dispositions_aggregate: WithTypename<Sizing_Dispositions_Aggregate> }, Subscription_RootSizing_Dispositions_AggregateArgs>,
    sizing_dispositions_by_pk?: GraphCacheUpdateResolver<{ sizing_dispositions_by_pk: Maybe<WithTypename<Sizing_Dispositions>> }, Subscription_RootSizing_Dispositions_By_PkArgs>,
    sizing_dispositions_stream?: GraphCacheUpdateResolver<{ sizing_dispositions_stream: Array<WithTypename<Sizing_Dispositions>> }, Subscription_RootSizing_Dispositions_StreamArgs>,
    sizing_imports?: GraphCacheUpdateResolver<{ sizing_imports: Array<WithTypename<Sizing_Imports>> }, Subscription_RootSizing_ImportsArgs>,
    sizing_imports_aggregate?: GraphCacheUpdateResolver<{ sizing_imports_aggregate: WithTypename<Sizing_Imports_Aggregate> }, Subscription_RootSizing_Imports_AggregateArgs>,
    sizing_imports_by_pk?: GraphCacheUpdateResolver<{ sizing_imports_by_pk: Maybe<WithTypename<Sizing_Imports>> }, Subscription_RootSizing_Imports_By_PkArgs>,
    sizing_imports_stream?: GraphCacheUpdateResolver<{ sizing_imports_stream: Array<WithTypename<Sizing_Imports>> }, Subscription_RootSizing_Imports_StreamArgs>,
    sizing_pumping_type?: GraphCacheUpdateResolver<{ sizing_pumping_type: Array<WithTypename<Sizing_Pumping_Type>> }, Subscription_RootSizing_Pumping_TypeArgs>,
    sizing_pumping_type_aggregate?: GraphCacheUpdateResolver<{ sizing_pumping_type_aggregate: WithTypename<Sizing_Pumping_Type_Aggregate> }, Subscription_RootSizing_Pumping_Type_AggregateArgs>,
    sizing_pumping_type_by_pk?: GraphCacheUpdateResolver<{ sizing_pumping_type_by_pk: Maybe<WithTypename<Sizing_Pumping_Type>> }, Subscription_RootSizing_Pumping_Type_By_PkArgs>,
    sizing_pumping_type_stream?: GraphCacheUpdateResolver<{ sizing_pumping_type_stream: Array<WithTypename<Sizing_Pumping_Type>> }, Subscription_RootSizing_Pumping_Type_StreamArgs>,
    sizings?: GraphCacheUpdateResolver<{ sizings: Array<WithTypename<Sizings>> }, Subscription_RootSizingsArgs>,
    sizings_aggregate?: GraphCacheUpdateResolver<{ sizings_aggregate: WithTypename<Sizings_Aggregate> }, Subscription_RootSizings_AggregateArgs>,
    sizings_stream?: GraphCacheUpdateResolver<{ sizings_stream: Array<WithTypename<Sizings>> }, Subscription_RootSizings_StreamArgs>,
    solution_gas_oil_ratio_options?: GraphCacheUpdateResolver<{ solution_gas_oil_ratio_options: Array<WithTypename<Solution_Gas_Oil_Ratio_Options>> }, Subscription_RootSolution_Gas_Oil_Ratio_OptionsArgs>,
    solution_gas_oil_ratio_options_aggregate?: GraphCacheUpdateResolver<{ solution_gas_oil_ratio_options_aggregate: WithTypename<Solution_Gas_Oil_Ratio_Options_Aggregate> }, Subscription_RootSolution_Gas_Oil_Ratio_Options_AggregateArgs>,
    solution_gas_oil_ratio_options_by_pk?: GraphCacheUpdateResolver<{ solution_gas_oil_ratio_options_by_pk: Maybe<WithTypename<Solution_Gas_Oil_Ratio_Options>> }, Subscription_RootSolution_Gas_Oil_Ratio_Options_By_PkArgs>,
    solution_gas_oil_ratio_options_stream?: GraphCacheUpdateResolver<{ solution_gas_oil_ratio_options_stream: Array<WithTypename<Solution_Gas_Oil_Ratio_Options>> }, Subscription_RootSolution_Gas_Oil_Ratio_Options_StreamArgs>,
    status?: GraphCacheUpdateResolver<{ status: Array<WithTypename<Status>> }, Subscription_RootStatusArgs>,
    status_aggregate?: GraphCacheUpdateResolver<{ status_aggregate: WithTypename<Status_Aggregate> }, Subscription_RootStatus_AggregateArgs>,
    status_stream?: GraphCacheUpdateResolver<{ status_stream: Array<WithTypename<Status>> }, Subscription_RootStatus_StreamArgs>,
    step_down_transformers?: GraphCacheUpdateResolver<{ step_down_transformers: Array<WithTypename<Step_Down_Transformers>> }, Subscription_RootStep_Down_TransformersArgs>,
    step_down_transformers_aggregate?: GraphCacheUpdateResolver<{ step_down_transformers_aggregate: WithTypename<Step_Down_Transformers_Aggregate> }, Subscription_RootStep_Down_Transformers_AggregateArgs>,
    step_down_transformers_by_pk?: GraphCacheUpdateResolver<{ step_down_transformers_by_pk: Maybe<WithTypename<Step_Down_Transformers>> }, Subscription_RootStep_Down_Transformers_By_PkArgs>,
    step_down_transformers_stream?: GraphCacheUpdateResolver<{ step_down_transformers_stream: Array<WithTypename<Step_Down_Transformers>> }, Subscription_RootStep_Down_Transformers_StreamArgs>,
    step_up_transformers?: GraphCacheUpdateResolver<{ step_up_transformers: Array<WithTypename<Step_Up_Transformers>> }, Subscription_RootStep_Up_TransformersArgs>,
    step_up_transformers_aggregate?: GraphCacheUpdateResolver<{ step_up_transformers_aggregate: WithTypename<Step_Up_Transformers_Aggregate> }, Subscription_RootStep_Up_Transformers_AggregateArgs>,
    step_up_transformers_by_pk?: GraphCacheUpdateResolver<{ step_up_transformers_by_pk: Maybe<WithTypename<Step_Up_Transformers>> }, Subscription_RootStep_Up_Transformers_By_PkArgs>,
    step_up_transformers_stream?: GraphCacheUpdateResolver<{ step_up_transformers_stream: Array<WithTypename<Step_Up_Transformers>> }, Subscription_RootStep_Up_Transformers_StreamArgs>,
    switchboards?: GraphCacheUpdateResolver<{ switchboards: Array<WithTypename<Switchboards>> }, Subscription_RootSwitchboardsArgs>,
    switchboards_aggregate?: GraphCacheUpdateResolver<{ switchboards_aggregate: WithTypename<Switchboards_Aggregate> }, Subscription_RootSwitchboards_AggregateArgs>,
    switchboards_by_pk?: GraphCacheUpdateResolver<{ switchboards_by_pk: Maybe<WithTypename<Switchboards>> }, Subscription_RootSwitchboards_By_PkArgs>,
    switchboards_stream?: GraphCacheUpdateResolver<{ switchboards_stream: Array<WithTypename<Switchboards>> }, Subscription_RootSwitchboards_StreamArgs>,
    tubing_flow_options?: GraphCacheUpdateResolver<{ tubing_flow_options: Array<WithTypename<Tubing_Flow_Options>> }, Subscription_RootTubing_Flow_OptionsArgs>,
    tubing_flow_options_aggregate?: GraphCacheUpdateResolver<{ tubing_flow_options_aggregate: WithTypename<Tubing_Flow_Options_Aggregate> }, Subscription_RootTubing_Flow_Options_AggregateArgs>,
    tubing_flow_options_by_pk?: GraphCacheUpdateResolver<{ tubing_flow_options_by_pk: Maybe<WithTypename<Tubing_Flow_Options>> }, Subscription_RootTubing_Flow_Options_By_PkArgs>,
    tubing_flow_options_stream?: GraphCacheUpdateResolver<{ tubing_flow_options_stream: Array<WithTypename<Tubing_Flow_Options>> }, Subscription_RootTubing_Flow_Options_StreamArgs>,
    tubings?: GraphCacheUpdateResolver<{ tubings: Array<WithTypename<Tubings>> }, Subscription_RootTubingsArgs>,
    tubings_aggregate?: GraphCacheUpdateResolver<{ tubings_aggregate: WithTypename<Tubings_Aggregate> }, Subscription_RootTubings_AggregateArgs>,
    tubings_by_pk?: GraphCacheUpdateResolver<{ tubings_by_pk: Maybe<WithTypename<Tubings>> }, Subscription_RootTubings_By_PkArgs>,
    tubings_stream?: GraphCacheUpdateResolver<{ tubings_stream: Array<WithTypename<Tubings>> }, Subscription_RootTubings_StreamArgs>,
    tubings_type?: GraphCacheUpdateResolver<{ tubings_type: Array<WithTypename<Tubings_Type>> }, Subscription_RootTubings_TypeArgs>,
    tubings_type_aggregate?: GraphCacheUpdateResolver<{ tubings_type_aggregate: WithTypename<Tubings_Type_Aggregate> }, Subscription_RootTubings_Type_AggregateArgs>,
    tubings_type_by_pk?: GraphCacheUpdateResolver<{ tubings_type_by_pk: Maybe<WithTypename<Tubings_Type>> }, Subscription_RootTubings_Type_By_PkArgs>,
    tubings_type_stream?: GraphCacheUpdateResolver<{ tubings_type_stream: Array<WithTypename<Tubings_Type>> }, Subscription_RootTubings_Type_StreamArgs>,
    under_saturated_oil_options?: GraphCacheUpdateResolver<{ under_saturated_oil_options: Array<WithTypename<Under_Saturated_Oil_Options>> }, Subscription_RootUnder_Saturated_Oil_OptionsArgs>,
    under_saturated_oil_options_aggregate?: GraphCacheUpdateResolver<{ under_saturated_oil_options_aggregate: WithTypename<Under_Saturated_Oil_Options_Aggregate> }, Subscription_RootUnder_Saturated_Oil_Options_AggregateArgs>,
    under_saturated_oil_options_by_pk?: GraphCacheUpdateResolver<{ under_saturated_oil_options_by_pk: Maybe<WithTypename<Under_Saturated_Oil_Options>> }, Subscription_RootUnder_Saturated_Oil_Options_By_PkArgs>,
    under_saturated_oil_options_stream?: GraphCacheUpdateResolver<{ under_saturated_oil_options_stream: Array<WithTypename<Under_Saturated_Oil_Options>> }, Subscription_RootUnder_Saturated_Oil_Options_StreamArgs>,
    user_eula_acceptance?: GraphCacheUpdateResolver<{ user_eula_acceptance: Array<WithTypename<User_Eula_Acceptance>> }, Subscription_RootUser_Eula_AcceptanceArgs>,
    user_eula_acceptance_aggregate?: GraphCacheUpdateResolver<{ user_eula_acceptance_aggregate: WithTypename<User_Eula_Acceptance_Aggregate> }, Subscription_RootUser_Eula_Acceptance_AggregateArgs>,
    user_eula_acceptance_by_pk?: GraphCacheUpdateResolver<{ user_eula_acceptance_by_pk: Maybe<WithTypename<User_Eula_Acceptance>> }, Subscription_RootUser_Eula_Acceptance_By_PkArgs>,
    user_eula_acceptance_stream?: GraphCacheUpdateResolver<{ user_eula_acceptance_stream: Array<WithTypename<User_Eula_Acceptance>> }, Subscription_RootUser_Eula_Acceptance_StreamArgs>,
    users?: GraphCacheUpdateResolver<{ users: Array<WithTypename<Users>> }, Subscription_RootUsersArgs>,
    users_aggregate?: GraphCacheUpdateResolver<{ users_aggregate: WithTypename<Users_Aggregate> }, Subscription_RootUsers_AggregateArgs>,
    users_by_pk?: GraphCacheUpdateResolver<{ users_by_pk: Maybe<WithTypename<Users>> }, Subscription_RootUsers_By_PkArgs>,
    users_stream?: GraphCacheUpdateResolver<{ users_stream: Array<WithTypename<Users>> }, Subscription_RootUsers_StreamArgs>,
    variable_speed_drives?: GraphCacheUpdateResolver<{ variable_speed_drives: Array<WithTypename<Variable_Speed_Drives>> }, Subscription_RootVariable_Speed_DrivesArgs>,
    variable_speed_drives_aggregate?: GraphCacheUpdateResolver<{ variable_speed_drives_aggregate: WithTypename<Variable_Speed_Drives_Aggregate> }, Subscription_RootVariable_Speed_Drives_AggregateArgs>,
    variable_speed_drives_by_pk?: GraphCacheUpdateResolver<{ variable_speed_drives_by_pk: Maybe<WithTypename<Variable_Speed_Drives>> }, Subscription_RootVariable_Speed_Drives_By_PkArgs>,
    variable_speed_drives_stream?: GraphCacheUpdateResolver<{ variable_speed_drives_stream: Array<WithTypename<Variable_Speed_Drives>> }, Subscription_RootVariable_Speed_Drives_StreamArgs>,
    water_density_options?: GraphCacheUpdateResolver<{ water_density_options: Array<WithTypename<Water_Density_Options>> }, Subscription_RootWater_Density_OptionsArgs>,
    water_density_options_aggregate?: GraphCacheUpdateResolver<{ water_density_options_aggregate: WithTypename<Water_Density_Options_Aggregate> }, Subscription_RootWater_Density_Options_AggregateArgs>,
    water_density_options_by_pk?: GraphCacheUpdateResolver<{ water_density_options_by_pk: Maybe<WithTypename<Water_Density_Options>> }, Subscription_RootWater_Density_Options_By_PkArgs>,
    water_density_options_stream?: GraphCacheUpdateResolver<{ water_density_options_stream: Array<WithTypename<Water_Density_Options>> }, Subscription_RootWater_Density_Options_StreamArgs>,
    water_solution_gas_options?: GraphCacheUpdateResolver<{ water_solution_gas_options: Array<WithTypename<Water_Solution_Gas_Options>> }, Subscription_RootWater_Solution_Gas_OptionsArgs>,
    water_solution_gas_options_aggregate?: GraphCacheUpdateResolver<{ water_solution_gas_options_aggregate: WithTypename<Water_Solution_Gas_Options_Aggregate> }, Subscription_RootWater_Solution_Gas_Options_AggregateArgs>,
    water_solution_gas_options_by_pk?: GraphCacheUpdateResolver<{ water_solution_gas_options_by_pk: Maybe<WithTypename<Water_Solution_Gas_Options>> }, Subscription_RootWater_Solution_Gas_Options_By_PkArgs>,
    water_solution_gas_options_stream?: GraphCacheUpdateResolver<{ water_solution_gas_options_stream: Array<WithTypename<Water_Solution_Gas_Options>> }, Subscription_RootWater_Solution_Gas_Options_StreamArgs>,
    water_viscosity_options?: GraphCacheUpdateResolver<{ water_viscosity_options: Array<WithTypename<Water_Viscosity_Options>> }, Subscription_RootWater_Viscosity_OptionsArgs>,
    water_viscosity_options_aggregate?: GraphCacheUpdateResolver<{ water_viscosity_options_aggregate: WithTypename<Water_Viscosity_Options_Aggregate> }, Subscription_RootWater_Viscosity_Options_AggregateArgs>,
    water_viscosity_options_by_pk?: GraphCacheUpdateResolver<{ water_viscosity_options_by_pk: Maybe<WithTypename<Water_Viscosity_Options>> }, Subscription_RootWater_Viscosity_Options_By_PkArgs>,
    water_viscosity_options_stream?: GraphCacheUpdateResolver<{ water_viscosity_options_stream: Array<WithTypename<Water_Viscosity_Options>> }, Subscription_RootWater_Viscosity_Options_StreamArgs>,
    water_volume_factor_options?: GraphCacheUpdateResolver<{ water_volume_factor_options: Array<WithTypename<Water_Volume_Factor_Options>> }, Subscription_RootWater_Volume_Factor_OptionsArgs>,
    water_volume_factor_options_aggregate?: GraphCacheUpdateResolver<{ water_volume_factor_options_aggregate: WithTypename<Water_Volume_Factor_Options_Aggregate> }, Subscription_RootWater_Volume_Factor_Options_AggregateArgs>,
    water_volume_factor_options_by_pk?: GraphCacheUpdateResolver<{ water_volume_factor_options_by_pk: Maybe<WithTypename<Water_Volume_Factor_Options>> }, Subscription_RootWater_Volume_Factor_Options_By_PkArgs>,
    water_volume_factor_options_stream?: GraphCacheUpdateResolver<{ water_volume_factor_options_stream: Array<WithTypename<Water_Volume_Factor_Options>> }, Subscription_RootWater_Volume_Factor_Options_StreamArgs>,
    well_gas_type_options?: GraphCacheUpdateResolver<{ well_gas_type_options: Array<WithTypename<Well_Gas_Type_Options>> }, Subscription_RootWell_Gas_Type_OptionsArgs>,
    well_gas_type_options_aggregate?: GraphCacheUpdateResolver<{ well_gas_type_options_aggregate: WithTypename<Well_Gas_Type_Options_Aggregate> }, Subscription_RootWell_Gas_Type_Options_AggregateArgs>,
    well_gas_type_options_by_pk?: GraphCacheUpdateResolver<{ well_gas_type_options_by_pk: Maybe<WithTypename<Well_Gas_Type_Options>> }, Subscription_RootWell_Gas_Type_Options_By_PkArgs>,
    well_gas_type_options_stream?: GraphCacheUpdateResolver<{ well_gas_type_options_stream: Array<WithTypename<Well_Gas_Type_Options>> }, Subscription_RootWell_Gas_Type_Options_StreamArgs>,
    well_test_gas_input_options?: GraphCacheUpdateResolver<{ well_test_gas_input_options: Array<WithTypename<Well_Test_Gas_Input_Options>> }, Subscription_RootWell_Test_Gas_Input_OptionsArgs>,
    well_test_gas_input_options_aggregate?: GraphCacheUpdateResolver<{ well_test_gas_input_options_aggregate: WithTypename<Well_Test_Gas_Input_Options_Aggregate> }, Subscription_RootWell_Test_Gas_Input_Options_AggregateArgs>,
    well_test_gas_input_options_by_pk?: GraphCacheUpdateResolver<{ well_test_gas_input_options_by_pk: Maybe<WithTypename<Well_Test_Gas_Input_Options>> }, Subscription_RootWell_Test_Gas_Input_Options_By_PkArgs>,
    well_test_gas_input_options_stream?: GraphCacheUpdateResolver<{ well_test_gas_input_options_stream: Array<WithTypename<Well_Test_Gas_Input_Options>> }, Subscription_RootWell_Test_Gas_Input_Options_StreamArgs>,
    well_test_liquid_input_options?: GraphCacheUpdateResolver<{ well_test_liquid_input_options: Array<WithTypename<Well_Test_Liquid_Input_Options>> }, Subscription_RootWell_Test_Liquid_Input_OptionsArgs>,
    well_test_liquid_input_options_aggregate?: GraphCacheUpdateResolver<{ well_test_liquid_input_options_aggregate: WithTypename<Well_Test_Liquid_Input_Options_Aggregate> }, Subscription_RootWell_Test_Liquid_Input_Options_AggregateArgs>,
    well_test_liquid_input_options_by_pk?: GraphCacheUpdateResolver<{ well_test_liquid_input_options_by_pk: Maybe<WithTypename<Well_Test_Liquid_Input_Options>> }, Subscription_RootWell_Test_Liquid_Input_Options_By_PkArgs>,
    well_test_liquid_input_options_stream?: GraphCacheUpdateResolver<{ well_test_liquid_input_options_stream: Array<WithTypename<Well_Test_Liquid_Input_Options>> }, Subscription_RootWell_Test_Liquid_Input_Options_StreamArgs>,
    well_test_pressure_input_options?: GraphCacheUpdateResolver<{ well_test_pressure_input_options: Array<WithTypename<Well_Test_Pressure_Input_Options>> }, Subscription_RootWell_Test_Pressure_Input_OptionsArgs>,
    well_test_pressure_input_options_aggregate?: GraphCacheUpdateResolver<{ well_test_pressure_input_options_aggregate: WithTypename<Well_Test_Pressure_Input_Options_Aggregate> }, Subscription_RootWell_Test_Pressure_Input_Options_AggregateArgs>,
    well_test_pressure_input_options_by_pk?: GraphCacheUpdateResolver<{ well_test_pressure_input_options_by_pk: Maybe<WithTypename<Well_Test_Pressure_Input_Options>> }, Subscription_RootWell_Test_Pressure_Input_Options_By_PkArgs>,
    well_test_pressure_input_options_stream?: GraphCacheUpdateResolver<{ well_test_pressure_input_options_stream: Array<WithTypename<Well_Test_Pressure_Input_Options>> }, Subscription_RootWell_Test_Pressure_Input_Options_StreamArgs>,
    wells?: GraphCacheUpdateResolver<{ wells: Array<WithTypename<Wells>> }, Subscription_RootWellsArgs>,
    wells_aggregate?: GraphCacheUpdateResolver<{ wells_aggregate: WithTypename<Wells_Aggregate> }, Subscription_RootWells_AggregateArgs>,
    wells_by_pk?: GraphCacheUpdateResolver<{ wells_by_pk: Maybe<WithTypename<Wells>> }, Subscription_RootWells_By_PkArgs>,
    wells_stream?: GraphCacheUpdateResolver<{ wells_stream: Array<WithTypename<Wells>> }, Subscription_RootWells_StreamArgs>,
    y_tools?: GraphCacheUpdateResolver<{ y_tools: Array<WithTypename<Y_Tools>> }, Subscription_RootY_ToolsArgs>,
    y_tools_aggregate?: GraphCacheUpdateResolver<{ y_tools_aggregate: WithTypename<Y_Tools_Aggregate> }, Subscription_RootY_Tools_AggregateArgs>,
    y_tools_by_pk?: GraphCacheUpdateResolver<{ y_tools_by_pk: Maybe<WithTypename<Y_Tools>> }, Subscription_RootY_Tools_By_PkArgs>,
    y_tools_stream?: GraphCacheUpdateResolver<{ y_tools_stream: Array<WithTypename<Y_Tools>> }, Subscription_RootY_Tools_StreamArgs>
  },
};

export type GraphCacheConfig = Parameters<typeof offlineExchange>[0] & {
  updates?: GraphCacheUpdaters,
  keys?: GraphCacheKeysConfig,
  optimistic?: GraphCacheOptimisticUpdaters,
  resolvers?: GraphCacheResolvers,
};